/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(544);
	module.exports = __webpack_require__(262);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(4);
	var core = __webpack_require__(26);
	var hide = __webpack_require__(16);
	var redefine = __webpack_require__(17);
	var ctx = __webpack_require__(27);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(552);
	} else {
	  module.exports = require('./cjs/react.development.js');
	}


/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(6);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ },
/* 4 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ },
/* 5 */
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ },
/* 6 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint-disable */
	
	var _constants = __webpack_require__(96);
	
	var _language = __webpack_require__(261);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _kit = __webpack_require__(43);
	
	var _nprogress = __webpack_require__(513);
	
	var _nprogress2 = _interopRequireDefault(_nprogress);
	
	var _universalCookie = __webpack_require__(221);
	
	var _universalCookie2 = _interopRequireDefault(_universalCookie);
	
	var _data = __webpack_require__(70);
	
	var _app = __webpack_require__(94);
	
	var _reactRouterRedux = __webpack_require__(60);
	
	var _localize = __webpack_require__(152);
	
	var _localize2 = _interopRequireDefault(_localize);
	
	var _axios = __webpack_require__(69);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _store = __webpack_require__(153);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var instance = null;
	
	var Superface = function () {
	    function Superface() {
	        _classCallCheck(this, Superface);
	
	        if (!instance) {
	            this.handleChange = this.handleChange.bind(this);
	            this.init();
	            instance = this;
	        }
	        return instance;
	    }
	
	    _createClass(Superface, [{
	        key: 'init',
	        value: function init() {
	
	            this.IS_MOBILE = (0, _kit.isMobile)();
	            this.IS_MOBILE_OR_TABLET = (0, _kit.isTabletOrMobile)();
	
	            this.loaded = false;
	            this.ready = false;
	            this.canDoIt = true;
	            _nprogress2.default.speed = 100;
	            _store2.default.subscribe(this.handleChange);
	        }
	
	        /*=============================================
	        =            STATES                           =
	        =============================================*/
	
	    }, {
	        key: 'datas',
	        value: function datas() {
	            return _store2.default.getState().data;
	        }
	    }, {
	        key: 'app',
	        value: function app() {
	            return _store2.default.getState().app;
	        }
	    }, {
	        key: 'routing',
	        value: function routing() {
	            return _store2.default.getState().routing;
	        }
	
	        /*=============================================
	        =            APP BEHAVIOURS                   =
	        =============================================*/
	
	    }, {
	        key: 'handleChange',
	        value: function handleChange() {
	            if (this.loaded) return;
	
	            var datas = this.datas();
	            var app = this.app();
	
	            this.ready = !datas.materials.isEmpty() && !datas.materialsKinds.isEmpty() && !datas.projects.isEmpty() && !datas.projectsAreas.isEmpty() && datas.home && datas.contact && datas.about;
	
	            if (!this.ready) return;
	
	            this.loaded = datas.projectsImagesLoaded && datas.aboutImagesLoaded && datas.materialsImagesLoaded && datas.homeVideoReady;
	
	            // console.log('loaded : ' + this.loaded)
	
	            if (!this.loaded && !this.isLoadingAssets) {
	                _nprogress2.default.inc();
	                this.isLoadingAssets = true;
	                this.loadAssets();
	            }
	
	            if (!this.loaded) return;
	
	            if (this.isLoadingAssets) {
	                this.isLoadingAssets = false;
	                if (app.currentSection !== 'matieres' && app.currentSection !== 'projets') {
	                    this.setLoading(false);
	                }
	                _store2.default.dispatch((0, _app.setAppLoaded)());
	            }
	        }
	    }, {
	        key: 'toggleMenu',
	        value: function toggleMenu() {
	            _store2.default.dispatch((0, _app.toggleMenu)());
	        }
	    }, {
	        key: 'getCardinal',
	        value: function getCardinal(path) {
	            switch (true) {
	                case path.includes('projets'):
	                    return 'E';
	                case path.includes('matieres'):
	                    return 'W';
	                case path.includes('notre-metier'):
	                    return 'S';
	                case path.includes('contact'):
	                    return 'N';
	                default:
	                    return 'center';
	            }
	        }
	    }, {
	        key: 'getIP',
	        value: function getIP() {
	            _store2.default.dispatch((0, _app.getIP)());
	        }
	    }, {
	        key: 'setCompass',
	        value: function setCompass(cardinal) {
	            _store2.default.dispatch((0, _app.setCompass)(cardinal));
	        }
	    }, {
	        key: 'setCompassHiddenOnMobile',
	        value: function setCompassHiddenOnMobile(bool) {
	            _store2.default.dispatch((0, _app.setCompassHiddenOnMobile)(bool));
	        }
	
	        /*=============================================
	        =            LOADING                          =
	        =============================================*/
	
	    }, {
	        key: 'setLoading',
	        value: function setLoading(bool) {
	            // console.log(bool)
	            if (bool) {
	                _nprogress2.default.set(0);
	                _nprogress2.default.start();
	            } else {
	                setTimeout(function () {
	                    _nprogress2.default.done();
	                }, 100);
	            }
	            _store2.default.dispatch((0, _app.setLoading)(bool));
	        }
	    }, {
	        key: 'loadJSONdatas',
	        value: function loadJSONdatas() {
	            _store2.default.dispatch((0, _data.getMaterials)());
	            _store2.default.dispatch((0, _data.getMaterialsKinds)());
	            _store2.default.dispatch((0, _data.getProjects)());
	            _store2.default.dispatch((0, _data.getProjectsAreas)());
	            _store2.default.dispatch((0, _data.getContact)());
	            _store2.default.dispatch((0, _data.getAbout)());
	            _store2.default.dispatch((0, _data.getHome)());
	        }
	    }, {
	        key: 'loadAssets',
	        value: function loadAssets() {
	            this.loadAboutImages();
	            if (!this.IS_MOBILE_OR_TABLET) {
	                this.loadHomeVideo();
	            } else {
	                this.loadHomeImageBackup();
	            }
	            this.loadProjectsImages();
	            this.loadMaterialsImages();
	        }
	    }, {
	        key: 'loadAboutImages',
	        value: function loadAboutImages() {
	            var _this = this;
	
	            var about = this.datas().about;
	            var imagesLoaded = 0;
	            var imagesToload = 0;
	            var images = [];
	
	            images.push(about.interstice);
	
	            for (var i = 1; i <= 7; i++) {
	                images.push(about['image_' + i]);
	            }
	
	            images.forEach(function (image, i) {
	
	                if (image.path) {
	
	                    var img = new Image();
	
	                    img.onload = function () {
	                        imagesLoaded += 1;
	                        if (imagesLoaded === imagesToload) {
	                            _nprogress2.default.inc();
	                            _store2.default.dispatch((0, _data.setAboutImagesLoaded)());
	                        }
	                    };
	                    img.src = _this.assetUrl(image.path);
	
	                    imagesToload += 1;
	                }
	            });
	        }
	    }, {
	        key: 'loadMaterialsImages',
	        value: function loadMaterialsImages() {
	            return _store2.default.dispatch((0, _data.setMaterialsImagesLoaded)());
	            // return
	            var materials = this.datas().materials;
	
	            var images_loaded = 0;
	            var images_to_load = 0;
	
	            materials.forEach(function (mat) {
	
	                if (mat.image.path !== undefined) {
	                    var str = _constants.ROOT_URL.replace('3000', '8888') + '/superadmin/api/cockpit/image?token=' + _constants.TOKEN + '&src=' + mat.image._id + '&m=resize&w=560&q=50';
	                    _axios2.default.get(str).then(function (result) {
	                        images_loaded += 1;
	                        var img = new Image();
	                        // img.onload = () => {
	                        //     images_loaded += 1
	                        // console.log( result.data )
	                        mat.image.thumb_path = result.data;
	                        if (images_loaded === images_to_load) {}
	
	                        //     }
	
	
	                        // img.src = this.assetUrl(result.data)
	                    });
	                    images_to_load += 1;
	                }
	            });
	        }
	    }, {
	        key: 'loadHomeImageBackup',
	        value: function loadHomeImageBackup() {
	            var home = this.datas().home;
	            this.HOME_BACKUP_INDEX = (0, _kit.getRandomInt)(0, home.backup_mobile.length - 1);
	            var image = home.backup_mobile[this.HOME_BACKUP_INDEX];
	            var img = new Image();
	
	            img.onload = function () {
	                _store2.default.dispatch((0, _data.setHomeVideoReady)());
	            };
	
	            img.src = this.assetUrl(image.path);
	        }
	    }, {
	        key: 'setloadProgress',
	        value: function setloadProgress(float) {
	            if (float === 'inc') return _nprogress2.default.inc();
	            _nprogress2.default.set(float);
	        }
	    }, {
	        key: 'loadHomeVideo',
	        value: function loadHomeVideo() {
	
	            var home = this.datas().home;
	            this.HOME_VIDEO_INDEX = (0, _kit.getRandomInt)(0, home.videos.length - 1);
	            var video = home.videos[this.HOME_VIDEO_INDEX];
	            var vid = document.createElement("video");
	            vid.src = this.assetUrl(video.value.path);
	            vid.load();
	            // vid.addEventListener("progress", function() {
	            //     console.log(vid.readyState)
	            //     if( vid.readyState >= 3 ){
	            //         store.dispatch( setHomeVideoReady() )
	            //     }
	            //     // if( vid.buffered.length > 0 ){
	            //     //     console.log( Math.round(vid.buffered.end(0)) / Math.round(vid.seekable.end(0)) )
	            //     //     if (Math.round(vid.buffered.end(0)) / Math.round(vid.seekable.end(0)) === 1) {
	            //     //         store.dispatch( setHomeVideoReady() )
	            //     //     }
	            //     // }
	            // }, false);
	            checkIfVideoIsReady(vid);
	
	            function checkIfVideoIsReady($vid) {
	
	                window.setTimeout(function () {
	                    console.log($vid.readyState);
	                    if ($vid.readyState === 2) {
	                        _nprogress2.default.inc();
	                    }
	                    if ($vid.readyState >= 3) {
	
	                        _store2.default.dispatch((0, _data.setHomeVideoReady)());
	                    } else {
	                        checkIfVideoIsReady($vid);
	                    }
	                }, 500);
	            }
	        }
	    }, {
	        key: 'loadProjectsImages',
	        value: function loadProjectsImages() {
	
	            _store2.default.dispatch((0, _data.setProjectsImagesLoaded)());
	        }
	
	        /*=============================================
	        =         ROUTING & URLS & SECTION            =
	        =============================================*/
	
	    }, {
	        key: 'getCurrentUrl',
	        value: function getCurrentUrl() {
	            return _constants.ROOT_URL + this.routing().location.pathname;
	        }
	    }, {
	        key: 'goTo',
	        value: function goTo(path) {
	            if (this.app().menuOpen) _store2.default.dispatch((0, _app.toggleMenu)());
	            _store2.default.dispatch((0, _app.setCompass)(this.getCardinal(path)));
	            _store2.default.dispatch((0, _reactRouterRedux.push)(path));
	        }
	    }, {
	        key: 'assetUrl',
	        value: function assetUrl(path) {
	            if (!path) return;
	
	            if (path.includes('http')) {
	                var arr = path.split('/');
	                arr.shift();
	                arr.shift();
	                arr.shift();
	                path = '/' + arr.join('/');
	            }
	            var src = path.includes('superadmin') ? path : '/superadmin/storage/uploads' + path;
	            return src;
	        }
	    }, {
	        key: 'uri',
	        value: function uri(key) {
	            var URIS = {
	                'matieres': 'matieres',
	                'projets': 'projets',
	                'notre-metier': 'notre-metier',
	                'contact': 'contact',
	                'accueil': ''
	            };
	            return '/' + URIS[key];
	        }
	    }, {
	        key: 'getSectionName',
	        value: function getSectionName(section) {
	            var NAMES = {
	                'matieres': 'Matières',
	                'projets': 'Projets',
	                'notre-metier': 'Notre Métier',
	                'contact': 'Contact',
	                'accueil': 'Accueil'
	            };
	            return NAMES[section] ? NAMES[section] : '';
	        }
	    }, {
	        key: 'isOnSingle',
	        value: function isOnSingle() {
	            return this.app().isOnSingle;
	        }
	
	        /*=============================================
	        =            TRANSLATION & FIELDS             =
	        =============================================*/
	
	    }, {
	        key: 'field',
	        value: function field(obj, key) {
	            var lang = this.app().lang;
	            if (lang !== 'fr') {
	                if (obj[key + '_' + lang] && obj[key + '_' + lang] !== '') {
	                    return obj[key + '_' + lang];
	                }
	            }
	            return obj[key];
	        }
	    }, {
	        key: 'translate',
	        value: function translate(str) {
	
	            if (_language2.default[str]) {
	                if (!_language2.default[str][this.app().lang]) return str;
	                return _language2.default[str][this.app().lang];
	            } else {
	                return str;
	            }
	        }
	    }, {
	        key: 'setLang',
	        value: function setLang(str) {
	            var cookies = new _universalCookie2.default();
	            cookies.set('locale', str);
	            _store2.default.dispatch((0, _app.setLanguage)(str));
	        }
	    }, {
	        key: 'getLang',
	        value: function getLang() {
	            return this.app().lang;
	        }
	    }, {
	        key: 'setCursor',
	        value: function setCursor(string) {
	            _store2.default.dispatch((0, _app.setCursor)(string));
	        }
	
	        /*=============================================
	        =            MATERIALS                        =
	        =============================================*/
	
	    }, {
	        key: 'enableMaterialsGrid',
	        value: function enableMaterialsGrid() {
	            _store2.default.dispatch((0, _app.setMaterialsGridActive)(true));
	        }
	    }, {
	        key: 'disableMaterialsGrid',
	        value: function disableMaterialsGrid() {
	            _store2.default.dispatch((0, _app.setMaterialsGridActive)(false));
	        }
	    }, {
	        key: 'getNextMaterialsKind',
	        value: function getNextMaterialsKind(kind) {
	            var kinds = this.datas().materialsKinds;
	            for (var i = 0; i < kinds.length; i++) {
	                if (kinds[i]._id === kind._id) {
	                    if (kinds[i + 1] !== undefined) return kinds[i + 1];
	                    return kinds[0];
	                }
	            }
	            return null;
	        }
	    }, {
	        key: 'getPreviousMaterialsKind',
	        value: function getPreviousMaterialsKind(kind) {
	            var kinds = this.datas().materialsKinds;
	            for (var i = 0; i < kinds.length; i++) {
	                if (kinds[i]._id === kind._id) {
	                    if (kinds[i - 1] !== undefined) return kinds[i - 1];
	                    return kinds[kinds.length - 1];
	                }
	            }
	            return null;
	        }
	    }, {
	        key: 'setKindTitle',
	        value: function setKindTitle(title) {
	            _store2.default.dispatch((0, _app.setKindTitle)(title));
	        }
	    }, {
	        key: 'toggleKindFilter',
	        value: function toggleKindFilter(slug) {
	            _store2.default.dispatch((0, _app.toggleKindFilter)(slug));
	        }
	    }, {
	        key: 'setKindFeaturedImagePath',
	        value: function setKindFeaturedImagePath(path) {
	
	            if (path != undefined) {
	                _store2.default.dispatch((0, _app.setKindFeaturedImagePath)(path));
	            }
	        }
	
	        /*=============================================
	        =            PROJECTS                         =
	        =============================================*/
	
	    }, {
	        key: 'getNextProject',
	        value: function getNextProject(project) {
	            var projects = this.datas().projects;
	            for (var i = 0; i < projects.length; i++) {
	                if (projects[i]._id === project._id) {
	                    var nextProject = projects[i + 1];
	                    if (nextProject !== undefined) {
	                        if (this.projectHasSingle(nextProject)) {
	                            return nextProject;
	                        } else {
	                            return this.getNextProject(nextProject);
	                        }
	                    } else {
	                        return this.getNextProject(projects[0]);
	                    }
	                }
	            }
	            return null;
	        }
	    }, {
	        key: 'projectHasSingle',
	        value: function projectHasSingle(project) {
	            return project.medias.length > 0;
	        }
	    }, {
	        key: 'getPreviousProject',
	        value: function getPreviousProject(project) {
	            var projects = this.datas().projects;
	            for (var i = 0; i < projects.length; i++) {
	                if (projects[i]._id === project._id) {
	                    var previousProject = projects[i - 1];
	                    if (previousProject !== undefined) {
	                        if (this.projectHasSingle(previousProject)) {
	                            return previousProject;
	                        } else {
	                            return this.getPreviousProject(previousProject);
	                        }
	                    } else {
	                        return this.getPreviousProject(projects[projects.length - 1]);
	                    }
	                }
	            }
	            return null;
	        }
	    }, {
	        key: 'setCurrentTimelineProjectIndex',
	        value: function setCurrentTimelineProjectIndex(index) {
	            _store2.default.dispatch((0, _app.setCurrentTimelineProjectIndex)(index));
	        }
	    }, {
	        key: 'toggleAreaFilter',
	        value: function toggleAreaFilter(slug) {
	            _store2.default.dispatch((0, _app.toggleAreaFilter)(slug));
	        }
	    }, {
	        key: 'setProjectsViewMode',
	        value: function setProjectsViewMode(mode) {
	            _store2.default.dispatch((0, _app.setProjectsViewMode)(mode));
	        }
	    }, {
	        key: 'setProjectsDate',
	        value: function setProjectsDate(date) {
	            _store2.default.dispatch((0, _app.setProjectsDate)(date));
	        }
	    }, {
	        key: 'enableProjectsGrid',
	        value: function enableProjectsGrid() {
	            _store2.default.dispatch((0, _app.setProjectsGridActive)(true));
	        }
	    }, {
	        key: 'disableProjectsGrid',
	        value: function disableProjectsGrid() {
	            _store2.default.dispatch((0, _app.setProjectsGridActive)(false));
	        }
	
	        /*=============================================
	        =            GET ENTRY                        =
	        =============================================*/
	
	    }, {
	        key: 'getMaterialKindById',
	        value: function getMaterialKindById(id) {
	            var kinds = this.datas().materialsKinds;
	            for (var i = 0; i < kinds.length; i++) {
	                if (kinds[i]._id === id) return kinds[i];
	            }
	            return null;
	        }
	    }, {
	        key: 'getProjectAreaById',
	        value: function getProjectAreaById(id) {
	            var areas = this.datas().projectsAreas;
	            for (var i = 0; i < areas.length; i++) {
	                if (areas[i]._id === id) return areas[i];
	            }
	            return null;
	        }
	    }, {
	        key: 'getMaterialKindBySlug',
	        value: function getMaterialKindBySlug(slug) {
	            var kinds = this.datas().materialsKinds;
	
	            for (var i = 0; i < kinds.length; i++) {
	                if (kinds[i].slug === slug) return kinds[i];
	            }
	            return null;
	        }
	    }, {
	        key: 'getProjectBySlug',
	        value: function getProjectBySlug(slug) {
	            var projects = this.datas().projects;
	
	            for (var i = 0; i < projects.length; i++) {
	                if (projects[i].slug === slug) return projects[i];
	            }
	            return null;
	        }
	    }, {
	        key: 'getSingleBySlug',
	        value: function getSingleBySlug(slug, type) {
	            if (type === 'projet') {
	                return this.getProjectBySlug(slug);
	            }
	            if (type === 'kind') {
	                return this.getMaterialKindBySlug(slug);
	            }
	        }
	    }, {
	        key: 'getNextSingle',
	        value: function getNextSingle(single, type) {
	            if (type === 'projet') {
	                return this.getNextProject(single);
	            }
	            if (type === 'kind') {
	                return this.getNextMaterialsKind(single);
	            }
	        }
	    }, {
	        key: 'getPreviousSingle',
	        value: function getPreviousSingle(single, type) {
	            if (type === 'projet') {
	                return this.getPreviousProject(single);
	            }
	            if (type === 'kind') {
	                return this.getPreviousMaterialsKind(single);
	            }
	        }
	    }, {
	        key: 'toggleFilter',
	        value: function toggleFilter(slug, type) {
	            if (type === 'projet') {
	                return this.toggleAreaFilter(slug);
	            }
	            if (type === 'kind') {
	                return this.toggleKindFilter(slug);
	            }
	        }
	    }, {
	        key: 'resetFilters',
	        value: function resetFilters(type) {
	            if (type === 'projet') {
	                return _store2.default.dispatch((0, _app.resetAreaFilters)());
	            }
	            if (type === 'kind') {
	                return _store2.default.dispatch((0, _app.resetKindFilters)());
	            }
	        }
	    }, {
	        key: 'singleLeaving',
	        value: function singleLeaving(bool) {
	            _store2.default.dispatch((0, _app.singleLeaving)(bool));
	        }
	    }, {
	        key: 'mapLeaving',
	        value: function mapLeaving(bool) {
	            _store2.default.dispatch((0, _app.mapLeaving)(bool));
	        }
	    }]);
	
	    return Superface;
	}();
	
	exports.default = new Superface();

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	var store = __webpack_require__(84)('wks');
	var uid = __webpack_require__(53);
	var Symbol = __webpack_require__(4).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(5)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(3);
	var IE8_DOM_DEFINE = __webpack_require__(164);
	var toPrimitive = __webpack_require__(33);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(9) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(32);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(516)();
	}


/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(30);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ },
/* 14 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.InlineBlock = exports.Flex = exports.Box = exports.Col = exports.Row = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Row = exports.Row = function Row(props) {
	    return _react2.default.createElement(
	        'div',
	        { className: "row " + props.className, style: props.style },
	        props.children
	    );
	};
	var Col = exports.Col = function Col(props) {
	    return _react2.default.createElement(
	        'div',
	        { className: 'col col-' + props.n + ' ' + props.className, style: props.style },
	        props.children
	    );
	};
	
	var Box = exports.Box = function Box(props) {
	    return _react2.default.createElement(
	        'div',
	        { style: Object.assign({ padding: (props.p || 2) * 0.5 + 'rem' }, props.style), className: "box " + props.className },
	        props.children
	    );
	};
	
	//
	// ─── FLEX ───────────────────────────────────────────────────────────────────────
	//
	
	var Flex = exports.Flex = function Flex(props) {
	    var classes = ' flex' + (props.n != undefined ? ' flex-' + props.n : '') + (props.align != undefined ? ' align-' + props.align : '') + (props.justify != undefined ? ' justify-' + props.justify : '') + (props.direction != undefined ? ' direction-' + props.direction : '');
	
	    // console.log( classes )
	    var style = Object.assign({
	        display: 'flex',
	        flex: props.n || 'initial',
	        alignItems: props.align || 'initial',
	        justifyContent: props.justify || 'initial',
	        flexDirection: props.direction || 'row'
	    }, props.style);
	
	    return _react2.default.createElement(
	        'div',
	        { ref: props.setRef, className: (props.className ? props.className : '') + ' ' + classes, id: props.id, style: props.style, onMouseDown: props.onMouseDown },
	        props.children
	    );
	};
	
	var InlineBlock = exports.InlineBlock = function InlineBlock(props) {
	
	    var style = Object.assign({
	        display: 'inline-block'
	    }, props.style);
	
	    return _react2.default.createElement(
	        'div',
	        { className: props.className, id: props.id, style: style },
	        props.children
	    );
	};

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(10);
	var createDesc = __webpack_require__(49);
	module.exports = __webpack_require__(9) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(4);
	var hide = __webpack_require__(16);
	var has = __webpack_require__(20);
	var SRC = __webpack_require__(53)('src');
	var TO_STRING = 'toString';
	var $toString = Function[TO_STRING];
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(26).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	var fails = __webpack_require__(5);
	var defined = __webpack_require__(30);
	var quot = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function (string, tag, attribute, value) {
	  var S = String(defined(string));
	  var p1 = '<' + tag;
	  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function (NAME, exec) {
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function () {
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};


/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(139);
	var isBuffer = __webpack_require__(499);
	
	/*global toString:true*/
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return (typeof FormData !== 'undefined') && (val instanceof FormData);
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	function isURLSearchParams(val) {
	  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.replace(/^\s*/, '').replace(/\s*$/, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  navigator.product -> 'ReactNative'
	 */
	function isStandardBrowserEnv() {
	  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
	    return false;
	  }
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object') {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = merge(result[key], val);
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */
	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isBuffer: isBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  extend: extend,
	  trim: trim
	};


/***/ },
/* 20 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(63);
	var createDesc = __webpack_require__(49);
	var toIObject = __webpack_require__(23);
	var toPrimitive = __webpack_require__(33);
	var has = __webpack_require__(20);
	var IE8_DOM_DEFINE = __webpack_require__(164);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(9) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(20);
	var toObject = __webpack_require__(13);
	var IE_PROTO = __webpack_require__(113)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(62);
	var defined = __webpack_require__(30);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 25 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ },
/* 26 */
/***/ function(module, exports) {

	var core = module.exports = { version: '2.5.6' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(14);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(5);
	
	module.exports = function (method, arg) {
	  return !!method && fails(function () {
	    // eslint-disable-next-line no-useless-call
	    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
	  });
	};


/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__(27);
	var IObject = __webpack_require__(62);
	var toObject = __webpack_require__(13);
	var toLength = __webpack_require__(11);
	var asc = __webpack_require__(98);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};


/***/ },
/* 30 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(1);
	var core = __webpack_require__(26);
	var fails = __webpack_require__(5);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ },
/* 32 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(6);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	var Map = __webpack_require__(185);
	var $export = __webpack_require__(1);
	var shared = __webpack_require__(84)('metadata');
	var store = shared.store || (shared.store = new (__webpack_require__(188))());
	
	var getOrCreateMetadataMap = function (target, targetKey, create) {
	  var targetMetadata = store.get(target);
	  if (!targetMetadata) {
	    if (!create) return undefined;
	    store.set(target, targetMetadata = new Map());
	  }
	  var keyMetadata = targetMetadata.get(targetKey);
	  if (!keyMetadata) {
	    if (!create) return undefined;
	    targetMetadata.set(targetKey, keyMetadata = new Map());
	  } return keyMetadata;
	};
	var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	};
	var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	};
	var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
	  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	};
	var ordinaryOwnMetadataKeys = function (target, targetKey) {
	  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
	  var keys = [];
	  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
	  return keys;
	};
	var toMetaKey = function (it) {
	  return it === undefined || typeof it == 'symbol' ? it : String(it);
	};
	var exp = function (O) {
	  $export($export.S, 'Reflect', O);
	};
	
	module.exports = {
	  store: store,
	  map: getOrCreateMetadataMap,
	  has: ordinaryHasOwnMetadata,
	  get: ordinaryGetOwnMetadata,
	  set: ordinaryDefineOwnMetadata,
	  keys: ordinaryOwnMetadataKeys,
	  key: toMetaKey,
	  exp: exp
	};


/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	if (__webpack_require__(9)) {
	  var LIBRARY = __webpack_require__(38);
	  var global = __webpack_require__(4);
	  var fails = __webpack_require__(5);
	  var $export = __webpack_require__(1);
	  var $typed = __webpack_require__(86);
	  var $buffer = __webpack_require__(119);
	  var ctx = __webpack_require__(27);
	  var anInstance = __webpack_require__(44);
	  var propertyDesc = __webpack_require__(49);
	  var hide = __webpack_require__(16);
	  var redefineAll = __webpack_require__(50);
	  var toInteger = __webpack_require__(32);
	  var toLength = __webpack_require__(11);
	  var toIndex = __webpack_require__(183);
	  var toAbsoluteIndex = __webpack_require__(52);
	  var toPrimitive = __webpack_require__(33);
	  var has = __webpack_require__(20);
	  var classof = __webpack_require__(61);
	  var isObject = __webpack_require__(6);
	  var toObject = __webpack_require__(13);
	  var isArrayIter = __webpack_require__(105);
	  var create = __webpack_require__(46);
	  var getPrototypeOf = __webpack_require__(22);
	  var gOPN = __webpack_require__(47).f;
	  var getIterFn = __webpack_require__(121);
	  var uid = __webpack_require__(53);
	  var wks = __webpack_require__(8);
	  var createArrayMethod = __webpack_require__(29);
	  var createArrayIncludes = __webpack_require__(73);
	  var speciesConstructor = __webpack_require__(85);
	  var ArrayIterators = __webpack_require__(122);
	  var Iterators = __webpack_require__(54);
	  var $iterDetect = __webpack_require__(79);
	  var setSpecies = __webpack_require__(51);
	  var arrayFill = __webpack_require__(97);
	  var arrayCopyWithin = __webpack_require__(156);
	  var $DP = __webpack_require__(10);
	  var $GOPD = __webpack_require__(21);
	  var dP = $DP.f;
	  var gOPD = $GOPD.f;
	  var RangeError = global.RangeError;
	  var TypeError = global.TypeError;
	  var Uint8Array = global.Uint8Array;
	  var ARRAY_BUFFER = 'ArrayBuffer';
	  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
	  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
	  var PROTOTYPE = 'prototype';
	  var ArrayProto = Array[PROTOTYPE];
	  var $ArrayBuffer = $buffer.ArrayBuffer;
	  var $DataView = $buffer.DataView;
	  var arrayForEach = createArrayMethod(0);
	  var arrayFilter = createArrayMethod(2);
	  var arraySome = createArrayMethod(3);
	  var arrayEvery = createArrayMethod(4);
	  var arrayFind = createArrayMethod(5);
	  var arrayFindIndex = createArrayMethod(6);
	  var arrayIncludes = createArrayIncludes(true);
	  var arrayIndexOf = createArrayIncludes(false);
	  var arrayValues = ArrayIterators.values;
	  var arrayKeys = ArrayIterators.keys;
	  var arrayEntries = ArrayIterators.entries;
	  var arrayLastIndexOf = ArrayProto.lastIndexOf;
	  var arrayReduce = ArrayProto.reduce;
	  var arrayReduceRight = ArrayProto.reduceRight;
	  var arrayJoin = ArrayProto.join;
	  var arraySort = ArrayProto.sort;
	  var arraySlice = ArrayProto.slice;
	  var arrayToString = ArrayProto.toString;
	  var arrayToLocaleString = ArrayProto.toLocaleString;
	  var ITERATOR = wks('iterator');
	  var TAG = wks('toStringTag');
	  var TYPED_CONSTRUCTOR = uid('typed_constructor');
	  var DEF_CONSTRUCTOR = uid('def_constructor');
	  var ALL_CONSTRUCTORS = $typed.CONSTR;
	  var TYPED_ARRAY = $typed.TYPED;
	  var VIEW = $typed.VIEW;
	  var WRONG_LENGTH = 'Wrong length!';
	
	  var $map = createArrayMethod(1, function (O, length) {
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	
	  var LITTLE_ENDIAN = fails(function () {
	    // eslint-disable-next-line no-undef
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
	    new Uint8Array(1).set({});
	  });
	
	  var toOffset = function (it, BYTES) {
	    var offset = toInteger(it);
	    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
	    return offset;
	  };
	
	  var validate = function (it) {
	    if (isObject(it) && TYPED_ARRAY in it) return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	
	  var allocate = function (C, length) {
	    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
	      throw TypeError('It is not a typed array constructor!');
	    } return new C(length);
	  };
	
	  var speciesFromList = function (O, list) {
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	
	  var fromList = function (C, list) {
	    var index = 0;
	    var length = list.length;
	    var result = allocate(C, length);
	    while (length > index) result[index] = list[index++];
	    return result;
	  };
	
	  var addGetter = function (it, key, internal) {
	    dP(it, key, { get: function () { return this._d[internal]; } });
	  };
	
	  var $from = function from(source /* , mapfn, thisArg */) {
	    var O = toObject(source);
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var iterFn = getIterFn(O);
	    var i, length, values, result, step, iterator;
	    if (iterFn != undefined && !isArrayIter(iterFn)) {
	      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
	        values.push(step.value);
	      } O = values;
	    }
	    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
	    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	
	  var $of = function of(/* ...items */) {
	    var index = 0;
	    var length = arguments.length;
	    var result = allocate(this, length);
	    while (length > index) result[index] = arguments[index++];
	    return result;
	  };
	
	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });
	
	  var $toLocaleString = function toLocaleString() {
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	
	  var proto = {
	    copyWithin: function copyWithin(target, start /* , end */) {
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /* , thisArg */) {
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /* , thisArg */) {
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
	        arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /* , thisArg */) {
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /* , thisArg */) {
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /* , thisArg */) {
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /* , fromIndex */) {
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /* , fromIndex */) {
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator) { // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /* , thisArg */) {
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse() {
	      var that = this;
	      var length = validate(that).length;
	      var middle = Math.floor(length / 2);
	      var index = 0;
	      var value;
	      while (index < middle) {
	        value = that[index];
	        that[index++] = that[--length];
	        that[length] = value;
	      } return that;
	    },
	    some: function some(callbackfn /* , thisArg */) {
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn) {
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end) {
	      var O = validate(this);
	      var length = O.length;
	      var $begin = toAbsoluteIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
	        O.buffer,
	        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
	        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
	      );
	    }
	  };
	
	  var $slice = function slice(start, end) {
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	
	  var $set = function set(arrayLike /* , offset */) {
	    validate(this);
	    var offset = toOffset(arguments[1], 1);
	    var length = this.length;
	    var src = toObject(arrayLike);
	    var len = toLength(src.length);
	    var index = 0;
	    if (len + offset > length) throw RangeError(WRONG_LENGTH);
	    while (index < len) this[offset + index] = src[index++];
	  };
	
	  var $iterators = {
	    entries: function entries() {
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys() {
	      return arrayKeys.call(validate(this));
	    },
	    values: function values() {
	      return arrayValues.call(validate(this));
	    }
	  };
	
	  var isTAIndex = function (target, key) {
	    return isObject(target)
	      && target[TYPED_ARRAY]
	      && typeof key != 'symbol'
	      && key in target
	      && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key) {
	    return isTAIndex(target, key = toPrimitive(key, true))
	      ? propertyDesc(2, target[key])
	      : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc) {
	    if (isTAIndex(target, key = toPrimitive(key, true))
	      && isObject(desc)
	      && has(desc, 'value')
	      && !has(desc, 'get')
	      && !has(desc, 'set')
	      // TODO: add validation descriptor w/o calling accessors
	      && !desc.configurable
	      && (!has(desc, 'writable') || desc.writable)
	      && (!has(desc, 'enumerable') || desc.enumerable)
	    ) {
	      target[key] = desc.value;
	      return target;
	    } return dP(target, key, desc);
	  };
	
	  if (!ALL_CONSTRUCTORS) {
	    $GOPD.f = $getDesc;
	    $DP.f = $setDesc;
	  }
	
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty: $setDesc
	  });
	
	  if (fails(function () { arrayToString.call({}); })) {
	    arrayToString = arrayToLocaleString = function toString() {
	      return arrayJoin.call(this);
	    };
	  }
	
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice: $slice,
	    set: $set,
	    constructor: function () { /* noop */ },
	    toString: arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function () { return this[TYPED_ARRAY]; }
	  });
	
	  // eslint-disable-next-line max-statements
	  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
	    CLAMPED = !!CLAMPED;
	    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
	    var GETTER = 'get' + KEY;
	    var SETTER = 'set' + KEY;
	    var TypedArray = global[NAME];
	    var Base = TypedArray || {};
	    var TAC = TypedArray && getPrototypeOf(TypedArray);
	    var FORCED = !TypedArray || !$typed.ABV;
	    var O = {};
	    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function (that, index) {
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function (that, index, value) {
	      var data = that._d;
	      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function (that, index) {
	      dP(that, index, {
	        get: function () {
	          return getter(this, index);
	        },
	        set: function (value) {
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if (FORCED) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME, '_d');
	        var index = 0;
	        var offset = 0;
	        var buffer, byteLength, length, klass;
	        if (!isObject(data)) {
	          length = toIndex(data);
	          byteLength = length * BYTES;
	          buffer = new $ArrayBuffer(byteLength);
	        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if ($length === undefined) {
	            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if (TYPED_ARRAY in data) {
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while (index < length) addElement(that, index++);
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if (!fails(function () {
	      TypedArray(1);
	    }) || !fails(function () {
	      new TypedArray(-1); // eslint-disable-line no-new
	    }) || !$iterDetect(function (iter) {
	      new TypedArray(); // eslint-disable-line no-new
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(1.5); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if (!isObject(data)) return new Base(toIndex(data));
	        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          return $length !== undefined
	            ? new Base(data, toOffset($offset, BYTES), $length)
	            : $offset !== undefined
	              ? new Base(data, toOffset($offset, BYTES))
	              : new Base(data);
	        }
	        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
	        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator = TypedArrayPrototype[ITERATOR];
	    var CORRECT_ITER_NAME = !!$nativeIterator
	      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
	    var $iterator = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
	      dP(TypedArrayPrototype, TAG, {
	        get: function () { return NAME; }
	      });
	    }
	
	    O[NAME] = TypedArray;
	
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES
	    });
	
	    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
	      from: $from,
	      of: $of
	    });
	
	    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	    $export($export.P, NAME, proto);
	
	    setSpecies(NAME);
	
	    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });
	
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;
	
	    $export($export.P + $export.F * fails(function () {
	      new TypedArray(1).slice();
	    }), NAME, { slice: $slice });
	
	    $export($export.P + $export.F * (fails(function () {
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
	    }) || !fails(function () {
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, { toLocaleString: $toLocaleString });
	
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function () { /* empty */ };


/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(8)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(16)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};


/***/ },
/* 38 */
/***/ function(module, exports) {

	module.exports = false;


/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	var META = __webpack_require__(53)('meta');
	var isObject = __webpack_require__(6);
	var has = __webpack_require__(20);
	var setDesc = __webpack_require__(10).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(5)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.withRouter = exports.matchPath = exports.Switch = exports.StaticRouter = exports.Router = exports.Route = exports.Redirect = exports.Prompt = exports.NavLink = exports.MemoryRouter = exports.Link = exports.HashRouter = exports.BrowserRouter = undefined;
	
	var _BrowserRouter2 = __webpack_require__(529);
	
	var _BrowserRouter3 = _interopRequireDefault(_BrowserRouter2);
	
	var _HashRouter2 = __webpack_require__(530);
	
	var _HashRouter3 = _interopRequireDefault(_HashRouter2);
	
	var _Link2 = __webpack_require__(205);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _MemoryRouter2 = __webpack_require__(531);
	
	var _MemoryRouter3 = _interopRequireDefault(_MemoryRouter2);
	
	var _NavLink2 = __webpack_require__(532);
	
	var _NavLink3 = _interopRequireDefault(_NavLink2);
	
	var _Prompt2 = __webpack_require__(533);
	
	var _Prompt3 = _interopRequireDefault(_Prompt2);
	
	var _Redirect2 = __webpack_require__(534);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(206);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _Router2 = __webpack_require__(131);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _StaticRouter2 = __webpack_require__(535);
	
	var _StaticRouter3 = _interopRequireDefault(_StaticRouter2);
	
	var _Switch2 = __webpack_require__(536);
	
	var _Switch3 = _interopRequireDefault(_Switch2);
	
	var _matchPath2 = __webpack_require__(537);
	
	var _matchPath3 = _interopRequireDefault(_matchPath2);
	
	var _withRouter2 = __webpack_require__(538);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.BrowserRouter = _BrowserRouter3.default;
	exports.HashRouter = _HashRouter3.default;
	exports.Link = _Link3.default;
	exports.MemoryRouter = _MemoryRouter3.default;
	exports.NavLink = _NavLink3.default;
	exports.Prompt = _Prompt3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	exports.Router = _Router3.default;
	exports.StaticRouter = _StaticRouter3.default;
	exports.Switch = _Switch3.default;
	exports.matchPath = _matchPath3.default;
	exports.withRouter = _withRouter3.default;

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.withRouter = exports.matchPath = exports.Switch = exports.StaticRouter = exports.Router = exports.Route = exports.Redirect = exports.Prompt = exports.MemoryRouter = undefined;
	
	var _MemoryRouter2 = __webpack_require__(209);
	
	var _MemoryRouter3 = _interopRequireDefault(_MemoryRouter2);
	
	var _Prompt2 = __webpack_require__(210);
	
	var _Prompt3 = _interopRequireDefault(_Prompt2);
	
	var _Redirect2 = __webpack_require__(211);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(132);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _Router2 = __webpack_require__(90);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _StaticRouter2 = __webpack_require__(212);
	
	var _StaticRouter3 = _interopRequireDefault(_StaticRouter2);
	
	var _Switch2 = __webpack_require__(213);
	
	var _Switch3 = _interopRequireDefault(_Switch2);
	
	var _matchPath2 = __webpack_require__(91);
	
	var _matchPath3 = _interopRequireDefault(_matchPath2);
	
	var _withRouter2 = __webpack_require__(214);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.MemoryRouter = _MemoryRouter3.default;
	exports.Prompt = _Prompt3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	exports.Router = _Router3.default;
	exports.StaticRouter = _StaticRouter3.default;
	exports.Switch = _Switch3.default;
	exports.matchPath = _matchPath3.default;
	exports.withRouter = _withRouter3.default;

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Overline = function Overline(props) {
	  return _react2.default.createElement(
	    'span',
	    null,
	    _react2.default.createElement('span', { className: 'overline' }),
	    props.children
	  );
	};
	
	exports.default = Overline;

/***/ },
/* 43 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.get_object_size = get_object_size;
	exports.get_closest_number = get_closest_number;
	exports.getRandomInt = getRandomInt;
	exports.hasClass = hasClass;
	exports.addClass = addClass;
	exports.removeClass = removeClass;
	exports.isEmptyObject = isEmptyObject;
	exports.isMobile = isMobile;
	exports.isTabletOrMobile = isTabletOrMobile;
	exports.isTablet = isTablet;
	/* eslint-disable */
	
	function get_object_size(obj) {
	    var size = 0,
	        key;
	    for (key in obj) {
	        if (obj.hasOwnProperty(key)) size++;
	    }
	    return size;
	}
	
	function get_closest_number(num, arr) {
	    var curr = arr[0];
	    var diff = Math.abs(num - curr);
	    for (var val = 0; val < arr.length; val++) {
	        var newdiff = Math.abs(num - arr[val]);
	        if (newdiff < diff) {
	            diff = newdiff;
	            curr = arr[val];
	        }
	    }
	    return curr;
	}
	
	function getRandomInt(min, max) {
	    return Math.floor(Math.random() * (max - min + 1)) + min;
	}
	
	function hasClass(ele, cls) {
	    return !!ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'));
	}
	
	function addClass(ele, cls) {
	    if (!hasClass(ele, cls)) ele.className += " " + cls;
	}
	
	function removeClass(ele, cls) {
	    if (hasClass(ele, cls)) {
	        var reg = new RegExp('(\\s|^)' + cls + '(\\s|$)');
	        ele.className = ele.className.replace(reg, ' ');
	    }
	}
	
	function isEmptyObject(obj) {
	    return Object.keys(obj).length === 0 && obj.constructor === Object;
	}
	
	function isMobile() {
	    var check = false;
	    (function (a) {
	        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
	    })(navigator.userAgent || navigator.vendor || window.opera);
	    return check;
	}
	
	function isTabletOrMobile() {
	    var check = false;
	    (function (a) {
	        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
	    })(navigator.userAgent || navigator.vendor || window.opera);
	    return check;
	};
	
	function isTablet() {
	    return isTabletOrMobile() && !isMobile();
	}
	
	//   export function getClientIP() {
	//     let xmlhttp = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject("Microsoft.XMLHTTP")
	
	//     xmlhttp.open("GET"," http://api.hostip.info/get_html.php ",false);
	//     xmlhttp.send();
	
	//     let hostipInfo = xmlhttp.responseText.split("\n");
	
	//     hostipInfo.forEach( (line) => {
	//         let array = line.split(":");
	//         if ( array[0] == "IP" ){
	//             return array[1].replace(' ', '')
	//         }
	//     })
	
	//     return false;
	// }

/***/ },
/* 44 */
/***/ function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(27);
	var call = __webpack_require__(167);
	var isArrayIter = __webpack_require__(105);
	var anObject = __webpack_require__(3);
	var toLength = __webpack_require__(11);
	var getIterFn = __webpack_require__(121);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(3);
	var dPs = __webpack_require__(173);
	var enumBugKeys = __webpack_require__(101);
	var IE_PROTO = __webpack_require__(113)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(100)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(103).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(175);
	var hiddenKeys = __webpack_require__(101).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(175);
	var enumBugKeys = __webpack_require__(101);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ },
/* 49 */
/***/ function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(17);
	module.exports = function (target, src, safe) {
	  for (var key in src) redefine(target, key, src[key], safe);
	  return target;
	};


/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(4);
	var dP = __webpack_require__(10);
	var DESCRIPTORS = __webpack_require__(9);
	var SPECIES = __webpack_require__(8)('species');
	
	module.exports = function (KEY) {
	  var C = global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(32);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ },
/* 53 */
/***/ function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ },
/* 54 */
/***/ function(module, exports) {

	module.exports = {};


/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	var def = __webpack_require__(10).f;
	var has = __webpack_require__(20);
	var TAG = __webpack_require__(8)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	var defined = __webpack_require__(30);
	var fails = __webpack_require__(5);
	var spaces = __webpack_require__(117);
	var space = '[' + spaces + ']';
	var non = '\u200b\u0085';
	var ltrim = RegExp('^' + space + space + '*');
	var rtrim = RegExp(space + space + '*$');
	
	var exporter = function (KEY, exec, ALIAS) {
	  var exp = {};
	  var FORCE = fails(function () {
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if (ALIAS) exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function (string, TYPE) {
	  string = String(defined(string));
	  if (TYPE & 1) string = string.replace(ltrim, '');
	  if (TYPE & 2) string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;


/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(6);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};


/***/ },
/* 58 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path : '/' + path;
	};
	
	var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path.substr(1) : path;
	};
	
	var hasBasename = exports.hasBasename = function hasBasename(path, prefix) {
	  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
	};
	
	var stripBasename = exports.stripBasename = function stripBasename(path, prefix) {
	  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
	};
	
	var stripTrailingSlash = exports.stripTrailingSlash = function stripTrailingSlash(path) {
	  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
	};
	
	var parsePath = exports.parsePath = function parsePath(path) {
	  var pathname = path || '/';
	  var search = '';
	  var hash = '';
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substr(hashIndex);
	    pathname = pathname.substr(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substr(searchIndex);
	    pathname = pathname.substr(0, searchIndex);
	  }
	
	  return {
	    pathname: pathname,
	    search: search === '?' ? '' : search,
	    hash: hash === '#' ? '' : hash
	  };
	};
	
	var createPath = exports.createPath = function createPath(location) {
	  var pathname = location.pathname,
	      search = location.search,
	      hash = location.hash;
	
	
	  var path = pathname || '/';
	
	  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;
	
	  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;
	
	  return path;
	};

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.connect = exports.connectAdvanced = exports.createProvider = exports.Provider = undefined;
	
	var _Provider = __webpack_require__(520);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _connectAdvanced = __webpack_require__(201);
	
	var _connectAdvanced2 = _interopRequireDefault(_connectAdvanced);
	
	var _connect = __webpack_require__(521);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Provider = _Provider2.default;
	exports.createProvider = _Provider.createProvider;
	exports.connectAdvanced = _connectAdvanced2.default;
	exports.connect = _connect2.default;

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.routerMiddleware = exports.routerActions = exports.goForward = exports.goBack = exports.go = exports.replace = exports.push = exports.CALL_HISTORY_METHOD = exports.routerReducer = exports.LOCATION_CHANGE = exports.createMatchSelector = exports.getLocation = exports.ConnectedRouter = undefined;
	
	var _selectors = __webpack_require__(541);
	
	Object.defineProperty(exports, 'getLocation', {
	  enumerable: true,
	  get: function get() {
	    return _selectors.getLocation;
	  }
	});
	Object.defineProperty(exports, 'createMatchSelector', {
	  enumerable: true,
	  get: function get() {
	    return _selectors.createMatchSelector;
	  }
	});
	
	var _reducer = __webpack_require__(208);
	
	Object.defineProperty(exports, 'LOCATION_CHANGE', {
	  enumerable: true,
	  get: function get() {
	    return _reducer.LOCATION_CHANGE;
	  }
	});
	Object.defineProperty(exports, 'routerReducer', {
	  enumerable: true,
	  get: function get() {
	    return _reducer.routerReducer;
	  }
	});
	
	var _actions = __webpack_require__(207);
	
	Object.defineProperty(exports, 'CALL_HISTORY_METHOD', {
	  enumerable: true,
	  get: function get() {
	    return _actions.CALL_HISTORY_METHOD;
	  }
	});
	Object.defineProperty(exports, 'push', {
	  enumerable: true,
	  get: function get() {
	    return _actions.push;
	  }
	});
	Object.defineProperty(exports, 'replace', {
	  enumerable: true,
	  get: function get() {
	    return _actions.replace;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _actions.go;
	  }
	});
	Object.defineProperty(exports, 'goBack', {
	  enumerable: true,
	  get: function get() {
	    return _actions.goBack;
	  }
	});
	Object.defineProperty(exports, 'goForward', {
	  enumerable: true,
	  get: function get() {
	    return _actions.goForward;
	  }
	});
	Object.defineProperty(exports, 'routerActions', {
	  enumerable: true,
	  get: function get() {
	    return _actions.routerActions;
	  }
	});
	
	var _ConnectedRouter2 = __webpack_require__(539);
	
	var _ConnectedRouter3 = _interopRequireDefault(_ConnectedRouter2);
	
	var _middleware = __webpack_require__(540);
	
	var _middleware2 = _interopRequireDefault(_middleware);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.ConnectedRouter = _ConnectedRouter3.default;
	exports.routerMiddleware = _middleware2.default;

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(25);
	var TAG = __webpack_require__(8)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(25);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ },
/* 63 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/facebook-black.e61d14dd.svg";

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/instagram-black.5f709f35.svg";

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/milan-circle.eb0a86c2.svg";

/***/ },
/* 67 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.THREE = {})));
	}(this, (function (exports) { 'use strict';
	
		// Polyfills
	
		if ( Number.EPSILON === undefined ) {
	
			Number.EPSILON = Math.pow( 2, - 52 );
	
		}
	
		if ( Number.isInteger === undefined ) {
	
			// Missing in IE
			// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isInteger
	
			Number.isInteger = function ( value ) {
	
				return typeof value === 'number' && isFinite( value ) && Math.floor( value ) === value;
	
			};
	
		}
	
		//
	
		if ( Math.sign === undefined ) {
	
			// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/sign
	
			Math.sign = function ( x ) {
	
				return ( x < 0 ) ? - 1 : ( x > 0 ) ? 1 : + x;
	
			};
	
		}
	
		if ( 'name' in Function.prototype === false ) {
	
			// Missing in IE
			// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/name
	
			Object.defineProperty( Function.prototype, 'name', {
	
				get: function () {
	
					return this.toString().match( /^\s*function\s*([^\(\s]*)/ )[ 1 ];
	
				}
	
			} );
	
		}
	
		if ( Object.assign === undefined ) {
	
			// Missing in IE
			// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
	
			( function () {
	
				Object.assign = function ( target ) {
	
					if ( target === undefined || target === null ) {
	
						throw new TypeError( 'Cannot convert undefined or null to object' );
	
					}
	
					var output = Object( target );
	
					for ( var index = 1; index < arguments.length; index ++ ) {
	
						var source = arguments[ index ];
	
						if ( source !== undefined && source !== null ) {
	
							for ( var nextKey in source ) {
	
								if ( Object.prototype.hasOwnProperty.call( source, nextKey ) ) {
	
									output[ nextKey ] = source[ nextKey ];
	
								}
	
							}
	
						}
	
					}
	
					return output;
	
				};
	
			} )();
	
		}
	
		/**
		 * https://github.com/mrdoob/eventdispatcher.js/
		 */
	
		function EventDispatcher() {}
	
		Object.assign( EventDispatcher.prototype, {
	
			addEventListener: function ( type, listener ) {
	
				if ( this._listeners === undefined ) this._listeners = {};
	
				var listeners = this._listeners;
	
				if ( listeners[ type ] === undefined ) {
	
					listeners[ type ] = [];
	
				}
	
				if ( listeners[ type ].indexOf( listener ) === - 1 ) {
	
					listeners[ type ].push( listener );
	
				}
	
			},
	
			hasEventListener: function ( type, listener ) {
	
				if ( this._listeners === undefined ) return false;
	
				var listeners = this._listeners;
	
				return listeners[ type ] !== undefined && listeners[ type ].indexOf( listener ) !== - 1;
	
			},
	
			removeEventListener: function ( type, listener ) {
	
				if ( this._listeners === undefined ) return;
	
				var listeners = this._listeners;
				var listenerArray = listeners[ type ];
	
				if ( listenerArray !== undefined ) {
	
					var index = listenerArray.indexOf( listener );
	
					if ( index !== - 1 ) {
	
						listenerArray.splice( index, 1 );
	
					}
	
				}
	
			},
	
			dispatchEvent: function ( event ) {
	
				if ( this._listeners === undefined ) return;
	
				var listeners = this._listeners;
				var listenerArray = listeners[ event.type ];
	
				if ( listenerArray !== undefined ) {
	
					event.target = this;
	
					var array = listenerArray.slice( 0 );
	
					for ( var i = 0, l = array.length; i < l; i ++ ) {
	
						array[ i ].call( this, event );
	
					}
	
				}
	
			}
	
		} );
	
		var REVISION = '89';
		var MOUSE = { LEFT: 0, MIDDLE: 1, RIGHT: 2 };
		var CullFaceNone = 0;
		var CullFaceBack = 1;
		var CullFaceFront = 2;
		var CullFaceFrontBack = 3;
		var FrontFaceDirectionCW = 0;
		var FrontFaceDirectionCCW = 1;
		var BasicShadowMap = 0;
		var PCFShadowMap = 1;
		var PCFSoftShadowMap = 2;
		var FrontSide = 0;
		var BackSide = 1;
		var DoubleSide = 2;
		var FlatShading = 1;
		var SmoothShading = 2;
		var NoColors = 0;
		var FaceColors = 1;
		var VertexColors = 2;
		var NoBlending = 0;
		var NormalBlending = 1;
		var AdditiveBlending = 2;
		var SubtractiveBlending = 3;
		var MultiplyBlending = 4;
		var CustomBlending = 5;
		var AddEquation = 100;
		var SubtractEquation = 101;
		var ReverseSubtractEquation = 102;
		var MinEquation = 103;
		var MaxEquation = 104;
		var ZeroFactor = 200;
		var OneFactor = 201;
		var SrcColorFactor = 202;
		var OneMinusSrcColorFactor = 203;
		var SrcAlphaFactor = 204;
		var OneMinusSrcAlphaFactor = 205;
		var DstAlphaFactor = 206;
		var OneMinusDstAlphaFactor = 207;
		var DstColorFactor = 208;
		var OneMinusDstColorFactor = 209;
		var SrcAlphaSaturateFactor = 210;
		var NeverDepth = 0;
		var AlwaysDepth = 1;
		var LessDepth = 2;
		var LessEqualDepth = 3;
		var EqualDepth = 4;
		var GreaterEqualDepth = 5;
		var GreaterDepth = 6;
		var NotEqualDepth = 7;
		var MultiplyOperation = 0;
		var MixOperation = 1;
		var AddOperation = 2;
		var NoToneMapping = 0;
		var LinearToneMapping = 1;
		var ReinhardToneMapping = 2;
		var Uncharted2ToneMapping = 3;
		var CineonToneMapping = 4;
		var UVMapping = 300;
		var CubeReflectionMapping = 301;
		var CubeRefractionMapping = 302;
		var EquirectangularReflectionMapping = 303;
		var EquirectangularRefractionMapping = 304;
		var SphericalReflectionMapping = 305;
		var CubeUVReflectionMapping = 306;
		var CubeUVRefractionMapping = 307;
		var RepeatWrapping = 1000;
		var ClampToEdgeWrapping = 1001;
		var MirroredRepeatWrapping = 1002;
		var NearestFilter = 1003;
		var NearestMipMapNearestFilter = 1004;
		var NearestMipMapLinearFilter = 1005;
		var LinearFilter = 1006;
		var LinearMipMapNearestFilter = 1007;
		var LinearMipMapLinearFilter = 1008;
		var UnsignedByteType = 1009;
		var ByteType = 1010;
		var ShortType = 1011;
		var UnsignedShortType = 1012;
		var IntType = 1013;
		var UnsignedIntType = 1014;
		var FloatType = 1015;
		var HalfFloatType = 1016;
		var UnsignedShort4444Type = 1017;
		var UnsignedShort5551Type = 1018;
		var UnsignedShort565Type = 1019;
		var UnsignedInt248Type = 1020;
		var AlphaFormat = 1021;
		var RGBFormat = 1022;
		var RGBAFormat = 1023;
		var LuminanceFormat = 1024;
		var LuminanceAlphaFormat = 1025;
		var RGBEFormat = RGBAFormat;
		var DepthFormat = 1026;
		var DepthStencilFormat = 1027;
		var RGB_S3TC_DXT1_Format = 2001;
		var RGBA_S3TC_DXT1_Format = 2002;
		var RGBA_S3TC_DXT3_Format = 2003;
		var RGBA_S3TC_DXT5_Format = 2004;
		var RGB_PVRTC_4BPPV1_Format = 2100;
		var RGB_PVRTC_2BPPV1_Format = 2101;
		var RGBA_PVRTC_4BPPV1_Format = 2102;
		var RGBA_PVRTC_2BPPV1_Format = 2103;
		var RGB_ETC1_Format = 2151;
		var LoopOnce = 2200;
		var LoopRepeat = 2201;
		var LoopPingPong = 2202;
		var InterpolateDiscrete = 2300;
		var InterpolateLinear = 2301;
		var InterpolateSmooth = 2302;
		var ZeroCurvatureEnding = 2400;
		var ZeroSlopeEnding = 2401;
		var WrapAroundEnding = 2402;
		var TrianglesDrawMode = 0;
		var TriangleStripDrawMode = 1;
		var TriangleFanDrawMode = 2;
		var LinearEncoding = 3000;
		var sRGBEncoding = 3001;
		var GammaEncoding = 3007;
		var RGBEEncoding = 3002;
		var LogLuvEncoding = 3003;
		var RGBM7Encoding = 3004;
		var RGBM16Encoding = 3005;
		var RGBDEncoding = 3006;
		var BasicDepthPacking = 3200;
		var RGBADepthPacking = 3201;
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		var _Math = {
	
			DEG2RAD: Math.PI / 180,
			RAD2DEG: 180 / Math.PI,
	
			generateUUID: ( function () {
	
				// http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
	
				var lut = [];
	
				for ( var i = 0; i < 256; i ++ ) {
	
					lut[ i ] = ( i < 16 ? '0' : '' ) + ( i ).toString( 16 ).toUpperCase();
	
				}
	
				return function () {
	
					var d0 = Math.random() * 0xffffffff | 0;
					var d1 = Math.random() * 0xffffffff | 0;
					var d2 = Math.random() * 0xffffffff | 0;
					var d3 = Math.random() * 0xffffffff | 0;
					return lut[ d0 & 0xff ] + lut[ d0 >> 8 & 0xff ] + lut[ d0 >> 16 & 0xff ] + lut[ d0 >> 24 & 0xff ] + '-' +
						lut[ d1 & 0xff ] + lut[ d1 >> 8 & 0xff ] + '-' + lut[ d1 >> 16 & 0x0f | 0x40 ] + lut[ d1 >> 24 & 0xff ] + '-' +
						lut[ d2 & 0x3f | 0x80 ] + lut[ d2 >> 8 & 0xff ] + '-' + lut[ d2 >> 16 & 0xff ] + lut[ d2 >> 24 & 0xff ] +
						lut[ d3 & 0xff ] + lut[ d3 >> 8 & 0xff ] + lut[ d3 >> 16 & 0xff ] + lut[ d3 >> 24 & 0xff ];
	
				};
	
			} )(),
	
			clamp: function ( value, min, max ) {
	
				return Math.max( min, Math.min( max, value ) );
	
			},
	
			// compute euclidian modulo of m % n
			// https://en.wikipedia.org/wiki/Modulo_operation
	
			euclideanModulo: function ( n, m ) {
	
				return ( ( n % m ) + m ) % m;
	
			},
	
			// Linear mapping from range <a1, a2> to range <b1, b2>
	
			mapLinear: function ( x, a1, a2, b1, b2 ) {
	
				return b1 + ( x - a1 ) * ( b2 - b1 ) / ( a2 - a1 );
	
			},
	
			// https://en.wikipedia.org/wiki/Linear_interpolation
	
			lerp: function ( x, y, t ) {
	
				return ( 1 - t ) * x + t * y;
	
			},
	
			// http://en.wikipedia.org/wiki/Smoothstep
	
			smoothstep: function ( x, min, max ) {
	
				if ( x <= min ) return 0;
				if ( x >= max ) return 1;
	
				x = ( x - min ) / ( max - min );
	
				return x * x * ( 3 - 2 * x );
	
			},
	
			smootherstep: function ( x, min, max ) {
	
				if ( x <= min ) return 0;
				if ( x >= max ) return 1;
	
				x = ( x - min ) / ( max - min );
	
				return x * x * x * ( x * ( x * 6 - 15 ) + 10 );
	
			},
	
			// Random integer from <low, high> interval
	
			randInt: function ( low, high ) {
	
				return low + Math.floor( Math.random() * ( high - low + 1 ) );
	
			},
	
			// Random float from <low, high> interval
	
			randFloat: function ( low, high ) {
	
				return low + Math.random() * ( high - low );
	
			},
	
			// Random float from <-range/2, range/2> interval
	
			randFloatSpread: function ( range ) {
	
				return range * ( 0.5 - Math.random() );
	
			},
	
			degToRad: function ( degrees ) {
	
				return degrees * _Math.DEG2RAD;
	
			},
	
			radToDeg: function ( radians ) {
	
				return radians * _Math.RAD2DEG;
	
			},
	
			isPowerOfTwo: function ( value ) {
	
				return ( value & ( value - 1 ) ) === 0 && value !== 0;
	
			},
	
			ceilPowerOfTwo: function ( value ) {
	
				return Math.pow( 2, Math.ceil( Math.log( value ) / Math.LN2 ) );
	
			},
	
			floorPowerOfTwo: function ( value ) {
	
				return Math.pow( 2, Math.floor( Math.log( value ) / Math.LN2 ) );
	
			}
	
		};
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author philogb / http://blog.thejit.org/
		 * @author egraether / http://egraether.com/
		 * @author zz85 / http://www.lab4games.net/zz85/blog
		 */
	
		function Vector2( x, y ) {
	
			this.x = x || 0;
			this.y = y || 0;
	
		}
	
		Object.defineProperties( Vector2.prototype, {
	
			"width": {
	
				get: function () {
	
					return this.x;
	
				},
	
				set: function ( value ) {
	
					this.x = value;
	
				}
	
			},
	
			"height": {
	
				get: function () {
	
					return this.y;
	
				},
	
				set: function ( value ) {
	
					this.y = value;
	
				}
	
			}
	
		} );
	
		Object.assign( Vector2.prototype, {
	
			isVector2: true,
	
			set: function ( x, y ) {
	
				this.x = x;
				this.y = y;
	
				return this;
	
			},
	
			setScalar: function ( scalar ) {
	
				this.x = scalar;
				this.y = scalar;
	
				return this;
	
			},
	
			setX: function ( x ) {
	
				this.x = x;
	
				return this;
	
			},
	
			setY: function ( y ) {
	
				this.y = y;
	
				return this;
	
			},
	
			setComponent: function ( index, value ) {
	
				switch ( index ) {
	
					case 0: this.x = value; break;
					case 1: this.y = value; break;
					default: throw new Error( 'index is out of range: ' + index );
	
				}
	
				return this;
	
			},
	
			getComponent: function ( index ) {
	
				switch ( index ) {
	
					case 0: return this.x;
					case 1: return this.y;
					default: throw new Error( 'index is out of range: ' + index );
	
				}
	
			},
	
			clone: function () {
	
				return new this.constructor( this.x, this.y );
	
			},
	
			copy: function ( v ) {
	
				this.x = v.x;
				this.y = v.y;
	
				return this;
	
			},
	
			add: function ( v, w ) {
	
				if ( w !== undefined ) {
	
					console.warn( 'THREE.Vector2: .add() now only accepts one argument. Use .addVectors( a, b ) instead.' );
					return this.addVectors( v, w );
	
				}
	
				this.x += v.x;
				this.y += v.y;
	
				return this;
	
			},
	
			addScalar: function ( s ) {
	
				this.x += s;
				this.y += s;
	
				return this;
	
			},
	
			addVectors: function ( a, b ) {
	
				this.x = a.x + b.x;
				this.y = a.y + b.y;
	
				return this;
	
			},
	
			addScaledVector: function ( v, s ) {
	
				this.x += v.x * s;
				this.y += v.y * s;
	
				return this;
	
			},
	
			sub: function ( v, w ) {
	
				if ( w !== undefined ) {
	
					console.warn( 'THREE.Vector2: .sub() now only accepts one argument. Use .subVectors( a, b ) instead.' );
					return this.subVectors( v, w );
	
				}
	
				this.x -= v.x;
				this.y -= v.y;
	
				return this;
	
			},
	
			subScalar: function ( s ) {
	
				this.x -= s;
				this.y -= s;
	
				return this;
	
			},
	
			subVectors: function ( a, b ) {
	
				this.x = a.x - b.x;
				this.y = a.y - b.y;
	
				return this;
	
			},
	
			multiply: function ( v ) {
	
				this.x *= v.x;
				this.y *= v.y;
	
				return this;
	
			},
	
			multiplyScalar: function ( scalar ) {
	
				this.x *= scalar;
				this.y *= scalar;
	
				return this;
	
			},
	
			divide: function ( v ) {
	
				this.x /= v.x;
				this.y /= v.y;
	
				return this;
	
			},
	
			divideScalar: function ( scalar ) {
	
				return this.multiplyScalar( 1 / scalar );
	
			},
	
			applyMatrix3: function ( m ) {
	
				var x = this.x, y = this.y;
				var e = m.elements;
	
				this.x = e[ 0 ] * x + e[ 3 ] * y + e[ 6 ];
				this.y = e[ 1 ] * x + e[ 4 ] * y + e[ 7 ];
	
				return this;
	
			},
	
			min: function ( v ) {
	
				this.x = Math.min( this.x, v.x );
				this.y = Math.min( this.y, v.y );
	
				return this;
	
			},
	
			max: function ( v ) {
	
				this.x = Math.max( this.x, v.x );
				this.y = Math.max( this.y, v.y );
	
				return this;
	
			},
	
			clamp: function ( min, max ) {
	
				// assumes min < max, componentwise
	
				this.x = Math.max( min.x, Math.min( max.x, this.x ) );
				this.y = Math.max( min.y, Math.min( max.y, this.y ) );
	
				return this;
	
			},
	
			clampScalar: function () {
	
				var min = new Vector2();
				var max = new Vector2();
	
				return function clampScalar( minVal, maxVal ) {
	
					min.set( minVal, minVal );
					max.set( maxVal, maxVal );
	
					return this.clamp( min, max );
	
				};
	
			}(),
	
			clampLength: function ( min, max ) {
	
				var length = this.length();
	
				return this.divideScalar( length || 1 ).multiplyScalar( Math.max( min, Math.min( max, length ) ) );
	
			},
	
			floor: function () {
	
				this.x = Math.floor( this.x );
				this.y = Math.floor( this.y );
	
				return this;
	
			},
	
			ceil: function () {
	
				this.x = Math.ceil( this.x );
				this.y = Math.ceil( this.y );
	
				return this;
	
			},
	
			round: function () {
	
				this.x = Math.round( this.x );
				this.y = Math.round( this.y );
	
				return this;
	
			},
	
			roundToZero: function () {
	
				this.x = ( this.x < 0 ) ? Math.ceil( this.x ) : Math.floor( this.x );
				this.y = ( this.y < 0 ) ? Math.ceil( this.y ) : Math.floor( this.y );
	
				return this;
	
			},
	
			negate: function () {
	
				this.x = - this.x;
				this.y = - this.y;
	
				return this;
	
			},
	
			dot: function ( v ) {
	
				return this.x * v.x + this.y * v.y;
	
			},
	
			lengthSq: function () {
	
				return this.x * this.x + this.y * this.y;
	
			},
	
			length: function () {
	
				return Math.sqrt( this.x * this.x + this.y * this.y );
	
			},
	
			manhattanLength: function () {
	
				return Math.abs( this.x ) + Math.abs( this.y );
	
			},
	
			normalize: function () {
	
				return this.divideScalar( this.length() || 1 );
	
			},
	
			angle: function () {
	
				// computes the angle in radians with respect to the positive x-axis
	
				var angle = Math.atan2( this.y, this.x );
	
				if ( angle < 0 ) angle += 2 * Math.PI;
	
				return angle;
	
			},
	
			distanceTo: function ( v ) {
	
				return Math.sqrt( this.distanceToSquared( v ) );
	
			},
	
			distanceToSquared: function ( v ) {
	
				var dx = this.x - v.x, dy = this.y - v.y;
				return dx * dx + dy * dy;
	
			},
	
			manhattanDistanceTo: function ( v ) {
	
				return Math.abs( this.x - v.x ) + Math.abs( this.y - v.y );
	
			},
	
			setLength: function ( length ) {
	
				return this.normalize().multiplyScalar( length );
	
			},
	
			lerp: function ( v, alpha ) {
	
				this.x += ( v.x - this.x ) * alpha;
				this.y += ( v.y - this.y ) * alpha;
	
				return this;
	
			},
	
			lerpVectors: function ( v1, v2, alpha ) {
	
				return this.subVectors( v2, v1 ).multiplyScalar( alpha ).add( v1 );
	
			},
	
			equals: function ( v ) {
	
				return ( ( v.x === this.x ) && ( v.y === this.y ) );
	
			},
	
			fromArray: function ( array, offset ) {
	
				if ( offset === undefined ) offset = 0;
	
				this.x = array[ offset ];
				this.y = array[ offset + 1 ];
	
				return this;
	
			},
	
			toArray: function ( array, offset ) {
	
				if ( array === undefined ) array = [];
				if ( offset === undefined ) offset = 0;
	
				array[ offset ] = this.x;
				array[ offset + 1 ] = this.y;
	
				return array;
	
			},
	
			fromBufferAttribute: function ( attribute, index, offset ) {
	
				if ( offset !== undefined ) {
	
					console.warn( 'THREE.Vector2: offset has been removed from .fromBufferAttribute().' );
	
				}
	
				this.x = attribute.getX( index );
				this.y = attribute.getY( index );
	
				return this;
	
			},
	
			rotateAround: function ( center, angle ) {
	
				var c = Math.cos( angle ), s = Math.sin( angle );
	
				var x = this.x - center.x;
				var y = this.y - center.y;
	
				this.x = x * c - y * s + center.x;
				this.y = x * s + y * c + center.y;
	
				return this;
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author supereggbert / http://www.paulbrunt.co.uk/
		 * @author philogb / http://blog.thejit.org/
		 * @author jordi_ros / http://plattsoft.com
		 * @author D1plo1d / http://github.com/D1plo1d
		 * @author alteredq / http://alteredqualia.com/
		 * @author mikael emtinger / http://gomo.se/
		 * @author timknip / http://www.floorplanner.com/
		 * @author bhouston / http://clara.io
		 * @author WestLangley / http://github.com/WestLangley
		 */
	
		function Matrix4() {
	
			this.elements = [
	
				1, 0, 0, 0,
				0, 1, 0, 0,
				0, 0, 1, 0,
				0, 0, 0, 1
	
			];
	
			if ( arguments.length > 0 ) {
	
				console.error( 'THREE.Matrix4: the constructor no longer reads arguments. use .set() instead.' );
	
			}
	
		}
	
		Object.assign( Matrix4.prototype, {
	
			isMatrix4: true,
	
			set: function ( n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44 ) {
	
				var te = this.elements;
	
				te[ 0 ] = n11; te[ 4 ] = n12; te[ 8 ] = n13; te[ 12 ] = n14;
				te[ 1 ] = n21; te[ 5 ] = n22; te[ 9 ] = n23; te[ 13 ] = n24;
				te[ 2 ] = n31; te[ 6 ] = n32; te[ 10 ] = n33; te[ 14 ] = n34;
				te[ 3 ] = n41; te[ 7 ] = n42; te[ 11 ] = n43; te[ 15 ] = n44;
	
				return this;
	
			},
	
			identity: function () {
	
				this.set(
	
					1, 0, 0, 0,
					0, 1, 0, 0,
					0, 0, 1, 0,
					0, 0, 0, 1
	
				);
	
				return this;
	
			},
	
			clone: function () {
	
				return new Matrix4().fromArray( this.elements );
	
			},
	
			copy: function ( m ) {
	
				var te = this.elements;
				var me = m.elements;
	
				te[ 0 ] = me[ 0 ]; te[ 1 ] = me[ 1 ]; te[ 2 ] = me[ 2 ]; te[ 3 ] = me[ 3 ];
				te[ 4 ] = me[ 4 ]; te[ 5 ] = me[ 5 ]; te[ 6 ] = me[ 6 ]; te[ 7 ] = me[ 7 ];
				te[ 8 ] = me[ 8 ]; te[ 9 ] = me[ 9 ]; te[ 10 ] = me[ 10 ]; te[ 11 ] = me[ 11 ];
				te[ 12 ] = me[ 12 ]; te[ 13 ] = me[ 13 ]; te[ 14 ] = me[ 14 ]; te[ 15 ] = me[ 15 ];
	
				return this;
	
			},
	
			copyPosition: function ( m ) {
	
				var te = this.elements, me = m.elements;
	
				te[ 12 ] = me[ 12 ];
				te[ 13 ] = me[ 13 ];
				te[ 14 ] = me[ 14 ];
	
				return this;
	
			},
	
			extractBasis: function ( xAxis, yAxis, zAxis ) {
	
				xAxis.setFromMatrixColumn( this, 0 );
				yAxis.setFromMatrixColumn( this, 1 );
				zAxis.setFromMatrixColumn( this, 2 );
	
				return this;
	
			},
	
			makeBasis: function ( xAxis, yAxis, zAxis ) {
	
				this.set(
					xAxis.x, yAxis.x, zAxis.x, 0,
					xAxis.y, yAxis.y, zAxis.y, 0,
					xAxis.z, yAxis.z, zAxis.z, 0,
					0, 0, 0, 1
				);
	
				return this;
	
			},
	
			extractRotation: function () {
	
				var v1 = new Vector3();
	
				return function extractRotation( m ) {
	
					var te = this.elements;
					var me = m.elements;
	
					var scaleX = 1 / v1.setFromMatrixColumn( m, 0 ).length();
					var scaleY = 1 / v1.setFromMatrixColumn( m, 1 ).length();
					var scaleZ = 1 / v1.setFromMatrixColumn( m, 2 ).length();
	
					te[ 0 ] = me[ 0 ] * scaleX;
					te[ 1 ] = me[ 1 ] * scaleX;
					te[ 2 ] = me[ 2 ] * scaleX;
	
					te[ 4 ] = me[ 4 ] * scaleY;
					te[ 5 ] = me[ 5 ] * scaleY;
					te[ 6 ] = me[ 6 ] * scaleY;
	
					te[ 8 ] = me[ 8 ] * scaleZ;
					te[ 9 ] = me[ 9 ] * scaleZ;
					te[ 10 ] = me[ 10 ] * scaleZ;
	
					return this;
	
				};
	
			}(),
	
			makeRotationFromEuler: function ( euler ) {
	
				if ( ! ( euler && euler.isEuler ) ) {
	
					console.error( 'THREE.Matrix4: .makeRotationFromEuler() now expects a Euler rotation rather than a Vector3 and order.' );
	
				}
	
				var te = this.elements;
	
				var x = euler.x, y = euler.y, z = euler.z;
				var a = Math.cos( x ), b = Math.sin( x );
				var c = Math.cos( y ), d = Math.sin( y );
				var e = Math.cos( z ), f = Math.sin( z );
	
				if ( euler.order === 'XYZ' ) {
	
					var ae = a * e, af = a * f, be = b * e, bf = b * f;
	
					te[ 0 ] = c * e;
					te[ 4 ] = - c * f;
					te[ 8 ] = d;
	
					te[ 1 ] = af + be * d;
					te[ 5 ] = ae - bf * d;
					te[ 9 ] = - b * c;
	
					te[ 2 ] = bf - ae * d;
					te[ 6 ] = be + af * d;
					te[ 10 ] = a * c;
	
				} else if ( euler.order === 'YXZ' ) {
	
					var ce = c * e, cf = c * f, de = d * e, df = d * f;
	
					te[ 0 ] = ce + df * b;
					te[ 4 ] = de * b - cf;
					te[ 8 ] = a * d;
	
					te[ 1 ] = a * f;
					te[ 5 ] = a * e;
					te[ 9 ] = - b;
	
					te[ 2 ] = cf * b - de;
					te[ 6 ] = df + ce * b;
					te[ 10 ] = a * c;
	
				} else if ( euler.order === 'ZXY' ) {
	
					var ce = c * e, cf = c * f, de = d * e, df = d * f;
	
					te[ 0 ] = ce - df * b;
					te[ 4 ] = - a * f;
					te[ 8 ] = de + cf * b;
	
					te[ 1 ] = cf + de * b;
					te[ 5 ] = a * e;
					te[ 9 ] = df - ce * b;
	
					te[ 2 ] = - a * d;
					te[ 6 ] = b;
					te[ 10 ] = a * c;
	
				} else if ( euler.order === 'ZYX' ) {
	
					var ae = a * e, af = a * f, be = b * e, bf = b * f;
	
					te[ 0 ] = c * e;
					te[ 4 ] = be * d - af;
					te[ 8 ] = ae * d + bf;
	
					te[ 1 ] = c * f;
					te[ 5 ] = bf * d + ae;
					te[ 9 ] = af * d - be;
	
					te[ 2 ] = - d;
					te[ 6 ] = b * c;
					te[ 10 ] = a * c;
	
				} else if ( euler.order === 'YZX' ) {
	
					var ac = a * c, ad = a * d, bc = b * c, bd = b * d;
	
					te[ 0 ] = c * e;
					te[ 4 ] = bd - ac * f;
					te[ 8 ] = bc * f + ad;
	
					te[ 1 ] = f;
					te[ 5 ] = a * e;
					te[ 9 ] = - b * e;
	
					te[ 2 ] = - d * e;
					te[ 6 ] = ad * f + bc;
					te[ 10 ] = ac - bd * f;
	
				} else if ( euler.order === 'XZY' ) {
	
					var ac = a * c, ad = a * d, bc = b * c, bd = b * d;
	
					te[ 0 ] = c * e;
					te[ 4 ] = - f;
					te[ 8 ] = d * e;
	
					te[ 1 ] = ac * f + bd;
					te[ 5 ] = a * e;
					te[ 9 ] = ad * f - bc;
	
					te[ 2 ] = bc * f - ad;
					te[ 6 ] = b * e;
					te[ 10 ] = bd * f + ac;
	
				}
	
				// last column
				te[ 3 ] = 0;
				te[ 7 ] = 0;
				te[ 11 ] = 0;
	
				// bottom row
				te[ 12 ] = 0;
				te[ 13 ] = 0;
				te[ 14 ] = 0;
				te[ 15 ] = 1;
	
				return this;
	
			},
	
			makeRotationFromQuaternion: function ( q ) {
	
				var te = this.elements;
	
				var x = q._x, y = q._y, z = q._z, w = q._w;
				var x2 = x + x, y2 = y + y, z2 = z + z;
				var xx = x * x2, xy = x * y2, xz = x * z2;
				var yy = y * y2, yz = y * z2, zz = z * z2;
				var wx = w * x2, wy = w * y2, wz = w * z2;
	
				te[ 0 ] = 1 - ( yy + zz );
				te[ 4 ] = xy - wz;
				te[ 8 ] = xz + wy;
	
				te[ 1 ] = xy + wz;
				te[ 5 ] = 1 - ( xx + zz );
				te[ 9 ] = yz - wx;
	
				te[ 2 ] = xz - wy;
				te[ 6 ] = yz + wx;
				te[ 10 ] = 1 - ( xx + yy );
	
				// last column
				te[ 3 ] = 0;
				te[ 7 ] = 0;
				te[ 11 ] = 0;
	
				// bottom row
				te[ 12 ] = 0;
				te[ 13 ] = 0;
				te[ 14 ] = 0;
				te[ 15 ] = 1;
	
				return this;
	
			},
	
			lookAt: function () {
	
				var x = new Vector3();
				var y = new Vector3();
				var z = new Vector3();
	
				return function lookAt( eye, target, up ) {
	
					var te = this.elements;
	
					z.subVectors( eye, target );
	
					if ( z.lengthSq() === 0 ) {
	
						// eye and target are in the same position
	
						z.z = 1;
	
					}
	
					z.normalize();
					x.crossVectors( up, z );
	
					if ( x.lengthSq() === 0 ) {
	
						// up and z are parallel
	
						if ( Math.abs( up.z ) === 1 ) {
	
							z.x += 0.0001;
	
						} else {
	
							z.z += 0.0001;
	
						}
	
						z.normalize();
						x.crossVectors( up, z );
	
					}
	
					x.normalize();
					y.crossVectors( z, x );
	
					te[ 0 ] = x.x; te[ 4 ] = y.x; te[ 8 ] = z.x;
					te[ 1 ] = x.y; te[ 5 ] = y.y; te[ 9 ] = z.y;
					te[ 2 ] = x.z; te[ 6 ] = y.z; te[ 10 ] = z.z;
	
					return this;
	
				};
	
			}(),
	
			multiply: function ( m, n ) {
	
				if ( n !== undefined ) {
	
					console.warn( 'THREE.Matrix4: .multiply() now only accepts one argument. Use .multiplyMatrices( a, b ) instead.' );
					return this.multiplyMatrices( m, n );
	
				}
	
				return this.multiplyMatrices( this, m );
	
			},
	
			premultiply: function ( m ) {
	
				return this.multiplyMatrices( m, this );
	
			},
	
			multiplyMatrices: function ( a, b ) {
	
				var ae = a.elements;
				var be = b.elements;
				var te = this.elements;
	
				var a11 = ae[ 0 ], a12 = ae[ 4 ], a13 = ae[ 8 ], a14 = ae[ 12 ];
				var a21 = ae[ 1 ], a22 = ae[ 5 ], a23 = ae[ 9 ], a24 = ae[ 13 ];
				var a31 = ae[ 2 ], a32 = ae[ 6 ], a33 = ae[ 10 ], a34 = ae[ 14 ];
				var a41 = ae[ 3 ], a42 = ae[ 7 ], a43 = ae[ 11 ], a44 = ae[ 15 ];
	
				var b11 = be[ 0 ], b12 = be[ 4 ], b13 = be[ 8 ], b14 = be[ 12 ];
				var b21 = be[ 1 ], b22 = be[ 5 ], b23 = be[ 9 ], b24 = be[ 13 ];
				var b31 = be[ 2 ], b32 = be[ 6 ], b33 = be[ 10 ], b34 = be[ 14 ];
				var b41 = be[ 3 ], b42 = be[ 7 ], b43 = be[ 11 ], b44 = be[ 15 ];
	
				te[ 0 ] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
				te[ 4 ] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
				te[ 8 ] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
				te[ 12 ] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;
	
				te[ 1 ] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
				te[ 5 ] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
				te[ 9 ] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
				te[ 13 ] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;
	
				te[ 2 ] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
				te[ 6 ] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
				te[ 10 ] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
				te[ 14 ] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;
	
				te[ 3 ] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
				te[ 7 ] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
				te[ 11 ] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
				te[ 15 ] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;
	
				return this;
	
			},
	
			multiplyScalar: function ( s ) {
	
				var te = this.elements;
	
				te[ 0 ] *= s; te[ 4 ] *= s; te[ 8 ] *= s; te[ 12 ] *= s;
				te[ 1 ] *= s; te[ 5 ] *= s; te[ 9 ] *= s; te[ 13 ] *= s;
				te[ 2 ] *= s; te[ 6 ] *= s; te[ 10 ] *= s; te[ 14 ] *= s;
				te[ 3 ] *= s; te[ 7 ] *= s; te[ 11 ] *= s; te[ 15 ] *= s;
	
				return this;
	
			},
	
			applyToBufferAttribute: function () {
	
				var v1 = new Vector3();
	
				return function applyToBufferAttribute( attribute ) {
	
					for ( var i = 0, l = attribute.count; i < l; i ++ ) {
	
						v1.x = attribute.getX( i );
						v1.y = attribute.getY( i );
						v1.z = attribute.getZ( i );
	
						v1.applyMatrix4( this );
	
						attribute.setXYZ( i, v1.x, v1.y, v1.z );
	
					}
	
					return attribute;
	
				};
	
			}(),
	
			determinant: function () {
	
				var te = this.elements;
	
				var n11 = te[ 0 ], n12 = te[ 4 ], n13 = te[ 8 ], n14 = te[ 12 ];
				var n21 = te[ 1 ], n22 = te[ 5 ], n23 = te[ 9 ], n24 = te[ 13 ];
				var n31 = te[ 2 ], n32 = te[ 6 ], n33 = te[ 10 ], n34 = te[ 14 ];
				var n41 = te[ 3 ], n42 = te[ 7 ], n43 = te[ 11 ], n44 = te[ 15 ];
	
				//TODO: make this more efficient
				//( based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm )
	
				return (
					n41 * (
						+ n14 * n23 * n32
						 - n13 * n24 * n32
						 - n14 * n22 * n33
						 + n12 * n24 * n33
						 + n13 * n22 * n34
						 - n12 * n23 * n34
					) +
					n42 * (
						+ n11 * n23 * n34
						 - n11 * n24 * n33
						 + n14 * n21 * n33
						 - n13 * n21 * n34
						 + n13 * n24 * n31
						 - n14 * n23 * n31
					) +
					n43 * (
						+ n11 * n24 * n32
						 - n11 * n22 * n34
						 - n14 * n21 * n32
						 + n12 * n21 * n34
						 + n14 * n22 * n31
						 - n12 * n24 * n31
					) +
					n44 * (
						- n13 * n22 * n31
						 - n11 * n23 * n32
						 + n11 * n22 * n33
						 + n13 * n21 * n32
						 - n12 * n21 * n33
						 + n12 * n23 * n31
					)
	
				);
	
			},
	
			transpose: function () {
	
				var te = this.elements;
				var tmp;
	
				tmp = te[ 1 ]; te[ 1 ] = te[ 4 ]; te[ 4 ] = tmp;
				tmp = te[ 2 ]; te[ 2 ] = te[ 8 ]; te[ 8 ] = tmp;
				tmp = te[ 6 ]; te[ 6 ] = te[ 9 ]; te[ 9 ] = tmp;
	
				tmp = te[ 3 ]; te[ 3 ] = te[ 12 ]; te[ 12 ] = tmp;
				tmp = te[ 7 ]; te[ 7 ] = te[ 13 ]; te[ 13 ] = tmp;
				tmp = te[ 11 ]; te[ 11 ] = te[ 14 ]; te[ 14 ] = tmp;
	
				return this;
	
			},
	
			setPosition: function ( v ) {
	
				var te = this.elements;
	
				te[ 12 ] = v.x;
				te[ 13 ] = v.y;
				te[ 14 ] = v.z;
	
				return this;
	
			},
	
			getInverse: function ( m, throwOnDegenerate ) {
	
				// based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm
				var te = this.elements,
					me = m.elements,
	
					n11 = me[ 0 ], n21 = me[ 1 ], n31 = me[ 2 ], n41 = me[ 3 ],
					n12 = me[ 4 ], n22 = me[ 5 ], n32 = me[ 6 ], n42 = me[ 7 ],
					n13 = me[ 8 ], n23 = me[ 9 ], n33 = me[ 10 ], n43 = me[ 11 ],
					n14 = me[ 12 ], n24 = me[ 13 ], n34 = me[ 14 ], n44 = me[ 15 ],
	
					t11 = n23 * n34 * n42 - n24 * n33 * n42 + n24 * n32 * n43 - n22 * n34 * n43 - n23 * n32 * n44 + n22 * n33 * n44,
					t12 = n14 * n33 * n42 - n13 * n34 * n42 - n14 * n32 * n43 + n12 * n34 * n43 + n13 * n32 * n44 - n12 * n33 * n44,
					t13 = n13 * n24 * n42 - n14 * n23 * n42 + n14 * n22 * n43 - n12 * n24 * n43 - n13 * n22 * n44 + n12 * n23 * n44,
					t14 = n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34;
	
				var det = n11 * t11 + n21 * t12 + n31 * t13 + n41 * t14;
	
				if ( det === 0 ) {
	
					var msg = "THREE.Matrix4: .getInverse() can't invert matrix, determinant is 0";
	
					if ( throwOnDegenerate === true ) {
	
						throw new Error( msg );
	
					} else {
	
						console.warn( msg );
	
					}
	
					return this.identity();
	
				}
	
				var detInv = 1 / det;
	
				te[ 0 ] = t11 * detInv;
				te[ 1 ] = ( n24 * n33 * n41 - n23 * n34 * n41 - n24 * n31 * n43 + n21 * n34 * n43 + n23 * n31 * n44 - n21 * n33 * n44 ) * detInv;
				te[ 2 ] = ( n22 * n34 * n41 - n24 * n32 * n41 + n24 * n31 * n42 - n21 * n34 * n42 - n22 * n31 * n44 + n21 * n32 * n44 ) * detInv;
				te[ 3 ] = ( n23 * n32 * n41 - n22 * n33 * n41 - n23 * n31 * n42 + n21 * n33 * n42 + n22 * n31 * n43 - n21 * n32 * n43 ) * detInv;
	
				te[ 4 ] = t12 * detInv;
				te[ 5 ] = ( n13 * n34 * n41 - n14 * n33 * n41 + n14 * n31 * n43 - n11 * n34 * n43 - n13 * n31 * n44 + n11 * n33 * n44 ) * detInv;
				te[ 6 ] = ( n14 * n32 * n41 - n12 * n34 * n41 - n14 * n31 * n42 + n11 * n34 * n42 + n12 * n31 * n44 - n11 * n32 * n44 ) * detInv;
				te[ 7 ] = ( n12 * n33 * n41 - n13 * n32 * n41 + n13 * n31 * n42 - n11 * n33 * n42 - n12 * n31 * n43 + n11 * n32 * n43 ) * detInv;
	
				te[ 8 ] = t13 * detInv;
				te[ 9 ] = ( n14 * n23 * n41 - n13 * n24 * n41 - n14 * n21 * n43 + n11 * n24 * n43 + n13 * n21 * n44 - n11 * n23 * n44 ) * detInv;
				te[ 10 ] = ( n12 * n24 * n41 - n14 * n22 * n41 + n14 * n21 * n42 - n11 * n24 * n42 - n12 * n21 * n44 + n11 * n22 * n44 ) * detInv;
				te[ 11 ] = ( n13 * n22 * n41 - n12 * n23 * n41 - n13 * n21 * n42 + n11 * n23 * n42 + n12 * n21 * n43 - n11 * n22 * n43 ) * detInv;
	
				te[ 12 ] = t14 * detInv;
				te[ 13 ] = ( n13 * n24 * n31 - n14 * n23 * n31 + n14 * n21 * n33 - n11 * n24 * n33 - n13 * n21 * n34 + n11 * n23 * n34 ) * detInv;
				te[ 14 ] = ( n14 * n22 * n31 - n12 * n24 * n31 - n14 * n21 * n32 + n11 * n24 * n32 + n12 * n21 * n34 - n11 * n22 * n34 ) * detInv;
				te[ 15 ] = ( n12 * n23 * n31 - n13 * n22 * n31 + n13 * n21 * n32 - n11 * n23 * n32 - n12 * n21 * n33 + n11 * n22 * n33 ) * detInv;
	
				return this;
	
			},
	
			scale: function ( v ) {
	
				var te = this.elements;
				var x = v.x, y = v.y, z = v.z;
	
				te[ 0 ] *= x; te[ 4 ] *= y; te[ 8 ] *= z;
				te[ 1 ] *= x; te[ 5 ] *= y; te[ 9 ] *= z;
				te[ 2 ] *= x; te[ 6 ] *= y; te[ 10 ] *= z;
				te[ 3 ] *= x; te[ 7 ] *= y; te[ 11 ] *= z;
	
				return this;
	
			},
	
			getMaxScaleOnAxis: function () {
	
				var te = this.elements;
	
				var scaleXSq = te[ 0 ] * te[ 0 ] + te[ 1 ] * te[ 1 ] + te[ 2 ] * te[ 2 ];
				var scaleYSq = te[ 4 ] * te[ 4 ] + te[ 5 ] * te[ 5 ] + te[ 6 ] * te[ 6 ];
				var scaleZSq = te[ 8 ] * te[ 8 ] + te[ 9 ] * te[ 9 ] + te[ 10 ] * te[ 10 ];
	
				return Math.sqrt( Math.max( scaleXSq, scaleYSq, scaleZSq ) );
	
			},
	
			makeTranslation: function ( x, y, z ) {
	
				this.set(
	
					1, 0, 0, x,
					0, 1, 0, y,
					0, 0, 1, z,
					0, 0, 0, 1
	
				);
	
				return this;
	
			},
	
			makeRotationX: function ( theta ) {
	
				var c = Math.cos( theta ), s = Math.sin( theta );
	
				this.set(
	
					1, 0, 0, 0,
					0, c, - s, 0,
					0, s, c, 0,
					0, 0, 0, 1
	
				);
	
				return this;
	
			},
	
			makeRotationY: function ( theta ) {
	
				var c = Math.cos( theta ), s = Math.sin( theta );
	
				this.set(
	
					 c, 0, s, 0,
					 0, 1, 0, 0,
					- s, 0, c, 0,
					 0, 0, 0, 1
	
				);
	
				return this;
	
			},
	
			makeRotationZ: function ( theta ) {
	
				var c = Math.cos( theta ), s = Math.sin( theta );
	
				this.set(
	
					c, - s, 0, 0,
					s, c, 0, 0,
					0, 0, 1, 0,
					0, 0, 0, 1
	
				);
	
				return this;
	
			},
	
			makeRotationAxis: function ( axis, angle ) {
	
				// Based on http://www.gamedev.net/reference/articles/article1199.asp
	
				var c = Math.cos( angle );
				var s = Math.sin( angle );
				var t = 1 - c;
				var x = axis.x, y = axis.y, z = axis.z;
				var tx = t * x, ty = t * y;
	
				this.set(
	
					tx * x + c, tx * y - s * z, tx * z + s * y, 0,
					tx * y + s * z, ty * y + c, ty * z - s * x, 0,
					tx * z - s * y, ty * z + s * x, t * z * z + c, 0,
					0, 0, 0, 1
	
				);
	
				 return this;
	
			},
	
			makeScale: function ( x, y, z ) {
	
				this.set(
	
					x, 0, 0, 0,
					0, y, 0, 0,
					0, 0, z, 0,
					0, 0, 0, 1
	
				);
	
				return this;
	
			},
	
			makeShear: function ( x, y, z ) {
	
				this.set(
	
					1, y, z, 0,
					x, 1, z, 0,
					x, y, 1, 0,
					0, 0, 0, 1
	
				);
	
				return this;
	
			},
	
			compose: function ( position, quaternion, scale ) {
	
				this.makeRotationFromQuaternion( quaternion );
				this.scale( scale );
				this.setPosition( position );
	
				return this;
	
			},
	
			decompose: function () {
	
				var vector = new Vector3();
				var matrix = new Matrix4();
	
				return function decompose( position, quaternion, scale ) {
	
					var te = this.elements;
	
					var sx = vector.set( te[ 0 ], te[ 1 ], te[ 2 ] ).length();
					var sy = vector.set( te[ 4 ], te[ 5 ], te[ 6 ] ).length();
					var sz = vector.set( te[ 8 ], te[ 9 ], te[ 10 ] ).length();
	
					// if determine is negative, we need to invert one scale
					var det = this.determinant();
					if ( det < 0 ) sx = - sx;
	
					position.x = te[ 12 ];
					position.y = te[ 13 ];
					position.z = te[ 14 ];
	
					// scale the rotation part
					matrix.copy( this );
	
					var invSX = 1 / sx;
					var invSY = 1 / sy;
					var invSZ = 1 / sz;
	
					matrix.elements[ 0 ] *= invSX;
					matrix.elements[ 1 ] *= invSX;
					matrix.elements[ 2 ] *= invSX;
	
					matrix.elements[ 4 ] *= invSY;
					matrix.elements[ 5 ] *= invSY;
					matrix.elements[ 6 ] *= invSY;
	
					matrix.elements[ 8 ] *= invSZ;
					matrix.elements[ 9 ] *= invSZ;
					matrix.elements[ 10 ] *= invSZ;
	
					quaternion.setFromRotationMatrix( matrix );
	
					scale.x = sx;
					scale.y = sy;
					scale.z = sz;
	
					return this;
	
				};
	
			}(),
	
			makePerspective: function ( left, right, top, bottom, near, far ) {
	
				if ( far === undefined ) {
	
					console.warn( 'THREE.Matrix4: .makePerspective() has been redefined and has a new signature. Please check the docs.' );
	
				}
	
				var te = this.elements;
				var x = 2 * near / ( right - left );
				var y = 2 * near / ( top - bottom );
	
				var a = ( right + left ) / ( right - left );
				var b = ( top + bottom ) / ( top - bottom );
				var c = - ( far + near ) / ( far - near );
				var d = - 2 * far * near / ( far - near );
	
				te[ 0 ] = x;	te[ 4 ] = 0;	te[ 8 ] = a;	te[ 12 ] = 0;
				te[ 1 ] = 0;	te[ 5 ] = y;	te[ 9 ] = b;	te[ 13 ] = 0;
				te[ 2 ] = 0;	te[ 6 ] = 0;	te[ 10 ] = c;	te[ 14 ] = d;
				te[ 3 ] = 0;	te[ 7 ] = 0;	te[ 11 ] = - 1;	te[ 15 ] = 0;
	
				return this;
	
			},
	
			makeOrthographic: function ( left, right, top, bottom, near, far ) {
	
				var te = this.elements;
				var w = 1.0 / ( right - left );
				var h = 1.0 / ( top - bottom );
				var p = 1.0 / ( far - near );
	
				var x = ( right + left ) * w;
				var y = ( top + bottom ) * h;
				var z = ( far + near ) * p;
	
				te[ 0 ] = 2 * w;	te[ 4 ] = 0;	te[ 8 ] = 0;	te[ 12 ] = - x;
				te[ 1 ] = 0;	te[ 5 ] = 2 * h;	te[ 9 ] = 0;	te[ 13 ] = - y;
				te[ 2 ] = 0;	te[ 6 ] = 0;	te[ 10 ] = - 2 * p;	te[ 14 ] = - z;
				te[ 3 ] = 0;	te[ 7 ] = 0;	te[ 11 ] = 0;	te[ 15 ] = 1;
	
				return this;
	
			},
	
			equals: function ( matrix ) {
	
				var te = this.elements;
				var me = matrix.elements;
	
				for ( var i = 0; i < 16; i ++ ) {
	
					if ( te[ i ] !== me[ i ] ) return false;
	
				}
	
				return true;
	
			},
	
			fromArray: function ( array, offset ) {
	
				if ( offset === undefined ) offset = 0;
	
				for ( var i = 0; i < 16; i ++ ) {
	
					this.elements[ i ] = array[ i + offset ];
	
				}
	
				return this;
	
			},
	
			toArray: function ( array, offset ) {
	
				if ( array === undefined ) array = [];
				if ( offset === undefined ) offset = 0;
	
				var te = this.elements;
	
				array[ offset ] = te[ 0 ];
				array[ offset + 1 ] = te[ 1 ];
				array[ offset + 2 ] = te[ 2 ];
				array[ offset + 3 ] = te[ 3 ];
	
				array[ offset + 4 ] = te[ 4 ];
				array[ offset + 5 ] = te[ 5 ];
				array[ offset + 6 ] = te[ 6 ];
				array[ offset + 7 ] = te[ 7 ];
	
				array[ offset + 8 ] = te[ 8 ];
				array[ offset + 9 ] = te[ 9 ];
				array[ offset + 10 ] = te[ 10 ];
				array[ offset + 11 ] = te[ 11 ];
	
				array[ offset + 12 ] = te[ 12 ];
				array[ offset + 13 ] = te[ 13 ];
				array[ offset + 14 ] = te[ 14 ];
				array[ offset + 15 ] = te[ 15 ];
	
				return array;
	
			}
	
		} );
	
		/**
		 * @author mikael emtinger / http://gomo.se/
		 * @author alteredq / http://alteredqualia.com/
		 * @author WestLangley / http://github.com/WestLangley
		 * @author bhouston / http://clara.io
		 */
	
		function Quaternion( x, y, z, w ) {
	
			this._x = x || 0;
			this._y = y || 0;
			this._z = z || 0;
			this._w = ( w !== undefined ) ? w : 1;
	
		}
	
		Object.assign( Quaternion, {
	
			slerp: function ( qa, qb, qm, t ) {
	
				return qm.copy( qa ).slerp( qb, t );
	
			},
	
			slerpFlat: function ( dst, dstOffset, src0, srcOffset0, src1, srcOffset1, t ) {
	
				// fuzz-free, array-based Quaternion SLERP operation
	
				var x0 = src0[ srcOffset0 + 0 ],
					y0 = src0[ srcOffset0 + 1 ],
					z0 = src0[ srcOffset0 + 2 ],
					w0 = src0[ srcOffset0 + 3 ],
	
					x1 = src1[ srcOffset1 + 0 ],
					y1 = src1[ srcOffset1 + 1 ],
					z1 = src1[ srcOffset1 + 2 ],
					w1 = src1[ srcOffset1 + 3 ];
	
				if ( w0 !== w1 || x0 !== x1 || y0 !== y1 || z0 !== z1 ) {
	
					var s = 1 - t,
	
						cos = x0 * x1 + y0 * y1 + z0 * z1 + w0 * w1,
	
						dir = ( cos >= 0 ? 1 : - 1 ),
						sqrSin = 1 - cos * cos;
	
					// Skip the Slerp for tiny steps to avoid numeric problems:
					if ( sqrSin > Number.EPSILON ) {
	
						var sin = Math.sqrt( sqrSin ),
							len = Math.atan2( sin, cos * dir );
	
						s = Math.sin( s * len ) / sin;
						t = Math.sin( t * len ) / sin;
	
					}
	
					var tDir = t * dir;
	
					x0 = x0 * s + x1 * tDir;
					y0 = y0 * s + y1 * tDir;
					z0 = z0 * s + z1 * tDir;
					w0 = w0 * s + w1 * tDir;
	
					// Normalize in case we just did a lerp:
					if ( s === 1 - t ) {
	
						var f = 1 / Math.sqrt( x0 * x0 + y0 * y0 + z0 * z0 + w0 * w0 );
	
						x0 *= f;
						y0 *= f;
						z0 *= f;
						w0 *= f;
	
					}
	
				}
	
				dst[ dstOffset ] = x0;
				dst[ dstOffset + 1 ] = y0;
				dst[ dstOffset + 2 ] = z0;
				dst[ dstOffset + 3 ] = w0;
	
			}
	
		} );
	
		Object.defineProperties( Quaternion.prototype, {
	
			x: {
	
				get: function () {
	
					return this._x;
	
				},
	
				set: function ( value ) {
	
					this._x = value;
					this.onChangeCallback();
	
				}
	
			},
	
			y: {
	
				get: function () {
	
					return this._y;
	
				},
	
				set: function ( value ) {
	
					this._y = value;
					this.onChangeCallback();
	
				}
	
			},
	
			z: {
	
				get: function () {
	
					return this._z;
	
				},
	
				set: function ( value ) {
	
					this._z = value;
					this.onChangeCallback();
	
				}
	
			},
	
			w: {
	
				get: function () {
	
					return this._w;
	
				},
	
				set: function ( value ) {
	
					this._w = value;
					this.onChangeCallback();
	
				}
	
			}
	
		} );
	
		Object.assign( Quaternion.prototype, {
	
			set: function ( x, y, z, w ) {
	
				this._x = x;
				this._y = y;
				this._z = z;
				this._w = w;
	
				this.onChangeCallback();
	
				return this;
	
			},
	
			clone: function () {
	
				return new this.constructor( this._x, this._y, this._z, this._w );
	
			},
	
			copy: function ( quaternion ) {
	
				this._x = quaternion.x;
				this._y = quaternion.y;
				this._z = quaternion.z;
				this._w = quaternion.w;
	
				this.onChangeCallback();
	
				return this;
	
			},
	
			setFromEuler: function ( euler, update ) {
	
				if ( ! ( euler && euler.isEuler ) ) {
	
					throw new Error( 'THREE.Quaternion: .setFromEuler() now expects an Euler rotation rather than a Vector3 and order.' );
	
				}
	
				var x = euler._x, y = euler._y, z = euler._z, order = euler.order;
	
				// http://www.mathworks.com/matlabcentral/fileexchange/
				// 	20696-function-to-convert-between-dcm-euler-angles-quaternions-and-euler-vectors/
				//	content/SpinCalc.m
	
				var cos = Math.cos;
				var sin = Math.sin;
	
				var c1 = cos( x / 2 );
				var c2 = cos( y / 2 );
				var c3 = cos( z / 2 );
	
				var s1 = sin( x / 2 );
				var s2 = sin( y / 2 );
				var s3 = sin( z / 2 );
	
				if ( order === 'XYZ' ) {
	
					this._x = s1 * c2 * c3 + c1 * s2 * s3;
					this._y = c1 * s2 * c3 - s1 * c2 * s3;
					this._z = c1 * c2 * s3 + s1 * s2 * c3;
					this._w = c1 * c2 * c3 - s1 * s2 * s3;
	
				} else if ( order === 'YXZ' ) {
	
					this._x = s1 * c2 * c3 + c1 * s2 * s3;
					this._y = c1 * s2 * c3 - s1 * c2 * s3;
					this._z = c1 * c2 * s3 - s1 * s2 * c3;
					this._w = c1 * c2 * c3 + s1 * s2 * s3;
	
				} else if ( order === 'ZXY' ) {
	
					this._x = s1 * c2 * c3 - c1 * s2 * s3;
					this._y = c1 * s2 * c3 + s1 * c2 * s3;
					this._z = c1 * c2 * s3 + s1 * s2 * c3;
					this._w = c1 * c2 * c3 - s1 * s2 * s3;
	
				} else if ( order === 'ZYX' ) {
	
					this._x = s1 * c2 * c3 - c1 * s2 * s3;
					this._y = c1 * s2 * c3 + s1 * c2 * s3;
					this._z = c1 * c2 * s3 - s1 * s2 * c3;
					this._w = c1 * c2 * c3 + s1 * s2 * s3;
	
				} else if ( order === 'YZX' ) {
	
					this._x = s1 * c2 * c3 + c1 * s2 * s3;
					this._y = c1 * s2 * c3 + s1 * c2 * s3;
					this._z = c1 * c2 * s3 - s1 * s2 * c3;
					this._w = c1 * c2 * c3 - s1 * s2 * s3;
	
				} else if ( order === 'XZY' ) {
	
					this._x = s1 * c2 * c3 - c1 * s2 * s3;
					this._y = c1 * s2 * c3 - s1 * c2 * s3;
					this._z = c1 * c2 * s3 + s1 * s2 * c3;
					this._w = c1 * c2 * c3 + s1 * s2 * s3;
	
				}
	
				if ( update !== false ) this.onChangeCallback();
	
				return this;
	
			},
	
			setFromAxisAngle: function ( axis, angle ) {
	
				// http://www.euclideanspace.com/maths/geometry/rotations/conversions/angleToQuaternion/index.htm
	
				// assumes axis is normalized
	
				var halfAngle = angle / 2, s = Math.sin( halfAngle );
	
				this._x = axis.x * s;
				this._y = axis.y * s;
				this._z = axis.z * s;
				this._w = Math.cos( halfAngle );
	
				this.onChangeCallback();
	
				return this;
	
			},
	
			setFromRotationMatrix: function ( m ) {
	
				// http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToQuaternion/index.htm
	
				// assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
	
				var te = m.elements,
	
					m11 = te[ 0 ], m12 = te[ 4 ], m13 = te[ 8 ],
					m21 = te[ 1 ], m22 = te[ 5 ], m23 = te[ 9 ],
					m31 = te[ 2 ], m32 = te[ 6 ], m33 = te[ 10 ],
	
					trace = m11 + m22 + m33,
					s;
	
				if ( trace > 0 ) {
	
					s = 0.5 / Math.sqrt( trace + 1.0 );
	
					this._w = 0.25 / s;
					this._x = ( m32 - m23 ) * s;
					this._y = ( m13 - m31 ) * s;
					this._z = ( m21 - m12 ) * s;
	
				} else if ( m11 > m22 && m11 > m33 ) {
	
					s = 2.0 * Math.sqrt( 1.0 + m11 - m22 - m33 );
	
					this._w = ( m32 - m23 ) / s;
					this._x = 0.25 * s;
					this._y = ( m12 + m21 ) / s;
					this._z = ( m13 + m31 ) / s;
	
				} else if ( m22 > m33 ) {
	
					s = 2.0 * Math.sqrt( 1.0 + m22 - m11 - m33 );
	
					this._w = ( m13 - m31 ) / s;
					this._x = ( m12 + m21 ) / s;
					this._y = 0.25 * s;
					this._z = ( m23 + m32 ) / s;
	
				} else {
	
					s = 2.0 * Math.sqrt( 1.0 + m33 - m11 - m22 );
	
					this._w = ( m21 - m12 ) / s;
					this._x = ( m13 + m31 ) / s;
					this._y = ( m23 + m32 ) / s;
					this._z = 0.25 * s;
	
				}
	
				this.onChangeCallback();
	
				return this;
	
			},
	
			setFromUnitVectors: function () {
	
				// assumes direction vectors vFrom and vTo are normalized
	
				var v1 = new Vector3();
				var r;
	
				var EPS = 0.000001;
	
				return function setFromUnitVectors( vFrom, vTo ) {
	
					if ( v1 === undefined ) v1 = new Vector3();
	
					r = vFrom.dot( vTo ) + 1;
	
					if ( r < EPS ) {
	
						r = 0;
	
						if ( Math.abs( vFrom.x ) > Math.abs( vFrom.z ) ) {
	
							v1.set( - vFrom.y, vFrom.x, 0 );
	
						} else {
	
							v1.set( 0, - vFrom.z, vFrom.y );
	
						}
	
					} else {
	
						v1.crossVectors( vFrom, vTo );
	
					}
	
					this._x = v1.x;
					this._y = v1.y;
					this._z = v1.z;
					this._w = r;
	
					return this.normalize();
	
				};
	
			}(),
	
			inverse: function () {
	
				return this.conjugate().normalize();
	
			},
	
			conjugate: function () {
	
				this._x *= - 1;
				this._y *= - 1;
				this._z *= - 1;
	
				this.onChangeCallback();
	
				return this;
	
			},
	
			dot: function ( v ) {
	
				return this._x * v._x + this._y * v._y + this._z * v._z + this._w * v._w;
	
			},
	
			lengthSq: function () {
	
				return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
	
			},
	
			length: function () {
	
				return Math.sqrt( this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w );
	
			},
	
			normalize: function () {
	
				var l = this.length();
	
				if ( l === 0 ) {
	
					this._x = 0;
					this._y = 0;
					this._z = 0;
					this._w = 1;
	
				} else {
	
					l = 1 / l;
	
					this._x = this._x * l;
					this._y = this._y * l;
					this._z = this._z * l;
					this._w = this._w * l;
	
				}
	
				this.onChangeCallback();
	
				return this;
	
			},
	
			multiply: function ( q, p ) {
	
				if ( p !== undefined ) {
	
					console.warn( 'THREE.Quaternion: .multiply() now only accepts one argument. Use .multiplyQuaternions( a, b ) instead.' );
					return this.multiplyQuaternions( q, p );
	
				}
	
				return this.multiplyQuaternions( this, q );
	
			},
	
			premultiply: function ( q ) {
	
				return this.multiplyQuaternions( q, this );
	
			},
	
			multiplyQuaternions: function ( a, b ) {
	
				// from http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/code/index.htm
	
				var qax = a._x, qay = a._y, qaz = a._z, qaw = a._w;
				var qbx = b._x, qby = b._y, qbz = b._z, qbw = b._w;
	
				this._x = qax * qbw + qaw * qbx + qay * qbz - qaz * qby;
				this._y = qay * qbw + qaw * qby + qaz * qbx - qax * qbz;
				this._z = qaz * qbw + qaw * qbz + qax * qby - qay * qbx;
				this._w = qaw * qbw - qax * qbx - qay * qby - qaz * qbz;
	
				this.onChangeCallback();
	
				return this;
	
			},
	
			slerp: function ( qb, t ) {
	
				if ( t === 0 ) return this;
				if ( t === 1 ) return this.copy( qb );
	
				var x = this._x, y = this._y, z = this._z, w = this._w;
	
				// http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/slerp/
	
				var cosHalfTheta = w * qb._w + x * qb._x + y * qb._y + z * qb._z;
	
				if ( cosHalfTheta < 0 ) {
	
					this._w = - qb._w;
					this._x = - qb._x;
					this._y = - qb._y;
					this._z = - qb._z;
	
					cosHalfTheta = - cosHalfTheta;
	
				} else {
	
					this.copy( qb );
	
				}
	
				if ( cosHalfTheta >= 1.0 ) {
	
					this._w = w;
					this._x = x;
					this._y = y;
					this._z = z;
	
					return this;
	
				}
	
				var sinHalfTheta = Math.sqrt( 1.0 - cosHalfTheta * cosHalfTheta );
	
				if ( Math.abs( sinHalfTheta ) < 0.001 ) {
	
					this._w = 0.5 * ( w + this._w );
					this._x = 0.5 * ( x + this._x );
					this._y = 0.5 * ( y + this._y );
					this._z = 0.5 * ( z + this._z );
	
					return this;
	
				}
	
				var halfTheta = Math.atan2( sinHalfTheta, cosHalfTheta );
				var ratioA = Math.sin( ( 1 - t ) * halfTheta ) / sinHalfTheta,
					ratioB = Math.sin( t * halfTheta ) / sinHalfTheta;
	
				this._w = ( w * ratioA + this._w * ratioB );
				this._x = ( x * ratioA + this._x * ratioB );
				this._y = ( y * ratioA + this._y * ratioB );
				this._z = ( z * ratioA + this._z * ratioB );
	
				this.onChangeCallback();
	
				return this;
	
			},
	
			equals: function ( quaternion ) {
	
				return ( quaternion._x === this._x ) && ( quaternion._y === this._y ) && ( quaternion._z === this._z ) && ( quaternion._w === this._w );
	
			},
	
			fromArray: function ( array, offset ) {
	
				if ( offset === undefined ) offset = 0;
	
				this._x = array[ offset ];
				this._y = array[ offset + 1 ];
				this._z = array[ offset + 2 ];
				this._w = array[ offset + 3 ];
	
				this.onChangeCallback();
	
				return this;
	
			},
	
			toArray: function ( array, offset ) {
	
				if ( array === undefined ) array = [];
				if ( offset === undefined ) offset = 0;
	
				array[ offset ] = this._x;
				array[ offset + 1 ] = this._y;
				array[ offset + 2 ] = this._z;
				array[ offset + 3 ] = this._w;
	
				return array;
	
			},
	
			onChange: function ( callback ) {
	
				this.onChangeCallback = callback;
	
				return this;
	
			},
	
			onChangeCallback: function () {}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author kile / http://kile.stravaganza.org/
		 * @author philogb / http://blog.thejit.org/
		 * @author mikael emtinger / http://gomo.se/
		 * @author egraether / http://egraether.com/
		 * @author WestLangley / http://github.com/WestLangley
		 */
	
		function Vector3( x, y, z ) {
	
			this.x = x || 0;
			this.y = y || 0;
			this.z = z || 0;
	
		}
	
		Object.assign( Vector3.prototype, {
	
			isVector3: true,
	
			set: function ( x, y, z ) {
	
				this.x = x;
				this.y = y;
				this.z = z;
	
				return this;
	
			},
	
			setScalar: function ( scalar ) {
	
				this.x = scalar;
				this.y = scalar;
				this.z = scalar;
	
				return this;
	
			},
	
			setX: function ( x ) {
	
				this.x = x;
	
				return this;
	
			},
	
			setY: function ( y ) {
	
				this.y = y;
	
				return this;
	
			},
	
			setZ: function ( z ) {
	
				this.z = z;
	
				return this;
	
			},
	
			setComponent: function ( index, value ) {
	
				switch ( index ) {
	
					case 0: this.x = value; break;
					case 1: this.y = value; break;
					case 2: this.z = value; break;
					default: throw new Error( 'index is out of range: ' + index );
	
				}
	
				return this;
	
			},
	
			getComponent: function ( index ) {
	
				switch ( index ) {
	
					case 0: return this.x;
					case 1: return this.y;
					case 2: return this.z;
					default: throw new Error( 'index is out of range: ' + index );
	
				}
	
			},
	
			clone: function () {
	
				return new this.constructor( this.x, this.y, this.z );
	
			},
	
			copy: function ( v ) {
	
				this.x = v.x;
				this.y = v.y;
				this.z = v.z;
	
				return this;
	
			},
	
			add: function ( v, w ) {
	
				if ( w !== undefined ) {
	
					console.warn( 'THREE.Vector3: .add() now only accepts one argument. Use .addVectors( a, b ) instead.' );
					return this.addVectors( v, w );
	
				}
	
				this.x += v.x;
				this.y += v.y;
				this.z += v.z;
	
				return this;
	
			},
	
			addScalar: function ( s ) {
	
				this.x += s;
				this.y += s;
				this.z += s;
	
				return this;
	
			},
	
			addVectors: function ( a, b ) {
	
				this.x = a.x + b.x;
				this.y = a.y + b.y;
				this.z = a.z + b.z;
	
				return this;
	
			},
	
			addScaledVector: function ( v, s ) {
	
				this.x += v.x * s;
				this.y += v.y * s;
				this.z += v.z * s;
	
				return this;
	
			},
	
			sub: function ( v, w ) {
	
				if ( w !== undefined ) {
	
					console.warn( 'THREE.Vector3: .sub() now only accepts one argument. Use .subVectors( a, b ) instead.' );
					return this.subVectors( v, w );
	
				}
	
				this.x -= v.x;
				this.y -= v.y;
				this.z -= v.z;
	
				return this;
	
			},
	
			subScalar: function ( s ) {
	
				this.x -= s;
				this.y -= s;
				this.z -= s;
	
				return this;
	
			},
	
			subVectors: function ( a, b ) {
	
				this.x = a.x - b.x;
				this.y = a.y - b.y;
				this.z = a.z - b.z;
	
				return this;
	
			},
	
			multiply: function ( v, w ) {
	
				if ( w !== undefined ) {
	
					console.warn( 'THREE.Vector3: .multiply() now only accepts one argument. Use .multiplyVectors( a, b ) instead.' );
					return this.multiplyVectors( v, w );
	
				}
	
				this.x *= v.x;
				this.y *= v.y;
				this.z *= v.z;
	
				return this;
	
			},
	
			multiplyScalar: function ( scalar ) {
	
				this.x *= scalar;
				this.y *= scalar;
				this.z *= scalar;
	
				return this;
	
			},
	
			multiplyVectors: function ( a, b ) {
	
				this.x = a.x * b.x;
				this.y = a.y * b.y;
				this.z = a.z * b.z;
	
				return this;
	
			},
	
			applyEuler: function () {
	
				var quaternion = new Quaternion();
	
				return function applyEuler( euler ) {
	
					if ( ! ( euler && euler.isEuler ) ) {
	
						console.error( 'THREE.Vector3: .applyEuler() now expects an Euler rotation rather than a Vector3 and order.' );
	
					}
	
					return this.applyQuaternion( quaternion.setFromEuler( euler ) );
	
				};
	
			}(),
	
			applyAxisAngle: function () {
	
				var quaternion = new Quaternion();
	
				return function applyAxisAngle( axis, angle ) {
	
					return this.applyQuaternion( quaternion.setFromAxisAngle( axis, angle ) );
	
				};
	
			}(),
	
			applyMatrix3: function ( m ) {
	
				var x = this.x, y = this.y, z = this.z;
				var e = m.elements;
	
				this.x = e[ 0 ] * x + e[ 3 ] * y + e[ 6 ] * z;
				this.y = e[ 1 ] * x + e[ 4 ] * y + e[ 7 ] * z;
				this.z = e[ 2 ] * x + e[ 5 ] * y + e[ 8 ] * z;
	
				return this;
	
			},
	
			applyMatrix4: function ( m ) {
	
				var x = this.x, y = this.y, z = this.z;
				var e = m.elements;
	
				var w = 1 / ( e[ 3 ] * x + e[ 7 ] * y + e[ 11 ] * z + e[ 15 ] );
	
				this.x = ( e[ 0 ] * x + e[ 4 ] * y + e[ 8 ] * z + e[ 12 ] ) * w;
				this.y = ( e[ 1 ] * x + e[ 5 ] * y + e[ 9 ] * z + e[ 13 ] ) * w;
				this.z = ( e[ 2 ] * x + e[ 6 ] * y + e[ 10 ] * z + e[ 14 ] ) * w;
	
				return this;
	
			},
	
			applyQuaternion: function ( q ) {
	
				var x = this.x, y = this.y, z = this.z;
				var qx = q.x, qy = q.y, qz = q.z, qw = q.w;
	
				// calculate quat * vector
	
				var ix = qw * x + qy * z - qz * y;
				var iy = qw * y + qz * x - qx * z;
				var iz = qw * z + qx * y - qy * x;
				var iw = - qx * x - qy * y - qz * z;
	
				// calculate result * inverse quat
	
				this.x = ix * qw + iw * - qx + iy * - qz - iz * - qy;
				this.y = iy * qw + iw * - qy + iz * - qx - ix * - qz;
				this.z = iz * qw + iw * - qz + ix * - qy - iy * - qx;
	
				return this;
	
			},
	
			project: function () {
	
				var matrix = new Matrix4();
	
				return function project( camera ) {
	
					matrix.multiplyMatrices( camera.projectionMatrix, matrix.getInverse( camera.matrixWorld ) );
					return this.applyMatrix4( matrix );
	
				};
	
			}(),
	
			unproject: function () {
	
				var matrix = new Matrix4();
	
				return function unproject( camera ) {
	
					matrix.multiplyMatrices( camera.matrixWorld, matrix.getInverse( camera.projectionMatrix ) );
					return this.applyMatrix4( matrix );
	
				};
	
			}(),
	
			transformDirection: function ( m ) {
	
				// input: THREE.Matrix4 affine matrix
				// vector interpreted as a direction
	
				var x = this.x, y = this.y, z = this.z;
				var e = m.elements;
	
				this.x = e[ 0 ] * x + e[ 4 ] * y + e[ 8 ] * z;
				this.y = e[ 1 ] * x + e[ 5 ] * y + e[ 9 ] * z;
				this.z = e[ 2 ] * x + e[ 6 ] * y + e[ 10 ] * z;
	
				return this.normalize();
	
			},
	
			divide: function ( v ) {
	
				this.x /= v.x;
				this.y /= v.y;
				this.z /= v.z;
	
				return this;
	
			},
	
			divideScalar: function ( scalar ) {
	
				return this.multiplyScalar( 1 / scalar );
	
			},
	
			min: function ( v ) {
	
				this.x = Math.min( this.x, v.x );
				this.y = Math.min( this.y, v.y );
				this.z = Math.min( this.z, v.z );
	
				return this;
	
			},
	
			max: function ( v ) {
	
				this.x = Math.max( this.x, v.x );
				this.y = Math.max( this.y, v.y );
				this.z = Math.max( this.z, v.z );
	
				return this;
	
			},
	
			clamp: function ( min, max ) {
	
				// assumes min < max, componentwise
	
				this.x = Math.max( min.x, Math.min( max.x, this.x ) );
				this.y = Math.max( min.y, Math.min( max.y, this.y ) );
				this.z = Math.max( min.z, Math.min( max.z, this.z ) );
	
				return this;
	
			},
	
			clampScalar: function () {
	
				var min = new Vector3();
				var max = new Vector3();
	
				return function clampScalar( minVal, maxVal ) {
	
					min.set( minVal, minVal, minVal );
					max.set( maxVal, maxVal, maxVal );
	
					return this.clamp( min, max );
	
				};
	
			}(),
	
			clampLength: function ( min, max ) {
	
				var length = this.length();
	
				return this.divideScalar( length || 1 ).multiplyScalar( Math.max( min, Math.min( max, length ) ) );
	
			},
	
			floor: function () {
	
				this.x = Math.floor( this.x );
				this.y = Math.floor( this.y );
				this.z = Math.floor( this.z );
	
				return this;
	
			},
	
			ceil: function () {
	
				this.x = Math.ceil( this.x );
				this.y = Math.ceil( this.y );
				this.z = Math.ceil( this.z );
	
				return this;
	
			},
	
			round: function () {
	
				this.x = Math.round( this.x );
				this.y = Math.round( this.y );
				this.z = Math.round( this.z );
	
				return this;
	
			},
	
			roundToZero: function () {
	
				this.x = ( this.x < 0 ) ? Math.ceil( this.x ) : Math.floor( this.x );
				this.y = ( this.y < 0 ) ? Math.ceil( this.y ) : Math.floor( this.y );
				this.z = ( this.z < 0 ) ? Math.ceil( this.z ) : Math.floor( this.z );
	
				return this;
	
			},
	
			negate: function () {
	
				this.x = - this.x;
				this.y = - this.y;
				this.z = - this.z;
	
				return this;
	
			},
	
			dot: function ( v ) {
	
				return this.x * v.x + this.y * v.y + this.z * v.z;
	
			},
	
			// TODO lengthSquared?
	
			lengthSq: function () {
	
				return this.x * this.x + this.y * this.y + this.z * this.z;
	
			},
	
			length: function () {
	
				return Math.sqrt( this.x * this.x + this.y * this.y + this.z * this.z );
	
			},
	
			manhattanLength: function () {
	
				return Math.abs( this.x ) + Math.abs( this.y ) + Math.abs( this.z );
	
			},
	
			normalize: function () {
	
				return this.divideScalar( this.length() || 1 );
	
			},
	
			setLength: function ( length ) {
	
				return this.normalize().multiplyScalar( length );
	
			},
	
			lerp: function ( v, alpha ) {
	
				this.x += ( v.x - this.x ) * alpha;
				this.y += ( v.y - this.y ) * alpha;
				this.z += ( v.z - this.z ) * alpha;
	
				return this;
	
			},
	
			lerpVectors: function ( v1, v2, alpha ) {
	
				return this.subVectors( v2, v1 ).multiplyScalar( alpha ).add( v1 );
	
			},
	
			cross: function ( v, w ) {
	
				if ( w !== undefined ) {
	
					console.warn( 'THREE.Vector3: .cross() now only accepts one argument. Use .crossVectors( a, b ) instead.' );
					return this.crossVectors( v, w );
	
				}
	
				return this.crossVectors( this, v );
	
			},
	
			crossVectors: function ( a, b ) {
	
				var ax = a.x, ay = a.y, az = a.z;
				var bx = b.x, by = b.y, bz = b.z;
	
				this.x = ay * bz - az * by;
				this.y = az * bx - ax * bz;
				this.z = ax * by - ay * bx;
	
				return this;
	
			},
	
			projectOnVector: function ( vector ) {
	
				var scalar = vector.dot( this ) / vector.lengthSq();
	
				return this.copy( vector ).multiplyScalar( scalar );
	
			},
	
			projectOnPlane: function () {
	
				var v1 = new Vector3();
	
				return function projectOnPlane( planeNormal ) {
	
					v1.copy( this ).projectOnVector( planeNormal );
	
					return this.sub( v1 );
	
				};
	
			}(),
	
			reflect: function () {
	
				// reflect incident vector off plane orthogonal to normal
				// normal is assumed to have unit length
	
				var v1 = new Vector3();
	
				return function reflect( normal ) {
	
					return this.sub( v1.copy( normal ).multiplyScalar( 2 * this.dot( normal ) ) );
	
				};
	
			}(),
	
			angleTo: function ( v ) {
	
				var theta = this.dot( v ) / ( Math.sqrt( this.lengthSq() * v.lengthSq() ) );
	
				// clamp, to handle numerical problems
	
				return Math.acos( _Math.clamp( theta, - 1, 1 ) );
	
			},
	
			distanceTo: function ( v ) {
	
				return Math.sqrt( this.distanceToSquared( v ) );
	
			},
	
			distanceToSquared: function ( v ) {
	
				var dx = this.x - v.x, dy = this.y - v.y, dz = this.z - v.z;
	
				return dx * dx + dy * dy + dz * dz;
	
			},
	
			manhattanDistanceTo: function ( v ) {
	
				return Math.abs( this.x - v.x ) + Math.abs( this.y - v.y ) + Math.abs( this.z - v.z );
	
			},
	
			setFromSpherical: function ( s ) {
	
				var sinPhiRadius = Math.sin( s.phi ) * s.radius;
	
				this.x = sinPhiRadius * Math.sin( s.theta );
				this.y = Math.cos( s.phi ) * s.radius;
				this.z = sinPhiRadius * Math.cos( s.theta );
	
				return this;
	
			},
	
			setFromCylindrical: function ( c ) {
	
				this.x = c.radius * Math.sin( c.theta );
				this.y = c.y;
				this.z = c.radius * Math.cos( c.theta );
	
				return this;
	
			},
	
			setFromMatrixPosition: function ( m ) {
	
				var e = m.elements;
	
				this.x = e[ 12 ];
				this.y = e[ 13 ];
				this.z = e[ 14 ];
	
				return this;
	
			},
	
			setFromMatrixScale: function ( m ) {
	
				var sx = this.setFromMatrixColumn( m, 0 ).length();
				var sy = this.setFromMatrixColumn( m, 1 ).length();
				var sz = this.setFromMatrixColumn( m, 2 ).length();
	
				this.x = sx;
				this.y = sy;
				this.z = sz;
	
				return this;
	
			},
	
			setFromMatrixColumn: function ( m, index ) {
	
				return this.fromArray( m.elements, index * 4 );
	
			},
	
			equals: function ( v ) {
	
				return ( ( v.x === this.x ) && ( v.y === this.y ) && ( v.z === this.z ) );
	
			},
	
			fromArray: function ( array, offset ) {
	
				if ( offset === undefined ) offset = 0;
	
				this.x = array[ offset ];
				this.y = array[ offset + 1 ];
				this.z = array[ offset + 2 ];
	
				return this;
	
			},
	
			toArray: function ( array, offset ) {
	
				if ( array === undefined ) array = [];
				if ( offset === undefined ) offset = 0;
	
				array[ offset ] = this.x;
				array[ offset + 1 ] = this.y;
				array[ offset + 2 ] = this.z;
	
				return array;
	
			},
	
			fromBufferAttribute: function ( attribute, index, offset ) {
	
				if ( offset !== undefined ) {
	
					console.warn( 'THREE.Vector3: offset has been removed from .fromBufferAttribute().' );
	
				}
	
				this.x = attribute.getX( index );
				this.y = attribute.getY( index );
				this.z = attribute.getZ( index );
	
				return this;
	
			}
	
		} );
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 * @author WestLangley / http://github.com/WestLangley
		 * @author bhouston / http://clara.io
		 * @author tschw
		 */
	
		function Matrix3() {
	
			this.elements = [
	
				1, 0, 0,
				0, 1, 0,
				0, 0, 1
	
			];
	
			if ( arguments.length > 0 ) {
	
				console.error( 'THREE.Matrix3: the constructor no longer reads arguments. use .set() instead.' );
	
			}
	
		}
	
		Object.assign( Matrix3.prototype, {
	
			isMatrix3: true,
	
			set: function ( n11, n12, n13, n21, n22, n23, n31, n32, n33 ) {
	
				var te = this.elements;
	
				te[ 0 ] = n11; te[ 1 ] = n21; te[ 2 ] = n31;
				te[ 3 ] = n12; te[ 4 ] = n22; te[ 5 ] = n32;
				te[ 6 ] = n13; te[ 7 ] = n23; te[ 8 ] = n33;
	
				return this;
	
			},
	
			identity: function () {
	
				this.set(
	
					1, 0, 0,
					0, 1, 0,
					0, 0, 1
	
				);
	
				return this;
	
			},
	
			clone: function () {
	
				return new this.constructor().fromArray( this.elements );
	
			},
	
			copy: function ( m ) {
	
				var te = this.elements;
				var me = m.elements;
	
				te[ 0 ] = me[ 0 ]; te[ 1 ] = me[ 1 ]; te[ 2 ] = me[ 2 ];
				te[ 3 ] = me[ 3 ]; te[ 4 ] = me[ 4 ]; te[ 5 ] = me[ 5 ];
				te[ 6 ] = me[ 6 ]; te[ 7 ] = me[ 7 ]; te[ 8 ] = me[ 8 ];
	
				return this;
	
			},
	
			setFromMatrix4: function ( m ) {
	
				var me = m.elements;
	
				this.set(
	
					me[ 0 ], me[ 4 ], me[ 8 ],
					me[ 1 ], me[ 5 ], me[ 9 ],
					me[ 2 ], me[ 6 ], me[ 10 ]
	
				);
	
				return this;
	
			},
	
			applyToBufferAttribute: function () {
	
				var v1 = new Vector3();
	
				return function applyToBufferAttribute( attribute ) {
	
					for ( var i = 0, l = attribute.count; i < l; i ++ ) {
	
						v1.x = attribute.getX( i );
						v1.y = attribute.getY( i );
						v1.z = attribute.getZ( i );
	
						v1.applyMatrix3( this );
	
						attribute.setXYZ( i, v1.x, v1.y, v1.z );
	
					}
	
					return attribute;
	
				};
	
			}(),
	
			multiply: function ( m ) {
	
				return this.multiplyMatrices( this, m );
	
			},
	
			premultiply: function ( m ) {
	
				return this.multiplyMatrices( m, this );
	
			},
	
			multiplyMatrices: function ( a, b ) {
	
				var ae = a.elements;
				var be = b.elements;
				var te = this.elements;
	
				var a11 = ae[ 0 ], a12 = ae[ 3 ], a13 = ae[ 6 ];
				var a21 = ae[ 1 ], a22 = ae[ 4 ], a23 = ae[ 7 ];
				var a31 = ae[ 2 ], a32 = ae[ 5 ], a33 = ae[ 8 ];
	
				var b11 = be[ 0 ], b12 = be[ 3 ], b13 = be[ 6 ];
				var b21 = be[ 1 ], b22 = be[ 4 ], b23 = be[ 7 ];
				var b31 = be[ 2 ], b32 = be[ 5 ], b33 = be[ 8 ];
	
				te[ 0 ] = a11 * b11 + a12 * b21 + a13 * b31;
				te[ 3 ] = a11 * b12 + a12 * b22 + a13 * b32;
				te[ 6 ] = a11 * b13 + a12 * b23 + a13 * b33;
	
				te[ 1 ] = a21 * b11 + a22 * b21 + a23 * b31;
				te[ 4 ] = a21 * b12 + a22 * b22 + a23 * b32;
				te[ 7 ] = a21 * b13 + a22 * b23 + a23 * b33;
	
				te[ 2 ] = a31 * b11 + a32 * b21 + a33 * b31;
				te[ 5 ] = a31 * b12 + a32 * b22 + a33 * b32;
				te[ 8 ] = a31 * b13 + a32 * b23 + a33 * b33;
	
				return this;
	
			},
	
			multiplyScalar: function ( s ) {
	
				var te = this.elements;
	
				te[ 0 ] *= s; te[ 3 ] *= s; te[ 6 ] *= s;
				te[ 1 ] *= s; te[ 4 ] *= s; te[ 7 ] *= s;
				te[ 2 ] *= s; te[ 5 ] *= s; te[ 8 ] *= s;
	
				return this;
	
			},
	
			determinant: function () {
	
				var te = this.elements;
	
				var a = te[ 0 ], b = te[ 1 ], c = te[ 2 ],
					d = te[ 3 ], e = te[ 4 ], f = te[ 5 ],
					g = te[ 6 ], h = te[ 7 ], i = te[ 8 ];
	
				return a * e * i - a * f * h - b * d * i + b * f * g + c * d * h - c * e * g;
	
			},
	
			getInverse: function ( matrix, throwOnDegenerate ) {
	
				if ( matrix && matrix.isMatrix4 ) {
	
					console.error( "THREE.Matrix3: .getInverse() no longer takes a Matrix4 argument." );
	
				}
	
				var me = matrix.elements,
					te = this.elements,
	
					n11 = me[ 0 ], n21 = me[ 1 ], n31 = me[ 2 ],
					n12 = me[ 3 ], n22 = me[ 4 ], n32 = me[ 5 ],
					n13 = me[ 6 ], n23 = me[ 7 ], n33 = me[ 8 ],
	
					t11 = n33 * n22 - n32 * n23,
					t12 = n32 * n13 - n33 * n12,
					t13 = n23 * n12 - n22 * n13,
	
					det = n11 * t11 + n21 * t12 + n31 * t13;
	
				if ( det === 0 ) {
	
					var msg = "THREE.Matrix3: .getInverse() can't invert matrix, determinant is 0";
	
					if ( throwOnDegenerate === true ) {
	
						throw new Error( msg );
	
					} else {
	
						console.warn( msg );
	
					}
	
					return this.identity();
	
				}
	
				var detInv = 1 / det;
	
				te[ 0 ] = t11 * detInv;
				te[ 1 ] = ( n31 * n23 - n33 * n21 ) * detInv;
				te[ 2 ] = ( n32 * n21 - n31 * n22 ) * detInv;
	
				te[ 3 ] = t12 * detInv;
				te[ 4 ] = ( n33 * n11 - n31 * n13 ) * detInv;
				te[ 5 ] = ( n31 * n12 - n32 * n11 ) * detInv;
	
				te[ 6 ] = t13 * detInv;
				te[ 7 ] = ( n21 * n13 - n23 * n11 ) * detInv;
				te[ 8 ] = ( n22 * n11 - n21 * n12 ) * detInv;
	
				return this;
	
			},
	
			transpose: function () {
	
				var tmp, m = this.elements;
	
				tmp = m[ 1 ]; m[ 1 ] = m[ 3 ]; m[ 3 ] = tmp;
				tmp = m[ 2 ]; m[ 2 ] = m[ 6 ]; m[ 6 ] = tmp;
				tmp = m[ 5 ]; m[ 5 ] = m[ 7 ]; m[ 7 ] = tmp;
	
				return this;
	
			},
	
			getNormalMatrix: function ( matrix4 ) {
	
				return this.setFromMatrix4( matrix4 ).getInverse( this ).transpose();
	
			},
	
			transposeIntoArray: function ( r ) {
	
				var m = this.elements;
	
				r[ 0 ] = m[ 0 ];
				r[ 1 ] = m[ 3 ];
				r[ 2 ] = m[ 6 ];
				r[ 3 ] = m[ 1 ];
				r[ 4 ] = m[ 4 ];
				r[ 5 ] = m[ 7 ];
				r[ 6 ] = m[ 2 ];
				r[ 7 ] = m[ 5 ];
				r[ 8 ] = m[ 8 ];
	
				return this;
	
			},
	
			setUvTransform: function ( tx, ty, sx, sy, rotation, cx, cy ) {
	
				var c = Math.cos( rotation );
				var s = Math.sin( rotation );
	
				this.set(
					sx * c, sx * s, - sx * ( c * cx + s * cy ) + cx + tx,
					- sy * s, sy * c, - sy * ( - s * cx + c * cy ) + cy + ty,
					0, 0, 1
				);
	
			},
	
			scale: function ( sx, sy ) {
	
				var te = this.elements;
	
				te[ 0 ] *= sx; te[ 3 ] *= sx; te[ 6 ] *= sx;
				te[ 1 ] *= sy; te[ 4 ] *= sy; te[ 7 ] *= sy;
	
				return this;
	
			},
	
			rotate: function ( theta ) {
	
				var c = Math.cos( theta );
				var s = Math.sin( theta );
	
				var te = this.elements;
	
				var a11 = te[ 0 ], a12 = te[ 3 ], a13 = te[ 6 ];
				var a21 = te[ 1 ], a22 = te[ 4 ], a23 = te[ 7 ];
	
				te[ 0 ] = c * a11 + s * a21;
				te[ 3 ] = c * a12 + s * a22;
				te[ 6 ] = c * a13 + s * a23;
	
				te[ 1 ] = - s * a11 + c * a21;
				te[ 4 ] = - s * a12 + c * a22;
				te[ 7 ] = - s * a13 + c * a23;
	
				return this;
	
			},
	
			translate: function ( tx, ty ) {
	
				var te = this.elements;
	
				te[ 0 ] += tx * te[ 2 ]; te[ 3 ] += tx * te[ 5 ]; te[ 6 ] += tx * te[ 8 ];
				te[ 1 ] += ty * te[ 2 ]; te[ 4 ] += ty * te[ 5 ]; te[ 7 ] += ty * te[ 8 ];
	
				return this;
	
			},
	
			equals: function ( matrix ) {
	
				var te = this.elements;
				var me = matrix.elements;
	
				for ( var i = 0; i < 9; i ++ ) {
	
					if ( te[ i ] !== me[ i ] ) return false;
	
				}
	
				return true;
	
			},
	
			fromArray: function ( array, offset ) {
	
				if ( offset === undefined ) offset = 0;
	
				for ( var i = 0; i < 9; i ++ ) {
	
					this.elements[ i ] = array[ i + offset ];
	
				}
	
				return this;
	
			},
	
			toArray: function ( array, offset ) {
	
				if ( array === undefined ) array = [];
				if ( offset === undefined ) offset = 0;
	
				var te = this.elements;
	
				array[ offset ] = te[ 0 ];
				array[ offset + 1 ] = te[ 1 ];
				array[ offset + 2 ] = te[ 2 ];
	
				array[ offset + 3 ] = te[ 3 ];
				array[ offset + 4 ] = te[ 4 ];
				array[ offset + 5 ] = te[ 5 ];
	
				array[ offset + 6 ] = te[ 6 ];
				array[ offset + 7 ] = te[ 7 ];
				array[ offset + 8 ] = te[ 8 ];
	
				return array;
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author alteredq / http://alteredqualia.com/
		 * @author szimek / https://github.com/szimek/
		 */
	
		var textureId = 0;
	
		function Texture( image, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding ) {
	
			Object.defineProperty( this, 'id', { value: textureId ++ } );
	
			this.uuid = _Math.generateUUID();
	
			this.name = '';
	
			this.image = image !== undefined ? image : Texture.DEFAULT_IMAGE;
			this.mipmaps = [];
	
			this.mapping = mapping !== undefined ? mapping : Texture.DEFAULT_MAPPING;
	
			this.wrapS = wrapS !== undefined ? wrapS : ClampToEdgeWrapping;
			this.wrapT = wrapT !== undefined ? wrapT : ClampToEdgeWrapping;
	
			this.magFilter = magFilter !== undefined ? magFilter : LinearFilter;
			this.minFilter = minFilter !== undefined ? minFilter : LinearMipMapLinearFilter;
	
			this.anisotropy = anisotropy !== undefined ? anisotropy : 1;
	
			this.format = format !== undefined ? format : RGBAFormat;
			this.type = type !== undefined ? type : UnsignedByteType;
	
			this.offset = new Vector2( 0, 0 );
			this.repeat = new Vector2( 1, 1 );
			this.center = new Vector2( 0, 0 );
			this.rotation = 0;
	
			this.matrixAutoUpdate = true;
			this.matrix = new Matrix3();
	
			this.generateMipmaps = true;
			this.premultiplyAlpha = false;
			this.flipY = true;
			this.unpackAlignment = 4;	// valid values: 1, 2, 4, 8 (see http://www.khronos.org/opengles/sdk/docs/man/xhtml/glPixelStorei.xml)
	
			// Values of encoding !== THREE.LinearEncoding only supported on map, envMap and emissiveMap.
			//
			// Also changing the encoding after already used by a Material will not automatically make the Material
			// update.  You need to explicitly call Material.needsUpdate to trigger it to recompile.
			this.encoding = encoding !== undefined ? encoding : LinearEncoding;
	
			this.version = 0;
			this.onUpdate = null;
	
		}
	
		Texture.DEFAULT_IMAGE = undefined;
		Texture.DEFAULT_MAPPING = UVMapping;
	
		Texture.prototype = Object.assign( Object.create( EventDispatcher.prototype ), {
	
			constructor: Texture,
	
			isTexture: true,
	
			clone: function () {
	
				return new this.constructor().copy( this );
	
			},
	
			copy: function ( source ) {
	
				this.name = source.name;
	
				this.image = source.image;
				this.mipmaps = source.mipmaps.slice( 0 );
	
				this.mapping = source.mapping;
	
				this.wrapS = source.wrapS;
				this.wrapT = source.wrapT;
	
				this.magFilter = source.magFilter;
				this.minFilter = source.minFilter;
	
				this.anisotropy = source.anisotropy;
	
				this.format = source.format;
				this.type = source.type;
	
				this.offset.copy( source.offset );
				this.repeat.copy( source.repeat );
				this.center.copy( source.center );
				this.rotation = source.rotation;
	
				this.matrixAutoUpdate = source.matrixAutoUpdate;
				this.matrix.copy( source.matrix );
	
				this.generateMipmaps = source.generateMipmaps;
				this.premultiplyAlpha = source.premultiplyAlpha;
				this.flipY = source.flipY;
				this.unpackAlignment = source.unpackAlignment;
				this.encoding = source.encoding;
	
				return this;
	
			},
	
			toJSON: function ( meta ) {
	
				var isRootObject = ( meta === undefined || typeof meta === 'string' );
	
				if ( ! isRootObject && meta.textures[ this.uuid ] !== undefined ) {
	
					return meta.textures[ this.uuid ];
	
				}
	
				function getDataURL( image ) {
	
					var canvas;
	
					if ( image instanceof HTMLCanvasElement ) {
	
						canvas = image;
	
					} else {
	
						canvas = document.createElementNS( 'http://www.w3.org/1999/xhtml', 'canvas' );
						canvas.width = image.width;
						canvas.height = image.height;
	
						var context = canvas.getContext( '2d' );
	
						if ( image instanceof ImageData ) {
	
							context.putImageData( image, 0, 0 );
	
						} else {
	
							context.drawImage( image, 0, 0, image.width, image.height );
	
						}
	
					}
	
					if ( canvas.width > 2048 || canvas.height > 2048 ) {
	
						return canvas.toDataURL( 'image/jpeg', 0.6 );
	
					} else {
	
						return canvas.toDataURL( 'image/png' );
	
					}
	
				}
	
				var output = {
					metadata: {
						version: 4.5,
						type: 'Texture',
						generator: 'Texture.toJSON'
					},
	
					uuid: this.uuid,
					name: this.name,
	
					mapping: this.mapping,
	
					repeat: [ this.repeat.x, this.repeat.y ],
					offset: [ this.offset.x, this.offset.y ],
					center: [ this.center.x, this.center.y ],
					rotation: this.rotation,
	
					wrap: [ this.wrapS, this.wrapT ],
	
					minFilter: this.minFilter,
					magFilter: this.magFilter,
					anisotropy: this.anisotropy,
	
					flipY: this.flipY
				};
	
				if ( this.image !== undefined ) {
	
					// TODO: Move to THREE.Image
	
					var image = this.image;
	
					if ( image.uuid === undefined ) {
	
						image.uuid = _Math.generateUUID(); // UGH
	
					}
	
					if ( ! isRootObject && meta.images[ image.uuid ] === undefined ) {
	
						meta.images[ image.uuid ] = {
							uuid: image.uuid,
							url: getDataURL( image )
						};
	
					}
	
					output.image = image.uuid;
	
				}
	
				if ( ! isRootObject ) {
	
					meta.textures[ this.uuid ] = output;
	
				}
	
				return output;
	
			},
	
			dispose: function () {
	
				this.dispatchEvent( { type: 'dispose' } );
	
			},
	
			transformUv: function ( uv ) {
	
				if ( this.mapping !== UVMapping ) return;
	
				uv.applyMatrix3( this.matrix );
	
				if ( uv.x < 0 || uv.x > 1 ) {
	
					switch ( this.wrapS ) {
	
						case RepeatWrapping:
	
							uv.x = uv.x - Math.floor( uv.x );
							break;
	
						case ClampToEdgeWrapping:
	
							uv.x = uv.x < 0 ? 0 : 1;
							break;
	
						case MirroredRepeatWrapping:
	
							if ( Math.abs( Math.floor( uv.x ) % 2 ) === 1 ) {
	
								uv.x = Math.ceil( uv.x ) - uv.x;
	
							} else {
	
								uv.x = uv.x - Math.floor( uv.x );
	
							}
							break;
	
					}
	
				}
	
				if ( uv.y < 0 || uv.y > 1 ) {
	
					switch ( this.wrapT ) {
	
						case RepeatWrapping:
	
							uv.y = uv.y - Math.floor( uv.y );
							break;
	
						case ClampToEdgeWrapping:
	
							uv.y = uv.y < 0 ? 0 : 1;
							break;
	
						case MirroredRepeatWrapping:
	
							if ( Math.abs( Math.floor( uv.y ) % 2 ) === 1 ) {
	
								uv.y = Math.ceil( uv.y ) - uv.y;
	
							} else {
	
								uv.y = uv.y - Math.floor( uv.y );
	
							}
							break;
	
					}
	
				}
	
				if ( this.flipY ) {
	
					uv.y = 1 - uv.y;
	
				}
	
			}
	
		} );
	
		Object.defineProperty( Texture.prototype, "needsUpdate", {
	
			set: function ( value ) {
	
				if ( value === true ) this.version ++;
	
			}
	
		} );
	
		/**
		 * @author supereggbert / http://www.paulbrunt.co.uk/
		 * @author philogb / http://blog.thejit.org/
		 * @author mikael emtinger / http://gomo.se/
		 * @author egraether / http://egraether.com/
		 * @author WestLangley / http://github.com/WestLangley
		 */
	
		function Vector4( x, y, z, w ) {
	
			this.x = x || 0;
			this.y = y || 0;
			this.z = z || 0;
			this.w = ( w !== undefined ) ? w : 1;
	
		}
	
		Object.assign( Vector4.prototype, {
	
			isVector4: true,
	
			set: function ( x, y, z, w ) {
	
				this.x = x;
				this.y = y;
				this.z = z;
				this.w = w;
	
				return this;
	
			},
	
			setScalar: function ( scalar ) {
	
				this.x = scalar;
				this.y = scalar;
				this.z = scalar;
				this.w = scalar;
	
				return this;
	
			},
	
			setX: function ( x ) {
	
				this.x = x;
	
				return this;
	
			},
	
			setY: function ( y ) {
	
				this.y = y;
	
				return this;
	
			},
	
			setZ: function ( z ) {
	
				this.z = z;
	
				return this;
	
			},
	
			setW: function ( w ) {
	
				this.w = w;
	
				return this;
	
			},
	
			setComponent: function ( index, value ) {
	
				switch ( index ) {
	
					case 0: this.x = value; break;
					case 1: this.y = value; break;
					case 2: this.z = value; break;
					case 3: this.w = value; break;
					default: throw new Error( 'index is out of range: ' + index );
	
				}
	
				return this;
	
			},
	
			getComponent: function ( index ) {
	
				switch ( index ) {
	
					case 0: return this.x;
					case 1: return this.y;
					case 2: return this.z;
					case 3: return this.w;
					default: throw new Error( 'index is out of range: ' + index );
	
				}
	
			},
	
			clone: function () {
	
				return new this.constructor( this.x, this.y, this.z, this.w );
	
			},
	
			copy: function ( v ) {
	
				this.x = v.x;
				this.y = v.y;
				this.z = v.z;
				this.w = ( v.w !== undefined ) ? v.w : 1;
	
				return this;
	
			},
	
			add: function ( v, w ) {
	
				if ( w !== undefined ) {
	
					console.warn( 'THREE.Vector4: .add() now only accepts one argument. Use .addVectors( a, b ) instead.' );
					return this.addVectors( v, w );
	
				}
	
				this.x += v.x;
				this.y += v.y;
				this.z += v.z;
				this.w += v.w;
	
				return this;
	
			},
	
			addScalar: function ( s ) {
	
				this.x += s;
				this.y += s;
				this.z += s;
				this.w += s;
	
				return this;
	
			},
	
			addVectors: function ( a, b ) {
	
				this.x = a.x + b.x;
				this.y = a.y + b.y;
				this.z = a.z + b.z;
				this.w = a.w + b.w;
	
				return this;
	
			},
	
			addScaledVector: function ( v, s ) {
	
				this.x += v.x * s;
				this.y += v.y * s;
				this.z += v.z * s;
				this.w += v.w * s;
	
				return this;
	
			},
	
			sub: function ( v, w ) {
	
				if ( w !== undefined ) {
	
					console.warn( 'THREE.Vector4: .sub() now only accepts one argument. Use .subVectors( a, b ) instead.' );
					return this.subVectors( v, w );
	
				}
	
				this.x -= v.x;
				this.y -= v.y;
				this.z -= v.z;
				this.w -= v.w;
	
				return this;
	
			},
	
			subScalar: function ( s ) {
	
				this.x -= s;
				this.y -= s;
				this.z -= s;
				this.w -= s;
	
				return this;
	
			},
	
			subVectors: function ( a, b ) {
	
				this.x = a.x - b.x;
				this.y = a.y - b.y;
				this.z = a.z - b.z;
				this.w = a.w - b.w;
	
				return this;
	
			},
	
			multiplyScalar: function ( scalar ) {
	
				this.x *= scalar;
				this.y *= scalar;
				this.z *= scalar;
				this.w *= scalar;
	
				return this;
	
			},
	
			applyMatrix4: function ( m ) {
	
				var x = this.x, y = this.y, z = this.z, w = this.w;
				var e = m.elements;
	
				this.x = e[ 0 ] * x + e[ 4 ] * y + e[ 8 ] * z + e[ 12 ] * w;
				this.y = e[ 1 ] * x + e[ 5 ] * y + e[ 9 ] * z + e[ 13 ] * w;
				this.z = e[ 2 ] * x + e[ 6 ] * y + e[ 10 ] * z + e[ 14 ] * w;
				this.w = e[ 3 ] * x + e[ 7 ] * y + e[ 11 ] * z + e[ 15 ] * w;
	
				return this;
	
			},
	
			divideScalar: function ( scalar ) {
	
				return this.multiplyScalar( 1 / scalar );
	
			},
	
			setAxisAngleFromQuaternion: function ( q ) {
	
				// http://www.euclideanspace.com/maths/geometry/rotations/conversions/quaternionToAngle/index.htm
	
				// q is assumed to be normalized
	
				this.w = 2 * Math.acos( q.w );
	
				var s = Math.sqrt( 1 - q.w * q.w );
	
				if ( s < 0.0001 ) {
	
					this.x = 1;
					this.y = 0;
					this.z = 0;
	
				} else {
	
					this.x = q.x / s;
					this.y = q.y / s;
					this.z = q.z / s;
	
				}
	
				return this;
	
			},
	
			setAxisAngleFromRotationMatrix: function ( m ) {
	
				// http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToAngle/index.htm
	
				// assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
	
				var angle, x, y, z,		// variables for result
					epsilon = 0.01,		// margin to allow for rounding errors
					epsilon2 = 0.1,		// margin to distinguish between 0 and 180 degrees
	
					te = m.elements,
	
					m11 = te[ 0 ], m12 = te[ 4 ], m13 = te[ 8 ],
					m21 = te[ 1 ], m22 = te[ 5 ], m23 = te[ 9 ],
					m31 = te[ 2 ], m32 = te[ 6 ], m33 = te[ 10 ];
	
				if ( ( Math.abs( m12 - m21 ) < epsilon ) &&
				     ( Math.abs( m13 - m31 ) < epsilon ) &&
				     ( Math.abs( m23 - m32 ) < epsilon ) ) {
	
					// singularity found
					// first check for identity matrix which must have +1 for all terms
					// in leading diagonal and zero in other terms
	
					if ( ( Math.abs( m12 + m21 ) < epsilon2 ) &&
					     ( Math.abs( m13 + m31 ) < epsilon2 ) &&
					     ( Math.abs( m23 + m32 ) < epsilon2 ) &&
					     ( Math.abs( m11 + m22 + m33 - 3 ) < epsilon2 ) ) {
	
						// this singularity is identity matrix so angle = 0
	
						this.set( 1, 0, 0, 0 );
	
						return this; // zero angle, arbitrary axis
	
					}
	
					// otherwise this singularity is angle = 180
	
					angle = Math.PI;
	
					var xx = ( m11 + 1 ) / 2;
					var yy = ( m22 + 1 ) / 2;
					var zz = ( m33 + 1 ) / 2;
					var xy = ( m12 + m21 ) / 4;
					var xz = ( m13 + m31 ) / 4;
					var yz = ( m23 + m32 ) / 4;
	
					if ( ( xx > yy ) && ( xx > zz ) ) {
	
						// m11 is the largest diagonal term
	
						if ( xx < epsilon ) {
	
							x = 0;
							y = 0.707106781;
							z = 0.707106781;
	
						} else {
	
							x = Math.sqrt( xx );
							y = xy / x;
							z = xz / x;
	
						}
	
					} else if ( yy > zz ) {
	
						// m22 is the largest diagonal term
	
						if ( yy < epsilon ) {
	
							x = 0.707106781;
							y = 0;
							z = 0.707106781;
	
						} else {
	
							y = Math.sqrt( yy );
							x = xy / y;
							z = yz / y;
	
						}
	
					} else {
	
						// m33 is the largest diagonal term so base result on this
	
						if ( zz < epsilon ) {
	
							x = 0.707106781;
							y = 0.707106781;
							z = 0;
	
						} else {
	
							z = Math.sqrt( zz );
							x = xz / z;
							y = yz / z;
	
						}
	
					}
	
					this.set( x, y, z, angle );
	
					return this; // return 180 deg rotation
	
				}
	
				// as we have reached here there are no singularities so we can handle normally
	
				var s = Math.sqrt( ( m32 - m23 ) * ( m32 - m23 ) +
				                   ( m13 - m31 ) * ( m13 - m31 ) +
				                   ( m21 - m12 ) * ( m21 - m12 ) ); // used to normalize
	
				if ( Math.abs( s ) < 0.001 ) s = 1;
	
				// prevent divide by zero, should not happen if matrix is orthogonal and should be
				// caught by singularity test above, but I've left it in just in case
	
				this.x = ( m32 - m23 ) / s;
				this.y = ( m13 - m31 ) / s;
				this.z = ( m21 - m12 ) / s;
				this.w = Math.acos( ( m11 + m22 + m33 - 1 ) / 2 );
	
				return this;
	
			},
	
			min: function ( v ) {
	
				this.x = Math.min( this.x, v.x );
				this.y = Math.min( this.y, v.y );
				this.z = Math.min( this.z, v.z );
				this.w = Math.min( this.w, v.w );
	
				return this;
	
			},
	
			max: function ( v ) {
	
				this.x = Math.max( this.x, v.x );
				this.y = Math.max( this.y, v.y );
				this.z = Math.max( this.z, v.z );
				this.w = Math.max( this.w, v.w );
	
				return this;
	
			},
	
			clamp: function ( min, max ) {
	
				// assumes min < max, componentwise
	
				this.x = Math.max( min.x, Math.min( max.x, this.x ) );
				this.y = Math.max( min.y, Math.min( max.y, this.y ) );
				this.z = Math.max( min.z, Math.min( max.z, this.z ) );
				this.w = Math.max( min.w, Math.min( max.w, this.w ) );
	
				return this;
	
			},
	
			clampScalar: function () {
	
				var min, max;
	
				return function clampScalar( minVal, maxVal ) {
	
					if ( min === undefined ) {
	
						min = new Vector4();
						max = new Vector4();
	
					}
	
					min.set( minVal, minVal, minVal, minVal );
					max.set( maxVal, maxVal, maxVal, maxVal );
	
					return this.clamp( min, max );
	
				};
	
			}(),
	
			clampLength: function ( min, max ) {
	
				var length = this.length();
	
				return this.divideScalar( length || 1 ).multiplyScalar( Math.max( min, Math.min( max, length ) ) );
	
			},
	
			floor: function () {
	
				this.x = Math.floor( this.x );
				this.y = Math.floor( this.y );
				this.z = Math.floor( this.z );
				this.w = Math.floor( this.w );
	
				return this;
	
			},
	
			ceil: function () {
	
				this.x = Math.ceil( this.x );
				this.y = Math.ceil( this.y );
				this.z = Math.ceil( this.z );
				this.w = Math.ceil( this.w );
	
				return this;
	
			},
	
			round: function () {
	
				this.x = Math.round( this.x );
				this.y = Math.round( this.y );
				this.z = Math.round( this.z );
				this.w = Math.round( this.w );
	
				return this;
	
			},
	
			roundToZero: function () {
	
				this.x = ( this.x < 0 ) ? Math.ceil( this.x ) : Math.floor( this.x );
				this.y = ( this.y < 0 ) ? Math.ceil( this.y ) : Math.floor( this.y );
				this.z = ( this.z < 0 ) ? Math.ceil( this.z ) : Math.floor( this.z );
				this.w = ( this.w < 0 ) ? Math.ceil( this.w ) : Math.floor( this.w );
	
				return this;
	
			},
	
			negate: function () {
	
				this.x = - this.x;
				this.y = - this.y;
				this.z = - this.z;
				this.w = - this.w;
	
				return this;
	
			},
	
			dot: function ( v ) {
	
				return this.x * v.x + this.y * v.y + this.z * v.z + this.w * v.w;
	
			},
	
			lengthSq: function () {
	
				return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
	
			},
	
			length: function () {
	
				return Math.sqrt( this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w );
	
			},
	
			manhattanLength: function () {
	
				return Math.abs( this.x ) + Math.abs( this.y ) + Math.abs( this.z ) + Math.abs( this.w );
	
			},
	
			normalize: function () {
	
				return this.divideScalar( this.length() || 1 );
	
			},
	
			setLength: function ( length ) {
	
				return this.normalize().multiplyScalar( length );
	
			},
	
			lerp: function ( v, alpha ) {
	
				this.x += ( v.x - this.x ) * alpha;
				this.y += ( v.y - this.y ) * alpha;
				this.z += ( v.z - this.z ) * alpha;
				this.w += ( v.w - this.w ) * alpha;
	
				return this;
	
			},
	
			lerpVectors: function ( v1, v2, alpha ) {
	
				return this.subVectors( v2, v1 ).multiplyScalar( alpha ).add( v1 );
	
			},
	
			equals: function ( v ) {
	
				return ( ( v.x === this.x ) && ( v.y === this.y ) && ( v.z === this.z ) && ( v.w === this.w ) );
	
			},
	
			fromArray: function ( array, offset ) {
	
				if ( offset === undefined ) offset = 0;
	
				this.x = array[ offset ];
				this.y = array[ offset + 1 ];
				this.z = array[ offset + 2 ];
				this.w = array[ offset + 3 ];
	
				return this;
	
			},
	
			toArray: function ( array, offset ) {
	
				if ( array === undefined ) array = [];
				if ( offset === undefined ) offset = 0;
	
				array[ offset ] = this.x;
				array[ offset + 1 ] = this.y;
				array[ offset + 2 ] = this.z;
				array[ offset + 3 ] = this.w;
	
				return array;
	
			},
	
			fromBufferAttribute: function ( attribute, index, offset ) {
	
				if ( offset !== undefined ) {
	
					console.warn( 'THREE.Vector4: offset has been removed from .fromBufferAttribute().' );
	
				}
	
				this.x = attribute.getX( index );
				this.y = attribute.getY( index );
				this.z = attribute.getZ( index );
				this.w = attribute.getW( index );
	
				return this;
	
			}
	
		} );
	
		/**
		 * @author szimek / https://github.com/szimek/
		 * @author alteredq / http://alteredqualia.com/
		 * @author Marius Kintel / https://github.com/kintel
		 */
	
		/*
		 In options, we can specify:
		 * Texture parameters for an auto-generated target texture
		 * depthBuffer/stencilBuffer: Booleans to indicate if we should generate these buffers
		*/
		function WebGLRenderTarget( width, height, options ) {
	
			this.uuid = _Math.generateUUID();
	
			this.width = width;
			this.height = height;
	
			this.scissor = new Vector4( 0, 0, width, height );
			this.scissorTest = false;
	
			this.viewport = new Vector4( 0, 0, width, height );
	
			options = options || {};
	
			if ( options.minFilter === undefined ) options.minFilter = LinearFilter;
	
			this.texture = new Texture( undefined, undefined, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.encoding );
	
			this.depthBuffer = options.depthBuffer !== undefined ? options.depthBuffer : true;
			this.stencilBuffer = options.stencilBuffer !== undefined ? options.stencilBuffer : true;
			this.depthTexture = options.depthTexture !== undefined ? options.depthTexture : null;
	
		}
	
		WebGLRenderTarget.prototype = Object.assign( Object.create( EventDispatcher.prototype ), {
	
			constructor: WebGLRenderTarget,
	
			isWebGLRenderTarget: true,
	
			setSize: function ( width, height ) {
	
				if ( this.width !== width || this.height !== height ) {
	
					this.width = width;
					this.height = height;
	
					this.dispose();
	
				}
	
				this.viewport.set( 0, 0, width, height );
				this.scissor.set( 0, 0, width, height );
	
			},
	
			clone: function () {
	
				return new this.constructor().copy( this );
	
			},
	
			copy: function ( source ) {
	
				this.width = source.width;
				this.height = source.height;
	
				this.viewport.copy( source.viewport );
	
				this.texture = source.texture.clone();
	
				this.depthBuffer = source.depthBuffer;
				this.stencilBuffer = source.stencilBuffer;
				this.depthTexture = source.depthTexture;
	
				return this;
	
			},
	
			dispose: function () {
	
				this.dispatchEvent( { type: 'dispose' } );
	
			}
	
		} );
	
		/**
		 * @author alteredq / http://alteredqualia.com
		 */
	
		function WebGLRenderTargetCube( width, height, options ) {
	
			WebGLRenderTarget.call( this, width, height, options );
	
			this.activeCubeFace = 0; // PX 0, NX 1, PY 2, NY 3, PZ 4, NZ 5
			this.activeMipMapLevel = 0;
	
		}
	
		WebGLRenderTargetCube.prototype = Object.create( WebGLRenderTarget.prototype );
		WebGLRenderTargetCube.prototype.constructor = WebGLRenderTargetCube;
	
		WebGLRenderTargetCube.prototype.isWebGLRenderTargetCube = true;
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 */
	
		function DataTexture( data, width, height, format, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, encoding ) {
	
			Texture.call( this, null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding );
	
			this.image = { data: data, width: width, height: height };
	
			this.magFilter = magFilter !== undefined ? magFilter : NearestFilter;
			this.minFilter = minFilter !== undefined ? minFilter : NearestFilter;
	
			this.generateMipmaps = false;
			this.flipY = false;
			this.unpackAlignment = 1;
	
		}
	
		DataTexture.prototype = Object.create( Texture.prototype );
		DataTexture.prototype.constructor = DataTexture;
	
		DataTexture.prototype.isDataTexture = true;
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function CubeTexture( images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding ) {
	
			images = images !== undefined ? images : [];
			mapping = mapping !== undefined ? mapping : CubeReflectionMapping;
	
			Texture.call( this, images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding );
	
			this.flipY = false;
	
		}
	
		CubeTexture.prototype = Object.create( Texture.prototype );
		CubeTexture.prototype.constructor = CubeTexture;
	
		CubeTexture.prototype.isCubeTexture = true;
	
		Object.defineProperty( CubeTexture.prototype, 'images', {
	
			get: function () {
	
				return this.image;
	
			},
	
			set: function ( value ) {
	
				this.image = value;
	
			}
	
		} );
	
		/**
		 * @author tschw
		 *
		 * Uniforms of a program.
		 * Those form a tree structure with a special top-level container for the root,
		 * which you get by calling 'new WebGLUniforms( gl, program, renderer )'.
		 *
		 *
		 * Properties of inner nodes including the top-level container:
		 *
		 * .seq - array of nested uniforms
		 * .map - nested uniforms by name
		 *
		 *
		 * Methods of all nodes except the top-level container:
		 *
		 * .setValue( gl, value, [renderer] )
		 *
		 * 		uploads a uniform value(s)
		 *  	the 'renderer' parameter is needed for sampler uniforms
		 *
		 *
		 * Static methods of the top-level container (renderer factorizations):
		 *
		 * .upload( gl, seq, values, renderer )
		 *
		 * 		sets uniforms in 'seq' to 'values[id].value'
		 *
		 * .seqWithValue( seq, values ) : filteredSeq
		 *
		 * 		filters 'seq' entries with corresponding entry in values
		 *
		 *
		 * Methods of the top-level container (renderer factorizations):
		 *
		 * .setValue( gl, name, value )
		 *
		 * 		sets uniform with  name 'name' to 'value'
		 *
		 * .set( gl, obj, prop )
		 *
		 * 		sets uniform from object and property with same name than uniform
		 *
		 * .setOptional( gl, obj, prop )
		 *
		 * 		like .set for an optional property of the object
		 *
		 */
	
		var emptyTexture = new Texture();
		var emptyCubeTexture = new CubeTexture();
	
		// --- Base for inner nodes (including the root) ---
	
		function UniformContainer() {
	
			this.seq = [];
			this.map = {};
	
		}
	
		// --- Utilities ---
	
		// Array Caches (provide typed arrays for temporary by size)
	
		var arrayCacheF32 = [];
		var arrayCacheI32 = [];
	
		// Float32Array caches used for uploading Matrix uniforms
	
		var mat4array = new Float32Array( 16 );
		var mat3array = new Float32Array( 9 );
	
		// Flattening for arrays of vectors and matrices
	
		function flatten( array, nBlocks, blockSize ) {
	
			var firstElem = array[ 0 ];
	
			if ( firstElem <= 0 || firstElem > 0 ) return array;
			// unoptimized: ! isNaN( firstElem )
			// see http://jacksondunstan.com/articles/983
	
			var n = nBlocks * blockSize,
				r = arrayCacheF32[ n ];
	
			if ( r === undefined ) {
	
				r = new Float32Array( n );
				arrayCacheF32[ n ] = r;
	
			}
	
			if ( nBlocks !== 0 ) {
	
				firstElem.toArray( r, 0 );
	
				for ( var i = 1, offset = 0; i !== nBlocks; ++ i ) {
	
					offset += blockSize;
					array[ i ].toArray( r, offset );
	
				}
	
			}
	
			return r;
	
		}
	
		// Texture unit allocation
	
		function allocTexUnits( renderer, n ) {
	
			var r = arrayCacheI32[ n ];
	
			if ( r === undefined ) {
	
				r = new Int32Array( n );
				arrayCacheI32[ n ] = r;
	
			}
	
			for ( var i = 0; i !== n; ++ i )
				r[ i ] = renderer.allocTextureUnit();
	
			return r;
	
		}
	
		// --- Setters ---
	
		// Note: Defining these methods externally, because they come in a bunch
		// and this way their names minify.
	
		// Single scalar
	
		function setValue1f( gl, v ) {
	
			gl.uniform1f( this.addr, v );
	
		}
	
		function setValue1i( gl, v ) {
	
			gl.uniform1i( this.addr, v );
	
		}
	
		// Single float vector (from flat array or THREE.VectorN)
	
		function setValue2fv( gl, v ) {
	
			if ( v.x === undefined ) {
	
				gl.uniform2fv( this.addr, v );
	
			} else {
	
				gl.uniform2f( this.addr, v.x, v.y );
	
			}
	
		}
	
		function setValue3fv( gl, v ) {
	
			if ( v.x !== undefined ) {
	
				gl.uniform3f( this.addr, v.x, v.y, v.z );
	
			} else if ( v.r !== undefined ) {
	
				gl.uniform3f( this.addr, v.r, v.g, v.b );
	
			} else {
	
				gl.uniform3fv( this.addr, v );
	
			}
	
		}
	
		function setValue4fv( gl, v ) {
	
			if ( v.x === undefined ) {
	
				gl.uniform4fv( this.addr, v );
	
			} else {
	
				 gl.uniform4f( this.addr, v.x, v.y, v.z, v.w );
	
			}
	
		}
	
		// Single matrix (from flat array or MatrixN)
	
		function setValue2fm( gl, v ) {
	
			gl.uniformMatrix2fv( this.addr, false, v.elements || v );
	
		}
	
		function setValue3fm( gl, v ) {
	
			if ( v.elements === undefined ) {
	
				gl.uniformMatrix3fv( this.addr, false, v );
	
			} else {
	
				mat3array.set( v.elements );
				gl.uniformMatrix3fv( this.addr, false, mat3array );
	
			}
	
		}
	
		function setValue4fm( gl, v ) {
	
			if ( v.elements === undefined ) {
	
				gl.uniformMatrix4fv( this.addr, false, v );
	
			} else {
	
				mat4array.set( v.elements );
				gl.uniformMatrix4fv( this.addr, false, mat4array );
	
			}
	
		}
	
		// Single texture (2D / Cube)
	
		function setValueT1( gl, v, renderer ) {
	
			var unit = renderer.allocTextureUnit();
			gl.uniform1i( this.addr, unit );
			renderer.setTexture2D( v || emptyTexture, unit );
	
		}
	
		function setValueT6( gl, v, renderer ) {
	
			var unit = renderer.allocTextureUnit();
			gl.uniform1i( this.addr, unit );
			renderer.setTextureCube( v || emptyCubeTexture, unit );
	
		}
	
		// Integer / Boolean vectors or arrays thereof (always flat arrays)
	
		function setValue2iv( gl, v ) {
	
			gl.uniform2iv( this.addr, v );
	
		}
	
		function setValue3iv( gl, v ) {
	
			gl.uniform3iv( this.addr, v );
	
		}
	
		function setValue4iv( gl, v ) {
	
			gl.uniform4iv( this.addr, v );
	
		}
	
		// Helper to pick the right setter for the singular case
	
		function getSingularSetter( type ) {
	
			switch ( type ) {
	
				case 0x1406: return setValue1f; // FLOAT
				case 0x8b50: return setValue2fv; // _VEC2
				case 0x8b51: return setValue3fv; // _VEC3
				case 0x8b52: return setValue4fv; // _VEC4
	
				case 0x8b5a: return setValue2fm; // _MAT2
				case 0x8b5b: return setValue3fm; // _MAT3
				case 0x8b5c: return setValue4fm; // _MAT4
	
				case 0x8b5e: case 0x8d66: return setValueT1; // SAMPLER_2D, SAMPLER_EXTERNAL_OES
				case 0x8b60: return setValueT6; // SAMPLER_CUBE
	
				case 0x1404: case 0x8b56: return setValue1i; // INT, BOOL
				case 0x8b53: case 0x8b57: return setValue2iv; // _VEC2
				case 0x8b54: case 0x8b58: return setValue3iv; // _VEC3
				case 0x8b55: case 0x8b59: return setValue4iv; // _VEC4
	
			}
	
		}
	
		// Array of scalars
	
		function setValue1fv( gl, v ) {
	
			gl.uniform1fv( this.addr, v );
	
		}
		function setValue1iv( gl, v ) {
	
			gl.uniform1iv( this.addr, v );
	
		}
	
		// Array of vectors (flat or from THREE classes)
	
		function setValueV2a( gl, v ) {
	
			gl.uniform2fv( this.addr, flatten( v, this.size, 2 ) );
	
		}
	
		function setValueV3a( gl, v ) {
	
			gl.uniform3fv( this.addr, flatten( v, this.size, 3 ) );
	
		}
	
		function setValueV4a( gl, v ) {
	
			gl.uniform4fv( this.addr, flatten( v, this.size, 4 ) );
	
		}
	
		// Array of matrices (flat or from THREE clases)
	
		function setValueM2a( gl, v ) {
	
			gl.uniformMatrix2fv( this.addr, false, flatten( v, this.size, 4 ) );
	
		}
	
		function setValueM3a( gl, v ) {
	
			gl.uniformMatrix3fv( this.addr, false, flatten( v, this.size, 9 ) );
	
		}
	
		function setValueM4a( gl, v ) {
	
			gl.uniformMatrix4fv( this.addr, false, flatten( v, this.size, 16 ) );
	
		}
	
		// Array of textures (2D / Cube)
	
		function setValueT1a( gl, v, renderer ) {
	
			var n = v.length,
				units = allocTexUnits( renderer, n );
	
			gl.uniform1iv( this.addr, units );
	
			for ( var i = 0; i !== n; ++ i ) {
	
				renderer.setTexture2D( v[ i ] || emptyTexture, units[ i ] );
	
			}
	
		}
	
		function setValueT6a( gl, v, renderer ) {
	
			var n = v.length,
				units = allocTexUnits( renderer, n );
	
			gl.uniform1iv( this.addr, units );
	
			for ( var i = 0; i !== n; ++ i ) {
	
				renderer.setTextureCube( v[ i ] || emptyCubeTexture, units[ i ] );
	
			}
	
		}
	
		// Helper to pick the right setter for a pure (bottom-level) array
	
		function getPureArraySetter( type ) {
	
			switch ( type ) {
	
				case 0x1406: return setValue1fv; // FLOAT
				case 0x8b50: return setValueV2a; // _VEC2
				case 0x8b51: return setValueV3a; // _VEC3
				case 0x8b52: return setValueV4a; // _VEC4
	
				case 0x8b5a: return setValueM2a; // _MAT2
				case 0x8b5b: return setValueM3a; // _MAT3
				case 0x8b5c: return setValueM4a; // _MAT4
	
				case 0x8b5e: return setValueT1a; // SAMPLER_2D
				case 0x8b60: return setValueT6a; // SAMPLER_CUBE
	
				case 0x1404: case 0x8b56: return setValue1iv; // INT, BOOL
				case 0x8b53: case 0x8b57: return setValue2iv; // _VEC2
				case 0x8b54: case 0x8b58: return setValue3iv; // _VEC3
				case 0x8b55: case 0x8b59: return setValue4iv; // _VEC4
	
			}
	
		}
	
		// --- Uniform Classes ---
	
		function SingleUniform( id, activeInfo, addr ) {
	
			this.id = id;
			this.addr = addr;
			this.setValue = getSingularSetter( activeInfo.type );
	
			// this.path = activeInfo.name; // DEBUG
	
		}
	
		function PureArrayUniform( id, activeInfo, addr ) {
	
			this.id = id;
			this.addr = addr;
			this.size = activeInfo.size;
			this.setValue = getPureArraySetter( activeInfo.type );
	
			// this.path = activeInfo.name; // DEBUG
	
		}
	
		function StructuredUniform( id ) {
	
			this.id = id;
	
			UniformContainer.call( this ); // mix-in
	
		}
	
		StructuredUniform.prototype.setValue = function ( gl, value ) {
	
			// Note: Don't need an extra 'renderer' parameter, since samplers
			// are not allowed in structured uniforms.
	
			var seq = this.seq;
	
			for ( var i = 0, n = seq.length; i !== n; ++ i ) {
	
				var u = seq[ i ];
				u.setValue( gl, value[ u.id ] );
	
			}
	
		};
	
		// --- Top-level ---
	
		// Parser - builds up the property tree from the path strings
	
		var RePathPart = /([\w\d_]+)(\])?(\[|\.)?/g;
	
		// extracts
		// 	- the identifier (member name or array index)
		//  - followed by an optional right bracket (found when array index)
		//  - followed by an optional left bracket or dot (type of subscript)
		//
		// Note: These portions can be read in a non-overlapping fashion and
		// allow straightforward parsing of the hierarchy that WebGL encodes
		// in the uniform names.
	
		function addUniform( container, uniformObject ) {
	
			container.seq.push( uniformObject );
			container.map[ uniformObject.id ] = uniformObject;
	
		}
	
		function parseUniform( activeInfo, addr, container ) {
	
			var path = activeInfo.name,
				pathLength = path.length;
	
			// reset RegExp object, because of the early exit of a previous run
			RePathPart.lastIndex = 0;
	
			for ( ; ; ) {
	
				var match = RePathPart.exec( path ),
					matchEnd = RePathPart.lastIndex,
	
					id = match[ 1 ],
					idIsIndex = match[ 2 ] === ']',
					subscript = match[ 3 ];
	
				if ( idIsIndex ) id = id | 0; // convert to integer
	
				if ( subscript === undefined || subscript === '[' && matchEnd + 2 === pathLength ) {
	
					// bare name or "pure" bottom-level array "[0]" suffix
	
					addUniform( container, subscript === undefined ?
						new SingleUniform( id, activeInfo, addr ) :
						new PureArrayUniform( id, activeInfo, addr ) );
	
					break;
	
				} else {
	
					// step into inner node / create it in case it doesn't exist
	
					var map = container.map, next = map[ id ];
	
					if ( next === undefined ) {
	
						next = new StructuredUniform( id );
						addUniform( container, next );
	
					}
	
					container = next;
	
				}
	
			}
	
		}
	
		// Root Container
	
		function WebGLUniforms( gl, program, renderer ) {
	
			UniformContainer.call( this );
	
			this.renderer = renderer;
	
			var n = gl.getProgramParameter( program, gl.ACTIVE_UNIFORMS );
	
			for ( var i = 0; i < n; ++ i ) {
	
				var info = gl.getActiveUniform( program, i ),
					path = info.name,
					addr = gl.getUniformLocation( program, path );
	
				parseUniform( info, addr, this );
	
			}
	
		}
	
		WebGLUniforms.prototype.setValue = function ( gl, name, value ) {
	
			var u = this.map[ name ];
	
			if ( u !== undefined ) u.setValue( gl, value, this.renderer );
	
		};
	
		WebGLUniforms.prototype.setOptional = function ( gl, object, name ) {
	
			var v = object[ name ];
	
			if ( v !== undefined ) this.setValue( gl, name, v );
	
		};
	
	
		// Static interface
	
		WebGLUniforms.upload = function ( gl, seq, values, renderer ) {
	
			for ( var i = 0, n = seq.length; i !== n; ++ i ) {
	
				var u = seq[ i ],
					v = values[ u.id ];
	
				if ( v.needsUpdate !== false ) {
	
					// note: always updating when .needsUpdate is undefined
					u.setValue( gl, v.value, renderer );
	
				}
	
			}
	
		};
	
		WebGLUniforms.seqWithValue = function ( seq, values ) {
	
			var r = [];
	
			for ( var i = 0, n = seq.length; i !== n; ++ i ) {
	
				var u = seq[ i ];
				if ( u.id in values ) r.push( u );
	
			}
	
			return r;
	
		};
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		var ColorKeywords = { 'aliceblue': 0xF0F8FF, 'antiquewhite': 0xFAEBD7, 'aqua': 0x00FFFF, 'aquamarine': 0x7FFFD4, 'azure': 0xF0FFFF,
			'beige': 0xF5F5DC, 'bisque': 0xFFE4C4, 'black': 0x000000, 'blanchedalmond': 0xFFEBCD, 'blue': 0x0000FF, 'blueviolet': 0x8A2BE2,
			'brown': 0xA52A2A, 'burlywood': 0xDEB887, 'cadetblue': 0x5F9EA0, 'chartreuse': 0x7FFF00, 'chocolate': 0xD2691E, 'coral': 0xFF7F50,
			'cornflowerblue': 0x6495ED, 'cornsilk': 0xFFF8DC, 'crimson': 0xDC143C, 'cyan': 0x00FFFF, 'darkblue': 0x00008B, 'darkcyan': 0x008B8B,
			'darkgoldenrod': 0xB8860B, 'darkgray': 0xA9A9A9, 'darkgreen': 0x006400, 'darkgrey': 0xA9A9A9, 'darkkhaki': 0xBDB76B, 'darkmagenta': 0x8B008B,
			'darkolivegreen': 0x556B2F, 'darkorange': 0xFF8C00, 'darkorchid': 0x9932CC, 'darkred': 0x8B0000, 'darksalmon': 0xE9967A, 'darkseagreen': 0x8FBC8F,
			'darkslateblue': 0x483D8B, 'darkslategray': 0x2F4F4F, 'darkslategrey': 0x2F4F4F, 'darkturquoise': 0x00CED1, 'darkviolet': 0x9400D3,
			'deeppink': 0xFF1493, 'deepskyblue': 0x00BFFF, 'dimgray': 0x696969, 'dimgrey': 0x696969, 'dodgerblue': 0x1E90FF, 'firebrick': 0xB22222,
			'floralwhite': 0xFFFAF0, 'forestgreen': 0x228B22, 'fuchsia': 0xFF00FF, 'gainsboro': 0xDCDCDC, 'ghostwhite': 0xF8F8FF, 'gold': 0xFFD700,
			'goldenrod': 0xDAA520, 'gray': 0x808080, 'green': 0x008000, 'greenyellow': 0xADFF2F, 'grey': 0x808080, 'honeydew': 0xF0FFF0, 'hotpink': 0xFF69B4,
			'indianred': 0xCD5C5C, 'indigo': 0x4B0082, 'ivory': 0xFFFFF0, 'khaki': 0xF0E68C, 'lavender': 0xE6E6FA, 'lavenderblush': 0xFFF0F5, 'lawngreen': 0x7CFC00,
			'lemonchiffon': 0xFFFACD, 'lightblue': 0xADD8E6, 'lightcoral': 0xF08080, 'lightcyan': 0xE0FFFF, 'lightgoldenrodyellow': 0xFAFAD2, 'lightgray': 0xD3D3D3,
			'lightgreen': 0x90EE90, 'lightgrey': 0xD3D3D3, 'lightpink': 0xFFB6C1, 'lightsalmon': 0xFFA07A, 'lightseagreen': 0x20B2AA, 'lightskyblue': 0x87CEFA,
			'lightslategray': 0x778899, 'lightslategrey': 0x778899, 'lightsteelblue': 0xB0C4DE, 'lightyellow': 0xFFFFE0, 'lime': 0x00FF00, 'limegreen': 0x32CD32,
			'linen': 0xFAF0E6, 'magenta': 0xFF00FF, 'maroon': 0x800000, 'mediumaquamarine': 0x66CDAA, 'mediumblue': 0x0000CD, 'mediumorchid': 0xBA55D3,
			'mediumpurple': 0x9370DB, 'mediumseagreen': 0x3CB371, 'mediumslateblue': 0x7B68EE, 'mediumspringgreen': 0x00FA9A, 'mediumturquoise': 0x48D1CC,
			'mediumvioletred': 0xC71585, 'midnightblue': 0x191970, 'mintcream': 0xF5FFFA, 'mistyrose': 0xFFE4E1, 'moccasin': 0xFFE4B5, 'navajowhite': 0xFFDEAD,
			'navy': 0x000080, 'oldlace': 0xFDF5E6, 'olive': 0x808000, 'olivedrab': 0x6B8E23, 'orange': 0xFFA500, 'orangered': 0xFF4500, 'orchid': 0xDA70D6,
			'palegoldenrod': 0xEEE8AA, 'palegreen': 0x98FB98, 'paleturquoise': 0xAFEEEE, 'palevioletred': 0xDB7093, 'papayawhip': 0xFFEFD5, 'peachpuff': 0xFFDAB9,
			'peru': 0xCD853F, 'pink': 0xFFC0CB, 'plum': 0xDDA0DD, 'powderblue': 0xB0E0E6, 'purple': 0x800080, 'rebeccapurple': 0x663399, 'red': 0xFF0000, 'rosybrown': 0xBC8F8F,
			'royalblue': 0x4169E1, 'saddlebrown': 0x8B4513, 'salmon': 0xFA8072, 'sandybrown': 0xF4A460, 'seagreen': 0x2E8B57, 'seashell': 0xFFF5EE,
			'sienna': 0xA0522D, 'silver': 0xC0C0C0, 'skyblue': 0x87CEEB, 'slateblue': 0x6A5ACD, 'slategray': 0x708090, 'slategrey': 0x708090, 'snow': 0xFFFAFA,
			'springgreen': 0x00FF7F, 'steelblue': 0x4682B4, 'tan': 0xD2B48C, 'teal': 0x008080, 'thistle': 0xD8BFD8, 'tomato': 0xFF6347, 'turquoise': 0x40E0D0,
			'violet': 0xEE82EE, 'wheat': 0xF5DEB3, 'white': 0xFFFFFF, 'whitesmoke': 0xF5F5F5, 'yellow': 0xFFFF00, 'yellowgreen': 0x9ACD32 };
	
		function Color( r, g, b ) {
	
			if ( g === undefined && b === undefined ) {
	
				// r is THREE.Color, hex or string
				return this.set( r );
	
			}
	
			return this.setRGB( r, g, b );
	
		}
	
		Object.assign( Color.prototype, {
	
			isColor: true,
	
			r: 1, g: 1, b: 1,
	
			set: function ( value ) {
	
				if ( value && value.isColor ) {
	
					this.copy( value );
	
				} else if ( typeof value === 'number' ) {
	
					this.setHex( value );
	
				} else if ( typeof value === 'string' ) {
	
					this.setStyle( value );
	
				}
	
				return this;
	
			},
	
			setScalar: function ( scalar ) {
	
				this.r = scalar;
				this.g = scalar;
				this.b = scalar;
	
				return this;
	
			},
	
			setHex: function ( hex ) {
	
				hex = Math.floor( hex );
	
				this.r = ( hex >> 16 & 255 ) / 255;
				this.g = ( hex >> 8 & 255 ) / 255;
				this.b = ( hex & 255 ) / 255;
	
				return this;
	
			},
	
			setRGB: function ( r, g, b ) {
	
				this.r = r;
				this.g = g;
				this.b = b;
	
				return this;
	
			},
	
			setHSL: function () {
	
				function hue2rgb( p, q, t ) {
	
					if ( t < 0 ) t += 1;
					if ( t > 1 ) t -= 1;
					if ( t < 1 / 6 ) return p + ( q - p ) * 6 * t;
					if ( t < 1 / 2 ) return q;
					if ( t < 2 / 3 ) return p + ( q - p ) * 6 * ( 2 / 3 - t );
					return p;
	
				}
	
				return function setHSL( h, s, l ) {
	
					// h,s,l ranges are in 0.0 - 1.0
					h = _Math.euclideanModulo( h, 1 );
					s = _Math.clamp( s, 0, 1 );
					l = _Math.clamp( l, 0, 1 );
	
					if ( s === 0 ) {
	
						this.r = this.g = this.b = l;
	
					} else {
	
						var p = l <= 0.5 ? l * ( 1 + s ) : l + s - ( l * s );
						var q = ( 2 * l ) - p;
	
						this.r = hue2rgb( q, p, h + 1 / 3 );
						this.g = hue2rgb( q, p, h );
						this.b = hue2rgb( q, p, h - 1 / 3 );
	
					}
	
					return this;
	
				};
	
			}(),
	
			setStyle: function ( style ) {
	
				function handleAlpha( string ) {
	
					if ( string === undefined ) return;
	
					if ( parseFloat( string ) < 1 ) {
	
						console.warn( 'THREE.Color: Alpha component of ' + style + ' will be ignored.' );
	
					}
	
				}
	
	
				var m;
	
				if ( m = /^((?:rgb|hsl)a?)\(\s*([^\)]*)\)/.exec( style ) ) {
	
					// rgb / hsl
	
					var color;
					var name = m[ 1 ];
					var components = m[ 2 ];
	
					switch ( name ) {
	
						case 'rgb':
						case 'rgba':
	
							if ( color = /^(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(,\s*([0-9]*\.?[0-9]+)\s*)?$/.exec( components ) ) {
	
								// rgb(255,0,0) rgba(255,0,0,0.5)
								this.r = Math.min( 255, parseInt( color[ 1 ], 10 ) ) / 255;
								this.g = Math.min( 255, parseInt( color[ 2 ], 10 ) ) / 255;
								this.b = Math.min( 255, parseInt( color[ 3 ], 10 ) ) / 255;
	
								handleAlpha( color[ 5 ] );
	
								return this;
	
							}
	
							if ( color = /^(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(,\s*([0-9]*\.?[0-9]+)\s*)?$/.exec( components ) ) {
	
								// rgb(100%,0%,0%) rgba(100%,0%,0%,0.5)
								this.r = Math.min( 100, parseInt( color[ 1 ], 10 ) ) / 100;
								this.g = Math.min( 100, parseInt( color[ 2 ], 10 ) ) / 100;
								this.b = Math.min( 100, parseInt( color[ 3 ], 10 ) ) / 100;
	
								handleAlpha( color[ 5 ] );
	
								return this;
	
							}
	
							break;
	
						case 'hsl':
						case 'hsla':
	
							if ( color = /^([0-9]*\.?[0-9]+)\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(,\s*([0-9]*\.?[0-9]+)\s*)?$/.exec( components ) ) {
	
								// hsl(120,50%,50%) hsla(120,50%,50%,0.5)
								var h = parseFloat( color[ 1 ] ) / 360;
								var s = parseInt( color[ 2 ], 10 ) / 100;
								var l = parseInt( color[ 3 ], 10 ) / 100;
	
								handleAlpha( color[ 5 ] );
	
								return this.setHSL( h, s, l );
	
							}
	
							break;
	
					}
	
				} else if ( m = /^\#([A-Fa-f0-9]+)$/.exec( style ) ) {
	
					// hex color
	
					var hex = m[ 1 ];
					var size = hex.length;
	
					if ( size === 3 ) {
	
						// #ff0
						this.r = parseInt( hex.charAt( 0 ) + hex.charAt( 0 ), 16 ) / 255;
						this.g = parseInt( hex.charAt( 1 ) + hex.charAt( 1 ), 16 ) / 255;
						this.b = parseInt( hex.charAt( 2 ) + hex.charAt( 2 ), 16 ) / 255;
	
						return this;
	
					} else if ( size === 6 ) {
	
						// #ff0000
						this.r = parseInt( hex.charAt( 0 ) + hex.charAt( 1 ), 16 ) / 255;
						this.g = parseInt( hex.charAt( 2 ) + hex.charAt( 3 ), 16 ) / 255;
						this.b = parseInt( hex.charAt( 4 ) + hex.charAt( 5 ), 16 ) / 255;
	
						return this;
	
					}
	
				}
	
				if ( style && style.length > 0 ) {
	
					// color keywords
					var hex = ColorKeywords[ style ];
	
					if ( hex !== undefined ) {
	
						// red
						this.setHex( hex );
	
					} else {
	
						// unknown color
						console.warn( 'THREE.Color: Unknown color ' + style );
	
					}
	
				}
	
				return this;
	
			},
	
			clone: function () {
	
				return new this.constructor( this.r, this.g, this.b );
	
			},
	
			copy: function ( color ) {
	
				this.r = color.r;
				this.g = color.g;
				this.b = color.b;
	
				return this;
	
			},
	
			copyGammaToLinear: function ( color, gammaFactor ) {
	
				if ( gammaFactor === undefined ) gammaFactor = 2.0;
	
				this.r = Math.pow( color.r, gammaFactor );
				this.g = Math.pow( color.g, gammaFactor );
				this.b = Math.pow( color.b, gammaFactor );
	
				return this;
	
			},
	
			copyLinearToGamma: function ( color, gammaFactor ) {
	
				if ( gammaFactor === undefined ) gammaFactor = 2.0;
	
				var safeInverse = ( gammaFactor > 0 ) ? ( 1.0 / gammaFactor ) : 1.0;
	
				this.r = Math.pow( color.r, safeInverse );
				this.g = Math.pow( color.g, safeInverse );
				this.b = Math.pow( color.b, safeInverse );
	
				return this;
	
			},
	
			convertGammaToLinear: function () {
	
				var r = this.r, g = this.g, b = this.b;
	
				this.r = r * r;
				this.g = g * g;
				this.b = b * b;
	
				return this;
	
			},
	
			convertLinearToGamma: function () {
	
				this.r = Math.sqrt( this.r );
				this.g = Math.sqrt( this.g );
				this.b = Math.sqrt( this.b );
	
				return this;
	
			},
	
			getHex: function () {
	
				return ( this.r * 255 ) << 16 ^ ( this.g * 255 ) << 8 ^ ( this.b * 255 ) << 0;
	
			},
	
			getHexString: function () {
	
				return ( '000000' + this.getHex().toString( 16 ) ).slice( - 6 );
	
			},
	
			getHSL: function ( optionalTarget ) {
	
				// h,s,l ranges are in 0.0 - 1.0
	
				var hsl = optionalTarget || { h: 0, s: 0, l: 0 };
	
				var r = this.r, g = this.g, b = this.b;
	
				var max = Math.max( r, g, b );
				var min = Math.min( r, g, b );
	
				var hue, saturation;
				var lightness = ( min + max ) / 2.0;
	
				if ( min === max ) {
	
					hue = 0;
					saturation = 0;
	
				} else {
	
					var delta = max - min;
	
					saturation = lightness <= 0.5 ? delta / ( max + min ) : delta / ( 2 - max - min );
	
					switch ( max ) {
	
						case r: hue = ( g - b ) / delta + ( g < b ? 6 : 0 ); break;
						case g: hue = ( b - r ) / delta + 2; break;
						case b: hue = ( r - g ) / delta + 4; break;
	
					}
	
					hue /= 6;
	
				}
	
				hsl.h = hue;
				hsl.s = saturation;
				hsl.l = lightness;
	
				return hsl;
	
			},
	
			getStyle: function () {
	
				return 'rgb(' + ( ( this.r * 255 ) | 0 ) + ',' + ( ( this.g * 255 ) | 0 ) + ',' + ( ( this.b * 255 ) | 0 ) + ')';
	
			},
	
			offsetHSL: function ( h, s, l ) {
	
				var hsl = this.getHSL();
	
				hsl.h += h; hsl.s += s; hsl.l += l;
	
				this.setHSL( hsl.h, hsl.s, hsl.l );
	
				return this;
	
			},
	
			add: function ( color ) {
	
				this.r += color.r;
				this.g += color.g;
				this.b += color.b;
	
				return this;
	
			},
	
			addColors: function ( color1, color2 ) {
	
				this.r = color1.r + color2.r;
				this.g = color1.g + color2.g;
				this.b = color1.b + color2.b;
	
				return this;
	
			},
	
			addScalar: function ( s ) {
	
				this.r += s;
				this.g += s;
				this.b += s;
	
				return this;
	
			},
	
			sub: function ( color ) {
	
				this.r = Math.max( 0, this.r - color.r );
				this.g = Math.max( 0, this.g - color.g );
				this.b = Math.max( 0, this.b - color.b );
	
				return this;
	
			},
	
			multiply: function ( color ) {
	
				this.r *= color.r;
				this.g *= color.g;
				this.b *= color.b;
	
				return this;
	
			},
	
			multiplyScalar: function ( s ) {
	
				this.r *= s;
				this.g *= s;
				this.b *= s;
	
				return this;
	
			},
	
			lerp: function ( color, alpha ) {
	
				this.r += ( color.r - this.r ) * alpha;
				this.g += ( color.g - this.g ) * alpha;
				this.b += ( color.b - this.b ) * alpha;
	
				return this;
	
			},
	
			equals: function ( c ) {
	
				return ( c.r === this.r ) && ( c.g === this.g ) && ( c.b === this.b );
	
			},
	
			fromArray: function ( array, offset ) {
	
				if ( offset === undefined ) offset = 0;
	
				this.r = array[ offset ];
				this.g = array[ offset + 1 ];
				this.b = array[ offset + 2 ];
	
				return this;
	
			},
	
			toArray: function ( array, offset ) {
	
				if ( array === undefined ) array = [];
				if ( offset === undefined ) offset = 0;
	
				array[ offset ] = this.r;
				array[ offset + 1 ] = this.g;
				array[ offset + 2 ] = this.b;
	
				return array;
	
			},
	
			toJSON: function () {
	
				return this.getHex();
	
			}
	
		} );
	
		/**
		 * Uniforms library for shared webgl shaders
		 */
	
		var UniformsLib = {
	
			common: {
	
				diffuse: { value: new Color( 0xeeeeee ) },
				opacity: { value: 1.0 },
	
				map: { value: null },
				uvTransform: { value: new Matrix3() },
	
				alphaMap: { value: null },
	
			},
	
			specularmap: {
	
				specularMap: { value: null },
	
			},
	
			envmap: {
	
				envMap: { value: null },
				flipEnvMap: { value: - 1 },
				reflectivity: { value: 1.0 },
				refractionRatio: { value: 0.98 }
	
			},
	
			aomap: {
	
				aoMap: { value: null },
				aoMapIntensity: { value: 1 }
	
			},
	
			lightmap: {
	
				lightMap: { value: null },
				lightMapIntensity: { value: 1 }
	
			},
	
			emissivemap: {
	
				emissiveMap: { value: null }
	
			},
	
			bumpmap: {
	
				bumpMap: { value: null },
				bumpScale: { value: 1 }
	
			},
	
			normalmap: {
	
				normalMap: { value: null },
				normalScale: { value: new Vector2( 1, 1 ) }
	
			},
	
			displacementmap: {
	
				displacementMap: { value: null },
				displacementScale: { value: 1 },
				displacementBias: { value: 0 }
	
			},
	
			roughnessmap: {
	
				roughnessMap: { value: null }
	
			},
	
			metalnessmap: {
	
				metalnessMap: { value: null }
	
			},
	
			gradientmap: {
	
				gradientMap: { value: null }
	
			},
	
			fog: {
	
				fogDensity: { value: 0.00025 },
				fogNear: { value: 1 },
				fogFar: { value: 2000 },
				fogColor: { value: new Color( 0xffffff ) }
	
			},
	
			lights: {
	
				ambientLightColor: { value: [] },
	
				directionalLights: { value: [], properties: {
					direction: {},
					color: {},
	
					shadow: {},
					shadowBias: {},
					shadowRadius: {},
					shadowMapSize: {}
				} },
	
				directionalShadowMap: { value: [] },
				directionalShadowMatrix: { value: [] },
	
				spotLights: { value: [], properties: {
					color: {},
					position: {},
					direction: {},
					distance: {},
					coneCos: {},
					penumbraCos: {},
					decay: {},
	
					shadow: {},
					shadowBias: {},
					shadowRadius: {},
					shadowMapSize: {}
				} },
	
				spotShadowMap: { value: [] },
				spotShadowMatrix: { value: [] },
	
				pointLights: { value: [], properties: {
					color: {},
					position: {},
					decay: {},
					distance: {},
	
					shadow: {},
					shadowBias: {},
					shadowRadius: {},
					shadowMapSize: {},
					shadowCameraNear: {},
					shadowCameraFar: {}
				} },
	
				pointShadowMap: { value: [] },
				pointShadowMatrix: { value: [] },
	
				hemisphereLights: { value: [], properties: {
					direction: {},
					skyColor: {},
					groundColor: {}
				} },
	
				// TODO (abelnation): RectAreaLight BRDF data needs to be moved from example to main src
				rectAreaLights: { value: [], properties: {
					color: {},
					position: {},
					width: {},
					height: {}
				} }
	
			},
	
			points: {
	
				diffuse: { value: new Color( 0xeeeeee ) },
				opacity: { value: 1.0 },
				size: { value: 1.0 },
				scale: { value: 1.0 },
				map: { value: null },
				uvTransform: { value: new Matrix3() }
	
			}
	
		};
	
		/**
		 * Uniform Utilities
		 */
	
		var UniformsUtils = {
	
			merge: function ( uniforms ) {
	
				var merged = {};
	
				for ( var u = 0; u < uniforms.length; u ++ ) {
	
					var tmp = this.clone( uniforms[ u ] );
	
					for ( var p in tmp ) {
	
						merged[ p ] = tmp[ p ];
	
					}
	
				}
	
				return merged;
	
			},
	
			clone: function ( uniforms_src ) {
	
				var uniforms_dst = {};
	
				for ( var u in uniforms_src ) {
	
					uniforms_dst[ u ] = {};
	
					for ( var p in uniforms_src[ u ] ) {
	
						var parameter_src = uniforms_src[ u ][ p ];
	
						if ( parameter_src && ( parameter_src.isColor ||
							parameter_src.isMatrix3 || parameter_src.isMatrix4 ||
							parameter_src.isVector2 || parameter_src.isVector3 || parameter_src.isVector4 ||
							parameter_src.isTexture ) ) {
	
							uniforms_dst[ u ][ p ] = parameter_src.clone();
	
						} else if ( Array.isArray( parameter_src ) ) {
	
							uniforms_dst[ u ][ p ] = parameter_src.slice();
	
						} else {
	
							uniforms_dst[ u ][ p ] = parameter_src;
	
						}
	
					}
	
				}
	
				return uniforms_dst;
	
			}
	
		};
	
		var alphamap_fragment = "#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, vUv ).g;\n#endif\n";
	
		var alphamap_pars_fragment = "#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif\n";
	
		var alphatest_fragment = "#ifdef ALPHATEST\n\tif ( diffuseColor.a < ALPHATEST ) discard;\n#endif\n";
	
		var aomap_fragment = "#ifdef USE_AOMAP\n\tfloat ambientOcclusion = ( texture2D( aoMap, vUv2 ).r - 1.0 ) * aoMapIntensity + 1.0;\n\treflectedLight.indirectDiffuse *= ambientOcclusion;\n\t#if defined( USE_ENVMAP ) && defined( PHYSICAL )\n\t\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\t\treflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.specularRoughness );\n\t#endif\n#endif\n";
	
		var aomap_pars_fragment = "#ifdef USE_AOMAP\n\tuniform sampler2D aoMap;\n\tuniform float aoMapIntensity;\n#endif";
	
		var begin_vertex = "\nvec3 transformed = vec3( position );\n";
	
		var beginnormal_vertex = "\nvec3 objectNormal = vec3( normal );\n";
	
		var bsdfs = "float punctualLightIntensityToIrradianceFactor( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n\tif( decayExponent > 0.0 ) {\n#if defined ( PHYSICALLY_CORRECT_LIGHTS )\n\t\tfloat distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n\t\tfloat maxDistanceCutoffFactor = pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n\t\treturn distanceFalloff * maxDistanceCutoffFactor;\n#else\n\t\treturn pow( saturate( -lightDistance / cutoffDistance + 1.0 ), decayExponent );\n#endif\n\t}\n\treturn 1.0;\n}\nvec3 BRDF_Diffuse_Lambert( const in vec3 diffuseColor ) {\n\treturn RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 specularColor, const in float dotLH ) {\n\tfloat fresnel = exp2( ( -5.55473 * dotLH - 6.98316 ) * dotLH );\n\treturn ( 1.0 - specularColor ) * fresnel + specularColor;\n}\nfloat G_GGX_Smith( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gl = dotNL + sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\tfloat gv = dotNV + sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\treturn 1.0 / ( gl * gv );\n}\nfloat G_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\tfloat gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\treturn 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n\tfloat a2 = pow2( alpha );\n\tfloat denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n\treturn RECIPROCAL_PI * a2 / pow2( denom );\n}\nvec3 BRDF_Specular_GGX( const in IncidentLight incidentLight, const in GeometricContext geometry, const in vec3 specularColor, const in float roughness ) {\n\tfloat alpha = pow2( roughness );\n\tvec3 halfDir = normalize( incidentLight.direction + geometry.viewDir );\n\tfloat dotNL = saturate( dot( geometry.normal, incidentLight.direction ) );\n\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\tfloat dotNH = saturate( dot( geometry.normal, halfDir ) );\n\tfloat dotLH = saturate( dot( incidentLight.direction, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, dotLH );\n\tfloat G = G_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\tfloat D = D_GGX( alpha, dotNH );\n\treturn F * ( G * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n\tconst float LUT_SIZE  = 64.0;\n\tconst float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n\tconst float LUT_BIAS  = 0.5 / LUT_SIZE;\n\tfloat theta = acos( dot( N, V ) );\n\tvec2 uv = vec2(\n\t\tsqrt( saturate( roughness ) ),\n\t\tsaturate( theta / ( 0.5 * PI ) ) );\n\tuv = uv * LUT_SCALE + LUT_BIAS;\n\treturn uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n\tfloat l = length( f );\n\treturn max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n\tfloat x = dot( v1, v2 );\n\tfloat y = abs( x );\n\tfloat a = 0.86267 + (0.49788 + 0.01436 * y ) * y;\n\tfloat b = 3.45068 + (4.18814 + y) * y;\n\tfloat v = a / b;\n\tfloat theta_sintheta = (x > 0.0) ? v : 0.5 * inversesqrt( 1.0 - x * x ) - v;\n\treturn cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n\tvec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n\tvec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n\tvec3 lightNormal = cross( v1, v2 );\n\tif( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n\tvec3 T1, T2;\n\tT1 = normalize( V - N * dot( V, N ) );\n\tT2 = - cross( N, T1 );\n\tmat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );\n\tvec3 coords[ 4 ];\n\tcoords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n\tcoords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n\tcoords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n\tcoords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n\tcoords[ 0 ] = normalize( coords[ 0 ] );\n\tcoords[ 1 ] = normalize( coords[ 1 ] );\n\tcoords[ 2 ] = normalize( coords[ 2 ] );\n\tcoords[ 3 ] = normalize( coords[ 3 ] );\n\tvec3 vectorFormFactor = vec3( 0.0 );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n\tvec3 result = vec3( LTC_ClippedSphereFormFactor( vectorFormFactor ) );\n\treturn result;\n}\nvec3 BRDF_Specular_GGX_Environment( const in GeometricContext geometry, const in vec3 specularColor, const in float roughness ) {\n\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\tconst vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n\tconst vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n\tvec4 r = roughness * c0 + c1;\n\tfloat a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n\tvec2 AB = vec2( -1.04, 1.04 ) * a004 + r.zw;\n\treturn specularColor * AB.x + AB.y;\n}\nfloat G_BlinnPhong_Implicit( ) {\n\treturn 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n\treturn RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_Specular_BlinnPhong( const in IncidentLight incidentLight, const in GeometricContext geometry, const in vec3 specularColor, const in float shininess ) {\n\tvec3 halfDir = normalize( incidentLight.direction + geometry.viewDir );\n\tfloat dotNH = saturate( dot( geometry.normal, halfDir ) );\n\tfloat dotLH = saturate( dot( incidentLight.direction, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, dotLH );\n\tfloat G = G_BlinnPhong_Implicit( );\n\tfloat D = D_BlinnPhong( shininess, dotNH );\n\treturn F * ( G * D );\n}\nfloat GGXRoughnessToBlinnExponent( const in float ggxRoughness ) {\n\treturn ( 2.0 / pow2( ggxRoughness + 0.0001 ) - 2.0 );\n}\nfloat BlinnExponentToGGXRoughness( const in float blinnExponent ) {\n\treturn sqrt( 2.0 / ( blinnExponent + 2.0 ) );\n}\n";
	
		var bumpmap_pars_fragment = "#ifdef USE_BUMPMAP\n\tuniform sampler2D bumpMap;\n\tuniform float bumpScale;\n\tvec2 dHdxy_fwd() {\n\t\tvec2 dSTdx = dFdx( vUv );\n\t\tvec2 dSTdy = dFdy( vUv );\n\t\tfloat Hll = bumpScale * texture2D( bumpMap, vUv ).x;\n\t\tfloat dBx = bumpScale * texture2D( bumpMap, vUv + dSTdx ).x - Hll;\n\t\tfloat dBy = bumpScale * texture2D( bumpMap, vUv + dSTdy ).x - Hll;\n\t\treturn vec2( dBx, dBy );\n\t}\n\tvec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy ) {\n\t\tvec3 vSigmaX = vec3( dFdx( surf_pos.x ), dFdx( surf_pos.y ), dFdx( surf_pos.z ) );\n\t\tvec3 vSigmaY = vec3( dFdy( surf_pos.x ), dFdy( surf_pos.y ), dFdy( surf_pos.z ) );\n\t\tvec3 vN = surf_norm;\n\t\tvec3 R1 = cross( vSigmaY, vN );\n\t\tvec3 R2 = cross( vN, vSigmaX );\n\t\tfloat fDet = dot( vSigmaX, R1 );\n\t\tvec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n\t\treturn normalize( abs( fDet ) * surf_norm - vGrad );\n\t}\n#endif\n";
	
		var clipping_planes_fragment = "#if NUM_CLIPPING_PLANES > 0\n\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; ++ i ) {\n\t\tvec4 plane = clippingPlanes[ i ];\n\t\tif ( dot( vViewPosition, plane.xyz ) > plane.w ) discard;\n\t}\n\t\t\n\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\tbool clipped = true;\n\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; ++ i ) {\n\t\t\tvec4 plane = clippingPlanes[ i ];\n\t\t\tclipped = ( dot( vViewPosition, plane.xyz ) > plane.w ) && clipped;\n\t\t}\n\t\tif ( clipped ) discard;\n\t\n\t#endif\n#endif\n";
	
		var clipping_planes_pars_fragment = "#if NUM_CLIPPING_PLANES > 0\n\t#if ! defined( PHYSICAL ) && ! defined( PHONG )\n\t\tvarying vec3 vViewPosition;\n\t#endif\n\tuniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif\n";
	
		var clipping_planes_pars_vertex = "#if NUM_CLIPPING_PLANES > 0 && ! defined( PHYSICAL ) && ! defined( PHONG )\n\tvarying vec3 vViewPosition;\n#endif\n";
	
		var clipping_planes_vertex = "#if NUM_CLIPPING_PLANES > 0 && ! defined( PHYSICAL ) && ! defined( PHONG )\n\tvViewPosition = - mvPosition.xyz;\n#endif\n";
	
		var color_fragment = "#ifdef USE_COLOR\n\tdiffuseColor.rgb *= vColor;\n#endif";
	
		var color_pars_fragment = "#ifdef USE_COLOR\n\tvarying vec3 vColor;\n#endif\n";
	
		var color_pars_vertex = "#ifdef USE_COLOR\n\tvarying vec3 vColor;\n#endif";
	
		var color_vertex = "#ifdef USE_COLOR\n\tvColor.xyz = color.xyz;\n#endif";
	
		var common = "#define PI 3.14159265359\n#define PI2 6.28318530718\n#define PI_HALF 1.5707963267949\n#define RECIPROCAL_PI 0.31830988618\n#define RECIPROCAL_PI2 0.15915494\n#define LOG2 1.442695\n#define EPSILON 1e-6\n#define saturate(a) clamp( a, 0.0, 1.0 )\n#define whiteCompliment(a) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat average( const in vec3 color ) { return dot( color, vec3( 0.3333 ) ); }\nhighp float rand( const in vec2 uv ) {\n\tconst highp float a = 12.9898, b = 78.233, c = 43758.5453;\n\thighp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n\treturn fract(sin(sn) * c);\n}\nstruct IncidentLight {\n\tvec3 color;\n\tvec3 direction;\n\tbool visible;\n};\nstruct ReflectedLight {\n\tvec3 directDiffuse;\n\tvec3 directSpecular;\n\tvec3 indirectDiffuse;\n\tvec3 indirectSpecular;\n};\nstruct GeometricContext {\n\tvec3 position;\n\tvec3 normal;\n\tvec3 viewDir;\n};\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nvec3 projectOnPlane(in vec3 point, in vec3 pointOnPlane, in vec3 planeNormal ) {\n\tfloat distance = dot( planeNormal, point - pointOnPlane );\n\treturn - distance * planeNormal + point;\n}\nfloat sideOfPlane( in vec3 point, in vec3 pointOnPlane, in vec3 planeNormal ) {\n\treturn sign( dot( point - pointOnPlane, planeNormal ) );\n}\nvec3 linePlaneIntersect( in vec3 pointOnLine, in vec3 lineDirection, in vec3 pointOnPlane, in vec3 planeNormal ) {\n\treturn lineDirection * ( dot( planeNormal, pointOnPlane - pointOnLine ) / dot( planeNormal, lineDirection ) ) + pointOnLine;\n}\nmat3 transposeMat3( const in mat3 m ) {\n\tmat3 tmp;\n\ttmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );\n\ttmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );\n\ttmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );\n\treturn tmp;\n}\nfloat linearToRelativeLuminance( const in vec3 color ) {\n\tvec3 weights = vec3( 0.2126, 0.7152, 0.0722 );\n\treturn dot( weights, color.rgb );\n}\n";
	
		var cube_uv_reflection_fragment = "#ifdef ENVMAP_TYPE_CUBE_UV\n#define cubeUV_textureSize (1024.0)\nint getFaceFromDirection(vec3 direction) {\n\tvec3 absDirection = abs(direction);\n\tint face = -1;\n\tif( absDirection.x > absDirection.z ) {\n\t\tif(absDirection.x > absDirection.y )\n\t\t\tface = direction.x > 0.0 ? 0 : 3;\n\t\telse\n\t\t\tface = direction.y > 0.0 ? 1 : 4;\n\t}\n\telse {\n\t\tif(absDirection.z > absDirection.y )\n\t\t\tface = direction.z > 0.0 ? 2 : 5;\n\t\telse\n\t\t\tface = direction.y > 0.0 ? 1 : 4;\n\t}\n\treturn face;\n}\n#define cubeUV_maxLods1  (log2(cubeUV_textureSize*0.25) - 1.0)\n#define cubeUV_rangeClamp (exp2((6.0 - 1.0) * 2.0))\nvec2 MipLevelInfo( vec3 vec, float roughnessLevel, float roughness ) {\n\tfloat scale = exp2(cubeUV_maxLods1 - roughnessLevel);\n\tfloat dxRoughness = dFdx(roughness);\n\tfloat dyRoughness = dFdy(roughness);\n\tvec3 dx = dFdx( vec * scale * dxRoughness );\n\tvec3 dy = dFdy( vec * scale * dyRoughness );\n\tfloat d = max( dot( dx, dx ), dot( dy, dy ) );\n\td = clamp(d, 1.0, cubeUV_rangeClamp);\n\tfloat mipLevel = 0.5 * log2(d);\n\treturn vec2(floor(mipLevel), fract(mipLevel));\n}\n#define cubeUV_maxLods2 (log2(cubeUV_textureSize*0.25) - 2.0)\n#define cubeUV_rcpTextureSize (1.0 / cubeUV_textureSize)\nvec2 getCubeUV(vec3 direction, float roughnessLevel, float mipLevel) {\n\tmipLevel = roughnessLevel > cubeUV_maxLods2 - 3.0 ? 0.0 : mipLevel;\n\tfloat a = 16.0 * cubeUV_rcpTextureSize;\n\tvec2 exp2_packed = exp2( vec2( roughnessLevel, mipLevel ) );\n\tvec2 rcp_exp2_packed = vec2( 1.0 ) / exp2_packed;\n\tfloat powScale = exp2_packed.x * exp2_packed.y;\n\tfloat scale = rcp_exp2_packed.x * rcp_exp2_packed.y * 0.25;\n\tfloat mipOffset = 0.75*(1.0 - rcp_exp2_packed.y) * rcp_exp2_packed.x;\n\tbool bRes = mipLevel == 0.0;\n\tscale =  bRes && (scale < a) ? a : scale;\n\tvec3 r;\n\tvec2 offset;\n\tint face = getFaceFromDirection(direction);\n\tfloat rcpPowScale = 1.0 / powScale;\n\tif( face == 0) {\n\t\tr = vec3(direction.x, -direction.z, direction.y);\n\t\toffset = vec2(0.0+mipOffset,0.75 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ? a : offset.y;\n\t}\n\telse if( face == 1) {\n\t\tr = vec3(direction.y, direction.x, direction.z);\n\t\toffset = vec2(scale+mipOffset, 0.75 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ? a : offset.y;\n\t}\n\telse if( face == 2) {\n\t\tr = vec3(direction.z, direction.x, direction.y);\n\t\toffset = vec2(2.0*scale+mipOffset, 0.75 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ? a : offset.y;\n\t}\n\telse if( face == 3) {\n\t\tr = vec3(direction.x, direction.z, direction.y);\n\t\toffset = vec2(0.0+mipOffset,0.5 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ? 0.0 : offset.y;\n\t}\n\telse if( face == 4) {\n\t\tr = vec3(direction.y, direction.x, -direction.z);\n\t\toffset = vec2(scale+mipOffset, 0.5 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ? 0.0 : offset.y;\n\t}\n\telse {\n\t\tr = vec3(direction.z, -direction.x, direction.y);\n\t\toffset = vec2(2.0*scale+mipOffset, 0.5 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ? 0.0 : offset.y;\n\t}\n\tr = normalize(r);\n\tfloat texelOffset = 0.5 * cubeUV_rcpTextureSize;\n\tvec2 s = ( r.yz / abs( r.x ) + vec2( 1.0 ) ) * 0.5;\n\tvec2 base = offset + vec2( texelOffset );\n\treturn base + s * ( scale - 2.0 * texelOffset );\n}\n#define cubeUV_maxLods3 (log2(cubeUV_textureSize*0.25) - 3.0)\nvec4 textureCubeUV(vec3 reflectedDirection, float roughness ) {\n\tfloat roughnessVal = roughness* cubeUV_maxLods3;\n\tfloat r1 = floor(roughnessVal);\n\tfloat r2 = r1 + 1.0;\n\tfloat t = fract(roughnessVal);\n\tvec2 mipInfo = MipLevelInfo(reflectedDirection, r1, roughness);\n\tfloat s = mipInfo.y;\n\tfloat level0 = mipInfo.x;\n\tfloat level1 = level0 + 1.0;\n\tlevel1 = level1 > 5.0 ? 5.0 : level1;\n\tlevel0 += min( floor( s + 0.5 ), 5.0 );\n\tvec2 uv_10 = getCubeUV(reflectedDirection, r1, level0);\n\tvec4 color10 = envMapTexelToLinear(texture2D(envMap, uv_10));\n\tvec2 uv_20 = getCubeUV(reflectedDirection, r2, level0);\n\tvec4 color20 = envMapTexelToLinear(texture2D(envMap, uv_20));\n\tvec4 result = mix(color10, color20, t);\n\treturn vec4(result.rgb, 1.0);\n}\n#endif\n";
	
		var defaultnormal_vertex = "vec3 transformedNormal = normalMatrix * objectNormal;\n#ifdef FLIP_SIDED\n\ttransformedNormal = - transformedNormal;\n#endif\n";
	
		var displacementmap_pars_vertex = "#ifdef USE_DISPLACEMENTMAP\n\tuniform sampler2D displacementMap;\n\tuniform float displacementScale;\n\tuniform float displacementBias;\n#endif\n";
	
		var displacementmap_vertex = "#ifdef USE_DISPLACEMENTMAP\n\ttransformed += normalize( objectNormal ) * ( texture2D( displacementMap, uv ).x * displacementScale + displacementBias );\n#endif\n";
	
		var emissivemap_fragment = "#ifdef USE_EMISSIVEMAP\n\tvec4 emissiveColor = texture2D( emissiveMap, vUv );\n\temissiveColor.rgb = emissiveMapTexelToLinear( emissiveColor ).rgb;\n\ttotalEmissiveRadiance *= emissiveColor.rgb;\n#endif\n";
	
		var emissivemap_pars_fragment = "#ifdef USE_EMISSIVEMAP\n\tuniform sampler2D emissiveMap;\n#endif\n";
	
		var encodings_fragment = "  gl_FragColor = linearToOutputTexel( gl_FragColor );\n";
	
		var encodings_pars_fragment = "\nvec4 LinearToLinear( in vec4 value ) {\n\treturn value;\n}\nvec4 GammaToLinear( in vec4 value, in float gammaFactor ) {\n\treturn vec4( pow( value.xyz, vec3( gammaFactor ) ), value.w );\n}\nvec4 LinearToGamma( in vec4 value, in float gammaFactor ) {\n\treturn vec4( pow( value.xyz, vec3( 1.0 / gammaFactor ) ), value.w );\n}\nvec4 sRGBToLinear( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), value.rgb * 0.0773993808, vec3( lessThanEqual( value.rgb, vec3( 0.04045 ) ) ) ), value.w );\n}\nvec4 LinearTosRGB( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.w );\n}\nvec4 RGBEToLinear( in vec4 value ) {\n\treturn vec4( value.rgb * exp2( value.a * 255.0 - 128.0 ), 1.0 );\n}\nvec4 LinearToRGBE( in vec4 value ) {\n\tfloat maxComponent = max( max( value.r, value.g ), value.b );\n\tfloat fExp = clamp( ceil( log2( maxComponent ) ), -128.0, 127.0 );\n\treturn vec4( value.rgb / exp2( fExp ), ( fExp + 128.0 ) / 255.0 );\n}\nvec4 RGBMToLinear( in vec4 value, in float maxRange ) {\n\treturn vec4( value.xyz * value.w * maxRange, 1.0 );\n}\nvec4 LinearToRGBM( in vec4 value, in float maxRange ) {\n\tfloat maxRGB = max( value.x, max( value.g, value.b ) );\n\tfloat M      = clamp( maxRGB / maxRange, 0.0, 1.0 );\n\tM            = ceil( M * 255.0 ) / 255.0;\n\treturn vec4( value.rgb / ( M * maxRange ), M );\n}\nvec4 RGBDToLinear( in vec4 value, in float maxRange ) {\n\treturn vec4( value.rgb * ( ( maxRange / 255.0 ) / value.a ), 1.0 );\n}\nvec4 LinearToRGBD( in vec4 value, in float maxRange ) {\n\tfloat maxRGB = max( value.x, max( value.g, value.b ) );\n\tfloat D      = max( maxRange / maxRGB, 1.0 );\n\tD            = min( floor( D ) / 255.0, 1.0 );\n\treturn vec4( value.rgb * ( D * ( 255.0 / maxRange ) ), D );\n}\nconst mat3 cLogLuvM = mat3( 0.2209, 0.3390, 0.4184, 0.1138, 0.6780, 0.7319, 0.0102, 0.1130, 0.2969 );\nvec4 LinearToLogLuv( in vec4 value )  {\n\tvec3 Xp_Y_XYZp = value.rgb * cLogLuvM;\n\tXp_Y_XYZp = max(Xp_Y_XYZp, vec3(1e-6, 1e-6, 1e-6));\n\tvec4 vResult;\n\tvResult.xy = Xp_Y_XYZp.xy / Xp_Y_XYZp.z;\n\tfloat Le = 2.0 * log2(Xp_Y_XYZp.y) + 127.0;\n\tvResult.w = fract(Le);\n\tvResult.z = (Le - (floor(vResult.w*255.0))/255.0)/255.0;\n\treturn vResult;\n}\nconst mat3 cLogLuvInverseM = mat3( 6.0014, -2.7008, -1.7996, -1.3320, 3.1029, -5.7721, 0.3008, -1.0882, 5.6268 );\nvec4 LogLuvToLinear( in vec4 value ) {\n\tfloat Le = value.z * 255.0 + value.w;\n\tvec3 Xp_Y_XYZp;\n\tXp_Y_XYZp.y = exp2((Le - 127.0) / 2.0);\n\tXp_Y_XYZp.z = Xp_Y_XYZp.y / value.y;\n\tXp_Y_XYZp.x = value.x * Xp_Y_XYZp.z;\n\tvec3 vRGB = Xp_Y_XYZp.rgb * cLogLuvInverseM;\n\treturn vec4( max(vRGB, 0.0), 1.0 );\n}\n";
	
		var envmap_fragment = "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG )\n\t\tvec3 cameraToVertex = normalize( vWorldPosition - cameraPosition );\n\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( cameraToVertex, worldNormal );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( cameraToVertex, worldNormal, refractionRatio );\n\t\t#endif\n\t#else\n\t\tvec3 reflectVec = vReflect;\n\t#endif\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 envColor = textureCube( envMap, vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n\t#elif defined( ENVMAP_TYPE_EQUIREC )\n\t\tvec2 sampleUV;\n\t\treflectVec = normalize( reflectVec );\n\t\tsampleUV.y = asin( clamp( reflectVec.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n\t\tsampleUV.x = atan( reflectVec.z, reflectVec.x ) * RECIPROCAL_PI2 + 0.5;\n\t\tvec4 envColor = texture2D( envMap, sampleUV );\n\t#elif defined( ENVMAP_TYPE_SPHERE )\n\t\treflectVec = normalize( reflectVec );\n\t\tvec3 reflectView = normalize( ( viewMatrix * vec4( reflectVec, 0.0 ) ).xyz + vec3( 0.0, 0.0, 1.0 ) );\n\t\tvec4 envColor = texture2D( envMap, reflectView.xy * 0.5 + 0.5 );\n\t#else\n\t\tvec4 envColor = vec4( 0.0 );\n\t#endif\n\tenvColor = envMapTexelToLinear( envColor );\n\t#ifdef ENVMAP_BLENDING_MULTIPLY\n\t\toutgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_MIX )\n\t\toutgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_ADD )\n\t\toutgoingLight += envColor.xyz * specularStrength * reflectivity;\n\t#endif\n#endif\n";
	
		var envmap_pars_fragment = "#if defined( USE_ENVMAP ) || defined( PHYSICAL )\n\tuniform float reflectivity;\n\tuniform float envMapIntensity;\n#endif\n#ifdef USE_ENVMAP\n\t#if ! defined( PHYSICAL ) && ( defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) )\n\t\tvarying vec3 vWorldPosition;\n\t#endif\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tuniform samplerCube envMap;\n\t#else\n\t\tuniform sampler2D envMap;\n\t#endif\n\tuniform float flipEnvMap;\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( PHYSICAL )\n\t\tuniform float refractionRatio;\n\t#else\n\t\tvarying vec3 vReflect;\n\t#endif\n#endif\n";
	
		var envmap_pars_vertex = "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG )\n\t\tvarying vec3 vWorldPosition;\n\t#else\n\t\tvarying vec3 vReflect;\n\t\tuniform float refractionRatio;\n\t#endif\n#endif\n";
	
		var envmap_vertex = "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG )\n\t\tvWorldPosition = worldPosition.xyz;\n\t#else\n\t\tvec3 cameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n\t\tvec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvReflect = reflect( cameraToVertex, worldNormal );\n\t\t#else\n\t\t\tvReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n\t\t#endif\n\t#endif\n#endif\n";
	
		var fog_vertex = "\n#ifdef USE_FOG\nfogDepth = -mvPosition.z;\n#endif";
	
		var fog_pars_vertex = "#ifdef USE_FOG\n  varying float fogDepth;\n#endif\n";
	
		var fog_fragment = "#ifdef USE_FOG\n\t#ifdef FOG_EXP2\n\t\tfloat fogFactor = whiteCompliment( exp2( - fogDensity * fogDensity * fogDepth * fogDepth * LOG2 ) );\n\t#else\n\t\tfloat fogFactor = smoothstep( fogNear, fogFar, fogDepth );\n\t#endif\n\tgl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif\n";
	
		var fog_pars_fragment = "#ifdef USE_FOG\n\tuniform vec3 fogColor;\n\tvarying float fogDepth;\n\t#ifdef FOG_EXP2\n\t\tuniform float fogDensity;\n\t#else\n\t\tuniform float fogNear;\n\t\tuniform float fogFar;\n\t#endif\n#endif\n";
	
		var gradientmap_pars_fragment = "#ifdef TOON\n\tuniform sampler2D gradientMap;\n\tvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n\t\tfloat dotNL = dot( normal, lightDirection );\n\t\tvec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n\t\t#ifdef USE_GRADIENTMAP\n\t\t\treturn texture2D( gradientMap, coord ).rgb;\n\t\t#else\n\t\t\treturn ( coord.x < 0.7 ) ? vec3( 0.7 ) : vec3( 1.0 );\n\t\t#endif\n\t}\n#endif\n";
	
		var lightmap_fragment = "#ifdef USE_LIGHTMAP\n\treflectedLight.indirectDiffuse += PI * texture2D( lightMap, vUv2 ).xyz * lightMapIntensity;\n#endif\n";
	
		var lightmap_pars_fragment = "#ifdef USE_LIGHTMAP\n\tuniform sampler2D lightMap;\n\tuniform float lightMapIntensity;\n#endif";
	
		var lights_lambert_vertex = "vec3 diffuse = vec3( 1.0 );\nGeometricContext geometry;\ngeometry.position = mvPosition.xyz;\ngeometry.normal = normalize( transformedNormal );\ngeometry.viewDir = normalize( -mvPosition.xyz );\nGeometricContext backGeometry;\nbackGeometry.position = geometry.position;\nbackGeometry.normal = -geometry.normal;\nbackGeometry.viewDir = geometry.viewDir;\nvLightFront = vec3( 0.0 );\n#ifdef DOUBLE_SIDED\n\tvLightBack = vec3( 0.0 );\n#endif\nIncidentLight directLight;\nfloat dotNL;\nvec3 directLightColor_Diffuse;\n#if NUM_POINT_LIGHTS > 0\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tgetPointDirectLightIrradiance( pointLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = PI * directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( -dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tgetSpotDirectLightIrradiance( spotLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = PI * directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( -dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n#endif\n#if NUM_DIR_LIGHTS > 0\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tgetDirectionalDirectLightIrradiance( directionalLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = PI * directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( -dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\tvLightFront += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry );\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += getHemisphereLightIrradiance( hemisphereLights[ i ], backGeometry );\n\t\t#endif\n\t}\n#endif\n";
	
		var lights_pars = "uniform vec3 ambientLightColor;\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n\tvec3 irradiance = ambientLightColor;\n\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\tirradiance *= PI;\n\t#endif\n\treturn irradiance;\n}\n#if NUM_DIR_LIGHTS > 0\n\tstruct DirectionalLight {\n\t\tvec3 direction;\n\t\tvec3 color;\n\t\tint shadow;\n\t\tfloat shadowBias;\n\t\tfloat shadowRadius;\n\t\tvec2 shadowMapSize;\n\t};\n\tuniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n\tvoid getDirectionalDirectLightIrradiance( const in DirectionalLight directionalLight, const in GeometricContext geometry, out IncidentLight directLight ) {\n\t\tdirectLight.color = directionalLight.color;\n\t\tdirectLight.direction = directionalLight.direction;\n\t\tdirectLight.visible = true;\n\t}\n#endif\n#if NUM_POINT_LIGHTS > 0\n\tstruct PointLight {\n\t\tvec3 position;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t\tint shadow;\n\t\tfloat shadowBias;\n\t\tfloat shadowRadius;\n\t\tvec2 shadowMapSize;\n\t\tfloat shadowCameraNear;\n\t\tfloat shadowCameraFar;\n\t};\n\tuniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n\tvoid getPointDirectLightIrradiance( const in PointLight pointLight, const in GeometricContext geometry, out IncidentLight directLight ) {\n\t\tvec3 lVector = pointLight.position - geometry.position;\n\t\tdirectLight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tdirectLight.color = pointLight.color;\n\t\tdirectLight.color *= punctualLightIntensityToIrradianceFactor( lightDistance, pointLight.distance, pointLight.decay );\n\t\tdirectLight.visible = ( directLight.color != vec3( 0.0 ) );\n\t}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\tstruct SpotLight {\n\t\tvec3 position;\n\t\tvec3 direction;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t\tfloat coneCos;\n\t\tfloat penumbraCos;\n\t\tint shadow;\n\t\tfloat shadowBias;\n\t\tfloat shadowRadius;\n\t\tvec2 shadowMapSize;\n\t};\n\tuniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n\tvoid getSpotDirectLightIrradiance( const in SpotLight spotLight, const in GeometricContext geometry, out IncidentLight directLight  ) {\n\t\tvec3 lVector = spotLight.position - geometry.position;\n\t\tdirectLight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tfloat angleCos = dot( directLight.direction, spotLight.direction );\n\t\tif ( angleCos > spotLight.coneCos ) {\n\t\t\tfloat spotEffect = smoothstep( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n\t\t\tdirectLight.color = spotLight.color;\n\t\t\tdirectLight.color *= spotEffect * punctualLightIntensityToIrradianceFactor( lightDistance, spotLight.distance, spotLight.decay );\n\t\t\tdirectLight.visible = true;\n\t\t} else {\n\t\t\tdirectLight.color = vec3( 0.0 );\n\t\t\tdirectLight.visible = false;\n\t\t}\n\t}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n\tstruct RectAreaLight {\n\t\tvec3 color;\n\t\tvec3 position;\n\t\tvec3 halfWidth;\n\t\tvec3 halfHeight;\n\t};\n\tuniform sampler2D ltcMat;\tuniform sampler2D ltcMag;\n\tuniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\tstruct HemisphereLight {\n\t\tvec3 direction;\n\t\tvec3 skyColor;\n\t\tvec3 groundColor;\n\t};\n\tuniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n\tvec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in GeometricContext geometry ) {\n\t\tfloat dotNL = dot( geometry.normal, hemiLight.direction );\n\t\tfloat hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n\t\tvec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n\t\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\t\tirradiance *= PI;\n\t\t#endif\n\t\treturn irradiance;\n\t}\n#endif\n#if defined( USE_ENVMAP ) && defined( PHYSICAL )\n\tvec3 getLightProbeIndirectIrradiance( const in GeometricContext geometry, const in int maxMIPLevel ) {\n\t\tvec3 worldNormal = inverseTransformDirection( geometry.normal, viewMatrix );\n\t\t#ifdef ENVMAP_TYPE_CUBE\n\t\t\tvec3 queryVec = vec3( flipEnvMap * worldNormal.x, worldNormal.yz );\n\t\t\t#ifdef TEXTURE_LOD_EXT\n\t\t\t\tvec4 envMapColor = textureCubeLodEXT( envMap, queryVec, float( maxMIPLevel ) );\n\t\t\t#else\n\t\t\t\tvec4 envMapColor = textureCube( envMap, queryVec, float( maxMIPLevel ) );\n\t\t\t#endif\n\t\t\tenvMapColor.rgb = envMapTexelToLinear( envMapColor ).rgb;\n\t\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\t\tvec3 queryVec = vec3( flipEnvMap * worldNormal.x, worldNormal.yz );\n\t\t\tvec4 envMapColor = textureCubeUV( queryVec, 1.0 );\n\t\t#else\n\t\t\tvec4 envMapColor = vec4( 0.0 );\n\t\t#endif\n\t\treturn PI * envMapColor.rgb * envMapIntensity;\n\t}\n\tfloat getSpecularMIPLevel( const in float blinnShininessExponent, const in int maxMIPLevel ) {\n\t\tfloat maxMIPLevelScalar = float( maxMIPLevel );\n\t\tfloat desiredMIPLevel = maxMIPLevelScalar + 0.79248 - 0.5 * log2( pow2( blinnShininessExponent ) + 1.0 );\n\t\treturn clamp( desiredMIPLevel, 0.0, maxMIPLevelScalar );\n\t}\n\tvec3 getLightProbeIndirectRadiance( const in GeometricContext geometry, const in float blinnShininessExponent, const in int maxMIPLevel ) {\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( -geometry.viewDir, geometry.normal );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( -geometry.viewDir, geometry.normal, refractionRatio );\n\t\t#endif\n\t\treflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n\t\tfloat specularMIPLevel = getSpecularMIPLevel( blinnShininessExponent, maxMIPLevel );\n\t\t#ifdef ENVMAP_TYPE_CUBE\n\t\t\tvec3 queryReflectVec = vec3( flipEnvMap * reflectVec.x, reflectVec.yz );\n\t\t\t#ifdef TEXTURE_LOD_EXT\n\t\t\t\tvec4 envMapColor = textureCubeLodEXT( envMap, queryReflectVec, specularMIPLevel );\n\t\t\t#else\n\t\t\t\tvec4 envMapColor = textureCube( envMap, queryReflectVec, specularMIPLevel );\n\t\t\t#endif\n\t\t\tenvMapColor.rgb = envMapTexelToLinear( envMapColor ).rgb;\n\t\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\t\tvec3 queryReflectVec = vec3( flipEnvMap * reflectVec.x, reflectVec.yz );\n\t\t\tvec4 envMapColor = textureCubeUV(queryReflectVec, BlinnExponentToGGXRoughness(blinnShininessExponent));\n\t\t#elif defined( ENVMAP_TYPE_EQUIREC )\n\t\t\tvec2 sampleUV;\n\t\t\tsampleUV.y = asin( clamp( reflectVec.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n\t\t\tsampleUV.x = atan( reflectVec.z, reflectVec.x ) * RECIPROCAL_PI2 + 0.5;\n\t\t\t#ifdef TEXTURE_LOD_EXT\n\t\t\t\tvec4 envMapColor = texture2DLodEXT( envMap, sampleUV, specularMIPLevel );\n\t\t\t#else\n\t\t\t\tvec4 envMapColor = texture2D( envMap, sampleUV, specularMIPLevel );\n\t\t\t#endif\n\t\t\tenvMapColor.rgb = envMapTexelToLinear( envMapColor ).rgb;\n\t\t#elif defined( ENVMAP_TYPE_SPHERE )\n\t\t\tvec3 reflectView = normalize( ( viewMatrix * vec4( reflectVec, 0.0 ) ).xyz + vec3( 0.0,0.0,1.0 ) );\n\t\t\t#ifdef TEXTURE_LOD_EXT\n\t\t\t\tvec4 envMapColor = texture2DLodEXT( envMap, reflectView.xy * 0.5 + 0.5, specularMIPLevel );\n\t\t\t#else\n\t\t\t\tvec4 envMapColor = texture2D( envMap, reflectView.xy * 0.5 + 0.5, specularMIPLevel );\n\t\t\t#endif\n\t\t\tenvMapColor.rgb = envMapTexelToLinear( envMapColor ).rgb;\n\t\t#endif\n\t\treturn envMapColor.rgb * envMapIntensity;\n\t}\n#endif\n";
	
		var lights_phong_fragment = "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;\n";
	
		var lights_phong_pars_fragment = "varying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\nstruct BlinnPhongMaterial {\n\tvec3\tdiffuseColor;\n\tvec3\tspecularColor;\n\tfloat\tspecularShininess;\n\tfloat\tspecularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\t#ifdef TOON\n\t\tvec3 irradiance = getGradientIrradiance( geometry.normal, directLight.direction ) * directLight.color;\n\t#else\n\t\tfloat dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n\t\tvec3 irradiance = dotNL * directLight.color;\n\t#endif\n\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\tirradiance *= PI;\n\t#endif\n\treflectedLight.directDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n\treflectedLight.directSpecular += irradiance * BRDF_Specular_BlinnPhong( directLight, geometry, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_BlinnPhong\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_BlinnPhong\n#define Material_LightProbeLOD( material )\t(0)\n";
	
		var lights_physical_fragment = "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nmaterial.specularRoughness = clamp( roughnessFactor, 0.04, 1.0 );\n#ifdef STANDARD\n\tmaterial.specularColor = mix( vec3( DEFAULT_SPECULAR_COEFFICIENT ), diffuseColor.rgb, metalnessFactor );\n#else\n\tmaterial.specularColor = mix( vec3( MAXIMUM_SPECULAR_COEFFICIENT * pow2( reflectivity ) ), diffuseColor.rgb, metalnessFactor );\n\tmaterial.clearCoat = saturate( clearCoat );\tmaterial.clearCoatRoughness = clamp( clearCoatRoughness, 0.04, 1.0 );\n#endif\n";
	
		var lights_physical_pars_fragment = "struct PhysicalMaterial {\n\tvec3\tdiffuseColor;\n\tfloat\tspecularRoughness;\n\tvec3\tspecularColor;\n\t#ifndef STANDARD\n\t\tfloat clearCoat;\n\t\tfloat clearCoatRoughness;\n\t#endif\n};\n#define MAXIMUM_SPECULAR_COEFFICIENT 0.16\n#define DEFAULT_SPECULAR_COEFFICIENT 0.04\nfloat clearCoatDHRApprox( const in float roughness, const in float dotNL ) {\n\treturn DEFAULT_SPECULAR_COEFFICIENT + ( 1.0 - DEFAULT_SPECULAR_COEFFICIENT ) * ( pow( 1.0 - dotNL, 5.0 ) * pow( 1.0 - roughness, 2.0 ) );\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n\tvoid RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\t\tvec3 normal = geometry.normal;\n\t\tvec3 viewDir = geometry.viewDir;\n\t\tvec3 position = geometry.position;\n\t\tvec3 lightPos = rectAreaLight.position;\n\t\tvec3 halfWidth = rectAreaLight.halfWidth;\n\t\tvec3 halfHeight = rectAreaLight.halfHeight;\n\t\tvec3 lightColor = rectAreaLight.color;\n\t\tfloat roughness = material.specularRoughness;\n\t\tvec3 rectCoords[ 4 ];\n\t\trectCoords[ 0 ] = lightPos - halfWidth - halfHeight;\t\trectCoords[ 1 ] = lightPos + halfWidth - halfHeight;\n\t\trectCoords[ 2 ] = lightPos + halfWidth + halfHeight;\n\t\trectCoords[ 3 ] = lightPos - halfWidth + halfHeight;\n\t\tvec2 uv = LTC_Uv( normal, viewDir, roughness );\n\t\tfloat norm = texture2D( ltcMag, uv ).a;\n\t\tvec4 t = texture2D( ltcMat, uv );\n\t\tmat3 mInv = mat3(\n\t\t\tvec3(   1,   0, t.y ),\n\t\t\tvec3(   0, t.z,   0 ),\n\t\t\tvec3( t.w,   0, t.x )\n\t\t);\n\t\treflectedLight.directSpecular += lightColor * material.specularColor * norm * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n\t\treflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1 ), rectCoords );\n\t}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\tirradiance *= PI;\n\t#endif\n\t#ifndef STANDARD\n\t\tfloat clearCoatDHR = material.clearCoat * clearCoatDHRApprox( material.clearCoatRoughness, dotNL );\n\t#else\n\t\tfloat clearCoatDHR = 0.0;\n\t#endif\n\treflectedLight.directSpecular += ( 1.0 - clearCoatDHR ) * irradiance * BRDF_Specular_GGX( directLight, geometry, material.specularColor, material.specularRoughness );\n\treflectedLight.directDiffuse += ( 1.0 - clearCoatDHR ) * irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n\t#ifndef STANDARD\n\t\treflectedLight.directSpecular += irradiance * material.clearCoat * BRDF_Specular_GGX( directLight, geometry, vec3( DEFAULT_SPECULAR_COEFFICIENT ), material.clearCoatRoughness );\n\t#endif\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 clearCoatRadiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\t#ifndef STANDARD\n\t\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\t\tfloat dotNL = dotNV;\n\t\tfloat clearCoatDHR = material.clearCoat * clearCoatDHRApprox( material.clearCoatRoughness, dotNL );\n\t#else\n\t\tfloat clearCoatDHR = 0.0;\n\t#endif\n\treflectedLight.indirectSpecular += ( 1.0 - clearCoatDHR ) * radiance * BRDF_Specular_GGX_Environment( geometry, material.specularColor, material.specularRoughness );\n\t#ifndef STANDARD\n\t\treflectedLight.indirectSpecular += clearCoatRadiance * material.clearCoat * BRDF_Specular_GGX_Environment( geometry, vec3( DEFAULT_SPECULAR_COEFFICIENT ), material.clearCoatRoughness );\n\t#endif\n}\n#define RE_Direct\t\t\t\tRE_Direct_Physical\n#define RE_Direct_RectArea\t\tRE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular\t\tRE_IndirectSpecular_Physical\n#define Material_BlinnShininessExponent( material )   GGXRoughnessToBlinnExponent( material.specularRoughness )\n#define Material_ClearCoat_BlinnShininessExponent( material )   GGXRoughnessToBlinnExponent( material.clearCoatRoughness )\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n\treturn saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}\n";
	
		var lights_template = "\nGeometricContext geometry;\ngeometry.position = - vViewPosition;\ngeometry.normal = normal;\ngeometry.viewDir = normalize( vViewPosition );\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n\tPointLight pointLight;\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tpointLight = pointLights[ i ];\n\t\tgetPointDirectLightIrradiance( pointLight, geometry, directLight );\n\t\t#ifdef USE_SHADOWMAP\n\t\tdirectLight.color *= all( bvec2( pointLight.shadow, directLight.visible ) ) ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n\tSpotLight spotLight;\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tspotLight = spotLights[ i ];\n\t\tgetSpotDirectLightIrradiance( spotLight, geometry, directLight );\n\t\t#ifdef USE_SHADOWMAP\n\t\tdirectLight.color *= all( bvec2( spotLight.shadow, directLight.visible ) ) ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n\tDirectionalLight directionalLight;\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tdirectionalLight = directionalLights[ i ];\n\t\tgetDirectionalDirectLightIrradiance( directionalLight, geometry, directLight );\n\t\t#ifdef USE_SHADOWMAP\n\t\tdirectLight.color *= all( bvec2( directionalLight.shadow, directLight.visible ) ) ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n\tRectAreaLight rectAreaLight;\n\tfor ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n\t\trectAreaLight = rectAreaLights[ i ];\n\t\tRE_Direct_RectArea( rectAreaLight, geometry, material, reflectedLight );\n\t}\n#endif\n#if defined( RE_IndirectDiffuse )\n\tvec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n\t#ifdef USE_LIGHTMAP\n\t\tvec3 lightMapIrradiance = texture2D( lightMap, vUv2 ).xyz * lightMapIntensity;\n\t\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\t\tlightMapIrradiance *= PI;\n\t\t#endif\n\t\tirradiance += lightMapIrradiance;\n\t#endif\n\t#if ( NUM_HEMI_LIGHTS > 0 )\n\t\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\t\tirradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry );\n\t\t}\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( PHYSICAL ) && defined( ENVMAP_TYPE_CUBE_UV )\n\t\tirradiance += getLightProbeIndirectIrradiance( geometry, 8 );\n\t#endif\n\tRE_IndirectDiffuse( irradiance, geometry, material, reflectedLight );\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n\tvec3 radiance = getLightProbeIndirectRadiance( geometry, Material_BlinnShininessExponent( material ), 8 );\n\t#ifndef STANDARD\n\t\tvec3 clearCoatRadiance = getLightProbeIndirectRadiance( geometry, Material_ClearCoat_BlinnShininessExponent( material ), 8 );\n\t#else\n\t\tvec3 clearCoatRadiance = vec3( 0.0 );\n\t#endif\n\tRE_IndirectSpecular( radiance, clearCoatRadiance, geometry, material, reflectedLight );\n#endif\n";
	
		var logdepthbuf_fragment = "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n\tgl_FragDepthEXT = log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif";
	
		var logdepthbuf_pars_fragment = "#ifdef USE_LOGDEPTHBUF\n\tuniform float logDepthBufFC;\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvarying float vFragDepth;\n\t#endif\n#endif\n";
	
		var logdepthbuf_pars_vertex = "#ifdef USE_LOGDEPTHBUF\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvarying float vFragDepth;\n\t#endif\n\tuniform float logDepthBufFC;\n#endif";
	
		var logdepthbuf_vertex = "#ifdef USE_LOGDEPTHBUF\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvFragDepth = 1.0 + gl_Position.w;\n\t#else\n\t\tgl_Position.z = log2( max( EPSILON, gl_Position.w + 1.0 ) ) * logDepthBufFC - 1.0;\n\t\tgl_Position.z *= gl_Position.w;\n\t#endif\n#endif\n";
	
		var map_fragment = "#ifdef USE_MAP\n\tvec4 texelColor = texture2D( map, vUv );\n\ttexelColor = mapTexelToLinear( texelColor );\n\tdiffuseColor *= texelColor;\n#endif\n";
	
		var map_pars_fragment = "#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif\n";
	
		var map_particle_fragment = "#ifdef USE_MAP\n\tvec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n\tvec4 mapTexel = texture2D( map, uv );\n\tdiffuseColor *= mapTexelToLinear( mapTexel );\n#endif\n";
	
		var map_particle_pars_fragment = "#ifdef USE_MAP\n\tuniform mat3 uvTransform;\n\tuniform sampler2D map;\n#endif\n";
	
		var metalnessmap_fragment = "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n\tvec4 texelMetalness = texture2D( metalnessMap, vUv );\n\tmetalnessFactor *= texelMetalness.b;\n#endif\n";
	
		var metalnessmap_pars_fragment = "#ifdef USE_METALNESSMAP\n\tuniform sampler2D metalnessMap;\n#endif";
	
		var morphnormal_vertex = "#ifdef USE_MORPHNORMALS\n\tobjectNormal += ( morphNormal0 - normal ) * morphTargetInfluences[ 0 ];\n\tobjectNormal += ( morphNormal1 - normal ) * morphTargetInfluences[ 1 ];\n\tobjectNormal += ( morphNormal2 - normal ) * morphTargetInfluences[ 2 ];\n\tobjectNormal += ( morphNormal3 - normal ) * morphTargetInfluences[ 3 ];\n#endif\n";
	
		var morphtarget_pars_vertex = "#ifdef USE_MORPHTARGETS\n\t#ifndef USE_MORPHNORMALS\n\tuniform float morphTargetInfluences[ 8 ];\n\t#else\n\tuniform float morphTargetInfluences[ 4 ];\n\t#endif\n#endif";
	
		var morphtarget_vertex = "#ifdef USE_MORPHTARGETS\n\ttransformed += ( morphTarget0 - position ) * morphTargetInfluences[ 0 ];\n\ttransformed += ( morphTarget1 - position ) * morphTargetInfluences[ 1 ];\n\ttransformed += ( morphTarget2 - position ) * morphTargetInfluences[ 2 ];\n\ttransformed += ( morphTarget3 - position ) * morphTargetInfluences[ 3 ];\n\t#ifndef USE_MORPHNORMALS\n\ttransformed += ( morphTarget4 - position ) * morphTargetInfluences[ 4 ];\n\ttransformed += ( morphTarget5 - position ) * morphTargetInfluences[ 5 ];\n\ttransformed += ( morphTarget6 - position ) * morphTargetInfluences[ 6 ];\n\ttransformed += ( morphTarget7 - position ) * morphTargetInfluences[ 7 ];\n\t#endif\n#endif\n";
	
		var normal_fragment = "#ifdef FLAT_SHADED\n\tvec3 fdx = vec3( dFdx( vViewPosition.x ), dFdx( vViewPosition.y ), dFdx( vViewPosition.z ) );\n\tvec3 fdy = vec3( dFdy( vViewPosition.x ), dFdy( vViewPosition.y ), dFdy( vViewPosition.z ) );\n\tvec3 normal = normalize( cross( fdx, fdy ) );\n#else\n\tvec3 normal = normalize( vNormal );\n\t#ifdef DOUBLE_SIDED\n\t\tnormal = normal * ( float( gl_FrontFacing ) * 2.0 - 1.0 );\n\t#endif\n#endif\n#ifdef USE_NORMALMAP\n\tnormal = perturbNormal2Arb( -vViewPosition, normal );\n#elif defined( USE_BUMPMAP )\n\tnormal = perturbNormalArb( -vViewPosition, normal, dHdxy_fwd() );\n#endif\n";
	
		var normalmap_pars_fragment = "#ifdef USE_NORMALMAP\n\tuniform sampler2D normalMap;\n\tuniform vec2 normalScale;\n\tvec3 perturbNormal2Arb( vec3 eye_pos, vec3 surf_norm ) {\n\t\tvec3 q0 = vec3( dFdx( eye_pos.x ), dFdx( eye_pos.y ), dFdx( eye_pos.z ) );\n\t\tvec3 q1 = vec3( dFdy( eye_pos.x ), dFdy( eye_pos.y ), dFdy( eye_pos.z ) );\n\t\tvec2 st0 = dFdx( vUv.st );\n\t\tvec2 st1 = dFdy( vUv.st );\n\t\tvec3 S = normalize( q0 * st1.t - q1 * st0.t );\n\t\tvec3 T = normalize( -q0 * st1.s + q1 * st0.s );\n\t\tvec3 N = normalize( surf_norm );\n\t\tvec3 mapN = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;\n\t\tmapN.xy = normalScale * mapN.xy;\n\t\tmat3 tsn = mat3( S, T, N );\n\t\treturn normalize( tsn * mapN );\n\t}\n#endif\n";
	
		var packing = "vec3 packNormalToRGB( const in vec3 normal ) {\n\treturn normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n\treturn 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;\nconst vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256.,  256. );\nconst vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );\nconst float ShiftRight8 = 1. / 256.;\nvec4 packDepthToRGBA( const in float v ) {\n\tvec4 r = vec4( fract( v * PackFactors ), v );\n\tr.yzw -= r.xyz * ShiftRight8;\treturn r * PackUpscale;\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n\treturn dot( v, UnpackFactors );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float linearClipZ, const in float near, const in float far ) {\n\treturn linearClipZ * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn (( near + viewZ ) * far ) / (( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float invClipZ, const in float near, const in float far ) {\n\treturn ( near * far ) / ( ( far - near ) * invClipZ - far );\n}\n";
	
		var premultiplied_alpha_fragment = "#ifdef PREMULTIPLIED_ALPHA\n\tgl_FragColor.rgb *= gl_FragColor.a;\n#endif\n";
	
		var project_vertex = "vec4 mvPosition = modelViewMatrix * vec4( transformed, 1.0 );\ngl_Position = projectionMatrix * mvPosition;\n";
	
		var dithering_fragment = "#if defined( DITHERING )\n  gl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif\n";
	
		var dithering_pars_fragment = "#if defined( DITHERING )\n\tvec3 dithering( vec3 color ) {\n\t\tfloat grid_position = rand( gl_FragCoord.xy );\n\t\tvec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n\t\tdither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n\t\treturn color + dither_shift_RGB;\n\t}\n#endif\n";
	
		var roughnessmap_fragment = "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n\tvec4 texelRoughness = texture2D( roughnessMap, vUv );\n\troughnessFactor *= texelRoughness.g;\n#endif\n";
	
		var roughnessmap_pars_fragment = "#ifdef USE_ROUGHNESSMAP\n\tuniform sampler2D roughnessMap;\n#endif";
	
		var shadowmap_pars_fragment = "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHTS > 0\n\t\tuniform sampler2D directionalShadowMap[ NUM_DIR_LIGHTS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHTS ];\n\t#endif\n\t#if NUM_SPOT_LIGHTS > 0\n\t\tuniform sampler2D spotShadowMap[ NUM_SPOT_LIGHTS ];\n\t\tvarying vec4 vSpotShadowCoord[ NUM_SPOT_LIGHTS ];\n\t#endif\n\t#if NUM_POINT_LIGHTS > 0\n\t\tuniform sampler2D pointShadowMap[ NUM_POINT_LIGHTS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHTS ];\n\t#endif\n\tfloat texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n\t\treturn step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n\t}\n\tfloat texture2DShadowLerp( sampler2D depths, vec2 size, vec2 uv, float compare ) {\n\t\tconst vec2 offset = vec2( 0.0, 1.0 );\n\t\tvec2 texelSize = vec2( 1.0 ) / size;\n\t\tvec2 centroidUV = floor( uv * size + 0.5 ) / size;\n\t\tfloat lb = texture2DCompare( depths, centroidUV + texelSize * offset.xx, compare );\n\t\tfloat lt = texture2DCompare( depths, centroidUV + texelSize * offset.xy, compare );\n\t\tfloat rb = texture2DCompare( depths, centroidUV + texelSize * offset.yx, compare );\n\t\tfloat rt = texture2DCompare( depths, centroidUV + texelSize * offset.yy, compare );\n\t\tvec2 f = fract( uv * size + 0.5 );\n\t\tfloat a = mix( lb, lt, f.y );\n\t\tfloat b = mix( rb, rt, f.y );\n\t\tfloat c = mix( a, b, f.x );\n\t\treturn c;\n\t}\n\tfloat getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\tfloat shadow = 1.0;\n\t\tshadowCoord.xyz /= shadowCoord.w;\n\t\tshadowCoord.z += shadowBias;\n\t\tbvec4 inFrustumVec = bvec4 ( shadowCoord.x >= 0.0, shadowCoord.x <= 1.0, shadowCoord.y >= 0.0, shadowCoord.y <= 1.0 );\n\t\tbool inFrustum = all( inFrustumVec );\n\t\tbvec2 frustumTestVec = bvec2( inFrustum, shadowCoord.z <= 1.0 );\n\t\tbool frustumTest = all( frustumTestVec );\n\t\tif ( frustumTest ) {\n\t\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx0 = - texelSize.x * shadowRadius;\n\t\t\tfloat dy0 = - texelSize.y * shadowRadius;\n\t\t\tfloat dx1 = + texelSize.x * shadowRadius;\n\t\t\tfloat dy1 = + texelSize.y * shadowRadius;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx0 = - texelSize.x * shadowRadius;\n\t\t\tfloat dy0 = - texelSize.y * shadowRadius;\n\t\t\tfloat dx1 = + texelSize.x * shadowRadius;\n\t\t\tfloat dy1 = + texelSize.y * shadowRadius;\n\t\t\tshadow = (\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy, shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#else\n\t\t\tshadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#endif\n\t\t}\n\t\treturn shadow;\n\t}\n\tvec2 cubeToUV( vec3 v, float texelSizeY ) {\n\t\tvec3 absV = abs( v );\n\t\tfloat scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n\t\tabsV *= scaleToCube;\n\t\tv *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n\t\tvec2 planar = v.xy;\n\t\tfloat almostATexel = 1.5 * texelSizeY;\n\t\tfloat almostOne = 1.0 - almostATexel;\n\t\tif ( absV.z >= almostOne ) {\n\t\t\tif ( v.z > 0.0 )\n\t\t\t\tplanar.x = 4.0 - v.x;\n\t\t} else if ( absV.x >= almostOne ) {\n\t\t\tfloat signX = sign( v.x );\n\t\t\tplanar.x = v.z * signX + 2.0 * signX;\n\t\t} else if ( absV.y >= almostOne ) {\n\t\t\tfloat signY = sign( v.y );\n\t\t\tplanar.x = v.x + 2.0 * signY + 2.0;\n\t\t\tplanar.y = v.z * signY - 2.0;\n\t\t}\n\t\treturn vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n\t}\n\tfloat getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n\t\tvec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n\t\tvec3 lightToPosition = shadowCoord.xyz;\n\t\tfloat dp = ( length( lightToPosition ) - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );\t\tdp += shadowBias;\n\t\tvec3 bd3D = normalize( lightToPosition );\n\t\t#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT )\n\t\t\tvec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n\t\t\treturn (\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#else\n\t\t\treturn texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n\t\t#endif\n\t}\n#endif\n";
	
		var shadowmap_pars_vertex = "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHTS > 0\n\t\tuniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHTS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHTS ];\n\t#endif\n\t#if NUM_SPOT_LIGHTS > 0\n\t\tuniform mat4 spotShadowMatrix[ NUM_SPOT_LIGHTS ];\n\t\tvarying vec4 vSpotShadowCoord[ NUM_SPOT_LIGHTS ];\n\t#endif\n\t#if NUM_POINT_LIGHTS > 0\n\t\tuniform mat4 pointShadowMatrix[ NUM_POINT_LIGHTS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHTS ];\n\t#endif\n#endif\n";
	
		var shadowmap_vertex = "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHTS > 0\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tvDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * worldPosition;\n\t}\n\t#endif\n\t#if NUM_SPOT_LIGHTS > 0\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tvSpotShadowCoord[ i ] = spotShadowMatrix[ i ] * worldPosition;\n\t}\n\t#endif\n\t#if NUM_POINT_LIGHTS > 0\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tvPointShadowCoord[ i ] = pointShadowMatrix[ i ] * worldPosition;\n\t}\n\t#endif\n#endif\n";
	
		var shadowmask_pars_fragment = "float getShadowMask() {\n\tfloat shadow = 1.0;\n\t#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHTS > 0\n\tDirectionalLight directionalLight;\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tdirectionalLight = directionalLights[ i ];\n\t\tshadow *= bool( directionalLight.shadow ) ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t}\n\t#endif\n\t#if NUM_SPOT_LIGHTS > 0\n\tSpotLight spotLight;\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tspotLight = spotLights[ i ];\n\t\tshadow *= bool( spotLight.shadow ) ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotShadowCoord[ i ] ) : 1.0;\n\t}\n\t#endif\n\t#if NUM_POINT_LIGHTS > 0\n\tPointLight pointLight;\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tpointLight = pointLights[ i ];\n\t\tshadow *= bool( pointLight.shadow ) ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n\t}\n\t#endif\n\t#endif\n\treturn shadow;\n}\n";
	
		var skinbase_vertex = "#ifdef USE_SKINNING\n\tmat4 boneMatX = getBoneMatrix( skinIndex.x );\n\tmat4 boneMatY = getBoneMatrix( skinIndex.y );\n\tmat4 boneMatZ = getBoneMatrix( skinIndex.z );\n\tmat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif";
	
		var skinning_pars_vertex = "#ifdef USE_SKINNING\n\tuniform mat4 bindMatrix;\n\tuniform mat4 bindMatrixInverse;\n\t#ifdef BONE_TEXTURE\n\t\tuniform sampler2D boneTexture;\n\t\tuniform int boneTextureSize;\n\t\tmat4 getBoneMatrix( const in float i ) {\n\t\t\tfloat j = i * 4.0;\n\t\t\tfloat x = mod( j, float( boneTextureSize ) );\n\t\t\tfloat y = floor( j / float( boneTextureSize ) );\n\t\t\tfloat dx = 1.0 / float( boneTextureSize );\n\t\t\tfloat dy = 1.0 / float( boneTextureSize );\n\t\t\ty = dy * ( y + 0.5 );\n\t\t\tvec4 v1 = texture2D( boneTexture, vec2( dx * ( x + 0.5 ), y ) );\n\t\t\tvec4 v2 = texture2D( boneTexture, vec2( dx * ( x + 1.5 ), y ) );\n\t\t\tvec4 v3 = texture2D( boneTexture, vec2( dx * ( x + 2.5 ), y ) );\n\t\t\tvec4 v4 = texture2D( boneTexture, vec2( dx * ( x + 3.5 ), y ) );\n\t\t\tmat4 bone = mat4( v1, v2, v3, v4 );\n\t\t\treturn bone;\n\t\t}\n\t#else\n\t\tuniform mat4 boneMatrices[ MAX_BONES ];\n\t\tmat4 getBoneMatrix( const in float i ) {\n\t\t\tmat4 bone = boneMatrices[ int(i) ];\n\t\t\treturn bone;\n\t\t}\n\t#endif\n#endif\n";
	
		var skinning_vertex = "#ifdef USE_SKINNING\n\tvec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n\tvec4 skinned = vec4( 0.0 );\n\tskinned += boneMatX * skinVertex * skinWeight.x;\n\tskinned += boneMatY * skinVertex * skinWeight.y;\n\tskinned += boneMatZ * skinVertex * skinWeight.z;\n\tskinned += boneMatW * skinVertex * skinWeight.w;\n\ttransformed = ( bindMatrixInverse * skinned ).xyz;\n#endif\n";
	
		var skinnormal_vertex = "#ifdef USE_SKINNING\n\tmat4 skinMatrix = mat4( 0.0 );\n\tskinMatrix += skinWeight.x * boneMatX;\n\tskinMatrix += skinWeight.y * boneMatY;\n\tskinMatrix += skinWeight.z * boneMatZ;\n\tskinMatrix += skinWeight.w * boneMatW;\n\tskinMatrix  = bindMatrixInverse * skinMatrix * bindMatrix;\n\tobjectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n#endif\n";
	
		var specularmap_fragment = "float specularStrength;\n#ifdef USE_SPECULARMAP\n\tvec4 texelSpecular = texture2D( specularMap, vUv );\n\tspecularStrength = texelSpecular.r;\n#else\n\tspecularStrength = 1.0;\n#endif";
	
		var specularmap_pars_fragment = "#ifdef USE_SPECULARMAP\n\tuniform sampler2D specularMap;\n#endif";
	
		var tonemapping_fragment = "#if defined( TONE_MAPPING )\n  gl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif\n";
	
		var tonemapping_pars_fragment = "#ifndef saturate\n\t#define saturate(a) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nuniform float toneMappingWhitePoint;\nvec3 LinearToneMapping( vec3 color ) {\n\treturn toneMappingExposure * color;\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\treturn saturate( color / ( vec3( 1.0 ) + color ) );\n}\n#define Uncharted2Helper( x ) max( ( ( x * ( 0.15 * x + 0.10 * 0.50 ) + 0.20 * 0.02 ) / ( x * ( 0.15 * x + 0.50 ) + 0.20 * 0.30 ) ) - 0.02 / 0.30, vec3( 0.0 ) )\nvec3 Uncharted2ToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\treturn saturate( Uncharted2Helper( color ) / Uncharted2Helper( vec3( toneMappingWhitePoint ) ) );\n}\nvec3 OptimizedCineonToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\tcolor = max( vec3( 0.0 ), color - 0.004 );\n\treturn pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\n";
	
		var uv_pars_fragment = "#if defined( USE_MAP ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( USE_SPECULARMAP ) || defined( USE_ALPHAMAP ) || defined( USE_EMISSIVEMAP ) || defined( USE_ROUGHNESSMAP ) || defined( USE_METALNESSMAP )\n\tvarying vec2 vUv;\n#endif";
	
		var uv_pars_vertex = "#if defined( USE_MAP ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( USE_SPECULARMAP ) || defined( USE_ALPHAMAP ) || defined( USE_EMISSIVEMAP ) || defined( USE_ROUGHNESSMAP ) || defined( USE_METALNESSMAP )\n\tvarying vec2 vUv;\n\tuniform mat3 uvTransform;\n#endif\n";
	
		var uv_vertex = "#if defined( USE_MAP ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( USE_SPECULARMAP ) || defined( USE_ALPHAMAP ) || defined( USE_EMISSIVEMAP ) || defined( USE_ROUGHNESSMAP ) || defined( USE_METALNESSMAP )\n\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n#endif";
	
		var uv2_pars_fragment = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tvarying vec2 vUv2;\n#endif";
	
		var uv2_pars_vertex = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tattribute vec2 uv2;\n\tvarying vec2 vUv2;\n#endif";
	
		var uv2_vertex = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tvUv2 = uv2;\n#endif";
	
		var worldpos_vertex = "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP )\n\tvec4 worldPosition = modelMatrix * vec4( transformed, 1.0 );\n#endif\n";
	
		var cube_frag = "uniform samplerCube tCube;\nuniform float tFlip;\nuniform float opacity;\nvarying vec3 vWorldPosition;\nvoid main() {\n\tgl_FragColor = textureCube( tCube, vec3( tFlip * vWorldPosition.x, vWorldPosition.yz ) );\n\tgl_FragColor.a *= opacity;\n}\n";
	
		var cube_vert = "varying vec3 vWorldPosition;\n#include <common>\nvoid main() {\n\tvWorldPosition = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}\n";
	
		var depth_frag = "#if DEPTH_PACKING == 3200\n\tuniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#if DEPTH_PACKING == 3200\n\t\tdiffuseColor.a = opacity;\n\t#endif\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <logdepthbuf_fragment>\n\t#if DEPTH_PACKING == 3200\n\t\tgl_FragColor = vec4( vec3( gl_FragCoord.z ), opacity );\n\t#elif DEPTH_PACKING == 3201\n\t\tgl_FragColor = packDepthToRGBA( gl_FragCoord.z );\n\t#endif\n}\n";
	
		var depth_vert = "#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n}\n";
	
		var distanceRGBA_frag = "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\tfloat dist = length( vWorldPosition - referencePosition );\n\tdist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n\tdist = saturate( dist );\n\tgl_FragColor = packDepthToRGBA( dist );\n}\n";
	
		var distanceRGBA_vert = "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\tvWorldPosition = worldPosition.xyz;\n}\n";
	
		var equirect_frag = "uniform sampler2D tEquirect;\nvarying vec3 vWorldPosition;\n#include <common>\nvoid main() {\n\tvec3 direction = normalize( vWorldPosition );\n\tvec2 sampleUV;\n\tsampleUV.y = asin( clamp( direction.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n\tsampleUV.x = atan( direction.z, direction.x ) * RECIPROCAL_PI2 + 0.5;\n\tgl_FragColor = texture2D( tEquirect, sampleUV );\n}\n";
	
		var equirect_vert = "varying vec3 vWorldPosition;\n#include <common>\nvoid main() {\n\tvWorldPosition = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n}\n";
	
		var linedashed_frag = "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tif ( mod( vLineDistance, totalSize ) > dashSize ) {\n\t\tdiscard;\n\t}\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <color_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <premultiplied_alpha_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}\n";
	
		var linedashed_vert = "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <color_vertex>\n\tvLineDistance = scale * lineDistance;\n\tvec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );\n\tgl_Position = projectionMatrix * mvPosition;\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}\n";
	
		var meshbasic_frag = "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\t#ifdef USE_LIGHTMAP\n\t\treflectedLight.indirectDiffuse += texture2D( lightMap, vUv2 ).xyz * lightMapIntensity;\n\t#else\n\t\treflectedLight.indirectDiffuse += vec3( 1.0 );\n\t#endif\n\t#include <aomap_fragment>\n\treflectedLight.indirectDiffuse *= diffuseColor.rgb;\n\tvec3 outgoingLight = reflectedLight.indirectDiffuse;\n\t#include <envmap_fragment>\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <premultiplied_alpha_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}\n";
	
		var meshbasic_vert = "#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_ENVMAP\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <envmap_vertex>\n\t#include <fog_vertex>\n}\n";
	
		var meshlambert_frag = "uniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\nvarying vec3 vLightFront;\n#ifdef DOUBLE_SIDED\n\tvarying vec3 vLightBack;\n#endif\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_pars_fragment>\n#include <bsdfs>\n#include <lights_pars>\n#include <fog_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\t#include <emissivemap_fragment>\n\treflectedLight.indirectDiffuse = getAmbientLightIrradiance( ambientLightColor );\n\t#include <lightmap_fragment>\n\treflectedLight.indirectDiffuse *= BRDF_Diffuse_Lambert( diffuseColor.rgb );\n\t#ifdef DOUBLE_SIDED\n\t\treflectedLight.directDiffuse = ( gl_FrontFacing ) ? vLightFront : vLightBack;\n\t#else\n\t\treflectedLight.directDiffuse = vLightFront;\n\t#endif\n\treflectedLight.directDiffuse *= BRDF_Diffuse_Lambert( diffuseColor.rgb ) * getShadowMask();\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}\n";
	
		var meshlambert_vert = "#define LAMBERT\nvarying vec3 vLightFront;\n#ifdef DOUBLE_SIDED\n\tvarying vec3 vLightBack;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <envmap_pars_vertex>\n#include <bsdfs>\n#include <lights_pars>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <lights_lambert_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}\n";
	
		var meshphong_frag = "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment>\n\t#include <emissivemap_fragment>\n\t#include <lights_phong_fragment>\n\t#include <lights_template>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}\n";
	
		var meshphong_vert = "#define PHONG\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}\n";
	
		var meshphysical_frag = "#define PHYSICAL\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifndef STANDARD\n\tuniform float clearCoat;\n\tuniform float clearCoatRoughness;\n#endif\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <cube_uv_reflection_fragment>\n#include <lights_pars>\n#include <lights_physical_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <roughnessmap_fragment>\n\t#include <metalnessmap_fragment>\n\t#include <normal_fragment>\n\t#include <emissivemap_fragment>\n\t#include <lights_physical_fragment>\n\t#include <lights_template>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}\n";
	
		var meshphysical_vert = "#define PHYSICAL\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}\n";
	
		var normal_frag = "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP )\n\tvarying vec3 vViewPosition;\n#endif\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\nvoid main() {\n\t#include <logdepthbuf_fragment>\n\t#include <normal_fragment>\n\tgl_FragColor = vec4( packNormalToRGB( normal ), opacity );\n}\n";
	
		var normal_vert = "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP )\n\tvarying vec3 vViewPosition;\n#endif\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP )\n\tvViewPosition = - mvPosition.xyz;\n#endif\n}\n";
	
		var points_frag = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <fog_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_particle_fragment>\n\t#include <color_fragment>\n\t#include <alphatest_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <premultiplied_alpha_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}\n";
	
		var points_vert = "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <color_vertex>\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\t#ifdef USE_SIZEATTENUATION\n\t\tgl_PointSize = size * ( scale / - mvPosition.z );\n\t#else\n\t\tgl_PointSize = size;\n\t#endif\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}\n";
	
		var shadow_frag = "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n\tgl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n\t#include <fog_fragment>\n}\n";
	
		var shadow_vert = "#include <fog_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}\n";
	
		var ShaderChunk = {
			alphamap_fragment: alphamap_fragment,
			alphamap_pars_fragment: alphamap_pars_fragment,
			alphatest_fragment: alphatest_fragment,
			aomap_fragment: aomap_fragment,
			aomap_pars_fragment: aomap_pars_fragment,
			begin_vertex: begin_vertex,
			beginnormal_vertex: beginnormal_vertex,
			bsdfs: bsdfs,
			bumpmap_pars_fragment: bumpmap_pars_fragment,
			clipping_planes_fragment: clipping_planes_fragment,
			clipping_planes_pars_fragment: clipping_planes_pars_fragment,
			clipping_planes_pars_vertex: clipping_planes_pars_vertex,
			clipping_planes_vertex: clipping_planes_vertex,
			color_fragment: color_fragment,
			color_pars_fragment: color_pars_fragment,
			color_pars_vertex: color_pars_vertex,
			color_vertex: color_vertex,
			common: common,
			cube_uv_reflection_fragment: cube_uv_reflection_fragment,
			defaultnormal_vertex: defaultnormal_vertex,
			displacementmap_pars_vertex: displacementmap_pars_vertex,
			displacementmap_vertex: displacementmap_vertex,
			emissivemap_fragment: emissivemap_fragment,
			emissivemap_pars_fragment: emissivemap_pars_fragment,
			encodings_fragment: encodings_fragment,
			encodings_pars_fragment: encodings_pars_fragment,
			envmap_fragment: envmap_fragment,
			envmap_pars_fragment: envmap_pars_fragment,
			envmap_pars_vertex: envmap_pars_vertex,
			envmap_vertex: envmap_vertex,
			fog_vertex: fog_vertex,
			fog_pars_vertex: fog_pars_vertex,
			fog_fragment: fog_fragment,
			fog_pars_fragment: fog_pars_fragment,
			gradientmap_pars_fragment: gradientmap_pars_fragment,
			lightmap_fragment: lightmap_fragment,
			lightmap_pars_fragment: lightmap_pars_fragment,
			lights_lambert_vertex: lights_lambert_vertex,
			lights_pars: lights_pars,
			lights_phong_fragment: lights_phong_fragment,
			lights_phong_pars_fragment: lights_phong_pars_fragment,
			lights_physical_fragment: lights_physical_fragment,
			lights_physical_pars_fragment: lights_physical_pars_fragment,
			lights_template: lights_template,
			logdepthbuf_fragment: logdepthbuf_fragment,
			logdepthbuf_pars_fragment: logdepthbuf_pars_fragment,
			logdepthbuf_pars_vertex: logdepthbuf_pars_vertex,
			logdepthbuf_vertex: logdepthbuf_vertex,
			map_fragment: map_fragment,
			map_pars_fragment: map_pars_fragment,
			map_particle_fragment: map_particle_fragment,
			map_particle_pars_fragment: map_particle_pars_fragment,
			metalnessmap_fragment: metalnessmap_fragment,
			metalnessmap_pars_fragment: metalnessmap_pars_fragment,
			morphnormal_vertex: morphnormal_vertex,
			morphtarget_pars_vertex: morphtarget_pars_vertex,
			morphtarget_vertex: morphtarget_vertex,
			normal_fragment: normal_fragment,
			normalmap_pars_fragment: normalmap_pars_fragment,
			packing: packing,
			premultiplied_alpha_fragment: premultiplied_alpha_fragment,
			project_vertex: project_vertex,
			dithering_fragment: dithering_fragment,
			dithering_pars_fragment: dithering_pars_fragment,
			roughnessmap_fragment: roughnessmap_fragment,
			roughnessmap_pars_fragment: roughnessmap_pars_fragment,
			shadowmap_pars_fragment: shadowmap_pars_fragment,
			shadowmap_pars_vertex: shadowmap_pars_vertex,
			shadowmap_vertex: shadowmap_vertex,
			shadowmask_pars_fragment: shadowmask_pars_fragment,
			skinbase_vertex: skinbase_vertex,
			skinning_pars_vertex: skinning_pars_vertex,
			skinning_vertex: skinning_vertex,
			skinnormal_vertex: skinnormal_vertex,
			specularmap_fragment: specularmap_fragment,
			specularmap_pars_fragment: specularmap_pars_fragment,
			tonemapping_fragment: tonemapping_fragment,
			tonemapping_pars_fragment: tonemapping_pars_fragment,
			uv_pars_fragment: uv_pars_fragment,
			uv_pars_vertex: uv_pars_vertex,
			uv_vertex: uv_vertex,
			uv2_pars_fragment: uv2_pars_fragment,
			uv2_pars_vertex: uv2_pars_vertex,
			uv2_vertex: uv2_vertex,
			worldpos_vertex: worldpos_vertex,
	
			cube_frag: cube_frag,
			cube_vert: cube_vert,
			depth_frag: depth_frag,
			depth_vert: depth_vert,
			distanceRGBA_frag: distanceRGBA_frag,
			distanceRGBA_vert: distanceRGBA_vert,
			equirect_frag: equirect_frag,
			equirect_vert: equirect_vert,
			linedashed_frag: linedashed_frag,
			linedashed_vert: linedashed_vert,
			meshbasic_frag: meshbasic_frag,
			meshbasic_vert: meshbasic_vert,
			meshlambert_frag: meshlambert_frag,
			meshlambert_vert: meshlambert_vert,
			meshphong_frag: meshphong_frag,
			meshphong_vert: meshphong_vert,
			meshphysical_frag: meshphysical_frag,
			meshphysical_vert: meshphysical_vert,
			normal_frag: normal_frag,
			normal_vert: normal_vert,
			points_frag: points_frag,
			points_vert: points_vert,
			shadow_frag: shadow_frag,
			shadow_vert: shadow_vert
		};
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 * @author mrdoob / http://mrdoob.com/
		 * @author mikael emtinger / http://gomo.se/
		 */
	
		var ShaderLib = {
	
			basic: {
	
				uniforms: UniformsUtils.merge( [
					UniformsLib.common,
					UniformsLib.specularmap,
					UniformsLib.envmap,
					UniformsLib.aomap,
					UniformsLib.lightmap,
					UniformsLib.fog
				] ),
	
				vertexShader: ShaderChunk.meshbasic_vert,
				fragmentShader: ShaderChunk.meshbasic_frag
	
			},
	
			lambert: {
	
				uniforms: UniformsUtils.merge( [
					UniformsLib.common,
					UniformsLib.specularmap,
					UniformsLib.envmap,
					UniformsLib.aomap,
					UniformsLib.lightmap,
					UniformsLib.emissivemap,
					UniformsLib.fog,
					UniformsLib.lights,
					{
						emissive: { value: new Color( 0x000000 ) }
					}
				] ),
	
				vertexShader: ShaderChunk.meshlambert_vert,
				fragmentShader: ShaderChunk.meshlambert_frag
	
			},
	
			phong: {
	
				uniforms: UniformsUtils.merge( [
					UniformsLib.common,
					UniformsLib.specularmap,
					UniformsLib.envmap,
					UniformsLib.aomap,
					UniformsLib.lightmap,
					UniformsLib.emissivemap,
					UniformsLib.bumpmap,
					UniformsLib.normalmap,
					UniformsLib.displacementmap,
					UniformsLib.gradientmap,
					UniformsLib.fog,
					UniformsLib.lights,
					{
						emissive: { value: new Color( 0x000000 ) },
						specular: { value: new Color( 0x111111 ) },
						shininess: { value: 30 }
					}
				] ),
	
				vertexShader: ShaderChunk.meshphong_vert,
				fragmentShader: ShaderChunk.meshphong_frag
	
			},
	
			standard: {
	
				uniforms: UniformsUtils.merge( [
					UniformsLib.common,
					UniformsLib.envmap,
					UniformsLib.aomap,
					UniformsLib.lightmap,
					UniformsLib.emissivemap,
					UniformsLib.bumpmap,
					UniformsLib.normalmap,
					UniformsLib.displacementmap,
					UniformsLib.roughnessmap,
					UniformsLib.metalnessmap,
					UniformsLib.fog,
					UniformsLib.lights,
					{
						emissive: { value: new Color( 0x000000 ) },
						roughness: { value: 0.5 },
						metalness: { value: 0.5 },
						envMapIntensity: { value: 1 } // temporary
					}
				] ),
	
				vertexShader: ShaderChunk.meshphysical_vert,
				fragmentShader: ShaderChunk.meshphysical_frag
	
			},
	
			points: {
	
				uniforms: UniformsUtils.merge( [
					UniformsLib.points,
					UniformsLib.fog
				] ),
	
				vertexShader: ShaderChunk.points_vert,
				fragmentShader: ShaderChunk.points_frag
	
			},
	
			dashed: {
	
				uniforms: UniformsUtils.merge( [
					UniformsLib.common,
					UniformsLib.fog,
					{
						scale: { value: 1 },
						dashSize: { value: 1 },
						totalSize: { value: 2 }
					}
				] ),
	
				vertexShader: ShaderChunk.linedashed_vert,
				fragmentShader: ShaderChunk.linedashed_frag
	
			},
	
			depth: {
	
				uniforms: UniformsUtils.merge( [
					UniformsLib.common,
					UniformsLib.displacementmap
				] ),
	
				vertexShader: ShaderChunk.depth_vert,
				fragmentShader: ShaderChunk.depth_frag
	
			},
	
			normal: {
	
				uniforms: UniformsUtils.merge( [
					UniformsLib.common,
					UniformsLib.bumpmap,
					UniformsLib.normalmap,
					UniformsLib.displacementmap,
					{
						opacity: { value: 1.0 }
					}
				] ),
	
				vertexShader: ShaderChunk.normal_vert,
				fragmentShader: ShaderChunk.normal_frag
	
			},
	
			/* -------------------------------------------------------------------------
			//	Cube map shader
			 ------------------------------------------------------------------------- */
	
			cube: {
	
				uniforms: {
					tCube: { value: null },
					tFlip: { value: - 1 },
					opacity: { value: 1.0 }
				},
	
				vertexShader: ShaderChunk.cube_vert,
				fragmentShader: ShaderChunk.cube_frag
	
			},
	
			equirect: {
	
				uniforms: {
					tEquirect: { value: null },
				},
	
				vertexShader: ShaderChunk.equirect_vert,
				fragmentShader: ShaderChunk.equirect_frag
	
			},
	
			distanceRGBA: {
	
				uniforms: UniformsUtils.merge( [
					UniformsLib.common,
					UniformsLib.displacementmap,
					{
						referencePosition: { value: new Vector3() },
						nearDistance: { value: 1 },
						farDistance: { value: 1000 }
					}
				] ),
	
				vertexShader: ShaderChunk.distanceRGBA_vert,
				fragmentShader: ShaderChunk.distanceRGBA_frag
	
			},
	
			shadow: {
	
				uniforms: UniformsUtils.merge( [
					UniformsLib.lights,
					UniformsLib.fog,
					{
						color: { value: new Color( 0x00000 ) },
						opacity: { value: 1.0 }
					},
				] ),
	
				vertexShader: ShaderChunk.shadow_vert,
				fragmentShader: ShaderChunk.shadow_frag
	
			}
	
		};
	
		ShaderLib.physical = {
	
			uniforms: UniformsUtils.merge( [
				ShaderLib.standard.uniforms,
				{
					clearCoat: { value: 0 },
					clearCoatRoughness: { value: 0 }
				}
			] ),
	
			vertexShader: ShaderChunk.meshphysical_vert,
			fragmentShader: ShaderChunk.meshphysical_frag
	
		};
	
		/**
		 * @author bhouston / http://clara.io
		 */
	
		function Box2( min, max ) {
	
			this.min = ( min !== undefined ) ? min : new Vector2( + Infinity, + Infinity );
			this.max = ( max !== undefined ) ? max : new Vector2( - Infinity, - Infinity );
	
		}
	
		Object.assign( Box2.prototype, {
	
			set: function ( min, max ) {
	
				this.min.copy( min );
				this.max.copy( max );
	
				return this;
	
			},
	
			setFromPoints: function ( points ) {
	
				this.makeEmpty();
	
				for ( var i = 0, il = points.length; i < il; i ++ ) {
	
					this.expandByPoint( points[ i ] );
	
				}
	
				return this;
	
			},
	
			setFromCenterAndSize: function () {
	
				var v1 = new Vector2();
	
				return function setFromCenterAndSize( center, size ) {
	
					var halfSize = v1.copy( size ).multiplyScalar( 0.5 );
					this.min.copy( center ).sub( halfSize );
					this.max.copy( center ).add( halfSize );
	
					return this;
	
				};
	
			}(),
	
			clone: function () {
	
				return new this.constructor().copy( this );
	
			},
	
			copy: function ( box ) {
	
				this.min.copy( box.min );
				this.max.copy( box.max );
	
				return this;
	
			},
	
			makeEmpty: function () {
	
				this.min.x = this.min.y = + Infinity;
				this.max.x = this.max.y = - Infinity;
	
				return this;
	
			},
	
			isEmpty: function () {
	
				// this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
	
				return ( this.max.x < this.min.x ) || ( this.max.y < this.min.y );
	
			},
	
			getCenter: function ( optionalTarget ) {
	
				var result = optionalTarget || new Vector2();
				return this.isEmpty() ? result.set( 0, 0 ) : result.addVectors( this.min, this.max ).multiplyScalar( 0.5 );
	
			},
	
			getSize: function ( optionalTarget ) {
	
				var result = optionalTarget || new Vector2();
				return this.isEmpty() ? result.set( 0, 0 ) : result.subVectors( this.max, this.min );
	
			},
	
			expandByPoint: function ( point ) {
	
				this.min.min( point );
				this.max.max( point );
	
				return this;
	
			},
	
			expandByVector: function ( vector ) {
	
				this.min.sub( vector );
				this.max.add( vector );
	
				return this;
	
			},
	
			expandByScalar: function ( scalar ) {
	
				this.min.addScalar( - scalar );
				this.max.addScalar( scalar );
	
				return this;
	
			},
	
			containsPoint: function ( point ) {
	
				return point.x < this.min.x || point.x > this.max.x ||
					point.y < this.min.y || point.y > this.max.y ? false : true;
	
			},
	
			containsBox: function ( box ) {
	
				return this.min.x <= box.min.x && box.max.x <= this.max.x &&
					this.min.y <= box.min.y && box.max.y <= this.max.y;
	
			},
	
			getParameter: function ( point, optionalTarget ) {
	
				// This can potentially have a divide by zero if the box
				// has a size dimension of 0.
	
				var result = optionalTarget || new Vector2();
	
				return result.set(
					( point.x - this.min.x ) / ( this.max.x - this.min.x ),
					( point.y - this.min.y ) / ( this.max.y - this.min.y )
				);
	
			},
	
			intersectsBox: function ( box ) {
	
				// using 4 splitting planes to rule out intersections
	
				return box.max.x < this.min.x || box.min.x > this.max.x ||
					box.max.y < this.min.y || box.min.y > this.max.y ? false : true;
	
			},
	
			clampPoint: function ( point, optionalTarget ) {
	
				var result = optionalTarget || new Vector2();
				return result.copy( point ).clamp( this.min, this.max );
	
			},
	
			distanceToPoint: function () {
	
				var v1 = new Vector2();
	
				return function distanceToPoint( point ) {
	
					var clampedPoint = v1.copy( point ).clamp( this.min, this.max );
					return clampedPoint.sub( point ).length();
	
				};
	
			}(),
	
			intersect: function ( box ) {
	
				this.min.max( box.min );
				this.max.min( box.max );
	
				return this;
	
			},
	
			union: function ( box ) {
	
				this.min.min( box.min );
				this.max.max( box.max );
	
				return this;
	
			},
	
			translate: function ( offset ) {
	
				this.min.add( offset );
				this.max.add( offset );
	
				return this;
	
			},
	
			equals: function ( box ) {
	
				return box.min.equals( this.min ) && box.max.equals( this.max );
	
			}
	
		} );
	
		/**
		 * @author mikael emtinger / http://gomo.se/
		 * @author alteredq / http://alteredqualia.com/
		 */
	
		function WebGLFlareRenderer( renderer, gl, state, textures, capabilities ) {
	
			var vertexBuffer, elementBuffer;
			var shader, program, attributes, uniforms;
	
			var tempTexture, occlusionTexture;
	
			function init() {
	
				var vertices = new Float32Array( [
					- 1, - 1, 0, 0,
					  1, - 1, 1, 0,
					  1, 1, 1, 1,
					- 1, 1, 0, 1
				] );
	
				var faces = new Uint16Array( [
					0, 1, 2,
					0, 2, 3
				] );
	
				// buffers
	
				vertexBuffer = gl.createBuffer();
				elementBuffer = gl.createBuffer();
	
				gl.bindBuffer( gl.ARRAY_BUFFER, vertexBuffer );
				gl.bufferData( gl.ARRAY_BUFFER, vertices, gl.STATIC_DRAW );
	
				gl.bindBuffer( gl.ELEMENT_ARRAY_BUFFER, elementBuffer );
				gl.bufferData( gl.ELEMENT_ARRAY_BUFFER, faces, gl.STATIC_DRAW );
	
				// textures
	
				tempTexture = gl.createTexture();
				occlusionTexture = gl.createTexture();
	
				state.bindTexture( gl.TEXTURE_2D, tempTexture );
				gl.texImage2D( gl.TEXTURE_2D, 0, gl.RGB, 16, 16, 0, gl.RGB, gl.UNSIGNED_BYTE, null );
				gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE );
				gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE );
				gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST );
				gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST );
	
				state.bindTexture( gl.TEXTURE_2D, occlusionTexture );
				gl.texImage2D( gl.TEXTURE_2D, 0, gl.RGBA, 16, 16, 0, gl.RGBA, gl.UNSIGNED_BYTE, null );
				gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE );
				gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE );
				gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST );
				gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST );
	
				shader = {
	
					vertexShader: [
	
						'uniform lowp int renderType;',
	
						'uniform vec3 screenPosition;',
						'uniform vec2 scale;',
						'uniform float rotation;',
	
						'uniform sampler2D occlusionMap;',
	
						'attribute vec2 position;',
						'attribute vec2 uv;',
	
						'varying vec2 vUV;',
						'varying float vVisibility;',
	
						'void main() {',
	
						'	vUV = uv;',
	
						'	vec2 pos = position;',
	
						'	if ( renderType == 2 ) {',
	
						'		vec4 visibility = texture2D( occlusionMap, vec2( 0.1, 0.1 ) );',
						'		visibility += texture2D( occlusionMap, vec2( 0.5, 0.1 ) );',
						'		visibility += texture2D( occlusionMap, vec2( 0.9, 0.1 ) );',
						'		visibility += texture2D( occlusionMap, vec2( 0.9, 0.5 ) );',
						'		visibility += texture2D( occlusionMap, vec2( 0.9, 0.9 ) );',
						'		visibility += texture2D( occlusionMap, vec2( 0.5, 0.9 ) );',
						'		visibility += texture2D( occlusionMap, vec2( 0.1, 0.9 ) );',
						'		visibility += texture2D( occlusionMap, vec2( 0.1, 0.5 ) );',
						'		visibility += texture2D( occlusionMap, vec2( 0.5, 0.5 ) );',
	
						'		vVisibility =        visibility.r / 9.0;',
						'		vVisibility *= 1.0 - visibility.g / 9.0;',
						'		vVisibility *=       visibility.b / 9.0;',
						'		vVisibility *= 1.0 - visibility.a / 9.0;',
	
						'		pos.x = cos( rotation ) * position.x - sin( rotation ) * position.y;',
						'		pos.y = sin( rotation ) * position.x + cos( rotation ) * position.y;',
	
						'	}',
	
						'	gl_Position = vec4( ( pos * scale + screenPosition.xy ).xy, screenPosition.z, 1.0 );',
	
						'}'
	
					].join( '\n' ),
	
					fragmentShader: [
	
						'uniform lowp int renderType;',
	
						'uniform sampler2D map;',
						'uniform float opacity;',
						'uniform vec3 color;',
	
						'varying vec2 vUV;',
						'varying float vVisibility;',
	
						'void main() {',
	
						// pink square
	
						'	if ( renderType == 0 ) {',
	
						'		gl_FragColor = vec4( 1.0, 0.0, 1.0, 0.0 );',
	
						// restore
	
						'	} else if ( renderType == 1 ) {',
	
						'		gl_FragColor = texture2D( map, vUV );',
	
						// flare
	
						'	} else {',
	
						'		vec4 texture = texture2D( map, vUV );',
						'		texture.a *= opacity * vVisibility;',
						'		gl_FragColor = texture;',
						'		gl_FragColor.rgb *= color;',
	
						'	}',
	
						'}'
	
					].join( '\n' )
	
				};
	
				program = createProgram( shader );
	
				attributes = {
					vertex: gl.getAttribLocation( program, 'position' ),
					uv: gl.getAttribLocation( program, 'uv' )
				};
	
				uniforms = {
					renderType: gl.getUniformLocation( program, 'renderType' ),
					map: gl.getUniformLocation( program, 'map' ),
					occlusionMap: gl.getUniformLocation( program, 'occlusionMap' ),
					opacity: gl.getUniformLocation( program, 'opacity' ),
					color: gl.getUniformLocation( program, 'color' ),
					scale: gl.getUniformLocation( program, 'scale' ),
					rotation: gl.getUniformLocation( program, 'rotation' ),
					screenPosition: gl.getUniformLocation( program, 'screenPosition' )
				};
	
			}
	
			/*
			 * Render lens flares
			 * Method: renders 16x16 0xff00ff-colored points scattered over the light source area,
			 *         reads these back and calculates occlusion.
			 */
	
			this.render = function ( flares, scene, camera, viewport ) {
	
				if ( flares.length === 0 ) return;
	
				var tempPosition = new Vector3();
	
				var invAspect = viewport.w / viewport.z,
					halfViewportWidth = viewport.z * 0.5,
					halfViewportHeight = viewport.w * 0.5;
	
				var size = 16 / viewport.w,
					scale = new Vector2( size * invAspect, size );
	
				var screenPosition = new Vector3( 1, 1, 0 ),
					screenPositionPixels = new Vector2( 1, 1 );
	
				var validArea = new Box2();
	
				validArea.min.set( viewport.x, viewport.y );
				validArea.max.set( viewport.x + ( viewport.z - 16 ), viewport.y + ( viewport.w - 16 ) );
	
				if ( program === undefined ) {
	
					init();
	
				}
	
				state.useProgram( program );
	
				state.initAttributes();
				state.enableAttribute( attributes.vertex );
				state.enableAttribute( attributes.uv );
				state.disableUnusedAttributes();
	
				// loop through all lens flares to update their occlusion and positions
				// setup gl and common used attribs/uniforms
	
				gl.uniform1i( uniforms.occlusionMap, 0 );
				gl.uniform1i( uniforms.map, 1 );
	
				gl.bindBuffer( gl.ARRAY_BUFFER, vertexBuffer );
				gl.vertexAttribPointer( attributes.vertex, 2, gl.FLOAT, false, 2 * 8, 0 );
				gl.vertexAttribPointer( attributes.uv, 2, gl.FLOAT, false, 2 * 8, 8 );
	
				gl.bindBuffer( gl.ELEMENT_ARRAY_BUFFER, elementBuffer );
	
				state.disable( gl.CULL_FACE );
				state.buffers.depth.setMask( false );
	
				for ( var i = 0, l = flares.length; i < l; i ++ ) {
	
					size = 16 / viewport.w;
					scale.set( size * invAspect, size );
	
					// calc object screen position
	
					var flare = flares[ i ];
	
					tempPosition.set( flare.matrixWorld.elements[ 12 ], flare.matrixWorld.elements[ 13 ], flare.matrixWorld.elements[ 14 ] );
	
					tempPosition.applyMatrix4( camera.matrixWorldInverse );
					tempPosition.applyMatrix4( camera.projectionMatrix );
	
					// setup arrays for gl programs
	
					screenPosition.copy( tempPosition );
	
					// horizontal and vertical coordinate of the lower left corner of the pixels to copy
	
					screenPositionPixels.x = viewport.x + ( screenPosition.x * halfViewportWidth ) + halfViewportWidth - 8;
					screenPositionPixels.y = viewport.y + ( screenPosition.y * halfViewportHeight ) + halfViewportHeight - 8;
	
					// screen cull
	
					if ( validArea.containsPoint( screenPositionPixels ) === true ) {
	
						// save current RGB to temp texture
	
						state.activeTexture( gl.TEXTURE0 );
						state.bindTexture( gl.TEXTURE_2D, null );
						state.activeTexture( gl.TEXTURE1 );
						state.bindTexture( gl.TEXTURE_2D, tempTexture );
						gl.copyTexImage2D( gl.TEXTURE_2D, 0, gl.RGB, screenPositionPixels.x, screenPositionPixels.y, 16, 16, 0 );
	
	
						// render pink quad
	
						gl.uniform1i( uniforms.renderType, 0 );
						gl.uniform2f( uniforms.scale, scale.x, scale.y );
						gl.uniform3f( uniforms.screenPosition, screenPosition.x, screenPosition.y, screenPosition.z );
	
						state.disable( gl.BLEND );
						state.enable( gl.DEPTH_TEST );
	
						gl.drawElements( gl.TRIANGLES, 6, gl.UNSIGNED_SHORT, 0 );
	
	
						// copy result to occlusionMap
	
						state.activeTexture( gl.TEXTURE0 );
						state.bindTexture( gl.TEXTURE_2D, occlusionTexture );
						gl.copyTexImage2D( gl.TEXTURE_2D, 0, gl.RGBA, screenPositionPixels.x, screenPositionPixels.y, 16, 16, 0 );
	
	
						// restore graphics
	
						gl.uniform1i( uniforms.renderType, 1 );
						state.disable( gl.DEPTH_TEST );
	
						state.activeTexture( gl.TEXTURE1 );
						state.bindTexture( gl.TEXTURE_2D, tempTexture );
						gl.drawElements( gl.TRIANGLES, 6, gl.UNSIGNED_SHORT, 0 );
	
	
						// update object positions
	
						flare.positionScreen.copy( screenPosition );
	
						if ( flare.customUpdateCallback ) {
	
							flare.customUpdateCallback( flare );
	
						} else {
	
							flare.updateLensFlares();
	
						}
	
						// render flares
	
						gl.uniform1i( uniforms.renderType, 2 );
						state.enable( gl.BLEND );
	
						for ( var j = 0, jl = flare.lensFlares.length; j < jl; j ++ ) {
	
							var sprite = flare.lensFlares[ j ];
	
							if ( sprite.opacity > 0.001 && sprite.scale > 0.001 ) {
	
								screenPosition.x = sprite.x;
								screenPosition.y = sprite.y;
								screenPosition.z = sprite.z;
	
								size = sprite.size * sprite.scale / viewport.w;
	
								scale.x = size * invAspect;
								scale.y = size;
	
								gl.uniform3f( uniforms.screenPosition, screenPosition.x, screenPosition.y, screenPosition.z );
								gl.uniform2f( uniforms.scale, scale.x, scale.y );
								gl.uniform1f( uniforms.rotation, sprite.rotation );
	
								gl.uniform1f( uniforms.opacity, sprite.opacity );
								gl.uniform3f( uniforms.color, sprite.color.r, sprite.color.g, sprite.color.b );
	
								state.setBlending( sprite.blending, sprite.blendEquation, sprite.blendSrc, sprite.blendDst );
	
								textures.setTexture2D( sprite.texture, 1 );
	
								gl.drawElements( gl.TRIANGLES, 6, gl.UNSIGNED_SHORT, 0 );
	
							}
	
						}
	
					}
	
				}
	
				// restore gl
	
				state.enable( gl.CULL_FACE );
				state.enable( gl.DEPTH_TEST );
				state.buffers.depth.setMask( true );
	
				state.reset();
	
			};
	
			function createProgram( shader ) {
	
				var program = gl.createProgram();
	
				var fragmentShader = gl.createShader( gl.FRAGMENT_SHADER );
				var vertexShader = gl.createShader( gl.VERTEX_SHADER );
	
				var prefix = 'precision ' + capabilities.precision + ' float;\n';
	
				gl.shaderSource( fragmentShader, prefix + shader.fragmentShader );
				gl.shaderSource( vertexShader, prefix + shader.vertexShader );
	
				gl.compileShader( fragmentShader );
				gl.compileShader( vertexShader );
	
				gl.attachShader( program, fragmentShader );
				gl.attachShader( program, vertexShader );
	
				gl.linkProgram( program );
	
				return program;
	
			}
	
		}
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function CanvasTexture( canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy ) {
	
			Texture.call( this, canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy );
	
			this.needsUpdate = true;
	
		}
	
		CanvasTexture.prototype = Object.create( Texture.prototype );
		CanvasTexture.prototype.constructor = CanvasTexture;
	
		/**
		 * @author mikael emtinger / http://gomo.se/
		 * @author alteredq / http://alteredqualia.com/
		 */
	
		function WebGLSpriteRenderer( renderer, gl, state, textures, capabilities ) {
	
			var vertexBuffer, elementBuffer;
			var program, attributes, uniforms;
	
			var texture;
	
			// decompose matrixWorld
	
			var spritePosition = new Vector3();
			var spriteRotation = new Quaternion();
			var spriteScale = new Vector3();
	
			function init() {
	
				var vertices = new Float32Array( [
					- 0.5, - 0.5, 0, 0,
					  0.5, - 0.5, 1, 0,
					  0.5, 0.5, 1, 1,
					- 0.5, 0.5, 0, 1
				] );
	
				var faces = new Uint16Array( [
					0, 1, 2,
					0, 2, 3
				] );
	
				vertexBuffer = gl.createBuffer();
				elementBuffer = gl.createBuffer();
	
				gl.bindBuffer( gl.ARRAY_BUFFER, vertexBuffer );
				gl.bufferData( gl.ARRAY_BUFFER, vertices, gl.STATIC_DRAW );
	
				gl.bindBuffer( gl.ELEMENT_ARRAY_BUFFER, elementBuffer );
				gl.bufferData( gl.ELEMENT_ARRAY_BUFFER, faces, gl.STATIC_DRAW );
	
				program = createProgram();
	
				attributes = {
					position: gl.getAttribLocation( program, 'position' ),
					uv: gl.getAttribLocation( program, 'uv' )
				};
	
				uniforms = {
					uvOffset: gl.getUniformLocation( program, 'uvOffset' ),
					uvScale: gl.getUniformLocation( program, 'uvScale' ),
	
					rotation: gl.getUniformLocation( program, 'rotation' ),
					scale: gl.getUniformLocation( program, 'scale' ),
	
					color: gl.getUniformLocation( program, 'color' ),
					map: gl.getUniformLocation( program, 'map' ),
					opacity: gl.getUniformLocation( program, 'opacity' ),
	
					modelViewMatrix: gl.getUniformLocation( program, 'modelViewMatrix' ),
					projectionMatrix: gl.getUniformLocation( program, 'projectionMatrix' ),
	
					fogType: gl.getUniformLocation( program, 'fogType' ),
					fogDensity: gl.getUniformLocation( program, 'fogDensity' ),
					fogNear: gl.getUniformLocation( program, 'fogNear' ),
					fogFar: gl.getUniformLocation( program, 'fogFar' ),
					fogColor: gl.getUniformLocation( program, 'fogColor' ),
					fogDepth: gl.getUniformLocation( program, 'fogDepth' ),
	
					alphaTest: gl.getUniformLocation( program, 'alphaTest' )
				};
	
				var canvas = document.createElementNS( 'http://www.w3.org/1999/xhtml', 'canvas' );
				canvas.width = 8;
				canvas.height = 8;
	
				var context = canvas.getContext( '2d' );
				context.fillStyle = 'white';
				context.fillRect( 0, 0, 8, 8 );
	
				texture = new CanvasTexture( canvas );
	
			}
	
			this.render = function ( sprites, scene, camera ) {
	
				if ( sprites.length === 0 ) return;
	
				// setup gl
	
				if ( program === undefined ) {
	
					init();
	
				}
	
				state.useProgram( program );
	
				state.initAttributes();
				state.enableAttribute( attributes.position );
				state.enableAttribute( attributes.uv );
				state.disableUnusedAttributes();
	
				state.disable( gl.CULL_FACE );
				state.enable( gl.BLEND );
	
				gl.bindBuffer( gl.ARRAY_BUFFER, vertexBuffer );
				gl.vertexAttribPointer( attributes.position, 2, gl.FLOAT, false, 2 * 8, 0 );
				gl.vertexAttribPointer( attributes.uv, 2, gl.FLOAT, false, 2 * 8, 8 );
	
				gl.bindBuffer( gl.ELEMENT_ARRAY_BUFFER, elementBuffer );
	
				gl.uniformMatrix4fv( uniforms.projectionMatrix, false, camera.projectionMatrix.elements );
	
				state.activeTexture( gl.TEXTURE0 );
				gl.uniform1i( uniforms.map, 0 );
	
				var oldFogType = 0;
				var sceneFogType = 0;
				var fog = scene.fog;
	
				if ( fog ) {
	
					gl.uniform3f( uniforms.fogColor, fog.color.r, fog.color.g, fog.color.b );
	
					if ( fog.isFog ) {
	
						gl.uniform1f( uniforms.fogNear, fog.near );
						gl.uniform1f( uniforms.fogFar, fog.far );
	
						gl.uniform1i( uniforms.fogType, 1 );
						oldFogType = 1;
						sceneFogType = 1;
	
					} else if ( fog.isFogExp2 ) {
	
						gl.uniform1f( uniforms.fogDensity, fog.density );
	
						gl.uniform1i( uniforms.fogType, 2 );
						oldFogType = 2;
						sceneFogType = 2;
	
					}
	
				} else {
	
					gl.uniform1i( uniforms.fogType, 0 );
					oldFogType = 0;
					sceneFogType = 0;
	
				}
	
	
				// update positions and sort
	
				for ( var i = 0, l = sprites.length; i < l; i ++ ) {
	
					var sprite = sprites[ i ];
	
					sprite.modelViewMatrix.multiplyMatrices( camera.matrixWorldInverse, sprite.matrixWorld );
					sprite.z = - sprite.modelViewMatrix.elements[ 14 ];
	
				}
	
				sprites.sort( painterSortStable );
	
				// render all sprites
	
				var scale = [];
	
				for ( var i = 0, l = sprites.length; i < l; i ++ ) {
	
					var sprite = sprites[ i ];
					var material = sprite.material;
	
					if ( material.visible === false ) continue;
	
					sprite.onBeforeRender( renderer, scene, camera, undefined, material, undefined );
	
					gl.uniform1f( uniforms.alphaTest, material.alphaTest );
					gl.uniformMatrix4fv( uniforms.modelViewMatrix, false, sprite.modelViewMatrix.elements );
	
					sprite.matrixWorld.decompose( spritePosition, spriteRotation, spriteScale );
	
					scale[ 0 ] = spriteScale.x;
					scale[ 1 ] = spriteScale.y;
	
					var fogType = 0;
	
					if ( scene.fog && material.fog ) {
	
						fogType = sceneFogType;
	
					}
	
					if ( oldFogType !== fogType ) {
	
						gl.uniform1i( uniforms.fogType, fogType );
						oldFogType = fogType;
	
					}
	
					if ( material.map !== null ) {
	
						gl.uniform2f( uniforms.uvOffset, material.map.offset.x, material.map.offset.y );
						gl.uniform2f( uniforms.uvScale, material.map.repeat.x, material.map.repeat.y );
	
					} else {
	
						gl.uniform2f( uniforms.uvOffset, 0, 0 );
						gl.uniform2f( uniforms.uvScale, 1, 1 );
	
					}
	
					gl.uniform1f( uniforms.opacity, material.opacity );
					gl.uniform3f( uniforms.color, material.color.r, material.color.g, material.color.b );
	
					gl.uniform1f( uniforms.rotation, material.rotation );
					gl.uniform2fv( uniforms.scale, scale );
	
					state.setBlending( material.blending, material.blendEquation, material.blendSrc, material.blendDst, material.blendEquationAlpha, material.blendSrcAlpha, material.blendDstAlpha, material.premultipliedAlpha );
					state.buffers.depth.setTest( material.depthTest );
					state.buffers.depth.setMask( material.depthWrite );
					state.buffers.color.setMask( material.colorWrite );
	
					textures.setTexture2D( material.map || texture, 0 );
	
					gl.drawElements( gl.TRIANGLES, 6, gl.UNSIGNED_SHORT, 0 );
	
					sprite.onAfterRender( renderer, scene, camera, undefined, material, undefined );
	
				}
	
				// restore gl
	
				state.enable( gl.CULL_FACE );
	
				state.reset();
	
			};
	
			function createProgram() {
	
				var program = gl.createProgram();
	
				var vertexShader = gl.createShader( gl.VERTEX_SHADER );
				var fragmentShader = gl.createShader( gl.FRAGMENT_SHADER );
	
				gl.shaderSource( vertexShader, [
	
					'precision ' + capabilities.precision + ' float;',
	
					'#define SHADER_NAME ' + 'SpriteMaterial',
	
					'uniform mat4 modelViewMatrix;',
					'uniform mat4 projectionMatrix;',
					'uniform float rotation;',
					'uniform vec2 scale;',
					'uniform vec2 uvOffset;',
					'uniform vec2 uvScale;',
	
					'attribute vec2 position;',
					'attribute vec2 uv;',
	
					'varying vec2 vUV;',
					'varying float fogDepth;',
	
					'void main() {',
	
					'	vUV = uvOffset + uv * uvScale;',
	
					'	vec2 alignedPosition = position * scale;',
	
					'	vec2 rotatedPosition;',
					'	rotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;',
					'	rotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;',
	
					'	vec4 mvPosition;',
	
					'	mvPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );',
					'	mvPosition.xy += rotatedPosition;',
	
					'	gl_Position = projectionMatrix * mvPosition;',
	
					'	fogDepth = - mvPosition.z;',
	
					'}'
	
				].join( '\n' ) );
	
				gl.shaderSource( fragmentShader, [
	
					'precision ' + capabilities.precision + ' float;',
	
					'#define SHADER_NAME ' + 'SpriteMaterial',
	
					'uniform vec3 color;',
					'uniform sampler2D map;',
					'uniform float opacity;',
	
					'uniform int fogType;',
					'uniform vec3 fogColor;',
					'uniform float fogDensity;',
					'uniform float fogNear;',
					'uniform float fogFar;',
					'uniform float alphaTest;',
	
					'varying vec2 vUV;',
					'varying float fogDepth;',
	
					'void main() {',
	
					'	vec4 texture = texture2D( map, vUV );',
	
					'	gl_FragColor = vec4( color * texture.xyz, texture.a * opacity );',
	
					'	if ( gl_FragColor.a < alphaTest ) discard;',
	
					'	if ( fogType > 0 ) {',
	
					'		float fogFactor = 0.0;',
	
					'		if ( fogType == 1 ) {',
	
					'			fogFactor = smoothstep( fogNear, fogFar, fogDepth );',
	
					'		} else {',
	
					'			const float LOG2 = 1.442695;',
					'			fogFactor = exp2( - fogDensity * fogDensity * fogDepth * fogDepth * LOG2 );',
					'			fogFactor = 1.0 - clamp( fogFactor, 0.0, 1.0 );',
	
					'		}',
	
					'		gl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );',
	
					'	}',
	
					'}'
	
				].join( '\n' ) );
	
				gl.compileShader( vertexShader );
				gl.compileShader( fragmentShader );
	
				gl.attachShader( program, vertexShader );
				gl.attachShader( program, fragmentShader );
	
				gl.linkProgram( program );
	
				return program;
	
			}
	
			function painterSortStable( a, b ) {
	
				if ( a.renderOrder !== b.renderOrder ) {
	
					return a.renderOrder - b.renderOrder;
	
				} else if ( a.z !== b.z ) {
	
					return b.z - a.z;
	
				} else {
	
					return b.id - a.id;
	
				}
	
			}
	
		}
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author alteredq / http://alteredqualia.com/
		 */
	
		var materialId = 0;
	
		function Material() {
	
			Object.defineProperty( this, 'id', { value: materialId ++ } );
	
			this.uuid = _Math.generateUUID();
	
			this.name = '';
			this.type = 'Material';
	
			this.fog = true;
			this.lights = true;
	
			this.blending = NormalBlending;
			this.side = FrontSide;
			this.flatShading = false;
			this.vertexColors = NoColors; // THREE.NoColors, THREE.VertexColors, THREE.FaceColors
	
			this.opacity = 1;
			this.transparent = false;
	
			this.blendSrc = SrcAlphaFactor;
			this.blendDst = OneMinusSrcAlphaFactor;
			this.blendEquation = AddEquation;
			this.blendSrcAlpha = null;
			this.blendDstAlpha = null;
			this.blendEquationAlpha = null;
	
			this.depthFunc = LessEqualDepth;
			this.depthTest = true;
			this.depthWrite = true;
	
			this.clippingPlanes = null;
			this.clipIntersection = false;
			this.clipShadows = false;
	
			this.colorWrite = true;
	
			this.precision = null; // override the renderer's default precision for this material
	
			this.polygonOffset = false;
			this.polygonOffsetFactor = 0;
			this.polygonOffsetUnits = 0;
	
			this.dithering = false;
	
			this.alphaTest = 0;
			this.premultipliedAlpha = false;
	
			this.overdraw = 0; // Overdrawn pixels (typically between 0 and 1) for fixing antialiasing gaps in CanvasRenderer
	
			this.visible = true;
	
			this.userData = {};
	
			this.needsUpdate = true;
	
		}
	
		Material.prototype = Object.assign( Object.create( EventDispatcher.prototype ), {
	
			constructor: Material,
	
			isMaterial: true,
	
			onBeforeCompile: function () {},
	
			setValues: function ( values ) {
	
				if ( values === undefined ) return;
	
				for ( var key in values ) {
	
					var newValue = values[ key ];
	
					if ( newValue === undefined ) {
	
						console.warn( "THREE.Material: '" + key + "' parameter is undefined." );
						continue;
	
					}
	
					// for backward compatability if shading is set in the constructor
					if ( key === 'shading' ) {
	
						console.warn( 'THREE.' + this.type + ': .shading has been removed. Use the boolean .flatShading instead.' );
						this.flatShading = ( newValue === FlatShading ) ? true : false;
						continue;
	
					}
	
					var currentValue = this[ key ];
	
					if ( currentValue === undefined ) {
	
						console.warn( "THREE." + this.type + ": '" + key + "' is not a property of this material." );
						continue;
	
					}
	
					if ( currentValue && currentValue.isColor ) {
	
						currentValue.set( newValue );
	
					} else if ( ( currentValue && currentValue.isVector3 ) && ( newValue && newValue.isVector3 ) ) {
	
						currentValue.copy( newValue );
	
					} else if ( key === 'overdraw' ) {
	
						// ensure overdraw is backwards-compatible with legacy boolean type
						this[ key ] = Number( newValue );
	
					} else {
	
						this[ key ] = newValue;
	
					}
	
				}
	
			},
	
			toJSON: function ( meta ) {
	
				var isRoot = ( meta === undefined || typeof meta === 'string' );
	
				if ( isRoot ) {
	
					meta = {
						textures: {},
						images: {}
					};
	
				}
	
				var data = {
					metadata: {
						version: 4.5,
						type: 'Material',
						generator: 'Material.toJSON'
					}
				};
	
				// standard Material serialization
				data.uuid = this.uuid;
				data.type = this.type;
	
				if ( this.name !== '' ) data.name = this.name;
	
				if ( this.color && this.color.isColor ) data.color = this.color.getHex();
	
				if ( this.roughness !== undefined ) data.roughness = this.roughness;
				if ( this.metalness !== undefined ) data.metalness = this.metalness;
	
				if ( this.emissive && this.emissive.isColor ) data.emissive = this.emissive.getHex();
				if ( this.emissiveIntensity !== 1 ) data.emissiveIntensity = this.emissiveIntensity;
	
				if ( this.specular && this.specular.isColor ) data.specular = this.specular.getHex();
				if ( this.shininess !== undefined ) data.shininess = this.shininess;
				if ( this.clearCoat !== undefined ) data.clearCoat = this.clearCoat;
				if ( this.clearCoatRoughness !== undefined ) data.clearCoatRoughness = this.clearCoatRoughness;
	
				if ( this.map && this.map.isTexture ) data.map = this.map.toJSON( meta ).uuid;
				if ( this.alphaMap && this.alphaMap.isTexture ) data.alphaMap = this.alphaMap.toJSON( meta ).uuid;
				if ( this.lightMap && this.lightMap.isTexture ) data.lightMap = this.lightMap.toJSON( meta ).uuid;
				if ( this.bumpMap && this.bumpMap.isTexture ) {
	
					data.bumpMap = this.bumpMap.toJSON( meta ).uuid;
					data.bumpScale = this.bumpScale;
	
				}
				if ( this.normalMap && this.normalMap.isTexture ) {
	
					data.normalMap = this.normalMap.toJSON( meta ).uuid;
					data.normalScale = this.normalScale.toArray();
	
				}
				if ( this.displacementMap && this.displacementMap.isTexture ) {
	
					data.displacementMap = this.displacementMap.toJSON( meta ).uuid;
					data.displacementScale = this.displacementScale;
					data.displacementBias = this.displacementBias;
	
				}
				if ( this.roughnessMap && this.roughnessMap.isTexture ) data.roughnessMap = this.roughnessMap.toJSON( meta ).uuid;
				if ( this.metalnessMap && this.metalnessMap.isTexture ) data.metalnessMap = this.metalnessMap.toJSON( meta ).uuid;
	
				if ( this.emissiveMap && this.emissiveMap.isTexture ) data.emissiveMap = this.emissiveMap.toJSON( meta ).uuid;
				if ( this.specularMap && this.specularMap.isTexture ) data.specularMap = this.specularMap.toJSON( meta ).uuid;
	
				if ( this.envMap && this.envMap.isTexture ) {
	
					data.envMap = this.envMap.toJSON( meta ).uuid;
					data.reflectivity = this.reflectivity; // Scale behind envMap
	
				}
	
				if ( this.gradientMap && this.gradientMap.isTexture ) {
	
					data.gradientMap = this.gradientMap.toJSON( meta ).uuid;
	
				}
	
				if ( this.size !== undefined ) data.size = this.size;
				if ( this.sizeAttenuation !== undefined ) data.sizeAttenuation = this.sizeAttenuation;
	
				if ( this.blending !== NormalBlending ) data.blending = this.blending;
				if ( this.flatShading === true ) data.flatShading = this.flatShading;
				if ( this.side !== FrontSide ) data.side = this.side;
				if ( this.vertexColors !== NoColors ) data.vertexColors = this.vertexColors;
	
				if ( this.opacity < 1 ) data.opacity = this.opacity;
				if ( this.transparent === true ) data.transparent = this.transparent;
	
				data.depthFunc = this.depthFunc;
				data.depthTest = this.depthTest;
				data.depthWrite = this.depthWrite;
	
				// rotation (SpriteMaterial)
				if ( this.rotation !== 0 ) data.rotation = this.rotation;
	
				if ( this.linewidth !== 1 ) data.linewidth = this.linewidth;
				if ( this.dashSize !== undefined ) data.dashSize = this.dashSize;
				if ( this.gapSize !== undefined ) data.gapSize = this.gapSize;
				if ( this.scale !== undefined ) data.scale = this.scale;
	
				if ( this.dithering === true ) data.dithering = true;
	
				if ( this.alphaTest > 0 ) data.alphaTest = this.alphaTest;
				if ( this.premultipliedAlpha === true ) data.premultipliedAlpha = this.premultipliedAlpha;
	
				if ( this.wireframe === true ) data.wireframe = this.wireframe;
				if ( this.wireframeLinewidth > 1 ) data.wireframeLinewidth = this.wireframeLinewidth;
				if ( this.wireframeLinecap !== 'round' ) data.wireframeLinecap = this.wireframeLinecap;
				if ( this.wireframeLinejoin !== 'round' ) data.wireframeLinejoin = this.wireframeLinejoin;
	
				if ( this.morphTargets === true ) data.morphTargets = true;
				if ( this.skinning === true ) data.skinning = true;
	
				if ( this.visible === false ) data.visible = false;
				if ( JSON.stringify( this.userData ) !== '{}' ) data.userData = this.userData;
	
				// TODO: Copied from Object3D.toJSON
	
				function extractFromCache( cache ) {
	
					var values = [];
	
					for ( var key in cache ) {
	
						var data = cache[ key ];
						delete data.metadata;
						values.push( data );
	
					}
	
					return values;
	
				}
	
				if ( isRoot ) {
	
					var textures = extractFromCache( meta.textures );
					var images = extractFromCache( meta.images );
	
					if ( textures.length > 0 ) data.textures = textures;
					if ( images.length > 0 ) data.images = images;
	
				}
	
				return data;
	
			},
	
			clone: function () {
	
				return new this.constructor().copy( this );
	
			},
	
			copy: function ( source ) {
	
				this.name = source.name;
	
				this.fog = source.fog;
				this.lights = source.lights;
	
				this.blending = source.blending;
				this.side = source.side;
				this.flatShading = source.flatShading;
				this.vertexColors = source.vertexColors;
	
				this.opacity = source.opacity;
				this.transparent = source.transparent;
	
				this.blendSrc = source.blendSrc;
				this.blendDst = source.blendDst;
				this.blendEquation = source.blendEquation;
				this.blendSrcAlpha = source.blendSrcAlpha;
				this.blendDstAlpha = source.blendDstAlpha;
				this.blendEquationAlpha = source.blendEquationAlpha;
	
				this.depthFunc = source.depthFunc;
				this.depthTest = source.depthTest;
				this.depthWrite = source.depthWrite;
	
				this.colorWrite = source.colorWrite;
	
				this.precision = source.precision;
	
				this.polygonOffset = source.polygonOffset;
				this.polygonOffsetFactor = source.polygonOffsetFactor;
				this.polygonOffsetUnits = source.polygonOffsetUnits;
	
				this.dithering = source.dithering;
	
				this.alphaTest = source.alphaTest;
				this.premultipliedAlpha = source.premultipliedAlpha;
	
				this.overdraw = source.overdraw;
	
				this.visible = source.visible;
				this.userData = JSON.parse( JSON.stringify( source.userData ) );
	
				this.clipShadows = source.clipShadows;
				this.clipIntersection = source.clipIntersection;
	
				var srcPlanes = source.clippingPlanes,
					dstPlanes = null;
	
				if ( srcPlanes !== null ) {
	
					var n = srcPlanes.length;
					dstPlanes = new Array( n );
	
					for ( var i = 0; i !== n; ++ i )
						dstPlanes[ i ] = srcPlanes[ i ].clone();
	
				}
	
				this.clippingPlanes = dstPlanes;
	
				return this;
	
			},
	
			dispose: function () {
	
				this.dispatchEvent( { type: 'dispose' } );
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author alteredq / http://alteredqualia.com/
		 * @author bhouston / https://clara.io
		 * @author WestLangley / http://github.com/WestLangley
		 *
		 * parameters = {
		 *
		 *  opacity: <float>,
		 *
		 *  map: new THREE.Texture( <Image> ),
		 *
		 *  alphaMap: new THREE.Texture( <Image> ),
		 *
		 *  displacementMap: new THREE.Texture( <Image> ),
		 *  displacementScale: <float>,
		 *  displacementBias: <float>,
		 *
		 *  wireframe: <boolean>,
		 *  wireframeLinewidth: <float>
		 * }
		 */
	
		function MeshDepthMaterial( parameters ) {
	
			Material.call( this );
	
			this.type = 'MeshDepthMaterial';
	
			this.depthPacking = BasicDepthPacking;
	
			this.skinning = false;
			this.morphTargets = false;
	
			this.map = null;
	
			this.alphaMap = null;
	
			this.displacementMap = null;
			this.displacementScale = 1;
			this.displacementBias = 0;
	
			this.wireframe = false;
			this.wireframeLinewidth = 1;
	
			this.fog = false;
			this.lights = false;
	
			this.setValues( parameters );
	
		}
	
		MeshDepthMaterial.prototype = Object.create( Material.prototype );
		MeshDepthMaterial.prototype.constructor = MeshDepthMaterial;
	
		MeshDepthMaterial.prototype.isMeshDepthMaterial = true;
	
		MeshDepthMaterial.prototype.copy = function ( source ) {
	
			Material.prototype.copy.call( this, source );
	
			this.depthPacking = source.depthPacking;
	
			this.skinning = source.skinning;
			this.morphTargets = source.morphTargets;
	
			this.map = source.map;
	
			this.alphaMap = source.alphaMap;
	
			this.displacementMap = source.displacementMap;
			this.displacementScale = source.displacementScale;
			this.displacementBias = source.displacementBias;
	
			this.wireframe = source.wireframe;
			this.wireframeLinewidth = source.wireframeLinewidth;
	
			return this;
	
		};
	
		/**
		 * @author WestLangley / http://github.com/WestLangley
		 *
		 * parameters = {
		 *
		 *  referencePosition: <float>,
		 *  nearDistance: <float>,
		 *  farDistance: <float>,
		 *
		 *  skinning: <bool>,
		 *  morphTargets: <bool>,
		 *
		 *  map: new THREE.Texture( <Image> ),
		 *
		 *  alphaMap: new THREE.Texture( <Image> ),
		 *
		 *  displacementMap: new THREE.Texture( <Image> ),
		 *  displacementScale: <float>,
		 *  displacementBias: <float>
		 *
		 * }
		 */
	
		function MeshDistanceMaterial( parameters ) {
	
			Material.call( this );
	
			this.type = 'MeshDistanceMaterial';
	
			this.referencePosition = new Vector3();
			this.nearDistance = 1;
			this.farDistance = 1000;
	
			this.skinning = false;
			this.morphTargets = false;
	
			this.map = null;
	
			this.alphaMap = null;
	
			this.displacementMap = null;
			this.displacementScale = 1;
			this.displacementBias = 0;
	
			this.fog = false;
			this.lights = false;
	
			this.setValues( parameters );
	
		}
	
		MeshDistanceMaterial.prototype = Object.create( Material.prototype );
		MeshDistanceMaterial.prototype.constructor = MeshDistanceMaterial;
	
		MeshDistanceMaterial.prototype.isMeshDistanceMaterial = true;
	
		MeshDistanceMaterial.prototype.copy = function ( source ) {
	
			Material.prototype.copy.call( this, source );
	
			this.referencePosition.copy( source.referencePosition );
			this.nearDistance = source.nearDistance;
			this.farDistance = source.farDistance;
	
			this.skinning = source.skinning;
			this.morphTargets = source.morphTargets;
	
			this.map = source.map;
	
			this.alphaMap = source.alphaMap;
	
			this.displacementMap = source.displacementMap;
			this.displacementScale = source.displacementScale;
			this.displacementBias = source.displacementBias;
	
			return this;
	
		};
	
		/**
		 * @author bhouston / http://clara.io
		 * @author WestLangley / http://github.com/WestLangley
		 */
	
		function Box3( min, max ) {
	
			this.min = ( min !== undefined ) ? min : new Vector3( + Infinity, + Infinity, + Infinity );
			this.max = ( max !== undefined ) ? max : new Vector3( - Infinity, - Infinity, - Infinity );
	
		}
	
		Object.assign( Box3.prototype, {
	
			isBox3: true,
	
			set: function ( min, max ) {
	
				this.min.copy( min );
				this.max.copy( max );
	
				return this;
	
			},
	
			setFromArray: function ( array ) {
	
				var minX = + Infinity;
				var minY = + Infinity;
				var minZ = + Infinity;
	
				var maxX = - Infinity;
				var maxY = - Infinity;
				var maxZ = - Infinity;
	
				for ( var i = 0, l = array.length; i < l; i += 3 ) {
	
					var x = array[ i ];
					var y = array[ i + 1 ];
					var z = array[ i + 2 ];
	
					if ( x < minX ) minX = x;
					if ( y < minY ) minY = y;
					if ( z < minZ ) minZ = z;
	
					if ( x > maxX ) maxX = x;
					if ( y > maxY ) maxY = y;
					if ( z > maxZ ) maxZ = z;
	
				}
	
				this.min.set( minX, minY, minZ );
				this.max.set( maxX, maxY, maxZ );
	
				return this;
	
			},
	
			setFromBufferAttribute: function ( attribute ) {
	
				var minX = + Infinity;
				var minY = + Infinity;
				var minZ = + Infinity;
	
				var maxX = - Infinity;
				var maxY = - Infinity;
				var maxZ = - Infinity;
	
				for ( var i = 0, l = attribute.count; i < l; i ++ ) {
	
					var x = attribute.getX( i );
					var y = attribute.getY( i );
					var z = attribute.getZ( i );
	
					if ( x < minX ) minX = x;
					if ( y < minY ) minY = y;
					if ( z < minZ ) minZ = z;
	
					if ( x > maxX ) maxX = x;
					if ( y > maxY ) maxY = y;
					if ( z > maxZ ) maxZ = z;
	
				}
	
				this.min.set( minX, minY, minZ );
				this.max.set( maxX, maxY, maxZ );
	
				return this;
	
			},
	
			setFromPoints: function ( points ) {
	
				this.makeEmpty();
	
				for ( var i = 0, il = points.length; i < il; i ++ ) {
	
					this.expandByPoint( points[ i ] );
	
				}
	
				return this;
	
			},
	
			setFromCenterAndSize: function () {
	
				var v1 = new Vector3();
	
				return function setFromCenterAndSize( center, size ) {
	
					var halfSize = v1.copy( size ).multiplyScalar( 0.5 );
	
					this.min.copy( center ).sub( halfSize );
					this.max.copy( center ).add( halfSize );
	
					return this;
	
				};
	
			}(),
	
			setFromObject: function ( object ) {
	
				this.makeEmpty();
	
				return this.expandByObject( object );
	
			},
	
			clone: function () {
	
				return new this.constructor().copy( this );
	
			},
	
			copy: function ( box ) {
	
				this.min.copy( box.min );
				this.max.copy( box.max );
	
				return this;
	
			},
	
			makeEmpty: function () {
	
				this.min.x = this.min.y = this.min.z = + Infinity;
				this.max.x = this.max.y = this.max.z = - Infinity;
	
				return this;
	
			},
	
			isEmpty: function () {
	
				// this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
	
				return ( this.max.x < this.min.x ) || ( this.max.y < this.min.y ) || ( this.max.z < this.min.z );
	
			},
	
			getCenter: function ( optionalTarget ) {
	
				var result = optionalTarget || new Vector3();
				return this.isEmpty() ? result.set( 0, 0, 0 ) : result.addVectors( this.min, this.max ).multiplyScalar( 0.5 );
	
			},
	
			getSize: function ( optionalTarget ) {
	
				var result = optionalTarget || new Vector3();
				return this.isEmpty() ? result.set( 0, 0, 0 ) : result.subVectors( this.max, this.min );
	
			},
	
			expandByPoint: function ( point ) {
	
				this.min.min( point );
				this.max.max( point );
	
				return this;
	
			},
	
			expandByVector: function ( vector ) {
	
				this.min.sub( vector );
				this.max.add( vector );
	
				return this;
	
			},
	
			expandByScalar: function ( scalar ) {
	
				this.min.addScalar( - scalar );
				this.max.addScalar( scalar );
	
				return this;
	
			},
	
			expandByObject: function () {
	
				// Computes the world-axis-aligned bounding box of an object (including its children),
				// accounting for both the object's, and children's, world transforms
	
				var scope, i, l;
	
				var v1 = new Vector3();
	
				function traverse( node ) {
	
					var geometry = node.geometry;
	
					if ( geometry !== undefined ) {
	
						if ( geometry.isGeometry ) {
	
							var vertices = geometry.vertices;
	
							for ( i = 0, l = vertices.length; i < l; i ++ ) {
	
								v1.copy( vertices[ i ] );
								v1.applyMatrix4( node.matrixWorld );
	
								scope.expandByPoint( v1 );
	
							}
	
						} else if ( geometry.isBufferGeometry ) {
	
							var attribute = geometry.attributes.position;
	
							if ( attribute !== undefined ) {
	
								for ( i = 0, l = attribute.count; i < l; i ++ ) {
	
									v1.fromBufferAttribute( attribute, i ).applyMatrix4( node.matrixWorld );
	
									scope.expandByPoint( v1 );
	
								}
	
							}
	
						}
	
					}
	
				}
	
				return function expandByObject( object ) {
	
					scope = this;
	
					object.updateMatrixWorld( true );
	
					object.traverse( traverse );
	
					return this;
	
				};
	
			}(),
	
			containsPoint: function ( point ) {
	
				return point.x < this.min.x || point.x > this.max.x ||
					point.y < this.min.y || point.y > this.max.y ||
					point.z < this.min.z || point.z > this.max.z ? false : true;
	
			},
	
			containsBox: function ( box ) {
	
				return this.min.x <= box.min.x && box.max.x <= this.max.x &&
					this.min.y <= box.min.y && box.max.y <= this.max.y &&
					this.min.z <= box.min.z && box.max.z <= this.max.z;
	
			},
	
			getParameter: function ( point, optionalTarget ) {
	
				// This can potentially have a divide by zero if the box
				// has a size dimension of 0.
	
				var result = optionalTarget || new Vector3();
	
				return result.set(
					( point.x - this.min.x ) / ( this.max.x - this.min.x ),
					( point.y - this.min.y ) / ( this.max.y - this.min.y ),
					( point.z - this.min.z ) / ( this.max.z - this.min.z )
				);
	
			},
	
			intersectsBox: function ( box ) {
	
				// using 6 splitting planes to rule out intersections.
				return box.max.x < this.min.x || box.min.x > this.max.x ||
					box.max.y < this.min.y || box.min.y > this.max.y ||
					box.max.z < this.min.z || box.min.z > this.max.z ? false : true;
	
			},
	
			intersectsSphere: ( function () {
	
				var closestPoint = new Vector3();
	
				return function intersectsSphere( sphere ) {
	
					// Find the point on the AABB closest to the sphere center.
					this.clampPoint( sphere.center, closestPoint );
	
					// If that point is inside the sphere, the AABB and sphere intersect.
					return closestPoint.distanceToSquared( sphere.center ) <= ( sphere.radius * sphere.radius );
	
				};
	
			} )(),
	
			intersectsPlane: function ( plane ) {
	
				// We compute the minimum and maximum dot product values. If those values
				// are on the same side (back or front) of the plane, then there is no intersection.
	
				var min, max;
	
				if ( plane.normal.x > 0 ) {
	
					min = plane.normal.x * this.min.x;
					max = plane.normal.x * this.max.x;
	
				} else {
	
					min = plane.normal.x * this.max.x;
					max = plane.normal.x * this.min.x;
	
				}
	
				if ( plane.normal.y > 0 ) {
	
					min += plane.normal.y * this.min.y;
					max += plane.normal.y * this.max.y;
	
				} else {
	
					min += plane.normal.y * this.max.y;
					max += plane.normal.y * this.min.y;
	
				}
	
				if ( plane.normal.z > 0 ) {
	
					min += plane.normal.z * this.min.z;
					max += plane.normal.z * this.max.z;
	
				} else {
	
					min += plane.normal.z * this.max.z;
					max += plane.normal.z * this.min.z;
	
				}
	
				return ( min <= plane.constant && max >= plane.constant );
	
			},
	
			clampPoint: function ( point, optionalTarget ) {
	
				var result = optionalTarget || new Vector3();
				return result.copy( point ).clamp( this.min, this.max );
	
			},
	
			distanceToPoint: function () {
	
				var v1 = new Vector3();
	
				return function distanceToPoint( point ) {
	
					var clampedPoint = v1.copy( point ).clamp( this.min, this.max );
					return clampedPoint.sub( point ).length();
	
				};
	
			}(),
	
			getBoundingSphere: function () {
	
				var v1 = new Vector3();
	
				return function getBoundingSphere( optionalTarget ) {
	
					var result = optionalTarget || new Sphere();
	
					this.getCenter( result.center );
	
					result.radius = this.getSize( v1 ).length() * 0.5;
	
					return result;
	
				};
	
			}(),
	
			intersect: function ( box ) {
	
				this.min.max( box.min );
				this.max.min( box.max );
	
				// ensure that if there is no overlap, the result is fully empty, not slightly empty with non-inf/+inf values that will cause subsequence intersects to erroneously return valid values.
				if ( this.isEmpty() ) this.makeEmpty();
	
				return this;
	
			},
	
			union: function ( box ) {
	
				this.min.min( box.min );
				this.max.max( box.max );
	
				return this;
	
			},
	
			applyMatrix4: function () {
	
				var points = [
					new Vector3(),
					new Vector3(),
					new Vector3(),
					new Vector3(),
					new Vector3(),
					new Vector3(),
					new Vector3(),
					new Vector3()
				];
	
				return function applyMatrix4( matrix ) {
	
					// transform of empty box is an empty box.
					if ( this.isEmpty() ) return this;
	
					// NOTE: I am using a binary pattern to specify all 2^3 combinations below
					points[ 0 ].set( this.min.x, this.min.y, this.min.z ).applyMatrix4( matrix ); // 000
					points[ 1 ].set( this.min.x, this.min.y, this.max.z ).applyMatrix4( matrix ); // 001
					points[ 2 ].set( this.min.x, this.max.y, this.min.z ).applyMatrix4( matrix ); // 010
					points[ 3 ].set( this.min.x, this.max.y, this.max.z ).applyMatrix4( matrix ); // 011
					points[ 4 ].set( this.max.x, this.min.y, this.min.z ).applyMatrix4( matrix ); // 100
					points[ 5 ].set( this.max.x, this.min.y, this.max.z ).applyMatrix4( matrix ); // 101
					points[ 6 ].set( this.max.x, this.max.y, this.min.z ).applyMatrix4( matrix ); // 110
					points[ 7 ].set( this.max.x, this.max.y, this.max.z ).applyMatrix4( matrix );	// 111
	
					this.setFromPoints( points );
	
					return this;
	
				};
	
			}(),
	
			translate: function ( offset ) {
	
				this.min.add( offset );
				this.max.add( offset );
	
				return this;
	
			},
	
			equals: function ( box ) {
	
				return box.min.equals( this.min ) && box.max.equals( this.max );
	
			}
	
		} );
	
		/**
		 * @author bhouston / http://clara.io
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function Sphere( center, radius ) {
	
			this.center = ( center !== undefined ) ? center : new Vector3();
			this.radius = ( radius !== undefined ) ? radius : 0;
	
		}
	
		Object.assign( Sphere.prototype, {
	
			set: function ( center, radius ) {
	
				this.center.copy( center );
				this.radius = radius;
	
				return this;
	
			},
	
			setFromPoints: function () {
	
				var box = new Box3();
	
				return function setFromPoints( points, optionalCenter ) {
	
					var center = this.center;
	
					if ( optionalCenter !== undefined ) {
	
						center.copy( optionalCenter );
	
					} else {
	
						box.setFromPoints( points ).getCenter( center );
	
					}
	
					var maxRadiusSq = 0;
	
					for ( var i = 0, il = points.length; i < il; i ++ ) {
	
						maxRadiusSq = Math.max( maxRadiusSq, center.distanceToSquared( points[ i ] ) );
	
					}
	
					this.radius = Math.sqrt( maxRadiusSq );
	
					return this;
	
				};
	
			}(),
	
			clone: function () {
	
				return new this.constructor().copy( this );
	
			},
	
			copy: function ( sphere ) {
	
				this.center.copy( sphere.center );
				this.radius = sphere.radius;
	
				return this;
	
			},
	
			empty: function () {
	
				return ( this.radius <= 0 );
	
			},
	
			containsPoint: function ( point ) {
	
				return ( point.distanceToSquared( this.center ) <= ( this.radius * this.radius ) );
	
			},
	
			distanceToPoint: function ( point ) {
	
				return ( point.distanceTo( this.center ) - this.radius );
	
			},
	
			intersectsSphere: function ( sphere ) {
	
				var radiusSum = this.radius + sphere.radius;
	
				return sphere.center.distanceToSquared( this.center ) <= ( radiusSum * radiusSum );
	
			},
	
			intersectsBox: function ( box ) {
	
				return box.intersectsSphere( this );
	
			},
	
			intersectsPlane: function ( plane ) {
	
				return Math.abs( plane.distanceToPoint( this.center ) ) <= this.radius;
	
			},
	
			clampPoint: function ( point, optionalTarget ) {
	
				var deltaLengthSq = this.center.distanceToSquared( point );
	
				var result = optionalTarget || new Vector3();
	
				result.copy( point );
	
				if ( deltaLengthSq > ( this.radius * this.radius ) ) {
	
					result.sub( this.center ).normalize();
					result.multiplyScalar( this.radius ).add( this.center );
	
				}
	
				return result;
	
			},
	
			getBoundingBox: function ( optionalTarget ) {
	
				var box = optionalTarget || new Box3();
	
				box.set( this.center, this.center );
				box.expandByScalar( this.radius );
	
				return box;
	
			},
	
			applyMatrix4: function ( matrix ) {
	
				this.center.applyMatrix4( matrix );
				this.radius = this.radius * matrix.getMaxScaleOnAxis();
	
				return this;
	
			},
	
			translate: function ( offset ) {
	
				this.center.add( offset );
	
				return this;
	
			},
	
			equals: function ( sphere ) {
	
				return sphere.center.equals( this.center ) && ( sphere.radius === this.radius );
	
			}
	
		} );
	
		/**
		 * @author bhouston / http://clara.io
		 */
	
		function Plane( normal, constant ) {
	
			// normal is assumed to be normalized
	
			this.normal = ( normal !== undefined ) ? normal : new Vector3( 1, 0, 0 );
			this.constant = ( constant !== undefined ) ? constant : 0;
	
		}
	
		Object.assign( Plane.prototype, {
	
			set: function ( normal, constant ) {
	
				this.normal.copy( normal );
				this.constant = constant;
	
				return this;
	
			},
	
			setComponents: function ( x, y, z, w ) {
	
				this.normal.set( x, y, z );
				this.constant = w;
	
				return this;
	
			},
	
			setFromNormalAndCoplanarPoint: function ( normal, point ) {
	
				this.normal.copy( normal );
				this.constant = - point.dot( this.normal );
	
				return this;
	
			},
	
			setFromCoplanarPoints: function () {
	
				var v1 = new Vector3();
				var v2 = new Vector3();
	
				return function setFromCoplanarPoints( a, b, c ) {
	
					var normal = v1.subVectors( c, b ).cross( v2.subVectors( a, b ) ).normalize();
	
					// Q: should an error be thrown if normal is zero (e.g. degenerate plane)?
	
					this.setFromNormalAndCoplanarPoint( normal, a );
	
					return this;
	
				};
	
			}(),
	
			clone: function () {
	
				return new this.constructor().copy( this );
	
			},
	
			copy: function ( plane ) {
	
				this.normal.copy( plane.normal );
				this.constant = plane.constant;
	
				return this;
	
			},
	
			normalize: function () {
	
				// Note: will lead to a divide by zero if the plane is invalid.
	
				var inverseNormalLength = 1.0 / this.normal.length();
				this.normal.multiplyScalar( inverseNormalLength );
				this.constant *= inverseNormalLength;
	
				return this;
	
			},
	
			negate: function () {
	
				this.constant *= - 1;
				this.normal.negate();
	
				return this;
	
			},
	
			distanceToPoint: function ( point ) {
	
				return this.normal.dot( point ) + this.constant;
	
			},
	
			distanceToSphere: function ( sphere ) {
	
				return this.distanceToPoint( sphere.center ) - sphere.radius;
	
			},
	
			projectPoint: function ( point, optionalTarget ) {
	
				var result = optionalTarget || new Vector3();
	
				return result.copy( this.normal ).multiplyScalar( - this.distanceToPoint( point ) ).add( point );
	
			},
	
			intersectLine: function () {
	
				var v1 = new Vector3();
	
				return function intersectLine( line, optionalTarget ) {
	
					var result = optionalTarget || new Vector3();
	
					var direction = line.delta( v1 );
	
					var denominator = this.normal.dot( direction );
	
					if ( denominator === 0 ) {
	
						// line is coplanar, return origin
						if ( this.distanceToPoint( line.start ) === 0 ) {
	
							return result.copy( line.start );
	
						}
	
						// Unsure if this is the correct method to handle this case.
						return undefined;
	
					}
	
					var t = - ( line.start.dot( this.normal ) + this.constant ) / denominator;
	
					if ( t < 0 || t > 1 ) {
	
						return undefined;
	
					}
	
					return result.copy( direction ).multiplyScalar( t ).add( line.start );
	
				};
	
			}(),
	
			intersectsLine: function ( line ) {
	
				// Note: this tests if a line intersects the plane, not whether it (or its end-points) are coplanar with it.
	
				var startSign = this.distanceToPoint( line.start );
				var endSign = this.distanceToPoint( line.end );
	
				return ( startSign < 0 && endSign > 0 ) || ( endSign < 0 && startSign > 0 );
	
			},
	
			intersectsBox: function ( box ) {
	
				return box.intersectsPlane( this );
	
			},
	
			intersectsSphere: function ( sphere ) {
	
				return sphere.intersectsPlane( this );
	
			},
	
			coplanarPoint: function ( optionalTarget ) {
	
				var result = optionalTarget || new Vector3();
	
				return result.copy( this.normal ).multiplyScalar( - this.constant );
	
			},
	
			applyMatrix4: function () {
	
				var v1 = new Vector3();
				var m1 = new Matrix3();
	
				return function applyMatrix4( matrix, optionalNormalMatrix ) {
	
					var normalMatrix = optionalNormalMatrix || m1.getNormalMatrix( matrix );
	
					var referencePoint = this.coplanarPoint( v1 ).applyMatrix4( matrix );
	
					var normal = this.normal.applyMatrix3( normalMatrix ).normalize();
	
					this.constant = - referencePoint.dot( normal );
	
					return this;
	
				};
	
			}(),
	
			translate: function ( offset ) {
	
				this.constant -= offset.dot( this.normal );
	
				return this;
	
			},
	
			equals: function ( plane ) {
	
				return plane.normal.equals( this.normal ) && ( plane.constant === this.constant );
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author alteredq / http://alteredqualia.com/
		 * @author bhouston / http://clara.io
		 */
	
		function Frustum( p0, p1, p2, p3, p4, p5 ) {
	
			this.planes = [
	
				( p0 !== undefined ) ? p0 : new Plane(),
				( p1 !== undefined ) ? p1 : new Plane(),
				( p2 !== undefined ) ? p2 : new Plane(),
				( p3 !== undefined ) ? p3 : new Plane(),
				( p4 !== undefined ) ? p4 : new Plane(),
				( p5 !== undefined ) ? p5 : new Plane()
	
			];
	
		}
	
		Object.assign( Frustum.prototype, {
	
			set: function ( p0, p1, p2, p3, p4, p5 ) {
	
				var planes = this.planes;
	
				planes[ 0 ].copy( p0 );
				planes[ 1 ].copy( p1 );
				planes[ 2 ].copy( p2 );
				planes[ 3 ].copy( p3 );
				planes[ 4 ].copy( p4 );
				planes[ 5 ].copy( p5 );
	
				return this;
	
			},
	
			clone: function () {
	
				return new this.constructor().copy( this );
	
			},
	
			copy: function ( frustum ) {
	
				var planes = this.planes;
	
				for ( var i = 0; i < 6; i ++ ) {
	
					planes[ i ].copy( frustum.planes[ i ] );
	
				}
	
				return this;
	
			},
	
			setFromMatrix: function ( m ) {
	
				var planes = this.planes;
				var me = m.elements;
				var me0 = me[ 0 ], me1 = me[ 1 ], me2 = me[ 2 ], me3 = me[ 3 ];
				var me4 = me[ 4 ], me5 = me[ 5 ], me6 = me[ 6 ], me7 = me[ 7 ];
				var me8 = me[ 8 ], me9 = me[ 9 ], me10 = me[ 10 ], me11 = me[ 11 ];
				var me12 = me[ 12 ], me13 = me[ 13 ], me14 = me[ 14 ], me15 = me[ 15 ];
	
				planes[ 0 ].setComponents( me3 - me0, me7 - me4, me11 - me8, me15 - me12 ).normalize();
				planes[ 1 ].setComponents( me3 + me0, me7 + me4, me11 + me8, me15 + me12 ).normalize();
				planes[ 2 ].setComponents( me3 + me1, me7 + me5, me11 + me9, me15 + me13 ).normalize();
				planes[ 3 ].setComponents( me3 - me1, me7 - me5, me11 - me9, me15 - me13 ).normalize();
				planes[ 4 ].setComponents( me3 - me2, me7 - me6, me11 - me10, me15 - me14 ).normalize();
				planes[ 5 ].setComponents( me3 + me2, me7 + me6, me11 + me10, me15 + me14 ).normalize();
	
				return this;
	
			},
	
			intersectsObject: function () {
	
				var sphere = new Sphere();
	
				return function intersectsObject( object ) {
	
					var geometry = object.geometry;
	
					if ( geometry.boundingSphere === null )
						geometry.computeBoundingSphere();
	
					sphere.copy( geometry.boundingSphere )
						.applyMatrix4( object.matrixWorld );
	
					return this.intersectsSphere( sphere );
	
				};
	
			}(),
	
			intersectsSprite: function () {
	
				var sphere = new Sphere();
	
				return function intersectsSprite( sprite ) {
	
					sphere.center.set( 0, 0, 0 );
					sphere.radius = 0.7071067811865476;
					sphere.applyMatrix4( sprite.matrixWorld );
	
					return this.intersectsSphere( sphere );
	
				};
	
			}(),
	
			intersectsSphere: function ( sphere ) {
	
				var planes = this.planes;
				var center = sphere.center;
				var negRadius = - sphere.radius;
	
				for ( var i = 0; i < 6; i ++ ) {
	
					var distance = planes[ i ].distanceToPoint( center );
	
					if ( distance < negRadius ) {
	
						return false;
	
					}
	
				}
	
				return true;
	
			},
	
			intersectsBox: function () {
	
				var p1 = new Vector3(),
					p2 = new Vector3();
	
				return function intersectsBox( box ) {
	
					var planes = this.planes;
	
					for ( var i = 0; i < 6; i ++ ) {
	
						var plane = planes[ i ];
	
						p1.x = plane.normal.x > 0 ? box.min.x : box.max.x;
						p2.x = plane.normal.x > 0 ? box.max.x : box.min.x;
						p1.y = plane.normal.y > 0 ? box.min.y : box.max.y;
						p2.y = plane.normal.y > 0 ? box.max.y : box.min.y;
						p1.z = plane.normal.z > 0 ? box.min.z : box.max.z;
						p2.z = plane.normal.z > 0 ? box.max.z : box.min.z;
	
						var d1 = plane.distanceToPoint( p1 );
						var d2 = plane.distanceToPoint( p2 );
	
						// if both outside plane, no intersection
	
						if ( d1 < 0 && d2 < 0 ) {
	
							return false;
	
						}
	
					}
	
					return true;
	
				};
	
			}(),
	
			containsPoint: function ( point ) {
	
				var planes = this.planes;
	
				for ( var i = 0; i < 6; i ++ ) {
	
					if ( planes[ i ].distanceToPoint( point ) < 0 ) {
	
						return false;
	
					}
	
				}
	
				return true;
	
			}
	
		} );
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function WebGLShadowMap( _renderer, _objects, maxTextureSize ) {
	
			var _frustum = new Frustum(),
				_projScreenMatrix = new Matrix4(),
	
				_shadowMapSize = new Vector2(),
				_maxShadowMapSize = new Vector2( maxTextureSize, maxTextureSize ),
	
				_lookTarget = new Vector3(),
				_lightPositionWorld = new Vector3(),
	
				_MorphingFlag = 1,
				_SkinningFlag = 2,
	
				_NumberOfMaterialVariants = ( _MorphingFlag | _SkinningFlag ) + 1,
	
				_depthMaterials = new Array( _NumberOfMaterialVariants ),
				_distanceMaterials = new Array( _NumberOfMaterialVariants ),
	
				_materialCache = {};
	
			var cubeDirections = [
				new Vector3( 1, 0, 0 ), new Vector3( - 1, 0, 0 ), new Vector3( 0, 0, 1 ),
				new Vector3( 0, 0, - 1 ), new Vector3( 0, 1, 0 ), new Vector3( 0, - 1, 0 )
			];
	
			var cubeUps = [
				new Vector3( 0, 1, 0 ), new Vector3( 0, 1, 0 ), new Vector3( 0, 1, 0 ),
				new Vector3( 0, 1, 0 ), new Vector3( 0, 0, 1 ),	new Vector3( 0, 0, - 1 )
			];
	
			var cube2DViewPorts = [
				new Vector4(), new Vector4(), new Vector4(),
				new Vector4(), new Vector4(), new Vector4()
			];
	
			// init
	
			for ( var i = 0; i !== _NumberOfMaterialVariants; ++ i ) {
	
				var useMorphing = ( i & _MorphingFlag ) !== 0;
				var useSkinning = ( i & _SkinningFlag ) !== 0;
	
				var depthMaterial = new MeshDepthMaterial( {
	
					depthPacking: RGBADepthPacking,
	
					morphTargets: useMorphing,
					skinning: useSkinning
	
				} );
	
				_depthMaterials[ i ] = depthMaterial;
	
				//
	
				var distanceMaterial = new MeshDistanceMaterial( {
	
					morphTargets: useMorphing,
					skinning: useSkinning
	
				} );
	
				_distanceMaterials[ i ] = distanceMaterial;
	
			}
	
			//
	
			var scope = this;
	
			this.enabled = false;
	
			this.autoUpdate = true;
			this.needsUpdate = false;
	
			this.type = PCFShadowMap;
	
			this.renderReverseSided = true;
			this.renderSingleSided = true;
	
			this.render = function ( lights, scene, camera ) {
	
				if ( scope.enabled === false ) return;
				if ( scope.autoUpdate === false && scope.needsUpdate === false ) return;
	
				if ( lights.length === 0 ) return;
	
				// TODO Clean up (needed in case of contextlost)
				var _gl = _renderer.context;
				var _state = _renderer.state;
	
				// Set GL state for depth map.
				_state.disable( _gl.BLEND );
				_state.buffers.color.setClear( 1, 1, 1, 1 );
				_state.buffers.depth.setTest( true );
				_state.setScissorTest( false );
	
				// render depth map
	
				var faceCount;
	
				for ( var i = 0, il = lights.length; i < il; i ++ ) {
	
					var light = lights[ i ];
					var shadow = light.shadow;
					var isPointLight = light && light.isPointLight;
	
					if ( shadow === undefined ) {
	
						console.warn( 'THREE.WebGLShadowMap:', light, 'has no shadow.' );
						continue;
	
					}
	
					var shadowCamera = shadow.camera;
	
					_shadowMapSize.copy( shadow.mapSize );
					_shadowMapSize.min( _maxShadowMapSize );
	
					if ( isPointLight ) {
	
						var vpWidth = _shadowMapSize.x;
						var vpHeight = _shadowMapSize.y;
	
						// These viewports map a cube-map onto a 2D texture with the
						// following orientation:
						//
						//  xzXZ
						//   y Y
						//
						// X - Positive x direction
						// x - Negative x direction
						// Y - Positive y direction
						// y - Negative y direction
						// Z - Positive z direction
						// z - Negative z direction
	
						// positive X
						cube2DViewPorts[ 0 ].set( vpWidth * 2, vpHeight, vpWidth, vpHeight );
						// negative X
						cube2DViewPorts[ 1 ].set( 0, vpHeight, vpWidth, vpHeight );
						// positive Z
						cube2DViewPorts[ 2 ].set( vpWidth * 3, vpHeight, vpWidth, vpHeight );
						// negative Z
						cube2DViewPorts[ 3 ].set( vpWidth, vpHeight, vpWidth, vpHeight );
						// positive Y
						cube2DViewPorts[ 4 ].set( vpWidth * 3, 0, vpWidth, vpHeight );
						// negative Y
						cube2DViewPorts[ 5 ].set( vpWidth, 0, vpWidth, vpHeight );
	
						_shadowMapSize.x *= 4.0;
						_shadowMapSize.y *= 2.0;
	
					}
	
					if ( shadow.map === null ) {
	
						var pars = { minFilter: NearestFilter, magFilter: NearestFilter, format: RGBAFormat };
	
						shadow.map = new WebGLRenderTarget( _shadowMapSize.x, _shadowMapSize.y, pars );
						shadow.map.texture.name = light.name + ".shadowMap";
	
						shadowCamera.updateProjectionMatrix();
	
					}
	
					if ( shadow.isSpotLightShadow ) {
	
						shadow.update( light );
	
					}
	
					var shadowMap = shadow.map;
					var shadowMatrix = shadow.matrix;
	
					_lightPositionWorld.setFromMatrixPosition( light.matrixWorld );
					shadowCamera.position.copy( _lightPositionWorld );
	
					if ( isPointLight ) {
	
						faceCount = 6;
	
						// for point lights we set the shadow matrix to be a translation-only matrix
						// equal to inverse of the light's position
	
						shadowMatrix.makeTranslation( - _lightPositionWorld.x, - _lightPositionWorld.y, - _lightPositionWorld.z );
	
					} else {
	
						faceCount = 1;
	
						_lookTarget.setFromMatrixPosition( light.target.matrixWorld );
						shadowCamera.lookAt( _lookTarget );
						shadowCamera.updateMatrixWorld();
	
						// compute shadow matrix
	
						shadowMatrix.set(
							0.5, 0.0, 0.0, 0.5,
							0.0, 0.5, 0.0, 0.5,
							0.0, 0.0, 0.5, 0.5,
							0.0, 0.0, 0.0, 1.0
						);
	
						shadowMatrix.multiply( shadowCamera.projectionMatrix );
						shadowMatrix.multiply( shadowCamera.matrixWorldInverse );
	
					}
	
					_renderer.setRenderTarget( shadowMap );
					_renderer.clear();
	
					// render shadow map for each cube face (if omni-directional) or
					// run a single pass if not
	
					for ( var face = 0; face < faceCount; face ++ ) {
	
						if ( isPointLight ) {
	
							_lookTarget.copy( shadowCamera.position );
							_lookTarget.add( cubeDirections[ face ] );
							shadowCamera.up.copy( cubeUps[ face ] );
							shadowCamera.lookAt( _lookTarget );
							shadowCamera.updateMatrixWorld();
	
							var vpDimensions = cube2DViewPorts[ face ];
							_state.viewport( vpDimensions );
	
						}
	
						// update camera matrices and frustum
	
						_projScreenMatrix.multiplyMatrices( shadowCamera.projectionMatrix, shadowCamera.matrixWorldInverse );
						_frustum.setFromMatrix( _projScreenMatrix );
	
						// set object matrices & frustum culling
	
						renderObject( scene, camera, shadowCamera, isPointLight );
	
					}
	
				}
	
				scope.needsUpdate = false;
	
			};
	
			function getDepthMaterial( object, material, isPointLight, lightPositionWorld, shadowCameraNear, shadowCameraFar ) {
	
				var geometry = object.geometry;
	
				var result = null;
	
				var materialVariants = _depthMaterials;
				var customMaterial = object.customDepthMaterial;
	
				if ( isPointLight ) {
	
					materialVariants = _distanceMaterials;
					customMaterial = object.customDistanceMaterial;
	
				}
	
				if ( ! customMaterial ) {
	
					var useMorphing = false;
	
					if ( material.morphTargets ) {
	
						if ( geometry && geometry.isBufferGeometry ) {
	
							useMorphing = geometry.morphAttributes && geometry.morphAttributes.position && geometry.morphAttributes.position.length > 0;
	
						} else if ( geometry && geometry.isGeometry ) {
	
							useMorphing = geometry.morphTargets && geometry.morphTargets.length > 0;
	
						}
	
					}
	
					if ( object.isSkinnedMesh && material.skinning === false ) {
	
						console.warn( 'THREE.WebGLShadowMap: THREE.SkinnedMesh with material.skinning set to false:', object );
	
					}
	
					var useSkinning = object.isSkinnedMesh && material.skinning;
	
					var variantIndex = 0;
	
					if ( useMorphing ) variantIndex |= _MorphingFlag;
					if ( useSkinning ) variantIndex |= _SkinningFlag;
	
					result = materialVariants[ variantIndex ];
	
				} else {
	
					result = customMaterial;
	
				}
	
				if ( _renderer.localClippingEnabled &&
						material.clipShadows === true &&
						material.clippingPlanes.length !== 0 ) {
	
					// in this case we need a unique material instance reflecting the
					// appropriate state
	
					var keyA = result.uuid, keyB = material.uuid;
	
					var materialsForVariant = _materialCache[ keyA ];
	
					if ( materialsForVariant === undefined ) {
	
						materialsForVariant = {};
						_materialCache[ keyA ] = materialsForVariant;
	
					}
	
					var cachedMaterial = materialsForVariant[ keyB ];
	
					if ( cachedMaterial === undefined ) {
	
						cachedMaterial = result.clone();
						materialsForVariant[ keyB ] = cachedMaterial;
	
					}
	
					result = cachedMaterial;
	
				}
	
				result.visible = material.visible;
				result.wireframe = material.wireframe;
	
				var side = material.side;
	
				if ( scope.renderSingleSided && side == DoubleSide ) {
	
					side = FrontSide;
	
				}
	
				if ( scope.renderReverseSided ) {
	
					if ( side === FrontSide ) side = BackSide;
					else if ( side === BackSide ) side = FrontSide;
	
				}
	
				result.side = side;
	
				result.clipShadows = material.clipShadows;
				result.clippingPlanes = material.clippingPlanes;
				result.clipIntersection = material.clipIntersection;
	
				result.wireframeLinewidth = material.wireframeLinewidth;
				result.linewidth = material.linewidth;
	
				if ( isPointLight && result.isMeshDistanceMaterial ) {
	
					result.referencePosition.copy( lightPositionWorld );
					result.nearDistance = shadowCameraNear;
					result.farDistance = shadowCameraFar;
	
				}
	
				return result;
	
			}
	
			function renderObject( object, camera, shadowCamera, isPointLight ) {
	
				if ( object.visible === false ) return;
	
				var visible = object.layers.test( camera.layers );
	
				if ( visible && ( object.isMesh || object.isLine || object.isPoints ) ) {
	
					if ( object.castShadow && ( ! object.frustumCulled || _frustum.intersectsObject( object ) ) ) {
	
						object.modelViewMatrix.multiplyMatrices( shadowCamera.matrixWorldInverse, object.matrixWorld );
	
						var geometry = _objects.update( object );
						var material = object.material;
	
						if ( Array.isArray( material ) ) {
	
							var groups = geometry.groups;
	
							for ( var k = 0, kl = groups.length; k < kl; k ++ ) {
	
								var group = groups[ k ];
								var groupMaterial = material[ group.materialIndex ];
	
								if ( groupMaterial && groupMaterial.visible ) {
	
									var depthMaterial = getDepthMaterial( object, groupMaterial, isPointLight, _lightPositionWorld, shadowCamera.near, shadowCamera.far );
									_renderer.renderBufferDirect( shadowCamera, null, geometry, depthMaterial, object, group );
	
								}
	
							}
	
						} else if ( material.visible ) {
	
							var depthMaterial = getDepthMaterial( object, material, isPointLight, _lightPositionWorld, shadowCamera.near, shadowCamera.far );
							_renderer.renderBufferDirect( shadowCamera, null, geometry, depthMaterial, object, null );
	
						}
	
					}
	
				}
	
				var children = object.children;
	
				for ( var i = 0, l = children.length; i < l; i ++ ) {
	
					renderObject( children[ i ], camera, shadowCamera, isPointLight );
	
				}
	
			}
	
		}
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function WebGLAttributes( gl ) {
	
			var buffers = {};
	
			function createBuffer( attribute, bufferType ) {
	
				var array = attribute.array;
				var usage = attribute.dynamic ? gl.DYNAMIC_DRAW : gl.STATIC_DRAW;
	
				var buffer = gl.createBuffer();
	
				gl.bindBuffer( bufferType, buffer );
				gl.bufferData( bufferType, array, usage );
	
				attribute.onUploadCallback();
	
				var type = gl.FLOAT;
	
				if ( array instanceof Float32Array ) {
	
					type = gl.FLOAT;
	
				} else if ( array instanceof Float64Array ) {
	
					console.warn( 'THREE.WebGLAttributes: Unsupported data buffer format: Float64Array.' );
	
				} else if ( array instanceof Uint16Array ) {
	
					type = gl.UNSIGNED_SHORT;
	
				} else if ( array instanceof Int16Array ) {
	
					type = gl.SHORT;
	
				} else if ( array instanceof Uint32Array ) {
	
					type = gl.UNSIGNED_INT;
	
				} else if ( array instanceof Int32Array ) {
	
					type = gl.INT;
	
				} else if ( array instanceof Int8Array ) {
	
					type = gl.BYTE;
	
				} else if ( array instanceof Uint8Array ) {
	
					type = gl.UNSIGNED_BYTE;
	
				}
	
				return {
					buffer: buffer,
					type: type,
					bytesPerElement: array.BYTES_PER_ELEMENT,
					version: attribute.version
				};
	
			}
	
			function updateBuffer( buffer, attribute, bufferType ) {
	
				var array = attribute.array;
				var updateRange = attribute.updateRange;
	
				gl.bindBuffer( bufferType, buffer );
	
				if ( attribute.dynamic === false ) {
	
					gl.bufferData( bufferType, array, gl.STATIC_DRAW );
	
				} else if ( updateRange.count === - 1 ) {
	
					// Not using update ranges
	
					gl.bufferSubData( bufferType, 0, array );
	
				} else if ( updateRange.count === 0 ) {
	
					console.error( 'THREE.WebGLObjects.updateBuffer: dynamic THREE.BufferAttribute marked as needsUpdate but updateRange.count is 0, ensure you are using set methods or updating manually.' );
	
				} else {
	
					gl.bufferSubData( bufferType, updateRange.offset * array.BYTES_PER_ELEMENT,
						array.subarray( updateRange.offset, updateRange.offset + updateRange.count ) );
	
					updateRange.count = - 1; // reset range
	
				}
	
			}
	
			//
	
			function get( attribute ) {
	
				if ( attribute.isInterleavedBufferAttribute ) attribute = attribute.data;
	
				return buffers[ attribute.uuid ];
	
			}
	
			function remove( attribute ) {
	
				if ( attribute.isInterleavedBufferAttribute ) attribute = attribute.data;
	
				var data = buffers[ attribute.uuid ];
	
				if ( data ) {
	
					gl.deleteBuffer( data.buffer );
	
					delete buffers[ attribute.uuid ];
	
				}
	
			}
	
			function update( attribute, bufferType ) {
	
				if ( attribute.isInterleavedBufferAttribute ) attribute = attribute.data;
	
				var data = buffers[ attribute.uuid ];
	
				if ( data === undefined ) {
	
					buffers[ attribute.uuid ] = createBuffer( attribute, bufferType );
	
				} else if ( data.version < attribute.version ) {
	
					updateBuffer( data.buffer, attribute, bufferType );
	
					data.version = attribute.version;
	
				}
	
			}
	
			return {
	
				get: get,
				remove: remove,
				update: update
	
			};
	
		}
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author WestLangley / http://github.com/WestLangley
		 * @author bhouston / http://clara.io
		 */
	
		function Euler( x, y, z, order ) {
	
			this._x = x || 0;
			this._y = y || 0;
			this._z = z || 0;
			this._order = order || Euler.DefaultOrder;
	
		}
	
		Euler.RotationOrders = [ 'XYZ', 'YZX', 'ZXY', 'XZY', 'YXZ', 'ZYX' ];
	
		Euler.DefaultOrder = 'XYZ';
	
		Object.defineProperties( Euler.prototype, {
	
			x: {
	
				get: function () {
	
					return this._x;
	
				},
	
				set: function ( value ) {
	
					this._x = value;
					this.onChangeCallback();
	
				}
	
			},
	
			y: {
	
				get: function () {
	
					return this._y;
	
				},
	
				set: function ( value ) {
	
					this._y = value;
					this.onChangeCallback();
	
				}
	
			},
	
			z: {
	
				get: function () {
	
					return this._z;
	
				},
	
				set: function ( value ) {
	
					this._z = value;
					this.onChangeCallback();
	
				}
	
			},
	
			order: {
	
				get: function () {
	
					return this._order;
	
				},
	
				set: function ( value ) {
	
					this._order = value;
					this.onChangeCallback();
	
				}
	
			}
	
		} );
	
		Object.assign( Euler.prototype, {
	
			isEuler: true,
	
			set: function ( x, y, z, order ) {
	
				this._x = x;
				this._y = y;
				this._z = z;
				this._order = order || this._order;
	
				this.onChangeCallback();
	
				return this;
	
			},
	
			clone: function () {
	
				return new this.constructor( this._x, this._y, this._z, this._order );
	
			},
	
			copy: function ( euler ) {
	
				this._x = euler._x;
				this._y = euler._y;
				this._z = euler._z;
				this._order = euler._order;
	
				this.onChangeCallback();
	
				return this;
	
			},
	
			setFromRotationMatrix: function ( m, order, update ) {
	
				var clamp = _Math.clamp;
	
				// assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
	
				var te = m.elements;
				var m11 = te[ 0 ], m12 = te[ 4 ], m13 = te[ 8 ];
				var m21 = te[ 1 ], m22 = te[ 5 ], m23 = te[ 9 ];
				var m31 = te[ 2 ], m32 = te[ 6 ], m33 = te[ 10 ];
	
				order = order || this._order;
	
				if ( order === 'XYZ' ) {
	
					this._y = Math.asin( clamp( m13, - 1, 1 ) );
	
					if ( Math.abs( m13 ) < 0.99999 ) {
	
						this._x = Math.atan2( - m23, m33 );
						this._z = Math.atan2( - m12, m11 );
	
					} else {
	
						this._x = Math.atan2( m32, m22 );
						this._z = 0;
	
					}
	
				} else if ( order === 'YXZ' ) {
	
					this._x = Math.asin( - clamp( m23, - 1, 1 ) );
	
					if ( Math.abs( m23 ) < 0.99999 ) {
	
						this._y = Math.atan2( m13, m33 );
						this._z = Math.atan2( m21, m22 );
	
					} else {
	
						this._y = Math.atan2( - m31, m11 );
						this._z = 0;
	
					}
	
				} else if ( order === 'ZXY' ) {
	
					this._x = Math.asin( clamp( m32, - 1, 1 ) );
	
					if ( Math.abs( m32 ) < 0.99999 ) {
	
						this._y = Math.atan2( - m31, m33 );
						this._z = Math.atan2( - m12, m22 );
	
					} else {
	
						this._y = 0;
						this._z = Math.atan2( m21, m11 );
	
					}
	
				} else if ( order === 'ZYX' ) {
	
					this._y = Math.asin( - clamp( m31, - 1, 1 ) );
	
					if ( Math.abs( m31 ) < 0.99999 ) {
	
						this._x = Math.atan2( m32, m33 );
						this._z = Math.atan2( m21, m11 );
	
					} else {
	
						this._x = 0;
						this._z = Math.atan2( - m12, m22 );
	
					}
	
				} else if ( order === 'YZX' ) {
	
					this._z = Math.asin( clamp( m21, - 1, 1 ) );
	
					if ( Math.abs( m21 ) < 0.99999 ) {
	
						this._x = Math.atan2( - m23, m22 );
						this._y = Math.atan2( - m31, m11 );
	
					} else {
	
						this._x = 0;
						this._y = Math.atan2( m13, m33 );
	
					}
	
				} else if ( order === 'XZY' ) {
	
					this._z = Math.asin( - clamp( m12, - 1, 1 ) );
	
					if ( Math.abs( m12 ) < 0.99999 ) {
	
						this._x = Math.atan2( m32, m22 );
						this._y = Math.atan2( m13, m11 );
	
					} else {
	
						this._x = Math.atan2( - m23, m33 );
						this._y = 0;
	
					}
	
				} else {
	
					console.warn( 'THREE.Euler: .setFromRotationMatrix() given unsupported order: ' + order );
	
				}
	
				this._order = order;
	
				if ( update !== false ) this.onChangeCallback();
	
				return this;
	
			},
	
			setFromQuaternion: function () {
	
				var matrix = new Matrix4();
	
				return function setFromQuaternion( q, order, update ) {
	
					matrix.makeRotationFromQuaternion( q );
	
					return this.setFromRotationMatrix( matrix, order, update );
	
				};
	
			}(),
	
			setFromVector3: function ( v, order ) {
	
				return this.set( v.x, v.y, v.z, order || this._order );
	
			},
	
			reorder: function () {
	
				// WARNING: this discards revolution information -bhouston
	
				var q = new Quaternion();
	
				return function reorder( newOrder ) {
	
					q.setFromEuler( this );
	
					return this.setFromQuaternion( q, newOrder );
	
				};
	
			}(),
	
			equals: function ( euler ) {
	
				return ( euler._x === this._x ) && ( euler._y === this._y ) && ( euler._z === this._z ) && ( euler._order === this._order );
	
			},
	
			fromArray: function ( array ) {
	
				this._x = array[ 0 ];
				this._y = array[ 1 ];
				this._z = array[ 2 ];
				if ( array[ 3 ] !== undefined ) this._order = array[ 3 ];
	
				this.onChangeCallback();
	
				return this;
	
			},
	
			toArray: function ( array, offset ) {
	
				if ( array === undefined ) array = [];
				if ( offset === undefined ) offset = 0;
	
				array[ offset ] = this._x;
				array[ offset + 1 ] = this._y;
				array[ offset + 2 ] = this._z;
				array[ offset + 3 ] = this._order;
	
				return array;
	
			},
	
			toVector3: function ( optionalResult ) {
	
				if ( optionalResult ) {
	
					return optionalResult.set( this._x, this._y, this._z );
	
				} else {
	
					return new Vector3( this._x, this._y, this._z );
	
				}
	
			},
	
			onChange: function ( callback ) {
	
				this.onChangeCallback = callback;
	
				return this;
	
			},
	
			onChangeCallback: function () {}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function Layers() {
	
			this.mask = 1 | 0;
	
		}
	
		Object.assign( Layers.prototype, {
	
			set: function ( channel ) {
	
				this.mask = 1 << channel | 0;
	
			},
	
			enable: function ( channel ) {
	
				this.mask |= 1 << channel | 0;
	
			},
	
			toggle: function ( channel ) {
	
				this.mask ^= 1 << channel | 0;
	
			},
	
			disable: function ( channel ) {
	
				this.mask &= ~ ( 1 << channel | 0 );
	
			},
	
			test: function ( layers ) {
	
				return ( this.mask & layers.mask ) !== 0;
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author mikael emtinger / http://gomo.se/
		 * @author alteredq / http://alteredqualia.com/
		 * @author WestLangley / http://github.com/WestLangley
		 * @author elephantatwork / www.elephantatwork.ch
		 */
	
		var object3DId = 0;
	
		function Object3D() {
	
			Object.defineProperty( this, 'id', { value: object3DId ++ } );
	
			this.uuid = _Math.generateUUID();
	
			this.name = '';
			this.type = 'Object3D';
	
			this.parent = null;
			this.children = [];
	
			this.up = Object3D.DefaultUp.clone();
	
			var position = new Vector3();
			var rotation = new Euler();
			var quaternion = new Quaternion();
			var scale = new Vector3( 1, 1, 1 );
	
			function onRotationChange() {
	
				quaternion.setFromEuler( rotation, false );
	
			}
	
			function onQuaternionChange() {
	
				rotation.setFromQuaternion( quaternion, undefined, false );
	
			}
	
			rotation.onChange( onRotationChange );
			quaternion.onChange( onQuaternionChange );
	
			Object.defineProperties( this, {
				position: {
					enumerable: true,
					value: position
				},
				rotation: {
					enumerable: true,
					value: rotation
				},
				quaternion: {
					enumerable: true,
					value: quaternion
				},
				scale: {
					enumerable: true,
					value: scale
				},
				modelViewMatrix: {
					value: new Matrix4()
				},
				normalMatrix: {
					value: new Matrix3()
				}
			} );
	
			this.matrix = new Matrix4();
			this.matrixWorld = new Matrix4();
	
			this.matrixAutoUpdate = Object3D.DefaultMatrixAutoUpdate;
			this.matrixWorldNeedsUpdate = false;
	
			this.layers = new Layers();
			this.visible = true;
	
			this.castShadow = false;
			this.receiveShadow = false;
	
			this.frustumCulled = true;
			this.renderOrder = 0;
	
			this.userData = {};
	
		}
	
		Object3D.DefaultUp = new Vector3( 0, 1, 0 );
		Object3D.DefaultMatrixAutoUpdate = true;
	
		Object3D.prototype = Object.assign( Object.create( EventDispatcher.prototype ), {
	
			constructor: Object3D,
	
			isObject3D: true,
	
			onBeforeRender: function () {},
			onAfterRender: function () {},
	
			applyMatrix: function ( matrix ) {
	
				this.matrix.multiplyMatrices( matrix, this.matrix );
	
				this.matrix.decompose( this.position, this.quaternion, this.scale );
	
			},
	
			applyQuaternion: function ( q ) {
	
				this.quaternion.premultiply( q );
	
				return this;
	
			},
	
			setRotationFromAxisAngle: function ( axis, angle ) {
	
				// assumes axis is normalized
	
				this.quaternion.setFromAxisAngle( axis, angle );
	
			},
	
			setRotationFromEuler: function ( euler ) {
	
				this.quaternion.setFromEuler( euler, true );
	
			},
	
			setRotationFromMatrix: function ( m ) {
	
				// assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
	
				this.quaternion.setFromRotationMatrix( m );
	
			},
	
			setRotationFromQuaternion: function ( q ) {
	
				// assumes q is normalized
	
				this.quaternion.copy( q );
	
			},
	
			rotateOnAxis: function () {
	
				// rotate object on axis in object space
				// axis is assumed to be normalized
	
				var q1 = new Quaternion();
	
				return function rotateOnAxis( axis, angle ) {
	
					q1.setFromAxisAngle( axis, angle );
	
					this.quaternion.multiply( q1 );
	
					return this;
	
				};
	
			}(),
	
			rotateOnWorldAxis: function () {
	
				// rotate object on axis in world space
				// axis is assumed to be normalized
				// method assumes no rotated parent
	
				var q1 = new Quaternion();
	
				return function rotateOnWorldAxis( axis, angle ) {
	
					q1.setFromAxisAngle( axis, angle );
	
					this.quaternion.premultiply( q1 );
	
					return this;
	
				};
	
			}(),
	
			rotateX: function () {
	
				var v1 = new Vector3( 1, 0, 0 );
	
				return function rotateX( angle ) {
	
					return this.rotateOnAxis( v1, angle );
	
				};
	
			}(),
	
			rotateY: function () {
	
				var v1 = new Vector3( 0, 1, 0 );
	
				return function rotateY( angle ) {
	
					return this.rotateOnAxis( v1, angle );
	
				};
	
			}(),
	
			rotateZ: function () {
	
				var v1 = new Vector3( 0, 0, 1 );
	
				return function rotateZ( angle ) {
	
					return this.rotateOnAxis( v1, angle );
	
				};
	
			}(),
	
			translateOnAxis: function () {
	
				// translate object by distance along axis in object space
				// axis is assumed to be normalized
	
				var v1 = new Vector3();
	
				return function translateOnAxis( axis, distance ) {
	
					v1.copy( axis ).applyQuaternion( this.quaternion );
	
					this.position.add( v1.multiplyScalar( distance ) );
	
					return this;
	
				};
	
			}(),
	
			translateX: function () {
	
				var v1 = new Vector3( 1, 0, 0 );
	
				return function translateX( distance ) {
	
					return this.translateOnAxis( v1, distance );
	
				};
	
			}(),
	
			translateY: function () {
	
				var v1 = new Vector3( 0, 1, 0 );
	
				return function translateY( distance ) {
	
					return this.translateOnAxis( v1, distance );
	
				};
	
			}(),
	
			translateZ: function () {
	
				var v1 = new Vector3( 0, 0, 1 );
	
				return function translateZ( distance ) {
	
					return this.translateOnAxis( v1, distance );
	
				};
	
			}(),
	
			localToWorld: function ( vector ) {
	
				return vector.applyMatrix4( this.matrixWorld );
	
			},
	
			worldToLocal: function () {
	
				var m1 = new Matrix4();
	
				return function worldToLocal( vector ) {
	
					return vector.applyMatrix4( m1.getInverse( this.matrixWorld ) );
	
				};
	
			}(),
	
			lookAt: function () {
	
				// This method does not support objects with rotated and/or translated parent(s)
	
				var m1 = new Matrix4();
				var vector = new Vector3();
	
				return function lookAt( x, y, z ) {
	
					if ( x.isVector3 ) {
	
						vector.copy( x );
	
					} else {
	
						vector.set( x, y, z );
	
					}
	
					if ( this.isCamera ) {
	
						m1.lookAt( this.position, vector, this.up );
	
					} else {
	
						m1.lookAt( vector, this.position, this.up );
	
					}
	
					this.quaternion.setFromRotationMatrix( m1 );
	
				};
	
			}(),
	
			add: function ( object ) {
	
				if ( arguments.length > 1 ) {
	
					for ( var i = 0; i < arguments.length; i ++ ) {
	
						this.add( arguments[ i ] );
	
					}
	
					return this;
	
				}
	
				if ( object === this ) {
	
					console.error( "THREE.Object3D.add: object can't be added as a child of itself.", object );
					return this;
	
				}
	
				if ( ( object && object.isObject3D ) ) {
	
					if ( object.parent !== null ) {
	
						object.parent.remove( object );
	
					}
	
					object.parent = this;
					object.dispatchEvent( { type: 'added' } );
	
					this.children.push( object );
	
				} else {
	
					console.error( "THREE.Object3D.add: object not an instance of THREE.Object3D.", object );
	
				}
	
				return this;
	
			},
	
			remove: function ( object ) {
	
				if ( arguments.length > 1 ) {
	
					for ( var i = 0; i < arguments.length; i ++ ) {
	
						this.remove( arguments[ i ] );
	
					}
	
					return this;
	
				}
	
				var index = this.children.indexOf( object );
	
				if ( index !== - 1 ) {
	
					object.parent = null;
	
					object.dispatchEvent( { type: 'removed' } );
	
					this.children.splice( index, 1 );
	
				}
	
				return this;
	
			},
	
			getObjectById: function ( id ) {
	
				return this.getObjectByProperty( 'id', id );
	
			},
	
			getObjectByName: function ( name ) {
	
				return this.getObjectByProperty( 'name', name );
	
			},
	
			getObjectByProperty: function ( name, value ) {
	
				if ( this[ name ] === value ) return this;
	
				for ( var i = 0, l = this.children.length; i < l; i ++ ) {
	
					var child = this.children[ i ];
					var object = child.getObjectByProperty( name, value );
	
					if ( object !== undefined ) {
	
						return object;
	
					}
	
				}
	
				return undefined;
	
			},
	
			getWorldPosition: function ( optionalTarget ) {
	
				var result = optionalTarget || new Vector3();
	
				this.updateMatrixWorld( true );
	
				return result.setFromMatrixPosition( this.matrixWorld );
	
			},
	
			getWorldQuaternion: function () {
	
				var position = new Vector3();
				var scale = new Vector3();
	
				return function getWorldQuaternion( optionalTarget ) {
	
					var result = optionalTarget || new Quaternion();
	
					this.updateMatrixWorld( true );
	
					this.matrixWorld.decompose( position, result, scale );
	
					return result;
	
				};
	
			}(),
	
			getWorldRotation: function () {
	
				var quaternion = new Quaternion();
	
				return function getWorldRotation( optionalTarget ) {
	
					var result = optionalTarget || new Euler();
	
					this.getWorldQuaternion( quaternion );
	
					return result.setFromQuaternion( quaternion, this.rotation.order, false );
	
				};
	
			}(),
	
			getWorldScale: function () {
	
				var position = new Vector3();
				var quaternion = new Quaternion();
	
				return function getWorldScale( optionalTarget ) {
	
					var result = optionalTarget || new Vector3();
	
					this.updateMatrixWorld( true );
	
					this.matrixWorld.decompose( position, quaternion, result );
	
					return result;
	
				};
	
			}(),
	
			getWorldDirection: function () {
	
				var quaternion = new Quaternion();
	
				return function getWorldDirection( optionalTarget ) {
	
					var result = optionalTarget || new Vector3();
	
					this.getWorldQuaternion( quaternion );
	
					return result.set( 0, 0, 1 ).applyQuaternion( quaternion );
	
				};
	
			}(),
	
			raycast: function () {},
	
			traverse: function ( callback ) {
	
				callback( this );
	
				var children = this.children;
	
				for ( var i = 0, l = children.length; i < l; i ++ ) {
	
					children[ i ].traverse( callback );
	
				}
	
			},
	
			traverseVisible: function ( callback ) {
	
				if ( this.visible === false ) return;
	
				callback( this );
	
				var children = this.children;
	
				for ( var i = 0, l = children.length; i < l; i ++ ) {
	
					children[ i ].traverseVisible( callback );
	
				}
	
			},
	
			traverseAncestors: function ( callback ) {
	
				var parent = this.parent;
	
				if ( parent !== null ) {
	
					callback( parent );
	
					parent.traverseAncestors( callback );
	
				}
	
			},
	
			updateMatrix: function () {
	
				this.matrix.compose( this.position, this.quaternion, this.scale );
	
				this.matrixWorldNeedsUpdate = true;
	
			},
	
			updateMatrixWorld: function ( force ) {
	
				if ( this.matrixAutoUpdate ) this.updateMatrix();
	
				if ( this.matrixWorldNeedsUpdate || force ) {
	
					if ( this.parent === null ) {
	
						this.matrixWorld.copy( this.matrix );
	
					} else {
	
						this.matrixWorld.multiplyMatrices( this.parent.matrixWorld, this.matrix );
	
					}
	
					this.matrixWorldNeedsUpdate = false;
	
					force = true;
	
				}
	
				// update children
	
				var children = this.children;
	
				for ( var i = 0, l = children.length; i < l; i ++ ) {
	
					children[ i ].updateMatrixWorld( force );
	
				}
	
			},
	
			toJSON: function ( meta ) {
	
				// meta is a string when called from JSON.stringify
				var isRootObject = ( meta === undefined || typeof meta === 'string' );
	
				var output = {};
	
				// meta is a hash used to collect geometries, materials.
				// not providing it implies that this is the root object
				// being serialized.
				if ( isRootObject ) {
	
					// initialize meta obj
					meta = {
						geometries: {},
						materials: {},
						textures: {},
						images: {},
						shapes: {}
					};
	
					output.metadata = {
						version: 4.5,
						type: 'Object',
						generator: 'Object3D.toJSON'
					};
	
				}
	
				// standard Object3D serialization
	
				var object = {};
	
				object.uuid = this.uuid;
				object.type = this.type;
	
				if ( this.name !== '' ) object.name = this.name;
				if ( this.castShadow === true ) object.castShadow = true;
				if ( this.receiveShadow === true ) object.receiveShadow = true;
				if ( this.visible === false ) object.visible = false;
				if ( JSON.stringify( this.userData ) !== '{}' ) object.userData = this.userData;
	
				object.matrix = this.matrix.toArray();
	
				//
	
				function serialize( library, element ) {
	
					if ( library[ element.uuid ] === undefined ) {
	
						library[ element.uuid ] = element.toJSON( meta );
	
					}
	
					return element.uuid;
	
				}
	
				if ( this.geometry !== undefined ) {
	
					object.geometry = serialize( meta.geometries, this.geometry );
	
					var parameters = this.geometry.parameters;
	
					if ( parameters !== undefined && parameters.shapes !== undefined ) {
	
						var shapes = parameters.shapes;
	
						if ( Array.isArray( shapes ) ) {
	
							for ( var i = 0, l = shapes.length; i < l; i ++ ) {
	
								var shape = shapes[ i ];
	
								serialize( meta.shapes, shape );
	
							}
	
						} else {
	
							serialize( meta.shapes, shapes );
	
						}
	
					}
	
				}
	
				if ( this.material !== undefined ) {
	
					if ( Array.isArray( this.material ) ) {
	
						var uuids = [];
	
						for ( var i = 0, l = this.material.length; i < l; i ++ ) {
	
							uuids.push( serialize( meta.materials, this.material[ i ] ) );
	
						}
	
						object.material = uuids;
	
					} else {
	
						object.material = serialize( meta.materials, this.material );
	
					}
	
				}
	
				//
	
				if ( this.children.length > 0 ) {
	
					object.children = [];
	
					for ( var i = 0; i < this.children.length; i ++ ) {
	
						object.children.push( this.children[ i ].toJSON( meta ).object );
	
					}
	
				}
	
				if ( isRootObject ) {
	
					var geometries = extractFromCache( meta.geometries );
					var materials = extractFromCache( meta.materials );
					var textures = extractFromCache( meta.textures );
					var images = extractFromCache( meta.images );
					var shapes = extractFromCache( meta.shapes );
	
					if ( geometries.length > 0 ) output.geometries = geometries;
					if ( materials.length > 0 ) output.materials = materials;
					if ( textures.length > 0 ) output.textures = textures;
					if ( images.length > 0 ) output.images = images;
					if ( shapes.length > 0 ) output.shapes = shapes;
	
				}
	
				output.object = object;
	
				return output;
	
				// extract data from the cache hash
				// remove metadata on each item
				// and return as array
				function extractFromCache( cache ) {
	
					var values = [];
					for ( var key in cache ) {
	
						var data = cache[ key ];
						delete data.metadata;
						values.push( data );
	
					}
					return values;
	
				}
	
			},
	
			clone: function ( recursive ) {
	
				return new this.constructor().copy( this, recursive );
	
			},
	
			copy: function ( source, recursive ) {
	
				if ( recursive === undefined ) recursive = true;
	
				this.name = source.name;
	
				this.up.copy( source.up );
	
				this.position.copy( source.position );
				this.quaternion.copy( source.quaternion );
				this.scale.copy( source.scale );
	
				this.matrix.copy( source.matrix );
				this.matrixWorld.copy( source.matrixWorld );
	
				this.matrixAutoUpdate = source.matrixAutoUpdate;
				this.matrixWorldNeedsUpdate = source.matrixWorldNeedsUpdate;
	
				this.layers.mask = source.layers.mask;
				this.visible = source.visible;
	
				this.castShadow = source.castShadow;
				this.receiveShadow = source.receiveShadow;
	
				this.frustumCulled = source.frustumCulled;
				this.renderOrder = source.renderOrder;
	
				this.userData = JSON.parse( JSON.stringify( source.userData ) );
	
				if ( recursive === true ) {
	
					for ( var i = 0; i < source.children.length; i ++ ) {
	
						var child = source.children[ i ];
						this.add( child.clone() );
	
					}
	
				}
	
				return this;
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author mikael emtinger / http://gomo.se/
		 * @author WestLangley / http://github.com/WestLangley
		*/
	
		function Camera() {
	
			Object3D.call( this );
	
			this.type = 'Camera';
	
			this.matrixWorldInverse = new Matrix4();
			this.projectionMatrix = new Matrix4();
	
		}
	
		Camera.prototype = Object.assign( Object.create( Object3D.prototype ), {
	
			constructor: Camera,
	
			isCamera: true,
	
			copy: function ( source, recursive ) {
	
				Object3D.prototype.copy.call( this, source, recursive );
	
				this.matrixWorldInverse.copy( source.matrixWorldInverse );
				this.projectionMatrix.copy( source.projectionMatrix );
	
				return this;
	
			},
	
			getWorldDirection: function () {
	
				var quaternion = new Quaternion();
	
				return function getWorldDirection( optionalTarget ) {
	
					var result = optionalTarget || new Vector3();
	
					this.getWorldQuaternion( quaternion );
	
					return result.set( 0, 0, - 1 ).applyQuaternion( quaternion );
	
				};
	
			}(),
	
			updateMatrixWorld: function ( force ) {
	
				Object3D.prototype.updateMatrixWorld.call( this, force );
	
				this.matrixWorldInverse.getInverse( this.matrixWorld );
	
			},
	
			clone: function () {
	
				return new this.constructor().copy( this );
	
			}
	
		} );
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 * @author arose / http://github.com/arose
		 */
	
		function OrthographicCamera( left, right, top, bottom, near, far ) {
	
			Camera.call( this );
	
			this.type = 'OrthographicCamera';
	
			this.zoom = 1;
			this.view = null;
	
			this.left = left;
			this.right = right;
			this.top = top;
			this.bottom = bottom;
	
			this.near = ( near !== undefined ) ? near : 0.1;
			this.far = ( far !== undefined ) ? far : 2000;
	
			this.updateProjectionMatrix();
	
		}
	
		OrthographicCamera.prototype = Object.assign( Object.create( Camera.prototype ), {
	
			constructor: OrthographicCamera,
	
			isOrthographicCamera: true,
	
			copy: function ( source, recursive ) {
	
				Camera.prototype.copy.call( this, source, recursive );
	
				this.left = source.left;
				this.right = source.right;
				this.top = source.top;
				this.bottom = source.bottom;
				this.near = source.near;
				this.far = source.far;
	
				this.zoom = source.zoom;
				this.view = source.view === null ? null : Object.assign( {}, source.view );
	
				return this;
	
			},
	
			setViewOffset: function ( fullWidth, fullHeight, x, y, width, height ) {
	
				if ( this.view === null ) {
	
					this.view = {
						enabled: true,
						fullWidth: 1,
						fullHeight: 1,
						offsetX: 0,
						offsetY: 0,
						width: 1,
						height: 1
					};
	
				}
	
				this.view.enabled = true;
				this.view.fullWidth = fullWidth;
				this.view.fullHeight = fullHeight;
				this.view.offsetX = x;
				this.view.offsetY = y;
				this.view.width = width;
				this.view.height = height;
	
				this.updateProjectionMatrix();
	
			},
	
			clearViewOffset: function () {
	
				if ( this.view !== null ) {
	
					this.view.enabled = false;
	
				}
	
				this.updateProjectionMatrix();
	
			},
	
			updateProjectionMatrix: function () {
	
				var dx = ( this.right - this.left ) / ( 2 * this.zoom );
				var dy = ( this.top - this.bottom ) / ( 2 * this.zoom );
				var cx = ( this.right + this.left ) / 2;
				var cy = ( this.top + this.bottom ) / 2;
	
				var left = cx - dx;
				var right = cx + dx;
				var top = cy + dy;
				var bottom = cy - dy;
	
				if ( this.view !== null && this.view.enabled ) {
	
					var zoomW = this.zoom / ( this.view.width / this.view.fullWidth );
					var zoomH = this.zoom / ( this.view.height / this.view.fullHeight );
					var scaleW = ( this.right - this.left ) / this.view.width;
					var scaleH = ( this.top - this.bottom ) / this.view.height;
	
					left += scaleW * ( this.view.offsetX / zoomW );
					right = left + scaleW * ( this.view.width / zoomW );
					top -= scaleH * ( this.view.offsetY / zoomH );
					bottom = top - scaleH * ( this.view.height / zoomH );
	
				}
	
				this.projectionMatrix.makeOrthographic( left, right, top, bottom, this.near, this.far );
	
			},
	
			toJSON: function ( meta ) {
	
				var data = Object3D.prototype.toJSON.call( this, meta );
	
				data.object.zoom = this.zoom;
				data.object.left = this.left;
				data.object.right = this.right;
				data.object.top = this.top;
				data.object.bottom = this.bottom;
				data.object.near = this.near;
				data.object.far = this.far;
	
				if ( this.view !== null ) data.object.view = Object.assign( {}, this.view );
	
				return data;
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author alteredq / http://alteredqualia.com/
		 */
	
		function Face3( a, b, c, normal, color, materialIndex ) {
	
			this.a = a;
			this.b = b;
			this.c = c;
	
			this.normal = ( normal && normal.isVector3 ) ? normal : new Vector3();
			this.vertexNormals = Array.isArray( normal ) ? normal : [];
	
			this.color = ( color && color.isColor ) ? color : new Color();
			this.vertexColors = Array.isArray( color ) ? color : [];
	
			this.materialIndex = materialIndex !== undefined ? materialIndex : 0;
	
		}
	
		Object.assign( Face3.prototype, {
	
			clone: function () {
	
				return new this.constructor().copy( this );
	
			},
	
			copy: function ( source ) {
	
				this.a = source.a;
				this.b = source.b;
				this.c = source.c;
	
				this.normal.copy( source.normal );
				this.color.copy( source.color );
	
				this.materialIndex = source.materialIndex;
	
				for ( var i = 0, il = source.vertexNormals.length; i < il; i ++ ) {
	
					this.vertexNormals[ i ] = source.vertexNormals[ i ].clone();
	
				}
	
				for ( var i = 0, il = source.vertexColors.length; i < il; i ++ ) {
	
					this.vertexColors[ i ] = source.vertexColors[ i ].clone();
	
				}
	
				return this;
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author kile / http://kile.stravaganza.org/
		 * @author alteredq / http://alteredqualia.com/
		 * @author mikael emtinger / http://gomo.se/
		 * @author zz85 / http://www.lab4games.net/zz85/blog
		 * @author bhouston / http://clara.io
		 */
	
		var geometryId = 0; // Geometry uses even numbers as Id
	
		function Geometry() {
	
			Object.defineProperty( this, 'id', { value: geometryId += 2 } );
	
			this.uuid = _Math.generateUUID();
	
			this.name = '';
			this.type = 'Geometry';
	
			this.vertices = [];
			this.colors = [];
			this.faces = [];
			this.faceVertexUvs = [[]];
	
			this.morphTargets = [];
			this.morphNormals = [];
	
			this.skinWeights = [];
			this.skinIndices = [];
	
			this.lineDistances = [];
	
			this.boundingBox = null;
			this.boundingSphere = null;
	
			// update flags
	
			this.elementsNeedUpdate = false;
			this.verticesNeedUpdate = false;
			this.uvsNeedUpdate = false;
			this.normalsNeedUpdate = false;
			this.colorsNeedUpdate = false;
			this.lineDistancesNeedUpdate = false;
			this.groupsNeedUpdate = false;
	
		}
	
		Geometry.prototype = Object.assign( Object.create( EventDispatcher.prototype ), {
	
			constructor: Geometry,
	
			isGeometry: true,
	
			applyMatrix: function ( matrix ) {
	
				var normalMatrix = new Matrix3().getNormalMatrix( matrix );
	
				for ( var i = 0, il = this.vertices.length; i < il; i ++ ) {
	
					var vertex = this.vertices[ i ];
					vertex.applyMatrix4( matrix );
	
				}
	
				for ( var i = 0, il = this.faces.length; i < il; i ++ ) {
	
					var face = this.faces[ i ];
					face.normal.applyMatrix3( normalMatrix ).normalize();
	
					for ( var j = 0, jl = face.vertexNormals.length; j < jl; j ++ ) {
	
						face.vertexNormals[ j ].applyMatrix3( normalMatrix ).normalize();
	
					}
	
				}
	
				if ( this.boundingBox !== null ) {
	
					this.computeBoundingBox();
	
				}
	
				if ( this.boundingSphere !== null ) {
	
					this.computeBoundingSphere();
	
				}
	
				this.verticesNeedUpdate = true;
				this.normalsNeedUpdate = true;
	
				return this;
	
			},
	
			rotateX: function () {
	
				// rotate geometry around world x-axis
	
				var m1 = new Matrix4();
	
				return function rotateX( angle ) {
	
					m1.makeRotationX( angle );
	
					this.applyMatrix( m1 );
	
					return this;
	
				};
	
			}(),
	
			rotateY: function () {
	
				// rotate geometry around world y-axis
	
				var m1 = new Matrix4();
	
				return function rotateY( angle ) {
	
					m1.makeRotationY( angle );
	
					this.applyMatrix( m1 );
	
					return this;
	
				};
	
			}(),
	
			rotateZ: function () {
	
				// rotate geometry around world z-axis
	
				var m1 = new Matrix4();
	
				return function rotateZ( angle ) {
	
					m1.makeRotationZ( angle );
	
					this.applyMatrix( m1 );
	
					return this;
	
				};
	
			}(),
	
			translate: function () {
	
				// translate geometry
	
				var m1 = new Matrix4();
	
				return function translate( x, y, z ) {
	
					m1.makeTranslation( x, y, z );
	
					this.applyMatrix( m1 );
	
					return this;
	
				};
	
			}(),
	
			scale: function () {
	
				// scale geometry
	
				var m1 = new Matrix4();
	
				return function scale( x, y, z ) {
	
					m1.makeScale( x, y, z );
	
					this.applyMatrix( m1 );
	
					return this;
	
				};
	
			}(),
	
			lookAt: function () {
	
				var obj = new Object3D();
	
				return function lookAt( vector ) {
	
					obj.lookAt( vector );
	
					obj.updateMatrix();
	
					this.applyMatrix( obj.matrix );
	
				};
	
			}(),
	
			fromBufferGeometry: function ( geometry ) {
	
				var scope = this;
	
				var indices = geometry.index !== null ? geometry.index.array : undefined;
				var attributes = geometry.attributes;
	
				var positions = attributes.position.array;
				var normals = attributes.normal !== undefined ? attributes.normal.array : undefined;
				var colors = attributes.color !== undefined ? attributes.color.array : undefined;
				var uvs = attributes.uv !== undefined ? attributes.uv.array : undefined;
				var uvs2 = attributes.uv2 !== undefined ? attributes.uv2.array : undefined;
	
				if ( uvs2 !== undefined ) this.faceVertexUvs[ 1 ] = [];
	
				var tempNormals = [];
				var tempUVs = [];
				var tempUVs2 = [];
	
				for ( var i = 0, j = 0; i < positions.length; i += 3, j += 2 ) {
	
					scope.vertices.push( new Vector3( positions[ i ], positions[ i + 1 ], positions[ i + 2 ] ) );
	
					if ( normals !== undefined ) {
	
						tempNormals.push( new Vector3( normals[ i ], normals[ i + 1 ], normals[ i + 2 ] ) );
	
					}
	
					if ( colors !== undefined ) {
	
						scope.colors.push( new Color( colors[ i ], colors[ i + 1 ], colors[ i + 2 ] ) );
	
					}
	
					if ( uvs !== undefined ) {
	
						tempUVs.push( new Vector2( uvs[ j ], uvs[ j + 1 ] ) );
	
					}
	
					if ( uvs2 !== undefined ) {
	
						tempUVs2.push( new Vector2( uvs2[ j ], uvs2[ j + 1 ] ) );
	
					}
	
				}
	
				function addFace( a, b, c, materialIndex ) {
	
					var vertexNormals = normals !== undefined ? [ tempNormals[ a ].clone(), tempNormals[ b ].clone(), tempNormals[ c ].clone() ] : [];
					var vertexColors = colors !== undefined ? [ scope.colors[ a ].clone(), scope.colors[ b ].clone(), scope.colors[ c ].clone() ] : [];
	
					var face = new Face3( a, b, c, vertexNormals, vertexColors, materialIndex );
	
					scope.faces.push( face );
	
					if ( uvs !== undefined ) {
	
						scope.faceVertexUvs[ 0 ].push( [ tempUVs[ a ].clone(), tempUVs[ b ].clone(), tempUVs[ c ].clone() ] );
	
					}
	
					if ( uvs2 !== undefined ) {
	
						scope.faceVertexUvs[ 1 ].push( [ tempUVs2[ a ].clone(), tempUVs2[ b ].clone(), tempUVs2[ c ].clone() ] );
	
					}
	
				}
	
				var groups = geometry.groups;
	
				if ( groups.length > 0 ) {
	
					for ( var i = 0; i < groups.length; i ++ ) {
	
						var group = groups[ i ];
	
						var start = group.start;
						var count = group.count;
	
						for ( var j = start, jl = start + count; j < jl; j += 3 ) {
	
							if ( indices !== undefined ) {
	
								addFace( indices[ j ], indices[ j + 1 ], indices[ j + 2 ], group.materialIndex );
	
							} else {
	
								addFace( j, j + 1, j + 2, group.materialIndex );
	
							}
	
						}
	
					}
	
				} else {
	
					if ( indices !== undefined ) {
	
						for ( var i = 0; i < indices.length; i += 3 ) {
	
							addFace( indices[ i ], indices[ i + 1 ], indices[ i + 2 ] );
	
						}
	
					} else {
	
						for ( var i = 0; i < positions.length / 3; i += 3 ) {
	
							addFace( i, i + 1, i + 2 );
	
						}
	
					}
	
				}
	
				this.computeFaceNormals();
	
				if ( geometry.boundingBox !== null ) {
	
					this.boundingBox = geometry.boundingBox.clone();
	
				}
	
				if ( geometry.boundingSphere !== null ) {
	
					this.boundingSphere = geometry.boundingSphere.clone();
	
				}
	
				return this;
	
			},
	
			center: function () {
	
				this.computeBoundingBox();
	
				var offset = this.boundingBox.getCenter().negate();
	
				this.translate( offset.x, offset.y, offset.z );
	
				return offset;
	
			},
	
			normalize: function () {
	
				this.computeBoundingSphere();
	
				var center = this.boundingSphere.center;
				var radius = this.boundingSphere.radius;
	
				var s = radius === 0 ? 1 : 1.0 / radius;
	
				var matrix = new Matrix4();
				matrix.set(
					s, 0, 0, - s * center.x,
					0, s, 0, - s * center.y,
					0, 0, s, - s * center.z,
					0, 0, 0, 1
				);
	
				this.applyMatrix( matrix );
	
				return this;
	
			},
	
			computeFaceNormals: function () {
	
				var cb = new Vector3(), ab = new Vector3();
	
				for ( var f = 0, fl = this.faces.length; f < fl; f ++ ) {
	
					var face = this.faces[ f ];
	
					var vA = this.vertices[ face.a ];
					var vB = this.vertices[ face.b ];
					var vC = this.vertices[ face.c ];
	
					cb.subVectors( vC, vB );
					ab.subVectors( vA, vB );
					cb.cross( ab );
	
					cb.normalize();
	
					face.normal.copy( cb );
	
				}
	
			},
	
			computeVertexNormals: function ( areaWeighted ) {
	
				if ( areaWeighted === undefined ) areaWeighted = true;
	
				var v, vl, f, fl, face, vertices;
	
				vertices = new Array( this.vertices.length );
	
				for ( v = 0, vl = this.vertices.length; v < vl; v ++ ) {
	
					vertices[ v ] = new Vector3();
	
				}
	
				if ( areaWeighted ) {
	
					// vertex normals weighted by triangle areas
					// http://www.iquilezles.org/www/articles/normals/normals.htm
	
					var vA, vB, vC;
					var cb = new Vector3(), ab = new Vector3();
	
					for ( f = 0, fl = this.faces.length; f < fl; f ++ ) {
	
						face = this.faces[ f ];
	
						vA = this.vertices[ face.a ];
						vB = this.vertices[ face.b ];
						vC = this.vertices[ face.c ];
	
						cb.subVectors( vC, vB );
						ab.subVectors( vA, vB );
						cb.cross( ab );
	
						vertices[ face.a ].add( cb );
						vertices[ face.b ].add( cb );
						vertices[ face.c ].add( cb );
	
					}
	
				} else {
	
					this.computeFaceNormals();
	
					for ( f = 0, fl = this.faces.length; f < fl; f ++ ) {
	
						face = this.faces[ f ];
	
						vertices[ face.a ].add( face.normal );
						vertices[ face.b ].add( face.normal );
						vertices[ face.c ].add( face.normal );
	
					}
	
				}
	
				for ( v = 0, vl = this.vertices.length; v < vl; v ++ ) {
	
					vertices[ v ].normalize();
	
				}
	
				for ( f = 0, fl = this.faces.length; f < fl; f ++ ) {
	
					face = this.faces[ f ];
	
					var vertexNormals = face.vertexNormals;
	
					if ( vertexNormals.length === 3 ) {
	
						vertexNormals[ 0 ].copy( vertices[ face.a ] );
						vertexNormals[ 1 ].copy( vertices[ face.b ] );
						vertexNormals[ 2 ].copy( vertices[ face.c ] );
	
					} else {
	
						vertexNormals[ 0 ] = vertices[ face.a ].clone();
						vertexNormals[ 1 ] = vertices[ face.b ].clone();
						vertexNormals[ 2 ] = vertices[ face.c ].clone();
	
					}
	
				}
	
				if ( this.faces.length > 0 ) {
	
					this.normalsNeedUpdate = true;
	
				}
	
			},
	
			computeFlatVertexNormals: function () {
	
				var f, fl, face;
	
				this.computeFaceNormals();
	
				for ( f = 0, fl = this.faces.length; f < fl; f ++ ) {
	
					face = this.faces[ f ];
	
					var vertexNormals = face.vertexNormals;
	
					if ( vertexNormals.length === 3 ) {
	
						vertexNormals[ 0 ].copy( face.normal );
						vertexNormals[ 1 ].copy( face.normal );
						vertexNormals[ 2 ].copy( face.normal );
	
					} else {
	
						vertexNormals[ 0 ] = face.normal.clone();
						vertexNormals[ 1 ] = face.normal.clone();
						vertexNormals[ 2 ] = face.normal.clone();
	
					}
	
				}
	
				if ( this.faces.length > 0 ) {
	
					this.normalsNeedUpdate = true;
	
				}
	
			},
	
			computeMorphNormals: function () {
	
				var i, il, f, fl, face;
	
				// save original normals
				// - create temp variables on first access
				//   otherwise just copy (for faster repeated calls)
	
				for ( f = 0, fl = this.faces.length; f < fl; f ++ ) {
	
					face = this.faces[ f ];
	
					if ( ! face.__originalFaceNormal ) {
	
						face.__originalFaceNormal = face.normal.clone();
	
					} else {
	
						face.__originalFaceNormal.copy( face.normal );
	
					}
	
					if ( ! face.__originalVertexNormals ) face.__originalVertexNormals = [];
	
					for ( i = 0, il = face.vertexNormals.length; i < il; i ++ ) {
	
						if ( ! face.__originalVertexNormals[ i ] ) {
	
							face.__originalVertexNormals[ i ] = face.vertexNormals[ i ].clone();
	
						} else {
	
							face.__originalVertexNormals[ i ].copy( face.vertexNormals[ i ] );
	
						}
	
					}
	
				}
	
				// use temp geometry to compute face and vertex normals for each morph
	
				var tmpGeo = new Geometry();
				tmpGeo.faces = this.faces;
	
				for ( i = 0, il = this.morphTargets.length; i < il; i ++ ) {
	
					// create on first access
	
					if ( ! this.morphNormals[ i ] ) {
	
						this.morphNormals[ i ] = {};
						this.morphNormals[ i ].faceNormals = [];
						this.morphNormals[ i ].vertexNormals = [];
	
						var dstNormalsFace = this.morphNormals[ i ].faceNormals;
						var dstNormalsVertex = this.morphNormals[ i ].vertexNormals;
	
						var faceNormal, vertexNormals;
	
						for ( f = 0, fl = this.faces.length; f < fl; f ++ ) {
	
							faceNormal = new Vector3();
							vertexNormals = { a: new Vector3(), b: new Vector3(), c: new Vector3() };
	
							dstNormalsFace.push( faceNormal );
							dstNormalsVertex.push( vertexNormals );
	
						}
	
					}
	
					var morphNormals = this.morphNormals[ i ];
	
					// set vertices to morph target
	
					tmpGeo.vertices = this.morphTargets[ i ].vertices;
	
					// compute morph normals
	
					tmpGeo.computeFaceNormals();
					tmpGeo.computeVertexNormals();
	
					// store morph normals
	
					var faceNormal, vertexNormals;
	
					for ( f = 0, fl = this.faces.length; f < fl; f ++ ) {
	
						face = this.faces[ f ];
	
						faceNormal = morphNormals.faceNormals[ f ];
						vertexNormals = morphNormals.vertexNormals[ f ];
	
						faceNormal.copy( face.normal );
	
						vertexNormals.a.copy( face.vertexNormals[ 0 ] );
						vertexNormals.b.copy( face.vertexNormals[ 1 ] );
						vertexNormals.c.copy( face.vertexNormals[ 2 ] );
	
					}
	
				}
	
				// restore original normals
	
				for ( f = 0, fl = this.faces.length; f < fl; f ++ ) {
	
					face = this.faces[ f ];
	
					face.normal = face.__originalFaceNormal;
					face.vertexNormals = face.__originalVertexNormals;
	
				}
	
			},
	
			computeLineDistances: function () {
	
				var d = 0;
				var vertices = this.vertices;
	
				for ( var i = 0, il = vertices.length; i < il; i ++ ) {
	
					if ( i > 0 ) {
	
						d += vertices[ i ].distanceTo( vertices[ i - 1 ] );
	
					}
	
					this.lineDistances[ i ] = d;
	
				}
	
			},
	
			computeBoundingBox: function () {
	
				if ( this.boundingBox === null ) {
	
					this.boundingBox = new Box3();
	
				}
	
				this.boundingBox.setFromPoints( this.vertices );
	
			},
	
			computeBoundingSphere: function () {
	
				if ( this.boundingSphere === null ) {
	
					this.boundingSphere = new Sphere();
	
				}
	
				this.boundingSphere.setFromPoints( this.vertices );
	
			},
	
			merge: function ( geometry, matrix, materialIndexOffset ) {
	
				if ( ! ( geometry && geometry.isGeometry ) ) {
	
					console.error( 'THREE.Geometry.merge(): geometry not an instance of THREE.Geometry.', geometry );
					return;
	
				}
	
				var normalMatrix,
					vertexOffset = this.vertices.length,
					vertices1 = this.vertices,
					vertices2 = geometry.vertices,
					faces1 = this.faces,
					faces2 = geometry.faces,
					uvs1 = this.faceVertexUvs[ 0 ],
					uvs2 = geometry.faceVertexUvs[ 0 ],
					colors1 = this.colors,
					colors2 = geometry.colors;
	
				if ( materialIndexOffset === undefined ) materialIndexOffset = 0;
	
				if ( matrix !== undefined ) {
	
					normalMatrix = new Matrix3().getNormalMatrix( matrix );
	
				}
	
				// vertices
	
				for ( var i = 0, il = vertices2.length; i < il; i ++ ) {
	
					var vertex = vertices2[ i ];
	
					var vertexCopy = vertex.clone();
	
					if ( matrix !== undefined ) vertexCopy.applyMatrix4( matrix );
	
					vertices1.push( vertexCopy );
	
				}
	
				// colors
	
				for ( var i = 0, il = colors2.length; i < il; i ++ ) {
	
					colors1.push( colors2[ i ].clone() );
	
				}
	
				// faces
	
				for ( i = 0, il = faces2.length; i < il; i ++ ) {
	
					var face = faces2[ i ], faceCopy, normal, color,
						faceVertexNormals = face.vertexNormals,
						faceVertexColors = face.vertexColors;
	
					faceCopy = new Face3( face.a + vertexOffset, face.b + vertexOffset, face.c + vertexOffset );
					faceCopy.normal.copy( face.normal );
	
					if ( normalMatrix !== undefined ) {
	
						faceCopy.normal.applyMatrix3( normalMatrix ).normalize();
	
					}
	
					for ( var j = 0, jl = faceVertexNormals.length; j < jl; j ++ ) {
	
						normal = faceVertexNormals[ j ].clone();
	
						if ( normalMatrix !== undefined ) {
	
							normal.applyMatrix3( normalMatrix ).normalize();
	
						}
	
						faceCopy.vertexNormals.push( normal );
	
					}
	
					faceCopy.color.copy( face.color );
	
					for ( var j = 0, jl = faceVertexColors.length; j < jl; j ++ ) {
	
						color = faceVertexColors[ j ];
						faceCopy.vertexColors.push( color.clone() );
	
					}
	
					faceCopy.materialIndex = face.materialIndex + materialIndexOffset;
	
					faces1.push( faceCopy );
	
				}
	
				// uvs
	
				for ( i = 0, il = uvs2.length; i < il; i ++ ) {
	
					var uv = uvs2[ i ], uvCopy = [];
	
					if ( uv === undefined ) {
	
						continue;
	
					}
	
					for ( var j = 0, jl = uv.length; j < jl; j ++ ) {
	
						uvCopy.push( uv[ j ].clone() );
	
					}
	
					uvs1.push( uvCopy );
	
				}
	
			},
	
			mergeMesh: function ( mesh ) {
	
				if ( ! ( mesh && mesh.isMesh ) ) {
	
					console.error( 'THREE.Geometry.mergeMesh(): mesh not an instance of THREE.Mesh.', mesh );
					return;
	
				}
	
				mesh.matrixAutoUpdate && mesh.updateMatrix();
	
				this.merge( mesh.geometry, mesh.matrix );
	
			},
	
			/*
			 * Checks for duplicate vertices with hashmap.
			 * Duplicated vertices are removed
			 * and faces' vertices are updated.
			 */
	
			mergeVertices: function () {
	
				var verticesMap = {}; // Hashmap for looking up vertices by position coordinates (and making sure they are unique)
				var unique = [], changes = [];
	
				var v, key;
				var precisionPoints = 4; // number of decimal points, e.g. 4 for epsilon of 0.0001
				var precision = Math.pow( 10, precisionPoints );
				var i, il, face;
				var indices, j, jl;
	
				for ( i = 0, il = this.vertices.length; i < il; i ++ ) {
	
					v = this.vertices[ i ];
					key = Math.round( v.x * precision ) + '_' + Math.round( v.y * precision ) + '_' + Math.round( v.z * precision );
	
					if ( verticesMap[ key ] === undefined ) {
	
						verticesMap[ key ] = i;
						unique.push( this.vertices[ i ] );
						changes[ i ] = unique.length - 1;
	
					} else {
	
						//console.log('Duplicate vertex found. ', i, ' could be using ', verticesMap[key]);
						changes[ i ] = changes[ verticesMap[ key ] ];
	
					}
	
				}
	
	
				// if faces are completely degenerate after merging vertices, we
				// have to remove them from the geometry.
				var faceIndicesToRemove = [];
	
				for ( i = 0, il = this.faces.length; i < il; i ++ ) {
	
					face = this.faces[ i ];
	
					face.a = changes[ face.a ];
					face.b = changes[ face.b ];
					face.c = changes[ face.c ];
	
					indices = [ face.a, face.b, face.c ];
	
					// if any duplicate vertices are found in a Face3
					// we have to remove the face as nothing can be saved
					for ( var n = 0; n < 3; n ++ ) {
	
						if ( indices[ n ] === indices[ ( n + 1 ) % 3 ] ) {
	
							faceIndicesToRemove.push( i );
							break;
	
						}
	
					}
	
				}
	
				for ( i = faceIndicesToRemove.length - 1; i >= 0; i -- ) {
	
					var idx = faceIndicesToRemove[ i ];
	
					this.faces.splice( idx, 1 );
	
					for ( j = 0, jl = this.faceVertexUvs.length; j < jl; j ++ ) {
	
						this.faceVertexUvs[ j ].splice( idx, 1 );
	
					}
	
				}
	
				// Use unique set of vertices
	
				var diff = this.vertices.length - unique.length;
				this.vertices = unique;
				return diff;
	
			},
	
			setFromPoints: function ( points ) {
	
				this.vertices = [];
	
				for ( var i = 0, l = points.length; i < l; i ++ ) {
	
					var point = points[ i ];
					this.vertices.push( new Vector3( point.x, point.y, point.z || 0 ) );
	
				}
	
				return this;
	
			},
	
			sortFacesByMaterialIndex: function () {
	
				var faces = this.faces;
				var length = faces.length;
	
				// tag faces
	
				for ( var i = 0; i < length; i ++ ) {
	
					faces[ i ]._id = i;
	
				}
	
				// sort faces
	
				function materialIndexSort( a, b ) {
	
					return a.materialIndex - b.materialIndex;
	
				}
	
				faces.sort( materialIndexSort );
	
				// sort uvs
	
				var uvs1 = this.faceVertexUvs[ 0 ];
				var uvs2 = this.faceVertexUvs[ 1 ];
	
				var newUvs1, newUvs2;
	
				if ( uvs1 && uvs1.length === length ) newUvs1 = [];
				if ( uvs2 && uvs2.length === length ) newUvs2 = [];
	
				for ( var i = 0; i < length; i ++ ) {
	
					var id = faces[ i ]._id;
	
					if ( newUvs1 ) newUvs1.push( uvs1[ id ] );
					if ( newUvs2 ) newUvs2.push( uvs2[ id ] );
	
				}
	
				if ( newUvs1 ) this.faceVertexUvs[ 0 ] = newUvs1;
				if ( newUvs2 ) this.faceVertexUvs[ 1 ] = newUvs2;
	
			},
	
			toJSON: function () {
	
				var data = {
					metadata: {
						version: 4.5,
						type: 'Geometry',
						generator: 'Geometry.toJSON'
					}
				};
	
				// standard Geometry serialization
	
				data.uuid = this.uuid;
				data.type = this.type;
				if ( this.name !== '' ) data.name = this.name;
	
				if ( this.parameters !== undefined ) {
	
					var parameters = this.parameters;
	
					for ( var key in parameters ) {
	
						if ( parameters[ key ] !== undefined ) data[ key ] = parameters[ key ];
	
					}
	
					return data;
	
				}
	
				var vertices = [];
	
				for ( var i = 0; i < this.vertices.length; i ++ ) {
	
					var vertex = this.vertices[ i ];
					vertices.push( vertex.x, vertex.y, vertex.z );
	
				}
	
				var faces = [];
				var normals = [];
				var normalsHash = {};
				var colors = [];
				var colorsHash = {};
				var uvs = [];
				var uvsHash = {};
	
				for ( var i = 0; i < this.faces.length; i ++ ) {
	
					var face = this.faces[ i ];
	
					var hasMaterial = true;
					var hasFaceUv = false; // deprecated
					var hasFaceVertexUv = this.faceVertexUvs[ 0 ][ i ] !== undefined;
					var hasFaceNormal = face.normal.length() > 0;
					var hasFaceVertexNormal = face.vertexNormals.length > 0;
					var hasFaceColor = face.color.r !== 1 || face.color.g !== 1 || face.color.b !== 1;
					var hasFaceVertexColor = face.vertexColors.length > 0;
	
					var faceType = 0;
	
					faceType = setBit( faceType, 0, 0 ); // isQuad
					faceType = setBit( faceType, 1, hasMaterial );
					faceType = setBit( faceType, 2, hasFaceUv );
					faceType = setBit( faceType, 3, hasFaceVertexUv );
					faceType = setBit( faceType, 4, hasFaceNormal );
					faceType = setBit( faceType, 5, hasFaceVertexNormal );
					faceType = setBit( faceType, 6, hasFaceColor );
					faceType = setBit( faceType, 7, hasFaceVertexColor );
	
					faces.push( faceType );
					faces.push( face.a, face.b, face.c );
					faces.push( face.materialIndex );
	
					if ( hasFaceVertexUv ) {
	
						var faceVertexUvs = this.faceVertexUvs[ 0 ][ i ];
	
						faces.push(
							getUvIndex( faceVertexUvs[ 0 ] ),
							getUvIndex( faceVertexUvs[ 1 ] ),
							getUvIndex( faceVertexUvs[ 2 ] )
						);
	
					}
	
					if ( hasFaceNormal ) {
	
						faces.push( getNormalIndex( face.normal ) );
	
					}
	
					if ( hasFaceVertexNormal ) {
	
						var vertexNormals = face.vertexNormals;
	
						faces.push(
							getNormalIndex( vertexNormals[ 0 ] ),
							getNormalIndex( vertexNormals[ 1 ] ),
							getNormalIndex( vertexNormals[ 2 ] )
						);
	
					}
	
					if ( hasFaceColor ) {
	
						faces.push( getColorIndex( face.color ) );
	
					}
	
					if ( hasFaceVertexColor ) {
	
						var vertexColors = face.vertexColors;
	
						faces.push(
							getColorIndex( vertexColors[ 0 ] ),
							getColorIndex( vertexColors[ 1 ] ),
							getColorIndex( vertexColors[ 2 ] )
						);
	
					}
	
				}
	
				function setBit( value, position, enabled ) {
	
					return enabled ? value | ( 1 << position ) : value & ( ~ ( 1 << position ) );
	
				}
	
				function getNormalIndex( normal ) {
	
					var hash = normal.x.toString() + normal.y.toString() + normal.z.toString();
	
					if ( normalsHash[ hash ] !== undefined ) {
	
						return normalsHash[ hash ];
	
					}
	
					normalsHash[ hash ] = normals.length / 3;
					normals.push( normal.x, normal.y, normal.z );
	
					return normalsHash[ hash ];
	
				}
	
				function getColorIndex( color ) {
	
					var hash = color.r.toString() + color.g.toString() + color.b.toString();
	
					if ( colorsHash[ hash ] !== undefined ) {
	
						return colorsHash[ hash ];
	
					}
	
					colorsHash[ hash ] = colors.length;
					colors.push( color.getHex() );
	
					return colorsHash[ hash ];
	
				}
	
				function getUvIndex( uv ) {
	
					var hash = uv.x.toString() + uv.y.toString();
	
					if ( uvsHash[ hash ] !== undefined ) {
	
						return uvsHash[ hash ];
	
					}
	
					uvsHash[ hash ] = uvs.length / 2;
					uvs.push( uv.x, uv.y );
	
					return uvsHash[ hash ];
	
				}
	
				data.data = {};
	
				data.data.vertices = vertices;
				data.data.normals = normals;
				if ( colors.length > 0 ) data.data.colors = colors;
				if ( uvs.length > 0 ) data.data.uvs = [ uvs ]; // temporal backward compatibility
				data.data.faces = faces;
	
				return data;
	
			},
	
			clone: function () {
	
				/*
				 // Handle primitives
	
				 var parameters = this.parameters;
	
				 if ( parameters !== undefined ) {
	
				 var values = [];
	
				 for ( var key in parameters ) {
	
				 values.push( parameters[ key ] );
	
				 }
	
				 var geometry = Object.create( this.constructor.prototype );
				 this.constructor.apply( geometry, values );
				 return geometry;
	
				 }
	
				 return new this.constructor().copy( this );
				 */
	
				return new Geometry().copy( this );
	
			},
	
			copy: function ( source ) {
	
				var i, il, j, jl, k, kl;
	
				// reset
	
				this.vertices = [];
				this.colors = [];
				this.faces = [];
				this.faceVertexUvs = [[]];
				this.morphTargets = [];
				this.morphNormals = [];
				this.skinWeights = [];
				this.skinIndices = [];
				this.lineDistances = [];
				this.boundingBox = null;
				this.boundingSphere = null;
	
				// name
	
				this.name = source.name;
	
				// vertices
	
				var vertices = source.vertices;
	
				for ( i = 0, il = vertices.length; i < il; i ++ ) {
	
					this.vertices.push( vertices[ i ].clone() );
	
				}
	
				// colors
	
				var colors = source.colors;
	
				for ( i = 0, il = colors.length; i < il; i ++ ) {
	
					this.colors.push( colors[ i ].clone() );
	
				}
	
				// faces
	
				var faces = source.faces;
	
				for ( i = 0, il = faces.length; i < il; i ++ ) {
	
					this.faces.push( faces[ i ].clone() );
	
				}
	
				// face vertex uvs
	
				for ( i = 0, il = source.faceVertexUvs.length; i < il; i ++ ) {
	
					var faceVertexUvs = source.faceVertexUvs[ i ];
	
					if ( this.faceVertexUvs[ i ] === undefined ) {
	
						this.faceVertexUvs[ i ] = [];
	
					}
	
					for ( j = 0, jl = faceVertexUvs.length; j < jl; j ++ ) {
	
						var uvs = faceVertexUvs[ j ], uvsCopy = [];
	
						for ( k = 0, kl = uvs.length; k < kl; k ++ ) {
	
							var uv = uvs[ k ];
	
							uvsCopy.push( uv.clone() );
	
						}
	
						this.faceVertexUvs[ i ].push( uvsCopy );
	
					}
	
				}
	
				// morph targets
	
				var morphTargets = source.morphTargets;
	
				for ( i = 0, il = morphTargets.length; i < il; i ++ ) {
	
					var morphTarget = {};
					morphTarget.name = morphTargets[ i ].name;
	
					// vertices
	
					if ( morphTargets[ i ].vertices !== undefined ) {
	
						morphTarget.vertices = [];
	
						for ( j = 0, jl = morphTargets[ i ].vertices.length; j < jl; j ++ ) {
	
							morphTarget.vertices.push( morphTargets[ i ].vertices[ j ].clone() );
	
						}
	
					}
	
					// normals
	
					if ( morphTargets[ i ].normals !== undefined ) {
	
						morphTarget.normals = [];
	
						for ( j = 0, jl = morphTargets[ i ].normals.length; j < jl; j ++ ) {
	
							morphTarget.normals.push( morphTargets[ i ].normals[ j ].clone() );
	
						}
	
					}
	
					this.morphTargets.push( morphTarget );
	
				}
	
				// morph normals
	
				var morphNormals = source.morphNormals;
	
				for ( i = 0, il = morphNormals.length; i < il; i ++ ) {
	
					var morphNormal = {};
	
					// vertex normals
	
					if ( morphNormals[ i ].vertexNormals !== undefined ) {
	
						morphNormal.vertexNormals = [];
	
						for ( j = 0, jl = morphNormals[ i ].vertexNormals.length; j < jl; j ++ ) {
	
							var srcVertexNormal = morphNormals[ i ].vertexNormals[ j ];
							var destVertexNormal = {};
	
							destVertexNormal.a = srcVertexNormal.a.clone();
							destVertexNormal.b = srcVertexNormal.b.clone();
							destVertexNormal.c = srcVertexNormal.c.clone();
	
							morphNormal.vertexNormals.push( destVertexNormal );
	
						}
	
					}
	
					// face normals
	
					if ( morphNormals[ i ].faceNormals !== undefined ) {
	
						morphNormal.faceNormals = [];
	
						for ( j = 0, jl = morphNormals[ i ].faceNormals.length; j < jl; j ++ ) {
	
							morphNormal.faceNormals.push( morphNormals[ i ].faceNormals[ j ].clone() );
	
						}
	
					}
	
					this.morphNormals.push( morphNormal );
	
				}
	
				// skin weights
	
				var skinWeights = source.skinWeights;
	
				for ( i = 0, il = skinWeights.length; i < il; i ++ ) {
	
					this.skinWeights.push( skinWeights[ i ].clone() );
	
				}
	
				// skin indices
	
				var skinIndices = source.skinIndices;
	
				for ( i = 0, il = skinIndices.length; i < il; i ++ ) {
	
					this.skinIndices.push( skinIndices[ i ].clone() );
	
				}
	
				// line distances
	
				var lineDistances = source.lineDistances;
	
				for ( i = 0, il = lineDistances.length; i < il; i ++ ) {
	
					this.lineDistances.push( lineDistances[ i ] );
	
				}
	
				// bounding box
	
				var boundingBox = source.boundingBox;
	
				if ( boundingBox !== null ) {
	
					this.boundingBox = boundingBox.clone();
	
				}
	
				// bounding sphere
	
				var boundingSphere = source.boundingSphere;
	
				if ( boundingSphere !== null ) {
	
					this.boundingSphere = boundingSphere.clone();
	
				}
	
				// update flags
	
				this.elementsNeedUpdate = source.elementsNeedUpdate;
				this.verticesNeedUpdate = source.verticesNeedUpdate;
				this.uvsNeedUpdate = source.uvsNeedUpdate;
				this.normalsNeedUpdate = source.normalsNeedUpdate;
				this.colorsNeedUpdate = source.colorsNeedUpdate;
				this.lineDistancesNeedUpdate = source.lineDistancesNeedUpdate;
				this.groupsNeedUpdate = source.groupsNeedUpdate;
	
				return this;
	
			},
	
			dispose: function () {
	
				this.dispatchEvent( { type: 'dispose' } );
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function BufferAttribute( array, itemSize, normalized ) {
	
			if ( Array.isArray( array ) ) {
	
				throw new TypeError( 'THREE.BufferAttribute: array should be a Typed Array.' );
	
			}
	
			this.uuid = _Math.generateUUID();
			this.name = '';
	
			this.array = array;
			this.itemSize = itemSize;
			this.count = array !== undefined ? array.length / itemSize : 0;
			this.normalized = normalized === true;
	
			this.dynamic = false;
			this.updateRange = { offset: 0, count: - 1 };
	
			this.onUploadCallback = function () {};
	
			this.version = 0;
	
		}
	
		Object.defineProperty( BufferAttribute.prototype, 'needsUpdate', {
	
			set: function ( value ) {
	
				if ( value === true ) this.version ++;
	
			}
	
		} );
	
		Object.assign( BufferAttribute.prototype, {
	
			isBufferAttribute: true,
	
			setArray: function ( array ) {
	
				if ( Array.isArray( array ) ) {
	
					throw new TypeError( 'THREE.BufferAttribute: array should be a Typed Array.' );
	
				}
	
				this.count = array !== undefined ? array.length / this.itemSize : 0;
				this.array = array;
	
			},
	
			setDynamic: function ( value ) {
	
				this.dynamic = value;
	
				return this;
	
			},
	
			copy: function ( source ) {
	
				this.array = new source.array.constructor( source.array );
				this.itemSize = source.itemSize;
				this.count = source.count;
				this.normalized = source.normalized;
	
				this.dynamic = source.dynamic;
	
				return this;
	
			},
	
			copyAt: function ( index1, attribute, index2 ) {
	
				index1 *= this.itemSize;
				index2 *= attribute.itemSize;
	
				for ( var i = 0, l = this.itemSize; i < l; i ++ ) {
	
					this.array[ index1 + i ] = attribute.array[ index2 + i ];
	
				}
	
				return this;
	
			},
	
			copyArray: function ( array ) {
	
				this.array.set( array );
	
				return this;
	
			},
	
			copyColorsArray: function ( colors ) {
	
				var array = this.array, offset = 0;
	
				for ( var i = 0, l = colors.length; i < l; i ++ ) {
	
					var color = colors[ i ];
	
					if ( color === undefined ) {
	
						console.warn( 'THREE.BufferAttribute.copyColorsArray(): color is undefined', i );
						color = new Color();
	
					}
	
					array[ offset ++ ] = color.r;
					array[ offset ++ ] = color.g;
					array[ offset ++ ] = color.b;
	
				}
	
				return this;
	
			},
	
			copyIndicesArray: function ( indices ) {
	
				var array = this.array, offset = 0;
	
				for ( var i = 0, l = indices.length; i < l; i ++ ) {
	
					var index = indices[ i ];
	
					array[ offset ++ ] = index.a;
					array[ offset ++ ] = index.b;
					array[ offset ++ ] = index.c;
	
				}
	
				return this;
	
			},
	
			copyVector2sArray: function ( vectors ) {
	
				var array = this.array, offset = 0;
	
				for ( var i = 0, l = vectors.length; i < l; i ++ ) {
	
					var vector = vectors[ i ];
	
					if ( vector === undefined ) {
	
						console.warn( 'THREE.BufferAttribute.copyVector2sArray(): vector is undefined', i );
						vector = new Vector2();
	
					}
	
					array[ offset ++ ] = vector.x;
					array[ offset ++ ] = vector.y;
	
				}
	
				return this;
	
			},
	
			copyVector3sArray: function ( vectors ) {
	
				var array = this.array, offset = 0;
	
				for ( var i = 0, l = vectors.length; i < l; i ++ ) {
	
					var vector = vectors[ i ];
	
					if ( vector === undefined ) {
	
						console.warn( 'THREE.BufferAttribute.copyVector3sArray(): vector is undefined', i );
						vector = new Vector3();
	
					}
	
					array[ offset ++ ] = vector.x;
					array[ offset ++ ] = vector.y;
					array[ offset ++ ] = vector.z;
	
				}
	
				return this;
	
			},
	
			copyVector4sArray: function ( vectors ) {
	
				var array = this.array, offset = 0;
	
				for ( var i = 0, l = vectors.length; i < l; i ++ ) {
	
					var vector = vectors[ i ];
	
					if ( vector === undefined ) {
	
						console.warn( 'THREE.BufferAttribute.copyVector4sArray(): vector is undefined', i );
						vector = new Vector4();
	
					}
	
					array[ offset ++ ] = vector.x;
					array[ offset ++ ] = vector.y;
					array[ offset ++ ] = vector.z;
					array[ offset ++ ] = vector.w;
	
				}
	
				return this;
	
			},
	
			set: function ( value, offset ) {
	
				if ( offset === undefined ) offset = 0;
	
				this.array.set( value, offset );
	
				return this;
	
			},
	
			getX: function ( index ) {
	
				return this.array[ index * this.itemSize ];
	
			},
	
			setX: function ( index, x ) {
	
				this.array[ index * this.itemSize ] = x;
	
				return this;
	
			},
	
			getY: function ( index ) {
	
				return this.array[ index * this.itemSize + 1 ];
	
			},
	
			setY: function ( index, y ) {
	
				this.array[ index * this.itemSize + 1 ] = y;
	
				return this;
	
			},
	
			getZ: function ( index ) {
	
				return this.array[ index * this.itemSize + 2 ];
	
			},
	
			setZ: function ( index, z ) {
	
				this.array[ index * this.itemSize + 2 ] = z;
	
				return this;
	
			},
	
			getW: function ( index ) {
	
				return this.array[ index * this.itemSize + 3 ];
	
			},
	
			setW: function ( index, w ) {
	
				this.array[ index * this.itemSize + 3 ] = w;
	
				return this;
	
			},
	
			setXY: function ( index, x, y ) {
	
				index *= this.itemSize;
	
				this.array[ index + 0 ] = x;
				this.array[ index + 1 ] = y;
	
				return this;
	
			},
	
			setXYZ: function ( index, x, y, z ) {
	
				index *= this.itemSize;
	
				this.array[ index + 0 ] = x;
				this.array[ index + 1 ] = y;
				this.array[ index + 2 ] = z;
	
				return this;
	
			},
	
			setXYZW: function ( index, x, y, z, w ) {
	
				index *= this.itemSize;
	
				this.array[ index + 0 ] = x;
				this.array[ index + 1 ] = y;
				this.array[ index + 2 ] = z;
				this.array[ index + 3 ] = w;
	
				return this;
	
			},
	
			onUpload: function ( callback ) {
	
				this.onUploadCallback = callback;
	
				return this;
	
			},
	
			clone: function () {
	
				return new this.constructor( this.array, this.itemSize ).copy( this );
	
			}
	
		} );
	
		//
	
		function Int8BufferAttribute( array, itemSize, normalized ) {
	
			BufferAttribute.call( this, new Int8Array( array ), itemSize, normalized );
	
		}
	
		Int8BufferAttribute.prototype = Object.create( BufferAttribute.prototype );
		Int8BufferAttribute.prototype.constructor = Int8BufferAttribute;
	
	
		function Uint8BufferAttribute( array, itemSize, normalized ) {
	
			BufferAttribute.call( this, new Uint8Array( array ), itemSize, normalized );
	
		}
	
		Uint8BufferAttribute.prototype = Object.create( BufferAttribute.prototype );
		Uint8BufferAttribute.prototype.constructor = Uint8BufferAttribute;
	
	
		function Uint8ClampedBufferAttribute( array, itemSize, normalized ) {
	
			BufferAttribute.call( this, new Uint8ClampedArray( array ), itemSize, normalized );
	
		}
	
		Uint8ClampedBufferAttribute.prototype = Object.create( BufferAttribute.prototype );
		Uint8ClampedBufferAttribute.prototype.constructor = Uint8ClampedBufferAttribute;
	
	
		function Int16BufferAttribute( array, itemSize, normalized ) {
	
			BufferAttribute.call( this, new Int16Array( array ), itemSize, normalized );
	
		}
	
		Int16BufferAttribute.prototype = Object.create( BufferAttribute.prototype );
		Int16BufferAttribute.prototype.constructor = Int16BufferAttribute;
	
	
		function Uint16BufferAttribute( array, itemSize, normalized ) {
	
			BufferAttribute.call( this, new Uint16Array( array ), itemSize, normalized );
	
		}
	
		Uint16BufferAttribute.prototype = Object.create( BufferAttribute.prototype );
		Uint16BufferAttribute.prototype.constructor = Uint16BufferAttribute;
	
	
		function Int32BufferAttribute( array, itemSize, normalized ) {
	
			BufferAttribute.call( this, new Int32Array( array ), itemSize, normalized );
	
		}
	
		Int32BufferAttribute.prototype = Object.create( BufferAttribute.prototype );
		Int32BufferAttribute.prototype.constructor = Int32BufferAttribute;
	
	
		function Uint32BufferAttribute( array, itemSize, normalized ) {
	
			BufferAttribute.call( this, new Uint32Array( array ), itemSize, normalized );
	
		}
	
		Uint32BufferAttribute.prototype = Object.create( BufferAttribute.prototype );
		Uint32BufferAttribute.prototype.constructor = Uint32BufferAttribute;
	
	
		function Float32BufferAttribute( array, itemSize, normalized ) {
	
			BufferAttribute.call( this, new Float32Array( array ), itemSize, normalized );
	
		}
	
		Float32BufferAttribute.prototype = Object.create( BufferAttribute.prototype );
		Float32BufferAttribute.prototype.constructor = Float32BufferAttribute;
	
	
		function Float64BufferAttribute( array, itemSize, normalized ) {
	
			BufferAttribute.call( this, new Float64Array( array ), itemSize, normalized );
	
		}
	
		Float64BufferAttribute.prototype = Object.create( BufferAttribute.prototype );
		Float64BufferAttribute.prototype.constructor = Float64BufferAttribute;
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function DirectGeometry() {
	
			this.indices = [];
			this.vertices = [];
			this.normals = [];
			this.colors = [];
			this.uvs = [];
			this.uvs2 = [];
	
			this.groups = [];
	
			this.morphTargets = {};
	
			this.skinWeights = [];
			this.skinIndices = [];
	
			// this.lineDistances = [];
	
			this.boundingBox = null;
			this.boundingSphere = null;
	
			// update flags
	
			this.verticesNeedUpdate = false;
			this.normalsNeedUpdate = false;
			this.colorsNeedUpdate = false;
			this.uvsNeedUpdate = false;
			this.groupsNeedUpdate = false;
	
		}
	
		Object.assign( DirectGeometry.prototype, {
	
			computeGroups: function ( geometry ) {
	
				var group;
				var groups = [];
				var materialIndex = undefined;
	
				var faces = geometry.faces;
	
				for ( var i = 0; i < faces.length; i ++ ) {
	
					var face = faces[ i ];
	
					// materials
	
					if ( face.materialIndex !== materialIndex ) {
	
						materialIndex = face.materialIndex;
	
						if ( group !== undefined ) {
	
							group.count = ( i * 3 ) - group.start;
							groups.push( group );
	
						}
	
						group = {
							start: i * 3,
							materialIndex: materialIndex
						};
	
					}
	
				}
	
				if ( group !== undefined ) {
	
					group.count = ( i * 3 ) - group.start;
					groups.push( group );
	
				}
	
				this.groups = groups;
	
			},
	
			fromGeometry: function ( geometry ) {
	
				var faces = geometry.faces;
				var vertices = geometry.vertices;
				var faceVertexUvs = geometry.faceVertexUvs;
	
				var hasFaceVertexUv = faceVertexUvs[ 0 ] && faceVertexUvs[ 0 ].length > 0;
				var hasFaceVertexUv2 = faceVertexUvs[ 1 ] && faceVertexUvs[ 1 ].length > 0;
	
				// morphs
	
				var morphTargets = geometry.morphTargets;
				var morphTargetsLength = morphTargets.length;
	
				var morphTargetsPosition;
	
				if ( morphTargetsLength > 0 ) {
	
					morphTargetsPosition = [];
	
					for ( var i = 0; i < morphTargetsLength; i ++ ) {
	
						morphTargetsPosition[ i ] = [];
	
					}
	
					this.morphTargets.position = morphTargetsPosition;
	
				}
	
				var morphNormals = geometry.morphNormals;
				var morphNormalsLength = morphNormals.length;
	
				var morphTargetsNormal;
	
				if ( morphNormalsLength > 0 ) {
	
					morphTargetsNormal = [];
	
					for ( var i = 0; i < morphNormalsLength; i ++ ) {
	
						morphTargetsNormal[ i ] = [];
	
					}
	
					this.morphTargets.normal = morphTargetsNormal;
	
				}
	
				// skins
	
				var skinIndices = geometry.skinIndices;
				var skinWeights = geometry.skinWeights;
	
				var hasSkinIndices = skinIndices.length === vertices.length;
				var hasSkinWeights = skinWeights.length === vertices.length;
	
				//
	
				for ( var i = 0; i < faces.length; i ++ ) {
	
					var face = faces[ i ];
	
					this.vertices.push( vertices[ face.a ], vertices[ face.b ], vertices[ face.c ] );
	
					var vertexNormals = face.vertexNormals;
	
					if ( vertexNormals.length === 3 ) {
	
						this.normals.push( vertexNormals[ 0 ], vertexNormals[ 1 ], vertexNormals[ 2 ] );
	
					} else {
	
						var normal = face.normal;
	
						this.normals.push( normal, normal, normal );
	
					}
	
					var vertexColors = face.vertexColors;
	
					if ( vertexColors.length === 3 ) {
	
						this.colors.push( vertexColors[ 0 ], vertexColors[ 1 ], vertexColors[ 2 ] );
	
					} else {
	
						var color = face.color;
	
						this.colors.push( color, color, color );
	
					}
	
					if ( hasFaceVertexUv === true ) {
	
						var vertexUvs = faceVertexUvs[ 0 ][ i ];
	
						if ( vertexUvs !== undefined ) {
	
							this.uvs.push( vertexUvs[ 0 ], vertexUvs[ 1 ], vertexUvs[ 2 ] );
	
						} else {
	
							console.warn( 'THREE.DirectGeometry.fromGeometry(): Undefined vertexUv ', i );
	
							this.uvs.push( new Vector2(), new Vector2(), new Vector2() );
	
						}
	
					}
	
					if ( hasFaceVertexUv2 === true ) {
	
						var vertexUvs = faceVertexUvs[ 1 ][ i ];
	
						if ( vertexUvs !== undefined ) {
	
							this.uvs2.push( vertexUvs[ 0 ], vertexUvs[ 1 ], vertexUvs[ 2 ] );
	
						} else {
	
							console.warn( 'THREE.DirectGeometry.fromGeometry(): Undefined vertexUv2 ', i );
	
							this.uvs2.push( new Vector2(), new Vector2(), new Vector2() );
	
						}
	
					}
	
					// morphs
	
					for ( var j = 0; j < morphTargetsLength; j ++ ) {
	
						var morphTarget = morphTargets[ j ].vertices;
	
						morphTargetsPosition[ j ].push( morphTarget[ face.a ], morphTarget[ face.b ], morphTarget[ face.c ] );
	
					}
	
					for ( var j = 0; j < morphNormalsLength; j ++ ) {
	
						var morphNormal = morphNormals[ j ].vertexNormals[ i ];
	
						morphTargetsNormal[ j ].push( morphNormal.a, morphNormal.b, morphNormal.c );
	
					}
	
					// skins
	
					if ( hasSkinIndices ) {
	
						this.skinIndices.push( skinIndices[ face.a ], skinIndices[ face.b ], skinIndices[ face.c ] );
	
					}
	
					if ( hasSkinWeights ) {
	
						this.skinWeights.push( skinWeights[ face.a ], skinWeights[ face.b ], skinWeights[ face.c ] );
	
					}
	
				}
	
				this.computeGroups( geometry );
	
				this.verticesNeedUpdate = geometry.verticesNeedUpdate;
				this.normalsNeedUpdate = geometry.normalsNeedUpdate;
				this.colorsNeedUpdate = geometry.colorsNeedUpdate;
				this.uvsNeedUpdate = geometry.uvsNeedUpdate;
				this.groupsNeedUpdate = geometry.groupsNeedUpdate;
	
				return this;
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function arrayMax( array ) {
	
			if ( array.length === 0 ) return - Infinity;
	
			var max = array[ 0 ];
	
			for ( var i = 1, l = array.length; i < l; ++ i ) {
	
				if ( array[ i ] > max ) max = array[ i ];
	
			}
	
			return max;
	
		}
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		var bufferGeometryId = 1; // BufferGeometry uses odd numbers as Id
	
		function BufferGeometry() {
	
			Object.defineProperty( this, 'id', { value: bufferGeometryId += 2 } );
	
			this.uuid = _Math.generateUUID();
	
			this.name = '';
			this.type = 'BufferGeometry';
	
			this.index = null;
			this.attributes = {};
	
			this.morphAttributes = {};
	
			this.groups = [];
	
			this.boundingBox = null;
			this.boundingSphere = null;
	
			this.drawRange = { start: 0, count: Infinity };
	
		}
	
		BufferGeometry.prototype = Object.assign( Object.create( EventDispatcher.prototype ), {
	
			constructor: BufferGeometry,
	
			isBufferGeometry: true,
	
			getIndex: function () {
	
				return this.index;
	
			},
	
			setIndex: function ( index ) {
	
				if ( Array.isArray( index ) ) {
	
					this.index = new ( arrayMax( index ) > 65535 ? Uint32BufferAttribute : Uint16BufferAttribute )( index, 1 );
	
				} else {
	
					this.index = index;
	
				}
	
			},
	
			addAttribute: function ( name, attribute ) {
	
				if ( ! ( attribute && attribute.isBufferAttribute ) && ! ( attribute && attribute.isInterleavedBufferAttribute ) ) {
	
					console.warn( 'THREE.BufferGeometry: .addAttribute() now expects ( name, attribute ).' );
	
					this.addAttribute( name, new BufferAttribute( arguments[ 1 ], arguments[ 2 ] ) );
	
					return;
	
				}
	
				if ( name === 'index' ) {
	
					console.warn( 'THREE.BufferGeometry.addAttribute: Use .setIndex() for index attribute.' );
					this.setIndex( attribute );
	
					return;
	
				}
	
				this.attributes[ name ] = attribute;
	
				return this;
	
			},
	
			getAttribute: function ( name ) {
	
				return this.attributes[ name ];
	
			},
	
			removeAttribute: function ( name ) {
	
				delete this.attributes[ name ];
	
				return this;
	
			},
	
			addGroup: function ( start, count, materialIndex ) {
	
				this.groups.push( {
	
					start: start,
					count: count,
					materialIndex: materialIndex !== undefined ? materialIndex : 0
	
				} );
	
			},
	
			clearGroups: function () {
	
				this.groups = [];
	
			},
	
			setDrawRange: function ( start, count ) {
	
				this.drawRange.start = start;
				this.drawRange.count = count;
	
			},
	
			applyMatrix: function ( matrix ) {
	
				var position = this.attributes.position;
	
				if ( position !== undefined ) {
	
					matrix.applyToBufferAttribute( position );
					position.needsUpdate = true;
	
				}
	
				var normal = this.attributes.normal;
	
				if ( normal !== undefined ) {
	
					var normalMatrix = new Matrix3().getNormalMatrix( matrix );
	
					normalMatrix.applyToBufferAttribute( normal );
					normal.needsUpdate = true;
	
				}
	
				if ( this.boundingBox !== null ) {
	
					this.computeBoundingBox();
	
				}
	
				if ( this.boundingSphere !== null ) {
	
					this.computeBoundingSphere();
	
				}
	
				return this;
	
			},
	
			rotateX: function () {
	
				// rotate geometry around world x-axis
	
				var m1 = new Matrix4();
	
				return function rotateX( angle ) {
	
					m1.makeRotationX( angle );
	
					this.applyMatrix( m1 );
	
					return this;
	
				};
	
			}(),
	
			rotateY: function () {
	
				// rotate geometry around world y-axis
	
				var m1 = new Matrix4();
	
				return function rotateY( angle ) {
	
					m1.makeRotationY( angle );
	
					this.applyMatrix( m1 );
	
					return this;
	
				};
	
			}(),
	
			rotateZ: function () {
	
				// rotate geometry around world z-axis
	
				var m1 = new Matrix4();
	
				return function rotateZ( angle ) {
	
					m1.makeRotationZ( angle );
	
					this.applyMatrix( m1 );
	
					return this;
	
				};
	
			}(),
	
			translate: function () {
	
				// translate geometry
	
				var m1 = new Matrix4();
	
				return function translate( x, y, z ) {
	
					m1.makeTranslation( x, y, z );
	
					this.applyMatrix( m1 );
	
					return this;
	
				};
	
			}(),
	
			scale: function () {
	
				// scale geometry
	
				var m1 = new Matrix4();
	
				return function scale( x, y, z ) {
	
					m1.makeScale( x, y, z );
	
					this.applyMatrix( m1 );
	
					return this;
	
				};
	
			}(),
	
			lookAt: function () {
	
				var obj = new Object3D();
	
				return function lookAt( vector ) {
	
					obj.lookAt( vector );
	
					obj.updateMatrix();
	
					this.applyMatrix( obj.matrix );
	
				};
	
			}(),
	
			center: function () {
	
				this.computeBoundingBox();
	
				var offset = this.boundingBox.getCenter().negate();
	
				this.translate( offset.x, offset.y, offset.z );
	
				return offset;
	
			},
	
			setFromObject: function ( object ) {
	
				// console.log( 'THREE.BufferGeometry.setFromObject(). Converting', object, this );
	
				var geometry = object.geometry;
	
				if ( object.isPoints || object.isLine ) {
	
					var positions = new Float32BufferAttribute( geometry.vertices.length * 3, 3 );
					var colors = new Float32BufferAttribute( geometry.colors.length * 3, 3 );
	
					this.addAttribute( 'position', positions.copyVector3sArray( geometry.vertices ) );
					this.addAttribute( 'color', colors.copyColorsArray( geometry.colors ) );
	
					if ( geometry.lineDistances && geometry.lineDistances.length === geometry.vertices.length ) {
	
						var lineDistances = new Float32BufferAttribute( geometry.lineDistances.length, 1 );
	
						this.addAttribute( 'lineDistance', lineDistances.copyArray( geometry.lineDistances ) );
	
					}
	
					if ( geometry.boundingSphere !== null ) {
	
						this.boundingSphere = geometry.boundingSphere.clone();
	
					}
	
					if ( geometry.boundingBox !== null ) {
	
						this.boundingBox = geometry.boundingBox.clone();
	
					}
	
				} else if ( object.isMesh ) {
	
					if ( geometry && geometry.isGeometry ) {
	
						this.fromGeometry( geometry );
	
					}
	
				}
	
				return this;
	
			},
	
			setFromPoints: function ( points ) {
	
				var position = [];
	
				for ( var i = 0, l = points.length; i < l; i ++ ) {
	
					var point = points[ i ];
					position.push( point.x, point.y, point.z || 0 );
	
				}
	
				this.addAttribute( 'position', new Float32BufferAttribute( position, 3 ) );
	
				return this;
	
			},
	
			updateFromObject: function ( object ) {
	
				var geometry = object.geometry;
	
				if ( object.isMesh ) {
	
					var direct = geometry.__directGeometry;
	
					if ( geometry.elementsNeedUpdate === true ) {
	
						direct = undefined;
						geometry.elementsNeedUpdate = false;
	
					}
	
					if ( direct === undefined ) {
	
						return this.fromGeometry( geometry );
	
					}
	
					direct.verticesNeedUpdate = geometry.verticesNeedUpdate;
					direct.normalsNeedUpdate = geometry.normalsNeedUpdate;
					direct.colorsNeedUpdate = geometry.colorsNeedUpdate;
					direct.uvsNeedUpdate = geometry.uvsNeedUpdate;
					direct.groupsNeedUpdate = geometry.groupsNeedUpdate;
	
					geometry.verticesNeedUpdate = false;
					geometry.normalsNeedUpdate = false;
					geometry.colorsNeedUpdate = false;
					geometry.uvsNeedUpdate = false;
					geometry.groupsNeedUpdate = false;
	
					geometry = direct;
	
				}
	
				var attribute;
	
				if ( geometry.verticesNeedUpdate === true ) {
	
					attribute = this.attributes.position;
	
					if ( attribute !== undefined ) {
	
						attribute.copyVector3sArray( geometry.vertices );
						attribute.needsUpdate = true;
	
					}
	
					geometry.verticesNeedUpdate = false;
	
				}
	
				if ( geometry.normalsNeedUpdate === true ) {
	
					attribute = this.attributes.normal;
	
					if ( attribute !== undefined ) {
	
						attribute.copyVector3sArray( geometry.normals );
						attribute.needsUpdate = true;
	
					}
	
					geometry.normalsNeedUpdate = false;
	
				}
	
				if ( geometry.colorsNeedUpdate === true ) {
	
					attribute = this.attributes.color;
	
					if ( attribute !== undefined ) {
	
						attribute.copyColorsArray( geometry.colors );
						attribute.needsUpdate = true;
	
					}
	
					geometry.colorsNeedUpdate = false;
	
				}
	
				if ( geometry.uvsNeedUpdate ) {
	
					attribute = this.attributes.uv;
	
					if ( attribute !== undefined ) {
	
						attribute.copyVector2sArray( geometry.uvs );
						attribute.needsUpdate = true;
	
					}
	
					geometry.uvsNeedUpdate = false;
	
				}
	
				if ( geometry.lineDistancesNeedUpdate ) {
	
					attribute = this.attributes.lineDistance;
	
					if ( attribute !== undefined ) {
	
						attribute.copyArray( geometry.lineDistances );
						attribute.needsUpdate = true;
	
					}
	
					geometry.lineDistancesNeedUpdate = false;
	
				}
	
				if ( geometry.groupsNeedUpdate ) {
	
					geometry.computeGroups( object.geometry );
					this.groups = geometry.groups;
	
					geometry.groupsNeedUpdate = false;
	
				}
	
				return this;
	
			},
	
			fromGeometry: function ( geometry ) {
	
				geometry.__directGeometry = new DirectGeometry().fromGeometry( geometry );
	
				return this.fromDirectGeometry( geometry.__directGeometry );
	
			},
	
			fromDirectGeometry: function ( geometry ) {
	
				var positions = new Float32Array( geometry.vertices.length * 3 );
				this.addAttribute( 'position', new BufferAttribute( positions, 3 ).copyVector3sArray( geometry.vertices ) );
	
				if ( geometry.normals.length > 0 ) {
	
					var normals = new Float32Array( geometry.normals.length * 3 );
					this.addAttribute( 'normal', new BufferAttribute( normals, 3 ).copyVector3sArray( geometry.normals ) );
	
				}
	
				if ( geometry.colors.length > 0 ) {
	
					var colors = new Float32Array( geometry.colors.length * 3 );
					this.addAttribute( 'color', new BufferAttribute( colors, 3 ).copyColorsArray( geometry.colors ) );
	
				}
	
				if ( geometry.uvs.length > 0 ) {
	
					var uvs = new Float32Array( geometry.uvs.length * 2 );
					this.addAttribute( 'uv', new BufferAttribute( uvs, 2 ).copyVector2sArray( geometry.uvs ) );
	
				}
	
				if ( geometry.uvs2.length > 0 ) {
	
					var uvs2 = new Float32Array( geometry.uvs2.length * 2 );
					this.addAttribute( 'uv2', new BufferAttribute( uvs2, 2 ).copyVector2sArray( geometry.uvs2 ) );
	
				}
	
				if ( geometry.indices.length > 0 ) {
	
					var TypeArray = arrayMax( geometry.indices ) > 65535 ? Uint32Array : Uint16Array;
					var indices = new TypeArray( geometry.indices.length * 3 );
					this.setIndex( new BufferAttribute( indices, 1 ).copyIndicesArray( geometry.indices ) );
	
				}
	
				// groups
	
				this.groups = geometry.groups;
	
				// morphs
	
				for ( var name in geometry.morphTargets ) {
	
					var array = [];
					var morphTargets = geometry.morphTargets[ name ];
	
					for ( var i = 0, l = morphTargets.length; i < l; i ++ ) {
	
						var morphTarget = morphTargets[ i ];
	
						var attribute = new Float32BufferAttribute( morphTarget.length * 3, 3 );
	
						array.push( attribute.copyVector3sArray( morphTarget ) );
	
					}
	
					this.morphAttributes[ name ] = array;
	
				}
	
				// skinning
	
				if ( geometry.skinIndices.length > 0 ) {
	
					var skinIndices = new Float32BufferAttribute( geometry.skinIndices.length * 4, 4 );
					this.addAttribute( 'skinIndex', skinIndices.copyVector4sArray( geometry.skinIndices ) );
	
				}
	
				if ( geometry.skinWeights.length > 0 ) {
	
					var skinWeights = new Float32BufferAttribute( geometry.skinWeights.length * 4, 4 );
					this.addAttribute( 'skinWeight', skinWeights.copyVector4sArray( geometry.skinWeights ) );
	
				}
	
				//
	
				if ( geometry.boundingSphere !== null ) {
	
					this.boundingSphere = geometry.boundingSphere.clone();
	
				}
	
				if ( geometry.boundingBox !== null ) {
	
					this.boundingBox = geometry.boundingBox.clone();
	
				}
	
				return this;
	
			},
	
			computeBoundingBox: function () {
	
				if ( this.boundingBox === null ) {
	
					this.boundingBox = new Box3();
	
				}
	
				var position = this.attributes.position;
	
				if ( position !== undefined ) {
	
					this.boundingBox.setFromBufferAttribute( position );
	
				} else {
	
					this.boundingBox.makeEmpty();
	
				}
	
				if ( isNaN( this.boundingBox.min.x ) || isNaN( this.boundingBox.min.y ) || isNaN( this.boundingBox.min.z ) ) {
	
					console.error( 'THREE.BufferGeometry.computeBoundingBox: Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this );
	
				}
	
			},
	
			computeBoundingSphere: function () {
	
				var box = new Box3();
				var vector = new Vector3();
	
				return function computeBoundingSphere() {
	
					if ( this.boundingSphere === null ) {
	
						this.boundingSphere = new Sphere();
	
					}
	
					var position = this.attributes.position;
	
					if ( position ) {
	
						var center = this.boundingSphere.center;
	
						box.setFromBufferAttribute( position );
						box.getCenter( center );
	
						// hoping to find a boundingSphere with a radius smaller than the
						// boundingSphere of the boundingBox: sqrt(3) smaller in the best case
	
						var maxRadiusSq = 0;
	
						for ( var i = 0, il = position.count; i < il; i ++ ) {
	
							vector.x = position.getX( i );
							vector.y = position.getY( i );
							vector.z = position.getZ( i );
							maxRadiusSq = Math.max( maxRadiusSq, center.distanceToSquared( vector ) );
	
						}
	
						this.boundingSphere.radius = Math.sqrt( maxRadiusSq );
	
						if ( isNaN( this.boundingSphere.radius ) ) {
	
							console.error( 'THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this );
	
						}
	
					}
	
				};
	
			}(),
	
			computeFaceNormals: function () {
	
				// backwards compatibility
	
			},
	
			computeVertexNormals: function () {
	
				var index = this.index;
				var attributes = this.attributes;
				var groups = this.groups;
	
				if ( attributes.position ) {
	
					var positions = attributes.position.array;
	
					if ( attributes.normal === undefined ) {
	
						this.addAttribute( 'normal', new BufferAttribute( new Float32Array( positions.length ), 3 ) );
	
					} else {
	
						// reset existing normals to zero
	
						var array = attributes.normal.array;
	
						for ( var i = 0, il = array.length; i < il; i ++ ) {
	
							array[ i ] = 0;
	
						}
	
					}
	
					var normals = attributes.normal.array;
	
					var vA, vB, vC;
					var pA = new Vector3(), pB = new Vector3(), pC = new Vector3();
					var cb = new Vector3(), ab = new Vector3();
	
					// indexed elements
	
					if ( index ) {
	
						var indices = index.array;
	
						if ( groups.length === 0 ) {
	
							this.addGroup( 0, indices.length );
	
						}
	
						for ( var j = 0, jl = groups.length; j < jl; ++ j ) {
	
							var group = groups[ j ];
	
							var start = group.start;
							var count = group.count;
	
							for ( var i = start, il = start + count; i < il; i += 3 ) {
	
								vA = indices[ i + 0 ] * 3;
								vB = indices[ i + 1 ] * 3;
								vC = indices[ i + 2 ] * 3;
	
								pA.fromArray( positions, vA );
								pB.fromArray( positions, vB );
								pC.fromArray( positions, vC );
	
								cb.subVectors( pC, pB );
								ab.subVectors( pA, pB );
								cb.cross( ab );
	
								normals[ vA ] += cb.x;
								normals[ vA + 1 ] += cb.y;
								normals[ vA + 2 ] += cb.z;
	
								normals[ vB ] += cb.x;
								normals[ vB + 1 ] += cb.y;
								normals[ vB + 2 ] += cb.z;
	
								normals[ vC ] += cb.x;
								normals[ vC + 1 ] += cb.y;
								normals[ vC + 2 ] += cb.z;
	
							}
	
						}
	
					} else {
	
						// non-indexed elements (unconnected triangle soup)
	
						for ( var i = 0, il = positions.length; i < il; i += 9 ) {
	
							pA.fromArray( positions, i );
							pB.fromArray( positions, i + 3 );
							pC.fromArray( positions, i + 6 );
	
							cb.subVectors( pC, pB );
							ab.subVectors( pA, pB );
							cb.cross( ab );
	
							normals[ i ] = cb.x;
							normals[ i + 1 ] = cb.y;
							normals[ i + 2 ] = cb.z;
	
							normals[ i + 3 ] = cb.x;
							normals[ i + 4 ] = cb.y;
							normals[ i + 5 ] = cb.z;
	
							normals[ i + 6 ] = cb.x;
							normals[ i + 7 ] = cb.y;
							normals[ i + 8 ] = cb.z;
	
						}
	
					}
	
					this.normalizeNormals();
	
					attributes.normal.needsUpdate = true;
	
				}
	
			},
	
			merge: function ( geometry, offset ) {
	
				if ( ! ( geometry && geometry.isBufferGeometry ) ) {
	
					console.error( 'THREE.BufferGeometry.merge(): geometry not an instance of THREE.BufferGeometry.', geometry );
					return;
	
				}
	
				if ( offset === undefined ) offset = 0;
	
				var attributes = this.attributes;
	
				for ( var key in attributes ) {
	
					if ( geometry.attributes[ key ] === undefined ) continue;
	
					var attribute1 = attributes[ key ];
					var attributeArray1 = attribute1.array;
	
					var attribute2 = geometry.attributes[ key ];
					var attributeArray2 = attribute2.array;
	
					var attributeSize = attribute2.itemSize;
	
					for ( var i = 0, j = attributeSize * offset; i < attributeArray2.length; i ++, j ++ ) {
	
						attributeArray1[ j ] = attributeArray2[ i ];
	
					}
	
				}
	
				return this;
	
			},
	
			normalizeNormals: function () {
	
				var vector = new Vector3();
	
				return function normalizeNormals() {
	
					var normals = this.attributes.normal;
	
					for ( var i = 0, il = normals.count; i < il; i ++ ) {
	
						vector.x = normals.getX( i );
						vector.y = normals.getY( i );
						vector.z = normals.getZ( i );
	
						vector.normalize();
	
						normals.setXYZ( i, vector.x, vector.y, vector.z );
	
					}
	
				};
	
			}(),
	
			toNonIndexed: function () {
	
				if ( this.index === null ) {
	
					console.warn( 'THREE.BufferGeometry.toNonIndexed(): Geometry is already non-indexed.' );
					return this;
	
				}
	
				var geometry2 = new BufferGeometry();
	
				var indices = this.index.array;
				var attributes = this.attributes;
	
				for ( var name in attributes ) {
	
					var attribute = attributes[ name ];
	
					var array = attribute.array;
					var itemSize = attribute.itemSize;
	
					var array2 = new array.constructor( indices.length * itemSize );
	
					var index = 0, index2 = 0;
	
					for ( var i = 0, l = indices.length; i < l; i ++ ) {
	
						index = indices[ i ] * itemSize;
	
						for ( var j = 0; j < itemSize; j ++ ) {
	
							array2[ index2 ++ ] = array[ index ++ ];
	
						}
	
					}
	
					geometry2.addAttribute( name, new BufferAttribute( array2, itemSize ) );
	
				}
	
				return geometry2;
	
			},
	
			toJSON: function () {
	
				var data = {
					metadata: {
						version: 4.5,
						type: 'BufferGeometry',
						generator: 'BufferGeometry.toJSON'
					}
				};
	
				// standard BufferGeometry serialization
	
				data.uuid = this.uuid;
				data.type = this.type;
				if ( this.name !== '' ) data.name = this.name;
	
				if ( this.parameters !== undefined ) {
	
					var parameters = this.parameters;
	
					for ( var key in parameters ) {
	
						if ( parameters[ key ] !== undefined ) data[ key ] = parameters[ key ];
	
					}
	
					return data;
	
				}
	
				data.data = { attributes: {} };
	
				var index = this.index;
	
				if ( index !== null ) {
	
					var array = Array.prototype.slice.call( index.array );
	
					data.data.index = {
						type: index.array.constructor.name,
						array: array
					};
	
				}
	
				var attributes = this.attributes;
	
				for ( var key in attributes ) {
	
					var attribute = attributes[ key ];
	
					var array = Array.prototype.slice.call( attribute.array );
	
					data.data.attributes[ key ] = {
						itemSize: attribute.itemSize,
						type: attribute.array.constructor.name,
						array: array,
						normalized: attribute.normalized
					};
	
				}
	
				var groups = this.groups;
	
				if ( groups.length > 0 ) {
	
					data.data.groups = JSON.parse( JSON.stringify( groups ) );
	
				}
	
				var boundingSphere = this.boundingSphere;
	
				if ( boundingSphere !== null ) {
	
					data.data.boundingSphere = {
						center: boundingSphere.center.toArray(),
						radius: boundingSphere.radius
					};
	
				}
	
				return data;
	
			},
	
			clone: function () {
	
				/*
				 // Handle primitives
	
				 var parameters = this.parameters;
	
				 if ( parameters !== undefined ) {
	
				 var values = [];
	
				 for ( var key in parameters ) {
	
				 values.push( parameters[ key ] );
	
				 }
	
				 var geometry = Object.create( this.constructor.prototype );
				 this.constructor.apply( geometry, values );
				 return geometry;
	
				 }
	
				 return new this.constructor().copy( this );
				 */
	
				return new BufferGeometry().copy( this );
	
			},
	
			copy: function ( source ) {
	
				var name, i, l;
	
				// reset
	
				this.index = null;
				this.attributes = {};
				this.morphAttributes = {};
				this.groups = [];
				this.boundingBox = null;
				this.boundingSphere = null;
	
				// name
	
				this.name = source.name;
	
				// index
	
				var index = source.index;
	
				if ( index !== null ) {
	
					this.setIndex( index.clone() );
	
				}
	
				// attributes
	
				var attributes = source.attributes;
	
				for ( name in attributes ) {
	
					var attribute = attributes[ name ];
					this.addAttribute( name, attribute.clone() );
	
				}
	
				// morph attributes
	
				var morphAttributes = source.morphAttributes;
	
				for ( name in morphAttributes ) {
	
					var array = [];
					var morphAttribute = morphAttributes[ name ]; // morphAttribute: array of Float32BufferAttributes
	
					for ( i = 0, l = morphAttribute.length; i < l; i ++ ) {
	
						array.push( morphAttribute[ i ].clone() );
	
					}
	
					this.morphAttributes[ name ] = array;
	
				}
	
				// groups
	
				var groups = source.groups;
	
				for ( i = 0, l = groups.length; i < l; i ++ ) {
	
					var group = groups[ i ];
					this.addGroup( group.start, group.count, group.materialIndex );
	
				}
	
				// bounding box
	
				var boundingBox = source.boundingBox;
	
				if ( boundingBox !== null ) {
	
					this.boundingBox = boundingBox.clone();
	
				}
	
				// bounding sphere
	
				var boundingSphere = source.boundingSphere;
	
				if ( boundingSphere !== null ) {
	
					this.boundingSphere = boundingSphere.clone();
	
				}
	
				// draw range
	
				this.drawRange.start = source.drawRange.start;
				this.drawRange.count = source.drawRange.count;
	
				return this;
	
			},
	
			dispose: function () {
	
				this.dispatchEvent( { type: 'dispose' } );
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author Mugen87 / https://github.com/Mugen87
		 */
	
		// BoxGeometry
	
		function BoxGeometry( width, height, depth, widthSegments, heightSegments, depthSegments ) {
	
			Geometry.call( this );
	
			this.type = 'BoxGeometry';
	
			this.parameters = {
				width: width,
				height: height,
				depth: depth,
				widthSegments: widthSegments,
				heightSegments: heightSegments,
				depthSegments: depthSegments
			};
	
			this.fromBufferGeometry( new BoxBufferGeometry( width, height, depth, widthSegments, heightSegments, depthSegments ) );
			this.mergeVertices();
	
		}
	
		BoxGeometry.prototype = Object.create( Geometry.prototype );
		BoxGeometry.prototype.constructor = BoxGeometry;
	
		// BoxBufferGeometry
	
		function BoxBufferGeometry( width, height, depth, widthSegments, heightSegments, depthSegments ) {
	
			BufferGeometry.call( this );
	
			this.type = 'BoxBufferGeometry';
	
			this.parameters = {
				width: width,
				height: height,
				depth: depth,
				widthSegments: widthSegments,
				heightSegments: heightSegments,
				depthSegments: depthSegments
			};
	
			var scope = this;
	
			width = width || 1;
			height = height || 1;
			depth = depth || 1;
	
			// segments
	
			widthSegments = Math.floor( widthSegments ) || 1;
			heightSegments = Math.floor( heightSegments ) || 1;
			depthSegments = Math.floor( depthSegments ) || 1;
	
			// buffers
	
			var indices = [];
			var vertices = [];
			var normals = [];
			var uvs = [];
	
			// helper variables
	
			var numberOfVertices = 0;
			var groupStart = 0;
	
			// build each side of the box geometry
	
			buildPlane( 'z', 'y', 'x', - 1, - 1, depth, height, width, depthSegments, heightSegments, 0 ); // px
			buildPlane( 'z', 'y', 'x', 1, - 1, depth, height, - width, depthSegments, heightSegments, 1 ); // nx
			buildPlane( 'x', 'z', 'y', 1, 1, width, depth, height, widthSegments, depthSegments, 2 ); // py
			buildPlane( 'x', 'z', 'y', 1, - 1, width, depth, - height, widthSegments, depthSegments, 3 ); // ny
			buildPlane( 'x', 'y', 'z', 1, - 1, width, height, depth, widthSegments, heightSegments, 4 ); // pz
			buildPlane( 'x', 'y', 'z', - 1, - 1, width, height, - depth, widthSegments, heightSegments, 5 ); // nz
	
			// build geometry
	
			this.setIndex( indices );
			this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
			this.addAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
			this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );
	
			function buildPlane( u, v, w, udir, vdir, width, height, depth, gridX, gridY, materialIndex ) {
	
				var segmentWidth = width / gridX;
				var segmentHeight = height / gridY;
	
				var widthHalf = width / 2;
				var heightHalf = height / 2;
				var depthHalf = depth / 2;
	
				var gridX1 = gridX + 1;
				var gridY1 = gridY + 1;
	
				var vertexCounter = 0;
				var groupCount = 0;
	
				var ix, iy;
	
				var vector = new Vector3();
	
				// generate vertices, normals and uvs
	
				for ( iy = 0; iy < gridY1; iy ++ ) {
	
					var y = iy * segmentHeight - heightHalf;
	
					for ( ix = 0; ix < gridX1; ix ++ ) {
	
						var x = ix * segmentWidth - widthHalf;
	
						// set values to correct vector component
	
						vector[ u ] = x * udir;
						vector[ v ] = y * vdir;
						vector[ w ] = depthHalf;
	
						// now apply vector to vertex buffer
	
						vertices.push( vector.x, vector.y, vector.z );
	
						// set values to correct vector component
	
						vector[ u ] = 0;
						vector[ v ] = 0;
						vector[ w ] = depth > 0 ? 1 : - 1;
	
						// now apply vector to normal buffer
	
						normals.push( vector.x, vector.y, vector.z );
	
						// uvs
	
						uvs.push( ix / gridX );
						uvs.push( 1 - ( iy / gridY ) );
	
						// counters
	
						vertexCounter += 1;
	
					}
	
				}
	
				// indices
	
				// 1. you need three indices to draw a single face
				// 2. a single segment consists of two faces
				// 3. so we need to generate six (2*3) indices per segment
	
				for ( iy = 0; iy < gridY; iy ++ ) {
	
					for ( ix = 0; ix < gridX; ix ++ ) {
	
						var a = numberOfVertices + ix + gridX1 * iy;
						var b = numberOfVertices + ix + gridX1 * ( iy + 1 );
						var c = numberOfVertices + ( ix + 1 ) + gridX1 * ( iy + 1 );
						var d = numberOfVertices + ( ix + 1 ) + gridX1 * iy;
	
						// faces
	
						indices.push( a, b, d );
						indices.push( b, c, d );
	
						// increase counter
	
						groupCount += 6;
	
					}
	
				}
	
				// add a group to the geometry. this will ensure multi material support
	
				scope.addGroup( groupStart, groupCount, materialIndex );
	
				// calculate new start value for groups
	
				groupStart += groupCount;
	
				// update total number of vertices
	
				numberOfVertices += vertexCounter;
	
			}
	
		}
	
		BoxBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
		BoxBufferGeometry.prototype.constructor = BoxBufferGeometry;
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author Mugen87 / https://github.com/Mugen87
		 */
	
		// PlaneGeometry
	
		function PlaneGeometry( width, height, widthSegments, heightSegments ) {
	
			Geometry.call( this );
	
			this.type = 'PlaneGeometry';
	
			this.parameters = {
				width: width,
				height: height,
				widthSegments: widthSegments,
				heightSegments: heightSegments
			};
	
			this.fromBufferGeometry( new PlaneBufferGeometry( width, height, widthSegments, heightSegments ) );
			this.mergeVertices();
	
		}
	
		PlaneGeometry.prototype = Object.create( Geometry.prototype );
		PlaneGeometry.prototype.constructor = PlaneGeometry;
	
		// PlaneBufferGeometry
	
		function PlaneBufferGeometry( width, height, widthSegments, heightSegments ) {
	
			BufferGeometry.call( this );
	
			this.type = 'PlaneBufferGeometry';
	
			this.parameters = {
				width: width,
				height: height,
				widthSegments: widthSegments,
				heightSegments: heightSegments
			};
	
			width = width || 1;
			height = height || 1;
	
			var width_half = width / 2;
			var height_half = height / 2;
	
			var gridX = Math.floor( widthSegments ) || 1;
			var gridY = Math.floor( heightSegments ) || 1;
	
			var gridX1 = gridX + 1;
			var gridY1 = gridY + 1;
	
			var segment_width = width / gridX;
			var segment_height = height / gridY;
	
			var ix, iy;
	
			// buffers
	
			var indices = [];
			var vertices = [];
			var normals = [];
			var uvs = [];
	
			// generate vertices, normals and uvs
	
			for ( iy = 0; iy < gridY1; iy ++ ) {
	
				var y = iy * segment_height - height_half;
	
				for ( ix = 0; ix < gridX1; ix ++ ) {
	
					var x = ix * segment_width - width_half;
	
					vertices.push( x, - y, 0 );
	
					normals.push( 0, 0, 1 );
	
					uvs.push( ix / gridX );
					uvs.push( 1 - ( iy / gridY ) );
	
				}
	
			}
	
			// indices
	
			for ( iy = 0; iy < gridY; iy ++ ) {
	
				for ( ix = 0; ix < gridX; ix ++ ) {
	
					var a = ix + gridX1 * iy;
					var b = ix + gridX1 * ( iy + 1 );
					var c = ( ix + 1 ) + gridX1 * ( iy + 1 );
					var d = ( ix + 1 ) + gridX1 * iy;
	
					// faces
	
					indices.push( a, b, d );
					indices.push( b, c, d );
	
				}
	
			}
	
			// build geometry
	
			this.setIndex( indices );
			this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
			this.addAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
			this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );
	
		}
	
		PlaneBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
		PlaneBufferGeometry.prototype.constructor = PlaneBufferGeometry;
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author alteredq / http://alteredqualia.com/
		 *
		 * parameters = {
		 *  color: <hex>,
		 *  opacity: <float>,
		 *  map: new THREE.Texture( <Image> ),
		 *
		 *  lightMap: new THREE.Texture( <Image> ),
		 *  lightMapIntensity: <float>
		 *
		 *  aoMap: new THREE.Texture( <Image> ),
		 *  aoMapIntensity: <float>
		 *
		 *  specularMap: new THREE.Texture( <Image> ),
		 *
		 *  alphaMap: new THREE.Texture( <Image> ),
		 *
		 *  envMap: new THREE.TextureCube( [posx, negx, posy, negy, posz, negz] ),
		 *  combine: THREE.Multiply,
		 *  reflectivity: <float>,
		 *  refractionRatio: <float>,
		 *
		 *  depthTest: <bool>,
		 *  depthWrite: <bool>,
		 *
		 *  wireframe: <boolean>,
		 *  wireframeLinewidth: <float>,
		 *
		 *  skinning: <bool>,
		 *  morphTargets: <bool>
		 * }
		 */
	
		function MeshBasicMaterial( parameters ) {
	
			Material.call( this );
	
			this.type = 'MeshBasicMaterial';
	
			this.color = new Color( 0xffffff ); // emissive
	
			this.map = null;
	
			this.lightMap = null;
			this.lightMapIntensity = 1.0;
	
			this.aoMap = null;
			this.aoMapIntensity = 1.0;
	
			this.specularMap = null;
	
			this.alphaMap = null;
	
			this.envMap = null;
			this.combine = MultiplyOperation;
			this.reflectivity = 1;
			this.refractionRatio = 0.98;
	
			this.wireframe = false;
			this.wireframeLinewidth = 1;
			this.wireframeLinecap = 'round';
			this.wireframeLinejoin = 'round';
	
			this.skinning = false;
			this.morphTargets = false;
	
			this.lights = false;
	
			this.setValues( parameters );
	
		}
	
		MeshBasicMaterial.prototype = Object.create( Material.prototype );
		MeshBasicMaterial.prototype.constructor = MeshBasicMaterial;
	
		MeshBasicMaterial.prototype.isMeshBasicMaterial = true;
	
		MeshBasicMaterial.prototype.copy = function ( source ) {
	
			Material.prototype.copy.call( this, source );
	
			this.color.copy( source.color );
	
			this.map = source.map;
	
			this.lightMap = source.lightMap;
			this.lightMapIntensity = source.lightMapIntensity;
	
			this.aoMap = source.aoMap;
			this.aoMapIntensity = source.aoMapIntensity;
	
			this.specularMap = source.specularMap;
	
			this.alphaMap = source.alphaMap;
	
			this.envMap = source.envMap;
			this.combine = source.combine;
			this.reflectivity = source.reflectivity;
			this.refractionRatio = source.refractionRatio;
	
			this.wireframe = source.wireframe;
			this.wireframeLinewidth = source.wireframeLinewidth;
			this.wireframeLinecap = source.wireframeLinecap;
			this.wireframeLinejoin = source.wireframeLinejoin;
	
			this.skinning = source.skinning;
			this.morphTargets = source.morphTargets;
	
			return this;
	
		};
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 *
		 * parameters = {
		 *  defines: { "label" : "value" },
		 *  uniforms: { "parameter1": { value: 1.0 }, "parameter2": { value2: 2 } },
		 *
		 *  fragmentShader: <string>,
		 *  vertexShader: <string>,
		 *
		 *  wireframe: <boolean>,
		 *  wireframeLinewidth: <float>,
		 *
		 *  lights: <bool>,
		 *
		 *  skinning: <bool>,
		 *  morphTargets: <bool>,
		 *  morphNormals: <bool>
		 * }
		 */
	
		function ShaderMaterial( parameters ) {
	
			Material.call( this );
	
			this.type = 'ShaderMaterial';
	
			this.defines = {};
			this.uniforms = {};
	
			this.vertexShader = 'void main() {\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}';
			this.fragmentShader = 'void main() {\n\tgl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}';
	
			this.linewidth = 1;
	
			this.wireframe = false;
			this.wireframeLinewidth = 1;
	
			this.fog = false; // set to use scene fog
			this.lights = false; // set to use scene lights
			this.clipping = false; // set to use user-defined clipping planes
	
			this.skinning = false; // set to use skinning attribute streams
			this.morphTargets = false; // set to use morph targets
			this.morphNormals = false; // set to use morph normals
	
			this.extensions = {
				derivatives: false, // set to use derivatives
				fragDepth: false, // set to use fragment depth values
				drawBuffers: false, // set to use draw buffers
				shaderTextureLOD: false // set to use shader texture LOD
			};
	
			// When rendered geometry doesn't include these attributes but the material does,
			// use these default values in WebGL. This avoids errors when buffer data is missing.
			this.defaultAttributeValues = {
				'color': [ 1, 1, 1 ],
				'uv': [ 0, 0 ],
				'uv2': [ 0, 0 ]
			};
	
			this.index0AttributeName = undefined;
	
			if ( parameters !== undefined ) {
	
				if ( parameters.attributes !== undefined ) {
	
					console.error( 'THREE.ShaderMaterial: attributes should now be defined in THREE.BufferGeometry instead.' );
	
				}
	
				this.setValues( parameters );
	
			}
	
		}
	
		ShaderMaterial.prototype = Object.create( Material.prototype );
		ShaderMaterial.prototype.constructor = ShaderMaterial;
	
		ShaderMaterial.prototype.isShaderMaterial = true;
	
		ShaderMaterial.prototype.copy = function ( source ) {
	
			Material.prototype.copy.call( this, source );
	
			this.fragmentShader = source.fragmentShader;
			this.vertexShader = source.vertexShader;
	
			this.uniforms = UniformsUtils.clone( source.uniforms );
	
			this.defines = source.defines;
	
			this.wireframe = source.wireframe;
			this.wireframeLinewidth = source.wireframeLinewidth;
	
			this.lights = source.lights;
			this.clipping = source.clipping;
	
			this.skinning = source.skinning;
	
			this.morphTargets = source.morphTargets;
			this.morphNormals = source.morphNormals;
	
			this.extensions = source.extensions;
	
			return this;
	
		};
	
		ShaderMaterial.prototype.toJSON = function ( meta ) {
	
			var data = Material.prototype.toJSON.call( this, meta );
	
			data.uniforms = this.uniforms;
			data.vertexShader = this.vertexShader;
			data.fragmentShader = this.fragmentShader;
	
			return data;
	
		};
	
		/**
		 * @author bhouston / http://clara.io
		 */
	
		function Ray( origin, direction ) {
	
			this.origin = ( origin !== undefined ) ? origin : new Vector3();
			this.direction = ( direction !== undefined ) ? direction : new Vector3();
	
		}
	
		Object.assign( Ray.prototype, {
	
			set: function ( origin, direction ) {
	
				this.origin.copy( origin );
				this.direction.copy( direction );
	
				return this;
	
			},
	
			clone: function () {
	
				return new this.constructor().copy( this );
	
			},
	
			copy: function ( ray ) {
	
				this.origin.copy( ray.origin );
				this.direction.copy( ray.direction );
	
				return this;
	
			},
	
			at: function ( t, optionalTarget ) {
	
				var result = optionalTarget || new Vector3();
	
				return result.copy( this.direction ).multiplyScalar( t ).add( this.origin );
	
			},
	
			lookAt: function ( v ) {
	
				this.direction.copy( v ).sub( this.origin ).normalize();
	
				return this;
	
			},
	
			recast: function () {
	
				var v1 = new Vector3();
	
				return function recast( t ) {
	
					this.origin.copy( this.at( t, v1 ) );
	
					return this;
	
				};
	
			}(),
	
			closestPointToPoint: function ( point, optionalTarget ) {
	
				var result = optionalTarget || new Vector3();
				result.subVectors( point, this.origin );
				var directionDistance = result.dot( this.direction );
	
				if ( directionDistance < 0 ) {
	
					return result.copy( this.origin );
	
				}
	
				return result.copy( this.direction ).multiplyScalar( directionDistance ).add( this.origin );
	
			},
	
			distanceToPoint: function ( point ) {
	
				return Math.sqrt( this.distanceSqToPoint( point ) );
	
			},
	
			distanceSqToPoint: function () {
	
				var v1 = new Vector3();
	
				return function distanceSqToPoint( point ) {
	
					var directionDistance = v1.subVectors( point, this.origin ).dot( this.direction );
	
					// point behind the ray
	
					if ( directionDistance < 0 ) {
	
						return this.origin.distanceToSquared( point );
	
					}
	
					v1.copy( this.direction ).multiplyScalar( directionDistance ).add( this.origin );
	
					return v1.distanceToSquared( point );
	
				};
	
			}(),
	
			distanceSqToSegment: function () {
	
				var segCenter = new Vector3();
				var segDir = new Vector3();
				var diff = new Vector3();
	
				return function distanceSqToSegment( v0, v1, optionalPointOnRay, optionalPointOnSegment ) {
	
					// from http://www.geometrictools.com/GTEngine/Include/Mathematics/GteDistRaySegment.h
					// It returns the min distance between the ray and the segment
					// defined by v0 and v1
					// It can also set two optional targets :
					// - The closest point on the ray
					// - The closest point on the segment
	
					segCenter.copy( v0 ).add( v1 ).multiplyScalar( 0.5 );
					segDir.copy( v1 ).sub( v0 ).normalize();
					diff.copy( this.origin ).sub( segCenter );
	
					var segExtent = v0.distanceTo( v1 ) * 0.5;
					var a01 = - this.direction.dot( segDir );
					var b0 = diff.dot( this.direction );
					var b1 = - diff.dot( segDir );
					var c = diff.lengthSq();
					var det = Math.abs( 1 - a01 * a01 );
					var s0, s1, sqrDist, extDet;
	
					if ( det > 0 ) {
	
						// The ray and segment are not parallel.
	
						s0 = a01 * b1 - b0;
						s1 = a01 * b0 - b1;
						extDet = segExtent * det;
	
						if ( s0 >= 0 ) {
	
							if ( s1 >= - extDet ) {
	
								if ( s1 <= extDet ) {
	
									// region 0
									// Minimum at interior points of ray and segment.
	
									var invDet = 1 / det;
									s0 *= invDet;
									s1 *= invDet;
									sqrDist = s0 * ( s0 + a01 * s1 + 2 * b0 ) + s1 * ( a01 * s0 + s1 + 2 * b1 ) + c;
	
								} else {
	
									// region 1
	
									s1 = segExtent;
									s0 = Math.max( 0, - ( a01 * s1 + b0 ) );
									sqrDist = - s0 * s0 + s1 * ( s1 + 2 * b1 ) + c;
	
								}
	
							} else {
	
								// region 5
	
								s1 = - segExtent;
								s0 = Math.max( 0, - ( a01 * s1 + b0 ) );
								sqrDist = - s0 * s0 + s1 * ( s1 + 2 * b1 ) + c;
	
							}
	
						} else {
	
							if ( s1 <= - extDet ) {
	
								// region 4
	
								s0 = Math.max( 0, - ( - a01 * segExtent + b0 ) );
								s1 = ( s0 > 0 ) ? - segExtent : Math.min( Math.max( - segExtent, - b1 ), segExtent );
								sqrDist = - s0 * s0 + s1 * ( s1 + 2 * b1 ) + c;
	
							} else if ( s1 <= extDet ) {
	
								// region 3
	
								s0 = 0;
								s1 = Math.min( Math.max( - segExtent, - b1 ), segExtent );
								sqrDist = s1 * ( s1 + 2 * b1 ) + c;
	
							} else {
	
								// region 2
	
								s0 = Math.max( 0, - ( a01 * segExtent + b0 ) );
								s1 = ( s0 > 0 ) ? segExtent : Math.min( Math.max( - segExtent, - b1 ), segExtent );
								sqrDist = - s0 * s0 + s1 * ( s1 + 2 * b1 ) + c;
	
							}
	
						}
	
					} else {
	
						// Ray and segment are parallel.
	
						s1 = ( a01 > 0 ) ? - segExtent : segExtent;
						s0 = Math.max( 0, - ( a01 * s1 + b0 ) );
						sqrDist = - s0 * s0 + s1 * ( s1 + 2 * b1 ) + c;
	
					}
	
					if ( optionalPointOnRay ) {
	
						optionalPointOnRay.copy( this.direction ).multiplyScalar( s0 ).add( this.origin );
	
					}
	
					if ( optionalPointOnSegment ) {
	
						optionalPointOnSegment.copy( segDir ).multiplyScalar( s1 ).add( segCenter );
	
					}
	
					return sqrDist;
	
				};
	
			}(),
	
			intersectSphere: function () {
	
				var v1 = new Vector3();
	
				return function intersectSphere( sphere, optionalTarget ) {
	
					v1.subVectors( sphere.center, this.origin );
					var tca = v1.dot( this.direction );
					var d2 = v1.dot( v1 ) - tca * tca;
					var radius2 = sphere.radius * sphere.radius;
	
					if ( d2 > radius2 ) return null;
	
					var thc = Math.sqrt( radius2 - d2 );
	
					// t0 = first intersect point - entrance on front of sphere
					var t0 = tca - thc;
	
					// t1 = second intersect point - exit point on back of sphere
					var t1 = tca + thc;
	
					// test to see if both t0 and t1 are behind the ray - if so, return null
					if ( t0 < 0 && t1 < 0 ) return null;
	
					// test to see if t0 is behind the ray:
					// if it is, the ray is inside the sphere, so return the second exit point scaled by t1,
					// in order to always return an intersect point that is in front of the ray.
					if ( t0 < 0 ) return this.at( t1, optionalTarget );
	
					// else t0 is in front of the ray, so return the first collision point scaled by t0
					return this.at( t0, optionalTarget );
	
				};
	
			}(),
	
			intersectsSphere: function ( sphere ) {
	
				return this.distanceToPoint( sphere.center ) <= sphere.radius;
	
			},
	
			distanceToPlane: function ( plane ) {
	
				var denominator = plane.normal.dot( this.direction );
	
				if ( denominator === 0 ) {
	
					// line is coplanar, return origin
					if ( plane.distanceToPoint( this.origin ) === 0 ) {
	
						return 0;
	
					}
	
					// Null is preferable to undefined since undefined means.... it is undefined
	
					return null;
	
				}
	
				var t = - ( this.origin.dot( plane.normal ) + plane.constant ) / denominator;
	
				// Return if the ray never intersects the plane
	
				return t >= 0 ? t : null;
	
			},
	
			intersectPlane: function ( plane, optionalTarget ) {
	
				var t = this.distanceToPlane( plane );
	
				if ( t === null ) {
	
					return null;
	
				}
	
				return this.at( t, optionalTarget );
	
			},
	
			intersectsPlane: function ( plane ) {
	
				// check if the ray lies on the plane first
	
				var distToPoint = plane.distanceToPoint( this.origin );
	
				if ( distToPoint === 0 ) {
	
					return true;
	
				}
	
				var denominator = plane.normal.dot( this.direction );
	
				if ( denominator * distToPoint < 0 ) {
	
					return true;
	
				}
	
				// ray origin is behind the plane (and is pointing behind it)
	
				return false;
	
			},
	
			intersectBox: function ( box, optionalTarget ) {
	
				var tmin, tmax, tymin, tymax, tzmin, tzmax;
	
				var invdirx = 1 / this.direction.x,
					invdiry = 1 / this.direction.y,
					invdirz = 1 / this.direction.z;
	
				var origin = this.origin;
	
				if ( invdirx >= 0 ) {
	
					tmin = ( box.min.x - origin.x ) * invdirx;
					tmax = ( box.max.x - origin.x ) * invdirx;
	
				} else {
	
					tmin = ( box.max.x - origin.x ) * invdirx;
					tmax = ( box.min.x - origin.x ) * invdirx;
	
				}
	
				if ( invdiry >= 0 ) {
	
					tymin = ( box.min.y - origin.y ) * invdiry;
					tymax = ( box.max.y - origin.y ) * invdiry;
	
				} else {
	
					tymin = ( box.max.y - origin.y ) * invdiry;
					tymax = ( box.min.y - origin.y ) * invdiry;
	
				}
	
				if ( ( tmin > tymax ) || ( tymin > tmax ) ) return null;
	
				// These lines also handle the case where tmin or tmax is NaN
				// (result of 0 * Infinity). x !== x returns true if x is NaN
	
				if ( tymin > tmin || tmin !== tmin ) tmin = tymin;
	
				if ( tymax < tmax || tmax !== tmax ) tmax = tymax;
	
				if ( invdirz >= 0 ) {
	
					tzmin = ( box.min.z - origin.z ) * invdirz;
					tzmax = ( box.max.z - origin.z ) * invdirz;
	
				} else {
	
					tzmin = ( box.max.z - origin.z ) * invdirz;
					tzmax = ( box.min.z - origin.z ) * invdirz;
	
				}
	
				if ( ( tmin > tzmax ) || ( tzmin > tmax ) ) return null;
	
				if ( tzmin > tmin || tmin !== tmin ) tmin = tzmin;
	
				if ( tzmax < tmax || tmax !== tmax ) tmax = tzmax;
	
				//return point closest to the ray (positive side)
	
				if ( tmax < 0 ) return null;
	
				return this.at( tmin >= 0 ? tmin : tmax, optionalTarget );
	
			},
	
			intersectsBox: ( function () {
	
				var v = new Vector3();
	
				return function intersectsBox( box ) {
	
					return this.intersectBox( box, v ) !== null;
	
				};
	
			} )(),
	
			intersectTriangle: function () {
	
				// Compute the offset origin, edges, and normal.
				var diff = new Vector3();
				var edge1 = new Vector3();
				var edge2 = new Vector3();
				var normal = new Vector3();
	
				return function intersectTriangle( a, b, c, backfaceCulling, optionalTarget ) {
	
					// from http://www.geometrictools.com/GTEngine/Include/Mathematics/GteIntrRay3Triangle3.h
	
					edge1.subVectors( b, a );
					edge2.subVectors( c, a );
					normal.crossVectors( edge1, edge2 );
	
					// Solve Q + t*D = b1*E1 + b2*E2 (Q = kDiff, D = ray direction,
					// E1 = kEdge1, E2 = kEdge2, N = Cross(E1,E2)) by
					//   |Dot(D,N)|*b1 = sign(Dot(D,N))*Dot(D,Cross(Q,E2))
					//   |Dot(D,N)|*b2 = sign(Dot(D,N))*Dot(D,Cross(E1,Q))
					//   |Dot(D,N)|*t = -sign(Dot(D,N))*Dot(Q,N)
					var DdN = this.direction.dot( normal );
					var sign;
	
					if ( DdN > 0 ) {
	
						if ( backfaceCulling ) return null;
						sign = 1;
	
					} else if ( DdN < 0 ) {
	
						sign = - 1;
						DdN = - DdN;
	
					} else {
	
						return null;
	
					}
	
					diff.subVectors( this.origin, a );
					var DdQxE2 = sign * this.direction.dot( edge2.crossVectors( diff, edge2 ) );
	
					// b1 < 0, no intersection
					if ( DdQxE2 < 0 ) {
	
						return null;
	
					}
	
					var DdE1xQ = sign * this.direction.dot( edge1.cross( diff ) );
	
					// b2 < 0, no intersection
					if ( DdE1xQ < 0 ) {
	
						return null;
	
					}
	
					// b1+b2 > 1, no intersection
					if ( DdQxE2 + DdE1xQ > DdN ) {
	
						return null;
	
					}
	
					// Line intersects triangle, check if ray does.
					var QdN = - sign * diff.dot( normal );
	
					// t < 0, no intersection
					if ( QdN < 0 ) {
	
						return null;
	
					}
	
					// Ray intersects triangle.
					return this.at( QdN / DdN, optionalTarget );
	
				};
	
			}(),
	
			applyMatrix4: function ( matrix4 ) {
	
				this.origin.applyMatrix4( matrix4 );
				this.direction.transformDirection( matrix4 );
	
				return this;
	
			},
	
			equals: function ( ray ) {
	
				return ray.origin.equals( this.origin ) && ray.direction.equals( this.direction );
	
			}
	
		} );
	
		/**
		 * @author bhouston / http://clara.io
		 */
	
		function Line3( start, end ) {
	
			this.start = ( start !== undefined ) ? start : new Vector3();
			this.end = ( end !== undefined ) ? end : new Vector3();
	
		}
	
		Object.assign( Line3.prototype, {
	
			set: function ( start, end ) {
	
				this.start.copy( start );
				this.end.copy( end );
	
				return this;
	
			},
	
			clone: function () {
	
				return new this.constructor().copy( this );
	
			},
	
			copy: function ( line ) {
	
				this.start.copy( line.start );
				this.end.copy( line.end );
	
				return this;
	
			},
	
			getCenter: function ( optionalTarget ) {
	
				var result = optionalTarget || new Vector3();
				return result.addVectors( this.start, this.end ).multiplyScalar( 0.5 );
	
			},
	
			delta: function ( optionalTarget ) {
	
				var result = optionalTarget || new Vector3();
				return result.subVectors( this.end, this.start );
	
			},
	
			distanceSq: function () {
	
				return this.start.distanceToSquared( this.end );
	
			},
	
			distance: function () {
	
				return this.start.distanceTo( this.end );
	
			},
	
			at: function ( t, optionalTarget ) {
	
				var result = optionalTarget || new Vector3();
	
				return this.delta( result ).multiplyScalar( t ).add( this.start );
	
			},
	
			closestPointToPointParameter: function () {
	
				var startP = new Vector3();
				var startEnd = new Vector3();
	
				return function closestPointToPointParameter( point, clampToLine ) {
	
					startP.subVectors( point, this.start );
					startEnd.subVectors( this.end, this.start );
	
					var startEnd2 = startEnd.dot( startEnd );
					var startEnd_startP = startEnd.dot( startP );
	
					var t = startEnd_startP / startEnd2;
	
					if ( clampToLine ) {
	
						t = _Math.clamp( t, 0, 1 );
	
					}
	
					return t;
	
				};
	
			}(),
	
			closestPointToPoint: function ( point, clampToLine, optionalTarget ) {
	
				var t = this.closestPointToPointParameter( point, clampToLine );
	
				var result = optionalTarget || new Vector3();
	
				return this.delta( result ).multiplyScalar( t ).add( this.start );
	
			},
	
			applyMatrix4: function ( matrix ) {
	
				this.start.applyMatrix4( matrix );
				this.end.applyMatrix4( matrix );
	
				return this;
	
			},
	
			equals: function ( line ) {
	
				return line.start.equals( this.start ) && line.end.equals( this.end );
	
			}
	
		} );
	
		/**
		 * @author bhouston / http://clara.io
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function Triangle( a, b, c ) {
	
			this.a = ( a !== undefined ) ? a : new Vector3();
			this.b = ( b !== undefined ) ? b : new Vector3();
			this.c = ( c !== undefined ) ? c : new Vector3();
	
		}
	
		Object.assign( Triangle, {
	
			normal: function () {
	
				var v0 = new Vector3();
	
				return function normal( a, b, c, optionalTarget ) {
	
					var result = optionalTarget || new Vector3();
	
					result.subVectors( c, b );
					v0.subVectors( a, b );
					result.cross( v0 );
	
					var resultLengthSq = result.lengthSq();
					if ( resultLengthSq > 0 ) {
	
						return result.multiplyScalar( 1 / Math.sqrt( resultLengthSq ) );
	
					}
	
					return result.set( 0, 0, 0 );
	
				};
	
			}(),
	
			// static/instance method to calculate barycentric coordinates
			// based on: http://www.blackpawn.com/texts/pointinpoly/default.html
			barycoordFromPoint: function () {
	
				var v0 = new Vector3();
				var v1 = new Vector3();
				var v2 = new Vector3();
	
				return function barycoordFromPoint( point, a, b, c, optionalTarget ) {
	
					v0.subVectors( c, a );
					v1.subVectors( b, a );
					v2.subVectors( point, a );
	
					var dot00 = v0.dot( v0 );
					var dot01 = v0.dot( v1 );
					var dot02 = v0.dot( v2 );
					var dot11 = v1.dot( v1 );
					var dot12 = v1.dot( v2 );
	
					var denom = ( dot00 * dot11 - dot01 * dot01 );
	
					var result = optionalTarget || new Vector3();
	
					// collinear or singular triangle
					if ( denom === 0 ) {
	
						// arbitrary location outside of triangle?
						// not sure if this is the best idea, maybe should be returning undefined
						return result.set( - 2, - 1, - 1 );
	
					}
	
					var invDenom = 1 / denom;
					var u = ( dot11 * dot02 - dot01 * dot12 ) * invDenom;
					var v = ( dot00 * dot12 - dot01 * dot02 ) * invDenom;
	
					// barycentric coordinates must always sum to 1
					return result.set( 1 - u - v, v, u );
	
				};
	
			}(),
	
			containsPoint: function () {
	
				var v1 = new Vector3();
	
				return function containsPoint( point, a, b, c ) {
	
					var result = Triangle.barycoordFromPoint( point, a, b, c, v1 );
	
					return ( result.x >= 0 ) && ( result.y >= 0 ) && ( ( result.x + result.y ) <= 1 );
	
				};
	
			}()
	
		} );
	
		Object.assign( Triangle.prototype, {
	
			set: function ( a, b, c ) {
	
				this.a.copy( a );
				this.b.copy( b );
				this.c.copy( c );
	
				return this;
	
			},
	
			setFromPointsAndIndices: function ( points, i0, i1, i2 ) {
	
				this.a.copy( points[ i0 ] );
				this.b.copy( points[ i1 ] );
				this.c.copy( points[ i2 ] );
	
				return this;
	
			},
	
			clone: function () {
	
				return new this.constructor().copy( this );
	
			},
	
			copy: function ( triangle ) {
	
				this.a.copy( triangle.a );
				this.b.copy( triangle.b );
				this.c.copy( triangle.c );
	
				return this;
	
			},
	
			area: function () {
	
				var v0 = new Vector3();
				var v1 = new Vector3();
	
				return function area() {
	
					v0.subVectors( this.c, this.b );
					v1.subVectors( this.a, this.b );
	
					return v0.cross( v1 ).length() * 0.5;
	
				};
	
			}(),
	
			midpoint: function ( optionalTarget ) {
	
				var result = optionalTarget || new Vector3();
				return result.addVectors( this.a, this.b ).add( this.c ).multiplyScalar( 1 / 3 );
	
			},
	
			normal: function ( optionalTarget ) {
	
				return Triangle.normal( this.a, this.b, this.c, optionalTarget );
	
			},
	
			plane: function ( optionalTarget ) {
	
				var result = optionalTarget || new Plane();
	
				return result.setFromCoplanarPoints( this.a, this.b, this.c );
	
			},
	
			barycoordFromPoint: function ( point, optionalTarget ) {
	
				return Triangle.barycoordFromPoint( point, this.a, this.b, this.c, optionalTarget );
	
			},
	
			containsPoint: function ( point ) {
	
				return Triangle.containsPoint( point, this.a, this.b, this.c );
	
			},
	
			closestPointToPoint: function () {
	
				var plane = new Plane();
				var edgeList = [ new Line3(), new Line3(), new Line3() ];
				var projectedPoint = new Vector3();
				var closestPoint = new Vector3();
	
				return function closestPointToPoint( point, optionalTarget ) {
	
					var result = optionalTarget || new Vector3();
					var minDistance = Infinity;
	
					// project the point onto the plane of the triangle
	
					plane.setFromCoplanarPoints( this.a, this.b, this.c );
					plane.projectPoint( point, projectedPoint );
	
					// check if the projection lies within the triangle
	
					if ( this.containsPoint( projectedPoint ) === true ) {
	
						// if so, this is the closest point
	
						result.copy( projectedPoint );
	
					} else {
	
						// if not, the point falls outside the triangle. the result is the closest point to the triangle's edges or vertices
	
						edgeList[ 0 ].set( this.a, this.b );
						edgeList[ 1 ].set( this.b, this.c );
						edgeList[ 2 ].set( this.c, this.a );
	
						for ( var i = 0; i < edgeList.length; i ++ ) {
	
							edgeList[ i ].closestPointToPoint( projectedPoint, true, closestPoint );
	
							var distance = projectedPoint.distanceToSquared( closestPoint );
	
							if ( distance < minDistance ) {
	
								minDistance = distance;
	
								result.copy( closestPoint );
	
							}
	
						}
	
					}
	
					return result;
	
				};
	
			}(),
	
			equals: function ( triangle ) {
	
				return triangle.a.equals( this.a ) && triangle.b.equals( this.b ) && triangle.c.equals( this.c );
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author alteredq / http://alteredqualia.com/
		 * @author mikael emtinger / http://gomo.se/
		 * @author jonobr1 / http://jonobr1.com/
		 */
	
		function Mesh( geometry, material ) {
	
			Object3D.call( this );
	
			this.type = 'Mesh';
	
			this.geometry = geometry !== undefined ? geometry : new BufferGeometry();
			this.material = material !== undefined ? material : new MeshBasicMaterial( { color: Math.random() * 0xffffff } );
	
			this.drawMode = TrianglesDrawMode;
	
			this.updateMorphTargets();
	
		}
	
		Mesh.prototype = Object.assign( Object.create( Object3D.prototype ), {
	
			constructor: Mesh,
	
			isMesh: true,
	
			setDrawMode: function ( value ) {
	
				this.drawMode = value;
	
			},
	
			copy: function ( source ) {
	
				Object3D.prototype.copy.call( this, source );
	
				this.drawMode = source.drawMode;
	
				if ( source.morphTargetInfluences !== undefined ) {
	
					this.morphTargetInfluences = source.morphTargetInfluences.slice();
	
				}
	
				if ( source.morphTargetDictionary !== undefined ) {
	
					this.morphTargetDictionary = Object.assign( {}, source.morphTargetDictionary );
	
				}
	
				return this;
	
			},
	
			updateMorphTargets: function () {
	
				var geometry = this.geometry;
				var m, ml, name;
	
				if ( geometry.isBufferGeometry ) {
	
					var morphAttributes = geometry.morphAttributes;
					var keys = Object.keys( morphAttributes );
	
					if ( keys.length > 0 ) {
	
						var morphAttribute = morphAttributes[ keys[ 0 ] ];
	
						if ( morphAttribute !== undefined ) {
	
							this.morphTargetInfluences = [];
							this.morphTargetDictionary = {};
	
							for ( m = 0, ml = morphAttribute.length; m < ml; m ++ ) {
	
								name = morphAttribute[ m ].name || String( m );
	
								this.morphTargetInfluences.push( 0 );
								this.morphTargetDictionary[ name ] = m;
	
							}
	
						}
	
					}
	
				} else {
	
					var morphTargets = geometry.morphTargets;
	
					if ( morphTargets !== undefined && morphTargets.length > 0 ) {
	
						this.morphTargetInfluences = [];
						this.morphTargetDictionary = {};
	
						for ( m = 0, ml = morphTargets.length; m < ml; m ++ ) {
	
							name = morphTargets[ m ].name || String( m );
	
							this.morphTargetInfluences.push( 0 );
							this.morphTargetDictionary[ name ] = m;
	
						}
	
					}
	
				}
	
			},
	
			raycast: ( function () {
	
				var inverseMatrix = new Matrix4();
				var ray = new Ray();
				var sphere = new Sphere();
	
				var vA = new Vector3();
				var vB = new Vector3();
				var vC = new Vector3();
	
				var tempA = new Vector3();
				var tempB = new Vector3();
				var tempC = new Vector3();
	
				var uvA = new Vector2();
				var uvB = new Vector2();
				var uvC = new Vector2();
	
				var barycoord = new Vector3();
	
				var intersectionPoint = new Vector3();
				var intersectionPointWorld = new Vector3();
	
				function uvIntersection( point, p1, p2, p3, uv1, uv2, uv3 ) {
	
					Triangle.barycoordFromPoint( point, p1, p2, p3, barycoord );
	
					uv1.multiplyScalar( barycoord.x );
					uv2.multiplyScalar( barycoord.y );
					uv3.multiplyScalar( barycoord.z );
	
					uv1.add( uv2 ).add( uv3 );
	
					return uv1.clone();
	
				}
	
				function checkIntersection( object, material, raycaster, ray, pA, pB, pC, point ) {
	
					var intersect;
	
					if ( material.side === BackSide ) {
	
						intersect = ray.intersectTriangle( pC, pB, pA, true, point );
	
					} else {
	
						intersect = ray.intersectTriangle( pA, pB, pC, material.side !== DoubleSide, point );
	
					}
	
					if ( intersect === null ) return null;
	
					intersectionPointWorld.copy( point );
					intersectionPointWorld.applyMatrix4( object.matrixWorld );
	
					var distance = raycaster.ray.origin.distanceTo( intersectionPointWorld );
	
					if ( distance < raycaster.near || distance > raycaster.far ) return null;
	
					return {
						distance: distance,
						point: intersectionPointWorld.clone(),
						object: object
					};
	
				}
	
				function checkBufferGeometryIntersection( object, raycaster, ray, position, uv, a, b, c ) {
	
					vA.fromBufferAttribute( position, a );
					vB.fromBufferAttribute( position, b );
					vC.fromBufferAttribute( position, c );
	
					var intersection = checkIntersection( object, object.material, raycaster, ray, vA, vB, vC, intersectionPoint );
	
					if ( intersection ) {
	
						if ( uv ) {
	
							uvA.fromBufferAttribute( uv, a );
							uvB.fromBufferAttribute( uv, b );
							uvC.fromBufferAttribute( uv, c );
	
							intersection.uv = uvIntersection( intersectionPoint, vA, vB, vC, uvA, uvB, uvC );
	
						}
	
						intersection.face = new Face3( a, b, c, Triangle.normal( vA, vB, vC ) );
						intersection.faceIndex = a;
	
					}
	
					return intersection;
	
				}
	
				return function raycast( raycaster, intersects ) {
	
					var geometry = this.geometry;
					var material = this.material;
					var matrixWorld = this.matrixWorld;
	
					if ( material === undefined ) return;
	
					// Checking boundingSphere distance to ray
	
					if ( geometry.boundingSphere === null ) geometry.computeBoundingSphere();
	
					sphere.copy( geometry.boundingSphere );
					sphere.applyMatrix4( matrixWorld );
	
					if ( raycaster.ray.intersectsSphere( sphere ) === false ) return;
	
					//
	
					inverseMatrix.getInverse( matrixWorld );
					ray.copy( raycaster.ray ).applyMatrix4( inverseMatrix );
	
					// Check boundingBox before continuing
	
					if ( geometry.boundingBox !== null ) {
	
						if ( ray.intersectsBox( geometry.boundingBox ) === false ) return;
	
					}
	
					var intersection;
	
					if ( geometry.isBufferGeometry ) {
	
						var a, b, c;
						var index = geometry.index;
						var position = geometry.attributes.position;
						var uv = geometry.attributes.uv;
						var i, l;
	
						if ( index !== null ) {
	
							// indexed buffer geometry
	
							for ( i = 0, l = index.count; i < l; i += 3 ) {
	
								a = index.getX( i );
								b = index.getX( i + 1 );
								c = index.getX( i + 2 );
	
								intersection = checkBufferGeometryIntersection( this, raycaster, ray, position, uv, a, b, c );
	
								if ( intersection ) {
	
									intersection.faceIndex = Math.floor( i / 3 ); // triangle number in indices buffer semantics
									intersects.push( intersection );
	
								}
	
							}
	
						} else if ( position !== undefined ) {
	
							// non-indexed buffer geometry
	
							for ( i = 0, l = position.count; i < l; i += 3 ) {
	
								a = i;
								b = i + 1;
								c = i + 2;
	
								intersection = checkBufferGeometryIntersection( this, raycaster, ray, position, uv, a, b, c );
	
								if ( intersection ) {
	
									intersection.index = a; // triangle number in positions buffer semantics
									intersects.push( intersection );
	
								}
	
							}
	
						}
	
					} else if ( geometry.isGeometry ) {
	
						var fvA, fvB, fvC;
						var isMultiMaterial = Array.isArray( material );
	
						var vertices = geometry.vertices;
						var faces = geometry.faces;
						var uvs;
	
						var faceVertexUvs = geometry.faceVertexUvs[ 0 ];
						if ( faceVertexUvs.length > 0 ) uvs = faceVertexUvs;
	
						for ( var f = 0, fl = faces.length; f < fl; f ++ ) {
	
							var face = faces[ f ];
							var faceMaterial = isMultiMaterial ? material[ face.materialIndex ] : material;
	
							if ( faceMaterial === undefined ) continue;
	
							fvA = vertices[ face.a ];
							fvB = vertices[ face.b ];
							fvC = vertices[ face.c ];
	
							if ( faceMaterial.morphTargets === true ) {
	
								var morphTargets = geometry.morphTargets;
								var morphInfluences = this.morphTargetInfluences;
	
								vA.set( 0, 0, 0 );
								vB.set( 0, 0, 0 );
								vC.set( 0, 0, 0 );
	
								for ( var t = 0, tl = morphTargets.length; t < tl; t ++ ) {
	
									var influence = morphInfluences[ t ];
	
									if ( influence === 0 ) continue;
	
									var targets = morphTargets[ t ].vertices;
	
									vA.addScaledVector( tempA.subVectors( targets[ face.a ], fvA ), influence );
									vB.addScaledVector( tempB.subVectors( targets[ face.b ], fvB ), influence );
									vC.addScaledVector( tempC.subVectors( targets[ face.c ], fvC ), influence );
	
								}
	
								vA.add( fvA );
								vB.add( fvB );
								vC.add( fvC );
	
								fvA = vA;
								fvB = vB;
								fvC = vC;
	
							}
	
							intersection = checkIntersection( this, faceMaterial, raycaster, ray, fvA, fvB, fvC, intersectionPoint );
	
							if ( intersection ) {
	
								if ( uvs && uvs[ f ] ) {
	
									var uvs_f = uvs[ f ];
									uvA.copy( uvs_f[ 0 ] );
									uvB.copy( uvs_f[ 1 ] );
									uvC.copy( uvs_f[ 2 ] );
	
									intersection.uv = uvIntersection( intersectionPoint, fvA, fvB, fvC, uvA, uvB, uvC );
	
								}
	
								intersection.face = face;
								intersection.faceIndex = f;
								intersects.push( intersection );
	
							}
	
						}
	
					}
	
				};
	
			}() ),
	
			clone: function () {
	
				return new this.constructor( this.geometry, this.material ).copy( this );
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function WebGLBackground( renderer, state, geometries, premultipliedAlpha ) {
	
			var clearColor = new Color( 0x000000 );
			var clearAlpha = 0;
	
			var planeCamera, planeMesh;
			var boxMesh;
	
			function render( renderList, scene, camera, forceClear ) {
	
				var background = scene.background;
	
				if ( background === null ) {
	
					setClear( clearColor, clearAlpha );
	
				} else if ( background && background.isColor ) {
	
					setClear( background, 1 );
					forceClear = true;
	
				}
	
				if ( renderer.autoClear || forceClear ) {
	
					renderer.clear( renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil );
	
				}
	
				if ( background && background.isCubeTexture ) {
	
					if ( boxMesh === undefined ) {
	
						boxMesh = new Mesh(
							new BoxBufferGeometry( 1, 1, 1 ),
							new ShaderMaterial( {
								uniforms: ShaderLib.cube.uniforms,
								vertexShader: ShaderLib.cube.vertexShader,
								fragmentShader: ShaderLib.cube.fragmentShader,
								side: BackSide,
								depthTest: true,
								depthWrite: false,
								fog: false
							} )
						);
	
						boxMesh.geometry.removeAttribute( 'normal' );
						boxMesh.geometry.removeAttribute( 'uv' );
	
						boxMesh.onBeforeRender = function ( renderer, scene, camera ) {
	
							this.matrixWorld.copyPosition( camera.matrixWorld );
	
						};
	
						geometries.update( boxMesh.geometry );
	
					}
	
					boxMesh.material.uniforms.tCube.value = background;
	
					renderList.push( boxMesh, boxMesh.geometry, boxMesh.material, 0, null );
	
				} else if ( background && background.isTexture ) {
	
					if ( planeCamera === undefined ) {
	
						planeCamera = new OrthographicCamera( - 1, 1, 1, - 1, 0, 1 );
	
						planeMesh = new Mesh(
							new PlaneBufferGeometry( 2, 2 ),
							new MeshBasicMaterial( { depthTest: false, depthWrite: false, fog: false } )
						);
	
						geometries.update( planeMesh.geometry );
	
					}
	
					planeMesh.material.map = background;
	
					// TODO Push this to renderList
	
					renderer.renderBufferDirect( planeCamera, null, planeMesh.geometry, planeMesh.material, planeMesh, null );
	
				}
	
			}
	
			function setClear( color, alpha ) {
	
				state.buffers.color.setClear( color.r, color.g, color.b, alpha, premultipliedAlpha );
	
			}
	
			return {
	
				getClearColor: function () {
	
					return clearColor;
	
				},
				setClearColor: function ( color, alpha ) {
	
					clearColor.set( color );
					clearAlpha = alpha !== undefined ? alpha : 1;
					setClear( clearColor, clearAlpha );
	
				},
				getClearAlpha: function () {
	
					return clearAlpha;
	
				},
				setClearAlpha: function ( alpha ) {
	
					clearAlpha = alpha;
					setClear( clearColor, clearAlpha );
	
				},
				render: render
	
			};
	
		}
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function painterSortStable( a, b ) {
	
			if ( a.renderOrder !== b.renderOrder ) {
	
				return a.renderOrder - b.renderOrder;
	
			} else if ( a.program && b.program && a.program !== b.program ) {
	
				return a.program.id - b.program.id;
	
			} else if ( a.material.id !== b.material.id ) {
	
				return a.material.id - b.material.id;
	
			} else if ( a.z !== b.z ) {
	
				return a.z - b.z;
	
			} else {
	
				return a.id - b.id;
	
			}
	
		}
	
		function reversePainterSortStable( a, b ) {
	
			if ( a.renderOrder !== b.renderOrder ) {
	
				return a.renderOrder - b.renderOrder;
	
			} if ( a.z !== b.z ) {
	
				return b.z - a.z;
	
			} else {
	
				return a.id - b.id;
	
			}
	
		}
	
		function WebGLRenderList() {
	
			var renderItems = [];
			var renderItemsIndex = 0;
	
			var opaque = [];
			var transparent = [];
	
			function init() {
	
				renderItemsIndex = 0;
	
				opaque.length = 0;
				transparent.length = 0;
	
			}
	
			function push( object, geometry, material, z, group ) {
	
				var renderItem = renderItems[ renderItemsIndex ];
	
				if ( renderItem === undefined ) {
	
					renderItem = {
						id: object.id,
						object: object,
						geometry: geometry,
						material: material,
						program: material.program,
						renderOrder: object.renderOrder,
						z: z,
						group: group
					};
	
					renderItems[ renderItemsIndex ] = renderItem;
	
				} else {
	
					renderItem.id = object.id;
					renderItem.object = object;
					renderItem.geometry = geometry;
					renderItem.material = material;
					renderItem.program = material.program;
					renderItem.renderOrder = object.renderOrder;
					renderItem.z = z;
					renderItem.group = group;
	
				}
	
				( material.transparent === true ? transparent : opaque ).push( renderItem );
	
				renderItemsIndex ++;
	
			}
	
			function sort() {
	
				if ( opaque.length > 1 ) opaque.sort( painterSortStable );
				if ( transparent.length > 1 ) transparent.sort( reversePainterSortStable );
	
			}
	
			return {
				opaque: opaque,
				transparent: transparent,
	
				init: init,
				push: push,
	
				sort: sort
			};
	
		}
	
		function WebGLRenderLists() {
	
			var lists = {};
	
			function get( scene, camera ) {
	
				var hash = scene.id + ',' + camera.id;
				var list = lists[ hash ];
	
				if ( list === undefined ) {
	
					// console.log( 'THREE.WebGLRenderLists:', hash );
	
					list = new WebGLRenderList();
					lists[ hash ] = list;
	
				}
	
				return list;
	
			}
	
			function dispose() {
	
				lists = {};
	
			}
	
			return {
				get: get,
				dispose: dispose
			};
	
		}
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function absNumericalSort( a, b ) {
	
			return Math.abs( b[ 1 ] ) - Math.abs( a[ 1 ] );
	
		}
	
		function WebGLMorphtargets( gl ) {
	
			var influencesList = {};
			var morphInfluences = new Float32Array( 8 );
	
			function update( object, geometry, material, program ) {
	
				var objectInfluences = object.morphTargetInfluences;
	
				var length = objectInfluences.length;
	
				var influences = influencesList[ geometry.id ];
	
				if ( influences === undefined ) {
	
					// initialise list
	
					influences = [];
	
					for ( var i = 0; i < length; i ++ ) {
	
						influences[ i ] = [ i, 0 ];
	
					}
	
					influencesList[ geometry.id ] = influences;
	
				}
	
				var morphTargets = material.morphTargets && geometry.morphAttributes.position;
				var morphNormals = material.morphNormals && geometry.morphAttributes.normal;
	
				// Remove current morphAttributes
	
				for ( var i = 0; i < length; i ++ ) {
	
					var influence = influences[ i ];
	
					if ( influence[ 1 ] !== 0 ) {
	
						if ( morphTargets ) geometry.removeAttribute( 'morphTarget' + i );
						if ( morphNormals ) geometry.removeAttribute( 'morphNormal' + i );
	
					}
	
				}
	
				// Collect influences
	
				for ( var i = 0; i < length; i ++ ) {
	
					var influence = influences[ i ];
	
					influence[ 0 ] = i;
					influence[ 1 ] = objectInfluences[ i ];
	
				}
	
				influences.sort( absNumericalSort );
	
				// Add morphAttributes
	
				for ( var i = 0; i < 8; i ++ ) {
	
					var influence = influences[ i ];
	
					if ( influence ) {
	
						var index = influence[ 0 ];
						var value = influence[ 1 ];
	
						if ( value ) {
	
							if ( morphTargets ) geometry.addAttribute( 'morphTarget' + i, morphTargets[ index ] );
							if ( morphNormals ) geometry.addAttribute( 'morphNormal' + i, morphNormals[ index ] );
	
							morphInfluences[ i ] = value;
							continue;
	
						}
	
					}
	
					morphInfluences[ i ] = 0;
	
				}
	
				program.getUniforms().setValue( gl, 'morphTargetInfluences', morphInfluences );
	
			}
	
			return {
	
				update: update
	
			};
	
		}
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function WebGLIndexedBufferRenderer( gl, extensions, infoRender ) {
	
			var mode;
	
			function setMode( value ) {
	
				mode = value;
	
			}
	
			var type, bytesPerElement;
	
			function setIndex( value ) {
	
				type = value.type;
				bytesPerElement = value.bytesPerElement;
	
			}
	
			function render( start, count ) {
	
				gl.drawElements( mode, count, type, start * bytesPerElement );
	
				infoRender.calls ++;
				infoRender.vertices += count;
	
				if ( mode === gl.TRIANGLES ) infoRender.faces += count / 3;
				else if ( mode === gl.POINTS ) infoRender.points += count;
	
			}
	
			function renderInstances( geometry, start, count ) {
	
				var extension = extensions.get( 'ANGLE_instanced_arrays' );
	
				if ( extension === null ) {
	
					console.error( 'THREE.WebGLIndexedBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.' );
					return;
	
				}
	
				extension.drawElementsInstancedANGLE( mode, count, type, start * bytesPerElement, geometry.maxInstancedCount );
	
				infoRender.calls ++;
				infoRender.vertices += count * geometry.maxInstancedCount;
	
				if ( mode === gl.TRIANGLES ) infoRender.faces += geometry.maxInstancedCount * count / 3;
				else if ( mode === gl.POINTS ) infoRender.points += geometry.maxInstancedCount * count;
	
			}
	
			//
	
			this.setMode = setMode;
			this.setIndex = setIndex;
			this.render = render;
			this.renderInstances = renderInstances;
	
		}
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function WebGLBufferRenderer( gl, extensions, infoRender ) {
	
			var mode;
	
			function setMode( value ) {
	
				mode = value;
	
			}
	
			function render( start, count ) {
	
				gl.drawArrays( mode, start, count );
	
				infoRender.calls ++;
				infoRender.vertices += count;
	
				if ( mode === gl.TRIANGLES ) infoRender.faces += count / 3;
				else if ( mode === gl.POINTS ) infoRender.points += count;
	
			}
	
			function renderInstances( geometry, start, count ) {
	
				var extension = extensions.get( 'ANGLE_instanced_arrays' );
	
				if ( extension === null ) {
	
					console.error( 'THREE.WebGLBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.' );
					return;
	
				}
	
				var position = geometry.attributes.position;
	
				if ( position.isInterleavedBufferAttribute ) {
	
					count = position.data.count;
	
					extension.drawArraysInstancedANGLE( mode, 0, count, geometry.maxInstancedCount );
	
				} else {
	
					extension.drawArraysInstancedANGLE( mode, start, count, geometry.maxInstancedCount );
	
				}
	
				infoRender.calls ++;
				infoRender.vertices += count * geometry.maxInstancedCount;
	
				if ( mode === gl.TRIANGLES ) infoRender.faces += geometry.maxInstancedCount * count / 3;
				else if ( mode === gl.POINTS ) infoRender.points += geometry.maxInstancedCount * count;
	
			}
	
			//
	
			this.setMode = setMode;
			this.render = render;
			this.renderInstances = renderInstances;
	
		}
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function WebGLGeometries( gl, attributes, infoMemory ) {
	
			var geometries = {};
			var wireframeAttributes = {};
	
			function onGeometryDispose( event ) {
	
				var geometry = event.target;
				var buffergeometry = geometries[ geometry.id ];
	
				if ( buffergeometry.index !== null ) {
	
					attributes.remove( buffergeometry.index );
	
				}
	
				for ( var name in buffergeometry.attributes ) {
	
					attributes.remove( buffergeometry.attributes[ name ] );
	
				}
	
				geometry.removeEventListener( 'dispose', onGeometryDispose );
	
				delete geometries[ geometry.id ];
	
				// TODO Remove duplicate code
	
				var attribute = wireframeAttributes[ geometry.id ];
	
				if ( attribute ) {
	
					attributes.remove( attribute );
					delete wireframeAttributes[ geometry.id ];
	
				}
	
				attribute = wireframeAttributes[ buffergeometry.id ];
	
				if ( attribute ) {
	
					attributes.remove( attribute );
					delete wireframeAttributes[ buffergeometry.id ];
	
				}
	
				//
	
				infoMemory.geometries --;
	
			}
	
			function get( object, geometry ) {
	
				var buffergeometry = geometries[ geometry.id ];
	
				if ( buffergeometry ) return buffergeometry;
	
				geometry.addEventListener( 'dispose', onGeometryDispose );
	
				if ( geometry.isBufferGeometry ) {
	
					buffergeometry = geometry;
	
				} else if ( geometry.isGeometry ) {
	
					if ( geometry._bufferGeometry === undefined ) {
	
						geometry._bufferGeometry = new BufferGeometry().setFromObject( object );
	
					}
	
					buffergeometry = geometry._bufferGeometry;
	
				}
	
				geometries[ geometry.id ] = buffergeometry;
	
				infoMemory.geometries ++;
	
				return buffergeometry;
	
			}
	
			function update( geometry ) {
	
				var index = geometry.index;
				var geometryAttributes = geometry.attributes;
	
				if ( index !== null ) {
	
					attributes.update( index, gl.ELEMENT_ARRAY_BUFFER );
	
				}
	
				for ( var name in geometryAttributes ) {
	
					attributes.update( geometryAttributes[ name ], gl.ARRAY_BUFFER );
	
				}
	
				// morph targets
	
				var morphAttributes = geometry.morphAttributes;
	
				for ( var name in morphAttributes ) {
	
					var array = morphAttributes[ name ];
	
					for ( var i = 0, l = array.length; i < l; i ++ ) {
	
						attributes.update( array[ i ], gl.ARRAY_BUFFER );
	
					}
	
				}
	
			}
	
			function getWireframeAttribute( geometry ) {
	
				var attribute = wireframeAttributes[ geometry.id ];
	
				if ( attribute ) return attribute;
	
				var indices = [];
	
				var geometryIndex = geometry.index;
				var geometryAttributes = geometry.attributes;
	
				// console.time( 'wireframe' );
	
				if ( geometryIndex !== null ) {
	
					var array = geometryIndex.array;
	
					for ( var i = 0, l = array.length; i < l; i += 3 ) {
	
						var a = array[ i + 0 ];
						var b = array[ i + 1 ];
						var c = array[ i + 2 ];
	
						indices.push( a, b, b, c, c, a );
	
					}
	
				} else {
	
					var array = geometryAttributes.position.array;
	
					for ( var i = 0, l = ( array.length / 3 ) - 1; i < l; i += 3 ) {
	
						var a = i + 0;
						var b = i + 1;
						var c = i + 2;
	
						indices.push( a, b, b, c, c, a );
	
					}
	
				}
	
				// console.timeEnd( 'wireframe' );
	
				attribute = new ( arrayMax( indices ) > 65535 ? Uint32BufferAttribute : Uint16BufferAttribute )( indices, 1 );
	
				attributes.update( attribute, gl.ELEMENT_ARRAY_BUFFER );
	
				wireframeAttributes[ geometry.id ] = attribute;
	
				return attribute;
	
			}
	
			return {
	
				get: get,
				update: update,
	
				getWireframeAttribute: getWireframeAttribute
	
			};
	
		}
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function UniformsCache() {
	
			var lights = {};
	
			return {
	
				get: function ( light ) {
	
					if ( lights[ light.id ] !== undefined ) {
	
						return lights[ light.id ];
	
					}
	
					var uniforms;
	
					switch ( light.type ) {
	
						case 'DirectionalLight':
							uniforms = {
								direction: new Vector3(),
								color: new Color(),
	
								shadow: false,
								shadowBias: 0,
								shadowRadius: 1,
								shadowMapSize: new Vector2()
							};
							break;
	
						case 'SpotLight':
							uniforms = {
								position: new Vector3(),
								direction: new Vector3(),
								color: new Color(),
								distance: 0,
								coneCos: 0,
								penumbraCos: 0,
								decay: 0,
	
								shadow: false,
								shadowBias: 0,
								shadowRadius: 1,
								shadowMapSize: new Vector2()
							};
							break;
	
						case 'PointLight':
							uniforms = {
								position: new Vector3(),
								color: new Color(),
								distance: 0,
								decay: 0,
	
								shadow: false,
								shadowBias: 0,
								shadowRadius: 1,
								shadowMapSize: new Vector2(),
								shadowCameraNear: 1,
								shadowCameraFar: 1000
							};
							break;
	
						case 'HemisphereLight':
							uniforms = {
								direction: new Vector3(),
								skyColor: new Color(),
								groundColor: new Color()
							};
							break;
	
						case 'RectAreaLight':
							uniforms = {
								color: new Color(),
								position: new Vector3(),
								halfWidth: new Vector3(),
								halfHeight: new Vector3()
								// TODO (abelnation): set RectAreaLight shadow uniforms
							};
							break;
	
					}
	
					lights[ light.id ] = uniforms;
	
					return uniforms;
	
				}
	
			};
	
		}
	
		function WebGLLights() {
	
			var cache = new UniformsCache();
	
			var state = {
	
				hash: '',
	
				ambient: [ 0, 0, 0 ],
				directional: [],
				directionalShadowMap: [],
				directionalShadowMatrix: [],
				spot: [],
				spotShadowMap: [],
				spotShadowMatrix: [],
				rectArea: [],
				point: [],
				pointShadowMap: [],
				pointShadowMatrix: [],
				hemi: []
	
			};
	
			var vector3 = new Vector3();
			var matrix4 = new Matrix4();
			var matrix42 = new Matrix4();
	
			function setup( lights, shadows, camera ) {
	
				var r = 0, g = 0, b = 0;
	
				var directionalLength = 0;
				var pointLength = 0;
				var spotLength = 0;
				var rectAreaLength = 0;
				var hemiLength = 0;
	
				var viewMatrix = camera.matrixWorldInverse;
	
				for ( var i = 0, l = lights.length; i < l; i ++ ) {
	
					var light = lights[ i ];
	
					var color = light.color;
					var intensity = light.intensity;
					var distance = light.distance;
	
					var shadowMap = ( light.shadow && light.shadow.map ) ? light.shadow.map.texture : null;
	
					if ( light.isAmbientLight ) {
	
						r += color.r * intensity;
						g += color.g * intensity;
						b += color.b * intensity;
	
					} else if ( light.isDirectionalLight ) {
	
						var uniforms = cache.get( light );
	
						uniforms.color.copy( light.color ).multiplyScalar( light.intensity );
						uniforms.direction.setFromMatrixPosition( light.matrixWorld );
						vector3.setFromMatrixPosition( light.target.matrixWorld );
						uniforms.direction.sub( vector3 );
						uniforms.direction.transformDirection( viewMatrix );
	
						uniforms.shadow = light.castShadow;
	
						if ( light.castShadow ) {
	
							var shadow = light.shadow;
	
							uniforms.shadowBias = shadow.bias;
							uniforms.shadowRadius = shadow.radius;
							uniforms.shadowMapSize = shadow.mapSize;
	
						}
	
						state.directionalShadowMap[ directionalLength ] = shadowMap;
						state.directionalShadowMatrix[ directionalLength ] = light.shadow.matrix;
						state.directional[ directionalLength ] = uniforms;
	
						directionalLength ++;
	
					} else if ( light.isSpotLight ) {
	
						var uniforms = cache.get( light );
	
						uniforms.position.setFromMatrixPosition( light.matrixWorld );
						uniforms.position.applyMatrix4( viewMatrix );
	
						uniforms.color.copy( color ).multiplyScalar( intensity );
						uniforms.distance = distance;
	
						uniforms.direction.setFromMatrixPosition( light.matrixWorld );
						vector3.setFromMatrixPosition( light.target.matrixWorld );
						uniforms.direction.sub( vector3 );
						uniforms.direction.transformDirection( viewMatrix );
	
						uniforms.coneCos = Math.cos( light.angle );
						uniforms.penumbraCos = Math.cos( light.angle * ( 1 - light.penumbra ) );
						uniforms.decay = ( light.distance === 0 ) ? 0.0 : light.decay;
	
						uniforms.shadow = light.castShadow;
	
						if ( light.castShadow ) {
	
							var shadow = light.shadow;
	
							uniforms.shadowBias = shadow.bias;
							uniforms.shadowRadius = shadow.radius;
							uniforms.shadowMapSize = shadow.mapSize;
	
						}
	
						state.spotShadowMap[ spotLength ] = shadowMap;
						state.spotShadowMatrix[ spotLength ] = light.shadow.matrix;
						state.spot[ spotLength ] = uniforms;
	
						spotLength ++;
	
					} else if ( light.isRectAreaLight ) {
	
						var uniforms = cache.get( light );
	
						// (a) intensity controls irradiance of entire light
						uniforms.color
							.copy( color )
							.multiplyScalar( intensity / ( light.width * light.height ) );
	
						// (b) intensity controls the radiance per light area
						// uniforms.color.copy( color ).multiplyScalar( intensity );
	
						uniforms.position.setFromMatrixPosition( light.matrixWorld );
						uniforms.position.applyMatrix4( viewMatrix );
	
						// extract local rotation of light to derive width/height half vectors
						matrix42.identity();
						matrix4.copy( light.matrixWorld );
						matrix4.premultiply( viewMatrix );
						matrix42.extractRotation( matrix4 );
	
						uniforms.halfWidth.set( light.width * 0.5, 0.0, 0.0 );
						uniforms.halfHeight.set( 0.0, light.height * 0.5, 0.0 );
	
						uniforms.halfWidth.applyMatrix4( matrix42 );
						uniforms.halfHeight.applyMatrix4( matrix42 );
	
						// TODO (abelnation): RectAreaLight distance?
						// uniforms.distance = distance;
	
						state.rectArea[ rectAreaLength ] = uniforms;
	
						rectAreaLength ++;
	
					} else if ( light.isPointLight ) {
	
						var uniforms = cache.get( light );
	
						uniforms.position.setFromMatrixPosition( light.matrixWorld );
						uniforms.position.applyMatrix4( viewMatrix );
	
						uniforms.color.copy( light.color ).multiplyScalar( light.intensity );
						uniforms.distance = light.distance;
						uniforms.decay = ( light.distance === 0 ) ? 0.0 : light.decay;
	
						uniforms.shadow = light.castShadow;
	
						if ( light.castShadow ) {
	
							var shadow = light.shadow;
	
							uniforms.shadowBias = shadow.bias;
							uniforms.shadowRadius = shadow.radius;
							uniforms.shadowMapSize = shadow.mapSize;
							uniforms.shadowCameraNear = shadow.camera.near;
							uniforms.shadowCameraFar = shadow.camera.far;
	
						}
	
						state.pointShadowMap[ pointLength ] = shadowMap;
						state.pointShadowMatrix[ pointLength ] = light.shadow.matrix;
						state.point[ pointLength ] = uniforms;
	
						pointLength ++;
	
					} else if ( light.isHemisphereLight ) {
	
						var uniforms = cache.get( light );
	
						uniforms.direction.setFromMatrixPosition( light.matrixWorld );
						uniforms.direction.transformDirection( viewMatrix );
						uniforms.direction.normalize();
	
						uniforms.skyColor.copy( light.color ).multiplyScalar( intensity );
						uniforms.groundColor.copy( light.groundColor ).multiplyScalar( intensity );
	
						state.hemi[ hemiLength ] = uniforms;
	
						hemiLength ++;
	
					}
	
				}
	
				state.ambient[ 0 ] = r;
				state.ambient[ 1 ] = g;
				state.ambient[ 2 ] = b;
	
				state.directional.length = directionalLength;
				state.spot.length = spotLength;
				state.rectArea.length = rectAreaLength;
				state.point.length = pointLength;
				state.hemi.length = hemiLength;
	
				// TODO (sam-g-steel) why aren't we using join
				state.hash = directionalLength + ',' + pointLength + ',' + spotLength + ',' + rectAreaLength + ',' + hemiLength + ',' + shadows.length;
	
			}
	
			return {
				setup: setup,
				state: state
			};
	
		}
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function WebGLObjects( geometries, infoRender ) {
	
			var updateList = {};
	
			function update( object ) {
	
				var frame = infoRender.frame;
	
				var geometry = object.geometry;
				var buffergeometry = geometries.get( object, geometry );
	
				// Update once per frame
	
				if ( updateList[ buffergeometry.id ] !== frame ) {
	
					if ( geometry.isGeometry ) {
	
						buffergeometry.updateFromObject( object );
	
					}
	
					geometries.update( buffergeometry );
	
					updateList[ buffergeometry.id ] = frame;
	
				}
	
				return buffergeometry;
	
			}
	
			function clear() {
	
				updateList = {};
	
			}
	
			return {
	
				update: update,
				clear: clear
	
			};
	
		}
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function addLineNumbers( string ) {
	
			var lines = string.split( '\n' );
	
			for ( var i = 0; i < lines.length; i ++ ) {
	
				lines[ i ] = ( i + 1 ) + ': ' + lines[ i ];
	
			}
	
			return lines.join( '\n' );
	
		}
	
		function WebGLShader( gl, type, string ) {
	
			var shader = gl.createShader( type );
	
			gl.shaderSource( shader, string );
			gl.compileShader( shader );
	
			if ( gl.getShaderParameter( shader, gl.COMPILE_STATUS ) === false ) {
	
				console.error( 'THREE.WebGLShader: Shader couldn\'t compile.' );
	
			}
	
			if ( gl.getShaderInfoLog( shader ) !== '' ) {
	
				console.warn( 'THREE.WebGLShader: gl.getShaderInfoLog()', type === gl.VERTEX_SHADER ? 'vertex' : 'fragment', gl.getShaderInfoLog( shader ), addLineNumbers( string ) );
	
			}
	
			// --enable-privileged-webgl-extension
			// console.log( type, gl.getExtension( 'WEBGL_debug_shaders' ).getTranslatedShaderSource( shader ) );
	
			return shader;
	
		}
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		var programIdCount = 0;
	
		function getEncodingComponents( encoding ) {
	
			switch ( encoding ) {
	
				case LinearEncoding:
					return [ 'Linear', '( value )' ];
				case sRGBEncoding:
					return [ 'sRGB', '( value )' ];
				case RGBEEncoding:
					return [ 'RGBE', '( value )' ];
				case RGBM7Encoding:
					return [ 'RGBM', '( value, 7.0 )' ];
				case RGBM16Encoding:
					return [ 'RGBM', '( value, 16.0 )' ];
				case RGBDEncoding:
					return [ 'RGBD', '( value, 256.0 )' ];
				case GammaEncoding:
					return [ 'Gamma', '( value, float( GAMMA_FACTOR ) )' ];
				default:
					throw new Error( 'unsupported encoding: ' + encoding );
	
			}
	
		}
	
		function getTexelDecodingFunction( functionName, encoding ) {
	
			var components = getEncodingComponents( encoding );
			return 'vec4 ' + functionName + '( vec4 value ) { return ' + components[ 0 ] + 'ToLinear' + components[ 1 ] + '; }';
	
		}
	
		function getTexelEncodingFunction( functionName, encoding ) {
	
			var components = getEncodingComponents( encoding );
			return 'vec4 ' + functionName + '( vec4 value ) { return LinearTo' + components[ 0 ] + components[ 1 ] + '; }';
	
		}
	
		function getToneMappingFunction( functionName, toneMapping ) {
	
			var toneMappingName;
	
			switch ( toneMapping ) {
	
				case LinearToneMapping:
					toneMappingName = 'Linear';
					break;
	
				case ReinhardToneMapping:
					toneMappingName = 'Reinhard';
					break;
	
				case Uncharted2ToneMapping:
					toneMappingName = 'Uncharted2';
					break;
	
				case CineonToneMapping:
					toneMappingName = 'OptimizedCineon';
					break;
	
				default:
					throw new Error( 'unsupported toneMapping: ' + toneMapping );
	
			}
	
			return 'vec3 ' + functionName + '( vec3 color ) { return ' + toneMappingName + 'ToneMapping( color ); }';
	
		}
	
		function generateExtensions( extensions, parameters, rendererExtensions ) {
	
			extensions = extensions || {};
	
			var chunks = [
				( extensions.derivatives || parameters.envMapCubeUV || parameters.bumpMap || parameters.normalMap || parameters.flatShading ) ? '#extension GL_OES_standard_derivatives : enable' : '',
				( extensions.fragDepth || parameters.logarithmicDepthBuffer ) && rendererExtensions.get( 'EXT_frag_depth' ) ? '#extension GL_EXT_frag_depth : enable' : '',
				( extensions.drawBuffers ) && rendererExtensions.get( 'WEBGL_draw_buffers' ) ? '#extension GL_EXT_draw_buffers : require' : '',
				( extensions.shaderTextureLOD || parameters.envMap ) && rendererExtensions.get( 'EXT_shader_texture_lod' ) ? '#extension GL_EXT_shader_texture_lod : enable' : ''
			];
	
			return chunks.filter( filterEmptyLine ).join( '\n' );
	
		}
	
		function generateDefines( defines ) {
	
			var chunks = [];
	
			for ( var name in defines ) {
	
				var value = defines[ name ];
	
				if ( value === false ) continue;
	
				chunks.push( '#define ' + name + ' ' + value );
	
			}
	
			return chunks.join( '\n' );
	
		}
	
		function fetchAttributeLocations( gl, program ) {
	
			var attributes = {};
	
			var n = gl.getProgramParameter( program, gl.ACTIVE_ATTRIBUTES );
	
			for ( var i = 0; i < n; i ++ ) {
	
				var info = gl.getActiveAttrib( program, i );
				var name = info.name;
	
				// console.log( 'THREE.WebGLProgram: ACTIVE VERTEX ATTRIBUTE:', name, i );
	
				attributes[ name ] = gl.getAttribLocation( program, name );
	
			}
	
			return attributes;
	
		}
	
		function filterEmptyLine( string ) {
	
			return string !== '';
	
		}
	
		function replaceLightNums( string, parameters ) {
	
			return string
				.replace( /NUM_DIR_LIGHTS/g, parameters.numDirLights )
				.replace( /NUM_SPOT_LIGHTS/g, parameters.numSpotLights )
				.replace( /NUM_RECT_AREA_LIGHTS/g, parameters.numRectAreaLights )
				.replace( /NUM_POINT_LIGHTS/g, parameters.numPointLights )
				.replace( /NUM_HEMI_LIGHTS/g, parameters.numHemiLights );
	
		}
	
		function parseIncludes( string ) {
	
			var pattern = /^[ \t]*#include +<([\w\d.]+)>/gm;
	
			function replace( match, include ) {
	
				var replace = ShaderChunk[ include ];
	
				if ( replace === undefined ) {
	
					throw new Error( 'Can not resolve #include <' + include + '>' );
	
				}
	
				return parseIncludes( replace );
	
			}
	
			return string.replace( pattern, replace );
	
		}
	
		function unrollLoops( string ) {
	
			var pattern = /for \( int i \= (\d+)\; i < (\d+)\; i \+\+ \) \{([\s\S]+?)(?=\})\}/g;
	
			function replace( match, start, end, snippet ) {
	
				var unroll = '';
	
				for ( var i = parseInt( start ); i < parseInt( end ); i ++ ) {
	
					unroll += snippet.replace( /\[ i \]/g, '[ ' + i + ' ]' );
	
				}
	
				return unroll;
	
			}
	
			return string.replace( pattern, replace );
	
		}
	
		function WebGLProgram( renderer, extensions, code, material, shader, parameters ) {
	
			var gl = renderer.context;
	
			var defines = material.defines;
	
			var vertexShader = shader.vertexShader;
			var fragmentShader = shader.fragmentShader;
	
			var shadowMapTypeDefine = 'SHADOWMAP_TYPE_BASIC';
	
			if ( parameters.shadowMapType === PCFShadowMap ) {
	
				shadowMapTypeDefine = 'SHADOWMAP_TYPE_PCF';
	
			} else if ( parameters.shadowMapType === PCFSoftShadowMap ) {
	
				shadowMapTypeDefine = 'SHADOWMAP_TYPE_PCF_SOFT';
	
			}
	
			var envMapTypeDefine = 'ENVMAP_TYPE_CUBE';
			var envMapModeDefine = 'ENVMAP_MODE_REFLECTION';
			var envMapBlendingDefine = 'ENVMAP_BLENDING_MULTIPLY';
	
			if ( parameters.envMap ) {
	
				switch ( material.envMap.mapping ) {
	
					case CubeReflectionMapping:
					case CubeRefractionMapping:
						envMapTypeDefine = 'ENVMAP_TYPE_CUBE';
						break;
	
					case CubeUVReflectionMapping:
					case CubeUVRefractionMapping:
						envMapTypeDefine = 'ENVMAP_TYPE_CUBE_UV';
						break;
	
					case EquirectangularReflectionMapping:
					case EquirectangularRefractionMapping:
						envMapTypeDefine = 'ENVMAP_TYPE_EQUIREC';
						break;
	
					case SphericalReflectionMapping:
						envMapTypeDefine = 'ENVMAP_TYPE_SPHERE';
						break;
	
				}
	
				switch ( material.envMap.mapping ) {
	
					case CubeRefractionMapping:
					case EquirectangularRefractionMapping:
						envMapModeDefine = 'ENVMAP_MODE_REFRACTION';
						break;
	
				}
	
				switch ( material.combine ) {
	
					case MultiplyOperation:
						envMapBlendingDefine = 'ENVMAP_BLENDING_MULTIPLY';
						break;
	
					case MixOperation:
						envMapBlendingDefine = 'ENVMAP_BLENDING_MIX';
						break;
	
					case AddOperation:
						envMapBlendingDefine = 'ENVMAP_BLENDING_ADD';
						break;
	
				}
	
			}
	
			var gammaFactorDefine = ( renderer.gammaFactor > 0 ) ? renderer.gammaFactor : 1.0;
	
			// console.log( 'building new program ' );
	
			//
	
			var customExtensions = generateExtensions( material.extensions, parameters, extensions );
	
			var customDefines = generateDefines( defines );
	
			//
	
			var program = gl.createProgram();
	
			var prefixVertex, prefixFragment;
	
			if ( material.isRawShaderMaterial ) {
	
				prefixVertex = [
	
					customDefines
	
				].filter( filterEmptyLine ).join( '\n' );
	
				if ( prefixVertex.length > 0 ) {
	
					prefixVertex += '\n';
	
				}
	
				prefixFragment = [
	
					customExtensions,
					customDefines
	
				].filter( filterEmptyLine ).join( '\n' );
	
				if ( prefixFragment.length > 0 ) {
	
					prefixFragment += '\n';
	
				}
	
			} else {
	
				prefixVertex = [
	
					'precision ' + parameters.precision + ' float;',
					'precision ' + parameters.precision + ' int;',
	
					'#define SHADER_NAME ' + shader.name,
	
					customDefines,
	
					parameters.supportsVertexTextures ? '#define VERTEX_TEXTURES' : '',
	
					'#define GAMMA_FACTOR ' + gammaFactorDefine,
	
					'#define MAX_BONES ' + parameters.maxBones,
					( parameters.useFog && parameters.fog ) ? '#define USE_FOG' : '',
					( parameters.useFog && parameters.fogExp ) ? '#define FOG_EXP2' : '',
	
					parameters.map ? '#define USE_MAP' : '',
					parameters.envMap ? '#define USE_ENVMAP' : '',
					parameters.envMap ? '#define ' + envMapModeDefine : '',
					parameters.lightMap ? '#define USE_LIGHTMAP' : '',
					parameters.aoMap ? '#define USE_AOMAP' : '',
					parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '',
					parameters.bumpMap ? '#define USE_BUMPMAP' : '',
					parameters.normalMap ? '#define USE_NORMALMAP' : '',
					parameters.displacementMap && parameters.supportsVertexTextures ? '#define USE_DISPLACEMENTMAP' : '',
					parameters.specularMap ? '#define USE_SPECULARMAP' : '',
					parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
					parameters.metalnessMap ? '#define USE_METALNESSMAP' : '',
					parameters.alphaMap ? '#define USE_ALPHAMAP' : '',
					parameters.vertexColors ? '#define USE_COLOR' : '',
	
					parameters.flatShading ? '#define FLAT_SHADED' : '',
	
					parameters.skinning ? '#define USE_SKINNING' : '',
					parameters.useVertexTexture ? '#define BONE_TEXTURE' : '',
	
					parameters.morphTargets ? '#define USE_MORPHTARGETS' : '',
					parameters.morphNormals && parameters.flatShading === false ? '#define USE_MORPHNORMALS' : '',
					parameters.doubleSided ? '#define DOUBLE_SIDED' : '',
					parameters.flipSided ? '#define FLIP_SIDED' : '',
	
					'#define NUM_CLIPPING_PLANES ' + parameters.numClippingPlanes,
	
					parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
					parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '',
	
					parameters.sizeAttenuation ? '#define USE_SIZEATTENUATION' : '',
	
					parameters.logarithmicDepthBuffer ? '#define USE_LOGDEPTHBUF' : '',
					parameters.logarithmicDepthBuffer && extensions.get( 'EXT_frag_depth' ) ? '#define USE_LOGDEPTHBUF_EXT' : '',
	
					'uniform mat4 modelMatrix;',
					'uniform mat4 modelViewMatrix;',
					'uniform mat4 projectionMatrix;',
					'uniform mat4 viewMatrix;',
					'uniform mat3 normalMatrix;',
					'uniform vec3 cameraPosition;',
	
					'attribute vec3 position;',
					'attribute vec3 normal;',
					'attribute vec2 uv;',
	
					'#ifdef USE_COLOR',
	
					'	attribute vec3 color;',
	
					'#endif',
	
					'#ifdef USE_MORPHTARGETS',
	
					'	attribute vec3 morphTarget0;',
					'	attribute vec3 morphTarget1;',
					'	attribute vec3 morphTarget2;',
					'	attribute vec3 morphTarget3;',
	
					'	#ifdef USE_MORPHNORMALS',
	
					'		attribute vec3 morphNormal0;',
					'		attribute vec3 morphNormal1;',
					'		attribute vec3 morphNormal2;',
					'		attribute vec3 morphNormal3;',
	
					'	#else',
	
					'		attribute vec3 morphTarget4;',
					'		attribute vec3 morphTarget5;',
					'		attribute vec3 morphTarget6;',
					'		attribute vec3 morphTarget7;',
	
					'	#endif',
	
					'#endif',
	
					'#ifdef USE_SKINNING',
	
					'	attribute vec4 skinIndex;',
					'	attribute vec4 skinWeight;',
	
					'#endif',
	
					'\n'
	
				].filter( filterEmptyLine ).join( '\n' );
	
				prefixFragment = [
	
					customExtensions,
	
					'precision ' + parameters.precision + ' float;',
					'precision ' + parameters.precision + ' int;',
	
					'#define SHADER_NAME ' + shader.name,
	
					customDefines,
	
					parameters.alphaTest ? '#define ALPHATEST ' + parameters.alphaTest : '',
	
					'#define GAMMA_FACTOR ' + gammaFactorDefine,
	
					( parameters.useFog && parameters.fog ) ? '#define USE_FOG' : '',
					( parameters.useFog && parameters.fogExp ) ? '#define FOG_EXP2' : '',
	
					parameters.map ? '#define USE_MAP' : '',
					parameters.envMap ? '#define USE_ENVMAP' : '',
					parameters.envMap ? '#define ' + envMapTypeDefine : '',
					parameters.envMap ? '#define ' + envMapModeDefine : '',
					parameters.envMap ? '#define ' + envMapBlendingDefine : '',
					parameters.lightMap ? '#define USE_LIGHTMAP' : '',
					parameters.aoMap ? '#define USE_AOMAP' : '',
					parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '',
					parameters.bumpMap ? '#define USE_BUMPMAP' : '',
					parameters.normalMap ? '#define USE_NORMALMAP' : '',
					parameters.specularMap ? '#define USE_SPECULARMAP' : '',
					parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
					parameters.metalnessMap ? '#define USE_METALNESSMAP' : '',
					parameters.alphaMap ? '#define USE_ALPHAMAP' : '',
					parameters.vertexColors ? '#define USE_COLOR' : '',
	
					parameters.gradientMap ? '#define USE_GRADIENTMAP' : '',
	
					parameters.flatShading ? '#define FLAT_SHADED' : '',
	
					parameters.doubleSided ? '#define DOUBLE_SIDED' : '',
					parameters.flipSided ? '#define FLIP_SIDED' : '',
	
					'#define NUM_CLIPPING_PLANES ' + parameters.numClippingPlanes,
					'#define UNION_CLIPPING_PLANES ' + ( parameters.numClippingPlanes - parameters.numClipIntersection ),
	
					parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
					parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '',
	
					parameters.premultipliedAlpha ? '#define PREMULTIPLIED_ALPHA' : '',
	
					parameters.physicallyCorrectLights ? '#define PHYSICALLY_CORRECT_LIGHTS' : '',
	
					parameters.logarithmicDepthBuffer ? '#define USE_LOGDEPTHBUF' : '',
					parameters.logarithmicDepthBuffer && extensions.get( 'EXT_frag_depth' ) ? '#define USE_LOGDEPTHBUF_EXT' : '',
	
					parameters.envMap && extensions.get( 'EXT_shader_texture_lod' ) ? '#define TEXTURE_LOD_EXT' : '',
	
					'uniform mat4 viewMatrix;',
					'uniform vec3 cameraPosition;',
	
					( parameters.toneMapping !== NoToneMapping ) ? '#define TONE_MAPPING' : '',
					( parameters.toneMapping !== NoToneMapping ) ? ShaderChunk[ 'tonemapping_pars_fragment' ] : '', // this code is required here because it is used by the toneMapping() function defined below
					( parameters.toneMapping !== NoToneMapping ) ? getToneMappingFunction( 'toneMapping', parameters.toneMapping ) : '',
	
					parameters.dithering ? '#define DITHERING' : '',
	
					( parameters.outputEncoding || parameters.mapEncoding || parameters.envMapEncoding || parameters.emissiveMapEncoding ) ? ShaderChunk[ 'encodings_pars_fragment' ] : '', // this code is required here because it is used by the various encoding/decoding function defined below
					parameters.mapEncoding ? getTexelDecodingFunction( 'mapTexelToLinear', parameters.mapEncoding ) : '',
					parameters.envMapEncoding ? getTexelDecodingFunction( 'envMapTexelToLinear', parameters.envMapEncoding ) : '',
					parameters.emissiveMapEncoding ? getTexelDecodingFunction( 'emissiveMapTexelToLinear', parameters.emissiveMapEncoding ) : '',
					parameters.outputEncoding ? getTexelEncodingFunction( 'linearToOutputTexel', parameters.outputEncoding ) : '',
	
					parameters.depthPacking ? '#define DEPTH_PACKING ' + material.depthPacking : '',
	
					'\n'
	
				].filter( filterEmptyLine ).join( '\n' );
	
			}
	
			vertexShader = parseIncludes( vertexShader );
			vertexShader = replaceLightNums( vertexShader, parameters );
	
			fragmentShader = parseIncludes( fragmentShader );
			fragmentShader = replaceLightNums( fragmentShader, parameters );
	
			if ( ! material.isShaderMaterial ) {
	
				vertexShader = unrollLoops( vertexShader );
				fragmentShader = unrollLoops( fragmentShader );
	
			}
	
			var vertexGlsl = prefixVertex + vertexShader;
			var fragmentGlsl = prefixFragment + fragmentShader;
	
			// console.log( '*VERTEX*', vertexGlsl );
			// console.log( '*FRAGMENT*', fragmentGlsl );
	
			var glVertexShader = WebGLShader( gl, gl.VERTEX_SHADER, vertexGlsl );
			var glFragmentShader = WebGLShader( gl, gl.FRAGMENT_SHADER, fragmentGlsl );
	
			gl.attachShader( program, glVertexShader );
			gl.attachShader( program, glFragmentShader );
	
			// Force a particular attribute to index 0.
	
			if ( material.index0AttributeName !== undefined ) {
	
				gl.bindAttribLocation( program, 0, material.index0AttributeName );
	
			} else if ( parameters.morphTargets === true ) {
	
				// programs with morphTargets displace position out of attribute 0
				gl.bindAttribLocation( program, 0, 'position' );
	
			}
	
			gl.linkProgram( program );
	
			var programLog = gl.getProgramInfoLog( program );
			var vertexLog = gl.getShaderInfoLog( glVertexShader );
			var fragmentLog = gl.getShaderInfoLog( glFragmentShader );
	
			var runnable = true;
			var haveDiagnostics = true;
	
			// console.log( '**VERTEX**', gl.getExtension( 'WEBGL_debug_shaders' ).getTranslatedShaderSource( glVertexShader ) );
			// console.log( '**FRAGMENT**', gl.getExtension( 'WEBGL_debug_shaders' ).getTranslatedShaderSource( glFragmentShader ) );
	
			if ( gl.getProgramParameter( program, gl.LINK_STATUS ) === false ) {
	
				runnable = false;
	
				console.error( 'THREE.WebGLProgram: shader error: ', gl.getError(), 'gl.VALIDATE_STATUS', gl.getProgramParameter( program, gl.VALIDATE_STATUS ), 'gl.getProgramInfoLog', programLog, vertexLog, fragmentLog );
	
			} else if ( programLog !== '' ) {
	
				console.warn( 'THREE.WebGLProgram: gl.getProgramInfoLog()', programLog );
	
			} else if ( vertexLog === '' || fragmentLog === '' ) {
	
				haveDiagnostics = false;
	
			}
	
			if ( haveDiagnostics ) {
	
				this.diagnostics = {
	
					runnable: runnable,
					material: material,
	
					programLog: programLog,
	
					vertexShader: {
	
						log: vertexLog,
						prefix: prefixVertex
	
					},
	
					fragmentShader: {
	
						log: fragmentLog,
						prefix: prefixFragment
	
					}
	
				};
	
			}
	
			// clean up
	
			gl.deleteShader( glVertexShader );
			gl.deleteShader( glFragmentShader );
	
			// set up caching for uniform locations
	
			var cachedUniforms;
	
			this.getUniforms = function () {
	
				if ( cachedUniforms === undefined ) {
	
					cachedUniforms = new WebGLUniforms( gl, program, renderer );
	
				}
	
				return cachedUniforms;
	
			};
	
			// set up caching for attribute locations
	
			var cachedAttributes;
	
			this.getAttributes = function () {
	
				if ( cachedAttributes === undefined ) {
	
					cachedAttributes = fetchAttributeLocations( gl, program );
	
				}
	
				return cachedAttributes;
	
			};
	
			// free resource
	
			this.destroy = function () {
	
				gl.deleteProgram( program );
				this.program = undefined;
	
			};
	
			// DEPRECATED
	
			Object.defineProperties( this, {
	
				uniforms: {
					get: function () {
	
						console.warn( 'THREE.WebGLProgram: .uniforms is now .getUniforms().' );
						return this.getUniforms();
	
					}
				},
	
				attributes: {
					get: function () {
	
						console.warn( 'THREE.WebGLProgram: .attributes is now .getAttributes().' );
						return this.getAttributes();
	
					}
				}
	
			} );
	
	
			//
	
			this.id = programIdCount ++;
			this.code = code;
			this.usedTimes = 1;
			this.program = program;
			this.vertexShader = glVertexShader;
			this.fragmentShader = glFragmentShader;
	
			return this;
	
		}
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function WebGLPrograms( renderer, extensions, capabilities ) {
	
			var programs = [];
	
			var shaderIDs = {
				MeshDepthMaterial: 'depth',
				MeshDistanceMaterial: 'distanceRGBA',
				MeshNormalMaterial: 'normal',
				MeshBasicMaterial: 'basic',
				MeshLambertMaterial: 'lambert',
				MeshPhongMaterial: 'phong',
				MeshToonMaterial: 'phong',
				MeshStandardMaterial: 'physical',
				MeshPhysicalMaterial: 'physical',
				LineBasicMaterial: 'basic',
				LineDashedMaterial: 'dashed',
				PointsMaterial: 'points',
				ShadowMaterial: 'shadow'
			};
	
			var parameterNames = [
				"precision", "supportsVertexTextures", "map", "mapEncoding", "envMap", "envMapMode", "envMapEncoding",
				"lightMap", "aoMap", "emissiveMap", "emissiveMapEncoding", "bumpMap", "normalMap", "displacementMap", "specularMap",
				"roughnessMap", "metalnessMap", "gradientMap",
				"alphaMap", "combine", "vertexColors", "fog", "useFog", "fogExp",
				"flatShading", "sizeAttenuation", "logarithmicDepthBuffer", "skinning",
				"maxBones", "useVertexTexture", "morphTargets", "morphNormals",
				"maxMorphTargets", "maxMorphNormals", "premultipliedAlpha",
				"numDirLights", "numPointLights", "numSpotLights", "numHemiLights", "numRectAreaLights",
				"shadowMapEnabled", "shadowMapType", "toneMapping", 'physicallyCorrectLights',
				"alphaTest", "doubleSided", "flipSided", "numClippingPlanes", "numClipIntersection", "depthPacking", "dithering"
			];
	
	
			function allocateBones( object ) {
	
				var skeleton = object.skeleton;
				var bones = skeleton.bones;
	
				if ( capabilities.floatVertexTextures ) {
	
					return 1024;
	
				} else {
	
					// default for when object is not specified
					// ( for example when prebuilding shader to be used with multiple objects )
					//
					//  - leave some extra space for other uniforms
					//  - limit here is ANGLE's 254 max uniform vectors
					//    (up to 54 should be safe)
	
					var nVertexUniforms = capabilities.maxVertexUniforms;
					var nVertexMatrices = Math.floor( ( nVertexUniforms - 20 ) / 4 );
	
					var maxBones = Math.min( nVertexMatrices, bones.length );
	
					if ( maxBones < bones.length ) {
	
						console.warn( 'THREE.WebGLRenderer: Skeleton has ' + bones.length + ' bones. This GPU supports ' + maxBones + '.' );
						return 0;
	
					}
	
					return maxBones;
	
				}
	
			}
	
			function getTextureEncodingFromMap( map, gammaOverrideLinear ) {
	
				var encoding;
	
				if ( ! map ) {
	
					encoding = LinearEncoding;
	
				} else if ( map.isTexture ) {
	
					encoding = map.encoding;
	
				} else if ( map.isWebGLRenderTarget ) {
	
					console.warn( "THREE.WebGLPrograms.getTextureEncodingFromMap: don't use render targets as textures. Use their .texture property instead." );
					encoding = map.texture.encoding;
	
				}
	
				// add backwards compatibility for WebGLRenderer.gammaInput/gammaOutput parameter, should probably be removed at some point.
				if ( encoding === LinearEncoding && gammaOverrideLinear ) {
	
					encoding = GammaEncoding;
	
				}
	
				return encoding;
	
			}
	
			this.getParameters = function ( material, lights, shadows, fog, nClipPlanes, nClipIntersection, object ) {
	
				var shaderID = shaderIDs[ material.type ];
	
				// heuristics to create shader parameters according to lights in the scene
				// (not to blow over maxLights budget)
	
				var maxBones = object.isSkinnedMesh ? allocateBones( object ) : 0;
				var precision = capabilities.precision;
	
				if ( material.precision !== null ) {
	
					precision = capabilities.getMaxPrecision( material.precision );
	
					if ( precision !== material.precision ) {
	
						console.warn( 'THREE.WebGLProgram.getParameters:', material.precision, 'not supported, using', precision, 'instead.' );
	
					}
	
				}
	
				var currentRenderTarget = renderer.getRenderTarget();
	
				var parameters = {
	
					shaderID: shaderID,
	
					precision: precision,
					supportsVertexTextures: capabilities.vertexTextures,
					outputEncoding: getTextureEncodingFromMap( ( ! currentRenderTarget ) ? null : currentRenderTarget.texture, renderer.gammaOutput ),
					map: !! material.map,
					mapEncoding: getTextureEncodingFromMap( material.map, renderer.gammaInput ),
					envMap: !! material.envMap,
					envMapMode: material.envMap && material.envMap.mapping,
					envMapEncoding: getTextureEncodingFromMap( material.envMap, renderer.gammaInput ),
					envMapCubeUV: ( !! material.envMap ) && ( ( material.envMap.mapping === CubeUVReflectionMapping ) || ( material.envMap.mapping === CubeUVRefractionMapping ) ),
					lightMap: !! material.lightMap,
					aoMap: !! material.aoMap,
					emissiveMap: !! material.emissiveMap,
					emissiveMapEncoding: getTextureEncodingFromMap( material.emissiveMap, renderer.gammaInput ),
					bumpMap: !! material.bumpMap,
					normalMap: !! material.normalMap,
					displacementMap: !! material.displacementMap,
					roughnessMap: !! material.roughnessMap,
					metalnessMap: !! material.metalnessMap,
					specularMap: !! material.specularMap,
					alphaMap: !! material.alphaMap,
	
					gradientMap: !! material.gradientMap,
	
					combine: material.combine,
	
					vertexColors: material.vertexColors,
	
					fog: !! fog,
					useFog: material.fog,
					fogExp: ( fog && fog.isFogExp2 ),
	
					flatShading: material.flatShading,
	
					sizeAttenuation: material.sizeAttenuation,
					logarithmicDepthBuffer: capabilities.logarithmicDepthBuffer,
	
					skinning: material.skinning && maxBones > 0,
					maxBones: maxBones,
					useVertexTexture: capabilities.floatVertexTextures,
	
					morphTargets: material.morphTargets,
					morphNormals: material.morphNormals,
					maxMorphTargets: renderer.maxMorphTargets,
					maxMorphNormals: renderer.maxMorphNormals,
	
					numDirLights: lights.directional.length,
					numPointLights: lights.point.length,
					numSpotLights: lights.spot.length,
					numRectAreaLights: lights.rectArea.length,
					numHemiLights: lights.hemi.length,
	
					numClippingPlanes: nClipPlanes,
					numClipIntersection: nClipIntersection,
	
					dithering: material.dithering,
	
					shadowMapEnabled: renderer.shadowMap.enabled && object.receiveShadow && shadows.length > 0,
					shadowMapType: renderer.shadowMap.type,
	
					toneMapping: renderer.toneMapping,
					physicallyCorrectLights: renderer.physicallyCorrectLights,
	
					premultipliedAlpha: material.premultipliedAlpha,
	
					alphaTest: material.alphaTest,
					doubleSided: material.side === DoubleSide,
					flipSided: material.side === BackSide,
	
					depthPacking: ( material.depthPacking !== undefined ) ? material.depthPacking : false
	
				};
	
				return parameters;
	
			};
	
			this.getProgramCode = function ( material, parameters ) {
	
				var array = [];
	
				if ( parameters.shaderID ) {
	
					array.push( parameters.shaderID );
	
				} else {
	
					array.push( material.fragmentShader );
					array.push( material.vertexShader );
	
				}
	
				if ( material.defines !== undefined ) {
	
					for ( var name in material.defines ) {
	
						array.push( name );
						array.push( material.defines[ name ] );
	
					}
	
				}
	
				for ( var i = 0; i < parameterNames.length; i ++ ) {
	
					array.push( parameters[ parameterNames[ i ] ] );
	
				}
	
				array.push( material.onBeforeCompile.toString() );
	
				array.push( renderer.gammaOutput );
	
				return array.join();
	
			};
	
			this.acquireProgram = function ( material, shader, parameters, code ) {
	
				var program;
	
				// Check if code has been already compiled
				for ( var p = 0, pl = programs.length; p < pl; p ++ ) {
	
					var programInfo = programs[ p ];
	
					if ( programInfo.code === code ) {
	
						program = programInfo;
						++ program.usedTimes;
	
						break;
	
					}
	
				}
	
				if ( program === undefined ) {
	
					program = new WebGLProgram( renderer, extensions, code, material, shader, parameters );
					programs.push( program );
	
				}
	
				return program;
	
			};
	
			this.releaseProgram = function ( program ) {
	
				if ( -- program.usedTimes === 0 ) {
	
					// Remove from unordered set
					var i = programs.indexOf( program );
					programs[ i ] = programs[ programs.length - 1 ];
					programs.pop();
	
					// Free WebGL resources
					program.destroy();
	
				}
	
			};
	
			// Exposed for resource monitoring & error feedback via renderer.info:
			this.programs = programs;
	
		}
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function WebGLTextures( _gl, extensions, state, properties, capabilities, utils, infoMemory ) {
	
			var _isWebGL2 = ( typeof WebGL2RenderingContext !== 'undefined' && _gl instanceof window.WebGL2RenderingContext );
			var _videoTextures = {};
	
			//
	
			function clampToMaxSize( image, maxSize ) {
	
				if ( image.width > maxSize || image.height > maxSize ) {
	
					// Warning: Scaling through the canvas will only work with images that use
					// premultiplied alpha.
	
					var scale = maxSize / Math.max( image.width, image.height );
	
					var canvas = document.createElementNS( 'http://www.w3.org/1999/xhtml', 'canvas' );
					canvas.width = Math.floor( image.width * scale );
					canvas.height = Math.floor( image.height * scale );
	
					var context = canvas.getContext( '2d' );
					context.drawImage( image, 0, 0, image.width, image.height, 0, 0, canvas.width, canvas.height );
	
					console.warn( 'THREE.WebGLRenderer: image is too big (' + image.width + 'x' + image.height + '). Resized to ' + canvas.width + 'x' + canvas.height, image );
	
					return canvas;
	
				}
	
				return image;
	
			}
	
			function isPowerOfTwo( image ) {
	
				return _Math.isPowerOfTwo( image.width ) && _Math.isPowerOfTwo( image.height );
	
			}
	
			function makePowerOfTwo( image ) {
	
				if ( image instanceof HTMLImageElement || image instanceof HTMLCanvasElement || image instanceof ImageBitmap ) {
	
					var canvas = document.createElementNS( 'http://www.w3.org/1999/xhtml', 'canvas' );
					canvas.width = _Math.floorPowerOfTwo( image.width );
					canvas.height = _Math.floorPowerOfTwo( image.height );
	
					var context = canvas.getContext( '2d' );
					context.drawImage( image, 0, 0, canvas.width, canvas.height );
	
					console.warn( 'THREE.WebGLRenderer: image is not power of two (' + image.width + 'x' + image.height + '). Resized to ' + canvas.width + 'x' + canvas.height, image );
	
					return canvas;
	
				}
	
				return image;
	
			}
	
			function textureNeedsPowerOfTwo( texture ) {
	
				return ( texture.wrapS !== ClampToEdgeWrapping || texture.wrapT !== ClampToEdgeWrapping ) ||
					( texture.minFilter !== NearestFilter && texture.minFilter !== LinearFilter );
	
			}
	
			function textureNeedsGenerateMipmaps( texture, isPowerOfTwo ) {
	
				return texture.generateMipmaps && isPowerOfTwo &&
					texture.minFilter !== NearestFilter && texture.minFilter !== LinearFilter;
	
			}
	
			// Fallback filters for non-power-of-2 textures
	
			function filterFallback( f ) {
	
				if ( f === NearestFilter || f === NearestMipMapNearestFilter || f === NearestMipMapLinearFilter ) {
	
					return _gl.NEAREST;
	
				}
	
				return _gl.LINEAR;
	
			}
	
			//
	
			function onTextureDispose( event ) {
	
				var texture = event.target;
	
				texture.removeEventListener( 'dispose', onTextureDispose );
	
				deallocateTexture( texture );
	
				if ( texture.isVideoTexture ) {
	
					delete _videoTextures[ texture.id ];
	
				}
	
				infoMemory.textures --;
	
			}
	
			function onRenderTargetDispose( event ) {
	
				var renderTarget = event.target;
	
				renderTarget.removeEventListener( 'dispose', onRenderTargetDispose );
	
				deallocateRenderTarget( renderTarget );
	
				infoMemory.textures --;
	
			}
	
			//
	
			function deallocateTexture( texture ) {
	
				var textureProperties = properties.get( texture );
	
				if ( texture.image && textureProperties.__image__webglTextureCube ) {
	
					// cube texture
	
					_gl.deleteTexture( textureProperties.__image__webglTextureCube );
	
				} else {
	
					// 2D texture
	
					if ( textureProperties.__webglInit === undefined ) return;
	
					_gl.deleteTexture( textureProperties.__webglTexture );
	
				}
	
				// remove all webgl properties
				properties.remove( texture );
	
			}
	
			function deallocateRenderTarget( renderTarget ) {
	
				var renderTargetProperties = properties.get( renderTarget );
				var textureProperties = properties.get( renderTarget.texture );
	
				if ( ! renderTarget ) return;
	
				if ( textureProperties.__webglTexture !== undefined ) {
	
					_gl.deleteTexture( textureProperties.__webglTexture );
	
				}
	
				if ( renderTarget.depthTexture ) {
	
					renderTarget.depthTexture.dispose();
	
				}
	
				if ( renderTarget.isWebGLRenderTargetCube ) {
	
					for ( var i = 0; i < 6; i ++ ) {
	
						_gl.deleteFramebuffer( renderTargetProperties.__webglFramebuffer[ i ] );
						if ( renderTargetProperties.__webglDepthbuffer ) _gl.deleteRenderbuffer( renderTargetProperties.__webglDepthbuffer[ i ] );
	
					}
	
				} else {
	
					_gl.deleteFramebuffer( renderTargetProperties.__webglFramebuffer );
					if ( renderTargetProperties.__webglDepthbuffer ) _gl.deleteRenderbuffer( renderTargetProperties.__webglDepthbuffer );
	
				}
	
				properties.remove( renderTarget.texture );
				properties.remove( renderTarget );
	
			}
	
			//
	
	
	
			function setTexture2D( texture, slot ) {
	
				var textureProperties = properties.get( texture );
	
				if ( texture.version > 0 && textureProperties.__version !== texture.version ) {
	
					var image = texture.image;
	
					if ( image === undefined ) {
	
						console.warn( 'THREE.WebGLRenderer: Texture marked for update but image is undefined', texture );
	
					} else if ( image.complete === false ) {
	
						console.warn( 'THREE.WebGLRenderer: Texture marked for update but image is incomplete', texture );
	
					} else {
	
						uploadTexture( textureProperties, texture, slot );
						return;
	
					}
	
				}
	
				state.activeTexture( _gl.TEXTURE0 + slot );
				state.bindTexture( _gl.TEXTURE_2D, textureProperties.__webglTexture );
	
			}
	
			function setTextureCube( texture, slot ) {
	
				var textureProperties = properties.get( texture );
	
				if ( texture.image.length === 6 ) {
	
					if ( texture.version > 0 && textureProperties.__version !== texture.version ) {
	
						if ( ! textureProperties.__image__webglTextureCube ) {
	
							texture.addEventListener( 'dispose', onTextureDispose );
	
							textureProperties.__image__webglTextureCube = _gl.createTexture();
	
							infoMemory.textures ++;
	
						}
	
						state.activeTexture( _gl.TEXTURE0 + slot );
						state.bindTexture( _gl.TEXTURE_CUBE_MAP, textureProperties.__image__webglTextureCube );
	
						_gl.pixelStorei( _gl.UNPACK_FLIP_Y_WEBGL, texture.flipY );
	
						var isCompressed = ( texture && texture.isCompressedTexture );
						var isDataTexture = ( texture.image[ 0 ] && texture.image[ 0 ].isDataTexture );
	
						var cubeImage = [];
	
						for ( var i = 0; i < 6; i ++ ) {
	
							if ( ! isCompressed && ! isDataTexture ) {
	
								cubeImage[ i ] = clampToMaxSize( texture.image[ i ], capabilities.maxCubemapSize );
	
							} else {
	
								cubeImage[ i ] = isDataTexture ? texture.image[ i ].image : texture.image[ i ];
	
							}
	
						}
	
						var image = cubeImage[ 0 ],
							isPowerOfTwoImage = isPowerOfTwo( image ),
							glFormat = utils.convert( texture.format ),
							glType = utils.convert( texture.type );
	
						setTextureParameters( _gl.TEXTURE_CUBE_MAP, texture, isPowerOfTwoImage );
	
						for ( var i = 0; i < 6; i ++ ) {
	
							if ( ! isCompressed ) {
	
								if ( isDataTexture ) {
	
									state.texImage2D( _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glFormat, cubeImage[ i ].width, cubeImage[ i ].height, 0, glFormat, glType, cubeImage[ i ].data );
	
								} else {
	
									state.texImage2D( _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glFormat, glFormat, glType, cubeImage[ i ] );
	
								}
	
							} else {
	
								var mipmap, mipmaps = cubeImage[ i ].mipmaps;
	
								for ( var j = 0, jl = mipmaps.length; j < jl; j ++ ) {
	
									mipmap = mipmaps[ j ];
	
									if ( texture.format !== RGBAFormat && texture.format !== RGBFormat ) {
	
										if ( state.getCompressedTextureFormats().indexOf( glFormat ) > - 1 ) {
	
											state.compressedTexImage2D( _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, glFormat, mipmap.width, mipmap.height, 0, mipmap.data );
	
										} else {
	
											console.warn( 'THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()' );
	
										}
	
									} else {
	
										state.texImage2D( _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, glFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data );
	
									}
	
								}
	
							}
	
						}
	
						if ( textureNeedsGenerateMipmaps( texture, isPowerOfTwoImage ) ) {
	
							_gl.generateMipmap( _gl.TEXTURE_CUBE_MAP );
	
						}
	
						textureProperties.__version = texture.version;
	
						if ( texture.onUpdate ) texture.onUpdate( texture );
	
					} else {
	
						state.activeTexture( _gl.TEXTURE0 + slot );
						state.bindTexture( _gl.TEXTURE_CUBE_MAP, textureProperties.__image__webglTextureCube );
	
					}
	
				}
	
			}
	
			function setTextureCubeDynamic( texture, slot ) {
	
				state.activeTexture( _gl.TEXTURE0 + slot );
				state.bindTexture( _gl.TEXTURE_CUBE_MAP, properties.get( texture ).__webglTexture );
	
			}
	
			function setTextureParameters( textureType, texture, isPowerOfTwoImage ) {
	
				var extension;
	
				if ( isPowerOfTwoImage ) {
	
					_gl.texParameteri( textureType, _gl.TEXTURE_WRAP_S, utils.convert( texture.wrapS ) );
					_gl.texParameteri( textureType, _gl.TEXTURE_WRAP_T, utils.convert( texture.wrapT ) );
	
					_gl.texParameteri( textureType, _gl.TEXTURE_MAG_FILTER, utils.convert( texture.magFilter ) );
					_gl.texParameteri( textureType, _gl.TEXTURE_MIN_FILTER, utils.convert( texture.minFilter ) );
	
				} else {
	
					_gl.texParameteri( textureType, _gl.TEXTURE_WRAP_S, _gl.CLAMP_TO_EDGE );
					_gl.texParameteri( textureType, _gl.TEXTURE_WRAP_T, _gl.CLAMP_TO_EDGE );
	
					if ( texture.wrapS !== ClampToEdgeWrapping || texture.wrapT !== ClampToEdgeWrapping ) {
	
						console.warn( 'THREE.WebGLRenderer: Texture is not power of two. Texture.wrapS and Texture.wrapT should be set to THREE.ClampToEdgeWrapping.', texture );
	
					}
	
					_gl.texParameteri( textureType, _gl.TEXTURE_MAG_FILTER, filterFallback( texture.magFilter ) );
					_gl.texParameteri( textureType, _gl.TEXTURE_MIN_FILTER, filterFallback( texture.minFilter ) );
	
					if ( texture.minFilter !== NearestFilter && texture.minFilter !== LinearFilter ) {
	
						console.warn( 'THREE.WebGLRenderer: Texture is not power of two. Texture.minFilter should be set to THREE.NearestFilter or THREE.LinearFilter.', texture );
	
					}
	
				}
	
				extension = extensions.get( 'EXT_texture_filter_anisotropic' );
	
				if ( extension ) {
	
					if ( texture.type === FloatType && extensions.get( 'OES_texture_float_linear' ) === null ) return;
					if ( texture.type === HalfFloatType && extensions.get( 'OES_texture_half_float_linear' ) === null ) return;
	
					if ( texture.anisotropy > 1 || properties.get( texture ).__currentAnisotropy ) {
	
						_gl.texParameterf( textureType, extension.TEXTURE_MAX_ANISOTROPY_EXT, Math.min( texture.anisotropy, capabilities.getMaxAnisotropy() ) );
						properties.get( texture ).__currentAnisotropy = texture.anisotropy;
	
					}
	
				}
	
			}
	
			function uploadTexture( textureProperties, texture, slot ) {
	
				if ( textureProperties.__webglInit === undefined ) {
	
					textureProperties.__webglInit = true;
	
					texture.addEventListener( 'dispose', onTextureDispose );
	
					textureProperties.__webglTexture = _gl.createTexture();
	
					if ( texture.isVideoTexture ) {
	
						_videoTextures[ texture.id ] = texture;
	
					}
	
					infoMemory.textures ++;
	
				}
	
				state.activeTexture( _gl.TEXTURE0 + slot );
				state.bindTexture( _gl.TEXTURE_2D, textureProperties.__webglTexture );
	
				_gl.pixelStorei( _gl.UNPACK_FLIP_Y_WEBGL, texture.flipY );
				_gl.pixelStorei( _gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha );
				_gl.pixelStorei( _gl.UNPACK_ALIGNMENT, texture.unpackAlignment );
	
				var image = clampToMaxSize( texture.image, capabilities.maxTextureSize );
	
				if ( textureNeedsPowerOfTwo( texture ) && isPowerOfTwo( image ) === false ) {
	
					image = makePowerOfTwo( image );
	
				}
	
				var isPowerOfTwoImage = isPowerOfTwo( image ),
					glFormat = utils.convert( texture.format ),
					glType = utils.convert( texture.type );
	
				setTextureParameters( _gl.TEXTURE_2D, texture, isPowerOfTwoImage );
	
				var mipmap, mipmaps = texture.mipmaps;
	
				if ( texture.isDepthTexture ) {
	
					// populate depth texture with dummy data
	
					var internalFormat = _gl.DEPTH_COMPONENT;
	
					if ( texture.type === FloatType ) {
	
						if ( ! _isWebGL2 ) throw new Error( 'Float Depth Texture only supported in WebGL2.0' );
						internalFormat = _gl.DEPTH_COMPONENT32F;
	
					} else if ( _isWebGL2 ) {
	
						// WebGL 2.0 requires signed internalformat for glTexImage2D
						internalFormat = _gl.DEPTH_COMPONENT16;
	
					}
	
					if ( texture.format === DepthFormat && internalFormat === _gl.DEPTH_COMPONENT ) {
	
						// The error INVALID_OPERATION is generated by texImage2D if format and internalformat are
						// DEPTH_COMPONENT and type is not UNSIGNED_SHORT or UNSIGNED_INT
						// (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
						if ( texture.type !== UnsignedShortType && texture.type !== UnsignedIntType ) {
	
							console.warn( 'THREE.WebGLRenderer: Use UnsignedShortType or UnsignedIntType for DepthFormat DepthTexture.' );
	
							texture.type = UnsignedShortType;
							glType = utils.convert( texture.type );
	
						}
	
					}
	
					// Depth stencil textures need the DEPTH_STENCIL internal format
					// (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
					if ( texture.format === DepthStencilFormat ) {
	
						internalFormat = _gl.DEPTH_STENCIL;
	
						// The error INVALID_OPERATION is generated by texImage2D if format and internalformat are
						// DEPTH_STENCIL and type is not UNSIGNED_INT_24_8_WEBGL.
						// (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
						if ( texture.type !== UnsignedInt248Type ) {
	
							console.warn( 'THREE.WebGLRenderer: Use UnsignedInt248Type for DepthStencilFormat DepthTexture.' );
	
							texture.type = UnsignedInt248Type;
							glType = utils.convert( texture.type );
	
						}
	
					}
	
					state.texImage2D( _gl.TEXTURE_2D, 0, internalFormat, image.width, image.height, 0, glFormat, glType, null );
	
				} else if ( texture.isDataTexture ) {
	
					// use manually created mipmaps if available
					// if there are no manual mipmaps
					// set 0 level mipmap and then use GL to generate other mipmap levels
	
					if ( mipmaps.length > 0 && isPowerOfTwoImage ) {
	
						for ( var i = 0, il = mipmaps.length; i < il; i ++ ) {
	
							mipmap = mipmaps[ i ];
							state.texImage2D( _gl.TEXTURE_2D, i, glFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data );
	
						}
	
						texture.generateMipmaps = false;
	
					} else {
	
						state.texImage2D( _gl.TEXTURE_2D, 0, glFormat, image.width, image.height, 0, glFormat, glType, image.data );
	
					}
	
				} else if ( texture.isCompressedTexture ) {
	
					for ( var i = 0, il = mipmaps.length; i < il; i ++ ) {
	
						mipmap = mipmaps[ i ];
	
						if ( texture.format !== RGBAFormat && texture.format !== RGBFormat ) {
	
							if ( state.getCompressedTextureFormats().indexOf( glFormat ) > - 1 ) {
	
								state.compressedTexImage2D( _gl.TEXTURE_2D, i, glFormat, mipmap.width, mipmap.height, 0, mipmap.data );
	
							} else {
	
								console.warn( 'THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()' );
	
							}
	
						} else {
	
							state.texImage2D( _gl.TEXTURE_2D, i, glFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data );
	
						}
	
					}
	
				} else {
	
					// regular Texture (image, video, canvas)
	
					// use manually created mipmaps if available
					// if there are no manual mipmaps
					// set 0 level mipmap and then use GL to generate other mipmap levels
	
					if ( mipmaps.length > 0 && isPowerOfTwoImage ) {
	
						for ( var i = 0, il = mipmaps.length; i < il; i ++ ) {
	
							mipmap = mipmaps[ i ];
							state.texImage2D( _gl.TEXTURE_2D, i, glFormat, glFormat, glType, mipmap );
	
						}
	
						texture.generateMipmaps = false;
	
					} else {
	
						state.texImage2D( _gl.TEXTURE_2D, 0, glFormat, glFormat, glType, image );
	
					}
	
				}
	
				if ( textureNeedsGenerateMipmaps( texture, isPowerOfTwoImage ) ) _gl.generateMipmap( _gl.TEXTURE_2D );
	
				textureProperties.__version = texture.version;
	
				if ( texture.onUpdate ) texture.onUpdate( texture );
	
			}
	
			// Render targets
	
			// Setup storage for target texture and bind it to correct framebuffer
			function setupFrameBufferTexture( framebuffer, renderTarget, attachment, textureTarget ) {
	
				var glFormat = utils.convert( renderTarget.texture.format );
				var glType = utils.convert( renderTarget.texture.type );
				state.texImage2D( textureTarget, 0, glFormat, renderTarget.width, renderTarget.height, 0, glFormat, glType, null );
				_gl.bindFramebuffer( _gl.FRAMEBUFFER, framebuffer );
				_gl.framebufferTexture2D( _gl.FRAMEBUFFER, attachment, textureTarget, properties.get( renderTarget.texture ).__webglTexture, 0 );
				_gl.bindFramebuffer( _gl.FRAMEBUFFER, null );
	
			}
	
			// Setup storage for internal depth/stencil buffers and bind to correct framebuffer
			function setupRenderBufferStorage( renderbuffer, renderTarget ) {
	
				_gl.bindRenderbuffer( _gl.RENDERBUFFER, renderbuffer );
	
				if ( renderTarget.depthBuffer && ! renderTarget.stencilBuffer ) {
	
					_gl.renderbufferStorage( _gl.RENDERBUFFER, _gl.DEPTH_COMPONENT16, renderTarget.width, renderTarget.height );
					_gl.framebufferRenderbuffer( _gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.RENDERBUFFER, renderbuffer );
	
				} else if ( renderTarget.depthBuffer && renderTarget.stencilBuffer ) {
	
					_gl.renderbufferStorage( _gl.RENDERBUFFER, _gl.DEPTH_STENCIL, renderTarget.width, renderTarget.height );
					_gl.framebufferRenderbuffer( _gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.RENDERBUFFER, renderbuffer );
	
				} else {
	
					// FIXME: We don't support !depth !stencil
					_gl.renderbufferStorage( _gl.RENDERBUFFER, _gl.RGBA4, renderTarget.width, renderTarget.height );
	
				}
	
				_gl.bindRenderbuffer( _gl.RENDERBUFFER, null );
	
			}
	
			// Setup resources for a Depth Texture for a FBO (needs an extension)
			function setupDepthTexture( framebuffer, renderTarget ) {
	
				var isCube = ( renderTarget && renderTarget.isWebGLRenderTargetCube );
				if ( isCube ) throw new Error( 'Depth Texture with cube render targets is not supported' );
	
				_gl.bindFramebuffer( _gl.FRAMEBUFFER, framebuffer );
	
				if ( ! ( renderTarget.depthTexture && renderTarget.depthTexture.isDepthTexture ) ) {
	
					throw new Error( 'renderTarget.depthTexture must be an instance of THREE.DepthTexture' );
	
				}
	
				// upload an empty depth texture with framebuffer size
				if ( ! properties.get( renderTarget.depthTexture ).__webglTexture ||
						renderTarget.depthTexture.image.width !== renderTarget.width ||
						renderTarget.depthTexture.image.height !== renderTarget.height ) {
	
					renderTarget.depthTexture.image.width = renderTarget.width;
					renderTarget.depthTexture.image.height = renderTarget.height;
					renderTarget.depthTexture.needsUpdate = true;
	
				}
	
				setTexture2D( renderTarget.depthTexture, 0 );
	
				var webglDepthTexture = properties.get( renderTarget.depthTexture ).__webglTexture;
	
				if ( renderTarget.depthTexture.format === DepthFormat ) {
	
					_gl.framebufferTexture2D( _gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0 );
	
				} else if ( renderTarget.depthTexture.format === DepthStencilFormat ) {
	
					_gl.framebufferTexture2D( _gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0 );
	
				} else {
	
					throw new Error( 'Unknown depthTexture format' );
	
				}
	
			}
	
			// Setup GL resources for a non-texture depth buffer
			function setupDepthRenderbuffer( renderTarget ) {
	
				var renderTargetProperties = properties.get( renderTarget );
	
				var isCube = ( renderTarget.isWebGLRenderTargetCube === true );
	
				if ( renderTarget.depthTexture ) {
	
					if ( isCube ) throw new Error( 'target.depthTexture not supported in Cube render targets' );
	
					setupDepthTexture( renderTargetProperties.__webglFramebuffer, renderTarget );
	
				} else {
	
					if ( isCube ) {
	
						renderTargetProperties.__webglDepthbuffer = [];
	
						for ( var i = 0; i < 6; i ++ ) {
	
							_gl.bindFramebuffer( _gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer[ i ] );
							renderTargetProperties.__webglDepthbuffer[ i ] = _gl.createRenderbuffer();
							setupRenderBufferStorage( renderTargetProperties.__webglDepthbuffer[ i ], renderTarget );
	
						}
	
					} else {
	
						_gl.bindFramebuffer( _gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer );
						renderTargetProperties.__webglDepthbuffer = _gl.createRenderbuffer();
						setupRenderBufferStorage( renderTargetProperties.__webglDepthbuffer, renderTarget );
	
					}
	
				}
	
				_gl.bindFramebuffer( _gl.FRAMEBUFFER, null );
	
			}
	
			// Set up GL resources for the render target
			function setupRenderTarget( renderTarget ) {
	
				var renderTargetProperties = properties.get( renderTarget );
				var textureProperties = properties.get( renderTarget.texture );
	
				renderTarget.addEventListener( 'dispose', onRenderTargetDispose );
	
				textureProperties.__webglTexture = _gl.createTexture();
	
				infoMemory.textures ++;
	
				var isCube = ( renderTarget.isWebGLRenderTargetCube === true );
				var isTargetPowerOfTwo = isPowerOfTwo( renderTarget );
	
				// Setup framebuffer
	
				if ( isCube ) {
	
					renderTargetProperties.__webglFramebuffer = [];
	
					for ( var i = 0; i < 6; i ++ ) {
	
						renderTargetProperties.__webglFramebuffer[ i ] = _gl.createFramebuffer();
	
					}
	
				} else {
	
					renderTargetProperties.__webglFramebuffer = _gl.createFramebuffer();
	
				}
	
				// Setup color buffer
	
				if ( isCube ) {
	
					state.bindTexture( _gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture );
					setTextureParameters( _gl.TEXTURE_CUBE_MAP, renderTarget.texture, isTargetPowerOfTwo );
	
					for ( var i = 0; i < 6; i ++ ) {
	
						setupFrameBufferTexture( renderTargetProperties.__webglFramebuffer[ i ], renderTarget, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i );
	
					}
	
					if ( textureNeedsGenerateMipmaps( renderTarget.texture, isTargetPowerOfTwo ) ) _gl.generateMipmap( _gl.TEXTURE_CUBE_MAP );
					state.bindTexture( _gl.TEXTURE_CUBE_MAP, null );
	
				} else {
	
					state.bindTexture( _gl.TEXTURE_2D, textureProperties.__webglTexture );
					setTextureParameters( _gl.TEXTURE_2D, renderTarget.texture, isTargetPowerOfTwo );
					setupFrameBufferTexture( renderTargetProperties.__webglFramebuffer, renderTarget, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D );
	
					if ( textureNeedsGenerateMipmaps( renderTarget.texture, isTargetPowerOfTwo ) ) _gl.generateMipmap( _gl.TEXTURE_2D );
					state.bindTexture( _gl.TEXTURE_2D, null );
	
				}
	
				// Setup depth and stencil buffers
	
				if ( renderTarget.depthBuffer ) {
	
					setupDepthRenderbuffer( renderTarget );
	
				}
	
			}
	
			function updateRenderTargetMipmap( renderTarget ) {
	
				var texture = renderTarget.texture;
				var isTargetPowerOfTwo = isPowerOfTwo( renderTarget );
	
				if ( textureNeedsGenerateMipmaps( texture, isTargetPowerOfTwo ) ) {
	
					var target = renderTarget.isWebGLRenderTargetCube ? _gl.TEXTURE_CUBE_MAP : _gl.TEXTURE_2D;
					var webglTexture = properties.get( texture ).__webglTexture;
	
					state.bindTexture( target, webglTexture );
					_gl.generateMipmap( target );
					state.bindTexture( target, null );
	
				}
	
			}
	
			function updateVideoTextures() {
	
				for ( var id in _videoTextures ) {
	
					_videoTextures[ id ].update();
	
				}
	
			}
	
			this.setTexture2D = setTexture2D;
			this.setTextureCube = setTextureCube;
			this.setTextureCubeDynamic = setTextureCubeDynamic;
			this.setupRenderTarget = setupRenderTarget;
			this.updateRenderTargetMipmap = updateRenderTargetMipmap;
			this.updateVideoTextures = updateVideoTextures;
	
		}
	
		/**
		 * @author fordacious / fordacious.github.io
		 */
	
		function WebGLProperties() {
	
			var properties = {};
	
			function get( object ) {
	
				var uuid = object.uuid;
				var map = properties[ uuid ];
	
				if ( map === undefined ) {
	
					map = {};
					properties[ uuid ] = map;
	
				}
	
				return map;
	
			}
	
			function remove( object ) {
	
				delete properties[ object.uuid ];
	
			}
	
			function clear() {
	
				properties = {};
	
			}
	
			return {
				get: get,
				remove: remove,
				clear: clear
			};
	
		}
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function WebGLState( gl, extensions, utils ) {
	
			function ColorBuffer() {
	
				var locked = false;
	
				var color = new Vector4();
				var currentColorMask = null;
				var currentColorClear = new Vector4( 0, 0, 0, 0 );
	
				return {
	
					setMask: function ( colorMask ) {
	
						if ( currentColorMask !== colorMask && ! locked ) {
	
							gl.colorMask( colorMask, colorMask, colorMask, colorMask );
							currentColorMask = colorMask;
	
						}
	
					},
	
					setLocked: function ( lock ) {
	
						locked = lock;
	
					},
	
					setClear: function ( r, g, b, a, premultipliedAlpha ) {
	
						if ( premultipliedAlpha === true ) {
	
							r *= a; g *= a; b *= a;
	
						}
	
						color.set( r, g, b, a );
	
						if ( currentColorClear.equals( color ) === false ) {
	
							gl.clearColor( r, g, b, a );
							currentColorClear.copy( color );
	
						}
	
					},
	
					reset: function () {
	
						locked = false;
	
						currentColorMask = null;
						currentColorClear.set( - 1, 0, 0, 0 ); // set to invalid state
	
					}
	
				};
	
			}
	
			function DepthBuffer() {
	
				var locked = false;
	
				var currentDepthMask = null;
				var currentDepthFunc = null;
				var currentDepthClear = null;
	
				return {
	
					setTest: function ( depthTest ) {
	
						if ( depthTest ) {
	
							enable( gl.DEPTH_TEST );
	
						} else {
	
							disable( gl.DEPTH_TEST );
	
						}
	
					},
	
					setMask: function ( depthMask ) {
	
						if ( currentDepthMask !== depthMask && ! locked ) {
	
							gl.depthMask( depthMask );
							currentDepthMask = depthMask;
	
						}
	
					},
	
					setFunc: function ( depthFunc ) {
	
						if ( currentDepthFunc !== depthFunc ) {
	
							if ( depthFunc ) {
	
								switch ( depthFunc ) {
	
									case NeverDepth:
	
										gl.depthFunc( gl.NEVER );
										break;
	
									case AlwaysDepth:
	
										gl.depthFunc( gl.ALWAYS );
										break;
	
									case LessDepth:
	
										gl.depthFunc( gl.LESS );
										break;
	
									case LessEqualDepth:
	
										gl.depthFunc( gl.LEQUAL );
										break;
	
									case EqualDepth:
	
										gl.depthFunc( gl.EQUAL );
										break;
	
									case GreaterEqualDepth:
	
										gl.depthFunc( gl.GEQUAL );
										break;
	
									case GreaterDepth:
	
										gl.depthFunc( gl.GREATER );
										break;
	
									case NotEqualDepth:
	
										gl.depthFunc( gl.NOTEQUAL );
										break;
	
									default:
	
										gl.depthFunc( gl.LEQUAL );
	
								}
	
							} else {
	
								gl.depthFunc( gl.LEQUAL );
	
							}
	
							currentDepthFunc = depthFunc;
	
						}
	
					},
	
					setLocked: function ( lock ) {
	
						locked = lock;
	
					},
	
					setClear: function ( depth ) {
	
						if ( currentDepthClear !== depth ) {
	
							gl.clearDepth( depth );
							currentDepthClear = depth;
	
						}
	
					},
	
					reset: function () {
	
						locked = false;
	
						currentDepthMask = null;
						currentDepthFunc = null;
						currentDepthClear = null;
	
					}
	
				};
	
			}
	
			function StencilBuffer() {
	
				var locked = false;
	
				var currentStencilMask = null;
				var currentStencilFunc = null;
				var currentStencilRef = null;
				var currentStencilFuncMask = null;
				var currentStencilFail = null;
				var currentStencilZFail = null;
				var currentStencilZPass = null;
				var currentStencilClear = null;
	
				return {
	
					setTest: function ( stencilTest ) {
	
						if ( stencilTest ) {
	
							enable( gl.STENCIL_TEST );
	
						} else {
	
							disable( gl.STENCIL_TEST );
	
						}
	
					},
	
					setMask: function ( stencilMask ) {
	
						if ( currentStencilMask !== stencilMask && ! locked ) {
	
							gl.stencilMask( stencilMask );
							currentStencilMask = stencilMask;
	
						}
	
					},
	
					setFunc: function ( stencilFunc, stencilRef, stencilMask ) {
	
						if ( currentStencilFunc !== stencilFunc ||
						     currentStencilRef 	!== stencilRef 	||
						     currentStencilFuncMask !== stencilMask ) {
	
							gl.stencilFunc( stencilFunc, stencilRef, stencilMask );
	
							currentStencilFunc = stencilFunc;
							currentStencilRef = stencilRef;
							currentStencilFuncMask = stencilMask;
	
						}
	
					},
	
					setOp: function ( stencilFail, stencilZFail, stencilZPass ) {
	
						if ( currentStencilFail	 !== stencilFail 	||
						     currentStencilZFail !== stencilZFail ||
						     currentStencilZPass !== stencilZPass ) {
	
							gl.stencilOp( stencilFail, stencilZFail, stencilZPass );
	
							currentStencilFail = stencilFail;
							currentStencilZFail = stencilZFail;
							currentStencilZPass = stencilZPass;
	
						}
	
					},
	
					setLocked: function ( lock ) {
	
						locked = lock;
	
					},
	
					setClear: function ( stencil ) {
	
						if ( currentStencilClear !== stencil ) {
	
							gl.clearStencil( stencil );
							currentStencilClear = stencil;
	
						}
	
					},
	
					reset: function () {
	
						locked = false;
	
						currentStencilMask = null;
						currentStencilFunc = null;
						currentStencilRef = null;
						currentStencilFuncMask = null;
						currentStencilFail = null;
						currentStencilZFail = null;
						currentStencilZPass = null;
						currentStencilClear = null;
	
					}
	
				};
	
			}
	
			//
	
			var colorBuffer = new ColorBuffer();
			var depthBuffer = new DepthBuffer();
			var stencilBuffer = new StencilBuffer();
	
			var maxVertexAttributes = gl.getParameter( gl.MAX_VERTEX_ATTRIBS );
			var newAttributes = new Uint8Array( maxVertexAttributes );
			var enabledAttributes = new Uint8Array( maxVertexAttributes );
			var attributeDivisors = new Uint8Array( maxVertexAttributes );
	
			var capabilities = {};
	
			var compressedTextureFormats = null;
	
			var currentProgram = null;
	
			var currentBlending = null;
			var currentBlendEquation = null;
			var currentBlendSrc = null;
			var currentBlendDst = null;
			var currentBlendEquationAlpha = null;
			var currentBlendSrcAlpha = null;
			var currentBlendDstAlpha = null;
			var currentPremultipledAlpha = false;
	
			var currentFlipSided = null;
			var currentCullFace = null;
	
			var currentLineWidth = null;
	
			var currentPolygonOffsetFactor = null;
			var currentPolygonOffsetUnits = null;
	
			var maxTextures = gl.getParameter( gl.MAX_COMBINED_TEXTURE_IMAGE_UNITS );
	
			var version = parseFloat( /^WebGL\ ([0-9])/.exec( gl.getParameter( gl.VERSION ) )[ 1 ] );
			var lineWidthAvailable = parseFloat( version ) >= 1.0;
	
			var currentTextureSlot = null;
			var currentBoundTextures = {};
	
			var currentScissor = new Vector4();
			var currentViewport = new Vector4();
	
			function createTexture( type, target, count ) {
	
				var data = new Uint8Array( 4 ); // 4 is required to match default unpack alignment of 4.
				var texture = gl.createTexture();
	
				gl.bindTexture( type, texture );
				gl.texParameteri( type, gl.TEXTURE_MIN_FILTER, gl.NEAREST );
				gl.texParameteri( type, gl.TEXTURE_MAG_FILTER, gl.NEAREST );
	
				for ( var i = 0; i < count; i ++ ) {
	
					gl.texImage2D( target + i, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, data );
	
				}
	
				return texture;
	
			}
	
			var emptyTextures = {};
			emptyTextures[ gl.TEXTURE_2D ] = createTexture( gl.TEXTURE_2D, gl.TEXTURE_2D, 1 );
			emptyTextures[ gl.TEXTURE_CUBE_MAP ] = createTexture( gl.TEXTURE_CUBE_MAP, gl.TEXTURE_CUBE_MAP_POSITIVE_X, 6 );
	
			// init
	
			colorBuffer.setClear( 0, 0, 0, 1 );
			depthBuffer.setClear( 1 );
			stencilBuffer.setClear( 0 );
	
			enable( gl.DEPTH_TEST );
			depthBuffer.setFunc( LessEqualDepth );
	
			setFlipSided( false );
			setCullFace( CullFaceBack );
			enable( gl.CULL_FACE );
	
			enable( gl.BLEND );
			setBlending( NormalBlending );
	
			//
	
			function initAttributes() {
	
				for ( var i = 0, l = newAttributes.length; i < l; i ++ ) {
	
					newAttributes[ i ] = 0;
	
				}
	
			}
	
			function enableAttribute( attribute ) {
	
				newAttributes[ attribute ] = 1;
	
				if ( enabledAttributes[ attribute ] === 0 ) {
	
					gl.enableVertexAttribArray( attribute );
					enabledAttributes[ attribute ] = 1;
	
				}
	
				if ( attributeDivisors[ attribute ] !== 0 ) {
	
					var extension = extensions.get( 'ANGLE_instanced_arrays' );
	
					extension.vertexAttribDivisorANGLE( attribute, 0 );
					attributeDivisors[ attribute ] = 0;
	
				}
	
			}
	
			function enableAttributeAndDivisor( attribute, meshPerAttribute ) {
	
				newAttributes[ attribute ] = 1;
	
				if ( enabledAttributes[ attribute ] === 0 ) {
	
					gl.enableVertexAttribArray( attribute );
					enabledAttributes[ attribute ] = 1;
	
				}
	
				if ( attributeDivisors[ attribute ] !== meshPerAttribute ) {
	
					var extension = extensions.get( 'ANGLE_instanced_arrays' );
	
					extension.vertexAttribDivisorANGLE( attribute, meshPerAttribute );
					attributeDivisors[ attribute ] = meshPerAttribute;
	
				}
	
			}
	
			function disableUnusedAttributes() {
	
				for ( var i = 0, l = enabledAttributes.length; i !== l; ++ i ) {
	
					if ( enabledAttributes[ i ] !== newAttributes[ i ] ) {
	
						gl.disableVertexAttribArray( i );
						enabledAttributes[ i ] = 0;
	
					}
	
				}
	
			}
	
			function enable( id ) {
	
				if ( capabilities[ id ] !== true ) {
	
					gl.enable( id );
					capabilities[ id ] = true;
	
				}
	
			}
	
			function disable( id ) {
	
				if ( capabilities[ id ] !== false ) {
	
					gl.disable( id );
					capabilities[ id ] = false;
	
				}
	
			}
	
			function getCompressedTextureFormats() {
	
				if ( compressedTextureFormats === null ) {
	
					compressedTextureFormats = [];
	
					if ( extensions.get( 'WEBGL_compressed_texture_pvrtc' ) ||
					     extensions.get( 'WEBGL_compressed_texture_s3tc' ) ||
					     extensions.get( 'WEBGL_compressed_texture_etc1' ) ) {
	
						var formats = gl.getParameter( gl.COMPRESSED_TEXTURE_FORMATS );
	
						for ( var i = 0; i < formats.length; i ++ ) {
	
							compressedTextureFormats.push( formats[ i ] );
	
						}
	
					}
	
				}
	
				return compressedTextureFormats;
	
			}
	
			function useProgram( program ) {
	
				if ( currentProgram !== program ) {
	
					gl.useProgram( program );
	
					currentProgram = program;
	
					return true;
	
				}
	
				return false;
	
			}
	
			function setBlending( blending, blendEquation, blendSrc, blendDst, blendEquationAlpha, blendSrcAlpha, blendDstAlpha, premultipliedAlpha ) {
	
				if ( blending !== NoBlending ) {
	
					enable( gl.BLEND );
	
				} else {
	
					disable( gl.BLEND );
	
				}
	
				if ( blending !== CustomBlending ) {
	
					if ( blending !== currentBlending || premultipliedAlpha !== currentPremultipledAlpha ) {
	
						switch ( blending ) {
	
							case AdditiveBlending:
	
								if ( premultipliedAlpha ) {
	
									gl.blendEquationSeparate( gl.FUNC_ADD, gl.FUNC_ADD );
									gl.blendFuncSeparate( gl.ONE, gl.ONE, gl.ONE, gl.ONE );
	
								} else {
	
									gl.blendEquation( gl.FUNC_ADD );
									gl.blendFunc( gl.SRC_ALPHA, gl.ONE );
	
								}
								break;
	
							case SubtractiveBlending:
	
								if ( premultipliedAlpha ) {
	
									gl.blendEquationSeparate( gl.FUNC_ADD, gl.FUNC_ADD );
									gl.blendFuncSeparate( gl.ZERO, gl.ZERO, gl.ONE_MINUS_SRC_COLOR, gl.ONE_MINUS_SRC_ALPHA );
	
								} else {
	
									gl.blendEquation( gl.FUNC_ADD );
									gl.blendFunc( gl.ZERO, gl.ONE_MINUS_SRC_COLOR );
	
								}
								break;
	
							case MultiplyBlending:
	
								if ( premultipliedAlpha ) {
	
									gl.blendEquationSeparate( gl.FUNC_ADD, gl.FUNC_ADD );
									gl.blendFuncSeparate( gl.ZERO, gl.SRC_COLOR, gl.ZERO, gl.SRC_ALPHA );
	
								} else {
	
									gl.blendEquation( gl.FUNC_ADD );
									gl.blendFunc( gl.ZERO, gl.SRC_COLOR );
	
								}
								break;
	
							default:
	
								if ( premultipliedAlpha ) {
	
									gl.blendEquationSeparate( gl.FUNC_ADD, gl.FUNC_ADD );
									gl.blendFuncSeparate( gl.ONE, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA );
	
								} else {
	
									gl.blendEquationSeparate( gl.FUNC_ADD, gl.FUNC_ADD );
									gl.blendFuncSeparate( gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA );
	
								}
	
						}
	
					}
	
					currentBlendEquation = null;
					currentBlendSrc = null;
					currentBlendDst = null;
					currentBlendEquationAlpha = null;
					currentBlendSrcAlpha = null;
					currentBlendDstAlpha = null;
	
				} else {
	
					blendEquationAlpha = blendEquationAlpha || blendEquation;
					blendSrcAlpha = blendSrcAlpha || blendSrc;
					blendDstAlpha = blendDstAlpha || blendDst;
	
					if ( blendEquation !== currentBlendEquation || blendEquationAlpha !== currentBlendEquationAlpha ) {
	
						gl.blendEquationSeparate( utils.convert( blendEquation ), utils.convert( blendEquationAlpha ) );
	
						currentBlendEquation = blendEquation;
						currentBlendEquationAlpha = blendEquationAlpha;
	
					}
	
					if ( blendSrc !== currentBlendSrc || blendDst !== currentBlendDst || blendSrcAlpha !== currentBlendSrcAlpha || blendDstAlpha !== currentBlendDstAlpha ) {
	
						gl.blendFuncSeparate( utils.convert( blendSrc ), utils.convert( blendDst ), utils.convert( blendSrcAlpha ), utils.convert( blendDstAlpha ) );
	
						currentBlendSrc = blendSrc;
						currentBlendDst = blendDst;
						currentBlendSrcAlpha = blendSrcAlpha;
						currentBlendDstAlpha = blendDstAlpha;
	
					}
	
				}
	
				currentBlending = blending;
				currentPremultipledAlpha = premultipliedAlpha;
	
			}
	
			function setMaterial( material, frontFaceCW ) {
	
				material.side === DoubleSide
					? disable( gl.CULL_FACE )
					: enable( gl.CULL_FACE );
	
				var flipSided = ( material.side === BackSide );
				if ( frontFaceCW ) flipSided = ! flipSided;
	
				setFlipSided( flipSided );
	
				material.transparent === true
					? setBlending( material.blending, material.blendEquation, material.blendSrc, material.blendDst, material.blendEquationAlpha, material.blendSrcAlpha, material.blendDstAlpha, material.premultipliedAlpha )
					: setBlending( NoBlending );
	
				depthBuffer.setFunc( material.depthFunc );
				depthBuffer.setTest( material.depthTest );
				depthBuffer.setMask( material.depthWrite );
				colorBuffer.setMask( material.colorWrite );
	
				setPolygonOffset( material.polygonOffset, material.polygonOffsetFactor, material.polygonOffsetUnits );
	
			}
	
			//
	
			function setFlipSided( flipSided ) {
	
				if ( currentFlipSided !== flipSided ) {
	
					if ( flipSided ) {
	
						gl.frontFace( gl.CW );
	
					} else {
	
						gl.frontFace( gl.CCW );
	
					}
	
					currentFlipSided = flipSided;
	
				}
	
			}
	
			function setCullFace( cullFace ) {
	
				if ( cullFace !== CullFaceNone ) {
	
					enable( gl.CULL_FACE );
	
					if ( cullFace !== currentCullFace ) {
	
						if ( cullFace === CullFaceBack ) {
	
							gl.cullFace( gl.BACK );
	
						} else if ( cullFace === CullFaceFront ) {
	
							gl.cullFace( gl.FRONT );
	
						} else {
	
							gl.cullFace( gl.FRONT_AND_BACK );
	
						}
	
					}
	
				} else {
	
					disable( gl.CULL_FACE );
	
				}
	
				currentCullFace = cullFace;
	
			}
	
			function setLineWidth( width ) {
	
				if ( width !== currentLineWidth ) {
	
					if ( lineWidthAvailable ) gl.lineWidth( width );
	
					currentLineWidth = width;
	
				}
	
			}
	
			function setPolygonOffset( polygonOffset, factor, units ) {
	
				if ( polygonOffset ) {
	
					enable( gl.POLYGON_OFFSET_FILL );
	
					if ( currentPolygonOffsetFactor !== factor || currentPolygonOffsetUnits !== units ) {
	
						gl.polygonOffset( factor, units );
	
						currentPolygonOffsetFactor = factor;
						currentPolygonOffsetUnits = units;
	
					}
	
				} else {
	
					disable( gl.POLYGON_OFFSET_FILL );
	
				}
	
			}
	
			function setScissorTest( scissorTest ) {
	
				if ( scissorTest ) {
	
					enable( gl.SCISSOR_TEST );
	
				} else {
	
					disable( gl.SCISSOR_TEST );
	
				}
	
			}
	
			// texture
	
			function activeTexture( webglSlot ) {
	
				if ( webglSlot === undefined ) webglSlot = gl.TEXTURE0 + maxTextures - 1;
	
				if ( currentTextureSlot !== webglSlot ) {
	
					gl.activeTexture( webglSlot );
					currentTextureSlot = webglSlot;
	
				}
	
			}
	
			function bindTexture( webglType, webglTexture ) {
	
				if ( currentTextureSlot === null ) {
	
					activeTexture();
	
				}
	
				var boundTexture = currentBoundTextures[ currentTextureSlot ];
	
				if ( boundTexture === undefined ) {
	
					boundTexture = { type: undefined, texture: undefined };
					currentBoundTextures[ currentTextureSlot ] = boundTexture;
	
				}
	
				if ( boundTexture.type !== webglType || boundTexture.texture !== webglTexture ) {
	
					gl.bindTexture( webglType, webglTexture || emptyTextures[ webglType ] );
	
					boundTexture.type = webglType;
					boundTexture.texture = webglTexture;
	
				}
	
			}
	
			function compressedTexImage2D() {
	
				try {
	
					gl.compressedTexImage2D.apply( gl, arguments );
	
				} catch ( error ) {
	
					console.error( 'THREE.WebGLState:', error );
	
				}
	
			}
	
			function texImage2D() {
	
				try {
	
					gl.texImage2D.apply( gl, arguments );
	
				} catch ( error ) {
	
					console.error( 'THREE.WebGLState:', error );
	
				}
	
			}
	
			//
	
			function scissor( scissor ) {
	
				if ( currentScissor.equals( scissor ) === false ) {
	
					gl.scissor( scissor.x, scissor.y, scissor.z, scissor.w );
					currentScissor.copy( scissor );
	
				}
	
			}
	
			function viewport( viewport ) {
	
				if ( currentViewport.equals( viewport ) === false ) {
	
					gl.viewport( viewport.x, viewport.y, viewport.z, viewport.w );
					currentViewport.copy( viewport );
	
				}
	
			}
	
			//
	
			function reset() {
	
				for ( var i = 0; i < enabledAttributes.length; i ++ ) {
	
					if ( enabledAttributes[ i ] === 1 ) {
	
						gl.disableVertexAttribArray( i );
						enabledAttributes[ i ] = 0;
	
					}
	
				}
	
				capabilities = {};
	
				compressedTextureFormats = null;
	
				currentTextureSlot = null;
				currentBoundTextures = {};
	
				currentProgram = null;
	
				currentBlending = null;
	
				currentFlipSided = null;
				currentCullFace = null;
	
				colorBuffer.reset();
				depthBuffer.reset();
				stencilBuffer.reset();
	
			}
	
			return {
	
				buffers: {
					color: colorBuffer,
					depth: depthBuffer,
					stencil: stencilBuffer
				},
	
				initAttributes: initAttributes,
				enableAttribute: enableAttribute,
				enableAttributeAndDivisor: enableAttributeAndDivisor,
				disableUnusedAttributes: disableUnusedAttributes,
				enable: enable,
				disable: disable,
				getCompressedTextureFormats: getCompressedTextureFormats,
	
				useProgram: useProgram,
	
				setBlending: setBlending,
				setMaterial: setMaterial,
	
				setFlipSided: setFlipSided,
				setCullFace: setCullFace,
	
				setLineWidth: setLineWidth,
				setPolygonOffset: setPolygonOffset,
	
				setScissorTest: setScissorTest,
	
				activeTexture: activeTexture,
				bindTexture: bindTexture,
				compressedTexImage2D: compressedTexImage2D,
				texImage2D: texImage2D,
	
				scissor: scissor,
				viewport: viewport,
	
				reset: reset
	
			};
	
		}
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function WebGLCapabilities( gl, extensions, parameters ) {
	
			var maxAnisotropy;
	
			function getMaxAnisotropy() {
	
				if ( maxAnisotropy !== undefined ) return maxAnisotropy;
	
				var extension = extensions.get( 'EXT_texture_filter_anisotropic' );
	
				if ( extension !== null ) {
	
					maxAnisotropy = gl.getParameter( extension.MAX_TEXTURE_MAX_ANISOTROPY_EXT );
	
				} else {
	
					maxAnisotropy = 0;
	
				}
	
				return maxAnisotropy;
	
			}
	
			function getMaxPrecision( precision ) {
	
				if ( precision === 'highp' ) {
	
					if ( gl.getShaderPrecisionFormat( gl.VERTEX_SHADER, gl.HIGH_FLOAT ).precision > 0 &&
					     gl.getShaderPrecisionFormat( gl.FRAGMENT_SHADER, gl.HIGH_FLOAT ).precision > 0 ) {
	
						return 'highp';
	
					}
	
					precision = 'mediump';
	
				}
	
				if ( precision === 'mediump' ) {
	
					if ( gl.getShaderPrecisionFormat( gl.VERTEX_SHADER, gl.MEDIUM_FLOAT ).precision > 0 &&
					     gl.getShaderPrecisionFormat( gl.FRAGMENT_SHADER, gl.MEDIUM_FLOAT ).precision > 0 ) {
	
						return 'mediump';
	
					}
	
				}
	
				return 'lowp';
	
			}
	
			var precision = parameters.precision !== undefined ? parameters.precision : 'highp';
			var maxPrecision = getMaxPrecision( precision );
	
			if ( maxPrecision !== precision ) {
	
				console.warn( 'THREE.WebGLRenderer:', precision, 'not supported, using', maxPrecision, 'instead.' );
				precision = maxPrecision;
	
			}
	
			var logarithmicDepthBuffer = parameters.logarithmicDepthBuffer === true;
	
			var maxTextures = gl.getParameter( gl.MAX_TEXTURE_IMAGE_UNITS );
			var maxVertexTextures = gl.getParameter( gl.MAX_VERTEX_TEXTURE_IMAGE_UNITS );
			var maxTextureSize = gl.getParameter( gl.MAX_TEXTURE_SIZE );
			var maxCubemapSize = gl.getParameter( gl.MAX_CUBE_MAP_TEXTURE_SIZE );
	
			var maxAttributes = gl.getParameter( gl.MAX_VERTEX_ATTRIBS );
			var maxVertexUniforms = gl.getParameter( gl.MAX_VERTEX_UNIFORM_VECTORS );
			var maxVaryings = gl.getParameter( gl.MAX_VARYING_VECTORS );
			var maxFragmentUniforms = gl.getParameter( gl.MAX_FRAGMENT_UNIFORM_VECTORS );
	
			var vertexTextures = maxVertexTextures > 0;
			var floatFragmentTextures = !! extensions.get( 'OES_texture_float' );
			var floatVertexTextures = vertexTextures && floatFragmentTextures;
	
			return {
	
				getMaxAnisotropy: getMaxAnisotropy,
				getMaxPrecision: getMaxPrecision,
	
				precision: precision,
				logarithmicDepthBuffer: logarithmicDepthBuffer,
	
				maxTextures: maxTextures,
				maxVertexTextures: maxVertexTextures,
				maxTextureSize: maxTextureSize,
				maxCubemapSize: maxCubemapSize,
	
				maxAttributes: maxAttributes,
				maxVertexUniforms: maxVertexUniforms,
				maxVaryings: maxVaryings,
				maxFragmentUniforms: maxFragmentUniforms,
	
				vertexTextures: vertexTextures,
				floatFragmentTextures: floatFragmentTextures,
				floatVertexTextures: floatVertexTextures
	
			};
	
		}
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author greggman / http://games.greggman.com/
		 * @author zz85 / http://www.lab4games.net/zz85/blog
		 * @author tschw
		 */
	
		function PerspectiveCamera( fov, aspect, near, far ) {
	
			Camera.call( this );
	
			this.type = 'PerspectiveCamera';
	
			this.fov = fov !== undefined ? fov : 50;
			this.zoom = 1;
	
			this.near = near !== undefined ? near : 0.1;
			this.far = far !== undefined ? far : 2000;
			this.focus = 10;
	
			this.aspect = aspect !== undefined ? aspect : 1;
			this.view = null;
	
			this.filmGauge = 35;	// width of the film (default in millimeters)
			this.filmOffset = 0;	// horizontal film offset (same unit as gauge)
	
			this.updateProjectionMatrix();
	
		}
	
		PerspectiveCamera.prototype = Object.assign( Object.create( Camera.prototype ), {
	
			constructor: PerspectiveCamera,
	
			isPerspectiveCamera: true,
	
			copy: function ( source, recursive ) {
	
				Camera.prototype.copy.call( this, source, recursive );
	
				this.fov = source.fov;
				this.zoom = source.zoom;
	
				this.near = source.near;
				this.far = source.far;
				this.focus = source.focus;
	
				this.aspect = source.aspect;
				this.view = source.view === null ? null : Object.assign( {}, source.view );
	
				this.filmGauge = source.filmGauge;
				this.filmOffset = source.filmOffset;
	
				return this;
	
			},
	
			/**
			 * Sets the FOV by focal length in respect to the current .filmGauge.
			 *
			 * The default film gauge is 35, so that the focal length can be specified for
			 * a 35mm (full frame) camera.
			 *
			 * Values for focal length and film gauge must have the same unit.
			 */
			setFocalLength: function ( focalLength ) {
	
				// see http://www.bobatkins.com/photography/technical/field_of_view.html
				var vExtentSlope = 0.5 * this.getFilmHeight() / focalLength;
	
				this.fov = _Math.RAD2DEG * 2 * Math.atan( vExtentSlope );
				this.updateProjectionMatrix();
	
			},
	
			/**
			 * Calculates the focal length from the current .fov and .filmGauge.
			 */
			getFocalLength: function () {
	
				var vExtentSlope = Math.tan( _Math.DEG2RAD * 0.5 * this.fov );
	
				return 0.5 * this.getFilmHeight() / vExtentSlope;
	
			},
	
			getEffectiveFOV: function () {
	
				return _Math.RAD2DEG * 2 * Math.atan(
					Math.tan( _Math.DEG2RAD * 0.5 * this.fov ) / this.zoom );
	
			},
	
			getFilmWidth: function () {
	
				// film not completely covered in portrait format (aspect < 1)
				return this.filmGauge * Math.min( this.aspect, 1 );
	
			},
	
			getFilmHeight: function () {
	
				// film not completely covered in landscape format (aspect > 1)
				return this.filmGauge / Math.max( this.aspect, 1 );
	
			},
	
			/**
			 * Sets an offset in a larger frustum. This is useful for multi-window or
			 * multi-monitor/multi-machine setups.
			 *
			 * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
			 * the monitors are in grid like this
			 *
			 *   +---+---+---+
			 *   | A | B | C |
			 *   +---+---+---+
			 *   | D | E | F |
			 *   +---+---+---+
			 *
			 * then for each monitor you would call it like this
			 *
			 *   var w = 1920;
			 *   var h = 1080;
			 *   var fullWidth = w * 3;
			 *   var fullHeight = h * 2;
			 *
			 *   --A--
			 *   camera.setOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
			 *   --B--
			 *   camera.setOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
			 *   --C--
			 *   camera.setOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
			 *   --D--
			 *   camera.setOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
			 *   --E--
			 *   camera.setOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
			 *   --F--
			 *   camera.setOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
			 *
			 *   Note there is no reason monitors have to be the same size or in a grid.
			 */
			setViewOffset: function ( fullWidth, fullHeight, x, y, width, height ) {
	
				this.aspect = fullWidth / fullHeight;
	
				if ( this.view === null ) {
	
					this.view = {
						enabled: true,
						fullWidth: 1,
						fullHeight: 1,
						offsetX: 0,
						offsetY: 0,
						width: 1,
						height: 1
					};
	
				}
	
				this.view.enabled = true;
				this.view.fullWidth = fullWidth;
				this.view.fullHeight = fullHeight;
				this.view.offsetX = x;
				this.view.offsetY = y;
				this.view.width = width;
				this.view.height = height;
	
				this.updateProjectionMatrix();
	
			},
	
			clearViewOffset: function () {
	
				if ( this.view !== null ) {
	
					this.view.enabled = false;
	
				}
	
				this.updateProjectionMatrix();
	
			},
	
			updateProjectionMatrix: function () {
	
				var near = this.near,
					top = near * Math.tan(
						_Math.DEG2RAD * 0.5 * this.fov ) / this.zoom,
					height = 2 * top,
					width = this.aspect * height,
					left = - 0.5 * width,
					view = this.view;
	
				if ( this.view !== null && this.view.enabled ) {
	
					var fullWidth = view.fullWidth,
						fullHeight = view.fullHeight;
	
					left += view.offsetX * width / fullWidth;
					top -= view.offsetY * height / fullHeight;
					width *= view.width / fullWidth;
					height *= view.height / fullHeight;
	
				}
	
				var skew = this.filmOffset;
				if ( skew !== 0 ) left += near * skew / this.getFilmWidth();
	
				this.projectionMatrix.makePerspective( left, left + width, top, top - height, near, this.far );
	
			},
	
			toJSON: function ( meta ) {
	
				var data = Object3D.prototype.toJSON.call( this, meta );
	
				data.object.fov = this.fov;
				data.object.zoom = this.zoom;
	
				data.object.near = this.near;
				data.object.far = this.far;
				data.object.focus = this.focus;
	
				data.object.aspect = this.aspect;
	
				if ( this.view !== null ) data.object.view = Object.assign( {}, this.view );
	
				data.object.filmGauge = this.filmGauge;
				data.object.filmOffset = this.filmOffset;
	
				return data;
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function ArrayCamera( array ) {
	
			PerspectiveCamera.call( this );
	
			this.cameras = array || [];
	
		}
	
		ArrayCamera.prototype = Object.assign( Object.create( PerspectiveCamera.prototype ), {
	
			constructor: ArrayCamera,
	
			isArrayCamera: true
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function WebVRManager( renderer ) {
	
			var scope = this;
	
			var device = null;
			var frameData = null;
	
			var poseTarget = null;
	
			if ( typeof window !== 'undefined' && 'VRFrameData' in window ) {
	
				frameData = new window.VRFrameData();
	
			}
	
			var matrixWorldInverse = new Matrix4();
	
			var cameraL = new PerspectiveCamera();
			cameraL.bounds = new Vector4( 0.0, 0.0, 0.5, 1.0 );
			cameraL.layers.enable( 1 );
	
			var cameraR = new PerspectiveCamera();
			cameraR.bounds = new Vector4( 0.5, 0.0, 0.5, 1.0 );
			cameraR.layers.enable( 2 );
	
			var cameraVR = new ArrayCamera( [ cameraL, cameraR ] );
			cameraVR.layers.enable( 1 );
			cameraVR.layers.enable( 2 );
	
			//
	
			var currentSize, currentPixelRatio;
	
			function onVRDisplayPresentChange() {
	
				if ( device !== null && device.isPresenting ) {
	
					var eyeParameters = device.getEyeParameters( 'left' );
					var renderWidth = eyeParameters.renderWidth;
					var renderHeight = eyeParameters.renderHeight;
	
					currentPixelRatio = renderer.getPixelRatio();
					currentSize = renderer.getSize();
	
					renderer.setDrawingBufferSize( renderWidth * 2, renderHeight, 1 );
	
				} else if ( scope.enabled ) {
	
					renderer.setDrawingBufferSize( currentSize.width, currentSize.height, currentPixelRatio );
	
				}
	
			}
	
			if ( typeof window !== 'undefined' ) {
	
				window.addEventListener( 'vrdisplaypresentchange', onVRDisplayPresentChange, false );
	
			}
	
			//
	
			this.enabled = false;
	
			this.getDevice = function () {
	
				return device;
	
			};
	
			this.setDevice = function ( value ) {
	
				if ( value !== undefined ) device = value;
	
			};
	
			this.setPoseTarget = function ( object ) {
	
				if ( object !== undefined ) poseTarget = object;
	
			};
	
			this.getCamera = function ( camera ) {
	
				if ( device === null ) return camera;
	
				device.depthNear = camera.near;
				device.depthFar = camera.far;
	
				device.getFrameData( frameData );
	
				//
	
				var pose = frameData.pose;
				var poseObject = poseTarget !== null ? poseTarget : camera;
	
				if ( pose.position !== null ) {
	
					poseObject.position.fromArray( pose.position );
	
				} else {
	
					poseObject.position.set( 0, 0, 0 );
	
				}
	
				if ( pose.orientation !== null ) {
	
					poseObject.quaternion.fromArray( pose.orientation );
	
				}
	
				poseObject.updateMatrixWorld();
	
				if ( device.isPresenting === false ) return camera;
	
				//
	
				cameraL.near = camera.near;
				cameraR.near = camera.near;
	
				cameraL.far = camera.far;
				cameraR.far = camera.far;
	
				cameraVR.matrixWorld.copy( camera.matrixWorld );
				cameraVR.matrixWorldInverse.copy( camera.matrixWorldInverse );
	
				cameraL.matrixWorldInverse.fromArray( frameData.leftViewMatrix );
				cameraR.matrixWorldInverse.fromArray( frameData.rightViewMatrix );
	
				var parent = poseObject.parent;
	
				if ( parent !== null ) {
	
					matrixWorldInverse.getInverse( parent.matrixWorld );
	
					cameraL.matrixWorldInverse.multiply( matrixWorldInverse );
					cameraR.matrixWorldInverse.multiply( matrixWorldInverse );
	
				}
	
				// envMap and Mirror needs camera.matrixWorld
	
				cameraL.matrixWorld.getInverse( cameraL.matrixWorldInverse );
				cameraR.matrixWorld.getInverse( cameraR.matrixWorldInverse );
	
				cameraL.projectionMatrix.fromArray( frameData.leftProjectionMatrix );
				cameraR.projectionMatrix.fromArray( frameData.rightProjectionMatrix );
	
				// HACK @mrdoob
				// https://github.com/w3c/webvr/issues/203
	
				cameraVR.projectionMatrix.copy( cameraL.projectionMatrix );
	
				//
	
				var layers = device.getLayers();
	
				if ( layers.length ) {
	
					var layer = layers[ 0 ];
	
					if ( layer.leftBounds !== null && layer.leftBounds.length === 4 ) {
	
						cameraL.bounds.fromArray( layer.leftBounds );
	
					}
	
					if ( layer.rightBounds !== null && layer.rightBounds.length === 4 ) {
	
						cameraR.bounds.fromArray( layer.rightBounds );
	
					}
	
				}
	
				return cameraVR;
	
			};
	
			this.submitFrame = function () {
	
				if ( device && device.isPresenting ) device.submitFrame();
	
			};
	
			this.dispose = function () {
	
				if ( typeof window !== 'undefined' ) {
	
					window.removeEventListener( 'vrdisplaypresentchange', onVRDisplayPresentChange );
	
				}
	
			};
	
		}
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function WebGLExtensions( gl ) {
	
			var extensions = {};
	
			return {
	
				get: function ( name ) {
	
					if ( extensions[ name ] !== undefined ) {
	
						return extensions[ name ];
	
					}
	
					var extension;
	
					switch ( name ) {
	
						case 'WEBGL_depth_texture':
							extension = gl.getExtension( 'WEBGL_depth_texture' ) || gl.getExtension( 'MOZ_WEBGL_depth_texture' ) || gl.getExtension( 'WEBKIT_WEBGL_depth_texture' );
							break;
	
						case 'EXT_texture_filter_anisotropic':
							extension = gl.getExtension( 'EXT_texture_filter_anisotropic' ) || gl.getExtension( 'MOZ_EXT_texture_filter_anisotropic' ) || gl.getExtension( 'WEBKIT_EXT_texture_filter_anisotropic' );
							break;
	
						case 'WEBGL_compressed_texture_s3tc':
							extension = gl.getExtension( 'WEBGL_compressed_texture_s3tc' ) || gl.getExtension( 'MOZ_WEBGL_compressed_texture_s3tc' ) || gl.getExtension( 'WEBKIT_WEBGL_compressed_texture_s3tc' );
							break;
	
						case 'WEBGL_compressed_texture_pvrtc':
							extension = gl.getExtension( 'WEBGL_compressed_texture_pvrtc' ) || gl.getExtension( 'WEBKIT_WEBGL_compressed_texture_pvrtc' );
							break;
	
						case 'WEBGL_compressed_texture_etc1':
							extension = gl.getExtension( 'WEBGL_compressed_texture_etc1' );
							break;
	
						default:
							extension = gl.getExtension( name );
	
					}
	
					if ( extension === null ) {
	
						console.warn( 'THREE.WebGLRenderer: ' + name + ' extension not supported.' );
	
					}
	
					extensions[ name ] = extension;
	
					return extension;
	
				}
	
			};
	
		}
	
		/**
		 * @author tschw
		 */
	
		function WebGLClipping() {
	
			var scope = this,
	
				globalState = null,
				numGlobalPlanes = 0,
				localClippingEnabled = false,
				renderingShadows = false,
	
				plane = new Plane(),
				viewNormalMatrix = new Matrix3(),
	
				uniform = { value: null, needsUpdate: false };
	
			this.uniform = uniform;
			this.numPlanes = 0;
			this.numIntersection = 0;
	
			this.init = function ( planes, enableLocalClipping, camera ) {
	
				var enabled =
					planes.length !== 0 ||
					enableLocalClipping ||
					// enable state of previous frame - the clipping code has to
					// run another frame in order to reset the state:
					numGlobalPlanes !== 0 ||
					localClippingEnabled;
	
				localClippingEnabled = enableLocalClipping;
	
				globalState = projectPlanes( planes, camera, 0 );
				numGlobalPlanes = planes.length;
	
				return enabled;
	
			};
	
			this.beginShadows = function () {
	
				renderingShadows = true;
				projectPlanes( null );
	
			};
	
			this.endShadows = function () {
	
				renderingShadows = false;
				resetGlobalState();
	
			};
	
			this.setState = function ( planes, clipIntersection, clipShadows, camera, cache, fromCache ) {
	
				if ( ! localClippingEnabled || planes === null || planes.length === 0 || renderingShadows && ! clipShadows ) {
	
					// there's no local clipping
	
					if ( renderingShadows ) {
	
						// there's no global clipping
	
						projectPlanes( null );
	
					} else {
	
						resetGlobalState();
	
					}
	
				} else {
	
					var nGlobal = renderingShadows ? 0 : numGlobalPlanes,
						lGlobal = nGlobal * 4,
	
						dstArray = cache.clippingState || null;
	
					uniform.value = dstArray; // ensure unique state
	
					dstArray = projectPlanes( planes, camera, lGlobal, fromCache );
	
					for ( var i = 0; i !== lGlobal; ++ i ) {
	
						dstArray[ i ] = globalState[ i ];
	
					}
	
					cache.clippingState = dstArray;
					this.numIntersection = clipIntersection ? this.numPlanes : 0;
					this.numPlanes += nGlobal;
	
				}
	
	
			};
	
			function resetGlobalState() {
	
				if ( uniform.value !== globalState ) {
	
					uniform.value = globalState;
					uniform.needsUpdate = numGlobalPlanes > 0;
	
				}
	
				scope.numPlanes = numGlobalPlanes;
				scope.numIntersection = 0;
	
			}
	
			function projectPlanes( planes, camera, dstOffset, skipTransform ) {
	
				var nPlanes = planes !== null ? planes.length : 0,
					dstArray = null;
	
				if ( nPlanes !== 0 ) {
	
					dstArray = uniform.value;
	
					if ( skipTransform !== true || dstArray === null ) {
	
						var flatSize = dstOffset + nPlanes * 4,
							viewMatrix = camera.matrixWorldInverse;
	
						viewNormalMatrix.getNormalMatrix( viewMatrix );
	
						if ( dstArray === null || dstArray.length < flatSize ) {
	
							dstArray = new Float32Array( flatSize );
	
						}
	
						for ( var i = 0, i4 = dstOffset; i !== nPlanes; ++ i, i4 += 4 ) {
	
							plane.copy( planes[ i ] ).applyMatrix4( viewMatrix, viewNormalMatrix );
	
							plane.normal.toArray( dstArray, i4 );
							dstArray[ i4 + 3 ] = plane.constant;
	
						}
	
					}
	
					uniform.value = dstArray;
					uniform.needsUpdate = true;
	
				}
	
				scope.numPlanes = nPlanes;
	
				return dstArray;
	
			}
	
		}
	
		/**
		 * @author thespite / http://www.twitter.com/thespite
		 */
	
		function WebGLUtils( gl, extensions ) {
	
			function convert( p ) {
	
				var extension;
	
				if ( p === RepeatWrapping ) return gl.REPEAT;
				if ( p === ClampToEdgeWrapping ) return gl.CLAMP_TO_EDGE;
				if ( p === MirroredRepeatWrapping ) return gl.MIRRORED_REPEAT;
	
				if ( p === NearestFilter ) return gl.NEAREST;
				if ( p === NearestMipMapNearestFilter ) return gl.NEAREST_MIPMAP_NEAREST;
				if ( p === NearestMipMapLinearFilter ) return gl.NEAREST_MIPMAP_LINEAR;
	
				if ( p === LinearFilter ) return gl.LINEAR;
				if ( p === LinearMipMapNearestFilter ) return gl.LINEAR_MIPMAP_NEAREST;
				if ( p === LinearMipMapLinearFilter ) return gl.LINEAR_MIPMAP_LINEAR;
	
				if ( p === UnsignedByteType ) return gl.UNSIGNED_BYTE;
				if ( p === UnsignedShort4444Type ) return gl.UNSIGNED_SHORT_4_4_4_4;
				if ( p === UnsignedShort5551Type ) return gl.UNSIGNED_SHORT_5_5_5_1;
				if ( p === UnsignedShort565Type ) return gl.UNSIGNED_SHORT_5_6_5;
	
				if ( p === ByteType ) return gl.BYTE;
				if ( p === ShortType ) return gl.SHORT;
				if ( p === UnsignedShortType ) return gl.UNSIGNED_SHORT;
				if ( p === IntType ) return gl.INT;
				if ( p === UnsignedIntType ) return gl.UNSIGNED_INT;
				if ( p === FloatType ) return gl.FLOAT;
	
				if ( p === HalfFloatType ) {
	
					extension = extensions.get( 'OES_texture_half_float' );
	
					if ( extension !== null ) return extension.HALF_FLOAT_OES;
	
				}
	
				if ( p === AlphaFormat ) return gl.ALPHA;
				if ( p === RGBFormat ) return gl.RGB;
				if ( p === RGBAFormat ) return gl.RGBA;
				if ( p === LuminanceFormat ) return gl.LUMINANCE;
				if ( p === LuminanceAlphaFormat ) return gl.LUMINANCE_ALPHA;
				if ( p === DepthFormat ) return gl.DEPTH_COMPONENT;
				if ( p === DepthStencilFormat ) return gl.DEPTH_STENCIL;
	
				if ( p === AddEquation ) return gl.FUNC_ADD;
				if ( p === SubtractEquation ) return gl.FUNC_SUBTRACT;
				if ( p === ReverseSubtractEquation ) return gl.FUNC_REVERSE_SUBTRACT;
	
				if ( p === ZeroFactor ) return gl.ZERO;
				if ( p === OneFactor ) return gl.ONE;
				if ( p === SrcColorFactor ) return gl.SRC_COLOR;
				if ( p === OneMinusSrcColorFactor ) return gl.ONE_MINUS_SRC_COLOR;
				if ( p === SrcAlphaFactor ) return gl.SRC_ALPHA;
				if ( p === OneMinusSrcAlphaFactor ) return gl.ONE_MINUS_SRC_ALPHA;
				if ( p === DstAlphaFactor ) return gl.DST_ALPHA;
				if ( p === OneMinusDstAlphaFactor ) return gl.ONE_MINUS_DST_ALPHA;
	
				if ( p === DstColorFactor ) return gl.DST_COLOR;
				if ( p === OneMinusDstColorFactor ) return gl.ONE_MINUS_DST_COLOR;
				if ( p === SrcAlphaSaturateFactor ) return gl.SRC_ALPHA_SATURATE;
	
				if ( p === RGB_S3TC_DXT1_Format || p === RGBA_S3TC_DXT1_Format ||
					p === RGBA_S3TC_DXT3_Format || p === RGBA_S3TC_DXT5_Format ) {
	
					extension = extensions.get( 'WEBGL_compressed_texture_s3tc' );
	
					if ( extension !== null ) {
	
						if ( p === RGB_S3TC_DXT1_Format ) return extension.COMPRESSED_RGB_S3TC_DXT1_EXT;
						if ( p === RGBA_S3TC_DXT1_Format ) return extension.COMPRESSED_RGBA_S3TC_DXT1_EXT;
						if ( p === RGBA_S3TC_DXT3_Format ) return extension.COMPRESSED_RGBA_S3TC_DXT3_EXT;
						if ( p === RGBA_S3TC_DXT5_Format ) return extension.COMPRESSED_RGBA_S3TC_DXT5_EXT;
	
					}
	
				}
	
				if ( p === RGB_PVRTC_4BPPV1_Format || p === RGB_PVRTC_2BPPV1_Format ||
					p === RGBA_PVRTC_4BPPV1_Format || p === RGBA_PVRTC_2BPPV1_Format ) {
	
					extension = extensions.get( 'WEBGL_compressed_texture_pvrtc' );
	
					if ( extension !== null ) {
	
						if ( p === RGB_PVRTC_4BPPV1_Format ) return extension.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
						if ( p === RGB_PVRTC_2BPPV1_Format ) return extension.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
						if ( p === RGBA_PVRTC_4BPPV1_Format ) return extension.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
						if ( p === RGBA_PVRTC_2BPPV1_Format ) return extension.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
	
					}
	
				}
	
				if ( p === RGB_ETC1_Format ) {
	
					extension = extensions.get( 'WEBGL_compressed_texture_etc1' );
	
					if ( extension !== null ) return extension.COMPRESSED_RGB_ETC1_WEBGL;
	
				}
	
				if ( p === MinEquation || p === MaxEquation ) {
	
					extension = extensions.get( 'EXT_blend_minmax' );
	
					if ( extension !== null ) {
	
						if ( p === MinEquation ) return extension.MIN_EXT;
						if ( p === MaxEquation ) return extension.MAX_EXT;
	
					}
	
				}
	
				if ( p === UnsignedInt248Type ) {
	
					extension = extensions.get( 'WEBGL_depth_texture' );
	
					if ( extension !== null ) return extension.UNSIGNED_INT_24_8_WEBGL;
	
				}
	
				return 0;
	
			}
	
			return { convert: convert };
	
		}
	
		/**
		 * @author supereggbert / http://www.paulbrunt.co.uk/
		 * @author mrdoob / http://mrdoob.com/
		 * @author alteredq / http://alteredqualia.com/
		 * @author szimek / https://github.com/szimek/
		 * @author tschw
		 */
	
		function WebGLRenderer( parameters ) {
	
			console.log( 'THREE.WebGLRenderer', REVISION );
	
			parameters = parameters || {};
	
			var _canvas = parameters.canvas !== undefined ? parameters.canvas : document.createElementNS( 'http://www.w3.org/1999/xhtml', 'canvas' ),
				_context = parameters.context !== undefined ? parameters.context : null,
	
				_alpha = parameters.alpha !== undefined ? parameters.alpha : false,
				_depth = parameters.depth !== undefined ? parameters.depth : true,
				_stencil = parameters.stencil !== undefined ? parameters.stencil : true,
				_antialias = parameters.antialias !== undefined ? parameters.antialias : false,
				_premultipliedAlpha = parameters.premultipliedAlpha !== undefined ? parameters.premultipliedAlpha : true,
				_preserveDrawingBuffer = parameters.preserveDrawingBuffer !== undefined ? parameters.preserveDrawingBuffer : false,
				_powerPreference = parameters.powerPreference !== undefined ? parameters.powerPreference : 'default';
	
			var lightsArray = [];
			var shadowsArray = [];
	
			var currentRenderList = null;
	
			var spritesArray = [];
			var flaresArray = [];
	
			// public properties
	
			this.domElement = _canvas;
			this.context = null;
	
			// clearing
	
			this.autoClear = true;
			this.autoClearColor = true;
			this.autoClearDepth = true;
			this.autoClearStencil = true;
	
			// scene graph
	
			this.sortObjects = true;
	
			// user-defined clipping
	
			this.clippingPlanes = [];
			this.localClippingEnabled = false;
	
			// physically based shading
	
			this.gammaFactor = 2.0;	// for backwards compatibility
			this.gammaInput = false;
			this.gammaOutput = false;
	
			// physical lights
	
			this.physicallyCorrectLights = false;
	
			// tone mapping
	
			this.toneMapping = LinearToneMapping;
			this.toneMappingExposure = 1.0;
			this.toneMappingWhitePoint = 1.0;
	
			// morphs
	
			this.maxMorphTargets = 8;
			this.maxMorphNormals = 4;
	
			// internal properties
	
			var _this = this,
	
				_isContextLost = false,
	
				// internal state cache
	
				_currentRenderTarget = null,
				_currentFramebuffer = null,
				_currentMaterialId = - 1,
				_currentGeometryProgram = '',
	
				_currentCamera = null,
				_currentArrayCamera = null,
	
				_currentViewport = new Vector4(),
				_currentScissor = new Vector4(),
				_currentScissorTest = null,
	
				//
	
				_usedTextureUnits = 0,
	
				//
	
				_width = _canvas.width,
				_height = _canvas.height,
	
				_pixelRatio = 1,
	
				_viewport = new Vector4( 0, 0, _width, _height ),
				_scissor = new Vector4( 0, 0, _width, _height ),
				_scissorTest = false,
	
				// frustum
	
				_frustum = new Frustum(),
	
				// clipping
	
				_clipping = new WebGLClipping(),
				_clippingEnabled = false,
				_localClippingEnabled = false,
	
				// camera matrices cache
	
				_projScreenMatrix = new Matrix4(),
	
				_vector3 = new Vector3(),
	
				// info
	
				_infoMemory = {
					geometries: 0,
					textures: 0
				},
	
				_infoRender = {
	
					frame: 0,
					calls: 0,
					vertices: 0,
					faces: 0,
					points: 0
	
				};
	
			this.info = {
	
				render: _infoRender,
				memory: _infoMemory,
				programs: null
	
			};
	
			function getTargetPixelRatio() {
	
				return _currentRenderTarget === null ? _pixelRatio : 1;
	
			}
	
			// initialize
	
			var _gl;
	
			try {
	
				var contextAttributes = {
					alpha: _alpha,
					depth: _depth,
					stencil: _stencil,
					antialias: _antialias,
					premultipliedAlpha: _premultipliedAlpha,
					preserveDrawingBuffer: _preserveDrawingBuffer,
					powerPreference: _powerPreference
				};
	
				// event listeners must be registered before WebGL context is created, see #12753
	
				_canvas.addEventListener( 'webglcontextlost', onContextLost, false );
				_canvas.addEventListener( 'webglcontextrestored', onContextRestore, false );
	
				_gl = _context || _canvas.getContext( 'webgl', contextAttributes ) || _canvas.getContext( 'experimental-webgl', contextAttributes );
	
				if ( _gl === null ) {
	
					if ( _canvas.getContext( 'webgl' ) !== null ) {
	
						throw new Error( 'Error creating WebGL context with your selected attributes.' );
	
					} else {
	
						throw new Error( 'Error creating WebGL context.' );
	
					}
	
				}
	
				// Some experimental-webgl implementations do not have getShaderPrecisionFormat
	
				if ( _gl.getShaderPrecisionFormat === undefined ) {
	
					_gl.getShaderPrecisionFormat = function () {
	
						return { 'rangeMin': 1, 'rangeMax': 1, 'precision': 1 };
	
					};
	
				}
	
			} catch ( error ) {
	
				console.error( 'THREE.WebGLRenderer: ' + error.message );
	
			}
	
			var extensions, capabilities, state;
			var properties, textures, attributes, geometries, objects, lights;
			var programCache, renderLists;
	
			var background, morphtargets, bufferRenderer, indexedBufferRenderer;
			var flareRenderer, spriteRenderer;
	
			var utils;
	
			function initGLContext() {
	
				extensions = new WebGLExtensions( _gl );
				extensions.get( 'WEBGL_depth_texture' );
				extensions.get( 'OES_texture_float' );
				extensions.get( 'OES_texture_float_linear' );
				extensions.get( 'OES_texture_half_float' );
				extensions.get( 'OES_texture_half_float_linear' );
				extensions.get( 'OES_standard_derivatives' );
				extensions.get( 'OES_element_index_uint' );
				extensions.get( 'ANGLE_instanced_arrays' );
	
				utils = new WebGLUtils( _gl, extensions );
	
				capabilities = new WebGLCapabilities( _gl, extensions, parameters );
	
				state = new WebGLState( _gl, extensions, utils );
				state.scissor( _currentScissor.copy( _scissor ).multiplyScalar( _pixelRatio ) );
				state.viewport( _currentViewport.copy( _viewport ).multiplyScalar( _pixelRatio ) );
	
				properties = new WebGLProperties();
				textures = new WebGLTextures( _gl, extensions, state, properties, capabilities, utils, _infoMemory );
				attributes = new WebGLAttributes( _gl );
				geometries = new WebGLGeometries( _gl, attributes, _infoMemory );
				objects = new WebGLObjects( geometries, _infoRender );
				morphtargets = new WebGLMorphtargets( _gl );
				programCache = new WebGLPrograms( _this, extensions, capabilities );
				lights = new WebGLLights();
				renderLists = new WebGLRenderLists();
	
				background = new WebGLBackground( _this, state, geometries, _premultipliedAlpha );
	
				bufferRenderer = new WebGLBufferRenderer( _gl, extensions, _infoRender );
				indexedBufferRenderer = new WebGLIndexedBufferRenderer( _gl, extensions, _infoRender );
	
				flareRenderer = new WebGLFlareRenderer( _this, _gl, state, textures, capabilities );
				spriteRenderer = new WebGLSpriteRenderer( _this, _gl, state, textures, capabilities );
	
				_this.info.programs = programCache.programs;
	
				_this.context = _gl;
				_this.capabilities = capabilities;
				_this.extensions = extensions;
				_this.properties = properties;
				_this.renderLists = renderLists;
				_this.state = state;
	
			}
	
			initGLContext();
	
			// vr
	
			var vr = new WebVRManager( _this );
	
			this.vr = vr;
	
			// shadow map
	
			var shadowMap = new WebGLShadowMap( _this, objects, capabilities.maxTextureSize );
	
			this.shadowMap = shadowMap;
	
			// API
	
			this.getContext = function () {
	
				return _gl;
	
			};
	
			this.getContextAttributes = function () {
	
				return _gl.getContextAttributes();
	
			};
	
			this.forceContextLoss = function () {
	
				var extension = extensions.get( 'WEBGL_lose_context' );
				if ( extension ) extension.loseContext();
	
			};
	
			this.forceContextRestore = function () {
	
				var extension = extensions.get( 'WEBGL_lose_context' );
				if ( extension ) extension.restoreContext();
	
			};
	
			this.getPixelRatio = function () {
	
				return _pixelRatio;
	
			};
	
			this.setPixelRatio = function ( value ) {
	
				if ( value === undefined ) return;
	
				_pixelRatio = value;
	
				this.setSize( _width, _height, false );
	
			};
	
			this.getSize = function () {
	
				return {
					width: _width,
					height: _height
				};
	
			};
	
			this.setSize = function ( width, height, updateStyle ) {
	
				var device = vr.getDevice();
	
				if ( device && device.isPresenting ) {
	
					console.warn( 'THREE.WebGLRenderer: Can\'t change size while VR device is presenting.' );
					return;
	
				}
	
				_width = width;
				_height = height;
	
				_canvas.width = width * _pixelRatio;
				_canvas.height = height * _pixelRatio;
	
				if ( updateStyle !== false ) {
	
					_canvas.style.width = width + 'px';
					_canvas.style.height = height + 'px';
	
				}
	
				this.setViewport( 0, 0, width, height );
	
			};
	
			this.getDrawingBufferSize = function () {
	
				return {
					width: _width * _pixelRatio,
					height: _height * _pixelRatio
				};
	
			};
	
			this.setDrawingBufferSize = function ( width, height, pixelRatio ) {
	
				_width = width;
				_height = height;
	
				_pixelRatio = pixelRatio;
	
				_canvas.width = width * pixelRatio;
				_canvas.height = height * pixelRatio;
	
				this.setViewport( 0, 0, width, height );
	
			};
	
			this.setViewport = function ( x, y, width, height ) {
	
				_viewport.set( x, _height - y - height, width, height );
				state.viewport( _currentViewport.copy( _viewport ).multiplyScalar( _pixelRatio ) );
	
			};
	
			this.setScissor = function ( x, y, width, height ) {
	
				_scissor.set( x, _height - y - height, width, height );
				state.scissor( _currentScissor.copy( _scissor ).multiplyScalar( _pixelRatio ) );
	
			};
	
			this.setScissorTest = function ( boolean ) {
	
				state.setScissorTest( _scissorTest = boolean );
	
			};
	
			// Clearing
	
			this.getClearColor = function () {
	
				return background.getClearColor();
	
			};
	
			this.setClearColor = function () {
	
				background.setClearColor.apply( background, arguments );
	
			};
	
			this.getClearAlpha = function () {
	
				return background.getClearAlpha();
	
			};
	
			this.setClearAlpha = function () {
	
				background.setClearAlpha.apply( background, arguments );
	
			};
	
			this.clear = function ( color, depth, stencil ) {
	
				var bits = 0;
	
				if ( color === undefined || color ) bits |= _gl.COLOR_BUFFER_BIT;
				if ( depth === undefined || depth ) bits |= _gl.DEPTH_BUFFER_BIT;
				if ( stencil === undefined || stencil ) bits |= _gl.STENCIL_BUFFER_BIT;
	
				_gl.clear( bits );
	
			};
	
			this.clearColor = function () {
	
				this.clear( true, false, false );
	
			};
	
			this.clearDepth = function () {
	
				this.clear( false, true, false );
	
			};
	
			this.clearStencil = function () {
	
				this.clear( false, false, true );
	
			};
	
			this.clearTarget = function ( renderTarget, color, depth, stencil ) {
	
				this.setRenderTarget( renderTarget );
				this.clear( color, depth, stencil );
	
			};
	
			//
	
			this.dispose = function () {
	
				_canvas.removeEventListener( 'webglcontextlost', onContextLost, false );
				_canvas.removeEventListener( 'webglcontextrestored', onContextRestore, false );
	
				renderLists.dispose();
	
				vr.dispose();
	
			};
	
			// Events
	
			function onContextLost( event ) {
	
				event.preventDefault();
	
				console.log( 'THREE.WebGLRenderer: Context Lost.' );
	
				_isContextLost = true;
	
			}
	
			function onContextRestore( /* event */ ) {
	
				console.log( 'THREE.WebGLRenderer: Context Restored.' );
	
				_isContextLost = false;
	
				initGLContext();
	
			}
	
			function onMaterialDispose( event ) {
	
				var material = event.target;
	
				material.removeEventListener( 'dispose', onMaterialDispose );
	
				deallocateMaterial( material );
	
			}
	
			// Buffer deallocation
	
			function deallocateMaterial( material ) {
	
				releaseMaterialProgramReference( material );
	
				properties.remove( material );
	
			}
	
	
			function releaseMaterialProgramReference( material ) {
	
				var programInfo = properties.get( material ).program;
	
				material.program = undefined;
	
				if ( programInfo !== undefined ) {
	
					programCache.releaseProgram( programInfo );
	
				}
	
			}
	
			// Buffer rendering
	
			function renderObjectImmediate( object, program, material ) {
	
				object.render( function ( object ) {
	
					_this.renderBufferImmediate( object, program, material );
	
				} );
	
			}
	
			this.renderBufferImmediate = function ( object, program, material ) {
	
				state.initAttributes();
	
				var buffers = properties.get( object );
	
				if ( object.hasPositions && ! buffers.position ) buffers.position = _gl.createBuffer();
				if ( object.hasNormals && ! buffers.normal ) buffers.normal = _gl.createBuffer();
				if ( object.hasUvs && ! buffers.uv ) buffers.uv = _gl.createBuffer();
				if ( object.hasColors && ! buffers.color ) buffers.color = _gl.createBuffer();
	
				var programAttributes = program.getAttributes();
	
				if ( object.hasPositions ) {
	
					_gl.bindBuffer( _gl.ARRAY_BUFFER, buffers.position );
					_gl.bufferData( _gl.ARRAY_BUFFER, object.positionArray, _gl.DYNAMIC_DRAW );
	
					state.enableAttribute( programAttributes.position );
					_gl.vertexAttribPointer( programAttributes.position, 3, _gl.FLOAT, false, 0, 0 );
	
				}
	
				if ( object.hasNormals ) {
	
					_gl.bindBuffer( _gl.ARRAY_BUFFER, buffers.normal );
	
					if ( ! material.isMeshPhongMaterial &&
						! material.isMeshStandardMaterial &&
						! material.isMeshNormalMaterial &&
						material.flatShading === true ) {
	
						for ( var i = 0, l = object.count * 3; i < l; i += 9 ) {
	
							var array = object.normalArray;
	
							var nx = ( array[ i + 0 ] + array[ i + 3 ] + array[ i + 6 ] ) / 3;
							var ny = ( array[ i + 1 ] + array[ i + 4 ] + array[ i + 7 ] ) / 3;
							var nz = ( array[ i + 2 ] + array[ i + 5 ] + array[ i + 8 ] ) / 3;
	
							array[ i + 0 ] = nx;
							array[ i + 1 ] = ny;
							array[ i + 2 ] = nz;
	
							array[ i + 3 ] = nx;
							array[ i + 4 ] = ny;
							array[ i + 5 ] = nz;
	
							array[ i + 6 ] = nx;
							array[ i + 7 ] = ny;
							array[ i + 8 ] = nz;
	
						}
	
					}
	
					_gl.bufferData( _gl.ARRAY_BUFFER, object.normalArray, _gl.DYNAMIC_DRAW );
	
					state.enableAttribute( programAttributes.normal );
	
					_gl.vertexAttribPointer( programAttributes.normal, 3, _gl.FLOAT, false, 0, 0 );
	
				}
	
				if ( object.hasUvs && material.map ) {
	
					_gl.bindBuffer( _gl.ARRAY_BUFFER, buffers.uv );
					_gl.bufferData( _gl.ARRAY_BUFFER, object.uvArray, _gl.DYNAMIC_DRAW );
	
					state.enableAttribute( programAttributes.uv );
	
					_gl.vertexAttribPointer( programAttributes.uv, 2, _gl.FLOAT, false, 0, 0 );
	
				}
	
				if ( object.hasColors && material.vertexColors !== NoColors ) {
	
					_gl.bindBuffer( _gl.ARRAY_BUFFER, buffers.color );
					_gl.bufferData( _gl.ARRAY_BUFFER, object.colorArray, _gl.DYNAMIC_DRAW );
	
					state.enableAttribute( programAttributes.color );
	
					_gl.vertexAttribPointer( programAttributes.color, 3, _gl.FLOAT, false, 0, 0 );
	
				}
	
				state.disableUnusedAttributes();
	
				_gl.drawArrays( _gl.TRIANGLES, 0, object.count );
	
				object.count = 0;
	
			};
	
			this.renderBufferDirect = function ( camera, fog, geometry, material, object, group ) {
	
				var frontFaceCW = ( object.isMesh && object.matrixWorld.determinant() < 0 );
	
				state.setMaterial( material, frontFaceCW );
	
				var program = setProgram( camera, fog, material, object );
				var geometryProgram = geometry.id + '_' + program.id + '_' + ( material.wireframe === true );
	
				var updateBuffers = false;
	
				if ( geometryProgram !== _currentGeometryProgram ) {
	
					_currentGeometryProgram = geometryProgram;
					updateBuffers = true;
	
				}
	
				if ( object.morphTargetInfluences ) {
	
					morphtargets.update( object, geometry, material, program );
	
					updateBuffers = true;
	
				}
	
				//
	
				var index = geometry.index;
				var position = geometry.attributes.position;
				var rangeFactor = 1;
	
				if ( material.wireframe === true ) {
	
					index = geometries.getWireframeAttribute( geometry );
					rangeFactor = 2;
	
				}
	
				var attribute;
				var renderer = bufferRenderer;
	
				if ( index !== null ) {
	
					attribute = attributes.get( index );
	
					renderer = indexedBufferRenderer;
					renderer.setIndex( attribute );
	
				}
	
				if ( updateBuffers ) {
	
					setupVertexAttributes( material, program, geometry );
	
					if ( index !== null ) {
	
						_gl.bindBuffer( _gl.ELEMENT_ARRAY_BUFFER, attribute.buffer );
	
					}
	
				}
	
				//
	
				var dataCount = 0;
	
				if ( index !== null ) {
	
					dataCount = index.count;
	
				} else if ( position !== undefined ) {
	
					dataCount = position.count;
	
				}
	
				var rangeStart = geometry.drawRange.start * rangeFactor;
				var rangeCount = geometry.drawRange.count * rangeFactor;
	
				var groupStart = group !== null ? group.start * rangeFactor : 0;
				var groupCount = group !== null ? group.count * rangeFactor : Infinity;
	
				var drawStart = Math.max( rangeStart, groupStart );
				var drawEnd = Math.min( dataCount, rangeStart + rangeCount, groupStart + groupCount ) - 1;
	
				var drawCount = Math.max( 0, drawEnd - drawStart + 1 );
	
				if ( drawCount === 0 ) return;
	
				//
	
				if ( object.isMesh ) {
	
					if ( material.wireframe === true ) {
	
						state.setLineWidth( material.wireframeLinewidth * getTargetPixelRatio() );
						renderer.setMode( _gl.LINES );
	
					} else {
	
						switch ( object.drawMode ) {
	
							case TrianglesDrawMode:
								renderer.setMode( _gl.TRIANGLES );
								break;
	
							case TriangleStripDrawMode:
								renderer.setMode( _gl.TRIANGLE_STRIP );
								break;
	
							case TriangleFanDrawMode:
								renderer.setMode( _gl.TRIANGLE_FAN );
								break;
	
						}
	
					}
	
	
				} else if ( object.isLine ) {
	
					var lineWidth = material.linewidth;
	
					if ( lineWidth === undefined ) lineWidth = 1; // Not using Line*Material
	
					state.setLineWidth( lineWidth * getTargetPixelRatio() );
	
					if ( object.isLineSegments ) {
	
						renderer.setMode( _gl.LINES );
	
					} else if ( object.isLineLoop ) {
	
						renderer.setMode( _gl.LINE_LOOP );
	
					} else {
	
						renderer.setMode( _gl.LINE_STRIP );
	
					}
	
				} else if ( object.isPoints ) {
	
					renderer.setMode( _gl.POINTS );
	
				}
	
				if ( geometry && geometry.isInstancedBufferGeometry ) {
	
					if ( geometry.maxInstancedCount > 0 ) {
	
						renderer.renderInstances( geometry, drawStart, drawCount );
	
					}
	
				} else {
	
					renderer.render( drawStart, drawCount );
	
				}
	
			};
	
			function setupVertexAttributes( material, program, geometry, startIndex ) {
	
				if ( geometry && geometry.isInstancedBufferGeometry ) {
	
					if ( extensions.get( 'ANGLE_instanced_arrays' ) === null ) {
	
						console.error( 'THREE.WebGLRenderer.setupVertexAttributes: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.' );
						return;
	
					}
	
				}
	
				if ( startIndex === undefined ) startIndex = 0;
	
				state.initAttributes();
	
				var geometryAttributes = geometry.attributes;
	
				var programAttributes = program.getAttributes();
	
				var materialDefaultAttributeValues = material.defaultAttributeValues;
	
				for ( var name in programAttributes ) {
	
					var programAttribute = programAttributes[ name ];
	
					if ( programAttribute >= 0 ) {
	
						var geometryAttribute = geometryAttributes[ name ];
	
						if ( geometryAttribute !== undefined ) {
	
							var normalized = geometryAttribute.normalized;
							var size = geometryAttribute.itemSize;
	
							var attribute = attributes.get( geometryAttribute );
	
							// TODO Attribute may not be available on context restore
	
							if ( attribute === undefined ) continue;
	
							var buffer = attribute.buffer;
							var type = attribute.type;
							var bytesPerElement = attribute.bytesPerElement;
	
							if ( geometryAttribute.isInterleavedBufferAttribute ) {
	
								var data = geometryAttribute.data;
								var stride = data.stride;
								var offset = geometryAttribute.offset;
	
								if ( data && data.isInstancedInterleavedBuffer ) {
	
									state.enableAttributeAndDivisor( programAttribute, data.meshPerAttribute );
	
									if ( geometry.maxInstancedCount === undefined ) {
	
										geometry.maxInstancedCount = data.meshPerAttribute * data.count;
	
									}
	
								} else {
	
									state.enableAttribute( programAttribute );
	
								}
	
								_gl.bindBuffer( _gl.ARRAY_BUFFER, buffer );
								_gl.vertexAttribPointer( programAttribute, size, type, normalized, stride * bytesPerElement, ( startIndex * stride + offset ) * bytesPerElement );
	
							} else {
	
								if ( geometryAttribute.isInstancedBufferAttribute ) {
	
									state.enableAttributeAndDivisor( programAttribute, geometryAttribute.meshPerAttribute );
	
									if ( geometry.maxInstancedCount === undefined ) {
	
										geometry.maxInstancedCount = geometryAttribute.meshPerAttribute * geometryAttribute.count;
	
									}
	
								} else {
	
									state.enableAttribute( programAttribute );
	
								}
	
								_gl.bindBuffer( _gl.ARRAY_BUFFER, buffer );
								_gl.vertexAttribPointer( programAttribute, size, type, normalized, 0, startIndex * size * bytesPerElement );
	
							}
	
						} else if ( materialDefaultAttributeValues !== undefined ) {
	
							var value = materialDefaultAttributeValues[ name ];
	
							if ( value !== undefined ) {
	
								switch ( value.length ) {
	
									case 2:
										_gl.vertexAttrib2fv( programAttribute, value );
										break;
	
									case 3:
										_gl.vertexAttrib3fv( programAttribute, value );
										break;
	
									case 4:
										_gl.vertexAttrib4fv( programAttribute, value );
										break;
	
									default:
										_gl.vertexAttrib1fv( programAttribute, value );
	
								}
	
							}
	
						}
	
					}
	
				}
	
				state.disableUnusedAttributes();
	
			}
	
			// Compile
	
			this.compile = function ( scene, camera ) {
	
				lightsArray.length = 0;
				shadowsArray.length = 0;
	
				scene.traverse( function ( object ) {
	
					if ( object.isLight ) {
	
						lightsArray.push( object );
	
						if ( object.castShadow ) {
	
							shadowsArray.push( object );
	
						}
	
					}
	
				} );
	
				lights.setup( lightsArray, shadowsArray, camera );
	
				scene.traverse( function ( object ) {
	
					if ( object.material ) {
	
						if ( Array.isArray( object.material ) ) {
	
							for ( var i = 0; i < object.material.length; i ++ ) {
	
								initMaterial( object.material[ i ], scene.fog, object );
	
							}
	
						} else {
	
							initMaterial( object.material, scene.fog, object );
	
						}
	
					}
	
				} );
	
			};
	
			// Animation Loop
	
			var isAnimating = false;
			var onAnimationFrame = null;
	
			function start() {
	
				if ( isAnimating ) return;
	
				var device = vr.getDevice();
	
				if ( device && device.isPresenting ) {
	
					device.requestAnimationFrame( loop );
	
				} else {
	
					window.requestAnimationFrame( loop );
	
				}
	
				isAnimating = true;
	
			}
	
			function loop( time ) {
	
				if ( onAnimationFrame !== null ) onAnimationFrame( time );
	
				var device = vr.getDevice();
	
				if ( device && device.isPresenting ) {
	
					device.requestAnimationFrame( loop );
	
				} else {
	
					window.requestAnimationFrame( loop );
	
				}
	
			}
	
			this.animate = function ( callback ) {
	
				onAnimationFrame = callback;
				start();
	
			};
	
			// Rendering
	
			this.render = function ( scene, camera, renderTarget, forceClear ) {
	
				if ( ! ( camera && camera.isCamera ) ) {
	
					console.error( 'THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.' );
					return;
	
				}
	
				if ( _isContextLost ) return;
	
				// reset caching for this frame
	
				_currentGeometryProgram = '';
				_currentMaterialId = - 1;
				_currentCamera = null;
	
				// update scene graph
	
				if ( scene.autoUpdate === true ) scene.updateMatrixWorld();
	
				// update camera matrices and frustum
	
				if ( camera.parent === null ) camera.updateMatrixWorld();
	
				if ( vr.enabled ) {
	
					camera = vr.getCamera( camera );
	
				}
	
				_projScreenMatrix.multiplyMatrices( camera.projectionMatrix, camera.matrixWorldInverse );
				_frustum.setFromMatrix( _projScreenMatrix );
	
				lightsArray.length = 0;
				shadowsArray.length = 0;
	
				spritesArray.length = 0;
				flaresArray.length = 0;
	
				_localClippingEnabled = this.localClippingEnabled;
				_clippingEnabled = _clipping.init( this.clippingPlanes, _localClippingEnabled, camera );
	
				currentRenderList = renderLists.get( scene, camera );
				currentRenderList.init();
	
				projectObject( scene, camera, _this.sortObjects );
	
				if ( _this.sortObjects === true ) {
	
					currentRenderList.sort();
	
				}
	
				//
	
				textures.updateVideoTextures();
	
				//
	
				if ( _clippingEnabled ) _clipping.beginShadows();
	
				shadowMap.render( shadowsArray, scene, camera );
	
				lights.setup( lightsArray, shadowsArray, camera );
	
				if ( _clippingEnabled ) _clipping.endShadows();
	
				//
	
				_infoRender.frame ++;
				_infoRender.calls = 0;
				_infoRender.vertices = 0;
				_infoRender.faces = 0;
				_infoRender.points = 0;
	
				if ( renderTarget === undefined ) {
	
					renderTarget = null;
	
				}
	
				this.setRenderTarget( renderTarget );
	
				//
	
				background.render( currentRenderList, scene, camera, forceClear );
	
				// render scene
	
				var opaqueObjects = currentRenderList.opaque;
				var transparentObjects = currentRenderList.transparent;
	
				if ( scene.overrideMaterial ) {
	
					var overrideMaterial = scene.overrideMaterial;
	
					if ( opaqueObjects.length ) renderObjects( opaqueObjects, scene, camera, overrideMaterial );
					if ( transparentObjects.length ) renderObjects( transparentObjects, scene, camera, overrideMaterial );
	
				} else {
	
					// opaque pass (front-to-back order)
	
					if ( opaqueObjects.length ) renderObjects( opaqueObjects, scene, camera );
	
					// transparent pass (back-to-front order)
	
					if ( transparentObjects.length ) renderObjects( transparentObjects, scene, camera );
	
				}
	
				// custom renderers
	
				spriteRenderer.render( spritesArray, scene, camera );
				flareRenderer.render( flaresArray, scene, camera, _currentViewport );
	
				// Generate mipmap if we're using any kind of mipmap filtering
	
				if ( renderTarget ) {
	
					textures.updateRenderTargetMipmap( renderTarget );
	
				}
	
				// Ensure depth buffer writing is enabled so it can be cleared on next render
	
				state.buffers.depth.setTest( true );
				state.buffers.depth.setMask( true );
				state.buffers.color.setMask( true );
	
				state.setPolygonOffset( false );
	
				if ( vr.enabled ) {
	
					vr.submitFrame();
	
				}
	
				// _gl.finish();
	
			};
	
			/*
			// TODO Duplicated code (Frustum)
	
			var _sphere = new Sphere();
	
			function isObjectViewable( object ) {
	
				var geometry = object.geometry;
	
				if ( geometry.boundingSphere === null )
					geometry.computeBoundingSphere();
	
				_sphere.copy( geometry.boundingSphere ).
				applyMatrix4( object.matrixWorld );
	
				return isSphereViewable( _sphere );
	
			}
	
			function isSpriteViewable( sprite ) {
	
				_sphere.center.set( 0, 0, 0 );
				_sphere.radius = 0.7071067811865476;
				_sphere.applyMatrix4( sprite.matrixWorld );
	
				return isSphereViewable( _sphere );
	
			}
	
			function isSphereViewable( sphere ) {
	
				if ( ! _frustum.intersectsSphere( sphere ) ) return false;
	
				var numPlanes = _clipping.numPlanes;
	
				if ( numPlanes === 0 ) return true;
	
				var planes = _this.clippingPlanes,
	
					center = sphere.center,
					negRad = - sphere.radius,
					i = 0;
	
				do {
	
					// out when deeper than radius in the negative halfspace
					if ( planes[ i ].distanceToPoint( center ) < negRad ) return false;
	
				} while ( ++ i !== numPlanes );
	
				return true;
	
			}
			*/
	
			function projectObject( object, camera, sortObjects ) {
	
				if ( object.visible === false ) return;
	
				var visible = object.layers.test( camera.layers );
	
				if ( visible ) {
	
					if ( object.isLight ) {
	
						lightsArray.push( object );
	
						if ( object.castShadow ) {
	
							shadowsArray.push( object );
	
						}
	
					} else if ( object.isSprite ) {
	
						if ( ! object.frustumCulled || _frustum.intersectsSprite( object ) ) {
	
							spritesArray.push( object );
	
						}
	
					} else if ( object.isLensFlare ) {
	
						flaresArray.push( object );
	
					} else if ( object.isImmediateRenderObject ) {
	
						if ( sortObjects ) {
	
							_vector3.setFromMatrixPosition( object.matrixWorld )
								.applyMatrix4( _projScreenMatrix );
	
						}
	
						currentRenderList.push( object, null, object.material, _vector3.z, null );
	
					} else if ( object.isMesh || object.isLine || object.isPoints ) {
	
						if ( object.isSkinnedMesh ) {
	
							object.skeleton.update();
	
						}
	
						if ( ! object.frustumCulled || _frustum.intersectsObject( object ) ) {
	
							if ( sortObjects ) {
	
								_vector3.setFromMatrixPosition( object.matrixWorld )
									.applyMatrix4( _projScreenMatrix );
	
							}
	
							var geometry = objects.update( object );
							var material = object.material;
	
							if ( Array.isArray( material ) ) {
	
								var groups = geometry.groups;
	
								for ( var i = 0, l = groups.length; i < l; i ++ ) {
	
									var group = groups[ i ];
									var groupMaterial = material[ group.materialIndex ];
	
									if ( groupMaterial && groupMaterial.visible ) {
	
										currentRenderList.push( object, geometry, groupMaterial, _vector3.z, group );
	
									}
	
								}
	
							} else if ( material.visible ) {
	
								currentRenderList.push( object, geometry, material, _vector3.z, null );
	
							}
	
						}
	
					}
	
				}
	
				var children = object.children;
	
				for ( var i = 0, l = children.length; i < l; i ++ ) {
	
					projectObject( children[ i ], camera, sortObjects );
	
				}
	
			}
	
			function renderObjects( renderList, scene, camera, overrideMaterial ) {
	
				for ( var i = 0, l = renderList.length; i < l; i ++ ) {
	
					var renderItem = renderList[ i ];
	
					var object = renderItem.object;
					var geometry = renderItem.geometry;
					var material = overrideMaterial === undefined ? renderItem.material : overrideMaterial;
					var group = renderItem.group;
	
					if ( camera.isArrayCamera ) {
	
						_currentArrayCamera = camera;
	
						var cameras = camera.cameras;
	
						for ( var j = 0, jl = cameras.length; j < jl; j ++ ) {
	
							var camera2 = cameras[ j ];
	
							if ( object.layers.test( camera2.layers ) ) {
	
								var bounds = camera2.bounds;
	
								var x = bounds.x * _width;
								var y = bounds.y * _height;
								var width = bounds.z * _width;
								var height = bounds.w * _height;
	
								state.viewport( _currentViewport.set( x, y, width, height ).multiplyScalar( _pixelRatio ) );
	
								renderObject( object, scene, camera2, geometry, material, group );
	
							}
	
						}
	
					} else {
	
						_currentArrayCamera = null;
	
						renderObject( object, scene, camera, geometry, material, group );
	
					}
	
				}
	
			}
	
			function renderObject( object, scene, camera, geometry, material, group ) {
	
				object.onBeforeRender( _this, scene, camera, geometry, material, group );
	
				object.modelViewMatrix.multiplyMatrices( camera.matrixWorldInverse, object.matrixWorld );
				object.normalMatrix.getNormalMatrix( object.modelViewMatrix );
	
				if ( object.isImmediateRenderObject ) {
	
					var frontFaceCW = ( object.isMesh && object.matrixWorld.determinant() < 0 );
	
					state.setMaterial( material, frontFaceCW );
	
					var program = setProgram( camera, scene.fog, material, object );
	
					_currentGeometryProgram = '';
	
					renderObjectImmediate( object, program, material );
	
				} else {
	
					_this.renderBufferDirect( camera, scene.fog, geometry, material, object, group );
	
				}
	
				object.onAfterRender( _this, scene, camera, geometry, material, group );
	
			}
	
			function initMaterial( material, fog, object ) {
	
				var materialProperties = properties.get( material );
	
				var parameters = programCache.getParameters(
					material, lights.state, shadowsArray, fog, _clipping.numPlanes, _clipping.numIntersection, object );
	
				var code = programCache.getProgramCode( material, parameters );
	
				var program = materialProperties.program;
				var programChange = true;
	
				if ( program === undefined ) {
	
					// new material
					material.addEventListener( 'dispose', onMaterialDispose );
	
				} else if ( program.code !== code ) {
	
					// changed glsl or parameters
					releaseMaterialProgramReference( material );
	
				} else if ( parameters.shaderID !== undefined ) {
	
					// same glsl and uniform list
					return;
	
				} else {
	
					// only rebuild uniform list
					programChange = false;
	
				}
	
				if ( programChange ) {
	
					if ( parameters.shaderID ) {
	
						var shader = ShaderLib[ parameters.shaderID ];
	
						materialProperties.shader = {
							name: material.type,
							uniforms: UniformsUtils.clone( shader.uniforms ),
							vertexShader: shader.vertexShader,
							fragmentShader: shader.fragmentShader
						};
	
					} else {
	
						materialProperties.shader = {
							name: material.type,
							uniforms: material.uniforms,
							vertexShader: material.vertexShader,
							fragmentShader: material.fragmentShader
						};
	
					}
	
					material.onBeforeCompile( materialProperties.shader );
	
					program = programCache.acquireProgram( material, materialProperties.shader, parameters, code );
	
					materialProperties.program = program;
					material.program = program;
	
				}
	
				var programAttributes = program.getAttributes();
	
				if ( material.morphTargets ) {
	
					material.numSupportedMorphTargets = 0;
	
					for ( var i = 0; i < _this.maxMorphTargets; i ++ ) {
	
						if ( programAttributes[ 'morphTarget' + i ] >= 0 ) {
	
							material.numSupportedMorphTargets ++;
	
						}
	
					}
	
				}
	
				if ( material.morphNormals ) {
	
					material.numSupportedMorphNormals = 0;
	
					for ( var i = 0; i < _this.maxMorphNormals; i ++ ) {
	
						if ( programAttributes[ 'morphNormal' + i ] >= 0 ) {
	
							material.numSupportedMorphNormals ++;
	
						}
	
					}
	
				}
	
				var uniforms = materialProperties.shader.uniforms;
	
				if ( ! material.isShaderMaterial &&
					! material.isRawShaderMaterial ||
					material.clipping === true ) {
	
					materialProperties.numClippingPlanes = _clipping.numPlanes;
					materialProperties.numIntersection = _clipping.numIntersection;
					uniforms.clippingPlanes = _clipping.uniform;
	
				}
	
				materialProperties.fog = fog;
	
				// store the light setup it was created for
	
				materialProperties.lightsHash = lights.state.hash;
	
				if ( material.lights ) {
	
					// wire up the material to this renderer's lighting state
	
					uniforms.ambientLightColor.value = lights.state.ambient;
					uniforms.directionalLights.value = lights.state.directional;
					uniforms.spotLights.value = lights.state.spot;
					uniforms.rectAreaLights.value = lights.state.rectArea;
					uniforms.pointLights.value = lights.state.point;
					uniforms.hemisphereLights.value = lights.state.hemi;
	
					uniforms.directionalShadowMap.value = lights.state.directionalShadowMap;
					uniforms.directionalShadowMatrix.value = lights.state.directionalShadowMatrix;
					uniforms.spotShadowMap.value = lights.state.spotShadowMap;
					uniforms.spotShadowMatrix.value = lights.state.spotShadowMatrix;
					uniforms.pointShadowMap.value = lights.state.pointShadowMap;
					uniforms.pointShadowMatrix.value = lights.state.pointShadowMatrix;
					// TODO (abelnation): add area lights shadow info to uniforms
	
				}
	
				var progUniforms = materialProperties.program.getUniforms(),
					uniformsList =
						WebGLUniforms.seqWithValue( progUniforms.seq, uniforms );
	
				materialProperties.uniformsList = uniformsList;
	
			}
	
			function setProgram( camera, fog, material, object ) {
	
				_usedTextureUnits = 0;
	
				var materialProperties = properties.get( material );
	
				if ( _clippingEnabled ) {
	
					if ( _localClippingEnabled || camera !== _currentCamera ) {
	
						var useCache =
							camera === _currentCamera &&
							material.id === _currentMaterialId;
	
						// we might want to call this function with some ClippingGroup
						// object instead of the material, once it becomes feasible
						// (#8465, #8379)
						_clipping.setState(
							material.clippingPlanes, material.clipIntersection, material.clipShadows,
							camera, materialProperties, useCache );
	
					}
	
				}
	
				if ( material.needsUpdate === false ) {
	
					if ( materialProperties.program === undefined ) {
	
						material.needsUpdate = true;
	
					} else if ( material.fog && materialProperties.fog !== fog ) {
	
						material.needsUpdate = true;
	
					} else if ( material.lights && materialProperties.lightsHash !== lights.state.hash ) {
	
						material.needsUpdate = true;
	
					} else if ( materialProperties.numClippingPlanes !== undefined &&
						( materialProperties.numClippingPlanes !== _clipping.numPlanes ||
						materialProperties.numIntersection !== _clipping.numIntersection ) ) {
	
						material.needsUpdate = true;
	
					}
	
				}
	
				if ( material.needsUpdate ) {
	
					initMaterial( material, fog, object );
					material.needsUpdate = false;
	
				}
	
				var refreshProgram = false;
				var refreshMaterial = false;
				var refreshLights = false;
	
				var program = materialProperties.program,
					p_uniforms = program.getUniforms(),
					m_uniforms = materialProperties.shader.uniforms;
	
				if ( state.useProgram( program.program ) ) {
	
					refreshProgram = true;
					refreshMaterial = true;
					refreshLights = true;
	
				}
	
				if ( material.id !== _currentMaterialId ) {
	
					_currentMaterialId = material.id;
	
					refreshMaterial = true;
	
				}
	
				if ( refreshProgram || camera !== _currentCamera ) {
	
					p_uniforms.setValue( _gl, 'projectionMatrix', camera.projectionMatrix );
	
					if ( capabilities.logarithmicDepthBuffer ) {
	
						p_uniforms.setValue( _gl, 'logDepthBufFC',
							2.0 / ( Math.log( camera.far + 1.0 ) / Math.LN2 ) );
	
					}
	
					// Avoid unneeded uniform updates per ArrayCamera's sub-camera
	
					if ( _currentCamera !== ( _currentArrayCamera || camera ) ) {
	
						_currentCamera = ( _currentArrayCamera || camera );
	
						// lighting uniforms depend on the camera so enforce an update
						// now, in case this material supports lights - or later, when
						// the next material that does gets activated:
	
						refreshMaterial = true;		// set to true on material change
						refreshLights = true;		// remains set until update done
	
					}
	
					// load material specific uniforms
					// (shader material also gets them for the sake of genericity)
	
					if ( material.isShaderMaterial ||
						material.isMeshPhongMaterial ||
						material.isMeshStandardMaterial ||
						material.envMap ) {
	
						var uCamPos = p_uniforms.map.cameraPosition;
	
						if ( uCamPos !== undefined ) {
	
							uCamPos.setValue( _gl,
								_vector3.setFromMatrixPosition( camera.matrixWorld ) );
	
						}
	
					}
	
					if ( material.isMeshPhongMaterial ||
						material.isMeshLambertMaterial ||
						material.isMeshBasicMaterial ||
						material.isMeshStandardMaterial ||
						material.isShaderMaterial ||
						material.skinning ) {
	
						p_uniforms.setValue( _gl, 'viewMatrix', camera.matrixWorldInverse );
	
					}
	
				}
	
				// skinning uniforms must be set even if material didn't change
				// auto-setting of texture unit for bone texture must go before other textures
				// not sure why, but otherwise weird things happen
	
				if ( material.skinning ) {
	
					p_uniforms.setOptional( _gl, object, 'bindMatrix' );
					p_uniforms.setOptional( _gl, object, 'bindMatrixInverse' );
	
					var skeleton = object.skeleton;
	
					if ( skeleton ) {
	
						var bones = skeleton.bones;
	
						if ( capabilities.floatVertexTextures ) {
	
							if ( skeleton.boneTexture === undefined ) {
	
								// layout (1 matrix = 4 pixels)
								//      RGBA RGBA RGBA RGBA (=> column1, column2, column3, column4)
								//  with  8x8  pixel texture max   16 bones * 4 pixels =  (8 * 8)
								//       16x16 pixel texture max   64 bones * 4 pixels = (16 * 16)
								//       32x32 pixel texture max  256 bones * 4 pixels = (32 * 32)
								//       64x64 pixel texture max 1024 bones * 4 pixels = (64 * 64)
	
	
								var size = Math.sqrt( bones.length * 4 ); // 4 pixels needed for 1 matrix
								size = _Math.ceilPowerOfTwo( size );
								size = Math.max( size, 4 );
	
								var boneMatrices = new Float32Array( size * size * 4 ); // 4 floats per RGBA pixel
								boneMatrices.set( skeleton.boneMatrices ); // copy current values
	
								var boneTexture = new DataTexture( boneMatrices, size, size, RGBAFormat, FloatType );
	
								skeleton.boneMatrices = boneMatrices;
								skeleton.boneTexture = boneTexture;
								skeleton.boneTextureSize = size;
	
							}
	
							p_uniforms.setValue( _gl, 'boneTexture', skeleton.boneTexture );
							p_uniforms.setValue( _gl, 'boneTextureSize', skeleton.boneTextureSize );
	
						} else {
	
							p_uniforms.setOptional( _gl, skeleton, 'boneMatrices' );
	
						}
	
					}
	
				}
	
				if ( refreshMaterial ) {
	
					p_uniforms.setValue( _gl, 'toneMappingExposure', _this.toneMappingExposure );
					p_uniforms.setValue( _gl, 'toneMappingWhitePoint', _this.toneMappingWhitePoint );
	
					if ( material.lights ) {
	
						// the current material requires lighting info
	
						// note: all lighting uniforms are always set correctly
						// they simply reference the renderer's state for their
						// values
						//
						// use the current material's .needsUpdate flags to set
						// the GL state when required
	
						markUniformsLightsNeedsUpdate( m_uniforms, refreshLights );
	
					}
	
					// refresh uniforms common to several materials
	
					if ( fog && material.fog ) {
	
						refreshUniformsFog( m_uniforms, fog );
	
					}
	
					if ( material.isMeshBasicMaterial ) {
	
						refreshUniformsCommon( m_uniforms, material );
	
					} else if ( material.isMeshLambertMaterial ) {
	
						refreshUniformsCommon( m_uniforms, material );
						refreshUniformsLambert( m_uniforms, material );
	
					} else if ( material.isMeshPhongMaterial ) {
	
						refreshUniformsCommon( m_uniforms, material );
	
						if ( material.isMeshToonMaterial ) {
	
							refreshUniformsToon( m_uniforms, material );
	
						} else {
	
							refreshUniformsPhong( m_uniforms, material );
	
						}
	
					} else if ( material.isMeshStandardMaterial ) {
	
						refreshUniformsCommon( m_uniforms, material );
	
						if ( material.isMeshPhysicalMaterial ) {
	
							refreshUniformsPhysical( m_uniforms, material );
	
						} else {
	
							refreshUniformsStandard( m_uniforms, material );
	
						}
	
					} else if ( material.isMeshDepthMaterial ) {
	
						refreshUniformsCommon( m_uniforms, material );
						refreshUniformsDepth( m_uniforms, material );
	
					} else if ( material.isMeshDistanceMaterial ) {
	
						refreshUniformsCommon( m_uniforms, material );
						refreshUniformsDistance( m_uniforms, material );
	
					} else if ( material.isMeshNormalMaterial ) {
	
						refreshUniformsCommon( m_uniforms, material );
						refreshUniformsNormal( m_uniforms, material );
	
					} else if ( material.isLineBasicMaterial ) {
	
						refreshUniformsLine( m_uniforms, material );
	
						if ( material.isLineDashedMaterial ) {
	
							refreshUniformsDash( m_uniforms, material );
	
						}
	
					} else if ( material.isPointsMaterial ) {
	
						refreshUniformsPoints( m_uniforms, material );
	
					} else if ( material.isShadowMaterial ) {
	
						m_uniforms.color.value = material.color;
						m_uniforms.opacity.value = material.opacity;
	
					}
	
					// RectAreaLight Texture
					// TODO (mrdoob): Find a nicer implementation
	
					if ( m_uniforms.ltcMat !== undefined ) m_uniforms.ltcMat.value = UniformsLib.LTC_MAT_TEXTURE;
					if ( m_uniforms.ltcMag !== undefined ) m_uniforms.ltcMag.value = UniformsLib.LTC_MAG_TEXTURE;
	
					WebGLUniforms.upload(
						_gl, materialProperties.uniformsList, m_uniforms, _this );
	
				}
	
	
				// common matrices
	
				p_uniforms.setValue( _gl, 'modelViewMatrix', object.modelViewMatrix );
				p_uniforms.setValue( _gl, 'normalMatrix', object.normalMatrix );
				p_uniforms.setValue( _gl, 'modelMatrix', object.matrixWorld );
	
				return program;
	
			}
	
			// Uniforms (refresh uniforms objects)
	
			function refreshUniformsCommon( uniforms, material ) {
	
				uniforms.opacity.value = material.opacity;
	
				if ( material.color ) {
	
					uniforms.diffuse.value = material.color;
	
				}
	
				if ( material.emissive ) {
	
					uniforms.emissive.value.copy( material.emissive ).multiplyScalar( material.emissiveIntensity );
	
				}
	
				if ( material.map ) {
	
					uniforms.map.value = material.map;
	
				}
	
				if ( material.alphaMap ) {
	
					uniforms.alphaMap.value = material.alphaMap;
	
				}
	
				if ( material.specularMap ) {
	
					uniforms.specularMap.value = material.specularMap;
	
				}
	
				if ( material.envMap ) {
	
					uniforms.envMap.value = material.envMap;
	
					// don't flip CubeTexture envMaps, flip everything else:
					//  WebGLRenderTargetCube will be flipped for backwards compatibility
					//  WebGLRenderTargetCube.texture will be flipped because it's a Texture and NOT a CubeTexture
					// this check must be handled differently, or removed entirely, if WebGLRenderTargetCube uses a CubeTexture in the future
					uniforms.flipEnvMap.value = ( ! ( material.envMap && material.envMap.isCubeTexture ) ) ? 1 : - 1;
	
					uniforms.reflectivity.value = material.reflectivity;
					uniforms.refractionRatio.value = material.refractionRatio;
	
				}
	
				if ( material.lightMap ) {
	
					uniforms.lightMap.value = material.lightMap;
					uniforms.lightMapIntensity.value = material.lightMapIntensity;
	
				}
	
				if ( material.aoMap ) {
	
					uniforms.aoMap.value = material.aoMap;
					uniforms.aoMapIntensity.value = material.aoMapIntensity;
	
				}
	
				// uv repeat and offset setting priorities
				// 1. color map
				// 2. specular map
				// 3. normal map
				// 4. bump map
				// 5. alpha map
				// 6. emissive map
	
				var uvScaleMap;
	
				if ( material.map ) {
	
					uvScaleMap = material.map;
	
				} else if ( material.specularMap ) {
	
					uvScaleMap = material.specularMap;
	
				} else if ( material.displacementMap ) {
	
					uvScaleMap = material.displacementMap;
	
				} else if ( material.normalMap ) {
	
					uvScaleMap = material.normalMap;
	
				} else if ( material.bumpMap ) {
	
					uvScaleMap = material.bumpMap;
	
				} else if ( material.roughnessMap ) {
	
					uvScaleMap = material.roughnessMap;
	
				} else if ( material.metalnessMap ) {
	
					uvScaleMap = material.metalnessMap;
	
				} else if ( material.alphaMap ) {
	
					uvScaleMap = material.alphaMap;
	
				} else if ( material.emissiveMap ) {
	
					uvScaleMap = material.emissiveMap;
	
				}
	
				if ( uvScaleMap !== undefined ) {
	
					// backwards compatibility
					if ( uvScaleMap.isWebGLRenderTarget ) {
	
						uvScaleMap = uvScaleMap.texture;
	
					}
	
					if ( uvScaleMap.matrixAutoUpdate === true ) {
	
						var offset = uvScaleMap.offset;
						var repeat = uvScaleMap.repeat;
						var rotation = uvScaleMap.rotation;
						var center = uvScaleMap.center;
	
						uvScaleMap.matrix.setUvTransform( offset.x, offset.y, repeat.x, repeat.y, rotation, center.x, center.y );
	
					}
	
					uniforms.uvTransform.value.copy( uvScaleMap.matrix );
	
				}
	
			}
	
			function refreshUniformsLine( uniforms, material ) {
	
				uniforms.diffuse.value = material.color;
				uniforms.opacity.value = material.opacity;
	
			}
	
			function refreshUniformsDash( uniforms, material ) {
	
				uniforms.dashSize.value = material.dashSize;
				uniforms.totalSize.value = material.dashSize + material.gapSize;
				uniforms.scale.value = material.scale;
	
			}
	
			function refreshUniformsPoints( uniforms, material ) {
	
				uniforms.diffuse.value = material.color;
				uniforms.opacity.value = material.opacity;
				uniforms.size.value = material.size * _pixelRatio;
				uniforms.scale.value = _height * 0.5;
	
				uniforms.map.value = material.map;
	
				if ( material.map !== null ) {
	
					if ( material.map.matrixAutoUpdate === true ) {
	
						var offset = material.map.offset;
						var repeat = material.map.repeat;
						var rotation = material.map.rotation;
						var center = material.map.center;
	
						material.map.matrix.setUvTransform( offset.x, offset.y, repeat.x, repeat.y, rotation, center.x, center.y );
	
					}
	
					uniforms.uvTransform.value.copy( material.map.matrix );
	
				}
	
			}
	
			function refreshUniformsFog( uniforms, fog ) {
	
				uniforms.fogColor.value = fog.color;
	
				if ( fog.isFog ) {
	
					uniforms.fogNear.value = fog.near;
					uniforms.fogFar.value = fog.far;
	
				} else if ( fog.isFogExp2 ) {
	
					uniforms.fogDensity.value = fog.density;
	
				}
	
			}
	
			function refreshUniformsLambert( uniforms, material ) {
	
				if ( material.emissiveMap ) {
	
					uniforms.emissiveMap.value = material.emissiveMap;
	
				}
	
			}
	
			function refreshUniformsPhong( uniforms, material ) {
	
				uniforms.specular.value = material.specular;
				uniforms.shininess.value = Math.max( material.shininess, 1e-4 ); // to prevent pow( 0.0, 0.0 )
	
				if ( material.emissiveMap ) {
	
					uniforms.emissiveMap.value = material.emissiveMap;
	
				}
	
				if ( material.bumpMap ) {
	
					uniforms.bumpMap.value = material.bumpMap;
					uniforms.bumpScale.value = material.bumpScale;
	
				}
	
				if ( material.normalMap ) {
	
					uniforms.normalMap.value = material.normalMap;
					uniforms.normalScale.value.copy( material.normalScale );
	
				}
	
				if ( material.displacementMap ) {
	
					uniforms.displacementMap.value = material.displacementMap;
					uniforms.displacementScale.value = material.displacementScale;
					uniforms.displacementBias.value = material.displacementBias;
	
				}
	
			}
	
			function refreshUniformsToon( uniforms, material ) {
	
				refreshUniformsPhong( uniforms, material );
	
				if ( material.gradientMap ) {
	
					uniforms.gradientMap.value = material.gradientMap;
	
				}
	
			}
	
			function refreshUniformsStandard( uniforms, material ) {
	
				uniforms.roughness.value = material.roughness;
				uniforms.metalness.value = material.metalness;
	
				if ( material.roughnessMap ) {
	
					uniforms.roughnessMap.value = material.roughnessMap;
	
				}
	
				if ( material.metalnessMap ) {
	
					uniforms.metalnessMap.value = material.metalnessMap;
	
				}
	
				if ( material.emissiveMap ) {
	
					uniforms.emissiveMap.value = material.emissiveMap;
	
				}
	
				if ( material.bumpMap ) {
	
					uniforms.bumpMap.value = material.bumpMap;
					uniforms.bumpScale.value = material.bumpScale;
	
				}
	
				if ( material.normalMap ) {
	
					uniforms.normalMap.value = material.normalMap;
					uniforms.normalScale.value.copy( material.normalScale );
	
				}
	
				if ( material.displacementMap ) {
	
					uniforms.displacementMap.value = material.displacementMap;
					uniforms.displacementScale.value = material.displacementScale;
					uniforms.displacementBias.value = material.displacementBias;
	
				}
	
				if ( material.envMap ) {
	
					//uniforms.envMap.value = material.envMap; // part of uniforms common
					uniforms.envMapIntensity.value = material.envMapIntensity;
	
				}
	
			}
	
			function refreshUniformsPhysical( uniforms, material ) {
	
				uniforms.clearCoat.value = material.clearCoat;
				uniforms.clearCoatRoughness.value = material.clearCoatRoughness;
	
				refreshUniformsStandard( uniforms, material );
	
			}
	
			function refreshUniformsDepth( uniforms, material ) {
	
				if ( material.displacementMap ) {
	
					uniforms.displacementMap.value = material.displacementMap;
					uniforms.displacementScale.value = material.displacementScale;
					uniforms.displacementBias.value = material.displacementBias;
	
				}
	
			}
	
			function refreshUniformsDistance( uniforms, material ) {
	
				if ( material.displacementMap ) {
	
					uniforms.displacementMap.value = material.displacementMap;
					uniforms.displacementScale.value = material.displacementScale;
					uniforms.displacementBias.value = material.displacementBias;
	
				}
	
				uniforms.referencePosition.value.copy( material.referencePosition );
				uniforms.nearDistance.value = material.nearDistance;
				uniforms.farDistance.value = material.farDistance;
	
			}
	
			function refreshUniformsNormal( uniforms, material ) {
	
				if ( material.bumpMap ) {
	
					uniforms.bumpMap.value = material.bumpMap;
					uniforms.bumpScale.value = material.bumpScale;
	
				}
	
				if ( material.normalMap ) {
	
					uniforms.normalMap.value = material.normalMap;
					uniforms.normalScale.value.copy( material.normalScale );
	
				}
	
				if ( material.displacementMap ) {
	
					uniforms.displacementMap.value = material.displacementMap;
					uniforms.displacementScale.value = material.displacementScale;
					uniforms.displacementBias.value = material.displacementBias;
	
				}
	
			}
	
			// If uniforms are marked as clean, they don't need to be loaded to the GPU.
	
			function markUniformsLightsNeedsUpdate( uniforms, value ) {
	
				uniforms.ambientLightColor.needsUpdate = value;
	
				uniforms.directionalLights.needsUpdate = value;
				uniforms.pointLights.needsUpdate = value;
				uniforms.spotLights.needsUpdate = value;
				uniforms.rectAreaLights.needsUpdate = value;
				uniforms.hemisphereLights.needsUpdate = value;
	
			}
	
			// GL state setting
	
			this.setFaceCulling = function ( cullFace, frontFaceDirection ) {
	
				state.setCullFace( cullFace );
				state.setFlipSided( frontFaceDirection === FrontFaceDirectionCW );
	
			};
	
			// Textures
	
			function allocTextureUnit() {
	
				var textureUnit = _usedTextureUnits;
	
				if ( textureUnit >= capabilities.maxTextures ) {
	
					console.warn( 'THREE.WebGLRenderer: Trying to use ' + textureUnit + ' texture units while this GPU supports only ' + capabilities.maxTextures );
	
				}
	
				_usedTextureUnits += 1;
	
				return textureUnit;
	
			}
	
			this.allocTextureUnit = allocTextureUnit;
	
			// this.setTexture2D = setTexture2D;
			this.setTexture2D = ( function () {
	
				var warned = false;
	
				// backwards compatibility: peel texture.texture
				return function setTexture2D( texture, slot ) {
	
					if ( texture && texture.isWebGLRenderTarget ) {
	
						if ( ! warned ) {
	
							console.warn( "THREE.WebGLRenderer.setTexture2D: don't use render targets as textures. Use their .texture property instead." );
							warned = true;
	
						}
	
						texture = texture.texture;
	
					}
	
					textures.setTexture2D( texture, slot );
	
				};
	
			}() );
	
			this.setTexture = ( function () {
	
				var warned = false;
	
				return function setTexture( texture, slot ) {
	
					if ( ! warned ) {
	
						console.warn( "THREE.WebGLRenderer: .setTexture is deprecated, use setTexture2D instead." );
						warned = true;
	
					}
	
					textures.setTexture2D( texture, slot );
	
				};
	
			}() );
	
			this.setTextureCube = ( function () {
	
				var warned = false;
	
				return function setTextureCube( texture, slot ) {
	
					// backwards compatibility: peel texture.texture
					if ( texture && texture.isWebGLRenderTargetCube ) {
	
						if ( ! warned ) {
	
							console.warn( "THREE.WebGLRenderer.setTextureCube: don't use cube render targets as textures. Use their .texture property instead." );
							warned = true;
	
						}
	
						texture = texture.texture;
	
					}
	
					// currently relying on the fact that WebGLRenderTargetCube.texture is a Texture and NOT a CubeTexture
					// TODO: unify these code paths
					if ( ( texture && texture.isCubeTexture ) ||
						( Array.isArray( texture.image ) && texture.image.length === 6 ) ) {
	
						// CompressedTexture can have Array in image :/
	
						// this function alone should take care of cube textures
						textures.setTextureCube( texture, slot );
	
					} else {
	
						// assumed: texture property of THREE.WebGLRenderTargetCube
	
						textures.setTextureCubeDynamic( texture, slot );
	
					}
	
				};
	
			}() );
	
			this.getRenderTarget = function () {
	
				return _currentRenderTarget;
	
			};
	
			this.setRenderTarget = function ( renderTarget ) {
	
				_currentRenderTarget = renderTarget;
	
				if ( renderTarget && properties.get( renderTarget ).__webglFramebuffer === undefined ) {
	
					textures.setupRenderTarget( renderTarget );
	
				}
	
				var framebuffer = null;
				var isCube = false;
	
				if ( renderTarget ) {
	
					var __webglFramebuffer = properties.get( renderTarget ).__webglFramebuffer;
	
					if ( renderTarget.isWebGLRenderTargetCube ) {
	
						framebuffer = __webglFramebuffer[ renderTarget.activeCubeFace ];
						isCube = true;
	
					} else {
	
						framebuffer = __webglFramebuffer;
	
					}
	
					_currentViewport.copy( renderTarget.viewport );
					_currentScissor.copy( renderTarget.scissor );
					_currentScissorTest = renderTarget.scissorTest;
	
				} else {
	
					_currentViewport.copy( _viewport ).multiplyScalar( _pixelRatio );
					_currentScissor.copy( _scissor ).multiplyScalar( _pixelRatio );
					_currentScissorTest = _scissorTest;
	
				}
	
				if ( _currentFramebuffer !== framebuffer ) {
	
					_gl.bindFramebuffer( _gl.FRAMEBUFFER, framebuffer );
					_currentFramebuffer = framebuffer;
	
				}
	
				state.viewport( _currentViewport );
				state.scissor( _currentScissor );
				state.setScissorTest( _currentScissorTest );
	
				if ( isCube ) {
	
					var textureProperties = properties.get( renderTarget.texture );
					_gl.framebufferTexture2D( _gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + renderTarget.activeCubeFace, textureProperties.__webglTexture, renderTarget.activeMipMapLevel );
	
				}
	
			};
	
			this.readRenderTargetPixels = function ( renderTarget, x, y, width, height, buffer ) {
	
				if ( ! ( renderTarget && renderTarget.isWebGLRenderTarget ) ) {
	
					console.error( 'THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.' );
					return;
	
				}
	
				var framebuffer = properties.get( renderTarget ).__webglFramebuffer;
	
				if ( framebuffer ) {
	
					var restore = false;
	
					if ( framebuffer !== _currentFramebuffer ) {
	
						_gl.bindFramebuffer( _gl.FRAMEBUFFER, framebuffer );
	
						restore = true;
	
					}
	
					try {
	
						var texture = renderTarget.texture;
						var textureFormat = texture.format;
						var textureType = texture.type;
	
						if ( textureFormat !== RGBAFormat && utils.convert( textureFormat ) !== _gl.getParameter( _gl.IMPLEMENTATION_COLOR_READ_FORMAT ) ) {
	
							console.error( 'THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.' );
							return;
	
						}
	
						if ( textureType !== UnsignedByteType && utils.convert( textureType ) !== _gl.getParameter( _gl.IMPLEMENTATION_COLOR_READ_TYPE ) && // IE11, Edge and Chrome Mac < 52 (#9513)
							! ( textureType === FloatType && ( extensions.get( 'OES_texture_float' ) || extensions.get( 'WEBGL_color_buffer_float' ) ) ) && // Chrome Mac >= 52 and Firefox
							! ( textureType === HalfFloatType && extensions.get( 'EXT_color_buffer_half_float' ) ) ) {
	
							console.error( 'THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.' );
							return;
	
						}
	
						if ( _gl.checkFramebufferStatus( _gl.FRAMEBUFFER ) === _gl.FRAMEBUFFER_COMPLETE ) {
	
							// the following if statement ensures valid read requests (no out-of-bounds pixels, see #8604)
	
							if ( ( x >= 0 && x <= ( renderTarget.width - width ) ) && ( y >= 0 && y <= ( renderTarget.height - height ) ) ) {
	
								_gl.readPixels( x, y, width, height, utils.convert( textureFormat ), utils.convert( textureType ), buffer );
	
							}
	
						} else {
	
							console.error( 'THREE.WebGLRenderer.readRenderTargetPixels: readPixels from renderTarget failed. Framebuffer not complete.' );
	
						}
	
					} finally {
	
						if ( restore ) {
	
							_gl.bindFramebuffer( _gl.FRAMEBUFFER, _currentFramebuffer );
	
						}
	
					}
	
				}
	
			};
	
		}
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author alteredq / http://alteredqualia.com/
		 */
	
		function FogExp2( color, density ) {
	
			this.name = '';
	
			this.color = new Color( color );
			this.density = ( density !== undefined ) ? density : 0.00025;
	
		}
	
		FogExp2.prototype.isFogExp2 = true;
	
		FogExp2.prototype.clone = function () {
	
			return new FogExp2( this.color.getHex(), this.density );
	
		};
	
		FogExp2.prototype.toJSON = function ( /* meta */ ) {
	
			return {
				type: 'FogExp2',
				color: this.color.getHex(),
				density: this.density
			};
	
		};
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author alteredq / http://alteredqualia.com/
		 */
	
		function Fog( color, near, far ) {
	
			this.name = '';
	
			this.color = new Color( color );
	
			this.near = ( near !== undefined ) ? near : 1;
			this.far = ( far !== undefined ) ? far : 1000;
	
		}
	
		Fog.prototype.isFog = true;
	
		Fog.prototype.clone = function () {
	
			return new Fog( this.color.getHex(), this.near, this.far );
	
		};
	
		Fog.prototype.toJSON = function ( /* meta */ ) {
	
			return {
				type: 'Fog',
				color: this.color.getHex(),
				near: this.near,
				far: this.far
			};
	
		};
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function Scene() {
	
			Object3D.call( this );
	
			this.type = 'Scene';
	
			this.background = null;
			this.fog = null;
			this.overrideMaterial = null;
	
			this.autoUpdate = true; // checked by the renderer
	
		}
	
		Scene.prototype = Object.assign( Object.create( Object3D.prototype ), {
	
			constructor: Scene,
	
			copy: function ( source, recursive ) {
	
				Object3D.prototype.copy.call( this, source, recursive );
	
				if ( source.background !== null ) this.background = source.background.clone();
				if ( source.fog !== null ) this.fog = source.fog.clone();
				if ( source.overrideMaterial !== null ) this.overrideMaterial = source.overrideMaterial.clone();
	
				this.autoUpdate = source.autoUpdate;
				this.matrixAutoUpdate = source.matrixAutoUpdate;
	
				return this;
	
			},
	
			toJSON: function ( meta ) {
	
				var data = Object3D.prototype.toJSON.call( this, meta );
	
				if ( this.background !== null ) data.object.background = this.background.toJSON( meta );
				if ( this.fog !== null ) data.object.fog = this.fog.toJSON();
	
				return data;
	
			}
	
		} );
	
		/**
		 * @author mikael emtinger / http://gomo.se/
		 * @author alteredq / http://alteredqualia.com/
		 */
	
		function LensFlare( texture, size, distance, blending, color ) {
	
			Object3D.call( this );
	
			this.lensFlares = [];
	
			this.positionScreen = new Vector3();
			this.customUpdateCallback = undefined;
	
			if ( texture !== undefined ) {
	
				this.add( texture, size, distance, blending, color );
	
			}
	
		}
	
		LensFlare.prototype = Object.assign( Object.create( Object3D.prototype ), {
	
			constructor: LensFlare,
	
			isLensFlare: true,
	
			copy: function ( source ) {
	
				Object3D.prototype.copy.call( this, source );
	
				this.positionScreen.copy( source.positionScreen );
				this.customUpdateCallback = source.customUpdateCallback;
	
				for ( var i = 0, l = source.lensFlares.length; i < l; i ++ ) {
	
					this.lensFlares.push( source.lensFlares[ i ] );
	
				}
	
				return this;
	
			},
	
			add: function ( texture, size, distance, blending, color, opacity ) {
	
				if ( size === undefined ) size = - 1;
				if ( distance === undefined ) distance = 0;
				if ( opacity === undefined ) opacity = 1;
				if ( color === undefined ) color = new Color( 0xffffff );
				if ( blending === undefined ) blending = NormalBlending;
	
				distance = Math.min( distance, Math.max( 0, distance ) );
	
				this.lensFlares.push( {
					texture: texture,	// THREE.Texture
					size: size, 		// size in pixels (-1 = use texture.width)
					distance: distance, 	// distance (0-1) from light source (0=at light source)
					x: 0, y: 0, z: 0,	// screen position (-1 => 1) z = 0 is in front z = 1 is back
					scale: 1, 		// scale
					rotation: 0, 		// rotation
					opacity: opacity,	// opacity
					color: color,		// color
					blending: blending	// blending
				} );
	
			},
	
			/*
			 * Update lens flares update positions on all flares based on the screen position
			 * Set myLensFlare.customUpdateCallback to alter the flares in your project specific way.
			 */
	
			updateLensFlares: function () {
	
				var f, fl = this.lensFlares.length;
				var flare;
				var vecX = - this.positionScreen.x * 2;
				var vecY = - this.positionScreen.y * 2;
	
				for ( f = 0; f < fl; f ++ ) {
	
					flare = this.lensFlares[ f ];
	
					flare.x = this.positionScreen.x + vecX * flare.distance;
					flare.y = this.positionScreen.y + vecY * flare.distance;
	
					flare.wantedRotation = flare.x * Math.PI * 0.25;
					flare.rotation += ( flare.wantedRotation - flare.rotation ) * 0.25;
	
				}
	
			}
	
		} );
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 *
		 * parameters = {
		 *  color: <hex>,
		 *  opacity: <float>,
		 *  map: new THREE.Texture( <Image> ),
		 *
		 *	uvOffset: new THREE.Vector2(),
		 *	uvScale: new THREE.Vector2()
		 * }
		 */
	
		function SpriteMaterial( parameters ) {
	
			Material.call( this );
	
			this.type = 'SpriteMaterial';
	
			this.color = new Color( 0xffffff );
			this.map = null;
	
			this.rotation = 0;
	
			this.fog = false;
			this.lights = false;
	
			this.setValues( parameters );
	
		}
	
		SpriteMaterial.prototype = Object.create( Material.prototype );
		SpriteMaterial.prototype.constructor = SpriteMaterial;
		SpriteMaterial.prototype.isSpriteMaterial = true;
	
		SpriteMaterial.prototype.copy = function ( source ) {
	
			Material.prototype.copy.call( this, source );
	
			this.color.copy( source.color );
			this.map = source.map;
	
			this.rotation = source.rotation;
	
			return this;
	
		};
	
		/**
		 * @author mikael emtinger / http://gomo.se/
		 * @author alteredq / http://alteredqualia.com/
		 */
	
		function Sprite( material ) {
	
			Object3D.call( this );
	
			this.type = 'Sprite';
	
			this.material = ( material !== undefined ) ? material : new SpriteMaterial();
	
		}
	
		Sprite.prototype = Object.assign( Object.create( Object3D.prototype ), {
	
			constructor: Sprite,
	
			isSprite: true,
	
			raycast: ( function () {
	
				var intersectPoint = new Vector3();
				var worldPosition = new Vector3();
				var worldScale = new Vector3();
	
				return function raycast( raycaster, intersects ) {
	
					worldPosition.setFromMatrixPosition( this.matrixWorld );
					raycaster.ray.closestPointToPoint( worldPosition, intersectPoint );
	
					worldScale.setFromMatrixScale( this.matrixWorld );
					var guessSizeSq = worldScale.x * worldScale.y / 4;
	
					if ( worldPosition.distanceToSquared( intersectPoint ) > guessSizeSq ) return;
	
					var distance = raycaster.ray.origin.distanceTo( intersectPoint );
	
					if ( distance < raycaster.near || distance > raycaster.far ) return;
	
					intersects.push( {
	
						distance: distance,
						point: intersectPoint.clone(),
						face: null,
						object: this
	
					} );
	
				};
	
			}() ),
	
			clone: function () {
	
				return new this.constructor( this.material ).copy( this );
	
			}
	
		} );
	
		/**
		 * @author mikael emtinger / http://gomo.se/
		 * @author alteredq / http://alteredqualia.com/
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function LOD() {
	
			Object3D.call( this );
	
			this.type = 'LOD';
	
			Object.defineProperties( this, {
				levels: {
					enumerable: true,
					value: []
				}
			} );
	
		}
	
		LOD.prototype = Object.assign( Object.create( Object3D.prototype ), {
	
			constructor: LOD,
	
			copy: function ( source ) {
	
				Object3D.prototype.copy.call( this, source, false );
	
				var levels = source.levels;
	
				for ( var i = 0, l = levels.length; i < l; i ++ ) {
	
					var level = levels[ i ];
	
					this.addLevel( level.object.clone(), level.distance );
	
				}
	
				return this;
	
			},
	
			addLevel: function ( object, distance ) {
	
				if ( distance === undefined ) distance = 0;
	
				distance = Math.abs( distance );
	
				var levels = this.levels;
	
				for ( var l = 0; l < levels.length; l ++ ) {
	
					if ( distance < levels[ l ].distance ) {
	
						break;
	
					}
	
				}
	
				levels.splice( l, 0, { distance: distance, object: object } );
	
				this.add( object );
	
			},
	
			getObjectForDistance: function ( distance ) {
	
				var levels = this.levels;
	
				for ( var i = 1, l = levels.length; i < l; i ++ ) {
	
					if ( distance < levels[ i ].distance ) {
	
						break;
	
					}
	
				}
	
				return levels[ i - 1 ].object;
	
			},
	
			raycast: ( function () {
	
				var matrixPosition = new Vector3();
	
				return function raycast( raycaster, intersects ) {
	
					matrixPosition.setFromMatrixPosition( this.matrixWorld );
	
					var distance = raycaster.ray.origin.distanceTo( matrixPosition );
	
					this.getObjectForDistance( distance ).raycast( raycaster, intersects );
	
				};
	
			}() ),
	
			update: function () {
	
				var v1 = new Vector3();
				var v2 = new Vector3();
	
				return function update( camera ) {
	
					var levels = this.levels;
	
					if ( levels.length > 1 ) {
	
						v1.setFromMatrixPosition( camera.matrixWorld );
						v2.setFromMatrixPosition( this.matrixWorld );
	
						var distance = v1.distanceTo( v2 );
	
						levels[ 0 ].object.visible = true;
	
						for ( var i = 1, l = levels.length; i < l; i ++ ) {
	
							if ( distance >= levels[ i ].distance ) {
	
								levels[ i - 1 ].object.visible = false;
								levels[ i ].object.visible = true;
	
							} else {
	
								break;
	
							}
	
						}
	
						for ( ; i < l; i ++ ) {
	
							levels[ i ].object.visible = false;
	
						}
	
					}
	
				};
	
			}(),
	
			toJSON: function ( meta ) {
	
				var data = Object3D.prototype.toJSON.call( this, meta );
	
				data.object.levels = [];
	
				var levels = this.levels;
	
				for ( var i = 0, l = levels.length; i < l; i ++ ) {
	
					var level = levels[ i ];
	
					data.object.levels.push( {
						object: level.object.uuid,
						distance: level.distance
					} );
	
				}
	
				return data;
	
			}
	
		} );
	
		/**
		 * @author mikael emtinger / http://gomo.se/
		 * @author alteredq / http://alteredqualia.com/
		 * @author michael guerrero / http://realitymeltdown.com
		 * @author ikerr / http://verold.com
		 */
	
		function Skeleton( bones, boneInverses ) {
	
			// copy the bone array
	
			bones = bones || [];
	
			this.bones = bones.slice( 0 );
			this.boneMatrices = new Float32Array( this.bones.length * 16 );
	
			// use the supplied bone inverses or calculate the inverses
	
			if ( boneInverses === undefined ) {
	
				this.calculateInverses();
	
			} else {
	
				if ( this.bones.length === boneInverses.length ) {
	
					this.boneInverses = boneInverses.slice( 0 );
	
				} else {
	
					console.warn( 'THREE.Skeleton boneInverses is the wrong length.' );
	
					this.boneInverses = [];
	
					for ( var i = 0, il = this.bones.length; i < il; i ++ ) {
	
						this.boneInverses.push( new Matrix4() );
	
					}
	
				}
	
			}
	
		}
	
		Object.assign( Skeleton.prototype, {
	
			calculateInverses: function () {
	
				this.boneInverses = [];
	
				for ( var i = 0, il = this.bones.length; i < il; i ++ ) {
	
					var inverse = new Matrix4();
	
					if ( this.bones[ i ] ) {
	
						inverse.getInverse( this.bones[ i ].matrixWorld );
	
					}
	
					this.boneInverses.push( inverse );
	
				}
	
			},
	
			pose: function () {
	
				var bone, i, il;
	
				// recover the bind-time world matrices
	
				for ( i = 0, il = this.bones.length; i < il; i ++ ) {
	
					bone = this.bones[ i ];
	
					if ( bone ) {
	
						bone.matrixWorld.getInverse( this.boneInverses[ i ] );
	
					}
	
				}
	
				// compute the local matrices, positions, rotations and scales
	
				for ( i = 0, il = this.bones.length; i < il; i ++ ) {
	
					bone = this.bones[ i ];
	
					if ( bone ) {
	
						if ( bone.parent && bone.parent.isBone ) {
	
							bone.matrix.getInverse( bone.parent.matrixWorld );
							bone.matrix.multiply( bone.matrixWorld );
	
						} else {
	
							bone.matrix.copy( bone.matrixWorld );
	
						}
	
						bone.matrix.decompose( bone.position, bone.quaternion, bone.scale );
	
					}
	
				}
	
			},
	
			update: ( function () {
	
				var offsetMatrix = new Matrix4();
				var identityMatrix = new Matrix4();
	
				return function update() {
	
					var bones = this.bones;
					var boneInverses = this.boneInverses;
					var boneMatrices = this.boneMatrices;
					var boneTexture = this.boneTexture;
	
					// flatten bone matrices to array
	
					for ( var i = 0, il = bones.length; i < il; i ++ ) {
	
						// compute the offset between the current and the original transform
	
						var matrix = bones[ i ] ? bones[ i ].matrixWorld : identityMatrix;
	
						offsetMatrix.multiplyMatrices( matrix, boneInverses[ i ] );
						offsetMatrix.toArray( boneMatrices, i * 16 );
	
					}
	
					if ( boneTexture !== undefined ) {
	
						boneTexture.needsUpdate = true;
	
					}
	
				};
	
			} )(),
	
			clone: function () {
	
				return new Skeleton( this.bones, this.boneInverses );
	
			}
	
		} );
	
		/**
		 * @author mikael emtinger / http://gomo.se/
		 * @author alteredq / http://alteredqualia.com/
		 * @author ikerr / http://verold.com
		 */
	
		function Bone() {
	
			Object3D.call( this );
	
			this.type = 'Bone';
	
		}
	
		Bone.prototype = Object.assign( Object.create( Object3D.prototype ), {
	
			constructor: Bone,
	
			isBone: true
	
		} );
	
		/**
		 * @author mikael emtinger / http://gomo.se/
		 * @author alteredq / http://alteredqualia.com/
		 * @author ikerr / http://verold.com
		 */
	
		function SkinnedMesh( geometry, material ) {
	
			Mesh.call( this, geometry, material );
	
			this.type = 'SkinnedMesh';
	
			this.bindMode = 'attached';
			this.bindMatrix = new Matrix4();
			this.bindMatrixInverse = new Matrix4();
	
			var bones = this.initBones();
			var skeleton = new Skeleton( bones );
	
			this.bind( skeleton, this.matrixWorld );
	
			this.normalizeSkinWeights();
	
		}
	
		SkinnedMesh.prototype = Object.assign( Object.create( Mesh.prototype ), {
	
			constructor: SkinnedMesh,
	
			isSkinnedMesh: true,
	
			initBones: function () {
	
				var bones = [], bone, gbone;
				var i, il;
	
				if ( this.geometry && this.geometry.bones !== undefined ) {
	
					// first, create array of 'Bone' objects from geometry data
	
					for ( i = 0, il = this.geometry.bones.length; i < il; i ++ ) {
	
						gbone = this.geometry.bones[ i ];
	
						// create new 'Bone' object
	
						bone = new Bone();
						bones.push( bone );
	
						// apply values
	
						bone.name = gbone.name;
						bone.position.fromArray( gbone.pos );
						bone.quaternion.fromArray( gbone.rotq );
						if ( gbone.scl !== undefined ) bone.scale.fromArray( gbone.scl );
	
					}
	
					// second, create bone hierarchy
	
					for ( i = 0, il = this.geometry.bones.length; i < il; i ++ ) {
	
						gbone = this.geometry.bones[ i ];
	
						if ( ( gbone.parent !== - 1 ) && ( gbone.parent !== null ) && ( bones[ gbone.parent ] !== undefined ) ) {
	
							// subsequent bones in the hierarchy
	
							bones[ gbone.parent ].add( bones[ i ] );
	
						} else {
	
							// topmost bone, immediate child of the skinned mesh
	
							this.add( bones[ i ] );
	
						}
	
					}
	
				}
	
				// now the bones are part of the scene graph and children of the skinned mesh.
				// let's update the corresponding matrices
	
				this.updateMatrixWorld( true );
	
				return bones;
	
			},
	
			bind: function ( skeleton, bindMatrix ) {
	
				this.skeleton = skeleton;
	
				if ( bindMatrix === undefined ) {
	
					this.updateMatrixWorld( true );
	
					this.skeleton.calculateInverses();
	
					bindMatrix = this.matrixWorld;
	
				}
	
				this.bindMatrix.copy( bindMatrix );
				this.bindMatrixInverse.getInverse( bindMatrix );
	
			},
	
			pose: function () {
	
				this.skeleton.pose();
	
			},
	
			normalizeSkinWeights: function () {
	
				var scale, i;
	
				if ( this.geometry && this.geometry.isGeometry ) {
	
					for ( i = 0; i < this.geometry.skinWeights.length; i ++ ) {
	
						var sw = this.geometry.skinWeights[ i ];
	
						scale = 1.0 / sw.manhattanLength();
	
						if ( scale !== Infinity ) {
	
							sw.multiplyScalar( scale );
	
						} else {
	
							sw.set( 1, 0, 0, 0 ); // do something reasonable
	
						}
	
					}
	
				} else if ( this.geometry && this.geometry.isBufferGeometry ) {
	
					var vec = new Vector4();
	
					var skinWeight = this.geometry.attributes.skinWeight;
	
					for ( i = 0; i < skinWeight.count; i ++ ) {
	
						vec.x = skinWeight.getX( i );
						vec.y = skinWeight.getY( i );
						vec.z = skinWeight.getZ( i );
						vec.w = skinWeight.getW( i );
	
						scale = 1.0 / vec.manhattanLength();
	
						if ( scale !== Infinity ) {
	
							vec.multiplyScalar( scale );
	
						} else {
	
							vec.set( 1, 0, 0, 0 ); // do something reasonable
	
						}
	
						skinWeight.setXYZW( i, vec.x, vec.y, vec.z, vec.w );
	
					}
	
				}
	
			},
	
			updateMatrixWorld: function ( force ) {
	
				Mesh.prototype.updateMatrixWorld.call( this, force );
	
				if ( this.bindMode === 'attached' ) {
	
					this.bindMatrixInverse.getInverse( this.matrixWorld );
	
				} else if ( this.bindMode === 'detached' ) {
	
					this.bindMatrixInverse.getInverse( this.bindMatrix );
	
				} else {
	
					console.warn( 'THREE.SkinnedMesh: Unrecognized bindMode: ' + this.bindMode );
	
				}
	
			},
	
			clone: function () {
	
				return new this.constructor( this.geometry, this.material ).copy( this );
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author alteredq / http://alteredqualia.com/
		 *
		 * parameters = {
		 *  color: <hex>,
		 *  opacity: <float>,
		 *
		 *  linewidth: <float>,
		 *  linecap: "round",
		 *  linejoin: "round"
		 * }
		 */
	
		function LineBasicMaterial( parameters ) {
	
			Material.call( this );
	
			this.type = 'LineBasicMaterial';
	
			this.color = new Color( 0xffffff );
	
			this.linewidth = 1;
			this.linecap = 'round';
			this.linejoin = 'round';
	
			this.lights = false;
	
			this.setValues( parameters );
	
		}
	
		LineBasicMaterial.prototype = Object.create( Material.prototype );
		LineBasicMaterial.prototype.constructor = LineBasicMaterial;
	
		LineBasicMaterial.prototype.isLineBasicMaterial = true;
	
		LineBasicMaterial.prototype.copy = function ( source ) {
	
			Material.prototype.copy.call( this, source );
	
			this.color.copy( source.color );
	
			this.linewidth = source.linewidth;
			this.linecap = source.linecap;
			this.linejoin = source.linejoin;
	
			return this;
	
		};
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function Line( geometry, material, mode ) {
	
			if ( mode === 1 ) {
	
				console.warn( 'THREE.Line: parameter THREE.LinePieces no longer supported. Created THREE.LineSegments instead.' );
				return new LineSegments( geometry, material );
	
			}
	
			Object3D.call( this );
	
			this.type = 'Line';
	
			this.geometry = geometry !== undefined ? geometry : new BufferGeometry();
			this.material = material !== undefined ? material : new LineBasicMaterial( { color: Math.random() * 0xffffff } );
	
		}
	
		Line.prototype = Object.assign( Object.create( Object3D.prototype ), {
	
			constructor: Line,
	
			isLine: true,
	
			raycast: ( function () {
	
				var inverseMatrix = new Matrix4();
				var ray = new Ray();
				var sphere = new Sphere();
	
				return function raycast( raycaster, intersects ) {
	
					var precision = raycaster.linePrecision;
					var precisionSq = precision * precision;
	
					var geometry = this.geometry;
					var matrixWorld = this.matrixWorld;
	
					// Checking boundingSphere distance to ray
	
					if ( geometry.boundingSphere === null ) geometry.computeBoundingSphere();
	
					sphere.copy( geometry.boundingSphere );
					sphere.applyMatrix4( matrixWorld );
	
					if ( raycaster.ray.intersectsSphere( sphere ) === false ) return;
	
					//
	
					inverseMatrix.getInverse( matrixWorld );
					ray.copy( raycaster.ray ).applyMatrix4( inverseMatrix );
	
					var vStart = new Vector3();
					var vEnd = new Vector3();
					var interSegment = new Vector3();
					var interRay = new Vector3();
					var step = ( this && this.isLineSegments ) ? 2 : 1;
	
					if ( geometry.isBufferGeometry ) {
	
						var index = geometry.index;
						var attributes = geometry.attributes;
						var positions = attributes.position.array;
	
						if ( index !== null ) {
	
							var indices = index.array;
	
							for ( var i = 0, l = indices.length - 1; i < l; i += step ) {
	
								var a = indices[ i ];
								var b = indices[ i + 1 ];
	
								vStart.fromArray( positions, a * 3 );
								vEnd.fromArray( positions, b * 3 );
	
								var distSq = ray.distanceSqToSegment( vStart, vEnd, interRay, interSegment );
	
								if ( distSq > precisionSq ) continue;
	
								interRay.applyMatrix4( this.matrixWorld ); //Move back to world space for distance calculation
	
								var distance = raycaster.ray.origin.distanceTo( interRay );
	
								if ( distance < raycaster.near || distance > raycaster.far ) continue;
	
								intersects.push( {
	
									distance: distance,
									// What do we want? intersection point on the ray or on the segment??
									// point: raycaster.ray.at( distance ),
									point: interSegment.clone().applyMatrix4( this.matrixWorld ),
									index: i,
									face: null,
									faceIndex: null,
									object: this
	
								} );
	
							}
	
						} else {
	
							for ( var i = 0, l = positions.length / 3 - 1; i < l; i += step ) {
	
								vStart.fromArray( positions, 3 * i );
								vEnd.fromArray( positions, 3 * i + 3 );
	
								var distSq = ray.distanceSqToSegment( vStart, vEnd, interRay, interSegment );
	
								if ( distSq > precisionSq ) continue;
	
								interRay.applyMatrix4( this.matrixWorld ); //Move back to world space for distance calculation
	
								var distance = raycaster.ray.origin.distanceTo( interRay );
	
								if ( distance < raycaster.near || distance > raycaster.far ) continue;
	
								intersects.push( {
	
									distance: distance,
									// What do we want? intersection point on the ray or on the segment??
									// point: raycaster.ray.at( distance ),
									point: interSegment.clone().applyMatrix4( this.matrixWorld ),
									index: i,
									face: null,
									faceIndex: null,
									object: this
	
								} );
	
							}
	
						}
	
					} else if ( geometry.isGeometry ) {
	
						var vertices = geometry.vertices;
						var nbVertices = vertices.length;
	
						for ( var i = 0; i < nbVertices - 1; i += step ) {
	
							var distSq = ray.distanceSqToSegment( vertices[ i ], vertices[ i + 1 ], interRay, interSegment );
	
							if ( distSq > precisionSq ) continue;
	
							interRay.applyMatrix4( this.matrixWorld ); //Move back to world space for distance calculation
	
							var distance = raycaster.ray.origin.distanceTo( interRay );
	
							if ( distance < raycaster.near || distance > raycaster.far ) continue;
	
							intersects.push( {
	
								distance: distance,
								// What do we want? intersection point on the ray or on the segment??
								// point: raycaster.ray.at( distance ),
								point: interSegment.clone().applyMatrix4( this.matrixWorld ),
								index: i,
								face: null,
								faceIndex: null,
								object: this
	
							} );
	
						}
	
					}
	
				};
	
			}() ),
	
			clone: function () {
	
				return new this.constructor( this.geometry, this.material ).copy( this );
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function LineSegments( geometry, material ) {
	
			Line.call( this, geometry, material );
	
			this.type = 'LineSegments';
	
		}
	
		LineSegments.prototype = Object.assign( Object.create( Line.prototype ), {
	
			constructor: LineSegments,
	
			isLineSegments: true
	
		} );
	
		/**
		 * @author mgreter / http://github.com/mgreter
		 */
	
		function LineLoop( geometry, material ) {
	
			Line.call( this, geometry, material );
	
			this.type = 'LineLoop';
	
		}
	
		LineLoop.prototype = Object.assign( Object.create( Line.prototype ), {
	
			constructor: LineLoop,
	
			isLineLoop: true,
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author alteredq / http://alteredqualia.com/
		 *
		 * parameters = {
		 *  color: <hex>,
		 *  opacity: <float>,
		 *  map: new THREE.Texture( <Image> ),
		 *
		 *  size: <float>,
		 *  sizeAttenuation: <bool>
		 * }
		 */
	
		function PointsMaterial( parameters ) {
	
			Material.call( this );
	
			this.type = 'PointsMaterial';
	
			this.color = new Color( 0xffffff );
	
			this.map = null;
	
			this.size = 1;
			this.sizeAttenuation = true;
	
			this.lights = false;
	
			this.setValues( parameters );
	
		}
	
		PointsMaterial.prototype = Object.create( Material.prototype );
		PointsMaterial.prototype.constructor = PointsMaterial;
	
		PointsMaterial.prototype.isPointsMaterial = true;
	
		PointsMaterial.prototype.copy = function ( source ) {
	
			Material.prototype.copy.call( this, source );
	
			this.color.copy( source.color );
	
			this.map = source.map;
	
			this.size = source.size;
			this.sizeAttenuation = source.sizeAttenuation;
	
			return this;
	
		};
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 */
	
		function Points( geometry, material ) {
	
			Object3D.call( this );
	
			this.type = 'Points';
	
			this.geometry = geometry !== undefined ? geometry : new BufferGeometry();
			this.material = material !== undefined ? material : new PointsMaterial( { color: Math.random() * 0xffffff } );
	
		}
	
		Points.prototype = Object.assign( Object.create( Object3D.prototype ), {
	
			constructor: Points,
	
			isPoints: true,
	
			raycast: ( function () {
	
				var inverseMatrix = new Matrix4();
				var ray = new Ray();
				var sphere = new Sphere();
	
				return function raycast( raycaster, intersects ) {
	
					var object = this;
					var geometry = this.geometry;
					var matrixWorld = this.matrixWorld;
					var threshold = raycaster.params.Points.threshold;
	
					// Checking boundingSphere distance to ray
	
					if ( geometry.boundingSphere === null ) geometry.computeBoundingSphere();
	
					sphere.copy( geometry.boundingSphere );
					sphere.applyMatrix4( matrixWorld );
					sphere.radius += threshold;
	
					if ( raycaster.ray.intersectsSphere( sphere ) === false ) return;
	
					//
	
					inverseMatrix.getInverse( matrixWorld );
					ray.copy( raycaster.ray ).applyMatrix4( inverseMatrix );
	
					var localThreshold = threshold / ( ( this.scale.x + this.scale.y + this.scale.z ) / 3 );
					var localThresholdSq = localThreshold * localThreshold;
					var position = new Vector3();
	
					function testPoint( point, index ) {
	
						var rayPointDistanceSq = ray.distanceSqToPoint( point );
	
						if ( rayPointDistanceSq < localThresholdSq ) {
	
							var intersectPoint = ray.closestPointToPoint( point );
							intersectPoint.applyMatrix4( matrixWorld );
	
							var distance = raycaster.ray.origin.distanceTo( intersectPoint );
	
							if ( distance < raycaster.near || distance > raycaster.far ) return;
	
							intersects.push( {
	
								distance: distance,
								distanceToRay: Math.sqrt( rayPointDistanceSq ),
								point: intersectPoint.clone(),
								index: index,
								face: null,
								object: object
	
							} );
	
						}
	
					}
	
					if ( geometry.isBufferGeometry ) {
	
						var index = geometry.index;
						var attributes = geometry.attributes;
						var positions = attributes.position.array;
	
						if ( index !== null ) {
	
							var indices = index.array;
	
							for ( var i = 0, il = indices.length; i < il; i ++ ) {
	
								var a = indices[ i ];
	
								position.fromArray( positions, a * 3 );
	
								testPoint( position, a );
	
							}
	
						} else {
	
							for ( var i = 0, l = positions.length / 3; i < l; i ++ ) {
	
								position.fromArray( positions, i * 3 );
	
								testPoint( position, i );
	
							}
	
						}
	
					} else {
	
						var vertices = geometry.vertices;
	
						for ( var i = 0, l = vertices.length; i < l; i ++ ) {
	
							testPoint( vertices[ i ], i );
	
						}
	
					}
	
				};
	
			}() ),
	
			clone: function () {
	
				return new this.constructor( this.geometry, this.material ).copy( this );
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function Group() {
	
			Object3D.call( this );
	
			this.type = 'Group';
	
		}
	
		Group.prototype = Object.assign( Object.create( Object3D.prototype ), {
	
			constructor: Group,
	
			isGroup: true
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function VideoTexture( video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy ) {
	
			Texture.call( this, video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy );
	
			this.generateMipmaps = false;
	
			// Set needsUpdate when first frame is ready
	
			var scope = this;
	
			function onLoaded() {
	
				video.removeEventListener( 'loadeddata', onLoaded, false );
				scope.needsUpdate = true;
	
			}
	
			video.addEventListener( 'loadeddata', onLoaded, false );
	
		}
	
		VideoTexture.prototype = Object.assign( Object.create( Texture.prototype ), {
	
			constructor: VideoTexture,
	
			isVideoTexture: true,
	
			update: function () {
	
				var video = this.image;
	
				if ( video.readyState >= video.HAVE_CURRENT_DATA ) {
	
					this.needsUpdate = true;
	
				}
	
			}
	
		} );
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 */
	
		function CompressedTexture( mipmaps, width, height, format, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, encoding ) {
	
			Texture.call( this, null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding );
	
			this.image = { width: width, height: height };
			this.mipmaps = mipmaps;
	
			// no flipping for cube textures
			// (also flipping doesn't work for compressed textures )
	
			this.flipY = false;
	
			// can't generate mipmaps for compressed textures
			// mips must be embedded in DDS files
	
			this.generateMipmaps = false;
	
		}
	
		CompressedTexture.prototype = Object.create( Texture.prototype );
		CompressedTexture.prototype.constructor = CompressedTexture;
	
		CompressedTexture.prototype.isCompressedTexture = true;
	
		/**
		 * @author Matt DesLauriers / @mattdesl
		 * @author atix / arthursilber.de
		 */
	
		function DepthTexture( width, height, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, format ) {
	
			format = format !== undefined ? format : DepthFormat;
	
			if ( format !== DepthFormat && format !== DepthStencilFormat ) {
	
				throw new Error( 'DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat' );
	
			}
	
			if ( type === undefined && format === DepthFormat ) type = UnsignedShortType;
			if ( type === undefined && format === DepthStencilFormat ) type = UnsignedInt248Type;
	
			Texture.call( this, null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy );
	
			this.image = { width: width, height: height };
	
			this.magFilter = magFilter !== undefined ? magFilter : NearestFilter;
			this.minFilter = minFilter !== undefined ? minFilter : NearestFilter;
	
			this.flipY = false;
			this.generateMipmaps	= false;
	
		}
	
		DepthTexture.prototype = Object.create( Texture.prototype );
		DepthTexture.prototype.constructor = DepthTexture;
		DepthTexture.prototype.isDepthTexture = true;
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author Mugen87 / https://github.com/Mugen87
		 */
	
		function WireframeGeometry( geometry ) {
	
			BufferGeometry.call( this );
	
			this.type = 'WireframeGeometry';
	
			// buffer
	
			var vertices = [];
	
			// helper variables
	
			var i, j, l, o, ol;
			var edge = [ 0, 0 ], edges = {}, e, edge1, edge2;
			var key, keys = [ 'a', 'b', 'c' ];
			var vertex;
	
			// different logic for Geometry and BufferGeometry
	
			if ( geometry && geometry.isGeometry ) {
	
				// create a data structure that contains all edges without duplicates
	
				var faces = geometry.faces;
	
				for ( i = 0, l = faces.length; i < l; i ++ ) {
	
					var face = faces[ i ];
	
					for ( j = 0; j < 3; j ++ ) {
	
						edge1 = face[ keys[ j ] ];
						edge2 = face[ keys[ ( j + 1 ) % 3 ] ];
						edge[ 0 ] = Math.min( edge1, edge2 ); // sorting prevents duplicates
						edge[ 1 ] = Math.max( edge1, edge2 );
	
						key = edge[ 0 ] + ',' + edge[ 1 ];
	
						if ( edges[ key ] === undefined ) {
	
							edges[ key ] = { index1: edge[ 0 ], index2: edge[ 1 ] };
	
						}
	
					}
	
				}
	
				// generate vertices
	
				for ( key in edges ) {
	
					e = edges[ key ];
	
					vertex = geometry.vertices[ e.index1 ];
					vertices.push( vertex.x, vertex.y, vertex.z );
	
					vertex = geometry.vertices[ e.index2 ];
					vertices.push( vertex.x, vertex.y, vertex.z );
	
				}
	
			} else if ( geometry && geometry.isBufferGeometry ) {
	
				var position, indices, groups;
				var group, start, count;
				var index1, index2;
	
				vertex = new Vector3();
	
				if ( geometry.index !== null ) {
	
					// indexed BufferGeometry
	
					position = geometry.attributes.position;
					indices = geometry.index;
					groups = geometry.groups;
	
					if ( groups.length === 0 ) {
	
						groups = [ { start: 0, count: indices.count, materialIndex: 0 } ];
	
					}
	
					// create a data structure that contains all eges without duplicates
	
					for ( o = 0, ol = groups.length; o < ol; ++ o ) {
	
						group = groups[ o ];
	
						start = group.start;
						count = group.count;
	
						for ( i = start, l = ( start + count ); i < l; i += 3 ) {
	
							for ( j = 0; j < 3; j ++ ) {
	
								edge1 = indices.getX( i + j );
								edge2 = indices.getX( i + ( j + 1 ) % 3 );
								edge[ 0 ] = Math.min( edge1, edge2 ); // sorting prevents duplicates
								edge[ 1 ] = Math.max( edge1, edge2 );
	
								key = edge[ 0 ] + ',' + edge[ 1 ];
	
								if ( edges[ key ] === undefined ) {
	
									edges[ key ] = { index1: edge[ 0 ], index2: edge[ 1 ] };
	
								}
	
							}
	
						}
	
					}
	
					// generate vertices
	
					for ( key in edges ) {
	
						e = edges[ key ];
	
						vertex.fromBufferAttribute( position, e.index1 );
						vertices.push( vertex.x, vertex.y, vertex.z );
	
						vertex.fromBufferAttribute( position, e.index2 );
						vertices.push( vertex.x, vertex.y, vertex.z );
	
					}
	
				} else {
	
					// non-indexed BufferGeometry
	
					position = geometry.attributes.position;
	
					for ( i = 0, l = ( position.count / 3 ); i < l; i ++ ) {
	
						for ( j = 0; j < 3; j ++ ) {
	
							// three edges per triangle, an edge is represented as (index1, index2)
							// e.g. the first triangle has the following edges: (0,1),(1,2),(2,0)
	
							index1 = 3 * i + j;
							vertex.fromBufferAttribute( position, index1 );
							vertices.push( vertex.x, vertex.y, vertex.z );
	
							index2 = 3 * i + ( ( j + 1 ) % 3 );
							vertex.fromBufferAttribute( position, index2 );
							vertices.push( vertex.x, vertex.y, vertex.z );
	
						}
	
					}
	
				}
	
			}
	
			// build geometry
	
			this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
	
		}
	
		WireframeGeometry.prototype = Object.create( BufferGeometry.prototype );
		WireframeGeometry.prototype.constructor = WireframeGeometry;
	
		/**
		 * @author zz85 / https://github.com/zz85
		 * @author Mugen87 / https://github.com/Mugen87
		 *
		 * Parametric Surfaces Geometry
		 * based on the brilliant article by @prideout http://prideout.net/blog/?p=44
		 */
	
		// ParametricGeometry
	
		function ParametricGeometry( func, slices, stacks ) {
	
			Geometry.call( this );
	
			this.type = 'ParametricGeometry';
	
			this.parameters = {
				func: func,
				slices: slices,
				stacks: stacks
			};
	
			this.fromBufferGeometry( new ParametricBufferGeometry( func, slices, stacks ) );
			this.mergeVertices();
	
		}
	
		ParametricGeometry.prototype = Object.create( Geometry.prototype );
		ParametricGeometry.prototype.constructor = ParametricGeometry;
	
		// ParametricBufferGeometry
	
		function ParametricBufferGeometry( func, slices, stacks ) {
	
			BufferGeometry.call( this );
	
			this.type = 'ParametricBufferGeometry';
	
			this.parameters = {
				func: func,
				slices: slices,
				stacks: stacks
			};
	
			// buffers
	
			var indices = [];
			var vertices = [];
			var normals = [];
			var uvs = [];
	
			var EPS = 0.00001;
	
			var normal = new Vector3();
	
			var p0 = new Vector3(), p1 = new Vector3();
			var pu = new Vector3(), pv = new Vector3();
	
			var i, j;
	
			// generate vertices, normals and uvs
	
			var sliceCount = slices + 1;
	
			for ( i = 0; i <= stacks; i ++ ) {
	
				var v = i / stacks;
	
				for ( j = 0; j <= slices; j ++ ) {
	
					var u = j / slices;
	
					// vertex
	
					p0 = func( u, v, p0 );
					vertices.push( p0.x, p0.y, p0.z );
	
					// normal
	
					// approximate tangent vectors via finite differences
	
					if ( u - EPS >= 0 ) {
	
						p1 = func( u - EPS, v, p1 );
						pu.subVectors( p0, p1 );
	
					} else {
	
						p1 = func( u + EPS, v, p1 );
						pu.subVectors( p1, p0 );
	
					}
	
					if ( v - EPS >= 0 ) {
	
						p1 = func( u, v - EPS, p1 );
						pv.subVectors( p0, p1 );
	
					} else {
	
						p1 = func( u, v + EPS, p1 );
						pv.subVectors( p1, p0 );
	
					}
	
					// cross product of tangent vectors returns surface normal
	
					normal.crossVectors( pu, pv ).normalize();
					normals.push( normal.x, normal.y, normal.z );
	
					// uv
	
					uvs.push( u, v );
	
				}
	
			}
	
			// generate indices
	
			for ( i = 0; i < stacks; i ++ ) {
	
				for ( j = 0; j < slices; j ++ ) {
	
					var a = i * sliceCount + j;
					var b = i * sliceCount + j + 1;
					var c = ( i + 1 ) * sliceCount + j + 1;
					var d = ( i + 1 ) * sliceCount + j;
	
					// faces one and two
	
					indices.push( a, b, d );
					indices.push( b, c, d );
	
				}
	
			}
	
			// build geometry
	
			this.setIndex( indices );
			this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
			this.addAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
			this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );
	
		}
	
		ParametricBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
		ParametricBufferGeometry.prototype.constructor = ParametricBufferGeometry;
	
		/**
		 * @author clockworkgeek / https://github.com/clockworkgeek
		 * @author timothypratley / https://github.com/timothypratley
		 * @author WestLangley / http://github.com/WestLangley
		 * @author Mugen87 / https://github.com/Mugen87
		 */
	
		// PolyhedronGeometry
	
		function PolyhedronGeometry( vertices, indices, radius, detail ) {
	
			Geometry.call( this );
	
			this.type = 'PolyhedronGeometry';
	
			this.parameters = {
				vertices: vertices,
				indices: indices,
				radius: radius,
				detail: detail
			};
	
			this.fromBufferGeometry( new PolyhedronBufferGeometry( vertices, indices, radius, detail ) );
			this.mergeVertices();
	
		}
	
		PolyhedronGeometry.prototype = Object.create( Geometry.prototype );
		PolyhedronGeometry.prototype.constructor = PolyhedronGeometry;
	
		// PolyhedronBufferGeometry
	
		function PolyhedronBufferGeometry( vertices, indices, radius, detail ) {
	
			BufferGeometry.call( this );
	
			this.type = 'PolyhedronBufferGeometry';
	
			this.parameters = {
				vertices: vertices,
				indices: indices,
				radius: radius,
				detail: detail
			};
	
			radius = radius || 1;
			detail = detail || 0;
	
			// default buffer data
	
			var vertexBuffer = [];
			var uvBuffer = [];
	
			// the subdivision creates the vertex buffer data
	
			subdivide( detail );
	
			// all vertices should lie on a conceptual sphere with a given radius
	
			appplyRadius( radius );
	
			// finally, create the uv data
	
			generateUVs();
	
			// build non-indexed geometry
	
			this.addAttribute( 'position', new Float32BufferAttribute( vertexBuffer, 3 ) );
			this.addAttribute( 'normal', new Float32BufferAttribute( vertexBuffer.slice(), 3 ) );
			this.addAttribute( 'uv', new Float32BufferAttribute( uvBuffer, 2 ) );
	
			if ( detail === 0 ) {
	
				this.computeVertexNormals(); // flat normals
	
			} else {
	
				this.normalizeNormals(); // smooth normals
	
			}
	
			// helper functions
	
			function subdivide( detail ) {
	
				var a = new Vector3();
				var b = new Vector3();
				var c = new Vector3();
	
				// iterate over all faces and apply a subdivison with the given detail value
	
				for ( var i = 0; i < indices.length; i += 3 ) {
	
					// get the vertices of the face
	
					getVertexByIndex( indices[ i + 0 ], a );
					getVertexByIndex( indices[ i + 1 ], b );
					getVertexByIndex( indices[ i + 2 ], c );
	
					// perform subdivision
	
					subdivideFace( a, b, c, detail );
	
				}
	
			}
	
			function subdivideFace( a, b, c, detail ) {
	
				var cols = Math.pow( 2, detail );
	
				// we use this multidimensional array as a data structure for creating the subdivision
	
				var v = [];
	
				var i, j;
	
				// construct all of the vertices for this subdivision
	
				for ( i = 0; i <= cols; i ++ ) {
	
					v[ i ] = [];
	
					var aj = a.clone().lerp( c, i / cols );
					var bj = b.clone().lerp( c, i / cols );
	
					var rows = cols - i;
	
					for ( j = 0; j <= rows; j ++ ) {
	
						if ( j === 0 && i === cols ) {
	
							v[ i ][ j ] = aj;
	
						} else {
	
							v[ i ][ j ] = aj.clone().lerp( bj, j / rows );
	
						}
	
					}
	
				}
	
				// construct all of the faces
	
				for ( i = 0; i < cols; i ++ ) {
	
					for ( j = 0; j < 2 * ( cols - i ) - 1; j ++ ) {
	
						var k = Math.floor( j / 2 );
	
						if ( j % 2 === 0 ) {
	
							pushVertex( v[ i ][ k + 1 ] );
							pushVertex( v[ i + 1 ][ k ] );
							pushVertex( v[ i ][ k ] );
	
						} else {
	
							pushVertex( v[ i ][ k + 1 ] );
							pushVertex( v[ i + 1 ][ k + 1 ] );
							pushVertex( v[ i + 1 ][ k ] );
	
						}
	
					}
	
				}
	
			}
	
			function appplyRadius( radius ) {
	
				var vertex = new Vector3();
	
				// iterate over the entire buffer and apply the radius to each vertex
	
				for ( var i = 0; i < vertexBuffer.length; i += 3 ) {
	
					vertex.x = vertexBuffer[ i + 0 ];
					vertex.y = vertexBuffer[ i + 1 ];
					vertex.z = vertexBuffer[ i + 2 ];
	
					vertex.normalize().multiplyScalar( radius );
	
					vertexBuffer[ i + 0 ] = vertex.x;
					vertexBuffer[ i + 1 ] = vertex.y;
					vertexBuffer[ i + 2 ] = vertex.z;
	
				}
	
			}
	
			function generateUVs() {
	
				var vertex = new Vector3();
	
				for ( var i = 0; i < vertexBuffer.length; i += 3 ) {
	
					vertex.x = vertexBuffer[ i + 0 ];
					vertex.y = vertexBuffer[ i + 1 ];
					vertex.z = vertexBuffer[ i + 2 ];
	
					var u = azimuth( vertex ) / 2 / Math.PI + 0.5;
					var v = inclination( vertex ) / Math.PI + 0.5;
					uvBuffer.push( u, 1 - v );
	
				}
	
				correctUVs();
	
				correctSeam();
	
			}
	
			function correctSeam() {
	
				// handle case when face straddles the seam, see #3269
	
				for ( var i = 0; i < uvBuffer.length; i += 6 ) {
	
					// uv data of a single face
	
					var x0 = uvBuffer[ i + 0 ];
					var x1 = uvBuffer[ i + 2 ];
					var x2 = uvBuffer[ i + 4 ];
	
					var max = Math.max( x0, x1, x2 );
					var min = Math.min( x0, x1, x2 );
	
					// 0.9 is somewhat arbitrary
	
					if ( max > 0.9 && min < 0.1 ) {
	
						if ( x0 < 0.2 ) uvBuffer[ i + 0 ] += 1;
						if ( x1 < 0.2 ) uvBuffer[ i + 2 ] += 1;
						if ( x2 < 0.2 ) uvBuffer[ i + 4 ] += 1;
	
					}
	
				}
	
			}
	
			function pushVertex( vertex ) {
	
				vertexBuffer.push( vertex.x, vertex.y, vertex.z );
	
			}
	
			function getVertexByIndex( index, vertex ) {
	
				var stride = index * 3;
	
				vertex.x = vertices[ stride + 0 ];
				vertex.y = vertices[ stride + 1 ];
				vertex.z = vertices[ stride + 2 ];
	
			}
	
			function correctUVs() {
	
				var a = new Vector3();
				var b = new Vector3();
				var c = new Vector3();
	
				var centroid = new Vector3();
	
				var uvA = new Vector2();
				var uvB = new Vector2();
				var uvC = new Vector2();
	
				for ( var i = 0, j = 0; i < vertexBuffer.length; i += 9, j += 6 ) {
	
					a.set( vertexBuffer[ i + 0 ], vertexBuffer[ i + 1 ], vertexBuffer[ i + 2 ] );
					b.set( vertexBuffer[ i + 3 ], vertexBuffer[ i + 4 ], vertexBuffer[ i + 5 ] );
					c.set( vertexBuffer[ i + 6 ], vertexBuffer[ i + 7 ], vertexBuffer[ i + 8 ] );
	
					uvA.set( uvBuffer[ j + 0 ], uvBuffer[ j + 1 ] );
					uvB.set( uvBuffer[ j + 2 ], uvBuffer[ j + 3 ] );
					uvC.set( uvBuffer[ j + 4 ], uvBuffer[ j + 5 ] );
	
					centroid.copy( a ).add( b ).add( c ).divideScalar( 3 );
	
					var azi = azimuth( centroid );
	
					correctUV( uvA, j + 0, a, azi );
					correctUV( uvB, j + 2, b, azi );
					correctUV( uvC, j + 4, c, azi );
	
				}
	
			}
	
			function correctUV( uv, stride, vector, azimuth ) {
	
				if ( ( azimuth < 0 ) && ( uv.x === 1 ) ) {
	
					uvBuffer[ stride ] = uv.x - 1;
	
				}
	
				if ( ( vector.x === 0 ) && ( vector.z === 0 ) ) {
	
					uvBuffer[ stride ] = azimuth / 2 / Math.PI + 0.5;
	
				}
	
			}
	
			// Angle around the Y axis, counter-clockwise when looking from above.
	
			function azimuth( vector ) {
	
				return Math.atan2( vector.z, - vector.x );
	
			}
	
	
			// Angle above the XZ plane.
	
			function inclination( vector ) {
	
				return Math.atan2( - vector.y, Math.sqrt( ( vector.x * vector.x ) + ( vector.z * vector.z ) ) );
	
			}
	
		}
	
		PolyhedronBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
		PolyhedronBufferGeometry.prototype.constructor = PolyhedronBufferGeometry;
	
		/**
		 * @author timothypratley / https://github.com/timothypratley
		 * @author Mugen87 / https://github.com/Mugen87
		 */
	
		// TetrahedronGeometry
	
		function TetrahedronGeometry( radius, detail ) {
	
			Geometry.call( this );
	
			this.type = 'TetrahedronGeometry';
	
			this.parameters = {
				radius: radius,
				detail: detail
			};
	
			this.fromBufferGeometry( new TetrahedronBufferGeometry( radius, detail ) );
			this.mergeVertices();
	
		}
	
		TetrahedronGeometry.prototype = Object.create( Geometry.prototype );
		TetrahedronGeometry.prototype.constructor = TetrahedronGeometry;
	
		// TetrahedronBufferGeometry
	
		function TetrahedronBufferGeometry( radius, detail ) {
	
			var vertices = [
				1, 1, 1, 	- 1, - 1, 1, 	- 1, 1, - 1, 	1, - 1, - 1
			];
	
			var indices = [
				2, 1, 0, 	0, 3, 2,	1, 3, 0,	2, 3, 1
			];
	
			PolyhedronBufferGeometry.call( this, vertices, indices, radius, detail );
	
			this.type = 'TetrahedronBufferGeometry';
	
			this.parameters = {
				radius: radius,
				detail: detail
			};
	
		}
	
		TetrahedronBufferGeometry.prototype = Object.create( PolyhedronBufferGeometry.prototype );
		TetrahedronBufferGeometry.prototype.constructor = TetrahedronBufferGeometry;
	
		/**
		 * @author timothypratley / https://github.com/timothypratley
		 * @author Mugen87 / https://github.com/Mugen87
		 */
	
		// OctahedronGeometry
	
		function OctahedronGeometry( radius, detail ) {
	
			Geometry.call( this );
	
			this.type = 'OctahedronGeometry';
	
			this.parameters = {
				radius: radius,
				detail: detail
			};
	
			this.fromBufferGeometry( new OctahedronBufferGeometry( radius, detail ) );
			this.mergeVertices();
	
		}
	
		OctahedronGeometry.prototype = Object.create( Geometry.prototype );
		OctahedronGeometry.prototype.constructor = OctahedronGeometry;
	
		// OctahedronBufferGeometry
	
		function OctahedronBufferGeometry( radius, detail ) {
	
			var vertices = [
				1, 0, 0, 	- 1, 0, 0,	0, 1, 0,
				0, - 1, 0, 	0, 0, 1,	0, 0, - 1
			];
	
			var indices = [
				0, 2, 4,	0, 4, 3,	0, 3, 5,
				0, 5, 2,	1, 2, 5,	1, 5, 3,
				1, 3, 4,	1, 4, 2
			];
	
			PolyhedronBufferGeometry.call( this, vertices, indices, radius, detail );
	
			this.type = 'OctahedronBufferGeometry';
	
			this.parameters = {
				radius: radius,
				detail: detail
			};
	
		}
	
		OctahedronBufferGeometry.prototype = Object.create( PolyhedronBufferGeometry.prototype );
		OctahedronBufferGeometry.prototype.constructor = OctahedronBufferGeometry;
	
		/**
		 * @author timothypratley / https://github.com/timothypratley
		 * @author Mugen87 / https://github.com/Mugen87
		 */
	
		// IcosahedronGeometry
	
		function IcosahedronGeometry( radius, detail ) {
	
			Geometry.call( this );
	
			this.type = 'IcosahedronGeometry';
	
			this.parameters = {
				radius: radius,
				detail: detail
			};
	
			this.fromBufferGeometry( new IcosahedronBufferGeometry( radius, detail ) );
			this.mergeVertices();
	
		}
	
		IcosahedronGeometry.prototype = Object.create( Geometry.prototype );
		IcosahedronGeometry.prototype.constructor = IcosahedronGeometry;
	
		// IcosahedronBufferGeometry
	
		function IcosahedronBufferGeometry( radius, detail ) {
	
			var t = ( 1 + Math.sqrt( 5 ) ) / 2;
	
			var vertices = [
				- 1, t, 0, 	1, t, 0, 	- 1, - t, 0, 	1, - t, 0,
				 0, - 1, t, 	0, 1, t,	0, - 1, - t, 	0, 1, - t,
				 t, 0, - 1, 	t, 0, 1, 	- t, 0, - 1, 	- t, 0, 1
			];
	
			var indices = [
				 0, 11, 5, 	0, 5, 1, 	0, 1, 7, 	0, 7, 10, 	0, 10, 11,
				 1, 5, 9, 	5, 11, 4,	11, 10, 2,	10, 7, 6,	7, 1, 8,
				 3, 9, 4, 	3, 4, 2,	3, 2, 6,	3, 6, 8,	3, 8, 9,
				 4, 9, 5, 	2, 4, 11,	6, 2, 10,	8, 6, 7,	9, 8, 1
			];
	
			PolyhedronBufferGeometry.call( this, vertices, indices, radius, detail );
	
			this.type = 'IcosahedronBufferGeometry';
	
			this.parameters = {
				radius: radius,
				detail: detail
			};
	
		}
	
		IcosahedronBufferGeometry.prototype = Object.create( PolyhedronBufferGeometry.prototype );
		IcosahedronBufferGeometry.prototype.constructor = IcosahedronBufferGeometry;
	
		/**
		 * @author Abe Pazos / https://hamoid.com
		 * @author Mugen87 / https://github.com/Mugen87
		 */
	
		// DodecahedronGeometry
	
		function DodecahedronGeometry( radius, detail ) {
	
			Geometry.call( this );
	
			this.type = 'DodecahedronGeometry';
	
			this.parameters = {
				radius: radius,
				detail: detail
			};
	
			this.fromBufferGeometry( new DodecahedronBufferGeometry( radius, detail ) );
			this.mergeVertices();
	
		}
	
		DodecahedronGeometry.prototype = Object.create( Geometry.prototype );
		DodecahedronGeometry.prototype.constructor = DodecahedronGeometry;
	
		// DodecahedronBufferGeometry
	
		function DodecahedronBufferGeometry( radius, detail ) {
	
			var t = ( 1 + Math.sqrt( 5 ) ) / 2;
			var r = 1 / t;
	
			var vertices = [
	
				// (±1, ±1, ±1)
				- 1, - 1, - 1,	- 1, - 1, 1,
				- 1, 1, - 1, - 1, 1, 1,
				1, - 1, - 1, 1, - 1, 1,
				1, 1, - 1, 1, 1, 1,
	
				// (0, ±1/φ, ±φ)
				 0, - r, - t, 0, - r, t,
				 0, r, - t, 0, r, t,
	
				// (±1/φ, ±φ, 0)
				- r, - t, 0, - r, t, 0,
				 r, - t, 0, r, t, 0,
	
				// (±φ, 0, ±1/φ)
				- t, 0, - r, t, 0, - r,
				- t, 0, r, t, 0, r
			];
	
			var indices = [
				3, 11, 7, 	3, 7, 15, 	3, 15, 13,
				7, 19, 17, 	7, 17, 6, 	7, 6, 15,
				17, 4, 8, 	17, 8, 10, 	17, 10, 6,
				8, 0, 16, 	8, 16, 2, 	8, 2, 10,
				0, 12, 1, 	0, 1, 18, 	0, 18, 16,
				6, 10, 2, 	6, 2, 13, 	6, 13, 15,
				2, 16, 18, 	2, 18, 3, 	2, 3, 13,
				18, 1, 9, 	18, 9, 11, 	18, 11, 3,
				4, 14, 12, 	4, 12, 0, 	4, 0, 8,
				11, 9, 5, 	11, 5, 19, 	11, 19, 7,
				19, 5, 14, 	19, 14, 4, 	19, 4, 17,
				1, 12, 14, 	1, 14, 5, 	1, 5, 9
			];
	
			PolyhedronBufferGeometry.call( this, vertices, indices, radius, detail );
	
			this.type = 'DodecahedronBufferGeometry';
	
			this.parameters = {
				radius: radius,
				detail: detail
			};
	
		}
	
		DodecahedronBufferGeometry.prototype = Object.create( PolyhedronBufferGeometry.prototype );
		DodecahedronBufferGeometry.prototype.constructor = DodecahedronBufferGeometry;
	
		/**
		 * @author oosmoxiecode / https://github.com/oosmoxiecode
		 * @author WestLangley / https://github.com/WestLangley
		 * @author zz85 / https://github.com/zz85
		 * @author miningold / https://github.com/miningold
		 * @author jonobr1 / https://github.com/jonobr1
		 * @author Mugen87 / https://github.com/Mugen87
		 *
		 */
	
		// TubeGeometry
	
		function TubeGeometry( path, tubularSegments, radius, radialSegments, closed, taper ) {
	
			Geometry.call( this );
	
			this.type = 'TubeGeometry';
	
			this.parameters = {
				path: path,
				tubularSegments: tubularSegments,
				radius: radius,
				radialSegments: radialSegments,
				closed: closed
			};
	
			if ( taper !== undefined ) console.warn( 'THREE.TubeGeometry: taper has been removed.' );
	
			var bufferGeometry = new TubeBufferGeometry( path, tubularSegments, radius, radialSegments, closed );
	
			// expose internals
	
			this.tangents = bufferGeometry.tangents;
			this.normals = bufferGeometry.normals;
			this.binormals = bufferGeometry.binormals;
	
			// create geometry
	
			this.fromBufferGeometry( bufferGeometry );
			this.mergeVertices();
	
		}
	
		TubeGeometry.prototype = Object.create( Geometry.prototype );
		TubeGeometry.prototype.constructor = TubeGeometry;
	
		// TubeBufferGeometry
	
		function TubeBufferGeometry( path, tubularSegments, radius, radialSegments, closed ) {
	
			BufferGeometry.call( this );
	
			this.type = 'TubeBufferGeometry';
	
			this.parameters = {
				path: path,
				tubularSegments: tubularSegments,
				radius: radius,
				radialSegments: radialSegments,
				closed: closed
			};
	
			tubularSegments = tubularSegments || 64;
			radius = radius || 1;
			radialSegments = radialSegments || 8;
			closed = closed || false;
	
			var frames = path.computeFrenetFrames( tubularSegments, closed );
	
			// expose internals
	
			this.tangents = frames.tangents;
			this.normals = frames.normals;
			this.binormals = frames.binormals;
	
			// helper variables
	
			var vertex = new Vector3();
			var normal = new Vector3();
			var uv = new Vector2();
			var P = new Vector3();
	
			var i, j;
	
			// buffer
	
			var vertices = [];
			var normals = [];
			var uvs = [];
			var indices = [];
	
			// create buffer data
	
			generateBufferData();
	
			// build geometry
	
			this.setIndex( indices );
			this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
			this.addAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
			this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );
	
			// functions
	
			function generateBufferData() {
	
				for ( i = 0; i < tubularSegments; i ++ ) {
	
					generateSegment( i );
	
				}
	
				// if the geometry is not closed, generate the last row of vertices and normals
				// at the regular position on the given path
				//
				// if the geometry is closed, duplicate the first row of vertices and normals (uvs will differ)
	
				generateSegment( ( closed === false ) ? tubularSegments : 0 );
	
				// uvs are generated in a separate function.
				// this makes it easy compute correct values for closed geometries
	
				generateUVs();
	
				// finally create faces
	
				generateIndices();
	
			}
	
			function generateSegment( i ) {
	
				// we use getPointAt to sample evenly distributed points from the given path
	
				P = path.getPointAt( i / tubularSegments, P );
	
				// retrieve corresponding normal and binormal
	
				var N = frames.normals[ i ];
				var B = frames.binormals[ i ];
	
				// generate normals and vertices for the current segment
	
				for ( j = 0; j <= radialSegments; j ++ ) {
	
					var v = j / radialSegments * Math.PI * 2;
	
					var sin = Math.sin( v );
					var cos = - Math.cos( v );
	
					// normal
	
					normal.x = ( cos * N.x + sin * B.x );
					normal.y = ( cos * N.y + sin * B.y );
					normal.z = ( cos * N.z + sin * B.z );
					normal.normalize();
	
					normals.push( normal.x, normal.y, normal.z );
	
					// vertex
	
					vertex.x = P.x + radius * normal.x;
					vertex.y = P.y + radius * normal.y;
					vertex.z = P.z + radius * normal.z;
	
					vertices.push( vertex.x, vertex.y, vertex.z );
	
				}
	
			}
	
			function generateIndices() {
	
				for ( j = 1; j <= tubularSegments; j ++ ) {
	
					for ( i = 1; i <= radialSegments; i ++ ) {
	
						var a = ( radialSegments + 1 ) * ( j - 1 ) + ( i - 1 );
						var b = ( radialSegments + 1 ) * j + ( i - 1 );
						var c = ( radialSegments + 1 ) * j + i;
						var d = ( radialSegments + 1 ) * ( j - 1 ) + i;
	
						// faces
	
						indices.push( a, b, d );
						indices.push( b, c, d );
	
					}
	
				}
	
			}
	
			function generateUVs() {
	
				for ( i = 0; i <= tubularSegments; i ++ ) {
	
					for ( j = 0; j <= radialSegments; j ++ ) {
	
						uv.x = i / tubularSegments;
						uv.y = j / radialSegments;
	
						uvs.push( uv.x, uv.y );
	
					}
	
				}
	
			}
	
		}
	
		TubeBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
		TubeBufferGeometry.prototype.constructor = TubeBufferGeometry;
	
		/**
		 * @author oosmoxiecode
		 * @author Mugen87 / https://github.com/Mugen87
		 *
		 * based on http://www.blackpawn.com/texts/pqtorus/
		 */
	
		// TorusKnotGeometry
	
		function TorusKnotGeometry( radius, tube, tubularSegments, radialSegments, p, q, heightScale ) {
	
			Geometry.call( this );
	
			this.type = 'TorusKnotGeometry';
	
			this.parameters = {
				radius: radius,
				tube: tube,
				tubularSegments: tubularSegments,
				radialSegments: radialSegments,
				p: p,
				q: q
			};
	
			if ( heightScale !== undefined ) console.warn( 'THREE.TorusKnotGeometry: heightScale has been deprecated. Use .scale( x, y, z ) instead.' );
	
			this.fromBufferGeometry( new TorusKnotBufferGeometry( radius, tube, tubularSegments, radialSegments, p, q ) );
			this.mergeVertices();
	
		}
	
		TorusKnotGeometry.prototype = Object.create( Geometry.prototype );
		TorusKnotGeometry.prototype.constructor = TorusKnotGeometry;
	
		// TorusKnotBufferGeometry
	
		function TorusKnotBufferGeometry( radius, tube, tubularSegments, radialSegments, p, q ) {
	
			BufferGeometry.call( this );
	
			this.type = 'TorusKnotBufferGeometry';
	
			this.parameters = {
				radius: radius,
				tube: tube,
				tubularSegments: tubularSegments,
				radialSegments: radialSegments,
				p: p,
				q: q
			};
	
			radius = radius || 1;
			tube = tube || 0.4;
			tubularSegments = Math.floor( tubularSegments ) || 64;
			radialSegments = Math.floor( radialSegments ) || 8;
			p = p || 2;
			q = q || 3;
	
			// buffers
	
			var indices = [];
			var vertices = [];
			var normals = [];
			var uvs = [];
	
			// helper variables
	
			var i, j;
	
			var vertex = new Vector3();
			var normal = new Vector3();
	
			var P1 = new Vector3();
			var P2 = new Vector3();
	
			var B = new Vector3();
			var T = new Vector3();
			var N = new Vector3();
	
			// generate vertices, normals and uvs
	
			for ( i = 0; i <= tubularSegments; ++ i ) {
	
				// the radian "u" is used to calculate the position on the torus curve of the current tubular segement
	
				var u = i / tubularSegments * p * Math.PI * 2;
	
				// now we calculate two points. P1 is our current position on the curve, P2 is a little farther ahead.
				// these points are used to create a special "coordinate space", which is necessary to calculate the correct vertex positions
	
				calculatePositionOnCurve( u, p, q, radius, P1 );
				calculatePositionOnCurve( u + 0.01, p, q, radius, P2 );
	
				// calculate orthonormal basis
	
				T.subVectors( P2, P1 );
				N.addVectors( P2, P1 );
				B.crossVectors( T, N );
				N.crossVectors( B, T );
	
				// normalize B, N. T can be ignored, we don't use it
	
				B.normalize();
				N.normalize();
	
				for ( j = 0; j <= radialSegments; ++ j ) {
	
					// now calculate the vertices. they are nothing more than an extrusion of the torus curve.
					// because we extrude a shape in the xy-plane, there is no need to calculate a z-value.
	
					var v = j / radialSegments * Math.PI * 2;
					var cx = - tube * Math.cos( v );
					var cy = tube * Math.sin( v );
	
					// now calculate the final vertex position.
					// first we orient the extrusion with our basis vectos, then we add it to the current position on the curve
	
					vertex.x = P1.x + ( cx * N.x + cy * B.x );
					vertex.y = P1.y + ( cx * N.y + cy * B.y );
					vertex.z = P1.z + ( cx * N.z + cy * B.z );
	
					vertices.push( vertex.x, vertex.y, vertex.z );
	
					// normal (P1 is always the center/origin of the extrusion, thus we can use it to calculate the normal)
	
					normal.subVectors( vertex, P1 ).normalize();
	
					normals.push( normal.x, normal.y, normal.z );
	
					// uv
	
					uvs.push( i / tubularSegments );
					uvs.push( j / radialSegments );
	
				}
	
			}
	
			// generate indices
	
			for ( j = 1; j <= tubularSegments; j ++ ) {
	
				for ( i = 1; i <= radialSegments; i ++ ) {
	
					// indices
	
					var a = ( radialSegments + 1 ) * ( j - 1 ) + ( i - 1 );
					var b = ( radialSegments + 1 ) * j + ( i - 1 );
					var c = ( radialSegments + 1 ) * j + i;
					var d = ( radialSegments + 1 ) * ( j - 1 ) + i;
	
					// faces
	
					indices.push( a, b, d );
					indices.push( b, c, d );
	
				}
	
			}
	
			// build geometry
	
			this.setIndex( indices );
			this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
			this.addAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
			this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );
	
			// this function calculates the current position on the torus curve
	
			function calculatePositionOnCurve( u, p, q, radius, position ) {
	
				var cu = Math.cos( u );
				var su = Math.sin( u );
				var quOverP = q / p * u;
				var cs = Math.cos( quOverP );
	
				position.x = radius * ( 2 + cs ) * 0.5 * cu;
				position.y = radius * ( 2 + cs ) * su * 0.5;
				position.z = radius * Math.sin( quOverP ) * 0.5;
	
			}
	
		}
	
		TorusKnotBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
		TorusKnotBufferGeometry.prototype.constructor = TorusKnotBufferGeometry;
	
		/**
		 * @author oosmoxiecode
		 * @author mrdoob / http://mrdoob.com/
		 * @author Mugen87 / https://github.com/Mugen87
		 */
	
		// TorusGeometry
	
		function TorusGeometry( radius, tube, radialSegments, tubularSegments, arc ) {
	
			Geometry.call( this );
	
			this.type = 'TorusGeometry';
	
			this.parameters = {
				radius: radius,
				tube: tube,
				radialSegments: radialSegments,
				tubularSegments: tubularSegments,
				arc: arc
			};
	
			this.fromBufferGeometry( new TorusBufferGeometry( radius, tube, radialSegments, tubularSegments, arc ) );
			this.mergeVertices();
	
		}
	
		TorusGeometry.prototype = Object.create( Geometry.prototype );
		TorusGeometry.prototype.constructor = TorusGeometry;
	
		// TorusBufferGeometry
	
		function TorusBufferGeometry( radius, tube, radialSegments, tubularSegments, arc ) {
	
			BufferGeometry.call( this );
	
			this.type = 'TorusBufferGeometry';
	
			this.parameters = {
				radius: radius,
				tube: tube,
				radialSegments: radialSegments,
				tubularSegments: tubularSegments,
				arc: arc
			};
	
			radius = radius || 1;
			tube = tube || 0.4;
			radialSegments = Math.floor( radialSegments ) || 8;
			tubularSegments = Math.floor( tubularSegments ) || 6;
			arc = arc || Math.PI * 2;
	
			// buffers
	
			var indices = [];
			var vertices = [];
			var normals = [];
			var uvs = [];
	
			// helper variables
	
			var center = new Vector3();
			var vertex = new Vector3();
			var normal = new Vector3();
	
			var j, i;
	
			// generate vertices, normals and uvs
	
			for ( j = 0; j <= radialSegments; j ++ ) {
	
				for ( i = 0; i <= tubularSegments; i ++ ) {
	
					var u = i / tubularSegments * arc;
					var v = j / radialSegments * Math.PI * 2;
	
					// vertex
	
					vertex.x = ( radius + tube * Math.cos( v ) ) * Math.cos( u );
					vertex.y = ( radius + tube * Math.cos( v ) ) * Math.sin( u );
					vertex.z = tube * Math.sin( v );
	
					vertices.push( vertex.x, vertex.y, vertex.z );
	
					// normal
	
					center.x = radius * Math.cos( u );
					center.y = radius * Math.sin( u );
					normal.subVectors( vertex, center ).normalize();
	
					normals.push( normal.x, normal.y, normal.z );
	
					// uv
	
					uvs.push( i / tubularSegments );
					uvs.push( j / radialSegments );
	
				}
	
			}
	
			// generate indices
	
			for ( j = 1; j <= radialSegments; j ++ ) {
	
				for ( i = 1; i <= tubularSegments; i ++ ) {
	
					// indices
	
					var a = ( tubularSegments + 1 ) * j + i - 1;
					var b = ( tubularSegments + 1 ) * ( j - 1 ) + i - 1;
					var c = ( tubularSegments + 1 ) * ( j - 1 ) + i;
					var d = ( tubularSegments + 1 ) * j + i;
	
					// faces
	
					indices.push( a, b, d );
					indices.push( b, c, d );
	
				}
	
			}
	
			// build geometry
	
			this.setIndex( indices );
			this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
			this.addAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
			this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );
	
		}
	
		TorusBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
		TorusBufferGeometry.prototype.constructor = TorusBufferGeometry;
	
		/**
		 * @author Mugen87 / https://github.com/Mugen87
		 * Port from https://github.com/mapbox/earcut (v2.1.2)
		 */
	
		var Earcut = {
	
			triangulate: function ( data, holeIndices, dim ) {
	
				dim = dim || 2;
	
				var hasHoles = holeIndices && holeIndices.length,
					outerLen = hasHoles ? holeIndices[ 0 ] * dim : data.length,
					outerNode = linkedList( data, 0, outerLen, dim, true ),
					triangles = [];
	
				if ( ! outerNode ) return triangles;
	
				var minX, minY, maxX, maxY, x, y, invSize;
	
				if ( hasHoles ) outerNode = eliminateHoles( data, holeIndices, outerNode, dim );
	
				// if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
	
				if ( data.length > 80 * dim ) {
	
					minX = maxX = data[ 0 ];
					minY = maxY = data[ 1 ];
	
					for ( var i = dim; i < outerLen; i += dim ) {
	
						x = data[ i ];
						y = data[ i + 1 ];
						if ( x < minX ) minX = x;
						if ( y < minY ) minY = y;
						if ( x > maxX ) maxX = x;
						if ( y > maxY ) maxY = y;
	
					}
	
					// minX, minY and invSize are later used to transform coords into integers for z-order calculation
	
					invSize = Math.max( maxX - minX, maxY - minY );
					invSize = invSize !== 0 ? 1 / invSize : 0;
	
				}
	
				earcutLinked( outerNode, triangles, dim, minX, minY, invSize );
	
				return triangles;
	
			}
	
		};
	
		// create a circular doubly linked list from polygon points in the specified winding order
	
		function linkedList( data, start, end, dim, clockwise ) {
	
			var i, last;
	
			if ( clockwise === ( signedArea( data, start, end, dim ) > 0 ) ) {
	
				for ( i = start; i < end; i += dim ) last = insertNode( i, data[ i ], data[ i + 1 ], last );
	
			} else {
	
				for ( i = end - dim; i >= start; i -= dim ) last = insertNode( i, data[ i ], data[ i + 1 ], last );
	
			}
	
			if ( last && equals( last, last.next ) ) {
	
				removeNode( last );
				last = last.next;
	
			}
	
			return last;
	
		}
	
		// eliminate colinear or duplicate points
	
		function filterPoints( start, end ) {
	
			if ( ! start ) return start;
			if ( ! end ) end = start;
	
			var p = start, again;
	
			do {
	
				again = false;
	
				if ( ! p.steiner && ( equals( p, p.next ) || area( p.prev, p, p.next ) === 0 ) ) {
	
					removeNode( p );
					p = end = p.prev;
					if ( p === p.next ) break;
					again = true;
	
				} else {
	
					p = p.next;
	
				}
	
			} while ( again || p !== end );
	
			return end;
	
		}
	
		// main ear slicing loop which triangulates a polygon (given as a linked list)
	
		function earcutLinked( ear, triangles, dim, minX, minY, invSize, pass ) {
	
			if ( ! ear ) return;
	
			// interlink polygon nodes in z-order
	
			if ( ! pass && invSize ) indexCurve( ear, minX, minY, invSize );
	
			var stop = ear, prev, next;
	
			// iterate through ears, slicing them one by one
	
			while ( ear.prev !== ear.next ) {
	
				prev = ear.prev;
				next = ear.next;
	
				if ( invSize ? isEarHashed( ear, minX, minY, invSize ) : isEar( ear ) ) {
	
					// cut off the triangle
					triangles.push( prev.i / dim );
					triangles.push( ear.i / dim );
					triangles.push( next.i / dim );
	
					removeNode( ear );
	
					// skipping the next vertice leads to less sliver triangles
					ear = next.next;
					stop = next.next;
	
					continue;
	
				}
	
				ear = next;
	
				// if we looped through the whole remaining polygon and can't find any more ears
	
				if ( ear === stop ) {
	
					// try filtering points and slicing again
	
					if ( ! pass ) {
	
						earcutLinked( filterPoints( ear ), triangles, dim, minX, minY, invSize, 1 );
	
						// if this didn't work, try curing all small self-intersections locally
	
					} else if ( pass === 1 ) {
	
						ear = cureLocalIntersections( ear, triangles, dim );
						earcutLinked( ear, triangles, dim, minX, minY, invSize, 2 );
	
					// as a last resort, try splitting the remaining polygon into two
	
					} else if ( pass === 2 ) {
	
						splitEarcut( ear, triangles, dim, minX, minY, invSize );
	
					}
	
					break;
	
				}
	
			}
	
		}
	
		// check whether a polygon node forms a valid ear with adjacent nodes
	
		function isEar( ear ) {
	
			var a = ear.prev,
				b = ear,
				c = ear.next;
	
			if ( area( a, b, c ) >= 0 ) return false; // reflex, can't be an ear
	
			// now make sure we don't have other points inside the potential ear
			var p = ear.next.next;
	
			while ( p !== ear.prev ) {
	
				if ( pointInTriangle( a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y ) && area( p.prev, p, p.next ) >= 0 ) {
	
					return false;
	
				}
	
				p = p.next;
	
			}
	
			return true;
	
		}
	
		function isEarHashed( ear, minX, minY, invSize ) {
	
			var a = ear.prev,
				b = ear,
				c = ear.next;
	
			if ( area( a, b, c ) >= 0 ) return false; // reflex, can't be an ear
	
			// triangle bbox; min & max are calculated like this for speed
	
			var minTX = a.x < b.x ? ( a.x < c.x ? a.x : c.x ) : ( b.x < c.x ? b.x : c.x ),
				minTY = a.y < b.y ? ( a.y < c.y ? a.y : c.y ) : ( b.y < c.y ? b.y : c.y ),
				maxTX = a.x > b.x ? ( a.x > c.x ? a.x : c.x ) : ( b.x > c.x ? b.x : c.x ),
				maxTY = a.y > b.y ? ( a.y > c.y ? a.y : c.y ) : ( b.y > c.y ? b.y : c.y );
	
			// z-order range for the current triangle bbox;
	
			var minZ = zOrder( minTX, minTY, minX, minY, invSize ),
				maxZ = zOrder( maxTX, maxTY, minX, minY, invSize );
	
			// first look for points inside the triangle in increasing z-order
	
			var p = ear.nextZ;
	
			while ( p && p.z <= maxZ ) {
	
				if ( p !== ear.prev && p !== ear.next &&
						pointInTriangle( a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y ) &&
						area( p.prev, p, p.next ) >= 0 ) return false;
				p = p.nextZ;
	
			}
	
			// then look for points in decreasing z-order
	
			p = ear.prevZ;
	
			while ( p && p.z >= minZ ) {
	
				if ( p !== ear.prev && p !== ear.next &&
						pointInTriangle( a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y ) &&
						area( p.prev, p, p.next ) >= 0 ) return false;
	
				p = p.prevZ;
	
			}
	
			return true;
	
		}
	
		// go through all polygon nodes and cure small local self-intersections
	
		function cureLocalIntersections( start, triangles, dim ) {
	
			var p = start;
	
			do {
	
				var a = p.prev, b = p.next.next;
	
				if ( ! equals( a, b ) && intersects( a, p, p.next, b ) && locallyInside( a, b ) && locallyInside( b, a ) ) {
	
					triangles.push( a.i / dim );
					triangles.push( p.i / dim );
					triangles.push( b.i / dim );
	
					// remove two nodes involved
	
					removeNode( p );
					removeNode( p.next );
	
					p = start = b;
	
				}
	
				p = p.next;
	
			} while ( p !== start );
	
			return p;
	
		}
	
		// try splitting polygon into two and triangulate them independently
	
		function splitEarcut( start, triangles, dim, minX, minY, invSize ) {
	
			// look for a valid diagonal that divides the polygon into two
	
			var a = start;
	
			do {
	
				var b = a.next.next;
	
				while ( b !== a.prev ) {
	
					if ( a.i !== b.i && isValidDiagonal( a, b ) ) {
	
						// split the polygon in two by the diagonal
	
						var c = splitPolygon( a, b );
	
						// filter colinear points around the cuts
	
						a = filterPoints( a, a.next );
						c = filterPoints( c, c.next );
	
						// run earcut on each half
	
						earcutLinked( a, triangles, dim, minX, minY, invSize );
						earcutLinked( c, triangles, dim, minX, minY, invSize );
						return;
	
					}
	
					b = b.next;
	
				}
	
				a = a.next;
	
			} while ( a !== start );
	
		}
	
		// link every hole into the outer loop, producing a single-ring polygon without holes
	
		function eliminateHoles( data, holeIndices, outerNode, dim ) {
	
			var queue = [], i, len, start, end, list;
	
			for ( i = 0, len = holeIndices.length; i < len; i ++ ) {
	
				start = holeIndices[ i ] * dim;
				end = i < len - 1 ? holeIndices[ i + 1 ] * dim : data.length;
				list = linkedList( data, start, end, dim, false );
				if ( list === list.next ) list.steiner = true;
				queue.push( getLeftmost( list ) );
	
			}
	
			queue.sort( compareX );
	
			// process holes from left to right
	
			for ( i = 0; i < queue.length; i ++ ) {
	
				eliminateHole( queue[ i ], outerNode );
				outerNode = filterPoints( outerNode, outerNode.next );
	
			}
	
			return outerNode;
	
		}
	
		function compareX( a, b ) {
	
			return a.x - b.x;
	
		}
	
		// find a bridge between vertices that connects hole with an outer ring and and link it
	
		function eliminateHole( hole, outerNode ) {
	
			outerNode = findHoleBridge( hole, outerNode );
	
			if ( outerNode ) {
	
				var b = splitPolygon( outerNode, hole );
	
				filterPoints( b, b.next );
	
			}
	
		}
	
		// David Eberly's algorithm for finding a bridge between hole and outer polygon
	
		function findHoleBridge( hole, outerNode ) {
	
			var p = outerNode,
				hx = hole.x,
				hy = hole.y,
				qx = - Infinity,
				m;
	
			// find a segment intersected by a ray from the hole's leftmost point to the left;
			// segment's endpoint with lesser x will be potential connection point
	
			do {
	
				if ( hy <= p.y && hy >= p.next.y && p.next.y !== p.y ) {
	
					var x = p.x + ( hy - p.y ) * ( p.next.x - p.x ) / ( p.next.y - p.y );
	
					if ( x <= hx && x > qx ) {
	
						qx = x;
	
						if ( x === hx ) {
	
							if ( hy === p.y ) return p;
							if ( hy === p.next.y ) return p.next;
	
						}
	
						m = p.x < p.next.x ? p : p.next;
	
					}
	
				}
	
				p = p.next;
	
			} while ( p !== outerNode );
	
			if ( ! m ) return null;
	
			if ( hx === qx ) return m.prev; // hole touches outer segment; pick lower endpoint
	
			// look for points inside the triangle of hole point, segment intersection and endpoint;
			// if there are no points found, we have a valid connection;
			// otherwise choose the point of the minimum angle with the ray as connection point
	
			var stop = m,
				mx = m.x,
				my = m.y,
				tanMin = Infinity,
				tan;
	
			p = m.next;
	
			while ( p !== stop ) {
	
				if ( hx >= p.x && p.x >= mx && hx !== p.x &&
								pointInTriangle( hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y ) ) {
	
					tan = Math.abs( hy - p.y ) / ( hx - p.x ); // tangential
	
					if ( ( tan < tanMin || ( tan === tanMin && p.x > m.x ) ) && locallyInside( p, hole ) ) {
	
						m = p;
						tanMin = tan;
	
					}
	
				}
	
				p = p.next;
	
			}
	
			return m;
	
		}
	
		// interlink polygon nodes in z-order
	
		function indexCurve( start, minX, minY, invSize ) {
	
			var p = start;
	
			do {
	
				if ( p.z === null ) p.z = zOrder( p.x, p.y, minX, minY, invSize );
				p.prevZ = p.prev;
				p.nextZ = p.next;
				p = p.next;
	
			} while ( p !== start );
	
			p.prevZ.nextZ = null;
			p.prevZ = null;
	
			sortLinked( p );
	
		}
	
		// Simon Tatham's linked list merge sort algorithm
		// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
	
		function sortLinked( list ) {
	
			var i, p, q, e, tail, numMerges, pSize, qSize, inSize = 1;
	
			do {
	
				p = list;
				list = null;
				tail = null;
				numMerges = 0;
	
				while ( p ) {
	
					numMerges ++;
					q = p;
					pSize = 0;
	
					for ( i = 0; i < inSize; i ++ ) {
	
						pSize ++;
						q = q.nextZ;
						if ( ! q ) break;
	
					}
	
					qSize = inSize;
	
					while ( pSize > 0 || ( qSize > 0 && q ) ) {
	
						if ( pSize !== 0 && ( qSize === 0 || ! q || p.z <= q.z ) ) {
	
							e = p;
							p = p.nextZ;
							pSize --;
	
						} else {
	
							e = q;
							q = q.nextZ;
							qSize --;
	
						}
	
						if ( tail ) tail.nextZ = e;
						else list = e;
	
						e.prevZ = tail;
						tail = e;
	
					}
	
					p = q;
	
				}
	
				tail.nextZ = null;
				inSize *= 2;
	
			} while ( numMerges > 1 );
	
			return list;
	
		}
	
		// z-order of a point given coords and inverse of the longer side of data bbox
	
		function zOrder( x, y, minX, minY, invSize ) {
	
			// coords are transformed into non-negative 15-bit integer range
	
			x = 32767 * ( x - minX ) * invSize;
			y = 32767 * ( y - minY ) * invSize;
	
			x = ( x | ( x << 8 ) ) & 0x00FF00FF;
			x = ( x | ( x << 4 ) ) & 0x0F0F0F0F;
			x = ( x | ( x << 2 ) ) & 0x33333333;
			x = ( x | ( x << 1 ) ) & 0x55555555;
	
			y = ( y | ( y << 8 ) ) & 0x00FF00FF;
			y = ( y | ( y << 4 ) ) & 0x0F0F0F0F;
			y = ( y | ( y << 2 ) ) & 0x33333333;
			y = ( y | ( y << 1 ) ) & 0x55555555;
	
			return x | ( y << 1 );
	
		}
	
		// find the leftmost node of a polygon ring
	
		function getLeftmost( start ) {
	
			var p = start, leftmost = start;
	
			do {
	
				if ( p.x < leftmost.x ) leftmost = p;
				p = p.next;
	
			} while ( p !== start );
	
			return leftmost;
	
		}
	
		// check if a point lies within a convex triangle
	
		function pointInTriangle( ax, ay, bx, by, cx, cy, px, py ) {
	
			return ( cx - px ) * ( ay - py ) - ( ax - px ) * ( cy - py ) >= 0 &&
			 ( ax - px ) * ( by - py ) - ( bx - px ) * ( ay - py ) >= 0 &&
			 ( bx - px ) * ( cy - py ) - ( cx - px ) * ( by - py ) >= 0;
	
		}
	
		// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
	
		function isValidDiagonal( a, b ) {
	
			return a.next.i !== b.i && a.prev.i !== b.i && ! intersectsPolygon( a, b ) &&
				locallyInside( a, b ) && locallyInside( b, a ) && middleInside( a, b );
	
		}
	
		// signed area of a triangle
	
		function area( p, q, r ) {
	
			return ( q.y - p.y ) * ( r.x - q.x ) - ( q.x - p.x ) * ( r.y - q.y );
	
		}
	
		// check if two points are equal
	
		function equals( p1, p2 ) {
	
			return p1.x === p2.x && p1.y === p2.y;
	
		}
	
		// check if two segments intersect
	
		function intersects( p1, q1, p2, q2 ) {
	
			if ( ( equals( p1, q1 ) && equals( p2, q2 ) ) ||
					( equals( p1, q2 ) && equals( p2, q1 ) ) ) return true;
	
			return area( p1, q1, p2 ) > 0 !== area( p1, q1, q2 ) > 0 &&
						 area( p2, q2, p1 ) > 0 !== area( p2, q2, q1 ) > 0;
	
		}
	
		// check if a polygon diagonal intersects any polygon segments
	
		function intersectsPolygon( a, b ) {
	
			var p = a;
	
			do {
	
				if ( p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i &&
								intersects( p, p.next, a, b ) ) {
	
					return true;
	
				}
	
				p = p.next;
	
			} while ( p !== a );
	
			return false;
	
		}
	
		// check if a polygon diagonal is locally inside the polygon
	
		function locallyInside( a, b ) {
	
			return area( a.prev, a, a.next ) < 0 ?
				area( a, b, a.next ) >= 0 && area( a, a.prev, b ) >= 0 :
				area( a, b, a.prev ) < 0 || area( a, a.next, b ) < 0;
	
		}
	
		// check if the middle point of a polygon diagonal is inside the polygon
	
		function middleInside( a, b ) {
	
			var p = a,
				inside = false,
				px = ( a.x + b.x ) / 2,
				py = ( a.y + b.y ) / 2;
	
			do {
	
				if ( ( ( p.y > py ) !== ( p.next.y > py ) ) && p.next.y !== p.y &&
								( px < ( p.next.x - p.x ) * ( py - p.y ) / ( p.next.y - p.y ) + p.x ) ) {
	
					inside = ! inside;
	
				}
	
				p = p.next;
	
			} while ( p !== a );
	
			return inside;
	
		}
	
		// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
		// if one belongs to the outer ring and another to a hole, it merges it into a single ring
	
		function splitPolygon( a, b ) {
	
			var a2 = new Node( a.i, a.x, a.y ),
				b2 = new Node( b.i, b.x, b.y ),
				an = a.next,
				bp = b.prev;
	
			a.next = b;
			b.prev = a;
	
			a2.next = an;
			an.prev = a2;
	
			b2.next = a2;
			a2.prev = b2;
	
			bp.next = b2;
			b2.prev = bp;
	
			return b2;
	
		}
	
		// create a node and optionally link it with previous one (in a circular doubly linked list)
	
		function insertNode( i, x, y, last ) {
	
			var p = new Node( i, x, y );
	
			if ( ! last ) {
	
				p.prev = p;
				p.next = p;
	
			} else {
	
				p.next = last.next;
				p.prev = last;
				last.next.prev = p;
				last.next = p;
	
			}
	
			return p;
	
		}
	
		function removeNode( p ) {
	
			p.next.prev = p.prev;
			p.prev.next = p.next;
	
			if ( p.prevZ ) p.prevZ.nextZ = p.nextZ;
			if ( p.nextZ ) p.nextZ.prevZ = p.prevZ;
	
		}
	
		function Node( i, x, y ) {
	
			// vertice index in coordinates array
			this.i = i;
	
			// vertex coordinates
			this.x = x;
			this.y = y;
	
			// previous and next vertice nodes in a polygon ring
			this.prev = null;
			this.next = null;
	
			// z-order curve value
			this.z = null;
	
			// previous and next nodes in z-order
			this.prevZ = null;
			this.nextZ = null;
	
			// indicates whether this is a steiner point
			this.steiner = false;
	
		}
	
		function signedArea( data, start, end, dim ) {
	
			var sum = 0;
	
			for ( var i = start, j = end - dim; i < end; i += dim ) {
	
				sum += ( data[ j ] - data[ i ] ) * ( data[ i + 1 ] + data[ j + 1 ] );
				j = i;
	
			}
	
			return sum;
	
		}
	
		/**
		 * @author zz85 / http://www.lab4games.net/zz85/blog
		 */
	
		var ShapeUtils = {
	
			// calculate area of the contour polygon
	
			area: function ( contour ) {
	
				var n = contour.length;
				var a = 0.0;
	
				for ( var p = n - 1, q = 0; q < n; p = q ++ ) {
	
					a += contour[ p ].x * contour[ q ].y - contour[ q ].x * contour[ p ].y;
	
				}
	
				return a * 0.5;
	
			},
	
			isClockWise: function ( pts ) {
	
				return ShapeUtils.area( pts ) < 0;
	
			},
	
			triangulateShape: function ( contour, holes ) {
	
				function removeDupEndPts( points ) {
	
					var l = points.length;
	
					if ( l > 2 && points[ l - 1 ].equals( points[ 0 ] ) ) {
	
						points.pop();
	
					}
	
				}
	
				function addContour( vertices, contour ) {
	
					for ( var i = 0; i < contour.length; i ++ ) {
	
						vertices.push( contour[ i ].x );
						vertices.push( contour[ i ].y );
	
					}
	
				}
	
				var vertices = []; // flat array of vertices like [ x0,y0, x1,y1, x2,y2, ... ]
				var holeIndices = []; // array of hole indices
				var faces = []; // final array of vertex indices like [ [ a,b,d ], [ b,c,d ] ]
	
				removeDupEndPts( contour );
				addContour( vertices, contour );
	
				//
	
				var holeIndex = contour.length;
				holes.forEach( removeDupEndPts );
	
				for ( i = 0; i < holes.length; i ++ ) {
	
					holeIndices.push( holeIndex );
					holeIndex += holes[ i ].length;
					addContour( vertices, holes[ i ] );
	
				}
	
				//
	
				var triangles = Earcut.triangulate( vertices, holeIndices );
	
				//
	
				for ( var i = 0; i < triangles.length; i += 3 ) {
	
					faces.push( triangles.slice( i, i + 3 ) );
	
				}
	
				return faces;
	
			}
	
		};
	
		/**
		 * @author zz85 / http://www.lab4games.net/zz85/blog
		 *
		 * Creates extruded geometry from a path shape.
		 *
		 * parameters = {
		 *
		 *  curveSegments: <int>, // number of points on the curves
		 *  steps: <int>, // number of points for z-side extrusions / used for subdividing segments of extrude spline too
		 *  amount: <int>, // Depth to extrude the shape
		 *
		 *  bevelEnabled: <bool>, // turn on bevel
		 *  bevelThickness: <float>, // how deep into the original shape bevel goes
		 *  bevelSize: <float>, // how far from shape outline is bevel
		 *  bevelSegments: <int>, // number of bevel layers
		 *
		 *  extrudePath: <THREE.Curve> // curve to extrude shape along
		 *  frames: <Object> // containing arrays of tangents, normals, binormals
		 *
		 *  UVGenerator: <Object> // object that provides UV generator functions
		 *
		 * }
		 */
	
		// ExtrudeGeometry
	
		function ExtrudeGeometry( shapes, options ) {
	
			Geometry.call( this );
	
			this.type = 'ExtrudeGeometry';
	
			this.parameters = {
				shapes: shapes,
				options: options
			};
	
			this.fromBufferGeometry( new ExtrudeBufferGeometry( shapes, options ) );
			this.mergeVertices();
	
		}
	
		ExtrudeGeometry.prototype = Object.create( Geometry.prototype );
		ExtrudeGeometry.prototype.constructor = ExtrudeGeometry;
	
		// ExtrudeBufferGeometry
	
		function ExtrudeBufferGeometry( shapes, options ) {
	
			if ( typeof ( shapes ) === "undefined" ) {
	
				return;
	
			}
	
			BufferGeometry.call( this );
	
			this.type = 'ExtrudeBufferGeometry';
	
			shapes = Array.isArray( shapes ) ? shapes : [ shapes ];
	
			this.addShapeList( shapes, options );
	
			this.computeVertexNormals();
	
			// can't really use automatic vertex normals
			// as then front and back sides get smoothed too
			// should do separate smoothing just for sides
	
			//this.computeVertexNormals();
	
			//console.log( "took", ( Date.now() - startTime ) );
	
		}
	
		ExtrudeBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
		ExtrudeBufferGeometry.prototype.constructor = ExtrudeBufferGeometry;
	
		ExtrudeBufferGeometry.prototype.getArrays = function () {
	
			var positionAttribute = this.getAttribute( "position" );
			var verticesArray = positionAttribute ? Array.prototype.slice.call( positionAttribute.array ) : [];
	
			var uvAttribute = this.getAttribute( "uv" );
			var uvArray = uvAttribute ? Array.prototype.slice.call( uvAttribute.array ) : [];
	
			var IndexAttribute = this.index;
			var indicesArray = IndexAttribute ? Array.prototype.slice.call( IndexAttribute.array ) : [];
	
			return {
				position: verticesArray,
				uv: uvArray,
				index: indicesArray
			};
	
		};
	
		ExtrudeBufferGeometry.prototype.addShapeList = function ( shapes, options ) {
	
			var sl = shapes.length;
			options.arrays = this.getArrays();
	
			for ( var s = 0; s < sl; s ++ ) {
	
				var shape = shapes[ s ];
				this.addShape( shape, options );
	
			}
	
			this.setIndex( options.arrays.index );
			this.addAttribute( 'position', new Float32BufferAttribute( options.arrays.position, 3 ) );
			this.addAttribute( 'uv', new Float32BufferAttribute( options.arrays.uv, 2 ) );
	
		};
	
		ExtrudeBufferGeometry.prototype.addShape = function ( shape, options ) {
	
			var arrays = options.arrays ? options.arrays : this.getArrays();
			var verticesArray = arrays.position;
			var indicesArray = arrays.index;
			var uvArray = arrays.uv;
	
			var placeholder = [];
	
	
			var amount = options.amount !== undefined ? options.amount : 100;
	
			var bevelThickness = options.bevelThickness !== undefined ? options.bevelThickness : 6; // 10
			var bevelSize = options.bevelSize !== undefined ? options.bevelSize : bevelThickness - 2; // 8
			var bevelSegments = options.bevelSegments !== undefined ? options.bevelSegments : 3;
	
			var bevelEnabled = options.bevelEnabled !== undefined ? options.bevelEnabled : true; // false
	
			var curveSegments = options.curveSegments !== undefined ? options.curveSegments : 12;
	
			var steps = options.steps !== undefined ? options.steps : 1;
	
			var extrudePath = options.extrudePath;
			var extrudePts, extrudeByPath = false;
	
			// Use default WorldUVGenerator if no UV generators are specified.
			var uvgen = options.UVGenerator !== undefined ? options.UVGenerator : ExtrudeGeometry.WorldUVGenerator;
	
			var splineTube, binormal, normal, position2;
			if ( extrudePath ) {
	
				extrudePts = extrudePath.getSpacedPoints( steps );
	
				extrudeByPath = true;
				bevelEnabled = false; // bevels not supported for path extrusion
	
				// SETUP TNB variables
	
				// TODO1 - have a .isClosed in spline?
	
				splineTube = options.frames !== undefined ? options.frames : extrudePath.computeFrenetFrames( steps, false );
	
				// console.log(splineTube, 'splineTube', splineTube.normals.length, 'steps', steps, 'extrudePts', extrudePts.length);
	
				binormal = new Vector3();
				normal = new Vector3();
				position2 = new Vector3();
	
			}
	
			// Safeguards if bevels are not enabled
	
			if ( ! bevelEnabled ) {
	
				bevelSegments = 0;
				bevelThickness = 0;
				bevelSize = 0;
	
			}
	
			// Variables initialization
	
			var ahole, h, hl; // looping of holes
			var scope = this;
	
			var shapePoints = shape.extractPoints( curveSegments );
	
			var vertices = shapePoints.shape;
			var holes = shapePoints.holes;
	
			var reverse = ! ShapeUtils.isClockWise( vertices );
	
			if ( reverse ) {
	
				vertices = vertices.reverse();
	
				// Maybe we should also check if holes are in the opposite direction, just to be safe ...
	
				for ( h = 0, hl = holes.length; h < hl; h ++ ) {
	
					ahole = holes[ h ];
	
					if ( ShapeUtils.isClockWise( ahole ) ) {
	
						holes[ h ] = ahole.reverse();
	
					}
	
				}
	
			}
	
	
			var faces = ShapeUtils.triangulateShape( vertices, holes );
	
			/* Vertices */
	
			var contour = vertices; // vertices has all points but contour has only points of circumference
	
			for ( h = 0, hl = holes.length; h < hl; h ++ ) {
	
				ahole = holes[ h ];
	
				vertices = vertices.concat( ahole );
	
			}
	
	
			function scalePt2( pt, vec, size ) {
	
				if ( ! vec ) console.error( "THREE.ExtrudeGeometry: vec does not exist" );
	
				return vec.clone().multiplyScalar( size ).add( pt );
	
			}
	
			var b, bs, t, z,
				vert, vlen = vertices.length,
				face, flen = faces.length;
	
	
			// Find directions for point movement
	
	
			function getBevelVec( inPt, inPrev, inNext ) {
	
				// computes for inPt the corresponding point inPt' on a new contour
				//   shifted by 1 unit (length of normalized vector) to the left
				// if we walk along contour clockwise, this new contour is outside the old one
				//
				// inPt' is the intersection of the two lines parallel to the two
				//  adjacent edges of inPt at a distance of 1 unit on the left side.
	
				var v_trans_x, v_trans_y, shrink_by; // resulting translation vector for inPt
	
				// good reading for geometry algorithms (here: line-line intersection)
				// http://geomalgorithms.com/a05-_intersect-1.html
	
				var v_prev_x = inPt.x - inPrev.x,
					v_prev_y = inPt.y - inPrev.y;
				var v_next_x = inNext.x - inPt.x,
					v_next_y = inNext.y - inPt.y;
	
				var v_prev_lensq = ( v_prev_x * v_prev_x + v_prev_y * v_prev_y );
	
				// check for collinear edges
				var collinear0 = ( v_prev_x * v_next_y - v_prev_y * v_next_x );
	
				if ( Math.abs( collinear0 ) > Number.EPSILON ) {
	
					// not collinear
	
					// length of vectors for normalizing
	
					var v_prev_len = Math.sqrt( v_prev_lensq );
					var v_next_len = Math.sqrt( v_next_x * v_next_x + v_next_y * v_next_y );
	
					// shift adjacent points by unit vectors to the left
	
					var ptPrevShift_x = ( inPrev.x - v_prev_y / v_prev_len );
					var ptPrevShift_y = ( inPrev.y + v_prev_x / v_prev_len );
	
					var ptNextShift_x = ( inNext.x - v_next_y / v_next_len );
					var ptNextShift_y = ( inNext.y + v_next_x / v_next_len );
	
					// scaling factor for v_prev to intersection point
	
					var sf = ( ( ptNextShift_x - ptPrevShift_x ) * v_next_y -
							( ptNextShift_y - ptPrevShift_y ) * v_next_x ) /
						( v_prev_x * v_next_y - v_prev_y * v_next_x );
	
					// vector from inPt to intersection point
	
					v_trans_x = ( ptPrevShift_x + v_prev_x * sf - inPt.x );
					v_trans_y = ( ptPrevShift_y + v_prev_y * sf - inPt.y );
	
					// Don't normalize!, otherwise sharp corners become ugly
					//  but prevent crazy spikes
					var v_trans_lensq = ( v_trans_x * v_trans_x + v_trans_y * v_trans_y );
					if ( v_trans_lensq <= 2 ) {
	
						return new Vector2( v_trans_x, v_trans_y );
	
					} else {
	
						shrink_by = Math.sqrt( v_trans_lensq / 2 );
	
					}
	
				} else {
	
					// handle special case of collinear edges
	
					var direction_eq = false; // assumes: opposite
					if ( v_prev_x > Number.EPSILON ) {
	
						if ( v_next_x > Number.EPSILON ) {
	
							direction_eq = true;
	
						}
	
					} else {
	
						if ( v_prev_x < - Number.EPSILON ) {
	
							if ( v_next_x < - Number.EPSILON ) {
	
								direction_eq = true;
	
							}
	
						} else {
	
							if ( Math.sign( v_prev_y ) === Math.sign( v_next_y ) ) {
	
								direction_eq = true;
	
							}
	
						}
	
					}
	
					if ( direction_eq ) {
	
						// console.log("Warning: lines are a straight sequence");
						v_trans_x = - v_prev_y;
						v_trans_y = v_prev_x;
						shrink_by = Math.sqrt( v_prev_lensq );
	
					} else {
	
						// console.log("Warning: lines are a straight spike");
						v_trans_x = v_prev_x;
						v_trans_y = v_prev_y;
						shrink_by = Math.sqrt( v_prev_lensq / 2 );
	
					}
	
				}
	
				return new Vector2( v_trans_x / shrink_by, v_trans_y / shrink_by );
	
			}
	
	
			var contourMovements = [];
	
			for ( var i = 0, il = contour.length, j = il - 1, k = i + 1; i < il; i ++, j ++, k ++ ) {
	
				if ( j === il ) j = 0;
				if ( k === il ) k = 0;
	
				//  (j)---(i)---(k)
				// console.log('i,j,k', i, j , k)
	
				contourMovements[ i ] = getBevelVec( contour[ i ], contour[ j ], contour[ k ] );
	
			}
	
			var holesMovements = [],
				oneHoleMovements, verticesMovements = contourMovements.concat();
	
			for ( h = 0, hl = holes.length; h < hl; h ++ ) {
	
				ahole = holes[ h ];
	
				oneHoleMovements = [];
	
				for ( i = 0, il = ahole.length, j = il - 1, k = i + 1; i < il; i ++, j ++, k ++ ) {
	
					if ( j === il ) j = 0;
					if ( k === il ) k = 0;
	
					//  (j)---(i)---(k)
					oneHoleMovements[ i ] = getBevelVec( ahole[ i ], ahole[ j ], ahole[ k ] );
	
				}
	
				holesMovements.push( oneHoleMovements );
				verticesMovements = verticesMovements.concat( oneHoleMovements );
	
			}
	
	
			// Loop bevelSegments, 1 for the front, 1 for the back
	
			for ( b = 0; b < bevelSegments; b ++ ) {
	
				//for ( b = bevelSegments; b > 0; b -- ) {
	
				t = b / bevelSegments;
				z = bevelThickness * Math.cos( t * Math.PI / 2 );
				bs = bevelSize * Math.sin( t * Math.PI / 2 );
	
				// contract shape
	
				for ( i = 0, il = contour.length; i < il; i ++ ) {
	
					vert = scalePt2( contour[ i ], contourMovements[ i ], bs );
	
					v( vert.x, vert.y, - z );
	
				}
	
				// expand holes
	
				for ( h = 0, hl = holes.length; h < hl; h ++ ) {
	
					ahole = holes[ h ];
					oneHoleMovements = holesMovements[ h ];
	
					for ( i = 0, il = ahole.length; i < il; i ++ ) {
	
						vert = scalePt2( ahole[ i ], oneHoleMovements[ i ], bs );
	
						v( vert.x, vert.y, - z );
	
					}
	
				}
	
			}
	
			bs = bevelSize;
	
			// Back facing vertices
	
			for ( i = 0; i < vlen; i ++ ) {
	
				vert = bevelEnabled ? scalePt2( vertices[ i ], verticesMovements[ i ], bs ) : vertices[ i ];
	
				if ( ! extrudeByPath ) {
	
					v( vert.x, vert.y, 0 );
	
				} else {
	
					// v( vert.x, vert.y + extrudePts[ 0 ].y, extrudePts[ 0 ].x );
	
					normal.copy( splineTube.normals[ 0 ] ).multiplyScalar( vert.x );
					binormal.copy( splineTube.binormals[ 0 ] ).multiplyScalar( vert.y );
	
					position2.copy( extrudePts[ 0 ] ).add( normal ).add( binormal );
	
					v( position2.x, position2.y, position2.z );
	
				}
	
			}
	
			// Add stepped vertices...
			// Including front facing vertices
	
			var s;
	
			for ( s = 1; s <= steps; s ++ ) {
	
				for ( i = 0; i < vlen; i ++ ) {
	
					vert = bevelEnabled ? scalePt2( vertices[ i ], verticesMovements[ i ], bs ) : vertices[ i ];
	
					if ( ! extrudeByPath ) {
	
						v( vert.x, vert.y, amount / steps * s );
	
					} else {
	
						// v( vert.x, vert.y + extrudePts[ s - 1 ].y, extrudePts[ s - 1 ].x );
	
						normal.copy( splineTube.normals[ s ] ).multiplyScalar( vert.x );
						binormal.copy( splineTube.binormals[ s ] ).multiplyScalar( vert.y );
	
						position2.copy( extrudePts[ s ] ).add( normal ).add( binormal );
	
						v( position2.x, position2.y, position2.z );
	
					}
	
				}
	
			}
	
	
			// Add bevel segments planes
	
			//for ( b = 1; b <= bevelSegments; b ++ ) {
			for ( b = bevelSegments - 1; b >= 0; b -- ) {
	
				t = b / bevelSegments;
				z = bevelThickness * Math.cos( t * Math.PI / 2 );
				bs = bevelSize * Math.sin( t * Math.PI / 2 );
	
				// contract shape
	
				for ( i = 0, il = contour.length; i < il; i ++ ) {
	
					vert = scalePt2( contour[ i ], contourMovements[ i ], bs );
					v( vert.x, vert.y, amount + z );
	
				}
	
				// expand holes
	
				for ( h = 0, hl = holes.length; h < hl; h ++ ) {
	
					ahole = holes[ h ];
					oneHoleMovements = holesMovements[ h ];
	
					for ( i = 0, il = ahole.length; i < il; i ++ ) {
	
						vert = scalePt2( ahole[ i ], oneHoleMovements[ i ], bs );
	
						if ( ! extrudeByPath ) {
	
							v( vert.x, vert.y, amount + z );
	
						} else {
	
							v( vert.x, vert.y + extrudePts[ steps - 1 ].y, extrudePts[ steps - 1 ].x + z );
	
						}
	
					}
	
				}
	
			}
	
			/* Faces */
	
			// Top and bottom faces
	
			buildLidFaces();
	
			// Sides faces
	
			buildSideFaces();
	
	
			/////  Internal functions
	
			function buildLidFaces() {
	
				var start = verticesArray.length / 3;
	
				if ( bevelEnabled ) {
	
					var layer = 0; // steps + 1
					var offset = vlen * layer;
	
					// Bottom faces
	
					for ( i = 0; i < flen; i ++ ) {
	
						face = faces[ i ];
						f3( face[ 2 ] + offset, face[ 1 ] + offset, face[ 0 ] + offset );
	
					}
	
					layer = steps + bevelSegments * 2;
					offset = vlen * layer;
	
					// Top faces
	
					for ( i = 0; i < flen; i ++ ) {
	
						face = faces[ i ];
						f3( face[ 0 ] + offset, face[ 1 ] + offset, face[ 2 ] + offset );
	
					}
	
				} else {
	
					// Bottom faces
	
					for ( i = 0; i < flen; i ++ ) {
	
						face = faces[ i ];
						f3( face[ 2 ], face[ 1 ], face[ 0 ] );
	
					}
	
					// Top faces
	
					for ( i = 0; i < flen; i ++ ) {
	
						face = faces[ i ];
						f3( face[ 0 ] + vlen * steps, face[ 1 ] + vlen * steps, face[ 2 ] + vlen * steps );
	
					}
	
				}
	
				scope.addGroup( start, verticesArray.length / 3 - start, options.material !== undefined ? options.material : 0 );
	
			}
	
			// Create faces for the z-sides of the shape
	
			function buildSideFaces() {
	
				var start = verticesArray.length / 3;
				var layeroffset = 0;
				sidewalls( contour, layeroffset );
				layeroffset += contour.length;
	
				for ( h = 0, hl = holes.length; h < hl; h ++ ) {
	
					ahole = holes[ h ];
					sidewalls( ahole, layeroffset );
	
					//, true
					layeroffset += ahole.length;
	
				}
	
	
				scope.addGroup( start, verticesArray.length / 3 - start, options.extrudeMaterial !== undefined ? options.extrudeMaterial : 1 );
	
	
			}
	
			function sidewalls( contour, layeroffset ) {
	
				var j, k;
				i = contour.length;
	
				while ( -- i >= 0 ) {
	
					j = i;
					k = i - 1;
					if ( k < 0 ) k = contour.length - 1;
	
					//console.log('b', i,j, i-1, k,vertices.length);
	
					var s = 0,
						sl = steps + bevelSegments * 2;
	
					for ( s = 0; s < sl; s ++ ) {
	
						var slen1 = vlen * s;
						var slen2 = vlen * ( s + 1 );
	
						var a = layeroffset + j + slen1,
							b = layeroffset + k + slen1,
							c = layeroffset + k + slen2,
							d = layeroffset + j + slen2;
	
						f4( a, b, c, d );
	
					}
	
				}
	
			}
	
			function v( x, y, z ) {
	
				placeholder.push( x );
				placeholder.push( y );
				placeholder.push( z );
	
			}
	
	
			function f3( a, b, c ) {
	
				addVertex( a );
				addVertex( b );
				addVertex( c );
	
				var nextIndex = verticesArray.length / 3;
				var uvs = uvgen.generateTopUV( scope, verticesArray, nextIndex - 3, nextIndex - 2, nextIndex - 1 );
	
				addUV( uvs[ 0 ] );
				addUV( uvs[ 1 ] );
				addUV( uvs[ 2 ] );
	
			}
	
			function f4( a, b, c, d ) {
	
				addVertex( a );
				addVertex( b );
				addVertex( d );
	
				addVertex( b );
				addVertex( c );
				addVertex( d );
	
	
				var nextIndex = verticesArray.length / 3;
				var uvs = uvgen.generateSideWallUV( scope, verticesArray, nextIndex - 6, nextIndex - 3, nextIndex - 2, nextIndex - 1 );
	
				addUV( uvs[ 0 ] );
				addUV( uvs[ 1 ] );
				addUV( uvs[ 3 ] );
	
				addUV( uvs[ 1 ] );
				addUV( uvs[ 2 ] );
				addUV( uvs[ 3 ] );
	
			}
	
			function addVertex( index ) {
	
				indicesArray.push( verticesArray.length / 3 );
				verticesArray.push( placeholder[ index * 3 + 0 ] );
				verticesArray.push( placeholder[ index * 3 + 1 ] );
				verticesArray.push( placeholder[ index * 3 + 2 ] );
	
			}
	
	
			function addUV( vector2 ) {
	
				uvArray.push( vector2.x );
				uvArray.push( vector2.y );
	
			}
	
			if ( ! options.arrays ) {
	
				this.setIndex( indicesArray );
				this.addAttribute( 'position', new Float32BufferAttribute( verticesArray, 3 ) );
				this.addAttribute( 'uv', new Float32BufferAttribute( uvArray, 2 ) );
	
			}
	
		};
	
		ExtrudeGeometry.WorldUVGenerator = {
	
			generateTopUV: function ( geometry, vertices, indexA, indexB, indexC ) {
	
				var a_x = vertices[ indexA * 3 ];
				var a_y = vertices[ indexA * 3 + 1 ];
				var b_x = vertices[ indexB * 3 ];
				var b_y = vertices[ indexB * 3 + 1 ];
				var c_x = vertices[ indexC * 3 ];
				var c_y = vertices[ indexC * 3 + 1 ];
	
				return [
					new Vector2( a_x, a_y ),
					new Vector2( b_x, b_y ),
					new Vector2( c_x, c_y )
				];
	
			},
	
			generateSideWallUV: function ( geometry, vertices, indexA, indexB, indexC, indexD ) {
	
				var a_x = vertices[ indexA * 3 ];
				var a_y = vertices[ indexA * 3 + 1 ];
				var a_z = vertices[ indexA * 3 + 2 ];
				var b_x = vertices[ indexB * 3 ];
				var b_y = vertices[ indexB * 3 + 1 ];
				var b_z = vertices[ indexB * 3 + 2 ];
				var c_x = vertices[ indexC * 3 ];
				var c_y = vertices[ indexC * 3 + 1 ];
				var c_z = vertices[ indexC * 3 + 2 ];
				var d_x = vertices[ indexD * 3 ];
				var d_y = vertices[ indexD * 3 + 1 ];
				var d_z = vertices[ indexD * 3 + 2 ];
	
				if ( Math.abs( a_y - b_y ) < 0.01 ) {
	
					return [
						new Vector2( a_x, 1 - a_z ),
						new Vector2( b_x, 1 - b_z ),
						new Vector2( c_x, 1 - c_z ),
						new Vector2( d_x, 1 - d_z )
					];
	
				} else {
	
					return [
						new Vector2( a_y, 1 - a_z ),
						new Vector2( b_y, 1 - b_z ),
						new Vector2( c_y, 1 - c_z ),
						new Vector2( d_y, 1 - d_z )
					];
	
				}
	
			}
		};
	
		/**
		 * @author zz85 / http://www.lab4games.net/zz85/blog
		 * @author alteredq / http://alteredqualia.com/
		 *
		 * Text = 3D Text
		 *
		 * parameters = {
		 *  font: <THREE.Font>, // font
		 *
		 *  size: <float>, // size of the text
		 *  height: <float>, // thickness to extrude text
		 *  curveSegments: <int>, // number of points on the curves
		 *
		 *  bevelEnabled: <bool>, // turn on bevel
		 *  bevelThickness: <float>, // how deep into text bevel goes
		 *  bevelSize: <float> // how far from text outline is bevel
		 * }
		 */
	
		// TextGeometry
	
		function TextGeometry( text, parameters ) {
	
			Geometry.call( this );
	
			this.type = 'TextGeometry';
	
			this.parameters = {
				text: text,
				parameters: parameters
			};
	
			this.fromBufferGeometry( new TextBufferGeometry( text, parameters ) );
			this.mergeVertices();
	
		}
	
		TextGeometry.prototype = Object.create( Geometry.prototype );
		TextGeometry.prototype.constructor = TextGeometry;
	
		// TextBufferGeometry
	
		function TextBufferGeometry( text, parameters ) {
	
			parameters = parameters || {};
	
			var font = parameters.font;
	
			if ( ! ( font && font.isFont ) ) {
	
				console.error( 'THREE.TextGeometry: font parameter is not an instance of THREE.Font.' );
				return new Geometry();
	
			}
	
			var shapes = font.generateShapes( text, parameters.size, parameters.curveSegments );
	
			// translate parameters to ExtrudeGeometry API
	
			parameters.amount = parameters.height !== undefined ? parameters.height : 50;
	
			// defaults
	
			if ( parameters.bevelThickness === undefined ) parameters.bevelThickness = 10;
			if ( parameters.bevelSize === undefined ) parameters.bevelSize = 8;
			if ( parameters.bevelEnabled === undefined ) parameters.bevelEnabled = false;
	
			ExtrudeBufferGeometry.call( this, shapes, parameters );
	
			this.type = 'TextBufferGeometry';
	
		}
	
		TextBufferGeometry.prototype = Object.create( ExtrudeBufferGeometry.prototype );
		TextBufferGeometry.prototype.constructor = TextBufferGeometry;
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author benaadams / https://twitter.com/ben_a_adams
		 * @author Mugen87 / https://github.com/Mugen87
		 */
	
		// SphereGeometry
	
		function SphereGeometry( radius, widthSegments, heightSegments, phiStart, phiLength, thetaStart, thetaLength ) {
	
			Geometry.call( this );
	
			this.type = 'SphereGeometry';
	
			this.parameters = {
				radius: radius,
				widthSegments: widthSegments,
				heightSegments: heightSegments,
				phiStart: phiStart,
				phiLength: phiLength,
				thetaStart: thetaStart,
				thetaLength: thetaLength
			};
	
			this.fromBufferGeometry( new SphereBufferGeometry( radius, widthSegments, heightSegments, phiStart, phiLength, thetaStart, thetaLength ) );
			this.mergeVertices();
	
		}
	
		SphereGeometry.prototype = Object.create( Geometry.prototype );
		SphereGeometry.prototype.constructor = SphereGeometry;
	
		// SphereBufferGeometry
	
		function SphereBufferGeometry( radius, widthSegments, heightSegments, phiStart, phiLength, thetaStart, thetaLength ) {
	
			BufferGeometry.call( this );
	
			this.type = 'SphereBufferGeometry';
	
			this.parameters = {
				radius: radius,
				widthSegments: widthSegments,
				heightSegments: heightSegments,
				phiStart: phiStart,
				phiLength: phiLength,
				thetaStart: thetaStart,
				thetaLength: thetaLength
			};
	
			radius = radius || 1;
	
			widthSegments = Math.max( 3, Math.floor( widthSegments ) || 8 );
			heightSegments = Math.max( 2, Math.floor( heightSegments ) || 6 );
	
			phiStart = phiStart !== undefined ? phiStart : 0;
			phiLength = phiLength !== undefined ? phiLength : Math.PI * 2;
	
			thetaStart = thetaStart !== undefined ? thetaStart : 0;
			thetaLength = thetaLength !== undefined ? thetaLength : Math.PI;
	
			var thetaEnd = thetaStart + thetaLength;
	
			var ix, iy;
	
			var index = 0;
			var grid = [];
	
			var vertex = new Vector3();
			var normal = new Vector3();
	
			// buffers
	
			var indices = [];
			var vertices = [];
			var normals = [];
			var uvs = [];
	
			// generate vertices, normals and uvs
	
			for ( iy = 0; iy <= heightSegments; iy ++ ) {
	
				var verticesRow = [];
	
				var v = iy / heightSegments;
	
				for ( ix = 0; ix <= widthSegments; ix ++ ) {
	
					var u = ix / widthSegments;
	
					// vertex
	
					vertex.x = - radius * Math.cos( phiStart + u * phiLength ) * Math.sin( thetaStart + v * thetaLength );
					vertex.y = radius * Math.cos( thetaStart + v * thetaLength );
					vertex.z = radius * Math.sin( phiStart + u * phiLength ) * Math.sin( thetaStart + v * thetaLength );
	
					vertices.push( vertex.x, vertex.y, vertex.z );
	
					// normal
	
					normal.set( vertex.x, vertex.y, vertex.z ).normalize();
					normals.push( normal.x, normal.y, normal.z );
	
					// uv
	
					uvs.push( u, 1 - v );
	
					verticesRow.push( index ++ );
	
				}
	
				grid.push( verticesRow );
	
			}
	
			// indices
	
			for ( iy = 0; iy < heightSegments; iy ++ ) {
	
				for ( ix = 0; ix < widthSegments; ix ++ ) {
	
					var a = grid[ iy ][ ix + 1 ];
					var b = grid[ iy ][ ix ];
					var c = grid[ iy + 1 ][ ix ];
					var d = grid[ iy + 1 ][ ix + 1 ];
	
					if ( iy !== 0 || thetaStart > 0 ) indices.push( a, b, d );
					if ( iy !== heightSegments - 1 || thetaEnd < Math.PI ) indices.push( b, c, d );
	
				}
	
			}
	
			// build geometry
	
			this.setIndex( indices );
			this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
			this.addAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
			this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );
	
		}
	
		SphereBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
		SphereBufferGeometry.prototype.constructor = SphereBufferGeometry;
	
		/**
		 * @author Kaleb Murphy
		 * @author Mugen87 / https://github.com/Mugen87
		 */
	
		// RingGeometry
	
		function RingGeometry( innerRadius, outerRadius, thetaSegments, phiSegments, thetaStart, thetaLength ) {
	
			Geometry.call( this );
	
			this.type = 'RingGeometry';
	
			this.parameters = {
				innerRadius: innerRadius,
				outerRadius: outerRadius,
				thetaSegments: thetaSegments,
				phiSegments: phiSegments,
				thetaStart: thetaStart,
				thetaLength: thetaLength
			};
	
			this.fromBufferGeometry( new RingBufferGeometry( innerRadius, outerRadius, thetaSegments, phiSegments, thetaStart, thetaLength ) );
			this.mergeVertices();
	
		}
	
		RingGeometry.prototype = Object.create( Geometry.prototype );
		RingGeometry.prototype.constructor = RingGeometry;
	
		// RingBufferGeometry
	
		function RingBufferGeometry( innerRadius, outerRadius, thetaSegments, phiSegments, thetaStart, thetaLength ) {
	
			BufferGeometry.call( this );
	
			this.type = 'RingBufferGeometry';
	
			this.parameters = {
				innerRadius: innerRadius,
				outerRadius: outerRadius,
				thetaSegments: thetaSegments,
				phiSegments: phiSegments,
				thetaStart: thetaStart,
				thetaLength: thetaLength
			};
	
			innerRadius = innerRadius || 0.5;
			outerRadius = outerRadius || 1;
	
			thetaStart = thetaStart !== undefined ? thetaStart : 0;
			thetaLength = thetaLength !== undefined ? thetaLength : Math.PI * 2;
	
			thetaSegments = thetaSegments !== undefined ? Math.max( 3, thetaSegments ) : 8;
			phiSegments = phiSegments !== undefined ? Math.max( 1, phiSegments ) : 1;
	
			// buffers
	
			var indices = [];
			var vertices = [];
			var normals = [];
			var uvs = [];
	
			// some helper variables
	
			var segment;
			var radius = innerRadius;
			var radiusStep = ( ( outerRadius - innerRadius ) / phiSegments );
			var vertex = new Vector3();
			var uv = new Vector2();
			var j, i;
	
			// generate vertices, normals and uvs
	
			for ( j = 0; j <= phiSegments; j ++ ) {
	
				for ( i = 0; i <= thetaSegments; i ++ ) {
	
					// values are generate from the inside of the ring to the outside
	
					segment = thetaStart + i / thetaSegments * thetaLength;
	
					// vertex
	
					vertex.x = radius * Math.cos( segment );
					vertex.y = radius * Math.sin( segment );
	
					vertices.push( vertex.x, vertex.y, vertex.z );
	
					// normal
	
					normals.push( 0, 0, 1 );
	
					// uv
	
					uv.x = ( vertex.x / outerRadius + 1 ) / 2;
					uv.y = ( vertex.y / outerRadius + 1 ) / 2;
	
					uvs.push( uv.x, uv.y );
	
				}
	
				// increase the radius for next row of vertices
	
				radius += radiusStep;
	
			}
	
			// indices
	
			for ( j = 0; j < phiSegments; j ++ ) {
	
				var thetaSegmentLevel = j * ( thetaSegments + 1 );
	
				for ( i = 0; i < thetaSegments; i ++ ) {
	
					segment = i + thetaSegmentLevel;
	
					var a = segment;
					var b = segment + thetaSegments + 1;
					var c = segment + thetaSegments + 2;
					var d = segment + 1;
	
					// faces
	
					indices.push( a, b, d );
					indices.push( b, c, d );
	
				}
	
			}
	
			// build geometry
	
			this.setIndex( indices );
			this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
			this.addAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
			this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );
	
		}
	
		RingBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
		RingBufferGeometry.prototype.constructor = RingBufferGeometry;
	
		/**
		 * @author astrodud / http://astrodud.isgreat.org/
		 * @author zz85 / https://github.com/zz85
		 * @author bhouston / http://clara.io
		 * @author Mugen87 / https://github.com/Mugen87
		 */
	
		// LatheGeometry
	
		function LatheGeometry( points, segments, phiStart, phiLength ) {
	
			Geometry.call( this );
	
			this.type = 'LatheGeometry';
	
			this.parameters = {
				points: points,
				segments: segments,
				phiStart: phiStart,
				phiLength: phiLength
			};
	
			this.fromBufferGeometry( new LatheBufferGeometry( points, segments, phiStart, phiLength ) );
			this.mergeVertices();
	
		}
	
		LatheGeometry.prototype = Object.create( Geometry.prototype );
		LatheGeometry.prototype.constructor = LatheGeometry;
	
		// LatheBufferGeometry
	
		function LatheBufferGeometry( points, segments, phiStart, phiLength ) {
	
			BufferGeometry.call( this );
	
			this.type = 'LatheBufferGeometry';
	
			this.parameters = {
				points: points,
				segments: segments,
				phiStart: phiStart,
				phiLength: phiLength
			};
	
			segments = Math.floor( segments ) || 12;
			phiStart = phiStart || 0;
			phiLength = phiLength || Math.PI * 2;
	
			// clamp phiLength so it's in range of [ 0, 2PI ]
	
			phiLength = _Math.clamp( phiLength, 0, Math.PI * 2 );
	
	
			// buffers
	
			var indices = [];
			var vertices = [];
			var uvs = [];
	
			// helper variables
	
			var base;
			var inverseSegments = 1.0 / segments;
			var vertex = new Vector3();
			var uv = new Vector2();
			var i, j;
	
			// generate vertices and uvs
	
			for ( i = 0; i <= segments; i ++ ) {
	
				var phi = phiStart + i * inverseSegments * phiLength;
	
				var sin = Math.sin( phi );
				var cos = Math.cos( phi );
	
				for ( j = 0; j <= ( points.length - 1 ); j ++ ) {
	
					// vertex
	
					vertex.x = points[ j ].x * sin;
					vertex.y = points[ j ].y;
					vertex.z = points[ j ].x * cos;
	
					vertices.push( vertex.x, vertex.y, vertex.z );
	
					// uv
	
					uv.x = i / segments;
					uv.y = j / ( points.length - 1 );
	
					uvs.push( uv.x, uv.y );
	
	
				}
	
			}
	
			// indices
	
			for ( i = 0; i < segments; i ++ ) {
	
				for ( j = 0; j < ( points.length - 1 ); j ++ ) {
	
					base = j + i * points.length;
	
					var a = base;
					var b = base + points.length;
					var c = base + points.length + 1;
					var d = base + 1;
	
					// faces
	
					indices.push( a, b, d );
					indices.push( b, c, d );
	
				}
	
			}
	
			// build geometry
	
			this.setIndex( indices );
			this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
			this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );
	
			// generate normals
	
			this.computeVertexNormals();
	
			// if the geometry is closed, we need to average the normals along the seam.
			// because the corresponding vertices are identical (but still have different UVs).
	
			if ( phiLength === Math.PI * 2 ) {
	
				var normals = this.attributes.normal.array;
				var n1 = new Vector3();
				var n2 = new Vector3();
				var n = new Vector3();
	
				// this is the buffer offset for the last line of vertices
	
				base = segments * points.length * 3;
	
				for ( i = 0, j = 0; i < points.length; i ++, j += 3 ) {
	
					// select the normal of the vertex in the first line
	
					n1.x = normals[ j + 0 ];
					n1.y = normals[ j + 1 ];
					n1.z = normals[ j + 2 ];
	
					// select the normal of the vertex in the last line
	
					n2.x = normals[ base + j + 0 ];
					n2.y = normals[ base + j + 1 ];
					n2.z = normals[ base + j + 2 ];
	
					// average normals
	
					n.addVectors( n1, n2 ).normalize();
	
					// assign the new values to both normals
	
					normals[ j + 0 ] = normals[ base + j + 0 ] = n.x;
					normals[ j + 1 ] = normals[ base + j + 1 ] = n.y;
					normals[ j + 2 ] = normals[ base + j + 2 ] = n.z;
	
				}
	
			}
	
		}
	
		LatheBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
		LatheBufferGeometry.prototype.constructor = LatheBufferGeometry;
	
		/**
		 * @author jonobr1 / http://jonobr1.com
		 * @author Mugen87 / https://github.com/Mugen87
		 */
	
		// ShapeGeometry
	
		function ShapeGeometry( shapes, curveSegments ) {
	
			Geometry.call( this );
	
			this.type = 'ShapeGeometry';
	
			if ( typeof curveSegments === 'object' ) {
	
				console.warn( 'THREE.ShapeGeometry: Options parameter has been removed.' );
	
				curveSegments = curveSegments.curveSegments;
	
			}
	
			this.parameters = {
				shapes: shapes,
				curveSegments: curveSegments
			};
	
			this.fromBufferGeometry( new ShapeBufferGeometry( shapes, curveSegments ) );
			this.mergeVertices();
	
		}
	
		ShapeGeometry.prototype = Object.create( Geometry.prototype );
		ShapeGeometry.prototype.constructor = ShapeGeometry;
	
		ShapeGeometry.prototype.toJSON = function () {
	
			var data = Geometry.prototype.toJSON.call( this );
	
			var shapes = this.parameters.shapes;
	
			return toJSON( shapes, data );
	
		};
	
		// ShapeBufferGeometry
	
		function ShapeBufferGeometry( shapes, curveSegments ) {
	
			BufferGeometry.call( this );
	
			this.type = 'ShapeBufferGeometry';
	
			this.parameters = {
				shapes: shapes,
				curveSegments: curveSegments
			};
	
			curveSegments = curveSegments || 12;
	
			// buffers
	
			var indices = [];
			var vertices = [];
			var normals = [];
			var uvs = [];
	
			// helper variables
	
			var groupStart = 0;
			var groupCount = 0;
	
			// allow single and array values for "shapes" parameter
	
			if ( Array.isArray( shapes ) === false ) {
	
				addShape( shapes );
	
			} else {
	
				for ( var i = 0; i < shapes.length; i ++ ) {
	
					addShape( shapes[ i ] );
	
					this.addGroup( groupStart, groupCount, i ); // enables MultiMaterial support
	
					groupStart += groupCount;
					groupCount = 0;
	
				}
	
			}
	
			// build geometry
	
			this.setIndex( indices );
			this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
			this.addAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
			this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );
	
	
			// helper functions
	
			function addShape( shape ) {
	
				var i, l, shapeHole;
	
				var indexOffset = vertices.length / 3;
				var points = shape.extractPoints( curveSegments );
	
				var shapeVertices = points.shape;
				var shapeHoles = points.holes;
	
				// check direction of vertices
	
				if ( ShapeUtils.isClockWise( shapeVertices ) === false ) {
	
					shapeVertices = shapeVertices.reverse();
	
					// also check if holes are in the opposite direction
	
					for ( i = 0, l = shapeHoles.length; i < l; i ++ ) {
	
						shapeHole = shapeHoles[ i ];
	
						if ( ShapeUtils.isClockWise( shapeHole ) === true ) {
	
							shapeHoles[ i ] = shapeHole.reverse();
	
						}
	
					}
	
				}
	
				var faces = ShapeUtils.triangulateShape( shapeVertices, shapeHoles );
	
				// join vertices of inner and outer paths to a single array
	
				for ( i = 0, l = shapeHoles.length; i < l; i ++ ) {
	
					shapeHole = shapeHoles[ i ];
					shapeVertices = shapeVertices.concat( shapeHole );
	
				}
	
				// vertices, normals, uvs
	
				for ( i = 0, l = shapeVertices.length; i < l; i ++ ) {
	
					var vertex = shapeVertices[ i ];
	
					vertices.push( vertex.x, vertex.y, 0 );
					normals.push( 0, 0, 1 );
					uvs.push( vertex.x, vertex.y ); // world uvs
	
				}
	
				// incides
	
				for ( i = 0, l = faces.length; i < l; i ++ ) {
	
					var face = faces[ i ];
	
					var a = face[ 0 ] + indexOffset;
					var b = face[ 1 ] + indexOffset;
					var c = face[ 2 ] + indexOffset;
	
					indices.push( a, b, c );
					groupCount += 3;
	
				}
	
			}
	
		}
	
		ShapeBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
		ShapeBufferGeometry.prototype.constructor = ShapeBufferGeometry;
	
		ShapeBufferGeometry.prototype.toJSON = function () {
	
			var data = BufferGeometry.prototype.toJSON.call( this );
	
			var shapes = this.parameters.shapes;
	
			return toJSON( shapes, data );
	
		};
	
		//
	
		function toJSON( shapes, data ) {
	
			data.shapes = [];
	
			if ( Array.isArray( shapes ) ) {
	
				for ( var i = 0, l = shapes.length; i < l; i ++ ) {
	
					var shape = shapes[ i ];
	
					data.shapes.push( shape.uuid );
	
				}
	
			} else {
	
				data.shapes.push( shapes.uuid );
	
			}
	
			return data;
	
		}
	
		/**
		 * @author WestLangley / http://github.com/WestLangley
		 * @author Mugen87 / https://github.com/Mugen87
		 */
	
		function EdgesGeometry( geometry, thresholdAngle ) {
	
			BufferGeometry.call( this );
	
			this.type = 'EdgesGeometry';
	
			this.parameters = {
				thresholdAngle: thresholdAngle
			};
	
			thresholdAngle = ( thresholdAngle !== undefined ) ? thresholdAngle : 1;
	
			// buffer
	
			var vertices = [];
	
			// helper variables
	
			var thresholdDot = Math.cos( _Math.DEG2RAD * thresholdAngle );
			var edge = [ 0, 0 ], edges = {}, edge1, edge2;
			var key, keys = [ 'a', 'b', 'c' ];
	
			// prepare source geometry
	
			var geometry2;
	
			if ( geometry.isBufferGeometry ) {
	
				geometry2 = new Geometry();
				geometry2.fromBufferGeometry( geometry );
	
			} else {
	
				geometry2 = geometry.clone();
	
			}
	
			geometry2.mergeVertices();
			geometry2.computeFaceNormals();
	
			var sourceVertices = geometry2.vertices;
			var faces = geometry2.faces;
	
			// now create a data structure where each entry represents an edge with its adjoining faces
	
			for ( var i = 0, l = faces.length; i < l; i ++ ) {
	
				var face = faces[ i ];
	
				for ( var j = 0; j < 3; j ++ ) {
	
					edge1 = face[ keys[ j ] ];
					edge2 = face[ keys[ ( j + 1 ) % 3 ] ];
					edge[ 0 ] = Math.min( edge1, edge2 );
					edge[ 1 ] = Math.max( edge1, edge2 );
	
					key = edge[ 0 ] + ',' + edge[ 1 ];
	
					if ( edges[ key ] === undefined ) {
	
						edges[ key ] = { index1: edge[ 0 ], index2: edge[ 1 ], face1: i, face2: undefined };
	
					} else {
	
						edges[ key ].face2 = i;
	
					}
	
				}
	
			}
	
			// generate vertices
	
			for ( key in edges ) {
	
				var e = edges[ key ];
	
				// an edge is only rendered if the angle (in degrees) between the face normals of the adjoining faces exceeds this value. default = 1 degree.
	
				if ( e.face2 === undefined || faces[ e.face1 ].normal.dot( faces[ e.face2 ].normal ) <= thresholdDot ) {
	
					var vertex = sourceVertices[ e.index1 ];
					vertices.push( vertex.x, vertex.y, vertex.z );
	
					vertex = sourceVertices[ e.index2 ];
					vertices.push( vertex.x, vertex.y, vertex.z );
	
				}
	
			}
	
			// build geometry
	
			this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
	
		}
	
		EdgesGeometry.prototype = Object.create( BufferGeometry.prototype );
		EdgesGeometry.prototype.constructor = EdgesGeometry;
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author Mugen87 / https://github.com/Mugen87
		 */
	
		// CylinderGeometry
	
		function CylinderGeometry( radiusTop, radiusBottom, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength ) {
	
			Geometry.call( this );
	
			this.type = 'CylinderGeometry';
	
			this.parameters = {
				radiusTop: radiusTop,
				radiusBottom: radiusBottom,
				height: height,
				radialSegments: radialSegments,
				heightSegments: heightSegments,
				openEnded: openEnded,
				thetaStart: thetaStart,
				thetaLength: thetaLength
			};
	
			this.fromBufferGeometry( new CylinderBufferGeometry( radiusTop, radiusBottom, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength ) );
			this.mergeVertices();
	
		}
	
		CylinderGeometry.prototype = Object.create( Geometry.prototype );
		CylinderGeometry.prototype.constructor = CylinderGeometry;
	
		// CylinderBufferGeometry
	
		function CylinderBufferGeometry( radiusTop, radiusBottom, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength ) {
	
			BufferGeometry.call( this );
	
			this.type = 'CylinderBufferGeometry';
	
			this.parameters = {
				radiusTop: radiusTop,
				radiusBottom: radiusBottom,
				height: height,
				radialSegments: radialSegments,
				heightSegments: heightSegments,
				openEnded: openEnded,
				thetaStart: thetaStart,
				thetaLength: thetaLength
			};
	
			var scope = this;
	
			radiusTop = radiusTop !== undefined ? radiusTop : 1;
			radiusBottom = radiusBottom !== undefined ? radiusBottom : 1;
			height = height || 1;
	
			radialSegments = Math.floor( radialSegments ) || 8;
			heightSegments = Math.floor( heightSegments ) || 1;
	
			openEnded = openEnded !== undefined ? openEnded : false;
			thetaStart = thetaStart !== undefined ? thetaStart : 0.0;
			thetaLength = thetaLength !== undefined ? thetaLength : Math.PI * 2;
	
			// buffers
	
			var indices = [];
			var vertices = [];
			var normals = [];
			var uvs = [];
	
			// helper variables
	
			var index = 0;
			var indexArray = [];
			var halfHeight = height / 2;
			var groupStart = 0;
	
			// generate geometry
	
			generateTorso();
	
			if ( openEnded === false ) {
	
				if ( radiusTop > 0 ) generateCap( true );
				if ( radiusBottom > 0 ) generateCap( false );
	
			}
	
			// build geometry
	
			this.setIndex( indices );
			this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
			this.addAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
			this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );
	
			function generateTorso() {
	
				var x, y;
				var normal = new Vector3();
				var vertex = new Vector3();
	
				var groupCount = 0;
	
				// this will be used to calculate the normal
				var slope = ( radiusBottom - radiusTop ) / height;
	
				// generate vertices, normals and uvs
	
				for ( y = 0; y <= heightSegments; y ++ ) {
	
					var indexRow = [];
	
					var v = y / heightSegments;
	
					// calculate the radius of the current row
	
					var radius = v * ( radiusBottom - radiusTop ) + radiusTop;
	
					for ( x = 0; x <= radialSegments; x ++ ) {
	
						var u = x / radialSegments;
	
						var theta = u * thetaLength + thetaStart;
	
						var sinTheta = Math.sin( theta );
						var cosTheta = Math.cos( theta );
	
						// vertex
	
						vertex.x = radius * sinTheta;
						vertex.y = - v * height + halfHeight;
						vertex.z = radius * cosTheta;
						vertices.push( vertex.x, vertex.y, vertex.z );
	
						// normal
	
						normal.set( sinTheta, slope, cosTheta ).normalize();
						normals.push( normal.x, normal.y, normal.z );
	
						// uv
	
						uvs.push( u, 1 - v );
	
						// save index of vertex in respective row
	
						indexRow.push( index ++ );
	
					}
	
					// now save vertices of the row in our index array
	
					indexArray.push( indexRow );
	
				}
	
				// generate indices
	
				for ( x = 0; x < radialSegments; x ++ ) {
	
					for ( y = 0; y < heightSegments; y ++ ) {
	
						// we use the index array to access the correct indices
	
						var a = indexArray[ y ][ x ];
						var b = indexArray[ y + 1 ][ x ];
						var c = indexArray[ y + 1 ][ x + 1 ];
						var d = indexArray[ y ][ x + 1 ];
	
						// faces
	
						indices.push( a, b, d );
						indices.push( b, c, d );
	
						// update group counter
	
						groupCount += 6;
	
					}
	
				}
	
				// add a group to the geometry. this will ensure multi material support
	
				scope.addGroup( groupStart, groupCount, 0 );
	
				// calculate new start value for groups
	
				groupStart += groupCount;
	
			}
	
			function generateCap( top ) {
	
				var x, centerIndexStart, centerIndexEnd;
	
				var uv = new Vector2();
				var vertex = new Vector3();
	
				var groupCount = 0;
	
				var radius = ( top === true ) ? radiusTop : radiusBottom;
				var sign = ( top === true ) ? 1 : - 1;
	
				// save the index of the first center vertex
				centerIndexStart = index;
	
				// first we generate the center vertex data of the cap.
				// because the geometry needs one set of uvs per face,
				// we must generate a center vertex per face/segment
	
				for ( x = 1; x <= radialSegments; x ++ ) {
	
					// vertex
	
					vertices.push( 0, halfHeight * sign, 0 );
	
					// normal
	
					normals.push( 0, sign, 0 );
	
					// uv
	
					uvs.push( 0.5, 0.5 );
	
					// increase index
	
					index ++;
	
				}
	
				// save the index of the last center vertex
	
				centerIndexEnd = index;
	
				// now we generate the surrounding vertices, normals and uvs
	
				for ( x = 0; x <= radialSegments; x ++ ) {
	
					var u = x / radialSegments;
					var theta = u * thetaLength + thetaStart;
	
					var cosTheta = Math.cos( theta );
					var sinTheta = Math.sin( theta );
	
					// vertex
	
					vertex.x = radius * sinTheta;
					vertex.y = halfHeight * sign;
					vertex.z = radius * cosTheta;
					vertices.push( vertex.x, vertex.y, vertex.z );
	
					// normal
	
					normals.push( 0, sign, 0 );
	
					// uv
	
					uv.x = ( cosTheta * 0.5 ) + 0.5;
					uv.y = ( sinTheta * 0.5 * sign ) + 0.5;
					uvs.push( uv.x, uv.y );
	
					// increase index
	
					index ++;
	
				}
	
				// generate indices
	
				for ( x = 0; x < radialSegments; x ++ ) {
	
					var c = centerIndexStart + x;
					var i = centerIndexEnd + x;
	
					if ( top === true ) {
	
						// face top
	
						indices.push( i, i + 1, c );
	
					} else {
	
						// face bottom
	
						indices.push( i + 1, i, c );
	
					}
	
					groupCount += 3;
	
				}
	
				// add a group to the geometry. this will ensure multi material support
	
				scope.addGroup( groupStart, groupCount, top === true ? 1 : 2 );
	
				// calculate new start value for groups
	
				groupStart += groupCount;
	
			}
	
		}
	
		CylinderBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
		CylinderBufferGeometry.prototype.constructor = CylinderBufferGeometry;
	
		/**
		 * @author abelnation / http://github.com/abelnation
		 */
	
		// ConeGeometry
	
		function ConeGeometry( radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength ) {
	
			CylinderGeometry.call( this, 0, radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength );
	
			this.type = 'ConeGeometry';
	
			this.parameters = {
				radius: radius,
				height: height,
				radialSegments: radialSegments,
				heightSegments: heightSegments,
				openEnded: openEnded,
				thetaStart: thetaStart,
				thetaLength: thetaLength
			};
	
		}
	
		ConeGeometry.prototype = Object.create( CylinderGeometry.prototype );
		ConeGeometry.prototype.constructor = ConeGeometry;
	
		// ConeBufferGeometry
	
		function ConeBufferGeometry( radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength ) {
	
			CylinderBufferGeometry.call( this, 0, radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength );
	
			this.type = 'ConeBufferGeometry';
	
			this.parameters = {
				radius: radius,
				height: height,
				radialSegments: radialSegments,
				heightSegments: heightSegments,
				openEnded: openEnded,
				thetaStart: thetaStart,
				thetaLength: thetaLength
			};
	
		}
	
		ConeBufferGeometry.prototype = Object.create( CylinderBufferGeometry.prototype );
		ConeBufferGeometry.prototype.constructor = ConeBufferGeometry;
	
		/**
		 * @author benaadams / https://twitter.com/ben_a_adams
		 * @author Mugen87 / https://github.com/Mugen87
		 * @author hughes
		 */
	
		// CircleGeometry
	
		function CircleGeometry( radius, segments, thetaStart, thetaLength ) {
	
			Geometry.call( this );
	
			this.type = 'CircleGeometry';
	
			this.parameters = {
				radius: radius,
				segments: segments,
				thetaStart: thetaStart,
				thetaLength: thetaLength
			};
	
			this.fromBufferGeometry( new CircleBufferGeometry( radius, segments, thetaStart, thetaLength ) );
			this.mergeVertices();
	
		}
	
		CircleGeometry.prototype = Object.create( Geometry.prototype );
		CircleGeometry.prototype.constructor = CircleGeometry;
	
		// CircleBufferGeometry
	
		function CircleBufferGeometry( radius, segments, thetaStart, thetaLength ) {
	
			BufferGeometry.call( this );
	
			this.type = 'CircleBufferGeometry';
	
			this.parameters = {
				radius: radius,
				segments: segments,
				thetaStart: thetaStart,
				thetaLength: thetaLength
			};
	
			radius = radius || 1;
			segments = segments !== undefined ? Math.max( 3, segments ) : 8;
	
			thetaStart = thetaStart !== undefined ? thetaStart : 0;
			thetaLength = thetaLength !== undefined ? thetaLength : Math.PI * 2;
	
			// buffers
	
			var indices = [];
			var vertices = [];
			var normals = [];
			var uvs = [];
	
			// helper variables
	
			var i, s;
			var vertex = new Vector3();
			var uv = new Vector2();
	
			// center point
	
			vertices.push( 0, 0, 0 );
			normals.push( 0, 0, 1 );
			uvs.push( 0.5, 0.5 );
	
			for ( s = 0, i = 3; s <= segments; s ++, i += 3 ) {
	
				var segment = thetaStart + s / segments * thetaLength;
	
				// vertex
	
				vertex.x = radius * Math.cos( segment );
				vertex.y = radius * Math.sin( segment );
	
				vertices.push( vertex.x, vertex.y, vertex.z );
	
				// normal
	
				normals.push( 0, 0, 1 );
	
				// uvs
	
				uv.x = ( vertices[ i ] / radius + 1 ) / 2;
				uv.y = ( vertices[ i + 1 ] / radius + 1 ) / 2;
	
				uvs.push( uv.x, uv.y );
	
			}
	
			// indices
	
			for ( i = 1; i <= segments; i ++ ) {
	
				indices.push( i, i + 1, 0 );
	
			}
	
			// build geometry
	
			this.setIndex( indices );
			this.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
			this.addAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
			this.addAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );
	
		}
	
		CircleBufferGeometry.prototype = Object.create( BufferGeometry.prototype );
		CircleBufferGeometry.prototype.constructor = CircleBufferGeometry;
	
	
	
		var Geometries = Object.freeze({
			WireframeGeometry: WireframeGeometry,
			ParametricGeometry: ParametricGeometry,
			ParametricBufferGeometry: ParametricBufferGeometry,
			TetrahedronGeometry: TetrahedronGeometry,
			TetrahedronBufferGeometry: TetrahedronBufferGeometry,
			OctahedronGeometry: OctahedronGeometry,
			OctahedronBufferGeometry: OctahedronBufferGeometry,
			IcosahedronGeometry: IcosahedronGeometry,
			IcosahedronBufferGeometry: IcosahedronBufferGeometry,
			DodecahedronGeometry: DodecahedronGeometry,
			DodecahedronBufferGeometry: DodecahedronBufferGeometry,
			PolyhedronGeometry: PolyhedronGeometry,
			PolyhedronBufferGeometry: PolyhedronBufferGeometry,
			TubeGeometry: TubeGeometry,
			TubeBufferGeometry: TubeBufferGeometry,
			TorusKnotGeometry: TorusKnotGeometry,
			TorusKnotBufferGeometry: TorusKnotBufferGeometry,
			TorusGeometry: TorusGeometry,
			TorusBufferGeometry: TorusBufferGeometry,
			TextGeometry: TextGeometry,
			TextBufferGeometry: TextBufferGeometry,
			SphereGeometry: SphereGeometry,
			SphereBufferGeometry: SphereBufferGeometry,
			RingGeometry: RingGeometry,
			RingBufferGeometry: RingBufferGeometry,
			PlaneGeometry: PlaneGeometry,
			PlaneBufferGeometry: PlaneBufferGeometry,
			LatheGeometry: LatheGeometry,
			LatheBufferGeometry: LatheBufferGeometry,
			ShapeGeometry: ShapeGeometry,
			ShapeBufferGeometry: ShapeBufferGeometry,
			ExtrudeGeometry: ExtrudeGeometry,
			ExtrudeBufferGeometry: ExtrudeBufferGeometry,
			EdgesGeometry: EdgesGeometry,
			ConeGeometry: ConeGeometry,
			ConeBufferGeometry: ConeBufferGeometry,
			CylinderGeometry: CylinderGeometry,
			CylinderBufferGeometry: CylinderBufferGeometry,
			CircleGeometry: CircleGeometry,
			CircleBufferGeometry: CircleBufferGeometry,
			BoxGeometry: BoxGeometry,
			BoxBufferGeometry: BoxBufferGeometry
		});
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 *
		 * parameters = {
		 *  color: <THREE.Color>,
		 *  opacity: <float>
		 * }
		 */
	
		function ShadowMaterial( parameters ) {
	
			Material.call( this );
	
			this.type = 'ShadowMaterial';
	
			this.color = new Color( 0x000000 );
			this.opacity = 1.0;
	
			this.lights = true;
			this.transparent = true;
	
			this.setValues( parameters );
	
		}
	
		ShadowMaterial.prototype = Object.create( Material.prototype );
		ShadowMaterial.prototype.constructor = ShadowMaterial;
	
		ShadowMaterial.prototype.isShadowMaterial = true;
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function RawShaderMaterial( parameters ) {
	
			ShaderMaterial.call( this, parameters );
	
			this.type = 'RawShaderMaterial';
	
		}
	
		RawShaderMaterial.prototype = Object.create( ShaderMaterial.prototype );
		RawShaderMaterial.prototype.constructor = RawShaderMaterial;
	
		RawShaderMaterial.prototype.isRawShaderMaterial = true;
	
		/**
		 * @author WestLangley / http://github.com/WestLangley
		 *
		 * parameters = {
		 *  color: <hex>,
		 *  roughness: <float>,
		 *  metalness: <float>,
		 *  opacity: <float>,
		 *
		 *  map: new THREE.Texture( <Image> ),
		 *
		 *  lightMap: new THREE.Texture( <Image> ),
		 *  lightMapIntensity: <float>
		 *
		 *  aoMap: new THREE.Texture( <Image> ),
		 *  aoMapIntensity: <float>
		 *
		 *  emissive: <hex>,
		 *  emissiveIntensity: <float>
		 *  emissiveMap: new THREE.Texture( <Image> ),
		 *
		 *  bumpMap: new THREE.Texture( <Image> ),
		 *  bumpScale: <float>,
		 *
		 *  normalMap: new THREE.Texture( <Image> ),
		 *  normalScale: <Vector2>,
		 *
		 *  displacementMap: new THREE.Texture( <Image> ),
		 *  displacementScale: <float>,
		 *  displacementBias: <float>,
		 *
		 *  roughnessMap: new THREE.Texture( <Image> ),
		 *
		 *  metalnessMap: new THREE.Texture( <Image> ),
		 *
		 *  alphaMap: new THREE.Texture( <Image> ),
		 *
		 *  envMap: new THREE.CubeTexture( [posx, negx, posy, negy, posz, negz] ),
		 *  envMapIntensity: <float>
		 *
		 *  refractionRatio: <float>,
		 *
		 *  wireframe: <boolean>,
		 *  wireframeLinewidth: <float>,
		 *
		 *  skinning: <bool>,
		 *  morphTargets: <bool>,
		 *  morphNormals: <bool>
		 * }
		 */
	
		function MeshStandardMaterial( parameters ) {
	
			Material.call( this );
	
			this.defines = { 'STANDARD': '' };
	
			this.type = 'MeshStandardMaterial';
	
			this.color = new Color( 0xffffff ); // diffuse
			this.roughness = 0.5;
			this.metalness = 0.5;
	
			this.map = null;
	
			this.lightMap = null;
			this.lightMapIntensity = 1.0;
	
			this.aoMap = null;
			this.aoMapIntensity = 1.0;
	
			this.emissive = new Color( 0x000000 );
			this.emissiveIntensity = 1.0;
			this.emissiveMap = null;
	
			this.bumpMap = null;
			this.bumpScale = 1;
	
			this.normalMap = null;
			this.normalScale = new Vector2( 1, 1 );
	
			this.displacementMap = null;
			this.displacementScale = 1;
			this.displacementBias = 0;
	
			this.roughnessMap = null;
	
			this.metalnessMap = null;
	
			this.alphaMap = null;
	
			this.envMap = null;
			this.envMapIntensity = 1.0;
	
			this.refractionRatio = 0.98;
	
			this.wireframe = false;
			this.wireframeLinewidth = 1;
			this.wireframeLinecap = 'round';
			this.wireframeLinejoin = 'round';
	
			this.skinning = false;
			this.morphTargets = false;
			this.morphNormals = false;
	
			this.setValues( parameters );
	
		}
	
		MeshStandardMaterial.prototype = Object.create( Material.prototype );
		MeshStandardMaterial.prototype.constructor = MeshStandardMaterial;
	
		MeshStandardMaterial.prototype.isMeshStandardMaterial = true;
	
		MeshStandardMaterial.prototype.copy = function ( source ) {
	
			Material.prototype.copy.call( this, source );
	
			this.defines = { 'STANDARD': '' };
	
			this.color.copy( source.color );
			this.roughness = source.roughness;
			this.metalness = source.metalness;
	
			this.map = source.map;
	
			this.lightMap = source.lightMap;
			this.lightMapIntensity = source.lightMapIntensity;
	
			this.aoMap = source.aoMap;
			this.aoMapIntensity = source.aoMapIntensity;
	
			this.emissive.copy( source.emissive );
			this.emissiveMap = source.emissiveMap;
			this.emissiveIntensity = source.emissiveIntensity;
	
			this.bumpMap = source.bumpMap;
			this.bumpScale = source.bumpScale;
	
			this.normalMap = source.normalMap;
			this.normalScale.copy( source.normalScale );
	
			this.displacementMap = source.displacementMap;
			this.displacementScale = source.displacementScale;
			this.displacementBias = source.displacementBias;
	
			this.roughnessMap = source.roughnessMap;
	
			this.metalnessMap = source.metalnessMap;
	
			this.alphaMap = source.alphaMap;
	
			this.envMap = source.envMap;
			this.envMapIntensity = source.envMapIntensity;
	
			this.refractionRatio = source.refractionRatio;
	
			this.wireframe = source.wireframe;
			this.wireframeLinewidth = source.wireframeLinewidth;
			this.wireframeLinecap = source.wireframeLinecap;
			this.wireframeLinejoin = source.wireframeLinejoin;
	
			this.skinning = source.skinning;
			this.morphTargets = source.morphTargets;
			this.morphNormals = source.morphNormals;
	
			return this;
	
		};
	
		/**
		 * @author WestLangley / http://github.com/WestLangley
		 *
		 * parameters = {
		 *  reflectivity: <float>
		 * }
		 */
	
		function MeshPhysicalMaterial( parameters ) {
	
			MeshStandardMaterial.call( this );
	
			this.defines = { 'PHYSICAL': '' };
	
			this.type = 'MeshPhysicalMaterial';
	
			this.reflectivity = 0.5; // maps to F0 = 0.04
	
			this.clearCoat = 0.0;
			this.clearCoatRoughness = 0.0;
	
			this.setValues( parameters );
	
		}
	
		MeshPhysicalMaterial.prototype = Object.create( MeshStandardMaterial.prototype );
		MeshPhysicalMaterial.prototype.constructor = MeshPhysicalMaterial;
	
		MeshPhysicalMaterial.prototype.isMeshPhysicalMaterial = true;
	
		MeshPhysicalMaterial.prototype.copy = function ( source ) {
	
			MeshStandardMaterial.prototype.copy.call( this, source );
	
			this.defines = { 'PHYSICAL': '' };
	
			this.reflectivity = source.reflectivity;
	
			this.clearCoat = source.clearCoat;
			this.clearCoatRoughness = source.clearCoatRoughness;
	
			return this;
	
		};
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author alteredq / http://alteredqualia.com/
		 *
		 * parameters = {
		 *  color: <hex>,
		 *  specular: <hex>,
		 *  shininess: <float>,
		 *  opacity: <float>,
		 *
		 *  map: new THREE.Texture( <Image> ),
		 *
		 *  lightMap: new THREE.Texture( <Image> ),
		 *  lightMapIntensity: <float>
		 *
		 *  aoMap: new THREE.Texture( <Image> ),
		 *  aoMapIntensity: <float>
		 *
		 *  emissive: <hex>,
		 *  emissiveIntensity: <float>
		 *  emissiveMap: new THREE.Texture( <Image> ),
		 *
		 *  bumpMap: new THREE.Texture( <Image> ),
		 *  bumpScale: <float>,
		 *
		 *  normalMap: new THREE.Texture( <Image> ),
		 *  normalScale: <Vector2>,
		 *
		 *  displacementMap: new THREE.Texture( <Image> ),
		 *  displacementScale: <float>,
		 *  displacementBias: <float>,
		 *
		 *  specularMap: new THREE.Texture( <Image> ),
		 *
		 *  alphaMap: new THREE.Texture( <Image> ),
		 *
		 *  envMap: new THREE.TextureCube( [posx, negx, posy, negy, posz, negz] ),
		 *  combine: THREE.Multiply,
		 *  reflectivity: <float>,
		 *  refractionRatio: <float>,
		 *
		 *  wireframe: <boolean>,
		 *  wireframeLinewidth: <float>,
		 *
		 *  skinning: <bool>,
		 *  morphTargets: <bool>,
		 *  morphNormals: <bool>
		 * }
		 */
	
		function MeshPhongMaterial( parameters ) {
	
			Material.call( this );
	
			this.type = 'MeshPhongMaterial';
	
			this.color = new Color( 0xffffff ); // diffuse
			this.specular = new Color( 0x111111 );
			this.shininess = 30;
	
			this.map = null;
	
			this.lightMap = null;
			this.lightMapIntensity = 1.0;
	
			this.aoMap = null;
			this.aoMapIntensity = 1.0;
	
			this.emissive = new Color( 0x000000 );
			this.emissiveIntensity = 1.0;
			this.emissiveMap = null;
	
			this.bumpMap = null;
			this.bumpScale = 1;
	
			this.normalMap = null;
			this.normalScale = new Vector2( 1, 1 );
	
			this.displacementMap = null;
			this.displacementScale = 1;
			this.displacementBias = 0;
	
			this.specularMap = null;
	
			this.alphaMap = null;
	
			this.envMap = null;
			this.combine = MultiplyOperation;
			this.reflectivity = 1;
			this.refractionRatio = 0.98;
	
			this.wireframe = false;
			this.wireframeLinewidth = 1;
			this.wireframeLinecap = 'round';
			this.wireframeLinejoin = 'round';
	
			this.skinning = false;
			this.morphTargets = false;
			this.morphNormals = false;
	
			this.setValues( parameters );
	
		}
	
		MeshPhongMaterial.prototype = Object.create( Material.prototype );
		MeshPhongMaterial.prototype.constructor = MeshPhongMaterial;
	
		MeshPhongMaterial.prototype.isMeshPhongMaterial = true;
	
		MeshPhongMaterial.prototype.copy = function ( source ) {
	
			Material.prototype.copy.call( this, source );
	
			this.color.copy( source.color );
			this.specular.copy( source.specular );
			this.shininess = source.shininess;
	
			this.map = source.map;
	
			this.lightMap = source.lightMap;
			this.lightMapIntensity = source.lightMapIntensity;
	
			this.aoMap = source.aoMap;
			this.aoMapIntensity = source.aoMapIntensity;
	
			this.emissive.copy( source.emissive );
			this.emissiveMap = source.emissiveMap;
			this.emissiveIntensity = source.emissiveIntensity;
	
			this.bumpMap = source.bumpMap;
			this.bumpScale = source.bumpScale;
	
			this.normalMap = source.normalMap;
			this.normalScale.copy( source.normalScale );
	
			this.displacementMap = source.displacementMap;
			this.displacementScale = source.displacementScale;
			this.displacementBias = source.displacementBias;
	
			this.specularMap = source.specularMap;
	
			this.alphaMap = source.alphaMap;
	
			this.envMap = source.envMap;
			this.combine = source.combine;
			this.reflectivity = source.reflectivity;
			this.refractionRatio = source.refractionRatio;
	
			this.wireframe = source.wireframe;
			this.wireframeLinewidth = source.wireframeLinewidth;
			this.wireframeLinecap = source.wireframeLinecap;
			this.wireframeLinejoin = source.wireframeLinejoin;
	
			this.skinning = source.skinning;
			this.morphTargets = source.morphTargets;
			this.morphNormals = source.morphNormals;
	
			return this;
	
		};
	
		/**
		 * @author takahirox / http://github.com/takahirox
		 *
		 * parameters = {
		 *  gradientMap: new THREE.Texture( <Image> )
		 * }
		 */
	
		function MeshToonMaterial( parameters ) {
	
			MeshPhongMaterial.call( this );
	
			this.defines = { 'TOON': '' };
	
			this.type = 'MeshToonMaterial';
	
			this.gradientMap = null;
	
			this.setValues( parameters );
	
		}
	
		MeshToonMaterial.prototype = Object.create( MeshPhongMaterial.prototype );
		MeshToonMaterial.prototype.constructor = MeshToonMaterial;
	
		MeshToonMaterial.prototype.isMeshToonMaterial = true;
	
		MeshToonMaterial.prototype.copy = function ( source ) {
	
			MeshPhongMaterial.prototype.copy.call( this, source );
	
			this.gradientMap = source.gradientMap;
	
			return this;
	
		};
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author WestLangley / http://github.com/WestLangley
		 *
		 * parameters = {
		 *  opacity: <float>,
		 *
		 *  bumpMap: new THREE.Texture( <Image> ),
		 *  bumpScale: <float>,
		 *
		 *  normalMap: new THREE.Texture( <Image> ),
		 *  normalScale: <Vector2>,
		 *
		 *  displacementMap: new THREE.Texture( <Image> ),
		 *  displacementScale: <float>,
		 *  displacementBias: <float>,
		 *
		 *  wireframe: <boolean>,
		 *  wireframeLinewidth: <float>
		 *
		 *  skinning: <bool>,
		 *  morphTargets: <bool>,
		 *  morphNormals: <bool>
		 * }
		 */
	
		function MeshNormalMaterial( parameters ) {
	
			Material.call( this );
	
			this.type = 'MeshNormalMaterial';
	
			this.bumpMap = null;
			this.bumpScale = 1;
	
			this.normalMap = null;
			this.normalScale = new Vector2( 1, 1 );
	
			this.displacementMap = null;
			this.displacementScale = 1;
			this.displacementBias = 0;
	
			this.wireframe = false;
			this.wireframeLinewidth = 1;
	
			this.fog = false;
			this.lights = false;
	
			this.skinning = false;
			this.morphTargets = false;
			this.morphNormals = false;
	
			this.setValues( parameters );
	
		}
	
		MeshNormalMaterial.prototype = Object.create( Material.prototype );
		MeshNormalMaterial.prototype.constructor = MeshNormalMaterial;
	
		MeshNormalMaterial.prototype.isMeshNormalMaterial = true;
	
		MeshNormalMaterial.prototype.copy = function ( source ) {
	
			Material.prototype.copy.call( this, source );
	
			this.bumpMap = source.bumpMap;
			this.bumpScale = source.bumpScale;
	
			this.normalMap = source.normalMap;
			this.normalScale.copy( source.normalScale );
	
			this.displacementMap = source.displacementMap;
			this.displacementScale = source.displacementScale;
			this.displacementBias = source.displacementBias;
	
			this.wireframe = source.wireframe;
			this.wireframeLinewidth = source.wireframeLinewidth;
	
			this.skinning = source.skinning;
			this.morphTargets = source.morphTargets;
			this.morphNormals = source.morphNormals;
	
			return this;
	
		};
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author alteredq / http://alteredqualia.com/
		 *
		 * parameters = {
		 *  color: <hex>,
		 *  opacity: <float>,
		 *
		 *  map: new THREE.Texture( <Image> ),
		 *
		 *  lightMap: new THREE.Texture( <Image> ),
		 *  lightMapIntensity: <float>
		 *
		 *  aoMap: new THREE.Texture( <Image> ),
		 *  aoMapIntensity: <float>
		 *
		 *  emissive: <hex>,
		 *  emissiveIntensity: <float>
		 *  emissiveMap: new THREE.Texture( <Image> ),
		 *
		 *  specularMap: new THREE.Texture( <Image> ),
		 *
		 *  alphaMap: new THREE.Texture( <Image> ),
		 *
		 *  envMap: new THREE.TextureCube( [posx, negx, posy, negy, posz, negz] ),
		 *  combine: THREE.Multiply,
		 *  reflectivity: <float>,
		 *  refractionRatio: <float>,
		 *
		 *  wireframe: <boolean>,
		 *  wireframeLinewidth: <float>,
		 *
		 *  skinning: <bool>,
		 *  morphTargets: <bool>,
		 *  morphNormals: <bool>
		 * }
		 */
	
		function MeshLambertMaterial( parameters ) {
	
			Material.call( this );
	
			this.type = 'MeshLambertMaterial';
	
			this.color = new Color( 0xffffff ); // diffuse
	
			this.map = null;
	
			this.lightMap = null;
			this.lightMapIntensity = 1.0;
	
			this.aoMap = null;
			this.aoMapIntensity = 1.0;
	
			this.emissive = new Color( 0x000000 );
			this.emissiveIntensity = 1.0;
			this.emissiveMap = null;
	
			this.specularMap = null;
	
			this.alphaMap = null;
	
			this.envMap = null;
			this.combine = MultiplyOperation;
			this.reflectivity = 1;
			this.refractionRatio = 0.98;
	
			this.wireframe = false;
			this.wireframeLinewidth = 1;
			this.wireframeLinecap = 'round';
			this.wireframeLinejoin = 'round';
	
			this.skinning = false;
			this.morphTargets = false;
			this.morphNormals = false;
	
			this.setValues( parameters );
	
		}
	
		MeshLambertMaterial.prototype = Object.create( Material.prototype );
		MeshLambertMaterial.prototype.constructor = MeshLambertMaterial;
	
		MeshLambertMaterial.prototype.isMeshLambertMaterial = true;
	
		MeshLambertMaterial.prototype.copy = function ( source ) {
	
			Material.prototype.copy.call( this, source );
	
			this.color.copy( source.color );
	
			this.map = source.map;
	
			this.lightMap = source.lightMap;
			this.lightMapIntensity = source.lightMapIntensity;
	
			this.aoMap = source.aoMap;
			this.aoMapIntensity = source.aoMapIntensity;
	
			this.emissive.copy( source.emissive );
			this.emissiveMap = source.emissiveMap;
			this.emissiveIntensity = source.emissiveIntensity;
	
			this.specularMap = source.specularMap;
	
			this.alphaMap = source.alphaMap;
	
			this.envMap = source.envMap;
			this.combine = source.combine;
			this.reflectivity = source.reflectivity;
			this.refractionRatio = source.refractionRatio;
	
			this.wireframe = source.wireframe;
			this.wireframeLinewidth = source.wireframeLinewidth;
			this.wireframeLinecap = source.wireframeLinecap;
			this.wireframeLinejoin = source.wireframeLinejoin;
	
			this.skinning = source.skinning;
			this.morphTargets = source.morphTargets;
			this.morphNormals = source.morphNormals;
	
			return this;
	
		};
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 *
		 * parameters = {
		 *  color: <hex>,
		 *  opacity: <float>,
		 *
		 *  linewidth: <float>,
		 *
		 *  scale: <float>,
		 *  dashSize: <float>,
		 *  gapSize: <float>
		 * }
		 */
	
		function LineDashedMaterial( parameters ) {
	
			LineBasicMaterial.call( this );
	
			this.type = 'LineDashedMaterial';
	
			this.scale = 1;
			this.dashSize = 3;
			this.gapSize = 1;
	
			this.setValues( parameters );
	
		}
	
		LineDashedMaterial.prototype = Object.create( LineBasicMaterial.prototype );
		LineDashedMaterial.prototype.constructor = LineDashedMaterial;
	
		LineDashedMaterial.prototype.isLineDashedMaterial = true;
	
		LineDashedMaterial.prototype.copy = function ( source ) {
	
			LineBasicMaterial.prototype.copy.call( this, source );
	
			this.scale = source.scale;
			this.dashSize = source.dashSize;
			this.gapSize = source.gapSize;
	
			return this;
	
		};
	
	
	
		var Materials = Object.freeze({
			ShadowMaterial: ShadowMaterial,
			SpriteMaterial: SpriteMaterial,
			RawShaderMaterial: RawShaderMaterial,
			ShaderMaterial: ShaderMaterial,
			PointsMaterial: PointsMaterial,
			MeshPhysicalMaterial: MeshPhysicalMaterial,
			MeshStandardMaterial: MeshStandardMaterial,
			MeshPhongMaterial: MeshPhongMaterial,
			MeshToonMaterial: MeshToonMaterial,
			MeshNormalMaterial: MeshNormalMaterial,
			MeshLambertMaterial: MeshLambertMaterial,
			MeshDepthMaterial: MeshDepthMaterial,
			MeshDistanceMaterial: MeshDistanceMaterial,
			MeshBasicMaterial: MeshBasicMaterial,
			LineDashedMaterial: LineDashedMaterial,
			LineBasicMaterial: LineBasicMaterial,
			Material: Material
		});
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		var Cache = {
	
			enabled: false,
	
			files: {},
	
			add: function ( key, file ) {
	
				if ( this.enabled === false ) return;
	
				// console.log( 'THREE.Cache', 'Adding key:', key );
	
				this.files[ key ] = file;
	
			},
	
			get: function ( key ) {
	
				if ( this.enabled === false ) return;
	
				// console.log( 'THREE.Cache', 'Checking key:', key );
	
				return this.files[ key ];
	
			},
	
			remove: function ( key ) {
	
				delete this.files[ key ];
	
			},
	
			clear: function () {
	
				this.files = {};
	
			}
	
		};
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function LoadingManager( onLoad, onProgress, onError ) {
	
			var scope = this;
	
			var isLoading = false;
			var itemsLoaded = 0;
			var itemsTotal = 0;
			var urlModifier = undefined;
	
			this.onStart = undefined;
			this.onLoad = onLoad;
			this.onProgress = onProgress;
			this.onError = onError;
	
			this.itemStart = function ( url ) {
	
				itemsTotal ++;
	
				if ( isLoading === false ) {
	
					if ( scope.onStart !== undefined ) {
	
						scope.onStart( url, itemsLoaded, itemsTotal );
	
					}
	
				}
	
				isLoading = true;
	
			};
	
			this.itemEnd = function ( url ) {
	
				itemsLoaded ++;
	
				if ( scope.onProgress !== undefined ) {
	
					scope.onProgress( url, itemsLoaded, itemsTotal );
	
				}
	
				if ( itemsLoaded === itemsTotal ) {
	
					isLoading = false;
	
					if ( scope.onLoad !== undefined ) {
	
						scope.onLoad();
	
					}
	
				}
	
			};
	
			this.itemError = function ( url ) {
	
				if ( scope.onError !== undefined ) {
	
					scope.onError( url );
	
				}
	
			};
	
			this.resolveURL = function ( url ) {
	
				if ( urlModifier ) {
	
					return urlModifier( url );
	
				}
	
				return url;
	
			};
	
			this.setURLModifier = function ( transform ) {
	
				urlModifier = transform;
				return this;
	
			};
	
		}
	
		var DefaultLoadingManager = new LoadingManager();
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		var loading = {};
	
		function FileLoader( manager ) {
	
			this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;
	
		}
	
		Object.assign( FileLoader.prototype, {
	
			load: function ( url, onLoad, onProgress, onError ) {
	
				if ( url === undefined ) url = '';
	
				if ( this.path !== undefined ) url = this.path + url;
	
				url = this.manager.resolveURL( url );
	
				var scope = this;
	
				var cached = Cache.get( url );
	
				if ( cached !== undefined ) {
	
					scope.manager.itemStart( url );
	
					setTimeout( function () {
	
						if ( onLoad ) onLoad( cached );
	
						scope.manager.itemEnd( url );
	
					}, 0 );
	
					return cached;
	
				}
	
				// Check if request is duplicate
	
				if ( loading[ url ] !== undefined ) {
	
					loading[ url ].push( {
	
						onLoad: onLoad,
						onProgress: onProgress,
						onError: onError
	
					} );
	
					return;
	
				}
	
				// Check for data: URI
				var dataUriRegex = /^data:(.*?)(;base64)?,(.*)$/;
				var dataUriRegexResult = url.match( dataUriRegex );
	
				// Safari can not handle Data URIs through XMLHttpRequest so process manually
				if ( dataUriRegexResult ) {
	
					var mimeType = dataUriRegexResult[ 1 ];
					var isBase64 = !! dataUriRegexResult[ 2 ];
					var data = dataUriRegexResult[ 3 ];
	
					data = window.decodeURIComponent( data );
	
					if ( isBase64 ) data = window.atob( data );
	
					try {
	
						var response;
						var responseType = ( this.responseType || '' ).toLowerCase();
	
						switch ( responseType ) {
	
							case 'arraybuffer':
							case 'blob':
	
								var view = new Uint8Array( data.length );
	
								for ( var i = 0; i < data.length; i ++ ) {
	
									view[ i ] = data.charCodeAt( i );
	
								}
	
								if ( responseType === 'blob' ) {
	
									response = new Blob( [ view.buffer ], { type: mimeType } );
	
								} else {
	
									response = view.buffer;
	
								}
	
								break;
	
							case 'document':
	
								var parser = new DOMParser();
								response = parser.parseFromString( data, mimeType );
	
								break;
	
							case 'json':
	
								response = JSON.parse( data );
	
								break;
	
							default: // 'text' or other
	
								response = data;
	
								break;
	
						}
	
						// Wait for next browser tick like standard XMLHttpRequest event dispatching does
						window.setTimeout( function () {
	
							if ( onLoad ) onLoad( response );
	
							scope.manager.itemEnd( url );
	
						}, 0 );
	
					} catch ( error ) {
	
						// Wait for next browser tick like standard XMLHttpRequest event dispatching does
						window.setTimeout( function () {
	
							if ( onError ) onError( error );
	
							scope.manager.itemEnd( url );
							scope.manager.itemError( url );
	
						}, 0 );
	
					}
	
				} else {
	
					// Initialise array for duplicate requests
	
					loading[ url ] = [];
	
					loading[ url ].push( {
	
						onLoad: onLoad,
						onProgress: onProgress,
						onError: onError
	
					} );
	
					var request = new XMLHttpRequest();
	
					request.open( 'GET', url, true );
	
					request.addEventListener( 'load', function ( event ) {
	
						var response = this.response;
	
						Cache.add( url, response );
	
						var callbacks = loading[ url ];
	
						delete loading[ url ];
	
						if ( this.status === 200 ) {
	
							for ( var i = 0, il = callbacks.length; i < il; i ++ ) {
	
								var callback = callbacks[ i ];
								if ( callback.onLoad ) callback.onLoad( response );
	
							}
	
							scope.manager.itemEnd( url );
	
						} else if ( this.status === 0 ) {
	
							// Some browsers return HTTP Status 0 when using non-http protocol
							// e.g. 'file://' or 'data://'. Handle as success.
	
							console.warn( 'THREE.FileLoader: HTTP Status 0 received.' );
	
							for ( var i = 0, il = callbacks.length; i < il; i ++ ) {
	
								var callback = callbacks[ i ];
								if ( callback.onLoad ) callback.onLoad( response );
	
							}
	
							scope.manager.itemEnd( url );
	
						} else {
	
							for ( var i = 0, il = callbacks.length; i < il; i ++ ) {
	
								var callback = callbacks[ i ];
								if ( callback.onError ) callback.onError( event );
	
							}
	
							scope.manager.itemEnd( url );
							scope.manager.itemError( url );
	
						}
	
					}, false );
	
					request.addEventListener( 'progress', function ( event ) {
	
						var callbacks = loading[ url ];
	
						for ( var i = 0, il = callbacks.length; i < il; i ++ ) {
	
							var callback = callbacks[ i ];
							if ( callback.onProgress ) callback.onProgress( event );
	
						}
	
					}, false );
	
					request.addEventListener( 'error', function ( event ) {
	
						var callbacks = loading[ url ];
	
						delete loading[ url ];
	
						for ( var i = 0, il = callbacks.length; i < il; i ++ ) {
	
							var callback = callbacks[ i ];
							if ( callback.onError ) callback.onError( event );
	
						}
	
						scope.manager.itemEnd( url );
						scope.manager.itemError( url );
	
					}, false );
	
					if ( this.responseType !== undefined ) request.responseType = this.responseType;
					if ( this.withCredentials !== undefined ) request.withCredentials = this.withCredentials;
	
					if ( request.overrideMimeType ) request.overrideMimeType( this.mimeType !== undefined ? this.mimeType : 'text/plain' );
	
					for ( var header in this.requestHeader ) {
	
						request.setRequestHeader( header, this.requestHeader[ header ] );
	
					}
	
					request.send( null );
	
				}
	
				scope.manager.itemStart( url );
	
				return request;
	
			},
	
			setPath: function ( value ) {
	
				this.path = value;
				return this;
	
			},
	
			setResponseType: function ( value ) {
	
				this.responseType = value;
				return this;
	
			},
	
			setWithCredentials: function ( value ) {
	
				this.withCredentials = value;
				return this;
	
			},
	
			setMimeType: function ( value ) {
	
				this.mimeType = value;
				return this;
	
			},
	
			setRequestHeader: function ( value ) {
	
				this.requestHeader = value;
				return this;
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 *
		 * Abstract Base class to block based textures loader (dds, pvr, ...)
		 */
	
		function CompressedTextureLoader( manager ) {
	
			this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;
	
			// override in sub classes
			this._parser = null;
	
		}
	
		Object.assign( CompressedTextureLoader.prototype, {
	
			load: function ( url, onLoad, onProgress, onError ) {
	
				var scope = this;
	
				var images = [];
	
				var texture = new CompressedTexture();
				texture.image = images;
	
				var loader = new FileLoader( this.manager );
				loader.setPath( this.path );
				loader.setResponseType( 'arraybuffer' );
	
				function loadTexture( i ) {
	
					loader.load( url[ i ], function ( buffer ) {
	
						var texDatas = scope._parser( buffer, true );
	
						images[ i ] = {
							width: texDatas.width,
							height: texDatas.height,
							format: texDatas.format,
							mipmaps: texDatas.mipmaps
						};
	
						loaded += 1;
	
						if ( loaded === 6 ) {
	
							if ( texDatas.mipmapCount === 1 )
								texture.minFilter = LinearFilter;
	
							texture.format = texDatas.format;
							texture.needsUpdate = true;
	
							if ( onLoad ) onLoad( texture );
	
						}
	
					}, onProgress, onError );
	
				}
	
				if ( Array.isArray( url ) ) {
	
					var loaded = 0;
	
					for ( var i = 0, il = url.length; i < il; ++ i ) {
	
						loadTexture( i );
	
					}
	
				} else {
	
					// compressed cubemap texture stored in a single DDS file
	
					loader.load( url, function ( buffer ) {
	
						var texDatas = scope._parser( buffer, true );
	
						if ( texDatas.isCubemap ) {
	
							var faces = texDatas.mipmaps.length / texDatas.mipmapCount;
	
							for ( var f = 0; f < faces; f ++ ) {
	
								images[ f ] = { mipmaps: [] };
	
								for ( var i = 0; i < texDatas.mipmapCount; i ++ ) {
	
									images[ f ].mipmaps.push( texDatas.mipmaps[ f * texDatas.mipmapCount + i ] );
									images[ f ].format = texDatas.format;
									images[ f ].width = texDatas.width;
									images[ f ].height = texDatas.height;
	
								}
	
							}
	
						} else {
	
							texture.image.width = texDatas.width;
							texture.image.height = texDatas.height;
							texture.mipmaps = texDatas.mipmaps;
	
						}
	
						if ( texDatas.mipmapCount === 1 ) {
	
							texture.minFilter = LinearFilter;
	
						}
	
						texture.format = texDatas.format;
						texture.needsUpdate = true;
	
						if ( onLoad ) onLoad( texture );
	
					}, onProgress, onError );
	
				}
	
				return texture;
	
			},
	
			setPath: function ( value ) {
	
				this.path = value;
				return this;
	
			}
	
		} );
	
		/**
		 * @author Nikos M. / https://github.com/foo123/
		 *
		 * Abstract Base class to load generic binary textures formats (rgbe, hdr, ...)
		 */
	
		function DataTextureLoader( manager ) {
	
			this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;
	
			// override in sub classes
			this._parser = null;
	
		}
	
		Object.assign( DataTextureLoader.prototype, {
	
			load: function ( url, onLoad, onProgress, onError ) {
	
				var scope = this;
	
				var texture = new DataTexture();
	
				var loader = new FileLoader( this.manager );
				loader.setResponseType( 'arraybuffer' );
	
				loader.load( url, function ( buffer ) {
	
					var texData = scope._parser( buffer );
	
					if ( ! texData ) return;
	
					if ( undefined !== texData.image ) {
	
						texture.image = texData.image;
	
					} else if ( undefined !== texData.data ) {
	
						texture.image.width = texData.width;
						texture.image.height = texData.height;
						texture.image.data = texData.data;
	
					}
	
					texture.wrapS = undefined !== texData.wrapS ? texData.wrapS : ClampToEdgeWrapping;
					texture.wrapT = undefined !== texData.wrapT ? texData.wrapT : ClampToEdgeWrapping;
	
					texture.magFilter = undefined !== texData.magFilter ? texData.magFilter : LinearFilter;
					texture.minFilter = undefined !== texData.minFilter ? texData.minFilter : LinearMipMapLinearFilter;
	
					texture.anisotropy = undefined !== texData.anisotropy ? texData.anisotropy : 1;
	
					if ( undefined !== texData.format ) {
	
						texture.format = texData.format;
	
					}
					if ( undefined !== texData.type ) {
	
						texture.type = texData.type;
	
					}
	
					if ( undefined !== texData.mipmaps ) {
	
						texture.mipmaps = texData.mipmaps;
	
					}
	
					if ( 1 === texData.mipmapCount ) {
	
						texture.minFilter = LinearFilter;
	
					}
	
					texture.needsUpdate = true;
	
					if ( onLoad ) onLoad( texture, texData );
	
				}, onProgress, onError );
	
	
				return texture;
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function ImageLoader( manager ) {
	
			this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;
	
		}
	
		Object.assign( ImageLoader.prototype, {
	
			crossOrigin: 'Anonymous',
	
			load: function ( url, onLoad, onProgress, onError ) {
	
				if ( url === undefined ) url = '';
	
				if ( this.path !== undefined ) url = this.path + url;
	
				url = this.manager.resolveURL( url );
	
				var scope = this;
	
				var cached = Cache.get( url );
	
				if ( cached !== undefined ) {
	
					scope.manager.itemStart( url );
	
					setTimeout( function () {
	
						if ( onLoad ) onLoad( cached );
	
						scope.manager.itemEnd( url );
	
					}, 0 );
	
					return cached;
	
				}
	
				var image = document.createElementNS( 'http://www.w3.org/1999/xhtml', 'img' );
	
				image.addEventListener( 'load', function () {
	
					Cache.add( url, this );
	
					if ( onLoad ) onLoad( this );
	
					scope.manager.itemEnd( url );
	
				}, false );
	
				/*
				image.addEventListener( 'progress', function ( event ) {
	
					if ( onProgress ) onProgress( event );
	
				}, false );
				*/
	
				image.addEventListener( 'error', function ( event ) {
	
					if ( onError ) onError( event );
	
					scope.manager.itemEnd( url );
					scope.manager.itemError( url );
	
				}, false );
	
				if ( url.substr( 0, 5 ) !== 'data:' ) {
	
					if ( this.crossOrigin !== undefined ) image.crossOrigin = this.crossOrigin;
	
				}
	
				scope.manager.itemStart( url );
	
				image.src = url;
	
				return image;
	
			},
	
			setCrossOrigin: function ( value ) {
	
				this.crossOrigin = value;
				return this;
	
			},
	
			setPath: function ( value ) {
	
				this.path = value;
				return this;
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function CubeTextureLoader( manager ) {
	
			this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;
	
		}
	
		Object.assign( CubeTextureLoader.prototype, {
	
			crossOrigin: 'Anonymous',
	
			load: function ( urls, onLoad, onProgress, onError ) {
	
				var texture = new CubeTexture();
	
				var loader = new ImageLoader( this.manager );
				loader.setCrossOrigin( this.crossOrigin );
				loader.setPath( this.path );
	
				var loaded = 0;
	
				function loadTexture( i ) {
	
					loader.load( urls[ i ], function ( image ) {
	
						texture.images[ i ] = image;
	
						loaded ++;
	
						if ( loaded === 6 ) {
	
							texture.needsUpdate = true;
	
							if ( onLoad ) onLoad( texture );
	
						}
	
					}, undefined, onError );
	
				}
	
				for ( var i = 0; i < urls.length; ++ i ) {
	
					loadTexture( i );
	
				}
	
				return texture;
	
			},
	
			setCrossOrigin: function ( value ) {
	
				this.crossOrigin = value;
				return this;
	
			},
	
			setPath: function ( value ) {
	
				this.path = value;
				return this;
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function TextureLoader( manager ) {
	
			this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;
	
		}
	
		Object.assign( TextureLoader.prototype, {
	
			crossOrigin: 'Anonymous',
	
			load: function ( url, onLoad, onProgress, onError ) {
	
				var texture = new Texture();
	
				var loader = new ImageLoader( this.manager );
				loader.setCrossOrigin( this.crossOrigin );
				loader.setPath( this.path );
	
				loader.load( url, function ( image ) {
	
					texture.image = image;
	
					// JPEGs can't have an alpha channel, so memory can be saved by storing them as RGB.
					var isJPEG = url.search( /\.(jpg|jpeg)$/ ) > 0 || url.search( /^data\:image\/jpeg/ ) === 0;
	
					texture.format = isJPEG ? RGBFormat : RGBAFormat;
					texture.needsUpdate = true;
	
					if ( onLoad !== undefined ) {
	
						onLoad( texture );
	
					}
	
				}, onProgress, onError );
	
				return texture;
	
			},
	
			setCrossOrigin: function ( value ) {
	
				this.crossOrigin = value;
				return this;
	
			},
	
			setPath: function ( value ) {
	
				this.path = value;
				return this;
	
			}
	
		} );
	
		/**
		 * @author zz85 / http://www.lab4games.net/zz85/blog
		 * Extensible curve object
		 *
		 * Some common of curve methods:
		 * .getPoint( t, optionalTarget ), .getTangent( t )
		 * .getPointAt( u, optionalTarget ), .getTangentAt( u )
		 * .getPoints(), .getSpacedPoints()
		 * .getLength()
		 * .updateArcLengths()
		 *
		 * This following curves inherit from THREE.Curve:
		 *
		 * -- 2D curves --
		 * THREE.ArcCurve
		 * THREE.CubicBezierCurve
		 * THREE.EllipseCurve
		 * THREE.LineCurve
		 * THREE.QuadraticBezierCurve
		 * THREE.SplineCurve
		 *
		 * -- 3D curves --
		 * THREE.CatmullRomCurve3
		 * THREE.CubicBezierCurve3
		 * THREE.LineCurve3
		 * THREE.QuadraticBezierCurve3
		 *
		 * A series of curves can be represented as a THREE.CurvePath.
		 *
		 **/
	
		/**************************************************************
		 *	Abstract Curve base class
		 **************************************************************/
	
		function Curve() {
	
			this.type = 'Curve';
	
			this.arcLengthDivisions = 200;
	
		}
	
		Object.assign( Curve.prototype, {
	
			// Virtual base class method to overwrite and implement in subclasses
			//	- t [0 .. 1]
	
			getPoint: function ( /* t, optionalTarget */ ) {
	
				console.warn( 'THREE.Curve: .getPoint() not implemented.' );
				return null;
	
			},
	
			// Get point at relative position in curve according to arc length
			// - u [0 .. 1]
	
			getPointAt: function ( u, optionalTarget ) {
	
				var t = this.getUtoTmapping( u );
				return this.getPoint( t, optionalTarget );
	
			},
	
			// Get sequence of points using getPoint( t )
	
			getPoints: function ( divisions ) {
	
				if ( divisions === undefined ) divisions = 5;
	
				var points = [];
	
				for ( var d = 0; d <= divisions; d ++ ) {
	
					points.push( this.getPoint( d / divisions ) );
	
				}
	
				return points;
	
			},
	
			// Get sequence of points using getPointAt( u )
	
			getSpacedPoints: function ( divisions ) {
	
				if ( divisions === undefined ) divisions = 5;
	
				var points = [];
	
				for ( var d = 0; d <= divisions; d ++ ) {
	
					points.push( this.getPointAt( d / divisions ) );
	
				}
	
				return points;
	
			},
	
			// Get total curve arc length
	
			getLength: function () {
	
				var lengths = this.getLengths();
				return lengths[ lengths.length - 1 ];
	
			},
	
			// Get list of cumulative segment lengths
	
			getLengths: function ( divisions ) {
	
				if ( divisions === undefined ) divisions = this.arcLengthDivisions;
	
				if ( this.cacheArcLengths &&
					( this.cacheArcLengths.length === divisions + 1 ) &&
					! this.needsUpdate ) {
	
					return this.cacheArcLengths;
	
				}
	
				this.needsUpdate = false;
	
				var cache = [];
				var current, last = this.getPoint( 0 );
				var p, sum = 0;
	
				cache.push( 0 );
	
				for ( p = 1; p <= divisions; p ++ ) {
	
					current = this.getPoint( p / divisions );
					sum += current.distanceTo( last );
					cache.push( sum );
					last = current;
	
				}
	
				this.cacheArcLengths = cache;
	
				return cache; // { sums: cache, sum: sum }; Sum is in the last element.
	
			},
	
			updateArcLengths: function () {
	
				this.needsUpdate = true;
				this.getLengths();
	
			},
	
			// Given u ( 0 .. 1 ), get a t to find p. This gives you points which are equidistant
	
			getUtoTmapping: function ( u, distance ) {
	
				var arcLengths = this.getLengths();
	
				var i = 0, il = arcLengths.length;
	
				var targetArcLength; // The targeted u distance value to get
	
				if ( distance ) {
	
					targetArcLength = distance;
	
				} else {
	
					targetArcLength = u * arcLengths[ il - 1 ];
	
				}
	
				// binary search for the index with largest value smaller than target u distance
	
				var low = 0, high = il - 1, comparison;
	
				while ( low <= high ) {
	
					i = Math.floor( low + ( high - low ) / 2 ); // less likely to overflow, though probably not issue here, JS doesn't really have integers, all numbers are floats
	
					comparison = arcLengths[ i ] - targetArcLength;
	
					if ( comparison < 0 ) {
	
						low = i + 1;
	
					} else if ( comparison > 0 ) {
	
						high = i - 1;
	
					} else {
	
						high = i;
						break;
	
						// DONE
	
					}
	
				}
	
				i = high;
	
				if ( arcLengths[ i ] === targetArcLength ) {
	
					return i / ( il - 1 );
	
				}
	
				// we could get finer grain at lengths, or use simple interpolation between two points
	
				var lengthBefore = arcLengths[ i ];
				var lengthAfter = arcLengths[ i + 1 ];
	
				var segmentLength = lengthAfter - lengthBefore;
	
				// determine where we are between the 'before' and 'after' points
	
				var segmentFraction = ( targetArcLength - lengthBefore ) / segmentLength;
	
				// add that fractional amount to t
	
				var t = ( i + segmentFraction ) / ( il - 1 );
	
				return t;
	
			},
	
			// Returns a unit vector tangent at t
			// In case any sub curve does not implement its tangent derivation,
			// 2 points a small delta apart will be used to find its gradient
			// which seems to give a reasonable approximation
	
			getTangent: function ( t ) {
	
				var delta = 0.0001;
				var t1 = t - delta;
				var t2 = t + delta;
	
				// Capping in case of danger
	
				if ( t1 < 0 ) t1 = 0;
				if ( t2 > 1 ) t2 = 1;
	
				var pt1 = this.getPoint( t1 );
				var pt2 = this.getPoint( t2 );
	
				var vec = pt2.clone().sub( pt1 );
				return vec.normalize();
	
			},
	
			getTangentAt: function ( u ) {
	
				var t = this.getUtoTmapping( u );
				return this.getTangent( t );
	
			},
	
			computeFrenetFrames: function ( segments, closed ) {
	
				// see http://www.cs.indiana.edu/pub/techreports/TR425.pdf
	
				var normal = new Vector3();
	
				var tangents = [];
				var normals = [];
				var binormals = [];
	
				var vec = new Vector3();
				var mat = new Matrix4();
	
				var i, u, theta;
	
				// compute the tangent vectors for each segment on the curve
	
				for ( i = 0; i <= segments; i ++ ) {
	
					u = i / segments;
	
					tangents[ i ] = this.getTangentAt( u );
					tangents[ i ].normalize();
	
				}
	
				// select an initial normal vector perpendicular to the first tangent vector,
				// and in the direction of the minimum tangent xyz component
	
				normals[ 0 ] = new Vector3();
				binormals[ 0 ] = new Vector3();
				var min = Number.MAX_VALUE;
				var tx = Math.abs( tangents[ 0 ].x );
				var ty = Math.abs( tangents[ 0 ].y );
				var tz = Math.abs( tangents[ 0 ].z );
	
				if ( tx <= min ) {
	
					min = tx;
					normal.set( 1, 0, 0 );
	
				}
	
				if ( ty <= min ) {
	
					min = ty;
					normal.set( 0, 1, 0 );
	
				}
	
				if ( tz <= min ) {
	
					normal.set( 0, 0, 1 );
	
				}
	
				vec.crossVectors( tangents[ 0 ], normal ).normalize();
	
				normals[ 0 ].crossVectors( tangents[ 0 ], vec );
				binormals[ 0 ].crossVectors( tangents[ 0 ], normals[ 0 ] );
	
	
				// compute the slowly-varying normal and binormal vectors for each segment on the curve
	
				for ( i = 1; i <= segments; i ++ ) {
	
					normals[ i ] = normals[ i - 1 ].clone();
	
					binormals[ i ] = binormals[ i - 1 ].clone();
	
					vec.crossVectors( tangents[ i - 1 ], tangents[ i ] );
	
					if ( vec.length() > Number.EPSILON ) {
	
						vec.normalize();
	
						theta = Math.acos( _Math.clamp( tangents[ i - 1 ].dot( tangents[ i ] ), - 1, 1 ) ); // clamp for floating pt errors
	
						normals[ i ].applyMatrix4( mat.makeRotationAxis( vec, theta ) );
	
					}
	
					binormals[ i ].crossVectors( tangents[ i ], normals[ i ] );
	
				}
	
				// if the curve is closed, postprocess the vectors so the first and last normal vectors are the same
	
				if ( closed === true ) {
	
					theta = Math.acos( _Math.clamp( normals[ 0 ].dot( normals[ segments ] ), - 1, 1 ) );
					theta /= segments;
	
					if ( tangents[ 0 ].dot( vec.crossVectors( normals[ 0 ], normals[ segments ] ) ) > 0 ) {
	
						theta = - theta;
	
					}
	
					for ( i = 1; i <= segments; i ++ ) {
	
						// twist a little...
						normals[ i ].applyMatrix4( mat.makeRotationAxis( tangents[ i ], theta * i ) );
						binormals[ i ].crossVectors( tangents[ i ], normals[ i ] );
	
					}
	
				}
	
				return {
					tangents: tangents,
					normals: normals,
					binormals: binormals
				};
	
			},
	
			clone: function () {
	
				return new this.constructor().copy( this );
	
			},
	
			copy: function ( source ) {
	
				this.arcLengthDivisions = source.arcLengthDivisions;
	
				return this;
	
			},
	
			toJSON: function () {
	
				var data = {
					metadata: {
						version: 4.5,
						type: 'Curve',
						generator: 'Curve.toJSON'
					}
				};
	
				data.arcLengthDivisions = this.arcLengthDivisions;
				data.type = this.type;
	
				return data;
	
			},
	
			fromJSON: function ( json ) {
	
				this.arcLengthDivisions = json.arcLengthDivisions;
	
				return this;
	
			}
	
		} );
	
		function EllipseCurve( aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation ) {
	
			Curve.call( this );
	
			this.type = 'EllipseCurve';
	
			this.aX = aX || 0;
			this.aY = aY || 0;
	
			this.xRadius = xRadius || 1;
			this.yRadius = yRadius || 1;
	
			this.aStartAngle = aStartAngle || 0;
			this.aEndAngle = aEndAngle || 2 * Math.PI;
	
			this.aClockwise = aClockwise || false;
	
			this.aRotation = aRotation || 0;
	
		}
	
		EllipseCurve.prototype = Object.create( Curve.prototype );
		EllipseCurve.prototype.constructor = EllipseCurve;
	
		EllipseCurve.prototype.isEllipseCurve = true;
	
		EllipseCurve.prototype.getPoint = function ( t, optionalTarget ) {
	
			var point = optionalTarget || new Vector2();
	
			var twoPi = Math.PI * 2;
			var deltaAngle = this.aEndAngle - this.aStartAngle;
			var samePoints = Math.abs( deltaAngle ) < Number.EPSILON;
	
			// ensures that deltaAngle is 0 .. 2 PI
			while ( deltaAngle < 0 ) deltaAngle += twoPi;
			while ( deltaAngle > twoPi ) deltaAngle -= twoPi;
	
			if ( deltaAngle < Number.EPSILON ) {
	
				if ( samePoints ) {
	
					deltaAngle = 0;
	
				} else {
	
					deltaAngle = twoPi;
	
				}
	
			}
	
			if ( this.aClockwise === true && ! samePoints ) {
	
				if ( deltaAngle === twoPi ) {
	
					deltaAngle = - twoPi;
	
				} else {
	
					deltaAngle = deltaAngle - twoPi;
	
				}
	
			}
	
			var angle = this.aStartAngle + t * deltaAngle;
			var x = this.aX + this.xRadius * Math.cos( angle );
			var y = this.aY + this.yRadius * Math.sin( angle );
	
			if ( this.aRotation !== 0 ) {
	
				var cos = Math.cos( this.aRotation );
				var sin = Math.sin( this.aRotation );
	
				var tx = x - this.aX;
				var ty = y - this.aY;
	
				// Rotate the point about the center of the ellipse.
				x = tx * cos - ty * sin + this.aX;
				y = tx * sin + ty * cos + this.aY;
	
			}
	
			return point.set( x, y );
	
		};
	
		EllipseCurve.prototype.copy = function ( source ) {
	
			Curve.prototype.copy.call( this, source );
	
			this.aX = source.aX;
			this.aY = source.aY;
	
			this.xRadius = source.xRadius;
			this.yRadius = source.yRadius;
	
			this.aStartAngle = source.aStartAngle;
			this.aEndAngle = source.aEndAngle;
	
			this.aClockwise = source.aClockwise;
	
			this.aRotation = source.aRotation;
	
			return this;
	
		};
	
	
		EllipseCurve.prototype.toJSON = function () {
	
			var data = Curve.prototype.toJSON.call( this );
	
			data.aX = this.aX;
			data.aY = this.aY;
	
			data.xRadius = this.xRadius;
			data.yRadius = this.yRadius;
	
			data.aStartAngle = this.aStartAngle;
			data.aEndAngle = this.aEndAngle;
	
			data.aClockwise = this.aClockwise;
	
			data.aRotation = this.aRotation;
	
			return data;
	
		};
	
		EllipseCurve.prototype.fromJSON = function ( json ) {
	
			Curve.prototype.fromJSON.call( this, json );
	
			this.aX = json.aX;
			this.aY = json.aY;
	
			this.xRadius = json.xRadius;
			this.yRadius = json.yRadius;
	
			this.aStartAngle = json.aStartAngle;
			this.aEndAngle = json.aEndAngle;
	
			this.aClockwise = json.aClockwise;
	
			this.aRotation = json.aRotation;
	
			return this;
	
		};
	
		function ArcCurve( aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise ) {
	
			EllipseCurve.call( this, aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise );
	
			this.type = 'ArcCurve';
	
		}
	
		ArcCurve.prototype = Object.create( EllipseCurve.prototype );
		ArcCurve.prototype.constructor = ArcCurve;
	
		ArcCurve.prototype.isArcCurve = true;
	
		/**
		 * @author zz85 https://github.com/zz85
		 *
		 * Centripetal CatmullRom Curve - which is useful for avoiding
		 * cusps and self-intersections in non-uniform catmull rom curves.
		 * http://www.cemyuksel.com/research/catmullrom_param/catmullrom.pdf
		 *
		 * curve.type accepts centripetal(default), chordal and catmullrom
		 * curve.tension is used for catmullrom which defaults to 0.5
		 */
	
	
		/*
		Based on an optimized c++ solution in
		 - http://stackoverflow.com/questions/9489736/catmull-rom-curve-with-no-cusps-and-no-self-intersections/
		 - http://ideone.com/NoEbVM
	
		This CubicPoly class could be used for reusing some variables and calculations,
		but for three.js curve use, it could be possible inlined and flatten into a single function call
		which can be placed in CurveUtils.
		*/
	
		function CubicPoly() {
	
			var c0 = 0, c1 = 0, c2 = 0, c3 = 0;
	
			/*
			 * Compute coefficients for a cubic polynomial
			 *   p(s) = c0 + c1*s + c2*s^2 + c3*s^3
			 * such that
			 *   p(0) = x0, p(1) = x1
			 *  and
			 *   p'(0) = t0, p'(1) = t1.
			 */
			function init( x0, x1, t0, t1 ) {
	
				c0 = x0;
				c1 = t0;
				c2 = - 3 * x0 + 3 * x1 - 2 * t0 - t1;
				c3 = 2 * x0 - 2 * x1 + t0 + t1;
	
			}
	
			return {
	
				initCatmullRom: function ( x0, x1, x2, x3, tension ) {
	
					init( x1, x2, tension * ( x2 - x0 ), tension * ( x3 - x1 ) );
	
				},
	
				initNonuniformCatmullRom: function ( x0, x1, x2, x3, dt0, dt1, dt2 ) {
	
					// compute tangents when parameterized in [t1,t2]
					var t1 = ( x1 - x0 ) / dt0 - ( x2 - x0 ) / ( dt0 + dt1 ) + ( x2 - x1 ) / dt1;
					var t2 = ( x2 - x1 ) / dt1 - ( x3 - x1 ) / ( dt1 + dt2 ) + ( x3 - x2 ) / dt2;
	
					// rescale tangents for parametrization in [0,1]
					t1 *= dt1;
					t2 *= dt1;
	
					init( x1, x2, t1, t2 );
	
				},
	
				calc: function ( t ) {
	
					var t2 = t * t;
					var t3 = t2 * t;
					return c0 + c1 * t + c2 * t2 + c3 * t3;
	
				}
	
			};
	
		}
	
		//
	
		var tmp = new Vector3();
		var px = new CubicPoly();
		var py = new CubicPoly();
		var pz = new CubicPoly();
	
		function CatmullRomCurve3( points, closed, curveType, tension ) {
	
			Curve.call( this );
	
			this.type = 'CatmullRomCurve3';
	
			this.points = points || [];
			this.closed = closed || false;
			this.curveType = curveType || 'centripetal';
			this.tension = tension || 0.5;
	
		}
	
		CatmullRomCurve3.prototype = Object.create( Curve.prototype );
		CatmullRomCurve3.prototype.constructor = CatmullRomCurve3;
	
		CatmullRomCurve3.prototype.isCatmullRomCurve3 = true;
	
		CatmullRomCurve3.prototype.getPoint = function ( t, optionalTarget ) {
	
			var point = optionalTarget || new Vector3();
	
			var points = this.points;
			var l = points.length;
	
			var p = ( l - ( this.closed ? 0 : 1 ) ) * t;
			var intPoint = Math.floor( p );
			var weight = p - intPoint;
	
			if ( this.closed ) {
	
				intPoint += intPoint > 0 ? 0 : ( Math.floor( Math.abs( intPoint ) / points.length ) + 1 ) * points.length;
	
			} else if ( weight === 0 && intPoint === l - 1 ) {
	
				intPoint = l - 2;
				weight = 1;
	
			}
	
			var p0, p1, p2, p3; // 4 points
	
			if ( this.closed || intPoint > 0 ) {
	
				p0 = points[ ( intPoint - 1 ) % l ];
	
			} else {
	
				// extrapolate first point
				tmp.subVectors( points[ 0 ], points[ 1 ] ).add( points[ 0 ] );
				p0 = tmp;
	
			}
	
			p1 = points[ intPoint % l ];
			p2 = points[ ( intPoint + 1 ) % l ];
	
			if ( this.closed || intPoint + 2 < l ) {
	
				p3 = points[ ( intPoint + 2 ) % l ];
	
			} else {
	
				// extrapolate last point
				tmp.subVectors( points[ l - 1 ], points[ l - 2 ] ).add( points[ l - 1 ] );
				p3 = tmp;
	
			}
	
			if ( this.curveType === 'centripetal' || this.curveType === 'chordal' ) {
	
				// init Centripetal / Chordal Catmull-Rom
				var pow = this.curveType === 'chordal' ? 0.5 : 0.25;
				var dt0 = Math.pow( p0.distanceToSquared( p1 ), pow );
				var dt1 = Math.pow( p1.distanceToSquared( p2 ), pow );
				var dt2 = Math.pow( p2.distanceToSquared( p3 ), pow );
	
				// safety check for repeated points
				if ( dt1 < 1e-4 ) dt1 = 1.0;
				if ( dt0 < 1e-4 ) dt0 = dt1;
				if ( dt2 < 1e-4 ) dt2 = dt1;
	
				px.initNonuniformCatmullRom( p0.x, p1.x, p2.x, p3.x, dt0, dt1, dt2 );
				py.initNonuniformCatmullRom( p0.y, p1.y, p2.y, p3.y, dt0, dt1, dt2 );
				pz.initNonuniformCatmullRom( p0.z, p1.z, p2.z, p3.z, dt0, dt1, dt2 );
	
			} else if ( this.curveType === 'catmullrom' ) {
	
				px.initCatmullRom( p0.x, p1.x, p2.x, p3.x, this.tension );
				py.initCatmullRom( p0.y, p1.y, p2.y, p3.y, this.tension );
				pz.initCatmullRom( p0.z, p1.z, p2.z, p3.z, this.tension );
	
			}
	
			point.set(
				px.calc( weight ),
				py.calc( weight ),
				pz.calc( weight )
			);
	
			return point;
	
		};
	
		CatmullRomCurve3.prototype.copy = function ( source ) {
	
			Curve.prototype.copy.call( this, source );
	
			this.points = [];
	
			for ( var i = 0, l = source.points.length; i < l; i ++ ) {
	
				var point = source.points[ i ];
	
				this.points.push( point.clone() );
	
			}
	
			this.closed = source.closed;
			this.curveType = source.curveType;
			this.tension = source.tension;
	
			return this;
	
		};
	
		CatmullRomCurve3.prototype.toJSON = function () {
	
			var data = Curve.prototype.toJSON.call( this );
	
			data.points = [];
	
			for ( var i = 0, l = this.points.length; i < l; i ++ ) {
	
				var point = this.points[ i ];
				data.points.push( point.toArray() );
	
			}
	
			data.closed = this.closed;
			data.curveType = this.curveType;
			data.tension = this.tension;
	
			return data;
	
		};
	
		CatmullRomCurve3.prototype.fromJSON = function ( json ) {
	
			Curve.prototype.fromJSON.call( this, json );
	
			this.points = [];
	
			for ( var i = 0, l = json.points.length; i < l; i ++ ) {
	
				var point = json.points[ i ];
				this.points.push( new Vector3().fromArray( point ) );
	
			}
	
			this.closed = json.closed;
			this.curveType = json.curveType;
			this.tension = json.tension;
	
			return this;
	
		};
	
		/**
		 * @author zz85 / http://www.lab4games.net/zz85/blog
		 *
		 * Bezier Curves formulas obtained from
		 * http://en.wikipedia.org/wiki/Bézier_curve
		 */
	
		function CatmullRom( t, p0, p1, p2, p3 ) {
	
			var v0 = ( p2 - p0 ) * 0.5;
			var v1 = ( p3 - p1 ) * 0.5;
			var t2 = t * t;
			var t3 = t * t2;
			return ( 2 * p1 - 2 * p2 + v0 + v1 ) * t3 + ( - 3 * p1 + 3 * p2 - 2 * v0 - v1 ) * t2 + v0 * t + p1;
	
		}
	
		//
	
		function QuadraticBezierP0( t, p ) {
	
			var k = 1 - t;
			return k * k * p;
	
		}
	
		function QuadraticBezierP1( t, p ) {
	
			return 2 * ( 1 - t ) * t * p;
	
		}
	
		function QuadraticBezierP2( t, p ) {
	
			return t * t * p;
	
		}
	
		function QuadraticBezier( t, p0, p1, p2 ) {
	
			return QuadraticBezierP0( t, p0 ) + QuadraticBezierP1( t, p1 ) +
				QuadraticBezierP2( t, p2 );
	
		}
	
		//
	
		function CubicBezierP0( t, p ) {
	
			var k = 1 - t;
			return k * k * k * p;
	
		}
	
		function CubicBezierP1( t, p ) {
	
			var k = 1 - t;
			return 3 * k * k * t * p;
	
		}
	
		function CubicBezierP2( t, p ) {
	
			return 3 * ( 1 - t ) * t * t * p;
	
		}
	
		function CubicBezierP3( t, p ) {
	
			return t * t * t * p;
	
		}
	
		function CubicBezier( t, p0, p1, p2, p3 ) {
	
			return CubicBezierP0( t, p0 ) + CubicBezierP1( t, p1 ) + CubicBezierP2( t, p2 ) +
				CubicBezierP3( t, p3 );
	
		}
	
		function CubicBezierCurve( v0, v1, v2, v3 ) {
	
			Curve.call( this );
	
			this.type = 'CubicBezierCurve';
	
			this.v0 = v0 || new Vector2();
			this.v1 = v1 || new Vector2();
			this.v2 = v2 || new Vector2();
			this.v3 = v3 || new Vector2();
	
		}
	
		CubicBezierCurve.prototype = Object.create( Curve.prototype );
		CubicBezierCurve.prototype.constructor = CubicBezierCurve;
	
		CubicBezierCurve.prototype.isCubicBezierCurve = true;
	
		CubicBezierCurve.prototype.getPoint = function ( t, optionalTarget ) {
	
			var point = optionalTarget || new Vector2();
	
			var v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
	
			point.set(
				CubicBezier( t, v0.x, v1.x, v2.x, v3.x ),
				CubicBezier( t, v0.y, v1.y, v2.y, v3.y )
			);
	
			return point;
	
		};
	
		CubicBezierCurve.prototype.copy = function ( source ) {
	
			Curve.prototype.copy.call( this, source );
	
			this.v0.copy( source.v0 );
			this.v1.copy( source.v1 );
			this.v2.copy( source.v2 );
			this.v3.copy( source.v3 );
	
			return this;
	
		};
	
		CubicBezierCurve.prototype.toJSON = function () {
	
			var data = Curve.prototype.toJSON.call( this );
	
			data.v0 = this.v0.toArray();
			data.v1 = this.v1.toArray();
			data.v2 = this.v2.toArray();
			data.v3 = this.v3.toArray();
	
			return data;
	
		};
	
		CubicBezierCurve.prototype.fromJSON = function ( json ) {
	
			Curve.prototype.fromJSON.call( this, json );
	
			this.v0.fromArray( json.v0 );
			this.v1.fromArray( json.v1 );
			this.v2.fromArray( json.v2 );
			this.v3.fromArray( json.v3 );
	
			return this;
	
		};
	
		function CubicBezierCurve3( v0, v1, v2, v3 ) {
	
			Curve.call( this );
	
			this.type = 'CubicBezierCurve3';
	
			this.v0 = v0 || new Vector3();
			this.v1 = v1 || new Vector3();
			this.v2 = v2 || new Vector3();
			this.v3 = v3 || new Vector3();
	
		}
	
		CubicBezierCurve3.prototype = Object.create( Curve.prototype );
		CubicBezierCurve3.prototype.constructor = CubicBezierCurve3;
	
		CubicBezierCurve3.prototype.isCubicBezierCurve3 = true;
	
		CubicBezierCurve3.prototype.getPoint = function ( t, optionalTarget ) {
	
			var point = optionalTarget || new Vector3();
	
			var v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
	
			point.set(
				CubicBezier( t, v0.x, v1.x, v2.x, v3.x ),
				CubicBezier( t, v0.y, v1.y, v2.y, v3.y ),
				CubicBezier( t, v0.z, v1.z, v2.z, v3.z )
			);
	
			return point;
	
		};
	
		CubicBezierCurve3.prototype.copy = function ( source ) {
	
			Curve.prototype.copy.call( this, source );
	
			this.v0.copy( source.v0 );
			this.v1.copy( source.v1 );
			this.v2.copy( source.v2 );
			this.v3.copy( source.v3 );
	
			return this;
	
		};
	
		CubicBezierCurve3.prototype.toJSON = function () {
	
			var data = Curve.prototype.toJSON.call( this );
	
			data.v0 = this.v0.toArray();
			data.v1 = this.v1.toArray();
			data.v2 = this.v2.toArray();
			data.v3 = this.v3.toArray();
	
			return data;
	
		};
	
		CubicBezierCurve3.prototype.fromJSON = function ( json ) {
	
			Curve.prototype.fromJSON.call( this, json );
	
			this.v0.fromArray( json.v0 );
			this.v1.fromArray( json.v1 );
			this.v2.fromArray( json.v2 );
			this.v3.fromArray( json.v3 );
	
			return this;
	
		};
	
		function LineCurve( v1, v2 ) {
	
			Curve.call( this );
	
			this.type = 'LineCurve';
	
			this.v1 = v1 || new Vector2();
			this.v2 = v2 || new Vector2();
	
		}
	
		LineCurve.prototype = Object.create( Curve.prototype );
		LineCurve.prototype.constructor = LineCurve;
	
		LineCurve.prototype.isLineCurve = true;
	
		LineCurve.prototype.getPoint = function ( t, optionalTarget ) {
	
			var point = optionalTarget || new Vector2();
	
			if ( t === 1 ) {
	
				point.copy( this.v2 );
	
			} else {
	
				point.copy( this.v2 ).sub( this.v1 );
				point.multiplyScalar( t ).add( this.v1 );
	
			}
	
			return point;
	
		};
	
		// Line curve is linear, so we can overwrite default getPointAt
	
		LineCurve.prototype.getPointAt = function ( u, optionalTarget ) {
	
			return this.getPoint( u, optionalTarget );
	
		};
	
		LineCurve.prototype.getTangent = function ( /* t */ ) {
	
			var tangent = this.v2.clone().sub( this.v1 );
	
			return tangent.normalize();
	
		};
	
		LineCurve.prototype.copy = function ( source ) {
	
			Curve.prototype.copy.call( this, source );
	
			this.v1.copy( source.v1 );
			this.v2.copy( source.v2 );
	
			return this;
	
		};
	
		LineCurve.prototype.toJSON = function () {
	
			var data = Curve.prototype.toJSON.call( this );
	
			data.v1 = this.v1.toArray();
			data.v2 = this.v2.toArray();
	
			return data;
	
		};
	
		LineCurve.prototype.fromJSON = function ( json ) {
	
			Curve.prototype.fromJSON.call( this, json );
	
			this.v1.fromArray( json.v1 );
			this.v2.fromArray( json.v2 );
	
			return this;
	
		};
	
		function LineCurve3( v1, v2 ) {
	
			Curve.call( this );
	
			this.type = 'LineCurve3';
	
			this.v1 = v1 || new Vector3();
			this.v2 = v2 || new Vector3();
	
		}
	
		LineCurve3.prototype = Object.create( Curve.prototype );
		LineCurve3.prototype.constructor = LineCurve3;
	
		LineCurve3.prototype.isLineCurve3 = true;
	
		LineCurve3.prototype.getPoint = function ( t, optionalTarget ) {
	
			var point = optionalTarget || new Vector3();
	
			if ( t === 1 ) {
	
				point.copy( this.v2 );
	
			} else {
	
				point.copy( this.v2 ).sub( this.v1 );
				point.multiplyScalar( t ).add( this.v1 );
	
			}
	
			return point;
	
		};
	
		// Line curve is linear, so we can overwrite default getPointAt
	
		LineCurve3.prototype.getPointAt = function ( u, optionalTarget ) {
	
			return this.getPoint( u, optionalTarget );
	
		};
	
		LineCurve3.prototype.copy = function ( source ) {
	
			Curve.prototype.copy.call( this, source );
	
			this.v1.copy( source.v1 );
			this.v2.copy( source.v2 );
	
			return this;
	
		};
	
		LineCurve3.prototype.toJSON = function () {
	
			var data = Curve.prototype.toJSON.call( this );
	
			data.v1 = this.v1.toArray();
			data.v2 = this.v2.toArray();
	
			return data;
	
		};
	
		LineCurve3.prototype.fromJSON = function ( json ) {
	
			Curve.prototype.fromJSON.call( this, json );
	
			this.v1.fromArray( json.v1 );
			this.v2.fromArray( json.v2 );
	
			return this;
	
		};
	
		function QuadraticBezierCurve( v0, v1, v2 ) {
	
			Curve.call( this );
	
			this.type = 'QuadraticBezierCurve';
	
			this.v0 = v0 || new Vector2();
			this.v1 = v1 || new Vector2();
			this.v2 = v2 || new Vector2();
	
		}
	
		QuadraticBezierCurve.prototype = Object.create( Curve.prototype );
		QuadraticBezierCurve.prototype.constructor = QuadraticBezierCurve;
	
		QuadraticBezierCurve.prototype.isQuadraticBezierCurve = true;
	
		QuadraticBezierCurve.prototype.getPoint = function ( t, optionalTarget ) {
	
			var point = optionalTarget || new Vector2();
	
			var v0 = this.v0, v1 = this.v1, v2 = this.v2;
	
			point.set(
				QuadraticBezier( t, v0.x, v1.x, v2.x ),
				QuadraticBezier( t, v0.y, v1.y, v2.y )
			);
	
			return point;
	
		};
	
		QuadraticBezierCurve.prototype.copy = function ( source ) {
	
			Curve.prototype.copy.call( this, source );
	
			this.v0.copy( source.v0 );
			this.v1.copy( source.v1 );
			this.v2.copy( source.v2 );
	
			return this;
	
		};
	
		QuadraticBezierCurve.prototype.toJSON = function () {
	
			var data = Curve.prototype.toJSON.call( this );
	
			data.v0 = this.v0.toArray();
			data.v1 = this.v1.toArray();
			data.v2 = this.v2.toArray();
	
			return data;
	
		};
	
		QuadraticBezierCurve.prototype.fromJSON = function ( json ) {
	
			Curve.prototype.fromJSON.call( this, json );
	
			this.v0.fromArray( json.v0 );
			this.v1.fromArray( json.v1 );
			this.v2.fromArray( json.v2 );
	
			return this;
	
		};
	
		function QuadraticBezierCurve3( v0, v1, v2 ) {
	
			Curve.call( this );
	
			this.type = 'QuadraticBezierCurve3';
	
			this.v0 = v0 || new Vector3();
			this.v1 = v1 || new Vector3();
			this.v2 = v2 || new Vector3();
	
		}
	
		QuadraticBezierCurve3.prototype = Object.create( Curve.prototype );
		QuadraticBezierCurve3.prototype.constructor = QuadraticBezierCurve3;
	
		QuadraticBezierCurve3.prototype.isQuadraticBezierCurve3 = true;
	
		QuadraticBezierCurve3.prototype.getPoint = function ( t, optionalTarget ) {
	
			var point = optionalTarget || new Vector3();
	
			var v0 = this.v0, v1 = this.v1, v2 = this.v2;
	
			point.set(
				QuadraticBezier( t, v0.x, v1.x, v2.x ),
				QuadraticBezier( t, v0.y, v1.y, v2.y ),
				QuadraticBezier( t, v0.z, v1.z, v2.z )
			);
	
			return point;
	
		};
	
		QuadraticBezierCurve3.prototype.copy = function ( source ) {
	
			Curve.prototype.copy.call( this, source );
	
			this.v0.copy( source.v0 );
			this.v1.copy( source.v1 );
			this.v2.copy( source.v2 );
	
			return this;
	
		};
	
		QuadraticBezierCurve3.prototype.toJSON = function () {
	
			var data = Curve.prototype.toJSON.call( this );
	
			data.v0 = this.v0.toArray();
			data.v1 = this.v1.toArray();
			data.v2 = this.v2.toArray();
	
			return data;
	
		};
	
		QuadraticBezierCurve3.prototype.fromJSON = function ( json ) {
	
			Curve.prototype.fromJSON.call( this, json );
	
			this.v0.fromArray( json.v0 );
			this.v1.fromArray( json.v1 );
			this.v2.fromArray( json.v2 );
	
			return this;
	
		};
	
		function SplineCurve( points /* array of Vector2 */ ) {
	
			Curve.call( this );
	
			this.type = 'SplineCurve';
	
			this.points = points || [];
	
		}
	
		SplineCurve.prototype = Object.create( Curve.prototype );
		SplineCurve.prototype.constructor = SplineCurve;
	
		SplineCurve.prototype.isSplineCurve = true;
	
		SplineCurve.prototype.getPoint = function ( t, optionalTarget ) {
	
			var point = optionalTarget || new Vector2();
	
			var points = this.points;
			var p = ( points.length - 1 ) * t;
	
			var intPoint = Math.floor( p );
			var weight = p - intPoint;
	
			var p0 = points[ intPoint === 0 ? intPoint : intPoint - 1 ];
			var p1 = points[ intPoint ];
			var p2 = points[ intPoint > points.length - 2 ? points.length - 1 : intPoint + 1 ];
			var p3 = points[ intPoint > points.length - 3 ? points.length - 1 : intPoint + 2 ];
	
			point.set(
				CatmullRom( weight, p0.x, p1.x, p2.x, p3.x ),
				CatmullRom( weight, p0.y, p1.y, p2.y, p3.y )
			);
	
			return point;
	
		};
	
		SplineCurve.prototype.copy = function ( source ) {
	
			Curve.prototype.copy.call( this, source );
	
			this.points = [];
	
			for ( var i = 0, l = source.points.length; i < l; i ++ ) {
	
				var point = source.points[ i ];
	
				this.points.push( point.clone() );
	
			}
	
			return this;
	
		};
	
		SplineCurve.prototype.toJSON = function () {
	
			var data = Curve.prototype.toJSON.call( this );
	
			data.points = [];
	
			for ( var i = 0, l = this.points.length; i < l; i ++ ) {
	
				var point = this.points[ i ];
				data.points.push( point.toArray() );
	
			}
	
			return data;
	
		};
	
		SplineCurve.prototype.fromJSON = function ( json ) {
	
			Curve.prototype.fromJSON.call( this, json );
	
			this.points = [];
	
			for ( var i = 0, l = json.points.length; i < l; i ++ ) {
	
				var point = json.points[ i ];
				this.points.push( new Vector2().fromArray( point ) );
	
			}
	
			return this;
	
		};
	
	
	
		var Curves = Object.freeze({
			ArcCurve: ArcCurve,
			CatmullRomCurve3: CatmullRomCurve3,
			CubicBezierCurve: CubicBezierCurve,
			CubicBezierCurve3: CubicBezierCurve3,
			EllipseCurve: EllipseCurve,
			LineCurve: LineCurve,
			LineCurve3: LineCurve3,
			QuadraticBezierCurve: QuadraticBezierCurve,
			QuadraticBezierCurve3: QuadraticBezierCurve3,
			SplineCurve: SplineCurve
		});
	
		/**
		 * @author zz85 / http://www.lab4games.net/zz85/blog
		 *
		 **/
	
		/**************************************************************
		 *	Curved Path - a curve path is simply a array of connected
		 *  curves, but retains the api of a curve
		 **************************************************************/
	
		function CurvePath() {
	
			Curve.call( this );
	
			this.type = 'CurvePath';
	
			this.curves = [];
			this.autoClose = false; // Automatically closes the path
	
		}
	
		CurvePath.prototype = Object.assign( Object.create( Curve.prototype ), {
	
			constructor: CurvePath,
	
			add: function ( curve ) {
	
				this.curves.push( curve );
	
			},
	
			closePath: function () {
	
				// Add a line curve if start and end of lines are not connected
				var startPoint = this.curves[ 0 ].getPoint( 0 );
				var endPoint = this.curves[ this.curves.length - 1 ].getPoint( 1 );
	
				if ( ! startPoint.equals( endPoint ) ) {
	
					this.curves.push( new LineCurve( endPoint, startPoint ) );
	
				}
	
			},
	
			// To get accurate point with reference to
			// entire path distance at time t,
			// following has to be done:
	
			// 1. Length of each sub path have to be known
			// 2. Locate and identify type of curve
			// 3. Get t for the curve
			// 4. Return curve.getPointAt(t')
	
			getPoint: function ( t ) {
	
				var d = t * this.getLength();
				var curveLengths = this.getCurveLengths();
				var i = 0;
	
				// To think about boundaries points.
	
				while ( i < curveLengths.length ) {
	
					if ( curveLengths[ i ] >= d ) {
	
						var diff = curveLengths[ i ] - d;
						var curve = this.curves[ i ];
	
						var segmentLength = curve.getLength();
						var u = segmentLength === 0 ? 0 : 1 - diff / segmentLength;
	
						return curve.getPointAt( u );
	
					}
	
					i ++;
	
				}
	
				return null;
	
				// loop where sum != 0, sum > d , sum+1 <d
	
			},
	
			// We cannot use the default THREE.Curve getPoint() with getLength() because in
			// THREE.Curve, getLength() depends on getPoint() but in THREE.CurvePath
			// getPoint() depends on getLength
	
			getLength: function () {
	
				var lens = this.getCurveLengths();
				return lens[ lens.length - 1 ];
	
			},
	
			// cacheLengths must be recalculated.
			updateArcLengths: function () {
	
				this.needsUpdate = true;
				this.cacheLengths = null;
				this.getCurveLengths();
	
			},
	
			// Compute lengths and cache them
			// We cannot overwrite getLengths() because UtoT mapping uses it.
	
			getCurveLengths: function () {
	
				// We use cache values if curves and cache array are same length
	
				if ( this.cacheLengths && this.cacheLengths.length === this.curves.length ) {
	
					return this.cacheLengths;
	
				}
	
				// Get length of sub-curve
				// Push sums into cached array
	
				var lengths = [], sums = 0;
	
				for ( var i = 0, l = this.curves.length; i < l; i ++ ) {
	
					sums += this.curves[ i ].getLength();
					lengths.push( sums );
	
				}
	
				this.cacheLengths = lengths;
	
				return lengths;
	
			},
	
			getSpacedPoints: function ( divisions ) {
	
				if ( divisions === undefined ) divisions = 40;
	
				var points = [];
	
				for ( var i = 0; i <= divisions; i ++ ) {
	
					points.push( this.getPoint( i / divisions ) );
	
				}
	
				if ( this.autoClose ) {
	
					points.push( points[ 0 ] );
	
				}
	
				return points;
	
			},
	
			getPoints: function ( divisions ) {
	
				divisions = divisions || 12;
	
				var points = [], last;
	
				for ( var i = 0, curves = this.curves; i < curves.length; i ++ ) {
	
					var curve = curves[ i ];
					var resolution = ( curve && curve.isEllipseCurve ) ? divisions * 2
						: ( curve && curve.isLineCurve ) ? 1
							: ( curve && curve.isSplineCurve ) ? divisions * curve.points.length
								: divisions;
	
					var pts = curve.getPoints( resolution );
	
					for ( var j = 0; j < pts.length; j ++ ) {
	
						var point = pts[ j ];
	
						if ( last && last.equals( point ) ) continue; // ensures no consecutive points are duplicates
	
						points.push( point );
						last = point;
	
					}
	
				}
	
				if ( this.autoClose && points.length > 1 && ! points[ points.length - 1 ].equals( points[ 0 ] ) ) {
	
					points.push( points[ 0 ] );
	
				}
	
				return points;
	
			},
	
			copy: function ( source ) {
	
				Curve.prototype.copy.call( this, source );
	
				this.curves = [];
	
				for ( var i = 0, l = source.curves.length; i < l; i ++ ) {
	
					var curve = source.curves[ i ];
	
					this.curves.push( curve.clone() );
	
				}
	
				this.autoClose = source.autoClose;
	
				return this;
	
			},
	
			toJSON: function () {
	
				var data = Curve.prototype.toJSON.call( this );
	
				data.autoClose = this.autoClose;
				data.curves = [];
	
				for ( var i = 0, l = this.curves.length; i < l; i ++ ) {
	
					var curve = this.curves[ i ];
					data.curves.push( curve.toJSON() );
	
				}
	
				return data;
	
			},
	
			fromJSON: function ( json ) {
	
				Curve.prototype.fromJSON.call( this, json );
	
				this.autoClose = json.autoClose;
				this.curves = [];
	
				for ( var i = 0, l = json.curves.length; i < l; i ++ ) {
	
					var curve = json.curves[ i ];
					this.curves.push( new Curves[ curve.type ]().fromJSON( curve ) );
	
				}
	
				return this;
	
			}
	
		} );
	
		/**
		 * @author zz85 / http://www.lab4games.net/zz85/blog
		 * Creates free form 2d path using series of points, lines or curves.
		 **/
	
		function Path( points ) {
	
			CurvePath.call( this );
	
			this.type = 'Path';
	
			this.currentPoint = new Vector2();
	
			if ( points ) {
	
				this.setFromPoints( points );
	
			}
	
		}
	
		Path.prototype = Object.assign( Object.create( CurvePath.prototype ), {
	
			constructor: Path,
	
			setFromPoints: function ( points ) {
	
				this.moveTo( points[ 0 ].x, points[ 0 ].y );
	
				for ( var i = 1, l = points.length; i < l; i ++ ) {
	
					this.lineTo( points[ i ].x, points[ i ].y );
	
				}
	
			},
	
			moveTo: function ( x, y ) {
	
				this.currentPoint.set( x, y ); // TODO consider referencing vectors instead of copying?
	
			},
	
			lineTo: function ( x, y ) {
	
				var curve = new LineCurve( this.currentPoint.clone(), new Vector2( x, y ) );
				this.curves.push( curve );
	
				this.currentPoint.set( x, y );
	
			},
	
			quadraticCurveTo: function ( aCPx, aCPy, aX, aY ) {
	
				var curve = new QuadraticBezierCurve(
					this.currentPoint.clone(),
					new Vector2( aCPx, aCPy ),
					new Vector2( aX, aY )
				);
	
				this.curves.push( curve );
	
				this.currentPoint.set( aX, aY );
	
			},
	
			bezierCurveTo: function ( aCP1x, aCP1y, aCP2x, aCP2y, aX, aY ) {
	
				var curve = new CubicBezierCurve(
					this.currentPoint.clone(),
					new Vector2( aCP1x, aCP1y ),
					new Vector2( aCP2x, aCP2y ),
					new Vector2( aX, aY )
				);
	
				this.curves.push( curve );
	
				this.currentPoint.set( aX, aY );
	
			},
	
			splineThru: function ( pts /*Array of Vector*/ ) {
	
				var npts = [ this.currentPoint.clone() ].concat( pts );
	
				var curve = new SplineCurve( npts );
				this.curves.push( curve );
	
				this.currentPoint.copy( pts[ pts.length - 1 ] );
	
			},
	
			arc: function ( aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise ) {
	
				var x0 = this.currentPoint.x;
				var y0 = this.currentPoint.y;
	
				this.absarc( aX + x0, aY + y0, aRadius,
					aStartAngle, aEndAngle, aClockwise );
	
			},
	
			absarc: function ( aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise ) {
	
				this.absellipse( aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise );
	
			},
	
			ellipse: function ( aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation ) {
	
				var x0 = this.currentPoint.x;
				var y0 = this.currentPoint.y;
	
				this.absellipse( aX + x0, aY + y0, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation );
	
			},
	
			absellipse: function ( aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation ) {
	
				var curve = new EllipseCurve( aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation );
	
				if ( this.curves.length > 0 ) {
	
					// if a previous curve is present, attempt to join
					var firstPoint = curve.getPoint( 0 );
	
					if ( ! firstPoint.equals( this.currentPoint ) ) {
	
						this.lineTo( firstPoint.x, firstPoint.y );
	
					}
	
				}
	
				this.curves.push( curve );
	
				var lastPoint = curve.getPoint( 1 );
				this.currentPoint.copy( lastPoint );
	
			},
	
			copy: function ( source ) {
	
				CurvePath.prototype.copy.call( this, source );
	
				this.currentPoint.copy( source.currentPoint );
	
				return this;
	
			},
	
			toJSON: function () {
	
				var data = CurvePath.prototype.toJSON.call( this );
	
				data.currentPoint = this.currentPoint.toArray();
	
				return data;
	
			},
	
			fromJSON: function ( json ) {
	
				CurvePath.prototype.fromJSON.call( this, json );
	
				this.currentPoint.fromArray( json.currentPoint );
	
				return this;
	
			}
	
		} );
	
		/**
		 * @author zz85 / http://www.lab4games.net/zz85/blog
		 * Defines a 2d shape plane using paths.
		 **/
	
		// STEP 1 Create a path.
		// STEP 2 Turn path into shape.
		// STEP 3 ExtrudeGeometry takes in Shape/Shapes
		// STEP 3a - Extract points from each shape, turn to vertices
		// STEP 3b - Triangulate each shape, add faces.
	
		function Shape( points ) {
	
			Path.call( this, points );
	
			this.uuid = _Math.generateUUID();
	
			this.type = 'Shape';
	
			this.holes = [];
	
		}
	
		Shape.prototype = Object.assign( Object.create( Path.prototype ), {
	
			constructor: Shape,
	
			getPointsHoles: function ( divisions ) {
	
				var holesPts = [];
	
				for ( var i = 0, l = this.holes.length; i < l; i ++ ) {
	
					holesPts[ i ] = this.holes[ i ].getPoints( divisions );
	
				}
	
				return holesPts;
	
			},
	
			// get points of shape and holes (keypoints based on segments parameter)
	
			extractPoints: function ( divisions ) {
	
				return {
	
					shape: this.getPoints( divisions ),
					holes: this.getPointsHoles( divisions )
	
				};
	
			},
	
			copy: function ( source ) {
	
				Path.prototype.copy.call( this, source );
	
				this.holes = [];
	
				for ( var i = 0, l = source.holes.length; i < l; i ++ ) {
	
					var hole = source.holes[ i ];
	
					this.holes.push( hole.clone() );
	
				}
	
				return this;
	
			},
	
			toJSON: function () {
	
				var data = Path.prototype.toJSON.call( this );
	
				data.uuid = this.uuid;
				data.holes = [];
	
				for ( var i = 0, l = this.holes.length; i < l; i ++ ) {
	
					var hole = this.holes[ i ];
					data.holes.push( hole.toJSON() );
	
				}
	
				return data;
	
			},
	
			fromJSON: function ( json ) {
	
				Path.prototype.fromJSON.call( this, json );
	
				this.uuid = json.uuid;
				this.holes = [];
	
				for ( var i = 0, l = json.holes.length; i < l; i ++ ) {
	
					var hole = json.holes[ i ];
					this.holes.push( new Path().fromJSON( hole ) );
	
				}
	
				return this;
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author alteredq / http://alteredqualia.com/
		 */
	
		function Light( color, intensity ) {
	
			Object3D.call( this );
	
			this.type = 'Light';
	
			this.color = new Color( color );
			this.intensity = intensity !== undefined ? intensity : 1;
	
			this.receiveShadow = undefined;
	
		}
	
		Light.prototype = Object.assign( Object.create( Object3D.prototype ), {
	
			constructor: Light,
	
			isLight: true,
	
			copy: function ( source ) {
	
				Object3D.prototype.copy.call( this, source );
	
				this.color.copy( source.color );
				this.intensity = source.intensity;
	
				return this;
	
			},
	
			toJSON: function ( meta ) {
	
				var data = Object3D.prototype.toJSON.call( this, meta );
	
				data.object.color = this.color.getHex();
				data.object.intensity = this.intensity;
	
				if ( this.groundColor !== undefined ) data.object.groundColor = this.groundColor.getHex();
	
				if ( this.distance !== undefined ) data.object.distance = this.distance;
				if ( this.angle !== undefined ) data.object.angle = this.angle;
				if ( this.decay !== undefined ) data.object.decay = this.decay;
				if ( this.penumbra !== undefined ) data.object.penumbra = this.penumbra;
	
				if ( this.shadow !== undefined ) data.object.shadow = this.shadow.toJSON();
	
				return data;
	
			}
	
		} );
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 */
	
		function HemisphereLight( skyColor, groundColor, intensity ) {
	
			Light.call( this, skyColor, intensity );
	
			this.type = 'HemisphereLight';
	
			this.castShadow = undefined;
	
			this.position.copy( Object3D.DefaultUp );
			this.updateMatrix();
	
			this.groundColor = new Color( groundColor );
	
		}
	
		HemisphereLight.prototype = Object.assign( Object.create( Light.prototype ), {
	
			constructor: HemisphereLight,
	
			isHemisphereLight: true,
	
			copy: function ( source ) {
	
				Light.prototype.copy.call( this, source );
	
				this.groundColor.copy( source.groundColor );
	
				return this;
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function LightShadow( camera ) {
	
			this.camera = camera;
	
			this.bias = 0;
			this.radius = 1;
	
			this.mapSize = new Vector2( 512, 512 );
	
			this.map = null;
			this.matrix = new Matrix4();
	
		}
	
		Object.assign( LightShadow.prototype, {
	
			copy: function ( source ) {
	
				this.camera = source.camera.clone();
	
				this.bias = source.bias;
				this.radius = source.radius;
	
				this.mapSize.copy( source.mapSize );
	
				return this;
	
			},
	
			clone: function () {
	
				return new this.constructor().copy( this );
	
			},
	
			toJSON: function () {
	
				var object = {};
	
				if ( this.bias !== 0 ) object.bias = this.bias;
				if ( this.radius !== 1 ) object.radius = this.radius;
				if ( this.mapSize.x !== 512 || this.mapSize.y !== 512 ) object.mapSize = this.mapSize.toArray();
	
				object.camera = this.camera.toJSON( false ).object;
				delete object.camera.matrix;
	
				return object;
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function SpotLightShadow() {
	
			LightShadow.call( this, new PerspectiveCamera( 50, 1, 0.5, 500 ) );
	
		}
	
		SpotLightShadow.prototype = Object.assign( Object.create( LightShadow.prototype ), {
	
			constructor: SpotLightShadow,
	
			isSpotLightShadow: true,
	
			update: function ( light ) {
	
				var camera = this.camera;
	
				var fov = _Math.RAD2DEG * 2 * light.angle;
				var aspect = this.mapSize.width / this.mapSize.height;
				var far = light.distance || camera.far;
	
				if ( fov !== camera.fov || aspect !== camera.aspect || far !== camera.far ) {
	
					camera.fov = fov;
					camera.aspect = aspect;
					camera.far = far;
					camera.updateProjectionMatrix();
	
				}
	
			}
	
		} );
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 */
	
		function SpotLight( color, intensity, distance, angle, penumbra, decay ) {
	
			Light.call( this, color, intensity );
	
			this.type = 'SpotLight';
	
			this.position.copy( Object3D.DefaultUp );
			this.updateMatrix();
	
			this.target = new Object3D();
	
			Object.defineProperty( this, 'power', {
				get: function () {
	
					// intensity = power per solid angle.
					// ref: equation (17) from http://www.frostbite.com/wp-content/uploads/2014/11/course_notes_moving_frostbite_to_pbr.pdf
					return this.intensity * Math.PI;
	
				},
				set: function ( power ) {
	
					// intensity = power per solid angle.
					// ref: equation (17) from http://www.frostbite.com/wp-content/uploads/2014/11/course_notes_moving_frostbite_to_pbr.pdf
					this.intensity = power / Math.PI;
	
				}
			} );
	
			this.distance = ( distance !== undefined ) ? distance : 0;
			this.angle = ( angle !== undefined ) ? angle : Math.PI / 3;
			this.penumbra = ( penumbra !== undefined ) ? penumbra : 0;
			this.decay = ( decay !== undefined ) ? decay : 1;	// for physically correct lights, should be 2.
	
			this.shadow = new SpotLightShadow();
	
		}
	
		SpotLight.prototype = Object.assign( Object.create( Light.prototype ), {
	
			constructor: SpotLight,
	
			isSpotLight: true,
	
			copy: function ( source ) {
	
				Light.prototype.copy.call( this, source );
	
				this.distance = source.distance;
				this.angle = source.angle;
				this.penumbra = source.penumbra;
				this.decay = source.decay;
	
				this.target = source.target.clone();
	
				this.shadow = source.shadow.clone();
	
				return this;
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
	
		function PointLight( color, intensity, distance, decay ) {
	
			Light.call( this, color, intensity );
	
			this.type = 'PointLight';
	
			Object.defineProperty( this, 'power', {
				get: function () {
	
					// intensity = power per solid angle.
					// ref: equation (15) from http://www.frostbite.com/wp-content/uploads/2014/11/course_notes_moving_frostbite_to_pbr.pdf
					return this.intensity * 4 * Math.PI;
	
				},
				set: function ( power ) {
	
					// intensity = power per solid angle.
					// ref: equation (15) from http://www.frostbite.com/wp-content/uploads/2014/11/course_notes_moving_frostbite_to_pbr.pdf
					this.intensity = power / ( 4 * Math.PI );
	
				}
			} );
	
			this.distance = ( distance !== undefined ) ? distance : 0;
			this.decay = ( decay !== undefined ) ? decay : 1;	// for physically correct lights, should be 2.
	
			this.shadow = new LightShadow( new PerspectiveCamera( 90, 1, 0.5, 500 ) );
	
		}
	
		PointLight.prototype = Object.assign( Object.create( Light.prototype ), {
	
			constructor: PointLight,
	
			isPointLight: true,
	
			copy: function ( source ) {
	
				Light.prototype.copy.call( this, source );
	
				this.distance = source.distance;
				this.decay = source.decay;
	
				this.shadow = source.shadow.clone();
	
				return this;
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function DirectionalLightShadow( ) {
	
			LightShadow.call( this, new OrthographicCamera( - 5, 5, 5, - 5, 0.5, 500 ) );
	
		}
	
		DirectionalLightShadow.prototype = Object.assign( Object.create( LightShadow.prototype ), {
	
			constructor: DirectionalLightShadow
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author alteredq / http://alteredqualia.com/
		 */
	
		function DirectionalLight( color, intensity ) {
	
			Light.call( this, color, intensity );
	
			this.type = 'DirectionalLight';
	
			this.position.copy( Object3D.DefaultUp );
			this.updateMatrix();
	
			this.target = new Object3D();
	
			this.shadow = new DirectionalLightShadow();
	
		}
	
		DirectionalLight.prototype = Object.assign( Object.create( Light.prototype ), {
	
			constructor: DirectionalLight,
	
			isDirectionalLight: true,
	
			copy: function ( source ) {
	
				Light.prototype.copy.call( this, source );
	
				this.target = source.target.clone();
	
				this.shadow = source.shadow.clone();
	
				return this;
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function AmbientLight( color, intensity ) {
	
			Light.call( this, color, intensity );
	
			this.type = 'AmbientLight';
	
			this.castShadow = undefined;
	
		}
	
		AmbientLight.prototype = Object.assign( Object.create( Light.prototype ), {
	
			constructor: AmbientLight,
	
			isAmbientLight: true
	
		} );
	
		/**
		 * @author abelnation / http://github.com/abelnation
		 */
	
		function RectAreaLight( color, intensity, width, height ) {
	
			Light.call( this, color, intensity );
	
			this.type = 'RectAreaLight';
	
			this.position.set( 0, 1, 0 );
			this.updateMatrix();
	
			this.width = ( width !== undefined ) ? width : 10;
			this.height = ( height !== undefined ) ? height : 10;
	
			// TODO (abelnation): distance/decay
	
			// TODO (abelnation): update method for RectAreaLight to update transform to lookat target
	
			// TODO (abelnation): shadows
	
		}
	
		// TODO (abelnation): RectAreaLight update when light shape is changed
		RectAreaLight.prototype = Object.assign( Object.create( Light.prototype ), {
	
			constructor: RectAreaLight,
	
			isRectAreaLight: true,
	
			copy: function ( source ) {
	
				Light.prototype.copy.call( this, source );
	
				this.width = source.width;
				this.height = source.height;
	
				return this;
	
			},
	
			toJSON: function ( meta ) {
	
				var data = Light.prototype.toJSON.call( this, meta );
	
				data.object.width = this.width;
				data.object.height = this.height;
	
				return data;
	
			}
	
		} );
	
		/**
		 *
		 * A Track that interpolates Strings
		 *
		 *
		 * @author Ben Houston / http://clara.io/
		 * @author David Sarno / http://lighthaus.us/
		 * @author tschw
		 */
	
		function StringKeyframeTrack( name, times, values, interpolation ) {
	
			KeyframeTrack.call( this, name, times, values, interpolation );
	
		}
	
		StringKeyframeTrack.prototype = Object.assign( Object.create( KeyframeTrack.prototype ), {
	
			constructor: StringKeyframeTrack,
	
			ValueTypeName: 'string',
			ValueBufferType: Array,
	
			DefaultInterpolation: InterpolateDiscrete,
	
			InterpolantFactoryMethodLinear: undefined,
	
			InterpolantFactoryMethodSmooth: undefined
	
		} );
	
		/**
		 *
		 * A Track of Boolean keyframe values.
		 *
		 *
		 * @author Ben Houston / http://clara.io/
		 * @author David Sarno / http://lighthaus.us/
		 * @author tschw
		 */
	
		function BooleanKeyframeTrack( name, times, values ) {
	
			KeyframeTrack.call( this, name, times, values );
	
		}
	
		BooleanKeyframeTrack.prototype = Object.assign( Object.create( KeyframeTrack.prototype ), {
	
			constructor: BooleanKeyframeTrack,
	
			ValueTypeName: 'bool',
			ValueBufferType: Array,
	
			DefaultInterpolation: InterpolateDiscrete,
	
			InterpolantFactoryMethodLinear: undefined,
			InterpolantFactoryMethodSmooth: undefined
	
			// Note: Actually this track could have a optimized / compressed
			// representation of a single value and a custom interpolant that
			// computes "firstValue ^ isOdd( index )".
	
		} );
	
		/**
		 * Abstract base class of interpolants over parametric samples.
		 *
		 * The parameter domain is one dimensional, typically the time or a path
		 * along a curve defined by the data.
		 *
		 * The sample values can have any dimensionality and derived classes may
		 * apply special interpretations to the data.
		 *
		 * This class provides the interval seek in a Template Method, deferring
		 * the actual interpolation to derived classes.
		 *
		 * Time complexity is O(1) for linear access crossing at most two points
		 * and O(log N) for random access, where N is the number of positions.
		 *
		 * References:
		 *
		 * 		http://www.oodesign.com/template-method-pattern.html
		 *
		 * @author tschw
		 */
	
		function Interpolant( parameterPositions, sampleValues, sampleSize, resultBuffer ) {
	
			this.parameterPositions = parameterPositions;
			this._cachedIndex = 0;
	
			this.resultBuffer = resultBuffer !== undefined ?
				resultBuffer : new sampleValues.constructor( sampleSize );
			this.sampleValues = sampleValues;
			this.valueSize = sampleSize;
	
		}
	
		Object.assign( Interpolant.prototype, {
	
			evaluate: function ( t ) {
	
				var pp = this.parameterPositions,
					i1 = this._cachedIndex,
	
					t1 = pp[ i1 ],
					t0 = pp[ i1 - 1 ];
	
				validate_interval: {
	
					seek: {
	
						var right;
	
						linear_scan: {
	
							//- See http://jsperf.com/comparison-to-undefined/3
							//- slower code:
							//-
							//- 				if ( t >= t1 || t1 === undefined ) {
							forward_scan: if ( ! ( t < t1 ) ) {
	
								for ( var giveUpAt = i1 + 2; ; ) {
	
									if ( t1 === undefined ) {
	
										if ( t < t0 ) break forward_scan;
	
										// after end
	
										i1 = pp.length;
										this._cachedIndex = i1;
										return this.afterEnd_( i1 - 1, t, t0 );
	
									}
	
									if ( i1 === giveUpAt ) break; // this loop
	
									t0 = t1;
									t1 = pp[ ++ i1 ];
	
									if ( t < t1 ) {
	
										// we have arrived at the sought interval
										break seek;
	
									}
	
								}
	
								// prepare binary search on the right side of the index
								right = pp.length;
								break linear_scan;
	
							}
	
							//- slower code:
							//-					if ( t < t0 || t0 === undefined ) {
							if ( ! ( t >= t0 ) ) {
	
								// looping?
	
								var t1global = pp[ 1 ];
	
								if ( t < t1global ) {
	
									i1 = 2; // + 1, using the scan for the details
									t0 = t1global;
	
								}
	
								// linear reverse scan
	
								for ( var giveUpAt = i1 - 2; ; ) {
	
									if ( t0 === undefined ) {
	
										// before start
	
										this._cachedIndex = 0;
										return this.beforeStart_( 0, t, t1 );
	
									}
	
									if ( i1 === giveUpAt ) break; // this loop
	
									t1 = t0;
									t0 = pp[ -- i1 - 1 ];
	
									if ( t >= t0 ) {
	
										// we have arrived at the sought interval
										break seek;
	
									}
	
								}
	
								// prepare binary search on the left side of the index
								right = i1;
								i1 = 0;
								break linear_scan;
	
							}
	
							// the interval is valid
	
							break validate_interval;
	
						} // linear scan
	
						// binary search
	
						while ( i1 < right ) {
	
							var mid = ( i1 + right ) >>> 1;
	
							if ( t < pp[ mid ] ) {
	
								right = mid;
	
							} else {
	
								i1 = mid + 1;
	
							}
	
						}
	
						t1 = pp[ i1 ];
						t0 = pp[ i1 - 1 ];
	
						// check boundary cases, again
	
						if ( t0 === undefined ) {
	
							this._cachedIndex = 0;
							return this.beforeStart_( 0, t, t1 );
	
						}
	
						if ( t1 === undefined ) {
	
							i1 = pp.length;
							this._cachedIndex = i1;
							return this.afterEnd_( i1 - 1, t0, t );
	
						}
	
					} // seek
	
					this._cachedIndex = i1;
	
					this.intervalChanged_( i1, t0, t1 );
	
				} // validate_interval
	
				return this.interpolate_( i1, t0, t, t1 );
	
			},
	
			settings: null, // optional, subclass-specific settings structure
			// Note: The indirection allows central control of many interpolants.
	
			// --- Protected interface
	
			DefaultSettings_: {},
	
			getSettings_: function () {
	
				return this.settings || this.DefaultSettings_;
	
			},
	
			copySampleValue_: function ( index ) {
	
				// copies a sample value to the result buffer
	
				var result = this.resultBuffer,
					values = this.sampleValues,
					stride = this.valueSize,
					offset = index * stride;
	
				for ( var i = 0; i !== stride; ++ i ) {
	
					result[ i ] = values[ offset + i ];
	
				}
	
				return result;
	
			},
	
			// Template methods for derived classes:
	
			interpolate_: function ( /* i1, t0, t, t1 */ ) {
	
				throw new Error( 'call to abstract method' );
				// implementations shall return this.resultBuffer
	
			},
	
			intervalChanged_: function ( /* i1, t0, t1 */ ) {
	
				// empty
	
			}
	
		} );
	
		//!\ DECLARE ALIAS AFTER assign prototype !
		Object.assign( Interpolant.prototype, {
	
			//( 0, t, t0 ), returns this.resultBuffer
			beforeStart_: Interpolant.prototype.copySampleValue_,
	
			//( N-1, tN-1, t ), returns this.resultBuffer
			afterEnd_: Interpolant.prototype.copySampleValue_,
	
		} );
	
		/**
		 * Spherical linear unit quaternion interpolant.
		 *
		 * @author tschw
		 */
	
		function QuaternionLinearInterpolant( parameterPositions, sampleValues, sampleSize, resultBuffer ) {
	
			Interpolant.call( this, parameterPositions, sampleValues, sampleSize, resultBuffer );
	
		}
	
		QuaternionLinearInterpolant.prototype = Object.assign( Object.create( Interpolant.prototype ), {
	
			constructor: QuaternionLinearInterpolant,
	
			interpolate_: function ( i1, t0, t, t1 ) {
	
				var result = this.resultBuffer,
					values = this.sampleValues,
					stride = this.valueSize,
	
					offset = i1 * stride,
	
					alpha = ( t - t0 ) / ( t1 - t0 );
	
				for ( var end = offset + stride; offset !== end; offset += 4 ) {
	
					Quaternion.slerpFlat( result, 0, values, offset - stride, values, offset, alpha );
	
				}
	
				return result;
	
			}
	
		} );
	
		/**
		 *
		 * A Track of quaternion keyframe values.
		 *
		 * @author Ben Houston / http://clara.io/
		 * @author David Sarno / http://lighthaus.us/
		 * @author tschw
		 */
	
		function QuaternionKeyframeTrack( name, times, values, interpolation ) {
	
			KeyframeTrack.call( this, name, times, values, interpolation );
	
		}
	
		QuaternionKeyframeTrack.prototype = Object.assign( Object.create( KeyframeTrack.prototype ), {
	
			constructor: QuaternionKeyframeTrack,
	
			ValueTypeName: 'quaternion',
	
			// ValueBufferType is inherited
	
			DefaultInterpolation: InterpolateLinear,
	
			InterpolantFactoryMethodLinear: function ( result ) {
	
				return new QuaternionLinearInterpolant( this.times, this.values, this.getValueSize(), result );
	
			},
	
			InterpolantFactoryMethodSmooth: undefined // not yet implemented
	
		} );
	
		/**
		 *
		 * A Track of keyframe values that represent color.
		 *
		 *
		 * @author Ben Houston / http://clara.io/
		 * @author David Sarno / http://lighthaus.us/
		 * @author tschw
		 */
	
		function ColorKeyframeTrack( name, times, values, interpolation ) {
	
			KeyframeTrack.call( this, name, times, values, interpolation );
	
		}
	
		ColorKeyframeTrack.prototype = Object.assign( Object.create( KeyframeTrack.prototype ), {
	
			constructor: ColorKeyframeTrack,
	
			ValueTypeName: 'color'
	
			// ValueBufferType is inherited
	
			// DefaultInterpolation is inherited
	
			// Note: Very basic implementation and nothing special yet.
			// However, this is the place for color space parameterization.
	
		} );
	
		/**
		 *
		 * A Track of numeric keyframe values.
		 *
		 * @author Ben Houston / http://clara.io/
		 * @author David Sarno / http://lighthaus.us/
		 * @author tschw
		 */
	
		function NumberKeyframeTrack( name, times, values, interpolation ) {
	
			KeyframeTrack.call( this, name, times, values, interpolation );
	
		}
	
		NumberKeyframeTrack.prototype = Object.assign( Object.create( KeyframeTrack.prototype ), {
	
			constructor: NumberKeyframeTrack,
	
			ValueTypeName: 'number'
	
			// ValueBufferType is inherited
	
			// DefaultInterpolation is inherited
	
		} );
	
		/**
		 * Fast and simple cubic spline interpolant.
		 *
		 * It was derived from a Hermitian construction setting the first derivative
		 * at each sample position to the linear slope between neighboring positions
		 * over their parameter interval.
		 *
		 * @author tschw
		 */
	
		function CubicInterpolant( parameterPositions, sampleValues, sampleSize, resultBuffer ) {
	
			Interpolant.call( this, parameterPositions, sampleValues, sampleSize, resultBuffer );
	
			this._weightPrev = - 0;
			this._offsetPrev = - 0;
			this._weightNext = - 0;
			this._offsetNext = - 0;
	
		}
	
		CubicInterpolant.prototype = Object.assign( Object.create( Interpolant.prototype ), {
	
			constructor: CubicInterpolant,
	
			DefaultSettings_: {
	
				endingStart: ZeroCurvatureEnding,
				endingEnd: ZeroCurvatureEnding
	
			},
	
			intervalChanged_: function ( i1, t0, t1 ) {
	
				var pp = this.parameterPositions,
					iPrev = i1 - 2,
					iNext = i1 + 1,
	
					tPrev = pp[ iPrev ],
					tNext = pp[ iNext ];
	
				if ( tPrev === undefined ) {
	
					switch ( this.getSettings_().endingStart ) {
	
						case ZeroSlopeEnding:
	
							// f'(t0) = 0
							iPrev = i1;
							tPrev = 2 * t0 - t1;
	
							break;
	
						case WrapAroundEnding:
	
							// use the other end of the curve
							iPrev = pp.length - 2;
							tPrev = t0 + pp[ iPrev ] - pp[ iPrev + 1 ];
	
							break;
	
						default: // ZeroCurvatureEnding
	
							// f''(t0) = 0 a.k.a. Natural Spline
							iPrev = i1;
							tPrev = t1;
	
					}
	
				}
	
				if ( tNext === undefined ) {
	
					switch ( this.getSettings_().endingEnd ) {
	
						case ZeroSlopeEnding:
	
							// f'(tN) = 0
							iNext = i1;
							tNext = 2 * t1 - t0;
	
							break;
	
						case WrapAroundEnding:
	
							// use the other end of the curve
							iNext = 1;
							tNext = t1 + pp[ 1 ] - pp[ 0 ];
	
							break;
	
						default: // ZeroCurvatureEnding
	
							// f''(tN) = 0, a.k.a. Natural Spline
							iNext = i1 - 1;
							tNext = t0;
	
					}
	
				}
	
				var halfDt = ( t1 - t0 ) * 0.5,
					stride = this.valueSize;
	
				this._weightPrev = halfDt / ( t0 - tPrev );
				this._weightNext = halfDt / ( tNext - t1 );
				this._offsetPrev = iPrev * stride;
				this._offsetNext = iNext * stride;
	
			},
	
			interpolate_: function ( i1, t0, t, t1 ) {
	
				var result = this.resultBuffer,
					values = this.sampleValues,
					stride = this.valueSize,
	
					o1 = i1 * stride,		o0 = o1 - stride,
					oP = this._offsetPrev, 	oN = this._offsetNext,
					wP = this._weightPrev,	wN = this._weightNext,
	
					p = ( t - t0 ) / ( t1 - t0 ),
					pp = p * p,
					ppp = pp * p;
	
				// evaluate polynomials
	
				var sP = - wP * ppp + 2 * wP * pp - wP * p;
				var s0 = ( 1 + wP ) * ppp + ( - 1.5 - 2 * wP ) * pp + ( - 0.5 + wP ) * p + 1;
				var s1 = ( - 1 - wN ) * ppp + ( 1.5 + wN ) * pp + 0.5 * p;
				var sN = wN * ppp - wN * pp;
	
				// combine data linearly
	
				for ( var i = 0; i !== stride; ++ i ) {
	
					result[ i ] =
							sP * values[ oP + i ] +
							s0 * values[ o0 + i ] +
							s1 * values[ o1 + i ] +
							sN * values[ oN + i ];
	
				}
	
				return result;
	
			}
	
		} );
	
		/**
		 * @author tschw
		 */
	
		function LinearInterpolant( parameterPositions, sampleValues, sampleSize, resultBuffer ) {
	
			Interpolant.call( this, parameterPositions, sampleValues, sampleSize, resultBuffer );
	
		}
	
		LinearInterpolant.prototype = Object.assign( Object.create( Interpolant.prototype ), {
	
			constructor: LinearInterpolant,
	
			interpolate_: function ( i1, t0, t, t1 ) {
	
				var result = this.resultBuffer,
					values = this.sampleValues,
					stride = this.valueSize,
	
					offset1 = i1 * stride,
					offset0 = offset1 - stride,
	
					weight1 = ( t - t0 ) / ( t1 - t0 ),
					weight0 = 1 - weight1;
	
				for ( var i = 0; i !== stride; ++ i ) {
	
					result[ i ] =
							values[ offset0 + i ] * weight0 +
							values[ offset1 + i ] * weight1;
	
				}
	
				return result;
	
			}
	
		} );
	
		/**
		 *
		 * Interpolant that evaluates to the sample value at the position preceeding
		 * the parameter.
		 *
		 * @author tschw
		 */
	
		function DiscreteInterpolant( parameterPositions, sampleValues, sampleSize, resultBuffer ) {
	
			Interpolant.call( this, parameterPositions, sampleValues, sampleSize, resultBuffer );
	
		}
	
		DiscreteInterpolant.prototype = Object.assign( Object.create( Interpolant.prototype ), {
	
			constructor: DiscreteInterpolant,
	
			interpolate_: function ( i1 /*, t0, t, t1 */ ) {
	
				return this.copySampleValue_( i1 - 1 );
	
			}
	
		} );
	
		/**
		 * @author tschw
		 * @author Ben Houston / http://clara.io/
		 * @author David Sarno / http://lighthaus.us/
		 */
	
		var AnimationUtils = {
	
			// same as Array.prototype.slice, but also works on typed arrays
			arraySlice: function ( array, from, to ) {
	
				if ( AnimationUtils.isTypedArray( array ) ) {
	
					// in ios9 array.subarray(from, undefined) will return empty array
					// but array.subarray(from) or array.subarray(from, len) is correct
					return new array.constructor( array.subarray( from, to !== undefined ? to : array.length ) );
	
				}
	
				return array.slice( from, to );
	
			},
	
			// converts an array to a specific type
			convertArray: function ( array, type, forceClone ) {
	
				if ( ! array || // let 'undefined' and 'null' pass
						! forceClone && array.constructor === type ) return array;
	
				if ( typeof type.BYTES_PER_ELEMENT === 'number' ) {
	
					return new type( array ); // create typed array
	
				}
	
				return Array.prototype.slice.call( array ); // create Array
	
			},
	
			isTypedArray: function ( object ) {
	
				return ArrayBuffer.isView( object ) &&
						! ( object instanceof DataView );
	
			},
	
			// returns an array by which times and values can be sorted
			getKeyframeOrder: function ( times ) {
	
				function compareTime( i, j ) {
	
					return times[ i ] - times[ j ];
	
				}
	
				var n = times.length;
				var result = new Array( n );
				for ( var i = 0; i !== n; ++ i ) result[ i ] = i;
	
				result.sort( compareTime );
	
				return result;
	
			},
	
			// uses the array previously returned by 'getKeyframeOrder' to sort data
			sortedArray: function ( values, stride, order ) {
	
				var nValues = values.length;
				var result = new values.constructor( nValues );
	
				for ( var i = 0, dstOffset = 0; dstOffset !== nValues; ++ i ) {
	
					var srcOffset = order[ i ] * stride;
	
					for ( var j = 0; j !== stride; ++ j ) {
	
						result[ dstOffset ++ ] = values[ srcOffset + j ];
	
					}
	
				}
	
				return result;
	
			},
	
			// function for parsing AOS keyframe formats
			flattenJSON: function ( jsonKeys, times, values, valuePropertyName ) {
	
				var i = 1, key = jsonKeys[ 0 ];
	
				while ( key !== undefined && key[ valuePropertyName ] === undefined ) {
	
					key = jsonKeys[ i ++ ];
	
				}
	
				if ( key === undefined ) return; // no data
	
				var value = key[ valuePropertyName ];
				if ( value === undefined ) return; // no data
	
				if ( Array.isArray( value ) ) {
	
					do {
	
						value = key[ valuePropertyName ];
	
						if ( value !== undefined ) {
	
							times.push( key.time );
							values.push.apply( values, value ); // push all elements
	
						}
	
						key = jsonKeys[ i ++ ];
	
					} while ( key !== undefined );
	
				} else if ( value.toArray !== undefined ) {
	
					// ...assume THREE.Math-ish
	
					do {
	
						value = key[ valuePropertyName ];
	
						if ( value !== undefined ) {
	
							times.push( key.time );
							value.toArray( values, values.length );
	
						}
	
						key = jsonKeys[ i ++ ];
	
					} while ( key !== undefined );
	
				} else {
	
					// otherwise push as-is
	
					do {
	
						value = key[ valuePropertyName ];
	
						if ( value !== undefined ) {
	
							times.push( key.time );
							values.push( value );
	
						}
	
						key = jsonKeys[ i ++ ];
	
					} while ( key !== undefined );
	
				}
	
			}
	
		};
	
		/**
		 *
		 * A timed sequence of keyframes for a specific property.
		 *
		 *
		 * @author Ben Houston / http://clara.io/
		 * @author David Sarno / http://lighthaus.us/
		 * @author tschw
		 */
	
		function KeyframeTrack( name, times, values, interpolation ) {
	
			if ( name === undefined ) throw new Error( 'THREE.KeyframeTrack: track name is undefined' );
			if ( times === undefined || times.length === 0 ) throw new Error( 'THREE.KeyframeTrack: no keyframes in track named ' + name );
	
			this.name = name;
	
			this.times = AnimationUtils.convertArray( times, this.TimeBufferType );
			this.values = AnimationUtils.convertArray( values, this.ValueBufferType );
	
			this.setInterpolation( interpolation || this.DefaultInterpolation );
	
			this.validate();
			this.optimize();
	
		}
	
		// Static methods:
	
		Object.assign( KeyframeTrack, {
	
			// Serialization (in static context, because of constructor invocation
			// and automatic invocation of .toJSON):
	
			parse: function ( json ) {
	
				if ( json.type === undefined ) {
	
					throw new Error( 'THREE.KeyframeTrack: track type undefined, can not parse' );
	
				}
	
				var trackType = KeyframeTrack._getTrackTypeForValueTypeName( json.type );
	
				if ( json.times === undefined ) {
	
					var times = [], values = [];
	
					AnimationUtils.flattenJSON( json.keys, times, values, 'value' );
	
					json.times = times;
					json.values = values;
	
				}
	
				// derived classes can define a static parse method
				if ( trackType.parse !== undefined ) {
	
					return trackType.parse( json );
	
				} else {
	
					// by default, we assume a constructor compatible with the base
					return new trackType( json.name, json.times, json.values, json.interpolation );
	
				}
	
			},
	
			toJSON: function ( track ) {
	
				var trackType = track.constructor;
	
				var json;
	
				// derived classes can define a static toJSON method
				if ( trackType.toJSON !== undefined ) {
	
					json = trackType.toJSON( track );
	
				} else {
	
					// by default, we assume the data can be serialized as-is
					json = {
	
						'name': track.name,
						'times': AnimationUtils.convertArray( track.times, Array ),
						'values': AnimationUtils.convertArray( track.values, Array )
	
					};
	
					var interpolation = track.getInterpolation();
	
					if ( interpolation !== track.DefaultInterpolation ) {
	
						json.interpolation = interpolation;
	
					}
	
				}
	
				json.type = track.ValueTypeName; // mandatory
	
				return json;
	
			},
	
			_getTrackTypeForValueTypeName: function ( typeName ) {
	
				switch ( typeName.toLowerCase() ) {
	
					case 'scalar':
					case 'double':
					case 'float':
					case 'number':
					case 'integer':
	
						return NumberKeyframeTrack;
	
					case 'vector':
					case 'vector2':
					case 'vector3':
					case 'vector4':
	
						return VectorKeyframeTrack;
	
					case 'color':
	
						return ColorKeyframeTrack;
	
					case 'quaternion':
	
						return QuaternionKeyframeTrack;
	
					case 'bool':
					case 'boolean':
	
						return BooleanKeyframeTrack;
	
					case 'string':
	
						return StringKeyframeTrack;
	
				}
	
				throw new Error( 'THREE.KeyframeTrack: Unsupported typeName: ' + typeName );
	
			}
	
		} );
	
		Object.assign( KeyframeTrack.prototype, {
	
			constructor: KeyframeTrack,
	
			TimeBufferType: Float32Array,
	
			ValueBufferType: Float32Array,
	
			DefaultInterpolation: InterpolateLinear,
	
			InterpolantFactoryMethodDiscrete: function ( result ) {
	
				return new DiscreteInterpolant( this.times, this.values, this.getValueSize(), result );
	
			},
	
			InterpolantFactoryMethodLinear: function ( result ) {
	
				return new LinearInterpolant( this.times, this.values, this.getValueSize(), result );
	
			},
	
			InterpolantFactoryMethodSmooth: function ( result ) {
	
				return new CubicInterpolant( this.times, this.values, this.getValueSize(), result );
	
			},
	
			setInterpolation: function ( interpolation ) {
	
				var factoryMethod;
	
				switch ( interpolation ) {
	
					case InterpolateDiscrete:
	
						factoryMethod = this.InterpolantFactoryMethodDiscrete;
	
						break;
	
					case InterpolateLinear:
	
						factoryMethod = this.InterpolantFactoryMethodLinear;
	
						break;
	
					case InterpolateSmooth:
	
						factoryMethod = this.InterpolantFactoryMethodSmooth;
	
						break;
	
				}
	
				if ( factoryMethod === undefined ) {
	
					var message = "unsupported interpolation for " +
						this.ValueTypeName + " keyframe track named " + this.name;
	
					if ( this.createInterpolant === undefined ) {
	
						// fall back to default, unless the default itself is messed up
						if ( interpolation !== this.DefaultInterpolation ) {
	
							this.setInterpolation( this.DefaultInterpolation );
	
						} else {
	
							throw new Error( message ); // fatal, in this case
	
						}
	
					}
	
					console.warn( 'THREE.KeyframeTrack:', message );
					return;
	
				}
	
				this.createInterpolant = factoryMethod;
	
			},
	
			getInterpolation: function () {
	
				switch ( this.createInterpolant ) {
	
					case this.InterpolantFactoryMethodDiscrete:
	
						return InterpolateDiscrete;
	
					case this.InterpolantFactoryMethodLinear:
	
						return InterpolateLinear;
	
					case this.InterpolantFactoryMethodSmooth:
	
						return InterpolateSmooth;
	
				}
	
			},
	
			getValueSize: function () {
	
				return this.values.length / this.times.length;
	
			},
	
			// move all keyframes either forwards or backwards in time
			shift: function ( timeOffset ) {
	
				if ( timeOffset !== 0.0 ) {
	
					var times = this.times;
	
					for ( var i = 0, n = times.length; i !== n; ++ i ) {
	
						times[ i ] += timeOffset;
	
					}
	
				}
	
				return this;
	
			},
	
			// scale all keyframe times by a factor (useful for frame <-> seconds conversions)
			scale: function ( timeScale ) {
	
				if ( timeScale !== 1.0 ) {
	
					var times = this.times;
	
					for ( var i = 0, n = times.length; i !== n; ++ i ) {
	
						times[ i ] *= timeScale;
	
					}
	
				}
	
				return this;
	
			},
	
			// removes keyframes before and after animation without changing any values within the range [startTime, endTime].
			// IMPORTANT: We do not shift around keys to the start of the track time, because for interpolated keys this will change their values
			trim: function ( startTime, endTime ) {
	
				var times = this.times,
					nKeys = times.length,
					from = 0,
					to = nKeys - 1;
	
				while ( from !== nKeys && times[ from ] < startTime ) {
	
					++ from;
	
				}
	
				while ( to !== - 1 && times[ to ] > endTime ) {
	
					-- to;
	
				}
	
				++ to; // inclusive -> exclusive bound
	
				if ( from !== 0 || to !== nKeys ) {
	
					// empty tracks are forbidden, so keep at least one keyframe
					if ( from >= to ) to = Math.max( to, 1 ), from = to - 1;
	
					var stride = this.getValueSize();
					this.times = AnimationUtils.arraySlice( times, from, to );
					this.values = AnimationUtils.arraySlice( this.values, from * stride, to * stride );
	
				}
	
				return this;
	
			},
	
			// ensure we do not get a GarbageInGarbageOut situation, make sure tracks are at least minimally viable
			validate: function () {
	
				var valid = true;
	
				var valueSize = this.getValueSize();
				if ( valueSize - Math.floor( valueSize ) !== 0 ) {
	
					console.error( 'THREE.KeyframeTrack: Invalid value size in track.', this );
					valid = false;
	
				}
	
				var times = this.times,
					values = this.values,
	
					nKeys = times.length;
	
				if ( nKeys === 0 ) {
	
					console.error( 'THREE.KeyframeTrack: Track is empty.', this );
					valid = false;
	
				}
	
				var prevTime = null;
	
				for ( var i = 0; i !== nKeys; i ++ ) {
	
					var currTime = times[ i ];
	
					if ( typeof currTime === 'number' && isNaN( currTime ) ) {
	
						console.error( 'THREE.KeyframeTrack: Time is not a valid number.', this, i, currTime );
						valid = false;
						break;
	
					}
	
					if ( prevTime !== null && prevTime > currTime ) {
	
						console.error( 'THREE.KeyframeTrack: Out of order keys.', this, i, currTime, prevTime );
						valid = false;
						break;
	
					}
	
					prevTime = currTime;
	
				}
	
				if ( values !== undefined ) {
	
					if ( AnimationUtils.isTypedArray( values ) ) {
	
						for ( var i = 0, n = values.length; i !== n; ++ i ) {
	
							var value = values[ i ];
	
							if ( isNaN( value ) ) {
	
								console.error( 'THREE.KeyframeTrack: Value is not a valid number.', this, i, value );
								valid = false;
								break;
	
							}
	
						}
	
					}
	
				}
	
				return valid;
	
			},
	
			// removes equivalent sequential keys as common in morph target sequences
			// (0,0,0,0,1,1,1,0,0,0,0,0,0,0) --> (0,0,1,1,0,0)
			optimize: function () {
	
				var times = this.times,
					values = this.values,
					stride = this.getValueSize(),
	
					smoothInterpolation = this.getInterpolation() === InterpolateSmooth,
	
					writeIndex = 1,
					lastIndex = times.length - 1;
	
				for ( var i = 1; i < lastIndex; ++ i ) {
	
					var keep = false;
	
					var time = times[ i ];
					var timeNext = times[ i + 1 ];
	
					// remove adjacent keyframes scheduled at the same time
	
					if ( time !== timeNext && ( i !== 1 || time !== time[ 0 ] ) ) {
	
						if ( ! smoothInterpolation ) {
	
							// remove unnecessary keyframes same as their neighbors
	
							var offset = i * stride,
								offsetP = offset - stride,
								offsetN = offset + stride;
	
							for ( var j = 0; j !== stride; ++ j ) {
	
								var value = values[ offset + j ];
	
								if ( value !== values[ offsetP + j ] ||
									value !== values[ offsetN + j ] ) {
	
									keep = true;
									break;
	
								}
	
							}
	
						} else {
	
							keep = true;
	
						}
	
					}
	
					// in-place compaction
	
					if ( keep ) {
	
						if ( i !== writeIndex ) {
	
							times[ writeIndex ] = times[ i ];
	
							var readOffset = i * stride,
								writeOffset = writeIndex * stride;
	
							for ( var j = 0; j !== stride; ++ j ) {
	
								values[ writeOffset + j ] = values[ readOffset + j ];
	
							}
	
						}
	
						++ writeIndex;
	
					}
	
				}
	
				// flush last keyframe (compaction looks ahead)
	
				if ( lastIndex > 0 ) {
	
					times[ writeIndex ] = times[ lastIndex ];
	
					for ( var readOffset = lastIndex * stride, writeOffset = writeIndex * stride, j = 0; j !== stride; ++ j ) {
	
						values[ writeOffset + j ] = values[ readOffset + j ];
	
					}
	
					++ writeIndex;
	
				}
	
				if ( writeIndex !== times.length ) {
	
					this.times = AnimationUtils.arraySlice( times, 0, writeIndex );
					this.values = AnimationUtils.arraySlice( values, 0, writeIndex * stride );
	
				}
	
				return this;
	
			}
	
		} );
	
		/**
		 *
		 * A Track of vectored keyframe values.
		 *
		 *
		 * @author Ben Houston / http://clara.io/
		 * @author David Sarno / http://lighthaus.us/
		 * @author tschw
		 */
	
		function VectorKeyframeTrack( name, times, values, interpolation ) {
	
			KeyframeTrack.call( this, name, times, values, interpolation );
	
		}
	
		VectorKeyframeTrack.prototype = Object.assign( Object.create( KeyframeTrack.prototype ), {
	
			constructor: VectorKeyframeTrack,
	
			ValueTypeName: 'vector'
	
			// ValueBufferType is inherited
	
			// DefaultInterpolation is inherited
	
		} );
	
		/**
		 *
		 * Reusable set of Tracks that represent an animation.
		 *
		 * @author Ben Houston / http://clara.io/
		 * @author David Sarno / http://lighthaus.us/
		 */
	
		function AnimationClip( name, duration, tracks ) {
	
			this.name = name;
			this.tracks = tracks;
			this.duration = ( duration !== undefined ) ? duration : - 1;
	
			this.uuid = _Math.generateUUID();
	
			// this means it should figure out its duration by scanning the tracks
			if ( this.duration < 0 ) {
	
				this.resetDuration();
	
			}
	
			this.optimize();
	
		}
	
		Object.assign( AnimationClip, {
	
			parse: function ( json ) {
	
				var tracks = [],
					jsonTracks = json.tracks,
					frameTime = 1.0 / ( json.fps || 1.0 );
	
				for ( var i = 0, n = jsonTracks.length; i !== n; ++ i ) {
	
					tracks.push( KeyframeTrack.parse( jsonTracks[ i ] ).scale( frameTime ) );
	
				}
	
				return new AnimationClip( json.name, json.duration, tracks );
	
			},
	
			toJSON: function ( clip ) {
	
				var tracks = [],
					clipTracks = clip.tracks;
	
				var json = {
	
					'name': clip.name,
					'duration': clip.duration,
					'tracks': tracks
	
				};
	
				for ( var i = 0, n = clipTracks.length; i !== n; ++ i ) {
	
					tracks.push( KeyframeTrack.toJSON( clipTracks[ i ] ) );
	
				}
	
				return json;
	
			},
	
			CreateFromMorphTargetSequence: function ( name, morphTargetSequence, fps, noLoop ) {
	
				var numMorphTargets = morphTargetSequence.length;
				var tracks = [];
	
				for ( var i = 0; i < numMorphTargets; i ++ ) {
	
					var times = [];
					var values = [];
	
					times.push(
						( i + numMorphTargets - 1 ) % numMorphTargets,
						i,
						( i + 1 ) % numMorphTargets );
	
					values.push( 0, 1, 0 );
	
					var order = AnimationUtils.getKeyframeOrder( times );
					times = AnimationUtils.sortedArray( times, 1, order );
					values = AnimationUtils.sortedArray( values, 1, order );
	
					// if there is a key at the first frame, duplicate it as the
					// last frame as well for perfect loop.
					if ( ! noLoop && times[ 0 ] === 0 ) {
	
						times.push( numMorphTargets );
						values.push( values[ 0 ] );
	
					}
	
					tracks.push(
						new NumberKeyframeTrack(
							'.morphTargetInfluences[' + morphTargetSequence[ i ].name + ']',
							times, values
						).scale( 1.0 / fps ) );
	
				}
	
				return new AnimationClip( name, - 1, tracks );
	
			},
	
			findByName: function ( objectOrClipArray, name ) {
	
				var clipArray = objectOrClipArray;
	
				if ( ! Array.isArray( objectOrClipArray ) ) {
	
					var o = objectOrClipArray;
					clipArray = o.geometry && o.geometry.animations || o.animations;
	
				}
	
				for ( var i = 0; i < clipArray.length; i ++ ) {
	
					if ( clipArray[ i ].name === name ) {
	
						return clipArray[ i ];
	
					}
	
				}
	
				return null;
	
			},
	
			CreateClipsFromMorphTargetSequences: function ( morphTargets, fps, noLoop ) {
	
				var animationToMorphTargets = {};
	
				// tested with https://regex101.com/ on trick sequences
				// such flamingo_flyA_003, flamingo_run1_003, crdeath0059
				var pattern = /^([\w-]*?)([\d]+)$/;
	
				// sort morph target names into animation groups based
				// patterns like Walk_001, Walk_002, Run_001, Run_002
				for ( var i = 0, il = morphTargets.length; i < il; i ++ ) {
	
					var morphTarget = morphTargets[ i ];
					var parts = morphTarget.name.match( pattern );
	
					if ( parts && parts.length > 1 ) {
	
						var name = parts[ 1 ];
	
						var animationMorphTargets = animationToMorphTargets[ name ];
						if ( ! animationMorphTargets ) {
	
							animationToMorphTargets[ name ] = animationMorphTargets = [];
	
						}
	
						animationMorphTargets.push( morphTarget );
	
					}
	
				}
	
				var clips = [];
	
				for ( var name in animationToMorphTargets ) {
	
					clips.push( AnimationClip.CreateFromMorphTargetSequence( name, animationToMorphTargets[ name ], fps, noLoop ) );
	
				}
	
				return clips;
	
			},
	
			// parse the animation.hierarchy format
			parseAnimation: function ( animation, bones ) {
	
				if ( ! animation ) {
	
					console.error( 'THREE.AnimationClip: No animation in JSONLoader data.' );
					return null;
	
				}
	
				var addNonemptyTrack = function ( trackType, trackName, animationKeys, propertyName, destTracks ) {
	
					// only return track if there are actually keys.
					if ( animationKeys.length !== 0 ) {
	
						var times = [];
						var values = [];
	
						AnimationUtils.flattenJSON( animationKeys, times, values, propertyName );
	
						// empty keys are filtered out, so check again
						if ( times.length !== 0 ) {
	
							destTracks.push( new trackType( trackName, times, values ) );
	
						}
	
					}
	
				};
	
				var tracks = [];
	
				var clipName = animation.name || 'default';
				// automatic length determination in AnimationClip.
				var duration = animation.length || - 1;
				var fps = animation.fps || 30;
	
				var hierarchyTracks = animation.hierarchy || [];
	
				for ( var h = 0; h < hierarchyTracks.length; h ++ ) {
	
					var animationKeys = hierarchyTracks[ h ].keys;
	
					// skip empty tracks
					if ( ! animationKeys || animationKeys.length === 0 ) continue;
	
					// process morph targets
					if ( animationKeys[ 0 ].morphTargets ) {
	
						// figure out all morph targets used in this track
						var morphTargetNames = {};
	
						for ( var k = 0; k < animationKeys.length; k ++ ) {
	
							if ( animationKeys[ k ].morphTargets ) {
	
								for ( var m = 0; m < animationKeys[ k ].morphTargets.length; m ++ ) {
	
									morphTargetNames[ animationKeys[ k ].morphTargets[ m ] ] = - 1;
	
								}
	
							}
	
						}
	
						// create a track for each morph target with all zero
						// morphTargetInfluences except for the keys in which
						// the morphTarget is named.
						for ( var morphTargetName in morphTargetNames ) {
	
							var times = [];
							var values = [];
	
							for ( var m = 0; m !== animationKeys[ k ].morphTargets.length; ++ m ) {
	
								var animationKey = animationKeys[ k ];
	
								times.push( animationKey.time );
								values.push( ( animationKey.morphTarget === morphTargetName ) ? 1 : 0 );
	
							}
	
							tracks.push( new NumberKeyframeTrack( '.morphTargetInfluence[' + morphTargetName + ']', times, values ) );
	
						}
	
						duration = morphTargetNames.length * ( fps || 1.0 );
	
					} else {
	
						// ...assume skeletal animation
	
						var boneName = '.bones[' + bones[ h ].name + ']';
	
						addNonemptyTrack(
							VectorKeyframeTrack, boneName + '.position',
							animationKeys, 'pos', tracks );
	
						addNonemptyTrack(
							QuaternionKeyframeTrack, boneName + '.quaternion',
							animationKeys, 'rot', tracks );
	
						addNonemptyTrack(
							VectorKeyframeTrack, boneName + '.scale',
							animationKeys, 'scl', tracks );
	
					}
	
				}
	
				if ( tracks.length === 0 ) {
	
					return null;
	
				}
	
				var clip = new AnimationClip( clipName, duration, tracks );
	
				return clip;
	
			}
	
		} );
	
		Object.assign( AnimationClip.prototype, {
	
			resetDuration: function () {
	
				var tracks = this.tracks, duration = 0;
	
				for ( var i = 0, n = tracks.length; i !== n; ++ i ) {
	
					var track = this.tracks[ i ];
	
					duration = Math.max( duration, track.times[ track.times.length - 1 ] );
	
				}
	
				this.duration = duration;
	
			},
	
			trim: function () {
	
				for ( var i = 0; i < this.tracks.length; i ++ ) {
	
					this.tracks[ i ].trim( 0, this.duration );
	
				}
	
				return this;
	
			},
	
			optimize: function () {
	
				for ( var i = 0; i < this.tracks.length; i ++ ) {
	
					this.tracks[ i ].optimize();
	
				}
	
				return this;
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function MaterialLoader( manager ) {
	
			this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;
			this.textures = {};
	
		}
	
		Object.assign( MaterialLoader.prototype, {
	
			load: function ( url, onLoad, onProgress, onError ) {
	
				var scope = this;
	
				var loader = new FileLoader( scope.manager );
				loader.load( url, function ( text ) {
	
					onLoad( scope.parse( JSON.parse( text ) ) );
	
				}, onProgress, onError );
	
			},
	
			setTextures: function ( value ) {
	
				this.textures = value;
	
			},
	
			parse: function ( json ) {
	
				var textures = this.textures;
	
				function getTexture( name ) {
	
					if ( textures[ name ] === undefined ) {
	
						console.warn( 'THREE.MaterialLoader: Undefined texture', name );
	
					}
	
					return textures[ name ];
	
				}
	
				var material = new Materials[ json.type ]();
	
				if ( json.uuid !== undefined ) material.uuid = json.uuid;
				if ( json.name !== undefined ) material.name = json.name;
				if ( json.color !== undefined ) material.color.setHex( json.color );
				if ( json.roughness !== undefined ) material.roughness = json.roughness;
				if ( json.metalness !== undefined ) material.metalness = json.metalness;
				if ( json.emissive !== undefined ) material.emissive.setHex( json.emissive );
				if ( json.specular !== undefined ) material.specular.setHex( json.specular );
				if ( json.shininess !== undefined ) material.shininess = json.shininess;
				if ( json.clearCoat !== undefined ) material.clearCoat = json.clearCoat;
				if ( json.clearCoatRoughness !== undefined ) material.clearCoatRoughness = json.clearCoatRoughness;
				if ( json.uniforms !== undefined ) material.uniforms = json.uniforms;
				if ( json.vertexShader !== undefined ) material.vertexShader = json.vertexShader;
				if ( json.fragmentShader !== undefined ) material.fragmentShader = json.fragmentShader;
				if ( json.vertexColors !== undefined ) material.vertexColors = json.vertexColors;
				if ( json.fog !== undefined ) material.fog = json.fog;
				if ( json.flatShading !== undefined ) material.flatShading = json.flatShading;
				if ( json.blending !== undefined ) material.blending = json.blending;
				if ( json.side !== undefined ) material.side = json.side;
				if ( json.opacity !== undefined ) material.opacity = json.opacity;
				if ( json.transparent !== undefined ) material.transparent = json.transparent;
				if ( json.alphaTest !== undefined ) material.alphaTest = json.alphaTest;
				if ( json.depthTest !== undefined ) material.depthTest = json.depthTest;
				if ( json.depthWrite !== undefined ) material.depthWrite = json.depthWrite;
				if ( json.colorWrite !== undefined ) material.colorWrite = json.colorWrite;
				if ( json.wireframe !== undefined ) material.wireframe = json.wireframe;
				if ( json.wireframeLinewidth !== undefined ) material.wireframeLinewidth = json.wireframeLinewidth;
				if ( json.wireframeLinecap !== undefined ) material.wireframeLinecap = json.wireframeLinecap;
				if ( json.wireframeLinejoin !== undefined ) material.wireframeLinejoin = json.wireframeLinejoin;
	
				if ( json.rotation !== undefined ) material.rotation = json.rotation;
	
				if ( json.linewidth !== 1 ) material.linewidth = json.linewidth;
				if ( json.dashSize !== undefined ) material.dashSize = json.dashSize;
				if ( json.gapSize !== undefined ) material.gapSize = json.gapSize;
				if ( json.scale !== undefined ) material.scale = json.scale;
	
				if ( json.skinning !== undefined ) material.skinning = json.skinning;
				if ( json.morphTargets !== undefined ) material.morphTargets = json.morphTargets;
				if ( json.dithering !== undefined ) material.dithering = json.dithering;
	
				if ( json.visible !== undefined ) material.visible = json.visible;
				if ( json.userData !== undefined ) material.userData = json.userData;
	
				// Deprecated
	
				if ( json.shading !== undefined ) material.flatShading = json.shading === 1; // THREE.FlatShading
	
				// for PointsMaterial
	
				if ( json.size !== undefined ) material.size = json.size;
				if ( json.sizeAttenuation !== undefined ) material.sizeAttenuation = json.sizeAttenuation;
	
				// maps
	
				if ( json.map !== undefined ) material.map = getTexture( json.map );
	
				if ( json.alphaMap !== undefined ) {
	
					material.alphaMap = getTexture( json.alphaMap );
					material.transparent = true;
	
				}
	
				if ( json.bumpMap !== undefined ) material.bumpMap = getTexture( json.bumpMap );
				if ( json.bumpScale !== undefined ) material.bumpScale = json.bumpScale;
	
				if ( json.normalMap !== undefined ) material.normalMap = getTexture( json.normalMap );
				if ( json.normalScale !== undefined ) {
	
					var normalScale = json.normalScale;
	
					if ( Array.isArray( normalScale ) === false ) {
	
						// Blender exporter used to export a scalar. See #7459
	
						normalScale = [ normalScale, normalScale ];
	
					}
	
					material.normalScale = new Vector2().fromArray( normalScale );
	
				}
	
				if ( json.displacementMap !== undefined ) material.displacementMap = getTexture( json.displacementMap );
				if ( json.displacementScale !== undefined ) material.displacementScale = json.displacementScale;
				if ( json.displacementBias !== undefined ) material.displacementBias = json.displacementBias;
	
				if ( json.roughnessMap !== undefined ) material.roughnessMap = getTexture( json.roughnessMap );
				if ( json.metalnessMap !== undefined ) material.metalnessMap = getTexture( json.metalnessMap );
	
				if ( json.emissiveMap !== undefined ) material.emissiveMap = getTexture( json.emissiveMap );
				if ( json.emissiveIntensity !== undefined ) material.emissiveIntensity = json.emissiveIntensity;
	
				if ( json.specularMap !== undefined ) material.specularMap = getTexture( json.specularMap );
	
				if ( json.envMap !== undefined ) material.envMap = getTexture( json.envMap );
	
				if ( json.reflectivity !== undefined ) material.reflectivity = json.reflectivity;
	
				if ( json.lightMap !== undefined ) material.lightMap = getTexture( json.lightMap );
				if ( json.lightMapIntensity !== undefined ) material.lightMapIntensity = json.lightMapIntensity;
	
				if ( json.aoMap !== undefined ) material.aoMap = getTexture( json.aoMap );
				if ( json.aoMapIntensity !== undefined ) material.aoMapIntensity = json.aoMapIntensity;
	
				if ( json.gradientMap !== undefined ) material.gradientMap = getTexture( json.gradientMap );
	
				return material;
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function BufferGeometryLoader( manager ) {
	
			this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;
	
		}
	
		Object.assign( BufferGeometryLoader.prototype, {
	
			load: function ( url, onLoad, onProgress, onError ) {
	
				var scope = this;
	
				var loader = new FileLoader( scope.manager );
				loader.load( url, function ( text ) {
	
					onLoad( scope.parse( JSON.parse( text ) ) );
	
				}, onProgress, onError );
	
			},
	
			parse: function ( json ) {
	
				var geometry = new BufferGeometry();
	
				var index = json.data.index;
	
				if ( index !== undefined ) {
	
					var typedArray = new TYPED_ARRAYS[ index.type ]( index.array );
					geometry.setIndex( new BufferAttribute( typedArray, 1 ) );
	
				}
	
				var attributes = json.data.attributes;
	
				for ( var key in attributes ) {
	
					var attribute = attributes[ key ];
					var typedArray = new TYPED_ARRAYS[ attribute.type ]( attribute.array );
	
					geometry.addAttribute( key, new BufferAttribute( typedArray, attribute.itemSize, attribute.normalized ) );
	
				}
	
				var groups = json.data.groups || json.data.drawcalls || json.data.offsets;
	
				if ( groups !== undefined ) {
	
					for ( var i = 0, n = groups.length; i !== n; ++ i ) {
	
						var group = groups[ i ];
	
						geometry.addGroup( group.start, group.count, group.materialIndex );
	
					}
	
				}
	
				var boundingSphere = json.data.boundingSphere;
	
				if ( boundingSphere !== undefined ) {
	
					var center = new Vector3();
	
					if ( boundingSphere.center !== undefined ) {
	
						center.fromArray( boundingSphere.center );
	
					}
	
					geometry.boundingSphere = new Sphere( center, boundingSphere.radius );
	
				}
	
				return geometry;
	
			}
	
		} );
	
		var TYPED_ARRAYS = {
			Int8Array: Int8Array,
			Uint8Array: Uint8Array,
			// Workaround for IE11 pre KB2929437. See #11440
			Uint8ClampedArray: typeof Uint8ClampedArray !== 'undefined' ? Uint8ClampedArray : Uint8Array,
			Int16Array: Int16Array,
			Uint16Array: Uint16Array,
			Int32Array: Int32Array,
			Uint32Array: Uint32Array,
			Float32Array: Float32Array,
			Float64Array: Float64Array
		};
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 */
	
		function Loader() {
	
			this.onLoadStart = function () {};
			this.onLoadProgress = function () {};
			this.onLoadComplete = function () {};
	
		}
	
		Loader.Handlers = {
	
			handlers: [],
	
			add: function ( regex, loader ) {
	
				this.handlers.push( regex, loader );
	
			},
	
			get: function ( file ) {
	
				var handlers = this.handlers;
	
				for ( var i = 0, l = handlers.length; i < l; i += 2 ) {
	
					var regex = handlers[ i ];
					var loader = handlers[ i + 1 ];
	
					if ( regex.test( file ) ) {
	
						return loader;
	
					}
	
				}
	
				return null;
	
			}
	
		};
	
		Object.assign( Loader.prototype, {
	
			crossOrigin: undefined,
	
			initMaterials: function ( materials, texturePath, crossOrigin ) {
	
				var array = [];
	
				for ( var i = 0; i < materials.length; ++ i ) {
	
					array[ i ] = this.createMaterial( materials[ i ], texturePath, crossOrigin );
	
				}
	
				return array;
	
			},
	
			createMaterial: ( function () {
	
				var BlendingMode = {
					NoBlending: NoBlending,
					NormalBlending: NormalBlending,
					AdditiveBlending: AdditiveBlending,
					SubtractiveBlending: SubtractiveBlending,
					MultiplyBlending: MultiplyBlending,
					CustomBlending: CustomBlending
				};
	
				var color = new Color();
				var textureLoader = new TextureLoader();
				var materialLoader = new MaterialLoader();
	
				return function createMaterial( m, texturePath, crossOrigin ) {
	
					// convert from old material format
	
					var textures = {};
	
					function loadTexture( path, repeat, offset, wrap, anisotropy ) {
	
						var fullPath = texturePath + path;
						var loader = Loader.Handlers.get( fullPath );
	
						var texture;
	
						if ( loader !== null ) {
	
							texture = loader.load( fullPath );
	
						} else {
	
							textureLoader.setCrossOrigin( crossOrigin );
							texture = textureLoader.load( fullPath );
	
						}
	
						if ( repeat !== undefined ) {
	
							texture.repeat.fromArray( repeat );
	
							if ( repeat[ 0 ] !== 1 ) texture.wrapS = RepeatWrapping;
							if ( repeat[ 1 ] !== 1 ) texture.wrapT = RepeatWrapping;
	
						}
	
						if ( offset !== undefined ) {
	
							texture.offset.fromArray( offset );
	
						}
	
						if ( wrap !== undefined ) {
	
							if ( wrap[ 0 ] === 'repeat' ) texture.wrapS = RepeatWrapping;
							if ( wrap[ 0 ] === 'mirror' ) texture.wrapS = MirroredRepeatWrapping;
	
							if ( wrap[ 1 ] === 'repeat' ) texture.wrapT = RepeatWrapping;
							if ( wrap[ 1 ] === 'mirror' ) texture.wrapT = MirroredRepeatWrapping;
	
						}
	
						if ( anisotropy !== undefined ) {
	
							texture.anisotropy = anisotropy;
	
						}
	
						var uuid = _Math.generateUUID();
	
						textures[ uuid ] = texture;
	
						return uuid;
	
					}
	
					//
	
					var json = {
						uuid: _Math.generateUUID(),
						type: 'MeshLambertMaterial'
					};
	
					for ( var name in m ) {
	
						var value = m[ name ];
	
						switch ( name ) {
	
							case 'DbgColor':
							case 'DbgIndex':
							case 'opticalDensity':
							case 'illumination':
								break;
							case 'DbgName':
								json.name = value;
								break;
							case 'blending':
								json.blending = BlendingMode[ value ];
								break;
							case 'colorAmbient':
							case 'mapAmbient':
								console.warn( 'THREE.Loader.createMaterial:', name, 'is no longer supported.' );
								break;
							case 'colorDiffuse':
								json.color = color.fromArray( value ).getHex();
								break;
							case 'colorSpecular':
								json.specular = color.fromArray( value ).getHex();
								break;
							case 'colorEmissive':
								json.emissive = color.fromArray( value ).getHex();
								break;
							case 'specularCoef':
								json.shininess = value;
								break;
							case 'shading':
								if ( value.toLowerCase() === 'basic' ) json.type = 'MeshBasicMaterial';
								if ( value.toLowerCase() === 'phong' ) json.type = 'MeshPhongMaterial';
								if ( value.toLowerCase() === 'standard' ) json.type = 'MeshStandardMaterial';
								break;
							case 'mapDiffuse':
								json.map = loadTexture( value, m.mapDiffuseRepeat, m.mapDiffuseOffset, m.mapDiffuseWrap, m.mapDiffuseAnisotropy );
								break;
							case 'mapDiffuseRepeat':
							case 'mapDiffuseOffset':
							case 'mapDiffuseWrap':
							case 'mapDiffuseAnisotropy':
								break;
							case 'mapEmissive':
								json.emissiveMap = loadTexture( value, m.mapEmissiveRepeat, m.mapEmissiveOffset, m.mapEmissiveWrap, m.mapEmissiveAnisotropy );
								break;
							case 'mapEmissiveRepeat':
							case 'mapEmissiveOffset':
							case 'mapEmissiveWrap':
							case 'mapEmissiveAnisotropy':
								break;
							case 'mapLight':
								json.lightMap = loadTexture( value, m.mapLightRepeat, m.mapLightOffset, m.mapLightWrap, m.mapLightAnisotropy );
								break;
							case 'mapLightRepeat':
							case 'mapLightOffset':
							case 'mapLightWrap':
							case 'mapLightAnisotropy':
								break;
							case 'mapAO':
								json.aoMap = loadTexture( value, m.mapAORepeat, m.mapAOOffset, m.mapAOWrap, m.mapAOAnisotropy );
								break;
							case 'mapAORepeat':
							case 'mapAOOffset':
							case 'mapAOWrap':
							case 'mapAOAnisotropy':
								break;
							case 'mapBump':
								json.bumpMap = loadTexture( value, m.mapBumpRepeat, m.mapBumpOffset, m.mapBumpWrap, m.mapBumpAnisotropy );
								break;
							case 'mapBumpScale':
								json.bumpScale = value;
								break;
							case 'mapBumpRepeat':
							case 'mapBumpOffset':
							case 'mapBumpWrap':
							case 'mapBumpAnisotropy':
								break;
							case 'mapNormal':
								json.normalMap = loadTexture( value, m.mapNormalRepeat, m.mapNormalOffset, m.mapNormalWrap, m.mapNormalAnisotropy );
								break;
							case 'mapNormalFactor':
								json.normalScale = [ value, value ];
								break;
							case 'mapNormalRepeat':
							case 'mapNormalOffset':
							case 'mapNormalWrap':
							case 'mapNormalAnisotropy':
								break;
							case 'mapSpecular':
								json.specularMap = loadTexture( value, m.mapSpecularRepeat, m.mapSpecularOffset, m.mapSpecularWrap, m.mapSpecularAnisotropy );
								break;
							case 'mapSpecularRepeat':
							case 'mapSpecularOffset':
							case 'mapSpecularWrap':
							case 'mapSpecularAnisotropy':
								break;
							case 'mapMetalness':
								json.metalnessMap = loadTexture( value, m.mapMetalnessRepeat, m.mapMetalnessOffset, m.mapMetalnessWrap, m.mapMetalnessAnisotropy );
								break;
							case 'mapMetalnessRepeat':
							case 'mapMetalnessOffset':
							case 'mapMetalnessWrap':
							case 'mapMetalnessAnisotropy':
								break;
							case 'mapRoughness':
								json.roughnessMap = loadTexture( value, m.mapRoughnessRepeat, m.mapRoughnessOffset, m.mapRoughnessWrap, m.mapRoughnessAnisotropy );
								break;
							case 'mapRoughnessRepeat':
							case 'mapRoughnessOffset':
							case 'mapRoughnessWrap':
							case 'mapRoughnessAnisotropy':
								break;
							case 'mapAlpha':
								json.alphaMap = loadTexture( value, m.mapAlphaRepeat, m.mapAlphaOffset, m.mapAlphaWrap, m.mapAlphaAnisotropy );
								break;
							case 'mapAlphaRepeat':
							case 'mapAlphaOffset':
							case 'mapAlphaWrap':
							case 'mapAlphaAnisotropy':
								break;
							case 'flipSided':
								json.side = BackSide;
								break;
							case 'doubleSided':
								json.side = DoubleSide;
								break;
							case 'transparency':
								console.warn( 'THREE.Loader.createMaterial: transparency has been renamed to opacity' );
								json.opacity = value;
								break;
							case 'depthTest':
							case 'depthWrite':
							case 'colorWrite':
							case 'opacity':
							case 'reflectivity':
							case 'transparent':
							case 'visible':
							case 'wireframe':
								json[ name ] = value;
								break;
							case 'vertexColors':
								if ( value === true ) json.vertexColors = VertexColors;
								if ( value === 'face' ) json.vertexColors = FaceColors;
								break;
							default:
								console.error( 'THREE.Loader.createMaterial: Unsupported', name, value );
								break;
	
						}
	
					}
	
					if ( json.type === 'MeshBasicMaterial' ) delete json.emissive;
					if ( json.type !== 'MeshPhongMaterial' ) delete json.specular;
	
					if ( json.opacity < 1 ) json.transparent = true;
	
					materialLoader.setTextures( textures );
	
					return materialLoader.parse( json );
	
				};
	
			} )()
	
		} );
	
		/**
		 * @author Don McCurdy / https://www.donmccurdy.com
		 */
	
		var LoaderUtils = {
	
			decodeText: function ( array ) {
	
				if ( typeof TextDecoder !== 'undefined' ) {
	
					return new TextDecoder().decode( array );
	
				}
	
				// Avoid the String.fromCharCode.apply(null, array) shortcut, which
				// throws a "maximum call stack size exceeded" error for large arrays.
	
				var s = '';
	
				for ( var i = 0, il = array.length; i < il; i ++ ) {
	
					// Implicitly assumes little-endian.
					s += String.fromCharCode( array[ i ] );
	
				}
	
				return s;
	
			},
	
			extractUrlBase: function ( url ) {
	
				var parts = url.split( '/' );
	
				if ( parts.length === 1 ) return './';
	
				parts.pop();
	
				return parts.join( '/' ) + '/';
	
			}
	
		};
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author alteredq / http://alteredqualia.com/
		 */
	
		function JSONLoader( manager ) {
	
			if ( typeof manager === 'boolean' ) {
	
				console.warn( 'THREE.JSONLoader: showStatus parameter has been removed from constructor.' );
				manager = undefined;
	
			}
	
			this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;
	
			this.withCredentials = false;
	
		}
	
		Object.assign( JSONLoader.prototype, {
	
			load: function ( url, onLoad, onProgress, onError ) {
	
				var scope = this;
	
				var texturePath = this.texturePath && ( typeof this.texturePath === 'string' ) ? this.texturePath : LoaderUtils.extractUrlBase( url );
	
				var loader = new FileLoader( this.manager );
				loader.setWithCredentials( this.withCredentials );
				loader.load( url, function ( text ) {
	
					var json = JSON.parse( text );
					var metadata = json.metadata;
	
					if ( metadata !== undefined ) {
	
						var type = metadata.type;
	
						if ( type !== undefined ) {
	
							if ( type.toLowerCase() === 'object' ) {
	
								console.error( 'THREE.JSONLoader: ' + url + ' should be loaded with THREE.ObjectLoader instead.' );
								return;
	
							}
	
							if ( type.toLowerCase() === 'scene' ) {
	
								console.error( 'THREE.JSONLoader: ' + url + ' should be loaded with THREE.SceneLoader instead.' );
								return;
	
							}
	
						}
	
					}
	
					var object = scope.parse( json, texturePath );
					onLoad( object.geometry, object.materials );
	
				}, onProgress, onError );
	
			},
	
			setTexturePath: function ( value ) {
	
				this.texturePath = value;
	
			},
	
			parse: ( function () {
	
				function parseModel( json, geometry ) {
	
					function isBitSet( value, position ) {
	
						return value & ( 1 << position );
	
					}
	
					var i, j, fi,
	
						offset, zLength,
	
						colorIndex, normalIndex, uvIndex, materialIndex,
	
						type,
						isQuad,
						hasMaterial,
						hasFaceVertexUv,
						hasFaceNormal, hasFaceVertexNormal,
						hasFaceColor, hasFaceVertexColor,
	
						vertex, face, faceA, faceB, hex, normal,
	
						uvLayer, uv, u, v,
	
						faces = json.faces,
						vertices = json.vertices,
						normals = json.normals,
						colors = json.colors,
	
						scale = json.scale,
	
						nUvLayers = 0;
	
	
					if ( json.uvs !== undefined ) {
	
						// disregard empty arrays
	
						for ( i = 0; i < json.uvs.length; i ++ ) {
	
							if ( json.uvs[ i ].length ) nUvLayers ++;
	
						}
	
						for ( i = 0; i < nUvLayers; i ++ ) {
	
							geometry.faceVertexUvs[ i ] = [];
	
						}
	
					}
	
					offset = 0;
					zLength = vertices.length;
	
					while ( offset < zLength ) {
	
						vertex = new Vector3();
	
						vertex.x = vertices[ offset ++ ] * scale;
						vertex.y = vertices[ offset ++ ] * scale;
						vertex.z = vertices[ offset ++ ] * scale;
	
						geometry.vertices.push( vertex );
	
					}
	
					offset = 0;
					zLength = faces.length;
	
					while ( offset < zLength ) {
	
						type = faces[ offset ++ ];
	
						isQuad = isBitSet( type, 0 );
						hasMaterial = isBitSet( type, 1 );
						hasFaceVertexUv = isBitSet( type, 3 );
						hasFaceNormal = isBitSet( type, 4 );
						hasFaceVertexNormal = isBitSet( type, 5 );
						hasFaceColor = isBitSet( type, 6 );
						hasFaceVertexColor = isBitSet( type, 7 );
	
						// console.log("type", type, "bits", isQuad, hasMaterial, hasFaceVertexUv, hasFaceNormal, hasFaceVertexNormal, hasFaceColor, hasFaceVertexColor);
	
						if ( isQuad ) {
	
							faceA = new Face3();
							faceA.a = faces[ offset ];
							faceA.b = faces[ offset + 1 ];
							faceA.c = faces[ offset + 3 ];
	
							faceB = new Face3();
							faceB.a = faces[ offset + 1 ];
							faceB.b = faces[ offset + 2 ];
							faceB.c = faces[ offset + 3 ];
	
							offset += 4;
	
							if ( hasMaterial ) {
	
								materialIndex = faces[ offset ++ ];
								faceA.materialIndex = materialIndex;
								faceB.materialIndex = materialIndex;
	
							}
	
							// to get face <=> uv index correspondence
	
							fi = geometry.faces.length;
	
							if ( hasFaceVertexUv ) {
	
								for ( i = 0; i < nUvLayers; i ++ ) {
	
									uvLayer = json.uvs[ i ];
	
									geometry.faceVertexUvs[ i ][ fi ] = [];
									geometry.faceVertexUvs[ i ][ fi + 1 ] = [];
	
									for ( j = 0; j < 4; j ++ ) {
	
										uvIndex = faces[ offset ++ ];
	
										u = uvLayer[ uvIndex * 2 ];
										v = uvLayer[ uvIndex * 2 + 1 ];
	
										uv = new Vector2( u, v );
	
										if ( j !== 2 ) geometry.faceVertexUvs[ i ][ fi ].push( uv );
										if ( j !== 0 ) geometry.faceVertexUvs[ i ][ fi + 1 ].push( uv );
	
									}
	
								}
	
							}
	
							if ( hasFaceNormal ) {
	
								normalIndex = faces[ offset ++ ] * 3;
	
								faceA.normal.set(
									normals[ normalIndex ++ ],
									normals[ normalIndex ++ ],
									normals[ normalIndex ]
								);
	
								faceB.normal.copy( faceA.normal );
	
							}
	
							if ( hasFaceVertexNormal ) {
	
								for ( i = 0; i < 4; i ++ ) {
	
									normalIndex = faces[ offset ++ ] * 3;
	
									normal = new Vector3(
										normals[ normalIndex ++ ],
										normals[ normalIndex ++ ],
										normals[ normalIndex ]
									);
	
	
									if ( i !== 2 ) faceA.vertexNormals.push( normal );
									if ( i !== 0 ) faceB.vertexNormals.push( normal );
	
								}
	
							}
	
	
							if ( hasFaceColor ) {
	
								colorIndex = faces[ offset ++ ];
								hex = colors[ colorIndex ];
	
								faceA.color.setHex( hex );
								faceB.color.setHex( hex );
	
							}
	
	
							if ( hasFaceVertexColor ) {
	
								for ( i = 0; i < 4; i ++ ) {
	
									colorIndex = faces[ offset ++ ];
									hex = colors[ colorIndex ];
	
									if ( i !== 2 ) faceA.vertexColors.push( new Color( hex ) );
									if ( i !== 0 ) faceB.vertexColors.push( new Color( hex ) );
	
								}
	
							}
	
							geometry.faces.push( faceA );
							geometry.faces.push( faceB );
	
						} else {
	
							face = new Face3();
							face.a = faces[ offset ++ ];
							face.b = faces[ offset ++ ];
							face.c = faces[ offset ++ ];
	
							if ( hasMaterial ) {
	
								materialIndex = faces[ offset ++ ];
								face.materialIndex = materialIndex;
	
							}
	
							// to get face <=> uv index correspondence
	
							fi = geometry.faces.length;
	
							if ( hasFaceVertexUv ) {
	
								for ( i = 0; i < nUvLayers; i ++ ) {
	
									uvLayer = json.uvs[ i ];
	
									geometry.faceVertexUvs[ i ][ fi ] = [];
	
									for ( j = 0; j < 3; j ++ ) {
	
										uvIndex = faces[ offset ++ ];
	
										u = uvLayer[ uvIndex * 2 ];
										v = uvLayer[ uvIndex * 2 + 1 ];
	
										uv = new Vector2( u, v );
	
										geometry.faceVertexUvs[ i ][ fi ].push( uv );
	
									}
	
								}
	
							}
	
							if ( hasFaceNormal ) {
	
								normalIndex = faces[ offset ++ ] * 3;
	
								face.normal.set(
									normals[ normalIndex ++ ],
									normals[ normalIndex ++ ],
									normals[ normalIndex ]
								);
	
							}
	
							if ( hasFaceVertexNormal ) {
	
								for ( i = 0; i < 3; i ++ ) {
	
									normalIndex = faces[ offset ++ ] * 3;
	
									normal = new Vector3(
										normals[ normalIndex ++ ],
										normals[ normalIndex ++ ],
										normals[ normalIndex ]
									);
	
									face.vertexNormals.push( normal );
	
								}
	
							}
	
	
							if ( hasFaceColor ) {
	
								colorIndex = faces[ offset ++ ];
								face.color.setHex( colors[ colorIndex ] );
	
							}
	
	
							if ( hasFaceVertexColor ) {
	
								for ( i = 0; i < 3; i ++ ) {
	
									colorIndex = faces[ offset ++ ];
									face.vertexColors.push( new Color( colors[ colorIndex ] ) );
	
								}
	
							}
	
							geometry.faces.push( face );
	
						}
	
					}
	
				}
	
				function parseSkin( json, geometry ) {
	
					var influencesPerVertex = ( json.influencesPerVertex !== undefined ) ? json.influencesPerVertex : 2;
	
					if ( json.skinWeights ) {
	
						for ( var i = 0, l = json.skinWeights.length; i < l; i += influencesPerVertex ) {
	
							var x = json.skinWeights[ i ];
							var y = ( influencesPerVertex > 1 ) ? json.skinWeights[ i + 1 ] : 0;
							var z = ( influencesPerVertex > 2 ) ? json.skinWeights[ i + 2 ] : 0;
							var w = ( influencesPerVertex > 3 ) ? json.skinWeights[ i + 3 ] : 0;
	
							geometry.skinWeights.push( new Vector4( x, y, z, w ) );
	
						}
	
					}
	
					if ( json.skinIndices ) {
	
						for ( var i = 0, l = json.skinIndices.length; i < l; i += influencesPerVertex ) {
	
							var a = json.skinIndices[ i ];
							var b = ( influencesPerVertex > 1 ) ? json.skinIndices[ i + 1 ] : 0;
							var c = ( influencesPerVertex > 2 ) ? json.skinIndices[ i + 2 ] : 0;
							var d = ( influencesPerVertex > 3 ) ? json.skinIndices[ i + 3 ] : 0;
	
							geometry.skinIndices.push( new Vector4( a, b, c, d ) );
	
						}
	
					}
	
					geometry.bones = json.bones;
	
					if ( geometry.bones && geometry.bones.length > 0 && ( geometry.skinWeights.length !== geometry.skinIndices.length || geometry.skinIndices.length !== geometry.vertices.length ) ) {
	
						console.warn( 'When skinning, number of vertices (' + geometry.vertices.length + '), skinIndices (' +
							geometry.skinIndices.length + '), and skinWeights (' + geometry.skinWeights.length + ') should match.' );
	
					}
	
				}
	
				function parseMorphing( json, geometry ) {
	
					var scale = json.scale;
	
					if ( json.morphTargets !== undefined ) {
	
						for ( var i = 0, l = json.morphTargets.length; i < l; i ++ ) {
	
							geometry.morphTargets[ i ] = {};
							geometry.morphTargets[ i ].name = json.morphTargets[ i ].name;
							geometry.morphTargets[ i ].vertices = [];
	
							var dstVertices = geometry.morphTargets[ i ].vertices;
							var srcVertices = json.morphTargets[ i ].vertices;
	
							for ( var v = 0, vl = srcVertices.length; v < vl; v += 3 ) {
	
								var vertex = new Vector3();
								vertex.x = srcVertices[ v ] * scale;
								vertex.y = srcVertices[ v + 1 ] * scale;
								vertex.z = srcVertices[ v + 2 ] * scale;
	
								dstVertices.push( vertex );
	
							}
	
						}
	
					}
	
					if ( json.morphColors !== undefined && json.morphColors.length > 0 ) {
	
						console.warn( 'THREE.JSONLoader: "morphColors" no longer supported. Using them as face colors.' );
	
						var faces = geometry.faces;
						var morphColors = json.morphColors[ 0 ].colors;
	
						for ( var i = 0, l = faces.length; i < l; i ++ ) {
	
							faces[ i ].color.fromArray( morphColors, i * 3 );
	
						}
	
					}
	
				}
	
				function parseAnimations( json, geometry ) {
	
					var outputAnimations = [];
	
					// parse old style Bone/Hierarchy animations
					var animations = [];
	
					if ( json.animation !== undefined ) {
	
						animations.push( json.animation );
	
					}
	
					if ( json.animations !== undefined ) {
	
						if ( json.animations.length ) {
	
							animations = animations.concat( json.animations );
	
						} else {
	
							animations.push( json.animations );
	
						}
	
					}
	
					for ( var i = 0; i < animations.length; i ++ ) {
	
						var clip = AnimationClip.parseAnimation( animations[ i ], geometry.bones );
						if ( clip ) outputAnimations.push( clip );
	
					}
	
					// parse implicit morph animations
					if ( geometry.morphTargets ) {
	
						// TODO: Figure out what an appropraite FPS is for morph target animations -- defaulting to 10, but really it is completely arbitrary.
						var morphAnimationClips = AnimationClip.CreateClipsFromMorphTargetSequences( geometry.morphTargets, 10 );
						outputAnimations = outputAnimations.concat( morphAnimationClips );
	
					}
	
					if ( outputAnimations.length > 0 ) geometry.animations = outputAnimations;
	
				}
	
				return function ( json, texturePath ) {
	
					if ( json.data !== undefined ) {
	
						// Geometry 4.0 spec
						json = json.data;
	
					}
	
					if ( json.scale !== undefined ) {
	
						json.scale = 1.0 / json.scale;
	
					} else {
	
						json.scale = 1.0;
	
					}
	
					var geometry = new Geometry();
	
					parseModel( json, geometry );
					parseSkin( json, geometry );
					parseMorphing( json, geometry );
					parseAnimations( json, geometry );
	
					geometry.computeFaceNormals();
					geometry.computeBoundingSphere();
	
					if ( json.materials === undefined || json.materials.length === 0 ) {
	
						return { geometry: geometry };
	
					} else {
	
						var materials = Loader.prototype.initMaterials( json.materials, texturePath, this.crossOrigin );
	
						return { geometry: geometry, materials: materials };
	
					}
	
				};
	
			} )()
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function ObjectLoader( manager ) {
	
			this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;
			this.texturePath = '';
	
		}
	
		Object.assign( ObjectLoader.prototype, {
	
			load: function ( url, onLoad, onProgress, onError ) {
	
				if ( this.texturePath === '' ) {
	
					this.texturePath = url.substring( 0, url.lastIndexOf( '/' ) + 1 );
	
				}
	
				var scope = this;
	
				var loader = new FileLoader( scope.manager );
				loader.load( url, function ( text ) {
	
					var json = null;
	
					try {
	
						json = JSON.parse( text );
	
					} catch ( error ) {
	
						if ( onError !== undefined ) onError( error );
	
						console.error( 'THREE:ObjectLoader: Can\'t parse ' + url + '.', error.message );
	
						return;
	
					}
	
					var metadata = json.metadata;
	
					if ( metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === 'geometry' ) {
	
						console.error( 'THREE.ObjectLoader: Can\'t load ' + url + '. Use THREE.JSONLoader instead.' );
						return;
	
					}
	
					scope.parse( json, onLoad );
	
				}, onProgress, onError );
	
			},
	
			setTexturePath: function ( value ) {
	
				this.texturePath = value;
	
			},
	
			setCrossOrigin: function ( value ) {
	
				this.crossOrigin = value;
	
			},
	
			parse: function ( json, onLoad ) {
	
				var shapes = this.parseShape( json.shapes );
				var geometries = this.parseGeometries( json.geometries, shapes );
	
				var images = this.parseImages( json.images, function () {
	
					if ( onLoad !== undefined ) onLoad( object );
	
				} );
	
				var textures = this.parseTextures( json.textures, images );
				var materials = this.parseMaterials( json.materials, textures );
	
				var object = this.parseObject( json.object, geometries, materials );
	
				if ( json.animations ) {
	
					object.animations = this.parseAnimations( json.animations );
	
				}
	
				if ( json.images === undefined || json.images.length === 0 ) {
	
					if ( onLoad !== undefined ) onLoad( object );
	
				}
	
				return object;
	
			},
	
			parseShape: function ( json ) {
	
				var shapes = {};
	
				if ( json !== undefined ) {
	
					for ( var i = 0, l = json.length; i < l; i ++ ) {
	
						var shape = new Shape().fromJSON( json[ i ] );
	
						shapes[ shape.uuid ] = shape;
	
					}
	
				}
	
				return shapes;
	
			},
	
			parseGeometries: function ( json, shapes ) {
	
				var geometries = {};
	
				if ( json !== undefined ) {
	
					var geometryLoader = new JSONLoader();
					var bufferGeometryLoader = new BufferGeometryLoader();
	
					for ( var i = 0, l = json.length; i < l; i ++ ) {
	
						var geometry;
						var data = json[ i ];
	
						switch ( data.type ) {
	
							case 'PlaneGeometry':
							case 'PlaneBufferGeometry':
	
								geometry = new Geometries[ data.type ](
									data.width,
									data.height,
									data.widthSegments,
									data.heightSegments
								);
	
								break;
	
							case 'BoxGeometry':
							case 'BoxBufferGeometry':
							case 'CubeGeometry': // backwards compatible
	
								geometry = new Geometries[ data.type ](
									data.width,
									data.height,
									data.depth,
									data.widthSegments,
									data.heightSegments,
									data.depthSegments
								);
	
								break;
	
							case 'CircleGeometry':
							case 'CircleBufferGeometry':
	
								geometry = new Geometries[ data.type ](
									data.radius,
									data.segments,
									data.thetaStart,
									data.thetaLength
								);
	
								break;
	
							case 'CylinderGeometry':
							case 'CylinderBufferGeometry':
	
								geometry = new Geometries[ data.type ](
									data.radiusTop,
									data.radiusBottom,
									data.height,
									data.radialSegments,
									data.heightSegments,
									data.openEnded,
									data.thetaStart,
									data.thetaLength
								);
	
								break;
	
							case 'ConeGeometry':
							case 'ConeBufferGeometry':
	
								geometry = new Geometries[ data.type ](
									data.radius,
									data.height,
									data.radialSegments,
									data.heightSegments,
									data.openEnded,
									data.thetaStart,
									data.thetaLength
								);
	
								break;
	
							case 'SphereGeometry':
							case 'SphereBufferGeometry':
	
								geometry = new Geometries[ data.type ](
									data.radius,
									data.widthSegments,
									data.heightSegments,
									data.phiStart,
									data.phiLength,
									data.thetaStart,
									data.thetaLength
								);
	
								break;
	
							case 'DodecahedronGeometry':
							case 'DodecahedronBufferGeometry':
							case 'IcosahedronGeometry':
							case 'IcosahedronBufferGeometry':
							case 'OctahedronGeometry':
							case 'OctahedronBufferGeometry':
							case 'TetrahedronGeometry':
							case 'TetrahedronBufferGeometry':
	
								geometry = new Geometries[ data.type ](
									data.radius,
									data.detail
								);
	
								break;
	
							case 'RingGeometry':
							case 'RingBufferGeometry':
	
								geometry = new Geometries[ data.type ](
									data.innerRadius,
									data.outerRadius,
									data.thetaSegments,
									data.phiSegments,
									data.thetaStart,
									data.thetaLength
								);
	
								break;
	
							case 'TorusGeometry':
							case 'TorusBufferGeometry':
	
								geometry = new Geometries[ data.type ](
									data.radius,
									data.tube,
									data.radialSegments,
									data.tubularSegments,
									data.arc
								);
	
								break;
	
							case 'TorusKnotGeometry':
							case 'TorusKnotBufferGeometry':
	
								geometry = new Geometries[ data.type ](
									data.radius,
									data.tube,
									data.tubularSegments,
									data.radialSegments,
									data.p,
									data.q
								);
	
								break;
	
							case 'LatheGeometry':
							case 'LatheBufferGeometry':
	
								geometry = new Geometries[ data.type ](
									data.points,
									data.segments,
									data.phiStart,
									data.phiLength
								);
	
								break;
	
							case 'PolyhedronGeometry':
							case 'PolyhedronBufferGeometry':
	
								geometry = new Geometries[ data.type ](
									data.vertices,
									data.indices,
									data.radius,
									data.details
								);
	
								break;
	
							case 'ShapeGeometry':
							case 'ShapeBufferGeometry':
	
								var geometryShapes = [];
	
								for ( var i = 0, l = data.shapes.length; i < l; i ++ ) {
	
									var shape = shapes[ data.shapes[ i ] ];
	
									geometryShapes.push( shape );
	
								}
	
								geometry = new Geometries[ data.type ](
									geometryShapes,
									data.curveSegments
								);
	
								break;
	
							case 'BufferGeometry':
	
								geometry = bufferGeometryLoader.parse( data );
	
								break;
	
							case 'Geometry':
	
								geometry = geometryLoader.parse( data, this.texturePath ).geometry;
	
								break;
	
							default:
	
								console.warn( 'THREE.ObjectLoader: Unsupported geometry type "' + data.type + '"' );
	
								continue;
	
						}
	
						geometry.uuid = data.uuid;
	
						if ( data.name !== undefined ) geometry.name = data.name;
	
						geometries[ data.uuid ] = geometry;
	
					}
	
				}
	
				return geometries;
	
			},
	
			parseMaterials: function ( json, textures ) {
	
				var materials = {};
	
				if ( json !== undefined ) {
	
					var loader = new MaterialLoader();
					loader.setTextures( textures );
	
					for ( var i = 0, l = json.length; i < l; i ++ ) {
	
						var data = json[ i ];
	
						if ( data.type === 'MultiMaterial' ) {
	
							// Deprecated
	
							var array = [];
	
							for ( var j = 0; j < data.materials.length; j ++ ) {
	
								array.push( loader.parse( data.materials[ j ] ) );
	
							}
	
							materials[ data.uuid ] = array;
	
						} else {
	
							materials[ data.uuid ] = loader.parse( data );
	
						}
	
					}
	
				}
	
				return materials;
	
			},
	
			parseAnimations: function ( json ) {
	
				var animations = [];
	
				for ( var i = 0; i < json.length; i ++ ) {
	
					var clip = AnimationClip.parse( json[ i ] );
	
					animations.push( clip );
	
				}
	
				return animations;
	
			},
	
			parseImages: function ( json, onLoad ) {
	
				var scope = this;
				var images = {};
	
				function loadImage( url ) {
	
					scope.manager.itemStart( url );
	
					return loader.load( url, function () {
	
						scope.manager.itemEnd( url );
	
					}, undefined, function () {
	
						scope.manager.itemEnd( url );
						scope.manager.itemError( url );
	
					} );
	
				}
	
				if ( json !== undefined && json.length > 0 ) {
	
					var manager = new LoadingManager( onLoad );
	
					var loader = new ImageLoader( manager );
					loader.setCrossOrigin( this.crossOrigin );
	
					for ( var i = 0, l = json.length; i < l; i ++ ) {
	
						var image = json[ i ];
						var path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test( image.url ) ? image.url : scope.texturePath + image.url;
	
						images[ image.uuid ] = loadImage( path );
	
					}
	
				}
	
				return images;
	
			},
	
			parseTextures: function ( json, images ) {
	
				function parseConstant( value, type ) {
	
					if ( typeof value === 'number' ) return value;
	
					console.warn( 'THREE.ObjectLoader.parseTexture: Constant should be in numeric form.', value );
	
					return type[ value ];
	
				}
	
				var textures = {};
	
				if ( json !== undefined ) {
	
					for ( var i = 0, l = json.length; i < l; i ++ ) {
	
						var data = json[ i ];
	
						if ( data.image === undefined ) {
	
							console.warn( 'THREE.ObjectLoader: No "image" specified for', data.uuid );
	
						}
	
						if ( images[ data.image ] === undefined ) {
	
							console.warn( 'THREE.ObjectLoader: Undefined image', data.image );
	
						}
	
						var texture = new Texture( images[ data.image ] );
						texture.needsUpdate = true;
	
						texture.uuid = data.uuid;
	
						if ( data.name !== undefined ) texture.name = data.name;
	
						if ( data.mapping !== undefined ) texture.mapping = parseConstant( data.mapping, TEXTURE_MAPPING );
	
						if ( data.offset !== undefined ) texture.offset.fromArray( data.offset );
						if ( data.repeat !== undefined ) texture.repeat.fromArray( data.repeat );
						if ( data.center !== undefined ) texture.center.fromArray( data.center );
						if ( data.rotation !== undefined ) texture.rotation = data.rotation;
	
						if ( data.wrap !== undefined ) {
	
							texture.wrapS = parseConstant( data.wrap[ 0 ], TEXTURE_WRAPPING );
							texture.wrapT = parseConstant( data.wrap[ 1 ], TEXTURE_WRAPPING );
	
						}
	
						if ( data.minFilter !== undefined ) texture.minFilter = parseConstant( data.minFilter, TEXTURE_FILTER );
						if ( data.magFilter !== undefined ) texture.magFilter = parseConstant( data.magFilter, TEXTURE_FILTER );
						if ( data.anisotropy !== undefined ) texture.anisotropy = data.anisotropy;
	
						if ( data.flipY !== undefined ) texture.flipY = data.flipY;
	
						textures[ data.uuid ] = texture;
	
					}
	
				}
	
				return textures;
	
			},
	
			parseObject: function () {
	
				var matrix = new Matrix4();
	
				return function parseObject( data, geometries, materials ) {
	
					var object;
	
					function getGeometry( name ) {
	
						if ( geometries[ name ] === undefined ) {
	
							console.warn( 'THREE.ObjectLoader: Undefined geometry', name );
	
						}
	
						return geometries[ name ];
	
					}
	
					function getMaterial( name ) {
	
						if ( name === undefined ) return undefined;
	
						if ( Array.isArray( name ) ) {
	
							var array = [];
	
							for ( var i = 0, l = name.length; i < l; i ++ ) {
	
								var uuid = name[ i ];
	
								if ( materials[ uuid ] === undefined ) {
	
									console.warn( 'THREE.ObjectLoader: Undefined material', uuid );
	
								}
	
								array.push( materials[ uuid ] );
	
							}
	
							return array;
	
						}
	
						if ( materials[ name ] === undefined ) {
	
							console.warn( 'THREE.ObjectLoader: Undefined material', name );
	
						}
	
						return materials[ name ];
	
					}
	
					switch ( data.type ) {
	
						case 'Scene':
	
							object = new Scene();
	
							if ( data.background !== undefined ) {
	
								if ( Number.isInteger( data.background ) ) {
	
									object.background = new Color( data.background );
	
								}
	
							}
	
							if ( data.fog !== undefined ) {
	
								if ( data.fog.type === 'Fog' ) {
	
									object.fog = new Fog( data.fog.color, data.fog.near, data.fog.far );
	
								} else if ( data.fog.type === 'FogExp2' ) {
	
									object.fog = new FogExp2( data.fog.color, data.fog.density );
	
								}
	
							}
	
							break;
	
						case 'PerspectiveCamera':
	
							object = new PerspectiveCamera( data.fov, data.aspect, data.near, data.far );
	
							if ( data.focus !== undefined ) object.focus = data.focus;
							if ( data.zoom !== undefined ) object.zoom = data.zoom;
							if ( data.filmGauge !== undefined ) object.filmGauge = data.filmGauge;
							if ( data.filmOffset !== undefined ) object.filmOffset = data.filmOffset;
							if ( data.view !== undefined ) object.view = Object.assign( {}, data.view );
	
							break;
	
						case 'OrthographicCamera':
	
							object = new OrthographicCamera( data.left, data.right, data.top, data.bottom, data.near, data.far );
	
							break;
	
						case 'AmbientLight':
	
							object = new AmbientLight( data.color, data.intensity );
	
							break;
	
						case 'DirectionalLight':
	
							object = new DirectionalLight( data.color, data.intensity );
	
							break;
	
						case 'PointLight':
	
							object = new PointLight( data.color, data.intensity, data.distance, data.decay );
	
							break;
	
						case 'RectAreaLight':
	
							object = new RectAreaLight( data.color, data.intensity, data.width, data.height );
	
							break;
	
						case 'SpotLight':
	
							object = new SpotLight( data.color, data.intensity, data.distance, data.angle, data.penumbra, data.decay );
	
							break;
	
						case 'HemisphereLight':
	
							object = new HemisphereLight( data.color, data.groundColor, data.intensity );
	
							break;
	
						case 'SkinnedMesh':
	
							console.warn( 'THREE.ObjectLoader.parseObject() does not support SkinnedMesh yet.' );
	
						case 'Mesh':
	
							var geometry = getGeometry( data.geometry );
							var material = getMaterial( data.material );
	
							if ( geometry.bones && geometry.bones.length > 0 ) {
	
								object = new SkinnedMesh( geometry, material );
	
							} else {
	
								object = new Mesh( geometry, material );
	
							}
	
							break;
	
						case 'LOD':
	
							object = new LOD();
	
							break;
	
						case 'Line':
	
							object = new Line( getGeometry( data.geometry ), getMaterial( data.material ), data.mode );
	
							break;
	
						case 'LineLoop':
	
							object = new LineLoop( getGeometry( data.geometry ), getMaterial( data.material ) );
	
							break;
	
						case 'LineSegments':
	
							object = new LineSegments( getGeometry( data.geometry ), getMaterial( data.material ) );
	
							break;
	
						case 'PointCloud':
						case 'Points':
	
							object = new Points( getGeometry( data.geometry ), getMaterial( data.material ) );
	
							break;
	
						case 'Sprite':
	
							object = new Sprite( getMaterial( data.material ) );
	
							break;
	
						case 'Group':
	
							object = new Group();
	
							break;
	
						default:
	
							object = new Object3D();
	
					}
	
					object.uuid = data.uuid;
	
					if ( data.name !== undefined ) object.name = data.name;
					if ( data.matrix !== undefined ) {
	
						matrix.fromArray( data.matrix );
						matrix.decompose( object.position, object.quaternion, object.scale );
	
					} else {
	
						if ( data.position !== undefined ) object.position.fromArray( data.position );
						if ( data.rotation !== undefined ) object.rotation.fromArray( data.rotation );
						if ( data.quaternion !== undefined ) object.quaternion.fromArray( data.quaternion );
						if ( data.scale !== undefined ) object.scale.fromArray( data.scale );
	
					}
	
					if ( data.castShadow !== undefined ) object.castShadow = data.castShadow;
					if ( data.receiveShadow !== undefined ) object.receiveShadow = data.receiveShadow;
	
					if ( data.shadow ) {
	
						if ( data.shadow.bias !== undefined ) object.shadow.bias = data.shadow.bias;
						if ( data.shadow.radius !== undefined ) object.shadow.radius = data.shadow.radius;
						if ( data.shadow.mapSize !== undefined ) object.shadow.mapSize.fromArray( data.shadow.mapSize );
						if ( data.shadow.camera !== undefined ) object.shadow.camera = this.parseObject( data.shadow.camera );
	
					}
	
					if ( data.visible !== undefined ) object.visible = data.visible;
					if ( data.userData !== undefined ) object.userData = data.userData;
	
					if ( data.children !== undefined ) {
	
						var children = data.children;
	
						for ( var i = 0; i < children.length; i ++ ) {
	
							object.add( this.parseObject( children[ i ], geometries, materials ) );
	
						}
	
					}
	
					if ( data.type === 'LOD' ) {
	
						var levels = data.levels;
	
						for ( var l = 0; l < levels.length; l ++ ) {
	
							var level = levels[ l ];
							var child = object.getObjectByProperty( 'uuid', level.object );
	
							if ( child !== undefined ) {
	
								object.addLevel( child, level.distance );
	
							}
	
						}
	
					}
	
					return object;
	
				};
	
			}()
	
		} );
	
		var TEXTURE_MAPPING = {
			UVMapping: UVMapping,
			CubeReflectionMapping: CubeReflectionMapping,
			CubeRefractionMapping: CubeRefractionMapping,
			EquirectangularReflectionMapping: EquirectangularReflectionMapping,
			EquirectangularRefractionMapping: EquirectangularRefractionMapping,
			SphericalReflectionMapping: SphericalReflectionMapping,
			CubeUVReflectionMapping: CubeUVReflectionMapping,
			CubeUVRefractionMapping: CubeUVRefractionMapping
		};
	
		var TEXTURE_WRAPPING = {
			RepeatWrapping: RepeatWrapping,
			ClampToEdgeWrapping: ClampToEdgeWrapping,
			MirroredRepeatWrapping: MirroredRepeatWrapping
		};
	
		var TEXTURE_FILTER = {
			NearestFilter: NearestFilter,
			NearestMipMapNearestFilter: NearestMipMapNearestFilter,
			NearestMipMapLinearFilter: NearestMipMapLinearFilter,
			LinearFilter: LinearFilter,
			LinearMipMapNearestFilter: LinearMipMapNearestFilter,
			LinearMipMapLinearFilter: LinearMipMapLinearFilter
		};
	
		/**
		 * @author thespite / http://clicktorelease.com/
		 */
	
		function ImageBitmapLoader( manager ) {
	
			if ( typeof createImageBitmap === 'undefined' ) {
	
				console.warn( 'THREE.ImageBitmapLoader: createImageBitmap() not supported.' );
	
			}
	
			if ( typeof fetch === 'undefined' ) {
	
				console.warn( 'THREE.ImageBitmapLoader: fetch() not supported.' );
	
			}
	
			this.manager = manager !== undefined ? manager : DefaultLoadingManager;
			this.options = undefined;
	
		}
	
		ImageBitmapLoader.prototype = {
	
			constructor: ImageBitmapLoader,
	
			setOptions: function setOptions( options ) {
	
				this.options = options;
	
				return this;
	
			},
	
			load: function load( url, onLoad, onProgress, onError ) {
	
				if ( url === undefined ) url = '';
	
				if ( this.path !== undefined ) url = this.path + url;
	
				var scope = this;
	
				var cached = Cache.get( url );
	
				if ( cached !== undefined ) {
	
					scope.manager.itemStart( url );
	
					setTimeout( function () {
	
						if ( onLoad ) onLoad( cached );
	
						scope.manager.itemEnd( url );
	
					}, 0 );
	
					return cached;
	
				}
	
				fetch( url ).then( function ( res ) {
	
					return res.blob();
	
				} ).then( function ( blob ) {
	
					return createImageBitmap( blob, scope.options );
	
				} ).then( function ( imageBitmap ) {
	
					Cache.add( url, imageBitmap );
	
					if ( onLoad ) onLoad( imageBitmap );
	
					scope.manager.itemEnd( url );
	
				} ).catch( function ( e ) {
	
					if ( onError ) onError( e );
	
					scope.manager.itemEnd( url );
					scope.manager.itemError( url );
	
				} );
	
			},
	
			setCrossOrigin: function ( /* value */ ) {
	
				return this;
	
			},
	
			setPath: function ( value ) {
	
				this.path = value;
				return this;
	
			}
	
		};
	
		/**
		 * @author zz85 / http://www.lab4games.net/zz85/blog
		 * minimal class for proxing functions to Path. Replaces old "extractSubpaths()"
		 **/
	
		function ShapePath() {
	
			this.type = 'ShapePath';
	
			this.subPaths = [];
			this.currentPath = null;
	
		}
	
		Object.assign( ShapePath.prototype, {
	
			moveTo: function ( x, y ) {
	
				this.currentPath = new Path();
				this.subPaths.push( this.currentPath );
				this.currentPath.moveTo( x, y );
	
			},
	
			lineTo: function ( x, y ) {
	
				this.currentPath.lineTo( x, y );
	
			},
	
			quadraticCurveTo: function ( aCPx, aCPy, aX, aY ) {
	
				this.currentPath.quadraticCurveTo( aCPx, aCPy, aX, aY );
	
			},
	
			bezierCurveTo: function ( aCP1x, aCP1y, aCP2x, aCP2y, aX, aY ) {
	
				this.currentPath.bezierCurveTo( aCP1x, aCP1y, aCP2x, aCP2y, aX, aY );
	
			},
	
			splineThru: function ( pts ) {
	
				this.currentPath.splineThru( pts );
	
			},
	
			toShapes: function ( isCCW, noHoles ) {
	
				function toShapesNoHoles( inSubpaths ) {
	
					var shapes = [];
	
					for ( var i = 0, l = inSubpaths.length; i < l; i ++ ) {
	
						var tmpPath = inSubpaths[ i ];
	
						var tmpShape = new Shape();
						tmpShape.curves = tmpPath.curves;
	
						shapes.push( tmpShape );
	
					}
	
					return shapes;
	
				}
	
				function isPointInsidePolygon( inPt, inPolygon ) {
	
					var polyLen = inPolygon.length;
	
					// inPt on polygon contour => immediate success    or
					// toggling of inside/outside at every single! intersection point of an edge
					//  with the horizontal line through inPt, left of inPt
					//  not counting lowerY endpoints of edges and whole edges on that line
					var inside = false;
					for ( var p = polyLen - 1, q = 0; q < polyLen; p = q ++ ) {
	
						var edgeLowPt = inPolygon[ p ];
						var edgeHighPt = inPolygon[ q ];
	
						var edgeDx = edgeHighPt.x - edgeLowPt.x;
						var edgeDy = edgeHighPt.y - edgeLowPt.y;
	
						if ( Math.abs( edgeDy ) > Number.EPSILON ) {
	
							// not parallel
							if ( edgeDy < 0 ) {
	
								edgeLowPt = inPolygon[ q ]; edgeDx = - edgeDx;
								edgeHighPt = inPolygon[ p ]; edgeDy = - edgeDy;
	
							}
							if ( ( inPt.y < edgeLowPt.y ) || ( inPt.y > edgeHighPt.y ) ) 		continue;
	
							if ( inPt.y === edgeLowPt.y ) {
	
								if ( inPt.x === edgeLowPt.x )		return	true;		// inPt is on contour ?
								// continue;				// no intersection or edgeLowPt => doesn't count !!!
	
							} else {
	
								var perpEdge = edgeDy * ( inPt.x - edgeLowPt.x ) - edgeDx * ( inPt.y - edgeLowPt.y );
								if ( perpEdge === 0 )				return	true;		// inPt is on contour ?
								if ( perpEdge < 0 ) 				continue;
								inside = ! inside;		// true intersection left of inPt
	
							}
	
						} else {
	
							// parallel or collinear
							if ( inPt.y !== edgeLowPt.y ) 		continue;			// parallel
							// edge lies on the same horizontal line as inPt
							if ( ( ( edgeHighPt.x <= inPt.x ) && ( inPt.x <= edgeLowPt.x ) ) ||
								 ( ( edgeLowPt.x <= inPt.x ) && ( inPt.x <= edgeHighPt.x ) ) )		return	true;	// inPt: Point on contour !
							// continue;
	
						}
	
					}
	
					return	inside;
	
				}
	
				var isClockWise = ShapeUtils.isClockWise;
	
				var subPaths = this.subPaths;
				if ( subPaths.length === 0 ) return [];
	
				if ( noHoles === true )	return	toShapesNoHoles( subPaths );
	
	
				var solid, tmpPath, tmpShape, shapes = [];
	
				if ( subPaths.length === 1 ) {
	
					tmpPath = subPaths[ 0 ];
					tmpShape = new Shape();
					tmpShape.curves = tmpPath.curves;
					shapes.push( tmpShape );
					return shapes;
	
				}
	
				var holesFirst = ! isClockWise( subPaths[ 0 ].getPoints() );
				holesFirst = isCCW ? ! holesFirst : holesFirst;
	
				// console.log("Holes first", holesFirst);
	
				var betterShapeHoles = [];
				var newShapes = [];
				var newShapeHoles = [];
				var mainIdx = 0;
				var tmpPoints;
	
				newShapes[ mainIdx ] = undefined;
				newShapeHoles[ mainIdx ] = [];
	
				for ( var i = 0, l = subPaths.length; i < l; i ++ ) {
	
					tmpPath = subPaths[ i ];
					tmpPoints = tmpPath.getPoints();
					solid = isClockWise( tmpPoints );
					solid = isCCW ? ! solid : solid;
	
					if ( solid ) {
	
						if ( ( ! holesFirst ) && ( newShapes[ mainIdx ] ) )	mainIdx ++;
	
						newShapes[ mainIdx ] = { s: new Shape(), p: tmpPoints };
						newShapes[ mainIdx ].s.curves = tmpPath.curves;
	
						if ( holesFirst )	mainIdx ++;
						newShapeHoles[ mainIdx ] = [];
	
						//console.log('cw', i);
	
					} else {
	
						newShapeHoles[ mainIdx ].push( { h: tmpPath, p: tmpPoints[ 0 ] } );
	
						//console.log('ccw', i);
	
					}
	
				}
	
				// only Holes? -> probably all Shapes with wrong orientation
				if ( ! newShapes[ 0 ] )	return	toShapesNoHoles( subPaths );
	
	
				if ( newShapes.length > 1 ) {
	
					var ambiguous = false;
					var toChange = [];
	
					for ( var sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx ++ ) {
	
						betterShapeHoles[ sIdx ] = [];
	
					}
	
					for ( var sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx ++ ) {
	
						var sho = newShapeHoles[ sIdx ];
	
						for ( var hIdx = 0; hIdx < sho.length; hIdx ++ ) {
	
							var ho = sho[ hIdx ];
							var hole_unassigned = true;
	
							for ( var s2Idx = 0; s2Idx < newShapes.length; s2Idx ++ ) {
	
								if ( isPointInsidePolygon( ho.p, newShapes[ s2Idx ].p ) ) {
	
									if ( sIdx !== s2Idx )	toChange.push( { froms: sIdx, tos: s2Idx, hole: hIdx } );
									if ( hole_unassigned ) {
	
										hole_unassigned = false;
										betterShapeHoles[ s2Idx ].push( ho );
	
									} else {
	
										ambiguous = true;
	
									}
	
								}
	
							}
							if ( hole_unassigned ) {
	
								betterShapeHoles[ sIdx ].push( ho );
	
							}
	
						}
	
					}
					// console.log("ambiguous: ", ambiguous);
					if ( toChange.length > 0 ) {
	
						// console.log("to change: ", toChange);
						if ( ! ambiguous )	newShapeHoles = betterShapeHoles;
	
					}
	
				}
	
				var tmpHoles;
	
				for ( var i = 0, il = newShapes.length; i < il; i ++ ) {
	
					tmpShape = newShapes[ i ].s;
					shapes.push( tmpShape );
					tmpHoles = newShapeHoles[ i ];
	
					for ( var j = 0, jl = tmpHoles.length; j < jl; j ++ ) {
	
						tmpShape.holes.push( tmpHoles[ j ].h );
	
					}
	
				}
	
				//console.log("shape", shapes);
	
				return shapes;
	
			}
	
		} );
	
		/**
		 * @author zz85 / http://www.lab4games.net/zz85/blog
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function Font( data ) {
	
			this.type = 'Font';
	
			this.data = data;
	
		}
	
		Object.assign( Font.prototype, {
	
			isFont: true,
	
			generateShapes: function ( text, size, divisions ) {
	
				function createPaths( text ) {
	
					var chars = String( text ).split( '' );
					var scale = size / data.resolution;
					var line_height = ( data.boundingBox.yMax - data.boundingBox.yMin + data.underlineThickness ) * scale;
	
					var offsetX = 0, offsetY = 0;
	
					var paths = [];
	
					for ( var i = 0; i < chars.length; i ++ ) {
	
						var char = chars[ i ];
	
						if ( char === '\n' ) {
	
							offsetX = 0;
							offsetY -= line_height;
	
						} else {
	
							var ret = createPath( char, scale, offsetX, offsetY );
							offsetX += ret.offsetX;
							paths.push( ret.path );
	
						}
	
					}
	
					return paths;
	
				}
	
				function createPath( c, scale, offsetX, offsetY ) {
	
					var glyph = data.glyphs[ c ] || data.glyphs[ '?' ];
	
					if ( ! glyph ) return;
	
					var path = new ShapePath();
	
					var pts = [];
					var x, y, cpx, cpy, cpx0, cpy0, cpx1, cpy1, cpx2, cpy2, laste;
	
					if ( glyph.o ) {
	
						var outline = glyph._cachedOutline || ( glyph._cachedOutline = glyph.o.split( ' ' ) );
	
						for ( var i = 0, l = outline.length; i < l; ) {
	
							var action = outline[ i ++ ];
	
							switch ( action ) {
	
								case 'm': // moveTo
	
									x = outline[ i ++ ] * scale + offsetX;
									y = outline[ i ++ ] * scale + offsetY;
	
									path.moveTo( x, y );
	
									break;
	
								case 'l': // lineTo
	
									x = outline[ i ++ ] * scale + offsetX;
									y = outline[ i ++ ] * scale + offsetY;
	
									path.lineTo( x, y );
	
									break;
	
								case 'q': // quadraticCurveTo
	
									cpx = outline[ i ++ ] * scale + offsetX;
									cpy = outline[ i ++ ] * scale + offsetY;
									cpx1 = outline[ i ++ ] * scale + offsetX;
									cpy1 = outline[ i ++ ] * scale + offsetY;
	
									path.quadraticCurveTo( cpx1, cpy1, cpx, cpy );
	
									laste = pts[ pts.length - 1 ];
	
									if ( laste ) {
	
										cpx0 = laste.x;
										cpy0 = laste.y;
	
										
	
									}
	
									break;
	
								case 'b': // bezierCurveTo
	
									cpx = outline[ i ++ ] * scale + offsetX;
									cpy = outline[ i ++ ] * scale + offsetY;
									cpx1 = outline[ i ++ ] * scale + offsetX;
									cpy1 = outline[ i ++ ] * scale + offsetY;
									cpx2 = outline[ i ++ ] * scale + offsetX;
									cpy2 = outline[ i ++ ] * scale + offsetY;
	
									path.bezierCurveTo( cpx1, cpy1, cpx2, cpy2, cpx, cpy );
	
									laste = pts[ pts.length - 1 ];
	
									if ( laste ) {
	
										cpx0 = laste.x;
										cpy0 = laste.y;
	
										
	
									}
	
									break;
	
							}
	
						}
	
					}
	
					return { offsetX: glyph.ha * scale, path: path };
	
				}
	
				//
	
				if ( size === undefined ) size = 100;
				if ( divisions === undefined ) divisions = 4;
	
				var data = this.data;
	
				var paths = createPaths( text );
				var shapes = [];
	
				for ( var p = 0, pl = paths.length; p < pl; p ++ ) {
	
					Array.prototype.push.apply( shapes, paths[ p ].toShapes() );
	
				}
	
				return shapes;
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function FontLoader( manager ) {
	
			this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;
	
		}
	
		Object.assign( FontLoader.prototype, {
	
			load: function ( url, onLoad, onProgress, onError ) {
	
				var scope = this;
	
				var loader = new FileLoader( this.manager );
				loader.setPath( this.path );
				loader.load( url, function ( text ) {
	
					var json;
	
					try {
	
						json = JSON.parse( text );
	
					} catch ( e ) {
	
						console.warn( 'THREE.FontLoader: typeface.js support is being deprecated. Use typeface.json instead.' );
						json = JSON.parse( text.substring( 65, text.length - 2 ) );
	
					}
	
					var font = scope.parse( json );
	
					if ( onLoad ) onLoad( font );
	
				}, onProgress, onError );
	
			},
	
			parse: function ( json ) {
	
				return new Font( json );
	
			},
	
			setPath: function ( value ) {
	
				this.path = value;
				return this;
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		var context;
	
		var AudioContext = {
	
			getContext: function () {
	
				if ( context === undefined ) {
	
					context = new ( window.AudioContext || window.webkitAudioContext )();
	
				}
	
				return context;
	
			},
	
			setContext: function ( value ) {
	
				context = value;
	
			}
	
		};
	
		/**
		 * @author Reece Aaron Lecrivain / http://reecenotes.com/
		 */
	
		function AudioLoader( manager ) {
	
			this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;
	
		}
	
		Object.assign( AudioLoader.prototype, {
	
			load: function ( url, onLoad, onProgress, onError ) {
	
				var loader = new FileLoader( this.manager );
				loader.setResponseType( 'arraybuffer' );
				loader.load( url, function ( buffer ) {
	
					var context = AudioContext.getContext();
	
					context.decodeAudioData( buffer, function ( audioBuffer ) {
	
						onLoad( audioBuffer );
	
					} );
	
				}, onProgress, onError );
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function StereoCamera() {
	
			this.type = 'StereoCamera';
	
			this.aspect = 1;
	
			this.eyeSep = 0.064;
	
			this.cameraL = new PerspectiveCamera();
			this.cameraL.layers.enable( 1 );
			this.cameraL.matrixAutoUpdate = false;
	
			this.cameraR = new PerspectiveCamera();
			this.cameraR.layers.enable( 2 );
			this.cameraR.matrixAutoUpdate = false;
	
		}
	
		Object.assign( StereoCamera.prototype, {
	
			update: ( function () {
	
				var instance, focus, fov, aspect, near, far, zoom, eyeSep;
	
				var eyeRight = new Matrix4();
				var eyeLeft = new Matrix4();
	
				return function update( camera ) {
	
					var needsUpdate = instance !== this || focus !== camera.focus || fov !== camera.fov ||
														aspect !== camera.aspect * this.aspect || near !== camera.near ||
														far !== camera.far || zoom !== camera.zoom || eyeSep !== this.eyeSep;
	
					if ( needsUpdate ) {
	
						instance = this;
						focus = camera.focus;
						fov = camera.fov;
						aspect = camera.aspect * this.aspect;
						near = camera.near;
						far = camera.far;
						zoom = camera.zoom;
	
						// Off-axis stereoscopic effect based on
						// http://paulbourke.net/stereographics/stereorender/
	
						var projectionMatrix = camera.projectionMatrix.clone();
						eyeSep = this.eyeSep / 2;
						var eyeSepOnProjection = eyeSep * near / focus;
						var ymax = ( near * Math.tan( _Math.DEG2RAD * fov * 0.5 ) ) / zoom;
						var xmin, xmax;
	
						// translate xOffset
	
						eyeLeft.elements[ 12 ] = - eyeSep;
						eyeRight.elements[ 12 ] = eyeSep;
	
						// for left eye
	
						xmin = - ymax * aspect + eyeSepOnProjection;
						xmax = ymax * aspect + eyeSepOnProjection;
	
						projectionMatrix.elements[ 0 ] = 2 * near / ( xmax - xmin );
						projectionMatrix.elements[ 8 ] = ( xmax + xmin ) / ( xmax - xmin );
	
						this.cameraL.projectionMatrix.copy( projectionMatrix );
	
						// for right eye
	
						xmin = - ymax * aspect - eyeSepOnProjection;
						xmax = ymax * aspect - eyeSepOnProjection;
	
						projectionMatrix.elements[ 0 ] = 2 * near / ( xmax - xmin );
						projectionMatrix.elements[ 8 ] = ( xmax + xmin ) / ( xmax - xmin );
	
						this.cameraR.projectionMatrix.copy( projectionMatrix );
	
					}
	
					this.cameraL.matrixWorld.copy( camera.matrixWorld ).multiply( eyeLeft );
					this.cameraR.matrixWorld.copy( camera.matrixWorld ).multiply( eyeRight );
	
				};
	
			} )()
	
		} );
	
		/**
		 * Camera for rendering cube maps
		 *	- renders scene into axis-aligned cube
		 *
		 * @author alteredq / http://alteredqualia.com/
		 */
	
		function CubeCamera( near, far, cubeResolution ) {
	
			Object3D.call( this );
	
			this.type = 'CubeCamera';
	
			var fov = 90, aspect = 1;
	
			var cameraPX = new PerspectiveCamera( fov, aspect, near, far );
			cameraPX.up.set( 0, - 1, 0 );
			cameraPX.lookAt( new Vector3( 1, 0, 0 ) );
			this.add( cameraPX );
	
			var cameraNX = new PerspectiveCamera( fov, aspect, near, far );
			cameraNX.up.set( 0, - 1, 0 );
			cameraNX.lookAt( new Vector3( - 1, 0, 0 ) );
			this.add( cameraNX );
	
			var cameraPY = new PerspectiveCamera( fov, aspect, near, far );
			cameraPY.up.set( 0, 0, 1 );
			cameraPY.lookAt( new Vector3( 0, 1, 0 ) );
			this.add( cameraPY );
	
			var cameraNY = new PerspectiveCamera( fov, aspect, near, far );
			cameraNY.up.set( 0, 0, - 1 );
			cameraNY.lookAt( new Vector3( 0, - 1, 0 ) );
			this.add( cameraNY );
	
			var cameraPZ = new PerspectiveCamera( fov, aspect, near, far );
			cameraPZ.up.set( 0, - 1, 0 );
			cameraPZ.lookAt( new Vector3( 0, 0, 1 ) );
			this.add( cameraPZ );
	
			var cameraNZ = new PerspectiveCamera( fov, aspect, near, far );
			cameraNZ.up.set( 0, - 1, 0 );
			cameraNZ.lookAt( new Vector3( 0, 0, - 1 ) );
			this.add( cameraNZ );
	
			var options = { format: RGBFormat, magFilter: LinearFilter, minFilter: LinearFilter };
	
			this.renderTarget = new WebGLRenderTargetCube( cubeResolution, cubeResolution, options );
			this.renderTarget.texture.name = "CubeCamera";
	
			this.update = function ( renderer, scene ) {
	
				if ( this.parent === null ) this.updateMatrixWorld();
	
				var renderTarget = this.renderTarget;
				var generateMipmaps = renderTarget.texture.generateMipmaps;
	
				renderTarget.texture.generateMipmaps = false;
	
				renderTarget.activeCubeFace = 0;
				renderer.render( scene, cameraPX, renderTarget );
	
				renderTarget.activeCubeFace = 1;
				renderer.render( scene, cameraNX, renderTarget );
	
				renderTarget.activeCubeFace = 2;
				renderer.render( scene, cameraPY, renderTarget );
	
				renderTarget.activeCubeFace = 3;
				renderer.render( scene, cameraNY, renderTarget );
	
				renderTarget.activeCubeFace = 4;
				renderer.render( scene, cameraPZ, renderTarget );
	
				renderTarget.texture.generateMipmaps = generateMipmaps;
	
				renderTarget.activeCubeFace = 5;
				renderer.render( scene, cameraNZ, renderTarget );
	
				renderer.setRenderTarget( null );
	
			};
	
			this.clear = function ( renderer, color, depth, stencil ) {
	
				var renderTarget = this.renderTarget;
	
				for ( var i = 0; i < 6; i ++ ) {
	
					renderTarget.activeCubeFace = i;
					renderer.setRenderTarget( renderTarget );
	
					renderer.clear( color, depth, stencil );
	
				}
	
				renderer.setRenderTarget( null );
	
			};
	
		}
	
		CubeCamera.prototype = Object.create( Object3D.prototype );
		CubeCamera.prototype.constructor = CubeCamera;
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function AudioListener() {
	
			Object3D.call( this );
	
			this.type = 'AudioListener';
	
			this.context = AudioContext.getContext();
	
			this.gain = this.context.createGain();
			this.gain.connect( this.context.destination );
	
			this.filter = null;
	
		}
	
		AudioListener.prototype = Object.assign( Object.create( Object3D.prototype ), {
	
			constructor: AudioListener,
	
			getInput: function () {
	
				return this.gain;
	
			},
	
			removeFilter: function ( ) {
	
				if ( this.filter !== null ) {
	
					this.gain.disconnect( this.filter );
					this.filter.disconnect( this.context.destination );
					this.gain.connect( this.context.destination );
					this.filter = null;
	
				}
	
			},
	
			getFilter: function () {
	
				return this.filter;
	
			},
	
			setFilter: function ( value ) {
	
				if ( this.filter !== null ) {
	
					this.gain.disconnect( this.filter );
					this.filter.disconnect( this.context.destination );
	
				} else {
	
					this.gain.disconnect( this.context.destination );
	
				}
	
				this.filter = value;
				this.gain.connect( this.filter );
				this.filter.connect( this.context.destination );
	
			},
	
			getMasterVolume: function () {
	
				return this.gain.gain.value;
	
			},
	
			setMasterVolume: function ( value ) {
	
				this.gain.gain.value = value;
	
			},
	
			updateMatrixWorld: ( function () {
	
				var position = new Vector3();
				var quaternion = new Quaternion();
				var scale = new Vector3();
	
				var orientation = new Vector3();
	
				return function updateMatrixWorld( force ) {
	
					Object3D.prototype.updateMatrixWorld.call( this, force );
	
					var listener = this.context.listener;
					var up = this.up;
	
					this.matrixWorld.decompose( position, quaternion, scale );
	
					orientation.set( 0, 0, - 1 ).applyQuaternion( quaternion );
	
					if ( listener.positionX ) {
	
						listener.positionX.setValueAtTime( position.x, this.context.currentTime );
						listener.positionY.setValueAtTime( position.y, this.context.currentTime );
						listener.positionZ.setValueAtTime( position.z, this.context.currentTime );
						listener.forwardX.setValueAtTime( orientation.x, this.context.currentTime );
						listener.forwardY.setValueAtTime( orientation.y, this.context.currentTime );
						listener.forwardZ.setValueAtTime( orientation.z, this.context.currentTime );
						listener.upX.setValueAtTime( up.x, this.context.currentTime );
						listener.upY.setValueAtTime( up.y, this.context.currentTime );
						listener.upZ.setValueAtTime( up.z, this.context.currentTime );
	
					} else {
	
						listener.setPosition( position.x, position.y, position.z );
						listener.setOrientation( orientation.x, orientation.y, orientation.z, up.x, up.y, up.z );
	
					}
	
				};
	
			} )()
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author Reece Aaron Lecrivain / http://reecenotes.com/
		 */
	
		function Audio( listener ) {
	
			Object3D.call( this );
	
			this.type = 'Audio';
	
			this.context = listener.context;
	
			this.gain = this.context.createGain();
			this.gain.connect( listener.getInput() );
	
			this.autoplay = false;
	
			this.buffer = null;
			this.loop = false;
			this.startTime = 0;
			this.offset = 0;
			this.playbackRate = 1;
			this.isPlaying = false;
			this.hasPlaybackControl = true;
			this.sourceType = 'empty';
	
			this.filters = [];
	
		}
	
		Audio.prototype = Object.assign( Object.create( Object3D.prototype ), {
	
			constructor: Audio,
	
			getOutput: function () {
	
				return this.gain;
	
			},
	
			setNodeSource: function ( audioNode ) {
	
				this.hasPlaybackControl = false;
				this.sourceType = 'audioNode';
				this.source = audioNode;
				this.connect();
	
				return this;
	
			},
	
			setBuffer: function ( audioBuffer ) {
	
				this.buffer = audioBuffer;
				this.sourceType = 'buffer';
	
				if ( this.autoplay ) this.play();
	
				return this;
	
			},
	
			play: function () {
	
				if ( this.isPlaying === true ) {
	
					console.warn( 'THREE.Audio: Audio is already playing.' );
					return;
	
				}
	
				if ( this.hasPlaybackControl === false ) {
	
					console.warn( 'THREE.Audio: this Audio has no playback control.' );
					return;
	
				}
	
				var source = this.context.createBufferSource();
	
				source.buffer = this.buffer;
				source.loop = this.loop;
				source.onended = this.onEnded.bind( this );
				source.playbackRate.setValueAtTime( this.playbackRate, this.startTime );
				this.startTime = this.context.currentTime;
				source.start( this.startTime, this.offset );
	
				this.isPlaying = true;
	
				this.source = source;
	
				return this.connect();
	
			},
	
			pause: function () {
	
				if ( this.hasPlaybackControl === false ) {
	
					console.warn( 'THREE.Audio: this Audio has no playback control.' );
					return;
	
				}
	
				if ( this.isPlaying === true ) {
	
					this.source.stop();
					this.offset += ( this.context.currentTime - this.startTime ) * this.playbackRate;
					this.isPlaying = false;
	
				}
	
				return this;
	
			},
	
			stop: function () {
	
				if ( this.hasPlaybackControl === false ) {
	
					console.warn( 'THREE.Audio: this Audio has no playback control.' );
					return;
	
				}
	
				this.source.stop();
				this.offset = 0;
				this.isPlaying = false;
	
				return this;
	
			},
	
			connect: function () {
	
				if ( this.filters.length > 0 ) {
	
					this.source.connect( this.filters[ 0 ] );
	
					for ( var i = 1, l = this.filters.length; i < l; i ++ ) {
	
						this.filters[ i - 1 ].connect( this.filters[ i ] );
	
					}
	
					this.filters[ this.filters.length - 1 ].connect( this.getOutput() );
	
				} else {
	
					this.source.connect( this.getOutput() );
	
				}
	
				return this;
	
			},
	
			disconnect: function () {
	
				if ( this.filters.length > 0 ) {
	
					this.source.disconnect( this.filters[ 0 ] );
	
					for ( var i = 1, l = this.filters.length; i < l; i ++ ) {
	
						this.filters[ i - 1 ].disconnect( this.filters[ i ] );
	
					}
	
					this.filters[ this.filters.length - 1 ].disconnect( this.getOutput() );
	
				} else {
	
					this.source.disconnect( this.getOutput() );
	
				}
	
				return this;
	
			},
	
			getFilters: function () {
	
				return this.filters;
	
			},
	
			setFilters: function ( value ) {
	
				if ( ! value ) value = [];
	
				if ( this.isPlaying === true ) {
	
					this.disconnect();
					this.filters = value;
					this.connect();
	
				} else {
	
					this.filters = value;
	
				}
	
				return this;
	
			},
	
			getFilter: function () {
	
				return this.getFilters()[ 0 ];
	
			},
	
			setFilter: function ( filter ) {
	
				return this.setFilters( filter ? [ filter ] : [] );
	
			},
	
			setPlaybackRate: function ( value ) {
	
				if ( this.hasPlaybackControl === false ) {
	
					console.warn( 'THREE.Audio: this Audio has no playback control.' );
					return;
	
				}
	
				this.playbackRate = value;
	
				if ( this.isPlaying === true ) {
	
					this.source.playbackRate.setValueAtTime( this.playbackRate, this.context.currentTime );
	
				}
	
				return this;
	
			},
	
			getPlaybackRate: function () {
	
				return this.playbackRate;
	
			},
	
			onEnded: function () {
	
				this.isPlaying = false;
	
			},
	
			getLoop: function () {
	
				if ( this.hasPlaybackControl === false ) {
	
					console.warn( 'THREE.Audio: this Audio has no playback control.' );
					return false;
	
				}
	
				return this.loop;
	
			},
	
			setLoop: function ( value ) {
	
				if ( this.hasPlaybackControl === false ) {
	
					console.warn( 'THREE.Audio: this Audio has no playback control.' );
					return;
	
				}
	
				this.loop = value;
	
				if ( this.isPlaying === true ) {
	
					this.source.loop = this.loop;
	
				}
	
				return this;
	
			},
	
			getVolume: function () {
	
				return this.gain.gain.value;
	
			},
	
			setVolume: function ( value ) {
	
				this.gain.gain.value = value;
	
				return this;
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function PositionalAudio( listener ) {
	
			Audio.call( this, listener );
	
			this.panner = this.context.createPanner();
			this.panner.connect( this.gain );
	
		}
	
		PositionalAudio.prototype = Object.assign( Object.create( Audio.prototype ), {
	
			constructor: PositionalAudio,
	
			getOutput: function () {
	
				return this.panner;
	
			},
	
			getRefDistance: function () {
	
				return this.panner.refDistance;
	
			},
	
			setRefDistance: function ( value ) {
	
				this.panner.refDistance = value;
	
			},
	
			getRolloffFactor: function () {
	
				return this.panner.rolloffFactor;
	
			},
	
			setRolloffFactor: function ( value ) {
	
				this.panner.rolloffFactor = value;
	
			},
	
			getDistanceModel: function () {
	
				return this.panner.distanceModel;
	
			},
	
			setDistanceModel: function ( value ) {
	
				this.panner.distanceModel = value;
	
			},
	
			getMaxDistance: function () {
	
				return this.panner.maxDistance;
	
			},
	
			setMaxDistance: function ( value ) {
	
				this.panner.maxDistance = value;
	
			},
	
			updateMatrixWorld: ( function () {
	
				var position = new Vector3();
	
				return function updateMatrixWorld( force ) {
	
					Object3D.prototype.updateMatrixWorld.call( this, force );
	
					position.setFromMatrixPosition( this.matrixWorld );
	
					this.panner.setPosition( position.x, position.y, position.z );
	
				};
	
			} )()
	
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function AudioAnalyser( audio, fftSize ) {
	
			this.analyser = audio.context.createAnalyser();
			this.analyser.fftSize = fftSize !== undefined ? fftSize : 2048;
	
			this.data = new Uint8Array( this.analyser.frequencyBinCount );
	
			audio.getOutput().connect( this.analyser );
	
		}
	
		Object.assign( AudioAnalyser.prototype, {
	
			getFrequencyData: function () {
	
				this.analyser.getByteFrequencyData( this.data );
	
				return this.data;
	
			},
	
			getAverageFrequency: function () {
	
				var value = 0, data = this.getFrequencyData();
	
				for ( var i = 0; i < data.length; i ++ ) {
	
					value += data[ i ];
	
				}
	
				return value / data.length;
	
			}
	
		} );
	
		/**
		 *
		 * Buffered scene graph property that allows weighted accumulation.
		 *
		 *
		 * @author Ben Houston / http://clara.io/
		 * @author David Sarno / http://lighthaus.us/
		 * @author tschw
		 */
	
		function PropertyMixer( binding, typeName, valueSize ) {
	
			this.binding = binding;
			this.valueSize = valueSize;
	
			var bufferType = Float64Array,
				mixFunction;
	
			switch ( typeName ) {
	
				case 'quaternion':
					mixFunction = this._slerp;
					break;
	
				case 'string':
				case 'bool':
					bufferType = Array;
					mixFunction = this._select;
					break;
	
				default:
					mixFunction = this._lerp;
	
			}
	
			this.buffer = new bufferType( valueSize * 4 );
			// layout: [ incoming | accu0 | accu1 | orig ]
			//
			// interpolators can use .buffer as their .result
			// the data then goes to 'incoming'
			//
			// 'accu0' and 'accu1' are used frame-interleaved for
			// the cumulative result and are compared to detect
			// changes
			//
			// 'orig' stores the original state of the property
	
			this._mixBufferRegion = mixFunction;
	
			this.cumulativeWeight = 0;
	
			this.useCount = 0;
			this.referenceCount = 0;
	
		}
	
		Object.assign( PropertyMixer.prototype, {
	
			// accumulate data in the 'incoming' region into 'accu<i>'
			accumulate: function ( accuIndex, weight ) {
	
				// note: happily accumulating nothing when weight = 0, the caller knows
				// the weight and shouldn't have made the call in the first place
	
				var buffer = this.buffer,
					stride = this.valueSize,
					offset = accuIndex * stride + stride,
	
					currentWeight = this.cumulativeWeight;
	
				if ( currentWeight === 0 ) {
	
					// accuN := incoming * weight
	
					for ( var i = 0; i !== stride; ++ i ) {
	
						buffer[ offset + i ] = buffer[ i ];
	
					}
	
					currentWeight = weight;
	
				} else {
	
					// accuN := accuN + incoming * weight
	
					currentWeight += weight;
					var mix = weight / currentWeight;
					this._mixBufferRegion( buffer, offset, 0, mix, stride );
	
				}
	
				this.cumulativeWeight = currentWeight;
	
			},
	
			// apply the state of 'accu<i>' to the binding when accus differ
			apply: function ( accuIndex ) {
	
				var stride = this.valueSize,
					buffer = this.buffer,
					offset = accuIndex * stride + stride,
	
					weight = this.cumulativeWeight,
	
					binding = this.binding;
	
				this.cumulativeWeight = 0;
	
				if ( weight < 1 ) {
	
					// accuN := accuN + original * ( 1 - cumulativeWeight )
	
					var originalValueOffset = stride * 3;
	
					this._mixBufferRegion(
						buffer, offset, originalValueOffset, 1 - weight, stride );
	
				}
	
				for ( var i = stride, e = stride + stride; i !== e; ++ i ) {
	
					if ( buffer[ i ] !== buffer[ i + stride ] ) {
	
						// value has changed -> update scene graph
	
						binding.setValue( buffer, offset );
						break;
	
					}
	
				}
	
			},
	
			// remember the state of the bound property and copy it to both accus
			saveOriginalState: function () {
	
				var binding = this.binding;
	
				var buffer = this.buffer,
					stride = this.valueSize,
	
					originalValueOffset = stride * 3;
	
				binding.getValue( buffer, originalValueOffset );
	
				// accu[0..1] := orig -- initially detect changes against the original
				for ( var i = stride, e = originalValueOffset; i !== e; ++ i ) {
	
					buffer[ i ] = buffer[ originalValueOffset + ( i % stride ) ];
	
				}
	
				this.cumulativeWeight = 0;
	
			},
	
			// apply the state previously taken via 'saveOriginalState' to the binding
			restoreOriginalState: function () {
	
				var originalValueOffset = this.valueSize * 3;
				this.binding.setValue( this.buffer, originalValueOffset );
	
			},
	
	
			// mix functions
	
			_select: function ( buffer, dstOffset, srcOffset, t, stride ) {
	
				if ( t >= 0.5 ) {
	
					for ( var i = 0; i !== stride; ++ i ) {
	
						buffer[ dstOffset + i ] = buffer[ srcOffset + i ];
	
					}
	
				}
	
			},
	
			_slerp: function ( buffer, dstOffset, srcOffset, t ) {
	
				Quaternion.slerpFlat( buffer, dstOffset, buffer, dstOffset, buffer, srcOffset, t );
	
			},
	
			_lerp: function ( buffer, dstOffset, srcOffset, t, stride ) {
	
				var s = 1 - t;
	
				for ( var i = 0; i !== stride; ++ i ) {
	
					var j = dstOffset + i;
	
					buffer[ j ] = buffer[ j ] * s + buffer[ srcOffset + i ] * t;
	
				}
	
			}
	
		} );
	
		/**
		 *
		 * A reference to a real property in the scene graph.
		 *
		 *
		 * @author Ben Houston / http://clara.io/
		 * @author David Sarno / http://lighthaus.us/
		 * @author tschw
		 */
	
		function Composite( targetGroup, path, optionalParsedPath ) {
	
			var parsedPath = optionalParsedPath || PropertyBinding.parseTrackName( path );
	
			this._targetGroup = targetGroup;
			this._bindings = targetGroup.subscribe_( path, parsedPath );
	
		}
	
		Object.assign( Composite.prototype, {
	
			getValue: function ( array, offset ) {
	
				this.bind(); // bind all binding
	
				var firstValidIndex = this._targetGroup.nCachedObjects_,
					binding = this._bindings[ firstValidIndex ];
	
				// and only call .getValue on the first
				if ( binding !== undefined ) binding.getValue( array, offset );
	
			},
	
			setValue: function ( array, offset ) {
	
				var bindings = this._bindings;
	
				for ( var i = this._targetGroup.nCachedObjects_,
						  n = bindings.length; i !== n; ++ i ) {
	
					bindings[ i ].setValue( array, offset );
	
				}
	
			},
	
			bind: function () {
	
				var bindings = this._bindings;
	
				for ( var i = this._targetGroup.nCachedObjects_,
						  n = bindings.length; i !== n; ++ i ) {
	
					bindings[ i ].bind();
	
				}
	
			},
	
			unbind: function () {
	
				var bindings = this._bindings;
	
				for ( var i = this._targetGroup.nCachedObjects_,
						  n = bindings.length; i !== n; ++ i ) {
	
					bindings[ i ].unbind();
	
				}
	
			}
	
		} );
	
	
		function PropertyBinding( rootNode, path, parsedPath ) {
	
			this.path = path;
			this.parsedPath = parsedPath || PropertyBinding.parseTrackName( path );
	
			this.node = PropertyBinding.findNode( rootNode, this.parsedPath.nodeName ) || rootNode;
	
			this.rootNode = rootNode;
	
		}
	
		Object.assign( PropertyBinding, {
	
			Composite: Composite,
	
			create: function ( root, path, parsedPath ) {
	
				if ( ! ( root && root.isAnimationObjectGroup ) ) {
	
					return new PropertyBinding( root, path, parsedPath );
	
				} else {
	
					return new PropertyBinding.Composite( root, path, parsedPath );
	
				}
	
			},
	
			/**
			 * Replaces spaces with underscores and removes unsupported characters from
			 * node names, to ensure compatibility with parseTrackName().
			 *
			 * @param  {string} name Node name to be sanitized.
			 * @return {string}
			 */
			sanitizeNodeName: function ( name ) {
	
				return name.replace( /\s/g, '_' ).replace( /[^\w-]/g, '' );
	
			},
	
			parseTrackName: function () {
	
				// Parent directories, delimited by '/' or ':'. Currently unused, but must
				// be matched to parse the rest of the track name.
				var directoryRe = /((?:[\w-]+[\/:])*)/;
	
				// Target node. May contain word characters (a-zA-Z0-9_) and '.' or '-'.
				var nodeRe = /([\w-\.]+)?/;
	
				// Object on target node, and accessor. Name may contain only word
				// characters. Accessor may contain any character except closing bracket.
				var objectRe = /(?:\.([\w-]+)(?:\[(.+)\])?)?/;
	
				// Property and accessor. May contain only word characters. Accessor may
				// contain any non-bracket characters.
				var propertyRe = /\.([\w-]+)(?:\[(.+)\])?/;
	
				var trackRe = new RegExp( ''
					+ '^'
					+ directoryRe.source
					+ nodeRe.source
					+ objectRe.source
					+ propertyRe.source
					+ '$'
				);
	
				var supportedObjectNames = [ 'material', 'materials', 'bones' ];
	
				return function ( trackName ) {
	
					var matches = trackRe.exec( trackName );
	
					if ( ! matches ) {
	
						throw new Error( 'PropertyBinding: Cannot parse trackName: ' + trackName );
	
					}
	
					var results = {
						// directoryName: matches[ 1 ], // (tschw) currently unused
						nodeName: matches[ 2 ],
						objectName: matches[ 3 ],
						objectIndex: matches[ 4 ],
						propertyName: matches[ 5 ], // required
						propertyIndex: matches[ 6 ]
					};
	
					var lastDot = results.nodeName && results.nodeName.lastIndexOf( '.' );
	
					if ( lastDot !== undefined && lastDot !== - 1 ) {
	
						var objectName = results.nodeName.substring( lastDot + 1 );
	
						// Object names must be checked against a whitelist. Otherwise, there
						// is no way to parse 'foo.bar.baz': 'baz' must be a property, but
						// 'bar' could be the objectName, or part of a nodeName (which can
						// include '.' characters).
						if ( supportedObjectNames.indexOf( objectName ) !== - 1 ) {
	
							results.nodeName = results.nodeName.substring( 0, lastDot );
							results.objectName = objectName;
	
						}
	
					}
	
					if ( results.propertyName === null || results.propertyName.length === 0 ) {
	
						throw new Error( 'PropertyBinding: can not parse propertyName from trackName: ' + trackName );
	
					}
	
					return results;
	
				};
	
			}(),
	
			findNode: function ( root, nodeName ) {
	
				if ( ! nodeName || nodeName === "" || nodeName === "root" || nodeName === "." || nodeName === - 1 || nodeName === root.name || nodeName === root.uuid ) {
	
					return root;
	
				}
	
				// search into skeleton bones.
				if ( root.skeleton ) {
	
					var searchSkeleton = function ( skeleton ) {
	
						for ( var i = 0; i < skeleton.bones.length; i ++ ) {
	
							var bone = skeleton.bones[ i ];
	
							if ( bone.name === nodeName ) {
	
								return bone;
	
							}
	
						}
	
						return null;
	
					};
	
					var bone = searchSkeleton( root.skeleton );
	
					if ( bone ) {
	
						return bone;
	
					}
	
				}
	
				// search into node subtree.
				if ( root.children ) {
	
					var searchNodeSubtree = function ( children ) {
	
						for ( var i = 0; i < children.length; i ++ ) {
	
							var childNode = children[ i ];
	
							if ( childNode.name === nodeName || childNode.uuid === nodeName ) {
	
								return childNode;
	
							}
	
							var result = searchNodeSubtree( childNode.children );
	
							if ( result ) return result;
	
						}
	
						return null;
	
					};
	
					var subTreeNode = searchNodeSubtree( root.children );
	
					if ( subTreeNode ) {
	
						return subTreeNode;
	
					}
	
				}
	
				return null;
	
			}
	
		} );
	
		Object.assign( PropertyBinding.prototype, { // prototype, continued
	
			// these are used to "bind" a nonexistent property
			_getValue_unavailable: function () {},
			_setValue_unavailable: function () {},
	
			BindingType: {
				Direct: 0,
				EntireArray: 1,
				ArrayElement: 2,
				HasFromToArray: 3
			},
	
			Versioning: {
				None: 0,
				NeedsUpdate: 1,
				MatrixWorldNeedsUpdate: 2
			},
	
			GetterByBindingType: [
	
				function getValue_direct( buffer, offset ) {
	
					buffer[ offset ] = this.node[ this.propertyName ];
	
				},
	
				function getValue_array( buffer, offset ) {
	
					var source = this.resolvedProperty;
	
					for ( var i = 0, n = source.length; i !== n; ++ i ) {
	
						buffer[ offset ++ ] = source[ i ];
	
					}
	
				},
	
				function getValue_arrayElement( buffer, offset ) {
	
					buffer[ offset ] = this.resolvedProperty[ this.propertyIndex ];
	
				},
	
				function getValue_toArray( buffer, offset ) {
	
					this.resolvedProperty.toArray( buffer, offset );
	
				}
	
			],
	
			SetterByBindingTypeAndVersioning: [
	
				[
					// Direct
	
					function setValue_direct( buffer, offset ) {
	
						this.targetObject[ this.propertyName ] = buffer[ offset ];
	
					},
	
					function setValue_direct_setNeedsUpdate( buffer, offset ) {
	
						this.targetObject[ this.propertyName ] = buffer[ offset ];
						this.targetObject.needsUpdate = true;
	
					},
	
					function setValue_direct_setMatrixWorldNeedsUpdate( buffer, offset ) {
	
						this.targetObject[ this.propertyName ] = buffer[ offset ];
						this.targetObject.matrixWorldNeedsUpdate = true;
	
					}
	
				], [
	
					// EntireArray
	
					function setValue_array( buffer, offset ) {
	
						var dest = this.resolvedProperty;
	
						for ( var i = 0, n = dest.length; i !== n; ++ i ) {
	
							dest[ i ] = buffer[ offset ++ ];
	
						}
	
					},
	
					function setValue_array_setNeedsUpdate( buffer, offset ) {
	
						var dest = this.resolvedProperty;
	
						for ( var i = 0, n = dest.length; i !== n; ++ i ) {
	
							dest[ i ] = buffer[ offset ++ ];
	
						}
	
						this.targetObject.needsUpdate = true;
	
					},
	
					function setValue_array_setMatrixWorldNeedsUpdate( buffer, offset ) {
	
						var dest = this.resolvedProperty;
	
						for ( var i = 0, n = dest.length; i !== n; ++ i ) {
	
							dest[ i ] = buffer[ offset ++ ];
	
						}
	
						this.targetObject.matrixWorldNeedsUpdate = true;
	
					}
	
				], [
	
					// ArrayElement
	
					function setValue_arrayElement( buffer, offset ) {
	
						this.resolvedProperty[ this.propertyIndex ] = buffer[ offset ];
	
					},
	
					function setValue_arrayElement_setNeedsUpdate( buffer, offset ) {
	
						this.resolvedProperty[ this.propertyIndex ] = buffer[ offset ];
						this.targetObject.needsUpdate = true;
	
					},
	
					function setValue_arrayElement_setMatrixWorldNeedsUpdate( buffer, offset ) {
	
						this.resolvedProperty[ this.propertyIndex ] = buffer[ offset ];
						this.targetObject.matrixWorldNeedsUpdate = true;
	
					}
	
				], [
	
					// HasToFromArray
	
					function setValue_fromArray( buffer, offset ) {
	
						this.resolvedProperty.fromArray( buffer, offset );
	
					},
	
					function setValue_fromArray_setNeedsUpdate( buffer, offset ) {
	
						this.resolvedProperty.fromArray( buffer, offset );
						this.targetObject.needsUpdate = true;
	
					},
	
					function setValue_fromArray_setMatrixWorldNeedsUpdate( buffer, offset ) {
	
						this.resolvedProperty.fromArray( buffer, offset );
						this.targetObject.matrixWorldNeedsUpdate = true;
	
					}
	
				]
	
			],
	
			getValue: function getValue_unbound( targetArray, offset ) {
	
				this.bind();
				this.getValue( targetArray, offset );
	
				// Note: This class uses a State pattern on a per-method basis:
				// 'bind' sets 'this.getValue' / 'setValue' and shadows the
				// prototype version of these methods with one that represents
				// the bound state. When the property is not found, the methods
				// become no-ops.
	
			},
	
			setValue: function getValue_unbound( sourceArray, offset ) {
	
				this.bind();
				this.setValue( sourceArray, offset );
	
			},
	
			// create getter / setter pair for a property in the scene graph
			bind: function () {
	
				var targetObject = this.node,
					parsedPath = this.parsedPath,
	
					objectName = parsedPath.objectName,
					propertyName = parsedPath.propertyName,
					propertyIndex = parsedPath.propertyIndex;
	
				if ( ! targetObject ) {
	
					targetObject = PropertyBinding.findNode( this.rootNode, parsedPath.nodeName ) || this.rootNode;
	
					this.node = targetObject;
	
				}
	
				// set fail state so we can just 'return' on error
				this.getValue = this._getValue_unavailable;
				this.setValue = this._setValue_unavailable;
	
				// ensure there is a value node
				if ( ! targetObject ) {
	
					console.error( 'THREE.PropertyBinding: Trying to update node for track: ' + this.path + ' but it wasn\'t found.' );
					return;
	
				}
	
				if ( objectName ) {
	
					var objectIndex = parsedPath.objectIndex;
	
					// special cases were we need to reach deeper into the hierarchy to get the face materials....
					switch ( objectName ) {
	
						case 'materials':
	
							if ( ! targetObject.material ) {
	
								console.error( 'THREE.PropertyBinding: Can not bind to material as node does not have a material.', this );
								return;
	
							}
	
							if ( ! targetObject.material.materials ) {
	
								console.error( 'THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.', this );
								return;
	
							}
	
							targetObject = targetObject.material.materials;
	
							break;
	
						case 'bones':
	
							if ( ! targetObject.skeleton ) {
	
								console.error( 'THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.', this );
								return;
	
							}
	
							// potential future optimization: skip this if propertyIndex is already an integer
							// and convert the integer string to a true integer.
	
							targetObject = targetObject.skeleton.bones;
	
							// support resolving morphTarget names into indices.
							for ( var i = 0; i < targetObject.length; i ++ ) {
	
								if ( targetObject[ i ].name === objectIndex ) {
	
									objectIndex = i;
									break;
	
								}
	
							}
	
							break;
	
						default:
	
							if ( targetObject[ objectName ] === undefined ) {
	
								console.error( 'THREE.PropertyBinding: Can not bind to objectName of node undefined.', this );
								return;
	
							}
	
							targetObject = targetObject[ objectName ];
	
					}
	
	
					if ( objectIndex !== undefined ) {
	
						if ( targetObject[ objectIndex ] === undefined ) {
	
							console.error( 'THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.', this, targetObject );
							return;
	
						}
	
						targetObject = targetObject[ objectIndex ];
	
					}
	
				}
	
				// resolve property
				var nodeProperty = targetObject[ propertyName ];
	
				if ( nodeProperty === undefined ) {
	
					var nodeName = parsedPath.nodeName;
	
					console.error( 'THREE.PropertyBinding: Trying to update property for track: ' + nodeName +
						'.' + propertyName + ' but it wasn\'t found.', targetObject );
					return;
	
				}
	
				// determine versioning scheme
				var versioning = this.Versioning.None;
	
				if ( targetObject.needsUpdate !== undefined ) { // material
	
					versioning = this.Versioning.NeedsUpdate;
					this.targetObject = targetObject;
	
				} else if ( targetObject.matrixWorldNeedsUpdate !== undefined ) { // node transform
	
					versioning = this.Versioning.MatrixWorldNeedsUpdate;
					this.targetObject = targetObject;
	
				}
	
				// determine how the property gets bound
				var bindingType = this.BindingType.Direct;
	
				if ( propertyIndex !== undefined ) {
	
					// access a sub element of the property array (only primitives are supported right now)
	
					if ( propertyName === "morphTargetInfluences" ) {
	
						// potential optimization, skip this if propertyIndex is already an integer, and convert the integer string to a true integer.
	
						// support resolving morphTarget names into indices.
						if ( ! targetObject.geometry ) {
	
							console.error( 'THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.', this );
							return;
	
						}
	
						if ( targetObject.geometry.isBufferGeometry ) {
	
							if ( ! targetObject.geometry.morphAttributes ) {
	
								console.error( 'THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.', this );
								return;
	
							}
	
							for ( var i = 0; i < this.node.geometry.morphAttributes.position.length; i ++ ) {
	
								if ( targetObject.geometry.morphAttributes.position[ i ].name === propertyIndex ) {
	
									propertyIndex = i;
									break;
	
								}
	
							}
	
	
						} else {
	
							if ( ! targetObject.geometry.morphTargets ) {
	
								console.error( 'THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphTargets.', this );
								return;
	
							}
	
							for ( var i = 0; i < this.node.geometry.morphTargets.length; i ++ ) {
	
								if ( targetObject.geometry.morphTargets[ i ].name === propertyIndex ) {
	
									propertyIndex = i;
									break;
	
								}
	
							}
	
						}
	
					}
	
					bindingType = this.BindingType.ArrayElement;
	
					this.resolvedProperty = nodeProperty;
					this.propertyIndex = propertyIndex;
	
				} else if ( nodeProperty.fromArray !== undefined && nodeProperty.toArray !== undefined ) {
	
					// must use copy for Object3D.Euler/Quaternion
	
					bindingType = this.BindingType.HasFromToArray;
	
					this.resolvedProperty = nodeProperty;
	
				} else if ( Array.isArray( nodeProperty ) ) {
	
					bindingType = this.BindingType.EntireArray;
	
					this.resolvedProperty = nodeProperty;
	
				} else {
	
					this.propertyName = propertyName;
	
				}
	
				// select getter / setter
				this.getValue = this.GetterByBindingType[ bindingType ];
				this.setValue = this.SetterByBindingTypeAndVersioning[ bindingType ][ versioning ];
	
			},
	
			unbind: function () {
	
				this.node = null;
	
				// back to the prototype version of getValue / setValue
				// note: avoiding to mutate the shape of 'this' via 'delete'
				this.getValue = this._getValue_unbound;
				this.setValue = this._setValue_unbound;
	
			}
	
		} );
	
		//!\ DECLARE ALIAS AFTER assign prototype !
		Object.assign( PropertyBinding.prototype, {
	
			// initial state of these methods that calls 'bind'
			_getValue_unbound: PropertyBinding.prototype.getValue,
			_setValue_unbound: PropertyBinding.prototype.setValue,
	
		} );
	
		/**
		 *
		 * A group of objects that receives a shared animation state.
		 *
		 * Usage:
		 *
		 * 	-	Add objects you would otherwise pass as 'root' to the
		 * 		constructor or the .clipAction method of AnimationMixer.
		 *
		 * 	-	Instead pass this object as 'root'.
		 *
		 * 	-	You can also add and remove objects later when the mixer
		 * 		is running.
		 *
		 * Note:
		 *
		 *  	Objects of this class appear as one object to the mixer,
		 *  	so cache control of the individual objects must be done
		 *  	on the group.
		 *
		 * Limitation:
		 *
		 * 	- 	The animated properties must be compatible among the
		 * 		all objects in the group.
		 *
		 *  -	A single property can either be controlled through a
		 *  	target group or directly, but not both.
		 *
		 * @author tschw
		 */
	
		function AnimationObjectGroup() {
	
			this.uuid = _Math.generateUUID();
	
			// cached objects followed by the active ones
			this._objects = Array.prototype.slice.call( arguments );
	
			this.nCachedObjects_ = 0;			// threshold
			// note: read by PropertyBinding.Composite
	
			var indices = {};
			this._indicesByUUID = indices;		// for bookkeeping
	
			for ( var i = 0, n = arguments.length; i !== n; ++ i ) {
	
				indices[ arguments[ i ].uuid ] = i;
	
			}
	
			this._paths = [];					// inside: string
			this._parsedPaths = [];				// inside: { we don't care, here }
			this._bindings = []; 				// inside: Array< PropertyBinding >
			this._bindingsIndicesByPath = {}; 	// inside: indices in these arrays
	
			var scope = this;
	
			this.stats = {
	
				objects: {
					get total() {
	
						return scope._objects.length;
	
					},
					get inUse() {
	
						return this.total - scope.nCachedObjects_;
	
					}
				},
				get bindingsPerObject() {
	
					return scope._bindings.length;
	
				}
	
			};
	
		}
	
		Object.assign( AnimationObjectGroup.prototype, {
	
			isAnimationObjectGroup: true,
	
			add: function () {
	
				var objects = this._objects,
					nObjects = objects.length,
					nCachedObjects = this.nCachedObjects_,
					indicesByUUID = this._indicesByUUID,
					paths = this._paths,
					parsedPaths = this._parsedPaths,
					bindings = this._bindings,
					nBindings = bindings.length;
	
				for ( var i = 0, n = arguments.length; i !== n; ++ i ) {
	
					var object = arguments[ i ],
						uuid = object.uuid,
						index = indicesByUUID[ uuid ],
						knownObject = undefined;
	
					if ( index === undefined ) {
	
						// unknown object -> add it to the ACTIVE region
	
						index = nObjects ++;
						indicesByUUID[ uuid ] = index;
						objects.push( object );
	
						// accounting is done, now do the same for all bindings
	
						for ( var j = 0, m = nBindings; j !== m; ++ j ) {
	
							bindings[ j ].push( new PropertyBinding( object, paths[ j ], parsedPaths[ j ] ) );
	
						}
	
					} else if ( index < nCachedObjects ) {
	
						knownObject = objects[ index ];
	
						// move existing object to the ACTIVE region
	
						var firstActiveIndex = -- nCachedObjects,
							lastCachedObject = objects[ firstActiveIndex ];
	
						indicesByUUID[ lastCachedObject.uuid ] = index;
						objects[ index ] = lastCachedObject;
	
						indicesByUUID[ uuid ] = firstActiveIndex;
						objects[ firstActiveIndex ] = object;
	
						// accounting is done, now do the same for all bindings
	
						for ( var j = 0, m = nBindings; j !== m; ++ j ) {
	
							var bindingsForPath = bindings[ j ],
								lastCached = bindingsForPath[ firstActiveIndex ],
								binding = bindingsForPath[ index ];
	
							bindingsForPath[ index ] = lastCached;
	
							if ( binding === undefined ) {
	
								// since we do not bother to create new bindings
								// for objects that are cached, the binding may
								// or may not exist
	
								binding = new PropertyBinding( object, paths[ j ], parsedPaths[ j ] );
	
							}
	
							bindingsForPath[ firstActiveIndex ] = binding;
	
						}
	
					} else if ( objects[ index ] !== knownObject ) {
	
						console.error( 'THREE.AnimationObjectGroup: Different objects with the same UUID ' +
								'detected. Clean the caches or recreate your infrastructure when reloading scenes.' );
	
					} // else the object is already where we want it to be
	
				} // for arguments
	
				this.nCachedObjects_ = nCachedObjects;
	
			},
	
			remove: function () {
	
				var objects = this._objects,
					nCachedObjects = this.nCachedObjects_,
					indicesByUUID = this._indicesByUUID,
					bindings = this._bindings,
					nBindings = bindings.length;
	
				for ( var i = 0, n = arguments.length; i !== n; ++ i ) {
	
					var object = arguments[ i ],
						uuid = object.uuid,
						index = indicesByUUID[ uuid ];
	
					if ( index !== undefined && index >= nCachedObjects ) {
	
						// move existing object into the CACHED region
	
						var lastCachedIndex = nCachedObjects ++,
							firstActiveObject = objects[ lastCachedIndex ];
	
						indicesByUUID[ firstActiveObject.uuid ] = index;
						objects[ index ] = firstActiveObject;
	
						indicesByUUID[ uuid ] = lastCachedIndex;
						objects[ lastCachedIndex ] = object;
	
						// accounting is done, now do the same for all bindings
	
						for ( var j = 0, m = nBindings; j !== m; ++ j ) {
	
							var bindingsForPath = bindings[ j ],
								firstActive = bindingsForPath[ lastCachedIndex ],
								binding = bindingsForPath[ index ];
	
							bindingsForPath[ index ] = firstActive;
							bindingsForPath[ lastCachedIndex ] = binding;
	
						}
	
					}
	
				} // for arguments
	
				this.nCachedObjects_ = nCachedObjects;
	
			},
	
			// remove & forget
			uncache: function () {
	
				var objects = this._objects,
					nObjects = objects.length,
					nCachedObjects = this.nCachedObjects_,
					indicesByUUID = this._indicesByUUID,
					bindings = this._bindings,
					nBindings = bindings.length;
	
				for ( var i = 0, n = arguments.length; i !== n; ++ i ) {
	
					var object = arguments[ i ],
						uuid = object.uuid,
						index = indicesByUUID[ uuid ];
	
					if ( index !== undefined ) {
	
						delete indicesByUUID[ uuid ];
	
						if ( index < nCachedObjects ) {
	
							// object is cached, shrink the CACHED region
	
							var firstActiveIndex = -- nCachedObjects,
								lastCachedObject = objects[ firstActiveIndex ],
								lastIndex = -- nObjects,
								lastObject = objects[ lastIndex ];
	
							// last cached object takes this object's place
							indicesByUUID[ lastCachedObject.uuid ] = index;
							objects[ index ] = lastCachedObject;
	
							// last object goes to the activated slot and pop
							indicesByUUID[ lastObject.uuid ] = firstActiveIndex;
							objects[ firstActiveIndex ] = lastObject;
							objects.pop();
	
							// accounting is done, now do the same for all bindings
	
							for ( var j = 0, m = nBindings; j !== m; ++ j ) {
	
								var bindingsForPath = bindings[ j ],
									lastCached = bindingsForPath[ firstActiveIndex ],
									last = bindingsForPath[ lastIndex ];
	
								bindingsForPath[ index ] = lastCached;
								bindingsForPath[ firstActiveIndex ] = last;
								bindingsForPath.pop();
	
							}
	
						} else {
	
							// object is active, just swap with the last and pop
	
							var lastIndex = -- nObjects,
								lastObject = objects[ lastIndex ];
	
							indicesByUUID[ lastObject.uuid ] = index;
							objects[ index ] = lastObject;
							objects.pop();
	
							// accounting is done, now do the same for all bindings
	
							for ( var j = 0, m = nBindings; j !== m; ++ j ) {
	
								var bindingsForPath = bindings[ j ];
	
								bindingsForPath[ index ] = bindingsForPath[ lastIndex ];
								bindingsForPath.pop();
	
							}
	
						} // cached or active
	
					} // if object is known
	
				} // for arguments
	
				this.nCachedObjects_ = nCachedObjects;
	
			},
	
			// Internal interface used by befriended PropertyBinding.Composite:
	
			subscribe_: function ( path, parsedPath ) {
	
				// returns an array of bindings for the given path that is changed
				// according to the contained objects in the group
	
				var indicesByPath = this._bindingsIndicesByPath,
					index = indicesByPath[ path ],
					bindings = this._bindings;
	
				if ( index !== undefined ) return bindings[ index ];
	
				var paths = this._paths,
					parsedPaths = this._parsedPaths,
					objects = this._objects,
					nObjects = objects.length,
					nCachedObjects = this.nCachedObjects_,
					bindingsForPath = new Array( nObjects );
	
				index = bindings.length;
	
				indicesByPath[ path ] = index;
	
				paths.push( path );
				parsedPaths.push( parsedPath );
				bindings.push( bindingsForPath );
	
				for ( var i = nCachedObjects, n = objects.length; i !== n; ++ i ) {
	
					var object = objects[ i ];
					bindingsForPath[ i ] = new PropertyBinding( object, path, parsedPath );
	
				}
	
				return bindingsForPath;
	
			},
	
			unsubscribe_: function ( path ) {
	
				// tells the group to forget about a property path and no longer
				// update the array previously obtained with 'subscribe_'
	
				var indicesByPath = this._bindingsIndicesByPath,
					index = indicesByPath[ path ];
	
				if ( index !== undefined ) {
	
					var paths = this._paths,
						parsedPaths = this._parsedPaths,
						bindings = this._bindings,
						lastBindingsIndex = bindings.length - 1,
						lastBindings = bindings[ lastBindingsIndex ],
						lastBindingsPath = path[ lastBindingsIndex ];
	
					indicesByPath[ lastBindingsPath ] = index;
	
					bindings[ index ] = lastBindings;
					bindings.pop();
	
					parsedPaths[ index ] = parsedPaths[ lastBindingsIndex ];
					parsedPaths.pop();
	
					paths[ index ] = paths[ lastBindingsIndex ];
					paths.pop();
	
				}
	
			}
	
		} );
	
		/**
		 *
		 * Action provided by AnimationMixer for scheduling clip playback on specific
		 * objects.
		 *
		 * @author Ben Houston / http://clara.io/
		 * @author David Sarno / http://lighthaus.us/
		 * @author tschw
		 *
		 */
	
		function AnimationAction( mixer, clip, localRoot ) {
	
			this._mixer = mixer;
			this._clip = clip;
			this._localRoot = localRoot || null;
	
			var tracks = clip.tracks,
				nTracks = tracks.length,
				interpolants = new Array( nTracks );
	
			var interpolantSettings = {
				endingStart: ZeroCurvatureEnding,
				endingEnd: ZeroCurvatureEnding
			};
	
			for ( var i = 0; i !== nTracks; ++ i ) {
	
				var interpolant = tracks[ i ].createInterpolant( null );
				interpolants[ i ] = interpolant;
				interpolant.settings = interpolantSettings;
	
			}
	
			this._interpolantSettings = interpolantSettings;
	
			this._interpolants = interpolants;	// bound by the mixer
	
			// inside: PropertyMixer (managed by the mixer)
			this._propertyBindings = new Array( nTracks );
	
			this._cacheIndex = null;			// for the memory manager
			this._byClipCacheIndex = null;		// for the memory manager
	
			this._timeScaleInterpolant = null;
			this._weightInterpolant = null;
	
			this.loop = LoopRepeat;
			this._loopCount = - 1;
	
			// global mixer time when the action is to be started
			// it's set back to 'null' upon start of the action
			this._startTime = null;
	
			// scaled local time of the action
			// gets clamped or wrapped to 0..clip.duration according to loop
			this.time = 0;
	
			this.timeScale = 1;
			this._effectiveTimeScale = 1;
	
			this.weight = 1;
			this._effectiveWeight = 1;
	
			this.repetitions = Infinity; 		// no. of repetitions when looping
	
			this.paused = false;				// true -> zero effective time scale
			this.enabled = true;				// false -> zero effective weight
	
			this.clampWhenFinished 	= false;	// keep feeding the last frame?
	
			this.zeroSlopeAtStart 	= true;		// for smooth interpolation w/o separate
			this.zeroSlopeAtEnd		= true;		// clips for start, loop and end
	
		}
	
		Object.assign( AnimationAction.prototype, {
	
			// State & Scheduling
	
			play: function () {
	
				this._mixer._activateAction( this );
	
				return this;
	
			},
	
			stop: function () {
	
				this._mixer._deactivateAction( this );
	
				return this.reset();
	
			},
	
			reset: function () {
	
				this.paused = false;
				this.enabled = true;
	
				this.time = 0;			// restart clip
				this._loopCount = - 1;	// forget previous loops
				this._startTime = null;	// forget scheduling
	
				return this.stopFading().stopWarping();
	
			},
	
			isRunning: function () {
	
				return this.enabled && ! this.paused && this.timeScale !== 0 &&
						this._startTime === null && this._mixer._isActiveAction( this );
	
			},
	
			// return true when play has been called
			isScheduled: function () {
	
				return this._mixer._isActiveAction( this );
	
			},
	
			startAt: function ( time ) {
	
				this._startTime = time;
	
				return this;
	
			},
	
			setLoop: function ( mode, repetitions ) {
	
				this.loop = mode;
				this.repetitions = repetitions;
	
				return this;
	
			},
	
			// Weight
	
			// set the weight stopping any scheduled fading
			// although .enabled = false yields an effective weight of zero, this
			// method does *not* change .enabled, because it would be confusing
			setEffectiveWeight: function ( weight ) {
	
				this.weight = weight;
	
				// note: same logic as when updated at runtime
				this._effectiveWeight = this.enabled ? weight : 0;
	
				return this.stopFading();
	
			},
	
			// return the weight considering fading and .enabled
			getEffectiveWeight: function () {
	
				return this._effectiveWeight;
	
			},
	
			fadeIn: function ( duration ) {
	
				return this._scheduleFading( duration, 0, 1 );
	
			},
	
			fadeOut: function ( duration ) {
	
				return this._scheduleFading( duration, 1, 0 );
	
			},
	
			crossFadeFrom: function ( fadeOutAction, duration, warp ) {
	
				fadeOutAction.fadeOut( duration );
				this.fadeIn( duration );
	
				if ( warp ) {
	
					var fadeInDuration = this._clip.duration,
						fadeOutDuration = fadeOutAction._clip.duration,
	
						startEndRatio = fadeOutDuration / fadeInDuration,
						endStartRatio = fadeInDuration / fadeOutDuration;
	
					fadeOutAction.warp( 1.0, startEndRatio, duration );
					this.warp( endStartRatio, 1.0, duration );
	
				}
	
				return this;
	
			},
	
			crossFadeTo: function ( fadeInAction, duration, warp ) {
	
				return fadeInAction.crossFadeFrom( this, duration, warp );
	
			},
	
			stopFading: function () {
	
				var weightInterpolant = this._weightInterpolant;
	
				if ( weightInterpolant !== null ) {
	
					this._weightInterpolant = null;
					this._mixer._takeBackControlInterpolant( weightInterpolant );
	
				}
	
				return this;
	
			},
	
			// Time Scale Control
	
			// set the time scale stopping any scheduled warping
			// although .paused = true yields an effective time scale of zero, this
			// method does *not* change .paused, because it would be confusing
			setEffectiveTimeScale: function ( timeScale ) {
	
				this.timeScale = timeScale;
				this._effectiveTimeScale = this.paused ? 0 : timeScale;
	
				return this.stopWarping();
	
			},
	
			// return the time scale considering warping and .paused
			getEffectiveTimeScale: function () {
	
				return this._effectiveTimeScale;
	
			},
	
			setDuration: function ( duration ) {
	
				this.timeScale = this._clip.duration / duration;
	
				return this.stopWarping();
	
			},
	
			syncWith: function ( action ) {
	
				this.time = action.time;
				this.timeScale = action.timeScale;
	
				return this.stopWarping();
	
			},
	
			halt: function ( duration ) {
	
				return this.warp( this._effectiveTimeScale, 0, duration );
	
			},
	
			warp: function ( startTimeScale, endTimeScale, duration ) {
	
				var mixer = this._mixer, now = mixer.time,
					interpolant = this._timeScaleInterpolant,
	
					timeScale = this.timeScale;
	
				if ( interpolant === null ) {
	
					interpolant = mixer._lendControlInterpolant();
					this._timeScaleInterpolant = interpolant;
	
				}
	
				var times = interpolant.parameterPositions,
					values = interpolant.sampleValues;
	
				times[ 0 ] = now;
				times[ 1 ] = now + duration;
	
				values[ 0 ] = startTimeScale / timeScale;
				values[ 1 ] = endTimeScale / timeScale;
	
				return this;
	
			},
	
			stopWarping: function () {
	
				var timeScaleInterpolant = this._timeScaleInterpolant;
	
				if ( timeScaleInterpolant !== null ) {
	
					this._timeScaleInterpolant = null;
					this._mixer._takeBackControlInterpolant( timeScaleInterpolant );
	
				}
	
				return this;
	
			},
	
			// Object Accessors
	
			getMixer: function () {
	
				return this._mixer;
	
			},
	
			getClip: function () {
	
				return this._clip;
	
			},
	
			getRoot: function () {
	
				return this._localRoot || this._mixer._root;
	
			},
	
			// Interna
	
			_update: function ( time, deltaTime, timeDirection, accuIndex ) {
	
				// called by the mixer
	
				if ( ! this.enabled ) {
	
					// call ._updateWeight() to update ._effectiveWeight
	
					this._updateWeight( time );
					return;
	
				}
	
				var startTime = this._startTime;
	
				if ( startTime !== null ) {
	
					// check for scheduled start of action
	
					var timeRunning = ( time - startTime ) * timeDirection;
					if ( timeRunning < 0 || timeDirection === 0 ) {
	
						return; // yet to come / don't decide when delta = 0
	
					}
	
					// start
	
					this._startTime = null; // unschedule
					deltaTime = timeDirection * timeRunning;
	
				}
	
				// apply time scale and advance time
	
				deltaTime *= this._updateTimeScale( time );
				var clipTime = this._updateTime( deltaTime );
	
				// note: _updateTime may disable the action resulting in
				// an effective weight of 0
	
				var weight = this._updateWeight( time );
	
				if ( weight > 0 ) {
	
					var interpolants = this._interpolants;
					var propertyMixers = this._propertyBindings;
	
					for ( var j = 0, m = interpolants.length; j !== m; ++ j ) {
	
						interpolants[ j ].evaluate( clipTime );
						propertyMixers[ j ].accumulate( accuIndex, weight );
	
					}
	
				}
	
			},
	
			_updateWeight: function ( time ) {
	
				var weight = 0;
	
				if ( this.enabled ) {
	
					weight = this.weight;
					var interpolant = this._weightInterpolant;
	
					if ( interpolant !== null ) {
	
						var interpolantValue = interpolant.evaluate( time )[ 0 ];
	
						weight *= interpolantValue;
	
						if ( time > interpolant.parameterPositions[ 1 ] ) {
	
							this.stopFading();
	
							if ( interpolantValue === 0 ) {
	
								// faded out, disable
								this.enabled = false;
	
							}
	
						}
	
					}
	
				}
	
				this._effectiveWeight = weight;
				return weight;
	
			},
	
			_updateTimeScale: function ( time ) {
	
				var timeScale = 0;
	
				if ( ! this.paused ) {
	
					timeScale = this.timeScale;
	
					var interpolant = this._timeScaleInterpolant;
	
					if ( interpolant !== null ) {
	
						var interpolantValue = interpolant.evaluate( time )[ 0 ];
	
						timeScale *= interpolantValue;
	
						if ( time > interpolant.parameterPositions[ 1 ] ) {
	
							this.stopWarping();
	
							if ( timeScale === 0 ) {
	
								// motion has halted, pause
								this.paused = true;
	
							} else {
	
								// warp done - apply final time scale
								this.timeScale = timeScale;
	
							}
	
						}
	
					}
	
				}
	
				this._effectiveTimeScale = timeScale;
				return timeScale;
	
			},
	
			_updateTime: function ( deltaTime ) {
	
				var time = this.time + deltaTime;
	
				if ( deltaTime === 0 ) return time;
	
				var duration = this._clip.duration,
	
					loop = this.loop,
					loopCount = this._loopCount;
	
				if ( loop === LoopOnce ) {
	
					if ( loopCount === - 1 ) {
	
						// just started
	
						this._loopCount = 0;
						this._setEndings( true, true, false );
	
					}
	
					handle_stop: {
	
						if ( time >= duration ) {
	
							time = duration;
	
						} else if ( time < 0 ) {
	
							time = 0;
	
						} else break handle_stop;
	
						if ( this.clampWhenFinished ) this.paused = true;
						else this.enabled = false;
	
						this._mixer.dispatchEvent( {
							type: 'finished', action: this,
							direction: deltaTime < 0 ? - 1 : 1
						} );
	
					}
	
				} else { // repetitive Repeat or PingPong
	
					var pingPong = ( loop === LoopPingPong );
	
					if ( loopCount === - 1 ) {
	
						// just started
	
						if ( deltaTime >= 0 ) {
	
							loopCount = 0;
	
							this._setEndings( true, this.repetitions === 0, pingPong );
	
						} else {
	
							// when looping in reverse direction, the initial
							// transition through zero counts as a repetition,
							// so leave loopCount at -1
	
							this._setEndings( this.repetitions === 0, true, pingPong );
	
						}
	
					}
	
					if ( time >= duration || time < 0 ) {
	
						// wrap around
	
						var loopDelta = Math.floor( time / duration ); // signed
						time -= duration * loopDelta;
	
						loopCount += Math.abs( loopDelta );
	
						var pending = this.repetitions - loopCount;
	
						if ( pending < 0 ) {
	
							// have to stop (switch state, clamp time, fire event)
	
							if ( this.clampWhenFinished ) this.paused = true;
							else this.enabled = false;
	
							time = deltaTime > 0 ? duration : 0;
	
							this._mixer.dispatchEvent( {
								type: 'finished', action: this,
								direction: deltaTime > 0 ? 1 : - 1
							} );
	
						} else {
	
							// keep running
	
							if ( pending === 0 ) {
	
								// entering the last round
	
								var atStart = deltaTime < 0;
								this._setEndings( atStart, ! atStart, pingPong );
	
							} else {
	
								this._setEndings( false, false, pingPong );
	
							}
	
							this._loopCount = loopCount;
	
							this._mixer.dispatchEvent( {
								type: 'loop', action: this, loopDelta: loopDelta
							} );
	
						}
	
					}
	
					if ( pingPong && ( loopCount & 1 ) === 1 ) {
	
						// invert time for the "pong round"
	
						this.time = time;
						return duration - time;
	
					}
	
				}
	
				this.time = time;
				return time;
	
			},
	
			_setEndings: function ( atStart, atEnd, pingPong ) {
	
				var settings = this._interpolantSettings;
	
				if ( pingPong ) {
	
					settings.endingStart 	= ZeroSlopeEnding;
					settings.endingEnd		= ZeroSlopeEnding;
	
				} else {
	
					// assuming for LoopOnce atStart == atEnd == true
	
					if ( atStart ) {
	
						settings.endingStart = this.zeroSlopeAtStart ? ZeroSlopeEnding : ZeroCurvatureEnding;
	
					} else {
	
						settings.endingStart = WrapAroundEnding;
	
					}
	
					if ( atEnd ) {
	
						settings.endingEnd = this.zeroSlopeAtEnd ? ZeroSlopeEnding : ZeroCurvatureEnding;
	
					} else {
	
						settings.endingEnd 	 = WrapAroundEnding;
	
					}
	
				}
	
			},
	
			_scheduleFading: function ( duration, weightNow, weightThen ) {
	
				var mixer = this._mixer, now = mixer.time,
					interpolant = this._weightInterpolant;
	
				if ( interpolant === null ) {
	
					interpolant = mixer._lendControlInterpolant();
					this._weightInterpolant = interpolant;
	
				}
	
				var times = interpolant.parameterPositions,
					values = interpolant.sampleValues;
	
				times[ 0 ] = now; 				values[ 0 ] = weightNow;
				times[ 1 ] = now + duration;	values[ 1 ] = weightThen;
	
				return this;
	
			}
	
		} );
	
		/**
		 *
		 * Player for AnimationClips.
		 *
		 *
		 * @author Ben Houston / http://clara.io/
		 * @author David Sarno / http://lighthaus.us/
		 * @author tschw
		 */
	
		function AnimationMixer( root ) {
	
			this._root = root;
			this._initMemoryManager();
			this._accuIndex = 0;
	
			this.time = 0;
	
			this.timeScale = 1.0;
	
		}
	
		AnimationMixer.prototype = Object.assign( Object.create( EventDispatcher.prototype ), {
	
			constructor: AnimationMixer,
	
			_bindAction: function ( action, prototypeAction ) {
	
				var root = action._localRoot || this._root,
					tracks = action._clip.tracks,
					nTracks = tracks.length,
					bindings = action._propertyBindings,
					interpolants = action._interpolants,
					rootUuid = root.uuid,
					bindingsByRoot = this._bindingsByRootAndName,
					bindingsByName = bindingsByRoot[ rootUuid ];
	
				if ( bindingsByName === undefined ) {
	
					bindingsByName = {};
					bindingsByRoot[ rootUuid ] = bindingsByName;
	
				}
	
				for ( var i = 0; i !== nTracks; ++ i ) {
	
					var track = tracks[ i ],
						trackName = track.name,
						binding = bindingsByName[ trackName ];
	
					if ( binding !== undefined ) {
	
						bindings[ i ] = binding;
	
					} else {
	
						binding = bindings[ i ];
	
						if ( binding !== undefined ) {
	
							// existing binding, make sure the cache knows
	
							if ( binding._cacheIndex === null ) {
	
								++ binding.referenceCount;
								this._addInactiveBinding( binding, rootUuid, trackName );
	
							}
	
							continue;
	
						}
	
						var path = prototypeAction && prototypeAction.
							_propertyBindings[ i ].binding.parsedPath;
	
						binding = new PropertyMixer(
							PropertyBinding.create( root, trackName, path ),
							track.ValueTypeName, track.getValueSize() );
	
						++ binding.referenceCount;
						this._addInactiveBinding( binding, rootUuid, trackName );
	
						bindings[ i ] = binding;
	
					}
	
					interpolants[ i ].resultBuffer = binding.buffer;
	
				}
	
			},
	
			_activateAction: function ( action ) {
	
				if ( ! this._isActiveAction( action ) ) {
	
					if ( action._cacheIndex === null ) {
	
						// this action has been forgotten by the cache, but the user
						// appears to be still using it -> rebind
	
						var rootUuid = ( action._localRoot || this._root ).uuid,
							clipUuid = action._clip.uuid,
							actionsForClip = this._actionsByClip[ clipUuid ];
	
						this._bindAction( action,
							actionsForClip && actionsForClip.knownActions[ 0 ] );
	
						this._addInactiveAction( action, clipUuid, rootUuid );
	
					}
	
					var bindings = action._propertyBindings;
	
					// increment reference counts / sort out state
					for ( var i = 0, n = bindings.length; i !== n; ++ i ) {
	
						var binding = bindings[ i ];
	
						if ( binding.useCount ++ === 0 ) {
	
							this._lendBinding( binding );
							binding.saveOriginalState();
	
						}
	
					}
	
					this._lendAction( action );
	
				}
	
			},
	
			_deactivateAction: function ( action ) {
	
				if ( this._isActiveAction( action ) ) {
	
					var bindings = action._propertyBindings;
	
					// decrement reference counts / sort out state
					for ( var i = 0, n = bindings.length; i !== n; ++ i ) {
	
						var binding = bindings[ i ];
	
						if ( -- binding.useCount === 0 ) {
	
							binding.restoreOriginalState();
							this._takeBackBinding( binding );
	
						}
	
					}
	
					this._takeBackAction( action );
	
				}
	
			},
	
			// Memory manager
	
			_initMemoryManager: function () {
	
				this._actions = []; // 'nActiveActions' followed by inactive ones
				this._nActiveActions = 0;
	
				this._actionsByClip = {};
				// inside:
				// {
				// 		knownActions: Array< AnimationAction >	- used as prototypes
				// 		actionByRoot: AnimationAction			- lookup
				// }
	
	
				this._bindings = []; // 'nActiveBindings' followed by inactive ones
				this._nActiveBindings = 0;
	
				this._bindingsByRootAndName = {}; // inside: Map< name, PropertyMixer >
	
	
				this._controlInterpolants = []; // same game as above
				this._nActiveControlInterpolants = 0;
	
				var scope = this;
	
				this.stats = {
	
					actions: {
						get total() {
	
							return scope._actions.length;
	
						},
						get inUse() {
	
							return scope._nActiveActions;
	
						}
					},
					bindings: {
						get total() {
	
							return scope._bindings.length;
	
						},
						get inUse() {
	
							return scope._nActiveBindings;
	
						}
					},
					controlInterpolants: {
						get total() {
	
							return scope._controlInterpolants.length;
	
						},
						get inUse() {
	
							return scope._nActiveControlInterpolants;
	
						}
					}
	
				};
	
			},
	
			// Memory management for AnimationAction objects
	
			_isActiveAction: function ( action ) {
	
				var index = action._cacheIndex;
				return index !== null && index < this._nActiveActions;
	
			},
	
			_addInactiveAction: function ( action, clipUuid, rootUuid ) {
	
				var actions = this._actions,
					actionsByClip = this._actionsByClip,
					actionsForClip = actionsByClip[ clipUuid ];
	
				if ( actionsForClip === undefined ) {
	
					actionsForClip = {
	
						knownActions: [ action ],
						actionByRoot: {}
	
					};
	
					action._byClipCacheIndex = 0;
	
					actionsByClip[ clipUuid ] = actionsForClip;
	
				} else {
	
					var knownActions = actionsForClip.knownActions;
	
					action._byClipCacheIndex = knownActions.length;
					knownActions.push( action );
	
				}
	
				action._cacheIndex = actions.length;
				actions.push( action );
	
				actionsForClip.actionByRoot[ rootUuid ] = action;
	
			},
	
			_removeInactiveAction: function ( action ) {
	
				var actions = this._actions,
					lastInactiveAction = actions[ actions.length - 1 ],
					cacheIndex = action._cacheIndex;
	
				lastInactiveAction._cacheIndex = cacheIndex;
				actions[ cacheIndex ] = lastInactiveAction;
				actions.pop();
	
				action._cacheIndex = null;
	
	
				var clipUuid = action._clip.uuid,
					actionsByClip = this._actionsByClip,
					actionsForClip = actionsByClip[ clipUuid ],
					knownActionsForClip = actionsForClip.knownActions,
	
					lastKnownAction =
						knownActionsForClip[ knownActionsForClip.length - 1 ],
	
					byClipCacheIndex = action._byClipCacheIndex;
	
				lastKnownAction._byClipCacheIndex = byClipCacheIndex;
				knownActionsForClip[ byClipCacheIndex ] = lastKnownAction;
				knownActionsForClip.pop();
	
				action._byClipCacheIndex = null;
	
	
				var actionByRoot = actionsForClip.actionByRoot,
					rootUuid = ( action._localRoot || this._root ).uuid;
	
				delete actionByRoot[ rootUuid ];
	
				if ( knownActionsForClip.length === 0 ) {
	
					delete actionsByClip[ clipUuid ];
	
				}
	
				this._removeInactiveBindingsForAction( action );
	
			},
	
			_removeInactiveBindingsForAction: function ( action ) {
	
				var bindings = action._propertyBindings;
				for ( var i = 0, n = bindings.length; i !== n; ++ i ) {
	
					var binding = bindings[ i ];
	
					if ( -- binding.referenceCount === 0 ) {
	
						this._removeInactiveBinding( binding );
	
					}
	
				}
	
			},
	
			_lendAction: function ( action ) {
	
				// [ active actions |  inactive actions  ]
				// [  active actions >| inactive actions ]
				//                 s        a
				//                  <-swap->
				//                 a        s
	
				var actions = this._actions,
					prevIndex = action._cacheIndex,
	
					lastActiveIndex = this._nActiveActions ++,
	
					firstInactiveAction = actions[ lastActiveIndex ];
	
				action._cacheIndex = lastActiveIndex;
				actions[ lastActiveIndex ] = action;
	
				firstInactiveAction._cacheIndex = prevIndex;
				actions[ prevIndex ] = firstInactiveAction;
	
			},
	
			_takeBackAction: function ( action ) {
	
				// [  active actions  | inactive actions ]
				// [ active actions |< inactive actions  ]
				//        a        s
				//         <-swap->
				//        s        a
	
				var actions = this._actions,
					prevIndex = action._cacheIndex,
	
					firstInactiveIndex = -- this._nActiveActions,
	
					lastActiveAction = actions[ firstInactiveIndex ];
	
				action._cacheIndex = firstInactiveIndex;
				actions[ firstInactiveIndex ] = action;
	
				lastActiveAction._cacheIndex = prevIndex;
				actions[ prevIndex ] = lastActiveAction;
	
			},
	
			// Memory management for PropertyMixer objects
	
			_addInactiveBinding: function ( binding, rootUuid, trackName ) {
	
				var bindingsByRoot = this._bindingsByRootAndName,
					bindingByName = bindingsByRoot[ rootUuid ],
	
					bindings = this._bindings;
	
				if ( bindingByName === undefined ) {
	
					bindingByName = {};
					bindingsByRoot[ rootUuid ] = bindingByName;
	
				}
	
				bindingByName[ trackName ] = binding;
	
				binding._cacheIndex = bindings.length;
				bindings.push( binding );
	
			},
	
			_removeInactiveBinding: function ( binding ) {
	
				var bindings = this._bindings,
					propBinding = binding.binding,
					rootUuid = propBinding.rootNode.uuid,
					trackName = propBinding.path,
					bindingsByRoot = this._bindingsByRootAndName,
					bindingByName = bindingsByRoot[ rootUuid ],
	
					lastInactiveBinding = bindings[ bindings.length - 1 ],
					cacheIndex = binding._cacheIndex;
	
				lastInactiveBinding._cacheIndex = cacheIndex;
				bindings[ cacheIndex ] = lastInactiveBinding;
				bindings.pop();
	
				delete bindingByName[ trackName ];
	
				remove_empty_map: {
	
					for ( var _ in bindingByName ) break remove_empty_map; // eslint-disable-line no-unused-vars
	
					delete bindingsByRoot[ rootUuid ];
	
				}
	
			},
	
			_lendBinding: function ( binding ) {
	
				var bindings = this._bindings,
					prevIndex = binding._cacheIndex,
	
					lastActiveIndex = this._nActiveBindings ++,
	
					firstInactiveBinding = bindings[ lastActiveIndex ];
	
				binding._cacheIndex = lastActiveIndex;
				bindings[ lastActiveIndex ] = binding;
	
				firstInactiveBinding._cacheIndex = prevIndex;
				bindings[ prevIndex ] = firstInactiveBinding;
	
			},
	
			_takeBackBinding: function ( binding ) {
	
				var bindings = this._bindings,
					prevIndex = binding._cacheIndex,
	
					firstInactiveIndex = -- this._nActiveBindings,
	
					lastActiveBinding = bindings[ firstInactiveIndex ];
	
				binding._cacheIndex = firstInactiveIndex;
				bindings[ firstInactiveIndex ] = binding;
	
				lastActiveBinding._cacheIndex = prevIndex;
				bindings[ prevIndex ] = lastActiveBinding;
	
			},
	
	
			// Memory management of Interpolants for weight and time scale
	
			_lendControlInterpolant: function () {
	
				var interpolants = this._controlInterpolants,
					lastActiveIndex = this._nActiveControlInterpolants ++,
					interpolant = interpolants[ lastActiveIndex ];
	
				if ( interpolant === undefined ) {
	
					interpolant = new LinearInterpolant(
						new Float32Array( 2 ), new Float32Array( 2 ),
						1, this._controlInterpolantsResultBuffer );
	
					interpolant.__cacheIndex = lastActiveIndex;
					interpolants[ lastActiveIndex ] = interpolant;
	
				}
	
				return interpolant;
	
			},
	
			_takeBackControlInterpolant: function ( interpolant ) {
	
				var interpolants = this._controlInterpolants,
					prevIndex = interpolant.__cacheIndex,
	
					firstInactiveIndex = -- this._nActiveControlInterpolants,
	
					lastActiveInterpolant = interpolants[ firstInactiveIndex ];
	
				interpolant.__cacheIndex = firstInactiveIndex;
				interpolants[ firstInactiveIndex ] = interpolant;
	
				lastActiveInterpolant.__cacheIndex = prevIndex;
				interpolants[ prevIndex ] = lastActiveInterpolant;
	
			},
	
			_controlInterpolantsResultBuffer: new Float32Array( 1 ),
	
			// return an action for a clip optionally using a custom root target
			// object (this method allocates a lot of dynamic memory in case a
			// previously unknown clip/root combination is specified)
			clipAction: function ( clip, optionalRoot ) {
	
				var root = optionalRoot || this._root,
					rootUuid = root.uuid,
	
					clipObject = typeof clip === 'string' ?
						AnimationClip.findByName( root, clip ) : clip,
	
					clipUuid = clipObject !== null ? clipObject.uuid : clip,
	
					actionsForClip = this._actionsByClip[ clipUuid ],
					prototypeAction = null;
	
				if ( actionsForClip !== undefined ) {
	
					var existingAction =
							actionsForClip.actionByRoot[ rootUuid ];
	
					if ( existingAction !== undefined ) {
	
						return existingAction;
	
					}
	
					// we know the clip, so we don't have to parse all
					// the bindings again but can just copy
					prototypeAction = actionsForClip.knownActions[ 0 ];
	
					// also, take the clip from the prototype action
					if ( clipObject === null )
						clipObject = prototypeAction._clip;
	
				}
	
				// clip must be known when specified via string
				if ( clipObject === null ) return null;
	
				// allocate all resources required to run it
				var newAction = new AnimationAction( this, clipObject, optionalRoot );
	
				this._bindAction( newAction, prototypeAction );
	
				// and make the action known to the memory manager
				this._addInactiveAction( newAction, clipUuid, rootUuid );
	
				return newAction;
	
			},
	
			// get an existing action
			existingAction: function ( clip, optionalRoot ) {
	
				var root = optionalRoot || this._root,
					rootUuid = root.uuid,
	
					clipObject = typeof clip === 'string' ?
						AnimationClip.findByName( root, clip ) : clip,
	
					clipUuid = clipObject ? clipObject.uuid : clip,
	
					actionsForClip = this._actionsByClip[ clipUuid ];
	
				if ( actionsForClip !== undefined ) {
	
					return actionsForClip.actionByRoot[ rootUuid ] || null;
	
				}
	
				return null;
	
			},
	
			// deactivates all previously scheduled actions
			stopAllAction: function () {
	
				var actions = this._actions,
					nActions = this._nActiveActions,
					bindings = this._bindings,
					nBindings = this._nActiveBindings;
	
				this._nActiveActions = 0;
				this._nActiveBindings = 0;
	
				for ( var i = 0; i !== nActions; ++ i ) {
	
					actions[ i ].reset();
	
				}
	
				for ( var i = 0; i !== nBindings; ++ i ) {
	
					bindings[ i ].useCount = 0;
	
				}
	
				return this;
	
			},
	
			// advance the time and update apply the animation
			update: function ( deltaTime ) {
	
				deltaTime *= this.timeScale;
	
				var actions = this._actions,
					nActions = this._nActiveActions,
	
					time = this.time += deltaTime,
					timeDirection = Math.sign( deltaTime ),
	
					accuIndex = this._accuIndex ^= 1;
	
				// run active actions
	
				for ( var i = 0; i !== nActions; ++ i ) {
	
					var action = actions[ i ];
	
					action._update( time, deltaTime, timeDirection, accuIndex );
	
				}
	
				// update scene graph
	
				var bindings = this._bindings,
					nBindings = this._nActiveBindings;
	
				for ( var i = 0; i !== nBindings; ++ i ) {
	
					bindings[ i ].apply( accuIndex );
	
				}
	
				return this;
	
			},
	
			// return this mixer's root target object
			getRoot: function () {
	
				return this._root;
	
			},
	
			// free all resources specific to a particular clip
			uncacheClip: function ( clip ) {
	
				var actions = this._actions,
					clipUuid = clip.uuid,
					actionsByClip = this._actionsByClip,
					actionsForClip = actionsByClip[ clipUuid ];
	
				if ( actionsForClip !== undefined ) {
	
					// note: just calling _removeInactiveAction would mess up the
					// iteration state and also require updating the state we can
					// just throw away
	
					var actionsToRemove = actionsForClip.knownActions;
	
					for ( var i = 0, n = actionsToRemove.length; i !== n; ++ i ) {
	
						var action = actionsToRemove[ i ];
	
						this._deactivateAction( action );
	
						var cacheIndex = action._cacheIndex,
							lastInactiveAction = actions[ actions.length - 1 ];
	
						action._cacheIndex = null;
						action._byClipCacheIndex = null;
	
						lastInactiveAction._cacheIndex = cacheIndex;
						actions[ cacheIndex ] = lastInactiveAction;
						actions.pop();
	
						this._removeInactiveBindingsForAction( action );
	
					}
	
					delete actionsByClip[ clipUuid ];
	
				}
	
			},
	
			// free all resources specific to a particular root target object
			uncacheRoot: function ( root ) {
	
				var rootUuid = root.uuid,
					actionsByClip = this._actionsByClip;
	
				for ( var clipUuid in actionsByClip ) {
	
					var actionByRoot = actionsByClip[ clipUuid ].actionByRoot,
						action = actionByRoot[ rootUuid ];
	
					if ( action !== undefined ) {
	
						this._deactivateAction( action );
						this._removeInactiveAction( action );
	
					}
	
				}
	
				var bindingsByRoot = this._bindingsByRootAndName,
					bindingByName = bindingsByRoot[ rootUuid ];
	
				if ( bindingByName !== undefined ) {
	
					for ( var trackName in bindingByName ) {
	
						var binding = bindingByName[ trackName ];
						binding.restoreOriginalState();
						this._removeInactiveBinding( binding );
	
					}
	
				}
	
			},
	
			// remove a targeted clip from the cache
			uncacheAction: function ( clip, optionalRoot ) {
	
				var action = this.existingAction( clip, optionalRoot );
	
				if ( action !== null ) {
	
					this._deactivateAction( action );
					this._removeInactiveAction( action );
	
				}
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function Uniform( value ) {
	
			if ( typeof value === 'string' ) {
	
				console.warn( 'THREE.Uniform: Type parameter is no longer needed.' );
				value = arguments[ 1 ];
	
			}
	
			this.value = value;
	
		}
	
		Uniform.prototype.clone = function () {
	
			return new Uniform( this.value.clone === undefined ? this.value : this.value.clone() );
	
		};
	
		/**
		 * @author benaadams / https://twitter.com/ben_a_adams
		 */
	
		function InstancedBufferGeometry() {
	
			BufferGeometry.call( this );
	
			this.type = 'InstancedBufferGeometry';
			this.maxInstancedCount = undefined;
	
		}
	
		InstancedBufferGeometry.prototype = Object.assign( Object.create( BufferGeometry.prototype ), {
	
			constructor: InstancedBufferGeometry,
	
			isInstancedBufferGeometry: true,
	
			copy: function ( source ) {
	
				BufferGeometry.prototype.copy.call( this, source );
	
				this.maxInstancedCount = source.maxInstancedCount;
	
				return this;
	
			},
	
			clone: function () {
	
				return new this.constructor().copy( this );
	
			}
	
		} );
	
		/**
		 * @author benaadams / https://twitter.com/ben_a_adams
		 */
	
		function InterleavedBufferAttribute( interleavedBuffer, itemSize, offset, normalized ) {
	
			this.uuid = _Math.generateUUID();
	
			this.data = interleavedBuffer;
			this.itemSize = itemSize;
			this.offset = offset;
	
			this.normalized = normalized === true;
	
		}
	
		Object.defineProperties( InterleavedBufferAttribute.prototype, {
	
			count: {
	
				get: function () {
	
					return this.data.count;
	
				}
	
			},
	
			array: {
	
				get: function () {
	
					return this.data.array;
	
				}
	
			}
	
		} );
	
		Object.assign( InterleavedBufferAttribute.prototype, {
	
			isInterleavedBufferAttribute: true,
	
			setX: function ( index, x ) {
	
				this.data.array[ index * this.data.stride + this.offset ] = x;
	
				return this;
	
			},
	
			setY: function ( index, y ) {
	
				this.data.array[ index * this.data.stride + this.offset + 1 ] = y;
	
				return this;
	
			},
	
			setZ: function ( index, z ) {
	
				this.data.array[ index * this.data.stride + this.offset + 2 ] = z;
	
				return this;
	
			},
	
			setW: function ( index, w ) {
	
				this.data.array[ index * this.data.stride + this.offset + 3 ] = w;
	
				return this;
	
			},
	
			getX: function ( index ) {
	
				return this.data.array[ index * this.data.stride + this.offset ];
	
			},
	
			getY: function ( index ) {
	
				return this.data.array[ index * this.data.stride + this.offset + 1 ];
	
			},
	
			getZ: function ( index ) {
	
				return this.data.array[ index * this.data.stride + this.offset + 2 ];
	
			},
	
			getW: function ( index ) {
	
				return this.data.array[ index * this.data.stride + this.offset + 3 ];
	
			},
	
			setXY: function ( index, x, y ) {
	
				index = index * this.data.stride + this.offset;
	
				this.data.array[ index + 0 ] = x;
				this.data.array[ index + 1 ] = y;
	
				return this;
	
			},
	
			setXYZ: function ( index, x, y, z ) {
	
				index = index * this.data.stride + this.offset;
	
				this.data.array[ index + 0 ] = x;
				this.data.array[ index + 1 ] = y;
				this.data.array[ index + 2 ] = z;
	
				return this;
	
			},
	
			setXYZW: function ( index, x, y, z, w ) {
	
				index = index * this.data.stride + this.offset;
	
				this.data.array[ index + 0 ] = x;
				this.data.array[ index + 1 ] = y;
				this.data.array[ index + 2 ] = z;
				this.data.array[ index + 3 ] = w;
	
				return this;
	
			}
	
		} );
	
		/**
		 * @author benaadams / https://twitter.com/ben_a_adams
		 */
	
		function InterleavedBuffer( array, stride ) {
	
			this.uuid = _Math.generateUUID();
	
			this.array = array;
			this.stride = stride;
			this.count = array !== undefined ? array.length / stride : 0;
	
			this.dynamic = false;
			this.updateRange = { offset: 0, count: - 1 };
	
			this.onUploadCallback = function () {};
	
			this.version = 0;
	
		}
	
		Object.defineProperty( InterleavedBuffer.prototype, 'needsUpdate', {
	
			set: function ( value ) {
	
				if ( value === true ) this.version ++;
	
			}
	
		} );
	
		Object.assign( InterleavedBuffer.prototype, {
	
			isInterleavedBuffer: true,
	
			setArray: function ( array ) {
	
				if ( Array.isArray( array ) ) {
	
					throw new TypeError( 'THREE.BufferAttribute: array should be a Typed Array.' );
	
				}
	
				this.count = array !== undefined ? array.length / this.stride : 0;
				this.array = array;
	
			},
	
			setDynamic: function ( value ) {
	
				this.dynamic = value;
	
				return this;
	
			},
	
			copy: function ( source ) {
	
				this.array = new source.array.constructor( source.array );
				this.count = source.count;
				this.stride = source.stride;
				this.dynamic = source.dynamic;
	
				return this;
	
			},
	
			copyAt: function ( index1, attribute, index2 ) {
	
				index1 *= this.stride;
				index2 *= attribute.stride;
	
				for ( var i = 0, l = this.stride; i < l; i ++ ) {
	
					this.array[ index1 + i ] = attribute.array[ index2 + i ];
	
				}
	
				return this;
	
			},
	
			set: function ( value, offset ) {
	
				if ( offset === undefined ) offset = 0;
	
				this.array.set( value, offset );
	
				return this;
	
			},
	
			clone: function () {
	
				return new this.constructor().copy( this );
	
			},
	
			onUpload: function ( callback ) {
	
				this.onUploadCallback = callback;
	
				return this;
	
			}
	
		} );
	
		/**
		 * @author benaadams / https://twitter.com/ben_a_adams
		 */
	
		function InstancedInterleavedBuffer( array, stride, meshPerAttribute ) {
	
			InterleavedBuffer.call( this, array, stride );
	
			this.meshPerAttribute = meshPerAttribute || 1;
	
		}
	
		InstancedInterleavedBuffer.prototype = Object.assign( Object.create( InterleavedBuffer.prototype ), {
	
			constructor: InstancedInterleavedBuffer,
	
			isInstancedInterleavedBuffer: true,
	
			copy: function ( source ) {
	
				InterleavedBuffer.prototype.copy.call( this, source );
	
				this.meshPerAttribute = source.meshPerAttribute;
	
				return this;
	
			}
	
		} );
	
		/**
		 * @author benaadams / https://twitter.com/ben_a_adams
		 */
	
		function InstancedBufferAttribute( array, itemSize, meshPerAttribute ) {
	
			BufferAttribute.call( this, array, itemSize );
	
			this.meshPerAttribute = meshPerAttribute || 1;
	
		}
	
		InstancedBufferAttribute.prototype = Object.assign( Object.create( BufferAttribute.prototype ), {
	
			constructor: InstancedBufferAttribute,
	
			isInstancedBufferAttribute: true,
	
			copy: function ( source ) {
	
				BufferAttribute.prototype.copy.call( this, source );
	
				this.meshPerAttribute = source.meshPerAttribute;
	
				return this;
	
			}
	
		} );
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author bhouston / http://clara.io/
		 * @author stephomi / http://stephaneginier.com/
		 */
	
		function Raycaster( origin, direction, near, far ) {
	
			this.ray = new Ray( origin, direction );
			// direction is assumed to be normalized (for accurate distance calculations)
	
			this.near = near || 0;
			this.far = far || Infinity;
	
			this.params = {
				Mesh: {},
				Line: {},
				LOD: {},
				Points: { threshold: 1 },
				Sprite: {}
			};
	
			Object.defineProperties( this.params, {
				PointCloud: {
					get: function () {
	
						console.warn( 'THREE.Raycaster: params.PointCloud has been renamed to params.Points.' );
						return this.Points;
	
					}
				}
			} );
	
		}
	
		function ascSort( a, b ) {
	
			return a.distance - b.distance;
	
		}
	
		function intersectObject( object, raycaster, intersects, recursive ) {
	
			if ( object.visible === false ) return;
	
			object.raycast( raycaster, intersects );
	
			if ( recursive === true ) {
	
				var children = object.children;
	
				for ( var i = 0, l = children.length; i < l; i ++ ) {
	
					intersectObject( children[ i ], raycaster, intersects, true );
	
				}
	
			}
	
		}
	
		Object.assign( Raycaster.prototype, {
	
			linePrecision: 1,
	
			set: function ( origin, direction ) {
	
				// direction is assumed to be normalized (for accurate distance calculations)
	
				this.ray.set( origin, direction );
	
			},
	
			setFromCamera: function ( coords, camera ) {
	
				if ( ( camera && camera.isPerspectiveCamera ) ) {
	
					this.ray.origin.setFromMatrixPosition( camera.matrixWorld );
					this.ray.direction.set( coords.x, coords.y, 0.5 ).unproject( camera ).sub( this.ray.origin ).normalize();
	
				} else if ( ( camera && camera.isOrthographicCamera ) ) {
	
					this.ray.origin.set( coords.x, coords.y, ( camera.near + camera.far ) / ( camera.near - camera.far ) ).unproject( camera ); // set origin in plane of camera
					this.ray.direction.set( 0, 0, - 1 ).transformDirection( camera.matrixWorld );
	
				} else {
	
					console.error( 'THREE.Raycaster: Unsupported camera type.' );
	
				}
	
			},
	
			intersectObject: function ( object, recursive ) {
	
				var intersects = [];
	
				intersectObject( object, this, intersects, recursive );
	
				intersects.sort( ascSort );
	
				return intersects;
	
			},
	
			intersectObjects: function ( objects, recursive ) {
	
				var intersects = [];
	
				if ( Array.isArray( objects ) === false ) {
	
					console.warn( 'THREE.Raycaster.intersectObjects: objects is not an Array.' );
					return intersects;
	
				}
	
				for ( var i = 0, l = objects.length; i < l; i ++ ) {
	
					intersectObject( objects[ i ], this, intersects, recursive );
	
				}
	
				intersects.sort( ascSort );
	
				return intersects;
	
			}
	
		} );
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 */
	
		function Clock( autoStart ) {
	
			this.autoStart = ( autoStart !== undefined ) ? autoStart : true;
	
			this.startTime = 0;
			this.oldTime = 0;
			this.elapsedTime = 0;
	
			this.running = false;
	
		}
	
		Object.assign( Clock.prototype, {
	
			start: function () {
	
				this.startTime = ( typeof performance === 'undefined' ? Date : performance ).now(); // see #10732
	
				this.oldTime = this.startTime;
				this.elapsedTime = 0;
				this.running = true;
	
			},
	
			stop: function () {
	
				this.getElapsedTime();
				this.running = false;
				this.autoStart = false;
	
			},
	
			getElapsedTime: function () {
	
				this.getDelta();
				return this.elapsedTime;
	
			},
	
			getDelta: function () {
	
				var diff = 0;
	
				if ( this.autoStart && ! this.running ) {
	
					this.start();
					return 0;
	
				}
	
				if ( this.running ) {
	
					var newTime = ( typeof performance === 'undefined' ? Date : performance ).now();
	
					diff = ( newTime - this.oldTime ) / 1000;
					this.oldTime = newTime;
	
					this.elapsedTime += diff;
	
				}
	
				return diff;
	
			}
	
		} );
	
		/**
		 * @author bhouston / http://clara.io
		 * @author WestLangley / http://github.com/WestLangley
		 *
		 * Ref: https://en.wikipedia.org/wiki/Spherical_coordinate_system
		 *
		 * The poles (phi) are at the positive and negative y axis.
		 * The equator starts at positive z.
		 */
	
		function Spherical( radius, phi, theta ) {
	
			this.radius = ( radius !== undefined ) ? radius : 1.0;
			this.phi = ( phi !== undefined ) ? phi : 0; // up / down towards top and bottom pole
			this.theta = ( theta !== undefined ) ? theta : 0; // around the equator of the sphere
	
			return this;
	
		}
	
		Object.assign( Spherical.prototype, {
	
			set: function ( radius, phi, theta ) {
	
				this.radius = radius;
				this.phi = phi;
				this.theta = theta;
	
				return this;
	
			},
	
			clone: function () {
	
				return new this.constructor().copy( this );
	
			},
	
			copy: function ( other ) {
	
				this.radius = other.radius;
				this.phi = other.phi;
				this.theta = other.theta;
	
				return this;
	
			},
	
			// restrict phi to be betwee EPS and PI-EPS
			makeSafe: function () {
	
				var EPS = 0.000001;
				this.phi = Math.max( EPS, Math.min( Math.PI - EPS, this.phi ) );
	
				return this;
	
			},
	
			setFromVector3: function ( vec3 ) {
	
				this.radius = vec3.length();
	
				if ( this.radius === 0 ) {
	
					this.theta = 0;
					this.phi = 0;
	
				} else {
	
					this.theta = Math.atan2( vec3.x, vec3.z ); // equator angle around y-up axis
					this.phi = Math.acos( _Math.clamp( vec3.y / this.radius, - 1, 1 ) ); // polar angle
	
				}
	
				return this;
	
			}
	
		} );
	
		/**
		 * @author Mugen87 / https://github.com/Mugen87
		 *
		 * Ref: https://en.wikipedia.org/wiki/Cylindrical_coordinate_system
		 *
		 */
	
		function Cylindrical( radius, theta, y ) {
	
			this.radius = ( radius !== undefined ) ? radius : 1.0; // distance from the origin to a point in the x-z plane
			this.theta = ( theta !== undefined ) ? theta : 0; // counterclockwise angle in the x-z plane measured in radians from the positive z-axis
			this.y = ( y !== undefined ) ? y : 0; // height above the x-z plane
	
			return this;
	
		}
	
		Object.assign( Cylindrical.prototype, {
	
			set: function ( radius, theta, y ) {
	
				this.radius = radius;
				this.theta = theta;
				this.y = y;
	
				return this;
	
			},
	
			clone: function () {
	
				return new this.constructor().copy( this );
	
			},
	
			copy: function ( other ) {
	
				this.radius = other.radius;
				this.theta = other.theta;
				this.y = other.y;
	
				return this;
	
			},
	
			setFromVector3: function ( vec3 ) {
	
				this.radius = Math.sqrt( vec3.x * vec3.x + vec3.z * vec3.z );
				this.theta = Math.atan2( vec3.x, vec3.z );
				this.y = vec3.y;
	
				return this;
	
			}
	
		} );
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 */
	
		function ImmediateRenderObject( material ) {
	
			Object3D.call( this );
	
			this.material = material;
			this.render = function ( /* renderCallback */ ) {};
	
		}
	
		ImmediateRenderObject.prototype = Object.create( Object3D.prototype );
		ImmediateRenderObject.prototype.constructor = ImmediateRenderObject;
	
		ImmediateRenderObject.prototype.isImmediateRenderObject = true;
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author WestLangley / http://github.com/WestLangley
		 */
	
		function VertexNormalsHelper( object, size, hex, linewidth ) {
	
			this.object = object;
	
			this.size = ( size !== undefined ) ? size : 1;
	
			var color = ( hex !== undefined ) ? hex : 0xff0000;
	
			var width = ( linewidth !== undefined ) ? linewidth : 1;
	
			//
	
			var nNormals = 0;
	
			var objGeometry = this.object.geometry;
	
			if ( objGeometry && objGeometry.isGeometry ) {
	
				nNormals = objGeometry.faces.length * 3;
	
			} else if ( objGeometry && objGeometry.isBufferGeometry ) {
	
				nNormals = objGeometry.attributes.normal.count;
	
			}
	
			//
	
			var geometry = new BufferGeometry();
	
			var positions = new Float32BufferAttribute( nNormals * 2 * 3, 3 );
	
			geometry.addAttribute( 'position', positions );
	
			LineSegments.call( this, geometry, new LineBasicMaterial( { color: color, linewidth: width } ) );
	
			//
	
			this.matrixAutoUpdate = false;
	
			this.update();
	
		}
	
		VertexNormalsHelper.prototype = Object.create( LineSegments.prototype );
		VertexNormalsHelper.prototype.constructor = VertexNormalsHelper;
	
		VertexNormalsHelper.prototype.update = ( function () {
	
			var v1 = new Vector3();
			var v2 = new Vector3();
			var normalMatrix = new Matrix3();
	
			return function update() {
	
				var keys = [ 'a', 'b', 'c' ];
	
				this.object.updateMatrixWorld( true );
	
				normalMatrix.getNormalMatrix( this.object.matrixWorld );
	
				var matrixWorld = this.object.matrixWorld;
	
				var position = this.geometry.attributes.position;
	
				//
	
				var objGeometry = this.object.geometry;
	
				if ( objGeometry && objGeometry.isGeometry ) {
	
					var vertices = objGeometry.vertices;
	
					var faces = objGeometry.faces;
	
					var idx = 0;
	
					for ( var i = 0, l = faces.length; i < l; i ++ ) {
	
						var face = faces[ i ];
	
						for ( var j = 0, jl = face.vertexNormals.length; j < jl; j ++ ) {
	
							var vertex = vertices[ face[ keys[ j ] ] ];
	
							var normal = face.vertexNormals[ j ];
	
							v1.copy( vertex ).applyMatrix4( matrixWorld );
	
							v2.copy( normal ).applyMatrix3( normalMatrix ).normalize().multiplyScalar( this.size ).add( v1 );
	
							position.setXYZ( idx, v1.x, v1.y, v1.z );
	
							idx = idx + 1;
	
							position.setXYZ( idx, v2.x, v2.y, v2.z );
	
							idx = idx + 1;
	
						}
	
					}
	
				} else if ( objGeometry && objGeometry.isBufferGeometry ) {
	
					var objPos = objGeometry.attributes.position;
	
					var objNorm = objGeometry.attributes.normal;
	
					var idx = 0;
	
					// for simplicity, ignore index and drawcalls, and render every normal
	
					for ( var j = 0, jl = objPos.count; j < jl; j ++ ) {
	
						v1.set( objPos.getX( j ), objPos.getY( j ), objPos.getZ( j ) ).applyMatrix4( matrixWorld );
	
						v2.set( objNorm.getX( j ), objNorm.getY( j ), objNorm.getZ( j ) );
	
						v2.applyMatrix3( normalMatrix ).normalize().multiplyScalar( this.size ).add( v1 );
	
						position.setXYZ( idx, v1.x, v1.y, v1.z );
	
						idx = idx + 1;
	
						position.setXYZ( idx, v2.x, v2.y, v2.z );
	
						idx = idx + 1;
	
					}
	
				}
	
				position.needsUpdate = true;
	
			};
	
		}() );
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 * @author mrdoob / http://mrdoob.com/
		 * @author WestLangley / http://github.com/WestLangley
		 */
	
		function SpotLightHelper( light, color ) {
	
			Object3D.call( this );
	
			this.light = light;
			this.light.updateMatrixWorld();
	
			this.matrix = light.matrixWorld;
			this.matrixAutoUpdate = false;
	
			this.color = color;
	
			var geometry = new BufferGeometry();
	
			var positions = [
				0, 0, 0, 	0, 0, 1,
				0, 0, 0, 	1, 0, 1,
				0, 0, 0,	- 1, 0, 1,
				0, 0, 0, 	0, 1, 1,
				0, 0, 0, 	0, - 1, 1
			];
	
			for ( var i = 0, j = 1, l = 32; i < l; i ++, j ++ ) {
	
				var p1 = ( i / l ) * Math.PI * 2;
				var p2 = ( j / l ) * Math.PI * 2;
	
				positions.push(
					Math.cos( p1 ), Math.sin( p1 ), 1,
					Math.cos( p2 ), Math.sin( p2 ), 1
				);
	
			}
	
			geometry.addAttribute( 'position', new Float32BufferAttribute( positions, 3 ) );
	
			var material = new LineBasicMaterial( { fog: false } );
	
			this.cone = new LineSegments( geometry, material );
			this.add( this.cone );
	
			this.update();
	
		}
	
		SpotLightHelper.prototype = Object.create( Object3D.prototype );
		SpotLightHelper.prototype.constructor = SpotLightHelper;
	
		SpotLightHelper.prototype.dispose = function () {
	
			this.cone.geometry.dispose();
			this.cone.material.dispose();
	
		};
	
		SpotLightHelper.prototype.update = function () {
	
			var vector = new Vector3();
			var vector2 = new Vector3();
	
			return function update() {
	
				this.light.updateMatrixWorld();
	
				var coneLength = this.light.distance ? this.light.distance : 1000;
				var coneWidth = coneLength * Math.tan( this.light.angle );
	
				this.cone.scale.set( coneWidth, coneWidth, coneLength );
	
				vector.setFromMatrixPosition( this.light.matrixWorld );
				vector2.setFromMatrixPosition( this.light.target.matrixWorld );
	
				this.cone.lookAt( vector2.sub( vector ) );
	
				if ( this.color !== undefined ) {
	
					this.cone.material.color.set( this.color );
	
				} else {
	
					this.cone.material.color.copy( this.light.color );
	
				}
	
			};
	
		}();
	
		/**
		 * @author Sean Griffin / http://twitter.com/sgrif
		 * @author Michael Guerrero / http://realitymeltdown.com
		 * @author mrdoob / http://mrdoob.com/
		 * @author ikerr / http://verold.com
		 * @author Mugen87 / https://github.com/Mugen87
		 */
	
		function getBoneList( object ) {
	
			var boneList = [];
	
			if ( object && object.isBone ) {
	
				boneList.push( object );
	
			}
	
			for ( var i = 0; i < object.children.length; i ++ ) {
	
				boneList.push.apply( boneList, getBoneList( object.children[ i ] ) );
	
			}
	
			return boneList;
	
		}
	
		function SkeletonHelper( object ) {
	
			var bones = getBoneList( object );
	
			var geometry = new BufferGeometry();
	
			var vertices = [];
			var colors = [];
	
			var color1 = new Color( 0, 0, 1 );
			var color2 = new Color( 0, 1, 0 );
	
			for ( var i = 0; i < bones.length; i ++ ) {
	
				var bone = bones[ i ];
	
				if ( bone.parent && bone.parent.isBone ) {
	
					vertices.push( 0, 0, 0 );
					vertices.push( 0, 0, 0 );
					colors.push( color1.r, color1.g, color1.b );
					colors.push( color2.r, color2.g, color2.b );
	
				}
	
			}
	
			geometry.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
			geometry.addAttribute( 'color', new Float32BufferAttribute( colors, 3 ) );
	
			var material = new LineBasicMaterial( { vertexColors: VertexColors, depthTest: false, depthWrite: false, transparent: true } );
	
			LineSegments.call( this, geometry, material );
	
			this.root = object;
			this.bones = bones;
	
			this.matrix = object.matrixWorld;
			this.matrixAutoUpdate = false;
	
		}
	
		SkeletonHelper.prototype = Object.create( LineSegments.prototype );
		SkeletonHelper.prototype.constructor = SkeletonHelper;
	
		SkeletonHelper.prototype.updateMatrixWorld = function () {
	
			var vector = new Vector3();
	
			var boneMatrix = new Matrix4();
			var matrixWorldInv = new Matrix4();
	
			return function updateMatrixWorld( force ) {
	
				var bones = this.bones;
	
				var geometry = this.geometry;
				var position = geometry.getAttribute( 'position' );
	
				matrixWorldInv.getInverse( this.root.matrixWorld );
	
				for ( var i = 0, j = 0; i < bones.length; i ++ ) {
	
					var bone = bones[ i ];
	
					if ( bone.parent && bone.parent.isBone ) {
	
						boneMatrix.multiplyMatrices( matrixWorldInv, bone.matrixWorld );
						vector.setFromMatrixPosition( boneMatrix );
						position.setXYZ( j, vector.x, vector.y, vector.z );
	
						boneMatrix.multiplyMatrices( matrixWorldInv, bone.parent.matrixWorld );
						vector.setFromMatrixPosition( boneMatrix );
						position.setXYZ( j + 1, vector.x, vector.y, vector.z );
	
						j += 2;
	
					}
	
				}
	
				geometry.getAttribute( 'position' ).needsUpdate = true;
	
				Object3D.prototype.updateMatrixWorld.call( this, force );
	
			};
	
		}();
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function PointLightHelper( light, sphereSize, color ) {
	
			this.light = light;
			this.light.updateMatrixWorld();
	
			this.color = color;
	
			var geometry = new SphereBufferGeometry( sphereSize, 4, 2 );
			var material = new MeshBasicMaterial( { wireframe: true, fog: false } );
	
			Mesh.call( this, geometry, material );
	
			this.matrix = this.light.matrixWorld;
			this.matrixAutoUpdate = false;
	
			this.update();
	
	
			/*
			var distanceGeometry = new THREE.IcosahedronGeometry( 1, 2 );
			var distanceMaterial = new THREE.MeshBasicMaterial( { color: hexColor, fog: false, wireframe: true, opacity: 0.1, transparent: true } );
	
			this.lightSphere = new THREE.Mesh( bulbGeometry, bulbMaterial );
			this.lightDistance = new THREE.Mesh( distanceGeometry, distanceMaterial );
	
			var d = light.distance;
	
			if ( d === 0.0 ) {
	
				this.lightDistance.visible = false;
	
			} else {
	
				this.lightDistance.scale.set( d, d, d );
	
			}
	
			this.add( this.lightDistance );
			*/
	
		}
	
		PointLightHelper.prototype = Object.create( Mesh.prototype );
		PointLightHelper.prototype.constructor = PointLightHelper;
	
		PointLightHelper.prototype.dispose = function () {
	
			this.geometry.dispose();
			this.material.dispose();
	
		};
	
		PointLightHelper.prototype.update = function () {
	
			if ( this.color !== undefined ) {
	
				this.material.color.set( this.color );
	
			} else {
	
				this.material.color.copy( this.light.color );
	
			}
	
			/*
			var d = this.light.distance;
	
			if ( d === 0.0 ) {
	
				this.lightDistance.visible = false;
	
			} else {
	
				this.lightDistance.visible = true;
				this.lightDistance.scale.set( d, d, d );
	
			}
			*/
	
		};
	
		/**
		 * @author abelnation / http://github.com/abelnation
		 * @author Mugen87 / http://github.com/Mugen87
		 * @author WestLangley / http://github.com/WestLangley
		 */
	
		function RectAreaLightHelper( light, color ) {
	
			Object3D.call( this );
	
			this.light = light;
			this.light.updateMatrixWorld();
	
			this.matrix = light.matrixWorld;
			this.matrixAutoUpdate = false;
	
			this.color = color;
	
			var material = new LineBasicMaterial( { fog: false } );
	
			var geometry = new BufferGeometry();
	
			geometry.addAttribute( 'position', new BufferAttribute( new Float32Array( 5 * 3 ), 3 ) );
	
			this.line = new Line( geometry, material );
			this.add( this.line );
	
	
			this.update();
	
		}
	
		RectAreaLightHelper.prototype = Object.create( Object3D.prototype );
		RectAreaLightHelper.prototype.constructor = RectAreaLightHelper;
	
		RectAreaLightHelper.prototype.dispose = function () {
	
			this.children[ 0 ].geometry.dispose();
			this.children[ 0 ].material.dispose();
	
		};
	
		RectAreaLightHelper.prototype.update = function () {
	
			// calculate new dimensions of the helper
	
			var hx = this.light.width * 0.5;
			var hy = this.light.height * 0.5;
	
			var position = this.line.geometry.attributes.position;
			var array = position.array;
	
			// update vertices
	
			array[ 0 ] = hx; array[ 1 ] = - hy; array[ 2 ] = 0;
			array[ 3 ] = hx; array[ 4 ] = hy; array[ 5 ] = 0;
			array[ 6 ] = - hx; array[ 7 ] = hy; array[ 8 ] = 0;
			array[ 9 ] = - hx; array[ 10 ] = - hy; array[ 11 ] = 0;
			array[ 12 ] = hx; array[ 13 ] = - hy; array[ 14 ] = 0;
	
			position.needsUpdate = true;
	
			if ( this.color !== undefined ) {
	
				this.line.material.color.set( this.color );
	
			} else {
	
				this.line.material.color.copy( this.light.color );
	
			}
	
		};
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 * @author mrdoob / http://mrdoob.com/
		 * @author Mugen87 / https://github.com/Mugen87
		 */
	
		function HemisphereLightHelper( light, size, color ) {
	
			Object3D.call( this );
	
			this.light = light;
			this.light.updateMatrixWorld();
	
			this.matrix = light.matrixWorld;
			this.matrixAutoUpdate = false;
	
			this.color = color;
	
			var geometry = new OctahedronBufferGeometry( size );
			geometry.rotateY( Math.PI * 0.5 );
	
			this.material = new MeshBasicMaterial( { wireframe: true, fog: false } );
			if ( this.color === undefined ) this.material.vertexColors = VertexColors;
	
			var position = geometry.getAttribute( 'position' );
			var colors = new Float32Array( position.count * 3 );
	
			geometry.addAttribute( 'color', new BufferAttribute( colors, 3 ) );
	
			this.add( new Mesh( geometry, this.material ) );
	
			this.update();
	
		}
	
		HemisphereLightHelper.prototype = Object.create( Object3D.prototype );
		HemisphereLightHelper.prototype.constructor = HemisphereLightHelper;
	
		HemisphereLightHelper.prototype.dispose = function () {
	
			this.children[ 0 ].geometry.dispose();
			this.children[ 0 ].material.dispose();
	
		};
	
		HemisphereLightHelper.prototype.update = function () {
	
			var vector = new Vector3();
	
			var color1 = new Color();
			var color2 = new Color();
	
			return function update() {
	
				var mesh = this.children[ 0 ];
	
				if ( this.color !== undefined ) {
	
					this.material.color.set( this.color );
	
				} else {
	
					var colors = mesh.geometry.getAttribute( 'color' );
	
					color1.copy( this.light.color );
					color2.copy( this.light.groundColor );
	
					for ( var i = 0, l = colors.count; i < l; i ++ ) {
	
						var color = ( i < ( l / 2 ) ) ? color1 : color2;
	
						colors.setXYZ( i, color.r, color.g, color.b );
	
					}
	
					colors.needsUpdate = true;
	
				}
	
				mesh.lookAt( vector.setFromMatrixPosition( this.light.matrixWorld ).negate() );
	
			};
	
		}();
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function GridHelper( size, divisions, color1, color2 ) {
	
			size = size || 10;
			divisions = divisions || 10;
			color1 = new Color( color1 !== undefined ? color1 : 0x444444 );
			color2 = new Color( color2 !== undefined ? color2 : 0x888888 );
	
			var center = divisions / 2;
			var step = size / divisions;
			var halfSize = size / 2;
	
			var vertices = [], colors = [];
	
			for ( var i = 0, j = 0, k = - halfSize; i <= divisions; i ++, k += step ) {
	
				vertices.push( - halfSize, 0, k, halfSize, 0, k );
				vertices.push( k, 0, - halfSize, k, 0, halfSize );
	
				var color = i === center ? color1 : color2;
	
				color.toArray( colors, j ); j += 3;
				color.toArray( colors, j ); j += 3;
				color.toArray( colors, j ); j += 3;
				color.toArray( colors, j ); j += 3;
	
			}
	
			var geometry = new BufferGeometry();
			geometry.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
			geometry.addAttribute( 'color', new Float32BufferAttribute( colors, 3 ) );
	
			var material = new LineBasicMaterial( { vertexColors: VertexColors } );
	
			LineSegments.call( this, geometry, material );
	
		}
	
		GridHelper.prototype = Object.create( LineSegments.prototype );
		GridHelper.prototype.constructor = GridHelper;
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author Mugen87 / http://github.com/Mugen87
		 * @author Hectate / http://www.github.com/Hectate
		 */
	
		function PolarGridHelper( radius, radials, circles, divisions, color1, color2 ) {
	
			radius = radius || 10;
			radials = radials || 16;
			circles = circles || 8;
			divisions = divisions || 64;
			color1 = new Color( color1 !== undefined ? color1 : 0x444444 );
			color2 = new Color( color2 !== undefined ? color2 : 0x888888 );
	
			var vertices = [];
			var colors = [];
	
			var x, z;
			var v, i, j, r, color;
	
			// create the radials
	
			for ( i = 0; i <= radials; i ++ ) {
	
				v = ( i / radials ) * ( Math.PI * 2 );
	
				x = Math.sin( v ) * radius;
				z = Math.cos( v ) * radius;
	
				vertices.push( 0, 0, 0 );
				vertices.push( x, 0, z );
	
				color = ( i & 1 ) ? color1 : color2;
	
				colors.push( color.r, color.g, color.b );
				colors.push( color.r, color.g, color.b );
	
			}
	
			// create the circles
	
			for ( i = 0; i <= circles; i ++ ) {
	
				color = ( i & 1 ) ? color1 : color2;
	
				r = radius - ( radius / circles * i );
	
				for ( j = 0; j < divisions; j ++ ) {
	
					// first vertex
	
					v = ( j / divisions ) * ( Math.PI * 2 );
	
					x = Math.sin( v ) * r;
					z = Math.cos( v ) * r;
	
					vertices.push( x, 0, z );
					colors.push( color.r, color.g, color.b );
	
					// second vertex
	
					v = ( ( j + 1 ) / divisions ) * ( Math.PI * 2 );
	
					x = Math.sin( v ) * r;
					z = Math.cos( v ) * r;
	
					vertices.push( x, 0, z );
					colors.push( color.r, color.g, color.b );
	
				}
	
			}
	
			var geometry = new BufferGeometry();
			geometry.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
			geometry.addAttribute( 'color', new Float32BufferAttribute( colors, 3 ) );
	
			var material = new LineBasicMaterial( { vertexColors: VertexColors } );
	
			LineSegments.call( this, geometry, material );
	
		}
	
		PolarGridHelper.prototype = Object.create( LineSegments.prototype );
		PolarGridHelper.prototype.constructor = PolarGridHelper;
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author WestLangley / http://github.com/WestLangley
		 */
	
		function FaceNormalsHelper( object, size, hex, linewidth ) {
	
			// FaceNormalsHelper only supports THREE.Geometry
	
			this.object = object;
	
			this.size = ( size !== undefined ) ? size : 1;
	
			var color = ( hex !== undefined ) ? hex : 0xffff00;
	
			var width = ( linewidth !== undefined ) ? linewidth : 1;
	
			//
	
			var nNormals = 0;
	
			var objGeometry = this.object.geometry;
	
			if ( objGeometry && objGeometry.isGeometry ) {
	
				nNormals = objGeometry.faces.length;
	
			} else {
	
				console.warn( 'THREE.FaceNormalsHelper: only THREE.Geometry is supported. Use THREE.VertexNormalsHelper, instead.' );
	
			}
	
			//
	
			var geometry = new BufferGeometry();
	
			var positions = new Float32BufferAttribute( nNormals * 2 * 3, 3 );
	
			geometry.addAttribute( 'position', positions );
	
			LineSegments.call( this, geometry, new LineBasicMaterial( { color: color, linewidth: width } ) );
	
			//
	
			this.matrixAutoUpdate = false;
			this.update();
	
		}
	
		FaceNormalsHelper.prototype = Object.create( LineSegments.prototype );
		FaceNormalsHelper.prototype.constructor = FaceNormalsHelper;
	
		FaceNormalsHelper.prototype.update = ( function () {
	
			var v1 = new Vector3();
			var v2 = new Vector3();
			var normalMatrix = new Matrix3();
	
			return function update() {
	
				this.object.updateMatrixWorld( true );
	
				normalMatrix.getNormalMatrix( this.object.matrixWorld );
	
				var matrixWorld = this.object.matrixWorld;
	
				var position = this.geometry.attributes.position;
	
				//
	
				var objGeometry = this.object.geometry;
	
				var vertices = objGeometry.vertices;
	
				var faces = objGeometry.faces;
	
				var idx = 0;
	
				for ( var i = 0, l = faces.length; i < l; i ++ ) {
	
					var face = faces[ i ];
	
					var normal = face.normal;
	
					v1.copy( vertices[ face.a ] )
						.add( vertices[ face.b ] )
						.add( vertices[ face.c ] )
						.divideScalar( 3 )
						.applyMatrix4( matrixWorld );
	
					v2.copy( normal ).applyMatrix3( normalMatrix ).normalize().multiplyScalar( this.size ).add( v1 );
	
					position.setXYZ( idx, v1.x, v1.y, v1.z );
	
					idx = idx + 1;
	
					position.setXYZ( idx, v2.x, v2.y, v2.z );
	
					idx = idx + 1;
	
				}
	
				position.needsUpdate = true;
	
			};
	
		}() );
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 * @author mrdoob / http://mrdoob.com/
		 * @author WestLangley / http://github.com/WestLangley
		 */
	
		function DirectionalLightHelper( light, size, color ) {
	
			Object3D.call( this );
	
			this.light = light;
			this.light.updateMatrixWorld();
	
			this.matrix = light.matrixWorld;
			this.matrixAutoUpdate = false;
	
			this.color = color;
	
			if ( size === undefined ) size = 1;
	
			var geometry = new BufferGeometry();
			geometry.addAttribute( 'position', new Float32BufferAttribute( [
				- size, size, 0,
				size, size, 0,
				size, - size, 0,
				- size, - size, 0,
				- size, size, 0
			], 3 ) );
	
			var material = new LineBasicMaterial( { fog: false } );
	
			this.lightPlane = new Line( geometry, material );
			this.add( this.lightPlane );
	
			geometry = new BufferGeometry();
			geometry.addAttribute( 'position', new Float32BufferAttribute( [ 0, 0, 0, 0, 0, 1 ], 3 ) );
	
			this.targetLine = new Line( geometry, material );
			this.add( this.targetLine );
	
			this.update();
	
		}
	
		DirectionalLightHelper.prototype = Object.create( Object3D.prototype );
		DirectionalLightHelper.prototype.constructor = DirectionalLightHelper;
	
		DirectionalLightHelper.prototype.dispose = function () {
	
			this.lightPlane.geometry.dispose();
			this.lightPlane.material.dispose();
			this.targetLine.geometry.dispose();
			this.targetLine.material.dispose();
	
		};
	
		DirectionalLightHelper.prototype.update = function () {
	
			var v1 = new Vector3();
			var v2 = new Vector3();
			var v3 = new Vector3();
	
			return function update() {
	
				v1.setFromMatrixPosition( this.light.matrixWorld );
				v2.setFromMatrixPosition( this.light.target.matrixWorld );
				v3.subVectors( v2, v1 );
	
				this.lightPlane.lookAt( v3 );
	
				if ( this.color !== undefined ) {
	
					this.lightPlane.material.color.set( this.color );
					this.targetLine.material.color.set( this.color );
	
				} else {
	
					this.lightPlane.material.color.copy( this.light.color );
					this.targetLine.material.color.copy( this.light.color );
	
				}
	
				this.targetLine.lookAt( v3 );
				this.targetLine.scale.z = v3.length();
	
			};
	
		}();
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 * @author Mugen87 / https://github.com/Mugen87
		 *
		 *	- shows frustum, line of sight and up of the camera
		 *	- suitable for fast updates
		 * 	- based on frustum visualization in lightgl.js shadowmap example
		 *		http://evanw.github.com/lightgl.js/tests/shadowmap.html
		 */
	
		function CameraHelper( camera ) {
	
			var geometry = new BufferGeometry();
			var material = new LineBasicMaterial( { color: 0xffffff, vertexColors: FaceColors } );
	
			var vertices = [];
			var colors = [];
	
			var pointMap = {};
	
			// colors
	
			var colorFrustum = new Color( 0xffaa00 );
			var colorCone = new Color( 0xff0000 );
			var colorUp = new Color( 0x00aaff );
			var colorTarget = new Color( 0xffffff );
			var colorCross = new Color( 0x333333 );
	
			// near
	
			addLine( 'n1', 'n2', colorFrustum );
			addLine( 'n2', 'n4', colorFrustum );
			addLine( 'n4', 'n3', colorFrustum );
			addLine( 'n3', 'n1', colorFrustum );
	
			// far
	
			addLine( 'f1', 'f2', colorFrustum );
			addLine( 'f2', 'f4', colorFrustum );
			addLine( 'f4', 'f3', colorFrustum );
			addLine( 'f3', 'f1', colorFrustum );
	
			// sides
	
			addLine( 'n1', 'f1', colorFrustum );
			addLine( 'n2', 'f2', colorFrustum );
			addLine( 'n3', 'f3', colorFrustum );
			addLine( 'n4', 'f4', colorFrustum );
	
			// cone
	
			addLine( 'p', 'n1', colorCone );
			addLine( 'p', 'n2', colorCone );
			addLine( 'p', 'n3', colorCone );
			addLine( 'p', 'n4', colorCone );
	
			// up
	
			addLine( 'u1', 'u2', colorUp );
			addLine( 'u2', 'u3', colorUp );
			addLine( 'u3', 'u1', colorUp );
	
			// target
	
			addLine( 'c', 't', colorTarget );
			addLine( 'p', 'c', colorCross );
	
			// cross
	
			addLine( 'cn1', 'cn2', colorCross );
			addLine( 'cn3', 'cn4', colorCross );
	
			addLine( 'cf1', 'cf2', colorCross );
			addLine( 'cf3', 'cf4', colorCross );
	
			function addLine( a, b, color ) {
	
				addPoint( a, color );
				addPoint( b, color );
	
			}
	
			function addPoint( id, color ) {
	
				vertices.push( 0, 0, 0 );
				colors.push( color.r, color.g, color.b );
	
				if ( pointMap[ id ] === undefined ) {
	
					pointMap[ id ] = [];
	
				}
	
				pointMap[ id ].push( ( vertices.length / 3 ) - 1 );
	
			}
	
			geometry.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
			geometry.addAttribute( 'color', new Float32BufferAttribute( colors, 3 ) );
	
			LineSegments.call( this, geometry, material );
	
			this.camera = camera;
			if ( this.camera.updateProjectionMatrix ) this.camera.updateProjectionMatrix();
	
			this.matrix = camera.matrixWorld;
			this.matrixAutoUpdate = false;
	
			this.pointMap = pointMap;
	
			this.update();
	
		}
	
		CameraHelper.prototype = Object.create( LineSegments.prototype );
		CameraHelper.prototype.constructor = CameraHelper;
	
		CameraHelper.prototype.update = function () {
	
			var geometry, pointMap;
	
			var vector = new Vector3();
			var camera = new Camera();
	
			function setPoint( point, x, y, z ) {
	
				vector.set( x, y, z ).unproject( camera );
	
				var points = pointMap[ point ];
	
				if ( points !== undefined ) {
	
					var position = geometry.getAttribute( 'position' );
	
					for ( var i = 0, l = points.length; i < l; i ++ ) {
	
						position.setXYZ( points[ i ], vector.x, vector.y, vector.z );
	
					}
	
				}
	
			}
	
			return function update() {
	
				geometry = this.geometry;
				pointMap = this.pointMap;
	
				var w = 1, h = 1;
	
				// we need just camera projection matrix
				// world matrix must be identity
	
				camera.projectionMatrix.copy( this.camera.projectionMatrix );
	
				// center / target
	
				setPoint( 'c', 0, 0, - 1 );
				setPoint( 't', 0, 0, 1 );
	
				// near
	
				setPoint( 'n1', - w, - h, - 1 );
				setPoint( 'n2', w, - h, - 1 );
				setPoint( 'n3', - w, h, - 1 );
				setPoint( 'n4', w, h, - 1 );
	
				// far
	
				setPoint( 'f1', - w, - h, 1 );
				setPoint( 'f2', w, - h, 1 );
				setPoint( 'f3', - w, h, 1 );
				setPoint( 'f4', w, h, 1 );
	
				// up
	
				setPoint( 'u1', w * 0.7, h * 1.1, - 1 );
				setPoint( 'u2', - w * 0.7, h * 1.1, - 1 );
				setPoint( 'u3', 0, h * 2, - 1 );
	
				// cross
	
				setPoint( 'cf1', - w, 0, 1 );
				setPoint( 'cf2', w, 0, 1 );
				setPoint( 'cf3', 0, - h, 1 );
				setPoint( 'cf4', 0, h, 1 );
	
				setPoint( 'cn1', - w, 0, - 1 );
				setPoint( 'cn2', w, 0, - 1 );
				setPoint( 'cn3', 0, - h, - 1 );
				setPoint( 'cn4', 0, h, - 1 );
	
				geometry.getAttribute( 'position' ).needsUpdate = true;
	
			};
	
		}();
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 * @author Mugen87 / http://github.com/Mugen87
		 */
	
		function BoxHelper( object, color ) {
	
			this.object = object;
	
			if ( color === undefined ) color = 0xffff00;
	
			var indices = new Uint16Array( [ 0, 1, 1, 2, 2, 3, 3, 0, 4, 5, 5, 6, 6, 7, 7, 4, 0, 4, 1, 5, 2, 6, 3, 7 ] );
			var positions = new Float32Array( 8 * 3 );
	
			var geometry = new BufferGeometry();
			geometry.setIndex( new BufferAttribute( indices, 1 ) );
			geometry.addAttribute( 'position', new BufferAttribute( positions, 3 ) );
	
			LineSegments.call( this, geometry, new LineBasicMaterial( { color: color } ) );
	
			this.matrixAutoUpdate = false;
	
			this.update();
	
		}
	
		BoxHelper.prototype = Object.create( LineSegments.prototype );
		BoxHelper.prototype.constructor = BoxHelper;
	
		BoxHelper.prototype.update = ( function () {
	
			var box = new Box3();
	
			return function update( object ) {
	
				if ( object !== undefined ) {
	
					console.warn( 'THREE.BoxHelper: .update() has no longer arguments.' );
	
				}
	
				if ( this.object !== undefined ) {
	
					box.setFromObject( this.object );
	
				}
	
				if ( box.isEmpty() ) return;
	
				var min = box.min;
				var max = box.max;
	
				/*
				  5____4
				1/___0/|
				| 6__|_7
				2/___3/
	
				0: max.x, max.y, max.z
				1: min.x, max.y, max.z
				2: min.x, min.y, max.z
				3: max.x, min.y, max.z
				4: max.x, max.y, min.z
				5: min.x, max.y, min.z
				6: min.x, min.y, min.z
				7: max.x, min.y, min.z
				*/
	
				var position = this.geometry.attributes.position;
				var array = position.array;
	
				array[ 0 ] = max.x; array[ 1 ] = max.y; array[ 2 ] = max.z;
				array[ 3 ] = min.x; array[ 4 ] = max.y; array[ 5 ] = max.z;
				array[ 6 ] = min.x; array[ 7 ] = min.y; array[ 8 ] = max.z;
				array[ 9 ] = max.x; array[ 10 ] = min.y; array[ 11 ] = max.z;
				array[ 12 ] = max.x; array[ 13 ] = max.y; array[ 14 ] = min.z;
				array[ 15 ] = min.x; array[ 16 ] = max.y; array[ 17 ] = min.z;
				array[ 18 ] = min.x; array[ 19 ] = min.y; array[ 20 ] = min.z;
				array[ 21 ] = max.x; array[ 22 ] = min.y; array[ 23 ] = min.z;
	
				position.needsUpdate = true;
	
				this.geometry.computeBoundingSphere();
	
			};
	
		} )();
	
		BoxHelper.prototype.setFromObject = function ( object ) {
	
			this.object = object;
			this.update();
	
			return this;
	
		};
	
		/**
		 * @author WestLangley / http://github.com/WestLangley
		 */
	
		function Box3Helper( box, hex ) {
	
			this.type = 'Box3Helper';
	
			this.box = box;
	
			var color = ( hex !== undefined ) ? hex : 0xffff00;
	
			var indices = new Uint16Array( [ 0, 1, 1, 2, 2, 3, 3, 0, 4, 5, 5, 6, 6, 7, 7, 4, 0, 4, 1, 5, 2, 6, 3, 7 ] );
	
			var positions = [ 1, 1, 1, - 1, 1, 1, - 1, - 1, 1, 1, - 1, 1, 1, 1, - 1, - 1, 1, - 1, - 1, - 1, - 1, 1, - 1, - 1 ];
	
			var geometry = new BufferGeometry();
	
			geometry.setIndex( new BufferAttribute( indices, 1 ) );
	
			geometry.addAttribute( 'position', new Float32BufferAttribute( positions, 3 ) );
	
			LineSegments.call( this, geometry, new LineBasicMaterial( { color: color } ) );
	
			this.geometry.computeBoundingSphere();
	
		}
	
		Box3Helper.prototype = Object.create( LineSegments.prototype );
		Box3Helper.prototype.constructor = Box3Helper;
	
		Box3Helper.prototype.updateMatrixWorld = function ( force ) {
	
			var box = this.box;
	
			if ( box.isEmpty() ) return;
	
			box.getCenter( this.position );
	
			box.getSize( this.scale );
	
			this.scale.multiplyScalar( 0.5 );
	
			Object3D.prototype.updateMatrixWorld.call( this, force );
	
		};
	
		/**
		 * @author WestLangley / http://github.com/WestLangley
		 */
	
		function PlaneHelper( plane, size, hex ) {
	
			this.type = 'PlaneHelper';
	
			this.plane = plane;
	
			this.size = ( size === undefined ) ? 1 : size;
	
			var color = ( hex !== undefined ) ? hex : 0xffff00;
	
			var positions = [ 1, - 1, 1, - 1, 1, 1, - 1, - 1, 1, 1, 1, 1, - 1, 1, 1, - 1, - 1, 1, 1, - 1, 1, 1, 1, 1, 0, 0, 1, 0, 0, 0 ];
	
			var geometry = new BufferGeometry();
			geometry.addAttribute( 'position', new Float32BufferAttribute( positions, 3 ) );
			geometry.computeBoundingSphere();
	
			Line.call( this, geometry, new LineBasicMaterial( { color: color } ) );
	
			//
	
			var positions2 = [ 1, 1, 1, - 1, 1, 1, - 1, - 1, 1, 1, 1, 1, - 1, - 1, 1, 1, - 1, 1 ];
	
			var geometry2 = new BufferGeometry();
			geometry2.addAttribute( 'position', new Float32BufferAttribute( positions2, 3 ) );
			geometry2.computeBoundingSphere();
	
			this.add( new Mesh( geometry2, new MeshBasicMaterial( { color: color, opacity: 0.2, transparent: true, depthWrite: false } ) ) );
	
		}
	
		PlaneHelper.prototype = Object.create( Line.prototype );
		PlaneHelper.prototype.constructor = PlaneHelper;
	
		PlaneHelper.prototype.updateMatrixWorld = function ( force ) {
	
			var scale = - this.plane.constant;
	
			if ( Math.abs( scale ) < 1e-8 ) scale = 1e-8; // sign does not matter
	
			this.scale.set( 0.5 * this.size, 0.5 * this.size, scale );
	
			this.lookAt( this.plane.normal );
	
			Object3D.prototype.updateMatrixWorld.call( this, force );
	
		};
	
		/**
		 * @author WestLangley / http://github.com/WestLangley
		 * @author zz85 / http://github.com/zz85
		 * @author bhouston / http://clara.io
		 *
		 * Creates an arrow for visualizing directions
		 *
		 * Parameters:
		 *  dir - Vector3
		 *  origin - Vector3
		 *  length - Number
		 *  color - color in hex value
		 *  headLength - Number
		 *  headWidth - Number
		 */
	
		var lineGeometry;
		var coneGeometry;
	
		function ArrowHelper( dir, origin, length, color, headLength, headWidth ) {
	
			// dir is assumed to be normalized
	
			Object3D.call( this );
	
			if ( color === undefined ) color = 0xffff00;
			if ( length === undefined ) length = 1;
			if ( headLength === undefined ) headLength = 0.2 * length;
			if ( headWidth === undefined ) headWidth = 0.2 * headLength;
	
			if ( lineGeometry === undefined ) {
	
				lineGeometry = new BufferGeometry();
				lineGeometry.addAttribute( 'position', new Float32BufferAttribute( [ 0, 0, 0, 0, 1, 0 ], 3 ) );
	
				coneGeometry = new CylinderBufferGeometry( 0, 0.5, 1, 5, 1 );
				coneGeometry.translate( 0, - 0.5, 0 );
	
			}
	
			this.position.copy( origin );
	
			this.line = new Line( lineGeometry, new LineBasicMaterial( { color: color } ) );
			this.line.matrixAutoUpdate = false;
			this.add( this.line );
	
			this.cone = new Mesh( coneGeometry, new MeshBasicMaterial( { color: color } ) );
			this.cone.matrixAutoUpdate = false;
			this.add( this.cone );
	
			this.setDirection( dir );
			this.setLength( length, headLength, headWidth );
	
		}
	
		ArrowHelper.prototype = Object.create( Object3D.prototype );
		ArrowHelper.prototype.constructor = ArrowHelper;
	
		ArrowHelper.prototype.setDirection = ( function () {
	
			var axis = new Vector3();
			var radians;
	
			return function setDirection( dir ) {
	
				// dir is assumed to be normalized
	
				if ( dir.y > 0.99999 ) {
	
					this.quaternion.set( 0, 0, 0, 1 );
	
				} else if ( dir.y < - 0.99999 ) {
	
					this.quaternion.set( 1, 0, 0, 0 );
	
				} else {
	
					axis.set( dir.z, 0, - dir.x ).normalize();
	
					radians = Math.acos( dir.y );
	
					this.quaternion.setFromAxisAngle( axis, radians );
	
				}
	
			};
	
		}() );
	
		ArrowHelper.prototype.setLength = function ( length, headLength, headWidth ) {
	
			if ( headLength === undefined ) headLength = 0.2 * length;
			if ( headWidth === undefined ) headWidth = 0.2 * headLength;
	
			this.line.scale.set( 1, Math.max( 0, length - headLength ), 1 );
			this.line.updateMatrix();
	
			this.cone.scale.set( headWidth, headLength, headWidth );
			this.cone.position.y = length;
			this.cone.updateMatrix();
	
		};
	
		ArrowHelper.prototype.setColor = function ( color ) {
	
			this.line.material.color.copy( color );
			this.cone.material.color.copy( color );
	
		};
	
		/**
		 * @author sroucheray / http://sroucheray.org/
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function AxesHelper( size ) {
	
			size = size || 1;
	
			var vertices = [
				0, 0, 0,	size, 0, 0,
				0, 0, 0,	0, size, 0,
				0, 0, 0,	0, 0, size
			];
	
			var colors = [
				1, 0, 0,	1, 0.6, 0,
				0, 1, 0,	0.6, 1, 0,
				0, 0, 1,	0, 0.6, 1
			];
	
			var geometry = new BufferGeometry();
			geometry.addAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
			geometry.addAttribute( 'color', new Float32BufferAttribute( colors, 3 ) );
	
			var material = new LineBasicMaterial( { vertexColors: VertexColors } );
	
			LineSegments.call( this, geometry, material );
	
		}
	
		AxesHelper.prototype = Object.create( LineSegments.prototype );
		AxesHelper.prototype.constructor = AxesHelper;
	
		/**
		 * @author alteredq / http://alteredqualia.com/
		 */
	
		var SceneUtils = {
	
			createMultiMaterialObject: function ( geometry, materials ) {
	
				var group = new Group();
	
				for ( var i = 0, l = materials.length; i < l; i ++ ) {
	
					group.add( new Mesh( geometry, materials[ i ] ) );
	
				}
	
				return group;
	
			},
	
			detach: function ( child, parent, scene ) {
	
				child.applyMatrix( parent.matrixWorld );
				parent.remove( child );
				scene.add( child );
	
			},
	
			attach: function ( child, scene, parent ) {
	
				child.applyMatrix( new Matrix4().getInverse( parent.matrixWorld ) );
	
				scene.remove( child );
				parent.add( child );
	
			}
	
		};
	
		/**
		 * @author mrdoob / http://mrdoob.com/
		 */
	
		function Face4( a, b, c, d, normal, color, materialIndex ) {
	
			console.warn( 'THREE.Face4 has been removed. A THREE.Face3 will be created instead.' );
			return new Face3( a, b, c, normal, color, materialIndex );
	
		}
	
		var LineStrip = 0;
	
		var LinePieces = 1;
	
		function MeshFaceMaterial( materials ) {
	
			console.warn( 'THREE.MeshFaceMaterial has been removed. Use an Array instead.' );
			return materials;
	
		}
	
		function MultiMaterial( materials ) {
	
			if ( materials === undefined ) materials = [];
	
			console.warn( 'THREE.MultiMaterial has been removed. Use an Array instead.' );
			materials.isMultiMaterial = true;
			materials.materials = materials;
			materials.clone = function () {
	
				return materials.slice();
	
			};
			return materials;
	
		}
	
		function PointCloud( geometry, material ) {
	
			console.warn( 'THREE.PointCloud has been renamed to THREE.Points.' );
			return new Points( geometry, material );
	
		}
	
		function Particle( material ) {
	
			console.warn( 'THREE.Particle has been renamed to THREE.Sprite.' );
			return new Sprite( material );
	
		}
	
		function ParticleSystem( geometry, material ) {
	
			console.warn( 'THREE.ParticleSystem has been renamed to THREE.Points.' );
			return new Points( geometry, material );
	
		}
	
		function PointCloudMaterial( parameters ) {
	
			console.warn( 'THREE.PointCloudMaterial has been renamed to THREE.PointsMaterial.' );
			return new PointsMaterial( parameters );
	
		}
	
		function ParticleBasicMaterial( parameters ) {
	
			console.warn( 'THREE.ParticleBasicMaterial has been renamed to THREE.PointsMaterial.' );
			return new PointsMaterial( parameters );
	
		}
	
		function ParticleSystemMaterial( parameters ) {
	
			console.warn( 'THREE.ParticleSystemMaterial has been renamed to THREE.PointsMaterial.' );
			return new PointsMaterial( parameters );
	
		}
	
		function Vertex( x, y, z ) {
	
			console.warn( 'THREE.Vertex has been removed. Use THREE.Vector3 instead.' );
			return new Vector3( x, y, z );
	
		}
	
		//
	
		function DynamicBufferAttribute( array, itemSize ) {
	
			console.warn( 'THREE.DynamicBufferAttribute has been removed. Use new THREE.BufferAttribute().setDynamic( true ) instead.' );
			return new BufferAttribute( array, itemSize ).setDynamic( true );
	
		}
	
		function Int8Attribute( array, itemSize ) {
	
			console.warn( 'THREE.Int8Attribute has been removed. Use new THREE.Int8BufferAttribute() instead.' );
			return new Int8BufferAttribute( array, itemSize );
	
		}
	
		function Uint8Attribute( array, itemSize ) {
	
			console.warn( 'THREE.Uint8Attribute has been removed. Use new THREE.Uint8BufferAttribute() instead.' );
			return new Uint8BufferAttribute( array, itemSize );
	
		}
	
		function Uint8ClampedAttribute( array, itemSize ) {
	
			console.warn( 'THREE.Uint8ClampedAttribute has been removed. Use new THREE.Uint8ClampedBufferAttribute() instead.' );
			return new Uint8ClampedBufferAttribute( array, itemSize );
	
		}
	
		function Int16Attribute( array, itemSize ) {
	
			console.warn( 'THREE.Int16Attribute has been removed. Use new THREE.Int16BufferAttribute() instead.' );
			return new Int16BufferAttribute( array, itemSize );
	
		}
	
		function Uint16Attribute( array, itemSize ) {
	
			console.warn( 'THREE.Uint16Attribute has been removed. Use new THREE.Uint16BufferAttribute() instead.' );
			return new Uint16BufferAttribute( array, itemSize );
	
		}
	
		function Int32Attribute( array, itemSize ) {
	
			console.warn( 'THREE.Int32Attribute has been removed. Use new THREE.Int32BufferAttribute() instead.' );
			return new Int32BufferAttribute( array, itemSize );
	
		}
	
		function Uint32Attribute( array, itemSize ) {
	
			console.warn( 'THREE.Uint32Attribute has been removed. Use new THREE.Uint32BufferAttribute() instead.' );
			return new Uint32BufferAttribute( array, itemSize );
	
		}
	
		function Float32Attribute( array, itemSize ) {
	
			console.warn( 'THREE.Float32Attribute has been removed. Use new THREE.Float32BufferAttribute() instead.' );
			return new Float32BufferAttribute( array, itemSize );
	
		}
	
		function Float64Attribute( array, itemSize ) {
	
			console.warn( 'THREE.Float64Attribute has been removed. Use new THREE.Float64BufferAttribute() instead.' );
			return new Float64BufferAttribute( array, itemSize );
	
		}
	
		//
	
		Curve.create = function ( construct, getPoint ) {
	
			console.log( 'THREE.Curve.create() has been deprecated' );
	
			construct.prototype = Object.create( Curve.prototype );
			construct.prototype.constructor = construct;
			construct.prototype.getPoint = getPoint;
	
			return construct;
	
		};
	
		//
	
		Object.assign( CurvePath.prototype, {
	
			createPointsGeometry: function ( divisions ) {
	
				console.warn( 'THREE.CurvePath: .createPointsGeometry() has been removed. Use new THREE.Geometry().setFromPoints( points ) instead.' );
	
				// generate geometry from path points (for Line or Points objects)
	
				var pts = this.getPoints( divisions );
				return this.createGeometry( pts );
	
			},
	
			createSpacedPointsGeometry: function ( divisions ) {
	
				console.warn( 'THREE.CurvePath: .createSpacedPointsGeometry() has been removed. Use new THREE.Geometry().setFromPoints( points ) instead.' );
	
				// generate geometry from equidistant sampling along the path
	
				var pts = this.getSpacedPoints( divisions );
				return this.createGeometry( pts );
	
			},
	
			createGeometry: function ( points ) {
	
				console.warn( 'THREE.CurvePath: .createGeometry() has been removed. Use new THREE.Geometry().setFromPoints( points ) instead.' );
	
				var geometry = new Geometry();
	
				for ( var i = 0, l = points.length; i < l; i ++ ) {
	
					var point = points[ i ];
					geometry.vertices.push( new Vector3( point.x, point.y, point.z || 0 ) );
	
				}
	
				return geometry;
	
			}
	
		} );
	
		//
	
		Object.assign( Path.prototype, {
	
			fromPoints: function ( points ) {
	
				console.warn( 'THREE.Path: .fromPoints() has been renamed to .setFromPoints().' );
				this.setFromPoints( points );
	
			}
	
		} );
	
		//
	
		function ClosedSplineCurve3( points ) {
	
			console.warn( 'THREE.ClosedSplineCurve3 has been deprecated. Use THREE.CatmullRomCurve3 instead.' );
	
			CatmullRomCurve3.call( this, points );
			this.type = 'catmullrom';
			this.closed = true;
	
		}
	
		ClosedSplineCurve3.prototype = Object.create( CatmullRomCurve3.prototype );
	
		//
	
		function SplineCurve3( points ) {
	
			console.warn( 'THREE.SplineCurve3 has been deprecated. Use THREE.CatmullRomCurve3 instead.' );
	
			CatmullRomCurve3.call( this, points );
			this.type = 'catmullrom';
	
		}
	
		SplineCurve3.prototype = Object.create( CatmullRomCurve3.prototype );
	
		//
	
		function Spline( points ) {
	
			console.warn( 'THREE.Spline has been removed. Use THREE.CatmullRomCurve3 instead.' );
	
			CatmullRomCurve3.call( this, points );
			this.type = 'catmullrom';
	
		}
	
		Spline.prototype = Object.create( CatmullRomCurve3.prototype );
	
		Object.assign( Spline.prototype, {
	
			initFromArray: function ( /* a */ ) {
	
				console.error( 'THREE.Spline: .initFromArray() has been removed.' );
	
			},
			getControlPointsArray: function ( /* optionalTarget */ ) {
	
				console.error( 'THREE.Spline: .getControlPointsArray() has been removed.' );
	
			},
			reparametrizeByArcLength: function ( /* samplingCoef */ ) {
	
				console.error( 'THREE.Spline: .reparametrizeByArcLength() has been removed.' );
	
			}
	
		} );
	
		//
	
		function AxisHelper( size ) {
	
			console.warn( 'THREE.AxisHelper has been renamed to THREE.AxesHelper.' );
			return new AxesHelper( size );
	
		}
	
		function BoundingBoxHelper( object, color ) {
	
			console.warn( 'THREE.BoundingBoxHelper has been deprecated. Creating a THREE.BoxHelper instead.' );
			return new BoxHelper( object, color );
	
		}
	
		function EdgesHelper( object, hex ) {
	
			console.warn( 'THREE.EdgesHelper has been removed. Use THREE.EdgesGeometry instead.' );
			return new LineSegments( new EdgesGeometry( object.geometry ), new LineBasicMaterial( { color: hex !== undefined ? hex : 0xffffff } ) );
	
		}
	
		GridHelper.prototype.setColors = function () {
	
			console.error( 'THREE.GridHelper: setColors() has been deprecated, pass them in the constructor instead.' );
	
		};
	
		SkeletonHelper.prototype.update = function () {
	
			console.error( 'THREE.SkeletonHelper: update() no longer needs to be called.' );
	
		};
	
		function WireframeHelper( object, hex ) {
	
			console.warn( 'THREE.WireframeHelper has been removed. Use THREE.WireframeGeometry instead.' );
			return new LineSegments( new WireframeGeometry( object.geometry ), new LineBasicMaterial( { color: hex !== undefined ? hex : 0xffffff } ) );
	
		}
	
		//
	
		Object.assign( Loader.prototype, {
	
			extractUrlBase: function ( url ) {
	
				console.warn( 'THREE.Loader: .extractUrlBase() has been deprecated. Use THREE.LoaderUtils.extractUrlBase() instead.' );
				return LoaderUtils.extractUrlBase( url );
	
			}
	
		} );
	
		function XHRLoader( manager ) {
	
			console.warn( 'THREE.XHRLoader has been renamed to THREE.FileLoader.' );
			return new FileLoader( manager );
	
		}
	
		function BinaryTextureLoader( manager ) {
	
			console.warn( 'THREE.BinaryTextureLoader has been renamed to THREE.DataTextureLoader.' );
			return new DataTextureLoader( manager );
	
		}
	
		//
	
		Object.assign( Box2.prototype, {
	
			center: function ( optionalTarget ) {
	
				console.warn( 'THREE.Box2: .center() has been renamed to .getCenter().' );
				return this.getCenter( optionalTarget );
	
			},
			empty: function () {
	
				console.warn( 'THREE.Box2: .empty() has been renamed to .isEmpty().' );
				return this.isEmpty();
	
			},
			isIntersectionBox: function ( box ) {
	
				console.warn( 'THREE.Box2: .isIntersectionBox() has been renamed to .intersectsBox().' );
				return this.intersectsBox( box );
	
			},
			size: function ( optionalTarget ) {
	
				console.warn( 'THREE.Box2: .size() has been renamed to .getSize().' );
				return this.getSize( optionalTarget );
	
			}
		} );
	
		Object.assign( Box3.prototype, {
	
			center: function ( optionalTarget ) {
	
				console.warn( 'THREE.Box3: .center() has been renamed to .getCenter().' );
				return this.getCenter( optionalTarget );
	
			},
			empty: function () {
	
				console.warn( 'THREE.Box3: .empty() has been renamed to .isEmpty().' );
				return this.isEmpty();
	
			},
			isIntersectionBox: function ( box ) {
	
				console.warn( 'THREE.Box3: .isIntersectionBox() has been renamed to .intersectsBox().' );
				return this.intersectsBox( box );
	
			},
			isIntersectionSphere: function ( sphere ) {
	
				console.warn( 'THREE.Box3: .isIntersectionSphere() has been renamed to .intersectsSphere().' );
				return this.intersectsSphere( sphere );
	
			},
			size: function ( optionalTarget ) {
	
				console.warn( 'THREE.Box3: .size() has been renamed to .getSize().' );
				return this.getSize( optionalTarget );
	
			}
		} );
	
		Line3.prototype.center = function ( optionalTarget ) {
	
			console.warn( 'THREE.Line3: .center() has been renamed to .getCenter().' );
			return this.getCenter( optionalTarget );
	
		};
	
		Object.assign( _Math, {
	
			random16: function () {
	
				console.warn( 'THREE.Math: .random16() has been deprecated. Use Math.random() instead.' );
				return Math.random();
	
			},
	
			nearestPowerOfTwo: function ( value ) {
	
				console.warn( 'THREE.Math: .nearestPowerOfTwo() has been renamed to .floorPowerOfTwo().' );
				return _Math.floorPowerOfTwo( value );
	
			},
	
			nextPowerOfTwo: function ( value ) {
	
				console.warn( 'THREE.Math: .nextPowerOfTwo() has been renamed to .ceilPowerOfTwo().' );
				return _Math.ceilPowerOfTwo( value );
	
			}
	
		} );
	
		Object.assign( Matrix3.prototype, {
	
			flattenToArrayOffset: function ( array, offset ) {
	
				console.warn( "THREE.Matrix3: .flattenToArrayOffset() has been deprecated. Use .toArray() instead." );
				return this.toArray( array, offset );
	
			},
			multiplyVector3: function ( vector ) {
	
				console.warn( 'THREE.Matrix3: .multiplyVector3() has been removed. Use vector.applyMatrix3( matrix ) instead.' );
				return vector.applyMatrix3( this );
	
			},
			multiplyVector3Array: function ( /* a */ ) {
	
				console.error( 'THREE.Matrix3: .multiplyVector3Array() has been removed.' );
	
			},
			applyToBuffer: function ( buffer /*, offset, length */ ) {
	
				console.warn( 'THREE.Matrix3: .applyToBuffer() has been removed. Use matrix.applyToBufferAttribute( attribute ) instead.' );
				return this.applyToBufferAttribute( buffer );
	
			},
			applyToVector3Array: function ( /* array, offset, length */ ) {
	
				console.error( 'THREE.Matrix3: .applyToVector3Array() has been removed.' );
	
			}
	
		} );
	
		Object.assign( Matrix4.prototype, {
	
			extractPosition: function ( m ) {
	
				console.warn( 'THREE.Matrix4: .extractPosition() has been renamed to .copyPosition().' );
				return this.copyPosition( m );
	
			},
			flattenToArrayOffset: function ( array, offset ) {
	
				console.warn( "THREE.Matrix4: .flattenToArrayOffset() has been deprecated. Use .toArray() instead." );
				return this.toArray( array, offset );
	
			},
			getPosition: function () {
	
				var v1;
	
				return function getPosition() {
	
					if ( v1 === undefined ) v1 = new Vector3();
					console.warn( 'THREE.Matrix4: .getPosition() has been removed. Use Vector3.setFromMatrixPosition( matrix ) instead.' );
					return v1.setFromMatrixColumn( this, 3 );
	
				};
	
			}(),
			setRotationFromQuaternion: function ( q ) {
	
				console.warn( 'THREE.Matrix4: .setRotationFromQuaternion() has been renamed to .makeRotationFromQuaternion().' );
				return this.makeRotationFromQuaternion( q );
	
			},
			multiplyToArray: function () {
	
				console.warn( 'THREE.Matrix4: .multiplyToArray() has been removed.' );
	
			},
			multiplyVector3: function ( vector ) {
	
				console.warn( 'THREE.Matrix4: .multiplyVector3() has been removed. Use vector.applyMatrix4( matrix ) instead.' );
				return vector.applyMatrix4( this );
	
			},
			multiplyVector4: function ( vector ) {
	
				console.warn( 'THREE.Matrix4: .multiplyVector4() has been removed. Use vector.applyMatrix4( matrix ) instead.' );
				return vector.applyMatrix4( this );
	
			},
			multiplyVector3Array: function ( /* a */ ) {
	
				console.error( 'THREE.Matrix4: .multiplyVector3Array() has been removed.' );
	
			},
			rotateAxis: function ( v ) {
	
				console.warn( 'THREE.Matrix4: .rotateAxis() has been removed. Use Vector3.transformDirection( matrix ) instead.' );
				v.transformDirection( this );
	
			},
			crossVector: function ( vector ) {
	
				console.warn( 'THREE.Matrix4: .crossVector() has been removed. Use vector.applyMatrix4( matrix ) instead.' );
				return vector.applyMatrix4( this );
	
			},
			translate: function () {
	
				console.error( 'THREE.Matrix4: .translate() has been removed.' );
	
			},
			rotateX: function () {
	
				console.error( 'THREE.Matrix4: .rotateX() has been removed.' );
	
			},
			rotateY: function () {
	
				console.error( 'THREE.Matrix4: .rotateY() has been removed.' );
	
			},
			rotateZ: function () {
	
				console.error( 'THREE.Matrix4: .rotateZ() has been removed.' );
	
			},
			rotateByAxis: function () {
	
				console.error( 'THREE.Matrix4: .rotateByAxis() has been removed.' );
	
			},
			applyToBuffer: function ( buffer /*, offset, length */ ) {
	
				console.warn( 'THREE.Matrix4: .applyToBuffer() has been removed. Use matrix.applyToBufferAttribute( attribute ) instead.' );
				return this.applyToBufferAttribute( buffer );
	
			},
			applyToVector3Array: function ( /* array, offset, length */ ) {
	
				console.error( 'THREE.Matrix4: .applyToVector3Array() has been removed.' );
	
			},
			makeFrustum: function ( left, right, bottom, top, near, far ) {
	
				console.warn( 'THREE.Matrix4: .makeFrustum() has been removed. Use .makePerspective( left, right, top, bottom, near, far ) instead.' );
				return this.makePerspective( left, right, top, bottom, near, far );
	
			}
	
		} );
	
		Plane.prototype.isIntersectionLine = function ( line ) {
	
			console.warn( 'THREE.Plane: .isIntersectionLine() has been renamed to .intersectsLine().' );
			return this.intersectsLine( line );
	
		};
	
		Quaternion.prototype.multiplyVector3 = function ( vector ) {
	
			console.warn( 'THREE.Quaternion: .multiplyVector3() has been removed. Use is now vector.applyQuaternion( quaternion ) instead.' );
			return vector.applyQuaternion( this );
	
		};
	
		Object.assign( Ray.prototype, {
	
			isIntersectionBox: function ( box ) {
	
				console.warn( 'THREE.Ray: .isIntersectionBox() has been renamed to .intersectsBox().' );
				return this.intersectsBox( box );
	
			},
			isIntersectionPlane: function ( plane ) {
	
				console.warn( 'THREE.Ray: .isIntersectionPlane() has been renamed to .intersectsPlane().' );
				return this.intersectsPlane( plane );
	
			},
			isIntersectionSphere: function ( sphere ) {
	
				console.warn( 'THREE.Ray: .isIntersectionSphere() has been renamed to .intersectsSphere().' );
				return this.intersectsSphere( sphere );
	
			}
	
		} );
	
		Object.assign( Shape.prototype, {
	
			extractAllPoints: function ( divisions ) {
	
				console.warn( 'THREE.Shape: .extractAllPoints() has been removed. Use .extractPoints() instead.' );
				return this.extractPoints( divisions );
	
			},
			extrude: function ( options ) {
	
				console.warn( 'THREE.Shape: .extrude() has been removed. Use ExtrudeGeometry() instead.' );
				return new ExtrudeGeometry( this, options );
	
			},
			makeGeometry: function ( options ) {
	
				console.warn( 'THREE.Shape: .makeGeometry() has been removed. Use ShapeGeometry() instead.' );
				return new ShapeGeometry( this, options );
	
			}
	
		} );
	
		Object.assign( Vector2.prototype, {
	
			fromAttribute: function ( attribute, index, offset ) {
	
				console.warn( 'THREE.Vector2: .fromAttribute() has been renamed to .fromBufferAttribute().' );
				return this.fromBufferAttribute( attribute, index, offset );
	
			},
			distanceToManhattan: function ( v ) {
	
				console.warn( 'THREE.Vector2: .distanceToManhattan() has been renamed to .manhattanDistanceTo().' );
				return this.manhattanDistanceTo( v );
	
			},
			lengthManhattan: function () {
	
				console.warn( 'THREE.Vector2: .lengthManhattan() has been renamed to .manhattanLength().' );
				return this.manhattanLength();
	
			}
	
		} );
	
		Object.assign( Vector3.prototype, {
	
			setEulerFromRotationMatrix: function () {
	
				console.error( 'THREE.Vector3: .setEulerFromRotationMatrix() has been removed. Use Euler.setFromRotationMatrix() instead.' );
	
			},
			setEulerFromQuaternion: function () {
	
				console.error( 'THREE.Vector3: .setEulerFromQuaternion() has been removed. Use Euler.setFromQuaternion() instead.' );
	
			},
			getPositionFromMatrix: function ( m ) {
	
				console.warn( 'THREE.Vector3: .getPositionFromMatrix() has been renamed to .setFromMatrixPosition().' );
				return this.setFromMatrixPosition( m );
	
			},
			getScaleFromMatrix: function ( m ) {
	
				console.warn( 'THREE.Vector3: .getScaleFromMatrix() has been renamed to .setFromMatrixScale().' );
				return this.setFromMatrixScale( m );
	
			},
			getColumnFromMatrix: function ( index, matrix ) {
	
				console.warn( 'THREE.Vector3: .getColumnFromMatrix() has been renamed to .setFromMatrixColumn().' );
				return this.setFromMatrixColumn( matrix, index );
	
			},
			applyProjection: function ( m ) {
	
				console.warn( 'THREE.Vector3: .applyProjection() has been removed. Use .applyMatrix4( m ) instead.' );
				return this.applyMatrix4( m );
	
			},
			fromAttribute: function ( attribute, index, offset ) {
	
				console.warn( 'THREE.Vector3: .fromAttribute() has been renamed to .fromBufferAttribute().' );
				return this.fromBufferAttribute( attribute, index, offset );
	
			},
			distanceToManhattan: function ( v ) {
	
				console.warn( 'THREE.Vector3: .distanceToManhattan() has been renamed to .manhattanDistanceTo().' );
				return this.manhattanDistanceTo( v );
	
			},
			lengthManhattan: function () {
	
				console.warn( 'THREE.Vector3: .lengthManhattan() has been renamed to .manhattanLength().' );
				return this.manhattanLength();
	
			}
	
		} );
	
		Object.assign( Vector4.prototype, {
	
			fromAttribute: function ( attribute, index, offset ) {
	
				console.warn( 'THREE.Vector4: .fromAttribute() has been renamed to .fromBufferAttribute().' );
				return this.fromBufferAttribute( attribute, index, offset );
	
			},
			lengthManhattan: function () {
	
				console.warn( 'THREE.Vector4: .lengthManhattan() has been renamed to .manhattanLength().' );
				return this.manhattanLength();
	
			}
	
		} );
	
		//
	
		Geometry.prototype.computeTangents = function () {
	
			console.warn( 'THREE.Geometry: .computeTangents() has been removed.' );
	
		};
	
		Object.assign( Object3D.prototype, {
	
			getChildByName: function ( name ) {
	
				console.warn( 'THREE.Object3D: .getChildByName() has been renamed to .getObjectByName().' );
				return this.getObjectByName( name );
	
			},
			renderDepth: function () {
	
				console.warn( 'THREE.Object3D: .renderDepth has been removed. Use .renderOrder, instead.' );
	
			},
			translate: function ( distance, axis ) {
	
				console.warn( 'THREE.Object3D: .translate() has been removed. Use .translateOnAxis( axis, distance ) instead.' );
				return this.translateOnAxis( axis, distance );
	
			}
	
		} );
	
		Object.defineProperties( Object3D.prototype, {
	
			eulerOrder: {
				get: function () {
	
					console.warn( 'THREE.Object3D: .eulerOrder is now .rotation.order.' );
					return this.rotation.order;
	
				},
				set: function ( value ) {
	
					console.warn( 'THREE.Object3D: .eulerOrder is now .rotation.order.' );
					this.rotation.order = value;
	
				}
			},
			useQuaternion: {
				get: function () {
	
					console.warn( 'THREE.Object3D: .useQuaternion has been removed. The library now uses quaternions by default.' );
	
				},
				set: function () {
	
					console.warn( 'THREE.Object3D: .useQuaternion has been removed. The library now uses quaternions by default.' );
	
				}
			}
	
		} );
	
		Object.defineProperties( LOD.prototype, {
	
			objects: {
				get: function () {
	
					console.warn( 'THREE.LOD: .objects has been renamed to .levels.' );
					return this.levels;
	
				}
			}
	
		} );
	
		Object.defineProperty( Skeleton.prototype, 'useVertexTexture', {
	
			get: function () {
	
				console.warn( 'THREE.Skeleton: useVertexTexture has been removed.' );
	
			},
			set: function () {
	
				console.warn( 'THREE.Skeleton: useVertexTexture has been removed.' );
	
			}
	
		} );
	
		Object.defineProperty( Curve.prototype, '__arcLengthDivisions', {
	
			get: function () {
	
				console.warn( 'THREE.Curve: .__arcLengthDivisions is now .arcLengthDivisions.' );
				return this.arcLengthDivisions;
	
			},
			set: function ( value ) {
	
				console.warn( 'THREE.Curve: .__arcLengthDivisions is now .arcLengthDivisions.' );
				this.arcLengthDivisions = value;
	
			}
	
		} );
	
		//
	
		PerspectiveCamera.prototype.setLens = function ( focalLength, filmGauge ) {
	
			console.warn( "THREE.PerspectiveCamera.setLens is deprecated. " +
					"Use .setFocalLength and .filmGauge for a photographic setup." );
	
			if ( filmGauge !== undefined ) this.filmGauge = filmGauge;
			this.setFocalLength( focalLength );
	
		};
	
		//
	
		Object.defineProperties( Light.prototype, {
			onlyShadow: {
				set: function () {
	
					console.warn( 'THREE.Light: .onlyShadow has been removed.' );
	
				}
			},
			shadowCameraFov: {
				set: function ( value ) {
	
					console.warn( 'THREE.Light: .shadowCameraFov is now .shadow.camera.fov.' );
					this.shadow.camera.fov = value;
	
				}
			},
			shadowCameraLeft: {
				set: function ( value ) {
	
					console.warn( 'THREE.Light: .shadowCameraLeft is now .shadow.camera.left.' );
					this.shadow.camera.left = value;
	
				}
			},
			shadowCameraRight: {
				set: function ( value ) {
	
					console.warn( 'THREE.Light: .shadowCameraRight is now .shadow.camera.right.' );
					this.shadow.camera.right = value;
	
				}
			},
			shadowCameraTop: {
				set: function ( value ) {
	
					console.warn( 'THREE.Light: .shadowCameraTop is now .shadow.camera.top.' );
					this.shadow.camera.top = value;
	
				}
			},
			shadowCameraBottom: {
				set: function ( value ) {
	
					console.warn( 'THREE.Light: .shadowCameraBottom is now .shadow.camera.bottom.' );
					this.shadow.camera.bottom = value;
	
				}
			},
			shadowCameraNear: {
				set: function ( value ) {
	
					console.warn( 'THREE.Light: .shadowCameraNear is now .shadow.camera.near.' );
					this.shadow.camera.near = value;
	
				}
			},
			shadowCameraFar: {
				set: function ( value ) {
	
					console.warn( 'THREE.Light: .shadowCameraFar is now .shadow.camera.far.' );
					this.shadow.camera.far = value;
	
				}
			},
			shadowCameraVisible: {
				set: function () {
	
					console.warn( 'THREE.Light: .shadowCameraVisible has been removed. Use new THREE.CameraHelper( light.shadow.camera ) instead.' );
	
				}
			},
			shadowBias: {
				set: function ( value ) {
	
					console.warn( 'THREE.Light: .shadowBias is now .shadow.bias.' );
					this.shadow.bias = value;
	
				}
			},
			shadowDarkness: {
				set: function () {
	
					console.warn( 'THREE.Light: .shadowDarkness has been removed.' );
	
				}
			},
			shadowMapWidth: {
				set: function ( value ) {
	
					console.warn( 'THREE.Light: .shadowMapWidth is now .shadow.mapSize.width.' );
					this.shadow.mapSize.width = value;
	
				}
			},
			shadowMapHeight: {
				set: function ( value ) {
	
					console.warn( 'THREE.Light: .shadowMapHeight is now .shadow.mapSize.height.' );
					this.shadow.mapSize.height = value;
	
				}
			}
		} );
	
		//
	
		Object.defineProperties( BufferAttribute.prototype, {
	
			length: {
				get: function () {
	
					console.warn( 'THREE.BufferAttribute: .length has been deprecated. Use .count instead.' );
					return this.array.length;
	
				}
			}
	
		} );
	
		Object.assign( BufferGeometry.prototype, {
	
			addIndex: function ( index ) {
	
				console.warn( 'THREE.BufferGeometry: .addIndex() has been renamed to .setIndex().' );
				this.setIndex( index );
	
			},
			addDrawCall: function ( start, count, indexOffset ) {
	
				if ( indexOffset !== undefined ) {
	
					console.warn( 'THREE.BufferGeometry: .addDrawCall() no longer supports indexOffset.' );
	
				}
				console.warn( 'THREE.BufferGeometry: .addDrawCall() is now .addGroup().' );
				this.addGroup( start, count );
	
			},
			clearDrawCalls: function () {
	
				console.warn( 'THREE.BufferGeometry: .clearDrawCalls() is now .clearGroups().' );
				this.clearGroups();
	
			},
			computeTangents: function () {
	
				console.warn( 'THREE.BufferGeometry: .computeTangents() has been removed.' );
	
			},
			computeOffsets: function () {
	
				console.warn( 'THREE.BufferGeometry: .computeOffsets() has been removed.' );
	
			}
	
		} );
	
		Object.defineProperties( BufferGeometry.prototype, {
	
			drawcalls: {
				get: function () {
	
					console.error( 'THREE.BufferGeometry: .drawcalls has been renamed to .groups.' );
					return this.groups;
	
				}
			},
			offsets: {
				get: function () {
	
					console.warn( 'THREE.BufferGeometry: .offsets has been renamed to .groups.' );
					return this.groups;
	
				}
			}
	
		} );
	
		//
	
		Object.defineProperties( Uniform.prototype, {
	
			dynamic: {
				set: function () {
	
					console.warn( 'THREE.Uniform: .dynamic has been removed. Use object.onBeforeRender() instead.' );
	
				}
			},
			onUpdate: {
				value: function () {
	
					console.warn( 'THREE.Uniform: .onUpdate() has been removed. Use object.onBeforeRender() instead.' );
					return this;
	
				}
			}
	
		} );
	
		//
	
		Object.defineProperties( Material.prototype, {
	
			wrapAround: {
				get: function () {
	
					console.warn( 'THREE.Material: .wrapAround has been removed.' );
	
				},
				set: function () {
	
					console.warn( 'THREE.Material: .wrapAround has been removed.' );
	
				}
			},
			wrapRGB: {
				get: function () {
	
					console.warn( 'THREE.Material: .wrapRGB has been removed.' );
					return new Color();
	
				}
			},
	
			shading: {
				get: function () {
	
					console.error( 'THREE.' + this.type + ': .shading has been removed. Use the boolean .flatShading instead.' );
	
				},
				set: function ( value ) {
	
					console.warn( 'THREE.' + this.type + ': .shading has been removed. Use the boolean .flatShading instead.' );
					this.flatShading = ( value === FlatShading );
	
				}
			}
	
		} );
	
		Object.defineProperties( MeshPhongMaterial.prototype, {
	
			metal: {
				get: function () {
	
					console.warn( 'THREE.MeshPhongMaterial: .metal has been removed. Use THREE.MeshStandardMaterial instead.' );
					return false;
	
				},
				set: function () {
	
					console.warn( 'THREE.MeshPhongMaterial: .metal has been removed. Use THREE.MeshStandardMaterial instead' );
	
				}
			}
	
		} );
	
		Object.defineProperties( ShaderMaterial.prototype, {
	
			derivatives: {
				get: function () {
	
					console.warn( 'THREE.ShaderMaterial: .derivatives has been moved to .extensions.derivatives.' );
					return this.extensions.derivatives;
	
				},
				set: function ( value ) {
	
					console.warn( 'THREE. ShaderMaterial: .derivatives has been moved to .extensions.derivatives.' );
					this.extensions.derivatives = value;
	
				}
			}
	
		} );
	
		//
	
		Object.assign( WebGLRenderer.prototype, {
	
			getCurrentRenderTarget: function () {
	
				console.warn( 'THREE.WebGLRenderer: .getCurrentRenderTarget() is now .getRenderTarget().' );
				return this.getRenderTarget();
	
			},
	
			getMaxAnisotropy: function () {
	
				console.warn( 'THREE.WebGLRenderer: .getMaxAnisotropy() is now .capabilities.getMaxAnisotropy().' );
				return this.capabilities.getMaxAnisotropy();
	
			},
	
			getPrecision: function () {
	
				console.warn( 'THREE.WebGLRenderer: .getPrecision() is now .capabilities.precision.' );
				return this.capabilities.precision;
	
			},
	
			resetGLState: function () {
	
				console.warn( 'THREE.WebGLRenderer: .resetGLState() is now .state.reset().' );
				return this.state.reset();
	
			},
	
			supportsFloatTextures: function () {
	
				console.warn( 'THREE.WebGLRenderer: .supportsFloatTextures() is now .extensions.get( \'OES_texture_float\' ).' );
				return this.extensions.get( 'OES_texture_float' );
	
			},
			supportsHalfFloatTextures: function () {
	
				console.warn( 'THREE.WebGLRenderer: .supportsHalfFloatTextures() is now .extensions.get( \'OES_texture_half_float\' ).' );
				return this.extensions.get( 'OES_texture_half_float' );
	
			},
			supportsStandardDerivatives: function () {
	
				console.warn( 'THREE.WebGLRenderer: .supportsStandardDerivatives() is now .extensions.get( \'OES_standard_derivatives\' ).' );
				return this.extensions.get( 'OES_standard_derivatives' );
	
			},
			supportsCompressedTextureS3TC: function () {
	
				console.warn( 'THREE.WebGLRenderer: .supportsCompressedTextureS3TC() is now .extensions.get( \'WEBGL_compressed_texture_s3tc\' ).' );
				return this.extensions.get( 'WEBGL_compressed_texture_s3tc' );
	
			},
			supportsCompressedTexturePVRTC: function () {
	
				console.warn( 'THREE.WebGLRenderer: .supportsCompressedTexturePVRTC() is now .extensions.get( \'WEBGL_compressed_texture_pvrtc\' ).' );
				return this.extensions.get( 'WEBGL_compressed_texture_pvrtc' );
	
			},
			supportsBlendMinMax: function () {
	
				console.warn( 'THREE.WebGLRenderer: .supportsBlendMinMax() is now .extensions.get( \'EXT_blend_minmax\' ).' );
				return this.extensions.get( 'EXT_blend_minmax' );
	
			},
			supportsVertexTextures: function () {
	
				console.warn( 'THREE.WebGLRenderer: .supportsVertexTextures() is now .capabilities.vertexTextures.' );
				return this.capabilities.vertexTextures;
	
			},
			supportsInstancedArrays: function () {
	
				console.warn( 'THREE.WebGLRenderer: .supportsInstancedArrays() is now .extensions.get( \'ANGLE_instanced_arrays\' ).' );
				return this.extensions.get( 'ANGLE_instanced_arrays' );
	
			},
			enableScissorTest: function ( boolean ) {
	
				console.warn( 'THREE.WebGLRenderer: .enableScissorTest() is now .setScissorTest().' );
				this.setScissorTest( boolean );
	
			},
			initMaterial: function () {
	
				console.warn( 'THREE.WebGLRenderer: .initMaterial() has been removed.' );
	
			},
			addPrePlugin: function () {
	
				console.warn( 'THREE.WebGLRenderer: .addPrePlugin() has been removed.' );
	
			},
			addPostPlugin: function () {
	
				console.warn( 'THREE.WebGLRenderer: .addPostPlugin() has been removed.' );
	
			},
			updateShadowMap: function () {
	
				console.warn( 'THREE.WebGLRenderer: .updateShadowMap() has been removed.' );
	
			}
	
		} );
	
		Object.defineProperties( WebGLRenderer.prototype, {
	
			shadowMapEnabled: {
				get: function () {
	
					return this.shadowMap.enabled;
	
				},
				set: function ( value ) {
	
					console.warn( 'THREE.WebGLRenderer: .shadowMapEnabled is now .shadowMap.enabled.' );
					this.shadowMap.enabled = value;
	
				}
			},
			shadowMapType: {
				get: function () {
	
					return this.shadowMap.type;
	
				},
				set: function ( value ) {
	
					console.warn( 'THREE.WebGLRenderer: .shadowMapType is now .shadowMap.type.' );
					this.shadowMap.type = value;
	
				}
			},
			shadowMapCullFace: {
				get: function () {
	
					return this.shadowMap.cullFace;
	
				},
				set: function ( value ) {
	
					console.warn( 'THREE.WebGLRenderer: .shadowMapCullFace is now .shadowMap.cullFace.' );
					this.shadowMap.cullFace = value;
	
				}
			}
		} );
	
		Object.defineProperties( WebGLShadowMap.prototype, {
	
			cullFace: {
				get: function () {
	
					return this.renderReverseSided ? CullFaceFront : CullFaceBack;
	
				},
				set: function ( cullFace ) {
	
					var value = ( cullFace !== CullFaceBack );
					console.warn( "WebGLRenderer: .shadowMap.cullFace is deprecated. Set .shadowMap.renderReverseSided to " + value + "." );
					this.renderReverseSided = value;
	
				}
			}
	
		} );
	
		//
	
		Object.defineProperties( WebGLRenderTarget.prototype, {
	
			wrapS: {
				get: function () {
	
					console.warn( 'THREE.WebGLRenderTarget: .wrapS is now .texture.wrapS.' );
					return this.texture.wrapS;
	
				},
				set: function ( value ) {
	
					console.warn( 'THREE.WebGLRenderTarget: .wrapS is now .texture.wrapS.' );
					this.texture.wrapS = value;
	
				}
			},
			wrapT: {
				get: function () {
	
					console.warn( 'THREE.WebGLRenderTarget: .wrapT is now .texture.wrapT.' );
					return this.texture.wrapT;
	
				},
				set: function ( value ) {
	
					console.warn( 'THREE.WebGLRenderTarget: .wrapT is now .texture.wrapT.' );
					this.texture.wrapT = value;
	
				}
			},
			magFilter: {
				get: function () {
	
					console.warn( 'THREE.WebGLRenderTarget: .magFilter is now .texture.magFilter.' );
					return this.texture.magFilter;
	
				},
				set: function ( value ) {
	
					console.warn( 'THREE.WebGLRenderTarget: .magFilter is now .texture.magFilter.' );
					this.texture.magFilter = value;
	
				}
			},
			minFilter: {
				get: function () {
	
					console.warn( 'THREE.WebGLRenderTarget: .minFilter is now .texture.minFilter.' );
					return this.texture.minFilter;
	
				},
				set: function ( value ) {
	
					console.warn( 'THREE.WebGLRenderTarget: .minFilter is now .texture.minFilter.' );
					this.texture.minFilter = value;
	
				}
			},
			anisotropy: {
				get: function () {
	
					console.warn( 'THREE.WebGLRenderTarget: .anisotropy is now .texture.anisotropy.' );
					return this.texture.anisotropy;
	
				},
				set: function ( value ) {
	
					console.warn( 'THREE.WebGLRenderTarget: .anisotropy is now .texture.anisotropy.' );
					this.texture.anisotropy = value;
	
				}
			},
			offset: {
				get: function () {
	
					console.warn( 'THREE.WebGLRenderTarget: .offset is now .texture.offset.' );
					return this.texture.offset;
	
				},
				set: function ( value ) {
	
					console.warn( 'THREE.WebGLRenderTarget: .offset is now .texture.offset.' );
					this.texture.offset = value;
	
				}
			},
			repeat: {
				get: function () {
	
					console.warn( 'THREE.WebGLRenderTarget: .repeat is now .texture.repeat.' );
					return this.texture.repeat;
	
				},
				set: function ( value ) {
	
					console.warn( 'THREE.WebGLRenderTarget: .repeat is now .texture.repeat.' );
					this.texture.repeat = value;
	
				}
			},
			format: {
				get: function () {
	
					console.warn( 'THREE.WebGLRenderTarget: .format is now .texture.format.' );
					return this.texture.format;
	
				},
				set: function ( value ) {
	
					console.warn( 'THREE.WebGLRenderTarget: .format is now .texture.format.' );
					this.texture.format = value;
	
				}
			},
			type: {
				get: function () {
	
					console.warn( 'THREE.WebGLRenderTarget: .type is now .texture.type.' );
					return this.texture.type;
	
				},
				set: function ( value ) {
	
					console.warn( 'THREE.WebGLRenderTarget: .type is now .texture.type.' );
					this.texture.type = value;
	
				}
			},
			generateMipmaps: {
				get: function () {
	
					console.warn( 'THREE.WebGLRenderTarget: .generateMipmaps is now .texture.generateMipmaps.' );
					return this.texture.generateMipmaps;
	
				},
				set: function ( value ) {
	
					console.warn( 'THREE.WebGLRenderTarget: .generateMipmaps is now .texture.generateMipmaps.' );
					this.texture.generateMipmaps = value;
	
				}
			}
	
		} );
	
		//
	
		Object.assign( WebVRManager.prototype, {
	
			getStandingMatrix: function () {
	
				console.warn( 'THREE.WebVRManager: .getStandingMatrix() has been removed.' );
	
			}
	
		} );
	
		Object.defineProperties( WebVRManager.prototype, {
	
			standing: {
				set: function ( /* value */ ) {
	
					console.warn( 'THREE.WebVRManager: .standing has been removed.' );
	
				}
			}
	
		} );
	
		//
	
		Audio.prototype.load = function ( file ) {
	
			console.warn( 'THREE.Audio: .load has been deprecated. Use THREE.AudioLoader instead.' );
			var scope = this;
			var audioLoader = new AudioLoader();
			audioLoader.load( file, function ( buffer ) {
	
				scope.setBuffer( buffer );
	
			} );
			return this;
	
		};
	
		AudioAnalyser.prototype.getData = function () {
	
			console.warn( 'THREE.AudioAnalyser: .getData() is now .getFrequencyData().' );
			return this.getFrequencyData();
	
		};
	
		//
	
		CubeCamera.prototype.updateCubeMap = function ( renderer, scene ) {
	
			console.warn( 'THREE.CubeCamera: .updateCubeMap() is now .update().' );
			return this.update( renderer, scene );
	
		};
	
		//
	
		var GeometryUtils = {
	
			merge: function ( geometry1, geometry2, materialIndexOffset ) {
	
				console.warn( 'THREE.GeometryUtils: .merge() has been moved to Geometry. Use geometry.merge( geometry2, matrix, materialIndexOffset ) instead.' );
				var matrix;
	
				if ( geometry2.isMesh ) {
	
					geometry2.matrixAutoUpdate && geometry2.updateMatrix();
	
					matrix = geometry2.matrix;
					geometry2 = geometry2.geometry;
	
				}
	
				geometry1.merge( geometry2, matrix, materialIndexOffset );
	
			},
	
			center: function ( geometry ) {
	
				console.warn( 'THREE.GeometryUtils: .center() has been moved to Geometry. Use geometry.center() instead.' );
				return geometry.center();
	
			}
	
		};
	
		var ImageUtils = {
	
			crossOrigin: undefined,
	
			loadTexture: function ( url, mapping, onLoad, onError ) {
	
				console.warn( 'THREE.ImageUtils.loadTexture has been deprecated. Use THREE.TextureLoader() instead.' );
	
				var loader = new TextureLoader();
				loader.setCrossOrigin( this.crossOrigin );
	
				var texture = loader.load( url, onLoad, undefined, onError );
	
				if ( mapping ) texture.mapping = mapping;
	
				return texture;
	
			},
	
			loadTextureCube: function ( urls, mapping, onLoad, onError ) {
	
				console.warn( 'THREE.ImageUtils.loadTextureCube has been deprecated. Use THREE.CubeTextureLoader() instead.' );
	
				var loader = new CubeTextureLoader();
				loader.setCrossOrigin( this.crossOrigin );
	
				var texture = loader.load( urls, onLoad, undefined, onError );
	
				if ( mapping ) texture.mapping = mapping;
	
				return texture;
	
			},
	
			loadCompressedTexture: function () {
	
				console.error( 'THREE.ImageUtils.loadCompressedTexture has been removed. Use THREE.DDSLoader instead.' );
	
			},
	
			loadCompressedTextureCube: function () {
	
				console.error( 'THREE.ImageUtils.loadCompressedTextureCube has been removed. Use THREE.DDSLoader instead.' );
	
			}
	
		};
	
		//
	
		function Projector() {
	
			console.error( 'THREE.Projector has been moved to /examples/js/renderers/Projector.js.' );
	
			this.projectVector = function ( vector, camera ) {
	
				console.warn( 'THREE.Projector: .projectVector() is now vector.project().' );
				vector.project( camera );
	
			};
	
			this.unprojectVector = function ( vector, camera ) {
	
				console.warn( 'THREE.Projector: .unprojectVector() is now vector.unproject().' );
				vector.unproject( camera );
	
			};
	
			this.pickingRay = function () {
	
				console.error( 'THREE.Projector: .pickingRay() is now raycaster.setFromCamera().' );
	
			};
	
		}
	
		//
	
		function CanvasRenderer() {
	
			console.error( 'THREE.CanvasRenderer has been moved to /examples/js/renderers/CanvasRenderer.js' );
	
			this.domElement = document.createElementNS( 'http://www.w3.org/1999/xhtml', 'canvas' );
			this.clear = function () {};
			this.render = function () {};
			this.setClearColor = function () {};
			this.setSize = function () {};
	
		}
	
		exports.WebGLRenderTargetCube = WebGLRenderTargetCube;
		exports.WebGLRenderTarget = WebGLRenderTarget;
		exports.WebGLRenderer = WebGLRenderer;
		exports.ShaderLib = ShaderLib;
		exports.UniformsLib = UniformsLib;
		exports.UniformsUtils = UniformsUtils;
		exports.ShaderChunk = ShaderChunk;
		exports.FogExp2 = FogExp2;
		exports.Fog = Fog;
		exports.Scene = Scene;
		exports.LensFlare = LensFlare;
		exports.Sprite = Sprite;
		exports.LOD = LOD;
		exports.SkinnedMesh = SkinnedMesh;
		exports.Skeleton = Skeleton;
		exports.Bone = Bone;
		exports.Mesh = Mesh;
		exports.LineSegments = LineSegments;
		exports.LineLoop = LineLoop;
		exports.Line = Line;
		exports.Points = Points;
		exports.Group = Group;
		exports.VideoTexture = VideoTexture;
		exports.DataTexture = DataTexture;
		exports.CompressedTexture = CompressedTexture;
		exports.CubeTexture = CubeTexture;
		exports.CanvasTexture = CanvasTexture;
		exports.DepthTexture = DepthTexture;
		exports.Texture = Texture;
		exports.CompressedTextureLoader = CompressedTextureLoader;
		exports.DataTextureLoader = DataTextureLoader;
		exports.CubeTextureLoader = CubeTextureLoader;
		exports.TextureLoader = TextureLoader;
		exports.ObjectLoader = ObjectLoader;
		exports.MaterialLoader = MaterialLoader;
		exports.BufferGeometryLoader = BufferGeometryLoader;
		exports.DefaultLoadingManager = DefaultLoadingManager;
		exports.LoadingManager = LoadingManager;
		exports.JSONLoader = JSONLoader;
		exports.ImageLoader = ImageLoader;
		exports.ImageBitmapLoader = ImageBitmapLoader;
		exports.FontLoader = FontLoader;
		exports.FileLoader = FileLoader;
		exports.Loader = Loader;
		exports.LoaderUtils = LoaderUtils;
		exports.Cache = Cache;
		exports.AudioLoader = AudioLoader;
		exports.SpotLightShadow = SpotLightShadow;
		exports.SpotLight = SpotLight;
		exports.PointLight = PointLight;
		exports.RectAreaLight = RectAreaLight;
		exports.HemisphereLight = HemisphereLight;
		exports.DirectionalLightShadow = DirectionalLightShadow;
		exports.DirectionalLight = DirectionalLight;
		exports.AmbientLight = AmbientLight;
		exports.LightShadow = LightShadow;
		exports.Light = Light;
		exports.StereoCamera = StereoCamera;
		exports.PerspectiveCamera = PerspectiveCamera;
		exports.OrthographicCamera = OrthographicCamera;
		exports.CubeCamera = CubeCamera;
		exports.ArrayCamera = ArrayCamera;
		exports.Camera = Camera;
		exports.AudioListener = AudioListener;
		exports.PositionalAudio = PositionalAudio;
		exports.AudioContext = AudioContext;
		exports.AudioAnalyser = AudioAnalyser;
		exports.Audio = Audio;
		exports.VectorKeyframeTrack = VectorKeyframeTrack;
		exports.StringKeyframeTrack = StringKeyframeTrack;
		exports.QuaternionKeyframeTrack = QuaternionKeyframeTrack;
		exports.NumberKeyframeTrack = NumberKeyframeTrack;
		exports.ColorKeyframeTrack = ColorKeyframeTrack;
		exports.BooleanKeyframeTrack = BooleanKeyframeTrack;
		exports.PropertyMixer = PropertyMixer;
		exports.PropertyBinding = PropertyBinding;
		exports.KeyframeTrack = KeyframeTrack;
		exports.AnimationUtils = AnimationUtils;
		exports.AnimationObjectGroup = AnimationObjectGroup;
		exports.AnimationMixer = AnimationMixer;
		exports.AnimationClip = AnimationClip;
		exports.Uniform = Uniform;
		exports.InstancedBufferGeometry = InstancedBufferGeometry;
		exports.BufferGeometry = BufferGeometry;
		exports.Geometry = Geometry;
		exports.InterleavedBufferAttribute = InterleavedBufferAttribute;
		exports.InstancedInterleavedBuffer = InstancedInterleavedBuffer;
		exports.InterleavedBuffer = InterleavedBuffer;
		exports.InstancedBufferAttribute = InstancedBufferAttribute;
		exports.Face3 = Face3;
		exports.Object3D = Object3D;
		exports.Raycaster = Raycaster;
		exports.Layers = Layers;
		exports.EventDispatcher = EventDispatcher;
		exports.Clock = Clock;
		exports.QuaternionLinearInterpolant = QuaternionLinearInterpolant;
		exports.LinearInterpolant = LinearInterpolant;
		exports.DiscreteInterpolant = DiscreteInterpolant;
		exports.CubicInterpolant = CubicInterpolant;
		exports.Interpolant = Interpolant;
		exports.Triangle = Triangle;
		exports.Math = _Math;
		exports.Spherical = Spherical;
		exports.Cylindrical = Cylindrical;
		exports.Plane = Plane;
		exports.Frustum = Frustum;
		exports.Sphere = Sphere;
		exports.Ray = Ray;
		exports.Matrix4 = Matrix4;
		exports.Matrix3 = Matrix3;
		exports.Box3 = Box3;
		exports.Box2 = Box2;
		exports.Line3 = Line3;
		exports.Euler = Euler;
		exports.Vector4 = Vector4;
		exports.Vector3 = Vector3;
		exports.Vector2 = Vector2;
		exports.Quaternion = Quaternion;
		exports.Color = Color;
		exports.ImmediateRenderObject = ImmediateRenderObject;
		exports.VertexNormalsHelper = VertexNormalsHelper;
		exports.SpotLightHelper = SpotLightHelper;
		exports.SkeletonHelper = SkeletonHelper;
		exports.PointLightHelper = PointLightHelper;
		exports.RectAreaLightHelper = RectAreaLightHelper;
		exports.HemisphereLightHelper = HemisphereLightHelper;
		exports.GridHelper = GridHelper;
		exports.PolarGridHelper = PolarGridHelper;
		exports.FaceNormalsHelper = FaceNormalsHelper;
		exports.DirectionalLightHelper = DirectionalLightHelper;
		exports.CameraHelper = CameraHelper;
		exports.BoxHelper = BoxHelper;
		exports.Box3Helper = Box3Helper;
		exports.PlaneHelper = PlaneHelper;
		exports.ArrowHelper = ArrowHelper;
		exports.AxesHelper = AxesHelper;
		exports.Shape = Shape;
		exports.Path = Path;
		exports.ShapePath = ShapePath;
		exports.Font = Font;
		exports.CurvePath = CurvePath;
		exports.Curve = Curve;
		exports.ShapeUtils = ShapeUtils;
		exports.SceneUtils = SceneUtils;
		exports.WebGLUtils = WebGLUtils;
		exports.WireframeGeometry = WireframeGeometry;
		exports.ParametricGeometry = ParametricGeometry;
		exports.ParametricBufferGeometry = ParametricBufferGeometry;
		exports.TetrahedronGeometry = TetrahedronGeometry;
		exports.TetrahedronBufferGeometry = TetrahedronBufferGeometry;
		exports.OctahedronGeometry = OctahedronGeometry;
		exports.OctahedronBufferGeometry = OctahedronBufferGeometry;
		exports.IcosahedronGeometry = IcosahedronGeometry;
		exports.IcosahedronBufferGeometry = IcosahedronBufferGeometry;
		exports.DodecahedronGeometry = DodecahedronGeometry;
		exports.DodecahedronBufferGeometry = DodecahedronBufferGeometry;
		exports.PolyhedronGeometry = PolyhedronGeometry;
		exports.PolyhedronBufferGeometry = PolyhedronBufferGeometry;
		exports.TubeGeometry = TubeGeometry;
		exports.TubeBufferGeometry = TubeBufferGeometry;
		exports.TorusKnotGeometry = TorusKnotGeometry;
		exports.TorusKnotBufferGeometry = TorusKnotBufferGeometry;
		exports.TorusGeometry = TorusGeometry;
		exports.TorusBufferGeometry = TorusBufferGeometry;
		exports.TextGeometry = TextGeometry;
		exports.TextBufferGeometry = TextBufferGeometry;
		exports.SphereGeometry = SphereGeometry;
		exports.SphereBufferGeometry = SphereBufferGeometry;
		exports.RingGeometry = RingGeometry;
		exports.RingBufferGeometry = RingBufferGeometry;
		exports.PlaneGeometry = PlaneGeometry;
		exports.PlaneBufferGeometry = PlaneBufferGeometry;
		exports.LatheGeometry = LatheGeometry;
		exports.LatheBufferGeometry = LatheBufferGeometry;
		exports.ShapeGeometry = ShapeGeometry;
		exports.ShapeBufferGeometry = ShapeBufferGeometry;
		exports.ExtrudeGeometry = ExtrudeGeometry;
		exports.ExtrudeBufferGeometry = ExtrudeBufferGeometry;
		exports.EdgesGeometry = EdgesGeometry;
		exports.ConeGeometry = ConeGeometry;
		exports.ConeBufferGeometry = ConeBufferGeometry;
		exports.CylinderGeometry = CylinderGeometry;
		exports.CylinderBufferGeometry = CylinderBufferGeometry;
		exports.CircleGeometry = CircleGeometry;
		exports.CircleBufferGeometry = CircleBufferGeometry;
		exports.BoxGeometry = BoxGeometry;
		exports.BoxBufferGeometry = BoxBufferGeometry;
		exports.ShadowMaterial = ShadowMaterial;
		exports.SpriteMaterial = SpriteMaterial;
		exports.RawShaderMaterial = RawShaderMaterial;
		exports.ShaderMaterial = ShaderMaterial;
		exports.PointsMaterial = PointsMaterial;
		exports.MeshPhysicalMaterial = MeshPhysicalMaterial;
		exports.MeshStandardMaterial = MeshStandardMaterial;
		exports.MeshPhongMaterial = MeshPhongMaterial;
		exports.MeshToonMaterial = MeshToonMaterial;
		exports.MeshNormalMaterial = MeshNormalMaterial;
		exports.MeshLambertMaterial = MeshLambertMaterial;
		exports.MeshDepthMaterial = MeshDepthMaterial;
		exports.MeshDistanceMaterial = MeshDistanceMaterial;
		exports.MeshBasicMaterial = MeshBasicMaterial;
		exports.LineDashedMaterial = LineDashedMaterial;
		exports.LineBasicMaterial = LineBasicMaterial;
		exports.Material = Material;
		exports.Float64BufferAttribute = Float64BufferAttribute;
		exports.Float32BufferAttribute = Float32BufferAttribute;
		exports.Uint32BufferAttribute = Uint32BufferAttribute;
		exports.Int32BufferAttribute = Int32BufferAttribute;
		exports.Uint16BufferAttribute = Uint16BufferAttribute;
		exports.Int16BufferAttribute = Int16BufferAttribute;
		exports.Uint8ClampedBufferAttribute = Uint8ClampedBufferAttribute;
		exports.Uint8BufferAttribute = Uint8BufferAttribute;
		exports.Int8BufferAttribute = Int8BufferAttribute;
		exports.BufferAttribute = BufferAttribute;
		exports.ArcCurve = ArcCurve;
		exports.CatmullRomCurve3 = CatmullRomCurve3;
		exports.CubicBezierCurve = CubicBezierCurve;
		exports.CubicBezierCurve3 = CubicBezierCurve3;
		exports.EllipseCurve = EllipseCurve;
		exports.LineCurve = LineCurve;
		exports.LineCurve3 = LineCurve3;
		exports.QuadraticBezierCurve = QuadraticBezierCurve;
		exports.QuadraticBezierCurve3 = QuadraticBezierCurve3;
		exports.SplineCurve = SplineCurve;
		exports.REVISION = REVISION;
		exports.MOUSE = MOUSE;
		exports.CullFaceNone = CullFaceNone;
		exports.CullFaceBack = CullFaceBack;
		exports.CullFaceFront = CullFaceFront;
		exports.CullFaceFrontBack = CullFaceFrontBack;
		exports.FrontFaceDirectionCW = FrontFaceDirectionCW;
		exports.FrontFaceDirectionCCW = FrontFaceDirectionCCW;
		exports.BasicShadowMap = BasicShadowMap;
		exports.PCFShadowMap = PCFShadowMap;
		exports.PCFSoftShadowMap = PCFSoftShadowMap;
		exports.FrontSide = FrontSide;
		exports.BackSide = BackSide;
		exports.DoubleSide = DoubleSide;
		exports.FlatShading = FlatShading;
		exports.SmoothShading = SmoothShading;
		exports.NoColors = NoColors;
		exports.FaceColors = FaceColors;
		exports.VertexColors = VertexColors;
		exports.NoBlending = NoBlending;
		exports.NormalBlending = NormalBlending;
		exports.AdditiveBlending = AdditiveBlending;
		exports.SubtractiveBlending = SubtractiveBlending;
		exports.MultiplyBlending = MultiplyBlending;
		exports.CustomBlending = CustomBlending;
		exports.AddEquation = AddEquation;
		exports.SubtractEquation = SubtractEquation;
		exports.ReverseSubtractEquation = ReverseSubtractEquation;
		exports.MinEquation = MinEquation;
		exports.MaxEquation = MaxEquation;
		exports.ZeroFactor = ZeroFactor;
		exports.OneFactor = OneFactor;
		exports.SrcColorFactor = SrcColorFactor;
		exports.OneMinusSrcColorFactor = OneMinusSrcColorFactor;
		exports.SrcAlphaFactor = SrcAlphaFactor;
		exports.OneMinusSrcAlphaFactor = OneMinusSrcAlphaFactor;
		exports.DstAlphaFactor = DstAlphaFactor;
		exports.OneMinusDstAlphaFactor = OneMinusDstAlphaFactor;
		exports.DstColorFactor = DstColorFactor;
		exports.OneMinusDstColorFactor = OneMinusDstColorFactor;
		exports.SrcAlphaSaturateFactor = SrcAlphaSaturateFactor;
		exports.NeverDepth = NeverDepth;
		exports.AlwaysDepth = AlwaysDepth;
		exports.LessDepth = LessDepth;
		exports.LessEqualDepth = LessEqualDepth;
		exports.EqualDepth = EqualDepth;
		exports.GreaterEqualDepth = GreaterEqualDepth;
		exports.GreaterDepth = GreaterDepth;
		exports.NotEqualDepth = NotEqualDepth;
		exports.MultiplyOperation = MultiplyOperation;
		exports.MixOperation = MixOperation;
		exports.AddOperation = AddOperation;
		exports.NoToneMapping = NoToneMapping;
		exports.LinearToneMapping = LinearToneMapping;
		exports.ReinhardToneMapping = ReinhardToneMapping;
		exports.Uncharted2ToneMapping = Uncharted2ToneMapping;
		exports.CineonToneMapping = CineonToneMapping;
		exports.UVMapping = UVMapping;
		exports.CubeReflectionMapping = CubeReflectionMapping;
		exports.CubeRefractionMapping = CubeRefractionMapping;
		exports.EquirectangularReflectionMapping = EquirectangularReflectionMapping;
		exports.EquirectangularRefractionMapping = EquirectangularRefractionMapping;
		exports.SphericalReflectionMapping = SphericalReflectionMapping;
		exports.CubeUVReflectionMapping = CubeUVReflectionMapping;
		exports.CubeUVRefractionMapping = CubeUVRefractionMapping;
		exports.RepeatWrapping = RepeatWrapping;
		exports.ClampToEdgeWrapping = ClampToEdgeWrapping;
		exports.MirroredRepeatWrapping = MirroredRepeatWrapping;
		exports.NearestFilter = NearestFilter;
		exports.NearestMipMapNearestFilter = NearestMipMapNearestFilter;
		exports.NearestMipMapLinearFilter = NearestMipMapLinearFilter;
		exports.LinearFilter = LinearFilter;
		exports.LinearMipMapNearestFilter = LinearMipMapNearestFilter;
		exports.LinearMipMapLinearFilter = LinearMipMapLinearFilter;
		exports.UnsignedByteType = UnsignedByteType;
		exports.ByteType = ByteType;
		exports.ShortType = ShortType;
		exports.UnsignedShortType = UnsignedShortType;
		exports.IntType = IntType;
		exports.UnsignedIntType = UnsignedIntType;
		exports.FloatType = FloatType;
		exports.HalfFloatType = HalfFloatType;
		exports.UnsignedShort4444Type = UnsignedShort4444Type;
		exports.UnsignedShort5551Type = UnsignedShort5551Type;
		exports.UnsignedShort565Type = UnsignedShort565Type;
		exports.UnsignedInt248Type = UnsignedInt248Type;
		exports.AlphaFormat = AlphaFormat;
		exports.RGBFormat = RGBFormat;
		exports.RGBAFormat = RGBAFormat;
		exports.LuminanceFormat = LuminanceFormat;
		exports.LuminanceAlphaFormat = LuminanceAlphaFormat;
		exports.RGBEFormat = RGBEFormat;
		exports.DepthFormat = DepthFormat;
		exports.DepthStencilFormat = DepthStencilFormat;
		exports.RGB_S3TC_DXT1_Format = RGB_S3TC_DXT1_Format;
		exports.RGBA_S3TC_DXT1_Format = RGBA_S3TC_DXT1_Format;
		exports.RGBA_S3TC_DXT3_Format = RGBA_S3TC_DXT3_Format;
		exports.RGBA_S3TC_DXT5_Format = RGBA_S3TC_DXT5_Format;
		exports.RGB_PVRTC_4BPPV1_Format = RGB_PVRTC_4BPPV1_Format;
		exports.RGB_PVRTC_2BPPV1_Format = RGB_PVRTC_2BPPV1_Format;
		exports.RGBA_PVRTC_4BPPV1_Format = RGBA_PVRTC_4BPPV1_Format;
		exports.RGBA_PVRTC_2BPPV1_Format = RGBA_PVRTC_2BPPV1_Format;
		exports.RGB_ETC1_Format = RGB_ETC1_Format;
		exports.LoopOnce = LoopOnce;
		exports.LoopRepeat = LoopRepeat;
		exports.LoopPingPong = LoopPingPong;
		exports.InterpolateDiscrete = InterpolateDiscrete;
		exports.InterpolateLinear = InterpolateLinear;
		exports.InterpolateSmooth = InterpolateSmooth;
		exports.ZeroCurvatureEnding = ZeroCurvatureEnding;
		exports.ZeroSlopeEnding = ZeroSlopeEnding;
		exports.WrapAroundEnding = WrapAroundEnding;
		exports.TrianglesDrawMode = TrianglesDrawMode;
		exports.TriangleStripDrawMode = TriangleStripDrawMode;
		exports.TriangleFanDrawMode = TriangleFanDrawMode;
		exports.LinearEncoding = LinearEncoding;
		exports.sRGBEncoding = sRGBEncoding;
		exports.GammaEncoding = GammaEncoding;
		exports.RGBEEncoding = RGBEEncoding;
		exports.LogLuvEncoding = LogLuvEncoding;
		exports.RGBM7Encoding = RGBM7Encoding;
		exports.RGBM16Encoding = RGBM16Encoding;
		exports.RGBDEncoding = RGBDEncoding;
		exports.BasicDepthPacking = BasicDepthPacking;
		exports.RGBADepthPacking = RGBADepthPacking;
		exports.CubeGeometry = BoxGeometry;
		exports.Face4 = Face4;
		exports.LineStrip = LineStrip;
		exports.LinePieces = LinePieces;
		exports.MeshFaceMaterial = MeshFaceMaterial;
		exports.MultiMaterial = MultiMaterial;
		exports.PointCloud = PointCloud;
		exports.Particle = Particle;
		exports.ParticleSystem = ParticleSystem;
		exports.PointCloudMaterial = PointCloudMaterial;
		exports.ParticleBasicMaterial = ParticleBasicMaterial;
		exports.ParticleSystemMaterial = ParticleSystemMaterial;
		exports.Vertex = Vertex;
		exports.DynamicBufferAttribute = DynamicBufferAttribute;
		exports.Int8Attribute = Int8Attribute;
		exports.Uint8Attribute = Uint8Attribute;
		exports.Uint8ClampedAttribute = Uint8ClampedAttribute;
		exports.Int16Attribute = Int16Attribute;
		exports.Uint16Attribute = Uint16Attribute;
		exports.Int32Attribute = Int32Attribute;
		exports.Uint32Attribute = Uint32Attribute;
		exports.Float32Attribute = Float32Attribute;
		exports.Float64Attribute = Float64Attribute;
		exports.ClosedSplineCurve3 = ClosedSplineCurve3;
		exports.SplineCurve3 = SplineCurve3;
		exports.Spline = Spline;
		exports.AxisHelper = AxisHelper;
		exports.BoundingBoxHelper = BoundingBoxHelper;
		exports.EdgesHelper = EdgesHelper;
		exports.WireframeHelper = WireframeHelper;
		exports.XHRLoader = XHRLoader;
		exports.BinaryTextureLoader = BinaryTextureLoader;
		exports.GeometryUtils = GeometryUtils;
		exports.ImageUtils = ImageUtils;
		exports.Projector = Projector;
		exports.CanvasRenderer = CanvasRenderer;
	
		Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(223);

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.setProjectsImagesLoaded = exports.setMaterialsImagesLoaded = exports.setContactImagesLoaded = exports.setAboutImagesLoaded = exports.setHomeVideoReady = exports.getProjectsAreas = exports.getMaterialsKinds = exports.getHome = exports.getContact = exports.getAbout = exports.getMateriautheque = exports.getMaterial = exports.getProjects = exports.getMaterials = exports.HOME_VIDEO_READY = exports.PROJECTS_IMAGES_LOADED = exports.MATERIALS_IMAGES_LOADED = exports.CONTACT_IMAGES_LOADED = exports.ABOUT_IMAGES_LOADED = exports.GET_CONTACT = exports.GET_ABOUT = exports.GET_PROJECTS_AREAS = exports.GET_MATERIALS_KINDS = exports.GET_PROJECTS = exports.GET_MATERIAUTHEQUE = exports.GET_MATERIALS = exports.GET_HOME = exports.GET_MATERIAL = undefined;
	
	var _axios = __webpack_require__(69);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(96);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* eslint-disable no-alert, no-console */
	
	var GET_MATERIAL = exports.GET_MATERIAL = 'data/GET_MATERIAL';
	var GET_HOME = exports.GET_HOME = 'data/GET_HOME';
	var GET_MATERIALS = exports.GET_MATERIALS = 'data/GET_MATERIALS';
	var GET_MATERIAUTHEQUE = exports.GET_MATERIAUTHEQUE = 'data/GET_MATERIAUTHEQUE';
	var GET_PROJECTS = exports.GET_PROJECTS = 'data/GET_PROJECTS';
	var GET_MATERIALS_KINDS = exports.GET_MATERIALS_KINDS = 'data/GET_MATERIALS_KINDS';
	var GET_PROJECTS_AREAS = exports.GET_PROJECTS_AREAS = 'data/GET_PROJECTS_AREAS';
	var GET_ABOUT = exports.GET_ABOUT = 'data/GET_ABOUT';
	var GET_CONTACT = exports.GET_CONTACT = 'data/GET_CONTACT';
	
	var ABOUT_IMAGES_LOADED = exports.ABOUT_IMAGES_LOADED = 'data/ABOUT_IMAGES_LOADED';
	var CONTACT_IMAGES_LOADED = exports.CONTACT_IMAGES_LOADED = 'data/CONTACT_IMAGES_LOADED';
	var MATERIALS_IMAGES_LOADED = exports.MATERIALS_IMAGES_LOADED = 'data/MATERIALS_IMAGES_LOADED';
	var PROJECTS_IMAGES_LOADED = exports.PROJECTS_IMAGES_LOADED = 'data/PROJECTS_IMAGES_LOADED';
	var HOME_VIDEO_READY = exports.HOME_VIDEO_READY = 'data/HOME_VIDEO_READY';
	
	var initialState = {
	    materials: [],
	    home: null,
	    material: null,
	    materiautheque: null,
	    materialsKinds: [],
	    projectsAreas: [],
	    projects: [],
	    about: null,
	    contact: null,
	    homeVideoReady: false,
	    projectsImagesLoaded: false,
	    materialsImagesLoaded: false,
	    aboutImagesLoaded: false,
	    contactImagesLoaded: false
	};
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	
	    switch (action.type) {
	
	        case GET_MATERIAL:
	            // console.log('- material ready')
	            return Object.assign({}, state, {
	                material: Object.assign({}, state.material, _defineProperty({}, action.payload.name, action.payload))
	            });
	
	        case GET_HOME:
	            // console.log('- home ready')
	            return Object.assign({}, state, {
	                home: action.payload
	
	                // case GET_MATERIAUTHEQUE:
	                //     console.log('- material ready')
	                //     return{
	                //         ...state,
	                //         materiautheque : action.payload
	                //     }
	
	            });case GET_MATERIALS:
	            // if( action.payload )
	            var materials = action.payload.shuffle();
	            materials = materials.shuffle();
	            // console.log('- materials ready')
	            return Object.assign({}, state, {
	                materials: materials
	            });
	
	        case GET_PROJECTS:
	            console.log(action.payload);
	            return Object.assign({}, state, {
	                projects: action.payload
	            });
	
	        case GET_MATERIALS_KINDS:
	            // console.log('- kinds ready')
	            return Object.assign({}, state, {
	                materialsKinds: action.payload
	            });
	
	        case GET_PROJECTS_AREAS:
	            // console.log('- areas ready')
	            return Object.assign({}, state, {
	                projectsAreas: action.payload
	            });
	
	        case GET_ABOUT:
	            // console.log('- about ready')
	            return Object.assign({}, state, {
	                about: action.payload
	            });
	
	        case GET_CONTACT:
	            // console.log('- contact ready')
	            return Object.assign({}, state, {
	                contact: action.payload
	            });
	
	        case ABOUT_IMAGES_LOADED:
	            return Object.assign({}, state, {
	                aboutImagesLoaded: true
	            });
	
	        case CONTACT_IMAGES_LOADED:
	            return Object.assign({}, state, {
	                contactImagesLoaded: true
	            });
	
	        case MATERIALS_IMAGES_LOADED:
	            return Object.assign({}, state, {
	                materialsImagesLoaded: true
	            });
	
	        case PROJECTS_IMAGES_LOADED:
	            return Object.assign({}, state, {
	                projectsImagesLoaded: true
	            });
	
	        case HOME_VIDEO_READY:
	            // console.log('- home video ready')
	            return Object.assign({}, state, {
	                homeVideoReady: true
	            });
	
	        default:
	            return state;
	    }
	};
	
	/*
	/*
	/*        A C T I O N S
	/*
	/*
	*/
	
	var getMaterials = exports.getMaterials = function getMaterials() {
	
	    return function (dispatch) {
	
	        _axios2.default.request({
	            method: 'get',
	            url: _constants.API_URL + '/collections/get/materials?token=' + _constants.TOKEN
	        }).then(function (result) {
	            dispatch({ type: GET_MATERIALS, payload: result.data.entries });
	        });
	    };
	};
	
	var getProjects = exports.getProjects = function getProjects() {
	
	    return function (dispatch) {
	        _axios2.default.request({
	            method: 'post',
	            url: _constants.API_URL + '/collections/get/projects?token=' + _constants.TOKEN,
	            data: {
	                sort: { date: -1 }
	            }
	        }).then(function (result) {
	            dispatch({ type: GET_PROJECTS, payload: result.data.entries });
	        });
	    };
	};
	
	var getMaterial = exports.getMaterial = function getMaterial(slug) {
	
	    return function (dispatch) {
	
	        _axios2.default.request({
	            method: 'get',
	            url: _constants.API_URL + '/collections/get/materials?token=' + _constants.TOKEN,
	            data: {
	                filter: { slug: { $in: [slug] } }
	            }
	        }).then(function (result) {
	            dispatch({ type: GET_MATERIAL, payload: result.data.entries.first() });
	        });
	    };
	};
	
	var getMateriautheque = exports.getMateriautheque = function getMateriautheque() {
	    return function (dispatch) {
	
	        _axios2.default.get(_constants.API_URL + '/regions/data/materials_library?token=' + _constants.TOKEN).then(function (result) {
	            dispatch({ type: GET_MATERIAUTHEQUE, payload: result.data });
	        });
	    };
	};
	
	var getAbout = exports.getAbout = function getAbout() {
	    return function (dispatch) {
	
	        _axios2.default.get(_constants.API_URL + '/regions/data/about?token=' + _constants.TOKEN).then(function (result) {
	            dispatch({ type: GET_ABOUT, payload: result.data });
	        });
	    };
	};
	
	var getContact = exports.getContact = function getContact() {
	    return function (dispatch) {
	
	        _axios2.default.get(_constants.API_URL + '/regions/data/contact?token=' + _constants.TOKEN).then(function (result) {
	            dispatch({ type: GET_CONTACT, payload: result.data });
	        });
	    };
	};
	
	var getHome = exports.getHome = function getHome() {
	    return function (dispatch) {
	
	        _axios2.default.get(_constants.API_URL + '/regions/data/home?token=' + _constants.TOKEN).then(function (result) {
	            dispatch({ type: GET_HOME, payload: result.data });
	        });
	    };
	};
	
	var getMaterialsKinds = exports.getMaterialsKinds = function getMaterialsKinds() {
	
	    return function (dispatch) {
	
	        _axios2.default.get(_constants.API_URL + '/collections/get/materials_kinds?token=' + _constants.TOKEN).then(function (result) {
	            dispatch({ type: GET_MATERIALS_KINDS, payload: result.data.entries });
	        });
	    };
	};
	
	var getProjectsAreas = exports.getProjectsAreas = function getProjectsAreas() {
	
	    return function (dispatch) {
	
	        _axios2.default.get(_constants.API_URL + '/collections/get/projects_activity_area?token=' + _constants.TOKEN).then(function (result) {
	            dispatch({ type: GET_PROJECTS_AREAS, payload: result.data.entries });
	        });
	    };
	};
	
	var setHomeVideoReady = exports.setHomeVideoReady = function setHomeVideoReady() {
	
	    return function (dispatch) {
	        dispatch({ type: HOME_VIDEO_READY });
	    };
	};
	
	var setAboutImagesLoaded = exports.setAboutImagesLoaded = function setAboutImagesLoaded() {
	
	    return function (dispatch) {
	        dispatch({ type: ABOUT_IMAGES_LOADED });
	    };
	};
	
	var setContactImagesLoaded = exports.setContactImagesLoaded = function setContactImagesLoaded() {
	
	    return function (dispatch) {
	        dispatch({ type: CONTACT_IMAGES_LOADED });
	    };
	};
	
	var setMaterialsImagesLoaded = exports.setMaterialsImagesLoaded = function setMaterialsImagesLoaded() {
	
	    return function (dispatch) {
	        dispatch({ type: MATERIALS_IMAGES_LOADED });
	    };
	};
	
	var setProjectsImagesLoaded = exports.setProjectsImagesLoaded = function setProjectsImagesLoaded() {
	
	    return function (dispatch) {
	        dispatch({ type: PROJECTS_IMAGES_LOADED });
	    };
	};

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Superface = __webpack_require__(7);
	
	var _Superface2 = _interopRequireDefault(_Superface);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        'div',
	        { className: 'menu-item soon', style: props.style },
	        _react2.default.createElement(
	            'span',
	            null,
	            _Superface2.default.translate(props.display)
	        ),
	        _react2.default.createElement(
	            'span',
	            null,
	            _Superface2.default.translate('Prochainement')
	        )
	    );
	};

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	   value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint-disable no-alert, no-console */
	
	var _virtualScroll = __webpack_require__(572);
	
	var _virtualScroll2 = _interopRequireDefault(_virtualScroll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ScrollTracker = function () {
	   function ScrollTracker(opt) {
	      _classCallCheck(this, ScrollTracker);
	
	      this.handleScroll = this.handleScroll.bind(this);
	      this.init();
	   }
	
	   _createClass(ScrollTracker, [{
	      key: 'init',
	      value: function init() {
	
	         this.virtual_scroll = new _virtualScroll2.default({
	            firefoxMultiplier: 50
	         });
	         this.virtual_scroll._noKey = true;
	
	         this.reset();
	
	         this.cbs = {
	            scroll: [],
	            scrollend: []
	         };
	      }
	   }, {
	      key: 'reset',
	      value: function reset() {
	         this.virtual_scroll._event.deltaX = 0;
	         this.virtual_scroll._event.deltaY = 0;
	         this.virtual_scroll._event.y = 0;
	         this.virtual_scroll._event.x = 0;
	         this.isScrolling = false;
	         this.deltaX = 0;
	         this.deltaY = 0;
	         this.positionY = 0;
	         this.positionX = 0;
	         this.lastScrollY = 0;
	         this.lastScrollX = 0;
	      }
	   }, {
	      key: 'start',
	      value: function start() {
	         this.virtual_scroll.on(this.handleScroll);
	      }
	   }, {
	      key: 'stop',
	      value: function stop() {
	         this.virtual_scroll.off(this.handleScroll);
	      }
	   }, {
	      key: 'on',
	      value: function on(evt, cb) {
	         // console.log('added : ' + evt )
	         switch (evt) {
	            case 'scroll':
	               this.cbs.scroll.push(cb);
	               break;
	            case 'scrollend':
	               // console.log('')
	               this.cbs.scrollend.push(cb);
	               break;
	            default:
	               console.warn(evt + ' : such event does not exist');
	         }
	      }
	   }, {
	      key: 'off',
	      value: function off(evt, cb) {
	
	         var index = this.cbs[evt].indexOf(cb);
	         this.cbs[evt].splice(index, 1);
	      }
	   }, {
	      key: 'handleScroll',
	      value: function handleScroll(e) {
	         var _this = this;
	
	         // console.log('scrollin\'')
	         if (this.timeoutScrollEnd) window.clearTimeout(this.timeoutScrollEnd);
	
	         this.deltaX = e.deltaX;
	         this.deltaY = e.deltaY;
	
	         this.positionY += this.deltaY;
	         this.positionX += this.deltaX;
	         this.isScrolling = true;
	
	         this.timeoutScrollEnd = window.setTimeout(function () {
	
	            _this.isScrolling = false;
	            _this.lastScrollPoint = _this.virtual_scrollPos;
	
	            _this.cbs.scrollend.forEach(function (cb) {
	               cb(e);
	            });
	         }, 60);
	
	         this.cbs.scroll.forEach(function (cb) {
	            cb(e);
	         });
	      }
	   }, {
	      key: 'destroy',
	      value: function destroy() {
	         if (this.timeoutScrollEnd) window.clearTimeout(this.timeoutScrollEnd);
	         this.stop();
	         this.virtual_scroll.destroy();
	      }
	   }]);
	
	   return ScrollTracker;
	}();
	
	exports.default = ScrollTracker;

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(23);
	var toLength = __webpack_require__(11);
	var toAbsoluteIndex = __webpack_require__(52);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(4);
	var $export = __webpack_require__(1);
	var redefine = __webpack_require__(17);
	var redefineAll = __webpack_require__(50);
	var meta = __webpack_require__(39);
	var forOf = __webpack_require__(45);
	var anInstance = __webpack_require__(44);
	var isObject = __webpack_require__(6);
	var fails = __webpack_require__(5);
	var $iterDetect = __webpack_require__(79);
	var setToStringTag = __webpack_require__(55);
	var inheritIfRequired = __webpack_require__(104);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  var fixMethod = function (KEY) {
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function (a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a) {
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance = new C();
	    // early implementations not supports chaining
	    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
	    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
	    // most early implementations doesn't supports iterables, most modern - not close it correctly
	    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
	    // for early implementations -0 and +0 not the same
	    var BUGGY_ZERO = !IS_WEAK && fails(function () {
	      // V8 ~ Chromium 42- fails only with 5+ elements
	      var $instance = new C();
	      var index = 5;
	      while (index--) $instance[ADDER](index, index);
	      return !$instance.has(-0);
	    });
	    if (!ACCEPT_ITERABLES) {
	      C = wrapper(function (target, iterable) {
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base(), target, C);
	        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if (IS_WEAK && proto.clear) delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var hide = __webpack_require__(16);
	var redefine = __webpack_require__(17);
	var fails = __webpack_require__(5);
	var defined = __webpack_require__(30);
	var wks = __webpack_require__(8);
	
	module.exports = function (KEY, length, exec) {
	  var SYMBOL = wks(KEY);
	  var fns = exec(defined, SYMBOL, ''[KEY]);
	  var strfn = fns[0];
	  var rxfn = fns[1];
	  if (fails(function () {
	    var O = {};
	    O[SYMBOL] = function () { return 7; };
	    return ''[KEY](O) != 7;
	  })) {
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function (string, arg) { return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function (string) { return rxfn.call(string, this); }
	    );
	  }
	};


/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(3);
	module.exports = function () {
	  var that = anObject(this);
	  var result = '';
	  if (that.global) result += 'g';
	  if (that.ignoreCase) result += 'i';
	  if (that.multiline) result += 'm';
	  if (that.unicode) result += 'u';
	  if (that.sticky) result += 'y';
	  return result;
	};


/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(25);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(6);
	var cof = __webpack_require__(25);
	var MATCH = __webpack_require__(8)('match');
	module.exports = function (it) {
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};


/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(8)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// Forced replacement prototype accessors methods
	module.exports = __webpack_require__(38) || !__webpack_require__(5)(function () {
	  var K = Math.random();
	  // In FF throws only define methods
	  // eslint-disable-next-line no-undef, no-useless-call
	  __defineSetter__.call(null, K, function () { /* empty */ });
	  delete __webpack_require__(4)[K];
	});


/***/ },
/* 81 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(1);
	var aFunction = __webpack_require__(14);
	var ctx = __webpack_require__(27);
	var forOf = __webpack_require__(45);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
	    var mapFn = arguments[1];
	    var mapping, A, n, cb;
	    aFunction(this);
	    mapping = mapFn !== undefined;
	    if (mapping) aFunction(mapFn);
	    if (source == undefined) return new this();
	    A = [];
	    if (mapping) {
	      n = 0;
	      cb = ctx(mapFn, arguments[2], 2);
	      forOf(source, false, function (nextItem) {
	        A.push(cb(nextItem, n++));
	      });
	    } else {
	      forOf(source, false, A.push, A);
	    }
	    return new this(A);
	  } });
	};


/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(1);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { of: function of() {
	    var length = arguments.length;
	    var A = new Array(length);
	    while (length--) A[length] = arguments[length];
	    return new this(A);
	  } });
	};


/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	var core = __webpack_require__(26);
	var global = __webpack_require__(4);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(38) ? 'pure' : 'global',
	  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
	});


/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(3);
	var aFunction = __webpack_require__(14);
	var SPECIES = __webpack_require__(8)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(4);
	var hide = __webpack_require__(16);
	var uid = __webpack_require__(53);
	var TYPED = uid('typed_array');
	var VIEW = uid('view');
	var ABV = !!(global.ArrayBuffer && global.DataView);
	var CONSTR = ABV;
	var i = 0;
	var l = 9;
	var Typed;
	
	var TypedArrayConstructors = (
	  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
	).split(',');
	
	while (i < l) {
	  if (Typed = global[TypedArrayConstructors[i++]]) {
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	
	module.exports = {
	  ABV: ABV,
	  CONSTR: CONSTR,
	  TYPED: TYPED,
	  VIEW: VIEW
	};


/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(4);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ },
/* 88 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationsAreEqual = exports.createLocation = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _resolvePathname = __webpack_require__(557);
	
	var _resolvePathname2 = _interopRequireDefault(_resolvePathname);
	
	var _valueEqual = __webpack_require__(570);
	
	var _valueEqual2 = _interopRequireDefault(_valueEqual);
	
	var _PathUtils = __webpack_require__(58);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createLocation = exports.createLocation = function createLocation(path, state, key, currentLocation) {
	  var location = void 0;
	  if (typeof path === 'string') {
	    // Two-arg form: push(path, state)
	    location = (0, _PathUtils.parsePath)(path);
	    location.state = state;
	  } else {
	    // One-arg form: push(location)
	    location = _extends({}, path);
	
	    if (location.pathname === undefined) location.pathname = '';
	
	    if (location.search) {
	      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
	    } else {
	      location.search = '';
	    }
	
	    if (location.hash) {
	      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
	    } else {
	      location.hash = '';
	    }
	
	    if (state !== undefined && location.state === undefined) location.state = state;
	  }
	
	  try {
	    location.pathname = decodeURI(location.pathname);
	  } catch (e) {
	    if (e instanceof URIError) {
	      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
	    } else {
	      throw e;
	    }
	  }
	
	  if (key) location.key = key;
	
	  if (currentLocation) {
	    // Resolve incomplete/relative pathname relative to current location.
	    if (!location.pathname) {
	      location.pathname = currentLocation.pathname;
	    } else if (location.pathname.charAt(0) !== '/') {
	      location.pathname = (0, _resolvePathname2.default)(location.pathname, currentLocation.pathname);
	    }
	  } else {
	    // When there is no prior location and pathname is empty, set it to /
	    if (!location.pathname) {
	      location.pathname = '/';
	    }
	  }
	
	  return location;
	};
	
	var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
	  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqual2.default)(a.state, b.state);
	};

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(24);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(34);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for putting history on context.
	 */
	var Router = function (_React$Component) {
	  _inherits(Router, _React$Component);
	
	  function Router() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Router);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      match: _this.computeMatch(_this.props.history.location.pathname)
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Router.prototype.getChildContext = function getChildContext() {
	    return {
	      router: _extends({}, this.context.router, {
	        history: this.props.history,
	        route: {
	          location: this.props.history.location,
	          match: this.state.match
	        }
	      })
	    };
	  };
	
	  Router.prototype.computeMatch = function computeMatch(pathname) {
	    return {
	      path: '/',
	      url: '/',
	      params: {},
	      isExact: pathname === '/'
	    };
	  };
	
	  Router.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    var _props = this.props,
	        children = _props.children,
	        history = _props.history;
	
	
	    (0, _invariant2.default)(children == null || _react2.default.Children.count(children) === 1, 'A <Router> may have only one child element');
	
	    // Do this here so we can setState when a <Redirect> changes the
	    // location in componentWillMount. This happens e.g. when doing
	    // server rendering using a <StaticRouter>.
	    this.unlisten = history.listen(function () {
	      _this2.setState({
	        match: _this2.computeMatch(history.location.pathname)
	      });
	    });
	  };
	
	  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    (0, _warning2.default)(this.props.history === nextProps.history, 'You cannot change <Router history>');
	  };
	
	  Router.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unlisten();
	  };
	
	  Router.prototype.render = function render() {
	    var children = this.props.children;
	
	    return children ? _react2.default.Children.only(children) : null;
	  };
	
	  return Router;
	}(_react2.default.Component);
	
	Router.propTypes = {
	  history: _propTypes2.default.object.isRequired,
	  children: _propTypes2.default.node
	};
	Router.contextTypes = {
	  router: _propTypes2.default.object
	};
	Router.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = Router;

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _pathToRegexp = __webpack_require__(543);
	
	var _pathToRegexp2 = _interopRequireDefault(_pathToRegexp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var patternCache = {};
	var cacheLimit = 10000;
	var cacheCount = 0;
	
	var compilePath = function compilePath(pattern, options) {
	  var cacheKey = '' + options.end + options.strict + options.sensitive;
	  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});
	
	  if (cache[pattern]) return cache[pattern];
	
	  var keys = [];
	  var re = (0, _pathToRegexp2.default)(pattern, keys, options);
	  var compiledPattern = { re: re, keys: keys };
	
	  if (cacheCount < cacheLimit) {
	    cache[pattern] = compiledPattern;
	    cacheCount++;
	  }
	
	  return compiledPattern;
	};
	
	/**
	 * Public API for matching a URL pathname to a path pattern.
	 */
	var matchPath = function matchPath(pathname) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (typeof options === 'string') options = { path: options };
	
	  var _options = options,
	      _options$path = _options.path,
	      path = _options$path === undefined ? '/' : _options$path,
	      _options$exact = _options.exact,
	      exact = _options$exact === undefined ? false : _options$exact,
	      _options$strict = _options.strict,
	      strict = _options$strict === undefined ? false : _options$strict,
	      _options$sensitive = _options.sensitive,
	      sensitive = _options$sensitive === undefined ? false : _options$sensitive;
	
	  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
	      re = _compilePath.re,
	      keys = _compilePath.keys;
	
	  var match = re.exec(pathname);
	
	  if (!match) return null;
	
	  var url = match[0],
	      values = match.slice(1);
	
	  var isExact = pathname === url;
	
	  if (exact && !isExact) return null;
	
	  return {
	    path: path, // the path pattern used to match
	    url: path === '/' && url === '' ? '/' : url, // the matched portion of the URL
	    isExact: isExact, // whether or not we matched exactly
	    params: keys.reduce(function (memo, key, index) {
	      memo[key.name] = values[index];
	      return memo;
	    }, {})
	  };
	};
	
	exports.default = matchPath;

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Tween.js - Licensed under the MIT license
	 * https://github.com/tweenjs/tween.js
	 * ----------------------------------------------
	 *
	 * See https://github.com/tweenjs/tween.js/graphs/contributors for the full list of contributors.
	 * Thank you all, you're awesome!
	 */
	
	
	var _Group = function () {
		this._tweens = {};
		this._tweensAddedDuringUpdate = {};
	};
	
	_Group.prototype = {
		getAll: function () {
	
			return Object.keys(this._tweens).map(function (tweenId) {
				return this._tweens[tweenId];
			}.bind(this));
	
		},
	
		removeAll: function () {
	
			this._tweens = {};
	
		},
	
		add: function (tween) {
	
			this._tweens[tween.getId()] = tween;
			this._tweensAddedDuringUpdate[tween.getId()] = tween;
	
		},
	
		remove: function (tween) {
	
			delete this._tweens[tween.getId()];
			delete this._tweensAddedDuringUpdate[tween.getId()];
	
		},
	
		update: function (time, preserve) {
	
			var tweenIds = Object.keys(this._tweens);
	
			if (tweenIds.length === 0) {
				return false;
			}
	
			time = time !== undefined ? time : TWEEN.now();
	
			// Tweens are updated in "batches". If you add a new tween during an update, then the
			// new tween will be updated in the next batch.
			// If you remove a tween during an update, it may or may not be updated. However,
			// if the removed tween was added during the current batch, then it will not be updated.
			while (tweenIds.length > 0) {
				this._tweensAddedDuringUpdate = {};
	
				for (var i = 0; i < tweenIds.length; i++) {
	
					var tween = this._tweens[tweenIds[i]];
	
					if (tween && tween.update(time) === false) {
						tween._isPlaying = false;
	
						if (!preserve) {
							delete this._tweens[tweenIds[i]];
						}
					}
				}
	
				tweenIds = Object.keys(this._tweensAddedDuringUpdate);
			}
	
			return true;
	
		}
	};
	
	var TWEEN = new _Group();
	
	TWEEN.Group = _Group;
	TWEEN._nextId = 0;
	TWEEN.nextId = function () {
		return TWEEN._nextId++;
	};
	
	
	// Include a performance.now polyfill.
	// In node.js, use process.hrtime.
	if (typeof (window) === 'undefined' && typeof (process) !== 'undefined') {
		TWEEN.now = function () {
			var time = process.hrtime();
	
			// Convert [seconds, nanoseconds] to milliseconds.
			return time[0] * 1000 + time[1] / 1000000;
		};
	}
	// In a browser, use window.performance.now if it is available.
	else if (typeof (window) !== 'undefined' &&
	         window.performance !== undefined &&
			 window.performance.now !== undefined) {
		// This must be bound, because directly assigning this function
		// leads to an invocation exception in Chrome.
		TWEEN.now = window.performance.now.bind(window.performance);
	}
	// Use Date.now if it is available.
	else if (Date.now !== undefined) {
		TWEEN.now = Date.now;
	}
	// Otherwise, use 'new Date().getTime()'.
	else {
		TWEEN.now = function () {
			return new Date().getTime();
		};
	}
	
	
	TWEEN.Tween = function (object, group) {
		this._object = object;
		this._valuesStart = {};
		this._valuesEnd = {};
		this._valuesStartRepeat = {};
		this._duration = 1000;
		this._repeat = 0;
		this._repeatDelayTime = undefined;
		this._yoyo = false;
		this._isPlaying = false;
		this._reversed = false;
		this._delayTime = 0;
		this._startTime = null;
		this._easingFunction = TWEEN.Easing.Linear.None;
		this._interpolationFunction = TWEEN.Interpolation.Linear;
		this._chainedTweens = [];
		this._onStartCallback = null;
		this._onStartCallbackFired = false;
		this._onUpdateCallback = null;
		this._onCompleteCallback = null;
		this._onStopCallback = null;
		this._group = group || TWEEN;
		this._id = TWEEN.nextId();
	
	};
	
	TWEEN.Tween.prototype = {
		getId: function getId() {
			return this._id;
		},
	
		isPlaying: function isPlaying() {
			return this._isPlaying;
		},
	
		to: function to(properties, duration) {
	
			this._valuesEnd = properties;
	
			if (duration !== undefined) {
				this._duration = duration;
			}
	
			return this;
	
		},
	
		start: function start(time) {
	
			this._group.add(this);
	
			this._isPlaying = true;
	
			this._onStartCallbackFired = false;
	
			this._startTime = time !== undefined ? typeof time === 'string' ? TWEEN.now() + parseFloat(time) : time : TWEEN.now();
			this._startTime += this._delayTime;
	
			for (var property in this._valuesEnd) {
	
				// Check if an Array was provided as property value
				if (this._valuesEnd[property] instanceof Array) {
	
					if (this._valuesEnd[property].length === 0) {
						continue;
					}
	
					// Create a local copy of the Array with the start value at the front
					this._valuesEnd[property] = [this._object[property]].concat(this._valuesEnd[property]);
	
				}
	
				// If `to()` specifies a property that doesn't exist in the source object,
				// we should not set that property in the object
				if (this._object[property] === undefined) {
					continue;
				}
	
				// Save the starting value.
				this._valuesStart[property] = this._object[property];
	
				if ((this._valuesStart[property] instanceof Array) === false) {
					this._valuesStart[property] *= 1.0; // Ensures we're using numbers, not strings
				}
	
				this._valuesStartRepeat[property] = this._valuesStart[property] || 0;
	
			}
	
			return this;
	
		},
	
		stop: function stop() {
	
			if (!this._isPlaying) {
				return this;
			}
	
			this._group.remove(this);
			this._isPlaying = false;
	
			if (this._onStopCallback !== null) {
				this._onStopCallback(this._object);
			}
	
			this.stopChainedTweens();
			return this;
	
		},
	
		end: function end() {
	
			this.update(this._startTime + this._duration);
			return this;
	
		},
	
		stopChainedTweens: function stopChainedTweens() {
	
			for (var i = 0, numChainedTweens = this._chainedTweens.length; i < numChainedTweens; i++) {
				this._chainedTweens[i].stop();
			}
	
		},
	
		delay: function delay(amount) {
	
			this._delayTime = amount;
			return this;
	
		},
	
		repeat: function repeat(times) {
	
			this._repeat = times;
			return this;
	
		},
	
		repeatDelay: function repeatDelay(amount) {
	
			this._repeatDelayTime = amount;
			return this;
	
		},
	
		yoyo: function yoyo(yoyo) {
	
			this._yoyo = yoyo;
			return this;
	
		},
	
		easing: function easing(easing) {
	
			this._easingFunction = easing;
			return this;
	
		},
	
		interpolation: function interpolation(interpolation) {
	
			this._interpolationFunction = interpolation;
			return this;
	
		},
	
		chain: function chain() {
	
			this._chainedTweens = arguments;
			return this;
	
		},
	
		onStart: function onStart(callback) {
	
			this._onStartCallback = callback;
			return this;
	
		},
	
		onUpdate: function onUpdate(callback) {
	
			this._onUpdateCallback = callback;
			return this;
	
		},
	
		onComplete: function onComplete(callback) {
	
			this._onCompleteCallback = callback;
			return this;
	
		},
	
		onStop: function onStop(callback) {
	
			this._onStopCallback = callback;
			return this;
	
		},
	
		update: function update(time) {
	
			var property;
			var elapsed;
			var value;
	
			if (time < this._startTime) {
				return true;
			}
	
			if (this._onStartCallbackFired === false) {
	
				if (this._onStartCallback !== null) {
					this._onStartCallback(this._object);
				}
	
				this._onStartCallbackFired = true;
			}
	
			elapsed = (time - this._startTime) / this._duration;
			elapsed = elapsed > 1 ? 1 : elapsed;
	
			value = this._easingFunction(elapsed);
	
			for (property in this._valuesEnd) {
	
				// Don't update properties that do not exist in the source object
				if (this._valuesStart[property] === undefined) {
					continue;
				}
	
				var start = this._valuesStart[property] || 0;
				var end = this._valuesEnd[property];
	
				if (end instanceof Array) {
	
					this._object[property] = this._interpolationFunction(end, value);
	
				} else {
	
					// Parses relative end values with start as base (e.g.: +10, -3)
					if (typeof (end) === 'string') {
	
						if (end.charAt(0) === '+' || end.charAt(0) === '-') {
							end = start + parseFloat(end);
						} else {
							end = parseFloat(end);
						}
					}
	
					// Protect against non numeric properties.
					if (typeof (end) === 'number') {
						this._object[property] = start + (end - start) * value;
					}
	
				}
	
			}
	
			if (this._onUpdateCallback !== null) {
				this._onUpdateCallback(this._object);
			}
	
			if (elapsed === 1) {
	
				if (this._repeat > 0) {
	
					if (isFinite(this._repeat)) {
						this._repeat--;
					}
	
					// Reassign starting values, restart by making startTime = now
					for (property in this._valuesStartRepeat) {
	
						if (typeof (this._valuesEnd[property]) === 'string') {
							this._valuesStartRepeat[property] = this._valuesStartRepeat[property] + parseFloat(this._valuesEnd[property]);
						}
	
						if (this._yoyo) {
							var tmp = this._valuesStartRepeat[property];
	
							this._valuesStartRepeat[property] = this._valuesEnd[property];
							this._valuesEnd[property] = tmp;
						}
	
						this._valuesStart[property] = this._valuesStartRepeat[property];
	
					}
	
					if (this._yoyo) {
						this._reversed = !this._reversed;
					}
	
					if (this._repeatDelayTime !== undefined) {
						this._startTime = time + this._repeatDelayTime;
					} else {
						this._startTime = time + this._delayTime;
					}
	
					return true;
	
				} else {
	
					if (this._onCompleteCallback !== null) {
	
						this._onCompleteCallback(this._object);
					}
	
					for (var i = 0, numChainedTweens = this._chainedTweens.length; i < numChainedTweens; i++) {
						// Make the chained tweens start exactly at the time they should,
						// even if the `update()` method was called way past the duration of the tween
						this._chainedTweens[i].start(this._startTime + this._duration);
					}
	
					return false;
	
				}
	
			}
	
			return true;
	
		}
	};
	
	
	TWEEN.Easing = {
	
		Linear: {
	
			None: function (k) {
	
				return k;
	
			}
	
		},
	
		Quadratic: {
	
			In: function (k) {
	
				return k * k;
	
			},
	
			Out: function (k) {
	
				return k * (2 - k);
	
			},
	
			InOut: function (k) {
	
				if ((k *= 2) < 1) {
					return 0.5 * k * k;
				}
	
				return - 0.5 * (--k * (k - 2) - 1);
	
			}
	
		},
	
		Cubic: {
	
			In: function (k) {
	
				return k * k * k;
	
			},
	
			Out: function (k) {
	
				return --k * k * k + 1;
	
			},
	
			InOut: function (k) {
	
				if ((k *= 2) < 1) {
					return 0.5 * k * k * k;
				}
	
				return 0.5 * ((k -= 2) * k * k + 2);
	
			}
	
		},
	
		Quartic: {
	
			In: function (k) {
	
				return k * k * k * k;
	
			},
	
			Out: function (k) {
	
				return 1 - (--k * k * k * k);
	
			},
	
			InOut: function (k) {
	
				if ((k *= 2) < 1) {
					return 0.5 * k * k * k * k;
				}
	
				return - 0.5 * ((k -= 2) * k * k * k - 2);
	
			}
	
		},
	
		Quintic: {
	
			In: function (k) {
	
				return k * k * k * k * k;
	
			},
	
			Out: function (k) {
	
				return --k * k * k * k * k + 1;
	
			},
	
			InOut: function (k) {
	
				if ((k *= 2) < 1) {
					return 0.5 * k * k * k * k * k;
				}
	
				return 0.5 * ((k -= 2) * k * k * k * k + 2);
	
			}
	
		},
	
		Sinusoidal: {
	
			In: function (k) {
	
				return 1 - Math.cos(k * Math.PI / 2);
	
			},
	
			Out: function (k) {
	
				return Math.sin(k * Math.PI / 2);
	
			},
	
			InOut: function (k) {
	
				return 0.5 * (1 - Math.cos(Math.PI * k));
	
			}
	
		},
	
		Exponential: {
	
			In: function (k) {
	
				return k === 0 ? 0 : Math.pow(1024, k - 1);
	
			},
	
			Out: function (k) {
	
				return k === 1 ? 1 : 1 - Math.pow(2, - 10 * k);
	
			},
	
			InOut: function (k) {
	
				if (k === 0) {
					return 0;
				}
	
				if (k === 1) {
					return 1;
				}
	
				if ((k *= 2) < 1) {
					return 0.5 * Math.pow(1024, k - 1);
				}
	
				return 0.5 * (- Math.pow(2, - 10 * (k - 1)) + 2);
	
			}
	
		},
	
		Circular: {
	
			In: function (k) {
	
				return 1 - Math.sqrt(1 - k * k);
	
			},
	
			Out: function (k) {
	
				return Math.sqrt(1 - (--k * k));
	
			},
	
			InOut: function (k) {
	
				if ((k *= 2) < 1) {
					return - 0.5 * (Math.sqrt(1 - k * k) - 1);
				}
	
				return 0.5 * (Math.sqrt(1 - (k -= 2) * k) + 1);
	
			}
	
		},
	
		Elastic: {
	
			In: function (k) {
	
				if (k === 0) {
					return 0;
				}
	
				if (k === 1) {
					return 1;
				}
	
				return -Math.pow(2, 10 * (k - 1)) * Math.sin((k - 1.1) * 5 * Math.PI);
	
			},
	
			Out: function (k) {
	
				if (k === 0) {
					return 0;
				}
	
				if (k === 1) {
					return 1;
				}
	
				return Math.pow(2, -10 * k) * Math.sin((k - 0.1) * 5 * Math.PI) + 1;
	
			},
	
			InOut: function (k) {
	
				if (k === 0) {
					return 0;
				}
	
				if (k === 1) {
					return 1;
				}
	
				k *= 2;
	
				if (k < 1) {
					return -0.5 * Math.pow(2, 10 * (k - 1)) * Math.sin((k - 1.1) * 5 * Math.PI);
				}
	
				return 0.5 * Math.pow(2, -10 * (k - 1)) * Math.sin((k - 1.1) * 5 * Math.PI) + 1;
	
			}
	
		},
	
		Back: {
	
			In: function (k) {
	
				var s = 1.70158;
	
				return k * k * ((s + 1) * k - s);
	
			},
	
			Out: function (k) {
	
				var s = 1.70158;
	
				return --k * k * ((s + 1) * k + s) + 1;
	
			},
	
			InOut: function (k) {
	
				var s = 1.70158 * 1.525;
	
				if ((k *= 2) < 1) {
					return 0.5 * (k * k * ((s + 1) * k - s));
				}
	
				return 0.5 * ((k -= 2) * k * ((s + 1) * k + s) + 2);
	
			}
	
		},
	
		Bounce: {
	
			In: function (k) {
	
				return 1 - TWEEN.Easing.Bounce.Out(1 - k);
	
			},
	
			Out: function (k) {
	
				if (k < (1 / 2.75)) {
					return 7.5625 * k * k;
				} else if (k < (2 / 2.75)) {
					return 7.5625 * (k -= (1.5 / 2.75)) * k + 0.75;
				} else if (k < (2.5 / 2.75)) {
					return 7.5625 * (k -= (2.25 / 2.75)) * k + 0.9375;
				} else {
					return 7.5625 * (k -= (2.625 / 2.75)) * k + 0.984375;
				}
	
			},
	
			InOut: function (k) {
	
				if (k < 0.5) {
					return TWEEN.Easing.Bounce.In(k * 2) * 0.5;
				}
	
				return TWEEN.Easing.Bounce.Out(k * 2 - 1) * 0.5 + 0.5;
	
			}
	
		}
	
	};
	
	TWEEN.Interpolation = {
	
		Linear: function (v, k) {
	
			var m = v.length - 1;
			var f = m * k;
			var i = Math.floor(f);
			var fn = TWEEN.Interpolation.Utils.Linear;
	
			if (k < 0) {
				return fn(v[0], v[1], f);
			}
	
			if (k > 1) {
				return fn(v[m], v[m - 1], m - f);
			}
	
			return fn(v[i], v[i + 1 > m ? m : i + 1], f - i);
	
		},
	
		Bezier: function (v, k) {
	
			var b = 0;
			var n = v.length - 1;
			var pw = Math.pow;
			var bn = TWEEN.Interpolation.Utils.Bernstein;
	
			for (var i = 0; i <= n; i++) {
				b += pw(1 - k, n - i) * pw(k, i) * v[i] * bn(n, i);
			}
	
			return b;
	
		},
	
		CatmullRom: function (v, k) {
	
			var m = v.length - 1;
			var f = m * k;
			var i = Math.floor(f);
			var fn = TWEEN.Interpolation.Utils.CatmullRom;
	
			if (v[0] === v[m]) {
	
				if (k < 0) {
					i = Math.floor(f = m * (1 + k));
				}
	
				return fn(v[(i - 1 + m) % m], v[i], v[(i + 1) % m], v[(i + 2) % m], f - i);
	
			} else {
	
				if (k < 0) {
					return v[0] - (fn(v[0], v[0], v[1], v[1], -f) - v[0]);
				}
	
				if (k > 1) {
					return v[m] - (fn(v[m], v[m], v[m - 1], v[m - 1], f - m) - v[m]);
				}
	
				return fn(v[i ? i - 1 : 0], v[i], v[m < i + 1 ? m : i + 1], v[m < i + 2 ? m : i + 2], f - i);
	
			}
	
		},
	
		Utils: {
	
			Linear: function (p0, p1, t) {
	
				return (p1 - p0) * t + p0;
	
			},
	
			Bernstein: function (n, i) {
	
				var fc = TWEEN.Interpolation.Utils.Factorial;
	
				return fc(n) / fc(i) / fc(n - i);
	
			},
	
			Factorial: (function () {
	
				var a = [1];
	
				return function (n) {
	
					var s = 1;
	
					if (a[n]) {
						return a[n];
					}
	
					for (var i = n; i > 1; i--) {
						s *= i;
					}
	
					a[n] = s;
					return s;
	
				};
	
			})(),
	
			CatmullRom: function (p0, p1, p2, p3, t) {
	
				var v0 = (p2 - p0) * 0.5;
				var v1 = (p3 - p1) * 0.5;
				var t2 = t * t;
				var t3 = t * t2;
	
				return (2 * p1 - 2 * p2 + v0 + v1) * t3 + (- 3 * p1 + 3 * p2 - 2 * v0 - v1) * t2 + v0 * t + p1;
	
			}
	
		}
	
	};
	
	// UMD (Universal Module Definition)
	(function (root) {
	
		if (true) {
	
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return TWEEN;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
		} else if (typeof module !== 'undefined' && typeof exports === 'object') {
	
			// Node.js
			module.exports = TWEEN;
	
		} else if (root !== undefined) {
	
			// Global variable
			root.TWEEN = TWEEN;
	
		}
	
	})(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(199)))

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var utils = __webpack_require__(19);
	var normalizeHeaderName = __webpack_require__(237);
	
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	function getDefaultAdapter() {
	  var adapter;
	  if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = __webpack_require__(135);
	  } else if (typeof process !== 'undefined') {
	    // For node use HTTP adapter
	    adapter = __webpack_require__(135);
	  }
	  return adapter;
	}
	
	var defaults = {
	  adapter: getDefaultAdapter(),
	
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Content-Type');
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	    if (utils.isObject(data)) {
	      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
	      return JSON.stringify(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    /*eslint no-param-reassign:0*/
	    if (typeof data === 'string') {
	      try {
	        data = JSON.parse(data);
	      } catch (e) { /* Ignore */ }
	    }
	    return data;
	  }],
	
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  }
	};
	
	defaults.headers = {
	  common: {
	    'Accept': 'application/json, text/plain, */*'
	  }
	};
	
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  defaults.headers[method] = {};
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
	});
	
	module.exports = defaults;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(199)))

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.toggleMenu = exports.toggleLoading = exports.setSection = exports.toggleAreaFilter = exports.resetAreaFilters = exports.resetKindFilters = exports.toggleKindFilter = exports.mapLeaving = exports.singleLeaving = exports.setAppLoaded = exports.setLoading = exports.setProjectsDate = exports.setKindTitle = exports.setLanguage = exports.setCompassHiddenOnMobile = exports.setCompass = exports.setProjectsGridActive = exports.setMaterialsGridActive = exports.setProjectsViewMode = exports.setCurrentTimelineProjectIndex = exports.getIP = exports.setCursor = exports.setKindFeaturedImagePath = exports.setNextSection = exports.SET_PROJECTS_DATE = exports.SET_CURSOR = exports.RESET_KIND_FILTERS = exports.RESET_AREA_FILTERS = exports.SET_KIND_FEATURED_IMAGE = exports.SET_CURRENT_TL_PROJECT_INDEX = exports.SET_PROJECTS_VIEW_MODE = exports.SET_PROJECTS_GRID_ACTIVE = exports.SET_MATERIALS_GRID_ACTIVE = exports.SET_KIND_TITLE = exports.TOGGLE_AREA_FILTER = exports.TOGGLE_KIND_FILTER = exports.APP_LOADED = exports.GET_IP = exports.MAP_LEAVING = exports.SINGLE_LEAVING = exports.SET_LOADING = exports.TOGGLE_MENU = exports.SET_COMPASS_HIDDEN_ON_MOBILE = exports.SET_COMPASS = exports.TOGGLE_LOADING = exports.SET_NEXT_SECTION = exports.SET_LANG = exports.SET_SECTION = undefined;
	
	var _localize = __webpack_require__(152);
	
	var _localize2 = _interopRequireDefault(_localize);
	
	var _kit = __webpack_require__(43);
	
	var _axios = __webpack_require__(69);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactRouterRedux = __webpack_require__(60);
	
	var _data = __webpack_require__(70);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/*
	/*
	/*        R E D U C E R
	/*
	/*
	*/
	
	// import Superface from '../Superface';
	var SET_SECTION = exports.SET_SECTION = 'app/SET_SECTION';
	var SET_LANG = exports.SET_LANG = 'app/SET_LANG';
	var SET_NEXT_SECTION = exports.SET_NEXT_SECTION = 'app/SET_NEXT_SECTION';
	var TOGGLE_LOADING = exports.TOGGLE_LOADING = 'app/TOGGLE_LOADING';
	var SET_COMPASS = exports.SET_COMPASS = 'app/SET_COMPASS';
	var SET_COMPASS_HIDDEN_ON_MOBILE = exports.SET_COMPASS_HIDDEN_ON_MOBILE = 'app/SET_COMPASS_HIDDEN_ON_MOBILE';
	var TOGGLE_MENU = exports.TOGGLE_MENU = 'app/TOGGLE_MENU';
	var SET_LOADING = exports.SET_LOADING = 'app/SET_LOADING';
	var SINGLE_LEAVING = exports.SINGLE_LEAVING = 'app/SINGLE_LEAVING';
	var MAP_LEAVING = exports.MAP_LEAVING = 'app/MAP_LEAVING';
	var GET_IP = exports.GET_IP = 'app/GET_IP';
	
	var APP_LOADED = exports.APP_LOADED = 'app/APP_LOADED';
	
	// Materials
	var TOGGLE_KIND_FILTER = exports.TOGGLE_KIND_FILTER = 'app/TOGGLE_KIND_FILTER';
	var TOGGLE_AREA_FILTER = exports.TOGGLE_AREA_FILTER = 'app/TOGGLE_AREA_FILTER';
	var SET_KIND_TITLE = exports.SET_KIND_TITLE = 'app/SET_KIND_TITLE';
	var SET_MATERIALS_GRID_ACTIVE = exports.SET_MATERIALS_GRID_ACTIVE = 'app/SET_MATERIALS_GRID_ACTIVE';
	var SET_PROJECTS_GRID_ACTIVE = exports.SET_PROJECTS_GRID_ACTIVE = 'app/SET_PROJECTS_GRID_ACTIVE';
	var SET_PROJECTS_VIEW_MODE = exports.SET_PROJECTS_VIEW_MODE = 'app/SET_PROJECTS_VIEW_MODE';
	var SET_CURRENT_TL_PROJECT_INDEX = exports.SET_CURRENT_TL_PROJECT_INDEX = 'app/SET_CURRENT_TL_PROJECT_INDEX';
	var SET_KIND_FEATURED_IMAGE = exports.SET_KIND_FEATURED_IMAGE = 'app/SET_KIND_FEATURED_IMAGE';
	var RESET_AREA_FILTERS = exports.RESET_AREA_FILTERS = 'app/RESET_AREA_FILTERS';
	var RESET_KIND_FILTERS = exports.RESET_KIND_FILTERS = 'app/RESET_KIND_FILTERS';
	
	var SET_CURSOR = exports.SET_CURSOR = 'app/SET_CURSOR';
	
	// Projects
	var SET_PROJECTS_DATE = exports.SET_PROJECTS_DATE = 'app/SET_PROJECTS_DATE';
	
	var LANG = (0, _localize2.default)();
	
	var initialState = {
		loaded: false,
		cardinal: 'N',
		loading: false,
		menuOpen: false,
		currentSection: '',
		previousSection: '',
		kindTitle: '',
		kindsFilters: [],
		areasFilters: [],
		// currentKind : false,
		entry: undefined,
		projectsDate: '2017',
		nextSection: false,
		lang: LANG,
		materialsGridActive: false,
		projectsGridActive: false,
		projectsViewMode: !(0, _kit.isTabletOrMobile)() ? 'timeline' : 'areas',
		currentTimeLineProjectIndex: 0,
		cursor: 'default',
		isOnSingle: false,
		kindFeaturedImagePath: '',
		compassHiddenOnMobile: false,
		singleLeaving: false,
		mapLeaving: false,
		ip: null
	};
	
	exports.default = function () {
		var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
		var action = arguments[1];
		var root = arguments[2];
	
	
		switch (action.type) {
	
			case SET_PROJECTS_VIEW_MODE:
				return Object.assign({}, state, {
					projectsViewMode: action.payload
				});
	
			case SINGLE_LEAVING:
				return Object.assign({}, state, {
					singleLeaving: action.payload
				});
	
			case MAP_LEAVING:
				return Object.assign({}, state, {
					mapLeaving: action.payload
				});
	
			case GET_IP:
				return Object.assign({}, state, {
					ip: action.payload
				});
	
			case SET_CURSOR:
				return Object.assign({}, state, {
					cursor: action.payload
				});
	
			case SET_CURRENT_TL_PROJECT_INDEX:
				return Object.assign({}, state, {
					currentTimeLineProjectIndex: action.payload
				});
	
			case SET_MATERIALS_GRID_ACTIVE:
				return Object.assign({}, state, {
					materialsGridActive: action.payload
				});
	
			case SET_PROJECTS_GRID_ACTIVE:
				return Object.assign({}, state, {
					projectsGridActive: action.payload
				});
	
			case SET_LANG:
				return Object.assign({}, state, {
					lang: action.payload
				});
	
			case TOGGLE_MENU:
				// alert('TOGGLEMENU')
				return Object.assign({}, state, {
					menuOpen: !state.menuOpen
				});
	
			case APP_LOADED:
				// alert('LOADED')
				return Object.assign({}, state, {
					loaded: true
				});
	
			case SET_LOADING:
				return Object.assign({}, state, {
					loading: action.payload
				});
	
			case SET_KIND_FEATURED_IMAGE:
				return Object.assign({}, state, {
					kindFeaturedImagePath: action.payload
				});
	
			case _data.GET_PROJECTS_AREAS:
				var areas = [].concat(_toConsumableArray(action.payload));
				var areasFilters = [];
	
				areas.forEach(function (area) {
					areasFilters.push({
						active: true,
						_id: area._id,
						slug: area.slug,
						name: area.name,
						name_en: area.name_en
					});
				});
	
				return Object.assign({}, state, {
					areasFilters: areasFilters
				});
	
			case _data.GET_MATERIALS_KINDS:
				var kinds = [].concat(_toConsumableArray(action.payload));
				var kindsFilters = [];
	
				kinds.forEach(function (kind) {
					kindsFilters.push({
						active: true,
						_id: kind._id,
						slug: kind.slug,
						name: kind.name,
						name_en: kind.name_en
					});
				});
	
				return Object.assign({}, state, {
					kindsFilters: kindsFilters
				});
	
			case SET_PROJECTS_DATE:
				if (state.projectsDate !== action.payload) {
					return Object.assign({}, state, {
						projectsDate: action.payload
					});
				} else {
					return state;
				}
	
			case SET_KIND_TITLE:
	
				return Object.assign({}, state, {
					kindTitle: action.payload
				});
	
			case TOGGLE_KIND_FILTER:
				var filters = [].concat(_toConsumableArray(state.kindsFilters));
				// console.log(filters)
				filters.forEach(function (filter) {
					filter.active = filter.slug === action.payload ? !filter.active : filter.active;
				});
				return Object.assign({}, state, {
					kindsFilters: filters
				});
	
			case TOGGLE_AREA_FILTER:
				var filters_area = [].concat(_toConsumableArray(state.areasFilters));
				// console.log(filters)
				filters_area.forEach(function (filter) {
					filter.active = filter.slug === action.payload ? !filter.active : filter.active;
				});
				return Object.assign({}, state, {
					areasFilters: filters_area
				});
	
			case RESET_AREA_FILTERS:
				var filters_area_bis = [].concat(_toConsumableArray(state.areasFilters));
				filters_area_bis.forEach(function (filter) {
					filter.active = true;
				});
				return Object.assign({}, state, {
					areasFilters: filters_area_bis
				});
	
			case RESET_KIND_FILTERS:
				var filters_kind = [].concat(_toConsumableArray(state.kindsFilters));
				// console.log(filters)
				filters_kind.forEach(function (filter) {
					filter.active = true;
				});
				return Object.assign({}, state, {
					kindsFilters: filters_kind
	
					// case SET_MATERIAUTHEQUE_PROGRESS:
					// 	// alert('TOGGLEMENU')
					// 	return{
					// 		...state,
					// 		materiauthequeProgress : action.payload
					// 	}
	
				});case SET_COMPASS:
				// console.log('set : ', action.payload)
				return Object.assign({}, state, {
					cardinal: action.payload
				});
	
			case SET_COMPASS_HIDDEN_ON_MOBILE:
	
				return Object.assign({}, state, {
					compassHiddenOnMobile: action.payload
				});
	
			case TOGGLE_LOADING:
	
				return Object.assign({}, state, {
					loading: !state.loading
				});
	
			case SET_SECTION:
				// alert('SET_SECTION')
				return Object.assign({}, state, {
					// cardinal: getCardinal(action.payload),
					currentSection: action.payload,
					previousSection: state.currentSection
				});
	
			case SET_NEXT_SECTION:
				// console.log(action.payload)
				return Object.assign({}, state, {
					nextSection: action.payload
				});
	
			case _reactRouterRedux.LOCATION_CHANGE:
	
				var path = action.payload.pathname;
				var sectionSlug = path === '/' ? 'accueil' : path.split('/')[1];
				var isOnSingle = path.split('/')[2] !== undefined;
				return Object.assign({}, state, {
					currentSection: sectionSlug,
					previousSection: state.currentSection,
					isOnSingle: isOnSingle
	
				});
	
			default:
				return state;
		}
	};
	
	/*
	/*
	/*        A C T I O N S
	/*
	/*
	*/
	
	var setNextSection = exports.setNextSection = function setNextSection(route) {
	
		return function (dispatch) {
	
			dispatch({
				type: SET_NEXT_SECTION,
				payload: route
			});
		};
	};
	
	var setKindFeaturedImagePath = exports.setKindFeaturedImagePath = function setKindFeaturedImagePath(path) {
	
		return function (dispatch) {
	
			dispatch({
				type: SET_KIND_FEATURED_IMAGE,
				payload: path
			});
		};
	};
	
	var setCursor = exports.setCursor = function setCursor(string) {
	
		return function (dispatch) {
	
			dispatch({
				type: SET_CURSOR,
				payload: string
			});
		};
	};
	
	var getIP = exports.getIP = function getIP() {
	
		return function (dispatch) {
	
			_axios2.default.request({
				method: 'get',
				url: 'https://api.ipify.org'
			}).then(function (result) {
				dispatch({ type: GET_IP, payload: result.data });
			});
		};
	};
	
	var setCurrentTimelineProjectIndex = exports.setCurrentTimelineProjectIndex = function setCurrentTimelineProjectIndex(index) {
		// console.log(index)
	
		return function (dispatch) {
	
			dispatch({
				type: SET_CURRENT_TL_PROJECT_INDEX,
				payload: index
			});
		};
	};
	
	var setProjectsViewMode = exports.setProjectsViewMode = function setProjectsViewMode(mode) {
	
		return function (dispatch) {
	
			dispatch({
				type: SET_PROJECTS_VIEW_MODE,
				payload: mode
			});
		};
	};
	
	var setMaterialsGridActive = exports.setMaterialsGridActive = function setMaterialsGridActive(bool) {
	
		return function (dispatch) {
	
			dispatch({
				type: SET_MATERIALS_GRID_ACTIVE,
				payload: bool
			});
		};
	};
	
	var setProjectsGridActive = exports.setProjectsGridActive = function setProjectsGridActive(bool) {
	
		return function (dispatch) {
	
			dispatch({
				type: SET_PROJECTS_GRID_ACTIVE,
				payload: bool
			});
		};
	};
	
	var setCompass = exports.setCompass = function setCompass(cardinal) {
		// console.log(cardinal)
		return function (dispatch) {
	
			dispatch({
				type: SET_COMPASS,
				payload: cardinal
			});
		};
	};
	
	var setCompassHiddenOnMobile = exports.setCompassHiddenOnMobile = function setCompassHiddenOnMobile(bool) {
	
		return function (dispatch) {
	
			dispatch({
				type: SET_COMPASS_HIDDEN_ON_MOBILE,
				payload: bool
			});
		};
	};
	
	var setLanguage = exports.setLanguage = function setLanguage(iso) {
	
		return function (dispatch) {
	
			dispatch({
				type: SET_LANG,
				payload: iso
			});
		};
	};
	
	var setKindTitle = exports.setKindTitle = function setKindTitle(title) {
	
		// console.log(progress)
		return function (dispatch) {
			dispatch({
				type: SET_KIND_TITLE,
				payload: title
			});
		};
	};
	
	var setProjectsDate = exports.setProjectsDate = function setProjectsDate(year) {
	
		// console.log(year)
		return function (dispatch) {
			dispatch({
				type: SET_PROJECTS_DATE,
				payload: year
			});
		};
	};
	
	var setLoading = exports.setLoading = function setLoading(bool) {
	
		// console.log(year)
		return function (dispatch) {
			dispatch({
				type: SET_LOADING,
				payload: bool
			});
		};
	};
	
	var setAppLoaded = exports.setAppLoaded = function setAppLoaded() {
	
		return function (dispatch) {
			dispatch({
				type: APP_LOADED
			});
		};
	};
	
	var singleLeaving = exports.singleLeaving = function singleLeaving(bool) {
	
		return function (dispatch) {
			dispatch({
				type: SINGLE_LEAVING,
				payload: bool
			});
		};
	};
	
	var mapLeaving = exports.mapLeaving = function mapLeaving(bool) {
	
		return function (dispatch) {
			dispatch({
				type: MAP_LEAVING,
				payload: bool
			});
		};
	};
	
	var toggleKindFilter = exports.toggleKindFilter = function toggleKindFilter(slug) {
	
		return function (dispatch) {
			dispatch({
				type: TOGGLE_KIND_FILTER,
				payload: slug
			});
		};
	};
	var resetKindFilters = exports.resetKindFilters = function resetKindFilters(slug) {
	
		return function (dispatch) {
			dispatch({
				type: RESET_KIND_FILTERS
			});
		};
	};
	var resetAreaFilters = exports.resetAreaFilters = function resetAreaFilters(slug) {
	
		return function (dispatch) {
			dispatch({
				type: RESET_AREA_FILTERS
			});
		};
	};
	
	var toggleAreaFilter = exports.toggleAreaFilter = function toggleAreaFilter(slug) {
	
		return function (dispatch) {
			dispatch({
				type: TOGGLE_AREA_FILTER,
				payload: slug
			});
		};
	};
	
	var setSection = exports.setSection = function setSection(name) {
	
		return function (dispatch) {
	
			dispatch({
				type: SET_SECTION,
				payload: name
			});
		};
	};
	
	var toggleLoading = exports.toggleLoading = function toggleLoading() {
	
		return function (dispatch) {
	
			dispatch({
				type: TOGGLE_LOADING
			});
		};
	};
	
	var toggleMenu = exports.toggleMenu = function toggleMenu() {
	
		return function (dispatch) {
	
			dispatch({
				type: TOGGLE_MENU
			});
		};
	};
	
	// export const togglePoint = (name) => {
	
	// 	return dispatch => {
	// 		dispatch({
	// 			type: 'app/TOGGLE_' + name.toUpperCase(),
	// 		})
	// 	}
	// }

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Plus = function Plus(props) {
	  return _react2.default.createElement(
	    'span',
	    { className: 'plus' },
	    _react2.default.createElement('span', { className: 'plus-v ' + (props.selected ? 'selected' : '') }),
	    _react2.default.createElement('span', { className: 'plus-h' })
	  );
	};
	
	exports.default = Plus;

/***/ },
/* 96 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var protocol = location.protocol;
	var slashes = protocol.concat("//");
	
	var HOST = exports.HOST = slashes.concat(window.location.href.split("/")[2]);
	var ROOT_URL = exports.ROOT_URL = HOST;
	var THUMB_URL = exports.THUMB_URL = (ROOT_URL + '/superadmin/cockpit/utils/thumb_url').replace('3000', '');
	var API_URL = exports.API_URL = HOST.replace('3000', '') + '/superadmin/api';
	var TOKEN = exports.TOKEN = 'c00095a41ede59b046a8e9745288a6';

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(13);
	var toAbsoluteIndex = __webpack_require__(52);
	var toLength = __webpack_require__(11);
	module.exports = function fill(value /* , start = 0, end = @length */) {
	  var O = toObject(this);
	  var length = toLength(O.length);
	  var aLen = arguments.length;
	  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
	  var end = aLen > 2 ? arguments[2] : undefined;
	  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
	  while (endPos > index) O[index++] = value;
	  return O;
	};


/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(266);
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};


/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(10);
	var createDesc = __webpack_require__(49);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(6);
	var document = __webpack_require__(4).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ },
/* 101 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(8)('match');
	module.exports = function (KEY) {
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch (e) {
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch (f) { /* empty */ }
	  } return true;
	};


/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	var document = __webpack_require__(4).document;
	module.exports = document && document.documentElement;


/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(6);
	var setPrototypeOf = __webpack_require__(112).set;
	module.exports = function (that, target, C) {
	  var S = target.constructor;
	  var P;
	  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
	    setPrototypeOf(that, P);
	  } return that;
	};


/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(54);
	var ITERATOR = __webpack_require__(8)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(46);
	var descriptor = __webpack_require__(49);
	var setToStringTag = __webpack_require__(55);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(16)(IteratorPrototype, __webpack_require__(8)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(38);
	var $export = __webpack_require__(1);
	var redefine = __webpack_require__(17);
	var hide = __webpack_require__(16);
	var Iterators = __webpack_require__(54);
	var $iterCreate = __webpack_require__(106);
	var setToStringTag = __webpack_require__(55);
	var getPrototypeOf = __webpack_require__(22);
	var ITERATOR = __webpack_require__(8)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ },
/* 108 */
/***/ function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x) {
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;


/***/ },
/* 109 */
/***/ function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};


/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(4);
	var macrotask = __webpack_require__(118).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(25)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(14);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(6);
	var anObject = __webpack_require__(3);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(27)(Function.call, __webpack_require__(21).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(84)('keys');
	var uid = __webpack_require__(53);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(32);
	var defined = __webpack_require__(30);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(78);
	var defined = __webpack_require__(30);
	
	module.exports = function (that, searchString, NAME) {
	  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};


/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(32);
	var defined = __webpack_require__(30);
	
	module.exports = function repeat(count) {
	  var str = String(defined(this));
	  var res = '';
	  var n = toInteger(count);
	  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
	  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
	  return res;
	};


/***/ },
/* 117 */
/***/ function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(27);
	var invoke = __webpack_require__(165);
	var html = __webpack_require__(103);
	var cel = __webpack_require__(100);
	var global = __webpack_require__(4);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(25)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(4);
	var DESCRIPTORS = __webpack_require__(9);
	var LIBRARY = __webpack_require__(38);
	var $typed = __webpack_require__(86);
	var hide = __webpack_require__(16);
	var redefineAll = __webpack_require__(50);
	var fails = __webpack_require__(5);
	var anInstance = __webpack_require__(44);
	var toInteger = __webpack_require__(32);
	var toLength = __webpack_require__(11);
	var toIndex = __webpack_require__(183);
	var gOPN = __webpack_require__(47).f;
	var dP = __webpack_require__(10).f;
	var arrayFill = __webpack_require__(97);
	var setToStringTag = __webpack_require__(55);
	var ARRAY_BUFFER = 'ArrayBuffer';
	var DATA_VIEW = 'DataView';
	var PROTOTYPE = 'prototype';
	var WRONG_LENGTH = 'Wrong length!';
	var WRONG_INDEX = 'Wrong index!';
	var $ArrayBuffer = global[ARRAY_BUFFER];
	var $DataView = global[DATA_VIEW];
	var Math = global.Math;
	var RangeError = global.RangeError;
	// eslint-disable-next-line no-shadow-restricted-names
	var Infinity = global.Infinity;
	var BaseBuffer = $ArrayBuffer;
	var abs = Math.abs;
	var pow = Math.pow;
	var floor = Math.floor;
	var log = Math.log;
	var LN2 = Math.LN2;
	var BUFFER = 'buffer';
	var BYTE_LENGTH = 'byteLength';
	var BYTE_OFFSET = 'byteOffset';
	var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
	var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
	var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	// IEEE754 conversions based on https://github.com/feross/ieee754
	function packIEEE754(value, mLen, nBytes) {
	  var buffer = new Array(nBytes);
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
	  var i = 0;
	  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
	  var e, m, c;
	  value = abs(value);
	  // eslint-disable-next-line no-self-compare
	  if (value != value || value === Infinity) {
	    // eslint-disable-next-line no-self-compare
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if (value * (c = pow(2, -e)) < 1) {
	      e--;
	      c *= 2;
	    }
	    if (e + eBias >= 1) {
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if (value * c >= 2) {
	      e++;
	      c /= 2;
	    }
	    if (e + eBias >= eMax) {
	      m = 0;
	      e = eMax;
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
	  e = e << mLen | m;
	  eLen += mLen;
	  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
	  buffer[--i] |= s * 128;
	  return buffer;
	}
	function unpackIEEE754(buffer, mLen, nBytes) {
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var nBits = eLen - 7;
	  var i = nBytes - 1;
	  var s = buffer[i--];
	  var e = s & 127;
	  var m;
	  s >>= 7;
	  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
	  if (e === 0) {
	    e = 1 - eBias;
	  } else if (e === eMax) {
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  } return (s ? -1 : 1) * m * pow(2, e - mLen);
	}
	
	function unpackI32(bytes) {
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	}
	function packI8(it) {
	  return [it & 0xff];
	}
	function packI16(it) {
	  return [it & 0xff, it >> 8 & 0xff];
	}
	function packI32(it) {
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	}
	function packF64(it) {
	  return packIEEE754(it, 52, 8);
	}
	function packF32(it) {
	  return packIEEE754(it, 23, 4);
	}
	
	function addGetter(C, key, internal) {
	  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
	}
	
	function get(view, bytes, index, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	}
	function set(view, bytes, index, conversion, value, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = conversion(+value);
	  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	}
	
	if (!$typed.ABV) {
	  $ArrayBuffer = function ArrayBuffer(length) {
	    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
	    var byteLength = toIndex(length);
	    this._b = arrayFill.call(new Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	
	  $DataView = function DataView(buffer, byteOffset, byteLength) {
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH];
	    var offset = toInteger(byteOffset);
	    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	
	  if (DESCRIPTORS) {
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset) {
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset) {
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if (!fails(function () {
	    $ArrayBuffer(1);
	  }) || !fails(function () {
	    new $ArrayBuffer(-1); // eslint-disable-line no-new
	  }) || fails(function () {
	    new $ArrayBuffer(); // eslint-disable-line no-new
	    new $ArrayBuffer(1.5); // eslint-disable-line no-new
	    new $ArrayBuffer(NaN); // eslint-disable-line no-new
	    return $ArrayBuffer.name != ARRAY_BUFFER;
	  })) {
	    $ArrayBuffer = function ArrayBuffer(length) {
	      anInstance(this, $ArrayBuffer);
	      return new BaseBuffer(toIndex(length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
	      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
	    }
	    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2));
	  var $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;


/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(4);
	var core = __webpack_require__(26);
	var LIBRARY = __webpack_require__(38);
	var wksExt = __webpack_require__(184);
	var defineProperty = __webpack_require__(10).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(61);
	var ITERATOR = __webpack_require__(8)('iterator');
	var Iterators = __webpack_require__(54);
	module.exports = __webpack_require__(26).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(37);
	var step = __webpack_require__(168);
	var Iterators = __webpack_require__(54);
	var toIObject = __webpack_require__(23);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(107)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/arrow-left.21c76116.svg";

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/arrow-right.184e9abd.svg";

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * getSize v2.0.3
	 * measure size of elements
	 * MIT license
	 */
	
	/* jshint browser: true, strict: true, undef: true, unused: true */
	/* globals console: false */
	
	( function( window, factory ) {
	  /* jshint strict: false */ /* globals define, module */
	  if ( true ) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS
	    module.exports = factory();
	  } else {
	    // browser global
	    window.getSize = factory();
	  }
	
	})( window, function factory() {
	'use strict';
	
	// -------------------------- helpers -------------------------- //
	
	// get a number from a string, not a percentage
	function getStyleSize( value ) {
	  var num = parseFloat( value );
	  // not a percent like '100%', and a number
	  var isValid = value.indexOf('%') == -1 && !isNaN( num );
	  return isValid && num;
	}
	
	function noop() {}
	
	var logError = typeof console == 'undefined' ? noop :
	  function( message ) {
	    console.error( message );
	  };
	
	// -------------------------- measurements -------------------------- //
	
	var measurements = [
	  'paddingLeft',
	  'paddingRight',
	  'paddingTop',
	  'paddingBottom',
	  'marginLeft',
	  'marginRight',
	  'marginTop',
	  'marginBottom',
	  'borderLeftWidth',
	  'borderRightWidth',
	  'borderTopWidth',
	  'borderBottomWidth'
	];
	
	var measurementsLength = measurements.length;
	
	function getZeroSize() {
	  var size = {
	    width: 0,
	    height: 0,
	    innerWidth: 0,
	    innerHeight: 0,
	    outerWidth: 0,
	    outerHeight: 0
	  };
	  for ( var i=0; i < measurementsLength; i++ ) {
	    var measurement = measurements[i];
	    size[ measurement ] = 0;
	  }
	  return size;
	}
	
	// -------------------------- getStyle -------------------------- //
	
	/**
	 * getStyle, get style of element, check for Firefox bug
	 * https://bugzilla.mozilla.org/show_bug.cgi?id=548397
	 */
	function getStyle( elem ) {
	  var style = getComputedStyle( elem );
	  if ( !style ) {
	    logError( 'Style returned ' + style +
	      '. Are you running this code in a hidden iframe on Firefox? ' +
	      'See https://bit.ly/getsizebug1' );
	  }
	  return style;
	}
	
	// -------------------------- setup -------------------------- //
	
	var isSetup = false;
	
	var isBoxSizeOuter;
	
	/**
	 * setup
	 * check isBoxSizerOuter
	 * do on first getSize() rather than on page load for Firefox bug
	 */
	function setup() {
	  // setup once
	  if ( isSetup ) {
	    return;
	  }
	  isSetup = true;
	
	  // -------------------------- box sizing -------------------------- //
	
	  /**
	   * Chrome & Safari measure the outer-width on style.width on border-box elems
	   * IE11 & Firefox<29 measures the inner-width
	   */
	  var div = document.createElement('div');
	  div.style.width = '200px';
	  div.style.padding = '1px 2px 3px 4px';
	  div.style.borderStyle = 'solid';
	  div.style.borderWidth = '1px 2px 3px 4px';
	  div.style.boxSizing = 'border-box';
	
	  var body = document.body || document.documentElement;
	  body.appendChild( div );
	  var style = getStyle( div );
	  // round value for browser zoom. desandro/masonry#928
	  isBoxSizeOuter = Math.round( getStyleSize( style.width ) ) == 200;
	  getSize.isBoxSizeOuter = isBoxSizeOuter;
	
	  body.removeChild( div );
	}
	
	// -------------------------- getSize -------------------------- //
	
	function getSize( elem ) {
	  setup();
	
	  // use querySeletor if elem is string
	  if ( typeof elem == 'string' ) {
	    elem = document.querySelector( elem );
	  }
	
	  // do not proceed on non-objects
	  if ( !elem || typeof elem != 'object' || !elem.nodeType ) {
	    return;
	  }
	
	  var style = getStyle( elem );
	
	  // if hidden, everything is 0
	  if ( style.display == 'none' ) {
	    return getZeroSize();
	  }
	
	  var size = {};
	  size.width = elem.offsetWidth;
	  size.height = elem.offsetHeight;
	
	  var isBorderBox = size.isBorderBox = style.boxSizing == 'border-box';
	
	  // get all measurements
	  for ( var i=0; i < measurementsLength; i++ ) {
	    var measurement = measurements[i];
	    var value = style[ measurement ];
	    var num = parseFloat( value );
	    // any 'auto', 'medium' value will be 0
	    size[ measurement ] = !isNaN( num ) ? num : 0;
	  }
	
	  var paddingWidth = size.paddingLeft + size.paddingRight;
	  var paddingHeight = size.paddingTop + size.paddingBottom;
	  var marginWidth = size.marginLeft + size.marginRight;
	  var marginHeight = size.marginTop + size.marginBottom;
	  var borderWidth = size.borderLeftWidth + size.borderRightWidth;
	  var borderHeight = size.borderTopWidth + size.borderBottomWidth;
	
	  var isBorderBoxSizeOuter = isBorderBox && isBoxSizeOuter;
	
	  // overwrite width and height if we can get it from style
	  var styleWidth = getStyleSize( style.width );
	  if ( styleWidth !== false ) {
	    size.width = styleWidth +
	      // add padding and border unless it's already including it
	      ( isBorderBoxSizeOuter ? 0 : paddingWidth + borderWidth );
	  }
	
	  var styleHeight = getStyleSize( style.height );
	  if ( styleHeight !== false ) {
	    size.height = styleHeight +
	      // add padding and border unless it's already including it
	      ( isBorderBoxSizeOuter ? 0 : paddingHeight + borderHeight );
	  }
	
	  size.innerWidth = size.width - ( paddingWidth + borderWidth );
	  size.innerHeight = size.height - ( paddingHeight + borderHeight );
	
	  size.outerWidth = size.width + marginWidth;
	  size.outerHeight = size.height + marginHeight;
	
	  return size;
	}
	
	return getSize;
	
	});


/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(24);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(34);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(89);
	
	var _PathUtils = __webpack_require__(58);
	
	var _createTransitionManager = __webpack_require__(127);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _DOMUtils = __webpack_require__(194);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PopStateEvent = 'popstate';
	var HashChangeEvent = 'hashchange';
	
	var getHistoryState = function getHistoryState() {
	  try {
	    return window.history.state || {};
	  } catch (e) {
	    // IE 11 sometimes throws when accessing window.history.state
	    // See https://github.com/ReactTraining/history/pull/289
	    return {};
	  }
	};
	
	/**
	 * Creates a history object that uses the HTML5 history API including
	 * pushState, replaceState, and the popstate event.
	 */
	var createBrowserHistory = function createBrowserHistory() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Browser history needs a DOM');
	
	  var globalHistory = window.history;
	  var canUseHistory = (0, _DOMUtils.supportsHistory)();
	  var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();
	
	  var _props$forceRefresh = props.forceRefresh,
	      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
	      _props$getUserConfirm = props.getUserConfirmation,
	      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
	      _props$keyLength = props.keyLength,
	      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;
	
	  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';
	
	  var getDOMLocation = function getDOMLocation(historyState) {
	    var _ref = historyState || {},
	        key = _ref.key,
	        state = _ref.state;
	
	    var _window$location = window.location,
	        pathname = _window$location.pathname,
	        search = _window$location.search,
	        hash = _window$location.hash;
	
	
	    var path = pathname + search + hash;
	
	    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');
	
	    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);
	
	    return (0, _LocationUtils.createLocation)(path, state, key);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength);
	  };
	
	  var transitionManager = (0, _createTransitionManager2.default)();
	
	  var setState = function setState(nextState) {
	    _extends(history, nextState);
	
	    history.length = globalHistory.length;
	
	    transitionManager.notifyListeners(history.location, history.action);
	  };
	
	  var handlePopState = function handlePopState(event) {
	    // Ignore extraneous popstate events in WebKit.
	    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;
	
	    handlePop(getDOMLocation(event.state));
	  };
	
	  var handleHashChange = function handleHashChange() {
	    handlePop(getDOMLocation(getHistoryState()));
	  };
	
	  var forceNextPop = false;
	
	  var handlePop = function handlePop(location) {
	    if (forceNextPop) {
	      forceNextPop = false;
	      setState();
	    } else {
	      var action = 'POP';
	
	      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	        if (ok) {
	          setState({ action: action, location: location });
	        } else {
	          revertPop(location);
	        }
	      });
	    }
	  };
	
	  var revertPop = function revertPop(fromLocation) {
	    var toLocation = history.location;
	
	    // TODO: We could probably make this more reliable by
	    // keeping a list of keys we've seen in sessionStorage.
	    // Instead, we just default to 0 for keys we don't know.
	
	    var toIndex = allKeys.indexOf(toLocation.key);
	
	    if (toIndex === -1) toIndex = 0;
	
	    var fromIndex = allKeys.indexOf(fromLocation.key);
	
	    if (fromIndex === -1) fromIndex = 0;
	
	    var delta = toIndex - fromIndex;
	
	    if (delta) {
	      forceNextPop = true;
	      go(delta);
	    }
	  };
	
	  var initialLocation = getDOMLocation(getHistoryState());
	  var allKeys = [initialLocation.key];
	
	  // Public interface
	
	  var createHref = function createHref(location) {
	    return basename + (0, _PathUtils.createPath)(location);
	  };
	
	  var push = function push(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'PUSH';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var href = createHref(location);
	      var key = location.key,
	          state = location.state;
	
	
	      if (canUseHistory) {
	        globalHistory.pushState({ key: key, state: state }, null, href);
	
	        if (forceRefresh) {
	          window.location.href = href;
	        } else {
	          var prevIndex = allKeys.indexOf(history.location.key);
	          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
	
	          nextKeys.push(location.key);
	          allKeys = nextKeys;
	
	          setState({ action: action, location: location });
	        }
	      } else {
	        (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');
	
	        window.location.href = href;
	      }
	    });
	  };
	
	  var replace = function replace(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'REPLACE';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var href = createHref(location);
	      var key = location.key,
	          state = location.state;
	
	
	      if (canUseHistory) {
	        globalHistory.replaceState({ key: key, state: state }, null, href);
	
	        if (forceRefresh) {
	          window.location.replace(href);
	        } else {
	          var prevIndex = allKeys.indexOf(history.location.key);
	
	          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
	
	          setState({ action: action, location: location });
	        }
	      } else {
	        (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');
	
	        window.location.replace(href);
	      }
	    });
	  };
	
	  var go = function go(n) {
	    globalHistory.go(n);
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var listenerCount = 0;
	
	  var checkDOMListeners = function checkDOMListeners(delta) {
	    listenerCount += delta;
	
	    if (listenerCount === 1) {
	      (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);
	
	      if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	    } else if (listenerCount === 0) {
	      (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);
	
	      if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	    }
	  };
	
	  var isBlocked = false;
	
	  var block = function block() {
	    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    var unblock = transitionManager.setPrompt(prompt);
	
	    if (!isBlocked) {
	      checkDOMListeners(1);
	      isBlocked = true;
	    }
	
	    return function () {
	      if (isBlocked) {
	        isBlocked = false;
	        checkDOMListeners(-1);
	      }
	
	      return unblock();
	    };
	  };
	
	  var listen = function listen(listener) {
	    var unlisten = transitionManager.appendListener(listener);
	    checkDOMListeners(1);
	
	    return function () {
	      checkDOMListeners(-1);
	      unlisten();
	    };
	  };
	
	  var history = {
	    length: globalHistory.length,
	    action: 'POP',
	    location: initialLocation,
	    createHref: createHref,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    block: block,
	    listen: listen
	  };
	
	  return history;
	};
	
	exports.default = createBrowserHistory;

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(24);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createTransitionManager = function createTransitionManager() {
	  var prompt = null;
	
	  var setPrompt = function setPrompt(nextPrompt) {
	    (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time');
	
	    prompt = nextPrompt;
	
	    return function () {
	      if (prompt === nextPrompt) prompt = null;
	    };
	  };
	
	  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
	    // TODO: If another transition starts while we're still confirming
	    // the previous one, we may end up in a weird state. Figure out the
	    // best way to handle this.
	    if (prompt != null) {
	      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
	
	      if (typeof result === 'string') {
	        if (typeof getUserConfirmation === 'function') {
	          getUserConfirmation(result, callback);
	        } else {
	          (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');
	
	          callback(true);
	        }
	      } else {
	        // Return false from a transition hook to cancel the transition.
	        callback(result !== false);
	      }
	    } else {
	      callback(true);
	    }
	  };
	
	  var listeners = [];
	
	  var appendListener = function appendListener(fn) {
	    var isActive = true;
	
	    var listener = function listener() {
	      if (isActive) fn.apply(undefined, arguments);
	    };
	
	    listeners.push(listener);
	
	    return function () {
	      isActive = false;
	      listeners = listeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var notifyListeners = function notifyListeners() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    listeners.forEach(function (listener) {
	      return listener.apply(undefined, args);
	    });
	  };
	
	  return {
	    setPrompt: setPrompt,
	    confirmTransitionTo: confirmTransitionTo,
	    appendListener: appendListener,
	    notifyListeners: notifyListeners
	  };
	};
	
	exports.default = createTransitionManager;

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(504),
	    getPrototype = __webpack_require__(506),
	    isObjectLike = __webpack_require__(511);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	            return factory(root);
	        }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module === "object" && module.exports) {
	        module.exports = factory(root);
	    } else {
	        root.lottie = factory(root);
	        root.bodymovin = root.lottie;
	    }
	}((window || {}), function(window) {
	    var svgNS = "http://www.w3.org/2000/svg";
	
	var locationHref = '';
	
	var subframeEnabled = true;
	var expressionsPlugin;
	var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
	var cachedColors = {};
	var bm_rounder = Math.round;
	var bm_rnd;
	var bm_pow = Math.pow;
	var bm_sqrt = Math.sqrt;
	var bm_abs = Math.abs;
	var bm_floor = Math.floor;
	var bm_max = Math.max;
	var bm_min = Math.min;
	var blitter = 10;
	
	var BMMath = {};
	(function(){
	    var propertyNames = Object.getOwnPropertyNames(Math);
	    var i, len = propertyNames.length;
	    for(i=0;i<len;i+=1){
	        BMMath[propertyNames[i]] = Math[propertyNames[i]];
	    }
	}());
	
	function ProjectInterface(){return {}};
	
	BMMath.random = Math.random;
	BMMath.abs = function(val){
	    var tOfVal = typeof val;
	    if(tOfVal === 'object' && val.length){
	        var absArr = Array.apply(null,{length:val.length});
	        var i, len = val.length;
	        for(i=0;i<len;i+=1){
	            absArr[i] = Math.abs(val[i]);
	        }
	        return absArr;
	    }
	    return Math.abs(val);
	
	}
	var defaultCurveSegments = 150;
	var degToRads = Math.PI/180;
	var roundCorner = 0.5519;
	
	function roundValues(flag){
	    if(flag){
	        bm_rnd = Math.round;
	    }else{
	        bm_rnd = function(val){
	            return val;
	        };
	    }
	}
	roundValues(false);
	
	function styleDiv(element){
	    element.style.position = 'absolute';
	    element.style.top = 0;
	    element.style.left = 0;
	    element.style.display = 'block';
	    element.style.transformOrigin = element.style.webkitTransformOrigin = '0 0';
	    element.style.backfaceVisibility  = element.style.webkitBackfaceVisibility = 'visible';
	    element.style.transformStyle = element.style.webkitTransformStyle = element.style.mozTransformStyle = "preserve-3d";
	}
	
	function styleUnselectableDiv(element){
	    element.style.userSelect = 'none';
	    element.style.MozUserSelect = 'none';
	    element.style.webkitUserSelect = 'none';
	    element.style.oUserSelect = 'none';
	
	}
	
	function BMEnterFrameEvent(n,c,t,d){
	    this.type = n;
	    this.currentTime = c;
	    this.totalTime = t;
	    this.direction = d < 0 ? -1:1;
	}
	
	function BMCompleteEvent(n,d){
	    this.type = n;
	    this.direction = d < 0 ? -1:1;
	}
	
	function BMCompleteLoopEvent(n,c,t,d){
	    this.type = n;
	    this.currentLoop = c;
	    this.totalLoops = t;
	    this.direction = d < 0 ? -1:1;
	}
	
	function BMSegmentStartEvent(n,f,t){
	    this.type = n;
	    this.firstFrame = f;
	    this.totalFrames = t;
	}
	
	function BMDestroyEvent(n,t){
	    this.type = n;
	    this.target = t;
	}
	
	function _addEventListener(eventName, callback){
	
	    if (!this._cbs[eventName]){
	        this._cbs[eventName] = [];
	    }
	    this._cbs[eventName].push(callback);
	
		return function() {
			this.removeEventListener(eventName, callback);
		}.bind(this);
	}
	
	function _removeEventListener(eventName,callback){
	
	    if (!callback){
	        this._cbs[eventName] = null;
	    }else if(this._cbs[eventName]){
	        var i = 0, len = this._cbs[eventName].length;
	        while(i<len){
	            if(this._cbs[eventName][i] === callback){
	                this._cbs[eventName].splice(i,1);
	                i -=1;
	                len -= 1;
	            }
	            i += 1;
	        }
	        if(!this._cbs[eventName].length){
	            this._cbs[eventName] = null;
	        }
	    }
	
	}
	
	function _triggerEvent(eventName, args){
	    if (this._cbs[eventName]) {
	        var len = this._cbs[eventName].length;
	        for (var i = 0; i < len; i++){
	            this._cbs[eventName][i](args);
	        }
	    }
	}
	
	function randomString(length, chars){
	    if(chars === undefined){
	        chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890';
	    }
	    var i;
	    var result = '';
	    for (i = length; i > 0; --i) result += chars[Math.round(Math.random() * (chars.length - 1))];
	    return result;
	}
	
	function HSVtoRGB(h, s, v) {
	    var r, g, b, i, f, p, q, t;
	    if (arguments.length === 1) {
	        s = h.s, v = h.v, h = h.h;
	    }
	    i = Math.floor(h * 6);
	    f = h * 6 - i;
	    p = v * (1 - s);
	    q = v * (1 - f * s);
	    t = v * (1 - (1 - f) * s);
	    switch (i % 6) {
	        case 0: r = v, g = t, b = p; break;
	        case 1: r = q, g = v, b = p; break;
	        case 2: r = p, g = v, b = t; break;
	        case 3: r = p, g = q, b = v; break;
	        case 4: r = t, g = p, b = v; break;
	        case 5: r = v, g = p, b = q; break;
	    }
	    return [ r,
	        g,
	         b ];
	}
	
	function RGBtoHSV(r, g, b) {
	    if (arguments.length === 1) {
	        g = r.g, b = r.b, r = r.r;
	    }
	    var max = Math.max(r, g, b), min = Math.min(r, g, b),
	        d = max - min,
	        h,
	        s = (max === 0 ? 0 : d / max),
	        v = max / 255;
	
	    switch (max) {
	        case min: h = 0; break;
	        case r: h = (g - b) + d * (g < b ? 6: 0); h /= 6 * d; break;
	        case g: h = (b - r) + d * 2; h /= 6 * d; break;
	        case b: h = (r - g) + d * 4; h /= 6 * d; break;
	    }
	
	    return [
	         h,
	         s,
	         v
	    ];
	}
	
	function addSaturationToRGB(color,offset){
	    var hsv = RGBtoHSV(color[0]*255,color[1]*255,color[2]*255);
	    hsv[1] += offset;
	    if (hsv[1] > 1) {
	        hsv[1] = 1;
	    }
	    else if (hsv[1] <= 0) {
	        hsv[1] = 0;
	    }
	    return HSVtoRGB(hsv[0],hsv[1],hsv[2]);
	}
	
	function addBrightnessToRGB(color,offset){
	    var hsv = RGBtoHSV(color[0]*255,color[1]*255,color[2]*255);
	    hsv[2] += offset;
	    if (hsv[2] > 1) {
	        hsv[2] = 1;
	    }
	    else if (hsv[2] < 0) {
	        hsv[2] = 0;
	    }
	    return HSVtoRGB(hsv[0],hsv[1],hsv[2]);
	}
	
	function addHueToRGB(color,offset) {
	    var hsv = RGBtoHSV(color[0]*255,color[1]*255,color[2]*255);
	    hsv[0] += offset/360;
	    if (hsv[0] > 1) {
	        hsv[0] -= 1;
	    }
	    else if (hsv[0] < 0) {
	        hsv[0] += 1;
	    }
	    return HSVtoRGB(hsv[0],hsv[1],hsv[2]);
	}
	
	var rgbToHex = (function(){
	    var colorMap = [];
	    var i;
	    var hex;
	    for(i=0;i<256;i+=1){
	        hex = i.toString(16);
	        colorMap[i] = hex.length == 1 ? '0' + hex : hex;
	    }
	
	    return function(r, g, b) {
	        if(r<0){
	            r = 0;
	        }
	        if(g<0){
	            g = 0;
	        }
	        if(b<0){
	            b = 0;
	        }
	        return '#' + colorMap[r] + colorMap[g] + colorMap[b];
	    };
	}());
	var createTypedArray = (function(){
		function createRegularArray(type, len){
			var i = 0, arr = [], value;
			switch(type) {
				case 'int16':
				case 'uint8c':
					value = 1;
					break;
				default:
					value = 1.1;
					break;
			}
			for(i = 0; i < len; i += 1) {
				arr.push(value);
			}
			return arr;
		}
		function createTypedArray(type, len){
			if(type === 'float32') {
				return new Float32Array(len);
			} else if(type === 'int16') {
				return new Int16Array(len);
			} else if(type === 'uint8c') {
				return new Uint8ClampedArray(len);
			}
		}
		if(typeof Uint8ClampedArray === 'function' && typeof Float32Array === 'function') {
			return createTypedArray
		} else {
			return createRegularArray
		}
	}())
	function createNS(type) {
		return document.createElementNS(svgNS, type);
	}
	/*!
	 Transformation Matrix v2.0
	 (c) Epistemex 2014-2015
	 www.epistemex.com
	 By Ken Fyrstenberg
	 Contributions by leeoniya.
	 License: MIT, header required.
	 */
	
	/**
	 * 2D transformation matrix object initialized with identity matrix.
	 *
	 * The matrix can synchronize a canvas context by supplying the context
	 * as an argument, or later apply current absolute transform to an
	 * existing context.
	 *
	 * All values are handled as floating point values.
	 *
	 * @param {CanvasRenderingContext2D} [context] - Optional context to sync with Matrix
	 * @prop {number} a - scale x
	 * @prop {number} b - shear y
	 * @prop {number} c - shear x
	 * @prop {number} d - scale y
	 * @prop {number} e - translate x
	 * @prop {number} f - translate y
	 * @prop {CanvasRenderingContext2D|null} [context=null] - set or get current canvas context
	 * @constructor
	 */
	
	var Matrix = (function(){
	
	    var _cos = Math.cos;
	    var _sin = Math.sin;
	    var _tan = Math.tan;
	    var _rnd = Math.round;
	
	    function reset(){
	        this.props[0] = 1;
	        this.props[1] = 0;
	        this.props[2] = 0;
	        this.props[3] = 0;
	        this.props[4] = 0;
	        this.props[5] = 1;
	        this.props[6] = 0;
	        this.props[7] = 0;
	        this.props[8] = 0;
	        this.props[9] = 0;
	        this.props[10] = 1;
	        this.props[11] = 0;
	        this.props[12] = 0;
	        this.props[13] = 0;
	        this.props[14] = 0;
	        this.props[15] = 1;
	        return this;
	    }
	
	    function rotate(angle) {
	        if(angle === 0){
	            return this;
	        }
	        var mCos = _cos(angle);
	        var mSin = _sin(angle);
	        return this._t(mCos, -mSin,  0, 0
	            , mSin,  mCos, 0, 0
	            , 0,  0,  1, 0
	            , 0, 0, 0, 1);
	    }
	
	    function rotateX(angle){
	        if(angle === 0){
	            return this;
	        }
	        var mCos = _cos(angle);
	        var mSin = _sin(angle);
	        return this._t(1, 0, 0, 0
	            , 0, mCos, -mSin, 0
	            , 0, mSin,  mCos, 0
	            , 0, 0, 0, 1);
	    }
	
	    function rotateY(angle){
	        if(angle === 0){
	            return this;
	        }
	        var mCos = _cos(angle);
	        var mSin = _sin(angle);
	        return this._t(mCos,  0,  mSin, 0
	            , 0, 1, 0, 0
	            , -mSin,  0,  mCos, 0
	            , 0, 0, 0, 1);
	    }
	
	    function rotateZ(angle){
	        if(angle === 0){
	            return this;
	        }
	        var mCos = _cos(angle);
	        var mSin = _sin(angle);
	        return this._t(mCos, -mSin,  0, 0
	            , mSin,  mCos, 0, 0
	            , 0,  0,  1, 0
	            , 0, 0, 0, 1);
	    }
	
	    function shear(sx,sy){
	        return this._t(1, sy, sx, 1, 0, 0);
	    }
	
	    function skew(ax, ay){
	        return this.shear(_tan(ax), _tan(ay));
	    }
	
	    function skewFromAxis(ax, angle){
	        var mCos = _cos(angle);
	        var mSin = _sin(angle);
	        return this._t(mCos, mSin,  0, 0
	            , -mSin,  mCos, 0, 0
	            , 0,  0,  1, 0
	            , 0, 0, 0, 1)
	            ._t(1, 0,  0, 0
	            , _tan(ax),  1, 0, 0
	            , 0,  0,  1, 0
	            , 0, 0, 0, 1)
	            ._t(mCos, -mSin,  0, 0
	            , mSin,  mCos, 0, 0
	            , 0,  0,  1, 0
	            , 0, 0, 0, 1);
	        //return this._t(mCos, mSin, -mSin, mCos, 0, 0)._t(1, 0, _tan(ax), 1, 0, 0)._t(mCos, -mSin, mSin, mCos, 0, 0);
	    }
	
	    function scale(sx, sy, sz) {
	        sz = isNaN(sz) ? 1 : sz;
	        if(sx == 1 && sy == 1 && sz == 1){
	            return this;
	        }
	        return this._t(sx, 0, 0, 0, 0, sy, 0, 0, 0, 0, sz, 0, 0, 0, 0, 1);
	    }
	
	    function setTransform(a, b, c, d, e, f, g, h, i, j, k, l, m, n, o, p) {
	        this.props[0] = a;
	        this.props[1] = b;
	        this.props[2] = c;
	        this.props[3] = d;
	        this.props[4] = e;
	        this.props[5] = f;
	        this.props[6] = g;
	        this.props[7] = h;
	        this.props[8] = i;
	        this.props[9] = j;
	        this.props[10] = k;
	        this.props[11] = l;
	        this.props[12] = m;
	        this.props[13] = n;
	        this.props[14] = o;
	        this.props[15] = p;
	        return this;
	    }
	
	    function translate(tx, ty, tz) {
	        tz = tz || 0;
	        if(tx !== 0 || ty !== 0 || tz !== 0){
	            return this._t(1,0,0,0,0,1,0,0,0,0,1,0,tx,ty,tz,1);
	        }
	        return this;
	    }
	
	    function transform(a2, b2, c2, d2, e2, f2, g2, h2, i2, j2, k2, l2, m2, n2, o2, p2) {
	
	        if(a2 === 1 && b2 === 0 && c2 === 0 && d2 === 0 && e2 === 0 && f2 === 1 && g2 === 0 && h2 === 0 && i2 === 0 && j2 === 0 && k2 === 1 && l2 === 0){
	            if(m2 !== 0 || n2 !== 0 || o2 !== 0){
	
	                this.props[12] = this.props[12] * a2 + this.props[13] * e2 + this.props[14] * i2 + this.props[15] * m2 ;
	                this.props[13] = this.props[12] * b2 + this.props[13] * f2 + this.props[14] * j2 + this.props[15] * n2 ;
	                this.props[14] = this.props[12] * c2 + this.props[13] * g2 + this.props[14] * k2 + this.props[15] * o2 ;
	                this.props[15] = this.props[12] * d2 + this.props[13] * h2 + this.props[14] * l2 + this.props[15] * p2 ;
	            }
	            this._identityCalculated = false;
	            return this;
	        }
	
	        var a1 = this.props[0];
	        var b1 = this.props[1];
	        var c1 = this.props[2];
	        var d1 = this.props[3];
	        var e1 = this.props[4];
	        var f1 = this.props[5];
	        var g1 = this.props[6];
	        var h1 = this.props[7];
	        var i1 = this.props[8];
	        var j1 = this.props[9];
	        var k1 = this.props[10];
	        var l1 = this.props[11];
	        var m1 = this.props[12];
	        var n1 = this.props[13];
	        var o1 = this.props[14];
	        var p1 = this.props[15];
	
	        /* matrix order (canvas compatible):
	         * ace
	         * bdf
	         * 001
	         */
	        this.props[0] = a1 * a2 + b1 * e2 + c1 * i2 + d1 * m2;
	        this.props[1] = a1 * b2 + b1 * f2 + c1 * j2 + d1 * n2 ;
	        this.props[2] = a1 * c2 + b1 * g2 + c1 * k2 + d1 * o2 ;
	        this.props[3] = a1 * d2 + b1 * h2 + c1 * l2 + d1 * p2 ;
	
	        this.props[4] = e1 * a2 + f1 * e2 + g1 * i2 + h1 * m2 ;
	        this.props[5] = e1 * b2 + f1 * f2 + g1 * j2 + h1 * n2 ;
	        this.props[6] = e1 * c2 + f1 * g2 + g1 * k2 + h1 * o2 ;
	        this.props[7] = e1 * d2 + f1 * h2 + g1 * l2 + h1 * p2 ;
	
	        this.props[8] = i1 * a2 + j1 * e2 + k1 * i2 + l1 * m2 ;
	        this.props[9] = i1 * b2 + j1 * f2 + k1 * j2 + l1 * n2 ;
	        this.props[10] = i1 * c2 + j1 * g2 + k1 * k2 + l1 * o2 ;
	        this.props[11] = i1 * d2 + j1 * h2 + k1 * l2 + l1 * p2 ;
	
	        this.props[12] = m1 * a2 + n1 * e2 + o1 * i2 + p1 * m2 ;
	        this.props[13] = m1 * b2 + n1 * f2 + o1 * j2 + p1 * n2 ;
	        this.props[14] = m1 * c2 + n1 * g2 + o1 * k2 + p1 * o2 ;
	        this.props[15] = m1 * d2 + n1 * h2 + o1 * l2 + p1 * p2 ;
	
	        this._identityCalculated = false;
	        return this;
	    }
	
	    function isIdentity() {
	        if(!this._identityCalculated){
	            this._identity = !(this.props[0] !== 1 || this.props[1] !== 0 || this.props[2] !== 0 || this.props[3] !== 0
	                || this.props[4] !== 0 || this.props[5] !== 1 || this.props[6] !== 0 || this.props[7] !== 0
	                || this.props[8] !== 0 || this.props[9] !== 0 || this.props[10] !== 1 || this.props[11] !== 0
	                || this.props[12] !== 0 || this.props[13] !== 0 || this.props[14] !== 0 || this.props[15] !== 1);
	            this._identityCalculated = true;
	        }
	        return this._identity;
	    }
	
	    function clone(matr){
	        var i;
	        for(i=0;i<16;i+=1){
	            matr.props[i] = this.props[i];
	        }
	    }
	
	    function cloneFromProps(props){
	        var i;
	        for(i=0;i<16;i+=1){
	            this.props[i] = props[i];
	        }
	    }
	
	    function applyToPoint(x, y, z) {
	
	        return {
	            x: x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12],
	            y: x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13],
	            z: x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14]
	        };
	        /*return {
	         x: x * me.a + y * me.c + me.e,
	         y: x * me.b + y * me.d + me.f
	         };*/
	    }
	    function applyToX(x, y, z) {
	        return x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12];
	    }
	    function applyToY(x, y, z) {
	        return x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13];
	    }
	    function applyToZ(x, y, z) {
	        return x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14];
	    }
	
	    function inversePoint(pt) {
	        var determinant = this.props[0] * this.props[5] - this.props[1] * this.props[4];
	        var a = this.props[5]/determinant;
	        var b = - this.props[1]/determinant;
	        var c = - this.props[4]/determinant;
	        var d = this.props[0]/determinant;
	        var e = (this.props[4] * this.props[13] - this.props[5] * this.props[12])/determinant;
	        var f = - (this.props[0] * this.props[13] - this.props[1] * this.props[12])/determinant;
	        return [pt[0] * a + pt[1] * c + e, pt[0] * b + pt[1] * d + f, 0];
	    }
	
	    function inversePoints(pts){
	        var i, len = pts.length, retPts = [];
	        for(i=0;i<len;i+=1){
	            retPts[i] = inversePoint(pts[i]);
	        }
	        return retPts;
	    }
	
	    function applyToPointArray(x,y,z,dimensions){
	        if(dimensions && dimensions === 2) {
	            var arr = point_pool.newPoint();
	            arr[0] = x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12]; 
	            arr[1] = x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13]; 
	            return arr;    
	        }
	        return [x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12],x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13],x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14]];
	    }
	    function applyToPointStringified(x, y) {
	        if(this.isIdentity()) {
	            return x + ',' + y;
	        }
	        return (bm_rnd(x * this.props[0] + y * this.props[4] + this.props[12]))+','+(bm_rnd(x * this.props[1] + y * this.props[5] + this.props[13]));
	    }
	
	    function toCSS() {
	        //Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.
	        /*if(this.isIdentity()) {
	            return '';
	        }*/
	        var i = 0;
	        var props = this.props;
	        var cssValue = 'matrix3d(';
	        var v = 10000;
	        while(i<16){
	            cssValue += _rnd(props[i]*v)/v
	            cssValue += i === 15 ? ')':',';
	            i += 1;
	        }
	        return cssValue;
	    }
	
	    function to2dCSS() {
	        //Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.
	        /*if(this.isIdentity()) {
	            console.log(new Error().stack)
	            return '';
	        }*/
	        var v = 10000;
	        var props = this.props;
	        return "matrix(" + _rnd(props[0]*v)/v + ',' + _rnd(props[1]*v)/v + ',' + _rnd(props[4]*v)/v + ',' + _rnd(props[5]*v)/v + ',' + _rnd(props[12]*v)/v + ',' + _rnd(props[13]*v)/v + ")";
	    }
	
	    return function(){
	        this.reset = reset;
	        this.rotate = rotate;
	        this.rotateX = rotateX;
	        this.rotateY = rotateY;
	        this.rotateZ = rotateZ;
	        this.skew = skew;
	        this.skewFromAxis = skewFromAxis;
	        this.shear = shear;
	        this.scale = scale;
	        this.setTransform = setTransform;
	        this.translate = translate;
	        this.transform = transform;
	        this.applyToPoint = applyToPoint;
	        this.applyToX = applyToX;
	        this.applyToY = applyToY;
	        this.applyToZ = applyToZ;
	        this.applyToPointArray = applyToPointArray;
	        this.applyToPointStringified = applyToPointStringified;
	        this.toCSS = toCSS;
	        this.to2dCSS = to2dCSS;
	        this.clone = clone;
	        this.cloneFromProps = cloneFromProps;
	        this.inversePoints = inversePoints;
	        this.inversePoint = inversePoint;
	        this._t = this.transform;
	        this.isIdentity = isIdentity;
	        this._identity = true;
	        this._identityCalculated = false;
	
	        this.props = createTypedArray('float32', 16);
	        this.reset();
	    }
	}());
	
	/*
	 Copyright 2014 David Bau.
	
	 Permission is hereby granted, free of charge, to any person obtaining
	 a copy of this software and associated documentation files (the
	 "Software"), to deal in the Software without restriction, including
	 without limitation the rights to use, copy, modify, merge, publish,
	 distribute, sublicense, and/or sell copies of the Software, and to
	 permit persons to whom the Software is furnished to do so, subject to
	 the following conditions:
	
	 The above copyright notice and this permission notice shall be
	 included in all copies or substantial portions of the Software.
	
	 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	 EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	 */
	
	(function (pool, math) {
	//
	// The following constants are related to IEEE 754 limits.
	//
	    var global = this,
	        width = 256,        // each RC4 output is 0 <= x < 256
	        chunks = 6,         // at least six RC4 outputs for each double
	        digits = 52,        // there are 52 significant digits in a double
	        rngname = 'random', // rngname: name for Math.random and Math.seedrandom
	        startdenom = math.pow(width, chunks),
	        significance = math.pow(2, digits),
	        overflow = significance * 2,
	        mask = width - 1,
	        nodecrypto;         // node.js crypto module, initialized at the bottom.
	
	//
	// seedrandom()
	// This is the seedrandom function described above.
	//
	    function seedrandom(seed, options, callback) {
	        var key = [];
	        options = (options == true) ? { entropy: true } : (options || {});
	
	        // Flatten the seed string or build one from local entropy if needed.
	        var shortseed = mixkey(flatten(
	            options.entropy ? [seed, tostring(pool)] :
	                (seed == null) ? autoseed() : seed, 3), key);
	
	        // Use the seed to initialize an ARC4 generator.
	        var arc4 = new ARC4(key);
	
	        // This function returns a random double in [0, 1) that contains
	        // randomness in every bit of the mantissa of the IEEE 754 value.
	        var prng = function() {
	            var n = arc4.g(chunks),             // Start with a numerator n < 2 ^ 48
	                d = startdenom,                 //   and denominator d = 2 ^ 48.
	                x = 0;                          //   and no 'extra last byte'.
	            while (n < significance) {          // Fill up all significant digits by
	                n = (n + x) * width;              //   shifting numerator and
	                d *= width;                       //   denominator and generating a
	                x = arc4.g(1);                    //   new least-significant-byte.
	            }
	            while (n >= overflow) {             // To avoid rounding up, before adding
	                n /= 2;                           //   last byte, shift everything
	                d /= 2;                           //   right using integer math until
	                x >>>= 1;                         //   we have exactly the desired bits.
	            }
	            return (n + x) / d;                 // Form the number within [0, 1).
	        };
	
	        prng.int32 = function() { return arc4.g(4) | 0; }
	        prng.quick = function() { return arc4.g(4) / 0x100000000; }
	        prng.double = prng;
	
	        // Mix the randomness into accumulated entropy.
	        mixkey(tostring(arc4.S), pool);
	
	        // Calling convention: what to return as a function of prng, seed, is_math.
	        return (options.pass || callback ||
	        function(prng, seed, is_math_call, state) {
	            if (state) {
	                // Load the arc4 state from the given state if it has an S array.
	                if (state.S) { copy(state, arc4); }
	                // Only provide the .state method if requested via options.state.
	                prng.state = function() { return copy(arc4, {}); }
	            }
	
	            // If called as a method of Math (Math.seedrandom()), mutate
	            // Math.random because that is how seedrandom.js has worked since v1.0.
	            if (is_math_call) { math[rngname] = prng; return seed; }
	
	            // Otherwise, it is a newer calling convention, so return the
	            // prng directly.
	            else return prng;
	        })(
	            prng,
	            shortseed,
	            'global' in options ? options.global : (this == math),
	            options.state);
	    }
	    math['seed' + rngname] = seedrandom;
	
	//
	// ARC4
	//
	// An ARC4 implementation.  The constructor takes a key in the form of
	// an array of at most (width) integers that should be 0 <= x < (width).
	//
	// The g(count) method returns a pseudorandom integer that concatenates
	// the next (count) outputs from ARC4.  Its return value is a number x
	// that is in the range 0 <= x < (width ^ count).
	//
	    function ARC4(key) {
	        var t, keylen = key.length,
	            me = this, i = 0, j = me.i = me.j = 0, s = me.S = [];
	
	        // The empty key [] is treated as [0].
	        if (!keylen) { key = [keylen++]; }
	
	        // Set up S using the standard key scheduling algorithm.
	        while (i < width) {
	            s[i] = i++;
	        }
	        for (i = 0; i < width; i++) {
	            s[i] = s[j = mask & (j + key[i % keylen] + (t = s[i]))];
	            s[j] = t;
	        }
	
	        // The "g" method returns the next (count) outputs as one number.
	        (me.g = function(count) {
	            // Using instance members instead of closure state nearly doubles speed.
	            var t, r = 0,
	                i = me.i, j = me.j, s = me.S;
	            while (count--) {
	                t = s[i = mask & (i + 1)];
	                r = r * width + s[mask & ((s[i] = s[j = mask & (j + t)]) + (s[j] = t))];
	            }
	            me.i = i; me.j = j;
	            return r;
	            // For robust unpredictability, the function call below automatically
	            // discards an initial batch of values.  This is called RC4-drop[256].
	            // See http://google.com/search?q=rsa+fluhrer+response&btnI
	        })(width);
	    }
	
	//
	// copy()
	// Copies internal state of ARC4 to or from a plain object.
	//
	    function copy(f, t) {
	        t.i = f.i;
	        t.j = f.j;
	        t.S = f.S.slice();
	        return t;
	    };
	
	//
	// flatten()
	// Converts an object tree to nested arrays of strings.
	//
	    function flatten(obj, depth) {
	        var result = [], typ = (typeof obj), prop;
	        if (depth && typ == 'object') {
	            for (prop in obj) {
	                try { result.push(flatten(obj[prop], depth - 1)); } catch (e) {}
	            }
	        }
	        return (result.length ? result : typ == 'string' ? obj : obj + '\0');
	    }
	
	//
	// mixkey()
	// Mixes a string seed into a key that is an array of integers, and
	// returns a shortened string seed that is equivalent to the result key.
	//
	    function mixkey(seed, key) {
	        var stringseed = seed + '', smear, j = 0;
	        while (j < stringseed.length) {
	            key[mask & j] =
	                mask & ((smear ^= key[mask & j] * 19) + stringseed.charCodeAt(j++));
	        }
	        return tostring(key);
	    }
	
	//
	// autoseed()
	// Returns an object for autoseeding, using window.crypto and Node crypto
	// module if available.
	//
	    function autoseed() {
	        try {
	            if (nodecrypto) { return tostring(nodecrypto.randomBytes(width)); }
	            var out = new Uint8Array(width);
	            (global.crypto || global.msCrypto).getRandomValues(out);
	            return tostring(out);
	        } catch (e) {
	            var browser = global.navigator,
	                plugins = browser && browser.plugins;
	            return [+new Date, global, plugins, global.screen, tostring(pool)];
	        }
	    }
	
	//
	// tostring()
	// Converts an array of charcodes to a string
	//
	    function tostring(a) {
	        return String.fromCharCode.apply(0, a);
	    }
	
	//
	// When seedrandom.js is loaded, we immediately mix a few bits
	// from the built-in RNG into the entropy pool.  Because we do
	// not want to interfere with deterministic PRNG state later,
	// seedrandom will not call math.random on its own again after
	// initialization.
	//
	    mixkey(math.random(), pool);
	
	//
	// Nodejs and AMD support: export the implementation as a module using
	// either convention.
	//
	
	// End anonymous scope, and pass initial values.
	})(
	    [],     // pool: entropy pool starts empty
	    BMMath    // math: package containing random, pow, and seedrandom
	);
	var BezierFactory = (function(){
	    /**
	     * BezierEasing - use bezier curve for transition easing function
	     * by Gaëtan Renaudeau 2014 - 2015 – MIT License
	     *
	     * Credits: is based on Firefox's nsSMILKeySpline.cpp
	     * Usage:
	     * var spline = BezierEasing([ 0.25, 0.1, 0.25, 1.0 ])
	     * spline.get(x) => returns the easing value | x must be in [0, 1] range
	     *
	     */
	
	        var ob = {};
	    ob.getBezierEasing = getBezierEasing;
	    var beziers = {};
	
	    function getBezierEasing(a,b,c,d,nm){
	        var str = nm || ('bez_' + a+'_'+b+'_'+c+'_'+d).replace(/\./g, 'p');
	        if(beziers[str]){
	            return beziers[str];
	        }
	        var bezEasing = new BezierEasing([a,b,c,d]);
	        beziers[str] = bezEasing;
	        return bezEasing;
	    }
	
	// These values are established by empiricism with tests (tradeoff: performance VS precision)
	    var NEWTON_ITERATIONS = 4;
	    var NEWTON_MIN_SLOPE = 0.001;
	    var SUBDIVISION_PRECISION = 0.0000001;
	    var SUBDIVISION_MAX_ITERATIONS = 10;
	
	    var kSplineTableSize = 11;
	    var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);
	
	    var float32ArraySupported = typeof Float32Array === "function";
	
	    function A (aA1, aA2) { return 1.0 - 3.0 * aA2 + 3.0 * aA1; }
	    function B (aA1, aA2) { return 3.0 * aA2 - 6.0 * aA1; }
	    function C (aA1)      { return 3.0 * aA1; }
	
	// Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
	    function calcBezier (aT, aA1, aA2) {
	        return ((A(aA1, aA2)*aT + B(aA1, aA2))*aT + C(aA1))*aT;
	    }
	
	// Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
	    function getSlope (aT, aA1, aA2) {
	        return 3.0 * A(aA1, aA2)*aT*aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
	    }
	
	    function binarySubdivide (aX, aA, aB, mX1, mX2) {
	        var currentX, currentT, i = 0;
	        do {
	            currentT = aA + (aB - aA) / 2.0;
	            currentX = calcBezier(currentT, mX1, mX2) - aX;
	            if (currentX > 0.0) {
	                aB = currentT;
	            } else {
	                aA = currentT;
	            }
	        } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
	        return currentT;
	    }
	
	    function newtonRaphsonIterate (aX, aGuessT, mX1, mX2) {
	        for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
	            var currentSlope = getSlope(aGuessT, mX1, mX2);
	            if (currentSlope === 0.0) return aGuessT;
	            var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
	            aGuessT -= currentX / currentSlope;
	        }
	        return aGuessT;
	    }
	
	    /**
	     * points is an array of [ mX1, mY1, mX2, mY2 ]
	     */
	    function BezierEasing (points) {
	        this._p = points;
	        this._mSampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
	        this._precomputed = false;
	
	        this.get = this.get.bind(this);
	    }
	
	    BezierEasing.prototype = {
	
	        get: function (x) {
	            var mX1 = this._p[0],
	                mY1 = this._p[1],
	                mX2 = this._p[2],
	                mY2 = this._p[3];
	            if (!this._precomputed) this._precompute();
	            if (mX1 === mY1 && mX2 === mY2) return x; // linear
	            // Because JavaScript number are imprecise, we should guarantee the extremes are right.
	            if (x === 0) return 0;
	            if (x === 1) return 1;
	            return calcBezier(this._getTForX(x), mY1, mY2);
	        },
	
	        // Private part
	
	        _precompute: function () {
	            var mX1 = this._p[0],
	                mY1 = this._p[1],
	                mX2 = this._p[2],
	                mY2 = this._p[3];
	            this._precomputed = true;
	            if (mX1 !== mY1 || mX2 !== mY2)
	                this._calcSampleValues();
	        },
	
	        _calcSampleValues: function () {
	            var mX1 = this._p[0],
	                mX2 = this._p[2];
	            for (var i = 0; i < kSplineTableSize; ++i) {
	                this._mSampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
	            }
	        },
	
	        /**
	         * getTForX chose the fastest heuristic to determine the percentage value precisely from a given X projection.
	         */
	        _getTForX: function (aX) {
	            var mX1 = this._p[0],
	                mX2 = this._p[2],
	                mSampleValues = this._mSampleValues;
	
	            var intervalStart = 0.0;
	            var currentSample = 1;
	            var lastSample = kSplineTableSize - 1;
	
	            for (; currentSample !== lastSample && mSampleValues[currentSample] <= aX; ++currentSample) {
	                intervalStart += kSampleStepSize;
	            }
	            --currentSample;
	
	            // Interpolate to provide an initial guess for t
	            var dist = (aX - mSampleValues[currentSample]) / (mSampleValues[currentSample+1] - mSampleValues[currentSample]);
	            var guessForT = intervalStart + dist * kSampleStepSize;
	
	            var initialSlope = getSlope(guessForT, mX1, mX2);
	            if (initialSlope >= NEWTON_MIN_SLOPE) {
	                return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
	            } else if (initialSlope === 0.0) {
	                return guessForT;
	            } else {
	                return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
	            }
	        }
	    };
	
	    return ob;
	
	}());
	(function () {
	    var lastTime = 0;
	    var vendors = ['ms', 'moz', 'webkit', 'o'];
	    for(var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
	        window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
	        window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
	    }
	    if(!window.requestAnimationFrame)
	        window.requestAnimationFrame = function (callback, element) {
	            var currTime = new Date().getTime();
	            var timeToCall = Math.max(0, 16 - (currTime - lastTime));
	            var id = setTimeout(function () {
	                    callback(currTime + timeToCall);
	                },
	                timeToCall);
	            lastTime = currTime + timeToCall;
	            return id;
	        };
	    if(!window.cancelAnimationFrame)
	        window.cancelAnimationFrame = function (id) {
	            clearTimeout(id);
	        };
	}());
	
	function createElement(parent,child,params){
	    if(child){
	        child.prototype = Object.create(parent.prototype);
	        child.prototype.constructor = child;
	        child.prototype._parent = parent.prototype;
	    }else{
	        var instance = Object.create(parent.prototype,params);
	        var getType = {};
	        if(instance && getType.toString.call(instance.init) === '[object Function]'){
	            instance.init();
	        }
	        return instance;
	    }
	}
	
	function extendPrototype(source,destination){
	    for (var attr in source.prototype) {
	        if (source.prototype.hasOwnProperty(attr)) destination.prototype[attr] = source.prototype[attr];
	    }
	}
	
	function getDescriptor(object, prop) {
	    return Object.getOwnPropertyDescriptor(object, prop);
	}
	function bezFunction(){
	
	    var easingFunctions = [];
	    var math = Math;
	
	    function pointOnLine2D(x1,y1, x2,y2, x3,y3){
	        var det1 = (x1*y2) + (y1*x3) + (x2*y3) - (x3*y2) - (y3*x1) - (x2*y1);
	        return det1 > -0.0001 && det1 < 0.0001;
	    }
	
	    function pointOnLine3D(x1,y1,z1, x2,y2,z2, x3,y3,z3){
	        if(z1 === 0 && z2 === 0 && z3 === 0) {
	            return pointOnLine2D(x1,y1, x2,y2, x3,y3);
	        }
	        var dist1 = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2) + Math.pow(z2 - z1, 2));
	        var dist2 = Math.sqrt(Math.pow(x3 - x1, 2) + Math.pow(y3 - y1, 2) + Math.pow(z3 - z1, 2));
	        var dist3 = Math.sqrt(Math.pow(x3 - x2, 2) + Math.pow(y3 - y2, 2) + Math.pow(z3 - z2, 2));
	        var diffDist;
	        if(dist1 > dist2){
	            if(dist1 > dist3){
	                diffDist = dist1 - dist2 - dist3;
	            } else {
	                diffDist = dist3 - dist2 - dist1;
	            }
	        } else if(dist3 > dist2){
	            diffDist = dist3 - dist2 - dist1;
	        } else {
	            diffDist = dist2 - dist1 - dist3;
	        }
	        return diffDist > -0.0001 && diffDist < 0.0001;
	    }
	
	    /*function getEasingCurve(aa,bb,cc,dd,encodedFuncName) {
	        if(!encodedFuncName){
	            encodedFuncName = ('bez_' + aa+'_'+bb+'_'+cc+'_'+dd).replace(/\./g, 'p');
	        }
	        if(easingFunctions[encodedFuncName]){
	            return easingFunctions[encodedFuncName];
	        }
	        var A0, B0, C0;
	        var A1, B1, C1;
	        easingFunctions[encodedFuncName] = function(tt) {
	            var x = tt;
	            var i = 0, z;
	            while (++i < 20) {
	                C0 = 3 * aa;
	                B0 = 3 * (cc - aa) - C0;
	                A0 = 1 - C0 - B0;
	                z = (x * (C0 + x * (B0 + x * A0))) - tt;
	                if (bm_abs(z) < 1e-3) break;
	                x -= z / (C0 + x * (2 * B0 + 3 * A0 * x));
	            }
	            C1 = 3 * bb;
	            B1 = 3 * (dd - bb) - C1;
	            A1 = 1 - C1 - B1;
	            var polyB = x * (C1 + x * (B1 + x * A1));
	            //return c * polyB + b;
	            return polyB;
	        };
	        return easingFunctions[encodedFuncName];
	    }*/
	    var getBezierLength = (function(){
	
	        function Segment(l,p){
	            this.l = l;
	            this.p = p;
	        }
	
	        return function(pt1,pt2,pt3,pt4){
	            var curveSegments = defaultCurveSegments;
	            var k;
	            var i, len;
	            var ptCoord,perc,addedLength = 0;
	            var ptDistance;
	            var point = [],lastPoint = [];
	            var lengthData = {
	                addedLength: 0,
	                segments: Array.apply(null,{length:curveSegments})
	            };
	            len = pt3.length;
	            for(k=0;k<curveSegments;k+=1){
	                perc = k/(curveSegments-1);
	                ptDistance = 0;
	                for(i=0;i<len;i+=1){
	                    ptCoord = bm_pow(1-perc,3)*pt1[i]+3*bm_pow(1-perc,2)*perc*pt3[i]+3*(1-perc)*bm_pow(perc,2)*pt4[i]+bm_pow(perc,3)*pt2[i];
	                    point[i] = ptCoord;
	                    if(lastPoint[i] !== null){
	                        ptDistance += bm_pow(point[i] - lastPoint[i],2);
	                    }
	                    lastPoint[i] = point[i];
	                }
	                if(ptDistance){
	                    ptDistance = bm_sqrt(ptDistance);
	                    addedLength += ptDistance;
	                }
	                lengthData.segments[k] = new Segment(addedLength,perc);
	            }
	            lengthData.addedLength = addedLength;
	            return lengthData;
	        };
	    }());
	
	    function getSegmentsLength(shapeData) {
	        var closed = shapeData.c;
	        var pathV = shapeData.v;
	        var pathO = shapeData.o;
	        var pathI = shapeData.i;
	        var i, len = shapeData._length;
	        var lengths = [];
	        var totalLength = 0;
	        for(i=0;i<len-1;i+=1){
	            lengths[i] = getBezierLength(pathV[i],pathV[i+1],pathO[i],pathI[i+1]);
	            totalLength += lengths[i].addedLength;
	        }
	        if(closed){
	            lengths[i] = getBezierLength(pathV[i],pathV[0],pathO[i],pathI[0]);
	            totalLength += lengths[i].addedLength;
	        }
	        return {lengths:lengths,totalLength:totalLength};
	    }
	
	    function BezierData(length){
	        this.segmentLength = 0;
	        this.points = new Array(length);
	    }
	
	    function PointData(partial,point){
	        this.partialLength = partial;
	        this.point = point;
	    }
	
	    var buildBezierData = (function(){
	
	        var storedData = {};
	
	        return function (keyData){
	            var pt1 = keyData.s;
	            var pt2 = keyData.e;
	            var pt3 = keyData.to;
	            var pt4 = keyData.ti;
	            var bezierName = (pt1[0]+'_'+pt1[1]+'_'+pt2[0]+'_'+pt2[1]+'_'+pt3[0]+'_'+pt3[1]+'_'+pt4[0]+'_'+pt4[1]).replace(/\./g, 'p');
	            if(storedData[bezierName]){
	                keyData.bezierData = storedData[bezierName];
	                return;
	            }
	        var curveSegments = defaultCurveSegments;
	        var k, i, len;
	            var ptCoord,perc,addedLength = 0;
	            var ptDistance;
	            var point,lastPoint = null;
	            if(pt1.length === 2 && (pt1[0] != pt2[0] || pt1[1] != pt2[1]) && pointOnLine2D(pt1[0],pt1[1],pt2[0],pt2[1],pt1[0]+pt3[0],pt1[1]+pt3[1]) && pointOnLine2D(pt1[0],pt1[1],pt2[0],pt2[1],pt2[0]+pt4[0],pt2[1]+pt4[1])){
	                curveSegments = 2;
	            }
	            var bezierData = new BezierData(curveSegments);
	            len = pt3.length;
	            for(k=0;k<curveSegments;k+=1){
	            point = new Array(len);
	                perc = k/(curveSegments-1);
	                ptDistance = 0;
	                for(i=0;i<len;i+=1){
	                ptCoord = bm_pow(1-perc,3)*pt1[i]+3*bm_pow(1-perc,2)*perc*(pt1[i] + pt3[i])+3*(1-perc)*bm_pow(perc,2)*(pt2[i] + pt4[i])+bm_pow(perc,3)*pt2[i];
	                point[i] = ptCoord;
	                    if(lastPoint !== null){
	                    ptDistance += bm_pow(point[i] - lastPoint[i],2);
	                    }
	                }
	            ptDistance = bm_sqrt(ptDistance);
	                addedLength += ptDistance;
	                bezierData.points[k] = new PointData(ptDistance,point);
	                lastPoint = point;
	            }
	            bezierData.segmentLength = addedLength;
	            keyData.bezierData = bezierData;
	            storedData[bezierName] = bezierData;
	
	        }
	    }());
	
	    function getDistancePerc(perc,bezierData){
	        var segments = bezierData.segments;
	        var len = segments.length;
	        var initPos = bm_floor((len-1)*perc);
	        var lengthPos = perc*bezierData.addedLength;
	        var lPerc = 0;
	        if(lengthPos == segments[initPos].l){
	            return segments[initPos].p;
	        }else{
	            var dir = segments[initPos].l > lengthPos ? -1 : 1;
	            var flag = true;
	            while(flag){
	                if(segments[initPos].l <= lengthPos && segments[initPos+1].l > lengthPos){
	                    lPerc = (lengthPos - segments[initPos].l)/(segments[initPos+1].l-segments[initPos].l);
	                    flag = false;
	                }else{
	                    initPos += dir;
	                }
	                if(initPos < 0 || initPos >= len - 1){
	                    flag = false;
	                }
	            }
	            return segments[initPos].p + (segments[initPos+1].p - segments[initPos].p)*lPerc;
	        }
	    }
	
	    function SegmentPoints(){
	        this.pt1 = new Array(2);
	        this.pt2 = new Array(2);
	        this.pt3 = new Array(2);
	        this.pt4 = new Array(2);
	    }
	
	    function getPointInSegment(pt1, pt2, pt3, pt4, percent, bezierData) {
	        var t1 = getDistancePerc(percent,bezierData);
	        var u0 = 1;
	        var u1 = 1 - t1;
	        var ptX = Math.round((u1*u1*u1* pt1[0] + (t1*u1*u1 + u1*t1*u1 + u1*u1*t1)* pt3[0] + (t1*t1*u1 + u1*t1*t1 + t1*u1*t1)*pt4[0] + t1*t1*t1* pt2[0])* 1000) / 1000;
	        var ptY = Math.round((u1*u1*u1* pt1[1] + (t1*u1*u1 + u1*t1*u1 + u1*u1*t1)* pt3[1] + (t1*t1*u1 + u1*t1*t1 + t1*u1*t1)*pt4[1] + t1*t1*t1* pt2[1])* 1000) / 1000;
	        return [ptX, ptY];
	    }
	
	    function getNewSegment(pt1,pt2,pt3,pt4,startPerc,endPerc, bezierData){
	
	        var pts = new SegmentPoints();
	        startPerc = startPerc < 0 ? 0 : startPerc > 1 ? 1 : startPerc;
	        var t0 = getDistancePerc(startPerc,bezierData);
	        endPerc = endPerc > 1 ? 1 : endPerc;
	        var t1 = getDistancePerc(endPerc,bezierData);
	        var i, len = pt1.length;
	        var u0 = 1 - t0;
	        var u1 = 1 - t1;
	        //Math.round(num * 100) / 100
	        for(i=0;i<len;i+=1){
	            pts.pt1[i] =  Math.round((u0*u0*u0* pt1[i] + (t0*u0*u0 + u0*t0*u0 + u0*u0*t0) * pt3[i] + (t0*t0*u0 + u0*t0*t0 + t0*u0*t0)* pt4[i] + t0*t0*t0* pt2[i])* 1000) / 1000;
	            pts.pt3[i] = Math.round((u0*u0*u1*pt1[i] + (t0*u0*u1 + u0*t0*u1 + u0*u0*t1)* pt3[i] + (t0*t0*u1 + u0*t0*t1 + t0*u0*t1)* pt4[i] + t0*t0*t1* pt2[i])* 1000) / 1000;
	            pts.pt4[i] = Math.round((u0*u1*u1* pt1[i] + (t0*u1*u1 + u0*t1*u1 + u0*u1*t1)* pt3[i] + (t0*t1*u1 + u0*t1*t1 + t0*u1*t1)* pt4[i] + t0*t1*t1* pt2[i])* 1000) / 1000;
	            pts.pt2[i] = Math.round((u1*u1*u1* pt1[i] + (t1*u1*u1 + u1*t1*u1 + u1*u1*t1)* pt3[i] + (t1*t1*u1 + u1*t1*t1 + t1*u1*t1)*pt4[i] + t1*t1*t1* pt2[i])* 1000) / 1000;
	        }
	        return pts;
	    }
	
	    return {
	        //getEasingCurve : getEasingCurve,
	        getBezierLength : getBezierLength,
	        getSegmentsLength : getSegmentsLength,
	        getNewSegment : getNewSegment,
	        getPointInSegment : getPointInSegment,
	        buildBezierData : buildBezierData,
	        pointOnLine2D : pointOnLine2D,
	        pointOnLine3D : pointOnLine3D
	    };
	}
	
	var bez = bezFunction();
	function dataFunctionManager(){
	
	    //var tCanvasHelper = document.createElement('canvas').getContext('2d');
	
	    function completeLayers(layers, comps, fontManager){
	        var layerData;
	        var animArray, lastFrame;
	        var i, len = layers.length;
	        var j, jLen, k, kLen;
	        for(i=0;i<len;i+=1){
	            layerData = layers[i];
	            if(!('ks' in layerData) || layerData.completed){
	                continue;
	            }
	            layerData.completed = true;
	            if(layerData.tt){
	                layers[i-1].td = layerData.tt;
	            }
	            animArray = [];
	            lastFrame = -1;
	            if(layerData.hasMask){
	                var maskProps = layerData.masksProperties;
	                jLen = maskProps.length;
	                for(j=0;j<jLen;j+=1){
	                    if(maskProps[j].pt.k.i){
	                        convertPathsToAbsoluteValues(maskProps[j].pt.k);
	                    }else{
	                        kLen = maskProps[j].pt.k.length;
	                        for(k=0;k<kLen;k+=1){
	                            if(maskProps[j].pt.k[k].s){
	                                convertPathsToAbsoluteValues(maskProps[j].pt.k[k].s[0]);
	                            }
	                            if(maskProps[j].pt.k[k].e){
	                                convertPathsToAbsoluteValues(maskProps[j].pt.k[k].e[0]);
	                            }
	                        }
	                    }
	                }
	            }
	            if(layerData.ty===0){
	                layerData.layers = findCompLayers(layerData.refId, comps);
	                completeLayers(layerData.layers,comps, fontManager);
	            }else if(layerData.ty === 4){
	                completeShapes(layerData.shapes);
	            }else if(layerData.ty == 5){
	                completeText(layerData, fontManager);
	            }
	        }
	    }
	
	    function findCompLayers(id,comps){
	        var i = 0, len = comps.length;
	        while(i<len){
	            if(comps[i].id === id){
	                if(!comps[i].layers.__used) {
	                    comps[i].layers.__used = true;
	                    return comps[i].layers;
	                }
	                return JSON.parse(JSON.stringify(comps[i].layers));
	            }
	            i += 1;
	        }
	    }
	
	    function completeShapes(arr){
	        var i, len = arr.length;
	        var j, jLen;
	        var hasPaths = false;
	        for(i=len-1;i>=0;i-=1){
	            if(arr[i].ty == 'sh'){
	                if(arr[i].ks.k.i){
	                    convertPathsToAbsoluteValues(arr[i].ks.k);
	                }else{
	                    jLen = arr[i].ks.k.length;
	                    for(j=0;j<jLen;j+=1){
	                        if(arr[i].ks.k[j].s){
	                            convertPathsToAbsoluteValues(arr[i].ks.k[j].s[0]);
	                        }
	                        if(arr[i].ks.k[j].e){
	                            convertPathsToAbsoluteValues(arr[i].ks.k[j].e[0]);
	                        }
	                    }
	                }
	                hasPaths = true;
	            }else if(arr[i].ty == 'gr'){
	                completeShapes(arr[i].it);
	            }
	        }
	        /*if(hasPaths){
	            //mx: distance
	            //ss: sensitivity
	            //dc: decay
	            arr.splice(arr.length-1,0,{
	                "ty": "ms",
	                "mx":20,
	                "ss":10,
	                 "dc":0.001,
	                "maxDist":200
	            });
	        }*/
	    }
	
	    function convertPathsToAbsoluteValues(path){
	        var i, len = path.i.length;
	        for(i=0;i<len;i+=1){
	            path.i[i][0] += path.v[i][0];
	            path.i[i][1] += path.v[i][1];
	            path.o[i][0] += path.v[i][0];
	            path.o[i][1] += path.v[i][1];
	        }
	    }
	
	    function checkVersion(minimum,animVersionString){
	        var animVersion = animVersionString ? animVersionString.split('.') : [100,100,100];
	        if(minimum[0]>animVersion[0]){
	            return true;
	        } else if(animVersion[0] > minimum[0]){
	            return false;
	        }
	        if(minimum[1]>animVersion[1]){
	            return true;
	        } else if(animVersion[1] > minimum[1]){
	            return false;
	        }
	        if(minimum[2]>animVersion[2]){
	            return true;
	        } else if(animVersion[2] > minimum[2]){
	            return false;
	        }
	    }
	
	    var checkText = (function(){
	        var minimumVersion = [4,4,14];
	
	        function updateTextLayer(textLayer){
	            var documentData = textLayer.t.d;
	            textLayer.t.d = {
	                k: [
	                    {
	                        s:documentData,
	                        t:0
	                    }
	                ]
	            }
	        }
	
	        function iterateLayers(layers){
	            var i, len = layers.length;
	            for(i=0;i<len;i+=1){
	                if(layers[i].ty === 5){
	                    updateTextLayer(layers[i]);
	                }
	            }
	        }
	
	        return function (animationData){
	            if(checkVersion(minimumVersion,animationData.v)){
	                iterateLayers(animationData.layers);
	                if(animationData.assets){
	                    var i, len = animationData.assets.length;
	                    for(i=0;i<len;i+=1){
	                        if(animationData.assets[i].layers){
	                            iterateLayers(animationData.assets[i].layers);
	
	                        }
	                    }
	                }
	            }
	        }
	    }())
	
	    var checkChars = (function() {
	        var minimumVersion = [4,7,99];
	        return function (animationData){
	            if(animationData.chars && !checkVersion(minimumVersion,animationData.v)){
	                var i, len = animationData.chars.length, j, jLen, k, kLen;
	                var pathData, paths;
	                for(i = 0; i < len; i += 1) {
	                    if(animationData.chars[i].data && animationData.chars[i].data.shapes) {
	                        paths = animationData.chars[i].data.shapes[0].it;
	                        jLen = paths.length;
	
	                        for(j = 0; j < jLen; j += 1) {
	                            pathData = paths[j].ks.k;
	                            if(!pathData.__converted) {
	                                convertPathsToAbsoluteValues(paths[j].ks.k);
	                                pathData.__converted = true;
	                            }
	                        }
	                    }
	                }
	            }
	        }
	
	    }())
	
	    var checkColors = (function(){
	        var minimumVersion = [4,1,9];
	
	        function iterateShapes(shapes){
	            var i, len = shapes.length;
	            var j, jLen;
	            for(i=0;i<len;i+=1){
	                if(shapes[i].ty === 'gr'){
	                    iterateShapes(shapes[i].it);
	                }else if(shapes[i].ty === 'fl' || shapes[i].ty === 'st'){
	                    if(shapes[i].c.k && shapes[i].c.k[0].i){
	                        jLen = shapes[i].c.k.length;
	                        for(j=0;j<jLen;j+=1){
	                            if(shapes[i].c.k[j].s){
	                                shapes[i].c.k[j].s[0] /= 255;
	                                shapes[i].c.k[j].s[1] /= 255;
	                                shapes[i].c.k[j].s[2] /= 255;
	                                shapes[i].c.k[j].s[3] /= 255;
	                            }
	                            if(shapes[i].c.k[j].e){
	                                shapes[i].c.k[j].e[0] /= 255;
	                                shapes[i].c.k[j].e[1] /= 255;
	                                shapes[i].c.k[j].e[2] /= 255;
	                                shapes[i].c.k[j].e[3] /= 255;
	                            }
	                        }
	                    } else {
	                        shapes[i].c.k[0] /= 255;
	                        shapes[i].c.k[1] /= 255;
	                        shapes[i].c.k[2] /= 255;
	                        shapes[i].c.k[3] /= 255;
	                    }
	                }
	            }
	        }
	
	        function iterateLayers(layers){
	            var i, len = layers.length;
	            for(i=0;i<len;i+=1){
	                if(layers[i].ty === 4){
	                    iterateShapes(layers[i].shapes);
	                }
	            }
	        }
	
	        return function (animationData){
	            if(checkVersion(minimumVersion,animationData.v)){
	                iterateLayers(animationData.layers);
	                if(animationData.assets){
	                    var i, len = animationData.assets.length;
	                    for(i=0;i<len;i+=1){
	                        if(animationData.assets[i].layers){
	                            iterateLayers(animationData.assets[i].layers);
	
	                        }
	                    }
	                }
	            }
	        }
	    }());
	
	    var checkShapes = (function(){
	        var minimumVersion = [4,4,18];
	
	
	
	        function completeShapes(arr){
	            var i, len = arr.length;
	            var j, jLen;
	            var hasPaths = false;
	            for(i=len-1;i>=0;i-=1){
	                if(arr[i].ty == 'sh'){
	                    if(arr[i].ks.k.i){
	                        arr[i].ks.k.c = arr[i].closed;
	                    }else{
	                        jLen = arr[i].ks.k.length;
	                        for(j=0;j<jLen;j+=1){
	                            if(arr[i].ks.k[j].s){
	                                arr[i].ks.k[j].s[0].c = arr[i].closed;
	                            }
	                            if(arr[i].ks.k[j].e){
	                                arr[i].ks.k[j].e[0].c = arr[i].closed;
	                            }
	                        }
	                    }
	                    hasPaths = true;
	                }else if(arr[i].ty == 'gr'){
	                    completeShapes(arr[i].it);
	                }
	            }
	        }
	
	        function iterateLayers(layers){
	            var layerData;
	            var i, len = layers.length;
	            var j, jLen, k, kLen;
	            for(i=0;i<len;i+=1){
	                layerData = layers[i];
	                if(layerData.hasMask){
	                    var maskProps = layerData.masksProperties;
	                    jLen = maskProps.length;
	                    for(j=0;j<jLen;j+=1){
	                        if(maskProps[j].pt.k.i){
	                            maskProps[j].pt.k.c = maskProps[j].cl;
	                        }else{
	                            kLen = maskProps[j].pt.k.length;
	                            for(k=0;k<kLen;k+=1){
	                                if(maskProps[j].pt.k[k].s){
	                                    maskProps[j].pt.k[k].s[0].c = maskProps[j].cl;
	                                }
	                                if(maskProps[j].pt.k[k].e){
	                                    maskProps[j].pt.k[k].e[0].c = maskProps[j].cl;
	                                }
	                            }
	                        }
	                    }
	                }
	                if(layerData.ty === 4){
	                    completeShapes(layerData.shapes);
	                }
	            }
	        }
	
	        return function (animationData){
	            if(checkVersion(minimumVersion,animationData.v)){
	                iterateLayers(animationData.layers);
	                if(animationData.assets){
	                    var i, len = animationData.assets.length;
	                    for(i=0;i<len;i+=1){
	                        if(animationData.assets[i].layers){
	                            iterateLayers(animationData.assets[i].layers);
	
	                        }
	                    }
	                }
	            }
	        }
	    }());
	
	    /*function blitPaths(path){
	        var i, len = path.i.length;
	        for(i=0;i<len;i+=1){
	            path.i[i][0] /= blitter;
	            path.i[i][1] /= blitter;
	            path.o[i][0] /= blitter;
	            path.o[i][1] /= blitter;
	            path.v[i][0] /= blitter;
	            path.v[i][1] /= blitter;
	        }
	    }
	
	    function blitShapes(arr){
	        var i, len = arr.length;
	        var j, jLen;
	        var hasPaths = false;
	        for(i=len-1;i>=0;i-=1){
	            if(arr[i].ty == 'sh'){
	                if(arr[i].ks.k.i){
	                    blitPaths(arr[i].ks.k);
	                }else{
	                    jLen = arr[i].ks.k.length;
	                    for(j=0;j<jLen;j+=1){
	                        if(arr[i].ks.k[j].s){
	                            blitPaths(arr[i].ks.k[j].s[0]);
	                        }
	                        if(arr[i].ks.k[j].e){
	                            blitPaths(arr[i].ks.k[j].e[0]);
	                        }
	                    }
	                }
	                hasPaths = true;
	            }else if(arr[i].ty == 'gr'){
	                blitShapes(arr[i].it);
	            }else if(arr[i].ty == 'rc'){
	                blitProperty(arr[i].p);
	                blitProperty(arr[i].s);
	            }else if(arr[i].ty == 'st'){
	                blitProperty(arr[i].w);
	            }else if(arr[i].ty == 'tr'){
	                blitProperty(arr[i].p);
	                blitProperty(arr[i].sk);
	                blitProperty(arr[i].a);
	            }else if(arr[i].ty == 'el'){
	                blitProperty(arr[i].p);
	                blitProperty(arr[i].s);
	            }else if(arr[i].ty == 'rd'){
	                blitProperty(arr[i].r);
	            }else{
	
	                //console.log(arr[i].ty );
	            }
	        }
	    }
	
	    function blitText(data, fontManager){
	
	    }
	
	    function blitValue(val){
	        if(typeof(val) === 'number'){
	            val /= blitter;
	        } else {
	            var i = val.length-1;
	            while(i>=0){
	                val[i] /= blitter;
	                i-=1;
	            }
	        }
	        return val;
	    }
	
	    function blitProperty(data){
	        if(!data.k.length){
	            data.k = blitValue(data.k);
	        }else if(typeof(data.k[0]) === 'number'){
	            data.k = blitValue(data.k);
	        } else {
	            var i, len = data.k.length;
	            for(i=0;i<len;i+=1){
	                if(data.k[i].s){
	                    //console.log('pre S: ', data.k[i].s);
	                    data.k[i].s = blitValue(data.k[i].s);
	                    //console.log('post S: ', data.k[i].s);
	                }
	                if(data.k[i].e){
	                    //console.log('pre E: ', data.k[i].e);
	                    data.k[i].e = blitValue(data.k[i].e);
	                    //console.log('post E: ', data.k[i].e);
	                }
	            }
	        }
	    }
	
	    function blitLayers(layers,comps, fontManager){
	        var layerData;
	        var animArray, lastFrame;
	        var i, len = layers.length;
	        var j, jLen, k, kLen;
	        for(i=0;i<len;i+=1){
	            layerData = layers[i];
	            if(!('ks' in layerData)){
	                continue;
	            }
	            blitProperty(layerData.ks.a);
	            blitProperty(layerData.ks.p);
	            layerData.completed = true;
	            if(layerData.tt){
	                layers[i-1].td = layerData.tt;
	            }
	            animArray = [];
	            lastFrame = -1;
	            if(layerData.hasMask){
	                var maskProps = layerData.masksProperties;
	                jLen = maskProps.length;
	                for(j=0;j<jLen;j+=1){
	                    if(maskProps[j].pt.k.i){
	                        blitPaths(maskProps[j].pt.k);
	                    }else{
	                        kLen = maskProps[j].pt.k.length;
	                        for(k=0;k<kLen;k+=1){
	                            if(maskProps[j].pt.k[k].s){
	                                blitPaths(maskProps[j].pt.k[k].s[0]);
	                            }
	                            if(maskProps[j].pt.k[k].e){
	                                blitPaths(maskProps[j].pt.k[k].e[0]);
	                            }
	                        }
	                    }
	                }
	            }
	            if(layerData.ty===0){
	                layerData.w = Math.round(layerData.w/blitter);
	                layerData.h = Math.round(layerData.h/blitter);
	                blitLayers(layerData.layers,comps, fontManager);
	            }else if(layerData.ty === 4){
	                blitShapes(layerData.shapes);
	            }else if(layerData.ty == 5){
	                blitText(layerData, fontManager);
	            }else if(layerData.ty == 1){
	                layerData.sh /= blitter;
	                layerData.sw /= blitter;
	            } else {
	            }
	        }
	    }
	
	    function blitAnimation(animationData,comps, fontManager){
	        blitLayers(animationData.layers,comps, fontManager);
	    }*/
	
	    function completeData(animationData, fontManager){
	        if(animationData.__complete){
	            return;
	        }
	        checkColors(animationData);
	        checkText(animationData);
	        checkChars(animationData);
	        checkShapes(animationData);
	        completeLayers(animationData.layers, animationData.assets, fontManager);
	        animationData.__complete = true;
	        //blitAnimation(animationData, animationData.assets, fontManager);
	    }
	
	    function completeText(data, fontManager){
	        if(data.t.a.length === 0 && !('m' in data.t.p)){
	            data.singleShape = true;
	        }
	    }
	
	    var moduleOb = {};
	    moduleOb.completeData = completeData;
	
	    return moduleOb;
	}
	
	var dataManager = dataFunctionManager();
	var FontManager = (function(){
	
	    var maxWaitingTime = 5000;
	    var emptyChar = {
	        w: 0,
	        size:0,
	        shapes:[]
	    }
	
	    function setUpNode(font, family){
	        var parentNode = document.createElement('span');
	        parentNode.style.fontFamily    = family;
	        var node = document.createElement('span');
	        // Characters that vary significantly among different fonts
	        node.innerHTML = 'giItT1WQy@!-/#';
	        // Visible - so we can measure it - but not on the screen
	        parentNode.style.position      = 'absolute';
	        parentNode.style.left          = '-10000px';
	        parentNode.style.top           = '-10000px';
	        // Large font size makes even subtle changes obvious
	        parentNode.style.fontSize      = '300px';
	        // Reset any font properties
	        parentNode.style.fontVariant   = 'normal';
	        parentNode.style.fontStyle     = 'normal';
	        parentNode.style.fontWeight    = 'normal';
	        parentNode.style.letterSpacing = '0';
	        parentNode.appendChild(node);
	        document.body.appendChild(parentNode);
	
	        // Remember width with no applied web font
	        var width = node.offsetWidth;
	        node.style.fontFamily = font + ', '+family;
	        return {node:node, w:width, parent:parentNode};
	    }
	
	    function checkLoadedFonts() {
	        var i, len = this.fonts.length;
	        var node, w;
	        var loadedCount = len;
	        for(i=0;i<len; i+= 1){
	            if(this.fonts[i].loaded){
	                loadedCount -= 1;
	                continue;
	            }
	            if(this.fonts[i].fOrigin === 't' || this.fonts[i].origin === 2){
	                if(window.Typekit && window.Typekit.load && this.typekitLoaded === 0){
	                    this.typekitLoaded = 1;
	                    try{window.Typekit.load({
	                        async: true,
	                        active: function() {
	                            this.typekitLoaded = 2;
	                        }.bind(this)
	                    });}catch(e){}
	                }
	                if(this.typekitLoaded === 2) {
	                    this.fonts[i].loaded = true;
	                }
	            } else if(this.fonts[i].fOrigin === 'n' || this.fonts[i].origin === 0){
	                this.fonts[i].loaded = true;
	            } else{
	                node = this.fonts[i].monoCase.node;
	                w = this.fonts[i].monoCase.w;
	                if(node.offsetWidth !== w){
	                    loadedCount -= 1;
	                    this.fonts[i].loaded = true;
	                }else{
	                    node = this.fonts[i].sansCase.node;
	                    w = this.fonts[i].sansCase.w;
	                    if(node.offsetWidth !== w){
	                        loadedCount -= 1;
	                        this.fonts[i].loaded = true;
	                    }
	                }
	                if(this.fonts[i].loaded){
	                    this.fonts[i].sansCase.parent.parentNode.removeChild(this.fonts[i].sansCase.parent);
	                    this.fonts[i].monoCase.parent.parentNode.removeChild(this.fonts[i].monoCase.parent);
	                }
	            }
	        }
	
	        if(loadedCount !== 0 && Date.now() - this.initTime < maxWaitingTime){
	            setTimeout(checkLoadedFonts.bind(this),20);
	        }else{
	            setTimeout(function(){this.loaded = true;}.bind(this),0);
	
	        }
	    };
	
	    function createHelper(def, fontData){
	        var tHelper = createNS('text');
	        tHelper.style.fontSize = '100px';
	        tHelper.style.fontFamily = fontData.fFamily;
	        tHelper.textContent = '1';
	        if(fontData.fClass){
	            tHelper.style.fontFamily = 'inherit';
	            tHelper.className = fontData.fClass;
	        } else {
	            tHelper.style.fontFamily = fontData.fFamily;
	        }
	        def.appendChild(tHelper);
	        var tCanvasHelper = document.createElement('canvas').getContext('2d');
	        tCanvasHelper.font = '100px '+ fontData.fFamily;
	        return tCanvasHelper;
	    }
	
	    function addFonts(fontData, defs){
	        if(!fontData){
	            this.loaded = true;
	            return;
	        }
	        if(this.chars){
	            this.loaded = true;
	            this.fonts = fontData.list;
	            return;
	        }
	
	        var fontArr = fontData.list;
	        var i, len = fontArr.length;
	        for(i=0; i<len; i+= 1){
	            fontArr[i].loaded = false;
	            fontArr[i].monoCase = setUpNode(fontArr[i].fFamily,'monospace');
	            fontArr[i].sansCase = setUpNode(fontArr[i].fFamily,'sans-serif');
	            if(!fontArr[i].fPath) {
	                fontArr[i].loaded = true;
	            }else if(fontArr[i].fOrigin === 'p' || fontArr[i].origin === 3){
	                var s = document.createElement('style');
	                s.type = "text/css";
	                s.innerHTML = "@font-face {" + "font-family: "+fontArr[i].fFamily+"; font-style: normal; src: url('"+fontArr[i].fPath+"');}";
	                defs.appendChild(s);
	            } else if(fontArr[i].fOrigin === 'g' || fontArr[i].origin === 1){
	                //<link href='https://fonts.googleapis.com/css?family=Montserrat' rel='stylesheet' type='text/css'>
	                var l = document.createElement('link');
	                l.type = "text/css";
	                l.rel = "stylesheet";
	                l.href = fontArr[i].fPath;
	                defs.appendChild(l);
	            } else if(fontArr[i].fOrigin === 't' || fontArr[i].origin === 2){
	                //<link href='https://fonts.googleapis.com/css?family=Montserrat' rel='stylesheet' type='text/css'>
	                var sc = document.createElement('script');
	                sc.setAttribute('src',fontArr[i].fPath);
	                defs.appendChild(sc);
	            }
	            fontArr[i].helper = createHelper(defs,fontArr[i]);
	            this.fonts.push(fontArr[i]);
	        }
	        checkLoadedFonts.bind(this)();
	    }
	
	    function addChars(chars){
	        if(!chars){
	            return;
	        }
	        if(!this.chars){
	            this.chars = [];
	        }
	        var i, len = chars.length;
	        var j, jLen = this.chars.length, found;
	        for(i=0;i<len;i+=1){
	            j = 0;
	            found = false;
	            while(j<jLen){
	                if(this.chars[j].style === chars[i].style && this.chars[j].fFamily === chars[i].fFamily && this.chars[j].ch === chars[i].ch){
	                    found = true;
	                }
	                j += 1;
	            }
	            if(!found){
	                this.chars.push(chars[i]);
	                jLen += 1;
	            }
	        }
	    }
	
	    function getCharData(char, style, font){
	        var i = 0, len = this.chars.length;
	        while( i < len) {
	            if(this.chars[i].ch === char && this.chars[i].style === style && this.chars[i].fFamily === font){
	                return this.chars[i];
	            }
	            i+= 1;
	        }
	        if(console && console.warn) {
	            console.warn('Missing character from exported characters list: ', char, style, font);
	        }
	        return emptyChar;
	    }
	
	    function measureText(char, fontName, size){
	        var fontData = this.getFontByName(fontName);
	        var tHelper = fontData.helper;
	        //tHelper.textContent = char;
	        return tHelper.measureText(char).width*size/100;
	        //return tHelper.getComputedTextLength()*size/100;
	    }
	
	    function getFontByName(name){
	        var i = 0, len = this.fonts.length;
	        while(i<len){
	            if(this.fonts[i].fName === name) {
	                return this.fonts[i];
	            }
	            i += 1;
	        }
	        return 'sans-serif';
	    }
	
	    var Font = function(){
	        this.fonts = [];
	        this.chars = null;
	        this.typekitLoaded = 0;
	        this.loaded = false;
	        this.initTime = Date.now();
	    };
	    Font.prototype.addChars = addChars;
	    Font.prototype.addFonts = addFonts;
	    Font.prototype.getCharData = getCharData;
	    Font.prototype.getFontByName = getFontByName;
	    Font.prototype.measureText = measureText;
	
	    return Font;
	
	}());
	var PropertyFactory = (function(){
	
	    var initFrame = -999999;
	
	    function interpolateValue(frameNum, iterationIndex, previousValue, caching){
	        var offsetTime = this.offsetTime;
	        var newValue;
	        if(this.propType === 'multidimensional') {
	            newValue = createTypedArray('float32', previousValue.length);
	        }
	        var i = iterationIndex;
	        var len = this.keyframes.length- 1,flag = true;
	        var keyData, nextKeyData;
	
	        while(flag){
	            keyData = this.keyframes[i];
	            nextKeyData = this.keyframes[i+1];
	            if(i == len-1 && frameNum >= nextKeyData.t - offsetTime){
	                if(keyData.h){
	                    keyData = nextKeyData;
	                }
	                iterationIndex = 0;
	                break;
	            }
	            if((nextKeyData.t - offsetTime) > frameNum){
	                iterationIndex = i;
	                break;
	            }
	            if(i < len - 1){
	                i += 1;
	            }else{
	                iterationIndex = 0;
	                flag = false;
	            }
	        }
	
	        var k, kLen,perc,jLen, j, fnc;
	        if(keyData.to){
	
	            if(!keyData.bezierData){
	                bez.buildBezierData(keyData);
	            }
	            var bezierData = keyData.bezierData;
	            if(frameNum >= nextKeyData.t-offsetTime || frameNum < keyData.t-offsetTime){
	                var ind = frameNum >= nextKeyData.t-offsetTime ? bezierData.points.length - 1 : 0;
	                kLen = bezierData.points[ind].point.length;
	                for(k = 0; k < kLen; k += 1){
	                    newValue[k] = bezierData.points[ind].point[k];
	                }
	                caching._lastBezierData = null;
	            }else{
	                if(keyData.__fnct){
	                    fnc = keyData.__fnct;
	                }else{
	                    fnc = BezierFactory.getBezierEasing(keyData.o.x,keyData.o.y,keyData.i.x,keyData.i.y,keyData.n).get;
	                    keyData.__fnct = fnc;
	                }
	                perc = fnc((frameNum-(keyData.t-offsetTime))/((nextKeyData.t-offsetTime)-(keyData.t-offsetTime)));
	                var distanceInLine = bezierData.segmentLength*perc;
	
	                var segmentPerc;
	                var addedLength =  (caching.lastFrame < frameNum && caching._lastBezierData === bezierData) ? caching._lastAddedLength : 0;
	                j =  (caching.lastFrame < frameNum && caching._lastBezierData === bezierData) ? caching._lastPoint : 0;
	                flag = true;
	                jLen = bezierData.points.length;
	                while(flag){
	                    addedLength +=bezierData.points[j].partialLength;
	                    if(distanceInLine === 0 || perc === 0 || j == bezierData.points.length - 1){
	                        kLen = bezierData.points[j].point.length;
	                        for(k=0;k<kLen;k+=1){
	                            newValue[k] = bezierData.points[j].point[k];
	                        }
	                        break;
	                    }else if(distanceInLine >= addedLength && distanceInLine < addedLength + bezierData.points[j+1].partialLength){
	                        segmentPerc = (distanceInLine-addedLength)/(bezierData.points[j+1].partialLength);
	                        kLen = bezierData.points[j].point.length;
	                        for(k=0;k<kLen;k+=1){
	                            newValue[k] = bezierData.points[j].point[k] + (bezierData.points[j+1].point[k] - bezierData.points[j].point[k])*segmentPerc;
	                        }
	                        break;
	                    }
	                    if(j < jLen - 1){
	                        j += 1;
	                    }else{
	                        flag = false;
	                    }
	                }
	                caching._lastPoint = j;
	                caching._lastAddedLength = addedLength - bezierData.points[j].partialLength;
	                caching._lastBezierData = bezierData;
	            }
	        }else{
	            var outX,outY,inX,inY, keyValue;
	            len = keyData.s.length;
	            for(i=0;i<len;i+=1){
	                if(keyData.h !== 1){
	                    if(frameNum >= nextKeyData.t-offsetTime){
	                        perc = 1;
	                    }else if(frameNum < keyData.t-offsetTime){
	                        perc = 0;
	                    }else{
	                        if(keyData.o.x.constructor === Array){
	                            if(!keyData.__fnct){
	                                keyData.__fnct = [];
	                            }
	                            if (!keyData.__fnct[i]) {
	                                outX = keyData.o.x[i] || keyData.o.x[0];
	                                outY = keyData.o.y[i] || keyData.o.y[0];
	                                inX = keyData.i.x[i] || keyData.i.x[0];
	                                inY = keyData.i.y[i] || keyData.i.y[0];
	                                fnc = BezierFactory.getBezierEasing(outX,outY,inX,inY).get;
	                                keyData.__fnct[i] = fnc;
	                            } else {
	                                fnc = keyData.__fnct[i];
	                            }
	                        } else {
	                            if (!keyData.__fnct) {
	                                outX = keyData.o.x;
	                                outY = keyData.o.y;
	                                inX = keyData.i.x;
	                                inY = keyData.i.y;
	                                fnc = BezierFactory.getBezierEasing(outX,outY,inX,inY).get;
	                                keyData.__fnct = fnc;
	                            } else{
	                                fnc = keyData.__fnct;
	                            }
	                        }
	                        perc = fnc((frameNum-(keyData.t-offsetTime))/((nextKeyData.t-offsetTime)-(keyData.t-offsetTime)));
	                    }
	                }
	                if(this.sh && keyData.h !== 1){
	                    var initP = keyData.s[i];
	                    var endP = keyData.e[i];
	                    if(initP-endP < -180){
	                        initP += 360;
	                    } else if(initP-endP > 180){
	                        initP -= 360;
	                    }
	                    keyValue = initP+(endP-initP)*perc;
	                } else {
	                    keyValue = keyData.h === 1 ? keyData.s[i] : keyData.s[i]+(keyData.e[i]-keyData.s[i])*perc;
	                }
	                if(len === 1){
	                    newValue = keyValue;
	                }else{
	                    newValue[i] = keyValue;
	                }
	            }
	        }
	        return {
	            value: newValue,
	            iterationIndex: iterationIndex
	        }
	    }
	
	    function getValueAtCurrentTime(){
	        if(this.elem.globalData.frameId === this.frameId){
	            return;
	        }
	        this.mdf = false;
	        var frameNum = this.comp.renderedFrame - this.offsetTime;
	        var initTime = this.keyframes[0].t-this.offsetTime;
	        var endTime = this.keyframes[this.keyframes.length- 1].t-this.offsetTime;
	        if(!(frameNum === this._caching.lastFrame || (this._caching.lastFrame !== initFrame && ((this._caching.lastFrame >= endTime && frameNum >= endTime) || (this._caching.lastFrame < initTime && frameNum < initTime))))){
	            var i = this._caching.lastFrame < frameNum ? this._caching.lastIndex : 0;
	            var renderResult = this.interpolateValue(frameNum, i, this.pv, this._caching);
	            this._caching.lastIndex = renderResult.iterationIndex;
	            if(this.propType === 'multidimensional'){
	                i = 0;
	                while(i<this.v.length){
	                    this.pv[i] = renderResult.value[i];
	                    this.v[i] = this.mult ? this.pv[i] * this.mult : this.pv[i];
	                    if(this.lastPValue[i] !== this.pv[i]) {
	                        this.mdf = true;
	                        this.lastPValue[i] = this.pv[i];
	                    }
	                    i += 1;
	                }
	                if(this.firstFrame) {
	                    this.firstFrame = false;
	                    this.mdf = true;
	                }
	            } else {
	                this.pv = renderResult.value;
	                this.v = this.mult ? this.pv*this.mult : this.pv;
	                if(this.lastPValue != this.pv){
	                    this.mdf = true;
	                    this.lastPValue = this.pv;
	                }
	            }
	            
	        }
	        this._caching.lastFrame = frameNum;
	        this.frameId = this.elem.globalData.frameId;
	    }
	
	    function getNoValue(){}
	
	    function ValueProperty(elem,data, mult){
	        this.propType = 'unidimensional';
	        this.mult = mult;
	        this.v = mult ? data.k * mult : data.k;
	        this.pv = data.k;
	        this.mdf = false;
	        this.comp = elem.comp;
	        this.k = false;
	        this.kf = false;
	        this.vel = 0;
	        this.getValue = getNoValue;
	    }
	
	    function MultiDimensionalProperty(elem,data, mult){
	        this.propType = 'multidimensional';
	        this.mult = mult;
	        this.data = data;
	        this.mdf = false;
	        this.comp = elem.comp;
	        this.k = false;
	        this.kf = false;
	        this.frameId = -1;
	        this.v = createTypedArray('float32', data.k.length);
	        this.pv = createTypedArray('float32', data.k.length);
	        this.lastValue = createTypedArray('float32', data.k.length);
	        var arr = createTypedArray('float32', data.k.length);
	        this.vel = createTypedArray('float32', data.k.length);
	        var i, len = data.k.length;
	        for(i = 0;i<len;i+=1){
	            this.v[i] = mult ? data.k[i] * mult : data.k[i];
	            this.pv[i] = data.k[i];
	        }
	        this.getValue = getNoValue;
	    }
	
	    function KeyframedValueProperty(elem, data, mult){
	        this.propType = 'unidimensional';
	        this.keyframes = data.k;
	        this.offsetTime = elem.data.st;
	        this.lastValue = -99999;
	        this.lastPValue = -99999;
	        this.frameId = -1;
	        this._caching={lastFrame:initFrame,lastIndex:0};
	        this.k = true;
	        this.kf = true;
	        this.data = data;
	        this.mult = mult;
	        this.elem = elem;
	        this.firstFrame = false;
	        this.comp = elem.comp;
	        this.v = mult ? data.k[0].s[0]*mult : data.k[0].s[0];
	        this.pv = data.k[0].s[0];
	        this.getValue = getValueAtCurrentTime;
	        this.interpolateValue = interpolateValue;
	    }
	
	    function KeyframedMultidimensionalProperty(elem, data, mult){
	        var i, len = data.k.length;
	        var s, e,to,ti;
	        for(i=0;i<len-1;i+=1){
	            if(data.k[i].to && data.k[i].s && data.k[i].e){
	                s = data.k[i].s;
	                e = data.k[i].e;
	                to = data.k[i].to;
	                ti = data.k[i].ti;
	                if((s.length === 2 && !(s[0] === e[0] && s[1] === e[1]) && bez.pointOnLine2D(s[0],s[1],e[0],e[1],s[0] + to[0],s[1] + to[1]) && bez.pointOnLine2D(s[0],s[1],e[0],e[1],e[0] + ti[0],e[1] + ti[1])) || (s.length === 3 && !(s[0] === e[0] && s[1] === e[1] && s[2] === e[2]) && bez.pointOnLine3D(s[0],s[1],s[2],e[0],e[1],e[2],s[0] + to[0],s[1] + to[1],s[2] + to[2]) && bez.pointOnLine3D(s[0],s[1],s[2],e[0],e[1],e[2],e[0] + ti[0],e[1] + ti[1],e[2] + ti[2]))){
	                    data.k[i].to = null;
	                    data.k[i].ti = null;
	                }
	            }
	        }
	        this.propType = 'multidimensional';
	        this.keyframes = data.k;
	        this.offsetTime = elem.data.st;
	        this.k = true;
	        this.kf = true;
	        this.firstFrame = true;
	        this.mult = mult;
	        this.elem = elem;
	        this.comp = elem.comp;
	        this._caching={lastFrame:initFrame,lastIndex:0};
	        this.getValue = getValueAtCurrentTime;
	        this.interpolateValue = interpolateValue;
	        this.frameId = -1;
	        var arrLen = data.k[0].s.length;
	        this.v = createTypedArray('float32', arrLen);
	        this.pv = createTypedArray('float32', arrLen);
	        this.lastValue = createTypedArray('float32', arrLen);
	        this.lastPValue = createTypedArray('float32', arrLen);
	    }
	
	    function getProp(elem,data,type, mult, arr) {
	        var p;
	        if(data.a === 0){
	            if(type === 0) {
	                p = new ValueProperty(elem,data,mult);
	            } else {
	                p = new MultiDimensionalProperty(elem,data, mult);
	            }
	        } else if(data.a === 1){
	            if(type === 0) {
	                p = new KeyframedValueProperty(elem,data,mult);
	            } else {
	                p = new KeyframedMultidimensionalProperty(elem,data, mult);
	            }
	        } else if(!data.k.length){
	            p = new ValueProperty(elem,data, mult);
	        }else if(typeof(data.k[0]) === 'number'){
	            p = new MultiDimensionalProperty(elem,data, mult);
	        }else{
	            switch(type){
	                case 0:
	                    p = new KeyframedValueProperty(elem,data,mult);
	                    break;
	                case 1:
	                    p = new KeyframedMultidimensionalProperty(elem,data,mult);
	                    break;
	            }
	        }
	        if(p.k){
	            arr.push(p);
	        }
	        return p;
	    }
	
	    var ob = {
	        getProp: getProp
	    };
	    return ob;
	}());
	var TransformPropertyFactory = (function() {
	    
	    function applyToMatrix(mat) {
	        var i, len = this.dynamicProperties.length;
	        for(i = 0; i < len; i += 1) {
	            this.dynamicProperties[i].getValue();
	            if (this.dynamicProperties[i].mdf) {
	                this.mdf = true;
	            }
	        }
	        if (this.a) {
	            mat.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
	        }
	        if (this.s) {
	            mat.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
	        }
	        if (this.r) {
	            mat.rotate(-this.r.v);
	        } else {
	            mat.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
	        }
	        if (this.data.p.s) {
	            if (this.data.p.z) {
	                mat.translate(this.px.v, this.py.v, -this.pz.v);
	            } else {
	                mat.translate(this.px.v, this.py.v, 0);
	            }
	        } else {
	            mat.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
	        }
	    }
	    function processKeys(){
	        if (this.elem.globalData.frameId === this.frameId) {
	            return;
	        }
	
	        this.mdf = false;
	        var i, len = this.dynamicProperties.length;
	
	        for(i = 0; i < len; i += 1) {
	            this.dynamicProperties[i].getValue();
	            if (this.dynamicProperties[i].mdf) {
	                this.mdf = true;
	            }
	        }
	
	        if (this.mdf) {
	            this.v.reset();
	            if (this.a) {
	                this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
	            }
	            if(this.s) {
	                this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
	            }
	            if (this.sk) {
	                this.v.skewFromAxis(-this.sk.v, this.sa.v);
	            }
	            if (this.r) {
	                this.v.rotate(-this.r.v);
	            } else {
	                this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
	            }
	            if (this.autoOriented && this.p.keyframes && this.p.getValueAtTime) {
	                var v1,v2;
	                if (this.p._caching.lastFrame+this.p.offsetTime <= this.p.keyframes[0].t) {
	                    v1 = this.p.getValueAtTime((this.p.keyframes[0].t + 0.01) / this.elem.globalData.frameRate,0);
	                    v2 = this.p.getValueAtTime(this.p.keyframes[0].t / this.elem.globalData.frameRate, 0);
	                } else if(this.p._caching.lastFrame+this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t) {
	                    v1 = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t / this.elem.globalData.frameRate), 0);
	                    v2 = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - 0.01) / this.elem.globalData.frameRate, 0);
	                } else {
	                    v1 = this.p.pv;
	                    v2 = this.p.getValueAtTime((this.p._caching.lastFrame+this.p.offsetTime - 0.01) / this.elem.globalData.frameRate, this.p.offsetTime);
	                }
	                this.v.rotate(-Math.atan2(v1[1] - v2[1], v1[0] - v2[0]));
	            }
	            if(this.data.p.s){
	                if(this.data.p.z) {
	                    this.v.translate(this.px.v, this.py.v, -this.pz.v);
	                } else {
	                    this.v.translate(this.px.v, this.py.v, 0);
	                }
	            }else{
	                this.v.translate(this.p.v[0],this.p.v[1],-this.p.v[2]);
	            }
	        }
	        this.frameId = this.elem.globalData.frameId;
	    }
	
	    function setInverted(){
	        this.inverted = true;
	        this.iv = new Matrix();
	        if(!this.k){
	            if(this.data.p.s){
	                this.iv.translate(this.px.v,this.py.v,-this.pz.v);
	            }else{
	                this.iv.translate(this.p.v[0],this.p.v[1],-this.p.v[2]);
	            }
	            if(this.r){
	                this.iv.rotate(-this.r.v);
	            }else{
	                this.iv.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v);
	            }
	            if(this.s){
	                this.iv.scale(this.s.v[0],this.s.v[1],1);
	            }
	            if(this.a){
	                this.iv.translate(-this.a.v[0],-this.a.v[1],this.a.v[2]);
	            }
	        }
	    }
	
	    function autoOrient(){
	        //
	        //var prevP = this.getValueAtTime();
	    }
	
	    function TransformProperty(elem,data,arr){
	        this.elem = elem;
	        this.frameId = -1;
	        this.type = 'transform';
	        this.dynamicProperties = [];
	        this.mdf = false;
	        this.data = data;
	        this.v = new Matrix();
	        if(data.p.s){
	            this.px = PropertyFactory.getProp(elem,data.p.x,0,0,this.dynamicProperties);
	            this.py = PropertyFactory.getProp(elem,data.p.y,0,0,this.dynamicProperties);
	            if(data.p.z){
	                this.pz = PropertyFactory.getProp(elem,data.p.z,0,0,this.dynamicProperties);
	            }
	        }else{
	            this.p = PropertyFactory.getProp(elem,data.p,1,0,this.dynamicProperties);
	        }
	        if(data.r) {
	            this.r = PropertyFactory.getProp(elem, data.r, 0, degToRads, this.dynamicProperties);
	        } else if(data.rx) {
	            this.rx = PropertyFactory.getProp(elem, data.rx, 0, degToRads, this.dynamicProperties);
	            this.ry = PropertyFactory.getProp(elem, data.ry, 0, degToRads, this.dynamicProperties);
	            this.rz = PropertyFactory.getProp(elem, data.rz, 0, degToRads, this.dynamicProperties);
	            if(data.or.k[0].ti) {
	                var i, len = data.or.k.length;
	                for(i=0;i<len;i+=1) {
	                    data.or.k[i].to = data.or.k[i].ti = null;
	                }
	            }
	            this.or = PropertyFactory.getProp(elem, data.or, 1, degToRads, this.dynamicProperties);
	            //sh Indicates it needs to be capped between -180 and 180
	            this.or.sh = true;
	        }
	        if(data.sk){
	            this.sk = PropertyFactory.getProp(elem, data.sk, 0, degToRads, this.dynamicProperties);
	            this.sa = PropertyFactory.getProp(elem, data.sa, 0, degToRads, this.dynamicProperties);
	        }
	        if(data.a) {
	            this.a = PropertyFactory.getProp(elem,data.a,1,0,this.dynamicProperties);
	        }
	        if(data.s) {
	            this.s = PropertyFactory.getProp(elem,data.s,1,0.01,this.dynamicProperties);
	        }
	        if(data.o){
	            this.o = PropertyFactory.getProp(elem,data.o,0,0.01,arr);
	        } else {
	            this.o = {mdf:false,v:1};
	        }
	        if(this.dynamicProperties.length){
	            arr.push(this);
	        }else{
	            if(this.a){
	                this.v.translate(-this.a.v[0],-this.a.v[1],this.a.v[2]);
	            }
	            if(this.s){
	                this.v.scale(this.s.v[0],this.s.v[1],this.s.v[2]);
	            }
	            if(this.sk){
	                this.v.skewFromAxis(-this.sk.v,this.sa.v);
	            }
	            if(this.r){
	                this.v.rotate(-this.r.v);
	            }else{
	                this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
	            }
	            if(this.data.p.s){
	                if(data.p.z) {
	                    this.v.translate(this.px.v, this.py.v, -this.pz.v);
	                } else {
	                    this.v.translate(this.px.v, this.py.v, 0);
	                }
	            }else{
	                this.v.translate(this.p.v[0],this.p.v[1],-this.p.v[2]);
	            }
	        }
	    }
	
	    TransformProperty.prototype.applyToMatrix = applyToMatrix;
	    TransformProperty.prototype.getValue = processKeys;
	    TransformProperty.prototype.setInverted = setInverted;
	    TransformProperty.prototype.autoOrient = autoOrient;
	
	    function getTransformProperty(elem,data,arr){
	        return new TransformProperty(elem,data,arr)
	    }
	
	    return {
	        getTransformProperty: getTransformProperty
	    };
	
	}());
	function ShapePath(){
		this.c = false;
		this._length = 0;
		this._maxLength = 8;
		this.v = Array.apply(null,{length:this._maxLength});
		this.o = Array.apply(null,{length:this._maxLength});
		this.i = Array.apply(null,{length:this._maxLength});
	};
	
	ShapePath.prototype.setPathData = function(closed, len) {
		this.c = closed;
		this.setLength(len);
		var i = 0;
		while(i < len){
			this.v[i] = point_pool.newPoint();
			this.o[i] = point_pool.newPoint();
			this.i[i] = point_pool.newPoint();
			i += 1;
		}
	};
	
	ShapePath.prototype.setLength = function(len) {
		while(this._maxLength < len) {
			this.doubleArrayLength();
		}
		this._length = len;
	}
	
	ShapePath.prototype.doubleArrayLength = function() {
		this.v = this.v.concat(Array.apply(null,{length:this._maxLength}))
		this.i = this.i.concat(Array.apply(null,{length:this._maxLength}))
		this.o = this.o.concat(Array.apply(null,{length:this._maxLength}))
		this._maxLength *= 2;
	};
	
	ShapePath.prototype.setXYAt = function(x, y, type, pos, replace) {
		var arr;
		this._length = Math.max(this._length, pos + 1);
		if(this._length >= this._maxLength) {
			this.doubleArrayLength();
		}
		switch(type){
			case 'v':
				arr = this.v;
				break;
			case 'i':
				arr = this.i;
				break;
			case 'o':
				arr = this.o;
				break;
		}
		if(!arr[pos] || (arr[pos] && !replace)){
			arr[pos] = point_pool.newPoint();
		}
		arr[pos][0] = x;
		arr[pos][1] = y;
	};
	
	ShapePath.prototype.setTripleAt = function(vX,vY,oX,oY,iX,iY,pos, replace) {
		this.setXYAt(vX,vY,'v',pos, replace);
		this.setXYAt(oX,oY,'o',pos, replace);
		this.setXYAt(iX,iY,'i',pos, replace);
	};
	
	ShapePath.prototype.reverse = function() {
		var newPath = new ShapePath();
		newPath.setPathData(this.c, this._length);
		var vertices = this.v, outPoints = this.o, inPoints = this.i;
		var init = 0;
		if (this.c) {
			newPath.setTripleAt(vertices[0][0], vertices[0][1], inPoints[0][0], inPoints[0][1], outPoints[0][0], outPoints[0][1], 0, false);
	        init = 1;
	    }
	    var cnt = this._length - 1;
	    var len = this._length;
	
	    for (i = init; i < len; i += 1) {
	    	newPath.setTripleAt(vertices[cnt][0], vertices[cnt][1], inPoints[cnt][0], inPoints[cnt][1], outPoints[cnt][0], outPoints[cnt][1], i, false);
	        cnt -= 1;
	    }
	    return newPath;
	};
	var ShapePropertyFactory = (function(){
	
	    var initFrame = -999999;
	
	    function interpolateShape(frameNum, iterationIndex, previousValue, isCurrentRender) {
	        var keyPropS,keyPropE,isHold;
	        if(frameNum < this.keyframes[0].t-this.offsetTime){
	            keyPropS = this.keyframes[0].s[0];
	            isHold = true;
	            iterationIndex = 0;
	        }else if(frameNum >= this.keyframes[this.keyframes.length - 1].t-this.offsetTime){
	            if(this.keyframes[this.keyframes.length - 2].h === 1){
	                keyPropS = this.keyframes[this.keyframes.length - 1].s[0];
	            }else{
	                keyPropS = this.keyframes[this.keyframes.length - 2].e[0];
	            }
	            isHold = true;
	        }else{
	            var i = iterationIndex;
	            var len = this.keyframes.length- 1,flag = true,keyData,nextKeyData, j, jLen, k, kLen;
	            while(flag){
	                keyData = this.keyframes[i];
	                nextKeyData = this.keyframes[i+1];
	                if((nextKeyData.t - this.offsetTime) > frameNum){
	                    break;
	                }
	                if(i < len - 1){
	                    i += 1;
	                }else{
	                    flag = false;
	                }
	            }
	            isHold = keyData.h === 1;
	            iterationIndex = i;
	
	            var perc;
	            if(!isHold){
	                if(frameNum >= nextKeyData.t-this.offsetTime){
	                    perc = 1;
	                }else if(frameNum < keyData.t-this.offsetTime){
	                    perc = 0;
	                }else{
	                    var fnc;
	                    if(keyData.__fnct){
	                        fnc = keyData.__fnct;
	                    }else{
	                        fnc = BezierFactory.getBezierEasing(keyData.o.x,keyData.o.y,keyData.i.x,keyData.i.y).get;
	                        keyData.__fnct = fnc;
	                    }
	                    perc = fnc((frameNum-(keyData.t-this.offsetTime))/((nextKeyData.t-this.offsetTime)-(keyData.t-this.offsetTime)));
	                }
	                keyPropE = keyData.e[0];
	            }
	            keyPropS = keyData.s[0];
	        }
	        jLen = previousValue._length;
	        kLen = keyPropS.i[0].length;
	        var hasModified = false;
	        var vertexValue;
	        for(j=0;j<jLen;j+=1){
	            for(k=0;k<kLen;k+=1){
	                if(isHold){
	                    vertexValue = keyPropS.i[j][k];
	                    if(previousValue.i[j][k] !== vertexValue){
	                        previousValue.i[j][k] = vertexValue;
	                        if(isCurrentRender) {
	                            this.pv.i[j][k] = vertexValue;
	                        }
	                        hasModified = true;
	                    }
	                    vertexValue = keyPropS.o[j][k];
	                    if(previousValue.o[j][k] !== vertexValue){
	                        previousValue.o[j][k] = vertexValue;
	                        if(isCurrentRender) {
	                            this.pv.o[j][k] = vertexValue;
	                        }
	                        hasModified = true;
	                    }
	                    vertexValue = keyPropS.v[j][k];
	                    if(previousValue.v[j][k] !== vertexValue){
	                        previousValue.v[j][k] = vertexValue;
	                        if(isCurrentRender) {
	                            this.pv.v[j][k] = vertexValue;
	                        }
	                        hasModified = true;
	                    }
	                }else{
	                    vertexValue = keyPropS.i[j][k]+(keyPropE.i[j][k]-keyPropS.i[j][k])*perc;
	                    if(previousValue.i[j][k] !== vertexValue){
	                        previousValue.i[j][k] = vertexValue;
	                        if(isCurrentRender) {
	                            this.pv.i[j][k] = vertexValue;
	                        }
	                        hasModified = true;
	                    }
	                    vertexValue = keyPropS.o[j][k]+(keyPropE.o[j][k]-keyPropS.o[j][k])*perc;
	                    if(previousValue.o[j][k] !== vertexValue){
	                        previousValue.o[j][k] = vertexValue;
	                        if(isCurrentRender) {
	                            this.pv.o[j][k] = vertexValue;
	                        }
	                        hasModified = true;
	                    }
	                    vertexValue = keyPropS.v[j][k]+(keyPropE.v[j][k]-keyPropS.v[j][k])*perc;
	                    if(previousValue.v[j][k] !== vertexValue){
	                        previousValue.v[j][k] = vertexValue;
	                        if(isCurrentRender) {
	                            this.pv.v[j][k] = vertexValue;
	                        }
	                        hasModified = true;
	                    }
	                }
	            }
	        }
	        if(hasModified) {
	            previousValue.c = keyPropS.c;
	        }
	        return {
	            iterationIndex: iterationIndex,
	            hasModified: hasModified
	        }
	    }
	
	    function interpolateShapeCurrentTime(){
	        if(this.elem.globalData.frameId === this.frameId){
	            return;
	        }
	        this.mdf = false;
	        var frameNum = this.comp.renderedFrame - this.offsetTime;
	        var initTime = this.keyframes[0].t - this.offsetTime;
	        var endTime = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
	        if(!(this.lastFrame !== initFrame && ((this.lastFrame < initTime && frameNum < initTime) || (this.lastFrame > endTime && frameNum > endTime)))){
	            ////
	            var i = this.lastFrame < frameNum ? this._lastIndex : 0;
	            var renderResult = this.interpolateShape(frameNum, i, this.v, true);
	            ////
	            this._lastIndex = renderResult.iterationIndex;
	            this.mdf = renderResult.hasModified;
	            if(renderResult.hasModified) {
	                this.paths = this.localShapeCollection;
	            }
	        }
	        this.lastFrame = frameNum;
	        this.frameId = this.elem.globalData.frameId;
	    }
	
	    function getShapeValue(){
	        return this.v;
	    }
	
	    function resetShape(){
	        this.paths = this.localShapeCollection;
	        if(!this.k){
	            this.mdf = false;
	        }
	    }
	
	    function ShapeProperty(elem, data, type){
	        this.__shapeObject = 1;
	        this.comp = elem.comp;
	        this.k = false;
	        this.mdf = false;
	        var pathData = type === 3 ? data.pt.k : data.ks.k;
	        this.v = shape_pool.clone(pathData);
	        this.pv = shape_pool.clone(this.v);
	        this.localShapeCollection = shapeCollection_pool.newShapeCollection();
	        this.paths = this.localShapeCollection;
	        this.paths.addShape(this.v);
	        this.reset = resetShape;
	    }
	    ShapeProperty.prototype.interpolateShape = interpolateShape;
	    ShapeProperty.prototype.getValue = getShapeValue;
	
	    function KeyframedShapeProperty(elem,data,type){
	        this.__shapeObject = 1;
	        this.comp = elem.comp;
	        this.elem = elem;
	        this.offsetTime = elem.data.st;
	        this._lastIndex = 0;
	        this.keyframes = type === 3 ? data.pt.k : data.ks.k;
	        this.k = true;
	        this.kf = true;
	        var i, len = this.keyframes[0].s[0].i.length;
	        var jLen = this.keyframes[0].s[0].i[0].length;
	        this.v = shape_pool.newShape();
	        this.v.setPathData(this.keyframes[0].s[0].c, len);
	        this.pv = shape_pool.clone(this.v);
	        this.localShapeCollection = shapeCollection_pool.newShapeCollection();
	        this.paths = this.localShapeCollection;
	        this.paths.addShape(this.v);
	        this.lastFrame = initFrame;
	        this.reset = resetShape;
	    }
	    KeyframedShapeProperty.prototype.getValue = interpolateShapeCurrentTime;
	    KeyframedShapeProperty.prototype.interpolateShape = interpolateShape;
	
	    var EllShapeProperty = (function(){
	
	        var cPoint = roundCorner;
	
	        function convertEllToPath(){
	            var p0 = this.p.v[0], p1 = this.p.v[1], s0 = this.s.v[0]/2, s1 = this.s.v[1]/2;
	            if(this.d !== 3){
	                this.v.v[0][0] = p0;
	                this.v.v[0][1] = p1-s1;
	                this.v.v[1][0] = p0 + s0;
	                this.v.v[1][1] = p1;
	                this.v.v[2][0] = p0;
	                this.v.v[2][1] = p1+s1;
	                this.v.v[3][0] = p0 - s0;
	                this.v.v[3][1] = p1;
	                this.v.i[0][0] = p0 - s0*cPoint;
	                this.v.i[0][1] = p1 - s1;
	                this.v.i[1][0] = p0 + s0;
	                this.v.i[1][1] = p1 - s1*cPoint;
	                this.v.i[2][0] = p0 + s0*cPoint;
	                this.v.i[2][1] = p1 + s1;
	                this.v.i[3][0] = p0 - s0;
	                this.v.i[3][1] = p1 + s1*cPoint;
	                this.v.o[0][0] = p0 + s0*cPoint;
	                this.v.o[0][1] = p1 - s1;
	                this.v.o[1][0] = p0 + s0;
	                this.v.o[1][1] = p1 + s1*cPoint;
	                this.v.o[2][0] = p0 - s0*cPoint;
	                this.v.o[2][1] = p1 + s1;
	                this.v.o[3][0] = p0 - s0;
	                this.v.o[3][1] = p1 - s1*cPoint;
	            }else{
	                this.v.v[0][0] = p0;
	                this.v.v[0][1] = p1-s1;
	                this.v.v[1][0] = p0 - s0;
	                this.v.v[1][1] = p1;
	                this.v.v[2][0] = p0;
	                this.v.v[2][1] = p1+s1;
	                this.v.v[3][0] = p0 + s0;
	                this.v.v[3][1] = p1;
	                this.v.i[0][0] = p0 + s0*cPoint;
	                this.v.i[0][1] = p1 - s1;
	                this.v.i[1][0] = p0 - s0;
	                this.v.i[1][1] = p1 - s1*cPoint;
	                this.v.i[2][0] = p0 - s0*cPoint;
	                this.v.i[2][1] = p1 + s1;
	                this.v.i[3][0] = p0 + s0;
	                this.v.i[3][1] = p1 + s1*cPoint;
	                this.v.o[0][0] = p0 - s0*cPoint;
	                this.v.o[0][1] = p1 - s1;
	                this.v.o[1][0] = p0 - s0;
	                this.v.o[1][1] = p1 + s1*cPoint;
	                this.v.o[2][0] = p0 + s0*cPoint;
	                this.v.o[2][1] = p1 + s1;
	                this.v.o[3][0] = p0 + s0;
	                this.v.o[3][1] = p1 - s1*cPoint;
	            }
	        }
	
	        function processKeys(frameNum){
	            var i, len = this.dynamicProperties.length;
	            if(this.elem.globalData.frameId === this.frameId){
	                return;
	            }
	            this.mdf = false;
	            this.frameId = this.elem.globalData.frameId;
	
	            for(i=0;i<len;i+=1){
	                this.dynamicProperties[i].getValue(frameNum);
	                if(this.dynamicProperties[i].mdf){
	                    this.mdf = true;
	                }
	            }
	            if(this.mdf){
	                this.convertEllToPath();
	            }
	        }
	
	        return function EllShapeProperty(elem,data) {
	            /*this.v = {
	                v: Array.apply(null,{length:4}),
	                i: Array.apply(null,{length:4}),
	                o: Array.apply(null,{length:4}),
	                c: true
	            };*/
	            this.v = shape_pool.newShape();
	            this.v.setPathData(true, 4);
	            this.localShapeCollection = shapeCollection_pool.newShapeCollection();
	            this.paths = this.localShapeCollection;
	            this.localShapeCollection.addShape(this.v);
	            this.d = data.d;
	            this.dynamicProperties = [];
	            this.elem = elem;
	            this.comp = elem.comp;
	            this.frameId = -1;
	            this.mdf = false;
	            this.getValue = processKeys;
	            this.convertEllToPath = convertEllToPath;
	            this.reset = resetShape;
	            this.p = PropertyFactory.getProp(elem,data.p,1,0,this.dynamicProperties);
	            this.s = PropertyFactory.getProp(elem,data.s,1,0,this.dynamicProperties);
	            if(this.dynamicProperties.length){
	                this.k = true;
	            }else{
	                this.convertEllToPath();
	            }
	        }
	    }());
	
	    var StarShapeProperty = (function() {
	
	        function convertPolygonToPath(){
	            var numPts = Math.floor(this.pt.v);
	            var angle = Math.PI*2/numPts;
	            /*this.v.v.length = numPts;
	            this.v.i.length = numPts;
	            this.v.o.length = numPts;*/
	            var rad = this.or.v;
	            var roundness = this.os.v;
	            var perimSegment = 2*Math.PI*rad/(numPts*4);
	            var i, currentAng = -Math.PI/ 2;
	            var dir = this.data.d === 3 ? -1 : 1;
	            currentAng += this.r.v;
	            this.v._length = 0;
	            for(i=0;i<numPts;i+=1){
	                var x = rad * Math.cos(currentAng);
	                var y = rad * Math.sin(currentAng);
	                var ox = x === 0 && y === 0 ? 0 : y/Math.sqrt(x*x + y*y);
	                var oy = x === 0 && y === 0 ? 0 : -x/Math.sqrt(x*x + y*y);
	                x +=  + this.p.v[0];
	                y +=  + this.p.v[1];
	                this.v.setTripleAt(x,y,x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir,x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir, i, true);
	                /*this.v.v[i] = [x,y];
	                this.v.i[i] = [x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir];
	                this.v.o[i] = [x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir];*/
	                currentAng += angle*dir;
	            }
	            this.paths.length = 0;
	            this.paths[0] = this.v;
	        }
	
	        function convertStarToPath() {
	            var numPts = Math.floor(this.pt.v)*2;
	            var angle = Math.PI*2/numPts;
	            /*this.v.v.length = numPts;
	            this.v.i.length = numPts;
	            this.v.o.length = numPts;*/
	            var longFlag = true;
	            var longRad = this.or.v;
	            var shortRad = this.ir.v;
	            var longRound = this.os.v;
	            var shortRound = this.is.v;
	            var longPerimSegment = 2*Math.PI*longRad/(numPts*2);
	            var shortPerimSegment = 2*Math.PI*shortRad/(numPts*2);
	            var i, rad,roundness,perimSegment, currentAng = -Math.PI/ 2;
	            currentAng += this.r.v;
	            var dir = this.data.d === 3 ? -1 : 1;
	            this.v._length = 0;
	            for(i=0;i<numPts;i+=1){
	                rad = longFlag ? longRad : shortRad;
	                roundness = longFlag ? longRound : shortRound;
	                perimSegment = longFlag ? longPerimSegment : shortPerimSegment;
	                var x = rad * Math.cos(currentAng);
	                var y = rad * Math.sin(currentAng);
	                var ox = x === 0 && y === 0 ? 0 : y/Math.sqrt(x*x + y*y);
	                var oy = x === 0 && y === 0 ? 0 : -x/Math.sqrt(x*x + y*y);
	                x +=  + this.p.v[0];
	                y +=  + this.p.v[1];
	                this.v.setTripleAt(x,y,x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir,x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir, i, true);
	
	                /*this.v.v[i] = [x,y];
	                this.v.i[i] = [x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir];
	                this.v.o[i] = [x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir];
	                this.v._length = numPts;*/
	                longFlag = !longFlag;
	                currentAng += angle*dir;
	            }
	        }
	
	        function processKeys() {
	            if(this.elem.globalData.frameId === this.frameId){
	                return;
	            }
	            this.mdf = false;
	            this.frameId = this.elem.globalData.frameId;
	            var i, len = this.dynamicProperties.length;
	
	            for(i=0;i<len;i+=1){
	                this.dynamicProperties[i].getValue();
	                if(this.dynamicProperties[i].mdf){
	                    this.mdf = true;
	                }
	            }
	            if(this.mdf){
	                this.convertToPath();
	            }
	        }
	
	        return function StarShapeProperty(elem,data) {
	            /*this.v = {
	                v: [],
	                i: [],
	                o: [],
	                c: true
	            };*/
	            this.v = shape_pool.newShape();
	            this.v.setPathData(true, 0);
	            this.elem = elem;
	            this.comp = elem.comp;
	            this.data = data;
	            this.frameId = -1;
	            this.d = data.d;
	            this.dynamicProperties = [];
	            this.mdf = false;
	            this.getValue = processKeys;
	            this.reset = resetShape;
	            if(data.sy === 1){
	                this.ir = PropertyFactory.getProp(elem,data.ir,0,0,this.dynamicProperties);
	                this.is = PropertyFactory.getProp(elem,data.is,0,0.01,this.dynamicProperties);
	                this.convertToPath = convertStarToPath;
	            } else {
	                this.convertToPath = convertPolygonToPath;
	            }
	            this.pt = PropertyFactory.getProp(elem,data.pt,0,0,this.dynamicProperties);
	            this.p = PropertyFactory.getProp(elem,data.p,1,0,this.dynamicProperties);
	            this.r = PropertyFactory.getProp(elem,data.r,0,degToRads,this.dynamicProperties);
	            this.or = PropertyFactory.getProp(elem,data.or,0,0,this.dynamicProperties);
	            this.os = PropertyFactory.getProp(elem,data.os,0,0.01,this.dynamicProperties);
	            this.localShapeCollection = shapeCollection_pool.newShapeCollection();
	            this.localShapeCollection.addShape(this.v);
	            this.paths = this.localShapeCollection;
	            if(this.dynamicProperties.length){
	                this.k = true;
	            }else{
	                this.convertToPath();
	            }
	        }
	    }());
	
	    var RectShapeProperty = (function() {
	        function processKeys(frameNum){
	            if(this.elem.globalData.frameId === this.frameId){
	                return;
	            }
	            this.mdf = false;
	            this.frameId = this.elem.globalData.frameId;
	            var i, len = this.dynamicProperties.length;
	
	            for(i=0;i<len;i+=1){
	                this.dynamicProperties[i].getValue(frameNum);
	                if(this.dynamicProperties[i].mdf){
	                    this.mdf = true;
	                }
	            }
	            if(this.mdf){
	                this.convertRectToPath();
	            }
	
	        }
	
	        function convertRectToPath(){
	            var p0 = this.p.v[0], p1 = this.p.v[1], v0 = this.s.v[0]/2, v1 = this.s.v[1]/2;
	            var round = bm_min(v0,v1,this.r.v);
	            var cPoint = round*(1-roundCorner);
	            this.v._length = 0;
	
	            if(this.d === 2 || this.d === 1) {
	                this.v.setTripleAt(p0+v0, p1-v1+round,p0+v0, p1-v1+round,p0+v0,p1-v1+cPoint,0, true);
	                this.v.setTripleAt(p0+v0, p1+v1-round,p0+v0, p1+v1-cPoint,p0+v0, p1+v1-round,1, true);
	                if(round!== 0){
	                    this.v.setTripleAt(p0+v0-round, p1+v1,p0+v0-round,p1+v1,p0+v0-cPoint,p1+v1,2, true);
	                    this.v.setTripleAt(p0-v0+round,p1+v1,p0-v0+cPoint,p1+v1,p0-v0+round,p1+v1,3, true);
	                    this.v.setTripleAt(p0-v0,p1+v1-round,p0-v0,p1+v1-round,p0-v0,p1+v1-cPoint,4, true);
	                    this.v.setTripleAt(p0-v0,p1-v1+round,p0-v0,p1-v1+cPoint,p0-v0,p1-v1+round,5, true);
	                    this.v.setTripleAt(p0-v0+round,p1-v1,p0-v0+round,p1-v1,p0-v0+cPoint,p1-v1,6, true);
	                    this.v.setTripleAt(p0+v0-round,p1-v1,p0+v0-cPoint,p1-v1,p0+v0-round,p1-v1,7, true);
	                } else {
	                    this.v.setTripleAt(p0-v0,p1+v1,p0-v0+cPoint,p1+v1,p0-v0,p1+v1,2);
	                    this.v.setTripleAt(p0-v0,p1-v1,p0-v0,p1-v1+cPoint,p0-v0,p1-v1,3);
	                }
	            }else{
	                this.v.setTripleAt(p0+v0,p1-v1+round,p0+v0,p1-v1+cPoint,p0+v0,p1-v1+round,0, true);
	                if(round!== 0){
	                    this.v.setTripleAt(p0+v0-round,p1-v1,p0+v0-round,p1-v1,p0+v0-cPoint,p1-v1,1, true);
	                    this.v.setTripleAt(p0-v0+round,p1-v1,p0-v0+cPoint,p1-v1,p0-v0+round,p1-v1,2, true);
	                    this.v.setTripleAt(p0-v0,p1-v1+round,p0-v0,p1-v1+round,p0-v0,p1-v1+cPoint,3, true);
	                    this.v.setTripleAt(p0-v0,p1+v1-round,p0-v0,p1+v1-cPoint,p0-v0,p1+v1-round,4, true);
	                    this.v.setTripleAt(p0-v0+round,p1+v1,p0-v0+round,p1+v1,p0-v0+cPoint,p1+v1,5, true);
	                    this.v.setTripleAt(p0+v0-round,p1+v1,p0+v0-cPoint,p1+v1,p0+v0-round,p1+v1,6, true);
	                    this.v.setTripleAt(p0+v0,p1+v1-round,p0+v0,p1+v1-round,p0+v0,p1+v1-cPoint,7, true);
	                } else {
	                    this.v.setTripleAt(p0-v0,p1-v1,p0-v0+cPoint,p1-v1,p0-v0,p1-v1,1, true);
	                    this.v.setTripleAt(p0-v0,p1+v1,p0-v0,p1+v1-cPoint,p0-v0,p1+v1,2, true);
	                    this.v.setTripleAt(p0+v0,p1+v1,p0+v0-cPoint,p1+v1,p0+v0,p1+v1,3, true);
	
	                }
	            }
	        }
	
	        return function RectShapeProperty(elem,data) {
	            this.v = shape_pool.newShape();
	            this.v.c = true;
	            this.localShapeCollection = shapeCollection_pool.newShapeCollection();
	            this.localShapeCollection.addShape(this.v);
	            this.paths = this.localShapeCollection;
	            this.elem = elem;
	            this.comp = elem.comp;
	            this.frameId = -1;
	            this.d = data.d;
	            this.dynamicProperties = [];
	            this.mdf = false;
	            this.getValue = processKeys;
	            this.convertRectToPath = convertRectToPath;
	            this.reset = resetShape;
	            this.p = PropertyFactory.getProp(elem,data.p,1,0,this.dynamicProperties);
	            this.s = PropertyFactory.getProp(elem,data.s,1,0,this.dynamicProperties);
	            this.r = PropertyFactory.getProp(elem,data.r,0,0,this.dynamicProperties);
	            if(this.dynamicProperties.length){
	                this.k = true;
	            }else{
	                this.convertRectToPath();
	            }
	        }
	    }());
	
	    function getShapeProp(elem,data,type, arr){
	        var prop;
	        if(type === 3 || type === 4){
	            var dataProp = type === 3 ? data.pt : data.ks;
	            var keys = dataProp.k;
	            if(dataProp.a === 1 || keys.length){
	                prop = new KeyframedShapeProperty(elem, data, type);
	            }else{
	                prop = new ShapeProperty(elem, data, type);
	            }
	        }else if(type === 5){
	            prop = new RectShapeProperty(elem, data);
	        }else if(type === 6){
	            prop = new EllShapeProperty(elem, data);
	        }else if(type === 7){
	            prop = new StarShapeProperty(elem, data);
	        }
	        if(prop.k){
	            arr.push(prop);
	        }
	        return prop;
	    }
	
	    function getConstructorFunction() {
	        return ShapeProperty;
	    }
	
	    function getKeyframedConstructorFunction() {
	        return KeyframedShapeProperty;
	    }
	
	    var ob = {};
	    ob.getShapeProp = getShapeProp;
	    ob.getConstructorFunction = getConstructorFunction;
	    ob.getKeyframedConstructorFunction = getKeyframedConstructorFunction;
	    return ob;
	}());
	var ShapeModifiers = (function(){
	    var ob = {};
	    var modifiers = {};
	    ob.registerModifier = registerModifier;
	    ob.getModifier = getModifier;
	
	    function registerModifier(nm,factory){
	        if(!modifiers[nm]){
	            modifiers[nm] = factory;
	        }
	    }
	
	    function getModifier(nm,elem, data, dynamicProperties){
	        return new modifiers[nm](elem, data, dynamicProperties);
	    }
	
	    return ob;
	}());
	
	function ShapeModifier(){}
	ShapeModifier.prototype.initModifierProperties = function(){};
	ShapeModifier.prototype.addShapeToModifier = function(){};
	ShapeModifier.prototype.addShape = function(data){
	    if(!this.closed){
	        this.shapes.push({shape:data.sh, data: data, localShapeCollection:shapeCollection_pool.newShapeCollection()});
	        this.addShapeToModifier(data.sh);
	    }
	}
	ShapeModifier.prototype.init = function(elem,data,dynamicProperties){
	    this.elem = elem;
	    this.frameId = -1;
	    this.shapes = [];
	    this.dynamicProperties = [];
	    this.mdf = false;
	    this.closed = false;
	    this.k = false;
	    this.comp = elem.comp;
	    this.initModifierProperties(elem,data);
	    if(this.dynamicProperties.length){
	        this.k = true;
	        dynamicProperties.push(this);
	    }else{
	        this.getValue(true);
	    }
	}
	function TrimModifier(){};
	extendPrototype(ShapeModifier,TrimModifier);
	TrimModifier.prototype.processKeys = function(forceRender){
	    if(this.elem.globalData.frameId === this.frameId && !forceRender){
	        return;
	    }
	    this.mdf = forceRender ? true : false;
	    this.frameId = this.elem.globalData.frameId;
	    var i, len = this.dynamicProperties.length;
	
	    for(i=0;i<len;i+=1){
	        this.dynamicProperties[i].getValue();
	        if(this.dynamicProperties[i].mdf){
	            this.mdf = true;
	        }
	    }
	    if(this.mdf || forceRender){
	        var o = (this.o.v%360)/360;
	        if(o < 0){
	            o += 1;
	        }
	        var s = this.s.v + o;
	        var e = this.e.v + o;
	        if(s == e){
	
	        }
	        if(s>e){
	            var _s = s;
	            s = e;
	            e = _s;
	        }
	        this.sValue = s;
	        this.eValue = e;
	        this.oValue = o;
	    }
	}
	TrimModifier.prototype.initModifierProperties = function(elem,data){
	    this.sValue = 0;
	    this.eValue = 0;
	    this.oValue = 0;
	    this.getValue = this.processKeys;
	    this.s = PropertyFactory.getProp(elem,data.s,0,0.01,this.dynamicProperties);
	    this.e = PropertyFactory.getProp(elem,data.e,0,0.01,this.dynamicProperties);
	    this.o = PropertyFactory.getProp(elem,data.o,0,0,this.dynamicProperties);
	    this.m = data.m;
	    if(!this.dynamicProperties.length){
	        this.getValue(true);
	    }
	};
	
	TrimModifier.prototype.calculateShapeEdges = function(s, e, shapeLength, addedLength, totalModifierLength) {
	    var segments = []
	    if(e <= 1){
	        segments.push({
	            s: s,
	            e: e
	        })
	    }else if(s >= 1){
	        segments.push({
	            s: s - 1,
	            e: e - 1
	        })
	    }else{
	        segments.push({
	            s: s,
	            e: 1
	        })
	        segments.push({
	            s: 0,
	            e: e - 1
	        })
	    }
	    var shapeSegments = [];
	    var i, len = segments.length, segmentOb;
	    for(i = 0; i < len; i += 1) {
	        segmentOb = segments[i];
	        if (segmentOb.e * totalModifierLength < addedLength || segmentOb.s * totalModifierLength > addedLength + shapeLength) {
	            
	        } else {
	            var shapeS, shapeE;
	            if(segmentOb.s * totalModifierLength <= addedLength) {
	                shapeS = 0;
	            } else {
	                shapeS = (segmentOb.s * totalModifierLength - addedLength) / shapeLength;
	            }
	            if(segmentOb.e * totalModifierLength >= addedLength + shapeLength) {
	                shapeE = 1;
	            } else {
	                shapeE = ((segmentOb.e * totalModifierLength - addedLength) / shapeLength);
	            }
	            shapeSegments.push([shapeS, shapeE]);
	        }
	    }
	    if(!shapeSegments.length){
	        shapeSegments.push([0,0]);
	    }
	    return shapeSegments;
	}
	
	TrimModifier.prototype.processShapes = function(firstFrame){
	    var shapePaths;
	    var i, len = this.shapes.length;
	    var j, jLen;
	    var s = this.sValue;
	    var e = this.eValue;
	    var pathsData,pathData, totalShapeLength, totalModifierLength = 0;
	
	    if(e === s){
	        for(i=0;i<len;i+=1){
	            this.shapes[i].localShapeCollection.releaseShapes();
	            this.shapes[i].shape.mdf = true;
	            this.shapes[i].shape.paths = this.shapes[i].localShapeCollection;
	        }
	    } else if(!((e === 1 && s === 0) || (e===0 && s === 1))){
	        var segments = [], shapeData, localShapeCollection;
	        for(i=0;i<len;i+=1){
	            shapeData = this.shapes[i];
	            if(!shapeData.shape.mdf && !this.mdf && !firstFrame && this.m !== 2){
	                shapeData.shape.paths = shapeData.localShapeCollection;
	            } else {
	                shapePaths = shapeData.shape.paths;
	                jLen = shapePaths._length;
	                totalShapeLength = 0;
	                if(!shapeData.shape.mdf && shapeData.pathsData){
	                    totalShapeLength = shapeData.totalShapeLength;
	                } else {
	                    pathsData = [];
	                    for(j=0;j<jLen;j+=1){
	                        pathData = bez.getSegmentsLength(shapePaths.shapes[j]);
	                        pathsData.push(pathData);
	                        totalShapeLength += pathData.totalLength;
	                    }
	                    shapeData.totalShapeLength = totalShapeLength;
	                    shapeData.pathsData = pathsData;
	                }
	
	                totalModifierLength += totalShapeLength;
	                shapeData.shape.mdf = true;
	            }
	        }
	        var shapeS = s, shapeE = e, addedLength = 0;
	        var j, jLen;
	        for(i = len - 1; i >= 0; i -= 1){
	            shapeData = this.shapes[i];
	            if (shapeData.shape.mdf) {
	                localShapeCollection = shapeData.localShapeCollection;
	                localShapeCollection.releaseShapes();
	                if(this.m === 2 && len > 1) {
	                    var edges = this.calculateShapeEdges(s, e, shapeData.totalShapeLength, addedLength, totalModifierLength);
	                    addedLength += shapeData.totalShapeLength;
	                } else {
	                    edges = [[shapeS, shapeE]]
	                }
	                jLen = edges.length;
	                for (j = 0; j < jLen; j += 1) {
	                    shapeS = edges[j][0];
	                    shapeE = edges[j][1];
	                    segments.length = 0;
	                    if(shapeE <= 1){
	                        segments.push({
	                            s:shapeData.totalShapeLength * shapeS,
	                            e:shapeData.totalShapeLength * shapeE
	                        })
	                    }else if(shapeS >= 1){
	                        segments.push({
	                            s:shapeData.totalShapeLength * (shapeS - 1),
	                            e:shapeData.totalShapeLength * (shapeE - 1)
	                        })
	                    }else{
	                        segments.push({
	                            s:shapeData.totalShapeLength * shapeS,
	                            e:shapeData.totalShapeLength
	                        })
	                        segments.push({
	                            s:0,
	                            e:shapeData.totalShapeLength*(shapeE - 1)
	                        })
	                    }
	                    var newShapesData = this.addShapes(shapeData,segments[0]);
	                    if (segments[0].s !== segments[0].e) {
	                        var lastPos;
	                        if(segments.length > 1){
	                            if(shapeData.shape.v.c){
	                                var lastShape = newShapesData.pop();
	                                this.addPaths(newShapesData, localShapeCollection);
	                                newShapesData = this.addShapes(shapeData,segments[1], lastShape);
	                            } else {
	                                this.addPaths(newShapesData, localShapeCollection);
	                                newShapesData = this.addShapes(shapeData,segments[1]);
	                            }
	                        } 
	                        this.addPaths(newShapesData, localShapeCollection);
	                    }
	                    
	                }
	                shapeData.shape.paths = localShapeCollection;
	            }
	        }
	    } else if(this.mdf){
	        for(i=0;i<len;i+=1){
	            this.shapes[i].shape.mdf = true;
	        }
	    }
	    if(!this.dynamicProperties.length){
	        this.mdf = false;
	    }
	}
	
	TrimModifier.prototype.addPaths = function(newPaths, localShapeCollection) {
	    var i, len = newPaths.length;
	    for(i = 0; i < len; i += 1) {
	        localShapeCollection.addShape(newPaths[i])
	    }
	}
	
	TrimModifier.prototype.addSegment = function(pt1,pt2,pt3,pt4,shapePath,pos, newShape) {
	    /*console.log(pt1, 'vertex: v, at: ', pos);
	    console.log(pt2, 'vertex: o, at: ', pos);
	    console.log(pt3, 'vertex: i, at: ', pos + 1);
	    console.log(pt4, 'vertex: v, at: ', pos + 1);
	    console.log('newShape: ', newShape);*/
	    shapePath.setXYAt(pt2[0],pt2[1],'o',pos);
	    shapePath.setXYAt(pt3[0],pt3[1],'i',pos + 1);
	    if(newShape){
	        shapePath.setXYAt(pt1[0],pt1[1],'v',pos);
	    }
	    shapePath.setXYAt(pt4[0],pt4[1],'v',pos + 1);
	}
	
	TrimModifier.prototype.addShapes = function(shapeData, shapeSegment, shapePath){
	    var pathsData = shapeData.pathsData;
	    var shapePaths = shapeData.shape.paths.shapes;
	    var i, len = shapeData.shape.paths._length, j, jLen;
	    var addedLength = 0;
	    var currentLengthData,segmentCount;
	    var lengths;
	    var segment;
	    var shapes = [];
	    var initPos;
	    var newShape = true;
	    if(!shapePath){
	        shapePath = shape_pool.newShape();
	        segmentCount = 0;
	        initPos = 0;
	    } else {
	        segmentCount = shapePath._length;
	        initPos = shapePath._length;
	    }
	    shapes.push(shapePath);
	    for(i=0;i<len;i+=1){
	        lengths = pathsData[i].lengths;
	        shapePath.c = shapePaths[i].c;
	        jLen = shapePaths[i].c ? lengths.length : lengths.length + 1;
	        for(j=1;j<jLen;j+=1){
	            currentLengthData = lengths[j-1];
	            if(addedLength + currentLengthData.addedLength < shapeSegment.s){
	                addedLength += currentLengthData.addedLength;
	                shapePath.c = false;
	            } else if(addedLength > shapeSegment.e){
	                shapePath.c = false;
	                break;
	            } else {
	                if(shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + currentLengthData.addedLength){
	                    this.addSegment(shapePaths[i].v[j-1],shapePaths[i].o[j-1],shapePaths[i].i[j],shapePaths[i].v[j],shapePath,segmentCount,newShape);
	                    newShape = false;
	                } else {
	                    segment = bez.getNewSegment(shapePaths[i].v[j-1],shapePaths[i].v[j],shapePaths[i].o[j-1],shapePaths[i].i[j], (shapeSegment.s - addedLength)/currentLengthData.addedLength,(shapeSegment.e - addedLength)/currentLengthData.addedLength, lengths[j-1]);
	                    this.addSegment(segment.pt1,segment.pt3,segment.pt4,segment.pt2,shapePath,segmentCount,newShape);
	                    newShape = false;
	                    shapePath.c = false;
	                }
	                addedLength += currentLengthData.addedLength;
	                segmentCount += 1;
	            }
	        }
	        if(shapePaths[i].c){
	            currentLengthData = lengths[j-1];
	            if(addedLength <= shapeSegment.e){
	                var segmentLength = lengths[j-1].addedLength;
	                if(shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + segmentLength){
	                    this.addSegment(shapePaths[i].v[j-1],shapePaths[i].o[j-1],shapePaths[i].i[0],shapePaths[i].v[0],shapePath,segmentCount,newShape);
	                    newShape = false;
	                }else{
	                    segment = bez.getNewSegment(shapePaths[i].v[j-1],shapePaths[i].v[0],shapePaths[i].o[j-1],shapePaths[i].i[0], (shapeSegment.s - addedLength)/segmentLength,(shapeSegment.e - addedLength)/segmentLength, lengths[j-1]);
	                    this.addSegment(segment.pt1,segment.pt3,segment.pt4,segment.pt2,shapePath,segmentCount,newShape);
	                    newShape = false;
	                    shapePath.c = false;
	                }
	            } else {
	                shapePath.c = false;
	            }
	            addedLength += currentLengthData.addedLength;
	            segmentCount += 1;
	        }
	        if(shapePath._length){
	            shapePath.setXYAt(shapePath.v[initPos][0],shapePath.v[initPos][1],'i',initPos);
	            shapePath.setXYAt(shapePath.v[shapePath._length - 1][0],shapePath.v[shapePath._length - 1][1],'o',shapePath._length - 1);
	        }
	        if(addedLength > shapeSegment.e){
	            break;
	        }
	        if(i<len-1){
	            shapePath = shape_pool.newShape();
	            newShape = true;
	            shapes.push(shapePath);
	            segmentCount = 0;
	        }
	    }
	    return shapes;
	
	}
	
	
	ShapeModifiers.registerModifier('tm',TrimModifier);
	function RoundCornersModifier(){};
	extendPrototype(ShapeModifier,RoundCornersModifier);
	RoundCornersModifier.prototype.processKeys = function(forceRender){
	    if(this.elem.globalData.frameId === this.frameId && !forceRender){
	        return;
	    }
	    this.mdf = forceRender ? true : false;
	    this.frameId = this.elem.globalData.frameId;
	    var i, len = this.dynamicProperties.length;
	
	    for(i=0;i<len;i+=1){
	        this.dynamicProperties[i].getValue();
	        if(this.dynamicProperties[i].mdf){
	            this.mdf = true;
	        }
	    }
	}
	RoundCornersModifier.prototype.initModifierProperties = function(elem,data){
	    this.getValue = this.processKeys;
	    this.rd = PropertyFactory.getProp(elem,data.r,0,null,this.dynamicProperties);
	    if(!this.dynamicProperties.length){
	        this.getValue(true);
	    }
	};
	
	RoundCornersModifier.prototype.processPath = function(path, round){
	    var cloned_path = shape_pool.newShape();
	    cloned_path.c = path.c;
	    var i, len = path._length;
	    var currentV,currentI,currentO,closerV, newV,newO,newI,distance,newPosPerc,index = 0;
	    var vX,vY,oX,oY,iX,iY;
	    for(i=0;i<len;i+=1){
	        currentV = path.v[i];
	        currentO = path.o[i];
	        currentI = path.i[i];
	        if(currentV[0]===currentO[0] && currentV[1]===currentO[1] && currentV[0]===currentI[0] && currentV[1]===currentI[1]){
	            if((i===0 || i === len - 1) && !path.c){
	                cloned_path.setTripleAt(currentV[0],currentV[1],currentO[0],currentO[1],currentI[0],currentI[1],index);
	                /*cloned_path.v[index] = currentV;
	                cloned_path.o[index] = currentO;
	                cloned_path.i[index] = currentI;*/
	                index += 1;
	            } else {
	                if(i===0){
	                    closerV = path.v[len-1];
	                } else {
	                    closerV = path.v[i-1];
	                }
	                distance = Math.sqrt(Math.pow(currentV[0]-closerV[0],2)+Math.pow(currentV[1]-closerV[1],2));
	                newPosPerc = distance ? Math.min(distance/2,round)/distance : 0;
	                vX = iX = currentV[0]+(closerV[0]-currentV[0])*newPosPerc;
	                vY = iY = currentV[1]-(currentV[1]-closerV[1])*newPosPerc;
	                oX = vX-(vX-currentV[0])*roundCorner;
	                oY = vY-(vY-currentV[1])*roundCorner;
	                cloned_path.setTripleAt(vX,vY,oX,oY,iX,iY,index);
	                index += 1;
	
	                if(i === len - 1){
	                    closerV = path.v[0];
	                } else {
	                    closerV = path.v[i+1];
	                }
	                distance = Math.sqrt(Math.pow(currentV[0]-closerV[0],2)+Math.pow(currentV[1]-closerV[1],2));
	                newPosPerc = distance ? Math.min(distance/2,round)/distance : 0;
	                vX = oX = currentV[0]+(closerV[0]-currentV[0])*newPosPerc;
	                vY = oY = currentV[1]+(closerV[1]-currentV[1])*newPosPerc;
	                iX = vX-(vX-currentV[0])*roundCorner;
	                iY = vY-(vY-currentV[1])*roundCorner;
	                cloned_path.setTripleAt(vX,vY,oX,oY,iX,iY,index);
	                index += 1;
	            }
	        } else {
	            cloned_path.setTripleAt(path.v[i][0],path.v[i][1],path.o[i][0],path.o[i][1],path.i[i][0],path.i[i][1],index);
	            index += 1;
	        }
	    }
	    return cloned_path;
	}
	
	RoundCornersModifier.prototype.processShapes = function(firstFrame){
	    var shapePaths;
	    var i, len = this.shapes.length;
	    var j, jLen;
	    var rd = this.rd.v;
	
	    if(rd !== 0){
	        var shapeData, newPaths, localShapeCollection;
	        for(i=0;i<len;i+=1){
	            shapeData = this.shapes[i];
	            newPaths = shapeData.shape.paths;
	            localShapeCollection = shapeData.localShapeCollection;
	            if(!(!shapeData.shape.mdf && !this.mdf && !firstFrame)){
	                localShapeCollection.releaseShapes();
	                shapeData.shape.mdf = true;
	                shapePaths = shapeData.shape.paths.shapes;
	                jLen = shapeData.shape.paths._length;
	                for(j=0;j<jLen;j+=1){
	                    localShapeCollection.addShape(this.processPath(shapePaths[j],rd));
	                }
	            }
	            shapeData.shape.paths = shapeData.localShapeCollection;
	        }
	
	    }
	    if(!this.dynamicProperties.length){
	        this.mdf = false;
	    }
	}
	
	
	ShapeModifiers.registerModifier('rd',RoundCornersModifier);
	function RepeaterModifier(){};
	RepeaterModifier.prototype.processKeys = function(forceRender){
	    if(this.elem.globalData.frameId === this.frameId && !forceRender){
	        return;
	    }
	    this.mdf = forceRender ? true : false;
	    var i, len = this.dynamicProperties.length;
	
	    for(i=0;i<len;i+=1){
	        this.dynamicProperties[i].getValue();
	        if(this.dynamicProperties[i].mdf){
	            this.mdf = true;
	        }
	    }
	};
	
	RepeaterModifier.prototype.initModifierProperties = function(elem,data){
	    this.getValue = this.processKeys;
	    this.c = PropertyFactory.getProp(elem,data.c,0,null,this.dynamicProperties);
	    this.o = PropertyFactory.getProp(elem,data.o,0,null,this.dynamicProperties);
	    this.tr = TransformPropertyFactory.getTransformProperty(elem,data.tr,this.dynamicProperties);
	    this.data = data;
	    if(!this.dynamicProperties.length){
	        this.getValue(true);
	    }
	    this.pMatrix = new Matrix();
	    this.rMatrix = new Matrix();
	    this.sMatrix = new Matrix();
	    this.tMatrix = new Matrix();
	    this.matrix = new Matrix();
	};
	
	RepeaterModifier.prototype.applyTransforms = function(pMatrix, rMatrix, sMatrix, transform, perc, inv){
	    var dir = inv ? -1 : 1;
	    var scaleX = transform.s.v[0] + (1 - transform.s.v[0]) * (1 - perc);
	    var scaleY = transform.s.v[1] + (1 - transform.s.v[1]) * (1 - perc);
	    pMatrix.translate(transform.p.v[0] * dir * perc, transform.p.v[1] * dir * perc, transform.p.v[2]);
	    rMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
	    rMatrix.rotate(-transform.r.v * dir * perc);
	    rMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
	    sMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
	    sMatrix.scale(inv ? 1/scaleX : scaleX, inv ? 1/scaleY : scaleY);
	    sMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
	}
	
	RepeaterModifier.prototype.init = function(elem, arr, pos, elemsData, dynamicProperties) {
	    this.elem = elem;
	    this.arr = arr;
	    this.pos = pos;
	    this.elemsData = elemsData;
	    this._currentCopies = 0;
	    this._elements = [];
	    this._groups = [];
	    this.dynamicProperties = [];
	    this.frameId = -1;
	    this.initModifierProperties(elem,arr[pos]);
	    var cont = 0;
	    while(pos>0){
	        pos -= 1;
	        //this._elements.unshift(arr.splice(pos,1)[0]);
	        this._elements.unshift(arr[pos]);
	        cont += 1;
	    }
	    if(this.dynamicProperties.length){
	        this.k = true;
	        dynamicProperties.push(this);
	    }else{
	        this.getValue(true);
	    }
	}
	
	RepeaterModifier.prototype.resetElements = function(elements){
	    var i, len = elements.length;
	    for(i = 0; i < len; i += 1) {
	        elements[i]._processed = false;
	        if(elements[i].ty === 'gr'){
	            this.resetElements(elements[i].it);
	        }
	    }
	}
	
	RepeaterModifier.prototype.cloneElements = function(elements){
	    var i, len = elements.length;
	    var newElements = JSON.parse(JSON.stringify(elements));
	    this.resetElements(newElements);
	    return newElements;
	}
	
	RepeaterModifier.prototype.changeGroupRender = function(elements, renderFlag) {
	    var i, len = elements.length;
	    for(i = 0; i < len ; i += 1) {
	        elements[i]._render = renderFlag;
	        if(elements[i].ty === 'gr') {
	            this.changeGroupRender(elements[i].it, renderFlag);
	        }
	    }
	}
	
	RepeaterModifier.prototype.processShapes = function(firstFrame){
	
	    if(this.elem.globalData.frameId === this.frameId){
	        return;
	    }
	    this.frameId = this.elem.globalData.frameId;
	    if(!this.dynamicProperties.length && !firstFrame){
	        this.mdf = false;
	    }
	    if(this.mdf){
	        var copies = Math.ceil(this.c.v);
	        if(this._groups.length < copies){
	            while(this._groups.length < copies){
	                var group = {
	                    it:this.cloneElements(this._elements),
	                    ty:'gr'
	                }
	                group.it.push({"a":{"a":0,"ix":1,"k":[0,0]},"nm":"Transform","o":{"a":0,"ix":7,"k":100},"p":{"a":0,"ix":2,"k":[0,0]},"r":{"a":0,"ix":6,"k":0},"s":{"a":0,"ix":3,"k":[100,100]},"sa":{"a":0,"ix":5,"k":0},"sk":{"a":0,"ix":4,"k":0},"ty":"tr"});
	                
	                this.arr.splice(0,0,group);
	                this._groups.splice(0,0,group);
	                this._currentCopies += 1;
	            }
	            this.elem.reloadShapes();
	        }
	        var i, cont = 0, renderFlag;
	        for(i = 0; i  <= this._groups.length - 1; i += 1){
	            renderFlag = cont < copies;
	            this._groups[i]._render = renderFlag;
	            this.changeGroupRender(this._groups[i].it, renderFlag);
	            cont += 1;
	        }
	        
	        this._currentCopies = copies;
	        this.elem.firstFrame = true;
	        ////
	
	        var offset = this.o.v;
	        var offsetModulo = offset%1;
	        var roundOffset = offset > 0 ? Math.floor(offset) : Math.ceil(offset);
	        var k;
	        var tMat = this.tr.v.props;
	        var pProps = this.pMatrix.props;
	        var rProps = this.rMatrix.props;
	        var sProps = this.sMatrix.props;
	        this.pMatrix.reset();
	        this.rMatrix.reset();
	        this.sMatrix.reset();
	        this.tMatrix.reset();
	        this.matrix.reset();
	        var iteration = 0;
	
	        if(offset > 0) {
	            while(iteration<roundOffset){
	                this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
	                iteration += 1;
	            }
	            if(offsetModulo){
	                this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, offsetModulo, false);
	                iteration += offsetModulo;
	            }
	        } else if(offset < 0) {
	            while(iteration>roundOffset){
	                this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, true);
	                iteration -= 1;
	            }
	            if(offsetModulo){
	                this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, - offsetModulo, true);
	                iteration -= offsetModulo;
	            }
	        }
	        i = this.data.m === 1 ? 0 : this._currentCopies - 1;
	        var dir = this.data.m === 1 ? 1 : -1;
	        cont = this._currentCopies;
	        while(cont){
	            if(iteration !== 0){
	                if((i !== 0 && dir === 1) || (i !== this._currentCopies - 1 && dir === -1)){
	                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
	                }
	                this.matrix.transform(rProps[0],rProps[1],rProps[2],rProps[3],rProps[4],rProps[5],rProps[6],rProps[7],rProps[8],rProps[9],rProps[10],rProps[11],rProps[12],rProps[13],rProps[14],rProps[15]);
	                this.matrix.transform(sProps[0],sProps[1],sProps[2],sProps[3],sProps[4],sProps[5],sProps[6],sProps[7],sProps[8],sProps[9],sProps[10],sProps[11],sProps[12],sProps[13],sProps[14],sProps[15]);
	                this.matrix.transform(pProps[0],pProps[1],pProps[2],pProps[3],pProps[4],pProps[5],pProps[6],pProps[7],pProps[8],pProps[9],pProps[10],pProps[11],pProps[12],pProps[13],pProps[14],pProps[15]);
	                var items = this.elemsData[i].it;
	                var itemsTransform = items[items.length - 1].transform.mProps.v.props;
	                var j, jLen = itemsTransform.length;
	                for(j=0;j<jLen;j+=1) {
	                    itemsTransform[j] = this.matrix.props[j];
	                }
	                this.matrix.reset();
	            } else {
	                this.matrix.reset();
	                var items = this.elemsData[i].it;
	                var itemsTransform = items[items.length - 1].transform.mProps.v.props;
	                var j, jLen = itemsTransform.length;
	                for(j=0;j<jLen;j+=1) {
	                    itemsTransform[j] = this.matrix.props[j];
	                }
	            }
	            iteration += 1;
	            cont -= 1;
	            i += dir;
	        }
	    }
	}
	
	RepeaterModifier.prototype.addShape = function(){}
	
	ShapeModifiers.registerModifier('rp',RepeaterModifier);
	function ShapeCollection(){
		this._length = 0;
		this._maxLength = 4;
		this.shapes = Array.apply(null,{length:this._maxLength});
	};
	
	ShapeCollection.prototype.addShape = function(shapeData){
		if(this._length === this._maxLength){
			this.shapes = this.shapes.concat(Array.apply(null,{length:this._maxLength}));
			this._maxLength *= 2;
		}
		this.shapes[this._length] = shapeData;
		this._length += 1;
	};
	
	ShapeCollection.prototype.releaseShapes = function(){
		var i;
		for(i = 0; i < this._length; i += 1) {
			shape_pool.release(this.shapes[i]);
		}
		this._length = 0;
	};
	function DashProperty(elem, data, renderer, dynamicProperties) {
	    this.elem = elem;
	    this.frameId = -1;
	    this.dataProps = Array.apply(null,{length:data.length});
	    this.renderer = renderer;
	    this.mdf = false;
	    this.k = false;
	    this.dashStr = '';
	    this.dashArray = createTypedArray('float32',  data.length - 1);
	    this.dashoffset = createTypedArray('float32',  1);
	    var i, len = data.length, prop;
	    for(i=0;i<len;i+=1){
	        prop = PropertyFactory.getProp(elem,data[i].v,0, 0, dynamicProperties);
	        this.k = prop.k ? true : this.k;
	        this.dataProps[i] = {n:data[i].n,p:prop};
	    }
	    if(this.k){
	        dynamicProperties.push(this);
	    }else{
	        this.getValue(true);
	    }
	}
	
	DashProperty.prototype.getValue = function(forceRender) {
	    if(this.elem.globalData.frameId === this.frameId && !forceRender){
	        return;
	    }
	    var i = 0, len = this.dataProps.length;
	    this.mdf = false;
	    this.frameId = this.elem.globalData.frameId;
	    while(i<len){
	        if(this.dataProps[i].p.mdf){
	            this.mdf = !forceRender;
	            break;
	        }
	        i+=1;
	    }
	    if(this.mdf || forceRender){
	        if(this.renderer === 'svg') {
	            this.dashStr = '';
	        }
	        for(i=0;i<len;i+=1){
	            if(this.dataProps[i].n != 'o'){
	                if(this.renderer === 'svg') {
	                    this.dashStr += ' ' + this.dataProps[i].p.v;
	                }else{
	                    this.dashArray[i] = this.dataProps[i].p.v;
	                }
	            }else{
	                this.dashoffset[0] = this.dataProps[i].p.v;
	            }
	        }
	    }
	}
	function GradientProperty(elem,data,arr){
	    this.prop = PropertyFactory.getProp(elem,data.k,1,null,[]);
	    this.data = data;
	    this.k = this.prop.k;
	    this.c = createTypedArray('uint8c', data.p*4)
	    var cLength = data.k.k[0].s ? (data.k.k[0].s.length - data.p*4) : data.k.k.length - data.p*4;
	    this.o = createTypedArray('float32', cLength);
	    this.cmdf = false;
	    this.omdf = false;
	    if(this.prop.k){
	        arr.push(this);
	    }
	    this.getValue(true);
	}
	
	GradientProperty.prototype.getValue = function(forceRender){
	    this.prop.getValue();
	    this.cmdf = false;
	    this.omdf = false;
	    if(this.prop.mdf || forceRender){
	        var i, len = this.data.p*4;
	        var mult, val;
	        for(i=0;i<len;i+=1){
	            mult = i%4 === 0 ? 100 : 255;
	            val = Math.round(this.prop.v[i]*mult);
	            if(this.c[i] !== val){
	                this.c[i] = val;
	                this.cmdf = !forceRender;
	            }
	        }
	        if(this.o.length){
	            len = this.prop.v.length;
	            for(i=this.data.p*4;i<len;i+=1){
	                mult = i%2 === 0 ? 100 : 1;
	                val = i%2 === 0 ?  Math.round(this.prop.v[i]*100):this.prop.v[i];
	                if(this.o[i-this.data.p*4] !== val){
	                    this.o[i-this.data.p*4] = val;
	                    this.omdf = !forceRender;
	                }
	            }
	        }
	    }
	}
	var ImagePreloader = (function(){
	
	    function imageLoaded(){
	        this.loadedAssets += 1;
	        if(this.loadedAssets === this.totalImages){
	            if(this.imagesLoadedCb) {
	                this.imagesLoadedCb(null);
	            }
	        }
	    }
	
	    function getAssetsPath(assetData){
	        var path = '';
	        if(this.assetsPath){
	            var imagePath = assetData.p;
	            if(imagePath.indexOf('images/') !== -1){
	                imagePath = imagePath.split('/')[1];
	            }
	            path = this.assetsPath + imagePath;
	        } else {
	            path = this.path;
	            path += assetData.u ? assetData.u : '';
	            path += assetData.p;
	        }
	        return path;
	    }
	
	    function loadImage(path){
	        var img = document.createElement('img');
	        img.addEventListener('load', imageLoaded.bind(this), false);
	        img.addEventListener('error', imageLoaded.bind(this), false);
	        img.src = path;
	    }
	    function loadAssets(assets, cb){
	        this.imagesLoadedCb = cb;
	        this.totalAssets = assets.length;
	        var i;
	        for(i=0;i<this.totalAssets;i+=1){
	            if(!assets[i].layers){
	                loadImage.bind(this)(getAssetsPath.bind(this)(assets[i]));
	                this.totalImages += 1;
	            }
	        }
	    }
	
	    function setPath(path){
	        this.path = path || '';
	    }
	
	    function setAssetsPath(path){
	        this.assetsPath = path || '';
	    }
	
	    function destroy() {
	        this.imagesLoadedCb = null;
	    }
	
	    return function ImagePreloader(){
	        this.loadAssets = loadAssets;
	        this.setAssetsPath = setAssetsPath;
	        this.setPath = setPath;
	        this.destroy = destroy;
	        this.assetsPath = '';
	        this.path = '';
	        this.totalAssets = 0;
	        this.totalImages = 0;
	        this.loadedAssets = 0;
	        this.imagesLoadedCb = null;
	    }
	}());
	var featureSupport = (function(){
		var ob = {
			maskType: true
		}
		if (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) {
		   ob.maskType = false;
		}
		return ob;
	}());
	var filtersFactory = (function(){
		var ob = {};
		ob.createFilter = createFilter;
		ob.createAlphaToLuminanceFilter = createAlphaToLuminanceFilter;
	
		function createFilter(filId){
	        	var fil = createNS('filter');
	        	fil.setAttribute('id',filId);
	                fil.setAttribute('filterUnits','objectBoundingBox');
	                fil.setAttribute('x','0%');
	                fil.setAttribute('y','0%');
	                fil.setAttribute('width','100%');
	                fil.setAttribute('height','100%');
	                return fil;
		}
	
		function createAlphaToLuminanceFilter(){
	                var feColorMatrix = createNS('feColorMatrix');
	                feColorMatrix.setAttribute('type','matrix');
	                feColorMatrix.setAttribute('color-interpolation-filters','sRGB');
	                feColorMatrix.setAttribute('values','0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1');
	                return feColorMatrix;
		}
	
		return ob;
	}())
	function TextAnimatorProperty(textData, renderType, elem){
	    this.mdf = false;
	    this._firstFrame = true;
		this._hasMaskedPath = false;
		this._frameId = -1;
		this._dynamicProperties = [];
		this._textData = textData;
		this._renderType = renderType;
		this._elem = elem;
		this._animatorsData = Array.apply(null,{length:this._textData.a.length});
		this._pathData = {}
		this._moreOptions = {
			alignment: {}
		};
		this.renderedLetters = [];
	    this.lettersChangedFlag = false;
	
	}
	
	TextAnimatorProperty.prototype.searchProperties = function(dynamicProperties){
	    var i, len = this._textData.a.length, animatorData, animatorProps;
	    var getProp = PropertyFactory.getProp;
	    for(i=0;i<len;i+=1){
	        animatorProps = this._textData.a[i];
	        animatorData = {
	            a: {},
	            s: {}
	        };
	        if('r' in animatorProps.a) {
	            animatorData.a.r = getProp(this._elem,animatorProps.a.r,0,degToRads,this._dynamicProperties);
	        }
	        if('rx' in animatorProps.a) {
	            animatorData.a.rx = getProp(this._elem,animatorProps.a.rx,0,degToRads,this._dynamicProperties);
	        }
	        if('ry' in animatorProps.a) {
	            animatorData.a.ry = getProp(this._elem,animatorProps.a.ry,0,degToRads,this._dynamicProperties);
	        }
	        if('sk' in animatorProps.a) {
	            animatorData.a.sk = getProp(this._elem,animatorProps.a.sk,0,degToRads,this._dynamicProperties);
	        }
	        if('sa' in animatorProps.a) {
	            animatorData.a.sa = getProp(this._elem,animatorProps.a.sa,0,degToRads,this._dynamicProperties);
	        }
	        if('s' in animatorProps.a) {
	            animatorData.a.s = getProp(this._elem,animatorProps.a.s,1,0.01,this._dynamicProperties);
	        }
	        if('a' in animatorProps.a) {
	            animatorData.a.a = getProp(this._elem,animatorProps.a.a,1,0,this._dynamicProperties);
	        }
	        if('o' in animatorProps.a) {
	            animatorData.a.o = getProp(this._elem,animatorProps.a.o,0,0.01,this._dynamicProperties);
	        }
	        if('p' in animatorProps.a) {
	            animatorData.a.p = getProp(this._elem,animatorProps.a.p,1,0,this._dynamicProperties);
	        }
	        if('sw' in animatorProps.a) {
	            animatorData.a.sw = getProp(this._elem,animatorProps.a.sw,0,0,this._dynamicProperties);
	        }
	        if('sc' in animatorProps.a) {
	            animatorData.a.sc = getProp(this._elem,animatorProps.a.sc,1,0,this._dynamicProperties);
	        }
	        if('fc' in animatorProps.a) {
	            animatorData.a.fc = getProp(this._elem,animatorProps.a.fc,1,0,this._dynamicProperties);
	        }
	        if('fh' in animatorProps.a) {
	            animatorData.a.fh = getProp(this._elem,animatorProps.a.fh,0,0,this._dynamicProperties);
	        }
	        if('fs' in animatorProps.a) {
	            animatorData.a.fs = getProp(this._elem,animatorProps.a.fs,0,0.01,this._dynamicProperties);
	        }
	        if('fb' in animatorProps.a) {
	            animatorData.a.fb = getProp(this._elem,animatorProps.a.fb,0,0.01,this._dynamicProperties);
	        }
	        if('t' in animatorProps.a) {
	            animatorData.a.t = getProp(this._elem,animatorProps.a.t,0,0,this._dynamicProperties);
	        }
	        animatorData.s = TextSelectorProp.getTextSelectorProp(this._elem,animatorProps.s,this._dynamicProperties);
	        animatorData.s.t = animatorProps.s.t;
	        this._animatorsData[i] = animatorData;
	    }
	    if(this._textData.p && 'm' in this._textData.p){
	        this._pathData = {
	            f: getProp(this._elem,this._textData.p.f,0,0,this._dynamicProperties),
	            l: getProp(this._elem,this._textData.p.l,0,0,this._dynamicProperties),
	            r: this._textData.p.r,
	            m: this._elem.maskManager.getMaskProperty(this._textData.p.m)
	        };
	        this._hasMaskedPath = true;
	    } else {
	        this._hasMaskedPath = false;
	    }
	    this._moreOptions.alignment = getProp(this._elem,this._textData.m.a,1,0,this._dynamicProperties);
	    if(this._dynamicProperties.length) {
	    	dynamicProperties.push(this);
	    }
	}
	
	TextAnimatorProperty.prototype.getMeasures = function(documentData, lettersChangedFlag){
	    this.lettersChangedFlag = lettersChangedFlag;
	    if(!this.mdf && !this._firstFrame && !lettersChangedFlag && (!this._hasMaskedPath || !this._pathData.m.mdf)) {
	        return;
	    }
	    this._firstFrame = false;
	    var alignment = this._moreOptions.alignment.v;
	    var animators = this._animatorsData;
	    var textData = this._textData;
	    var matrixHelper = this.mHelper;
	    var renderType = this._renderType;
	    var renderedLettersCount = this.renderedLetters.length;
	    var data = this.data;
	    var xPos,yPos;
	    var i, len;
	    var letters = documentData.l;
	    if(this._hasMaskedPath) {
	        var mask = this._pathData.m;
	        if(!this._pathData.n || this._pathData.mdf){
	            var paths = mask.v;
	            if(this._pathData.r){
	                paths = paths.reverse();
	            }
	            var pathInfo = {
	                tLength: 0,
	                segments: []
	            };
	            len = paths._length - 1;
	            var pathData;
	            var totalLength = 0;
	            for (i = 0; i < len; i += 1) {
	                pathData = {
	                    s: paths.v[i],
	                    e: paths.v[i + 1],
	                    to: [paths.o[i][0] - paths.v[i][0], paths.o[i][1] - paths.v[i][1]],
	                    ti: [paths.i[i + 1][0] - paths.v[i + 1][0], paths.i[i + 1][1] - paths.v[i + 1][1]]
	                };
	                bez.buildBezierData(pathData);
	                pathInfo.tLength += pathData.bezierData.segmentLength;
	                pathInfo.segments.push(pathData);
	                totalLength += pathData.bezierData.segmentLength;
	            }
	            i = len;
	            if (mask.v.c) {
	                pathData = {
	                    s: paths.v[i],
	                    e: paths.v[0],
	                    to: [paths.o[i][0] - paths.v[i][0], paths.o[i][1] - paths.v[i][1]],
	                    ti: [paths.i[0][0] - paths.v[0][0], paths.i[0][1] - paths.v[0][1]]
	                };
	                bez.buildBezierData(pathData);
	                pathInfo.tLength += pathData.bezierData.segmentLength;
	                pathInfo.segments.push(pathData);
	                totalLength += pathData.bezierData.segmentLength;
	            }
	            this._pathData.pi = pathInfo;
	        }
	        var pathInfo = this._pathData.pi;
	
	        var currentLength = this._pathData.f.v, segmentInd = 0, pointInd = 1, currentPoint, prevPoint, points;
	        var segmentLength = 0, flag = true;
	        var segments = pathInfo.segments;
	        if (currentLength < 0 && mask.v.c) {
	            if (pathInfo.tLength < Math.abs(currentLength)) {
	                currentLength = -Math.abs(currentLength) % pathInfo.tLength;
	            }
	            segmentInd = segments.length - 1;
	            points = segments[segmentInd].bezierData.points;
	            pointInd = points.length - 1;
	            while (currentLength < 0) {
	                currentLength += points[pointInd].partialLength;
	                pointInd -= 1;
	                if (pointInd < 0) {
	                    segmentInd -= 1;
	                    points = segments[segmentInd].bezierData.points;
	                    pointInd = points.length - 1;
	                }
	            }
	
	        }
	        points = segments[segmentInd].bezierData.points;
	        prevPoint = points[pointInd - 1];
	        currentPoint = points[pointInd];
	        var partialLength = currentPoint.partialLength;
	        var perc, tanAngle;
	    }
	
	
	    len = letters.length;
	    xPos = 0;
	    yPos = 0;
	    var yOff = documentData.s*1.2*.714;
	    var firstLine = true;
	    var animatorProps, animatorSelector;
	    var j, jLen;
	    var letterValue;
	
	    jLen = animators.length;
	    //Todo Confirm this is not necessary here. Text Animator Selectors should not be called without a text index. And it is later correctly called.
	    /*if (lettersChangedFlag) {
	        for (j = 0; j < jLen; j += 1) {
	            animatorSelector = animators[j].s;
	            //animatorSelector.getValue(true);
	        }
	    }*/
	    var lastLetter;
	
	    var mult, ind = -1, offf, xPathPos, yPathPos;
	    var initPathPos = currentLength,initSegmentInd = segmentInd, initPointInd = pointInd, currentLine = -1;
	    var elemOpacity;
	    var sc,sw,fc,k;
	    var lineLength = 0;
	    var letterSw,letterSc,letterFc,letterM = '',letterP = this.defaultPropsArray,letterO;
	    for( i = 0; i < len; i += 1) {
	        matrixHelper.reset();
	        elemOpacity = 1;
	        if(letters[i].n) {
	            xPos = 0;
	            yPos += documentData.yOffset;
	            yPos += firstLine ? 1 : 0;
	            currentLength = initPathPos ;
	            firstLine = false;
	            lineLength = 0;
	            if(this._hasMaskedPath) {
	                segmentInd = initSegmentInd;
	                pointInd = initPointInd;
	                points = segments[segmentInd].bezierData.points;
	                prevPoint = points[pointInd - 1];
	                currentPoint = points[pointInd];
	                partialLength = currentPoint.partialLength;
	                segmentLength = 0;
	            }
	            letterO = letterSw = letterFc = letterM = '';
	            letterP = this.defaultPropsArray;
	        }else{
	            if(this._hasMaskedPath) {
	                if(currentLine !== letters[i].line){
	                    switch(documentData.j){
	                        case 1:
	                            currentLength += totalLength - documentData.lineWidths[letters[i].line];
	                            break;
	                        case 2:
	                            currentLength += (totalLength - documentData.lineWidths[letters[i].line])/2;
	                            break;
	                    }
	                    currentLine = letters[i].line;
	                }
	                if (ind !== letters[i].ind) {
	                    if (letters[ind]) {
	                        currentLength += letters[ind].extra;
	                    }
	                    currentLength += letters[i].an / 2;
	                    ind = letters[i].ind;
	                }
	                currentLength += alignment[0] * letters[i].an / 200;
	                var animatorOffset = 0;
	                for (j = 0; j < jLen; j += 1) {
	                    animatorProps = animators[j].a;
	                    if ('p' in animatorProps) {
	                        animatorSelector = animators[j].s;
	                        mult = animatorSelector.getMult(letters[i].anIndexes[j],textData.a[j].s.totalChars);
	                        if(mult.length){
	                            animatorOffset += animatorProps.p.v[0] * mult[0];
	                        } else{
	                            animatorOffset += animatorProps.p.v[0] * mult;
	                        }
	
	                    }
	                    if ('a' in animatorProps) {
	                        animatorSelector = animators[j].s;
	                        mult = animatorSelector.getMult(letters[i].anIndexes[j],textData.a[j].s.totalChars);
	                        if(mult.length){
	                            animatorOffset += animatorProps.a.v[0] * mult[0];
	                        } else{
	                            animatorOffset += animatorProps.a.v[0] * mult;
	                        }
	
	                    }
	                }
	                flag = true;
	                while (flag) {
	                    if (segmentLength + partialLength >= currentLength + animatorOffset || !points) {
	                        perc = (currentLength + animatorOffset - segmentLength) / currentPoint.partialLength;
	                        xPathPos = prevPoint.point[0] + (currentPoint.point[0] - prevPoint.point[0]) * perc;
	                        yPathPos = prevPoint.point[1] + (currentPoint.point[1] - prevPoint.point[1]) * perc;
	                        matrixHelper.translate(-alignment[0]*letters[i].an/200, -(alignment[1] * yOff / 100));
	                        flag = false;
	                    } else if (points) {
	                        segmentLength += currentPoint.partialLength;
	                        pointInd += 1;
	                        if (pointInd >= points.length) {
	                            pointInd = 0;
	                            segmentInd += 1;
	                            if (!segments[segmentInd]) {
	                                if (mask.v.c) {
	                                    pointInd = 0;
	                                    segmentInd = 0;
	                                    points = segments[segmentInd].bezierData.points;
	                                } else {
	                                    segmentLength -= currentPoint.partialLength;
	                                    points = null;
	                                }
	                            } else {
	                                points = segments[segmentInd].bezierData.points;
	                            }
	                        }
	                        if (points) {
	                            prevPoint = currentPoint;
	                            currentPoint = points[pointInd];
	                            partialLength = currentPoint.partialLength;
	                        }
	                    }
	                }
	                offf = letters[i].an / 2 - letters[i].add;
	                matrixHelper.translate(-offf, 0, 0);
	            } else {
	                offf = letters[i].an/2 - letters[i].add;
	                matrixHelper.translate(-offf,0,0);
	
	                // Grouping alignment
	                matrixHelper.translate(-alignment[0]*letters[i].an/200, -alignment[1]*yOff/100, 0);
	            }
	
	            lineLength += letters[i].l/2;
	            for(j=0;j<jLen;j+=1){
	                animatorProps = animators[j].a;
	                if ('t' in animatorProps) {
	                    animatorSelector = animators[j].s;
	                    mult = animatorSelector.getMult(letters[i].anIndexes[j],textData.a[j].s.totalChars);
	                    if(this._hasMaskedPath) {
	                        if(mult.length) {
	                            currentLength += animatorProps.t*mult[0];
	                        } else {
	                            currentLength += animatorProps.t*mult;
	                        }
	                    }else{
	                        if(mult.length) {
	                            xPos += animatorProps.t.v*mult[0];
	                        } else {
	                            xPos += animatorProps.t.v*mult;
	                        }
	                    }
	                }
	            }
	            lineLength += letters[i].l/2;
	            if(documentData.strokeWidthAnim) {
	                sw = documentData.sw || 0;
	            }
	            if(documentData.strokeColorAnim) {
	                if(documentData.sc){
	                    sc = [documentData.sc[0], documentData.sc[1], documentData.sc[2]];
	                }else{
	                    sc = [0,0,0];
	                }
	            }
	            if(documentData.fillColorAnim && documentData.fc) {
	                fc = [documentData.fc[0], documentData.fc[1], documentData.fc[2]];
	            }
	            for(j=0;j<jLen;j+=1){
	                animatorProps = animators[j].a;
	                if ('a' in animatorProps) {
	                    animatorSelector = animators[j].s;
	                    mult = animatorSelector.getMult(letters[i].anIndexes[j],textData.a[j].s.totalChars);
	
	                    if(mult.length){
	                        matrixHelper.translate(-animatorProps.a.v[0]*mult[0], -animatorProps.a.v[1]*mult[1], animatorProps.a.v[2]*mult[2]);
	                    } else {
	                        matrixHelper.translate(-animatorProps.a.v[0]*mult, -animatorProps.a.v[1]*mult, animatorProps.a.v[2]*mult);
	                    }
	                }
	            }
	            for(j=0;j<jLen;j+=1){
	                animatorProps = animators[j].a;
	                if ('s' in animatorProps) {
	                    animatorSelector = animators[j].s;
	                    mult = animatorSelector.getMult(letters[i].anIndexes[j],textData.a[j].s.totalChars);
	                    if(mult.length){
	                        matrixHelper.scale(1+((animatorProps.s.v[0]-1)*mult[0]),1+((animatorProps.s.v[1]-1)*mult[1]),1);
	                    } else {
	                        matrixHelper.scale(1+((animatorProps.s.v[0]-1)*mult),1+((animatorProps.s.v[1]-1)*mult),1);
	                    }
	                }
	            }
	            for(j=0;j<jLen;j+=1) {
	                animatorProps = animators[j].a;
	                animatorSelector = animators[j].s;
	                mult = animatorSelector.getMult(letters[i].anIndexes[j],textData.a[j].s.totalChars);
	                if ('sk' in animatorProps) {
	                    if(mult.length) {
	                        matrixHelper.skewFromAxis(-animatorProps.sk.v * mult[0], animatorProps.sa.v * mult[1]);
	                    } else {
	                        matrixHelper.skewFromAxis(-animatorProps.sk.v * mult, animatorProps.sa.v * mult);
	                    }
	                }
	                if ('r' in animatorProps) {
	                    if(mult.length) {
	                        matrixHelper.rotateZ(-animatorProps.r.v * mult[2]);
	                    } else {
	                        matrixHelper.rotateZ(-animatorProps.r.v * mult);
	                    }
	                }
	                if ('ry' in animatorProps) {
	
	                    if(mult.length) {
	                        matrixHelper.rotateY(animatorProps.ry.v*mult[1]);
	                    }else{
	                        matrixHelper.rotateY(animatorProps.ry.v*mult);
	                    }
	                }
	                if ('rx' in animatorProps) {
	                    if(mult.length) {
	                        matrixHelper.rotateX(animatorProps.rx.v*mult[0]);
	                    } else {
	                        matrixHelper.rotateX(animatorProps.rx.v*mult);
	                    }
	                }
	                if ('o' in animatorProps) {
	                    if(mult.length) {
	                        elemOpacity += ((animatorProps.o.v)*mult[0] - elemOpacity)*mult[0];
	                    } else {
	                        elemOpacity += ((animatorProps.o.v)*mult - elemOpacity)*mult;
	                    }
	                }
	                if (documentData.strokeWidthAnim && 'sw' in animatorProps) {
	                    if(mult.length) {
	                        sw += animatorProps.sw.v*mult[0];
	                    } else {
	                        sw += animatorProps.sw.v*mult;
	                    }
	                }
	                if (documentData.strokeColorAnim && 'sc' in animatorProps) {
	                    for(k=0;k<3;k+=1){
	                        if(mult.length) {
	                            sc[k] = sc[k] + (animatorProps.sc.v[k] - sc[k])*mult[0]
	                        } else {
	                            sc[k] = sc[k] + (animatorProps.sc.v[k] - sc[k])*mult;
	                        }
	                    }
	                }
	                if (documentData.fillColorAnim && documentData.fc) {
	                    if('fc' in animatorProps){
	                        for(k=0;k<3;k+=1){
	                            if(mult.length) {
	                                fc[k] = fc[k] + (animatorProps.fc.v[k] - fc[k])*mult[0];
	                            } else {
	                                fc[k] = fc[k] + (animatorProps.fc.v[k] - fc[k])*mult;
	                            }
	                        }
	                    }
	                    if('fh' in animatorProps){
	                        if(mult.length) {
	                            fc = addHueToRGB(fc,animatorProps.fh.v*mult[0]);
	                        } else {
	                            fc = addHueToRGB(fc,animatorProps.fh.v*mult);
	                        }
	                    }
	                    if('fs' in animatorProps){
	                        if(mult.length) {
	                            fc = addSaturationToRGB(fc,animatorProps.fs.v*mult[0]);
	                        } else {
	                            fc = addSaturationToRGB(fc,animatorProps.fs.v*mult);
	                        }
	                    }
	                    if('fb' in animatorProps){
	                        if(mult.length) {
	                            fc = addBrightnessToRGB(fc,animatorProps.fb.v*mult[0]);
	                        } else {
	                            fc = addBrightnessToRGB(fc,animatorProps.fb.v*mult);
	                        }
	                    }
	                }
	            }
	
	            for(j=0;j<jLen;j+=1){
	                animatorProps = animators[j].a;
	
	                if ('p' in animatorProps) {
	                    animatorSelector = animators[j].s;
	                    mult = animatorSelector.getMult(letters[i].anIndexes[j],textData.a[j].s.totalChars);
	                    if(this._hasMaskedPath) {
	                        if(mult.length) {
	                            matrixHelper.translate(0, animatorProps.p.v[1] * mult[0], -animatorProps.p.v[2] * mult[1]);
	                        } else {
	                            matrixHelper.translate(0, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
	                        }
	                    }else{
	                        if(mult.length) {
	                            matrixHelper.translate(animatorProps.p.v[0] * mult[0], animatorProps.p.v[1] * mult[1], -animatorProps.p.v[2] * mult[2]);
	                        } else {
	                            matrixHelper.translate(animatorProps.p.v[0] * mult, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
	                        }
	                    }
	                }
	            }
	            if(documentData.strokeWidthAnim){
	                letterSw = sw < 0 ? 0 : sw;
	            }
	            if(documentData.strokeColorAnim){
	                letterSc = 'rgb('+Math.round(sc[0]*255)+','+Math.round(sc[1]*255)+','+Math.round(sc[2]*255)+')';
	            }
	            if(documentData.fillColorAnim && documentData.fc){
	                letterFc = 'rgb('+Math.round(fc[0]*255)+','+Math.round(fc[1]*255)+','+Math.round(fc[2]*255)+')';
	            }
	
	            if(this._hasMaskedPath) {
	                matrixHelper.translate(0,-documentData.ls);
	
	                matrixHelper.translate(0, alignment[1]*yOff/100 + yPos,0);
	                if (textData.p.p) {
	                    tanAngle = (currentPoint.point[1] - prevPoint.point[1]) / (currentPoint.point[0] - prevPoint.point[0]);
	                    var rot = Math.atan(tanAngle) * 180 / Math.PI;
	                    if (currentPoint.point[0] < prevPoint.point[0]) {
	                        rot += 180;
	                    }
	                    matrixHelper.rotate(-rot * Math.PI / 180);
	                }
	                matrixHelper.translate(xPathPos, yPathPos, 0);
	                currentLength -= alignment[0]*letters[i].an/200;
	                if(letters[i+1] && ind !== letters[i+1].ind){
	                    currentLength += letters[i].an / 2;
	                    currentLength += documentData.tr/1000*documentData.s;
	                }
	            }else{
	
	                matrixHelper.translate(xPos,yPos,0);
	
	                if(documentData.ps){
	                    //matrixHelper.translate(documentData.ps[0],documentData.ps[1],0);
	                    matrixHelper.translate(documentData.ps[0],documentData.ps[1] + documentData.ascent,0);
	                }
	                switch(documentData.j){
	                    case 1:
	                        matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line]),0,0);
	                        break;
	                    case 2:
	                        matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line])/2,0,0);
	                        break;
	                }
	                matrixHelper.translate(0,-documentData.ls);
	                matrixHelper.translate(offf,0,0);
	                matrixHelper.translate(alignment[0]*letters[i].an/200,alignment[1]*yOff/100,0);
	                xPos += letters[i].l + documentData.tr/1000*documentData.s;
	            }
	            if(renderType === 'html'){
	                letterM = matrixHelper.toCSS();
	            }else if(renderType === 'svg'){
	                letterM = matrixHelper.to2dCSS();
	            }else{
	                letterP = [matrixHelper.props[0],matrixHelper.props[1],matrixHelper.props[2],matrixHelper.props[3],matrixHelper.props[4],matrixHelper.props[5],matrixHelper.props[6],matrixHelper.props[7],matrixHelper.props[8],matrixHelper.props[9],matrixHelper.props[10],matrixHelper.props[11],matrixHelper.props[12],matrixHelper.props[13],matrixHelper.props[14],matrixHelper.props[15]];
	            }
	            letterO = elemOpacity;
	        }
	
	        if(renderedLettersCount <= i) {
	            letterValue = new LetterProps(letterO,letterSw,letterSc,letterFc,letterM,letterP);
	            this.renderedLetters.push(letterValue);
	            renderedLettersCount += 1;
	            this.lettersChangedFlag = true;
	        } else {
	            letterValue = this.renderedLetters[i];
	            this.lettersChangedFlag = letterValue.update(letterO, letterSw, letterSc, letterFc, letterM, letterP) || this.lettersChangedFlag;
	        }
	    }
	}
	
	TextAnimatorProperty.prototype.getValue = function(){
		if(this._elem.globalData.frameId === this._frameId){
	        return;
	    }
	    this._frameId = this._elem.globalData.frameId;
		var i, len = this._dynamicProperties.length;
	    this.mdf = false;
		for(i = 0; i < len; i += 1) {
			this._dynamicProperties[i].getValue();
	        this.mdf = this._dynamicProperties[i].mdf || this.mdf;
		}
	}
	
	TextAnimatorProperty.prototype.mHelper = new Matrix();
	TextAnimatorProperty.prototype.defaultPropsArray = [];
	function LetterProps(o, sw, sc, fc, m, p){
	    this.o = o;
	    this.sw = sw;
	    this.sc = sc;
	    this.fc = fc;
	    this.m = m;
	    this.p = p;
	    this.mdf = {
	    	o: true,
	    	sw: !!sw,
	    	sc: !!sc,
	    	fc: !!fc,
	    	m: true,
	    	p: true
	    };
	}
	
	LetterProps.prototype.update = function(o, sw, sc, fc, m, p) {
		this.mdf.o = false;
		this.mdf.sw = false;
		this.mdf.sc = false;
		this.mdf.fc = false;
		this.mdf.m = false;
		this.mdf.p = false;
		var updated = false;
	
		if(this.o !== o) {
			this.o = o;
			this.mdf.o = true;
			updated = true;
		}
		if(this.sw !== sw) {
			this.sw = sw;
			this.mdf.sw = true;
			updated = true;
		}
		if(this.sc !== sc) {
			this.sc = sc;
			this.mdf.sc = true;
			updated = true;
		}
		if(this.fc !== fc) {
			this.fc = fc;
			this.mdf.fc = true;
			updated = true;
		}
		if(this.m !== m) {
			this.m = m;
			this.mdf.m = true;
			updated = true;
		}
		if(p.length && (this.p[0] !== p[0] || this.p[1] !== p[1] || this.p[4] !== p[4] || this.p[5] !== p[5] || this.p[12] !== p[12] || this.p[13] !== p[13])) {
			this.p = p;
			this.mdf.p = true;
			updated = true;
		}
		return updated;
	}
	function TextProperty(elem, data, dynamicProperties){
		this._frameId = -99999;
		this.pv = '';
		this.v = '';
		this.kf = false;
		this.firstFrame = true;
		this.mdf = true;
		this.data = data;
		this.elem = elem;
		this.keysIndex = -1;
		this.currentData = {
			ascent: 0,
	        boxWidth: [0,0],
	        f: '',
	        fStyle: '',
	        fWeight: '',
	        fc: '',
	        j: '',
	        justifyOffset: '',
	        l: [],
	        lh: 0,
	        lineWidths: [],
	        ls: '',
	        of: '',
	        s: '',
	        sc: '',
	        sw: 0,
	        t: 0,
	        tr: 0,
	        sz:0,
	        ps:[0,0],
	        fillColorAnim: false,
	        strokeColorAnim: false,
	        strokeWidthAnim: false,
	        yOffset: 0,
	        __complete: false
	
		}
		if(this.searchProperty()) {
			dynamicProperties.push(this);
		} else {
			this.getValue(true);
		}
	}
	
	TextProperty.prototype.setCurrentData = function(data){
			var currentData = this.currentData;
	        currentData.ascent = data.ascent;
	        currentData.boxWidth = data.boxWidth ? data.boxWidth : currentData.boxWidth;
	        currentData.f = data.f;
	        currentData.fStyle = data.fStyle;
	        currentData.fWeight = data.fWeight;
	        currentData.fc = data.fc;
	        currentData.j = data.j;
	        currentData.justifyOffset = data.justifyOffset;
	        currentData.l = data.l;
	        currentData.lh = data.lh;
	        currentData.lineWidths = data.lineWidths;
	        currentData.ls = data.ls;
	        currentData.of = data.of;
	        currentData.s = data.s;
	        currentData.sc = data.sc;
	        currentData.sw = data.sw;
	        currentData.sz = data.sz;
	        currentData.ps = data.ps;
	        currentData.t = data.t;
	        currentData.tr = data.tr;
	        currentData.fillColorAnim = data.fillColorAnim || currentData.fillColorAnim;
	        currentData.strokeColorAnim = data.strokeColorAnim || currentData.strokeColorAnim;
	        currentData.strokeWidthAnim = data.strokeWidthAnim || currentData.strokeWidthAnim;
	        currentData.yOffset = data.yOffset;
	        currentData.__complete = false;
	}
	
	TextProperty.prototype.searchProperty = function() {
		this.kf = this.data.d.k.length > 1;
		return this.kf;
	}
	
	TextProperty.prototype.getValue = function() {
		this.mdf = false;
		var frameId = this.elem.globalData.frameId;
		if((frameId === this._frameId || !this.kf) && !this.firstFrame) {
			return;
		}
		var textKeys = this.data.d.k, textDocumentData;
	    var i = 0, len = textKeys.length;
	    while(i <= len - 1) {
	        textDocumentData = textKeys[i].s;
	        if(i === len - 1 || textKeys[i+1].t > frameId){
	            break;
	        }
	        i += 1;
	    }
	    if(this.keysIndex !== i) {
	    	if(!textDocumentData.__complete) {
	            this.completeTextData(textDocumentData);
	        }
	        this.setCurrentData(textDocumentData);
	        this.mdf = this.firstFrame ? false : true;
	        this.pv = this.v = this.currentData.t;
	        this.keysIndex = i;
	    }
		this._frameId = frameId;
	}
	
	TextProperty.prototype.completeTextData = function(documentData) {
	    documentData.__complete = true;
	    var fontManager = this.elem.globalData.fontManager;
	    var data = this.data;
	    var letters = [];
	    var i, len;
	    var newLineFlag, index = 0, val;
	    var anchorGrouping = data.m.g;
	    var currentSize = 0, currentPos = 0, currentLine = 0, lineWidths = [];
	    var lineWidth = 0;
	    var maxLineWidth = 0;
	    var j, jLen;
	    var fontData = fontManager.getFontByName(documentData.f);
	    var charData, cLength = 0;
	    var styles = fontData.fStyle.split(' ');
	
	    var fWeight = 'normal', fStyle = 'normal';
	    len = styles.length;
	    var styleName;
	    for(i=0;i<len;i+=1){
	        styleName = styles[i].toLowerCase();
	        switch(styleName) {
	            case 'italic':
	            fStyle = 'italic';
	            break;
	            case 'bold':
	            fWeight = '700';
	            break;
	            case 'black':
	            fWeight = '900';
	            break;
	            case 'medium':
	            fWeight = '500';
	            break;
	            case 'regular':
	            case 'normal':
	            fWeight = '400';
	            case 'light':
	            case 'thin':
	            fWeight = '200';
	            break;
	        }
	    }
	    documentData.fWeight = fWeight;
	    documentData.fStyle = fStyle;
	    len = documentData.t.length;
	    var trackingOffset = documentData.tr/1000*documentData.s;
	    if(documentData.sz){
	        var boxWidth = documentData.sz[0];
	        var lastSpaceIndex = -1;
	        for(i=0;i<len;i+=1){
	            newLineFlag = false;
	            if(documentData.t.charAt(i) === ' '){
	                lastSpaceIndex = i;
	            }else if(documentData.t.charCodeAt(i) === 13){
	                lineWidth = 0;
	                newLineFlag = true;
	            }
	            if(fontManager.chars){
	                charData = fontManager.getCharData(documentData.t.charAt(i), fontData.fStyle, fontData.fFamily);
	                cLength = newLineFlag ? 0 : charData.w*documentData.s/100;
	            }else{
	                //tCanvasHelper.font = documentData.s + 'px '+ fontData.fFamily;
	                cLength = fontManager.measureText(documentData.t.charAt(i), documentData.f, documentData.s);
	            }
	            if(lineWidth + cLength > boxWidth && documentData.t.charAt(i) !== ' '){
	                if(lastSpaceIndex === -1){
	                    len += 1;
	                } else {
	                    i = lastSpaceIndex;
	                }
	                documentData.t = documentData.t.substr(0,i) + "\r" + documentData.t.substr(i === lastSpaceIndex ? i + 1 : i);
	                lastSpaceIndex = -1;
	                lineWidth = 0;
	            }else {
	                lineWidth += cLength;
	                lineWidth += trackingOffset;
	            }
	        }
	        len = documentData.t.length;
	    }
	    lineWidth = - trackingOffset;
	    cLength = 0;
	    var uncollapsedSpaces = 0;
	    var currentChar;
	    for (i = 0;i < len ;i += 1) {
	        newLineFlag = false;
	        currentChar = documentData.t.charAt(i);
	        if(currentChar === ' '){
	            val = '\u00A0';
	        }else if(currentChar.charCodeAt(0) === 13){
	            uncollapsedSpaces = 0;
	            lineWidths.push(lineWidth);
	            maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
	            lineWidth = - 2 * trackingOffset;
	            val = '';
	            newLineFlag = true;
	            currentLine += 1;
	        }else{
	            val = documentData.t.charAt(i);
	        }
	        if(fontManager.chars){
	            charData = fontManager.getCharData(currentChar, fontData.fStyle, fontManager.getFontByName(documentData.f).fFamily);
	            cLength = newLineFlag ? 0 : charData.w*documentData.s/100;
	        }else{
	            //var charWidth = fontManager.measureText(val, documentData.f, documentData.s);
	            //tCanvasHelper.font = documentData.s + 'px '+ fontManager.getFontByName(documentData.f).fFamily;
	            cLength = fontManager.measureText(val, documentData.f, documentData.s);
	        }
	
	        //
	        if(currentChar === ' '){
	            uncollapsedSpaces += cLength + trackingOffset;
	        } else {
	            lineWidth += cLength + trackingOffset + uncollapsedSpaces;
	            uncollapsedSpaces = 0;
	        }
	        letters.push({l:cLength,an:cLength,add:currentSize,n:newLineFlag, anIndexes:[], val: val, line: currentLine});
	        if(anchorGrouping == 2){
	            currentSize += cLength;
	            if(val == '' || val == '\u00A0' || i == len - 1){
	                if(val == '' || val == '\u00A0'){
	                    currentSize -= cLength;
	                }
	                while(currentPos<=i){
	                    letters[currentPos].an = currentSize;
	                    letters[currentPos].ind = index;
	                    letters[currentPos].extra = cLength;
	                    currentPos += 1;
	                }
	                index += 1;
	                currentSize = 0;
	            }
	        }else if(anchorGrouping == 3){
	            currentSize += cLength;
	            if(val == '' || i == len - 1){
	                if(val == ''){
	                    currentSize -= cLength;
	                }
	                while(currentPos<=i){
	                    letters[currentPos].an = currentSize;
	                    letters[currentPos].ind = index;
	                    letters[currentPos].extra = cLength;
	                    currentPos += 1;
	                }
	                currentSize = 0;
	                index += 1;
	            }
	        }else{
	            letters[index].ind = index;
	            letters[index].extra = 0;
	            index += 1;
	        }
	    }
	    documentData.l = letters;
	    maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
	    lineWidths.push(lineWidth);
	    if(documentData.sz){
	        documentData.boxWidth = documentData.sz[0];
	        documentData.justifyOffset = 0;
	    }else{
	        documentData.boxWidth = maxLineWidth;
	        switch(documentData.j){
	            case 1:
	                documentData.justifyOffset = - documentData.boxWidth;
	                break;
	            case 2:
	                documentData.justifyOffset = - documentData.boxWidth/2;
	                break;
	            default:
	                documentData.justifyOffset = 0;
	        }
	    }
	    documentData.lineWidths = lineWidths;
	
	    var animators = data.a, animatorData, letterData;
	    jLen = animators.length;
	    var based, ind, indexes = [];
	    for(j=0;j<jLen;j+=1){
	        animatorData = animators[j];
	        if(animatorData.a.sc){
	            documentData.strokeColorAnim = true;
	        }
	        if(animatorData.a.sw){
	            documentData.strokeWidthAnim = true;
	        }
	        if(animatorData.a.fc || animatorData.a.fh || animatorData.a.fs || animatorData.a.fb){
	            documentData.fillColorAnim = true;
	        }
	        ind = 0;
	        based = animatorData.s.b;
	        for(i=0;i<len;i+=1){
	            letterData = letters[i];
	            letterData.anIndexes[j] = ind;
	            if((based == 1 && letterData.val != '') || (based == 2 && letterData.val != '' && letterData.val != '\u00A0') || (based == 3 && (letterData.n || letterData.val == '\u00A0' || i == len - 1)) || (based == 4 && (letterData.n || i == len - 1))){
	                if(animatorData.s.rn === 1){
	                    indexes.push(ind);
	                }
	                ind += 1;
	            }
	        }
	        data.a[j].s.totalChars = ind;
	        var currentInd = -1, newInd;
	        if(animatorData.s.rn === 1){
	            for(i = 0; i < len; i += 1){
	                letterData = letters[i];
	                if(currentInd != letterData.anIndexes[j]){
	                    currentInd = letterData.anIndexes[j];
	                    newInd = indexes.splice(Math.floor(Math.random()*indexes.length),1)[0];
	                }
	                letterData.anIndexes[j] = newInd;
	            }
	        }
	    }
	    documentData.yOffset = documentData.lh || documentData.s*1.2;
	    documentData.ls = documentData.ls || 0;
	    documentData.ascent = fontData.ascent*documentData.s/100;
	}
	
	TextProperty.prototype.updateDocumentData = function(newData, index) {
		index = index === undefined ? this.keysIndex : index;
	    var dData = this.data.d.k[index].s;
	    dData.__complete = false;
	    dData.t = newData.t;
	    this.keysIndex = -1;
	    this.firstFrame = true;
	    this.getValue();
	}
	
	var TextSelectorProp = (function(){
	    var max = Math.max;
	    var min = Math.min;
	    var floor = Math.floor;
	    function updateRange(newCharsFlag){
	        this.mdf = newCharsFlag || false;
	        if(this.dynamicProperties.length){
	            var i, len = this.dynamicProperties.length;
	            for(i=0;i<len;i+=1){
	                this.dynamicProperties[i].getValue();
	                if(this.dynamicProperties[i].mdf){
	                    this.mdf = true;
	                }
	            }
	        }
	        var totalChars = this.elem.textProperty.currentData ? this.elem.textProperty.currentData.l.length : 0;
	        if(newCharsFlag && this.data.r === 2) {
	            this.e.v = totalChars;
	        }
	        var divisor = this.data.r === 2 ? 1 : 100 / totalChars;
	        var o = this.o.v/divisor;
	        var s = this.s.v/divisor + o;
	        var e = (this.e.v/divisor) + o;
	        if(s>e){
	            var _s = s;
	            s = e;
	            e = _s;
	        }
	        this.finalS = s;
	        this.finalE = e;
	    }
	
	    function getMult(ind){
	        //var easer = bez.getEasingCurve(this.ne.v/100,0,1-this.xe.v/100,1);
	        var easer = BezierFactory.getBezierEasing(this.ne.v/100,0,1-this.xe.v/100,1).get;
	        var mult = 0;
	        var s = this.finalS;
	        var e = this.finalE;
	        var type = this.data.sh;
	        if(type == 2){
	            if(e === s){
	                mult = ind >= e ? 1 : 0;
	            }else{
	                mult = max(0,min(0.5/(e-s) + (ind-s)/(e-s),1));
	            }
	            mult = easer(mult);
	        }else if(type == 3){
	            if(e === s){
	                mult = ind >= e ? 0 : 1;
	            }else{
	                mult = 1 - max(0,min(0.5/(e-s) + (ind-s)/(e-s),1));
	            }
	
	            mult = easer(mult);
	        }else if(type == 4){
	            if(e === s){
	                mult = 0;
	            }else{
	                mult = max(0,min(0.5/(e-s) + (ind-s)/(e-s),1));
	                if(mult<.5){
	                    mult *= 2;
	                }else{
	                    mult = 1 - 2*(mult-0.5);
	                }
	            }
	            mult = easer(mult);
	        }else if(type == 5){
	            if(e === s){
	                mult = 0;
	            }else{
	                var tot = e - s;
	                /*ind += 0.5;
	                mult = -4/(tot*tot)*(ind*ind)+(4/tot)*ind;*/
	                ind = min(max(0,ind+0.5-s),e-s);
	                var x = -tot/2+ind;
	                var a = tot/2;
	                mult = Math.sqrt(1 - (x*x)/(a*a));
	            }
	            mult = easer(mult);
	        }else if(type == 6){
	            if(e === s){
	                mult = 0;
	            }else{
	                ind = min(max(0,ind+0.5-s),e-s);
	                mult = (1+(Math.cos((Math.PI+Math.PI*2*(ind)/(e-s)))))/2;
	                /*
	                 ind = Math.min(Math.max(s,ind),e-1);
	                 mult = (1+(Math.cos((Math.PI+Math.PI*2*(ind-s)/(e-1-s)))))/2;
	                 mult = Math.max(mult,(1/(e-1-s))/(e-1-s));*/
	            }
	            mult = easer(mult);
	        }else {
	            if(ind >= floor(s)){
	                if(ind-s < 0){
	                    mult = 1 - (s - ind);
	                }else{
	                    mult = max(0,min(e-ind,1));
	                }
	            }
	            mult = easer(mult);
	        }
	        return mult*this.a.v;
	    }
	
	    function TextSelectorProp(elem,data, arr){
	        this.mdf = false;
	        this.k = false;
	        this.data = data;
	        this.dynamicProperties = [];
	        this.getValue = updateRange;
	        this.getMult = getMult;
	        this.elem = elem;
	        this.comp = elem.comp;
	        this.finalS = 0;
	        this.finalE = 0;
	        this.s = PropertyFactory.getProp(elem,data.s || {k:0},0,0,this.dynamicProperties);
	        if('e' in data){
	            this.e = PropertyFactory.getProp(elem,data.e,0,0,this.dynamicProperties);
	        }else{
	            this.e = {v:100};
	        }
	        this.o = PropertyFactory.getProp(elem,data.o || {k:0},0,0,this.dynamicProperties);
	        this.xe = PropertyFactory.getProp(elem,data.xe || {k:0},0,0,this.dynamicProperties);
	        this.ne = PropertyFactory.getProp(elem,data.ne || {k:0},0,0,this.dynamicProperties);
	        this.a = PropertyFactory.getProp(elem,data.a,0,0.01,this.dynamicProperties);
	        if(this.dynamicProperties.length){
	            arr.push(this);
	        }else{
	            this.getValue();
	        }
	    }
	
	    function getTextSelectorProp(elem, data,arr) {
	        return new TextSelectorProp(elem, data, arr);
	    };
	
	    return {
	        getTextSelectorProp: getTextSelectorProp
	    }
	}());
	
	    
	var pooling = (function(){
	
		function double(arr){
			return arr.concat(Array.apply(null,{length:arr.length}))
		}
	
		return {
			double: double
		}
	}());
	var point_pool = (function(){
		var ob = {
			newPoint: newPoint,
			release: release
		}
	
		var _length = 0;
		var _maxLength = 8;
		var pool = Array.apply(null,{length:_maxLength});
	
		function newPoint(){
			var point;
			if(_length){
				_length -= 1;
				point = pool[_length];
			} else {
				point = createTypedArray('float32', 2);
			}
			return point;
		}
	
		function release(point) {
			if(_length === _maxLength) {
				pool = pooling.double(pool);
				_maxLength = _maxLength*2;
			}
			pool[_length] = point;
			_length += 1;
		}
	
	
		return ob;
	}());
	var shape_pool = (function(){
		var ob = {
			clone: clone,
			newShape: newShape,
			release: release,
			releaseArray: releaseArray
		}
	
		var _length = 0;
		var _maxLength = 4;
		var pool = Array.apply(null,{length:_maxLength});
	
		function newShape(){
			var shapePath;
			if(_length){
				_length -= 1;
				shapePath = pool[_length];
			} else {
				shapePath = new ShapePath();
			}
			return shapePath;
		}
	
		function release(shapePath) {
			if(_length === _maxLength) {
				pool = pooling.double(pool);
				_maxLength = _maxLength*2;
			}
			var len = shapePath._length, i;
			for(i = 0; i < len; i += 1) {
				point_pool.release(shapePath.v[i]);
				point_pool.release(shapePath.i[i]);
				point_pool.release(shapePath.o[i]);
				shapePath.v[i] = null;
				shapePath.i[i] = null;
				shapePath.o[i] = null;
			}
			shapePath._length = 0;
			shapePath.c = false;
			pool[_length] = shapePath;
			_length += 1;
		}
	
		function releaseArray(shapePathsCollection, length) {
			while(length--) {
				release(shapePathsCollection[length]);
			}
		}
	
		function clone(shape, transform) {
			var i, len = shape._length === undefined ? shape.v.length : shape._length;
			var cloned = newShape();
			cloned.setLength(len);
			cloned.c = shape.c;
	
			var pt;
			
			for(i = 0; i < len; i += 1) {
				if(transform){
					pt = transform.applyToPointArray(shape.v[i][0],shape.v[i][1],0,2);
					cloned.setXYAt(pt[0],pt[1],'v',i);
					point_pool.release(pt);
					pt = transform.applyToPointArray(shape.o[i][0],shape.o[i][1],0,2);
					cloned.setXYAt(pt[0],pt[1],'o',i);
					point_pool.release(pt);
					pt = transform.applyToPointArray(shape.i[i][0],shape.i[i][1],0,2);
					cloned.setXYAt(pt[0],pt[1],'i',i);
					point_pool.release(pt);
				}else{
					cloned.setTripleAt(shape.v[i][0],shape.v[i][1],shape.o[i][0],shape.o[i][1],shape.i[i][0],shape.i[i][1], i);
				}
			}
			return cloned
		}
	
	
		return ob;
	}());
	var shapeCollection_pool = (function(){
		var ob = {
			newShapeCollection: newShapeCollection,
			release: release,
			clone: clone
		}
	
		var _length = 0;
		var _maxLength = 4;
		var pool = Array.apply(null,{length:_maxLength});
	
		var cont = 0;
	
		function newShapeCollection(){
			var shapeCollection;
			if(_length){
				_length -= 1;
				shapeCollection = pool[_length];
			} else {
				shapeCollection = new ShapeCollection();
			}
			return shapeCollection;
		}
	
		function release(shapeCollection) {
			var i, len = shapeCollection._length;
			for(i = 0; i < len; i += 1) {
				shape_pool.release(shapeCollection.shapes[i]);
			}
			shapeCollection._length = 0;
	
			if(_length === _maxLength) {
				pool = pooling.double(pool);
				_maxLength = _maxLength*2;
			}
			pool[_length] = shapeCollection;
			_length += 1;
		}
	
		function clone(shapeCollection, originCollection) {
			release(shapeCollection);
			if(_length === _maxLength) {
				pool = pooling.double(pool);
				_maxLength = _maxLength*2;
			}
			pool[_length] = shapeCollection;
			_length += 1;
		}
	
	
		return ob;
	}());
	function BaseRenderer(){}
	BaseRenderer.prototype.checkLayers = function(num){
	    var i, len = this.layers.length, data;
	    this.completeLayers = true;
	    for (i = len - 1; i >= 0; i--) {
	        if (!this.elements[i]) {
	            data = this.layers[i];
	            if(data.ip - data.st <= (num - this.layers[i].st) && data.op - data.st > (num - this.layers[i].st))
	            {
	                this.buildItem(i);
	            }
	        }
	        this.completeLayers = this.elements[i] ? this.completeLayers:false;
	    }
	    this.checkPendingElements();
	};
	
	BaseRenderer.prototype.createItem = function(layer){
	    switch(layer.ty){
	        case 2:
	            return this.createImage(layer);
	        case 0:
	            return this.createComp(layer);
	        case 1:
	            return this.createSolid(layer);
	        case 4:
	            return this.createShape(layer);
	        case 5:
	            return this.createText(layer);
	        case 13:
	            return this.createCamera(layer);
	        case 99:
	            return null;
	    }
	    return this.createBase(layer);
	};
	
	BaseRenderer.prototype.createCamera = function(){
	    throw new Error('You\'re using a 3d camera. Try the html renderer.');
	}
	
	BaseRenderer.prototype.buildAllItems = function(){
	    var i, len = this.layers.length;
	    for(i=0;i<len;i+=1){
	        this.buildItem(i);
	    }
	    this.checkPendingElements();
	};
	
	BaseRenderer.prototype.includeLayers = function(newLayers){
	    this.completeLayers = false;
	    var i, len = newLayers.length;
	    var j, jLen = this.layers.length;
	    for(i=0;i<len;i+=1){
	        j = 0;
	        while(j<jLen){
	            if(this.layers[j].id == newLayers[i].id){
	                this.layers[j] = newLayers[i];
	                break;
	            }
	            j += 1;
	        }
	    }
	};
	
	BaseRenderer.prototype.setProjectInterface = function(pInterface){
	    this.globalData.projectInterface = pInterface;
	};
	
	BaseRenderer.prototype.initItems = function(){
	    if(!this.globalData.progressiveLoad){
	        this.buildAllItems();
	    }
	};
	BaseRenderer.prototype.buildElementParenting = function(element, parentName, hierarchy){
	    hierarchy = hierarchy || [];
	    var elements = this.elements;
	    var layers = this.layers;
	    var i=0, len = layers.length;
	    while(i<len){
	        if(layers[i].ind == parentName){
	            if(!elements[i] || elements[i] === true){
	                this.buildItem(i);
	                this.addPendingElement(element);
	            } else if(layers[i].parent !== undefined){
	                hierarchy.push(elements[i]);
	                elements[i]._isParent = true;
	                this.buildElementParenting(element,layers[i].parent, hierarchy);
	            } else {
	                hierarchy.push(elements[i]);
	                elements[i]._isParent = true;
	                element.setHierarchy(hierarchy);
	            }
	
	
	        }
	        i += 1;
	    }
	};
	
	BaseRenderer.prototype.addPendingElement = function(element){
	    this.pendingElements.push(element);
	};
	function SVGRenderer(animationItem, config){
	    this.animationItem = animationItem;
	    this.layers = null;
	    this.renderedFrame = -1;
	    this.globalData = {
	        frameNum: -1
	    };
	    this.renderConfig = {
	        preserveAspectRatio: (config && config.preserveAspectRatio) || 'xMidYMid meet',
	        progressiveLoad: (config && config.progressiveLoad) || false,
	        hideOnTransparent: (config && config.hideOnTransparent === false) ? false : true,
	        viewBoxOnly: (config && config.viewBoxOnly) || false,
	        className: (config && config.className) || ''
	    };
	    this.globalData.renderConfig = this.renderConfig;
	    this.elements = [];
	    this.pendingElements = [];
	    this.destroyed = false;
	
	}
	
	extendPrototype(BaseRenderer,SVGRenderer);
	
	SVGRenderer.prototype.createBase = function (data) {
	    return new SVGBaseElement(data, this.layerElement,this.globalData,this);
	};
	
	SVGRenderer.prototype.createShape = function (data) {
	    return new IShapeElement(data, this.layerElement,this.globalData,this);
	};
	
	SVGRenderer.prototype.createText = function (data) {
	    return new SVGTextElement(data, this.layerElement,this.globalData,this);
	
	};
	
	SVGRenderer.prototype.createImage = function (data) {
	    return new IImageElement(data, this.layerElement,this.globalData,this);
	};
	
	SVGRenderer.prototype.createComp = function (data) {
	    return new ICompElement(data, this.layerElement,this.globalData,this);
	
	};
	
	SVGRenderer.prototype.createSolid = function (data) {
	    return new ISolidElement(data, this.layerElement,this.globalData,this);
	};
	
	SVGRenderer.prototype.configAnimation = function(animData){
	    this.layerElement = createNS('svg');
	    this.layerElement.setAttribute('xmlns','http://www.w3.org/2000/svg');
	    this.layerElement.setAttribute('viewBox','0 0 '+animData.w+' '+animData.h);
	    if(!this.renderConfig.viewBoxOnly) {
	        this.layerElement.setAttribute('width',animData.w);
	        this.layerElement.setAttribute('height',animData.h);
	        this.layerElement.style.width = '100%';
	        this.layerElement.style.height = '100%';
	    }
	    if(this.renderConfig.className) {
	        this.layerElement.setAttribute('class', this.renderConfig.className);
	    }
	    this.layerElement.setAttribute('preserveAspectRatio',this.renderConfig.preserveAspectRatio);
	    //this.layerElement.style.transform = 'translate3d(0,0,0)';
	    //this.layerElement.style.transformOrigin = this.layerElement.style.mozTransformOrigin = this.layerElement.style.webkitTransformOrigin = this.layerElement.style['-webkit-transform'] = "0px 0px 0px";
	    this.animationItem.wrapper.appendChild(this.layerElement);
	    //Mask animation
	    var defs = createNS( 'defs');
	    this.globalData.defs = defs;
	    this.layerElement.appendChild(defs);
	    this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem);
	    this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem);
	    this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
	    this.globalData.frameId = 0;
	    this.globalData.nm = animData.nm;
	    this.globalData.compSize = {
	        w: animData.w,
	        h: animData.h
	    };
	    this.data = animData;
	    this.globalData.frameRate = animData.fr;
	    var maskElement = createNS( 'clipPath');
	    var rect = createNS('rect');
	    rect.setAttribute('width',animData.w);
	    rect.setAttribute('height',animData.h);
	    rect.setAttribute('x',0);
	    rect.setAttribute('y',0);
	    var maskId = 'animationMask_'+randomString(10);
	    maskElement.setAttribute('id', maskId);
	    maskElement.appendChild(rect);
	    var maskedElement = createNS('g');
	    maskedElement.setAttribute("clip-path", "url(" + locationHref + "#"+maskId+")");
	    this.layerElement.appendChild(maskedElement);
	    defs.appendChild(maskElement);
	    this.layerElement = maskedElement;
	    this.layers = animData.layers;
	    this.globalData.fontManager = new FontManager();
	    this.globalData.fontManager.addChars(animData.chars);
	    this.globalData.fontManager.addFonts(animData.fonts,defs);
	    this.elements = Array.apply(null,{length:animData.layers.length});
	};
	
	
	SVGRenderer.prototype.destroy = function () {
	    this.animationItem.wrapper.innerHTML = '';
	    this.layerElement = null;
	    this.globalData.defs = null;
	    var i, len = this.layers ? this.layers.length : 0;
	    for (i = 0; i < len; i++) {
	        if(this.elements[i]){
	            this.elements[i].destroy();
	        }
	    }
	    this.elements.length = 0;
	    this.destroyed = true;
	    this.animationItem = null;
	};
	
	SVGRenderer.prototype.updateContainerSize = function () {
	};
	
	SVGRenderer.prototype.buildItem  = function(pos){
	    var elements = this.elements;
	    if(elements[pos] || this.layers[pos].ty == 99){
	        return;
	    }
	    elements[pos] = true;
	    var element = this.createItem(this.layers[pos]);
	
	    elements[pos] = element;
	    if(expressionsPlugin){
	        if(this.layers[pos].ty === 0){
	            this.globalData.projectInterface.registerComposition(element);
	        }
	        element.initExpressions();
	    }
	    this.appendElementInPos(element,pos);
	    if(this.layers[pos].tt){
	        if(!this.elements[pos - 1] || this.elements[pos - 1] === true){
	            this.buildItem(pos - 1);
	            this.addPendingElement(element);
	        } else {
	            element.setMatte(elements[pos - 1].layerId);
	        }
	    }
	};
	
	SVGRenderer.prototype.checkPendingElements  = function(){
	    while(this.pendingElements.length){
	        var element = this.pendingElements.pop();
	        element.checkParenting();
	        if(element.data.tt){
	            var i = 0, len = this.elements.length;
	            while(i<len){
	                if(this.elements[i] === element){
	                    element.setMatte(this.elements[i - 1].layerId);
	                    break;
	                }
	                i += 1;
	            }
	        }
	    }
	};
	
	SVGRenderer.prototype.renderFrame = function(num){
	    if(this.renderedFrame == num || this.destroyed){
	        return;
	    }
	    if(num === null){
	        num = this.renderedFrame;
	    }else{
	        this.renderedFrame = num;
	    }
	    //clearPoints();
	    /*console.log('-------');
	    console.log('FRAME ',num);*/
	    this.globalData.frameNum = num;
	    this.globalData.frameId += 1;
	    this.globalData.projectInterface.currentFrame = num;
	    var i, len = this.layers.length;
	    if(!this.completeLayers){
	        this.checkLayers(num);
	    }
	    for (i = len - 1; i >= 0; i--) {
	        if(this.completeLayers || this.elements[i]){
	            this.elements[i].prepareFrame(num - this.layers[i].st);
	        }
	    }
	    for (i = len - 1; i >= 0; i--) {
	        if(this.completeLayers || this.elements[i]){
	            this.elements[i].renderFrame();
	        }
	    }
	};
	
	SVGRenderer.prototype.appendElementInPos = function(element, pos){
	    var newElement = element.getBaseElement();
	    if(!newElement){
	        return;
	    }
	    var i = 0;
	    var nextElement;
	    while(i<pos){
	        if(this.elements[i] && this.elements[i]!== true && this.elements[i].getBaseElement()){
	            nextElement = this.elements[i].getBaseElement();
	        }
	        i += 1;
	    }
	    if(nextElement){
	        this.layerElement.insertBefore(newElement, nextElement);
	    } else {
	        this.layerElement.appendChild(newElement);
	    }
	};
	
	SVGRenderer.prototype.hide = function(){
	    this.layerElement.style.display = 'none';
	};
	
	SVGRenderer.prototype.show = function(){
	    this.layerElement.style.display = 'block';
	};
	
	SVGRenderer.prototype.searchExtraCompositions = function(assets){
	    var i, len = assets.length;
	    var floatingContainer = createNS('g');
	    for(i=0;i<len;i+=1){
	        if(assets[i].xt){
	            var comp = this.createComp(assets[i],floatingContainer,this.globalData.comp,null);
	            comp.initExpressions();
	            //comp.compInterface = CompExpressionInterface(comp);
	            //Expressions.addLayersInterface(comp.elements, this.globalData.projectInterface);
	            this.globalData.projectInterface.registerComposition(comp);
	        }
	    }
	};
	
	function MaskElement(data,element,globalData) {
	    this.dynamicProperties = [];
	    this.data = data;
	    this.element = element;
	    this.globalData = globalData;
	    this.storedData = [];
	    this.masksProperties = this.data.masksProperties;
	    this.viewData = Array.apply(null,{length:this.masksProperties.length});
	    this.maskElement = null;
	    this.firstFrame = true;
	    var defs = this.globalData.defs;
	    var i, len = this.masksProperties.length;
	
	
	    var path, properties = this.masksProperties;
	    var count = 0;
	    var currentMasks = [];
	    var j, jLen;
	    var layerId = randomString(10);
	    var rect, expansor, feMorph,x;
	    var maskType = 'clipPath', maskRef = 'clip-path';
	    for (i = 0; i < len; i++) {
	
	        if((properties[i].mode !== 'a' && properties[i].mode !== 'n')|| properties[i].inv || properties[i].o.k !== 100){
	            maskType = 'mask';
	            maskRef = 'mask';
	        }
	
	        if((properties[i].mode == 's' || properties[i].mode == 'i') && count == 0){
	            rect = createNS( 'rect');
	            rect.setAttribute('fill', '#ffffff');
	            rect.setAttribute('width', this.element.comp.data.w);
	            rect.setAttribute('height', this.element.comp.data.h);
	            currentMasks.push(rect);
	        } else {
	            rect = null;
	        }
	
	        path = createNS( 'path');
	        if(properties[i].mode == 'n') {
	            this.viewData[i] = {
	                op: PropertyFactory.getProp(this.element,properties[i].o,0,0.01,this.dynamicProperties),
	                prop: ShapePropertyFactory.getShapeProp(this.element,properties[i],3,this.dynamicProperties,null),
	                elem: path
	            };
	            defs.appendChild(path);
	            continue;
	        }
	        count += 1;
	
	        if(properties[i].mode == 's'){
	            path.setAttribute('fill', '#000000');
	        }else{
	            path.setAttribute('fill', '#ffffff');
	        }
	        path.setAttribute('clip-rule','nonzero');
	
	        if(properties[i].x.k !== 0){
	            maskType = 'mask';
	            maskRef = 'mask';
	            x = PropertyFactory.getProp(this.element,properties[i].x,0,null,this.dynamicProperties);
	            var filterID = 'fi_'+randomString(10);
	            expansor = createNS('filter');
	            expansor.setAttribute('id',filterID);
	            feMorph = createNS('feMorphology');
	            feMorph.setAttribute('operator','dilate');
	            feMorph.setAttribute('in','SourceGraphic');
	            feMorph.setAttribute('radius','0');
	            expansor.appendChild(feMorph);
	            defs.appendChild(expansor);
	            if(properties[i].mode == 's'){
	                path.setAttribute('stroke', '#000000');
	            }else{
	                path.setAttribute('stroke', '#ffffff');
	            }
	        }else{
	            feMorph = null;
	            x = null;
	        }
	
	
	        this.storedData[i] = {
	             elem: path,
	             x: x,
	             expan: feMorph,
	            lastPath: '',
	            lastOperator:'',
	            filterId:filterID,
	            lastRadius:0
	        };
	        if(properties[i].mode == 'i'){
	            jLen = currentMasks.length;
	            var g = createNS('g');
	            for(j=0;j<jLen;j+=1){
	                g.appendChild(currentMasks[j]);
	            }
	            var mask = createNS('mask');
	            mask.setAttribute('mask-type','alpha');
	            mask.setAttribute('id',layerId+'_'+count);
	            mask.appendChild(path);
	            defs.appendChild(mask);
	            g.setAttribute('mask','url(' + locationHref + '#'+layerId+'_'+count+')');
	
	            currentMasks.length = 0;
	            currentMasks.push(g);
	        }else{
	            currentMasks.push(path);
	        }
	        if(properties[i].inv && !this.solidPath){
	            this.solidPath = this.createLayerSolidPath();
	        }
	        this.viewData[i] = {
	            elem: path,
	            lastPath: '',
	            op: PropertyFactory.getProp(this.element,properties[i].o,0,0.01,this.dynamicProperties),
	            prop:ShapePropertyFactory.getShapeProp(this.element,properties[i],3,this.dynamicProperties,null)
	        };
	        if(rect){
	            this.viewData[i].invRect = rect;
	        }
	        if(!this.viewData[i].prop.k){
	            this.drawPath(properties[i],this.viewData[i].prop.v,this.viewData[i]);
	        }
	    }
	
	    this.maskElement = createNS( maskType);
	
	    len = currentMasks.length;
	    for(i=0;i<len;i+=1){
	        this.maskElement.appendChild(currentMasks[i]);
	    }
	
	    this.maskElement.setAttribute('id', layerId);
	    if(count > 0){
	        this.element.maskedElement.setAttribute(maskRef, "url(" + locationHref + "#" + layerId + ")");
	    }
	
	    defs.appendChild(this.maskElement);
	};
	
	MaskElement.prototype.getMaskProperty = function(pos){
	    return this.viewData[pos].prop;
	};
	
	MaskElement.prototype.prepareFrame = function(){
	    var i, len = this.dynamicProperties.length;
	    for(i=0;i<len;i+=1){
	        this.dynamicProperties[i].getValue();
	
	    }
	};
	
	MaskElement.prototype.renderFrame = function (finalMat) {
	    var i, len = this.masksProperties.length;
	    for (i = 0; i < len; i++) {
	        if(this.viewData[i].prop.mdf || this.firstFrame){
	            this.drawPath(this.masksProperties[i],this.viewData[i].prop.v,this.viewData[i]);
	        }
	        if(this.viewData[i].op.mdf || this.firstFrame){
	            this.viewData[i].elem.setAttribute('fill-opacity',this.viewData[i].op.v);
	        }
	        if(this.masksProperties[i].mode !== 'n'){
	            if(this.viewData[i].invRect && (this.element.finalTransform.mProp.mdf || this.firstFrame)){
	                this.viewData[i].invRect.setAttribute('x', -finalMat.props[12]);
	                this.viewData[i].invRect.setAttribute('y', -finalMat.props[13]);
	            }
	            if(this.storedData[i].x && (this.storedData[i].x.mdf || this.firstFrame)){
	                var feMorph = this.storedData[i].expan;
	                if(this.storedData[i].x.v < 0){
	                    if(this.storedData[i].lastOperator !== 'erode'){
	                        this.storedData[i].lastOperator = 'erode';
	                        this.storedData[i].elem.setAttribute('filter','url(' + locationHref + '#'+this.storedData[i].filterId+')');
	                    }
	                    feMorph.setAttribute('radius',-this.storedData[i].x.v);
	                }else{
	                    if(this.storedData[i].lastOperator !== 'dilate'){
	                        this.storedData[i].lastOperator = 'dilate';
	                        this.storedData[i].elem.setAttribute('filter',null);
	                    }
	                    this.storedData[i].elem.setAttribute('stroke-width', this.storedData[i].x.v*2);
	
	                }
	            }
	        }
	    }
	    this.firstFrame = false;
	};
	
	MaskElement.prototype.getMaskelement = function () {
	    return this.maskElement;
	};
	
	MaskElement.prototype.createLayerSolidPath = function(){
	    var path = 'M0,0 ';
	    path += ' h' + this.globalData.compSize.w ;
	    path += ' v' + this.globalData.compSize.h ;
	    path += ' h-' + this.globalData.compSize.w ;
	    path += ' v-' + this.globalData.compSize.h + ' ';
	    return path;
	};
	
	MaskElement.prototype.drawPath = function(pathData,pathNodes,viewData){
	    var pathString = " M"+pathNodes.v[0][0]+','+pathNodes.v[0][1];
	    var i, len;
	    len = pathNodes._length;
	    for(i=1;i<len;i+=1){
	        //pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[i][0]+','+pathNodes.i[i][1] + " "+pathNodes.v[i][0]+','+pathNodes.v[i][1];
	        pathString += " C"+bm_rnd(pathNodes.o[i-1][0])+','+bm_rnd(pathNodes.o[i-1][1]) + " "+bm_rnd(pathNodes.i[i][0])+','+bm_rnd(pathNodes.i[i][1]) + " "+bm_rnd(pathNodes.v[i][0])+','+bm_rnd(pathNodes.v[i][1]);
	    }
	        //pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[0][0]+','+pathNodes.i[0][1] + " "+pathNodes.v[0][0]+','+pathNodes.v[0][1];
	    if(pathNodes.c && len > 1){
	        pathString += " C"+bm_rnd(pathNodes.o[i-1][0])+','+bm_rnd(pathNodes.o[i-1][1]) + " "+bm_rnd(pathNodes.i[0][0])+','+bm_rnd(pathNodes.i[0][1]) + " "+bm_rnd(pathNodes.v[0][0])+','+bm_rnd(pathNodes.v[0][1]);
	    }
	    //pathNodes.__renderedString = pathString;
	
	
	    if(viewData.lastPath !== pathString){
	        if(viewData.elem){
	            if(!pathNodes.c){
	                viewData.elem.setAttribute('d','');
	            }else if(pathData.inv){
	                viewData.elem.setAttribute('d',this.solidPath + pathString);
	            }else{
	                viewData.elem.setAttribute('d',pathString);
	            }
	        }
	        viewData.lastPath = pathString;
	    }
	};
	
	MaskElement.prototype.destroy = function(){
	    this.element = null;
	    this.globalData = null;
	    this.maskElement = null;
	    this.data = null;
	    this.masksProperties = null;
	};
	function BaseElement(){
	};
	BaseElement.prototype.checkMasks = function(){
	    if(!this.data.hasMask){
	        return false;
	    }
	    var i = 0, len = this.data.masksProperties.length;
	    while(i<len) {
	        if((this.data.masksProperties[i].mode !== 'n' && this.data.masksProperties[i].cl !== false)) {
	            return true;
	        }
	        i += 1;
	    }
	    return false;
	}
	
	BaseElement.prototype.checkParenting = function(){
	    if(this.data.parent !== undefined){
	        this.comp.buildElementParenting(this, this.data.parent);
	    }
	}
	
	BaseElement.prototype.prepareFrame = function(num){
	    if(this.data.ip - this.data.st <= num && this.data.op - this.data.st > num)
	    {
	        if(this.isVisible !== true){
	            this.elemMdf = true;
	            this.globalData.mdf = true;
	            this.isVisible = true;
	            this.firstFrame = true;
	            if(this.data.hasMask){
	                this.maskManager.firstFrame = true;
	            }
	        }
	    }else{
	        if(this.isVisible !== false){
	            this.elemMdf = true;
	            this.globalData.mdf = true;
	            this.isVisible = false;
	        }
	    }
	    var i, len = this.dynamicProperties.length;
	    for(i=0;i<len;i+=1){
	        if(this.isVisible || (this._isParent && this.dynamicProperties[i].type === 'transform')){
	            this.dynamicProperties[i].getValue();
	            if(this.dynamicProperties[i].mdf){
	                this.elemMdf = true;
	                this.globalData.mdf = true;
	            }
	        }
	    }
	    if(this.data.hasMask && this.isVisible){
	        this.maskManager.prepareFrame(num*this.data.sr);
	    }
	    
	    /* TODO check this
	    if(this.data.sy){
	        if(this.data.sy[0].renderedData[num]){
	            if(this.data.sy[0].renderedData[num].c){
	                this.feFlood.setAttribute('flood-color','rgb('+Math.round(this.data.sy[0].renderedData[num].c[0])+','+Math.round(this.data.sy[0].renderedData[num].c[1])+','+Math.round(this.data.sy[0].renderedData[num].c[2])+')');
	            }
	            if(this.data.sy[0].renderedData[num].s){
	                this.feMorph.setAttribute('radius',this.data.sy[0].renderedData[num].s);
	            }
	        }
	    }
	    */
	
	
	    this.currentFrameNum = num*this.data.sr;
	    return this.isVisible;
	};
	
	BaseElement.prototype.globalToLocal = function(pt){
	    var transforms = [];
	    transforms.push(this.finalTransform);
	    var flag = true;
	    var comp = this.comp;
	    while(flag){
	        if(comp.finalTransform){
	            if(comp.data.hasMask){
	                transforms.splice(0,0,comp.finalTransform);
	            }
	            comp = comp.comp;
	        } else {
	            flag = false;
	        }
	    }
	    var i, len = transforms.length,ptNew;
	    for(i=0;i<len;i+=1){
	        ptNew = transforms[i].mat.applyToPointArray(0,0,0);
	        //ptNew = transforms[i].mat.applyToPointArray(pt[0],pt[1],pt[2]);
	        pt = [pt[0] - ptNew[0],pt[1] - ptNew[1],0];
	    }
	    return pt;
	};
	
	BaseElement.prototype.initExpressions = function(){
	    this.layerInterface = LayerExpressionInterface(this);
	    if(this.data.hasMask){
	        this.layerInterface.registerMaskInterface(this.maskManager);
	    }
	    var effectsInterface = EffectsExpressionInterface.createEffectsInterface(this,this.layerInterface);
	    this.layerInterface.registerEffectsInterface(effectsInterface);
	
	    if(this.data.ty === 0 || this.data.xt){
	        this.compInterface = CompExpressionInterface(this);
	    } else if(this.data.ty === 4){
	        this.layerInterface.shapeInterface = ShapeExpressionInterface.createShapeInterface(this.shapesData,this.itemsData,this.layerInterface);
	        this.layerInterface.content = this.layerInterface.shapeInterface;
	    } else if(this.data.ty === 5){
	        this.layerInterface.textInterface = TextExpressionInterface(this);
	        this.layerInterface.text = this.layerInterface.textInterface;
	    }
	}
	
	BaseElement.prototype.setBlendMode = function(){
	    var blendModeValue = '';
	    switch(this.data.bm){
	        case 1:
	            blendModeValue = 'multiply';
	            break;
	        case 2:
	            blendModeValue = 'screen';
	            break;
	        case 3:
	            blendModeValue = 'overlay';
	            break;
	        case 4:
	            blendModeValue = 'darken';
	            break;
	        case 5:
	            blendModeValue = 'lighten';
	            break;
	        case 6:
	            blendModeValue = 'color-dodge';
	            break;
	        case 7:
	            blendModeValue = 'color-burn';
	            break;
	        case 8:
	            blendModeValue = 'hard-light';
	            break;
	        case 9:
	            blendModeValue = 'soft-light';
	            break;
	        case 10:
	            blendModeValue = 'difference';
	            break;
	        case 11:
	            blendModeValue = 'exclusion';
	            break;
	        case 12:
	            blendModeValue = 'hue';
	            break;
	        case 13:
	            blendModeValue = 'saturation';
	            break;
	        case 14:
	            blendModeValue = 'color';
	            break;
	        case 15:
	            blendModeValue = 'luminosity';
	            break;
	    }
	    var elem = this.baseElement || this.layerElement;
	
	    elem.style['mix-blend-mode'] = blendModeValue;
	}
	
	BaseElement.prototype.init = function(){
	    if(!this.data.sr){
	        this.data.sr = 1;
	    }
	    this.dynamicProperties = this.dynamicProperties || [];
	    if(this.data.ef){
	        this.effects = new EffectsManager(this.data,this,this.dynamicProperties);
	        //this.effect = this.effectsManager.bind(this.effectsManager);
	    }
	    //this.elemInterface = buildLayerExpressionInterface(this);
	    this.hidden = false;
	    this.firstFrame = true;
	    this.isVisible = false;
	    this._isParent = false;
	    this.currentFrameNum = -99999;
	    this.lastNum = -99999;
	    if(this.data.ks){
	        this.finalTransform = {
	            mProp: TransformPropertyFactory.getTransformProperty(this,this.data.ks,this.dynamicProperties),
	            //mProp: PropertyFactory.getProp(this,this.data.ks,2,null,this.dynamicProperties),
	            matMdf: false,
	            opMdf: false,
	            mat: new Matrix(),
	            opacity: 1
	        };
	        if(this.data.ao){
	            this.finalTransform.mProp.autoOriented = true;
	        }
	        this.finalTransform.op = this.finalTransform.mProp.o;
	        this.transform = this.finalTransform.mProp;
	        if(this.data.ty !== 11){
	            this.createElements();
	        }
	        if(this.data.hasMask){
	            this.addMasks(this.data);
	        }
	    }
	    this.elemMdf = false;
	};
	BaseElement.prototype.getType = function(){
	    return this.type;
	};
	
	BaseElement.prototype.resetHierarchy = function(){
	    if(!this.hierarchy){
	        this.hierarchy = [];
	    }else{
	        this.hierarchy.length = 0;
	    }
	};
	
	BaseElement.prototype.getHierarchy = function(){
	    if(!this.hierarchy){
	        this.hierarchy = [];
	    }
	    return this.hierarchy;
	};
	
	BaseElement.prototype.setHierarchy = function(hierarchy){
	    this.hierarchy = hierarchy;
	};
	
	BaseElement.prototype.getLayerSize = function(){
	    if(this.data.ty === 5){
	        return {w:this.data.textData.width,h:this.data.textData.height};
	    }else{
	        return {w:this.data.width,h:this.data.height};
	    }
	};
	
	BaseElement.prototype.hide = function(){
	
	};
	
	BaseElement.prototype.sourceRectAtTime = function(){
	    return {
	        top:0,
	        left:0,
	        width:100,
	        height:100
	    }
	};
	
	BaseElement.prototype.mHelper = new Matrix();
	function SVGBaseElement(data,parentContainer,globalData,comp, placeholder){
	    this.globalData = globalData;
	    this.comp = comp;
	    this.data = data;
	    this.matteElement = null;
	    this.transformedElement = null;
	    this.isTransparent = false;
	    this.parentContainer = parentContainer;
	    this.layerId = placeholder ? placeholder.layerId : 'ly_'+randomString(10);
	    this.placeholder = placeholder;
	    this._sizeChanged = false;
	    this.init();
	};
	
	createElement(BaseElement, SVGBaseElement);
	
	SVGBaseElement.prototype.createElements = function(){
	    this.layerElement = createNS('g');
	    this.transformedElement = this.layerElement;
	    if(this.data.hasMask){
	        this.maskedElement = this.layerElement;
	    }
	    var layerElementParent = null;
	    if(this.data.td){
	        if(this.data.td == 3 || this.data.td == 1){
	            var masker = createNS('mask');
	            masker.setAttribute('id',this.layerId);
	            masker.setAttribute('mask-type',this.data.td == 3 ? 'luminance':'alpha');
	            masker.appendChild(this.layerElement);
	            layerElementParent = masker;
	            this.globalData.defs.appendChild(masker);
	            ////// This is only for IE and Edge when mask if of type alpha
	            if(!featureSupport.maskType && this.data.td == 1){
	                masker.setAttribute('mask-type','luminance');
	                var filId = randomString(10);
	                var fil = filtersFactory.createFilter(filId);
	                this.globalData.defs.appendChild(fil);
	                fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
	                var gg = createNS('g');
	                gg.appendChild(this.layerElement);
	                layerElementParent = gg;
	                masker.appendChild(gg);
	                gg.setAttribute('filter','url(' + locationHref + '#'+filId+')');
	            }
	        }else if(this.data.td == 2){
	            var maskGroup = createNS('mask');
	            maskGroup.setAttribute('id',this.layerId);
	            maskGroup.setAttribute('mask-type','alpha');
	            var maskGrouper = createNS('g');
	            maskGroup.appendChild(maskGrouper);
	            var filId = randomString(10);
	            var fil = filtersFactory.createFilter(filId);
	            ////
	
	            var feColorMatrix = createNS('feColorMatrix');
	            feColorMatrix.setAttribute('type','matrix');
	            feColorMatrix.setAttribute('color-interpolation-filters','sRGB');
	            feColorMatrix.setAttribute('values','1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 -1 1');
	            fil.appendChild(feColorMatrix);
	
	            ////
	            /*var feCTr = createNS('feComponentTransfer');
	            feCTr.setAttribute('in','SourceGraphic');
	            fil.appendChild(feCTr);
	            var feFunc = createNS('feFuncA');
	            feFunc.setAttribute('type','table');
	            feFunc.setAttribute('tableValues','1.0 0.0');
	            feCTr.appendChild(feFunc);*/
	            this.globalData.defs.appendChild(fil);
	            var alphaRect = createNS('rect');
	            alphaRect.setAttribute('width',this.comp.data.w);
	            alphaRect.setAttribute('height',this.comp.data.h);
	            alphaRect.setAttribute('x','0');
	            alphaRect.setAttribute('y','0');
	            alphaRect.setAttribute('fill','#ffffff');
	            alphaRect.setAttribute('opacity','0');
	            maskGrouper.setAttribute('filter','url(' + locationHref + '#'+filId+')');
	            maskGrouper.appendChild(alphaRect);
	            maskGrouper.appendChild(this.layerElement);
	            layerElementParent = maskGrouper;
	            if(!featureSupport.maskType){
	                maskGroup.setAttribute('mask-type','luminance');
	                fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
	                var gg = createNS('g');
	                maskGrouper.appendChild(alphaRect);
	                gg.appendChild(this.layerElement);
	                layerElementParent = gg;
	                maskGrouper.appendChild(gg);
	            }
	            this.globalData.defs.appendChild(maskGroup);
	        }
	    }else if(this.data.hasMask || this.data.tt){
	        if(this.data.tt){
	            this.matteElement = createNS('g');
	            this.matteElement.appendChild(this.layerElement);
	            layerElementParent = this.matteElement;
	            this.baseElement = this.matteElement;
	        }else{
	            this.baseElement = this.layerElement;
	        }
	    }else{
	        this.baseElement = this.layerElement;
	    }
	    if((this.data.ln || this.data.cl) && (this.data.ty === 4 || this.data.ty === 0)){
	        if(this.data.ln){
	            this.layerElement.setAttribute('id',this.data.ln);
	        }
	        if(this.data.cl){
	            this.layerElement.setAttribute('class',this.data.cl);
	        }
	    }
	    if(this.data.ty === 0){
	            var cp = createNS( 'clipPath');
	            var pt = createNS('path');
	            pt.setAttribute('d','M0,0 L'+this.data.w+',0'+' L'+this.data.w+','+this.data.h+' L0,'+this.data.h+'z');
	            var clipId = 'cp_'+randomString(8);
	            cp.setAttribute('id',clipId);
	            cp.appendChild(pt);
	            this.globalData.defs.appendChild(cp);
	        if(this.checkMasks()){
	            var cpGroup = createNS('g');
	            cpGroup.setAttribute('clip-path','url(' + locationHref + '#'+clipId+')');
	            cpGroup.appendChild(this.layerElement);
	            this.transformedElement = cpGroup;
	            if(layerElementParent){
	                layerElementParent.appendChild(this.transformedElement);
	            } else {
	                this.baseElement = this.transformedElement;
	            }
	        } else {
	            this.layerElement.setAttribute('clip-path','url(' + locationHref + '#'+clipId+')');
	        }
	        
	    }
	    if(this.data.bm !== 0){
	        this.setBlendMode();
	    }
	    if(this.layerElement !== this.parentContainer){
	        this.placeholder = null;
	    }
	    /* Todo performance killer
	    if(this.data.sy){
	        var filterID = 'st_'+randomString(10);
	        var c = this.data.sy[0].c.k;
	        var r = this.data.sy[0].s.k;
	        var expansor = createNS('filter');
	        expansor.setAttribute('id',filterID);
	        var feFlood = createNS('feFlood');
	        this.feFlood = feFlood;
	        if(!c[0].e){
	            feFlood.setAttribute('flood-color','rgb('+c[0]+','+c[1]+','+c[2]+')');
	        }
	        feFlood.setAttribute('result','base');
	        expansor.appendChild(feFlood);
	        var feMorph = createNS('feMorphology');
	        feMorph.setAttribute('operator','dilate');
	        feMorph.setAttribute('in','SourceGraphic');
	        feMorph.setAttribute('result','bigger');
	        this.feMorph = feMorph;
	        if(!r.length){
	            feMorph.setAttribute('radius',this.data.sy[0].s.k);
	        }
	        expansor.appendChild(feMorph);
	        var feColorMatrix = createNS('feColorMatrix');
	        feColorMatrix.setAttribute('result','mask');
	        feColorMatrix.setAttribute('in','bigger');
	        feColorMatrix.setAttribute('type','matrix');
	        feColorMatrix.setAttribute('values','0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0');
	        expansor.appendChild(feColorMatrix);
	        var feComposite = createNS('feComposite');
	        feComposite.setAttribute('result','drop');
	        feComposite.setAttribute('in','base');
	        feComposite.setAttribute('in2','mask');
	        feComposite.setAttribute('operator','in');
	        expansor.appendChild(feComposite);
	        var feBlend = createNS('feBlend');
	        feBlend.setAttribute('in','SourceGraphic');
	        feBlend.setAttribute('in2','drop');
	        feBlend.setAttribute('mode','normal');
	        expansor.appendChild(feBlend);
	        this.globalData.defs.appendChild(expansor);
	        var cont = createNS('g');
	        if(this.layerElement === this.parentContainer){
	            this.layerElement = cont;
	        }else{
	            cont.appendChild(this.layerElement);
	        }
	        cont.setAttribute('filter','url(#'+filterID+')');
	        if(this.data.td){
	            cont.setAttribute('data-td',this.data.td);
	        }
	        if(this.data.td == 3){
	            this.globalData.defs.appendChild(cont);
	        }else if(this.data.td == 2){
	            maskGrouper.appendChild(cont);
	        }else if(this.data.td == 1){
	            masker.appendChild(cont);
	        }else{
	            if(this.data.hasMask && this.data.tt){
	                this.matteElement.appendChild(cont);
	            }else{
	                this.appendNodeToParent(cont);
	            }
	        }
	    }*/
	    if(this.data.ef){
	        this.effectsManager = new SVGEffects(this);
	    }
	    this.checkParenting();
	};
	
	
	SVGBaseElement.prototype.setBlendMode = BaseElement.prototype.setBlendMode;
	
	SVGBaseElement.prototype.renderFrame = function(parentTransform){
	    if(this.data.ty === 3 || this.data.hd || !this.isVisible){
	        return false;
	    }
	
	    this.lastNum = this.currentFrameNum;
	    this.finalTransform.opMdf = this.firstFrame || this.finalTransform.op.mdf;
	    this.finalTransform.matMdf = this.firstFrame || this.finalTransform.mProp.mdf;
	    this.finalTransform.opacity = this.finalTransform.op.v;
	
	    var mat;
	    var finalMat = this.finalTransform.mat;
	
	    if(this.hierarchy){
	        var i = 0, len = this.hierarchy.length;
	        if(!this.finalTransform.matMdf) {
	            while(i < len) {
	                if(this.hierarchy[i].finalTransform.mProp.mdf) {
	                    this.finalTransform.matMdf = true;
	                    break;
	                }
	                i += 1;
	            }
	        }
	        
	        if(this.finalTransform.matMdf) {
	            mat = this.finalTransform.mProp.v.props;
	            finalMat.cloneFromProps(mat);
	            for(i=0;i<len;i+=1){
	                mat = this.hierarchy[i].finalTransform.mProp.v.props;
	                finalMat.transform(mat[0],mat[1],mat[2],mat[3],mat[4],mat[5],mat[6],mat[7],mat[8],mat[9],mat[10],mat[11],mat[12],mat[13],mat[14],mat[15]);
	            }
	        }
	        
	    }else if(this.isVisible){
	        finalMat = this.finalTransform.mProp.v;
	    }
	    if(this.finalTransform.matMdf && this.layerElement){
	        this.transformedElement.setAttribute('transform',finalMat.to2dCSS());
	    }
	    if(this.finalTransform.opMdf && this.layerElement){
	        if(this.finalTransform.op.v <= 0) {
	            if(!this.isTransparent && this.globalData.renderConfig.hideOnTransparent){
	                this.isTransparent = true;
	                this.hide();
	            }
	        } else if(this.hidden && this.isTransparent){
	            this.isTransparent = false;
	            this.show();
	        }
	        this.transformedElement.setAttribute('opacity',this.finalTransform.op.v);
	    }
	
	    if(this.data.hasMask){
	        this.maskManager.renderFrame(finalMat);
	    }
	    if(this.effectsManager){
	        this.effectsManager.renderFrame(this.firstFrame);
	    }
	    return this.isVisible;
	};
	
	SVGBaseElement.prototype.destroy = function(){
	    this.layerElement = null;
	    this.parentContainer = null;
	    if(this.matteElement) {
	        this.matteElement = null;
	    }
	    if(this.maskManager) {
	        this.maskManager.destroy();
	    }
	};
	
	SVGBaseElement.prototype.getBaseElement = function(){
	    return this.baseElement;
	};
	SVGBaseElement.prototype.addMasks = function(data){
	    this.maskManager = new MaskElement(data,this,this.globalData);
	};
	
	SVGBaseElement.prototype.setMatte = function(id){
	    if(!this.matteElement){
	        return;
	    }
	    this.matteElement.setAttribute("mask", "url(" + locationHref + "#" + id + ")");
	};
	
	SVGBaseElement.prototype.hide = function(){
	    if(!this.hidden){
	        this.layerElement.style.display = 'none';
	        this.hidden = true;
	    }
	};
	
	SVGBaseElement.prototype.show = function(){
	    if(this.isVisible && !this.isTransparent){
	        this.hidden = false;
	        this.layerElement.style.display = 'block';
	    }
	};
	
	function IShapeElement(data,parentContainer,globalData,comp, placeholder){
	    this.shapes = [];
	    this.shapesData = data.shapes;
	    this.stylesList = [];
	    this.itemsData = [];
	    this.prevViewData = [];
	    this.shapeModifiers = [];
	    this.processedElements = [];
	    this._parent.constructor.call(this,data,parentContainer,globalData,comp, placeholder);
	}
	createElement(SVGBaseElement, IShapeElement);
	
	IShapeElement.prototype.identityMatrix = new Matrix();
	
	IShapeElement.prototype.lcEnum = {
	    '1': 'butt',
	    '2': 'round',
	    '3': 'square'
	}
	
	IShapeElement.prototype.ljEnum = {
	    '1': 'miter',
	    '2': 'round',
	    '3': 'butt'
	}
	
	IShapeElement.prototype.searchProcessedElement = function(elem){
	    var i = this.processedElements.length;
	    while(i){
	        i -= 1;
	        if(this.processedElements[i].elem === elem){
	            return this.processedElements[i].pos;
	        }
	    }
	    return 0;
	};
	
	IShapeElement.prototype.addProcessedElement = function(elem, pos){
	    var i = this.processedElements.length;
	    while(i){
	        i -= 1;
	        if(this.processedElements[i].elem === elem){
	            this.processedElements[i].pos = pos;
	            break;
	        }
	    }
	    if(i === 0){
	        this.processedElements.push({
	            elem: elem,
	            pos: pos
	        })
	    }
	};
	
	IShapeElement.prototype.buildExpressionInterface = function(){};
	
	IShapeElement.prototype.createElements = function(){
	    //TODO check if I can use symbol so i can set its viewBox
	    this._parent.createElements.call(this);
	    this.searchShapes(this.shapesData,this.itemsData,this.prevViewData,this.layerElement,this.dynamicProperties, 0, [], true);
	    if(!this.data.hd || this.data.td){
	        styleUnselectableDiv(this.layerElement);
	    }
	};
	
	IShapeElement.prototype.setGradientData = function(pathElement,arr,data){
	
	    var gradientId = 'gr_'+randomString(10);
	    var gfill;
	    if(arr.t === 1){
	        gfill = createNS('linearGradient');
	    } else {
	        gfill = createNS('radialGradient');
	    }
	    gfill.setAttribute('id',gradientId);
	    gfill.setAttribute('spreadMethod','pad');
	    gfill.setAttribute('gradientUnits','userSpaceOnUse');
	    var stops = [];
	    var stop, j, jLen;
	    jLen = arr.g.p*4;
	    for(j=0;j<jLen;j+=4){
	        stop = createNS('stop');
	        gfill.appendChild(stop);
	        stops.push(stop);
	    }
	    pathElement.setAttribute( arr.ty === 'gf' ? 'fill':'stroke','url(#'+gradientId+')');
	    this.globalData.defs.appendChild(gfill);
	    data.gf = gfill;
	    data.cst = stops;
	}
	
	IShapeElement.prototype.setGradientOpacity = function(arr, data, styleOb){
	    if((arr.g.k.k[0].s && arr.g.k.k[0].s.length > arr.g.p*4) || arr.g.k.k.length > arr.g.p*4){
	        var opFill;
	        var stop, j, jLen;
	        var mask = createNS("mask");
	        var maskElement = createNS( 'path');
	        mask.appendChild(maskElement);
	        var opacityId = 'op_'+randomString(10);
	        var maskId = 'mk_'+randomString(10);
	        mask.setAttribute('id',maskId);
	        if(arr.t === 1){
	            opFill = createNS('linearGradient');
	        } else {
	            opFill = createNS('radialGradient');
	        }
	        opFill.setAttribute('id',opacityId);
	        opFill.setAttribute('spreadMethod','pad');
	        opFill.setAttribute('gradientUnits','userSpaceOnUse');
	        jLen = arr.g.k.k[0].s ? arr.g.k.k[0].s.length : arr.g.k.k.length;
	        var stops = [];
	        for(j=arr.g.p*4;j<jLen;j+=2){
	            stop = createNS('stop');
	            stop.setAttribute('stop-color','rgb(255,255,255)');
	            //stop.setAttribute('offset',Math.round(arr.y[j][0]*100)+'%');
	            //stop.setAttribute('style','stop-color:rgb(255,255,255);stop-opacity:'+arr.y[j][1]);
	            opFill.appendChild(stop);
	            stops.push(stop);
	        }
	        maskElement.setAttribute( arr.ty === 'gf' ? 'fill':'stroke','url(#'+opacityId+')');
	        this.globalData.defs.appendChild(opFill);
	        this.globalData.defs.appendChild(mask);
	        data.of = opFill;
	        data.ost = stops;
	        styleOb.msElem = maskElement;
	        return maskId;
	    }
	};
	
	IShapeElement.prototype.createStyleElement = function(data, level, dynamicProperties){
	    var elementData = {
	    };
	    var styleOb = {
	        data: data,
	        type: data.ty,
	        d: '',
	        ld: '',
	        lvl: level,
	        mdf: false,
	        closed: false
	    };
	    var pathElement = createNS( "path");
	    elementData.o = PropertyFactory.getProp(this,data.o,0,0.01,dynamicProperties);
	    if(data.ty == 'st' || data.ty == 'gs') {
	        pathElement.setAttribute('stroke-linecap', this.lcEnum[data.lc] || 'round');
	        ////pathElement.style.strokeLinecap = this.lcEnum[data.lc] || 'round';
	        pathElement.setAttribute('stroke-linejoin',this.ljEnum[data.lj] || 'round');
	        ////pathElement.style.strokeLinejoin = this.ljEnum[data.lj] || 'round';
	        pathElement.setAttribute('fill-opacity','0');
	        ////pathElement.style.fillOpacity = 0;
	        if(data.lj == 1) {
	            pathElement.setAttribute('stroke-miterlimit',data.ml);
	            ////pathElement.style.strokeMiterlimit = data.ml;
	        }
	
	        elementData.w = PropertyFactory.getProp(this,data.w,0,null,dynamicProperties);
	        if(data.d){
	            var d = new DashProperty(this,data.d,'svg',dynamicProperties);
	            if(!d.k){
	                pathElement.setAttribute('stroke-dasharray', d.dasharray);
	                ////pathElement.style.strokeDasharray = d.dasharray;
	                pathElement.setAttribute('stroke-dashoffset', d.dashoffset[0]);
	                ////pathElement.style.strokeDashoffset = d.dashoffset;
	            }
	            elementData.d = d;
	        }
	
	    }
	    if(data.ty == 'fl' || data.ty == 'st'){
	        elementData.c = PropertyFactory.getProp(this,data.c,1,255,dynamicProperties);
	    } else {
	        elementData.g = new GradientProperty(this,data.g,dynamicProperties);
	        if(data.t == 2){
	            elementData.h = PropertyFactory.getProp(this,data.h,0,0.01,dynamicProperties);
	            elementData.a = PropertyFactory.getProp(this,data.a,0,degToRads,dynamicProperties);
	        }
	        elementData.s = PropertyFactory.getProp(this,data.s,1,null,dynamicProperties);
	        elementData.e = PropertyFactory.getProp(this,data.e,1,null,dynamicProperties);
	        this.setGradientData(pathElement,data,elementData, styleOb);
	        var maskId = this.setGradientOpacity(data,elementData, styleOb);
	        if(maskId){
	            pathElement.setAttribute('mask','url(#'+maskId+')');
	        }
	    }
	    elementData.elem = pathElement;
	    //container.appendChild(pathElement);
	    if(data.r === 2) {
	        pathElement.setAttribute('fill-rule', 'evenodd');
	    }
	
	    if(data.ln){
	        pathElement.setAttribute('id',data.ln);
	    }
	    if(data.cl){
	        pathElement.setAttribute('class',data.cl);
	    }
	    styleOb.pElem = pathElement;
	    this.stylesList.push(styleOb);
	    elementData.style = styleOb;
	    return elementData;
	}
	
	IShapeElement.prototype.createGroupElement = function(data) {
	    var elementData = {
	        it: [],
	        prevViewData: []
	    };
	    var g = createNS('g');
	    elementData.gr = g;
	    if(data.ln){
	        elementData.gr.setAttribute('id',data.ln);
	    }
	    return elementData;
	}
	
	IShapeElement.prototype.createTransformElement = function(data, dynamicProperties) {
	    var elementData = {
	        transform : {
	            op: PropertyFactory.getProp(this,data.o,0,0.01,dynamicProperties),
	            mProps: TransformPropertyFactory.getTransformProperty(this,data,dynamicProperties)
	            //mProps: PropertyFactory.getProp(this,data,2,null,dynamicProperties)
	        },
	        elements: []
	    };
	    return elementData;
	}
	
	IShapeElement.prototype.createShapeElement = function(data, ownTransformers, level, dynamicProperties) {
	    var elementData = {
	        elements : [],
	        caches:[],
	        styles : [],
	        transformers: ownTransformers,
	        lStr: ''
	    };
	    var ty = 4;
	    if(data.ty == 'rc'){
	        ty = 5;
	    }else if(data.ty == 'el'){
	        ty = 6;
	    }else if(data.ty == 'sr'){
	        ty = 7;
	    }
	    elementData.sh = ShapePropertyFactory.getShapeProp(this,data,ty,dynamicProperties);
	    elementData.lvl = level;
	    this.shapes.push(elementData.sh);
	    this.addShapeToModifiers(elementData);
	    return elementData;
	}
	
	var cont = 0;
	
	IShapeElement.prototype.setElementStyles = function(){
	    var j, jLen = this.stylesList.length;
	    var arr = [];
	    for(j=0;j<jLen;j+=1){
	        if(!this.stylesList[j].closed){
	            arr.push(this.stylesList[j]);
	        }
	    }
	    return arr;
	}
	
	IShapeElement.prototype.reloadShapes = function(){
	    this.firstFrame = true;
	    var i, len = this.itemsData.length;
	    for(i=0;i<len;i+=1){
	        this.prevViewData[i] = this.itemsData[i];
	    }
	    this.searchShapes(this.shapesData,this.itemsData,this.prevViewData,this.layerElement,this.dynamicProperties, 0, [], true);
	    var i, len = this.dynamicProperties.length;
	    for(i=0;i<len;i+=1){
	        this.dynamicProperties[i].getValue();
	    }
	    this.renderModifiers();
	}
	
	IShapeElement.prototype.searchShapes = function(arr,itemsData,prevViewData,container,dynamicProperties, level, transformers, render){
	    var ownTransformers = [].concat(transformers);
	    var i, len = arr.length - 1;
	    var j, jLen;
	    var ownStyles = [], ownModifiers = [], styleOb, currentTransform, modifier, processedPos;
	    for(i=len;i>=0;i-=1){
	        processedPos = this.searchProcessedElement(arr[i]);
	        if(!processedPos){
	            arr[i]._render = render;
	        } else {
	            itemsData[i] = prevViewData[processedPos - 1];
	        }
	        if(arr[i].ty == 'fl' || arr[i].ty == 'st' || arr[i].ty == 'gf' || arr[i].ty == 'gs'){
	            if(!processedPos){
	                itemsData[i] = this.createStyleElement(arr[i], level, dynamicProperties);
	            } else {
	                itemsData[i].style.closed = false;
	            }
	            if(arr[i]._render){
	                container.appendChild(itemsData[i].elem);
	            }
	            ownStyles.push(itemsData[i].style);
	        }else if(arr[i].ty == 'gr'){
	            if(!processedPos){
	                itemsData[i] = this.createGroupElement(arr[i]);
	            } else {
	                jLen = itemsData[i].it.length;
	                for(j=0;j<jLen;j+=1){
	                    itemsData[i].prevViewData[j] = itemsData[i].it[j];
	                }
	            }
	            this.searchShapes(arr[i].it,itemsData[i].it,itemsData[i].prevViewData,itemsData[i].gr,dynamicProperties, level + 1, ownTransformers, render);
	            if(arr[i]._render){
	                container.appendChild(itemsData[i].gr);
	            }
	        }else if(arr[i].ty == 'tr'){
	            if(!processedPos){
	                itemsData[i] = this.createTransformElement(arr[i], dynamicProperties);
	            }
	            currentTransform = itemsData[i].transform;
	            ownTransformers.push(currentTransform);
	        }else if(arr[i].ty == 'sh' || arr[i].ty == 'rc' || arr[i].ty == 'el' || arr[i].ty == 'sr'){
	            if(!processedPos){
	                itemsData[i] = this.createShapeElement(arr[i], ownTransformers, level, dynamicProperties);
	            }
	            itemsData[i].elements = this.setElementStyles();
	
	        }else if(arr[i].ty == 'tm' || arr[i].ty == 'rd' || arr[i].ty == 'ms'){
	            if(!processedPos){
	                modifier = ShapeModifiers.getModifier(arr[i].ty);
	                modifier.init(this,arr[i],dynamicProperties);
	                itemsData[i] = modifier;
	                this.shapeModifiers.push(modifier);
	            } else {
	                modifier = itemsData[i];
	                modifier.closed = false;
	            }
	            ownModifiers.push(modifier);
	        }else if(arr[i].ty == 'rp'){
	            if(!processedPos){
	                modifier = ShapeModifiers.getModifier(arr[i].ty);
	                itemsData[i] = modifier;
	                modifier.init(this,arr,i,itemsData,dynamicProperties);
	                this.shapeModifiers.push(modifier);
	                render = false;
	            }else{
	                modifier = itemsData[i];
	                modifier.closed = true;
	            }
	            ownModifiers.push(modifier);
	        }
	        this.addProcessedElement(arr[i], i + 1);
	    }
	    len = ownStyles.length;
	    for(i=0;i<len;i+=1){
	        ownStyles[i].closed = true;
	    }
	    len = ownModifiers.length;
	    for(i=0;i<len;i+=1){
	        ownModifiers[i].closed = true;
	    }
	};
	
	IShapeElement.prototype.addShapeToModifiers = function(data) {
	    var i, len = this.shapeModifiers.length;
	    for(i=0;i<len;i+=1){
	        this.shapeModifiers[i].addShape(data);
	    }
	};
	
	IShapeElement.prototype.renderModifiers = function() {
	    if(!this.shapeModifiers.length){
	        return;
	    }
	    var i, len = this.shapes.length;
	    for(i=0;i<len;i+=1){
	        this.shapes[i].reset();
	    }
	
	
	    len = this.shapeModifiers.length;
	
	    for(i=len-1;i>=0;i-=1){
	        this.shapeModifiers[i].processShapes(this.firstFrame);
	    }
	};
	
	IShapeElement.prototype.renderFrame = function(parentMatrix){
	    //this.reloadShapes();
	    var renderParent = this._parent.renderFrame.call(this,parentMatrix);
	    if(renderParent===false){
	        this.hide();
	        return;
	    }
	    if(this.hidden){
	        this.layerElement.style.display = 'block';
	        this.hidden = false;
	    }
	    this.renderModifiers();
	    var i, len = this.stylesList.length;
	    for(i=0;i<len;i+=1){
	        this.stylesList[i].d = '';
	        this.stylesList[i].mdf = false;
	    }
	    this.renderShape(this.shapesData,this.itemsData, null);
	
	    for (i = 0; i < len; i += 1) {
	        if (this.stylesList[i].ld === '0') {
	            this.stylesList[i].ld = '1';
	            this.stylesList[i].pElem.style.display = 'block';
	            //this.stylesList[i].parent.appendChild(this.stylesList[i].pElem);
	        }
	        if (this.stylesList[i].mdf || this.firstFrame) {
	            this.stylesList[i].pElem.setAttribute('d', this.stylesList[i].d || 'M0 0');
	            if(this.stylesList[i].msElem){
	                this.stylesList[i].msElem.setAttribute('d', this.stylesList[i].d);
	            }
	        }
	    }
	    if (this.firstFrame) {
	        this.firstFrame = false;
	    }
	};
	
	IShapeElement.prototype.hide = function(){
	    if(!this.hidden){
	        this.layerElement.style.display = 'none';
	        var i, len = this.stylesList.length;
	        for(i=len-1;i>=0;i-=1){
	            if(this.stylesList[i].ld !== '0'){
	                this.stylesList[i].ld = '0';
	                this.stylesList[i].pElem.style.display = 'none';
	                if(this.stylesList[i].pElem.parentNode){
	                    this.stylesList[i].parent = this.stylesList[i].pElem.parentNode;
	                    //this.stylesList[i].pElem.parentNode.removeChild(this.stylesList[i].pElem);
	                }
	            }
	        }
	        this.hidden = true;
	    }
	};
	
	IShapeElement.prototype.renderShape = function(items,data, container){
	    var i, len = items.length - 1;
	    var ty;
	    for(i=0;i<=len;i+=1){
	        ty = items[i].ty;
	        if(ty == 'tr'){
	            if(this.firstFrame || data[i].transform.op.mdf && container){
	                container.setAttribute('opacity',data[i].transform.op.v);
	            }
	            if(this.firstFrame || data[i].transform.mProps.mdf && container){
	                container.setAttribute('transform',data[i].transform.mProps.v.to2dCSS());
	            }
	        }else if(ty == 'sh' || ty == 'el' || ty == 'rc' || ty == 'sr'){
	            this.renderPath(items[i],data[i]);
	        }else if(ty == 'fl'){
	            this.renderFill(items[i],data[i]);
	        }else if(ty == 'gf'){
	            this.renderGradient(items[i],data[i]);
	        }else if(ty == 'gs'){
	            this.renderGradient(items[i],data[i]);
	            this.renderStroke(items[i],data[i]);
	        }else if(ty == 'st'){
	            this.renderStroke(items[i],data[i]);
	        }else if(ty == 'gr'){
	            this.renderShape(items[i].it,data[i].it, data[i].gr);
	        }else if(ty == 'tm'){
	            //
	        }
	    }
	
	};
	
	IShapeElement.prototype.buildShapeString = function(pathNodes, length, closed, mat) {
	    var i, shapeString = '';
	    for(i = 1; i < length; i += 1) {
	        if (i === 1) {
	            shapeString += " M" + mat.applyToPointStringified(pathNodes.v[0][0], pathNodes.v[0][1]);
	        }
	        shapeString += " C" + mat.applyToPointStringified(pathNodes.o[i - 1][0], pathNodes.o[i - 1][1]) + " " + mat.applyToPointStringified(pathNodes.i[i][0], pathNodes.i[i][1]) + " " + mat.applyToPointStringified(pathNodes.v[i][0], pathNodes.v[i][1]);
	    }
	    if (length === 1) {
	        shapeString += " M" + mat.applyToPointStringified(pathNodes.v[0][0], pathNodes.v[0][1]);
	    }
	    if (closed && length) {
	        shapeString += " C" + mat.applyToPointStringified(pathNodes.o[i - 1][0], pathNodes.o[i - 1][1]) + " " + mat.applyToPointStringified(pathNodes.i[0][0], pathNodes.i[0][1]) + " " + mat.applyToPointStringified(pathNodes.v[0][0], pathNodes.v[0][1]);
	        shapeString += 'z';
	    }
	    return shapeString;
	};
	
	IShapeElement.prototype.renderPath = function(pathData,itemData){
	    var len, i, j, jLen,pathStringTransformed,redraw,pathNodes,l, lLen = itemData.elements.length;
	    var lvl = itemData.lvl;
	    if(!pathData._render){
	        return;
	    }
	    for(l=0;l<lLen;l+=1){
	        if(itemData.elements[l].data._render){
	            redraw = itemData.sh.mdf || this.firstFrame;
	            //M0 0 is needed for IE and Edge bug. If it's missing, and shape has a mask with a gradient fill, it won't show up. :/
	            //Removing it because it's causing issues with Chrome, and also it's probably better not to have it so the shape won't be larger than needed.
	            //Keeping previous comment to try to find a solution.
	            pathStringTransformed = '';
	            var paths = itemData.sh.paths;
	            jLen = paths._length;
	
	            if(itemData.elements[l].lvl < lvl){
	                mat = this.mHelper.reset();
	                iterations = lvl - itemData.elements[l].lvl;
	                k = itemData.transformers.length-1;
	                while(iterations > 0) {
	                    redraw = itemData.transformers[k].mProps.mdf || redraw;
	                    props = itemData.transformers[k].mProps.v.props;
	                    mat.transform(props[0],props[1],props[2],props[3],props[4],props[5],props[6],props[7],props[8],props[9],props[10],props[11],props[12],props[13],props[14],props[15]);
	                    iterations --;
	                    k --;
	                }
	            } else {
	                mat = this.identityMatrix;
	            }
	            if(redraw){
	                for(j=0;j<jLen;j+=1){
	                    pathNodes = paths.shapes[j];
	                    if(pathNodes && pathNodes._length){
	                        pathStringTransformed += this.buildShapeString(pathNodes, pathNodes._length, pathNodes.c, mat);
	                    }
	                }
	                itemData.caches[l] = pathStringTransformed;
	            } else {
	                pathStringTransformed = itemData.caches[l];
	            }
	            itemData.elements[l].d += pathStringTransformed;
	            itemData.elements[l].mdf = redraw || itemData.elements[l].mdf;
	        } else {
	            itemData.elements[l].mdf = true;
	        }
	    }
	};
	
	IShapeElement.prototype.renderFill = function(styleData,itemData){
	    var styleElem = itemData.style;
	
	    if(itemData.c.mdf || this.firstFrame){
	        styleElem.pElem.setAttribute('fill','rgb('+bm_floor(itemData.c.v[0])+','+bm_floor(itemData.c.v[1])+','+bm_floor(itemData.c.v[2])+')');
	        ////styleElem.pElem.style.fill = 'rgb('+bm_floor(itemData.c.v[0])+','+bm_floor(itemData.c.v[1])+','+bm_floor(itemData.c.v[2])+')';
	    }
	    if(itemData.o.mdf || this.firstFrame){
	        styleElem.pElem.setAttribute('fill-opacity',itemData.o.v);
	    }
	};
	
	IShapeElement.prototype.renderGradient = function(styleData,itemData){
	    var gfill = itemData.gf;
	    var opFill = itemData.of;
	    var pt1 = itemData.s.v,pt2 = itemData.e.v;
	
	    if(itemData.o.mdf || this.firstFrame){
	        var attr = styleData.ty === 'gf' ? 'fill-opacity':'stroke-opacity';
	        itemData.elem.setAttribute(attr,itemData.o.v);
	    }
	    //clippedElement.setAttribute('transform','matrix(1,0,0,1,-100,0)');
	    if(itemData.s.mdf || this.firstFrame){
	        var attr1 = styleData.t === 1 ? 'x1':'cx';
	        var attr2 = attr1 === 'x1' ? 'y1':'cy';
	        gfill.setAttribute(attr1,pt1[0]);
	        gfill.setAttribute(attr2,pt1[1]);
	        if(opFill){
	            opFill.setAttribute(attr1,pt1[0]);
	            opFill.setAttribute(attr2,pt1[1]);
	        }
	    }
	    var stops, i, len, stop;
	    if(itemData.g.cmdf || this.firstFrame){
	        stops = itemData.cst;
	        var cValues = itemData.g.c;
	        len = stops.length;
	        for(i=0;i<len;i+=1){
	            stop = stops[i];
	            stop.setAttribute('offset',cValues[i*4]+'%');
	            stop.setAttribute('stop-color','rgb('+cValues[i*4+1]+','+cValues[i*4+2]+','+cValues[i*4+3]+')');
	        }
	    }
	    if(opFill && (itemData.g.omdf || this.firstFrame)){
	        stops = itemData.ost;
	        var oValues = itemData.g.o;
	        len = stops.length;
	        for(i=0;i<len;i+=1){
	            stop = stops[i];
	            stop.setAttribute('offset',oValues[i*2]+'%');
	            stop.setAttribute('stop-opacity',oValues[i*2+1]);
	        }
	    }
	    if(styleData.t === 1){
	        if(itemData.e.mdf  || this.firstFrame){
	            gfill.setAttribute('x2',pt2[0]);
	            gfill.setAttribute('y2',pt2[1]);
	            if(opFill){
	                opFill.setAttribute('x2',pt2[0]);
	                opFill.setAttribute('y2',pt2[1]);
	            }
	        }
	    } else {
	        var rad;
	        if(itemData.s.mdf || itemData.e.mdf || this.firstFrame){
	            rad = Math.sqrt(Math.pow(pt1[0]-pt2[0],2)+Math.pow(pt1[1]-pt2[1],2));
	            gfill.setAttribute('r',rad);
	            if(opFill){
	                opFill.setAttribute('r',rad);
	            }
	        }
	        if(itemData.e.mdf || itemData.h.mdf || itemData.a.mdf || this.firstFrame){
	            if(!rad){
	                rad = Math.sqrt(Math.pow(pt1[0]-pt2[0],2)+Math.pow(pt1[1]-pt2[1],2));
	            }
	            var ang = Math.atan2(pt2[1]-pt1[1], pt2[0]-pt1[0]);
	
	            var percent = itemData.h.v >= 1 ? 0.99 : itemData.h.v <= -1 ? -0.99:itemData.h.v;
	            var dist = rad*percent;
	            var x = Math.cos(ang + itemData.a.v)*dist + pt1[0];
	            var y = Math.sin(ang + itemData.a.v)*dist + pt1[1];
	            gfill.setAttribute('fx',x);
	            gfill.setAttribute('fy',y);
	            if(opFill){
	                opFill.setAttribute('fx',x);
	                opFill.setAttribute('fy',y);
	            }
	        }
	        //gfill.setAttribute('fy','200');
	    }
	};
	
	IShapeElement.prototype.renderStroke = function(styleData,itemData){
	    var styleElem = itemData.style;
	    var d = itemData.d;
	    if(d && (d.mdf || this.firstFrame)){
	        styleElem.pElem.setAttribute('stroke-dasharray', d.dashStr);
	        styleElem.pElem.setAttribute('stroke-dashoffset', d.dashoffset[0]);
	    }
	    if(itemData.c && (itemData.c.mdf || this.firstFrame)){
	        styleElem.pElem.setAttribute('stroke','rgb('+bm_floor(itemData.c.v[0])+','+bm_floor(itemData.c.v[1])+','+bm_floor(itemData.c.v[2])+')');
	    }
	    if(itemData.o.mdf || this.firstFrame){
	        styleElem.pElem.setAttribute('stroke-opacity',itemData.o.v);
	    }
	    if(itemData.w.mdf || this.firstFrame){
	        styleElem.pElem.setAttribute('stroke-width',itemData.w.v);
	        if(styleElem.msElem){
	            styleElem.msElem.setAttribute('stroke-width',itemData.w.v);
	        }
	    }
	};
	
	IShapeElement.prototype.destroy = function(){
	    this._parent.destroy.call(this._parent);
	    this.shapeData = null;
	    this.itemsData = null;
	    this.parentContainer = null;
	    this.placeholder = null;
	};
	
	function ITextElement(data, animationItem,parentContainer,globalData){
	}
	ITextElement.prototype.init = function(){
	    this.lettersChangedFlag = true;
	    this.dynamicProperties = this.dynamicProperties || [];
	    this.textAnimator = new TextAnimatorProperty(this.data.t, this.renderType, this);
	    this.textProperty = new TextProperty(this, this.data.t, this.dynamicProperties);
	    this._parent.init.call(this);
	    this.textAnimator.searchProperties(this.dynamicProperties);
	};
	
	ITextElement.prototype.prepareFrame = function(num) {
	    this._parent.prepareFrame.call(this, num);
	    if(this.textProperty.mdf || this.textProperty.firstFrame) {
	        this.buildNewText();
	        this.textProperty.firstFrame = false;
	    }
	}
	
	ITextElement.prototype.createPathShape = function(matrixHelper, shapes) {
	    var j,jLen = shapes.length;
	    var k, kLen, pathNodes;
	    var shapeStr = '';
	    for(j=0;j<jLen;j+=1){
	        pathNodes = shapes[j].ks.k;
	        shapeStr += this.buildShapeString(pathNodes, pathNodes.i.length, true, matrixHelper);
	    }
	    return shapeStr;
	};
	
	ITextElement.prototype.updateDocumentData = function(newData, index) {
	    this.textProperty.updateDocumentData(newData, index);
	}
	
	ITextElement.prototype.applyTextPropertiesToMatrix = function(documentData, matrixHelper, lineNumber, xPos, yPos) {
	    if(documentData.ps){
	        matrixHelper.translate(documentData.ps[0],documentData.ps[1] + documentData.ascent,0);
	    }
	    matrixHelper.translate(0,-documentData.ls,0);
	    switch(documentData.j){
	        case 1:
	            matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[lineNumber]),0,0);
	            break;
	        case 2:
	            matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[lineNumber] )/2,0,0);
	            break;
	    }
	    matrixHelper.translate(xPos, yPos, 0);
	}
	
	ITextElement.prototype.buildColor = function(colorData) {
	    return 'rgb(' + Math.round(colorData[0]*255) + ',' + Math.round(colorData[1]*255) + ',' + Math.round(colorData[2]*255) + ')';
	}
	
	ITextElement.prototype.buildShapeString = IShapeElement.prototype.buildShapeString;
	
	ITextElement.prototype.emptyProp = new LetterProps();
	
	ITextElement.prototype.destroy = function(){
	    this._parent.destroy.call(this._parent);
	};
	function SVGTextElement(data,parentContainer,globalData,comp, placeholder){
	    this.textSpans = [];
	    this.renderType = 'svg';
	    this._parent.constructor.call(this,data,parentContainer,globalData,comp, placeholder);
	}
	createElement(SVGBaseElement, SVGTextElement);
	
	extendPrototype(ITextElement, SVGTextElement);
	
	SVGTextElement.prototype.createElements = function(){
	
	    this._parent.createElements.call(this);
	
	
	    if(this.data.ln){
	        this.layerElement.setAttribute('id',this.data.ln);
	    }
	    if(this.data.cl){
	        this.layerElement.setAttribute('class',this.data.cl);
	    }
	    if (this.data.singleShape && !this.globalData.fontManager.chars) {
	        this.textContainer = createNS('text');
	    }
	};
	
	SVGTextElement.prototype.buildNewText = function(){
	    var i, len;
	
	    var documentData = this.textProperty.currentData;
	    this.renderedLetters = Array.apply(null,{length:documentData ? documentData.l.length : 0});
	    if(documentData.fc) {
	        this.layerElement.setAttribute('fill', this.buildColor(documentData.fc));
	    }else{
	        this.layerElement.setAttribute('fill', 'rgba(0,0,0,0)');
	    }
	    if(documentData.sc){
	        this.layerElement.setAttribute('stroke', this.buildColor(documentData.sc));
	        this.layerElement.setAttribute('stroke-width', documentData.sw);
	    }
	    this.layerElement.setAttribute('font-size', documentData.s);
	    var fontData = this.globalData.fontManager.getFontByName(documentData.f);
	    if(fontData.fClass){
	        this.layerElement.setAttribute('class',fontData.fClass);
	    } else {
	        this.layerElement.setAttribute('font-family', fontData.fFamily);
	        var fWeight = documentData.fWeight, fStyle = documentData.fStyle;
	        this.layerElement.setAttribute('font-style', fStyle);
	        this.layerElement.setAttribute('font-weight', fWeight);
	    }
	
	    var letters = documentData.l || [];
	    var usesGlyphs = this.globalData.fontManager.chars;
	    len = letters.length;
	    if(!len){
	        return;
	    }
	    var tSpan;
	    var matrixHelper = this.mHelper;
	    var shapes, shapeStr = '', singleShape = this.data.singleShape;
	    var xPos = 0, yPos = 0, firstLine = true;
	    var trackingOffset = documentData.tr/1000*documentData.s;
	    if(singleShape && !usesGlyphs) {
	        var tElement = this.textContainer;
	        var justify = '';
	        switch(documentData.j) {
	            case 1:
	                justify = 'end';
	                break;
	            case 2:
	                justify = 'middle';
	                break;
	            case 2:
	                justify = 'start';
	                break;
	        }
	        tElement.setAttribute('text-anchor',justify);
	        tElement.setAttribute('letter-spacing',trackingOffset);
	        var textContent = documentData.t.split(String.fromCharCode(13));
	        len = textContent.length;
	        var yPos = documentData.ps ? documentData.ps[1] + documentData.ascent : 0;
	        for ( i = 0; i < len; i += 1) {
	            tSpan = this.textSpans[i] || createNS('tspan');
	            tSpan.textContent = textContent[i];
	            tSpan.setAttribute('x', 0);
	            tSpan.setAttribute('y', yPos);
	            tSpan.style.display = 'inherit';
	            tElement.appendChild(tSpan);
	            this.textSpans[i] = tSpan;
	            yPos += documentData.lh;
	        }
	        
	        this.layerElement.appendChild(tElement);
	    } else {
	        var cachedSpansLength = this.textSpans.length;
	        var shapeData, charData;
	        for (i = 0; i < len; i += 1) {
	            if(!usesGlyphs || !singleShape || i === 0){
	                tSpan = cachedSpansLength > i ? this.textSpans[i] : createNS(usesGlyphs?'path':'text');
	                if (cachedSpansLength <= i) {
	                    tSpan.setAttribute('stroke-linecap', 'butt');
	                    tSpan.setAttribute('stroke-linejoin','round');
	                    tSpan.setAttribute('stroke-miterlimit','4');
	                    this.textSpans[i] = tSpan;
	                    this.layerElement.appendChild(tSpan);
	                }
	                tSpan.style.display = 'inherit';
	            }
	            
	            matrixHelper.reset();
	            if(usesGlyphs) {
	                matrixHelper.scale(documentData.s / 100, documentData.s / 100);
	                if (singleShape) {
	                    if(letters[i].n) {
	                        xPos = -trackingOffset;
	                        yPos += documentData.yOffset;
	                        yPos += firstLine ? 1 : 0;
	                        firstLine = false;
	                    }
	                    this.applyTextPropertiesToMatrix(documentData, matrixHelper, letters[i].line, xPos, yPos);
	                    xPos += letters[i].l || 0;
	                    //xPos += letters[i].val === ' ' ? 0 : trackingOffset;
	                    xPos += trackingOffset;
	                }
	                charData = this.globalData.fontManager.getCharData(documentData.t.charAt(i), fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
	                shapeData = charData && charData.data || {};
	                shapes = shapeData.shapes ? shapeData.shapes[0].it : [];
	                if(!singleShape){
	                    tSpan.setAttribute('d',this.createPathShape(matrixHelper,shapes));
	                } else {
	                    shapeStr += this.createPathShape(matrixHelper,shapes);
	                }
	            } else {
	                tSpan.textContent = letters[i].val;
	                tSpan.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space","preserve");
	            }
	            //
	        }
	        if (singleShape) {
	            tSpan.setAttribute('d',shapeStr);
	        }
	    }
	    while (i < this.textSpans.length){
	        this.textSpans[i].style.display = 'none';
	        i += 1;
	    }
	    
	    this._sizeChanged = true;
	}
	
	SVGTextElement.prototype.sourceRectAtTime = function(time){
	    this.prepareFrame(this.comp.renderedFrame - this.data.st);
	    this.renderLetters();
	    if(this._sizeChanged){
	        this._sizeChanged = false;
	        var textBox = this.layerElement.getBBox();
	        this.bbox = {
	            top: textBox.y,
	            left: textBox.x,
	            width: textBox.width,
	            height: textBox.height
	        }
	    }
	    return this.bbox;
	}
	
	SVGTextElement.prototype.renderLetters = function(){
	
	    if(!this.data.singleShape){
	        this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
	        if(this.lettersChangedFlag || this.textAnimator.lettersChangedFlag){
	            this._sizeChanged = true;
	            var  i,len;
	            var renderedLetters = this.textAnimator.renderedLetters;
	
	            var letters = this.textProperty.currentData.l;
	
	            len = letters.length;
	            var renderedLetter, textSpan;
	            for(i=0;i<len;i+=1){
	                if(letters[i].n){
	                    continue;
	                }
	                renderedLetter = renderedLetters[i];
	                textSpan = this.textSpans[i];
	                if(renderedLetter.mdf.m) {
	                    textSpan.setAttribute('transform',renderedLetter.m);
	                }
	                if(renderedLetter.mdf.o) {
	                    textSpan.setAttribute('opacity',renderedLetter.o);
	                }
	                if(renderedLetter.mdf.sw){
	                    textSpan.setAttribute('stroke-width',renderedLetter.sw);
	                }
	                if(renderedLetter.mdf.sc){
	                    textSpan.setAttribute('stroke',renderedLetter.sc);
	                }
	                if(renderedLetter.mdf.fc){
	                    textSpan.setAttribute('fill',renderedLetter.fc);
	                }
	            }
	        }
	    }
	}
	
	SVGTextElement.prototype.renderFrame = function(parentMatrix){
	
	    var renderParent = this._parent.renderFrame.call(this,parentMatrix);
	    if(renderParent===false){
	        this.hide();
	        return;
	    }
	    if(this.hidden){
	        this.show();
	    }
	    if(this.firstFrame) {
	        this.firstFrame = false;
	    }
	    this.renderLetters();
	}
	function SVGTintFilter(filter, filterManager){
	    this.filterManager = filterManager;
	    var feColorMatrix = createNS('feColorMatrix');
	    feColorMatrix.setAttribute('type','matrix');
	    feColorMatrix.setAttribute('color-interpolation-filters','linearRGB');
	    feColorMatrix.setAttribute('values','0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0');
	    feColorMatrix.setAttribute('result','f1');
	    filter.appendChild(feColorMatrix);
	    feColorMatrix = createNS('feColorMatrix');
	    feColorMatrix.setAttribute('type','matrix');
	    feColorMatrix.setAttribute('color-interpolation-filters','sRGB');
	    feColorMatrix.setAttribute('values','1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0');
	    feColorMatrix.setAttribute('result','f2');
	    filter.appendChild(feColorMatrix);
	    this.matrixFilter = feColorMatrix;
	    if(filterManager.effectElements[2].p.v !== 100 || filterManager.effectElements[2].p.k){
	        var feMerge = createNS('feMerge');
	        filter.appendChild(feMerge);
	        var feMergeNode;
	        feMergeNode = createNS('feMergeNode');
	        feMergeNode.setAttribute('in','SourceGraphic');
	        feMerge.appendChild(feMergeNode);
	        feMergeNode = createNS('feMergeNode');
	        feMergeNode.setAttribute('in','f2');
	        feMerge.appendChild(feMergeNode);
	    }
	}
	
	SVGTintFilter.prototype.renderFrame = function(forceRender){
	    if(forceRender || this.filterManager.mdf){
	        var colorBlack = this.filterManager.effectElements[0].p.v;
	        var colorWhite = this.filterManager.effectElements[1].p.v;
	        var opacity = this.filterManager.effectElements[2].p.v/100;
	        this.matrixFilter.setAttribute('values',(colorWhite[0]- colorBlack[0])+' 0 0 0 '+ colorBlack[0] +' '+ (colorWhite[1]- colorBlack[1]) +' 0 0 0 '+ colorBlack[1] +' '+ (colorWhite[2]- colorBlack[2]) +' 0 0 0 '+ colorBlack[2] +' 0 0 0 ' + opacity + ' 0');
	    }
	};
	function SVGFillFilter(filter, filterManager){
	    this.filterManager = filterManager;
	    var feColorMatrix = createNS('feColorMatrix');
	    feColorMatrix.setAttribute('type','matrix');
	    feColorMatrix.setAttribute('color-interpolation-filters','sRGB');
	    feColorMatrix.setAttribute('values','1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0');
	    filter.appendChild(feColorMatrix);
	    this.matrixFilter = feColorMatrix;
	}
	SVGFillFilter.prototype.renderFrame = function(forceRender){
	    if(forceRender || this.filterManager.mdf){
	        var color = this.filterManager.effectElements[2].p.v;
	        var opacity = this.filterManager.effectElements[6].p.v;
	        this.matrixFilter.setAttribute('values','0 0 0 0 '+color[0]+' 0 0 0 0 '+color[1]+' 0 0 0 0 '+color[2]+' 0 0 0 '+opacity+' 0');
	    }
	};
	function SVGStrokeEffect(elem, filterManager){
	    this.initialized = false;
	    this.filterManager = filterManager;
	    this.elem = elem;
	    this.paths = [];
	}
	
	SVGStrokeEffect.prototype.initialize = function(){
	
	    var elemChildren = this.elem.layerElement.children || this.elem.layerElement.childNodes;
	    var path,groupPath, i, len;
	    if(this.filterManager.effectElements[1].p.v === 1){
	        len = this.elem.maskManager.masksProperties.length;
	        i = 0;
	    } else {
	        i = this.filterManager.effectElements[0].p.v - 1;
	        len = i + 1;
	    }
	    groupPath = createNS('g'); 
	    groupPath.setAttribute('fill','none');
	    groupPath.setAttribute('stroke-linecap','round');
	    groupPath.setAttribute('stroke-dashoffset',1);
	    for(i;i<len;i+=1){
	        path = createNS('path');
	        groupPath.appendChild(path);
	        this.paths.push({p:path,m:i});
	    }
	    if(this.filterManager.effectElements[10].p.v === 3){
	        var mask = createNS('mask');
	        var id = 'stms_' + randomString(10);
	        mask.setAttribute('id',id);
	        mask.setAttribute('mask-type','alpha');
	        mask.appendChild(groupPath);
	        this.elem.globalData.defs.appendChild(mask);
	        var g = createNS('g');
	        g.setAttribute('mask','url(' + locationHref + '#'+id+')');
	        if(elemChildren[0]){
	            g.appendChild(elemChildren[0]);
	        }
	        this.elem.layerElement.appendChild(g);
	        this.masker = mask;
	        groupPath.setAttribute('stroke','#fff');
	    } else if(this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2){
	        if(this.filterManager.effectElements[10].p.v === 2){
	            var elemChildren = this.elem.layerElement.children || this.elem.layerElement.childNodes;
	            while(elemChildren.length){
	                this.elem.layerElement.removeChild(elemChildren[0]);
	            }
	        }
	        this.elem.layerElement.appendChild(groupPath);
	        this.elem.layerElement.removeAttribute('mask');
	        groupPath.setAttribute('stroke','#fff');
	    }
	    this.initialized = true;
	    this.pathMasker = groupPath;
	}
	
	SVGStrokeEffect.prototype.renderFrame = function(forceRender){
	    if(!this.initialized){
	        this.initialize();
	    }
	    var i, len = this.paths.length;
	    var mask, path;
	    for(i=0;i<len;i+=1){
	        mask = this.elem.maskManager.viewData[this.paths[i].m];
	        path = this.paths[i].p;
	        if(forceRender || this.filterManager.mdf || mask.prop.mdf){
	            path.setAttribute('d',mask.lastPath);
	        }
	        if(forceRender || this.filterManager.effectElements[9].p.mdf || this.filterManager.effectElements[4].p.mdf || this.filterManager.effectElements[7].p.mdf || this.filterManager.effectElements[8].p.mdf || mask.prop.mdf){
	            var dasharrayValue;
	            if(this.filterManager.effectElements[7].p.v !== 0 || this.filterManager.effectElements[8].p.v !== 100){
	                var s = Math.min(this.filterManager.effectElements[7].p.v,this.filterManager.effectElements[8].p.v)/100;
	                var e = Math.max(this.filterManager.effectElements[7].p.v,this.filterManager.effectElements[8].p.v)/100;
	                var l = path.getTotalLength();
	                dasharrayValue = '0 0 0 ' + l*s + ' ';
	                var lineLength = l*(e-s);
	                var segment = 1+this.filterManager.effectElements[4].p.v*2*this.filterManager.effectElements[9].p.v/100;
	                var units = Math.floor(lineLength/segment);
	                var j;
	                for(j=0;j<units;j+=1){
	                    dasharrayValue += '1 ' + this.filterManager.effectElements[4].p.v*2*this.filterManager.effectElements[9].p.v/100 + ' ';
	                }
	                dasharrayValue += '0 ' + l*10 + ' 0 0';
	            } else {
	                dasharrayValue = '1 ' + this.filterManager.effectElements[4].p.v*2*this.filterManager.effectElements[9].p.v/100;
	            }
	            path.setAttribute('stroke-dasharray',dasharrayValue);
	        }
	    }
	    if(forceRender || this.filterManager.effectElements[4].p.mdf){
	        this.pathMasker.setAttribute('stroke-width',this.filterManager.effectElements[4].p.v*2);
	    }
	    
	    if(forceRender || this.filterManager.effectElements[6].p.mdf){
	        this.pathMasker.setAttribute('opacity',this.filterManager.effectElements[6].p.v);
	    }
	    if(this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2){
	        if(forceRender || this.filterManager.effectElements[3].p.mdf){
	            var color = this.filterManager.effectElements[3].p.v;
	            this.pathMasker.setAttribute('stroke','rgb('+bm_floor(color[0]*255)+','+bm_floor(color[1]*255)+','+bm_floor(color[2]*255)+')');
	        }
	    }
	};
	function SVGTritoneFilter(filter, filterManager){
	    this.filterManager = filterManager;
	    var feColorMatrix = createNS('feColorMatrix');
	    feColorMatrix.setAttribute('type','matrix');
	    feColorMatrix.setAttribute('color-interpolation-filters','linearRGB');
	    feColorMatrix.setAttribute('values','0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0');
	    feColorMatrix.setAttribute('result','f1');
	    filter.appendChild(feColorMatrix);
	    var feComponentTransfer = createNS('feComponentTransfer');
	    feComponentTransfer.setAttribute('color-interpolation-filters','sRGB');
	    filter.appendChild(feComponentTransfer);
	    this.matrixFilter = feComponentTransfer;
	    var feFuncR = createNS('feFuncR');
	    feFuncR.setAttribute('type','table');
	    feComponentTransfer.appendChild(feFuncR);
	    this.feFuncR = feFuncR;
	    var feFuncG = createNS('feFuncG');
	    feFuncG.setAttribute('type','table');
	    feComponentTransfer.appendChild(feFuncG);
	    this.feFuncG = feFuncG;
	    var feFuncB = createNS('feFuncB');
	    feFuncB.setAttribute('type','table');
	    feComponentTransfer.appendChild(feFuncB);
	    this.feFuncB = feFuncB;
	}
	
	SVGTritoneFilter.prototype.renderFrame = function(forceRender){
	    if(forceRender || this.filterManager.mdf){
	        var color1 = this.filterManager.effectElements[0].p.v;
	        var color2 = this.filterManager.effectElements[1].p.v;
	        var color3 = this.filterManager.effectElements[2].p.v;
	        var tableR = color3[0] + ' ' + color2[0] + ' ' + color1[0]
	        var tableG = color3[1] + ' ' + color2[1] + ' ' + color1[1]
	        var tableB = color3[2] + ' ' + color2[2] + ' ' + color1[2]
	        this.feFuncR.setAttribute('tableValues', tableR);
	        this.feFuncG.setAttribute('tableValues', tableG);
	        this.feFuncB.setAttribute('tableValues', tableB);
	        //var opacity = this.filterManager.effectElements[2].p.v/100;
	        //this.matrixFilter.setAttribute('values',(colorWhite[0]- colorBlack[0])+' 0 0 0 '+ colorBlack[0] +' '+ (colorWhite[1]- colorBlack[1]) +' 0 0 0 '+ colorBlack[1] +' '+ (colorWhite[2]- colorBlack[2]) +' 0 0 0 '+ colorBlack[2] +' 0 0 0 ' + opacity + ' 0');
	    }
	};
	function SVGProLevelsFilter(filter, filterManager){
	    this.filterManager = filterManager;
	    var effectElements = this.filterManager.effectElements;
	    var feComponentTransfer = createNS('feComponentTransfer');
	    var feFuncR, feFuncG, feFuncB;
	    
	    if(effectElements[10].p.k || effectElements[10].p.v !== 0 || effectElements[11].p.k || effectElements[11].p.v !== 1 || effectElements[12].p.k || effectElements[12].p.v !== 1 || effectElements[13].p.k || effectElements[13].p.v !== 0 || effectElements[14].p.k || effectElements[14].p.v !== 1){
	        this.feFuncR = this.createFeFunc('feFuncR', feComponentTransfer);
	    }
	    if(effectElements[17].p.k || effectElements[17].p.v !== 0 || effectElements[18].p.k || effectElements[18].p.v !== 1 || effectElements[19].p.k || effectElements[19].p.v !== 1 || effectElements[20].p.k || effectElements[20].p.v !== 0 || effectElements[21].p.k || effectElements[21].p.v !== 1){
	        this.feFuncG = this.createFeFunc('feFuncG', feComponentTransfer);
	    }
	    if(effectElements[24].p.k || effectElements[24].p.v !== 0 || effectElements[25].p.k || effectElements[25].p.v !== 1 || effectElements[26].p.k || effectElements[26].p.v !== 1 || effectElements[27].p.k || effectElements[27].p.v !== 0 || effectElements[28].p.k || effectElements[28].p.v !== 1){
	        this.feFuncB = this.createFeFunc('feFuncB', feComponentTransfer);
	    }
	    if(effectElements[31].p.k || effectElements[31].p.v !== 0 || effectElements[32].p.k || effectElements[32].p.v !== 1 || effectElements[33].p.k || effectElements[33].p.v !== 1 || effectElements[34].p.k || effectElements[34].p.v !== 0 || effectElements[35].p.k || effectElements[35].p.v !== 1){
	        this.feFuncA = this.createFeFunc('feFuncA', feComponentTransfer);
	    }
	    
	    if(this.feFuncR || this.feFuncG || this.feFuncB || this.feFuncA){
	        feComponentTransfer.setAttribute('color-interpolation-filters','sRGB');
	        filter.appendChild(feComponentTransfer);
	        feComponentTransfer = createNS('feComponentTransfer');
	    }
	
	    if(effectElements[3].p.k || effectElements[3].p.v !== 0 || effectElements[4].p.k || effectElements[4].p.v !== 1 || effectElements[5].p.k || effectElements[5].p.v !== 1 || effectElements[6].p.k || effectElements[6].p.v !== 0 || effectElements[7].p.k || effectElements[7].p.v !== 1){
	
	        feComponentTransfer.setAttribute('color-interpolation-filters','sRGB');
	        filter.appendChild(feComponentTransfer);
	        this.feFuncRComposed = this.createFeFunc('feFuncR', feComponentTransfer);
	        this.feFuncGComposed = this.createFeFunc('feFuncG', feComponentTransfer);
	        this.feFuncBComposed = this.createFeFunc('feFuncB', feComponentTransfer);
	    }
	}
	
	SVGProLevelsFilter.prototype.createFeFunc = function(type, feComponentTransfer) {
	    var feFunc = createNS(type);
	    feFunc.setAttribute('type','table');
	    feComponentTransfer.appendChild(feFunc);
	    return feFunc;
	};
	
	SVGProLevelsFilter.prototype.getTableValue = function(inputBlack, inputWhite, gamma, outputBlack, outputWhite) {
	    var cnt = 0;
	    var segments = 256;
	    var perc;
	    var min = Math.min(inputBlack, inputWhite);
	    var max = Math.max(inputBlack, inputWhite);
	    var table = Array.call(null,{length:segments});
	    var colorValue;
	    var pos = 0;
	    var outputDelta = outputWhite - outputBlack; 
	    var inputDelta = inputWhite - inputBlack; 
	    while(cnt <= 256) {
	        perc = cnt/256;
	        if(perc <= min){
	            colorValue = inputDelta < 0 ? outputWhite : outputBlack;
	        } else if(perc >= max){
	            colorValue = inputDelta < 0 ? outputBlack : outputWhite;
	        } else {
	            colorValue = (outputBlack + outputDelta * Math.pow((perc - inputBlack) / inputDelta, 1 / gamma));
	        }
	        table[pos++] = colorValue;
	        cnt += 256/(segments-1);
	    }
	    return table.join(' ');
	};
	
	SVGProLevelsFilter.prototype.renderFrame = function(forceRender){
	    if(forceRender || this.filterManager.mdf){
	        var val, cnt, perc, bezier;
	        var effectElements = this.filterManager.effectElements;
	        if(this.feFuncRComposed && (forceRender || effectElements[3].p.mdf || effectElements[4].p.mdf || effectElements[5].p.mdf || effectElements[6].p.mdf || effectElements[7].p.mdf)){
	            val = this.getTableValue(effectElements[3].p.v,effectElements[4].p.v,effectElements[5].p.v,effectElements[6].p.v,effectElements[7].p.v);
	            this.feFuncRComposed.setAttribute('tableValues',val);
	            this.feFuncGComposed.setAttribute('tableValues',val);
	            this.feFuncBComposed.setAttribute('tableValues',val);
	        }
	
	        if(this.feFuncR && (forceRender || effectElements[10].p.mdf || effectElements[11].p.mdf || effectElements[12].p.mdf || effectElements[13].p.mdf || effectElements[14].p.mdf)){
	            val = this.getTableValue(effectElements[10].p.v,effectElements[11].p.v,effectElements[12].p.v,effectElements[13].p.v,effectElements[14].p.v);
	            this.feFuncR.setAttribute('tableValues',val);
	        }
	
	        if(this.feFuncG && (forceRender || effectElements[17].p.mdf || effectElements[18].p.mdf || effectElements[19].p.mdf || effectElements[20].p.mdf || effectElements[21].p.mdf)){
	            val = this.getTableValue(effectElements[17].p.v,effectElements[18].p.v,effectElements[19].p.v,effectElements[20].p.v,effectElements[21].p.v);
	            this.feFuncG.setAttribute('tableValues',val);
	        }
	
	        if(this.feFuncB && (forceRender || effectElements[24].p.mdf || effectElements[25].p.mdf || effectElements[26].p.mdf || effectElements[27].p.mdf || effectElements[28].p.mdf)){
	            val = this.getTableValue(effectElements[24].p.v,effectElements[25].p.v,effectElements[26].p.v,effectElements[27].p.v,effectElements[28].p.v);
	            this.feFuncB.setAttribute('tableValues',val);
	        }
	
	        if(this.feFuncA && (forceRender || effectElements[31].p.mdf || effectElements[32].p.mdf || effectElements[33].p.mdf || effectElements[34].p.mdf || effectElements[35].p.mdf)){
	            val = this.getTableValue(effectElements[31].p.v,effectElements[32].p.v,effectElements[33].p.v,effectElements[34].p.v,effectElements[35].p.v);
	            this.feFuncA.setAttribute('tableValues',val);
	        }
	        
	    }
	};
	function SVGDropShadowEffect(filter, filterManager){
	    /*<feGaussianBlur in="SourceAlpha" stdDeviation="3"/> <!-- stdDeviation is how much to blur -->
	  <feOffset dx="2" dy="2" result="offsetblur"/> <!-- how much to offset -->
	  <feMerge> 
	    <feMergeNode/> <!-- this contains the offset blurred image -->
	    <feMergeNode in="SourceGraphic"/> <!-- this contains the element that the filter is applied to -->
	  </feMerge>*/
	  /*<feFlood flood-color="#3D4574" flood-opacity="0.5" result="offsetColor"/>*/
	    filter.setAttribute('x','-100%');
	    filter.setAttribute('y','-100%');
	    filter.setAttribute('width','400%');
	    filter.setAttribute('height','400%');
	    this.filterManager = filterManager;
	
	    var feGaussianBlur = createNS('feGaussianBlur');
	    feGaussianBlur.setAttribute('in','SourceAlpha');
	    feGaussianBlur.setAttribute('result','drop_shadow_1');
	    feGaussianBlur.setAttribute('stdDeviation','0');
	    this.feGaussianBlur = feGaussianBlur;
	    filter.appendChild(feGaussianBlur);
	
	    var feOffset = createNS('feOffset');
	    feOffset.setAttribute('dx','25');
	    feOffset.setAttribute('dy','0');
	    feOffset.setAttribute('in','drop_shadow_1');
	    feOffset.setAttribute('result','drop_shadow_2');
	    this.feOffset = feOffset;
	    filter.appendChild(feOffset);
	    var feFlood = createNS('feFlood');
	    feFlood.setAttribute('flood-color','#00ff00');
	    feFlood.setAttribute('flood-opacity','1');
	    feFlood.setAttribute('result','drop_shadow_3');
	    this.feFlood = feFlood;
	    filter.appendChild(feFlood);
	
	    var feComposite = createNS('feComposite');
	    feComposite.setAttribute('in','drop_shadow_3');
	    feComposite.setAttribute('in2','drop_shadow_2');
	    feComposite.setAttribute('operator','in');
	    feComposite.setAttribute('result','drop_shadow_4');
	    filter.appendChild(feComposite);
	
	
	    var feMerge = createNS('feMerge');
	    filter.appendChild(feMerge);
	    var feMergeNode;
	    feMergeNode = createNS('feMergeNode');
	    feMerge.appendChild(feMergeNode);
	    feMergeNode = createNS('feMergeNode');
	    feMergeNode.setAttribute('in','SourceGraphic');
	    this.feMergeNode = feMergeNode;
	    this.feMerge = feMerge;
	    this.originalNodeAdded = false;
	    feMerge.appendChild(feMergeNode);
	}
	
	SVGDropShadowEffect.prototype.renderFrame = function(forceRender){
	    if(forceRender || this.filterManager.mdf){
	        if(forceRender || this.filterManager.effectElements[4].p.mdf){
	            this.feGaussianBlur.setAttribute('stdDeviation', this.filterManager.effectElements[4].p.v / 4);
	        }
	        if(forceRender || this.filterManager.effectElements[0].p.mdf){
	            var col = this.filterManager.effectElements[0].p.v;
	            this.feFlood.setAttribute('flood-color',rgbToHex(Math.round(col[0]*255),Math.round(col[1]*255),Math.round(col[2]*255)));
	        }
	        if(forceRender || this.filterManager.effectElements[1].p.mdf){
	            this.feFlood.setAttribute('flood-opacity',this.filterManager.effectElements[1].p.v/255);
	        }
	        if(forceRender || this.filterManager.effectElements[2].p.mdf || this.filterManager.effectElements[3].p.mdf){
	            var distance = this.filterManager.effectElements[3].p.v
	            var angle = (this.filterManager.effectElements[2].p.v - 90) * degToRads
	            var x = distance * Math.cos(angle)
	            var y = distance * Math.sin(angle)
	            this.feOffset.setAttribute('dx', x);
	            this.feOffset.setAttribute('dy', y);
	        }
	        /*if(forceRender || this.filterManager.effectElements[5].p.mdf){
	            if(this.filterManager.effectElements[5].p.v === 1 && this.originalNodeAdded) {
	                this.feMerge.removeChild(this.feMergeNode);
	                this.originalNodeAdded = false;
	            } else if(this.filterManager.effectElements[5].p.v === 0 && !this.originalNodeAdded) {
	                this.feMerge.appendChild(this.feMergeNode);
	                this.originalNodeAdded = true;
	            }
	        }*/
	    }
	};
	function SVGMatte3Effect(filterElem, filterManager, elem){
	    this.initialized = false;
	    this.filterManager = filterManager;
	    this.filterElem = filterElem;
	    this.elem = elem;
	    elem.matteElement = createNS('g');
	    elem.matteElement.appendChild(elem.layerElement);
	    elem.matteElement.appendChild(elem.transformedElement);
	    elem.baseElement = elem.matteElement;
	}
	
	SVGMatte3Effect.prototype.setElementAsMask = function(elem, mask) {
	    var masker = createNS('mask');
	    masker.setAttribute('id',mask.layerId);
	    masker.setAttribute('mask-type','alpha');
	    masker.appendChild(mask.layerElement);
	    elem.setMatte(mask.layerId);
	    mask.data.hd = false;
	    var defs = elem.globalData.defs;
	    defs.appendChild(masker);
	}
	
	SVGMatte3Effect.prototype.initialize = function() {
	    var ind = this.filterManager.effectElements[0].p.v;
	    var i = 0, len = this.elem.comp.elements.length;
	    while(i < len) {
	    	if(this.elem.comp.elements[i].data.ind === ind) {
	    		this.setElementAsMask(this.elem, this.elem.comp.elements[i]);
	    	}
	    	i += 1;
	    }
	    this.initialized = true;
	}
	
	SVGMatte3Effect.prototype.renderFrame = function() {
		if(!this.initialized) {
			this.initialize();
		}
	}
	function SVGEffects(elem){
	    var i, len = elem.data.ef.length;
	    var filId = randomString(10);
	    var fil = filtersFactory.createFilter(filId);
	    var count = 0;
	    this.filters = [];
	    var filterManager;
	    for(i=0;i<len;i+=1){
	        if(elem.data.ef[i].ty === 20){
	            count += 1;
	            filterManager = new SVGTintFilter(fil, elem.effects.effectElements[i]);
	            this.filters.push(filterManager);
	        }else if(elem.data.ef[i].ty === 21){
	            count += 1;
	            filterManager = new SVGFillFilter(fil, elem.effects.effectElements[i]);
	            this.filters.push(filterManager);
	        }else if(elem.data.ef[i].ty === 22){
	            filterManager = new SVGStrokeEffect(elem, elem.effects.effectElements[i]);
	            this.filters.push(filterManager);
	        }else if(elem.data.ef[i].ty === 23){
	            count += 1;
	            filterManager = new SVGTritoneFilter(fil, elem.effects.effectElements[i]);
	            this.filters.push(filterManager);
	        }else if(elem.data.ef[i].ty === 24){
	            count += 1;
	            filterManager = new SVGProLevelsFilter(fil, elem.effects.effectElements[i]);
	            this.filters.push(filterManager);
	        }else if(elem.data.ef[i].ty === 25){
	            count += 1;
	            filterManager = new SVGDropShadowEffect(fil, elem.effects.effectElements[i]);
	            this.filters.push(filterManager);
	        }else if(elem.data.ef[i].ty === 28){
	            //count += 1;
	            filterManager = new SVGMatte3Effect(fil, elem.effects.effectElements[i], elem);
	            this.filters.push(filterManager);
	        }
	    }
	    if(count){
	        elem.globalData.defs.appendChild(fil);
	        elem.layerElement.setAttribute('filter','url(' + locationHref + '#'+filId+')');
	    }
	}
	
	SVGEffects.prototype.renderFrame = function(firstFrame){
	    var i, len = this.filters.length;
	    for(i=0;i<len;i+=1){
	        this.filters[i].renderFrame(firstFrame);
	    }
	};
	function ICompElement(data,parentContainer,globalData,comp, placeholder){
	    this._parent.constructor.call(this,data,parentContainer,globalData,comp, placeholder);
	    this.layers = data.layers;
	    this.supports3d = true;
	    this.completeLayers = false;
	    this.pendingElements = [];
	    this.elements = this.layers ? Array.apply(null,{length:this.layers.length}) : [];
	    if(this.data.tm){
	        this.tm = PropertyFactory.getProp(this,this.data.tm,0,globalData.frameRate,this.dynamicProperties);
	    }
	    if(this.data.xt){
	        this.layerElement = createNS('g');
	        this.buildAllItems();
	    } else if(!globalData.progressiveLoad){
	        this.buildAllItems();
	    }
	}
	createElement(SVGBaseElement, ICompElement);
	
	ICompElement.prototype.hide = function(){
	    if(!this.hidden){
	        this._parent.hide.call(this);
	        var i,len = this.elements.length;
	        for( i = 0; i < len; i+=1 ){
	            if(this.elements[i]){
	                this.elements[i].hide();
	            }
	        }
	    }
	};
	
	ICompElement.prototype.prepareFrame = function(num){
	    this._parent.prepareFrame.call(this,num);
	    if(this.isVisible===false && !this.data.xt){
	        return;
	    }
	
	    if(this.tm){
	        var timeRemapped = this.tm.v;
	        if(timeRemapped === this.data.op){
	            timeRemapped = this.data.op - 1;
	        }
	        this.renderedFrame = timeRemapped;
	    } else {
	        this.renderedFrame = num/this.data.sr;
	    }
	    var i,len = this.elements.length;
	    if(!this.completeLayers){
	        this.checkLayers(this.renderedFrame);
	    }
	    for( i = 0; i < len; i+=1 ){
	        if(this.completeLayers || this.elements[i]){
	            this.elements[i].prepareFrame(this.renderedFrame - this.layers[i].st);
	        }
	    }
	};
	
	ICompElement.prototype.renderFrame = function(parentMatrix){
	    var renderParent = this._parent.renderFrame.call(this,parentMatrix);
	    var i,len = this.layers.length;
	    if(renderParent===false){
	        this.hide();
	        return;
	    }
	
	    if(this.hidden) {
	        this.show();
	    }
	    for( i = 0; i < len; i+=1 ){
	        if(this.completeLayers || this.elements[i]){
	            this.elements[i].renderFrame();
	        }
	    }
	    if(this.firstFrame){
	        this.firstFrame = false;
	    }
	};
	
	ICompElement.prototype.setElements = function(elems){
	    this.elements = elems;
	};
	
	ICompElement.prototype.getElements = function(){
	    return this.elements;
	};
	
	ICompElement.prototype.destroy = function(){
	    this._parent.destroy.call(this._parent);
	    var i,len = this.layers.length;
	    for( i = 0; i < len; i+=1 ){
	        if(this.elements[i]){
	            this.elements[i].destroy();
	        }
	    }
	};
	
	ICompElement.prototype.checkLayers = SVGRenderer.prototype.checkLayers;
	ICompElement.prototype.buildItem = SVGRenderer.prototype.buildItem;
	ICompElement.prototype.buildAllItems = SVGRenderer.prototype.buildAllItems;
	ICompElement.prototype.buildElementParenting = SVGRenderer.prototype.buildElementParenting;
	ICompElement.prototype.createItem = SVGRenderer.prototype.createItem;
	ICompElement.prototype.createImage = SVGRenderer.prototype.createImage;
	ICompElement.prototype.createComp = SVGRenderer.prototype.createComp;
	ICompElement.prototype.createSolid = SVGRenderer.prototype.createSolid;
	ICompElement.prototype.createShape = SVGRenderer.prototype.createShape;
	ICompElement.prototype.createText = SVGRenderer.prototype.createText;
	ICompElement.prototype.createBase = SVGRenderer.prototype.createBase;
	ICompElement.prototype.appendElementInPos = SVGRenderer.prototype.appendElementInPos;
	ICompElement.prototype.checkPendingElements = SVGRenderer.prototype.checkPendingElements;
	ICompElement.prototype.addPendingElement = SVGRenderer.prototype.addPendingElement;
	function IImageElement(data,parentContainer,globalData,comp,placeholder){
	    this.assetData = globalData.getAssetData(data.refId);
	    this._parent.constructor.call(this,data,parentContainer,globalData,comp,placeholder);
	}
	createElement(SVGBaseElement, IImageElement);
	
	IImageElement.prototype.createElements = function(){
	
	    var assetPath = this.globalData.getAssetsPath(this.assetData);
	
	    this._parent.createElements.call(this);
	
	    this.innerElem = createNS('image');
	    this.innerElem.setAttribute('width',this.assetData.w+"px");
	    this.innerElem.setAttribute('height',this.assetData.h+"px");
	    this.innerElem.setAttribute('preserveAspectRatio','xMidYMid slice');
	    this.innerElem.setAttributeNS('http://www.w3.org/1999/xlink','href',assetPath);
	    this.maskedElement = this.innerElem;
	    this.layerElement.appendChild(this.innerElem);
	    if(this.data.ln){
	        this.layerElement.setAttribute('id',this.data.ln);
	    }
	    if(this.data.cl){
	        this.layerElement.setAttribute('class',this.data.cl);
	    }
	
	};
	
	IImageElement.prototype.renderFrame = function(parentMatrix){
	    var renderParent = this._parent.renderFrame.call(this,parentMatrix);
	    if(renderParent===false){
	        this.hide();
	        return;
	    }
	    if(this.hidden){
	        this.show();
	    }
	    if(this.firstFrame){
	        this.firstFrame = false;
	    }
	};
	
	IImageElement.prototype.destroy = function(){
	    this._parent.destroy.call(this._parent);
	    this.innerElem =  null;
	};
	function ISolidElement(data,parentContainer,globalData,comp, placeholder){
	    this._parent.constructor.call(this,data,parentContainer,globalData,comp, placeholder);
	}
	createElement(SVGBaseElement, ISolidElement);
	
	ISolidElement.prototype.createElements = function(){
	    this._parent.createElements.call(this);
	
	    var rect = createNS('rect');
	    ////rect.style.width = this.data.sw;
	    ////rect.style.height = this.data.sh;
	    ////rect.style.fill = this.data.sc;
	    rect.setAttribute('width',this.data.sw);
	    rect.setAttribute('height',this.data.sh);
	    rect.setAttribute('fill',this.data.sc);
	    this.layerElement.appendChild(rect);
	    this.innerElem = rect;
	    if(this.data.ln){
	        this.layerElement.setAttribute('id',this.data.ln);
	    }
	    if(this.data.cl){
	        this.layerElement.setAttribute('class',this.data.cl);
	    }
	};
	
	ISolidElement.prototype.renderFrame = IImageElement.prototype.renderFrame;
	ISolidElement.prototype.destroy = IImageElement.prototype.destroy;
	
	var animationManager = (function(){
	    var moduleOb = {};
	    var registeredAnimations = [];
	    var initTime = 0;
	    var len = 0;
	    var idled = true;
	    var playingAnimationsNum = 0;
	
	    function removeElement(ev){
	        var i = 0;
	        var animItem = ev.target;
	        while(i<len) {
	            if (registeredAnimations[i].animation === animItem) {
	                registeredAnimations.splice(i, 1);
	                i -= 1;
	                len -= 1;
	                if(!animItem.isPaused){
	                    subtractPlayingCount();
	                }
	            }
	            i += 1;
	        }
	    }
	
	    function registerAnimation(element, animationData){
	        if(!element){
	            return null;
	        }
	        var i=0;
	        while(i<len){
	            if(registeredAnimations[i].elem == element && registeredAnimations[i].elem !== null ){
	                return registeredAnimations[i].animation;
	            }
	            i+=1;
	        }
	        var animItem = new AnimationItem();
	        setupAnimation(animItem, element);
	        animItem.setData(element, animationData);
	        return animItem;
	    }
	
	    function addPlayingCount(){
	        playingAnimationsNum += 1;
	        activate();
	    }
	
	    function subtractPlayingCount(){
	        playingAnimationsNum -= 1;
	        if(playingAnimationsNum === 0){
	            idled = true;
	        }
	    }
	
	    function setupAnimation(animItem, element){
	        animItem.addEventListener('destroy',removeElement);
	        animItem.addEventListener('_active',addPlayingCount);
	        animItem.addEventListener('_idle',subtractPlayingCount);
	        registeredAnimations.push({elem: element,animation:animItem});
	        len += 1;
	    }
	
	    function loadAnimation(params){
	        var animItem = new AnimationItem();
	        setupAnimation(animItem, null);
	        animItem.setParams(params);
	        return animItem;
	    }
	
	
	    function setSpeed(val,animation){
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.setSpeed(val, animation);
	        }
	    }
	
	    function setDirection(val, animation){
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.setDirection(val, animation);
	        }
	    }
	
	    function play(animation){
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.play(animation);
	        }
	    }
	
	    function moveFrame (value, animation) {
	        initTime = Date.now();
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.moveFrame(value,animation);
	        }
	    }
	
	    function resume(nowTime) {
	
	        var elapsedTime = nowTime - initTime;
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.advanceTime(elapsedTime);
	        }
	        initTime = nowTime;
	        if(!idled) {
	            window.requestAnimationFrame(resume);
	        }
	    }
	
	    function first(nowTime){
	        initTime = nowTime;
	        window.requestAnimationFrame(resume);
	    }
	
	    function pause(animation) {
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.pause(animation);
	        }
	    }
	
	    function goToAndStop(value,isFrame,animation) {
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.goToAndStop(value,isFrame,animation);
	        }
	    }
	
	    function stop(animation) {
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.stop(animation);
	        }
	    }
	
	    function togglePause(animation) {
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.togglePause(animation);
	        }
	    }
	
	    function destroy(animation) {
	        var i;
	        for(i=(len-1);i>=0;i-=1){
	            registeredAnimations[i].animation.destroy(animation);
	        }
	    }
	
	    function searchAnimations(animationData, standalone, renderer){
	        var animElements = [].concat([].slice.call(document.getElementsByClassName('lottie')),
	                  [].slice.call(document.getElementsByClassName('bodymovin')));
	        var i, len = animElements.length;
	        for(i=0;i<len;i+=1){
	            if(renderer){
	                animElements[i].setAttribute('data-bm-type',renderer);
	            }
	            registerAnimation(animElements[i], animationData);
	        }
	        if(standalone && len === 0){
	            if(!renderer){
	                renderer = 'svg';
	            }
	            var body = document.getElementsByTagName('body')[0];
	            body.innerHTML = '';
	            var div = document.createElement('div');
	            div.style.width = '100%';
	            div.style.height = '100%';
	            div.setAttribute('data-bm-type',renderer);
	            body.appendChild(div);
	            registerAnimation(div, animationData);
	        }
	    }
	
	    function resize(){
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.resize();
	        }
	    }
	
	    /*function start(){
	        window.requestAnimationFrame(first);
	    }*/
	
	    function activate(){
	        if(idled){
	            idled = false;
	            window.requestAnimationFrame(first);
	        }
	    }
	
	    //start();
	
	    //setTimeout(start,0);
	
	    moduleOb.registerAnimation = registerAnimation;
	    moduleOb.loadAnimation = loadAnimation;
	    moduleOb.setSpeed = setSpeed;
	    moduleOb.setDirection = setDirection;
	    moduleOb.play = play;
	    moduleOb.moveFrame = moveFrame;
	    moduleOb.pause = pause;
	    moduleOb.stop = stop;
	    moduleOb.togglePause = togglePause;
	    moduleOb.searchAnimations = searchAnimations;
	    moduleOb.resize = resize;
	    //moduleOb.start = start;
	    moduleOb.goToAndStop = goToAndStop;
	    moduleOb.destroy = destroy;
	    return moduleOb;
	}());
	
	var AnimationItem = function () {
	    this._cbs = [];
	    this.name = '';
	    this.path = '';
	    this.isLoaded = false;
	    this.currentFrame = 0;
	    this.currentRawFrame = 0;
	    this.totalFrames = 0;
	    this.frameRate = 0;
	    this.frameMult = 0;
	    this.playSpeed = 1;
	    this.playDirection = 1;
	    this.pendingElements = 0;
	    this.playCount = 0;
	    this.animationData = {};
	    this.layers = [];
	    this.assets = [];
	    this.isPaused = true;
	    this.autoplay = false;
	    this.loop = true;
	    this.renderer = null;
	    this.animationID = randomString(10);
	    this.assetsPath = '';
	    this.timeCompleted = 0;
	    this.segmentPos = 0;
	    this.subframeEnabled = subframeEnabled;
	    this.segments = [];
	    this.pendingSegment = false;
	    this._idle = true;
	    this.projectInterface = ProjectInterface();
	};
	
	AnimationItem.prototype.setParams = function(params) {
	    var self = this;
	    if(params.context){
	        this.context = params.context;
	    }
	    if(params.wrapper || params.container){
	        this.wrapper = params.wrapper || params.container;
	    }
	    var animType = params.animType ? params.animType : params.renderer ? params.renderer : 'svg';
	    switch(animType){
	        case 'canvas':
	            this.renderer = new CanvasRenderer(this, params.rendererSettings);
	            break;
	        case 'svg':
	            this.renderer = new SVGRenderer(this, params.rendererSettings);
	            break;
	        case 'hybrid':
	        case 'html':
	        default:
	            this.renderer = new HybridRenderer(this, params.rendererSettings);
	            break;
	    }
	    this.renderer.setProjectInterface(this.projectInterface);
	    this.animType = animType;
	
	    if(params.loop === '' || params.loop === null){
	    }else if(params.loop === false){
	        this.loop = false;
	    }else if(params.loop === true){
	        this.loop = true;
	    }else{
	        this.loop = parseInt(params.loop);
	    }
	    this.autoplay = 'autoplay' in params ? params.autoplay : true;
	    this.name = params.name ? params.name :  '';
	    this.autoloadSegments = params.hasOwnProperty('autoloadSegments') ? params.autoloadSegments :  true;
	    if(params.animationData){
	        self.configAnimation(params.animationData);
	    }else if(params.path){
	        if(params.path.substr(-4) != 'json'){
	            if (params.path.substr(-1, 1) != '/') {
	                params.path += '/';
	            }
	            params.path += 'data.json';
	        }
	
	        var xhr = new XMLHttpRequest();
	        if(params.path.lastIndexOf('\\') != -1){
	            this.path = params.path.substr(0,params.path.lastIndexOf('\\')+1);
	        }else{
	            this.path = params.path.substr(0,params.path.lastIndexOf('/')+1);
	        }
	        this.assetsPath = params.assetsPath;
	        this.fileName = params.path.substr(params.path.lastIndexOf('/')+1);
	        this.fileName = this.fileName.substr(0,this.fileName.lastIndexOf('.json'));
	        xhr.open('GET', params.path, true);
	        xhr.send();
	        xhr.onreadystatechange = function () {
	            if (xhr.readyState == 4) {
	                if(xhr.status == 200){
	                    self.configAnimation(JSON.parse(xhr.responseText));
	                }else{
	                    try{
	                        var response = JSON.parse(xhr.responseText);
	                        self.configAnimation(response);
	                    }catch(err){
	                    }
	                }
	            }
	        };
	    }
	};
	
	AnimationItem.prototype.setData = function (wrapper, animationData) {
	    var params = {
	        wrapper: wrapper,
	        animationData: animationData ? (typeof animationData  === "object") ? animationData : JSON.parse(animationData) : null
	    };
	    var wrapperAttributes = wrapper.attributes;
	
	    params.path = wrapperAttributes.getNamedItem('data-animation-path') ? wrapperAttributes.getNamedItem('data-animation-path').value : wrapperAttributes.getNamedItem('data-bm-path') ? wrapperAttributes.getNamedItem('data-bm-path').value :  wrapperAttributes.getNamedItem('bm-path') ? wrapperAttributes.getNamedItem('bm-path').value : '';
	    params.animType = wrapperAttributes.getNamedItem('data-anim-type') ? wrapperAttributes.getNamedItem('data-anim-type').value : wrapperAttributes.getNamedItem('data-bm-type') ? wrapperAttributes.getNamedItem('data-bm-type').value : wrapperAttributes.getNamedItem('bm-type') ? wrapperAttributes.getNamedItem('bm-type').value :  wrapperAttributes.getNamedItem('data-bm-renderer') ? wrapperAttributes.getNamedItem('data-bm-renderer').value : wrapperAttributes.getNamedItem('bm-renderer') ? wrapperAttributes.getNamedItem('bm-renderer').value : 'canvas';
	
	    var loop = wrapperAttributes.getNamedItem('data-anim-loop') ? wrapperAttributes.getNamedItem('data-anim-loop').value :  wrapperAttributes.getNamedItem('data-bm-loop') ? wrapperAttributes.getNamedItem('data-bm-loop').value :  wrapperAttributes.getNamedItem('bm-loop') ? wrapperAttributes.getNamedItem('bm-loop').value : '';
	    if(loop === ''){
	    }else if(loop === 'false'){
	        params.loop = false;
	    }else if(loop === 'true'){
	        params.loop = true;
	    }else{
	        params.loop = parseInt(loop);
	    }
	    var autoplay = wrapperAttributes.getNamedItem('data-anim-autoplay') ? wrapperAttributes.getNamedItem('data-anim-autoplay').value :  wrapperAttributes.getNamedItem('data-bm-autoplay') ? wrapperAttributes.getNamedItem('data-bm-autoplay').value :  wrapperAttributes.getNamedItem('bm-autoplay') ? wrapperAttributes.getNamedItem('bm-autoplay').value : true;
	    params.autoplay = autoplay !== "false";
	
	    params.name = wrapperAttributes.getNamedItem('data-name') ? wrapperAttributes.getNamedItem('data-name').value :  wrapperAttributes.getNamedItem('data-bm-name') ? wrapperAttributes.getNamedItem('data-bm-name').value : wrapperAttributes.getNamedItem('bm-name') ? wrapperAttributes.getNamedItem('bm-name').value :  '';
	    var prerender = wrapperAttributes.getNamedItem('data-anim-prerender') ? wrapperAttributes.getNamedItem('data-anim-prerender').value :  wrapperAttributes.getNamedItem('data-bm-prerender') ? wrapperAttributes.getNamedItem('data-bm-prerender').value :  wrapperAttributes.getNamedItem('bm-prerender') ? wrapperAttributes.getNamedItem('bm-prerender').value : '';
	
	    if(prerender === 'false'){
	        params.prerender = false;
	    }
	    this.setParams(params);
	};
	
	AnimationItem.prototype.includeLayers = function(data) {
	    if(data.op > this.animationData.op){
	        this.animationData.op = data.op;
	        this.totalFrames = Math.floor(data.op - this.animationData.ip) - 1;
	        this.animationData.tf = this.totalFrames;
	    }
	    var layers = this.animationData.layers;
	    var i, len = layers.length;
	    var newLayers = data.layers;
	    var j, jLen = newLayers.length;
	    for(j=0;j<jLen;j+=1){
	        i = 0;
	        while(i<len){
	            if(layers[i].id == newLayers[j].id){
	                layers[i] = newLayers[j];
	                break;
	            }
	            i += 1;
	        }
	    }
	    if(data.chars || data.fonts){
	        this.renderer.globalData.fontManager.addChars(data.chars);
	        this.renderer.globalData.fontManager.addFonts(data.fonts, this.renderer.globalData.defs);
	    }
	    if(data.assets){
	        len = data.assets.length;
	        for(i = 0; i < len; i += 1){
	            this.animationData.assets.push(data.assets[i]);
	        }
	    }
	    //this.totalFrames = 50;
	    //this.animationData.tf = 50;
	    this.animationData.__complete = false;
	    dataManager.completeData(this.animationData,this.renderer.globalData.fontManager);
	    this.renderer.includeLayers(data.layers);
	    if(expressionsPlugin){
	        expressionsPlugin.initExpressions(this);
	    }
	    this.renderer.renderFrame(null);
	    this.loadNextSegment();
	};
	
	AnimationItem.prototype.loadNextSegment = function() {
	    var segments = this.animationData.segments;
	    if(!segments || segments.length === 0 || !this.autoloadSegments){
	        this.trigger('data_ready');
	        this.timeCompleted = this.animationData.tf;
	        return;
	    }
	    var segment = segments.shift();
	    this.timeCompleted = segment.time * this.frameRate;
	    var xhr = new XMLHttpRequest();
	    var self = this;
	    var segmentPath = this.path+this.fileName+'_' + this.segmentPos + '.json';
	    this.segmentPos += 1;
	    xhr.open('GET', segmentPath, true);
	    xhr.send();
	    xhr.onreadystatechange = function () {
	        if (xhr.readyState == 4) {
	            if(xhr.status == 200){
	                self.includeLayers(JSON.parse(xhr.responseText));
	            }else{
	                try{
	                    var response = JSON.parse(xhr.responseText);
	                    self.includeLayers(response);
	                }catch(err){
	                }
	            }
	        }
	    };
	};
	
	AnimationItem.prototype.loadSegments = function() {
	    var segments = this.animationData.segments;
	    if(!segments) {
	        this.timeCompleted = this.animationData.tf;
	    }
	    this.loadNextSegment();
	};
	
	AnimationItem.prototype.configAnimation = function (animData) {
	    var _this = this;
	    if(this.renderer && this.renderer.destroyed){
	        return;
	    }
	    //console.log(JSON.parse(JSON.stringify(animData)));
	    //animData.w = Math.round(animData.w/blitter);
	    //animData.h = Math.round(animData.h/blitter);
	    this.animationData = animData;
	    this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip) - 1;
	    this.animationData.tf = this.totalFrames;
	    this.renderer.configAnimation(animData);
	    if(!animData.assets){
	        animData.assets = [];
	    }
	    if(animData.comps) {
	        animData.assets = animData.assets.concat(animData.comps);
	        animData.comps = null;
	    }
	    this.renderer.searchExtraCompositions(animData.assets);
	
	    this.layers = this.animationData.layers;
	    this.assets = this.animationData.assets;
	    this.frameRate = this.animationData.fr;
	    this.firstFrame = Math.round(this.animationData.ip);
	    this.frameMult = this.animationData.fr / 1000;
	    this.trigger('config_ready');
	    this.imagePreloader = new ImagePreloader();
	    this.imagePreloader.setAssetsPath(this.assetsPath);
	    this.imagePreloader.setPath(this.path);
	    this.imagePreloader.loadAssets(animData.assets, function(err) {
	        if(!err) {
	            _this.trigger('loaded_images');
	        }
	    });
	    this.loadSegments();
	    this.updaFrameModifier();
	    if(this.renderer.globalData.fontManager){
	        this.waitForFontsLoaded();
	    }else{
	        dataManager.completeData(this.animationData,this.renderer.globalData.fontManager);
	        this.checkLoaded();
	    }
	};
	
	AnimationItem.prototype.waitForFontsLoaded = (function(){
	    function checkFontsLoaded(){
	        if(this.renderer.globalData.fontManager.loaded){
	            dataManager.completeData(this.animationData,this.renderer.globalData.fontManager);
	            //this.renderer.buildItems(this.animationData.layers);
	            this.checkLoaded();
	        }else{
	            setTimeout(checkFontsLoaded.bind(this),20);
	        }
	    }
	
	    return function(){
	        checkFontsLoaded.bind(this)();
	    }
	}());
	
	AnimationItem.prototype.addPendingElement = function () {
	    this.pendingElements += 1;
	}
	
	AnimationItem.prototype.elementLoaded = function () {
	    this.pendingElements--;
	    this.checkLoaded();
	};
	
	AnimationItem.prototype.checkLoaded = function () {
	    if (this.pendingElements === 0) {
	        if(expressionsPlugin){
	            expressionsPlugin.initExpressions(this);
	        }
	        this.renderer.initItems();
	        setTimeout(function(){
	            this.trigger('DOMLoaded');
	        }.bind(this),0);
	        this.isLoaded = true;
	        this.gotoFrame();
	        if(this.autoplay){
	            this.play();
	        }
	    }
	};
	
	AnimationItem.prototype.resize = function () {
	    this.renderer.updateContainerSize();
	};
	
	AnimationItem.prototype.setSubframe = function(flag){
	    this.subframeEnabled = flag ? true : false;
	}
	
	AnimationItem.prototype.gotoFrame = function () {
	    this.currentFrame = this.subframeEnabled ? this.currentRawFrame : ~~this.currentRawFrame;
	
	    if(this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted){
	        this.currentFrame = this.timeCompleted;
	    }
	    this.trigger('enterFrame');
	    this.renderFrame();
	};
	
	AnimationItem.prototype.renderFrame = function () {
	    if(this.isLoaded === false){
	        return;
	    }
	    //console.log('this.currentFrame:',this.currentFrame + this.firstFrame);
	    this.renderer.renderFrame(this.currentFrame + this.firstFrame);
	};
	
	AnimationItem.prototype.play = function (name) {
	    if(name && this.name != name){
	        return;
	    }
	    if(this.isPaused === true){
	        this.isPaused = false;
	        if(this._idle){
	            this._idle = false;
	            this.trigger('_active');
	        }
	    }
	};
	
	AnimationItem.prototype.pause = function (name) {
	    if(name && this.name != name){
	        return;
	    }
	    if(this.isPaused === false){
	        this.isPaused = true;
	        if(!this.pendingSegment){
	            this._idle = true;
	            this.trigger('_idle');
	        }
	    }
	};
	
	AnimationItem.prototype.togglePause = function (name) {
	    if(name && this.name != name){
	        return;
	    }
	    if(this.isPaused === true){
	        this.play();
	    }else{
	        this.pause();
	    }
	};
	
	AnimationItem.prototype.stop = function (name) {
	    if(name && this.name != name){
	        return;
	    }
	    this.pause();
	    this.currentFrame = this.currentRawFrame = 0;
	    this.playCount = 0;
	    this.gotoFrame();
	};
	
	AnimationItem.prototype.goToAndStop = function (value, isFrame, name) {
	    if(name && this.name != name){
	        return;
	    }
	    if(isFrame){
	        this.setCurrentRawFrameValue(value);
	    }else{
	        this.setCurrentRawFrameValue(value * this.frameModifier);
	    }
	    this.pause();
	};
	
	AnimationItem.prototype.goToAndPlay = function (value, isFrame, name) {
	    this.goToAndStop(value, isFrame, name);
	    this.play();
	};
	
	AnimationItem.prototype.advanceTime = function (value) {
	    if(this.pendingSegment){
	        this.pendingSegment = false;
	        this.adjustSegment(this.segments.shift());
	        if(this.isPaused){
	            this.play();
	        }
	        return;
	    }
	    if (this.isPaused === true || this.isLoaded === false) {
	        return;
	    }
	    this.setCurrentRawFrameValue(this.currentRawFrame + value * this.frameModifier);
	};
	
	AnimationItem.prototype.updateAnimation = function (perc) {
	    this.setCurrentRawFrameValue(this.totalFrames * perc);
	};
	
	AnimationItem.prototype.moveFrame = function (value, name) {
	    if(name && this.name != name){
	        return;
	    }
	    this.setCurrentRawFrameValue(this.currentRawFrame+value);
	};
	
	AnimationItem.prototype.adjustSegment = function(arr){
	    this.playCount = 0;
	    if(arr[1] < arr[0]){
	        if(this.frameModifier > 0){
	            if(this.playSpeed < 0){
	                this.setSpeed(-this.playSpeed);
	            } else {
	                this.setDirection(-1);
	            }
	        }
	        this.totalFrames = arr[0] - arr[1] - 1;
	        this.firstFrame = arr[1];
	        this.setCurrentRawFrameValue(this.totalFrames);
	    } else if(arr[1] > arr[0]){
	        if(this.frameModifier < 0){
	            if(this.playSpeed < 0){
	                this.setSpeed(-this.playSpeed);
	            } else {
	                this.setDirection(1);
	            }
	        }
	        this.totalFrames = arr[1] - arr[0] - 1;
	        this.firstFrame = arr[0];
	        this.setCurrentRawFrameValue(0);
	    }
	    this.trigger('segmentStart');
	};
	AnimationItem.prototype.setSegment = function (init,end) {
	    var pendingFrame = -1;
	    if(this.isPaused) {
	        if (this.currentRawFrame + this.firstFrame < init) {
	            pendingFrame = init;
	        } else if (this.currentRawFrame + this.firstFrame > end) {
	            pendingFrame = end - init;
	        }
	    }
	
	    this.firstFrame = init;
	    this.totalFrames = end - init - 1;
	    if(pendingFrame !== -1) {
	        this.goToAndStop(pendingFrame,true);
	    }
	}
	
	AnimationItem.prototype.playSegments = function (arr,forceFlag) {
	    if(typeof arr[0] === 'object'){
	        var i, len = arr.length;
	        for(i=0;i<len;i+=1){
	            this.segments.push(arr[i]);
	        }
	    }else{
	        this.segments.push(arr);
	    }
	    if(forceFlag){
	        this.adjustSegment(this.segments.shift());
	    }
	    if(this.isPaused){
	        this.play();
	    }
	};
	
	AnimationItem.prototype.resetSegments = function (forceFlag) {
	    this.segments.length = 0;
	    this.segments.push([this.animationData.ip*this.frameRate,Math.floor(this.animationData.op - this.animationData.ip+this.animationData.ip*this.frameRate)]);
	    if(forceFlag){
	        this.adjustSegment(this.segments.shift());
	    }
	};
	AnimationItem.prototype.checkSegments = function(){
	    if(this.segments.length){
	        this.pendingSegment = true;
	    }
	}
	
	AnimationItem.prototype.remove = function (name) {
	    if(name && this.name != name){
	        return;
	    }
	    this.renderer.destroy();
	};
	
	AnimationItem.prototype.destroy = function (name) {
	    if((name && this.name != name) || (this.renderer && this.renderer.destroyed)){
	        return;
	    }
	    this.renderer.destroy();
	    this.trigger('destroy');
	    this._cbs = null;
	    this.onEnterFrame = this.onLoopComplete = this.onComplete = this.onSegmentStart = this.onDestroy = null;
	    this.renderer = null;
	};
	
	AnimationItem.prototype.setCurrentRawFrameValue = function(value){
	    this.currentRawFrame = value;
	    //console.log(this.totalFrames);
	    var _completeFlag = false;
	    if (this.currentRawFrame >= this.totalFrames) {
	        this.checkSegments();
	        if(this.loop === false){
	            this.currentRawFrame = this.totalFrames;
	            _completeFlag = true;
	        }else{
	            this.trigger('loopComplete');
	            this.playCount += 1;
	            if((this.loop !== true && this.playCount == this.loop) || this.pendingSegment){
	                this.currentRawFrame = this.totalFrames;
	                _completeFlag = true;
	            } else {
	                this.currentRawFrame = this.currentRawFrame % this.totalFrames;
	            }
	        }
	    } else if (this.currentRawFrame < 0) {
	        this.checkSegments();
	        this.playCount -= 1;
	        if(this.playCount < 0){
	            this.playCount = 0;
	        }
	        if(this.loop === false  || this.pendingSegment){
	            this.currentRawFrame = 0;
	            _completeFlag = true;
	        }else{
	            this.trigger('loopComplete');
	            this.currentRawFrame = (this.totalFrames + this.currentRawFrame) % this.totalFrames;
	        }
	    }
	
	    this.gotoFrame();
	    if(_completeFlag) {
	        this.pause();
	        this.trigger('complete');
	    }
	};
	
	AnimationItem.prototype.setSpeed = function (val) {
	    this.playSpeed = val;
	    this.updaFrameModifier();
	};
	
	AnimationItem.prototype.setDirection = function (val) {
	    this.playDirection = val < 0 ? -1 : 1;
	    this.updaFrameModifier();
	};
	
	AnimationItem.prototype.updaFrameModifier = function () {
	    this.frameModifier = this.frameMult * this.playSpeed * this.playDirection;
	};
	
	AnimationItem.prototype.getPath = function () {
	    return this.path;
	};
	
	AnimationItem.prototype.getAssetsPath = function (assetData) {
	    var path = '';
	    if(this.assetsPath){
	        var imagePath = assetData.p;
	        if(imagePath.indexOf('images/') !== -1){
	            imagePath = imagePath.split('/')[1];
	        }
	        path = this.assetsPath + imagePath;
	    } else {
	        path = this.path;
	        path += assetData.u ? assetData.u : '';
	        path += assetData.p;
	    }
	    return path;
	};
	
	AnimationItem.prototype.getAssetData = function (id) {
	    var i = 0, len = this.assets.length;
	    while (i < len) {
	        if(id == this.assets[i].id){
	            return this.assets[i];
	        }
	        i += 1;
	    }
	};
	
	AnimationItem.prototype.hide = function () {
	    this.renderer.hide();
	};
	
	AnimationItem.prototype.show = function () {
	    this.renderer.show();
	};
	
	AnimationItem.prototype.getAssets = function () {
	    return this.assets;
	};
	
	AnimationItem.prototype.trigger = function(name){
	    if(this._cbs && this._cbs[name]){
	        switch(name){
	            case 'enterFrame':
	                this.triggerEvent(name,new BMEnterFrameEvent(name,this.currentFrame,this.totalFrames,this.frameMult));
	                break;
	            case 'loopComplete':
	                this.triggerEvent(name,new BMCompleteLoopEvent(name,this.loop,this.playCount,this.frameMult));
	                break;
	            case 'complete':
	                this.triggerEvent(name,new BMCompleteEvent(name,this.frameMult));
	                break;
	            case 'segmentStart':
	                this.triggerEvent(name,new BMSegmentStartEvent(name,this.firstFrame,this.totalFrames));
	                break;
	            case 'destroy':
	                this.triggerEvent(name,new BMDestroyEvent(name,this));
	                break;
	            default:
	                this.triggerEvent(name);
	        }
	    }
	    if(name === 'enterFrame' && this.onEnterFrame){
	        this.onEnterFrame.call(this,new BMEnterFrameEvent(name,this.currentFrame,this.totalFrames,this.frameMult));
	    }
	    if(name === 'loopComplete' && this.onLoopComplete){
	        this.onLoopComplete.call(this,new BMCompleteLoopEvent(name,this.loop,this.playCount,this.frameMult));
	    }
	    if(name === 'complete' && this.onComplete){
	        this.onComplete.call(this,new BMCompleteEvent(name,this.frameMult));
	    }
	    if(name === 'segmentStart' && this.onSegmentStart){
	        this.onSegmentStart.call(this,new BMSegmentStartEvent(name,this.firstFrame,this.totalFrames));
	    }
	    if(name === 'destroy' && this.onDestroy){
	        this.onDestroy.call(this,new BMDestroyEvent(name,this));
	    }
	};
	
	AnimationItem.prototype.addEventListener = _addEventListener;
	AnimationItem.prototype.removeEventListener = _removeEventListener;
	AnimationItem.prototype.triggerEvent = _triggerEvent;
	
	function CanvasRenderer(animationItem, config){
	    this.animationItem = animationItem;
	    this.renderConfig = {
	        clearCanvas: (config && config.clearCanvas !== undefined) ? config.clearCanvas : true,
	        context: (config && config.context) || null,
	        progressiveLoad: (config && config.progressiveLoad) || false,
	        preserveAspectRatio: (config && config.preserveAspectRatio) || 'xMidYMid meet',
	        className: (config && config.className) || ''
	    };
	    this.renderConfig.dpr = (config && config.dpr) || 1;
	    if (this.animationItem.wrapper) {
	        this.renderConfig.dpr = (config && config.dpr) || window.devicePixelRatio || 1;
	    }
	    this.renderedFrame = -1;
	    this.globalData = {
	        frameNum: -1
	    };
	    this.contextData = {
	        saved : Array.apply(null,{length:15}),
	        savedOp: Array.apply(null,{length:15}),
	        cArrPos : 0,
	        cTr : new Matrix(),
	        cO : 1
	    };
	    var i, len = 15;
	    for(i=0;i<len;i+=1){
	        this.contextData.saved[i] = Array.apply(null,{length:16});
	    }
	    this.elements = [];
	    this.pendingElements = [];
	    this.transformMat = new Matrix();
	    this.completeLayers = false;
	}
	extendPrototype(BaseRenderer,CanvasRenderer);
	
	CanvasRenderer.prototype.createBase = function (data) {
	    return new CVBaseElement(data, this, this.globalData);
	};
	
	CanvasRenderer.prototype.createShape = function (data) {
	    return new CVShapeElement(data, this, this.globalData);
	};
	
	CanvasRenderer.prototype.createText = function (data) {
	    return new CVTextElement(data, this, this.globalData);
	};
	
	CanvasRenderer.prototype.createImage = function (data) {
	    return new CVImageElement(data, this, this.globalData);
	};
	
	CanvasRenderer.prototype.createComp = function (data) {
	    return new CVCompElement(data, this, this.globalData);
	};
	
	CanvasRenderer.prototype.createSolid = function (data) {
	    return new CVSolidElement(data, this, this.globalData);
	};
	
	CanvasRenderer.prototype.ctxTransform = function(props){
	    if(props[0] === 1 && props[1] === 0 && props[4] === 0 && props[5] === 1 && props[12] === 0 && props[13] === 0){
	        return;
	    }
	    if(!this.renderConfig.clearCanvas){
	        this.canvasContext.transform(props[0],props[1],props[4],props[5],props[12],props[13]);
	        return;
	    }
	    this.transformMat.cloneFromProps(props);
	    this.transformMat.transform(this.contextData.cTr.props[0],this.contextData.cTr.props[1],this.contextData.cTr.props[2],this.contextData.cTr.props[3],this.contextData.cTr.props[4],this.contextData.cTr.props[5],this.contextData.cTr.props[6],this.contextData.cTr.props[7],this.contextData.cTr.props[8],this.contextData.cTr.props[9],this.contextData.cTr.props[10],this.contextData.cTr.props[11],this.contextData.cTr.props[12],this.contextData.cTr.props[13],this.contextData.cTr.props[14],this.contextData.cTr.props[15])
	    //this.contextData.cTr.transform(props[0],props[1],props[2],props[3],props[4],props[5],props[6],props[7],props[8],props[9],props[10],props[11],props[12],props[13],props[14],props[15]);
	    this.contextData.cTr.cloneFromProps(this.transformMat.props);
	    var trProps = this.contextData.cTr.props;
	    this.canvasContext.setTransform(trProps[0],trProps[1],trProps[4],trProps[5],trProps[12],trProps[13]);
	};
	
	CanvasRenderer.prototype.ctxOpacity = function(op){
	    if(op === 1){
	        return;
	    }
	    if(!this.renderConfig.clearCanvas){
	        this.canvasContext.globalAlpha *= op < 0 ? 0 : op;
	        return;
	    }
	    this.contextData.cO *= op < 0 ? 0 : op;
	    this.canvasContext.globalAlpha = this.contextData.cO;
	};
	
	CanvasRenderer.prototype.reset = function(){
	    if(!this.renderConfig.clearCanvas){
	        this.canvasContext.restore();
	        return;
	    }
	    this.contextData.cArrPos = 0;
	    this.contextData.cTr.reset();
	    this.contextData.cO = 1;
	};
	
	CanvasRenderer.prototype.save = function(actionFlag){
	    if(!this.renderConfig.clearCanvas){
	        this.canvasContext.save();
	        return;
	    }
	    if(actionFlag){
	        this.canvasContext.save();
	    }
	    var props = this.contextData.cTr.props;
	    if(this.contextData.saved[this.contextData.cArrPos] === null || this.contextData.saved[this.contextData.cArrPos] === undefined){
	        this.contextData.saved[this.contextData.cArrPos] = new Array(16);
	    }
	    var i,arr = this.contextData.saved[this.contextData.cArrPos];
	    for(i=0;i<16;i+=1){
	        arr[i] = props[i];
	    }
	    this.contextData.savedOp[this.contextData.cArrPos] = this.contextData.cO;
	    this.contextData.cArrPos += 1;
	};
	
	CanvasRenderer.prototype.restore = function(actionFlag){
	    if(!this.renderConfig.clearCanvas){
	        this.canvasContext.restore();
	        return;
	    }
	    if(actionFlag){
	        this.canvasContext.restore();
	    }
	    this.contextData.cArrPos -= 1;
	    var popped = this.contextData.saved[this.contextData.cArrPos];
	    var i,arr = this.contextData.cTr.props;
	    for(i=0;i<16;i+=1){
	        arr[i] = popped[i];
	    }
	    this.canvasContext.setTransform(popped[0],popped[1],popped[4],popped[5],popped[12],popped[13]);
	    popped = this.contextData.savedOp[this.contextData.cArrPos];
	    this.contextData.cO = popped;
	    this.canvasContext.globalAlpha = popped;
	};
	
	CanvasRenderer.prototype.configAnimation = function(animData){
	    if(this.animationItem.wrapper){
	        this.animationItem.container = document.createElement('canvas');
	        this.animationItem.container.style.width = '100%';
	        this.animationItem.container.style.height = '100%';
	        //this.animationItem.container.style.transform = 'translate3d(0,0,0)';
	        //this.animationItem.container.style.webkitTransform = 'translate3d(0,0,0)';
	        this.animationItem.container.style.transformOrigin = this.animationItem.container.style.mozTransformOrigin = this.animationItem.container.style.webkitTransformOrigin = this.animationItem.container.style['-webkit-transform'] = "0px 0px 0px";
	        this.animationItem.wrapper.appendChild(this.animationItem.container);
	        this.canvasContext = this.animationItem.container.getContext('2d');
	        if(this.renderConfig.className) {
	            this.animationItem.container.setAttribute('class', this.renderConfig.className);
	        }
	    }else{
	        this.canvasContext = this.renderConfig.context;
	    }
	    this.data = animData;
	    this.globalData.canvasContext = this.canvasContext;
	    this.globalData.renderer = this;
	    this.globalData.isDashed = false;
	    this.globalData.totalFrames = Math.floor(animData.tf);
	    this.globalData.compWidth = animData.w;
	    this.globalData.compHeight = animData.h;
	    this.globalData.frameRate = animData.fr;
	    this.globalData.frameId = 0;
	    this.globalData.compSize = {
	        w: animData.w,
	        h: animData.h
	    };
	    this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
	    this.layers = animData.layers;
	    this.transformCanvas = {};
	    this.transformCanvas.w = animData.w;
	    this.transformCanvas.h = animData.h;
	    this.globalData.fontManager = new FontManager();
	    this.globalData.fontManager.addChars(animData.chars);
	    this.globalData.fontManager.addFonts(animData.fonts,document.body);
	    this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem);
	    this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem);
	    this.globalData.elementLoaded = this.animationItem.elementLoaded.bind(this.animationItem);
	    this.globalData.addPendingElement = this.animationItem.addPendingElement.bind(this.animationItem);
	    this.globalData.transformCanvas = this.transformCanvas;
	    this.elements = Array.apply(null,{length:animData.layers.length});
	
	    this.updateContainerSize();
	};
	
	CanvasRenderer.prototype.updateContainerSize = function () {
	    var elementWidth,elementHeight;
	    if(this.animationItem.wrapper && this.animationItem.container){
	        elementWidth = this.animationItem.wrapper.offsetWidth;
	        elementHeight = this.animationItem.wrapper.offsetHeight;
	        this.animationItem.container.setAttribute('width',elementWidth * this.renderConfig.dpr );
	        this.animationItem.container.setAttribute('height',elementHeight * this.renderConfig.dpr);
	    }else{
	        elementWidth = this.canvasContext.canvas.width * this.renderConfig.dpr;
	        elementHeight = this.canvasContext.canvas.height * this.renderConfig.dpr;
	    }
	    var elementRel,animationRel;
	    if(this.renderConfig.preserveAspectRatio.indexOf('meet') !== -1 || this.renderConfig.preserveAspectRatio.indexOf('slice') !== -1){
	        var par = this.renderConfig.preserveAspectRatio.split(' ');
	        var fillType = par[1] || 'meet';
	        var pos = par[0] || 'xMidYMid';
	        var xPos = pos.substr(0,4);
	        var yPos = pos.substr(4);
	        elementRel = elementWidth/elementHeight;
	        animationRel = this.transformCanvas.w/this.transformCanvas.h;
	        if(animationRel>elementRel && fillType === 'meet' || animationRel<elementRel && fillType === 'slice'){
	            this.transformCanvas.sx = elementWidth/(this.transformCanvas.w/this.renderConfig.dpr);
	            this.transformCanvas.sy = elementWidth/(this.transformCanvas.w/this.renderConfig.dpr);
	        }else{
	            this.transformCanvas.sx = elementHeight/(this.transformCanvas.h / this.renderConfig.dpr);
	            this.transformCanvas.sy = elementHeight/(this.transformCanvas.h / this.renderConfig.dpr);
	        }
	
	        if(xPos === 'xMid' && ((animationRel<elementRel && fillType==='meet') || (animationRel>elementRel && fillType === 'slice'))){
	            this.transformCanvas.tx = (elementWidth-this.transformCanvas.w*(elementHeight/this.transformCanvas.h))/2*this.renderConfig.dpr;
	        } else if(xPos === 'xMax' && ((animationRel<elementRel && fillType==='meet') || (animationRel>elementRel && fillType === 'slice'))){
	            this.transformCanvas.tx = (elementWidth-this.transformCanvas.w*(elementHeight/this.transformCanvas.h))*this.renderConfig.dpr;
	        } else {
	            this.transformCanvas.tx = 0;
	        }
	        if(yPos === 'YMid' && ((animationRel>elementRel && fillType==='meet') || (animationRel<elementRel && fillType === 'slice'))){
	            this.transformCanvas.ty = ((elementHeight-this.transformCanvas.h*(elementWidth/this.transformCanvas.w))/2)*this.renderConfig.dpr;
	        } else if(yPos === 'YMax' && ((animationRel>elementRel && fillType==='meet') || (animationRel<elementRel && fillType === 'slice'))){
	            this.transformCanvas.ty = ((elementHeight-this.transformCanvas.h*(elementWidth/this.transformCanvas.w)))*this.renderConfig.dpr;
	        } else {
	            this.transformCanvas.ty = 0;
	        }
	
	    }else if(this.renderConfig.preserveAspectRatio == 'none'){
	        this.transformCanvas.sx = elementWidth/(this.transformCanvas.w/this.renderConfig.dpr);
	        this.transformCanvas.sy = elementHeight/(this.transformCanvas.h/this.renderConfig.dpr);
	        this.transformCanvas.tx = 0;
	        this.transformCanvas.ty = 0;
	    }else{
	        this.transformCanvas.sx = this.renderConfig.dpr;
	        this.transformCanvas.sy = this.renderConfig.dpr;
	        this.transformCanvas.tx = 0;
	        this.transformCanvas.ty = 0;
	    }
	    this.transformCanvas.props = [this.transformCanvas.sx,0,0,0,0,this.transformCanvas.sy,0,0,0,0,1,0,this.transformCanvas.tx,this.transformCanvas.ty,0,1];
	    var i, len = this.elements.length;
	    for(i=0;i<len;i+=1){
	        if(this.elements[i] && this.elements[i].data.ty === 0){
	            this.elements[i].resize(this.globalData.transformCanvas);
	        }
	    }
	};
	
	CanvasRenderer.prototype.destroy = function () {
	    if(this.renderConfig.clearCanvas) {
	        this.animationItem.wrapper.innerHTML = '';
	    }
	    var i, len = this.layers ? this.layers.length : 0;
	    for (i = len - 1; i >= 0; i-=1) {
	        if(this.elements[i]) {
	            this.elements[i].destroy();
	        }
	    }
	    this.elements.length = 0;
	    this.globalData.canvasContext = null;
	    this.animationItem.container = null;
	    this.destroyed = true;
	};
	
	CanvasRenderer.prototype.renderFrame = function(num){
	    if((this.renderedFrame == num && this.renderConfig.clearCanvas === true) || this.destroyed || num === null){
	        return;
	    }
	    this.renderedFrame = num;
	    this.globalData.frameNum = num - this.animationItem.firstFrame;
	    this.globalData.frameId += 1;
	    this.globalData.projectInterface.currentFrame = num;
	    if(this.renderConfig.clearCanvas === true){
	        this.reset();
	        this.canvasContext.save();
	        //this.canvasContext.canvas.width = this.canvasContext.canvas.width;
	        this.canvasContext.clearRect(this.transformCanvas.tx, this.transformCanvas.ty, this.transformCanvas.w*this.transformCanvas.sx, this.transformCanvas.h*this.transformCanvas.sy);
	    }else{
	        this.save();
	    }
	    this.ctxTransform(this.transformCanvas.props);
	    this.canvasContext.beginPath();
	    this.canvasContext.rect(0,0,this.transformCanvas.w,this.transformCanvas.h);
	    this.canvasContext.closePath();
	    this.canvasContext.clip();
	
	    //console.log('--------');
	    //console.log('NEW: ',num);
	    var i, len = this.layers.length;
	    if(!this.completeLayers){
	        this.checkLayers(num);
	    }
	
	    for (i = 0; i < len; i++) {
	        if(this.completeLayers || this.elements[i]){
	            this.elements[i].prepareFrame(num - this.layers[i].st);
	        }
	    }
	    for (i = len - 1; i >= 0; i-=1) {
	        if(this.completeLayers || this.elements[i]){
	            this.elements[i].renderFrame();
	        }
	    }
	    if(this.renderConfig.clearCanvas !== true){
	        this.restore();
	    } else {
	        this.canvasContext.restore();
	    }
	};
	
	CanvasRenderer.prototype.buildItem = function(pos){
	    var elements = this.elements;
	    if(elements[pos] || this.layers[pos].ty == 99){
	        return;
	    }
	    var element = this.createItem(this.layers[pos], this,this.globalData);
	    elements[pos] = element;
	    element.initExpressions();
	    if(this.layers[pos].ty === 0){
	        element.resize(this.globalData.transformCanvas);
	    }
	};
	
	CanvasRenderer.prototype.checkPendingElements  = function(){
	    while(this.pendingElements.length){
	        var element = this.pendingElements.pop();
	        element.checkParenting();
	    }
	};
	
	CanvasRenderer.prototype.hide = function(){
	    this.animationItem.container.style.display = 'none';
	};
	
	CanvasRenderer.prototype.show = function(){
	    this.animationItem.container.style.display = 'block';
	};
	
	CanvasRenderer.prototype.searchExtraCompositions = function(assets){
	    var i, len = assets.length;
	    var floatingContainer = createNS('g');
	    for(i=0;i<len;i+=1){
	        if(assets[i].xt){
	            var comp = this.createComp(assets[i],this.globalData.comp,this.globalData);
	            comp.initExpressions();
	            //comp.compInterface = CompExpressionInterface(comp);
	            //Expressions.addLayersInterface(comp.elements, this.globalData.projectInterface);
	            this.globalData.projectInterface.registerComposition(comp);
	        }
	    }
	};
	
	function HybridRenderer(animationItem, config){
	    this.animationItem = animationItem;
	    this.layers = null;
	    this.renderedFrame = -1;
	    this.globalData = {
	        frameNum: -1
	    };
	    this.renderConfig = {
	        className: (config && config.className) || ''
	    };
	    this.pendingElements = [];
	    this.elements = [];
	    this.threeDElements = [];
	    this.destroyed = false;
	    this.camera = null;
	    this.supports3d = true;
	
	}
	
	extendPrototype(BaseRenderer,HybridRenderer);
	
	HybridRenderer.prototype.buildItem = SVGRenderer.prototype.buildItem;
	
	HybridRenderer.prototype.checkPendingElements  = function(){
	    while(this.pendingElements.length){
	        var element = this.pendingElements.pop();
	        element.checkParenting();
	    }
	};
	
	HybridRenderer.prototype.appendElementInPos = function(element, pos){
	    var newDOMElement = element.getBaseElement();
	    if(!newDOMElement){
	        return;
	    }
	    var layer = this.layers[pos];
	    if(!layer.ddd || !this.supports3d){
	        var i = 0;
	        var nextDOMElement, nextLayer;
	        while(i<pos){
	            if(this.elements[i] && this.elements[i]!== true && this.elements[i].getBaseElement){
	                nextLayer = this.elements[i];
	                nextDOMElement = this.layers[i].ddd ? this.getThreeDContainerByPos(i) : nextLayer.getBaseElement();
	            }
	            i += 1;
	        }
	        if(nextDOMElement){
	            if(!layer.ddd || !this.supports3d){
	                this.layerElement.insertBefore(newDOMElement, nextDOMElement);
	            }
	        } else {
	            if(!layer.ddd || !this.supports3d){
	                this.layerElement.appendChild(newDOMElement);
	            }
	        }
	    } else {
	        this.addTo3dContainer(newDOMElement,pos);
	    }
	};
	
	
	HybridRenderer.prototype.createBase = function (data) {
	    return new SVGBaseElement(data, this.layerElement,this.globalData,this);
	};
	
	HybridRenderer.prototype.createShape = function (data) {
	    if(!this.supports3d){
	        return new IShapeElement(data, this.layerElement,this.globalData,this);
	    }
	    return new HShapeElement(data, this.layerElement,this.globalData,this);
	};
	
	HybridRenderer.prototype.createText = function (data) {
	    if(!this.supports3d){
	        return new SVGTextElement(data, this.layerElement,this.globalData,this);
	    }
	    return new HTextElement(data, this.layerElement,this.globalData,this);
	};
	
	HybridRenderer.prototype.createCamera = function (data) {
	    this.camera = new HCameraElement(data, this.layerElement,this.globalData,this);
	    return this.camera;
	};
	
	HybridRenderer.prototype.createImage = function (data) {
	    if(!this.supports3d){
	        return new IImageElement(data, this.layerElement,this.globalData,this);
	    }
	    return new HImageElement(data, this.layerElement,this.globalData,this);
	};
	
	HybridRenderer.prototype.createComp = function (data) {
	    if(!this.supports3d){
	        return new ICompElement(data, this.layerElement,this.globalData,this);
	    }
	    return new HCompElement(data, this.layerElement,this.globalData,this);
	
	};
	
	HybridRenderer.prototype.createSolid = function (data) {
	    if(!this.supports3d){
	        return new ISolidElement(data, this.layerElement,this.globalData,this);
	    }
	    return new HSolidElement(data, this.layerElement,this.globalData,this);
	};
	
	HybridRenderer.prototype.getThreeDContainerByPos = function(pos){
	    var i = 0, len = this.threeDElements.length;
	    while(i<len) {
	        if(this.threeDElements[i].startPos <= pos && this.threeDElements[i].endPos >= pos) {
	            return this.threeDElements[i].perspectiveElem;
	        }
	        i += 1;
	    }
	}
	
	HybridRenderer.prototype.createThreeDContainer = function(pos){
	    var perspectiveElem = document.createElement('div');
	    styleDiv(perspectiveElem);
	    perspectiveElem.style.width = this.globalData.compSize.w+'px';
	    perspectiveElem.style.height = this.globalData.compSize.h+'px';
	    perspectiveElem.style.transformOrigin = perspectiveElem.style.mozTransformOrigin = perspectiveElem.style.webkitTransformOrigin = "50% 50%";
	    var container = document.createElement('div');
	    styleDiv(container);
	    container.style.transform = container.style.webkitTransform = 'matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)';
	    perspectiveElem.appendChild(container);
	    this.resizerElem.appendChild(perspectiveElem);
	    var threeDContainerData = {
	        container:container,
	        perspectiveElem:perspectiveElem,
	        startPos: pos,
	        endPos: pos
	    };
	    this.threeDElements.push(threeDContainerData);
	    return threeDContainerData;
	};
	
	HybridRenderer.prototype.build3dContainers = function(){
	    var i, len = this.layers.length;
	    var lastThreeDContainerData;
	    for(i=0;i<len;i+=1){
	        if(this.layers[i].ddd){
	            if(!lastThreeDContainerData){
	                lastThreeDContainerData = this.createThreeDContainer(i);
	            }
	            lastThreeDContainerData.endPos = Math.max(lastThreeDContainerData.endPos,i);
	        } else {
	            lastThreeDContainerData = null;
	        }
	    }
	};
	
	HybridRenderer.prototype.addTo3dContainer = function(elem,pos){
	    var i = 0, len = this.threeDElements.length;
	    while(i<len){
	        if(pos <= this.threeDElements[i].endPos){
	            var j = this.threeDElements[i].startPos;
	            var nextElement;
	            while(j<pos){
	                if(this.elements[j] && this.elements[j].getBaseElement){
	                    nextElement = this.elements[j].getBaseElement();
	                }
	                j += 1;
	            }
	            if(nextElement){
	                this.threeDElements[i].container.insertBefore(elem, nextElement);
	            } else {
	                this.threeDElements[i].container.appendChild(elem);
	            }
	            break;
	        }
	        i += 1;
	    }
	};
	
	HybridRenderer.prototype.configAnimation = function(animData){
	    var resizerElem = document.createElement('div');
	    var wrapper = this.animationItem.wrapper;
	    resizerElem.style.width = animData.w+'px';
	    resizerElem.style.height = animData.h+'px';
	    this.resizerElem = resizerElem;
	    styleDiv(resizerElem);
	    resizerElem.style.transformStyle = resizerElem.style.webkitTransformStyle = resizerElem.style.mozTransformStyle = "flat";
	    if(this.renderConfig.className) {
	      wrapper.setAttribute('class', this.renderConfig.className);
	    }
	    wrapper.appendChild(resizerElem);
	
	    resizerElem.style.overflow = 'hidden';
	    var svg = createNS('svg');
	    svg.setAttribute('width','1');
	    svg.setAttribute('height','1');
	    styleDiv(svg);
	    this.resizerElem.appendChild(svg);
	    var defs = createNS('defs');
	    svg.appendChild(defs);
	    this.globalData.defs = defs;
	    this.data = animData;
	    //Mask animation
	    this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem);
	    this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem);
	    this.globalData.elementLoaded = this.animationItem.elementLoaded.bind(this.animationItem);
	    this.globalData.frameId = 0;
	    this.globalData.compSize = {
	        w: animData.w,
	        h: animData.h
	    };
	    this.globalData.frameRate = animData.fr;
	    this.layers = animData.layers;
	    this.globalData.fontManager = new FontManager();
	    this.globalData.fontManager.addChars(animData.chars);
	    this.globalData.fontManager.addFonts(animData.fonts,svg);
	    this.layerElement = this.resizerElem;
	    this.build3dContainers();
	    this.updateContainerSize();
	};
	
	HybridRenderer.prototype.destroy = function () {
	    this.animationItem.wrapper.innerHTML = '';
	    this.animationItem.container = null;
	    this.globalData.defs = null;
	    var i, len = this.layers ? this.layers.length : 0;
	    for (i = 0; i < len; i++) {
	        this.elements[i].destroy();
	    }
	    this.elements.length = 0;
	    this.destroyed = true;
	    this.animationItem = null;
	};
	
	HybridRenderer.prototype.updateContainerSize = function () {
	    var elementWidth = this.animationItem.wrapper.offsetWidth;
	    var elementHeight = this.animationItem.wrapper.offsetHeight;
	    var elementRel = elementWidth/elementHeight;
	    var animationRel = this.globalData.compSize.w/this.globalData.compSize.h;
	    var sx,sy,tx,ty;
	    if(animationRel>elementRel){
	        sx = elementWidth/(this.globalData.compSize.w);
	        sy = elementWidth/(this.globalData.compSize.w);
	        tx = 0;
	        ty = ((elementHeight-this.globalData.compSize.h*(elementWidth/this.globalData.compSize.w))/2);
	    }else{
	        sx = elementHeight/(this.globalData.compSize.h);
	        sy = elementHeight/(this.globalData.compSize.h);
	        tx = (elementWidth-this.globalData.compSize.w*(elementHeight/this.globalData.compSize.h))/2;
	        ty = 0;
	    }
	    this.resizerElem.style.transform = this.resizerElem.style.webkitTransform = 'matrix3d(' + sx + ',0,0,0,0,'+sy+',0,0,0,0,1,0,'+tx+','+ty+',0,1)';
	};
	
	HybridRenderer.prototype.renderFrame = SVGRenderer.prototype.renderFrame;
	
	HybridRenderer.prototype.hide = function(){
	    this.resizerElem.style.display = 'none';
	};
	
	HybridRenderer.prototype.show = function(){
	    this.resizerElem.style.display = 'block';
	};
	
	HybridRenderer.prototype.initItems = function(){
	    this.buildAllItems();
	    if(this.camera){
	        this.camera.setup();
	    } else {
	        var cWidth = this.globalData.compSize.w;
	        var cHeight = this.globalData.compSize.h;
	        var i, len = this.threeDElements.length;
	        for(i=0;i<len;i+=1){
	            this.threeDElements[i].perspectiveElem.style.perspective = this.threeDElements[i].perspectiveElem.style.webkitPerspective = Math.sqrt(Math.pow(cWidth,2) + Math.pow(cHeight,2)) + 'px';
	        }
	    }
	};
	
	HybridRenderer.prototype.searchExtraCompositions = function(assets){
	    var i, len = assets.length;
	    var floatingContainer = document.createElement('div');
	    for(i=0;i<len;i+=1){
	        if(assets[i].xt){
	            var comp = this.createComp(assets[i],floatingContainer,this.globalData.comp,null);
	            comp.initExpressions();
	            this.globalData.projectInterface.registerComposition(comp);
	        }
	    }
	};
	
	function CVBaseElement(data, comp,globalData){
	    this.globalData = globalData;
	    this.data = data;
	    this.comp = comp;
	    this.canvasContext = globalData.canvasContext;
	    this.init();
	}
	
	createElement(BaseElement, CVBaseElement);
	
	CVBaseElement.prototype.createElements = function(){
	    this.checkParenting();
	};
	
	CVBaseElement.prototype.checkBlendMode = function(globalData){
	    if(globalData.blendMode !== this.data.bm) {
	        globalData.blendMode = this.data.bm;
	
	        var blendModeValue = '';
	        switch (this.data.bm) {
	            case 0:
	                blendModeValue = 'normal';
	                break;
	            case 1:
	                blendModeValue = 'multiply';
	                break;
	            case 2:
	                blendModeValue = 'screen';
	                break;
	            case 3:
	                blendModeValue = 'overlay';
	                break;
	            case 4:
	                blendModeValue = 'darken';
	                break;
	            case 5:
	                blendModeValue = 'lighten';
	                break;
	            case 6:
	                blendModeValue = 'color-dodge';
	                break;
	            case 7:
	                blendModeValue = 'color-burn';
	                break;
	            case 8:
	                blendModeValue = 'hard-light';
	                break;
	            case 9:
	                blendModeValue = 'soft-light';
	                break;
	            case 10:
	                blendModeValue = 'difference';
	                break;
	            case 11:
	                blendModeValue = 'exclusion';
	                break;
	            case 12:
	                blendModeValue = 'hue';
	                break;
	            case 13:
	                blendModeValue = 'saturation';
	                break;
	            case 14:
	                blendModeValue = 'color';
	                break;
	            case 15:
	                blendModeValue = 'luminosity';
	                break;
	        }
	        globalData.canvasContext.globalCompositeOperation = blendModeValue;
	    }
	};
	
	
	CVBaseElement.prototype.renderFrame = function(parentTransform){
	    if(this.data.ty === 3){
	        return false;
	    }
	        this.checkBlendMode(this.data.ty === 0?this.parentGlobalData:this.globalData);
	
	    if(!this.isVisible){
	        return this.isVisible;
	    }
	    this.finalTransform.opMdf = this.finalTransform.op.mdf;
	    this.finalTransform.matMdf = this.finalTransform.mProp.mdf;
	    this.finalTransform.opacity = this.finalTransform.op.v;
	
	    var mat;
	    var finalMat = this.finalTransform.mat;
	
	    if(this.hierarchy){
	        var i, len = this.hierarchy.length;
	        mat = this.finalTransform.mProp.v.props;
	        finalMat.cloneFromProps(mat);
	        for(i=0;i<len;i+=1){
	            this.finalTransform.matMdf = this.hierarchy[i].finalTransform.mProp.mdf ? true : this.finalTransform.matMdf;
	            mat = this.hierarchy[i].finalTransform.mProp.v.props;
	            finalMat.transform(mat[0],mat[1],mat[2],mat[3],mat[4],mat[5],mat[6],mat[7],mat[8],mat[9],mat[10],mat[11],mat[12],mat[13],mat[14],mat[15]);
	        }
	    }else{
	        if(!parentTransform){
	            finalMat.cloneFromProps(this.finalTransform.mProp.v.props);
	        }else{
	            mat = this.finalTransform.mProp.v.props;
	            finalMat.cloneFromProps(mat);
	        }
	    }
	
	    if(parentTransform){
	        mat = parentTransform.mat.props;
	        finalMat.transform(mat[0],mat[1],mat[2],mat[3],mat[4],mat[5],mat[6],mat[7],mat[8],mat[9],mat[10],mat[11],mat[12],mat[13],mat[14],mat[15]);
	        this.finalTransform.opacity *= parentTransform.opacity;
	        this.finalTransform.opMdf = parentTransform.opMdf ? true : this.finalTransform.opMdf;
	        this.finalTransform.matMdf = parentTransform.matMdf ? true : this.finalTransform.matMdf
	    }
	
	    if(this.data.hasMask){
	        this.globalData.renderer.save(true);
	        this.maskManager.renderFrame(this.data.ty === 0?null:finalMat);
	    }
	    if(this.data.hd){
	        this.isVisible = false;
	    }
	    return this.isVisible;
	
	};
	
	CVBaseElement.prototype.addMasks = function(data){
	    this.maskManager = new CVMaskElement(data,this,this.globalData);
	};
	
	
	CVBaseElement.prototype.destroy = function(){
	    this.canvasContext = null;
	    this.data = null;
	    this.globalData = null;
	    if(this.maskManager) {
	        this.maskManager.destroy();
	    }
	};
	
	CVBaseElement.prototype.mHelper = new Matrix();
	
	function CVCompElement(data, comp,globalData){
	    this._parent.constructor.call(this,data, comp,globalData);
	    var compGlobalData = {};
	    for(var s in globalData){
	        if(globalData.hasOwnProperty(s)){
	            compGlobalData[s] = globalData[s];
	        }
	    }
	    compGlobalData.renderer = this;
	    compGlobalData.compHeight = this.data.h;
	    compGlobalData.compWidth = this.data.w;
	    this.renderConfig = {
	        clearCanvas: true
	    };
	    this.contextData = {
	        saved : Array.apply(null,{length:15}),
	        savedOp: Array.apply(null,{length:15}),
	        cArrPos : 0,
	        cTr : new Matrix(),
	        cO : 1
	    };
	    this.completeLayers = false;
	    var i, len = 15;
	    for(i=0;i<len;i+=1){
	        this.contextData.saved[i] = Array.apply(null,{length:16});
	    }
	    this.transformMat = new Matrix();
	    this.parentGlobalData = this.globalData;
	    var cv = document.createElement('canvas');
	    //document.body.appendChild(cv);
	    compGlobalData.canvasContext = cv.getContext('2d');
	    this.canvasContext = compGlobalData.canvasContext;
	    cv.width = this.data.w;
	    cv.height = this.data.h;
	    this.canvas = cv;
	    this.globalData = compGlobalData;
	    this.layers = data.layers;
	    this.pendingElements = [];
	    this.elements = Array.apply(null,{length:this.layers.length});
	    if(this.data.tm){
	        this.tm = PropertyFactory.getProp(this,this.data.tm,0,globalData.frameRate,this.dynamicProperties);
	    }
	    if(this.data.xt || !globalData.progressiveLoad){
	        this.buildAllItems();
	    }
	}
	createElement(CVBaseElement, CVCompElement);
	
	CVCompElement.prototype.ctxTransform = CanvasRenderer.prototype.ctxTransform;
	CVCompElement.prototype.ctxOpacity = CanvasRenderer.prototype.ctxOpacity;
	CVCompElement.prototype.save = CanvasRenderer.prototype.save;
	CVCompElement.prototype.restore = CanvasRenderer.prototype.restore;
	CVCompElement.prototype.reset =  function(){
	    this.contextData.cArrPos = 0;
	    this.contextData.cTr.reset();
	    this.contextData.cO = 1;
	};
	CVCompElement.prototype.resize = function(transformCanvas){
	    var maxScale = Math.max(transformCanvas.sx,transformCanvas.sy);
	    this.canvas.width = this.data.w*maxScale;
	    this.canvas.height = this.data.h*maxScale;
	    this.transformCanvas = {
	        sc:maxScale,
	        w:this.data.w*maxScale,
	        h:this.data.h*maxScale,
	        props:[maxScale,0,0,0,0,maxScale,0,0,0,0,1,0,0,0,0,1]
	    }
	    var i,len = this.elements.length;
	    for( i = 0; i < len; i+=1 ){
	        if(this.elements[i] && this.elements[i].data.ty === 0){
	            this.elements[i].resize(transformCanvas);
	        }
	    }
	};
	
	CVCompElement.prototype.prepareFrame = function(num){
	    this.globalData.frameId = this.parentGlobalData.frameId;
	    this.globalData.mdf = false;
	    this._parent.prepareFrame.call(this,num);
	    if(this.isVisible===false && !this.data.xt){
	        return;
	    }
	    var timeRemapped = num;
	    if(this.tm){
	        timeRemapped = this.tm.v;
	        if(timeRemapped === this.data.op){
	            timeRemapped = this.data.op - 1;
	        }
	    }
	    this.renderedFrame = timeRemapped/this.data.sr;
	    var i,len = this.elements.length;
	
	    if(!this.completeLayers){
	        this.checkLayers(num);
	    }
	
	    for( i = 0; i < len; i+=1 ){
	        if(this.completeLayers || this.elements[i]){
	            this.elements[i].prepareFrame(timeRemapped/this.data.sr - this.layers[i].st);
	            if(this.elements[i].data.ty === 0 && this.elements[i].globalData.mdf){
	                this.globalData.mdf = true;
	            }
	        }
	    }
	    if(this.globalData.mdf && !this.data.xt){
	        this.canvasContext.clearRect(0, 0, this.data.w, this.data.h);
	        this.ctxTransform(this.transformCanvas.props);
	    }
	};
	
	CVCompElement.prototype.renderFrame = function(parentMatrix){
	    if(this._parent.renderFrame.call(this,parentMatrix)===false){
	        return;
	    }
	    if(this.globalData.mdf){
	        var i,len = this.layers.length;
	        for( i = len - 1; i >= 0; i -= 1 ){
	            if(this.completeLayers || this.elements[i]){
	                this.elements[i].renderFrame();
	            }
	        }
	    }
	    if(this.data.hasMask){
	        this.globalData.renderer.restore(true);
	    }
	    if(this.firstFrame){
	        this.firstFrame = false;
	    }
	    this.parentGlobalData.renderer.save();
	    this.parentGlobalData.renderer.ctxTransform(this.finalTransform.mat.props);
	    this.parentGlobalData.renderer.ctxOpacity(this.finalTransform.opacity);
	    this.parentGlobalData.renderer.canvasContext.drawImage(this.canvas,0,0,this.data.w,this.data.h);
	    this.parentGlobalData.renderer.restore();
	
	    if(this.globalData.mdf){
	        this.reset();
	    }
	};
	
	CVCompElement.prototype.setElements = function(elems){
	    this.elements = elems;
	};
	
	CVCompElement.prototype.getElements = function(){
	    return this.elements;
	};
	
	CVCompElement.prototype.destroy = function(){
	    var i,len = this.layers.length;
	    for( i = len - 1; i >= 0; i -= 1 ){
	        this.elements[i].destroy();
	    }
	    this.layers = null;
	    this.elements = null;
	    this._parent.destroy.call(this._parent);
	};
	CVCompElement.prototype.checkLayers = CanvasRenderer.prototype.checkLayers;
	CVCompElement.prototype.buildItem = CanvasRenderer.prototype.buildItem;
	CVCompElement.prototype.checkPendingElements = CanvasRenderer.prototype.checkPendingElements;
	CVCompElement.prototype.addPendingElement = CanvasRenderer.prototype.addPendingElement;
	CVCompElement.prototype.buildAllItems = CanvasRenderer.prototype.buildAllItems;
	CVCompElement.prototype.createItem = CanvasRenderer.prototype.createItem;
	CVCompElement.prototype.createImage = CanvasRenderer.prototype.createImage;
	CVCompElement.prototype.createComp = CanvasRenderer.prototype.createComp;
	CVCompElement.prototype.createSolid = CanvasRenderer.prototype.createSolid;
	CVCompElement.prototype.createShape = CanvasRenderer.prototype.createShape;
	CVCompElement.prototype.createText = CanvasRenderer.prototype.createText;
	CVCompElement.prototype.createBase = CanvasRenderer.prototype.createBase;
	CVCompElement.prototype.buildElementParenting = CanvasRenderer.prototype.buildElementParenting;
	function CVImageElement(data, comp,globalData){
	    this.assetData = globalData.getAssetData(data.refId);
	    this._parent.constructor.call(this,data, comp,globalData);
	    this.globalData.addPendingElement();
	}
	createElement(CVBaseElement, CVImageElement);
	
	CVImageElement.prototype.createElements = function(){
	    var imageLoaded = function(){
	        this.globalData.elementLoaded();
	        if(this.assetData.w !== this.img.width || this.assetData.h !== this.img.height){
	            var canvas = document.createElement('canvas');
	            canvas.width = this.assetData.w;
	            canvas.height = this.assetData.h;
	            var ctx = canvas.getContext('2d');
	
	            var imgW = this.img.width;
	            var imgH = this.img.height;
	            var imgRel = imgW / imgH;
	            var canvasRel = this.assetData.w/this.assetData.h;
	            var widthCrop, heightCrop;
	            if(imgRel>canvasRel){
	                heightCrop = imgH;
	                widthCrop = heightCrop*canvasRel;
	            } else {
	                widthCrop = imgW;
	                heightCrop = widthCrop/canvasRel;
	            }
	            ctx.drawImage(this.img,(imgW-widthCrop)/2,(imgH-heightCrop)/2,widthCrop,heightCrop,0,0,this.assetData.w,this.assetData.h);
	            this.img = canvas;
	        }
	    }.bind(this);
	    var imageFailed = function(){
	        this.failed = true;
	        this.globalData.elementLoaded();
	    }.bind(this);
	
	    this.img = new Image();
	    this.img.addEventListener('load', imageLoaded, false);
	    this.img.addEventListener('error', imageFailed, false);
	    var assetPath = this.globalData.getAssetsPath(this.assetData);
	    this.img.src = assetPath;
	
	    this._parent.createElements.call(this);
	
	};
	
	CVImageElement.prototype.renderFrame = function(parentMatrix){
	    if(this.failed){
	        return;
	    }
	    if(this._parent.renderFrame.call(this,parentMatrix)===false){
	        return;
	    }
	    var ctx = this.canvasContext;
	    this.globalData.renderer.save();
	    var finalMat = this.finalTransform.mat.props;
	    this.globalData.renderer.ctxTransform(finalMat);
	    this.globalData.renderer.ctxOpacity(this.finalTransform.opacity);
	    ctx.drawImage(this.img,0,0);
	    this.globalData.renderer.restore(this.data.hasMask);
	    if(this.firstFrame){
	        this.firstFrame = false;
	    }
	};
	
	CVImageElement.prototype.destroy = function(){
	    this.img = null;
	    this._parent.destroy.call(this._parent);
	};
	
	function CVMaskElement(data,element){
	    this.data = data;
	    this.element = element;
	    this.dynamicProperties = [];
	    this.masksProperties = this.data.masksProperties;
	    this.viewData = Array.apply(null,{length:this.masksProperties.length});
	    var i, len = this.masksProperties.length;
	    for (i = 0; i < len; i++) {
	        this.viewData[i] = ShapePropertyFactory.getShapeProp(this.element,this.masksProperties[i],3,this.dynamicProperties,null);
	    }
	}
	
	CVMaskElement.prototype.prepareFrame = function(num){
	    var i, len = this.dynamicProperties.length;
	    for(i=0;i<len;i+=1){
	        this.dynamicProperties[i].getValue(num);
	        if(this.dynamicProperties[i].mdf){
	            this.element.globalData.mdf = true;
	        }
	    }
	};
	
	CVMaskElement.prototype.renderFrame = function (transform) {
	    var ctx = this.element.canvasContext;
	    var i, len = this.data.masksProperties.length;
	    var pt,pt2,pt3,data, hasMasks = false;
	    for (i = 0; i < len; i++) {
	        if(this.masksProperties[i].mode === 'n'){
	            continue;
	        }
	        if(hasMasks === false){
	            ctx.beginPath();
	            hasMasks = true;
	        }
	        if (this.masksProperties[i].inv) {
	            ctx.moveTo(0, 0);
	            ctx.lineTo(this.element.globalData.compWidth, 0);
	            ctx.lineTo(this.element.globalData.compWidth, this.element.globalData.compHeight);
	            ctx.lineTo(0, this.element.globalData.compHeight);
	            ctx.lineTo(0, 0);
	        }
	        data = this.viewData[i].v;
	        pt = transform ? transform.applyToPointArray(data.v[0][0],data.v[0][1],0):data.v[0];
	        ctx.moveTo(pt[0], pt[1]);
	        var j, jLen = data._length;
	        for (j = 1; j < jLen; j++) {
	            pt = transform ? transform.applyToPointArray(data.o[j - 1][0],data.o[j - 1][1],0) : data.o[j - 1];
	            pt2 = transform ? transform.applyToPointArray(data.i[j][0],data.i[j][1],0) : data.i[j];
	            pt3 = transform ? transform.applyToPointArray(data.v[j][0],data.v[j][1],0) : data.v[j];
	            ctx.bezierCurveTo(pt[0], pt[1], pt2[0], pt2[1], pt3[0], pt3[1]);
	        }
	        pt = transform ? transform.applyToPointArray(data.o[j - 1][0],data.o[j - 1][1],0) : data.o[j - 1];
	        pt2 = transform ? transform.applyToPointArray(data.i[0][0],data.i[0][1],0) : data.i[0];
	        pt3 = transform ? transform.applyToPointArray(data.v[0][0],data.v[0][1],0) : data.v[0];
	        ctx.bezierCurveTo(pt[0], pt[1], pt2[0], pt2[1], pt3[0], pt3[1]);
	    }
	    if(hasMasks){
	        ctx.clip();
	    }
	};
	
	CVMaskElement.prototype.getMaskProperty = MaskElement.prototype.getMaskProperty;
	
	CVMaskElement.prototype.destroy = function(){
	    this.element = null;
	};
	function CVShapeElement(data, comp,globalData){
	    this.shapes = [];
	    this.shapesData = data.shapes;
	    this.stylesList = [];
	    this.itemsData = [];
	    this.prevViewData = [];
	    this.shapeModifiers = [];
	    this.processedElements = [];
	    this._parent.constructor.call(this,data, comp,globalData);
	}
	createElement(CVBaseElement, CVShapeElement);
	
	CVShapeElement.prototype.transformHelper = {opacity:1,mat:new Matrix(),matMdf:false,opMdf:false};
	
	CVShapeElement.prototype.dashResetter = [];
	
	CVShapeElement.prototype.createElements = function(){
	
	    this._parent.createElements.call(this);
	    this.searchShapes(this.shapesData,this.itemsData,this.prevViewData,this.dynamicProperties, true);
	};
	
	CVShapeElement.prototype.createStyleElement = function(data, dynamicProperties){
	    var styleElem = {
	        data: data,
	        type: data.ty,
	        elements: []
	    };
	    var elementData = {};
	    if(data.ty == 'fl' || data.ty == 'st'){
	        elementData.c = PropertyFactory.getProp(this,data.c,1,255,dynamicProperties);
	        if(!elementData.c.k){
	            styleElem.co = 'rgb('+bm_floor(elementData.c.v[0])+','+bm_floor(elementData.c.v[1])+','+bm_floor(elementData.c.v[2])+')';
	        }
	    }
	    elementData.o = PropertyFactory.getProp(this,data.o,0,0.01,dynamicProperties);
	    if(data.ty == 'st') {
	        styleElem.lc = this.lcEnum[data.lc] || 'round';
	        styleElem.lj = this.ljEnum[data.lj] || 'round';
	        if(data.lj == 1) {
	            styleElem.ml = data.ml;
	        }
	        elementData.w = PropertyFactory.getProp(this,data.w,0,null,dynamicProperties);
	        if(!elementData.w.k){
	            styleElem.wi = elementData.w.v;
	        }
	        if(data.d){
	            var d = new DashProperty(this,data.d,'canvas',dynamicProperties);
	            elementData.d = d;
	            if(!elementData.d.k){
	                styleElem.da = elementData.d.dashArray;
	                styleElem.do = elementData.d.dashoffset[0];
	            }
	        }
	
	    } else {
	
	        styleElem.r = data.r === 2 ? 'evenodd' : 'nonzero';
	    }
	    this.stylesList.push(styleElem);
	    elementData.style = styleElem;
	    return elementData;
	}
	
	CVShapeElement.prototype.createGroupElement = function(data) {
	    var elementData = {
	        it: [],
	        prevViewData: []
	    };
	    return elementData;
	}
	
	CVShapeElement.prototype.createTransformElement = function(data, dynamicProperties) {
	    var elementData = {
	        transform : {
	            mat: new Matrix(),
	            opacity: 1,
	            matMdf:false,
	            opMdf:false,
	            op: PropertyFactory.getProp(this,data.o,0,0.01,dynamicProperties),
	            //mProps: PropertyFactory.getProp(this,data,2,null,dynamicProperties)
	            mProps: TransformPropertyFactory.getTransformProperty(this,data,dynamicProperties)
	        },
	        elements: []
	    };
	    return elementData;
	}
	
	CVShapeElement.prototype.createShapeElement = function(data, dynamicProperties) {
	    var elementData = {
	        nodes:[],
	        trNodes:[],
	        tr:[0,0,0,0,0,0]
	    };
	    var ty = 4;
	    if(data.ty == 'rc'){
	        ty = 5;
	    }else if(data.ty == 'el'){
	        ty = 6;
	    }else if(data.ty == 'sr'){
	        ty = 7;
	    }
	    elementData.sh = ShapePropertyFactory.getShapeProp(this,data,ty,dynamicProperties);
	    this.shapes.push(elementData.sh);
	    this.addShapeToModifiers(elementData);
	    jLen = this.stylesList.length;
	    var hasStrokes = false, hasFills = false;
	    for(j=0;j<jLen;j+=1){
	        if(!this.stylesList[j].closed){
	            this.stylesList[j].elements.push(elementData);
	            if(this.stylesList[j].type === 'st'){
	                hasStrokes = true;
	            }else{
	                hasFills = true;
	            }
	        }
	    }
	    elementData.st = hasStrokes;
	    elementData.fl = hasFills;
	    return elementData;
	}
	
	CVShapeElement.prototype.reloadShapes = function(){
	    this.firstFrame = true;
	    var i, len = this.itemsData.length;
	    for(i=0;i<len;i+=1){
	        this.prevViewData[i] = this.itemsData[i];
	    }
	    this.searchShapes(this.shapesData,this.itemsData,this.prevViewData,this.dynamicProperties, true);
	    var i, len = this.dynamicProperties.length;
	    for(i=0;i<len;i+=1){
	        this.dynamicProperties[i].getValue();
	    }
	    this.renderModifiers();
	}
	
	CVShapeElement.prototype.searchShapes = function(arr,itemsData, prevViewData,dynamicProperties, render){
	    var i, len = arr.length - 1;
	    var j, jLen;
	    var ownArrays = [], ownModifiers = [], processedPos;
	    for(i=len;i>=0;i-=1){
	        processedPos = this.searchProcessedElement(arr[i]);
	        if(!processedPos){
	            arr[i]._render = render;
	        } else {
	            itemsData[i] = prevViewData[processedPos - 1];
	        }
	        if(arr[i].ty == 'fl' || arr[i].ty == 'st'){
	            if(!processedPos){
	                itemsData[i] = this.createStyleElement(arr[i], dynamicProperties);
	            } else {
	                itemsData[i].style.closed = false;
	            }
	            
	            ownArrays.push(itemsData[i].style);
	        }else if(arr[i].ty == 'gr'){
	            if(!processedPos){
	                itemsData[i] = this.createGroupElement(arr[i]);
	            } else {
	                jLen = itemsData[i].it.length;
	                for(j=0;j<jLen;j+=1){
	                    itemsData[i].prevViewData[j] = itemsData[i].it[j];
	                }
	            }
	            this.searchShapes(arr[i].it,itemsData[i].it,itemsData[i].prevViewData,dynamicProperties, render);
	        }else if(arr[i].ty == 'tr'){
	            if(!processedPos){
	                itemsData[i] = this.createTransformElement(arr[i], dynamicProperties);
	            }
	        }else if(arr[i].ty == 'sh' || arr[i].ty == 'rc' || arr[i].ty == 'el' || arr[i].ty == 'sr'){
	            if(!processedPos){
	                itemsData[i] = this.createShapeElement(arr[i], dynamicProperties);
	            }
	            
	        }else if(arr[i].ty == 'tm' || arr[i].ty == 'rd'){
	            if(!processedPos){
	                var modifier = ShapeModifiers.getModifier(arr[i].ty);
	                modifier.init(this,arr[i],dynamicProperties);
	                itemsData[i] = modifier;
	                this.shapeModifiers.push(modifier);
	            } else {
	                modifier = itemsData[i];
	                modifier.closed = false;
	            }
	            ownModifiers.push(modifier);
	        } else if(arr[i].ty == 'rp'){
	            if(!processedPos){
	                modifier = ShapeModifiers.getModifier(arr[i].ty);
	                itemsData[i] = modifier;
	                modifier.init(this,arr,i,itemsData,dynamicProperties);
	                this.shapeModifiers.push(modifier);
	                render = false;
	            }else{
	                modifier = itemsData[i];
	                modifier.closed = true;
	            }
	            ownModifiers.push(modifier);
	        }
	        this.addProcessedElement(arr[i], i + 1);
	    }
	    len = ownArrays.length;
	    for(i=0;i<len;i+=1){
	        ownArrays[i].closed = true;
	    }
	    len = ownModifiers.length;
	    for(i=0;i<len;i+=1){
	        ownModifiers[i].closed = true;
	    }
	};
	
	CVShapeElement.prototype.addShapeToModifiers = IShapeElement.prototype.addShapeToModifiers;
	CVShapeElement.prototype.renderModifiers = IShapeElement.prototype.renderModifiers;
	CVShapeElement.prototype.lcEnum = IShapeElement.prototype.lcEnum;
	CVShapeElement.prototype.ljEnum = IShapeElement.prototype.ljEnum;
	CVShapeElement.prototype.searchProcessedElement = IShapeElement.prototype.searchProcessedElement;
	CVShapeElement.prototype.addProcessedElement = IShapeElement.prototype.addProcessedElement;
	
	CVShapeElement.prototype.renderFrame = function(parentMatrix){
	    if(this._parent.renderFrame.call(this, parentMatrix)===false){
	        return;
	    }
	    this.transformHelper.mat.reset();
	    this.transformHelper.opacity = this.finalTransform.opacity;
	    this.transformHelper.matMdf = false;
	    this.transformHelper.opMdf = this.finalTransform.opMdf;
	    this.renderModifiers();
	    this.renderShape(this.transformHelper,null,null,true);
	    if(this.data.hasMask){
	        this.globalData.renderer.restore(true);
	    }
	};
	
	CVShapeElement.prototype.renderShape = function(parentTransform,items,data,isMain){
	    var i, len;
	    if(!items){
	        items = this.shapesData;
	        len = this.stylesList.length;
	        for(i=0;i<len;i+=1){
	            this.stylesList[i].d = '';
	            this.stylesList[i].mdf = false;
	        }
	    }
	    if(!data){
	        data = this.itemsData;
	    }
	    ///
	    ///
	    len = items.length - 1;
	    var groupTransform,groupMatrix;
	    groupTransform = parentTransform;
	    for(i=len;i>=0;i-=1){
	        if(items[i].ty == 'tr'){
	            groupTransform = data[i].transform;
	            var mtArr = data[i].transform.mProps.v.props;
	            groupTransform.matMdf = groupTransform.mProps.mdf;
	            groupTransform.opMdf = groupTransform.op.mdf;
	            groupMatrix = groupTransform.mat;
	            groupMatrix.cloneFromProps(mtArr);
	            if(parentTransform){
	                var props = parentTransform.mat.props;
	                groupTransform.opacity = parentTransform.opacity;
	                groupTransform.opacity *= data[i].transform.op.v;
	                groupTransform.matMdf = parentTransform.matMdf ? true : groupTransform.matMdf;
	                groupTransform.opMdf = parentTransform.opMdf ? true : groupTransform.opMdf;
	                groupMatrix.transform(props[0],props[1],props[2],props[3],props[4],props[5],props[6],props[7],props[8],props[9],props[10],props[11],props[12],props[13],props[14],props[15]);
	            }else{
	                groupTransform.opacity = groupTransform.op.o;
	            }
	        }else if(items[i].ty == 'sh' || items[i].ty == 'el' || items[i].ty == 'rc' || items[i].ty == 'sr'){
	            this.renderPath(items[i],data[i],groupTransform);
	        }else if(items[i].ty == 'fl'){
	            this.renderFill(items[i],data[i],groupTransform);
	        }else if(items[i].ty == 'st'){
	            this.renderStroke(items[i],data[i],groupTransform);
	        }else if(items[i].ty == 'gr'){
	            this.renderShape(groupTransform,items[i].it,data[i].it);
	        }else if(items[i].ty == 'tm'){
	            //
	        }
	    }
	    if(!isMain){
	        return;
	    }
	    len = this.stylesList.length;
	    var j, jLen, k, kLen,elems,nodes, renderer = this.globalData.renderer, ctx = this.globalData.canvasContext, type;
	    renderer.save();
	    renderer.ctxTransform(this.finalTransform.mat.props);
	    for(i=0;i<len;i+=1){
	        type = this.stylesList[i].type;
	        if((type === 'st' && this.stylesList[i].wi === 0) || !this.stylesList[i].data._render){
	            continue;
	        }
	        renderer.save();
	        elems = this.stylesList[i].elements;
	        if(type === 'st'){
	            ctx.strokeStyle = this.stylesList[i].co;
	            ctx.lineWidth = this.stylesList[i].wi;
	            ctx.lineCap = this.stylesList[i].lc;
	            ctx.lineJoin = this.stylesList[i].lj;
	            ctx.miterLimit = this.stylesList[i].ml || 0;
	        }else{
	            ctx.fillStyle = this.stylesList[i].co;
	        }
	        renderer.ctxOpacity(this.stylesList[i].coOp);
	        if(type !== 'st'){
	            ctx.beginPath();
	        }
	        jLen = elems.length;
	        for(j=0;j<jLen;j+=1){
	            if(type === 'st'){
	                ctx.beginPath();
	                if(this.stylesList[i].da){
	                    ctx.setLineDash(this.stylesList[i].da);
	                    ctx.lineDashOffset = this.stylesList[i].do;
	                    this.globalData.isDashed = true;
	                }else if(this.globalData.isDashed){
	                    ctx.setLineDash(this.dashResetter);
	                    this.globalData.isDashed = false;
	                }
	            }
	            nodes = elems[j].trNodes;
	            kLen = nodes.length;
	
	            for(k=0;k<kLen;k+=1){
	                if(nodes[k].t == 'm'){
	                    ctx.moveTo(nodes[k].p[0],nodes[k].p[1]);
	                }else if(nodes[k].t == 'c'){
	                    ctx.bezierCurveTo(nodes[k].p1[0],nodes[k].p1[1],nodes[k].p2[0],nodes[k].p2[1],nodes[k].p3[0],nodes[k].p3[1]);
	                }else{
	                    ctx.closePath();
	                }
	            }
	            if(type === 'st'){
	                ctx.stroke();
	            }
	        }
	        if(type !== 'st'){
	            ctx.fill(this.stylesList[i].r);
	        }
	        renderer.restore();
	    }
	    renderer.restore();
	    if(this.firstFrame){
	        this.firstFrame = false;
	    }
	};
	CVShapeElement.prototype.renderPath = function(pathData,itemData,groupTransform){
	    var len, i, j,jLen;
	    var redraw = groupTransform.matMdf || itemData.sh.mdf || this.firstFrame;
	    if(redraw) {
	        var paths = itemData.sh.paths, groupTransformMat = groupTransform.mat;
	        jLen = paths._length;
	        var pathStringTransformed = itemData.trNodes;
	        pathStringTransformed.length = 0;
	        for(j=0;j<jLen;j+=1){
	            var pathNodes = paths.shapes[j];
	            if(pathNodes && pathNodes.v){
	                len = pathNodes._length;
	                for (i = 1; i < len; i += 1) {
	                    if (i == 1) {
	                        pathStringTransformed.push({
	                            t: 'm',
	                            p: groupTransformMat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0)
	                        });
	                    }
	                    pathStringTransformed.push({
	                        t: 'c',
	                        p1: groupTransformMat.applyToPointArray(pathNodes.o[i - 1][0], pathNodes.o[i - 1][1], 0),
	                        p2: groupTransformMat.applyToPointArray(pathNodes.i[i][0], pathNodes.i[i][1], 0),
	                        p3: groupTransformMat.applyToPointArray(pathNodes.v[i][0], pathNodes.v[i][1], 0)
	                    });
	                }
	                if (len == 1) {
	                    pathStringTransformed.push({
	                        t: 'm',
	                        p: groupTransformMat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0)
	                    });
	                }
	                if (pathNodes.c && len) {
	                    pathStringTransformed.push({
	                        t: 'c',
	                        p1: groupTransformMat.applyToPointArray(pathNodes.o[i - 1][0], pathNodes.o[i - 1][1], 0),
	                        p2: groupTransformMat.applyToPointArray(pathNodes.i[0][0], pathNodes.i[0][1], 0),
	                        p3: groupTransformMat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0)
	                    });
	                    pathStringTransformed.push({
	                        t: 'z'
	                    });
	                }
	                itemData.lStr = pathStringTransformed;
	            }
	
	        }
	
	        if (itemData.st) {
	            for (i = 0; i < 16; i += 1) {
	                itemData.tr[i] = groupTransform.mat.props[i];
	            }
	        }
	        itemData.trNodes = pathStringTransformed;
	
	    }
	};
	
	
	
	CVShapeElement.prototype.renderFill = function(styleData,itemData, groupTransform){
	    var styleElem = itemData.style;
	
	    if(itemData.c.mdf || this.firstFrame){
	        styleElem.co = 'rgb('+bm_floor(itemData.c.v[0])+','+bm_floor(itemData.c.v[1])+','+bm_floor(itemData.c.v[2])+')';
	    }
	    if(itemData.o.mdf || groupTransform.opMdf || this.firstFrame){
	        styleElem.coOp = itemData.o.v*groupTransform.opacity;
	    }
	};
	
	CVShapeElement.prototype.renderStroke = function(styleData,itemData, groupTransform){
	    var styleElem = itemData.style;
	    //TODO fix dashes
	    var d = itemData.d;
	    if(d && (d.mdf  || this.firstFrame)){
	        styleElem.da = d.dashArray;
	        styleElem.do = d.dashoffset[0];
	    }
	    if(itemData.c.mdf || this.firstFrame){
	        styleElem.co = 'rgb('+bm_floor(itemData.c.v[0])+','+bm_floor(itemData.c.v[1])+','+bm_floor(itemData.c.v[2])+')';
	    }
	    if(itemData.o.mdf || groupTransform.opMdf || this.firstFrame){
	        styleElem.coOp = itemData.o.v*groupTransform.opacity;
	    }
	    if(itemData.w.mdf || this.firstFrame){
	        styleElem.wi = itemData.w.v;
	    }
	};
	
	
	CVShapeElement.prototype.destroy = function(){
	    this.shapesData = null;
	    this.globalData = null;
	    this.canvasContext = null;
	    this.stylesList.length = 0;
	    this.itemData.length = 0;
	    this._parent.destroy.call(this._parent);
	};
	
	
	function CVSolidElement(data, comp,globalData){
	    this._parent.constructor.call(this,data, comp,globalData);
	}
	createElement(CVBaseElement, CVSolidElement);
	
	CVSolidElement.prototype.renderFrame = function(parentMatrix){
	    if(this._parent.renderFrame.call(this, parentMatrix)===false){
	        return;
	    }
	    var ctx = this.canvasContext;
	    this.globalData.renderer.save();
	    this.globalData.renderer.ctxTransform(this.finalTransform.mat.props);
	    this.globalData.renderer.ctxOpacity(this.finalTransform.opacity);
	    ctx.fillStyle=this.data.sc;
	    ctx.fillRect(0,0,this.data.sw,this.data.sh);
	    this.globalData.renderer.restore(this.data.hasMask);
	    if(this.firstFrame){
	        this.firstFrame = false;
	    }
	};
	function CVTextElement(data, comp, globalData){
	    this.textSpans = [];
	    this.yOffset = 0;
	    this.fillColorAnim = false;
	    this.strokeColorAnim = false;
	    this.strokeWidthAnim = false;
	    this.stroke = false;
	    this.fill = false;
	    this.justifyOffset = 0;
	    this.currentRender = null;
	    this.renderType = 'canvas';
	    this.values = {
	        fill: 'rgba(0,0,0,0)',
	        stroke: 'rgba(0,0,0,0)',
	        sWidth: 0,
	        fValue: ''
	    }
	    this._parent.constructor.call(this,data,comp, globalData);
	}
	createElement(CVBaseElement, CVTextElement);
	
	extendPrototype(ITextElement, CVTextElement);
	
	CVTextElement.prototype.tHelper = document.createElement('canvas').getContext('2d');
	
	CVTextElement.prototype.createElements = function(){
	
	    this._parent.createElements.call(this);
	    //console.log('this.data: ',this.data);
	
	};
	
	CVTextElement.prototype.buildNewText = function(){
	    var documentData = this.textProperty.currentData;
	    this.renderedLetters = Array.apply(null,{length:documentData.l ? documentData.l.length : 0});
	
	    var hasFill = false;
	    if(documentData.fc) {
	        hasFill = true;
	        this.values.fill = this.buildColor(documentData.fc);
	    }else{
	        this.values.fill = 'rgba(0,0,0,0)';
	    }
	    this.fill = hasFill;
	    var hasStroke = false;
	    if(documentData.sc){
	        hasStroke = true;
	        this.values.stroke = this.buildColor(documentData.sc);
	        this.values.sWidth = documentData.sw;
	    }
	    var fontData = this.globalData.fontManager.getFontByName(documentData.f);
	    var i, len;
	    var letters = documentData.l;
	    var matrixHelper = this.mHelper;
	    this.stroke = hasStroke;
	    this.values.fValue = documentData.s + 'px '+ this.globalData.fontManager.getFontByName(documentData.f).fFamily;
	    len = documentData.t.length;
	    //this.tHelper.font = this.values.fValue;
	    var charData, shapeData, k, kLen, shapes, j, jLen, pathNodes, commands, pathArr, singleShape = this.data.singleShape;
	    var trackingOffset = documentData.tr/1000*documentData.s;
	    var xPos = 0, yPos = 0, firstLine = true;
	    var cnt = 0;
	    for (i = 0; i < len; i += 1) {
	        charData = this.globalData.fontManager.getCharData(documentData.t.charAt(i), fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
	        shapeData = charData && charData.data || {};
	        matrixHelper.reset();
	        if(singleShape && letters[i].n) {
	            xPos = -trackingOffset;
	            yPos += documentData.yOffset;
	            yPos += firstLine ? 1 : 0;
	            firstLine = false;
	        }
	
	        shapes = shapeData.shapes ? shapeData.shapes[0].it : [];
	        jLen = shapes.length;
	        matrixHelper.scale(documentData.s/100,documentData.s/100);
	        if(singleShape){
	            this.applyTextPropertiesToMatrix(documentData, matrixHelper, letters[i].line, xPos, yPos);
	        }
	        commands = Array.apply(null,{length:jLen})
	        for(j=0;j<jLen;j+=1){
	            kLen = shapes[j].ks.k.i.length;
	            pathNodes = shapes[j].ks.k;
	            pathArr = [];
	            for(k=1;k<kLen;k+=1){
	                if(k==1){
	                    pathArr.push(matrixHelper.applyToX(pathNodes.v[0][0],pathNodes.v[0][1],0),matrixHelper.applyToY(pathNodes.v[0][0],pathNodes.v[0][1],0));
	                }
	                pathArr.push(matrixHelper.applyToX(pathNodes.o[k-1][0],pathNodes.o[k-1][1],0),matrixHelper.applyToY(pathNodes.o[k-1][0],pathNodes.o[k-1][1],0),matrixHelper.applyToX(pathNodes.i[k][0],pathNodes.i[k][1],0),matrixHelper.applyToY(pathNodes.i[k][0],pathNodes.i[k][1],0),matrixHelper.applyToX(pathNodes.v[k][0],pathNodes.v[k][1],0),matrixHelper.applyToY(pathNodes.v[k][0],pathNodes.v[k][1],0));
	            }
	            pathArr.push(matrixHelper.applyToX(pathNodes.o[k-1][0],pathNodes.o[k-1][1],0),matrixHelper.applyToY(pathNodes.o[k-1][0],pathNodes.o[k-1][1],0),matrixHelper.applyToX(pathNodes.i[0][0],pathNodes.i[0][1],0),matrixHelper.applyToY(pathNodes.i[0][0],pathNodes.i[0][1],0),matrixHelper.applyToX(pathNodes.v[0][0],pathNodes.v[0][1],0),matrixHelper.applyToY(pathNodes.v[0][0],pathNodes.v[0][1],0));
	            commands[j] = pathArr;
	        }
	        if(singleShape){
	            xPos += letters[i].l;
	            xPos += trackingOffset;
	        }
	        if(this.textSpans[cnt]){
	            this.textSpans[cnt].elem = commands;
	        } else {
	            this.textSpans[cnt] = {elem: commands};
	        }
	        cnt +=1;
	    }
	}
	
	CVTextElement.prototype.renderFrame = function(parentMatrix){
	    if(this._parent.renderFrame.call(this, parentMatrix)===false){
	        return;
	    }
	    var ctx = this.canvasContext;
	    var finalMat = this.finalTransform.mat.props;
	    this.globalData.renderer.save();
	    this.globalData.renderer.ctxTransform(finalMat);
	    this.globalData.renderer.ctxOpacity(this.finalTransform.opacity);
	    ctx.font = this.values.fValue;
	    ctx.lineCap = 'butt';
	    ctx.lineJoin = 'miter';
	    ctx.miterLimit = 4;
	
	    if(!this.data.singleShape){
	        this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
	    }
	
	    var  i,len, j, jLen, k, kLen;
	    var renderedLetters = this.textAnimator.renderedLetters;
	
	    var letters = this.textProperty.currentData.l;
	
	    len = letters.length;
	    var renderedLetter;
	    var lastFill = null, lastStroke = null, lastStrokeW = null, commands, pathArr;
	    for(i=0;i<len;i+=1){
	        if(letters[i].n){
	            continue;
	        }
	        renderedLetter = renderedLetters[i];
	        if(renderedLetter){
	            this.globalData.renderer.save();
	            this.globalData.renderer.ctxTransform(renderedLetter.p);
	            this.globalData.renderer.ctxOpacity(renderedLetter.o);
	        }
	        if(this.fill){
	            if(renderedLetter && renderedLetter.fc){
	                if(lastFill !== renderedLetter.fc){
	                    lastFill = renderedLetter.fc;
	                    ctx.fillStyle = renderedLetter.fc;
	                }
	            }else if(lastFill !== this.values.fill){
	                lastFill = this.values.fill;
	                ctx.fillStyle = this.values.fill;
	            }
	            commands = this.textSpans[i].elem;
	            jLen = commands.length;
	            this.globalData.canvasContext.beginPath();
	            for(j=0;j<jLen;j+=1) {
	                pathArr = commands[j];
	                kLen = pathArr.length;
	                this.globalData.canvasContext.moveTo(pathArr[0], pathArr[1]);
	                for (k = 2; k < kLen; k += 6) {
	                    this.globalData.canvasContext.bezierCurveTo(pathArr[k], pathArr[k + 1], pathArr[k + 2], pathArr[k + 3], pathArr[k + 4], pathArr[k + 5]);
	                }
	            }
	            this.globalData.canvasContext.closePath();
	            this.globalData.canvasContext.fill();
	            ///ctx.fillText(this.textSpans[i].val,0,0);
	        }
	        if(this.stroke){
	            if(renderedLetter && renderedLetter.sw){
	                if(lastStrokeW !== renderedLetter.sw){
	                    lastStrokeW = renderedLetter.sw;
	                    ctx.lineWidth = renderedLetter.sw;
	                }
	            }else if(lastStrokeW !== this.values.sWidth){
	                lastStrokeW = this.values.sWidth;
	                ctx.lineWidth = this.values.sWidth;
	            }
	            if(renderedLetter && renderedLetter.sc){
	                if(lastStroke !== renderedLetter.sc){
	                    lastStroke = renderedLetter.sc;
	                    ctx.strokeStyle = renderedLetter.sc;
	                }
	            }else if(lastStroke !== this.values.stroke){
	                lastStroke = this.values.stroke;
	                ctx.strokeStyle = this.values.stroke;
	            }
	            commands = this.textSpans[i].elem;
	            jLen = commands.length;
	            this.globalData.canvasContext.beginPath();
	            for(j=0;j<jLen;j+=1) {
	                pathArr = commands[j];
	                kLen = pathArr.length;
	                this.globalData.canvasContext.moveTo(pathArr[0], pathArr[1]);
	                for (k = 2; k < kLen; k += 6) {
	                    this.globalData.canvasContext.bezierCurveTo(pathArr[k], pathArr[k + 1], pathArr[k + 2], pathArr[k + 3], pathArr[k + 4], pathArr[k + 5]);
	                }
	            }
	            this.globalData.canvasContext.closePath();
	            this.globalData.canvasContext.stroke();
	            ///ctx.strokeText(letters[i].val,0,0);
	        }
	        if(renderedLetter) {
	            this.globalData.renderer.restore();
	        }
	    }
	    /*if(this.data.hasMask){
	     this.globalData.renderer.restore(true);
	     }*/
	    this.globalData.renderer.restore(this.data.hasMask);
	    if(this.firstFrame){
	        this.firstFrame = false;
	    }
	};
	function HBaseElement(data,parentContainer,globalData,comp, placeholder){
	    this.globalData = globalData;
	    this.comp = comp;
	    this.data = data;
	    this.matteElement = null;
	    this.parentContainer = parentContainer;
	    this.layerId = placeholder ? placeholder.layerId : 'ly_'+randomString(10);
	    this.placeholder = placeholder;
	    this.init();
	};
	
	createElement(BaseElement, HBaseElement);
	HBaseElement.prototype.checkBlendMode = function(){
	
	};
	HBaseElement.prototype.setBlendMode = BaseElement.prototype.setBlendMode;
	
	/*HBaseElement.prototype.appendNodeToParent = function(node) {
	    if(this.data.hd){
	        return;
	    }
	    if(this.placeholder){
	        var g = this.placeholder.phElement;
	        g.parentNode.insertBefore(node, g);
	        //g.parentNode.removeChild(g);
	    }else{
	        this.parentContainer.appendChild(node);
	    }
	};*/
	
	
	HBaseElement.prototype.getBaseElement = function(){
	    return this.baseElement;
	};
	
	HBaseElement.prototype.createElements = function(){
	    if(this.data.hasMask){
	        this.layerElement = createNS('svg');
	        styleDiv(this.layerElement);
	        //this.appendNodeToParent(this.layerElement);
	        this.baseElement = this.layerElement;
	        this.maskedElement = this.layerElement;
	    }else{
	        this.layerElement = this.parentContainer;
	    }
	    this.transformedElement = this.layerElement;
	    if(this.data.ln && (this.data.ty === 4 || this.data.ty === 0)){
	        if(this.layerElement === this.parentContainer){
	            this.layerElement = createNS('g');
	            //this.appendNodeToParent(this.layerElement);
	            this.baseElement = this.layerElement;
	        }
	        this.layerElement.setAttribute('id',this.data.ln);
	    }
	    this.setBlendMode();
	    if(this.layerElement !== this.parentContainer){
	        this.placeholder = null;
	    }
	    this.checkParenting();
	};
	
	HBaseElement.prototype.renderFrame = function(parentTransform){
	    if(this.data.ty === 3){
	        return false;
	    }
	
	    if(this.currentFrameNum === this.lastNum || !this.isVisible){
	        return this.isVisible;
	    }
	    this.lastNum = this.currentFrameNum;
	
	    this.finalTransform.opMdf = this.finalTransform.op.mdf;
	    this.finalTransform.matMdf = this.finalTransform.mProp.mdf;
	    this.finalTransform.opacity = this.finalTransform.op.v;
	    if(this.firstFrame){
	        this.finalTransform.opMdf = true;
	        this.finalTransform.matMdf = true;
	    }
	
	    var mat;
	    var finalMat = this.finalTransform.mat;
	
	    if(this.hierarchy){
	        var i, len = this.hierarchy.length;
	
	        mat = this.finalTransform.mProp.v.props;
	        finalMat.cloneFromProps(mat);
	        for(i=0;i<len;i+=1){
	            this.finalTransform.matMdf = this.hierarchy[i].finalTransform.mProp.mdf ? true : this.finalTransform.matMdf;
	            mat = this.hierarchy[i].finalTransform.mProp.v.props;
	            finalMat.transform(mat[0],mat[1],mat[2],mat[3],mat[4],mat[5],mat[6],mat[7],mat[8],mat[9],mat[10],mat[11],mat[12],mat[13],mat[14],mat[15]);
	        }
	    }else{
	        if(this.isVisible && this.finalTransform.matMdf){
	            if(!parentTransform){
	                finalMat.cloneFromProps(this.finalTransform.mProp.v.props);
	            }else{
	                mat = this.finalTransform.mProp.v.props;
	                finalMat.cloneFromProps(mat);
	            }
	        }
	    }
	    if(this.data.hasMask){
	        this.maskManager.renderFrame(finalMat);
	    }
	
	    if(parentTransform){
	        mat = parentTransform.mat.props;
	        finalMat.cloneFromProps(mat);
	        this.finalTransform.opacity *= parentTransform.opacity;
	        this.finalTransform.opMdf = parentTransform.opMdf ? true : this.finalTransform.opMdf;
	        this.finalTransform.matMdf = parentTransform.matMdf ? true : this.finalTransform.matMdf
	    }
	
	    if(this.finalTransform.matMdf){
	        this.transformedElement.style.transform = this.transformedElement.style.webkitTransform = finalMat.toCSS();
	        this.finalMat = finalMat;
	    }
	    if(this.finalTransform.opMdf){
	        this.transformedElement.style.opacity = this.finalTransform.opacity;
	    }
	    return this.isVisible;
	};
	
	HBaseElement.prototype.destroy = function(){
	    this.layerElement = null;
	    this.transformedElement = null;
	    this.parentContainer = null;
	    if(this.matteElement) {
	        this.matteElement = null;
	    }
	    if(this.maskManager) {
	        this.maskManager.destroy();
	        this.maskManager = null;
	    }
	};
	
	HBaseElement.prototype.getDomElement = function(){
	    return this.layerElement;
	};
	HBaseElement.prototype.addMasks = function(data){
	    this.maskManager = new MaskElement(data,this,this.globalData);
	};
	
	HBaseElement.prototype.hide = function(){
	};
	
	HBaseElement.prototype.setMatte = function(){
	
	}
	
	HBaseElement.prototype.buildElementParenting = HybridRenderer.prototype.buildElementParenting;
	function HSolidElement(data,parentContainer,globalData,comp, placeholder){
	    this._parent.constructor.call(this,data,parentContainer,globalData,comp, placeholder);
	}
	createElement(HBaseElement, HSolidElement);
	
	HSolidElement.prototype.createElements = function(){
	    var parent = document.createElement('div');
	    styleDiv(parent);
	    var cont = createNS('svg');
	    styleDiv(cont);
	    cont.setAttribute('width',this.data.sw);
	    cont.setAttribute('height',this.data.sh);
	    parent.appendChild(cont);
	    this.layerElement = parent;
	    this.transformedElement = parent;
	    //this.appendNodeToParent(parent);
	    this.baseElement = parent;
	    this.innerElem = parent;
	    if(this.data.ln){
	        this.innerElem.setAttribute('id',this.data.ln);
	    }
	    if(this.data.bm !== 0){
	        this.setBlendMode();
	    }
	    var rect = createNS('rect');
	    rect.setAttribute('width',this.data.sw);
	    rect.setAttribute('height',this.data.sh);
	    rect.setAttribute('fill',this.data.sc);
	    cont.appendChild(rect);
	    if(this.data.hasMask){
	        this.maskedElement = rect;
	    }
	    this.checkParenting();
	};
	
	
	
	HSolidElement.prototype.hide = SVGBaseElement.prototype.hide;
	HSolidElement.prototype.show = SVGBaseElement.prototype.show;
	HSolidElement.prototype.renderFrame = IImageElement.prototype.renderFrame;
	HSolidElement.prototype.destroy = IImageElement.prototype.destroy;
	function HCompElement(data,parentContainer,globalData,comp, placeholder){
	    this._parent.constructor.call(this,data,parentContainer,globalData,comp, placeholder);
	    this.layers = data.layers;
	    this.supports3d = true;
	    this.completeLayers = false;
	    this.pendingElements = [];
	    this.elements = Array.apply(null,{length:this.layers.length});
	    if(this.data.tm){
	        this.tm = PropertyFactory.getProp(this,this.data.tm,0,globalData.frameRate,this.dynamicProperties);
	    }
	    if(this.data.hasMask) {
	        this.supports3d = false;
	    }
	    if(this.data.xt){
	        this.layerElement = document.createElement('div');
	    }
	    this.buildAllItems();
	
	}
	createElement(HBaseElement, HCompElement);
	
	HCompElement.prototype.createElements = function(){
	    var divElement = document.createElement('div');
	    styleDiv(divElement);
	    if(this.data.ln){
	        divElement.setAttribute('id',this.data.ln);
	    }
	    divElement.style.clip = 'rect(0px, '+this.data.w+'px, '+this.data.h+'px, 0px)';
	    if(this.data.hasMask){
	        var compSvg = createNS('svg');
	        styleDiv(compSvg);
	        compSvg.setAttribute('width',this.data.w);
	        compSvg.setAttribute('height',this.data.h);
	        var g = createNS('g');
	        compSvg.appendChild(g);
	        divElement.appendChild(compSvg);
	        this.maskedElement = g;
	        this.baseElement = divElement;
	        this.layerElement = g;
	        this.transformedElement = divElement;
	    }else{
	        this.layerElement = divElement;
	        this.baseElement = this.layerElement;
	        this.transformedElement = divElement;
	    }
	    //this.appendNodeToParent(this.layerElement);
	    this.checkParenting();
	};
	
	HCompElement.prototype.hide = ICompElement.prototype.hide;
	HCompElement.prototype.prepareFrame = ICompElement.prototype.prepareFrame;
	HCompElement.prototype.setElements = ICompElement.prototype.setElements;
	HCompElement.prototype.getElements = ICompElement.prototype.getElements;
	HCompElement.prototype.destroy = ICompElement.prototype.destroy;
	
	HCompElement.prototype.renderFrame = function(parentMatrix){
	    var renderParent = this._parent.renderFrame.call(this,parentMatrix);
	    var i,len = this.layers.length;
	    if(renderParent===false){
	        this.hide();
	        return;
	    }
	
	    this.hidden = false;
	
	    for( i = 0; i < len; i+=1 ){
	        if(this.completeLayers || this.elements[i]){
	            this.elements[i].renderFrame();
	        }
	    }
	    if(this.firstFrame){
	        this.firstFrame = false;
	    }
	};
	
	HCompElement.prototype.checkLayers = BaseRenderer.prototype.checkLayers;
	HCompElement.prototype.buildItem = HybridRenderer.prototype.buildItem;
	HCompElement.prototype.checkPendingElements = HybridRenderer.prototype.checkPendingElements;
	HCompElement.prototype.addPendingElement = HybridRenderer.prototype.addPendingElement;
	HCompElement.prototype.buildAllItems = BaseRenderer.prototype.buildAllItems;
	HCompElement.prototype.createItem = HybridRenderer.prototype.createItem;
	HCompElement.prototype.buildElementParenting = HybridRenderer.prototype.buildElementParenting;
	HCompElement.prototype.createImage = HybridRenderer.prototype.createImage;
	HCompElement.prototype.createComp = HybridRenderer.prototype.createComp;
	HCompElement.prototype.createSolid = HybridRenderer.prototype.createSolid;
	HCompElement.prototype.createShape = HybridRenderer.prototype.createShape;
	HCompElement.prototype.createText = HybridRenderer.prototype.createText;
	HCompElement.prototype.createBase = HybridRenderer.prototype.createBase;
	HCompElement.prototype.appendElementInPos = HybridRenderer.prototype.appendElementInPos;
	function HShapeElement(data,parentContainer,globalData,comp, placeholder){
	    this.shapes = [];
	    this.shapesData = data.shapes;
	    this.stylesList = [];
	    this.itemsData = [];
	    this.prevViewData = [];
	    this.shapeModifiers = [];
	    this.processedElements = [];
	    this._parent.constructor.call(this,data,parentContainer,globalData,comp, placeholder);
	    this.currentBBox = {
	        x:999999,
	        y: -999999,
	        h: 0,
	        w: 0
	    };
	}
	createElement(HBaseElement, HShapeElement);
	var parent = HShapeElement.prototype._parent;
	extendPrototype(IShapeElement, HShapeElement);
	HShapeElement.prototype._parent = parent;
	HShapeElement.prototype._renderShapeFrame = HShapeElement.prototype.renderFrame;
	
	HShapeElement.prototype.createElements = function(){
	    var parent = document.createElement('div');
	    styleDiv(parent);
	    var cont = createNS('svg');
	    styleDiv(cont);
	    var size = this.comp.data ? this.comp.data : this.globalData.compSize;
	    cont.setAttribute('width',size.w);
	    cont.setAttribute('height',size.h);
	    if(this.data.hasMask){
	        var g = createNS('g');
	        parent.appendChild(cont);
	        cont.appendChild(g);
	        this.maskedElement = g;
	        this.layerElement = g;
	        this.shapesContainer = g;
	    }else{
	        parent.appendChild(cont);
	        this.layerElement = cont;
	        this.shapesContainer = createNS('g');
	        this.layerElement.appendChild(this.shapesContainer);
	    }
	    if(!this.data.hd){
	        //this.parentContainer.appendChild(parent);
	        this.baseElement = parent;
	    }
	    this.innerElem = parent;
	    if(this.data.ln){
	        this.innerElem.setAttribute('id',this.data.ln);
	    }
	
	    this.searchShapes(this.shapesData,this.itemsData,this.prevViewData,this.layerElement,this.dynamicProperties,0, [], true);
	    this.buildExpressionInterface();
	    this.layerElement = parent;
	    this.transformedElement = parent;
	    this.shapeCont = cont;
	    if(this.data.bm !== 0){
	        this.setBlendMode();
	    }
	    this.checkParenting();
	};
	
	HShapeElement.prototype.renderFrame = function(parentMatrix){
	    var firstFrame = this.firstFrame;
	    this._renderShapeFrame();
	
	    if(this.isVisible && (this.elemMdf || firstFrame)){
	        var boundingBox = this.shapeCont.getBBox();
	        var changed = false;
	        if(this.currentBBox.w !== boundingBox.width){
	            this.currentBBox.w = boundingBox.width;
	            this.shapeCont.setAttribute('width',boundingBox.width);
	            changed = true;
	        }
	        if(this.currentBBox.h !== boundingBox.height){
	            this.currentBBox.h = boundingBox.height;
	            this.shapeCont.setAttribute('height',boundingBox.height);
	            changed = true;
	        }
	        if(changed  || this.currentBBox.x !== boundingBox.x  || this.currentBBox.y !== boundingBox.y){
	            this.currentBBox.w = boundingBox.width;
	            this.currentBBox.h = boundingBox.height;
	            this.currentBBox.x = boundingBox.x;
	            this.currentBBox.y = boundingBox.y;
	
	            this.shapeCont.setAttribute('viewBox',this.currentBBox.x+' '+this.currentBBox.y+' '+this.currentBBox.w+' '+this.currentBBox.h);
	            this.shapeCont.style.transform = this.shapeCont.style.webkitTransform = 'translate(' + this.currentBBox.x + 'px,' + this.currentBBox.y + 'px)';
	        }
	    }
	
	};
	function HTextElement(data,parentContainer,globalData,comp, placeholder){
	    this.textSpans = [];
	    this.textPaths = [];
	    this.currentBBox = {
	        x:999999,
	        y: -999999,
	        h: 0,
	        w: 0
	    }
	    this.renderType = 'svg';
	    this.isMasked = false;
	    this._parent.constructor.call(this,data,parentContainer,globalData,comp, placeholder);
	
	}
	createElement(HBaseElement, HTextElement);
	
	extendPrototype(ITextElement, HTextElement);
	
	HTextElement.prototype.createElements = function(){
	    this.isMasked = this.checkMasks();
	    var parent = document.createElement('div');
	    styleDiv(parent);
	    this.layerElement = parent;
	    this.transformedElement = parent;
	    if(this.isMasked){
	        this.renderType = 'svg';
	        var cont = createNS('svg');
	        styleDiv(cont);
	        this.cont = cont;
	        this.compW = this.comp.data.w;
	        this.compH = this.comp.data.h;
	        cont.setAttribute('width',this.compW);
	        cont.setAttribute('height',this.compH);
	        var g = createNS('g');
	        cont.appendChild(g);
	        parent.appendChild(cont);
	        this.maskedElement = g;
	        this.innerElem = g;
	    } else {
	        this.renderType = 'html';
	        this.innerElem = parent;
	    }
	    this.baseElement = parent;
	
	    this.checkParenting();
	
	};
	
	HTextElement.prototype.buildNewText = function(){
	    var documentData = this.textProperty.currentData;
	    this.renderedLetters = Array.apply(null,{length:this.textProperty.currentData.l ? this.textProperty.currentData.l.length : 0});
	    var innerElemStyle = this.innerElem.style;
	    innerElemStyle.color = innerElemStyle.fill = documentData.fc ? this.buildColor(documentData.fc) : 'rgba(0,0,0,0)';
	    if(documentData.sc){
	        innerElemStyle.stroke = this.buildColor(documentData.sc);
	        innerElemStyle.strokeWidth = documentData.sw+'px';
	    }
	    var fontData = this.globalData.fontManager.getFontByName(documentData.f);
	    if(!this.globalData.fontManager.chars){
	        innerElemStyle.fontSize = documentData.s+'px';
	        innerElemStyle.lineHeight = documentData.s+'px';
	        if(fontData.fClass){
	            this.innerElem.className = fontData.fClass;
	        } else {
	            innerElemStyle.fontFamily = fontData.fFamily;
	            var fWeight = documentData.fWeight, fStyle = documentData.fStyle;
	            innerElemStyle.fontStyle = fStyle;
	            innerElemStyle.fontWeight = fWeight;
	        }
	    }
	    var i, len;
	
	    var letters = documentData.l;
	    len = letters.length;
	    var tSpan,tParent,tCont;
	    var matrixHelper = this.mHelper;
	    var shapes, shapeStr = '';
	    var cnt = 0;
	    for (i = 0;i < len ;i += 1) {
	        if(this.globalData.fontManager.chars){
	            if(!this.textPaths[cnt]){
	                tSpan = createNS('path');
	                tSpan.setAttribute('stroke-linecap', 'butt');
	                tSpan.setAttribute('stroke-linejoin','round');
	                tSpan.setAttribute('stroke-miterlimit','4');
	            } else {
	                tSpan = this.textPaths[cnt];
	            }
	            if(!this.isMasked){
	                if(this.textSpans[cnt]){
	                    tParent = this.textSpans[cnt];
	                    tCont = tParent.children[0];
	                } else {
	
	                    tParent = document.createElement('div');
	                    tCont = createNS('svg');
	                    tCont.appendChild(tSpan);
	                    styleDiv(tParent);
	                }
	            }
	        }else{
	            if(!this.isMasked){
	                if(this.textSpans[cnt]){
	                    tParent = this.textSpans[cnt];
	                    tSpan = this.textPaths[cnt];
	                } else {
	                    tParent = document.createElement('span');
	                    styleDiv(tParent);
	                    tSpan = document.createElement('span');
	                    styleDiv(tSpan);
	                    tParent.appendChild(tSpan);
	                }
	            } else {
	                tSpan = this.textPaths[cnt] ? this.textPaths[cnt] : createNS('text');
	            }
	        }
	        //tSpan.setAttribute('visibility', 'hidden');
	        if(this.globalData.fontManager.chars){
	            var charData = this.globalData.fontManager.getCharData(documentData.t.charAt(i), fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
	            var shapeData;
	            if(charData){
	                shapeData = charData.data;
	            } else {
	                shapeData = null;
	            }
	            matrixHelper.reset();
	            if(shapeData && shapeData.shapes){
	                shapes = shapeData.shapes[0].it;
	                matrixHelper.scale(documentData.s/100,documentData.s/100);
	                shapeStr = this.createPathShape(matrixHelper,shapes);
	                tSpan.setAttribute('d',shapeStr);
	            }
	            if(!this.isMasked){
	                this.innerElem.appendChild(tParent);
	                if(shapeData && shapeData.shapes){
	                    document.body.appendChild(tCont);
	
	                    var boundingBox = tCont.getBBox();
	                    tCont.setAttribute('width',boundingBox.width + 2);
	                    tCont.setAttribute('height',boundingBox.height + 2);
	                    tCont.setAttribute('viewBox',(boundingBox.x-1)+' '+ (boundingBox.y-1)+' '+ (boundingBox.width+2)+' '+ (boundingBox.height+2));
	                    tCont.style.transform = tCont.style.webkitTransform = 'translate(' + (boundingBox.x-1) + 'px,' + (boundingBox.y-1) + 'px)';
	
	                    letters[i].yOffset = boundingBox.y-1;
	                    tParent.appendChild(tCont);
	
	                } else{
	                    tCont.setAttribute('width',1);
	                    tCont.setAttribute('height',1);
	                }
	            }else{
	                this.innerElem.appendChild(tSpan);
	            }
	        }else{
	            tSpan.textContent = letters[i].val;
	            tSpan.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space","preserve");
	            if(!this.isMasked){
	                this.innerElem.appendChild(tParent);
	                //
	                tSpan.style.transform = tSpan.style.webkitTransform = 'translate3d(0,'+ -documentData.s/1.2+'px,0)';
	            } else {
	                this.innerElem.appendChild(tSpan);
	            }
	        }
	        //
	        if(!this.isMasked){
	            this.textSpans[cnt] = tParent;
	        }else{
	            this.textSpans[cnt] = tSpan;
	        }
	        this.textSpans[cnt].style.display = 'block';
	        this.textPaths[cnt] = tSpan;
	        cnt += 1;
	    }
	    while(cnt < this.textSpans.length){
	        this.textSpans[cnt].style.display = 'none';
	        cnt += 1;
	    }
	}
	
	HTextElement.prototype.hide = SVGTextElement.prototype.hide;
	
	HTextElement.prototype.renderFrame = function(parentMatrix){
	
	    var renderParent = this._parent.renderFrame.call(this,parentMatrix);
	    if(renderParent===false){
	        this.hide();
	        return;
	    }
	    if(this.hidden){
	        this.hidden = false;
	        this.innerElem.style.display = 'block';
	        this.layerElement.style.display = 'block';
	    }
	
	    if(this.data.singleShape){
	        if(!this.firstFrame && !this.lettersChangedFlag){
	            return;
	        } else {
	            // Todo Benchmark if using this is better than getBBox
	             if(this.isMasked && this.finalTransform.matMdf){
	                 this.cont.setAttribute('viewBox',-this.finalTransform.mProp.p.v[0]+' '+ -this.finalTransform.mProp.p.v[1]+' '+this.compW+' '+this.compH);
	                this.cont.style.transform = this.cont.style.webkitTransform = 'translate(' + -this.finalTransform.mProp.p.v[0] + 'px,' + -this.finalTransform.mProp.p.v[1] + 'px)';
	             }
	        }
	    }
	
	    this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
	    if(!this.lettersChangedFlag && !this.textAnimator.lettersChangedFlag){
	        return;
	    }
	    var  i,len, count = 0;
	    var renderedLetters = this.textAnimator.renderedLetters;
	
	    var letters = this.textProperty.currentData.l;
	
	    len = letters.length;
	    var renderedLetter, textSpan, textPath;
	    for(i=0;i<len;i+=1){
	        if(letters[i].n){
	            count += 1;
	            continue;
	        }
	        textSpan = this.textSpans[i];
	        textPath = this.textPaths[i];
	        renderedLetter = renderedLetters[count];
	        count += 1;
	        if(!this.isMasked){
	            textSpan.style.transform = textSpan.style.webkitTransform = renderedLetter.m;
	        }else{
	            textSpan.setAttribute('transform',renderedLetter.m);
	        }
	        ////textSpan.setAttribute('opacity',renderedLetter.o);
	        textSpan.style.opacity = renderedLetter.o;
	        if(renderedLetter.sw){
	            textPath.setAttribute('stroke-width',renderedLetter.sw);
	        }
	        if(renderedLetter.sc){
	            textPath.setAttribute('stroke',renderedLetter.sc);
	        }
	        if(renderedLetter.fc){
	            textPath.setAttribute('fill',renderedLetter.fc);
	            textPath.style.color = renderedLetter.fc;
	        }
	    }
	    if(this.isVisible && (this.elemMdf || this.firstFrame)){
	        if(this.innerElem.getBBox){
	            var boundingBox = this.innerElem.getBBox();
	
	            if(this.currentBBox.w !== boundingBox.width){
	                this.currentBBox.w = boundingBox.width;
	                this.cont.setAttribute('width',boundingBox.width);
	            }
	            if(this.currentBBox.h !== boundingBox.height){
	                this.currentBBox.h = boundingBox.height;
	                this.cont.setAttribute('height',boundingBox.height);
	            }
	
	            var margin = 1;
	            if(this.currentBBox.w !== (boundingBox.width + margin*2) || this.currentBBox.h !== (boundingBox.height + margin*2)  || this.currentBBox.x !== (boundingBox.x - margin)  || this.currentBBox.y !== (boundingBox.y - margin)){
	                this.currentBBox.w = boundingBox.width + margin*2;
	                this.currentBBox.h = boundingBox.height + margin*2;
	                this.currentBBox.x = boundingBox.x - margin;
	                this.currentBBox.y = boundingBox.y - margin;
	
	                this.cont.setAttribute('viewBox',this.currentBBox.x+' '+this.currentBBox.y+' '+this.currentBBox.w+' '+this.currentBBox.h);
	                this.cont.style.transform = this.cont.style.webkitTransform = 'translate(' + this.currentBBox.x + 'px,' + this.currentBBox.y + 'px)';
	            }
	        }
	    }
	    if(this.firstFrame){
	        this.firstFrame = false;
	    }
	}
	function HImageElement(data,parentContainer,globalData,comp, placeholder){
	    this.assetData = globalData.getAssetData(data.refId);
	    this._parent.constructor.call(this,data,parentContainer,globalData,comp, placeholder);
	}
	createElement(HBaseElement, HImageElement);
	
	HImageElement.prototype.createElements = function(){
	
	    var assetPath = this.globalData.getAssetsPath(this.assetData);
	    var img = new Image();
	
	    if(this.data.hasMask){
	        var parent = document.createElement('div');
	        styleDiv(parent);
	        var cont = createNS('svg');
	        styleDiv(cont);
	        cont.setAttribute('width',this.assetData.w);
	        cont.setAttribute('height',this.assetData.h);
	        parent.appendChild(cont);
	        this.imageElem = createNS('image');
	        this.imageElem.setAttribute('width',this.assetData.w+"px");
	        this.imageElem.setAttribute('height',this.assetData.h+"px");
	        this.imageElem.setAttributeNS('http://www.w3.org/1999/xlink','href',assetPath);
	        cont.appendChild(this.imageElem);
	        this.layerElement = parent;
	        this.transformedElement = parent;
	        this.baseElement = parent;
	        this.innerElem = parent;
	        this.maskedElement = this.imageElem;
	    } else {
	        styleDiv(img);
	        this.layerElement = img;
	        this.baseElement = img;
	        this.innerElem = img;
	        this.transformedElement = img;
	    }
	    img.src = assetPath;
	    if(this.data.ln){
	        this.innerElem.setAttribute('id',this.data.ln);
	    }
	    this.checkParenting();
	};
	
	HImageElement.prototype.show = HSolidElement.prototype.show;
	HImageElement.prototype.hide = HSolidElement.prototype.hide;
	HImageElement.prototype.renderFrame = HSolidElement.prototype.renderFrame;
	HImageElement.prototype.destroy = HSolidElement.prototype.destroy;
	function HCameraElement(data,parentContainer,globalData,comp, placeholder){
	    this._parent.constructor.call(this,data,parentContainer,globalData,comp, placeholder);
	    var getProp = PropertyFactory.getProp;
	    this.pe = getProp(this,data.pe,0,0,this.dynamicProperties);
	    if(data.ks.p.s){
	        this.px = getProp(this,data.ks.p.x,1,0,this.dynamicProperties);
	        this.py = getProp(this,data.ks.p.y,1,0,this.dynamicProperties);
	        this.pz = getProp(this,data.ks.p.z,1,0,this.dynamicProperties);
	    }else{
	        this.p = getProp(this,data.ks.p,1,0,this.dynamicProperties);
	    }
	    if(data.ks.a){
	        this.a = getProp(this,data.ks.a,1,0,this.dynamicProperties);
	    }
	    if(data.ks.or.k.length && data.ks.or.k[0].to){
	        var i,len = data.ks.or.k.length;
	        for(i=0;i<len;i+=1){
	            data.ks.or.k[i].to = null;
	            data.ks.or.k[i].ti = null;
	        }
	    }
	    this.or = getProp(this,data.ks.or,1,degToRads,this.dynamicProperties);
	    this.or.sh = true;
	    this.rx = getProp(this,data.ks.rx,0,degToRads,this.dynamicProperties);
	    this.ry = getProp(this,data.ks.ry,0,degToRads,this.dynamicProperties);
	    this.rz = getProp(this,data.ks.rz,0,degToRads,this.dynamicProperties);
	    this.mat = new Matrix();
	}
	createElement(HBaseElement, HCameraElement);
	
	HCameraElement.prototype.setup = function() {
	    var i, len = this.comp.threeDElements.length, comp;
	    for(i=0;i<len;i+=1){
	        //[perspectiveElem,container]
	        comp = this.comp.threeDElements[i];
	        comp.perspectiveElem.style.perspective = comp.perspectiveElem.style.webkitPerspective = this.pe.v+'px';
	        comp.container.style.transformOrigin = comp.container.style.mozTransformOrigin = comp.container.style.webkitTransformOrigin = "0px 0px 0px";
	        comp.perspectiveElem.style.transform = comp.perspectiveElem.style.webkitTransform = 'matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)';
	    }
	};
	
	HCameraElement.prototype.createElements = function(){
	};
	
	HCameraElement.prototype.hide = function(){
	};
	
	HCameraElement.prototype.renderFrame = function(){
	    var mdf = this.firstFrame;
	    var i, len;
	    if(this.hierarchy){
	        len = this.hierarchy.length;
	        for(i=0;i<len;i+=1){
	            mdf = this.hierarchy[i].finalTransform.mProp.mdf ? true : mdf;
	        }
	    }
	    if(mdf || (this.p && this.p.mdf) || (this.px && (this.px.mdf || this.py.mdf || this.pz.mdf)) || this.rx.mdf || this.ry.mdf || this.rz.mdf || this.or.mdf || (this.a && this.a.mdf)) {
	        this.mat.reset();
	
	        if(this.p){
	            this.mat.translate(-this.p.v[0],-this.p.v[1],this.p.v[2]);
	        }else{
	            this.mat.translate(-this.px.v,-this.py.v,this.pz.v);
	        }
	        if(this.a){
	            var diffVector = [this.p.v[0]-this.a.v[0],this.p.v[1]-this.a.v[1],this.p.v[2]-this.a.v[2]];
	            var mag = Math.sqrt(Math.pow(diffVector[0],2)+Math.pow(diffVector[1],2)+Math.pow(diffVector[2],2));
	            //var lookDir = getNormalizedPoint(getDiffVector(this.a.v,this.p.v));
	            var lookDir = [diffVector[0]/mag,diffVector[1]/mag,diffVector[2]/mag];
	            var lookLengthOnXZ = Math.sqrt( lookDir[2]*lookDir[2] + lookDir[0]*lookDir[0] );
	            var m_rotationX = (Math.atan2( lookDir[1], lookLengthOnXZ ));
	            var m_rotationY = (Math.atan2( lookDir[0], -lookDir[2]));
	            this.mat.rotateY(m_rotationY).rotateX(-m_rotationX);
	
	        }
	        this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v);
	        this.mat.rotateX(-this.or.v[0]).rotateY(-this.or.v[1]).rotateZ(this.or.v[2]);
	        this.mat.translate(this.globalData.compSize.w/2,this.globalData.compSize.h/2,0);
	        this.mat.translate(0,0,this.pe.v);
	        if(this.hierarchy){
	            var mat;
	            len = this.hierarchy.length;
	            for(i=0;i<len;i+=1){
	                mat = this.hierarchy[i].finalTransform.mProp.iv.props;
	                this.mat.transform(mat[0],mat[1],mat[2],mat[3],mat[4],mat[5],mat[6],mat[7],mat[8],mat[9],mat[10],mat[11],-mat[12],-mat[13],mat[14],mat[15]);
	            }
	        }
	        len = this.comp.threeDElements.length;
	        var comp;
	        for(i=0;i<len;i+=1){
	            comp = this.comp.threeDElements[i];
	            comp.container.style.transform = comp.container.style.webkitTransform = this.mat.toCSS();
	        }
	    }
	    this.firstFrame = false;
	};
	
	HCameraElement.prototype.destroy = function(){
	};
	var Expressions = (function(){
	    var ob = {};
	    ob.initExpressions = initExpressions;
	
	
	    function initExpressions(animation){
	        animation.renderer.compInterface = CompExpressionInterface(animation.renderer);
	        animation.renderer.globalData.projectInterface.registerComposition(animation.renderer);
	    }
	   return ob;
	}());
	
	expressionsPlugin = Expressions;
	
	(function addPropertyDecorator() {
	
	    function getStaticValueAtTime() {
	        return this.pv;
	    }
	
	    function loopOut(type,duration,durationFlag){
	        if(!this.k || !this.keyframes){
	            return this.pv;
	        }
	        type = type.toLowerCase();
	        var currentFrame = this.comp.renderedFrame;
	        var keyframes = this.keyframes;
	        var lastKeyFrame = keyframes[keyframes.length - 1].t;
	        if(currentFrame<=lastKeyFrame){
	            return this.pv;
	        }else{
	            var cycleDuration, firstKeyFrame;
	            if(!durationFlag){
	                if(!duration || duration > keyframes.length - 1){
	                    duration = keyframes.length - 1;
	                }
	                firstKeyFrame = keyframes[keyframes.length - 1 - duration].t;
	                cycleDuration = lastKeyFrame - firstKeyFrame;
	            } else {
	                if(!duration){
	                    cycleDuration = Math.max(0,lastKeyFrame - this.elem.data.ip);
	                } else {
	                    cycleDuration = Math.abs(lastKeyFrame - elem.comp.globalData.frameRate*duration);
	                }
	                firstKeyFrame = lastKeyFrame - cycleDuration;
	            }
	            var i, len, ret;
	            if(type === 'pingpong') {
	                var iterations = Math.floor((currentFrame - firstKeyFrame)/cycleDuration);
	                if(iterations % 2 !== 0){
	                    return this.getValueAtTime(((cycleDuration - (currentFrame - firstKeyFrame) % cycleDuration +  firstKeyFrame)) / this.comp.globalData.frameRate, 0);
	                }
	            } else if(type === 'offset'){
	                var initV = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
	                var endV = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
	                var current = this.getValueAtTime(((currentFrame - firstKeyFrame) % cycleDuration +  firstKeyFrame) / this.comp.globalData.frameRate, 0);
	                var repeats = Math.floor((currentFrame - firstKeyFrame)/cycleDuration);
	                if(this.pv.length){
	                    ret = new Array(initV.length);
	                    len = ret.length;
	                    for(i=0;i<len;i+=1){
	                        ret[i] = (endV[i]-initV[i])*repeats + current[i];
	                    }
	                    return ret;
	                }
	                return (endV-initV)*repeats + current;
	            } else if(type === 'continue'){
	                var lastValue = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
	                var nextLastValue = this.getValueAtTime((lastKeyFrame - 0.001) / this.comp.globalData.frameRate, 0);
	                if(this.pv.length){
	                    ret = new Array(lastValue.length);
	                    len = ret.length;
	                    for(i=0;i<len;i+=1){
	                        ret[i] = lastValue[i] + (lastValue[i]-nextLastValue[i])*((currentFrame - lastKeyFrame)/ this.comp.globalData.frameRate)/0.0005;
	                    }
	                    return ret;
	                }
	                return lastValue + (lastValue-nextLastValue)*(((currentFrame - lastKeyFrame))/0.001);
	            }
	            return this.getValueAtTime((((currentFrame - firstKeyFrame) % cycleDuration +  firstKeyFrame)) / this.comp.globalData.frameRate, 0);
	        }
	    }
	
	    function loopIn(type,duration, durationFlag) {
	        if(!this.k){
	            return this.pv;
	        }
	        type = type.toLowerCase();
	        var currentFrame = this.comp.renderedFrame;
	        var keyframes = this.keyframes;
	        var firstKeyFrame = keyframes[0].t;
	        if(currentFrame>=firstKeyFrame){
	            return this.pv;
	        }else{
	            var cycleDuration, lastKeyFrame;
	            if(!durationFlag){
	                if(!duration || duration > keyframes.length - 1){
	                    duration = keyframes.length - 1;
	                }
	                lastKeyFrame = keyframes[duration].t;
	                cycleDuration = lastKeyFrame - firstKeyFrame;
	            } else {
	                if(!duration){
	                    cycleDuration = Math.max(0,this.elem.data.op - firstKeyFrame);
	                } else {
	                    cycleDuration = Math.abs(elem.comp.globalData.frameRate*duration);
	                }
	                lastKeyFrame = firstKeyFrame + cycleDuration;
	            }
	            var i, len, ret;
	            if(type === 'pingpong') {
	                var iterations = Math.floor((firstKeyFrame - currentFrame)/cycleDuration);
	                if(iterations % 2 === 0){
	                    return this.getValueAtTime((((firstKeyFrame - currentFrame)%cycleDuration +  firstKeyFrame)) / this.comp.globalData.frameRate, 0);
	                }
	            } else if(type === 'offset'){
	                var initV = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
	                var endV = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
	                var current = this.getValueAtTime((cycleDuration - (firstKeyFrame - currentFrame)%cycleDuration +  firstKeyFrame) / this.comp.globalData.frameRate, 0);
	                var repeats = Math.floor((firstKeyFrame - currentFrame)/cycleDuration)+1;
	                if(this.pv.length){
	                    ret = new Array(initV.length);
	                    len = ret.length;
	                    for(i=0;i<len;i+=1){
	                        ret[i] = current[i]-(endV[i]-initV[i])*repeats;
	                    }
	                    return ret;
	                }
	                return current-(endV-initV)*repeats;
	            } else if(type === 'continue'){
	                var firstValue = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
	                var nextFirstValue = this.getValueAtTime((firstKeyFrame + 0.001) / this.comp.globalData.frameRate, 0);
	                if(this.pv.length){
	                    ret = new Array(firstValue.length);
	                    len = ret.length;
	                    for(i=0;i<len;i+=1){
	                        ret[i] = firstValue[i] + (firstValue[i]-nextFirstValue[i])*(firstKeyFrame - currentFrame)/0.001;
	                    }
	                    return ret;
	                }
	                return firstValue + (firstValue-nextFirstValue)*(firstKeyFrame - currentFrame)/0.001;
	            }
	            return this.getValueAtTime(((cycleDuration - (firstKeyFrame - currentFrame) % cycleDuration +  firstKeyFrame)) / this.comp.globalData.frameRate, 0);
	        }
	    }
	
	    function getValueAtTime(frameNum) {
	        if(!this._cachingAtTime) {
	            this._cachingAtTime = {lastValue:-99999,lastIndex:0};
	        }
	        if(frameNum !== this._cachingAtTime.lastFrame) {
	            frameNum *= this.elem.globalData.frameRate;
	            frameNum -= this.offsetTime;
	            var i = this._caching.lastFrame < frameNum ? this._caching.lastIndex : 0;
	            var interpolationResult = this.interpolateValue(frameNum, i, this.pv, this._cachingAtTime);
	            this._cachingAtTime.lastIndex = interpolationResult.iterationIndex;
	            this._cachingAtTime.value = interpolationResult.value;
	            this._cachingAtTime.lastFrame = frameNum;
	        }
	        return this._cachingAtTime.value;
	
	    }
	
	    function getVelocityAtTime(frameNum) {
	        if(this.vel !== undefined){
	            return this.vel;
	        }
	        var delta = -0.01;
	        //frameNum += this.elem.data.st;
	        var v1 = this.getValueAtTime(frameNum);
	        var v2 = this.getValueAtTime(frameNum + delta);
	        var velocity;
	        if(v1.length){
	            velocity = createTypedArray('float32', v1.length);
	            var i;
	            for(i=0;i<v1.length;i+=1){
	                //removing frameRate
	                //if needed, don't add it here
	                //velocity[i] = this.elem.globalData.frameRate*((v2[i] - v1[i])/delta);
	                velocity[i] = (v2[i] - v1[i])/delta;
	            }
	        } else {
	            velocity = (v2 - v1)/delta;
	        }
	        return velocity;
	    };
	
	    function setGroupProperty(propertyGroup){
	        this.propertyGroup = propertyGroup;
	    }
	
	    function searchExpressions(elem,data,prop){
	        if(data.x){
	            prop.k = true;
	            prop.x = true;
	            if(prop.getValue) {
	                prop.getPreValue = prop.getValue;
	            }
	            prop.getValue = ExpressionManager.initiateExpression.bind(prop)(elem,data,prop);
	        }
	    }
	
	    function getTransformValueAtTime(time) {
	        //console.log('time:', time)
	    }
	
	    function getTransformStaticValueAtTime(time) {
	
	    }
	
	    var TextExpressionSelectorProp = (function(){
	
	        function getValueProxy(index,total){
	            this.textIndex = index+1;
	            this.textTotal = total;
	            this.getValue();
	            return this.v;
	        }
	
	        return function TextExpressionSelectorProp(elem,data){
	            this.pv = 1;
	            this.comp = elem.comp;
	            this.elem = elem;
	            this.mult = .01;
	            this.type = 'textSelector';
	            this.textTotal = data.totalChars;
	            this.selectorValue = 100;
	            this.lastValue = [1,1,1];
	            searchExpressions.bind(this)(elem,data,this);
	            this.getMult = getValueProxy;
	            this.getVelocityAtTime = getVelocityAtTime;
	            if(this.kf){
	                this.getValueAtTime = getValueAtTime.bind(this);
	            } else {
	                this.getValueAtTime = getStaticValueAtTime.bind(this);
	            }
	            this.setGroupProperty = setGroupProperty;
	        }
	    }());
	
	    var getTransformProperty = TransformPropertyFactory.getTransformProperty;
	    TransformPropertyFactory.getTransformProperty = function(elem, data, arr) {
	        var prop = getTransformProperty(elem, data, arr);
	        if(prop.dynamicProperties.length) {
	            prop.getValueAtTime = getTransformValueAtTime.bind(prop);
	        } else {
	            prop.getValueAtTime = getTransformStaticValueAtTime.bind(prop);
	        }
	        prop.setGroupProperty = setGroupProperty;
	        return prop;
	    }
	
	    var propertyGetProp = PropertyFactory.getProp;
	    PropertyFactory.getProp = function(elem,data,type, mult, arr){
	        var prop = propertyGetProp(elem,data,type, mult, arr);
	        //prop.getVelocityAtTime = getVelocityAtTime;
	        //prop.loopOut = loopOut;
	        //prop.loopIn = loopIn;
	        if(prop.kf){
	            prop.getValueAtTime = getValueAtTime.bind(prop);
	        } else {
	            prop.getValueAtTime = getStaticValueAtTime.bind(prop);
	        }
	        prop.setGroupProperty = setGroupProperty;
	        prop.loopOut = loopOut;
	        prop.loopIn = loopIn;
	        prop.getVelocityAtTime = getVelocityAtTime;
	        prop.numKeys = data.a === 1 ? data.k.length : 0;
	        var isAdded = prop.k;
	        prop.propertyIndex = data.ix;
	        searchExpressions(elem,data,prop);
	        if(!isAdded && prop.x){
	            arr.push(prop);
	        }
	
	        return prop;
	    }
	
	    function getShapeValueAtTime(frameNum) {
	        if (!this._shapeValueAtTime) {
	            this._lastIndexAtTime = 0;
	            this._lastTimeAtTime = -999999;
	            this._shapeValueAtTime = shape_pool.clone(this.pv);
	        }
	        if(frameNum !== this._lastTimeAtTime) {
	            this._lastTimeAtTime = frameNum;
	            frameNum *= this.elem.globalData.frameRate;
	            var interpolationResult = this.interpolateShape(frameNum, this._lastIndexAtTime, this._shapeValueAtTime, false);
	            this._lastIndexAtTime = interpolationResult.iterationIndex;
	        }
	        return this._shapeValueAtTime;
	    }
	
	    var ShapePropertyConstructorFunction = ShapePropertyFactory.getConstructorFunction();
	    var KeyframedShapePropertyConstructorFunction = ShapePropertyFactory.getKeyframedConstructorFunction();
	
	    ShapePropertyConstructorFunction.prototype.vertices = function(prop, time){
	        var shapePath = this.v;
	        if(time !== undefined) {
	            shapePath = this.getValueAtTime(time, 0);
	        }
	        var i, len = shapePath._length;
	        var vertices = shapePath[prop];
	        var points = shapePath.v;
	        var arr = Array.apply(null,{length:len})
	        for(i = 0; i < len; i += 1) {
	            if(prop === 'i' || prop === 'o') {
	                arr[i] = [vertices[i][0] - points[i][0], vertices[i][1] - points[i][1]]
	            } else {
	                arr[i] = [vertices[i][0], vertices[i][1]]
	            }
	            
	        }
	        return arr;
	    }
	
	    ShapePropertyConstructorFunction.prototype.points = function(time){
	        return this.vertices('v', time);
	    }
	
	    ShapePropertyConstructorFunction.prototype.inTangents = function(time){
	        return this.vertices('i', time);
	    }
	
	    ShapePropertyConstructorFunction.prototype.outTangents = function(time){
	        return this.vertices('o', time);
	    }
	
	    ShapePropertyConstructorFunction.prototype.isClosed = function(){
	        return this.v.c;
	    }
	
	    ShapePropertyConstructorFunction.prototype.pointOnPath = function(perc, time){
	        var shapePath = this.v;
	        if(time !== undefined) {
	            shapePath = this.getValueAtTime(time, 0);
	        }
	        if(!this._segmentsLength) {
	            this._segmentsLength = bez.getSegmentsLength(shapePath);
	        }
	
	        var segmentsLength = this._segmentsLength;
	        var lengths = segmentsLength.lengths;
	        var lengthPos = segmentsLength.totalLength * perc;
	        var i = 0, len = lengths.length;
	        var j = 0, jLen;
	        var accumulatedLength = 0;
	        var segments;
	        while(i < len) {
	            if(accumulatedLength + lengths[i].addedLength > lengthPos) {
	                segments = lengths[i].segments;
	                var initIndex = i;
	                var endIndex = (shapePath.c && i === len - 1) ? 0 : i + 1;
	                var segmentPerc = (lengthPos - accumulatedLength)/lengths[i].addedLength;
	                var pt = bez.getPointInSegment(shapePath.v[initIndex], shapePath.v[endIndex], shapePath.o[initIndex], shapePath.i[endIndex], segmentPerc, lengths[i])
	                break;
	            } else {
	                accumulatedLength += lengths[i].addedLength;
	            }
	            i += 1;
	        }
	        if(!pt){
	            pt = shapePath.c ? [shapePath.v[0][0],shapePath.v[0][1]]:[shapePath.v[shapePath._length-1][0],shapePath.v[shapePath._length-1][1]]
	        }
	        return pt;
	    }
	
	    ShapePropertyConstructorFunction.prototype.vectorOnPath = function(perc, time, vectorType){
	        //perc doesn't use triple equality because can be a Number object, not a primitive.
	        perc = perc == 1 ? this.v.c ? 0 : 0.999 : perc;
	        var pt1 = this.pointOnPath(perc, time);
	        var pt2 = this.pointOnPath(perc + 0.001, time);
	        var xLength = pt2[0] - pt1[0];
	        var yLength = pt2[1] - pt1[1];
	        var magnitude = Math.sqrt(Math.pow(xLength,2) + Math.pow(yLength,2));
	        var unitVector = vectorType === 'tangent' ? [xLength/magnitude, yLength/magnitude] : [-yLength/magnitude, xLength/magnitude];
	        return unitVector;
	    }
	
	    ShapePropertyConstructorFunction.prototype.tangentOnPath = function(perc, time){
	        return this.vectorOnPath(perc, time, 'tangent');
	    }
	
	    ShapePropertyConstructorFunction.prototype.normalOnPath = function(perc, time){
	        return this.vectorOnPath(perc, time, 'normal');
	    }
	
	    ShapePropertyConstructorFunction.prototype.setGroupProperty = setGroupProperty;
	    ShapePropertyConstructorFunction.prototype.getValueAtTime = getStaticValueAtTime;
	
	    KeyframedShapePropertyConstructorFunction.prototype.vertices = ShapePropertyConstructorFunction.prototype.vertices;
	    KeyframedShapePropertyConstructorFunction.prototype.points = ShapePropertyConstructorFunction.prototype.points;
	    KeyframedShapePropertyConstructorFunction.prototype.inTangents = ShapePropertyConstructorFunction.prototype.inTangents;
	    KeyframedShapePropertyConstructorFunction.prototype.outTangents = ShapePropertyConstructorFunction.prototype.outTangents;
	    KeyframedShapePropertyConstructorFunction.prototype.isClosed = ShapePropertyConstructorFunction.prototype.isClosed;
	    KeyframedShapePropertyConstructorFunction.prototype.pointOnPath = ShapePropertyConstructorFunction.prototype.pointOnPath;
	    KeyframedShapePropertyConstructorFunction.prototype.vectorOnPath = ShapePropertyConstructorFunction.prototype.vectorOnPath;
	    KeyframedShapePropertyConstructorFunction.prototype.tangentOnPath = ShapePropertyConstructorFunction.prototype.tangentOnPath;
	    KeyframedShapePropertyConstructorFunction.prototype.normalOnPath = ShapePropertyConstructorFunction.prototype.normalOnPath;
	    KeyframedShapePropertyConstructorFunction.prototype.setGroupProperty = ShapePropertyConstructorFunction.prototype.setGroupProperty;
	    KeyframedShapePropertyConstructorFunction.prototype.getValueAtTime = getShapeValueAtTime;
	
	    var propertyGetShapeProp = ShapePropertyFactory.getShapeProp;
	    ShapePropertyFactory.getShapeProp = function(elem,data,type, arr, trims){
	        var prop = propertyGetShapeProp(elem,data,type, arr, trims);
	        var isAdded = prop.k;
	        prop.propertyIndex = data.ix;
	        if(type === 3){
	            searchExpressions(elem,data.pt,prop);
	        } else if(type === 4){
	            searchExpressions(elem,data.ks,prop);
	        }
	        if(!isAdded && prop.x){
	            arr.push(prop);
	        }
	        return prop;
	    }
	
	    var propertyGetTextProp = TextSelectorProp.getTextSelectorProp;
	    TextSelectorProp.getTextSelectorProp = function(elem, data,arr){
	        if(data.t === 1){
	            return new TextExpressionSelectorProp(elem, data,arr);
	        } else {
	            return propertyGetTextProp(elem,data,arr);
	        }
	    }
	}());
	(function addTextPropertyDecorator() {
	
	    function searchExpressions(){
	        if(this.data.d.x){
	            this.comp = this.elem.comp;
	            if(this.getValue) {
	                this.getPreValue = this.getValue;
	            }
	            this.calculateExpression = ExpressionManager.initiateExpression.bind(this)(this.elem,this.data.d,this);
	            this.getValue = this.getExpressionValue;
	            return true;
	        }
	        return false;
	    }
	
	    TextProperty.prototype.searchProperty = function(){
	        this.kf = this.searchExpressions() || this.data.d.k.length > 1;
	        return this.kf;
	    }
	
	    TextProperty.prototype.getExpressionValue = function(num){
	        this.calculateExpression();
	        if(this.mdf) {
	            this.currentData.t = this.v.toString();
	            this.completeTextData(this.currentData);
	        }
	    }
	
	    TextProperty.prototype.searchExpressions = searchExpressions;
	    
	}());
	var ExpressionManager = (function(){
	    var ob = {};
	    var Math = BMMath;
	    var window = null;
	    var document = null;
	
	    function duplicatePropertyValue(value, mult){
	        mult = mult || 1;
	
	        if(typeof value === 'number'  || value instanceof Number){
	            return value*mult;
	        }else if(value.i){
	            return JSON.parse(JSON.stringify(value));
	        }else{
	            var arr = createTypedArray('int16', value.length);
	            var i, len = value.length;
	            for(i=0;i<len;i+=1){
	                arr[i]=value[i]*mult;
	            }
	            return arr;
	        }
	    }
	
	    function isTypeOfArray(arr) {
	        return arr.constructor === Array || arr.constructor === Float32Array;
	    }
	
	    function shapesEqual(shape1, shape2) {
	        if(shape1._length !== shape2._length || shape1.c !== shape2.c){
	            return false;
	        }
	        var i, len = shape1._length;
	        for(i = 0; i < len; i += 1) {
	            if(shape1.v[i][0] !== shape2.v[i][0] || shape1.v[i][1] !== shape2.v[i][1]
	                || shape1.o[i][0] !== shape2.o[i][0] || shape1.o[i][1] !== shape2.o[i][1]
	                || shape1.i[i][0] !== shape2.i[i][0] || shape1.i[i][1] !== shape2.i[i][1]){
	                return false;
	            }
	        }
	        return true;
	    }
	
	    function $bm_neg(a){
	        var tOfA = typeof a;
	        if(tOfA === 'number' || tOfA === 'boolean'  || a instanceof Number ){
	            return -a;
	        }
	        if(isTypeOfArray(a)){
	            var i, lenA = a.length;
	            var retArr = [];
	            for(i=0;i<lenA;i+=1){
	                retArr[i] = -a[i];
	            }
	            return retArr;
	        }
	    }
	
	    function sum(a,b) {
	        var tOfA = typeof a;
	        var tOfB = typeof b;
	        if(tOfA === 'string' || tOfB === 'string'){
	            return a + b;
	        }
	        if((tOfA === 'number' || tOfA === 'boolean' || tOfA === 'string' || a instanceof Number) && (tOfB === 'number' || tOfB === 'boolean' || tOfB === 'string'  || b instanceof Number)) {
	            return a + b;
	        }
	        if(isTypeOfArray(a) && (tOfB === 'number' || tOfB === 'boolean' || tOfB === 'string' || b instanceof Number )){
	            a[0] = a[0] + b;
	            return a;
	        }
	        if((tOfA === 'number' || tOfA === 'boolean' || tOfA === 'string' || a instanceof Number ) && isTypeOfArray(b)){
	            b[0] = a + b[0];
	            return b;
	        }
	        if(isTypeOfArray(a) && isTypeOfArray(b)){
	            
	            var i = 0, lenA = a.length, lenB = b.length;
	            var retArr = [];
	            while(i<lenA || i < lenB){
	                if((typeof a[i] === 'number' || a[i] instanceof Number) && (typeof b[i] === 'number' || b[i] instanceof Number)){
	                    retArr[i] = a[i] + b[i];
	                }else{
	                    retArr[i] = b[i] == undefined ? a[i] : a[i] || b[i];
	                }
	                i += 1;
	            }
	            return retArr;
	        }
	        return 0;
	    }
	    var add = sum;
	
	    function sub(a,b) {
	        var tOfA = typeof a;
	        var tOfB = typeof b;
	        if((tOfA === 'number' || tOfA === 'boolean' || tOfA === 'string' || a instanceof Number ) && (tOfB === 'number' || tOfB === 'boolean' || tOfB === 'string' || b instanceof Number )) {
	            if(tOfA === 'string') {
	                a = parseInt(a);
	            }
	            if(tOfB === 'string') {
	                b = parseInt(b);
	            }
	            return a - b;
	        }
	        if( isTypeOfArray(a) && (tOfB === 'number' || tOfB === 'boolean' || tOfB === 'string' || b instanceof Number )){
	            a[0] = a[0] - b;
	            return a;
	        }
	        if((tOfA === 'number' || tOfA === 'boolean' || tOfA === 'string' || a instanceof Number ) &&  isTypeOfArray(b)){
	            b[0] = a - b[0];
	            return b;
	        }
	        if(isTypeOfArray(a) && isTypeOfArray(b)){
	            var i = 0, lenA = a.length, lenB = b.length;
	            var retArr = [];
	            while(i<lenA || i < lenB){
	                if((typeof a[i] === 'number' || a[i] instanceof Number) && typeof (typeof b[i] === 'number' || b[i] instanceof Number)){
	                    retArr[i] = a[i] - b[i];
	                }else{
	                    retArr[i] = b[i] == undefined ? a[i] : a[i] || b[i];
	                }
	                i += 1;
	            }
	            return retArr;
	        }
	        return 0;
	    }
	
	    function mul(a,b) {
	        var tOfA = typeof a;
	        var tOfB = typeof b;
	        var arr;
	        if((tOfA === 'number' || tOfA === 'boolean' || tOfA === 'string' || a instanceof Number ) && (tOfB === 'number' || tOfB === 'boolean' || tOfB === 'string' || b instanceof Number )) {
	            return a * b;
	        }
	
	        var i, len;
	        if(isTypeOfArray(a) && (tOfB === 'number' || tOfB === 'boolean' || tOfB === 'string' || b instanceof Number )){
	            len = a.length;
	            arr = createTypedArray('float32', len);
	            for(i=0;i<len;i+=1){
	                arr[i] = a[i] * b;
	            }
	            return arr;
	        }
	        if((tOfA === 'number' || tOfA === 'boolean' || tOfA === 'string' || a instanceof Number ) && isTypeOfArray(b)){
	            len = b.length;
	            arr = createTypedArray('float32', len);
	            for(i=0;i<len;i+=1){
	                arr[i] = a * b[i];
	            }
	            return arr;
	        }
	        return 0;
	    }
	
	    function div(a,b) {
	        var tOfA = typeof a;
	        var tOfB = typeof b;
	        var arr;
	        if((tOfA === 'number' || tOfA === 'boolean' || tOfA === 'string' || a instanceof Number ) && (tOfB === 'number' || tOfB === 'boolean' || tOfB === 'string' || b instanceof Number )) {
	            return a / b;
	        }
	        var i, len;
	        if(isTypeOfArray(a) && (tOfB === 'number' || tOfB === 'boolean' || tOfB === 'string' || b instanceof Number  )){
	            len = a.length;
	            arr = createTypedArray('float32', len);
	            for(i=0;i<len;i+=1){
	                arr[i] = a[i] / b;
	            }
	            return arr;
	        }
	        if((tOfA === 'number' || tOfA === 'boolean' || tOfA === 'string' || a instanceof Number ) && isTypeOfArray(b)){
	            len = b.length;
	            arr = createTypedArray('float32', len);
	            for(i=0;i<len;i+=1){
	                arr[i] = a / b[i];
	            }
	            return arr;
	        }
	        return 0;
	    }
	    function mod(a,b) {
	        if(typeof a === 'string') {
	            a = parseInt(a);
	        }
	        if(typeof b === 'string') {
	            b = parseInt(b);
	        }
	        return a % b;
	    }
	
	    function clamp(num, min, max) {
	        if(min > max){
	            var mm = max;
	            max = min;
	            min = mm;
	        }
	        return Math.min(Math.max(num, min), max);
	    }
	
	    function radiansToDegrees(val) {
	        return val/degToRads;
	    }
	    var radians_to_degrees = radiansToDegrees;
	
	    function degreesToRadians(val) {
	        return val*degToRads;
	    }
	    var degrees_to_radians = radiansToDegrees;
	
	    var helperLengthArray = [0,0,0,0,0,0];
	
	    function length(arr1,arr2){
	        if(typeof arr1 === 'number' || arr1 instanceof Number){
	            arr2 = arr2 || 0;
	            return Math.abs(arr1 - arr2);
	        }
	        if(!arr2){
	            arr2 = helperLengthArray;
	        }
	        var i,len = Math.min(arr1.length,arr2.length);
	        var addedLength = 0;
	        for(i=0;i<len;i+=1){
	            addedLength += Math.pow(arr2[i]-arr1[i],2);
	        }
	        return Math.sqrt(addedLength);
	    }
	
	    function normalize(vec){
	        return div(vec, length(vec));
	    }
	
	    function rgbToHsl(val){
	        var r = val[0]; var g = val[1]; var b = val[2];
	        var max = Math.max(r, g, b), min = Math.min(r, g, b);
	        var h, s, l = (max + min) / 2;
	
	        if(max == min){
	            h = s = 0; // achromatic
	        }else{
	            var d = max - min;
	            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
	            switch(max){
	                case r: h = (g - b) / d + (g < b ? 6 : 0); break;
	                case g: h = (b - r) / d + 2; break;
	                case b: h = (r - g) / d + 4; break;
	            }
	            h /= 6;
	        }
	
	        return [h, s, l,val[3]];
	    }
	    function hslToRgb(val){
	        var h = val[0];
	        var s = val[1];
	        var l = val[2];
	
	        var r, g, b;
	
	        if(s == 0){
	            r = g = b = l; // achromatic
	        }else{
	            function hue2rgb(p, q, t){
	                if(t < 0) t += 1;
	                if(t > 1) t -= 1;
	                if(t < 1/6) return p + (q - p) * 6 * t;
	                if(t < 1/2) return q;
	                if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;
	                return p;
	            }
	
	            var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
	            var p = 2 * l - q;
	            r = hue2rgb(p, q, h + 1/3);
	            g = hue2rgb(p, q, h);
	            b = hue2rgb(p, q, h - 1/3);
	        }
	
	        return [r, g , b, val[3]];
	    }
	
	    function linear(t, tMin, tMax, value1, value2){
	        if(value1 === undefined || value2 === undefined){
	            return linear(t,0,1,tMin,tMax);
	        }
	        if(t <= tMin) {
	            return value1;
	        }else if(t >= tMax){
	            return value2;
	        }
	        var perc = tMax === tMin ? 0 : (t-tMin)/(tMax-tMin);
	        if(!value1.length){
	            return value1 + (value2-value1)*perc;
	        }
	        var i, len = value1.length;
	        var arr = createTypedArray('float32', len);
	        for(i=0;i<len;i+=1){
	            arr[i] = value1[i] + (value2[i]-value1[i])*perc;
	        }
	        return arr;
	    }
	    function random(min,max){
	        if(max === undefined){
	            if(min === undefined){
	                min = 0;
	                max = 1;
	            } else {
	                max = min;
	                min = undefined;
	            }
	        }
	        if(max.length){
	            var i, len = max.length;
	            if(!min){
	                min = createTypedArray('float32', len);
	            }
	            var arr = createTypedArray('float32', len);
	            var rnd = BMMath.random();
	            for(i=0;i<len;i+=1){
	                arr[i] = min[i] + rnd*(max[i]-min[i])
	            }
	            return arr;
	        }
	        if(min === undefined){
	            min = 0;
	        }
	        var rndm = BMMath.random();
	        return min + rndm*(max-min);
	    }
	
	    function createPath(points, inTangents, outTangents, closed) {
	        inTangents = inTangents && inTangents.length ? inTangents : points;
	        outTangents = outTangents && outTangents.length ? outTangents : points;
	        var path = shape_pool.newShape();
	        var len = points.length;
	        path.setPathData(closed, len);
	        for(i = 0; i < len; i += 1) {
	            path.setTripleAt(points[i][0],points[i][1],outTangents[i][0] + points[i][0],outTangents[i][1] + points[i][1],inTangents[i][0] + points[i][0],inTangents[i][1] + points[i][1],i,true)
	        }
	        return path
	    }
	
	    function initiateExpression(elem,data,property){
	        var val = data.x;
	        var needsVelocity = /velocity(?![\w\d])/.test(val);
	        var _needsRandom = val.indexOf('random') !== -1;
	        var elemType = elem.data.ty;
	        var transform,content,effect;
	        var thisComp = elem.comp;
	        var thisProperty = property;
	        elem.comp.frameDuration = 1/elem.comp.globalData.frameRate;
	        var inPoint = elem.data.ip/elem.comp.globalData.frameRate;
	        var outPoint = elem.data.op/elem.comp.globalData.frameRate;
	        var width = elem.data.sw ? elem.data.sw : 0;
	        var height = elem.data.sh ? elem.data.sh : 0;
	        var loopIn, loop_in, loopOut, loop_out;
	        var toWorld,fromWorld,fromComp,fromCompToSurface,anchorPoint,thisLayer,thisComp,mask,valueAtTime,velocityAtTime;
	        var fn = new Function();
	        //var fnStr = 'var fn = function(){'+val+';this.v = $bm_rt;}';
	        //eval(fnStr);
	
	        var fn = eval('[function(){' + val+';if($bm_rt.__shapeObject){this.v=shape_pool.clone($bm_rt.v);}else{this.v=$bm_rt;}}' + ']')[0];
	        var bindedFn = fn.bind(this);
	        var numKeys = property.kf ? data.k.length : 0;
	
	        var wiggle = function wiggle(freq,amp){
	            var i,j, len = this.pv.length ? this.pv.length : 1;
	            var addedAmps = createTypedArray('float32', len);
	            freq = 5;
	            var iterations = Math.floor(time*freq);
	            i = 0;
	            j = 0;
	            while(i<iterations){
	                //var rnd = BMMath.random();
	                for(j=0;j<len;j+=1){
	                    addedAmps[j] += -amp + amp*2*BMMath.random();
	                    //addedAmps[j] += -amp + amp*2*rnd;
	                }
	                i += 1;
	            }
	            //var rnd2 = BMMath.random();
	            var periods = time*freq;
	            var perc = periods - Math.floor(periods);
	            var arr = createTypedArray('float32', len);
	            if(len>1){
	                for(j=0;j<len;j+=1){
	                    arr[j] = this.pv[j] + addedAmps[j] + (-amp + amp*2*BMMath.random())*perc;
	                    //arr[j] = this.pv[j] + addedAmps[j] + (-amp + amp*2*rnd)*perc;
	                    //arr[i] = this.pv[i] + addedAmp + amp1*perc + amp2*(1-perc);
	                }
	                return arr;
	            } else {
	                return this.pv + addedAmps[0] + (-amp + amp*2*BMMath.random())*perc;
	            }
	        }.bind(this);
	
	        if(thisProperty.loopIn) {
	            loopIn = thisProperty.loopIn.bind(thisProperty);
	            loop_in = loopIn;
	        }
	
	        if(thisProperty.loopOut) {
	            loopOut = thisProperty.loopOut.bind(thisProperty);
	            loop_out = loopOut;
	        }
	
	        var loopInDuration = function loopInDuration(type,duration){
	            return loopIn(type,duration,true);
	        }.bind(this);
	
	        var loopOutDuration = function loopOutDuration(type,duration){
	            return loopOut(type,duration,true);
	        }.bind(this);
	
	        if(this.getValueAtTime) {
	            valueAtTime = this.getValueAtTime.bind(this);
	        }
	
	        if(this.getVelocityAtTime) {
	            velocityAtTime = this.getVelocityAtTime.bind(this);
	        }
	
	        var comp = elem.comp.globalData.projectInterface.bind(elem.comp.globalData.projectInterface);
	
	        function lookAt(elem1,elem2){
	            var fVec = [elem2[0]-elem1[0],elem2[1]-elem1[1],elem2[2]-elem1[2]];
	            var pitch = Math.atan2(fVec[0],Math.sqrt(fVec[1]*fVec[1]+fVec[2]*fVec[2]))/degToRads;
	            var yaw = -Math.atan2(fVec[1],fVec[2])/degToRads;
	            return [yaw,pitch,0];
	        };
	
	        function easeOut(t, tMin, tMax, val1, val2){
	            if(val1 === undefined){
	                val1 = tMin;
	                val2 = tMax;
	            } else {
	                t = (t - tMin) / (tMax - tMin);
	            }
	            return -(val2-val1) * t*(t-2) + val1;
	        };
	
	        function easeIn(t, tMin, tMax, val1, val2){
	            if(val1 === undefined){
	                val1 = tMin;
	                val2 = tMax;
	            } else {
	                t = (t - tMin) / (tMax - tMin);
	            }
	            return (val2-val1)*t*t + val1;
	        };
	
	        function nearestKey(time){
	            var i, len = data.k.length,index,keyTime;
	            if(!data.k.length || typeof(data.k[0]) === 'number'){
	                index = 0;
	                keyTime = 0;
	            } else {
	                index = -1;
	                time *= elem.comp.globalData.frameRate;
	                if (time < data.k[0].t) {
	                    index = 1;
	                    keyTime = data.k[0].t;
	                } else {
	                    for(i=0;i<len-1;i+=1){
	                        if(time === data.k[i].t){
	                            index = i + 1;
	                            keyTime = data.k[i].t;
	                            break;
	                        }else if(time>data.k[i].t && time<data.k[i+1].t){
	                            if(time-data.k[i].t > data.k[i+1].t - time){
	                                index = i + 2;
	                                keyTime = data.k[i+1].t;
	                            } else {
	                                index = i + 1;
	                                keyTime = data.k[i].t;
	                            }
	                            break;
	                        }
	                    }
	                    if(index === -1){
	                        index = i + 1;
	                        keyTime = data.k[i].t;
	                    }
	                }
	                
	            }
	            var ob = {};
	            ob.index = index;
	            ob.time = keyTime/elem.comp.globalData.frameRate;
	            return ob;
	        };
	
	        function key(ind){
	            var ob, i, len;
	            if(!data.k.length || typeof(data.k[0]) === 'number'){
	                throw new Error('The property has no keyframe at index ' + ind);
	            }
	            ind -= 1;
	            ob = {
	                time: data.k[ind].t/elem.comp.globalData.frameRate
	            };
	            var arr;
	            if(ind === data.k.length - 1 && !data.k[ind].h){
	                arr = data.k[ind-1].e;
	            }else{
	                arr = data.k[ind].s;
	            }
	            len = arr.length;
	            for(i=0;i<len;i+=1){
	                ob[i] = arr[i];
	            }
	            return ob;
	        };
	
	        function framesToTime(frames,fps){
	            if(!fps){
	                fps = elem.comp.globalData.frameRate;
	            }
	            return frames/fps;
	        };
	
	        function timeToFrames(t,fps){
	            if(!t && t !== 0){
	                t = time;
	            }
	            if(!fps){
	                fps = elem.comp.globalData.frameRate;
	            }
	            return t*fps;
	        };
	
	        function seedRandom(seed){
	            BMMath.seedrandom(randSeed + seed);
	        };
	
	        function sourceRectAtTime() {
	            return elem.sourceRectAtTime();
	        }
	
	        var time,velocity, value,textIndex,textTotal,selectorValue;
	        var index = elem.data.ind;
	        var hasParent = !!(elem.hierarchy && elem.hierarchy.length);
	        var parent;
	        var randSeed = Math.floor(Math.random()*1000000);
	        function executeExpression(){
	            if(_needsRandom){
	                seedRandom(randSeed);
	            }
	            if(this.frameExpressionId === elem.globalData.frameId && this.type !== 'textSelector'){
	                return;
	            }
	            if(this.lock){
	                this.v = duplicatePropertyValue(this.pv,this.mult);
	                return true;
	            }
	            if(this.type === 'textSelector'){
	                textIndex = this.textIndex;
	                textTotal = this.textTotal;
	                selectorValue = this.selectorValue;
	            }
	            if(!thisLayer){
	                thisLayer = elem.layerInterface;
	                thisComp = elem.comp.compInterface;
	                toWorld = thisLayer.toWorld.bind(thisLayer);
	                fromWorld = thisLayer.fromWorld.bind(thisLayer);
	                fromComp = thisLayer.fromComp.bind(thisLayer);
	                mask = thisLayer.mask ? thisLayer.mask.bind(thisLayer):null;
	                fromCompToSurface = fromComp;
	            }
	            if(!transform){
	                transform = elem.layerInterface("ADBE Transform Group");
	                anchorPoint = transform.anchorPoint;
	            }
	            
	            if(elemType === 4 && !content){
	                content = thisLayer("ADBE Root Vectors Group");
	            }
	            if(!effect){
	                effect = thisLayer(4);
	            }
	            hasParent = !!(elem.hierarchy && elem.hierarchy.length);
	            if(hasParent && !parent){
	                parent = elem.hierarchy[0].layerInterface;
	            }
	            this.lock = true;
	            if(this.getPreValue){
	                this.getPreValue();
	            }
	            value = this.pv;
	            time = this.comp.renderedFrame/this.comp.globalData.frameRate;
	            if(needsVelocity){
	                velocity = velocityAtTime(time);
	            }
	            bindedFn();
	            this.frameExpressionId = elem.globalData.frameId;
	            var i,len;
	            if(this.mult){
	                if(typeof this.v === 'number' || this.v instanceof Number || this.v instanceof String || typeof this.v === 'string'){
	                    this.v *= this.mult;
	                }else if(this.v.length === 1){
	                    this.v = this.v[0] * this.mult;
	                }else{
	                    len = this.v.length;
	                    if(value === this.v){
	                        this.v = len === 2 ? [value[0],value[1]] : [value[0],value[1],value[2]];
	                    }
	                    for(i = 0; i < len; i += 1){
	                        this.v[i] *= this.mult;
	                    }
	                }
	            }
	            if(this.v.length === 1){
	                this.v = this.v[0];
	            }
	            if(typeof this.v === 'number' || this.v instanceof Number || this.v instanceof String || typeof this.v === 'string'){
	                if(this.lastValue !== this.v){
	                    this.lastValue = this.v;
	                    this.mdf = true;
	                }
	            }else if( this.v._length){
	                if(!shapesEqual(this.v,this.localShapeCollection.shapes[0])){
	                    this.mdf = true;
	                    this.localShapeCollection.releaseShapes();
	                    this.localShapeCollection.addShape(shape_pool.clone(this.v));
	                }
	            }else{
	                len = this.v.length;
	                for(i = 0; i < len; i += 1){
	                    if(this.v[i] !== this.lastValue[i]){
	                        this.lastValue[i] = this.v[i];
	                        this.mdf = true;
	                    }
	                }
	            }
	            this.lock = false;
	        }
	        return executeExpression;
	    };
	
	    ob.initiateExpression = initiateExpression;
	    return ob;
	}());
	var ShapeExpressionInterface = (function(){
	    var ob = {
	        createShapeInterface:createShapeInterface,
	        createGroupInterface:createGroupInterface,
	        createTrimInterface:createTrimInterface,
	        createStrokeInterface:createStrokeInterface,
	        createTransformInterface:createTransformInterface,
	        createEllipseInterface:createEllipseInterface,
	        createStarInterface:createStarInterface,
	        createRectInterface:createRectInterface,
	        createRoundedInterface:createRoundedInterface,
	        createRepatearInterface:createRepatearInterface,
	        createPathInterface:createPathInterface,
	        createFillInterface:createFillInterface
	    };
	    function createShapeInterface(shapes,view,propertyGroup){
	        return shapeInterfaceFactory(shapes,view,propertyGroup);
	    }
	    function createGroupInterface(shapes,view,propertyGroup){
	        return groupInterfaceFactory(shapes,view,propertyGroup);
	    }
	    function createFillInterface(shape,view,propertyGroup){
	        return fillInterfaceFactory(shape,view,propertyGroup);
	    }
	    function createStrokeInterface(shape,view,propertyGroup){
	        return strokeInterfaceFactory(shape,view,propertyGroup);
	    }
	    function createTrimInterface(shape,view,propertyGroup){
	        return trimInterfaceFactory(shape,view,propertyGroup);
	    }
	    function createTransformInterface(shape,view,propertyGroup){
	        return transformInterfaceFactory(shape,view,propertyGroup);
	    }
	    function createEllipseInterface(shape,view,propertyGroup){
	        return ellipseInterfaceFactory(shape,view,propertyGroup);
	    }
	    function createStarInterface(shape,view,propertyGroup){
	        return starInterfaceFactory(shape,view,propertyGroup);
	    }
	    function createRectInterface(shape,view,propertyGroup){
	        return rectInterfaceFactory(shape,view,propertyGroup);
	    }
	    function createRoundedInterface(shape,view,propertyGroup){
	        return roundedInterfaceFactory(shape,view,propertyGroup);
	    }
	    function createRepatearInterface(shape,view,propertyGroup){
	        return repeaterInterfaceFactory(shape,view,propertyGroup);
	    }
	    function createPathInterface(shape,view,propertyGroup){
	        return pathInterfaceFactory(shape,view,propertyGroup);
	    }
	
	    function iterateElements(shapes,view, propertyGroup){
	        var arr = [];
	        var i, len = shapes ? shapes.length : 0;
	        for(i=0;i<len;i+=1){
	            if(shapes[i].ty == 'gr'){
	                arr.push(ShapeExpressionInterface.createGroupInterface(shapes[i],view[i],propertyGroup));
	            }else if(shapes[i].ty == 'fl'){
	                arr.push(ShapeExpressionInterface.createFillInterface(shapes[i],view[i],propertyGroup));
	            }else if(shapes[i].ty == 'st'){
	                arr.push(ShapeExpressionInterface.createStrokeInterface(shapes[i],view[i],propertyGroup));
	            }else if(shapes[i].ty == 'tm'){
	                arr.push(ShapeExpressionInterface.createTrimInterface(shapes[i],view[i],propertyGroup));
	            }else if(shapes[i].ty == 'tr'){
	                //arr.push(ShapeExpressionInterface.createTransformInterface(shapes[i],view[i],propertyGroup));
	            }else if(shapes[i].ty == 'el'){
	                arr.push(ShapeExpressionInterface.createEllipseInterface(shapes[i],view[i],propertyGroup));
	            }else if(shapes[i].ty == 'sr'){
	                arr.push(ShapeExpressionInterface.createStarInterface(shapes[i],view[i],propertyGroup));
	            } else if(shapes[i].ty == 'sh'){
	                arr.push(ShapeExpressionInterface.createPathInterface(shapes[i],view[i],propertyGroup));
	            } else if(shapes[i].ty == 'rc'){
	                arr.push(ShapeExpressionInterface.createRectInterface(shapes[i],view[i],propertyGroup));
	            } else if(shapes[i].ty == 'rd'){
	                arr.push(ShapeExpressionInterface.createRoundedInterface(shapes[i],view[i],propertyGroup));
	            } else if(shapes[i].ty == 'rp'){
	                arr.push(ShapeExpressionInterface.createRepatearInterface(shapes[i],view[i],propertyGroup));
	            } else{
	                //console.log(shapes[i].ty);
	            }
	        }
	        return arr;
	    }
	
	    var shapeInterfaceFactory = (function(){
	        return function(shapes,view,propertyGroup){
	            var interfaces;
	            function _interfaceFunction(value){
	                if(typeof value === 'number'){
	                    return interfaces[value-1];
	                } else {
	                    var i = 0, len = interfaces.length;
	                    while(i<len){
	                        if(interfaces[i]._name === value){
	                            return interfaces[i];
	                        }
	                        i+=1;
	                    }
	                }
	            }
	            _interfaceFunction.propertyGroup = propertyGroup;
	            interfaces = iterateElements(shapes, view, _interfaceFunction);
	            return _interfaceFunction;
	        }
	    }());
	
	    var contentsInterfaceFactory = (function(){
	       return function(shape,view, propertyGroup){
	           var interfaces;
	           var interfaceFunction = function _interfaceFunction(value){
	               var i = 0, len = interfaces.length;
	                while(i<len){
	                    if(interfaces[i]._name === value || interfaces[i].mn === value || interfaces[i].propertyIndex === value || interfaces[i].ix === value || interfaces[i].ind === value){
	                       return interfaces[i];
	                    }
	                    i+=1;
	                }
	                if(typeof value === 'number'){
	                   return interfaces[value-1];
	                }
	           };
	           interfaceFunction.propertyGroup = function(val){
	               if(val === 1){
	                   return interfaceFunction;
	               } else{
	                   return propertyGroup(val-1);
	               }
	           };
	           interfaces = iterateElements(shape.it, view.it, interfaceFunction.propertyGroup);
	           interfaceFunction.numProperties = interfaces.length;
	           interfaceFunction.propertyIndex = shape.cix;
	
	           return interfaceFunction;
	       }
	    }());
	
	    var groupInterfaceFactory = (function(){
	        return function(shape,view, propertyGroup){
	            var interfaceFunction = function _interfaceFunction(value){
	                switch(value){
	                    case 'ADBE Vectors Group':
	                    case 'Contents':
	                    case 2:
	                        return interfaceFunction.content;
	                    case 'ADBE Vector Transform Group':
	                    case 3:
	                    default:
	                        return interfaceFunction.transform;
	                }
	            }
	            interfaceFunction.propertyGroup = function(val){
	                if(val === 1){
	                    return interfaceFunction;
	                } else{
	                    return propertyGroup(val-1);
	                }
	            };
	            var content = contentsInterfaceFactory(shape,view,interfaceFunction.propertyGroup);
	            var transformInterface = ShapeExpressionInterface.createTransformInterface(shape.it[shape.it.length - 1],view.it[view.it.length - 1],interfaceFunction.propertyGroup);
	            interfaceFunction.content = content;
	            interfaceFunction.transform = transformInterface;
	            Object.defineProperty(interfaceFunction, '_name', {
	                get: function(){
	                    return shape.nm;
	                }
	            });
	            //interfaceFunction.content = interfaceFunction;
	            interfaceFunction.numProperties = shape.np;
	            interfaceFunction.propertyIndex = shape.ix;
	            interfaceFunction.nm = shape.nm;
	            interfaceFunction.mn = shape.mn;
	            return interfaceFunction;
	        }
	    }());
	
	    var fillInterfaceFactory = (function(){
	        return function(shape,view,propertyGroup){
	
	            function interfaceFunction(val){
	                if(val === 'Color' || val === 'color'){
	                    return interfaceFunction.color;
	                } else if(val === 'Opacity' || val === 'opacity'){
	                    return interfaceFunction.opacity;
	                }
	            }
	            Object.defineProperty(interfaceFunction, 'color', {
	                get: function(){
	                    return ExpressionValue(view.c, 1 / view.c.mult, 'color');
	                }
	            });
	            Object.defineProperty(interfaceFunction, 'opacity', {
	                get: function(){
	                    return ExpressionValue(view.o, 100);
	                }
	            });
	            Object.defineProperty(interfaceFunction, '_name', { value: shape.nm });
	            Object.defineProperty(interfaceFunction, 'mn', { value: shape.mn });
	
	            view.c.setGroupProperty(propertyGroup);
	            view.o.setGroupProperty(propertyGroup);
	            return interfaceFunction;
	        }
	    }());
	
	    var strokeInterfaceFactory = (function(){
	        return function(shape,view,propertyGroup){
	            function _propertyGroup(val){
	                if(val === 1){
	                    return ob;
	                } else{
	                    return propertyGroup(val-1);
	                }
	            };
	            function _dashPropertyGroup(val){
	                if(val === 1){
	                    return dashOb;
	                } else{
	                    return _propertyGroup(val-1);
	                }
	            };
	            function addPropertyToDashOb(i) {
	                Object.defineProperty(dashOb, shape.d[i].nm, {
	                    get: function(){
	                        return ExpressionValue(view.d.dataProps[i].p)
	                    }
	                });
	            }
	            var i, len = shape.d ? shape.d.length : 0;
	            var dashOb = {}
	            for (i = 0; i < len; i += 1) {
	                addPropertyToDashOb(i);
	                view.d.dataProps[i].p.setGroupProperty(_dashPropertyGroup);
	            }
	
	            function interfaceFunction(val){
	                if(val === 'Color' || val === 'color'){
	                    return interfaceFunction.color;
	                } else if(val === 'Opacity' || val === 'opacity'){
	                    return interfaceFunction.opacity;
	                } else if(val === 'Stroke Width' || val === 'stroke width'){
	                    return interfaceFunction.strokeWidth;
	                }
	            }
	            Object.defineProperty(interfaceFunction, 'color', {
	                get: function(){
	                    return ExpressionValue(view.c, 1 / view.c.mult, 'color');
	                }
	            });
	            Object.defineProperty(interfaceFunction, 'opacity', {
	                get: function(){
	                    return ExpressionValue(view.o, 100);
	                }
	            });
	            Object.defineProperty(interfaceFunction, 'strokeWidth', {
	                get: function(){
	                    return ExpressionValue(view.w);
	                }
	            });
	            Object.defineProperty(interfaceFunction, 'dash', {
	                get: function(){
	                    return dashOb;
	                }
	            });
	            Object.defineProperty(interfaceFunction, '_name', { value: shape.nm });
	            Object.defineProperty(interfaceFunction, 'mn', { value: shape.mn });
	
	            view.c.setGroupProperty(_propertyGroup);
	            view.o.setGroupProperty(_propertyGroup);
	            view.w.setGroupProperty(_propertyGroup);
	            return interfaceFunction;
	        }
	    }());
	
	    var trimInterfaceFactory = (function(){
	        return function(shape,view,propertyGroup){
	            function _propertyGroup(val){
	                if(val == 1){
	                    return interfaceFunction;
	                } else {
	                    return propertyGroup(--val);
	                }
	            }
	            interfaceFunction.propertyIndex = shape.ix;
	
	            view.s.setGroupProperty(_propertyGroup);
	            view.e.setGroupProperty(_propertyGroup);
	            view.o.setGroupProperty(_propertyGroup);
	
	            function interfaceFunction(val){
	                if(val === shape.e.ix || val === 'End' || val === 'end'){
	                    return interfaceFunction.end;
	                }
	                if(val === shape.s.ix){
	                    return interfaceFunction.start;
	                }
	                if(val === shape.o.ix){
	                    return interfaceFunction.offset;
	                }
	            }
	            interfaceFunction.propertyIndex = shape.ix;
	            Object.defineProperty(interfaceFunction, 'start', {
	                get: function(){
	                    return ExpressionValue(view.s, 1 / view.s.mult);
	                }
	            });
	            Object.defineProperty(interfaceFunction, 'end', {
	                get: function(){
	                    return ExpressionValue(view.e, 1 / view.e.mult);
	                }
	            });
	            Object.defineProperty(interfaceFunction, 'offset', {
	                get: function(){
	                    return ExpressionValue(view.o);
	                }
	            });
	            Object.defineProperty(interfaceFunction, '_name', {
	                get: function(){
	                    return shape.nm;
	                }
	            });
	            interfaceFunction.mn = shape.mn;
	            return interfaceFunction;
	        }
	    }());
	
	    var transformInterfaceFactory = (function(){
	        return function(shape,view,propertyGroup){
	            function _propertyGroup(val){
	                if(val == 1){
	                    return interfaceFunction;
	                } else {
	                    return propertyGroup(--val);
	                }
	            }
	            view.transform.mProps.o.setGroupProperty(_propertyGroup);
	            view.transform.mProps.p.setGroupProperty(_propertyGroup);
	            view.transform.mProps.a.setGroupProperty(_propertyGroup);
	            view.transform.mProps.s.setGroupProperty(_propertyGroup);
	            view.transform.mProps.r.setGroupProperty(_propertyGroup);
	            if(view.transform.mProps.sk){
	                view.transform.mProps.sk.setGroupProperty(_propertyGroup);
	                view.transform.mProps.sa.setGroupProperty(_propertyGroup);
	            }
	            view.transform.op.setGroupProperty(_propertyGroup);
	
	            function interfaceFunction(value){
	                if(shape.a.ix === value){
	                    return interfaceFunction.anchorPoint;
	                }
	                if(shape.o.ix === value){
	                    return interfaceFunction.opacity;
	                }
	                if(shape.p.ix === value){
	                    return interfaceFunction.position;
	                }
	                if(shape.r.ix === value){
	                    return interfaceFunction.rotation;
	                }
	                if(shape.s.ix === value){
	                    return interfaceFunction.scale;
	                }
	                if(shape.sk && shape.sk.ix === value){
	                    return interfaceFunction.skew;
	                }
	                if(shape.sa && shape.sa.ix === value){
	                    return interfaceFunction.skewAxis;
	                }
	                if(value === 'Opacity') {
	                    return interfaceFunction.opacity;
	                }
	                if(value === 'Position') {
	                    return interfaceFunction.position;
	                }
	                if(value === 'Anchor Point') {
	                    return interfaceFunction.anchorPoint;
	                }
	                if(value === 'Scale') {
	                    return interfaceFunction.scale;
	                }
	                if(value === 'Rotation' || value === 'ADBE Vector Rotation') {
	                    return interfaceFunction.rotation;
	                }
	                if(value === 'Skew') {
	                    return interfaceFunction.skew;
	                }
	                if(value === 'Skew Axis') {
	                    return interfaceFunction.skewAxis;
	                }
	
	            }
	            Object.defineProperty(interfaceFunction, 'opacity', {
	                get: function(){
	                    return ExpressionValue(view.transform.mProps.o, 1/view.transform.mProps.o.mult);
	                }
	            });
	            Object.defineProperty(interfaceFunction, 'position', {
	                get: function(){
	                    return ExpressionValue(view.transform.mProps.p);
	                }
	            });
	            Object.defineProperty(interfaceFunction, 'anchorPoint', {
	                get: function(){
	                    return ExpressionValue(view.transform.mProps.a);
	                }
	            });
	            var scaleArray = [];
	            Object.defineProperty(interfaceFunction, 'scale', {
	                get: function(){
	                    return ExpressionValue(view.transform.mProps.s, 1 / view.transform.mProps.s.mult);
	                }
	            });
	            Object.defineProperty(interfaceFunction, 'rotation', {
	                get: function(){
	                    return ExpressionValue(view.transform.mProps.r, 1 / view.transform.mProps.r.mult);
	                }
	            });
	            Object.defineProperty(interfaceFunction, 'skew', {
	                get: function(){
	                    return ExpressionValue(view.transform.mProps.sk);
	                }
	            });
	            Object.defineProperty(interfaceFunction, 'skewAxis', {
	                get: function(){
	                    return ExpressionValue(view.transform.mProps.sa);
	                }
	            });
	            Object.defineProperty(interfaceFunction, '_name', {
	                get: function(){
	                    return shape.nm;
	                }
	            });
	            interfaceFunction.ty = 'tr';
	            interfaceFunction.mn = shape.mn;
	            return interfaceFunction;
	        }
	    }());
	
	    var ellipseInterfaceFactory = (function(){
	        return function(shape,view,propertyGroup){
	            function _propertyGroup(val){
	                if(val == 1){
	                    return interfaceFunction;
	                } else {
	                    return propertyGroup(--val);
	                }
	            }
	            interfaceFunction.propertyIndex = shape.ix;
	            var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
	            prop.s.setGroupProperty(_propertyGroup);
	            prop.p.setGroupProperty(_propertyGroup);
	            function interfaceFunction(value){
	                if(shape.p.ix === value){
	                    return interfaceFunction.position;
	                }
	                if(shape.s.ix === value){
	                    return interfaceFunction.size;
	                }
	            }
	            Object.defineProperty(interfaceFunction, 'size', {
	                get: function(){
	                    return ExpressionValue(prop.s);
	                }
	            });
	            Object.defineProperty(interfaceFunction, 'position', {
	                get: function(){
	                    return ExpressionValue(prop.p);
	                }
	            });
	            Object.defineProperty(interfaceFunction, '_name', {
	                get: function(){
	                    return shape.nm;
	                }
	            });
	            interfaceFunction.mn = shape.mn;
	            return interfaceFunction;
	        }
	    }());
	
	    var starInterfaceFactory = (function(){
	        return function(shape,view,propertyGroup){
	            function _propertyGroup(val){
	                if(val == 1){
	                    return interfaceFunction;
	                } else {
	                    return propertyGroup(--val);
	                }
	            }
	            var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
	            interfaceFunction.propertyIndex = shape.ix;
	            prop.or.setGroupProperty(_propertyGroup);
	            prop.os.setGroupProperty(_propertyGroup);
	            prop.pt.setGroupProperty(_propertyGroup);
	            prop.p.setGroupProperty(_propertyGroup);
	            prop.r.setGroupProperty(_propertyGroup);
	            if(shape.ir){
	                prop.ir.setGroupProperty(_propertyGroup);
	                prop.is.setGroupProperty(_propertyGroup);
	            }
	
	            function interfaceFunction(value){
	                if(shape.p.ix === value){
	                    return interfaceFunction.position;
	                }
	                if(shape.r.ix === value){
	                    return interfaceFunction.rotation;
	                }
	                if(shape.pt.ix === value){
	                    return interfaceFunction.points;
	                }
	                if(shape.or.ix === value || 'ADBE Vector Star Outer Radius' === value){
	                    return interfaceFunction.outerRadius;
	                }
	                if(shape.os.ix === value){
	                    return interfaceFunction.outerRoundness;
	                }
	                if(shape.ir && (shape.ir.ix === value || 'ADBE Vector Star Inner Radius' === value)){
	                    return interfaceFunction.innerRadius;
	                }
	                if(shape.is && shape.is.ix === value){
	                    return interfaceFunction.innerRoundness;
	                }
	
	            }
	            Object.defineProperty(interfaceFunction, 'position', {
	                get: function(){
	                    return ExpressionValue(prop.p);
	                }
	            });
	            Object.defineProperty(interfaceFunction, 'rotation', {
	                get: function(){
	                    return ExpressionValue(prop.r, 1 / prop.r.mult);
	                }
	            });
	            Object.defineProperty(interfaceFunction, 'points', {
	                get: function(){
	                    return ExpressionValue(prop.pt);
	                }
	            });
	            Object.defineProperty(interfaceFunction, 'outerRadius', {
	                get: function(){
	                    return ExpressionValue(prop.or);
	                }
	            });
	            Object.defineProperty(interfaceFunction, 'outerRoundness', {
	                get: function(){
	                    return ExpressionValue(prop.os);
	                }
	            });
	            Object.defineProperty(interfaceFunction, 'innerRadius', {
	                get: function(){
	                    if(!prop.ir){
	                        return 0;
	                    }
	                    return ExpressionValue(prop.ir);
	                }
	            });
	            Object.defineProperty(interfaceFunction, 'innerRoundness', {
	                get: function(){
	                    if(!prop.is){
	                        return 0;
	                    }
	                    return ExpressionValue(prop.is, 1 / prop.is.mult);
	                }
	            });
	            Object.defineProperty(interfaceFunction, '_name', {
	                get: function(){
	                    return shape.nm;
	                }
	            });
	            interfaceFunction.mn = shape.mn;
	            return interfaceFunction;
	        }
	    }());
	
	    var rectInterfaceFactory = (function(){
	        return function(shape,view,propertyGroup){
	            function _propertyGroup(val){
	                if(val == 1){
	                    return interfaceFunction;
	                } else {
	                    return propertyGroup(--val);
	                }
	            }
	            var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
	            interfaceFunction.propertyIndex = shape.ix;
	            prop.p.setGroupProperty(_propertyGroup);
	            prop.s.setGroupProperty(_propertyGroup);
	            prop.r.setGroupProperty(_propertyGroup);
	
	            function interfaceFunction(value){
	                if(shape.p.ix === value){
	                    return interfaceFunction.position;
	                }
	                if(shape.r.ix === value){
	                    return interfaceFunction.roundness;
	                }
	                if(shape.s.ix === value || value === 'Size'){
	                    return interfaceFunction.size;
	                }
	
	            }
	            Object.defineProperty(interfaceFunction, 'position', {
	                get: function(){
	                    return ExpressionValue(prop.p);
	                }
	            });
	            Object.defineProperty(interfaceFunction, 'roundness', {
	                get: function(){
	                    return ExpressionValue(prop.r);
	                }
	            });
	            Object.defineProperty(interfaceFunction, 'size', {
	                get: function(){
	                    return ExpressionValue(prop.s);
	                }
	            });
	
	            Object.defineProperty(interfaceFunction, '_name', {
	                get: function(){
	                    return shape.nm;
	                }
	            });
	            interfaceFunction.mn = shape.mn;
	            return interfaceFunction;
	        }
	    }());
	
	    var roundedInterfaceFactory = (function(){
	        return function(shape,view,propertyGroup){
	            function _propertyGroup(val){
	                if(val == 1){
	                    return interfaceFunction;
	                } else {
	                    return propertyGroup(--val);
	                }
	            }
	            var prop = view;
	            interfaceFunction.propertyIndex = shape.ix;
	            prop.rd.setGroupProperty(_propertyGroup);
	
	            function interfaceFunction(value){
	                if(shape.r.ix === value || 'Round Corners 1' === value){
	                    return interfaceFunction.radius;
	                }
	
	            }
	            Object.defineProperty(interfaceFunction, 'radius', {
	                get: function(){
	                    return ExpressionValue(prop.rd);
	                }
	            });
	
	            Object.defineProperty(interfaceFunction, '_name', {
	                get: function(){
	                    return shape.nm;
	                }
	            });
	            interfaceFunction.mn = shape.mn;
	            return interfaceFunction;
	        }
	    }());
	
	    var repeaterInterfaceFactory = (function(){
	        return function(shape,view,propertyGroup){
	            function _propertyGroup(val){
	                if(val == 1){
	                    return interfaceFunction;
	                } else {
	                    return propertyGroup(--val);
	                }
	            }
	            var prop = view;
	            interfaceFunction.propertyIndex = shape.ix;
	            prop.c.setGroupProperty(_propertyGroup);
	            prop.o.setGroupProperty(_propertyGroup);
	
	            function interfaceFunction(value){
	                if(shape.c.ix === value || 'Copies' === value){
	                    return interfaceFunction.copies;
	                } else if(shape.o.ix === value || 'Offset' === value){
	                    return interfaceFunction.offset;
	                }
	
	            }
	            Object.defineProperty(interfaceFunction, 'copies', {
	                get: function(){
	                    return ExpressionValue(prop.c);
	                }
	            });
	
	            Object.defineProperty(interfaceFunction, 'offset', {
	                get: function(){
	                    return ExpressionValue(prop.o);
	                }
	            });
	
	            Object.defineProperty(interfaceFunction, '_name', {
	                get: function(){
	                    return shape.nm;
	                }
	            });
	            interfaceFunction.mn = shape.mn;
	            return interfaceFunction;
	        }
	    }());
	
	    var pathInterfaceFactory = (function(){
	        return function(shape,view,propertyGroup){
	            var prop = view.sh;
	            function _propertyGroup(val){
	                if(val == 1){
	                    return interfaceFunction;
	                } else {
	                    return propertyGroup(--val);
	                }
	            }
	            prop.setGroupProperty(_propertyGroup);
	
	            function interfaceFunction(val){
	                if(val === 'Shape' || val === 'shape' || val === 'Path' || val === 'path' || val === 'ADBE Vector Shape' || val === 2){
	                    return interfaceFunction.path;
	                }
	            }
	
	            Object.defineProperty(interfaceFunction, 'path', {
	                get: function(){
	                    if(prop.k){
	                        prop.getValue();
	                    }
	                    return prop;
	                    //return shape_pool.clone(prop.v);
	                }
	            });
	            Object.defineProperty(interfaceFunction, 'shape', {
	                get: function(){
	                    if(prop.k){
	                        prop.getValue();
	                    }
	                    return prop;
	                    //return shape_pool.clone(prop.v);
	                }
	            });
	            Object.defineProperty(interfaceFunction, '_name', { value: shape.nm });
	            Object.defineProperty(interfaceFunction, 'ix', { value: shape.ix });
	            Object.defineProperty(interfaceFunction, 'mn', { value: shape.mn });
	            return interfaceFunction;
	        }
	    }());
	
	
	    return ob;
	}())
	
	var TextExpressionInterface = (function(){
		return function(elem){
	        var _prevValue, _sourceText;
	        function _thisLayerFunction(){
	        }
	        Object.defineProperty(_thisLayerFunction, "sourceText", {
	            get: function(){
	                var stringValue = elem.textProperty.currentData.t;
	                if(elem.textProperty.currentData.t !== _prevValue) {
	                    elem.textProperty.currentData.t = _prevValue;
	                    _sourceText = new String(stringValue);
	                    //If stringValue is an empty string, eval returns undefined, so it has to be returned as a String primitive
	                    _sourceText.value = stringValue ? stringValue : new String(stringValue);
	                }
	                return _sourceText;
	            }
	        });
	        return _thisLayerFunction;
	    }
	}())
	var LayerExpressionInterface = (function (){
	    function toWorld(arr, time){
	        var toWorldMat = new Matrix();
	        toWorldMat.reset();
	        var transformMat;
	        if(time) {
	            //Todo implement value at time on transform properties
	            //transformMat = this._elem.finalTransform.mProp.getValueAtTime(time);
	            transformMat = this._elem.finalTransform.mProp;
	        } else {
	            transformMat = this._elem.finalTransform.mProp;
	        }
	        transformMat.applyToMatrix(toWorldMat);
	        if(this._elem.hierarchy && this._elem.hierarchy.length){
	            var i, len = this._elem.hierarchy.length;
	            for(i=0;i<len;i+=1){
	                this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(toWorldMat);
	            }
	            return toWorldMat.applyToPointArray(arr[0],arr[1],arr[2]||0);
	        }
	        return toWorldMat.applyToPointArray(arr[0],arr[1],arr[2]||0);
	    }
	    function fromWorld(arr, time){
	        var toWorldMat = new Matrix();
	        toWorldMat.reset();
	        var transformMat;
	        if(time) {
	            //Todo implement value at time on transform properties
	            //transformMat = this._elem.finalTransform.mProp.getValueAtTime(time);
	            transformMat = this._elem.finalTransform.mProp;
	        } else {
	            transformMat = this._elem.finalTransform.mProp;
	        }
	        transformMat.applyToMatrix(toWorldMat);
	        if(this._elem.hierarchy && this._elem.hierarchy.length){
	            var i, len = this._elem.hierarchy.length;
	            for(i=0;i<len;i+=1){
	                this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(toWorldMat);
	            }
	            return toWorldMat.inversePoint(arr);
	        }
	        return toWorldMat.inversePoint(arr);
	    }
	    function fromComp(arr){
	        var toWorldMat = new Matrix();
	        toWorldMat.reset();
	        this._elem.finalTransform.mProp.applyToMatrix(toWorldMat);
	        if(this._elem.hierarchy && this._elem.hierarchy.length){
	            var i, len = this._elem.hierarchy.length;
	            for(i=0;i<len;i+=1){
	                this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(toWorldMat);
	            }
	            return toWorldMat.inversePoint(arr);
	        }
	        return toWorldMat.inversePoint(arr);
	    }
	
	
	    return function(elem){
	
	        var transformInterface = TransformExpressionInterface(elem.transform);
	
	        function _registerMaskInterface(maskManager){
	            _thisLayerFunction.mask = new MaskManagerInterface(maskManager, elem);
	        }
	        function _registerEffectsInterface(effects){
	            _thisLayerFunction.effect = effects;
	        }
	
	        function _thisLayerFunction(name){
	            switch(name){
	                case "ADBE Root Vectors Group":
	                case "Contents":
	                case 2:
	                    return _thisLayerFunction.shapeInterface;
	                case 1:
	                case 6:
	                case "Transform":
	                case "transform":
	                case "ADBE Transform Group":
	                    return transformInterface;
	                case 4:
	                case "ADBE Effect Parade":
	                    return _thisLayerFunction.effect;
	            }
	        }
	        _thisLayerFunction.toWorld = toWorld;
	        _thisLayerFunction.fromWorld = fromWorld;
	        _thisLayerFunction.toComp = toWorld;
	        _thisLayerFunction.fromComp = fromComp;
	        _thisLayerFunction.sourceRectAtTime = elem.sourceRectAtTime.bind(elem);
	        _thisLayerFunction._elem = elem;
	        Object.defineProperty(_thisLayerFunction, 'hasParent', {
	            get: function(){
	                return !!elem.hierarchy;
	            }
	        });
	        Object.defineProperty(_thisLayerFunction, 'parent', {
	            get: function(){
	                return elem.hierarchy[0].layerInterface;
	            }
	        });
	        Object.defineProperty(_thisLayerFunction, "rotation", getDescriptor(transformInterface, 'rotation'));
	        Object.defineProperty(_thisLayerFunction, "scale", getDescriptor(transformInterface, 'scale'));
	        Object.defineProperty(_thisLayerFunction, "position", getDescriptor(transformInterface, 'position'));
	        Object.defineProperty(_thisLayerFunction, "opacity", getDescriptor(transformInterface, 'opacity'));
	        var anchorPointDescriptor = getDescriptor(transformInterface, 'anchorPoint');
	        Object.defineProperty(_thisLayerFunction, "anchorPoint", anchorPointDescriptor);
	        Object.defineProperty(_thisLayerFunction, "anchor_point", anchorPointDescriptor);
	
	        Object.defineProperty(_thisLayerFunction, "transform", {
	            get: function () {
	                return transformInterface;
	            }
	        });
	
	        Object.defineProperty(_thisLayerFunction, "_name", { value:elem.data.nm });
	
	        Object.defineProperty(_thisLayerFunction, "active", {
	            get: function(){
	                return elem.isVisible;
	            }
	        });
	
	        _thisLayerFunction.startTime = elem.data.st;
	        _thisLayerFunction.index = elem.data.ind;
	        _thisLayerFunction.source = elem.data.refId;
	        _thisLayerFunction.height = elem.data.ty === 0 ? elem.data.h : 100;
	        _thisLayerFunction.width = elem.data.ty === 0 ? elem.data.w : 100;
	
	        _thisLayerFunction.registerMaskInterface = _registerMaskInterface;
	        _thisLayerFunction.registerEffectsInterface = _registerEffectsInterface;
	        return _thisLayerFunction;
	    }
	}());
	
	var CompExpressionInterface = (function (){
	    return function(comp){
	        function _thisLayerFunction(name){
	            var i=0, len = comp.layers.length;
	            while(i<len){
	                if(comp.layers[i].nm === name || comp.layers[i].ind === name){
	                    return comp.elements[i].layerInterface;
	                }
	                i += 1;
	            }
	            return {active:false}
	        }
	        Object.defineProperty(_thisLayerFunction, "_name", { value:comp.data.nm });
	        _thisLayerFunction.layer = _thisLayerFunction;
	        _thisLayerFunction.pixelAspect = 1;
	        _thisLayerFunction.height = comp.globalData.compSize.h;
	        _thisLayerFunction.width = comp.globalData.compSize.w;
	        _thisLayerFunction.pixelAspect = 1;
	        _thisLayerFunction.frameDuration = 1/comp.globalData.frameRate;
	        return _thisLayerFunction;
	    }
	}());
	var TransformExpressionInterface = (function (){
	    return function(transform){
	        function _thisFunction(name){
	            switch(name){
	                case "scale":
	                case "Scale":
	                case "ADBE Scale":
	                case 6:
	                    return _thisFunction.scale;
	                case "rotation":
	                case "Rotation":
	                case "ADBE Rotation":
	                case "ADBE Rotate Z":
	                case 10:
	                    return _thisFunction.rotation;
	                case "position":
	                case "Position":
	                case "ADBE Position":
	                case 2:
	                    return _thisFunction.position;
	                case "anchorPoint":
	                case "AnchorPoint":
	                case "Anchor Point":
	                case "ADBE AnchorPoint":
	                case 1:
	                    return _thisFunction.anchorPoint;
	                case "opacity":
	                case "Opacity":
	                case 11:
	                    return _thisFunction.opacity;
	            }
	        }
	
	        Object.defineProperty(_thisFunction, "rotation", {
	            get: function(){
	                if(transform.r) {
	                    return ExpressionValue(transform.r, 1/degToRads);
	                } else {
	                    return ExpressionValue(transform.rz, 1/degToRads);
	                }
	            }
	        });
	        Object.defineProperty(_thisFunction, "scale", {
	            get: function () {
	                return ExpressionValue(transform.s, 100);
	            }
	        });
	
	        Object.defineProperty(_thisFunction, "position", {
	            get: function () {
	                if(transform.p) {
	                    return ExpressionValue(transform.p);
	                } else {
	                    return [transform.px.v, transform.py.v, transform.pz ? transform.pz.v : 0];
	                };
	            }
	        });
	
	        Object.defineProperty(_thisFunction, "xPosition", {
	            get: function () {
	                return ExpressionValue(transform.px);
	            }
	        });
	
	        Object.defineProperty(_thisFunction, "yPosition", {
	            get: function () {
	                return ExpressionValue(transform.py);
	            }
	        });
	
	        Object.defineProperty(_thisFunction, "zPosition", {
	            get: function () {
	                return ExpressionValue(transform.pz);
	            }
	        });
	
	        Object.defineProperty(_thisFunction, "anchorPoint", {
	            get: function () {
	                return ExpressionValue(transform.a);
	            }
	        });
	
	        Object.defineProperty(_thisFunction, "opacity", {
	            get: function () {
	                return ExpressionValue(transform.o, 100);
	            }
	        });
	
	        Object.defineProperty(_thisFunction, "skew", {
	            get: function () {
	                return ExpressionValue(transform.sk);
	            }
	        });
	
	        Object.defineProperty(_thisFunction, "skewAxis", {
	            get: function () {
	                return ExpressionValue(transform.sa);
	            }
	        });
	
	        Object.defineProperty(_thisFunction, "orientation", {
	            get: function () {
	                return ExpressionValue(transform.or);
	            }
	        });
	
	        return _thisFunction;
	    }
	}());
	var ProjectInterface = (function (){
	
	    function registerComposition(comp){
	        this.compositions.push(comp);
	    }
	
	    return function(){
	        function _thisProjectFunction(name){
	            var i = 0, len = this.compositions.length;
	            while(i<len){
	                if(this.compositions[i].data && this.compositions[i].data.nm === name){
	                    if(this.compositions[i].prepareFrame) {
	                        this.compositions[i].prepareFrame(this.compositions[i].data.xt ? this.currentFrame : this.compositions[i].currentFrameNum);
	                    }
	                    return this.compositions[i].compInterface;
	                }
	                i+=1;
	            }
	        }
	
	        _thisProjectFunction.compositions = [];
	        _thisProjectFunction.currentFrame = 0;
	
	        _thisProjectFunction.registerComposition = registerComposition;
	
	
	
	        return _thisProjectFunction;
	    }
	}());
	var EffectsExpressionInterface = (function (){
	    var ob = {
	        createEffectsInterface: createEffectsInterface
	    };
	
	    function createEffectsInterface(elem, propertyGroup){
	        if(elem.effects){
	
	            var effectElements = [];
	            var effectsData = elem.data.ef;
	            var i, len = elem.effects.effectElements.length;
	            for(i=0;i<len;i+=1){
	                effectElements.push(createGroupInterface(effectsData[i],elem.effects.effectElements[i],propertyGroup,elem));
	            }
	
	            return function(name){
	                var effects = elem.data.ef, i = 0, len = effects.length;
	                while(i<len) {
	                    if(name === effects[i].nm || name === effects[i].mn || name === effects[i].ix){
	                        return effectElements[i];
	                    }
	                    i += 1;
	                }
	            }
	        }
	    }
	
	    function createGroupInterface(data,elements, propertyGroup, elem){
	        var effectElements = [];
	        var i, len = data.ef.length;
	        for(i=0;i<len;i+=1){
	            if(data.ef[i].ty === 5){
	                effectElements.push(createGroupInterface(data.ef[i],elements.effectElements[i],elements.effectElements[i].propertyGroup, elem));
	            } else {
	                effectElements.push(createValueInterface(elements.effectElements[i],data.ef[i].ty, elem, _propertyGroup));
	            }
	        }
	
	        function _propertyGroup(val) {
	            if(val === 1){
	               return groupInterface;
	            } else{
	               return propertyGroup(val-1);
	            }
	        }
	
	        var groupInterface = function(name){
	            var effects = data.ef, i = 0, len = effects.length;
	            while(i<len) {
	                if(name === effects[i].nm || name === effects[i].mn || name === effects[i].ix){
	                    if(effects[i].ty === 5){
	                        return effectElements[i];
	                    } else {
	                        return effectElements[i]();
	                    }
	                }
	                i += 1;
	            }
	            return effectElements[0]();
	        }
	
	        groupInterface.propertyGroup = _propertyGroup;
	
	        if(data.mn === 'ADBE Color Control'){
	            Object.defineProperty(groupInterface, 'color', {
	                get: function(){
	                    return effectElements[0]();
	                }
	            });
	        }
	        Object.defineProperty(groupInterface, 'numProperties', {
	            get: function(){
	                return data.np;
	            }
	        });
	        groupInterface.active = data.en !== 0;
	        return groupInterface
	    }
	
	    function createValueInterface(element, type, elem, propertyGroup){
	        function interfaceFunction(){
	            if(type === 10){
	                return elem.comp.compInterface(element.p.v);
	            }
	            return ExpressionValue(element.p);
	        }
	
	        if(element.p.setGroupProperty) {
	            element.p.setGroupProperty(propertyGroup);
	        }
	
	        return interfaceFunction;
	    }
	
	    return ob;
	
	}());
	var MaskManagerInterface = (function(){
	
		function MaskInterface(mask, data){
			this._mask = mask;
			this._data = data;
		}
		Object.defineProperty(MaskInterface.prototype, 'maskPath', {
	        get: function(){
	                if(this._mask.prop.k){
	                    this._mask.prop.getValue();
	                }
	                return this._mask.prop;
	            }
	        });
	
		var MaskManager = function(maskManager, elem){
			var _maskManager = maskManager;
			var _elem = elem;
			var _masksInterfaces = Array.apply(null,{length: maskManager.viewData.length});
			var i, len = maskManager.viewData.length;
			for(i = 0; i < len; i += 1) {
				_masksInterfaces[i] = new MaskInterface(maskManager.viewData[i], maskManager.masksProperties[i]);
			}
	
			var maskFunction = function(name){
				i = 0;
			    while(i<len){
			        if(maskManager.masksProperties[i].nm === name){
			            return _masksInterfaces[i];
			        }
			        i += 1;
			    }
			}
			return maskFunction
		}
		return MaskManager
	}())
	
	
	var ExpressionValue = (function() {
		return function(elementProp, mult, type) {
	        var expressionValue, arrayValue;
	
			if (elementProp.k) {
	            elementProp.getValue();
	        }
	        var i, len, arrValue;
	        if (type) {
	        	if(type === 'color') {
	        		len = 4;
	                expressionValue = createTypedArray('float32', len);
	                arrValue = createTypedArray('float32', len);
			        for (i = 0; i < len; i += 1) {
			            expressionValue[i] = arrValue[i] = (mult && i < 3) ? elementProp.v[i] * mult : 1;
			        }
		        	expressionValue.value = arrValue;
	        	}
	        } else if (typeof elementProp.v === 'number' || elementProp.v instanceof Number){
	            expressionValue = mult ? new Number(elementProp.v * mult) : new Number(elementProp.v);
	            expressionValue.value = mult ? elementProp.v * mult : elementProp.v;
	        } else {
	        	len = elementProp.v.length;
	            expressionValue = createTypedArray('float32', len);
	            arrValue = createTypedArray('float32', len);
		        for (i = 0; i < len; i += 1) {
		            expressionValue[i] = arrValue[i] = mult ? elementProp.v[i] * mult : elementProp.v[i];
		        }
		        expressionValue.value = arrValue;
	        }
	        
	        expressionValue.numKeys = elementProp.keyframes ? elementProp.keyframes.length : 0;
	        expressionValue.key = function(pos) {
	            if (!expressionValue.numKeys) {
	                return 0;
	            } else {
	                return elementProp.keyframes[pos-1].t;
	            }
	        };
	        expressionValue.valueAtTime = elementProp.getValueAtTime;
	        expressionValue.propertyGroup = elementProp.propertyGroup;
	        return expressionValue;
		}
	}())
	function SliderEffect(data,elem, dynamicProperties){
	    this.p = PropertyFactory.getProp(elem,data.v,0,0,dynamicProperties);
	}
	function AngleEffect(data,elem, dynamicProperties){
	    this.p = PropertyFactory.getProp(elem,data.v,0,0,dynamicProperties);
	}
	function ColorEffect(data,elem, dynamicProperties){
	    this.p = PropertyFactory.getProp(elem,data.v,1,0,dynamicProperties);
	}
	function PointEffect(data,elem, dynamicProperties){
	    this.p = PropertyFactory.getProp(elem,data.v,1,0,dynamicProperties);
	}
	function LayerIndexEffect(data,elem, dynamicProperties){
	    this.p = PropertyFactory.getProp(elem,data.v,0,0,dynamicProperties);
	}
	function MaskIndexEffect(data,elem, dynamicProperties){
	    this.p = PropertyFactory.getProp(elem,data.v,0,0,dynamicProperties);
	}
	function CheckboxEffect(data,elem, dynamicProperties){
	    this.p = PropertyFactory.getProp(elem,data.v,0,0,dynamicProperties);
	}
	function NoValueEffect(){
	    this.p = {};
	}
	function EffectsManager(data,element,dynamicProperties){
	    var effects = data.ef;
	    this.effectElements = [];
	    var i,len = effects.length;
	    var effectItem;
	    for(i=0;i<len;i++) {
	        effectItem = new GroupEffect(effects[i],element,dynamicProperties);
	        this.effectElements.push(effectItem);
	    }
	}
	
	function GroupEffect(data,element,dynamicProperties){
	    this.dynamicProperties = [];
	    this.init(data,element,this.dynamicProperties);
	    if(this.dynamicProperties.length){
	        dynamicProperties.push(this);
	    }
	}
	
	GroupEffect.prototype.getValue = function(){
	    this.mdf = false;
	    var i, len = this.dynamicProperties.length;
	    for(i=0;i<len;i+=1){
	        this.dynamicProperties[i].getValue();
	        this.mdf = this.dynamicProperties[i].mdf ? true : this.mdf;
	    }
	};
	
	GroupEffect.prototype.init = function(data,element,dynamicProperties){
	    this.data = data;
	    this.mdf = false;
	    this.effectElements = [];
	    var i, len = this.data.ef.length;
	    var eff, effects = this.data.ef;
	    for(i=0;i<len;i+=1){
	        switch(effects[i].ty){
	            case 0:
	                eff = new SliderEffect(effects[i],element,dynamicProperties);
	                this.effectElements.push(eff);
	                break;
	            case 1:
	                eff = new AngleEffect(effects[i],element,dynamicProperties);
	                this.effectElements.push(eff);
	                break;
	            case 2:
	                eff = new ColorEffect(effects[i],element,dynamicProperties);
	                this.effectElements.push(eff);
	                break;
	            case 3:
	                eff = new PointEffect(effects[i],element,dynamicProperties);
	                this.effectElements.push(eff);
	                break;
	            case 4:
	            case 7:
	                eff = new CheckboxEffect(effects[i],element,dynamicProperties);
	                this.effectElements.push(eff);
	                break;
	            case 10:
	                eff = new LayerIndexEffect(effects[i],element,dynamicProperties);
	                this.effectElements.push(eff);
	                break;
	            case 11:
	                eff = new MaskIndexEffect(effects[i],element,dynamicProperties);
	                this.effectElements.push(eff);
	                break;
	            case 5:
	                eff = new EffectsManager(effects[i],element,dynamicProperties);
	                this.effectElements.push(eff);
	                break;
	            case 6:
	            default:
	                eff = new NoValueEffect(effects[i],element,dynamicProperties);
	                this.effectElements.push(eff);
	                break;
	        }
	    }
	};
	    var lottiejs = {};
	
	    function setLocationHref (href) {
	        locationHref = href;
	    }
	    function play(animation){
	        animationManager.play(animation);
	    }
	
	    function pause(animation) {
	        animationManager.pause(animation);
	    }
	
	    function togglePause(animation) {
	        animationManager.togglePause(animation);
	    }
	
	    function setSpeed(value, animation) {
	        animationManager.setSpeed(value, animation);
	    }
	
	    function setDirection(value, animation) {
	        animationManager.setDirection(value, animation);
	    }
	
	    function stop(animation) {
	        animationManager.stop(animation);
	    }
	
	    function moveFrame(value) {
	        animationManager.moveFrame(value);
	    }
	
	    function searchAnimations() {
	        if (standalone === true) {
	            animationManager.searchAnimations(animationData, standalone, renderer);
	        } else {
	            animationManager.searchAnimations();
	        }
	    }
	
	    function registerAnimation(elem) {
	        return animationManager.registerAnimation(elem);
	    }
	
	    function resize() {
	        animationManager.resize();
	    }
	
	    /*function start() {
	        animationManager.start();
	    }*/
	
	    function goToAndStop(val, isFrame, animation) {
	        animationManager.goToAndStop(val, isFrame, animation);
	    }
	
	    function setSubframeRendering(flag) {
	        subframeEnabled = flag;
	    }
	
	    function loadAnimation(params) {
	        if (standalone === true) {
	            params.animationData = JSON.parse(animationData);
	        }
	        return animationManager.loadAnimation(params);
	    }
	
	    function destroy(animation) {
	        return animationManager.destroy(animation);
	    }
	
	    function setQuality(value) {
	        if (typeof value === 'string') {
	            switch (value) {
	                case 'high':
	                    defaultCurveSegments = 200;
	                    break;
	                case 'medium':
	                    defaultCurveSegments = 50;
	                    break;
	                case 'low':
	                    defaultCurveSegments = 10;
	                    break;
	            }
	        } else if (!isNaN(value) && value > 1) {
	            defaultCurveSegments = value;
	        }
	        if (defaultCurveSegments >= 50) {
	            roundValues(false);
	        } else {
	            roundValues(true);
	        }
	    }
	
	    function inBrowser() {
	        return typeof navigator !== 'undefined';
	    }
	
	    function installPlugin(type, plugin) {
	        if (type === 'expressions') {
	            expressionsPlugin = plugin;
	        }
	    }
	
	    function getFactory(name) {
	        switch (name) {
	            case "propertyFactory":
	                return PropertyFactory;
	            case "shapePropertyFactory":
	                return ShapePropertyFactory;
	            case "matrix":
	                return Matrix;
	        }
	    }
	    lottiejs.play = play;
	    lottiejs.pause = pause;
	    lottiejs.setLocationHref = setLocationHref;
	    lottiejs.togglePause = togglePause;
	    lottiejs.setSpeed = setSpeed;
	    lottiejs.setDirection = setDirection;
	    lottiejs.stop = stop;
	    lottiejs.moveFrame = moveFrame;
	    lottiejs.searchAnimations = searchAnimations;
	    lottiejs.registerAnimation = registerAnimation;
	    lottiejs.loadAnimation = loadAnimation;
	    lottiejs.setSubframeRendering = setSubframeRendering;
	    lottiejs.resize = resize;
	    //lottiejs.start = start;
	    lottiejs.goToAndStop = goToAndStop;
	    lottiejs.destroy = destroy;
	    lottiejs.setQuality = setQuality;
	    lottiejs.inBrowser = inBrowser;
	    lottiejs.installPlugin = installPlugin;
	    lottiejs.__getFactory = getFactory;
	    lottiejs.version = '5.0.5';
	
	    function checkReady() {
	        if (document.readyState === "complete") {
	            clearInterval(readyStateCheckInterval);
	            searchAnimations();
	        }
	    }
	
	    function getQueryVariable(variable) {
	        var vars = queryString.split('&');
	        for (var i = 0; i < vars.length; i++) {
	            var pair = vars[i].split('=');
	            if (decodeURIComponent(pair[0]) == variable) {
	                return decodeURIComponent(pair[1]);
	            }
	        }
	    }
	    var standalone = '__[STANDALONE]__';
	    var animationData = '__[ANIMATIONDATA]__';
	    var renderer = '';
	    if (standalone) {
	        var scripts = document.getElementsByTagName('script');
	        var index = scripts.length - 1;
	        var myScript = scripts[index] || {
	            src: ''
	        };
	        var queryString = myScript.src.replace(/^[^\?]+\??/, '');
	        renderer = getQueryVariable('renderer');
	    }
	    var readyStateCheckInterval = setInterval(checkReady, 100);
	    return lottiejs;
	}));

/***/ },
/* 130 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Router = __webpack_require__(90);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Router2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(24);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(34);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _matchPath = __webpack_require__(91);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isEmptyChildren = function isEmptyChildren(children) {
	  return _react2.default.Children.count(children) === 0;
	};
	
	/**
	 * The public API for matching a single path and rendering.
	 */
	
	var Route = function (_React$Component) {
	  _inherits(Route, _React$Component);
	
	  function Route() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Route);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      match: _this.computeMatch(_this.props, _this.context.router)
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Route.prototype.getChildContext = function getChildContext() {
	    return {
	      router: _extends({}, this.context.router, {
	        route: {
	          location: this.props.location || this.context.router.route.location,
	          match: this.state.match
	        }
	      })
	    };
	  };
	
	  Route.prototype.computeMatch = function computeMatch(_ref, router) {
	    var computedMatch = _ref.computedMatch,
	        location = _ref.location,
	        path = _ref.path,
	        strict = _ref.strict,
	        exact = _ref.exact,
	        sensitive = _ref.sensitive;
	
	    if (computedMatch) return computedMatch; // <Switch> already computed the match for us
	
	    (0, _invariant2.default)(router, 'You should not use <Route> or withRouter() outside a <Router>');
	
	    var route = router.route;
	
	    var pathname = (location || route.location).pathname;
	
	    return path ? (0, _matchPath2.default)(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }) : route.match;
	  };
	
	  Route.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!(this.props.component && this.props.render), 'You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored');
	
	    (0, _warning2.default)(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored');
	
	    (0, _warning2.default)(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored');
	  };
	
	  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
	    (0, _warning2.default)(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
	
	    (0, _warning2.default)(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
	
	    this.setState({
	      match: this.computeMatch(nextProps, nextContext.router)
	    });
	  };
	
	  Route.prototype.render = function render() {
	    var match = this.state.match;
	    var _props = this.props,
	        children = _props.children,
	        component = _props.component,
	        render = _props.render;
	    var _context$router = this.context.router,
	        history = _context$router.history,
	        route = _context$router.route,
	        staticContext = _context$router.staticContext;
	
	    var location = this.props.location || route.location;
	    var props = { match: match, location: location, history: history, staticContext: staticContext };
	
	    return component ? // component prop gets first priority, only called if there's a match
	    match ? _react2.default.createElement(component, props) : null : render ? // render prop is next, only called if there's a match
	    match ? render(props) : null : children ? // children come last, always called
	    typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? _react2.default.Children.only(children) : null : null;
	  };
	
	  return Route;
	}(_react2.default.Component);
	
	Route.propTypes = {
	  computedMatch: _propTypes2.default.object, // private, from <Switch>
	  path: _propTypes2.default.string,
	  exact: _propTypes2.default.bool,
	  strict: _propTypes2.default.bool,
	  sensitive: _propTypes2.default.bool,
	  component: _propTypes2.default.func,
	  render: _propTypes2.default.func,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.node]),
	  location: _propTypes2.default.object
	};
	Route.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.object.isRequired,
	    route: _propTypes2.default.object.isRequired,
	    staticContext: _propTypes2.default.object
	  })
	};
	Route.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = Route;

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(219);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(556);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(555);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(554);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(218);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(220);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Swiper 4.1.0
	 * Most modern mobile touch slider and framework with hardware accelerated transitions
	 * http://www.idangero.us/swiper/
	 *
	 * Copyright 2014-2018 Vladimir Kharlampidi
	 *
	 * Released under the MIT License
	 *
	 * Released on: January 13, 2018
	 */
	
	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.Swiper = factory());
	}(this, (function () { 'use strict';
	
	/**
	 * Dom7 2.0.1
	 * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
	 * http://framework7.io/docs/dom.html
	 *
	 * Copyright 2017, Vladimir Kharlampidi
	 * The iDangero.us
	 * http://www.idangero.us/
	 *
	 * Licensed under MIT
	 *
	 * Released on: October 2, 2017
	 */
	var Dom7 = function Dom7(arr) {
	  var self = this;
	  // Create array-like object
	  for (var i = 0; i < arr.length; i += 1) {
	    self[i] = arr[i];
	  }
	  self.length = arr.length;
	  // Return collection with methods
	  return this;
	};
	
	function $$1(selector, context) {
	  var arr = [];
	  var i = 0;
	  if (selector && !context) {
	    if (selector instanceof Dom7) {
	      return selector;
	    }
	  }
	  if (selector) {
	      // String
	    if (typeof selector === 'string') {
	      var els;
	      var tempParent;
	      var html = selector.trim();
	      if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
	        var toCreate = 'div';
	        if (html.indexOf('<li') === 0) { toCreate = 'ul'; }
	        if (html.indexOf('<tr') === 0) { toCreate = 'tbody'; }
	        if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) { toCreate = 'tr'; }
	        if (html.indexOf('<tbody') === 0) { toCreate = 'table'; }
	        if (html.indexOf('<option') === 0) { toCreate = 'select'; }
	        tempParent = document.createElement(toCreate);
	        tempParent.innerHTML = html;
	        for (i = 0; i < tempParent.childNodes.length; i += 1) {
	          arr.push(tempParent.childNodes[i]);
	        }
	      } else {
	        if (!context && selector[0] === '#' && !selector.match(/[ .<>:~]/)) {
	          // Pure ID selector
	          els = [document.getElementById(selector.trim().split('#')[1])];
	        } else {
	          // Other selectors
	          els = (context || document).querySelectorAll(selector.trim());
	        }
	        for (i = 0; i < els.length; i += 1) {
	          if (els[i]) { arr.push(els[i]); }
	        }
	      }
	    } else if (selector.nodeType || selector === window || selector === document) {
	      // Node/element
	      arr.push(selector);
	    } else if (selector.length > 0 && selector[0].nodeType) {
	      // Array of elements or instance of Dom
	      for (i = 0; i < selector.length; i += 1) {
	        arr.push(selector[i]);
	      }
	    }
	  }
	  return new Dom7(arr);
	}
	
	$$1.fn = Dom7.prototype;
	$$1.Class = Dom7;
	$$1.Dom7 = Dom7;
	
	function unique(arr) {
	  var uniqueArray = [];
	  for (var i = 0; i < arr.length; i += 1) {
	    if (uniqueArray.indexOf(arr[i]) === -1) { uniqueArray.push(arr[i]); }
	  }
	  return uniqueArray;
	}
	// Classes and attributes
	function addClass(className) {
	  var this$1 = this;
	
	  if (typeof className === 'undefined') {
	    return this;
	  }
	  var classes = className.split(' ');
	  for (var i = 0; i < classes.length; i += 1) {
	    for (var j = 0; j < this.length; j += 1) {
	      if (typeof this$1[j].classList !== 'undefined') { this$1[j].classList.add(classes[i]); }
	    }
	  }
	  return this;
	}
	function removeClass(className) {
	  var this$1 = this;
	
	  var classes = className.split(' ');
	  for (var i = 0; i < classes.length; i += 1) {
	    for (var j = 0; j < this.length; j += 1) {
	      if (typeof this$1[j].classList !== 'undefined') { this$1[j].classList.remove(classes[i]); }
	    }
	  }
	  return this;
	}
	function hasClass(className) {
	  if (!this[0]) { return false; }
	  return this[0].classList.contains(className);
	}
	function toggleClass(className) {
	  var this$1 = this;
	
	  var classes = className.split(' ');
	  for (var i = 0; i < classes.length; i += 1) {
	    for (var j = 0; j < this.length; j += 1) {
	      if (typeof this$1[j].classList !== 'undefined') { this$1[j].classList.toggle(classes[i]); }
	    }
	  }
	  return this;
	}
	function attr(attrs, value) {
	  var arguments$1 = arguments;
	  var this$1 = this;
	
	  if (arguments.length === 1 && typeof attrs === 'string') {
	    // Get attr
	    if (this[0]) { return this[0].getAttribute(attrs); }
	    return undefined;
	  }
	
	  // Set attrs
	  for (var i = 0; i < this.length; i += 1) {
	    if (arguments$1.length === 2) {
	      // String
	      this$1[i].setAttribute(attrs, value);
	    } else {
	      // Object
	      // eslint-disable-next-line
	      for (var attrName in attrs) {
	        this$1[i][attrName] = attrs[attrName];
	        this$1[i].setAttribute(attrName, attrs[attrName]);
	      }
	    }
	  }
	  return this;
	}
	// eslint-disable-next-line
	function removeAttr(attr) {
	  var this$1 = this;
	
	  for (var i = 0; i < this.length; i += 1) {
	    this$1[i].removeAttribute(attr);
	  }
	  return this;
	}
	function data(key, value) {
	  var this$1 = this;
	
	  var el;
	  if (typeof value === 'undefined') {
	    el = this[0];
	    // Get value
	    if (el) {
	      if (el.dom7ElementDataStorage && (key in el.dom7ElementDataStorage)) {
	        return el.dom7ElementDataStorage[key];
	      }
	
	      var dataKey = el.getAttribute(("data-" + key));
	      if (dataKey) {
	        return dataKey;
	      }
	      return undefined;
	    }
	    return undefined;
	  }
	
	  // Set value
	  for (var i = 0; i < this.length; i += 1) {
	    el = this$1[i];
	    if (!el.dom7ElementDataStorage) { el.dom7ElementDataStorage = {}; }
	    el.dom7ElementDataStorage[key] = value;
	  }
	  return this;
	}
	// Transforms
	// eslint-disable-next-line
	function transform(transform) {
	  var this$1 = this;
	
	  for (var i = 0; i < this.length; i += 1) {
	    var elStyle = this$1[i].style;
	    elStyle.webkitTransform = transform;
	    elStyle.transform = transform;
	  }
	  return this;
	}
	function transition(duration) {
	  var this$1 = this;
	
	  if (typeof duration !== 'string') {
	    duration = duration + "ms"; // eslint-disable-line
	  }
	  for (var i = 0; i < this.length; i += 1) {
	    var elStyle = this$1[i].style;
	    elStyle.webkitTransitionDuration = duration;
	    elStyle.transitionDuration = duration;
	  }
	  return this;
	}
	// Events
	function on() {
	  var this$1 = this;
	  var args = [], len = arguments.length;
	  while ( len-- ) args[ len ] = arguments[ len ];
	
	  var eventType = args[0];
	  var targetSelector = args[1];
	  var listener = args[2];
	  var capture = args[3];
	  if (typeof args[1] === 'function') {
	    var assign;
	    (assign = args, eventType = assign[0], listener = assign[1], capture = assign[2]);
	    targetSelector = undefined;
	  }
	  if (!capture) { capture = false; }
	
	  function handleLiveEvent(e) {
	    var target = e.target;
	    if (!target) { return; }
	    var eventData = e.target.dom7EventData || [];
	    eventData.unshift(e);
	    if ($$1(target).is(targetSelector)) { listener.apply(target, eventData); }
	    else {
	      var parents = $$1(target).parents(); // eslint-disable-line
	      for (var k = 0; k < parents.length; k += 1) {
	        if ($$1(parents[k]).is(targetSelector)) { listener.apply(parents[k], eventData); }
	      }
	    }
	  }
	  function handleEvent(e) {
	    var eventData = e && e.target ? e.target.dom7EventData || [] : [];
	    eventData.unshift(e);
	    listener.apply(this, eventData);
	  }
	  var events = eventType.split(' ');
	  var j;
	  for (var i = 0; i < this.length; i += 1) {
	    var el = this$1[i];
	    if (!targetSelector) {
	      for (j = 0; j < events.length; j += 1) {
	        if (!el.dom7Listeners) { el.dom7Listeners = []; }
	        el.dom7Listeners.push({
	          type: eventType,
	          listener: listener,
	          proxyListener: handleEvent,
	        });
	        el.addEventListener(events[j], handleEvent, capture);
	      }
	    } else {
	      // Live events
	      for (j = 0; j < events.length; j += 1) {
	        if (!el.dom7LiveListeners) { el.dom7LiveListeners = []; }
	        el.dom7LiveListeners.push({
	          type: eventType,
	          listener: listener,
	          proxyListener: handleLiveEvent,
	        });
	        el.addEventListener(events[j], handleLiveEvent, capture);
	      }
	    }
	  }
	  return this;
	}
	function off() {
	  var this$1 = this;
	  var args = [], len = arguments.length;
	  while ( len-- ) args[ len ] = arguments[ len ];
	
	  var eventType = args[0];
	  var targetSelector = args[1];
	  var listener = args[2];
	  var capture = args[3];
	  if (typeof args[1] === 'function') {
	    var assign;
	    (assign = args, eventType = assign[0], listener = assign[1], capture = assign[2]);
	    targetSelector = undefined;
	  }
	  if (!capture) { capture = false; }
	
	  var events = eventType.split(' ');
	  for (var i = 0; i < events.length; i += 1) {
	    for (var j = 0; j < this.length; j += 1) {
	      var el = this$1[j];
	      if (!targetSelector) {
	        if (el.dom7Listeners) {
	          for (var k = 0; k < el.dom7Listeners.length; k += 1) {
	            if (listener) {
	              if (el.dom7Listeners[k].listener === listener) {
	                el.removeEventListener(events[i], el.dom7Listeners[k].proxyListener, capture);
	              }
	            } else if (el.dom7Listeners[k].type === events[i]) {
	              el.removeEventListener(events[i], el.dom7Listeners[k].proxyListener, capture);
	            }
	          }
	        }
	      } else if (el.dom7LiveListeners) {
	        for (var k$1 = 0; k$1 < el.dom7LiveListeners.length; k$1 += 1) {
	          if (listener) {
	            if (el.dom7LiveListeners[k$1].listener === listener) {
	              el.removeEventListener(events[i], el.dom7LiveListeners[k$1].proxyListener, capture);
	            }
	          } else if (el.dom7LiveListeners[k$1].type === events[i]) {
	            el.removeEventListener(events[i], el.dom7LiveListeners[k$1].proxyListener, capture);
	          }
	        }
	      }
	    }
	  }
	  return this;
	}
	function trigger() {
	  var this$1 = this;
	  var args = [], len = arguments.length;
	  while ( len-- ) args[ len ] = arguments[ len ];
	
	  var events = args[0].split(' ');
	  var eventData = args[1];
	  for (var i = 0; i < events.length; i += 1) {
	    for (var j = 0; j < this.length; j += 1) {
	      var evt = (void 0);
	      try {
	        evt = new window.CustomEvent(events[i], {
	          detail: eventData,
	          bubbles: true,
	          cancelable: true,
	        });
	      } catch (e) {
	        evt = document.createEvent('Event');
	        evt.initEvent(events[i], true, true);
	        evt.detail = eventData;
	      }
	      // eslint-disable-next-line
	      this$1[j].dom7EventData = args.filter(function (data, dataIndex) { return dataIndex > 0; });
	      this$1[j].dispatchEvent(evt);
	      this$1[j].dom7EventData = [];
	      delete this$1[j].dom7EventData;
	    }
	  }
	  return this;
	}
	function transitionEnd(callback) {
	  var events = ['webkitTransitionEnd', 'transitionend'];
	  var dom = this;
	  var i;
	  function fireCallBack(e) {
	    /* jshint validthis:true */
	    if (e.target !== this) { return; }
	    callback.call(this, e);
	    for (i = 0; i < events.length; i += 1) {
	      dom.off(events[i], fireCallBack);
	    }
	  }
	  if (callback) {
	    for (i = 0; i < events.length; i += 1) {
	      dom.on(events[i], fireCallBack);
	    }
	  }
	  return this;
	}
	function outerWidth(includeMargins) {
	  if (this.length > 0) {
	    if (includeMargins) {
	      // eslint-disable-next-line
	      var styles = this.styles();
	      return this[0].offsetWidth + parseFloat(styles.getPropertyValue('margin-right')) + parseFloat(styles.getPropertyValue('margin-left'));
	    }
	    return this[0].offsetWidth;
	  }
	  return null;
	}
	function outerHeight(includeMargins) {
	  if (this.length > 0) {
	    if (includeMargins) {
	      // eslint-disable-next-line
	      var styles = this.styles();
	      return this[0].offsetHeight + parseFloat(styles.getPropertyValue('margin-top')) + parseFloat(styles.getPropertyValue('margin-bottom'));
	    }
	    return this[0].offsetHeight;
	  }
	  return null;
	}
	function offset() {
	  if (this.length > 0) {
	    var el = this[0];
	    var box = el.getBoundingClientRect();
	    var body = document.body;
	    var clientTop = el.clientTop || body.clientTop || 0;
	    var clientLeft = el.clientLeft || body.clientLeft || 0;
	    var scrollTop = el === window ? window.scrollY : el.scrollTop;
	    var scrollLeft = el === window ? window.scrollX : el.scrollLeft;
	    return {
	      top: (box.top + scrollTop) - clientTop,
	      left: (box.left + scrollLeft) - clientLeft,
	    };
	  }
	
	  return null;
	}
	function styles() {
	  if (this[0]) { return window.getComputedStyle(this[0], null); }
	  return {};
	}
	function css(props, value) {
	  var this$1 = this;
	
	  var i;
	  if (arguments.length === 1) {
	    if (typeof props === 'string') {
	      if (this[0]) { return window.getComputedStyle(this[0], null).getPropertyValue(props); }
	    } else {
	      for (i = 0; i < this.length; i += 1) {
	        // eslint-disable-next-line
	        for (var prop in props) {
	          this$1[i].style[prop] = props[prop];
	        }
	      }
	      return this;
	    }
	  }
	  if (arguments.length === 2 && typeof props === 'string') {
	    for (i = 0; i < this.length; i += 1) {
	      this$1[i].style[props] = value;
	    }
	    return this;
	  }
	  return this;
	}
	
	// Iterate over the collection passing elements to `callback`
	function each(callback) {
	  var this$1 = this;
	
	  // Don't bother continuing without a callback
	  if (!callback) { return this; }
	  // Iterate over the current collection
	  for (var i = 0; i < this.length; i += 1) {
	    // If the callback returns false
	    if (callback.call(this$1[i], i, this$1[i]) === false) {
	      // End the loop early
	      return this$1;
	    }
	  }
	  // Return `this` to allow chained DOM operations
	  return this;
	}
	// eslint-disable-next-line
	function html(html) {
	  var this$1 = this;
	
	  if (typeof html === 'undefined') {
	    return this[0] ? this[0].innerHTML : undefined;
	  }
	
	  for (var i = 0; i < this.length; i += 1) {
	    this$1[i].innerHTML = html;
	  }
	  return this;
	}
	// eslint-disable-next-line
	function text(text) {
	  var this$1 = this;
	
	  if (typeof text === 'undefined') {
	    if (this[0]) {
	      return this[0].textContent.trim();
	    }
	    return null;
	  }
	
	  for (var i = 0; i < this.length; i += 1) {
	    this$1[i].textContent = text;
	  }
	  return this;
	}
	function is(selector) {
	  var el = this[0];
	  var compareWith;
	  var i;
	  if (!el || typeof selector === 'undefined') { return false; }
	  if (typeof selector === 'string') {
	    if (el.matches) { return el.matches(selector); }
	    else if (el.webkitMatchesSelector) { return el.webkitMatchesSelector(selector); }
	    else if (el.msMatchesSelector) { return el.msMatchesSelector(selector); }
	
	    compareWith = $$1(selector);
	    for (i = 0; i < compareWith.length; i += 1) {
	      if (compareWith[i] === el) { return true; }
	    }
	    return false;
	  } else if (selector === document) { return el === document; }
	  else if (selector === window) { return el === window; }
	
	  if (selector.nodeType || selector instanceof Dom7) {
	    compareWith = selector.nodeType ? [selector] : selector;
	    for (i = 0; i < compareWith.length; i += 1) {
	      if (compareWith[i] === el) { return true; }
	    }
	    return false;
	  }
	  return false;
	}
	function index() {
	  var child = this[0];
	  var i;
	  if (child) {
	    i = 0;
	    // eslint-disable-next-line
	    while ((child = child.previousSibling) !== null) {
	      if (child.nodeType === 1) { i += 1; }
	    }
	    return i;
	  }
	  return undefined;
	}
	// eslint-disable-next-line
	function eq(index) {
	  if (typeof index === 'undefined') { return this; }
	  var length = this.length;
	  var returnIndex;
	  if (index > length - 1) {
	    return new Dom7([]);
	  }
	  if (index < 0) {
	    returnIndex = length + index;
	    if (returnIndex < 0) { return new Dom7([]); }
	    return new Dom7([this[returnIndex]]);
	  }
	  return new Dom7([this[index]]);
	}
	function append() {
	  var this$1 = this;
	  var args = [], len = arguments.length;
	  while ( len-- ) args[ len ] = arguments[ len ];
	
	  var newChild;
	
	  for (var k = 0; k < args.length; k += 1) {
	    newChild = args[k];
	    for (var i = 0; i < this.length; i += 1) {
	      if (typeof newChild === 'string') {
	        var tempDiv = document.createElement('div');
	        tempDiv.innerHTML = newChild;
	        while (tempDiv.firstChild) {
	          this$1[i].appendChild(tempDiv.firstChild);
	        }
	      } else if (newChild instanceof Dom7) {
	        for (var j = 0; j < newChild.length; j += 1) {
	          this$1[i].appendChild(newChild[j]);
	        }
	      } else {
	        this$1[i].appendChild(newChild);
	      }
	    }
	  }
	
	  return this;
	}
	 function prepend(newChild) {
	  var this$1 = this;
	
	  var i;
	  var j;
	  for (i = 0; i < this.length; i += 1) {
	    if (typeof newChild === 'string') {
	      var tempDiv = document.createElement('div');
	      tempDiv.innerHTML = newChild;
	      for (j = tempDiv.childNodes.length - 1; j >= 0; j -= 1) {
	        this$1[i].insertBefore(tempDiv.childNodes[j], this$1[i].childNodes[0]);
	      }
	    } else if (newChild instanceof Dom7) {
	      for (j = 0; j < newChild.length; j += 1) {
	        this$1[i].insertBefore(newChild[j], this$1[i].childNodes[0]);
	      }
	    } else {
	      this$1[i].insertBefore(newChild, this$1[i].childNodes[0]);
	    }
	  }
	  return this;
	}
	 function next(selector) {
	  if (this.length > 0) {
	    if (selector) {
	      if (this[0].nextElementSibling && $$1(this[0].nextElementSibling).is(selector)) {
	        return new Dom7([this[0].nextElementSibling]);
	      }
	      return new Dom7([]);
	    }
	
	    if (this[0].nextElementSibling) { return new Dom7([this[0].nextElementSibling]); }
	    return new Dom7([]);
	  }
	  return new Dom7([]);
	}
	function nextAll(selector) {
	  var nextEls = [];
	  var el = this[0];
	  if (!el) { return new Dom7([]); }
	  while (el.nextElementSibling) {
	    var next = el.nextElementSibling; // eslint-disable-line
	    if (selector) {
	      if ($$1(next).is(selector)) { nextEls.push(next); }
	    } else { nextEls.push(next); }
	    el = next;
	  }
	  return new Dom7(nextEls);
	}
	function prev(selector) {
	  if (this.length > 0) {
	    var el = this[0];
	    if (selector) {
	      if (el.previousElementSibling && $$1(el.previousElementSibling).is(selector)) {
	        return new Dom7([el.previousElementSibling]);
	      }
	      return new Dom7([]);
	    }
	
	    if (el.previousElementSibling) { return new Dom7([el.previousElementSibling]); }
	    return new Dom7([]);
	  }
	  return new Dom7([]);
	}
	function prevAll(selector) {
	  var prevEls = [];
	  var el = this[0];
	  if (!el) { return new Dom7([]); }
	  while (el.previousElementSibling) {
	    var prev = el.previousElementSibling; // eslint-disable-line
	    if (selector) {
	      if ($$1(prev).is(selector)) { prevEls.push(prev); }
	    } else { prevEls.push(prev); }
	    el = prev;
	  }
	  return new Dom7(prevEls);
	}
	function parent(selector) {
	  var this$1 = this;
	
	  var parents = []; // eslint-disable-line
	  for (var i = 0; i < this.length; i += 1) {
	    if (this$1[i].parentNode !== null) {
	      if (selector) {
	        if ($$1(this$1[i].parentNode).is(selector)) { parents.push(this$1[i].parentNode); }
	      } else {
	        parents.push(this$1[i].parentNode);
	      }
	    }
	  }
	  return $$1(unique(parents));
	}
	function parents(selector) {
	  var this$1 = this;
	
	  var parents = []; // eslint-disable-line
	  for (var i = 0; i < this.length; i += 1) {
	    var parent = this$1[i].parentNode; // eslint-disable-line
	    while (parent) {
	      if (selector) {
	        if ($$1(parent).is(selector)) { parents.push(parent); }
	      } else {
	        parents.push(parent);
	      }
	      parent = parent.parentNode;
	    }
	  }
	  return $$1(unique(parents));
	}
	function closest(selector) {
	  var closest = this; // eslint-disable-line
	  if (typeof selector === 'undefined') {
	    return new Dom7([]);
	  }
	  if (!closest.is(selector)) {
	    closest = closest.parents(selector).eq(0);
	  }
	  return closest;
	}
	function find(selector) {
	  var this$1 = this;
	
	  var foundElements = [];
	  for (var i = 0; i < this.length; i += 1) {
	    var found = this$1[i].querySelectorAll(selector);
	    for (var j = 0; j < found.length; j += 1) {
	      foundElements.push(found[j]);
	    }
	  }
	  return new Dom7(foundElements);
	}
	function children(selector) {
	  var this$1 = this;
	
	  var children = []; // eslint-disable-line
	  for (var i = 0; i < this.length; i += 1) {
	    var childNodes = this$1[i].childNodes;
	
	    for (var j = 0; j < childNodes.length; j += 1) {
	      if (!selector) {
	        if (childNodes[j].nodeType === 1) { children.push(childNodes[j]); }
	      } else if (childNodes[j].nodeType === 1 && $$1(childNodes[j]).is(selector)) {
	        children.push(childNodes[j]);
	      }
	    }
	  }
	  return new Dom7(unique(children));
	}
	function remove() {
	  var this$1 = this;
	
	  for (var i = 0; i < this.length; i += 1) {
	    if (this$1[i].parentNode) { this$1[i].parentNode.removeChild(this$1[i]); }
	  }
	  return this;
	}
	function add() {
	  var args = [], len = arguments.length;
	  while ( len-- ) args[ len ] = arguments[ len ];
	
	  var dom = this;
	  var i;
	  var j;
	  for (i = 0; i < args.length; i += 1) {
	    var toAdd = $$1(args[i]);
	    for (j = 0; j < toAdd.length; j += 1) {
	      dom[dom.length] = toAdd[j];
	      dom.length += 1;
	    }
	  }
	  return dom;
	}
	var noTrigger = ('resize scroll').split(' ');
	
	var Methods = {
	  addClass: addClass,
	  removeClass: removeClass,
	  hasClass: hasClass,
	  toggleClass: toggleClass,
	  attr: attr,
	  removeAttr: removeAttr,
	  data: data,
	  transform: transform,
	  transition: transition,
	  on: on,
	  off: off,
	  trigger: trigger,
	  transitionEnd: transitionEnd,
	  outerWidth: outerWidth,
	  outerHeight: outerHeight,
	  offset: offset,
	  css: css,
	  each: each,
	  html: html,
	  text: text,
	  is: is,
	  index: index,
	  eq: eq,
	  append: append,
	  prepend: prepend,
	  next: next,
	  nextAll: nextAll,
	  prev: prev,
	  prevAll: prevAll,
	  parent: parent,
	  parents: parents,
	  closest: closest,
	  find: find,
	  children: children,
	  remove: remove,
	  add: add,
	  styles: styles,
	};
	
	Object.keys(Methods).forEach(function (methodName) {
	  $$1.fn[methodName] = Methods[methodName];
	});
	
	var w;
	if (typeof window === 'undefined') {
	  w = {
	    navigator: {
	      userAgent: '',
	    },
	    location: {},
	    history: {},
	    addEventListener: function addEventListener() {},
	    removeEventListener: function removeEventListener() {},
	    getComputedStyle: function getComputedStyle() {
	      return {};
	    },
	    Image: function Image() {},
	    Date: function Date() {},
	    screen: {},
	  };
	} else {
	  w = window;
	}
	
	var win = w;
	
	var Utils = {
	  deleteProps: function deleteProps(obj) {
	    var object = obj;
	    Object.keys(object).forEach(function (key) {
	      try {
	        object[key] = null;
	      } catch (e) {
	        // no getter for object
	      }
	      try {
	        delete object[key];
	      } catch (e) {
	        // something got wrong
	      }
	    });
	  },
	  nextTick: function nextTick(callback, delay) {
	    if ( delay === void 0 ) delay = 0;
	
	    return setTimeout(callback, delay);
	  },
	  now: function now() {
	    return Date.now();
	  },
	  getTranslate: function getTranslate(el, axis) {
	    if ( axis === void 0 ) axis = 'x';
	
	    var matrix;
	    var curTransform;
	    var transformMatrix;
	
	    var curStyle = win.getComputedStyle(el, null);
	
	    if (win.WebKitCSSMatrix) {
	      curTransform = curStyle.transform || curStyle.webkitTransform;
	      if (curTransform.split(',').length > 6) {
	        curTransform = curTransform.split(', ').map(function (a) { return a.replace(',', '.'); }).join(', ');
	      }
	      // Some old versions of Webkit choke when 'none' is passed; pass
	      // empty string instead in this case
	      transformMatrix = new win.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
	    } else {
	      transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
	      matrix = transformMatrix.toString().split(',');
	    }
	
	    if (axis === 'x') {
	      // Latest Chrome and webkits Fix
	      if (win.WebKitCSSMatrix) { curTransform = transformMatrix.m41; }
	      // Crazy IE10 Matrix
	      else if (matrix.length === 16) { curTransform = parseFloat(matrix[12]); }
	      // Normal Browsers
	      else { curTransform = parseFloat(matrix[4]); }
	    }
	    if (axis === 'y') {
	      // Latest Chrome and webkits Fix
	      if (win.WebKitCSSMatrix) { curTransform = transformMatrix.m42; }
	      // Crazy IE10 Matrix
	      else if (matrix.length === 16) { curTransform = parseFloat(matrix[13]); }
	      // Normal Browsers
	      else { curTransform = parseFloat(matrix[5]); }
	    }
	    return curTransform || 0;
	  },
	  parseUrlQuery: function parseUrlQuery(url) {
	    var query = {};
	    var urlToParse = url || win.location.href;
	    var i;
	    var params;
	    var param;
	    var length;
	    if (typeof urlToParse === 'string' && urlToParse.length) {
	      urlToParse = urlToParse.indexOf('?') > -1 ? urlToParse.replace(/\S*\?/, '') : '';
	      params = urlToParse.split('&').filter(function (paramsPart) { return paramsPart !== ''; });
	      length = params.length;
	
	      for (i = 0; i < length; i += 1) {
	        param = params[i].replace(/#\S+/g, '').split('=');
	        query[decodeURIComponent(param[0])] = typeof param[1] === 'undefined' ? undefined : decodeURIComponent(param[1]) || '';
	      }
	    }
	    return query;
	  },
	  isObject: function isObject(o) {
	    return typeof o === 'object' && o !== null && o.constructor && o.constructor === Object;
	  },
	  extend: function extend() {
	    var args = [], len$1 = arguments.length;
	    while ( len$1-- ) args[ len$1 ] = arguments[ len$1 ];
	
	    var to = Object(args[0]);
	    for (var i = 1; i < args.length; i += 1) {
	      var nextSource = args[i];
	      if (nextSource !== undefined && nextSource !== null) {
	        var keysArray = Object.keys(Object(nextSource));
	        for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
	          var nextKey = keysArray[nextIndex];
	          var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
	          if (desc !== undefined && desc.enumerable) {
	            if (Utils.isObject(to[nextKey]) && Utils.isObject(nextSource[nextKey])) {
	              Utils.extend(to[nextKey], nextSource[nextKey]);
	            } else if (!Utils.isObject(to[nextKey]) && Utils.isObject(nextSource[nextKey])) {
	              to[nextKey] = {};
	              Utils.extend(to[nextKey], nextSource[nextKey]);
	            } else {
	              to[nextKey] = nextSource[nextKey];
	            }
	          }
	        }
	      }
	    }
	    return to;
	  },
	};
	
	var d;
	if (typeof document === 'undefined') {
	  d = {
	    addEventListener: function addEventListener() {},
	    removeEventListener: function removeEventListener() {},
	    activeElement: {
	      blur: function blur() {},
	      nodeName: '',
	    },
	    querySelector: function querySelector() {
	      return {};
	    },
	    querySelectorAll: function querySelectorAll() {
	      return [];
	    },
	    createElement: function createElement() {
	      return {
	        style: {},
	        setAttribute: function setAttribute() {},
	        getElementsByTagName: function getElementsByTagName() {
	          return [];
	        },
	      };
	    },
	    location: { hash: '' },
	  };
	} else {
	  d = document;
	}
	
	var doc = d;
	
	var Support = (function Support() {
	  var testDiv = doc.createElement('div');
	  return {
	    touch: (win.Modernizr && win.Modernizr.touch === true) || (function checkTouch() {
	      return !!(('ontouchstart' in win) || (win.DocumentTouch && doc instanceof win.DocumentTouch));
	    }()),
	
	    pointerEvents: !!(win.navigator.pointerEnabled || win.PointerEvent),
	    prefixedPointerEvents: !!win.navigator.msPointerEnabled,
	
	    transition: (function checkTransition() {
	      var style = testDiv.style;
	      return ('transition' in style || 'webkitTransition' in style || 'MozTransition' in style);
	    }()),
	    transforms3d: (win.Modernizr && win.Modernizr.csstransforms3d === true) || (function checkTransforms3d() {
	      var style = testDiv.style;
	      return ('webkitPerspective' in style || 'MozPerspective' in style || 'OPerspective' in style || 'MsPerspective' in style || 'perspective' in style);
	    }()),
	
	    flexbox: (function checkFlexbox() {
	      var style = testDiv.style;
	      var styles = ('alignItems webkitAlignItems webkitBoxAlign msFlexAlign mozBoxAlign webkitFlexDirection msFlexDirection mozBoxDirection mozBoxOrient webkitBoxDirection webkitBoxOrient').split(' ');
	      for (var i = 0; i < styles.length; i += 1) {
	        if (styles[i] in style) { return true; }
	      }
	      return false;
	    }()),
	
	    observer: (function checkObserver() {
	      return ('MutationObserver' in win || 'WebkitMutationObserver' in win);
	    }()),
	
	    passiveListener: (function checkPassiveListener() {
	      var supportsPassive = false;
	      try {
	        var opts = Object.defineProperty({}, 'passive', {
	          // eslint-disable-next-line
	          get: function get() {
	            supportsPassive = true;
	          },
	        });
	        win.addEventListener('testPassiveListener', null, opts);
	      } catch (e) {
	        // No support
	      }
	      return supportsPassive;
	    }()),
	
	    gestures: (function checkGestures() {
	      return 'ongesturestart' in win;
	    }()),
	  };
	}());
	
	var SwiperClass = function SwiperClass(params) {
	  if ( params === void 0 ) params = {};
	
	  var self = this;
	  self.params = params;
	
	  // Events
	  self.eventsListeners = {};
	
	  if (self.params && self.params.on) {
	    Object.keys(self.params.on).forEach(function (eventName) {
	      self.on(eventName, self.params.on[eventName]);
	    });
	  }
	};
	
	var staticAccessors = { components: { configurable: true } };
	SwiperClass.prototype.on = function on (events, handler) {
	  var self = this;
	  if (typeof handler !== 'function') { return self; }
	  events.split(' ').forEach(function (event) {
	    if (!self.eventsListeners[event]) { self.eventsListeners[event] = []; }
	    self.eventsListeners[event].push(handler);
	  });
	  return self;
	};
	SwiperClass.prototype.once = function once (events, handler) {
	  var self = this;
	  if (typeof handler !== 'function') { return self; }
	  function onceHandler() {
	      var args = [], len = arguments.length;
	      while ( len-- ) args[ len ] = arguments[ len ];
	
	    handler.apply(self, args);
	    self.off(events, onceHandler);
	  }
	  return self.on(events, onceHandler);
	};
	SwiperClass.prototype.off = function off (events, handler) {
	  var self = this;
	  events.split(' ').forEach(function (event) {
	    if (typeof handler === 'undefined') {
	      self.eventsListeners[event] = [];
	    } else {
	      self.eventsListeners[event].forEach(function (eventHandler, index) {
	        if (eventHandler === handler) {
	          self.eventsListeners[event].splice(index, 1);
	        }
	      });
	    }
	  });
	  return self;
	};
	SwiperClass.prototype.emit = function emit () {
	    var args = [], len = arguments.length;
	    while ( len-- ) args[ len ] = arguments[ len ];
	
	  var self = this;
	  if (!self.eventsListeners) { return self; }
	  var events;
	  var data;
	  var context;
	  if (typeof args[0] === 'string' || Array.isArray(args[0])) {
	    events = args[0];
	    data = args.slice(1, args.length);
	    context = self;
	  } else {
	    events = args[0].events;
	    data = args[0].data;
	    context = args[0].context || self;
	  }
	  var eventsArray = Array.isArray(events) ? events : events.split(' ');
	  eventsArray.forEach(function (event) {
	    if (self.eventsListeners[event]) {
	      var handlers = [];
	      self.eventsListeners[event].forEach(function (eventHandler) {
	        handlers.push(eventHandler);
	      });
	      handlers.forEach(function (eventHandler) {
	        eventHandler.apply(context, data);
	      });
	    }
	  });
	  return self;
	};
	SwiperClass.prototype.useModulesParams = function useModulesParams (instanceParams) {
	  var instance = this;
	  if (!instance.modules) { return; }
	  Object.keys(instance.modules).forEach(function (moduleName) {
	    var module = instance.modules[moduleName];
	    // Extend params
	    if (module.params) {
	      Utils.extend(instanceParams, module.params);
	    }
	  });
	};
	SwiperClass.prototype.useModules = function useModules (modulesParams) {
	    if ( modulesParams === void 0 ) modulesParams = {};
	
	  var instance = this;
	  if (!instance.modules) { return; }
	  Object.keys(instance.modules).forEach(function (moduleName) {
	    var module = instance.modules[moduleName];
	    var moduleParams = modulesParams[moduleName] || {};
	    // Extend instance methods and props
	    if (module.instance) {
	      Object.keys(module.instance).forEach(function (modulePropName) {
	        var moduleProp = module.instance[modulePropName];
	        if (typeof moduleProp === 'function') {
	          instance[modulePropName] = moduleProp.bind(instance);
	        } else {
	          instance[modulePropName] = moduleProp;
	        }
	      });
	    }
	    // Add event listeners
	    if (module.on && instance.on) {
	      Object.keys(module.on).forEach(function (moduleEventName) {
	        instance.on(moduleEventName, module.on[moduleEventName]);
	      });
	    }
	
	    // Module create callback
	    if (module.create) {
	      module.create.bind(instance)(moduleParams);
	    }
	  });
	};
	staticAccessors.components.set = function (components) {
	  var Class = this;
	  if (!Class.use) { return; }
	  Class.use(components);
	};
	SwiperClass.installModule = function installModule (module) {
	    var params = [], len = arguments.length - 1;
	    while ( len-- > 0 ) params[ len ] = arguments[ len + 1 ];
	
	  var Class = this;
	  if (!Class.prototype.modules) { Class.prototype.modules = {}; }
	  var name = module.name || (((Object.keys(Class.prototype.modules).length) + "_" + (Utils.now())));
	  Class.prototype.modules[name] = module;
	  // Prototype
	  if (module.proto) {
	    Object.keys(module.proto).forEach(function (key) {
	      Class.prototype[key] = module.proto[key];
	    });
	  }
	  // Class
	  if (module.static) {
	    Object.keys(module.static).forEach(function (key) {
	      Class[key] = module.static[key];
	    });
	  }
	  // Callback
	  if (module.install) {
	    module.install.apply(Class, params);
	  }
	  return Class;
	};
	SwiperClass.use = function use (module) {
	    var params = [], len = arguments.length - 1;
	    while ( len-- > 0 ) params[ len ] = arguments[ len + 1 ];
	
	  var Class = this;
	  if (Array.isArray(module)) {
	    module.forEach(function (m) { return Class.installModule(m); });
	    return Class;
	  }
	  return Class.installModule.apply(Class, [ module ].concat( params ));
	};
	
	Object.defineProperties( SwiperClass, staticAccessors );
	
	var updateSize = function () {
	  var swiper = this;
	  var width;
	  var height;
	  var $el = swiper.$el;
	  if (typeof swiper.params.width !== 'undefined') {
	    width = swiper.params.width;
	  } else {
	    width = $el[0].clientWidth;
	  }
	  if (typeof swiper.params.height !== 'undefined') {
	    height = swiper.params.height;
	  } else {
	    height = $el[0].clientHeight;
	  }
	  if ((width === 0 && swiper.isHorizontal()) || (height === 0 && swiper.isVertical())) {
	    return;
	  }
	
	  // Subtract paddings
	  width = width - parseInt($el.css('padding-left'), 10) - parseInt($el.css('padding-right'), 10);
	  height = height - parseInt($el.css('padding-top'), 10) - parseInt($el.css('padding-bottom'), 10);
	
	  Utils.extend(swiper, {
	    width: width,
	    height: height,
	    size: swiper.isHorizontal() ? width : height,
	  });
	};
	
	var updateSlides = function () {
	  var swiper = this;
	  var params = swiper.params;
	
	  var $wrapperEl = swiper.$wrapperEl;
	  var swiperSize = swiper.size;
	  var rtl = swiper.rtl;
	  var wrongRTL = swiper.wrongRTL;
	  var slides = $wrapperEl.children(("." + (swiper.params.slideClass)));
	  var isVirtual = swiper.virtual && params.virtual.enabled;
	  var slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
	  var snapGrid = [];
	  var slidesGrid = [];
	  var slidesSizesGrid = [];
	
	  var offsetBefore = params.slidesOffsetBefore;
	  if (typeof offsetBefore === 'function') {
	    offsetBefore = params.slidesOffsetBefore.call(swiper);
	  }
	
	  var offsetAfter = params.slidesOffsetAfter;
	  if (typeof offsetAfter === 'function') {
	    offsetAfter = params.slidesOffsetAfter.call(swiper);
	  }
	
	  var previousSlidesLength = slidesLength;
	  var previousSnapGridLength = swiper.snapGrid.length;
	  var previousSlidesGridLength = swiper.snapGrid.length;
	
	  var spaceBetween = params.spaceBetween;
	  var slidePosition = -offsetBefore;
	  var prevSlideSize = 0;
	  var index = 0;
	  if (typeof swiperSize === 'undefined') {
	    return;
	  }
	  if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
	    spaceBetween = (parseFloat(spaceBetween.replace('%', '')) / 100) * swiperSize;
	  }
	
	  swiper.virtualSize = -spaceBetween;
	
	  // reset margins
	  if (rtl) { slides.css({ marginLeft: '', marginTop: '' }); }
	  else { slides.css({ marginRight: '', marginBottom: '' }); }
	
	  var slidesNumberEvenToRows;
	  if (params.slidesPerColumn > 1) {
	    if (Math.floor(slidesLength / params.slidesPerColumn) === slidesLength / swiper.params.slidesPerColumn) {
	      slidesNumberEvenToRows = slidesLength;
	    } else {
	      slidesNumberEvenToRows = Math.ceil(slidesLength / params.slidesPerColumn) * params.slidesPerColumn;
	    }
	    if (params.slidesPerView !== 'auto' && params.slidesPerColumnFill === 'row') {
	      slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, params.slidesPerView * params.slidesPerColumn);
	    }
	  }
	
	  // Calc slides
	  var slideSize;
	  var slidesPerColumn = params.slidesPerColumn;
	  var slidesPerRow = slidesNumberEvenToRows / slidesPerColumn;
	  var numFullColumns = slidesPerRow - ((params.slidesPerColumn * slidesPerRow) - slidesLength);
	  for (var i = 0; i < slidesLength; i += 1) {
	    slideSize = 0;
	    var slide = slides.eq(i);
	    if (params.slidesPerColumn > 1) {
	      // Set slides order
	      var newSlideOrderIndex = (void 0);
	      var column = (void 0);
	      var row = (void 0);
	      if (params.slidesPerColumnFill === 'column') {
	        column = Math.floor(i / slidesPerColumn);
	        row = i - (column * slidesPerColumn);
	        if (column > numFullColumns || (column === numFullColumns && row === slidesPerColumn - 1)) {
	          row += 1;
	          if (row >= slidesPerColumn) {
	            row = 0;
	            column += 1;
	          }
	        }
	        newSlideOrderIndex = column + ((row * slidesNumberEvenToRows) / slidesPerColumn);
	        slide
	          .css({
	            '-webkit-box-ordinal-group': newSlideOrderIndex,
	            '-moz-box-ordinal-group': newSlideOrderIndex,
	            '-ms-flex-order': newSlideOrderIndex,
	            '-webkit-order': newSlideOrderIndex,
	            order: newSlideOrderIndex,
	          });
	      } else {
	        row = Math.floor(i / slidesPerRow);
	        column = i - (row * slidesPerRow);
	      }
	      slide
	        .css(
	          ("margin-" + (swiper.isHorizontal() ? 'top' : 'left')),
	          (row !== 0 && params.spaceBetween) && (((params.spaceBetween) + "px"))
	        )
	        .attr('data-swiper-column', column)
	        .attr('data-swiper-row', row);
	    }
	    if (slide.css('display') === 'none') { continue; } // eslint-disable-line
	    if (params.slidesPerView === 'auto') {
	      slideSize = swiper.isHorizontal() ? slide.outerWidth(true) : slide.outerHeight(true);
	      if (params.roundLengths) { slideSize = Math.floor(slideSize); }
	    } else {
	      slideSize = (swiperSize - ((params.slidesPerView - 1) * spaceBetween)) / params.slidesPerView;
	      if (params.roundLengths) { slideSize = Math.floor(slideSize); }
	
	      if (slides[i]) {
	        if (swiper.isHorizontal()) {
	          slides[i].style.width = slideSize + "px";
	        } else {
	          slides[i].style.height = slideSize + "px";
	        }
	      }
	    }
	    if (slides[i]) {
	      slides[i].swiperSlideSize = slideSize;
	    }
	    slidesSizesGrid.push(slideSize);
	
	
	    if (params.centeredSlides) {
	      slidePosition = slidePosition + (slideSize / 2) + (prevSlideSize / 2) + spaceBetween;
	      if (prevSlideSize === 0 && i !== 0) { slidePosition = slidePosition - (swiperSize / 2) - spaceBetween; }
	      if (i === 0) { slidePosition = slidePosition - (swiperSize / 2) - spaceBetween; }
	      if (Math.abs(slidePosition) < 1 / 1000) { slidePosition = 0; }
	      if ((index) % params.slidesPerGroup === 0) { snapGrid.push(slidePosition); }
	      slidesGrid.push(slidePosition);
	    } else {
	      if ((index) % params.slidesPerGroup === 0) { snapGrid.push(slidePosition); }
	      slidesGrid.push(slidePosition);
	      slidePosition = slidePosition + slideSize + spaceBetween;
	    }
	
	    swiper.virtualSize += slideSize + spaceBetween;
	
	    prevSlideSize = slideSize;
	
	    index += 1;
	  }
	  swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
	  var newSlidesGrid;
	
	  if (
	    rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
	    $wrapperEl.css({ width: ((swiper.virtualSize + params.spaceBetween) + "px") });
	  }
	  if (!Support.flexbox || params.setWrapperSize) {
	    if (swiper.isHorizontal()) { $wrapperEl.css({ width: ((swiper.virtualSize + params.spaceBetween) + "px") }); }
	    else { $wrapperEl.css({ height: ((swiper.virtualSize + params.spaceBetween) + "px") }); }
	  }
	
	  if (params.slidesPerColumn > 1) {
	    swiper.virtualSize = (slideSize + params.spaceBetween) * slidesNumberEvenToRows;
	    swiper.virtualSize = Math.ceil(swiper.virtualSize / params.slidesPerColumn) - params.spaceBetween;
	    if (swiper.isHorizontal()) { $wrapperEl.css({ width: ((swiper.virtualSize + params.spaceBetween) + "px") }); }
	    else { $wrapperEl.css({ height: ((swiper.virtualSize + params.spaceBetween) + "px") }); }
	    if (params.centeredSlides) {
	      newSlidesGrid = [];
	      for (var i$1 = 0; i$1 < snapGrid.length; i$1 += 1) {
	        if (snapGrid[i$1] < swiper.virtualSize + snapGrid[0]) { newSlidesGrid.push(snapGrid[i$1]); }
	      }
	      snapGrid = newSlidesGrid;
	    }
	  }
	
	  // Remove last grid elements depending on width
	  if (!params.centeredSlides) {
	    newSlidesGrid = [];
	    for (var i$2 = 0; i$2 < snapGrid.length; i$2 += 1) {
	      if (snapGrid[i$2] <= swiper.virtualSize - swiperSize) {
	        newSlidesGrid.push(snapGrid[i$2]);
	      }
	    }
	    snapGrid = newSlidesGrid;
	    if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
	      snapGrid.push(swiper.virtualSize - swiperSize);
	    }
	  }
	  if (snapGrid.length === 0) { snapGrid = [0]; }
	
	  if (params.spaceBetween !== 0) {
	    if (swiper.isHorizontal()) {
	      if (rtl) { slides.css({ marginLeft: (spaceBetween + "px") }); }
	      else { slides.css({ marginRight: (spaceBetween + "px") }); }
	    } else { slides.css({ marginBottom: (spaceBetween + "px") }); }
	  }
	
	  Utils.extend(swiper, {
	    slides: slides,
	    snapGrid: snapGrid,
	    slidesGrid: slidesGrid,
	    slidesSizesGrid: slidesSizesGrid,
	  });
	
	  if (slidesLength !== previousSlidesLength) {
	    swiper.emit('slidesLengthChange');
	  }
	  if (snapGrid.length !== previousSnapGridLength) {
	    if (swiper.params.watchOverflow) { swiper.checkOverflow(); }
	    swiper.emit('snapGridLengthChange');
	  }
	  if (slidesGrid.length !== previousSlidesGridLength) {
	    swiper.emit('slidesGridLengthChange');
	  }
	
	  if (params.watchSlidesProgress || params.watchSlidesVisibility) {
	    swiper.updateSlidesOffset();
	  }
	};
	
	var updateAutoHeight = function () {
	  var swiper = this;
	  var activeSlides = [];
	  var newHeight = 0;
	  var i;
	
	  // Find slides currently in view
	  if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
	    for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
	      var index = swiper.activeIndex + i;
	      if (index > swiper.slides.length) { break; }
	      activeSlides.push(swiper.slides.eq(index)[0]);
	    }
	  } else {
	    activeSlides.push(swiper.slides.eq(swiper.activeIndex)[0]);
	  }
	
	  // Find new height from highest slide in view
	  for (i = 0; i < activeSlides.length; i += 1) {
	    if (typeof activeSlides[i] !== 'undefined') {
	      var height = activeSlides[i].offsetHeight;
	      newHeight = height > newHeight ? height : newHeight;
	    }
	  }
	
	  // Update Height
	  if (newHeight) { swiper.$wrapperEl.css('height', (newHeight + "px")); }
	};
	
	var updateSlidesOffset = function () {
	  var swiper = this;
	  var slides = swiper.slides;
	  for (var i = 0; i < slides.length; i += 1) {
	    slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
	  }
	};
	
	var updateSlidesProgress = function (translate) {
	  if ( translate === void 0 ) translate = this.translate || 0;
	
	  var swiper = this;
	  var params = swiper.params;
	
	  var slides = swiper.slides;
	  var rtl = swiper.rtl;
	
	  if (slides.length === 0) { return; }
	  if (typeof slides[0].swiperSlideOffset === 'undefined') { swiper.updateSlidesOffset(); }
	
	  var offsetCenter = -translate;
	  if (rtl) { offsetCenter = translate; }
	
	  // Visible Slides
	  slides.removeClass(params.slideVisibleClass);
	
	  for (var i = 0; i < slides.length; i += 1) {
	    var slide = slides[i];
	    var slideProgress =
	      (
	        (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0)) - slide.swiperSlideOffset
	      ) / (slide.swiperSlideSize + params.spaceBetween);
	    if (params.watchSlidesVisibility) {
	      var slideBefore = -(offsetCenter - slide.swiperSlideOffset);
	      var slideAfter = slideBefore + swiper.slidesSizesGrid[i];
	      var isVisible =
	                (slideBefore >= 0 && slideBefore < swiper.size) ||
	                (slideAfter > 0 && slideAfter <= swiper.size) ||
	                (slideBefore <= 0 && slideAfter >= swiper.size);
	      if (isVisible) {
	        slides.eq(i).addClass(params.slideVisibleClass);
	      }
	    }
	    slide.progress = rtl ? -slideProgress : slideProgress;
	  }
	};
	
	var updateProgress = function (translate) {
	  if ( translate === void 0 ) translate = this.translate || 0;
	
	  var swiper = this;
	  var params = swiper.params;
	
	  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
	  var progress = swiper.progress;
	  var isBeginning = swiper.isBeginning;
	  var isEnd = swiper.isEnd;
	  var wasBeginning = isBeginning;
	  var wasEnd = isEnd;
	  if (translatesDiff === 0) {
	    progress = 0;
	    isBeginning = true;
	    isEnd = true;
	  } else {
	    progress = (translate - swiper.minTranslate()) / (translatesDiff);
	    isBeginning = progress <= 0;
	    isEnd = progress >= 1;
	  }
	  Utils.extend(swiper, {
	    progress: progress,
	    isBeginning: isBeginning,
	    isEnd: isEnd,
	  });
	
	  if (params.watchSlidesProgress || params.watchSlidesVisibility) { swiper.updateSlidesProgress(translate); }
	
	  if (isBeginning && !wasBeginning) {
	    swiper.emit('reachBeginning toEdge');
	  }
	  if (isEnd && !wasEnd) {
	    swiper.emit('reachEnd toEdge');
	  }
	  if ((wasBeginning && !isBeginning) || (wasEnd && !isEnd)) {
	    swiper.emit('fromEdge');
	  }
	
	  swiper.emit('progress', progress);
	};
	
	var updateSlidesClasses = function () {
	  var swiper = this;
	
	  var slides = swiper.slides;
	  var params = swiper.params;
	  var $wrapperEl = swiper.$wrapperEl;
	  var activeIndex = swiper.activeIndex;
	  var realIndex = swiper.realIndex;
	  var isVirtual = swiper.virtual && params.virtual.enabled;
	
	  slides.removeClass(((params.slideActiveClass) + " " + (params.slideNextClass) + " " + (params.slidePrevClass) + " " + (params.slideDuplicateActiveClass) + " " + (params.slideDuplicateNextClass) + " " + (params.slideDuplicatePrevClass)));
	
	  var activeSlide;
	  if (isVirtual) {
	    activeSlide = swiper.$wrapperEl.find(("." + (params.slideClass) + "[data-swiper-slide-index=\"" + activeIndex + "\"]"));
	  } else {
	    activeSlide = slides.eq(activeIndex);
	  }
	
	  // Active classes
	  activeSlide.addClass(params.slideActiveClass);
	
	  if (params.loop) {
	    // Duplicate to all looped slides
	    if (activeSlide.hasClass(params.slideDuplicateClass)) {
	      $wrapperEl
	        .children(("." + (params.slideClass) + ":not(." + (params.slideDuplicateClass) + ")[data-swiper-slide-index=\"" + realIndex + "\"]"))
	        .addClass(params.slideDuplicateActiveClass);
	    } else {
	      $wrapperEl
	        .children(("." + (params.slideClass) + "." + (params.slideDuplicateClass) + "[data-swiper-slide-index=\"" + realIndex + "\"]"))
	        .addClass(params.slideDuplicateActiveClass);
	    }
	  }
	  // Next Slide
	  var nextSlide = activeSlide.nextAll(("." + (params.slideClass))).eq(0).addClass(params.slideNextClass);
	  if (params.loop && nextSlide.length === 0) {
	    nextSlide = slides.eq(0);
	    nextSlide.addClass(params.slideNextClass);
	  }
	  // Prev Slide
	  var prevSlide = activeSlide.prevAll(("." + (params.slideClass))).eq(0).addClass(params.slidePrevClass);
	  if (params.loop && prevSlide.length === 0) {
	    prevSlide = slides.eq(-1);
	    prevSlide.addClass(params.slidePrevClass);
	  }
	  if (params.loop) {
	    // Duplicate to all looped slides
	    if (nextSlide.hasClass(params.slideDuplicateClass)) {
	      $wrapperEl
	        .children(("." + (params.slideClass) + ":not(." + (params.slideDuplicateClass) + ")[data-swiper-slide-index=\"" + (nextSlide.attr('data-swiper-slide-index')) + "\"]"))
	        .addClass(params.slideDuplicateNextClass);
	    } else {
	      $wrapperEl
	        .children(("." + (params.slideClass) + "." + (params.slideDuplicateClass) + "[data-swiper-slide-index=\"" + (nextSlide.attr('data-swiper-slide-index')) + "\"]"))
	        .addClass(params.slideDuplicateNextClass);
	    }
	    if (prevSlide.hasClass(params.slideDuplicateClass)) {
	      $wrapperEl
	        .children(("." + (params.slideClass) + ":not(." + (params.slideDuplicateClass) + ")[data-swiper-slide-index=\"" + (prevSlide.attr('data-swiper-slide-index')) + "\"]"))
	        .addClass(params.slideDuplicatePrevClass);
	    } else {
	      $wrapperEl
	        .children(("." + (params.slideClass) + "." + (params.slideDuplicateClass) + "[data-swiper-slide-index=\"" + (prevSlide.attr('data-swiper-slide-index')) + "\"]"))
	        .addClass(params.slideDuplicatePrevClass);
	    }
	  }
	};
	
	var updateActiveIndex = function (newActiveIndex) {
	  var swiper = this;
	  var translate = swiper.rtl ? swiper.translate : -swiper.translate;
	  var slidesGrid = swiper.slidesGrid;
	  var snapGrid = swiper.snapGrid;
	  var params = swiper.params;
	  var previousIndex = swiper.activeIndex;
	  var previousRealIndex = swiper.realIndex;
	  var previousSnapIndex = swiper.snapIndex;
	  var activeIndex = newActiveIndex;
	  var snapIndex;
	  if (typeof activeIndex === 'undefined') {
	    for (var i = 0; i < slidesGrid.length; i += 1) {
	      if (typeof slidesGrid[i + 1] !== 'undefined') {
	        if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - ((slidesGrid[i + 1] - slidesGrid[i]) / 2)) {
	          activeIndex = i;
	        } else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
	          activeIndex = i + 1;
	        }
	      } else if (translate >= slidesGrid[i]) {
	        activeIndex = i;
	      }
	    }
	    // Normalize slideIndex
	    if (params.normalizeSlideIndex) {
	      if (activeIndex < 0 || typeof activeIndex === 'undefined') { activeIndex = 0; }
	    }
	  }
	  if (snapGrid.indexOf(translate) >= 0) {
	    snapIndex = snapGrid.indexOf(translate);
	  } else {
	    snapIndex = Math.floor(activeIndex / params.slidesPerGroup);
	  }
	  if (snapIndex >= snapGrid.length) { snapIndex = snapGrid.length - 1; }
	  if (activeIndex === previousIndex) {
	    if (snapIndex !== previousSnapIndex) {
	      swiper.snapIndex = snapIndex;
	      swiper.emit('snapIndexChange');
	    }
	    return;
	  }
	
	  // Get real index
	  var realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);
	
	  Utils.extend(swiper, {
	    snapIndex: snapIndex,
	    realIndex: realIndex,
	    previousIndex: previousIndex,
	    activeIndex: activeIndex,
	  });
	  swiper.emit('activeIndexChange');
	  swiper.emit('snapIndexChange');
	  if (previousRealIndex !== realIndex) {
	    swiper.emit('realIndexChange');
	  }
	  swiper.emit('slideChange');
	};
	
	var updateClickedSlide = function (e) {
	  var swiper = this;
	  var params = swiper.params;
	  var slide = $$1(e.target).closest(("." + (params.slideClass)))[0];
	  var slideFound = false;
	  if (slide) {
	    for (var i = 0; i < swiper.slides.length; i += 1) {
	      if (swiper.slides[i] === slide) { slideFound = true; }
	    }
	  }
	
	  if (slide && slideFound) {
	    swiper.clickedSlide = slide;
	    if (swiper.virtual && swiper.params.virtual.enabled) {
	      swiper.clickedIndex = parseInt($$1(slide).attr('data-swiper-slide-index'), 10);
	    } else {
	      swiper.clickedIndex = $$1(slide).index();
	    }
	  } else {
	    swiper.clickedSlide = undefined;
	    swiper.clickedIndex = undefined;
	    return;
	  }
	  if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
	    swiper.slideToClickedSlide();
	  }
	};
	
	var update = {
	  updateSize: updateSize,
	  updateSlides: updateSlides,
	  updateAutoHeight: updateAutoHeight,
	  updateSlidesOffset: updateSlidesOffset,
	  updateSlidesProgress: updateSlidesProgress,
	  updateProgress: updateProgress,
	  updateSlidesClasses: updateSlidesClasses,
	  updateActiveIndex: updateActiveIndex,
	  updateClickedSlide: updateClickedSlide,
	};
	
	var getTranslate = function (axis) {
	  if ( axis === void 0 ) axis = this.isHorizontal() ? 'x' : 'y';
	
	  var swiper = this;
	
	  var params = swiper.params;
	  var rtl = swiper.rtl;
	  var translate = swiper.translate;
	  var $wrapperEl = swiper.$wrapperEl;
	
	  if (params.virtualTranslate) {
	    return rtl ? -translate : translate;
	  }
	
	  var currentTranslate = Utils.getTranslate($wrapperEl[0], axis);
	  if (rtl) { currentTranslate = -currentTranslate; }
	
	  return currentTranslate || 0;
	};
	
	var setTranslate = function (translate, byController) {
	  var swiper = this;
	  var rtl = swiper.rtl;
	  var params = swiper.params;
	  var $wrapperEl = swiper.$wrapperEl;
	  var progress = swiper.progress;
	  var x = 0;
	  var y = 0;
	  var z = 0;
	
	  if (swiper.isHorizontal()) {
	    x = rtl ? -translate : translate;
	  } else {
	    y = translate;
	  }
	
	  if (params.roundLengths) {
	    x = Math.floor(x);
	    y = Math.floor(y);
	  }
	
	  if (!params.virtualTranslate) {
	    if (Support.transforms3d) { $wrapperEl.transform(("translate3d(" + x + "px, " + y + "px, " + z + "px)")); }
	    else { $wrapperEl.transform(("translate(" + x + "px, " + y + "px)")); }
	  }
	
	  swiper.translate = swiper.isHorizontal() ? x : y;
	
	  // Check if we need to update progress
	  var newProgress;
	  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
	  if (translatesDiff === 0) {
	    newProgress = 0;
	  } else {
	    newProgress = (translate - swiper.minTranslate()) / (translatesDiff);
	  }
	  if (newProgress !== progress) {
	    swiper.updateProgress(translate);
	  }
	
	  swiper.emit('setTranslate', swiper.translate, byController);
	};
	
	var minTranslate = function () {
	  return (-this.snapGrid[0]);
	};
	
	var maxTranslate = function () {
	  return (-this.snapGrid[this.snapGrid.length - 1]);
	};
	
	var translate = {
	  getTranslate: getTranslate,
	  setTranslate: setTranslate,
	  minTranslate: minTranslate,
	  maxTranslate: maxTranslate,
	};
	
	var setTransition = function (duration, byController) {
	  var swiper = this;
	
	  swiper.$wrapperEl.transition(duration);
	
	  swiper.emit('setTransition', duration, byController);
	};
	
	var transitionStart = function (runCallbacks) {
	  if ( runCallbacks === void 0 ) runCallbacks = true;
	
	  var swiper = this;
	  var activeIndex = swiper.activeIndex;
	  var params = swiper.params;
	  var previousIndex = swiper.previousIndex;
	  if (params.autoHeight) {
	    swiper.updateAutoHeight();
	  }
	  swiper.emit('transitionStart');
	
	  if (!runCallbacks) { return; }
	  if (activeIndex !== previousIndex) {
	    swiper.emit('slideChangeTransitionStart');
	    if (activeIndex > previousIndex) {
	      swiper.emit('slideNextTransitionStart');
	    } else {
	      swiper.emit('slidePrevTransitionStart');
	    }
	  }
	};
	
	var transitionEnd$1 = function (runCallbacks) {
	  if ( runCallbacks === void 0 ) runCallbacks = true;
	
	  var swiper = this;
	  var activeIndex = swiper.activeIndex;
	  var previousIndex = swiper.previousIndex;
	  swiper.animating = false;
	  swiper.setTransition(0);
	
	  swiper.emit('transitionEnd');
	  if (runCallbacks) {
	    if (activeIndex !== previousIndex) {
	      swiper.emit('slideChangeTransitionEnd');
	      if (activeIndex > previousIndex) {
	        swiper.emit('slideNextTransitionEnd');
	      } else {
	        swiper.emit('slidePrevTransitionEnd');
	      }
	    }
	  }
	};
	
	var transition$1 = {
	  setTransition: setTransition,
	  transitionStart: transitionStart,
	  transitionEnd: transitionEnd$1,
	};
	
	var slideTo = function (index, speed, runCallbacks, internal) {
	  if ( index === void 0 ) index = 0;
	  if ( speed === void 0 ) speed = this.params.speed;
	  if ( runCallbacks === void 0 ) runCallbacks = true;
	
	  var swiper = this;
	  var slideIndex = index;
	  if (slideIndex < 0) { slideIndex = 0; }
	
	  var params = swiper.params;
	  var snapGrid = swiper.snapGrid;
	  var slidesGrid = swiper.slidesGrid;
	  var previousIndex = swiper.previousIndex;
	  var activeIndex = swiper.activeIndex;
	  var rtl = swiper.rtl;
	  var $wrapperEl = swiper.$wrapperEl;
	
	  var snapIndex = Math.floor(slideIndex / params.slidesPerGroup);
	  if (snapIndex >= snapGrid.length) { snapIndex = snapGrid.length - 1; }
	
	  if ((activeIndex || params.initialSlide || 0) === (previousIndex || 0) && runCallbacks) {
	    swiper.emit('beforeSlideChangeStart');
	  }
	
	  var translate = -snapGrid[snapIndex];
	
	  // Update progress
	  swiper.updateProgress(translate);
	
	  // Normalize slideIndex
	  if (params.normalizeSlideIndex) {
	    for (var i = 0; i < slidesGrid.length; i += 1) {
	      if (-Math.floor(translate * 100) >= Math.floor(slidesGrid[i] * 100)) {
	        slideIndex = i;
	      }
	    }
	  }
	
	  // Directions locks
	  if (swiper.initialized) {
	    if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) {
	      return false;
	    }
	    if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
	      if ((activeIndex || 0) !== slideIndex) { return false; }
	    }
	  }
	
	  // Update Index
	  if ((rtl && -translate === swiper.translate) || (!rtl && translate === swiper.translate)) {
	    swiper.updateActiveIndex(slideIndex);
	    // Update Height
	    if (params.autoHeight) {
	      swiper.updateAutoHeight();
	    }
	    swiper.updateSlidesClasses();
	    if (params.effect !== 'slide') {
	      swiper.setTranslate(translate);
	    }
	    return false;
	  }
	
	  if (speed === 0 || !Support.transition) {
	    swiper.setTransition(0);
	    swiper.setTranslate(translate);
	    swiper.updateActiveIndex(slideIndex);
	    swiper.updateSlidesClasses();
	    swiper.emit('beforeTransitionStart', speed, internal);
	    swiper.transitionStart(runCallbacks);
	    swiper.transitionEnd(runCallbacks);
	  } else {
	    swiper.setTransition(speed);
	    swiper.setTranslate(translate);
	    swiper.updateActiveIndex(slideIndex);
	    swiper.updateSlidesClasses();
	    swiper.emit('beforeTransitionStart', speed, internal);
	    swiper.transitionStart(runCallbacks);
	    if (!swiper.animating) {
	      swiper.animating = true;
	      $wrapperEl.transitionEnd(function () {
	        if (!swiper || swiper.destroyed) { return; }
	        swiper.transitionEnd(runCallbacks);
	      });
	    }
	  }
	
	  return true;
	};
	
	/* eslint no-unused-vars: "off" */
	var slideNext = function (speed, runCallbacks, internal) {
	  if ( speed === void 0 ) speed = this.params.speed;
	  if ( runCallbacks === void 0 ) runCallbacks = true;
	
	  var swiper = this;
	  var params = swiper.params;
	  var animating = swiper.animating;
	  if (params.loop) {
	    if (animating) { return false; }
	    swiper.loopFix();
	    // eslint-disable-next-line
	    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
	    return swiper.slideTo(swiper.activeIndex + params.slidesPerGroup, speed, runCallbacks, internal);
	  }
	  return swiper.slideTo(swiper.activeIndex + params.slidesPerGroup, speed, runCallbacks, internal);
	};
	
	/* eslint no-unused-vars: "off" */
	var slidePrev = function (speed, runCallbacks, internal) {
	  if ( speed === void 0 ) speed = this.params.speed;
	  if ( runCallbacks === void 0 ) runCallbacks = true;
	
	  var swiper = this;
	  var params = swiper.params;
	  var animating = swiper.animating;
	
	  if (params.loop) {
	    if (animating) { return false; }
	    swiper.loopFix();
	    // eslint-disable-next-line
	    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
	    return swiper.slideTo(swiper.activeIndex - 1, speed, runCallbacks, internal);
	  }
	  return swiper.slideTo(swiper.activeIndex - 1, speed, runCallbacks, internal);
	};
	
	/* eslint no-unused-vars: "off" */
	var slideReset = function (speed, runCallbacks, internal) {
	  if ( speed === void 0 ) speed = this.params.speed;
	  if ( runCallbacks === void 0 ) runCallbacks = true;
	
	  var swiper = this;
	  return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
	};
	
	var slideToClickedSlide = function () {
	  var swiper = this;
	  var params = swiper.params;
	  var $wrapperEl = swiper.$wrapperEl;
	
	  var slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
	  var slideToIndex = swiper.clickedIndex;
	  var realIndex;
	  if (params.loop) {
	    if (swiper.animating) { return; }
	    realIndex = parseInt($$1(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);
	    if (params.centeredSlides) {
	      if (
	        (slideToIndex < swiper.loopedSlides - (slidesPerView / 2)) ||
	        (slideToIndex > (swiper.slides.length - swiper.loopedSlides) + (slidesPerView / 2))
	      ) {
	        swiper.loopFix();
	        slideToIndex = $wrapperEl
	          .children(("." + (params.slideClass) + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + (params.slideDuplicateClass) + ")"))
	          .eq(0)
	          .index();
	
	        Utils.nextTick(function () {
	          swiper.slideTo(slideToIndex);
	        });
	      } else {
	        swiper.slideTo(slideToIndex);
	      }
	    } else if (slideToIndex > swiper.slides.length - slidesPerView) {
	      swiper.loopFix();
	      slideToIndex = $wrapperEl
	        .children(("." + (params.slideClass) + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + (params.slideDuplicateClass) + ")"))
	        .eq(0)
	        .index();
	
	      Utils.nextTick(function () {
	        swiper.slideTo(slideToIndex);
	      });
	    } else {
	      swiper.slideTo(slideToIndex);
	    }
	  } else {
	    swiper.slideTo(slideToIndex);
	  }
	};
	
	var slide = {
	  slideTo: slideTo,
	  slideNext: slideNext,
	  slidePrev: slidePrev,
	  slideReset: slideReset,
	  slideToClickedSlide: slideToClickedSlide,
	};
	
	var loopCreate = function () {
	  var swiper = this;
	  var params = swiper.params;
	  var $wrapperEl = swiper.$wrapperEl;
	  // Remove duplicated slides
	  $wrapperEl.children(("." + (params.slideClass) + "." + (params.slideDuplicateClass))).remove();
	
	  var slides = $wrapperEl.children(("." + (params.slideClass)));
	
	  if (params.loopFillGroupWithBlank) {
	    var blankSlidesNum = params.slidesPerGroup - (slides.length % params.slidesPerGroup);
	    if (blankSlidesNum !== params.slidesPerGroup) {
	      for (var i = 0; i < blankSlidesNum; i += 1) {
	        var blankNode = $$1(doc.createElement('div')).addClass(((params.slideClass) + " " + (params.slideBlankClass)));
	        $wrapperEl.append(blankNode);
	      }
	      slides = $wrapperEl.children(("." + (params.slideClass)));
	    }
	  }
	
	  if (params.slidesPerView === 'auto' && !params.loopedSlides) { params.loopedSlides = slides.length; }
	
	  swiper.loopedSlides = parseInt(params.loopedSlides || params.slidesPerView, 10);
	  swiper.loopedSlides += params.loopAdditionalSlides;
	  if (swiper.loopedSlides > slides.length) {
	    swiper.loopedSlides = slides.length;
	  }
	
	  var prependSlides = [];
	  var appendSlides = [];
	  slides.each(function (index, el) {
	    var slide = $$1(el);
	    if (index < swiper.loopedSlides) { appendSlides.push(el); }
	    if (index < slides.length && index >= slides.length - swiper.loopedSlides) { prependSlides.push(el); }
	    slide.attr('data-swiper-slide-index', index);
	  });
	  for (var i$1 = 0; i$1 < appendSlides.length; i$1 += 1) {
	    $wrapperEl.append($$1(appendSlides[i$1].cloneNode(true)).addClass(params.slideDuplicateClass));
	  }
	  for (var i$2 = prependSlides.length - 1; i$2 >= 0; i$2 -= 1) {
	    $wrapperEl.prepend($$1(prependSlides[i$2].cloneNode(true)).addClass(params.slideDuplicateClass));
	  }
	};
	
	var loopFix = function () {
	  var swiper = this;
	  var params = swiper.params;
	  var activeIndex = swiper.activeIndex;
	  var slides = swiper.slides;
	  var loopedSlides = swiper.loopedSlides;
	  var allowSlidePrev = swiper.allowSlidePrev;
	  var allowSlideNext = swiper.allowSlideNext;
	  var newIndex;
	  swiper.allowSlidePrev = true;
	  swiper.allowSlideNext = true;
	  // Fix For Negative Oversliding
	  if (activeIndex < loopedSlides) {
	    newIndex = (slides.length - (loopedSlides * 3)) + activeIndex;
	    newIndex += loopedSlides;
	    swiper.slideTo(newIndex, 0, false, true);
	  } else if ((params.slidesPerView === 'auto' && activeIndex >= loopedSlides * 2) || (activeIndex > slides.length - (params.slidesPerView * 2))) {
	    // Fix For Positive Oversliding
	    newIndex = -slides.length + activeIndex + loopedSlides;
	    newIndex += loopedSlides;
	    swiper.slideTo(newIndex, 0, false, true);
	  }
	  swiper.allowSlidePrev = allowSlidePrev;
	  swiper.allowSlideNext = allowSlideNext;
	};
	
	var loopDestroy = function () {
	  var swiper = this;
	  var $wrapperEl = swiper.$wrapperEl;
	  var params = swiper.params;
	  var slides = swiper.slides;
	  $wrapperEl.children(("." + (params.slideClass) + "." + (params.slideDuplicateClass))).remove();
	  slides.removeAttr('data-swiper-slide-index');
	};
	
	var loop = {
	  loopCreate: loopCreate,
	  loopFix: loopFix,
	  loopDestroy: loopDestroy,
	};
	
	var setGrabCursor = function (moving) {
	  var swiper = this;
	  if (Support.touch || !swiper.params.simulateTouch) { return; }
	  var el = swiper.el;
	  el.style.cursor = 'move';
	  el.style.cursor = moving ? '-webkit-grabbing' : '-webkit-grab';
	  el.style.cursor = moving ? '-moz-grabbin' : '-moz-grab';
	  el.style.cursor = moving ? 'grabbing' : 'grab';
	};
	
	var unsetGrabCursor = function () {
	  var swiper = this;
	  if (Support.touch) { return; }
	  swiper.el.style.cursor = '';
	};
	
	var grabCursor = {
	  setGrabCursor: setGrabCursor,
	  unsetGrabCursor: unsetGrabCursor,
	};
	
	var appendSlide = function (slides) {
	  var swiper = this;
	  var $wrapperEl = swiper.$wrapperEl;
	  var params = swiper.params;
	  if (params.loop) {
	    swiper.loopDestroy();
	  }
	  if (typeof slides === 'object' && 'length' in slides) {
	    for (var i = 0; i < slides.length; i += 1) {
	      if (slides[i]) { $wrapperEl.append(slides[i]); }
	    }
	  } else {
	    $wrapperEl.append(slides);
	  }
	  if (params.loop) {
	    swiper.loopCreate();
	  }
	  if (!(params.observer && Support.observer)) {
	    swiper.update();
	  }
	};
	
	var prependSlide = function (slides) {
	  var swiper = this;
	  var params = swiper.params;
	  var $wrapperEl = swiper.$wrapperEl;
	  var activeIndex = swiper.activeIndex;
	
	  if (params.loop) {
	    swiper.loopDestroy();
	  }
	  var newActiveIndex = activeIndex + 1;
	  if (typeof slides === 'object' && 'length' in slides) {
	    for (var i = 0; i < slides.length; i += 1) {
	      if (slides[i]) { $wrapperEl.prepend(slides[i]); }
	    }
	    newActiveIndex = activeIndex + slides.length;
	  } else {
	    $wrapperEl.prepend(slides);
	  }
	  if (params.loop) {
	    swiper.loopCreate();
	  }
	  if (!(params.observer && Support.observer)) {
	    swiper.update();
	  }
	  swiper.slideTo(newActiveIndex, 0, false);
	};
	
	var removeSlide = function (slidesIndexes) {
	  var swiper = this;
	  var params = swiper.params;
	  var $wrapperEl = swiper.$wrapperEl;
	  var activeIndex = swiper.activeIndex;
	
	  if (params.loop) {
	    swiper.loopDestroy();
	    swiper.slides = $wrapperEl.children(("." + (params.slideClass)));
	  }
	  var newActiveIndex = activeIndex;
	  var indexToRemove;
	
	  if (typeof slidesIndexes === 'object' && 'length' in slidesIndexes) {
	    for (var i = 0; i < slidesIndexes.length; i += 1) {
	      indexToRemove = slidesIndexes[i];
	      if (swiper.slides[indexToRemove]) { swiper.slides.eq(indexToRemove).remove(); }
	      if (indexToRemove < newActiveIndex) { newActiveIndex -= 1; }
	    }
	    newActiveIndex = Math.max(newActiveIndex, 0);
	  } else {
	    indexToRemove = slidesIndexes;
	    if (swiper.slides[indexToRemove]) { swiper.slides.eq(indexToRemove).remove(); }
	    if (indexToRemove < newActiveIndex) { newActiveIndex -= 1; }
	    newActiveIndex = Math.max(newActiveIndex, 0);
	  }
	
	  if (params.loop) {
	    swiper.loopCreate();
	  }
	
	  if (!(params.observer && Support.observer)) {
	    swiper.update();
	  }
	  if (params.loop) {
	    swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
	  } else {
	    swiper.slideTo(newActiveIndex, 0, false);
	  }
	};
	
	var removeAllSlides = function () {
	  var swiper = this;
	
	  var slidesIndexes = [];
	  for (var i = 0; i < swiper.slides.length; i += 1) {
	    slidesIndexes.push(i);
	  }
	  swiper.removeSlide(slidesIndexes);
	};
	
	var manipulation = {
	  appendSlide: appendSlide,
	  prependSlide: prependSlide,
	  removeSlide: removeSlide,
	  removeAllSlides: removeAllSlides,
	};
	
	var Device = (function Device() {
	  var ua = win.navigator.userAgent;
	
	  var device = {
	    ios: false,
	    android: false,
	    androidChrome: false,
	    desktop: false,
	    windows: false,
	    iphone: false,
	    ipod: false,
	    ipad: false,
	    cordova: win.cordova || win.phonegap,
	    phonegap: win.cordova || win.phonegap,
	  };
	
	  var windows = ua.match(/(Windows Phone);?[\s\/]+([\d.]+)?/); // eslint-disable-line
	  var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
	  var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
	  var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
	  var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
	
	
	  // Windows
	  if (windows) {
	    device.os = 'windows';
	    device.osVersion = windows[2];
	    device.windows = true;
	  }
	  // Android
	  if (android && !windows) {
	    device.os = 'android';
	    device.osVersion = android[2];
	    device.android = true;
	    device.androidChrome = ua.toLowerCase().indexOf('chrome') >= 0;
	  }
	  if (ipad || iphone || ipod) {
	    device.os = 'ios';
	    device.ios = true;
	  }
	  // iOS
	  if (iphone && !ipod) {
	    device.osVersion = iphone[2].replace(/_/g, '.');
	    device.iphone = true;
	  }
	  if (ipad) {
	    device.osVersion = ipad[2].replace(/_/g, '.');
	    device.ipad = true;
	  }
	  if (ipod) {
	    device.osVersion = ipod[3] ? ipod[3].replace(/_/g, '.') : null;
	    device.iphone = true;
	  }
	  // iOS 8+ changed UA
	  if (device.ios && device.osVersion && ua.indexOf('Version/') >= 0) {
	    if (device.osVersion.split('.')[0] === '10') {
	      device.osVersion = ua.toLowerCase().split('version/')[1].split(' ')[0];
	    }
	  }
	
	  // Desktop
	  device.desktop = !(device.os || device.android || device.webView);
	
	  // Webview
	  device.webView = (iphone || ipad || ipod) && ua.match(/.*AppleWebKit(?!.*Safari)/i);
	
	  // Minimal UI
	  if (device.os && device.os === 'ios') {
	    var osVersionArr = device.osVersion.split('.');
	    var metaViewport = doc.querySelector('meta[name="viewport"]');
	    device.minimalUi =
	      !device.webView &&
	      (ipod || iphone) &&
	      (osVersionArr[0] * 1 === 7 ? osVersionArr[1] * 1 >= 1 : osVersionArr[0] * 1 > 7) &&
	      metaViewport && metaViewport.getAttribute('content').indexOf('minimal-ui') >= 0;
	  }
	
	  // Pixel Ratio
	  device.pixelRatio = win.devicePixelRatio || 1;
	
	  // Export object
	  return device;
	}());
	
	var onTouchStart = function (event) {
	  var swiper = this;
	  var data = swiper.touchEventsData;
	  var params = swiper.params;
	  var touches = swiper.touches;
	  var e = event;
	  if (e.originalEvent) { e = e.originalEvent; }
	  data.isTouchEvent = e.type === 'touchstart';
	  if (!data.isTouchEvent && 'which' in e && e.which === 3) { return; }
	  if (data.isTouched && data.isMoved) { return; }
	  if (params.noSwiping && $$1(e.target).closest(("." + (params.noSwipingClass)))[0]) {
	    swiper.allowClick = true;
	    return;
	  }
	  if (params.swipeHandler) {
	    if (!$$1(e).closest(params.swipeHandler)[0]) { return; }
	  }
	
	  touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
	  touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
	  var startX = touches.currentX;
	  var startY = touches.currentY;
	
	  // Do NOT start if iOS edge swipe is detected. Otherwise iOS app (UIWebView) cannot swipe-to-go-back anymore
	
	  if (
	    Device.ios &&
	    !Device.cordova &&
	    params.iOSEdgeSwipeDetection &&
	    (startX <= params.iOSEdgeSwipeThreshold) &&
	    (startX >= window.screen.width - params.iOSEdgeSwipeThreshold)
	  ) {
	    return;
	  }
	
	  Utils.extend(data, {
	    isTouched: true,
	    isMoved: false,
	    allowTouchCallbacks: true,
	    isScrolling: undefined,
	    startMoving: undefined,
	  });
	
	  touches.startX = startX;
	  touches.startY = startY;
	  data.touchStartTime = Utils.now();
	  swiper.allowClick = true;
	  swiper.updateSize();
	  swiper.swipeDirection = undefined;
	  if (params.threshold > 0) { data.allowThresholdMove = false; }
	  if (e.type !== 'touchstart') {
	    var preventDefault = true;
	    if ($$1(e.target).is(data.formElements)) { preventDefault = false; }
	    if (doc.activeElement && $$1(doc.activeElement).is(data.formElements)) {
	      doc.activeElement.blur();
	    }
	    if (preventDefault && swiper.allowTouchMove) {
	      e.preventDefault();
	    }
	  }
	  swiper.emit('touchStart', e);
	};
	
	var onTouchMove = function (event) {
	  var swiper = this;
	  var data = swiper.touchEventsData;
	  var params = swiper.params;
	  var touches = swiper.touches;
	  var rtl = swiper.rtl;
	  var e = event;
	  if (e.originalEvent) { e = e.originalEvent; }
	  if (data.isTouchEvent && e.type === 'mousemove') { return; }
	  var pageX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
	  var pageY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
	  if (e.preventedByNestedSwiper) {
	    touches.startX = pageX;
	    touches.startY = pageY;
	    return;
	  }
	  if (!swiper.allowTouchMove) {
	    // isMoved = true;
	    swiper.allowClick = false;
	    if (data.isTouched) {
	      Utils.extend(touches, {
	        startX: pageX,
	        startY: pageY,
	        currentX: pageX,
	        currentY: pageY,
	      });
	      data.touchStartTime = Utils.now();
	    }
	    return;
	  }
	  if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
	    if (swiper.isVertical()) {
	      // Vertical
	      if (
	        (pageY < touches.startY && swiper.translate <= swiper.maxTranslate()) ||
	        (pageY > touches.startY && swiper.translate >= swiper.minTranslate())
	      ) {
	        data.isTouched = false;
	        data.isMoved = false;
	        return;
	      }
	    } else if (
	      (pageX < touches.startX && swiper.translate <= swiper.maxTranslate()) ||
	      (pageX > touches.startX && swiper.translate >= swiper.minTranslate())
	    ) {
	      return;
	    }
	  }
	  if (data.isTouchEvent && doc.activeElement) {
	    if (e.target === doc.activeElement && $$1(e.target).is(data.formElements)) {
	      data.isMoved = true;
	      swiper.allowClick = false;
	      return;
	    }
	  }
	  if (data.allowTouchCallbacks) {
	    swiper.emit('touchMove', e);
	  }
	  if (e.targetTouches && e.targetTouches.length > 1) { return; }
	
	  touches.currentX = pageX;
	  touches.currentY = pageY;
	
	  var diffX = touches.currentX - touches.startX;
	  var diffY = touches.currentY - touches.startY;
	
	  if (typeof data.isScrolling === 'undefined') {
	    var touchAngle;
	    if ((swiper.isHorizontal() && touches.currentY === touches.startY) || (swiper.isVertical() && touches.currentX === touches.startX)) {
	      data.isScrolling = false;
	    } else {
	      // eslint-disable-next-line
	      if ((diffX * diffX) + (diffY * diffY) >= 25) {
	        touchAngle = (Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180) / Math.PI;
	        data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : (90 - touchAngle > params.touchAngle);
	      }
	    }
	  }
	  if (data.isScrolling) {
	    swiper.emit('touchMoveOpposite', e);
	  }
	  if (typeof startMoving === 'undefined') {
	    if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
	      data.startMoving = true;
	    }
	  }
	  if (!data.isTouched) { return; }
	  if (data.isScrolling) {
	    data.isTouched = false;
	    return;
	  }
	  if (!data.startMoving) {
	    return;
	  }
	  swiper.allowClick = false;
	  e.preventDefault();
	  if (params.touchMoveStopPropagation && !params.nested) {
	    e.stopPropagation();
	  }
	
	  if (!data.isMoved) {
	    if (params.loop) {
	      swiper.loopFix();
	    }
	    data.startTranslate = swiper.getTranslate();
	    swiper.setTransition(0);
	    if (swiper.animating) {
	      swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
	    }
	    data.allowMomentumBounce = false;
	    // Grab Cursor
	    if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
	      swiper.setGrabCursor(true);
	    }
	    swiper.emit('sliderFirstMove', e);
	  }
	  swiper.emit('sliderMove', e);
	  data.isMoved = true;
	
	  var diff = swiper.isHorizontal() ? diffX : diffY;
	  touches.diff = diff;
	
	  diff *= params.touchRatio;
	  if (rtl) { diff = -diff; }
	
	  swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
	  data.currentTranslate = diff + data.startTranslate;
	
	  var disableParentSwiper = true;
	  var resistanceRatio = params.resistanceRatio;
	  if (params.touchReleaseOnEdges) {
	    resistanceRatio = 0;
	  }
	  if ((diff > 0 && data.currentTranslate > swiper.minTranslate())) {
	    disableParentSwiper = false;
	    if (params.resistance) { data.currentTranslate = (swiper.minTranslate() - 1) + (Math.pow( (-swiper.minTranslate() + data.startTranslate + diff), resistanceRatio )); }
	  } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
	    disableParentSwiper = false;
	    if (params.resistance) { data.currentTranslate = (swiper.maxTranslate() + 1) - (Math.pow( (swiper.maxTranslate() - data.startTranslate - diff), resistanceRatio )); }
	  }
	
	  if (disableParentSwiper) {
	    e.preventedByNestedSwiper = true;
	  }
	
	  // Directions locks
	  if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) {
	    data.currentTranslate = data.startTranslate;
	  }
	  if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) {
	    data.currentTranslate = data.startTranslate;
	  }
	
	
	  // Threshold
	  if (params.threshold > 0) {
	    if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
	      if (!data.allowThresholdMove) {
	        data.allowThresholdMove = true;
	        touches.startX = touches.currentX;
	        touches.startY = touches.currentY;
	        data.currentTranslate = data.startTranslate;
	        touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
	        return;
	      }
	    } else {
	      data.currentTranslate = data.startTranslate;
	      return;
	    }
	  }
	
	  if (!params.followFinger) { return; }
	
	  // Update active index in free mode
	  if (params.freeMode || params.watchSlidesProgress || params.watchSlidesVisibility) {
	    swiper.updateActiveIndex();
	    swiper.updateSlidesClasses();
	  }
	  if (params.freeMode) {
	    // Velocity
	    if (data.velocities.length === 0) {
	      data.velocities.push({
	        position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
	        time: data.touchStartTime,
	      });
	    }
	    data.velocities.push({
	      position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
	      time: Utils.now(),
	    });
	  }
	  // Update progress
	  swiper.updateProgress(data.currentTranslate);
	  // Update translate
	  swiper.setTranslate(data.currentTranslate);
	};
	
	var onTouchEnd = function (event) {
	  var swiper = this;
	  var data = swiper.touchEventsData;
	
	  var params = swiper.params;
	  var touches = swiper.touches;
	  var rtl = swiper.rtl;
	  var $wrapperEl = swiper.$wrapperEl;
	  var slidesGrid = swiper.slidesGrid;
	  var snapGrid = swiper.snapGrid;
	  var e = event;
	  if (e.originalEvent) { e = e.originalEvent; }
	  if (data.allowTouchCallbacks) {
	    swiper.emit('touchEnd', e);
	  }
	  data.allowTouchCallbacks = false;
	  if (!data.isTouched) { return; }
	  // Return Grab Cursor
	  if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
	    swiper.setGrabCursor(false);
	  }
	
	  // Time diff
	  var touchEndTime = Utils.now();
	  var timeDiff = touchEndTime - data.touchStartTime;
	
	  // Tap, doubleTap, Click
	  if (swiper.allowClick) {
	    swiper.updateClickedSlide(e);
	    swiper.emit('tap', e);
	    if (timeDiff < 300 && (touchEndTime - data.lastClickTime) > 300) {
	      if (data.clickTimeout) { clearTimeout(data.clickTimeout); }
	      data.clickTimeout = Utils.nextTick(function () {
	        if (!swiper || swiper.destroyed) { return; }
	        swiper.emit('click', e);
	      }, 300);
	    }
	    if (timeDiff < 300 && (touchEndTime - data.lastClickTime) < 300) {
	      if (data.clickTimeout) { clearTimeout(data.clickTimeout); }
	      swiper.emit('doubleTap', e);
	    }
	  }
	
	  data.lastClickTime = Utils.now();
	  Utils.nextTick(function () {
	    if (!swiper.destroyed) { swiper.allowClick = true; }
	  });
	
	  if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
	    data.isTouched = false;
	    data.isMoved = false;
	    return;
	  }
	  data.isTouched = false;
	  data.isMoved = false;
	
	  var currentPos;
	  if (params.followFinger) {
	    currentPos = rtl ? swiper.translate : -swiper.translate;
	  } else {
	    currentPos = -data.currentTranslate;
	  }
	  if (params.freeMode) {
	    if (currentPos < -swiper.minTranslate()) {
	      swiper.slideTo(swiper.activeIndex);
	      return;
	    } else if (currentPos > -swiper.maxTranslate()) {
	      if (swiper.slides.length < snapGrid.length) {
	        swiper.slideTo(snapGrid.length - 1);
	      } else {
	        swiper.slideTo(swiper.slides.length - 1);
	      }
	      return;
	    }
	
	    if (params.freeModeMomentum) {
	      if (data.velocities.length > 1) {
	        var lastMoveEvent = data.velocities.pop();
	        var velocityEvent = data.velocities.pop();
	
	        var distance = lastMoveEvent.position - velocityEvent.position;
	        var time = lastMoveEvent.time - velocityEvent.time;
	        swiper.velocity = distance / time;
	        swiper.velocity /= 2;
	        if (Math.abs(swiper.velocity) < params.freeModeMinimumVelocity) {
	          swiper.velocity = 0;
	        }
	        // this implies that the user stopped moving a finger then released.
	        // There would be no events with distance zero, so the last event is stale.
	        if (time > 150 || (Utils.now() - lastMoveEvent.time) > 300) {
	          swiper.velocity = 0;
	        }
	      } else {
	        swiper.velocity = 0;
	      }
	      swiper.velocity *= params.freeModeMomentumVelocityRatio;
	
	      data.velocities.length = 0;
	      var momentumDuration = 1000 * params.freeModeMomentumRatio;
	      var momentumDistance = swiper.velocity * momentumDuration;
	
	      var newPosition = swiper.translate + momentumDistance;
	      if (rtl) { newPosition = -newPosition; }
	      var doBounce = false;
	      var afterBouncePosition;
	      var bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeModeMomentumBounceRatio;
	      if (newPosition < swiper.maxTranslate()) {
	        if (params.freeModeMomentumBounce) {
	          if (newPosition + swiper.maxTranslate() < -bounceAmount) {
	            newPosition = swiper.maxTranslate() - bounceAmount;
	          }
	          afterBouncePosition = swiper.maxTranslate();
	          doBounce = true;
	          data.allowMomentumBounce = true;
	        } else {
	          newPosition = swiper.maxTranslate();
	        }
	      } else if (newPosition > swiper.minTranslate()) {
	        if (params.freeModeMomentumBounce) {
	          if (newPosition - swiper.minTranslate() > bounceAmount) {
	            newPosition = swiper.minTranslate() + bounceAmount;
	          }
	          afterBouncePosition = swiper.minTranslate();
	          doBounce = true;
	          data.allowMomentumBounce = true;
	        } else {
	          newPosition = swiper.minTranslate();
	        }
	      } else if (params.freeModeSticky) {
	        var nextSlide;
	        for (var j = 0; j < snapGrid.length; j += 1) {
	          if (snapGrid[j] > -newPosition) {
	            nextSlide = j;
	            break;
	          }
	        }
	        if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') {
	          newPosition = snapGrid[nextSlide];
	        } else {
	          newPosition = snapGrid[nextSlide - 1];
	        }
	        newPosition = -newPosition;
	      }
	      // Fix duration
	      if (swiper.velocity !== 0) {
	        if (rtl) {
	          momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
	        } else {
	          momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
	        }
	      } else if (params.freeModeSticky) {
	        swiper.slideReset();
	        return;
	      }
	
	      if (params.freeModeMomentumBounce && doBounce) {
	        swiper.updateProgress(afterBouncePosition);
	        swiper.setTransition(momentumDuration);
	        swiper.setTranslate(newPosition);
	        swiper.transitionStart();
	        swiper.animating = true;
	        $wrapperEl.transitionEnd(function () {
	          if (!swiper || swiper.destroyed || !data.allowMomentumBounce) { return; }
	          swiper.emit('momentumBounce');
	
	          swiper.setTransition(params.speed);
	          swiper.setTranslate(afterBouncePosition);
	          $wrapperEl.transitionEnd(function () {
	            if (!swiper || swiper.destroyed) { return; }
	            swiper.transitionEnd();
	          });
	        });
	      } else if (swiper.velocity) {
	        swiper.updateProgress(newPosition);
	        swiper.setTransition(momentumDuration);
	        swiper.setTranslate(newPosition);
	        swiper.transitionStart();
	        if (!swiper.animating) {
	          swiper.animating = true;
	          $wrapperEl.transitionEnd(function () {
	            if (!swiper || swiper.destroyed) { return; }
	            swiper.transitionEnd();
	          });
	        }
	      } else {
	        swiper.updateProgress(newPosition);
	      }
	
	      swiper.updateActiveIndex();
	      swiper.updateSlidesClasses();
	    }
	    if (!params.freeModeMomentum || timeDiff >= params.longSwipesMs) {
	      swiper.updateProgress();
	      swiper.updateActiveIndex();
	      swiper.updateSlidesClasses();
	    }
	    return;
	  }
	
	  // Find current slide
	  var stopIndex = 0;
	  var groupSize = swiper.slidesSizesGrid[0];
	  for (var i = 0; i < slidesGrid.length; i += params.slidesPerGroup) {
	    if (typeof slidesGrid[i + params.slidesPerGroup] !== 'undefined') {
	      if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + params.slidesPerGroup]) {
	        stopIndex = i;
	        groupSize = slidesGrid[i + params.slidesPerGroup] - slidesGrid[i];
	      }
	    } else if (currentPos >= slidesGrid[i]) {
	      stopIndex = i;
	      groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
	    }
	  }
	
	  // Find current slide size
	  var ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
	
	  if (timeDiff > params.longSwipesMs) {
	    // Long touches
	    if (!params.longSwipes) {
	      swiper.slideTo(swiper.activeIndex);
	      return;
	    }
	    if (swiper.swipeDirection === 'next') {
	      if (ratio >= params.longSwipesRatio) { swiper.slideTo(stopIndex + params.slidesPerGroup); }
	      else { swiper.slideTo(stopIndex); }
	    }
	    if (swiper.swipeDirection === 'prev') {
	      if (ratio > (1 - params.longSwipesRatio)) { swiper.slideTo(stopIndex + params.slidesPerGroup); }
	      else { swiper.slideTo(stopIndex); }
	    }
	  } else {
	    // Short swipes
	    if (!params.shortSwipes) {
	      swiper.slideTo(swiper.activeIndex);
	      return;
	    }
	    if (swiper.swipeDirection === 'next') {
	      swiper.slideTo(stopIndex + params.slidesPerGroup);
	    }
	    if (swiper.swipeDirection === 'prev') {
	      swiper.slideTo(stopIndex);
	    }
	  }
	};
	
	var onResize = function () {
	  var swiper = this;
	
	  var params = swiper.params;
	  var el = swiper.el;
	
	  if (el && el.offsetWidth === 0) { return; }
	
	  // Breakpoints
	  if (params.breakpoints) {
	    swiper.setBreakpoint();
	  }
	
	  // Save locks
	  var allowSlideNext = swiper.allowSlideNext;
	  var allowSlidePrev = swiper.allowSlidePrev;
	
	  // Disable locks on resize
	  swiper.allowSlideNext = true;
	  swiper.allowSlidePrev = true;
	
	  swiper.updateSize();
	  swiper.updateSlides();
	
	  if (params.freeMode) {
	    var newTranslate = Math.min(Math.max(swiper.translate, swiper.maxTranslate()), swiper.minTranslate());
	    swiper.setTranslate(newTranslate);
	    swiper.updateActiveIndex();
	    swiper.updateSlidesClasses();
	
	    if (params.autoHeight) {
	      swiper.updateAutoHeight();
	    }
	  } else {
	    swiper.updateSlidesClasses();
	    if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
	      swiper.slideTo(swiper.slides.length - 1, 0, false, true);
	    } else {
	      swiper.slideTo(swiper.activeIndex, 0, false, true);
	    }
	  }
	  // Return locks after resize
	  swiper.allowSlidePrev = allowSlidePrev;
	  swiper.allowSlideNext = allowSlideNext;
	};
	
	var onClick = function (e) {
	  var swiper = this;
	  if (!swiper.allowClick) {
	    if (swiper.params.preventClicks) { e.preventDefault(); }
	    if (swiper.params.preventClicksPropagation && swiper.animating) {
	      e.stopPropagation();
	      e.stopImmediatePropagation();
	    }
	  }
	};
	
	function attachEvents() {
	  var swiper = this;
	
	  var params = swiper.params;
	  var touchEvents = swiper.touchEvents;
	  var el = swiper.el;
	  var wrapperEl = swiper.wrapperEl;
	
	  {
	    swiper.onTouchStart = onTouchStart.bind(swiper);
	    swiper.onTouchMove = onTouchMove.bind(swiper);
	    swiper.onTouchEnd = onTouchEnd.bind(swiper);
	  }
	
	  swiper.onClick = onClick.bind(swiper);
	
	  var target = params.touchEventsTarget === 'container' ? el : wrapperEl;
	  var capture = !!params.nested;
	
	  // Touch Events
	  {
	    if (Support.pointerEvents || Support.prefixedPointerEvents) {
	      target.addEventListener(touchEvents.start, swiper.onTouchStart, false);
	      (Support.touch ? target : doc).addEventListener(touchEvents.move, swiper.onTouchMove, capture);
	      (Support.touch ? target : doc).addEventListener(touchEvents.end, swiper.onTouchEnd, false);
	    } else {
	      if (Support.touch) {
	        var passiveListener = touchEvents.start === 'touchstart' && Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
	        target.addEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
	        target.addEventListener(touchEvents.move, swiper.onTouchMove, Support.passiveListener ? { passive: false, capture: capture } : capture);
	        target.addEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
	      }
	      if ((params.simulateTouch && !Device.ios && !Device.android) || (params.simulateTouch && !Support.touch && Device.ios)) {
	        target.addEventListener('mousedown', swiper.onTouchStart, false);
	        doc.addEventListener('mousemove', swiper.onTouchMove, capture);
	        doc.addEventListener('mouseup', swiper.onTouchEnd, false);
	      }
	    }
	    // Prevent Links Clicks
	    if (params.preventClicks || params.preventClicksPropagation) {
	      target.addEventListener('click', swiper.onClick, true);
	    }
	  }
	
	  // Resize handler
	  swiper.on('resize observerUpdate', onResize);
	}
	
	function detachEvents() {
	  var swiper = this;
	
	  var params = swiper.params;
	  var touchEvents = swiper.touchEvents;
	  var el = swiper.el;
	  var wrapperEl = swiper.wrapperEl;
	
	  var target = params.touchEventsTarget === 'container' ? el : wrapperEl;
	  var capture = !!params.nested;
	
	  // Touch Events
	  {
	    if (Support.pointerEvents || Support.prefixedPointerEvents) {
	      target.removeEventListener(touchEvents.start, swiper.onTouchStart, false);
	      (Support.touch ? target : doc).removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
	      (Support.touch ? target : doc).removeEventListener(touchEvents.end, swiper.onTouchEnd, false);
	    } else {
	      if (Support.touch) {
	        var passiveListener = touchEvents.start === 'onTouchStart' && Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
	        target.removeEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
	        target.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
	        target.removeEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
	      }
	      if ((params.simulateTouch && !Device.ios && !Device.android) || (params.simulateTouch && !Support.touch && Device.ios)) {
	        target.removeEventListener('mousedown', swiper.onTouchStart, false);
	        doc.removeEventListener('mousemove', swiper.onTouchMove, capture);
	        doc.removeEventListener('mouseup', swiper.onTouchEnd, false);
	      }
	    }
	    // Prevent Links Clicks
	    if (params.preventClicks || params.preventClicksPropagation) {
	      target.removeEventListener('click', swiper.onClick, true);
	    }
	  }
	
	  // Resize handler
	  swiper.off('resize observerUpdate', onResize);
	}
	
	var events = {
	  attachEvents: attachEvents,
	  detachEvents: detachEvents,
	};
	
	var setBreakpoint = function () {
	  var swiper = this;
	  var activeIndex = swiper.activeIndex;
	  var loopedSlides = swiper.loopedSlides; if ( loopedSlides === void 0 ) loopedSlides = 0;
	  var params = swiper.params;
	  var breakpoints = params.breakpoints;
	  if (!breakpoints || (breakpoints && Object.keys(breakpoints).length === 0)) { return; }
	  // Set breakpoint for window width and update parameters
	  var breakpoint = swiper.getBreakpoint(breakpoints);
	  if (breakpoint && swiper.currentBreakpoint !== breakpoint) {
	    var breakPointsParams = breakpoint in breakpoints ? breakpoints[breakpoint] : swiper.originalParams;
	    var needsReLoop = params.loop && (breakPointsParams.slidesPerView !== params.slidesPerView);
	
	    Utils.extend(swiper.params, breakPointsParams);
	
	    Utils.extend(swiper, {
	      allowTouchMove: swiper.params.allowTouchMove,
	      allowSlideNext: swiper.params.allowSlideNext,
	      allowSlidePrev: swiper.params.allowSlidePrev,
	    });
	
	    swiper.currentBreakpoint = breakpoint;
	
	    if (needsReLoop) {
	      swiper.loopDestroy();
	      swiper.loopCreate();
	      swiper.updateSlides();
	      swiper.slideTo((activeIndex - loopedSlides) + swiper.loopedSlides, 0, false);
	    }
	    swiper.emit('breakpoint', breakPointsParams);
	  }
	};
	
	var getBreakpoint = function (breakpoints) {
	  // Get breakpoint for window width
	  if (!breakpoints) { return undefined; }
	  var breakpoint = false;
	  var points = [];
	  Object.keys(breakpoints).forEach(function (point) {
	    points.push(point);
	  });
	  points.sort(function (a, b) { return parseInt(a, 10) - parseInt(b, 10); });
	  for (var i = 0; i < points.length; i += 1) {
	    var point = points[i];
	    if (point >= win.innerWidth && !breakpoint) {
	      breakpoint = point;
	    }
	  }
	  return breakpoint || 'max';
	};
	
	var breakpoints = { setBreakpoint: setBreakpoint, getBreakpoint: getBreakpoint };
	
	var addClasses = function () {
	  var swiper = this;
	  var classNames = swiper.classNames;
	  var params = swiper.params;
	  var rtl = swiper.rtl;
	  var $el = swiper.$el;
	  var suffixes = [];
	
	  suffixes.push(params.direction);
	
	  if (params.freeMode) {
	    suffixes.push('free-mode');
	  }
	  if (!Support.flexbox) {
	    suffixes.push('no-flexbox');
	  }
	  if (params.autoHeight) {
	    suffixes.push('autoheight');
	  }
	  if (rtl) {
	    suffixes.push('rtl');
	  }
	  if (params.slidesPerColumn > 1) {
	    suffixes.push('multirow');
	  }
	  if (Device.android) {
	    suffixes.push('android');
	  }
	  if (Device.ios) {
	    suffixes.push('ios');
	  }
	  // WP8 Touch Events Fix
	  if (Support.pointerEvents || Support.prefixedPointerEvents) {
	    suffixes.push(("wp8-" + (params.direction)));
	  }
	
	  suffixes.forEach(function (suffix) {
	    classNames.push(params.containerModifierClass + suffix);
	  });
	
	  $el.addClass(classNames.join(' '));
	};
	
	var removeClasses = function () {
	  var swiper = this;
	  var $el = swiper.$el;
	  var classNames = swiper.classNames;
	
	  $el.removeClass(classNames.join(' '));
	};
	
	var classes = { addClasses: addClasses, removeClasses: removeClasses };
	
	var loadImage = function (imageEl, src, srcset, sizes, checkForComplete, callback) {
	  var image;
	  function onReady() {
	    if (callback) { callback(); }
	  }
	  if (!imageEl.complete || !checkForComplete) {
	    if (src) {
	      image = new win.Image();
	      image.onload = onReady;
	      image.onerror = onReady;
	      if (sizes) {
	        image.sizes = sizes;
	      }
	      if (srcset) {
	        image.srcset = srcset;
	      }
	      if (src) {
	        image.src = src;
	      }
	    } else {
	      onReady();
	    }
	  } else {
	    // image already loaded...
	    onReady();
	  }
	};
	
	var preloadImages = function () {
	  var swiper = this;
	  swiper.imagesToLoad = swiper.$el.find('img');
	  function onReady() {
	    if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) { return; }
	    if (swiper.imagesLoaded !== undefined) { swiper.imagesLoaded += 1; }
	    if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
	      if (swiper.params.updateOnImagesReady) { swiper.update(); }
	      swiper.emit('imagesReady');
	    }
	  }
	  for (var i = 0; i < swiper.imagesToLoad.length; i += 1) {
	    var imageEl = swiper.imagesToLoad[i];
	    swiper.loadImage(
	      imageEl,
	      imageEl.currentSrc || imageEl.getAttribute('src'),
	      imageEl.srcset || imageEl.getAttribute('srcset'),
	      imageEl.sizes || imageEl.getAttribute('sizes'),
	      true,
	      onReady
	    );
	  }
	};
	
	var images = {
	  loadImage: loadImage,
	  preloadImages: preloadImages,
	};
	
	function checkOverflow() {
	  var swiper = this;
	  var wasLocked = swiper.isLocked;
	
	  swiper.isLocked = swiper.snapGrid.length === 1;
	  swiper.allowTouchMove = !swiper.isLocked;
	
	  if (wasLocked && wasLocked !== swiper.isLocked) {
	    swiper.isEnd = false;
	    swiper.navigation.update();
	  }
	}
	
	var checkOverflow$1 = { checkOverflow: checkOverflow };
	
	var defaults = {
	  init: true,
	  direction: 'horizontal',
	  touchEventsTarget: 'container',
	  initialSlide: 0,
	  speed: 300,
	
	  // To support iOS's swipe-to-go-back gesture (when being used in-app, with UIWebView).
	  iOSEdgeSwipeDetection: false,
	  iOSEdgeSwipeThreshold: 20,
	
	  // Free mode
	  freeMode: false,
	  freeModeMomentum: true,
	  freeModeMomentumRatio: 1,
	  freeModeMomentumBounce: true,
	  freeModeMomentumBounceRatio: 1,
	  freeModeMomentumVelocityRatio: 1,
	  freeModeSticky: false,
	  freeModeMinimumVelocity: 0.02,
	
	  // Autoheight
	  autoHeight: false,
	
	  // Set wrapper width
	  setWrapperSize: false,
	
	  // Virtual Translate
	  virtualTranslate: false,
	
	  // Effects
	  effect: 'slide', // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
	
	  // Breakpoints
	  breakpoints: undefined,
	
	  // Slides grid
	  spaceBetween: 0,
	  slidesPerView: 1,
	  slidesPerColumn: 1,
	  slidesPerColumnFill: 'column',
	  slidesPerGroup: 1,
	  centeredSlides: false,
	  slidesOffsetBefore: 0, // in px
	  slidesOffsetAfter: 0, // in px
	  normalizeSlideIndex: true,
	
	  // Disable swiper and hide navigation when container not overflow
	  watchOverflow: false,
	
	  // Round length
	  roundLengths: false,
	
	  // Touches
	  touchRatio: 1,
	  touchAngle: 45,
	  simulateTouch: true,
	  shortSwipes: true,
	  longSwipes: true,
	  longSwipesRatio: 0.5,
	  longSwipesMs: 300,
	  followFinger: true,
	  allowTouchMove: true,
	  threshold: 0,
	  touchMoveStopPropagation: true,
	  touchReleaseOnEdges: false,
	
	  // Unique Navigation Elements
	  uniqueNavElements: true,
	
	  // Resistance
	  resistance: true,
	  resistanceRatio: 0.85,
	
	  // Progress
	  watchSlidesProgress: false,
	  watchSlidesVisibility: false,
	
	  // Cursor
	  grabCursor: false,
	
	  // Clicks
	  preventClicks: true,
	  preventClicksPropagation: true,
	  slideToClickedSlide: false,
	
	  // Images
	  preloadImages: true,
	  updateOnImagesReady: true,
	
	  // loop
	  loop: false,
	  loopAdditionalSlides: 0,
	  loopedSlides: null,
	  loopFillGroupWithBlank: false,
	
	  // Swiping/no swiping
	  allowSlidePrev: true,
	  allowSlideNext: true,
	  swipeHandler: null, // '.swipe-handler',
	  noSwiping: true,
	  noSwipingClass: 'swiper-no-swiping',
	
	  // Passive Listeners
	  passiveListeners: true,
	
	  // NS
	  containerModifierClass: 'swiper-container-', // NEW
	  slideClass: 'swiper-slide',
	  slideBlankClass: 'swiper-slide-invisible-blank',
	  slideActiveClass: 'swiper-slide-active',
	  slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
	  slideVisibleClass: 'swiper-slide-visible',
	  slideDuplicateClass: 'swiper-slide-duplicate',
	  slideNextClass: 'swiper-slide-next',
	  slideDuplicateNextClass: 'swiper-slide-duplicate-next',
	  slidePrevClass: 'swiper-slide-prev',
	  slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
	  wrapperClass: 'swiper-wrapper',
	
	  // Callbacks
	  runCallbacksOnInit: true,
	};
	
	var prototypes = {
	  update: update,
	  translate: translate,
	  transition: transition$1,
	  slide: slide,
	  loop: loop,
	  grabCursor: grabCursor,
	  manipulation: manipulation,
	  events: events,
	  breakpoints: breakpoints,
	  checkOverflow: checkOverflow$1,
	  classes: classes,
	  images: images,
	};
	
	var extendedDefaults = {};
	
	var Swiper$1 = (function (SwiperClass$$1) {
	  function Swiper() {
	    var args = [], len = arguments.length;
	    while ( len-- ) args[ len ] = arguments[ len ];
	
	    var el;
	    var params;
	    if (args.length === 1 && args[0].constructor && args[0].constructor === Object) {
	      params = args[0];
	    } else {
	      var assign;
	      (assign = args, el = assign[0], params = assign[1]);
	    }
	    if (!params) { params = {}; }
	
	    params = Utils.extend({}, params);
	    if (el && !params.el) { params.el = el; }
	
	    SwiperClass$$1.call(this, params);
	
	    Object.keys(prototypes).forEach(function (prototypeGroup) {
	      Object.keys(prototypes[prototypeGroup]).forEach(function (protoMethod) {
	        if (!Swiper.prototype[protoMethod]) {
	          Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
	        }
	      });
	    });
	
	    // Swiper Instance
	    var swiper = this;
	    if (typeof swiper.modules === 'undefined') {
	      swiper.modules = {};
	    }
	    Object.keys(swiper.modules).forEach(function (moduleName) {
	      var module = swiper.modules[moduleName];
	      if (module.params) {
	        var moduleParamName = Object.keys(module.params)[0];
	        var moduleParams = module.params[moduleParamName];
	        if (typeof moduleParams !== 'object') { return; }
	        if (!(moduleParamName in params && 'enabled' in moduleParams)) { return; }
	        if (params[moduleParamName] === true) {
	          params[moduleParamName] = { enabled: true };
	        }
	        if (
	          typeof params[moduleParamName] === 'object' &&
	          !('enabled' in params[moduleParamName])
	        ) {
	          params[moduleParamName].enabled = true;
	        }
	        if (!params[moduleParamName]) { params[moduleParamName] = { enabled: false }; }
	      }
	    });
	
	    // Extend defaults with modules params
	    var swiperParams = Utils.extend({}, defaults);
	    swiper.useModulesParams(swiperParams);
	
	    // Extend defaults with passed params
	    swiper.params = Utils.extend({}, swiperParams, extendedDefaults, params);
	    swiper.originalParams = Utils.extend({}, swiper.params);
	    swiper.passedParams = Utils.extend({}, params);
	
	    // Find el
	    var $el = $$1(swiper.params.el);
	    el = $el[0];
	
	    if (!el) {
	      return undefined;
	    }
	
	    if ($el.length > 1) {
	      var swipers = [];
	      $el.each(function (index, containerEl) {
	        var newParams = Utils.extend({}, params, { el: containerEl });
	        swipers.push(new Swiper(newParams));
	      });
	      return swipers;
	    }
	
	    el.swiper = swiper;
	    $el.data('swiper', swiper);
	
	    // Find Wrapper
	    var $wrapperEl = $el.children(("." + (swiper.params.wrapperClass)));
	
	    // Extend Swiper
	    Utils.extend(swiper, {
	      $el: $el,
	      el: el,
	      $wrapperEl: $wrapperEl,
	      wrapperEl: $wrapperEl[0],
	
	      // Classes
	      classNames: [],
	
	      // Slides
	      slides: $$1(),
	      slidesGrid: [],
	      snapGrid: [],
	      slidesSizesGrid: [],
	
	      // isDirection
	      isHorizontal: function isHorizontal() {
	        return swiper.params.direction === 'horizontal';
	      },
	      isVertical: function isVertical() {
	        return swiper.params.direction === 'vertical';
	      },
	      // RTL
	      rtl: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
	      wrongRTL: $wrapperEl.css('display') === '-webkit-box',
	
	      // Indexes
	      activeIndex: 0,
	      realIndex: 0,
	
	      //
	      isBeginning: true,
	      isEnd: false,
	
	      // Props
	      translate: 0,
	      progress: 0,
	      velocity: 0,
	      animating: false,
	
	      // Locks
	      allowSlideNext: swiper.params.allowSlideNext,
	      allowSlidePrev: swiper.params.allowSlidePrev,
	
	      // Touch Events
	      touchEvents: (function touchEvents() {
	        var touch = ['touchstart', 'touchmove', 'touchend'];
	        var desktop = ['mousedown', 'mousemove', 'mouseup'];
	        if (Support.pointerEvents) {
	          desktop = ['pointerdown', 'pointermove', 'pointerup'];
	        } else if (Support.prefixedPointerEvents) {
	          desktop = ['MSPointerDown', 'MSPointerMove', 'MSPointerUp'];
	        }
	
	        return {
	          start: Support.touch || !swiper.params.simulateTouch ? touch[0] : desktop[0],
	          move: Support.touch || !swiper.params.simulateTouch ? touch[1] : desktop[1],
	          end: Support.touch || !swiper.params.simulateTouch ? touch[2] : desktop[2],
	        };
	      }()),
	      touchEventsData: {
	        isTouched: undefined,
	        isMoved: undefined,
	        allowTouchCallbacks: undefined,
	        touchStartTime: undefined,
	        isScrolling: undefined,
	        currentTranslate: undefined,
	        startTranslate: undefined,
	        allowThresholdMove: undefined,
	        // Form elements to match
	        formElements: 'input, select, option, textarea, button, video',
	        // Last click time
	        lastClickTime: Utils.now(),
	        clickTimeout: undefined,
	        // Velocities
	        velocities: [],
	        allowMomentumBounce: undefined,
	        isTouchEvent: undefined,
	        startMoving: undefined,
	      },
	
	      // Clicks
	      allowClick: true,
	
	      // Touches
	      allowTouchMove: swiper.params.allowTouchMove,
	
	      touches: {
	        startX: 0,
	        startY: 0,
	        currentX: 0,
	        currentY: 0,
	        diff: 0,
	      },
	
	      // Images
	      imagesToLoad: [],
	      imagesLoaded: 0,
	
	    });
	
	    // Install Modules
	    swiper.useModules();
	
	    // Init
	    if (swiper.params.init) {
	      swiper.init();
	    }
	
	    // Return app instance
	    return swiper;
	  }
	
	  if ( SwiperClass$$1 ) Swiper.__proto__ = SwiperClass$$1;
	  Swiper.prototype = Object.create( SwiperClass$$1 && SwiperClass$$1.prototype );
	  Swiper.prototype.constructor = Swiper;
	
	  var staticAccessors = { extendedDefaults: { configurable: true },defaults: { configurable: true },Class: { configurable: true },$: { configurable: true } };
	  Swiper.prototype.slidesPerViewDynamic = function slidesPerViewDynamic () {
	    var swiper = this;
	    var params = swiper.params;
	    var slides = swiper.slides;
	    var slidesGrid = swiper.slidesGrid;
	    var swiperSize = swiper.size;
	    var activeIndex = swiper.activeIndex;
	    var spv = 1;
	    if (params.centeredSlides) {
	      var slideSize = slides[activeIndex].swiperSlideSize;
	      var breakLoop;
	      for (var i = activeIndex + 1; i < slides.length; i += 1) {
	        if (slides[i] && !breakLoop) {
	          slideSize += slides[i].swiperSlideSize;
	          spv += 1;
	          if (slideSize > swiperSize) { breakLoop = true; }
	        }
	      }
	      for (var i$1 = activeIndex - 1; i$1 >= 0; i$1 -= 1) {
	        if (slides[i$1] && !breakLoop) {
	          slideSize += slides[i$1].swiperSlideSize;
	          spv += 1;
	          if (slideSize > swiperSize) { breakLoop = true; }
	        }
	      }
	    } else {
	      for (var i$2 = activeIndex + 1; i$2 < slides.length; i$2 += 1) {
	        if (slidesGrid[i$2] - slidesGrid[activeIndex] < swiperSize) {
	          spv += 1;
	        }
	      }
	    }
	    return spv;
	  };
	  Swiper.prototype.update = function update$$1 () {
	    var swiper = this;
	    if (!swiper || swiper.destroyed) { return; }
	    swiper.updateSize();
	    swiper.updateSlides();
	    swiper.updateProgress();
	    swiper.updateSlidesClasses();
	
	    function setTranslate() {
	      var translateValue = swiper.rtl ? swiper.translate * -1 : swiper.translate;
	      var newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
	      swiper.setTranslate(newTranslate);
	      swiper.updateActiveIndex();
	      swiper.updateSlidesClasses();
	    }
	    var translated;
	    if (swiper.params.freeMode) {
	      setTranslate();
	      if (swiper.params.autoHeight) {
	        swiper.updateAutoHeight();
	      }
	    } else {
	      if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
	        translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
	      } else {
	        translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
	      }
	      if (!translated) {
	        setTranslate();
	      }
	    }
	    swiper.emit('update');
	  };
	  Swiper.prototype.init = function init () {
	    var swiper = this;
	    if (swiper.initialized) { return; }
	
	    swiper.emit('beforeInit');
	
	    // Set breakpoint
	    if (swiper.params.breakpoints) {
	      swiper.setBreakpoint();
	    }
	
	    // Add Classes
	    swiper.addClasses();
	
	    // Create loop
	    if (swiper.params.loop) {
	      swiper.loopCreate();
	    }
	
	    // Update size
	    swiper.updateSize();
	
	    // Update slides
	    swiper.updateSlides();
	
	    if (swiper.params.watchOverflow) {
	      swiper.checkOverflow();
	    }
	
	    // Set Grab Cursor
	    if (swiper.params.grabCursor) {
	      swiper.setGrabCursor();
	    }
	
	    if (swiper.params.preloadImages) {
	      swiper.preloadImages();
	    }
	
	    // Slide To Initial Slide
	    if (swiper.params.loop) {
	      swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit);
	    } else {
	      swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit);
	    }
	
	    // Attach events
	    swiper.attachEvents();
	
	    // Init Flag
	    swiper.initialized = true;
	
	    // Emit
	    swiper.emit('init');
	  };
	  Swiper.prototype.destroy = function destroy (deleteInstance, cleanStyles) {
	    if ( deleteInstance === void 0 ) deleteInstance = true;
	    if ( cleanStyles === void 0 ) cleanStyles = true;
	
	    var swiper = this;
	    var params = swiper.params;
	    var $el = swiper.$el;
	    var $wrapperEl = swiper.$wrapperEl;
	    var slides = swiper.slides;
	    swiper.emit('beforeDestroy');
	
	    // Init Flag
	    swiper.initialized = false;
	
	    // Detach events
	    swiper.detachEvents();
	
	    // Destroy loop
	    if (params.loop) {
	      swiper.loopDestroy();
	    }
	
	    // Cleanup styles
	    if (cleanStyles) {
	      swiper.removeClasses();
	      $el.removeAttr('style');
	      $wrapperEl.removeAttr('style');
	      if (slides && slides.length) {
	        slides
	          .removeClass([
	            params.slideVisibleClass,
	            params.slideActiveClass,
	            params.slideNextClass,
	            params.slidePrevClass ].join(' '))
	          .removeAttr('style')
	          .removeAttr('data-swiper-slide-index')
	          .removeAttr('data-swiper-column')
	          .removeAttr('data-swiper-row');
	      }
	    }
	
	    swiper.emit('destroy');
	
	    // Detach emitter events
	    Object.keys(swiper.eventsListeners).forEach(function (eventName) {
	      swiper.off(eventName);
	    });
	
	    if (deleteInstance !== false) {
	      swiper.$el[0].swiper = null;
	      swiper.$el.data('swiper', null);
	      Utils.deleteProps(swiper);
	    }
	    swiper.destroyed = true;
	  };
	  Swiper.extendDefaults = function extendDefaults (newDefaults) {
	    Utils.extend(extendedDefaults, newDefaults);
	  };
	  staticAccessors.extendedDefaults.get = function () {
	    return extendedDefaults;
	  };
	  staticAccessors.defaults.get = function () {
	    return defaults;
	  };
	  staticAccessors.Class.get = function () {
	    return SwiperClass$$1;
	  };
	  staticAccessors.$.get = function () {
	    return $$1;
	  };
	
	  Object.defineProperties( Swiper, staticAccessors );
	
	  return Swiper;
	}(SwiperClass));
	
	var Device$2 = {
	  name: 'device',
	  proto: {
	    device: Device,
	  },
	  static: {
	    device: Device,
	  },
	};
	
	var Support$2 = {
	  name: 'support',
	  proto: {
	    support: Support,
	  },
	  static: {
	    support: Support,
	  },
	};
	
	var Browser$1 = (function Browser() {
	  function isSafari() {
	    var ua = win.navigator.userAgent.toLowerCase();
	    return (ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0);
	  }
	  return {
	    isSafari: isSafari(),
	    isUiWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(win.navigator.userAgent),
	  };
	}());
	
	var Browser = {
	  name: 'browser',
	  proto: {
	    browser: Browser$1,
	  },
	  static: {
	    browser: Browser$1,
	  },
	};
	
	var Resize = {
	  name: 'resize',
	  create: function create() {
	    var swiper = this;
	    Utils.extend(swiper, {
	      resize: {
	        resizeHandler: function resizeHandler() {
	          if (!swiper || swiper.destroyed || !swiper.initialized) { return; }
	          swiper.emit('beforeResize');
	          swiper.emit('resize');
	        },
	        orientationChangeHandler: function orientationChangeHandler() {
	          if (!swiper || swiper.destroyed || !swiper.initialized) { return; }
	          swiper.emit('orientationchange');
	        },
	      },
	    });
	  },
	  on: {
	    init: function init() {
	      var swiper = this;
	      // Emit resize
	      win.addEventListener('resize', swiper.resize.resizeHandler);
	
	      // Emit orientationchange
	      win.addEventListener('orientationchange', swiper.resize.orientationChangeHandler);
	    },
	    destroy: function destroy() {
	      var swiper = this;
	      win.removeEventListener('resize', swiper.resize.resizeHandler);
	      win.removeEventListener('orientationchange', swiper.resize.orientationChangeHandler);
	    },
	  },
	};
	
	var Observer = {
	  func: win.MutationObserver || win.WebkitMutationObserver,
	  attach: function attach(target, options) {
	    if ( options === void 0 ) options = {};
	
	    var swiper = this;
	
	    var ObserverFunc = Observer.func;
	    var observer = new ObserverFunc(function (mutations) {
	      mutations.forEach(function (mutation) {
	        swiper.emit('observerUpdate', mutation);
	      });
	    });
	
	    observer.observe(target, {
	      attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
	      childList: typeof options.childList === 'undefined' ? true : options.childList,
	      characterData: typeof options.characterData === 'undefined' ? true : options.characterData,
	    });
	
	    swiper.observer.observers.push(observer);
	  },
	  init: function init() {
	    var swiper = this;
	    if (!Support.observer || !swiper.params.observer) { return; }
	    if (swiper.params.observeParents) {
	      var containerParents = swiper.$el.parents();
	      for (var i = 0; i < containerParents.length; i += 1) {
	        swiper.observer.attach(containerParents[i]);
	      }
	    }
	    // Observe container
	    swiper.observer.attach(swiper.$el[0], { childList: false });
	
	    // Observe wrapper
	    swiper.observer.attach(swiper.$wrapperEl[0], { attributes: false });
	  },
	  destroy: function destroy() {
	    var swiper = this;
	    swiper.observer.observers.forEach(function (observer) {
	      observer.disconnect();
	    });
	    swiper.observer.observers = [];
	  },
	};
	
	var Observer$1 = {
	  name: 'observer',
	  params: {
	    observer: false,
	    observeParents: false,
	  },
	  create: function create() {
	    var swiper = this;
	    Utils.extend(swiper, {
	      observer: {
	        init: Observer.init.bind(swiper),
	        attach: Observer.attach.bind(swiper),
	        destroy: Observer.destroy.bind(swiper),
	        observers: [],
	      },
	    });
	  },
	  on: {
	    init: function init() {
	      var swiper = this;
	      swiper.observer.init();
	    },
	    destroy: function destroy() {
	      var swiper = this;
	      swiper.observer.destroy();
	    },
	  },
	};
	
	var Virtual = {
	  update: function update(force) {
	    var swiper = this;
	    var ref = swiper.params;
	    var slidesPerView = ref.slidesPerView;
	    var slidesPerGroup = ref.slidesPerGroup;
	    var centeredSlides = ref.centeredSlides;
	    var ref$1 = swiper.virtual;
	    var previousFrom = ref$1.from;
	    var previousTo = ref$1.to;
	    var slides = ref$1.slides;
	    var previousSlidesGrid = ref$1.slidesGrid;
	    var renderSlide = ref$1.renderSlide;
	    var previousOffset = ref$1.offset;
	    swiper.updateActiveIndex();
	    var activeIndex = swiper.activeIndex || 0;
	
	    var offsetProp;
	    if (swiper.rtl && swiper.isHorizontal()) { offsetProp = 'right'; }
	    else { offsetProp = swiper.isHorizontal() ? 'left' : 'top'; }
	
	    var slidesAfter;
	    var slidesBefore;
	    if (centeredSlides) {
	      slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup;
	      slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup;
	    } else {
	      slidesAfter = slidesPerView + (slidesPerGroup - 1);
	      slidesBefore = slidesPerGroup;
	    }
	    var from = Math.max((activeIndex || 0) - slidesBefore, 0);
	    var to = Math.min((activeIndex || 0) + slidesAfter, slides.length - 1);
	    var offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
	
	    Utils.extend(swiper.virtual, {
	      from: from,
	      to: to,
	      offset: offset,
	      slidesGrid: swiper.slidesGrid,
	    });
	
	    function onRendered() {
	      swiper.updateSlides();
	      swiper.updateProgress();
	      swiper.updateSlidesClasses();
	      if (swiper.lazy && swiper.params.lazy.enabled) {
	        swiper.lazy.load();
	      }
	    }
	
	    if (previousFrom === from && previousTo === to && !force) {
	      if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) {
	        swiper.slides.css(offsetProp, (offset + "px"));
	      }
	      swiper.updateProgress();
	      return;
	    }
	    if (swiper.params.virtual.renderExternal) {
	      swiper.params.virtual.renderExternal.call(swiper, {
	        offset: offset,
	        from: from,
	        to: to,
	        slides: (function getSlides() {
	          var slidesToRender = [];
	          for (var i = from; i <= to; i += 1) {
	            slidesToRender.push(slides[i]);
	          }
	          return slidesToRender;
	        }()),
	      });
	      onRendered();
	      return;
	    }
	    var prependIndexes = [];
	    var appendIndexes = [];
	    if (force) {
	      swiper.$wrapperEl.find(("." + (swiper.params.slideClass))).remove();
	    } else {
	      for (var i = previousFrom; i <= previousTo; i += 1) {
	        if (i < from || i > to) {
	          swiper.$wrapperEl.find(("." + (swiper.params.slideClass) + "[data-swiper-slide-index=\"" + i + "\"]")).remove();
	        }
	      }
	    }
	    for (var i$1 = 0; i$1 < slides.length; i$1 += 1) {
	      if (i$1 >= from && i$1 <= to) {
	        if (typeof previousTo === 'undefined' || force) {
	          appendIndexes.push(i$1);
	        } else {
	          if (i$1 > previousTo) { appendIndexes.push(i$1); }
	          if (i$1 < previousFrom) { prependIndexes.push(i$1); }
	        }
	      }
	    }
	    appendIndexes.forEach(function (index) {
	      swiper.$wrapperEl.append(renderSlide(slides[index], index));
	    });
	    prependIndexes.sort(function (a, b) { return a < b; }).forEach(function (index) {
	      swiper.$wrapperEl.prepend(renderSlide(slides[index], index));
	    });
	    swiper.$wrapperEl.children('.swiper-slide').css(offsetProp, (offset + "px"));
	    onRendered();
	  },
	  renderSlide: function renderSlide(slide, index) {
	    var swiper = this;
	    var params = swiper.params.virtual;
	    if (params.cache && swiper.virtual.cache[index]) {
	      return swiper.virtual.cache[index];
	    }
	    var $slideEl = params.renderSlide
	      ? $$1(params.renderSlide.call(swiper, slide, index))
	      : $$1(("<div class=\"" + (swiper.params.slideClass) + "\" data-swiper-slide-index=\"" + index + "\">" + slide + "</div>"));
	    if (!$slideEl.attr('data-swiper-slide-index')) { $slideEl.attr('data-swiper-slide-index', index); }
	    if (params.cache) { swiper.virtual.cache[index] = $slideEl; }
	    return $slideEl;
	  },
	  appendSlide: function appendSlide(slide) {
	    var swiper = this;
	    swiper.virtual.slides.push(slide);
	    swiper.virtual.update(true);
	  },
	  prependSlide: function prependSlide(slide) {
	    var swiper = this;
	    swiper.virtual.slides.unshift(slide);
	    if (swiper.params.virtual.cache) {
	      var cache = swiper.virtual.cache;
	      var newCache = {};
	      Object.keys(cache).forEach(function (cachedIndex) {
	        newCache[cachedIndex + 1] = cache[cachedIndex];
	      });
	      swiper.virtual.cache = newCache;
	    }
	    swiper.virtual.update(true);
	    swiper.slideNext(0);
	  },
	};
	
	var Virtual$1 = {
	  name: 'virtual',
	  params: {
	    virtual: {
	      enabled: false,
	      slides: [],
	      cache: true,
	      renderSlide: null,
	      renderExternal: null,
	    },
	  },
	  create: function create() {
	    var swiper = this;
	    Utils.extend(swiper, {
	      virtual: {
	        update: Virtual.update.bind(swiper),
	        appendSlide: Virtual.appendSlide.bind(swiper),
	        prependSlide: Virtual.prependSlide.bind(swiper),
	        renderSlide: Virtual.renderSlide.bind(swiper),
	        slides: swiper.params.virtual.slides,
	        cache: {},
	      },
	    });
	  },
	  on: {
	    beforeInit: function beforeInit() {
	      var swiper = this;
	      if (!swiper.params.virtual.enabled) { return; }
	      swiper.classNames.push(((swiper.params.containerModifierClass) + "virtual"));
	      var overwriteParams = {
	        watchSlidesProgress: true,
	      };
	      Utils.extend(swiper.params, overwriteParams);
	      Utils.extend(swiper.originalParams, overwriteParams);
	
	      swiper.virtual.update();
	    },
	    setTranslate: function setTranslate() {
	      var swiper = this;
	      if (!swiper.params.virtual.enabled) { return; }
	      swiper.virtual.update();
	    },
	  },
	};
	
	var Keyboard = {
	  handle: function handle(event) {
	    var swiper = this;
	    var e = event;
	    if (e.originalEvent) { e = e.originalEvent; } // jquery fix
	    var kc = e.keyCode || e.charCode;
	    // Directions locks
	    if (!swiper.allowSlideNext && ((swiper.isHorizontal() && kc === 39) || (swiper.isVertical() && kc === 40))) {
	      return false;
	    }
	    if (!swiper.allowSlidePrev && ((swiper.isHorizontal() && kc === 37) || (swiper.isVertical() && kc === 38))) {
	      return false;
	    }
	    if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) {
	      return undefined;
	    }
	    if (doc.activeElement && doc.activeElement.nodeName && (doc.activeElement.nodeName.toLowerCase() === 'input' || doc.activeElement.nodeName.toLowerCase() === 'textarea')) {
	      return undefined;
	    }
	    if (swiper.params.keyboard.onlyInViewport && (kc === 37 || kc === 39 || kc === 38 || kc === 40)) {
	      var inView = false;
	      // Check that swiper should be inside of visible area of window
	      if (swiper.$el.parents(("." + (swiper.params.slideClass))).length > 0 && swiper.$el.parents(("." + (swiper.params.slideActiveClass))).length === 0) {
	        return undefined;
	      }
	      var windowScroll = {
	        left: win.pageXOffset,
	        top: win.pageYOffset,
	      };
	      var windowWidth = win.innerWidth;
	      var windowHeight = win.innerHeight;
	      var swiperOffset = swiper.$el.offset();
	      if (swiper.rtl) { swiperOffset.left -= swiper.$el[0].scrollLeft; }
	      var swiperCoord = [
	        [swiperOffset.left, swiperOffset.top],
	        [swiperOffset.left + swiper.width, swiperOffset.top],
	        [swiperOffset.left, swiperOffset.top + swiper.height],
	        [swiperOffset.left + swiper.width, swiperOffset.top + swiper.height] ];
	      for (var i = 0; i < swiperCoord.length; i += 1) {
	        var point = swiperCoord[i];
	        if (
	          point[0] >= windowScroll.left && point[0] <= windowScroll.left + windowWidth &&
	            point[1] >= windowScroll.top && point[1] <= windowScroll.top + windowHeight
	        ) {
	          inView = true;
	        }
	      }
	      if (!inView) { return undefined; }
	    }
	    if (swiper.isHorizontal()) {
	      if (kc === 37 || kc === 39) {
	        if (e.preventDefault) { e.preventDefault(); }
	        else { e.returnValue = false; }
	      }
	      if ((kc === 39 && !swiper.rtl) || (kc === 37 && swiper.rtl)) { swiper.slideNext(); }
	      if ((kc === 37 && !swiper.rtl) || (kc === 39 && swiper.rtl)) { swiper.slidePrev(); }
	    } else {
	      if (kc === 38 || kc === 40) {
	        if (e.preventDefault) { e.preventDefault(); }
	        else { e.returnValue = false; }
	      }
	      if (kc === 40) { swiper.slideNext(); }
	      if (kc === 38) { swiper.slidePrev(); }
	    }
	    swiper.emit('keyPress', kc);
	    return undefined;
	  },
	  enable: function enable() {
	    var swiper = this;
	    if (swiper.keyboard.enabled) { return; }
	    $$1(doc).on('keydown', swiper.keyboard.handle);
	    swiper.keyboard.enabled = true;
	  },
	  disable: function disable() {
	    var swiper = this;
	    if (!swiper.keyboard.enabled) { return; }
	    $$1(doc).off('keydown', swiper.keyboard.handle);
	    swiper.keyboard.enabled = false;
	  },
	};
	
	var Keyboard$1 = {
	  name: 'keyboard',
	  params: {
	    keyboard: {
	      enabled: false,
	      onlyInViewport: true,
	    },
	  },
	  create: function create() {
	    var swiper = this;
	    Utils.extend(swiper, {
	      keyboard: {
	        enabled: false,
	        enable: Keyboard.enable.bind(swiper),
	        disable: Keyboard.disable.bind(swiper),
	        handle: Keyboard.handle.bind(swiper),
	      },
	    });
	  },
	  on: {
	    init: function init() {
	      var swiper = this;
	      if (swiper.params.keyboard.enabled) {
	        swiper.keyboard.enable();
	      }
	    },
	    destroy: function destroy() {
	      var swiper = this;
	      if (swiper.keyboard.enabled) {
	        swiper.keyboard.disable();
	      }
	    },
	  },
	};
	
	function isEventSupported() {
	  var eventName = 'onwheel';
	  var isSupported = eventName in doc;
	
	  if (!isSupported) {
	    var element = doc.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported &&
	    doc.implementation &&
	    doc.implementation.hasFeature &&
	    // always returns true in newer browsers as per the standard.
	    // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	    doc.implementation.hasFeature('', '') !== true
	  ) {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = doc.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	var Mousewheel = {
	  lastScrollTime: Utils.now(),
	  event: (function getEvent() {
	    if (win.navigator.userAgent.indexOf('firefox') > -1) { return 'DOMMouseScroll'; }
	    return isEventSupported() ? 'wheel' : 'mousewheel';
	  }()),
	  normalize: function normalize(e) {
	    // Reasonable defaults
	    var PIXEL_STEP = 10;
	    var LINE_HEIGHT = 40;
	    var PAGE_HEIGHT = 800;
	
	    var sX = 0;
	    var sY = 0; // spinX, spinY
	    var pX = 0;
	    var pY = 0; // pixelX, pixelY
	
	    // Legacy
	    if ('detail' in e) {
	      sY = e.detail;
	    }
	    if ('wheelDelta' in e) {
	      sY = -e.wheelDelta / 120;
	    }
	    if ('wheelDeltaY' in e) {
	      sY = -e.wheelDeltaY / 120;
	    }
	    if ('wheelDeltaX' in e) {
	      sX = -e.wheelDeltaX / 120;
	    }
	
	    // side scrolling on FF with DOMMouseScroll
	    if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
	      sX = sY;
	      sY = 0;
	    }
	
	    pX = sX * PIXEL_STEP;
	    pY = sY * PIXEL_STEP;
	
	    if ('deltaY' in e) {
	      pY = e.deltaY;
	    }
	    if ('deltaX' in e) {
	      pX = e.deltaX;
	    }
	
	    if ((pX || pY) && e.deltaMode) {
	      if (e.deltaMode === 1) { // delta in LINE units
	        pX *= LINE_HEIGHT;
	        pY *= LINE_HEIGHT;
	      } else { // delta in PAGE units
	        pX *= PAGE_HEIGHT;
	        pY *= PAGE_HEIGHT;
	      }
	    }
	
	    // Fall-back if spin cannot be determined
	    if (pX && !sX) {
	      sX = (pX < 1) ? -1 : 1;
	    }
	    if (pY && !sY) {
	      sY = (pY < 1) ? -1 : 1;
	    }
	
	    return {
	      spinX: sX,
	      spinY: sY,
	      pixelX: pX,
	      pixelY: pY,
	    };
	  },
	  handle: function handle(event) {
	    var e = event;
	    var swiper = this;
	    var params = swiper.params.mousewheel;
	    if (e.originalEvent) { e = e.originalEvent; } // jquery fix
	    var delta = 0;
	    var rtlFactor = swiper.rtl ? -1 : 1;
	
	    var data = Mousewheel.normalize(e);
	
	    if (params.forceToAxis) {
	      if (swiper.isHorizontal()) {
	        if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) { delta = data.pixelX * rtlFactor; }
	        else { return true; }
	      } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) { delta = data.pixelY; }
	      else { return true; }
	    } else {
	      delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
	    }
	
	    if (delta === 0) { return true; }
	
	    if (params.invert) { delta = -delta; }
	
	    if (!swiper.params.freeMode) {
	      if (Utils.now() - swiper.mousewheel.lastScrollTime > 60) {
	        if (delta < 0) {
	          if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
	            swiper.slideNext();
	            swiper.emit('scroll', e);
	          } else if (params.releaseOnEdges) { return true; }
	        } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
	          swiper.slidePrev();
	          swiper.emit('scroll', e);
	        } else if (params.releaseOnEdges) { return true; }
	      }
	      swiper.mousewheel.lastScrollTime = (new win.Date()).getTime();
	    } else {
	      // Freemode or scrollContainer:
	      var position = swiper.getTranslate() + (delta * params.sensitivity);
	      var wasBeginning = swiper.isBeginning;
	      var wasEnd = swiper.isEnd;
	
	      if (position >= swiper.minTranslate()) { position = swiper.minTranslate(); }
	      if (position <= swiper.maxTranslate()) { position = swiper.maxTranslate(); }
	
	      swiper.setTransition(0);
	      swiper.setTranslate(position);
	      swiper.updateProgress();
	      swiper.updateActiveIndex();
	      swiper.updateSlidesClasses();
	
	      if ((!wasBeginning && swiper.isBeginning) || (!wasEnd && swiper.isEnd)) {
	        swiper.updateSlidesClasses();
	      }
	
	      if (swiper.params.freeModeSticky) {
	        clearTimeout(swiper.mousewheel.timeout);
	        swiper.mousewheel.timeout = Utils.nextTick(function () {
	          swiper.slideReset();
	        }, 300);
	      }
	      // Emit event
	      swiper.emit('scroll', e);
	
	      // Stop autoplay
	      if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) { swiper.stopAutoplay(); }
	
	      // Return page scroll on edge positions
	      if (position === 0 || position === swiper.maxTranslate()) { return true; }
	    }
	
	    if (e.preventDefault) { e.preventDefault(); }
	    else { e.returnValue = false; }
	    return false;
	  },
	  enable: function enable() {
	    var swiper = this;
	    if (!Mousewheel.event) { return false; }
	    if (swiper.mousewheel.enabled) { return false; }
	    var target = swiper.$el;
	    if (swiper.params.mousewheel.eventsTarged !== 'container') {
	      target = $$1(swiper.params.mousewheel.eventsTarged);
	    }
	    target.on(Mousewheel.event, swiper.mousewheel.handle);
	    swiper.mousewheel.enabled = true;
	    return true;
	  },
	  disable: function disable() {
	    var swiper = this;
	    if (!Mousewheel.event) { return false; }
	    if (!swiper.mousewheel.enabled) { return false; }
	    var target = swiper.$el;
	    if (swiper.params.mousewheel.eventsTarged !== 'container') {
	      target = $$1(swiper.params.mousewheel.eventsTarged);
	    }
	    target.off(Mousewheel.event, swiper.mousewheel.handle);
	    swiper.mousewheel.enabled = false;
	    return true;
	  },
	};
	
	var Mousewheel$1 = {
	  name: 'mousewheel',
	  params: {
	    mousewheel: {
	      enabled: false,
	      releaseOnEdges: false,
	      invert: false,
	      forceToAxis: false,
	      sensitivity: 1,
	      eventsTarged: 'container',
	    },
	  },
	  create: function create() {
	    var swiper = this;
	    Utils.extend(swiper, {
	      mousewheel: {
	        enabled: false,
	        enable: Mousewheel.enable.bind(swiper),
	        disable: Mousewheel.disable.bind(swiper),
	        handle: Mousewheel.handle.bind(swiper),
	        lastScrollTime: Utils.now(),
	      },
	    });
	  },
	  on: {
	    init: function init() {
	      var swiper = this;
	      if (swiper.params.mousewheel.enabled) { swiper.mousewheel.enable(); }
	    },
	    destroy: function destroy() {
	      var swiper = this;
	      if (swiper.mousewheel.enabled) { swiper.mousewheel.disable(); }
	    },
	  },
	};
	
	var Navigation = {
	  update: function update() {
	    // Update Navigation Buttons
	    var swiper = this;
	    var params = swiper.params.navigation;
	
	    if (swiper.params.loop) { return; }
	    var ref = swiper.navigation;
	    var $nextEl = ref.$nextEl;
	    var $prevEl = ref.$prevEl;
	
	    if ($prevEl && $prevEl.length > 0) {
	      if (swiper.isBeginning) {
	        $prevEl.addClass(params.disabledClass);
	      } else {
	        $prevEl.removeClass(params.disabledClass);
	      }
	      $prevEl[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
	    }
	    if ($nextEl && $nextEl.length > 0) {
	      if (swiper.isEnd) {
	        $nextEl.addClass(params.disabledClass);
	      } else {
	        $nextEl.removeClass(params.disabledClass);
	      }
	      $nextEl[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
	    }
	  },
	  init: function init() {
	    var swiper = this;
	    var params = swiper.params.navigation;
	    if (!(params.nextEl || params.prevEl)) { return; }
	
	    var $nextEl;
	    var $prevEl;
	    if (params.nextEl) {
	      $nextEl = $$1(params.nextEl);
	      if (
	        swiper.params.uniqueNavElements &&
	        typeof params.nextEl === 'string' &&
	        $nextEl.length > 1 &&
	        swiper.$el.find(params.nextEl).length === 1
	      ) {
	        $nextEl = swiper.$el.find(params.nextEl);
	      }
	    }
	    if (params.prevEl) {
	      $prevEl = $$1(params.prevEl);
	      if (
	        swiper.params.uniqueNavElements &&
	        typeof params.prevEl === 'string' &&
	        $prevEl.length > 1 &&
	        swiper.$el.find(params.prevEl).length === 1
	      ) {
	        $prevEl = swiper.$el.find(params.prevEl);
	      }
	    }
	
	    if ($nextEl && $nextEl.length > 0) {
	      $nextEl.on('click', function (e) {
	        e.preventDefault();
	        if (swiper.isEnd && !swiper.params.loop) { return; }
	        swiper.slideNext();
	      });
	    }
	    if ($prevEl && $prevEl.length > 0) {
	      $prevEl.on('click', function (e) {
	        e.preventDefault();
	        if (swiper.isBeginning && !swiper.params.loop) { return; }
	        swiper.slidePrev();
	      });
	    }
	
	    Utils.extend(swiper.navigation, {
	      $nextEl: $nextEl,
	      nextEl: $nextEl && $nextEl[0],
	      $prevEl: $prevEl,
	      prevEl: $prevEl && $prevEl[0],
	    });
	  },
	  destroy: function destroy() {
	    var swiper = this;
	    var ref = swiper.navigation;
	    var $nextEl = ref.$nextEl;
	    var $prevEl = ref.$prevEl;
	    if ($nextEl && $nextEl.length) {
	      $nextEl.off('click');
	      $nextEl.removeClass(swiper.params.navigation.disabledClass);
	    }
	    if ($prevEl && $prevEl.length) {
	      $prevEl.off('click');
	      $prevEl.removeClass(swiper.params.navigation.disabledClass);
	    }
	  },
	};
	
	var Navigation$1 = {
	  name: 'navigation',
	  params: {
	    navigation: {
	      nextEl: null,
	      prevEl: null,
	
	      hideOnClick: false,
	      disabledClass: 'swiper-button-disabled',
	      hiddenClass: 'swiper-button-hidden',
	      lockClass: 'swiper-button-lock',
	    },
	  },
	  create: function create() {
	    var swiper = this;
	    Utils.extend(swiper, {
	      navigation: {
	        init: Navigation.init.bind(swiper),
	        update: Navigation.update.bind(swiper),
	        destroy: Navigation.destroy.bind(swiper),
	      },
	    });
	  },
	  on: {
	    init: function init() {
	      var swiper = this;
	      swiper.navigation.init();
	      swiper.navigation.update();
	    },
	    toEdge: function toEdge() {
	      var swiper = this;
	      swiper.navigation.update();
	    },
	    fromEdge: function fromEdge() {
	      var swiper = this;
	      swiper.navigation.update();
	    },
	    destroy: function destroy() {
	      var swiper = this;
	      swiper.navigation.destroy();
	    },
	    click: function click(e) {
	      var swiper = this;
	      var ref = swiper.navigation;
	      var $nextEl = ref.$nextEl;
	      var $prevEl = ref.$prevEl;
	      if (
	        swiper.params.navigation.hideOnClick &&
	        !$$1(e.target).is($prevEl) &&
	        !$$1(e.target).is($nextEl)
	      ) {
	        if ($nextEl) { $nextEl.toggleClass(swiper.params.navigation.hiddenClass); }
	        if ($prevEl) { $prevEl.toggleClass(swiper.params.navigation.hiddenClass); }
	      }
	    },
	  },
	};
	
	var Pagination = {
	  update: function update() {
	    // Render || Update Pagination bullets/items
	    var swiper = this;
	    var rtl = swiper.rtl;
	    var params = swiper.params.pagination;
	    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) { return; }
	    var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
	    var $el = swiper.pagination.$el;
	    // Current/Total
	    var current;
	    var total = swiper.params.loop ? Math.ceil((slidesLength - (swiper.loopedSlides * 2)) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
	    if (swiper.params.loop) {
	      current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);
	      if (current > slidesLength - 1 - (swiper.loopedSlides * 2)) {
	        current -= (slidesLength - (swiper.loopedSlides * 2));
	      }
	      if (current > total - 1) { current -= total; }
	      if (current < 0 && swiper.params.paginationType !== 'bullets') { current = total + current; }
	    } else if (typeof swiper.snapIndex !== 'undefined') {
	      current = swiper.snapIndex;
	    } else {
	      current = swiper.activeIndex || 0;
	    }
	    // Types
	    if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
	      var bullets = swiper.pagination.bullets;
	      if (params.dynamicBullets) {
	        swiper.pagination.bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
	        $el.css(swiper.isHorizontal() ? 'width' : 'height', ((swiper.pagination.bulletSize * 5) + "px"));
	      }
	      bullets.removeClass(((params.bulletActiveClass) + " " + (params.bulletActiveClass) + "-next " + (params.bulletActiveClass) + "-next-next " + (params.bulletActiveClass) + "-prev " + (params.bulletActiveClass) + "-prev-prev"));
	      if ($el.length > 1) {
	        bullets.each(function (index, bullet) {
	          var $bullet = $$1(bullet);
	          if ($bullet.index() === current) {
	            $bullet.addClass(params.bulletActiveClass);
	            if (params.dynamicBullets) {
	              $bullet
	                .prev()
	                .addClass(((params.bulletActiveClass) + "-prev"))
	                .prev()
	                .addClass(((params.bulletActiveClass) + "-prev-prev"));
	              $bullet
	                .next()
	                .addClass(((params.bulletActiveClass) + "-next"))
	                .next()
	                .addClass(((params.bulletActiveClass) + "-next-next"));
	            }
	          }
	        });
	      } else {
	        var $bullet = bullets.eq(current);
	        $bullet.addClass(params.bulletActiveClass);
	        if (params.dynamicBullets) {
	          $bullet
	            .prev()
	            .addClass(((params.bulletActiveClass) + "-prev"))
	            .prev()
	            .addClass(((params.bulletActiveClass) + "-prev-prev"));
	          $bullet
	            .next()
	            .addClass(((params.bulletActiveClass) + "-next"))
	            .next()
	            .addClass(((params.bulletActiveClass) + "-next-next"));
	        }
	      }
	      if (params.dynamicBullets) {
	        var dynamicBulletsLength = Math.min(bullets.length, 5);
	        var bulletsOffset = (((swiper.pagination.bulletSize * dynamicBulletsLength) - (swiper.pagination.bulletSize)) / 2) - (current * swiper.pagination.bulletSize);
	        var offsetProp = rtl ? 'right' : 'left';
	        bullets.css(swiper.isHorizontal() ? offsetProp : 'top', (bulletsOffset + "px"));
	      }
	    }
	    if (params.type === 'fraction') {
	      $el.find(("." + (params.currentClass))).text(current + 1);
	      $el.find(("." + (params.totalClass))).text(total);
	    }
	    if (params.type === 'progressbar') {
	      var scale = (current + 1) / total;
	      var scaleX = scale;
	      var scaleY = 1;
	      if (!swiper.isHorizontal()) {
	        scaleY = scale;
	        scaleX = 1;
	      }
	      $el.find(("." + (params.progressbarFillClass))).transform(("translate3d(0,0,0) scaleX(" + scaleX + ") scaleY(" + scaleY + ")")).transition(swiper.params.speed);
	    }
	    if (params.type === 'custom' && params.renderCustom) {
	      $el.html(params.renderCustom(swiper, current + 1, total));
	      swiper.emit('paginationRender', swiper, $el[0]);
	    } else {
	      swiper.emit('paginationUpdate', swiper, $el[0]);
	    }
	    $el[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
	  },
	  render: function render() {
	    // Render Container
	    var swiper = this;
	    var params = swiper.params.pagination;
	    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) { return; }
	    var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
	
	    var $el = swiper.pagination.$el;
	    var paginationHTML = '';
	    if (params.type === 'bullets') {
	      var numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - (swiper.loopedSlides * 2)) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
	      for (var i = 0; i < numberOfBullets; i += 1) {
	        if (params.renderBullet) {
	          paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
	        } else {
	          paginationHTML += "<" + (params.bulletElement) + " class=\"" + (params.bulletClass) + "\"></" + (params.bulletElement) + ">";
	        }
	      }
	      $el.html(paginationHTML);
	      swiper.pagination.bullets = $el.find(("." + (params.bulletClass)));
	    }
	    if (params.type === 'fraction') {
	      if (params.renderFraction) {
	        paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
	      } else {
	        paginationHTML =
	        "<span class=\"" + (params.currentClass) + "\"></span>" +
	        ' / ' +
	        "<span class=\"" + (params.totalClass) + "\"></span>";
	      }
	      $el.html(paginationHTML);
	    }
	    if (params.type === 'progressbar') {
	      if (params.renderProgressbar) {
	        paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
	      } else {
	        paginationHTML = "<span class=\"" + (params.progressbarFillClass) + "\"></span>";
	      }
	      $el.html(paginationHTML);
	    }
	    if (params.type !== 'custom') {
	      swiper.emit('paginationRender', swiper.pagination.$el[0]);
	    }
	  },
	  init: function init() {
	    var swiper = this;
	    var params = swiper.params.pagination;
	    if (!params.el) { return; }
	
	    var $el = $$1(params.el);
	    if ($el.length === 0) { return; }
	
	    if (
	      swiper.params.uniqueNavElements &&
	      typeof params.el === 'string' &&
	      $el.length > 1 &&
	      swiper.$el.find(params.el).length === 1
	    ) {
	      $el = swiper.$el.find(params.el);
	    }
	
	    if (params.type === 'bullets' && params.clickable) {
	      $el.addClass(params.clickableClass);
	    }
	
	    $el.addClass(params.modifierClass + params.type);
	
	    if (params.type === 'bullets' && params.dynamicBullets) {
	      $el.addClass(("" + (params.modifierClass) + (params.type) + "-dynamic"));
	    }
	
	    if (params.clickable) {
	      $el.on('click', ("." + (params.bulletClass)), function onClick(e) {
	        e.preventDefault();
	        var index = $$1(this).index() * swiper.params.slidesPerGroup;
	        if (swiper.params.loop) { index += swiper.loopedSlides; }
	        swiper.slideTo(index);
	      });
	    }
	
	    Utils.extend(swiper.pagination, {
	      $el: $el,
	      el: $el[0],
	    });
	  },
	  destroy: function destroy() {
	    var swiper = this;
	    var params = swiper.params.pagination;
	    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) { return; }
	    var $el = swiper.pagination.$el;
	
	    $el.removeClass(params.hiddenClass);
	    $el.removeClass(params.modifierClass + params.type);
	    if (swiper.pagination.bullets) { swiper.pagination.bullets.removeClass(params.bulletActiveClass); }
	    if (params.clickable) {
	      $el.off('click', ("." + (params.bulletClass)));
	    }
	  },
	};
	
	var Pagination$1 = {
	  name: 'pagination',
	  params: {
	    pagination: {
	      el: null,
	      bulletElement: 'span',
	      clickable: false,
	      hideOnClick: false,
	      renderBullet: null,
	      renderProgressbar: null,
	      renderFraction: null,
	      renderCustom: null,
	      type: 'bullets', // 'bullets' or 'progressbar' or 'fraction' or 'custom'
	      dynamicBullets: false,
	
	      bulletClass: 'swiper-pagination-bullet',
	      bulletActiveClass: 'swiper-pagination-bullet-active',
	      modifierClass: 'swiper-pagination-', // NEW
	      currentClass: 'swiper-pagination-current',
	      totalClass: 'swiper-pagination-total',
	      hiddenClass: 'swiper-pagination-hidden',
	      progressbarFillClass: 'swiper-pagination-progressbar-fill',
	      clickableClass: 'swiper-pagination-clickable', // NEW
	      lockClass: 'swiper-pagination-lock',
	    },
	  },
	  create: function create() {
	    var swiper = this;
	    Utils.extend(swiper, {
	      pagination: {
	        init: Pagination.init.bind(swiper),
	        render: Pagination.render.bind(swiper),
	        update: Pagination.update.bind(swiper),
	        destroy: Pagination.destroy.bind(swiper),
	      },
	    });
	  },
	  on: {
	    init: function init() {
	      var swiper = this;
	      swiper.pagination.init();
	      swiper.pagination.render();
	      swiper.pagination.update();
	    },
	    activeIndexChange: function activeIndexChange() {
	      var swiper = this;
	      if (swiper.params.loop) {
	        swiper.pagination.update();
	      } else if (typeof swiper.snapIndex === 'undefined') {
	        swiper.pagination.update();
	      }
	    },
	    snapIndexChange: function snapIndexChange() {
	      var swiper = this;
	      if (!swiper.params.loop) {
	        swiper.pagination.update();
	      }
	    },
	    slidesLengthChange: function slidesLengthChange() {
	      var swiper = this;
	      if (swiper.params.loop) {
	        swiper.pagination.render();
	        swiper.pagination.update();
	      }
	    },
	    snapGridLengthChange: function snapGridLengthChange() {
	      var swiper = this;
	      if (!swiper.params.loop) {
	        swiper.pagination.render();
	        swiper.pagination.update();
	      }
	    },
	    destroy: function destroy() {
	      var swiper = this;
	      swiper.pagination.destroy();
	    },
	    click: function click(e) {
	      var swiper = this;
	      if (
	        swiper.params.pagination.el &&
	        swiper.params.pagination.hideOnClick &&
	        swiper.pagination.$el.length > 0 &&
	        !$$1(e.target).hasClass(swiper.params.pagination.bulletClass)
	      ) {
	        swiper.pagination.$el.toggleClass(swiper.params.pagination.hiddenClass);
	      }
	    },
	  },
	};
	
	var Scrollbar = {
	  setTranslate: function setTranslate() {
	    var swiper = this;
	    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) { return; }
	    var scrollbar = swiper.scrollbar;
	    var rtl = swiper.rtl;
	    var progress = swiper.progress;
	    var dragSize = scrollbar.dragSize;
	    var trackSize = scrollbar.trackSize;
	    var $dragEl = scrollbar.$dragEl;
	    var $el = scrollbar.$el;
	    var params = swiper.params.scrollbar;
	
	    var newSize = dragSize;
	    var newPos = (trackSize - dragSize) * progress;
	    if (rtl && swiper.isHorizontal()) {
	      newPos = -newPos;
	      if (newPos > 0) {
	        newSize = dragSize - newPos;
	        newPos = 0;
	      } else if (-newPos + dragSize > trackSize) {
	        newSize = trackSize + newPos;
	      }
	    } else if (newPos < 0) {
	      newSize = dragSize + newPos;
	      newPos = 0;
	    } else if (newPos + dragSize > trackSize) {
	      newSize = trackSize - newPos;
	    }
	    if (swiper.isHorizontal()) {
	      if (Support.transforms3d) {
	        $dragEl.transform(("translate3d(" + newPos + "px, 0, 0)"));
	      } else {
	        $dragEl.transform(("translateX(" + newPos + "px)"));
	      }
	      $dragEl[0].style.width = newSize + "px";
	    } else {
	      if (Support.transforms3d) {
	        $dragEl.transform(("translate3d(0px, " + newPos + "px, 0)"));
	      } else {
	        $dragEl.transform(("translateY(" + newPos + "px)"));
	      }
	      $dragEl[0].style.height = newSize + "px";
	    }
	    if (params.hide) {
	      clearTimeout(swiper.scrollbar.timeout);
	      $el[0].style.opacity = 1;
	      swiper.scrollbar.timeout = setTimeout(function () {
	        $el[0].style.opacity = 0;
	        $el.transition(400);
	      }, 1000);
	    }
	  },
	  setTransition: function setTransition(duration) {
	    var swiper = this;
	    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) { return; }
	    swiper.scrollbar.$dragEl.transition(duration);
	  },
	  updateSize: function updateSize() {
	    var swiper = this;
	    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) { return; }
	
	    var scrollbar = swiper.scrollbar;
	    var $dragEl = scrollbar.$dragEl;
	    var $el = scrollbar.$el;
	
	    $dragEl[0].style.width = '';
	    $dragEl[0].style.height = '';
	    var trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;
	
	    var divider = swiper.size / swiper.virtualSize;
	    var moveDivider = divider * (trackSize / swiper.size);
	    var dragSize;
	    if (swiper.params.scrollbar.dragSize === 'auto') {
	      dragSize = trackSize * divider;
	    } else {
	      dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
	    }
	
	    if (swiper.isHorizontal()) {
	      $dragEl[0].style.width = dragSize + "px";
	    } else {
	      $dragEl[0].style.height = dragSize + "px";
	    }
	
	    if (divider >= 1) {
	      $el[0].style.display = 'none';
	    } else {
	      $el[0].style.display = '';
	    }
	    if (swiper.params.scrollbarHide) {
	      $el[0].style.opacity = 0;
	    }
	    Utils.extend(scrollbar, {
	      trackSize: trackSize,
	      divider: divider,
	      moveDivider: moveDivider,
	      dragSize: dragSize,
	    });
	    scrollbar.$el[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](swiper.params.scrollbar.lockClass);
	  },
	  setDragPosition: function setDragPosition(e) {
	    var swiper = this;
	    var scrollbar = swiper.scrollbar;
	    var $el = scrollbar.$el;
	    var dragSize = scrollbar.dragSize;
	    var trackSize = scrollbar.trackSize;
	
	    var pointerPosition;
	    if (swiper.isHorizontal()) {
	      pointerPosition = ((e.type === 'touchstart' || e.type === 'touchmove') ? e.targetTouches[0].pageX : e.pageX || e.clientX);
	    } else {
	      pointerPosition = ((e.type === 'touchstart' || e.type === 'touchmove') ? e.targetTouches[0].pageY : e.pageY || e.clientY);
	    }
	    var positionRatio;
	    positionRatio = ((pointerPosition) - $el.offset()[swiper.isHorizontal() ? 'left' : 'top'] - (dragSize / 2)) / (trackSize - dragSize);
	    positionRatio = Math.max(Math.min(positionRatio, 1), 0);
	    if (swiper.rtl) {
	      positionRatio = 1 - positionRatio;
	    }
	
	    var position = swiper.minTranslate() + ((swiper.maxTranslate() - swiper.minTranslate()) * positionRatio);
	
	    swiper.updateProgress(position);
	    swiper.setTranslate(position);
	    swiper.updateActiveIndex();
	    swiper.updateSlidesClasses();
	  },
	  onDragStart: function onDragStart(e) {
	    var swiper = this;
	    var params = swiper.params.scrollbar;
	    var scrollbar = swiper.scrollbar;
	    var $wrapperEl = swiper.$wrapperEl;
	    var $el = scrollbar.$el;
	    var $dragEl = scrollbar.$dragEl;
	    swiper.scrollbar.isTouched = true;
	    e.preventDefault();
	    e.stopPropagation();
	
	    $wrapperEl.transition(100);
	    $dragEl.transition(100);
	    scrollbar.setDragPosition(e);
	
	    clearTimeout(swiper.scrollbar.dragTimeout);
	
	    $el.transition(0);
	    if (params.hide) {
	      $el.css('opacity', 1);
	    }
	    swiper.emit('scrollbarDragStart', e);
	  },
	  onDragMove: function onDragMove(e) {
	    var swiper = this;
	    var scrollbar = swiper.scrollbar;
	    var $wrapperEl = swiper.$wrapperEl;
	    var $el = scrollbar.$el;
	    var $dragEl = scrollbar.$dragEl;
	
	    if (!swiper.scrollbar.isTouched) { return; }
	    if (e.preventDefault) { e.preventDefault(); }
	    else { e.returnValue = false; }
	    scrollbar.setDragPosition(e);
	    $wrapperEl.transition(0);
	    $el.transition(0);
	    $dragEl.transition(0);
	    swiper.emit('scrollbarDragMove', e);
	  },
	  onDragEnd: function onDragEnd(e) {
	    var swiper = this;
	
	    var params = swiper.params.scrollbar;
	    var scrollbar = swiper.scrollbar;
	    var $el = scrollbar.$el;
	
	    if (!swiper.scrollbar.isTouched) { return; }
	    swiper.scrollbar.isTouched = false;
	    if (params.hide) {
	      clearTimeout(swiper.scrollbar.dragTimeout);
	      swiper.scrollbar.dragTimeout = Utils.nextTick(function () {
	        $el.css('opacity', 0);
	        $el.transition(400);
	      }, 1000);
	    }
	    swiper.emit('scrollbarDragEnd', e);
	    if (params.snapOnRelease) {
	      swiper.slideReset();
	    }
	  },
	  enableDraggable: function enableDraggable() {
	    var swiper = this;
	    if (!swiper.params.scrollbar.el) { return; }
	    var scrollbar = swiper.scrollbar;
	    var $el = scrollbar.$el;
	    var target = Support.touch ? $el[0] : document;
	    $el.on(swiper.scrollbar.dragEvents.start, swiper.scrollbar.onDragStart);
	    $$1(target).on(swiper.scrollbar.dragEvents.move, swiper.scrollbar.onDragMove);
	    $$1(target).on(swiper.scrollbar.dragEvents.end, swiper.scrollbar.onDragEnd);
	  },
	  disableDraggable: function disableDraggable() {
	    var swiper = this;
	    if (!swiper.params.scrollbar.el) { return; }
	    var scrollbar = swiper.scrollbar;
	    var $el = scrollbar.$el;
	    var target = Support.touch ? $el[0] : document;
	    $el.off(swiper.scrollbar.dragEvents.start);
	    $$1(target).off(swiper.scrollbar.dragEvents.move);
	    $$1(target).off(swiper.scrollbar.dragEvents.end);
	  },
	  init: function init() {
	    var swiper = this;
	    if (!swiper.params.scrollbar.el) { return; }
	    var scrollbar = swiper.scrollbar;
	    var $swiperEl = swiper.$el;
	    var touchEvents = swiper.touchEvents;
	    var params = swiper.params.scrollbar;
	
	    var $el = $$1(params.el);
	    if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1 && $swiperEl.find(params.el).length === 1) {
	      $el = $swiperEl.find(params.el);
	    }
	
	    var $dragEl = $el.find('.swiper-scrollbar-drag');
	    if ($dragEl.length === 0) {
	      $dragEl = $$1('<div class="swiper-scrollbar-drag"></div>');
	      $el.append($dragEl);
	    }
	
	    swiper.scrollbar.dragEvents = (function dragEvents() {
	      if ((swiper.params.simulateTouch === false && !Support.touch)) {
	        return {
	          start: 'mousedown',
	          move: 'mousemove',
	          end: 'mouseup',
	        };
	      }
	      return touchEvents;
	    }());
	
	    Utils.extend(scrollbar, {
	      $el: $el,
	      el: $el[0],
	      $dragEl: $dragEl,
	      dragEl: $dragEl[0],
	    });
	
	    if (params.draggable) {
	      scrollbar.enableDraggable();
	    }
	  },
	  destroy: function destroy() {
	    var swiper = this;
	    swiper.scrollbar.disableDraggable();
	  },
	};
	
	var Scrollbar$1 = {
	  name: 'scrollbar',
	  params: {
	    scrollbar: {
	      el: null,
	      dragSize: 'auto',
	      hide: false,
	      draggable: false,
	      snapOnRelease: true,
	      lockClass: 'swiper-scrollbar-lock',
	    },
	  },
	  create: function create() {
	    var swiper = this;
	    Utils.extend(swiper, {
	      scrollbar: {
	        init: Scrollbar.init.bind(swiper),
	        destroy: Scrollbar.destroy.bind(swiper),
	        updateSize: Scrollbar.updateSize.bind(swiper),
	        setTranslate: Scrollbar.setTranslate.bind(swiper),
	        setTransition: Scrollbar.setTransition.bind(swiper),
	        enableDraggable: Scrollbar.enableDraggable.bind(swiper),
	        disableDraggable: Scrollbar.disableDraggable.bind(swiper),
	        setDragPosition: Scrollbar.setDragPosition.bind(swiper),
	        onDragStart: Scrollbar.onDragStart.bind(swiper),
	        onDragMove: Scrollbar.onDragMove.bind(swiper),
	        onDragEnd: Scrollbar.onDragEnd.bind(swiper),
	        isTouched: false,
	        timeout: null,
	        dragTimeout: null,
	      },
	    });
	  },
	  on: {
	    init: function init() {
	      var swiper = this;
	      swiper.scrollbar.init();
	      swiper.scrollbar.updateSize();
	      swiper.scrollbar.setTranslate();
	    },
	    update: function update() {
	      var swiper = this;
	      swiper.scrollbar.updateSize();
	    },
	    resize: function resize() {
	      var swiper = this;
	      swiper.scrollbar.updateSize();
	    },
	    observerUpdate: function observerUpdate() {
	      var swiper = this;
	      swiper.scrollbar.updateSize();
	    },
	    setTranslate: function setTranslate() {
	      var swiper = this;
	      swiper.scrollbar.setTranslate();
	    },
	    setTransition: function setTransition(duration) {
	      var swiper = this;
	      swiper.scrollbar.setTransition(duration);
	    },
	    destroy: function destroy() {
	      var swiper = this;
	      swiper.scrollbar.destroy();
	    },
	  },
	};
	
	var Parallax = {
	  setTransform: function setTransform(el, progress) {
	    var swiper = this;
	    var rtl = swiper.rtl;
	
	    var $el = $$1(el);
	    var rtlFactor = rtl ? -1 : 1;
	
	    var p = $el.attr('data-swiper-parallax') || '0';
	    var x = $el.attr('data-swiper-parallax-x');
	    var y = $el.attr('data-swiper-parallax-y');
	    var scale = $el.attr('data-swiper-parallax-scale');
	    var opacity = $el.attr('data-swiper-parallax-opacity');
	
	    if (x || y) {
	      x = x || '0';
	      y = y || '0';
	    } else if (swiper.isHorizontal()) {
	      x = p;
	      y = '0';
	    } else {
	      y = p;
	      x = '0';
	    }
	
	    if ((x).indexOf('%') >= 0) {
	      x = (parseInt(x, 10) * progress * rtlFactor) + "%";
	    } else {
	      x = (x * progress * rtlFactor) + "px";
	    }
	    if ((y).indexOf('%') >= 0) {
	      y = (parseInt(y, 10) * progress) + "%";
	    } else {
	      y = (y * progress) + "px";
	    }
	
	    if (typeof opacity !== 'undefined' && opacity !== null) {
	      var currentOpacity = opacity - ((opacity - 1) * (1 - Math.abs(progress)));
	      $el[0].style.opacity = currentOpacity;
	    }
	    if (typeof scale === 'undefined' || scale === null) {
	      $el.transform(("translate3d(" + x + ", " + y + ", 0px)"));
	    } else {
	      var currentScale = scale - ((scale - 1) * (1 - Math.abs(progress)));
	      $el.transform(("translate3d(" + x + ", " + y + ", 0px) scale(" + currentScale + ")"));
	    }
	  },
	  setTranslate: function setTranslate() {
	    var swiper = this;
	    var $el = swiper.$el;
	    var slides = swiper.slides;
	    var progress = swiper.progress;
	    var snapGrid = swiper.snapGrid;
	    $el.children('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]')
	      .each(function (index, el) {
	        swiper.parallax.setTransform(el, progress);
	      });
	    slides.each(function (slideIndex, slideEl) {
	      var slideProgress = slideEl.progress;
	      if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') {
	        slideProgress += Math.ceil(slideIndex / 2) - (progress * (snapGrid.length - 1));
	      }
	      slideProgress = Math.min(Math.max(slideProgress, -1), 1);
	      $$1(slideEl).find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]')
	        .each(function (index, el) {
	          swiper.parallax.setTransform(el, slideProgress);
	        });
	    });
	  },
	  setTransition: function setTransition(duration) {
	    if ( duration === void 0 ) duration = this.params.speed;
	
	    var swiper = this;
	    var $el = swiper.$el;
	    $el.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]')
	      .each(function (index, parallaxEl) {
	        var $parallaxEl = $$1(parallaxEl);
	        var parallaxDuration = parseInt($parallaxEl.attr('data-swiper-parallax-duration'), 10) || duration;
	        if (duration === 0) { parallaxDuration = 0; }
	        $parallaxEl.transition(parallaxDuration);
	      });
	  },
	};
	
	var Parallax$1 = {
	  name: 'parallax',
	  params: {
	    parallax: {
	      enabled: false,
	    },
	  },
	  create: function create() {
	    var swiper = this;
	    Utils.extend(swiper, {
	      parallax: {
	        setTransform: Parallax.setTransform.bind(swiper),
	        setTranslate: Parallax.setTranslate.bind(swiper),
	        setTransition: Parallax.setTransition.bind(swiper),
	      },
	    });
	  },
	  on: {
	    beforeInit: function beforeInit() {
	      var swiper = this;
	      swiper.params.watchSlidesProgress = true;
	    },
	    init: function init() {
	      var swiper = this;
	      if (!swiper.params.parallax) { return; }
	      swiper.parallax.setTranslate();
	    },
	    setTranslate: function setTranslate() {
	      var swiper = this;
	      if (!swiper.params.parallax) { return; }
	      swiper.parallax.setTranslate();
	    },
	    setTransition: function setTransition(duration) {
	      var swiper = this;
	      if (!swiper.params.parallax) { return; }
	      swiper.parallax.setTransition(duration);
	    },
	  },
	};
	
	var Zoom = {
	  // Calc Scale From Multi-touches
	  getDistanceBetweenTouches: function getDistanceBetweenTouches(e) {
	    if (e.targetTouches.length < 2) { return 1; }
	    var x1 = e.targetTouches[0].pageX;
	    var y1 = e.targetTouches[0].pageY;
	    var x2 = e.targetTouches[1].pageX;
	    var y2 = e.targetTouches[1].pageY;
	    var distance = Math.sqrt((Math.pow( (x2 - x1), 2 )) + (Math.pow( (y2 - y1), 2 )));
	    return distance;
	  },
	  // Events
	  onGestureStart: function onGestureStart(e) {
	    var swiper = this;
	    var params = swiper.params.zoom;
	    var zoom = swiper.zoom;
	    var gesture = zoom.gesture;
	    zoom.fakeGestureTouched = false;
	    zoom.fakeGestureMoved = false;
	    if (!Support.gestures) {
	      if (e.type !== 'touchstart' || (e.type === 'touchstart' && e.targetTouches.length < 2)) {
	        return;
	      }
	      zoom.fakeGestureTouched = true;
	      gesture.scaleStart = Zoom.getDistanceBetweenTouches(e);
	    }
	    if (!gesture.$slideEl || !gesture.$slideEl.length) {
	      gesture.$slideEl = $$1(this);
	      if (gesture.$slideEl.length === 0) { gesture.$slideEl = swiper.slides.eq(swiper.activeIndex); }
	      gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas');
	      gesture.$imageWrapEl = gesture.$imageEl.parent(("." + (params.containerClass)));
	      gesture.maxRatio = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
	      if (gesture.$imageWrapEl.length === 0) {
	        gesture.$imageEl = undefined;
	        return;
	      }
	    }
	    gesture.$imageEl.transition(0);
	    swiper.zoom.isScaling = true;
	  },
	  onGestureChange: function onGestureChange(e) {
	    var swiper = this;
	    var params = swiper.params.zoom;
	    var zoom = swiper.zoom;
	    var gesture = zoom.gesture;
	    if (!Support.gestures) {
	      if (e.type !== 'touchmove' || (e.type === 'touchmove' && e.targetTouches.length < 2)) {
	        return;
	      }
	      zoom.fakeGestureMoved = true;
	      gesture.scaleMove = Zoom.getDistanceBetweenTouches(e);
	    }
	    if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
	    if (Support.gestures) {
	      swiper.zoom.scale = e.scale * zoom.currentScale;
	    } else {
	      zoom.scale = (gesture.scaleMove / gesture.scaleStart) * zoom.currentScale;
	    }
	    if (zoom.scale > gesture.maxRatio) {
	      zoom.scale = (gesture.maxRatio - 1) + (Math.pow( ((zoom.scale - gesture.maxRatio) + 1), 0.5 ));
	    }
	    if (zoom.scale < params.minRatio) {
	      zoom.scale = (params.minRatio + 1) - (Math.pow( ((params.minRatio - zoom.scale) + 1), 0.5 ));
	    }
	    gesture.$imageEl.transform(("translate3d(0,0,0) scale(" + (zoom.scale) + ")"));
	  },
	  onGestureEnd: function onGestureEnd(e) {
	    var swiper = this;
	    var params = swiper.params.zoom;
	    var zoom = swiper.zoom;
	    var gesture = zoom.gesture;
	    if (!Support.gestures) {
	      if (!zoom.fakeGestureTouched || !zoom.fakeGestureMoved) {
	        return;
	      }
	      if (e.type !== 'touchend' || (e.type === 'touchend' && e.changedTouches.length < 2 && !Device.android)) {
	        return;
	      }
	      zoom.fakeGestureTouched = false;
	      zoom.fakeGestureMoved = false;
	    }
	    if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
	    zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
	    gesture.$imageEl.transition(swiper.params.speed).transform(("translate3d(0,0,0) scale(" + (zoom.scale) + ")"));
	    zoom.currentScale = zoom.scale;
	    zoom.isScaling = false;
	    if (zoom.scale === 1) { gesture.$slideEl = undefined; }
	  },
	  onTouchStart: function onTouchStart(e) {
	    var swiper = this;
	    var zoom = swiper.zoom;
	    var gesture = zoom.gesture;
	    var image = zoom.image;
	    if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
	    if (image.isTouched) { return; }
	    if (Device.android) { e.preventDefault(); }
	    image.isTouched = true;
	    image.touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
	    image.touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
	  },
	  onTouchMove: function onTouchMove(e) {
	    var swiper = this;
	    var zoom = swiper.zoom;
	    var gesture = zoom.gesture;
	    var image = zoom.image;
	    var velocity = zoom.velocity;
	    if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
	    swiper.allowClick = false;
	    if (!image.isTouched || !gesture.$slideEl) { return; }
	
	    if (!image.isMoved) {
	      image.width = gesture.$imageEl[0].offsetWidth;
	      image.height = gesture.$imageEl[0].offsetHeight;
	      image.startX = Utils.getTranslate(gesture.$imageWrapEl[0], 'x') || 0;
	      image.startY = Utils.getTranslate(gesture.$imageWrapEl[0], 'y') || 0;
	      gesture.slideWidth = gesture.$slideEl[0].offsetWidth;
	      gesture.slideHeight = gesture.$slideEl[0].offsetHeight;
	      gesture.$imageWrapEl.transition(0);
	      if (swiper.rtl) { image.startX = -image.startX; }
	      if (swiper.rtl) { image.startY = -image.startY; }
	    }
	    // Define if we need image drag
	    var scaledWidth = image.width * zoom.scale;
	    var scaledHeight = image.height * zoom.scale;
	
	    if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) { return; }
	
	    image.minX = Math.min(((gesture.slideWidth / 2) - (scaledWidth / 2)), 0);
	    image.maxX = -image.minX;
	    image.minY = Math.min(((gesture.slideHeight / 2) - (scaledHeight / 2)), 0);
	    image.maxY = -image.minY;
	
	    image.touchesCurrent.x = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
	    image.touchesCurrent.y = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
	
	    if (!image.isMoved && !zoom.isScaling) {
	      if (
	        swiper.isHorizontal() &&
	        (
	          (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x) ||
	          (Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)
	        )
	      ) {
	        image.isTouched = false;
	        return;
	      } else if (
	        !swiper.isHorizontal() &&
	        (
	          (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y) ||
	          (Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)
	        )
	      ) {
	        image.isTouched = false;
	        return;
	      }
	    }
	    e.preventDefault();
	    e.stopPropagation();
	
	    image.isMoved = true;
	    image.currentX = (image.touchesCurrent.x - image.touchesStart.x) + image.startX;
	    image.currentY = (image.touchesCurrent.y - image.touchesStart.y) + image.startY;
	
	    if (image.currentX < image.minX) {
	      image.currentX = (image.minX + 1) - (Math.pow( ((image.minX - image.currentX) + 1), 0.8 ));
	    }
	    if (image.currentX > image.maxX) {
	      image.currentX = (image.maxX - 1) + (Math.pow( ((image.currentX - image.maxX) + 1), 0.8 ));
	    }
	
	    if (image.currentY < image.minY) {
	      image.currentY = (image.minY + 1) - (Math.pow( ((image.minY - image.currentY) + 1), 0.8 ));
	    }
	    if (image.currentY > image.maxY) {
	      image.currentY = (image.maxY - 1) + (Math.pow( ((image.currentY - image.maxY) + 1), 0.8 ));
	    }
	
	    // Velocity
	    if (!velocity.prevPositionX) { velocity.prevPositionX = image.touchesCurrent.x; }
	    if (!velocity.prevPositionY) { velocity.prevPositionY = image.touchesCurrent.y; }
	    if (!velocity.prevTime) { velocity.prevTime = Date.now(); }
	    velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
	    velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
	    if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) { velocity.x = 0; }
	    if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) { velocity.y = 0; }
	    velocity.prevPositionX = image.touchesCurrent.x;
	    velocity.prevPositionY = image.touchesCurrent.y;
	    velocity.prevTime = Date.now();
	
	    gesture.$imageWrapEl.transform(("translate3d(" + (image.currentX) + "px, " + (image.currentY) + "px,0)"));
	  },
	  onTouchEnd: function onTouchEnd() {
	    var swiper = this;
	    var zoom = swiper.zoom;
	    var gesture = zoom.gesture;
	    var image = zoom.image;
	    var velocity = zoom.velocity;
	    if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
	    if (!image.isTouched || !image.isMoved) {
	      image.isTouched = false;
	      image.isMoved = false;
	      return;
	    }
	    image.isTouched = false;
	    image.isMoved = false;
	    var momentumDurationX = 300;
	    var momentumDurationY = 300;
	    var momentumDistanceX = velocity.x * momentumDurationX;
	    var newPositionX = image.currentX + momentumDistanceX;
	    var momentumDistanceY = velocity.y * momentumDurationY;
	    var newPositionY = image.currentY + momentumDistanceY;
	
	    // Fix duration
	    if (velocity.x !== 0) { momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x); }
	    if (velocity.y !== 0) { momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y); }
	    var momentumDuration = Math.max(momentumDurationX, momentumDurationY);
	
	    image.currentX = newPositionX;
	    image.currentY = newPositionY;
	
	    // Define if we need image drag
	    var scaledWidth = image.width * zoom.scale;
	    var scaledHeight = image.height * zoom.scale;
	    image.minX = Math.min(((gesture.slideWidth / 2) - (scaledWidth / 2)), 0);
	    image.maxX = -image.minX;
	    image.minY = Math.min(((gesture.slideHeight / 2) - (scaledHeight / 2)), 0);
	    image.maxY = -image.minY;
	    image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
	    image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
	
	    gesture.$imageWrapEl.transition(momentumDuration).transform(("translate3d(" + (image.currentX) + "px, " + (image.currentY) + "px,0)"));
	  },
	  onTransitionEnd: function onTransitionEnd() {
	    var swiper = this;
	    var zoom = swiper.zoom;
	    var gesture = zoom.gesture;
	    if (gesture.$slideEl && swiper.previousIndex !== swiper.activeIndex) {
	      gesture.$imageEl.transform('translate3d(0,0,0) scale(1)');
	      gesture.$imageWrapEl.transform('translate3d(0,0,0)');
	      gesture.$slideEl = undefined;
	      gesture.$imageEl = undefined;
	      gesture.$imageWrapEl = undefined;
	
	      zoom.scale = 1;
	      zoom.currentScale = 1;
	    }
	  },
	  // Toggle Zoom
	  toggle: function toggle(e) {
	    var swiper = this;
	    var zoom = swiper.zoom;
	
	    if (zoom.scale && zoom.scale !== 1) {
	      // Zoom Out
	      zoom.out();
	    } else {
	      // Zoom In
	      zoom.in(e);
	    }
	  },
	  in: function in$1(e) {
	    var swiper = this;
	
	    var zoom = swiper.zoom;
	    var params = swiper.params.zoom;
	    var gesture = zoom.gesture;
	    var image = zoom.image;
	
	    if (!gesture.$slideEl) {
	      gesture.$slideEl = swiper.clickedSlide ? $$1(swiper.clickedSlide) : swiper.slides.eq(swiper.activeIndex);
	      gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas');
	      gesture.$imageWrapEl = gesture.$imageEl.parent(("." + (params.containerClass)));
	    }
	    if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
	
	    gesture.$slideEl.addClass(("" + (params.zoomedSlideClass)));
	
	    var touchX;
	    var touchY;
	    var offsetX;
	    var offsetY;
	    var diffX;
	    var diffY;
	    var translateX;
	    var translateY;
	    var imageWidth;
	    var imageHeight;
	    var scaledWidth;
	    var scaledHeight;
	    var translateMinX;
	    var translateMinY;
	    var translateMaxX;
	    var translateMaxY;
	    var slideWidth;
	    var slideHeight;
	
	    if (typeof image.touchesStart.x === 'undefined' && e) {
	      touchX = e.type === 'touchend' ? e.changedTouches[0].pageX : e.pageX;
	      touchY = e.type === 'touchend' ? e.changedTouches[0].pageY : e.pageY;
	    } else {
	      touchX = image.touchesStart.x;
	      touchY = image.touchesStart.y;
	    }
	
	    zoom.scale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
	    zoom.currentScale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
	    if (e) {
	      slideWidth = gesture.$slideEl[0].offsetWidth;
	      slideHeight = gesture.$slideEl[0].offsetHeight;
	      offsetX = gesture.$slideEl.offset().left;
	      offsetY = gesture.$slideEl.offset().top;
	      diffX = (offsetX + (slideWidth / 2)) - touchX;
	      diffY = (offsetY + (slideHeight / 2)) - touchY;
	
	      imageWidth = gesture.$imageEl[0].offsetWidth;
	      imageHeight = gesture.$imageEl[0].offsetHeight;
	      scaledWidth = imageWidth * zoom.scale;
	      scaledHeight = imageHeight * zoom.scale;
	
	      translateMinX = Math.min(((slideWidth / 2) - (scaledWidth / 2)), 0);
	      translateMinY = Math.min(((slideHeight / 2) - (scaledHeight / 2)), 0);
	      translateMaxX = -translateMinX;
	      translateMaxY = -translateMinY;
	
	      translateX = diffX * zoom.scale;
	      translateY = diffY * zoom.scale;
	
	      if (translateX < translateMinX) {
	        translateX = translateMinX;
	      }
	      if (translateX > translateMaxX) {
	        translateX = translateMaxX;
	      }
	
	      if (translateY < translateMinY) {
	        translateY = translateMinY;
	      }
	      if (translateY > translateMaxY) {
	        translateY = translateMaxY;
	      }
	    } else {
	      translateX = 0;
	      translateY = 0;
	    }
	    gesture.$imageWrapEl.transition(300).transform(("translate3d(" + translateX + "px, " + translateY + "px,0)"));
	    gesture.$imageEl.transition(300).transform(("translate3d(0,0,0) scale(" + (zoom.scale) + ")"));
	  },
	  out: function out() {
	    var swiper = this;
	
	    var zoom = swiper.zoom;
	    var params = swiper.params.zoom;
	    var gesture = zoom.gesture;
	
	    if (!gesture.$slideEl) {
	      gesture.$slideEl = swiper.clickedSlide ? $$1(swiper.clickedSlide) : swiper.slides.eq(swiper.activeIndex);
	      gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas');
	      gesture.$imageWrapEl = gesture.$imageEl.parent(("." + (params.containerClass)));
	    }
	    if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
	
	    zoom.scale = 1;
	    zoom.currentScale = 1;
	    gesture.$imageWrapEl.transition(300).transform('translate3d(0,0,0)');
	    gesture.$imageEl.transition(300).transform('translate3d(0,0,0) scale(1)');
	    gesture.$slideEl.removeClass(("" + (params.zoomedSlideClass)));
	    gesture.$slideEl = undefined;
	  },
	  // Attach/Detach Events
	  enable: function enable() {
	    var swiper = this;
	    var zoom = swiper.zoom;
	    if (zoom.enabled) { return; }
	    zoom.enabled = true;
	
	    var slides = swiper.slides;
	
	    var passiveListener = swiper.touchEvents.start === 'touchstart' && Support.passiveListener && swiper.params.passiveListeners ? { passive: true, capture: false } : false;
	
	    // Scale image
	    if (Support.gestures) {
	      slides.on('gesturestart', zoom.onGestureStart, passiveListener);
	      slides.on('gesturechange', zoom.onGestureChange, passiveListener);
	      slides.on('gestureend', zoom.onGestureEnd, passiveListener);
	    } else if (swiper.touchEvents.start === 'touchstart') {
	      slides.on(swiper.touchEvents.start, zoom.onGestureStart, passiveListener);
	      slides.on(swiper.touchEvents.move, zoom.onGestureChange, passiveListener);
	      slides.on(swiper.touchEvents.end, zoom.onGestureEnd, passiveListener);
	    }
	
	    // Move image
	    swiper.slides.each(function (index, slideEl) {
	      var $slideEl = $$1(slideEl);
	      if ($slideEl.find(("." + (swiper.params.zoom.containerClass))).length > 0) {
	        $slideEl.on(swiper.touchEvents.move, zoom.onTouchMove);
	      }
	    });
	  },
	  disable: function disable() {
	    var swiper = this;
	    var zoom = swiper.zoom;
	    if (!zoom.enabled) { return; }
	
	    swiper.zoom.enabled = false;
	
	    var slides = swiper.slides;
	
	    var passiveListener = swiper.touchEvents.start === 'touchstart' && Support.passiveListener && swiper.params.passiveListeners ? { passive: true, capture: false } : false;
	
	    // Scale image
	    if (Support.gestures) {
	      slides.off('gesturestart', zoom.onGestureStart, passiveListener);
	      slides.off('gesturechange', zoom.onGestureChange, passiveListener);
	      slides.off('gestureend', zoom.onGestureEnd, passiveListener);
	    } else if (swiper.touchEvents.start === 'touchstart') {
	      slides.off(swiper.touchEvents.start, zoom.onGestureStart, passiveListener);
	      slides.off(swiper.touchEvents.move, zoom.onGestureChange, passiveListener);
	      slides.off(swiper.touchEvents.end, zoom.onGestureEnd, passiveListener);
	    }
	
	    // Move image
	    swiper.slides.each(function (index, slideEl) {
	      var $slideEl = $$1(slideEl);
	      if ($slideEl.find(("." + (swiper.params.zoom.containerClass))).length > 0) {
	        $slideEl.off(swiper.touchEvents.move, zoom.onTouchMove);
	      }
	    });
	  },
	};
	
	var Zoom$1 = {
	  name: 'zoom',
	  params: {
	    zoom: {
	      enabled: false,
	      maxRatio: 3,
	      minRatio: 1,
	      toggle: true,
	      containerClass: 'swiper-zoom-container',
	      zoomedSlideClass: 'swiper-slide-zoomed',
	    },
	  },
	  create: function create() {
	    var swiper = this;
	    var zoom = {
	      enabled: false,
	      scale: 1,
	      currentScale: 1,
	      isScaling: false,
	      gesture: {
	        $slideEl: undefined,
	        slideWidth: undefined,
	        slideHeight: undefined,
	        $imageEl: undefined,
	        $imageWrapEl: undefined,
	        maxRatio: 3,
	      },
	      image: {
	        isTouched: undefined,
	        isMoved: undefined,
	        currentX: undefined,
	        currentY: undefined,
	        minX: undefined,
	        minY: undefined,
	        maxX: undefined,
	        maxY: undefined,
	        width: undefined,
	        height: undefined,
	        startX: undefined,
	        startY: undefined,
	        touchesStart: {},
	        touchesCurrent: {},
	      },
	      velocity: {
	        x: undefined,
	        y: undefined,
	        prevPositionX: undefined,
	        prevPositionY: undefined,
	        prevTime: undefined,
	      },
	    };
	    ('onGestureStart onGestureChange onGestureEnd onTouchStart onTouchMove onTouchEnd onTransitionEnd toggle enable disable in out').split(' ').forEach(function (methodName) {
	      zoom[methodName] = Zoom[methodName].bind(swiper);
	    });
	    Utils.extend(swiper, {
	      zoom: zoom,
	    });
	  },
	  on: {
	    init: function init() {
	      var swiper = this;
	      if (swiper.params.zoom.enabled) {
	        swiper.zoom.enable();
	      }
	    },
	    destroy: function destroy() {
	      var swiper = this;
	      swiper.zoom.disable();
	    },
	    touchStart: function touchStart(e) {
	      var swiper = this;
	      if (!swiper.zoom.enabled) { return; }
	      swiper.zoom.onTouchStart(e);
	    },
	    touchEnd: function touchEnd(e) {
	      var swiper = this;
	      if (!swiper.zoom.enabled) { return; }
	      swiper.zoom.onTouchEnd(e);
	    },
	    doubleTap: function doubleTap(e) {
	      var swiper = this;
	      if (swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) {
	        swiper.zoom.toggle(e);
	      }
	    },
	    transitionEnd: function transitionEnd() {
	      var swiper = this;
	      if (swiper.zoom.enabled && swiper.params.zoom.enabled) {
	        swiper.zoom.onTransitionEnd();
	      }
	    },
	  },
	};
	
	var Lazy = {
	  loadInSlide: function loadInSlide(index, loadInDuplicate) {
	    if ( loadInDuplicate === void 0 ) loadInDuplicate = true;
	
	    var swiper = this;
	    var params = swiper.params.lazy;
	    if (typeof index === 'undefined') { return; }
	    if (swiper.slides.length === 0) { return; }
	    var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
	
	    var $slideEl = isVirtual
	      ? swiper.$wrapperEl.children(("." + (swiper.params.slideClass) + "[data-swiper-slide-index=\"" + index + "\"]"))
	      : swiper.slides.eq(index);
	
	    var $images = $slideEl.find(("." + (params.elementClass) + ":not(." + (params.loadedClass) + "):not(." + (params.loadingClass) + ")"));
	    if ($slideEl.hasClass(params.elementClass) && !$slideEl.hasClass(params.loadedClass) && !$slideEl.hasClass(params.loadingClass)) {
	      $images = $images.add($slideEl[0]);
	    }
	    if ($images.length === 0) { return; }
	
	    $images.each(function (imageIndex, imageEl) {
	      var $imageEl = $$1(imageEl);
	      $imageEl.addClass(params.loadingClass);
	
	      var background = $imageEl.attr('data-background');
	      var src = $imageEl.attr('data-src');
	      var srcset = $imageEl.attr('data-srcset');
	      var sizes = $imageEl.attr('data-sizes');
	
	      swiper.loadImage($imageEl[0], (src || background), srcset, sizes, false, function () {
	        if (typeof swiper === 'undefined' || swiper === null || !swiper || (swiper && !swiper.params) || swiper.destroyed) { return; }
	        if (background) {
	          $imageEl.css('background-image', ("url(\"" + background + "\")"));
	          $imageEl.removeAttr('data-background');
	        } else {
	          if (srcset) {
	            $imageEl.attr('srcset', srcset);
	            $imageEl.removeAttr('data-srcset');
	          }
	          if (sizes) {
	            $imageEl.attr('sizes', sizes);
	            $imageEl.removeAttr('data-sizes');
	          }
	          if (src) {
	            $imageEl.attr('src', src);
	            $imageEl.removeAttr('data-src');
	          }
	        }
	
	        $imageEl.addClass(params.loadedClass).removeClass(params.loadingClass);
	        $slideEl.find(("." + (params.preloaderClass))).remove();
	        if (swiper.params.loop && loadInDuplicate) {
	          var slideOriginalIndex = $slideEl.attr('data-swiper-slide-index');
	          if ($slideEl.hasClass(swiper.params.slideDuplicateClass)) {
	            var originalSlide = swiper.$wrapperEl.children(("[data-swiper-slide-index=\"" + slideOriginalIndex + "\"]:not(." + (swiper.params.slideDuplicateClass) + ")"));
	            swiper.lazy.loadInSlide(originalSlide.index(), false);
	          } else {
	            var duplicatedSlide = swiper.$wrapperEl.children(("." + (swiper.params.slideDuplicateClass) + "[data-swiper-slide-index=\"" + slideOriginalIndex + "\"]"));
	            swiper.lazy.loadInSlide(duplicatedSlide.index(), false);
	          }
	        }
	        swiper.emit('lazyImageReady', $slideEl[0], $imageEl[0]);
	      });
	
	      swiper.emit('lazyImageLoad', $slideEl[0], $imageEl[0]);
	    });
	  },
	  load: function load() {
	    var swiper = this;
	    var $wrapperEl = swiper.$wrapperEl;
	    var swiperParams = swiper.params;
	    var slides = swiper.slides;
	    var activeIndex = swiper.activeIndex;
	    var isVirtual = swiper.virtual && swiperParams.virtual.enabled;
	    var params = swiperParams.lazy;
	
	    var slidesPerView = swiperParams.slidesPerView;
	    if (slidesPerView === 'auto') {
	      slidesPerView = 0;
	    }
	
	    function slideExist(index) {
	      if (isVirtual) {
	        if ($wrapperEl.children(("." + (swiperParams.slideClass) + "[data-swiper-slide-index=\"" + index + "\"]")).length) {
	          return true;
	        }
	      } else if (slides[index]) { return true; }
	      return false;
	    }
	    function slideIndex(slideEl) {
	      if (isVirtual) {
	        return $$1(slideEl).attr('data-swiper-slide-index');
	      }
	      return $$1(slideEl).index();
	    }
	
	    if (!swiper.lazy.initialImageLoaded) { swiper.lazy.initialImageLoaded = true; }
	    if (swiper.params.watchSlidesVisibility) {
	      $wrapperEl.children(("." + (swiperParams.slideVisibleClass))).each(function (elIndex, slideEl) {
	        var index = isVirtual ? $$1(slideEl).attr('data-swiper-slide-index') : $$1(slideEl).index();
	        swiper.lazy.loadInSlide(index);
	      });
	    } else if (slidesPerView > 1) {
	      for (var i = activeIndex; i < activeIndex + slidesPerView; i += 1) {
	        if (slideExist(i)) { swiper.lazy.loadInSlide(i); }
	      }
	    } else {
	      swiper.lazy.loadInSlide(activeIndex);
	    }
	    if (params.loadPrevNext) {
	      if (slidesPerView > 1 || (params.loadPrevNextAmount && params.loadPrevNextAmount > 1)) {
	        var amount = params.loadPrevNextAmount;
	        var spv = slidesPerView;
	        var maxIndex = Math.min(activeIndex + spv + Math.max(amount, spv), slides.length);
	        var minIndex = Math.max(activeIndex - Math.max(spv, amount), 0);
	        // Next Slides
	        for (var i$1 = activeIndex + slidesPerView; i$1 < maxIndex; i$1 += 1) {
	          if (slideExist(i$1)) { swiper.lazy.loadInSlide(i$1); }
	        }
	        // Prev Slides
	        for (var i$2 = minIndex; i$2 < activeIndex; i$2 += 1) {
	          if (slideExist(i$2)) { swiper.lazy.loadInSlide(i$2); }
	        }
	      } else {
	        var nextSlide = $wrapperEl.children(("." + (swiperParams.slideNextClass)));
	        if (nextSlide.length > 0) { swiper.lazy.loadInSlide(slideIndex(nextSlide)); }
	
	        var prevSlide = $wrapperEl.children(("." + (swiperParams.slidePrevClass)));
	        if (prevSlide.length > 0) { swiper.lazy.loadInSlide(slideIndex(prevSlide)); }
	      }
	    }
	  },
	};
	
	var Lazy$1 = {
	  name: 'lazy',
	  params: {
	    lazy: {
	      enabled: false,
	      loadPrevNext: false,
	      loadPrevNextAmount: 1,
	      loadOnTransitionStart: false,
	
	      elementClass: 'swiper-lazy',
	      loadingClass: 'swiper-lazy-loading',
	      loadedClass: 'swiper-lazy-loaded',
	      preloaderClass: 'swiper-lazy-preloader',
	    },
	  },
	  create: function create() {
	    var swiper = this;
	    Utils.extend(swiper, {
	      lazy: {
	        initialImageLoaded: false,
	        load: Lazy.load.bind(swiper),
	        loadInSlide: Lazy.loadInSlide.bind(swiper),
	      },
	    });
	  },
	  on: {
	    beforeInit: function beforeInit() {
	      var swiper = this;
	      if (swiper.params.lazy.enabled && swiper.params.preloadImages) {
	        swiper.params.preloadImages = false;
	      }
	    },
	    init: function init() {
	      var swiper = this;
	      if (swiper.params.lazy.enabled && !swiper.params.loop && swiper.params.initialSlide === 0) {
	        swiper.lazy.load();
	      }
	    },
	    scroll: function scroll() {
	      var swiper = this;
	      if (swiper.params.freeMode && !swiper.params.freeModeSticky) {
	        swiper.lazy.load();
	      }
	    },
	    resize: function resize() {
	      var swiper = this;
	      if (swiper.params.lazy.enabled) {
	        swiper.lazy.load();
	      }
	    },
	    scrollbarDragMove: function scrollbarDragMove() {
	      var swiper = this;
	      if (swiper.params.lazy.enabled) {
	        swiper.lazy.load();
	      }
	    },
	    transitionStart: function transitionStart() {
	      var swiper = this;
	      if (swiper.params.lazy.enabled) {
	        if (swiper.params.lazy.loadOnTransitionStart || (!swiper.params.lazy.loadOnTransitionStart && !swiper.lazy.initialImageLoaded)) {
	          swiper.lazy.load();
	        }
	      }
	    },
	    transitionEnd: function transitionEnd() {
	      var swiper = this;
	      if (swiper.params.lazy.enabled && !swiper.params.lazy.loadOnTransitionStart) {
	        swiper.lazy.load();
	      }
	    },
	  },
	};
	
	/* eslint no-bitwise: ["error", { "allow": [">>"] }] */
	var Controller = {
	  LinearSpline: function LinearSpline(x, y) {
	    var binarySearch = (function search() {
	      var maxIndex;
	      var minIndex;
	      var guess;
	      return function (array, val) {
	        minIndex = -1;
	        maxIndex = array.length;
	        while (maxIndex - minIndex > 1) {
	          guess = maxIndex + minIndex >> 1;
	          if (array[guess] <= val) {
	            minIndex = guess;
	          } else {
	            maxIndex = guess;
	          }
	        }
	        return maxIndex;
	      };
	    }());
	    this.x = x;
	    this.y = y;
	    this.lastIndex = x.length - 1;
	    // Given an x value (x2), return the expected y2 value:
	    // (x1,y1) is the known point before given value,
	    // (x3,y3) is the known point after given value.
	    var i1;
	    var i3;
	
	    this.interpolate = function interpolate(x2) {
	      if (!x2) { return 0; }
	
	      // Get the indexes of x1 and x3 (the array indexes before and after given x2):
	      i3 = binarySearch(this.x, x2);
	      i1 = i3 - 1;
	
	      // We have our indexes i1 & i3, so we can calculate already:
	      // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
	      return (((x2 - this.x[i1]) * (this.y[i3] - this.y[i1])) / (this.x[i3] - this.x[i1])) + this.y[i1];
	    };
	    return this;
	  },
	  // xxx: for now i will just save one spline function to to
	  getInterpolateFunction: function getInterpolateFunction(c) {
	    var swiper = this;
	    if (!swiper.controller.spline) {
	      swiper.controller.spline = swiper.params.loop ?
	        new Controller.LinearSpline(swiper.slidesGrid, c.slidesGrid) :
	        new Controller.LinearSpline(swiper.snapGrid, c.snapGrid);
	    }
	  },
	  setTranslate: function setTranslate(setTranslate$1, byController) {
	    var swiper = this;
	    var controlled = swiper.controller.control;
	    var multiplier;
	    var controlledTranslate;
	    function setControlledTranslate(c) {
	      // this will create an Interpolate function based on the snapGrids
	      // x is the Grid of the scrolled scroller and y will be the controlled scroller
	      // it makes sense to create this only once and recall it for the interpolation
	      // the function does a lot of value caching for performance
	      var translate = c.rtl && c.params.direction === 'horizontal' ? -swiper.translate : swiper.translate;
	      if (swiper.params.controller.by === 'slide') {
	        swiper.controller.getInterpolateFunction(c);
	        // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
	        // but it did not work out
	        controlledTranslate = -swiper.controller.spline.interpolate(-translate);
	      }
	
	      if (!controlledTranslate || swiper.params.controller.by === 'container') {
	        multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
	        controlledTranslate = ((translate - swiper.minTranslate()) * multiplier) + c.minTranslate();
	      }
	
	      if (swiper.params.controller.inverse) {
	        controlledTranslate = c.maxTranslate() - controlledTranslate;
	      }
	      c.updateProgress(controlledTranslate);
	      c.setTranslate(controlledTranslate, swiper);
	      c.updateActiveIndex();
	      c.updateSlidesClasses();
	    }
	    if (Array.isArray(controlled)) {
	      for (var i = 0; i < controlled.length; i += 1) {
	        if (controlled[i] !== byController && controlled[i] instanceof Swiper$1) {
	          setControlledTranslate(controlled[i]);
	        }
	      }
	    } else if (controlled instanceof Swiper$1 && byController !== controlled) {
	      setControlledTranslate(controlled);
	    }
	  },
	  setTransition: function setTransition(duration, byController) {
	    var swiper = this;
	    var controlled = swiper.controller.control;
	    var i;
	    function setControlledTransition(c) {
	      c.setTransition(duration, swiper);
	      if (duration !== 0) {
	        c.transitionStart();
	        c.$wrapperEl.transitionEnd(function () {
	          if (!controlled) { return; }
	          if (c.params.loop && swiper.params.controller.by === 'slide') {
	            c.loopFix();
	          }
	          c.transitionEnd();
	        });
	      }
	    }
	    if (Array.isArray(controlled)) {
	      for (i = 0; i < controlled.length; i += 1) {
	        if (controlled[i] !== byController && controlled[i] instanceof Swiper$1) {
	          setControlledTransition(controlled[i]);
	        }
	      }
	    } else if (controlled instanceof Swiper$1 && byController !== controlled) {
	      setControlledTransition(controlled);
	    }
	  },
	};
	var Controller$1 = {
	  name: 'controller',
	  params: {
	    controller: {
	      control: undefined,
	      inverse: false,
	      by: 'slide', // or 'container'
	    },
	  },
	  create: function create() {
	    var swiper = this;
	    Utils.extend(swiper, {
	      controller: {
	        control: swiper.params.controller.control,
	        getInterpolateFunction: Controller.getInterpolateFunction.bind(swiper),
	        setTranslate: Controller.setTranslate.bind(swiper),
	        setTransition: Controller.setTransition.bind(swiper),
	      },
	    });
	  },
	  on: {
	    update: function update() {
	      var swiper = this;
	      if (!swiper.controller.control) { return; }
	      if (swiper.controller.spline) {
	        swiper.controller.spline = undefined;
	        delete swiper.controller.spline;
	      }
	    },
	    resize: function resize() {
	      var swiper = this;
	      if (!swiper.controller.control) { return; }
	      if (swiper.controller.spline) {
	        swiper.controller.spline = undefined;
	        delete swiper.controller.spline;
	      }
	    },
	    observerUpdate: function observerUpdate() {
	      var swiper = this;
	      if (!swiper.controller.control) { return; }
	      if (swiper.controller.spline) {
	        swiper.controller.spline = undefined;
	        delete swiper.controller.spline;
	      }
	    },
	    setTranslate: function setTranslate(translate, byController) {
	      var swiper = this;
	      if (!swiper.controller.control) { return; }
	      swiper.controller.setTranslate(translate, byController);
	    },
	    setTransition: function setTransition(duration, byController) {
	      var swiper = this;
	      if (!swiper.controller.control) { return; }
	      swiper.controller.setTransition(duration, byController);
	    },
	  },
	};
	
	var a11y = {
	  makeElFocusable: function makeElFocusable($el) {
	    $el.attr('tabIndex', '0');
	    return $el;
	  },
	  addElRole: function addElRole($el, role) {
	    $el.attr('role', role);
	    return $el;
	  },
	  addElLabel: function addElLabel($el, label) {
	    $el.attr('aria-label', label);
	    return $el;
	  },
	  disableEl: function disableEl($el) {
	    $el.attr('aria-disabled', true);
	    return $el;
	  },
	  enableEl: function enableEl($el) {
	    $el.attr('aria-disabled', false);
	    return $el;
	  },
	  onEnterKey: function onEnterKey(e) {
	    var swiper = this;
	    var params = swiper.params.a11y;
	    if (e.keyCode !== 13) { return; }
	    var $targetEl = $$1(e.target);
	    if (swiper.navigation && swiper.navigation.$nextEl && $targetEl.is(swiper.navigation.$nextEl)) {
	      if (!(swiper.isEnd && !swiper.params.loop)) {
	        swiper.slideNext();
	      }
	      if (swiper.isEnd) {
	        swiper.a11y.notify(params.lastSlideMessage);
	      } else {
	        swiper.a11y.notify(params.nextSlideMessage);
	      }
	    }
	    if (swiper.navigation && swiper.navigation.$prevEl && $targetEl.is(swiper.navigation.$prevEl)) {
	      if (!(swiper.isBeginning && !swiper.params.loop)) {
	        swiper.slidePrev();
	      }
	      if (swiper.isBeginning) {
	        swiper.a11y.notify(params.firstSlideMessage);
	      } else {
	        swiper.a11y.notify(params.prevSlideMessage);
	      }
	    }
	    if (swiper.pagination && $targetEl.is(("." + (swiper.params.pagination.bulletClass)))) {
	      $targetEl[0].click();
	    }
	  },
	  notify: function notify(message) {
	    var swiper = this;
	    var notification = swiper.a11y.liveRegion;
	    if (notification.length === 0) { return; }
	    notification.html('');
	    notification.html(message);
	  },
	  updateNavigation: function updateNavigation() {
	    var swiper = this;
	
	    if (swiper.params.loop) { return; }
	    var ref = swiper.navigation;
	    var $nextEl = ref.$nextEl;
	    var $prevEl = ref.$prevEl;
	
	    if ($prevEl && $prevEl.length > 0) {
	      if (swiper.isBeginning) {
	        swiper.a11y.disableEl($prevEl);
	      } else {
	        swiper.a11y.enableEl($prevEl);
	      }
	    }
	    if ($nextEl && $nextEl.length > 0) {
	      if (swiper.isEnd) {
	        swiper.a11y.disableEl($nextEl);
	      } else {
	        swiper.a11y.enableEl($nextEl);
	      }
	    }
	  },
	  updatePagination: function updatePagination() {
	    var swiper = this;
	    var params = swiper.params.a11y;
	    if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
	      swiper.pagination.bullets.each(function (bulletIndex, bulletEl) {
	        var $bulletEl = $$1(bulletEl);
	        swiper.a11y.makeElFocusable($bulletEl);
	        swiper.a11y.addElRole($bulletEl, 'button');
	        swiper.a11y.addElLabel($bulletEl, params.paginationBulletMessage.replace(/{{index}}/, $bulletEl.index() + 1));
	      });
	    }
	  },
	  init: function init() {
	    var swiper = this;
	
	    swiper.$el.append(swiper.a11y.liveRegion);
	
	    // Navigation
	    var params = swiper.params.a11y;
	    var $nextEl;
	    var $prevEl;
	    if (swiper.navigation && swiper.navigation.$nextEl) {
	      $nextEl = swiper.navigation.$nextEl;
	    }
	    if (swiper.navigation && swiper.navigation.$prevEl) {
	      $prevEl = swiper.navigation.$prevEl;
	    }
	    if ($nextEl) {
	      swiper.a11y.makeElFocusable($nextEl);
	      swiper.a11y.addElRole($nextEl, 'button');
	      swiper.a11y.addElLabel($nextEl, params.nextSlideMessage);
	      $nextEl.on('keydown', swiper.a11y.onEnterKey);
	    }
	    if ($prevEl) {
	      swiper.a11y.makeElFocusable($prevEl);
	      swiper.a11y.addElRole($prevEl, 'button');
	      swiper.a11y.addElLabel($prevEl, params.prevSlideMessage);
	      $prevEl.on('keydown', swiper.a11y.onEnterKey);
	    }
	
	    // Pagination
	    if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
	      swiper.pagination.$el.on('keydown', ("." + (swiper.params.pagination.bulletClass)), swiper.a11y.onEnterKey);
	    }
	  },
	  destroy: function destroy() {
	    var swiper = this;
	    if (swiper.a11y.liveRegion && swiper.a11y.liveRegion.length > 0) { swiper.a11y.liveRegion.remove(); }
	
	    var $nextEl;
	    var $prevEl;
	    if (swiper.navigation && swiper.navigation.$nextEl) {
	      $nextEl = swiper.navigation.$nextEl;
	    }
	    if (swiper.navigation && swiper.navigation.$prevEl) {
	      $prevEl = swiper.navigation.$prevEl;
	    }
	    if ($nextEl) {
	      $nextEl.off('keydown', swiper.a11y.onEnterKey);
	    }
	    if ($prevEl) {
	      $prevEl.off('keydown', swiper.a11y.onEnterKey);
	    }
	
	    // Pagination
	    if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
	      swiper.pagination.$el.off('keydown', ("." + (swiper.params.pagination.bulletClass)), swiper.a11y.onEnterKey);
	    }
	  },
	};
	var A11y = {
	  name: 'a11y',
	  params: {
	    a11y: {
	      enabled: false,
	      notificationClass: 'swiper-notification',
	      prevSlideMessage: 'Previous slide',
	      nextSlideMessage: 'Next slide',
	      firstSlideMessage: 'This is the first slide',
	      lastSlideMessage: 'This is the last slide',
	      paginationBulletMessage: 'Go to slide {{index}}',
	    },
	  },
	  create: function create() {
	    var swiper = this;
	    Utils.extend(swiper, {
	      a11y: {
	        liveRegion: $$1(("<span class=\"" + (swiper.params.a11y.notificationClass) + "\" aria-live=\"assertive\" aria-atomic=\"true\"></span>")),
	      },
	    });
	    Object.keys(a11y).forEach(function (methodName) {
	      swiper.a11y[methodName] = a11y[methodName].bind(swiper);
	    });
	  },
	  on: {
	    init: function init() {
	      var swiper = this;
	      if (!swiper.params.a11y.enabled) { return; }
	      swiper.a11y.init();
	      swiper.a11y.updateNavigation();
	    },
	    toEdge: function toEdge() {
	      var swiper = this;
	      if (!swiper.params.a11y.enabled) { return; }
	      swiper.a11y.updateNavigation();
	    },
	    fromEdge: function fromEdge() {
	      var swiper = this;
	      if (!swiper.params.a11y.enabled) { return; }
	      swiper.a11y.updateNavigation();
	    },
	    paginationUpdate: function paginationUpdate() {
	      var swiper = this;
	      if (!swiper.params.a11y.enabled) { return; }
	      swiper.a11y.updatePagination();
	    },
	    destroy: function destroy() {
	      var swiper = this;
	      if (!swiper.params.a11y.enabled) { return; }
	      swiper.a11y.destroy();
	    },
	  },
	};
	
	var History = {
	  init: function init() {
	    var swiper = this;
	    if (!swiper.params.history) { return; }
	    if (!win.history || !win.history.pushState) {
	      swiper.params.history.enabled = false;
	      swiper.params.hashNavigation.enabled = true;
	      return;
	    }
	    var history = swiper.history;
	    history.initialized = true;
	    history.paths = History.getPathValues();
	    if (!history.paths.key && !history.paths.value) { return; }
	    history.scrollToSlide(0, history.paths.value, swiper.params.runCallbacksOnInit);
	    if (!swiper.params.history.replaceState) {
	      win.addEventListener('popstate', swiper.history.setHistoryPopState);
	    }
	  },
	  destroy: function destroy() {
	    var swiper = this;
	    if (!swiper.params.history.replaceState) {
	      win.removeEventListener('popstate', swiper.history.setHistoryPopState);
	    }
	  },
	  setHistoryPopState: function setHistoryPopState() {
	    var swiper = this;
	    swiper.history.paths = History.getPathValues();
	    swiper.history.scrollToSlide(swiper.params.speed, swiper.history.paths.value, false);
	  },
	  getPathValues: function getPathValues() {
	    var pathArray = win.location.pathname.slice(1).split('/').filter(function (part) { return part !== ''; });
	    var total = pathArray.length;
	    var key = pathArray[total - 2];
	    var value = pathArray[total - 1];
	    return { key: key, value: value };
	  },
	  setHistory: function setHistory(key, index) {
	    var swiper = this;
	    if (!swiper.history.initialized || !swiper.params.history.enabled) { return; }
	    var slide = swiper.slides.eq(index);
	    var value = History.slugify(slide.attr('data-history'));
	    if (!win.location.pathname.includes(key)) {
	      value = key + "/" + value;
	    }
	    var currentState = win.history.state;
	    if (currentState && currentState.value === value) {
	      return;
	    }
	    if (swiper.params.history.replaceState) {
	      win.history.replaceState({ value: value }, null, value);
	    } else {
	      win.history.pushState({ value: value }, null, value);
	    }
	  },
	  slugify: function slugify(text) {
	    return text.toString().toLowerCase()
	      .replace(/\s+/g, '-')
	      .replace(/[^\w-]+/g, '')
	      .replace(/--+/g, '-')
	      .replace(/^-+/, '')
	      .replace(/-+$/, '');
	  },
	  scrollToSlide: function scrollToSlide(speed, value, runCallbacks) {
	    var swiper = this;
	    if (value) {
	      for (var i = 0, length = swiper.slides.length; i < length; i += 1) {
	        var slide = swiper.slides.eq(i);
	        var slideHistory = History.slugify(slide.attr('data-history'));
	        if (slideHistory === value && !slide.hasClass(swiper.params.slideDuplicateClass)) {
	          var index = slide.index();
	          swiper.slideTo(index, speed, runCallbacks);
	        }
	      }
	    } else {
	      swiper.slideTo(0, speed, runCallbacks);
	    }
	  },
	};
	
	var History$1 = {
	  name: 'history',
	  params: {
	    history: {
	      enabled: false,
	      replaceState: false,
	      key: 'slides',
	    },
	  },
	  create: function create() {
	    var swiper = this;
	    Utils.extend(swiper, {
	      history: {
	        init: History.init.bind(swiper),
	        setHistory: History.setHistory.bind(swiper),
	        setHistoryPopState: History.setHistoryPopState.bind(swiper),
	        scrollToSlide: History.scrollToSlide.bind(swiper),
	        destroy: History.destroy.bind(swiper),
	      },
	    });
	  },
	  on: {
	    init: function init() {
	      var swiper = this;
	      if (swiper.params.history.enabled) {
	        swiper.history.init();
	      }
	    },
	    destroy: function destroy() {
	      var swiper = this;
	      if (swiper.params.history.enabled) {
	        swiper.history.destroy();
	      }
	    },
	    transitionEnd: function transitionEnd() {
	      var swiper = this;
	      if (swiper.history.initialized) {
	        swiper.history.setHistory(swiper.params.history.key, swiper.activeIndex);
	      }
	    },
	  },
	};
	
	var HashNavigation = {
	  onHashCange: function onHashCange() {
	    var swiper = this;
	    var newHash = doc.location.hash.replace('#', '');
	    var activeSlideHash = swiper.slides.eq(swiper.activeIndex).attr('data-hash');
	    if (newHash !== activeSlideHash) {
	      swiper.slideTo(swiper.$wrapperEl.children(("." + (swiper.params.slideClass) + "[data-hash=\"" + newHash + "\"]")).index());
	    }
	  },
	  setHash: function setHash() {
	    var swiper = this;
	    if (!swiper.hashNavigation.initialized || !swiper.params.hashNavigation.enabled) { return; }
	    if (swiper.params.hashNavigation.replaceState && win.history && win.history.replaceState) {
	      win.history.replaceState(null, null, (("#" + (swiper.slides.eq(swiper.activeIndex).attr('data-hash'))) || ''));
	    } else {
	      var slide = swiper.slides.eq(swiper.activeIndex);
	      var hash = slide.attr('data-hash') || slide.attr('data-history');
	      doc.location.hash = hash || '';
	    }
	  },
	  init: function init() {
	    var swiper = this;
	    if (!swiper.params.hashNavigation.enabled || (swiper.params.history && swiper.params.history.enabled)) { return; }
	    swiper.hashNavigation.initialized = true;
	    var hash = doc.location.hash.replace('#', '');
	    if (hash) {
	      var speed = 0;
	      for (var i = 0, length = swiper.slides.length; i < length; i += 1) {
	        var slide = swiper.slides.eq(i);
	        var slideHash = slide.attr('data-hash') || slide.attr('data-history');
	        if (slideHash === hash && !slide.hasClass(swiper.params.slideDuplicateClass)) {
	          var index = slide.index();
	          swiper.slideTo(index, speed, swiper.params.runCallbacksOnInit, true);
	        }
	      }
	    }
	    if (swiper.params.hashNavigation.watchState) {
	      $$1(win).on('hashchange', swiper.hashNavigation.onHashCange);
	    }
	  },
	  destroy: function destroy() {
	    var swiper = this;
	    if (swiper.params.hashNavigation.watchState) {
	      $$1(win).off('hashchange', swiper.hashNavigation.onHashCange);
	    }
	  },
	};
	var HashNavigation$1 = {
	  name: 'hash-navigation',
	  params: {
	    hashNavigation: {
	      enabled: false,
	      replaceState: false,
	      watchState: false,
	    },
	  },
	  create: function create() {
	    var swiper = this;
	    Utils.extend(swiper, {
	      hashNavigation: {
	        initialized: false,
	        init: HashNavigation.init.bind(swiper),
	        destroy: HashNavigation.destroy.bind(swiper),
	        setHash: HashNavigation.setHash.bind(swiper),
	        onHashCange: HashNavigation.onHashCange.bind(swiper),
	      },
	    });
	  },
	  on: {
	    init: function init() {
	      var swiper = this;
	      if (swiper.params.hashNavigation.enabled) {
	        swiper.hashNavigation.init();
	      }
	    },
	    destroy: function destroy() {
	      var swiper = this;
	      if (swiper.params.hashNavigation.enabled) {
	        swiper.hashNavigation.destroy();
	      }
	    },
	    transitionEnd: function transitionEnd() {
	      var swiper = this;
	      if (swiper.hashNavigation.initialized) {
	        swiper.hashNavigation.setHash();
	      }
	    },
	  },
	};
	
	var Autoplay = {
	  run: function run() {
	    var swiper = this;
	    var $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
	    var delay = swiper.params.autoplay.delay;
	    if ($activeSlideEl.attr('data-swiper-autoplay')) {
	      delay = $activeSlideEl.attr('data-swiper-autoplay') || swiper.params.autoplay.delay;
	    }
	    swiper.autoplay.timeout = Utils.nextTick(function () {
	      if (swiper.params.autoplay.reverseDirection) {
	        if (swiper.params.loop) {
	          swiper.loopFix();
	          swiper.slidePrev(swiper.params.speed, true, true);
	          swiper.emit('autoplay');
	        } else if (!swiper.isBeginning) {
	          swiper.slidePrev(swiper.params.speed, true, true);
	          swiper.emit('autoplay');
	        } else if (!swiper.params.autoplay.stopOnLastSlide) {
	          swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
	          swiper.emit('autoplay');
	        } else {
	          swiper.autoplay.stop();
	        }
	      } else if (swiper.params.loop) {
	        swiper.loopFix();
	        swiper.slideNext(swiper.params.speed, true, true);
	        swiper.emit('autoplay');
	      } else if (!swiper.isEnd) {
	        swiper.slideNext(swiper.params.speed, true, true);
	        swiper.emit('autoplay');
	      } else if (!swiper.params.autoplay.stopOnLastSlide) {
	        swiper.slideTo(0, swiper.params.speed, true, true);
	        swiper.emit('autoplay');
	      } else {
	        swiper.autoplay.stop();
	      }
	    }, delay);
	  },
	  start: function start() {
	    var swiper = this;
	    if (typeof swiper.autoplay.timeout !== 'undefined') { return false; }
	    if (swiper.autoplay.running) { return false; }
	    swiper.autoplay.running = true;
	    swiper.emit('autoplayStart');
	    swiper.autoplay.run();
	    return true;
	  },
	  stop: function stop() {
	    var swiper = this;
	    if (!swiper.autoplay.running) { return false; }
	    if (typeof swiper.autoplay.timeout === 'undefined') { return false; }
	
	    if (swiper.autoplay.timeout) {
	      clearTimeout(swiper.autoplay.timeout);
	      swiper.autoplay.timeout = undefined;
	    }
	    swiper.autoplay.running = false;
	    swiper.emit('autoplayStop');
	    return true;
	  },
	  pause: function pause(speed) {
	    var swiper = this;
	    if (!swiper.autoplay.running) { return; }
	    if (swiper.autoplay.paused) { return; }
	    if (swiper.autoplay.timeout) { clearTimeout(swiper.autoplay.timeout); }
	    swiper.autoplay.paused = true;
	    if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
	      swiper.autoplay.paused = false;
	      swiper.autoplay.run();
	    } else {
	      swiper.$wrapperEl.transitionEnd(function () {
	        if (!swiper || swiper.destroyed) { return; }
	        swiper.autoplay.paused = false;
	        if (!swiper.autoplay.running) {
	          swiper.autoplay.stop();
	        } else {
	          swiper.autoplay.run();
	        }
	      });
	    }
	  },
	};
	
	var Autoplay$1 = {
	  name: 'autoplay',
	  params: {
	    autoplay: {
	      enabled: false,
	      delay: 3000,
	      waitForTransition: true,
	      disableOnInteraction: true,
	      stopOnLastSlide: false,
	      reverseDirection: false,
	    },
	  },
	  create: function create() {
	    var swiper = this;
	    Utils.extend(swiper, {
	      autoplay: {
	        running: false,
	        paused: false,
	        run: Autoplay.run.bind(swiper),
	        start: Autoplay.start.bind(swiper),
	        stop: Autoplay.stop.bind(swiper),
	        pause: Autoplay.pause.bind(swiper),
	      },
	    });
	  },
	  on: {
	    init: function init() {
	      var swiper = this;
	      if (swiper.params.autoplay.enabled) {
	        swiper.autoplay.start();
	      }
	    },
	    beforeTransitionStart: function beforeTransitionStart(speed, internal) {
	      var swiper = this;
	      if (swiper.autoplay.running) {
	        if (internal || !swiper.params.autoplay.disableOnInteraction) {
	          swiper.autoplay.pause(speed);
	        } else {
	          swiper.autoplay.stop();
	        }
	      }
	    },
	    sliderFirstMove: function sliderFirstMove() {
	      var swiper = this;
	      if (swiper.autoplay.running) {
	        if (swiper.params.autoplay.disableOnInteraction) {
	          swiper.autoplay.stop();
	        } else {
	          swiper.autoplay.pause();
	        }
	      }
	    },
	    destroy: function destroy() {
	      var swiper = this;
	      if (swiper.autoplay.running) {
	        swiper.autoplay.stop();
	      }
	    },
	  },
	};
	
	var Fade = {
	  setTranslate: function setTranslate() {
	    var swiper = this;
	    var slides = swiper.slides;
	    for (var i = 0; i < slides.length; i += 1) {
	      var $slideEl = swiper.slides.eq(i);
	      var offset = $slideEl[0].swiperSlideOffset;
	      var tx = -offset;
	      if (!swiper.params.virtualTranslate) { tx -= swiper.translate; }
	      var ty = 0;
	      if (!swiper.isHorizontal()) {
	        ty = tx;
	        tx = 0;
	      }
	      var slideOpacity = swiper.params.fadeEffect.crossFade ?
	        Math.max(1 - Math.abs($slideEl[0].progress), 0) :
	        1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
	      $slideEl
	        .css({
	          opacity: slideOpacity,
	        })
	        .transform(("translate3d(" + tx + "px, " + ty + "px, 0px)"));
	    }
	  },
	  setTransition: function setTransition(duration) {
	    var swiper = this;
	    var slides = swiper.slides;
	    var $wrapperEl = swiper.$wrapperEl;
	    slides.transition(duration);
	    if (swiper.params.virtualTranslate && duration !== 0) {
	      var eventTriggered = false;
	      slides.transitionEnd(function () {
	        if (eventTriggered) { return; }
	        if (!swiper || swiper.destroyed) { return; }
	        eventTriggered = true;
	        swiper.animating = false;
	        var triggerEvents = ['webkitTransitionEnd', 'transitionend'];
	        for (var i = 0; i < triggerEvents.length; i += 1) {
	          $wrapperEl.trigger(triggerEvents[i]);
	        }
	      });
	    }
	  },
	};
	
	var EffectFade = {
	  name: 'effect-fade',
	  params: {
	    fadeEffect: {
	      crossFade: false,
	    },
	  },
	  create: function create() {
	    var swiper = this;
	    Utils.extend(swiper, {
	      fadeEffect: {
	        setTranslate: Fade.setTranslate.bind(swiper),
	        setTransition: Fade.setTransition.bind(swiper),
	      },
	    });
	  },
	  on: {
	    beforeInit: function beforeInit() {
	      var swiper = this;
	      if (swiper.params.effect !== 'fade') { return; }
	      swiper.classNames.push(((swiper.params.containerModifierClass) + "fade"));
	      var overwriteParams = {
	        slidesPerView: 1,
	        slidesPerColumn: 1,
	        slidesPerGroup: 1,
	        watchSlidesProgress: true,
	        spaceBetween: 0,
	        virtualTranslate: true,
	      };
	      Utils.extend(swiper.params, overwriteParams);
	      Utils.extend(swiper.originalParams, overwriteParams);
	    },
	    setTranslate: function setTranslate() {
	      var swiper = this;
	      if (swiper.params.effect !== 'fade') { return; }
	      swiper.fadeEffect.setTranslate();
	    },
	    setTransition: function setTransition(duration) {
	      var swiper = this;
	      if (swiper.params.effect !== 'fade') { return; }
	      swiper.fadeEffect.setTransition(duration);
	    },
	  },
	};
	
	var Cube = {
	  setTranslate: function setTranslate() {
	    var swiper = this;
	    var $el = swiper.$el;
	    var $wrapperEl = swiper.$wrapperEl;
	    var slides = swiper.slides;
	    var swiperWidth = swiper.width;
	    var swiperHeight = swiper.height;
	    var rtl = swiper.rtl;
	    var swiperSize = swiper.size;
	    var params = swiper.params.cubeEffect;
	    var isHorizontal = swiper.isHorizontal();
	    var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
	    var wrapperRotate = 0;
	    var $cubeShadowEl;
	    if (params.shadow) {
	      if (isHorizontal) {
	        $cubeShadowEl = $wrapperEl.find('.swiper-cube-shadow');
	        if ($cubeShadowEl.length === 0) {
	          $cubeShadowEl = $$1('<div class="swiper-cube-shadow"></div>');
	          $wrapperEl.append($cubeShadowEl);
	        }
	        $cubeShadowEl.css({ height: (swiperWidth + "px") });
	      } else {
	        $cubeShadowEl = $el.find('.swiper-cube-shadow');
	        if ($cubeShadowEl.length === 0) {
	          $cubeShadowEl = $$1('<div class="swiper-cube-shadow"></div>');
	          $el.append($cubeShadowEl);
	        }
	      }
	    }
	    for (var i = 0; i < slides.length; i += 1) {
	      var $slideEl = slides.eq(i);
	      var slideIndex = i;
	      if (isVirtual) {
	        slideIndex = parseInt($slideEl.attr('data-swiper-slide-index'), 10);
	      }
	      var slideAngle = slideIndex * 90;
	      var round = Math.floor(slideAngle / 360);
	      if (rtl) {
	        slideAngle = -slideAngle;
	        round = Math.floor(-slideAngle / 360);
	      }
	      var progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
	      var tx = 0;
	      var ty = 0;
	      var tz = 0;
	      if (slideIndex % 4 === 0) {
	        tx = -round * 4 * swiperSize;
	        tz = 0;
	      } else if ((slideIndex - 1) % 4 === 0) {
	        tx = 0;
	        tz = -round * 4 * swiperSize;
	      } else if ((slideIndex - 2) % 4 === 0) {
	        tx = swiperSize + (round * 4 * swiperSize);
	        tz = swiperSize;
	      } else if ((slideIndex - 3) % 4 === 0) {
	        tx = -swiperSize;
	        tz = (3 * swiperSize) + (swiperSize * 4 * round);
	      }
	      if (rtl) {
	        tx = -tx;
	      }
	
	      if (!isHorizontal) {
	        ty = tx;
	        tx = 0;
	      }
	
	      var transform = "rotateX(" + (isHorizontal ? 0 : -slideAngle) + "deg) rotateY(" + (isHorizontal ? slideAngle : 0) + "deg) translate3d(" + tx + "px, " + ty + "px, " + tz + "px)";
	      if (progress <= 1 && progress > -1) {
	        wrapperRotate = (slideIndex * 90) + (progress * 90);
	        if (rtl) { wrapperRotate = (-slideIndex * 90) - (progress * 90); }
	      }
	      $slideEl.transform(transform);
	      if (params.slideShadows) {
	        // Set shadows
	        var shadowBefore = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
	        var shadowAfter = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
	        if (shadowBefore.length === 0) {
	          shadowBefore = $$1(("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'left' : 'top') + "\"></div>"));
	          $slideEl.append(shadowBefore);
	        }
	        if (shadowAfter.length === 0) {
	          shadowAfter = $$1(("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'right' : 'bottom') + "\"></div>"));
	          $slideEl.append(shadowAfter);
	        }
	        if (shadowBefore.length) { shadowBefore[0].style.opacity = Math.max(-progress, 0); }
	        if (shadowAfter.length) { shadowAfter[0].style.opacity = Math.max(progress, 0); }
	      }
	    }
	    $wrapperEl.css({
	      '-webkit-transform-origin': ("50% 50% -" + (swiperSize / 2) + "px"),
	      '-moz-transform-origin': ("50% 50% -" + (swiperSize / 2) + "px"),
	      '-ms-transform-origin': ("50% 50% -" + (swiperSize / 2) + "px"),
	      'transform-origin': ("50% 50% -" + (swiperSize / 2) + "px"),
	    });
	
	    if (params.shadow) {
	      if (isHorizontal) {
	        $cubeShadowEl.transform(("translate3d(0px, " + ((swiperWidth / 2) + params.shadowOffset) + "px, " + (-swiperWidth / 2) + "px) rotateX(90deg) rotateZ(0deg) scale(" + (params.shadowScale) + ")"));
	      } else {
	        var shadowAngle = Math.abs(wrapperRotate) - (Math.floor(Math.abs(wrapperRotate) / 90) * 90);
	        var multiplier = 1.5 - (
	          (Math.sin((shadowAngle * 2 * Math.PI) / 360) / 2) +
	          (Math.cos((shadowAngle * 2 * Math.PI) / 360) / 2)
	        );
	        var scale1 = params.shadowScale;
	        var scale2 = params.shadowScale / multiplier;
	        var offset = params.shadowOffset;
	        $cubeShadowEl.transform(("scale3d(" + scale1 + ", 1, " + scale2 + ") translate3d(0px, " + ((swiperHeight / 2) + offset) + "px, " + (-swiperHeight / 2 / scale2) + "px) rotateX(-90deg)"));
	      }
	    }
	    var zFactor = (Browser$1.isSafari || Browser$1.isUiWebView) ? (-swiperSize / 2) : 0;
	    $wrapperEl
	      .transform(("translate3d(0px,0," + zFactor + "px) rotateX(" + (swiper.isHorizontal() ? 0 : wrapperRotate) + "deg) rotateY(" + (swiper.isHorizontal() ? -wrapperRotate : 0) + "deg)"));
	  },
	  setTransition: function setTransition(duration) {
	    var swiper = this;
	    var $el = swiper.$el;
	    var slides = swiper.slides;
	    slides
	      .transition(duration)
	      .find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left')
	      .transition(duration);
	    if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
	      $el.find('.swiper-cube-shadow').transition(duration);
	    }
	  },
	};
	
	var EffectCube = {
	  name: 'effect-cube',
	  params: {
	    cubeEffect: {
	      slideShadows: true,
	      shadow: true,
	      shadowOffset: 20,
	      shadowScale: 0.94,
	    },
	  },
	  create: function create() {
	    var swiper = this;
	    Utils.extend(swiper, {
	      cubeEffect: {
	        setTranslate: Cube.setTranslate.bind(swiper),
	        setTransition: Cube.setTransition.bind(swiper),
	      },
	    });
	  },
	  on: {
	    beforeInit: function beforeInit() {
	      var swiper = this;
	      if (swiper.params.effect !== 'cube') { return; }
	      swiper.classNames.push(((swiper.params.containerModifierClass) + "cube"));
	      swiper.classNames.push(((swiper.params.containerModifierClass) + "3d"));
	      var overwriteParams = {
	        slidesPerView: 1,
	        slidesPerColumn: 1,
	        slidesPerGroup: 1,
	        watchSlidesProgress: true,
	        resistanceRatio: 0,
	        spaceBetween: 0,
	        centeredSlides: false,
	        virtualTranslate: true,
	      };
	      Utils.extend(swiper.params, overwriteParams);
	      Utils.extend(swiper.originalParams, overwriteParams);
	    },
	    setTranslate: function setTranslate() {
	      var swiper = this;
	      if (swiper.params.effect !== 'cube') { return; }
	      swiper.cubeEffect.setTranslate();
	    },
	    setTransition: function setTransition(duration) {
	      var swiper = this;
	      if (swiper.params.effect !== 'cube') { return; }
	      swiper.cubeEffect.setTransition(duration);
	    },
	  },
	};
	
	var Flip = {
	  setTranslate: function setTranslate() {
	    var swiper = this;
	    var slides = swiper.slides;
	    for (var i = 0; i < slides.length; i += 1) {
	      var $slideEl = slides.eq(i);
	      var progress = $slideEl[0].progress;
	      if (swiper.params.flipEffect.limitRotation) {
	        progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
	      }
	      var offset = $slideEl[0].swiperSlideOffset;
	      var rotate = -180 * progress;
	      var rotateY = rotate;
	      var rotateX = 0;
	      var tx = -offset;
	      var ty = 0;
	      if (!swiper.isHorizontal()) {
	        ty = tx;
	        tx = 0;
	        rotateX = -rotateY;
	        rotateY = 0;
	      } else if (swiper.rtl) {
	        rotateY = -rotateY;
	      }
	
	      $slideEl[0].style.zIndex = -Math.abs(Math.round(progress)) + slides.length;
	
	      if (swiper.params.flipEffect.slideShadows) {
	        // Set shadows
	        var shadowBefore = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
	        var shadowAfter = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
	        if (shadowBefore.length === 0) {
	          shadowBefore = $$1(("<div class=\"swiper-slide-shadow-" + (swiper.isHorizontal() ? 'left' : 'top') + "\"></div>"));
	          $slideEl.append(shadowBefore);
	        }
	        if (shadowAfter.length === 0) {
	          shadowAfter = $$1(("<div class=\"swiper-slide-shadow-" + (swiper.isHorizontal() ? 'right' : 'bottom') + "\"></div>"));
	          $slideEl.append(shadowAfter);
	        }
	        if (shadowBefore.length) { shadowBefore[0].style.opacity = Math.max(-progress, 0); }
	        if (shadowAfter.length) { shadowAfter[0].style.opacity = Math.max(progress, 0); }
	      }
	      $slideEl
	        .transform(("translate3d(" + tx + "px, " + ty + "px, 0px) rotateX(" + rotateX + "deg) rotateY(" + rotateY + "deg)"));
	    }
	  },
	  setTransition: function setTransition(duration) {
	    var swiper = this;
	    var slides = swiper.slides;
	    var activeIndex = swiper.activeIndex;
	    var $wrapperEl = swiper.$wrapperEl;
	    slides
	      .transition(duration)
	      .find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left')
	      .transition(duration);
	    if (swiper.params.virtualTranslate && duration !== 0) {
	      var eventTriggered = false;
	      // eslint-disable-next-line
	      slides.eq(activeIndex).transitionEnd(function onTransitionEnd() {
	        if (eventTriggered) { return; }
	        if (!swiper || swiper.destroyed) { return; }
	        // if (!$(this).hasClass(swiper.params.slideActiveClass)) return;
	        eventTriggered = true;
	        swiper.animating = false;
	        var triggerEvents = ['webkitTransitionEnd', 'transitionend'];
	        for (var i = 0; i < triggerEvents.length; i += 1) {
	          $wrapperEl.trigger(triggerEvents[i]);
	        }
	      });
	    }
	  },
	};
	
	var EffectFlip = {
	  name: 'effect-flip',
	  params: {
	    flipEffect: {
	      slideShadows: true,
	      limitRotation: true,
	    },
	  },
	  create: function create() {
	    var swiper = this;
	    Utils.extend(swiper, {
	      flipEffect: {
	        setTranslate: Flip.setTranslate.bind(swiper),
	        setTransition: Flip.setTransition.bind(swiper),
	      },
	    });
	  },
	  on: {
	    beforeInit: function beforeInit() {
	      var swiper = this;
	      if (swiper.params.effect !== 'flip') { return; }
	      swiper.classNames.push(((swiper.params.containerModifierClass) + "flip"));
	      swiper.classNames.push(((swiper.params.containerModifierClass) + "3d"));
	      var overwriteParams = {
	        slidesPerView: 1,
	        slidesPerColumn: 1,
	        slidesPerGroup: 1,
	        watchSlidesProgress: true,
	        spaceBetween: 0,
	        virtualTranslate: true,
	      };
	      Utils.extend(swiper.params, overwriteParams);
	      Utils.extend(swiper.originalParams, overwriteParams);
	    },
	    setTranslate: function setTranslate() {
	      var swiper = this;
	      if (swiper.params.effect !== 'flip') { return; }
	      swiper.flipEffect.setTranslate();
	    },
	    setTransition: function setTransition(duration) {
	      var swiper = this;
	      if (swiper.params.effect !== 'flip') { return; }
	      swiper.flipEffect.setTransition(duration);
	    },
	  },
	};
	
	var Coverflow = {
	  setTranslate: function setTranslate() {
	    var swiper = this;
	    var swiperWidth = swiper.width;
	    var swiperHeight = swiper.height;
	    var slides = swiper.slides;
	    var $wrapperEl = swiper.$wrapperEl;
	    var slidesSizesGrid = swiper.slidesSizesGrid;
	    var params = swiper.params.coverflowEffect;
	    var isHorizontal = swiper.isHorizontal();
	    var transform = swiper.translate;
	    var center = isHorizontal ? -transform + (swiperWidth / 2) : -transform + (swiperHeight / 2);
	    var rotate = isHorizontal ? params.rotate : -params.rotate;
	    var translate = params.depth;
	    // Each slide offset from center
	    for (var i = 0, length = slides.length; i < length; i += 1) {
	      var $slideEl = slides.eq(i);
	      var slideSize = slidesSizesGrid[i];
	      var slideOffset = $slideEl[0].swiperSlideOffset;
	      var offsetMultiplier = ((center - slideOffset - (slideSize / 2)) / slideSize) * params.modifier;
	
	      var rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
	      var rotateX = isHorizontal ? 0 : rotate * offsetMultiplier;
	      // var rotateZ = 0
	      var translateZ = -translate * Math.abs(offsetMultiplier);
	
	      var translateY = isHorizontal ? 0 : params.stretch * (offsetMultiplier);
	      var translateX = isHorizontal ? params.stretch * (offsetMultiplier) : 0;
	
	      // Fix for ultra small values
	      if (Math.abs(translateX) < 0.001) { translateX = 0; }
	      if (Math.abs(translateY) < 0.001) { translateY = 0; }
	      if (Math.abs(translateZ) < 0.001) { translateZ = 0; }
	      if (Math.abs(rotateY) < 0.001) { rotateY = 0; }
	      if (Math.abs(rotateX) < 0.001) { rotateX = 0; }
	
	      var slideTransform = "translate3d(" + translateX + "px," + translateY + "px," + translateZ + "px)  rotateX(" + rotateX + "deg) rotateY(" + rotateY + "deg)";
	
	      $slideEl.transform(slideTransform);
	      $slideEl[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
	      if (params.slideShadows) {
	        // Set shadows
	        var $shadowBeforeEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
	        var $shadowAfterEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
	        if ($shadowBeforeEl.length === 0) {
	          $shadowBeforeEl = $$1(("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'left' : 'top') + "\"></div>"));
	          $slideEl.append($shadowBeforeEl);
	        }
	        if ($shadowAfterEl.length === 0) {
	          $shadowAfterEl = $$1(("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'right' : 'bottom') + "\"></div>"));
	          $slideEl.append($shadowAfterEl);
	        }
	        if ($shadowBeforeEl.length) { $shadowBeforeEl[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0; }
	        if ($shadowAfterEl.length) { $shadowAfterEl[0].style.opacity = (-offsetMultiplier) > 0 ? -offsetMultiplier : 0; }
	      }
	    }
	
	    // Set correct perspective for IE10
	    if (Support.pointerEvents || Support.prefixedPointerEvents) {
	      var ws = $wrapperEl[0].style;
	      ws.perspectiveOrigin = center + "px 50%";
	    }
	  },
	  setTransition: function setTransition(duration) {
	    var swiper = this;
	    swiper.slides
	      .transition(duration)
	      .find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left')
	      .transition(duration);
	  },
	};
	
	var EffectCoverflow = {
	  name: 'effect-coverflow',
	  params: {
	    coverflowEffect: {
	      rotate: 50,
	      stretch: 0,
	      depth: 100,
	      modifier: 1,
	      slideShadows: true,
	    },
	  },
	  create: function create() {
	    var swiper = this;
	    Utils.extend(swiper, {
	      coverflowEffect: {
	        setTranslate: Coverflow.setTranslate.bind(swiper),
	        setTransition: Coverflow.setTransition.bind(swiper),
	      },
	    });
	  },
	  on: {
	    beforeInit: function beforeInit() {
	      var swiper = this;
	      if (swiper.params.effect !== 'coverflow') { return; }
	
	      swiper.classNames.push(((swiper.params.containerModifierClass) + "coverflow"));
	      swiper.classNames.push(((swiper.params.containerModifierClass) + "3d"));
	
	      swiper.params.watchSlidesProgress = true;
	      swiper.originalParams.watchSlidesProgress = true;
	    },
	    setTranslate: function setTranslate() {
	      var swiper = this;
	      if (swiper.params.effect !== 'coverflow') { return; }
	      swiper.coverflowEffect.setTranslate();
	    },
	    setTransition: function setTransition(duration) {
	      var swiper = this;
	      if (swiper.params.effect !== 'coverflow') { return; }
	      swiper.coverflowEffect.setTransition(duration);
	    },
	  },
	};
	
	// Swiper Class
	// Core Modules
	var components = [
	  Device$2,
	  Support$2,
	  Browser,
	  Resize,
	  Observer$1,
	  Virtual$1,
	  Keyboard$1,
	  Mousewheel$1,
	  Navigation$1,
	  Pagination$1,
	  Scrollbar$1,
	  Parallax$1,
	  Zoom$1,
	  Lazy$1,
	  Controller$1,
	  A11y,
	  History$1,
	  HashNavigation$1,
	  Autoplay$1,
	  EffectFade,
	  EffectCube,
	  EffectFlip,
	  EffectCoverflow
	];
	
	if (typeof Swiper$1.use === 'undefined') {
	  Swiper$1.use = Swiper$1.Class.use;
	  Swiper$1.installModule = Swiper$1.Class.installModule;
	}
	
	Swiper$1.use(components);
	
	return Swiper$1;
	
	})));


/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(19);
	var settle = __webpack_require__(229);
	var buildURL = __webpack_require__(232);
	var parseHeaders = __webpack_require__(238);
	var isURLSameOrigin = __webpack_require__(236);
	var createError = __webpack_require__(138);
	var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(231);
	
	module.exports = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	
	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }
	
	    var request = new XMLHttpRequest();
	    var loadEvent = 'onreadystatechange';
	    var xDomain = false;
	
	    // For IE 8/9 CORS support
	    // Only supports POST and GET calls and doesn't returns the response headers.
	    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
	    if (("production") !== 'test' &&
	        typeof window !== 'undefined' &&
	        window.XDomainRequest && !('withCredentials' in request) &&
	        !isURLSameOrigin(config.url)) {
	      request = new window.XDomainRequest();
	      loadEvent = 'onload';
	      xDomain = true;
	      request.onprogress = function handleProgress() {};
	      request.ontimeout = function handleTimeout() {};
	    }
	
	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password || '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }
	
	    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);
	
	    // Set the request timeout in MS
	    request.timeout = config.timeout;
	
	    // Listen for ready state
	    request[loadEvent] = function handleLoad() {
	      if (!request || (request.readyState !== 4 && !xDomain)) {
	        return;
	      }
	
	      // The request errored out and we didn't get a response, this will be
	      // handled by onerror instead
	      // With one exception: request that using file: protocol, most browsers
	      // will return status as 0 even though it's a successful request
	      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	        return;
	      }
	
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
	      var response = {
	        data: responseData,
	        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
	        status: request.status === 1223 ? 204 : request.status,
	        statusText: request.status === 1223 ? 'No Content' : request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	
	      settle(resolve, reject, response);
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config, null, request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
	        request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      var cookies = __webpack_require__(234);
	
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
	          cookies.read(config.xsrfCookieName) :
	          undefined;
	
	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }
	
	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }
	
	    // Add withCredentials to request if needed
	    if (config.withCredentials) {
	      request.withCredentials = true;
	    }
	
	    // Add responseType to request if needed
	    if (config.responseType) {
	      try {
	        request.responseType = config.responseType;
	      } catch (e) {
	        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
	        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
	        if (config.responseType !== 'json') {
	          throw e;
	        }
	      }
	    }
	
	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }
	
	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }
	
	    if (config.cancelToken) {
	      // Handle cancellation
	      config.cancelToken.promise.then(function onCanceled(cancel) {
	        if (!request) {
	          return;
	        }
	
	        request.abort();
	        reject(cancel);
	        // Clean up request
	        request = null;
	      });
	    }
	
	    if (requestData === undefined) {
	      requestData = null;
	    }
	
	    // Send the request
	    request.send(requestData);
	  });
	};


/***/ },
/* 136 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function Cancel(message) {
	  this.message = message;
	}
	
	Cancel.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};
	
	Cancel.prototype.__CANCEL__ = true;
	
	module.exports = Cancel;


/***/ },
/* 137 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};


/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var enhanceError = __webpack_require__(228);
	
	/**
	 * Create an Error with the specified message, config, error code, request and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	module.exports = function createError(message, config, code, request, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, request, response);
	};


/***/ },
/* 139 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _layout = __webpack_require__(15);
	
	var _ScrollTracker = __webpack_require__(72);
	
	var _ScrollTracker2 = _interopRequireDefault(_ScrollTracker);
	
	var _MenuItemSoon = __webpack_require__(71);
	
	var _MenuItemSoon2 = _interopRequireDefault(_MenuItemSoon);
	
	var _Superface = __webpack_require__(7);
	
	var _Superface2 = _interopRequireDefault(_Superface);
	
	var _Overline = __webpack_require__(42);
	
	var _Overline2 = _interopRequireDefault(_Overline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var About = function (_React$Component) {
	    _inherits(About, _React$Component);
	
	    function About(props) {
	        _classCallCheck(this, About);
	
	        // console.log(props)
	        var _this = _possibleConstructorReturn(this, (About.__proto__ || Object.getPrototypeOf(About)).call(this, props));
	
	        _this.handleScroll = _this.handleScroll.bind(_this);
	        return _this;
	    }
	
	    _createClass(About, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _this2 = this;
	
	            document.title = 'Contact - Superface';
	            this.setState({
	                mounted: false
	            });
	            this.scroll = new _ScrollTracker2.default();
	            this.timeoutStartScroll = window.setTimeout(function () {
	                _this2.scroll.start();
	            }, 1000);
	            this.scroll.on('scroll', this.handleScroll);
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this3 = this;
	
	            this.timeoutMount = setTimeout(function () {
	                _this3.setState({
	                    mounted: true
	                });
	            }, 800);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            if (this.timeoutStartScroll) window.clearTimeout(this.timeoutStartScroll);
	            if (this.timeoutMount) window.clearTimeout(this.timeoutMount);
	            this.scroll.destroy();
	        }
	    }, {
	        key: 'handleScroll',
	        value: function handleScroll(e) {
	            if (_Superface2.default.IS_MOBILE_OR_TABLET) return;
	            var ratio = this.scroll.positionY / (window.innerHeight / 2);
	
	            if (ratio < -2.5) {
	                this.scroll.stop();
	                this.scroll.off('scroll', this.handleScroll);
	                _Superface2.default.goTo(_Superface2.default.uri('accueil'));
	            }
	        }
	    }, {
	        key: 'renderCircle',
	        value: function renderCircle() {
	            if (!_Superface2.default.IS_MOBILE) {
	                return _react2.default.createElement(
	                    'div',
	                    { style: { width: _Superface2.default.IS_MOBILE ? '20vw' : '15rem', position: 'absolute', bottom: '0', left: '60%' } },
	                    _react2.default.createElement('img', { src: __webpack_require__(66), alt: 'Pi\xE8ce de Milan' })
	                );
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var contact = this.props.contact;
	            // console.log(contact)
	
	            if (!contact) return _react2.default.createElement('span', null);
	
	            var textStyle = {
	                fontSize: _Superface2.default.IS_MOBILE ? '1.2rem' : '2rem',
	                margin: 'auto',
	                color: 'white',
	                maxWidth: '900px',
	                width: '70%'
	            };
	
	            return _react2.default.createElement(
	                _layout.Flex,
	                { className: this.state.mounted ? 'mounted' : '', id: 'contact', align: 'center', justify: 'center', style: { backgroundColor: 'white', width: '100%', height: '100%' } },
	                _react2.default.createElement(
	                    'div',
	                    { id: 'contact-text' },
	                    _react2.default.createElement(
	                        'div',
	                        { style: Object.assign({}, textStyle, { color: 'black', position: 'relative' }) },
	                        _Superface2.default.field(contact, 'text'),
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement(
	                            'p',
	                            { style: { fontSize: '1.2rem', lineHeight: '2rem' } },
	                            contact.adresse,
	                            ',',
	                            _react2.default.createElement('br', null),
	                            ' ',
	                            contact.city,
	                            ', ',
	                            contact.country,
	                            _react2.default.createElement('br', null),
	                            contact.phone,
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement(
	                                'a',
	                                { href: 'mailto:' + contact.email },
	                                contact.email.replace('@', '(at)')
	                            ),
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement('br', null)
	                        ),
	                        _react2.default.createElement(
	                            'a',
	                            { className: 'icon icon-md', style: { marginLeft: '-0.5rem' }, href: _Superface2.default.datas().contact.facebook, target: '_blank' },
	                            _react2.default.createElement('img', { src: __webpack_require__(64), alt: 'facebook' })
	                        ),
	                        _react2.default.createElement(
	                            'a',
	                            { className: 'icon icon-md', href: _Superface2.default.datas().contact.instagram, target: '_blank' },
	                            _react2.default.createElement('img', { src: __webpack_require__(65), alt: 'instagram' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { style: { position: 'relative' } },
	                        this.renderCircle()
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { id: 'footer', style: { position: 'absolute', bottom: 0, width: '100%', height: '4rem', borderTop: '1px solid black' } },
	                    _react2.default.createElement(
	                        _layout.Flex,
	                        { justify: 'space-around' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'footer-link', style: { marginTop: 0 } },
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'overline-link', onClick: function onClick() {
	                                        _Superface2.default.goTo(_Superface2.default.uri('notre-metier'));
	                                    } },
	                                _react2.default.createElement(
	                                    _Overline2.default,
	                                    null,
	                                    _Superface2.default.translate('Notre métier')
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'footer-link', style: { marginTop: 0 } },
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'overline-link', onClick: function onClick() {
	                                        _Superface2.default.goTo(_Superface2.default.uri('matieres'));
	                                    } },
	                                _react2.default.createElement(
	                                    _Overline2.default,
	                                    null,
	                                    _Superface2.default.translate('Matières')
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'footer-link', style: { marginTop: 0 } },
	                            _react2.default.createElement(_MenuItemSoon2.default, { display: _Superface2.default.translate('Projets'), style: { display: 'inline-block', width: 'auto' } })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return About;
	}(_react2.default.Component);
	
	exports.default = About;

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(40);
	
	var _FooterSingle = __webpack_require__(252);
	
	var _FooterSingle2 = _interopRequireDefault(_FooterSingle);
	
	var _axios = __webpack_require__(69);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(96);
	
	var _kit = __webpack_require__(43);
	
	var kit = _interopRequireWildcard(_kit);
	
	var _layout = __webpack_require__(15);
	
	var _Superface = __webpack_require__(7);
	
	var _Superface2 = _interopRequireDefault(_Superface);
	
	var _GalleryLarge = __webpack_require__(253);
	
	var _GalleryLarge2 = _interopRequireDefault(_GalleryLarge);
	
	var _GallerySmall = __webpack_require__(145);
	
	var _GallerySmall2 = _interopRequireDefault(_GallerySmall);
	
	var _masonryLayout = __webpack_require__(512);
	
	var _masonryLayout2 = _interopRequireDefault(_masonryLayout);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Single = function (_React$Component) {
	    _inherits(Single, _React$Component);
	
	    function Single(props) {
	        _classCallCheck(this, Single);
	
	        var _this = _possibleConstructorReturn(this, (Single.__proto__ || Object.getPrototypeOf(Single)).call(this, props));
	
	        _this.handleScroll = _this.handleScroll.bind(_this);
	        _this.handleResize = _this.handleResize.bind(_this);
	        _this.refresh = _this.refresh.bind(_this);
	        _this.state = {
	            mounted: false,
	            leaving: false
	        };
	        return _this;
	    }
	
	    _createClass(Single, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(new_props) {
	
	            if (_Superface2.default.ready && this._single === undefined) {
	                _Superface2.default.setLoading(true);
	                this.setState(Object.assign({}, this.state, { mounted: false }));
	                this._single = _Superface2.default.getSingleBySlug(this.props.match.params.slug, this._type);
	                this.loadSingle();
	            }
	
	            if (new_props.match.params.slug !== this.props.match.params.slug) {
	                // on change de projet 
	                _Superface2.default.setLoading(true);
	                this.setState(Object.assign({}, this.state, { mounted: false }));
	                this._single = _Superface2.default.getSingleBySlug(new_props.match.params.slug, this._type);
	                this.loadSingle();
	            }
	        }
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	
	            if (_Superface2.default.ready && this._single === undefined) {
	                this._single = _Superface2.default.getSingleBySlug(this.props.match.params.slug, this._type);
	                document.title = _Superface2.default.field(this._single, 'name') + ' - Superface';
	                this.loadSingle();
	            }
	            window.addEventListener('resize', this.handleResize);
	        }
	    }, {
	        key: 'loadSingle',
	        value: function loadSingle() {
	            var _this2 = this;
	
	            var ids = [];
	            var images_loaded = 0;
	
	            ids.push(this._single.featured_image._id);
	
	            this._single.medias.forEach(function (media) {
	                if (media.field.name === 'image' && media.value !== null) {
	                    if (media.value.image !== null) {
	                        if (!media.value.image.video) {
	                            ids.push(media.value.image._id);
	                        }
	                    }
	                } else if (media.field.type === 'gallery') {
	                    if (media.value) {
	                        // console.log(media.value)
	                        media.value.forEach(function (img) {
	                            console.log(img.meta.asset);
	                            ids.push(img.meta.asset);
	                        });
	                    }
	                }
	            });
	
	            ids.forEach(function (id) {
	                console.log(id);
	                _axios2.default.request({
	                    method: 'post',
	                    url: _constants.API_URL + '/cockpit/image?token=' + _constants.TOKEN,
	                    data: {
	                        src: id,
	                        m: 'thumbnail',
	                        w: 680,
	                        q: 50
	                    }
	                }).then(function (response) {
	                    console.log(response);
	                    var img = new Image();
	                    img.onload = function () {
	                        images_loaded += 1;
	                        if (images_loaded === Math.round(ids.length / 2)) {
	                            _Superface2.default.setloadProgress('inc');
	                        }
	                        if (images_loaded >= ids.length) {
	                            _this2.initPage();
	                        }
	                    };
	                    img.src = response.data;
	                });
	            });
	        }
	    }, {
	        key: 'initPage',
	        value: function initPage() {
	
	            document.querySelector('#page-single').scrollTo(0, 0);
	            // setTimeout(() => {
	            if (!_Superface2.default.IS_MOBILE) this.initMasonry();
	            if (!_Superface2.default.IS_MOBILE_OR_TABLET) this.initParallax();
	            if (!_Superface2.default.IS_MOBILE_OR_TABLET) this.handleScroll();
	            if (!_Superface2.default.IS_MOBILE_OR_TABLET) this.mediasContainer.addEventListener('scroll', this.handleScroll);
	            this.setState(Object.assign({}, this.state, { mounted: true, leaving: false
	            }));
	            _Superface2.default.setLoading(false);
	            // }, 3000)
	            console.log('initPage');
	        }
	    }, {
	        key: 'initMasonry',
	        value: function initMasonry() {
	            this.masonry = {};
	            var grid = document.getElementById('scrollable-body');
	            var col_width = '';
	            var size = ['sm', 'md', 'lg'];
	            size.forEach(function (s) {
	                if (document.querySelectorAll('.image_' + s).length > 0) {
	                    col_width = '.image_' + s;
	                }
	            });
	
	            this.masonry = new _masonryLayout2.default(grid, { columnWidth: col_width, itemSelector: '.brick' });
	        }
	    }, {
	        key: 'initParallax',
	        value: function initParallax() {
	            var _this3 = this;
	
	            this.scrollData = [];
	            // const container = this.mediasContainer
	            var scrollableBody = document.getElementById('scrollable-body');
	            // const progress = container.scrollTop / scrollableBody.offsetHeight
	            document.querySelectorAll('.brick.scrollable').forEach(function (el, i) {
	                var q = i % 3 === 0 ? 0.85 : 0.65;
	                if (i % 2 === 0) q *= 0.4;
	                _this3.scrollData.push({
	                    topPos: parseInt(el.style.top) + scrollableBody.offsetTop,
	                    height: el.clientHeight,
	                    q: q
	                });
	            });
	            // this.containerHeight = this.mediasContainer.offsetHeight
	        }
	    }, {
	        key: 'setBrickPos',
	        value: function setBrickPos(i, progress, el) {
	            var q = this.scrollData[i].q;
	            // const py = this.scrollData[i].topPos
	            var tr = el.childNodes[0].style.transform.split(' ');
	            var currentY = parseFloat(tr[1].replace('translateY(', '').replace('%)', ''));
	            var targetY = q * progress * 200;
	            var nextY = currentY + (targetY - currentY) * 0.13;
	            //  if (i === 3) console.log(targetY)
	            var transform = 'translateX(' + 0 + '%)' + ' translateY(' + nextY + 'px)';
	            el.childNodes[0].style.transform = transform;
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.clearTimeout(this.timeoutMount);
	            window.clearTimeout(this.timeoutScroll);
	            cancelAnimationFrame(this.rafID);
	            if (this.timeoutLoad) clearTimeout(this.timeoutLoad);
	            if (this.timeoutChange) clearTimeout(this.timeoutChange);
	            this.mediasContainer.removeEventListener('scroll', this.handleScroll);
	            window.removeEventListener('resize', this.handleResize);
	        }
	    }, {
	        key: 'handleResize',
	        value: function handleResize() {
	            this.setState(Object.assign({}, this.state));
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            _Superface2.default.setLoading(true);
	        }
	    }, {
	        key: 'handleScroll',
	        value: function handleScroll(e) {
	            var _this4 = this;
	
	            if (_Superface2.default.IS_MOBILE_OR_TABLET) return;
	            if (this.timeoutScroll) clearTimeout(this.timeoutScroll);
	
	            if (!this.isScrolling) {
	                this.rafID = requestAnimationFrame(this.refresh);
	            }
	            this.timeoutScroll = setTimeout(function () {
	                _this4.isScrolling = false;
	                cancelAnimationFrame(_this4.rafID);
	            }, 500);
	        }
	    }, {
	        key: 'refresh',
	        value: function refresh() {
	            var _this5 = this;
	
	            this.isScrolling = true;
	            var container = this.mediasContainer;
	            //   const scrollableBody = document.getElementById('scrollable-body')
	            document.querySelectorAll('.brick.scrollable').forEach(function (el, i) {
	                var elemTop = _this5.scrollData[i].topPos;
	                var elemHeight = el.offsetHeight;
	
	                var scrollOffset = container.scrollTop;
	                var relativeOffset = elemTop - scrollOffset;
	                var p = (relativeOffset + elemHeight) / (window.innerHeight + elemHeight);
	                // if(i===3){
	                //     el.style.border = '1px solid red'
	                //    console.log({ p })
	                // }
	                if (p >= 0 && p <= 1) {
	                    _this5.setBrickPos(i, p, el);
	                }
	            });
	            this.rafID = requestAnimationFrame(this.refresh);
	        }
	    }, {
	        key: 'renderFeaturedImage',
	        value: function renderFeaturedImage(single) {
	            if (!_Superface2.default.IS_MOBILE_OR_TABLET) {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'single-featured-container', style: { width: '50%', overflow: 'hidden', position: 'relative' } },
	                    _react2.default.createElement('img', { src: _Superface2.default.assetUrl(single.featured_image.path), alt: _Superface2.default.field(this._single, 'name') })
	                );
	            }
	        }
	    }, {
	        key: 'renderSubTitle',
	        value: function renderSubTitle(single) {
	            if (this._type === 'projet') {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'single-type', style: { textAlign: 'center', marginBottom: '1rem' } },
	                    _Superface2.default.field(single.activity_area, 'display')
	                );
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this6 = this;
	
	            var single = this._single;
	            var key_uri = this._type === 'kind' ? 'matieres' : 'projets';
	            var style = {
	                position: 'absolute',
	                top: 0, left: 0, right: 0, bottom: 0,
	                minHeight: '100vh',
	                zIndex: 500,
	                backgroundColor: 'white',
	                overflowY: 'scroll', overflowX: 'hidden'
	            };
	
	            if (!single) return _react2.default.createElement('div', { id: 'page-single', ref: function ref(el) {
	                    _this6.mediasContainer = el;
	                } });
	
	            var text = _Superface2.default.field(single, 'body');
	
	            return _react2.default.createElement(
	                'div',
	                {
	                    id: 'page-single',
	                    ref: function ref(el) {
	                        _this6.mediasContainer = el;
	                    },
	                    style: style,
	                    className: (this.state.mounted ? 'mounted ' : ' ') + (this.state.leaving || this.props.singleLeaving ? 'leaving ' : ' ') + (_Superface2.default.IS_MOBILE ? 'mobile ' : ' ')
	                },
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { style: { display: 'flex' } },
	                        this.renderFeaturedImage(single),
	                        _react2.default.createElement(
	                            'div',
	                            { style: { width: '50%', padding: '4rem', flex: 1 } },
	                            _react2.default.createElement(
	                                _layout.Flex,
	                                { direction: 'column', justify: 'center', align: 'center', style: { width: '100%', paddingTop: _Superface2.default.IS_MOBILE_OR_TABLET ? '4rem' : '10vh' } },
	                                this.renderSubTitle(single),
	                                _react2.default.createElement(
	                                    'h1',
	                                    { className: 'single-title', style: { textTransform: 'capitalize', fontSize: '3rem', textAlign: 'center', paddingBottom: '2rem' } },
	                                    _Superface2.default.field(single, 'name')
	                                ),
	                                _react2.default.createElement('div', { className: 'single-body', style: { maxWidth: 450 }, dangerouslySetInnerHTML: this.createMarkup(text) })
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { id: 'scrollable-body', className: 'single-medias' },
	                        this.renderMedias()
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'single-footer', style: { display: 'flex', width: 'calc( 100% - 4rem)', justifyContent: 'space-between', padding: '4rem 2rem', marginTop: '10vh' } },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'single-bottom-nav-item previous' },
	                            this.renderPreviousItemNav()
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                'div',
	                                { onClick: function onClick() {
	                                        _Superface2.default.singleLeaving(true);
	                                        setTimeout(function () {
	                                            _Superface2.default.goTo(_Superface2.default.uri(key_uri));
	                                            _Superface2.default.singleLeaving(false);
	                                        }, 600);
	                                    }, className: 'cross' },
	                                _react2.default.createElement('img', { src: __webpack_require__(482), alt: 'cross' })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'single-bottom-nav-item next' },
	                            this.renderNextItemNav()
	                        )
	                    )
	                ),
	                _react2.default.createElement(_FooterSingle2.default, null)
	            );
	        }
	    }, {
	        key: 'renderNextItemNav',
	        value: function renderNextItemNav() {
	            var _this7 = this;
	
	            var nextItem = _Superface2.default.getNextSingle(this._single, this._type);
	            var fontSize = _Superface2.default.IS_MOBILE_OR_TABLET ? '1.2rem' : '2rem';
	            if (window.innerWidth < 1440) fontSize = '1.5rem';
	            var key_uri = this._type === 'kind' ? 'matieres' : 'projets';
	            if (nextItem) {
	                return _react2.default.createElement(
	                    _layout.Flex,
	                    {
	                        align: 'center',
	                        justify: _Superface2.default.IS_MOBILE ? "flex-end" : "center",
	                        onMouseDown: function onMouseDown() {
	                            _this7.goToSingle(nextItem);
	                        }
	                    },
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'next-text' },
	                            _Superface2.default.translate('Projet suivant : ')
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { style: { fontSize: fontSize, textTransform: 'capitalize' } },
	                            _Superface2.default.field(nextItem, 'name')
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'arrow' },
	                        _react2.default.createElement('img', { src: __webpack_require__(124), alt: 'arrow' })
	                    )
	                );
	            }
	            return;
	        }
	    }, {
	        key: 'renderPreviousItemNav',
	        value: function renderPreviousItemNav() {
	            var _this8 = this;
	
	            var previousItem = _Superface2.default.getPreviousSingle(this._single, this._type);
	            var fontSize = _Superface2.default.IS_MOBILE_OR_TABLET ? '1.2rem' : '2rem';
	
	            if (window.innerWidth < 1440) fontSize = '1.5rem';
	            if (previousItem) {
	                return _react2.default.createElement(
	                    _layout.Flex,
	                    {
	                        align: 'center',
	                        justify: _Superface2.default.IS_MOBILE ? "flex-start" : "center",
	                        onMouseDown: function onMouseDown() {
	                            _this8.goToSingle(previousItem);
	                        }
	                    },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'arrow' },
	                        _react2.default.createElement('img', { src: __webpack_require__(123), alt: 'arrow' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'previous-text' },
	                            _Superface2.default.translate('Projet précédent :')
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { style: { fontSize: fontSize, textTransform: 'capitalize' } },
	                            _Superface2.default.field(previousItem, 'name')
	                        )
	                    )
	                );
	            }
	            return;
	        }
	    }, {
	        key: 'goToSingle',
	        value: function goToSingle(single) {
	            var key_uri = this._type === 'kind' ? 'matieres' : 'projets';
	            this.setState(Object.assign({}, this.state, { leaving: true, mounted: false }));
	            this.timeoutChange = setTimeout(function () {
	                _Superface2.default.goTo(_Superface2.default.uri(key_uri) + '/' + single.slug);
	            }, 500);
	        }
	
	        //  renderCols(medias, i){
	        //     const C = ['yellow', 'red', 'blue', 'gold', 'green', 'black', '#dddddd', 'tomato', 'yellow', 'red', 'blue', 'gold', 'green', 'black', '#dddddd', 'tomato', 'yellow', 'red', 'blue', 'gold', 'green', 'black', '#dddddd', 'tomato', 'yellow', 'red', 'blue', 'gold', 'green', 'black', '#dddddd', 'tomato']
	        //      return (
	        //          <div key={"col-" + i} className="single-cols">
	        //              { medias.map( (media, i) => {
	
	        //                  const style = {
	        //                      display: 'block', border : `1px solid ${C[i]}`
	        //                  }
	        //                  console.log(style)
	        //                  switch( media.field.name){
	
	        //                      case 'gallery_xs':
	        //                          if( media.value === null ) return
	        //                          return( 
	        //                              <div style={style} className={"brick image_sm gallery-small"} key={"medias-" + i}>
	        //                                  <GallerySmall i={i} slides={media.value} name="single" /> 
	        //                              </div>
	        //                          )
	
	        //                      default:
	        //                          if( media.value === null ) return
	        //                          if( media.value.size === undefined ) return
	        //                          if( media.value.image === null ) return
	
	        //                          if( media.value.image.video ){
	
	        //                              if( !Superface.IS_MOBILE_OR_TABLET ){
	        //                                  return(
	        //                                      <div style={style} className={"brick image_" + media.value.size.toLowerCase()} key={i}>
	        //                                          <video muted src={Superface.assetUrl(media.value.image.path)} alt={Superface.field(this._single, 'name')} autoPlay loop />
	        //                                      </div>
	        //                                  )    
	        //                              }
	        //                          }
	        //                          console.log( 'description : ', media.value.image.description )
	        //                          return(
	        //                              <div title={media.value.image.description}  style={style} className={"brick scrollable image_" + media.value.size.toLowerCase()} key={i}>
	        //                                 <img style={{transform:'translateX(0%) translateY(0%)'}} src={Superface.assetUrl(media.value.image.thumb_path)} alt={Superface.field(this._single, 'name')} />
	        //                              </div>
	        //                          )
	        //                  }
	        //              })}
	        //          </div>
	        //      )
	        //  }
	
	    }, {
	        key: 'renderMedias',
	        value: function renderMedias() {
	            var _this9 = this;
	
	            if (!this._single.medias.length > 0) return;
	
	            return this._single.medias.map(function (media, i) {
	
	                if (media.field.name === 'gallery_l') {
	
	                    if (!_Superface2.default.IS_MOBILE) {
	                        return _react2.default.createElement(
	                            'div',
	                            { style: { textAlign: Math.random() < 0.5 ? 'center' : 'right' }, className: 'brick', key: i },
	                            _react2.default.createElement(_GalleryLarge2.default, { i: i, slides: media.value })
	                        );
	                    } else {
	                        return _react2.default.createElement(
	                            'div',
	                            { style: { textAlign: 'center' }, className: "brick image_md", key: i },
	                            _react2.default.createElement(_GallerySmall2.default, { i: i, slides: media.value })
	                        );
	                    }
	                } else if (media.field.name === 'gallery_xs') {
	
	                    if (media.value === null) return;
	                    return _react2.default.createElement(
	                        'div',
	                        { style: { textAlign: Math.random() < 0.5 || _Superface2.default.IS_MOBILE ? 'center' : 'right' }, className: "brick image_md gallery-small", key: "medias-" + i },
	                        _react2.default.createElement(_GallerySmall2.default, { i: i, slides: media.value, name: 'single' })
	                    );
	                } else if (media.field.name === 'image') {
	
	                    if (media.value === null) return;
	                    if (media.value.image === null) return;
	                    if (media.value.size === undefined) media.value.size = 'md';
	
	                    if (media.value.image.video) {
	
	                        if (!_Superface2.default.IS_MOBILE_OR_TABLET) {
	                            return _react2.default.createElement(
	                                'div',
	                                { style: { textAlign: Math.random() < 0.2 || _Superface2.default.IS_MOBILE ? 'center' : 'right' }, className: "brick image_" + media.value.size.toLowerCase(), key: i },
	                                _react2.default.createElement('video', { muted: true, src: _Superface2.default.assetUrl(media.value.image.path), alt: _Superface2.default.field(_this9._single, 'name'), autoPlay: true, loop: true })
	                            );
	                        }
	                    }
	
	                    return _react2.default.createElement(
	                        'div',
	                        { style: { textAlign: Math.random() < 0.2 || _Superface2.default.IS_MOBILE ? 'center' : 'right' }, title: media.value.image.description, className: "brick scrollable image_" + media.value.size.toLowerCase(), key: i },
	                        _react2.default.createElement('img', { style: { transform: 'translateX(0%) translateY(0%)', display: 'inline-block' }, src: _Superface2.default.assetUrl(media.value.image.thumb_path), alt: _Superface2.default.field(_this9._single, 'name') })
	                    );
	                }
	            });
	        }
	
	        // renderMedias(){
	        //     if( !this._single.medias.length > 0 ) return
	
	        //     let blocks = []
	        //     let i = 0
	        //     this._single.medias.forEach( media => {
	
	        //         if( media.field.name != 'gallery_l' ){
	
	        //             if( blocks[i] === undefined ) blocks[i] = []
	        //             blocks[i].push(media)
	        //         }else{
	        //             i++
	        //             blocks[i] = media
	        //             i++
	        //         }
	        //     })
	
	        //     return blocks.map( (bloc, i) => {
	
	        //         if( bloc instanceof Array ){
	        //             return this.renderCols(bloc, i)
	        //         }else{
	        //             if( !Superface.IS_MOBILE ){
	        //                 return (
	        //                     <div className="brick" key={i}>
	        //                         <GalleryLarge i={i} slides={bloc.value} />
	        //                     </div>
	        //                 )
	        //             }else{
	        //                 return (
	        //                     <div className={"brick image_md"} key={i}>
	        //                         <GallerySmall i={i} slides={bloc.value} />
	        //                     </div>
	        //                 )
	        //             }
	        //         }
	        //     })
	
	        // }
	
	    }, {
	        key: 'createMarkup',
	        value: function createMarkup(html) {
	            return { __html: html };
	        }
	    }]);
	
	    return Single;
	}(_react2.default.Component);
	
	exports.default = Single;

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _burgerToCross = __webpack_require__(500);
	
	var _burgerToCross2 = _interopRequireDefault(_burgerToCross);
	
	var _lottieWeb = __webpack_require__(129);
	
	var _lottieWeb2 = _interopRequireDefault(_lottieWeb);
	
	var _Superface = __webpack_require__(7);
	
	var _Superface2 = _interopRequireDefault(_Superface);
	
	var _reactRouter = __webpack_require__(41);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import burgerHover from '../json/burger-hover.json'
	
	
	var Burger = function (_React$Component) {
	    _inherits(Burger, _React$Component);
	
	    function Burger() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Burger);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Burger.__proto__ || Object.getPrototypeOf(Burger)).call.apply(_ref, [this].concat(args))), _this), _this.options = {
	            renderer: 'svg',
	            loop: false,
	            autoplay: false
	            // animationData : milanAnimation
	        }, _this.isHoverPlaying = false, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Burger, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.setState(Object.assign({}, this.state, { hover: false, mounted: false
	            }));
	            // this.setState({mounted : false})
	        }
	
	        // componentDidMount(){
	        //     this.burger_to_cross.goToAndStop(0)
	        //     this.burger_hover.goToAndPlay(0)
	        //     // this.setState({mounted : true})
	        // }
	        // direction = -1
	        // componentDidMount(){
	
	        // }
	
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(new_props) {
	            // console.log(' THIS.PROPS.OPEN : ', this.props.open)
	            if (new_props.open !== this.props.open) {
	                // alert('sisi')
	                if (new_props.open) {
	                    // alert('sisi')
	                    // this.burger_to_cross.seek(0)
	                    // this.cross_to_burger.goToAndPlay(0)
	                    // alert('open')
	                    // this.burger_to_cross.pause()
	                    this.burger_to_cross.pause();
	                    this.burger_to_cross.setDirection(1);
	                    this.burger_to_cross.goToAndPlay(0);
	                } else {
	                    this.burger_to_cross.pause();
	                    this.burger_to_cross.setDirection(-1);
	                    this.burger_to_cross.play();
	                    // alert('close')
	                    // this.burger_to_cross.seek(0)
	                }
	            }
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            this.burger_to_cross = _lottieWeb2.default.loadAnimation(Object.assign({}, this.options, { container: this.container, animationData: _burgerToCross2.default }));
	            // this.burger_hover = Lottie.loadAnimation( {...this.options, container : this.containerHover, animationData : burgerHover } )
	            if (this.props.open) {
	                this.burger_to_cross.pause();
	                this.burger_to_cross.setDirection(1);
	                this.burger_to_cross.goToAndPlay(0);
	            }
	            this.timeoutMount = setTimeout(function () {
	                _this2.setState(Object.assign({}, _this2.state, { mounted: true
	                }));
	            }, 600);
	        }
	    }, {
	        key: 'onMouseEnter',
	        value: function onMouseEnter() {
	            this.setState(Object.assign({}, this.state, { hover: true
	            }));
	            // this.burger_hover.goToAndPlay(0)
	        }
	    }, {
	        key: 'onMouseLeave',
	        value: function onMouseLeave() {
	            this.setState(Object.assign({}, this.state, { hover: false
	            }));
	        }
	    }, {
	        key: 'handleClick',
	        value: function handleClick() {
	            if (_Superface2.default.app().isOnSingle) {
	                _Superface2.default.singleLeaving(true);
	                setTimeout(function () {
	                    _Superface2.default.goTo(_Superface2.default.uri(_Superface2.default.app().currentSection));
	                    _Superface2.default.singleLeaving(false);
	                }, 600);
	            } else {
	                _Superface2.default.toggleMenu();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var open = this.props.open;
	
	            var style = { cursor: 'pointer', width: '2rem', position: 'fixed', zIndex: 2000, right: '2rem', top: '2.5rem'
	
	                // display : open ? 'block' : 'none'
	            };return _react2.default.createElement(
	                'div',
	                { id: 'burger', className: this.state.mounted ? 'mounted' : '', style: style,
	                    onMouseEnter: function onMouseEnter(e) {
	                        _this3.onMouseEnter(e);
	                    },
	                    onMouseLeave: function onMouseLeave(e) {
	                        _this3.onMouseLeave(e);
	                    },
	                    onClick: function onClick(e) {
	                        _this3.handleClick(e);
	                    }
	                },
	                _react2.default.createElement('div', { style: { display: open ? 'block' : 'none' }, ref: function ref(container) {
	                        _this3.container = container;
	                    } }),
	                _react2.default.createElement(
	                    'div',
	                    { id: 'burger-strokes', className: this.state.hover ? 'hover' : '', style: { display: open ? 'none' : 'block' } },
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        _react2.default.createElement('span', null),
	                        _react2.default.createElement('span', null)
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        _react2.default.createElement('span', null),
	                        _react2.default.createElement('span', null)
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        _react2.default.createElement('span', null),
	                        _react2.default.createElement('span', null)
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Burger;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRouter.withRouter)(Burger);

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(40);
	
	var _Superface = __webpack_require__(7);
	
	var _Superface2 = _interopRequireDefault(_Superface);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import milanAnimation from '../json/milan.json'
	// import milanBlackAnimation from '../json/milan-black.json'
	// import Lottie from 'lottie-web'
	
	
	var ANGLES = {
	    'N': 90,
	    'E': 180,
	    'S': 270,
	    'W': 0,
	    'center': 0
	};
	
	var Compass = function (_React$Component) {
	    _inherits(Compass, _React$Component);
	
	    function Compass(props) {
	        _classCallCheck(this, Compass);
	
	        var _this = _possibleConstructorReturn(this, (Compass.__proto__ || Object.getPrototypeOf(Compass)).call(this, props));
	
	        _this.direction = 1;
	        _this.options = {
	            renderer: 'svg',
	            loop: true,
	            autoplay: false
	            // animationData : milanAnimation
	        };
	        _this.oldCardinal = 'W';
	        _this.lastAngle = 0;
	
	        _this.handleMouseMove = _this.handleMouseMove.bind(_this);
	        _this.handleMouseDown = _this.handleMouseDown.bind(_this);
	        return _this;
	    }
	
	    _createClass(Compass, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.setState({
	                mounted: false
	            });
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            this.timeoutMount = setTimeout(function () {
	                _this2.setState(Object.assign({}, _this2.state, { mounted: true
	                }));
	            }, 600);
	
	            window.addEventListener('mousemove', this.handleMouseMove);
	            window.addEventListener('mousedown', this.handleMouseDown);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(new_props) {
	            if (this.props.cardinal !== new_props.cardinal) {
	                this.oldCardinal = this.props.cardinal;
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            if (this.timeoutMount) clearTimeout(this.timeoutMount);
	            window.removeEventListener('mousemove', this.handleMouseMove);
	        }
	    }, {
	        key: 'handleMouseMove',
	        value: function handleMouseMove(e) {
	            if (this.props.section !== 'accueil') return;
	
	            var setCompass = _Superface2.default.setCompass;
	
	            var xFromCenter = e.pageX - window.innerWidth / 2;
	            var yFromCenter = e.pageY - window.innerHeight / 2;
	            var angleRad = Math.atan(yFromCenter / xFromCenter);
	
	            if (xFromCenter > 0) {
	                angleRad += Math.PI;
	            } else {
	                if (yFromCenter > 0) {
	                    angleRad = 2 * Math.PI + angleRad;
	                }
	            }
	
	            var degree = angleRad * 180 / Math.PI;
	            if (degree > 45 && degree <= 135) setCompass('N');else if (degree > 135 && degree <= 225) setCompass('E');else if (degree > 225 && degree <= 315) setCompass('S');else setCompass('W');
	        }
	    }, {
	        key: 'handleMouseDown',
	        value: function handleMouseDown() {
	            // if( this.props.section !== 'accueil' ) return
	            // switch(this.props.cardinal){
	            //     case 'N':
	            //         Superface.goTo(Superface.uri('contact'))
	            //         break;
	            //     case 'S':
	            //         Superface.goTo(Superface.uri('notre-metier'))
	            //         break;
	            //     case 'W':
	            //         Superface.goTo(Superface.uri('matieres'))
	            //         break;
	            //     case 'E':
	            //         Superface.goTo(Superface.uri('projets'))
	            //         break;
	            // }
	        }
	    }, {
	        key: 'renderSectionTitle',
	        value: function renderSectionTitle() {
	            if (this.props.section !== 'accueil' && !this.props.menuOpen) {
	                var fontStyle = { position: 'absolute', left: '7rem', top: '2rem', width: '9rem' };
	                return _react2.default.createElement(
	                    'div',
	                    { style: fontStyle },
	                    _Superface2.default.translate(_Superface2.default.getSectionName(this.props.section))
	                );
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var squareWidth = '6rem';
	            var _props = this.props,
	                section = _props.section,
	                menuOpen = _props.menuOpen,
	                cardinal = _props.cardinal;
	
	            var style = { width: squareWidth, height: squareWidth, position: 'fixed', left: '2rem', top: '2rem', zIndex: 1352 };
	            var squareStyle = { width: squareWidth, height: squareWidth, position: 'absolute', left: 0, top: 0 };
	
	            var rotate = void 0;
	
	            if (this.props.cardinal !== this.oldCardinal) {
	                var finalAngle = ANGLES[this.props.cardinal];
	                var angleOffset = finalAngle - ANGLES[this.oldCardinal];
	                if (angleOffset > 180) angleOffset = 180 - angleOffset;
	                if (angleOffset < -180) angleOffset += 360;
	
	                var currentAngle = this.lastAngle + angleOffset;
	                this.lastAngle = currentAngle % 360 === 0 ? 0 : currentAngle;
	                this.oldCardinal = this.props.cardinal;
	                rotate = 'rotate(' + currentAngle + 'deg)';
	            } else {
	                rotate = this.lastRotate;
	            }
	            this.lastRotate = rotate;
	            var classNamesBase = _Superface2.default.IS_MOBILE ? 'compass-mobile opacity-' + (this.props.hidden ? '0' : '1') : '';
	
	            return _react2.default.createElement(
	                'div',
	                { id: 'compass', className: classNamesBase + (this.state.mounted ? ' mounted' : ''), style: style },
	                this.renderSectionTitle(),
	                _react2.default.createElement(
	                    'div',
	                    {
	                        ref: function ref(stroke) {
	                            return _this3.stroke = stroke;
	                        },
	                        onClick: function onClick(e) {
	                            if (menuOpen) _Superface2.default.toggleMenu();_Superface2.default.goTo(_Superface2.default.uri('accueil'));
	                        },
	                        style: { transform: rotate, cursor: 'pointer', position: 'absolute', zIndex: 5000, width: squareWidth, height: squareWidth },
	                        className: 'stroke-container'
	                    },
	                    _react2.default.createElement(
	                        'div',
	                        { className: "stroke-index " + (section !== 'accueil' ? 'shown' : ''), style: squareStyle },
	                        _react2.default.createElement('img', { src: __webpack_require__(495), alt: 'Superface pi\xE8ce de Milan' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: "stroke-index " + (section !== 'accueil' ? '' : 'shown'), style: squareStyle },
	                        _react2.default.createElement('img', { src: __webpack_require__(494), alt: 'Superface pi\xE8ce de Milan' })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: "logo-index " + (section !== 'accueil' ? 'shown' : ''), style: squareStyle },
	                    _react2.default.createElement('img', { src: __webpack_require__(66), alt: 'Superface pi\xE8ce de Milan' })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: "logo-index " + (section !== 'accueil' ? '' : 'shown'), style: squareStyle },
	                    _react2.default.createElement('img', { src: __webpack_require__(496), alt: 'Superface pi\xE8ce de Milan' })
	                )
	            );
	        }
	    }]);
	
	    return Compass;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRouterDom.withRouter)(Compass);

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _layout = __webpack_require__(15);
	
	var _Plus = __webpack_require__(95);
	
	var _Plus2 = _interopRequireDefault(_Plus);
	
	var _Superface = __webpack_require__(7);
	
	var _Superface2 = _interopRequireDefault(_Superface);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MaterialsKinds = function (_React$Component) {
	    _inherits(MaterialsKinds, _React$Component);
	
	    function MaterialsKinds(props) {
	        _classCallCheck(this, MaterialsKinds);
	
	        var _this = _possibleConstructorReturn(this, (MaterialsKinds.__proto__ || Object.getPrototypeOf(MaterialsKinds)).call(this, props));
	
	        _this.handleClick = _this.handleClick.bind(_this);
	        _this.handleResize = _this.handleResize.bind(_this);
	
	        return _this;
	    }
	
	    _createClass(MaterialsKinds, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            this.setState({
	                mounted: false
	            });
	            window.addEventListener('resize', this.handleResize);
	        }
	    }, {
	        key: "handleResize",
	        value: function handleResize() {
	            this.setState(Object.assign({}, this.state));
	        }
	    }, {
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            this.timeoutMount = window.setTimeout(function () {
	                // alert()
	                _this2.setState({
	                    mounted: true
	                });
	            }, 1200);
	        }
	    }, {
	        key: "componentWillUnmount",
	        value: function componentWillUnmount() {
	            window.clearTimeout(this.timeoutMount);
	        }
	    }, {
	        key: "handleClick",
	        value: function handleClick(slug) {
	            _Superface2.default.toggleFilter(slug, this.props.type);
	        }
	    }, {
	        key: "renderControl",
	        value: function renderControl() {
	            var _this3 = this;
	
	            return this.props.filters.map(function (filter, i) {
	                return _react2.default.createElement(
	                    _layout.Flex,
	                    {
	                        className: "filter",
	                        direction: "column",
	                        align: "center",
	                        justify: "flex-end",
	                        key: 'filter' + i,
	                        style: { pointerEvents: 'all' },
	                        onMouseDown: function onMouseDown(e) {
	                            e.preventDefault();_this3.handleClick(filter.slug);
	                        }
	                    },
	                    _react2.default.createElement(_Plus2.default, { selected: filter.active ? true : false }),
	                    _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                            "p",
	                            { className: filter.active ? '' : ' active' },
	                            _react2.default.createElement(
	                                "span",
	                                null,
	                                _Superface2.default.field(filter, 'name')
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        null,
	                        "\xA0\xA0"
	                    )
	                );
	            });
	        }
	    }, {
	        key: "render",
	        value: function render() {
	
	            var style = {
	                position: 'absolute',
	                bottom: '0',
	                width: '100%',
	                justifyContent: 'center',
	                pointerEvents: 'none',
	                display: window.innerWidth < 900 ? 'none' : 'flex'
	            };
	
	            return _react2.default.createElement(
	                _layout.Flex,
	                { id: "filters", className: this.state.mounted ? 'mounted' : '', style: style },
	                this.renderControl()
	            );
	        }
	    }]);
	
	    return MaterialsKinds;
	}(_react2.default.Component);
	
	exports.default = MaterialsKinds;

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Superface = __webpack_require__(7);
	
	var _Superface2 = _interopRequireDefault(_Superface);
	
	var _swiper = __webpack_require__(134);
	
	var _swiper2 = _interopRequireDefault(_swiper);
	
	var _kit = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GallerySmall = function (_React$Component) {
	    _inherits(GallerySmall, _React$Component);
	
	    function GallerySmall() {
	        _classCallCheck(this, GallerySmall);
	
	        return _possibleConstructorReturn(this, (GallerySmall.__proto__ || Object.getPrototypeOf(GallerySmall)).apply(this, arguments));
	    }
	
	    _createClass(GallerySmall, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.images_loaded = 0;
	            this.setState({
	                loaded: false,
	                activeIndex: 0
	            });
	        }
	    }, {
	        key: 'initSlider',
	        value: function initSlider() {
	            var _this2 = this;
	
	            if (this.swiper) return;
	
	            (0, _kit.addClass)(this.slider, 'slider-' + this.props.i);
	            (0, _kit.addClass)(this.pagination, 'pagination-' + this.props.i);
	
	            var params = {
	                speed: 400
	                // loop : true,
	            };
	
	            setTimeout(function () {
	                _this2.swiper = new _swiper2.default('.slider-' + _this2.props.i, params);
	                _this2.swiper.on('slideChange', function () {
	                    _this2.setState(Object.assign({}, _this2.state, {
	                        activeIndex: _this2.swiper.activeIndex
	                    }));
	                });
	            }, 500);
	        }
	    }, {
	        key: 'renderMedias',
	        value: function renderMedias(slides) {
	            var _this3 = this;
	
	            return slides.map(function (slide, i) {
	                // console.log('PATH ' + slide.path)
	                // console.log('MODIFIED PATH ' + Superface.assetUrl(slide.path))
	                return _react2.default.createElement(
	                    'div',
	                    { key: i,
	                        className: 'swiper-slide',
	                        style: { display: 'inline-block' }
	                    },
	                    _react2.default.createElement('img', { alt: _this3.props.name, src: _Superface2.default.assetUrl(slide.path), onLoad: function onLoad() {
	                            _this3.images_loaded++;
	                            // console.log( this.images_loaded + '/' + this.props.slides.length )
	                            if (_this3.images_loaded === _this3.props.slides.length) {
	                                _this3.setState({ loaded: true });
	                                _this3.initSlider();
	                            }
	                        } })
	                );
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { style: { display: 'block', backgroundColor: 'white', position: 'relative' } },
	                _react2.default.createElement(
	                    'div',
	                    { ref: function ref(slider) {
	                            return _this4.slider = slider;
	                        }, className: "swiper-container swiper-small " + this.props.name },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'swiper-wrapper' },
	                        this.renderMedias(this.props.slides)
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { ref: function ref(pagination) {
	                            return _this4.pagination = pagination;
	                        }, className: 'swiper-pagination' },
	                    this.props.slides.map(function (slide, i) {
	                        return _react2.default.createElement('span', {
	                            onClick: function onClick() {
	                                _this4.swiper.slideTo(i);
	                            },
	                            style: { cursor: 'pointer' },
	                            key: 'slide -' + i,
	                            className: "swiper-pagination-bullet " + (_this4.state.activeIndex === i ? 'swiper-pagination-bullet-active' : '')
	                        });
	                    })
	                )
	            );
	        }
	    }]);
	
	    return GallerySmall;
	}(_react2.default.Component);
	
	exports.default = GallerySmall;

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _milanBlack = __webpack_require__(501);
	
	var _milanBlack2 = _interopRequireDefault(_milanBlack);
	
	var _lottieWeb = __webpack_require__(129);
	
	var _lottieWeb2 = _interopRequireDefault(_lottieWeb);
	
	var _Superface = __webpack_require__(7);
	
	var _Superface2 = _interopRequireDefault(_Superface);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LoadingAnimation = function (_React$Component) {
	    _inherits(LoadingAnimation, _React$Component);
	
	    function LoadingAnimation() {
	        _classCallCheck(this, LoadingAnimation);
	
	        return _possibleConstructorReturn(this, (LoadingAnimation.__proto__ || Object.getPrototypeOf(LoadingAnimation)).apply(this, arguments));
	    }
	
	    _createClass(LoadingAnimation, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	
	            this.animationBlack = _lottieWeb2.default.loadAnimation(Object.assign({}, this.options, { container: this.containerBlack, animationData: _milanBlack2.default }));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var style = { width: '100%', height: '100%', position: 'absolute', zIndex: 1352, display: 'flex', justifyContent: 'center', alignItems: 'center' };
	            var animStyles = { width: '150px', height: '150px', position: 'absolute', padding: '5px' };
	
	            return _react2.default.createElement(
	                'div',
	                { style: style },
	                _react2.default.createElement('div', { style: Object.assign({}, animStyles), ref: function ref(containerBlack) {
	                        _this2.containerBlack = containerBlack;
	                    } })
	            );
	        }
	    }]);
	
	    return LoadingAnimation;
	}(_react2.default.Component);
	
	exports.default = LoadingAnimation;

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _layout = __webpack_require__(15);
	
	var _MenuItemSoon = __webpack_require__(71);
	
	var _MenuItemSoon2 = _interopRequireDefault(_MenuItemSoon);
	
	var _Superface = __webpack_require__(7);
	
	var _Superface2 = _interopRequireDefault(_Superface);
	
	var _Overline = __webpack_require__(42);
	
	var _Overline2 = _interopRequireDefault(_Overline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import Interface from './Interface'
	
	
	var Menu = function (_React$Component) {
	    _inherits(Menu, _React$Component);
	
	    function Menu() {
	        _classCallCheck(this, Menu);
	
	        return _possibleConstructorReturn(this, (Menu.__proto__ || Object.getPrototypeOf(Menu)).apply(this, arguments));
	    }
	
	    _createClass(Menu, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                open = _props.open,
	                section = _props.section,
	                contact = _props.contact;
	            // console.log(contact)
	
	            if (!contact) return _react2.default.createElement('span', null);
	
	            var items = [{ slug: 'notre-metier', display: 'Notre métier' }, { slug: 'matieres', display: 'Matières' }, { slug: 'projets', display: 'Projets' }, { slug: 'contact', display: 'Contact' }];
	
	            return _react2.default.createElement(
	                'div',
	                { id: 'main-menu', className: (open ? 'open' : '') + ' menu-' + this.props.section, style: { height: '100%' } },
	                _react2.default.createElement(
	                    _layout.Flex,
	                    {
	                        justify: 'center',
	                        align: 'center',
	                        style: { width: '100%', height: '100vh', position: 'absolute', zIndex: 1351 }
	                    },
	                    _react2.default.createElement(
	                        _layout.Flex,
	                        { direction: 'column', justify: 'center', align: 'center' },
	                        items.map(function (item, i) {
	                            if (i === 2) return _react2.default.createElement(_MenuItemSoon2.default, { key: 'menu-item ' + i, display: item.display, style: { marginBottom: '2rem' } });
	                            return _react2.default.createElement(
	                                'div',
	                                { key: 'menu-item ' + i, className: 'menu-item', style: { marginBottom: '2rem' } },
	                                _react2.default.createElement(
	                                    'span',
	                                    {
	                                        className: 'overline-link ' + (section === item.slug ? 'active' : ''),
	                                        onClick: function onClick() {
	                                            if (section !== item.slug) _Superface2.default.goTo(_Superface2.default.uri(item.slug));
	                                        } },
	                                    _react2.default.createElement(
	                                        _Overline2.default,
	                                        null,
	                                        _Superface2.default.translate(item.display)
	                                    )
	                                )
	                            );
	                        })
	                    ),
	                    _react2.default.createElement(
	                        _layout.Flex,
	                        { justify: 'space-between', style: { position: 'absolute', bottom: '3rem', left: '3rem', right: '3rem' } },
	                        _react2.default.createElement(
	                            'div',
	                            { id: 'menu-languages', style: { width: '150px', textAlign: 'left', cursor: 'pointer' } },
	                            _react2.default.createElement(
	                                'span',
	                                { style: { textDecoration: _Superface2.default.getLang() !== 'fr' ? 'none' : 'line-through' }, onClick: function onClick(e) {
	                                        _Superface2.default.setLang('fr');
	                                    } },
	                                'Fr'
	                            ),
	                            '\xA0\xA0\xA0',
	                            _react2.default.createElement(
	                                'span',
	                                { style: { textDecoration: _Superface2.default.getLang() !== 'en' ? 'none' : 'line-through' }, onClick: function onClick(e) {
	                                        _Superface2.default.setLang('en');
	                                    } },
	                                'En'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { style: { width: '150px', textAlign: 'right' } },
	                            _react2.default.createElement(
	                                'a',
	                                { className: 'icon', href: contact.facebook, target: '_blank' },
	                                _react2.default.createElement('img', { src: __webpack_require__(64), alt: 'facebook' })
	                            ),
	                            _react2.default.createElement(
	                                'a',
	                                { className: 'icon', href: contact.instagram, target: '_blank' },
	                                _react2.default.createElement('img', { src: __webpack_require__(65), alt: 'instagram' })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Menu;
	}(_react2.default.Component);
	
	exports.default = Menu;

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Plus = __webpack_require__(95);
	
	var _Plus2 = _interopRequireDefault(_Plus);
	
	var _layout = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ZoomControls = function (_React$Component) {
	    _inherits(ZoomControls, _React$Component);
	
	    function ZoomControls() {
	        _classCallCheck(this, ZoomControls);
	
	        return _possibleConstructorReturn(this, (ZoomControls.__proto__ || Object.getPrototypeOf(ZoomControls)).apply(this, arguments));
	    }
	
	    _createClass(ZoomControls, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                _layout.Flex,
	                null,
	                _react2.default.createElement(
	                    _layout.Flex,
	                    { align: 'center', justify: 'center', onMouseDown: function onMouseDown() {
	                            _this2.props.onClickPlus();
	                        }, style: { width: '2rem', height: '2rem' } },
	                    _react2.default.createElement(_Plus2.default, { selected: true })
	                ),
	                _react2.default.createElement(
	                    _layout.Flex,
	                    { align: 'center', justify: 'center', style: { width: '2rem', height: '2rem', marginLeft: '2rem' } },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'plus', onClick: function onClick() {
	                                _this2.props.onClickMinus();
	                            } },
	                        _react2.default.createElement('span', { className: 'plus-h' })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ZoomControls;
	}(_react2.default.Component);
	
	exports.default = ZoomControls;

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _layout = __webpack_require__(15);
	
	var _HomeAnimation = __webpack_require__(245);
	
	var _HomeAnimation2 = _interopRequireDefault(_HomeAnimation);
	
	var _HomeInterface = __webpack_require__(246);
	
	var _HomeInterface2 = _interopRequireDefault(_HomeInterface);
	
	var _HomeVideo = __webpack_require__(247);
	
	var _HomeVideo2 = _interopRequireDefault(_HomeVideo);
	
	var _redux = __webpack_require__(133);
	
	var _app = __webpack_require__(94);
	
	var _section = __webpack_require__(241);
	
	var _reactRedux = __webpack_require__(59);
	
	var _reactRouterRedux = __webpack_require__(60);
	
	var _reactRouter = __webpack_require__(41);
	
	var _ScrollTracker = __webpack_require__(72);
	
	var _ScrollTracker2 = _interopRequireDefault(_ScrollTracker);
	
	var _data = __webpack_require__(70);
	
	var _tween = __webpack_require__(92);
	
	var _tween2 = _interopRequireDefault(_tween);
	
	var _Superface = __webpack_require__(7);
	
	var _Superface2 = _interopRequireDefault(_Superface);
	
	var _kit = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import superfaceAnimation from '../superface.json'
	
	// import {SECTIONS} from '../etc/sections'
	
	
	var EASE = function EASE(t) {
	    return Math.sign(t) * t * t * 10;
	};
	
	var Home = function (_React$Component) {
	    _inherits(Home, _React$Component);
	
	    function Home(props) {
	        _classCallCheck(this, Home);
	
	        var _this = _possibleConstructorReturn(this, (Home.__proto__ || Object.getPrototypeOf(Home)).call(this, props));
	
	        _this.state = {
	            overlay: false
	        };
	
	        _this.setRef = _this.setRef.bind(_this);
	        _this.setAnimRef = _this.setAnimRef.bind(_this);
	        _this.frameAnimation = _this.frameAnimation.bind(_this);
	        _this.handleScroll = _this.handleScroll.bind(_this);
	        _this.handleScrollEnd = _this.handleScrollEnd.bind(_this);
	        return _this;
	    }
	
	    _createClass(Home, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            document.title = _Superface2.default.translate('Designer matériaux') + ' - Superface';
	            if ((0, _kit.isTabletOrMobile)()) return;
	            this.scroll = new _ScrollTracker2.default();
	            // alert('initScroll')
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            if (!(0, _kit.isTabletOrMobile)()) {
	                this.videoContainer.childNodes[0].childNodes[0].pause();
	                if (this.timeoutStartScroll) window.clearTimeout(this.timeoutStartScroll);
	                window.cancelAnimationFrame(this.frameId);
	                this.scroll.destroy();
	            }
	            if (this.timeoutVideoReady) window.clearTimeout(this.videoReady);
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            // console.log('HOME DID MOUNT')
	            if (!(0, _kit.isTabletOrMobile)()) {
	                this.timeoutStartScroll = window.setTimeout(function () {
	                    _this2.scroll.start();
	                }, 1000);
	                this.scroll.on('scroll', this.handleScroll);
	                this.scroll.on('scrollend', this.handleScrollEnd);
	                this.tweenScroll = new _tween.Tween({ value: 0 }).to({ value: 1 }, 600).easing(_tween.Easing.Quadratic.InOut);
	            }
	
	            // this.checkIfVideoIsReady()
	        }
	    }, {
	        key: 'frameAnimation',
	        value: function frameAnimation() {
	            var _this3 = this;
	
	            if (_Superface2.default.IS_MOBILE_OR_TABLET) return;
	
	            _tween2.default.update();
	            // console.log('frame animation')
	            // const ease = t => Math.sign(t) * t * t
	            var progress = this.tweenScroll._object.value;
	            // this.videoContainer.style.transform = 'translateY(' + EASE(this._last_ratio * 1.7 ) * ( 1 - progress ) + 'px)'
	
	            document.querySelectorAll('.nav-item.overline-link.section-link').forEach(function (el, i) {
	                var transform = '';
	
	                switch (true) {
	                    case i === 0:
	                        transform += ' translateY(-' + EASE(Math.abs(_this3._last_ratio) * 2.2) * (1 - progress) + 'px)';
	                        break;
	                    case i === 1:
	                        transform += ' translateX(-' + EASE(Math.abs(_this3._last_ratio) * 2.2) * (1 - progress) + 'px)';
	                        break;
	                    case i === 2:
	                        transform += ' translateX(' + EASE(Math.abs(_this3._last_ratio) * 2.2) * (1 - progress) + 'px)';
	                        break;
	                    default:
	                        transform += ' translateY(' + EASE(Math.abs(_this3._last_ratio) * 2.2) * (1 - progress) + 'px)';
	                }
	                // const transform = "translate" + () 
	                el.style.transform = transform;
	            });
	
	            this.animation.style.transform = 'translateY(' + EASE(this._last_ratio * 2.2) * (1 - progress) + 'px)';
	            // console.log(progress)
	            if (progress === 1) {
	                window.cancelAnimationFrame(this.frameId);
	                this.tweenScroll._object.value = 0;
	                this.scroll.reset();
	                this.scroll.on('scroll', this.handleScroll);
	            } else {
	                this.frameId = window.requestAnimationFrame(this.frameAnimation);
	            }
	        }
	
	        // checkIfVideoIsReady(){
	
	        //     this.timeoutVideoReady = window.setTimeout( () => {
	        //         // console.log( this.videoContainer.childNodes[0].readyState )
	        //         if( this.videoContainer.childNodes[0].readyState === 4 ){
	        //             this.props.setHomeVideoReady()
	        //             this.videoContainer.childNodes[0].play()
	        //         }else{
	        //             this.checkIfVideoIsReady()
	        //         }
	        //     }, 200)
	
	        // }
	
	    }, {
	        key: 'handleScrollEnd',
	        value: function handleScrollEnd(e) {
	            if (_Superface2.default.IS_MOBILE_OR_TABLET) return;
	            this.scroll.off('scroll', this.handleScroll);
	            if (this.frameId) window.cancelAnimationFrame(this.frameId);
	            this.frameId = window.requestAnimationFrame(this.frameAnimation);
	            this.tweenScroll.start();
	        }
	    }, {
	        key: 'handleScroll',
	        value: function handleScroll(e) {
	            if ((0, _kit.isTabletOrMobile)()) return;
	            var ratio = this.scroll.positionY / (window.innerHeight / 2);
	
	            if (ratio > 2) {
	                // console.log('leavin')
	                this.scroll.stop();
	                this.scroll.off('scroll', this.handleScroll);
	                if (!(0, _kit.isTabletOrMobile)()) {
	                    this.videoContainer.childNodes[0].childNodes[0].pause();
	                }
	                return _Superface2.default.goTo(_Superface2.default.uri('contact'));
	            }
	
	            if (ratio < -2) {
	                // console.log('leavin')
	                this.scroll.stop();
	                this.scroll.off('scroll', this.handleScroll);
	                if (!(0, _kit.isTabletOrMobile)()) {
	                    this.videoContainer.childNodes[0].childNodes[0].pause();
	                }
	                return _Superface2.default.goTo(_Superface2.default.uri('notre-metier'));
	            }
	
	            // this.videoContainer.style.transform = 'translateY(' + EASE(ratio * 1.7 ) + 'px)'
	            this.animation.style.transform = 'translateY(' + EASE(ratio * 2.2) + 'px)';
	
	            document.querySelectorAll('.nav-item.overline-link.section-link').forEach(function (el, i) {
	                var transform = '';
	
	                switch (true) {
	                    case i === 0:
	                        transform += ' translateY(-' + EASE(Math.abs(ratio) * 2.2) + 'px)';
	                        break;
	                    case i === 1:
	                        transform += ' translateX(-' + EASE(Math.abs(ratio) * 2.2) + 'px)';
	                        break;
	                    case i === 2:
	                        transform += ' translateX(' + EASE(Math.abs(ratio) * 2.2) + 'px)';
	                        break;
	                    default:
	                        transform += ' translateY(' + EASE(Math.abs(ratio) * 2.2) + 'px)';
	                }
	                // const transform = "translate" + () 
	                el.style.transform = transform;
	            });
	
	            this._last_ratio = ratio;
	            // console.log('-------------------------')
	        }
	    }, {
	        key: 'setAnimRef',
	        value: function setAnimRef(ref) {
	            this.animation = ref;
	        }
	    }, {
	        key: 'setRef',
	        value: function setRef(ref) {
	            this.videoContainer = ref;
	        }
	    }, {
	        key: 'renderBackground',
	        value: function renderBackground() {
	            // console.log(this.props.home)
	            if (!_Superface2.default.IS_MOBILE_OR_TABLET) {
	                return _react2.default.createElement(_HomeVideo2.default, { setRef: this.setRef, src: _Superface2.default.assetUrl(this.props.home.videos[_Superface2.default.HOME_VIDEO_INDEX].value.path) });
	            } else {
	                return _react2.default.createElement(_HomeVideo2.default, { setRef: this.setRef, backupSrc: _Superface2.default.assetUrl(this.props.home.backup_mobile[_Superface2.default.HOME_BACKUP_INDEX].path) });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            if (!this.props.home) return _react2.default.createElement('span', null);
	            if (!_Superface2.default.IS_MOBILE_OR_TABLET && _Superface2.default.HOME_VIDEO_INDEX === undefined) return _react2.default.createElement('span', null);
	            if (_Superface2.default.IS_MOBILE_OR_TABLET && _Superface2.default.HOME_BACKUP_INDEX === undefined) return _react2.default.createElement('span', null);
	
	            return _react2.default.createElement(
	                _layout.Flex,
	                { id: 'home', align: 'center', justify: 'center', style: { width: '100%', height: '100%', overflow: 'hidden' } },
	                _react2.default.createElement(_HomeInterface2.default, null),
	                _react2.default.createElement(_HomeAnimation2.default, { setRef: this.setAnimRef }),
	                this.renderBackground()
	            );
	        }
	    }]);
	
	    return Home;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	
	    return {
	        loading: state.app.loading,
	        cardinal: state.app.cardinal,
	        section: state.section,
	        location: state.routing.location,
	        lang: state.app.lang,
	        home: state.data.home
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return (0, _redux.bindActionCreators)({
	        setCompass: _app.setCompass, setSection: _section.setSection, setHomeVideoReady: _data.setHomeVideoReady,
	        goTo: function goTo(section) {
	            return (0, _reactRouterRedux.push)(section);
	        }
	        //   changePage: () => push('/about-us')
	    }, dispatch);
	};
	
	exports.default = (0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Home));

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(59);
	
	var _reactRouter = __webpack_require__(41);
	
	var _reactRouterDom = __webpack_require__(40);
	
	var _layout = __webpack_require__(15);
	
	var _MaterialsGrid = __webpack_require__(248);
	
	var _MaterialsGrid2 = _interopRequireDefault(_MaterialsGrid);
	
	var _mobile_MaterialsGrid = __webpack_require__(257);
	
	var _mobile_MaterialsGrid2 = _interopRequireDefault(_mobile_MaterialsGrid);
	
	var _Filters = __webpack_require__(144);
	
	var _Filters2 = _interopRequireDefault(_Filters);
	
	var _MaterialsKind = __webpack_require__(249);
	
	var _MaterialsKind2 = _interopRequireDefault(_MaterialsKind);
	
	var _Superface = __webpack_require__(7);
	
	var _Superface2 = _interopRequireDefault(_Superface);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import { isTabletOrMobile } from '../kit';
	// import * as kit from '../kit'
	
	var Materials = function (_React$Component) {
	    _inherits(Materials, _React$Component);
	
	    function Materials() {
	        _classCallCheck(this, Materials);
	
	        return _possibleConstructorReturn(this, (Materials.__proto__ || Object.getPrototypeOf(Materials)).apply(this, arguments));
	    }
	
	    _createClass(Materials, [{
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            if (this.timeoutMount) clearTimeout(this.timeoutMount);
	        }
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            document.title = _Superface2.default.translate('Matières') + ' - Superface';
	            this.setState(Object.assign({}, this.state, {
	                mounted: false
	            }));
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            _Superface2.default.setCompass('W');
	            this.checkMaterialGridActivation(this.props.location.pathname);
	            this.timeoutMount = setTimeout(function () {
	                _this2.setState(Object.assign({}, _this2.state, { mounted: true }));
	            }, 1000);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(new_props) {
	
	            if (new_props.location.pathname !== this.props.location.pathname) {
	                this.checkMaterialGridActivation(new_props.location.pathname);
	            }
	        }
	    }, {
	        key: 'checkMaterialGridActivation',
	        value: function checkMaterialGridActivation(path) {
	
	            if (this.props.isOnSingle) {
	                _Superface2.default.disableMaterialsGrid();
	            } else {
	                _Superface2.default.enableMaterialsGrid();
	            }
	        }
	    }, {
	        key: 'renderKinds',
	        value: function renderKinds() {
	            if (!_Superface2.default.IS_MOBILE_OR_TABLET) return _react2.default.createElement(_Filters2.default, { type: 'kind', filters: this.props.kindsFilters });
	        }
	    }, {
	        key: 'renderKindTitle',
	        value: function renderKindTitle() {
	            if (!this.props.isOnSingle && !_Superface2.default.IS_MOBILE) {
	                return _react2.default.createElement(
	                    'div',
	                    { id: 'kind-title', className: this.props.kindTitle === '' ? '' : 'show', style: { position: 'absolute', zIndex: '940', top: '4.2rem', left: '50%', width: '300px', marginLeft: '-150px', textAlign: 'center', pointerEvents: 'none' } },
	                    this.props.kindTitle
	                );
	            }
	        }
	    }, {
	        key: 'renderGrid',
	        value: function renderGrid() {
	
	            if (_Superface2.default.IS_MOBILE) {
	                return _react2.default.createElement(_mobile_MaterialsGrid2.default, {
	                    materials: this.props.materials,
	                    materialsImagesLoaded: this.props.materialsImagesLoaded
	                });
	            } else {
	                return _react2.default.createElement(_MaterialsGrid2.default, {
	                    kindsFilters: this.props.kindsFilters,
	                    materials: this.props.materials,
	                    active: this.props.materialsGridActive,
	                    isOnSingle: this.props.isOnSingle,
	                    materialsImagesLoaded: this.props.materialsImagesLoaded
	                });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            // console.log(  )
	            return _react2.default.createElement(
	                'div',
	                {
	                    id: 'materials',
	                    className: (this.state.mounted ? 'mounted' : '') + (this.props.mapLeaving ? ' leave' : ''),
	                    style: { overflow: 'hidden', width: '100%', height: '100%', backgroundColor: 'white', cursor: this.props.cursor }
	                },
	                _react2.default.createElement(
	                    _layout.Flex,
	                    { align: 'center', justify: 'center', style: { backgroundColor: 'white', width: '100%', height: '100%' } },
	                    _react2.default.createElement(_reactRouterDom.Route, { path: _Superface2.default.uri('matieres') + '/:slug', render: function render(props) {
	                            return _react2.default.createElement(_MaterialsKind2.default, {
	                                kinds: _this3.props.materialsKinds,
	                                featuredImage: _this3.props.kindFeaturedImagePath,
	                                singleLeaving: _this3.props.singleLeaving
	                            });
	                        } }),
	                    this.renderKindTitle(),
	                    this.renderGrid(),
	                    this.renderKinds()
	                )
	            );
	        }
	    }]);
	
	    return Materials;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    // console.log('featured image : ' + state.app.kindFeaturedImagePath)
	    return {
	        singleLeaving: state.app.singleLeaving,
	        mapLeaving: state.app.mapLeaving,
	        kindsFilters: state.app.kindsFilters,
	        materialsGridActive: !state.app.isOnSingle,
	        materials: state.data.materials,
	        materialsImagesLoaded: state.data.materialsImagesLoaded,
	        materialsKinds: state.data.materialsKinds,
	        kindTitle: state.app.kindTitle,
	        entry: state.app.entry,
	        cursor: state.app.cursor,
	        kindFeaturedImagePath: state.app.kindFeaturedImagePath,
	        isOnSingle: state.app.isOnSingle
	    };
	};
	
	exports.default = (0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps, null)(Materials));

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(59);
	
	var _reactRouter = __webpack_require__(41);
	
	var _reactRouterDom = __webpack_require__(40);
	
	var _layout = __webpack_require__(15);
	
	var _ProjectsGrid = __webpack_require__(251);
	
	var _ProjectsGrid2 = _interopRequireDefault(_ProjectsGrid);
	
	var _mobile_ProjectsGrid = __webpack_require__(258);
	
	var _mobile_ProjectsGrid2 = _interopRequireDefault(_mobile_ProjectsGrid);
	
	var _Overline = __webpack_require__(42);
	
	var _Overline2 = _interopRequireDefault(_Overline);
	
	var _Filters = __webpack_require__(144);
	
	var _Filters2 = _interopRequireDefault(_Filters);
	
	var _Project = __webpack_require__(250);
	
	var _Project2 = _interopRequireDefault(_Project);
	
	var _Superface = __webpack_require__(7);
	
	var _Superface2 = _interopRequireDefault(_Superface);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IPS = ['78.212.251.144', '5.48.120.102', '94.228.187.54', '82.235.118.89', '176.160.42.188'];
	
	var Projects = function (_React$Component) {
	    _inherits(Projects, _React$Component);
	
	    function Projects() {
	        _classCallCheck(this, Projects);
	
	        return _possibleConstructorReturn(this, (Projects.__proto__ || Object.getPrototypeOf(Projects)).apply(this, arguments));
	    }
	
	    _createClass(Projects, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            document.title = _Superface2.default.translate('Projets') + ' - Superface';
	            this.setState(Object.assign({}, this.state, { mounted: false }));
	            if (this.props.ip == null) _Superface2.default.getIP();
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            _Superface2.default.setCompass('E');
	            this.checkProjectsGridActivation(this.props.location.pathname);
	            setTimeout(function () {
	                _this2.setState(Object.assign({}, _this2.state, { mounted: true }));
	            }, 1000);
	        }
	    }, {
	        key: 'checkProjectsGridActivation',
	        value: function checkProjectsGridActivation(path) {
	
	            if (path.split('/')[2] !== undefined) {
	                _Superface2.default.disableProjectsGrid();
	            } else {
	                _Superface2.default.enableProjectsGrid();
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(new_props) {
	            if (this.props.location.pathname !== new_props.location.pathname) {
	                this.checkProjectsGridActivation(new_props.location.pathname);
	            }
	            //  console.log(this.props.ip, new_props.ip )
	            if (this.props.ip !== new_props.ip && new_props.ip !== null) {
	                if (IPS.indexOf(new_props.ip) == -1) document.location.href = '/';
	            }
	        }
	    }, {
	        key: 'handleClick',
	        value: function handleClick(mode) {
	            if (_Superface2.default.canDoIt) {
	                _Superface2.default.setProjectsViewMode(mode);
	                _Superface2.default.canDoIt = false;
	            }
	        }
	    }, {
	        key: 'renderNav',
	        value: function renderNav() {
	            var _this3 = this;
	
	            if (this.props.isOnSingle || _Superface2.default.IS_MOBILE_OR_TABLET) return _react2.default.createElement('span', null);
	            return _react2.default.createElement(
	                _layout.Flex,
	                { className: 'page-top-menu', align: 'center', justify: 'center', style: { top: '4.2rem', position: 'absolute', zIndex: '940', width: '100%', pointerEvents: 'none' } },
	                _react2.default.createElement(
	                    'span',
	                    {
	                        style: { pointerEvents: 'all' },
	                        onMouseDown: function onMouseDown(e) {
	                            e.preventDefault();_this3.handleClick('galaxy');
	                        },
	                        className: 'overline-link ' + (this.props.viewMode === 'timeline' ? '' : 'active')
	                    },
	                    _react2.default.createElement(
	                        _Overline2.default,
	                        null,
	                        'Galaxy'
	                    )
	                ),
	                '\xA0\xA0\xA0\xA0',
	                _react2.default.createElement('span', { className: 'top-nav-stroke' }),
	                '\xA0\xA0\xA0\xA0',
	                _react2.default.createElement(
	                    'span',
	                    {
	                        style: { pointerEvents: 'all' },
	                        onMouseDown: function onMouseDown(e) {
	                            e.preventDefault();_this3.handleClick('timeline');
	                        },
	                        className: 'overline-link ' + (this.props.viewMode === 'timeline' ? 'active' : '')
	                    },
	                    _react2.default.createElement(
	                        _Overline2.default,
	                        null,
	                        'Timeline'
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'renderFilters',
	        value: function renderFilters() {
	            if (this.props.viewMode === 'timeline' || _Superface2.default.IS_MOBILE_OR_TABLET) return;
	            return _react2.default.createElement(_Filters2.default, { type: 'projet', filters: this.props.areasFilters });
	        }
	    }, {
	        key: 'renderProjectDate',
	        value: function renderProjectDate() {
	            if (this.props.projects.length === 0 || this.props.viewMode !== 'timeline' || _Superface2.default.IS_MOBILE) return;
	
	            var date = this.props.projects[this.props.currentTimeLineProjectIndex].date;
	            date = date.split('-')[0];
	            return _react2.default.createElement(
	                'div',
	                { className: 'projects-date', style: { position: 'fixed', top: '8rem', textAlign: 'center', fontSize: '1.7rem', zIndex: 400 } },
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    date
	                )
	            );
	        }
	    }, {
	        key: 'renderProjectName',
	        value: function renderProjectName() {
	            if (this.props.projects.length === 0 || this.props.viewMode !== 'timeline' || _Superface2.default.IS_MOBILE) return;
	            // console.log( this.props.projects[ this.props.currentTimeLineProjectIndex ] )
	            return _react2.default.createElement(
	                'div',
	                { className: 'projects-name', style: { position: 'fixed', bottom: '4rem', textAlign: 'center' } },
	                _Superface2.default.field(this.props.projects[this.props.currentTimeLineProjectIndex].activity_area, 'display'),
	                _react2.default.createElement(
	                    'div',
	                    { style: { fontSize: '1.7rem', marginTop: '1.5rem' } },
	                    _Superface2.default.field(this.props.projects[this.props.currentTimeLineProjectIndex], 'name')
	                )
	            );
	        }
	    }, {
	        key: 'renderGrid',
	        value: function renderGrid() {
	            if (_Superface2.default.IS_MOBILE) {
	                return _react2.default.createElement(_mobile_ProjectsGrid2.default, {
	                    projects: this.props.projects
	                });
	            } else {
	                return _react2.default.createElement(_ProjectsGrid2.default, {
	                    mounted: this.state.mounted,
	                    areasFilters: this.props.areasFilters,
	                    projects: this.props.projects,
	                    active: this.props.projectsGridActive && this.props.viewMode !== 'timeline',
	                    mode: this.props.viewMode,
	                    currentTimeLineProjectIndex: this.props.currentTimeLineProjectIndex,
	                    isOnSingle: this.props.isOnSingle
	                });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            return _react2.default.createElement(
	                'div',
	                {
	                    id: 'projects',
	                    className: (this.state.mounted ? 'mounted' : '') + (this.props.mapLeaving ? ' leave' : ''),
	                    style: { overflow: 'hidden', width: '100%', height: '100%', backgroundColor: 'white', cursor: this.props.cursor }
	                },
	                _react2.default.createElement(
	                    _layout.Flex,
	                    { align: 'center', justify: 'center', style: { backgroundColor: 'white', width: '100%', height: '100%' } },
	                    _react2.default.createElement(_reactRouterDom.Route, { path: _Superface2.default.uri('projets') + '/:slug', render: function render(props) {
	                            return _react2.default.createElement(_Project2.default, { projects: _this4.props.projects, singleLeaving: _this4.props.singleLeaving });
	                        } }),
	                    this.renderProjectDate(),
	                    this.renderNav(),
	                    this.renderGrid(),
	                    this.renderFilters(),
	                    this.renderProjectName()
	                )
	            );
	        }
	    }]);
	
	    return Projects;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	
	    return {
	        ip: state.app.ip,
	        singleLeaving: state.app.singleLeaving,
	        mapLeaving: state.app.mapLeaving,
	        areasFilters: state.app.areasFilters,
	        projectsGridActive: state.app.projectsGridActive,
	        projects: state.data.projects,
	        projectsAreas: state.data.projectsAreas,
	        viewMode: state.app.projectsViewMode,
	        currentTimeLineProjectIndex: state.app.currentTimeLineProjectIndex,
	        cursor: state.app.cursor,
	        isOnSingle: state.app.isOnSingle
	    };
	};
	
	exports.default = (0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps, null)(Projects));

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = initLocale;
	
	var _universalCookie = __webpack_require__(221);
	
	var _universalCookie2 = _interopRequireDefault(_universalCookie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import { initialize } from 'react-localize-redux';
	
	function initLocale() {
	
	    // const languages = [
	    //     { name: 'French', code: 'fr' },
	    //     { name: 'English', code: 'en' },
	    // ];
	
	    var cookies = new _universalCookie2.default();
	    var locale = cookies.get('locale');
	
	    if (locale === undefined) {
	        // check the borweer language
	        locale = navigator.language || navigator.userLanguage;
	        locale = locale.substring(0, 2);
	    }
	
	    // if doesn't match actives languages set EN to default  
	    if (locale !== 'en' && locale !== 'fr') locale = 'en';
	
	    cookies.set('locale', locale);
	
	    // console.log( locale )
	
	    return locale;
	}

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.history = undefined;
	
	var _redux = __webpack_require__(133);
	
	var _reactRouterRedux = __webpack_require__(60);
	
	var _reduxThunk = __webpack_require__(553);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _createBrowserHistory = __webpack_require__(126);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _behaviors = __webpack_require__(240);
	
	var _behaviors2 = _interopRequireDefault(_behaviors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var history = exports.history = (0, _createBrowserHistory2.default)();
	
	var initialState = {};
	var enhancers = [];
	
	var middleware = [_reduxThunk2.default, (0, _reactRouterRedux.routerMiddleware)(history)];
	
	if (false) {
		var devToolsExtension = window.devToolsExtension;
	
		if (typeof devToolsExtension === 'function') {
			enhancers.push(devToolsExtension());
		}
	}
	
	var composedEnhancers = _redux.compose.apply(undefined, [_redux.applyMiddleware.apply(undefined, middleware)].concat(enhancers));
	
	var store = (0, _redux.createStore)(_behaviors2.default, initialState, composedEnhancers);
	
	exports.default = store;

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _three = __webpack_require__(68);
	
	var THREE = _interopRequireWildcard(_three);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function MapControls(object, domElement) {
	
		var _this = this;
		var STATE = { NONE: -1, ROTATE: 0, ZOOM: 1, PAN: 2, TOUCH_ROTATE: 3, TOUCH_ZOOM_PAN: 4 };
	
		this.object = object;
		this.domElement = domElement !== undefined ? domElement : document;
	
		// API
	
		this.enabled = true;
	
		this.screen = { left: 0, top: 0, width: 0, height: 0 };
	
		this.rotateSpeed = 1.0;
		this.zoomSpeed = 0.25;
		this.initialZoomSpeed = this.zoomSpeed;
		this.panSpeed = 0.005;
		this.initialPanSpeed = this.panSpeed;
		this.noRotate = false;
		this.noZoom = false;
		this.noPan = false;
	
		this.staticMoving = false;
		this.dynamicDampingFactor = 0.2;
	
		this.minDistance = 0;
		this.maxDistance = Infinity;
	
		this.keys = [65 /*A*/, 83 /*S*/, 68 /*D*/];
	
		// internals
	
		this.target = new THREE.Vector3();
	
		var EPS = 0.000001;
	
		var lastPosition = new THREE.Vector3();
	
		var _state = STATE.NONE,
		    _prevState = STATE.NONE,
		    _eye = new THREE.Vector3(),
		    _movePrev = new THREE.Vector2(),
		    _moveCurr = new THREE.Vector2(),
		    _lastAxis = new THREE.Vector3(),
		    _lastAngle = 0,
		    _zoomStart = new THREE.Vector2(),
		    _zoomEnd = new THREE.Vector2(),
		    _touchZoomDistanceStart = 0,
		    _touchZoomDistanceEnd = 0,
		    _panStart = new THREE.Vector2(),
		    _lastMouseDown = 0,
		    _panEnd = new THREE.Vector2();
		// for reset
	
		this.target0 = this.target.clone();
		this.position0 = this.object.position.clone();
		this.up0 = this.object.up.clone();
	
		// events
	
		var changeEvent = { type: 'change' };
		var startEvent = { type: 'start' };
		var endEvent = { type: 'end' };
	
		// methods
	
		this.handleResize = function () {
	
			if (this.domElement === document) {
	
				this.screen.left = 0;
				this.screen.top = 0;
				this.screen.width = window.innerWidth;
				this.screen.height = window.innerHeight;
			} else {
	
				var box = this.domElement.getBoundingClientRect();
				// adjustments come from similar code in the jquery offset() function
				var d = this.domElement.ownerDocument.documentElement;
				this.screen.left = box.left + window.pageXOffset - d.clientLeft;
				this.screen.top = box.top + window.pageYOffset - d.clientTop;
				this.screen.width = box.width;
				this.screen.height = box.height;
			}
		};
	
		this.handleEvent = function (event) {
	
			if (typeof this[event.type] === 'function') {
	
				this[event.type](event);
			}
		};
	
		var getMouseOnScreen = function () {
	
			var vector = new THREE.Vector2();
			// console.log( 'coucou' )
			return function getMouseOnScreen(pageX, pageY) {
	
				vector.set((pageX - _this.screen.left) / _this.screen.width, (pageY - _this.screen.top) / _this.screen.height);
	
				return vector;
			};
		}();
	
		var getMouseOnCircle = function () {
	
			var vector = new THREE.Vector2();
	
			return function getMouseOnCircle(pageX, pageY) {
	
				vector.set((pageX - _this.screen.width * 0.5 - _this.screen.left) / (_this.screen.width * 0.5), (_this.screen.height + 2 * (_this.screen.top - pageY)) / _this.screen.width // screen.width intentional
				);
	
				return vector;
			};
		}();
	
		this.rotateCamera = function () {
			// return () => {}
			var axis = new THREE.Vector3(),
			    quaternion = new THREE.Quaternion(),
			    eyeDirection = new THREE.Vector3(),
			    objectUpDirection = new THREE.Vector3(),
			    objectSidewaysDirection = new THREE.Vector3(),
			    moveDirection = new THREE.Vector3(),
			    angle;
	
			return function rotateCamera() {
	
				moveDirection.set(_moveCurr.x - _movePrev.x, _moveCurr.y - _movePrev.y, 0);
				angle = moveDirection.length();
	
				if (angle) {
	
					_eye.copy(_this.object.position).sub(_this.target);
	
					eyeDirection.copy(_eye).normalize();
					objectUpDirection.copy(_this.object.up).normalize();
					objectSidewaysDirection.crossVectors(objectUpDirection, eyeDirection).normalize();
	
					objectUpDirection.setLength(_moveCurr.y - _movePrev.y);
					objectSidewaysDirection.setLength(_moveCurr.x - _movePrev.x);
	
					moveDirection.copy(objectUpDirection.add(objectSidewaysDirection));
	
					axis.crossVectors(moveDirection, _eye).normalize();
	
					angle *= _this.rotateSpeed;
					quaternion.setFromAxisAngle(axis, angle);
	
					_eye.applyQuaternion(quaternion);
					_this.object.up.applyQuaternion(quaternion);
	
					_lastAxis.copy(axis);
					_lastAngle = angle;
				} else if (!_this.staticMoving && _lastAngle) {
	
					_lastAngle *= Math.sqrt(1.0 - _this.dynamicDampingFactor);
					_eye.copy(_this.object.position).sub(_this.target);
					quaternion.setFromAxisAngle(_lastAxis, _lastAngle);
					_eye.applyQuaternion(quaternion);
					_this.object.up.applyQuaternion(quaternion);
				}
	
				_movePrev.copy(_moveCurr);
			};
		}();
	
		this.zoomCamera = function () {
	
			var factor;
	
			if (_state === STATE.TOUCH_ZOOM_PAN) {
	
				factor = _touchZoomDistanceStart / _touchZoomDistanceEnd;
				_touchZoomDistanceStart = _touchZoomDistanceEnd;
				_eye.multiplyScalar(factor);
			} else {
	
				factor = 1.0 + (_zoomEnd.y - _zoomStart.y) * _this.zoomSpeed;
	
				if (factor !== 1.0 && factor > 0.0) {
	
					_eye.multiplyScalar(factor);
				}
	
				if (_this.staticMoving) {
	
					_zoomStart.copy(_zoomEnd);
				} else {
					var _factor = Math.abs(1 - _this.object.position.z / (_this.maxDistance - _this.minDistance));
					_this.zoomSpeed = _this.initialZoomSpeed + 0.1 * _factor;
					_zoomStart.y += (_zoomEnd.y - _zoomStart.y) * this.dynamicDampingFactor;
				}
			}
		};
	
		// this.panToZero = function(){
		// 	_panEnd.x = 0
		// 	_panEnd.y = 0
		// }
	
		this.panCamera = function () {
	
			var mouseChange = new THREE.Vector2(),
			    objectUp = new THREE.Vector3(),
			    pan = new THREE.Vector3();
	
			return function panCamera() {
	
				// console.log( _this.object.position.z )
				// console.log( _this.maxDistance * 0.98 )
				// console.log('-----------------------')
				// if( _this.object.position.z > _this.maxDistance * 0.8 ){
				// 	_state = STATE.NONE
				// }
	
				mouseChange.copy(_panEnd).sub(_panStart);
	
				if (mouseChange.lengthSq()) {
	
					mouseChange.multiplyScalar(_eye.length() * _this.panSpeed);
	
					pan.copy(_eye).cross(_this.object.up).setLength(mouseChange.x);
					pan.add(objectUp.copy(_this.object.up).setLength(mouseChange.y));
	
					_this.object.position.add(pan);
					_this.target.add(pan);
	
					if (_this.staticMoving) {
	
						_panStart.copy(_panEnd);
					} else {
						var factor = Math.abs(1 - _this.object.position.z / (_this.maxDistance - _this.minDistance));
						_this.panSpeed = _this.initialPanSpeed + 0.7 * factor;
						_panStart.add(mouseChange.subVectors(_panEnd, _panStart).multiplyScalar(_this.dynamicDampingFactor));
					}
				}
			};
		}();
	
		this.checkDistances = function () {
	
			if (!_this.noZoom || !_this.noPan) {
	
				// if( _this.object.position.x > _this.maxPanX ){
				// 	_this.object.position.setX(_this.maxPanX)
				// 	_panStart.copy( _panEnd );
				// }
	
				// if( _this.object.position.y < _this.minPanY  ){
				// 	_this.object.position.setY(_this.minPanY)
				// 	_panStart.copy( _panEnd );
				// }
	
				// if( _this.object.position.y > _this.maxPanY ){
				// 	_this.object.position.setY(_this.maxPanY)
				// 	_panStart.copy( _panEnd );
				// }
	
				// if( _this.object.position.y > _this.maxPanY ||
				// 	_this.object.position.y < _this.minPanY ||
				// 	_this.object.position.x > _this.maxPanX ||
				// 	_this.object.position.x < _this.minPanX
				//  ){
				// 	 return
				//  }
				// if( _eye.)
				// console.log(_eye.x)
	
				if (_eye.lengthSq() > _this.maxDistance * _this.maxDistance) {
	
					_this.object.position.addVectors(_this.target, _eye.setLength(_this.maxDistance));
					_zoomStart.copy(_zoomEnd);
				}
	
				if (_eye.lengthSq() < _this.minDistance * _this.minDistance) {
	
					_this.object.position.addVectors(_this.target, _eye.setLength(_this.minDistance));
					_zoomStart.copy(_zoomEnd);
				}
	
				var factor = 1 - (_this.object.position.z - _this.minDistance) / (_this.maxDistance - _this.minDistance);
	
				var minPanX = _this.minPanX * factor;
				var maxPanX = _this.maxPanX * factor;
				var minPanY = _this.minPanY * factor;
				var maxPanY = _this.maxPanY * factor;
	
				if (_this.target.x < minPanX) {
					_this.object.position.x = minPanX;
					_this.target.x = minPanX;
					_panStart.copy(_panEnd);
				}
	
				if (_this.target.x > maxPanX) {
					_this.object.position.x = maxPanX;
					_this.target.x = maxPanX;
					_panStart.copy(_panEnd);
				}
	
				if (_this.target.y < minPanY) {
					_this.object.position.y = minPanY;
					_this.target.y = minPanY;
					_panStart.copy(_panEnd);
				}
	
				if (_this.target.y > maxPanY) {
					_this.object.position.y = maxPanY;
					_this.target.y = maxPanY;
					_panStart.copy(_panEnd);
				}
			}
		};
	
		this.update = function () {
	
			_eye.subVectors(_this.object.position, _this.target);
	
			if (!_this.noRotate) {
	
				// _this.rotateCamera();
	
			}
	
			if (!_this.noZoom) {
	
				_this.zoomCamera();
			}
	
			if (!_this.noPan) {
	
				_this.panCamera();
			}
	
			_this.object.position.addVectors(_this.target, _eye);
	
			_this.checkDistances();
	
			// _this.object.lookAt( _this.target );
	
			if (lastPosition.distanceToSquared(_this.object.position) > EPS) {
	
				_this.dispatchEvent(changeEvent);
	
				lastPosition.copy(_this.object.position);
			}
		};
	
		this.reset = function () {
	
			_state = STATE.NONE;
			_prevState = STATE.NONE;
	
			_this.target.copy(_this.target0);
			_this.object.position.copy(_this.position0);
			_this.object.up.copy(_this.up0);
	
			_eye.subVectors(_this.object.position, _this.target);
	
			_this.object.lookAt(_this.target);
	
			_this.dispatchEvent(changeEvent);
	
			lastPosition.copy(_this.object.position);
		};
	
		// listeners
	
		function keydown(event) {
	
			if (_this.enabled === false) return;
	
			window.removeEventListener('keydown', keydown);
	
			_prevState = _state;
	
			if (_state !== STATE.NONE) {
	
				return;
			} else if (event.keyCode === _this.keys[STATE.ROTATE] && !_this.noRotate) {
	
				_state = STATE.ROTATE;
			} else if (event.keyCode === _this.keys[STATE.ZOOM] && !_this.noZoom) {
	
				_state = STATE.ZOOM;
			} else if (event.keyCode === _this.keys[STATE.PAN] && !_this.noPan) {
	
				_state = STATE.PAN;
			}
		}
	
		function keyup(event) {
	
			if (_this.enabled === false) return;
	
			_state = _prevState;
	
			window.addEventListener('keydown', keydown, false);
		}
	
		this.zoomPlus = function () {
	
			_state = STATE.ZOOM;
			var vector = new THREE.Vector2();
			vector.set(_this.object.position.x, _this.object.position.y);
			_zoomStart = vector;
			// if( targetY < _this.minDistance ) targetY = _this.minDistance
			_zoomEnd.copy(_zoomStart);
			var targetY = _zoomEnd.y - 0.2;
			_zoomEnd.y = targetY;
			_this.dispatchEvent(startEvent);
		};
	
		this.zoomMinus = function () {
			_state = STATE.ZOOM;
			var vector = new THREE.Vector2();
			vector.set(_this.object.position.x, _this.object.position.y);
			_zoomStart = vector;
			// if( targetY > _this.maxDistance ) targetY = _this.maxDistance
			_zoomEnd.copy(_zoomStart);
			var targetY = _zoomEnd.y + 0.2;
			_zoomEnd.y = targetY;
			_this.dispatchEvent(startEvent);
		};
	
		function mousedown(event) {
			// return
			if (_this.enabled === false) return;
	
			event.preventDefault();
			event.stopPropagation();
	
			_state = STATE.PAN;
	
			var now = new Date();
	
			if (_lastMouseDown !== 0) {
				var timeDif = (now.getTime() - _lastMouseDown.getTime()) / 1000;
				if (timeDif < 0.3 && getMouseOnScreen(event.pageX, event.pageY).y < 0.8) {
					_state = STATE.ZOOM;
				}
			}
	
			_lastMouseDown = now;
	
			if (_state === STATE.ZOOM && !_this.noZoom) {
	
				_zoomStart.copy(getMouseOnScreen(event.pageX, event.pageY));
				_zoomEnd.copy(_zoomStart);
				_zoomEnd.y -= 100 * 0.0025;
			} else if (_state === STATE.PAN && !_this.noPan) {
	
				_panStart.copy(getMouseOnScreen(event.pageX, event.pageY));
				_panEnd.copy(_panStart);
			}
	
			document.addEventListener('mousemove', mousemove, false);
			document.addEventListener('mouseup', mouseup, false);
	
			_this.dispatchEvent(startEvent);
		}
	
		function mousemove(event) {
	
			if (_this.enabled === false) return;
	
			event.preventDefault();
			event.stopPropagation();
	
			if (_state === STATE.ZOOM && !_this.noZoom) {
	
				_zoomEnd.copy(getMouseOnScreen(event.pageX, event.pageY));
			} else if (_state === STATE.PAN && !_this.noPan) {
	
				_panEnd.copy(getMouseOnScreen(event.pageX, event.pageY));
			}
		}
	
		function mouseup(event) {
	
			if (_this.enabled === false) return;
	
			// event.preventDefault();
			// event.stopPropagation();
	
			_state = STATE.NONE;
	
			document.removeEventListener('mousemove', mousemove);
			document.removeEventListener('mouseup', mouseup);
			_this.dispatchEvent(endEvent);
		}
	
		function mousewheel(event) {
			// console.log('wheel')
			if (_this.enabled === false) return;
	
			event.preventDefault();
			event.stopPropagation();
	
			switch (event.deltaMode) {
	
				case 2:
					// Zoom in pages
					_zoomStart.y -= event.deltaY * 0.025;
					break;
	
				case 1:
					// Zoom in lines
					_zoomStart.y -= event.deltaY * 0.01;
					break;
	
				default:
					// undefined, 0, assume pixels
					_zoomStart.y -= event.deltaY * 0.00025;
					break;
	
			}
	
			_this.dispatchEvent(startEvent);
			_this.dispatchEvent(endEvent);
		}
	
		function touchstart(event) {
	
			if (_this.enabled === false) return;
			// console.log(event)
			switch (event.touches.length) {
	
				case 1:
					_state = STATE.PAN;
					var x = event.touches[0].pageX;
					var y = event.touches[0].pageY;
					_panStart.copy(getMouseOnScreen(x, y));
					_panEnd.copy(_panStart);
					break;
	
				default:
					// 2 or more
					_state = STATE.TOUCH_ZOOM_PAN;
					var dx = event.touches[0].pageX - event.touches[1].pageX;
					var dy = event.touches[0].pageY - event.touches[1].pageY;
					_touchZoomDistanceEnd = _touchZoomDistanceStart = Math.sqrt(dx * dx + dy * dy);
	
					var x = (event.touches[0].pageX + event.touches[1].pageX) / 2;
					var y = (event.touches[0].pageY + event.touches[1].pageY) / 2;
					_panStart.copy(getMouseOnScreen(x, y));
					_panEnd.copy(_panStart);
					break;
	
			}
	
			_this.dispatchEvent(startEvent);
		}
	
		function touchmove(event) {
	
			if (_this.enabled === false) return;
	
			event.preventDefault();
			event.stopPropagation();
	
			switch (event.touches.length) {
	
				case 1:
					var x = event.touches[0].pageX;
					var y = event.touches[0].pageY;
					_panEnd.copy(getMouseOnScreen(x, y));
					break;
	
				default:
					// 2 or more
					var dx = event.touches[0].pageX - event.touches[1].pageX;
					var dy = event.touches[0].pageY - event.touches[1].pageY;
					_touchZoomDistanceEnd = Math.sqrt(dx * dx + dy * dy);
	
					var x = (event.touches[0].pageX + event.touches[1].pageX) / 2;
					var y = (event.touches[0].pageY + event.touches[1].pageY) / 2;
					_panEnd.copy(getMouseOnScreen(x, y));
					break;
	
			}
		}
	
		function touchend(event) {
	
			if (_this.enabled === false) return;
	
			switch (event.touches.length) {
	
				case 0:
					_state = STATE.NONE;
					break;
	
				case 1:
					_state = STATE.PAN;
					var x = event.touches[0].pageX;
					var y = event.touches[0].pageY;
					_panStart.copy(getMouseOnScreen(x, y));
					_panEnd.copy(_panStart);
					break;
	
			}
	
			_this.dispatchEvent(endEvent);
		}
	
		function contextmenu(event) {
	
			if (_this.enabled === false) return;
	
			event.preventDefault();
		}
	
		this.dispose = function () {
			// console.log('')
			// console.log('dispose controls')
			// console.log('')
			this.domElement.removeEventListener('contextmenu', contextmenu, false);
			this.domElement.removeEventListener('mousedown', mousedown, false);
			this.domElement.removeEventListener('wheel', mousewheel, false);
	
			this.domElement.removeEventListener('touchstart', touchstart, false);
			this.domElement.removeEventListener('touchend', touchend, false);
			this.domElement.removeEventListener('touchmove', touchmove, false);
	
			document.removeEventListener('mousemove', mousemove, false);
			document.removeEventListener('mouseup', mouseup, false);
	
			window.removeEventListener('keydown', keydown, false);
			window.removeEventListener('keyup', keyup, false);
		};
	
		this.activate = function () {
			// console.log('')
			// console.log('activate Controls')
			// console.log('')
			this.domElement.addEventListener('contextmenu', contextmenu, false);
			this.domElement.addEventListener('mousedown', mousedown, false);
			this.domElement.addEventListener('wheel', mousewheel, false);
	
			this.domElement.addEventListener('touchstart', touchstart, false);
			this.domElement.addEventListener('touchend', touchend, false);
			this.domElement.addEventListener('touchmove', touchmove, false);
	
			// document.addEventListener( 'mousemove', mousemove, false );
			// document.addEventListener( 'mouseup', mouseup, false );
	
			window.addEventListener('keydown', keydown, false);
			window.addEventListener('keyup', keyup, false);
		};
	
		this.domElement.addEventListener('contextmenu', contextmenu, false);
		this.domElement.addEventListener('mousedown', mousedown, false);
		this.domElement.addEventListener('wheel', mousewheel, false);
	
		this.domElement.addEventListener('touchstart', touchstart, false);
		this.domElement.addEventListener('touchend', touchend, false);
		this.domElement.addEventListener('touchmove', touchmove, false);
	
		window.addEventListener('keydown', keydown, false);
		window.addEventListener('keyup', keyup, false);
	
		this.handleResize();
	
		// force an update at start
		this.update();
	} /* eslint-disable */
	
	/**
	 * @author Eberhard Graether / http://egraether.com/
	 * @author Mark Lundin 	/ http://mark-lundin.com
	 * @author Simone Manini / http://daron1337.github.io
	 * @author Luca Antiga 	/ http://lantiga.github.io
	 */
	;
	
	MapControls.prototype = Object.create(THREE.EventDispatcher.prototype);
	MapControls.prototype.constructor = MapControls;
	
	exports.default = MapControls;

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(25);
	module.exports = function (it, msg) {
	  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
	  return +it;
	};


/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(13);
	var toAbsoluteIndex = __webpack_require__(52);
	var toLength = __webpack_require__(11);
	
	module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
	  var O = toObject(this);
	  var len = toLength(O.length);
	  var to = toAbsoluteIndex(target, len);
	  var from = toAbsoluteIndex(start, len);
	  var end = arguments.length > 2 ? arguments[2] : undefined;
	  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
	  var inc = 1;
	  if (from < to && to < from + count) {
	    inc = -1;
	    from += count - 1;
	    to += count - 1;
	  }
	  while (count-- > 0) {
	    if (from in O) O[to] = O[from];
	    else delete O[to];
	    to += inc;
	    from += inc;
	  } return O;
	};


/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(45);
	
	module.exports = function (iter, ITERATOR) {
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(14);
	var toObject = __webpack_require__(13);
	var IObject = __webpack_require__(62);
	var toLength = __webpack_require__(11);
	
	module.exports = function (that, callbackfn, aLen, memo, isRight) {
	  aFunction(callbackfn);
	  var O = toObject(that);
	  var self = IObject(O);
	  var length = toLength(O.length);
	  var index = isRight ? length - 1 : 0;
	  var i = isRight ? -1 : 1;
	  if (aLen < 2) for (;;) {
	    if (index in self) {
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if (isRight ? index < 0 : length <= index) {
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};


/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var aFunction = __webpack_require__(14);
	var isObject = __webpack_require__(6);
	var invoke = __webpack_require__(165);
	var arraySlice = [].slice;
	var factories = {};
	
	var construct = function (F, len, args) {
	  if (!(len in factories)) {
	    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
	    // eslint-disable-next-line no-new-func
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};
	
	module.exports = Function.bind || function bind(that /* , ...args */) {
	  var fn = aFunction(this);
	  var partArgs = arraySlice.call(arguments, 1);
	  var bound = function (/* args... */) {
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
	  return bound;
	};


/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var dP = __webpack_require__(10).f;
	var create = __webpack_require__(46);
	var redefineAll = __webpack_require__(50);
	var ctx = __webpack_require__(27);
	var anInstance = __webpack_require__(44);
	var forOf = __webpack_require__(45);
	var $iterDefine = __webpack_require__(107);
	var step = __webpack_require__(168);
	var setSpecies = __webpack_require__(51);
	var DESCRIPTORS = __webpack_require__(9);
	var fastKey = __webpack_require__(39).fastKey;
	var validate = __webpack_require__(57);
	var SIZE = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function (that, key) {
	  // fast case
	  var index = fastKey(key);
	  var entry;
	  if (index !== 'F') return that._i[index];
	  // frozen object case
	  for (entry = that._f; entry; entry = entry.n) {
	    if (entry.k == key) return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;         // collection type
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear() {
	        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
	          entry.r = true;
	          if (entry.p) entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function (key) {
	        var that = validate(this, NAME);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.n;
	          var prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if (prev) prev.n = next;
	          if (next) next.p = prev;
	          if (that._f == entry) that._f = next;
	          if (that._l == entry) that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        validate(this, NAME);
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	        var entry;
	        while (entry = entry ? entry.n : this._f) {
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while (entry && entry.r) entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key) {
	        return !!getEntry(validate(this, NAME), key);
	      }
	    });
	    if (DESCRIPTORS) dP(C.prototype, 'size', {
	      get: function () {
	        return validate(this, NAME)[SIZE];
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var entry = getEntry(that, key);
	    var prev, index;
	    // change existing entry
	    if (entry) {
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if (!that._f) that._f = entry;
	      if (prev) prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if (index !== 'F') that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function (C, NAME, IS_MAP) {
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function (iterated, kind) {
	      this._t = validate(iterated, NAME); // target
	      this._k = kind;                     // kind
	      this._l = undefined;                // previous
	    }, function () {
	      var that = this;
	      var kind = that._k;
	      var entry = that._l;
	      // revert to the last existing entry
	      while (entry && entry.r) entry = entry.p;
	      // get next entry
	      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if (kind == 'keys') return step(0, entry.k);
	      if (kind == 'values') return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};


/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(61);
	var from = __webpack_require__(157);
	module.exports = function (NAME) {
	  return function toJSON() {
	    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};


/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll = __webpack_require__(50);
	var getWeak = __webpack_require__(39).getWeak;
	var anObject = __webpack_require__(3);
	var isObject = __webpack_require__(6);
	var anInstance = __webpack_require__(44);
	var forOf = __webpack_require__(45);
	var createArrayMethod = __webpack_require__(29);
	var $has = __webpack_require__(20);
	var validate = __webpack_require__(57);
	var arrayFind = createArrayMethod(5);
	var arrayFindIndex = createArrayMethod(6);
	var id = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function (that) {
	  return that._l || (that._l = new UncaughtFrozenStore());
	};
	var UncaughtFrozenStore = function () {
	  this.a = [];
	};
	var findUncaughtFrozen = function (store, key) {
	  return arrayFind(store.a, function (it) {
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function (key) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) return entry[1];
	  },
	  has: function (key) {
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function (key, value) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function (key) {
	    var index = arrayFindIndex(this.a, function (it) {
	      return it[0] === key;
	    });
	    if (~index) this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;      // collection type
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function (key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var data = getWeak(anObject(key), true);
	    if (data === true) uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};


/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
	var isArray = __webpack_require__(77);
	var isObject = __webpack_require__(6);
	var toLength = __webpack_require__(11);
	var ctx = __webpack_require__(27);
	var IS_CONCAT_SPREADABLE = __webpack_require__(8)('isConcatSpreadable');
	
	function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
	  var targetIndex = start;
	  var sourceIndex = 0;
	  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
	  var element, spreadable;
	
	  while (sourceIndex < sourceLen) {
	    if (sourceIndex in source) {
	      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
	
	      spreadable = false;
	      if (isObject(element)) {
	        spreadable = element[IS_CONCAT_SPREADABLE];
	        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
	      }
	
	      if (spreadable && depth > 0) {
	        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
	      } else {
	        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
	        target[targetIndex] = element;
	      }
	
	      targetIndex++;
	    }
	    sourceIndex++;
	  }
	  return targetIndex;
	}
	
	module.exports = flattenIntoArray;


/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(9) && !__webpack_require__(5)(function () {
	  return Object.defineProperty(__webpack_require__(100)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 165 */
/***/ function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(6);
	var floor = Math.floor;
	module.exports = function isInteger(it) {
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};


/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(3);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ },
/* 168 */
/***/ function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var sign = __webpack_require__(109);
	var pow = Math.pow;
	var EPSILON = pow(2, -52);
	var EPSILON32 = pow(2, -23);
	var MAX32 = pow(2, 127) * (2 - EPSILON32);
	var MIN32 = pow(2, -126);
	
	var roundTiesToEven = function (n) {
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	module.exports = Math.fround || function fround(x) {
	  var $abs = Math.abs(x);
	  var $sign = sign(x);
	  var a, result;
	  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	  a = (1 + EPSILON32 / EPSILON) * $abs;
	  result = a - (a - $abs);
	  // eslint-disable-next-line no-self-compare
	  if (result > MAX32 || result != result) return $sign * Infinity;
	  return $sign * result;
	};


/***/ },
/* 170 */
/***/ function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x) {
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};


/***/ },
/* 171 */
/***/ function(module, exports) {

	// https://rwaldron.github.io/proposal-math-extensions/
	module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
	  if (
	    arguments.length === 0
	      // eslint-disable-next-line no-self-compare
	      || x != x
	      // eslint-disable-next-line no-self-compare
	      || inLow != inLow
	      // eslint-disable-next-line no-self-compare
	      || inHigh != inHigh
	      // eslint-disable-next-line no-self-compare
	      || outLow != outLow
	      // eslint-disable-next-line no-self-compare
	      || outHigh != outHigh
	  ) return NaN;
	  if (x === Infinity || x === -Infinity) return x;
	  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
	};


/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys = __webpack_require__(48);
	var gOPS = __webpack_require__(81);
	var pIE = __webpack_require__(63);
	var toObject = __webpack_require__(13);
	var IObject = __webpack_require__(62);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(5)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	  } return T;
	} : $assign;


/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(10);
	var anObject = __webpack_require__(3);
	var getKeys = __webpack_require__(48);
	
	module.exports = __webpack_require__(9) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(23);
	var gOPN = __webpack_require__(47).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	var has = __webpack_require__(20);
	var toIObject = __webpack_require__(23);
	var arrayIndexOf = __webpack_require__(73)(false);
	var IE_PROTO = __webpack_require__(113)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	var getKeys = __webpack_require__(48);
	var toIObject = __webpack_require__(23);
	var isEnum = __webpack_require__(63).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) if (isEnum.call(O, key = keys[i++])) {
	      result.push(isEntries ? [key, O[key]] : O[key]);
	    } return result;
	  };
	};


/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var gOPN = __webpack_require__(47);
	var gOPS = __webpack_require__(81);
	var anObject = __webpack_require__(3);
	var Reflect = __webpack_require__(4).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
	  var keys = gOPN.f(anObject(it));
	  var getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};


/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(4).parseFloat;
	var $trim = __webpack_require__(56).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(117) + '-0') !== -Infinity ? function parseFloat(str) {
	  var string = $trim(String(str), 3);
	  var result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;


/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(4).parseInt;
	var $trim = __webpack_require__(56).trim;
	var ws = __webpack_require__(117);
	var hex = /^[-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;


/***/ },
/* 180 */
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(3);
	var isObject = __webpack_require__(6);
	var newPromiseCapability = __webpack_require__(111);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(11);
	var repeat = __webpack_require__(116);
	var defined = __webpack_require__(30);
	
	module.exports = function (that, maxLength, fillString, left) {
	  var S = String(defined(that));
	  var stringLength = S.length;
	  var fillStr = fillString === undefined ? ' ' : String(fillString);
	  var intMaxLength = toLength(maxLength);
	  if (intMaxLength <= stringLength || fillStr == '') return S;
	  var fillLen = intMaxLength - stringLength;
	  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};


/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/ecma262/#sec-toindex
	var toInteger = __webpack_require__(32);
	var toLength = __webpack_require__(11);
	module.exports = function (it) {
	  if (it === undefined) return 0;
	  var number = toInteger(it);
	  var length = toLength(number);
	  if (number !== length) throw RangeError('Wrong length!');
	  return length;
	};


/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(8);


/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(160);
	var validate = __webpack_require__(57);
	var MAP = 'Map';
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(74)(MAP, function (get) {
	  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key) {
	    var entry = strong.getEntry(validate(this, MAP), key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value) {
	    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
	  }
	}, strong, true);


/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	if (__webpack_require__(9) && /./g.flags != 'g') __webpack_require__(10).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(76)
	});


/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(160);
	var validate = __webpack_require__(57);
	var SET = 'Set';
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(74)(SET, function (get) {
	  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value) {
	    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
	  }
	}, strong);


/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var each = __webpack_require__(29)(0);
	var redefine = __webpack_require__(17);
	var meta = __webpack_require__(39);
	var assign = __webpack_require__(172);
	var weak = __webpack_require__(162);
	var isObject = __webpack_require__(6);
	var fails = __webpack_require__(5);
	var validate = __webpack_require__(57);
	var WEAK_MAP = 'WeakMap';
	var getWeak = meta.getWeak;
	var isExtensible = Object.isExtensible;
	var uncaughtFrozenStore = weak.ufstore;
	var tmp = {};
	var InternalMap;
	
	var wrapper = function (get) {
	  return function WeakMap() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key) {
	    if (isObject(key)) {
	      var data = getWeak(key);
	      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value) {
	    return weak.def(validate(this, WEAK_MAP), key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(74)(WEAK_MAP, wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if (fails(function () { return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7; })) {
	  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function (key) {
	    var proto = $WeakMap.prototype;
	    var method = proto[key];
	    redefine(proto, key, function (a, b) {
	      // store frozen objects on internal weakmap shim
	      if (isObject(a) && !isExtensible(a)) {
	        if (!this._f) this._f = new InternalMap();
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}


/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * EvEmitter v1.1.0
	 * Lil' event emitter
	 * MIT License
	 */
	
	/* jshint unused: true, undef: true, strict: true */
	
	( function( global, factory ) {
	  // universal module definition
	  /* jshint strict: false */ /* globals define, module, window */
	  if ( true ) {
	    // AMD - RequireJS
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS - Browserify, Webpack
	    module.exports = factory();
	  } else {
	    // Browser globals
	    global.EvEmitter = factory();
	  }
	
	}( typeof window != 'undefined' ? window : this, function() {
	
	"use strict";
	
	function EvEmitter() {}
	
	var proto = EvEmitter.prototype;
	
	proto.on = function( eventName, listener ) {
	  if ( !eventName || !listener ) {
	    return;
	  }
	  // set events hash
	  var events = this._events = this._events || {};
	  // set listeners array
	  var listeners = events[ eventName ] = events[ eventName ] || [];
	  // only add once
	  if ( listeners.indexOf( listener ) == -1 ) {
	    listeners.push( listener );
	  }
	
	  return this;
	};
	
	proto.once = function( eventName, listener ) {
	  if ( !eventName || !listener ) {
	    return;
	  }
	  // add event
	  this.on( eventName, listener );
	  // set once flag
	  // set onceEvents hash
	  var onceEvents = this._onceEvents = this._onceEvents || {};
	  // set onceListeners object
	  var onceListeners = onceEvents[ eventName ] = onceEvents[ eventName ] || {};
	  // set flag
	  onceListeners[ listener ] = true;
	
	  return this;
	};
	
	proto.off = function( eventName, listener ) {
	  var listeners = this._events && this._events[ eventName ];
	  if ( !listeners || !listeners.length ) {
	    return;
	  }
	  var index = listeners.indexOf( listener );
	  if ( index != -1 ) {
	    listeners.splice( index, 1 );
	  }
	
	  return this;
	};
	
	proto.emitEvent = function( eventName, args ) {
	  var listeners = this._events && this._events[ eventName ];
	  if ( !listeners || !listeners.length ) {
	    return;
	  }
	  // copy over to avoid interference if .off() in listener
	  listeners = listeners.slice(0);
	  args = args || [];
	  // once stuff
	  var onceListeners = this._onceEvents && this._onceEvents[ eventName ];
	
	  for ( var i=0; i < listeners.length; i++ ) {
	    var listener = listeners[i]
	    var isOnce = onceListeners && onceListeners[ listener ];
	    if ( isOnce ) {
	      // remove listener
	      // remove before trigger to prevent recursion
	      this.off( eventName, listener );
	      // unset once flag
	      delete onceListeners[ listener ];
	    }
	    // trigger listener
	    listener.apply( this, args );
	  }
	
	  return this;
	};
	
	proto.allOff = function() {
	  delete this._events;
	  delete this._onceEvents;
	};
	
	return EvEmitter;
	
	}));


/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/galaxy-1.75aa35de.svg";

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/galaxy-2.3ef93504.svg";

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/galaxy-3.9a4a9e7b.svg";

/***/ },
/* 194 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
	  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
	};
	
	var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
	  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
	};
	
	var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
	  return callback(window.confirm(message));
	}; // eslint-disable-line no-alert
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
	 */
	var supportsHistory = exports.supportsHistory = function supportsHistory() {
	  var ua = window.navigator.userAgent;
	
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
	
	  return window.history && 'pushState' in window.history;
	};
	
	/**
	 * Returns true if browser fires popstate on hash change.
	 * IE10 and IE11 do not.
	 */
	var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
	  return window.navigator.userAgent.indexOf('Trident') === -1;
	};
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
	  return window.navigator.userAgent.indexOf('Firefox') === -1;
	};
	
	/**
	 * Returns true if a given popstate event is an extraneous WebKit event.
	 * Accounts for the fact that Chrome on iOS fires real popstate events
	 * containing undefined state when pressing the back button.
	 */
	var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
	  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
	};

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(24);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(34);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(89);
	
	var _PathUtils = __webpack_require__(58);
	
	var _createTransitionManager = __webpack_require__(127);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _DOMUtils = __webpack_require__(194);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HashChangeEvent = 'hashchange';
	
	var HashPathCoders = {
	  hashbang: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '!' ? path : '!/' + (0, _PathUtils.stripLeadingSlash)(path);
	    },
	    decodePath: function decodePath(path) {
	      return path.charAt(0) === '!' ? path.substr(1) : path;
	    }
	  },
	  noslash: {
	    encodePath: _PathUtils.stripLeadingSlash,
	    decodePath: _PathUtils.addLeadingSlash
	  },
	  slash: {
	    encodePath: _PathUtils.addLeadingSlash,
	    decodePath: _PathUtils.addLeadingSlash
	  }
	};
	
	var getHashPath = function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  var href = window.location.href;
	  var hashIndex = href.indexOf('#');
	  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
	};
	
	var pushHashPath = function pushHashPath(path) {
	  return window.location.hash = path;
	};
	
	var replaceHashPath = function replaceHashPath(path) {
	  var hashIndex = window.location.href.indexOf('#');
	
	  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
	};
	
	var createHashHistory = function createHashHistory() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Hash history needs a DOM');
	
	  var globalHistory = window.history;
	  var canGoWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();
	
	  var _props$getUserConfirm = props.getUserConfirmation,
	      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
	      _props$hashType = props.hashType,
	      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;
	
	  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';
	
	  var _HashPathCoders$hashT = HashPathCoders[hashType],
	      encodePath = _HashPathCoders$hashT.encodePath,
	      decodePath = _HashPathCoders$hashT.decodePath;
	
	
	  var getDOMLocation = function getDOMLocation() {
	    var path = decodePath(getHashPath());
	
	    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');
	
	    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);
	
	    return (0, _LocationUtils.createLocation)(path);
	  };
	
	  var transitionManager = (0, _createTransitionManager2.default)();
	
	  var setState = function setState(nextState) {
	    _extends(history, nextState);
	
	    history.length = globalHistory.length;
	
	    transitionManager.notifyListeners(history.location, history.action);
	  };
	
	  var forceNextPop = false;
	  var ignorePath = null;
	
	  var handleHashChange = function handleHashChange() {
	    var path = getHashPath();
	    var encodedPath = encodePath(path);
	
	    if (path !== encodedPath) {
	      // Ensure we always have a properly-encoded hash.
	      replaceHashPath(encodedPath);
	    } else {
	      var location = getDOMLocation();
	      var prevLocation = history.location;
	
	      if (!forceNextPop && (0, _LocationUtils.locationsAreEqual)(prevLocation, location)) return; // A hashchange doesn't always == location change.
	
	      if (ignorePath === (0, _PathUtils.createPath)(location)) return; // Ignore this change; we already setState in push/replace.
	
	      ignorePath = null;
	
	      handlePop(location);
	    }
	  };
	
	  var handlePop = function handlePop(location) {
	    if (forceNextPop) {
	      forceNextPop = false;
	      setState();
	    } else {
	      var action = 'POP';
	
	      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	        if (ok) {
	          setState({ action: action, location: location });
	        } else {
	          revertPop(location);
	        }
	      });
	    }
	  };
	
	  var revertPop = function revertPop(fromLocation) {
	    var toLocation = history.location;
	
	    // TODO: We could probably make this more reliable by
	    // keeping a list of paths we've seen in sessionStorage.
	    // Instead, we just default to 0 for paths we don't know.
	
	    var toIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(toLocation));
	
	    if (toIndex === -1) toIndex = 0;
	
	    var fromIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(fromLocation));
	
	    if (fromIndex === -1) fromIndex = 0;
	
	    var delta = toIndex - fromIndex;
	
	    if (delta) {
	      forceNextPop = true;
	      go(delta);
	    }
	  };
	
	  // Ensure the hash is encoded properly before doing anything else.
	  var path = getHashPath();
	  var encodedPath = encodePath(path);
	
	  if (path !== encodedPath) replaceHashPath(encodedPath);
	
	  var initialLocation = getDOMLocation();
	  var allPaths = [(0, _PathUtils.createPath)(initialLocation)];
	
	  // Public interface
	
	  var createHref = function createHref(location) {
	    return '#' + encodePath(basename + (0, _PathUtils.createPath)(location));
	  };
	
	  var push = function push(path, state) {
	    (0, _warning2.default)(state === undefined, 'Hash history cannot push state; it is ignored');
	
	    var action = 'PUSH';
	    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var path = (0, _PathUtils.createPath)(location);
	      var encodedPath = encodePath(basename + path);
	      var hashChanged = getHashPath() !== encodedPath;
	
	      if (hashChanged) {
	        // We cannot tell if a hashchange was caused by a PUSH, so we'd
	        // rather setState here and ignore the hashchange. The caveat here
	        // is that other hash histories in the page will consider it a POP.
	        ignorePath = path;
	        pushHashPath(encodedPath);
	
	        var prevIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(history.location));
	        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
	
	        nextPaths.push(path);
	        allPaths = nextPaths;
	
	        setState({ action: action, location: location });
	      } else {
	        (0, _warning2.default)(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');
	
	        setState();
	      }
	    });
	  };
	
	  var replace = function replace(path, state) {
	    (0, _warning2.default)(state === undefined, 'Hash history cannot replace state; it is ignored');
	
	    var action = 'REPLACE';
	    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var path = (0, _PathUtils.createPath)(location);
	      var encodedPath = encodePath(basename + path);
	      var hashChanged = getHashPath() !== encodedPath;
	
	      if (hashChanged) {
	        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
	        // rather setState here and ignore the hashchange. The caveat here
	        // is that other hash histories in the page will consider it a POP.
	        ignorePath = path;
	        replaceHashPath(encodedPath);
	      }
	
	      var prevIndex = allPaths.indexOf((0, _PathUtils.createPath)(history.location));
	
	      if (prevIndex !== -1) allPaths[prevIndex] = path;
	
	      setState({ action: action, location: location });
	    });
	  };
	
	  var go = function go(n) {
	    (0, _warning2.default)(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');
	
	    globalHistory.go(n);
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var listenerCount = 0;
	
	  var checkDOMListeners = function checkDOMListeners(delta) {
	    listenerCount += delta;
	
	    if (listenerCount === 1) {
	      (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	    } else if (listenerCount === 0) {
	      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	    }
	  };
	
	  var isBlocked = false;
	
	  var block = function block() {
	    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    var unblock = transitionManager.setPrompt(prompt);
	
	    if (!isBlocked) {
	      checkDOMListeners(1);
	      isBlocked = true;
	    }
	
	    return function () {
	      if (isBlocked) {
	        isBlocked = false;
	        checkDOMListeners(-1);
	      }
	
	      return unblock();
	    };
	  };
	
	  var listen = function listen(listener) {
	    var unlisten = transitionManager.appendListener(listener);
	    checkDOMListeners(1);
	
	    return function () {
	      checkDOMListeners(-1);
	      unlisten();
	    };
	  };
	
	  var history = {
	    length: globalHistory.length,
	    action: 'POP',
	    location: initialLocation,
	    createHref: createHref,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    block: block,
	    listen: listen
	  };
	
	  return history;
	};
	
	exports.default = createHashHistory;

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(24);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _PathUtils = __webpack_require__(58);
	
	var _LocationUtils = __webpack_require__(89);
	
	var _createTransitionManager = __webpack_require__(127);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var clamp = function clamp(n, lowerBound, upperBound) {
	  return Math.min(Math.max(n, lowerBound), upperBound);
	};
	
	/**
	 * Creates a history object that stores locations in memory.
	 */
	var createMemoryHistory = function createMemoryHistory() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var getUserConfirmation = props.getUserConfirmation,
	      _props$initialEntries = props.initialEntries,
	      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
	      _props$initialIndex = props.initialIndex,
	      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
	      _props$keyLength = props.keyLength,
	      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;
	
	
	  var transitionManager = (0, _createTransitionManager2.default)();
	
	  var setState = function setState(nextState) {
	    _extends(history, nextState);
	
	    history.length = history.entries.length;
	
	    transitionManager.notifyListeners(history.location, history.action);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength);
	  };
	
	  var index = clamp(initialIndex, 0, initialEntries.length - 1);
	  var entries = initialEntries.map(function (entry) {
	    return typeof entry === 'string' ? (0, _LocationUtils.createLocation)(entry, undefined, createKey()) : (0, _LocationUtils.createLocation)(entry, undefined, entry.key || createKey());
	  });
	
	  // Public interface
	
	  var createHref = _PathUtils.createPath;
	
	  var push = function push(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'PUSH';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var prevIndex = history.index;
	      var nextIndex = prevIndex + 1;
	
	      var nextEntries = history.entries.slice(0);
	      if (nextEntries.length > nextIndex) {
	        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
	      } else {
	        nextEntries.push(location);
	      }
	
	      setState({
	        action: action,
	        location: location,
	        index: nextIndex,
	        entries: nextEntries
	      });
	    });
	  };
	
	  var replace = function replace(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'REPLACE';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      history.entries[history.index] = location;
	
	      setState({ action: action, location: location });
	    });
	  };
	
	  var go = function go(n) {
	    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
	
	    var action = 'POP';
	    var location = history.entries[nextIndex];
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (ok) {
	        setState({
	          action: action,
	          location: location,
	          index: nextIndex
	        });
	      } else {
	        // Mimic the behavior of DOM histories by
	        // causing a render after a cancelled POP.
	        setState();
	      }
	    });
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var canGo = function canGo(n) {
	    var nextIndex = history.index + n;
	    return nextIndex >= 0 && nextIndex < history.entries.length;
	  };
	
	  var block = function block() {
	    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	    return transitionManager.setPrompt(prompt);
	  };
	
	  var listen = function listen(listener) {
	    return transitionManager.appendListener(listener);
	  };
	
	  var history = {
	    length: entries.length,
	    action: 'POP',
	    location: entries[index],
	    index: index,
	    entries: entries,
	    createHref: createHref,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    canGo: canGo,
	    block: block,
	    listen: listen
	  };
	
	  return history;
	};
	
	exports.default = createMemoryHistory;

/***/ },
/* 197 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	};


/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(510);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 199 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function checkDCE() {
	  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
	  if (
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
	  ) {
	    return;
	  }
	  if (false) {
	    // This branch is unreachable because this function is only called
	    // in production, but the condition is true only in development.
	    // Therefore if the branch is still here, dead code elimination wasn't
	    // properly applied.
	    // Don't change the message. React DevTools relies on it. Also make sure
	    // this message doesn't occur elsewhere in this function, or it will cause
	    // a false positive.
	    throw new Error('^_^');
	  }
	  try {
	    // Verify that the code above has been dead code eliminated (DCE'd).
	    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
	  } catch (err) {
	    // DevTools shouldn't crash React, no matter what.
	    // We should still report in case we break this code.
	    console.error(err);
	  }
	}
	
	if (true) {
	  // DCE check should happen before ReactDOM bundle executes so that
	  // DevTools can report bad minification during injection.
	  checkDCE();
	  module.exports = __webpack_require__(518);
	} else {
	  module.exports = require('./cjs/react-dom.development.js');
	}


/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = connectAdvanced;
	
	var _hoistNonReactStatics = __webpack_require__(197);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(34);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(2);
	
	var _Subscription = __webpack_require__(527);
	
	var _Subscription2 = _interopRequireDefault(_Subscription);
	
	var _PropTypes = __webpack_require__(203);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var hotReloadingVersion = 0;
	var dummyState = {};
	function noop() {}
	function makeSelectorStateful(sourceSelector, store) {
	  // wrap the selector in an object that tracks its results between runs.
	  var selector = {
	    run: function runComponentSelector(props) {
	      try {
	        var nextProps = sourceSelector(store.getState(), props);
	        if (nextProps !== selector.props || selector.error) {
	          selector.shouldComponentUpdate = true;
	          selector.props = nextProps;
	          selector.error = null;
	        }
	      } catch (error) {
	        selector.shouldComponentUpdate = true;
	        selector.error = error;
	      }
	    }
	  };
	
	  return selector;
	}
	
	function connectAdvanced(
	/*
	  selectorFactory is a func that is responsible for returning the selector function used to
	  compute new props from state, props, and dispatch. For example:
	     export default connectAdvanced((dispatch, options) => (state, props) => ({
	      thing: state.things[props.thingId],
	      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
	    }))(YourComponent)
	   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
	  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
	  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
	   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
	  props. Do not use connectAdvanced directly without memoizing results between calls to your
	  selector, otherwise the Connect component will re-render on every state or props change.
	*/
	selectorFactory) {
	  var _contextTypes, _childContextTypes;
	
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$getDisplayName = _ref.getDisplayName,
	      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
	    return 'ConnectAdvanced(' + name + ')';
	  } : _ref$getDisplayName,
	      _ref$methodName = _ref.methodName,
	      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
	      _ref$renderCountProp = _ref.renderCountProp,
	      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
	      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
	      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
	      _ref$storeKey = _ref.storeKey,
	      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
	      _ref$withRef = _ref.withRef,
	      withRef = _ref$withRef === undefined ? false : _ref$withRef,
	      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);
	
	  var subscriptionKey = storeKey + 'Subscription';
	  var version = hotReloadingVersion++;
	
	  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = _PropTypes.storeShape, _contextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _contextTypes);
	  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _childContextTypes);
	
	  return function wrapWithConnect(WrappedComponent) {
	    (0, _invariant2.default)(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + ('connect. Instead received ' + JSON.stringify(WrappedComponent)));
	
	    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	
	    var displayName = getDisplayName(wrappedComponentName);
	
	    var selectorFactoryOptions = _extends({}, connectOptions, {
	      getDisplayName: getDisplayName,
	      methodName: methodName,
	      renderCountProp: renderCountProp,
	      shouldHandleStateChanges: shouldHandleStateChanges,
	      storeKey: storeKey,
	      withRef: withRef,
	      displayName: displayName,
	      wrappedComponentName: wrappedComponentName,
	      WrappedComponent: WrappedComponent
	    });
	
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.state = {};
	        _this.renderCount = 0;
	        _this.store = props[storeKey] || context[storeKey];
	        _this.propsMode = Boolean(props[storeKey]);
	        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);
	
	        (0, _invariant2.default)(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));
	
	        _this.initSelector();
	        _this.initSubscription();
	        return _this;
	      }
	
	      Connect.prototype.getChildContext = function getChildContext() {
	        var _ref2;
	
	        // If this component received store from props, its subscription should be transparent
	        // to any descendants receiving store+subscription from context; it passes along
	        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
	        // Connect to control ordering of notifications to flow top-down.
	        var subscription = this.propsMode ? null : this.subscription;
	        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        if (!shouldHandleStateChanges) return;
	
	        // componentWillMount fires during server side rendering, but componentDidMount and
	        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
	        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
	        // To handle the case where a child component may have triggered a state change by
	        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
	        // re-render.
	        this.subscription.trySubscribe();
	        this.selector.run(this.props);
	        if (this.selector.shouldComponentUpdate) this.forceUpdate();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        this.selector.run(nextProps);
	      };
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return this.selector.shouldComponentUpdate;
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        if (this.subscription) this.subscription.tryUnsubscribe();
	        this.subscription = null;
	        this.notifyNestedSubs = noop;
	        this.store = null;
	        this.selector.run = noop;
	        this.selector.shouldComponentUpdate = false;
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2.default)(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
	        return this.wrappedInstance;
	      };
	
	      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
	        this.wrappedInstance = ref;
	      };
	
	      Connect.prototype.initSelector = function initSelector() {
	        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
	        this.selector = makeSelectorStateful(sourceSelector, this.store);
	        this.selector.run(this.props);
	      };
	
	      Connect.prototype.initSubscription = function initSubscription() {
	        if (!shouldHandleStateChanges) return;
	
	        // parentSub's source should match where store came from: props vs. context. A component
	        // connected to the store via props shouldn't use subscription from context, or vice versa.
	        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
	        this.subscription = new _Subscription2.default(this.store, parentSub, this.onStateChange.bind(this));
	
	        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
	        // the middle of the notification loop, where `this.subscription` will then be null. An
	        // extra null check every change can be avoided by copying the method onto `this` and then
	        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
	        // listeners logic is changed to not call listeners that have been unsubscribed in the
	        // middle of the notification loop.
	        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
	      };
	
	      Connect.prototype.onStateChange = function onStateChange() {
	        this.selector.run(this.props);
	
	        if (!this.selector.shouldComponentUpdate) {
	          this.notifyNestedSubs();
	        } else {
	          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
	          this.setState(dummyState);
	        }
	      };
	
	      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
	        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
	        // needs to notify nested subs. Once called, it unimplements itself until further state
	        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
	        // a boolean check every time avoids an extra method call most of the time, resulting
	        // in some perf boost.
	        this.componentDidUpdate = undefined;
	        this.notifyNestedSubs();
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return Boolean(this.subscription) && this.subscription.isSubscribed();
	      };
	
	      Connect.prototype.addExtraProps = function addExtraProps(props) {
	        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
	        // make a shallow copy so that fields added don't leak to the original selector.
	        // this is especially important for 'ref' since that's a reference back to the component
	        // instance. a singleton memoized selector would then be holding a reference to the
	        // instance, preventing the instance from being garbage collected, and that would be bad
	        var withExtras = _extends({}, props);
	        if (withRef) withExtras.ref = this.setWrappedInstance;
	        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
	        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
	        return withExtras;
	      };
	
	      Connect.prototype.render = function render() {
	        var selector = this.selector;
	        selector.shouldComponentUpdate = false;
	
	        if (selector.error) {
	          throw selector.error;
	        } else {
	          return (0, _react.createElement)(WrappedComponent, this.addExtraProps(selector.props));
	        }
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.displayName = displayName;
	    Connect.childContextTypes = childContextTypes;
	    Connect.contextTypes = contextTypes;
	    Connect.propTypes = contextTypes;
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        var _this2 = this;
	
	        // We are hot reloading!
	        if (this.version !== version) {
	          this.version = version;
	          this.initSelector();
	
	          // If any connected descendants don't hot reload (and resubscribe in the process), their
	          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
	          // listeners, this does mean that the old versions of connected descendants will still be
	          // notified of state changes; however, their onStateChange function is a no-op so this
	          // isn't a huge deal.
	          var oldListeners = [];
	
	          if (this.subscription) {
	            oldListeners = this.subscription.listeners.get();
	            this.subscription.tryUnsubscribe();
	          }
	          this.initSubscription();
	          if (shouldHandleStateChanges) {
	            this.subscription.trySubscribe();
	            oldListeners.forEach(function (listener) {
	              return _this2.subscription.listeners.subscribe(listener);
	            });
	          }
	        }
	      };
	    }
	
	    return (0, _hoistNonReactStatics2.default)(Connect, WrappedComponent);
	  };
	}

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.wrapMapToPropsConstant = wrapMapToPropsConstant;
	exports.getDependsOnOwnProps = getDependsOnOwnProps;
	exports.wrapMapToPropsFunc = wrapMapToPropsFunc;
	
	var _verifyPlainObject = __webpack_require__(204);
	
	var _verifyPlainObject2 = _interopRequireDefault(_verifyPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function wrapMapToPropsConstant(getConstant) {
	  return function initConstantSelector(dispatch, options) {
	    var constant = getConstant(dispatch, options);
	
	    function constantSelector() {
	      return constant;
	    }
	    constantSelector.dependsOnOwnProps = false;
	    return constantSelector;
	  };
	}
	
	// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
	// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
	// whether mapToProps needs to be invoked when props have changed.
	// 
	// A length of one signals that mapToProps does not depend on props from the parent component.
	// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
	// therefore not reporting its length accurately..
	function getDependsOnOwnProps(mapToProps) {
	  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
	}
	
	// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
	// this function wraps mapToProps in a proxy function which does several things:
	// 
	//  * Detects whether the mapToProps function being called depends on props, which
	//    is used by selectorFactory to decide if it should reinvoke on props changes.
	//    
	//  * On first call, handles mapToProps if returns another function, and treats that
	//    new function as the true mapToProps for subsequent calls.
	//    
	//  * On first call, verifies the first result is a plain object, in order to warn
	//    the developer that their mapToProps function is not returning a valid result.
	//    
	function wrapMapToPropsFunc(mapToProps, methodName) {
	  return function initProxySelector(dispatch, _ref) {
	    var displayName = _ref.displayName;
	
	    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
	      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
	    };
	
	    // allow detectFactoryAndVerify to get ownProps
	    proxy.dependsOnOwnProps = true;
	
	    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
	      proxy.mapToProps = mapToProps;
	      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
	      var props = proxy(stateOrDispatch, ownProps);
	
	      if (typeof props === 'function') {
	        proxy.mapToProps = props;
	        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
	        props = proxy(stateOrDispatch, ownProps);
	      }
	
	      if (false) (0, _verifyPlainObject2.default)(props, displayName, methodName);
	
	      return props;
	    };
	
	    return proxy;
	  };
	}

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.storeShape = exports.subscriptionShape = undefined;
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var subscriptionShape = exports.subscriptionShape = _propTypes2.default.shape({
	  trySubscribe: _propTypes2.default.func.isRequired,
	  tryUnsubscribe: _propTypes2.default.func.isRequired,
	  notifyNestedSubs: _propTypes2.default.func.isRequired,
	  isSubscribed: _propTypes2.default.func.isRequired
	});
	
	var storeShape = exports.storeShape = _propTypes2.default.shape({
	  subscribe: _propTypes2.default.func.isRequired,
	  dispatch: _propTypes2.default.func.isRequired,
	  getState: _propTypes2.default.func.isRequired
	});

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = verifyPlainObject;
	
	var _isPlainObject = __webpack_require__(128);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(130);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function verifyPlainObject(value, displayName, methodName) {
	  if (!(0, _isPlainObject2.default)(value)) {
	    (0, _warning2.default)(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
	  }
	}

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _invariant = __webpack_require__(34);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isModifiedEvent = function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	};
	
	/**
	 * The public API for rendering a history-aware <a>.
	 */
	
	var Link = function (_React$Component) {
	  _inherits(Link, _React$Component);
	
	  function Link() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Link);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
	      if (_this.props.onClick) _this.props.onClick(event);
	
	      if (!event.defaultPrevented && // onClick prevented default
	      event.button === 0 && // ignore right clicks
	      !_this.props.target && // let browser handle "target=_blank" etc.
	      !isModifiedEvent(event) // ignore clicks with modifier keys
	      ) {
	          event.preventDefault();
	
	          var history = _this.context.router.history;
	          var _this$props = _this.props,
	              replace = _this$props.replace,
	              to = _this$props.to;
	
	
	          if (replace) {
	            history.replace(to);
	          } else {
	            history.push(to);
	          }
	        }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Link.prototype.render = function render() {
	    var _props = this.props,
	        replace = _props.replace,
	        to = _props.to,
	        innerRef = _props.innerRef,
	        props = _objectWithoutProperties(_props, ['replace', 'to', 'innerRef']); // eslint-disable-line no-unused-vars
	
	    (0, _invariant2.default)(this.context.router, 'You should not use <Link> outside a <Router>');
	
	    var href = this.context.router.history.createHref(typeof to === 'string' ? { pathname: to } : to);
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
	  };
	
	  return Link;
	}(_react2.default.Component);
	
	Link.propTypes = {
	  onClick: _propTypes2.default.func,
	  target: _propTypes2.default.string,
	  replace: _propTypes2.default.bool,
	  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired,
	  innerRef: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
	};
	Link.defaultProps = {
	  replace: false
	};
	Link.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      push: _propTypes2.default.func.isRequired,
	      replace: _propTypes2.default.func.isRequired,
	      createHref: _propTypes2.default.func.isRequired
	    }).isRequired
	  }).isRequired
	};
	exports.default = Link;

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Route = __webpack_require__(132);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Route2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 207 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	/**
	 * This action type will be dispatched by the history actions below.
	 * If you're writing a middleware to watch for navigation events, be sure to
	 * look for actions of this type.
	 */
	var CALL_HISTORY_METHOD = exports.CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';
	
	function updateLocation(method) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return {
	      type: CALL_HISTORY_METHOD,
	      payload: { method: method, args: args }
	    };
	  };
	}
	
	/**
	 * These actions correspond to the history API.
	 * The associated routerMiddleware will capture these events before they get to
	 * your reducer and reissue them as the matching function on your history.
	 */
	var push = exports.push = updateLocation('push');
	var replace = exports.replace = updateLocation('replace');
	var go = exports.go = updateLocation('go');
	var goBack = exports.goBack = updateLocation('goBack');
	var goForward = exports.goForward = updateLocation('goForward');
	
	var routerActions = exports.routerActions = { push: push, replace: replace, go: go, goBack: goBack, goForward: goForward };

/***/ },
/* 208 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.routerReducer = routerReducer;
	/**
	 * This action type will be dispatched when your history
	 * receives a location change.
	 */
	var LOCATION_CHANGE = exports.LOCATION_CHANGE = '@@router/LOCATION_CHANGE';
	
	var initialState = {
	  location: null
	
	  /**
	   * This reducer will update the state with the most recent location history
	   * has transitioned to. This may not be in sync with the router, particularly
	   * if you have asynchronously-loaded routes, so reading from and relying on
	   * this state is discouraged.
	   */
	};function routerReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      type = _ref.type,
	      payload = _ref.payload;
	
	  if (type === LOCATION_CHANGE) {
	    return _extends({}, state, { location: payload });
	  }
	
	  return state;
	}

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(24);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createMemoryHistory = __webpack_require__(196);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _Router = __webpack_require__(90);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that stores location in memory.
	 */
	var MemoryRouter = function (_React$Component) {
	  _inherits(MemoryRouter, _React$Component);
	
	  function MemoryRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MemoryRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _createMemoryHistory2.default)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, '<MemoryRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { MemoryRouter as Router }`.');
	  };
	
	  MemoryRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return MemoryRouter;
	}(_react2.default.Component);
	
	MemoryRouter.propTypes = {
	  initialEntries: _propTypes2.default.array,
	  initialIndex: _propTypes2.default.number,
	  getUserConfirmation: _propTypes2.default.func,
	  keyLength: _propTypes2.default.number,
	  children: _propTypes2.default.node
	};
	exports.default = MemoryRouter;

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _invariant = __webpack_require__(34);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for prompting the user before navigating away
	 * from a screen with a component.
	 */
	var Prompt = function (_React$Component) {
	  _inherits(Prompt, _React$Component);
	
	  function Prompt() {
	    _classCallCheck(this, Prompt);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Prompt.prototype.enable = function enable(message) {
	    if (this.unblock) this.unblock();
	
	    this.unblock = this.context.router.history.block(message);
	  };
	
	  Prompt.prototype.disable = function disable() {
	    if (this.unblock) {
	      this.unblock();
	      this.unblock = null;
	    }
	  };
	
	  Prompt.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, 'You should not use <Prompt> outside a <Router>');
	
	    if (this.props.when) this.enable(this.props.message);
	  };
	
	  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.when) {
	      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
	    } else {
	      this.disable();
	    }
	  };
	
	  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.disable();
	  };
	
	  Prompt.prototype.render = function render() {
	    return null;
	  };
	
	  return Prompt;
	}(_react2.default.Component);
	
	Prompt.propTypes = {
	  when: _propTypes2.default.bool,
	  message: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired
	};
	Prompt.defaultProps = {
	  when: true
	};
	Prompt.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      block: _propTypes2.default.func.isRequired
	    }).isRequired
	  }).isRequired
	};
	exports.default = Prompt;

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(24);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(34);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _history = __webpack_require__(498);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for updating the location programmatically
	 * with a component.
	 */
	var Redirect = function (_React$Component) {
	  _inherits(Redirect, _React$Component);
	
	  function Redirect() {
	    _classCallCheck(this, Redirect);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Redirect.prototype.isStatic = function isStatic() {
	    return this.context.router && this.context.router.staticContext;
	  };
	
	  Redirect.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, 'You should not use <Redirect> outside a <Router>');
	
	    if (this.isStatic()) this.perform();
	  };
	
	  Redirect.prototype.componentDidMount = function componentDidMount() {
	    if (!this.isStatic()) this.perform();
	  };
	
	  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var prevTo = (0, _history.createLocation)(prevProps.to);
	    var nextTo = (0, _history.createLocation)(this.props.to);
	
	    if ((0, _history.locationsAreEqual)(prevTo, nextTo)) {
	      (0, _warning2.default)(false, 'You tried to redirect to the same route you\'re currently on: ' + ('"' + nextTo.pathname + nextTo.search + '"'));
	      return;
	    }
	
	    this.perform();
	  };
	
	  Redirect.prototype.perform = function perform() {
	    var history = this.context.router.history;
	    var _props = this.props,
	        push = _props.push,
	        to = _props.to;
	
	
	    if (push) {
	      history.push(to);
	    } else {
	      history.replace(to);
	    }
	  };
	
	  Redirect.prototype.render = function render() {
	    return null;
	  };
	
	  return Redirect;
	}(_react2.default.Component);
	
	Redirect.propTypes = {
	  push: _propTypes2.default.bool,
	  from: _propTypes2.default.string,
	  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired
	};
	Redirect.defaultProps = {
	  push: false
	};
	Redirect.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      push: _propTypes2.default.func.isRequired,
	      replace: _propTypes2.default.func.isRequired
	    }).isRequired,
	    staticContext: _propTypes2.default.object
	  }).isRequired
	};
	exports.default = Redirect;

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(24);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(34);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PathUtils = __webpack_require__(58);
	
	var _Router = __webpack_require__(90);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var normalizeLocation = function normalizeLocation(object) {
	  var _object$pathname = object.pathname,
	      pathname = _object$pathname === undefined ? '/' : _object$pathname,
	      _object$search = object.search,
	      search = _object$search === undefined ? '' : _object$search,
	      _object$hash = object.hash,
	      hash = _object$hash === undefined ? '' : _object$hash;
	
	
	  return {
	    pathname: pathname,
	    search: search === '?' ? '' : search,
	    hash: hash === '#' ? '' : hash
	  };
	};
	
	var addBasename = function addBasename(basename, location) {
	  if (!basename) return location;
	
	  return _extends({}, location, {
	    pathname: (0, _PathUtils.addLeadingSlash)(basename) + location.pathname
	  });
	};
	
	var stripBasename = function stripBasename(basename, location) {
	  if (!basename) return location;
	
	  var base = (0, _PathUtils.addLeadingSlash)(basename);
	
	  if (location.pathname.indexOf(base) !== 0) return location;
	
	  return _extends({}, location, {
	    pathname: location.pathname.substr(base.length)
	  });
	};
	
	var createLocation = function createLocation(location) {
	  return typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : normalizeLocation(location);
	};
	
	var createURL = function createURL(location) {
	  return typeof location === 'string' ? location : (0, _PathUtils.createPath)(location);
	};
	
	var staticHandler = function staticHandler(methodName) {
	  return function () {
	    (0, _invariant2.default)(false, 'You cannot %s with <StaticRouter>', methodName);
	  };
	};
	
	var noop = function noop() {};
	
	/**
	 * The public top-level API for a "static" <Router>, so-called because it
	 * can't actually change the current location. Instead, it just records
	 * location changes in a context object. Useful mainly in testing and
	 * server-rendering scenarios.
	 */
	
	var StaticRouter = function (_React$Component) {
	  _inherits(StaticRouter, _React$Component);
	
	  function StaticRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, StaticRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
	      return (0, _PathUtils.addLeadingSlash)(_this.props.basename + createURL(path));
	    }, _this.handlePush = function (location) {
	      var _this$props = _this.props,
	          basename = _this$props.basename,
	          context = _this$props.context;
	
	      context.action = 'PUSH';
	      context.location = addBasename(basename, createLocation(location));
	      context.url = createURL(context.location);
	    }, _this.handleReplace = function (location) {
	      var _this$props2 = _this.props,
	          basename = _this$props2.basename,
	          context = _this$props2.context;
	
	      context.action = 'REPLACE';
	      context.location = addBasename(basename, createLocation(location));
	      context.url = createURL(context.location);
	    }, _this.handleListen = function () {
	      return noop;
	    }, _this.handleBlock = function () {
	      return noop;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  StaticRouter.prototype.getChildContext = function getChildContext() {
	    return {
	      router: {
	        staticContext: this.props.context
	      }
	    };
	  };
	
	  StaticRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, '<StaticRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { StaticRouter as Router }`.');
	  };
	
	  StaticRouter.prototype.render = function render() {
	    var _props = this.props,
	        basename = _props.basename,
	        context = _props.context,
	        location = _props.location,
	        props = _objectWithoutProperties(_props, ['basename', 'context', 'location']);
	
	    var history = {
	      createHref: this.createHref,
	      action: 'POP',
	      location: stripBasename(basename, createLocation(location)),
	      push: this.handlePush,
	      replace: this.handleReplace,
	      go: staticHandler('go'),
	      goBack: staticHandler('goBack'),
	      goForward: staticHandler('goForward'),
	      listen: this.handleListen,
	      block: this.handleBlock
	    };
	
	    return _react2.default.createElement(_Router2.default, _extends({}, props, { history: history }));
	  };
	
	  return StaticRouter;
	}(_react2.default.Component);
	
	StaticRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  context: _propTypes2.default.object.isRequired,
	  location: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object])
	};
	StaticRouter.defaultProps = {
	  basename: '',
	  location: '/'
	};
	StaticRouter.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = StaticRouter;

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(24);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(34);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _matchPath = __webpack_require__(91);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for rendering the first <Route> that matches.
	 */
	var Switch = function (_React$Component) {
	  _inherits(Switch, _React$Component);
	
	  function Switch() {
	    _classCallCheck(this, Switch);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Switch.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, 'You should not use <Switch> outside a <Router>');
	  };
	
	  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    (0, _warning2.default)(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
	
	    (0, _warning2.default)(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
	  };
	
	  Switch.prototype.render = function render() {
	    var route = this.context.router.route;
	    var children = this.props.children;
	
	    var location = this.props.location || route.location;
	
	    var match = void 0,
	        child = void 0;
	    _react2.default.Children.forEach(children, function (element) {
	      if (!_react2.default.isValidElement(element)) return;
	
	      var _element$props = element.props,
	          pathProp = _element$props.path,
	          exact = _element$props.exact,
	          strict = _element$props.strict,
	          sensitive = _element$props.sensitive,
	          from = _element$props.from;
	
	      var path = pathProp || from;
	
	      if (match == null) {
	        child = element;
	        match = path ? (0, _matchPath2.default)(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }) : route.match;
	      }
	    });
	
	    return match ? _react2.default.cloneElement(child, { location: location, computedMatch: match }) : null;
	  };
	
	  return Switch;
	}(_react2.default.Component);
	
	Switch.contextTypes = {
	  router: _propTypes2.default.shape({
	    route: _propTypes2.default.object.isRequired
	  }).isRequired
	};
	Switch.propTypes = {
	  children: _propTypes2.default.node,
	  location: _propTypes2.default.object
	};
	exports.default = Switch;

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _hoistNonReactStatics = __webpack_require__(197);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _Route = __webpack_require__(132);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A public higher-order component to access the imperative API
	 */
	var withRouter = function withRouter(Component) {
	  var C = function C(props) {
	    var wrappedComponentRef = props.wrappedComponentRef,
	        remainingProps = _objectWithoutProperties(props, ['wrappedComponentRef']);
	
	    return _react2.default.createElement(_Route2.default, { render: function render(routeComponentProps) {
	        return _react2.default.createElement(Component, _extends({}, remainingProps, routeComponentProps, { ref: wrappedComponentRef }));
	      } });
	  };
	
	  C.displayName = 'withRouter(' + (Component.displayName || Component.name) + ')';
	  C.WrappedComponent = Component;
	  C.propTypes = {
	    wrappedComponentRef: _propTypes2.default.func
	  };
	
	  return (0, _hoistNonReactStatics2.default)(C, Component);
	};
	
	exports.default = withRouter;

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(222);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;
	
	var _propTypes = __webpack_require__(12);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(200);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _PropTypes = __webpack_require__(217);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UNMOUNTED = exports.UNMOUNTED = 'unmounted';
	var EXITED = exports.EXITED = 'exited';
	var ENTERING = exports.ENTERING = 'entering';
	var ENTERED = exports.ENTERED = 'entered';
	var EXITING = exports.EXITING = 'exiting';
	
	/**
	 * The Transition component lets you describe a transition from one component
	 * state to another _over time_ with a simple declarative API. Most commonly
	 * it's used to animate the mounting and unmounting of a component, but can also
	 * be used to describe in-place transition states as well.
	 *
	 * By default the `Transition` component does not alter the behavior of the
	 * component it renders, it only tracks "enter" and "exit" states for the components.
	 * It's up to you to give meaning and effect to those states. For example we can
	 * add styles to a component when it enters or exits:
	 *
	 * ```jsx
	 * import Transition from 'react-transition-group/Transition';
	 *
	 * const duration = 300;
	 *
	 * const defaultStyle = {
	 *   transition: `opacity ${duration}ms ease-in-out`,
	 *   opacity: 0,
	 * }
	 *
	 * const transitionStyles = {
	 *   entering: { opacity: 0 },
	 *   entered:  { opacity: 1 },
	 * };
	 *
	 * const Fade = ({ in: inProp }) => (
	 *   <Transition in={inProp} timeout={duration}>
	 *     {(state) => (
	 *       <div style={{
	 *         ...defaultStyle,
	 *         ...transitionStyles[state]
	 *       }}>
	 *         I'm A fade Transition!
	 *       </div>
	 *     )}
	 *   </Transition>
	 * );
	 * ```
	 *
	 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
	 * What it does do is track transition states over time so you can update the
	 * component (such as by adding styles or classes) when it changes states.
	 *
	 * There are 4 main states a Transition can be in:
	 *  - `ENTERING`
	 *  - `ENTERED`
	 *  - `EXITING`
	 *  - `EXITED`
	 *
	 * Transition state is toggled via the `in` prop. When `true` the component begins the
	 * "Enter" stage. During this stage, the component will shift from its current transition state,
	 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
	 * it's complete. Let's take the following example:
	 *
	 * ```jsx
	 * state= { in: false };
	 *
	 * toggleEnterState = () => {
	 *   this.setState({ in: true });
	 * }
	 *
	 * render() {
	 *   return (
	 *     <div>
	 *       <Transition in={this.state.in} timeout={500} />
	 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the button is clicked the component will shift to the `'entering'` state and
	 * stay there for 500ms (the value of `timeout`) when finally switches to `'entered'`.
	 *
	 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
	 */
	
	var Transition = function (_React$Component) {
	  _inherits(Transition, _React$Component);
	
	  function Transition(props, context) {
	    _classCallCheck(this, Transition);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    var parentGroup = context.transitionGroup;
	    // In the context of a TransitionGroup all enters are really appears
	    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
	
	    var initialStatus = void 0;
	    _this.nextStatus = null;
	
	    if (props.in) {
	      if (appear) {
	        initialStatus = EXITED;
	        _this.nextStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = { status: initialStatus };
	
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  Transition.prototype.getChildContext = function getChildContext() {
	    return { transitionGroup: null }; // allows for nested Transitions
	  };
	
	  Transition.prototype.componentDidMount = function componentDidMount() {
	    this.updateStatus(true);
	  };
	
	  Transition.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _ref = this.pendingState || this.state,
	        status = _ref.status;
	
	    if (nextProps.in) {
	      if (status === UNMOUNTED) {
	        this.setState({ status: EXITED });
	      }
	      if (status !== ENTERING && status !== ENTERED) {
	        this.nextStatus = ENTERING;
	      }
	    } else {
	      if (status === ENTERING || status === ENTERED) {
	        this.nextStatus = EXITING;
	      }
	    }
	  };
	
	  Transition.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.updateStatus();
	  };
	
	  Transition.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.cancelNextCallback();
	  };
	
	  Transition.prototype.getTimeouts = function getTimeouts() {
	    var timeout = this.props.timeout;
	
	    var exit = void 0,
	        enter = void 0,
	        appear = void 0;
	
	    exit = enter = appear = timeout;
	
	    if (timeout != null && typeof timeout !== 'number') {
	      exit = timeout.exit;
	      enter = timeout.enter;
	      appear = timeout.appear;
	    }
	    return { exit: exit, enter: enter, appear: appear };
	  };
	
	  Transition.prototype.updateStatus = function updateStatus() {
	    var mounting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    var nextStatus = this.nextStatus;
	
	    if (nextStatus !== null) {
	      this.nextStatus = null;
	      // nextStatus will always be ENTERING or EXITING.
	      this.cancelNextCallback();
	      var node = _reactDom2.default.findDOMNode(this);
	
	      if (nextStatus === ENTERING) {
	        this.performEnter(node, mounting);
	      } else {
	        this.performExit(node);
	      }
	    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	      this.setState({ status: UNMOUNTED });
	    }
	  };
	
	  Transition.prototype.performEnter = function performEnter(node, mounting) {
	    var _this2 = this;
	
	    var enter = this.props.enter;
	
	    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
	
	    var timeouts = this.getTimeouts();
	
	    // no enter animation skip right to ENTERED
	    // if we are mounting and running this it means appear _must_ be set
	    if (!mounting && !enter) {
	      this.safeSetState({ status: ENTERED }, function () {
	        _this2.props.onEntered(node);
	      });
	      return;
	    }
	
	    this.props.onEnter(node, appearing);
	
	    this.safeSetState({ status: ENTERING }, function () {
	      _this2.props.onEntering(node, appearing);
	
	      // FIXME: appear timeout?
	      _this2.onTransitionEnd(node, timeouts.enter, function () {
	        _this2.safeSetState({ status: ENTERED }, function () {
	          _this2.props.onEntered(node, appearing);
	        });
	      });
	    });
	  };
	
	  Transition.prototype.performExit = function performExit(node) {
	    var _this3 = this;
	
	    var exit = this.props.exit;
	
	    var timeouts = this.getTimeouts();
	
	    // no exit animation skip right to EXITED
	    if (!exit) {
	      this.safeSetState({ status: EXITED }, function () {
	        _this3.props.onExited(node);
	      });
	      return;
	    }
	    this.props.onExit(node);
	
	    this.safeSetState({ status: EXITING }, function () {
	      _this3.props.onExiting(node);
	
	      _this3.onTransitionEnd(node, timeouts.exit, function () {
	        _this3.safeSetState({ status: EXITED }, function () {
	          _this3.props.onExited(node);
	        });
	      });
	    });
	  };
	
	  Transition.prototype.cancelNextCallback = function cancelNextCallback() {
	    if (this.nextCallback !== null) {
	      this.nextCallback.cancel();
	      this.nextCallback = null;
	    }
	  };
	
	  Transition.prototype.safeSetState = function safeSetState(nextState, callback) {
	    var _this4 = this;
	
	    // We need to track pending updates for instances where a cWRP fires quickly
	    // after cDM and before the state flushes, which would double trigger a
	    // transition
	    this.pendingState = nextState;
	
	    // This shouldn't be necessary, but there are weird race conditions with
	    // setState callbacks and unmounting in testing, so always make sure that
	    // we can cancel any pending setState callbacks after we unmount.
	    callback = this.setNextCallback(callback);
	    this.setState(nextState, function () {
	      _this4.pendingState = null;
	      callback();
	    });
	  };
	
	  Transition.prototype.setNextCallback = function setNextCallback(callback) {
	    var _this5 = this;
	
	    var active = true;
	
	    this.nextCallback = function (event) {
	      if (active) {
	        active = false;
	        _this5.nextCallback = null;
	
	        callback(event);
	      }
	    };
	
	    this.nextCallback.cancel = function () {
	      active = false;
	    };
	
	    return this.nextCallback;
	  };
	
	  Transition.prototype.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
	    this.setNextCallback(handler);
	
	    if (node) {
	      if (this.props.addEndListener) {
	        this.props.addEndListener(node, this.nextCallback);
	      }
	      if (timeout != null) {
	        setTimeout(this.nextCallback, timeout);
	      }
	    } else {
	      setTimeout(this.nextCallback, 0);
	    }
	  };
	
	  Transition.prototype.render = function render() {
	    var status = this.state.status;
	    if (status === UNMOUNTED) {
	      return null;
	    }
	
	    var _props = this.props,
	        children = _props.children,
	        childProps = _objectWithoutProperties(_props, ['children']);
	    // filter props for Transtition
	
	
	    delete childProps.in;
	    delete childProps.mountOnEnter;
	    delete childProps.unmountOnExit;
	    delete childProps.appear;
	    delete childProps.enter;
	    delete childProps.exit;
	    delete childProps.timeout;
	    delete childProps.addEndListener;
	    delete childProps.onEnter;
	    delete childProps.onEntering;
	    delete childProps.onEntered;
	    delete childProps.onExit;
	    delete childProps.onExiting;
	    delete childProps.onExited;
	
	    if (typeof children === 'function') {
	      return children(status, childProps);
	    }
	
	    var child = _react2.default.Children.only(children);
	    return _react2.default.cloneElement(child, childProps);
	  };
	
	  return Transition;
	}(_react2.default.Component);
	
	Transition.contextTypes = {
	  transitionGroup: PropTypes.object
	};
	Transition.childContextTypes = {
	  transitionGroup: function transitionGroup() {}
	};
	
	
	Transition.propTypes =  false ? {
	  /**
	   * A `function` child can be used instead of a React element.
	   * This function is called with the current transition status
	   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can used
	   * to apply context specific props to a component.
	   *
	   * ```jsx
	   * <Transition timeout={150}>
	   *   {(status) => (
	   *     <MyComponent className={`fade fade-${status}`} />
	   *   )}
	   * </Transition>
	   * ```
	   */
	  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,
	
	  /**
	   * Show the component; triggers the enter or exit states
	   */
	  in: PropTypes.bool,
	
	  /**
	   * By default the child component is mounted immediately along with
	   * the parent `Transition` component. If you want to "lazy mount" the component on the
	   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
	   * mounted, even on "exited", unless you also specify `unmountOnExit`.
	   */
	  mountOnEnter: PropTypes.bool,
	
	  /**
	   * By default the child component stays mounted after it reaches the `'exited'` state.
	   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
	   */
	  unmountOnExit: PropTypes.bool,
	
	  /**
	   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
	   * If you want to transition on the first mount set `appear` to `true`, and the
	   * component will transition in as soon as the `<Transition>` mounts.
	   *
	   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
	   */
	  appear: PropTypes.bool,
	
	  /**
	   * Enable or disable enter transitions.
	   */
	  enter: PropTypes.bool,
	
	  /**
	   * Enable or disable exit transitions.
	   */
	  exit: PropTypes.bool,
	
	  /**
	   * The duration of the transition, in milliseconds.
	   * Required unless `addEventListener` is provided
	   *
	   * You may specify a single timeout for all transitions like: `timeout={500}`,
	   * or individually like:
	   *
	   * ```jsx
	   * timeout={{
	   *  enter: 300,
	   *  exit: 500,
	   * }}
	   * ```
	   *
	   * @type {number | { enter?: number, exit?: number }}
	   */
	  timeout: function timeout(props) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var pt = _PropTypes.timeoutsShape;
	    if (!props.addEndListener) pt = pt.isRequired;
	    return pt.apply(undefined, [props].concat(args));
	  },
	
	  /**
	   * Add a custom transition end trigger. Called with the transitioning
	   * DOM node and a `done` callback. Allows for more fine grained transition end
	   * logic. **Note:** Timeouts are still used as a fallback if provided.
	   *
	   * ```jsx
	   * addEndListener={(node, done) => {
	   *   // use the css transitionend event to mark the finish of a transition
	   *   node.addEventListener('transitionend', done, false);
	   * }}
	   * ```
	   */
	  addEndListener: PropTypes.func,
	
	  /**
	   * Callback fired before the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * Callback fired after the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * Callback fired after the "entered" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * Callback fired before the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * Callback fired after the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * Callback fired after the "exited" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExited: PropTypes.func
	} : {};
	
	// Name the function so it is clearer in the documentation
	function noop() {}
	
	Transition.defaultProps = {
	  in: false,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  appear: false,
	  enter: true,
	  exit: true,
	
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	
	Transition.UNMOUNTED = 0;
	Transition.EXITED = 1;
	Transition.ENTERING = 2;
	Transition.ENTERED = 3;
	Transition.EXITING = 4;
	
	exports.default = Transition;

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.classNamesShape = exports.timeoutsShape = undefined;
	exports.transitionTimeout = transitionTimeout;
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function transitionTimeout(transitionType) {
	  var timeoutPropName = 'transition' + transitionType + 'Timeout';
	  var enabledPropName = 'transition' + transitionType;
	
	  return function (props) {
	    // If the transition is enabled
	    if (props[enabledPropName]) {
	      // If no timeout duration is provided
	      if (props[timeoutPropName] == null) {
	        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');
	
	        // If the duration isn't a number
	      } else if (typeof props[timeoutPropName] !== 'number') {
	        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
	      }
	    }
	
	    return null;
	  };
	}
	
	var timeoutsShape = exports.timeoutsShape = _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
	  enter: _propTypes2.default.number,
	  exit: _propTypes2.default.number
	}).isRequired]);
	
	var classNamesShape = exports.classNamesShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  exit: _propTypes2.default.string,
	  active: _propTypes2.default.string
	}), _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  enterActive: _propTypes2.default.string,
	  exit: _propTypes2.default.string,
	  exitActive: _propTypes2.default.string
	})]);

/***/ },
/* 218 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__(128);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(558);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	
	  /**
	   * Creates a Redux store that holds the state tree.
	   * The only way to change the data in the store is to call `dispatch()` on it.
	   *
	   * There should only be a single store in your app. To specify how different
	   * parts of the state tree respond to actions, you may combine several reducers
	   * into a single reducer function by using `combineReducers`.
	   *
	   * @param {Function} reducer A function that returns the next state tree, given
	   * the current state tree and the action to handle.
	   *
	   * @param {any} [preloadedState] The initial state. You may optionally specify it
	   * to hydrate the state from the server in universal apps, or to restore a
	   * previously serialized user session.
	   * If you use `combineReducers` to produce the root reducer function, this must be
	   * an object with the same shape as `combineReducers` keys.
	   *
	   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	   * to enhance the store with third-party capabilities such as middleware,
	   * time travel, persistence, etc. The only store enhancer that ships with Redux
	   * is `applyMiddleware()`.
	   *
	   * @returns {Store} A Redux store that lets you read the state, dispatch actions
	   * and subscribe to changes.
	   */
	};function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ },
/* 220 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Cookies = __webpack_require__(562);
	
	var _Cookies2 = _interopRequireDefault(_Cookies);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Cookies2.default;
	module.exports = exports['default'];

/***/ },
/* 222 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(19);
	var bind = __webpack_require__(139);
	var Axios = __webpack_require__(225);
	var defaults = __webpack_require__(93);
	
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */
	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context);
	
	  // Copy axios.prototype to instance
	  utils.extend(instance, Axios.prototype, context);
	
	  // Copy context to instance
	  utils.extend(instance, context);
	
	  return instance;
	}
	
	// Create the default instance to be exported
	var axios = createInstance(defaults);
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Factory for creating new instances
	axios.create = function create(instanceConfig) {
	  return createInstance(utils.merge(defaults, instanceConfig));
	};
	
	// Expose Cancel & CancelToken
	axios.Cancel = __webpack_require__(136);
	axios.CancelToken = __webpack_require__(224);
	axios.isCancel = __webpack_require__(137);
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(239);
	
	module.exports = axios;
	
	// Allow use of default import syntax in TypeScript
	module.exports.default = axios;


/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Cancel = __webpack_require__(136);
	
	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }
	
	  var resolvePromise;
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	
	  var token = this;
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }
	
	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};
	
	module.exports = CancelToken;


/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(93);
	var utils = __webpack_require__(19);
	var InterceptorManager = __webpack_require__(226);
	var dispatchRequest = __webpack_require__(227);
	
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */
	function Axios(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = utils.merge({
	      url: arguments[0]
	    }, arguments[1]);
	  }
	
	  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
	  config.method = config.method.toLowerCase();
	
	  // Hook up interceptors middleware
	  var chain = [dispatchRequest, undefined];
	  var promise = Promise.resolve(config);
	
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    chain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    chain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  while (chain.length) {
	    promise = promise.then(chain.shift(), chain.shift());
	  }
	
	  return promise;
	};
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url
	    }));
	  };
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	});
	
	module.exports = Axios;


/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(19);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(19);
	var transformData = __webpack_require__(230);
	var isCancel = __webpack_require__(137);
	var defaults = __webpack_require__(93);
	var isAbsoluteURL = __webpack_require__(235);
	var combineURLs = __webpack_require__(233);
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	function throwIfCancellationRequested(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }
	}
	
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  throwIfCancellationRequested(config);
	
	  // Support baseURL config
	  if (config.baseURL && !isAbsoluteURL(config.url)) {
	    config.url = combineURLs(config.baseURL, config.url);
	  }
	
	  // Ensure headers exist
	  config.headers = config.headers || {};
	
	  // Transform request data
	  config.data = transformData(
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers || {}
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  var adapter = config.adapter || defaults.adapter;
	
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested(config);
	
	    // Transform response data
	    response.data = transformData(
	      response.data,
	      response.headers,
	      config.transformResponse
	    );
	
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel(reason)) {
	      throwIfCancellationRequested(config);
	
	      // Transform response data
	      if (reason && reason.response) {
	        reason.response.data = transformData(
	          reason.response.data,
	          reason.response.headers,
	          config.transformResponse
	        );
	      }
	    }
	
	    return Promise.reject(reason);
	  });
	};


/***/ },
/* 228 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */
	module.exports = function enhanceError(error, config, code, request, response) {
	  error.config = config;
	  if (code) {
	    error.code = code;
	  }
	  error.request = request;
	  error.response = response;
	  return error;
	};


/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var createError = __webpack_require__(138);
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  // Note: status is not exposed by XDomainRequest
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response.request,
	      response
	    ));
	  }
	};


/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(19);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn(data, headers);
	  });
	
	  return data;
	};


/***/ },
/* 231 */
/***/ function(module, exports) {

	'use strict';
	
	// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js
	
	var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
	function E() {
	  this.message = 'String contains an invalid character';
	}
	E.prototype = new Error;
	E.prototype.code = 5;
	E.prototype.name = 'InvalidCharacterError';
	
	function btoa(input) {
	  var str = String(input);
	  var output = '';
	  for (
	    // initialize result and counter
	    var block, charCode, idx = 0, map = chars;
	    // if the next str index does not exist:
	    //   change the mapping table to "="
	    //   check if d has no fractional digits
	    str.charAt(idx | 0) || (map = '=', idx % 1);
	    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
	    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
	  ) {
	    charCode = str.charCodeAt(idx += 3 / 4);
	    if (charCode > 0xFF) {
	      throw new E();
	    }
	    block = block << 8 | charCode;
	  }
	  return output;
	}
	
	module.exports = btoa;


/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(19);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%40/gi, '@').
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      }
	
	      if (!utils.isArray(val)) {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};


/***/ },
/* 233 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return relativeURL
	    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
	    : baseURL;
	};


/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(19);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	  (function standardBrowserEnv() {
	    return {
	      write: function write(name, value, expires, path, domain, secure) {
	        var cookie = [];
	        cookie.push(name + '=' + encodeURIComponent(value));
	
	        if (utils.isNumber(expires)) {
	          cookie.push('expires=' + new Date(expires).toGMTString());
	        }
	
	        if (utils.isString(path)) {
	          cookie.push('path=' + path);
	        }
	
	        if (utils.isString(domain)) {
	          cookie.push('domain=' + domain);
	        }
	
	        if (secure === true) {
	          cookie.push('secure');
	        }
	
	        document.cookie = cookie.join('; ');
	      },
	
	      read: function read(name) {
	        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	        return (match ? decodeURIComponent(match[3]) : null);
	      },
	
	      remove: function remove(name) {
	        this.write(name, '', Date.now() - 86400000);
	      }
	    };
	  })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return {
	      write: function write() {},
	      read: function read() { return null; },
	      remove: function remove() {}
	    };
	  })()
	);


/***/ },
/* 235 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};


/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(19);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	  (function standardBrowserEnv() {
	    var msie = /(msie|trident)/i.test(navigator.userAgent);
	    var urlParsingNode = document.createElement('a');
	    var originURL;
	
	    /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	    function resolveURL(url) {
	      var href = url;
	
	      if (msie) {
	        // IE needs attribute set twice to normalize properties
	        urlParsingNode.setAttribute('href', href);
	        href = urlParsingNode.href;
	      }
	
	      urlParsingNode.setAttribute('href', href);
	
	      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	      return {
	        href: urlParsingNode.href,
	        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	        host: urlParsingNode.host,
	        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	        hostname: urlParsingNode.hostname,
	        port: urlParsingNode.port,
	        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	                  urlParsingNode.pathname :
	                  '/' + urlParsingNode.pathname
	      };
	    }
	
	    originURL = resolveURL(window.location.href);
	
	    /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	    return function isURLSameOrigin(requestURL) {
	      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	      return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	    };
	  })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return function isURLSameOrigin() {
	      return true;
	    };
	  })()
	);


/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(19);
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};


/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(19);
	
	// Headers whose duplicates are ignored by node
	// c.f. https://nodejs.org/api/http.html#http_message_headers
	var ignoreDuplicateOf = [
	  'age', 'authorization', 'content-length', 'content-type', 'etag',
	  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
	  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
	  'referer', 'retry-after', 'user-agent'
	];
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
	        return;
	      }
	      if (key === 'set-cookie') {
	        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
	      } else {
	        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	      }
	    }
	  });
	
	  return parsed;
	};


/***/ },
/* 239 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _reactRouterRedux = __webpack_require__(60);
	
	var _app = __webpack_require__(94);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _data = __webpack_require__(70);
	
	var _data2 = _interopRequireDefault(_data);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import { localeReducer } from 'react-localize-redux';
	
	exports.default = function () {
		var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
		var action = arguments[1];
	
		return {
			app: (0, _app2.default)(state.app, action, state),
			routing: (0, _reactRouterRedux.routerReducer)(state.routing, action, state),
			data: (0, _data2.default)(state.data, action, state)
		};
	}; // import { combineReducers } from 'redux'

/***/ },
/* 241 */
/***/ function(module, exports) {

	
	// /*
	// /*
	// /*        R E D U C E R
	// /*
	// /*
	// */
	
	// import { LOCATION_CHANGE } from 'react-router-redux'
	
	// export const SET_SECTION = 'app/SET_SECTION'
	// export const TOGGLE_LOADING = 'app/TOGGLE_LOADING'
	
	// const initialState = {
	// 	current : '',
	// 	last : ''
	// }
	
	// export default (state = initialState, action) => {
	
	
	// 	switch (action.type) {
	
	
	//         default:
	//             return state
	//     }
	// }
	
	
	// /*
	// /*
	// /*        A C T I O N S
	// /*
	// /*
	// */
	
	// export const setSection = (name) => {
	
	// 	return dispatch => {
	
	// 		dispatch({
	// 			type: SET_SECTION,
	// 			payload: name,
	// 		})
	
	// 	}
	
	// }
	"use strict";

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _layout = __webpack_require__(15);
	
	var _ScrollTracker = __webpack_require__(72);
	
	var _ScrollTracker2 = _interopRequireDefault(_ScrollTracker);
	
	var _Overline = __webpack_require__(42);
	
	var _Overline2 = _interopRequireDefault(_Overline);
	
	var _AboutMilanVideos = __webpack_require__(243);
	
	var _AboutMilanVideos2 = _interopRequireDefault(_AboutMilanVideos);
	
	var _Plus = __webpack_require__(95);
	
	var _Plus2 = _interopRequireDefault(_Plus);
	
	var _Superface = __webpack_require__(7);
	
	var _Superface2 = _interopRequireDefault(_Superface);
	
	var _MenuItemSoon = __webpack_require__(71);
	
	var _MenuItemSoon2 = _interopRequireDefault(_MenuItemSoon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var About = function (_React$Component) {
	    _inherits(About, _React$Component);
	
	    function About(props) {
	        _classCallCheck(this, About);
	
	        var _this = _possibleConstructorReturn(this, (About.__proto__ || Object.getPrototypeOf(About)).call(this, props));
	
	        _this.handleResize = _this.handleResize.bind(_this);
	        _this.handleScroll = _this.handleScroll.bind(_this);
	        _this.handleScrollVirtual = _this.handleScrollVirtual.bind(_this);
	
	        return _this;
	    }
	
	    _createClass(About, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            this.container.addEventListener('scroll', this.handleScroll);
	            _Superface2.default.setCompass('S');
	            this.timeoutStartScroll = window.setTimeout(function () {
	                _this2.setState(Object.assign({}, _this2.state, { mounted: true }));
	                _this2.scroll.start();
	                _this2.container.style.overflow = 'scroll';
	                _Superface2.default.setLoading(false);
	            }, 800);
	
	            window.addEventListener('resize', this.handleResize);
	        }
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            document.title = _Superface2.default.translate('Notre métier') + ' - Superface';
	            this.setState({
	                currentSectionIndex: 0,
	                displayTopImages: true,
	                showImageTopLeft: false,
	                mounted: false,
	                currentMilan: 1,
	                shapeTextFixed: false,
	                milanVideosFixed: false,
	                milanVideosLeave: false,
	                milanGalleryFixed: false
	            });
	            this.scroll = new _ScrollTracker2.default();
	            this.scroll.on('scroll', this.handleScrollVirtual);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener('resize', this.handleResize);
	            if (this.timeoutStartScroll) window.clearTimeout(this.timeoutStartScroll);
	            this.scroll.off('scroll', this.handleScrollVirtual);
	            this.scroll.destroy();
	        }
	    }, {
	        key: 'handleResize',
	        value: function handleResize() {
	            this.setState(Object.assign({}, this.state));
	            this.handleScroll(null);
	        }
	    }, {
	        key: 'handleScroll',
	        value: function handleScroll(e) {
	            // console.log('sisisisisisisi')
	            var MAIN_HEIGHT = 25 * window.innerHeight;
	
	            var scrollTop = this.container.scrollTop;
	            var overAllProgress = scrollTop / MAIN_HEIGHT * 100;
	            var BREAKS = [9, 13.98, 23.17, 28.09, 44.8, 50.2];
	
	            switch (true) {
	                case overAllProgress < BREAKS[0] && this.state.currentSectionIndex !== 0:
	
	                    this.setState(Object.assign({}, this.state, {
	                        currentSectionIndex: 0
	                    }));
	                    break;
	
	                case overAllProgress >= BREAKS[0] && overAllProgress < BREAKS[1] && this.state.currentSectionIndex !== 1:
	
	                    this.setState(Object.assign({}, this.state, {
	                        currentSectionIndex: 1
	                    }));
	                    break;
	
	                case overAllProgress >= BREAKS[1] && overAllProgress < BREAKS[2] && this.state.currentSectionIndex !== 2:
	
	                    this.setState(Object.assign({}, this.state, {
	                        currentSectionIndex: 2
	                    }));
	                    break;
	
	                case overAllProgress >= BREAKS[2] && overAllProgress < BREAKS[3] && this.state.currentSectionIndex !== 3:
	
	                    this.setState(Object.assign({}, this.state, {
	                        currentSectionIndex: 3
	                    }));
	                    break;
	
	                case overAllProgress >= BREAKS[3] && overAllProgress < BREAKS[4] && this.state.currentSectionIndex !== 4:
	
	                    this.setState(Object.assign({}, this.state, {
	                        currentSectionIndex: 4
	                    }));
	                    break;
	
	                case overAllProgress >= BREAKS[4] && overAllProgress < BREAKS[5] && this.state.currentSectionIndex !== 5:
	
	                    this.setState(Object.assign({}, this.state, {
	                        currentSectionIndex: 5
	                    }));
	                    break;
	
	                case overAllProgress >= BREAKS[5] && this.state.currentSectionIndex !== 6:
	
	                    this.setState(Object.assign({}, this.state, {
	                        currentSectionIndex: 6
	                    }));
	                    break;
	
	                default:
	                    break;
	
	            }
	
	            if (overAllProgress > 0.5 && !this.state.showImageTopLeft) {
	                this.setState(Object.assign({}, this.state, { showImageTopLeft: true }));
	            } else if (overAllProgress < 0.5 && this.state.showImageTopLeft) {
	                this.setState(Object.assign({}, this.state, { showImageTopLeft: false }));
	            }
	
	            /*=============================================
	            =            SKILLS                           =
	            =============================================*/
	
	            if (overAllProgress > 7 && overAllProgress <= 11 && !this.state.skillsFixed) {
	                this.setState(Object.assign({}, this.state, {
	                    skillsFixed: true,
	                    displayTopImages: false
	                }));
	            } else if (overAllProgress > 11 && this.state.skillsFixed) {
	                this.setState(Object.assign({}, this.state, {
	                    skillsFixed: false
	                }));
	            } else if (overAllProgress <= 7 && this.state.skillsFixed) {
	                this.setState(Object.assign({}, this.state, {
	                    skillsFixed: false,
	                    displayTopImages: true
	                }));
	            }
	
	            /*=============================================
	            =            SHAPES                           =
	            =============================================*/
	
	            if (overAllProgress > 14 && overAllProgress <= 20 && !this.state.shapeTextFixed) {
	                this.setState(Object.assign({}, this.state, {
	                    shapeTextFixed: true
	                }));
	            } else if (overAllProgress < 14 && this.state.shapeTextFixed) {
	                this.setState(Object.assign({}, this.state, {
	                    shapeTextFixed: false
	                }));
	            } else if (overAllProgress > 20 && this.state.shapeTextFixed) {
	                this.setState(Object.assign({}, this.state, {
	                    shapeTextFixed: false
	                }));
	            }
	
	            if (overAllProgress > 9 && overAllProgress < 25) {
	                var progress = (overAllProgress - 9) / 16;
	                var shapes_images = document.querySelectorAll('.shapes-image');
	                shapes_images.forEach(function (el, i) {
	                    var q = i % 3 === 0 ? 0.8 : -1;
	                    el.style.transform = 'translateY(' + progress * window.innerHeight * 2 * q + 'px)';
	                });
	            }
	
	            /*=============================================
	            =            MILANS VIDEO                     =
	            =============================================*/
	
	            if (overAllProgress >= 19.4 && overAllProgress < 21 && !this.state.milanVideosFixed) {
	                this.setState(Object.assign({}, this.state, {
	                    milanVideosFixed: true
	                }));
	            } else if (overAllProgress < 19.4 && this.state.milanVideosFixed) {
	                this.setState(Object.assign({}, this.state, {
	                    milanVideosFixed: false,
	                    milanVideosLeave: false
	                }));
	            } else if (overAllProgress >= 21 && this.state.milanVideosFixed) {
	                this.setState(Object.assign({}, this.state, {
	                    milanVideosFixed: false,
	                    milanVideosLeave: true
	                }));
	            }
	
	            /*=============================================
	            =            EXPERIENCE                       =
	            =============================================*/
	
	            if (overAllProgress > 21 && overAllProgress < 30) {
	
	                var _progress = (overAllProgress - 21) / 9;
	                var exp_images = document.querySelectorAll('.experience-image');
	                exp_images.forEach(function (el, i) {
	                    var q = void 0;
	                    switch (i) {
	                        case 0:
	                            q = 0.15;
	                            break;
	                        case 1:
	                            q = -0.06;
	                            break;
	                        case 2:
	                            q = 0.04;
	                            break;
	                        default:
	                            q = -0.08;
	                            break;
	                    }
	                    el.style.transform = 'translateY(' + _progress * window.innerHeight * 2 * q + 'px)';
	                });
	            }
	
	            /*=============================================
	            =            GALERIE MILANS                   =
	            =============================================*/
	
	            if (overAllProgress > 29.19 && overAllProgress <= 41.20 && !this.state.milanGalleryFixed) {
	                this.setState(Object.assign({}, this.state, {
	                    milanGalleryFixed: true
	                }));
	            } else if (overAllProgress <= 29.19 && this.state.milanGalleryFixed) {
	                this.setState(Object.assign({}, this.state, {
	                    milanGalleryFixed: false
	                }));
	            } else if (overAllProgress > 41.20 && this.state.milanGalleryFixed) {
	                this.setState(Object.assign({}, this.state, {
	                    milanGalleryFixed: false
	                }));
	            }
	
	            if (overAllProgress > 29.19 && overAllProgress < 44) {
	                var _progress2 = (overAllProgress - 29.19) / 5;
	                var imgs = document.querySelectorAll('.milan-image-container img');
	                imgs.forEach(function (img, i) {
	                    if (i !== 0) {
	                        if (_progress2 > i * 0.2) {
	                            img.style.display = 'block';
	                        } else {
	                            img.style.display = 'none';
	                        }
	                    }
	                });
	            }
	        }
	    }, {
	        key: 'handleScrollVirtual',
	        value: function handleScrollVirtual(e) {
	
	            var ratio = this.scroll.positionY / (window.innerHeight / 2);
	
	            if (ratio > 2.5) {
	                this.scroll.stop();
	                this.container.style.overflow = 'hidden';
	                _Superface2.default.goTo(_Superface2.default.uri('accueil'));
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { ref: function ref(el) {
	                        return _this3.container = el;
	                    }, id: 'notre-metier', style: { backgroundColor: 'white', width: '100vw', height: '100vh', overflow: 'hidden' } },
	                this.renderPageTitle(),
	                this.renderPage()
	            );
	        }
	    }, {
	        key: 'renderPageTitle',
	        value: function renderPageTitle() {
	            if (!this.props.about) return;
	            var sectionName = _Superface2.default.field(this.props.about, 'section_title_' + (this.state.currentSectionIndex + 1));
	            return _react2.default.createElement(
	                'div',
	                { style: {
	                        position: 'fixed',
	                        top: '4.22rem',
	                        width: '100vw',
	                        textAlign: 'center',
	                        zIndex: 99
	                        // mixBlendMode : (this.state.currentSectionIndex !== 4 ? 'initial' : 'difference')
	                    }
	                },
	                sectionName
	            );
	        }
	    }, {
	        key: 'getSkillsStyle',
	        value: function getSkillsStyle() {
	            return {
	                width: '100%',
	                height: '100vh',
	                position: this.state.skillsFixed ? 'fixed' : 'absolute',
	                top: this.state.skillsFixed ? 0 : '275vh',
	                pointerEvents: 'none'
	            };
	        }
	    }, {
	        key: 'getShapesTextStyle',
	        value: function getShapesTextStyle() {
	            return {
	                width: '100%',
	                height: '100vh',
	                position: this.state.shapeTextFixed ? 'fixed' : 'absolute',
	                top: this.state.shapeTextFixed ? 0 : '350vh',
	                pointerEvents: 'none'
	            };
	        }
	    }, {
	        key: 'getMilanVideosStyle',
	        value: function getMilanVideosStyle() {
	            return {
	                width: '100%',
	                height: '100vh',
	                pointerEvents: 'none',
	                position: 'absolute',
	                zIndex: '98',
	                top: '480vh',
	                backgroundColor: 'white'
	            };
	        }
	    }, {
	        key: 'getMilanGalleryStyle',
	        value: function getMilanGalleryStyle() {
	            return {
	                width: '100%',
	                height: '100vh',
	                pointerEvents: 'none',
	                position: this.state.milanGalleryFixed ? 'fixed' : 'absolute',
	                zIndex: '98',
	                top: this.state.milanGalleryFixed ? 0 : '730vh'
	            };
	        }
	    }, {
	        key: 'renderPage',
	        value: function renderPage() {
	            var about = this.props.about;
	
	            var state = this.state;
	            var MAIN_HEIGHT = 25 * window.innerHeight;
	
	            var smallText = { fontSize: '1.2rem', margin: 'auto', maxWidth: '600px', width: '50%' };
	            var largeText = { fontSize: '2.2rem', margin: 'auto', maxWidth: '600px', width: '50%' };
	            var imagesTopStyle = { zIndex: 80, position: 'fixed' };
	
	            if (about) {
	
	                // console.log(about)
	
	                return _react2.default.createElement(
	                    'div',
	                    { style: { height: MAIN_HEIGHT * 0.51 } },
	                    _react2.default.createElement(
	                        _layout.Flex,
	                        { className: 'about-text-1 ' + (this.state.mounted ? 'mounted' : ''), style: { position: 'absolute', top: 0, bottom: 0, left: 0, right: 0 }, align: 'center', justify: 'center' },
	                        _react2.default.createElement('div', { style: largeText, dangerouslySetInnerHTML: this.crtmrkp(_Superface2.default.field(about, 'text_1')) })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { style: { position: 'absolute', width: '100vw', top: '100vh' } },
	                        _react2.default.createElement('div', { style: largeText, dangerouslySetInnerHTML: this.crtmrkp(_Superface2.default.field(about, 'text_2')) })
	                    ),
	                    _react2.default.createElement('img', {
	                        src: _Superface2.default.assetUrl(about.image_1.path),
	                        style: Object.assign({ display: state.displayTopImages ? 'block' : 'none', width: '25vw', top: '30vh', right: '0' }, imagesTopStyle),
	                        className: 'image-top ' + (this.state.mounted ? 'shown' : 'hidden'),
	                        alt: 'Pi\xE8ce de Milan'
	                    }),
	                    _react2.default.createElement('img', {
	                        src: _Superface2.default.assetUrl(about.image_2.path),
	                        style: Object.assign({ display: state.displayTopImages ? 'block' : 'none', height: '50vh', width: 'auto', left: '-200px', top: '18vh' }, imagesTopStyle),
	                        className: 'image-top ' + (this.state.showImageTopLeft ? 'shown' : 'hidden'),
	                        alt: 'Pi\xE8ce de Milan 2'
	                    }),
	                    _react2.default.createElement(
	                        'div',
	                        {
	                            style: {
	                                width: '100vw',
	                                height: '100vh',
	                                clip: 'rect(0, auto, auto, 0)',
	                                left: 0,
	                                position: 'absolute',
	                                zIndex: 100,
	                                top: '175vh'
	                            } },
	                        _react2.default.createElement('img', {
	                            style: {
	                                width: window.innerWidth / window.innerHeight > 1.33 ? '100vw' : 'auto',
	                                height: window.innerWidth / window.innerHeight < 1.33 ? '100vh' : 'auto',
	                                position: 'fixed',
	                                top: '0'
	                            },
	                            src: _Superface2.default.assetUrl(about.interstice.path),
	                            alt: 'interstice'
	                        })
	                    ),
	                    _react2.default.createElement(
	                        _layout.Flex,
	                        {
	                            id: 'skills',
	                            justify: 'center',
	                            align: 'center',
	                            style: this.getSkillsStyle()
	                        },
	                        _react2.default.createElement(
	                            _layout.Flex,
	                            { align: 'flex-start', justify: 'space-around', style: { width: '100%' } },
	                            _react2.default.createElement(
	                                _layout.Flex,
	                                { className: 'skill', direction: 'column' },
	                                _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    _react2.default.createElement(
	                                        'h2',
	                                        null,
	                                        _Superface2.default.field(about, 'titre_recherche')
	                                    ),
	                                    _react2.default.createElement('div', { dangerouslySetInnerHTML: this.crtmrkp(_Superface2.default.field(about, 'recherche')) })
	                                ),
	                                _react2.default.createElement('br', null),
	                                _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    _react2.default.createElement(
	                                        'h2',
	                                        null,
	                                        _Superface2.default.field(about, 'titre_proposition')
	                                    ),
	                                    _react2.default.createElement('div', { dangerouslySetInnerHTML: this.crtmrkp(_Superface2.default.field(about, 'proposition')) })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _layout.Flex,
	                                { className: 'skill', direction: 'column' },
	                                _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    _react2.default.createElement(
	                                        'h2',
	                                        null,
	                                        _Superface2.default.field(about, 'titre_developpement')
	                                    ),
	                                    _react2.default.createElement('div', { dangerouslySetInnerHTML: this.crtmrkp(_Superface2.default.field(about, 'developpement')) })
	                                ),
	                                _react2.default.createElement('br', null),
	                                _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    _react2.default.createElement(
	                                        'h2',
	                                        null,
	                                        _Superface2.default.field(about, 'titre_suivi')
	                                    ),
	                                    _react2.default.createElement('div', { dangerouslySetInnerHTML: this.crtmrkp(_Superface2.default.field(about, 'suivi')) })
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _layout.Flex,
	                        {
	                            id: 'shapes',
	                            style: this.getShapesTextStyle()
	                        },
	                        _react2.default.createElement('div', {
	                            style: smallText,
	                            dangerouslySetInnerHTML: this.crtmrkp(_Superface2.default.field(about, 'text_4')),
	                            className: this.state.shapeTextFixed ? 'shapes-fixed' : ''
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { style: { position: 'relative', top: '310vh', zIndex: 50 } },
	                        _react2.default.createElement('img', { className: 'shapes-image', src: __webpack_require__(191), alt: 'forme filaire' }),
	                        _react2.default.createElement('img', { className: 'shapes-image', src: __webpack_require__(192), alt: 'forme filaire' }),
	                        _react2.default.createElement('img', { className: 'shapes-image', src: __webpack_require__(66), alt: 'forme filaire' }),
	                        _react2.default.createElement('img', { className: 'shapes-image', src: __webpack_require__(193), alt: 'forme filaire' }),
	                        _react2.default.createElement('img', { className: 'shapes-image', src: __webpack_require__(488), alt: 'forme filaire' }),
	                        _react2.default.createElement('img', { className: 'shapes-image', src: __webpack_require__(489), alt: 'forme filaire' }),
	                        _react2.default.createElement('img', { className: 'shapes-image', src: __webpack_require__(490), alt: 'forme filaire' }),
	                        _react2.default.createElement('img', { className: 'shapes-image', src: __webpack_require__(491), alt: 'forme filaire' }),
	                        _react2.default.createElement('img', { className: 'shapes-image', src: __webpack_require__(484), alt: 'forme filaire' }),
	                        _react2.default.createElement('img', { className: 'shapes-image', src: __webpack_require__(485), alt: 'forme filaire' }),
	                        _react2.default.createElement('img', { className: 'shapes-image', src: __webpack_require__(486), alt: 'forme filaire' }),
	                        _react2.default.createElement('img', { className: 'shapes-image', src: __webpack_require__(487), alt: 'forme filaire' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        {
	                            id: 'milans',
	                            style: this.getMilanVideosStyle()
	                        },
	                        _react2.default.createElement(
	                            _layout.Flex,
	                            { align: 'center', justify: 'space-around', style: { width: '80%', padding: '0 10%', position: 'absolute', zIndex: 10, bottom: '0' } },
	                            this.renderObjLinks()
	                        ),
	                        _react2.default.createElement(
	                            _layout.Flex,
	                            { align: 'center', direction: 'column', justify: 'center', style: { width: '100%', height: '100vh', position: 'absolute', zIndex: 6, pointerEvents: 'none' } },
	                            _react2.default.createElement(_AboutMilanVideos2.default, { about: about, current: this.state.currentMilan })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _layout.Flex,
	                        {
	                            id: 'experience-text-1',
	                            style: { position: 'absolute', width: '100%', top: '610vh' }
	                        },
	                        _react2.default.createElement('div', { style: largeText, dangerouslySetInnerHTML: this.crtmrkp(_Superface2.default.field(about, 'text_5')) })
	                    ),
	                    _react2.default.createElement(
	                        _layout.Flex,
	                        {
	                            id: 'experience-text-2',
	                            style: { position: 'absolute', width: '100%', top: '690vh' }
	                        },
	                        _react2.default.createElement('div', { style: smallText, dangerouslySetInnerHTML: this.crtmrkp(_Superface2.default.field(about, 'text_6')) })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { style: { position: 'relative', top: '560vh', zIndex: 10 } },
	                        _react2.default.createElement('img', { className: 'experience-image', src: _Superface2.default.assetUrl(about.image_4.path), alt: 'notre experience' }),
	                        _react2.default.createElement('img', { className: 'experience-image', src: _Superface2.default.assetUrl(about.image_5.path), alt: 'notre experience' }),
	                        _react2.default.createElement('img', { className: 'experience-image', src: _Superface2.default.assetUrl(about.image_6.path), alt: 'notre experience' }),
	                        _react2.default.createElement('img', { className: 'experience-image', src: _Superface2.default.assetUrl(about.image_7.path), alt: 'notre experience' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { id: 'images-milan', style: this.getMilanGalleryStyle() },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { height: '100vh', position: 'relative' } },
	                            this.renderMilansImages(about.milans)
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        {
	                            style: {
	                                width: '100vw',
	                                height: '100vh',
	                                clip: 'rect(0, auto, auto, 0)',
	                                left: 0,
	                                position: 'absolute',
	                                zIndex: 100,
	                                top: '1030vh'
	                            } },
	                        _react2.default.createElement('img', {
	                            style: {
	                                width: window.innerWidth / window.innerHeight > 1.33 ? '100vw' : 'auto',
	                                height: window.innerWidth / window.innerHeight < 1.33 ? '100vh' : 'auto',
	                                position: 'fixed',
	                                top: '0'
	                            },
	                            src: _Superface2.default.assetUrl(this.props.about.milans[6].path),
	                            alt: 'Pi\xE8ces de Milan interstice'
	                        })
	                    ),
	                    _react2.default.createElement(
	                        _layout.Flex,
	                        {
	                            direction: 'row-reverse',
	                            align: 'center',
	                            justify: 'center',
	                            id: 'team',
	                            style: {
	                                height: '100vh',
	                                width: window.innerWidth > 1280 ? '66%' : '70%',
	                                marginLeft: window.innerWidth > 1280 ? '17%' : '15%',
	                                position: 'absolute',
	                                top: '1130vh'
	                            }
	                        },
	                        this.renderMembers(this.props.about.team)
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        {
	                            id: 'contact',
	                            style: {
	                                position: 'absolute', top: '1290vh', width: '100%'
	                            }
	                        },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { position: 'relative' } },
	                            _react2.default.createElement(
	                                'div',
	                                { style: Object.assign({}, largeText, { color: 'black', position: 'relative', zIndex: 50 }) },
	                                _Superface2.default.field(this.props.about, 'text_merci'),
	                                _react2.default.createElement('br', null),
	                                _react2.default.createElement('br', null),
	                                _react2.default.createElement(
	                                    'p',
	                                    { style: { fontSize: '1rem', lineHeight: '1.5rem', marginTop: '4vh' } },
	                                    _Superface2.default.translate('Crédits :'),
	                                    _react2.default.createElement('br', null),
	                                    _Superface2.default.translate('Direction artistique et site internet : '),
	                                    _react2.default.createElement(
	                                        'a',
	                                        { className: 'overline-link', href: 'https://www.bureaukayser.com/', target: '_blank' },
	                                        _react2.default.createElement(
	                                            _Overline2.default,
	                                            null,
	                                            'Bureau Kayser'
	                                        )
	                                    ),
	                                    _react2.default.createElement('br', null),
	                                    _Superface2.default.translate('Photos : '),
	                                    _react2.default.createElement(
	                                        'a',
	                                        { className: 'overline-link', href: 'https://marvinleuvrey.com/', target: '_blank' },
	                                        _react2.default.createElement(
	                                            _Overline2.default,
	                                            null,
	                                            'Marvin Leuvrey'
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'a',
	                                    { target: '_blank', href: this.props.contact.facebook, style: { display: 'inline-block', width: '2rem', marginLeft: '-0.5rem', marginTop: '5vh' } },
	                                    _react2.default.createElement('img', { src: __webpack_require__(64), alt: 'facebook' })
	                                ),
	                                '\xA0\xA0',
	                                _react2.default.createElement(
	                                    'a',
	                                    { target: '_blank', href: this.props.contact.instagram, style: { display: 'inline-block', width: '2rem' } },
	                                    _react2.default.createElement('img', { src: __webpack_require__(65), alt: 'instagram' })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { style: { position: 'realtive' } },
	                                _react2.default.createElement(
	                                    'div',
	                                    { style: { position: 'absolute', width: '15rem', left: '60%', bottom: '-20px', zIndex: '8' } },
	                                    _react2.default.createElement('img', { src: __webpack_require__(66), alt: 'Pi\xE8ce de Milan' })
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { style: { position: 'absolute', top: '1350vh', width: '100%', height: '4rem', borderTop: '1px solid black' } },
	                        _react2.default.createElement(
	                            _layout.Flex,
	                            { justify: 'space-around' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'footer-link', style: { marginTop: 0 } },
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: 'overline-link', onClick: function onClick() {
	                                            _Superface2.default.goTo(_Superface2.default.uri('contact'));
	                                        } },
	                                    _react2.default.createElement(
	                                        _Overline2.default,
	                                        null,
	                                        _Superface2.default.translate('Contact')
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'footer-link', style: { marginTop: 0 } },
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: 'overline-link', onClick: function onClick() {
	                                            _Superface2.default.goTo(_Superface2.default.uri('matieres'));
	                                        } },
	                                    _react2.default.createElement(
	                                        _Overline2.default,
	                                        null,
	                                        _Superface2.default.translate('Matières')
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'footer-link', style: { marginTop: 0 } },
	                                _react2.default.createElement(_MenuItemSoon2.default, { display: _Superface2.default.translate('Projets'), style: { display: 'inline-block' } })
	                            )
	                        )
	                    )
	                );
	            }
	        }
	    }, {
	        key: 'renderObjLinks',
	        value: function renderObjLinks() {
	            var _this4 = this;
	
	            var a = [1, 2, 3, 4, 5, 6];
	            return a.map(function (n) {
	                return _react2.default.createElement(
	                    _layout.Flex,
	                    { key: 'milans' + n, style: { pointerEvents: 'all', cursor: 'pointer' }, direction: 'column', align: 'center', justify: 'center' },
	                    _react2.default.createElement(
	                        'div',
	                        { onClick: function onClick() {
	                                _this4.setState(Object.assign({}, _this4.state, { currentMilan: n }));
	                            }, style: { width: "5vw" } },
	                        _react2.default.createElement('img', { src: __webpack_require__(575)("./superface_3D_" + n + '.png'), alt: 'Pi\xE8ces de Milan 3d' })
	                    ),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(_Plus2.default, { selected: _this4.state.currentMilan === n })
	                );
	            });
	        }
	    }, {
	        key: 'renderMembers',
	        value: function renderMembers(members) {
	            var _this5 = this;
	
	            return members.map(function (data, i) {
	                var member = Object.assign({}, data.value);
	                var style = { width: '33.3%', textAlign: 'center', marginTop: '-0.6vw' };
	                return _react2.default.createElement(
	                    'div',
	                    { key: 'member-' + i, className: 'member', style: style },
	                    _react2.default.createElement(
	                        _layout.Flex,
	                        { direction: 'column', align: 'center' },
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement('img', { src: _Superface2.default.assetUrl(member.image.path), alt: member.firstname + ' ' + member.lastname })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'member-text' },
	                            _react2.default.createElement(
	                                'p',
	                                { style: { fontSize: '1.4rem', marginTop: '3rem' } },
	                                member.firstname + ' ' + member.lastname
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                { style: { fontSize: '0.9rem', marginTop: '1rem', minHeight: '3rem' } },
	                                _this5.renderRoles(member)
	                            )
	                        )
	                    )
	                );
	            });
	        }
	    }, {
	        key: 'renderRoles',
	        value: function renderRoles(member) {
	            if (_Superface2.default.app().lang === 'fr') {
	                return member.roles.map(function (role, i) {
	                    return _react2.default.createElement(
	                        'span',
	                        { style: { display: 'block' }, key: 'role_' + i },
	                        role
	                    );
	                });
	            } else {
	                return member.roles_en.map(function (role, i) {
	                    return _react2.default.createElement(
	                        'span',
	                        { style: { display: 'block' }, key: 'role_' + i },
	                        role
	                    );
	                });
	            }
	        }
	    }, {
	        key: 'renderMilansImages',
	        value: function renderMilansImages(images) {
	            var _this6 = this;
	
	            return images.map(function (img, i) {
	
	                if (i !== images.length - 1) {
	                    return _react2.default.createElement(
	                        'div',
	                        { key: 'milan_images_' + i, className: 'milan-image-container' },
	                        _react2.default.createElement('img', { className: 'milan-image', ref: function ref(el) {
	                                return _this6['milan_image_' + i] = el;
	                            }, src: img.path, alt: 'Pi\xE8ce de Milan' })
	                    );
	                } else {
	                    return;
	                }
	            });
	        }
	    }, {
	        key: 'crtmrkp',
	        value: function crtmrkp(text) {
	            text = text.replace(/title="(.*)"/, '');
	            return { __html: text };
	        }
	    }]);
	
	    return About;
	}(_react2.default.Component);
	
	exports.default = About;

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Superface = __webpack_require__(7);
	
	var _Superface2 = _interopRequireDefault(_Superface);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MilanVideos = function (_React$Component) {
	    _inherits(MilanVideos, _React$Component);
	
	    function MilanVideos() {
	        _classCallCheck(this, MilanVideos);
	
	        return _possibleConstructorReturn(this, (MilanVideos.__proto__ || Object.getPrototypeOf(MilanVideos)).apply(this, arguments));
	    }
	
	    _createClass(MilanVideos, [{
	        key: 'getVideosStyle',
	        value: function getVideosStyle(i) {
	            return {
	                opacity: i + 1 === this.props.current ? 1 : 0,
	                position: 'absolute',
	                width: window.innerWidth < 1024 ? '100%' : '80%'
	            };
	        }
	    }, {
	        key: 'renderVideos',
	        value: function renderVideos() {
	            var _this2 = this;
	
	            var videos = [this.props.about.video_galaxy_1.path, this.props.about.video_galaxy_2.path, this.props.about.video_galaxy_3.path, this.props.about.video_galaxy_4.path, this.props.about.video_galaxy_5.path, this.props.about.video_galaxy_6.path];
	            return videos.map(function (path, i) {
	                return _react2.default.createElement('video', {
	                    style: _this2.getVideosStyle(i),
	                    key: 'milan-videos-' + i,
	                    src: _Superface2.default.assetUrl(path),
	                    autoPlay: true,
	                    loop: true
	                });
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            if (!this.props.about) return _react2.default.createElement('span', null);
	
	            return _react2.default.createElement(
	                'div',
	                {
	                    id: 'milan-videos',
	                    style: { width: '100%', height: '100%', zIndex: 10, position: 'absolute', display: 'flex', alignItems: 'center', justifyContent: 'center', pointerEvents: 'none' }
	                },
	                this.renderVideos()
	            );
	        }
	    }]);
	
	    return MilanVideos;
	}(_react2.default.Component);
	
	exports.default = MilanVideos;

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BrowserApp = __webpack_require__(259);
	
	var _BrowserApp2 = _interopRequireDefault(_BrowserApp);
	
	var _MobileApp = __webpack_require__(260);
	
	var _MobileApp2 = _interopRequireDefault(_MobileApp);
	
	var _Superface = __webpack_require__(7);
	
	var _Superface2 = _interopRequireDefault(_Superface);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import Detect from 'three/examples/js/Detector'
	
	
	// const WEBGL_CAPABLE = Detect.webgl
	
	var App = function (_Component) {
		_inherits(App, _Component);
	
		function App() {
			_classCallCheck(this, App);
	
			return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
		}
	
		_createClass(App, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var _this2 = this;
	
				window.addEventListener('resize', function () {
					_this2.setState({});
				});
			}
		}, {
			key: 'renderApp',
			value: function renderApp() {
	
				if (_Superface2.default.IS_MOBILE_OR_TABLET) {
					return _react2.default.createElement(_MobileApp2.default, null);
				} else {
					return _react2.default.createElement(_BrowserApp2.default, null);
				}
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ style: { width: '100%', height: '100%' } },
					this.renderApp()
				);
			}
		}]);
	
		return App;
	}(_react.Component);
	
	exports.default = App;

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _superface = __webpack_require__(502);
	
	var _superface2 = _interopRequireDefault(_superface);
	
	var _layout = __webpack_require__(15);
	
	var _lottieWeb = __webpack_require__(129);
	
	var _lottieWeb2 = _interopRequireDefault(_lottieWeb);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HomeAnimation = function (_React$Component) {
	    _inherits(HomeAnimation, _React$Component);
	
	    function HomeAnimation(props) {
	        _classCallCheck(this, HomeAnimation);
	
	        var _this = _possibleConstructorReturn(this, (HomeAnimation.__proto__ || Object.getPrototypeOf(HomeAnimation)).call(this, props));
	
	        _this.direction = 1;
	        _this.options = {
	            renderer: 'svg',
	            loop: true,
	            autoplay: true,
	            animationData: _superface2.default
	        };
	
	        _this.handleResize = _this.handleResize.bind(_this);
	        return _this;
	    }
	
	    _createClass(HomeAnimation, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.animation = _lottieWeb2.default.loadAnimation(Object.assign({}, this.options, { container: this.container }));
	            // this.animation.play()
	            window.addEventListener('resize', this.handleResize);
	            // window.addEventListener('mousemove', this.handleMove)
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            // window.removeEventListener('mousemove', this.handleMove)
	            this.animation.stop();
	        }
	    }, {
	        key: 'handleResize',
	        value: function handleResize() {
	            var _this2 = this;
	
	            if (this.timeout) clearTimeout(this.timeout);
	            this.timeout = setTimeout(function () {
	                _this2.setState({});
	            }, 200);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var style = { position: 'absolute', zIndex: 300, height: '100%', width: '100%' };
	            var animationStyle = {
	                transform: 'rotate(' + (window.innerWidth / window.innerHeight < 1 ? '-90' : '0') + 'deg)',
	                transformOrigin: 'center center',
	                width: '55%',
	                margin: 'auto'
	            };
	
	            return _react2.default.createElement(
	                _layout.Flex,
	                { align: 'center', style: style, id: 'home-animation' },
	                _react2.default.createElement(
	                    'div',
	                    { ref: this.props.setRef, style: { width: '100%' } },
	                    _react2.default.createElement('div', { style: animationStyle, ref: function ref(container) {
	                            _this3.container = container;
	                        } })
	                )
	            );
	        }
	    }]);
	
	    return HomeAnimation;
	}(_react2.default.Component);
	
	exports.default = HomeAnimation;

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _layout = __webpack_require__(15);
	
	var _SectionLink = __webpack_require__(254);
	
	var _SectionLink2 = _interopRequireDefault(_SectionLink);
	
	var _SectionLinkSoon = __webpack_require__(255);
	
	var _SectionLinkSoon2 = _interopRequireDefault(_SectionLinkSoon);
	
	var _Superface = __webpack_require__(7);
	
	var _Superface2 = _interopRequireDefault(_Superface);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Interface = function (_React$Component) {
	    _inherits(Interface, _React$Component);
	
	    function Interface(props) {
	        _classCallCheck(this, Interface);
	
	        var _this = _possibleConstructorReturn(this, (Interface.__proto__ || Object.getPrototypeOf(Interface)).call(this, props));
	
	        _this.state = {
	            lang: 0
	        };
	
	        _this.handleResize = _this.handleResize.bind(_this);
	        return _this;
	    }
	
	    _createClass(Interface, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            window.addEventListener('resize', this.handleResize);
	        }
	    }, {
	        key: 'componentWillUnmout',
	        value: function componentWillUnmout() {
	            if (this.timeoutMount) clearTimeout(this.timeoutMount);
	            window.removeEventListener('resize', this.handleResize);
	        }
	    }, {
	        key: 'handleResize',
	        value: function handleResize() {
	            this.setState({});
	        }
	    }, {
	        key: 'renderContact',
	        value: function renderContact() {
	            if (this.props.showContact) return _react2.default.createElement(Contact, null);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            if (!_Superface2.default.datas().contact) return _react2.default.createElement('span', null);
	
	            var windowRatio = window.innerWidth / window.innerHeight;
	
	            var style = {
	                width: 'calc(100% - 4rem)',
	                height: 'calc(100% - 4rem)',
	                position: 'absolute',
	                zIndex: 900,
	                padding: '2rem'
	            };
	
	            var widthLinkBottom = _Superface2.default.IS_MOBILE ? '100px' : '150px';
	
	            return _react2.default.createElement(
	                _layout.Flex,
	                { id: 'interface', direction: 'column', justify: 'space-between', style: style },
	                _react2.default.createElement(
	                    _layout.Flex,
	                    { style: { height: '33%' }, align: 'flex-start', justify: 'space-between' },
	                    _react2.default.createElement('div', { style: { width: '150px', textAlign: 'left' } }),
	                    _react2.default.createElement(
	                        _SectionLink2.default,
	                        {
	                            to: _Superface2.default.uri('contact'),
	                            align: 'center'
	                        },
	                        _Superface2.default.translate('Contact')
	                    ),
	                    _react2.default.createElement('div', { id: 'mail', style: { width: '150px' } })
	                ),
	                _react2.default.createElement(
	                    _layout.Flex,
	                    { style: { height: '33%' }, align: 'center', justify: 'space-between' },
	                    _react2.default.createElement(
	                        _SectionLink2.default,
	                        {
	                            to: _Superface2.default.uri('matieres'),
	                            align: windowRatio < 1 ? 'center' : 'left',
	                            rotate: windowRatio < 1 ? 'rotate(-90deg)' : 'rotate(0deg)',
	                            margin: windowRatio < 1 ? '0 0 0 -7rem' : 0
	                        },
	                        _Superface2.default.translate('Matières')
	                    ),
	                    _react2.default.createElement(
	                        _SectionLinkSoon2.default,
	                        {
	                            align: windowRatio < 1 ? 'center' : 'right',
	                            rotate: windowRatio < 1 ? 'rotate(90deg)' : 'rotate(0deg)',
	                            margin: windowRatio < 1 ? '0 -7rem 0 0' : 0
	                        },
	                        _Superface2.default.translate('Projets')
	                    )
	                ),
	                _react2.default.createElement(
	                    _layout.Flex,
	                    { style: { height: '33%' }, align: 'flex-end', justify: 'space-between' },
	                    _react2.default.createElement(
	                        'div',
	                        { id: 'languages', style: { width: widthLinkBottom, textAlign: 'left', cursor: 'pointer', color: 'white' } },
	                        _react2.default.createElement(
	                            'span',
	                            { style: { textDecoration: _Superface2.default.getLang() !== 'fr' ? 'none' : 'line-through' }, onClick: function onClick(e) {
	                                    _Superface2.default.setLang('fr');
	                                } },
	                            'Fr'
	                        ),
	                        '\xA0\xA0\xA0',
	                        _react2.default.createElement(
	                            'span',
	                            { style: { textDecoration: _Superface2.default.getLang() !== 'en' ? 'none' : 'line-through' }, onClick: function onClick(e) {
	                                    _Superface2.default.setLang('en');
	                                } },
	                            'En'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _SectionLink2.default,
	                        {
	                            to: _Superface2.default.uri('notre-metier'),
	                            align: 'center'
	                        },
	                        _Superface2.default.translate('Notre métier')
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { style: { width: widthLinkBottom, textAlign: 'right' } },
	                        _react2.default.createElement(
	                            'a',
	                            { className: 'icon', href: _Superface2.default.datas().contact.facebook, target: '_blank' },
	                            _react2.default.createElement('img', { src: __webpack_require__(483), alt: 'facebook' })
	                        ),
	                        _react2.default.createElement(
	                            'a',
	                            { className: 'icon', href: _Superface2.default.datas().contact.instagram, target: '_blank' },
	                            _react2.default.createElement('img', { src: __webpack_require__(492), alt: 'instagram' })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Interface;
	}(_react2.default.Component);
	
	exports.default = Interface;
	
	
	var Contact = function Contact(props) {
	    return _react2.default.createElement(
	        'a',
	        { style: { width: '1.5rem', height: '1.5rem', display: 'inline-block' }, href: 'mailto:mail@superface.fr' },
	        _react2.default.createElement('img', { src: __webpack_require__(493), alt: 'email' }),
	        ' '
	    );
	};

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Superface = __webpack_require__(7);
	
	var _Superface2 = _interopRequireDefault(_Superface);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Video = function (_React$Component) {
	    _inherits(Video, _React$Component);
	
	    function Video(props) {
	        _classCallCheck(this, Video);
	
	        var _this = _possibleConstructorReturn(this, (Video.__proto__ || Object.getPrototypeOf(Video)).call(this, props));
	
	        _this.handleResize = _this.handleResize.bind(_this);
	        return _this;
	    }
	
	    _createClass(Video, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            window.addEventListener('resize', this.handleResize);
	        }
	    }, {
	        key: 'handleResize',
	        value: function handleResize(e) {
	            var _this2 = this;
	
	            if (this.timer) clearTimeout(this.timer);
	            this.timer = setTimeout(function () {
	                _this2.setState({});
	            }, 200);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener('resize', this.handleResize);
	        }
	    }, {
	        key: 'renderVideo',
	        value: function renderVideo() {
	            var _this3 = this;
	
	            // console.log('render')
	            var ratio = !_Superface2.default.IS_MOBILE_OR_TABLET ? 1920 / 1080 : 1;
	            var windowRatio = window.innerWidth / window.innerHeight;
	
	            var videoStyle = {
	                objectFit: 'cover',
	                width: windowRatio > ratio ? '100%' : 'auto',
	                height: windowRatio < ratio ? '100%' : 'auto',
	                transform: 'scale(1)'
	            };
	            if (!_Superface2.default.IS_MOBILE_OR_TABLET) {
	                return _react2.default.createElement('video', { ref: function ref(el) {
	                        return _this3.video = el;
	                    }, type: 'video/mp4', style: videoStyle, muted: 'muted', src: this.props.src, loop: 'loop', autoPlay: 'autoplay', preload: 'auto' });
	            } else {
	                return _react2.default.createElement('img', { style: videoStyle, src: this.props.backupSrc });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            var style = {
	                position: 'absolute',
	                zIndex: 200,
	                width: '100%',
	                height: '100%',
	                left: '0%',
	                overflow: 'hidden'
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { ref: this.props.setRef, style: style },
	                _react2.default.createElement(
	                    'div',
	                    { id: 'home-video', style: style },
	                    this.renderVideo()
	                )
	            );
	        }
	    }]);
	
	    return Video;
	}(_react2.default.Component);
	
	exports.default = Video;

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _three = __webpack_require__(68);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _Superface = __webpack_require__(7);
	
	var _Superface2 = _interopRequireDefault(_Superface);
	
	var _kit = __webpack_require__(43);
	
	var _tween = __webpack_require__(92);
	
	var _tween2 = _interopRequireDefault(_tween);
	
	var _MapControls = __webpack_require__(154);
	
	var _MapControls2 = _interopRequireDefault(_MapControls);
	
	var _ZoomControls = __webpack_require__(148);
	
	var _ZoomControls2 = _interopRequireDefault(_ZoomControls);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CAMERA_Z_MAX = 160;
	var CAMERA_Z_MIN = 10;
	var CAMERA_Z = 20;
	
	var PLANE_SCALE_X = 5.3;
	var GRID_Z = 0;
	var GRID_GUTTER = 5;
	
	var MaterialsGrid = function (_React$Component) {
	    _inherits(MaterialsGrid, _React$Component);
	
	    function MaterialsGrid(props) {
	        _classCallCheck(this, MaterialsGrid);
	
	        var _this = _possibleConstructorReturn(this, (MaterialsGrid.__proto__ || Object.getPrototypeOf(MaterialsGrid)).call(this, props));
	
	        _this.mouse = { x: 0, y: 0 };
	        _this.planes = [];
	        _this.targetMesh = false;
	        _this.lastCameraX = 0;
	
	        _this.frame = 0;
	
	        _this.start = _this.start.bind(_this);
	        _this.stop = _this.stop.bind(_this);
	        _this.animate = _this.animate.bind(_this);
	        _this.handleResize = _this.handleResize.bind(_this);
	        // this.handleKeyDown = this.handleKeyDown.bind(this)
	        _this.onMouseDown = _this.onMouseDown.bind(_this);
	        _this.onMouseUp = _this.onMouseUp.bind(_this);
	        _this.handleMouseMove = _this.handleMouseMove.bind(_this);
	        _this.state = {};
	        return _this;
	    }
	
	    //
	    // ─── LIFE CYCLE ─────────────────────────────────────────────────────────────────
	    //
	
	    _createClass(MaterialsGrid, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	
	            this.initScene();
	
	            if (this.props.materialsImagesLoaded) {
	                this.loadImages(this.props.materials);
	            }
	            this.setState(Object.assign({}, this.state, { mounted: false, ready: false, leave: false
	            }));
	            this.start();
	        }
	
	        // shouldComponentUpdate(){
	        //     // return false
	        // }
	
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	
	            window.addEventListener('mousemove', this.handleMouseMove);
	            window.addEventListener('resize', this.handleResize);
	            window.addEventListener('keydown', this.handleKeyDown);
	
	            this.mount.appendChild(this.renderer.domElement);
	            this.mount.addEventListener('mousedown', this.onMouseDown);
	            this.mount.addEventListener('mouseup', this.onMouseUp);
	
	            this.setState(Object.assign({}, this.state, { mounted: true
	            }));
	
	            if (this.props.active) {
	                this.controls.activate();
	            } else {
	                this.controls.dispose();
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(new_props) {
	
	            // console.log(new_props.active)
	            // If fetching materials is done
	            if (new_props.materialsImagesLoaded && this.props.materialsImagesLoaded !== new_props.materialsImagesLoaded) {
	                this.loadImages(new_props.materials);
	            }
	
	            if (this.props.kindsFilters !== new_props.kindsFilters && !new_props.kindsFilters.isEmpty()) {
	                this.initPlanesAnimation();
	            }
	
	            if (new_props.active !== this.props.active) {
	                if (new_props.active) {
	                    this.controls.activate();
	                } else {
	                    this.controls.dispose();
	                }
	            }
	
	            if (new_props.isOnSingle !== this.props.isOnSingle) {
	                if (new_props.isOnSingle) {
	                    this.setState(Object.assign({}, this.state, { ready: false, leave: false }));
	                } else if (this.props.isOnSingle) {
	                    this.setState(Object.assign({}, this.state, { ready: true, leave: false }));
	                }
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.stop();
	            this.controls.dispose();
	            this.controls = null;
	            if (this.timeoutResize) window.clearTimeout(this.timeoutResize);
	            if (this.timeoutMount) clearTimeout(this.timeoutMount);
	            if (this.timeoutScroll) window.clearTimeout(this.timeoutScroll);
	            window.removeEventListener('mousemove', this.handleMouseMove);
	            window.removeEventListener('resize', this.handleResize);
	            this.mount.removeEventListener('mousedown', this.onMouseDown);
	            this.mount.removeEventListener('mouseup', this.onMouseUp);
	        }
	
	        //
	        // ─── INIT 3D ────────────────────────────────────────────────────────────────────
	        //
	
	    }, {
	        key: 'initScene',
	        value: function initScene() {
	            var _this2 = this;
	
	            // console.log('------ INIT SCENE --------------')
	            this.scene = new THREE.Scene();
	            this.scene.background = new THREE.Color(255, 255, 255);
	            this.camera = new THREE.PerspectiveCamera(35, window.innerWidth / window.innerHeight, 0.1, 1000);
	
	            this.camera.tweenEnter = new _tween.Tween({ value: 0 }).to({ value: 1 }, 1200).easing(_tween.Easing.Quadratic.Out).onUpdate(function (tween) {
	                _this2.camera.animProgress = tween.value;
	            }).onComplete(function (tween) {
	                tween.value = 0;
	            });
	
	            this.controls = this.setControls(this.camera);
	            this.renderer = new THREE.WebGLRenderer({ antialias: true });
	            this.renderer.setSize(window.innerWidth, window.innerHeight);
	        }
	    }, {
	        key: 'setControls',
	        value: function setControls(camera) {
	
	            var controls = new _MapControls2.default(camera);
	            // controls.zoomSpeed = 0.3;
	            controls.minDistance = CAMERA_Z_MIN;
	            controls.maxDistance = CAMERA_Z_MAX;
	
	            controls.dynamicDampingFactor = 0.2;
	            return controls;
	        }
	    }, {
	        key: 'initPlanesGroup',
	        value: function initPlanesGroup() {
	            var _this3 = this;
	
	            this.planeGroup = new THREE.Object3D();
	            this.planeGroup.lastPos = { x: this.planeGroup.position.x, y: this.planeGroup.position.y, z: 0 };
	            this.planeGroup.tween = new _tween.Tween({ value: 0 }).to({ value: 1 }, 400).easing(_tween.Easing.Quadratic.InOut).onUpdate(function (tween) {
	                _this3.planeGroup.animProgress = tween.value;
	            }).onComplete(function (tween) {
	                tween.value = 0;
	            });
	        }
	
	        // initPlanesGroupAnimation(){
	        //     // console.log('init group animation')
	        //     this.planeGroup.shouldAnim = true
	        //     this.planeGroup.tween.start()
	        // }
	
	    }, {
	        key: 'loadImages',
	        value: function loadImages(materials) {
	            var _this4 = this;
	
	            this.planes = [];
	            this.imagesLoaded = 0;
	            this.imagesToLoad = 0;
	
	            this.initPlanesGroup();
	            _Superface2.default.setLoading(true);
	            materials.forEach(function (matiere, i) {
	
	                // console.log( i + ' : ' + matiere.slug + ' : ' +  matiere.image.thumb_path )
	                var path = _Superface2.default.assetUrl(matiere.image.thumb_path);
	
	                if (path != undefined) {
	
	                    _this4.imagesToLoad += 1;
	                    var texture = new THREE.TextureLoader().load(path, function (texture) {
	
	                        _this4.imagesLoaded += 1;
	                        texture.anisotropy = _this4.renderer.getMaxAnisotropy();
	                        var planeMaterial = new THREE.MeshBasicMaterial({ map: texture, transparent: path.includes('.png') });
	                        var geometry = new THREE.PlaneGeometry(1, 1);
	                        var plane = new THREE.Mesh(geometry, planeMaterial);
	
	                        plane.ratio = texture.image.width / texture.image.height;
	                        // plane.targetScale = { x : PLANE_SCALE_X, y : PLANE_SCALE_X / plane.ratio }
	                        plane.targetScale = { x: PLANE_SCALE_X, y: PLANE_SCALE_X / plane.ratio
	
	                            // plane.scale.x = PLANE_SCALE_X
	                            // plane.scale.y = PLANE_SCALE_X
	                        };plane.scale.x = plane.targetScale.x;
	                        plane.scale.y = plane.targetScale.y;
	
	                        plane.slug = matiere.slug;
	                        var kind = _Superface2.default.getMaterialKindById(matiere.material_kind._id);
	                        // console.log( matiere.material_kind )
	                        plane.name = {
	                            fr: kind.name,
	                            en: kind.name_en
	                        };
	                        plane.linkSlug = kind.slug;
	                        plane.imagePath = matiere.image.path;
	                        plane.tween = new _tween.Tween({ value: 0 }).to({ value: 1 }, 400).easing(_tween.Easing.Cubic.InOut).onUpdate(function (tween) {
	                            plane.animProgress = tween.value;
	                        }).onComplete(function (tween) {
	                            tween.value = 0;
	                        });
	
	                        plane.lastScale = plane.targetScale;
	
	                        _this4.planeGroup.add(plane);
	
	                        _this4.planes[i] = plane;
	                        if (_this4.imagesLoaded === Math.round(_this4.imagesLoaded / 2)) {
	                            _Superface2.default.setloadProgress(0.6);
	                        }
	                        // console.log( i + ' : ' + this.imagesLoaded + '/' + this.imagesToLoad )
	
	                        if (_this4.imagesLoaded >= _this4.imagesToLoad) {
	
	                            if (!_Superface2.default.IS_MOBILE_OR_TABLET) {
	
	                                _this4.timeoutMount = setTimeout(function () {
	
	                                    // this.camera.lastPos = this.camera.position
	                                    // this.initCameraAnimation()
	                                    _this4.materialsReady();
	                                }, 1400);
	                            } else {
	                                _this4.camera.position.setZ(CAMERA_Z);
	                                _this4.materialsReady();
	                            }
	                        }
	                    });
	                }
	            });
	        }
	    }, {
	        key: 'initCameraAnimation',
	        value: function initCameraAnimation() {
	            this.controls.enabled = false;
	            this.camera.shouldAnim = true;
	            // this.camera.tweenEnter.start()
	        }
	
	        // setInitialCameraPosition(){
	        //     this.
	        // }
	
	        // setGridPositions(){
	
	        //     let window_ratio = window.innerWidth / window.innerHeight
	        //     let frames_count = this.planes.length
	        //     let n_col_square = Math.ceil( Math.sqrt( this.planes.length ) )
	
	        //     const ROW_LENGTH =  Math.ceil( n_col_square / window_ratio )
	        //     const COL_LENGTH =  this.planes.length / ROW_LENGTH
	
	        //     let index = 0
	
	        //     for( var j = 0; j < ROW_LENGTH + 1; j++ ){
	        //         for( var i = 0; i < COL_LENGTH - 1; i ++){
	        //             if( this.planes[index] ){
	
	        //                 this.planes[index].gridPos = {
	        //                     x : i * ( PLANE_SCALE_X + GRID_GUTTER ) + ( 0.5 - Math.random()) * PLANE_SCALE_X ,
	        //                     y : - j * ( PLANE_SCALE_X + GRID_GUTTER ) + ( 0.5 - Math.random()) * PLANE_SCALE_X ,
	        //                     z : GRID_Z - Math.random() * 20
	        //                 }
	
	        //                 this.planes[index].position.setX( this.planes[index].gridPos.x )
	        //                 this.planes[index].position.setY( this.planes[index].gridPos.y )
	        //                 this.planes[index].position.setZ( this.planes[index].gridPos.z )
	        //                 // this.planes[index].lastPos = this.planes[index].gridPos
	
	        //             }
	        //             index += 1
	        //         }
	        //     }
	
	        //     // const plane_scaleX = this.planes[0].scale.x
	        //     const frame_height = PLANE_SCALE_X + GRID_GUTTER
	        //     const limitPanX = frame_height * ( COL_LENGTH - 1 ) / 2 - GRID_GUTTER * 0.5
	        //     const limitPanY = frame_height * ( ROW_LENGTH + 1 ) / 2 - GRID_GUTTER * 0.5
	
	        //     this.controls.minPanX = - limitPanX
	        //     this.controls.maxPanX = limitPanX
	        //     this.controls.minPanY = - limitPanY
	        //     this.controls.maxPanY = limitPanY
	
	        //     this.planeGroup.gridPos = {
	        //         x : - limitPanX,
	        //         y : limitPanY,
	        //         z : 0
	        //     }
	
	        // }
	
	    }, {
	        key: 'setGridPositions',
	        value: function setGridPositions() {
	
	            var window_ratio = window.innerWidth / window.innerHeight;
	            var n_col_square = Math.round(Math.sqrt(this.planes.length));
	
	            var COL_LENGTH = Math.floor(n_col_square * window_ratio);
	            var row_num = 0;
	            var col_num = 0;
	
	            this.planes.forEach(function (plane, i) {
	
	                if (col_num == COL_LENGTH) {
	                    col_num = 0;
	                    row_num += 1;
	                }
	
	                plane.gridPos = {
	                    x: col_num * (PLANE_SCALE_X + GRID_GUTTER) + (0.5 - Math.random()) * PLANE_SCALE_X,
	                    y: -row_num * (PLANE_SCALE_X + GRID_GUTTER) + (0.5 - Math.random()) * PLANE_SCALE_X,
	                    z: GRID_Z - Math.random() * 20
	
	                    // plane.gridPos = {
	                    //     x : col_num * ( PLANE_SCALE_X + GRID_GUTTER ) ,
	                    //     y : - row_num * ( PLANE_SCALE_X + GRID_GUTTER ) ,
	                    //     z : GRID_Z
	                    // }
	
	                    // if( setPosition ){
	                };plane.position.setX(plane.gridPos.x);
	                plane.position.setY(plane.gridPos.y);
	                plane.position.setZ(plane.gridPos.z);
	                plane.lastPos = plane.position;
	                // }
	                col_num += 1;
	            });
	
	            var frame_height = PLANE_SCALE_X + GRID_GUTTER;
	            var limitPanX = frame_height * COL_LENGTH / 2 - GRID_GUTTER;
	            var limitPanY = frame_height * row_num / 2;
	
	            var margin = 8;
	            this.controls.minPanX = -limitPanX - margin;
	            this.controls.maxPanX = limitPanX + margin;
	            this.controls.minPanY = -limitPanY - margin;
	            this.controls.maxPanY = limitPanY + margin;
	
	            this.planeGroup.gridPos = {
	                x: -limitPanX,
	                y: limitPanY,
	                z: 0
	            };
	        }
	    }, {
	        key: 'setTargetScale',
	        value: function setTargetScale() {
	            this.planes.forEach(function (plane, i) {
	                // if( i === this.currentTimelineProjectIndex && this.mode === TIMELINE ){
	
	                //     plane.targetScale = {
	                //         x : PLANE_SCALE_X * MAGNIFICATION,
	                //         y : ( PLANE_SCALE_X * MAGNIFICATION ) / plane.ratio
	                //     }
	                // }else{
	                if (plane.targetScale.x !== PLANE_SCALE_X) {
	                    plane.targetScale = {
	                        x: PLANE_SCALE_X,
	                        y: PLANE_SCALE_X / plane.ratio
	                    };
	                }
	                // }
	            });
	        }
	    }, {
	        key: 'materialsReady',
	        value: function materialsReady() {
	            this.camera.position.setZ(CAMERA_Z);
	            this.scene.add(this.planeGroup);
	            this.setTargetScale();
	            this.setGridPositions();
	            this.planeGroup.position.x = this.planeGroup.gridPos.x;
	            this.planeGroup.position.y = this.planeGroup.gridPos.y;
	
	            _Superface2.default.setLoading(false);
	            this.setState(Object.assign({}, this.state, { ready: true
	            }));
	        }
	    }, {
	        key: 'initPlanesAnimation',
	        value: function initPlanesAnimation() {
	            var mounting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	
	            this.planes.forEach(function (plane, i) {
	                plane.shouldAnim = true;
	            });
	        }
	    }, {
	        key: 'handleResize',
	        value: function handleResize() {
	            this.camera.aspect = window.innerWidth / window.innerHeight;
	            this.camera.updateProjectionMatrix();
	            this.renderer.setSize(window.innerWidth, window.innerHeight);
	            this.sceneDimension = this.project(window.innerWidth, window.innerHeight);
	            this.setGridPositions();
	            this.planeGroup.position.x = this.planeGroup.gridPos.x;
	            this.planeGroup.position.y = this.planeGroup.gridPos.y;
	        }
	    }, {
	        key: 'onMouseDown',
	        value: function onMouseDown(e) {
	
	            this.mouseDownTime = new Date();
	
	            if (this.planes.length === this.props.materials.length) {
	
	                var intersect = this.checkBrowserMouseIntersection(this.mouse.x, this.mouse.y, this.planes);
	
	                if (!intersect || intersect[0] === undefined) return;
	                var obj = intersect.first().object;
	                this.targetMesh = obj;
	            }
	        }
	    }, {
	        key: 'onMouseUp',
	        value: function onMouseUp(e) {
	            var _this5 = this;
	
	            if (!this.targetMesh) return;
	
	            var now = new Date();
	            var timeDif = (now.getTime() - this.mouseDownTime.getTime()) / 1000;
	            var shortClick = timeDif < 0.3 ? true : false;
	
	            if (shortClick && this.targetMesh.slug !== undefined) {
	
	                var active = false;
	                this.props.kindsFilters.forEach(function (kind) {
	                    if (kind.slug === _this5.targetMesh.linkSlug && kind.active) {
	                        active = true;
	                    }
	                });
	                if (!active) return;
	
	                _Superface2.default.setCursor('default');
	                this.controls.dispose();
	                _Superface2.default.setKindFeaturedImagePath(this.targetMesh.imagePath);
	                this.setState(Object.assign({}, this.state, { leave: true
	                }));
	
	                _Superface2.default.mapLeaving(true);
	                this.timeoutLeave = setTimeout(function () {
	                    _Superface2.default.mapLeaving(false);
	                    _Superface2.default.goTo(_Superface2.default.uri('matieres') + '/' + _this5.targetMesh.linkSlug);
	                    _this5.targetMesh = null;
	                }, 400);
	            }
	        }
	    }, {
	        key: 'handleMouseMove',
	        value: function handleMouseMove(e) {
	            if (!this.planes || !this.scene.children.length || this.props.isOnSingle || !this.state.ready) return;
	
	            this.mouse.x = e.pageX;
	            this.mouse.y = e.pageY;
	
	            if (this.planes.length === this.props.materials.length) {
	                var intersect = this.checkBrowserMouseIntersection(e.pageX, e.pageY, this.planes);
	                if (intersect || intersect[0] !== undefined) {
	                    var plane = intersect.first().object;
	
	                    var active = false;
	                    this.props.kindsFilters.forEach(function (kind) {
	                        if (kind.slug === plane.linkSlug && kind.active) {
	                            active = true;
	                        }
	                    });
	                    if (!active) return;
	
	                    _Superface2.default.setKindTitle(plane.name[_Superface2.default.app().lang]);
	                    _Superface2.default.setCursor('pointer');
	                    document.getElementById('kind-title').style.opacity = 1;
	                } else {
	                    if (_Superface2.default.app().cursor !== 'default') {
	                        _Superface2.default.setCursor('default');
	                        document.getElementById('kind-title').style.opacity = 0;
	                    }
	                }
	            }
	        }
	
	        //
	        // ─── ANIMATE ────────────────────────────────────────────────────────────────────
	        //
	
	    }, {
	        key: 'start',
	        value: function start() {
	            if (!this.frameId) this.frameId = requestAnimationFrame(this.animate);
	        }
	    }, {
	        key: 'stop',
	        value: function stop() {
	            cancelAnimationFrame(this.frameId);
	        }
	    }, {
	        key: 'moveObject',
	        value: function moveObject(obj, target_coord, deceleration) {
	            // console.log(target_coord)
	            var offset = {
	                x: target_coord.x - obj.lastPos.x,
	                y: target_coord.y - obj.lastPos.y,
	                z: target_coord.z - obj.lastPos.z
	            };
	            var Z = obj.lastPos.z + offset.z * deceleration;
	            var X = obj.lastPos.x + offset.x * deceleration;
	            var Y = obj.lastPos.y + offset.y * deceleration;
	
	            obj.position.x = X;
	            obj.position.y = Y;
	            obj.position.z = Z;
	        }
	    }, {
	        key: 'animate',
	        value: function animate() {
	            var _this6 = this;
	
	            if (this.props.isOnSingle) return this.frameId = window.requestAnimationFrame(this.animate);
	
	            if (this.controls && this.controls.enabled) this.controls.update();
	
	            if (this.planes && this.planeGroup) {
	                // console.log( this.camera.position.x, this.camera.position.y )
	                if (this.planes.length === this.props.materials.length) {
	
	                    this.planes.forEach(function (plane, i) {
	                        if (plane.shouldAnim) {
	
	                            var active = false;
	                            _this6.props.kindsFilters.forEach(function (kind) {
	                                if (kind.slug === plane.linkSlug && kind.active) {
	                                    active = true;
	                                }
	                            });
	
	                            if (!active) {
	                                _this6.planeGroup.remove(plane);
	                            } else {
	                                _this6.planeGroup.add(plane);
	                            }
	
	                            plane.shouldAnim = false;
	                        }
	                    });
	                }
	            }
	
	            this.lastCameraX = this.camera.position.x;
	            this.renderer.render(this.scene, this.camera);
	            this.frameId = window.requestAnimationFrame(this.animate);
	        }
	    }, {
	        key: 'project',
	        value: function project(x, y, targetZ) {
	            var vector = new THREE.Vector3();
	
	            vector.set(x / window.innerWidth * 2 - 1, -(y / window.innerHeight) * 2 + 1, 0.5);
	
	            vector.unproject(this.camera);
	
	            var dir = vector.sub(this.camera.position).normalize();
	
	            var distance = ((targetZ ? targetZ : 0) - this.camera.position.z) / dir.z;
	
	            var pos = this.camera.position.clone().add(dir.multiplyScalar(distance));
	            return pos;
	        }
	    }, {
	        key: 'checkBrowserMouseIntersection',
	        value: function checkBrowserMouseIntersection(mouseX, mouseY, threeObject) {
	
	            if (!this.camera || !this.renderer || !this.scene) return false;
	
	            if (!this.raycaster) this.raycaster = new THREE.Raycaster();
	
	            var mouse = {
	                x: mouseX / this.renderer.domElement.clientWidth * 2 - 1,
	                y: -(mouseY / this.renderer.domElement.clientHeight) * 2 + 1
	            };
	            var intersects = void 0;
	            this.raycaster.setFromCamera(mouse, this.camera);
	            if (threeObject && (threeObject instanceof Array || threeObject === this.scene.children)) {
	                intersects = this.raycaster.intersectObjects(threeObject);
	            } else if (threeObject) {
	                intersects = this.raycaster.intersectObject(threeObject);
	            }
	            return intersects.length ? intersects : false;
	        }
	    }, {
	        key: 'renderControls',
	        value: function renderControls() {
	            var _this7 = this;
	
	            if (!this.props.isOnSingle) {
	                return _react2.default.createElement(_ZoomControls2.default, { onClickPlus: function onClickPlus() {
	                        _this7.controls.zoomPlus();
	                    }, onClickMinus: function onClickMinus() {
	                        _this7.controls.zoomMinus();
	                    } });
	            } else {
	                return _react2.default.createElement('span', null);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this8 = this;
	
	            var margin = _Superface2.default.IS_MOBILE_OR_TABLET ? '2rem' : '2rem';
	
	            return _react2.default.createElement(
	                'div',
	                { className: (this.state.ready ? 'map-loaded ' : '') + (this.state.leave ? 'map-leave' : '') },
	                _react2.default.createElement('div', {
	                    id: 'three-map-container',
	                    style: { width: '100%', height: '100%' },
	                    ref: function ref(mount) {
	                        _this8.mount = mount;
	                    }
	                }),
	                _react2.default.createElement(
	                    'div',
	                    { style: { position: 'absolute', bottom: margin, right: margin, zIndex: 400 } },
	                    this.renderControls()
	                )
	            );
	        }
	    }]);
	
	    return MaterialsGrid;
	}(_react2.default.Component);
	
	exports.default = MaterialsGrid;

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Superface = __webpack_require__(7);
	
	var _Superface2 = _interopRequireDefault(_Superface);
	
	var _reactRouterDom = __webpack_require__(40);
	
	var _Single2 = __webpack_require__(141);
	
	var _Single3 = _interopRequireDefault(_Single2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MaterialsKind = function (_Single) {
	    _inherits(MaterialsKind, _Single);
	
	    function MaterialsKind(props) {
	        _classCallCheck(this, MaterialsKind);
	
	        var _this = _possibleConstructorReturn(this, (MaterialsKind.__proto__ || Object.getPrototypeOf(MaterialsKind)).call(this, props));
	
	        _this._type = 'kind';
	        return _this;
	    }
	
	    _createClass(MaterialsKind, [{
	        key: 'renderFeaturedImage',
	        value: function renderFeaturedImage(kind) {
	            if (!_Superface2.default.IS_MOBILE_OR_TABLET) {
	
	                var path = void 0;
	
	                if (this.props.featuredImage !== '') {
	                    path = _Superface2.default.assetUrl(this.props.featuredImage);
	                } else {
	                    path = _Superface2.default.assetUrl(kind.featured_image.path);
	                }
	
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'single-featured-container', style: { width: '50%', overflow: 'hidden', position: 'relative' } },
	                    _react2.default.createElement('img', { src: path, alt: _Superface2.default.field(this._single, 'name') })
	                );
	            }
	        }
	    }, {
	        key: 'goToSingle',
	        value: function goToSingle(single) {
	            this.setState(Object.assign({}, this.state, { leaving: true, mounted: false }));
	            this.timeoutChange = setTimeout(function () {
	                // console.log('@goToSingle')
	                _Superface2.default.setKindFeaturedImagePath('');
	                _Superface2.default.goTo(_Superface2.default.uri('matieres') + '/' + single.slug);
	            }, 500);
	        }
	    }]);
	
	    return MaterialsKind;
	}(_Single3.default);
	
	exports.default = (0, _reactRouterDom.withRouter)(MaterialsKind);

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(40);
	
	var _Single2 = __webpack_require__(141);
	
	var _Single3 = _interopRequireDefault(_Single2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Project = function (_Single) {
	    _inherits(Project, _Single);
	
	    function Project(props) {
	        _classCallCheck(this, Project);
	
	        var _this = _possibleConstructorReturn(this, (Project.__proto__ || Object.getPrototypeOf(Project)).call(this, props));
	
	        _this._type = 'projet';
	        return _this;
	    }
	
	    return Project;
	}(_Single3.default);
	
	exports.default = (0, _reactRouterDom.withRouter)(Project);

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ScrollTracker = __webpack_require__(72);
	
	var _ScrollTracker2 = _interopRequireDefault(_ScrollTracker);
	
	var _three = __webpack_require__(68);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _tween = __webpack_require__(92);
	
	var _tween2 = _interopRequireDefault(_tween);
	
	var _MapControls = __webpack_require__(154);
	
	var _MapControls2 = _interopRequireDefault(_MapControls);
	
	var _ZoomControls = __webpack_require__(148);
	
	var _ZoomControls2 = _interopRequireDefault(_ZoomControls);
	
	var _Superface = __webpack_require__(7);
	
	var _Superface2 = _interopRequireDefault(_Superface);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import Superface from '../Superface'
	
	
	var CAMERA_Z_MAX = 120;
	var CAMERA_Z_MIN = 5;
	var CAMERA_Z = 80;
	
	var PLANE_SCALE_X = 5.4;
	
	var MAGNIFICATION = 1.8;
	var TWEEN_DURATION = 600;
	
	// const SCROLL_INTERVAL = 200
	
	var TIMELINE_Z = 20;
	var TIMELINE_GUTTER = 1.2;
	var GRID_Z = 0;
	var GRID_GUTTER = 8;
	
	var AREAS = 'secteur';
	var TIMELINE = 'timeline';
	
	var ProjectsGrid = function (_React$Component) {
	    _inherits(ProjectsGrid, _React$Component);
	
	    function ProjectsGrid(props) {
	        _classCallCheck(this, ProjectsGrid);
	
	        var _this = _possibleConstructorReturn(this, (ProjectsGrid.__proto__ || Object.getPrototypeOf(ProjectsGrid)).call(this, props));
	
	        _this.mouse = { x: 0, y: 0 };
	        _this.planes = [];
	        _this.targetMesh = false;
	
	        _this.start = _this.start.bind(_this);
	        _this.stop = _this.stop.bind(_this);
	        _this.animate = _this.animate.bind(_this);
	        _this.handleResize = _this.handleResize.bind(_this);
	        _this.handleKeyDown = _this.handleKeyDown.bind(_this);
	        _this.onMouseDown = _this.onMouseDown.bind(_this);
	        _this.onMouseUp = _this.onMouseUp.bind(_this);
	        _this.handleMouseMove = _this.handleMouseMove.bind(_this);
	        _this.handleScroll = _this.handleScroll.bind(_this);
	        _this.handleScrollEnd = _this.handleScrollEnd.bind(_this);
	        _this.state = {
	            ready: false,
	            mounted: false
	        };
	        return _this;
	    }
	
	    //
	    // ─── LIFE CYCLE ─────────────────────────────────────────────────────────────────
	    //
	
	    _createClass(ProjectsGrid, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	
	            _Superface2.default.setProjectsViewMode(TIMELINE);
	            this.initScene();
	            this.currentProjectIndex = 0;
	
	            this.scroll = new _ScrollTracker2.default();
	
	            if (this.props.projects.length > 0) {
	                this.loadImages(this.props.projects);
	            }
	            MAGNIFICATION = window.innerHeight / 325;
	            this.setState(Object.assign({}, this.state, { mounted: false, ready: false, leave: false
	            }));
	            this.start();
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	
	            window.addEventListener('resize', this.handleResize);
	            window.addEventListener('keydown', this.handleKeyDown);
	
	            this.mount.appendChild(this.renderer.domElement);
	            window.addEventListener('mousemove', this.handleMouseMove);
	            this.mount.addEventListener('mousedown', this.onMouseDown);
	            this.mount.addEventListener('mouseup', this.onMouseUp);
	
	            this.setState(Object.assign({}, this.state, { mounted: true
	            }));
	
	            if (this.props.active) {
	                this.controls.activate();
	            } else {
	                this.controls.dispose();
	            }
	        }
	    }, {
	        key: 'activateScroll',
	        value: function activateScroll() {
	            this.scroll.start();
	            this.scroll.on('scroll', this.handleScroll);
	            // this.scroll.on( 'scrollend', this.handleScrollEnd )
	        }
	    }, {
	        key: 'disposeScroll',
	        value: function disposeScroll() {
	            this.scroll.stop();
	            // this.scroll.off( 'scrollend', this.handleScrollEnd )
	            this.scroll.off('scroll', this.handleScroll);
	        }
	    }, {
	        key: 'handleScrollEnd',
	        value: function handleScrollEnd() {
	            if (this.props.isOnSingle) return;
	            this.isScrolling = false;
	            if (this.props.mode !== TIMELINE) return;
	            this.scroll.reset();
	            if (this.planeGroup.shouldAnim) return;
	            this.setTargetScale(TIMELINE);
	            this.setTimelinePositions();
	            this.initPlanesAnimation(false, TIMELINE);
	            this.initPlanesGroupAnimation(TIMELINE);
	        }
	    }, {
	        key: 'handleScroll',
	        value: function handleScroll(e) {
	            if (this.props.isOnSingle) return;
	            this.isScrolling = true;
	            var step = 180;
	            var scaleFactor = 0.0065;
	
	            var lastIndex = this.currentProjectIndex;
	            if (this.props.mode !== TIMELINE) return;
	            if (this.planeGroup.shouldAnim) return;
	
	            if (e.deltaY > 0 && this.planes[this.currentProjectIndex + 1]) {
	                this.planeGroup.position.x -= e.deltaY * 0.01;
	                var plane = this.planes[this.currentProjectIndex + 1];
	                var currentPlane = this.planes[this.currentProjectIndex];
	                plane.scale.x += e.deltaY * scaleFactor;
	                plane.scale.y = plane.scale.x / plane.ratio;
	                currentPlane.scale.x -= e.deltaY * scaleFactor;
	                currentPlane.scale.y = currentPlane.scale.x / currentPlane.ratio;
	            }
	            if (e.deltaY < 0 && this.planes[this.currentProjectIndex - 1]) {
	                this.planeGroup.position.x -= e.deltaY * 0.01;
	                var _plane = this.planes[this.currentProjectIndex - 1];
	                var _currentPlane = this.planes[this.currentProjectIndex];
	                _plane.scale.x -= e.deltaY * scaleFactor;
	                _plane.scale.y = _plane.scale.x / _plane.ratio;
	                _currentPlane.scale.x += e.deltaY * scaleFactor;
	                _currentPlane.scale.y = _currentPlane.scale.x / _currentPlane.ratio;
	            }
	
	            if (e.y > step) {
	                this.scroll.reset();
	                // this.currentProjectIndex += 1
	                // if( this.currentProjectIndex > this.props.projects.length - 1 ){
	                //     this.currentProjectIndex = this.props.projects.length - 1
	                //     return
	                // } 
	                this.increaseProjectIndex();
	            }
	            if (e.y < -step) {
	                this.scroll.reset();
	                this.decreaseProjectIndex();
	                // this.currentProjectIndex -= 1
	                // if( this.currentProjectIndex < 0 ){
	                //     this.currentProjectIndex = 0
	                //     return
	                // }
	            }
	            if (lastIndex !== this.currentProjectIndex) {
	                _Superface2.default.setCurrentTimelineProjectIndex(this.currentProjectIndex);
	                this.setTargetScale(TIMELINE);
	                this.setTimelinePositions();
	                this.initPlanesAnimation(false, TIMELINE);
	                this.initPlanesGroupAnimation(TIMELINE);
	            }
	            console.log('current Index : ' + this.currentProjectIndex);
	        }
	    }, {
	        key: 'handleKeyDown',
	        value: function handleKeyDown(e) {
	            // console.log(e.keyCode)
	            // if( e.keyCode === 32 ) this.stop()
	
	            if (this.props.mode !== TIMELINE) return;
	            if (this.planeGroup.shouldAnim) return;
	
	            e = e || window.event;
	
	            if (e.keyCode === 37) {
	                // left arrow
	                console.log('37');
	                this.decreaseProjectIndex();
	            } else if (e.keyCode === 39) {
	                // right
	                console.log('39');
	                this.increaseProjectIndex();
	            }
	            _Superface2.default.setCurrentTimelineProjectIndex(this.currentProjectIndex);
	            // Superface.setProjectsDate( this.planes[this.currentProjectIndex].date )
	            // console.log( this.currentProjectIndex )
	            this.setTargetScale(TIMELINE);
	            this.setTimelinePositions();
	            this.initPlanesAnimation(false, TIMELINE);
	            this.initPlanesGroupAnimation(TIMELINE);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(new_props) {
	
	            if (new_props.active !== this.props.active) {
	                if (new_props.active) {
	                    this.controls.activate();
	                } else {
	                    this.controls.dispose();
	                }
	            }
	
	            if (new_props.projects.length !== this.props.projects.length && new_props.projects.length > 0) {
	                this.loadImages(new_props.projects);
	            }
	
	            if (new_props.mode !== this.props.mode && this.props.mounted) {
	
	                this.setTargetScale(new_props.mode);
	                this.setTimelinePositions();
	                this.initPlanesAnimation(false);
	                this.initCameraAnimation();
	                this.initPlanesGroupAnimation();
	
	                if (new_props.mode === TIMELINE) {
	                    _Superface2.default.resetFilters('projet');
	                    this.activateScroll();
	                } else {
	                    this.controls.activate();
	                    this.controls.enabled = true;
	                    this.disposeScroll();
	                }
	            }
	
	            if (this.props.areasFilters !== new_props.areasFilters && !new_props.areasFilters.isEmpty()) {
	                this.initPlanesFiltering();
	            }
	
	            if (new_props.isOnSingle !== this.props.isOnSingle) {
	                if (new_props.isOnSingle) {
	                    this.setState(Object.assign({}, this.state, { ready: false, leave: false }));
	                } else if (this.props.isOnSingle) {
	                    this.setState(Object.assign({}, this.state, { ready: true, leave: false }));
	                }
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.stop();
	            this.controls.dispose();
	            this.controls = null;
	            if (this.timeoutResize) window.clearTimeout(this.timeoutResize);
	            if (this.timeoutMousePos) window.clearTimeout(this.timeoutMousePos);
	            if (this.timeoutScroll) window.clearTimeout(this.timeoutScroll);
	            window.removeEventListener('mousemove', this.handleMouseMove);
	            window.removeEventListener('resize', this.handleResize);
	            this.mount.removeEventListener('mousedown', this.onMouseDown);
	            this.mount.removeEventListener('mouseup', this.onMouseUp);
	        }
	
	        //
	        // ─── INIT 3D ────────────────────────────────────────────────────────────────────
	        //
	
	    }, {
	        key: 'initScene',
	        value: function initScene() {
	            var _this2 = this;
	
	            this.scene = new THREE.Scene();
	            this.scene.background = new THREE.Color(255, 255, 255);
	            this.camera = new THREE.PerspectiveCamera(35, window.innerWidth / window.innerHeight, 0.1, 1000);
	            this.camera.position.z = CAMERA_Z;
	            this.camera.tween = new _tween.Tween({ value: 0 }).to({ value: 1 }, TWEEN_DURATION * 2.1).easing(_tween.Easing.Quadratic.InOut).onUpdate(function (tween) {
	                _this2.camera.animProgress = tween.value;
	            }).onComplete(function (tween) {
	                tween.value = 0;
	            });
	
	            this.camera.tweenTL = new _tween.Tween({ value: 0 }).to({ value: 1 }, TWEEN_DURATION / 1.6).easing(_tween.Easing.Quadratic.InOut).onUpdate(function (tween) {
	                _this2.camera.animProgress = tween.value;
	            }).onComplete(function (tween) {
	                tween.value = 0;
	            });
	
	            this.controls = this.setControls(this.camera);
	            this.renderer = new THREE.WebGLRenderer({ antialias: true });
	            this.renderer.setSize(window.innerWidth, window.innerHeight);
	        }
	    }, {
	        key: 'setControls',
	        value: function setControls(camera) {
	
	            var controls = new _MapControls2.default(camera);
	            controls.minDistance = CAMERA_Z_MIN;
	            controls.maxDistance = CAMERA_Z_MAX;
	            controls.dynamicDampingFactor = 0.2;
	            return controls;
	        }
	    }, {
	        key: 'initPlanesGroup',
	        value: function initPlanesGroup() {
	            var _this3 = this;
	
	            this.planeGroup = new THREE.Object3D();
	            this.planeGroup.lastPos = { x: 0, y: 0, z: 0 };
	
	            this.planeGroup.tween = new _tween.Tween({ value: 0 }).to({ value: 1 }, TWEEN_DURATION * 2.1).easing(_tween.Easing.Quadratic.InOut).onUpdate(function (tween) {
	                _this3.planeGroup.animProgress = tween.value;
	            }).onComplete(function (tween) {
	                tween.value = 0;
	            });
	
	            this.planeGroup.tweenTL = new _tween.Tween({ value: 0 }).to({ value: 1 }, TWEEN_DURATION / 1.6).easing(_tween.Easing.Quadratic.InOut).onUpdate(function (tween) {
	                _this3.planeGroup.animProgress = tween.value;
	            }).onComplete(function (tween) {
	                tween.value = 0;
	            });
	
	            this.planeGroup.tweenTLQuick = new _tween.Tween({ value: 0 }).to({ value: 1 }, 200)
	            // .easing( Easing.Linear )
	            .onUpdate(function (tween) {
	                _this3.planeGroup.animProgress = tween.value;
	            }).onComplete(function (tween) {
	                tween.value = 0;
	            });
	        }
	    }, {
	        key: 'loadImages',
	        value: function loadImages(projects) {
	            var _this4 = this;
	
	            this.planes = [];
	            this.imagesLoaded = 0;
	            this.imagesToLoad = 0;
	
	            this.initPlanesGroup();
	            _Superface2.default.setLoading(true);
	            projects.forEach(function (project, i) {
	
	                // console.log( i + ' : ' + matiere.slug + ' : ' +  Superface.assetUrl(matiere.image.thumb_path) )
	                var path = _Superface2.default.assetUrl(project.thumb.path);
	
	                if (path != undefined && project.activity_area._id) {
	
	                    _this4.imagesToLoad += 1;
	                    var texture = new THREE.TextureLoader().load(path, function (texture) {
	                        // console.log( i + ' of ' + ( projects.length - 1 ) )
	                        _this4.imagesLoaded += 1;
	                        texture.anisotropy = _this4.renderer.getMaxAnisotropy();
	                        var planeMaterial = new THREE.MeshBasicMaterial({ map: texture });
	                        var geometry = new THREE.PlaneGeometry(1, 1);
	                        var plane = new THREE.Mesh(geometry, planeMaterial);
	
	                        plane.ratio = texture.image.width / texture.image.height;
	                        plane.targetScale = { x: PLANE_SCALE_X, y: PLANE_SCALE_X / plane.ratio };
	
	                        plane.scale.x = plane.targetScale.x;
	                        plane.scale.y = plane.targetScale.y;
	
	                        plane.slug = project.slug;
	                        plane.date = project.date.split('-')[0];
	
	                        plane.isClickable = plane.medias !== undefined;
	                        var area = _Superface2.default.getProjectAreaById(project.activity_area._id);
	                        plane.name = _Superface2.default.field(area, 'name');
	                        plane.hasSingle = _Superface2.default.projectHasSingle(project);
	                        plane.linkSlug = project.slug;
	                        plane.area = area.slug;
	                        plane.date = project.date;
	                        plane.projectIndex = i;
	
	                        plane.tween = new _tween.Tween({ value: 0 }).to({ value: 1 }, TWEEN_DURATION * 2.1).easing(_tween.Easing.Cubic.InOut).onUpdate(function (tween) {
	                            plane.animProgress = tween.value;
	                        }).onComplete(function (tween) {
	                            tween.value = 0;
	                        });
	
	                        plane.tweenTL = new _tween.Tween({ value: 0 }).to({ value: 1 }, TWEEN_DURATION / 1.6).easing(_tween.Easing.Cubic.InOut).onUpdate(function (tween) {
	                            plane.animProgress = tween.value;
	                        }).onComplete(function (tween) {
	                            tween.value = 0;
	                        });
	
	                        plane.tweenTLQuick = new _tween.Tween({ value: 0 }).to({ value: 1 }, 200)
	                        // .easing( Easing.Linear )
	                        .onUpdate(function (tween) {
	                            plane.animProgress = tween.value;
	                        }).onComplete(function (tween) {
	                            tween.value = 0;
	                        });
	
	                        plane.lastScale = plane.targetScale;
	
	                        _this4.planeGroup.add(plane);
	
	                        _this4.planes[i] = plane;
	
	                        // if( this.imagesLoaded === Math.round(this.imagesToLoad / 2 ) ){
	                        //     // Superface.setloadProgress('inc')
	                        // }
	                        // console.log(this.imagesLoaded + '/' + this.imagesToLoad )
	                        if (_this4.imagesLoaded >= _this4.imagesToLoad) {
	                            // console.log(this.imagesLoaded + '/' + this.imagesToLoad )
	                            if (!_Superface2.default.IS_MOBILE_OR_TABLET) {
	
	                                _this4.timeoutMount = setTimeout(function () {
	                                    _this4.projectsReady();
	                                }, 1200);
	                            } else {
	
	                                _this4.projectsReady();
	                            }
	                        }
	                    });
	                }
	            });
	        }
	    }, {
	        key: 'setGridPositions',
	        value: function setGridPositions() {
	            var setPosition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	
	            var window_ratio = window.innerWidth / window.innerHeight;
	            var n_col_square = Math.ceil(Math.sqrt(this.planes.length));
	
	            var COL_LENGTH = Math.ceil(n_col_square * window_ratio) - 2;
	            var row_num = 0;
	            var col_num = 0;
	
	            this.planes.forEach(function (plane, i) {
	
	                if (col_num >= COL_LENGTH) {
	                    col_num = 0;
	                    row_num += 1;
	                    // console.log( '# ---- new row ----#' )
	                }
	
	                plane.gridPos = {
	                    x: col_num * (PLANE_SCALE_X + GRID_GUTTER) + (0.5 - Math.random()) * PLANE_SCALE_X,
	                    y: -row_num * (PLANE_SCALE_X + GRID_GUTTER) + (0.5 - Math.random()) * PLANE_SCALE_X,
	                    z: GRID_Z - Math.random() * 20
	                };
	
	                if (setPosition) {
	                    plane.position.setX(plane.gridPos.x);
	                    plane.position.setY(plane.gridPos.y);
	                    plane.position.setZ(plane.gridPos.z);
	                    plane.lastPos = plane.position;
	                }
	                col_num += 1;
	            });
	
	            var frame_height = PLANE_SCALE_X + GRID_GUTTER;
	            var limitPanX = frame_height * (COL_LENGTH - 1) / 2 - GRID_GUTTER * 0.5;
	            var limitPanY = frame_height * row_num / 2 - GRID_GUTTER * 0.5;
	
	            this.controls.minPanX = -limitPanX - 5;
	            this.controls.maxPanX = limitPanX + 5;
	            this.controls.minPanY = -limitPanY - 5;
	            this.controls.maxPanY = limitPanY + 5;
	
	            this.planeGroup.gridPos = {
	                x: -limitPanX,
	                y: limitPanY,
	                z: 0
	            };
	        }
	    }, {
	        key: 'setTimelinePositions',
	        value: function setTimelinePositions() {
	            var _this5 = this;
	
	            var setPosition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	
	            this.planes.forEach(function (plane, i) {
	
	                var baseX = 0;
	                if (i !== 0) {
	                    baseX = _this5.planes[i - 1].timelinePos.x;
	                    baseX += _this5.planes[i - 1].targetScale.x / 2;
	                }
	                baseX += plane.targetScale.x / 2;
	
	                plane.timelinePos = {
	                    x: baseX + TIMELINE_GUTTER,
	                    y: 0,
	                    z: TIMELINE_Z
	                };
	                if (setPosition) {
	                    plane.position.setX(plane.timelinePos.x);
	                    plane.position.setY(plane.timelinePos.y);
	                    plane.position.setZ(plane.timelinePos.z);
	                    plane.lastPos = plane.position;
	                }
	            });
	
	            this.planeGroup.timelinePos = {
	                x: -this.planes[this.currentProjectIndex].timelinePos.x,
	                y: 0,
	                z: 0
	            };
	        }
	    }, {
	        key: 'setTargetScale',
	        value: function setTargetScale(mode, setScale) {
	            var _this6 = this;
	
	            this.planes.forEach(function (plane, i) {
	                if (i === _this6.currentProjectIndex && mode === TIMELINE) {
	
	                    plane.targetScale = {
	                        x: PLANE_SCALE_X * MAGNIFICATION,
	                        y: PLANE_SCALE_X * MAGNIFICATION / plane.ratio
	                    };
	                } else {
	                    if (plane.targetScale.x !== PLANE_SCALE_X) {
	                        plane.targetScale = {
	                            x: PLANE_SCALE_X,
	                            y: PLANE_SCALE_X / plane.ratio
	                        };
	                    }
	                }
	                if (setScale) {
	                    plane.scale.setX(plane.targetScale.x);
	                    plane.scale.setY(plane.targetScale.y);
	                }
	            });
	        }
	    }, {
	        key: 'projectsReady',
	        value: function projectsReady() {
	
	            _Superface2.default.setLoading(false);
	            this.camera.position.setZ(CAMERA_Z);
	            this.camera.lastPos = this.camera.position;
	            this.scene.add(this.planeGroup);
	            this.setTargetScale(this.props.mode, true);
	            this.setGridPositions(_Superface2.default.IS_MOBILE ? true : false);
	            this.setTimelinePositions(!_Superface2.default.IS_MOBILE ? true : false);
	            if (this.props.mode === TIMELINE) {
	                this.planeGroup.position.x = this.planeGroup.timelinePos.x;
	                this.planeGroup.position.y = this.planeGroup.timelinePos.y;
	            } else {
	                this.planeGroup.position.x = this.planeGroup.gridPos.x;
	                this.planeGroup.position.y = this.planeGroup.gridPos.y;
	            }
	            this.planeGroup.lastPos = this.planeGroup.position;
	
	            this.activateScroll();
	            this.setState(Object.assign({}, this.state, { ready: true
	            }));
	        }
	    }, {
	        key: 'initCameraAnimation',
	        value: function initCameraAnimation() {
	            var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : AREAS;
	
	            this.controls.enabled = false;
	            this.controls.dispose();
	            this.camera.shouldAnim = true;
	            if (mode === TIMELINE) {
	                this.camera.tweenTL.start();
	            } else {
	                this.camera.tween.start();
	            }
	        }
	    }, {
	        key: 'initPlanesAnimation',
	        value: function initPlanesAnimation() {
	            var mounting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	            var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : AREAS;
	            var fromMouse = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	
	            this.souldAnimPlanes = true;
	
	            this.planes.forEach(function (plane, i) {
	                plane.shouldAnim = true;
	                if (mode === TIMELINE && !fromMouse) plane.tweenTL.start();else if (mode === TIMELINE) {
	                    plane.tweenTLQuick.start();
	                } else {
	                    plane.tween.start();
	                }
	            });
	        }
	    }, {
	        key: 'initPlanesFiltering',
	        value: function initPlanesFiltering() {
	            this.planes.forEach(function (plane, i) {
	                plane.shouldFilter = true;
	            });
	        }
	    }, {
	        key: 'initPlanesGroupAnimation',
	        value: function initPlanesGroupAnimation() {
	            var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : AREAS;
	            var fromMouse = arguments[1];
	
	            this.planeGroup.shouldAnim = true;
	            if (mode === TIMELINE && !fromMouse) this.planeGroup.tweenTL.start();else if (mode === TIMELINE) {
	                this.planeGroup.tweenTLQuick.start();
	            } else {
	                this.planeGroup.tween.start();
	            }
	        }
	    }, {
	        key: 'handleResize',
	        value: function handleResize() {
	            MAGNIFICATION = window.innerHeight / 285;
	            this.camera.aspect = window.innerWidth / window.innerHeight;
	            this.camera.updateProjectionMatrix();
	            // this.controls.handleResize()
	            this.renderer.setSize(window.innerWidth, window.innerHeight);
	            this.sceneDimension = this.project(window.innerWidth, window.innerHeight);
	            this.setGridPositions();
	            this.setTimelinePositions();
	            // if( this.timeoutResize ) window.clearTimeout( this.timeoutResize )
	            // this.timeoutResize = window.setTimeout( this.handleResize , 100)
	        }
	    }, {
	        key: 'onMouseDown',
	        value: function onMouseDown(e) {
	            // alert('coucou')
	            this.mouseDownTime = new Date();
	            if (this.planes.length === this.props.projects.length) {
	                var intersect = this.checkBrowserMouseIntersection(this.mouse.x, this.mouse.y, this.planes);
	
	                // console.log(intersect)
	                if (!intersect || intersect[0] === undefined) return;
	                var obj = intersect.first().object;
	                this.targetMesh = obj;
	            }
	        }
	    }, {
	        key: 'onMouseUp',
	        value: function onMouseUp(e) {
	            var _this7 = this;
	
	            if (!this.targetMesh) return;
	
	            var now = new Date();
	            var timeDif = (now.getTime() - this.mouseDownTime.getTime()) / 1000;
	            var shortClick = timeDif < 0.3 ? true : false;
	
	            if (shortClick && this.targetMesh.slug !== undefined) {
	                if (this.targetMesh.hasSingle) {
	                    this.controls.dispose();
	                    _Superface2.default.setCursor('default');
	                    this.setState(Object.assign({}, this.state, { leave: true
	                    }));
	                    _Superface2.default.mapLeaving(true);
	                    this.timeoutLeave = setTimeout(function () {
	                        _Superface2.default.mapLeaving(false);
	                        // Superface.goTo( Superface.uri('matieres') + '/' + this.targetMesh.linkSlug )
	                        _Superface2.default.goTo(_Superface2.default.uri('projets') + '/' + _this7.targetMesh.linkSlug);
	                        _this7.targetMesh = null;
	                    }, 400);
	                }
	                // this.targetMesh = null
	            }
	        }
	    }, {
	        key: 'handleMouseMove',
	        value: function handleMouseMove(e) {
	            if (!this.planes || !this.scene.children.length || this.props.isOnSingle || !this.state.ready) return;
	
	            this.mouse.x = e.pageX;
	            this.mouse.y = e.pageY;
	
	            if (this.planes.length === this.props.projects.length) {
	                var intersect = this.checkBrowserMouseIntersection(e.pageX, e.pageY, this.planes);
	                if (intersect || intersect[0] !== undefined) {
	                    var plane = intersect.first().object;
	
	                    var active = false;
	                    this.props.areasFilters.forEach(function (area) {
	                        if (area.slug === plane.area && area.active) {
	                            active = true;
	                        }
	                    });
	                    if (!active) return;
	
	                    if (this.props.mode !== TIMELINE) {
	                        if (this._projectNameFollow) this._projectNameFollow.style.display = 'block';
	                        this.currentProjectIndex = plane.projectIndex;
	                    }
	                    _Superface2.default.setCursor('pointer');
	                } else {
	                    if (this._projectNameFollow) this._projectNameFollow.style.display = 'none';
	                    if (_Superface2.default.app().cursor !== 'default') _Superface2.default.setCursor('default');
	                }
	            }
	
	            if (this.props.mode !== TIMELINE && this._projectNameFollow) {
	                this._projectNameFollow.style.left = e.pageX + 20 + 'px';
	                this._projectNameFollow.style.top = e.pageY - 20 + 'px';
	            }
	        }
	    }, {
	        key: 'increaseProjectIndex',
	        value: function increaseProjectIndex() {
	            this.currentProjectIndex += 1;
	            if (this.currentProjectIndex > this.props.projects.length - 1) this.currentProjectIndex = this.props.projects.length - 1;
	        }
	    }, {
	        key: 'decreaseProjectIndex',
	        value: function decreaseProjectIndex() {
	            this.currentProjectIndex -= 1;
	            if (this.currentProjectIndex < 0) this.currentProjectIndex = 0;
	        }
	
	        //
	        // ─── ANIMATE ────────────────────────────────────────────────────────────────────
	        //
	
	    }, {
	        key: 'start',
	        value: function start() {
	            if (!this.frameId) this.frameId = requestAnimationFrame(this.animate);
	        }
	    }, {
	        key: 'stop',
	        value: function stop() {
	            cancelAnimationFrame(this.frameId);
	        }
	    }, {
	        key: 'moveObject',
	        value: function moveObject(obj, target_coord, deceleration) {
	
	            var offset = {
	                x: target_coord.x - obj.lastPos.x,
	                y: target_coord.y - obj.lastPos.y,
	                z: target_coord.z - obj.lastPos.z
	            };
	
	            var Z = obj.lastPos.z + offset.z * deceleration * 0.8;
	            var X = obj.lastPos.x + offset.x * deceleration * 0.8;
	            var Y = obj.lastPos.y + offset.y * deceleration * 0.8;
	
	            // console.log('plane ' + this.planes.indexOf(obj) + ' : ', X, Y, Z)
	
	            obj.position.x = X;
	            obj.position.y = Y;
	            obj.position.z = Z;
	        }
	    }, {
	        key: 'scaleObject',
	        value: function scaleObject(obj, target_scale, deceleration) {
	
	            var offset = {
	                x: target_scale.x - obj.lastScale.x,
	                y: target_scale.y - obj.lastScale.y
	            };
	
	            var Y = obj.lastScale.y + offset.y * deceleration;
	            var X = obj.lastScale.x + offset.x * deceleration;
	
	            obj.scale.x = X;
	            obj.scale.y = Y;
	        }
	    }, {
	        key: 'animate',
	        value: function animate() {
	            var _this8 = this;
	
	            if (this.props.isOnSingle) return this.frameId = window.requestAnimationFrame(this.animate);
	
	            if (this.controls && this.controls.enabled) this.controls.update();
	
	            if (this.planes && this.planeGroup) {
	
	                if (this.planes.length === this.props.projects.length) {
	
	                    _tween2.default.update();
	
	                    if (this.camera.shouldAnim) {
	
	                        var progress = this.camera.animProgress;
	                        if (progress !== 1) {
	                            var targetCoord = {
	                                x: 0,
	                                y: 0,
	                                z: this.props.mode === TIMELINE ? CAMERA_Z : 20
	                                // console.log('move camera to : ', targetCoord)
	                            };this.moveObject(this.camera, targetCoord, progress);
	                        } else {
	                            // console.log(this.camera.position)
	                            this.camera.tween.stop();
	                            this.camera.tweenTL.stop();
	                            // console.log('-----------------------------')
	                            this.camera.shouldAnim = false;
	                            _Superface2.default.canDoIt = true;
	                            if (this.props.mode !== TIMELINE) {
	                                this.controls.activate();
	                                this.controls.enabled = true;
	                            }
	                        }
	                    }
	
	                    this.planes.forEach(function (plane, i) {
	                        if (plane.shouldAnim) {
	                            // console.log( plane )
	
	                            var _progress = plane.animProgress;
	
	                            if (_progress !== 1) {
	                                var targetCoord;
	                                if (_this8.props.mode === TIMELINE) {
	
	                                    targetCoord = {
	                                        x: plane.timelinePos.x,
	                                        y: plane.timelinePos.y,
	                                        z: plane.timelinePos.z
	                                    };
	                                } else {
	
	                                    targetCoord = {
	                                        x: plane.gridPos.x,
	                                        y: plane.gridPos.y,
	                                        z: plane.gridPos.z
	                                    };
	                                }
	
	                                _this8.moveObject(plane, targetCoord, _progress);
	                                _this8.scaleObject(plane, plane.targetScale, _progress);
	                            } else {
	                                plane.shouldAnim = false;
	                                // plane.tween.stop()
	                                // plane.tweenTL.stop()
	                            }
	                        }
	                    });
	
	                    this.planes.forEach(function (plane, i) {
	
	                        if (plane.shouldFilter) {
	                            var active = false;
	                            _this8.props.areasFilters.forEach(function (area) {
	                                if (area.slug === plane.area && area.active) {
	                                    active = true;
	                                }
	                            });
	                            if (active) {
	                                _this8.planeGroup.add(plane);
	                            } else {
	                                _this8.planeGroup.remove(plane);
	                            }
	                            plane.shouldFilter = false;
	                        }
	
	                        plane.lastScale = {
	                            x: plane.scale.x,
	                            y: plane.scale.y
	                        };
	
	                        plane.lastPos = {
	                            x: plane.position.x,
	                            y: plane.position.y,
	                            z: plane.position.z
	                        };
	                    });
	
	                    //
	                    // GROUP ANIM
	                    //
	
	                    if (this.planeGroup.shouldAnim) {
	
	                        var _progress2 = this.planeGroup.animProgress;
	
	                        if (_progress2 !== 1) {
	
	                            // console.log( this.props.mode )
	
	                            var _targetCoord = {
	                                x: this.props.mode === TIMELINE ? this.planeGroup.timelinePos.x : this.planeGroup.gridPos.x,
	                                y: this.props.mode === TIMELINE ? this.planeGroup.timelinePos.y : this.planeGroup.gridPos.y,
	                                z: this.props.mode === TIMELINE ? this.planeGroup.timelinePos.z : this.planeGroup.gridPos.z
	                                // console.log('move group to : ', targetCoord)
	                            };this.moveObject(this.planeGroup, _targetCoord, _progress2);
	                        } else {
	                            this.planeGroup.shouldAnim = false;
	                            // this.planeGroup.tween.stop()
	                            // this.planeGroup.tweenTL.stop()
	
	                            this.planeGroup.lastPos = {
	                                x: this.planeGroup.position.x,
	                                y: this.planeGroup.position.y,
	                                z: this.planeGroup.position.z
	                            };
	                        }
	                    }
	                }
	
	                this.planeGroup.lastPos = this.planeGroup.position;
	                this.camera.lastPos = this.camera.position;
	            }
	
	            // this.lastCameraX = this.camera.position.x
	            this.renderer.render(this.scene, this.camera);
	
	            // if( this.planeGroup ){
	
	            //     if( this.planeGroup.shouldAnim ||
	            //         this.camera.shouldAnim ||
	            //         this.isScrolling ||
	            //         this.souldAnimPlanes || 
	            //         this.controls._state !== -1
	            //     ){
	            //         this.shouldRender = true
	            //     }else{
	            //         this.shouldRender = false
	            //     }
	            //     console.log(' --> this.shouldRender : ' + this.shouldRender )
	            // }
	
	            this.frameId = window.requestAnimationFrame(this.animate);
	        }
	    }, {
	        key: 'project',
	        value: function project(x, y, targetZ) {
	            var vector = new THREE.Vector3();
	
	            vector.set(x / window.innerWidth * 2 - 1, -(y / window.innerHeight) * 2 + 1, 0.5);
	
	            vector.unproject(this.camera);
	
	            var dir = vector.sub(this.camera.position).normalize();
	
	            var distance = ((targetZ ? targetZ : 0) - this.camera.position.z) / dir.z;
	            // var distance = ((targetZ || 0) - this.camera.position.z) / dir.z;
	
	            var pos = this.camera.position.clone().add(dir.multiplyScalar(distance));
	            return pos;
	        }
	    }, {
	        key: 'checkBrowserMouseIntersection',
	        value: function checkBrowserMouseIntersection(mouseX, mouseY, threeObject) {
	
	            if (!this.camera || !this.renderer || !this.scene) return false;
	
	            if (!this.raycaster) this.raycaster = new THREE.Raycaster();
	
	            var mouse = {
	                x: mouseX / this.renderer.domElement.clientWidth * 2 - 1,
	                y: -(mouseY / this.renderer.domElement.clientHeight) * 2 + 1
	            };
	            var intersects = void 0;
	            this.raycaster.setFromCamera(mouse, this.camera);
	            if (threeObject && (threeObject instanceof Array || threeObject === this.scene.children)) {
	                intersects = this.raycaster.intersectObjects(threeObject);
	            } else if (threeObject) {
	                intersects = this.raycaster.intersectObject(threeObject);
	            }
	            return intersects.length ? intersects : false;
	        }
	    }, {
	        key: 'renderControls',
	        value: function renderControls() {
	            var _this9 = this;
	
	            if (this.props.mode !== TIMELINE && !this.props.isOnSingle) {
	                return _react2.default.createElement(_ZoomControls2.default, { onClickPlus: function onClickPlus() {
	                        _this9.controls.zoomPlus();
	                    }, onClickMinus: function onClickMinus() {
	                        _this9.controls.zoomMinus();
	                    } });
	            } else {
	                return _react2.default.createElement('span', null);
	            }
	        }
	    }, {
	        key: 'renderProjectsArrows',
	        value: function renderProjectsArrows() {
	            var _this10 = this;
	
	            if (this.props.projects.length === 0 || this.props.mode !== TIMELINE || _Superface2.default.IS_MOBILE) return;
	
	            return _react2.default.createElement(
	                'div',
	                { style: { position: 'fixed', bottom: '4rem', textAlign: 'center', zIndex: 400, width: '100%', display: 'flex', justifyContent: 'space-between' } },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'arrow timeline-arrow', style: { marginLeft: '20vh' }, onClick: function onClick() {
	                            _this10.onArrowClick('left');
	                        } },
	                    _react2.default.createElement('img', { style: { opacity: this.props.currentTimeLineProjectIndex == 0 ? 0 : 1 }, src: __webpack_require__(123), alt: 'arrow' })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'arrow timeline-arrow', style: { marginRight: '20vh' }, onClick: function onClick() {
	                            _this10.onArrowClick('right');
	                        } },
	                    _react2.default.createElement('img', { style: { opacity: this.props.currentTimeLineProjectIndex == this.props.projects.length - 1 ? 0 : 1 }, src: __webpack_require__(124), alt: 'arrow' })
	                )
	            );
	        }
	    }, {
	        key: 'onArrowClick',
	        value: function onArrowClick(direction) {
	
	            if (direction === 'left') {
	                this.decreaseProjectIndex();
	            } else {
	                this.increaseProjectIndex();
	            }
	            _Superface2.default.setCurrentTimelineProjectIndex(this.currentProjectIndex);
	            this.setTargetScale(TIMELINE);
	            this.setTimelinePositions();
	            this.initPlanesAnimation(false, TIMELINE);
	            this.initPlanesGroupAnimation(TIMELINE);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this11 = this;
	
	            var margin = _Superface2.default.IS_MOBILE_OR_TABLET ? '2rem' : '2rem';
	
	            return _react2.default.createElement(
	                'div',
	                { className: (this.state.ready ? 'map-loaded ' : '') + (this.state.leave ? 'map-leave' : ''), style: { width: '100%', height: '100%', backgroundColor: 'white' } },
	                _react2.default.createElement('div', {
	                    id: 'three-map-container',
	                    style: { width: '100%', height: '100%' },
	                    ref: function ref(mount) {
	                        _this11.mount = mount;
	                    }
	                }),
	                _react2.default.createElement(
	                    'div',
	                    { style: { position: 'absolute', bottom: margin, right: margin, zIndex: 400 } },
	                    this.renderControls()
	                ),
	                this.renderProjectNameFollowMouse(),
	                this.renderProjectsArrows()
	            );
	        }
	    }, {
	        key: 'renderProjectNameFollowMouse',
	        value: function renderProjectNameFollowMouse() {
	            var _this12 = this;
	
	            if (this.props.projects.length === 0 || this.props.mode === TIMELINE || _Superface2.default.IS_MOBILE || this.props.isOnSingle) return;
	
	            return _react2.default.createElement(
	                'div',
	                { ref: function ref(el) {
	                        return _this12._projectNameFollow = el;
	                    }, className: 'projects-name-follow', style: { position: 'absolute', zIndex: 400 } },
	                _Superface2.default.field(this.props.projects[this.currentProjectIndex], 'name')
	            );
	        }
	    }]);
	
	    return ProjectsGrid;
	}(_react2.default.Component);
	
	exports.default = ProjectsGrid;

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Superface = __webpack_require__(7);
	
	var _Superface2 = _interopRequireDefault(_Superface);
	
	var _layout = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FooterSingle = function (_React$Component) {
	    _inherits(FooterSingle, _React$Component);
	
	    function FooterSingle() {
	        _classCallCheck(this, FooterSingle);
	
	        return _possibleConstructorReturn(this, (FooterSingle.__proto__ || Object.getPrototypeOf(FooterSingle)).apply(this, arguments));
	    }
	
	    _createClass(FooterSingle, [{
	        key: 'shareByMail',
	        value: function shareByMail() {
	            window.location = 'mailto:?subject=' + _Superface2.default.translate('Superface') + '&body=' + _Superface2.default.getCurrentUrl();
	        }
	    }, {
	        key: 'renderSocialFollowText',
	        value: function renderSocialFollowText() {
	            if (!_Superface2.default.IS_MOBILE) {
	                return _react2.default.createElement(
	                    'span',
	                    null,
	                    _Superface2.default.translate('Suivez-nous sur : ')
	                );
	            }
	        }
	    }, {
	        key: 'renderShare',
	        value: function renderShare() {
	            var _this2 = this;
	
	            if (!_Superface2.default.IS_MOBILE) {
	                var page_url = _Superface2.default.getCurrentUrl();
	                return _react2.default.createElement(
	                    'div',
	                    { style: { borderTop: '1px solid black', height: '4rem' } },
	                    _react2.default.createElement(
	                        _layout.Flex,
	                        { justify: 'space-between', style: { paddingLeft: '2rem', paddingRight: '3rem' } },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'footer-link' },
	                            _react2.default.createElement(
	                                'a',
	                                { href: '#', onMouseDown: function onMouseDown() {
	                                        _this2.shareByMail();
	                                    } },
	                                _Superface2.default.translate('Partager par mail')
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'footer-link' },
	                            _react2.default.createElement(
	                                'a',
	                                { target: '_blank', href: 'http://www.facebook.com/sharer.php?u=' + page_url, title: 'Partager sur Facebook' },
	                                _Superface2.default.translate('Partager sur Facebook')
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'footer-link' },
	                            _react2.default.createElement(
	                                'a',
	                                { target: '_blank', href: 'https://twitter.com/share?url=' + page_url + '&text=', title: 'Partager sur Twitter' },
	                                _Superface2.default.translate('Partager sur Twitter')
	                            )
	                        )
	                    )
	                );
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                this.renderShare(),
	                _react2.default.createElement(
	                    'div',
	                    { style: { borderTop: '1px solid black', height: '4rem', paddingBottom: _Superface2.default.IS_MOBILE_OR_TABLET ? '30px' : 0 } },
	                    _react2.default.createElement(
	                        _layout.Flex,
	                        { justify: 'space-between', style: { paddingLeft: '2rem', paddingRight: '3rem' } },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'footer-link' },
	                            _react2.default.createElement(
	                                'span',
	                                { onClick: function onClick() {
	                                        _Superface2.default.goTo(_Superface2.default.uri('notre-metier'));
	                                    } },
	                                _Superface2.default.translate('Notre métier')
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'footer-link' },
	                            _react2.default.createElement(
	                                'span',
	                                { onClick: function onClick() {
	                                        _Superface2.default.goTo(_Superface2.default.uri('contact'));
	                                    } },
	                                _Superface2.default.translate('Contact')
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _layout.Flex,
	                            { align: 'center', justify: 'center', className: 'footer-link' },
	                            this.renderSocialFollowText(),
	                            _react2.default.createElement(
	                                'a',
	                                { className: 'icon', href: _Superface2.default.datas().contact.facebook, target: '_blank' },
	                                _react2.default.createElement('img', { src: __webpack_require__(64), alt: 'facebook' })
	                            ),
	                            _react2.default.createElement(
	                                'a',
	                                { className: 'icon', href: _Superface2.default.datas().contact.instagram, target: '_blank' },
	                                _react2.default.createElement('img', { src: __webpack_require__(65), alt: 'instagram' })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return FooterSingle;
	}(_react2.default.Component);
	
	exports.default = FooterSingle;

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Superface = __webpack_require__(7);
	
	var _Superface2 = _interopRequireDefault(_Superface);
	
	var _swiper = __webpack_require__(134);
	
	var _swiper2 = _interopRequireDefault(_swiper);
	
	var _kit = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GalleryLarge = function (_React$Component) {
	    _inherits(GalleryLarge, _React$Component);
	
	    function GalleryLarge() {
	        _classCallCheck(this, GalleryLarge);
	
	        return _possibleConstructorReturn(this, (GalleryLarge.__proto__ || Object.getPrototypeOf(GalleryLarge)).apply(this, arguments));
	    }
	
	    _createClass(GalleryLarge, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.images_loaded = 0;
	            this.setState({
	                loaded: false
	            });
	        }
	    }, {
	        key: 'initSlider',
	        value: function initSlider() {
	            var _this2 = this;
	
	            if (this.swiper) return;
	
	            (0, _kit.addClass)(this.slider, 'slider-' + this.props.i);
	            var params = {
	                speed: 400,
	                loop: true,
	                initialSlide: 0,
	                loopAdditionalSlides: this.props.slides.length,
	                loopedSlides: this.props.slides.length,
	                slidesPerView: 'auto'
	            };
	
	            setTimeout(function () {
	                _this2.swiper = new _swiper2.default('.slider-' + _this2.props.i, params);
	            }, 500);
	
	            // mySwiper.on('slideChange', function () {
	
	            // })
	        }
	    }, {
	        key: 'renderMedias',
	        value: function renderMedias(slides) {
	            var _this3 = this;
	
	            return slides.map(function (slide, i) {
	                // console.log('PATH ' + slide.path)
	                // console.log('MODIFIED PATH ' + Superface.assetUrl(slide.path))
	                return _react2.default.createElement(
	                    'div',
	                    { key: i, className: 'swiper-slide' },
	                    _react2.default.createElement('img', { alt: 'materials', src: _Superface2.default.assetUrl(slide.path), onLoad: function onLoad() {
	                            _this3.images_loaded++;
	                            // console.log( this.images_loaded + '/' + this.props.slides.length )
	                            if (_this3.images_loaded === _this3.props.slides.length) {
	                                _this3.setState({ loaded: true });
	                                _this3.initSlider();
	                            }
	                        } })
	                );
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { style: { display: 'block', padding: '17rem 0 0', backgroundColor: 'white', position: 'relative', width: '120vw' } },
	                _react2.default.createElement(
	                    'div',
	                    { style: { position: 'absolute', left: '10vw', top: '17rem', width: '20vw', bottom: '0', backgroundColor: 'white', zIndex: 20 } },
	                    _react2.default.createElement(
	                        'div',
	                        { style: { display: 'flex', alignItems: 'center', height: '100%', paddingLeft: '10vw' } },
	                        _react2.default.createElement(
	                            'div',
	                            {
	                                onClick: function onClick() {
	                                    _this4.swiper.slidePrev();
	                                },
	                                className: 'arrow' },
	                            _react2.default.createElement('img', { src: __webpack_require__(123), alt: 'arrow' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            {
	                                onClick: function onClick() {
	                                    _this4.swiper.slideNext();
	                                },
	                                className: 'arrow' },
	                            _react2.default.createElement('img', { src: __webpack_require__(124), alt: 'arrow' })
	                        )
	                    )
	                ),
	                _react2.default.createElement('div', { style: { position: 'absolute', left: '30vw', top: 'calc(17rem - 10vh)', right: '30vw', bottom: '-10vh', border: '10vh solid white', pointerEvents: 'none', zIndex: 20 } }),
	                _react2.default.createElement(
	                    'div',
	                    { ref: function ref(slider) {
	                            return _this4.slider = slider;
	                        }, className: 'swiper-container swiper-large' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'swiper-wrapper' },
	                        this.renderMedias(this.props.slides)
	                    )
	                )
	            );
	        }
	    }]);
	
	    return GalleryLarge;
	}(_react2.default.Component);
	
	exports.default = GalleryLarge;

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Overline = __webpack_require__(42);
	
	var _Overline2 = _interopRequireDefault(_Overline);
	
	var _Superface = __webpack_require__(7);
	
	var _Superface2 = _interopRequireDefault(_Superface);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SectionLink = function (_React$Component) {
	    _inherits(SectionLink, _React$Component);
	
	    function SectionLink() {
	        _classCallCheck(this, SectionLink);
	
	        return _possibleConstructorReturn(this, (SectionLink.__proto__ || Object.getPrototypeOf(SectionLink)).apply(this, arguments));
	    }
	
	    _createClass(SectionLink, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.setState({
	                mount: false
	            });
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            this.timeoutMount = setTimeout(function () {
	                _this2.setState(Object.assign({}, _this2.state, { mount: true }));
	            }, 50);
	        }
	    }, {
	        key: 'componentWillUnmout',
	        value: function componentWillUnmout() {
	            if (this.timeoutMount) clearTimeout(this.timeoutMount);
	            // window.removeEventListener('resize', this.handleResize)
	        }
	    }, {
	        key: 'handleClick',
	        value: function handleClick() {
	            if (this.props.toggleMenu !== undefined) this.props.toggleMenu();
	            _Superface2.default.goTo(this.props.to);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var props = this.props;
	
	            var containerStyle = {
	                // width:'150px', 
	                transformOrigin: 'center center',
	                transform: props.rotate || 'none',
	                padding: '0.3rem',
	                fontSize: '0.9rem',
	                position: 'relative',
	                textAlign: props.align,
	                margin: props.margin,
	                width: '150px'
	            };
	
	            return _react2.default.createElement(
	                'a',
	                { onClick: function onClick(e) {
	                        _this3.handleClick();
	                    }, className: "nav-item overline-link section-link " + this.props.identifier, style: containerStyle },
	                _react2.default.createElement(
	                    _Overline2.default,
	                    null,
	                    props.children
	                )
	            );
	        }
	    }]);
	
	    return SectionLink;
	}(_react2.default.Component);
	
	exports.default = SectionLink;

/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Overline = __webpack_require__(42);
	
	var _Overline2 = _interopRequireDefault(_Overline);
	
	var _Superface = __webpack_require__(7);
	
	var _Superface2 = _interopRequireDefault(_Superface);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SectionLink = function (_React$Component) {
	    _inherits(SectionLink, _React$Component);
	
	    function SectionLink() {
	        _classCallCheck(this, SectionLink);
	
	        return _possibleConstructorReturn(this, (SectionLink.__proto__ || Object.getPrototypeOf(SectionLink)).apply(this, arguments));
	    }
	
	    _createClass(SectionLink, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.setState({
	                mount: false
	            });
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            this.timeoutMount = setTimeout(function () {
	                _this2.setState(Object.assign({}, _this2.state, { mount: true }));
	            }, 50);
	        }
	    }, {
	        key: 'componentWillUnmout',
	        value: function componentWillUnmout() {
	            if (this.timeoutMount) clearTimeout(this.timeoutMount);
	            // window.removeEventListener('resize', this.handleResize)
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            var props = this.props;
	
	            var containerStyle = {
	                // width:'150px', 
	                transformOrigin: 'center center',
	                transform: props.rotate || 'none',
	                padding: '0.3rem',
	                fontSize: '0.9rem',
	                position: 'relative',
	                textAlign: props.align,
	                margin: props.margin,
	                width: '150px'
	            };
	
	            return _react2.default.createElement(
	                'a',
	                { className: "soon nav-item overline-link section-link " + this.props.identifier, style: containerStyle },
	                _react2.default.createElement(
	                    'span',
	                    null,
	                    props.children
	                ),
	                _react2.default.createElement(
	                    'span',
	                    null,
	                    _Superface2.default.translate('Prochainement')
	                )
	            );
	        }
	    }]);
	
	    return SectionLink;
	}(_react2.default.Component);
	
	exports.default = SectionLink;

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _layout = __webpack_require__(15);
	
	var _Overline = __webpack_require__(42);
	
	var _Overline2 = _interopRequireDefault(_Overline);
	
	var _GallerySmall = __webpack_require__(145);
	
	var _GallerySmall2 = _interopRequireDefault(_GallerySmall);
	
	var _Superface = __webpack_require__(7);
	
	var _Superface2 = _interopRequireDefault(_Superface);
	
	var _MenuItemSoon = __webpack_require__(71);
	
	var _MenuItemSoon2 = _interopRequireDefault(_MenuItemSoon);
	
	var _swiper = __webpack_require__(134);
	
	var _swiper2 = _interopRequireDefault(_swiper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var About = function (_React$Component) {
	    _inherits(About, _React$Component);
	
	    function About(props) {
	        _classCallCheck(this, About);
	
	        var _this = _possibleConstructorReturn(this, (About.__proto__ || Object.getPrototypeOf(About)).call(this, props));
	
	        _this.handleResize = _this.handleResize.bind(_this);
	        _this.handleScroll = _this.handleScroll.bind(_this);
	        return _this;
	    }
	
	    _createClass(About, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            _Superface2.default.setCompass('S');
	            this.initSliders();
	            this.setState(Object.assign({}, this.state, {
	                mounted: true
	            }));
	            window.addEventListener('resize', this.handleResize);
	            this.container.addEventListener('scroll', this.handleScroll);
	        }
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            document.title = _Superface2.default.translate('Notre métier') + ' - Superface';
	            this.setState({
	                mounted: false,
	                hideCompass: false
	            });
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            _Superface2.default.setCompassHiddenOnMobile(false);
	            window.removeEventListener('resize', this.handleResize);
	            this.container.removeEventListener('scroll', this.handleScroll);
	        }
	    }, {
	        key: 'handleResize',
	        value: function handleResize() {
	            this.setState(Object.assign({}, this.state));
	        }
	    }, {
	        key: 'handleScroll',
	        value: function handleScroll(e) {
	            var scrollTop = this.container.scrollTop;
	
	            if (scrollTop > 30 && !this.state.hideCompass) {
	
	                _Superface2.default.setCompassHiddenOnMobile(true);
	                this.setState(Object.assign({}, this.state, {
	                    hideCompass: true
	                }));
	            }
	
	            if (scrollTop < 30 && this.state.hideCompass) {
	                _Superface2.default.setCompassHiddenOnMobile(false);
	                this.setState(Object.assign({}, this.state, {
	                    hideCompass: false
	                }));
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { ref: function ref(el) {
	                        return _this2.container = el;
	                    }, id: 'notre-metier', className: "notre-metier-mobile" + (this.state.mounted ? ' mounted' : ''), style: { backgroundColor: 'white', width: '100vw', height: '100vh', overflow: 'scroll' } },
	                this.renderPage()
	            );
	        }
	    }, {
	        key: 'initSliders',
	        value: function initSliders() {
	            var _this3 = this;
	
	            // addClass( this.sliderExp, 'slider-exp' )
	
	            var params = {
	                speed: 400,
	                initialSlide: 0
	            };
	
	            setTimeout(function () {
	                _this3.swiperExp = new _swiper2.default('.slider-exp', params);
	                _this3.swiperMilan = new _swiper2.default('.slider-milan', params);
	            }, 2000);
	        }
	    }, {
	        key: 'renderPage',
	        value: function renderPage() {
	            var about = this.props.about;
	
	
	            var largeText = {
	                fontSize: _Superface2.default.IS_MOBILE ? '1.4rem' : '2rem',
	                margin: _Superface2.default.IS_MOBILE ? '0 2rem' : '0 6rem'
	            };
	
	            if (about) {
	                var expSlides = [about.image_4, about.image_5, about.image_6, about.image_7];
	                return _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { style: { marginTop: '10rem' } },
	                        _react2.default.createElement(SectionTitle, { title: _Superface2.default.field(this.props.about, 'section_title_1') })
	                    ),
	                    _react2.default.createElement(
	                        _layout.Flex,
	                        { align: 'center', justify: 'center' },
	                        _react2.default.createElement('div', { style: Object.assign({}, largeText), dangerouslySetInnerHTML: this.crtmrkp(_Superface2.default.field(about, 'text_1')) })
	                    ),
	                    _react2.default.createElement(
	                        _layout.Flex,
	                        { align: 'center', justify: 'center' },
	                        _react2.default.createElement('div', { style: largeText, dangerouslySetInnerHTML: this.crtmrkp(_Superface2.default.field(about, 'text_2')) })
	                    ),
	                    _react2.default.createElement(SectionTitle, { title: _Superface2.default.field(this.props.about, 'section_title_2') }),
	                    _react2.default.createElement(
	                        'div',
	                        {
	                            id: 'skills',
	                            style: { margin: window.innerWidth > 767 ? '4rem 6rem' : '4rem 2rem' }
	                        },
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                'h2',
	                                null,
	                                'Recherche'
	                            ),
	                            _react2.default.createElement('div', { dangerouslySetInnerHTML: this.crtmrkp(_Superface2.default.field(about, 'recherche')) })
	                        ),
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                'h2',
	                                null,
	                                'Proposition'
	                            ),
	                            _react2.default.createElement('div', { dangerouslySetInnerHTML: this.crtmrkp(_Superface2.default.field(about, 'proposition')) })
	                        ),
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                'h2',
	                                null,
	                                'Developpement'
	                            ),
	                            _react2.default.createElement('div', { dangerouslySetInnerHTML: this.crtmrkp(_Superface2.default.field(about, 'developpement')) })
	                        ),
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                'h2',
	                                null,
	                                'Suivi'
	                            ),
	                            _react2.default.createElement('div', { dangerouslySetInnerHTML: this.crtmrkp(_Superface2.default.field(about, 'suivi')) })
	                        )
	                    ),
	                    _react2.default.createElement(SectionTitle, { title: _Superface2.default.field(this.props.about, 'section_title_3') }),
	                    _react2.default.createElement(
	                        'div',
	                        {
	                            id: 'shapes'
	                        },
	                        _react2.default.createElement('div', { style: largeText, dangerouslySetInnerHTML: this.crtmrkp(_Superface2.default.field(about, 'text_4')) })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { style: { position: 'relative' } },
	                        _react2.default.createElement('img', { className: 'shapes-image-mobile', src: __webpack_require__(191), alt: 'forme filaire' }),
	                        _react2.default.createElement('img', { className: 'shapes-image-mobile', src: __webpack_require__(192), alt: 'forme filaire' }),
	                        _react2.default.createElement('img', { className: 'shapes-image-mobile', src: __webpack_require__(193), alt: 'forme filaire' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { id: 'milans' },
	                        _react2.default.createElement(
	                            _layout.Flex,
	                            { align: 'center', direction: 'column', justify: 'center', style: { width: '100%' } },
	                            _react2.default.createElement('img', { src: _Superface2.default.assetUrl(about.image_backup_video_galaxy.path), alt: 'logo' })
	                        )
	                    ),
	                    _react2.default.createElement(SectionTitle, { title: _Superface2.default.field(this.props.about, 'section_title_4') }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'experience-left' },
	                        _react2.default.createElement(
	                            'div',
	                            {
	                                id: 'experience-text-1'
	                            },
	                            _react2.default.createElement('div', { style: largeText, dangerouslySetInnerHTML: this.crtmrkp(_Superface2.default.field(about, 'text_5')) })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            {
	                                id: 'experience-text-2'
	                            },
	                            _react2.default.createElement('div', { style: largeText, dangerouslySetInnerHTML: this.crtmrkp(_Superface2.default.field(about, 'text_6')) })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'experience-right' },
	                        _react2.default.createElement(
	                            'div',
	                            { style: { padding: '2rem 0' } },
	                            _react2.default.createElement(_GallerySmall2.default, { slides: expSlides, name: 'exp', i: 'exp' })
	                        )
	                    ),
	                    _react2.default.createElement(SectionTitle, { title: _Superface2.default.field(this.props.about, 'section_title_5') }),
	                    _react2.default.createElement(
	                        'div',
	                        { id: 'images-milan' },
	                        _react2.default.createElement(_GallerySmall2.default, { slides: about.milans, name: 'milans', i: 'milans' })
	                    ),
	                    _react2.default.createElement(SectionTitle, { title: _Superface2.default.field(this.props.about, 'section_title_6') }),
	                    _react2.default.createElement(
	                        _layout.Flex,
	                        {
	                            direction: 'row-reverse',
	                            justify: 'center',
	                            id: 'team-mobile',
	                            style: {
	                                width: window.innerWidth > 767 ? '80%' : 'calc(100vw)',
	                                marginLeft: window.innerWidth > 767 ? '10%' : '0'
	                            }
	                        },
	                        this.renderMembers(this.props.about.team)
	                    ),
	                    _react2.default.createElement(SectionTitle, { title: '' }),
	                    _react2.default.createElement(
	                        'div',
	                        {
	                            id: 'contact'
	                        },
	                        _react2.default.createElement(
	                            _layout.Flex,
	                            { align: 'center', justify: 'center', style: { position: 'relative', minHeight: '40vh', width: '100vw' } },
	                            _react2.default.createElement(
	                                'div',
	                                { style: Object.assign({}, largeText, { color: 'black', position: 'relative', zIndex: 50, width: '420px' }) },
	                                _Superface2.default.field(this.props.about, 'text_merci'),
	                                _react2.default.createElement('br', null),
	                                _react2.default.createElement('br', null),
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: this.props.contact.facebook, target: '_blank', style: { display: 'inline-block', width: '2rem' } },
	                                    _react2.default.createElement('img', { src: __webpack_require__(64), alt: 'facebook' })
	                                ),
	                                '\xA0\xA0',
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: this.props.contact.instagram, target: '_blank', style: { display: 'inline-block', width: '2rem' } },
	                                    _react2.default.createElement('img', { src: __webpack_require__(65), alt: 'instagram' })
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { style: { fontSize: '1rem', marginTop: '5vh', width: '50%' } },
	                                    _Superface2.default.translate('Crédits:'),
	                                    _react2.default.createElement('br', null),
	                                    _Superface2.default.translate('Direction artistique et site internet : '),
	                                    _react2.default.createElement(
	                                        'a',
	                                        { className: 'overline-link', href: 'https://www.bureaukayser.com/', target: '_blank' },
	                                        _react2.default.createElement(
	                                            _Overline2.default,
	                                            null,
	                                            'Bureau Kayser'
	                                        )
	                                    ),
	                                    _react2.default.createElement('br', null),
	                                    _Superface2.default.translate('Photos : '),
	                                    _react2.default.createElement(
	                                        'a',
	                                        { className: 'overline-link', href: 'https://marvinleuvrey.com/', target: '_blank' },
	                                        _react2.default.createElement(
	                                            _Overline2.default,
	                                            null,
	                                            'Marvin Leuvrey'
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { style: { position: 'absolute', width: '20vw', left: '70%', top: '55%', zIndex: '8' } },
	                                    _react2.default.createElement('img', { src: __webpack_require__(66), alt: 'Pi\xE8ce de Milan' })
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { style: { width: '100%', height: '4rem', borderTop: '1px solid black' } },
	                        _react2.default.createElement(
	                            _layout.Flex,
	                            { justify: 'space-around' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'footer-link', style: { marginTop: 0 } },
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: 'overline-link', onClick: function onClick() {
	                                            _Superface2.default.goTo(_Superface2.default.uri('contact'));
	                                        } },
	                                    _react2.default.createElement(
	                                        _Overline2.default,
	                                        null,
	                                        _Superface2.default.translate('Contact')
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'footer-link', style: { marginTop: 0 } },
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: 'overline-link', onClick: function onClick() {
	                                            _Superface2.default.goTo(_Superface2.default.uri('matieres'));
	                                        } },
	                                    _react2.default.createElement(
	                                        _Overline2.default,
	                                        null,
	                                        _Superface2.default.translate('Matières')
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'footer-link', style: { marginTop: 0 } },
	                                _react2.default.createElement(_MenuItemSoon2.default, { display: _Superface2.default.translate('Projets'), style: { display: 'inline-block', width: 'auto' } })
	                            )
	                        )
	                    )
	                );
	            }
	        }
	    }, {
	        key: 'renderMembers',
	        value: function renderMembers(members) {
	            return members.map(function (data, i) {
	                var member = Object.assign({}, data.value);
	                var style = { width: '25%', margin: '0 2%', textAlign: 'center' };
	                return _react2.default.createElement(
	                    'div',
	                    { key: 'member-' + i, className: 'member-mobile', style: style },
	                    _react2.default.createElement(
	                        _layout.Flex,
	                        { direction: 'column', align: 'center' },
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement('img', { src: _Superface2.default.assetUrl(member.image.path), alt: member.firstname + ' ' + member.lastname })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { style: { fontSize: '1rem', marginTop: '3rem', width: window.innerWidth > 767 ? 'initial' : '80%' } },
	                            member.firstname + ' ' + member.lastname
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { style: { fontSize: '0.7rem', marginTop: '1rem' } },
	                            member.roles.map(function (role, i) {
	                                return _react2.default.createElement(
	                                    'div',
	                                    { key: 'role_' + i },
	                                    role
	                                );
	                            })
	                        )
	                    )
	                );
	            });
	        }
	    }, {
	        key: 'crtmrkp',
	        value: function crtmrkp(text) {
	            return { __html: text };
	        }
	    }]);
	
	    return About;
	}(_react2.default.Component);
	
	exports.default = About;
	
	
	var SectionTitle = function SectionTitle(props) {
	    return _react2.default.createElement(
	        'div',
	        { style: { width: '100%', textAlign: 'center', margin: '10rem 0 3rem' } },
	        _Superface2.default.translate(props.title)
	    );
	};

/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _three = __webpack_require__(68);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _Superface = __webpack_require__(7);
	
	var _Superface2 = _interopRequireDefault(_Superface);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MaterialsGridMobile = function (_React$Component) {
	    _inherits(MaterialsGridMobile, _React$Component);
	
	    function MaterialsGridMobile(props) {
	        _classCallCheck(this, MaterialsGridMobile);
	
	        var _this = _possibleConstructorReturn(this, (MaterialsGridMobile.__proto__ || Object.getPrototypeOf(MaterialsGridMobile)).call(this, props));
	
	        _this.frame = 0;
	
	        _this.handleResize = _this.handleResize.bind(_this);
	        // this.onMouseDown = this.onMouseDown.bind(this)
	        // this.onMouseUp = this.onMouseUp.bind(this)
	
	        return _this;
	    }
	
	    //
	    // ─── LIFE CYCLE ─────────────────────────────────────────────────────────────────
	    //
	
	    _createClass(MaterialsGridMobile, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	
	            // if( this.props.materialsImagesLoaded ){
	            //     this.loadImages( this.props.materials )
	            // }
	            this.setState(Object.assign({}, this.state, { mounted: false
	            }));
	            // this.start()
	        }
	
	        // shouldComponentUpdate(){
	        //     // return false
	        // }
	
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            _Superface2.default.setLoading(true);
	            // window.addEventListener('mousemove', this.handleMouseMove)
	            window.addEventListener('resize', this.handleResize);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(new_props) {}
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	
	            if (this.timeoutResize) window.clearTimeout(this.timeoutResize);
	            if (this.timeoutMount) clearTimeout(this.timeoutMount);
	            window.removeEventListener('resize', this.handleResize);
	        }
	
	        //
	        // ─── INIT 3D ────────────────────────────────────────────────────────────────────
	        //
	
	    }, {
	        key: 'increaseImagesLoaded',
	        value: function increaseImagesLoaded() {
	            this.imagesLoaded += 1;
	            if (this.imagesLoaded === this.imagesToLoad) {
	                this.materialsReady();
	            }
	        }
	    }, {
	        key: 'renderImages',
	        value: function renderImages() {
	            var _this2 = this;
	
	            this.imagesLoaded = 0;
	            this.imagesToLoad = 39;
	
	            // console.log(this.props.materials)
	            return this.props.materials.map(function (matiere, i) {
	                var style = {
	                    textAlign: i % 2 === 0 ? 'left' : 'right',
	                    width: '80%',
	                    paddingTop: i % 3 === 0 ? '5rem' : '10rem',
	                    paddingLeft: i % 3 === 0 ? '5rem' : '0'
	                };
	                if (i < 40) {
	                    return _react2.default.createElement(
	                        'div',
	                        { style: style, key: i, onClick: function onClick() {
	                                var kind = _Superface2.default.getMaterialKindById(matiere.material_kind._id);
	                                _Superface2.default.setKindFeaturedImagePath(matiere.image.path);
	                                _Superface2.default.goTo(_Superface2.default.uri('matieres') + '/' + kind.slug);
	                            } },
	                        _react2.default.createElement('img', { style: { display: 'inline-block', width: '60%' }, onLoad: function onLoad() {
	                                _this2.increaseImagesLoaded();
	                            }, src: _Superface2.default.assetUrl(matiere.image.thumb_path), alt: "matière " + matiere.name })
	                    );
	                }
	            });
	        }
	    }, {
	        key: 'materialsReady',
	        value: function materialsReady() {
	            setTimeout(function () {
	                _Superface2.default.setLoading(false);
	            }, 200);
	            this.setState(Object.assign({}, this.state, { mounted: true
	            }));
	        }
	    }, {
	        key: 'handleResize',
	        value: function handleResize() {
	            this.setState(Object.assign({}, this.state));
	        }
	
	        //
	        // ─── ANIMATE ────────────────────────────────────────────────────────────────────
	        //
	
	    }, {
	        key: 'render',
	        value: function render() {
	            if (!this.props.materialsImagesLoaded) return _react2.default.createElement('div', null);
	
	            return _react2.default.createElement(
	                'div',
	                { id: 'grid-mobile', className: this.state.mounted ? 'mounted' : '', style: { width: '100%', height: '100%' } },
	                this.renderImages()
	            );
	        }
	    }]);
	
	    return MaterialsGridMobile;
	}(_react2.default.Component);
	
	exports.default = MaterialsGridMobile;

/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _three = __webpack_require__(68);
	
	var THREE = _interopRequireWildcard(_three);
	
	var _Superface = __webpack_require__(7);
	
	var _Superface2 = _interopRequireDefault(_Superface);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MaterialsGridMobile = function (_React$Component) {
	    _inherits(MaterialsGridMobile, _React$Component);
	
	    function MaterialsGridMobile(props) {
	        _classCallCheck(this, MaterialsGridMobile);
	
	        var _this = _possibleConstructorReturn(this, (MaterialsGridMobile.__proto__ || Object.getPrototypeOf(MaterialsGridMobile)).call(this, props));
	
	        _this.frame = 0;
	
	        _this.handleResize = _this.handleResize.bind(_this);
	        // this.onMouseDown = this.onMouseDown.bind(this)
	        // this.onMouseUp = this.onMouseUp.bind(this)
	
	        return _this;
	    }
	
	    //
	    // ─── LIFE CYCLE ─────────────────────────────────────────────────────────────────
	    //
	
	    _createClass(MaterialsGridMobile, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	
	            // if( this.props.materialsImagesLoaded ){
	            //     this.loadImages( this.props.materials )
	            // }
	            this.setState(Object.assign({}, this.state, { mounted: false
	            }));
	            // this.start()
	        }
	
	        // shouldComponentUpdate(){
	        //     // return false
	        // }
	
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            _Superface2.default.setLoading(true);
	            // window.addEventListener('mousemove', this.handleMouseMove)
	            window.addEventListener('resize', this.handleResize);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(new_props) {}
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	
	            if (this.timeoutResize) window.clearTimeout(this.timeoutResize);
	            if (this.timeoutMount) clearTimeout(this.timeoutMount);
	            window.removeEventListener('resize', this.handleResize);
	        }
	
	        //
	        // ─── INIT 3D ────────────────────────────────────────────────────────────────────
	        //
	
	    }, {
	        key: 'increaseImagesLoaded',
	        value: function increaseImagesLoaded() {
	            this.imagesLoaded += 1;
	            if (this.imagesLoaded > this.imagesToLoad) {
	                this.projectsReady();
	            }
	        }
	    }, {
	        key: 'renderImages',
	        value: function renderImages() {
	            var _this2 = this;
	
	            this.imagesLoaded = 0;
	            this.imagesToLoad = this.props.projects.length - 1;
	
	            // console.log(this.props.projects)
	            return this.props.projects.map(function (projet, i) {
	                var style = {
	                    textAlign: i % 2 === 0 ? 'left' : 'right',
	                    width: '100%',
	                    paddingTop: i % 3 === 0 ? '5rem' : '10rem'
	                };
	                return _react2.default.createElement(
	                    'div',
	                    { style: style, key: i, onClick: function onClick() {
	                            _Superface2.default.goTo(_Superface2.default.uri('projets') + '/' + projet.slug);
	                        } },
	                    _react2.default.createElement('img', { style: { display: 'inline-block', width: '60%' }, onLoad: function onLoad() {
	                            _this2.increaseImagesLoaded();
	                        }, src: _Superface2.default.assetUrl(projet.thumb.path), alt: "projet " + projet.name })
	                );
	            });
	        }
	    }, {
	        key: 'projectsReady',
	        value: function projectsReady() {
	            _Superface2.default.setLoading(false);
	            this.setState(Object.assign({}, this.state, { mounted: true
	            }));
	        }
	    }, {
	        key: 'handleResize',
	        value: function handleResize() {
	            this.setState(Object.assign({}, this.state));
	        }
	
	        //
	        // ─── ANIMATE ────────────────────────────────────────────────────────────────────
	        //
	
	    }, {
	        key: 'render',
	        value: function render() {
	            if (this.props.projects.length === 0) return _react2.default.createElement('div', null);
	
	            return _react2.default.createElement(
	                'div',
	                { id: 'grid-mobile', style: { width: '100%', height: '100%', display: this.state.mounted ? 'block' : 'none' } },
	                this.renderImages()
	            );
	        }
	    }]);
	
	    return MaterialsGridMobile;
	}(_react2.default.Component);
	
	exports.default = MaterialsGridMobile;

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(59);
	
	var _reactRouterDom = __webpack_require__(40);
	
	var _reactRouter = __webpack_require__(41);
	
	var _Home = __webpack_require__(149);
	
	var _Home2 = _interopRequireDefault(_Home);
	
	var _Menu = __webpack_require__(147);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _Burger = __webpack_require__(142);
	
	var _Burger2 = _interopRequireDefault(_Burger);
	
	var _Materials = __webpack_require__(150);
	
	var _Materials2 = _interopRequireDefault(_Materials);
	
	var _Projects = __webpack_require__(151);
	
	var _Projects2 = _interopRequireDefault(_Projects);
	
	var _About = __webpack_require__(242);
	
	var _About2 = _interopRequireDefault(_About);
	
	var _Contact = __webpack_require__(140);
	
	var _Contact2 = _interopRequireDefault(_Contact);
	
	var _Compass = __webpack_require__(143);
	
	var _Compass2 = _interopRequireDefault(_Compass);
	
	var _reactTransitionGroup = __webpack_require__(550);
	
	var _Superface = __webpack_require__(7);
	
	var _Superface2 = _interopRequireDefault(_Superface);
	
	var _LoadingAnimation = __webpack_require__(146);
	
	var _LoadingAnimation2 = _interopRequireDefault(_LoadingAnimation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BrowserApp = function (_React$Component) {
	    _inherits(BrowserApp, _React$Component);
	
	    function BrowserApp() {
	        _classCallCheck(this, BrowserApp);
	
	        return _possibleConstructorReturn(this, (BrowserApp.__proto__ || Object.getPrototypeOf(BrowserApp)).apply(this, arguments));
	    }
	
	    _createClass(BrowserApp, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	
	            if (!_Superface2.default.ready) {
	                _Superface2.default.setLoading(true);
	                _Superface2.default.loadJSONdatas();
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(new_props) {
	
	            // if( Superface.ready && Superface.loaded  ){
	            //     Superface.setLoading(false)
	            // }
	
	        }
	    }, {
	        key: 'renderCompass',
	        value: function renderCompass() {
	
	            if (this.props.isOnSingle) {
	                return _react2.default.createElement('span', null);
	            } else {
	                return _react2.default.createElement(_Compass2.default, { menuOpen: this.props.menuOpen, cardinal: this.props.cardinal, section: this.props.currentSection, loading: this.props.loading });
	            }
	        }
	    }, {
	        key: 'renderBurger',
	        value: function renderBurger() {
	
	            if (this.props.currentSection !== 'accueil') {
	                return _react2.default.createElement(_Burger2.default, { open: this.props.menuOpen || this.props.isOnSingle });
	            } else {
	                return _react2.default.createElement('span', null);
	            }
	        }
	    }, {
	        key: 'renderLoadingLoop',
	        value: function renderLoadingLoop() {
	            if (!_Superface2.default.loaded) return _react2.default.createElement(_LoadingAnimation2.default, null);else return '';
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            if (!_Superface2.default.loaded) {
	                return this.renderLoadingLoop();
	            }
	            // const { currentSection } = this.props
	
	            return _react2.default.createElement(
	                'div',
	                { id: 'App', style: { height: '100%', width: '100%', display: !_Superface2.default.loaded ? 'none' : '' } },
	                this.renderCompass(),
	                this.renderBurger(),
	                _react2.default.createElement(_Menu2.default, { contact: this.props.contact, open: this.props.menuOpen, section: this.props.currentSection }),
	                _react2.default.createElement(
	                    _reactTransitionGroup.TransitionGroup,
	                    { component: 'main', className: 'page-main from-' + this.props.previousSection + ' to-' + this.props.currentSection },
	                    _react2.default.createElement(
	                        _reactTransitionGroup.CSSTransition,
	                        { key: this.props.currentSection, timeout: 800, classNames: 'anim', appear: false },
	                        _react2.default.createElement(
	                            _reactRouterDom.Switch,
	                            { location: this.props.location },
	                            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: _Superface2.default.uri('accueil'), component: _Home2.default }),
	                            _react2.default.createElement(_reactRouterDom.Route, { path: _Superface2.default.uri('projets'), component: _Projects2.default }),
	                            _react2.default.createElement(_reactRouterDom.Route, { path: _Superface2.default.uri('matieres'), component: _Materials2.default }),
	                            _react2.default.createElement(_reactRouterDom.Route, { path: _Superface2.default.uri('notre-metier'), render: function render(props) {
	                                    return _react2.default.createElement(_About2.default, { about: _this2.props.about, contact: _this2.props.contact });
	                                } }),
	                            _react2.default.createElement(_reactRouterDom.Route, { path: _Superface2.default.uri('contact'), render: function render(props) {
	                                    return _react2.default.createElement(_Contact2.default, { contact: _this2.props.contact });
	                                } }),
	                            _react2.default.createElement(_reactRouterDom.Route, { render: function render() {
	                                    window.location.href = '/';
	                                    return '';
	                                } })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return BrowserApp;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	
	    return {
	        cardinal: state.app.cardinal,
	        loaded: state.app.loaded,
	        loading: state.app.loading,
	        location: state.routing.location,
	        lang: state.app.lang,
	        menuOpen: state.app.menuOpen,
	        currentSection: state.app.currentSection,
	        previousSection: state.app.previousSection,
	        about: state.data.about,
	        contact: state.data.contact,
	        isOnSingle: state.app.isOnSingle
	    };
	};
	
	exports.default = (0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps, null)(BrowserApp));

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(59);
	
	var _reactRouterDom = __webpack_require__(40);
	
	var _reactRouter = __webpack_require__(41);
	
	var _Home = __webpack_require__(149);
	
	var _Home2 = _interopRequireDefault(_Home);
	
	var _Menu = __webpack_require__(147);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _Burger = __webpack_require__(142);
	
	var _Burger2 = _interopRequireDefault(_Burger);
	
	var _Materials = __webpack_require__(150);
	
	var _Materials2 = _interopRequireDefault(_Materials);
	
	var _Projects = __webpack_require__(151);
	
	var _Projects2 = _interopRequireDefault(_Projects);
	
	var _mobile_About = __webpack_require__(256);
	
	var _mobile_About2 = _interopRequireDefault(_mobile_About);
	
	var _Contact = __webpack_require__(140);
	
	var _Contact2 = _interopRequireDefault(_Contact);
	
	var _Compass = __webpack_require__(143);
	
	var _Compass2 = _interopRequireDefault(_Compass);
	
	var _Superface = __webpack_require__(7);
	
	var _Superface2 = _interopRequireDefault(_Superface);
	
	var _LoadingAnimation = __webpack_require__(146);
	
	var _LoadingAnimation2 = _interopRequireDefault(_LoadingAnimation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BrowserApp = function (_React$Component) {
	    _inherits(BrowserApp, _React$Component);
	
	    function BrowserApp() {
	        _classCallCheck(this, BrowserApp);
	
	        return _possibleConstructorReturn(this, (BrowserApp.__proto__ || Object.getPrototypeOf(BrowserApp)).apply(this, arguments));
	    }
	
	    _createClass(BrowserApp, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	
	            if (!_Superface2.default.ready) {
	                _Superface2.default.setLoading(true);
	                _Superface2.default.loadJSONdatas();
	            }
	        }
	    }, {
	        key: 'renderCompass',
	        value: function renderCompass() {
	            // alert(this.props.compassHiddenOnMobile)
	            if (this.props.isOnSingle) {
	                return _react2.default.createElement('span', null);
	            } else {
	                return _react2.default.createElement(_Compass2.default, { hidden: this.props.compassHiddenOnMobile, cardinal: this.props.cardinal, section: this.props.currentSection, loading: this.props.loading });
	            }
	        }
	    }, {
	        key: 'renderBurger',
	        value: function renderBurger() {
	
	            if (this.props.currentSection !== 'accueil') {
	                return _react2.default.createElement(_Burger2.default, { open: this.props.menuOpen || this.props.isOnSingle });
	            } else {
	                return _react2.default.createElement('span', null);
	            }
	        }
	    }, {
	        key: 'renderLoadingLoop',
	        value: function renderLoadingLoop() {
	            if (!_Superface2.default.loaded) return _react2.default.createElement(_LoadingAnimation2.default, null);else return '';
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { id: 'App', style: { height: '100%', width: '100%', display: !_Superface2.default.loaded ? 'none' : '' } },
	                this.renderLoadingLoop(),
	                this.renderCompass(),
	                this.renderBurger(),
	                _react2.default.createElement(_Menu2.default, { open: this.props.menuOpen, section: this.props.currentSection, contact: this.props.contact }),
	                _react2.default.createElement(
	                    _reactRouterDom.Switch,
	                    { location: this.props.location },
	                    _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: _Superface2.default.uri('accueil'), component: _Home2.default }),
	                    _react2.default.createElement(_reactRouterDom.Route, { path: _Superface2.default.uri('projets'), component: _Projects2.default }),
	                    _react2.default.createElement(_reactRouterDom.Route, { path: _Superface2.default.uri('matieres'), component: _Materials2.default }),
	                    _react2.default.createElement(_reactRouterDom.Route, { path: _Superface2.default.uri('notre-metier'), render: function render(props) {
	                            return _react2.default.createElement(_mobile_About2.default, { contact: _this2.props.contact, about: _this2.props.about });
	                        } }),
	                    _react2.default.createElement(_reactRouterDom.Route, { path: _Superface2.default.uri('contact'), render: function render(props) {
	                            return _react2.default.createElement(_Contact2.default, { contact: _this2.props.contact });
	                        } })
	                )
	            );
	        }
	    }]);
	
	    return BrowserApp;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	
	    return {
	        cardinal: state.app.cardinal,
	        loaded: state.app.loaded,
	        loading: state.app.loading,
	        location: state.routing.location,
	        lang: state.app.lang,
	        menuOpen: state.app.menuOpen,
	        currentSection: state.app.currentSection,
	        previousSection: state.app.previousSection,
	        about: state.data.about,
	        contact: state.data.contact,
	        isOnSingle: state.app.isOnSingle,
	        compassHiddenOnMobile: state.app.compassHiddenOnMobile
	    };
	};
	
	exports.default = (0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps, null)(BrowserApp));

/***/ },
/* 261 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	
	    'Accueil': {
	        en: 'Home', fr: 'Accueil'
	    },
	
	    'Matières': {
	        en: 'Materials', fr: 'Matières'
	    },
	
	    'Projets': {
	        en: 'Projects', fr: 'Projets'
	    },
	
	    'Notre métier': {
	        en: 'About', fr: 'Notre métier'
	    },
	
	    'Direction artistique et site internet : ': {
	        en: 'Art direction and website : ', fr: 'Direction artistique et site internet : '
	    },
	
	    'Crédits : ': {
	        en: 'Credits : ', fr: 'Crédits : '
	    },
	
	    'Prochainement': {
	        en: 'Soon', fr: 'Prochainement'
	    },
	
	    'Designer matériaux': {
	        en: 'Materials designer', fr: 'Designer matériaux'
	    }
	
	};

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(264);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(200);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRedux = __webpack_require__(59);
	
	var _reactRouterRedux = __webpack_require__(60);
	
	var _store = __webpack_require__(153);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _reactGa = __webpack_require__(519);
	
	var _reactGa2 = _interopRequireDefault(_reactGa);
	
	var _App = __webpack_require__(244);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _superface = __webpack_require__(472);
	
	var _superface2 = _interopRequireDefault(_superface);
	
	var _prototypes = __webpack_require__(263);
	
	var _prototypes2 = _interopRequireDefault(_prototypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable */
	
	(0, _prototypes2.default)();
	function noop() {}
	// console.log = noop;
	console.warn = noop;
	// console.error = noop;
	
	
	_store.history.listen(function (location, action) {
	
	  setTimeout(function () {
	    _reactGa2.default.set({ page: location.pathname });
	    _reactGa2.default.pageview(location.pathname);
	  }, 1500);
	});
	
	_reactDom2.default.render(_react2.default.createElement(
	  _reactRedux.Provider,
	  { store: _store2.default },
	  _react2.default.createElement(
	    _reactRouterRedux.ConnectedRouter,
	    { history: _store.history },
	    _react2.default.createElement(_App2.default, null)
	  )
	), document.getElementById('root'));
	
	_reactGa2.default.initialize('UA-74656785-1');
	_reactGa2.default.pageview(window.location.pathname + window.location.search);

/***/ },
/* 263 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = prototypes;
	/* eslint-disable */
	function prototypes() {
	
		//
		// ─── ARRAY ──────────────────────────────────────────────────────────────────────
		//
	
		if (!Array.prototype.first) {
			Array.prototype.first = function () {
				return this[0];
			};
		}
	
		if (!Array.prototype.last) {
			Array.prototype.last = function () {
				return this[this.length - 1];
			};
		}
	
		if (!Array.prototype.getRandomElement) {
			Array.prototype.getRandomElement = function () {
				return this[Math.floor(Math.random() * this.length)];
			};
		}
	
		if (!Array.prototype.loopUp) {
			Array.prototype.loopUp = function () {
				var last = this.pop();
				this.unshift(last);
				// return this
			};
		}
	
		if (!Array.prototype.shuffle) {
			Array.prototype.shuffle = function () {
				var currentIndex = this.length,
				    temporaryValue,
				    randomIndex;
				while (0 !== currentIndex) {
					// Pick a remaining element...
					randomIndex = Math.floor(Math.random() * currentIndex);
					currentIndex -= 1;
					// And swap it with the current element.
					temporaryValue = this[currentIndex];
					this[currentIndex] = this[randomIndex];
					this[randomIndex] = temporaryValue;
				}
				return this;
			};
		}
	
		if (!Array.prototype.isEmpty) {
			Array.prototype.isEmpty = function () {
				return this.length == 0;
			};
		}
	
		//
		// ─── OBJECT ─────────────────────────────────────────────────────────────────────
		//
	
	
		// if (!Object.prototype.isEmpy) {
		// 	Object.prototype.isEmpty = function() {
		// 		return Object.keys(obj).length === 0 && obj.constructor === Object
		// 	};
		// }
	
	
		//
		// ─── STRING ─────────────────────────────────────────────────────────────────────
		//
	
		if (!Number.prototype.normalizeDeg) {
			Number.prototype.normalizeDeg = function () {
				var a = this;
				a = a % 360;
				a = (a + 360) % 360;
				return a;
			};
		}
	
		if (!Number.prototype.normalizeDeg180) {
			Number.prototype.normalizeDeg180 = function () {
				var a = this;
				a = a.normalizeDeg();
				if (a > 180) a -= 360;
				return a;
			};
		}
	}

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	__webpack_require__(464);
	
	__webpack_require__(465);
	
	__webpack_require__(265);
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	
	var DEFINE_PROPERTY = "defineProperty";
	function define(O, key, value) {
	  O[key] || Object[DEFINE_PROPERTY](O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}
	
	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);
	
	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(272);
	module.exports = __webpack_require__(26).RegExp.escape;


/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(6);
	var isArray = __webpack_require__(77);
	var SPECIES = __webpack_require__(8)('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};


/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var fails = __webpack_require__(5);
	var getTime = Date.prototype.getTime;
	var $toISOString = Date.prototype.toISOString;
	
	var lz = function (num) {
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	module.exports = (fails(function () {
	  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
	}) || !fails(function () {
	  $toISOString.call(new Date(NaN));
	})) ? function toISOString() {
	  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
	  var d = this;
	  var y = d.getUTCFullYear();
	  var m = d.getUTCMilliseconds();
	  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
	  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	} : $toISOString;


/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var anObject = __webpack_require__(3);
	var toPrimitive = __webpack_require__(33);
	var NUMBER = 'number';
	
	module.exports = function (hint) {
	  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};


/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(48);
	var gOPS = __webpack_require__(81);
	var pIE = __webpack_require__(63);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ },
/* 270 */
/***/ function(module, exports) {

	module.exports = function (regExp, replace) {
	  var replacer = replace === Object(replace) ? function (part) {
	    return replace[part];
	  } : replace;
	  return function (it) {
	    return String(it).replace(regExp, replacer);
	  };
	};


/***/ },
/* 271 */
/***/ function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y) {
	  // eslint-disable-next-line no-self-compare
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};


/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(1);
	var $re = __webpack_require__(270)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(1);
	
	$export($export.P, 'Array', { copyWithin: __webpack_require__(156) });
	
	__webpack_require__(37)('copyWithin');


/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $every = __webpack_require__(29)(4);
	
	$export($export.P + $export.F * !__webpack_require__(28)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */) {
	    return $every(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(1);
	
	$export($export.P, 'Array', { fill: __webpack_require__(97) });
	
	__webpack_require__(37)('fill');


/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $filter = __webpack_require__(29)(2);
	
	$export($export.P + $export.F * !__webpack_require__(28)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */) {
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(1);
	var $find = __webpack_require__(29)(6);
	var KEY = 'findIndex';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(37)(KEY);


/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(1);
	var $find = __webpack_require__(29)(5);
	var KEY = 'find';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(37)(KEY);


/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $forEach = __webpack_require__(29)(0);
	var STRICT = __webpack_require__(28)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */) {
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(27);
	var $export = __webpack_require__(1);
	var toObject = __webpack_require__(13);
	var call = __webpack_require__(167);
	var isArrayIter = __webpack_require__(105);
	var toLength = __webpack_require__(11);
	var createProperty = __webpack_require__(99);
	var getIterFn = __webpack_require__(121);
	
	$export($export.S + $export.F * !__webpack_require__(79)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $indexOf = __webpack_require__(73)(false);
	var $native = [].indexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(28)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});


/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Array', { isArray: __webpack_require__(77) });


/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export = __webpack_require__(1);
	var toIObject = __webpack_require__(23);
	var arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(62) != Object || !__webpack_require__(28)(arrayJoin)), 'Array', {
	  join: function join(separator) {
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});


/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var toIObject = __webpack_require__(23);
	var toInteger = __webpack_require__(32);
	var toLength = __webpack_require__(11);
	var $native = [].lastIndexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(28)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
	    // convert -0 to +0
	    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
	    var O = toIObject(this);
	    var length = toLength(O.length);
	    var index = length - 1;
	    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
	    if (index < 0) index = length + index;
	    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
	    return -1;
	  }
	});


/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $map = __webpack_require__(29)(1);
	
	$export($export.P + $export.F * !__webpack_require__(28)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */) {
	    return $map(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var createProperty = __webpack_require__(99);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(5)(function () {
	  function F() { /* empty */ }
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */) {
	    var index = 0;
	    var aLen = arguments.length;
	    var result = new (typeof this == 'function' ? this : Array)(aLen);
	    while (aLen > index) createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});


/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $reduce = __webpack_require__(158);
	
	$export($export.P + $export.F * !__webpack_require__(28)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});


/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $reduce = __webpack_require__(158);
	
	$export($export.P + $export.F * !__webpack_require__(28)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});


/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var html = __webpack_require__(103);
	var cof = __webpack_require__(25);
	var toAbsoluteIndex = __webpack_require__(52);
	var toLength = __webpack_require__(11);
	var arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(5)(function () {
	  if (html) arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end) {
	    var len = toLength(this.length);
	    var klass = cof(this);
	    end = end === undefined ? len : end;
	    if (klass == 'Array') return arraySlice.call(this, begin, end);
	    var start = toAbsoluteIndex(begin, len);
	    var upTo = toAbsoluteIndex(end, len);
	    var size = toLength(upTo - start);
	    var cloned = new Array(size);
	    var i = 0;
	    for (; i < size; i++) cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});


/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $some = __webpack_require__(29)(3);
	
	$export($export.P + $export.F * !__webpack_require__(28)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */) {
	    return $some(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var aFunction = __webpack_require__(14);
	var toObject = __webpack_require__(13);
	var fails = __webpack_require__(5);
	var $sort = [].sort;
	var test = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function () {
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function () {
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(28)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn) {
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});


/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(51)('Array');


/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(1);
	var toISOString = __webpack_require__(267);
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
	  toISOString: toISOString
	});


/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var toObject = __webpack_require__(13);
	var toPrimitive = __webpack_require__(33);
	
	$export($export.P + $export.F * __webpack_require__(5)(function () {
	  return new Date(NaN).toJSON() !== null
	    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
	}), 'Date', {
	  // eslint-disable-next-line no-unused-vars
	  toJSON: function toJSON(key) {
	    var O = toObject(this);
	    var pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});


/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	var TO_PRIMITIVE = __webpack_require__(8)('toPrimitive');
	var proto = Date.prototype;
	
	if (!(TO_PRIMITIVE in proto)) __webpack_require__(16)(proto, TO_PRIMITIVE, __webpack_require__(268));


/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	var DateProto = Date.prototype;
	var INVALID_DATE = 'Invalid Date';
	var TO_STRING = 'toString';
	var $toString = DateProto[TO_STRING];
	var getTime = DateProto.getTime;
	if (new Date(NaN) + '' != INVALID_DATE) {
	  __webpack_require__(17)(DateProto, TO_STRING, function toString() {
	    var value = getTime.call(this);
	    // eslint-disable-next-line no-self-compare
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}


/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(1);
	
	$export($export.P, 'Function', { bind: __webpack_require__(159) });


/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var isObject = __webpack_require__(6);
	var getPrototypeOf = __webpack_require__(22);
	var HAS_INSTANCE = __webpack_require__(8)('hasInstance');
	var FunctionProto = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(10).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
	  if (typeof this != 'function' || !isObject(O)) return false;
	  if (!isObject(this.prototype)) return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
	  return false;
	} });


/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(10).f;
	var FProto = Function.prototype;
	var nameRE = /^\s*function ([^ (]*)/;
	var NAME = 'name';
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(9) && dP(FProto, NAME, {
	  configurable: true,
	  get: function () {
	    try {
	      return ('' + this).match(nameRE)[1];
	    } catch (e) {
	      return '';
	    }
	  }
	});


/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(1);
	var log1p = __webpack_require__(170);
	var sqrt = Math.sqrt;
	var $acosh = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x) {
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});


/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(1);
	var $asinh = Math.asinh;
	
	function asinh(x) {
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(1);
	var $atanh = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x) {
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});


/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(1);
	var sign = __webpack_require__(109);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x) {
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});


/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x) {
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});


/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(1);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x) {
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});


/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(1);
	var $expm1 = __webpack_require__(108);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', { fround: __webpack_require__(169) });


/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(1);
	var abs = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
	    var sum = 0;
	    var i = 0;
	    var aLen = arguments.length;
	    var larg = 0;
	    var arg, div;
	    while (i < aLen) {
	      arg = abs(arguments[i++]);
	      if (larg < arg) {
	        div = larg / arg;
	        sum = sum * div * div + 1;
	        larg = arg;
	      } else if (arg > 0) {
	        div = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});


/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(1);
	var $imul = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(5)(function () {
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y) {
	    var UINT16 = 0xffff;
	    var xn = +x;
	    var yn = +y;
	    var xl = UINT16 & xn;
	    var yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});


/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  log10: function log10(x) {
	    return Math.log(x) * Math.LOG10E;
	  }
	});


/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', { log1p: __webpack_require__(170) });


/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  log2: function log2(x) {
	    return Math.log(x) / Math.LN2;
	  }
	});


/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', { sign: __webpack_require__(109) });


/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(1);
	var expm1 = __webpack_require__(108);
	var exp = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(5)(function () {
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x) {
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});


/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(1);
	var expm1 = __webpack_require__(108);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x) {
	    var a = expm1(x = +x);
	    var b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});


/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it) {
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});


/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(4);
	var has = __webpack_require__(20);
	var cof = __webpack_require__(25);
	var inheritIfRequired = __webpack_require__(104);
	var toPrimitive = __webpack_require__(33);
	var fails = __webpack_require__(5);
	var gOPN = __webpack_require__(47).f;
	var gOPD = __webpack_require__(21).f;
	var dP = __webpack_require__(10).f;
	var $trim = __webpack_require__(56).trim;
	var NUMBER = 'Number';
	var $Number = global[NUMBER];
	var Base = $Number;
	var proto = $Number.prototype;
	// Opera ~12 has broken Object#toString
	var BROKEN_COF = cof(__webpack_require__(46)(proto)) == NUMBER;
	var TRIM = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function (argument) {
	  var it = toPrimitive(argument, false);
	  if (typeof it == 'string' && it.length > 2) {
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0);
	    var third, radix, maxCode;
	    if (first === 43 || first === 45) {
	      third = it.charCodeAt(2);
	      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if (first === 48) {
	      switch (it.charCodeAt(1)) {
	        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default: return +it;
	      }
	      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if (code < 48 || code > maxCode) return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
	  $Number = function Number(value) {
	    var it = arguments.length < 1 ? 0 : value;
	    var that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for (var keys = __webpack_require__(9) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++) {
	    if (has(Base, key = keys[j]) && !has($Number, key)) {
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(17)(global, NUMBER, $Number);
	}


/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export = __webpack_require__(1);
	var _isFinite = __webpack_require__(4).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it) {
	    return typeof it == 'number' && _isFinite(it);
	  }
	});


/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Number', { isInteger: __webpack_require__(166) });


/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number) {
	    // eslint-disable-next-line no-self-compare
	    return number != number;
	  }
	});


/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export = __webpack_require__(1);
	var isInteger = __webpack_require__(166);
	var abs = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number) {
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});


/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	var $parseFloat = __webpack_require__(178);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	var $parseInt = __webpack_require__(179);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var toInteger = __webpack_require__(32);
	var aNumberValue = __webpack_require__(155);
	var repeat = __webpack_require__(116);
	var $toFixed = 1.0.toFixed;
	var floor = Math.floor;
	var data = [0, 0, 0, 0, 0, 0];
	var ERROR = 'Number.toFixed: incorrect invocation!';
	var ZERO = '0';
	
	var multiply = function (n, c) {
	  var i = -1;
	  var c2 = c;
	  while (++i < 6) {
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function (n) {
	  var i = 6;
	  var c = 0;
	  while (--i >= 0) {
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function () {
	  var i = 6;
	  var s = '';
	  while (--i >= 0) {
	    if (s !== '' || i === 0 || data[i] !== 0) {
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function (x, n, acc) {
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function (x) {
	  var n = 0;
	  var x2 = x;
	  while (x2 >= 4096) {
	    n += 12;
	    x2 /= 4096;
	  }
	  while (x2 >= 2) {
	    n += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(5)(function () {
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits) {
	    var x = aNumberValue(this, ERROR);
	    var f = toInteger(fractionDigits);
	    var s = '';
	    var m = ZERO;
	    var e, z, j, k;
	    if (f < 0 || f > 20) throw RangeError(ERROR);
	    // eslint-disable-next-line no-self-compare
	    if (x != x) return 'NaN';
	    if (x <= -1e21 || x >= 1e21) return String(x);
	    if (x < 0) {
	      s = '-';
	      x = -x;
	    }
	    if (x > 1e-21) {
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if (e > 0) {
	        multiply(0, z);
	        j = f;
	        while (j >= 7) {
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while (j >= 23) {
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if (f > 0) {
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});


/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $fails = __webpack_require__(5);
	var aNumberValue = __webpack_require__(155);
	var $toPrecision = 1.0.toPrecision;
	
	$export($export.P + $export.F * ($fails(function () {
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function () {
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision) {
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
	  }
	});


/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(1);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(172) });


/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(46) });


/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(9), 'Object', { defineProperties: __webpack_require__(173) });


/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(9), 'Object', { defineProperty: __webpack_require__(10).f });


/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(6);
	var meta = __webpack_require__(39).onFreeze;
	
	__webpack_require__(31)('freeze', function ($freeze) {
	  return function freeze(it) {
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});


/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(23);
	var $getOwnPropertyDescriptor = __webpack_require__(21).f;
	
	__webpack_require__(31)('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});


/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(31)('getOwnPropertyNames', function () {
	  return __webpack_require__(174).f;
	});


/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(13);
	var $getPrototypeOf = __webpack_require__(22);
	
	__webpack_require__(31)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(6);
	
	__webpack_require__(31)('isExtensible', function ($isExtensible) {
	  return function isExtensible(it) {
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});


/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(6);
	
	__webpack_require__(31)('isFrozen', function ($isFrozen) {
	  return function isFrozen(it) {
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});


/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(6);
	
	__webpack_require__(31)('isSealed', function ($isSealed) {
	  return function isSealed(it) {
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});


/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(1);
	$export($export.S, 'Object', { is: __webpack_require__(271) });


/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(13);
	var $keys = __webpack_require__(48);
	
	__webpack_require__(31)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(6);
	var meta = __webpack_require__(39).onFreeze;
	
	__webpack_require__(31)('preventExtensions', function ($preventExtensions) {
	  return function preventExtensions(it) {
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});


/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(6);
	var meta = __webpack_require__(39).onFreeze;
	
	__webpack_require__(31)('seal', function ($seal) {
	  return function seal(it) {
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});


/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(1);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(112).set });


/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(61);
	var test = {};
	test[__webpack_require__(8)('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  __webpack_require__(17)(Object.prototype, 'toString', function toString() {
	    return '[object ' + classof(this) + ']';
	  }, true);
	}


/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	var $parseFloat = __webpack_require__(178);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	var $parseInt = __webpack_require__(179);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(38);
	var global = __webpack_require__(4);
	var ctx = __webpack_require__(27);
	var classof = __webpack_require__(61);
	var $export = __webpack_require__(1);
	var isObject = __webpack_require__(6);
	var aFunction = __webpack_require__(14);
	var anInstance = __webpack_require__(44);
	var forOf = __webpack_require__(45);
	var speciesConstructor = __webpack_require__(85);
	var task = __webpack_require__(118).set;
	var microtask = __webpack_require__(110)();
	var newPromiseCapabilityModule = __webpack_require__(111);
	var perform = __webpack_require__(180);
	var userAgent = __webpack_require__(87);
	var promiseResolve = __webpack_require__(181);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(8)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(50)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(55)($Promise, PROMISE);
	__webpack_require__(51)(PROMISE);
	Wrapper = __webpack_require__(26)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(79)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export = __webpack_require__(1);
	var aFunction = __webpack_require__(14);
	var anObject = __webpack_require__(3);
	var rApply = (__webpack_require__(4).Reflect || {}).apply;
	var fApply = Function.apply;
	// MS Edge argumentsList argument is optional
	$export($export.S + $export.F * !__webpack_require__(5)(function () {
	  rApply(function () { /* empty */ });
	}), 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList) {
	    var T = aFunction(target);
	    var L = anObject(argumentsList);
	    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	  }
	});


/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export = __webpack_require__(1);
	var create = __webpack_require__(46);
	var aFunction = __webpack_require__(14);
	var anObject = __webpack_require__(3);
	var isObject = __webpack_require__(6);
	var fails = __webpack_require__(5);
	var bind = __webpack_require__(159);
	var rConstruct = (__webpack_require__(4).Reflect || {}).construct;
	
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function () {
	  function F() { /* empty */ }
	  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
	});
	var ARGS_BUG = !fails(function () {
	  rConstruct(function () { /* empty */ });
	});
	
	$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	  construct: function construct(Target, args /* , newTarget */) {
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
	    if (Target == newTarget) {
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch (args.length) {
	        case 0: return new Target();
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args))();
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto = newTarget.prototype;
	    var instance = create(isObject(proto) ? proto : Object.prototype);
	    var result = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});


/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP = __webpack_require__(10);
	var $export = __webpack_require__(1);
	var anObject = __webpack_require__(3);
	var toPrimitive = __webpack_require__(33);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(5)(function () {
	  // eslint-disable-next-line no-undef
	  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes) {
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export = __webpack_require__(1);
	var gOPD = __webpack_require__(21).f;
	var anObject = __webpack_require__(3);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey) {
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});


/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export = __webpack_require__(1);
	var anObject = __webpack_require__(3);
	var Enumerate = function (iterated) {
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = [];      // keys
	  var key;
	  for (key in iterated) keys.push(key);
	};
	__webpack_require__(106)(Enumerate, 'Object', function () {
	  var that = this;
	  var keys = that._k;
	  var key;
	  do {
	    if (that._i >= keys.length) return { value: undefined, done: true };
	  } while (!((key = keys[that._i++]) in that._t));
	  return { value: key, done: false };
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target) {
	    return new Enumerate(target);
	  }
	});


/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD = __webpack_require__(21);
	var $export = __webpack_require__(1);
	var anObject = __webpack_require__(3);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});


/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export = __webpack_require__(1);
	var getProto = __webpack_require__(22);
	var anObject = __webpack_require__(3);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target) {
	    return getProto(anObject(target));
	  }
	});


/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD = __webpack_require__(21);
	var getPrototypeOf = __webpack_require__(22);
	var has = __webpack_require__(20);
	var $export = __webpack_require__(1);
	var isObject = __webpack_require__(6);
	var anObject = __webpack_require__(3);
	
	function get(target, propertyKey /* , receiver */) {
	  var receiver = arguments.length < 3 ? target : arguments[2];
	  var desc, proto;
	  if (anObject(target) === receiver) return target[propertyKey];
	  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', { get: get });


/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey) {
	    return propertyKey in target;
	  }
	});


/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export = __webpack_require__(1);
	var anObject = __webpack_require__(3);
	var $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target) {
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});


/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Reflect', { ownKeys: __webpack_require__(177) });


/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export = __webpack_require__(1);
	var anObject = __webpack_require__(3);
	var $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target) {
	    anObject(target);
	    try {
	      if ($preventExtensions) $preventExtensions(target);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export = __webpack_require__(1);
	var setProto = __webpack_require__(112);
	
	if (setProto) $export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto) {
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP = __webpack_require__(10);
	var gOPD = __webpack_require__(21);
	var getPrototypeOf = __webpack_require__(22);
	var has = __webpack_require__(20);
	var $export = __webpack_require__(1);
	var createDesc = __webpack_require__(49);
	var anObject = __webpack_require__(3);
	var isObject = __webpack_require__(6);
	
	function set(target, propertyKey, V /* , receiver */) {
	  var receiver = arguments.length < 4 ? target : arguments[3];
	  var ownDesc = gOPD.f(anObject(target), propertyKey);
	  var existingDescriptor, proto;
	  if (!ownDesc) {
	    if (isObject(proto = getPrototypeOf(target))) {
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if (has(ownDesc, 'value')) {
	    if (ownDesc.writable === false || !isObject(receiver)) return false;
	    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
	      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
	      existingDescriptor.value = V;
	      dP.f(receiver, propertyKey, existingDescriptor);
	    } else dP.f(receiver, propertyKey, createDesc(0, V));
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', { set: set });


/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(4);
	var inheritIfRequired = __webpack_require__(104);
	var dP = __webpack_require__(10).f;
	var gOPN = __webpack_require__(47).f;
	var isRegExp = __webpack_require__(78);
	var $flags = __webpack_require__(76);
	var $RegExp = global.RegExp;
	var Base = $RegExp;
	var proto = $RegExp.prototype;
	var re1 = /a/g;
	var re2 = /a/g;
	// "new" creates a new object, old webkit buggy here
	var CORRECT_NEW = new $RegExp(re1) !== re1;
	
	if (__webpack_require__(9) && (!CORRECT_NEW || __webpack_require__(5)(function () {
	  re2[__webpack_require__(8)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))) {
	  $RegExp = function RegExp(p, f) {
	    var tiRE = this instanceof $RegExp;
	    var piRE = isRegExp(p);
	    var fiU = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
	      , tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function (key) {
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function () { return Base[key]; },
	      set: function (it) { Base[key] = it; }
	    });
	  };
	  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(17)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(51)('RegExp');


/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	// @@match logic
	__webpack_require__(75)('match', 1, function (defined, MATCH, $match) {
	  // 21.1.3.11 String.prototype.match(regexp)
	  return [function match(regexp) {
	    'use strict';
	    var O = defined(this);
	    var fn = regexp == undefined ? undefined : regexp[MATCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	  }, $match];
	});


/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	// @@replace logic
	__webpack_require__(75)('replace', 2, function (defined, REPLACE, $replace) {
	  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
	  return [function replace(searchValue, replaceValue) {
	    'use strict';
	    var O = defined(this);
	    var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	    return fn !== undefined
	      ? fn.call(searchValue, O, replaceValue)
	      : $replace.call(String(O), searchValue, replaceValue);
	  }, $replace];
	});


/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	// @@search logic
	__webpack_require__(75)('search', 1, function (defined, SEARCH, $search) {
	  // 21.1.3.15 String.prototype.search(regexp)
	  return [function search(regexp) {
	    'use strict';
	    var O = defined(this);
	    var fn = regexp == undefined ? undefined : regexp[SEARCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	  }, $search];
	});


/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	// @@split logic
	__webpack_require__(75)('split', 2, function (defined, SPLIT, $split) {
	  'use strict';
	  var isRegExp = __webpack_require__(78);
	  var _split = $split;
	  var $push = [].push;
	  var $SPLIT = 'split';
	  var LENGTH = 'length';
	  var LAST_INDEX = 'lastIndex';
	  if (
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ) {
	    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
	    // based on es5-shim implementation, need to rework it
	    $split = function (separator, limit) {
	      var string = String(this);
	      if (separator === undefined && limit === 0) return [];
	      // If `separator` is not a regex, use native split
	      if (!isRegExp(separator)) return _split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var separator2, match, lastIndex, lastLength, i;
	      // Doesn't need flags gy, but they don't hurt
	      if (!NPCG) separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
	      while (match = separatorCopy.exec(string)) {
	        // `separatorCopy.lastIndex` is not reliable cross-browser
	        lastIndex = match.index + match[0][LENGTH];
	        if (lastIndex > lastLastIndex) {
	          output.push(string.slice(lastLastIndex, match.index));
	          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
	          // eslint-disable-next-line no-loop-func
	          if (!NPCG && match[LENGTH] > 1) match[0].replace(separator2, function () {
	            for (i = 1; i < arguments[LENGTH] - 2; i++) if (arguments[i] === undefined) match[i] = undefined;
	          });
	          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if (output[LENGTH] >= splitLimit) break;
	        }
	        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if (lastLastIndex === string[LENGTH]) {
	        if (lastLength || !separatorCopy.test('')) output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
	    $split = function (separator, limit) {
	      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
	    };
	  }
	  // 21.1.3.17 String.prototype.split(separator, limit)
	  return [function split(separator, limit) {
	    var O = defined(this);
	    var fn = separator == undefined ? undefined : separator[SPLIT];
	    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
	  }, $split];
	});


/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(186);
	var anObject = __webpack_require__(3);
	var $flags = __webpack_require__(76);
	var DESCRIPTORS = __webpack_require__(9);
	var TO_STRING = 'toString';
	var $toString = /./[TO_STRING];
	
	var define = function (fn) {
	  __webpack_require__(17)(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if (__webpack_require__(5)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
	  define(function toString() {
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if ($toString.name != TO_STRING) {
	  define(function toString() {
	    return $toString.call(this);
	  });
	}


/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__(18)('anchor', function (createHTML) {
	  return function anchor(name) {
	    return createHTML(this, 'a', 'name', name);
	  };
	});


/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	__webpack_require__(18)('big', function (createHTML) {
	  return function big() {
	    return createHTML(this, 'big', '', '');
	  };
	});


/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	__webpack_require__(18)('blink', function (createHTML) {
	  return function blink() {
	    return createHTML(this, 'blink', '', '');
	  };
	});


/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	__webpack_require__(18)('bold', function (createHTML) {
	  return function bold() {
	    return createHTML(this, 'b', '', '');
	  };
	});


/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $at = __webpack_require__(114)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos) {
	    return $at(this, pos);
	  }
	});


/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export = __webpack_require__(1);
	var toLength = __webpack_require__(11);
	var context = __webpack_require__(115);
	var ENDS_WITH = 'endsWith';
	var $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(102)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /* , endPosition = @length */) {
	    var that = context(this, searchString, ENDS_WITH);
	    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
	    var len = toLength(that.length);
	    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
	    var search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});


/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__(18)('fixed', function (createHTML) {
	  return function fixed() {
	    return createHTML(this, 'tt', '', '');
	  };
	});


/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__(18)('fontcolor', function (createHTML) {
	  return function fontcolor(color) {
	    return createHTML(this, 'font', 'color', color);
	  };
	});


/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__(18)('fontsize', function (createHTML) {
	  return function fontsize(size) {
	    return createHTML(this, 'font', 'size', size);
	  };
	});


/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	var toAbsoluteIndex = __webpack_require__(52);
	var fromCharCode = String.fromCharCode;
	var $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
	    var res = [];
	    var aLen = arguments.length;
	    var i = 0;
	    var code;
	    while (aLen > i) {
	      code = +arguments[i++];
	      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});


/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export = __webpack_require__(1);
	var context = __webpack_require__(115);
	var INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(102)(INCLUDES), 'String', {
	  includes: function includes(searchString /* , position = 0 */) {
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	__webpack_require__(18)('italics', function (createHTML) {
	  return function italics() {
	    return createHTML(this, 'i', '', '');
	  };
	});


/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(114)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(107)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__(18)('link', function (createHTML) {
	  return function link(url) {
	    return createHTML(this, 'a', 'href', url);
	  };
	});


/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	var toIObject = __webpack_require__(23);
	var toLength = __webpack_require__(11);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite) {
	    var tpl = toIObject(callSite.raw);
	    var len = toLength(tpl.length);
	    var aLen = arguments.length;
	    var res = [];
	    var i = 0;
	    while (len > i) {
	      res.push(String(tpl[i++]));
	      if (i < aLen) res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});


/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(116)
	});


/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	__webpack_require__(18)('small', function (createHTML) {
	  return function small() {
	    return createHTML(this, 'small', '', '');
	  };
	});


/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export = __webpack_require__(1);
	var toLength = __webpack_require__(11);
	var context = __webpack_require__(115);
	var STARTS_WITH = 'startsWith';
	var $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(102)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /* , position = 0 */) {
	    var that = context(this, searchString, STARTS_WITH);
	    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
	    var search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});


/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	__webpack_require__(18)('strike', function (createHTML) {
	  return function strike() {
	    return createHTML(this, 'strike', '', '');
	  };
	});


/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	__webpack_require__(18)('sub', function (createHTML) {
	  return function sub() {
	    return createHTML(this, 'sub', '', '');
	  };
	});


/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	__webpack_require__(18)('sup', function (createHTML) {
	  return function sup() {
	    return createHTML(this, 'sup', '', '');
	  };
	});


/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(56)('trim', function ($trim) {
	  return function trim() {
	    return $trim(this, 3);
	  };
	});


/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(4);
	var has = __webpack_require__(20);
	var DESCRIPTORS = __webpack_require__(9);
	var $export = __webpack_require__(1);
	var redefine = __webpack_require__(17);
	var META = __webpack_require__(39).KEY;
	var $fails = __webpack_require__(5);
	var shared = __webpack_require__(84);
	var setToStringTag = __webpack_require__(55);
	var uid = __webpack_require__(53);
	var wks = __webpack_require__(8);
	var wksExt = __webpack_require__(184);
	var wksDefine = __webpack_require__(120);
	var enumKeys = __webpack_require__(269);
	var isArray = __webpack_require__(77);
	var anObject = __webpack_require__(3);
	var isObject = __webpack_require__(6);
	var toIObject = __webpack_require__(23);
	var toPrimitive = __webpack_require__(33);
	var createDesc = __webpack_require__(49);
	var _create = __webpack_require__(46);
	var gOPNExt = __webpack_require__(174);
	var $GOPD = __webpack_require__(21);
	var $DP = __webpack_require__(10);
	var $keys = __webpack_require__(48);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function';
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(47).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(63).f = $propertyIsEnumerable;
	  __webpack_require__(81).f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(38)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(16)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $typed = __webpack_require__(86);
	var buffer = __webpack_require__(119);
	var anObject = __webpack_require__(3);
	var toAbsoluteIndex = __webpack_require__(52);
	var toLength = __webpack_require__(11);
	var isObject = __webpack_require__(6);
	var ArrayBuffer = __webpack_require__(4).ArrayBuffer;
	var speciesConstructor = __webpack_require__(85);
	var $ArrayBuffer = buffer.ArrayBuffer;
	var $DataView = buffer.DataView;
	var $isView = $typed.ABV && ArrayBuffer.isView;
	var $slice = $ArrayBuffer.prototype.slice;
	var VIEW = $typed.VIEW;
	var ARRAY_BUFFER = 'ArrayBuffer';
	
	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });
	
	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it) {
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});
	
	$export($export.P + $export.U + $export.F * __webpack_require__(5)(function () {
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end) {
	    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
	    var len = anObject(this).byteLength;
	    var first = toAbsoluteIndex(start, len);
	    var final = toAbsoluteIndex(end === undefined ? len : end, len);
	    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first));
	    var viewS = new $DataView(this);
	    var viewT = new $DataView(result);
	    var index = 0;
	    while (first < final) {
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    } return result;
	  }
	});
	
	__webpack_require__(51)(ARRAY_BUFFER);


/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	$export($export.G + $export.W + $export.F * !__webpack_require__(86).ABV, {
	  DataView: __webpack_require__(119).DataView
	});


/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(36)('Float32', 4, function (init) {
	  return function Float32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(36)('Float64', 8, function (init) {
	  return function Float64Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(36)('Int16', 2, function (init) {
	  return function Int16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(36)('Int32', 4, function (init) {
	  return function Int32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(36)('Int8', 1, function (init) {
	  return function Int8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(36)('Uint16', 2, function (init) {
	  return function Uint16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(36)('Uint32', 4, function (init) {
	  return function Uint32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(36)('Uint8', 1, function (init) {
	  return function Uint8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(36)('Uint8', 1, function (init) {
	  return function Uint8ClampedArray(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	}, true);


/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(162);
	var validate = __webpack_require__(57);
	var WEAK_SET = 'WeakSet';
	
	// 23.4 WeakSet Objects
	__webpack_require__(74)(WEAK_SET, function (get) {
	  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value) {
	    return weak.def(validate(this, WEAK_SET), value, true);
	  }
	}, weak, false, true);


/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
	var $export = __webpack_require__(1);
	var flattenIntoArray = __webpack_require__(163);
	var toObject = __webpack_require__(13);
	var toLength = __webpack_require__(11);
	var aFunction = __webpack_require__(14);
	var arraySpeciesCreate = __webpack_require__(98);
	
	$export($export.P, 'Array', {
	  flatMap: function flatMap(callbackfn /* , thisArg */) {
	    var O = toObject(this);
	    var sourceLen, A;
	    aFunction(callbackfn);
	    sourceLen = toLength(O.length);
	    A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
	    return A;
	  }
	});
	
	__webpack_require__(37)('flatMap');


/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
	var $export = __webpack_require__(1);
	var flattenIntoArray = __webpack_require__(163);
	var toObject = __webpack_require__(13);
	var toLength = __webpack_require__(11);
	var toInteger = __webpack_require__(32);
	var arraySpeciesCreate = __webpack_require__(98);
	
	$export($export.P, 'Array', {
	  flatten: function flatten(/* depthArg = 1 */) {
	    var depthArg = arguments[0];
	    var O = toObject(this);
	    var sourceLen = toLength(O.length);
	    var A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
	    return A;
	  }
	});
	
	__webpack_require__(37)('flatten');


/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export = __webpack_require__(1);
	var $includes = __webpack_require__(73)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /* , fromIndex = 0 */) {
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(37)('includes');


/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	var $export = __webpack_require__(1);
	var microtask = __webpack_require__(110)();
	var process = __webpack_require__(4).process;
	var isNode = __webpack_require__(25)(process) == 'process';
	
	$export($export.G, {
	  asap: function asap(fn) {
	    var domain = isNode && process.domain;
	    microtask(domain ? domain.bind(fn) : fn);
	  }
	});


/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-is-error
	var $export = __webpack_require__(1);
	var cof = __webpack_require__(25);
	
	$export($export.S, 'Error', {
	  isError: function isError(it) {
	    return cof(it) === 'Error';
	  }
	});


/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(1);
	
	$export($export.G, { global: __webpack_require__(4) });


/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
	__webpack_require__(82)('Map');


/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
	__webpack_require__(83)('Map');


/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(1);
	
	$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(161)('Map') });


/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  clamp: function clamp(x, lower, upper) {
	    return Math.min(upper, Math.max(lower, x));
	  }
	});


/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(1);
	var RAD_PER_DEG = 180 / Math.PI;
	
	$export($export.S, 'Math', {
	  degrees: function degrees(radians) {
	    return radians * RAD_PER_DEG;
	  }
	});


/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(1);
	var scale = __webpack_require__(171);
	var fround = __webpack_require__(169);
	
	$export($export.S, 'Math', {
	  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
	    return fround(scale(x, inLow, inHigh, outLow, outHigh));
	  }
	});


/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  iaddh: function iaddh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	  }
	});


/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  imulh: function imulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >> 16;
	    var v1 = $v >> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	  }
	});


/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  isubh: function isubh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	  }
	});


/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(1);
	var DEG_PER_RAD = Math.PI / 180;
	
	$export($export.S, 'Math', {
	  radians: function radians(degrees) {
	    return degrees * DEG_PER_RAD;
	  }
	});


/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', { scale: __webpack_require__(171) });


/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	// http://jfbastien.github.io/papers/Math.signbit.html
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', { signbit: function signbit(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
	} });


/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  umulh: function umulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >>> 16;
	    var v1 = $v >>> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	  }
	});


/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var toObject = __webpack_require__(13);
	var aFunction = __webpack_require__(14);
	var $defineProperty = __webpack_require__(10);
	
	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__(9) && $export($export.P + __webpack_require__(80), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter) {
	    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
	  }
	});


/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var toObject = __webpack_require__(13);
	var aFunction = __webpack_require__(14);
	var $defineProperty = __webpack_require__(10);
	
	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__(9) && $export($export.P + __webpack_require__(80), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter) {
	    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
	  }
	});


/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(1);
	var $entries = __webpack_require__(176)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});


/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export = __webpack_require__(1);
	var ownKeys = __webpack_require__(177);
	var toIObject = __webpack_require__(23);
	var gOPD = __webpack_require__(21);
	var createProperty = __webpack_require__(99);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
	    var O = toIObject(object);
	    var getDesc = gOPD.f;
	    var keys = ownKeys(O);
	    var result = {};
	    var i = 0;
	    var key, desc;
	    while (keys.length > i) {
	      desc = getDesc(O, key = keys[i++]);
	      if (desc !== undefined) createProperty(result, key, desc);
	    }
	    return result;
	  }
	});


/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var toObject = __webpack_require__(13);
	var toPrimitive = __webpack_require__(33);
	var getPrototypeOf = __webpack_require__(22);
	var getOwnPropertyDescriptor = __webpack_require__(21).f;
	
	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__(9) && $export($export.P + __webpack_require__(80), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var toObject = __webpack_require__(13);
	var toPrimitive = __webpack_require__(33);
	var getPrototypeOf = __webpack_require__(22);
	var getOwnPropertyDescriptor = __webpack_require__(21).f;
	
	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__(9) && $export($export.P + __webpack_require__(80), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(1);
	var $values = __webpack_require__(176)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/zenparsing/es-observable
	var $export = __webpack_require__(1);
	var global = __webpack_require__(4);
	var core = __webpack_require__(26);
	var microtask = __webpack_require__(110)();
	var OBSERVABLE = __webpack_require__(8)('observable');
	var aFunction = __webpack_require__(14);
	var anObject = __webpack_require__(3);
	var anInstance = __webpack_require__(44);
	var redefineAll = __webpack_require__(50);
	var hide = __webpack_require__(16);
	var forOf = __webpack_require__(45);
	var RETURN = forOf.RETURN;
	
	var getMethod = function (fn) {
	  return fn == null ? undefined : aFunction(fn);
	};
	
	var cleanupSubscription = function (subscription) {
	  var cleanup = subscription._c;
	  if (cleanup) {
	    subscription._c = undefined;
	    cleanup();
	  }
	};
	
	var subscriptionClosed = function (subscription) {
	  return subscription._o === undefined;
	};
	
	var closeSubscription = function (subscription) {
	  if (!subscriptionClosed(subscription)) {
	    subscription._o = undefined;
	    cleanupSubscription(subscription);
	  }
	};
	
	var Subscription = function (observer, subscriber) {
	  anObject(observer);
	  this._c = undefined;
	  this._o = observer;
	  observer = new SubscriptionObserver(this);
	  try {
	    var cleanup = subscriber(observer);
	    var subscription = cleanup;
	    if (cleanup != null) {
	      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
	      else aFunction(cleanup);
	      this._c = cleanup;
	    }
	  } catch (e) {
	    observer.error(e);
	    return;
	  } if (subscriptionClosed(this)) cleanupSubscription(this);
	};
	
	Subscription.prototype = redefineAll({}, {
	  unsubscribe: function unsubscribe() { closeSubscription(this); }
	});
	
	var SubscriptionObserver = function (subscription) {
	  this._s = subscription;
	};
	
	SubscriptionObserver.prototype = redefineAll({}, {
	  next: function next(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      try {
	        var m = getMethod(observer.next);
	        if (m) return m.call(observer, value);
	      } catch (e) {
	        try {
	          closeSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }
	    }
	  },
	  error: function error(value) {
	    var subscription = this._s;
	    if (subscriptionClosed(subscription)) throw value;
	    var observer = subscription._o;
	    subscription._o = undefined;
	    try {
	      var m = getMethod(observer.error);
	      if (!m) throw value;
	      value = m.call(observer, value);
	    } catch (e) {
	      try {
	        cleanupSubscription(subscription);
	      } finally {
	        throw e;
	      }
	    } cleanupSubscription(subscription);
	    return value;
	  },
	  complete: function complete(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      subscription._o = undefined;
	      try {
	        var m = getMethod(observer.complete);
	        value = m ? m.call(observer, value) : undefined;
	      } catch (e) {
	        try {
	          cleanupSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      } cleanupSubscription(subscription);
	      return value;
	    }
	  }
	});
	
	var $Observable = function Observable(subscriber) {
	  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	};
	
	redefineAll($Observable.prototype, {
	  subscribe: function subscribe(observer) {
	    return new Subscription(observer, this._f);
	  },
	  forEach: function forEach(fn) {
	    var that = this;
	    return new (core.Promise || global.Promise)(function (resolve, reject) {
	      aFunction(fn);
	      var subscription = that.subscribe({
	        next: function (value) {
	          try {
	            return fn(value);
	          } catch (e) {
	            reject(e);
	            subscription.unsubscribe();
	          }
	        },
	        error: reject,
	        complete: resolve
	      });
	    });
	  }
	});
	
	redefineAll($Observable, {
	  from: function from(x) {
	    var C = typeof this === 'function' ? this : $Observable;
	    var method = getMethod(anObject(x)[OBSERVABLE]);
	    if (method) {
	      var observable = anObject(method.call(x));
	      return observable.constructor === C ? observable : new C(function (observer) {
	        return observable.subscribe(observer);
	      });
	    }
	    return new C(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          try {
	            if (forOf(x, false, function (it) {
	              observer.next(it);
	              if (done) return RETURN;
	            }) === RETURN) return;
	          } catch (e) {
	            if (done) throw e;
	            observer.error(e);
	            return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  },
	  of: function of() {
	    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
	    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          for (var j = 0; j < items.length; ++j) {
	            observer.next(items[j]);
	            if (done) return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  }
	});
	
	hide($Observable.prototype, OBSERVABLE, function () { return this; });
	
	$export($export.G, { Observable: $Observable });
	
	__webpack_require__(51)('Observable');


/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(1);
	var core = __webpack_require__(26);
	var global = __webpack_require__(4);
	var speciesConstructor = __webpack_require__(85);
	var promiseResolve = __webpack_require__(181);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(1);
	var newPromiseCapability = __webpack_require__(111);
	var perform = __webpack_require__(180);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(35);
	var anObject = __webpack_require__(3);
	var toMetaKey = metadata.key;
	var ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
	  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	} });


/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(35);
	var anObject = __webpack_require__(3);
	var toMetaKey = metadata.key;
	var getOrCreateMetadataMap = metadata.map;
	var store = metadata.store;
	
	metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
	  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
	  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
	  if (metadataMap.size) return true;
	  var targetMetadata = store.get(target);
	  targetMetadata['delete'](targetKey);
	  return !!targetMetadata.size || store['delete'](target);
	} });


/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(187);
	var from = __webpack_require__(157);
	var metadata = __webpack_require__(35);
	var anObject = __webpack_require__(3);
	var getPrototypeOf = __webpack_require__(22);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	var ordinaryMetadataKeys = function (O, P) {
	  var oKeys = ordinaryOwnMetadataKeys(O, P);
	  var parent = getPrototypeOf(O);
	  if (parent === null) return oKeys;
	  var pKeys = ordinaryMetadataKeys(parent, P);
	  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	};
	
	metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
	  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(35);
	var anObject = __webpack_require__(3);
	var getPrototypeOf = __webpack_require__(22);
	var ordinaryHasOwnMetadata = metadata.has;
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	var ordinaryGetMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	};
	
	metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(35);
	var anObject = __webpack_require__(3);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
	  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(35);
	var anObject = __webpack_require__(3);
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(35);
	var anObject = __webpack_require__(3);
	var getPrototypeOf = __webpack_require__(22);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	var ordinaryHasMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return true;
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	};
	
	metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(35);
	var anObject = __webpack_require__(3);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	var $metadata = __webpack_require__(35);
	var anObject = __webpack_require__(3);
	var aFunction = __webpack_require__(14);
	var toMetaKey = $metadata.key;
	var ordinaryDefineOwnMetadata = $metadata.set;
	
	$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
	  return function decorator(target, targetKey) {
	    ordinaryDefineOwnMetadata(
	      metadataKey, metadataValue,
	      (targetKey !== undefined ? anObject : aFunction)(target),
	      toMetaKey(targetKey)
	    );
	  };
	} });


/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
	__webpack_require__(82)('Set');


/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
	__webpack_require__(83)('Set');


/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(1);
	
	$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(161)('Set') });


/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(1);
	var $at = __webpack_require__(114)(true);
	
	$export($export.P, 'String', {
	  at: function at(pos) {
	    return $at(this, pos);
	  }
	});


/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/String.prototype.matchAll/
	var $export = __webpack_require__(1);
	var defined = __webpack_require__(30);
	var toLength = __webpack_require__(11);
	var isRegExp = __webpack_require__(78);
	var getFlags = __webpack_require__(76);
	var RegExpProto = RegExp.prototype;
	
	var $RegExpStringIterator = function (regexp, string) {
	  this._r = regexp;
	  this._s = string;
	};
	
	__webpack_require__(106)($RegExpStringIterator, 'RegExp String', function next() {
	  var match = this._r.exec(this._s);
	  return { value: match, done: match === null };
	});
	
	$export($export.P, 'String', {
	  matchAll: function matchAll(regexp) {
	    defined(this);
	    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
	    var S = String(this);
	    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
	    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	    rx.lastIndex = toLength(regexp.lastIndex);
	    return new $RegExpStringIterator(rx, S);
	  }
	});


/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(1);
	var $pad = __webpack_require__(182);
	var userAgent = __webpack_require__(87);
	
	// https://github.com/zloirock/core-js/issues/280
	$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
	  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});


/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(1);
	var $pad = __webpack_require__(182);
	var userAgent = __webpack_require__(87);
	
	// https://github.com/zloirock/core-js/issues/280
	$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
	  padStart: function padStart(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});


/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(56)('trimLeft', function ($trim) {
	  return function trimLeft() {
	    return $trim(this, 1);
	  };
	}, 'trimStart');


/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(56)('trimRight', function ($trim) {
	  return function trimRight() {
	    return $trim(this, 2);
	  };
	}, 'trimEnd');


/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(120)('asyncIterator');


/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(120)('observable');


/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(1);
	
	$export($export.S, 'System', { global: __webpack_require__(4) });


/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
	__webpack_require__(82)('WeakMap');


/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
	__webpack_require__(83)('WeakMap');


/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
	__webpack_require__(82)('WeakSet');


/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
	__webpack_require__(83)('WeakSet');


/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	var $iterators = __webpack_require__(122);
	var getKeys = __webpack_require__(48);
	var redefine = __webpack_require__(17);
	var global = __webpack_require__(4);
	var hide = __webpack_require__(16);
	var Iterators = __webpack_require__(54);
	var wks = __webpack_require__(8);
	var ITERATOR = wks('iterator');
	var TO_STRING_TAG = wks('toStringTag');
	var ArrayValues = Iterators.Array;
	
	var DOMIterables = {
	  CSSRuleList: true, // TODO: Not spec compliant, should be false.
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true, // TODO: Not spec compliant, should be false.
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true, // TODO: Not spec compliant, should be false.
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	
	for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
	    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
	  }
	}


/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	var $task = __webpack_require__(118);
	$export($export.G + $export.B, {
	  setImmediate: $task.set,
	  clearImmediate: $task.clear
	});


/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global = __webpack_require__(4);
	var $export = __webpack_require__(1);
	var userAgent = __webpack_require__(87);
	var slice = [].slice;
	var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
	var wrap = function (set) {
	  return function (fn, time /* , ...args */) {
	    var boundArgs = arguments.length > 2;
	    var args = boundArgs ? slice.call(arguments, 2) : false;
	    return set(boundArgs ? function () {
	      // eslint-disable-next-line no-new-func
	      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
	    } : fn, time);
	  };
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout: wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});


/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(392);
	__webpack_require__(331);
	__webpack_require__(333);
	__webpack_require__(332);
	__webpack_require__(335);
	__webpack_require__(337);
	__webpack_require__(342);
	__webpack_require__(336);
	__webpack_require__(334);
	__webpack_require__(344);
	__webpack_require__(343);
	__webpack_require__(339);
	__webpack_require__(340);
	__webpack_require__(338);
	__webpack_require__(330);
	__webpack_require__(341);
	__webpack_require__(345);
	__webpack_require__(346);
	__webpack_require__(298);
	__webpack_require__(300);
	__webpack_require__(299);
	__webpack_require__(348);
	__webpack_require__(347);
	__webpack_require__(318);
	__webpack_require__(328);
	__webpack_require__(329);
	__webpack_require__(319);
	__webpack_require__(320);
	__webpack_require__(321);
	__webpack_require__(322);
	__webpack_require__(323);
	__webpack_require__(324);
	__webpack_require__(325);
	__webpack_require__(326);
	__webpack_require__(327);
	__webpack_require__(301);
	__webpack_require__(302);
	__webpack_require__(303);
	__webpack_require__(304);
	__webpack_require__(305);
	__webpack_require__(306);
	__webpack_require__(307);
	__webpack_require__(308);
	__webpack_require__(309);
	__webpack_require__(310);
	__webpack_require__(311);
	__webpack_require__(312);
	__webpack_require__(313);
	__webpack_require__(314);
	__webpack_require__(315);
	__webpack_require__(316);
	__webpack_require__(317);
	__webpack_require__(379);
	__webpack_require__(384);
	__webpack_require__(391);
	__webpack_require__(382);
	__webpack_require__(374);
	__webpack_require__(375);
	__webpack_require__(380);
	__webpack_require__(385);
	__webpack_require__(387);
	__webpack_require__(370);
	__webpack_require__(371);
	__webpack_require__(372);
	__webpack_require__(373);
	__webpack_require__(376);
	__webpack_require__(377);
	__webpack_require__(378);
	__webpack_require__(381);
	__webpack_require__(383);
	__webpack_require__(386);
	__webpack_require__(388);
	__webpack_require__(389);
	__webpack_require__(390);
	__webpack_require__(293);
	__webpack_require__(295);
	__webpack_require__(294);
	__webpack_require__(297);
	__webpack_require__(296);
	__webpack_require__(282);
	__webpack_require__(280);
	__webpack_require__(286);
	__webpack_require__(283);
	__webpack_require__(289);
	__webpack_require__(291);
	__webpack_require__(279);
	__webpack_require__(285);
	__webpack_require__(276);
	__webpack_require__(290);
	__webpack_require__(274);
	__webpack_require__(288);
	__webpack_require__(287);
	__webpack_require__(281);
	__webpack_require__(284);
	__webpack_require__(273);
	__webpack_require__(275);
	__webpack_require__(278);
	__webpack_require__(277);
	__webpack_require__(292);
	__webpack_require__(122);
	__webpack_require__(364);
	__webpack_require__(369);
	__webpack_require__(186);
	__webpack_require__(365);
	__webpack_require__(366);
	__webpack_require__(367);
	__webpack_require__(368);
	__webpack_require__(349);
	__webpack_require__(185);
	__webpack_require__(187);
	__webpack_require__(188);
	__webpack_require__(404);
	__webpack_require__(393);
	__webpack_require__(394);
	__webpack_require__(399);
	__webpack_require__(402);
	__webpack_require__(403);
	__webpack_require__(397);
	__webpack_require__(400);
	__webpack_require__(398);
	__webpack_require__(401);
	__webpack_require__(395);
	__webpack_require__(396);
	__webpack_require__(350);
	__webpack_require__(351);
	__webpack_require__(352);
	__webpack_require__(353);
	__webpack_require__(354);
	__webpack_require__(357);
	__webpack_require__(355);
	__webpack_require__(356);
	__webpack_require__(358);
	__webpack_require__(359);
	__webpack_require__(360);
	__webpack_require__(361);
	__webpack_require__(363);
	__webpack_require__(362);
	__webpack_require__(407);
	__webpack_require__(405);
	__webpack_require__(406);
	__webpack_require__(448);
	__webpack_require__(451);
	__webpack_require__(450);
	__webpack_require__(452);
	__webpack_require__(453);
	__webpack_require__(449);
	__webpack_require__(454);
	__webpack_require__(455);
	__webpack_require__(429);
	__webpack_require__(432);
	__webpack_require__(428);
	__webpack_require__(426);
	__webpack_require__(427);
	__webpack_require__(430);
	__webpack_require__(431);
	__webpack_require__(413);
	__webpack_require__(447);
	__webpack_require__(412);
	__webpack_require__(446);
	__webpack_require__(458);
	__webpack_require__(460);
	__webpack_require__(411);
	__webpack_require__(445);
	__webpack_require__(457);
	__webpack_require__(459);
	__webpack_require__(410);
	__webpack_require__(456);
	__webpack_require__(409);
	__webpack_require__(414);
	__webpack_require__(415);
	__webpack_require__(416);
	__webpack_require__(417);
	__webpack_require__(418);
	__webpack_require__(420);
	__webpack_require__(419);
	__webpack_require__(421);
	__webpack_require__(422);
	__webpack_require__(423);
	__webpack_require__(425);
	__webpack_require__(424);
	__webpack_require__(434);
	__webpack_require__(435);
	__webpack_require__(436);
	__webpack_require__(437);
	__webpack_require__(439);
	__webpack_require__(438);
	__webpack_require__(441);
	__webpack_require__(440);
	__webpack_require__(442);
	__webpack_require__(443);
	__webpack_require__(444);
	__webpack_require__(408);
	__webpack_require__(433);
	__webpack_require__(463);
	__webpack_require__(462);
	__webpack_require__(461);
	module.exports = __webpack_require__(26);


/***/ },
/* 465 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 466 */
/***/ function(module, exports) {

	'use strict';
	
	var toString = Object.prototype.toString,
	    hasOwnProperty = Object.prototype.hasOwnProperty;
	
	module.exports = function(object) {
	    if(!object) return console.warn('bindAll requires at least one argument.');
	
	    var functions = Array.prototype.slice.call(arguments, 1);
	
	    if (functions.length === 0) {
	
	        for (var method in object) {
	            if(hasOwnProperty.call(object, method)) {
	                if(typeof object[method] == 'function' && toString.call(object[method]) == "[object Function]") {
	                    functions.push(method);
	                }
	            }
	        }
	    }
	
	    for(var i = 0; i < functions.length; i++) {
	        var f = functions[i];
	        object[f] = bind(object[f], object);
	    }
	};
	
	/*
	    Faster bind without specific-case checking. (see https://coderwall.com/p/oi3j3w).
	    bindAll is only needed for events binding so no need to make slow fixes for constructor
	    or partial application.
	*/
	function bind(func, context) {
	  return function() {
	    return func.apply(context, arguments);
	  };
	}

/***/ },
/* 467 */
/***/ function(module, exports) {

	/*!
	 * cookie
	 * Copyright(c) 2012-2014 Roman Shtylman
	 * Copyright(c) 2015 Douglas Christopher Wilson
	 * MIT Licensed
	 */
	
	'use strict';
	
	/**
	 * Module exports.
	 * @public
	 */
	
	exports.parse = parse;
	exports.serialize = serialize;
	
	/**
	 * Module variables.
	 * @private
	 */
	
	var decode = decodeURIComponent;
	var encode = encodeURIComponent;
	var pairSplitRegExp = /; */;
	
	/**
	 * RegExp to match field-content in RFC 7230 sec 3.2
	 *
	 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
	 * field-vchar   = VCHAR / obs-text
	 * obs-text      = %x80-FF
	 */
	
	var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
	
	/**
	 * Parse a cookie header.
	 *
	 * Parse the given cookie header string into an object
	 * The object has the various cookies as keys(names) => values
	 *
	 * @param {string} str
	 * @param {object} [options]
	 * @return {object}
	 * @public
	 */
	
	function parse(str, options) {
	  if (typeof str !== 'string') {
	    throw new TypeError('argument str must be a string');
	  }
	
	  var obj = {}
	  var opt = options || {};
	  var pairs = str.split(pairSplitRegExp);
	  var dec = opt.decode || decode;
	
	  for (var i = 0; i < pairs.length; i++) {
	    var pair = pairs[i];
	    var eq_idx = pair.indexOf('=');
	
	    // skip things that don't look like key=value
	    if (eq_idx < 0) {
	      continue;
	    }
	
	    var key = pair.substr(0, eq_idx).trim()
	    var val = pair.substr(++eq_idx, pair.length).trim();
	
	    // quoted values
	    if ('"' == val[0]) {
	      val = val.slice(1, -1);
	    }
	
	    // only assign once
	    if (undefined == obj[key]) {
	      obj[key] = tryDecode(val, dec);
	    }
	  }
	
	  return obj;
	}
	
	/**
	 * Serialize data into a cookie header.
	 *
	 * Serialize the a name value pair into a cookie string suitable for
	 * http headers. An optional options object specified cookie parameters.
	 *
	 * serialize('foo', 'bar', { httpOnly: true })
	 *   => "foo=bar; httpOnly"
	 *
	 * @param {string} name
	 * @param {string} val
	 * @param {object} [options]
	 * @return {string}
	 * @public
	 */
	
	function serialize(name, val, options) {
	  var opt = options || {};
	  var enc = opt.encode || encode;
	
	  if (typeof enc !== 'function') {
	    throw new TypeError('option encode is invalid');
	  }
	
	  if (!fieldContentRegExp.test(name)) {
	    throw new TypeError('argument name is invalid');
	  }
	
	  var value = enc(val);
	
	  if (value && !fieldContentRegExp.test(value)) {
	    throw new TypeError('argument val is invalid');
	  }
	
	  var str = name + '=' + value;
	
	  if (null != opt.maxAge) {
	    var maxAge = opt.maxAge - 0;
	    if (isNaN(maxAge)) throw new Error('maxAge should be a Number');
	    str += '; Max-Age=' + Math.floor(maxAge);
	  }
	
	  if (opt.domain) {
	    if (!fieldContentRegExp.test(opt.domain)) {
	      throw new TypeError('option domain is invalid');
	    }
	
	    str += '; Domain=' + opt.domain;
	  }
	
	  if (opt.path) {
	    if (!fieldContentRegExp.test(opt.path)) {
	      throw new TypeError('option path is invalid');
	    }
	
	    str += '; Path=' + opt.path;
	  }
	
	  if (opt.expires) {
	    if (typeof opt.expires.toUTCString !== 'function') {
	      throw new TypeError('option expires is invalid');
	    }
	
	    str += '; Expires=' + opt.expires.toUTCString();
	  }
	
	  if (opt.httpOnly) {
	    str += '; HttpOnly';
	  }
	
	  if (opt.secure) {
	    str += '; Secure';
	  }
	
	  if (opt.sameSite) {
	    var sameSite = typeof opt.sameSite === 'string'
	      ? opt.sameSite.toLowerCase() : opt.sameSite;
	
	    switch (sameSite) {
	      case true:
	        str += '; SameSite=Strict';
	        break;
	      case 'lax':
	        str += '; SameSite=Lax';
	        break;
	      case 'strict':
	        str += '; SameSite=Strict';
	        break;
	      default:
	        throw new TypeError('option sameSite is invalid');
	    }
	  }
	
	  return str;
	}
	
	/**
	 * Try decoding a string using a decoding function.
	 *
	 * @param {string} str
	 * @param {function} decode
	 * @private
	 */
	
	function tryDecode(str, decode) {
	  try {
	    return decode(str);
	  } catch (e) {
	    return str;
	  }
	}


/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * matchesSelector v2.0.2
	 * matchesSelector( element, '.selector' )
	 * MIT license
	 */
	
	/*jshint browser: true, strict: true, undef: true, unused: true */
	
	( function( window, factory ) {
	  /*global define: false, module: false */
	  'use strict';
	  // universal module definition
	  if ( true ) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS
	    module.exports = factory();
	  } else {
	    // browser global
	    window.matchesSelector = factory();
	  }
	
	}( window, function factory() {
	  'use strict';
	
	  var matchesMethod = ( function() {
	    var ElemProto = window.Element.prototype;
	    // check for the standard method name first
	    if ( ElemProto.matches ) {
	      return 'matches';
	    }
	    // check un-prefixed
	    if ( ElemProto.matchesSelector ) {
	      return 'matchesSelector';
	    }
	    // check vendor prefixes
	    var prefixes = [ 'webkit', 'moz', 'ms', 'o' ];
	
	    for ( var i=0; i < prefixes.length; i++ ) {
	      var prefix = prefixes[i];
	      var method = prefix + 'MatchesSelector';
	      if ( ElemProto[ method ] ) {
	        return method;
	      }
	    }
	  })();
	
	  return function matchesSelector( elem, selector ) {
	    return elem[ matchesMethod ]( selector );
	  };
	
	}));


/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addClass;
	
	var _hasClass = __webpack_require__(470);
	
	var _hasClass2 = _interopRequireDefault(_hasClass);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!(0, _hasClass2.default)(element)) element.className = element.className + ' ' + className;
	}
	module.exports = exports['default'];

/***/ },
/* 470 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hasClass;
	function hasClass(element, className) {
	  if (element.classList) return !!className && element.classList.contains(className);else return (" " + element.className + " ").indexOf(" " + className + " ") !== -1;
	}
	module.exports = exports["default"];

/***/ },
/* 471 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function removeClass(element, className) {
	  if (element.classList) element.classList.remove(className);else element.className = element.className.replace(new RegExp('(^|\\s)' + className + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
	};

/***/ },
/* 472 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(88);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ },
/* 474 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(480);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 476 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 477 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 479 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(479);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 481 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/cross.bbd09e3e.svg";

/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/facebook.df742186.svg";

/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/galaxy-10.7b2b0e9e.svg";

/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/galaxy-11.f7367a03.svg";

/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/galaxy-12.7646f901.svg";

/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/galaxy-13.2f719ada.svg";

/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/galaxy-4.bfbf4e1e.svg";

/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/galaxy-7.3327f188.svg";

/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/galaxy-8.8f522e96.svg";

/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/galaxy-9.5430c9ab.svg";

/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/instagram.2b76f017.svg";

/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/mail-black.02c2cb12.svg";

/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/milan-circle-index-white.ba2b0545.svg";

/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/milan-circle-index.ef0def03.svg";

/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/milan-circle-white.25bca64b.svg";

/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * Fizzy UI utils v2.0.7
	 * MIT license
	 */
	
	/*jshint browser: true, undef: true, unused: true, strict: true */
	
	( function( window, factory ) {
	  // universal module definition
	  /*jshint strict: false */ /*globals define, module, require */
	
	  if ( true ) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	      __webpack_require__(468)
	    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( matchesSelector ) {
	      return factory( window, matchesSelector );
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS
	    module.exports = factory(
	      window,
	      require('desandro-matches-selector')
	    );
	  } else {
	    // browser global
	    window.fizzyUIUtils = factory(
	      window,
	      window.matchesSelector
	    );
	  }
	
	}( window, function factory( window, matchesSelector ) {
	
	'use strict';
	
	var utils = {};
	
	// ----- extend ----- //
	
	// extends objects
	utils.extend = function( a, b ) {
	  for ( var prop in b ) {
	    a[ prop ] = b[ prop ];
	  }
	  return a;
	};
	
	// ----- modulo ----- //
	
	utils.modulo = function( num, div ) {
	  return ( ( num % div ) + div ) % div;
	};
	
	// ----- makeArray ----- //
	
	var arraySlice = Array.prototype.slice;
	
	// turn element or nodeList into an array
	utils.makeArray = function( obj ) {
	  if ( Array.isArray( obj ) ) {
	    // use object if already an array
	    return obj;
	  }
	  // return empty array if undefined or null. #6
	  if ( obj === null || obj === undefined ) {
	    return [];
	  }
	
	  var isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';
	  if ( isArrayLike ) {
	    // convert nodeList to array
	    return arraySlice.call( obj );
	  }
	
	  // array of single index
	  return [ obj ];
	};
	
	// ----- removeFrom ----- //
	
	utils.removeFrom = function( ary, obj ) {
	  var index = ary.indexOf( obj );
	  if ( index != -1 ) {
	    ary.splice( index, 1 );
	  }
	};
	
	// ----- getParent ----- //
	
	utils.getParent = function( elem, selector ) {
	  while ( elem.parentNode && elem != document.body ) {
	    elem = elem.parentNode;
	    if ( matchesSelector( elem, selector ) ) {
	      return elem;
	    }
	  }
	};
	
	// ----- getQueryElement ----- //
	
	// use element as selector string
	utils.getQueryElement = function( elem ) {
	  if ( typeof elem == 'string' ) {
	    return document.querySelector( elem );
	  }
	  return elem;
	};
	
	// ----- handleEvent ----- //
	
	// enable .ontype to trigger from .addEventListener( elem, 'type' )
	utils.handleEvent = function( event ) {
	  var method = 'on' + event.type;
	  if ( this[ method ] ) {
	    this[ method ]( event );
	  }
	};
	
	// ----- filterFindElements ----- //
	
	utils.filterFindElements = function( elems, selector ) {
	  // make array of elems
	  elems = utils.makeArray( elems );
	  var ffElems = [];
	
	  elems.forEach( function( elem ) {
	    // check that elem is an actual element
	    if ( !( elem instanceof HTMLElement ) ) {
	      return;
	    }
	    // add elem if no selector
	    if ( !selector ) {
	      ffElems.push( elem );
	      return;
	    }
	    // filter & find items if we have a selector
	    // filter
	    if ( matchesSelector( elem, selector ) ) {
	      ffElems.push( elem );
	    }
	    // find children
	    var childElems = elem.querySelectorAll( selector );
	    // concat childElems to filterFound array
	    for ( var i=0; i < childElems.length; i++ ) {
	      ffElems.push( childElems[i] );
	    }
	  });
	
	  return ffElems;
	};
	
	// ----- debounceMethod ----- //
	
	utils.debounceMethod = function( _class, methodName, threshold ) {
	  threshold = threshold || 100;
	  // original method
	  var method = _class.prototype[ methodName ];
	  var timeoutName = methodName + 'Timeout';
	
	  _class.prototype[ methodName ] = function() {
	    var timeout = this[ timeoutName ];
	    clearTimeout( timeout );
	
	    var args = arguments;
	    var _this = this;
	    this[ timeoutName ] = setTimeout( function() {
	      method.apply( _this, args );
	      delete _this[ timeoutName ];
	    }, threshold );
	  };
	};
	
	// ----- docReady ----- //
	
	utils.docReady = function( callback ) {
	  var readyState = document.readyState;
	  if ( readyState == 'complete' || readyState == 'interactive' ) {
	    // do async to allow for other scripts to run. metafizzy/flickity#441
	    setTimeout( callback );
	  } else {
	    document.addEventListener( 'DOMContentLoaded', callback );
	  }
	};
	
	// ----- htmlInit ----- //
	
	// http://jamesroberts.name/blog/2010/02/22/string-functions-for-javascript-trim-to-camel-case-to-dashed-and-to-underscore/
	utils.toDashed = function( str ) {
	  return str.replace( /(.)([A-Z])/g, function( match, $1, $2 ) {
	    return $1 + '-' + $2;
	  }).toLowerCase();
	};
	
	var console = window.console;
	/**
	 * allow user to initialize classes via [data-namespace] or .js-namespace class
	 * htmlInit( Widget, 'widgetName' )
	 * options are parsed from data-namespace-options
	 */
	utils.htmlInit = function( WidgetClass, namespace ) {
	  utils.docReady( function() {
	    var dashedNamespace = utils.toDashed( namespace );
	    var dataAttr = 'data-' + dashedNamespace;
	    var dataAttrElems = document.querySelectorAll( '[' + dataAttr + ']' );
	    var jsDashElems = document.querySelectorAll( '.js-' + dashedNamespace );
	    var elems = utils.makeArray( dataAttrElems )
	      .concat( utils.makeArray( jsDashElems ) );
	    var dataOptionsAttr = dataAttr + '-options';
	    var jQuery = window.jQuery;
	
	    elems.forEach( function( elem ) {
	      var attr = elem.getAttribute( dataAttr ) ||
	        elem.getAttribute( dataOptionsAttr );
	      var options;
	      try {
	        options = attr && JSON.parse( attr );
	      } catch ( error ) {
	        // log error, do not initialize
	        if ( console ) {
	          console.error( 'Error parsing ' + dataAttr + ' on ' + elem.className +
	          ': ' + error );
	        }
	        return;
	      }
	      // initialize
	      var instance = new WidgetClass( elem, options );
	      // make available via $().data('namespace')
	      if ( jQuery ) {
	        jQuery.data( elem, namespace, instance );
	      }
	    });
	
	  });
	};
	
	// -----  ----- //
	
	return utils;
	
	}));


/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createPath = exports.parsePath = exports.locationsAreEqual = exports.createLocation = exports.createMemoryHistory = exports.createHashHistory = exports.createBrowserHistory = undefined;
	
	var _LocationUtils = __webpack_require__(89);
	
	Object.defineProperty(exports, 'createLocation', {
	  enumerable: true,
	  get: function get() {
	    return _LocationUtils.createLocation;
	  }
	});
	Object.defineProperty(exports, 'locationsAreEqual', {
	  enumerable: true,
	  get: function get() {
	    return _LocationUtils.locationsAreEqual;
	  }
	});
	
	var _PathUtils = __webpack_require__(58);
	
	Object.defineProperty(exports, 'parsePath', {
	  enumerable: true,
	  get: function get() {
	    return _PathUtils.parsePath;
	  }
	});
	Object.defineProperty(exports, 'createPath', {
	  enumerable: true,
	  get: function get() {
	    return _PathUtils.createPath;
	  }
	});
	
	var _createBrowserHistory2 = __webpack_require__(126);
	
	var _createBrowserHistory3 = _interopRequireDefault(_createBrowserHistory2);
	
	var _createHashHistory2 = __webpack_require__(195);
	
	var _createHashHistory3 = _interopRequireDefault(_createHashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(196);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.createBrowserHistory = _createBrowserHistory3.default;
	exports.createHashHistory = _createHashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ },
/* 499 */
/***/ function(module, exports) {

	/*!
	 * Determine if an object is a Buffer
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */
	
	// The _isBuffer check is for Safari 5-7 support, because it's missing
	// Object.prototype.constructor. Remove this eventually
	module.exports = function (obj) {
	  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
	}
	
	function isBuffer (obj) {
	  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
	}
	
	// For Node v0.10 support. Remove this eventually.
	function isSlowBuffer (obj) {
	  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
	}


/***/ },
/* 500 */
/***/ function(module, exports) {

	module.exports = {
		"v": "4.8.0",
		"fr": 30,
		"ip": 0,
		"op": 21,
		"w": 150,
		"h": 150,
		"nm": "render",
		"ddd": 0,
		"assets": [
			{
				"id": "comp_0",
				"layers": [
					{
						"ddd": 0,
						"ind": 1,
						"ty": 0,
						"nm": "burger_to_empty",
						"refId": "comp_1",
						"ks": {
							"o": {
								"a": 0,
								"k": 100
							},
							"r": {
								"a": 0,
								"k": 0
							},
							"p": {
								"a": 0,
								"k": [
									75,
									75,
									0
								]
							},
							"a": {
								"a": 0,
								"k": [
									75,
									75,
									0
								]
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100,
									100
								]
							}
						},
						"ao": 0,
						"w": 150,
						"h": 150,
						"ip": 0,
						"op": 101,
						"st": 0,
						"bm": 0,
						"sr": 1
					},
					{
						"ddd": 0,
						"ind": 2,
						"ty": 0,
						"nm": "empty_to_cross",
						"refId": "comp_2",
						"ks": {
							"o": {
								"a": 0,
								"k": 100
							},
							"r": {
								"a": 0,
								"k": 0
							},
							"p": {
								"a": 0,
								"k": [
									75,
									75,
									0
								]
							},
							"a": {
								"a": 0,
								"k": [
									75,
									75,
									0
								]
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100,
									100
								]
							}
						},
						"ao": 0,
						"w": 150,
						"h": 150,
						"ip": 0,
						"op": 101,
						"st": 0,
						"bm": 0,
						"sr": 1
					}
				]
			},
			{
				"id": "comp_1",
				"layers": [
					{
						"ddd": 0,
						"ind": 1,
						"ty": 4,
						"nm": "Shape Layer 3",
						"ks": {
							"o": {
								"a": 0,
								"k": 100
							},
							"r": {
								"a": 0,
								"k": 0
							},
							"p": {
								"a": 0,
								"k": [
									16.812,
									32,
									0
								]
							},
							"a": {
								"a": 0,
								"k": [
									-58.188,
									0,
									0
								]
							},
							"s": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": [
												0.833,
												0.833,
												0.833
											],
											"y": [
												1,
												1,
												1
											]
										},
										"o": {
											"x": [
												0.333,
												0.333,
												0.333
											],
											"y": [
												0,
												0,
												0
											]
										},
										"n": [
											"0p833_1_0p333_0",
											"0p833_1_0p333_0",
											"0p833_1_0p333_0"
										],
										"t": 0,
										"s": [
											100,
											100,
											100
										],
										"e": [
											0,
											100,
											100
										]
									},
									{
										"t": 10
									}
								]
							}
						},
						"ao": 0,
						"shapes": [
							{
								"ty": "gr",
								"it": [
									{
										"ty": "rc",
										"d": 1,
										"s": {
											"a": 0,
											"k": [
												116.67,
												6.045
											]
										},
										"p": {
											"a": 0,
											"k": [
												0,
												0
											]
										},
										"r": {
											"a": 0,
											"k": 0
										},
										"nm": "Rectangle Path 1",
										"mn": "ADBE Vector Shape - Rect"
									},
									{
										"ty": "fl",
										"c": {
											"a": 0,
											"k": [
												0,
												0,
												0,
												1
											]
										},
										"o": {
											"a": 0,
											"k": 100
										},
										"r": 1,
										"nm": "Fill 1",
										"mn": "ADBE Vector Graphic - Fill"
									},
									{
										"ty": "tr",
										"p": {
											"a": 0,
											"k": [
												0.335,
												0.023
											],
											"ix": 2
										},
										"a": {
											"a": 0,
											"k": [
												0,
												0
											],
											"ix": 1
										},
										"s": {
											"a": 0,
											"k": [
												100,
												100
											],
											"ix": 3
										},
										"r": {
											"a": 0,
											"k": 0,
											"ix": 6
										},
										"o": {
											"a": 0,
											"k": 100,
											"ix": 7
										},
										"sk": {
											"a": 0,
											"k": 0,
											"ix": 4
										},
										"sa": {
											"a": 0,
											"k": 0,
											"ix": 5
										},
										"nm": "Transform"
									}
								],
								"nm": "Rectangle 2",
								"np": 3,
								"cix": 2,
								"ix": 1,
								"mn": "ADBE Vector Group"
							}
						],
						"ip": 0,
						"op": 101,
						"st": 0,
						"bm": 0,
						"sr": 1
					},
					{
						"ddd": 0,
						"ind": 2,
						"ty": 4,
						"nm": "Shape Layer 1",
						"ks": {
							"o": {
								"a": 0,
								"k": 100
							},
							"r": {
								"a": 0,
								"k": 0
							},
							"p": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": 0.833,
											"y": 1
										},
										"o": {
											"x": 0.167,
											"y": 0
										},
										"n": "0p833_1_0p167_0",
										"t": 7,
										"s": [
											16.812,
											74.75,
											0
										],
										"e": [
											71.812,
											74.75,
											0
										],
										"to": [
											9.16666698455811,
											0,
											0
										],
										"ti": [
											-9.16666698455811,
											0,
											0
										]
									},
									{
										"t": 17
									}
								]
							},
							"a": {
								"a": 0,
								"k": [
									-58.188,
									0,
									0
								]
							},
							"s": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": [
												0.833,
												0.833,
												0.833
											],
											"y": [
												1,
												1,
												1
											]
										},
										"o": {
											"x": [
												0.333,
												0.333,
												0.333
											],
											"y": [
												0,
												0,
												0
											]
										},
										"n": [
											"0p833_1_0p333_0",
											"0p833_1_0p333_0",
											"0p833_1_0p333_0"
										],
										"t": 7,
										"s": [
											100,
											100,
											100
										],
										"e": [
											0,
											100,
											100
										]
									},
									{
										"t": 17
									}
								]
							}
						},
						"ao": 0,
						"shapes": [
							{
								"ty": "gr",
								"it": [
									{
										"ty": "rc",
										"d": 1,
										"s": {
											"a": 0,
											"k": [
												116.67,
												6.045
											]
										},
										"p": {
											"a": 0,
											"k": [
												0,
												0
											]
										},
										"r": {
											"a": 0,
											"k": 0
										},
										"nm": "Rectangle Path 1",
										"mn": "ADBE Vector Shape - Rect"
									},
									{
										"ty": "fl",
										"c": {
											"a": 0,
											"k": [
												0,
												0,
												0,
												1
											]
										},
										"o": {
											"a": 0,
											"k": 100
										},
										"r": 1,
										"nm": "Fill 1",
										"mn": "ADBE Vector Graphic - Fill"
									},
									{
										"ty": "tr",
										"p": {
											"a": 0,
											"k": [
												0.335,
												0.023
											],
											"ix": 2
										},
										"a": {
											"a": 0,
											"k": [
												0,
												0
											],
											"ix": 1
										},
										"s": {
											"a": 0,
											"k": [
												100,
												100
											],
											"ix": 3
										},
										"r": {
											"a": 0,
											"k": 0,
											"ix": 6
										},
										"o": {
											"a": 0,
											"k": 100,
											"ix": 7
										},
										"sk": {
											"a": 0,
											"k": 0,
											"ix": 4
										},
										"sa": {
											"a": 0,
											"k": 0,
											"ix": 5
										},
										"nm": "Transform"
									}
								],
								"nm": "Rectangle 2",
								"np": 3,
								"cix": 2,
								"ix": 1,
								"mn": "ADBE Vector Group"
							}
						],
						"ip": 0,
						"op": 101,
						"st": 0,
						"bm": 0,
						"sr": 1
					},
					{
						"ddd": 0,
						"ind": 3,
						"ty": 4,
						"nm": "Shape Layer 2",
						"ks": {
							"o": {
								"a": 0,
								"k": 100
							},
							"r": {
								"a": 0,
								"k": 0
							},
							"p": {
								"a": 0,
								"k": [
									16.812,
									117.5,
									0
								]
							},
							"a": {
								"a": 0,
								"k": [
									-58.188,
									0,
									0
								]
							},
							"s": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": [
												0.833,
												0.833,
												0.833
											],
											"y": [
												1,
												1,
												1
											]
										},
										"o": {
											"x": [
												0.333,
												0.333,
												0.333
											],
											"y": [
												0,
												0,
												0
											]
										},
										"n": [
											"0p833_1_0p333_0",
											"0p833_1_0p333_0",
											"0p833_1_0p333_0"
										],
										"t": 4,
										"s": [
											100,
											100,
											100
										],
										"e": [
											0,
											100,
											100
										]
									},
									{
										"t": 14
									}
								]
							}
						},
						"ao": 0,
						"shapes": [
							{
								"ty": "gr",
								"it": [
									{
										"ty": "rc",
										"d": 1,
										"s": {
											"a": 0,
											"k": [
												116.67,
												6.045
											]
										},
										"p": {
											"a": 0,
											"k": [
												0,
												0
											]
										},
										"r": {
											"a": 0,
											"k": 0
										},
										"nm": "Rectangle Path 1",
										"mn": "ADBE Vector Shape - Rect"
									},
									{
										"ty": "fl",
										"c": {
											"a": 0,
											"k": [
												0,
												0,
												0,
												1
											]
										},
										"o": {
											"a": 0,
											"k": 100
										},
										"r": 1,
										"nm": "Fill 1",
										"mn": "ADBE Vector Graphic - Fill"
									},
									{
										"ty": "tr",
										"p": {
											"a": 0,
											"k": [
												0.335,
												0.023
											],
											"ix": 2
										},
										"a": {
											"a": 0,
											"k": [
												0,
												0
											],
											"ix": 1
										},
										"s": {
											"a": 0,
											"k": [
												100,
												100
											],
											"ix": 3
										},
										"r": {
											"a": 0,
											"k": 0,
											"ix": 6
										},
										"o": {
											"a": 0,
											"k": 100,
											"ix": 7
										},
										"sk": {
											"a": 0,
											"k": 0,
											"ix": 4
										},
										"sa": {
											"a": 0,
											"k": 0,
											"ix": 5
										},
										"nm": "Transform"
									}
								],
								"nm": "Rectangle 2",
								"np": 3,
								"cix": 2,
								"ix": 1,
								"mn": "ADBE Vector Group"
							}
						],
						"ip": 0,
						"op": 101,
						"st": 0,
						"bm": 0,
						"sr": 1
					}
				]
			},
			{
				"id": "comp_2",
				"layers": [
					{
						"ddd": 0,
						"ind": 1,
						"ty": 4,
						"nm": "Shape Layer 3",
						"ks": {
							"o": {
								"a": 0,
								"k": 100
							},
							"r": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": [
												0.833
											],
											"y": [
												1
											]
										},
										"o": {
											"x": [
												0.333
											],
											"y": [
												0
											]
										},
										"n": [
											"0p833_1_0p333_0"
										],
										"t": 8,
										"s": [
											0
										],
										"e": [
											45
										]
									},
									{
										"t": 20
									}
								]
							},
							"p": {
								"a": 0,
								"k": [
									75.438,
									74.977,
									0
								]
							},
							"a": {
								"a": 0,
								"k": [
									0.438,
									0,
									0
								]
							},
							"s": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": [
												0.833,
												0.833,
												0.833
											],
											"y": [
												1,
												1,
												1
											]
										},
										"o": {
											"x": [
												0.167,
												0.167,
												0.167
											],
											"y": [
												0,
												0,
												0
											]
										},
										"n": [
											"0p833_1_0p167_0",
											"0p833_1_0p167_0",
											"0p833_1_0p167_0"
										],
										"t": 0,
										"s": [
											0,
											100,
											100
										],
										"e": [
											100,
											100,
											100
										]
									},
									{
										"t": 10
									}
								]
							}
						},
						"ao": 0,
						"shapes": [
							{
								"ty": "gr",
								"it": [
									{
										"ty": "rc",
										"d": 1,
										"s": {
											"a": 0,
											"k": [
												116.67,
												6.045
											]
										},
										"p": {
											"a": 0,
											"k": [
												0,
												0
											]
										},
										"r": {
											"a": 0,
											"k": 0
										},
										"nm": "Rectangle Path 1",
										"mn": "ADBE Vector Shape - Rect"
									},
									{
										"ty": "fl",
										"c": {
											"a": 0,
											"k": [
												0,
												0,
												0,
												1
											]
										},
										"o": {
											"a": 0,
											"k": 100
										},
										"r": 1,
										"nm": "Fill 1",
										"mn": "ADBE Vector Graphic - Fill"
									},
									{
										"ty": "tr",
										"p": {
											"a": 0,
											"k": [
												0.335,
												0.023
											],
											"ix": 2
										},
										"a": {
											"a": 0,
											"k": [
												0,
												0
											],
											"ix": 1
										},
										"s": {
											"a": 0,
											"k": [
												100,
												100
											],
											"ix": 3
										},
										"r": {
											"a": 0,
											"k": 0,
											"ix": 6
										},
										"o": {
											"a": 0,
											"k": 100,
											"ix": 7
										},
										"sk": {
											"a": 0,
											"k": 0,
											"ix": 4
										},
										"sa": {
											"a": 0,
											"k": 0,
											"ix": 5
										},
										"nm": "Transform"
									}
								],
								"nm": "Rectangle 2",
								"np": 3,
								"cix": 2,
								"ix": 1,
								"mn": "ADBE Vector Group"
							}
						],
						"ip": 0,
						"op": 101,
						"st": 0,
						"bm": 0,
						"sr": 1
					},
					{
						"ddd": 0,
						"ind": 2,
						"ty": 4,
						"nm": "Shape Layer 1",
						"ks": {
							"o": {
								"a": 0,
								"k": 100
							},
							"r": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": [
												0.833
											],
											"y": [
												1
											]
										},
										"o": {
											"x": [
												0.333
											],
											"y": [
												0
											]
										},
										"n": [
											"0p833_1_0p333_0"
										],
										"t": 8,
										"s": [
											0
										],
										"e": [
											-45
										]
									},
									{
										"t": 20
									}
								]
							},
							"p": {
								"a": 0,
								"k": [
									75.312,
									74.977,
									0
								]
							},
							"a": {
								"a": 0,
								"k": [
									0.312,
									0,
									0
								]
							},
							"s": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": [
												0.833,
												0.833,
												0.833
											],
											"y": [
												1,
												1,
												1
											]
										},
										"o": {
											"x": [
												0.167,
												0.167,
												0.167
											],
											"y": [
												0,
												0,
												0
											]
										},
										"n": [
											"0p833_1_0p167_0",
											"0p833_1_0p167_0",
											"0p833_1_0p167_0"
										],
										"t": 4,
										"s": [
											0,
											100,
											100
										],
										"e": [
											100,
											100,
											100
										]
									},
									{
										"t": 14
									}
								]
							}
						},
						"ao": 0,
						"shapes": [
							{
								"ty": "gr",
								"it": [
									{
										"ty": "rc",
										"d": 1,
										"s": {
											"a": 0,
											"k": [
												116.67,
												6.045
											]
										},
										"p": {
											"a": 0,
											"k": [
												0,
												0
											]
										},
										"r": {
											"a": 0,
											"k": 0
										},
										"nm": "Rectangle Path 1",
										"mn": "ADBE Vector Shape - Rect"
									},
									{
										"ty": "fl",
										"c": {
											"a": 0,
											"k": [
												0,
												0,
												0,
												1
											]
										},
										"o": {
											"a": 0,
											"k": 100
										},
										"r": 1,
										"nm": "Fill 1",
										"mn": "ADBE Vector Graphic - Fill"
									},
									{
										"ty": "tr",
										"p": {
											"a": 0,
											"k": [
												0.335,
												0.023
											],
											"ix": 2
										},
										"a": {
											"a": 0,
											"k": [
												0,
												0
											],
											"ix": 1
										},
										"s": {
											"a": 0,
											"k": [
												100,
												100
											],
											"ix": 3
										},
										"r": {
											"a": 0,
											"k": 0,
											"ix": 6
										},
										"o": {
											"a": 0,
											"k": 100,
											"ix": 7
										},
										"sk": {
											"a": 0,
											"k": 0,
											"ix": 4
										},
										"sa": {
											"a": 0,
											"k": 0,
											"ix": 5
										},
										"nm": "Transform"
									}
								],
								"nm": "Rectangle 2",
								"np": 3,
								"cix": 2,
								"ix": 1,
								"mn": "ADBE Vector Group"
							}
						],
						"ip": 0,
						"op": 101,
						"st": 0,
						"bm": 0,
						"sr": 1
					}
				]
			}
		],
		"layers": [
			{
				"ddd": 0,
				"ind": 1,
				"ty": 0,
				"nm": "burger_to_cross",
				"refId": "comp_0",
				"ks": {
					"o": {
						"a": 0,
						"k": 100
					},
					"r": {
						"a": 0,
						"k": 0
					},
					"p": {
						"a": 0,
						"k": [
							75,
							75,
							0
						]
					},
					"a": {
						"a": 0,
						"k": [
							75,
							75,
							0
						]
					},
					"s": {
						"a": 0,
						"k": [
							100,
							100,
							100
						]
					}
				},
				"ao": 0,
				"w": 150,
				"h": 150,
				"ip": 0,
				"op": 21,
				"st": 0,
				"bm": 0,
				"sr": 1
			}
		]
	};

/***/ },
/* 501 */
/***/ function(module, exports) {

	module.exports = {
		"v": "4.8.0",
		"fr": 30,
		"ip": 0,
		"op": 101,
		"w": 150,
		"h": 150,
		"nm": "renderBlack",
		"ddd": 0,
		"assets": [
			{
				"id": "comp_0",
				"layers": [
					{
						"ddd": 0,
						"ind": 1,
						"ty": 1,
						"nm": "Black Solid 1",
						"ks": {
							"o": {
								"a": 0,
								"k": 100
							},
							"r": {
								"a": 0,
								"k": 0
							},
							"p": {
								"a": 0,
								"k": [
									360,
									360,
									0
								]
							},
							"a": {
								"a": 0,
								"k": [
									360,
									360,
									0
								]
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100,
									100
								]
							}
						},
						"ao": 0,
						"hasMask": true,
						"masksProperties": [
							{
								"inv": false,
								"mode": "a",
								"pt": {
									"a": 1,
									"k": [
										{
											"t": 0,
											"s": [
												{
													"i": [
														[
															-0.119,
															0.007
														],
														[
															6.861,
															-0.608
														],
														[
															6.871,
															-1.172
														],
														[
															16.464,
															-5.754
														],
														[
															13.401,
															-6.788
														],
														[
															2.985,
															-1.552
														],
														[
															2.156,
															-1.322
														],
														[
															1.957,
															-1.189
														],
														[
															1.931,
															-0.87
														],
														[
															0.161,
															-0.451
														],
														[
															0.19,
															-0.123
														],
														[
															0.689,
															-0.298
														],
														[
															0.679,
															-0.444
														],
														[
															2.124,
															-1.466
														],
														[
															1.975,
															-1.483
														],
														[
															2.994,
															-2.293
														],
														[
															2.848,
															-2.441
														],
														[
															1.362,
															-1.453
														],
														[
															1.102,
															-0.945
														],
														[
															0.731,
															-0.262
														],
														[
															0.559,
															-0.51
														],
														[
															3.305,
															-3.338
														],
														[
															2.588,
															-2.74
														],
														[
															0.265,
															-0.744
														],
														[
															0.475,
															-0.534
														],
														[
															0.859,
															-0.812
														],
														[
															0.794,
															-0.887
														],
														[
															7.921,
															-11.952
														],
														[
															6.648,
															-13.384
														],
														[
															2.406,
															-4.999
														],
														[
															1.99,
															-5.202
														],
														[
															0.258,
															-1.34
														],
														[
															0.487,
															-1.384
														],
														[
															0.516,
															-1.319
														],
														[
															0.448,
															-1.334
														],
														[
															2.142,
															-8.761
														],
														[
															1.529,
															-9.316
														],
														[
															-13.19,
															-45.969
														],
														[
															-24.465,
															-30.947
														],
														[
															-1.457,
															-2.027
														],
														[
															-1.609,
															-1.913
														],
														[
															-2.334,
															-2.363
														],
														[
															-1.623,
															-2.12
														],
														[
															-3.382,
															-3.001
														],
														[
															-3.468,
															-3.07
														],
														[
															-3.865,
															-3.169
														],
														[
															-8.574,
															-5.879
														],
														[
															-0.999,
															-0.957
														],
														[
															-1.087,
															-0.7
														],
														[
															-0.982,
															-0.605
														],
														[
															-2.363,
															-1.449
														],
														[
															-2.037,
															-1.249
														],
														[
															-19.011,
															-6.091
														],
														[
															-5.964,
															-1.642
														],
														[
															-28.335,
															-1.503
														],
														[
															-9.883,
															2.409
														],
														[
															-1.958,
															1.721
														],
														[
															-1.184,
															1.271
														],
														[
															-0.637,
															0.599
														],
														[
															-3.344,
															1.194
														],
														[
															-5.479,
															1.034
														],
														[
															-15.887,
															6.094
														],
														[
															-10.933,
															5.497
														],
														[
															-4.473,
															2.571
														],
														[
															-2.095,
															1.245
														],
														[
															-6.67,
															3.007
														],
														[
															-0.37,
															0.247
														],
														[
															-0.511,
															0.23
														],
														[
															-0.362,
															0.248
														],
														[
															-0.506,
															0.228
														],
														[
															-0.358,
															0.248
														],
														[
															-6.282,
															5.201
														],
														[
															-0.865,
															0.69
														],
														[
															-1.246,
															1.141
														],
														[
															-3.482,
															3.482
														],
														[
															-6.459,
															7.525
														],
														[
															-1.598,
															1.969
														],
														[
															-1.466,
															1.88
														],
														[
															-1.522,
															2.065
														],
														[
															-4.352,
															6.674
														],
														[
															-6.566,
															14.114
														],
														[
															5.828,
															71.331
														],
														[
															20.635,
															39.075
														],
														[
															5.459,
															8.406
														],
														[
															6.27,
															7.857
														],
														[
															7.049,
															7.338
														],
														[
															3.52,
															3.52
														],
														[
															4.395,
															1.981
														],
														[
															0.295,
															0.246
														],
														[
															16.126,
															9.926
														],
														[
															83.308,
															-3.936
														]
													],
													"o": [
														[
															-6.683,
															0.395
														],
														[
															-6.861,
															0.608
														],
														[
															-18.743,
															3.197
														],
														[
															-16.464,
															5.754
														],
														[
															-2.905,
															1.471
														],
														[
															-2.985,
															1.552
														],
														[
															-2.24,
															1.373
														],
														[
															-1.957,
															1.189
														],
														[
															-0.166,
															0.075
														],
														[
															-0.161,
															0.451
														],
														[
															-0.565,
															0.364
														],
														[
															-0.689,
															0.298
														],
														[
															-2.53,
															1.654
														],
														[
															-2.124,
															1.466
														],
														[
															-3.177,
															2.386
														],
														[
															-2.994,
															2.293
														],
														[
															-1.451,
															1.243
														],
														[
															-1.362,
															1.453
														],
														[
															-0.516,
															0.441
														],
														[
															-0.731,
															0.262
														],
														[
															-3.191,
															2.906
														],
														[
															-3.305,
															3.338
														],
														[
															-0.464,
															0.491
														],
														[
															-0.265,
															0.744
														],
														[
															-0.769,
															0.864
														],
														[
															-0.859,
															0.812
														],
														[
															-9.668,
															10.807
														],
														[
															-7.921,
															11.952
														],
														[
															-2.386,
															4.803
														],
														[
															-2.406,
															4.999
														],
														[
															-0.481,
															1.257
														],
														[
															-0.258,
															1.34
														],
														[
															-0.489,
															1.389
														],
														[
															-0.516,
															1.319
														],
														[
															-2.901,
															8.639
														],
														[
															-2.143,
															8.761
														],
														[
															-9.225,
															56.179
														],
														[
															13.19,
															45.969
														],
														[
															1.564,
															1.978
														],
														[
															1.457,
															2.027
														],
														[
															2.043,
															2.429
														],
														[
															2.334,
															2.363
														],
														[
															3.005,
															3.926
														],
														[
															3.382,
															3.001
														],
														[
															3.68,
															3.258
														],
														[
															8.351,
															6.848
														],
														[
															2.268,
															1.555
														],
														[
															0.817,
															0.783
														],
														[
															1.026,
															0.661
														],
														[
															3.374,
															2.08
														],
														[
															2.803,
															1.719
														],
														[
															16.941,
															10.388
														],
														[
															5.526,
															1.77
														],
														[
															23.647,
															6.511
														],
														[
															11.351,
															0.602
														],
														[
															3.539,
															-0.863
														],
														[
															2.083,
															-1.831
														],
														[
															0.602,
															-0.646
														],
														[
															1.858,
															-1.746
														],
														[
															5.17,
															-1.845
														],
														[
															19.914,
															-3.758
														],
														[
															12.976,
															-4.978
														],
														[
															4.717,
															-2.372
														],
														[
															2.129,
															-1.223
														],
														[
															6.88,
															-4.088
														],
														[
															0.324,
															-0.146
														],
														[
															0.46,
															-0.307
														],
														[
															0.319,
															-0.144
														],
														[
															0.452,
															-0.309
														],
														[
															0.316,
															-0.143
														],
														[
															7.31,
															-5.066
														],
														[
															0.841,
															-0.696
														],
														[
															1.352,
															-1.079
														],
														[
															3.556,
															-3.255
														],
														[
															6.994,
															-6.994
														],
														[
															1.574,
															-1.833
														],
														[
															1.509,
															-1.859
														],
														[
															1.472,
															-1.887
														],
														[
															4.769,
															-6.472
														],
														[
															8.543,
															-13.1
														],
														[
															22.416,
															-48.182
														],
														[
															-3.987,
															-48.795
														],
														[
															-4.955,
															-9.383
														],
														[
															-5.505,
															-8.477
														],
														[
															-6.063,
															-7.597
														],
														[
															-3.274,
															-3.408
														],
														[
															-4.025,
															-4.025
														],
														[
															-0.274,
															-0.124
														],
														[
															-14.561,
															-12.134
														],
														[
															-51.019,
															-31.405
														],
														[
															-0.63,
															0.03
														]
													],
													"v": [
														[
															342,
															16
														],
														[
															321.641,
															17.417
														],
														[
															301,
															20
														],
														[
															247.994,
															33.807
														],
														[
															203,
															53
														],
														[
															193.938,
															57.612
														],
														[
															186,
															62
														],
														[
															179.769,
															65.877
														],
														[
															174,
															69
														],
														[
															173.519,
															69.964
														],
														[
															173,
															71
														],
														[
															171.085,
															71.94
														],
														[
															169,
															73
														],
														[
															162.084,
															77.628
														],
														[
															156,
															82
														],
														[
															146.753,
															88.958
														],
														[
															138,
															96
														],
														[
															133.739,
															100.224
														],
														[
															130,
															104
														],
														[
															128.033,
															104.949
														],
														[
															126,
															106
														],
														[
															116.048,
															115.624
														],
														[
															107,
															125
														],
														[
															106.009,
															126.968
														],
														[
															105,
															129
														],
														[
															102.519,
															131.482
														],
														[
															100,
															134
														],
														[
															73.735,
															168.067
														],
														[
															52,
															206
														],
														[
															44.703,
															220.701
														],
														[
															38,
															236
														],
														[
															37.005,
															239.905
														],
														[
															36,
															244
														],
														[
															34.469,
															248.042
														],
														[
															33,
															252
														],
														[
															25.472,
															277.993
														],
														[
															20,
															305
														],
														[
															28.733,
															459.424
														],
														[
															88,
															576
														],
														[
															92.466,
															582.049
														],
														[
															97,
															588
														],
														[
															103.816,
															595.232
														],
														[
															110,
															602
														],
														[
															119.653,
															612.142
														],
														[
															130,
															621
														],
														[
															141,
															631
														],
														[
															166,
															650
														],
														[
															174,
															655
														],
														[
															176,
															656
														],
														[
															179,
															659
														],
														[
															189,
															664
														],
														[
															196,
															668
														],
														[
															253,
															693
														],
														[
															270,
															698
														],
														[
															347,
															709
														],
														[
															389,
															708
														],
														[
															394,
															706
														],
														[
															399,
															700
														],
														[
															400,
															697
														],
														[
															406,
															695
														],
														[
															423,
															692
														],
														[
															480,
															676
														],
														[
															517,
															660
														],
														[
															530,
															652
														],
														[
															537,
															649
														],
														[
															557,
															636
														],
														[
															558,
															634
														],
														[
															560,
															634
														],
														[
															561,
															632
														],
														[
															563,
															632
														],
														[
															564,
															630
														],
														[
															585,
															614
														],
														[
															587,
															611
														],
														[
															591,
															609
														],
														[
															601,
															598
														],
														[
															622,
															577
														],
														[
															626,
															571
														],
														[
															631,
															566
														],
														[
															635,
															560
														],
														[
															648,
															541
														],
														[
															671,
															501
														],
														[
															702,
															326
														],
														[
															664,
															197
														],
														[
															649,
															170
														],
														[
															631,
															146
														],
														[
															612,
															123
														],
														[
															601,
															113
														],
														[
															589,
															102
														],
														[
															588,
															100
														],
														[
															543,
															67
														],
														[
															343,
															15
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 1,
											"s": [
												{
													"i": [
														[
															-0.119,
															0.007
														],
														[
															6.818,
															-0.604
														],
														[
															6.938,
															-1.184
														],
														[
															34.454,
															-21.006
														],
														[
															23.913,
															-28.084
														],
														[
															1.832,
															-2.479
														],
														[
															0.905,
															-2.007
														],
														[
															0.451,
															-0.166
														],
														[
															0.124,
															-0.179
														],
														[
															1.15,
															-1.627
														],
														[
															1.108,
															-1.631
														],
														[
															0.639,
															-1.201
														],
														[
															0.724,
															-1.135
														],
														[
															1.549,
															-2.133
														],
														[
															1.251,
															-2.029
														],
														[
															-0.067,
															-0.374
														],
														[
															0.118,
															-0.262
														],
														[
															0.451,
															-0.155
														],
														[
															0.119,
															-0.206
														],
														[
															0.345,
															-0.726
														],
														[
															0.294,
															-0.529
														],
														[
															1.104,
															-2.502
														],
														[
															1.24,
															-2.577
														],
														[
															2.402,
															-4.949
														],
														[
															2.071,
															-5.386
														],
														[
															3.93,
															-25.349
														],
														[
															-2.072,
															-27.885
														],
														[
															-6.738,
															-22.433
														],
														[
															-10.057,
															-19.474
														],
														[
															-7.46,
															-10.972
														],
														[
															-8.047,
															-9.274
														],
														[
															-1.451,
															-1.344
														],
														[
															-0.909,
															-1.139
														],
														[
															-0.229,
															-0.682
														],
														[
															-0.548,
															-0.599
														],
														[
															-3.894,
															-3.445
														],
														[
															-3.929,
															-3.4
														],
														[
															-4.198,
															-3.676
														],
														[
															-4.361,
															-1.966
														],
														[
															-0.166,
															-0.451
														],
														[
															-0.179,
															-0.124
														],
														[
															-2.801,
															-1.797
														],
														[
															-2.787,
															-1.726
														],
														[
															-5.773,
															-3.358
														],
														[
															-6.157,
															-3.004
														],
														[
															-23.515,
															-6.043
														],
														[
															-27.605,
															-1.396
														],
														[
															-0.087,
															0.247
														],
														[
															-0.15,
															0.039
														],
														[
															-1.65,
															-0.279
														],
														[
															-0.978,
															0.004
														],
														[
															-5.817,
															0.222
														],
														[
															-3.353,
															1.092
														],
														[
															-1.93,
															1.799
														],
														[
															-1.625,
															1.717
														],
														[
															-0.475,
															0.51
														],
														[
															-0.637,
															0.599
														],
														[
															-3.137,
															1.1
														],
														[
															-5.641,
															1.083
														],
														[
															-31.192,
															18.76
														],
														[
															-6.662,
															3.003
														],
														[
															-0.37,
															0.247
														],
														[
															-0.511,
															0.23
														],
														[
															-0.359,
															0.248
														],
														[
															-2.072,
															1.532
														],
														[
															-4.299,
															1.938
														],
														[
															-0.795,
															0.671
														],
														[
															-3.901,
															3.113
														],
														[
															-1.174,
															1.075
														],
														[
															-3.399,
															3.683
														],
														[
															-17.083,
															46.176
														],
														[
															5.031,
															57.429
														],
														[
															3.941,
															15.389
														],
														[
															12.636,
															23.821
														],
														[
															2.626,
															4.414
														],
														[
															2.772,
															4.28
														],
														[
															1.755,
															3.894
														],
														[
															0.249,
															0.346
														],
														[
															3.597,
															4.52
														],
														[
															14.075,
															11.652
														],
														[
															0.865,
															0.69
														],
														[
															1.144,
															0.928
														],
														[
															2.447,
															1.692
														],
														[
															2.943,
															2.133
														],
														[
															0.494,
															0.223
														],
														[
															0.358,
															0.248
														],
														[
															3.438,
															2.161
														],
														[
															0.839,
															0.803
														],
														[
															1.689,
															0.986
														],
														[
															11.499,
															5.162
														],
														[
															63.171,
															-2.985
														]
													],
													"o": [
														[
															-6.79,
															0.401
														],
														[
															-6.818,
															0.604
														],
														[
															-46.272,
															7.893
														],
														[
															-34.454,
															21.006
														],
														[
															-1.767,
															2.075
														],
														[
															-1.832,
															2.479
														],
														[
															-0.072,
															0.158
														],
														[
															-0.451,
															0.166
														],
														[
															-1.291,
															1.862
														],
														[
															-1.15,
															1.627
														],
														[
															-0.72,
															1.06
														],
														[
															-0.639,
															1.201
														],
														[
															-1.555,
															2.44
														],
														[
															-1.549,
															2.133
														],
														[
															-0.15,
															0.243
														],
														[
															0.067,
															0.374
														],
														[
															-0.078,
															0.174
														],
														[
															-0.451,
															0.155
														],
														[
															-0.327,
															0.565
														],
														[
															-0.345,
															0.726
														],
														[
															-1.345,
															2.416
														],
														[
															-1.104,
															2.502
														],
														[
															-2.319,
															4.819
														],
														[
															-2.402,
															4.949
														],
														[
															-8.352,
															21.721
														],
														[
															-3.93,
															25.349
														],
														[
															1.992,
															26.793
														],
														[
															6.738,
															22.433
														],
														[
															6.114,
															11.838
														],
														[
															7.46,
															10.972
														],
														[
															1.289,
															1.486
														],
														[
															1.451,
															1.344
														],
														[
															0.537,
															0.673
														],
														[
															0.229,
															0.682
														],
														[
															3.495,
															3.818
														],
														[
															3.894,
															3.445
														],
														[
															3.847,
															3.329
														],
														[
															4.198,
															3.676
														],
														[
															0.158,
															0.072
														],
														[
															0.166,
															0.451
														],
														[
															3.009,
															2.085
														],
														[
															2.801,
															1.797
														],
														[
															5.753,
															3.562
														],
														[
															5.773,
															3.359
														],
														[
															19.334,
															9.432
														],
														[
															23.515,
															6.043
														],
														[
															0.503,
															0.025
														],
														[
															0.087,
															-0.246
														],
														[
															0.423,
															-0.111
														],
														[
															1.65,
															0.279
														],
														[
															4.377,
															-0.019
														],
														[
															5.817,
															-0.222
														],
														[
															3.78,
															-1.231
														],
														[
															1.343,
															-1.251
														],
														[
															0.474,
															-0.501
														],
														[
															0.602,
															-0.646
														],
														[
															1.833,
															-1.724
														],
														[
															5.163,
															-1.811
														],
														[
															43.411,
															-8.336
														],
														[
															7.219,
															-4.342
														],
														[
															0.324,
															-0.146
														],
														[
															0.46,
															-0.307
														],
														[
															0.317,
															-0.143
														],
														[
															2.07,
															-1.432
														],
														[
															4.396,
															-3.251
														],
														[
															1.057,
															-0.476
														],
														[
															4.741,
															-4.004
														],
														[
															1.1,
															-0.878
														],
														[
															3.587,
															-3.284
														],
														[
															29.48,
															-31.943
														],
														[
															14.854,
															-40.15
														],
														[
															-1.687,
															-19.251
														],
														[
															-7.008,
															-27.367
														],
														[
															-2.364,
															-4.456
														],
														[
															-2.569,
															-4.318
														],
														[
															-2.942,
															-4.543
														],
														[
															-0.139,
															-0.309
														],
														[
															-3.896,
															-5.42
														],
														[
															-12.052,
															-15.146
														],
														[
															-0.841,
															-0.696
														],
														[
															-1.363,
															-1.088
														],
														[
															-2.941,
															-2.386
														],
														[
															-3.837,
															-2.654
														],
														[
															-0.431,
															-0.313
														],
														[
															-0.316,
															-0.143
														],
														[
															-3.761,
															-2.607
														],
														[
															-2.08,
															-1.308
														],
														[
															-1.682,
															-1.612
														],
														[
															-11.491,
															-6.706
														],
														[
															-43.739,
															-19.635
														],
														[
															-0.63,
															0.03
														]
													],
													"v": [
														[
															342,
															16
														],
														[
															321.611,
															17.413
														],
														[
															301,
															20
														],
														[
															180.231,
															64.856
														],
														[
															93,
															140
														],
														[
															87.353,
															147.051
														],
														[
															83,
															154
														],
														[
															82.039,
															154.484
														],
														[
															81,
															155
														],
														[
															77.363,
															160.173
														],
														[
															74,
															165
														],
														[
															72.003,
															168.444
														],
														[
															70,
															172
														],
														[
															65.272,
															178.808
														],
														[
															61,
															185
														],
														[
															60.976,
															185.985
														],
														[
															61,
															187
														],
														[
															60.03,
															187.477
														],
														[
															59,
															188
														],
														[
															57.976,
															190.027
														],
														[
															57,
															192
														],
														[
															53.421,
															199.379
														],
														[
															50,
															207
														],
														[
															42.814,
															221.575
														],
														[
															36,
															237
														],
														[
															17.181,
															307.877
														],
														[
															14,
															388
														],
														[
															27.451,
															461.489
														],
														[
															53,
															524
														],
														[
															73.55,
															558.423
														],
														[
															97,
															589
														],
														[
															101.285,
															593.26
														],
														[
															105,
															597
														],
														[
															105.992,
															599.056
														],
														[
															107,
															601
														],
														[
															118.174,
															611.813
														],
														[
															130,
															622
														],
														[
															142.114,
															633.022
														],
														[
															155,
															642
														],
														[
															155.484,
															642.961
														],
														[
															156,
															644
														],
														[
															164.666,
															649.769
														],
														[
															173,
															655
														],
														[
															190.197,
															665.419
														],
														[
															208,
															675
														],
														[
															272.298,
															698.527
														],
														[
															349,
															710
														],
														[
															349.764,
															709.549
														],
														[
															350,
															709
														],
														[
															353.583,
															709.42
														],
														[
															358,
															710
														],
														[
															374.268,
															709.805
														],
														[
															389,
															708
														],
														[
															394,
															706
														],
														[
															397,
															701
														],
														[
															399,
															700
														],
														[
															400,
															697
														],
														[
															406,
															695
														],
														[
															423,
															692
														],
														[
															537,
															649
														],
														[
															558,
															636
														],
														[
															559,
															634
														],
														[
															561,
															634
														],
														[
															562,
															632
														],
														[
															569,
															628
														],
														[
															582,
															618
														],
														[
															586,
															614
														],
														[
															599,
															601
														],
														[
															603,
															599
														],
														[
															613,
															588
														],
														[
															685,
															472
														],
														[
															704,
															325
														],
														[
															695,
															272
														],
														[
															666,
															196
														],
														[
															658,
															183
														],
														[
															650,
															170
														],
														[
															641,
															156
														],
														[
															639,
															155
														],
														[
															628,
															140
														],
														[
															586,
															98
														],
														[
															584,
															95
														],
														[
															580,
															93
														],
														[
															572,
															86
														],
														[
															563,
															79
														],
														[
															561,
															79
														],
														[
															560,
															77
														],
														[
															550,
															71
														],
														[
															542,
															66
														],
														[
															537,
															63
														],
														[
															502,
															45
														],
														[
															343,
															15
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 2,
											"s": [
												{
													"i": [
														[
															-0.119,
															0.007
														],
														[
															6.832,
															-0.604
														],
														[
															6.955,
															-1.187
														],
														[
															20.998,
															-8.268
														],
														[
															17.04,
															-10.668
														],
														[
															11.605,
															-10.001
														],
														[
															10.775,
															-11.351
														],
														[
															11.106,
															-17.569
														],
														[
															8.532,
															-21.93
														],
														[
															4.354,
															-25.416
														],
														[
															-1.79,
															-27.803
														],
														[
															-2.874,
															-13.711
														],
														[
															-3.556,
															-11.414
														],
														[
															-0.79,
															-2.897
														],
														[
															-0.98,
															-2.654
														],
														[
															-0.765,
															-1.14
														],
														[
															-0.495,
															-1.233
														],
														[
															-0.134,
															-0.7
														],
														[
															-0.177,
															-0.488
														],
														[
															-3.47,
															-6.656
														],
														[
															-3.416,
															-5.918
														],
														[
															-1.29,
															-2.331
														],
														[
															-1.44,
															-2.252
														],
														[
															-8.237,
															-10.219
														],
														[
															-8.834,
															-8.834
														],
														[
															-2.282,
															-2.048
														],
														[
															-1.937,
															-0.873
														],
														[
															-0.776,
															-0.859
														],
														[
															-0.381,
															-0.33
														],
														[
															-1.325,
															-1.436
														],
														[
															-1.17,
															-0.933
														],
														[
															-0.684,
															-0.249
														],
														[
															-0.611,
															-0.483
														],
														[
															-5.303,
															-3.877
														],
														[
															-5.658,
															-3.434
														],
														[
															-20.039,
															-7.667
														],
														[
															-2.773,
															-0.976
														],
														[
															-22.713,
															-3.606
														],
														[
															-19.908,
															0.718
														],
														[
															-4.335,
															2.572
														],
														[
															-1.607,
															1.97
														],
														[
															-0.654,
															0.533
														],
														[
															-3.924,
															1.267
														],
														[
															-5.441,
															1.05
														],
														[
															-19.466,
															7.788
														],
														[
															-4.693,
															2.117
														],
														[
															-4.633,
															2.425
														],
														[
															-4.537,
															2.619
														],
														[
															-2.154,
															1.293
														],
														[
															-2.075,
															1.264
														],
														[
															-1.176,
															1.127
														],
														[
															-1.696,
															1.201
														],
														[
															-7.807,
															6.41
														],
														[
															-9.391,
															10.313
														],
														[
															-1.504,
															1.705
														],
														[
															-0.78,
															0.826
														],
														[
															-0.958,
															1.095
														],
														[
															-3.035,
															3.923
														],
														[
															-3.983,
															5.526
														],
														[
															-1.377,
															2.1
														],
														[
															-1.05,
															1.096
														],
														[
															-2.228,
															4.091
														],
														[
															-5.062,
															15.307
														],
														[
															-0.537,
															1.474
														],
														[
															-2.917,
															11.251
														],
														[
															-0.87,
															4.016
														],
														[
															-0.799,
															21.342
														],
														[
															4.305,
															21.611
														],
														[
															3.254,
															10.896
														],
														[
															1.859,
															5.041
														],
														[
															0.955,
															2.448
														],
														[
															1.445,
															3.372
														],
														[
															0.844,
															2.051
														],
														[
															9.912,
															14.639
														],
														[
															1.876,
															4.161
														],
														[
															0.249,
															0.325
														],
														[
															2.663,
															3.044
														],
														[
															9.555,
															7.963
														],
														[
															2.502,
															2.206
														],
														[
															1.811,
															1.498
														],
														[
															0.844,
															0.723
														],
														[
															1.188,
															0.965
														],
														[
															4.062,
															1.831
														],
														[
															0.37,
															0.247
														],
														[
															0.511,
															0.23
														],
														[
															0.358,
															0.248
														],
														[
															4.235,
															2.597
														],
														[
															0.417,
															0.399
														],
														[
															1.689,
															0.986
														],
														[
															11.493,
															5.143
														],
														[
															63.236,
															-2.988
														]
													],
													"o": [
														[
															-6.719,
															0.397
														],
														[
															-6.832,
															0.604
														],
														[
															-24.966,
															4.259
														],
														[
															-20.999,
															8.268
														],
														[
															-13.805,
															8.643
														],
														[
															-11.605,
															10.002
														],
														[
															-14.042,
															14.794
														],
														[
															-11.106,
															17.569
														],
														[
															-8.377,
															21.531
														],
														[
															-4.353,
															25.416
														],
														[
															0.95,
															14.743
														],
														[
															2.874,
															13.711
														],
														[
															0.86,
															2.76
														],
														[
															0.79,
															2.897
														],
														[
															0.445,
															1.207
														],
														[
															0.765,
															1.14
														],
														[
															0.285,
															0.711
														],
														[
															0.134,
															0.7
														],
														[
															2.706,
															7.457
														],
														[
															3.469,
															6.656
														],
														[
															1.398,
															2.423
														],
														[
															1.29,
															2.331
														],
														[
															7.219,
															11.289
														],
														[
															8.237,
															10.219
														],
														[
															1.934,
															1.935
														],
														[
															2.282,
															2.048
														],
														[
															0.517,
															0.233
														],
														[
															0.776,
															0.859
														],
														[
															1.529,
															1.321
														],
														[
															1.325,
															1.436
														],
														[
															0.654,
															0.523
														],
														[
															0.684,
															0.249
														],
														[
															5.129,
															4.058
														],
														[
															5.303,
															3.877
														],
														[
															18.113,
															10.992
														],
														[
															2.571,
															0.984
														],
														[
															19.736,
															6.945
														],
														[
															19.27,
															3.06
														],
														[
															9.559,
															-0.345
														],
														[
															2.87,
															-1.703
														],
														[
															0.526,
															-0.644
														],
														[
															2.047,
															-1.669
														],
														[
															5.488,
															-1.771
														],
														[
															23.183,
															-4.474
														],
														[
															4.707,
															-1.883
														],
														[
															5.099,
															-2.3
														],
														[
															4.569,
															-2.392
														],
														[
															2.22,
															-1.281
														],
														[
															2.081,
															-1.249
														],
														[
															2.545,
															-1.551
														],
														[
															1.764,
															-1.69
														],
														[
															8.185,
															-5.793
														],
														[
															11.753,
															-9.65
														],
														[
															1.6,
															-1.757
														],
														[
															0.744,
															-0.844
														],
														[
															0.94,
															-0.995
														],
														[
															3.298,
															-3.77
														],
														[
															4.589,
															-5.932
														],
														[
															1.563,
															-2.169
														],
														[
															1.498,
															-2.284
														],
														[
															3.415,
															-3.565
														],
														[
															7.824,
															-14.368
														],
														[
															0.604,
															-1.826
														],
														[
															3.782,
															-10.38
														],
														[
															1.283,
															-4.949
														],
														[
															4.189,
															-19.334
														],
														[
															1.039,
															-27.733
														],
														[
															-2.347,
															-11.781
														],
														[
															-1.591,
															-5.327
														],
														[
															-0.984,
															-2.668
														],
														[
															-1.493,
															-3.829
														],
														[
															-1.1,
															-2.566
														],
														[
															-7.496,
															-18.221
														],
														[
															-3.201,
															-4.727
														],
														[
															-0.133,
															-0.295
														],
														[
															-2.958,
															-3.865
														],
														[
															-8.908,
															-10.185
														],
														[
															-2.998,
															-2.498
														],
														[
															-1.811,
															-1.596
														],
														[
															-0.844,
															-0.699
														],
														[
															-1.04,
															-0.892
														],
														[
															-4.109,
															-3.338
														],
														[
															-0.324,
															-0.146
														],
														[
															-0.46,
															-0.307
														],
														[
															-0.317,
															-0.143
														],
														[
															-5.214,
															-3.608
														],
														[
															-1.521,
															-0.933
														],
														[
															-1.682,
															-1.612
														],
														[
															-11.394,
															-6.649
														],
														[
															-43.475,
															-19.455
														],
														[
															-0.63,
															0.03
														]
													],
													"v": [
														[
															342,
															16
														],
														[
															321.677,
															17.408
														],
														[
															301,
															20
														],
														[
															232.055,
															39.193
														],
														[
															175,
															68
														],
														[
															137.227,
															95.969
														],
														[
															104,
															128
														],
														[
															66.367,
															176.148
														],
														[
															37,
															235
														],
														[
															17.375,
															305.796
														],
														[
															13,
															386
														],
														[
															19.045,
															428.996
														],
														[
															29,
															467
														],
														[
															31.409,
															475.579
														],
														[
															34,
															484
														],
														[
															35.963,
															487.48
														],
														[
															38,
															491
														],
														[
															38.581,
															493.167
														],
														[
															39,
															495
														],
														[
															48.467,
															516.154
														],
														[
															59,
															535
														],
														[
															62.969,
															542.128
														],
														[
															67,
															549
														],
														[
															90.289,
															581.342
														],
														[
															116,
															610
														],
														[
															122.498,
															616.296
														],
														[
															129,
															621
														],
														[
															131.102,
															622.928
														],
														[
															133,
															625
														],
														[
															137.269,
															629.291
														],
														[
															141,
															633
														],
														[
															143.033,
															634.03
														],
														[
															145,
															635
														],
														[
															160.603,
															646.968
														],
														[
															177,
															658
														],
														[
															235,
															687
														],
														[
															243,
															689
														],
														[
															304,
															705
														],
														[
															365,
															710
														],
														[
															392,
															707
														],
														[
															398,
															700
														],
														[
															400,
															697
														],
														[
															407,
															695
														],
														[
															424,
															692
														],
														[
															489,
															673
														],
														[
															503,
															666
														],
														[
															518,
															660
														],
														[
															531,
															652
														],
														[
															538,
															649
														],
														[
															544,
															644
														],
														[
															552,
															640
														],
														[
															557,
															636
														],
														[
															581,
															618
														],
														[
															614,
															588
														],
														[
															618,
															582
														],
														[
															621,
															580
														],
														[
															623,
															576
														],
														[
															633,
															565
														],
														[
															646,
															547
														],
														[
															651,
															541
														],
														[
															655,
															533
														],
														[
															662,
															521
														],
														[
															684,
															475
														],
														[
															686,
															471
														],
														[
															695,
															438
														],
														[
															698,
															426
														],
														[
															706,
															365
														],
														[
															699,
															289
														],
														[
															691,
															255
														],
														[
															685,
															240
														],
														[
															683,
															232
														],
														[
															678,
															221
														],
														[
															675,
															214
														],
														[
															646,
															164
														],
														[
															637,
															150
														],
														[
															635,
															149
														],
														[
															628,
															140
														],
														[
															600,
															110
														],
														[
															592,
															102
														],
														[
															586,
															98
														],
														[
															584,
															95
														],
														[
															580,
															93
														],
														[
															567,
															83
														],
														[
															566,
															81
														],
														[
															564,
															81
														],
														[
															563,
															79
														],
														[
															547,
															69
														],
														[
															542,
															66
														],
														[
															537,
															63
														],
														[
															502,
															45
														],
														[
															343,
															15
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 3,
											"s": [
												{
													"i": [
														[
															-0.119,
															0.007
														],
														[
															6.827,
															-0.6
														],
														[
															6.966,
															-1.201
														],
														[
															6.096,
															-1.347
														],
														[
															5.416,
															-1.544
														],
														[
															10.325,
															-4.262
														],
														[
															8.978,
															-4.609
														],
														[
															4.683,
															-2.425
														],
														[
															4.404,
															-2.8
														],
														[
															10.304,
															-8.313
														],
														[
															8.704,
															-8.703
														],
														[
															1.869,
															-1.833
														],
														[
															1.721,
															-1.865
														],
														[
															0.572,
															-1.014
														],
														[
															0.85,
															-1.011
														],
														[
															0.565,
															-0.293
														],
														[
															0.384,
															-0.406
														],
														[
															0.227,
															-0.695
														],
														[
															0.508,
															-0.602
														],
														[
															0.565,
															-0.293
														],
														[
															0.385,
															-0.407
														],
														[
															0.251,
															-0.71
														],
														[
															0.535,
															-0.671
														],
														[
															0.581,
															-0.288
														],
														[
															0.341,
															-0.428
														],
														[
															0.279,
															-0.716
														],
														[
															0.436,
															-0.577
														],
														[
															2.982,
															-4.325
														],
														[
															2.822,
															-4.394
														],
														[
															9.671,
															-35.154
														],
														[
															-3.18,
															-41.694
														],
														[
															-2.153,
															-12.277
														],
														[
															-3.363,
															-11.478
														],
														[
															-17.176,
															-26.984
														],
														[
															-22.59,
															-19.946
														],
														[
															-29.29,
															-14.595
														],
														[
															-37.469,
															-5.865
														],
														[
															-10.374,
															-0.969
														],
														[
															-9.979,
															0.368
														],
														[
															-3.664,
															0.069
														],
														[
															-2.736,
															0.589
														],
														[
															-1.163,
															0.593
														],
														[
															-0.831,
															1.087
														],
														[
															-1.137,
															1.652
														],
														[
															-1.182,
															0.733
														],
														[
															-2.691,
															0.361
														],
														[
															-2.339,
															0.381
														],
														[
															-4.428,
															0.822
														],
														[
															-4.033,
															1.016
														],
														[
															-12.854,
															4.964
														],
														[
															-10.844,
															5.685
														],
														[
															-2.372,
															1.134
														],
														[
															-2.202,
															1.253
														],
														[
															-0.257,
															0.252
														],
														[
															-0.019,
															0.019
														],
														[
															-0.859,
															0.442
														],
														[
															-0.756,
															0.457
														],
														[
															-4.2,
															2.904
														],
														[
															-3.707,
															2.663
														],
														[
															-1.924,
															1.456
														],
														[
															-1.995,
															1.519
														],
														[
															-4.611,
															4.188
														],
														[
															-4.448,
															4.36
														],
														[
															-1.831,
															2.136
														],
														[
															-1.019,
															1.119
														],
														[
															-1.605,
															1.753
														],
														[
															-4.494,
															5.873
														],
														[
															-1.427,
															1.937
														],
														[
															-6.757,
															11.506
														],
														[
															6.992,
															82.797
														],
														[
															8.611,
															23.879
														],
														[
															1.007,
															2.676
														],
														[
															0.972,
															2.263
														],
														[
															2.256,
															4.696
														],
														[
															12.962,
															16.421
														],
														[
															0.853,
															1.893
														],
														[
															0.684,
															0.829
														],
														[
															5.053,
															5.497
														],
														[
															3.662,
															3.334
														],
														[
															1.764,
															1.615
														],
														[
															1.877,
															1.709
														],
														[
															1.995,
															1.652
														],
														[
															0.864,
															0.69
														],
														[
															1.192,
															0.973
														],
														[
															2.455,
															1.698
														],
														[
															2.945,
															2.162
														],
														[
															4.24,
															2.6
														],
														[
															0.584,
															0.559
														],
														[
															1.689,
															0.986
														],
														[
															11.516,
															5.153
														],
														[
															62.903,
															-2.972
														]
													],
													"o": [
														[
															-6.726,
															0.398
														],
														[
															-6.827,
															0.6
														],
														[
															-6.2,
															1.069
														],
														[
															-6.096,
															1.347
														],
														[
															-11.721,
															3.343
														],
														[
															-10.325,
															4.262
														],
														[
															-4.865,
															2.498
														],
														[
															-4.683,
															2.425
														],
														[
															-11.079,
															7.044
														],
														[
															-10.304,
															8.313
														],
														[
															-1.803,
															1.803
														],
														[
															-1.869,
															1.833
														],
														[
															-0.861,
															0.932
														],
														[
															-0.572,
															1.014
														],
														[
															-0.355,
															0.422
														],
														[
															-0.565,
															0.293
														],
														[
															-0.583,
															0.617
														],
														[
															-0.227,
															0.695
														],
														[
															-0.356,
															0.422
														],
														[
															-0.565,
															0.293
														],
														[
															-0.461,
															0.488
														],
														[
															-0.251,
															0.71
														],
														[
															-0.336,
															0.421
														],
														[
															-0.581,
															0.288
														],
														[
															-0.447,
															0.56
														],
														[
															-0.279,
															0.715
														],
														[
															-3.25,
															4.306
														],
														[
															-2.982,
															4.325
														],
														[
															-16.497,
															25.69
														],
														[
															-9.671,
															35.154
														],
														[
															1.023,
															13.413
														],
														[
															2.154,
															12.277
														],
														[
															9.704,
															33.12
														],
														[
															17.176,
															26.984
														],
														[
															22.373,
															19.754
														],
														[
															29.29,
															14.595
														],
														[
															9.525,
															1.491
														],
														[
															10.374,
															0.969
														],
														[
															3.607,
															-0.133
														],
														[
															3.664,
															-0.069
														],
														[
															2.518,
															-0.542
														],
														[
															1.163,
															-0.593
														],
														[
															1.269,
															-1.66
														],
														[
															1.137,
															-1.652
														],
														[
															1.898,
															-1.176
														],
														[
															2.691,
															-0.361
														],
														[
															4.257,
															-0.695
														],
														[
															4.428,
															-0.822
														],
														[
															13.741,
															-3.462
														],
														[
															12.854,
															-4.963
														],
														[
															2.311,
															-1.211
														],
														[
															2.372,
															-1.134
														],
														[
															-0.046,
															0.026
														],
														[
															0.257,
															-0.252
														],
														[
															0.807,
															-0.773
														],
														[
															0.859,
															-0.442
														],
														[
															4.494,
															-2.719
														],
														[
															4.2,
															-2.904
														],
														[
															2.308,
															-1.658
														],
														[
															1.924,
															-1.456
														],
														[
															5.109,
															-3.888
														],
														[
															4.611,
															-4.188
														],
														[
															2.65,
															-2.598
														],
														[
															0.883,
															-1.031
														],
														[
															1.563,
															-1.716
														],
														[
															5.301,
															-5.789
														],
														[
															1.466,
															-1.916
														],
														[
															7.594,
															-10.305
														],
														[
															31.098,
															-52.954
														],
														[
															-2.689,
															-31.846
														],
														[
															-0.946,
															-2.622
														],
														[
															-0.863,
															-2.293
														],
														[
															-2.155,
															-5.017
														],
														[
															-10.157,
															-21.141
														],
														[
															-1.995,
															-2.527
														],
														[
															-0.488,
															-1.082
														],
														[
															-5.071,
															-6.151
														],
														[
															-3.207,
															-3.489
														],
														[
															-1.792,
															-1.631
														],
														[
															-1.872,
															-1.715
														],
														[
															-1.78,
															-1.621
														],
														[
															-0.841,
															-0.696
														],
														[
															-1.07,
															-0.854
														],
														[
															-2.904,
															-2.371
														],
														[
															-3.702,
															-2.56
														],
														[
															-5.07,
															-3.721
														],
														[
															-1.87,
															-1.147
														],
														[
															-1.682,
															-1.612
														],
														[
															-11.424,
															-6.667
														],
														[
															-43.584,
															-19.504
														],
														[
															-0.63,
															0.03
														]
													],
													"v": [
														[
															342,
															16
														],
														[
															321.68,
															17.397
														],
														[
															301,
															20
														],
														[
															282.412,
															23.643
														],
														[
															265,
															28
														],
														[
															231.943,
															39.55
														],
														[
															203,
															53
														],
														[
															188.654,
															60.273
														],
														[
															175,
															68
														],
														[
															142.719,
															91.256
														],
														[
															114,
															117
														],
														[
															108.439,
															122.453
														],
														[
															103,
															128
														],
														[
															100.993,
															130.941
														],
														[
															99,
															134
														],
														[
															97.522,
															135.012
														],
														[
															96,
															136
														],
														[
															94.944,
															138.011
														],
														[
															94,
															140
														],
														[
															92.521,
															141.011
														],
														[
															91,
															142
														],
														[
															90.055,
															143.863
														],
														[
															89,
															146
														],
														[
															87.504,
															146.995
														],
														[
															86,
															148
														],
														[
															84.991,
															149.987
														],
														[
															84,
															152
														],
														[
															74.679,
															164.934
														],
														[
															66,
															178
														],
														[
															25.243,
															269.997
														],
														[
															14,
															386
														],
														[
															18.745,
															424.451
														],
														[
															27,
															460
														],
														[
															67.835,
															550.38
														],
														[
															128,
															621
														],
														[
															205.178,
															673.416
														],
														[
															305,
															705
														],
														[
															335.16,
															708.894
														],
														[
															366,
															710
														],
														[
															377.153,
															709.842
														],
														[
															387,
															709
														],
														[
															392.265,
															707.408
														],
														[
															395,
															705
														],
														[
															398.566,
															699.804
														],
														[
															402,
															696
														],
														[
															409.169,
															693.904
														],
														[
															417,
															693
														],
														[
															430.168,
															690.741
														],
														[
															443,
															688
														],
														[
															483.173,
															675.167
														],
														[
															519,
															659
														],
														[
															526.081,
															655.531
														],
														[
															533,
															652
														],
														[
															533.451,
															651.534
														],
														[
															534,
															651
														],
														[
															536.538,
															649.263
														],
														[
															539,
															648
														],
														[
															552.09,
															639.458
														],
														[
															564,
															631
														],
														[
															570.235,
															626.395
														],
														[
															576,
															622
														],
														[
															590.495,
															609.854
														],
														[
															604,
															597
														],
														[
															612,
															590
														],
														[
															614,
															586
														],
														[
															619,
															581
														],
														[
															634,
															564
														],
														[
															638,
															558
														],
														[
															659,
															526
														],
														[
															704,
															325
														],
														[
															685,
															240
														],
														[
															683,
															232
														],
														[
															679,
															225
														],
														[
															673,
															210
														],
														[
															637,
															152
														],
														[
															632,
															144
														],
														[
															628,
															140
														],
														[
															613,
															123
														],
														[
															603,
															112
														],
														[
															597,
															108
														],
														[
															592,
															102
														],
														[
															586,
															98
														],
														[
															584,
															95
														],
														[
															580,
															93
														],
														[
															572,
															86
														],
														[
															563,
															79
														],
														[
															547,
															69
														],
														[
															542,
															66
														],
														[
															537,
															63
														],
														[
															502,
															45
														],
														[
															343,
															15
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 4,
											"s": [
												{
													"i": [
														[
															-0.119,
															0.007
														],
														[
															6.847,
															-0.591
														],
														[
															6.897,
															-1.237
														],
														[
															19.285,
															-7.25
														],
														[
															15.419,
															-8.974
														],
														[
															0.661,
															-0.297
														],
														[
															0.65,
															-0.401
														],
														[
															0.952,
															-0.909
														],
														[
															1.082,
															-0.682
														],
														[
															0.684,
															-0.061
														],
														[
															0.636,
															-0.359
														],
														[
															0.501,
															-0.6
														],
														[
															0.472,
															-0.302
														],
														[
															2.098,
															-1.466
														],
														[
															2.028,
															-1.493
														],
														[
															1.343,
															-0.852
														],
														[
															1.202,
															-0.541
														],
														[
															0.761,
															-0.854
														],
														[
															0.415,
															-0.341
														],
														[
															4.865,
															-4.341
														],
														[
															4.381,
															-4.381
														],
														[
															1.863,
															-1.824
														],
														[
															1.715,
															-1.873
														],
														[
															0.612,
															-1.053
														],
														[
															0.769,
															-0.929
														],
														[
															0.572,
															-0.289
														],
														[
															0.362,
															-0.422
														],
														[
															0.237,
															-0.689
														],
														[
															0.512,
															-0.613
														],
														[
															0.571,
															-0.289
														],
														[
															0.363,
															-0.423
														],
														[
															0.27,
															-0.719
														],
														[
															0.475,
															-0.602
														],
														[
															0.846,
															-0.975
														],
														[
															0.791,
															-1.055
														],
														[
															12.872,
															-39.589
														],
														[
															-3.587,
															-48.505
														],
														[
															-7.792,
															-24.827
														],
														[
															-11.61,
															-20.644
														],
														[
															-2.089,
															-4.635
														],
														[
															-0.238,
															-0.411
														],
														[
															-0.967,
															-1.498
														],
														[
															-2.961,
															-3.944
														],
														[
															-4.767,
															-5.561
														],
														[
															-1.922,
															-2.243
														],
														[
															-1.111,
															-1.22
														],
														[
															-3.498,
															-3.498
														],
														[
															-2.166,
															-1.857
														],
														[
															-1.132,
															-1.011
														],
														[
															-1.777,
															-1.59
														],
														[
															-15.53,
															-9.71
														],
														[
															-1.017,
															-0.974
														],
														[
															-0.74,
															-0.709
														],
														[
															-1.202,
															-0.697
														],
														[
															-19.297,
															-6.183
														],
														[
															-35.646,
															-1.812
														],
														[
															-9.777,
															2.384
														],
														[
															-1.958,
															1.721
														],
														[
															-2.997,
															0.829
														],
														[
															-1.206,
															0.397
														],
														[
															-5.847,
															1.128
														],
														[
															-17.107,
															6.365
														],
														[
															-2.72,
															1.067
														],
														[
															-3.508,
															1.645
														],
														[
															-9.059,
															5.244
														],
														[
															-20.612,
															19.855
														],
														[
															-1.828,
															2.133
														],
														[
															-1.019,
															1.119
														],
														[
															-4.162,
															5.181
														],
														[
															-2.629,
															3.582
														],
														[
															-1.193,
															1.245
														],
														[
															-0.814,
															0.85
														],
														[
															-1.748,
															2.621
														],
														[
															-2.613,
															4.456
														],
														[
															-6.73,
															37.958
														],
														[
															-0.23,
															1.147
														],
														[
															-0.458,
															2.889
														],
														[
															-0.528,
															16.832
														],
														[
															1.332,
															13.816
														],
														[
															27.006,
															40.894
														],
														[
															2.058,
															4.565
														],
														[
															0.249,
															0.346
														],
														[
															3.672,
															4.615
														],
														[
															5.047,
															5.432
														],
														[
															4.104,
															1.85
														],
														[
															0.295,
															0.246
														],
														[
															2.782,
															2.547
														],
														[
															1.93,
															1.625
														],
														[
															1.767,
															1.467
														],
														[
															12.997,
															7.978
														],
														[
															83.175,
															-3.93
														]
													],
													"o": [
														[
															-6.714,
															0.397
														],
														[
															-6.847,
															0.591
														],
														[
															-22.442,
															4.025
														],
														[
															-19.285,
															7.25
														],
														[
															-0.707,
															0.411
														],
														[
															-0.661,
															0.297
														],
														[
															-1.109,
															0.684
														],
														[
															-0.952,
															0.909
														],
														[
															-0.629,
															0.397
														],
														[
															-0.684,
															0.061
														],
														[
															-0.525,
															0.297
														],
														[
															-0.501,
															0.6
														],
														[
															-2.579,
															1.644
														],
														[
															-2.098,
															1.466
														],
														[
															-1.426,
															1.049
														],
														[
															-1.343,
															0.852
														],
														[
															-0.541,
															0.244
														],
														[
															-0.761,
															0.854
														],
														[
															-5.16,
															4.254
														],
														[
															-4.865,
															4.341
														],
														[
															-1.832,
															1.832
														],
														[
															-1.863,
															1.824
														],
														[
															-0.785,
															0.858
														],
														[
															-0.612,
															1.053
														],
														[
															-0.35,
															0.422
														],
														[
															-0.572,
															0.289
														],
														[
															-0.542,
															0.632
														],
														[
															-0.236,
															0.689
														],
														[
															-0.352,
															0.422
														],
														[
															-0.571,
															0.289
														],
														[
															-0.446,
															0.52
														],
														[
															-0.27,
															0.719
														],
														[
															-0.825,
															1.046
														],
														[
															-0.846,
															0.975
														],
														[
															-21.097,
															28.141
														],
														[
															-12.872,
															39.589
														],
														[
															2.222,
															30.05
														],
														[
															7.792,
															24.827
														],
														[
															2.906,
															5.167
														],
														[
															0.157,
															0.348
														],
														[
															0.774,
															1.339
														],
														[
															3.196,
															4.951
														],
														[
															4.73,
															6.3
														],
														[
															2.667,
															3.111
														],
														[
															1.03,
															1.202
														],
														[
															3.45,
															3.789
														],
														[
															2.699,
															2.699
														],
														[
															1.033,
															0.886
														],
														[
															1.729,
															1.543
														],
														[
															13.716,
															12.271
														],
														[
															2.414,
															1.509
														],
														[
															1.78,
															1.705
														],
														[
															0.864,
															0.828
														],
														[
															17.304,
															10.028
														],
														[
															28.729,
															9.204
														],
														[
															11.293,
															0.574
														],
														[
															3.539,
															-0.863
														],
														[
															3.271,
															-2.875
														],
														[
															1.226,
															-0.339
														],
														[
															5.536,
															-1.823
														],
														[
															20.207,
															-3.9
														],
														[
															3.837,
															-1.428
														],
														[
															4.69,
															-1.84
														],
														[
															9.536,
															-4.471
														],
														[
															26.165,
															-15.146
														],
														[
															2.671,
															-2.573
														],
														[
															0.883,
															-1.031
														],
														[
															5.029,
															-5.523
														],
														[
															3.326,
															-4.141
														],
														[
															1.616,
															-2.203
														],
														[
															0.803,
															-0.838
														],
														[
															2.373,
															-2.477
														],
														[
															2.77,
															-4.154
														],
														[
															16.909,
															-28.834
														],
														[
															0.224,
															-1.264
														],
														[
															0.545,
															-2.718
														],
														[
															2.32,
															-14.624
														],
														[
															0.415,
															-13.234
														],
														[
															-5.606,
															-58.174
														],
														[
															-3.178,
															-4.813
														],
														[
															-0.139,
															-0.309
														],
														[
															-4.002,
															-5.569
														],
														[
															-4.939,
															-6.207
														],
														[
															-3.76,
															-4.047
														],
														[
															-0.274,
															-0.124
														],
														[
															-3.296,
															-2.747
														],
														[
															-1.772,
															-1.622
														],
														[
															-1.874,
															-1.578
														],
														[
															-11.841,
															-9.827
														],
														[
															-51.266,
															-31.468
														],
														[
															-0.63,
															0.03
														]
													],
													"v": [
														[
															342,
															16
														],
														[
															321.638,
															17.37
														],
														[
															301,
															20
														],
														[
															238.233,
															37.288
														],
														[
															186,
															62
														],
														[
															183.958,
															63.008
														],
														[
															182,
															64
														],
														[
															178.979,
															66.501
														],
														[
															176,
															69
														],
														[
															174.005,
															69.528
														],
														[
															172,
															70
														],
														[
															170.46,
															71.497
														],
														[
															169,
															73
														],
														[
															162.087,
															77.614
														],
														[
															156,
															82
														],
														[
															151.832,
															84.881
														],
														[
															148,
															87
														],
														[
															145.905,
															88.927
														],
														[
															144,
															91
														],
														[
															128.916,
															103.904
														],
														[
															115,
															117
														],
														[
															109.412,
															122.469
														],
														[
															104,
															128
														],
														[
															101.988,
															130.946
														],
														[
															100,
															134
														],
														[
															98.509,
															135
														],
														[
															97,
															136
														],
														[
															95.977,
															138.015
														],
														[
															95,
															140
														],
														[
															93.508,
															140.999
														],
														[
															92,
															142
														],
														[
															91.021,
															143.939
														],
														[
															90,
															146
														],
														[
															87.475,
															148.993
														],
														[
															85,
															152
														],
														[
															31.987,
															254.227
														],
														[
															16,
															387
														],
														[
															31.459,
															469.055
														],
														[
															61,
															537
														],
														[
															70,
															552
														],
														[
															72,
															553
														],
														[
															74,
															557
														],
														[
															83,
															570
														],
														[
															97,
															588
														],
														[
															105,
															596
														],
														[
															107,
															600
														],
														[
															118,
															611
														],
														[
															126,
															619
														],
														[
															130,
															621
														],
														[
															135,
															626
														],
														[
															179,
															659
														],
														[
															187,
															663
														],
														[
															194,
															667
														],
														[
															196,
															668
														],
														[
															253,
															693
														],
														[
															347,
															709
														],
														[
															389,
															708
														],
														[
															394,
															706
														],
														[
															403,
															695
														],
														[
															407,
															695
														],
														[
															424,
															692
														],
														[
															481,
															676
														],
														[
															492,
															671
														],
														[
															503,
															666
														],
														[
															531,
															652
														],
														[
															602,
															598
														],
														[
															610,
															591
														],
														[
															612,
															587
														],
														[
															627,
															571
														],
														[
															636,
															560
														],
														[
															641,
															552
														],
														[
															643,
															549
														],
														[
															649,
															541
														],
														[
															657,
															528
														],
														[
															696,
															426
														],
														[
															698,
															422
														],
														[
															699,
															413
														],
														[
															704,
															365
														],
														[
															703,
															324
														],
														[
															649,
															170
														],
														[
															640,
															156
														],
														[
															638,
															155
														],
														[
															627,
															140
														],
														[
															612,
															123
														],
														[
															600,
															112
														],
														[
															599,
															110
														],
														[
															591,
															102
														],
														[
															585,
															98
														],
														[
															580,
															93
														],
														[
															543,
															67
														],
														[
															343,
															15
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 5,
											"s": [
												{
													"i": [
														[
															-0.119,
															0.007
														],
														[
															6.885,
															-0.592
														],
														[
															6.82,
															-1.239
														],
														[
															16.286,
															-5.724
														],
														[
															13.286,
															-6.73
														],
														[
															1.756,
															-0.841
														],
														[
															1.197,
															-0.734
														],
														[
															2.768,
															-1.827
														],
														[
															2.81,
															-1.779
														],
														[
															0.375,
															0.067
														],
														[
															0.26,
															-0.117
														],
														[
															0.163,
															-0.451
														],
														[
															0.185,
															-0.124
														],
														[
															0.379,
															0.067
														],
														[
															0.255,
															-0.115
														],
														[
															0.163,
															-0.451
														],
														[
															0.186,
															-0.124
														],
														[
															0.378,
															0.067
														],
														[
															0.256,
															-0.115
														],
														[
															0.161,
															-0.451
														],
														[
															0.19,
															-0.123
														],
														[
															0.724,
															-0.314
														],
														[
															0.543,
															-0.382
														],
														[
															2.378,
															-1.848
														],
														[
															2.184,
															-0.984
														],
														[
															0.168,
															-0.451
														],
														[
															0.173,
															-0.124
														],
														[
															5.335,
															-4.749
														],
														[
															4.77,
															-4.77
														],
														[
															2.034,
															-2.248
														],
														[
															0.94,
															-2.085
														],
														[
															0.859,
															-0.776
														],
														[
															0.329,
															-0.381
														],
														[
															4.354,
															-5.44
														],
														[
															2.469,
															-5.478
														],
														[
															0.451,
															-0.161
														],
														[
															0.123,
															-0.19
														],
														[
															0.324,
															-0.729
														],
														[
															0.351,
															-0.537
														],
														[
															5.442,
															-10.707
														],
														[
															4.699,
															-12.179
														],
														[
															3.826,
															-29.19
														],
														[
															-3.573,
															-29.22
														],
														[
															-12.05,
															-28.172
														],
														[
															-16.581,
															-21.817
														],
														[
															-1.475,
															-2.018
														],
														[
															-1.59,
															-1.942
														],
														[
															-2.338,
															-2.352
														],
														[
															-1.626,
															-2.125
														],
														[
															-6.389,
															-2.88
														],
														[
															-1.202,
															-1.03
														],
														[
															-1.173,
															-0.98
														],
														[
															-0.847,
															-0.726
														],
														[
															-1.155,
															-0.91
														],
														[
															-2.072,
															-1.573
														],
														[
															-31.555,
															-12.256
														],
														[
															-27.27,
															-4.318
														],
														[
															-13.759,
															-0.741
														],
														[
															-9.551,
															2.329
														],
														[
															-1.958,
															1.721
														],
														[
															-1.184,
															1.271
														],
														[
															-0.637,
															0.599
														],
														[
															-3.344,
															1.194
														],
														[
															-5.484,
															1.071
														],
														[
															-10.748,
															3.252
														],
														[
															-5.122,
															1.8
														],
														[
															-4.802,
															1.959
														],
														[
															-13.591,
															7.947
														],
														[
															-3.93,
															2.499
														],
														[
															-4.509,
															2.033
														],
														[
															-0.346,
															0.249
														],
														[
															-3.141,
															1.416
														],
														[
															-0.881,
															0.7
														],
														[
															-14.872,
															17.727
														],
														[
															-1.571,
															1.987
														],
														[
															-5.101,
															7.589
														],
														[
															-1.323,
															2.047
														],
														[
															-0.947,
															0.988
														],
														[
															-2.351,
															4.255
														],
														[
															-4.934,
															12.132
														],
														[
															5.985,
															63.961
														],
														[
															29.295,
															42.933
														],
														[
															0.721,
															1.04
														],
														[
															1.433,
															1.931
														],
														[
															0.22,
															0.489
														],
														[
															0.248,
															0.358
														],
														[
															0.773,
															0.985
														],
														[
															3.177,
															3.787
														],
														[
															6.874,
															6.587
														],
														[
															46.339,
															17.849
														],
														[
															55.857,
															-2.639
														]
													],
													"o": [
														[
															-6.642,
															0.392
														],
														[
															-6.885,
															0.592
														],
														[
															-18.569,
															3.373
														],
														[
															-16.286,
															5.724
														],
														[
															-1.779,
															0.901
														],
														[
															-1.756,
															0.841
														],
														[
															-3.118,
															1.913
														],
														[
															-2.768,
															1.827
														],
														[
															-0.238,
															0.151
														],
														[
															-0.375,
															-0.067
														],
														[
															-0.162,
															0.073
														],
														[
															-0.163,
															0.451
														],
														[
															-0.23,
															0.154
														],
														[
															-0.379,
															-0.067
														],
														[
															-0.162,
															0.073
														],
														[
															-0.163,
															0.451
														],
														[
															-0.231,
															0.153
														],
														[
															-0.378,
															-0.067
														],
														[
															-0.166,
															0.075
														],
														[
															-0.161,
															0.451
														],
														[
															-0.561,
															0.361
														],
														[
															-0.724,
															0.314
														],
														[
															-2.305,
															1.625
														],
														[
															-2.378,
															1.848
														],
														[
															-0.154,
															0.07
														],
														[
															-0.168,
															0.451
														],
														[
															-5.891,
															4.234
														],
														[
															-5.335,
															4.749
														],
														[
															-1.924,
															1.924
														],
														[
															-2.034,
															2.248
														],
														[
															-0.233,
															0.517
														],
														[
															-0.859,
															0.776
														],
														[
															-4.116,
															4.762
														],
														[
															-4.354,
															5.44
														],
														[
															-0.075,
															0.166
														],
														[
															-0.451,
															0.161
														],
														[
															-0.352,
															0.546
														],
														[
															-0.324,
															0.729
														],
														[
															-6.532,
															9.994
														],
														[
															-5.442,
															10.707
														],
														[
															-9.267,
															24.019
														],
														[
															-3.826,
															29.19
														],
														[
															4.218,
															34.495
														],
														[
															12.05,
															28.172
														],
														[
															1.511,
															1.987
														],
														[
															1.475,
															2.017
														],
														[
															2.02,
															2.467
														],
														[
															2.338,
															2.352
														],
														[
															4.876,
															6.37
														],
														[
															2.229,
															1.005
														],
														[
															1.039,
															0.891
														],
														[
															0.844,
															0.705
														],
														[
															1.114,
															0.955
														],
														[
															1.972,
															1.554
														],
														[
															24.811,
															18.831
														],
														[
															20.792,
															8.076
														],
														[
															12.371,
															1.959
														],
														[
															12.875,
															0.694
														],
														[
															3.539,
															-0.863
														],
														[
															2.083,
															-1.831
														],
														[
															0.602,
															-0.646
														],
														[
															1.858,
															-1.746
														],
														[
															5.183,
															-1.85
														],
														[
															12.147,
															-2.373
														],
														[
															5.099,
															-1.543
														],
														[
															5.183,
															-1.821
														],
														[
															15.762,
															-6.431
														],
														[
															4.31,
															-2.52
														],
														[
															4.894,
															-3.112
														],
														[
															0.309,
															-0.139
														],
														[
															3.63,
															-2.609
														],
														[
															1.119,
															-0.504
														],
														[
															18.09,
															-14.382
														],
														[
															1.476,
															-1.759
														],
														[
															6.247,
															-7.9
														],
														[
															1.334,
															-1.984
														],
														[
															1.487,
															-2.3
														],
														[
															3.629,
															-3.788
														],
														[
															6.256,
															-11.323
														],
														[
															17.629,
															-43.348
														],
														[
															-5.921,
															-63.278
														],
														[
															-0.888,
															-1.301
														],
														[
															-1.322,
															-1.908
														],
														[
															-0.314,
															-0.423
														],
														[
															-0.143,
															-0.317
														],
														[
															-0.758,
															-1.093
														],
														[
															-3.018,
															-3.843
														],
														[
															-6.656,
															-7.934
														],
														[
															-31.669,
															-30.343
														],
														[
															-40.762,
															-15.701
														],
														[
															-0.63,
															0.03
														]
													],
													"v": [
														[
															342,
															16
														],
														[
															321.634,
															17.365
														],
														[
															301,
															20
														],
														[
															248.538,
															33.983
														],
														[
															204,
															53
														],
														[
															198.564,
															55.625
														],
														[
															194,
															58
														],
														[
															185.268,
															63.6
														],
														[
															177,
															69
														],
														[
															176.016,
															69.026
														],
														[
															175,
															69
														],
														[
															174.517,
															69.962
														],
														[
															174,
															71
														],
														[
															173.019,
															71.029
														],
														[
															172,
															71
														],
														[
															171.518,
															71.963
														],
														[
															171,
															73
														],
														[
															170.019,
															73.028
														],
														[
															169,
															73
														],
														[
															168.519,
															73.964
														],
														[
															168,
															75
														],
														[
															165.986,
															75.984
														],
														[
															164,
															77
														],
														[
															156.909,
															82.48
														],
														[
															150,
															87
														],
														[
															149.514,
															87.959
														],
														[
															149,
															89
														],
														[
															132.159,
															102.598
														],
														[
															117,
															117
														],
														[
															110.762,
															123.379
														],
														[
															106,
															130
														],
														[
															104.072,
															132.102
														],
														[
															102,
															134
														],
														[
															88.765,
															149.462
														],
														[
															78,
															166
														],
														[
															77.036,
															166.481
														],
														[
															76,
															167
														],
														[
															75,
															169.007
														],
														[
															74,
															171
														],
														[
															56.125,
															201.861
														],
														[
															41,
															236
														],
														[
															20.87,
															317.1
														],
														[
															20,
															406
														],
														[
															45.228,
															500.009
														],
														[
															89,
															575
														],
														[
															93.44,
															581.034
														],
														[
															98,
															587
														],
														[
															104.795,
															594.256
														],
														[
															111,
															601
														],
														[
															132,
															621
														],
														[
															138,
															628
														],
														[
															142,
															630
														],
														[
															144,
															633
														],
														[
															148,
															635
														],
														[
															154,
															640
														],
														[
															237,
															687
														],
														[
															306,
															705
														],
														[
															345,
															709
														],
														[
															389,
															708
														],
														[
															394,
															706
														],
														[
															399,
															700
														],
														[
															400,
															697
														],
														[
															406,
															695
														],
														[
															423,
															692
														],
														[
															457,
															684
														],
														[
															472,
															678
														],
														[
															487,
															673
														],
														[
															529,
															652
														],
														[
															542,
															645
														],
														[
															556,
															636
														],
														[
															557,
															634
														],
														[
															568,
															627
														],
														[
															572,
															623
														],
														[
															620,
															576
														],
														[
															625,
															571
														],
														[
															642,
															547
														],
														[
															647,
															541
														],
														[
															651,
															533
														],
														[
															658,
															521
														],
														[
															675,
															486
														],
														[
															700,
															325
														],
														[
															641,
															162
														],
														[
															639,
															158
														],
														[
															634,
															153
														],
														[
															634,
															151
														],
														[
															632,
															150
														],
														[
															630,
															146
														],
														[
															620,
															135
														],
														[
															600,
															113
														],
														[
															486,
															39
														],
														[
															343,
															15
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 6,
											"s": [
												{
													"i": [
														[
															-0.119,
															0.007
														],
														[
															6.865,
															-0.587
														],
														[
															6.886,
															-1.258
														],
														[
															9.345,
															-2.626
														],
														[
															7.353,
															-2.803
														],
														[
															0.894,
															-0.113
														],
														[
															0.69,
															-0.269
														],
														[
															1.133,
															-0.754
														],
														[
															1.175,
															-0.48
														],
														[
															0.681,
															-0.117
														],
														[
															0.531,
															-0.227
														],
														[
															1.173,
															-0.507
														],
														[
															1.025,
															-0.422
														],
														[
															0.66,
															-0.35
														],
														[
															0.624,
															-0.297
														],
														[
															11.181,
															-6.852
														],
														[
															9.803,
															-7.655
														],
														[
															1.779,
															-1.701
														],
														[
															1.921,
															-1.663
														],
														[
															2.027,
															-1.605
														],
														[
															1.893,
															-1.853
														],
														[
															5.282,
															-5.755
														],
														[
															4.443,
															-5.666
														],
														[
															1.214,
															-1.528
														],
														[
															0.905,
															-1.309
														],
														[
															0.315,
															-0.74
														],
														[
															0.362,
															-0.495
														],
														[
															0.916,
															-0.784
														],
														[
															0.66,
															-0.939
														],
														[
															-0.067,
															-0.382
														],
														[
															0.112,
															-0.25
														],
														[
															0.451,
															-0.161
														],
														[
															0.123,
															-0.19
														],
														[
															0.309,
															-0.708
														],
														[
															0.392,
															-0.594
														],
														[
															2.752,
															-4.483
														],
														[
															1.459,
															-2.38
														],
														[
															3.024,
															-6.153
														],
														[
															2.143,
															-4.972
														],
														[
															1.097,
															-3.317
														],
														[
															2.344,
															-7.172
														],
														[
															2.648,
															-25.056
														],
														[
															-1.627,
															-21.774
														],
														[
															-19.106,
															-38.811
														],
														[
															-30.185,
															-27.857
														],
														[
															-8.084,
															-6.186
														],
														[
															-4.124,
															-1.859
														],
														[
															-0.358,
															-0.248
														],
														[
															-1.758,
															-1.684
														],
														[
															-0.85,
															-0.815
														],
														[
															-1.507,
															-0.924
														],
														[
															-1.969,
															-1.207
														],
														[
															-26.804,
															-7.193
														],
														[
															-12.242,
															-1.922
														],
														[
															-21.868,
															3.469
														],
														[
															-2.213,
															2.269
														],
														[
															-1.419,
															1.274
														],
														[
															-3.378,
															1.218
														],
														[
															-5.662,
															1.122
														],
														[
															-18.689,
															7.7
														],
														[
															-6.504,
															3.288
														],
														[
															-6.888,
															4.039
														],
														[
															-10.818,
															8.448
														],
														[
															-3.774,
															3.222
														],
														[
															-1.977,
															1.8
														],
														[
															-7.947,
															8.964
														],
														[
															-1.053,
															2.336
														],
														[
															-0.245,
															0.29
														],
														[
															-0.736,
															1.633
														],
														[
															-0.703,
															0.889
														],
														[
															-2.435,
															3.318
														],
														[
															-1.505,
															2.214
														],
														[
															-4.908,
															8.702
														],
														[
															6.633,
															84.825
														],
														[
															0.812,
															5.826
														],
														[
															1.649,
															7.23
														],
														[
															4.505,
															12.688
														],
														[
															0.371,
															0.945
														],
														[
															0.564,
															1.526
														],
														[
															3.393,
															7.917
														],
														[
															2.544,
															4.605
														],
														[
															0.957,
															0.999
														],
														[
															0.699,
															1.176
														],
														[
															3.37,
															7.477
														],
														[
															0.249,
															0.346
														],
														[
															1.416,
															3.141
														],
														[
															0.249,
															0.346
														],
														[
															3.627,
															4.153
														],
														[
															9.601,
															8.755
														],
														[
															40.172,
															15.863
														],
														[
															56.408,
															-2.665
														]
													],
													"o": [
														[
															-6.656,
															0.393
														],
														[
															-6.865,
															0.587
														],
														[
															-9.267,
															1.692
														],
														[
															-9.345,
															2.626
														],
														[
															-0.733,
															0.279
														],
														[
															-0.894,
															0.113
														],
														[
															-1.293,
															0.505
														],
														[
															-1.133,
															0.754
														],
														[
															-0.746,
															0.305
														],
														[
															-0.681,
															0.117
														],
														[
															-1.283,
															0.55
														],
														[
															-1.173,
															0.507
														],
														[
															-0.734,
															0.302
														],
														[
															-0.66,
															0.35
														],
														[
															-12.474,
															5.939
														],
														[
															-11.181,
															6.852
														],
														[
															-1.963,
															1.533
														],
														[
															-1.779,
															1.701
														],
														[
															-1.998,
															1.729
														],
														[
															-2.027,
															1.604
														],
														[
															-5.428,
															5.312
														],
														[
															-5.282,
															5.755
														],
														[
															-1.239,
															1.581
														],
														[
															-1.214,
															1.528
														],
														[
															-0.377,
															0.545
														],
														[
															-0.315,
															0.74
														],
														[
															-0.675,
															0.924
														],
														[
															-0.916,
															0.784
														],
														[
															-0.156,
															0.221
														],
														[
															0.067,
															0.382
														],
														[
															-0.075,
															0.166
														],
														[
															-0.451,
															0.161
														],
														[
															-0.371,
															0.577
														],
														[
															-0.309,
															0.707
														],
														[
															-2.841,
															4.302
														],
														[
															-1.995,
															3.251
														],
														[
															-3.745,
															6.107
														],
														[
															-2.304,
															4.688
														],
														[
															-1.609,
															3.733
														],
														[
															-2.195,
															6.637
														],
														[
															-7.154,
															21.89
														],
														[
															-2.122,
															20.078
														],
														[
															4.014,
															53.731
														],
														[
															18.977,
															38.551
														],
														[
															7.539,
															6.958
														],
														[
															4.206,
															3.218
														],
														[
															0.316,
															0.143
														],
														[
															3.239,
															2.245
														],
														[
															0.838,
															0.803
														],
														[
															1.615,
															1.547
														],
														[
															2.697,
															1.654
														],
														[
															21.789,
															13.361
														],
														[
															10.928,
															2.932
														],
														[
															24.006,
															3.769
														],
														[
															3.362,
															-0.533
														],
														[
															1.818,
															-1.865
														],
														[
															1.848,
															-1.659
														],
														[
															5.372,
															-1.937
														],
														[
															22.566,
															-4.473
														],
														[
															7.338,
															-3.023
														],
														[
															7.291,
															-3.685
														],
														[
															12.998,
															-7.622
														],
														[
															4.04,
															-3.155
														],
														[
															1.9,
															-1.622
														],
														[
															9.344,
															-8.509
														],
														[
															2.193,
															-2.474
														],
														[
															0.122,
															-0.27
														],
														[
															1.608,
															-1.9
														],
														[
															0.507,
															-1.124
														],
														[
															3.062,
															-3.872
														],
														[
															1.527,
															-2.081
														],
														[
															5.521,
															-8.12
														],
														[
															29.613,
															-52.503
														],
														[
															-0.43,
															-5.5
														],
														[
															-1.368,
															-9.812
														],
														[
															-3.221,
															-14.124
														],
														[
															-0.231,
															-0.652
														],
														[
															-0.614,
															-1.564
														],
														[
															-3.403,
															-9.209
														],
														[
															-2.588,
															-6.04
														],
														[
															-1.402,
															-2.538
														],
														[
															-0.819,
															-0.854
														],
														[
															-4.735,
															-7.969
														],
														[
															-0.139,
															-0.309
														],
														[
															-2.609,
															-3.63
														],
														[
															-0.139,
															-0.309
														],
														[
															-3.814,
															-5.307
														],
														[
															-8.511,
															-9.745
														],
														[
															-27.926,
															-25.463
														],
														[
															-39.874,
															-15.745
														],
														[
															-0.63,
															0.03
														]
													],
													"v": [
														[
															342,
															16
														],
														[
															321.673,
															17.352
														],
														[
															301,
															20
														],
														[
															272.565,
															26.667
														],
														[
															247,
															35
														],
														[
															244.468,
															35.508
														],
														[
															242,
															36
														],
														[
															238.411,
															38.019
														],
														[
															235,
															40
														],
														[
															232.838,
															40.558
														],
														[
															231,
															41
														],
														[
															227.307,
															42.596
														],
														[
															224,
															44
														],
														[
															221.917,
															45.004
														],
														[
															220,
															46
														],
														[
															184.496,
															65.213
														],
														[
															153,
															87
														],
														[
															147.469,
															91.903
														],
														[
															142,
															97
														],
														[
															135.921,
															101.907
														],
														[
															130,
															107
														],
														[
															113.762,
															123.735
														],
														[
															99,
															141
														],
														[
															95.249,
															145.704
														],
														[
															92,
															150
														],
														[
															90.988,
															152.038
														],
														[
															90,
															154
														],
														[
															87.489,
															156.489
														],
														[
															85,
															159
														],
														[
															84.968,
															159.978
														],
														[
															85,
															161
														],
														[
															84.036,
															161.481
														],
														[
															83,
															162
														],
														[
															82.016,
															163.987
														],
														[
															81,
															166
														],
														[
															72,
															179
														],
														[
															67,
															189
														],
														[
															57,
															207
														],
														[
															51,
															222
														],
														[
															46,
															233
														],
														[
															39,
															253
														],
														[
															24,
															324
														],
														[
															23,
															387
														],
														[
															60,
															522
														],
														[
															134,
															621
														],
														[
															157,
															641
														],
														[
															171,
															650
														],
														[
															172,
															652
														],
														[
															184,
															659
														],
														[
															187,
															661
														],
														[
															192,
															664
														],
														[
															199,
															668
														],
														[
															272,
															698
														],
														[
															307,
															706
														],
														[
															391,
															708
														],
														[
															397,
															702
														],
														[
															400,
															697
														],
														[
															406,
															695
														],
														[
															423,
															692
														],
														[
															486,
															673
														],
														[
															507,
															663
														],
														[
															528,
															652
														],
														[
															565,
															627
														],
														[
															576,
															617
														],
														[
															582,
															613
														],
														[
															608,
															587
														],
														[
															613,
															580
														],
														[
															615,
															579
														],
														[
															618,
															574
														],
														[
															622,
															570
														],
														[
															631,
															559
														],
														[
															635,
															552
														],
														[
															651,
															527
														],
														[
															696,
															325
														],
														[
															693,
															308
														],
														[
															689,
															281
														],
														[
															678,
															241
														],
														[
															676,
															238
														],
														[
															675,
															234
														],
														[
															664,
															208
														],
														[
															655,
															191
														],
														[
															651,
															183
														],
														[
															650,
															181
														],
														[
															635,
															157
														],
														[
															633,
															156
														],
														[
															626,
															145
														],
														[
															624,
															144
														],
														[
															613,
															130
														],
														[
															587,
															103
														],
														[
															485,
															39
														],
														[
															343,
															15
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 7,
											"s": [
												{
													"i": [
														[
															-0.115,
															0.007
														],
														[
															6.667,
															-0.574
														],
														[
															6.827,
															-1.285
														],
														[
															8.6,
															-2.472
														],
														[
															6.861,
															-2.466
														],
														[
															1.363,
															-0.26
														],
														[
															1.232,
															-0.485
														],
														[
															1.179,
															-0.771
														],
														[
															1.141,
															-0.465
														],
														[
															0.681,
															-0.117
														],
														[
															0.531,
															-0.227
														],
														[
															1.173,
															-0.507
														],
														[
															1.025,
															-0.422
														],
														[
															4.237,
															-2.269
														],
														[
															3.452,
															-2.032
														],
														[
															3.338,
															-1.961
														],
														[
															3.115,
															-2.077
														],
														[
															3.413,
															-2.611
														],
														[
															3.124,
															-1.408
														],
														[
															0.166,
															-0.451
														],
														[
															0.179,
															-0.124
														],
														[
															1.412,
															-1.103
														],
														[
															1.464,
															-1.281
														],
														[
															4.692,
															-4.323
														],
														[
															4.306,
															-4.399
														],
														[
															1.641,
															-2.061
														],
														[
															1.709,
															-1.993
														],
														[
															6.043,
															-8.15
														],
														[
															5.257,
															-8.736
														],
														[
															1.122,
															-2.378
														],
														[
															1.218,
															-2.334
														],
														[
															2.305,
															-4.707
														],
														[
															2.212,
															-5.25
														],
														[
															4.085,
															-13.872
														],
														[
															2.335,
															-14.873
														],
														[
															-6.168,
															-36.98
														],
														[
															-13.696,
															-27.529
														],
														[
															-12.028,
															-16.531
														],
														[
															-14.433,
															-13.865
														],
														[
															-1.362,
															-1.195
														],
														[
															-1.176,
															-0.9
														],
														[
															-0.453,
															-0.509
														],
														[
															-0.555,
															-0.48
														],
														[
															-1.002,
															-0.583
														],
														[
															-1.031,
															-0.839
														],
														[
															-0.84,
															-0.72
														],
														[
															-1.141,
															-0.902
														],
														[
															-5.598,
															-3.939
														],
														[
															-0.921,
															-0.882
														],
														[
															-2.159,
															-1.324
														],
														[
															-2.037,
															-1.249
														],
														[
															-3.719,
															-1.979
														],
														[
															-59.811,
															2.223
														],
														[
															-5.716,
															1.29
														],
														[
															-3.397,
															3.303
														],
														[
															-1.539,
															0.996
														],
														[
															-4.281,
															0.759
														],
														[
															-12.244,
															3.873
														],
														[
															-3.059,
															1.012
														],
														[
															-1.679,
															0.646
														],
														[
															-2.372,
															0.913
														],
														[
															-0.982,
															0.385
														],
														[
															-2.412,
															0.947
														],
														[
															-3.751,
															1.855
														],
														[
															-6.097,
															3.739
														],
														[
															-0.584,
															0.559
														],
														[
															-0.85,
															0.815
														],
														[
															-1.116,
															0.701
														],
														[
															-5.778,
															4.349
														],
														[
															-15.232,
															17.578
														],
														[
															-8.692,
															13.107
														],
														[
															-4.754,
															8.64
														],
														[
															-4.341,
															9.684
														],
														[
															-0.413,
															1.053
														],
														[
															-1.387,
															3.661
														],
														[
															6.169,
															61.689
														],
														[
															6.258,
															21.236
														],
														[
															8.846,
															17.594
														],
														[
															3.981,
															6.492
														],
														[
															0.507,
															0.529
														],
														[
															0.814,
															0.85
														],
														[
															0.814,
															0.85
														],
														[
															0.815,
															0.85
														],
														[
															0.69,
															0.995
														],
														[
															1.341,
															1.861
														],
														[
															0.223,
															0.495
														],
														[
															0.245,
															0.381
														],
														[
															0.82,
															1.088
														],
														[
															14.779,
															13.567
														],
														[
															39.668,
															16.396
														],
														[
															54.776,
															-2.911
														]
													],
													"o": [
														[
															-6.506,
															0.419
														],
														[
															-6.667,
															0.574
														],
														[
															-8.74,
															1.645
														],
														[
															-8.599,
															2.472
														],
														[
															-1.317,
															0.474
														],
														[
															-1.363,
															0.26
														],
														[
															-1.144,
															0.451
														],
														[
															-1.179,
															0.771
														],
														[
															-0.746,
															0.305
														],
														[
															-0.681,
															0.117
														],
														[
															-1.283,
															0.55
														],
														[
															-1.173,
															0.507
														],
														[
															-4.6,
															1.892
														],
														[
															-4.237,
															2.269
														],
														[
															-3.533,
															2.081
														],
														[
															-3.338,
															1.961
														],
														[
															-3.223,
															2.149
														],
														[
															-3.413,
															2.611
														],
														[
															-0.158,
															0.072
														],
														[
															-0.166,
															0.451
														],
														[
															-1.888,
															1.309
														],
														[
															-1.412,
															1.103
														],
														[
															-4.925,
															4.308
														],
														[
															-4.692,
															4.323
														],
														[
															-1.727,
															1.764
														],
														[
															-1.641,
															2.061
														],
														[
															-6.57,
															7.665
														],
														[
															-6.043,
															8.15
														],
														[
															-1.296,
															2.154
														],
														[
															-1.121,
															2.378
														],
														[
															-2.57,
															4.924
														],
														[
															-2.304,
															4.707
														],
														[
															-5.326,
															12.639
														],
														[
															-4.085,
															13.872
														],
														[
															-6.367,
															40.55
														],
														[
															6.168,
															36.98
														],
														[
															9.457,
															19.01
														],
														[
															12.027,
															16.531
														],
														[
															1.375,
															1.321
														],
														[
															1.362,
															1.195
														],
														[
															0.632,
															0.484
														],
														[
															0.453,
															0.509
														],
														[
															0.96,
															0.831
														],
														[
															1.002,
															0.583
														],
														[
															0.844,
															0.686
														],
														[
															0.885,
															0.759
														],
														[
															6.033,
															4.769
														],
														[
															2.281,
															1.605
														],
														[
															2.456,
															2.353
														],
														[
															2.803,
															1.719
														],
														[
															4.13,
															2.532
														],
														[
															39.844,
															21.197
														],
														[
															7.76,
															-0.288
														],
														[
															6.721,
															-1.517
														],
														[
															1.79,
															-1.74
														],
														[
															3.382,
															-2.189
														],
														[
															13.752,
															-2.439
														],
														[
															3.884,
															-1.229
														],
														[
															1.517,
															-0.502
														],
														[
															2.477,
															-0.952
														],
														[
															0.694,
															-0.267
														],
														[
															3.336,
															-1.309
														],
														[
															4.651,
															-1.825
														],
														[
															7.424,
															-3.671
														],
														[
															1.87,
															-1.147
														],
														[
															0.838,
															-0.803
														],
														[
															0.83,
															-0.795
														],
														[
															6.616,
															-4.154
														],
														[
															19.651,
															-14.793
														],
														[
															10.039,
															-11.585
														],
														[
															5.317,
															-8.018
														],
														[
															4.802,
															-8.728
														],
														[
															0.346,
															-0.771
														],
														[
															1.723,
															-4.39
														],
														[
															16.377,
															-43.235
														],
														[
															-2.375,
															-23.744
														],
														[
															-6.204,
															-21.052
														],
														[
															-3.988,
															-7.931
														],
														[
															-1.099,
															-1.792
														],
														[
															-0.803,
															-0.838
														],
														[
															-0.803,
															-0.838
														],
														[
															-0.803,
															-0.838
														],
														[
															-0.742,
															-0.775
														],
														[
															-1.363,
															-1.966
														],
														[
															-0.312,
															-0.433
														],
														[
															-0.149,
															-0.331
														],
														[
															-0.736,
															-1.144
														],
														[
															-11.503,
															-15.26
														],
														[
															-27.707,
															-25.433
														],
														[
															-38.781,
															-16.029
														],
														[
															-0.629,
															0.033
														]
													],
													"v": [
														[
															342,
															16
														],
														[
															322.24,
															17.351
														],
														[
															302,
															20
														],
														[
															275.591,
															26.385
														],
														[
															252,
															34
														],
														[
															247.936,
															34.991
														],
														[
															244,
															36
														],
														[
															240.497,
															37.989
														],
														[
															237,
															40
														],
														[
															234.838,
															40.558
														],
														[
															233,
															41
														],
														[
															229.307,
															42.596
														],
														[
															226,
															44
														],
														[
															212.639,
															50.395
														],
														[
															201,
															57
														],
														[
															190.686,
															63.003
														],
														[
															181,
															69
														],
														[
															170.925,
															76.556
														],
														[
															161,
															83
														],
														[
															160.516,
															83.961
														],
														[
															160,
															85
														],
														[
															155.182,
															88.521
														],
														[
															151,
															92
														],
														[
															136.535,
															104.931
														],
														[
															123,
															118
														],
														[
															117.987,
															123.828
														],
														[
															113,
															130
														],
														[
															94.015,
															153.696
														],
														[
															77,
															179
														],
														[
															73.441,
															185.865
														],
														[
															70,
															193
														],
														[
															62.731,
															207.256
														],
														[
															56,
															222
														],
														[
															41.757,
															261.825
														],
														[
															32,
															305
														],
														[
															32.953,
															422.765
														],
														[
															64,
															521
														],
														[
															96.269,
															574.359
														],
														[
															136,
															620
														],
														[
															140.149,
															623.815
														],
														[
															144,
															627
														],
														[
															145.558,
															628.503
														],
														[
															147,
															630
														],
														[
															149.946,
															631.994
														],
														[
															153,
															634
														],
														[
															155,
															637
														],
														[
															159,
															639
														],
														[
															177,
															653
														],
														[
															185,
															658
														],
														[
															193,
															663
														],
														[
															200,
															667
														],
														[
															211,
															673
														],
														[
															365,
															709
														],
														[
															387,
															709
														],
														[
															397,
															701
														],
														[
															401,
															696
														],
														[
															417,
															693
														],
														[
															457,
															683
														],
														[
															468,
															679
														],
														[
															472,
															677
														],
														[
															480,
															675
														],
														[
															483,
															673
														],
														[
															490,
															670
														],
														[
															501,
															665
														],
														[
															524,
															653
														],
														[
															529,
															650
														],
														[
															532,
															648
														],
														[
															534,
															647
														],
														[
															552,
															634
														],
														[
															605,
															585
														],
														[
															632,
															550
														],
														[
															648,
															525
														],
														[
															661,
															497
														],
														[
															663,
															494
														],
														[
															667,
															483
														],
														[
															690,
															323
														],
														[
															677,
															255
														],
														[
															653,
															197
														],
														[
															641,
															174
														],
														[
															638,
															169
														],
														[
															636,
															166
														],
														[
															634,
															163
														],
														[
															632,
															160
														],
														[
															631,
															158
														],
														[
															626,
															153
														],
														[
															626,
															151
														],
														[
															624,
															150
														],
														[
															622,
															146
														],
														[
															583,
															103
														],
														[
															483,
															39
														],
														[
															343,
															15
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 8,
											"s": [
												{
													"i": [
														[
															-0.115,
															0.007
														],
														[
															6.688,
															-0.577
														],
														[
															6.615,
															-1.264
														],
														[
															5.553,
															-1.587
														],
														[
															5.082,
															-1.56
														],
														[
															21.735,
															-13.477
														],
														[
															17.311,
															-17.568
														],
														[
															1.612,
															-1.805
														],
														[
															1.786,
															-1.99
														],
														[
															2.02,
															-2.157
														],
														[
															1.01,
															-2.24
														],
														[
															0.85,
															-0.75
														],
														[
															0.35,
															-0.44
														],
														[
															2.51,
															-3.395
														],
														[
															1.501,
															-3.329
														],
														[
															0.451,
															-0.163
														],
														[
															0.124,
															-0.185
														],
														[
															-0.067,
															-0.379
														],
														[
															0.115,
															-0.255
														],
														[
															0.451,
															-0.163
														],
														[
															0.124,
															-0.186
														],
														[
															-0.067,
															-0.378
														],
														[
															0.115,
															-0.256
														],
														[
															0.451,
															-0.161
														],
														[
															0.123,
															-0.19
														],
														[
															0.33,
															-0.735
														],
														[
															0.356,
															-0.557
														],
														[
															4.566,
															-8.775
														],
														[
															3.781,
															-8.149
														],
														[
															0.088,
															-0.876
														],
														[
															0.326,
															-0.799
														],
														[
															0.776,
															-1.173
														],
														[
															0.42,
															-1.137
														],
														[
															0.237,
															-1.508
														],
														[
															0.514,
															-1.512
														],
														[
															1.705,
															-5.292
														],
														[
															1.38,
															-5.534
														],
														[
															1.143,
															-5.954
														],
														[
															0.957,
															-6.291
														],
														[
															-6.257,
															-36.525
														],
														[
															-13.165,
															-27.193
														],
														[
															-24.13,
															-25.63
														],
														[
															-31.638,
															-16.757
														],
														[
															-3.733,
															-1.641
														],
														[
															-3.493,
															-1.543
														],
														[
															-1.09,
															-0.721
														],
														[
															-1.258,
															-0.505
														],
														[
															-1.404,
															-0.275
														],
														[
															-1.194,
															-0.42
														],
														[
															-1.257,
															-0.493
														],
														[
															-1.49,
															-0.505
														],
														[
															-8.396,
															-2.195
														],
														[
															-9.228,
															-1.445
														],
														[
															-6.534,
															-0.434
														],
														[
															-6.798,
															-0.316
														],
														[
															-7.252,
															0.04
														],
														[
															-4.966,
															1.168
														],
														[
															-0.222,
															0.368
														],
														[
															-0.424,
															0.367
														],
														[
															-0.835,
															1.11
														],
														[
															-0.601,
															0.644
														],
														[
															-0.095,
															0.594
														],
														[
															-0.318,
															0.3
														],
														[
															-0.884,
															0.14
														],
														[
															-1.548,
															0.577
														],
														[
															-2.876,
															0.353
														],
														[
															-2.797,
															0.583
														],
														[
															-7.782,
															2.361
														],
														[
															-7.309,
															2.769
														],
														[
															-23.172,
															17.497
														],
														[
															-17.88,
															22.863
														],
														[
															-9.64,
															17.414
														],
														[
															-6.877,
															20.558
														],
														[
															-3.208,
															24.039
														],
														[
															2.491,
															27.934
														],
														[
															8.467,
															25.815
														],
														[
															12.539,
															20.662
														],
														[
															3.141,
															4.412
														],
														[
															1.829,
															4.056
														],
														[
															0.452,
															0.168
														],
														[
															0.125,
															0.173
														],
														[
															2.633,
															3.253
														],
														[
															2.749,
															3.207
														],
														[
															3.203,
															3.334
														],
														[
															16.734,
															11.548
														],
														[
															1.115,
															1.068
														],
														[
															0.85,
															0.815
														],
														[
															2.555,
															1.549
														],
														[
															5.471,
															2.938
														],
														[
															2.4,
															1.125
														],
														[
															61.957,
															-3.293
														]
													],
													"o": [
														[
															-6.634,
															0.427
														],
														[
															-6.688,
															0.577
														],
														[
															-5.707,
															1.09
														],
														[
															-5.553,
															1.587
														],
														[
															-27.748,
															8.522
														],
														[
															-21.735,
															13.477
														],
														[
															-1.766,
															1.791
														],
														[
															-1.612,
															1.804
														],
														[
															-1.911,
															2.13
														],
														[
															-2.02,
															2.157
														],
														[
															-0.252,
															0.56
														],
														[
															-0.85,
															0.75
														],
														[
															-2.459,
															3.093
														],
														[
															-2.51,
															3.395
														],
														[
															-0.073,
															0.162
														],
														[
															-0.451,
															0.163
														],
														[
															-0.154,
															0.23
														],
														[
															0.067,
															0.379
														],
														[
															-0.073,
															0.162
														],
														[
															-0.451,
															0.163
														],
														[
															-0.153,
															0.231
														],
														[
															0.067,
															0.378
														],
														[
															-0.075,
															0.166
														],
														[
															-0.451,
															0.161
														],
														[
															-0.323,
															0.502
														],
														[
															-0.33,
															0.735
														],
														[
															-4.955,
															7.749
														],
														[
															-4.566,
															8.775
														],
														[
															-0.323,
															0.695
														],
														[
															-0.088,
															0.876
														],
														[
															-0.477,
															1.17
														],
														[
															-0.776,
															1.173
														],
														[
															-0.538,
															1.456
														],
														[
															-0.237,
															1.508
														],
														[
															-1.8,
															5.298
														],
														[
															-1.705,
															5.292
														],
														[
															-1.469,
															5.894
														],
														[
															-1.143,
															5.954
														],
														[
															-6.191,
															40.704
														],
														[
															6.257,
															36.526
														],
														[
															15.841,
															32.721
														],
														[
															24.13,
															25.63
														],
														[
															3.575,
															1.894
														],
														[
															3.733,
															1.641
														],
														[
															1.38,
															0.61
														],
														[
															1.091,
															0.721
														],
														[
															1.191,
															0.478
														],
														[
															1.404,
															0.275
														],
														[
															1.481,
															0.522
														],
														[
															1.257,
															0.493
														],
														[
															8.186,
															2.777
														],
														[
															8.396,
															2.195
														],
														[
															6.065,
															0.949
														],
														[
															6.534,
															0.434
														],
														[
															7.026,
															0.327
														],
														[
															7.252,
															-0.04
														],
														[
															0.689,
															-0.162
														],
														[
															0.222,
															-0.368
														],
														[
															1.061,
															-0.918
														],
														[
															0.835,
															-1.109
														],
														[
															0.301,
															-0.323
														],
														[
															0.095,
															-0.594
														],
														[
															0.918,
															-0.863
														],
														[
															0.884,
															-0.14
														],
														[
															2.698,
															-1.005
														],
														[
															2.876,
															-0.353
														],
														[
															8.565,
															-1.785
														],
														[
															7.782,
															-2.361
														],
														[
															29.434,
															-11.149
														],
														[
															23.172,
															-17.497
														],
														[
															11.562,
															-14.784
														],
														[
															9.64,
															-17.414
														],
														[
															6.659,
															-19.908
														],
														[
															3.208,
															-24.04
														],
														[
															-2.593,
															-29.078
														],
														[
															-8.467,
															-25.815
														],
														[
															-2.608,
															-4.297
														],
														[
															-3.141,
															-4.412
														],
														[
															-0.07,
															-0.154
														],
														[
															-0.451,
															-0.168
														],
														[
															-2.718,
															-3.782
														],
														[
															-2.633,
															-3.253
														],
														[
															-3.084,
															-3.598
														],
														[
															-14.569,
															-15.166
														],
														[
															-2.4,
															-1.656
														],
														[
															-0.838,
															-0.803
														],
														[
															-2.518,
															-2.412
														],
														[
															-6.111,
															-3.703
														],
														[
															-2.058,
															-1.105
														],
														[
															-40.943,
															-19.195
														],
														[
															-0.629,
															0.033
														]
													],
													"v": [
														[
															342,
															16
														],
														[
															321.986,
															17.372
														],
														[
															302,
															20
														],
														[
															285.031,
															24.148
														],
														[
															269,
															29
														],
														[
															195.173,
															62.215
														],
														[
															137,
															109
														],
														[
															132.015,
															114.351
														],
														[
															127,
															120
														],
														[
															120.824,
															126.418
														],
														[
															116,
															133
														],
														[
															114.073,
															135.089
														],
														[
															112,
															137
														],
														[
															104.282,
															146.823
														],
														[
															98,
															157
														],
														[
															97.038,
															157.483
														],
														[
															96,
															158
														],
														[
															95.971,
															158.981
														],
														[
															96,
															160
														],
														[
															95.037,
															160.482
														],
														[
															94,
															161
														],
														[
															93.972,
															161.981
														],
														[
															94,
															163
														],
														[
															93.036,
															163.481
														],
														[
															92,
															164
														],
														[
															91.024,
															165.959
														],
														[
															90,
															168
														],
														[
															75.62,
															193.2
														],
														[
															63,
															219
														],
														[
															62.503,
															221.422
														],
														[
															62,
															224
														],
														[
															59.957,
															227.525
														],
														[
															58,
															231
														],
														[
															56.982,
															235.458
														],
														[
															56,
															240
														],
														[
															50.684,
															255.823
														],
														[
															46,
															272
														],
														[
															42.116,
															289.703
														],
														[
															39,
															308
														],
														[
															40.483,
															425.133
														],
														[
															71,
															522
														],
														[
															131.152,
															609.972
														],
														[
															215,
															674
														],
														[
															226.061,
															679.263
														],
														[
															237,
															684
														],
														[
															240.591,
															686.078
														],
														[
															244,
															688
														],
														[
															247.998,
															689.043
														],
														[
															252,
															690
														],
														[
															255.994,
															691.512
														],
														[
															260,
															693
														],
														[
															284.718,
															700.5
														],
														[
															311,
															706
														],
														[
															329.95,
															707.975
														],
														[
															350,
															709
														],
														[
															372.045,
															709.622
														],
														[
															391,
															708
														],
														[
															392.198,
															707.154
														],
														[
															393,
															706
														],
														[
															395.845,
															702.795
														],
														[
															398,
															700
														],
														[
															398.487,
															698.482
														],
														[
															399,
															697
														],
														[
															401.528,
															695.785
														],
														[
															405,
															695
														],
														[
															413.426,
															693.183
														],
														[
															422,
															692
														],
														[
															446.442,
															685.738
														],
														[
															469,
															678
														],
														[
															547.666,
															634.785
														],
														[
															609,
															574
														],
														[
															641.013,
															525.83
														],
														[
															666,
															469
														],
														[
															681.363,
															403.019
														],
														[
															683,
															325
														],
														[
															665.959,
															242.188
														],
														[
															634,
															172
														],
														[
															624.915,
															158.82
														],
														[
															617,
															146
														],
														[
															616.041,
															145.514
														],
														[
															615,
															145
														],
														[
															607.023,
															134.569
														],
														[
															599,
															125
														],
														[
															590,
															114
														],
														[
															541,
															72
														],
														[
															533,
															67
														],
														[
															530,
															65
														],
														[
															522,
															60
														],
														[
															503,
															49
														],
														[
															496,
															46
														],
														[
															343,
															15
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 9,
											"s": [
												{
													"i": [
														[
															-0.112,
															0.008
														],
														[
															6.522,
															-0.574
														],
														[
															6.431,
															-1.254
														],
														[
															15.404,
															-6.158
														],
														[
															12.142,
															-7.008
														],
														[
															1.552,
															-0.692
														],
														[
															0.517,
															-0.495
														],
														[
															0.539,
															-0.298
														],
														[
															0.425,
															-0.407
														],
														[
															0.539,
															-0.298
														],
														[
															0.425,
															-0.407
														],
														[
															0.246,
															-0.06
														],
														[
															0.588,
															-0.349
														],
														[
															1.445,
															-1.227
														],
														[
															1.48,
															-1.06
														],
														[
															1.981,
															-1.48
														],
														[
															2.002,
															-1.591
														],
														[
															2.043,
															-1.454
														],
														[
															1.885,
															-1.637
														],
														[
															3.452,
															-3.557
														],
														[
															3.457,
															-3.528
														],
														[
															3.359,
															-3.646
														],
														[
															3.103,
															-3.887
														],
														[
															14.637,
															-42.799
														],
														[
															-3.822,
															-53.642
														],
														[
															-6.922,
															-24.381
														],
														[
															-10.216,
															-20.048
														],
														[
															-3.216,
															-5.612
														],
														[
															-3.18,
															-4.753
														],
														[
															-0.956,
															-1.612
														],
														[
															-0.448,
															-0.468
														],
														[
															-0.067,
															-0.27
														],
														[
															-0.348,
															-0.522
														],
														[
															-0.97,
															-0.861
														],
														[
															-0.499,
															-0.625
														],
														[
															-0.256,
															-0.686
														],
														[
															-0.46,
															-0.611
														],
														[
															-1.702,
															-1.986
														],
														[
															-0.741,
															-0.891
														],
														[
															-1.543,
															-1.767
														],
														[
															-4.913,
															-5.114
														],
														[
															-3.9,
															-1.758
														],
														[
															-1.202,
															-1.03
														],
														[
															-1.212,
															-1.035
														],
														[
															-4.055,
															-3.036
														],
														[
															-3.578,
															-1.613
														],
														[
															-0.37,
															-0.247
														],
														[
															-0.511,
															-0.23
														],
														[
															-0.372,
															-0.247
														],
														[
															-0.512,
															-0.231
														],
														[
															-0.381,
															-0.245
														],
														[
															-0.973,
															-0.595
														],
														[
															-2.936,
															-1.66
														],
														[
															-0.996,
															-0.553
														],
														[
															-2.193,
															-1.203
														],
														[
															-7.363,
															-3.156
														],
														[
															-28.173,
															-2.978
														],
														[
															-12.131,
															0.513
														],
														[
															-4.48,
															4.48
														],
														[
															-1.359,
															1.559
														],
														[
															-1.64,
															0.883
														],
														[
															-1.102,
															0.436
														],
														[
															-5.575,
															1.165
														],
														[
															-4.982,
															1.364
														],
														[
															-37.66,
															46.053
														],
														[
															-1.846,
															4.096
														],
														[
															-0.249,
															0.346
														],
														[
															-11.834,
															51.393
														],
														[
															3.538,
															41.125
														],
														[
															5.9,
															21.682
														],
														[
															3.516,
															9.783
														],
														[
															0.942,
															2.34
														],
														[
															0.412,
															0.962
														],
														[
															2.755,
															5.805
														],
														[
															2.205,
															4.219
														],
														[
															4.826,
															7.548
														],
														[
															29.686,
															22.995
														],
														[
															0.435,
															0.416
														],
														[
															2.584,
															1.165
														],
														[
															0.37,
															0.247
														],
														[
															0.511,
															0.23
														],
														[
															0.395,
															0.242
														],
														[
															1.105,
															1.059
														],
														[
															1.506,
															0.925
														],
														[
															8.639,
															4.009
														],
														[
															1.321,
															0.569
														],
														[
															2.738,
															1.074
														],
														[
															1.527,
															0.561
														],
														[
															16.155,
															3.095
														],
														[
															6.235,
															0.896
														],
														[
															20.231,
															-1.188
														]
													],
													"o": [
														[
															-6.48,
															0.45
														],
														[
															-6.522,
															0.574
														],
														[
															-17.243,
															3.361
														],
														[
															-15.404,
															6.158
														],
														[
															-1.277,
															0.737
														],
														[
															-1.552,
															0.692
														],
														[
															-0.419,
															0.401
														],
														[
															-0.539,
															0.298
														],
														[
															-0.419,
															0.401
														],
														[
															-0.539,
															0.298
														],
														[
															-0.427,
															0.409
														],
														[
															-0.246,
															0.06
														],
														[
															-1.74,
															1.034
														],
														[
															-1.445,
															1.227
														],
														[
															-2.075,
															1.487
														],
														[
															-1.981,
															1.48
														],
														[
															-1.945,
															1.546
														],
														[
															-2.043,
															1.454
														],
														[
															-3.733,
															3.244
														],
														[
															-3.452,
															3.557
														],
														[
															-3.46,
															3.53
														],
														[
															-3.359,
															3.646
														],
														[
															-23.274,
															29.162
														],
														[
															-14.637,
															42.799
														],
														[
															2.096,
															29.427
														],
														[
															6.922,
															24.381
														],
														[
															2.956,
															5.8
														],
														[
															3.216,
															5.612
														],
														[
															0.726,
															1.084
														],
														[
															0.956,
															1.612
														],
														[
															0.382,
															0.399
														],
														[
															0.067,
															0.27
														],
														[
															0.621,
															0.932
														],
														[
															0.97,
															0.861
														],
														[
															0.516,
															0.647
														],
														[
															0.256,
															0.686
														],
														[
															2.255,
															2.987
														],
														[
															0.939,
															1.095
														],
														[
															1.439,
															1.729
														],
														[
															5.069,
															5.805
														],
														[
															3.356,
															3.493
														],
														[
															2.229,
															1.005
														],
														[
															1.263,
															1.083
														],
														[
															3.738,
															3.192
														],
														[
															3.958,
															2.963
														],
														[
															0.324,
															0.146
														],
														[
															0.46,
															0.307
														],
														[
															0.325,
															0.147
														],
														[
															0.462,
															0.306
														],
														[
															0.331,
															0.149
														],
														[
															1.023,
															0.659
														],
														[
															3.301,
															2.02
														],
														[
															1.063,
															0.601
														],
														[
															2.106,
															1.169
														],
														[
															7.71,
															4.228
														],
														[
															23.603,
															10.116
														],
														[
															13.87,
															1.466
														],
														[
															11.895,
															-0.503
														],
														[
															1.066,
															-1.066
														],
														[
															1.978,
															-2.268
														],
														[
															1.035,
															-0.557
														],
														[
															5.386,
															-2.13
														],
														[
															5.476,
															-1.144
														],
														[
															66.526,
															-18.211
														],
														[
															3.374,
															-4.127
														],
														[
															0.139,
															-0.309
														],
														[
															27.011,
															-37.582
														],
														[
															7.629,
															-33.132
														],
														[
															-2.065,
															-24.001
														],
														[
															-2.826,
															-10.386
														],
														[
															-0.934,
															-2.6
														],
														[
															-0.28,
															-0.695
														],
														[
															-2.815,
															-6.569
														],
														[
															-2.217,
															-4.672
														],
														[
															-4.607,
															-8.815
														],
														[
															-20.849,
															-32.604
														],
														[
															-1.307,
															-1.013
														],
														[
															-2.774,
															-2.658
														],
														[
															-0.324,
															-0.146
														],
														[
															-0.46,
															-0.307
														],
														[
															-0.339,
															-0.153
														],
														[
															-2.417,
															-1.484
														],
														[
															-1.615,
															-1.547
														],
														[
															-8.758,
															-5.379
														],
														[
															-1.402,
															-0.65
														],
														[
															-3.232,
															-1.393
														],
														[
															-1.564,
															-0.614
														],
														[
															-14.991,
															-5.509
														],
														[
															-5.767,
															-1.105
														],
														[
															-18.088,
															-2.6
														],
														[
															-0.628,
															0.037
														]
													],
													"v": [
														[
															342,
															16
														],
														[
															322.463,
															17.397
														],
														[
															303,
															20
														],
														[
															253.674,
															34.764
														],
														[
															212,
															55
														],
														[
															207.43,
															57.182
														],
														[
															204,
															59
														],
														[
															202.505,
															59.995
														],
														[
															201,
															61
														],
														[
															199.505,
															61.995
														],
														[
															198,
															63
														],
														[
															197.121,
															63.545
														],
														[
															196,
															64
														],
														[
															191.305,
															67.48
														],
														[
															187,
															71
														],
														[
															180.946,
															75.422
														],
														[
															175,
															80
														],
														[
															168.955,
															84.432
														],
														[
															163,
															89
														],
														[
															152.293,
															99.287
														],
														[
															142,
															110
														],
														[
															131.732,
															120.732
														],
														[
															122,
															132
														],
														[
															62.678,
															240.641
														],
														[
															44,
															386
														],
														[
															57.91,
															466.535
														],
														[
															84,
															533
														],
														[
															93.331,
															550.285
														],
														[
															103,
															566
														],
														[
															105.708,
															570.462
														],
														[
															108,
															574
														],
														[
															108.526,
															574.908
														],
														[
															109,
															576
														],
														[
															111.592,
															578.73
														],
														[
															114,
															581
														],
														[
															115.042,
															583.027
														],
														[
															116,
															585
														],
														[
															123,
															593
														],
														[
															125,
															597
														],
														[
															130,
															602
														],
														[
															145,
															619
														],
														[
															157,
															629
														],
														[
															163,
															636
														],
														[
															167,
															638
														],
														[
															178,
															648
														],
														[
															192,
															657
														],
														[
															193,
															659
														],
														[
															195,
															659
														],
														[
															196,
															661
														],
														[
															198,
															661
														],
														[
															199,
															663
														],
														[
															203,
															665
														],
														[
															213,
															670
														],
														[
															216,
															673
														],
														[
															223,
															676
														],
														[
															248,
															688
														],
														[
															327,
															708
														],
														[
															366,
															709
														],
														[
															393,
															706
														],
														[
															396,
															702
														],
														[
															400,
															695
														],
														[
															404,
															695
														],
														[
															421,
															692
														],
														[
															437,
															688
														],
														[
															594,
															585
														],
														[
															604,
															572
														],
														[
															606,
															571
														],
														[
															667,
															437
														],
														[
															675,
															326
														],
														[
															663,
															258
														],
														[
															653,
															228
														],
														[
															651,
															220
														],
														[
															649,
															217
														],
														[
															641,
															200
														],
														[
															635,
															186
														],
														[
															620,
															161
														],
														[
															543,
															77
														],
														[
															539,
															74
														],
														[
															530,
															68
														],
														[
															529,
															66
														],
														[
															527,
															66
														],
														[
															526,
															64
														],
														[
															518,
															60
														],
														[
															513,
															57
														],
														[
															484,
															41
														],
														[
															479,
															40
														],
														[
															469,
															35
														],
														[
															465,
															34
														],
														[
															419,
															20
														],
														[
															401,
															18
														],
														[
															343,
															15
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 10,
											"s": [
												{
													"i": [
														[
															-0.112,
															0.008
														],
														[
															0.336,
															0.004
														],
														[
															0.328,
															0.008
														],
														[
															6.033,
															-0.978
														],
														[
															5.947,
															-1.233
														],
														[
															2.875,
															-0.42
														],
														[
															2.653,
															-0.73
														],
														[
															1.137,
															-0.573
														],
														[
															1.228,
															-0.37
														],
														[
															12.872,
															-6.074
														],
														[
															10.824,
															-7.279
														],
														[
															5.823,
															-4.508
														],
														[
															5.415,
															-4.736
														],
														[
															1.642,
															-1.713
														],
														[
															1.678,
															-1.615
														],
														[
															1.438,
															-1.162
														],
														[
															0.914,
															-1.066
														],
														[
															0.262,
															-0.731
														],
														[
															0.51,
															-0.559
														],
														[
															1.737,
															-1.634
														],
														[
															1.479,
															-1.737
														],
														[
															0.593,
															-1.011
														],
														[
															0.808,
															-0.993
														],
														[
															0.574,
															-0.29
														],
														[
															0.36,
															-0.419
														],
														[
															0.268,
															-0.716
														],
														[
															0.452,
															-0.581
														],
														[
															14.011,
															-42.331
														],
														[
															-2.886,
															-54.308
														],
														[
															-1.912,
															-11.881
														],
														[
															-2.689,
															-10.996
														],
														[
															-11.445,
															-23.066
														],
														[
															-14.57,
															-18.556
														],
														[
															-1.71,
															-1.791
														],
														[
															-1.61,
															-1.863
														],
														[
															-0.591,
															-1.04
														],
														[
															-0.858,
															-0.937
														],
														[
															-1.661,
															-1.62
														],
														[
															-1.013,
															-1.058
														],
														[
															-0.122,
															-0.365
														],
														[
															-0.26,
															-0.277
														],
														[
															-1.057,
															-0.553
														],
														[
															-0.955,
															-0.919
														],
														[
															-1.923,
															-2.003
														],
														[
															-2.27,
															-1.024
														],
														[
															-0.179,
															-0.454
														],
														[
															-0.148,
															-0.123
														],
														[
															-2.275,
															-1.787
														],
														[
															-2.376,
															-1.751
														],
														[
															-7.45,
															-4.781
														],
														[
															-7.464,
															-3.913
														],
														[
															-12.581,
															-4.354
														],
														[
															-15.497,
															-2.722
														],
														[
															-9.668,
															-0.949
														],
														[
															-9.464,
															0.352
														],
														[
															-3.53,
															0.069
														],
														[
															-2.437,
															0.596
														],
														[
															-1.022,
															0.583
														],
														[
															-0.701,
															1.127
														],
														[
															-0.813,
															1.167
														],
														[
															-0.84,
															0.873
														],
														[
															-0.147,
															0.665
														],
														[
															-0.21,
															0.13
														],
														[
															-0.749,
															-0.129
														],
														[
															-0.526,
															0.219
														],
														[
															-2.749,
															0.356
														],
														[
															-2.512,
															0.537
														],
														[
															-8.84,
															2.938
														],
														[
															-7.34,
															3.259
														],
														[
															-6.528,
															3.561
														],
														[
															-21.377,
															23.257
														],
														[
															-1.787,
															3.964
														],
														[
															-0.246,
															0.295
														],
														[
															-4.966,
															6.688
														],
														[
															-1.355,
															1.912
														],
														[
															-11.717,
															37.66
														],
														[
															3.764,
															54.279
														],
														[
															5.545,
															21.742
														],
														[
															3.467,
															9.798
														],
														[
															0.924,
															2.464
														],
														[
															0.95,
															2.341
														],
														[
															1.083,
															2.527
														],
														[
															2.599,
															5.17
														],
														[
															3.573,
															6.149
														],
														[
															1.241,
															2.004
														],
														[
															21.314,
															19.411
														],
														[
															1.867,
															1.614
														],
														[
															4.21,
															1.898
														],
														[
															0.346,
															0.249
														],
														[
															22.4,
															10.056
														],
														[
															53.639,
															-3.151
														]
													],
													"o": [
														[
															-0.327,
															0.023
														],
														[
															-0.336,
															-0.004
														],
														[
															-5.923,
															-0.147
														],
														[
															-6.033,
															0.978
														],
														[
															-2.848,
															0.59
														],
														[
															-2.875,
															0.42
														],
														[
															-1.224,
															0.337
														],
														[
															-1.137,
															0.573
														],
														[
															-14.686,
															4.424
														],
														[
															-12.873,
															6.074
														],
														[
															-6.295,
															4.233
														],
														[
															-5.823,
															4.508
														],
														[
															-1.755,
															1.535
														],
														[
															-1.642,
															1.712
														],
														[
															-1.335,
															1.286
														],
														[
															-1.438,
															1.162
														],
														[
															-0.442,
															0.516
														],
														[
															-0.262,
															0.731
														],
														[
															-1.572,
															1.727
														],
														[
															-1.737,
															1.634
														],
														[
															-0.819,
															0.962
														],
														[
															-0.593,
															1.011
														],
														[
															-0.343,
															0.422
														],
														[
															-0.574,
															0.29
														],
														[
															-0.478,
															0.558
														],
														[
															-0.268,
															0.715
														],
														[
															-22.841,
															29.368
														],
														[
															-14.011,
															42.331
														],
														[
															0.663,
															12.478
														],
														[
															1.912,
															11.881
														],
														[
															6.648,
															27.18
														],
														[
															11.445,
															23.066
														],
														[
															1.549,
															1.973
														],
														[
															1.71,
															1.791
														],
														[
															0.779,
															0.902
														],
														[
															0.591,
															1.04
														],
														[
															1.341,
															1.464
														],
														[
															1.661,
															1.62
														],
														[
															0.251,
															0.262
														],
														[
															0.122,
															0.365
														],
														[
															0.817,
															0.869
														],
														[
															1.057,
															0.553
														],
														[
															2.038,
															1.963
														],
														[
															1.923,
															2.003
														],
														[
															0.137,
															0.062
														],
														[
															0.179,
															0.454
														],
														[
															2.522,
															2.102
														],
														[
															2.275,
															1.787
														],
														[
															6.735,
															4.964
														],
														[
															7.45,
															4.781
														],
														[
															11.18,
															5.861
														],
														[
															12.581,
															4.354
														],
														[
															8.866,
															1.557
														],
														[
															9.667,
															0.949
														],
														[
															3.442,
															-0.128
														],
														[
															3.53,
															-0.069
														],
														[
															2.212,
															-0.541
														],
														[
															1.022,
															-0.583
														],
														[
															0.908,
															-1.459
														],
														[
															0.813,
															-1.167
														],
														[
															0.202,
															-0.211
														],
														[
															0.147,
															-0.665
														],
														[
															0.478,
															-0.298
														],
														[
															0.749,
															0.129
														],
														[
															2.494,
															-1.039
														],
														[
															2.749,
															-0.356
														],
														[
															9.302,
															-1.988
														],
														[
															8.84,
															-2.938
														],
														[
															7.645,
															-3.394
														],
														[
															30.137,
															-16.438
														],
														[
															3.509,
															-3.818
														],
														[
															0.124,
															-0.274
														],
														[
															5.669,
															-6.803
														],
														[
															1.339,
															-1.803
														],
														[
															20.926,
															-29.537
														],
														[
															12.369,
															-39.756
														],
														[
															-1.594,
															-22.996
														],
														[
															-2.596,
															-10.18
														],
														[
															-0.831,
															-2.347
														],
														[
															-0.918,
															-2.448
														],
														[
															-1.298,
															-3.197
														],
														[
															-2.717,
															-6.34
														],
														[
															-3.701,
															-7.361
														],
														[
															-1.297,
															-2.232
														],
														[
															-16.174,
															-26.128
														],
														[
															-1.792,
															-1.632
														],
														[
															-4.016,
															-3.47
														],
														[
															-0.309,
															-0.139
														],
														[
															-18.558,
															-13.339
														],
														[
															-36.287,
															-16.289
														],
														[
															-0.628,
															0.037
														]
													],
													"v": [
														[
															342,
															16
														],
														[
															341,
															16.023
														],
														[
															340,
															16
														],
														[
															322.018,
															17.465
														],
														[
															304,
															21
														],
														[
															295.353,
															22.395
														],
														[
															287,
															24
														],
														[
															283.503,
															25.475
														],
														[
															280,
															27
														],
														[
															238.603,
															42.859
														],
														[
															203,
															63
														],
														[
															184.84,
															76.123
														],
														[
															168,
															90
														],
														[
															162.942,
															94.939
														],
														[
															158,
															100
														],
														[
															153.684,
															103.665
														],
														[
															150,
															107
														],
														[
															149.051,
															108.967
														],
														[
															148,
															111
														],
														[
															142.93,
															115.992
														],
														[
															138,
															121
														],
														[
															135.992,
															123.976
														],
														[
															134,
															127
														],
														[
															132.513,
															128.002
														],
														[
															131,
															129
														],
														[
															129.981,
															130.983
														],
														[
															129,
															133
														],
														[
															71.704,
															240.795
														],
														[
															53,
															386
														],
														[
															56.98,
															422.611
														],
														[
															64,
															457
														],
														[
															91.558,
															532.468
														],
														[
															131,
															595
														],
														[
															135.954,
															600.582
														],
														[
															141,
															606
														],
														[
															142.941,
															608.974
														],
														[
															145,
															612
														],
														[
															149.745,
															616.804
														],
														[
															154,
															621
														],
														[
															154.493,
															621.989
														],
														[
															155,
															623
														],
														[
															157.896,
															624.962
														],
														[
															161,
															627
														],
														[
															166.826,
															633.205
														],
														[
															173,
															638
														],
														[
															173.492,
															638.954
														],
														[
															174,
															640
														],
														[
															181.109,
															645.763
														],
														[
															188,
															651
														],
														[
															209.453,
															665.788
														],
														[
															232,
															679
														],
														[
															267.262,
															694.354
														],
														[
															309,
															705
														],
														[
															337.052,
															708.932
														],
														[
															366,
															710
														],
														[
															376.754,
															709.851
														],
														[
															386,
															709
														],
														[
															390.634,
															707.439
														],
														[
															393,
															705
														],
														[
															395.551,
															701.061
														],
														[
															398,
															698
														],
														[
															398.494,
															696.44
														],
														[
															399,
															695
														],
														[
															400.964,
															694.941
														],
														[
															403,
															695
														],
														[
															410.986,
															693.124
														],
														[
															419,
															692
														],
														[
															446.471,
															684.452
														],
														[
															471,
															675
														],
														[
															491,
															665
														],
														[
															570,
															605
														],
														[
															580,
															593
														],
														[
															582,
															592
														],
														[
															597,
															572
														],
														[
															601,
															567
														],
														[
															650,
															467
														],
														[
															666,
															326
														],
														[
															654,
															259
														],
														[
															645,
															229
														],
														[
															642,
															222
														],
														[
															640,
															214
														],
														[
															635,
															204
														],
														[
															627,
															188
														],
														[
															617,
															168
														],
														[
															613,
															162
														],
														[
															555,
															91
														],
														[
															549,
															87
														],
														[
															537,
															77
														],
														[
															536,
															75
														],
														[
															477,
															40
														],
														[
															343,
															15
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 11,
											"s": [
												{
													"i": [
														[
															-0.112,
															0.008
														],
														[
															0.336,
															0.004
														],
														[
															0.328,
															0.008
														],
														[
															11.289,
															-2.666
														],
														[
															10.44,
															-3.617
														],
														[
															2.502,
															-0.778
														],
														[
															2.438,
															-1.005
														],
														[
															4.471,
															-2.166
														],
														[
															4.108,
															-2.274
														],
														[
															4.152,
															-2.712
														],
														[
															3.839,
															-2.632
														],
														[
															2.203,
															-1.648
														],
														[
															1.974,
															-0.89
														],
														[
															0.179,
															-0.454
														],
														[
															0.147,
															-0.123
														],
														[
															1.751,
															-1.26
														],
														[
															1.404,
															-0.632
														],
														[
															1.071,
															-1.496
														],
														[
															0.601,
															-0.515
														],
														[
															0.731,
															-0.262
														],
														[
															0.56,
															-0.51
														],
														[
															3.097,
															-3.579
														],
														[
															3.174,
															-3.557
														],
														[
															3.518,
															-4.133
														],
														[
															1.772,
															-3.93
														],
														[
															0.451,
															-0.163
														],
														[
															0.124,
															-0.185
														],
														[
															-0.067,
															-0.379
														],
														[
															0.115,
															-0.255
														],
														[
															0.451,
															-0.166
														],
														[
															0.124,
															-0.178
														],
														[
															1.377,
															-2.417
														],
														[
															0.977,
															-2.166
														],
														[
															0.451,
															-0.163
														],
														[
															0.124,
															-0.185
														],
														[
															0.23,
															-0.511
														],
														[
															0.243,
															-0.392
														],
														[
															1.257,
															-2.116
														],
														[
															1.223,
															-2.134
														],
														[
															7.769,
															-27.422
														],
														[
															2.62,
															-20.371
														],
														[
															-23.806,
															-56.495
														],
														[
															-5.649,
															-10.283
														],
														[
															-1.194,
															-2.095
														],
														[
															-1.224,
															-2.022
														],
														[
															-1.484,
															-2.354
														],
														[
															-1.058,
															-1.104
														],
														[
															-0.815,
															-0.85
														],
														[
															-0.69,
															-0.995
														],
														[
															-1.28,
															-1.771
														],
														[
															-0.223,
															-0.495
														],
														[
															-0.247,
															-0.37
														],
														[
															-0.23,
															-0.511
														],
														[
															-0.249,
															-0.328
														],
														[
															-4.384,
															-5.295
														],
														[
															-0.69,
															-0.865
														],
														[
															-1.075,
															-1.174
														],
														[
															-10.346,
															-8.46
														],
														[
															-4.096,
															-1.846
														],
														[
															-0.346,
															-0.249
														],
														[
															-17.094,
															-7.782
														],
														[
															-23.995,
															-4.54
														],
														[
															-18.491,
															0.687
														],
														[
															-4.551,
															1.243
														],
														[
															-3.003,
															3.376
														],
														[
															-0.397,
															0.247
														],
														[
															-1.05,
															0.449
														],
														[
															-5.07,
															1.17
														],
														[
															-4.577,
															1.316
														],
														[
															-10.385,
															4.628
														],
														[
															-3.669,
															2.026
														],
														[
															-2.078,
															1.143
														],
														[
															-1.725,
															1.023
														],
														[
															-2.119,
															1.325
														],
														[
															-4.901,
															3.353
														],
														[
															-5.396,
															4.644
														],
														[
															-13.59,
															18.907
														],
														[
															-1.895,
															2.662
														],
														[
															-1.142,
															1.736
														],
														[
															-0.11,
															0.115
														],
														[
															-0.699,
															1.176
														],
														[
															-3.037,
															5.179
														],
														[
															-6.163,
															15.706
														],
														[
															5.457,
															67.752
														],
														[
															33.697,
															46.96
														],
														[
															2.931,
															3.594
														],
														[
															2.233,
															2.701
														],
														[
															27.547,
															16.86
														],
														[
															10.87,
															4.636
														],
														[
															2.525,
															0.991
														],
														[
															43.325,
															-2.545
														]
													],
													"o": [
														[
															-0.327,
															0.023
														],
														[
															-0.336,
															-0.004
														],
														[
															-11.404,
															-0.284
														],
														[
															-11.289,
															2.666
														],
														[
															-2.553,
															0.884
														],
														[
															-2.502,
															0.778
														],
														[
															-5.008,
															2.064
														],
														[
															-4.471,
															2.166
														],
														[
															-4.555,
															2.521
														],
														[
															-4.152,
															2.712
														],
														[
															-2.213,
															1.517
														],
														[
															-2.203,
															1.648
														],
														[
															-0.137,
															0.062
														],
														[
															-0.179,
															0.454
														],
														[
															-1.592,
															1.327
														],
														[
															-1.751,
															1.26
														],
														[
															-1.115,
															0.502
														],
														[
															-1.071,
															1.496
														],
														[
															-0.516,
															0.441
														],
														[
															-0.731,
															0.262
														],
														[
															-3.435,
															3.128
														],
														[
															-3.097,
															3.579
														],
														[
															-3.156,
															3.537
														],
														[
															-3.518,
															4.133
														],
														[
															-0.073,
															0.162
														],
														[
															-0.451,
															0.163
														],
														[
															-0.154,
															0.23
														],
														[
															0.067,
															0.379
														],
														[
															-0.071,
															0.157
														],
														[
															-0.451,
															0.166
														],
														[
															-1.515,
															2.165
														],
														[
															-1.377,
															2.417
														],
														[
															-0.073,
															0.162
														],
														[
															-0.451,
															0.163
														],
														[
															-0.307,
															0.46
														],
														[
															-0.152,
															0.338
														],
														[
															-1.29,
															2.083
														],
														[
															-1.277,
															2.15
														],
														[
															-13.457,
															23.482
														],
														[
															-5.323,
															18.786
														],
														[
															-9.765,
															75.918
														],
														[
															5.031,
															11.941
														],
														[
															1.181,
															2.15
														],
														[
															1.279,
															2.245
														],
														[
															1.387,
															2.293
														],
														[
															1.469,
															2.33
														],
														[
															0.803,
															0.838
														],
														[
															0.742,
															0.775
														],
														[
															1.335,
															1.926
														],
														[
															0.313,
															0.432
														],
														[
															0.146,
															0.324
														],
														[
															0.307,
															0.46
														],
														[
															0.134,
															0.297
														],
														[
															4.677,
															6.17
														],
														[
															0.696,
															0.841
														],
														[
															0.878,
															1.1
														],
														[
															9.587,
															10.472
														],
														[
															4.127,
															3.374
														],
														[
															0.309,
															0.139
														],
														[
															14.956,
															10.75
														],
														[
															16.609,
															7.561
														],
														[
															17.42,
															3.296
														],
														[
															6.756,
															-0.251
														],
														[
															6.561,
															-1.792
														],
														[
															0.368,
															-0.414
														],
														[
															0.96,
															-0.597
														],
														[
															5.014,
															-2.144
														],
														[
															5.168,
															-1.193
														],
														[
															12.062,
															-3.467
														],
														[
															4.607,
															-2.053
														],
														[
															2.33,
															-1.287
														],
														[
															1.669,
															-0.918
														],
														[
															2.186,
															-1.296
														],
														[
															6.031,
															-3.771
														],
														[
															6.405,
															-4.382
														],
														[
															18.297,
															-15.749
														],
														[
															2.078,
															-2.891
														],
														[
															1.24,
															-1.743
														],
														[
															0.019,
															-0.03
														],
														[
															0.818,
															-0.854
														],
														[
															3.203,
															-5.391
														],
														[
															8.941,
															-15.247
														],
														[
															18.6,
															-47.4
														],
														[
															-5.923,
															-73.539
														],
														[
															-3.449,
															-4.806
														],
														[
															-2.552,
															-3.129
														],
														[
															-19.758,
															-23.902
														],
														[
															-10.16,
															-6.219
														],
														[
															-3.248,
															-1.386
														],
														[
															-31.268,
															-12.27
														],
														[
															-0.628,
															0.037
														]
													],
													"v": [
														[
															343,
															16
														],
														[
															342,
															16.023
														],
														[
															341,
															16
														],
														[
															306.776,
															20.074
														],
														[
															274,
															30
														],
														[
															266.414,
															32.41
														],
														[
															259,
															35
														],
														[
															244.825,
															41.342
														],
														[
															232,
															48
														],
														[
															218.963,
															55.917
														],
														[
															207,
															64
														],
														[
															200.321,
															68.97
														],
														[
															194,
															73
														],
														[
															193.508,
															73.954
														],
														[
															193,
															75
														],
														[
															187.859,
															79.021
														],
														[
															183,
															82
														],
														[
															179.615,
															85.491
														],
														[
															177,
															89
														],
														[
															175.033,
															89.949
														],
														[
															173,
															91
														],
														[
															163.304,
															101.178
														],
														[
															154,
															112
														],
														[
															143.462,
															123.705
														],
														[
															135,
															136
														],
														[
															134.038,
															136.483
														],
														[
															133,
															137
														],
														[
															132.971,
															137.981
														],
														[
															133,
															139
														],
														[
															132.04,
															139.485
														],
														[
															131,
															140
														],
														[
															126.596,
															146.999
														],
														[
															123,
															154
														],
														[
															122.038,
															154.483
														],
														[
															121,
															155
														],
														[
															121,
															157
														],
														[
															119,
															158
														],
														[
															116,
															165
														],
														[
															112,
															171
														],
														[
															79,
															250
														],
														[
															67,
															309
														],
														[
															94,
															516
														],
														[
															110,
															550
														],
														[
															114,
															556
														],
														[
															117,
															563
														],
														[
															122,
															569
														],
														[
															126,
															577
														],
														[
															128,
															580
														],
														[
															129,
															582
														],
														[
															134,
															587
														],
														[
															134,
															589
														],
														[
															136,
															590
														],
														[
															136,
															592
														],
														[
															138,
															593
														],
														[
															151,
															610
														],
														[
															154,
															612
														],
														[
															156,
															616
														],
														[
															187,
															645
														],
														[
															200,
															655
														],
														[
															201,
															657
														],
														[
															249,
															685
														],
														[
															310,
															705
														],
														[
															366,
															710
														],
														[
															386,
															709
														],
														[
															397,
															698
														],
														[
															398,
															695
														],
														[
															402,
															695
														],
														[
															418,
															692
														],
														[
															433,
															688
														],
														[
															468,
															675
														],
														[
															481,
															668
														],
														[
															488,
															665
														],
														[
															493,
															661
														],
														[
															500,
															658
														],
														[
															517,
															646
														],
														[
															534,
															633
														],
														[
															583,
															580
														],
														[
															590,
															572
														],
														[
															593,
															566
														],
														[
															594,
															565
														],
														[
															595,
															563
														],
														[
															605,
															548
														],
														[
															629,
															499
														],
														[
															655,
															327
														],
														[
															590,
															140
														],
														[
															580,
															126
														],
														[
															573,
															118
														],
														[
															500,
															54
														],
														[
															468,
															38
														],
														[
															458,
															33
														],
														[
															344,
															15
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 12,
											"s": [
												{
													"i": [
														[
															-0.054,
															0.004
														],
														[
															0.167,
															-0.002
														],
														[
															0.168,
															0.003
														],
														[
															0.167,
															0.004
														],
														[
															0.165,
															0
														],
														[
															5.617,
															-0.756
														],
														[
															5.474,
															-1.302
														],
														[
															5.245,
															-1.644
														],
														[
															4.931,
															-1.784
														],
														[
															4.776,
															-2.104
														],
														[
															4.426,
															-2.293
														],
														[
															4.062,
															-2.418
														],
														[
															3.685,
															-2.478
														],
														[
															7.874,
															-6.63
														],
														[
															7.021,
															-7.232
														],
														[
															6.157,
															-7.665
														],
														[
															1.602,
															-2.225
														],
														[
															0.899,
															-1.993
														],
														[
															0.451,
															-0.163
														],
														[
															0.124,
															-0.185
														],
														[
															-0.067,
															-0.379
														],
														[
															0.115,
															-0.255
														],
														[
															0.451,
															-0.167
														],
														[
															0.124,
															-0.177
														],
														[
															2.503,
															-4.042
														],
														[
															2.408,
															-4.166
														],
														[
															4.335,
															-8.956
														],
														[
															3.668,
															-9.541
														],
														[
															4.483,
															-29.094
														],
														[
															-1.114,
															-29.744
														],
														[
															-4.893,
															-21.93
														],
														[
															-7.515,
															-18.876
														],
														[
															-10.033,
															-16.682
														],
														[
															-12.274,
															-14.204
														],
														[
															-24.482,
															-15.753
														],
														[
															-33.268,
															-6.389
														],
														[
															-5.917,
															-0.628
														],
														[
															-6.506,
															-0.37
														],
														[
															-8.643,
															0.061
														],
														[
															-2.661,
															3.026
														],
														[
															-0.226,
															0.47
														],
														[
															-0.014,
															0.026
														],
														[
															-0.511,
															0.615
														],
														[
															-0.387,
															0.515
														],
														[
															-0.061,
															0.531
														],
														[
															-0.398,
															0.398
														],
														[
															-0.644,
															0.085
														],
														[
															-1.374,
															0.61
														],
														[
															-1.204,
															0.326
														],
														[
															-1.188,
															0.254
														],
														[
															-3.762,
															0.988
														],
														[
															-3.729,
															1.146
														],
														[
															-16.162,
															9.329
														],
														[
															-13.072,
															11.76
														],
														[
															-3.087,
															3.173
														],
														[
															-3.219,
															3.219
														],
														[
															-4.284,
															5.181
														],
														[
															-3.924,
															5.336
														],
														[
															-0.57,
															0.771
														],
														[
															-0.202,
															0.211
														],
														[
															-0.298,
															0.539
														],
														[
															-0.408,
															0.425
														],
														[
															-0.298,
															0.539
														],
														[
															-0.408,
															0.425
														],
														[
															-0.796,
															1.187
														],
														[
															-0.736,
															1.125
														],
														[
															-1.81,
															2.947
														],
														[
															-1.712,
															3.084
														],
														[
															-2.214,
															4.219
														],
														[
															-1.779,
															3.864
														],
														[
															-0.764,
															2.393
														],
														[
															-0.952,
															2.274
														],
														[
															-0.553,
															1.012
														],
														[
															-0.392,
															1
														],
														[
															-1.974,
															6.16
														],
														[
															-1.79,
															6.463
														],
														[
															-2.615,
															22.679
														],
														[
															1.931,
															26.529
														],
														[
															6.859,
															25.39
														],
														[
															10.485,
															20.855
														],
														[
															2.368,
															3.964
														],
														[
															2.41,
															3.932
														],
														[
															5.298,
															7.554
														],
														[
															5.996,
															6.929
														],
														[
															3.207,
															3.112
														],
														[
															3.315,
															3.249
														],
														[
															11.025,
															7.971
														],
														[
															13.034,
															6.445
														],
														[
															21.076,
															4.826
														],
														[
															25.815,
															-1.652
														],
														[
															0.185,
															-0.246
														]
													],
													"o": [
														[
															-0.164,
															0.012
														],
														[
															-0.167,
															0.002
														],
														[
															-0.168,
															-0.003
														],
														[
															-0.167,
															-0.004
														],
														[
															-5.673,
															0.008
														],
														[
															-5.617,
															0.756
														],
														[
															-5.474,
															1.302
														],
														[
															-5.245,
															1.644
														],
														[
															-5.111,
															1.849
														],
														[
															-4.776,
															2.104
														],
														[
															-4.426,
															2.293
														],
														[
															-4.062,
															2.418
														],
														[
															-8.714,
															5.86
														],
														[
															-7.874,
															6.63
														],
														[
															-7.021,
															7.232
														],
														[
															-1.692,
															2.106
														],
														[
															-1.602,
															2.225
														],
														[
															-0.073,
															0.162
														],
														[
															-0.451,
															0.163
														],
														[
															-0.154,
															0.23
														],
														[
															0.067,
															0.379
														],
														[
															-0.07,
															0.156
														],
														[
															-0.451,
															0.167
														],
														[
															-2.582,
															3.668
														],
														[
															-2.503,
															4.042
														],
														[
															-4.992,
															8.636
														],
														[
															-4.335,
															8.956
														],
														[
															-9.183,
															23.881
														],
														[
															-4.483,
															29.094
														],
														[
															0.914,
															24.404
														],
														[
															4.893,
															21.93
														],
														[
															7.592,
															19.069
														],
														[
															10.033,
															16.682
														],
														[
															17.803,
															20.601
														],
														[
															24.482,
															15.753
														],
														[
															5.825,
															1.119
														],
														[
															5.917,
															0.628
														],
														[
															4.768,
															0.271
														],
														[
															8.643,
															-0.061
														],
														[
															0.082,
															-0.093
														],
														[
															0.226,
															-0.47
														],
														[
															0.568,
															-1.023
														],
														[
															0.511,
															-0.615
														],
														[
															0.357,
															-0.477
														],
														[
															0.061,
															-0.531
														],
														[
															1.05,
															-1.051
														],
														[
															0.644,
															-0.085
														],
														[
															0.994,
															-0.442
														],
														[
															1.204,
															-0.326
														],
														[
															4.221,
															-0.902
														],
														[
															3.762,
															-0.988
														],
														[
															19.281,
															-5.922
														],
														[
															16.162,
															-9.329
														],
														[
															3.433,
															-3.088
														],
														[
															3.087,
															-3.173
														],
														[
															4.94,
															-4.94
														],
														[
															4.284,
															-5.181
														],
														[
															0.519,
															-0.706
														],
														[
															0.57,
															-0.771
														],
														[
															0.401,
															-0.419
														],
														[
															0.298,
															-0.539
														],
														[
															0.401,
															-0.419
														],
														[
															0.298,
															-0.539
														],
														[
															1.079,
															-1.127
														],
														[
															0.796,
															-1.187
														],
														[
															2.049,
															-3.13
														],
														[
															1.81,
															-2.947
														],
														[
															2.365,
															-4.262
														],
														[
															2.214,
															-4.219
														],
														[
															0.991,
															-2.154
														],
														[
															0.764,
															-2.393
														],
														[
															0.398,
															-0.951
														],
														[
															0.553,
															-1.012
														],
														[
															2.312,
															-5.899
														],
														[
															1.974,
															-6.16
														],
														[
															5.472,
															-19.756
														],
														[
															2.615,
															-22.679
														],
														[
															-2.081,
															-28.586
														],
														[
															-6.859,
															-25.39
														],
														[
															-2.118,
															-4.212
														],
														[
															-2.368,
															-3.964
														],
														[
															-4.814,
															-7.853
														],
														[
															-5.298,
															-7.554
														],
														[
															-2.858,
															-3.303
														],
														[
															-3.207,
															-3.112
														],
														[
															-9.868,
															-9.672
														],
														[
															-11.025,
															-7.971
														],
														[
															-16.882,
															-8.348
														],
														[
															-21.076,
															-4.826
														],
														[
															-0.313,
															0.02
														],
														[
															-0.185,
															0.246
														]
													],
													"v": [
														[
															343,
															16
														],
														[
															342.503,
															16.021
														],
														[
															342.001,
															16.018
														],
														[
															341.498,
															16.006
														],
														[
															341,
															16
														],
														[
															324.044,
															17.198
														],
														[
															307.387,
															20.336
														],
														[
															291.286,
															24.806
														],
														[
															276,
															30
														],
														[
															261.166,
															35.946
														],
														[
															247.361,
															42.557
														],
														[
															234.625,
															49.64
														],
														[
															223,
															57
														],
														[
															198.115,
															75.777
														],
														[
															175.77,
															96.613
														],
														[
															156,
															119
														],
														[
															150.905,
															125.585
														],
														[
															147,
															132
														],
														[
															146.038,
															132.483
														],
														[
															145,
															133
														],
														[
															144.971,
															133.981
														],
														[
															145,
															135
														],
														[
															144.04,
															135.485
														],
														[
															143,
															136
														],
														[
															135.37,
															147.626
														],
														[
															128,
															160
														],
														[
															114.007,
															186.321
														],
														[
															102,
															214
														],
														[
															81.277,
															294.603
														],
														[
															76,
															384
														],
														[
															85.049,
															453.646
														],
														[
															104,
															515
														],
														[
															130.488,
															568.649
														],
														[
															164,
															615
														],
														[
															226.901,
															670.659
														],
														[
															313,
															705
														],
														[
															330.489,
															707.561
														],
														[
															349,
															709
														],
														[
															371.58,
															709.973
														],
														[
															391,
															706
														],
														[
															391.55,
															704.95
														],
														[
															392,
															704
														],
														[
															393.636,
															701.62
														],
														[
															395,
															700
														],
														[
															395.47,
															698.44
														],
														[
															396,
															697
														],
														[
															398.258,
															695.67
														],
														[
															401,
															695
														],
														[
															404.355,
															693.859
														],
														[
															408,
															693
														],
														[
															419.869,
															690.182
														],
														[
															431,
															687
														],
														[
															484.158,
															663.879
														],
														[
															528,
															632
														],
														[
															537.66,
															622.599
														],
														[
															547,
															613
														],
														[
															560.762,
															597.797
														],
														[
															573,
															582
														],
														[
															574.737,
															579.629
														],
														[
															576,
															578
														],
														[
															576.995,
															576.505
														],
														[
															578,
															575
														],
														[
															578.995,
															573.505
														],
														[
															580,
															572
														],
														[
															582.757,
															568.499
														],
														[
															585,
															565
														],
														[
															590.753,
															555.966
														],
														[
															596,
															547
														],
														[
															602.94,
															534.202
														],
														[
															609,
															522
														],
														[
															611.529,
															515.091
														],
														[
															614,
															508
														],
														[
															615.505,
															505.037
														],
														[
															617,
															502
														],
														[
															623.392,
															483.923
														],
														[
															629,
															465
														],
														[
															641.552,
															401.58
														],
														[
															643,
															328
														],
														[
															629.303,
															246.702
														],
														[
															603,
															177
														],
														[
															596.219,
															164.79
														],
														[
															589,
															153
														],
														[
															573.886,
															129.807
														],
														[
															557,
															108
														],
														[
															547.843,
															98.46
														],
														[
															538,
															89
														],
														[
															506.874,
															62.58
														],
														[
															471,
															41
														],
														[
															414.2,
															20.5
														],
														[
															344,
															15
														],
														[
															343.224,
															15.518
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 13,
											"s": [
												{
													"i": [
														[
															-0.109,
															0.008
														],
														[
															5.685,
															-0.787
														],
														[
															5.995,
															-1.389
														],
														[
															5.021,
															-1.481
														],
														[
															4.679,
															-1.863
														],
														[
															6.172,
															-3.199
														],
														[
															5.754,
															-2.593
														],
														[
															0.158,
															-0.451
														],
														[
															0.198,
															-0.121
														],
														[
															1.193,
															-0.395
														],
														[
															1.066,
															-0.711
														],
														[
															0.744,
															-0.901
														],
														[
															1.048,
															-0.743
														],
														[
															1.047,
															-0.425
														],
														[
															0.879,
															-0.636
														],
														[
															1.144,
															-0.89
														],
														[
															1.148,
															-0.517
														],
														[
															0.179,
															-0.454
														],
														[
															0.147,
															-0.123
														],
														[
															2.165,
															-1.834
														],
														[
															1.973,
															-1.691
														],
														[
															2.37,
															-2.441
														],
														[
															2.578,
															-2.716
														],
														[
															2.979,
															-3.503
														],
														[
															2.897,
															-3.631
														],
														[
															1.284,
															-1.707
														],
														[
															0.786,
															-0.821
														],
														[
															1.015,
															-1.568
														],
														[
															0.6,
															-1.33
														],
														[
															0.247,
															-0.37
														],
														[
															0.23,
															-0.511
														],
														[
															0.246,
															-0.373
														],
														[
															1.242,
															-2.003
														],
														[
															9.774,
															-30.505
														],
														[
															2.631,
															-11.059
														],
														[
															1.05,
															-5.468
														],
														[
															1.385,
															-11.686
														],
														[
															-22.425,
															-54.32
														],
														[
															-19.227,
															-24.703
														],
														[
															-1.497,
															-1.866
														],
														[
															-0.576,
															-0.74
														],
														[
															-0.69,
															-0.843
														],
														[
															-1.562,
															-1.783
														],
														[
															-3.23,
															-3.403
														],
														[
															-15.113,
															-10.262
														],
														[
															-8.93,
															-4.585
														],
														[
															-4.414,
															-1.991
														],
														[
															-5.165,
															-1.882
														],
														[
															-2.175,
															-0.732
														],
														[
															-2.547,
															-0.734
														],
														[
															-23.552,
															0.995
														],
														[
															-4.11,
															1.644
														],
														[
															-0.876,
															0.828
														],
														[
															-1.469,
															1.505
														],
														[
															-1.692,
															0.825
														],
														[
															-4.72,
															1.214
														],
														[
															-4.237,
															1.385
														],
														[
															-8.361,
															3.812
														],
														[
															-9.429,
															4.251
														],
														[
															-0.37,
															0.247
														],
														[
															-0.511,
															0.23
														],
														[
															-0.361,
															0.248
														],
														[
															-0.904,
															0.866
														],
														[
															-0.949,
															0.681
														],
														[
															-1.99,
															1.509
														],
														[
															-0.962,
															0.672
														],
														[
															-0.828,
															0.642
														],
														[
															-0.759,
															0.591
														],
														[
															-0.836,
															0.699
														],
														[
															-0.966,
															0.675
														],
														[
															-0.773,
															0.696
														],
														[
															-7.638,
															8.276
														],
														[
															-9.89,
															15.819
														],
														[
															-10.848,
															41.002
														],
														[
															3.109,
															52.595
														],
														[
															14.07,
															37.268
														],
														[
															19.854,
															25.221
														],
														[
															1.581,
															1.923
														],
														[
															2.802,
															3.243
														],
														[
															0.675,
															0.966
														],
														[
															0.695,
															0.773
														],
														[
															9.529,
															7.445
														],
														[
															1.688,
															1.264
														],
														[
															0.961,
															0.672
														],
														[
															0.852,
															0.602
														],
														[
															0.499,
															0.225
														],
														[
															0.37,
															0.247
														],
														[
															0.511,
															0.23
														],
														[
															0.353,
															0.249
														],
														[
															8.236,
															4.585
														],
														[
															49.509,
															-3.169
														]
													],
													"o": [
														[
															-6.267,
															0.463
														],
														[
															-5.685,
															0.787
														],
														[
															-5.235,
															1.213
														],
														[
															-5.021,
															1.481
														],
														[
															-6.558,
															2.611
														],
														[
															-6.172,
															3.199
														],
														[
															-0.17,
															0.076
														],
														[
															-0.158,
															0.451
														],
														[
															-1.163,
															0.709
														],
														[
															-1.193,
															0.395
														],
														[
															-0.976,
															0.651
														],
														[
															-0.744,
															0.901
														],
														[
															-0.933,
															0.662
														],
														[
															-1.047,
															0.425
														],
														[
															-1.274,
															0.922
														],
														[
															-1.145,
															0.89
														],
														[
															-0.137,
															0.062
														],
														[
															-0.179,
															0.454
														],
														[
															-2.367,
															1.972
														],
														[
															-2.165,
															1.834
														],
														[
															-2.941,
															2.52
														],
														[
															-2.37,
															2.441
														],
														[
															-3.185,
															3.356
														],
														[
															-2.979,
															3.503
														],
														[
															-1.078,
															1.351
														],
														[
															-1.284,
															1.707
														],
														[
															-1.339,
															1.398
														],
														[
															-1.015,
															1.568
														],
														[
															-0.146,
															0.324
														],
														[
															-0.307,
															0.46
														],
														[
															-0.147,
															0.326
														],
														[
															-1.123,
															1.701
														],
														[
															-15.822,
															25.523
														],
														[
															-3.418,
															10.669
														],
														[
															-1.291,
															5.428
														],
														[
															-2.103,
															10.952
														],
														[
															-9.261,
															78.145
														],
														[
															13.383,
															32.418
														],
														[
															1.462,
															1.879
														],
														[
															0.645,
															0.804
														],
														[
															0.657,
															0.843
														],
														[
															1.539,
															1.879
														],
														[
															3.103,
															3.543
														],
														[
															12.654,
															13.331
														],
														[
															7.654,
															5.197
														],
														[
															4.071,
															2.09
														],
														[
															4.523,
															2.04
														],
														[
															2.098,
															0.764
														],
														[
															2.457,
															0.826
														],
														[
															19.448,
															5.601
														],
														[
															7.161,
															-0.303
														],
														[
															1.371,
															-0.549
														],
														[
															2.336,
															-2.208
														],
														[
															1.116,
															-1.143
														],
														[
															4.325,
															-2.11
														],
														[
															5.114,
															-1.315
														],
														[
															9.417,
															-3.078
														],
														[
															10.972,
															-5.003
														],
														[
															0.324,
															-0.146
														],
														[
															0.46,
															-0.307
														],
														[
															0.318,
															-0.144
														],
														[
															1.84,
															-1.265
														],
														[
															0.752,
															-0.721
														],
														[
															1.75,
															-1.256
														],
														[
															0.872,
															-0.661
														],
														[
															0.834,
															-0.583
														],
														[
															0.84,
															-0.652
														],
														[
															0.843,
															-0.657
														],
														[
															0.848,
															-0.709
														],
														[
															0.825,
															-0.577
														],
														[
															8.555,
															-7.699
														],
														[
															12.044,
															-13.051
														],
														[
															18.877,
															-30.193
														],
														[
															10.213,
															-38.6
														],
														[
															-2.578,
															-43.603
														],
														[
															-12.78,
															-33.852
														],
														[
															-1.634,
															-2.076
														],
														[
															-2.713,
															-3.299
														],
														[
															-0.723,
															-0.837
														],
														[
															-0.576,
															-0.825
														],
														[
															-8.792,
															-9.771
														],
														[
															-1.639,
															-1.28
														],
														[
															-0.875,
															-0.655
														],
														[
															-0.832,
															-0.581
														],
														[
															-0.441,
															-0.311
														],
														[
															-0.324,
															-0.146
														],
														[
															-0.46,
															-0.307
														],
														[
															-0.313,
															-0.141
														],
														[
															-7.296,
															-5.135
														],
														[
															-31.876,
															-17.746
														],
														[
															-0.627,
															0.04
														]
													],
													"v": [
														[
															344,
															16
														],
														[
															326.296,
															17.805
														],
														[
															309,
															21
														],
														[
															293.583,
															25.013
														],
														[
															279,
															30
														],
														[
															259.897,
															39.013
														],
														[
															242,
															48
														],
														[
															241.521,
															48.967
														],
														[
															241,
															50
														],
														[
															237.427,
															51.499
														],
														[
															234,
															53
														],
														[
															231.554,
															55.43
														],
														[
															229,
															58
														],
														[
															225.96,
															59.519
														],
														[
															223,
															61
														],
														[
															219.406,
															63.804
														],
														[
															216,
															66
														],
														[
															215.508,
															66.954
														],
														[
															215,
															68
														],
														[
															208.204,
															73.712
														],
														[
															202,
															79
														],
														[
															194.228,
															86.353
														],
														[
															187,
															94
														],
														[
															177.784,
															104.293
														],
														[
															169,
															115
														],
														[
															165.281,
															119.898
														],
														[
															162,
															124
														],
														[
															158.445,
															128.551
														],
														[
															156,
															133
														],
														[
															154,
															134
														],
														[
															154,
															136
														],
														[
															152,
															137
														],
														[
															149,
															143
														],
														[
															109,
															229
														],
														[
															101,
															260
														],
														[
															97,
															276
														],
														[
															92,
															310
														],
														[
															118,
															520
														],
														[
															167,
															608
														],
														[
															172,
															613
														],
														[
															173,
															616
														],
														[
															176,
															618
														],
														[
															180,
															624
														],
														[
															190,
															634
														],
														[
															232,
															670
														],
														[
															257,
															684
														],
														[
															269,
															691
														],
														[
															284,
															696
														],
														[
															290,
															699
														],
														[
															298,
															701
														],
														[
															367,
															710
														],
														[
															388,
															708
														],
														[
															389,
															706
														],
														[
															396,
															696
														],
														[
															399,
															695
														],
														[
															414,
															692
														],
														[
															428,
															687
														],
														[
															455,
															677
														],
														[
															486,
															660
														],
														[
															487,
															658
														],
														[
															489,
															658
														],
														[
															490,
															656
														],
														[
															494,
															654
														],
														[
															496,
															653
														],
														[
															501,
															648
														],
														[
															504,
															647
														],
														[
															506,
															644
														],
														[
															509,
															643
														],
														[
															511,
															640
														],
														[
															514,
															639
														],
														[
															516,
															636
														],
														[
															540,
															612
														],
														[
															572,
															569
														],
														[
															617,
															464
														],
														[
															631,
															328
														],
														[
															604,
															206
														],
														[
															554,
															116
														],
														[
															550,
															110
														],
														[
															541,
															101
														],
														[
															540,
															98
														],
														[
															537,
															96
														],
														[
															508,
															68
														],
														[
															503,
															64
														],
														[
															500,
															63
														],
														[
															498,
															60
														],
														[
															496,
															60
														],
														[
															495,
															58
														],
														[
															493,
															58
														],
														[
															492,
															56
														],
														[
															468,
															42
														],
														[
															345,
															15
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 14,
											"s": [
												{
													"i": [
														[
															-0.106,
															0.008
														],
														[
															0.334,
															0.009
														],
														[
															0.332,
															-0.011
														],
														[
															9.921,
															-2.721
														],
														[
															9.067,
															-3.748
														],
														[
															4.856,
															-2.396
														],
														[
															3.704,
															-2.4
														],
														[
															5.221,
															-3.629
														],
														[
															4.572,
															-3.893
														],
														[
															2.291,
															-2.139
														],
														[
															1.659,
															-1.589
														],
														[
															0.375,
															-0.129
														],
														[
															0.254,
															-0.246
														],
														[
															0.584,
															-1.084
														],
														[
															0.819,
															-0.846
														],
														[
															1.698,
															-1.389
														],
														[
															1.497,
															-1.677
														],
														[
															0.074,
															-0.526
														],
														[
															0.337,
															-0.483
														],
														[
															0.596,
															-0.293
														],
														[
															0.327,
															-0.41
														],
														[
															1.046,
															-1.436
														],
														[
															0.771,
															-0.946
														],
														[
															0.32,
															-0.524
														],
														[
															0.368,
															-0.472
														],
														[
															0.926,
															-0.818
														],
														[
															0.654,
															-0.907
														],
														[
															0.441,
															-1.063
														],
														[
															0.606,
															-0.876
														],
														[
															0.226,
															-0.223
														],
														[
															0.069,
															-0.072
														],
														[
															0.298,
															-0.539
														],
														[
															0.407,
															-0.425
														],
														[
															0.781,
															-1.169
														],
														[
															0.76,
															-1.16
														],
														[
															11.427,
															-42.496
														],
														[
															-2.32,
															-51.066
														],
														[
															-2.17,
															-14.244
														],
														[
															-2.665,
															-11.573
														],
														[
															-0.631,
															-3.319
														],
														[
															-0.707,
															-2.382
														],
														[
															-0.721,
															-1.827
														],
														[
															-0.516,
															-1.672
														],
														[
															-1.163,
															-3.523
														],
														[
															-1.096,
															-2.853
														],
														[
															-0.785,
															-2.325
														],
														[
															-0.903,
															-2.211
														],
														[
															-3.015,
															-6.363
														],
														[
															-2.407,
															-5.341
														],
														[
															-0.451,
															-0.154
														],
														[
															-0.118,
															-0.207
														],
														[
															-0.444,
															-1.217
														],
														[
															-0.628,
															-1.087
														],
														[
															-5.241,
															-7.582
														],
														[
															-5.358,
															-6.579
														],
														[
															-11.777,
															-10.08
														],
														[
															-14.691,
															-8.155
														],
														[
															-9.025,
															-3.897
														],
														[
															-10.749,
															-2.442
														],
														[
															-8.951,
															-0.889
														],
														[
															-8.472,
															0.312
														],
														[
															-3.299,
															0.084
														],
														[
															-1.782,
															0.553
														],
														[
															-1.089,
															0.287
														],
														[
															0.051,
															-0.051
														],
														[
															0.083,
															0.417
														],
														[
															-0.167,
															0.165
														],
														[
															-0.91,
															1.668
														],
														[
															-0.995,
															0.983
														],
														[
															-2.253,
															0.48
														],
														[
															-2.458,
															0.568
														],
														[
															-7.048,
															2.847
														],
														[
															-4.086,
															1.917
														],
														[
															-5.589,
															3.278
														],
														[
															-24.846,
															42.308
														],
														[
															5.21,
															99.398
														],
														[
															4.266,
															20.471
														],
														[
															39.598,
															45.089
														],
														[
															4.015,
															3.747
														],
														[
															1.845,
															1.619
														],
														[
															4.468,
															3.392
														],
														[
															0.962,
															0.672
														],
														[
															0.845,
															0.616
														],
														[
															1.793,
															1.258
														],
														[
															1.929,
															1.302
														],
														[
															1.38,
															0.622
														],
														[
															0.377,
															0.246
														],
														[
															2.116,
															1.239
														],
														[
															3.813,
															1.883
														],
														[
															4.445,
															1.882
														],
														[
															37.536,
															-2.588
														]
													],
													"o": [
														[
															-0.331,
															0.026
														],
														[
															-0.334,
															-0.009
														],
														[
															-11.249,
															0.37
														],
														[
															-9.921,
															2.721
														],
														[
															-4.874,
															2.014
														],
														[
															-4.856,
															2.396
														],
														[
															-5.546,
															3.593
														],
														[
															-5.221,
															3.628
														],
														[
															-2.179,
															1.856
														],
														[
															-2.291,
															2.139
														],
														[
															-0.246,
															0.236
														],
														[
															-0.375,
															0.129
														],
														[
															-0.844,
															0.819
														],
														[
															-0.584,
															1.084
														],
														[
															-1.71,
															1.766
														],
														[
															-1.698,
															1.389
														],
														[
															-0.368,
															0.413
														],
														[
															-0.074,
															0.526
														],
														[
															-0.291,
															0.416
														],
														[
															-0.595,
															0.294
														],
														[
															-1.046,
															1.309
														],
														[
															-1.046,
															1.436
														],
														[
															-0.351,
															0.43
														],
														[
															-0.32,
															0.524
														],
														[
															-0.641,
															0.823
														],
														[
															-0.926,
															0.817
														],
														[
															-0.629,
															0.871
														],
														[
															-0.441,
															1.063
														],
														[
															-0.025,
															0.036
														],
														[
															-0.226,
															0.223
														],
														[
															-0.401,
															0.419
														],
														[
															-0.298,
															0.539
														],
														[
															-1.115,
															1.163
														],
														[
															-0.781,
															1.169
														],
														[
															-19.61,
															29.95
														],
														[
															-11.427,
															42.496
														],
														[
															0.656,
															14.452
														],
														[
															2.17,
															14.243
														],
														[
															0.77,
															3.343
														],
														[
															0.631,
															3.319
														],
														[
															0.599,
															2.019
														],
														[
															0.721,
															1.827
														],
														[
															1.251,
															4.057
														],
														[
															1.163,
															3.523
														],
														[
															0.956,
															2.488
														],
														[
															0.785,
															2.325
														],
														[
															2.534,
															6.207
														],
														[
															3.015,
															6.363
														],
														[
															0.079,
															0.176
														],
														[
															0.451,
															0.154
														],
														[
															0.594,
															1.046
														],
														[
															0.444,
															1.217
														],
														[
															4.678,
															8.092
														],
														[
															5.241,
															7.582
														],
														[
															10.202,
															12.526
														],
														[
															11.777,
															10.08
														],
														[
															7.15,
															3.969
														],
														[
															9.025,
															3.897
														],
														[
															7.722,
															1.755
														],
														[
															8.951,
															0.889
														],
														[
															3.02,
															-0.111
														],
														[
															3.299,
															-0.084
														],
														[
															-0.307,
															0.096
														],
														[
															1.09,
															-0.287
														],
														[
															0.166,
															-0.166
														],
														[
															-0.083,
															-0.417
														],
														[
															1.365,
															-1.346
														],
														[
															0.91,
															-1.668
														],
														[
															1.53,
															-1.511
														],
														[
															2.253,
															-0.48
														],
														[
															9.851,
															-2.276
														],
														[
															4.591,
															-1.854
														],
														[
															6.066,
															-2.846
														],
														[
															42.524,
															-24.937
														],
														[
															34.979,
															-59.564
														],
														[
															-1.152,
															-21.975
														],
														[
															-14.57,
															-69.914
														],
														[
															-4.242,
															-4.83
														],
														[
															-1.646,
															-1.536
														],
														[
															-4.869,
															-4.271
														],
														[
															-0.872,
															-0.662
														],
														[
															-0.833,
															-0.582
														],
														[
															-1.765,
															-1.286
														],
														[
															-1.804,
															-1.266
														],
														[
															-1.736,
															-1.172
														],
														[
															-0.328,
															-0.148
														],
														[
															-1.964,
															-1.281
														],
														[
															-3.784,
															-2.216
														],
														[
															-4.14,
															-2.044
														],
														[
															-25.404,
															-10.756
														],
														[
															-0.625,
															0.043
														]
													],
													"v": [
														[
															344,
															16
														],
														[
															343.001,
															16.011
														],
														[
															342,
															16
														],
														[
															310.363,
															20.966
														],
														[
															282,
															31
														],
														[
															267.123,
															37.711
														],
														[
															254,
															45
														],
														[
															237.77,
															55.775
														],
														[
															223,
															67
														],
														[
															216.11,
															73.2
														],
														[
															210,
															79
														],
														[
															209.006,
															79.492
														],
														[
															208,
															80
														],
														[
															205.981,
															82.98
														],
														[
															204,
															86
														],
														[
															198.84,
															90.566
														],
														[
															194,
															95
														],
														[
															193.476,
															96.448
														],
														[
															193,
															98
														],
														[
															191.527,
															99.005
														],
														[
															190,
															100
														],
														[
															186.793,
															104.273
														],
														[
															184,
															108
														],
														[
															183.012,
															109.469
														],
														[
															182,
															111
														],
														[
															179.511,
															113.437
														],
														[
															177,
															116
														],
														[
															175.483,
															118.997
														],
														[
															174,
															122
														],
														[
															173.533,
															122.473
														],
														[
															173,
															123
														],
														[
															172.005,
															124.496
														],
														[
															171,
															126
														],
														[
															168.234,
															129.502
														],
														[
															166,
															133
														],
														[
															118.053,
															242.663
														],
														[
															103,
															384
														],
														[
															107.494,
															427.659
														],
														[
															115,
															467
														],
														[
															117.048,
															477.22
														],
														[
															119,
															486
														],
														[
															121.063,
															491.76
														],
														[
															123,
															497
														],
														[
															126.615,
															508.403
														],
														[
															130,
															518
														],
														[
															132.54,
															525.208
														],
														[
															135,
															532
														],
														[
															143.595,
															551.15
														],
														[
															152,
															569
														],
														[
															152.971,
															569.476
														],
														[
															154,
															570
														],
														[
															155.475,
															573.47
														],
														[
															157,
															577
														],
														[
															171.989,
															600.635
														],
														[
															188,
															622
														],
														[
															220.633,
															655.778
														],
														[
															260,
															683
														],
														[
															284.301,
															695.145
														],
														[
															314,
															705
														],
														[
															339.437,
															709.05
														],
														[
															366,
															710
														],
														[
															375.928,
															709.832
														],
														[
															384,
															709
														],
														[
															385.808,
															708.533
														],
														[
															388,
															708
														],
														[
															387.999,
															706.999
														],
														[
															388,
															706
														],
														[
															391.277,
															701.227
														],
														[
															394,
															697
														],
														[
															399.804,
															694.293
														],
														[
															407,
															693
														],
														[
															434,
															684
														],
														[
															447,
															679
														],
														[
															465,
															669
														],
														[
															563,
															566
														],
														[
															617,
															328
														],
														[
															608,
															264
														],
														[
															525,
															92
														],
														[
															512,
															78
														],
														[
															506,
															74
														],
														[
															492,
															61
														],
														[
															489,
															60
														],
														[
															487,
															57
														],
														[
															481,
															54
														],
														[
															476,
															50
														],
														[
															472,
															48
														],
														[
															471,
															46
														],
														[
															464,
															43
														],
														[
															453,
															36
														],
														[
															440,
															31
														],
														[
															345,
															15
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 15,
											"s": [
												{
													"i": [
														[
															-0.106,
															0.008
														],
														[
															0.336,
															0.006
														],
														[
															0.329,
															0.002
														],
														[
															7.732,
															-1.973
														],
														[
															5.781,
															-2.149
														],
														[
															1.706,
															-0.687
														],
														[
															1.257,
															-0.539
														],
														[
															4.289,
															-2.28
														],
														[
															4.096,
															-1.846
														],
														[
															0.16,
															-0.451
														],
														[
															0.192,
															-0.123
														],
														[
															0.988,
															-0.419
														],
														[
															1.005,
															-0.66
														],
														[
															0.812,
															-0.695
														],
														[
															0.901,
															-0.66
														],
														[
															7.233,
															-6.768
														],
														[
															6.029,
															-7.049
														],
														[
															0.998,
															-1.389
														],
														[
															0.839,
															-1.076
														],
														[
															0.586,
															-0.287
														],
														[
															0.329,
															-0.43
														],
														[
															0.448,
															-1.1
														],
														[
															0.611,
															-0.818
														],
														[
															0.371,
															-0.335
														],
														[
															0.283,
															-0.347
														],
														[
															0.916,
															-1.363
														],
														[
															0.495,
															-0.517
														],
														[
															0.804,
															-1.187
														],
														[
															0.698,
															-1.118
														],
														[
															1.147,
															-1.777
														],
														[
															1.087,
															-1.769
														],
														[
															0.26,
															-0.809
														],
														[
															0.344,
															-0.762
														],
														[
															0.451,
															-0.153
														],
														[
															0.117,
															-0.21
														],
														[
															0.978,
															-2.033
														],
														[
															1.038,
															-1.986
														],
														[
															0.985,
															-2.212
														],
														[
															0.988,
															-2.102
														],
														[
															4.874,
															-13.51
														],
														[
															3.452,
															-15.089
														],
														[
															2.388,
															-23.001
														],
														[
															-1.101,
															-23.12
														],
														[
															-10.966,
															-35.883
														],
														[
															-17.082,
															-27.361
														],
														[
															-0.728,
															-1.373
														],
														[
															-0.418,
															-0.436
														],
														[
															-0.298,
															-0.539
														],
														[
															-0.407,
															-0.425
														],
														[
															-0.744,
															-1.163
														],
														[
															-0.889,
															-1.163
														],
														[
															-0.674,
															-0.824
														],
														[
															-0.652,
															-0.852
														],
														[
															-2.807,
															-3.28
														],
														[
															-2.882,
															-3.102
														],
														[
															-3.174,
															-3.174
														],
														[
															-15.343,
															-9.311
														],
														[
															-21.047,
															-5.323
														],
														[
															-11.431,
															-0.872
														],
														[
															-4.644,
															4.245
														],
														[
															-1.568,
															1.606
														],
														[
															-3.431,
															0.77
														],
														[
															-0.53,
															0.148
														],
														[
															-1.257,
															0.282
														],
														[
															-0.531,
															0.166
														],
														[
															-15.512,
															10.918
														],
														[
															-11.154,
															12.382
														],
														[
															-2.792,
															2.984
														],
														[
															-1.126,
															1.204
														],
														[
															-1.28,
															1.569
														],
														[
															-4.398,
															7.371
														],
														[
															-9.607,
															47.261
														],
														[
															-1.32,
															8.152
														],
														[
															1.561,
															37.033
														],
														[
															14.714,
															38.705
														],
														[
															1.752,
															4.158
														],
														[
															9.784,
															15.28
														],
														[
															1.646,
															1.718
														],
														[
															0.683,
															0.96
														],
														[
															2.34,
															3.083
														],
														[
															0.499,
															0.73
														],
														[
															1.899,
															2.248
														],
														[
															0.551,
															0.707
														],
														[
															2.113,
															2.29
														],
														[
															5.858,
															5.172
														],
														[
															7.624,
															5.31
														],
														[
															2.135,
															1.305
														],
														[
															7.607,
															3.501
														],
														[
															2.021,
															0.837
														],
														[
															2.063,
															0.756
														],
														[
															30.23,
															-2.084
														]
													],
													"o": [
														[
															-0.328,
															0.026
														],
														[
															-0.336,
															-0.006
														],
														[
															-8.293,
															-0.041
														],
														[
															-7.732,
															1.973
														],
														[
															-1.919,
															0.714
														],
														[
															-1.706,
															0.687
														],
														[
															-4.748,
															2.035
														],
														[
															-4.289,
															2.28
														],
														[
															-0.167,
															0.075
														],
														[
															-0.16,
															0.451
														],
														[
															-1.045,
															0.665
														],
														[
															-0.988,
															0.419
														],
														[
															-0.852,
															0.559
														],
														[
															-0.812,
															0.695
														],
														[
															-8.038,
															5.88
														],
														[
															-7.233,
															6.768
														],
														[
															-1.169,
															1.367
														],
														[
															-0.998,
															1.389
														],
														[
															-0.327,
															0.42
														],
														[
															-0.586,
															0.287
														],
														[
															-0.597,
															0.781
														],
														[
															-0.448,
															1.1
														],
														[
															-0.232,
															0.311
														],
														[
															-0.371,
															0.335
														],
														[
															-0.84,
															1.029
														],
														[
															-0.916,
															1.363
														],
														[
															-1.087,
															1.135
														],
														[
															-0.804,
															1.187
														],
														[
															-1.326,
															2.124
														],
														[
															-1.147,
															1.777
														],
														[
															-0.616,
															1.003
														],
														[
															-0.26,
															0.809
														],
														[
															-0.079,
															0.177
														],
														[
															-0.451,
															0.153
														],
														[
															-1.049,
															1.882
														],
														[
															-0.978,
															2.033
														],
														[
															-1.072,
															2.051
														],
														[
															-0.985,
															2.212
														],
														[
															-6.053,
															12.872
														],
														[
															-4.874,
															13.51
														],
														[
															-4.547,
															19.877
														],
														[
															-2.389,
															23.001
														],
														[
															2.053,
															43.108
														],
														[
															10.966,
															35.883
														],
														[
															0.669,
															1.072
														],
														[
															0.728,
															1.373
														],
														[
															0.401,
															0.419
														],
														[
															0.298,
															0.539
														],
														[
															1.135,
															1.185
														],
														[
															0.744,
															1.163
														],
														[
															0.651,
															0.851
														],
														[
															0.674,
															0.824
														],
														[
															2.889,
															3.776
														],
														[
															2.807,
															3.281
														],
														[
															3.06,
															3.293
														],
														[
															12.01,
															12.01
														],
														[
															13.943,
															8.462
														],
														[
															9.859,
															2.494
														],
														[
															9.957,
															0.759
														],
														[
															2.625,
															-2.4
														],
														[
															2.623,
															-2.686
														],
														[
															0.377,
															-0.085
														],
														[
															1.239,
															-0.346
														],
														[
															0.381,
															-0.086
														],
														[
															21.382,
															-6.7
														],
														[
															14.353,
															-10.102
														],
														[
															3.477,
															-3.86
														],
														[
															1.718,
															-1.836
														],
														[
															1.841,
															-1.968
														],
														[
															6.078,
															-7.452
														],
														[
															21.618,
															-36.233
														],
														[
															1.487,
															-7.315
														],
														[
															5.072,
															-31.321
														],
														[
															-2.048,
															-48.6
														],
														[
															-1.701,
															-4.474
														],
														[
															-7.698,
															-18.266
														],
														[
															-1.832,
															-2.861
														],
														[
															-0.726,
															-0.758
														],
														[
															-2.293,
															-3.223
														],
														[
															-0.611,
															-0.806
														],
														[
															-2.006,
															-2.934
														],
														[
															-0.631,
															-0.747
														],
														[
															-2.155,
															-2.766
														],
														[
															-5.927,
															-6.422
														],
														[
															-7.788,
															-6.876
														],
														[
															-1.991,
															-1.387
														],
														[
															-7.262,
															-4.439
														],
														[
															-1.983,
															-0.913
														],
														[
															-2.234,
															-0.926
														],
														[
															-22.488,
															-8.235
														],
														[
															-0.625,
															0.043
														]
													],
													"v": [
														[
															345,
															16
														],
														[
															344.001,
															16.02
														],
														[
															343,
															16
														],
														[
															318.616,
															19.357
														],
														[
															298,
															26
														],
														[
															292.503,
															28.131
														],
														[
															288,
															30
														],
														[
															274.511,
															36.641
														],
														[
															262,
															43
														],
														[
															261.519,
															43.964
														],
														[
															261,
															45
														],
														[
															257.97,
															46.503
														],
														[
															255,
															48
														],
														[
															252.537,
															49.925
														],
														[
															250,
															52
														],
														[
															226.993,
															71.123
														],
														[
															207,
															92
														],
														[
															203.752,
															96.218
														],
														[
															201,
															100
														],
														[
															199.502,
															100.992
														],
														[
															198,
															102
														],
														[
															196.511,
															104.972
														],
														[
															195,
															108
														],
														[
															194.038,
															108.973
														],
														[
															193,
															110
														],
														[
															190.242,
															113.884
														],
														[
															188,
															117
														],
														[
															185.208,
															120.512
														],
														[
															183,
															124
														],
														[
															179.321,
															129.767
														],
														[
															176,
															135
														],
														[
															174.796,
															137.681
														],
														[
															174,
															140
														],
														[
															173.028,
															140.475
														],
														[
															172,
															141
														],
														[
															168.991,
															146.922
														],
														[
															166,
															153
														],
														[
															162.937,
															159.462
														],
														[
															160,
															166
														],
														[
															143.549,
															205.337
														],
														[
															131,
															248
														],
														[
															120.264,
															313.069
														],
														[
															118,
															383
														],
														[
															138.228,
															501.811
														],
														[
															181,
															597
														],
														[
															183.189,
															600.977
														],
														[
															185,
															604
														],
														[
															185.995,
															605.495
														],
														[
															187,
															607
														],
														[
															189.684,
															610.517
														],
														[
															192,
															614
														],
														[
															193.999,
															616.499
														],
														[
															196,
															619
														],
														[
															204.506,
															629.505
														],
														[
															213,
															639
														],
														[
															222,
															649
														],
														[
															263,
															682
														],
														[
															315,
															704
														],
														[
															347,
															709
														],
														[
															387,
															707
														],
														[
															393,
															696
														],
														[
															406,
															693
														],
														[
															409,
															691
														],
														[
															413,
															691
														],
														[
															416,
															689
														],
														[
															469,
															662
														],
														[
															507,
															629
														],
														[
															517,
															617
														],
														[
															521,
															612
														],
														[
															525,
															607
														],
														[
															542,
															583
														],
														[
															592,
															455
														],
														[
															596,
															432
														],
														[
															602,
															330
														],
														[
															573,
															191
														],
														[
															568,
															178
														],
														[
															540,
															125
														],
														[
															534,
															116
														],
														[
															533,
															114
														],
														[
															525,
															105
														],
														[
															524,
															102
														],
														[
															517,
															95
														],
														[
															516,
															92
														],
														[
															509,
															85
														],
														[
															491,
															67
														],
														[
															466,
															47
														],
														[
															460,
															44
														],
														[
															438,
															31
														],
														[
															431,
															29
														],
														[
															425,
															26
														],
														[
															346,
															15
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 16,
											"s": [
												{
													"i": [
														[
															-0.052,
															0.004
														],
														[
															2.713,
															-0.35
														],
														[
															2.593,
															-0.483
														],
														[
															2.584,
															-0.642
														],
														[
															2.684,
															-0.826
														],
														[
															3.869,
															-1.509
														],
														[
															3.577,
															-1.694
														],
														[
															3.295,
															-1.838
														],
														[
															3.023,
															-1.943
														],
														[
															0.413,
															-0.331
														],
														[
															0.399,
															-0.348
														],
														[
															0.412,
															-0.344
														],
														[
															0.451,
															-0.316
														],
														[
															0.512,
															-0.243
														],
														[
															0.535,
															-0.221
														],
														[
															0.505,
															-0.243
														],
														[
															0.423,
															-0.308
														],
														[
															0.163,
															-0.165
														],
														[
															0.17,
															-0.188
														],
														[
															0.172,
															-0.179
														],
														[
															0.169,
															-0.138
														],
														[
															1.018,
															-0.925
														],
														[
															0.963,
															-0.921
														],
														[
															0.963,
															-0.911
														],
														[
															1.02,
															-0.895
														],
														[
															0.337,
															-0.073
														],
														[
															0.352,
															-0.067
														],
														[
															0.322,
															-0.225
														],
														[
															1.22,
															-1.309
														],
														[
															0.878,
															-0.894
														],
														[
															1.263,
															-1.708
														],
														[
															1.438,
															-1.63
														],
														[
															2.29,
															-2.334
														],
														[
															1.697,
															-2.234
														],
														[
															0.083,
															-0.521
														],
														[
															0.336,
															-0.481
														],
														[
															0.6,
															-0.29
														],
														[
															0.308,
															-0.422
														],
														[
															0.45,
															-1.08
														],
														[
															0.584,
															-0.832
														],
														[
															0.684,
															-0.792
														],
														[
															0.571,
															-0.846
														],
														[
															9.681,
															-23.285
														],
														[
															5.906,
															-27.063
														],
														[
															0.766,
															-33.734
														],
														[
															-4.897,
															-30.748
														],
														[
															-9.507,
															-26.354
														],
														[
															-13.999,
															-22.359
														],
														[
															-10.863,
															-12.148
														],
														[
															-12.186,
															-9.056
														],
														[
															-0.52,
															-0.085
														],
														[
															-0.48,
															-0.336
														],
														[
															-0.289,
															-0.605
														],
														[
															-0.43,
															-0.29
														],
														[
															-1.017,
															-0.438
														],
														[
															-1.099,
															-0.686
														],
														[
															-0.554,
															-0.257
														],
														[
															-0.832,
															-0.375
														],
														[
															-0.155,
															-0.451
														],
														[
															-0.206,
															-0.119
														],
														[
															-1.046,
															-0.508
														],
														[
															-0.959,
															-0.476
														],
														[
															-13.433,
															-3.544
														],
														[
															-15.728,
															0.404
														],
														[
															-3.37,
															0.088
														],
														[
															-1.589,
															0.572
														],
														[
															-0.766,
															1.153
														],
														[
															-1.253,
															1.783
														],
														[
															-0.234,
															0.893
														],
														[
															-0.354,
															0.414
														],
														[
															-0.748,
															0.105
														],
														[
															-1.225,
															0.666
														],
														[
															-2.216,
															0.558
														],
														[
															-2.149,
															0.686
														],
														[
															-3.002,
															1.177
														],
														[
															-2.678,
															1.236
														],
														[
															-9.209,
															6.598
														],
														[
															-8.579,
															8.264
														],
														[
															-10,
															14.061
														],
														[
															-7.229,
															14.38
														],
														[
															-5.831,
															17.367
														],
														[
															-4.058,
															19.383
														],
														[
															-1.693,
															21.167
														],
														[
															0.734,
															23.401
														],
														[
															7.832,
															30.95
														],
														[
															11.619,
															23.674
														],
														[
															14.115,
															17.924
														],
														[
															19.149,
															13.13
														],
														[
															18.228,
															5.587
														],
														[
															22.512,
															-1.656
														],
														[
															0.185,
															-0.245
														]
													],
													"o": [
														[
															-2.943,
															0.242
														],
														[
															-2.713,
															0.35
														],
														[
															-2.593,
															0.483
														],
														[
															-2.584,
															0.642
														],
														[
															-4.171,
															1.283
														],
														[
															-3.869,
															1.509
														],
														[
															-3.577,
															1.694
														],
														[
															-3.295,
															1.838
														],
														[
															-0.452,
															0.29
														],
														[
															-0.413,
															0.331
														],
														[
															-0.399,
															0.348
														],
														[
															-0.412,
															0.344
														],
														[
															-0.438,
															0.307
														],
														[
															-0.512,
															0.243
														],
														[
															-0.535,
															0.221
														],
														[
															-0.505,
															0.243
														],
														[
															-0.151,
															0.11
														],
														[
															-0.163,
															0.165
														],
														[
															-0.17,
															0.188
														],
														[
															-0.172,
															0.179
														],
														[
															-1.13,
															0.922
														],
														[
															-1.018,
															0.925
														],
														[
															-0.963,
															0.921
														],
														[
															-0.963,
															0.911
														],
														[
															-0.277,
															0.243
														],
														[
															-0.337,
															0.073
														],
														[
															-0.352,
															0.067
														],
														[
															-1.242,
															0.867
														],
														[
															-1.22,
															1.31
														],
														[
															-1.51,
															1.539
														],
														[
															-1.263,
															1.708
														],
														[
															-2.142,
															2.43
														],
														[
															-2.29,
															2.334
														],
														[
															-0.331,
															0.436
														],
														[
															-0.083,
															0.521
														],
														[
															-0.291,
															0.416
														],
														[
															-0.6,
															0.29
														],
														[
															-0.618,
															0.848
														],
														[
															-0.45,
															1.08
														],
														[
															-0.692,
															0.987
														],
														[
															-0.684,
															0.792
														],
														[
															-13.37,
															19.799
														],
														[
															-9.681,
															23.285
														],
														[
															-6.834,
															31.317
														],
														[
															-0.766,
															33.734
														],
														[
															4.972,
															31.226
														],
														[
															9.507,
															26.354
														],
														[
															8.361,
															13.353
														],
														[
															10.863,
															12.148
														],
														[
															0.438,
															0.325
														],
														[
															0.521,
															0.085
														],
														[
															0.414,
															0.289
														],
														[
															0.289,
															0.605
														],
														[
															0.832,
															0.561
														],
														[
															1.017,
															0.438
														],
														[
															0.954,
															0.596
														],
														[
															0.553,
															0.257
														],
														[
															0.174,
															0.079
														],
														[
															0.155,
															0.451
														],
														[
															0.855,
															0.494
														],
														[
															1.046,
															0.508
														],
														[
															10.538,
															5.227
														],
														[
															13.434,
															3.544
														],
														[
															2.932,
															-0.075
														],
														[
															3.37,
															-0.088
														],
														[
															1.683,
															-0.606
														],
														[
															0.766,
															-1.153
														],
														[
															0.712,
															-1.013
														],
														[
															0.234,
															-0.893
														],
														[
															0.782,
															-0.916
														],
														[
															0.748,
															-0.105
														],
														[
															1.987,
															-1.081
														],
														[
															2.216,
															-0.558
														],
														[
															3.312,
															-1.058
														],
														[
															3.002,
															-1.177
														],
														[
															11.585,
															-5.346
														],
														[
															9.209,
															-6.598
														],
														[
															10.771,
															-10.375
														],
														[
															10,
															-14.061
														],
														[
															7.616,
															-15.148
														],
														[
															5.831,
															-17.367
														],
														[
															3.964,
															-18.929
														],
														[
															1.693,
															-21.168
														],
														[
															-1.052,
															-33.525
														],
														[
															-7.832,
															-30.95
														],
														[
															-10.392,
															-21.175
														],
														[
															-14.115,
															-17.924
														],
														[
															-13.577,
															-9.309
														],
														[
															-18.228,
															-5.587
														],
														[
															-0.312,
															0.023
														],
														[
															-0.185,
															0.245
														]
													],
													"v": [
														[
															346,
															16
														],
														[
															337.544,
															16.88
														],
														[
															329.612,
															18.123
														],
														[
															321.875,
															19.804
														],
														[
															314,
															22
														],
														[
															301.944,
															26.198
														],
														[
															290.779,
															31.011
														],
														[
															280.474,
															36.318
														],
														[
															271,
															42
														],
														[
															269.71,
															42.937
														],
														[
															268.499,
															43.961
														],
														[
															267.288,
															45.005
														],
														[
															266,
															46
														],
														[
															264.561,
															46.814
														],
														[
															262.977,
															47.499
														],
														[
															261.405,
															48.185
														],
														[
															260,
															49
														],
														[
															259.528,
															49.42
														],
														[
															259.027,
															49.958
														],
														[
															258.513,
															50.516
														],
														[
															258,
															51
														],
														[
															254.791,
															53.771
														],
														[
															251.834,
															56.541
														],
														[
															248.96,
															59.29
														],
														[
															246,
															62
														],
														[
															245.067,
															62.434
														],
														[
															244.022,
															62.603
														],
														[
															243,
															63
														],
														[
															239.227,
															66.48
														],
														[
															236,
															70
														],
														[
															231.945,
															74.931
														],
														[
															228,
															80
														],
														[
															221.166,
															87.147
														],
														[
															215,
															94
														],
														[
															214.504,
															95.466
														],
														[
															214,
															97
														],
														[
															212.513,
															97.996
														],
														[
															211,
															99
														],
														[
															209.474,
															102.012
														],
														[
															208,
															105
														],
														[
															205.909,
															107.606
														],
														[
															204,
															110
														],
														[
															169.402,
															174.552
														],
														[
															146,
															250
														],
														[
															134.702,
															348.927
														],
														[
															141,
															447
														],
														[
															162.731,
															533.15
														],
														[
															198,
															606
														],
														[
															227.13,
															644.723
														],
														[
															262,
															677
														],
														[
															263.468,
															677.493
														],
														[
															265,
															678
														],
														[
															265.988,
															679.5
														],
														[
															267,
															681
														],
														[
															269.8,
															682.407
														],
														[
															273,
															684
														],
														[
															275.092,
															685.165
														],
														[
															277,
															686
														],
														[
															277.477,
															686.97
														],
														[
															278,
															688
														],
														[
															280.922,
															689.514
														],
														[
															284,
															691
														],
														[
															320.107,
															704.724
														],
														[
															364,
															710
														],
														[
															374.008,
															709.872
														],
														[
															382,
															709
														],
														[
															385.323,
															706.383
														],
														[
															388,
															702
														],
														[
															389.268,
															699.052
														],
														[
															390,
															697
														],
														[
															392.168,
															695.813
														],
														[
															395,
															695
														],
														[
															401.378,
															692.704
														],
														[
															408,
															691
														],
														[
															417.476,
															687.634
														],
														[
															426,
															684
														],
														[
															456.755,
															666.188
														],
														[
															483,
															644
														],
														[
															514.656,
															606.503
														],
														[
															541,
															563
														],
														[
															561.168,
															514.176
														],
														[
															576,
															459
														],
														[
															584.523,
															398.854
														],
														[
															586,
															332
														],
														[
															571.926,
															234.112
														],
														[
															542,
															151
														],
														[
															505.568,
															91.966
														],
														[
															456,
															45
														],
														[
															408.202,
															21.777
														],
														[
															347,
															15
														],
														[
															346.227,
															15.52
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 17,
											"s": [
												{
													"i": [
														[
															30.229,
															-2.672
														],
														[
															0.336,
															0.007
														],
														[
															0.328,
															0.001
														],
														[
															9.035,
															-3.148
														],
														[
															7.674,
															-4.424
														],
														[
															9.174,
															-8.202
														],
														[
															7.716,
															-9.513
														],
														[
															2.507,
															-3.309
														],
														[
															2.303,
															-3.472
														],
														[
															2.615,
															-4.176
														],
														[
															2.05,
															-3.541
														],
														[
															3.419,
															-7.471
														],
														[
															3.047,
															-7.729
														],
														[
															5.904,
															-36.089
														],
														[
															-1.618,
															-34.735
														],
														[
															-0.062,
															-5.693
														],
														[
															-0.49,
															-5.643
														],
														[
															-1.555,
															-10.175
														],
														[
															-1.843,
															-9.526
														],
														[
															-1.216,
															-4.636
														],
														[
															-1.203,
															-4.639
														],
														[
															-1.092,
															-4.682
														],
														[
															-1.394,
															-4.495
														],
														[
															-2.13,
															-5.292
														],
														[
															-1.863,
															-4.615
														],
														[
															-0.786,
															-2.143
														],
														[
															-0.95,
															-2.178
														],
														[
															-0.531,
															-1.015
														],
														[
															-0.433,
															-0.928
														],
														[
															-3.255,
															-5.715
														],
														[
															-3.115,
															-4.997
														],
														[
															-0.462,
															-1.05
														],
														[
															-0.568,
															-0.865
														],
														[
															-1.84,
															-2.443
														],
														[
															-1.839,
															-2.486
														],
														[
															-0.695,
															-0.844
														],
														[
															-0.612,
															-0.806
														],
														[
															-0.083,
															-0.521
														],
														[
															-0.336,
															-0.481
														],
														[
															-0.594,
															-0.294
														],
														[
															-0.331,
															-0.406
														],
														[
															-2.608,
															-3.234
														],
														[
															-2.986,
															-2.899
														],
														[
															-1.218,
															-0.779
														],
														[
															-0.933,
															-0.726
														],
														[
															-0.292,
															-0.579
														],
														[
															-0.412,
															-0.356
														],
														[
															-16.917,
															-7.361
														],
														[
															-22.616,
															0.581
														],
														[
															-3.216,
															0.1
														],
														[
															-1.35,
															0.529
														],
														[
															-1.001,
															2.306
														],
														[
															-1.425,
															1.767
														],
														[
															-1.858,
															0.445
														],
														[
															-2.325,
															0.677
														],
														[
															-1.033,
															0.353
														],
														[
															-0.78,
															0.271
														],
														[
															-5.942,
															3.195
														],
														[
															-4.811,
															2.99
														],
														[
															-1.166,
															0.859
														],
														[
															-1.046,
															0.761
														],
														[
															-1.444,
															1.371
														],
														[
															-1.565,
															1.307
														],
														[
															-0.847,
															0.406
														],
														[
															-0.827,
															0.721
														],
														[
															-0.673,
															0.701
														],
														[
															-0.649,
															0.623
														],
														[
															-11.771,
															18.823
														],
														[
															-8.074,
															20.449
														],
														[
															-1.535,
															4.021
														],
														[
															-1.367,
															4.13
														],
														[
															-1.618,
															6.649
														],
														[
															-1.477,
															6.209
														],
														[
															-0.765,
															2.185
														],
														[
															-0.435,
															2.137
														],
														[
															-0.283,
															2.332
														],
														[
															-0.414,
															2.438
														],
														[
															-0.57,
															2.361
														],
														[
															-0.341,
															2.32
														],
														[
															0.6,
															31.291
														],
														[
															4.936,
															27.307
														],
														[
															20.52,
															35.443
														],
														[
															0.388,
															0.695
														],
														[
															2.092,
															3.457
														],
														[
															0.915,
															1.418
														],
														[
															1.418,
															1.855
														],
														[
															0.603,
															0.856
														],
														[
															3.268,
															4.273
														],
														[
															0.58,
															0.716
														],
														[
															9.494,
															7.922
														],
														[
															10.569,
															5.532
														]
													],
													"o": [
														[
															-0.327,
															0.029
														],
														[
															-0.336,
															-0.007
														],
														[
															-9.188,
															-0.016
														],
														[
															-9.034,
															3.148
														],
														[
															-11.589,
															6.68
														],
														[
															-9.174,
															8.202
														],
														[
															-2.671,
															3.292
														],
														[
															-2.507,
															3.309
														],
														[
															-2.491,
															3.756
														],
														[
															-2.615,
															4.176
														],
														[
															-4.278,
															7.389
														],
														[
															-3.419,
															7.471
														],
														[
															-11.003,
															27.911
														],
														[
															-5.904,
															36.089
														],
														[
															0.26,
															5.584
														],
														[
															0.062,
															5.693
														],
														[
															0.935,
															10.772
														],
														[
															1.555,
															10.175
														],
														[
															0.932,
															4.818
														],
														[
															1.216,
															4.636
														],
														[
															1.239,
															4.779
														],
														[
															1.092,
															4.682
														],
														[
															1.617,
															5.216
														],
														[
															2.13,
															5.292
														],
														[
															0.908,
															2.248
														],
														[
															0.786,
															2.143
														],
														[
															0.442,
															1.013
														],
														[
															0.531,
															1.015
														],
														[
															2.865,
															6.141
														],
														[
															3.255,
															5.715
														],
														[
															0.584,
															0.936
														],
														[
															0.462,
															1.05
														],
														[
															1.8,
															2.741
														],
														[
															1.84,
															2.443
														],
														[
															0.606,
															0.82
														],
														[
															0.696,
															0.844
														],
														[
															0.331,
															0.436
														],
														[
															0.083,
															0.521
														],
														[
															0.291,
															0.417
														],
														[
															0.595,
															0.294
														],
														[
															2.584,
															3.164
														],
														[
															2.608,
															3.234
														],
														[
															1.194,
															1.159
														],
														[
															1.218,
															0.779
														],
														[
															0.422,
															0.328
														],
														[
															0.292,
															0.579
														],
														[
															11.714,
															10.137
														],
														[
															16.917,
															7.361
														],
														[
															2.786,
															-0.072
														],
														[
															3.216,
															-0.1
														],
														[
															2.572,
															-1.009
														],
														[
															1.001,
															-2.306
														],
														[
															1.245,
															-1.544
														],
														[
															1.858,
															-0.445
														],
														[
															1.088,
															-0.317
														],
														[
															1.033,
															-0.353
														],
														[
															6.421,
															-2.229
														],
														[
															5.942,
															-3.195
														],
														[
															1.291,
															-0.803
														],
														[
															1.166,
															-0.859
														],
														[
															1.659,
															-1.207
														],
														[
															1.444,
															-1.371
														],
														[
															0.783,
															-0.654
														],
														[
															0.848,
															-0.406
														],
														[
															0.658,
															-0.573
														],
														[
															0.673,
															-0.701
														],
														[
															14.841,
															-14.258
														],
														[
															11.771,
															-18.823
														],
														[
															1.495,
															-3.784
														],
														[
															1.535,
															-4.021
														],
														[
															2.05,
															-6.193
														],
														[
															1.618,
															-6.649
														],
														[
															0.505,
															-2.123
														],
														[
															0.765,
															-2.185
														],
														[
															0.455,
															-2.232
														],
														[
															0.283,
															-2.332
														],
														[
															0.38,
															-2.236
														],
														[
															0.57,
															-2.361
														],
														[
															4.334,
															-29.529
														],
														[
															-0.6,
															-31.291
														],
														[
															-9.06,
															-50.128
														],
														[
															-0.527,
															-0.91
														],
														[
															-1.934,
															-3.469
														],
														[
															-0.836,
															-1.381
														],
														[
															-1.872,
															-2.902
														],
														[
															-0.548,
															-0.717
														],
														[
															-3.781,
															-5.368
														],
														[
															-0.49,
															-0.641
														],
														[
															-8.316,
															-10.26
														],
														[
															-9.148,
															-7.633
														],
														[
															-21.908,
															-11.467
														]
													],
													"v": [
														[
															347,
															16
														],
														[
															346.001,
															16.022
														],
														[
															345,
															16
														],
														[
															317.365,
															21.17
														],
														[
															292,
															33
														],
														[
															261.096,
															55.375
														],
														[
															236,
															82
														],
														[
															228.224,
															91.865
														],
														[
															221,
															102
														],
														[
															213.17,
															114.161
														],
														[
															206,
															126
														],
														[
															194.577,
															148.245
														],
														[
															185,
															171
														],
														[
															159.034,
															269.382
														],
														[
															152,
															378
														],
														[
															152.327,
															394.957
														],
														[
															153,
															412
														],
														[
															156.819,
															443.434
														],
														[
															162,
															473
														],
														[
															165.297,
															487.134
														],
														[
															169,
															501
														],
														[
															172.384,
															515.213
														],
														[
															176,
															529
														],
														[
															181.815,
															544.95
														],
														[
															188,
															560
														],
														[
															190.469,
															566.553
														],
														[
															193,
															573
														],
														[
															194.506,
															576.064
														],
														[
															196,
															579
														],
														[
															205.312,
															596.858
														],
														[
															215,
															613
														],
														[
															216.512,
															616.054
														],
														[
															218,
															619
														],
														[
															223.471,
															626.692
														],
														[
															229,
															634
														],
														[
															230.995,
															636.51
														],
														[
															233,
															639
														],
														[
															233.496,
															640.466
														],
														[
															234,
															642
														],
														[
															235.47,
															643.008
														],
														[
															237,
															644
														],
														[
															244.698,
															653.698
														],
														[
															253,
															663
														],
														[
															256.696,
															665.825
														],
														[
															260,
															668
														],
														[
															261.007,
															669.479
														],
														[
															262,
															671
														],
														[
															304.823,
															698.538
														],
														[
															364,
															710
														],
														[
															373.577,
															709.843
														],
														[
															381,
															709
														],
														[
															385.86,
															703.569
														],
														[
															389,
															697
														],
														[
															393.69,
															694.35
														],
														[
															400,
															693
														],
														[
															403.231,
															691.966
														],
														[
															406,
															691
														],
														[
															424.707,
															682.571
														],
														[
															441,
															673
														],
														[
															444.684,
															670.469
														],
														[
															448,
															668
														],
														[
															452.571,
															664.075
														],
														[
															457,
															660
														],
														[
															459.467,
															658.55
														],
														[
															462,
															657
														],
														[
															464.006,
															655.037
														],
														[
															466,
															653
														],
														[
															506.075,
															602.643
														],
														[
															536,
															543
														],
														[
															540.596,
															531.259
														],
														[
															545,
															519
														],
														[
															550.429,
															499.512
														],
														[
															555,
															480
														],
														[
															557.053,
															473.511
														],
														[
															559,
															467
														],
														[
															560.03,
															460.154
														],
														[
															561,
															453
														],
														[
															562.53,
															446.063
														],
														[
															564,
															439
														],
														[
															569.452,
															346.334
														],
														[
															561,
															257
														],
														[
															516,
															125
														],
														[
															514,
															123
														],
														[
															509,
															112
														],
														[
															505,
															108
														],
														[
															501,
															100
														],
														[
															499,
															98
														],
														[
															487,
															81
														],
														[
															485,
															79
														],
														[
															456,
															50
														],
														[
															426,
															30
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 18,
											"s": [
												{
													"i": [
														[
															3.078,
															-0.329
														],
														[
															3.365,
															-0.647
														],
														[
															3.148,
															-0.868
														],
														[
															2.834,
															-1.038
														],
														[
															2.422,
															-1.154
														],
														[
															4.198,
															-2.6
														],
														[
															3.946,
															-2.964
														],
														[
															3.525,
															-3.132
														],
														[
															2.935,
															-3.104
														],
														[
															0.585,
															-0.743
														],
														[
															0.564,
															-0.775
														],
														[
															0.572,
															-0.77
														],
														[
															0.61,
															-0.726
														],
														[
															0.553,
															-0.54
														],
														[
															0.555,
															-0.509
														],
														[
															0.474,
															-0.465
														],
														[
															0.312,
															-0.408
														],
														[
															0.073,
															-0.347
														],
														[
															0.077,
															-0.352
														],
														[
															0.225,
															-0.294
														],
														[
															1.409,
															-1.446
														],
														[
															1.156,
															-1.642
														],
														[
															7.242,
															-14.835
														],
														[
															5.345,
															-15.317
														],
														[
															4.072,
															-17.663
														],
														[
															2.798,
															-20.262
														],
														[
															-0.489,
															-30.664
														],
														[
															-4.231,
															-27.026
														],
														[
															-7.797,
															-24.687
														],
														[
															-11.368,
															-20.871
														],
														[
															-9.218,
															-12.274
														],
														[
															-12.723,
															-10.306
														],
														[
															-6.724,
															-4.162
														],
														[
															-8.795,
															-3.053
														],
														[
															-4.644,
															-0.835
														],
														[
															-5.049,
															-0.49
														],
														[
															-6.688,
															0.003
														],
														[
															-2.143,
															1.387
														],
														[
															-0.738,
															2.288
														],
														[
															-0.659,
															0.95
														],
														[
															-1.721,
															0.44
														],
														[
															-1.969,
															0.589
														],
														[
															-1.122,
															0.374
														],
														[
															-0.651,
															0.245
														],
														[
															-4.667,
															2.879
														],
														[
															-3.966,
															2.466
														],
														[
															-0.529,
															0.101
														],
														[
															-0.449,
															0.325
														],
														[
															-1.049,
															1.166
														],
														[
															-0.721,
															0.551
														],
														[
															-0.557,
															0.093
														],
														[
															-0.384,
															0.331
														],
														[
															-1.318,
															1.387
														],
														[
															-1.351,
															1.265
														],
														[
															-3.094,
															3.157
														],
														[
															-1.821,
															2.745
														],
														[
															-0.815,
															1.139
														],
														[
															-0.88,
															1.149
														],
														[
															-2.657,
															3.629
														],
														[
															-1.834,
															3.168
														],
														[
															-0.483,
															0.788
														],
														[
															-0.437,
															0.755
														],
														[
															-0.483,
															0.788
														],
														[
															-0.437,
															0.755
														],
														[
															-0.599,
															1.288
														],
														[
															-0.706,
															1.296
														],
														[
															-1.88,
															3.494
														],
														[
															-1.582,
															3.542
														],
														[
															-5.44,
															18.236
														],
														[
															-3.724,
															20.236
														],
														[
															-1.673,
															19.387
														],
														[
															0,
															21.469
														],
														[
															2.645,
															21.716
														],
														[
															4.421,
															18.435
														],
														[
															0.486,
															2.203
														],
														[
															0.548,
															2.065
														],
														[
															1.4,
															3.954
														],
														[
															1.284,
															3.972
														],
														[
															2.481,
															6.98
														],
														[
															2.75,
															5.88
														],
														[
															0.489,
															1.322
														],
														[
															0.41,
															1.356
														],
														[
															0.459,
															0.393
														],
														[
															0.108,
															0.245
														],
														[
															1.27,
															2.52
														],
														[
															1.504,
															2.701
														],
														[
															10.704,
															13.287
														],
														[
															13.731,
															9.665
														],
														[
															9.837,
															4.235
														],
														[
															10.508,
															1.029
														],
														[
															5.398,
															-0.274
														]
													],
													"o": [
														[
															-3.485,
															0.372
														],
														[
															-3.365,
															0.647
														],
														[
															-3.148,
															0.868
														],
														[
															-2.834,
															1.038
														],
														[
															-4.281,
															2.041
														],
														[
															-4.198,
															2.6
														],
														[
															-3.946,
															2.964
														],
														[
															-3.525,
															3.132
														],
														[
															-0.635,
															0.672
														],
														[
															-0.585,
															0.743
														],
														[
															-0.564,
															0.775
														],
														[
															-0.572,
															0.77
														],
														[
															-0.469,
															0.558
														],
														[
															-0.553,
															0.54
														],
														[
															-0.555,
															0.509
														],
														[
															-0.474,
															0.465
														],
														[
															-0.212,
															0.277
														],
														[
															-0.073,
															0.347
														],
														[
															-0.077,
															0.352
														],
														[
															-1.207,
															1.575
														],
														[
															-1.409,
															1.446
														],
														[
															-8.686,
															12.34
														],
														[
															-7.242,
															14.836
														],
														[
															-4.916,
															14.088
														],
														[
															-4.072,
															17.663
														],
														[
															-4.186,
															30.316
														],
														[
															0.489,
															30.664
														],
														[
															4.443,
															28.38
														],
														[
															7.797,
															24.687
														],
														[
															7.407,
															13.6
														],
														[
															9.218,
															12.273
														],
														[
															5.31,
															4.301
														],
														[
															6.724,
															4.162
														],
														[
															3.375,
															1.171
														],
														[
															4.644,
															0.835
														],
														[
															4.103,
															0.399
														],
														[
															6.688,
															-0.003
														],
														[
															1.387,
															-0.898
														],
														[
															0.738,
															-2.288
														],
														[
															1.148,
															-1.652
														],
														[
															1.721,
															-0.44
														],
														[
															0.862,
															-0.257
														],
														[
															1.122,
															-0.374
														],
														[
															5.363,
															-2.019
														],
														[
															4.668,
															-2.879
														],
														[
															0.435,
															-0.271
														],
														[
															0.529,
															-0.101
														],
														[
															1.084,
															-0.784
														],
														[
															1.049,
															-1.166
														],
														[
															0.387,
															-0.295
														],
														[
															0.557,
															-0.093
														],
														[
															1.377,
															-1.188
														],
														[
															1.318,
															-1.387
														],
														[
															2.804,
															-2.627
														],
														[
															3.094,
															-3.157
														],
														[
															0.858,
															-1.294
														],
														[
															0.816,
															-1.139
														],
														[
															2.538,
															-3.317
														],
														[
															2.657,
															-3.629
														],
														[
															0.633,
															-1.093
														],
														[
															0.483,
															-0.788
														],
														[
															0.633,
															-1.093
														],
														[
															0.483,
															-0.788
														],
														[
															0.898,
															-1.552
														],
														[
															0.599,
															-1.288
														],
														[
															1.896,
															-3.481
														],
														[
															1.88,
															-3.494
														],
														[
															7.515,
															-16.819
														],
														[
															5.44,
															-18.236
														],
														[
															3.31,
															-17.984
														],
														[
															1.673,
															-19.387
														],
														[
															0,
															-21.702
														],
														[
															-2.645,
															-21.716
														],
														[
															-0.51,
															-2.124
														],
														[
															-0.486,
															-2.203
														],
														[
															-1.116,
															-4.212
														],
														[
															-1.4,
															-3.954
														],
														[
															-2.328,
															-7.2
														],
														[
															-2.481,
															-6.98
														],
														[
															-0.635,
															-1.356
														],
														[
															-0.489,
															-1.322
														],
														[
															-0.055,
															-0.181
														],
														[
															-0.459,
															-0.393
														],
														[
															-1.416,
															-3.221
														],
														[
															-1.27,
															-2.52
														],
														[
															-8.456,
															-15.189
														],
														[
															-10.703,
															-13.287
														],
														[
															-7.145,
															-5.029
														],
														[
															-9.837,
															-4.235
														],
														[
															-4.331,
															-0.425
														],
														[
															-5.398,
															0.274
														]
													],
													"v": [
														[
															347,
															16
														],
														[
															336.7,
															17.542
														],
														[
															326.905,
															19.827
														],
														[
															317.907,
															22.699
														],
														[
															310,
															26
														],
														[
															297.24,
															33.011
														],
														[
															284.981,
															41.405
														],
														[
															273.732,
															50.597
														],
														[
															264,
															60
														],
														[
															262.177,
															62.132
														],
														[
															260.462,
															64.419
														],
														[
															258.766,
															66.747
														],
														[
															257,
															69
														],
														[
															255.447,
															70.65
														],
														[
															253.764,
															72.225
														],
														[
															252.2,
															73.688
														],
														[
															251,
															75
														],
														[
															250.608,
															75.952
														],
														[
															250.418,
															77.016
														],
														[
															250,
															78
														],
														[
															245.962,
															82.449
														],
														[
															242,
															87
														],
														[
															217.994,
															128.267
														],
														[
															199,
															174
														],
														[
															185.411,
															221.87
														],
														[
															175,
															279
														],
														[
															169.687,
															371.467
														],
														[
															177,
															459
														],
														[
															195.306,
															538.632
														],
														[
															224,
															607
														],
														[
															248.513,
															645.971
														],
														[
															281,
															680
														],
														[
															298.886,
															692.936
														],
														[
															322,
															704
														],
														[
															334.244,
															707.011
														],
														[
															349,
															709
														],
														[
															366.97,
															709.839
														],
														[
															382,
															708
														],
														[
															385.046,
															702.539
														],
														[
															387,
															697
														],
														[
															391.384,
															694.202
														],
														[
															397,
															693
														],
														[
															400.158,
															691.991
														],
														[
															403,
															691
														],
														[
															418.048,
															683.335
														],
														[
															431,
															675
														],
														[
															432.49,
															674.541
														],
														[
															434,
															674
														],
														[
															437.273,
															670.825
														],
														[
															440,
															668
														],
														[
															441.502,
															667.527
														],
														[
															443,
															667
														],
														[
															447.02,
															663.058
														],
														[
															451,
															659
														],
														[
															460.238,
															650.089
														],
														[
															468,
															641
														],
														[
															470.484,
															637.392
														],
														[
															473,
															634
														],
														[
															481.028,
															623.388
														],
														[
															488,
															613
														],
														[
															489.647,
															610.246
														],
														[
															491,
															608
														],
														[
															492.647,
															605.246
														],
														[
															494,
															603
														],
														[
															496.144,
															598.808
														],
														[
															498,
															595
														],
														[
															503.735,
															584.545
														],
														[
															509,
															574
														],
														[
															528.344,
															521.563
														],
														[
															542,
															464
														],
														[
															549.482,
															408.114
														],
														[
															552,
															347
														],
														[
															547.816,
															281.05
														],
														[
															537,
															220
														],
														[
															535.529,
															213.456
														],
														[
															534,
															207
														],
														[
															530.126,
															194.82
														],
														[
															526,
															183
														],
														[
															518.816,
															161.51
														],
														[
															511,
															142
														],
														[
															509.332,
															138
														],
														[
															508,
															134
														],
														[
															507.04,
															133.048
														],
														[
															506,
															132
														],
														[
															502.066,
															123.61
														],
														[
															498,
															116
														],
														[
															469.456,
															72.857
														],
														[
															433,
															38
														],
														[
															407.022,
															23.5
														],
														[
															376,
															15
														],
														[
															360.56,
															14.935
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 19,
											"s": [
												{
													"i": [
														[
															2.678,
															-0.309
														],
														[
															3.905,
															-0.968
														],
														[
															3.464,
															-1.322
														],
														[
															3.077,
															-1.568
														],
														[
															2.744,
															-1.706
														],
														[
															0.164,
															-0.172
														],
														[
															0.172,
															-0.2
														],
														[
															0.171,
															-0.178
														],
														[
															0.164,
															-0.106
														],
														[
															0.712,
															-0.313
														],
														[
															0.654,
															-0.293
														],
														[
															0.53,
															-0.396
														],
														[
															0.462,
															-0.771
														],
														[
															0.608,
															-0.509
														],
														[
															0.568,
															-0.104
														],
														[
															0.353,
															-0.27
														],
														[
															1.42,
															-1.776
														],
														[
															1.517,
															-1.517
														],
														[
															2.912,
															-2.938
														],
														[
															1.76,
															-2.654
														],
														[
															0.464,
															-0.844
														],
														[
															0.511,
															-0.668
														],
														[
															0.358,
															-0.309
														],
														[
															0.3,
															-0.412
														],
														[
															3.871,
															-6.426
														],
														[
															3.161,
															-6.319
														],
														[
															7.893,
															-30.07
														],
														[
															3.537,
															-34.95
														],
														[
															-3.879,
															-42.283
														],
														[
															-9.935,
															-33.907
														],
														[
															-1.331,
															-4.668
														],
														[
															-1.459,
															-3.164
														],
														[
															-0.677,
															-2.049
														],
														[
															-0.509,
															-1.104
														],
														[
															-0.716,
															-1.359
														],
														[
															-0.461,
															-1.1
														],
														[
															-2.282,
															-5.388
														],
														[
															-2.46,
															-4.7
														],
														[
															-1.066,
															-1.458
														],
														[
															-0.892,
															-1.553
														],
														[
															-0.753,
															-1.675
														],
														[
															-1.017,
															-1.61
														],
														[
															-0.4,
															-0.341
														],
														[
															-0.209,
															-0.336
														],
														[
															-0.098,
															-0.517
														],
														[
															-0.326,
															-0.479
														],
														[
															-0.766,
															-0.656
														],
														[
															-0.483,
															-0.711
														],
														[
															-0.246,
															-0.88
														],
														[
															-0.512,
															-0.736
														],
														[
															-0.724,
															-0.621
														],
														[
															-0.56,
															-0.731
														],
														[
															-1.474,
															-1.772
														],
														[
															-0.818,
															-1.234
														],
														[
															-0.319,
															-0.266
														],
														[
															-0.38,
															-0.416
														],
														[
															-7.496,
															-5.905
														],
														[
															-11.885,
															-4.586
														],
														[
															-6.451,
															-1.273
														],
														[
															-7,
															0.096
														],
														[
															-2.847,
															0.115
														],
														[
															-1.159,
															0.505
														],
														[
															-0.882,
															2.549
														],
														[
															-1.512,
															1.512
														],
														[
															-1.636,
															0.62
														],
														[
															-1.534,
															0.594
														],
														[
															-12.457,
															12.254
														],
														[
															-9.884,
															16.288
														],
														[
															-8.458,
															69.972
														],
														[
															13.962,
															68.108
														],
														[
															5.469,
															16.963
														],
														[
															6.447,
															14.201
														],
														[
															1.672,
															3.334
														],
														[
															1.707,
															3.127
														],
														[
															1.854,
															2.978
														],
														[
															1.725,
															2.686
														],
														[
															0.259,
															0.878
														],
														[
															0.43,
															0.655
														],
														[
															0.746,
															0.631
														],
														[
															0.534,
															0.743
														],
														[
															0.966,
															1.532
														],
														[
															1.056,
															1.371
														],
														[
															1.185,
															1.317
														],
														[
															1.171,
															1.32
														],
														[
															6.736,
															5.931
														],
														[
															7.458,
															3.959
														],
														[
															2.425,
															0.837
														],
														[
															1.389,
															0.64
														],
														[
															3.667,
															1.06
														],
														[
															3.267,
															0.349
														],
														[
															4.809,
															-0.309
														]
													],
													"o": [
														[
															-4.399,
															0.507
														],
														[
															-3.905,
															0.968
														],
														[
															-3.464,
															1.322
														],
														[
															-3.077,
															1.568
														],
														[
															-0.15,
															0.093
														],
														[
															-0.164,
															0.172
														],
														[
															-0.172,
															0.2
														],
														[
															-0.171,
															0.178
														],
														[
															-0.704,
															0.454
														],
														[
															-0.712,
															0.313
														],
														[
															-0.654,
															0.293
														],
														[
															-0.543,
															0.405
														],
														[
															-0.462,
															0.772
														],
														[
															-0.374,
															0.313
														],
														[
															-0.568,
															0.104
														],
														[
															-1.803,
															1.379
														],
														[
															-1.42,
															1.776
														],
														[
															-2.593,
															2.593
														],
														[
															-2.912,
															2.938
														],
														[
															-0.634,
															0.954
														],
														[
															-0.464,
															0.844
														],
														[
															-0.268,
															0.35
														],
														[
															-0.358,
															0.309
														],
														[
															-4.353,
															5.977
														],
														[
															-3.871,
															6.426
														],
														[
															-12.892,
															25.769
														],
														[
															-7.892,
															30.07
														],
														[
															-4.45,
															43.96
														],
														[
															3.879,
															42.283
														],
														[
															1.219,
															4.161
														],
														[
															1.331,
															4.668
														],
														[
															0.783,
															1.699
														],
														[
															0.677,
															2.049
														],
														[
															0.675,
															1.464
														],
														[
															0.716,
															1.359
														],
														[
															2.41,
															5.747
														],
														[
															2.282,
															5.388
														],
														[
															0.845,
															1.615
														],
														[
															1.066,
															1.458
														],
														[
															0.971,
															1.691
														],
														[
															0.753,
															1.675
														],
														[
															0.191,
															0.303
														],
														[
															0.4,
															0.341
														],
														[
															0.281,
															0.452
														],
														[
															0.098,
															0.517
														],
														[
															0.453,
															0.667
														],
														[
															0.766,
															0.656
														],
														[
															0.505,
															0.743
														],
														[
															0.246,
															0.88
														],
														[
															0.546,
															0.785
														],
														[
															0.724,
															0.621
														],
														[
															1.287,
															1.679
														],
														[
															1.474,
															1.772
														],
														[
															0.344,
															0.519
														],
														[
															0.319,
															0.266
														],
														[
															7.13,
															7.795
														],
														[
															7.496,
															5.905
														],
														[
															5.197,
															2.005
														],
														[
															6.451,
															1.273
														],
														[
															2.452,
															-0.034
														],
														[
															2.847,
															-0.115
														],
														[
															2.961,
															-1.29
														],
														[
															0.882,
															-2.55
														],
														[
															0.924,
															-0.924
														],
														[
															1.636,
															-0.62
														],
														[
															17.287,
															-6.697
														],
														[
															12.457,
															-12.254
														],
														[
															29.132,
															-48.003
														],
														[
															8.458,
															-69.972
														],
														[
															-3.679,
															-17.948
														],
														[
															-5.469,
															-16.963
														],
														[
															-1.606,
															-3.536
														],
														[
															-1.672,
															-3.334
														],
														[
															-1.858,
															-3.403
														],
														[
															-1.854,
															-2.978
														],
														[
															-0.534,
															-0.832
														],
														[
															-0.259,
															-0.878
														],
														[
															-0.482,
															-0.734
														],
														[
															-0.746,
															-0.631
														],
														[
															-1.078,
															-1.501
														],
														[
															-0.966,
															-1.532
														],
														[
															-1.087,
															-1.412
														],
														[
															-1.185,
															-1.317
														],
														[
															-5.599,
															-6.316
														],
														[
															-6.736,
															-5.931
														],
														[
															-1.909,
															-1.014
														],
														[
															-2.425,
															-0.837
														],
														[
															-3.063,
															-1.412
														],
														[
															-3.667,
															-1.06
														],
														[
															-5.086,
															-0.544
														],
														[
															-4.809,
															0.309
														]
													],
													"v": [
														[
															348,
															16
														],
														[
															335.557,
															18.239
														],
														[
															324.517,
															21.701
														],
														[
															314.719,
															26.062
														],
														[
															306,
															31
														],
														[
															305.527,
															31.41
														],
														[
															305.021,
															31.981
														],
														[
															304.505,
															32.561
														],
														[
															304,
															33
														],
														[
															301.859,
															34.12
														],
														[
															299.793,
															34.998
														],
														[
															298,
															36
														],
														[
															296.549,
															37.922
														],
														[
															295,
															40
														],
														[
															293.484,
															40.532
														],
														[
															292,
															41
														],
														[
															287.285,
															45.896
														],
														[
															283,
															51
														],
														[
															274.376,
															59.454
														],
														[
															267,
															68
														],
														[
															265.408,
															70.715
														],
														[
															264,
															73
														],
														[
															263.024,
															73.954
														],
														[
															262,
															75
														],
														[
															249.607,
															93.743
														],
														[
															239,
															113
														],
														[
															207.984,
															196.615
														],
														[
															191,
															294
														],
														[
															190.712,
															425.04
														],
														[
															212,
															541
														],
														[
															215.821,
															554.748
														],
														[
															220,
															567
														],
														[
															222.206,
															572.947
														],
														[
															224,
															578
														],
														[
															226.161,
															582.273
														],
														[
															228,
															586
														],
														[
															234.963,
															602.785
														],
														[
															242,
															618
														],
														[
															244.964,
															622.546
														],
														[
															248,
															627
														],
														[
															250.466,
															632.061
														],
														[
															253,
															637
														],
														[
															253.987,
															637.975
														],
														[
															255,
															639
														],
														[
															255.467,
															640.48
														],
														[
															256,
															642
														],
														[
															257.977,
															643.967
														],
														[
															260,
															646
														],
														[
															260.995,
															648.505
														],
														[
															262,
															651
														],
														[
															263.989,
															653.041
														],
														[
															266,
															655
														],
														[
															270.352,
															660.335
														],
														[
															274,
															665
														],
														[
															274.973,
															666.077
														],
														[
															276,
															667
														],
														[
															296.933,
															687.407
														],
														[
															325,
															703
														],
														[
															342.648,
															708.076
														],
														[
															363,
															710
														],
														[
															371.47,
															709.853
														],
														[
															378,
															709
														],
														[
															383.087,
															702.667
														],
														[
															386,
															696
														],
														[
															390.043,
															693.753
														],
														[
															395,
															692
														],
														[
															439.052,
															663.193
														],
														[
															472,
															620
														],
														[
															528.82,
															437.079
														],
														[
															521,
															224
														],
														[
															507.075,
															171.189
														],
														[
															489,
															124
														],
														[
															484.077,
															113.693
														],
														[
															479,
															104
														],
														[
															473.4,
															94.463
														],
														[
															468,
															86
														],
														[
															466.922,
															83.367
														],
														[
															466,
															81
														],
														[
															464.039,
															79.006
														],
														[
															462,
															77
														],
														[
															458.983,
															72.403
														],
														[
															456,
															68
														],
														[
															452.562,
															63.931
														],
														[
															449,
															60
														],
														[
															430.394,
															41.233
														],
														[
															409,
															26
														],
														[
															402.109,
															23.22
														],
														[
															396,
															21
														],
														[
															385.653,
															17.203
														],
														[
															375,
															15
														],
														[
															359.694,
															14.861
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 20,
											"s": [
												{
													"i": [
														[
															10.47,
															-1.329
														],
														[
															4.331,
															-1.182
														],
														[
															3.366,
															-1.726
														],
														[
															1.363,
															-1.131
														],
														[
															1.056,
															-0.712
														],
														[
															0.901,
															-0.251
														],
														[
															0.643,
															-0.489
														],
														[
															0.878,
															-0.982
														],
														[
															0.637,
															-0.422
														],
														[
															0.267,
															-0.321
														],
														[
															0.415,
															-0.376
														],
														[
															5.841,
															-7.197
														],
														[
															4.734,
															-7.969
														],
														[
															5.639,
															-13.247
														],
														[
															4.242,
															-13.889
														],
														[
															4.626,
															-43.228
														],
														[
															-3.223,
															-44.992
														],
														[
															-6.372,
															-31.407
														],
														[
															-10.978,
															-26.994
														],
														[
															-3.607,
															-7.345
														],
														[
															-3.555,
															-6.204
														],
														[
															-0.547,
															-0.66
														],
														[
															-0.433,
															-0.698
														],
														[
															-0.527,
															-0.645
														],
														[
															-0.329,
															-0.516
														],
														[
															-0.266,
															-0.895
														],
														[
															-0.478,
															-0.699
														],
														[
															-0.416,
															-0.133
														],
														[
															-0.179,
															-0.24
														],
														[
															-0.108,
															-0.553
														],
														[
															-0.26,
															-0.372
														],
														[
															-5.108,
															-5.254
														],
														[
															-4.578,
															-4.262
														],
														[
															-0.535,
															-0.072
														],
														[
															-0.461,
															-0.341
														],
														[
															-1.005,
															-0.921
														],
														[
															-0.919,
															-0.532
														],
														[
															-2.183,
															-1.141
														],
														[
															-2.993,
															-1.116
														],
														[
															-2.223,
															-0.725
														],
														[
															-2.229,
															-0.399
														],
														[
															-7.363,
															0.235
														],
														[
															-1.356,
															1.809
														],
														[
															-0.514,
															2.168
														],
														[
															-0.79,
															0.79
														],
														[
															-2.215,
															0.684
														],
														[
															-1.728,
															0.851
														],
														[
															-2.554,
															1.826
														],
														[
															-1.988,
															1.318
														],
														[
															-0.675,
															0.534
														],
														[
															-0.47,
															0.312
														],
														[
															-1.341,
															1.313
														],
														[
															-1.145,
															0.76
														],
														[
															-0.261,
															0.299
														],
														[
															-0.414,
															0.445
														],
														[
															-1.704,
															1.614
														],
														[
															-0.842,
															1.101
														],
														[
															-0.091,
															0.551
														],
														[
															-0.334,
															0.4
														],
														[
															-1.246,
															1.112
														],
														[
															-0.981,
															1.311
														],
														[
															-0.241,
															0.89
														],
														[
															-0.517,
															0.744
														],
														[
															-0.751,
															0.631
														],
														[
															-0.471,
															0.718
														],
														[
															-3.236,
															6.298
														],
														[
															-3.051,
															6.692
														],
														[
															-3.902,
															10.887
														],
														[
															-2.99,
															10.795
														],
														[
															-4.04,
															29.892
														],
														[
															-0.35,
															33.396
														],
														[
															1.451,
															19.612
														],
														[
															2.403,
															16.817
														],
														[
															1.092,
															5.071
														],
														[
															0.863,
															4.341
														],
														[
															2.992,
															11.466
														],
														[
															3.512,
															10.466
														],
														[
															2.953,
															6.974
														],
														[
															2.764,
															5.877
														],
														[
															0.82,
															1.641
														],
														[
															0.917,
															1.724
														],
														[
															1.151,
															2.427
														],
														[
															1.171,
															1.987
														],
														[
															0.975,
															1.074
														],
														[
															0.44,
															0.587
														],
														[
															0.108,
															0.553
														],
														[
															0.26,
															0.373
														],
														[
															3.274,
															4.041
														],
														[
															2.887,
															3.512
														],
														[
															1.465,
															1.434
														],
														[
															12.825,
															4.617
														]
													],
													"o": [
														[
															-4.31,
															0.547
														],
														[
															-4.331,
															1.182
														],
														[
															-1.49,
															0.764
														],
														[
															-1.363,
															1.131
														],
														[
															-0.754,
															0.508
														],
														[
															-0.901,
															0.251
														],
														[
															-0.852,
															0.648
														],
														[
															-0.878,
															0.982
														],
														[
															-0.517,
															0.343
														],
														[
															-0.267,
															0.32
														],
														[
															-6.9,
															6.242
														],
														[
															-5.841,
															7.197
														],
														[
															-7.201,
															12.121
														],
														[
															-5.639,
															13.247
														],
														[
															-10.719,
															35.094
														],
														[
															-4.626,
															43.228
														],
														[
															2.534,
															35.379
														],
														[
															6.372,
															31.407
														],
														[
															3.017,
															7.418
														],
														[
															3.607,
															7.345
														],
														[
															0.379,
															0.661
														],
														[
															0.547,
															0.66
														],
														[
															0.562,
															0.904
														],
														[
															0.527,
															0.645
														],
														[
															0.458,
															0.718
														],
														[
															0.266,
															0.896
														],
														[
															0.155,
															0.227
														],
														[
															0.416,
															0.133
														],
														[
															0.31,
															0.414
														],
														[
															0.108,
															0.553
														],
														[
															3.99,
															5.724
														],
														[
															5.108,
															5.254
														],
														[
															0.398,
															0.37
														],
														[
															0.535,
															0.072
														],
														[
															1.063,
															0.786
														],
														[
															1.005,
															0.921
														],
														[
															2.276,
															1.317
														],
														[
															2.183,
															1.141
														],
														[
															1.88,
															0.702
														],
														[
															2.223,
															0.725
														],
														[
															4.193,
															0.75
														],
														[
															7.363,
															-0.235
														],
														[
															1.153,
															-1.539
														],
														[
															0.514,
															-2.168
														],
														[
															1.413,
															-1.413
														],
														[
															2.215,
															-0.684
														],
														[
															2.796,
															-1.377
														],
														[
															2.554,
															-1.826
														],
														[
															0.831,
															-0.552
														],
														[
															0.675,
															-0.534
														],
														[
															1.493,
															-0.99
														],
														[
															1.341,
															-1.313
														],
														[
															0.541,
															-0.359
														],
														[
															0.261,
															-0.299
														],
														[
															1.342,
															-1.442
														],
														[
															1.704,
															-1.614
														],
														[
															0.303,
															-0.396
														],
														[
															0.091,
															-0.551
														],
														[
															1.034,
															-1.241
														],
														[
															1.246,
															-1.112
														],
														[
															0.519,
															-0.695
														],
														[
															0.241,
															-0.89
														],
														[
															0.525,
															-0.755
														],
														[
															0.751,
															-0.632
														],
														[
															4.005,
															-6.115
														],
														[
															3.236,
															-6.298
														],
														[
															4.403,
															-9.656
														],
														[
															3.902,
															-10.887
														],
														[
															7.488,
															-27.036
														],
														[
															4.04,
															-29.892
														],
														[
															0.207,
															-19.734
														],
														[
															-1.451,
															-19.612
														],
														[
															-0.768,
															-5.376
														],
														[
															-1.092,
															-5.071
														],
														[
															-2.519,
															-12.669
														],
														[
															-2.992,
															-11.466
														],
														[
															-2.425,
															-7.228
														],
														[
															-2.953,
															-6.974
														],
														[
															-0.804,
															-1.71
														],
														[
															-0.82,
															-1.641
														],
														[
															-1.227,
															-2.306
														],
														[
															-1.151,
															-2.427
														],
														[
															-0.659,
															-1.119
														],
														[
															-0.975,
															-1.074
														],
														[
															-0.31,
															-0.414
														],
														[
															-0.108,
															-0.553
														],
														[
															-3.014,
															-4.325
														],
														[
															-3.275,
															-4.041
														],
														[
															-1.334,
															-1.623
														],
														[
															-10.106,
															-9.892
														],
														[
															-12.905,
															-4.646
														]
													],
													"v": [
														[
															349,
															16
														],
														[
															335.793,
															18.616
														],
														[
															324,
															23
														],
														[
															319.675,
															26.039
														],
														[
															316,
															29
														],
														[
															313.417,
															30.014
														],
														[
															311,
															31
														],
														[
															308.339,
															33.669
														],
														[
															306,
															36
														],
														[
															304.924,
															36.975
														],
														[
															304,
															38
														],
														[
															284.875,
															58.205
														],
														[
															269,
															81
														],
														[
															249.781,
															119.174
														],
														[
															235,
															160
														],
														[
															211.544,
															279.077
														],
														[
															209,
															413
														],
														[
															222.167,
															513.289
														],
														[
															248,
															601
														],
														[
															258.096,
															623.41
														],
														[
															269,
															644
														],
														[
															270.459,
															645.972
														],
														[
															272,
															648
														],
														[
															273.674,
															650.291
														],
														[
															275,
															652
														],
														[
															275.985,
															654.514
														],
														[
															277,
															657
														],
														[
															277.982,
															657.491
														],
														[
															279,
															658
														],
														[
															279.538,
															659.531
														],
														[
															280,
															661
														],
														[
															294.059,
															677.596
														],
														[
															309,
															692
														],
														[
															310.453,
															692.523
														],
														[
															312,
															693
														],
														[
															315.108,
															695.691
														],
														[
															318,
															698
														],
														[
															324.462,
															701.651
														],
														[
															332,
															705
														],
														[
															338.238,
															707.227
														],
														[
															345,
															709
														],
														[
															364.628,
															709.919
														],
														[
															380,
															707
														],
														[
															382.272,
															700.938
														],
														[
															384,
															696
														],
														[
															389.763,
															693.079
														],
														[
															396,
															691
														],
														[
															404.106,
															685.956
														],
														[
															411,
															681
														],
														[
															413.271,
															679.32
														],
														[
															415,
															678
														],
														[
															419.261,
															674.327
														],
														[
															423,
															671
														],
														[
															424.095,
															670.064
														],
														[
															425,
															669
														],
														[
															429.875,
															664.245
														],
														[
															434,
															660
														],
														[
															434.476,
															658.504
														],
														[
															435,
															657
														],
														[
															438.54,
															653.553
														],
														[
															442,
															650
														],
														[
															443.002,
															647.537
														],
														[
															444,
															645
														],
														[
															446.041,
															642.972
														],
														[
															448,
															641
														],
														[
															458.716,
															622.432
														],
														[
															468,
															603
														],
														[
															480.559,
															571.855
														],
														[
															491,
															539
														],
														[
															508.354,
															453.77
														],
														[
															515,
															359
														],
														[
															512.957,
															299.313
														],
														[
															507,
															244
														],
														[
															504.071,
															228.223
														],
														[
															501,
															214
														],
														[
															492.745,
															177.847
														],
														[
															483,
															145
														],
														[
															474.754,
															123.487
														],
														[
															466,
															104
														],
														[
															463.584,
															99.01
														],
														[
															461,
															94
														],
														[
															457.458,
															86.761
														],
														[
															454,
															80
														],
														[
															451.335,
															76.601
														],
														[
															449,
															74
														],
														[
															448.462,
															72.469
														],
														[
															448,
															71
														],
														[
															438.405,
															58.39
														],
														[
															429,
															47
														],
														[
															425,
															43
														],
														[
															390,
															19
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 21,
											"s": [
												{
													"i": [
														[
															4.49,
															-0.679
														],
														[
															5.439,
															-3.079
														],
														[
															4.964,
															-4.431
														],
														[
															2.702,
															-2.815
														],
														[
															1.62,
															-2.442
														],
														[
															0.534,
															-0.675
														],
														[
															0.312,
															-0.47
														],
														[
															0.358,
															-0.292
														],
														[
															0.264,
															-0.374
														],
														[
															0.286,
															-0.93
														],
														[
															0.431,
															-0.677
														],
														[
															0.423,
															-0.139
														],
														[
															0.171,
															-0.227
														],
														[
															0.125,
															-0.567
														],
														[
															0.214,
															-0.346
														],
														[
															6.657,
															-17.057
														],
														[
															4.423,
															-17.237
														],
														[
															2.957,
															-52.449
														],
														[
															-5.827,
															-49.34
														],
														[
															-9.203,
															-32.528
														],
														[
															-14.059,
															-24.917
														],
														[
															-0.547,
															-0.659
														],
														[
															-0.426,
															-0.677
														],
														[
															-0.528,
															-0.648
														],
														[
															-0.326,
															-0.512
														],
														[
															-0.261,
															-0.892
														],
														[
															-0.515,
															-0.738
														],
														[
															-0.414,
															-0.132
														],
														[
															-0.182,
															-0.243
														],
														[
															-0.091,
															-0.543
														],
														[
															-0.305,
															-0.39
														],
														[
															-0.403,
															-0.136
														],
														[
															-0.208,
															-0.224
														],
														[
															-0.074,
															-0.546
														],
														[
															-0.344,
															-0.429
														],
														[
															-1.246,
															-1.161
														],
														[
															-1.058,
															-1.157
														],
														[
															-3.216,
															-2.695
														],
														[
															-3.198,
															-2.008
														],
														[
															-1.295,
															-0.504
														],
														[
															-2.009,
															-0.848
														],
														[
															-0.634,
															-0.365
														],
														[
															-0.705,
															-0.219
														],
														[
															-3.137,
															-0.503
														],
														[
															-3.41,
															-0.038
														],
														[
															-2.88,
															0.159
														],
														[
															-0.795,
															0.395
														],
														[
															-0.694,
															2.545
														],
														[
															-2.278,
															2.355
														],
														[
															-1.648,
															0.543
														],
														[
															-1.327,
															0.708
														],
														[
															-1.775,
															1.378
														],
														[
															-1.472,
															1.192
														],
														[
															-3.603,
															4.02
														],
														[
															-3.185,
															4.354
														],
														[
															-0.542,
															0.451
														],
														[
															-0.374,
															0.57
														],
														[
															-0.243,
															0.856
														],
														[
															-0.521,
															0.803
														],
														[
															-0.553,
															0.447
														],
														[
															-0.391,
															0.602
														],
														[
															-0.227,
															0.808
														],
														[
															-0.539,
															0.917
														],
														[
															-0.577,
															0.452
														],
														[
															-0.315,
															0.551
														],
														[
															-0.286,
															0.856
														],
														[
															-0.387,
															0.758
														],
														[
															-1.549,
															2.82
														],
														[
															-1.249,
															2.67
														],
														[
															-0.087,
															0.876
														],
														[
															-0.326,
															0.801
														],
														[
															-0.595,
															0.623
														],
														[
															-0.312,
															0.753
														],
														[
															-0.442,
															1.729
														],
														[
															-0.615,
															1.593
														],
														[
															-1.154,
															3.096
														],
														[
															-1.111,
															3.318
														],
														[
															-0.743,
															1.69
														],
														[
															-0.482,
															1.606
														],
														[
															-0.951,
															3.448
														],
														[
															-0.35,
															1.234
														],
														[
															-2.126,
															9.317
														],
														[
															-2.901,
															39.035
														],
														[
															18.827,
															70.874
														],
														[
															0.509,
															1.817
														],
														[
															0.991,
															3.327
														],
														[
															2.154,
															6.141
														],
														[
															14.078,
															19.266
														],
														[
															0.872,
															1.162
														],
														[
															0.699,
															0.797
														],
														[
															15.372,
															4.283
														]
													],
													"o": [
														[
															-8.28,
															1.252
														],
														[
															-5.439,
															3.079
														],
														[
															-2.573,
															2.297
														],
														[
															-2.702,
															2.815
														],
														[
															-0.552,
															0.831
														],
														[
															-0.534,
															0.675
														],
														[
															-0.303,
															0.456
														],
														[
															-0.358,
															0.292
														],
														[
															-0.425,
															0.603
														],
														[
															-0.286,
															0.93
														],
														[
															-0.138,
															0.216
														],
														[
															-0.423,
															0.139
														],
														[
															-0.288,
															0.384
														],
														[
															-0.125,
															0.567
														],
														[
															-8.947,
															14.535
														],
														[
															-6.657,
															17.057
														],
														[
															-11,
															42.865
														],
														[
															-2.957,
															52.449
														],
														[
															4.13,
															34.972
														],
														[
															9.203,
															32.528
														],
														[
															0.387,
															0.686
														],
														[
															0.547,
															0.659
														],
														[
															0.563,
															0.895
														],
														[
															0.528,
															0.648
														],
														[
															0.441,
															0.692
														],
														[
															0.261,
															0.892
														],
														[
															0.161,
															0.231
														],
														[
															0.414,
															0.132
														],
														[
															0.329,
															0.439
														],
														[
															0.091,
															0.543
														],
														[
															0.18,
															0.23
														],
														[
															0.403,
															0.137
														],
														[
															0.36,
															0.386
														],
														[
															0.074,
															0.546
														],
														[
															0.958,
															1.197
														],
														[
															1.246,
															1.162
														],
														[
															2.938,
															3.212
														],
														[
															3.216,
															2.695
														],
														[
															1.81,
															1.137
														],
														[
															1.295,
															0.504
														],
														[
															0.758,
															0.32
														],
														[
															0.634,
															0.365
														],
														[
															3.043,
															0.948
														],
														[
															3.137,
															0.503
														],
														[
															2.684,
															0.03
														],
														[
															2.88,
															-0.159
														],
														[
															2.947,
															-1.464
														],
														[
															0.694,
															-2.545
														],
														[
															1.082,
															-1.119
														],
														[
															1.648,
															-0.543
														],
														[
															2.429,
															-1.296
														],
														[
															1.775,
															-1.378
														],
														[
															4.401,
															-3.565
														],
														[
															3.603,
															-4.02
														],
														[
															0.458,
															-0.626
														],
														[
															0.542,
															-0.451
														],
														[
															0.506,
															-0.772
														],
														[
															0.243,
															-0.856
														],
														[
															0.397,
															-0.611
														],
														[
															0.553,
															-0.447
														],
														[
															0.552,
															-0.85
														],
														[
															0.227,
															-0.808
														],
														[
															0.377,
															-0.641
														],
														[
															0.577,
															-0.452
														],
														[
															0.469,
															-0.82
														],
														[
															0.286,
															-0.856
														],
														[
															1.555,
															-3.051
														],
														[
															1.549,
															-2.82
														],
														[
															0.325,
															-0.695
														],
														[
															0.087,
															-0.876
														],
														[
															0.307,
															-0.754
														],
														[
															0.595,
															-0.623
														],
														[
															0.619,
															-1.49
														],
														[
															0.441,
															-1.729
														],
														[
															1.273,
															-3.298
														],
														[
															1.154,
															-3.096
														],
														[
															0.547,
															-1.634
														],
														[
															0.743,
															-1.69
														],
														[
															0.991,
															-3.3
														],
														[
															0.387,
															-1.404
														],
														[
															2.743,
															-9.676
														],
														[
															7.878,
															-34.516
														],
														[
															6.731,
															-90.557
														],
														[
															-0.464,
															-1.745
														],
														[
															-1.002,
															-3.576
														],
														[
															-1.904,
															-6.391
														],
														[
															-8.974,
															-25.584
														],
														[
															-1.463,
															-2.002
														],
														[
															-0.69,
															-0.919
														],
														[
															-10.068,
															-11.479
														],
														[
															-9.864,
															-2.748
														]
													],
													"v": [
														[
															350,
															16
														],
														[
															330.013,
															22.616
														],
														[
															315,
															34
														],
														[
															306.785,
															41.891
														],
														[
															300,
															50
														],
														[
															298.32,
															52.271
														],
														[
															297,
															54
														],
														[
															295.971,
															55.061
														],
														[
															295,
															56
														],
														[
															294.005,
															58.445
														],
														[
															293,
															61
														],
														[
															292.024,
															61.492
														],
														[
															291,
															62
														],
														[
															290.444,
															63.528
														],
														[
															290,
															65
														],
														[
															266.607,
															112.974
														],
														[
															250,
															165
														],
														[
															228.88,
															311.144
														],
														[
															233,
															467
														],
														[
															253.053,
															569.542
														],
														[
															288,
															657
														],
														[
															289.471,
															659.007
														],
														[
															291,
															661
														],
														[
															292.678,
															663.287
														],
														[
															294,
															665
														],
														[
															294.945,
															667.465
														],
														[
															296,
															670
														],
														[
															296.984,
															670.491
														],
														[
															298,
															671
														],
														[
															298.518,
															672.537
														],
														[
															299,
															674
														],
														[
															299.979,
															674.505
														],
														[
															301,
															675
														],
														[
															301.512,
															676.467
														],
														[
															302,
															678
														],
														[
															305.425,
															681.531
														],
														[
															309,
															685
														],
														[
															318.305,
															693.903
														],
														[
															328,
															701
														],
														[
															332.351,
															703.217
														],
														[
															337,
															705
														],
														[
															339.04,
															706.075
														],
														[
															341,
															707
														],
														[
															350.225,
															709.182
														],
														[
															360,
															710
														],
														[
															368.917,
															709.819
														],
														[
															375,
															709
														],
														[
															379.502,
															702.668
														],
														[
															383,
															695
														],
														[
															387.316,
															692.692
														],
														[
															392,
															691
														],
														[
															398.218,
															686.922
														],
														[
															403,
															683
														],
														[
															414.912,
															671.592
														],
														[
															425,
															659
														],
														[
															426.563,
															657.458
														],
														[
															428,
															656
														],
														[
															428.989,
															653.523
														],
														[
															430,
															651
														],
														[
															431.504,
															649.494
														],
														[
															433,
															648
														],
														[
															434.009,
															645.55
														],
														[
															435,
															643
														],
														[
															436.547,
															641.432
														],
														[
															438,
															640
														],
														[
															439.062,
															637.454
														],
														[
															440,
															635
														],
														[
															444.73,
															626.215
														],
														[
															449,
															618
														],
														[
															449.5,
															615.58
														],
														[
															450,
															613
														],
														[
															451.495,
															610.999
														],
														[
															453,
															609
														],
														[
															454.503,
															604.078
														],
														[
															456,
															599
														],
														[
															459.621,
															589.515
														],
														[
															463,
															580
														],
														[
															465.049,
															574.979
														],
														[
															467,
															570
														],
														[
															469,
															559
														],
														[
															471,
															555
														],
														[
															477,
															528
														],
														[
															493,
															413
														],
														[
															471,
															157
														],
														[
															469,
															152
														],
														[
															467,
															141
														],
														[
															460,
															122
														],
														[
															425,
															52
														],
														[
															420,
															47
														],
														[
															419,
															44
														],
														[
															380,
															17
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 22,
											"s": [
												{
													"i": [
														[
															0.919,
															-0.168
														],
														[
															0.255,
															0.014
														],
														[
															0.261,
															0.028
														],
														[
															0.251,
															0
														],
														[
															0.223,
															-0.071
														],
														[
															5.201,
															-4.002
														],
														[
															4.147,
															-5.322
														],
														[
															3.373,
															-6.034
														],
														[
															2.877,
															-6.137
														],
														[
															1.554,
															-3.712
														],
														[
															1.411,
															-3.765
														],
														[
															1.277,
															-3.796
														],
														[
															1.15,
															-3.803
														],
														[
															1.189,
															-4.135
														],
														[
															1.156,
															-4.285
														],
														[
															1.014,
															-4.132
														],
														[
															0.764,
															-3.678
														],
														[
															2.268,
															-15.052
														],
														[
															1.476,
															-15.626
														],
														[
															0.72,
															-16.637
														],
														[
															0,
															-18.083
														],
														[
															-0.732,
															-17.632
														],
														[
															-1.585,
															-16.304
														],
														[
															-2.561,
															-15.77
														],
														[
															-3.659,
															-16.031
														],
														[
															-2.984,
															-10.894
														],
														[
															-3.644,
															-10.143
														],
														[
															-4.588,
															-9.177
														],
														[
															-5.817,
															-7.996
														],
														[
															-2.962,
															-3.192
														],
														[
															-3.567,
															-2.575
														],
														[
															-4.321,
															-1.596
														],
														[
															-5.226,
															-0.254
														],
														[
															-1.616,
															0.04
														],
														[
															-1.68,
															0.102
														],
														[
															-1.225,
															0.136
														],
														[
															-0.248,
															0.143
														],
														[
															-0.516,
															0.944
														],
														[
															-0.267,
															1.127
														],
														[
															-0.243,
															1.12
														],
														[
															-0.442,
															0.921
														],
														[
															-0.211,
															0.245
														],
														[
															-0.251,
															0.204
														],
														[
															-0.289,
															0.232
														],
														[
															-0.326,
															0.33
														],
														[
															-0.633,
															0.321
														],
														[
															-0.729,
															0.277
														],
														[
															-0.731,
															0.318
														],
														[
															-0.64,
															0.444
														],
														[
															-0.509,
															0.493
														],
														[
															-0.476,
															0.535
														],
														[
															-0.48,
															0.525
														],
														[
															-0.518,
															0.463
														],
														[
															-1.268,
															1.318
														],
														[
															-1.166,
															1.366
														],
														[
															-1.065,
															1.365
														],
														[
															-0.965,
															1.315
														],
														[
															-0.446,
															0.587
														],
														[
															-0.394,
															0.53
														],
														[
															-0.376,
															0.553
														],
														[
															-0.391,
															0.656
														],
														[
															-0.578,
															1.05
														],
														[
															-0.541,
															1.035
														],
														[
															-0.567,
															1.093
														],
														[
															-0.658,
															1.222
														],
														[
															-0.694,
															1.385
														],
														[
															-0.632,
															1.358
														],
														[
															-0.622,
															1.419
														],
														[
															-0.664,
															1.567
														],
														[
															-0.339,
															0.739
														],
														[
															-0.346,
															0.748
														],
														[
															-0.335,
															0.759
														],
														[
															-0.303,
															0.775
														],
														[
															-4.188,
															15.128
														],
														[
															-3.045,
															16.121
														],
														[
															-2.084,
															17.058
														],
														[
															-1.305,
															17.937
														],
														[
															0.683,
															32.591
														],
														[
															3.784,
															30.499
														],
														[
															6.841,
															27.56
														],
														[
															4.205,
															13.14
														],
														[
															6.289,
															12.796
														],
														[
															3.41,
															5.242
														],
														[
															3.725,
															4.667
														],
														[
															3.329,
															3.321
														],
														[
															3.766,
															2.059
														],
														[
															1.231,
															0.277
														],
														[
															1.004,
															0.303
														],
														[
															0.387,
															0.468
														],
														[
															0.265,
															0.07
														],
														[
															5.224,
															-0.235
														]
													],
													"o": [
														[
															-0.231,
															0.042
														],
														[
															-0.255,
															-0.014
														],
														[
															-0.261,
															-0.028
														],
														[
															-0.251,
															0
														],
														[
															-6.533,
															2.073
														],
														[
															-5.201,
															4.002
														],
														[
															-4.147,
															5.323
														],
														[
															-3.373,
															6.034
														],
														[
															-1.704,
															3.636
														],
														[
															-1.554,
															3.712
														],
														[
															-1.411,
															3.765
														],
														[
															-1.277,
															3.796
														],
														[
															-1.113,
															3.683
														],
														[
															-1.189,
															4.135
														],
														[
															-1.156,
															4.285
														],
														[
															-1.014,
															4.132
														],
														[
															-3.097,
															14.913
														],
														[
															-2.268,
															15.052
														],
														[
															-1.476,
															15.626
														],
														[
															-0.72,
															16.637
														],
														[
															0,
															19.754
														],
														[
															0.732,
															17.632
														],
														[
															1.585,
															16.304
														],
														[
															2.561,
															15.77
														],
														[
															2.609,
															11.43
														],
														[
															2.984,
															10.894
														],
														[
															3.644,
															10.143
														],
														[
															4.588,
															9.177
														],
														[
															2.507,
															3.446
														],
														[
															2.962,
															3.192
														],
														[
															3.567,
															2.575
														],
														[
															4.321,
															1.596
														],
														[
															1.031,
															0.05
														],
														[
															1.616,
															-0.04
														],
														[
															1.68,
															-0.102
														],
														[
															1.225,
															-0.136
														],
														[
															0.989,
															-0.57
														],
														[
															0.516,
															-0.944
														],
														[
															0.267,
															-1.127
														],
														[
															0.243,
															-1.12
														],
														[
															0.17,
															-0.354
														],
														[
															0.211,
															-0.245
														],
														[
															0.251,
															-0.204
														],
														[
															0.289,
															-0.232
														],
														[
															0.444,
															-0.449
														],
														[
															0.633,
															-0.321
														],
														[
															0.729,
															-0.277
														],
														[
															0.731,
															-0.318
														],
														[
															0.576,
															-0.399
														],
														[
															0.509,
															-0.493
														],
														[
															0.476,
															-0.535
														],
														[
															0.48,
															-0.525
														],
														[
															1.37,
															-1.222
														],
														[
															1.268,
															-1.318
														],
														[
															1.166,
															-1.366
														],
														[
															1.065,
															-1.365
														],
														[
															0.531,
															-0.724
														],
														[
															0.446,
															-0.587
														],
														[
															0.394,
															-0.53
														],
														[
															0.376,
															-0.553
														],
														[
															0.679,
															-1.137
														],
														[
															0.578,
															-1.05
														],
														[
															0.541,
															-1.035
														],
														[
															0.567,
															-1.093
														],
														[
															0.808,
															-1.501
														],
														[
															0.694,
															-1.385
														],
														[
															0.632,
															-1.358
														],
														[
															0.622,
															-1.419
														],
														[
															0.311,
															-0.735
														],
														[
															0.339,
															-0.739
														],
														[
															0.346,
															-0.748
														],
														[
															0.335,
															-0.759
														],
														[
															5.513,
															-14.078
														],
														[
															4.188,
															-15.128
														],
														[
															3.045,
															-16.121
														],
														[
															2.084,
															-17.058
														],
														[
															2.463,
															-33.837
														],
														[
															-0.683,
															-32.591
														],
														[
															-3.784,
															-30.499
														],
														[
															-2.89,
															-11.645
														],
														[
															-4.205,
															-13.14
														],
														[
															-2.637,
															-5.364
														],
														[
															-3.41,
															-5.242
														],
														[
															-2.919,
															-3.658
														],
														[
															-3.329,
															-3.321
														],
														[
															-1.073,
															-0.587
														],
														[
															-1.231,
															-0.277
														],
														[
															-0.188,
															-0.057
														],
														[
															-0.387,
															-0.468
														],
														[
															-4.183,
															-1.107
														],
														[
															-5.224,
															0.235
														]
													],
													"v": [
														[
															351,
															16
														],
														[
															350.267,
															16.032
														],
														[
															349.488,
															15.957
														],
														[
															348.715,
															15.904
														],
														[
															348,
															16
														],
														[
															330.469,
															25.264
														],
														[
															316.516,
															39.403
														],
														[
															305.305,
															56.591
														],
														[
															296,
															75
														],
														[
															291.114,
															86.027
														],
														[
															286.668,
															97.248
														],
														[
															282.638,
															108.595
														],
														[
															279,
															120
														],
														[
															275.519,
															131.802
														],
														[
															271.975,
															144.507
														],
														[
															268.694,
															157.209
														],
														[
															266,
															169
														],
														[
															257.96,
															213.838
														],
														[
															252.354,
															259.745
														],
														[
															249.07,
															308.03
														],
														[
															248,
															360
														],
														[
															249.067,
															415.879
														],
														[
															252.512,
															466.584
														],
														[
															258.7,
															514.497
														],
														[
															268,
															562
														],
														[
															276.318,
															595.54
														],
														[
															286.187,
															627.151
														],
														[
															298.463,
															656.186
														],
														[
															314,
															682
														],
														[
															322.166,
															692.048
														],
														[
															331.922,
															700.789
														],
														[
															343.716,
															707.135
														],
														[
															358,
															710
														],
														[
															362.099,
															710.009
														],
														[
															367.173,
															709.789
														],
														[
															371.661,
															709.426
														],
														[
															374,
															709
														],
														[
															376.202,
															706.681
														],
														[
															377.321,
															703.526
														],
														[
															378.03,
															700.109
														],
														[
															379,
															697
														],
														[
															379.572,
															696.119
														],
														[
															380.266,
															695.463
														],
														[
															381.077,
															694.826
														],
														[
															382,
															694
														],
														[
															383.639,
															692.866
														],
														[
															385.705,
															691.991
														],
														[
															387.919,
															691.121
														],
														[
															390,
															690
														],
														[
															391.618,
															688.649
														],
														[
															393.087,
															687.095
														],
														[
															394.512,
															685.494
														],
														[
															396,
															684
														],
														[
															399.956,
															680.177
														],
														[
															403.607,
															676.14
														],
														[
															406.955,
															672.032
														],
														[
															410,
															668
														],
														[
															411.457,
															666.054
														],
														[
															412.709,
															664.398
														],
														[
															413.857,
															662.793
														],
														[
															415,
															661
														],
														[
															416.87,
															657.737
														],
														[
															418.532,
															654.628
														],
														[
															420.178,
															651.454
														],
														[
															422,
															648
														],
														[
															424.24,
															643.692
														],
														[
															426.216,
															639.599
														],
														[
															428.084,
															635.457
														],
														[
															430,
															631
														],
														[
															430.98,
															628.79
														],
														[
															432.012,
															626.56
														],
														[
															433.038,
															624.301
														],
														[
															434,
															622
														],
														[
															448.507,
															578.177
														],
														[
															459.312,
															531.288
														],
														[
															466.961,
															481.506
														],
														[
															472,
															429
														],
														[
															474.659,
															329.146
														],
														[
															467.948,
															234.3
														],
														[
															452,
															147
														],
														[
															441.549,
															109.363
														],
														[
															426,
															70
														],
														[
															416.816,
															53.977
														],
														[
															406,
															39
														],
														[
															396.635,
															28.301
														],
														[
															386,
															20
														],
														[
															382.448,
															18.787
														],
														[
															379,
															18
														],
														[
															378.058,
															17.01
														],
														[
															377,
															16
														],
														[
															361.552,
															15.043
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 23,
											"s": [
												{
													"i": [
														[
															0.586,
															-0.131
														],
														[
															1.366,
															-0.532
														],
														[
															1.219,
															-0.686
														],
														[
															1.085,
															-0.805
														],
														[
															0.964,
															-0.888
														],
														[
															0.857,
															-0.934
														],
														[
															0.763,
															-0.945
														],
														[
															0.683,
															-0.92
														],
														[
															0.615,
															-0.858
														],
														[
															0.123,
															-0.138
														],
														[
															0.134,
															-0.128
														],
														[
															0.139,
															-0.121
														],
														[
															0.139,
															-0.117
														],
														[
															0.133,
															-0.116
														],
														[
															0.123,
															-0.118
														],
														[
															0.108,
															-0.124
														],
														[
															0.087,
															-0.132
														],
														[
															0.705,
															-1.185
														],
														[
															0.652,
															-1.207
														],
														[
															0.611,
															-1.228
														],
														[
															0.582,
															-1.249
														],
														[
															0.565,
															-1.27
														],
														[
															0.559,
															-1.29
														],
														[
															0.565,
															-1.31
														],
														[
															3.142,
															-10.041
														],
														[
															2.527,
															-10.624
														],
														[
															1.997,
															-10.646
														],
														[
															1.551,
															-10.106
														],
														[
															1.874,
															-24.195
														],
														[
															0.536,
															-25.351
														],
														[
															-0.731,
															-24.855
														],
														[
															-1.927,
															-22.708
														],
														[
															-2.133,
															-16.123
														],
														[
															-3.015,
															-15.564
														],
														[
															-3.999,
															-14.284
														],
														[
															-5.087,
															-12.282
														],
														[
															-2.7,
															-5.257
														],
														[
															-3.398,
															-4.745
														],
														[
															-4.124,
															-3.365
														],
														[
															-4.877,
															-1.118
														],
														[
															-1.963,
															-0.176
														],
														[
															-2.211,
															-0.047
														],
														[
															-1.767,
															0.152
														],
														[
															-0.634,
															0.422
														],
														[
															-0.432,
															1.115
														],
														[
															-0.24,
															1.355
														],
														[
															-0.313,
															1.313
														],
														[
															-0.651,
															0.988
														],
														[
															-0.453,
															0.32
														],
														[
															-0.572,
															0.318
														],
														[
															-0.583,
															0.339
														],
														[
															-0.486,
															0.381
														],
														[
															-0.62,
															0.575
														],
														[
															-0.486,
															0.567
														],
														[
															-0.373,
															0.583
														],
														[
															-0.282,
															0.625
														],
														[
															-0.174,
															0.084
														],
														[
															-0.227,
															0.089
														],
														[
															-0.189,
															0.086
														],
														[
															-0.062,
															0.074
														],
														[
															-1,
															1.399
														],
														[
															-0.843,
															1.361
														],
														[
															-0.796,
															1.406
														],
														[
															-0.861,
															1.535
														],
														[
															-2.27,
															5.008
														],
														[
															-1.949,
															5.253
														],
														[
															-1.705,
															5.493
														],
														[
															-1.538,
															5.729
														],
														[
															-2.692,
															13.883
														],
														[
															-1.983,
															14.461
														],
														[
															-1.424,
															14.973
														],
														[
															-1.016,
															15.417
														],
														[
															-0.331,
															16.186
														],
														[
															0.317,
															15.955
														],
														[
															0.864,
															15.667
														],
														[
															1.312,
															15.322
														],
														[
															1.953,
															14.529
														],
														[
															2.724,
															14.164
														],
														[
															3.534,
															13.178
														],
														[
															4.383,
															11.572
														],
														[
															2.254,
															4.981
														],
														[
															2.747,
															4.771
														],
														[
															3.245,
															4.029
														],
														[
															3.747,
															2.755
														],
														[
															0.686,
															0.499
														],
														[
															0.702,
															0.467
														],
														[
															0.665,
															0.36
														],
														[
															0.575,
															0.176
														],
														[
															2.301,
															0.141
														],
														[
															2.292,
															-0.101
														],
														[
															1.72,
															-0.192
														]
													],
													"o": [
														[
															-1.527,
															0.341
														],
														[
															-1.366,
															0.532
														],
														[
															-1.219,
															0.686
														],
														[
															-1.085,
															0.805
														],
														[
															-0.964,
															0.888
														],
														[
															-0.857,
															0.934
														],
														[
															-0.763,
															0.945
														],
														[
															-0.683,
															0.92
														],
														[
															-0.108,
															0.151
														],
														[
															-0.123,
															0.138
														],
														[
															-0.134,
															0.128
														],
														[
															-0.139,
															0.121
														],
														[
															-0.139,
															0.117
														],
														[
															-0.133,
															0.116
														],
														[
															-0.123,
															0.118
														],
														[
															-0.108,
															0.124
														],
														[
															-0.769,
															1.163
														],
														[
															-0.705,
															1.185
														],
														[
															-0.652,
															1.207
														],
														[
															-0.611,
															1.228
														],
														[
															-0.582,
															1.249
														],
														[
															-0.565,
															1.27
														],
														[
															-0.559,
															1.29
														],
														[
															-3.839,
															8.897
														],
														[
															-3.142,
															10.041
														],
														[
															-2.527,
															10.624
														],
														[
															-1.997,
															10.646
														],
														[
															-3.282,
															21.389
														],
														[
															-1.874,
															24.195
														],
														[
															-0.536,
															25.351
														],
														[
															0.731,
															24.855
														],
														[
															1.354,
															15.96
														],
														[
															2.133,
															16.123
														],
														[
															3.015,
															15.565
														],
														[
															3.999,
															14.284
														],
														[
															2.031,
															4.904
														],
														[
															2.7,
															5.257
														],
														[
															3.398,
															4.745
														],
														[
															4.124,
															3.365
														],
														[
															1.024,
															0.235
														],
														[
															1.963,
															0.176
														],
														[
															2.21,
															0.047
														],
														[
															1.768,
															-0.152
														],
														[
															0.89,
															-0.593
														],
														[
															0.432,
															-1.115
														],
														[
															0.24,
															-1.355
														],
														[
															0.313,
															-1.313
														],
														[
															0.227,
															-0.345
														],
														[
															0.453,
															-0.32
														],
														[
															0.572,
															-0.318
														],
														[
															0.583,
															-0.339
														],
														[
															0.775,
															-0.608
														],
														[
															0.62,
															-0.575
														],
														[
															0.486,
															-0.567
														],
														[
															0.373,
															-0.583
														],
														[
															0.031,
															-0.068
														],
														[
															0.174,
															-0.084
														],
														[
															0.227,
															-0.089
														],
														[
															0.189,
															-0.086
														],
														[
															1.269,
															-1.523
														],
														[
															1,
															-1.399
														],
														[
															0.843,
															-1.361
														],
														[
															0.796,
															-1.406
														],
														[
															2.668,
															-4.759
														],
														[
															2.27,
															-5.008
														],
														[
															1.949,
															-5.253
														],
														[
															1.705,
															-5.493
														],
														[
															3.552,
															-13.237
														],
														[
															2.692,
															-13.883
														],
														[
															1.983,
															-14.461
														],
														[
															1.424,
															-14.973
														],
														[
															1.078,
															-16.36
														],
														[
															0.331,
															-16.186
														],
														[
															-0.317,
															-15.955
														],
														[
															-0.864,
															-15.667
														],
														[
															-1.222,
															-14.273
														],
														[
															-1.953,
															-14.529
														],
														[
															-2.724,
															-14.164
														],
														[
															-3.534,
															-13.178
														],
														[
															-1.765,
															-4.66
														],
														[
															-2.254,
															-4.981
														],
														[
															-2.747,
															-4.771
														],
														[
															-3.245,
															-4.029
														],
														[
															-0.617,
															-0.454
														],
														[
															-0.686,
															-0.499
														],
														[
															-0.702,
															-0.467
														],
														[
															-0.665,
															-0.36
														],
														[
															-1.747,
															-0.537
														],
														[
															-2.301,
															-0.141
														],
														[
															-2.292,
															0.101
														],
														[
															-1.72,
															0.192
														]
													],
													"v": [
														[
															352,
															16
														],
														[
															347.663,
															17.318
														],
														[
															343.788,
															19.154
														],
														[
															340.335,
															21.4
														],
														[
															337.264,
															23.948
														],
														[
															334.535,
															26.69
														],
														[
															332.108,
															29.519
														],
														[
															329.943,
															32.324
														],
														[
															328,
															35
														],
														[
															327.651,
															35.432
														],
														[
															327.265,
															35.829
														],
														[
															326.855,
															36.2
														],
														[
															326.438,
															36.556
														],
														[
															326.029,
															36.904
														],
														[
															325.642,
															37.255
														],
														[
															325.294,
															37.617
														],
														[
															325,
															38
														],
														[
															322.792,
															41.522
														],
														[
															320.761,
															45.11
														],
														[
															318.869,
															48.763
														],
														[
															317.083,
															52.48
														],
														[
															315.366,
															56.259
														],
														[
															313.684,
															60.099
														],
														[
															312,
															64
														],
														[
															301.549,
															92.547
														],
														[
															293.067,
															123.685
														],
														[
															286.301,
															155.731
														],
														[
															281,
															187
														],
														[
															273.284,
															255.79
														],
														[
															269.687,
															330.522
														],
														[
															269.996,
															406.243
														],
														[
															274,
															478
														],
														[
															279.205,
															526.305
														],
														[
															286.902,
															574.017
														],
														[
															297.397,
															618.97
														],
														[
															311,
															659
														],
														[
															318.09,
															674.458
														],
														[
															327.23,
															689.678
														],
														[
															338.505,
															702.059
														],
														[
															352,
															709
														],
														[
															356.653,
															709.634
														],
														[
															363.086,
															709.985
														],
														[
															369.225,
															709.844
														],
														[
															373,
															709
														],
														[
															374.918,
															706.368
														],
														[
															375.859,
															702.593
														],
														[
															376.621,
															698.522
														],
														[
															378,
															695
														],
														[
															379.048,
															694.007
														],
														[
															380.612,
															693.055
														],
														[
															382.37,
															692.075
														],
														[
															384,
															691
														],
														[
															386.086,
															689.232
														],
														[
															387.739,
															687.525
														],
														[
															389.023,
															685.806
														],
														[
															390,
															684
														],
														[
															390.33,
															683.77
														],
														[
															390.954,
															683.508
														],
														[
															391.601,
															683.242
														],
														[
															392,
															683
														],
														[
															395.376,
															678.638
														],
														[
															398.112,
															674.519
														],
														[
															400.542,
															670.391
														],
														[
															403,
															666
														],
														[
															410.387,
															651.349
														],
														[
															416.695,
															635.956
														],
														[
															422.156,
															619.835
														],
														[
															427,
															603
														],
														[
															436.329,
															562.303
														],
														[
															443.304,
															519.77
														],
														[
															448.377,
															475.602
														],
														[
															452,
															430
														],
														[
															454.089,
															381.168
														],
														[
															454.085,
															332.943
														],
														[
															452.289,
															285.497
														],
														[
															449,
															239
														],
														[
															444.247,
															195.642
														],
														[
															437.242,
															152.447
														],
														[
															427.865,
															111.279
														],
														[
															416,
															74
														],
														[
															409.973,
															59.405
														],
														[
															402.473,
															44.643
														],
														[
															393.487,
															31.31
														],
														[
															383,
															21
														],
														[
															381.032,
															19.552
														],
														[
															378.936,
															18.084
														],
														[
															376.872,
															16.824
														],
														[
															375,
															16
														],
														[
															368.787,
															15.021
														],
														[
															361.758,
															14.999
														],
														[
															355.599,
															15.478
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 24,
											"s": [
												{
													"i": [
														[
															-0.244,
															0.062
														],
														[
															2.447,
															-1.94
														],
														[
															1.956,
															-2.656
														],
														[
															1.407,
															-2.888
														],
														[
															0.797,
															-2.636
														],
														[
															0.176,
															-0.166
														],
														[
															0.23,
															-0.196
														],
														[
															0.189,
															-0.182
														],
														[
															0.052,
															-0.124
														],
														[
															1.649,
															-5.06
														],
														[
															1.336,
															-5.111
														],
														[
															1.144,
															-5.121
														],
														[
															1.073,
															-5.089
														],
														[
															0.276,
															-1.407
														],
														[
															0.254,
															-1.373
														],
														[
															0.226,
															-1.28
														],
														[
															0.191,
															-1.125
														],
														[
															0.084,
															-0.509
														],
														[
															0.083,
															-0.51
														],
														[
															0.083,
															-0.496
														],
														[
															0.082,
															-0.467
														],
														[
															0.634,
															-3.844
														],
														[
															0.585,
															-3.831
														],
														[
															0.534,
															-3.822
														],
														[
															0.48,
															-3.817
														],
														[
															1.387,
															-16.014
														],
														[
															0.901,
															-16.67
														],
														[
															0.438,
															-17.071
														],
														[
															0,
															-17.216
														],
														[
															-0.865,
															-20.926
														],
														[
															-1.742,
															-20.277
														],
														[
															-2.631,
															-19.212
														],
														[
															-3.532,
															-17.731
														],
														[
															-1.65,
															-7.084
														],
														[
															-2.023,
															-6.869
														],
														[
															-2.486,
															-6.226
														],
														[
															-3.039,
															-5.154
														],
														[
															-0.819,
															-1.254
														],
														[
															-0.988,
															-1.25
														],
														[
															-1.175,
															-1.121
														],
														[
															-1.381,
															-0.866
														],
														[
															-2.296,
															-0.724
														],
														[
															-2.263,
															-0.194
														],
														[
															-1.836,
															0.377
														],
														[
															-1.014,
															0.99
														],
														[
															-0.202,
															0.685
														],
														[
															-0.004,
															0.747
														],
														[
															-0.05,
															0.813
														],
														[
															-0.34,
															0.886
														],
														[
															-0.472,
															0.756
														],
														[
															-0.486,
															0.505
														],
														[
															-0.521,
															0.496
														],
														[
															-0.577,
															0.729
														],
														[
															-1.071,
															1.573
														],
														[
															-0.877,
															1.488
														],
														[
															-0.743,
															1.421
														],
														[
															-0.668,
															1.371
														],
														[
															-2.127,
															5.723
														],
														[
															-1.748,
															6.067
														],
														[
															-1.497,
															6.435
														],
														[
															-1.374,
															6.829
														],
														[
															-2.092,
															13.83
														],
														[
															-1.561,
															14.33
														],
														[
															-1.063,
															14.71
														],
														[
															-0.598,
															14.97
														],
														[
															-0.152,
															7.903
														],
														[
															-0.047,
															7.955
														],
														[
															0.004,
															7.949
														],
														[
															0,
															7.886
														],
														[
															0.449,
															14.617
														],
														[
															0.96,
															14.671
														],
														[
															1.53,
															14.968
														],
														[
															2.162,
															15.509
														],
														[
															1.137,
															6.622
														],
														[
															1.391,
															6.958
														],
														[
															1.558,
															6.732
														],
														[
															1.64,
															5.943
														],
														[
															0.459,
															1.44
														],
														[
															0.518,
															1.512
														],
														[
															0.55,
															1.566
														],
														[
															0.555,
															1.601
														],
														[
															0.843,
															2.658
														],
														[
															0.905,
															2.452
														],
														[
															1.027,
															1.804
														],
														[
															0.627,
															0.538
														],
														[
															0.281,
															0.479
														],
														[
															0.607,
															1.41
														],
														[
															0.817,
															1.075
														],
														[
															2.361,
															1.998
														],
														[
															1.581,
															0.407
														],
														[
															3.541,
															-0.464
														]
													],
													"o": [
														[
															-2.877,
															0.74
														],
														[
															-2.447,
															1.94
														],
														[
															-1.956,
															2.656
														],
														[
															-1.407,
															2.888
														],
														[
															-0.028,
															0.092
														],
														[
															-0.176,
															0.166
														],
														[
															-0.23,
															0.196
														],
														[
															-0.189,
															0.182
														],
														[
															-2.083,
															4.967
														],
														[
															-1.649,
															5.06
														],
														[
															-1.336,
															5.111
														],
														[
															-1.144,
															5.121
														],
														[
															-0.291,
															1.381
														],
														[
															-0.276,
															1.407
														],
														[
															-0.254,
															1.373
														],
														[
															-0.226,
															1.28
														],
														[
															-0.084,
															0.494
														],
														[
															-0.084,
															0.509
														],
														[
															-0.083,
															0.51
														],
														[
															-0.083,
															0.496
														],
														[
															-0.68,
															3.861
														],
														[
															-0.634,
															3.844
														],
														[
															-0.585,
															3.831
														],
														[
															-0.534,
															3.822
														],
														[
															-1.898,
															15.103
														],
														[
															-1.387,
															16.014
														],
														[
															-0.901,
															16.67
														],
														[
															-0.438,
															17.071
														],
														[
															0,
															21.16
														],
														[
															0.865,
															20.926
														],
														[
															1.742,
															20.277
														],
														[
															2.631,
															19.212
														],
														[
															1.368,
															6.87
														],
														[
															1.651,
															7.084
														],
														[
															2.023,
															6.869
														],
														[
															2.486,
															6.226
														],
														[
															0.668,
															1.133
														],
														[
															0.819,
															1.254
														],
														[
															0.988,
															1.25
														],
														[
															1.175,
															1.121
														],
														[
															1.934,
															1.212
														],
														[
															2.296,
															0.724
														],
														[
															2.263,
															0.194
														],
														[
															1.836,
															-0.377
														],
														[
															0.643,
															-0.628
														],
														[
															0.202,
															-0.685
														],
														[
															0.004,
															-0.747
														],
														[
															0.05,
															-0.813
														],
														[
															0.48,
															-1.249
														],
														[
															0.472,
															-0.756
														],
														[
															0.486,
															-0.505
														],
														[
															0.521,
															-0.496
														],
														[
															1.325,
															-1.676
														],
														[
															1.071,
															-1.573
														],
														[
															0.877,
															-1.488
														],
														[
															0.743,
															-1.421
														],
														[
															2.632,
															-5.404
														],
														[
															2.127,
															-5.723
														],
														[
															1.748,
															-6.067
														],
														[
															1.497,
															-6.435
														],
														[
															2.656,
															-13.209
														],
														[
															2.092,
															-13.83
														],
														[
															1.561,
															-14.33
														],
														[
															1.063,
															-14.71
														],
														[
															0.312,
															-7.794
														],
														[
															0.152,
															-7.903
														],
														[
															0.047,
															-7.955
														],
														[
															-0.004,
															-7.949
														],
														[
															0,
															-14.808
														],
														[
															-0.449,
															-14.617
														],
														[
															-0.96,
															-14.671
														],
														[
															-1.53,
															-14.968
														],
														[
															-0.798,
															-5.725
														],
														[
															-1.137,
															-6.622
														],
														[
															-1.391,
															-6.958
														],
														[
															-1.558,
															-6.732
														],
														[
															-0.373,
															-1.35
														],
														[
															-0.459,
															-1.44
														],
														[
															-0.518,
															-1.512
														],
														[
															-0.55,
															-1.566
														],
														[
															-0.839,
															-2.422
														],
														[
															-0.843,
															-2.658
														],
														[
															-0.905,
															-2.452
														],
														[
															-0.209,
															-0.367
														],
														[
															-0.627,
															-0.538
														],
														[
															-0.754,
															-1.284
														],
														[
															-0.607,
															-1.41
														],
														[
															-1.975,
															-2.602
														],
														[
															-2.361,
															-1.998
														],
														[
															-3.082,
															-0.793
														],
														[
															-3.541,
															0.464
														]
													],
													"v": [
														[
															354,
															16
														],
														[
															345.999,
															20.141
														],
														[
															339.38,
															27.156
														],
														[
															334.32,
															35.593
														],
														[
															331,
															44
														],
														[
															330.67,
															44.397
														],
														[
															330.037,
															44.951
														],
														[
															329.385,
															45.529
														],
														[
															329,
															46
														],
														[
															323.432,
															61.051
														],
														[
															318.985,
															76.317
														],
														[
															315.295,
															91.675
														],
														[
															312,
															107
														],
														[
															311.147,
															111.197
														],
														[
															310.35,
															115.383
														],
														[
															309.628,
															119.377
														],
														[
															309,
															123
														],
														[
															308.748,
															124.508
														],
														[
															308.497,
															126.04
														],
														[
															308.248,
															127.552
														],
														[
															308,
															129
														],
														[
															306.029,
															140.555
														],
														[
															304.2,
															152.066
														],
														[
															302.521,
															163.543
														],
														[
															301,
															175
														],
														[
															296.079,
															221.74
														],
														[
															292.653,
															270.83
														],
														[
															290.651,
															321.506
														],
														[
															290,
															373
														],
														[
															291.295,
															436.234
														],
														[
															295.202,
															498.143
														],
														[
															301.758,
															557.481
														],
														[
															311,
															613
														],
														[
															315.506,
															634.037
														],
														[
															320.993,
															655.074
														],
														[
															327.734,
															674.824
														],
														[
															336,
															692
														],
														[
															338.226,
															695.613
														],
														[
															340.93,
															699.4
														],
														[
															344.17,
															702.988
														],
														[
															348,
															706
														],
														[
															354.443,
															708.915
														],
														[
															361.38,
															710.303
														],
														[
															367.627,
															710.04
														],
														[
															372,
															708
														],
														[
															373.207,
															706.032
														],
														[
															373.455,
															703.886
														],
														[
															373.476,
															701.547
														],
														[
															374,
															699
														],
														[
															375.422,
															696.052
														],
														[
															376.855,
															694.22
														],
														[
															378.359,
															692.778
														],
														[
															380,
															691
														],
														[
															383.578,
															686.132
														],
														[
															386.485,
															681.544
														],
														[
															388.899,
															677.184
														],
														[
															391,
															673
														],
														[
															398.107,
															656.315
														],
														[
															403.888,
															638.636
														],
														[
															408.726,
															619.89
														],
														[
															413,
															600
														],
														[
															420.115,
															559.412
														],
														[
															425.587,
															517.142
														],
														[
															429.516,
															473.551
														],
														[
															432,
															429
														],
														[
															432.682,
															405.44
														],
														[
															432.967,
															381.638
														],
														[
															433.019,
															357.767
														],
														[
															433,
															334
														],
														[
															432.341,
															289.923
														],
														[
															430.243,
															246.052
														],
														[
															426.523,
															201.655
														],
														[
															421,
															156
														],
														[
															418.076,
															137.339
														],
														[
															414.263,
															116.828
														],
														[
															409.818,
															96.153
														],
														[
															405,
															77
														],
														[
															403.746,
															72.81
														],
														[
															402.273,
															68.376
														],
														[
															400.664,
															63.755
														],
														[
															399,
															59
														],
														[
															396.491,
															51.27
														],
														[
															393.883,
															43.495
														],
														[
															391,
															37
														],
														[
															389.554,
															35.584
														],
														[
															388,
															34
														],
														[
															386.047,
															29.844
														],
														[
															384,
															26
														],
														[
															377.204,
															18.854
														],
														[
															371,
															15
														],
														[
															360.006,
															14.953
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 25,
											"s": [
												{
													"i": [
														[
															0.058,
															-0.021
														],
														[
															1.052,
															-0.857
														],
														[
															0.926,
															-1.198
														],
														[
															0.813,
															-1.464
														],
														[
															0.714,
															-1.656
														],
														[
															0.629,
															-1.774
														],
														[
															0.556,
															-1.818
														],
														[
															0.497,
															-1.787
														],
														[
															0.452,
															-1.683
														],
														[
															1.325,
															-6.106
														],
														[
															1.092,
															-6.242
														],
														[
															0.896,
															-6.345
														],
														[
															0.736,
															-6.417
														],
														[
															0.613,
															-6.458
														],
														[
															0.526,
															-6.467
														],
														[
															0.476,
															-6.445
														],
														[
															0.463,
															-6.391
														],
														[
															0.583,
															-10.843
														],
														[
															0.407,
															-10.993
														],
														[
															0.244,
															-11.099
														],
														[
															0.093,
															-11.16
														],
														[
															-0.047,
															-11.177
														],
														[
															-0.174,
															-11.15
														],
														[
															-0.288,
															-11.078
														],
														[
															-0.391,
															-10.962
														],
														[
															-0.493,
															-10.049
														],
														[
															-0.662,
															-9.969
														],
														[
															-0.864,
															-9.806
														],
														[
															-1.101,
															-9.56
														],
														[
															-1.371,
															-9.231
														],
														[
															-1.676,
															-8.819
														],
														[
															-2.014,
															-8.323
														],
														[
															-0.359,
															-1.673
														],
														[
															-0.374,
															-1.662
														],
														[
															-0.453,
															-1.658
														],
														[
															-0.596,
															-1.66
														],
														[
															-0.489,
															-1.033
														],
														[
															-0.579,
															-1.111
														],
														[
															-0.55,
															-1.023
														],
														[
															-0.404,
															-0.767
														],
														[
															-0.161,
															-0.464
														],
														[
															-0.165,
															-0.499
														],
														[
															-0.171,
															-0.411
														],
														[
															-0.181,
															-0.199
														],
														[
															-1.575,
															-0.843
														],
														[
															-1.776,
															-0.397
														],
														[
															-1.688,
															0.145
														],
														[
															-1.311,
															0.783
														],
														[
															-0.329,
															0.156
														],
														[
															-0.133,
															0.108
														],
														[
															-0.112,
															0.272
														],
														[
															-0.267,
															0.65
														],
														[
															-0.075,
															0.972
														],
														[
															-0.005,
															1.071
														],
														[
															-0.052,
															0.938
														],
														[
															-0.217,
															0.573
														],
														[
															-0.248,
															0.216
														],
														[
															-0.32,
															0.249
														],
														[
															-0.287,
															0.284
														],
														[
															-0.148,
															0.32
														],
														[
															-0.761,
															1.516
														],
														[
															-0.694,
															1.384
														],
														[
															-0.586,
															1.301
														],
														[
															-0.436,
															1.267
														],
														[
															-0.983,
															3.385
														],
														[
															-0.812,
															3.281
														],
														[
															-0.673,
															3.131
														],
														[
															-0.566,
															2.935
														],
														[
															-1.111,
															7.365
														],
														[
															-0.855,
															7.217
														],
														[
															-0.691,
															7.118
														],
														[
															-0.619,
															7.07
														],
														[
															-1.34,
															31.385
														],
														[
															-0.058,
															31.665
														],
														[
															1.186,
															31.198
														],
														[
															2.391,
															29.982
														],
														[
															1.054,
															11.091
														],
														[
															1.429,
															10.701
														],
														[
															2.035,
															10.26
														],
														[
															2.873,
															9.767
														],
														[
															1.17,
															3.33
														],
														[
															1.525,
															3.206
														],
														[
															1.842,
															2.274
														],
														[
															2.122,
															0.531
														],
														[
															1.162,
															0.06
														],
														[
															1.245,
															-0.023
														],
														[
															0.961,
															-0.072
														],
														[
															0.309,
															-0.085
														],
														[
															0.11,
															-0.096
														],
														[
															0.065,
															-0.107
														],
														[
															0.048,
															-0.082
														]
													],
													"o": [
														[
															-1.191,
															0.442
														],
														[
															-1.052,
															0.857
														],
														[
															-0.926,
															1.198
														],
														[
															-0.813,
															1.464
														],
														[
															-0.714,
															1.656
														],
														[
															-0.629,
															1.774
														],
														[
															-0.556,
															1.818
														],
														[
															-0.497,
															1.787
														],
														[
															-1.594,
															5.94
														],
														[
															-1.325,
															6.106
														],
														[
															-1.092,
															6.242
														],
														[
															-0.896,
															6.345
														],
														[
															-0.736,
															6.417
														],
														[
															-0.613,
															6.458
														],
														[
															-0.526,
															6.467
														],
														[
															-0.476,
															6.445
														],
														[
															-0.771,
															10.648
														],
														[
															-0.583,
															10.843
														],
														[
															-0.407,
															10.993
														],
														[
															-0.244,
															11.099
														],
														[
															-0.093,
															11.16
														],
														[
															0.047,
															11.177
														],
														[
															0.174,
															11.15
														],
														[
															0.288,
															11.078
														],
														[
															0.358,
															10.046
														],
														[
															0.493,
															10.049
														],
														[
															0.662,
															9.969
														],
														[
															0.864,
															9.806
														],
														[
															1.101,
															9.56
														],
														[
															1.371,
															9.231
														],
														[
															1.676,
															8.819
														],
														[
															0.409,
															1.691
														],
														[
															0.359,
															1.673
														],
														[
															0.374,
															1.662
														],
														[
															0.453,
															1.658
														],
														[
															0.283,
															0.788
														],
														[
															0.489,
															1.033
														],
														[
															0.579,
															1.111
														],
														[
															0.55,
															1.023
														],
														[
															0.16,
															0.304
														],
														[
															0.161,
															0.464
														],
														[
															0.165,
															0.499
														],
														[
															0.171,
															0.411
														],
														[
															1.086,
															1.194
														],
														[
															1.575,
															0.843
														],
														[
															1.776,
															0.397
														],
														[
															1.688,
															-0.145
														],
														[
															0.701,
															-0.418
														],
														[
															0.329,
															-0.156
														],
														[
															0.133,
															-0.108
														],
														[
															0.112,
															-0.272
														],
														[
															0.264,
															-0.641
														],
														[
															0.075,
															-0.972
														],
														[
															0.005,
															-1.071
														],
														[
															0.052,
															-0.938
														],
														[
															0.07,
															-0.185
														],
														[
															0.248,
															-0.216
														],
														[
															0.32,
															-0.249
														],
														[
															0.287,
															-0.284
														],
														[
															0.786,
															-1.697
														],
														[
															0.761,
															-1.516
														],
														[
															0.694,
															-1.384
														],
														[
															0.586,
															-1.301
														],
														[
															1.185,
															-3.443
														],
														[
															0.983,
															-3.385
														],
														[
															0.812,
															-3.281
														],
														[
															0.673,
															-3.131
														],
														[
															1.459,
															-7.563
														],
														[
															1.111,
															-7.365
														],
														[
															0.855,
															-7.217
														],
														[
															0.691,
															-7.118
														],
														[
															2.659,
															-30.356
														],
														[
															1.34,
															-31.385
														],
														[
															0.058,
															-31.665
														],
														[
															-1.186,
															-31.198
														],
														[
															-0.911,
															-11.43
														],
														[
															-1.054,
															-11.091
														],
														[
															-1.429,
															-10.701
														],
														[
															-2.035,
															-10.26
														],
														[
															-0.778,
															-2.644
														],
														[
															-1.17,
															-3.33
														],
														[
															-1.525,
															-3.206
														],
														[
															-1.842,
															-2.274
														],
														[
															-0.711,
															-0.178
														],
														[
															-1.162,
															-0.06
														],
														[
															-1.245,
															0.023
														],
														[
															-0.961,
															0.072
														],
														[
															-0.182,
															0.05
														],
														[
															-0.11,
															0.096
														],
														[
															-0.065,
															0.107
														],
														[
															-0.048,
															0.082
														]
													],
													"v": [
														[
															355,
															16
														],
														[
															351.639,
															17.967
														],
														[
															348.675,
															21.068
														],
														[
															346.07,
															25.079
														],
														[
															343.781,
															29.778
														],
														[
															341.77,
															34.942
														],
														[
															339.996,
															40.349
														],
														[
															338.42,
															45.776
														],
														[
															337,
															51
														],
														[
															332.632,
															69.078
														],
														[
															329.016,
															87.607
														],
														[
															326.045,
															106.495
														],
														[
															323.607,
															125.647
														],
														[
															321.593,
															144.967
														],
														[
															319.894,
															164.362
														],
														[
															318.399,
															183.738
														],
														[
															317,
															203
														],
														[
															314.972,
															235.247
														],
														[
															313.49,
															268.011
														],
														[
															312.516,
															301.159
														],
														[
															312.015,
															334.558
														],
														[
															311.949,
															368.075
														],
														[
															312.282,
															401.576
														],
														[
															312.978,
															434.929
														],
														[
															314,
															468
														],
														[
															315.268,
															498.163
														],
														[
															316.991,
															528.211
														],
														[
															319.271,
															557.894
														],
														[
															322.211,
															586.964
														],
														[
															325.91,
															615.171
														],
														[
															330.473,
															642.266
														],
														[
															336,
															668
														],
														[
															337.137,
															673.045
														],
														[
															338.22,
															678.046
														],
														[
															339.444,
															683.024
														],
														[
															341,
															688
														],
														[
															342.187,
															690.773
														],
														[
															343.819,
															694.03
														],
														[
															345.541,
															697.273
														],
														[
															347,
															700
														],
														[
															347.481,
															701.183
														],
														[
															347.969,
															702.658
														],
														[
															348.472,
															704.054
														],
														[
															349,
															705
														],
														[
															353.064,
															708.08
														],
														[
															358.163,
															709.964
														],
														[
															363.431,
															710.367
														],
														[
															368,
															709
														],
														[
															369.501,
															708.191
														],
														[
															370.15,
															707.848
														],
														[
															370.474,
															707.331
														],
														[
															371,
															706
														],
														[
															371.479,
															703.521
														],
														[
															371.57,
															700.397
														],
														[
															371.626,
															697.325
														],
														[
															372,
															695
														],
														[
															372.503,
															694.4
														],
														[
															373.382,
															693.704
														],
														[
															374.32,
															692.905
														],
														[
															375,
															692
														],
														[
															377.331,
															687.193
														],
														[
															379.525,
															682.855
														],
														[
															381.456,
															678.84
														],
														[
															383,
															675
														],
														[
															386.243,
															664.747
														],
														[
															388.928,
															654.738
														],
														[
															391.148,
															645.109
														],
														[
															393,
															636
														],
														[
															396.833,
															613.621
														],
														[
															399.76,
															591.76
														],
														[
															402.057,
															570.27
														],
														[
															404,
															549
														],
														[
															409.989,
															456.202
														],
														[
															412.076,
															361.439
														],
														[
															410.375,
															266.957
														],
														[
															405,
															175
														],
														[
															402.109,
															141.207
														],
														[
															398.442,
															108.506
														],
														[
															393.304,
															77.053
														],
														[
															386,
															47
														],
														[
															383.069,
															37.838
														],
														[
															379.017,
															27.832
														],
														[
															373.956,
															19.41
														],
														[
															368,
															15
														],
														[
															365.098,
															14.652
														],
														[
															361.396,
															14.606
														],
														[
															357.996,
															14.757
														],
														[
															356,
															15
														],
														[
															355.569,
															15.229
														],
														[
															355.314,
															15.543
														],
														[
															355.151,
															15.836
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 26,
											"s": [
												{
													"i": [
														[
															0.023,
															-0.013
														],
														[
															0.147,
															-0.096
														],
														[
															0.106,
															-0.086
														],
														[
															0.075,
															-0.087
														],
														[
															0.055,
															-0.097
														],
														[
															0.046,
															-0.119
														],
														[
															0.047,
															-0.15
														],
														[
															0.059,
															-0.192
														],
														[
															0.081,
															-0.244
														],
														[
															0.799,
															-3.053
														],
														[
															0.652,
															-3.18
														],
														[
															0.53,
															-3.297
														],
														[
															0.433,
															-3.403
														],
														[
															0.361,
															-3.499
														],
														[
															0.315,
															-3.584
														],
														[
															0.293,
															-3.658
														],
														[
															0.297,
															-3.722
														],
														[
															0.694,
															-11.001
														],
														[
															0.538,
															-11.1
														],
														[
															0.401,
															-11.198
														],
														[
															0.283,
															-11.295
														],
														[
															0.183,
															-11.391
														],
														[
															0.103,
															-11.485
														],
														[
															0.042,
															-11.578
														],
														[
															0,
															-11.669
														],
														[
															0.003,
															-3.845
														],
														[
															0,
															-3.814
														],
														[
															-0.009,
															-3.783
														],
														[
															-0.025,
															-3.751
														],
														[
															-0.047,
															-3.719
														],
														[
															-0.075,
															-3.686
														],
														[
															-0.11,
															-3.653
														],
														[
															-0.151,
															-3.619
														],
														[
															-0.109,
															-4.235
														],
														[
															-0.065,
															-4.256
														],
														[
															-0.045,
															-4.289
														],
														[
															-0.051,
															-4.333
														],
														[
															-0.081,
															-4.389
														],
														[
															-0.135,
															-4.456
														],
														[
															-0.214,
															-4.535
														],
														[
															-0.655,
															-10.973
														],
														[
															-0.876,
															-10.978
														],
														[
															-1.158,
															-10.516
														],
														[
															-1.501,
															-9.588
														],
														[
															-0.336,
															-2.598
														],
														[
															-0.521,
															-2.856
														],
														[
															-0.8,
															-2.33
														],
														[
															-1.172,
															-1.02
														],
														[
															-0.764,
															-0.388
														],
														[
															-0.86,
															-0.191
														],
														[
															-0.916,
															0.042
														],
														[
															-0.932,
															0.312
														],
														[
															-0.585,
															0.283
														],
														[
															-0.286,
															0.382
														],
														[
															-0.184,
															0.658
														],
														[
															-0.277,
															1.111
														],
														[
															-0.052,
															0.81
														],
														[
															-0.019,
															0.907
														],
														[
															-0.083,
															1.018
														],
														[
															-0.243,
															1.144
														],
														[
															-0.47,
															1.631
														],
														[
															-0.466,
															1.449
														],
														[
															-0.387,
															1.343
														],
														[
															-0.236,
															1.314
														],
														[
															-0.508,
															3.741
														],
														[
															-0.377,
															3.533
														],
														[
															-0.305,
															3.276
														],
														[
															-0.293,
															2.97
														],
														[
															-0.615,
															7.605
														],
														[
															-0.482,
															7.348
														],
														[
															-0.376,
															7.069
														],
														[
															-0.298,
															6.766
														],
														[
															-0.342,
															11.215
														],
														[
															-0.214,
															11.012
														],
														[
															-0.14,
															11.291
														],
														[
															-0.119,
															12.053
														],
														[
															0.05,
															26.5
														],
														[
															0.54,
															26.863
														],
														[
															1.22,
															26.431
														],
														[
															2.089,
															25.206
														],
														[
															0.487,
															5.422
														],
														[
															0.598,
															5.127
														],
														[
															0.812,
															4.892
														],
														[
															1.13,
															4.717
														],
														[
															0.465,
															1.82
														],
														[
															0.556,
															1.355
														],
														[
															0.813,
															0.857
														],
														[
															1.237,
															0.328
														],
														[
															1.129,
															-0.037
														],
														[
															0.98,
															-0.192
														],
														[
															0.611,
															-0.184
														]
													],
													"o": [
														[
															-0.198,
															0.116
														],
														[
															-0.147,
															0.096
														],
														[
															-0.106,
															0.086
														],
														[
															-0.075,
															0.087
														],
														[
															-0.055,
															0.097
														],
														[
															-0.046,
															0.119
														],
														[
															-0.047,
															0.15
														],
														[
															-0.059,
															0.192
														],
														[
															-0.971,
															2.916
														],
														[
															-0.799,
															3.053
														],
														[
															-0.652,
															3.18
														],
														[
															-0.53,
															3.297
														],
														[
															-0.433,
															3.403
														],
														[
															-0.361,
															3.499
														],
														[
															-0.315,
															3.584
														],
														[
															-0.293,
															3.658
														],
														[
															-0.869,
															10.9
														],
														[
															-0.694,
															11.001
														],
														[
															-0.538,
															11.1
														],
														[
															-0.401,
															11.198
														],
														[
															-0.283,
															11.295
														],
														[
															-0.183,
															11.391
														],
														[
															-0.103,
															11.485
														],
														[
															-0.042,
															11.578
														],
														[
															0,
															3.875
														],
														[
															-0.003,
															3.845
														],
														[
															0,
															3.814
														],
														[
															0.009,
															3.783
														],
														[
															0.025,
															3.751
														],
														[
															0.047,
															3.719
														],
														[
															0.075,
															3.686
														],
														[
															0.11,
															3.653
														],
														[
															0.177,
															4.226
														],
														[
															0.109,
															4.235
														],
														[
															0.065,
															4.256
														],
														[
															0.045,
															4.289
														],
														[
															0.051,
															4.333
														],
														[
															0.081,
															4.389
														],
														[
															0.135,
															4.456
														],
														[
															0.496,
															10.5
														],
														[
															0.655,
															10.973
														],
														[
															0.876,
															10.978
														],
														[
															1.158,
															10.516
														],
														[
															0.244,
															1.557
														],
														[
															0.336,
															2.598
														],
														[
															0.521,
															2.856
														],
														[
															0.8,
															2.33
														],
														[
															0.629,
															0.548
														],
														[
															0.764,
															0.388
														],
														[
															0.86,
															0.191
														],
														[
															0.916,
															-0.042
														],
														[
															1.079,
															-0.361
														],
														[
															0.585,
															-0.283
														],
														[
															0.286,
															-0.382
														],
														[
															0.184,
															-0.658
														],
														[
															0.182,
															-0.728
														],
														[
															0.052,
															-0.81
														],
														[
															0.019,
															-0.907
														],
														[
															0.083,
															-1.018
														],
														[
															0.401,
															-1.89
														],
														[
															0.47,
															-1.631
														],
														[
															0.466,
															-1.449
														],
														[
															0.387,
															-1.343
														],
														[
															0.7,
															-3.9
														],
														[
															0.508,
															-3.741
														],
														[
															0.377,
															-3.533
														],
														[
															0.305,
															-3.276
														],
														[
															0.774,
															-7.84
														],
														[
															0.615,
															-7.605
														],
														[
															0.482,
															-7.348
														],
														[
															0.376,
															-7.069
														],
														[
															0.523,
															-11.9
														],
														[
															0.342,
															-11.215
														],
														[
															0.214,
															-11.012
														],
														[
															0.14,
															-11.291
														],
														[
															0.251,
															-25.344
														],
														[
															-0.05,
															-26.5
														],
														[
															-0.54,
															-26.863
														],
														[
															-1.22,
															-26.431
														],
														[
															-0.479,
															-5.776
														],
														[
															-0.487,
															-5.422
														],
														[
															-0.598,
															-5.127
														],
														[
															-0.812,
															-4.892
														],
														[
															-0.54,
															-2.254
														],
														[
															-0.465,
															-1.82
														],
														[
															-0.556,
															-1.354
														],
														[
															-0.813,
															-0.857
														],
														[
															-1.057,
															-0.28
														],
														[
															-1.129,
															0.037
														],
														[
															-0.98,
															0.192
														],
														[
															-0.611,
															0.184
														]
													],
													"v": [
														[
															356,
															16
														],
														[
															355.485,
															16.315
														],
														[
															355.11,
															16.585
														],
														[
															354.841,
															16.842
														],
														[
															354.649,
															17.115
														],
														[
															354.5,
															17.436
														],
														[
															354.364,
															17.837
														],
														[
															354.208,
															18.348
														],
														[
															354,
															19
														],
														[
															351.352,
															27.956
														],
														[
															349.182,
															37.309
														],
														[
															347.416,
															47.027
														],
														[
															345.978,
															57.079
														],
														[
															344.793,
															67.434
														],
														[
															343.785,
															78.06
														],
														[
															342.879,
															88.926
														],
														[
															342,
															100
														],
														[
															339.659,
															132.852
														],
														[
															337.816,
															166.004
														],
														[
															336.412,
															199.452
														],
														[
															335.392,
															233.193
														],
														[
															334.697,
															267.223
														],
														[
															334.272,
															301.536
														],
														[
															334.058,
															336.13
														],
														[
															334,
															371
														],
														[
															333.993,
															382.58
														],
														[
															333.986,
															394.068
														],
														[
															333.997,
															405.465
														],
														[
															334.046,
															416.767
														],
														[
															334.151,
															427.973
														],
														[
															334.332,
															439.081
														],
														[
															334.609,
															450.091
														],
														[
															335,
															461
														],
														[
															335.422,
															473.689
														],
														[
															335.676,
															486.423
														],
														[
															335.835,
															499.239
														],
														[
															335.973,
															512.169
														],
														[
															336.164,
															525.25
														],
														[
															336.482,
															538.515
														],
														[
															337,
															552
														],
														[
															338.712,
															584.326
														],
														[
															340.993,
															617.369
														],
														[
															344.027,
															649.727
														],
														[
															348,
															680
														],
														[
															348.846,
															686.428
														],
														[
															350.108,
															694.805
														],
														[
															352.066,
															702.78
														],
														[
															355,
															708
														],
														[
															357.1,
															709.412
														],
														[
															359.546,
															710.29
														],
														[
															362.219,
															710.522
														],
														[
															365,
															710
														],
														[
															367.446,
															709.078
														],
														[
															368.703,
															708.125
														],
														[
															369.359,
															706.609
														],
														[
															370,
															704
														],
														[
															370.326,
															701.696
														],
														[
															370.408,
															699.123
														],
														[
															370.536,
															696.239
														],
														[
															371,
															693
														],
														[
															372.326,
															687.737
														],
														[
															373.749,
															683.136
														],
														[
															375.047,
															678.967
														],
														[
															376,
															675
														],
														[
															377.797,
															663.527
														],
														[
															379.109,
															652.605
														],
														[
															380.117,
															642.38
														],
														[
															381,
															633
														],
														[
															383.077,
															609.826
														],
														[
															384.716,
															587.39
														],
														[
															385.996,
															565.758
														],
														[
															387,
															545
														],
														[
															388.285,
															510.447
														],
														[
															389.106,
															477.228
														],
														[
															389.624,
															443.895
														],
														[
															390,
															409
														],
														[
															390.348,
															331.036
														],
														[
															389.51,
															250.794
														],
														[
															386.917,
															170.655
														],
														[
															382,
															93
														],
														[
															380.577,
															76.218
														],
														[
															378.976,
															60.41
														],
														[
															376.887,
															45.398
														],
														[
															374,
															31
														],
														[
															372.535,
															24.881
														],
														[
															371.046,
															20.111
														],
														[
															369.033,
															16.786
														],
														[
															366,
															15
														],
														[
															362.667,
															14.676
														],
														[
															359.449,
															15.06
														],
														[
															357.006,
															15.664
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 27,
											"s": [
												{
													"i": [
														[
															0.46,
															-0.566
														],
														[
															0.014,
															-0.063
														],
														[
															0.005,
															-0.086
														],
														[
															-0.002,
															-0.1
														],
														[
															-0.007,
															-0.106
														],
														[
															-0.009,
															-0.103
														],
														[
															-0.008,
															-0.092
														],
														[
															-0.005,
															-0.072
														],
														[
															0,
															-0.044
														],
														[
															0.028,
															-14.263
														],
														[
															0.047,
															-14.357
														],
														[
															0.059,
															-14.444
														],
														[
															0.062,
															-14.522
														],
														[
															0.058,
															-14.592
														],
														[
															0.047,
															-14.654
														],
														[
															0.027,
															-14.707
														],
														[
															0,
															-14.753
														],
														[
															0.052,
															-12.706
														],
														[
															0.075,
															-12.805
														],
														[
															0.07,
															-12.859
														],
														[
															0.035,
															-12.869
														],
														[
															-0.028,
															-12.834
														],
														[
															-0.12,
															-12.755
														],
														[
															-0.241,
															-12.631
														],
														[
															-0.391,
															-12.462
														],
														[
															0.044,
															-1.437
														],
														[
															0.082,
															-1.771
														],
														[
															0.085,
															-1.947
														],
														[
															0.053,
															-1.964
														],
														[
															-0.015,
															-1.823
														],
														[
															-0.118,
															-1.523
														],
														[
															-0.257,
															-1.066
														],
														[
															-0.431,
															-0.45
														],
														[
															-0.32,
															-0.143
														],
														[
															-0.417,
															-0.097
														],
														[
															-0.473,
															-0.05
														],
														[
															-0.486,
															-0.002
														],
														[
															-0.458,
															0.046
														],
														[
															-0.389,
															0.096
														],
														[
															-0.277,
															0.147
														],
														[
															-0.124,
															0.198
														],
														[
															-0.035,
															0.163
														],
														[
															0.002,
															0.191
														],
														[
															0.025,
															0.219
														],
														[
															0.035,
															0.248
														],
														[
															0.032,
															0.278
														],
														[
															0.016,
															0.308
														],
														[
															-0.014,
															0.339
														],
														[
															-0.056,
															0.371
														],
														[
															-0.088,
															1.052
														],
														[
															-0.068,
															1.283
														],
														[
															-0.05,
															1.427
														],
														[
															-0.035,
															1.483
														],
														[
															-0.022,
															1.452
														],
														[
															-0.012,
															1.333
														],
														[
															-0.005,
															1.128
														],
														[
															0,
															0.835
														],
														[
															-0.027,
															5.759
														],
														[
															-0.047,
															5.566
														],
														[
															-0.059,
															5.422
														],
														[
															-0.062,
															5.327
														],
														[
															-0.059,
															5.282
														],
														[
															-0.047,
															5.285
														],
														[
															-0.027,
															5.338
														],
														[
															0,
															5.44
														],
														[
															0.027,
															20.391
														],
														[
															0.047,
															20.463
														],
														[
															0.059,
															20.48
														],
														[
															0.062,
															20.44
														],
														[
															0.059,
															20.345
														],
														[
															0.047,
															20.194
														],
														[
															0.027,
															19.988
														],
														[
															0,
															19.725
														],
														[
															-0.032,
															1.288
														],
														[
															-0.049,
															1.419
														],
														[
															-0.052,
															1.496
														],
														[
															-0.039,
															1.519
														],
														[
															-0.012,
															1.488
														],
														[
															0.03,
															1.403
														],
														[
															0.086,
															1.264
														],
														[
															0.158,
															1.071
														],
														[
															0.056,
															0.637
														],
														[
															0.041,
															0.457
														],
														[
															0.083,
															0.314
														],
														[
															0.18,
															0.209
														],
														[
															0.333,
															0.141
														],
														[
															0.541,
															0.111
														],
														[
															0.805,
															0.118
														],
														[
															0.447,
															0.087
														],
														[
															0.598,
															0.011
														],
														[
															0.602,
															-0.207
														]
													],
													"o": [
														[
															-0.026,
															0.032
														],
														[
															-0.014,
															0.063
														],
														[
															-0.005,
															0.086
														],
														[
															0.002,
															0.1
														],
														[
															0.006,
															0.106
														],
														[
															0.009,
															0.103
														],
														[
															0.008,
															0.092
														],
														[
															0.005,
															0.072
														],
														[
															0,
															14.16
														],
														[
															-0.028,
															14.263
														],
														[
															-0.047,
															14.357
														],
														[
															-0.059,
															14.444
														],
														[
															-0.062,
															14.522
														],
														[
															-0.058,
															14.592
														],
														[
															-0.047,
															14.654
														],
														[
															-0.027,
															14.707
														],
														[
															0,
															12.562
														],
														[
															-0.052,
															12.706
														],
														[
															-0.075,
															12.805
														],
														[
															-0.07,
															12.859
														],
														[
															-0.035,
															12.869
														],
														[
															0.028,
															12.834
														],
														[
															0.12,
															12.755
														],
														[
															0.241,
															12.631
														],
														[
															0.03,
															0.946
														],
														[
															-0.044,
															1.437
														],
														[
															-0.082,
															1.771
														],
														[
															-0.085,
															1.947
														],
														[
															-0.053,
															1.964
														],
														[
															0.015,
															1.823
														],
														[
															0.118,
															1.523
														],
														[
															0.257,
															1.066
														],
														[
															0.181,
															0.189
														],
														[
															0.32,
															0.143
														],
														[
															0.417,
															0.097
														],
														[
															0.473,
															0.05
														],
														[
															0.486,
															0.002
														],
														[
															0.458,
															-0.046
														],
														[
															0.389,
															-0.096
														],
														[
															0.277,
															-0.147
														],
														[
															0.085,
															-0.136
														],
														[
															0.035,
															-0.163
														],
														[
															-0.002,
															-0.191
														],
														[
															-0.025,
															-0.219
														],
														[
															-0.035,
															-0.248
														],
														[
															-0.032,
															-0.278
														],
														[
															-0.016,
															-0.308
														],
														[
															0.014,
															-0.339
														],
														[
															0.111,
															-0.734
														],
														[
															0.088,
															-1.052
														],
														[
															0.068,
															-1.283
														],
														[
															0.05,
															-1.427
														],
														[
															0.035,
															-1.483
														],
														[
															0.022,
															-1.452
														],
														[
															0.012,
															-1.333
														],
														[
															0.005,
															-1.128
														],
														[
															0,
															-6.001
														],
														[
															0.027,
															-5.759
														],
														[
															0.047,
															-5.566
														],
														[
															0.059,
															-5.422
														],
														[
															0.062,
															-5.327
														],
														[
															0.059,
															-5.282
														],
														[
															0.047,
															-5.285
														],
														[
															0.027,
															-5.338
														],
														[
															0,
															-20.263
														],
														[
															-0.027,
															-20.391
														],
														[
															-0.047,
															-20.463
														],
														[
															-0.059,
															-20.48
														],
														[
															-0.062,
															-20.44
														],
														[
															-0.059,
															-20.345
														],
														[
															-0.047,
															-20.194
														],
														[
															-0.027,
															-19.988
														],
														[
															0,
															-1.104
														],
														[
															0.032,
															-1.288
														],
														[
															0.049,
															-1.419
														],
														[
															0.052,
															-1.496
														],
														[
															0.039,
															-1.519
														],
														[
															0.012,
															-1.488
														],
														[
															-0.03,
															-1.403
														],
														[
															-0.086,
															-1.264
														],
														[
															-0.126,
															-0.854
														],
														[
															-0.056,
															-0.637
														],
														[
															-0.041,
															-0.457
														],
														[
															-0.083,
															-0.314
														],
														[
															-0.18,
															-0.209
														],
														[
															-0.333,
															-0.141
														],
														[
															-0.541,
															-0.111
														],
														[
															-0.15,
															-0.022
														],
														[
															-0.447,
															-0.087
														],
														[
															-0.598,
															-0.011
														],
														[
															-0.602,
															0.207
														]
													],
													"v": [
														[
															357,
															16
														],
														[
															356.94,
															16.145
														],
														[
															356.912,
															16.371
														],
														[
															356.909,
															16.653
														],
														[
															356.922,
															16.964
														],
														[
															356.945,
															17.28
														],
														[
															356.971,
															17.575
														],
														[
															356.991,
															17.823
														],
														[
															357,
															18
														],
														[
															356.956,
															60.636
														],
														[
															356.842,
															103.568
														],
														[
															356.682,
															146.772
														],
														[
															356.499,
															190.222
														],
														[
															356.316,
															233.894
														],
														[
															356.156,
															277.764
														],
														[
															356.043,
															321.808
														],
														[
															356,
															366
														],
														[
															355.915,
															403.913
														],
														[
															355.717,
															442.19
														],
														[
															355.492,
															480.697
														],
														[
															355.327,
															519.301
														],
														[
															355.309,
															557.867
														],
														[
															355.525,
															596.262
														],
														[
															356.059,
															634.351
														],
														[
															357,
															672
														],
														[
															356.97,
															675.614
														],
														[
															356.771,
															680.466
														],
														[
															356.511,
															686.083
														],
														[
															356.296,
															691.988
														],
														[
															356.23,
															697.707
														],
														[
															356.422,
															702.765
														],
														[
															356.977,
															706.688
														],
														[
															358,
															709
														],
														[
															358.761,
															709.498
														],
														[
															359.877,
															709.86
														],
														[
															361.222,
															710.081
														],
														[
															362.671,
															710.161
														],
														[
															364.098,
															710.095
														],
														[
															365.379,
															709.881
														],
														[
															366.388,
															709.517
														],
														[
															367,
															709
														],
														[
															367.177,
															708.551
														],
														[
															367.224,
															708.019
														],
														[
															367.181,
															707.404
														],
														[
															367.087,
															706.703
														],
														[
															366.982,
															705.914
														],
														[
															366.906,
															705.035
														],
														[
															366.898,
															704.065
														],
														[
															367,
															703
														],
														[
															367.299,
															700.3
														],
														[
															367.533,
															696.775
														],
														[
															367.708,
															692.689
														],
														[
															367.835,
															688.303
														],
														[
															367.919,
															683.879
														],
														[
															367.969,
															679.679
														],
														[
															367.994,
															675.965
														],
														[
															368,
															673
														],
														[
															368.043,
															655.373
														],
														[
															368.156,
															638.398
														],
														[
															368.316,
															621.929
														],
														[
															368.5,
															605.818
														],
														[
															368.684,
															589.917
														],
														[
															368.844,
															574.078
														],
														[
															368.957,
															558.155
														],
														[
															369,
															542
														],
														[
															368.957,
															481.004
														],
														[
															368.844,
															419.708
														],
														[
															368.684,
															358.279
														],
														[
															368.5,
															296.885
														],
														[
															368.316,
															235.692
														],
														[
															368.156,
															174.869
														],
														[
															368.043,
															114.583
														],
														[
															368,
															55
														],
														[
															368.052,
															51.398
														],
														[
															368.178,
															47.323
														],
														[
															368.333,
															42.937
														],
														[
															368.474,
															38.401
														],
														[
															368.555,
															33.877
														],
														[
															368.533,
															29.528
														],
														[
															368.363,
															25.515
														],
														[
															368,
															22
														],
														[
															367.741,
															19.773
														],
														[
															367.609,
															18.142
														],
														[
															367.437,
															16.995
														],
														[
															367.057,
															16.22
														],
														[
															366.303,
															15.703
														],
														[
															365.006,
															15.334
														],
														[
															363,
															15
														],
														[
															362.067,
															14.801
														],
														[
															360.464,
															14.618
														],
														[
															358.628,
															14.876
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 28,
											"s": [
												{
													"i": [
														[
															0.022,
															-0.012
														],
														[
															0.148,
															-0.098
														],
														[
															0.103,
															-0.088
														],
														[
															0.071,
															-0.088
														],
														[
															0.051,
															-0.098
														],
														[
															0.043,
															-0.118
														],
														[
															0.047,
															-0.149
														],
														[
															0.064,
															-0.19
														],
														[
															0.092,
															-0.24
														],
														[
															0.429,
															-1.391
														],
														[
															0.365,
															-1.462
														],
														[
															0.31,
															-1.53
														],
														[
															0.265,
															-1.594
														],
														[
															0.23,
															-1.654
														],
														[
															0.206,
															-1.71
														],
														[
															0.191,
															-1.762
														],
														[
															0.186,
															-1.811
														],
														[
															0.184,
															-1.713
														],
														[
															0.191,
															-1.743
														],
														[
															0.191,
															-1.763
														],
														[
															0.184,
															-1.775
														],
														[
															0.171,
															-1.777
														],
														[
															0.151,
															-1.77
														],
														[
															0.125,
															-1.753
														],
														[
															0.092,
															-1.727
														],
														[
															0.497,
															-11.109
														],
														[
															0.395,
															-10.893
														],
														[
															0.304,
															-10.802
														],
														[
															0.223,
															-10.835
														],
														[
															0.152,
															-10.993
														],
														[
															0.091,
															-11.274
														],
														[
															0.04,
															-11.681
														],
														[
															0,
															-12.212
														],
														[
															-0.003,
															-6.525
														],
														[
															-0.02,
															-6.414
														],
														[
															-0.049,
															-6.337
														],
														[
															-0.092,
															-6.294
														],
														[
															-0.147,
															-6.285
														],
														[
															-0.215,
															-6.311
														],
														[
															-0.296,
															-6.372
														],
														[
															-0.084,
															-3.704
														],
														[
															-0.049,
															-3.76
														],
														[
															-0.066,
															-3.801
														],
														[
															-0.134,
															-3.827
														],
														[
															-0.325,
															-7.084
														],
														[
															-0.416,
															-7.322
														],
														[
															-0.508,
															-7.452
														],
														[
															-0.602,
															-7.474
														],
														[
															-0.551,
															-5.273
														],
														[
															-0.627,
															-4.61
														],
														[
															-0.762,
															-4.657
														],
														[
															-0.958,
															-5.412
														],
														[
															-0.183,
															-0.856
														],
														[
															-0.202,
															-0.887
														],
														[
															-0.168,
															-0.713
														],
														[
															-0.08,
															-0.333
														],
														[
															-0.043,
															-0.9
														],
														[
															-0.1,
															-0.306
														],
														[
															-0.632,
															-0.128
														],
														[
															-1.64,
															-0.365
														],
														[
															-1.361,
															0.539
														],
														[
															-0.675,
															1.246
														],
														[
															-0.352,
															1.584
														],
														[
															-0.391,
															1.553
														],
														[
															-0.425,
															1.867
														],
														[
															-0.372,
															1.776
														],
														[
															-0.261,
															1.395
														],
														[
															-0.091,
															0.727
														],
														[
															-0.856,
															11.103
														],
														[
															-0.553,
															11.244
														],
														[
															-0.42,
															11.019
														],
														[
															-0.458,
															10.428
														],
														[
															-0.511,
															26.52
														],
														[
															-0.079,
															27.393
														],
														[
															0.221,
															27.051
														],
														[
															0.389,
															25.494
														],
														[
															0.046,
															3.79
														],
														[
															0.064,
															3.845
														],
														[
															0.111,
															3.882
														],
														[
															0.186,
															3.903
														],
														[
															0.563,
															11.156
														],
														[
															0.695,
															11.114
														],
														[
															0.91,
															10.651
														],
														[
															1.207,
															9.766
														],
														[
															0.34,
															3.747
														],
														[
															0.655,
															3.901
														],
														[
															1.237,
															2.829
														],
														[
															2.087,
															0.53
														],
														[
															1.033,
															-0.04
														],
														[
															0.858,
															-0.188
														],
														[
															0.52,
															-0.179
														]
													],
													"o": [
														[
															-0.204,
															0.118
														],
														[
															-0.148,
															0.098
														],
														[
															-0.103,
															0.088
														],
														[
															-0.071,
															0.088
														],
														[
															-0.051,
															0.098
														],
														[
															-0.043,
															0.118
														],
														[
															-0.047,
															0.149
														],
														[
															-0.064,
															0.19
														],
														[
															-0.504,
															1.315
														],
														[
															-0.429,
															1.391
														],
														[
															-0.365,
															1.462
														],
														[
															-0.31,
															1.53
														],
														[
															-0.265,
															1.594
														],
														[
															-0.23,
															1.654
														],
														[
															-0.206,
															1.71
														],
														[
															-0.191,
															1.762
														],
														[
															-0.171,
															1.674
														],
														[
															-0.184,
															1.713
														],
														[
															-0.191,
															1.743
														],
														[
															-0.191,
															1.763
														],
														[
															-0.184,
															1.775
														],
														[
															-0.171,
															1.777
														],
														[
															-0.151,
															1.77
														],
														[
															-0.125,
															1.753
														],
														[
															-0.608,
															11.449
														],
														[
															-0.497,
															11.109
														],
														[
															-0.395,
															10.893
														],
														[
															-0.304,
															10.802
														],
														[
															-0.223,
															10.835
														],
														[
															-0.152,
															10.993
														],
														[
															-0.091,
															11.274
														],
														[
															-0.04,
															11.681
														],
														[
															0,
															6.67
														],
														[
															0.003,
															6.525
														],
														[
															0.02,
															6.414
														],
														[
															0.049,
															6.337
														],
														[
															0.092,
															6.294
														],
														[
															0.147,
															6.285
														],
														[
															0.215,
															6.311
														],
														[
															0.169,
															3.633
														],
														[
															0.084,
															3.704
														],
														[
															0.049,
															3.76
														],
														[
															0.066,
															3.801
														],
														[
															0.235,
															6.736
														],
														[
															0.325,
															7.084
														],
														[
															0.416,
															7.322
														],
														[
															0.508,
															7.452
														],
														[
															0.535,
															6.646
														],
														[
															0.551,
															5.273
														],
														[
															0.627,
															4.61
														],
														[
															0.762,
															4.657
														],
														[
															0.11,
															0.62
														],
														[
															0.183,
															0.856
														],
														[
															0.203,
															0.887
														],
														[
															0.168,
															0.713
														],
														[
															0.46,
															1.911
														],
														[
															0.043,
															0.9
														],
														[
															0.1,
															0.306
														],
														[
															0.632,
															0.128
														],
														[
															2.41,
															0.537
														],
														[
															1.361,
															-0.539
														],
														[
															0.675,
															-1.246
														],
														[
															0.352,
															-1.584
														],
														[
															0.421,
															-1.67
														],
														[
															0.425,
															-1.867
														],
														[
															0.372,
															-1.776
														],
														[
															0.261,
															-1.395
														],
														[
															1.332,
															-10.597
														],
														[
															0.856,
															-11.103
														],
														[
															0.553,
															-11.244
														],
														[
															0.42,
															-11.019
														],
														[
															1.074,
															-24.433
														],
														[
															0.511,
															-26.52
														],
														[
															0.079,
															-27.393
														],
														[
															-0.221,
															-27.051
														],
														[
															-0.057,
															-3.718
														],
														[
															-0.046,
															-3.79
														],
														[
															-0.064,
															-3.845
														],
														[
															-0.111,
															-3.882
														],
														[
															-0.513,
															-10.776
														],
														[
															-0.563,
															-11.156
														],
														[
															-0.695,
															-11.114
														],
														[
															-0.91,
															-10.651
														],
														[
															-0.292,
															-2.367
														],
														[
															-0.34,
															-3.747
														],
														[
															-0.655,
															-3.901
														],
														[
															-1.237,
															-2.829
														],
														[
															-1.048,
															-0.266
														],
														[
															-1.033,
															0.04
														],
														[
															-0.858,
															0.188
														],
														[
															-0.52,
															0.179
														]
													],
													"v": [
														[
															357,
															16
														],
														[
															356.476,
															16.321
														],
														[
															356.103,
															16.596
														],
														[
															355.844,
															16.857
														],
														[
															355.664,
															17.133
														],
														[
															355.526,
															17.454
														],
														[
															355.394,
															17.852
														],
														[
															355.231,
															18.357
														],
														[
															355,
															19
														],
														[
															353.603,
															23.06
														],
														[
															352.415,
															27.34
														],
														[
															351.406,
															31.829
														],
														[
															350.546,
															36.515
														],
														[
															349.805,
															41.386
														],
														[
															349.153,
															46.432
														],
														[
															348.562,
															51.64
														],
														[
															348,
															57
														],
														[
															347.465,
															62.082
														],
														[
															346.9,
															67.268
														],
														[
															346.326,
															72.529
														],
														[
															345.762,
															77.838
														],
														[
															345.227,
															83.168
														],
														[
															344.742,
															88.49
														],
														[
															344.327,
															93.777
														],
														[
															344,
															99
														],
														[
															342.345,
															132.805
														],
														[
															341.009,
															165.776
														],
														[
															339.962,
															198.287
														],
														[
															339.175,
															230.711
														],
														[
															338.615,
															263.421
														],
														[
															338.253,
															296.79
														],
														[
															338.058,
															331.192
														],
														[
															338,
															367
														],
														[
															338.002,
															386.784
														],
														[
															338.034,
															406.183
														],
														[
															338.134,
															425.3
														],
														[
															338.342,
															444.237
														],
														[
															338.696,
															463.097
														],
														[
															339.236,
															481.984
														],
														[
															340,
															501
														],
														[
															340.366,
															512.009
														],
														[
															340.553,
															523.208
														],
														[
															340.713,
															534.554
														],
														[
															341,
															546
														],
														[
															341.84,
															566.757
														],
														[
															342.95,
															588.394
														],
														[
															344.335,
															610.583
														],
														[
															346,
															633
														],
														[
															347.614,
															650.702
														],
														[
															349.366,
															665.35
														],
														[
															351.434,
															679.074
														],
														[
															354,
															694
														],
														[
															354.453,
															696.264
														],
														[
															355.044,
															698.929
														],
														[
															355.614,
															701.38
														],
														[
															356,
															703
														],
														[
															356.636,
															707.113
														],
														[
															356.731,
															708.818
														],
														[
															357.711,
															709.364
														],
														[
															361,
															710
														],
														[
															366.565,
															709.904
														],
														[
															369.528,
															707.134
														],
														[
															370.977,
															702.797
														],
														[
															372,
															698
														],
														[
															373.284,
															692.621
														],
														[
															374.494,
															687.084
														],
														[
															375.458,
															682.255
														],
														[
															376,
															679
														],
														[
															379.239,
															646.358
														],
														[
															381.31,
															612.746
														],
														[
															382.725,
															579.261
														],
														[
															384,
															547
														],
														[
															386.344,
															470.266
														],
														[
															387.195,
															389.092
														],
														[
															386.949,
															307.122
														],
														[
															386,
															228
														],
														[
															385.852,
															216.734
														],
														[
															385.694,
															205.277
														],
														[
															385.438,
															193.682
														],
														[
															385,
															182
														],
														[
															383.406,
															148.996
														],
														[
															381.54,
															115.485
														],
														[
															379.154,
															82.731
														],
														[
															376,
															52
														],
														[
															375.118,
															42.523
														],
														[
															373.692,
															30.745
														],
														[
															370.92,
															20.344
														],
														[
															366,
															15
														],
														[
															362.837,
															14.7
														],
														[
															359.961,
															15.082
														],
														[
															357.853,
															15.673
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 29,
											"s": [
												{
													"i": [
														[
															0.059,
															-0.022
														],
														[
															1.141,
															-1.026
														],
														[
															0.964,
															-1.444
														],
														[
															0.816,
															-1.759
														],
														[
															0.695,
															-1.971
														],
														[
															0.603,
															-2.079
														],
														[
															0.539,
															-2.084
														],
														[
															0.503,
															-1.986
														],
														[
															0.975,
															-5.102
														],
														[
															0.766,
															-5.154
														],
														[
															0.658,
															-5.225
														],
														[
															0.652,
															-5.316
														],
														[
															0.269,
															-1.773
														],
														[
															0.276,
															-1.743
														],
														[
															0.244,
															-1.724
														],
														[
															0.172,
															-1.714
														],
														[
															0.363,
															-3.827
														],
														[
															0.333,
															-3.743
														],
														[
															0.304,
															-3.67
														],
														[
															0.275,
															-3.607
														],
														[
															0.568,
															-11.44
														],
														[
															0.409,
															-11.42
														],
														[
															0.387,
															-11.27
														],
														[
															0.501,
															-10.989
														],
														[
															0.033,
															-3.952
														],
														[
															-0.044,
															-4.073
														],
														[
															-0.055,
															-4.21
														],
														[
															0,
															-4.362
														],
														[
															-0.366,
															-15.836
														],
														[
															-0.693,
															-15.624
														],
														[
															-0.98,
															-15.101
														],
														[
															-1.227,
															-14.266
														],
														[
															-1.049,
															-10.937
														],
														[
															-1.428,
															-10.849
														],
														[
															-2.04,
															-10.238
														],
														[
															-2.885,
															-9.102
														],
														[
															-0.51,
															-1.298
														],
														[
															-0.609,
															-1.419
														],
														[
															-0.67,
															-1.536
														],
														[
															-0.692,
															-1.65
														],
														[
															-0.275,
															-0.248
														],
														[
															-0.325,
															-0.242
														],
														[
															-0.263,
															-0.248
														],
														[
															-0.087,
															-0.265
														],
														[
															-0.08,
															-1.553
														],
														[
															-0.02,
															-1.251
														],
														[
															-0.43,
															-0.947
														],
														[
															-1.309,
															-0.643
														],
														[
															-1.015,
															-0.108
														],
														[
															-1.214,
															0.01
														],
														[
															-1.092,
															0.114
														],
														[
															-0.648,
															0.201
														],
														[
															-1.513,
															1.869
														],
														[
															-1.221,
															2.432
														],
														[
															-0.848,
															2.221
														],
														[
															-0.392,
															1.239
														],
														[
															-0.177,
															0.85
														],
														[
															-0.136,
															0.844
														],
														[
															-0.141,
															0.822
														],
														[
															-0.192,
															0.785
														],
														[
															-0.639,
															2.482
														],
														[
															-0.589,
															2.375
														],
														[
															-0.53,
															2.455
														],
														[
															-0.463,
															2.723
														],
														[
															-0.265,
															1.769
														],
														[
															-0.245,
															1.774
														],
														[
															-0.232,
															1.743
														],
														[
															-0.227,
															1.677
														],
														[
															-0.652,
															5.675
														],
														[
															-0.572,
															5.726
														],
														[
															-0.509,
															5.688
														],
														[
															-0.463,
															5.561
														],
														[
															-0.901,
															15.74
														],
														[
															-0.548,
															15.767
														],
														[
															-0.248,
															15.769
														],
														[
															0,
															15.745
														],
														[
															0.152,
															16.008
														],
														[
															0.422,
															15.427
														],
														[
															0.809,
															15.581
														],
														[
															1.313,
															16.469
														],
														[
															1.072,
															11.251
														],
														[
															1.391,
															10.912
														],
														[
															1.874,
															10.455
														],
														[
															2.52,
															9.88
														],
														[
															1.292,
															4.324
														],
														[
															1.993,
															3.38
														],
														[
															3.204,
															1.491
														],
														[
															4.926,
															-1.343
														],
														[
															0.11,
															-0.096
														],
														[
															0.064,
															-0.107
														],
														[
															0.047,
															-0.082
														]
													],
													"o": [
														[
															-1.347,
															0.504
														],
														[
															-1.141,
															1.026
														],
														[
															-0.964,
															1.444
														],
														[
															-0.816,
															1.759
														],
														[
															-0.695,
															1.971
														],
														[
															-0.603,
															2.079
														],
														[
															-0.539,
															2.084
														],
														[
															-1.285,
															5.069
														],
														[
															-0.975,
															5.102
														],
														[
															-0.766,
															5.154
														],
														[
															-0.658,
															5.225
														],
														[
															-0.222,
															1.813
														],
														[
															-0.269,
															1.773
														],
														[
															-0.276,
															1.743
														],
														[
															-0.244,
															1.724
														],
														[
															-0.392,
															3.92
														],
														[
															-0.363,
															3.827
														],
														[
															-0.333,
															3.743
														],
														[
															-0.304,
															3.67
														],
														[
															-0.864,
															11.331
														],
														[
															-0.568,
															11.44
														],
														[
															-0.409,
															11.42
														],
														[
															-0.387,
															11.27
														],
														[
															-0.175,
															3.846
														],
														[
															-0.033,
															3.952
														],
														[
															0.044,
															4.073
														],
														[
															0.055,
															4.21
														],
														[
															0,
															15.736
														],
														[
															0.366,
															15.836
														],
														[
															0.693,
															15.624
														],
														[
															0.98,
															15.101
														],
														[
															0.903,
															10.5
														],
														[
															1.049,
															10.937
														],
														[
															1.428,
															10.849
														],
														[
															2.04,
															10.238
														],
														[
															0.372,
															1.173
														],
														[
															0.51,
															1.298
														],
														[
															0.609,
															1.419
														],
														[
															0.67,
															1.536
														],
														[
															0.112,
															0.266
														],
														[
															0.275,
															0.248
														],
														[
															0.325,
															0.242
														],
														[
															0.263,
															0.248
														],
														[
															0.609,
															1.854
														],
														[
															0.08,
															1.553
														],
														[
															0.02,
															1.251
														],
														[
															0.43,
															0.947
														],
														[
															0.494,
															0.243
														],
														[
															1.015,
															0.108
														],
														[
															1.214,
															-0.01
														],
														[
															1.092,
															-0.114
														],
														[
															1.722,
															-0.535
														],
														[
															1.513,
															-1.869
														],
														[
															1.221,
															-2.431
														],
														[
															0.848,
															-2.221
														],
														[
															0.265,
															-0.84
														],
														[
															0.177,
															-0.85
														],
														[
															0.135,
															-0.844
														],
														[
															0.141,
															-0.822
														],
														[
															0.681,
															-2.778
														],
														[
															0.639,
															-2.482
														],
														[
															0.589,
															-2.375
														],
														[
															0.53,
															-2.455
														],
														[
															0.294,
															-1.727
														],
														[
															0.265,
															-1.769
														],
														[
															0.245,
															-1.774
														],
														[
															0.232,
															-1.743
														],
														[
															0.75,
															-5.534
														],
														[
															0.652,
															-5.675
														],
														[
															0.572,
															-5.726
														],
														[
															0.509,
															-5.688
														],
														[
															1.306,
															-15.687
														],
														[
															0.901,
															-15.74
														],
														[
															0.548,
															-15.767
														],
														[
															0.248,
															-15.769
														],
														[
															0,
															-17.323
														],
														[
															-0.152,
															-16.008
														],
														[
															-0.422,
															-15.427
														],
														[
															-0.809,
															-15.581
														],
														[
															-0.915,
															-11.472
														],
														[
															-1.072,
															-11.251
														],
														[
															-1.391,
															-10.912
														],
														[
															-1.874,
															-10.455
														],
														[
															-1.103,
															-4.323
														],
														[
															-1.292,
															-4.324
														],
														[
															-1.993,
															-3.38
														],
														[
															-3.204,
															-1.491
														],
														[
															-0.184,
															0.05
														],
														[
															-0.11,
															0.096
														],
														[
															-0.064,
															0.107
														],
														[
															-0.047,
															0.082
														]
													],
													"v": [
														[
															356,
															16
														],
														[
															352.275,
															18.32
														],
														[
															349.123,
															22.05
														],
														[
															346.461,
															26.88
														],
														[
															344.202,
															32.499
														],
														[
															342.262,
															38.599
														],
														[
															340.556,
															44.87
														],
														[
															339,
															51
														],
														[
															335.636,
															66.25
														],
														[
															333.051,
															81.629
														],
														[
															330.941,
															97.193
														],
														[
															329,
															113
														],
														[
															328.252,
															118.376
														],
														[
															327.423,
															123.648
														],
														[
															326.633,
															128.845
														],
														[
															326,
															134
														],
														[
															324.868,
															145.617
														],
														[
															323.825,
															156.97
														],
														[
															322.869,
															168.087
														],
														[
															322,
															179
														],
														[
															319.887,
															213.189
														],
														[
															318.456,
															247.512
														],
														[
															317.298,
															281.579
														],
														[
															316,
															315
														],
														[
															315.704,
															326.693
														],
														[
															315.737,
															338.726
														],
														[
															315.901,
															351.146
														],
														[
															316,
															364
														],
														[
															316.56,
															411.437
														],
														[
															318.159,
															458.706
														],
														[
															320.679,
															504.872
														],
														[
															324,
															549
														],
														[
															326.87,
															581.287
														],
														[
															330.528,
															614.097
														],
														[
															335.672,
															645.859
														],
														[
															343,
															675
														],
														[
															344.332,
															678.708
														],
														[
															346.02,
															682.785
														],
														[
															347.948,
															687.22
														],
														[
															350,
															692
														],
														[
															350.608,
															692.769
														],
														[
															351.537,
															693.502
														],
														[
															352.447,
															694.234
														],
														[
															353,
															695
														],
														[
															353.916,
															700.111
														],
														[
															353.95,
															704.317
														],
														[
															354.508,
															707.614
														],
														[
															357,
															710
														],
														[
															359.345,
															710.523
														],
														[
															362.769,
															710.666
														],
														[
															366.31,
															710.476
														],
														[
															369,
															710
														],
														[
															373.874,
															706.201
														],
														[
															377.996,
															699.557
														],
														[
															381.12,
															692.384
														],
														[
															383,
															687
														],
														[
															383.652,
															684.463
														],
														[
															384.11,
															681.919
														],
														[
															384.512,
															679.415
														],
														[
															385,
															677
														],
														[
															386.983,
															669.157
														],
														[
															388.827,
															661.918
														],
														[
															390.508,
															654.72
														],
														[
															392,
															647
														],
														[
															392.837,
															641.748
														],
														[
															393.6,
															636.425
														],
														[
															394.313,
															631.139
														],
														[
															395,
															626
														],
														[
															397.099,
															609.164
														],
														[
															398.93,
															592.04
														],
														[
															400.547,
															574.896
														],
														[
															402,
															558
														],
														[
															405.298,
															510.854
														],
														[
															407.459,
															463.588
														],
														[
															408.641,
															416.278
														],
														[
															409,
															369
														],
														[
															408.801,
															319.187
														],
														[
															407.97,
															272.218
														],
														[
															406.154,
															225.891
														],
														[
															403,
															178
														],
														[
															400.061,
															143.886
														],
														[
															396.407,
															110.612
														],
														[
															391.55,
															78.532
														],
														[
															385,
															48
														],
														[
															381.535,
															34.793
														],
														[
															376.735,
															23
														],
														[
															369.067,
															15.457
														],
														[
															357,
															15
														],
														[
															356.567,
															15.228
														],
														[
															356.314,
															15.542
														],
														[
															356.153,
															15.834
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 30,
											"s": [
												{
													"i": [
														[
															0.399,
															-0.111
														],
														[
															0.117,
															-0.004
														],
														[
															0.133,
															0.011
														],
														[
															0.142,
															0.019
														],
														[
															0.144,
															0.019
														],
														[
															0.138,
															0.013
														],
														[
															0.126,
															-0.001
														],
														[
															0.107,
															-0.023
														],
														[
															0.082,
															-0.051
														],
														[
															1.831,
															-1.841
														],
														[
															1.598,
															-2.277
														],
														[
															1.393,
															-2.621
														],
														[
															1.217,
															-2.872
														],
														[
															1.068,
															-3.03
														],
														[
															0.948,
															-3.096
														],
														[
															0.856,
															-3.069
														],
														[
															0.792,
															-2.95
														],
														[
															0.398,
															-1.621
														],
														[
															0.367,
															-1.621
														],
														[
															0.341,
															-1.622
														],
														[
															0.319,
															-1.624
														],
														[
															0.304,
															-1.626
														],
														[
															0.293,
															-1.628
														],
														[
															0.287,
															-1.631
														],
														[
															0.287,
															-1.635
														],
														[
															2.334,
															-19.389
														],
														[
															1.536,
															-20.478
														],
														[
															0.741,
															-21.113
														],
														[
															-0.05,
															-21.294
														],
														[
															-0.838,
															-21.021
														],
														[
															-1.623,
															-20.294
														],
														[
															-2.405,
															-19.113
														],
														[
															-3.184,
															-17.478
														],
														[
															-0.659,
															-3.334
														],
														[
															-0.714,
															-3.282
														],
														[
															-0.778,
															-3.214
														],
														[
															-0.851,
															-3.128
														],
														[
															-0.933,
															-3.026
														],
														[
															-1.024,
															-2.907
														],
														[
															-1.124,
															-2.771
														],
														[
															-1.233,
															-2.618
														],
														[
															-0.409,
															-0.764
														],
														[
															-0.448,
															-0.768
														],
														[
															-0.467,
															-0.757
														],
														[
															-0.466,
															-0.731
														],
														[
															-0.445,
															-0.689
														],
														[
															-0.405,
															-0.631
														],
														[
															-0.344,
															-0.559
														],
														[
															-0.448,
															-0.54
														],
														[
															-0.454,
															-0.481
														],
														[
															-0.404,
															-0.451
														],
														[
															-0.299,
															-0.449
														],
														[
															-0.287,
															-0.981
														],
														[
															-0.18,
															-1.034
														],
														[
															-0.178,
															-0.912
														],
														[
															-0.28,
															-0.612
														],
														[
															-0.209,
															-0.332
														],
														[
															-0.197,
															-0.043
														],
														[
															-0.389,
															-0.064
														],
														[
															-0.787,
															-0.395
														],
														[
															-1.818,
															-0.192
														],
														[
															-1.857,
															0.321
														],
														[
															-1.736,
															0.727
														],
														[
															-1.454,
															1.026
														],
														[
															-1.056,
															1.182
														],
														[
															-0.897,
															1.344
														],
														[
															-0.767,
															1.365
														],
														[
															-0.668,
															1.245
														],
														[
															-3.331,
															10.199
														],
														[
															-2.433,
															11.084
														],
														[
															-1.76,
															10.968
														],
														[
															-1.313,
															9.852
														],
														[
															-1.514,
															16.467
														],
														[
															-0.981,
															16.643
														],
														[
															-0.476,
															16.104
														],
														[
															0,
															14.851
														],
														[
															0.78,
															24.954
														],
														[
															1.874,
															24.194
														],
														[
															3.282,
															22.768
														],
														[
															5.004,
															20.675
														],
														[
															1.512,
															5.592
														],
														[
															1.806,
															5.237
														],
														[
															2.266,
															4.651
														],
														[
															2.893,
															3.836
														],
														[
															0.822,
															1.023
														],
														[
															0.871,
															0.939
														],
														[
															0.864,
															0.696
														],
														[
															0.799,
															0.294
														],
														[
															1.849,
															0.14
														],
														[
															1.768,
															-0.113
														],
														[
															1.285,
															-0.197
														]
													],
													"o": [
														[
															-0.094,
															0.026
														],
														[
															-0.117,
															0.004
														],
														[
															-0.133,
															-0.011
														],
														[
															-0.142,
															-0.019
														],
														[
															-0.144,
															-0.019
														],
														[
															-0.138,
															-0.013
														],
														[
															-0.126,
															0.001
														],
														[
															-0.107,
															0.023
														],
														[
															-2.091,
															1.313
														],
														[
															-1.831,
															1.841
														],
														[
															-1.598,
															2.277
														],
														[
															-1.393,
															2.621
														],
														[
															-1.217,
															2.872
														],
														[
															-1.068,
															3.03
														],
														[
															-0.948,
															3.096
														],
														[
															-0.856,
															3.069
														],
														[
															-0.435,
															1.621
														],
														[
															-0.398,
															1.621
														],
														[
															-0.367,
															1.621
														],
														[
															-0.341,
															1.622
														],
														[
															-0.319,
															1.624
														],
														[
															-0.304,
															1.626
														],
														[
															-0.293,
															1.628
														],
														[
															-0.287,
															1.631
														],
														[
															-3.135,
															17.846
														],
														[
															-2.334,
															19.389
														],
														[
															-1.536,
															20.478
														],
														[
															-0.741,
															21.113
														],
														[
															0.05,
															21.294
														],
														[
															0.838,
															21.021
														],
														[
															1.623,
															20.294
														],
														[
															2.405,
															19.113
														],
														[
															0.614,
															3.369
														],
														[
															0.659,
															3.334
														],
														[
															0.714,
															3.282
														],
														[
															0.778,
															3.214
														],
														[
															0.851,
															3.128
														],
														[
															0.933,
															3.026
														],
														[
															1.024,
															2.907
														],
														[
															1.124,
															2.771
														],
														[
															0.35,
															0.744
														],
														[
															0.409,
															0.764
														],
														[
															0.448,
															0.768
														],
														[
															0.467,
															0.757
														],
														[
															0.466,
															0.731
														],
														[
															0.445,
															0.689
														],
														[
															0.405,
															0.631
														],
														[
															0.386,
															0.627
														],
														[
															0.448,
															0.54
														],
														[
															0.454,
															0.481
														],
														[
															0.404,
															0.451
														],
														[
															0.5,
															0.75
														],
														[
															0.287,
															0.981
														],
														[
															0.18,
															1.034
														],
														[
															0.178,
															0.912
														],
														[
															0.427,
															0.931
														],
														[
															0.209,
															0.332
														],
														[
															0.197,
															0.043
														],
														[
															0.389,
															0.064
														],
														[
															1.617,
															0.812
														],
														[
															1.818,
															0.192
														],
														[
															1.857,
															-0.321
														],
														[
															1.736,
															-0.727
														],
														[
															1.246,
															-0.88
														],
														[
															1.056,
															-1.182
														],
														[
															0.897,
															-1.344
														],
														[
															0.767,
															-1.365
														],
														[
															4.455,
															-8.313
														],
														[
															3.331,
															-10.199
														],
														[
															2.433,
															-11.084
														],
														[
															1.76,
															-10.968
														],
														[
															2.077,
															-15.577
														],
														[
															1.514,
															-16.467
														],
														[
															0.981,
															-16.643
														],
														[
															0.476,
															-16.104
														],
														[
															0,
															-25.047
														],
														[
															-0.78,
															-24.954
														],
														[
															-1.874,
															-24.194
														],
														[
															-3.282,
															-22.768
														],
														[
															-1.384,
															-5.717
														],
														[
															-1.512,
															-5.592
														],
														[
															-1.806,
															-5.237
														],
														[
															-2.266,
															-4.651
														],
														[
															-0.716,
															-0.949
														],
														[
															-0.822,
															-1.023
														],
														[
															-0.871,
															-0.939
														],
														[
															-0.864,
															-0.696
														],
														[
															-1.528,
															-0.563
														],
														[
															-1.849,
															-0.14
														],
														[
															-1.768,
															0.113
														],
														[
															-1.285,
															0.197
														]
													],
													"v": [
														[
															355,
															16
														],
														[
															354.681,
															16.044
														],
														[
															354.305,
															16.031
														],
														[
															353.891,
															15.984
														],
														[
															353.462,
															15.925
														],
														[
															353.037,
															15.876
														],
														[
															352.638,
															15.857
														],
														[
															352.285,
															15.891
														],
														[
															352,
															16
														],
														[
															346.124,
															20.755
														],
														[
															340.988,
															26.956
														],
														[
															336.508,
															34.327
														],
														[
															332.6,
															42.589
														],
														[
															329.18,
															51.465
														],
														[
															326.163,
															60.677
														],
														[
															323.464,
															69.948
														],
														[
															321,
															79
														],
														[
															319.751,
															83.863
														],
														[
															318.605,
															88.726
														],
														[
															317.545,
															93.591
														],
														[
															316.556,
															98.46
														],
														[
															315.623,
															103.333
														],
														[
															314.73,
															108.213
														],
														[
															313.861,
															113.102
														],
														[
															313,
															118
														],
														[
															304.799,
															173.966
														],
														[
															298.996,
															233.88
														],
														[
															295.581,
															296.379
														],
														[
															294.546,
															360.103
														],
														[
															295.879,
															423.689
														],
														[
															299.573,
															485.774
														],
														[
															305.616,
															544.999
														],
														[
															314,
															600
														],
														[
															315.907,
															610.059
														],
														[
															317.965,
															619.989
														],
														[
															320.201,
															629.737
														],
														[
															322.642,
															639.254
														],
														[
															325.315,
															648.49
														],
														[
															328.248,
															657.393
														],
														[
															331.467,
															665.913
														],
														[
															335,
															674
														],
														[
															336.144,
															676.265
														],
														[
															337.436,
															678.567
														],
														[
															338.814,
															680.859
														],
														[
															340.22,
															683.094
														],
														[
															341.592,
															685.227
														],
														[
															342.873,
															687.211
														],
														[
															344,
															689
														],
														[
															345.264,
															690.743
														],
														[
															346.63,
															692.267
														],
														[
															347.931,
															693.658
														],
														[
															349,
															695
														],
														[
															350.155,
															697.64
														],
														[
															350.829,
															700.707
														],
														[
															351.339,
															703.67
														],
														[
															352,
															706
														],
														[
															352.902,
															707.818
														],
														[
															353.459,
															708.304
														],
														[
															354.287,
															708.388
														],
														[
															356,
															709
														],
														[
															361.192,
															710.478
														],
														[
															366.745,
															710.257
														],
														[
															372.174,
															708.657
														],
														[
															377,
															706
														],
														[
															380.446,
															702.873
														],
														[
															383.368,
															699.049
														],
														[
															385.856,
															694.95
														],
														[
															388,
															691
														],
														[
															399.623,
															662.982
														],
														[
															408.213,
															630.808
														],
														[
															414.446,
															597.481
														],
														[
															419,
															566
														],
														[
															424.38,
															517.754
														],
														[
															428.115,
															467.91
														],
														[
															430.293,
															418.611
														],
														[
															431,
															372
														],
														[
															429.908,
															296.831
														],
														[
															426.006,
															222.942
														],
														[
															418.35,
															152.332
														],
														[
															406,
															87
														],
														[
															401.699,
															69.979
														],
														[
															396.764,
															53.678
														],
														[
															390.697,
															38.788
														],
														[
															383,
															26
														],
														[
															380.679,
															23.002
														],
														[
															378.125,
															20.018
														],
														[
															375.508,
															17.526
														],
														[
															373,
															16
														],
														[
															367.833,
															14.987
														],
														[
															362.306,
															14.988
														],
														[
															357.626,
															15.496
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 31,
											"s": [
												{
													"i": [
														[
															0.582,
															-0.12
														],
														[
															0.168,
															0.004
														],
														[
															0.17,
															0.017
														],
														[
															0.167,
															0.004
														],
														[
															0.159,
															-0.034
														],
														[
															2.469,
															-1.574
														],
														[
															2.203,
															-2.231
														],
														[
															1.882,
															-2.542
														],
														[
															1.508,
															-2.506
														],
														[
															1.394,
															-2.823
														],
														[
															1.228,
															-2.899
														],
														[
															1.095,
															-2.876
														],
														[
															0.995,
															-2.755
														],
														[
															2.738,
															-9.727
														],
														[
															2.128,
															-9.921
														],
														[
															1.701,
															-10.358
														],
														[
															1.457,
															-11.038
														],
														[
															1.558,
															-19.277
														],
														[
															0.724,
															-20.136
														],
														[
															-0.196,
															-20.041
														],
														[
															-1.201,
															-18.991
														],
														[
															-1.551,
															-16.875
														],
														[
															-2.236,
															-15.908
														],
														[
															-3.192,
															-15.078
														],
														[
															-4.419,
															-14.388
														],
														[
															-0.485,
															-1.613
														],
														[
															-0.494,
															-1.606
														],
														[
															-0.511,
															-1.565
														],
														[
															-0.539,
															-1.489
														],
														[
															-0.984,
															-2.191
														],
														[
															-1.062,
															-2.105
														],
														[
															-1.047,
															-1.986
														],
														[
															-0.938,
															-1.835
														],
														[
															-0.313,
															-0.771
														],
														[
															-0.299,
															-0.771
														],
														[
															-0.337,
															-0.739
														],
														[
															-0.427,
															-0.676
														],
														[
															-0.621,
															-0.736
														],
														[
															-0.655,
															-0.685
														],
														[
															-0.581,
															-0.606
														],
														[
															-0.4,
															-0.501
														],
														[
															-0.167,
															-0.361
														],
														[
															-0.127,
															-0.355
														],
														[
															-0.147,
															-0.317
														],
														[
															-0.225,
															-0.245
														],
														[
															-0.373,
															-0.401
														],
														[
															-0.427,
															-0.439
														],
														[
															-0.466,
															-0.443
														],
														[
															-0.489,
															-0.415
														],
														[
															-0.71,
															-0.419
														],
														[
															-0.799,
															-0.434
														],
														[
															-0.564,
															-0.298
														],
														[
															-0.006,
															-0.01
														],
														[
															-0.102,
															-0.757
														],
														[
															0.044,
															-0.765
														],
														[
															-0.001,
															-0.751
														],
														[
															-0.237,
															-0.714
														],
														[
															-0.352,
															-0.579
														],
														[
															-0.387,
															-0.278
														],
														[
															-0.466,
															-0.185
														],
														[
															-0.59,
															-0.301
														],
														[
															-0.979,
															-0.192
														],
														[
															-1.045,
															-0.031
														],
														[
															-1.044,
															0.052
														],
														[
															-0.975,
															0.057
														],
														[
															-4.895,
															3.408
														],
														[
															-3.543,
															5.074
														],
														[
															-2.501,
															5.379
														],
														[
															-1.769,
															4.323
														],
														[
															-3.151,
															10.572
														],
														[
															-2.436,
															11.064
														],
														[
															-1.942,
															11.46
														],
														[
															-1.67,
															11.761
														],
														[
															-0.457,
															4.134
														],
														[
															-0.38,
															4.147
														],
														[
															-0.358,
															4.19
														],
														[
															-0.39,
															4.261
														],
														[
															-0.803,
															26.095
														],
														[
															0.749,
															25.94
														],
														[
															2.303,
															25.25
														],
														[
															3.858,
															24.024
														],
														[
															1.066,
															5.962
														],
														[
															1.073,
															5.127
														],
														[
															1.22,
															4.977
														],
														[
															1.508,
															5.51
														],
														[
															2.218,
															6.965
														],
														[
															2.608,
															6.509
														],
														[
															3.125,
															5.77
														],
														[
															4.77,
															5.18
														],
														[
															4.732,
															1.392
														],
														[
															4.241,
															-0.224
														]
													],
													"o": [
														[
															-0.16,
															0.033
														],
														[
															-0.168,
															-0.004
														],
														[
															-0.17,
															-0.017
														],
														[
															-0.167,
															-0.004
														],
														[
															-2.682,
															0.569
														],
														[
															-2.469,
															1.574
														],
														[
															-2.203,
															2.231
														],
														[
															-1.882,
															2.542
														],
														[
															-1.594,
															2.649
														],
														[
															-1.394,
															2.823
														],
														[
															-1.228,
															2.899
														],
														[
															-1.095,
															2.876
														],
														[
															-3.532,
															9.776
														],
														[
															-2.738,
															9.727
														],
														[
															-2.128,
															9.921
														],
														[
															-1.701,
															10.358
														],
														[
															-2.306,
															17.465
														],
														[
															-1.558,
															19.277
														],
														[
															-0.724,
															20.136
														],
														[
															0.196,
															20.041
														],
														[
															1.137,
															17.982
														],
														[
															1.551,
															16.875
														],
														[
															2.236,
															15.908
														],
														[
															3.192,
															15.078
														],
														[
															0.487,
															1.586
														],
														[
															0.485,
															1.613
														],
														[
															0.494,
															1.606
														],
														[
															0.511,
															1.565
														],
														[
															0.812,
															2.245
														],
														[
															0.984,
															2.191
														],
														[
															1.062,
															2.105
														],
														[
															1.047,
															1.986
														],
														[
															0.379,
															0.741
														],
														[
															0.313,
															0.771
														],
														[
															0.299,
															0.771
														],
														[
															0.337,
															0.739
														],
														[
															0.48,
															0.76
														],
														[
															0.621,
															0.736
														],
														[
															0.655,
															0.685
														],
														[
															0.581,
															0.606
														],
														[
															0.266,
															0.334
														],
														[
															0.167,
															0.361
														],
														[
															0.127,
															0.355
														],
														[
															0.147,
															0.317
														],
														[
															0.303,
															0.33
														],
														[
															0.373,
															0.401
														],
														[
															0.427,
															0.439
														],
														[
															0.466,
															0.443
														],
														[
															0.299,
															0.254
														],
														[
															0.71,
															0.419
														],
														[
															0.799,
															0.434
														],
														[
															0.564,
															0.298
														],
														[
															0.438,
															0.726
														],
														[
															0.102,
															0.757
														],
														[
															-0.044,
															0.765
														],
														[
															0.001,
															0.751
														],
														[
															0.361,
															1.088
														],
														[
															0.352,
															0.579
														],
														[
															0.387,
															0.278
														],
														[
															0.466,
															0.185
														],
														[
															0.846,
															0.432
														],
														[
															0.979,
															0.192
														],
														[
															1.045,
															0.031
														],
														[
															1.044,
															-0.052
														],
														[
															6.557,
															-0.381
														],
														[
															4.895,
															-3.408
														],
														[
															3.543,
															-5.074
														],
														[
															2.501,
															-5.379
														],
														[
															4.087,
															-9.984
														],
														[
															3.151,
															-10.572
														],
														[
															2.436,
															-11.064
														],
														[
															1.942,
															-11.46
														],
														[
															0.589,
															-4.149
														],
														[
															0.457,
															-4.134
														],
														[
															0.38,
															-4.147
														],
														[
															0.358,
															-4.19
														],
														[
															2.355,
															-25.716
														],
														[
															0.803,
															-26.095
														],
														[
															-0.749,
															-25.94
														],
														[
															-2.303,
															-25.25
														],
														[
															-1.201,
															-7.481
														],
														[
															-1.066,
															-5.962
														],
														[
															-1.073,
															-5.127
														],
														[
															-1.22,
															-4.977
														],
														[
															-1.954,
															-7.14
														],
														[
															-2.218,
															-6.965
														],
														[
															-2.608,
															-6.509
														],
														[
															-3.188,
															-5.887
														],
														[
															-4.77,
															-5.18
														],
														[
															-3.453,
															-1.016
														],
														[
															-4.241,
															0.224
														]
													],
													"v": [
														[
															354,
															16
														],
														[
															353.508,
															16.037
														],
														[
															353,
															15.999
														],
														[
															352.492,
															15.962
														],
														[
															352,
															16
														],
														[
															344.261,
															19.301
														],
														[
															337.24,
															25.095
														],
														[
															331.099,
															32.341
														],
														[
															326,
															40
														],
														[
															321.526,
															48.233
														],
														[
															317.602,
															56.841
														],
														[
															314.127,
															65.528
														],
														[
															311,
															74
														],
														[
															301.641,
															103.195
														],
														[
															294.389,
															132.608
														],
														[
															288.692,
															162.966
														],
														[
															284,
															195
														],
														[
															278.183,
															250.352
														],
														[
															274.739,
															309.71
														],
														[
															273.926,
															370.214
														],
														[
															276,
															429
														],
														[
															279.965,
															481.251
														],
														[
															285.578,
															530.391
														],
														[
															293.652,
															576.835
														],
														[
															305,
															621
														],
														[
															306.456,
															625.808
														],
														[
															307.922,
															630.646
														],
														[
															309.427,
															635.411
														],
														[
															311,
															640
														],
														[
															313.719,
															646.663
														],
														[
															316.812,
															653.115
														],
														[
															320,
															659.26
														],
														[
															323,
															665
														],
														[
															324.024,
															667.276
														],
														[
															324.928,
															669.598
														],
														[
															325.868,
															671.87
														],
														[
															327,
															674
														],
														[
															328.678,
															676.251
														],
														[
															330.62,
															678.389
														],
														[
															332.502,
															680.332
														],
														[
															334,
															682
														],
														[
															334.635,
															683.05
														],
														[
															335.061,
															684.133
														],
														[
															335.457,
															685.149
														],
														[
															336,
															686
														],
														[
															337.018,
															687.105
														],
														[
															338.222,
															688.373
														],
														[
															339.565,
															689.704
														],
														[
															341,
															691
														],
														[
															342.595,
															692.048
														],
														[
															344.94,
															693.366
														],
														[
															347.064,
															694.501
														],
														[
															348,
															695
														],
														[
															348.763,
															697.229
														],
														[
															348.802,
															699.518
														],
														[
															348.69,
															701.798
														],
														[
															349,
															704
														],
														[
															350.059,
															706.448
														],
														[
															351.157,
															707.68
														],
														[
															352.426,
															708.323
														],
														[
															354,
															709
														],
														[
															356.753,
															709.916
														],
														[
															359.806,
															710.232
														],
														[
															362.955,
															710.182
														],
														[
															366,
															710
														],
														[
															383.101,
															703.976
														],
														[
															395.681,
															690.912
														],
														[
															404.671,
															674.893
														],
														[
															411,
															660
														],
														[
															421.8,
															629.143
														],
														[
															430.125,
															596.666
														],
														[
															436.637,
															562.856
														],
														[
															442,
															528
														],
														[
															443.556,
															515.584
														],
														[
															444.798,
															503.169
														],
														[
															445.892,
															490.67
														],
														[
															447,
															478
														],
														[
															451.738,
															400.149
														],
														[
															451.819,
															321.962
														],
														[
															447.241,
															245.044
														],
														[
															438,
															171
														],
														[
															434.634,
															151.007
														],
														[
															431.46,
															134.545
														],
														[
															428.057,
															119.56
														],
														[
															424,
															104
														],
														[
															417.774,
															82.771
														],
														[
															410.567,
															62.489
														],
														[
															402,
															44
														],
														[
															389.659,
															26.629
														],
														[
															375,
															16
														],
														[
															362.346,
															15.148
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 32,
											"s": [
												{
													"i": [
														[
															1.751,
															-0.299
														],
														[
															1.134,
															-0.214
														],
														[
															1.05,
															-0.243
														],
														[
															0.891,
															-0.283
														],
														[
															0.659,
															-0.333
														],
														[
															0.587,
															-0.471
														],
														[
															0.534,
															-0.533
														],
														[
															0.555,
															-0.545
														],
														[
															0.65,
															-0.508
														],
														[
															0.368,
															-0.175
														],
														[
															0.367,
															-0.141
														],
														[
															0.315,
															-0.145
														],
														[
															0.213,
															-0.189
														],
														[
															0.743,
															-0.723
														],
														[
															0.763,
															-0.773
														],
														[
															0.638,
															-0.664
														],
														[
															0.369,
															-0.396
														],
														[
															0.074,
															-0.251
														],
														[
															0.037,
															-0.274
														],
														[
															0.07,
															-0.261
														],
														[
															0.172,
															-0.212
														],
														[
															0.721,
															-0.657
														],
														[
															0.702,
															-0.659
														],
														[
															0.503,
															-0.697
														],
														[
															0.268,
															-0.659
														],
														[
															0.456,
															-0.712
														],
														[
															1.143,
															-2.203
														],
														[
															1.105,
															-2.126
														],
														[
															0.908,
															-1.318
														],
														[
															0.631,
															-1.308
														],
														[
															2.266,
															-6.219
														],
														[
															2.105,
															-6.258
														],
														[
															2.271,
															-7.471
														],
														[
															1.442,
															-6.762
														],
														[
															3.29,
															-28.894
														],
														[
															1.721,
															-33.753
														],
														[
															-0.244,
															0.008
														],
														[
															-0.025,
															-0.02
														],
														[
															0.338,
															-0.206
														],
														[
															-0.015,
															0.094
														],
														[
															-0.073,
															-1.477
														],
														[
															0.025,
															-1.405
														],
														[
															-1.282,
															-22.448
														],
														[
															-2.298,
															-20.173
														],
														[
															-0.973,
															-7.673
														],
														[
															-1.2,
															-7.327
														],
														[
															-8.519,
															-26.562
														],
														[
															-13.21,
															-17.961
														],
														[
															-3.153,
															-3.486
														],
														[
															-2.565,
															-1.579
														],
														[
															-0.284,
															-0.362
														],
														[
															-0.383,
															-0.258
														],
														[
															-1.828,
															-0.875
														],
														[
															-0.08,
															-1.418
														],
														[
															-0.562,
															-1.809
														],
														[
															-0.653,
															-1.016
														],
														[
															-3.383,
															-0.409
														],
														[
															-3.453,
															0.216
														],
														[
															-5.282,
															3.046
														],
														[
															-3.819,
															4.313
														],
														[
															-0.451,
															0.654
														],
														[
															-0.625,
															0.738
														],
														[
															-1.217,
															1.073
														],
														[
															-0.957,
															1.32
														],
														[
															-0.318,
															0.733
														],
														[
															-0.359,
															0.56
														],
														[
															-0.767,
															1.443
														],
														[
															-0.887,
															1.597
														],
														[
															-0.57,
															0.668
														],
														[
															-0.341,
															0.643
														],
														[
															-5.542,
															17.63
														],
														[
															-3.823,
															17.36
														],
														[
															-3.043,
															33.026
														],
														[
															0,
															36.882
														],
														[
															2.99,
															33.46
														],
														[
															7.041,
															33.085
														],
														[
															2.738,
															10.302
														],
														[
															2.831,
															9.365
														],
														[
															0.462,
															0.389
														],
														[
															0.094,
															0.257
														],
														[
															0.99,
															3.238
														],
														[
															0.962,
															2.088
														],
														[
															0.507,
															1.212
														],
														[
															0.405,
															0.927
														],
														[
															1.142,
															2.26
														],
														[
															1.238,
															2.23
														],
														[
															4.556,
															6.087
														],
														[
															5.182,
															4.178
														],
														[
															2.32,
															1.465
														],
														[
															1.857,
															0.638
														],
														[
															5.231,
															-0.047
														]
													],
													"o": [
														[
															-1.143,
															0.195
														],
														[
															-1.134,
															0.214
														],
														[
															-1.05,
															0.243
														],
														[
															-0.891,
															0.283
														],
														[
															-0.714,
															0.361
														],
														[
															-0.587,
															0.471
														],
														[
															-0.534,
															0.533
														],
														[
															-0.555,
															0.545
														],
														[
															-0.318,
															0.248
														],
														[
															-0.368,
															0.175
														],
														[
															-0.367,
															0.141
														],
														[
															-0.315,
															0.145
														],
														[
															-0.579,
															0.514
														],
														[
															-0.743,
															0.723
														],
														[
															-0.763,
															0.773
														],
														[
															-0.638,
															0.664
														],
														[
															-0.179,
															0.192
														],
														[
															-0.074,
															0.251
														],
														[
															-0.037,
															0.274
														],
														[
															-0.07,
															0.261
														],
														[
															-0.56,
															0.691
														],
														[
															-0.721,
															0.657
														],
														[
															-0.702,
															0.659
														],
														[
															-0.472,
															0.654
														],
														[
															-0.268,
															0.659
														],
														[
															-1.322,
															2.061
														],
														[
															-1.144,
															2.203
														],
														[
															-0.738,
															1.422
														],
														[
															-0.908,
															1.318
														],
														[
															-2.83,
															5.864
														],
														[
															-2.266,
															6.219
														],
														[
															-2.474,
															7.354
														],
														[
															-2.271,
															7.471
														],
														[
															-6.117,
															28.673
														],
														[
															-3.29,
															28.894
														],
														[
															0,
															0.014
														],
														[
															0.244,
															-0.008
														],
														[
															0.337,
															0.269
														],
														[
															-0.338,
															0.206
														],
														[
															-0.267,
															1.688
														],
														[
															0.073,
															1.477
														],
														[
															-0.425,
															24.034
														],
														[
															1.282,
															22.448
														],
														[
															0.909,
															7.981
														],
														[
															0.973,
															7.673
														],
														[
															4.715,
															28.793
														],
														[
															8.519,
															26.562
														],
														[
															1.822,
															2.476
														],
														[
															3.153,
															3.486
														],
														[
															0.48,
															0.295
														],
														[
															0.284,
															0.362
														],
														[
															1.608,
															1.083
														],
														[
															1.828,
															0.875
														],
														[
															0.099,
															1.749
														],
														[
															0.562,
															1.809
														],
														[
															1.014,
															1.581
														],
														[
															3.383,
															0.409
														],
														[
															8.055,
															-0.504
														],
														[
															5.281,
															-3.046
														],
														[
															0.572,
															-0.646
														],
														[
															0.451,
															-0.654
														],
														[
															1.173,
															-1.388
														],
														[
															1.218,
															-1.073
														],
														[
															0.369,
															-0.509
														],
														[
															0.318,
															-0.733
														],
														[
															1.044,
															-1.629
														],
														[
															0.767,
															-1.443
														],
														[
															0.381,
															-0.687
														],
														[
															0.57,
															-0.667
														],
														[
															8.009,
															-15.12
														],
														[
															5.542,
															-17.63
														],
														[
															6.83,
															-31.013
														],
														[
															3.042,
															-33.026
														],
														[
															0,
															-33.073
														],
														[
															-2.99,
															-33.46
														],
														[
															-2.219,
															-10.428
														],
														[
															-2.738,
															-10.302
														],
														[
															-0.057,
															-0.187
														],
														[
															-0.462,
															-0.389
														],
														[
															-1.079,
															-2.962
														],
														[
															-0.99,
															-3.238
														],
														[
															-0.565,
															-1.227
														],
														[
															-0.507,
															-1.212
														],
														[
															-1.193,
															-2.728
														],
														[
															-1.142,
															-2.261
														],
														[
															-3.593,
															-6.473
														],
														[
															-4.556,
															-6.087
														],
														[
															-1.863,
															-1.502
														],
														[
															-2.32,
															-1.465
														],
														[
															-4.327,
															-1.486
														],
														[
															-5.231,
															0.047
														]
													],
													"v": [
														[
															353,
															16
														],
														[
															349.567,
															16.611
														],
														[
															346.273,
															17.293
														],
														[
															343.343,
															18.079
														],
														[
															341,
															19
														],
														[
															339.068,
															20.261
														],
														[
															337.405,
															21.78
														],
														[
															335.789,
															23.409
														],
														[
															334,
															25
														],
														[
															332.958,
															25.625
														],
														[
															331.842,
															26.089
														],
														[
															330.805,
															26.508
														],
														[
															330,
															27
														],
														[
															327.98,
															28.894
														],
														[
															325.684,
															31.177
														],
														[
															323.546,
															33.371
														],
														[
															322,
															35
														],
														[
															321.639,
															35.673
														],
														[
															321.49,
															36.47
														],
														[
															321.346,
															37.281
														],
														[
															321,
															38
														],
														[
															319.034,
															40.012
														],
														[
															316.854,
															41.976
														],
														[
															315,
															44
														],
														[
															313.988,
															45.957
														],
														[
															313,
															48
														],
														[
															309.337,
															54.451
														],
														[
															306,
															61
														],
														[
															303.419,
															65.085
														],
														[
															301,
															69
														],
														[
															293.456,
															87.204
														],
														[
															287,
															106
														],
														[
															279.727,
															128.444
														],
														[
															274,
															150
														],
														[
															260.203,
															235.19
														],
														[
															253,
															328
														],
														[
															253.481,
															327.995
														],
														[
															254,
															328
														],
														[
															253.741,
															328.772
														],
														[
															253,
															329
														],
														[
															252.819,
															333.712
														],
														[
															253,
															338
														],
														[
															254.458,
															407.895
														],
														[
															260,
															472
														],
														[
															262.782,
															495.49
														],
														[
															266,
															518
														],
														[
															285.629,
															602.625
														],
														[
															318,
															671
														],
														[
															325.942,
															680.673
														],
														[
															335,
															689
														],
														[
															336.073,
															690.028
														],
														[
															337,
															691
														],
														[
															342.646,
															693.749
														],
														[
															346,
															697
														],
														[
															347.085,
															702.549
														],
														[
															349,
															707
														],
														[
															356.171,
															709.847
														],
														[
															367,
															710
														],
														[
															386.677,
															704.357
														],
														[
															400,
															693
														],
														[
															401.461,
															691.069
														],
														[
															403,
															689
														],
														[
															406.663,
															685.449
														],
														[
															410,
															682
														],
														[
															411.007,
															680.038
														],
														[
															412,
															678
														],
														[
															414.618,
															673.476
														],
														[
															417,
															669
														],
														[
															418.531,
															666.967
														],
														[
															420,
															665
														],
														[
															440.139,
															615.18
														],
														[
															454,
															562
														],
														[
															468.623,
															466.402
														],
														[
															473,
															362
														],
														[
															468.781,
															262.009
														],
														[
															454,
															162
														],
														[
															446.459,
															130.703
														],
														[
															438,
															101
														],
														[
															437.028,
															100.053
														],
														[
															436,
															99
														],
														[
															432.913,
															89.345
														],
														[
															430,
															81
														],
														[
															428.38,
															77.275
														],
														[
															427,
															74
														],
														[
															423.533,
															66.626
														],
														[
															420,
															60
														],
														[
															407.691,
															40.779
														],
														[
															393,
															25
														],
														[
															386.495,
															20.352
														],
														[
															380,
															17
														],
														[
															364.568,
															15.161
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 33,
											"s": [
												{
													"i": [
														[
															2.26,
															-0.318
														],
														[
															0.167,
															0.001
														],
														[
															0.168,
															0.01
														],
														[
															0.167,
															0.004
														],
														[
															0.164,
															-0.018
														],
														[
															1.323,
															-0.372
														],
														[
															1.252,
															-0.494
														],
														[
															1.053,
															-0.5
														],
														[
															0.727,
															-0.391
														],
														[
															0.889,
															-0.413
														],
														[
															0.83,
															-0.375
														],
														[
															0.776,
															-0.4
														],
														[
															0.727,
															-0.487
														],
														[
															0.325,
															-0.318
														],
														[
															0.3,
															-0.348
														],
														[
															0.325,
															-0.355
														],
														[
															0.4,
															-0.342
														],
														[
															1.705,
															-1.624
														],
														[
															1.505,
															-1.6
														],
														[
															1.297,
															-1.551
														],
														[
															1.082,
															-1.476
														],
														[
															0.9,
															-1.183
														],
														[
															0.869,
															-1.167
														],
														[
															0.784,
															-1.151
														],
														[
															0.645,
															-1.134
														],
														[
															2.552,
															-4.947
														],
														[
															2.312,
															-5.15
														],
														[
															2.122,
															-5.602
														],
														[
															1.235,
															-2.809
														],
														[
															0.849,
															-2.563
														],
														[
															0.253,
															-1.709
														],
														[
															0.49,
															-1.659
														],
														[
															0.387,
															-0.625
														],
														[
															0.226,
															-0.734
														],
														[
															0.607,
															-2.416
														],
														[
															0.651,
															-2.346
														],
														[
															3.281,
															-19.093
														],
														[
															1.865,
															-21.577
														],
														[
															0.668,
															-15.855
														],
														[
															0,
															-16.214
														],
														[
															-5.385,
															-36.398
														],
														[
															-9.46,
															-30.072
														],
														[
															-3.781,
															-8.742
														],
														[
															-3.921,
															-7.637
														],
														[
															-2.154,
															-4.117
														],
														[
															-2.255,
															-3.379
														],
														[
															-0.573,
															-0.491
														],
														[
															-0.368,
															-0.522
														],
														[
															-1.262,
															-1.783
														],
														[
															-1.476,
															-1.771
														],
														[
															-1.94,
															-1.687
														],
														[
															-2.238,
															-1.853
														],
														[
															-0.983,
															-0.853
														],
														[
															-1.013,
															-0.715
														],
														[
															-1.152,
															-0.629
														],
														[
															-1.235,
															-0.668
														],
														[
															-1.317,
															-0.696
														],
														[
															-0.57,
															-0.59
														],
														[
															-0.446,
															-2.108
														],
														[
															-1.143,
															-1.425
														],
														[
															-3.637,
															-0.387
														],
														[
															-4.149,
															0.173
														],
														[
															-3.798,
															0.935
														],
														[
															-2.38,
															1.077
														],
														[
															-8.268,
															9.357
														],
														[
															-6.434,
															12.274
														],
														[
															-7.618,
															26.801
														],
														[
															-4.353,
															29.567
														],
														[
															0.961,
															49.372
														],
														[
															7.917,
															44.601
														],
														[
															1.227,
															5.392
														],
														[
															1.064,
															4.632
														],
														[
															0.711,
															2.594
														],
														[
															0.488,
															1.721
														],
														[
															2.28,
															7.486
														],
														[
															2.579,
															6.935
														],
														[
															5.148,
															10.116
														],
														[
															6.339,
															8.594
														],
														[
															3.082,
															3.185
														],
														[
															3.276,
															3.007
														],
														[
															1.292,
															1.379
														],
														[
															0.781,
															0.521
														],
														[
															0.695,
															0.057
														],
														[
															0.616,
															0.367
														],
														[
															0.8,
															0.755
														],
														[
															0.879,
															0.431
														],
														[
															0.639,
															0.091
														],
														[
															0.726,
															0.285
														],
														[
															0.502,
															0.412
														],
														[
															0.436,
															0.135
														],
														[
															5.918,
															-0.062
														]
													],
													"o": [
														[
															-0.163,
															0.023
														],
														[
															-0.167,
															-0.001
														],
														[
															-0.168,
															-0.01
														],
														[
															-0.167,
															-0.004
														],
														[
															-1.265,
															0.135
														],
														[
															-1.323,
															0.372
														],
														[
															-1.252,
															0.494
														],
														[
															-1.053,
															0.5
														],
														[
															-0.953,
															0.512
														],
														[
															-0.889,
															0.413
														],
														[
															-0.83,
															0.375
														],
														[
															-0.776,
															0.4
														],
														[
															-0.399,
															0.267
														],
														[
															-0.325,
															0.318
														],
														[
															-0.3,
															0.348
														],
														[
															-0.325,
															0.355
														],
														[
															-1.899,
															1.623
														],
														[
															-1.705,
															1.624
														],
														[
															-1.505,
															1.6
														],
														[
															-1.297,
															1.551
														],
														[
															-0.878,
															1.197
														],
														[
															-0.9,
															1.183
														],
														[
															-0.869,
															1.167
														],
														[
															-0.784,
															1.151
														],
														[
															-2.842,
															4.995
														],
														[
															-2.552,
															4.947
														],
														[
															-2.312,
															5.15
														],
														[
															-1.212,
															3.2
														],
														[
															-1.235,
															2.809
														],
														[
															-0.498,
															1.502
														],
														[
															-0.253,
															1.71
														],
														[
															-0.226,
															0.766
														],
														[
															-0.387,
															0.625
														],
														[
															-0.92,
															2.989
														],
														[
															-0.607,
															2.416
														],
														[
															-5.01,
															18.052
														],
														[
															-3.281,
															19.093
														],
														[
															-1.328,
															15.366
														],
														[
															-0.668,
															15.855
														],
														[
															0,
															39.337
														],
														[
															5.385,
															36.398
														],
														[
															2.955,
															9.393
														],
														[
															3.781,
															8.743
														],
														[
															2.131,
															4.151
														],
														[
															2.154,
															4.118
														],
														[
															0.342,
															0.513
														],
														[
															0.573,
															0.491
														],
														[
															1.477,
															2.099
														],
														[
															1.262,
															1.783
														],
														[
															2,
															2.399
														],
														[
															1.94,
															1.687
														],
														[
															1.054,
															0.873
														],
														[
															0.983,
															0.853
														],
														[
															1.155,
															0.815
														],
														[
															1.152,
															0.629
														],
														[
															1.161,
															0.628
														],
														[
															1.317,
															0.696
														],
														[
															2.073,
															2.144
														],
														[
															0.446,
															2.108
														],
														[
															1.303,
															1.624
														],
														[
															3.637,
															0.387
														],
														[
															4.428,
															-0.185
														],
														[
															3.798,
															-0.935
														],
														[
															9.495,
															-4.296
														],
														[
															8.268,
															-9.358
														],
														[
															12.177,
															-23.229
														],
														[
															7.617,
															-26.801
														],
														[
															6.76,
															-45.909
														],
														[
															-0.961,
															-49.372
														],
														[
															-1.029,
															-5.798
														],
														[
															-1.227,
															-5.392
														],
														[
															-0.667,
															-2.902
														],
														[
															-0.711,
															-2.594
														],
														[
															-2.303,
															-8.121
														],
														[
															-2.28,
															-7.486
														],
														[
															-4.068,
															-10.941
														],
														[
															-5.148,
															-10.116
														],
														[
															-2.398,
															-3.252
														],
														[
															-3.082,
															-3.185
														],
														[
															-1.05,
															-0.965
														],
														[
															-1.292,
															-1.379
														],
														[
															-0.606,
															-0.404
														],
														[
															-0.695,
															-0.057
														],
														[
															-0.923,
															-0.55
														],
														[
															-0.8,
															-0.755
														],
														[
															-0.717,
															-0.352
														],
														[
															-0.639,
															-0.091
														],
														[
															-0.554,
															-0.218
														],
														[
															-0.502,
															-0.412
														],
														[
															-5.067,
															-1.568
														],
														[
															-5.918,
															0.062
														]
													],
													"v": [
														[
															352,
															16
														],
														[
															351.504,
															16.029
														],
														[
															351.001,
															16.008
														],
														[
															350.498,
															15.983
														],
														[
															350,
															16
														],
														[
															346.086,
															16.789
														],
														[
															342.192,
															18.117
														],
														[
															338.702,
															19.636
														],
														[
															336,
															21
														],
														[
															333.238,
															22.371
														],
														[
															330.66,
															23.538
														],
														[
															328.253,
															24.685
														],
														[
															326,
															26
														],
														[
															324.926,
															26.884
														],
														[
															324.001,
															27.889
														],
														[
															323.075,
															28.949
														],
														[
															322,
															30
														],
														[
															316.592,
															34.878
														],
														[
															311.775,
															39.721
														],
														[
															307.571,
															44.453
														],
														[
															304,
															49
														],
														[
															301.319,
															52.57
														],
														[
															298.651,
															56.094
														],
														[
															296.158,
															59.572
														],
														[
															294,
															63
														],
														[
															285.921,
															77.852
														],
														[
															278.638,
															92.935
														],
														[
															272,
															109
														],
														[
															268.227,
															117.977
														],
														[
															265,
															126
														],
														[
															263.995,
															130.882
														],
														[
															263,
															136
														],
														[
															262,
															138.023
														],
														[
															261,
															140
														],
														[
															258.799,
															147.982
														],
														[
															257,
															155
														],
														[
															244.641,
															210.356
														],
														[
															237,
															271
														],
														[
															234.004,
															317.864
														],
														[
															233,
															366
														],
														[
															241.405,
															480.448
														],
														[
															264,
															581
														],
														[
															274.276,
															608.317
														],
														[
															286,
															633
														],
														[
															292.407,
															645.579
														],
														[
															299,
															657
														],
														[
															300.481,
															658.493
														],
														[
															302,
															660
														],
														[
															306.001,
															665.746
														],
														[
															310,
															671
														],
														[
															315.821,
															676.91
														],
														[
															322,
															682
														],
														[
															325.031,
															684.619
														],
														[
															328,
															687
														],
														[
															331.44,
															689.111
														],
														[
															335,
															691
														],
														[
															338.943,
															693.029
														],
														[
															342,
															695
														],
														[
															345.198,
															701.539
														],
														[
															347,
															707
														],
														[
															354.865,
															709.847
														],
														[
															367,
															710
														],
														[
															379.536,
															708.169
														],
														[
															389,
															705
														],
														[
															415.796,
															683.984
														],
														[
															438,
															651
														],
														[
															467.367,
															575.754
														],
														[
															485,
															491
														],
														[
															493.507,
															346.019
														],
														[
															480,
															203
														],
														[
															476.526,
															186.125
														],
														[
															473,
															171
														],
														[
															470.866,
															162.615
														],
														[
															469,
															156
														],
														[
															462.207,
															132.61
														],
														[
															455,
															111
														],
														[
															441.202,
															79.24
														],
														[
															424,
															51
														],
														[
															415.659,
															41.317
														],
														[
															406,
															32
														],
														[
															402.298,
															28.167
														],
														[
															399,
															25
														],
														[
															397.007,
															24.473
														],
														[
															395,
															24
														],
														[
															392.467,
															21.911
														],
														[
															390,
															20
														],
														[
															388.006,
															19.45
														],
														[
															386,
															19
														],
														[
															384.411,
															17.938
														],
														[
															383,
															17
														],
														[
															365.394,
															15.085
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 34,
											"s": [
												{
													"i": [
														[
															7.239,
															-0.919
														],
														[
															3.047,
															-0.666
														],
														[
															2.315,
															-0.894
														],
														[
															0.897,
															-0.347
														],
														[
															0.655,
															-0.322
														],
														[
															1.383,
															-1.156
														],
														[
															1.003,
															-0.657
														],
														[
															0.91,
															-0.272
														],
														[
															0.66,
															-0.453
														],
														[
															0.148,
															-0.418
														],
														[
															0.2,
															-0.185
														],
														[
															0.544,
															-0.074
														],
														[
															0.436,
															-0.343
														],
														[
															1.173,
															-1.251
														],
														[
															1.126,
															-1.064
														],
														[
															0.708,
															-0.453
														],
														[
															0.519,
															-0.572
														],
														[
															0.412,
															-0.871
														],
														[
															0.7,
															-0.798
														],
														[
															1.193,
															-1.1
														],
														[
															1.072,
															-1.286
														],
														[
															1.575,
															-2.122
														],
														[
															1.16,
															-1.664
														],
														[
															0.736,
															-1.451
														],
														[
															0.925,
															-1.571
														],
														[
															0.407,
															-0.346
														],
														[
															0.201,
															-0.322
														],
														[
															0.095,
															-0.492
														],
														[
															0.318,
															-0.544
														],
														[
															5.676,
															-13.455
														],
														[
															4.048,
															-13.787
														],
														[
															3.075,
															-15.698
														],
														[
															2.279,
															-17.151
														],
														[
															1.297,
															-17.908
														],
														[
															-0.311,
															-20.395
														],
														[
															-5.046,
															-33.427
														],
														[
															-9.257,
															-28.582
														],
														[
															-5.918,
															-12.74
														],
														[
															-7.234,
															-11.312
														],
														[
															-1.285,
															-1.783
														],
														[
															-0.786,
															-1.184
														],
														[
															-0.534,
															-0.675
														],
														[
															-0.312,
															-0.47
														],
														[
															-0.775,
															-0.863
														],
														[
															-0.994,
															-1.179
														],
														[
															-2.301,
															-2.536
														],
														[
															-2.424,
															-2.042
														],
														[
															-2.857,
															-1.973
														],
														[
															-2.728,
															-1.714
														],
														[
															-0.64,
															-0.55
														],
														[
															-0.829,
															-0.416
														],
														[
															-2.023,
															-0.505
														],
														[
															-1.262,
															-1.156
														],
														[
															-0.579,
															-1.152
														],
														[
															-0.639,
															-1.436
														],
														[
															-0.208,
															-0.918
														],
														[
															-2.176,
															-1.099
														],
														[
															-2.129,
															-0.178
														],
														[
															-2.169,
															-0.127
														],
														[
															-6.491,
															1.276
														],
														[
															-2.758,
															1.321
														],
														[
															-1.507,
															0.865
														],
														[
															-1.376,
															0.776
														],
														[
															-4.452,
															3.855
														],
														[
															-3.237,
															3.784
														],
														[
															-1.404,
															1.578
														],
														[
															-1.001,
															1.075
														],
														[
															-0.073,
															0.539
														],
														[
															-0.342,
															0.449
														],
														[
															-0.406,
															0.139
														],
														[
															-0.203,
															0.218
														],
														[
															-0.072,
															0.531
														],
														[
															-0.338,
															0.474
														],
														[
															-0.412,
															0.13
														],
														[
															-0.185,
															0.247
														],
														[
															-0.108,
															0.553
														],
														[
															-0.26,
															0.372
														],
														[
															-7.293,
															17.035
														],
														[
															-4.978,
															17.727
														],
														[
															-4.117,
															27.957
														],
														[
															-1.397,
															30.762
														],
														[
															2.959,
															34.244
														],
														[
															4.487,
															21.734
														],
														[
															1.804,
															7.406
														],
														[
															4.659,
															13.876
														],
														[
															19.643,
															24.647
														],
														[
															4.574,
															4.312
														],
														[
															2.35,
															1.935
														],
														[
															3.761,
															2.14
														],
														[
															6.164,
															1.965
														],
														[
															1.542,
															0.4
														]
													],
													"o": [
														[
															-3.497,
															0.444
														],
														[
															-3.047,
															0.666
														],
														[
															-0.755,
															0.291
														],
														[
															-0.898,
															0.347
														],
														[
															-1.466,
															0.721
														],
														[
															-1.383,
															1.156
														],
														[
															-0.7,
															0.458
														],
														[
															-0.91,
															0.272
														],
														[
															-0.208,
															0.143
														],
														[
															-0.148,
															0.418
														],
														[
															-0.389,
															0.362
														],
														[
															-0.544,
															0.074
														],
														[
															-1.183,
															0.932
														],
														[
															-1.173,
															1.251
														],
														[
															-0.65,
															0.614
														],
														[
															-0.708,
															0.453
														],
														[
															-0.651,
															0.719
														],
														[
															-0.412,
															0.871
														],
														[
															-1.154,
															1.316
														],
														[
															-1.193,
															1.1
														],
														[
															-1.539,
															1.846
														],
														[
															-1.575,
															2.122
														],
														[
															-1.132,
															1.624
														],
														[
															-0.736,
															1.451
														],
														[
															-0.172,
															0.292
														],
														[
															-0.407,
															0.346
														],
														[
															-0.302,
															0.486
														],
														[
															-0.095,
															0.493
														],
														[
															-7.248,
															12.394
														],
														[
															-5.676,
															13.454
														],
														[
															-4.419,
															15.055
														],
														[
															-3.075,
															15.698
														],
														[
															-2.123,
															15.971
														],
														[
															-1.297,
															17.908
														],
														[
															0.56,
															36.71
														],
														[
															5.046,
															33.427
														],
														[
															5.094,
															15.729
														],
														[
															5.918,
															12.74
														],
														[
															1.076,
															1.683
														],
														[
															1.285,
															1.783
														],
														[
															0.552,
															0.831
														],
														[
															0.534,
															0.675
														],
														[
															0.906,
															1.366
														],
														[
															0.775,
															0.864
														],
														[
															2.371,
															2.816
														],
														[
															2.301,
															2.536
														],
														[
															2.846,
															2.396
														],
														[
															2.856,
															1.973
														],
														[
															0.611,
															0.384
														],
														[
															0.64,
															0.55
														],
														[
															1.644,
															0.824
														],
														[
															2.023,
															0.505
														],
														[
															1.044,
															0.956
														],
														[
															0.579,
															1.152
														],
														[
															0.993,
															2.227
														],
														[
															0.208,
															0.918
														],
														[
															0.316,
															0.159
														],
														[
															2.129,
															0.178
														],
														[
															7.278,
															0.427
														],
														[
															6.491,
															-1.276
														],
														[
															1.598,
															-0.765
														],
														[
															1.507,
															-0.865
														],
														[
															4.956,
															-2.796
														],
														[
															4.452,
															-3.855
														],
														[
															1.381,
															-1.614
														],
														[
															1.404,
															-1.578
														],
														[
															0.366,
															-0.394
														],
														[
															0.073,
															-0.539
														],
														[
															0.172,
															-0.226
														],
														[
															0.406,
															-0.139
														],
														[
															0.375,
															-0.402
														],
														[
															0.072,
															-0.531
														],
														[
															0.167,
															-0.234
														],
														[
															0.412,
															-0.13
														],
														[
															0.31,
															-0.414
														],
														[
															0.108,
															-0.553
														],
														[
															9.85,
															-14.131
														],
														[
															7.293,
															-17.035
														],
														[
															7.135,
															-25.409
														],
														[
															4.117,
															-27.957
														],
														[
															1.616,
															-35.579
														],
														[
															-2.193,
															-25.377
														],
														[
															-1.59,
															-7.704
														],
														[
															-3.612,
															-14.831
														],
														[
															-11.598,
															-34.547
														],
														[
															-3.981,
															-4.995
														],
														[
															-1.914,
															-1.805
														],
														[
															-3.692,
															-3.04
														],
														[
															-6.393,
															-3.637
														],
														[
															-1.795,
															-0.572
														],
														[
															-8.972,
															-2.33
														]
													],
													"v": [
														[
															351,
															16
														],
														[
															341.114,
															17.663
														],
														[
															333,
															20
														],
														[
															330.426,
															20.977
														],
														[
															328,
															22
														],
														[
															323.653,
															25.048
														],
														[
															320,
															28
														],
														[
															317.47,
															29.004
														],
														[
															315,
															30
														],
														[
															314.494,
															30.968
														],
														[
															314,
															32
														],
														[
															312.536,
															32.514
														],
														[
															311,
															33
														],
														[
															307.457,
															36.401
														],
														[
															304,
															40
														],
														[
															301.901,
															41.532
														],
														[
															300,
															43
														],
														[
															298.536,
															45.441
														],
														[
															297,
															48
														],
														[
															293.439,
															51.522
														],
														[
															290,
															55
														],
														[
															285.215,
															61.137
														],
														[
															281,
															67
														],
														[
															278.345,
															71.54
														],
														[
															276,
															76
														],
														[
															275.021,
															76.977
														],
														[
															274,
															78
														],
														[
															273.512,
															79.456
														],
														[
															273,
															81
														],
														[
															253.6,
															119.955
														],
														[
															239,
															161
														],
														[
															227.895,
															206.928
														],
														[
															220,
															256
														],
														[
															214.674,
															306.682
														],
														[
															213,
															364
														],
														[
															221.477,
															469.596
														],
														[
															243,
															563
														],
														[
															259.395,
															605.312
														],
														[
															279,
															641
														],
														[
															282.718,
															646.374
														],
														[
															286,
															651
														],
														[
															287.68,
															653.271
														],
														[
															289,
															655
														],
														[
															291.435,
															658.14
														],
														[
															294,
															661
														],
														[
															300.96,
															669.081
														],
														[
															308,
															676
														],
														[
															316.588,
															682.512
														],
														[
															325,
															688
														],
														[
															326.836,
															689.476
														],
														[
															329,
															691
														],
														[
															334.787,
															692.751
														],
														[
															340,
															695
														],
														[
															342.303,
															698.14
														],
														[
															344,
															702
														],
														[
															345.113,
															706.346
														],
														[
															348,
															709
														],
														[
															352.11,
															709.524
														],
														[
															359,
															710
														],
														[
															380.39,
															708.311
														],
														[
															395,
															704
														],
														[
															399.666,
															701.508
														],
														[
															404,
															699
														],
														[
															418.289,
															688.741
														],
														[
															430,
															677
														],
														[
															434.285,
															672.096
														],
														[
															438,
															668
														],
														[
															438.518,
															666.542
														],
														[
															439,
															665
														],
														[
															439.976,
															664.495
														],
														[
															441,
															664
														],
														[
															441.527,
															662.554
														],
														[
															442,
															661
														],
														[
															442.986,
															660.51
														],
														[
															444,
															660
														],
														[
															444.538,
															658.469
														],
														[
															445,
															657
														],
														[
															470.654,
															609.697
														],
														[
															489,
															557
														],
														[
															505.804,
															477.014
														],
														[
															514,
															389
														],
														[
															510,
															283
														],
														[
															500,
															211
														],
														[
															494,
															189
														],
														[
															482,
															146
														],
														[
															436,
															55
														],
														[
															423,
															40
														],
														[
															416,
															35
														],
														[
															406,
															27
														],
														[
															389,
															19
														],
														[
															385,
															17
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 35,
											"s": [
												{
													"i": [
														[
															11.106,
															-1.188
														],
														[
															3.136,
															-0.63
														],
														[
															2.889,
															-0.863
														],
														[
															2.559,
															-1.052
														],
														[
															2.144,
															-1.197
														],
														[
															0.522,
															-0.249
														],
														[
															0.522,
															-0.24
														],
														[
															0.489,
															-0.246
														],
														[
															0.423,
															-0.267
														],
														[
															0.339,
															-0.344
														],
														[
															0.324,
															-0.383
														],
														[
															0.323,
															-0.347
														],
														[
															0.336,
															-0.238
														],
														[
															0.39,
															-0.181
														],
														[
															0.332,
															-0.117
														],
														[
															0.276,
															-0.128
														],
														[
															0.222,
															-0.213
														],
														[
															0.403,
															-0.334
														],
														[
															0.386,
															-0.289
														],
														[
															0.416,
															-0.31
														],
														[
															0.491,
															-0.398
														],
														[
															3.189,
															-3.151
														],
														[
															2.883,
															-3.372
														],
														[
															2.627,
															-3.535
														],
														[
															2.422,
															-3.641
														],
														[
															0.261,
															-0.25
														],
														[
															0.287,
															-0.242
														],
														[
															0.257,
															-0.246
														],
														[
															0.172,
															-0.262
														],
														[
															0.151,
															-0.407
														],
														[
															0.136,
															-0.447
														],
														[
															0.167,
															-0.441
														],
														[
															0.243,
															-0.391
														],
														[
															1.133,
															-1.869
														],
														[
															1.086,
															-1.883
														],
														[
															1.046,
															-1.949
														],
														[
															2.564,
															-5.526
														],
														[
															2.074,
															-4.919
														],
														[
															3.837,
															-12.956
														],
														[
															3.31,
															-14.502
														],
														[
															1.556,
															-7.659
														],
														[
															1.094,
															-7.995
														],
														[
															0.435,
															-26.366
														],
														[
															-2.012,
															-24.619
														],
														[
															-4.441,
															-22.56
														],
														[
															-7.171,
															-20.479
														],
														[
															-2.465,
															-6.535
														],
														[
															-2.781,
															-6.116
														],
														[
															-9.307,
															-13.412
														],
														[
															-11.579,
															-10.53
														],
														[
															-1.147,
															-1.249
														],
														[
															-1.194,
															-0.899
														],
														[
															-0.89,
															-0.241
														],
														[
															-0.747,
															-0.513
														],
														[
															-0.148,
															-0.418
														],
														[
															-0.2,
															-0.186
														],
														[
															-0.829,
															-0.339
														],
														[
															-0.147,
															-0.141
														],
														[
															-2.693,
															-1.283
														],
														[
															-2.228,
															-0.955
														],
														[
															-2.262,
															-0.716
														],
														[
															-0.748,
															-0.622
														],
														[
															-0.764,
															-2.581
														],
														[
															-3.275,
															-1.452
														],
														[
															-2.466,
															-0.119
														],
														[
															-2.108,
															-0.071
														],
														[
															-7.501,
															1.409
														],
														[
															-3.504,
															1.615
														],
														[
															-1.335,
															0.672
														],
														[
															-1.143,
															0.613
														],
														[
															-8.615,
															8.686
														],
														[
															-6.95,
															10.038
														],
														[
															-11.302,
															38.953
														],
														[
															-3.5,
															43.875
														],
														[
															-0.405,
															10.578
														],
														[
															0.407,
															7.839
														],
														[
															-0.067,
															3.786
														],
														[
															0.058,
															3.76
														],
														[
															0.4,
															4.646
														],
														[
															0.328,
															4.735
														],
														[
															3.021,
															19.59
														],
														[
															4.531,
															16.692
														],
														[
															1.871,
															5.641
														],
														[
															1.948,
															5.661
														],
														[
															8.597,
															16.392
														],
														[
															11.106,
															13.525
														],
														[
															2.839,
															3.106
														],
														[
															2.798,
															2.114
														],
														[
															3.934,
															2.919
														],
														[
															4.296,
															2.326
														],
														[
															9.659,
															1.679
														]
													],
													"o": [
														[
															-3.299,
															0.353
														],
														[
															-3.136,
															0.63
														],
														[
															-2.889,
															0.863
														],
														[
															-2.559,
															1.052
														],
														[
															-0.49,
															0.274
														],
														[
															-0.522,
															0.249
														],
														[
															-0.521,
															0.24
														],
														[
															-0.489,
															0.246
														],
														[
															-0.368,
															0.232
														],
														[
															-0.339,
															0.344
														],
														[
															-0.324,
															0.383
														],
														[
															-0.323,
															0.347
														],
														[
															-0.45,
															0.318
														],
														[
															-0.39,
															0.181
														],
														[
															-0.332,
															0.117
														],
														[
															-0.276,
															0.128
														],
														[
															-0.465,
															0.445
														],
														[
															-0.403,
															0.334
														],
														[
															-0.386,
															0.289
														],
														[
															-0.416,
															0.31
														],
														[
															-3.546,
															2.872
														],
														[
															-3.189,
															3.151
														],
														[
															-2.883,
															3.372
														],
														[
															-2.627,
															3.535
														],
														[
															-0.18,
															0.27
														],
														[
															-0.261,
															0.25
														],
														[
															-0.287,
															0.242
														],
														[
															-0.257,
															0.246
														],
														[
															-0.212,
															0.323
														],
														[
															-0.151,
															0.407
														],
														[
															-0.136,
															0.447
														],
														[
															-0.167,
															0.441
														],
														[
															-1.188,
															1.906
														],
														[
															-1.133,
															1.869
														],
														[
															-1.086,
															1.883
														],
														[
															-2.671,
															4.975
														],
														[
															-2.564,
															5.527
														],
														[
															-5.343,
															12.673
														],
														[
															-3.837,
															12.956
														],
														[
															-1.682,
															7.37
														],
														[
															-1.556,
															7.659
														],
														[
															-3.271,
															23.916
														],
														[
															-0.435,
															26.366
														],
														[
															2.065,
															25.279
														],
														[
															4.441,
															22.56
														],
														[
															2.361,
															6.743
														],
														[
															2.465,
															6.535
														],
														[
															7.192,
															15.822
														],
														[
															9.307,
															13.412
														],
														[
															1.216,
															1.106
														],
														[
															1.147,
															1.249
														],
														[
															0.692,
															0.522
														],
														[
															0.89,
															0.241
														],
														[
															0.208,
															0.143
														],
														[
															0.148,
															0.418
														],
														[
															0.538,
															0.502
														],
														[
															0.829,
															0.339
														],
														[
															1.999,
															1.915
														],
														[
															2.693,
															1.283
														],
														[
															1.202,
															0.515
														],
														[
															2.262,
															0.716
														],
														[
															2.668,
															2.224
														],
														[
															0.764,
															2.581
														],
														[
															1.026,
															0.455
														],
														[
															2.466,
															0.119
														],
														[
															7.492,
															0.25
														],
														[
															7.501,
															-1.409
														],
														[
															1.517,
															-0.699
														],
														[
															1.335,
															-0.672
														],
														[
															11.589,
															-6.218
														],
														[
															8.615,
															-8.686
														],
														[
															20.293,
															-29.312
														],
														[
															11.302,
															-38.953
														],
														[
															0.785,
															-9.85
														],
														[
															0.405,
															-10.578
														],
														[
															-0.212,
															-4.094
														],
														[
															0.067,
															-3.787
														],
														[
															-0.072,
															-4.681
														],
														[
															-0.4,
															-4.646
														],
														[
															-1.383,
															-19.948
														],
														[
															-3.021,
															-19.59
														],
														[
															-1.568,
															-5.776
														],
														[
															-1.871,
															-5.641
														],
														[
															-6.505,
															-18.904
														],
														[
															-8.597,
															-16.393
														],
														[
															-2.844,
															-3.463
														],
														[
															-2.84,
															-3.106
														],
														[
															-3.966,
															-2.996
														],
														[
															-3.935,
															-2.919
														],
														[
															-8.26,
															-4.473
														],
														[
															-9.659,
															-1.679
														]
													],
													"v": [
														[
															351,
															16
														],
														[
															341.326,
															17.485
														],
														[
															332.267,
															19.734
														],
														[
															324.075,
															22.616
														],
														[
															317,
															26
														],
														[
															315.473,
															26.781
														],
														[
															313.899,
															27.511
														],
														[
															312.376,
															28.235
														],
														[
															311,
															29
														],
														[
															309.942,
															29.883
														],
														[
															308.952,
															30.991
														],
														[
															307.985,
															32.104
														],
														[
															307,
															33
														],
														[
															305.741,
															33.73
														],
														[
															304.659,
															34.158
														],
														[
															303.747,
															34.508
														],
														[
															303,
															35
														],
														[
															301.711,
															36.153
														],
														[
															300.539,
															37.072
														],
														[
															299.348,
															37.955
														],
														[
															298,
															39
														],
														[
															287.91,
															48.049
														],
														[
															278.814,
															57.847
														],
														[
															270.561,
															68.221
														],
														[
															263,
															79
														],
														[
															262.325,
															79.777
														],
														[
															261.488,
															80.512
														],
														[
															260.658,
															81.241
														],
														[
															260,
															82
														],
														[
															259.467,
															83.106
														],
														[
															259.047,
															84.398
														],
														[
															258.604,
															85.741
														],
														[
															258,
															87
														],
														[
															254.521,
															92.65
														],
														[
															251.196,
															98.265
														],
														[
															248,
															104
														],
														[
															240.052,
															120.042
														],
														[
															233,
															136
														],
														[
															219.475,
															174.128
														],
														[
															209,
															215
														],
														[
															204.059,
															237.531
														],
														[
															200,
															261
														],
														[
															194.538,
															337.472
														],
														[
															197,
															415
														],
														[
															206.671,
															486.6
														],
														[
															224,
															551
														],
														[
															231.185,
															570.97
														],
														[
															239,
															590
														],
														[
															263.709,
															633.969
														],
														[
															295,
															670
														],
														[
															298.517,
															673.656
														],
														[
															302,
															677
														],
														[
															304.459,
															678.006
														],
														[
															307,
															679
														],
														[
															307.506,
															679.968
														],
														[
															308,
															681
														],
														[
															310.294,
															682.27
														],
														[
															312,
															683
														],
														[
															319.328,
															687.72
														],
														[
															327,
															691
														],
														[
															332.841,
															692.92
														],
														[
															338,
															695
														],
														[
															342.045,
															702.579
														],
														[
															347,
															709
														],
														[
															352.688,
															709.788
														],
														[
															360,
															710
														],
														[
															383.491,
															707.899
														],
														[
															401,
															703
														],
														[
															405.28,
															700.936
														],
														[
															409,
															699
														],
														[
															438.98,
															676.365
														],
														[
															462,
															648
														],
														[
															509.095,
															544.423
														],
														[
															531,
															419
														],
														[
															532.894,
															387.492
														],
														[
															533,
															359
														],
														[
															532.884,
															347.25
														],
														[
															533,
															336
														],
														[
															532.192,
															322.04
														],
														[
															531,
															308
														],
														[
															524.361,
															248.057
														],
														[
															513,
															193
														],
														[
															507.785,
															175.913
														],
														[
															502,
															159
														],
														[
															479.45,
															105.966
														],
														[
															450,
															61
														],
														[
															441.466,
															50.988
														],
														[
															433,
															43
														],
														[
															421.247,
															33.997
														],
														[
															409,
															26
														],
														[
															382.134,
															16.755
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 36,
											"s": [
												{
													"i": [
														[
															9.312,
															-0.912
														],
														[
															2.287,
															-0.334
														],
														[
															2.142,
															-0.466
														],
														[
															2.159,
															-0.649
														],
														[
															2.338,
															-0.883
														],
														[
															0.99,
															-0.424
														],
														[
															0.881,
															-0.415
														],
														[
															0.825,
															-0.408
														],
														[
															0.823,
															-0.405
														],
														[
															0.945,
															-0.398
														],
														[
															0.939,
															-0.388
														],
														[
															0.899,
															-0.421
														],
														[
															0.827,
															-0.496
														],
														[
															4.055,
															-3.228
														],
														[
															3.539,
															-3.398
														],
														[
															2.945,
															-3.204
														],
														[
															7.999,
															-12.842
														],
														[
															6.218,
															-13.894
														],
														[
															4.938,
															-15.892
														],
														[
															3.651,
															-17.688
														],
														[
															2.123,
															-19.173
														],
														[
															0,
															-21.315
														],
														[
															-0.295,
															-10.149
														],
														[
															-0.82,
															-9.843
														],
														[
															-2.24,
															-13.648
														],
														[
															-2.828,
															-11.862
														],
														[
															-1.692,
															-6.311
														],
														[
															-1.681,
															-5.258
														],
														[
															-9.868,
															-19.515
														],
														[
															-12.388,
															-14.608
														],
														[
															-4.735,
															-4.567
														],
														[
															-4.812,
															-3.724
														],
														[
															-5.88,
															-3.66
														],
														[
															-6.394,
															-2.422
														],
														[
															-2.865,
															-0.852
														],
														[
															-1.06,
															-1.653
														],
														[
															-0.481,
															-1.818
														],
														[
															-0.418,
															-0.702
														],
														[
															-3.509,
															-0.505
														],
														[
															-2.861,
															-0.133
														],
														[
															-7.21,
															1.143
														],
														[
															-5.35,
															1.789
														],
														[
															-3.65,
															1.68
														],
														[
															-3.368,
															1.93
														],
														[
															-1.196,
															0.922
														],
														[
															-0.851,
															0.529
														],
														[
															-0.521,
															0.099
														],
														[
															-0.47,
															0.325
														],
														[
															-1.482,
															1.423
														],
														[
															-1.448,
															1.183
														],
														[
															-2.885,
															2.475
														],
														[
															-2.512,
															2.692
														],
														[
															-1.104,
															1.519
														],
														[
															-1.288,
															1.535
														],
														[
															-1.385,
															1.477
														],
														[
															-1.187,
															1.574
														],
														[
															-12.613,
															41.907
														],
														[
															-3.31,
															48.543
														],
														[
															5.064,
															38.319
														],
														[
															11.55,
															33.564
														],
														[
															1.888,
															4.923
														],
														[
															1.698,
															4.222
														],
														[
															1.322,
															2.484
														],
														[
															1.367,
															2.719
														],
														[
															1.771,
															3.428
														],
														[
															1.924,
															3.325
														],
														[
															2.354,
															4.017
														],
														[
															2.352,
															3.076
														],
														[
															0.741,
															0.661
														],
														[
															0.414,
															0.542
														],
														[
															0.087,
															0.537
														],
														[
															0.337,
															0.436
														],
														[
															1.409,
															1.278
														],
														[
															1.263,
															1.465
														],
														[
															0.107,
															0.575
														],
														[
															0.263,
															0.344
														],
														[
															0.38,
															0.358
														],
														[
															0.268,
															0.289
														],
														[
															2.199,
															1.933
														],
														[
															2.109,
															2.002
														],
														[
															1.306,
															1.394
														],
														[
															1.44,
															1.156
														],
														[
															0.863,
															0.45
														],
														[
															0.794,
															0.597
														],
														[
															1.14,
															0.827
														],
														[
															1.086,
															0.675
														],
														[
															3.523,
															1.966
														],
														[
															3.63,
															1.098
														],
														[
															0.389,
															0.463
														],
														[
															0.258,
															0.093
														],
														[
															9.729,
															1.026
														]
													],
													"o": [
														[
															-2.594,
															0.254
														],
														[
															-2.287,
															0.334
														],
														[
															-2.142,
															0.466
														],
														[
															-2.159,
															0.649
														],
														[
															-1.154,
															0.436
														],
														[
															-0.99,
															0.424
														],
														[
															-0.881,
															0.415
														],
														[
															-0.825,
															0.408
														],
														[
															-0.919,
															0.452
														],
														[
															-0.945,
															0.398
														],
														[
															-0.939,
															0.388
														],
														[
															-0.899,
															0.421
														],
														[
															-4.494,
															2.696
														],
														[
															-4.055,
															3.228
														],
														[
															-3.539,
															3.398
														],
														[
															-10.788,
															11.736
														],
														[
															-7.999,
															12.842
														],
														[
															-6.599,
															14.745
														],
														[
															-4.938,
															15.892
														],
														[
															-3.508,
															16.993
														],
														[
															-2.123,
															19.173
														],
														[
															0,
															10.56
														],
														[
															0.295,
															10.149
														],
														[
															1.211,
															14.545
														],
														[
															2.24,
															13.648
														],
														[
															1.549,
															6.5
														],
														[
															1.692,
															6.311
														],
														[
															7.138,
															22.332
														],
														[
															9.868,
															19.515
														],
														[
															4.247,
															5.008
														],
														[
															4.735,
															4.567
														],
														[
															5.086,
															3.936
														],
														[
															5.88,
															3.661
														],
														[
															2.478,
															0.939
														],
														[
															2.865,
															0.852
														],
														[
															0.658,
															1.026
														],
														[
															0.481,
															1.818
														],
														[
															1.102,
															1.848
														],
														[
															3.509,
															0.505
														],
														[
															7.812,
															0.362
														],
														[
															7.21,
															-1.143
														],
														[
															4.033,
															-1.349
														],
														[
															3.65,
															-1.68
														],
														[
															1.366,
															-0.783
														],
														[
															1.196,
															-0.922
														],
														[
															0.447,
															-0.278
														],
														[
															0.521,
															-0.099
														],
														[
															1.625,
															-1.127
														],
														[
															1.482,
															-1.423
														],
														[
															2.947,
															-2.407
														],
														[
															2.885,
															-2.475
														],
														[
															1.296,
															-1.389
														],
														[
															1.104,
															-1.519
														],
														[
															1.272,
															-1.516
														],
														[
															1.385,
															-1.477
														],
														[
															23.238,
															-30.827
														],
														[
															12.613,
															-41.907
														],
														[
															2.807,
															-41.161
														],
														[
															-5.064,
															-38.319
														],
														[
															-1.75,
															-5.084
														],
														[
															-1.888,
															-4.923
														],
														[
															-1.345,
															-3.345
														],
														[
															-1.322,
															-2.484
														],
														[
															-1.994,
															-3.965
														],
														[
															-1.771,
															-3.428
														],
														[
															-2.232,
															-3.856
														],
														[
															-2.354,
															-4.017
														],
														[
															-0.621,
															-0.813
														],
														[
															-0.741,
															-0.661
														],
														[
															-0.317,
															-0.414
														],
														[
															-0.087,
															-0.538
														],
														[
															-1.102,
															-1.424
														],
														[
															-1.409,
															-1.278
														],
														[
															-0.308,
															-0.358
														],
														[
															-0.107,
															-0.575
														],
														[
															-0.214,
															-0.279
														],
														[
															-0.38,
															-0.358
														],
														[
															-2.096,
															-2.267
														],
														[
															-2.199,
															-1.933
														],
														[
															-1.336,
															-1.269
														],
														[
															-1.306,
															-1.394
														],
														[
															-0.752,
															-0.603
														],
														[
															-0.863,
															-0.45
														],
														[
															-1.353,
															-1.016
														],
														[
															-1.14,
															-0.827
														],
														[
															-3.278,
															-2.038
														],
														[
															-3.523,
															-1.966
														],
														[
															-0.187,
															-0.056
														],
														[
															-0.389,
															-0.463
														],
														[
															-7.772,
															-2.806
														],
														[
															-9.729,
															-1.027
														]
													],
													"v": [
														[
															350,
															16
														],
														[
															342.72,
															16.87
														],
														[
															336.118,
															18.057
														],
														[
															329.706,
															19.715
														],
														[
															323,
															22
														],
														[
															319.796,
															23.289
														],
														[
															317.003,
															24.547
														],
														[
															314.459,
															25.781
														],
														[
															312,
															27
														],
														[
															309.195,
															28.265
														],
														[
															306.361,
															29.434
														],
														[
															303.596,
															30.636
														],
														[
															301,
															32
														],
														[
															288.157,
															40.977
														],
														[
															276.746,
															51.007
														],
														[
															267,
															61
														],
														[
															239.073,
															97.881
														],
														[
															218,
															138
														],
														[
															200.79,
															183.793
														],
														[
															188,
															234
														],
														[
															179.369,
															288.258
														],
														[
															176,
															349
														],
														[
															176.385,
															380.037
														],
														[
															178,
															410
														],
														[
															183.287,
															452.512
														],
														[
															191,
															491
														],
														[
															195.901,
															510.431
														],
														[
															201,
															528
														],
														[
															226.563,
															591.293
														],
														[
															260,
															643
														],
														[
															273.577,
															657.463
														],
														[
															288,
															670
														],
														[
															304.518,
															681.635
														],
														[
															323,
															691
														],
														[
															331.564,
															693.465
														],
														[
															338,
															697
														],
														[
															339.68,
															701.743
														],
														[
															341,
															706
														],
														[
															348.681,
															709.286
														],
														[
															359,
															710
														],
														[
															381.847,
															708.614
														],
														[
															401,
															704
														],
														[
															412.499,
															699.436
														],
														[
															423,
															694
														],
														[
															426.886,
															691.31
														],
														[
															430,
															689
														],
														[
															431.483,
															688.536
														],
														[
															433,
															688
														],
														[
															437.633,
															684.042
														],
														[
															442,
															680
														],
														[
															450.827,
															672.714
														],
														[
															459,
															665
														],
														[
															462.505,
															660.61
														],
														[
															466,
															656
														],
														[
															470.064,
															651.544
														],
														[
															474,
															647
														],
														[
															527.446,
															536.787
														],
														[
															551,
															400
														],
														[
															547.267,
															280.302
														],
														[
															522,
															172
														],
														[
															516.461,
															156.854
														],
														[
															511,
															143
														],
														[
															507.016,
															134.53
														],
														[
															503,
															127
														],
														[
															497.448,
															116.02
														],
														[
															492,
															106
														],
														[
															485.09,
															93.915
														],
														[
															478,
															83
														],
														[
															475.845,
															80.797
														],
														[
															474,
															79
														],
														[
															473.516,
															77.517
														],
														[
															473,
															76
														],
														[
															469.121,
															72.03
														],
														[
															465,
															68
														],
														[
															464.466,
															66.489
														],
														[
															464,
															65
														],
														[
															463.041,
															64.007
														],
														[
															462,
															63
														],
														[
															455.51,
															56.801
														],
														[
															449,
															51
														],
														[
															445.078,
															46.916
														],
														[
															441,
															43
														],
														[
															438.532,
															41.495
														],
														[
															436,
															40
														],
														[
															432.3,
															37.244
														],
														[
															429,
															35
														],
														[
															418.764,
															28.795
														],
														[
															408,
															24
														],
														[
															407.053,
															23.027
														],
														[
															406,
															22
														],
														[
															379.156,
															16.211
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 37,
											"s": [
												{
													"i": [
														[
															-0.044,
															0.004
														],
														[
															0.167,
															-0.001
														],
														[
															0.168,
															0.005
														],
														[
															0.167,
															0.004
														],
														[
															0.165,
															-0.005
														],
														[
															4.851,
															-1.051
														],
														[
															4.425,
															-1.629
														],
														[
															3.862,
															-1.889
														],
														[
															3.162,
															-1.831
														],
														[
															0.573,
															-0.347
														],
														[
															0.498,
															-0.304
														],
														[
															0.503,
															-0.291
														],
														[
															1.081,
															-0.819
														],
														[
															1.154,
															-0.84
														],
														[
															0.539,
															-0.093
														],
														[
															0.395,
															-0.302
														],
														[
															12.239,
															-15.687
														],
														[
															8.936,
															-17.935
														],
														[
															2.306,
															-4.675
														],
														[
															1.613,
															-3.964
														],
														[
															3.379,
															-11.389
														],
														[
															3.013,
															-12.452
														],
														[
															2.478,
															-19.668
														],
														[
															0,
															-21.432
														],
														[
															-15.338,
															-48.957
														],
														[
															-28.649,
															-33.301
														],
														[
															-2.777,
															-3.006
														],
														[
															-2.438,
															-2.125
														],
														[
															-0.851,
															-0.406
														],
														[
															-0.772,
															-0.659
														],
														[
															-1.275,
															-1.414
														],
														[
															-1.504,
															-1.152
														],
														[
															-0.549,
															-0.096
														],
														[
															-0.381,
															-0.291
														],
														[
															-1.737,
															-1.217
														],
														[
															-1.411,
															-0.877
														],
														[
															-0.855,
															-0.504
														],
														[
															-0.683,
															-0.425
														],
														[
															-4.263,
															-2.049
														],
														[
															-4.182,
															-1.462
														],
														[
															-2.91,
															-0.781
														],
														[
															-1.077,
															-1.077
														],
														[
															-0.902,
															-2.354
														],
														[
															-3.031,
															-1.225
														],
														[
															-3.004,
															-0.106
														],
														[
															-2.758,
															-0.079
														],
														[
															-2.904,
															0.21
														],
														[
															-2.494,
															0.243
														],
														[
															-12.543,
															5.463
														],
														[
															-9.267,
															7.537
														],
														[
															-8.248,
															9.548
														],
														[
															-6.81,
															10.516
														],
														[
															-2.567,
															4.389
														],
														[
															-2.175,
															3.498
														],
														[
															-0.095,
															0.486
														],
														[
															-0.314,
															0.561
														],
														[
															-2.895,
															6.357
														],
														[
															-2.231,
															5.868
														],
														[
															-0.845,
															2.152
														],
														[
															-0.676,
															1.91
														],
														[
															-1.146,
															3.921
														],
														[
															-0.918,
															4.091
														],
														[
															-0.471,
															0.637
														],
														[
															-0.073,
															0.265
														],
														[
															0.078,
															0.688
														],
														[
															-0.141,
															0.629
														],
														[
															-0.471,
															0.637
														],
														[
															-0.073,
															0.265
														],
														[
															-0.445,
															2.57
														],
														[
															-0.579,
															2.391
														],
														[
															-2.565,
															21.337
														],
														[
															0,
															23.065
														],
														[
															2.132,
															21.367
														],
														[
															4.471,
															20.39
														],
														[
															4.397,
															13.554
														],
														[
															5.18,
															12.041
														],
														[
															2.36,
															5.129
														],
														[
															2.421,
															4.511
														],
														[
															0.757,
															0.813
														],
														[
															0.521,
															0.906
														],
														[
															0.48,
															1.034
														],
														[
															0.566,
															0.97
														],
														[
															2.936,
															4.411
														],
														[
															3.363,
															4.394
														],
														[
															5.755,
															6.164
														],
														[
															6.851,
															5.64
														],
														[
															1.449,
															1.386
														],
														[
															1.661,
															1.186
														],
														[
															16.243,
															5.246
														],
														[
															20.918,
															-1.627
														],
														[
															0.182,
															-0.245
														]
													],
													"o": [
														[
															-0.164,
															0.015
														],
														[
															-0.167,
															0.001
														],
														[
															-0.168,
															-0.005
														],
														[
															-0.167,
															-0.004
														],
														[
															-5.139,
															0.154
														],
														[
															-4.851,
															1.051
														],
														[
															-4.425,
															1.629
														],
														[
															-3.862,
															1.889
														],
														[
															-0.729,
															0.422
														],
														[
															-0.573,
															0.347
														],
														[
															-0.498,
															0.304
														],
														[
															-1.524,
															0.883
														],
														[
															-1.081,
															0.819
														],
														[
															-0.449,
															0.328
														],
														[
															-0.539,
															0.093
														],
														[
															-16.109,
															12.319
														],
														[
															-12.239,
															15.687
														],
														[
															-2.161,
															4.337
														],
														[
															-2.306,
															4.675
														],
														[
															-4.471,
															10.989
														],
														[
															-3.379,
															11.39
														],
														[
															-4.089,
															16.897
														],
														[
															-2.478,
															19.668
														],
														[
															0,
															62.871
														],
														[
															15.338,
															48.957
														],
														[
															2.453,
															2.851
														],
														[
															2.777,
															3.006
														],
														[
															0.824,
															0.718
														],
														[
															0.851,
															0.406
														],
														[
															1.395,
															1.192
														],
														[
															1.275,
															1.414
														],
														[
															0.423,
															0.324
														],
														[
															0.549,
															0.096
														],
														[
															1.643,
															1.256
														],
														[
															1.737,
															1.217
														],
														[
															0.899,
															0.558
														],
														[
															0.855,
															0.504
														],
														[
															3.768,
															2.342
														],
														[
															4.263,
															2.049
														],
														[
															2.282,
															0.798
														],
														[
															2.91,
															0.781
														],
														[
															2.361,
															2.361
														],
														[
															0.902,
															2.354
														],
														[
															1.226,
															0.495
														],
														[
															3.004,
															0.106
														],
														[
															2.892,
															0.083
														],
														[
															2.904,
															-0.21
														],
														[
															16.56,
															-1.61
														],
														[
															12.543,
															-5.463
														],
														[
															10.197,
															-8.293
														],
														[
															8.248,
															-9.548
														],
														[
															2.557,
															-3.947
														],
														[
															2.567,
															-4.389
														],
														[
															0.307,
															-0.494
														],
														[
															0.095,
															-0.486
														],
														[
															3.19,
															-5.705
														],
														[
															2.895,
															-6.357
														],
														[
															0.944,
															-2.483
														],
														[
															0.845,
															-2.152
														],
														[
															1.495,
															-4.225
														],
														[
															1.147,
															-3.921
														],
														[
															0.043,
															-0.188
														],
														[
															0.471,
															-0.637
														],
														[
															0.173,
															-0.62
														],
														[
															-0.078,
															-0.688
														],
														[
															0.043,
															-0.188
														],
														[
															0.471,
															-0.637
														],
														[
															0.64,
															-2.327
														],
														[
															0.445,
															-2.571
														],
														[
															4.74,
															-19.586
														],
														[
															2.565,
															-21.337
														],
														[
															0,
															-23.143
														],
														[
															-2.132,
															-21.367
														],
														[
															-3.233,
															-14.745
														],
														[
															-4.397,
															-13.554
														],
														[
															-2.14,
															-4.975
														],
														[
															-2.36,
															-5.129
														],
														[
															-0.451,
															-0.84
														],
														[
															-0.757,
															-0.814
														],
														[
															-0.515,
															-0.895
														],
														[
															-0.48,
															-1.034
														],
														[
															-2.894,
															-4.96
														],
														[
															-2.936,
															-4.412
														],
														[
															-5.13,
															-6.705
														],
														[
															-5.755,
															-6.164
														],
														[
															-1.544,
															-1.271
														],
														[
															-1.449,
															-1.386
														],
														[
															-12.11,
															-8.642
														],
														[
															-16.243,
															-5.246
														],
														[
															-0.317,
															0.024
														],
														[
															-0.182,
															0.245
														]
													],
													"v": [
														[
															349,
															16
														],
														[
															348.503,
															16.023
														],
														[
															348.001,
															16.015
														],
														[
															347.499,
															16
														],
														[
															347,
															16
														],
														[
															331.981,
															17.887
														],
														[
															318.034,
															21.986
														],
														[
															305.57,
															27.342
														],
														[
															295,
															33
														],
														[
															293.067,
															34.146
														],
														[
															291.481,
															35.116
														],
														[
															290,
															36
														],
														[
															286.222,
															38.532
														],
														[
															283,
															41
														],
														[
															281.46,
															41.519
														],
														[
															280,
															42
														],
														[
															237.62,
															84.288
														],
														[
															206,
															135
														],
														[
															199.089,
															148.779
														],
														[
															193,
															162
														],
														[
															181.406,
															195.403
														],
														[
															172,
															231
														],
														[
															161.933,
															286.099
														],
														[
															158,
															348
														],
														[
															181.513,
															516.178
														],
														[
															248,
															640
														],
														[
															256.012,
															649.045
														],
														[
															264,
															657
														],
														[
															266.539,
															658.544
														],
														[
															269,
															660
														],
														[
															272.919,
															664.03
														],
														[
															277,
															668
														],
														[
															278.532,
															668.525
														],
														[
															280,
															669
														],
														[
															285.174,
															672.784
														],
														[
															290,
															676
														],
														[
															292.662,
															677.601
														],
														[
															295,
															679
														],
														[
															307.189,
															685.66
														],
														[
															320,
															691
														],
														[
															328.404,
															693.291
														],
														[
															335,
															696
														],
														[
															338.997,
															703.352
														],
														[
															344,
															709
														],
														[
															350.851,
															709.812
														],
														[
															360,
															710
														],
														[
															368.799,
															709.744
														],
														[
															377,
															709
														],
														[
															420.47,
															697.946
														],
														[
															453,
															678
														],
														[
															480.54,
															651.167
														],
														[
															503,
															621
														],
														[
															510.786,
															608.163
														],
														[
															518,
															596
														],
														[
															518.494,
															594.551
														],
														[
															519,
															593
														],
														[
															528.22,
															574.623
														],
														[
															536,
															556
														],
														[
															538.701,
															549.07
														],
														[
															541,
															543
														],
														[
															544.933,
															530.899
														],
														[
															548,
															519
														],
														[
															548.977,
															517.557
														],
														[
															550,
															516
														],
														[
															550.024,
															514.007
														],
														[
															550,
															512
														],
														[
															550.977,
															510.557
														],
														[
															552,
															509
														],
														[
															553.546,
															501.548
														],
														[
															555,
															494
														],
														[
															566.055,
															432.609
														],
														[
															570,
															366
														],
														[
															566.853,
															299.436
														],
														[
															557,
															237
														],
														[
															545.461,
															194.473
														],
														[
															531,
															156
														],
														[
															524.211,
															140.652
														],
														[
															517,
															126
														],
														[
															515.052,
															123.549
														],
														[
															513,
															121
														],
														[
															511.538,
															118.056
														],
														[
															510,
															115
														],
														[
															501.352,
															101.076
														],
														[
															492,
															88
														],
														[
															475.79,
															68.701
														],
														[
															457,
															51
														],
														[
															452.588,
															46.936
														],
														[
															448,
															43
														],
														[
															405.606,
															21.298
														],
														[
															350,
															15
														],
														[
															349.23,
															15.521
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 38,
											"s": [
												{
													"i": [
														[
															22.593,
															-1.855
														],
														[
															0.335,
															0.009
														],
														[
															0.331,
															-0.009
														],
														[
															15.899,
															-7.805
														],
														[
															10.893,
															-9.275
														],
														[
															4.234,
															-4.256
														],
														[
															3.575,
															-4.153
														],
														[
															0.805,
															-1.21
														],
														[
															0.755,
															-0.97
														],
														[
															0.585,
															-0.288
														],
														[
															0.334,
															-0.428
														],
														[
															0.098,
															-0.553
														],
														[
															0.287,
															-0.375
														],
														[
															1.584,
															-1.848
														],
														[
															1.17,
															-1.656
														],
														[
															0.432,
															-1.037
														],
														[
															0.655,
															-0.978
														],
														[
															0.719,
															-0.581
														],
														[
															0.548,
															-0.814
														],
														[
															0.475,
															-1.073
														],
														[
															0.536,
															-0.87
														],
														[
															3.06,
															-5.344
														],
														[
															2.512,
															-5.349
														],
														[
															0.292,
															-1.054
														],
														[
															0.44,
															-0.955
														],
														[
															3.974,
															-11.477
														],
														[
															3.152,
															-12.36
														],
														[
															2.931,
															-19.894
														],
														[
															0,
															-21.657
														],
														[
															-1.989,
															-20.464
														],
														[
															-4.045,
															-18.451
														],
														[
															-5.928,
															-16.617
														],
														[
															-7.255,
															-14.131
														],
														[
															-10.948,
															-14.863
														],
														[
															-11.846,
															-10.265
														],
														[
															-1.216,
															-0.808
														],
														[
															-0.933,
															-0.726
														],
														[
															-0.288,
															-0.584
														],
														[
															-0.427,
															-0.337
														],
														[
															-0.556,
															-0.099
														],
														[
															-0.371,
															-0.284
														],
														[
															-0.314,
															-0.36
														],
														[
															-0.399,
															-0.298
														],
														[
															-2.413,
															-1.596
														],
														[
															-2.137,
															-0.963
														],
														[
															-0.157,
															-0.451
														],
														[
															-0.2,
															-0.12
														],
														[
															-1.048,
															-0.239
														],
														[
															-0.967,
															-0.536
														],
														[
															-0.823,
															-0.769
														],
														[
															-0.877,
															-0.465
														],
														[
															-4.007,
															-1.649
														],
														[
															-3.99,
															-1.292
														],
														[
															-1.033,
															-0.364
														],
														[
															-1.048,
															-0.279
														],
														[
															-1.422,
															-0.034
														],
														[
															-1.041,
															-0.526
														],
														[
															-1.026,
															-1.14
														],
														[
															-1.202,
															-1.586
														],
														[
															-0.191,
															-0.86
														],
														[
															-0.498,
															-0.582
														],
														[
															-4.088,
															-0.524
														],
														[
															-4.097,
															-0.091
														],
														[
															-2.851,
															0.204
														],
														[
															-2.772,
															0.247
														],
														[
															-4.065,
															0.451
														],
														[
															-3.448,
															0.814
														],
														[
															-1.15,
															0.589
														],
														[
															-1.214,
															0.366
														],
														[
															-8.303,
															4.036
														],
														[
															-6.784,
															4.842
														],
														[
															-0.814,
															0.678
														],
														[
															-0.868,
															0.664
														],
														[
															-6.525,
															6.653
														],
														[
															-5.474,
															6.711
														],
														[
															-0.636,
															0.804
														],
														[
															-0.596,
															0.731
														],
														[
															-1.363,
															1.852
														],
														[
															-1.006,
															1.699
														],
														[
															-1.042,
															1.262
														],
														[
															-0.874,
															1.332
														],
														[
															-8.238,
															19.524
														],
														[
															-5.865,
															21.855
														],
														[
															-2.179,
															33.441
														],
														[
															3.567,
															32.979
														],
														[
															9.068,
															28.082
														],
														[
															13.111,
															23.21
														],
														[
															22.18,
															19.09
														],
														[
															3.395,
															2.77
														],
														[
															7.124,
															3.989
														],
														[
															8.095,
															2.791
														]
													],
													"o": [
														[
															-0.33,
															0.027
														],
														[
															-0.335,
															-0.009
														],
														[
															-18.509,
															0.506
														],
														[
															-15.899,
															7.805
														],
														[
															-4.488,
															3.822
														],
														[
															-4.234,
															4.256
														],
														[
															-1.024,
															1.191
														],
														[
															-0.805,
															1.21
														],
														[
															-0.327,
															0.421
														],
														[
															-0.585,
															0.288
														],
														[
															-0.322,
															0.412
														],
														[
															-0.098,
															0.553
														],
														[
															-1.495,
															1.954
														],
														[
															-1.584,
															1.847
														],
														[
															-0.618,
															0.874
														],
														[
															-0.432,
															1.037
														],
														[
															-0.577,
															0.862
														],
														[
															-0.719,
															0.581
														],
														[
															-0.564,
															0.837
														],
														[
															-0.475,
															1.073
														],
														[
															-3.246,
															5.274
														],
														[
															-3.061,
															5.344
														],
														[
															-0.39,
															0.831
														],
														[
															-0.292,
															1.054
														],
														[
															-4.952,
															10.731
														],
														[
															-3.974,
															11.477
														],
														[
															-4.276,
															16.767
														],
														[
															-2.931,
															19.894
														],
														[
															0,
															21.692
														],
														[
															1.989,
															20.464
														],
														[
															4.034,
															18.399
														],
														[
															5.928,
															16.617
														],
														[
															8.36,
															16.283
														],
														[
															10.948,
															14.863
														],
														[
															1.204,
															1.043
														],
														[
															1.216,
															0.808
														],
														[
															0.421,
															0.328
														],
														[
															0.288,
															0.584
														],
														[
															0.406,
															0.321
														],
														[
															0.556,
															0.099
														],
														[
															0.344,
															0.263
														],
														[
															0.314,
															0.36
														],
														[
															2.211,
															1.654
														],
														[
															2.413,
															1.596
														],
														[
															0.171,
															0.077
														],
														[
															0.157,
															0.451
														],
														[
															0.842,
															0.507
														],
														[
															1.048,
															0.239
														],
														[
															0.832,
															0.461
														],
														[
															0.823,
															0.769
														],
														[
															3.984,
															2.113
														],
														[
															4.007,
															1.649
														],
														[
															0.821,
															0.266
														],
														[
															1.033,
															0.364
														],
														[
															1.272,
															0.34
														],
														[
															1.422,
															0.034
														],
														[
															1.692,
															0.856
														],
														[
															1.026,
															1.14
														],
														[
															0.74,
															0.977
														],
														[
															0.191,
															0.86
														],
														[
															1.552,
															1.814
														],
														[
															4.088,
															0.524
														],
														[
															2.827,
															0.063
														],
														[
															2.851,
															-0.204
														],
														[
															4.292,
															-0.383
														],
														[
															4.065,
															-0.451
														],
														[
															1.187,
															-0.28
														],
														[
															1.15,
															-0.588
														],
														[
															10.002,
															-3.015
														],
														[
															8.303,
															-4.036
														],
														[
															0.877,
															-0.626
														],
														[
															0.814,
															-0.678
														],
														[
															7.425,
															-5.678
														],
														[
															6.525,
															-6.653
														],
														[
															0.858,
															-1.052
														],
														[
															0.636,
															-0.804
														],
														[
															1.543,
															-1.892
														],
														[
															1.363,
															-1.852
														],
														[
															0.959,
															-1.619
														],
														[
															1.042,
															-1.262
														],
														[
															11.182,
															-17.051
														],
														[
															8.238,
															-19.524
														],
														[
															7.851,
															-29.257
														],
														[
															2.179,
															-33.441
														],
														[
															-3.619,
															-33.46
														],
														[
															-9.068,
															-28.082
														],
														[
															-15.424,
															-27.306
														],
														[
															-4.158,
															-3.579
														],
														[
															-6.455,
															-5.266
														],
														[
															-7.807,
															-4.372
														],
														[
															-18.182,
															-6.268
														]
													],
													"v": [
														[
															349,
															16
														],
														[
															348.001,
															16.014
														],
														[
															347,
															16
														],
														[
															294.788,
															29.924
														],
														[
															254,
															57
														],
														[
															240.815,
															69.251
														],
														[
															229,
															82
														],
														[
															226.298,
															85.665
														],
														[
															224,
															89
														],
														[
															222.505,
															89.994
														],
														[
															221,
															91
														],
														[
															220.474,
															92.528
														],
														[
															220,
															94
														],
														[
															215.256,
															99.724
														],
														[
															211,
															105
														],
														[
															209.528,
															107.922
														],
														[
															208,
															111
														],
														[
															205.979,
															113.036
														],
														[
															204,
															115
														],
														[
															202.479,
															117.975
														],
														[
															201,
															121
														],
														[
															191.449,
															136.944
														],
														[
															183,
															153
														],
														[
															182.038,
															155.907
														],
														[
															181,
															159
														],
														[
															167.65,
															192.279
														],
														[
															157,
															228
														],
														[
															145.793,
															283.332
														],
														[
															141,
															346
														],
														[
															143.966,
															409.431
														],
														[
															153,
															468
														],
														[
															168.084,
															520.701
														],
														[
															188,
															567
														],
														[
															217.385,
															614.514
														],
														[
															252,
															653
														],
														[
															255.703,
															655.737
														],
														[
															259,
															658
														],
														[
															259.996,
															659.493
														],
														[
															261,
															661
														],
														[
															262.526,
															661.528
														],
														[
															264,
															662
														],
														[
															264.958,
															662.973
														],
														[
															266,
															664
														],
														[
															273.056,
															669.018
														],
														[
															280,
															673
														],
														[
															280.478,
															673.967
														],
														[
															281,
															675
														],
														[
															283.906,
															675.979
														],
														[
															287,
															677
														],
														[
															289.467,
															678.997
														],
														[
															292,
															681
														],
														[
															303.996,
															686.616
														],
														[
															316,
															691
														],
														[
															318.83,
															691.99
														],
														[
															322,
															693
														],
														[
															326.173,
															693.36
														],
														[
															330,
															694
														],
														[
															333.868,
															696.953
														],
														[
															337,
															701
														],
														[
															338.182,
															703.796
														],
														[
															339,
															706
														],
														[
															348.091,
															709.292
														],
														[
															361,
															710
														],
														[
															369.541,
															709.733
														],
														[
															378,
															709
														],
														[
															390.633,
															707.823
														],
														[
															402,
															706
														],
														[
															405.48,
															704.564
														],
														[
															409,
															703
														],
														[
															436.413,
															692.37
														],
														[
															459,
															679
														],
														[
															461.507,
															677.029
														],
														[
															464,
															675
														],
														[
															484.964,
															656.274
														],
														[
															503,
															636
														],
														[
															505.196,
															633.26
														],
														[
															507,
															631
														],
														[
															511.403,
															625.355
														],
														[
															515,
															620
														],
														[
															518.064,
															615.785
														],
														[
															521,
															612
														],
														[
															549.988,
															557.103
														],
														[
															571,
															495
														],
														[
															586.063,
															399.791
														],
														[
															584,
															299
														],
														[
															564.619,
															206.813
														],
														[
															531,
															130
														],
														[
															474,
															58
														],
														[
															461,
															48
														],
														[
															441,
															35
														],
														[
															416,
															23
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 39,
											"s": [
												{
													"i": [
														[
															-0.106,
															0.008
														],
														[
															0.336,
															0.006
														],
														[
															0.329,
															0.002
														],
														[
															9.323,
															-2.601
														],
														[
															8.07,
															-3.645
														],
														[
															17.481,
															-17.033
														],
														[
															12.665,
															-20.838
														],
														[
															6.946,
															-15.71
														],
														[
															5.326,
															-18.529
														],
														[
															3.02,
															-20.869
														],
														[
															0,
															-20.413
														],
														[
															-2.362,
															-20.536
														],
														[
															-4.551,
															-18.296
														],
														[
															-2.074,
															-6.582
														],
														[
															-1.95,
															-5.626
														],
														[
															-0.585,
															-2.379
														],
														[
															-0.844,
															-2.126
														],
														[
															-0.576,
															-0.825
														],
														[
															-0.375,
															-0.888
														],
														[
															-0.284,
															-1.238
														],
														[
															-0.419,
															-0.994
														],
														[
															-1.077,
															-1.805
														],
														[
															-0.867,
															-1.829
														],
														[
															-1.724,
															-3.825
														],
														[
															-1.357,
															-3.01
														],
														[
															-0.451,
															-0.153
														],
														[
															-0.117,
															-0.21
														],
														[
															-0.637,
															-1.387
														],
														[
															-0.608,
															-0.938
														],
														[
															-0.761,
															-1.221
														],
														[
															-0.918,
															-1.515
														],
														[
															-0.465,
															-1.047
														],
														[
															-0.584,
															-0.89
														],
														[
															-0.734,
															-0.6
														],
														[
															-0.557,
															-0.827
														],
														[
															-0.438,
															-1.05
														],
														[
															-0.632,
															-0.885
														],
														[
															-0.678,
															-0.814
														],
														[
															-0.664,
															-0.868
														],
														[
															-6.288,
															-6.987
														],
														[
															-6.228,
															-5.701
														],
														[
															-1.453,
															-0.99
														],
														[
															-0.849,
															-0.813
														],
														[
															-0.31,
															-0.086
														],
														[
															-0.416,
															-0.325
														],
														[
															-1.453,
															-1.405
														],
														[
															-1.591,
															-1.135
														],
														[
															-7.676,
															-3.978
														],
														[
															-8.322,
															-3.111
														],
														[
															-2.806,
															-0.848
														],
														[
															-2.271,
															-0.673
														],
														[
															-2.681,
															-0.723
														],
														[
															-0.504,
															-0.581
														],
														[
															-1.198,
															-2.55
														],
														[
															-1.083,
															-0.499
														],
														[
															-0.718,
															0.113
														],
														[
															-0.576,
															-0.199
														],
														[
															-2.751,
															-0.285
														],
														[
															-2.846,
															-0.114
														],
														[
															-8.619,
															1.114
														],
														[
															-7.243,
															1.917
														],
														[
															-6.908,
															2.708
														],
														[
															-5.786,
															3.161
														],
														[
															-1.801,
															1.084
														],
														[
															-2.143,
															1.604
														],
														[
															-2.726,
															1.999
														],
														[
															-3.465,
															2.95
														],
														[
															-0.702,
															0.547
														],
														[
															-1.538,
															1.282
														],
														[
															-3.956,
															4.258
														],
														[
															-9.544,
															14.473
														],
														[
															-1.149,
															1.749
														],
														[
															-2.216,
															4.916
														],
														[
															-0.233,
															0.424
														],
														[
															-3.948,
															8.658
														],
														[
															0,
															72.59
														],
														[
															21.464,
															50.084
														],
														[
															1.643,
															3.688
														],
														[
															0.434,
															1.012
														],
														[
															3.786,
															8.398
														],
														[
															0.237,
															0.414
														],
														[
															1.093,
															1.844
														],
														[
															2.365,
															3.64
														],
														[
															4.022,
															5.335
														],
														[
															2.877,
															3.379
														],
														[
															0.547,
															0.702
														],
														[
															0.731,
															0.807
														],
														[
															5.559,
															5.016
														],
														[
															1.804,
															1.567
														],
														[
															3.606,
															2.789
														],
														[
															55.37,
															-3.818
														]
													],
													"o": [
														[
															-0.328,
															0.026
														],
														[
															-0.336,
															-0.006
														],
														[
															-9.638,
															-0.049
														],
														[
															-9.323,
															2.601
														],
														[
															-24.413,
															11.028
														],
														[
															-17.48,
															17.033
														],
														[
															-8.891,
															14.629
														],
														[
															-6.946,
															15.71
														],
														[
															-4.918,
															17.112
														],
														[
															-3.02,
															20.869
														],
														[
															0,
															23.562
														],
														[
															2.362,
															20.536
														],
														[
															1.753,
															7.047
														],
														[
															2.074,
															6.582
														],
														[
															0.817,
															2.357
														],
														[
															0.585,
															2.379
														],
														[
															0.322,
															0.812
														],
														[
															0.576,
															0.825
														],
														[
															0.445,
															1.052
														],
														[
															0.284,
															1.238
														],
														[
															0.824,
															1.952
														],
														[
															1.077,
															1.805
														],
														[
															1.748,
															3.688
														],
														[
															1.724,
															3.825
														],
														[
															0.079,
															0.177
														],
														[
															0.451,
															0.153
														],
														[
															0.843,
															1.512
														],
														[
															0.637,
															1.388
														],
														[
															1.037,
															1.601
														],
														[
															0.761,
															1.221
														],
														[
															0.558,
															0.92
														],
														[
															0.465,
															1.047
														],
														[
															0.506,
															0.772
														],
														[
															0.734,
															0.6
														],
														[
															0.617,
															0.916
														],
														[
															0.438,
															1.05
														],
														[
															0.626,
															0.877
														],
														[
															0.678,
															0.814
														],
														[
															5.621,
															7.351
														],
														[
															6.288,
															6.987
														],
														[
															1.338,
															1.225
														],
														[
															1.453,
															0.99
														],
														[
															0.346,
															0.331
														],
														[
															0.31,
															0.086
														],
														[
															1.596,
															1.245
														],
														[
															1.453,
															1.405
														],
														[
															6.973,
															4.976
														],
														[
															7.676,
															3.978
														],
														[
															2.505,
															0.936
														],
														[
															2.806,
															0.848
														],
														[
															1.774,
															0.526
														],
														[
															2.681,
															0.723
														],
														[
															1.125,
															1.299
														],
														[
															1.198,
															2.551
														],
														[
															0.55,
															0.254
														],
														[
															0.718,
															-0.113
														],
														[
															2.151,
															0.744
														],
														[
															2.751,
															0.285
														],
														[
															9.281,
															0.371
														],
														[
															8.619,
															-1.114
														],
														[
															7.58,
															-2.005
														],
														[
															6.908,
															-2.708
														],
														[
															1.685,
															-0.92
														],
														[
															3.648,
															-2.195
														],
														[
															3.147,
															-2.355
														],
														[
															3.583,
															-2.628
														],
														[
															0.738,
															-0.628
														],
														[
															1.995,
															-1.554
														],
														[
															4.658,
															-3.882
														],
														[
															12.489,
															-13.443
														],
														[
															1.085,
															-1.645
														],
														[
															3.178,
															-4.838
														],
														[
															0.16,
															-0.356
														],
														[
															4.504,
															-8.209
														],
														[
															23.35,
															-51.212
														],
														[
															0,
															-70.484
														],
														[
															-1.496,
															-3.491
														],
														[
															-0.334,
															-0.75
														],
														[
															-4.097,
															-9.561
														],
														[
															-0.158,
															-0.351
														],
														[
															-1.14,
															-1.999
														],
														[
															-2.448,
															-4.129
														],
														[
															-4.04,
															-6.22
														],
														[
															-2.684,
															-3.561
														],
														[
															-0.628,
															-0.738
														],
														[
															-0.655,
															-0.841
														],
														[
															-5.671,
															-6.263
														],
														[
															-1.773,
															-1.6
														],
														[
															-3.387,
															-2.943
														],
														[
															-32.407,
															-25.069
														],
														[
															-0.625,
															0.043
														]
													],
													"v": [
														[
															348,
															16
														],
														[
															347.001,
															16.02
														],
														[
															346,
															16
														],
														[
															317.324,
															20.23
														],
														[
															291,
															30
														],
														[
															228.688,
															72.642
														],
														[
															184,
															130
														],
														[
															160.327,
															175.075
														],
														[
															142,
															226
														],
														[
															129.811,
															284.024
														],
														[
															125,
															347
														],
														[
															128.587,
															412.949
														],
														[
															139,
															471
														],
														[
															144.852,
															491.565
														],
														[
															151,
															510
														],
														[
															152.98,
															517.173
														],
														[
															155,
															524
														],
														[
															156.46,
															526.443
														],
														[
															158,
															529
														],
														[
															159.019,
															532.543
														],
														[
															160,
															536
														],
														[
															162.968,
															541.593
														],
														[
															166,
															547
														],
														[
															171.293,
															558.508
														],
														[
															176,
															569
														],
														[
															176.972,
															569.475
														],
														[
															178,
															570
														],
														[
															180.176,
															574.43
														],
														[
															182,
															578
														],
														[
															184.59,
															582.064
														],
														[
															187,
															586
														],
														[
															188.48,
															589.023
														],
														[
															190,
															592
														],
														[
															191.962,
															593.958
														],
														[
															194,
															596
														],
														[
															195.489,
															599.023
														],
														[
															197,
															602
														],
														[
															198.971,
															604.507
														],
														[
															201,
															607
														],
														[
															219.045,
															628.737
														],
														[
															238,
															648
														],
														[
															242.366,
															651.308
														],
														[
															246,
															654
														],
														[
															246.947,
															654.505
														],
														[
															248,
															655
														],
														[
															252.504,
															659.082
														],
														[
															257,
															663
														],
														[
															278.988,
															676.399
														],
														[
															303,
															687
														],
														[
															311.175,
															689.697
														],
														[
															319,
															692
														],
														[
															326.452,
															693.959
														],
														[
															332,
															696
														],
														[
															335.532,
															702.6
														],
														[
															339,
															708
														],
														[
															340.981,
															708.041
														],
														[
															343,
															708
														],
														[
															350.479,
															709.473
														],
														[
															359,
															710
														],
														[
															386.029,
															708.716
														],
														[
															410,
															704
														],
														[
															431.845,
															696.867
														],
														[
															451,
															688
														],
														[
															456,
															684
														],
														[
															465,
															679
														],
														[
															474,
															673
														],
														[
															484,
															664
														],
														[
															487,
															663
														],
														[
															492,
															658
														],
														[
															504,
															646
														],
														[
															538,
															604
														],
														[
															541,
															598
														],
														[
															550,
															582
														],
														[
															552,
															581
														],
														[
															564,
															555
														],
														[
															604,
															367
														],
														[
															569,
															180
														],
														[
															565,
															170
														],
														[
															563,
															167
														],
														[
															550,
															140
														],
														[
															548,
															139
														],
														[
															545,
															133
														],
														[
															538,
															121
														],
														[
															526,
															104
														],
														[
															517,
															94
														],
														[
															516,
															91
														],
														[
															513,
															89
														],
														[
															495,
															69
														],
														[
															489,
															65
														],
														[
															479,
															56
														],
														[
															349,
															15
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 40,
											"s": [
												{
													"i": [
														[
															-0.054,
															0.004
														],
														[
															2.651,
															-0.228
														],
														[
															2.579,
															-0.302
														],
														[
															2.514,
															-0.423
														],
														[
															2.454,
															-0.59
														],
														[
															1.1,
															-0.32
														],
														[
															1.092,
															-0.351
														],
														[
															1.071,
															-0.355
														],
														[
															1.036,
															-0.333
														],
														[
															1.593,
															-0.408
														],
														[
															1.543,
															-0.422
														],
														[
															1.443,
															-0.555
														],
														[
															1.808,
															-1.095
														],
														[
															1.915,
															-0.907
														],
														[
															3.031,
															-1.481
														],
														[
															2.656,
															-1.55
														],
														[
															3.567,
															-2.381
														],
														[
															2.91,
															-2.248
														],
														[
															4.974,
															-4.2
														],
														[
															3.99,
															-4.25
														],
														[
															3.575,
															-3.817
														],
														[
															3.097,
															-3.892
														],
														[
															7.725,
															-13.173
														],
														[
															5.933,
															-13.791
														],
														[
															2.208,
															-6.138
														],
														[
															1.683,
															-5.674
														],
														[
															0.518,
															-1.72
														],
														[
															0.411,
															-1.378
														],
														[
															0.987,
															-3.359
														],
														[
															0.901,
															-3.708
														],
														[
															1.664,
															-28.242
														],
														[
															-3.345,
															-26.62
														],
														[
															-9.225,
															-26.488
														],
														[
															-13.164,
															-21.723
														],
														[
															-21.025,
															-19.628
														],
														[
															-27.506,
															-10.734
														],
														[
															-1.156,
															-0.279
														],
														[
															-1.148,
															-0.404
														],
														[
															-2.156,
															-0.915
														],
														[
															-2.343,
															-0.626
														],
														[
															-3.646,
															-0.622
														],
														[
															-1.352,
															-1.692
														],
														[
															-0.209,
															-0.87
														],
														[
															-0.692,
															-0.929
														],
														[
															-0.535,
															-1.059
														],
														[
															-0.833,
															-0.384
														],
														[
															-0.718,
															0.109
														],
														[
															-0.578,
															-0.185
														],
														[
															-6.039,
															0.037
														],
														[
															-5.932,
															0.425
														],
														[
															-10.46,
															2.305
														],
														[
															-9.251,
															3.854
														],
														[
															-5.251,
															2.985
														],
														[
															-4.178,
															2.635
														],
														[
															-0.375,
															-0.067
														],
														[
															-0.26,
															0.118
														],
														[
															-0.163,
															0.451
														],
														[
															-0.185,
															0.123
														],
														[
															-0.379,
															-0.067
														],
														[
															-0.255,
															0.115
														],
														[
															-0.163,
															0.451
														],
														[
															-0.185,
															0.123
														],
														[
															-0.379,
															-0.067
														],
														[
															-0.255,
															0.115
														],
														[
															-0.163,
															0.451
														],
														[
															-0.185,
															0.123
														],
														[
															-0.379,
															-0.067
														],
														[
															-0.255,
															0.115
														],
														[
															-0.17,
															0.452
														],
														[
															-0.169,
															0.125
														],
														[
															-0.984,
															0.611
														],
														[
															-1.009,
															0.781
														],
														[
															-9.487,
															10.089
														],
														[
															-7.914,
															11.03
														],
														[
															-8.463,
															17.336
														],
														[
															-6.267,
															19.491
														],
														[
															-3.653,
															22.401
														],
														[
															0,
															25.536
														],
														[
															0.609,
															12.133
														],
														[
															1.563,
															11.429
														],
														[
															1.454,
															6.953
														],
														[
															1.272,
															5.522
														],
														[
															1.895,
															6.44
														],
														[
															1.872,
															5.519
														],
														[
															7.509,
															15.34
														],
														[
															9.13,
															13.447
														],
														[
															12.92,
															12.954
														],
														[
															16.293,
															10.419
														],
														[
															20.595,
															5.791
														],
														[
															25.272,
															-1.617
														],
														[
															0.185,
															-0.246
														]
													],
													"o": [
														[
															-2.729,
															0.202
														],
														[
															-2.651,
															0.228
														],
														[
															-2.579,
															0.302
														],
														[
															-2.514,
															0.423
														],
														[
															-1.095,
															0.263
														],
														[
															-1.1,
															0.32
														],
														[
															-1.092,
															0.351
														],
														[
															-1.071,
															0.355
														],
														[
															-1.594,
															0.513
														],
														[
															-1.593,
															0.408
														],
														[
															-1.543,
															0.422
														],
														[
															-1.853,
															0.712
														],
														[
															-1.808,
															1.095
														],
														[
															-3.221,
															1.526
														],
														[
															-3.031,
															1.481
														],
														[
															-3.82,
															2.228
														],
														[
															-3.567,
															2.381
														],
														[
															-5.114,
															3.952
														],
														[
															-4.974,
															4.2
														],
														[
															-3.605,
															3.84
														],
														[
															-3.575,
															3.817
														],
														[
															-9.168,
															11.519
														],
														[
															-7.725,
															13.173
														],
														[
															-2.484,
															5.774
														],
														[
															-2.208,
															6.138
														],
														[
															-0.517,
															1.743
														],
														[
															-0.518,
															1.72
														],
														[
															-1.15,
															3.855
														],
														[
															-0.987,
															3.359
														],
														[
															-5.69,
															23.412
														],
														[
															-1.664,
															28.242
														],
														[
															3.936,
															31.327
														],
														[
															9.225,
															26.488
														],
														[
															14.395,
															23.755
														],
														[
															21.025,
															19.628
														],
														[
															1.229,
															0.479
														],
														[
															1.156,
															0.279
														],
														[
															2.034,
															0.715
														],
														[
															2.156,
															0.915
														],
														[
															3.065,
															0.819
														],
														[
															3.646,
															0.622
														],
														[
															0.473,
															0.591
														],
														[
															0.209,
															0.87
														],
														[
															1.028,
															1.379
														],
														[
															0.535,
															1.059
														],
														[
															0.548,
															0.253
														],
														[
															0.718,
															-0.109
														],
														[
															4.913,
															1.572
														],
														[
															6.039,
															-0.037
														],
														[
															12.909,
															-0.925
														],
														[
															10.46,
															-2.305
														],
														[
															5.817,
															-2.423
														],
														[
															5.251,
															-2.985
														],
														[
															0.239,
															-0.15
														],
														[
															0.375,
															0.067
														],
														[
															0.162,
															-0.073
														],
														[
															0.163,
															-0.451
														],
														[
															0.23,
															-0.154
														],
														[
															0.379,
															0.067
														],
														[
															0.162,
															-0.073
														],
														[
															0.163,
															-0.451
														],
														[
															0.23,
															-0.154
														],
														[
															0.379,
															0.067
														],
														[
															0.162,
															-0.073
														],
														[
															0.163,
															-0.451
														],
														[
															0.23,
															-0.154
														],
														[
															0.379,
															0.067
														],
														[
															0.152,
															-0.068
														],
														[
															0.17,
															-0.452
														],
														[
															1.055,
															-0.775
														],
														[
															0.984,
															-0.611
														],
														[
															11.136,
															-8.614
														],
														[
															9.487,
															-10.089
														],
														[
															10.881,
															-15.163
														],
														[
															8.463,
															-17.336
														],
														[
															6.387,
															-19.863
														],
														[
															3.653,
															-22.401
														],
														[
															0,
															-13.038
														],
														[
															-0.609,
															-12.133
														],
														[
															-0.911,
															-6.666
														],
														[
															-1.454,
															-6.953
														],
														[
															-1.548,
															-6.721
														],
														[
															-1.895,
															-6.44
														],
														[
															-5.833,
															-17.192
														],
														[
															-7.509,
															-15.34
														],
														[
															-10.026,
															-14.766
														],
														[
															-12.92,
															-12.954
														],
														[
															-16.349,
															-10.454
														],
														[
															-20.595,
															-5.791
														],
														[
															-0.313,
															0.02
														],
														[
															-0.185,
															0.246
														]
													],
													"v": [
														[
															348,
															16
														],
														[
															339.931,
															16.633
														],
														[
															332.088,
															17.417
														],
														[
															324.451,
															18.492
														],
														[
															317,
															20
														],
														[
															313.703,
															20.882
														],
														[
															310.411,
															21.895
														],
														[
															307.163,
															22.961
														],
														[
															304,
															24
														],
														[
															299.207,
															25.351
														],
														[
															294.491,
															26.565
														],
														[
															290,
															28
														],
														[
															284.547,
															30.854
														],
														[
															279,
															34
														],
														[
															269.577,
															38.482
														],
														[
															261,
															43
														],
														[
															249.817,
															49.985
														],
														[
															240,
															57
														],
														[
															224.656,
															69.276
														],
														[
															211,
															82
														],
														[
															200.12,
															93.461
														],
														[
															190,
															105
														],
														[
															164.574,
															142.296
														],
														[
															144,
															183
														],
														[
															136.9,
															201.074
														],
														[
															131,
															219
														],
														[
															129.421,
															224.274
														],
														[
															128,
															229
														],
														[
															124.814,
															239.61
														],
														[
															122,
															250
														],
														[
															110.724,
															329.094
														],
														[
															113,
															413
														],
														[
															133.079,
															499.704
														],
														[
															167,
															572
														],
														[
															220.167,
															638.265
														],
														[
															293,
															685
														],
														[
															296.561,
															686.057
														],
														[
															300,
															687
														],
														[
															306.268,
															689.566
														],
														[
															313,
															692
														],
														[
															323.784,
															693.846
														],
														[
															332,
															697
														],
														[
															332.835,
															699.246
														],
														[
															334,
															702
														],
														[
															336.146,
															705.746
														],
														[
															338,
															708
														],
														[
															339.977,
															708.051
														],
														[
															342,
															708
														],
														[
															358.736,
															709.997
														],
														[
															377,
															709
														],
														[
															411.744,
															704.197
														],
														[
															441,
															695
														],
														[
															457.729,
															686.659
														],
														[
															472,
															678
														],
														[
															472.984,
															677.975
														],
														[
															474,
															678
														],
														[
															474.483,
															677.038
														],
														[
															475,
															676
														],
														[
															475.981,
															675.971
														],
														[
															477,
															676
														],
														[
															477.483,
															675.038
														],
														[
															478,
															674
														],
														[
															478.981,
															673.971
														],
														[
															480,
															674
														],
														[
															480.483,
															673.038
														],
														[
															481,
															672
														],
														[
															481.981,
															671.971
														],
														[
															483,
															672
														],
														[
															483.487,
															671.042
														],
														[
															484,
															670
														],
														[
															487.035,
															668.004
														],
														[
															490,
															666
														],
														[
															520.916,
															637.812
														],
														[
															547,
															606
														],
														[
															575.96,
															557.246
														],
														[
															598,
															502
														],
														[
															613.29,
															438.755
														],
														[
															619,
															367
														],
														[
															618.173,
															329.293
														],
														[
															615,
															294
														],
														[
															611.27,
															273.142
														],
														[
															607,
															254
														],
														[
															601.743,
															234.098
														],
														[
															596,
															216
														],
														[
															575.973,
															167.191
														],
														[
															551,
															124
														],
														[
															516.7,
															82.239
														],
														[
															473,
															47
														],
														[
															417.693,
															21.946
														],
														[
															349,
															15
														],
														[
															348.224,
															15.518
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 41,
											"s": [
												{
													"i": [
														[
															-0.109,
															0.008
														],
														[
															0.335,
															0.006
														],
														[
															0.33,
															0
														],
														[
															9.901,
															-2.411
														],
														[
															8.815,
															-3.339
														],
														[
															6.631,
															-3.21
														],
														[
															5.334,
															-3.456
														],
														[
															2.345,
															-1.482
														],
														[
															2.062,
															-1.416
														],
														[
															0.833,
															-0.703
														],
														[
															0.815,
															-0.602
														],
														[
															0.52,
															-0.085
														],
														[
															0.48,
															-0.335
														],
														[
															0.293,
															-0.596
														],
														[
															0.412,
															-0.324
														],
														[
															0.521,
															-0.081
														],
														[
															0.483,
															-0.337
														],
														[
															0.295,
															-0.594
														],
														[
															0.403,
															-0.334
														],
														[
															0.523,
															-0.078
														],
														[
															0.483,
															-0.338
														],
														[
															1.139,
															-1.269
														],
														[
															1.091,
															-0.98
														],
														[
															7.246,
															-8.055
														],
														[
															6.032,
															-8.606
														],
														[
															7.912,
															-15.965
														],
														[
															6.322,
															-18.832
														],
														[
															3.824,
															-27.124
														],
														[
															-1.565,
															-29.851
														],
														[
															-0.74,
															-5.3
														],
														[
															-0.749,
															-5.274
														],
														[
															-1.946,
															-9.993
														],
														[
															-2.715,
															-9.462
														],
														[
															-7.561,
															-16.713
														],
														[
															-9.325,
															-14.219
														],
														[
															-9.917,
															-11.278
														],
														[
															-11.061,
															-9.28
														],
														[
															-1.64,
															-1.56
														],
														[
															-1.711,
															-1.309
														],
														[
															-0.521,
															-0.083
														],
														[
															-0.481,
															-0.337
														],
														[
															-0.29,
															-0.6
														],
														[
															-0.423,
															-0.308
														],
														[
															-1.075,
															-0.45
														],
														[
															-0.899,
															-0.619
														],
														[
															-0.825,
															-0.721
														],
														[
															-0.869,
															-0.543
														],
														[
															-1.38,
															-0.857
														],
														[
															-0.966,
															-0.626
														],
														[
															-8.652,
															-3.732
														],
														[
															-8.255,
															-2.449
														],
														[
															-1.149,
															-0.322
														],
														[
															-1.155,
															-0.342
														],
														[
															-1.788,
															-0.493
														],
														[
															-1.846,
															-0.436
														],
														[
															-1.434,
															-0.305
														],
														[
															-0.979,
															-0.477
														],
														[
															-0.548,
															0.098
														],
														[
															-0.404,
															-0.197
														],
														[
															-0.078,
															-0.613
														],
														[
															-0.288,
															-0.351
														],
														[
															-1.307,
															-2.107
														],
														[
															-0.781,
															-0.36
														],
														[
															-0.719,
															0.107
														],
														[
															-0.579,
															-0.177
														],
														[
															-6.2,
															0.022
														],
														[
															-6.258,
															0.419
														],
														[
															-10.905,
															2.423
														],
														[
															-16.823,
															9.94
														],
														[
															-3.131,
															1.411
														],
														[
															-0.369,
															0.247
														],
														[
															-3.631,
															3.479
														],
														[
															-0.781,
															0.631
														],
														[
															-4.174,
															1.882
														],
														[
															-0.295,
															0.246
														],
														[
															-5.161,
															5.637
														],
														[
															-1.519,
															1.72
														],
														[
															-1.539,
															1.812
														],
														[
															-7.029,
															15.594
														],
														[
															-0.238,
															0.409
														],
														[
															-1.189,
															2.165
														],
														[
															-4.956,
															11.563
														],
														[
															-0.377,
															0.937
														],
														[
															-0.9,
															2.355
														],
														[
															-1.587,
															4.662
														],
														[
															-1.442,
															51.826
														],
														[
															7.169,
															30.005
														],
														[
															3.067,
															9.644
														],
														[
															23.175,
															31.166
														],
														[
															34.446,
															20.056
														],
														[
															52.198,
															-3.341
														]
													],
													"o": [
														[
															-0.329,
															0.024
														],
														[
															-0.335,
															-0.006
														],
														[
															-10.579,
															0.015
														],
														[
															-9.901,
															2.411
														],
														[
															-7.141,
															2.705
														],
														[
															-6.631,
															3.21
														],
														[
															-2.558,
															1.658
														],
														[
															-2.345,
															1.482
														],
														[
															-0.851,
															0.584
														],
														[
															-0.833,
															0.703
														],
														[
															-0.439,
															0.324
														],
														[
															-0.52,
															0.085
														],
														[
															-0.417,
															0.291
														],
														[
															-0.293,
															0.596
														],
														[
															-0.432,
															0.34
														],
														[
															-0.521,
															0.081
														],
														[
															-0.416,
															0.291
														],
														[
															-0.295,
															0.594
														],
														[
															-0.425,
															0.352
														],
														[
															-0.523,
															0.078
														],
														[
															-1.351,
															0.945
														],
														[
															-1.139,
															1.269
														],
														[
															-7.984,
															7.174
														],
														[
															-7.246,
															8.055
														],
														[
															-10.031,
															14.31
														],
														[
															-7.912,
															15.965
														],
														[
															-7.269,
															21.651
														],
														[
															-3.824,
															27.125
														],
														[
															0.29,
															5.528
														],
														[
															0.74,
															5.3
														],
														[
															1.5,
															10.565
														],
														[
															1.946,
															9.993
														],
														[
															5.43,
															18.928
														],
														[
															7.561,
															16.713
														],
														[
															8.269,
															12.609
														],
														[
															9.917,
															11.278
														],
														[
															1.731,
															1.452
														],
														[
															1.64,
															1.56
														],
														[
															0.435,
															0.333
														],
														[
															0.521,
															0.083
														],
														[
															0.416,
															0.291
														],
														[
															0.29,
															0.6
														],
														[
															0.8,
															0.582
														],
														[
															1.075,
															0.45
														],
														[
															0.832,
															0.573
														],
														[
															0.825,
															0.721
														],
														[
															1.515,
															0.945
														],
														[
															1.38,
															0.857
														],
														[
															7.137,
															4.624
														],
														[
															8.652,
															3.732
														],
														[
															1.249,
															0.37
														],
														[
															1.149,
															0.322
														],
														[
															2,
															0.593
														],
														[
															1.788,
															0.493
														],
														[
															1.284,
															0.303
														],
														[
															1.434,
															0.305
														],
														[
															0.404,
															0.197
														],
														[
															0.548,
															-0.098
														],
														[
															0.401,
															0.196
														],
														[
															0.078,
															0.613
														],
														[
															0.993,
															1.214
														],
														[
															1.307,
															2.107
														],
														[
															0.546,
															0.252
														],
														[
															0.719,
															-0.107
														],
														[
															4.943,
															1.507
														],
														[
															6.2,
															-0.022
														],
														[
															12.946,
															-0.868
														],
														[
															23.388,
															-5.197
														],
														[
															3.583,
															-2.117
														],
														[
															0.323,
															-0.146
														],
														[
															5.139,
															-3.444
														],
														[
															0.663,
															-0.635
														],
														[
															4.106,
															-3.317
														],
														[
															0.274,
															-0.124
														],
														[
															6.393,
															-5.328
														],
														[
															1.652,
															-1.804
														],
														[
															1.615,
															-1.83
														],
														[
															11.149,
															-13.128
														],
														[
															0.157,
															-0.347
														],
														[
															1.191,
															-2.046
														],
														[
															6.281,
															-11.434
														],
														[
															0.494,
															-1.152
														],
														[
															1.06,
															-2.632
														],
														[
															1.851,
															-4.847
														],
														[
															13.45,
															-39.501
														],
														[
															1.075,
															-38.636
														],
														[
															-2.722,
															-11.394
														],
														[
															-13.21,
															-41.532
														],
														[
															-21.748,
															-29.247
														],
														[
															-33.972,
															-19.78
														],
														[
															-0.627,
															0.04
														]
													],
													"v": [
														[
															347,
															16
														],
														[
															346.001,
															16.018
														],
														[
															345,
															16
														],
														[
															314.177,
															20.007
														],
														[
															286,
															29
														],
														[
															265.145,
															37.936
														],
														[
															247,
															48
														],
														[
															239.628,
															52.682
														],
														[
															233,
															57
														],
														[
															230.473,
															58.986
														],
														[
															228,
															61
														],
														[
															226.531,
															61.491
														],
														[
															225,
															62
														],
														[
															223.996,
															63.476
														],
														[
															223,
															65
														],
														[
															221.538,
															65.502
														],
														[
															220,
															66
														],
														[
															218.99,
															67.467
														],
														[
															218,
															69
														],
														[
															216.543,
															69.511
														],
														[
															215,
															70
														],
														[
															211.304,
															73.474
														],
														[
															208,
															77
														],
														[
															185.036,
															99.926
														],
														[
															165,
															125
														],
														[
															138.219,
															170.108
														],
														[
															117,
															222
														],
														[
															99.875,
															295.851
														],
														[
															96,
															382
														],
														[
															97.655,
															398.19
														],
														[
															100,
															414
														],
														[
															105.089,
															444.827
														],
														[
															112,
															474
														],
														[
															131.579,
															527.532
														],
														[
															157,
															574
														],
														[
															184.406,
															609.997
														],
														[
															216,
															641
														],
														[
															221.015,
															645.607
														],
														[
															226,
															650
														],
														[
															227.466,
															650.497
														],
														[
															229,
															651
														],
														[
															229.995,
															652.488
														],
														[
															231,
															654
														],
														[
															233.926,
															655.472
														],
														[
															237,
															657
														],
														[
															239.473,
															659.023
														],
														[
															242,
															661
														],
														[
															246.412,
															663.739
														],
														[
															250,
															666
														],
														[
															274.161,
															678.631
														],
														[
															300,
															688
														],
														[
															303.57,
															689.021
														],
														[
															307,
															690
														],
														[
															312.616,
															691.618
														],
														[
															318,
															693
														],
														[
															322.229,
															693.87
														],
														[
															326,
															695
														],
														[
															327.5,
															695
														],
														[
															329,
															695
														],
														[
															329.586,
															696.383
														],
														[
															330,
															698
														],
														[
															333.659,
															703.64
														],
														[
															337,
															708
														],
														[
															338.975,
															708.056
														],
														[
															341,
															708
														],
														[
															358.014,
															709.945
														],
														[
															377,
															709
														],
														[
															413,
															705
														],
														[
															477,
															679
														],
														[
															488,
															673
														],
														[
															489,
															671
														],
														[
															505,
															660
														],
														[
															507,
															659
														],
														[
															519,
															649
														],
														[
															520,
															647
														],
														[
															538,
															630
														],
														[
															542,
															624
														],
														[
															547,
															619
														],
														[
															578,
															574
														],
														[
															580,
															573
														],
														[
															583,
															566
														],
														[
															601,
															529
														],
														[
															603,
															526
														],
														[
															605,
															518
														],
														[
															611,
															504
														],
														[
															634,
															367
														],
														[
															622,
															260
														],
														[
															613,
															229
														],
														[
															560,
															122
														],
														[
															477,
															46
														],
														[
															348,
															15
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 42,
											"s": [
												{
													"i": [
														[
															-0.112,
															0.008
														],
														[
															5.81,
															-0.585
														],
														[
															5.833,
															-1.247
														],
														[
															6.168,
															-2.001
														],
														[
															4.458,
															-1.739
														],
														[
															2.135,
															-0.787
														],
														[
															1.9,
															-0.854
														],
														[
															4.816,
															-2.654
														],
														[
															4.579,
															-2.064
														],
														[
															0.16,
															-0.451
														],
														[
															0.192,
															-0.123
														],
														[
															0.988,
															-0.419
														],
														[
															1.005,
															-0.66
														],
														[
															11.708,
															-11.395
														],
														[
															9.877,
															-13.032
														],
														[
															11.237,
															-25.489
														],
														[
															5.84,
															-31.655
														],
														[
															1.22,
															-11.308
														],
														[
															0.071,
															-11.666
														],
														[
															-0.603,
															-11.267
														],
														[
															-1.661,
															-10.798
														],
														[
															-3.883,
															-14.737
														],
														[
															-4.972,
															-12.844
														],
														[
															-5.269,
															-10.208
														],
														[
															-5.572,
															-8.924
														],
														[
															-0.728,
															-1.373
														],
														[
															-0.418,
															-0.436
														],
														[
															-0.298,
															-0.539
														],
														[
															-0.407,
															-0.425
														],
														[
															-0.766,
															-1.173
														],
														[
															-0.825,
															-1.151
														],
														[
															-1.979,
															-2.673
														],
														[
															-2.094,
															-2.529
														],
														[
															-6.037,
															-6.07
														],
														[
															-5.559,
															-5.325
														],
														[
															-0.685,
															-0.59
														],
														[
															-3.382,
															-2.732
														],
														[
															-0.735,
															-0.573
														],
														[
															-0.859,
															-0.663
														],
														[
															-0.48,
															-0.216
														],
														[
															-0.346,
															-0.249
														],
														[
															-5.315,
															-2.396
														],
														[
															-0.387,
															-0.244
														],
														[
															-2.114,
															-1.236
														],
														[
															-7.124,
															-2.795
														],
														[
															-10.75,
															-3.21
														],
														[
															-7.334,
															-1.517
														],
														[
															-1.84,
															-2.802
														],
														[
															-1.95,
															-1.441
														],
														[
															-8.254,
															-0.331
														],
														[
															-5.696,
															0.373
														],
														[
															-10.999,
															2.292
														],
														[
															-16.227,
															8.331
														],
														[
															-4.356,
															1.964
														],
														[
															-0.37,
															0.247
														],
														[
															-0.511,
															0.23
														],
														[
															-0.395,
															0.242
														],
														[
															-1.915,
															1.283
														],
														[
															-1.765,
															1.276
														],
														[
															-0.495,
															0.223
														],
														[
															-0.37,
															0.247
														],
														[
															-0.511,
															0.23
														],
														[
															-0.335,
															0.249
														],
														[
															-3.829,
															3.191
														],
														[
															-16.106,
															23.719
														],
														[
															-1.918,
															4.255
														],
														[
															-0.247,
															0.37
														],
														[
															-0.23,
															0.511
														],
														[
															-0.241,
															0.4
														],
														[
															-0.677,
															1.318
														],
														[
															-0.515,
															0.939
														],
														[
															-4.323,
															9.334
														],
														[
															-1.874,
															4.775
														],
														[
															0,
															57.761
														],
														[
															14.658,
															42.446
														],
														[
															10.028,
															17.649
														],
														[
															0.687,
															1.523
														],
														[
															0.237,
															0.411
														],
														[
															1.238,
															2.045
														],
														[
															1.13,
															2.507
														],
														[
															0.247,
															0.37
														],
														[
															0.23,
															0.511
														],
														[
															0.247,
															0.37
														],
														[
															0.23,
															0.511
														],
														[
															0.247,
															0.37
														],
														[
															0.23,
															0.511
														],
														[
															0.249,
															0.354
														],
														[
															4.235,
															5.272
														],
														[
															4.702,
															5.122
														],
														[
															7.312,
															6.456
														],
														[
															79.463,
															-4.668
														]
													],
													"o": [
														[
															-5.925,
															0.411
														],
														[
															-5.81,
															0.585
														],
														[
															-5.87,
															1.255
														],
														[
															-6.168,
															2.001
														],
														[
															-2.56,
															0.999
														],
														[
															-2.135,
															0.787
														],
														[
															-5.158,
															2.318
														],
														[
															-4.816,
															2.654
														],
														[
															-0.166,
															0.075
														],
														[
															-0.16,
															0.451
														],
														[
															-1.045,
															0.665
														],
														[
															-0.987,
															0.419
														],
														[
															-14.291,
															9.389
														],
														[
															-11.708,
															11.395
														],
														[
															-16.21,
															21.387
														],
														[
															-11.237,
															25.489
														],
														[
															-2.048,
															11.105
														],
														[
															-1.22,
															11.308
														],
														[
															-0.074,
															12.134
														],
														[
															0.603,
															11.267
														],
														[
															2.494,
															16.207
														],
														[
															3.883,
															14.737
														],
														[
															4.352,
															11.244
														],
														[
															5.269,
															10.208
														],
														[
															0.669,
															1.072
														],
														[
															0.728,
															1.373
														],
														[
															0.401,
															0.419
														],
														[
															0.298,
															0.539
														],
														[
															1.111,
															1.159
														],
														[
															0.766,
															1.173
														],
														[
															1.992,
															2.779
														],
														[
															1.979,
															2.673
														],
														[
															5.293,
															6.394
														],
														[
															6.037,
															6.07
														],
														[
															0.606,
															0.581
														],
														[
															3.195,
															2.754
														],
														[
															0.796,
															0.643
														],
														[
															0.84,
															0.655
														],
														[
															0.408,
															0.315
														],
														[
															0.309,
															0.139
														],
														[
															5.454,
															3.92
														],
														[
															0.334,
															0.151
														],
														[
															2.057,
															1.3
														],
														[
															6.825,
															3.991
														],
														[
															9.32,
															3.657
														],
														[
															6.837,
															2.042
														],
														[
															5.351,
															1.107
														],
														[
															1.818,
															2.768
														],
														[
															4.088,
															3.022
														],
														[
															6.551,
															0.262
														],
														[
															13.165,
															-0.863
														],
														[
															22.813,
															-4.754
														],
														[
															5.218,
															-2.679
														],
														[
															0.324,
															-0.146
														],
														[
															0.46,
															-0.307
														],
														[
															0.339,
															-0.153
														],
														[
															2.02,
															-1.241
														],
														[
															1.94,
															-1.299
														],
														[
															0.433,
															-0.313
														],
														[
															0.324,
															-0.146
														],
														[
															0.46,
															-0.307
														],
														[
															0.302,
															-0.136
														],
														[
															4.198,
															-3.117
														],
														[
															22.685,
															-18.904
														],
														[
															2.99,
															-4.404
														],
														[
															0.146,
															-0.324
														],
														[
															0.307,
															-0.46
														],
														[
															0.154,
															-0.342
														],
														[
															0.779,
															-1.293
														],
														[
															0.53,
															-1.032
														],
														[
															4.839,
															-8.819
														],
														[
															2.541,
															-5.487
														],
														[
															16.938,
															-43.164
														],
														[
															0,
															-52.232
														],
														[
															-8.12,
															-23.513
														],
														[
															-1.159,
															-2.039
														],
														[
															-0.157,
															-0.349
														],
														[
															-1.291,
															-2.237
														],
														[
															-1.75,
															-2.891
														],
														[
															-0.146,
															-0.324
														],
														[
															-0.307,
															-0.46
														],
														[
															-0.146,
															-0.324
														],
														[
															-0.307,
															-0.46
														],
														[
															-0.146,
															-0.324
														],
														[
															-0.307,
															-0.46
														],
														[
															-0.141,
															-0.314
														],
														[
															-4.497,
															-6.398
														],
														[
															-4.662,
															-5.804
														],
														[
															-6.39,
															-6.961
														],
														[
															-41.81,
															-36.916
														],
														[
															-0.628,
															0.037
														]
													],
													"v": [
														[
															347,
															16
														],
														[
															329.431,
															17.373
														],
														[
															312,
															20
														],
														[
															293.441,
															25.137
														],
														[
															277,
															31
														],
														[
															270.005,
															33.609
														],
														[
															264,
															36
														],
														[
															249.066,
															43.691
														],
														[
															235,
															51
														],
														[
															234.519,
															51.964
														],
														[
															234,
															53
														],
														[
															230.97,
															54.503
														],
														[
															228,
															56
														],
														[
															189.19,
															87.268
														],
														[
															157,
															124
														],
														[
															115.722,
															193.799
														],
														[
															90,
															279
														],
														[
															85.017,
															312.579
														],
														[
															83,
															347
														],
														[
															83.698,
															382.002
														],
														[
															87,
															415
														],
														[
															96.641,
															461.523
														],
														[
															110,
															503
														],
														[
															124.586,
															535.24
														],
														[
															141,
															564
														],
														[
															143.189,
															567.977
														],
														[
															145,
															571
														],
														[
															145.995,
															572.495
														],
														[
															147,
															574
														],
														[
															149.714,
															577.506
														],
														[
															152,
															581
														],
														[
															157.924,
															589.188
														],
														[
															164,
															597
														],
														[
															181.3,
															615.802
														],
														[
															199,
															633
														],
														[
															201,
															634
														],
														[
															210,
															643
														],
														[
															213,
															644
														],
														[
															215,
															647
														],
														[
															217,
															647
														],
														[
															218,
															649
														],
														[
															236,
															660
														],
														[
															237,
															662
														],
														[
															244,
															665
														],
														[
															265,
															676
														],
														[
															295,
															688
														],
														[
															318,
															693
														],
														[
															330,
															698
														],
														[
															335,
															707
														],
														[
															359,
															710
														],
														[
															378,
															709
														],
														[
															415,
															705
														],
														[
															474,
															683
														],
														[
															489,
															676
														],
														[
															490,
															674
														],
														[
															492,
															674
														],
														[
															493,
															672
														],
														[
															500,
															669
														],
														[
															505,
															664
														],
														[
															507,
															664
														],
														[
															508,
															662
														],
														[
															510,
															662
														],
														[
															511,
															660
														],
														[
															523,
															651
														],
														[
															581,
															587
														],
														[
															589,
															573
														],
														[
															591,
															572
														],
														[
															591,
															570
														],
														[
															593,
															569
														],
														[
															594,
															565
														],
														[
															597,
															562
														],
														[
															610,
															534
														],
														[
															618,
															517
														],
														[
															647,
															367
														],
														[
															625,
															227
														],
														[
															597,
															164
														],
														[
															595,
															159
														],
														[
															593,
															158
														],
														[
															590,
															151
														],
														[
															585,
															143
														],
														[
															583,
															142
														],
														[
															583,
															140
														],
														[
															581,
															139
														],
														[
															581,
															137
														],
														[
															579,
															136
														],
														[
															579,
															134
														],
														[
															577,
															133
														],
														[
															564,
															115
														],
														[
															550,
															99
														],
														[
															529,
															79
														],
														[
															348,
															15
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 43,
											"s": [
												{
													"i": [
														[
															-0.112,
															0.008
														],
														[
															0.336,
															0.004
														],
														[
															0.328,
															0.008
														],
														[
															10.656,
															-2.277
														],
														[
															9.579,
															-3.159
														],
														[
															9.26,
															-4.27
														],
														[
															7.308,
															-4.736
														],
														[
															3.302,
															-2.085
														],
														[
															3.155,
															-2.305
														],
														[
															3.52,
															-2.849
														],
														[
															3.234,
															-2.91
														],
														[
															3.401,
															-2.914
														],
														[
															2.987,
															-3.28
														],
														[
															0.073,
															-0.527
														],
														[
															0.337,
															-0.482
														],
														[
															1.465,
															-1.069
														],
														[
															1.082,
															-1.212
														],
														[
															0.074,
															-0.526
														],
														[
															0.337,
															-0.483
														],
														[
															0.596,
															-0.293
														],
														[
															0.327,
															-0.41
														],
														[
															4.295,
															-5.741
														],
														[
															2.588,
															-5.741
														],
														[
															0.451,
															-0.163
														],
														[
															0.124,
															-0.185
														],
														[
															-0.067,
															-0.379
														],
														[
															0.115,
															-0.255
														],
														[
															0.451,
															-0.16
														],
														[
															0.122,
															-0.194
														],
														[
															0.476,
															-1.051
														],
														[
															0.52,
															-0.879
														],
														[
															1.638,
															-2.944
														],
														[
															1.614,
															-3.125
														],
														[
															0.96,
															-2.153
														],
														[
															1.038,
															-2.214
														],
														[
															2.076,
															-4.307
														],
														[
															1.733,
															-4.584
														],
														[
															0.602,
															-2.388
														],
														[
															0.781,
															-2.306
														],
														[
															3.649,
															-19.281
														],
														[
															0,
															-19.919
														],
														[
															-0.586,
															-11.786
														],
														[
															-1.656,
															-10.885
														],
														[
															-11.082,
															-26.607
														],
														[
															-15.659,
															-21.613
														],
														[
															-12.351,
															-12.315
														],
														[
															-15.859,
															-10.918
														],
														[
															-7.549,
															-4.279
														],
														[
															-7.788,
															-3.056
														],
														[
															-2.796,
															-1.202
														],
														[
															-3.076,
															-1.116
														],
														[
															-4.794,
															-1.526
														],
														[
															-5.058,
															-1.167
														],
														[
															-3.972,
															-0.635
														],
														[
															-1.795,
															-1.695
														],
														[
															-0.95,
															-2.047
														],
														[
															-1.06,
															-0.734
														],
														[
															-1.047,
															-0.325
														],
														[
															-1.192,
															-0.269
														],
														[
															-3.328,
															-0.083
														],
														[
															-3.326,
															-0.133
														],
														[
															-9.622,
															0.913
														],
														[
															-8.579,
															1.705
														],
														[
															-18.565,
															9.053
														],
														[
															-15.165,
															12.103
														],
														[
															-5.991,
															5.322
														],
														[
															-4.738,
															5.685
														],
														[
															-1.418,
															1.313
														],
														[
															-1.084,
															1.255
														],
														[
															-0.62,
															1.041
														],
														[
															-0.716,
															0.905
														],
														[
															-2.772,
															3.762
														],
														[
															-5.178,
															8.444
														],
														[
															-0.723,
															0.755
														],
														[
															-0.699,
															1.176
														],
														[
															-3.955,
															7.866
														],
														[
															-2.624,
															6.883
														],
														[
															-0.858,
															2.188
														],
														[
															-0.584,
															1.516
														],
														[
															0,
															49.948
														],
														[
															33.728,
															54.023
														],
														[
															9.167,
															10.986
														],
														[
															9.915,
															9.077
														],
														[
															1.768,
															1.463
														],
														[
															0.844,
															0.723
														],
														[
															1.212,
															1.035
														],
														[
															1.765,
															1.418
														],
														[
															6.175,
															4.152
														],
														[
															20.707,
															7.765
														],
														[
															5.058,
															1.565
														],
														[
															33.121,
															-1.946
														]
													],
													"o": [
														[
															-0.327,
															0.023
														],
														[
															-0.336,
															-0.004
														],
														[
															-10.798,
															-0.268
														],
														[
															-10.656,
															2.277
														],
														[
															-9.653,
															3.183
														],
														[
															-9.26,
															4.27
														],
														[
															-3.637,
															2.356
														],
														[
															-3.302,
															2.085
														],
														[
															-3.686,
															2.692
														],
														[
															-3.52,
															2.849
														],
														[
															-3.407,
															3.066
														],
														[
															-3.401,
															2.914
														],
														[
															-0.373,
															0.409
														],
														[
															-0.073,
															0.527
														],
														[
															-1.057,
															1.513
														],
														[
															-1.465,
															1.069
														],
														[
															-0.368,
															0.413
														],
														[
															-0.074,
															0.526
														],
														[
															-0.291,
															0.416
														],
														[
															-0.595,
															0.294
														],
														[
															-4.231,
															5.294
														],
														[
															-4.295,
															5.741
														],
														[
															-0.073,
															0.162
														],
														[
															-0.451,
															0.163
														],
														[
															-0.154,
															0.23
														],
														[
															0.067,
															0.379
														],
														[
															-0.076,
															0.168
														],
														[
															-0.451,
															0.16
														],
														[
															-0.578,
															0.916
														],
														[
															-0.476,
															1.051
														],
														[
															-1.834,
															3.1
														],
														[
															-1.638,
															2.944
														],
														[
															-1.123,
															2.174
														],
														[
															-0.96,
															2.153
														],
														[
															-1.963,
															4.188
														],
														[
															-2.076,
															4.307
														],
														[
															-0.809,
															2.141
														],
														[
															-0.602,
															2.388
														],
														[
															-5.405,
															15.958
														],
														[
															-3.649,
															19.281
														],
														[
															0,
															12.969
														],
														[
															0.586,
															11.786
														],
														[
															5.013,
															32.957
														],
														[
															11.082,
															26.607
														],
														[
															10.738,
															14.822
														],
														[
															12.351,
															12.315
														],
														[
															7.014,
															4.829
														],
														[
															7.549,
															4.279
														],
														[
															2.741,
															1.075
														],
														[
															2.796,
															1.202
														],
														[
															4.765,
															1.73
														],
														[
															4.794,
															1.526
														],
														[
															3.319,
															0.766
														],
														[
															3.971,
															0.635
														],
														[
															1.142,
															1.077
														],
														[
															0.95,
															2.047
														],
														[
															0.621,
															0.43
														],
														[
															1.047,
															0.325
														],
														[
															2.362,
															0.533
														],
														[
															3.328,
															0.084
														],
														[
															8.932,
															0.358
														],
														[
															9.622,
															-0.913
														],
														[
															23.575,
															-4.685
														],
														[
															18.565,
															-9.053
														],
														[
															6.297,
															-5.025
														],
														[
															5.991,
															-5.322
														],
														[
															1.245,
															-1.494
														],
														[
															1.418,
															-1.313
														],
														[
															0.803,
															-0.93
														],
														[
															0.62,
															-1.041
														],
														[
															3.182,
															-4.025
														],
														[
															6.436,
															-8.734
														],
														[
															1.242,
															-2.026
														],
														[
															0.819,
															-0.854
														],
														[
															4.583,
															-7.713
														],
														[
															3.943,
															-7.843
														],
														[
															1.277,
															-3.35
														],
														[
															0.613,
															-1.563
														],
														[
															14.306,
															-37.167
														],
														[
															0,
															-89.605
														],
														[
															-8.196,
															-13.128
														],
														[
															-9.27,
															-11.109
														],
														[
															-1.803,
															-1.651
														],
														[
															-0.844,
															-0.699
														],
														[
															-1.263,
															-1.083
														],
														[
															-1.838,
															-1.569
														],
														[
															-6.132,
															-4.926
														],
														[
															-17.228,
															-11.585
														],
														[
															-4.961,
															-1.861
														],
														[
															-26.983,
															-8.349
														],
														[
															-0.628,
															0.037
														]
													],
													"v": [
														[
															347,
															16
														],
														[
															346,
															16.023
														],
														[
															345,
															16
														],
														[
															312.585,
															19.429
														],
														[
															282,
															28
														],
														[
															253.242,
															39.336
														],
														[
															228,
															53
														],
														[
															217.639,
															59.539
														],
														[
															208,
															66
														],
														[
															197.161,
															74.337
														],
														[
															187,
															83
														],
														[
															176.684,
															91.839
														],
														[
															167,
															101
														],
														[
															166.473,
															102.445
														],
														[
															166,
															104
														],
														[
															162.018,
															107.726
														],
														[
															158,
															111
														],
														[
															157.476,
															112.448
														],
														[
															157,
															114
														],
														[
															155.527,
															115.005
														],
														[
															154,
															116
														],
														[
															140.767,
															132.665
														],
														[
															130,
															150
														],
														[
															129.038,
															150.483
														],
														[
															128,
															151
														],
														[
															127.971,
															151.981
														],
														[
															128,
															153
														],
														[
															127.035,
															153.481
														],
														[
															126,
															154
														],
														[
															124.457,
															157.028
														],
														[
															123,
															160
														],
														[
															117.835,
															168.981
														],
														[
															113,
															178
														],
														[
															109.937,
															184.47
														],
														[
															107,
															191
														],
														[
															100.828,
															203.703
														],
														[
															95,
															217
														],
														[
															92.979,
															223.876
														],
														[
															91,
															231
														],
														[
															76.946,
															284.529
														],
														[
															71,
															344
														],
														[
															71.758,
															381.062
														],
														[
															75,
															415
														],
														[
															99.516,
															504.008
														],
														[
															140,
															576
														],
														[
															174.16,
															616.428
														],
														[
															216,
															651
														],
														[
															237.919,
															664.83
														],
														[
															261,
															676
														],
														[
															269.249,
															679.469
														],
														[
															278,
															683
														],
														[
															292.281,
															687.922
														],
														[
															307,
															692
														],
														[
															318.643,
															693.804
														],
														[
															328,
															697
														],
														[
															331.062,
															702.258
														],
														[
															334,
															707
														],
														[
															336.572,
															708.121
														],
														[
															340,
															709
														],
														[
															348.777,
															709.8
														],
														[
															359,
															710
														],
														[
															387.264,
															709.047
														],
														[
															415,
															705
														],
														[
															477.807,
															684.064
														],
														[
															528,
															652
														],
														[
															546.669,
															636.495
														],
														[
															563,
															620
														],
														[
															567.12,
															615.821
														],
														[
															571,
															612
														],
														[
															573.066,
															608.981
														],
														[
															575,
															606
														],
														[
															584,
															595
														],
														[
															603,
															567
														],
														[
															606,
															562
														],
														[
															607,
															560
														],
														[
															620,
															537
														],
														[
															631,
															512
														],
														[
															634,
															504
														],
														[
															635,
															500
														],
														[
															659,
															368
														],
														[
															602,
															156
														],
														[
															576,
															119
														],
														[
															546,
															87
														],
														[
															540,
															83
														],
														[
															538,
															80
														],
														[
															534,
															78
														],
														[
															529,
															73
														],
														[
															511,
															60
														],
														[
															456,
															32
														],
														[
															441,
															26
														],
														[
															348,
															15
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 44,
											"s": [
												{
													"i": [
														[
															-0.115,
															0.007
														],
														[
															5.922,
															-0.608
														],
														[
															6.101,
															-1.169
														],
														[
															9.603,
															-3.019
														],
														[
															8.488,
															-3.799
														],
														[
															4.337,
															-2.175
														],
														[
															3.973,
															-2.206
														],
														[
															13.651,
															-11.396
														],
														[
															11.607,
															-13.541
														],
														[
															1.283,
															-1.866
														],
														[
															1.363,
															-1.784
														],
														[
															1.289,
															-1.699
														],
														[
															0.774,
															-0.808
														],
														[
															0.784,
															-1.196
														],
														[
															0.76,
															-1.06
														],
														[
															1.377,
															-1.81
														],
														[
															1.044,
															-1.736
														],
														[
															0.42,
															-1.2
														],
														[
															0.686,
															-1.147
														],
														[
															0.392,
															-0.327
														],
														[
															0.251,
															-0.388
														],
														[
															1.85,
															-3.332
														],
														[
															1.064,
															-1.907
														],
														[
															1.068,
															-2.19
														],
														[
															0.89,
															-58.279
														],
														[
															-20.281,
															-45.211
														],
														[
															-3.158,
															-6.151
														],
														[
															-2.284,
															-3.985
														],
														[
															-1.075,
															-1.705
														],
														[
															-0.235,
															-0.52
														],
														[
															-0.247,
															-0.37
														],
														[
															-0.23,
															-0.511
														],
														[
															-0.244,
															-0.385
														],
														[
															-1.148,
															-1.852
														],
														[
															-2.448,
															-3.316
														],
														[
															-1.472,
															-1.939
														],
														[
															-0.499,
															-0.73
														],
														[
															-2.056,
															-2.538
														],
														[
															-9.702,
															-8.953
														],
														[
															-1.685,
															-1.444
														],
														[
															-7.332,
															-5.27
														],
														[
															-2.531,
															-1.781
														],
														[
															-0.5,
															-0.225
														],
														[
															-0.37,
															-0.247
														],
														[
															-0.511,
															-0.23
														],
														[
															-0.376,
															-0.246
														],
														[
															-1.86,
															-1.166
														],
														[
															-26.168,
															-7.507
														],
														[
															-4.263,
															-0.949
														],
														[
															-3.896,
															-3.677
														],
														[
															-1.613,
															-1.755
														],
														[
															-2.815,
															-0.779
														],
														[
															-1.24,
															-0.339
														],
														[
															-11.574,
															0.65
														],
														[
															-6.679,
															0.722
														],
														[
															-5.984,
															1.018
														],
														[
															-31.733,
															23.92
														],
														[
															-12.856,
															14.118
														],
														[
															-1.534,
															1.799
														],
														[
															-0.73,
															0.851
														],
														[
															-1.064,
															1.286
														],
														[
															-1.885,
															4.182
														],
														[
															-0.249,
															0.346
														],
														[
															-1.183,
															1.734
														],
														[
															-0.723,
															1.046
														],
														[
															-1.306,
															1.927
														],
														[
															-0.703,
															1.243
														],
														[
															-0.597,
															0.953
														],
														[
															-6.261,
															13.313
														],
														[
															-1.177,
															2.741
														],
														[
															-1.002,
															2.44
														],
														[
															-0.869,
															2.311
														],
														[
															-0.375,
															0.984
														],
														[
															-0.515,
															1.436
														],
														[
															-1.554,
															5.145
														],
														[
															-1.81,
															8.356
														],
														[
															0,
															29.913
														],
														[
															4.383,
															24.128
														],
														[
															8.52,
															21.848
														],
														[
															1.512,
															3.527
														],
														[
															1.774,
															3.772
														],
														[
															2.382,
															4.471
														],
														[
															2.612,
															4.429
														],
														[
															0.994,
															1.037
														],
														[
															1.105,
															1.694
														],
														[
															2.942,
															4.123
														],
														[
															1.073,
															2.38
														],
														[
															0.248,
															0.358
														],
														[
															4.367,
															5.095
														],
														[
															37.821,
															18.703
														],
														[
															55.896,
															-2.971
														]
													],
													"o": [
														[
															-6.211,
															0.4
														],
														[
															-5.922,
															0.608
														],
														[
															-11.097,
															2.126
														],
														[
															-9.603,
															3.019
														],
														[
															-4.68,
															2.094
														],
														[
															-4.337,
															2.175
														],
														[
															-17.79,
															9.875
														],
														[
															-13.651,
															11.396
														],
														[
															-1.504,
															1.754
														],
														[
															-1.283,
															1.866
														],
														[
															-1.068,
															1.397
														],
														[
															-1.289,
															1.699
														],
														[
															-1.106,
															1.154
														],
														[
															-0.784,
															1.196
														],
														[
															-1.448,
															2.022
														],
														[
															-1.377,
															1.81
														],
														[
															-0.632,
															1.051
														],
														[
															-0.42,
															1.2
														],
														[
															-0.181,
															0.303
														],
														[
															-0.392,
															0.327
														],
														[
															-2.209,
															3.41
														],
														[
															-1.026,
															1.848
														],
														[
															-1.148,
															2.057
														],
														[
															-20.338,
															41.691
														],
														[
															-1.053,
															68.948
														],
														[
															3.306,
															7.37
														],
														[
															2.291,
															4.462
														],
														[
															1.018,
															1.777
														],
														[
															0.301,
															0.478
														],
														[
															0.146,
															0.324
														],
														[
															0.307,
															0.46
														],
														[
															0.15,
															0.333
														],
														[
															1.159,
															1.825
														],
														[
															2.566,
															4.139
														],
														[
															1.395,
															1.89
														],
														[
															0.611,
															0.806
														],
														[
															2.084,
															3.049
														],
														[
															8.652,
															10.681
														],
														[
															1.618,
															1.493
														],
														[
															7.601,
															6.514
														],
														[
															2.839,
															2.04
														],
														[
															0.442,
															0.311
														],
														[
															0.324,
															0.146
														],
														[
															0.46,
															0.307
														],
														[
															0.328,
															0.148
														],
														[
															1.687,
															1.106
														],
														[
															21.525,
															13.493
														],
														[
															4.857,
															1.393
														],
														[
															7.079,
															1.577
														],
														[
															1.224,
															1.155
														],
														[
															2.676,
															2.91
														],
														[
															1.239,
															0.343
														],
														[
															10.715,
															2.927
														],
														[
															6.814,
															-0.383
														],
														[
															6.153,
															-0.665
														],
														[
															48.84,
															-8.309
														],
														[
															16.46,
															-12.408
														],
														[
															1.505,
															-1.652
														],
														[
															0.719,
															-0.844
														],
														[
															1.039,
															-1.213
														],
														[
															3.462,
															-4.182
														],
														[
															0.139,
															-0.309
														],
														[
															1.696,
															-2.36
														],
														[
															0.89,
															-1.305
														],
														[
															1.286,
															-1.862
														],
														[
															0.812,
															-1.197
														],
														[
															0.595,
															-1.053
														],
														[
															8.05,
															-12.857
														],
														[
															1.197,
															-2.544
														],
														[
															1.034,
															-2.408
														],
														[
															0.935,
															-2.277
														],
														[
															0.259,
															-0.688
														],
														[
															0.57,
															-1.496
														],
														[
															1.805,
															-5.033
														],
														[
															2.905,
															-9.619
														],
														[
															5.47,
															-25.252
														],
														[
															0,
															-28.504
														],
														[
															-4.794,
															-26.389
														],
														[
															-1.597,
															-4.095
														],
														[
															-1.62,
															-3.78
														],
														[
															-2.245,
															-4.774
														],
														[
															-2.477,
															-4.648
														],
														[
															-1.499,
															-2.541
														],
														[
															-1.656,
															-1.729
														],
														[
															-2.745,
															-4.21
														],
														[
															-1.845,
															-2.585
														],
														[
															-0.143,
															-0.317
														],
														[
															-4.177,
															-6.027
														],
														[
															-24.885,
															-29.03
														],
														[
															-37.924,
															-18.754
														],
														[
															-0.629,
															0.033
														]
													],
													"v": [
														[
															347,
															16
														],
														[
															328.918,
															17.424
														],
														[
															311,
															20
														],
														[
															280.043,
															27.746
														],
														[
															253,
															38
														],
														[
															239.469,
															44.417
														],
														[
															227,
															51
														],
														[
															180.363,
															82.751
														],
														[
															143,
															120
														],
														[
															138.895,
															125.477
														],
														[
															135,
															131
														],
														[
															131.28,
															135.942
														],
														[
															128,
															140
														],
														[
															125.24,
															143.57
														],
														[
															123,
															147
														],
														[
															118.697,
															152.715
														],
														[
															115,
															158
														],
														[
															113.541,
															161.428
														],
														[
															112,
															165
														],
														[
															111.052,
															165.936
														],
														[
															110,
															167
														],
														[
															105,
															177
														],
														[
															101,
															182
														],
														[
															98,
															189
														],
														[
															60,
															344
														],
														[
															93,
															511
														],
														[
															103,
															530
														],
														[
															109,
															543
														],
														[
															113,
															548
														],
														[
															113,
															550
														],
														[
															115,
															551
														],
														[
															115,
															553
														],
														[
															117,
															554
														],
														[
															120,
															560
														],
														[
															128,
															572
														],
														[
															133,
															577
														],
														[
															134,
															580
														],
														[
															141,
															588
														],
														[
															168,
															618
														],
														[
															173,
															622
														],
														[
															197,
															641
														],
														[
															205,
															648
														],
														[
															207,
															648
														],
														[
															208,
															650
														],
														[
															210,
															650
														],
														[
															211,
															652
														],
														[
															217,
															655
														],
														[
															290,
															688
														],
														[
															305,
															692
														],
														[
															327,
															697
														],
														[
															330,
															702
														],
														[
															335,
															708
														],
														[
															339,
															708
														],
														[
															376,
															709
														],
														[
															396,
															708
														],
														[
															414,
															705
														],
														[
															532,
															654
														],
														[
															577,
															614
														],
														[
															581,
															608
														],
														[
															584,
															606
														],
														[
															586,
															602
														],
														[
															596,
															589
														],
														[
															598,
															588
														],
														[
															602,
															582
														],
														[
															604,
															578
														],
														[
															609,
															573
														],
														[
															610,
															569
														],
														[
															613,
															566
														],
														[
															635,
															525
														],
														[
															638,
															517
														],
														[
															642,
															510
														],
														[
															644,
															502
														],
														[
															646,
															499
														],
														[
															647,
															494
														],
														[
															653,
															479
														],
														[
															660,
															450
														],
														[
															670,
															369
														],
														[
															664,
															291
														],
														[
															643,
															217
														],
														[
															638,
															206
														],
														[
															633,
															195
														],
														[
															626,
															181
														],
														[
															618,
															168
														],
														[
															614,
															160
														],
														[
															610,
															155
														],
														[
															602,
															142
														],
														[
															597,
															135
														],
														[
															595,
															134
														],
														[
															583,
															118
														],
														[
															488,
															44
														],
														[
															348,
															15
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 45,
											"s": [
												{
													"i": [
														[
															-0.115,
															0.007
														],
														[
															5.926,
															-0.628
														],
														[
															5.981,
															-1.081
														],
														[
															7.726,
															-2.021
														],
														[
															6.667,
															-2.392
														],
														[
															7.006,
															-3.074
														],
														[
															5.953,
															-3.186
														],
														[
															0.804,
															-0.752
														],
														[
															0.847,
															-0.494
														],
														[
															1.181,
															-0.416
														],
														[
															1.119,
															-0.661
														],
														[
															2,
															-1.37
														],
														[
															1.92,
															-1.291
														],
														[
															2.885,
															-2.016
														],
														[
															2.486,
															-1.935
														],
														[
															0.803,
															-0.896
														],
														[
															0.868,
															-0.697
														],
														[
															0.557,
															-0.097
														],
														[
															0.37,
															-0.288
														],
														[
															0.289,
															-0.582
														],
														[
															0.421,
															-0.345
														],
														[
															1.043,
															-0.615
														],
														[
															0.938,
															-0.811
														],
														[
															1.611,
															-1.688
														],
														[
															1.738,
															-1.674
														],
														[
															1.716,
															-1.459
														],
														[
															1.53,
															-1.618
														],
														[
															1.438,
															-1.856
														],
														[
															1.644,
															-1.879
														],
														[
															1.51,
															-1.616
														],
														[
															1.421,
															-1.776
														],
														[
															6.345,
															-9.793
														],
														[
															5.252,
															-10.622
														],
														[
															1.809,
															-3.262
														],
														[
															1.157,
															-2.701
														],
														[
															0.236,
															-1.363
														],
														[
															0.52,
															-1.296
														],
														[
															0.541,
															-0.986
														],
														[
															0.423,
															-1.024
														],
														[
															3.707,
															-33.497
														],
														[
															-5.6,
															-33.922
														],
														[
															-9.457,
															-23.211
														],
														[
															-12.531,
															-19.056
														],
														[
															-0.095,
															-0.521
														],
														[
															-0.329,
															-0.471
														],
														[
															-0.602,
															-0.29
														],
														[
															-0.301,
															-0.426
														],
														[
															0.067,
															-0.382
														],
														[
															-0.112,
															-0.25
														],
														[
															-0.451,
															-0.163
														],
														[
															-0.124,
															-0.185
														],
														[
															0.067,
															-0.379
														],
														[
															-0.115,
															-0.255
														],
														[
															-0.452,
															-0.17
														],
														[
															-0.124,
															-0.168
														],
														[
															-2.842,
															-3.644
														],
														[
															-13.569,
															-12.473
														],
														[
															-7.27,
															-5.443
														],
														[
															-0.961,
															-0.672
														],
														[
															-0.852,
															-0.602
														],
														[
															-0.499,
															-0.225
														],
														[
															-0.37,
															-0.247
														],
														[
															-0.511,
															-0.23
														],
														[
															-0.353,
															-0.249
														],
														[
															-5.487,
															-3.252
														],
														[
															-18.07,
															-6.485
														],
														[
															-12.454,
															-2.62
														],
														[
															-4.783,
															-2.038
														],
														[
															-0.719,
															-0.443
														],
														[
															-0.278,
															-0.316
														],
														[
															-1.436,
															-1.336
														],
														[
															-4.432,
															-1.264
														],
														[
															-8.323,
															0.49
														],
														[
															-0.801,
															0.04
														],
														[
															-24.957,
															9.155
														],
														[
															-5.152,
															2.248
														],
														[
															-27.469,
															27.469
														],
														[
															-11.332,
															17.328
														],
														[
															-0.834,
															79.669
														],
														[
															51.64,
															58.329
														],
														[
															1.582,
															1.811
														],
														[
															3.693,
															3.165
														],
														[
															1.22,
															1.111
														],
														[
															3.821,
															3.049
														],
														[
															1.22,
															0.977
														],
														[
															8.9,
															5.458
														],
														[
															0.635,
															0.608
														],
														[
															1.689,
															0.986
														],
														[
															12.842,
															5.325
														],
														[
															23.908,
															3.562
														],
														[
															21.366,
															-1.136
														]
													],
													"o": [
														[
															-6.316,
															0.407
														],
														[
															-5.926,
															0.628
														],
														[
															-8.429,
															1.523
														],
														[
															-7.726,
															2.021
														],
														[
															-7.022,
															2.519
														],
														[
															-7.006,
															3.074
														],
														[
															-0.935,
															0.5
														],
														[
															-0.805,
															0.752
														],
														[
															-1.157,
															0.674
														],
														[
															-1.181,
															0.416
														],
														[
															-2.078,
															1.227
														],
														[
															-2.001,
															1.37
														],
														[
															-2.974,
															1.999
														],
														[
															-2.885,
															2.016
														],
														[
															-0.921,
															0.718
														],
														[
															-0.803,
															0.896
														],
														[
															-0.402,
															0.322
														],
														[
															-0.557,
															0.097
														],
														[
															-0.421,
															0.328
														],
														[
															-0.289,
															0.582
														],
														[
															-0.892,
															0.731
														],
														[
															-1.043,
															0.615
														],
														[
															-1.819,
															1.573
														],
														[
															-1.611,
															1.688
														],
														[
															-1.606,
															1.547
														],
														[
															-1.716,
															1.459
														],
														[
															-1.605,
															1.698
														],
														[
															-1.438,
															1.856
														],
														[
															-1.538,
															1.758
														],
														[
															-1.51,
															1.616
														],
														[
															-7.368,
															9.207
														],
														[
															-6.345,
															9.793
														],
														[
															-1.608,
															3.251
														],
														[
															-1.809,
															3.262
														],
														[
															-0.536,
															1.252
														],
														[
															-0.236,
															1.363
														],
														[
															-0.413,
															1.031
														],
														[
															-0.541,
															0.986
														],
														[
															-10.772,
															26.092
														],
														[
															-3.707,
															33.497
														],
														[
															4.639,
															28.101
														],
														[
															9.457,
															23.211
														],
														[
															0.292,
															0.445
														],
														[
															0.094,
															0.521
														],
														[
															0.291,
															0.416
														],
														[
															0.602,
															0.289
														],
														[
															0.156,
															0.221
														],
														[
															-0.067,
															0.382
														],
														[
															0.073,
															0.162
														],
														[
															0.451,
															0.163
														],
														[
															0.154,
															0.23
														],
														[
															-0.067,
															0.379
														],
														[
															0.068,
															0.15
														],
														[
															0.452,
															0.171
														],
														[
															2.807,
															3.78
														],
														[
															11.202,
															14.363
														],
														[
															6.673,
															6.134
														],
														[
															0.875,
															0.655
														],
														[
															0.832,
															0.581
														],
														[
															0.441,
															0.311
														],
														[
															0.324,
															0.146
														],
														[
															0.46,
															0.307
														],
														[
															0.313,
															0.141
														],
														[
															5.802,
															4.084
														],
														[
															16.003,
															9.484
														],
														[
															11.929,
															4.281
														],
														[
															5.367,
															1.129
														],
														[
															0.784,
															0.334
														],
														[
															0.277,
															0.17
														],
														[
															2.042,
															2.323
														],
														[
															2.274,
															2.115
														],
														[
															8.588,
															2.449
														],
														[
															1.003,
															-0.059
														],
														[
															34.39,
															-1.739
														],
														[
															5.57,
															-2.043
														],
														[
															41.523,
															-18.12
														],
														[
															13.919,
															-13.92
														],
														[
															33.346,
															-50.991
														],
														[
															1.166,
															-111.444
														],
														[
															-1.543,
															-1.743
														],
														[
															-3.975,
															-4.552
														],
														[
															-1.202,
															-1.03
														],
														[
															-4.433,
															-4.037
														],
														[
															-1.313,
															-1.048
														],
														[
															-8.76,
															-7.014
														],
														[
															-2.012,
															-1.234
														],
														[
															-1.682,
															-1.612
														],
														[
															-11.961,
															-6.98
														],
														[
															-20.504,
															-8.502
														],
														[
															-19.182,
															-2.858
														],
														[
															-0.629,
															0.033
														]
													],
													"v": [
														[
															346,
															16
														],
														[
															327.749,
															17.494
														],
														[
															310,
															20
														],
														[
															285.678,
															25.349
														],
														[
															264,
															32
														],
														[
															242.699,
															40.5
														],
														[
															223,
															50
														],
														[
															220.435,
															52.005
														],
														[
															218,
															54
														],
														[
															214.471,
															55.51
														],
														[
															211,
															57
														],
														[
															204.882,
															60.952
														],
														[
															199,
															65
														],
														[
															190.134,
															71.048
														],
														[
															182,
															77
														],
														[
															179.46,
															79.515
														],
														[
															177,
															82
														],
														[
															175.476,
															82.526
														],
														[
															174,
															83
														],
														[
															173,
															84.487
														],
														[
															172,
															86
														],
														[
															169.034,
															87.939
														],
														[
															166,
															90
														],
														[
															160.94,
															94.924
														],
														[
															156,
															100
														],
														[
															150.943,
															104.447
														],
														[
															146,
															109
														],
														[
															141.529,
															114.364
														],
														[
															137,
															120
														],
														[
															132.412,
															124.987
														],
														[
															128,
															130
														],
														[
															107.414,
															158.439
														],
														[
															90,
															189
														],
														[
															84.662,
															198.913
														],
														[
															80,
															208
														],
														[
															78.988,
															211.967
														],
														[
															78,
															216
														],
														[
															76.507,
															219.005
														],
														[
															75,
															222
														],
														[
															52.721,
															313.128
														],
														[
															55,
															416
														],
														[
															76.581,
															492.783
														],
														[
															110,
															556
														],
														[
															110.472,
															557.48
														],
														[
															111,
															559
														],
														[
															112.492,
															559.993
														],
														[
															114,
															561
														],
														[
															114.032,
															561.978
														],
														[
															114,
															563
														],
														[
															114.962,
															563.483
														],
														[
															116,
															564
														],
														[
															116.029,
															564.981
														],
														[
															116,
															566
														],
														[
															116.958,
															566.487
														],
														[
															118,
															567
														],
														[
															126,
															579
														],
														[
															164,
															619
														],
														[
															185,
															637
														],
														[
															188,
															638
														],
														[
															190,
															641
														],
														[
															192,
															641
														],
														[
															193,
															643
														],
														[
															195,
															643
														],
														[
															196,
															645
														],
														[
															214,
															656
														],
														[
															267,
															681
														],
														[
															305,
															692
														],
														[
															322,
															695
														],
														[
															325,
															695
														],
														[
															326,
															698
														],
														[
															332,
															706
														],
														[
															338,
															708
														],
														[
															374,
															709
														],
														[
															376,
															710
														],
														[
															465,
															692
														],
														[
															481,
															686
														],
														[
															582,
															615
														],
														[
															620,
															567
														],
														[
															680,
															369
														],
														[
															589,
															117
														],
														[
															584,
															112
														],
														[
															571,
															98
														],
														[
															567,
															96
														],
														[
															554,
															83
														],
														[
															550,
															81
														],
														[
															522,
															61
														],
														[
															517,
															58
														],
														[
															512,
															55
														],
														[
															476,
															37
														],
														[
															409,
															18
														],
														[
															347,
															15
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 46,
											"s": [
												{
													"i": [
														[
															-0.115,
															0.007
														],
														[
															6.053,
															-0.623
														],
														[
															6.299,
															-1.092
														],
														[
															24.447,
															-12.029
														],
														[
															18.716,
															-15.597
														],
														[
															1.598,
															-1.716
														],
														[
															1.786,
															-1.615
														],
														[
															1.898,
															-1.423
														],
														[
															1.644,
															-1.71
														],
														[
															1.463,
															-1.908
														],
														[
															1.632,
															-1.791
														],
														[
															1.515,
															-1.656
														],
														[
															1.37,
															-1.658
														],
														[
															5.043,
															-6.65
														],
														[
															3.812,
															-6.335
														],
														[
															0.706,
															-1.584
														],
														[
															0.469,
															-0.49
														],
														[
															0.06,
															-0.246
														],
														[
															0.35,
															-0.588
														],
														[
															1.932,
															-3.755
														],
														[
															1.999,
															-4.155
														],
														[
															1.253,
															-2.15
														],
														[
															0.962,
															-2.268
														],
														[
															3.163,
															-10.111
														],
														[
															2.614,
															-10.757
														],
														[
															0.639,
															-24.716
														],
														[
															-3.834,
															-22.418
														],
														[
															-12.788,
															-27.111
														],
														[
															-17.142,
															-21.19
														],
														[
															-13.815,
															-12.009
														],
														[
															-16.744,
															-10.132
														],
														[
															-16.542,
															-6.63
														],
														[
															-18.42,
															-3.758
														],
														[
															-2.933,
															-0.351
														],
														[
															-2.48,
															-1.029
														],
														[
															-0.544,
															0.093
														],
														[
															-0.406,
															-0.197
														],
														[
															-0.074,
															-0.622
														],
														[
															-0.303,
															-0.316
														],
														[
															-1.789,
															-1.965
														],
														[
															-3.647,
															-0.846
														],
														[
															-3.519,
															-0.065
														],
														[
															-3.424,
															-0.159
														],
														[
															-6.403,
															0.407
														],
														[
															-6.785,
															0.681
														],
														[
															-10.695,
															2.252
														],
														[
															-8.96,
															2.862
														],
														[
															-13.28,
															6.822
														],
														[
															-11.596,
															7.83
														],
														[
															-1.97,
															1.511
														],
														[
															-1.972,
															1.507
														],
														[
															-1.436,
															0.894
														],
														[
															-0.964,
															0.435
														],
														[
															-0.18,
															0.454
														],
														[
															-0.145,
															0.122
														],
														[
															-0.808,
															0.457
														],
														[
															-0.817,
															0.368
														],
														[
															-0.18,
															0.454
														],
														[
															-0.145,
															0.122
														],
														[
															-1.444,
															1.287
														],
														[
															-1.496,
															1.39
														],
														[
															-4.167,
															3.931
														],
														[
															-1.803,
															4
														],
														[
															-0.454,
															0.18
														],
														[
															-0.122,
															0.145
														],
														[
															-0.878,
															1.04
														],
														[
															-0.659,
															0.861
														],
														[
															-1.458,
															1.863
														],
														[
															-0.787,
															1.746
														],
														[
															-0.451,
															0.166
														],
														[
															-0.124,
															0.179
														],
														[
															-2.25,
															3.211
														],
														[
															-0.968,
															1.011
														],
														[
															-0.815,
															0.85
														],
														[
															-1.55,
															2.479
														],
														[
															-0.235,
															0.522
														],
														[
															-0.238,
															0.411
														],
														[
															-0.696,
															1.203
														],
														[
															-5.371,
															12.533
														],
														[
															-1.488,
															4.5
														],
														[
															-3.757,
															16.461
														],
														[
															3.732,
															40.575
														],
														[
															4.138,
															16.328
														],
														[
															3.716,
															9.751
														],
														[
															0.538,
															1.379
														],
														[
															0.989,
															2.464
														],
														[
															0.97,
															2.277
														],
														[
															1.104,
															2.425
														],
														[
															2.558,
															4.88
														],
														[
															69.667,
															32.762
														],
														[
															57.673,
															-3.065
														]
													],
													"o": [
														[
															-6.489,
															0.418
														],
														[
															-6.053,
															0.622
														],
														[
															-30.494,
															5.285
														],
														[
															-24.447,
															12.029
														],
														[
															-1.824,
															1.52
														],
														[
															-1.598,
															1.716
														],
														[
															-1.765,
															1.596
														],
														[
															-1.898,
															1.423
														],
														[
															-1.515,
															1.577
														],
														[
															-1.463,
															1.908
														],
														[
															-1.568,
															1.719
														],
														[
															-1.515,
															1.656
														],
														[
															-5.014,
															6.066
														],
														[
															-5.043,
															6.65
														],
														[
															-0.707,
															1.175
														],
														[
															-0.706,
															1.584
														],
														[
															-0.41,
															0.427
														],
														[
															-0.06,
															0.246
														],
														[
															-2.273,
															3.825
														],
														[
															-1.932,
															3.755
														],
														[
															-1.026,
															2.132
														],
														[
															-1.253,
															2.15
														],
														[
															-3.732,
															8.8
														],
														[
															-3.163,
															10.111
														],
														[
															-5.278,
															21.716
														],
														[
															-0.639,
															24.716
														],
														[
															5.707,
															33.367
														],
														[
															12.788,
															27.111
														],
														[
															11.998,
															14.831
														],
														[
															13.815,
															12.009
														],
														[
															14.412,
															8.721
														],
														[
															16.542,
															6.63
														],
														[
															2.787,
															0.568
														],
														[
															2.933,
															0.351
														],
														[
															0.418,
															0.173
														],
														[
															0.544,
															-0.093
														],
														[
															0.4,
															0.195
														],
														[
															0.074,
															0.622
														],
														[
															2.197,
															2.294
														],
														[
															1.789,
															1.965
														],
														[
															2.501,
															0.58
														],
														[
															3.519,
															0.065
														],
														[
															6.605,
															0.308
														],
														[
															6.403,
															-0.407
														],
														[
															11.26,
															-1.13
														],
														[
															10.695,
															-2.252
														],
														[
															15.283,
															-4.881
														],
														[
															13.28,
															-6.822
														],
														[
															2.148,
															-1.45
														],
														[
															1.97,
															-1.511
														],
														[
															1.294,
															-0.988
														],
														[
															1.436,
															-0.894
														],
														[
															0.135,
															-0.061
														],
														[
															0.18,
															-0.454
														],
														[
															0.95,
															-0.804
														],
														[
															0.808,
															-0.457
														],
														[
															0.135,
															-0.061
														],
														[
															0.18,
															-0.454
														],
														[
															1.729,
															-1.462
														],
														[
															1.444,
															-1.287
														],
														[
															3.528,
															-3.277
														],
														[
															4.167,
															-3.931
														],
														[
															0.061,
															-0.135
														],
														[
															0.454,
															-0.18
														],
														[
															0.828,
															-0.978
														],
														[
															0.878,
															-1.04
														],
														[
															1.38,
															-1.803
														],
														[
															1.458,
															-1.863
														],
														[
															0.072,
															-0.158
														],
														[
															0.451,
															-0.166
														],
														[
															2.692,
															-3.884
														],
														[
															1.588,
															-2.265
														],
														[
															0.803,
															-0.838
														],
														[
															2.421,
															-2.527
														],
														[
															0.3,
															-0.48
														],
														[
															0.157,
															-0.348
														],
														[
															0.803,
															-1.388
														],
														[
															7.211,
															-12.459
														],
														[
															2.248,
															-5.244
														],
														[
															5.181,
															-15.668
														],
														[
															8.042,
															-35.236
														],
														[
															-1.85,
															-20.113
														],
														[
															-3.139,
															-12.386
														],
														[
															-0.558,
															-1.465
														],
														[
															-0.964,
															-2.471
														],
														[
															-1.01,
															-2.517
														],
														[
															-1.17,
															-2.745
														],
														[
															-2.474,
															-5.435
														],
														[
															-35.157,
															-67.068
														],
														[
															-39.463,
															-18.558
														],
														[
															-0.629,
															0.033
														]
													],
													"v": [
														[
															346,
															16
														],
														[
															327.357,
															17.495
														],
														[
															309,
															20
														],
														[
															226.667,
															46.766
														],
														[
															162,
															89
														],
														[
															156.971,
															93.929
														],
														[
															152,
															99
														],
														[
															146.409,
															103.415
														],
														[
															141,
															108
														],
														[
															136.588,
															113.34
														],
														[
															132,
															119
														],
														[
															127.352,
															124.046
														],
														[
															123,
															129
														],
														[
															107.599,
															148.298
														],
														[
															94,
															168
														],
														[
															91.822,
															172.514
														],
														[
															90,
															176
														],
														[
															89.455,
															176.879
														],
														[
															89,
															178
														],
														[
															82.795,
															189.252
														],
														[
															77,
															201
														],
														[
															73.452,
															207.398
														],
														[
															70,
															214
														],
														[
															59.662,
															242.532
														],
														[
															51,
															274
														],
														[
															42.166,
															344.974
														],
														[
															47,
															417
														],
														[
															75.424,
															507.633
														],
														[
															121,
															580
														],
														[
															159.44,
															620.024
														],
														[
															205,
															653
														],
														[
															251.494,
															676.222
														],
														[
															304,
															692
														],
														[
															312.73,
															693.155
														],
														[
															321,
															695
														],
														[
															322.509,
															694.982
														],
														[
															324,
															695
														],
														[
															324.573,
															696.409
														],
														[
															325,
															698
														],
														[
															330.412,
															704.587
														],
														[
															338,
															709
														],
														[
															347.308,
															709.815
														],
														[
															358,
															710
														],
														[
															377.365,
															709.741
														],
														[
															397,
															708
														],
														[
															430.225,
															702.799
														],
														[
															460,
															695
														],
														[
															502.765,
															677.212
														],
														[
															540,
															655
														],
														[
															546.132,
															650.542
														],
														[
															552,
															646
														],
														[
															556.247,
															643.085
														],
														[
															560,
															641
														],
														[
															560.493,
															640.046
														],
														[
															561,
															639
														],
														[
															563.6,
															637.173
														],
														[
															566,
															636
														],
														[
															566.493,
															635.046
														],
														[
															567,
															634
														],
														[
															571.674,
															629.946
														],
														[
															576,
															626
														],
														[
															588.294,
															615.042
														],
														[
															598,
															603
														],
														[
															598.954,
															602.507
														],
														[
															600,
															602
														],
														[
															602.627,
															598.912
														],
														[
															605,
															596
														],
														[
															609.445,
															590.458
														],
														[
															613,
															585
														],
														[
															613.961,
															584.516
														],
														[
															615,
															584
														],
														[
															622,
															574
														],
														[
															627,
															566
														],
														[
															629,
															563
														],
														[
															635,
															555
														],
														[
															635,
															553
														],
														[
															637,
															552
														],
														[
															639,
															548
														],
														[
															659,
															508
														],
														[
															665,
															493
														],
														[
															679,
															446
														],
														[
															687,
															328
														],
														[
															678,
															272
														],
														[
															666,
															235
														],
														[
															665,
															230
														],
														[
															661,
															223
														],
														[
															659,
															215
														],
														[
															655,
															208
														],
														[
															648,
															193
														],
														[
															493,
															43
														],
														[
															347,
															15
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 47,
											"s": [
												{
													"i": [
														[
															-0.119,
															0.007
														],
														[
															0.337,
															0
														],
														[
															0.325,
															0.018
														],
														[
															5.834,
															-0.841
														],
														[
															5.727,
															-0.974
														],
														[
															17.078,
															-6.134
														],
														[
															14.48,
															-8.026
														],
														[
															1.881,
															-1.06
														],
														[
															1.595,
															-0.719
														],
														[
															0.158,
															-0.451
														],
														[
															0.197,
															-0.121
														],
														[
															1.518,
															-0.655
														],
														[
															0.573,
															-0.549
														],
														[
															0.27,
															-0.067
														],
														[
															0.522,
															-0.348
														],
														[
															1.313,
															-1.272
														],
														[
															1.297,
															-0.947
														],
														[
															0.385,
															0.067
														],
														[
															0.246,
															-0.111
														],
														[
															0.168,
															-0.451
														],
														[
															0.173,
															-0.124
														],
														[
															4.149,
															-3.294
														],
														[
															3.841,
															-3.545
														],
														[
															3.268,
															-3.318
														],
														[
															3.428,
															-3.497
														],
														[
															8.882,
															-12.552
														],
														[
															7.43,
															-13.526
														],
														[
															0.46,
															-1.192
														],
														[
															0.558,
															-1.135
														],
														[
															1.224,
															-2.098
														],
														[
															1.013,
															-2.388
														],
														[
															5.237,
															-22.072
														],
														[
															0.36,
															-23.572
														],
														[
															-0.802,
															-12.234
														],
														[
															-2.002,
															-11.366
														],
														[
															-13.118,
															-26.929
														],
														[
															-17.548,
															-21.315
														],
														[
															-14.138,
															-11.992
														],
														[
															-17.19,
															-10.138
														],
														[
															-16.856,
															-6.633
														],
														[
															-18.828,
															-3.769
														],
														[
															-4.205,
															-0.663
														],
														[
															-1.765,
															-1.666
														],
														[
															-0.387,
															-0.89
														],
														[
															-0.836,
															-0.858
														],
														[
															-0.578,
															-0.618
														],
														[
															-0.693,
															-0.505
														],
														[
															0.079,
															-0.433
														],
														[
															-0.149,
															-0.149
														],
														[
															-0.421,
															0.042
														],
														[
															-0.188,
															-0.042
														],
														[
															-7.145,
															0.035
														],
														[
															-6.826,
															0.339
														],
														[
															-6.876,
															0.401
														],
														[
															-6.371,
															1.041
														],
														[
															-11.432,
															3.517
														],
														[
															-9.754,
															3.89
														],
														[
															-20.238,
															15.059
														],
														[
															-16.974,
															17.969
														],
														[
															-0.232,
															0.701
														],
														[
															-0.532,
															0.625
														],
														[
															-0.569,
															0.288
														],
														[
															-0.365,
															0.426
														],
														[
															-0.921,
															1.145
														],
														[
															-0.685,
															0.858
														],
														[
															-0.955,
															1.221
														],
														[
															-1.927,
															4.276
														],
														[
															-0.245,
															0.381
														],
														[
															-0.743,
															1.136
														],
														[
															-0.729,
															1.068
														],
														[
															-0.953,
															1.499
														],
														[
															-1.251,
															2.045
														],
														[
															-0.725,
															1.282
														],
														[
															-0.561,
															0.99
														],
														[
															-2.651,
															5.163
														],
														[
															-1.174,
															2.531
														],
														[
															-0.683,
															1.522
														],
														[
															-1.162,
															2.693
														],
														[
															-1.658,
															52.865
														],
														[
															7.949,
															28.286
														],
														[
															5.35,
															12.923
														],
														[
															5.017,
															9.224
														],
														[
															4.138,
															9.18
														],
														[
															0.245,
															0.381
														],
														[
															0.932,
															1.363
														],
														[
															1.08,
															2.397
														],
														[
															0.248,
															0.358
														],
														[
															2.506,
															3.191
														],
														[
															14.772,
															12.714
														],
														[
															31.002,
															14.136
														],
														[
															59.018,
															-2.789
														]
													],
													"o": [
														[
															-0.325,
															0.019
														],
														[
															-0.337,
															0
														],
														[
															-5.936,
															-0.341
														],
														[
															-5.834,
															0.841
														],
														[
															-20.209,
															3.438
														],
														[
															-17.078,
															6.134
														],
														[
															-1.881,
															1.043
														],
														[
															-1.881,
															1.06
														],
														[
															-0.169,
															0.076
														],
														[
															-0.158,
															0.451
														],
														[
															-1.353,
															0.831
														],
														[
															-1.518,
															0.655
														],
														[
															-0.399,
															0.382
														],
														[
															-0.27,
															0.067
														],
														[
															-1.45,
															0.966
														],
														[
															-1.313,
															1.272
														],
														[
															-0.214,
															0.156
														],
														[
															-0.385,
															-0.067
														],
														[
															-0.154,
															0.07
														],
														[
															-0.168,
															0.451
														],
														[
															-4.562,
															3.279
														],
														[
															-4.149,
															3.294
														],
														[
															-3.501,
															3.231
														],
														[
															-3.268,
															3.318
														],
														[
															-11.043,
															11.266
														],
														[
															-8.882,
															12.552
														],
														[
															-0.603,
															1.099
														],
														[
															-0.46,
															1.192
														],
														[
															-1.091,
															2.221
														],
														[
															-1.224,
															2.098
														],
														[
															-7.692,
															18.139
														],
														[
															-5.237,
															22.072
														],
														[
															-0.209,
															13.697
														],
														[
															0.802,
															12.234
														],
														[
															5.981,
															33.967
														],
														[
															13.118,
															26.929
														],
														[
															12.26,
															14.892
														],
														[
															14.138,
															11.992
														],
														[
															14.75,
															8.699
														],
														[
															16.856,
															6.633
														],
														[
															3.413,
															0.683
														],
														[
															4.206,
															0.663
														],
														[
															0.616,
															0.582
														],
														[
															0.387,
															0.89
														],
														[
															0.994,
															1.021
														],
														[
															0.578,
															0.618
														],
														[
															0.166,
															0.121
														],
														[
															-0.079,
															0.433
														],
														[
															0.127,
															0.127
														],
														[
															0.421,
															-0.042
														],
														[
															6.594,
															1.481
														],
														[
															7.145,
															-0.035
														],
														[
															7.126,
															-0.354
														],
														[
															6.876,
															-0.401
														],
														[
															12.517,
															-2.044
														],
														[
															11.432,
															-3.517
														],
														[
															27.072,
															-10.796
														],
														[
															20.239,
															-15.059
														],
														[
															0.539,
															-0.571
														],
														[
															0.232,
															-0.701
														],
														[
															0.359,
															-0.422
														],
														[
															0.569,
															-0.288
														],
														[
															0.955,
															-1.114
														],
														[
															0.677,
															-0.842
														],
														[
															1.042,
															-1.305
														],
														[
															3.426,
															-4.381
														],
														[
															0.149,
															-0.331
														],
														[
															0.823,
															-1.278
														],
														[
															0.725,
															-1.109
														],
														[
															0.864,
															-1.266
														],
														[
															1.303,
															-2.049
														],
														[
															0.784,
															-1.282
														],
														[
															0.6,
															-1.062
														],
														[
															2.696,
															-4.759
														],
														[
															1.803,
															-3.513
														],
														[
															0.627,
															-1.351
														],
														[
															1.105,
															-2.461
														],
														[
															16.848,
															-39.053
														],
														[
															1.22,
															-38.908
														],
														[
															-4.302,
															-15.307
														],
														[
															-4.456,
															-10.764
														],
														[
															-5.397,
															-9.924
														],
														[
															-0.149,
															-0.331
														],
														[
															-0.74,
															-1.15
														],
														[
															-1.959,
															-2.864
														],
														[
															-0.143,
															-0.317
														],
														[
															-2.654,
															-3.83
														],
														[
															-12.411,
															-15.806
														],
														[
															-24.327,
															-20.939
														],
														[
															-40.179,
															-18.32
														],
														[
															-0.63,
															0.03
														]
													],
													"v": [
														[
															346,
															16
														],
														[
															345,
															16.028
														],
														[
															344,
															16
														],
														[
															326.344,
															17.014
														],
														[
															309,
															20
														],
														[
															253.203,
															34.559
														],
														[
															206,
															56
														],
														[
															200.285,
															59.243
														],
														[
															195,
															62
														],
														[
															194.521,
															62.967
														],
														[
															194,
															64
														],
														[
															189.415,
															66.211
														],
														[
															186,
															68
														],
														[
															185.092,
															68.526
														],
														[
															184,
															69
														],
														[
															179.886,
															72.514
														],
														[
															176,
															76
														],
														[
															175.024,
															76.034
														],
														[
															174,
															76
														],
														[
															173.514,
															76.959
														],
														[
															173,
															78
														],
														[
															159.959,
															87.801
														],
														[
															148,
															98
														],
														[
															137.945,
															107.8
														],
														[
															128,
															118
														],
														[
															98.291,
															153.805
														],
														[
															74,
															193
														],
														[
															72.466,
															196.473
														],
														[
															71,
															200
														],
														[
															67.441,
															206.374
														],
														[
															64,
															213
														],
														[
															44.001,
															273.926
														],
														[
															35,
															343
														],
														[
															35.842,
															381.748
														],
														[
															40,
															417
														],
														[
															69.325,
															507.989
														],
														[
															116,
															580
														],
														[
															155.303,
															620.066
														],
														[
															202,
															653
														],
														[
															249.441,
															676.198
														],
														[
															303,
															692
														],
														[
															315.236,
															693.763
														],
														[
															325,
															697
														],
														[
															326.336,
															699.293
														],
														[
															328,
															702
														],
														[
															330.225,
															704.387
														],
														[
															332,
															706
														],
														[
															332.013,
															706.979
														],
														[
															332,
															708
														],
														[
															332.955,
															708.064
														],
														[
															334,
															708
														],
														[
															354.826,
															709.865
														],
														[
															376,
															709
														],
														[
															397.066,
															708.015
														],
														[
															417,
															706
														],
														[
															453.072,
															697.385
														],
														[
															485,
															686
														],
														[
															555.073,
															646.88
														],
														[
															610,
															597
														],
														[
															611.006,
															595.041
														],
														[
															612,
															593
														],
														[
															613.495,
															592.003
														],
														[
															615,
															591
														],
														[
															617,
															587
														],
														[
															620,
															585
														],
														[
															622,
															581
														],
														[
															632,
															567
														],
														[
															634,
															566
														],
														[
															636,
															562
														],
														[
															638,
															559
														],
														[
															640,
															555
														],
														[
															645,
															549
														],
														[
															646,
															545
														],
														[
															649,
															542
														],
														[
															656,
															527
														],
														[
															662,
															517
														],
														[
															663,
															512
														],
														[
															667,
															505
														],
														[
															696,
															369
														],
														[
															682,
															263
														],
														[
															668,
															222
														],
														[
															654,
															192
														],
														[
															637,
															163
														],
														[
															635,
															162
														],
														[
															633,
															158
														],
														[
															628,
															150
														],
														[
															626,
															149
														],
														[
															619,
															139
														],
														[
															576,
															94
														],
														[
															495,
															43
														],
														[
															347,
															15
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 48,
											"s": [
												{
													"i": [
														[
															-0.119,
															0.007
														],
														[
															0.337,
															0
														],
														[
															0.325,
															0.018
														],
														[
															6.049,
															-0.847
														],
														[
															5.765,
															-0.957
														],
														[
															30.428,
															-17.083
														],
														[
															21.974,
															-21.974
														],
														[
															1.431,
															-1.671
														],
														[
															0.925,
															-0.965
														],
														[
															0.106,
															-0.343
														],
														[
															0.29,
															-0.332
														],
														[
															1.76,
															-1.627
														],
														[
															1.45,
															-1.763
														],
														[
															0.638,
															-1.042
														],
														[
															0.717,
															-0.941
														],
														[
															1.562,
															-1.83
														],
														[
															1.24,
															-1.699
														],
														[
															-0.067,
															-0.385
														],
														[
															0.111,
															-0.246
														],
														[
															0.828,
															-0.689
														],
														[
															0.377,
															-0.549
														],
														[
															5.094,
															-9.382
														],
														[
															3.937,
															-9.186
														],
														[
															0.391,
															-0.489
														],
														[
															0.189,
															-0.469
														],
														[
															0.26,
															-1.404
														],
														[
															0.468,
															-1.166
														],
														[
															0.415,
															-0.535
														],
														[
															0.197,
															-0.501
														],
														[
															4.056,
															-19.19
														],
														[
															0.484,
															-20.211
														],
														[
															-4.076,
															-22.652
														],
														[
															-7.353,
															-18.996
														],
														[
															-10.086,
															-16.797
														],
														[
															-11.975,
															-13.968
														],
														[
															-3.01,
															-3.059
														],
														[
															-2.304,
															-2.665
														],
														[
															-2.229,
															-1.94
														],
														[
															-2.137,
															-1.985
														],
														[
															-2.03,
															-1.836
														],
														[
															-1.985,
															-0.895
														],
														[
															-0.748,
															-0.849
														],
														[
															-0.445,
															-0.351
														],
														[
															-1.851,
															-1.565
														],
														[
															-1.692,
															-1.236
														],
														[
															-0.385,
															0.067
														],
														[
															-0.246,
															-0.111
														],
														[
															-0.689,
															-0.827
														],
														[
															-0.549,
															-0.378
														],
														[
															-21.277,
															-9.278
														],
														[
															-24.171,
															-4.722
														],
														[
															-4.411,
															-0.643
														],
														[
															-1.775,
															-1.727
														],
														[
															-0.13,
															-0.615
														],
														[
															-0.215,
															-0.281
														],
														[
															-0.741,
															-0.661
														],
														[
															-0.414,
															-0.543
														],
														[
															-0.157,
															-0.66
														],
														[
															-0.204,
															-0.139
														],
														[
															-1.012,
															0.03
														],
														[
															-1.995,
															-0.473
														],
														[
															-6.619,
															0.016
														],
														[
															-6.667,
															0.322
														],
														[
															-12.676,
															1.939
														],
														[
															-5.947,
															1.307
														],
														[
															-21.142,
															10.369
														],
														[
															-1.33,
															0.752
														],
														[
															-1.198,
															0.616
														],
														[
															-2.963,
															2.838
														],
														[
															-1.087,
															0.7
														],
														[
															-0.805,
															0.492
														],
														[
															-1.282,
															0.725
														],
														[
															-1.212,
															0.779
														],
														[
															-8.267,
															6.58
														],
														[
															-3.943,
															3.38
														],
														[
															-1.089,
															0.966
														],
														[
															-8.542,
															10.005
														],
														[
															-3.914,
															8.684
														],
														[
															-0.245,
															0.381
														],
														[
															-0.763,
															1.139
														],
														[
															-2.573,
															3.97
														],
														[
															-1.344,
															2.293
														],
														[
															-6.123,
															14.766
														],
														[
															-1.912,
															5.461
														],
														[
															-1.665,
															5.504
														],
														[
															-2.571,
															13.223
														],
														[
															-0.799,
															5.99
														],
														[
															7.392,
															36.23
														],
														[
															22.254,
															33.417
														],
														[
															61.889,
															27.051
														],
														[
															59.617,
															-2.817
														]
													],
													"o": [
														[
															-0.325,
															0.019
														],
														[
															-0.337,
															0
														],
														[
															-6.038,
															-0.346
														],
														[
															-6.049,
															0.847
														],
														[
															-40.315,
															6.693
														],
														[
															-30.428,
															17.083
														],
														[
															-1.352,
															1.352
														],
														[
															-1.431,
															1.671
														],
														[
															-0.284,
															0.296
														],
														[
															-0.107,
															0.343
														],
														[
															-1.511,
															1.728
														],
														[
															-1.76,
															1.627
														],
														[
															-0.731,
															0.889
														],
														[
															-0.638,
															1.042
														],
														[
															-1.511,
															1.983
														],
														[
															-1.562,
															1.83
														],
														[
															-0.156,
															0.214
														],
														[
															0.067,
															0.385
														],
														[
															-0.312,
															0.694
														],
														[
															-0.828,
															0.689
														],
														[
															-5.688,
															8.284
														],
														[
															-5.094,
															9.382
														],
														[
															-0.247,
															0.576
														],
														[
															-0.391,
															0.489
														],
														[
															-0.49,
															1.218
														],
														[
															-0.26,
															1.404
														],
														[
															-0.144,
															0.358
														],
														[
															-0.415,
															0.535
														],
														[
															-6.29,
															16.029
														],
														[
															-4.056,
															19.19
														],
														[
															-0.657,
															27.394
														],
														[
															4.076,
															22.653
														],
														[
															7.681,
															19.842
														],
														[
															10.086,
															16.797
														],
														[
															2.656,
															3.099
														],
														[
															3.01,
															3.059
														],
														[
															1.948,
															2.254
														],
														[
															2.229,
															1.94
														],
														[
															1.894,
															1.76
														],
														[
															2.03,
															1.836
														],
														[
															0.562,
															0.254
														],
														[
															0.748,
															0.849
														],
														[
															1.904,
															1.505
														],
														[
															1.851,
															1.565
														],
														[
															0.214,
															0.157
														],
														[
															0.385,
															-0.067
														],
														[
															0.694,
															0.312
														],
														[
															0.689,
															0.827
														],
														[
															17.719,
															12.166
														],
														[
															21.277,
															9.278
														],
														[
															3.579,
															0.699
														],
														[
															4.411,
															0.643
														],
														[
															0.267,
															0.26
														],
														[
															0.13,
															0.615
														],
														[
															0.621,
															0.813
														],
														[
															0.741,
															0.661
														],
														[
															0.168,
															0.221
														],
														[
															0.157,
															0.66
														],
														[
															0.957,
															0.649
														],
														[
															1.012,
															-0.031
														],
														[
															5.856,
															1.387
														],
														[
															6.619,
															-0.016
														],
														[
															13.749,
															-0.665
														],
														[
															5.922,
															-0.906
														],
														[
															28.011,
															-6.155
														],
														[
															1.416,
															-0.694
														],
														[
															1.17,
															-0.661
														],
														[
															5.047,
															-2.595
														],
														[
															0.817,
															-0.783
														],
														[
															1.337,
															-0.861
														],
														[
															1.282,
															-0.784
														],
														[
															1.055,
															-0.596
														],
														[
															8.983,
															-5.768
														],
														[
															4.806,
															-3.825
														],
														[
															1.106,
															-0.948
														],
														[
															10.067,
															-8.93
														],
														[
															6.666,
															-7.807
														],
														[
															0.149,
															-0.331
														],
														[
															0.829,
															-1.287
														],
														[
															3.178,
															-4.743
														],
														[
															1.567,
															-2.417
														],
														[
															8.352,
															-14.242
														],
														[
															2.133,
															-5.144
														],
														[
															1.882,
															-5.374
														],
														[
															3.807,
															-12.583
														],
														[
															1.187,
															-6.104
														],
														[
															5.473,
															-41.047
														],
														[
															-9.817,
															-48.117
														],
														[
															-35.259,
															-52.947
														],
														[
															-41.554,
															-18.162
														],
														[
															-0.63,
															0.03
														]
													],
													"v": [
														[
															346,
															16
														],
														[
															345,
															16.028
														],
														[
															344,
															16
														],
														[
															325.795,
															17.022
														],
														[
															308,
															20
														],
														[
															202.244,
															57.039
														],
														[
															124,
															117
														],
														[
															119.68,
															121.79
														],
														[
															116,
															126
														],
														[
															115.505,
															126.973
														],
														[
															115,
															128
														],
														[
															109.954,
															132.973
														],
														[
															105,
															138
														],
														[
															102.989,
															140.961
														],
														[
															101,
															144
														],
														[
															96.297,
															149.713
														],
														[
															92,
															155
														],
														[
															91.966,
															155.976
														],
														[
															92,
															157
														],
														[
															90.049,
															159.108
														],
														[
															88,
															161
														],
														[
															71.687,
															187.823
														],
														[
															58,
															216
														],
														[
															56.956,
															217.581
														],
														[
															56,
															219
														],
														[
															54.983,
															223.039
														],
														[
															54,
															227
														],
														[
															53.04,
															228.393
														],
														[
															52,
															230
														],
														[
															36.145,
															283.364
														],
														[
															29,
															343
														],
														[
															34.493,
															417.798
														],
														[
															52,
															480
														],
														[
															78.78,
															534.905
														],
														[
															112,
															581
														],
														[
															120.764,
															590.325
														],
														[
															129,
															599
														],
														[
															135.359,
															605.201
														],
														[
															142,
															611
														],
														[
															147.932,
															616.649
														],
														[
															154,
															621
														],
														[
															156.088,
															622.927
														],
														[
															158,
															625
														],
														[
															163.659,
															629.702
														],
														[
															169,
															634
														],
														[
															169.976,
															634.034
														],
														[
															171,
															634
														],
														[
															173.108,
															635.951
														],
														[
															175,
															638
														],
														[
															233.661,
															670.583
														],
														[
															302,
															692
														],
														[
															314.853,
															693.729
														],
														[
															325,
															697
														],
														[
															325.539,
															698.484
														],
														[
															326,
															700
														],
														[
															328.155,
															702.203
														],
														[
															330,
															704
														],
														[
															330.473,
															705.562
														],
														[
															331,
															707
														],
														[
															333.721,
															707.633
														],
														[
															338,
															708
														],
														[
															356.892,
															709.782
														],
														[
															377,
															709
														],
														[
															418,
															706
														],
														[
															436,
															702
														],
														[
															510,
															676
														],
														[
															514,
															675
														],
														[
															517,
															672
														],
														[
															533,
															664
														],
														[
															535,
															663
														],
														[
															538,
															660
														],
														[
															542,
															659
														],
														[
															545,
															656
														],
														[
															571,
															638
														],
														[
															585,
															625
														],
														[
															589,
															623
														],
														[
															616,
															594
														],
														[
															636,
															568
														],
														[
															638,
															567
														],
														[
															640,
															563
														],
														[
															649,
															550
														],
														[
															653,
															543
														],
														[
															675,
															498
														],
														[
															681,
															482
														],
														[
															687,
															466
														],
														[
															695,
															429
														],
														[
															699,
															411
														],
														[
															694,
															289
														],
														[
															642,
															164
														],
														[
															497,
															43
														],
														[
															347,
															15
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 49,
											"s": [
												{
													"i": [
														[
															-0.119,
															0.007
														],
														[
															0.65,
															0.037
														],
														[
															11.534,
															-1.826
														],
														[
															37.784,
															-27.187
														],
														[
															9.583,
															-9.206
														],
														[
															9.588,
															-11.936
														],
														[
															4.422,
															-6.248
														],
														[
															5.65,
															-10.228
														],
														[
															3.897,
															-9.932
														],
														[
															0.385,
															-0.96
														],
														[
															0.891,
															-2.375
														],
														[
															0.831,
															-2.347
														],
														[
															1.713,
															-36.26
														],
														[
															-0.853,
															-12.433
														],
														[
															-2.126,
															-11.263
														],
														[
															-20.292,
															-33.153
														],
														[
															-11.132,
															-11.784
														],
														[
															-0.841,
															-0.945
														],
														[
															-3.183,
															-3.463
														],
														[
															-3.419,
															-3.139
														],
														[
															-8.655,
															-6.701
														],
														[
															-3.434,
															-3.289
														],
														[
															-0.85,
															-0.815
														],
														[
															-0.85,
															-0.815
														],
														[
															-0.85,
															-0.815
														],
														[
															-0.85,
															-0.815
														],
														[
															-1.124,
															-0.701
														],
														[
															-43.865,
															-8.486
														],
														[
															-5.105,
															-2.079
														],
														[
															-0.812,
															-0.395
														],
														[
															-0.605,
															-0.632
														],
														[
															-1.616,
															-1.716
														],
														[
															-2.822,
															-0.781
														],
														[
															-1.244,
															-0.329
														],
														[
															-12.6,
															0.626
														],
														[
															-13.004,
															1.898
														],
														[
															-11.277,
															3.105
														],
														[
															-27.197,
															17.294
														],
														[
															-6.354,
															4.395
														],
														[
															-1.888,
															1.618
														],
														[
															-1.131,
															0.935
														],
														[
															-0.844,
															0.723
														],
														[
															-1.184,
															1.018
														],
														[
															-1.897,
															1.679
														],
														[
															-1.065,
															0.933
														],
														[
															-4.555,
															4.555
														],
														[
															-1.829,
															2.133
														],
														[
															-1.003,
															1.144
														],
														[
															-1.287,
															2.855
														],
														[
															-0.249,
															0.325
														],
														[
															-1.474,
															1.719
														],
														[
															-1.045,
															1.279
														],
														[
															-1.239,
															2.75
														],
														[
															-0.245,
															0.381
														],
														[
															-0.836,
															1.188
														],
														[
															-1.102,
															2.445
														],
														[
															-0.238,
															0.411
														],
														[
															-0.834,
															1.341
														],
														[
															-7.289,
															52.792
														],
														[
															7.379,
															35.406
														],
														[
															11.635,
															23.529
														],
														[
															2.508,
															2.618
														],
														[
															0.75,
															0.783
														],
														[
															0.821,
															1.82
														],
														[
															0.238,
															0.411
														],
														[
															0.934,
															1.481
														],
														[
															1.172,
															2.6
														],
														[
															0.248,
															0.358
														],
														[
															6.08,
															7.395
														],
														[
															4.818,
															5.071
														],
														[
															2.956,
															2.262
														],
														[
															2.74,
															2.601
														],
														[
															4.468,
															2.014
														],
														[
															0.325,
															0.249
														],
														[
															1.796,
															1.433
														],
														[
															1.079,
															0.818
														],
														[
															4.37,
															2.984
														],
														[
															2.194,
															1.422
														],
														[
															2.111,
															1.331
														],
														[
															1.272,
															0.719
														],
														[
															1.157,
															0.681
														],
														[
															0.531,
															0.239
														],
														[
															0.411,
															0.238
														],
														[
															1.044,
															0.574
														],
														[
															4.824,
															2.335
														],
														[
															3.168,
															1.337
														],
														[
															1.642,
															0.708
														],
														[
															2.406,
															1.014
														],
														[
															9.575,
															2.66
														],
														[
															13.16,
															2.148
														],
														[
															26.058,
															-1.231
														]
													],
													"o": [
														[
															-0.65,
															0.038
														],
														[
															-12.37,
															-0.71
														],
														[
															-58.08,
															9.197
														],
														[
															-11.963,
															8.608
														],
														[
															-11.93,
															11.461
														],
														[
															-4.94,
															6.15
														],
														[
															-7.084,
															10.009
														],
														[
															-5.165,
															9.35
														],
														[
															-0.469,
															1.196
														],
														[
															-0.973,
															2.425
														],
														[
															-0.924,
															2.464
														],
														[
															-10.343,
															29.23
														],
														[
															-0.627,
															13.269
														],
														[
															0.86,
															12.536
														],
														[
															8.743,
															46.328
														],
														[
															9.36,
															15.292
														],
														[
															1.026,
															1.086
														],
														[
															3.087,
															3.468
														],
														[
															3.484,
															3.79
														],
														[
															8.912,
															8.181
														],
														[
															4.712,
															3.648
														],
														[
															0.838,
															0.803
														],
														[
															0.838,
															0.803
														],
														[
															0.838,
															0.803
														],
														[
															0.838,
															0.803
														],
														[
															0.833,
															0.798
														],
														[
															33.765,
															21.051
														],
														[
															5.942,
															1.149
														],
														[
															0.839,
															0.342
														],
														[
															0.8,
															0.39
														],
														[
															1.298,
															1.356
														],
														[
															2.752,
															2.921
														],
														[
															1.24,
															0.343
														],
														[
															10.918,
															2.883
														],
														[
															14.366,
															-0.714
														],
														[
															12.151,
															-1.773
														],
														[
															35.791,
															-9.856
														],
														[
															7.558,
															-4.806
														],
														[
															3.082,
															-2.132
														],
														[
															1.113,
															-0.954
														],
														[
															0.844,
															-0.698
														],
														[
															1.283,
															-1.1
														],
														[
															1.809,
															-1.555
														],
														[
															1.006,
															-0.89
														],
														[
															5.028,
															-4.406
														],
														[
															2.777,
															-2.777
														],
														[
															0.887,
															-1.035
														],
														[
															2.422,
															-2.761
														],
														[
															0.133,
															-0.295
														],
														[
															2.029,
															-2.651
														],
														[
															0.832,
															-0.97
														],
														[
															2.312,
															-2.829
														],
														[
															0.149,
															-0.331
														],
														[
															0.755,
															-1.173
														],
														[
															1.962,
															-2.788
														],
														[
															0.157,
															-0.348
														],
														[
															0.77,
															-1.331
														],
														[
															23.724,
															-38.154
														],
														[
															5.594,
															-40.515
														],
														[
															-6.038,
															-28.972
														],
														[
															-2.389,
															-4.832
														],
														[
															-1.684,
															-1.758
														],
														[
															-2.12,
															-2.213
														],
														[
															-0.157,
															-0.349
														],
														[
															-0.762,
															-1.317
														],
														[
															-2.053,
															-3.254
														],
														[
															-0.143,
															-0.317
														],
														[
															-5.859,
															-8.454
														],
														[
															-4.958,
															-6.03
														],
														[
															-3.19,
															-3.357
														],
														[
															-3.531,
															-2.703
														],
														[
															-4.107,
															-3.899
														],
														[
															-0.295,
															-0.133
														],
														[
															-2.783,
															-2.131
														],
														[
															-1.174,
															-0.937
														],
														[
															-4.424,
															-3.353
														],
														[
															-2.072,
															-1.415
														],
														[
															-2.239,
															-1.451
														],
														[
															-1.258,
															-0.793
														],
														[
															-1.168,
															-0.66
														],
														[
															-0.498,
															-0.293
														],
														[
															-0.348,
															-0.157
														],
														[
															-1.117,
															-0.646
														],
														[
															-4.697,
															-2.585
														],
														[
															-3.782,
															-1.831
														],
														[
															-1.454,
															-0.614
														],
														[
															-2.433,
															-1.048
														],
														[
															-10.073,
															-4.244
														],
														[
															-12.716,
															-3.532
														],
														[
															-21.821,
															-3.562
														],
														[
															-0.63,
															0.03
														]
													],
													"v": [
														[
															346,
															16
														],
														[
															344,
															16
														],
														[
															308,
															20
														],
														[
															165,
															79
														],
														[
															132,
															106
														],
														[
															98,
															143
														],
														[
															85,
															161
														],
														[
															66,
															192
														],
														[
															51,
															223
														],
														[
															49,
															226
														],
														[
															47,
															234
														],
														[
															44,
															241
														],
														[
															24,
															343
														],
														[
															25,
															382
														],
														[
															30,
															418
														],
														[
															75,
															535
														],
														[
															107,
															578
														],
														[
															109,
															582
														],
														[
															119,
															592
														],
														[
															129,
															602
														],
														[
															156,
															626
														],
														[
															172,
															637
														],
														[
															175,
															639
														],
														[
															178,
															641
														],
														[
															181,
															643
														],
														[
															184,
															645
														],
														[
															186,
															646
														],
														[
															302,
															692
														],
														[
															320,
															695
														],
														[
															323,
															695
														],
														[
															324,
															698
														],
														[
															328,
															702
														],
														[
															333,
															708
														],
														[
															337,
															708
														],
														[
															376,
															709
														],
														[
															418,
															706
														],
														[
															454,
															698
														],
														[
															547,
															657
														],
														[
															569,
															641
														],
														[
															575,
															636
														],
														[
															579,
															634
														],
														[
															581,
															631
														],
														[
															585,
															629
														],
														[
															590,
															623
														],
														[
															594,
															621
														],
														[
															608,
															607
														],
														[
															616,
															599
														],
														[
															618,
															595
														],
														[
															624,
															588
														],
														[
															626,
															587
														],
														[
															631,
															581
														],
														[
															633,
															577
														],
														[
															639,
															569
														],
														[
															641,
															568
														],
														[
															643,
															564
														],
														[
															648,
															556
														],
														[
															650,
															555
														],
														[
															652,
															551
														],
														[
															703,
															412
														],
														[
															699,
															288
														],
														[
															670,
															206
														],
														[
															662,
															190
														],
														[
															658,
															183
														],
														[
															654,
															176
														],
														[
															652,
															175
														],
														[
															650,
															171
														],
														[
															645,
															162
														],
														[
															643,
															161
														],
														[
															626,
															138
														],
														[
															610,
															121
														],
														[
															602,
															112
														],
														[
															593,
															104
														],
														[
															580,
															93
														],
														[
															579,
															91
														],
														[
															573,
															86
														],
														[
															569,
															84
														],
														[
															556,
															74
														],
														[
															549,
															70
														],
														[
															543,
															65
														],
														[
															539,
															64
														],
														[
															536,
															61
														],
														[
															534,
															61
														],
														[
															533,
															59
														],
														[
															529,
															57
														],
														[
															514,
															50
														],
														[
															503,
															44
														],
														[
															498,
															43
														],
														[
															491,
															39
														],
														[
															458,
															28
														],
														[
															421,
															20
														],
														[
															347,
															15
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 50,
											"s": [
												{
													"i": [
														[
															-0.119,
															0.007
														],
														[
															0.337,
															0
														],
														[
															0.325,
															0.018
														],
														[
															6.002,
															-0.851
														],
														[
															5.861,
															-0.949
														],
														[
															5.673,
															-1.154
														],
														[
															5.26,
															-1.405
														],
														[
															18.156,
															-8.734
														],
														[
															15.475,
															-11.211
														],
														[
															2.853,
															-2.188
														],
														[
															2.459,
															-1.981
														],
														[
															2.806,
															-2.265
														],
														[
															2.713,
															-2.473
														],
														[
															3.24,
															-3.495
														],
														[
															3.241,
															-3.554
														],
														[
															1.719,
															-1.603
														],
														[
															1.523,
															-1.831
														],
														[
															0.613,
															-1.026
														],
														[
															0.787,
															-0.981
														],
														[
															0.867,
															-1.148
														],
														[
															0.515,
															-1.142
														],
														[
															0.451,
															-0.168
														],
														[
															0.124,
															-0.173
														],
														[
															0.64,
															-0.988
														],
														[
															0.591,
															-0.867
														],
														[
															0.329,
															-0.755
														],
														[
															0.343,
															-0.483
														],
														[
															0.914,
															-0.763
														],
														[
															0.621,
															-0.931
														],
														[
															0.669,
															-1.569
														],
														[
															0.566,
															-0.591
														],
														[
															0.298,
															-0.539
														],
														[
															0.407,
															-0.425
														],
														[
															0.063,
															-0.257
														],
														[
															0.35,
															-0.558
														],
														[
															8.784,
															-27.548
														],
														[
															1.361,
															-32.305
														],
														[
															-4.45,
															-23.128
														],
														[
															-7.342,
															-18.441
														],
														[
															-3.153,
															-6.566
														],
														[
															-2.709,
															-6.009
														],
														[
															-0.451,
															-0.153
														],
														[
															-0.117,
															-0.21
														],
														[
															-0.447,
															-1.213
														],
														[
															-0.622,
															-1.093
														],
														[
															-5.877,
															-8.172
														],
														[
															-5.684,
															-6.865
														],
														[
															-0.577,
															-0.287
														],
														[
															-0.345,
															-0.433
														],
														[
															-0.258,
															-0.716
														],
														[
															-0.529,
															-0.59
														],
														[
															-3.167,
															-3.409
														],
														[
															-11.265,
															-9.138
														],
														[
															-60.642,
															-11.387
														],
														[
															-5.003,
															-2.054
														],
														[
															-0.715,
															-0.44
														],
														[
															-0.352,
															-0.36
														],
														[
															-1.491,
															-1.51
														],
														[
															-1.294,
															-0.861
														],
														[
															-3.899,
															-0.904
														],
														[
															-13.34,
															0.645
														],
														[
															-13.058,
															1.998
														],
														[
															-5.866,
															1.289
														],
														[
															-10.568,
															4.094
														],
														[
															-4.922,
															1.786
														],
														[
															-17.838,
															11.902
														],
														[
															-23.623,
															33.569
														],
														[
															-2.579,
															4.065
														],
														[
															-1.585,
															2.65
														],
														[
															-0.586,
															0.956
														],
														[
															-1.273,
															2.075
														],
														[
															-3.218,
															6.646
														],
														[
															7.598,
															71.883
														],
														[
															13.705,
															31.705
														],
														[
															1.146,
															2.489
														],
														[
															11.461,
															15.575
														],
														[
															1.083,
															2.404
														],
														[
															0.249,
															0.325
														],
														[
															2.804,
															3.429
														],
														[
															3.465,
															3.81
														],
														[
															8.04,
															7.214
														],
														[
															4.521,
															2.038
														],
														[
															0.325,
															0.249
														],
														[
															1.796,
															1.433
														],
														[
															1.219,
															0.902
														],
														[
															14.728,
															8.176
														],
														[
															10.757,
															3.903
														],
														[
															4.092,
															1.514
														],
														[
															12.162,
															3.051
														],
														[
															6,
															1.169
														],
														[
															29.673,
															-1.402
														]
													],
													"o": [
														[
															-0.325,
															0.019
														],
														[
															-0.337,
															0
														],
														[
															-6.133,
															-0.352
														],
														[
															-6.002,
															0.851
														],
														[
															-6.048,
															0.98
														],
														[
															-5.673,
															1.154
														],
														[
															-21.901,
															5.853
														],
														[
															-18.156,
															8.734
														],
														[
															-3.13,
															2.267
														],
														[
															-2.853,
															2.188
														],
														[
															-3.063,
															2.467
														],
														[
															-2.806,
															2.265
														],
														[
															-3.801,
															3.466
														],
														[
															-3.24,
															3.495
														],
														[
															-1.602,
															1.756
														],
														[
															-1.719,
															1.603
														],
														[
															-0.761,
															0.915
														],
														[
															-0.613,
															1.026
														],
														[
															-1.016,
															1.264
														],
														[
															-0.867,
															1.148
														],
														[
															-0.07,
															0.154
														],
														[
															-0.451,
															0.168
														],
														[
															-0.848,
															1.18
														],
														[
															-0.64,
															0.988
														],
														[
															-0.34,
															0.499
														],
														[
															-0.329,
															0.754
														],
														[
															-0.722,
															1.018
														],
														[
															-0.914,
															0.763
														],
														[
															-0.756,
															1.133
														],
														[
															-0.669,
															1.569
														],
														[
															-0.401,
															0.419
														],
														[
															-0.298,
															0.539
														],
														[
															-0.398,
															0.415
														],
														[
															-0.063,
															0.257
														],
														[
															-13.501,
															21.502
														],
														[
															-8.784,
															27.548
														],
														[
															-1.14,
															27.048
														],
														[
															4.45,
															23.128
														],
														[
															2.678,
															6.726
														],
														[
															3.153,
															6.566
														],
														[
															0.079,
															0.177
														],
														[
															0.451,
															0.153
														],
														[
															0.589,
															1.055
														],
														[
															0.447,
															1.213
														],
														[
															4.806,
															8.447
														],
														[
															5.877,
															8.172
														],
														[
															0.348,
															0.42
														],
														[
															0.577,
															0.287
														],
														[
															0.437,
															0.548
														],
														[
															0.259,
															0.716
														],
														[
															3.085,
															3.438
														],
														[
															10.129,
															10.902
														],
														[
															41.216,
															33.432
														],
														[
															5.875,
															1.103
														],
														[
															0.785,
															0.322
														],
														[
															0.333,
															0.205
														],
														[
															1.259,
															1.29
														],
														[
															1.847,
															1.871
														],
														[
															1.937,
															1.289
														],
														[
															11.822,
															2.74
														],
														[
															14.063,
															-0.68
														],
														[
															5.872,
															-0.898
														],
														[
															14.172,
															-3.114
														],
														[
															6.322,
															-2.449
														],
														[
															22.974,
															-8.335
														],
														[
															35.412,
															-23.628
														],
														[
															3.335,
															-4.739
														],
														[
															1.504,
															-2.371
														],
														[
															0.481,
															-0.803
														],
														[
															1.751,
															-2.855
														],
														[
															3.953,
															-6.446
														],
														[
															23.923,
															-49.415
														],
														[
															-4.369,
															-41.338
														],
														[
															-1.085,
															-2.509
														],
														[
															-9.433,
															-20.492
														],
														[
															-2.099,
															-2.852
														],
														[
															-0.133,
															-0.295
														],
														[
															-3.143,
															-4.106
														],
														[
															-3.255,
															-3.98
														],
														[
															-7.81,
															-8.588
														],
														[
															-4.235,
															-3.8
														],
														[
															-0.295,
															-0.133
														],
														[
															-2.784,
															-2.131
														],
														[
															-1.285,
															-1.025
														],
														[
															-13.267,
															-9.811
														],
														[
															-10.885,
															-6.042
														],
														[
															-4.366,
															-1.584
														],
														[
															-11.408,
															-4.22
														],
														[
															-6.109,
															-1.532
														],
														[
															-25.553,
															-4.98
														],
														[
															-0.63,
															0.03
														]
													],
													"v": [
														[
															346,
															16
														],
														[
															345,
															16.028
														],
														[
															344,
															16
														],
														[
															325.796,
															17.024
														],
														[
															308,
															20
														],
														[
															290.409,
															23.18
														],
														[
															274,
															27
														],
														[
															214.18,
															48.982
														],
														[
															164,
															79
														],
														[
															154.997,
															85.715
														],
														[
															147,
															92
														],
														[
															138.237,
															98.996
														],
														[
															130,
															106
														],
														[
															119.58,
															116.434
														],
														[
															110,
															127
														],
														[
															104.941,
															131.944
														],
														[
															100,
															137
														],
														[
															98.02,
															139.95
														],
														[
															96,
															143
														],
														[
															93.125,
															146.591
														],
														[
															91,
															150
														],
														[
															90.041,
															150.486
														],
														[
															89,
															151
														],
														[
															86.808,
															154.235
														],
														[
															85,
															157
														],
														[
															84.002,
															159.011
														],
														[
															83,
															161
														],
														[
															80.424,
															163.565
														],
														[
															78,
															166
														],
														[
															75.858,
															170.407
														],
														[
															74,
															174
														],
														[
															73.005,
															175.495
														],
														[
															72,
															177
														],
														[
															71.465,
															177.893
														],
														[
															71,
															179
														],
														[
															36.895,
															252.898
														],
														[
															21,
															343
														],
														[
															26.639,
															418.455
														],
														[
															45,
															481
														],
														[
															53.977,
															501.038
														],
														[
															63,
															520
														],
														[
															63.972,
															520.475
														],
														[
															65,
															521
														],
														[
															66.475,
															524.472
														],
														[
															68,
															528
														],
														[
															84.342,
															553.187
														],
														[
															102,
															576
														],
														[
															103.502,
															576.991
														],
														[
															105,
															578
														],
														[
															105.931,
															579.969
														],
														[
															107,
															582
														],
														[
															117,
															592
														],
														[
															149,
															621
														],
														[
															302,
															692
														],
														[
															320,
															695
														],
														[
															323,
															695
														],
														[
															324,
															698
														],
														[
															328,
															702
														],
														[
															331,
															707
														],
														[
															338,
															708
														],
														[
															377,
															709
														],
														[
															419,
															706
														],
														[
															437,
															702
														],
														[
															476,
															691
														],
														[
															493,
															685
														],
														[
															555,
															652
														],
														[
															646,
															564
														],
														[
															655,
															551
														],
														[
															659,
															543
														],
														[
															661,
															540
														],
														[
															665,
															533
														],
														[
															675,
															514
														],
														[
															708,
															327
														],
														[
															680,
															220
														],
														[
															676,
															213
														],
														[
															643,
															157
														],
														[
															638,
															149
														],
														[
															636,
															148
														],
														[
															628,
															138
														],
														[
															618,
															126
														],
														[
															595,
															104
														],
														[
															582,
															93
														],
														[
															581,
															91
														],
														[
															575,
															86
														],
														[
															571,
															84
														],
														[
															530,
															57
														],
														[
															496,
															41
														],
														[
															484,
															36
														],
														[
															449,
															26
														],
														[
															431,
															21
														],
														[
															347,
															15
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 51,
											"s": [
												{
													"i": [
														[
															-0.115,
															0.007
														],
														[
															6.291,
															-0.635
														],
														[
															6.224,
															-1.033
														],
														[
															23.672,
															-10.067
														],
														[
															19.606,
															-13.8
														],
														[
															2.838,
															-2.193
														],
														[
															2.486,
															-2.002
														],
														[
															2.8,
															-2.266
														],
														[
															2.722,
															-2.459
														],
														[
															2.769,
															-2.533
														],
														[
															2.159,
															-2.37
														],
														[
															0.603,
															-1.06
														],
														[
															0.781,
															-0.875
														],
														[
															1.735,
															-1.625
														],
														[
															1.519,
															-1.772
														],
														[
															2.178,
															-2.908
														],
														[
															1.934,
															-2.625
														],
														[
															2.657,
															-3.888
														],
														[
															1.758,
															-3.901
														],
														[
															0.451,
															-0.158
														],
														[
															0.121,
															-0.198
														],
														[
															-0.067,
															-0.373
														],
														[
															0.118,
															-0.263
														],
														[
															0.451,
															-0.155
														],
														[
															0.119,
															-0.206
														],
														[
															0.762,
															-1.906
														],
														[
															0.922,
															-1.594
														],
														[
															0.702,
															-0.962
														],
														[
															0.563,
															-1.062
														],
														[
															6.967,
															-31.01
														],
														[
															-2.649,
															-35.828
														],
														[
															-6.337,
															-21.141
														],
														[
															-8.808,
															-17.519
														],
														[
															-2.543,
															-4.338
														],
														[
															-2.566,
															-4.144
														],
														[
															-21.118,
															-19.82
														],
														[
															-25.847,
															-14.389
														],
														[
															-17.288,
															-6.382
														],
														[
															-19.178,
															-3.746
														],
														[
															-3.069,
															-0.353
														],
														[
															-2.762,
															-1.008
														],
														[
															-0.733,
															0.12
														],
														[
															-0.514,
															-0.277
														],
														[
															-0.072,
															-0.619
														],
														[
															-0.315,
															-0.308
														],
														[
															-1.188,
															-1.153
														],
														[
															-0.507,
															-0.664
														],
														[
															-0.157,
															-0.66
														],
														[
															-0.204,
															-0.139
														],
														[
															-1.012,
															0.03
														],
														[
															-1.995,
															-0.473
														],
														[
															-7.162,
															0.016
														],
														[
															-7.159,
															0.404
														],
														[
															-6.901,
															0.639
														],
														[
															-6.409,
															1.05
														],
														[
															-29.877,
															15.484
														],
														[
															-22.495,
															20.678
														],
														[
															-6.96,
															8.037
														],
														[
															-6.442,
															8.759
														],
														[
															-9.882,
															21.123
														],
														[
															-5.342,
															24.656
														],
														[
															-0.315,
															1.397
														],
														[
															-0.344,
															1.588
														],
														[
															-0.888,
															3.939
														],
														[
															-0.544,
															4.081
														],
														[
															-0.242,
															6.357
														],
														[
															-0.267,
															5.849
														],
														[
															0.023,
															0.368
														],
														[
															-0.021,
															0.952
														],
														[
															1.178,
															13.134
														],
														[
															2.593,
															12.414
														],
														[
															4.267,
															11.974
														],
														[
															4.277,
															10.397
														],
														[
															1.543,
															3.228
														],
														[
															1.512,
															2.888
														],
														[
															0.913,
															1.138
														],
														[
															0.723,
															1.257
														],
														[
															0.735,
															1.301
														],
														[
															0.575,
															0.977
														],
														[
															1.52,
															2.434
														],
														[
															2.946,
															6.535
														],
														[
															0.248,
															0.358
														],
														[
															0.75,
															0.956
														],
														[
															3.575,
															4.187
														],
														[
															0.663,
															0.866
														],
														[
															6.519,
															6.381
														],
														[
															4.016,
															3.569
														],
														[
															4.252,
															3.44
														],
														[
															25.809,
															10.617
														],
														[
															1.161,
															0.521
														],
														[
															63.481,
															-3.374
														]
													],
													"o": [
														[
															-6.612,
															0.425
														],
														[
															-6.291,
															0.635
														],
														[
															-29.704,
															4.931
														],
														[
															-23.672,
															10.067
														],
														[
															-3.162,
															2.225
														],
														[
															-2.838,
															2.193
														],
														[
															-3.077,
															2.478
														],
														[
															-2.8,
															2.266
														],
														[
															-2.766,
															2.499
														],
														[
															-2.769,
															2.533
														],
														[
															-0.806,
															0.886
														],
														[
															-0.603,
															1.06
														],
														[
															-1.541,
															1.727
														],
														[
															-1.735,
															1.625
														],
														[
															-2.353,
															2.745
														],
														[
															-2.178,
															2.908
														],
														[
															-2.612,
															3.545
														],
														[
															-2.657,
															3.888
														],
														[
															-0.077,
															0.17
														],
														[
															-0.451,
															0.158
														],
														[
															-0.149,
															0.244
														],
														[
															0.067,
															0.373
														],
														[
															-0.078,
															0.174
														],
														[
															-0.451,
															0.155
														],
														[
															-1.03,
															1.781
														],
														[
															-0.762,
															1.906
														],
														[
															-0.63,
															1.091
														],
														[
															-0.702,
															0.962
														],
														[
															-12.781,
															24.131
														],
														[
															-6.967,
															31.01
														],
														[
															1.843,
															24.917
														],
														[
															6.337,
															21.141
														],
														[
															2.264,
															4.503
														],
														[
															2.543,
															4.338
														],
														[
															15.682,
															25.332
														],
														[
															21.118,
															19.82
														],
														[
															15.671,
															8.724
														],
														[
															17.288,
															6.382
														],
														[
															2.963,
															0.579
														],
														[
															3.069,
															0.353
														],
														[
															0.553,
															0.202
														],
														[
															0.733,
															-0.12
														],
														[
															0.399,
															0.215
														],
														[
															0.072,
															0.619
														],
														[
															0.74,
															0.726
														],
														[
															1.188,
															1.153
														],
														[
															0.168,
															0.221
														],
														[
															0.157,
															0.66
														],
														[
															0.957,
															0.649
														],
														[
															1.012,
															-0.031
														],
														[
															6.194,
															1.467
														],
														[
															7.162,
															-0.016
														],
														[
															6.989,
															-0.395
														],
														[
															6.9,
															-0.639
														],
														[
															38.996,
															-6.386
														],
														[
															29.877,
															-15.484
														],
														[
															7.718,
															-7.094
														],
														[
															6.96,
															-8.037
														],
														[
															13.13,
															-17.851
														],
														[
															9.882,
															-21.123
														],
														[
															0.395,
															-1.822
														],
														[
															0.315,
															-1.397
														],
														[
															0.902,
															-4.163
														],
														[
															0.889,
															-3.939
														],
														[
															0.763,
															-5.724
														],
														[
															0.242,
															-6.357
														],
														[
															0.072,
															-1.575
														],
														[
															-0.023,
															-0.368
														],
														[
															0.303,
															-14.048
														],
														[
															-1.178,
															-13.134
														],
														[
															-2.654,
															-12.707
														],
														[
															-4.267,
															-11.974
														],
														[
															-1.316,
															-3.2
														],
														[
															-1.543,
															-3.228
														],
														[
															-0.623,
															-1.19
														],
														[
															-0.913,
															-1.138
														],
														[
															-0.762,
															-1.326
														],
														[
															-0.599,
															-1.059
														],
														[
															-1.498,
															-2.545
														],
														[
															-4.347,
															-6.963
														],
														[
															-0.143,
															-0.317
														],
														[
															-0.766,
															-1.106
														],
														[
															-3.252,
															-4.141
														],
														[
															-0.752,
															-0.88
														],
														[
															-5.899,
															-7.706
														],
														[
															-3.679,
															-3.601
														],
														[
															-4.089,
															-3.635
														],
														[
															-21.089,
															-17.06
														],
														[
															-1.252,
															-0.515
														],
														[
															-42.344,
															-19.002
														],
														[
															-0.629,
															0.033
														]
													],
													"v": [
														[
															345,
															16
														],
														[
															325.709,
															17.544
														],
														[
															307,
															20
														],
														[
															227.427,
															42.848
														],
														[
															163,
															79
														],
														[
															153.993,
															85.668
														],
														[
															146,
															92
														],
														[
															137.233,
															99.014
														],
														[
															129,
															106
														],
														[
															120.544,
															113.596
														],
														[
															113,
															121
														],
														[
															110.981,
															124.008
														],
														[
															109,
															127
														],
														[
															103.984,
															131.966
														],
														[
															99,
															137
														],
														[
															92.186,
															145.59
														],
														[
															86,
															154
														],
														[
															77.859,
															165.233
														],
														[
															71,
															177
														],
														[
															70.033,
															177.479
														],
														[
															69,
															178
														],
														[
															68.977,
															178.986
														],
														[
															69,
															180
														],
														[
															68.03,
															180.477
														],
														[
															67,
															181
														],
														[
															64.419,
															186.64
														],
														[
															62,
															192
														],
														[
															59.95,
															195.021
														],
														[
															58,
															198
														],
														[
															27.428,
															281.227
														],
														[
															20,
															382
														],
														[
															32.776,
															451.048
														],
														[
															56,
															509
														],
														[
															63.273,
															522.269
														],
														[
															71,
															535
														],
														[
															126.376,
															602.708
														],
														[
															197,
															654
														],
														[
															246.369,
															676.733
														],
														[
															301,
															692
														],
														[
															310.15,
															693.178
														],
														[
															319,
															695
														],
														[
															321.029,
															694.944
														],
														[
															323,
															695
														],
														[
															323.563,
															696.43
														],
														[
															324,
															698
														],
														[
															327.174,
															701.046
														],
														[
															330,
															704
														],
														[
															330.473,
															705.562
														],
														[
															331,
															707
														],
														[
															333.721,
															707.633
														],
														[
															338,
															708
														],
														[
															358.277,
															709.904
														],
														[
															380,
															709
														],
														[
															400.935,
															707.491
														],
														[
															421,
															705
														],
														[
															523.875,
															671.219
														],
														[
															602,
															616
														],
														[
															623.957,
															593.248
														],
														[
															644,
															568
														],
														[
															678.841,
															509.604
														],
														[
															702,
															441
														],
														[
															703.038,
															436.324
														],
														[
															704,
															432
														],
														[
															706.768,
															419.938
														],
														[
															709,
															408
														],
														[
															710.372,
															389.593
														],
														[
															711,
															371
														],
														[
															711.039,
															368.533
														],
														[
															711,
															367
														],
														[
															709.673,
															326.274
														],
														[
															704,
															288
														],
														[
															693.217,
															250.767
														],
														[
															680,
															217
														],
														[
															675.647,
															207.266
														],
														[
															671,
															198
														],
														[
															668.575,
															194.551
														],
														[
															666,
															191
														],
														[
															665,
															187
														],
														[
															662,
															184
														],
														[
															658,
															177
														],
														[
															644,
															155
														],
														[
															642,
															154
														],
														[
															640,
															150
														],
														[
															629,
															138
														],
														[
															627,
															135
														],
														[
															608,
															114
														],
														[
															596,
															104
														],
														[
															584,
															93
														],
														[
															512,
															48
														],
														[
															508,
															46
														],
														[
															346,
															15
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 52,
											"s": [
												{
													"i": [
														[
															-0.115,
															0.007
														],
														[
															6.287,
															-0.637
														],
														[
															6.389,
															-1.035
														],
														[
															15.814,
															-4.935
														],
														[
															13.048,
															-6.394
														],
														[
															8.559,
															-5.002
														],
														[
															7.609,
															-5.505
														],
														[
															11.175,
															-10.63
														],
														[
															9.828,
															-11.733
														],
														[
															1.555,
															-1.869
														],
														[
															1.208,
															-1.646
														],
														[
															0.861,
															-1.524
														],
														[
															0.669,
															-0.698
														],
														[
															0.298,
															-0.539
														],
														[
															0.407,
															-0.425
														],
														[
															0.298,
															-0.539
														],
														[
															0.407,
															-0.425
														],
														[
															0.298,
															-0.539
														],
														[
															0.407,
															-0.425
														],
														[
															0.298,
															-0.539
														],
														[
															0.407,
															-0.425
														],
														[
															0.44,
															-0.86
														],
														[
															0.467,
															-0.75
														],
														[
															1.361,
															-2.181
														],
														[
															1.118,
															-1.968
														],
														[
															0.269,
															-0.805
														],
														[
															0.343,
															-0.762
														],
														[
															0.451,
															-0.152
														],
														[
															0.115,
															-0.214
														],
														[
															0.924,
															-1.858
														],
														[
															0.464,
															-1
														],
														[
															0.086,
															-0.894
														],
														[
															0.344,
															-0.752
														],
														[
															1.268,
															-2.14
														],
														[
															0.911,
															-2.219
														],
														[
															0.252,
															-1.375
														],
														[
															0.497,
															-1.291
														],
														[
															0.418,
															-0.541
														],
														[
															0.193,
															-0.491
														],
														[
															3.676,
															-18.149
														],
														[
															0.382,
															-19.329
														],
														[
															-9.337,
															-31.5
														],
														[
															-15.47,
															-24.709
														],
														[
															-5.656,
															-7.365
														],
														[
															-5.631,
															-5.961
														],
														[
															-0.267,
															-0.746
														],
														[
															-0.421,
															-0.473
														],
														[
															-5.333,
															-4.853
														],
														[
															-4.966,
															-4.303
														],
														[
															-8.79,
															-6.567
														],
														[
															-9.276,
															-4.181
														],
														[
															-0.155,
															-0.451
														],
														[
															-0.206,
															-0.119
														],
														[
															-0.667,
															-0.069
														],
														[
															-0.668,
															-0.343
														],
														[
															-0.504,
															-0.619
														],
														[
															-0.469,
															-0.257
														],
														[
															-2.358,
															-0.9
														],
														[
															-2.331,
															-1.172
														],
														[
															-2.14,
															-1.223
														],
														[
															-2.24,
															-1.001
														],
														[
															-13.174,
															-4.045
														],
														[
															-13.45,
															-2.525
														],
														[
															-4.434,
															-0.67
														],
														[
															-1.693,
															-1.649
														],
														[
															-0.13,
															-0.615
														],
														[
															-0.215,
															-0.281
														],
														[
															-0.858,
															-0.312
														],
														[
															-1.201,
															-0.189
														],
														[
															-7.665,
															-0.282
														],
														[
															-6.64,
															0.358
														],
														[
															-52.589,
															48.534
														],
														[
															-19.043,
															53.816
														],
														[
															-0.445,
															42.497
														],
														[
															19.192,
															42.157
														],
														[
															31.322,
															31.322
														],
														[
															2.156,
															1.848
														],
														[
															1.144,
															1.003
														],
														[
															4.458,
															2.01
														],
														[
															0.358,
															0.248
														],
														[
															1.079,
															0.83
														],
														[
															0.847,
															0.676
														],
														[
															1.19,
															0.886
														],
														[
															4.788,
															2.158
														],
														[
															0.381,
															0.245
														],
														[
															1.127,
															0.698
														],
														[
															2.402,
															1.456
														],
														[
															4.628,
															2.838
														],
														[
															1.415,
															0.765
														],
														[
															34.123,
															6.585
														],
														[
															29.935,
															-1.591
														]
													],
													"o": [
														[
															-6.464,
															0.416
														],
														[
															-6.287,
															0.637
														],
														[
															-17.696,
															2.866
														],
														[
															-15.814,
															4.935
														],
														[
															-9.155,
															4.486
														],
														[
															-8.559,
															5.002
														],
														[
															-13.47,
															9.745
														],
														[
															-11.175,
															10.63
														],
														[
															-1.574,
															1.879
														],
														[
															-1.555,
															1.869
														],
														[
															-0.885,
															1.206
														],
														[
															-0.861,
															1.524
														],
														[
															-0.401,
															0.419
														],
														[
															-0.298,
															0.539
														],
														[
															-0.401,
															0.419
														],
														[
															-0.298,
															0.539
														],
														[
															-0.401,
															0.419
														],
														[
															-0.298,
															0.539
														],
														[
															-0.401,
															0.419
														],
														[
															-0.298,
															0.539
														],
														[
															-0.774,
															0.808
														],
														[
															-0.44,
															0.86
														],
														[
															-1.436,
															2.308
														],
														[
															-1.361,
															2.181
														],
														[
															-0.579,
															1.019
														],
														[
															-0.269,
															0.805
														],
														[
															-0.081,
															0.179
														],
														[
															-0.451,
															0.152
														],
														[
															-0.842,
															1.567
														],
														[
															-0.923,
															1.858
														],
														[
															-0.311,
															0.671
														],
														[
															-0.086,
															0.894
														],
														[
															-1.018,
															2.222
														],
														[
															-1.268,
															2.14
														],
														[
															-0.497,
															1.21
														],
														[
															-0.252,
															1.374
														],
														[
															-0.133,
															0.347
														],
														[
															-0.418,
															0.541
														],
														[
															-5.916,
															15.077
														],
														[
															-3.675,
															18.149
														],
														[
															-0.816,
															41.291
														],
														[
															9.337,
															31.5
														],
														[
															4.745,
															7.578
														],
														[
															5.656,
															7.365
														],
														[
															0.513,
															0.543
														],
														[
															0.267,
															0.746
														],
														[
															4.703,
															5.284
														],
														[
															5.333,
															4.853
														],
														[
															7.562,
															6.553
														],
														[
															8.79,
															6.567
														],
														[
															0.174,
															0.079
														],
														[
															0.155,
															0.451
														],
														[
															0.665,
															0.382
														],
														[
															0.667,
															0.069
														],
														[
															0.516,
															0.265
														],
														[
															0.504,
															0.619
														],
														[
															2.238,
															1.228
														],
														[
															2.358,
															0.9
														],
														[
															2.199,
															1.106
														],
														[
															2.14,
															1.223
														],
														[
															11.852,
															5.296
														],
														[
															13.174,
															4.045
														],
														[
															3.57,
															0.67
														],
														[
															4.434,
															0.67
														],
														[
															0.267,
															0.26
														],
														[
															0.13,
															0.615
														],
														[
															1.532,
															2.003
														],
														[
															1.135,
															0.413
														],
														[
															4.976,
															0.784
														],
														[
															7.024,
															0.258
														],
														[
															99.652,
															-5.371
														],
														[
															38.271,
															-35.32
														],
														[
															11.533,
															-32.593
														],
														[
															0.617,
															-58.998
														],
														[
															-20.29,
															-44.568
														],
														[
															-2.727,
															-2.727
														],
														[
															-1.035,
															-0.887
														],
														[
															-4.346,
															-3.811
														],
														[
															-0.316,
															-0.143
														],
														[
															-1.305,
															-0.905
														],
														[
															-0.842,
															-0.647
														],
														[
															-1.037,
															-0.827
														],
														[
															-4.754,
															-3.54
														],
														[
															-0.331,
															-0.149
														],
														[
															-1.257,
															-0.809
														],
														[
															-2.293,
															-1.42
														],
														[
															-5.751,
															-3.485
														],
														[
															-1.385,
															-0.849
														],
														[
															-26.583,
															-14.364
														],
														[
															-25.292,
															-4.881
														],
														[
															-0.629,
															0.033
														]
													],
													"v": [
														[
															345,
															16
														],
														[
															325.944,
															17.536
														],
														[
															307,
															20
														],
														[
															256.514,
															31.854
														],
														[
															213,
															49
														],
														[
															186.34,
															63.236
														],
														[
															162,
															79
														],
														[
															125.269,
															109.509
														],
														[
															94,
															143
														],
														[
															89.225,
															148.674
														],
														[
															85,
															154
														],
														[
															82.338,
															158.381
														],
														[
															80,
															162
														],
														[
															79.005,
															163.495
														],
														[
															78,
															165
														],
														[
															77.005,
															166.495
														],
														[
															76,
															168
														],
														[
															75.005,
															169.495
														],
														[
															74,
															171
														],
														[
															73.005,
															172.495
														],
														[
															72,
															174
														],
														[
															70.27,
															176.543
														],
														[
															69,
															179
														],
														[
															64.761,
															185.756
														],
														[
															61,
															192
														],
														[
															59.823,
															194.693
														],
														[
															59,
															197
														],
														[
															58.026,
															197.473
														],
														[
															57,
															198
														],
														[
															54.216,
															203.425
														],
														[
															52,
															208
														],
														[
															51.525,
															210.439
														],
														[
															51,
															213
														],
														[
															47.42,
															219.503
														],
														[
															44,
															226
														],
														[
															43,
															229.939
														],
														[
															42,
															234
														],
														[
															41.045,
															235.392
														],
														[
															40,
															237
														],
														[
															25.349,
															287.31
														],
														[
															19,
															344
														],
														[
															32.785,
															452.436
														],
														[
															71,
															536
														],
														[
															86.835,
															558.713
														],
														[
															104,
															579
														],
														[
															105.069,
															581.053
														],
														[
															106,
															583
														],
														[
															121.303,
															598.236
														],
														[
															137,
															612
														],
														[
															161.715,
															632.279
														],
														[
															189,
															649
														],
														[
															189.476,
															649.97
														],
														[
															190,
															651
														],
														[
															191.998,
															651.53
														],
														[
															194,
															652
														],
														[
															195.535,
															653.506
														],
														[
															197,
															655
														],
														[
															203.93,
															658.042
														],
														[
															211,
															661
														],
														[
															217.469,
															664.578
														],
														[
															224,
															668
														],
														[
															261.802,
															682.078
														],
														[
															302,
															692
														],
														[
															314.907,
															693.766
														],
														[
															325,
															697
														],
														[
															325.539,
															698.484
														],
														[
															326,
															700
														],
														[
															333,
															708
														],
														[
															337,
															708
														],
														[
															359,
															710
														],
														[
															380,
															709
														],
														[
															602,
															616
														],
														[
															691,
															481
														],
														[
															712,
															367
														],
														[
															681,
															219
														],
														[
															607,
															113
														],
														[
															599,
															105
														],
														[
															595,
															103
														],
														[
															582,
															92
														],
														[
															581,
															90
														],
														[
															577,
															88
														],
														[
															575,
															85
														],
														[
															571,
															83
														],
														[
															556,
															73
														],
														[
															555,
															71
														],
														[
															551,
															69
														],
														[
															544,
															65
														],
														[
															526,
															55
														],
														[
															522,
															53
														],
														[
															430,
															21
														],
														[
															346,
															15
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 53,
											"s": [
												{
													"i": [
														[
															-0.058,
															0.004
														],
														[
															3.198,
															-0.256
														],
														[
															3.144,
															-0.32
														],
														[
															3.124,
															-0.404
														],
														[
															3.137,
															-0.508
														],
														[
															13.261,
															-3.807
														],
														[
															11.926,
															-5.043
														],
														[
															10.702,
															-6.09
														],
														[
															9.59,
															-6.948
														],
														[
															4.007,
															-3.04
														],
														[
															3.779,
															-3.068
														],
														[
															3.508,
															-3.119
														],
														[
															3.194,
															-3.193
														],
														[
															1.629,
															-1.741
														],
														[
															1.58,
															-1.77
														],
														[
															1.536,
															-1.769
														],
														[
															1.496,
															-1.738
														],
														[
															2.061,
															-2.543
														],
														[
															1.949,
															-2.574
														],
														[
															1.818,
															-2.594
														],
														[
															11.053,
															-30.754
														],
														[
															1.552,
															-36.827
														],
														[
															-3.575,
															-20.631
														],
														[
															-5.706,
															-16.581
														],
														[
															-0.261,
															-1.338
														],
														[
															-0.502,
															-1.335
														],
														[
															-0.775,
															-1.172
														],
														[
															-0.471,
															-1.173
														],
														[
															-0.224,
															-1.334
														],
														[
															-0.567,
															-1.325
														],
														[
															-0.951,
															-1.801
														],
														[
															-0.573,
															-1.337
														],
														[
															-0.376,
															-0.475
														],
														[
															-0.236,
															-0.494
														],
														[
															-24.14,
															-25.242
														],
														[
															-31.404,
															-17.483
														],
														[
															-17.289,
															-6.394
														],
														[
															-19.197,
															-3.714
														],
														[
															-3.076,
															-0.357
														],
														[
															-2.774,
															-1.007
														],
														[
															-0.733,
															0.12
														],
														[
															-0.514,
															-0.277
														],
														[
															-0.072,
															-0.619
														],
														[
															-0.315,
															-0.308
														],
														[
															-1.188,
															-1.153
														],
														[
															-0.507,
															-0.664
														],
														[
															-0.157,
															-0.66
														],
														[
															-0.204,
															-0.139
														],
														[
															-1.012,
															0.03
														],
														[
															-1.995,
															-0.473
														],
														[
															-6.632,
															0.015
														],
														[
															-6.685,
															0.312
														],
														[
															-10.049,
															1.163
														],
														[
															-8.578,
															1.825
														],
														[
															-8.173,
															2.412
														],
														[
															-6.598,
															2.499
														],
														[
															-0.895,
															0.113
														],
														[
															-0.687,
															0.269
														],
														[
															-1.132,
															0.748
														],
														[
															-1.232,
															0.522
														],
														[
															-0.694,
															0.122
														],
														[
															-0.509,
															0.209
														],
														[
															-9.269,
															5.149
														],
														[
															-7.938,
															5.296
														],
														[
															-6.422,
															4.872
														],
														[
															-5.486,
															4.958
														],
														[
															-1.521,
															1.388
														],
														[
															-1.332,
															1.019
														],
														[
															-2.301,
															2.397
														],
														[
															-2.026,
															2.291
														],
														[
															-1.038,
															0.977
														],
														[
															-0.915,
															1.034
														],
														[
															-9.075,
															13.521
														],
														[
															-7.13,
															14.978
														],
														[
															-6.242,
															31.676
														],
														[
															3.963,
															36.097
														],
														[
															2.701,
															12.192
														],
														[
															3.655,
															11.184
														],
														[
															4.803,
															10.429
														],
														[
															5.122,
															9.068
														],
														[
															2.581,
															4.024
														],
														[
															2.226,
															3.562
														],
														[
															1.111,
															1.562
														],
														[
															1.25,
															1.664
														],
														[
															1.983,
															2.74
														],
														[
															2,
															2.282
														],
														[
															21.829,
															16.404
														],
														[
															27.565,
															11.709
														],
														[
															25.699,
															4.972
														],
														[
															29.736,
															-1.581
														],
														[
															0.186,
															-0.247
														]
													],
													"o": [
														[
															-3.286,
															0.212
														],
														[
															-3.198,
															0.256
														],
														[
															-3.144,
															0.32
														],
														[
															-3.124,
															0.404
														],
														[
															-14.707,
															2.382
														],
														[
															-13.261,
															3.807
														],
														[
															-11.926,
															5.043
														],
														[
															-10.702,
															6.09
														],
														[
															-4.191,
															3.037
														],
														[
															-4.007,
															3.04
														],
														[
															-3.779,
															3.068
														],
														[
															-3.508,
															3.119
														],
														[
															-1.683,
															1.683
														],
														[
															-1.629,
															1.741
														],
														[
															-1.58,
															1.77
														],
														[
															-1.536,
															1.769
														],
														[
															-2.153,
															2.501
														],
														[
															-2.061,
															2.543
														],
														[
															-1.949,
															2.574
														],
														[
															-16.234,
															23.16
														],
														[
															-11.053,
															30.753
														],
														[
															-1.007,
															23.896
														],
														[
															3.575,
															20.631
														],
														[
															0.453,
															1.314
														],
														[
															0.261,
															1.338
														],
														[
															0.428,
															1.137
														],
														[
															0.775,
															1.173
														],
														[
															0.538,
															1.341
														],
														[
															0.224,
															1.334
														],
														[
															0.625,
															1.459
														],
														[
															0.95,
															1.801
														],
														[
															0.26,
															0.605
														],
														[
															0.376,
															0.475
														],
														[
															16.034,
															33.549
														],
														[
															24.14,
															25.242
														],
														[
															15.648,
															8.712
														],
														[
															17.289,
															6.394
														],
														[
															2.924,
															0.565
														],
														[
															3.076,
															0.357
														],
														[
															0.553,
															0.201
														],
														[
															0.733,
															-0.12
														],
														[
															0.399,
															0.215
														],
														[
															0.072,
															0.619
														],
														[
															0.74,
															0.726
														],
														[
															1.188,
															1.153
														],
														[
															0.168,
															0.221
														],
														[
															0.157,
															0.66
														],
														[
															0.957,
															0.649
														],
														[
															1.012,
															-0.031
														],
														[
															5.786,
															1.37
														],
														[
															6.632,
															-0.015
														],
														[
															11.224,
															-0.523
														],
														[
															10.05,
															-1.163
														],
														[
															8.709,
															-1.853
														],
														[
															8.173,
															-2.412
														],
														[
															0.731,
															-0.277
														],
														[
															0.895,
															-0.113
														],
														[
															1.242,
															-0.487
														],
														[
															1.132,
															-0.748
														],
														[
															0.717,
															-0.303
														],
														[
															0.694,
															-0.122
														],
														[
															9.987,
															-4.109
														],
														[
															9.269,
															-5.149
														],
														[
															6.825,
															-4.554
														],
														[
															6.422,
															-4.872
														],
														[
															1.582,
															-1.43
														],
														[
															1.521,
															-1.388
														],
														[
															2.772,
															-2.121
														],
														[
															2.301,
															-2.397
														],
														[
															0.935,
															-1.057
														],
														[
															1.038,
															-0.977
														],
														[
															10.57,
															-11.939
														],
														[
															9.075,
															-13.521
														],
														[
															11.996,
															-25.197
														],
														[
															6.242,
															-31.676
														],
														[
															-1.543,
															-14.047
														],
														[
															-2.701,
															-12.192
														],
														[
															-3.666,
															-11.216
														],
														[
															-4.803,
															-10.429
														],
														[
															-2.452,
															-4.341
														],
														[
															-2.581,
															-4.024
														],
														[
															-1.305,
															-2.088
														],
														[
															-1.111,
															-1.562
														],
														[
															-2.07,
															-2.757
														],
														[
															-1.983,
															-2.74
														],
														[
															-18.12,
															-20.677
														],
														[
															-21.829,
															-16.404
														],
														[
															-20.466,
															-8.694
														],
														[
															-25.699,
															-4.972
														],
														[
															-0.315,
															0.017
														],
														[
															-0.186,
															0.247
														]
													],
													"v": [
														[
															345,
															16
														],
														[
															335.281,
															16.696
														],
														[
															325.776,
															17.555
														],
														[
															316.383,
															18.637
														],
														[
															307,
															20
														],
														[
															265.075,
															29.33
														],
														[
															227.324,
															42.651
														],
														[
															193.41,
															59.397
														],
														[
															163,
															79
														],
														[
															150.692,
															88.109
														],
														[
															139.003,
															97.265
														],
														[
															128.063,
															106.538
														],
														[
															118,
															116
														],
														[
															113.033,
															121.144
														],
														[
															108.22,
															126.417
														],
														[
															103.547,
															131.732
														],
														[
															99,
															137
														],
														[
															92.675,
															144.569
														],
														[
															86.656,
															152.246
														],
														[
															81,
															160
														],
														[
															38.988,
															241.25
														],
														[
															19,
															343
														],
														[
															23.466,
															409.987
														],
														[
															38,
															466
														],
														[
															38.963,
															469.984
														],
														[
															40,
															474
														],
														[
															41.968,
															477.473
														],
														[
															44,
															481
														],
														[
															44.978,
															485.012
														],
														[
															46,
															489
														],
														[
															48.539,
															494.091
														],
														[
															51,
															499
														],
														[
															52.018,
															500.584
														],
														[
															53,
															502
														],
														[
															113.472,
															590.05
														],
														[
															197,
															654
														],
														[
															246.338,
															676.748
														],
														[
															301,
															692
														],
														[
															310.113,
															693.169
														],
														[
															319,
															695
														],
														[
															321.03,
															694.943
														],
														[
															323,
															695
														],
														[
															323.563,
															696.43
														],
														[
															324,
															698
														],
														[
															327.174,
															701.046
														],
														[
															330,
															704
														],
														[
															330.473,
															705.562
														],
														[
															331,
															707
														],
														[
															333.721,
															707.633
														],
														[
															338,
															708
														],
														[
															356.826,
															709.762
														],
														[
															377,
															709
														],
														[
															408.984,
															706.477
														],
														[
															437,
															702
														],
														[
															462.583,
															695.485
														],
														[
															485,
															688
														],
														[
															487.533,
															687.494
														],
														[
															490,
															687
														],
														[
															493.507,
															685.026
														],
														[
															497,
															683
														],
														[
															499.156,
															682.429
														],
														[
															501,
															682
														],
														[
															530.037,
															667.891
														],
														[
															556,
															652
														],
														[
															576.005,
															637.803
														],
														[
															594,
															623
														],
														[
															598.688,
															618.692
														],
														[
															603,
															615
														],
														[
															610.559,
															608.127
														],
														[
															617,
															601
														],
														[
															620.015,
															597.982
														],
														[
															623,
															595
														],
														[
															652.58,
															556.779
														],
														[
															677,
															514
														],
														[
															705.469,
															428.175
														],
														[
															710,
															326
														],
														[
															703.584,
															286.853
														],
														[
															694,
															252
														],
														[
															681.092,
															219.389
														],
														[
															666,
															190
														],
														[
															658.331,
															177.416
														],
														[
															651,
															166
														],
														[
															647.458,
															160.682
														],
														[
															644,
															156
														],
														[
															637.947,
															147.644
														],
														[
															632,
															140
														],
														[
															572.584,
															84.274
														],
														[
															499,
															42
														],
														[
															429.452,
															20.794
														],
														[
															346,
															15
														],
														[
															345.221,
															15.515
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 54,
											"s": [
												{
													"i": [
														[
															-0.112,
															0.008
														],
														[
															6.246,
															-0.622
														],
														[
															6.438,
															-1.054
														],
														[
															17.722,
															-6.208
														],
														[
															14.678,
															-7.82
														],
														[
															2.161,
															-1.147
														],
														[
															2.077,
															-1.199
														],
														[
															4.393,
															-3.161
														],
														[
															4.032,
															-1.817
														],
														[
															0.163,
															-0.451
														],
														[
															0.185,
															-0.124
														],
														[
															0.379,
															0.067
														],
														[
															0.255,
															-0.115
														],
														[
															0.17,
															-0.452
														],
														[
															0.169,
															-0.124
														],
														[
															6.228,
															-5.453
														],
														[
															5.948,
															-5.948
														],
														[
															11.138,
															-15.611
														],
														[
															9.185,
															-19.294
														],
														[
															1.785,
															-4.892
														],
														[
															1.772,
															-5.051
														],
														[
															1.721,
															-5.138
														],
														[
															1.344,
															-5.393
														],
														[
															1.745,
															-12.076
														],
														[
															0.188,
															-12.336
														],
														[
															-4.204,
															-22.785
														],
														[
															-7.613,
															-18.874
														],
														[
															-4.276,
															-8.544
														],
														[
															-4.424,
															-7.216
														],
														[
															-0.52,
															-0.919
														],
														[
															-0.304,
															-0.317
														],
														[
															-0.298,
															-0.539
														],
														[
															-0.407,
															-0.425
														],
														[
															-0.298,
															-0.539
														],
														[
															-0.407,
															-0.425
														],
														[
															-0.298,
															-0.539
														],
														[
															-0.407,
															-0.425
														],
														[
															-0.071,
															-0.279
														],
														[
															-0.345,
															-0.497
														],
														[
															-1.392,
															-1.932
														],
														[
															-0.223,
															-0.495
														],
														[
															-0.245,
															-0.381
														],
														[
															-0.82,
															-1.088
														],
														[
															-2.981,
															-3.686
														],
														[
															-6.455,
															-6.594
														],
														[
															-12.425,
															-9.469
														],
														[
															-3.391,
															-2.503
														],
														[
															-5.098,
															-2.298
														],
														[
															-0.396,
															-0.242
														],
														[
															-2.334,
															-1.431
														],
														[
															-11.317,
															-4.441
														],
														[
															-0.971,
															-0.406
														],
														[
															-5.18,
															-1.823
														],
														[
															-2.682,
															-0.91
														],
														[
															-17.859,
															-3.345
														],
														[
															-2.008,
															-1.236
														],
														[
															-0.352,
															-0.36
														],
														[
															-7.564,
															-1.753
														],
														[
															-7.706,
															-0.326
														],
														[
															-19.081,
															3.09
														],
														[
															-35.838,
															22.949
														],
														[
															-10.509,
															8.044
														],
														[
															-1.943,
															1.487
														],
														[
															-3.591,
															2.749
														],
														[
															-2.522,
															3.338
														],
														[
															-0.984,
															1.095
														],
														[
															-8.501,
															12.08
														],
														[
															-0.97,
															1.013
														],
														[
															-2.621,
															4.313
														],
														[
															-0.374,
															69.608
														],
														[
															22.07,
															43.31
														],
														[
															2.538,
															2.649
														],
														[
															0.7,
															1.087
														],
														[
															0.49,
															0.801
														],
														[
															0.725,
															1.282
														],
														[
															0.602,
															0.946
														],
														[
															3.167,
															4.518
														],
														[
															15.506,
															15.506
														],
														[
															2.127,
															1.697
														],
														[
															1.182,
															1.043
														],
														[
															4.658,
															2.1
														],
														[
															0.358,
															0.248
														],
														[
															1.328,
															1.022
														],
														[
															0.847,
															0.676
														],
														[
															1.22,
															0.908
														],
														[
															4.565,
															2.058
														],
														[
															0.381,
															0.245
														],
														[
															1.182,
															0.744
														],
														[
															18.943,
															7.829
														],
														[
															25.353,
															4.784
														],
														[
															30.269,
															-1.778
														]
													],
													"o": [
														[
															-6.578,
															0.456
														],
														[
															-6.246,
															0.622
														],
														[
															-20.433,
															3.346
														],
														[
															-17.722,
															6.209
														],
														[
															-2.281,
															1.215
														],
														[
															-2.161,
															1.147
														],
														[
															-4.397,
															2.538
														],
														[
															-4.393,
															3.161
														],
														[
															-0.162,
															0.073
														],
														[
															-0.163,
															0.451
														],
														[
															-0.23,
															0.154
														],
														[
															-0.379,
															-0.067
														],
														[
															-0.152,
															0.069
														],
														[
															-0.17,
															0.452
														],
														[
															-7.138,
															5.241
														],
														[
															-6.228,
															5.453
														],
														[
															-13.262,
															13.262
														],
														[
															-11.138,
															15.611
														],
														[
															-2.086,
															4.382
														],
														[
															-1.785,
															4.892
														],
														[
															-1.773,
															5.053
														],
														[
															-1.721,
															5.138
														],
														[
															-2.831,
															11.359
														],
														[
															-1.745,
															12.076
														],
														[
															-0.428,
															27.986
														],
														[
															4.204,
															22.785
														],
														[
															3.472,
															8.608
														],
														[
															4.276,
															8.544
														],
														[
															0.617,
															1.006
														],
														[
															0.52,
															0.919
														],
														[
															0.401,
															0.419
														],
														[
															0.298,
															0.539
														],
														[
															0.401,
															0.419
														],
														[
															0.298,
															0.539
														],
														[
															0.401,
															0.419
														],
														[
															0.298,
															0.539
														],
														[
															0.371,
															0.388
														],
														[
															0.071,
															0.279
														],
														[
															1.312,
															1.893
														],
														[
															0.312,
															0.433
														],
														[
															0.149,
															0.331
														],
														[
															0.736,
															1.144
														],
														[
															2.84,
															3.767
														],
														[
															6.283,
															7.767
														],
														[
															11.586,
															11.836
														],
														[
															3.969,
															3.025
														],
														[
															5.178,
															3.822
														],
														[
															0.34,
															0.153
														],
														[
															3.299,
															2.019
														],
														[
															10.963,
															6.723
														],
														[
															1.209,
															0.475
														],
														[
															5.423,
															2.267
														],
														[
															2.679,
															0.943
														],
														[
															17.301,
															5.87
														],
														[
															4.134,
															0.774
														],
														[
															0.333,
															0.205
														],
														[
															4.437,
															4.548
														],
														[
															5.855,
															1.357
														],
														[
															20.84,
															0.881
														],
														[
															52.868,
															-8.562
														],
														[
															12.513,
															-8.013
														],
														[
															2.462,
															-1.884
														],
														[
															4.425,
															-3.387
														],
														[
															4.048,
															-3.098
														],
														[
															0.817,
															-1.082
														],
														[
															10.407,
															-11.58
														],
														[
															1.594,
															-2.264
														],
														[
															3.719,
															-3.882
														],
														[
															27.926,
															-45.951
														],
														[
															0.363,
															-67.564
														],
														[
															-2.463,
															-4.833
														],
														[
															-0.783,
															-0.817
														],
														[
															-0.583,
															-0.905
														],
														[
															-0.784,
															-1.282
														],
														[
															-0.594,
															-1.051
														],
														[
															-3.086,
															-4.853
														],
														[
															-12.193,
															-17.395
														],
														[
															-2.662,
															-2.662
														],
														[
															-1.092,
															-0.871
														],
														[
															-4.332,
															-3.82
														],
														[
															-0.316,
															-0.143
														],
														[
															-1.296,
															-0.898
														],
														[
															-0.842,
															-0.647
														],
														[
															-1.288,
															-1.027
														],
														[
															-4.668,
															-3.476
														],
														[
															-0.331,
															-0.149
														],
														[
															-1.137,
															-0.732
														],
														[
															-16.759,
															-10.552
														],
														[
															-20.874,
															-8.628
														],
														[
															-25.219,
															-4.759
														],
														[
															-0.628,
															0.037
														]
													],
													"v": [
														[
															344,
															16
														],
														[
															324.894,
															17.552
														],
														[
															306,
															20
														],
														[
															248.683,
															34.644
														],
														[
															200,
															56
														],
														[
															193.347,
															59.512
														],
														[
															187,
															63
														],
														[
															173.727,
															72.04
														],
														[
															161,
															80
														],
														[
															160.517,
															80.962
														],
														[
															160,
															82
														],
														[
															159.019,
															82.029
														],
														[
															158,
															82
														],
														[
															157.513,
															82.958
														],
														[
															157,
															84
														],
														[
															137.108,
															99.969
														],
														[
															119,
															117
														],
														[
															82.443,
															159.976
														],
														[
															52,
															212
														],
														[
															46.264,
															225.998
														],
														[
															41,
															241
														],
														[
															35.679,
															256.245
														],
														[
															31,
															272
														],
														[
															24.018,
															307.267
														],
														[
															21,
															344
														],
														[
															26.97,
															419.834
														],
														[
															45,
															482
														],
														[
															56.786,
															508.045
														],
														[
															70,
															532
														],
														[
															71.735,
															535.016
														],
														[
															73,
															537
														],
														[
															73.995,
															538.495
														],
														[
															75,
															540
														],
														[
															75.995,
															541.495
														],
														[
															77,
															543
														],
														[
															77.995,
															544.495
														],
														[
															79,
															546
														],
														[
															79.52,
															546.918
														],
														[
															80,
															548
														],
														[
															85,
															553
														],
														[
															85,
															555
														],
														[
															87,
															556
														],
														[
															89,
															560
														],
														[
															98,
															571
														],
														[
															117,
															593
														],
														[
															155,
															626
														],
														[
															166,
															635
														],
														[
															183,
															645
														],
														[
															184,
															647
														],
														[
															194,
															652
														],
														[
															228,
															669
														],
														[
															231,
															671
														],
														[
															246,
															676
														],
														[
															254,
															679
														],
														[
															310,
															694
														],
														[
															323,
															695
														],
														[
															324,
															698
														],
														[
															337,
															709
														],
														[
															359,
															709
														],
														[
															420,
															705
														],
														[
															550,
															656
														],
														[
															585,
															630
														],
														[
															591,
															625
														],
														[
															603,
															614
														],
														[
															614,
															603
														],
														[
															617,
															600
														],
														[
															647,
															563
														],
														[
															652,
															555
														],
														[
															660,
															542
														],
														[
															710,
															367
														],
														[
															672,
															204
														],
														[
															664,
															188
														],
														[
															663,
															186
														],
														[
															660,
															183
														],
														[
															659,
															179
														],
														[
															656,
															176
														],
														[
															647,
															162
														],
														[
															606,
															113
														],
														[
															598,
															105
														],
														[
															594,
															103
														],
														[
															581,
															92
														],
														[
															580,
															90
														],
														[
															576,
															88
														],
														[
															574,
															85
														],
														[
															570,
															83
														],
														[
															555,
															73
														],
														[
															554,
															71
														],
														[
															550,
															69
														],
														[
															498,
															42
														],
														[
															429,
															21
														],
														[
															345,
															15
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 55,
											"s": [
												{
													"i": [
														[
															-0.112,
															0.008
														],
														[
															6.275,
															-0.624
														],
														[
															6.409,
															-1.053
														],
														[
															10.468,
															-2.879
														],
														[
															9.391,
															-3.558
														],
														[
															7.918,
															-3.894
														],
														[
															7.133,
															-3.941
														],
														[
															1.542,
															-0.695
														],
														[
															0.515,
															-0.493
														],
														[
															0.861,
															-0.438
														],
														[
															0.746,
															-0.474
														],
														[
															5.935,
															-4.455
														],
														[
															5.082,
															-4.258
														],
														[
															2.622,
															-2.291
														],
														[
															2.645,
															-2.431
														],
														[
															1.884,
															-1.655
														],
														[
															1.6,
															-1.665
														],
														[
															1.474,
															-1.903
														],
														[
															1.559,
															-1.781
														],
														[
															1.826,
															-1.985
														],
														[
															0.911,
															-2.021
														],
														[
															0.849,
															-0.748
														],
														[
															0.352,
															-0.445
														],
														[
															1.561,
															-1.851
														],
														[
															1.224,
															-1.657
														],
														[
															0.634,
															-0.984
														],
														[
															0.685,
															-1.008
														],
														[
															11.008,
															-30.864
														],
														[
															0.383,
															-36.593
														],
														[
															-1.177,
															-13.814
														],
														[
															-2.458,
															-12.1
														],
														[
															-0.349,
															-1.317
														],
														[
															-0.321,
															-1.344
														],
														[
															-13.036,
															-24.548
														],
														[
															-16.769,
															-19.147
														],
														[
															-3.386,
															-3.291
														],
														[
															-3.313,
															-3.247
														],
														[
															-1.643,
															-1.714
														],
														[
															-1.754,
															-1.503
														],
														[
															-1.011,
															-0.592
														],
														[
															-0.995,
															-0.808
														],
														[
															-0.29,
															-0.574
														],
														[
															-0.42,
															-0.36
														],
														[
															-0.688,
															-0.238
														],
														[
															-0.606,
															-0.495
														],
														[
															-0.798,
															-0.889
														],
														[
															-0.887,
															-0.69
														],
														[
															-1.888,
															-1.231
														],
														[
															-0.952,
															-0.911
														],
														[
															-0.299,
															-0.08
														],
														[
															-0.444,
															-0.333
														],
														[
															-0.786,
															-0.916
														],
														[
															-0.972,
															-0.673
														],
														[
															-0.381,
															0.067
														],
														[
															-0.251,
															-0.113
														],
														[
															-0.163,
															-0.451
														],
														[
															-0.185,
															-0.123
														],
														[
															-0.379,
															0.067
														],
														[
															-0.255,
															-0.115
														],
														[
															-0.387,
															-0.244
														],
														[
															-1.018,
															-0.975
														],
														[
															-1.689,
															-0.986
														],
														[
															-14.647,
															-5.748
														],
														[
															-0.96,
															-0.385
														],
														[
															-2.387,
															-0.875
														],
														[
															-0.664,
															-0.257
														],
														[
															-1.45,
															-0.509
														],
														[
															-15.631,
															-2.95
														],
														[
															-3.779,
															-0.751
														],
														[
															-1.176,
															-0.724
														],
														[
															-0.352,
															-0.361
														],
														[
															-7.489,
															-1.736
														],
														[
															-8.071,
															-0.3
														],
														[
															-19.146,
															3.595
														],
														[
															-15.504,
															5.712
														],
														[
															-1.362,
															0.54
														],
														[
															-2.467,
															1.059
														],
														[
															-2.543,
															1.151
														],
														[
															-4.92,
															2.552
														],
														[
															-6.916,
															4.632
														],
														[
															-1.137,
															0.732
														],
														[
															-1.264,
															0.715
														],
														[
															-1.098,
															0.739
														],
														[
															-3.952,
															2.953
														],
														[
															-9.955,
															9.151
														],
														[
															-18.888,
															40.599
														],
														[
															-0.854,
															55.914
														],
														[
															34.848,
															50.614
														],
														[
															6.904,
															8.108
														],
														[
															85.627,
															16.729
														],
														[
															30.098,
															-1.768
														]
													],
													"o": [
														[
															-6.491,
															0.45
														],
														[
															-6.275,
															0.624
														],
														[
															-11.738,
															1.928
														],
														[
															-10.468,
															2.879
														],
														[
															-9.195,
															3.483
														],
														[
															-7.918,
															3.894
														],
														[
															-1.317,
															0.727
														],
														[
															-1.542,
															0.695
														],
														[
															-0.809,
															0.775
														],
														[
															-0.861,
															0.438
														],
														[
															-6.177,
															3.921
														],
														[
															-5.935,
															4.455
														],
														[
															-2.868,
															2.403
														],
														[
															-2.622,
															2.291
														],
														[
															-1.864,
															1.714
														],
														[
															-1.884,
															1.655
														],
														[
															-1.546,
															1.609
														],
														[
															-1.474,
															1.903
														],
														[
															-1.785,
															2.038
														],
														[
															-1.826,
															1.985
														],
														[
															-0.254,
															0.562
														],
														[
															-0.849,
															0.748
														],
														[
															-1.532,
															1.938
														],
														[
															-1.561,
															1.851
														],
														[
															-0.779,
															1.055
														],
														[
															-0.634,
															0.984
														],
														[
															-15.584,
															22.95
														],
														[
															-11.008,
															30.864
														],
														[
															-0.164,
															15.645
														],
														[
															1.177,
															13.814
														],
														[
															0.282,
															1.387
														],
														[
															0.349,
															1.317
														],
														[
															7.087,
															29.662
														],
														[
															13.036,
															24.548
														],
														[
															3.142,
															3.587
														],
														[
															3.386,
															3.291
														],
														[
															1.674,
															1.64
														],
														[
															1.643,
															1.714
														],
														[
															0.96,
															0.823
														],
														[
															1.011,
															0.592
														],
														[
															0.422,
															0.343
														],
														[
															0.29,
															0.574
														],
														[
															0.642,
															0.551
														],
														[
															0.688,
															0.239
														],
														[
															0.921,
															0.755
														],
														[
															0.798,
															0.889
														],
														[
															1.497,
															1.166
														],
														[
															1.888,
															1.231
														],
														[
															0.361,
															0.346
														],
														[
															0.299,
															0.08
														],
														[
															0.886,
															0.664
														],
														[
															0.786,
															0.916
														],
														[
															0.224,
															0.155
														],
														[
															0.381,
															-0.067
														],
														[
															0.162,
															0.073
														],
														[
															0.163,
															0.451
														],
														[
															0.23,
															0.154
														],
														[
															0.379,
															-0.067
														],
														[
															0.334,
															0.151
														],
														[
															2.407,
															1.52
														],
														[
															1.682,
															1.612
														],
														[
															13.967,
															8.151
														],
														[
															1.196,
															0.469
														],
														[
															2.429,
															0.975
														],
														[
															0.55,
															0.202
														],
														[
															1.501,
															0.581
														],
														[
															15.024,
															5.27
														],
														[
															5.078,
															0.958
														],
														[
															2.855,
															0.568
														],
														[
															0.333,
															0.205
														],
														[
															4.431,
															4.543
														],
														[
															5.83,
															1.351
														],
														[
															20.078,
															0.746
														],
														[
															20.055,
															-3.766
														],
														[
															1.459,
															-0.537
														],
														[
															2.488,
															-0.987
														],
														[
															2.728,
															-1.171
														],
														[
															5.038,
															-2.279
														],
														[
															8.283,
															-4.297
														],
														[
															1.286,
															-0.861
														],
														[
															1.241,
															-0.799
														],
														[
															1.154,
															-0.652
														],
														[
															4.853,
															-3.265
														],
														[
															11.202,
															-8.371
														],
														[
															30.866,
															-28.371
														],
														[
															19.233,
															-41.342
														],
														[
															1.326,
															-86.831
														],
														[
															-6.171,
															-8.963
														],
														[
															-47.142,
															-55.364
														],
														[
															-25.262,
															-4.935
														],
														[
															-0.628,
															0.037
														]
													],
													"v": [
														[
															344,
															16
														],
														[
															324.938,
															17.548
														],
														[
															306,
															20
														],
														[
															272.739,
															27.277
														],
														[
															243,
															37
														],
														[
															217.453,
															48.157
														],
														[
															195,
															60
														],
														[
															190.399,
															62.175
														],
														[
															187,
															64
														],
														[
															184.453,
															65.726
														],
														[
															182,
															67
														],
														[
															163.68,
															79.747
														],
														[
															147,
															93
														],
														[
															138.833,
															99.978
														],
														[
															131,
															107
														],
														[
															125.301,
															112.037
														],
														[
															120,
															117
														],
														[
															115.51,
															122.372
														],
														[
															111,
															128
														],
														[
															105.345,
															134.013
														],
														[
															101,
															140
														],
														[
															99.073,
															142.088
														],
														[
															97,
															144
														],
														[
															92.269,
															149.71
														],
														[
															88,
															155
														],
														[
															85.93,
															158.035
														],
														[
															84,
															161
														],
														[
															42.6,
															242.268
														],
														[
															24,
															344
														],
														[
															25.534,
															388.159
														],
														[
															31,
															427
														],
														[
															31.971,
															431.032
														],
														[
															33,
															435
														],
														[
															63.738,
															516.387
														],
														[
															109,
															582
														],
														[
															118.872,
															592.255
														],
														[
															129,
															602
														],
														[
															133.94,
															607.103
														],
														[
															139,
															612
														],
														[
															141.974,
															614.011
														],
														[
															145,
															616
														],
														[
															146.001,
															617.487
														],
														[
															147,
															619
														],
														[
															149.028,
															620.041
														],
														[
															151,
															621
														],
														[
															153.526,
															623.548
														],
														[
															156,
															626
														],
														[
															161.409,
															629.691
														],
														[
															166,
															633
														],
														[
															166.937,
															633.509
														],
														[
															168,
															634
														],
														[
															170.435,
															636.493
														],
														[
															173,
															639
														],
														[
															173.979,
															639.031
														],
														[
															175,
															639
														],
														[
															175.483,
															639.962
														],
														[
															176,
															641
														],
														[
															176.981,
															641.029
														],
														[
															178,
															641
														],
														[
															179,
															643
														],
														[
															187,
															647
														],
														[
															192,
															650
														],
														[
															236,
															672
														],
														[
															239,
															674
														],
														[
															247,
															676
														],
														[
															250,
															678
														],
														[
															255,
															679
														],
														[
															302,
															692
														],
														[
															315,
															694
														],
														[
															323,
															695
														],
														[
															324,
															698
														],
														[
															337,
															709
														],
														[
															359,
															709
														],
														[
															428,
															704
														],
														[
															484,
															688
														],
														[
															489,
															687
														],
														[
															496,
															683
														],
														[
															504,
															680
														],
														[
															519,
															673
														],
														[
															544,
															659
														],
														[
															547,
															656
														],
														[
															551,
															655
														],
														[
															554,
															652
														],
														[
															567,
															643
														],
														[
															598,
															617
														],
														[
															673,
															513
														],
														[
															707,
															368
														],
														[
															645,
															163
														],
														[
															626,
															137
														],
														[
															429,
															21
														],
														[
															345,
															15
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 56,
											"s": [
												{
													"i": [
														[
															-0.112,
															0.008
														],
														[
															6.338,
															-0.614
														],
														[
															6.238,
															-1.099
														],
														[
															6.791,
															-1.753
														],
														[
															5.547,
															-1.704
														],
														[
															2.476,
															-0.832
														],
														[
															2.185,
															-0.777
														],
														[
															1.352,
															-0.258
														],
														[
															1.204,
															-0.472
														],
														[
															0.538,
															-0.417
														],
														[
															0.495,
															-0.195
														],
														[
															6.035,
															-2.757
														],
														[
															5.483,
															-2.471
														],
														[
															0.153,
															-0.451
														],
														[
															0.21,
															-0.117
														],
														[
															1.187,
															-0.438
														],
														[
															1.133,
															-0.626
														],
														[
															12.261,
															-9.933
														],
														[
															10.044,
															-10.582
														],
														[
															11.7,
															-17.668
														],
														[
															7.987,
															-20.354
														],
														[
															0.393,
															-0.481
														],
														[
															0.192,
															-0.48
														],
														[
															0.272,
															-1.395
														],
														[
															0.441,
															-1.24
														],
														[
															0.549,
															-1.176
														],
														[
															0.407,
															-1.175
														],
														[
															3.319,
															-17.261
														],
														[
															0.567,
															-18.077
														],
														[
															-2.314,
															-17.907
														],
														[
															-4.374,
															-15.22
														],
														[
															-1.439,
															-3.736
														],
														[
															-1.123,
															-3.16
														],
														[
															-0.268,
															-1.377
														],
														[
															-0.456,
															-1.161
														],
														[
															-0.417,
															-0.538
														],
														[
															-0.195,
															-0.495
														],
														[
															-1.808,
															-3.867
														],
														[
															-1.925,
															-3.83
														],
														[
															-1.129,
															-2.824
														],
														[
															-1.309,
															-1.366
														],
														[
															-0.06,
															-0.246
														],
														[
															-0.35,
															-0.588
														],
														[
															-6.647,
															-9.292
														],
														[
															-7.316,
															-8.569
														],
														[
															-31.76,
															-19.161
														],
														[
															-40.36,
															-7.885
														],
														[
															-3.142,
															-0.35
														],
														[
															-2.577,
															-1.044
														],
														[
															-0.543,
															0.092
														],
														[
															-0.406,
															-0.197
														],
														[
															-0.074,
															-0.627
														],
														[
															-0.305,
															-0.3
														],
														[
															-0.638,
															-0.634
														],
														[
															-0.786,
															-0.818
														],
														[
															-0.969,
															-1.057
														],
														[
															-3.181,
															-0.754
														],
														[
															-3.753,
															0.218
														],
														[
															-4.02,
															-0.17
														],
														[
															-3.325,
															-0.003
														],
														[
															-3.168,
															0.163
														],
														[
															-29.753,
															11.029
														],
														[
															-22.817,
															16.875
														],
														[
															-1.344,
															0.852
														],
														[
															-1.2,
															0.541
														],
														[
															-0.166,
															0.451
														],
														[
															-0.179,
															0.124
														],
														[
															-0.641,
															0.232
														],
														[
															-0.698,
															0.561
														],
														[
															-0.288,
															0.58
														],
														[
															-0.428,
															0.342
														],
														[
															-0.678,
															0.24
														],
														[
															-0.668,
															0.546
														],
														[
															-0.287,
															0.578
														],
														[
															-0.431,
															0.343
														],
														[
															-0.682,
															0.229
														],
														[
															-0.599,
															0.548
														],
														[
															-0.744,
															1.034
														],
														[
															-1.063,
															0.985
														],
														[
															-2.716,
															2.187
														],
														[
															-1.761,
															2.054
														],
														[
															-0.232,
															0.697
														],
														[
															-0.555,
															0.61
														],
														[
															-1.902,
															1.791
														],
														[
															-1.656,
															1.932
														],
														[
															-6.117,
															8.444
														],
														[
															10.717,
															99.47
														],
														[
															13.658,
															30.52
														],
														[
															30.206,
															30.206
														],
														[
															42.852,
															18.202
														],
														[
															59.27,
															-3.482
														]
													],
													"o": [
														[
															-6.411,
															0.444
														],
														[
															-6.338,
															0.614
														],
														[
															-7.291,
															1.284
														],
														[
															-6.791,
															1.753
														],
														[
															-2.913,
															0.895
														],
														[
															-2.476,
															0.832
														],
														[
															-1.389,
															0.494
														],
														[
															-1.352,
															0.258
														],
														[
															-0.352,
															0.138
														],
														[
															-0.538,
															0.417
														],
														[
															-6.376,
															2.502
														],
														[
															-6.035,
															2.757
														],
														[
															-0.177,
															0.079
														],
														[
															-0.153,
															0.451
														],
														[
															-1.118,
															0.623
														],
														[
															-1.187,
															0.438
														],
														[
															-13.912,
															7.685
														],
														[
															-12.261,
															9.933
														],
														[
															-14.213,
															14.974
														],
														[
															-11.7,
															17.668
														],
														[
															-0.234,
															0.598
														],
														[
															-0.393,
															0.48
														],
														[
															-0.473,
															1.178
														],
														[
															-0.271,
															1.395
														],
														[
															-0.398,
															1.121
														],
														[
															-0.548,
															1.176
														],
														[
															-5.156,
															14.878
														],
														[
															-3.319,
															17.261
														],
														[
															-0.632,
															20.151
														],
														[
															2.314,
															17.907
														],
														[
															1.12,
															3.898
														],
														[
															1.439,
															3.736
														],
														[
															0.474,
															1.331
														],
														[
															0.268,
															1.377
														],
														[
															0.138,
															0.352
														],
														[
															0.417,
															0.538
														],
														[
															1.844,
															4.701
														],
														[
															1.807,
															3.867
														],
														[
															1.174,
															2.336
														],
														[
															1.129,
															2.824
														],
														[
															0.409,
															0.427
														],
														[
															0.06,
															0.246
														],
														[
															6.098,
															10.262
														],
														[
															6.647,
															9.292
														],
														[
															22.599,
															26.469
														],
														[
															31.76,
															19.161
														],
														[
															2.853,
															0.558
														],
														[
															3.143,
															0.35
														],
														[
															0.42,
															0.17
														],
														[
															0.543,
															-0.092
														],
														[
															0.397,
															0.193
														],
														[
															0.074,
															0.627
														],
														[
															0.66,
															0.648
														],
														[
															0.638,
															0.634
														],
														[
															1.942,
															2.021
														],
														[
															0.969,
															1.056
														],
														[
															2.969,
															0.703
														],
														[
															3.753,
															-0.218
														],
														[
															3.533,
															0.149
														],
														[
															3.325,
															0.003
														],
														[
															39.172,
															-2.01
														],
														[
															29.753,
															-11.029
														],
														[
															1.423,
															-1.052
														],
														[
															1.344,
															-0.852
														],
														[
															0.158,
															-0.072
														],
														[
															0.166,
															-0.451
														],
														[
															0.738,
															-0.512
														],
														[
															0.641,
															-0.232
														],
														[
															0.421,
															-0.338
														],
														[
															0.288,
															-0.58
														],
														[
															0.618,
															-0.493
														],
														[
															0.678,
															-0.24
														],
														[
															0.42,
															-0.344
														],
														[
															0.287,
															-0.578
														],
														[
															0.673,
															-0.537
														],
														[
															0.682,
															-0.229
														],
														[
															0.959,
															-0.879
														],
														[
															0.744,
															-1.034
														],
														[
															2.373,
															-2.198
														],
														[
															2.716,
															-2.187
														],
														[
															0.515,
															-0.601
														],
														[
															0.232,
															-0.697
														],
														[
															1.736,
															-1.906
														],
														[
															1.902,
															-1.791
														],
														[
															6.883,
															-8.029
														],
														[
															42.007,
															-57.982
														],
														[
															-4.366,
															-40.528
														],
														[
															-19.938,
															-44.553
														],
														[
															-30.263,
															-30.263
														],
														[
															-40.299,
															-17.117
														],
														[
															-0.628,
															0.037
														]
													],
													"v": [
														[
															344,
															16
														],
														[
															324.87,
															17.509
														],
														[
															306,
															20
														],
														[
															284.692,
															24.685
														],
														[
															266,
															30
														],
														[
															257.954,
															32.588
														],
														[
															251,
															35
														],
														[
															246.861,
															36.016
														],
														[
															243,
															37
														],
														[
															241.608,
															37.958
														],
														[
															240,
															39
														],
														[
															221.33,
															47.023
														],
														[
															204,
															55
														],
														[
															203.525,
															55.972
														],
														[
															203,
															57
														],
														[
															199.512,
															58.498
														],
														[
															196,
															60
														],
														[
															156.599,
															86.828
														],
														[
															123,
															118
														],
														[
															83.831,
															166.965
														],
														[
															54,
															224
														],
														[
															52.968,
															225.589
														],
														[
															52,
															227
														],
														[
															50.976,
															230.954
														],
														[
															50,
															235
														],
														[
															48.507,
															238.459
														],
														[
															47,
															242
														],
														[
															34.058,
															290.6
														],
														[
															28,
															344
														],
														[
															30.745,
															401.199
														],
														[
															41,
															451
														],
														[
															44.998,
															462.553
														],
														[
															49,
															473
														],
														[
															50.014,
															477.127
														],
														[
															51,
															481
														],
														[
															51.958,
															482.392
														],
														[
															53,
															484
														],
														[
															58.439,
															496.653
														],
														[
															64,
															508
														],
														[
															67.398,
															516.227
														],
														[
															71,
															523
														],
														[
															71.545,
															523.879
														],
														[
															72,
															525
														],
														[
															91.087,
															554.27
														],
														[
															112,
															581
														],
														[
															193.68,
															650.438
														],
														[
															302,
															692
														],
														[
															311.207,
															693.135
														],
														[
															320,
															695
														],
														[
															321.51,
															694.979
														],
														[
															323,
															695
														],
														[
															323.569,
															696.42
														],
														[
															324,
															698
														],
														[
															325.905,
															699.873
														],
														[
															328,
															702
														],
														[
															331.571,
															706.45
														],
														[
															337,
															709
														],
														[
															347.211,
															709.4
														],
														[
															359,
															709
														],
														[
															369.273,
															709.234
														],
														[
															379,
															709
														],
														[
															481.766,
															688.649
														],
														[
															560,
															646
														],
														[
															564.167,
															643.117
														],
														[
															568,
															641
														],
														[
															568.484,
															640.039
														],
														[
															569,
															639
														],
														[
															571.03,
															638.037
														],
														[
															573,
															637
														],
														[
															573.994,
															635.503
														],
														[
															575,
															634
														],
														[
															576.962,
															633.04
														],
														[
															579,
															632
														],
														[
															579.992,
															630.5
														],
														[
															581,
															629
														],
														[
															583.056,
															628.008
														],
														[
															585,
															627
														],
														[
															587.422,
															624.08
														],
														[
															590,
															621
														],
														[
															597.959,
															614.392
														],
														[
															605,
															608
														],
														[
															605.97,
															606.007
														],
														[
															607,
															604
														],
														[
															612.56,
															598.519
														],
														[
															618,
															593
														],
														[
															637,
															568
														],
														[
															701,
															325
														],
														[
															673,
															220
														],
														[
															601,
															114
														],
														[
															496,
															42
														],
														[
															345,
															15
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 57,
											"s": [
												{
													"i": [
														[
															-0.112,
															0.008
														],
														[
															6.156,
															-0.621
														],
														[
															6.16,
															-1.085
														],
														[
															6.851,
															-1.772
														],
														[
															5.365,
															-1.637
														],
														[
															4.441,
															-1.51
														],
														[
															3.618,
															-1.55
														],
														[
															1.112,
															-0.477
														],
														[
															1.185,
															-0.508
														],
														[
															1.112,
															-0.477
														],
														[
															1.185,
															-0.508
														],
														[
															0.475,
															-0.376
														],
														[
															0.493,
															-0.236
														],
														[
															16.658,
															-12.209
														],
														[
															12.07,
															-12.939
														],
														[
															2.154,
															-2.747
														],
														[
															1.956,
															-2.409
														],
														[
															0.878,
															-0.787
														],
														[
															0.715,
															-0.899
														],
														[
															1.665,
															-2.316
														],
														[
															1.742,
															-2.476
														],
														[
															0.225,
															-0.5
														],
														[
															0.247,
															-0.37
														],
														[
															0.23,
															-0.511
														],
														[
															0.246,
															-0.375
														],
														[
															0.232,
															-0.514
														],
														[
															0.247,
															-0.37
														],
														[
															0.23,
															-0.511
														],
														[
															0.242,
															-0.395
														],
														[
															1.268,
															-2.107
														],
														[
															2.291,
															-4.164
														],
														[
															1.182,
															-2.14
														],
														[
															1.335,
															-3.403
														],
														[
															0.456,
															-0.994
														],
														[
															0.923,
															-50.606
														],
														[
															-14.518,
															-38.325
														],
														[
															-0.8,
															-2.033
														],
														[
															-0.967,
															-2.355
														],
														[
															-2.2,
															-4.483
														],
														[
															-3.055,
															-5.53
														],
														[
															-0.957,
															-0.999
														],
														[
															-0.947,
															-1.492
														],
														[
															-3.969,
															-5.63
														],
														[
															-1.482,
															-2.008
														],
														[
															-1.341,
															-1.74
														],
														[
															-2.873,
															-3.689
														],
														[
															-0.715,
															-0.822
														],
														[
															-1.636,
															-1.796
														],
														[
															-10.686,
															-8.917
														],
														[
															-16.276,
															-7.337
														],
														[
															-0.402,
															-0.24
														],
														[
															-2.272,
															-1.241
														],
														[
															-4.527,
															-2.242
														],
														[
															-1.098,
															-0.431
														],
														[
															-1.444,
															-0.68
														],
														[
															-4.4,
															-1.845
														],
														[
															-15.276,
															-4.009
														],
														[
															-10.559,
															-2.732
														],
														[
															-3.152,
															-3.346
														],
														[
															-1.703,
															-0.619
														],
														[
															-1.21,
															-0.35
														],
														[
															-13.934,
															0.669
														],
														[
															-12.451,
															2.067
														],
														[
															-37.253,
															27.739
														],
														[
															-4.3,
															1.939
														],
														[
															-0.29,
															0.245
														],
														[
															-1.633,
															0.736
														],
														[
															-0.29,
															0.245
														],
														[
															-5.713,
															6.665
														],
														[
															-1.111,
															1.22
														],
														[
															-3.52,
															4.106
														],
														[
															-5.943,
															8.432
														],
														[
															-1.616,
															81.731
														],
														[
															14.018,
															36.777
														],
														[
															0.543,
															1.391
														],
														[
															1.011,
															2.354
														],
														[
															1.135,
															2.443
														],
														[
															6.645,
															10.796
														],
														[
															2.077,
															4.608
														],
														[
															0.245,
															0.381
														],
														[
															0.768,
															1.123
														],
														[
															0.967,
															2.144
														],
														[
															0.248,
															0.358
														],
														[
															13.696,
															13.001
														],
														[
															6.329,
															2.853
														],
														[
															0.325,
															0.249
														],
														[
															1.859,
															1.594
														],
														[
															1.179,
															0.881
														],
														[
															19.431,
															8.781
														],
														[
															8.293,
															3.2
														],
														[
															51.411,
															-3.02
														]
													],
													"o": [
														[
															-6.217,
															0.431
														],
														[
															-6.156,
															0.621
														],
														[
															-7.23,
															1.273
														],
														[
															-6.851,
															1.773
														],
														[
															-4.618,
															1.409
														],
														[
															-4.441,
															1.51
														],
														[
															-1.365,
															0.585
														],
														[
															-1.112,
															0.477
														],
														[
															-1.365,
															0.585
														],
														[
															-1.112,
															0.477
														],
														[
															-0.605,
															0.259
														],
														[
															-0.475,
															0.376
														],
														[
															-19.298,
															9.224
														],
														[
															-16.658,
															12.209
														],
														[
															-2.429,
															2.605
														],
														[
															-2.154,
															2.747
														],
														[
															-0.773,
															0.952
														],
														[
															-0.878,
															0.787
														],
														[
															-2.392,
															3.005
														],
														[
															-2.051,
															2.853
														],
														[
															-0.311,
															0.442
														],
														[
															-0.146,
															0.324
														],
														[
															-0.307,
															0.46
														],
														[
															-0.148,
															0.327
														],
														[
															-0.305,
															0.466
														],
														[
															-0.146,
															0.324
														],
														[
															-0.307,
															0.46
														],
														[
															-0.153,
															0.339
														],
														[
															-1.225,
															1.994
														],
														[
															-2.454,
															4.078
														],
														[
															-1.15,
															2.09
														],
														[
															-1.971,
															3.569
														],
														[
															-0.486,
															1.237
														],
														[
															-17.32,
															37.789
														],
														[
															-0.964,
															52.844
														],
														[
															0.766,
															2.023
														],
														[
															1.064,
															2.704
														],
														[
															1.989,
															4.843
														],
														[
															3.569,
															7.272
														],
														[
															1.402,
															2.538
														],
														[
															1.55,
															1.617
														],
														[
															3.944,
															6.214
														],
														[
															1.369,
															1.942
														],
														[
															1.315,
															1.782
														],
														[
															3.626,
															4.706
														],
														[
															0.656,
															0.842
														],
														[
															1.717,
															1.974
														],
														[
															9.658,
															10.607
														],
														[
															13.674,
															11.41
														],
														[
															0.343,
															0.155
														],
														[
															2.094,
															1.253
														],
														[
															4.524,
															2.471
														],
														[
															0.817,
															0.404
														],
														[
															1.541,
															0.604
														],
														[
															4.368,
															2.057
														],
														[
															14.818,
															6.214
														],
														[
															10.962,
															2.877
														],
														[
															5.863,
															1.517
														],
														[
															2.142,
															2.274
														],
														[
															1.18,
															0.429
														],
														[
															11.252,
															3.253
														],
														[
															13.559,
															-0.651
														],
														[
															58.356,
															-9.688
														],
														[
															4.415,
															-3.288
														],
														[
															0.271,
															-0.122
														],
														[
															1.9,
															-1.608
														],
														[
															0.271,
															-0.122
														],
														[
															7.51,
															-6.354
														],
														[
															1.03,
															-1.202
														],
														[
															3.635,
															-3.992
														],
														[
															6.623,
															-7.726
														],
														[
															35.917,
															-50.957
														],
														[
															1.042,
															-52.731
														],
														[
															-0.511,
															-1.34
														],
														[
															-0.954,
															-2.445
														],
														[
															-1.156,
															-2.69
														],
														[
															-5.84,
															-12.572
														],
														[
															-3.196,
															-5.193
														],
														[
															-0.149,
															-0.331
														],
														[
															-0.664,
															-1.032
														],
														[
															-1.95,
															-2.852
														],
														[
															-0.143,
															-0.317
														],
														[
															-11.213,
															-16.181
														],
														[
															-5.414,
															-5.139
														],
														[
															-0.294,
															-0.133
														],
														[
															-2.925,
															-2.239
														],
														[
															-1.114,
															-0.955
														],
														[
															-16.757,
															-12.532
														],
														[
															-7.608,
															-3.438
														],
														[
															-36.061,
															-13.913
														],
														[
															-0.628,
															0.037
														]
													],
													"v": [
														[
															344,
															16
														],
														[
															325.457,
															17.509
														],
														[
															307,
															20
														],
														[
															285.601,
															24.727
														],
														[
															267,
															30
														],
														[
															253.25,
															34.394
														],
														[
															241,
															39
														],
														[
															237.365,
															40.558
														],
														[
															234,
															42
														],
														[
															230.365,
															43.558
														],
														[
															227,
															45
														],
														[
															225.416,
															46.017
														],
														[
															224,
															47
														],
														[
															169.578,
															79.713
														],
														[
															126,
															118
														],
														[
															119.145,
															126.147
														],
														[
															113,
															134
														],
														[
															110.457,
															136.54
														],
														[
															108,
															139
														],
														[
															102,
															148
														],
														[
															95,
															156
														],
														[
															95,
															158
														],
														[
															93,
															159
														],
														[
															93,
															161
														],
														[
															91,
															162
														],
														[
															91,
															164
														],
														[
															89,
															165
														],
														[
															89,
															167
														],
														[
															87,
															168
														],
														[
															84,
															175
														],
														[
															76,
															187
														],
														[
															73,
															194
														],
														[
															68,
															204
														],
														[
															66,
															207
														],
														[
															34,
															344
														],
														[
															56,
															479
														],
														[
															59,
															485
														],
														[
															61,
															493
														],
														[
															68,
															506
														],
														[
															78,
															526
														],
														[
															82,
															534
														],
														[
															85,
															539
														],
														[
															97,
															557
														],
														[
															101,
															563
														],
														[
															106,
															568
														],
														[
															116,
															582
														],
														[
															119,
															584
														],
														[
															123,
															590
														],
														[
															154,
															619
														],
														[
															199,
															651
														],
														[
															200,
															653
														],
														[
															207,
															656
														],
														[
															220,
															663
														],
														[
															223,
															665
														],
														[
															227,
															666
														],
														[
															240,
															673
														],
														[
															285,
															688
														],
														[
															320,
															695
														],
														[
															328,
															702
														],
														[
															333,
															708
														],
														[
															337,
															708
														],
														[
															378,
															709
														],
														[
															418,
															705
														],
														[
															557,
															646
														],
														[
															571,
															636
														],
														[
															572,
															634
														],
														[
															577,
															631
														],
														[
															578,
															629
														],
														[
															601,
															608
														],
														[
															603,
															604
														],
														[
															614,
															593
														],
														[
															633,
															568
														],
														[
															697,
															368
														],
														[
															673,
															233
														],
														[
															672,
															228
														],
														[
															668,
															221
														],
														[
															665,
															213
														],
														[
															646,
															177
														],
														[
															637,
															162
														],
														[
															635,
															161
														],
														[
															633,
															157
														],
														[
															628,
															149
														],
														[
															626,
															148
														],
														[
															587,
															104
														],
														[
															568,
															88
														],
														[
															567,
															86
														],
														[
															561,
															81
														],
														[
															557,
															79
														],
														[
															502,
															46
														],
														[
															479,
															36
														],
														[
															345,
															15
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 58,
											"s": [
												{
													"i": [
														[
															-0.112,
															0.008
														],
														[
															6.147,
															-0.613
														],
														[
															6.028,
															-1.107
														],
														[
															18.795,
															-7.762
														],
														[
															15.498,
															-9.855
														],
														[
															13.864,
															-12.93
														],
														[
															10.745,
															-14.234
														],
														[
															1.227,
															-1.87
														],
														[
															0.901,
															-0.941
														],
														[
															0.298,
															-0.539
														],
														[
															0.407,
															-0.425
														],
														[
															0.298,
															-0.539
														],
														[
															0.407,
															-0.425
														],
														[
															0.298,
															-0.539
														],
														[
															0.407,
															-0.425
														],
														[
															0.298,
															-0.539
														],
														[
															0.407,
															-0.425
														],
														[
															0.796,
															-1.169
														],
														[
															0.729,
															-1.188
														],
														[
															0.26,
															-0.809
														],
														[
															0.344,
															-0.762
														],
														[
															0.451,
															-0.156
														],
														[
															0.12,
															-0.204
														],
														[
															0.432,
															-1.187
														],
														[
															0.648,
															-1.186
														],
														[
															1.615,
															-3.273
														],
														[
															1.719,
															-3.573
														],
														[
															1.251,
															-2.143
														],
														[
															0.965,
															-2.287
														],
														[
															0.286,
															-1.238
														],
														[
															0.436,
															-1.054
														],
														[
															3.969,
															-14.505
														],
														[
															1.867,
															-15.265
														],
														[
															-4.236,
															-29.884
														],
														[
															-9.135,
															-24.123
														],
														[
															-4.425,
															-8.992
														],
														[
															-4.755,
															-7.67
														],
														[
															-11.335,
															-13.539
														],
														[
															-13.049,
															-11.337
														],
														[
															-24.293,
															-12.431
														],
														[
															-28.831,
															-5.771
														],
														[
															-2.973,
															-0.363
														],
														[
															-2.446,
															-1.014
														],
														[
															-0.544,
															0.093
														],
														[
															-0.406,
															-0.197
														],
														[
															-0.074,
															-0.622
														],
														[
															-0.303,
															-0.316
														],
														[
															-0.62,
															-0.6
														],
														[
															-0.858,
															-0.907
														],
														[
															-0.385,
															-0.93
														],
														[
															-0.725,
															-0.502
														],
														[
															-4.891,
															0.018
														],
														[
															-4.735,
															-0.2
														],
														[
															-10.097,
															0.695
														],
														[
															-9.312,
															1.653
														],
														[
															-20.288,
															8.692
														],
														[
															-16.606,
															11.754
														],
														[
															-1.998,
															1.514
														],
														[
															-1.881,
															1.438
														],
														[
															-1.401,
															0.878
														],
														[
															-1.094,
															0.494
														],
														[
															-0.18,
															0.454
														],
														[
															-0.145,
															0.122
														],
														[
															-0.808,
															0.457
														],
														[
															-0.817,
															0.368
														],
														[
															-0.18,
															0.454
														],
														[
															-0.145,
															0.122
														],
														[
															-2.993,
															2.781
														],
														[
															-20.496,
															45.8
														],
														[
															-1.08,
															54.639
														],
														[
															5.043,
															24.314
														],
														[
															3.545,
															11.269
														],
														[
															4.357,
															10.339
														],
														[
															43.792,
															35.425
														],
														[
															4.134,
															1.864
														],
														[
															0.37,
															0.247
														],
														[
															0.511,
															0.23
														],
														[
															0.372,
															0.247
														],
														[
															0.512,
															0.231
														],
														[
															0.381,
															0.245
														],
														[
															1.116,
															0.723
														],
														[
															2.62,
															1.606
														],
														[
															0.51,
															0.489
														],
														[
															0.74,
															0.709
														],
														[
															1.202,
															0.697
														],
														[
															3.556,
															1.65
														],
														[
															1.522,
															0.683
														],
														[
															4.846,
															1.907
														],
														[
															8.347,
															2.427
														],
														[
															8.933,
															1.827
														],
														[
															29.689,
															-1.744
														]
													],
													"o": [
														[
															-6.387,
															0.443
														],
														[
															-6.147,
															0.613
														],
														[
															-22.322,
															4.097
														],
														[
															-18.795,
															7.762
														],
														[
															-15.797,
															10.045
														],
														[
															-13.865,
															12.93
														],
														[
															-1.192,
															1.579
														],
														[
															-1.227,
															1.87
														],
														[
															-0.401,
															0.419
														],
														[
															-0.298,
															0.539
														],
														[
															-0.401,
															0.419
														],
														[
															-0.298,
															0.539
														],
														[
															-0.401,
															0.419
														],
														[
															-0.298,
															0.539
														],
														[
															-0.401,
															0.419
														],
														[
															-0.298,
															0.539
														],
														[
															-1.088,
															1.135
														],
														[
															-0.796,
															1.169
														],
														[
															-0.616,
															1.003
														],
														[
															-0.26,
															0.809
														],
														[
															-0.078,
															0.173
														],
														[
															-0.451,
															0.156
														],
														[
															-0.624,
															1.067
														],
														[
															-0.432,
															1.187
														],
														[
															-1.821,
															3.334
														],
														[
															-1.615,
															3.273
														],
														[
															-1.029,
															2.139
														],
														[
															-1.251,
															2.143
														],
														[
															-0.419,
															0.993
														],
														[
															-0.286,
															1.238
														],
														[
															-5.257,
															12.713
														],
														[
															-3.969,
															14.505
														],
														[
															-4.078,
															33.344
														],
														[
															4.236,
															29.884
														],
														[
															3.546,
															9.363
														],
														[
															4.425,
															8.992
														],
														[
															9.612,
															15.505
														],
														[
															11.335,
															13.54
														],
														[
															18.999,
															16.506
														],
														[
															24.293,
															12.431
														],
														[
															2.664,
															0.533
														],
														[
															2.972,
															0.363
														],
														[
															0.418,
															0.173
														],
														[
															0.544,
															-0.093
														],
														[
															0.4,
															0.195
														],
														[
															0.074,
															0.622
														],
														[
															0.663,
															0.693
														],
														[
															0.62,
															0.6
														],
														[
															0.738,
															0.779
														],
														[
															0.384,
															0.93
														],
														[
															2.701,
															1.871
														],
														[
															4.891,
															-0.018
														],
														[
															10.298,
															0.435
														],
														[
															10.097,
															-0.696
														],
														[
															25.24,
															-4.48
														],
														[
															20.288,
															-8.692
														],
														[
															2.128,
															-1.505
														],
														[
															1.998,
															-1.514
														],
														[
															1.302,
															-0.995
														],
														[
															1.401,
															-0.878
														],
														[
															0.135,
															-0.061
														],
														[
															0.18,
															-0.454
														],
														[
															0.95,
															-0.804
														],
														[
															0.808,
															-0.457
														],
														[
															0.135,
															-0.061
														],
														[
															0.18,
															-0.454
														],
														[
															3.458,
															-2.925
														],
														[
															34.55,
															-32.1
														],
														[
															18.201,
															-40.671
														],
														[
															0.57,
															-28.818
														],
														[
															-2.5,
															-12.051
														],
														[
															-3.424,
															-10.884
														],
														[
															-24.075,
															-57.133
														],
														[
															-4.295,
															-3.474
														],
														[
															-0.324,
															-0.146
														],
														[
															-0.46,
															-0.307
														],
														[
															-0.325,
															-0.147
														],
														[
															-0.462,
															-0.306
														],
														[
															-0.331,
															-0.149
														],
														[
															-1.011,
															-0.65
														],
														[
															-3.474,
															-2.25
														],
														[
															-1.682,
															-1.031
														],
														[
															-1.78,
															-1.705
														],
														[
															-0.864,
															-0.828
														],
														[
															-4.58,
															-2.654
														],
														[
															-1.351,
															-0.627
														],
														[
															-4.658,
															-2.091
														],
														[
															-8.234,
															-3.241
														],
														[
															-8.363,
															-2.432
														],
														[
															-24.382,
															-4.986
														],
														[
															-0.628,
															0.037
														]
													],
													"v": [
														[
															344,
															16
														],
														[
															325.231,
															17.502
														],
														[
															307,
															20
														],
														[
															245.382,
															38.182
														],
														[
															194,
															65
														],
														[
															149.211,
															99.858
														],
														[
															112,
															141
														],
														[
															108.282,
															146.479
														],
														[
															105,
															151
														],
														[
															104.005,
															152.495
														],
														[
															103,
															154
														],
														[
															102.005,
															155.495
														],
														[
															101,
															157
														],
														[
															100.005,
															158.495
														],
														[
															99,
															160
														],
														[
															98.005,
															161.495
														],
														[
															97,
															163
														],
														[
															94.231,
															166.461
														],
														[
															92,
															170
														],
														[
															90.796,
															172.681
														],
														[
															90,
															175
														],
														[
															89.031,
															175.477
														],
														[
															88,
															176
														],
														[
															86.518,
															179.411
														],
														[
															85,
															183
														],
														[
															79.924,
															192.821
														],
														[
															75,
															203
														],
														[
															71.452,
															209.389
														],
														[
															68,
															216
														],
														[
															67.013,
															219.454
														],
														[
															66,
															223
														],
														[
															51.957,
															264.086
														],
														[
															43,
															309
														],
														[
															44.091,
															404.416
														],
														[
															65,
															486
														],
														[
															77.093,
															513.769
														],
														[
															91,
															539
														],
														[
															122.422,
															582.626
														],
														[
															159,
															620
														],
														[
															224.126,
															664.052
														],
														[
															304,
															692
														],
														[
															312.663,
															693.139
														],
														[
															321,
															695
														],
														[
															322.509,
															694.982
														],
														[
															324,
															695
														],
														[
															324.573,
															696.409
														],
														[
															325,
															698
														],
														[
															326.854,
															699.84
														],
														[
															329,
															702
														],
														[
															330.51,
															704.708
														],
														[
															332,
															707
														],
														[
															343.975,
															709.254
														],
														[
															359,
															709
														],
														[
															389.74,
															708.566
														],
														[
															419,
															705
														],
														[
															486.975,
															684.955
														],
														[
															542,
															654
														],
														[
															548.185,
															649.449
														],
														[
															554,
															645
														],
														[
															558.155,
															642.124
														],
														[
															562,
															640
														],
														[
															562.493,
															639.046
														],
														[
															563,
															638
														],
														[
															565.6,
															636.173
														],
														[
															568,
															635
														],
														[
															568.493,
															634.046
														],
														[
															569,
															633
														],
														[
															578,
															625
														],
														[
															659,
															510
														],
														[
															690,
															367
														],
														[
															682,
															288
														],
														[
															674,
															253
														],
														[
															662,
															221
														],
														[
															560,
															84
														],
														[
															546,
															74
														],
														[
															545,
															72
														],
														[
															543,
															72
														],
														[
															542,
															70
														],
														[
															540,
															70
														],
														[
															539,
															68
														],
														[
															535,
															66
														],
														[
															525,
															60
														],
														[
															520,
															57
														],
														[
															513,
															53
														],
														[
															511,
															52
														],
														[
															497,
															44
														],
														[
															492,
															43
														],
														[
															478,
															36
														],
														[
															453,
															28
														],
														[
															427,
															21
														],
														[
															345,
															15
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 59,
											"s": [
												{
													"i": [
														[
															-0.109,
															0.008
														],
														[
															5.983,
															-0.619
														],
														[
															5.758,
															-1.057
														],
														[
															5.147,
															-1.367
														],
														[
															4.869,
															-1.515
														],
														[
															16.841,
															-9.016
														],
														[
															14.222,
															-11.584
														],
														[
															5.011,
															-4.707
														],
														[
															4.463,
															-4.702
														],
														[
															11.465,
															-17.508
														],
														[
															8.781,
															-20.839
														],
														[
															4.692,
															-28.056
														],
														[
															-2.405,
															-30.91
														],
														[
															-7.021,
															-23.971
														],
														[
															-10.674,
															-19.322
														],
														[
															-0.458,
															-1.223
														],
														[
															-0.595,
															-1.072
														],
														[
															-0.733,
															-0.781
														],
														[
															-0.552,
															-0.948
														],
														[
															-0.687,
															-1.553
														],
														[
															-0.531,
															-0.555
														],
														[
															-0.06,
															-0.246
														],
														[
															-0.35,
															-0.588
														],
														[
															-2.4,
															-3.331
														],
														[
															-2.248,
															-3.052
														],
														[
															-0.642,
															-1.026
														],
														[
															-0.705,
															-0.91
														],
														[
															-0.854,
															-0.746
														],
														[
															-0.776,
															-0.976
														],
														[
															-1.285,
															-1.889
														],
														[
															-1.435,
															-1.651
														],
														[
															-0.835,
															-0.866
														],
														[
															-0.586,
															-1.3
														],
														[
															-0.246,
															-0.295
														],
														[
															-12.602,
															-9.965
														],
														[
															-1.735,
															-1.333
														],
														[
															-0.963,
															-0.673
														],
														[
															-0.852,
															-0.602
														],
														[
															-0.499,
															-0.225
														],
														[
															-0.37,
															-0.247
														],
														[
															-0.511,
															-0.23
														],
														[
															-0.363,
															-0.248
														],
														[
															-0.506,
															-0.228
														],
														[
															-0.37,
															-0.247
														],
														[
															-0.511,
															-0.23
														],
														[
															-0.37,
															-0.247
														],
														[
															-0.511,
															-0.23
														],
														[
															-0.37,
															-0.247
														],
														[
															-0.511,
															-0.23
														],
														[
															-0.387,
															-0.244
														],
														[
															-2.014,
															-1.192
														],
														[
															-4.27,
															-2.346
														],
														[
															-2.108,
															-1.06
														],
														[
															-2.159,
															-0.947
														],
														[
															-2.218,
															-0.956
														],
														[
															-5.63,
															-1.959
														],
														[
															-12.989,
															-2.777
														],
														[
															-3.763,
															-3.552
														],
														[
															-1.917,
															-2.031
														],
														[
															-6.089,
															-1.489
														],
														[
															-7.585,
															-0.32
														],
														[
															-17.817,
															3.262
														],
														[
															-22.61,
															11.181
														],
														[
															-2.997,
															1.694
														],
														[
															-1.022,
															0.588
														],
														[
															-2.157,
															1.305
														],
														[
															-2.507,
															1.13
														],
														[
															-0.381,
															0.245
														],
														[
															-1.32,
															0.863
														],
														[
															-3.58,
															2.826
														],
														[
															-1.893,
															0.853
														],
														[
															-0.325,
															0.249
														],
														[
															-1.862,
															1.759
														],
														[
															-0.971,
															0.849
														],
														[
															-4.616,
															4.689
														],
														[
															-3.156,
															3.683
														],
														[
															-1.104,
															1.278
														],
														[
															-0.775,
															0.82
														],
														[
															-0.979,
															1.194
														],
														[
															-0.722,
															0.842
														],
														[
															-0.906,
															1.159
														],
														[
															-1.285,
															1.691
														],
														[
															-2.531,
															3.793
														],
														[
															-10.029,
															23.164
														],
														[
															6.954,
															67.619
														],
														[
															6.594,
															22.504
														],
														[
															4.181,
															10.282
														],
														[
															48.987,
															36.927
														],
														[
															19.499,
															8.905
														],
														[
															23.573,
															4.901
														],
														[
															28.957,
															-1.854
														]
													],
													"o": [
														[
															-6.31,
															0.466
														],
														[
															-5.983,
															0.619
														],
														[
															-5.545,
															1.017
														],
														[
															-5.147,
															1.367
														],
														[
															-20.413,
															6.351
														],
														[
															-16.841,
															9.016
														],
														[
															-5.492,
															4.472
														],
														[
															-5.011,
															4.706
														],
														[
															-14.361,
															15.13
														],
														[
															-11.465,
															17.508
														],
														[
															-9.636,
															22.867
														],
														[
															-4.692,
															28.056
														],
														[
															2.24,
															28.794
														],
														[
															7.022,
															23.971
														],
														[
															0.572,
															1.035
														],
														[
															0.458,
															1.223
														],
														[
															0.514,
															0.927
														],
														[
															0.733,
															0.781
														],
														[
															0.719,
															1.235
														],
														[
															0.687,
															1.553
														],
														[
															0.409,
															0.427
														],
														[
															0.06,
															0.246
														],
														[
															2.154,
															3.625
														],
														[
															2.4,
															3.331
														],
														[
															0.725,
															0.986
														],
														[
															0.642,
															1.026
														],
														[
															0.806,
															1.042
														],
														[
															0.854,
															0.746
														],
														[
															1.425,
															1.791
														],
														[
															1.285,
															1.889
														],
														[
															1.075,
															1.236
														],
														[
															0.835,
															0.866
														],
														[
															0.124,
															0.274
														],
														[
															10.953,
															13.144
														],
														[
															1.811,
															1.432
														],
														[
															0.87,
															0.668
														],
														[
															0.832,
															0.581
														],
														[
															0.441,
															0.311
														],
														[
															0.324,
															0.146
														],
														[
															0.46,
															0.307
														],
														[
															0.319,
															0.144
														],
														[
															0.452,
															0.309
														],
														[
															0.324,
															0.146
														],
														[
															0.46,
															0.307
														],
														[
															0.324,
															0.146
														],
														[
															0.46,
															0.307
														],
														[
															0.324,
															0.146
														],
														[
															0.46,
															0.307
														],
														[
															0.335,
															0.151
														],
														[
															1.703,
															1.074
														],
														[
															4.394,
															2.599
														],
														[
															2.117,
															1.163
														],
														[
															2.128,
															1.07
														],
														[
															2.478,
															1.087
														],
														[
															7.09,
															3.055
														],
														[
															13.022,
															4.531
														],
														[
															7.113,
															1.521
														],
														[
															1.311,
															1.237
														],
														[
															3.793,
															4.017
														],
														[
															5.439,
															1.33
														],
														[
															19.88,
															0.84
														],
														[
															32.455,
															-5.942
														],
														[
															3.651,
															-1.806
														],
														[
															0.956,
															-0.54
														],
														[
															2.226,
															-1.28
														],
														[
															2.891,
															-1.75
														],
														[
															0.331,
															-0.149
														],
														[
															1.369,
															-0.881
														],
														[
															4.736,
															-3.095
														],
														[
															2.527,
															-1.995
														],
														[
															0.295,
															-0.133
														],
														[
															2.979,
															-2.28
														],
														[
															1.099,
															-1.038
														],
														[
															5.636,
															-4.93
														],
														[
															4.162,
															-4.228
														],
														[
															1.016,
															-1.185
														],
														[
															0.729,
															-0.844
														],
														[
															0.984,
															-1.042
														],
														[
															0.693,
															-0.844
														],
														[
															0.955,
															-1.114
														],
														[
															1.431,
															-1.829
														],
														[
															3.397,
															-4.471
														],
														[
															13.198,
															-19.78
														],
														[
															21.546,
															-49.766
														],
														[
															-2.763,
															-26.868
														],
														[
															-3.215,
															-10.974
														],
														[
															-25.008,
															-61.494
														],
														[
															-16.105,
															-12.14
														],
														[
															-19.035,
															-8.693
														],
														[
															-24.212,
															-5.034
														],
														[
															-0.627,
															0.04
														]
													],
													"v": [
														[
															344,
															16
														],
														[
															325.586,
															17.557
														],
														[
															308,
															20
														],
														[
															291.993,
															23.627
														],
														[
															277,
															28
														],
														[
															221.358,
															51.076
														],
														[
															175,
															82
														],
														[
															159.228,
															95.828
														],
														[
															145,
															110
														],
														[
															106.315,
															158.718
														],
														[
															76,
															216
														],
														[
															53.97,
															292.967
														],
														[
															50,
															382
														],
														[
															64.175,
															461.105
														],
														[
															91,
															526
														],
														[
															92.483,
															529.473
														],
														[
															94,
															533
														],
														[
															95.972,
															535.484
														],
														[
															98,
															538
														],
														[
															100.141,
															542.51
														],
														[
															102,
															546
														],
														[
															102.545,
															546.879
														],
														[
															103,
															548
														],
														[
															109.93,
															558.43
														],
														[
															117,
															568
														],
														[
															119.015,
															571.056
														],
														[
															121,
															574
														],
														[
															123.523,
															576.55
														],
														[
															126,
															579
														],
														[
															129.993,
															584.604
														],
														[
															134,
															590
														],
														[
															136.866,
															592.952
														],
														[
															139,
															596
														],
														[
															141,
															597
														],
														[
															179,
															632
														],
														[
															184,
															637
														],
														[
															187,
															638
														],
														[
															189,
															641
														],
														[
															191,
															641
														],
														[
															192,
															643
														],
														[
															194,
															643
														],
														[
															195,
															645
														],
														[
															197,
															645
														],
														[
															198,
															647
														],
														[
															200,
															647
														],
														[
															201,
															649
														],
														[
															203,
															649
														],
														[
															204,
															651
														],
														[
															206,
															651
														],
														[
															207,
															653
														],
														[
															213,
															656
														],
														[
															226,
															663
														],
														[
															232,
															667
														],
														[
															239,
															669
														],
														[
															245,
															673
														],
														[
															266,
															681
														],
														[
															304,
															692
														],
														[
															326,
															697
														],
														[
															329,
															702
														],
														[
															338,
															709
														],
														[
															359,
															709
														],
														[
															418,
															705
														],
														[
															498,
															678
														],
														[
															509,
															673
														],
														[
															512,
															670
														],
														[
															519,
															667
														],
														[
															527,
															662
														],
														[
															528,
															660
														],
														[
															532,
															658
														],
														[
															544,
															649
														],
														[
															552,
															644
														],
														[
															553,
															642
														],
														[
															559,
															637
														],
														[
															563,
															635
														],
														[
															579,
															619
														],
														[
															592,
															606
														],
														[
															594,
															602
														],
														[
															597,
															600
														],
														[
															599,
															596
														],
														[
															602,
															594
														],
														[
															604,
															590
														],
														[
															609,
															585
														],
														[
															618,
															572
														],
														[
															652,
															509
														],
														[
															680,
															326
														],
														[
															666,
															254
														],
														[
															655,
															222
														],
														[
															544,
															75
														],
														[
															490,
															43
														],
														[
															426,
															21
														],
														[
															345,
															15
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 60,
											"s": [
												{
													"i": [
														[
															-0.112,
															0.008
														],
														[
															5.989,
															-0.611
														],
														[
															5.868,
															-1.127
														],
														[
															17.798,
															-8.008
														],
														[
															14.286,
															-9.835
														],
														[
															8.518,
															-7.356
														],
														[
															7.314,
															-7.957
														],
														[
															0.851,
															-0.814
														],
														[
															0.826,
															-0.907
														],
														[
															0.602,
															-1.049
														],
														[
															0.774,
															-0.906
														],
														[
															1.551,
															-1.637
														],
														[
															1.303,
															-1.703
														],
														[
															7.017,
															-11.454
														],
														[
															5.147,
															-12.009
														],
														[
															1.683,
															-4.002
														],
														[
															1.523,
															-3.919
														],
														[
															2.09,
															-6.214
														],
														[
															1.428,
															-5.454
														],
														[
															1.485,
															-8.193
														],
														[
															1.043,
															-8.526
														],
														[
															-3.227,
															-28.813
														],
														[
															-7.816,
															-23.283
														],
														[
															-5.118,
															-11.158
														],
														[
															-5.504,
															-9.385
														],
														[
															-0.738,
															-1.367
														],
														[
															-0.385,
															-0.402
														],
														[
															-0.298,
															-0.539
														],
														[
															-0.407,
															-0.425
														],
														[
															-0.786,
															-1.178
														],
														[
															-0.768,
															-1.15
														],
														[
															-2.385,
															-3.476
														],
														[
															-2.166,
															-2.655
														],
														[
															-1.852,
															-2.174
														],
														[
															-1.684,
															-1.965
														],
														[
															-0.861,
															-0.801
														],
														[
															-0.769,
															-0.877
														],
														[
															-0.074,
															-0.525
														],
														[
															-0.338,
															-0.483
														],
														[
															-0.591,
															-0.3
														],
														[
															-0.347,
															-0.387
														],
														[
															-5.921,
															-5.157
														],
														[
															-1.815,
															-1.588
														],
														[
															-0.966,
															-0.675
														],
														[
															-0.819,
															-0.654
														],
														[
															-3.209,
															-2.394
														],
														[
															-3.258,
															-2.292
														],
														[
															-0.5,
															-0.225
														],
														[
															-0.37,
															-0.247
														],
														[
															-0.511,
															-0.23
														],
														[
															-0.38,
															-0.246
														],
														[
															-1.791,
															-1.062
														],
														[
															-20.812,
															-7.112
														],
														[
															-4.157,
															-1.177
														],
														[
															-5.289,
															-1.245
														],
														[
															-2.625,
															-0.523
														],
														[
															-2.622,
															-2.4
														],
														[
															-0.395,
															-0.516
														],
														[
															-0.507,
															-0.516
														],
														[
															-5.995,
															-1.39
														],
														[
															-6.586,
															-0.245
														],
														[
															-6.262,
															0.384
														],
														[
															-11.563,
															2.182
														],
														[
															-14.696,
															5.68
														],
														[
															-5.122,
															2.296
														],
														[
															-2.959,
															1.673
														],
														[
															-1.317,
															0.704
														],
														[
															-4.461,
															2.65
														],
														[
															-7.864,
															6.017
														],
														[
															-13.096,
															14.381
														],
														[
															-1.447,
															1.698
														],
														[
															-0.73,
															0.851
														],
														[
															-1.08,
															1.266
														],
														[
															-2.987,
															3.989
														],
														[
															-10.663,
															22.674
														],
														[
															-1.217,
															2.834
														],
														[
															-1.002,
															2.44
														],
														[
															-0.918,
															2.443
														],
														[
															-0.375,
															0.984
														],
														[
															-0.907,
															2.311
														],
														[
															-2.509,
															9.96
														],
														[
															-1.23,
															5.727
														],
														[
															-1.489,
															12.568
														],
														[
															-0.073,
															13.592
														],
														[
															10.182,
															34.067
														],
														[
															0.924,
															2.793
														],
														[
															2.104,
															5.499
														],
														[
															4.288,
															9.118
														],
														[
															5.29,
															8.716
														],
														[
															62.913,
															26.51
														],
														[
															49.706,
															-2.92
														]
													],
													"o": [
														[
															-6.175,
															0.428
														],
														[
															-5.989,
															0.611
														],
														[
															-21.524,
															4.133
														],
														[
															-17.798,
															8.008
														],
														[
															-9.614,
															6.62
														],
														[
															-8.518,
															7.356
														],
														[
															-0.769,
															0.836
														],
														[
															-0.851,
															0.814
														],
														[
															-0.816,
															0.896
														],
														[
															-0.603,
															1.049
														],
														[
															-1.493,
															1.748
														],
														[
															-1.551,
															1.637
														],
														[
															-7.785,
															10.174
														],
														[
															-7.017,
															11.454
														],
														[
															-1.746,
															4.075
														],
														[
															-1.683,
															4.001
														],
														[
															-2.212,
															5.689
														],
														[
															-2.09,
															6.214
														],
														[
															-2.017,
															7.703
														],
														[
															-1.485,
															8.193
														],
														[
															-3.725,
															30.465
														],
														[
															3.227,
															28.813
														],
														[
															4.023,
															11.985
														],
														[
															5.118,
															11.158
														],
														[
															0.662,
															1.13
														],
														[
															0.738,
															1.367
														],
														[
															0.401,
															0.419
														],
														[
															0.298,
															0.539
														],
														[
															1.089,
															1.137
														],
														[
															0.786,
															1.178
														],
														[
															2.295,
															3.439
														],
														[
															2.385,
															3.476
														],
														[
															1.908,
															2.339
														],
														[
															1.852,
															2.174
														],
														[
															0.786,
															0.918
														],
														[
															0.861,
															0.801
														],
														[
															0.365,
															0.416
														],
														[
															0.074,
															0.525
														],
														[
															0.288,
															0.413
														],
														[
															0.591,
															0.3
														],
														[
															5.851,
															6.503
														],
														[
															1.725,
															1.502
														],
														[
															0.833,
															0.729
														],
														[
															0.833,
															0.582
														],
														[
															3.725,
															2.977
														],
														[
															3.808,
															2.841
														],
														[
															0.442,
															0.311
														],
														[
															0.324,
															0.146
														],
														[
															0.46,
															0.307
														],
														[
															0.33,
															0.149
														],
														[
															1.728,
															1.117
														],
														[
															18.097,
															10.726
														],
														[
															5.135,
															1.755
														],
														[
															4.834,
															1.368
														],
														[
															2.612,
															0.615
														],
														[
															5.013,
															0.999
														],
														[
															0.496,
															0.454
														],
														[
															0.396,
															0.517
														],
														[
															3.109,
															3.168
														],
														[
															4.901,
															1.136
														],
														[
															7.348,
															0.273
														],
														[
															13.294,
															-0.816
														],
														[
															17.771,
															-3.354
														],
														[
															5.214,
															-2.015
														],
														[
															3.853,
															-1.727
														],
														[
															1.354,
															-0.765
														],
														[
															4.744,
															-2.535
														],
														[
															8.874,
															-5.272
														],
														[
															16.472,
															-12.604
														],
														[
															1.463,
															-1.606
														],
														[
															0.719,
															-0.844
														],
														[
															1.037,
															-1.21
														],
														[
															3.305,
															-3.871
														],
														[
															14.852,
															-19.838
														],
														[
															1.226,
															-2.607
														],
														[
															1.034,
															-2.407
														],
														[
															0.958,
															-2.332
														],
														[
															0.259,
															-0.688
														],
														[
															1.396,
															-3.661
														],
														[
															3.733,
															-9.514
														],
														[
															1.431,
															-5.679
														],
														[
															2.498,
															-11.631
														],
														[
															1.58,
															-13.333
														],
														[
															0.244,
															-45.337
														],
														[
															-0.812,
															-2.718
														],
														[
															-1.862,
															-5.626
														],
														[
															-3.835,
															-10.022
														],
														[
															-4.678,
															-9.948
														],
														[
															-34.146,
															-56.265
														],
														[
															-33.971,
															-14.315
														],
														[
															-0.628,
															0.037
														]
													],
													"v": [
														[
															345,
															16
														],
														[
															326.769,
															17.476
														],
														[
															309,
															20
														],
														[
															250.071,
															38.724
														],
														[
															202,
															66
														],
														[
															174.775,
															86.997
														],
														[
															151,
															110
														],
														[
															148.543,
															112.447
														],
														[
															146,
															115
														],
														[
															143.969,
															117.992
														],
														[
															142,
															121
														],
														[
															137.358,
															126.033
														],
														[
															133,
															131
														],
														[
															110.521,
															163.624
														],
														[
															92,
															199
														],
														[
															86.833,
															211.117
														],
														[
															82,
															223
														],
														[
															75.413,
															241.176
														],
														[
															70,
															259
														],
														[
															64.769,
															282.883
														],
														[
															61,
															308
														],
														[
															60.844,
															397.887
														],
														[
															78,
															477
														],
														[
															91.89,
															511.95
														],
														[
															108,
															543
														],
														[
															110.208,
															547.046
														],
														[
															112,
															550
														],
														[
															112.995,
															551.495
														],
														[
															114,
															553
														],
														[
															116.74,
															556.49
														],
														[
															119,
															560
														],
														[
															126.097,
															570.588
														],
														[
															133,
															580
														],
														[
															138.668,
															586.781
														],
														[
															144,
															593
														],
														[
															146.513,
															595.531
														],
														[
															149,
															598
														],
														[
															149.521,
															599.45
														],
														[
															150,
															601
														],
														[
															151.455,
															602.02
														],
														[
															153,
															603
														],
														[
															172,
															622
														],
														[
															177,
															627
														],
														[
															180,
															628
														],
														[
															182,
															631
														],
														[
															193,
															639
														],
														[
															204,
															648
														],
														[
															206,
															648
														],
														[
															207,
															650
														],
														[
															209,
															650
														],
														[
															210,
															652
														],
														[
															216,
															655
														],
														[
															275,
															683
														],
														[
															289,
															688
														],
														[
															305,
															691
														],
														[
															313,
															693
														],
														[
															327,
															697
														],
														[
															328,
															700
														],
														[
															330,
															702
														],
														[
															339,
															709
														],
														[
															359,
															710
														],
														[
															379,
															709
														],
														[
															417,
															705
														],
														[
															466,
															691
														],
														[
															481,
															684
														],
														[
															492,
															680
														],
														[
															495,
															677
														],
														[
															509,
															670
														],
														[
															534,
															653
														],
														[
															579,
															613
														],
														[
															583,
															607
														],
														[
															586,
															605
														],
														[
															588,
															601
														],
														[
															598,
															590
														],
														[
															637,
															524
														],
														[
															640,
															516
														],
														[
															644,
															509
														],
														[
															646,
															501
														],
														[
															648,
															498
														],
														[
															651,
															490
														],
														[
															659,
															461
														],
														[
															664,
															444
														],
														[
															669,
															407
														],
														[
															672,
															367
														],
														[
															655,
															248
														],
														[
															652,
															240
														],
														[
															647,
															223
														],
														[
															634,
															194
														],
														[
															619,
															166
														],
														[
															473,
															37
														],
														[
															346,
															15
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 61,
											"s": [
												{
													"i": [
														[
															-0.109,
															0.008
														],
														[
															10.404,
															-1.996
														],
														[
															9.607,
															-3.145
														],
														[
															4.24,
															-1.596
														],
														[
															3.069,
															-1.316
														],
														[
															5.417,
															-2.779
														],
														[
															4.034,
															-2.614
														],
														[
															2.397,
															-1.518
														],
														[
															1.918,
															-1.312
														],
														[
															4.438,
															-3.47
														],
														[
															4.317,
															-3.746
														],
														[
															4.125,
															-3.876
														],
														[
															3.28,
															-3.835
														],
														[
															0.861,
															-0.801
														],
														[
															0.769,
															-0.877
														],
														[
															1.705,
															-2.368
														],
														[
															1.419,
															-1.517
														],
														[
															0.644,
															-0.87
														],
														[
															0.563,
															-0.602
														],
														[
															2.414,
															-3.386
														],
														[
															1.774,
															-2.709
														],
														[
															5.106,
															-9.522
														],
														[
															3.977,
															-9.362
														],
														[
															0.535,
															-0.974
														],
														[
															0.413,
															-1.049
														],
														[
															0.255,
															-1.368
														],
														[
															0.496,
															-1.3
														],
														[
															1.731,
															-4.462
														],
														[
															1.411,
															-4.788
														],
														[
															2.642,
															-16.714
														],
														[
															0.094,
															-17.428
														],
														[
															-0.624,
															-11.755
														],
														[
															-1.573,
															-10.949
														],
														[
															-5.093,
															-16.456
														],
														[
															-6.022,
															-14.051
														],
														[
															-2.83,
															-5.586
														],
														[
															-2.255,
															-5.001
														],
														[
															-0.451,
															-0.156
														],
														[
															-0.12,
															-0.202
														],
														[
															-0.427,
															-1.22
														],
														[
															-0.676,
															-1.082
														],
														[
															-1.392,
															-1.806
														],
														[
															-1.213,
															-1.823
														],
														[
															-0.427,
															-1.032
														],
														[
															-0.629,
															-0.877
														],
														[
															-0.904,
															-0.772
														],
														[
															-0.707,
															-0.968
														],
														[
															-0.441,
															-1.077
														],
														[
															-0.611,
															-0.839
														],
														[
															-0.376,
															-0.34
														],
														[
															-0.276,
															-0.338
														],
														[
															-1.81,
															-2.122
														],
														[
															-1.851,
															-2.168
														],
														[
															-4.688,
															-4.866
														],
														[
															-4.769,
															-4.291
														],
														[
															-5.261,
															-4.109
														],
														[
															-5.757,
															-3.888
														],
														[
															-5.907,
															-3.619
														],
														[
															-5.8,
															-2.762
														],
														[
															-1.237,
															-0.266
														],
														[
															-1.046,
															-0.459
														],
														[
															-0.939,
															-0.759
														],
														[
															-1.083,
															-0.457
														],
														[
															-2.265,
															-0.88
														],
														[
															-7.157,
															-2.113
														],
														[
															-5.067,
															-1.193
														],
														[
															-2.194,
															-0.472
														],
														[
															-2.054,
															-0.92
														],
														[
															-2.245,
															-2.637
														],
														[
															-1.134,
															-1.134
														],
														[
															-0.4,
															-0.133
														],
														[
															-8.115,
															-0.343
														],
														[
															-6.399,
															0.376
														],
														[
															-11.556,
															2.302
														],
														[
															-30.354,
															23.737
														],
														[
															-7.159,
															6.878
														],
														[
															-6.532,
															7.62
														],
														[
															-4.052,
															5.858
														],
														[
															-0.723,
															0.99
														],
														[
															-1.321,
															1.878
														],
														[
															-0.225,
															0.5
														],
														[
															-0.245,
															0.381
														],
														[
															-0.735,
															1.135
														],
														[
															-10.686,
															35.787
														],
														[
															0,
															40.08
														],
														[
															30.225,
															52.438
														],
														[
															11.545,
															12.222
														],
														[
															0.865,
															1.027
														],
														[
															3.17,
															3.38
														],
														[
															33.003,
															16.568
														],
														[
															54.779,
															-3.506
														]
													],
													"o": [
														[
															-11.776,
															0.871
														],
														[
															-10.404,
															1.996
														],
														[
															-3.969,
															1.3
														],
														[
															-4.241,
															1.596
														],
														[
															-5.298,
															2.271
														],
														[
															-5.417,
															2.779
														],
														[
															-2.493,
															1.615
														],
														[
															-2.398,
															1.518
														],
														[
															-4.931,
															3.374
														],
														[
															-4.438,
															3.47
														],
														[
															-4.221,
															3.662
														],
														[
															-4.125,
															3.876
														],
														[
															-0.786,
															0.919
														],
														[
															-0.861,
															0.801
														],
														[
															-1.759,
															2.008
														],
														[
															-1.705,
															2.368
														],
														[
															-0.859,
															0.918
														],
														[
															-0.645,
															0.87
														],
														[
															-2.569,
															2.746
														],
														[
															-2.414,
															3.386
														],
														[
															-5.599,
															8.55
														],
														[
															-5.106,
															9.522
														],
														[
															-0.448,
															1.055
														],
														[
															-0.535,
															0.974
														],
														[
															-0.483,
															1.227
														],
														[
															-0.255,
															1.368
														],
														[
															-1.667,
															4.364
														],
														[
															-1.73,
															4.462
														],
														[
															-4.337,
															14.717
														],
														[
															-2.642,
															16.714
														],
														[
															-0.07,
															13.029
														],
														[
															0.624,
															11.755
														],
														[
															2.606,
															18.126
														],
														[
															5.093,
															16.456
														],
														[
															2.424,
															5.657
														],
														[
															2.83,
															5.586
														],
														[
															0.078,
															0.173
														],
														[
															0.451,
															0.156
														],
														[
															0.617,
															1.04
														],
														[
															0.427,
															1.22
														],
														[
															1.221,
															1.952
														],
														[
															1.392,
															1.806
														],
														[
															0.661,
															0.995
														],
														[
															0.427,
															1.032
														],
														[
															0.676,
															0.942
														],
														[
															0.904,
															0.773
														],
														[
															0.624,
															0.854
														],
														[
															0.441,
															1.077
														],
														[
															0.219,
															0.302
														],
														[
															0.376,
															0.34
														],
														[
															1.911,
															2.343
														],
														[
															1.81,
															2.122
														],
														[
															4.478,
															5.245
														],
														[
															4.688,
															4.866
														],
														[
															5.2,
															4.678
														],
														[
															5.261,
															4.109
														],
														[
															5.572,
															3.763
														],
														[
															5.907,
															3.619
														],
														[
															1.005,
															0.478
														],
														[
															1.237,
															0.266
														],
														[
															1.159,
															0.509
														],
														[
															0.939,
															0.758
														],
														[
															2.052,
															0.866
														],
														[
															7.103,
															2.761
														],
														[
															4.828,
															1.425
														],
														[
															2.356,
															0.554
														],
														[
															3.258,
															0.702
														],
														[
															4.052,
															1.814
														],
														[
															1.768,
															2.077
														],
														[
															0.282,
															0.282
														],
														[
															5.133,
															1.711
														],
														[
															6.652,
															0.281
														],
														[
															13.676,
															-0.803
														],
														[
															47.723,
															-9.507
														],
														[
															8.086,
															-6.324
														],
														[
															7.027,
															-6.751
														],
														[
															5.229,
															-6.1
														],
														[
															0.754,
															-1.09
														],
														[
															1.35,
															-1.848
														],
														[
															0.311,
															-0.442
														],
														[
															0.149,
															-0.331
														],
														[
															0.82,
															-1.275
														],
														[
															18.907,
															-29.197
														],
														[
															9.773,
															-32.727
														],
														[
															0,
															-81.901
														],
														[
															-9.209,
															-15.976
														],
														[
															-1.065,
															-1.127
														],
														[
															-2.804,
															-3.329
														],
														[
															-24.318,
															-25.931
														],
														[
															-36.707,
															-18.427
														],
														[
															-0.627,
															0.04
														]
													],
													"v": [
														[
															345,
															16
														],
														[
															311.873,
															20.294
														],
														[
															282,
															28
														],
														[
															269.325,
															32.488
														],
														[
															258,
															37
														],
														[
															241.551,
															44.743
														],
														[
															227,
															53
														],
														[
															219.569,
															57.727
														],
														[
															213,
															62
														],
														[
															199.04,
															72.221
														],
														[
															186,
															83
														],
														[
															173.295,
															94.37
														],
														[
															162,
															106
														],
														[
															159.487,
															108.531
														],
														[
															157,
															111
														],
														[
															151.745,
															117.868
														],
														[
															147,
															124
														],
														[
															144.778,
															126.737
														],
														[
															143,
															129
														],
														[
															135.404,
															138.528
														],
														[
															129,
															148
														],
														[
															112.784,
															175.391
														],
														[
															99,
															204
														],
														[
															97.474,
															207.005
														],
														[
															96,
															210
														],
														[
															95.01,
															213.945
														],
														[
															94,
															218
														],
														[
															88.808,
															231.182
														],
														[
															84,
															245
														],
														[
															73.317,
															292.467
														],
														[
															69,
															344
														],
														[
															69.767,
															381.06
														],
														[
															73,
															415
														],
														[
															84.938,
															467.057
														],
														[
															102,
															513
														],
														[
															110.127,
															529.992
														],
														[
															118,
															546
														],
														[
															118.968,
															546.478
														],
														[
															120,
															547
														],
														[
															121.455,
															550.469
														],
														[
															123,
															554
														],
														[
															127.006,
															559.597
														],
														[
															131,
															565
														],
														[
															132.524,
															568.088
														],
														[
															134,
															571
														],
														[
															136.477,
															573.48
														],
														[
															139,
															576
														],
														[
															140.51,
															579.011
														],
														[
															142,
															582
														],
														[
															142.958,
															582.973
														],
														[
															144,
															584
														],
														[
															149.546,
															590.632
														],
														[
															155,
															597
														],
														[
															168.782,
															612.216
														],
														[
															183,
															626
														],
														[
															198.582,
															639.093
														],
														[
															215,
															651
														],
														[
															232.329,
															662.251
														],
														[
															250,
															672
														],
														[
															253.47,
															673.015
														],
														[
															257,
															674
														],
														[
															260.057,
															676.038
														],
														[
															263,
															678
														],
														[
															270,
															680
														],
														[
															291,
															688
														],
														[
															307,
															691
														],
														[
															314,
															693
														],
														[
															324,
															695
														],
														[
															331,
															702
														],
														[
															334,
															708
														],
														[
															336,
															708
														],
														[
															358,
															710
														],
														[
															378,
															709
														],
														[
															416,
															705
														],
														[
															529,
															652
														],
														[
															552,
															633
														],
														[
															572,
															611
														],
														[
															588,
															592
														],
														[
															590,
															588
														],
														[
															595,
															583
														],
														[
															595,
															581
														],
														[
															597,
															580
														],
														[
															599,
															576
														],
														[
															645,
															477
														],
														[
															661,
															367
														],
														[
															611,
															168
														],
														[
															579,
															122
														],
														[
															577,
															118
														],
														[
															567,
															108
														],
														[
															484,
															44
														],
														[
															346,
															15
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 62,
											"s": [
												{
													"i": [
														[
															-0.106,
															0.008
														],
														[
															10.35,
															-2.16
														],
														[
															9.824,
															-3.44
														],
														[
															18.032,
															-12.788
														],
														[
															14.435,
															-15.641
														],
														[
															3.226,
															-4
														],
														[
															2.767,
															-3.392
														],
														[
															1.755,
															-2.571
														],
														[
															1.071,
															-2.376
														],
														[
															0.451,
															-0.163
														],
														[
															0.124,
															-0.185
														],
														[
															-0.067,
															-0.379
														],
														[
															0.115,
															-0.255
														],
														[
															0.451,
															-0.161
														],
														[
															0.123,
															-0.19
														],
														[
															0.487,
															-1.071
														],
														[
															0.519,
															-0.89
														],
														[
															0.858,
															-1.355
														],
														[
															0.639,
															-0.986
														],
														[
															0.786,
															-1.713
														],
														[
															0.803,
															-1.521
														],
														[
															6.561,
															-17.997
														],
														[
															3.946,
															-21.332
														],
														[
															1.118,
															-11.431
														],
														[
															0.483,
															-11.227
														],
														[
															-0.264,
															-0.389
														],
														[
															0.027,
															-0.809
														],
														[
															0.001,
															-2.148
														],
														[
															-0.059,
															-1.784
														],
														[
															0.276,
															-0.099
														],
														[
															-0.103,
															-0.515
														],
														[
															-0.212,
															-1.076
														],
														[
															-0.032,
															-1.089
														],
														[
															-1.535,
															-12.448
														],
														[
															-2.454,
															-11.478
														],
														[
															-1.381,
															-4.823
														],
														[
															-1.373,
															-4.546
														],
														[
															-10.78,
															-20.159
														],
														[
															-13.331,
															-16.369
														],
														[
															-2.217,
															-2.308
														],
														[
															-1.951,
															-2.09
														],
														[
															-0.603,
															-1.069
														],
														[
															-0.805,
															-0.885
														],
														[
															-0.903,
															-0.647
														],
														[
															-0.718,
															-0.674
														],
														[
															-2.337,
															-2.434
														],
														[
															-2.238,
															-1.997
														],
														[
															-0.526,
															-0.074
														],
														[
															-0.483,
															-0.337
														],
														[
															-0.293,
															-0.596
														],
														[
															-0.409,
															-0.327
														],
														[
															-2.801,
															-1.929
														],
														[
															-1.582,
															-1.516
														],
														[
															-1.158,
															-0.764
														],
														[
															-1.197,
															-0.822
														],
														[
															-1.787,
															-1.117
														],
														[
															-1.861,
															-1.167
														],
														[
															-6.358,
															-3.259
														],
														[
															-5.959,
															-2.449
														],
														[
															-3.476,
															-1.108
														],
														[
															-3.743,
															-1.19
														],
														[
															-1.857,
															-0.413
														],
														[
															-3.909,
															-0.924
														],
														[
															-2.154,
															-2.348
														],
														[
															-0.009,
															-0.016
														],
														[
															-0.928,
															-0.891
														],
														[
															-3.263,
															-0.967
														],
														[
															-13.094,
															0.794
														],
														[
															-11.11,
															2.283
														],
														[
															-17.619,
															9.733
														],
														[
															-0.999,
															0.957
														],
														[
															-2.26,
															1.316
														],
														[
															-1.008,
															0.675
														],
														[
															-1.765,
															1.276
														],
														[
															-0.495,
															0.223
														],
														[
															-0.37,
															0.247
														],
														[
															-0.511,
															0.23
														],
														[
															-0.335,
															0.249
														],
														[
															-3.844,
															3.114
														],
														[
															-22.408,
															59.354
														],
														[
															0,
															51.655
														],
														[
															47.59,
															59.873
														],
														[
															28.529,
															17.462
														],
														[
															2.945,
															1.665
														],
														[
															1.092,
															0.584
														],
														[
															4.123,
															1.618
														],
														[
															1.484,
															0.635
														],
														[
															2.489,
															0.999
														],
														[
															2.75,
															0.978
														],
														[
															12.879,
															2.191
														],
														[
															20.158,
															-1.39
														]
													],
													"o": [
														[
															-11.775,
															0.921
														],
														[
															-10.35,
															2.16
														],
														[
															-23.438,
															8.207
														],
														[
															-18.032,
															12.788
														],
														[
															-3.329,
															3.606
														],
														[
															-3.226,
															4
														],
														[
															-1.909,
															2.341
														],
														[
															-1.755,
															2.571
														],
														[
															-0.073,
															0.162
														],
														[
															-0.451,
															0.163
														],
														[
															-0.154,
															0.23
														],
														[
															0.067,
															0.379
														],
														[
															-0.075,
															0.165
														],
														[
															-0.451,
															0.161
														],
														[
															-0.534,
															0.826
														],
														[
															-0.487,
															1.071
														],
														[
															-0.929,
															1.593
														],
														[
															-0.858,
															1.355
														],
														[
															-1.053,
															1.625
														],
														[
															-0.786,
															1.714
														],
														[
															-8.809,
															16.681
														],
														[
															-6.561,
															17.997
														],
														[
															-2.044,
															11.05
														],
														[
															-1.118,
															11.431
														],
														[
															-0.028,
															0.634
														],
														[
															0.264,
															0.389
														],
														[
															-0.054,
															1.625
														],
														[
															-0.001,
															2.148
														],
														[
															0.003,
															0.087
														],
														[
															-0.277,
															0.099
														],
														[
															0.121,
															0.607
														],
														[
															0.212,
															1.076
														],
														[
															0.404,
															13.729
														],
														[
															1.535,
															12.448
														],
														[
															1.103,
															5.163
														],
														[
															1.381,
															4.823
														],
														[
															7.548,
															24.995
														],
														[
															10.78,
															20.159
														],
														[
															2.183,
															2.68
														],
														[
															2.217,
															2.308
														],
														[
															0.783,
															0.839
														],
														[
															0.603,
															1.069
														],
														[
															0.673,
															0.738
														],
														[
															0.902,
															0.647
														],
														[
															2.413,
															2.265
														],
														[
															2.337,
															2.434
														],
														[
															0.413,
															0.369
														],
														[
															0.526,
															0.074
														],
														[
															0.416,
															0.291
														],
														[
															0.294,
															0.596
														],
														[
															2.214,
															1.769
														],
														[
															2.801,
															1.929
														],
														[
															1.173,
															1.124
														],
														[
															1.158,
															0.764
														],
														[
															1.99,
															1.366
														],
														[
															1.787,
															1.117
														],
														[
															5.61,
															3.516
														],
														[
															6.358,
															3.259
														],
														[
															3.352,
															1.378
														],
														[
															3.476,
															1.108
														],
														[
															2.957,
															0.94
														],
														[
															5.465,
															1.214
														],
														[
															4.891,
															1.156
														],
														[
															0.132,
															0.144
														],
														[
															1.257,
															2.263
														],
														[
															2.324,
															2.231
														],
														[
															9.871,
															2.925
														],
														[
															13.211,
															-0.801
														],
														[
															24.906,
															-5.118
														],
														[
															2.538,
															-1.402
														],
														[
															2.485,
															-2.381
														],
														[
															1.256,
															-0.731
														],
														[
															1.94,
															-1.299
														],
														[
															0.433,
															-0.313
														],
														[
															0.324,
															-0.146
														],
														[
															0.46,
															-0.307
														],
														[
															0.302,
															-0.136
														],
														[
															4.178,
															-3.102
														],
														[
															45.636,
															-36.968
														],
														[
															15.196,
															-40.252
														],
														[
															0,
															-107.312
														],
														[
															-20.689,
															-26.029
														],
														[
															-3.402,
															-2.082
														],
														[
															-1.262,
															-0.713
														],
														[
															-5.054,
															-2.705
														],
														[
															-1.555,
															-0.61
														],
														[
															-2.471,
															-1.058
														],
														[
															-2.532,
															-1.016
														],
														[
															-12.214,
															-4.344
														],
														[
															-17.864,
															-3.039
														],
														[
															-0.625,
															0.043
														]
													],
													"v": [
														[
															345,
															16
														],
														[
															312.036,
															20.611
														],
														[
															282,
															29
														],
														[
															220.247,
															60.925
														],
														[
															172,
															104
														],
														[
															162.079,
															115.661
														],
														[
															153,
															127
														],
														[
															147.371,
															134.474
														],
														[
															143,
															142
														],
														[
															142.038,
															142.483
														],
														[
															141,
															143
														],
														[
															140.971,
															143.981
														],
														[
															141,
															145
														],
														[
															140.036,
															145.481
														],
														[
															139,
															146
														],
														[
															137.489,
															148.952
														],
														[
															136,
															152
														],
														[
															133.282,
															156.455
														],
														[
															131,
															160
														],
														[
															128.312,
															165.078
														],
														[
															126,
															170
														],
														[
															102.852,
															221.512
														],
														[
															87,
															280
														],
														[
															82.329,
															313.868
														],
														[
															80,
															348
														],
														[
															80.5,
															349.369
														],
														[
															81,
															351
														],
														[
															80.915,
															356.881
														],
														[
															81,
															363
														],
														[
															80.425,
															363.179
														],
														[
															80,
															364
														],
														[
															80.567,
															366.639
														],
														[
															81,
															370
														],
														[
															83.962,
															409.188
														],
														[
															90,
															445
														],
														[
															93.798,
															459.962
														],
														[
															98,
															474
														],
														[
															125.663,
															541.47
														],
														[
															162,
															596
														],
														[
															168.674,
															603.442
														],
														[
															175,
															610
														],
														[
															176.983,
															612.966
														],
														[
															179,
															616
														],
														[
															181.466,
															618.048
														],
														[
															184,
															620
														],
														[
															191.132,
															627.201
														],
														[
															198,
															634
														],
														[
															199.448,
															634.524
														],
														[
															201,
															635
														],
														[
															202.005,
															636.473
														],
														[
															203,
															638
														],
														[
															210.974,
															643.69
														],
														[
															218,
															649
														],
														[
															221.482,
															651.727
														],
														[
															225,
															654
														],
														[
															230.597,
															657.65
														],
														[
															236,
															661
														],
														[
															254.238,
															671.301
														],
														[
															273,
															680
														],
														[
															283.207,
															683.64
														],
														[
															294,
															687
														],
														[
															304,
															691
														],
														[
															316,
															693
														],
														[
															329,
															697
														],
														[
															330,
															699
														],
														[
															334,
															706
														],
														[
															340,
															708
														],
														[
															377,
															709
														],
														[
															414,
															705
														],
														[
															481,
															680
														],
														[
															489,
															676
														],
														[
															497,
															671
														],
														[
															501,
															669
														],
														[
															506,
															664
														],
														[
															508,
															664
														],
														[
															509,
															662
														],
														[
															511,
															662
														],
														[
															512,
															660
														],
														[
															524,
															651
														],
														[
															624,
															506
														],
														[
															649,
															367
														],
														[
															569,
															120
														],
														[
															494,
															52
														],
														[
															484,
															47
														],
														[
															481,
															44
														],
														[
															464,
															36
														],
														[
															460,
															35
														],
														[
															453,
															31
														],
														[
															445,
															29
														],
														[
															405,
															18
														],
														[
															346,
															15
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 63,
											"s": [
												{
													"i": [
														[
															-0.106,
															0.008
														],
														[
															10.073,
															-2.149
														],
														[
															9.479,
															-3.524
														],
														[
															14.608,
															-9.632
														],
														[
															11.903,
															-11.903
														],
														[
															2.803,
															-3.188
														],
														[
															2.757,
															-3.216
														],
														[
															1.063,
															-1.258
														],
														[
															0.731,
															-0.781
														],
														[
															0.61,
															-0.808
														],
														[
															0.64,
															-0.785
														],
														[
															1.588,
															-2.263
														],
														[
															1.592,
															-2.423
														],
														[
															0.713,
															-0.817
														],
														[
															0.577,
															-0.865
														],
														[
															11.137,
															-41.062
														],
														[
															-2.6,
															-50.682
														],
														[
															-2.792,
															-15.528
														],
														[
															-3.945,
															-13.593
														],
														[
															-3.37,
															-8.806
														],
														[
															-3.748,
															-8.22
														],
														[
															-4.34,
															-7.777
														],
														[
															-4.668,
															-7.179
														],
														[
															-0.271,
															-0.69
														],
														[
															-0.339,
															-0.353
														],
														[
															-0.779,
															-1.19
														],
														[
															-0.793,
															-1.102
														],
														[
															-1.364,
															-1.642
														],
														[
															-1.315,
															-1.721
														],
														[
															-0.083,
															-0.521
														],
														[
															-0.337,
															-0.481
														],
														[
															-0.596,
															-0.293
														],
														[
															-0.324,
															-0.412
														],
														[
															-0.081,
															-0.521
														],
														[
															-0.337,
															-0.483
														],
														[
															-0.594,
															-0.296
														],
														[
															-0.334,
															-0.402
														],
														[
															-1.3,
															-1.688
														],
														[
															-1.433,
															-1.606
														],
														[
															-13.987,
															-10.32
														],
														[
															-16.436,
															-7.706
														],
														[
															-1.983,
															-1.063
														],
														[
															-2.052,
															-0.803
														],
														[
															-2.354,
															-0.591
														],
														[
															-2.308,
															-0.746
														],
														[
															-0.983,
															-0.595
														],
														[
															-1.038,
															-0.288
														],
														[
															-2.447,
															-0.411
														],
														[
															-2.232,
															-0.528
														],
														[
															-1.421,
															-0.298
														],
														[
															-0.976,
															-0.49
														],
														[
															-0.562,
															0.104
														],
														[
															-0.365,
															-0.225
														],
														[
															-0.199,
															-0.702
														],
														[
															-0.099,
															-0.128
														],
														[
															-0.469,
															-0.638
														],
														[
															-0.647,
															-0.831
														],
														[
															-0.219,
															-0.928
														],
														[
															-0.458,
															-0.433
														],
														[
															-8.23,
															-0.303
														],
														[
															-5.969,
															0.407
														],
														[
															-19.356,
															7.271
														],
														[
															-9.331,
															5.514
														],
														[
															-10.19,
															8.315
														],
														[
															-5.168,
															5.025
														],
														[
															-18.881,
															53.637
														],
														[
															0,
															50.582
														],
														[
															26.322,
															52.354
														],
														[
															3.341,
															7.41
														],
														[
															0.242,
															0.397
														],
														[
															1.063,
															1.109
														],
														[
															0.815,
															0.85
														],
														[
															0.69,
															0.995
														],
														[
															1.28,
															1.771
														],
														[
															0.223,
															0.495
														],
														[
															0.247,
															0.37
														],
														[
															0.23,
															0.511
														],
														[
															0.249,
															0.33
														],
														[
															1.387,
															1.726
														],
														[
															1.03,
															2.285
														],
														[
															0.675,
															0.806
														],
														[
															1.471,
															1.681
														],
														[
															4.747,
															4.323
														],
														[
															1.717,
															1.533
														],
														[
															8.276,
															3.73
														],
														[
															1.096,
															0.755
														],
														[
															3.762,
															2.235
														],
														[
															1.008,
															0.966
														],
														[
															1.176,
															0.699
														],
														[
															7.529,
															3.168
														],
														[
															40.073,
															-2.763
														]
													],
													"o": [
														[
															-11.229,
															0.878
														],
														[
															-10.073,
															2.149
														],
														[
															-17.665,
															6.569
														],
														[
															-14.608,
															9.632
														],
														[
															-3.031,
															3.031
														],
														[
															-2.803,
															3.188
														],
														[
															-1.019,
															1.189
														],
														[
															-1.063,
															1.258
														],
														[
															-0.921,
															0.984
														],
														[
															-0.61,
															0.808
														],
														[
															-2.058,
															2.523
														],
														[
															-1.588,
															2.263
														],
														[
															-0.57,
															0.868
														],
														[
															-0.713,
															0.817
														],
														[
															-20.051,
															30.068
														],
														[
															-11.137,
															41.062
														],
														[
															0.888,
															17.297
														],
														[
															2.792,
															15.528
														],
														[
															2.773,
															9.554
														],
														[
															3.37,
															8.806
														],
														[
															3.972,
															8.712
														],
														[
															4.34,
															7.777
														],
														[
															0.576,
															0.886
														],
														[
															0.271,
															0.69
														],
														[
															1.091,
															1.139
														],
														[
															0.779,
															1.19
														],
														[
															1.23,
															1.709
														],
														[
															1.364,
															1.642
														],
														[
															0.332,
															0.436
														],
														[
															0.083,
															0.521
														],
														[
															0.291,
															0.417
														],
														[
															0.596,
															0.293
														],
														[
															0.34,
															0.432
														],
														[
															0.081,
															0.521
														],
														[
															0.291,
															0.416
														],
														[
															0.594,
															0.296
														],
														[
															1.365,
															1.641
														],
														[
															1.3,
															1.688
														],
														[
															11.615,
															13.014
														],
														[
															13.987,
															10.32
														],
														[
															2.014,
															0.945
														],
														[
															1.983,
															1.063
														],
														[
															2.276,
															0.891
														],
														[
															2.354,
															0.591
														],
														[
															1.03,
															0.333
														],
														[
															0.983,
															0.595
														],
														[
															2.981,
															0.829
														],
														[
															2.447,
															0.411
														],
														[
															1.339,
															0.317
														],
														[
															1.421,
															0.298
														],
														[
															0.385,
															0.193
														],
														[
															0.562,
															-0.104
														],
														[
															0.106,
															0.065
														],
														[
															0.199,
															0.702
														],
														[
															0.478,
															0.62
														],
														[
															0.469,
															0.637
														],
														[
															0.668,
															0.857
														],
														[
															0.219,
															0.928
														],
														[
															3.245,
															3.064
														],
														[
															6.48,
															0.238
														],
														[
															27.653,
															-1.886
														],
														[
															12.942,
															-4.861
														],
														[
															12.561,
															-7.422
														],
														[
															6.063,
															-4.947
														],
														[
															37.209,
															-36.179
														],
														[
															13.843,
															-39.326
														],
														[
															0,
															-76.965
														],
														[
															-4.164,
															-8.282
														],
														[
															-0.154,
															-0.341
														],
														[
															-1.443,
															-2.367
														],
														[
															-0.803,
															-0.838
														],
														[
															-0.742,
															-0.775
														],
														[
															-1.335,
															-1.926
														],
														[
															-0.313,
															-0.433
														],
														[
															-0.146,
															-0.324
														],
														[
															-0.307,
															-0.46
														],
														[
															-0.134,
															-0.298
														],
														[
															-1.451,
															-1.925
														],
														[
															-2.031,
															-2.529
														],
														[
															-0.48,
															-1.065
														],
														[
															-1.525,
															-1.82
														],
														[
															-4.893,
															-5.593
														],
														[
															-1.593,
															-1.451
														],
														[
															-7.2,
															-6.426
														],
														[
															-1.385,
															-0.624
														],
														[
															-4.112,
															-2.831
														],
														[
															-2.448,
															-1.455
														],
														[
															-0.854,
															-0.818
														],
														[
															-7.388,
															-4.39
														],
														[
															-27.773,
															-11.684
														],
														[
															-0.625,
															0.043
														]
													],
													"v": [
														[
															346,
															16
														],
														[
															314.188,
															20.515
														],
														[
															285,
															29
														],
														[
															236.678,
															53.5
														],
														[
															197,
															86
														],
														[
															188.295,
															95.361
														],
														[
															180,
															105
														],
														[
															176.784,
															108.806
														],
														[
															174,
															112
														],
														[
															171.79,
															114.65
														],
														[
															170,
															117
														],
														[
															164.65,
															124.075
														],
														[
															160,
															131
														],
														[
															158.005,
															133.503
														],
														[
															156,
															136
														],
														[
															108.012,
															243.039
														],
														[
															94,
															381
														],
														[
															99.707,
															430.278
														],
														[
															110,
															474
														],
														[
															119.269,
															501.501
														],
														[
															130,
															527
														],
														[
															142.478,
															551.65
														],
														[
															156,
															574
														],
														[
															157.178,
															576.4
														],
														[
															158,
															578
														],
														[
															160.723,
															581.527
														],
														[
															163,
															585
														],
														[
															166.936,
															589.991
														],
														[
															171,
															595
														],
														[
															171.497,
															596.466
														],
														[
															172,
															598
														],
														[
															173.476,
															599.004
														],
														[
															175,
															600
														],
														[
															175.502,
															601.462
														],
														[
															176,
															603
														],
														[
															177.467,
															604.01
														],
														[
															179,
															605
														],
														[
															182.949,
															610.027
														],
														[
															187,
															615
														],
														[
															225.385,
															649.982
														],
														[
															271,
															677
														],
														[
															276.972,
															680.106
														],
														[
															283,
															683
														],
														[
															289.976,
															685.109
														],
														[
															297,
															687
														],
														[
															299.994,
															688.533
														],
														[
															303,
															690
														],
														[
															311.061,
															691.725
														],
														[
															318,
															693
														],
														[
															322.272,
															693.87
														],
														[
															326,
															695
														],
														[
															327.515,
															694.976
														],
														[
															329,
															695
														],
														[
															329.505,
															696.453
														],
														[
															330,
															698
														],
														[
															331.373,
															699.842
														],
														[
															333,
															702
														],
														[
															334.157,
															704.818
														],
														[
															335,
															707
														],
														[
															359,
															710
														],
														[
															378,
															709
														],
														[
															444,
															695
														],
														[
															478,
															679
														],
														[
															513,
															654
														],
														[
															529,
															640
														],
														[
															613,
															504
														],
														[
															636,
															367
														],
														[
															592,
															171
														],
														[
															579,
															147
														],
														[
															577,
															146
														],
														[
															573,
															138
														],
														[
															571,
															135
														],
														[
															570,
															133
														],
														[
															565,
															128
														],
														[
															565,
															126
														],
														[
															563,
															125
														],
														[
															563,
															123
														],
														[
															561,
															122
														],
														[
															557,
															116
														],
														[
															552,
															109
														],
														[
															548,
															105
														],
														[
															543,
															100
														],
														[
															529,
															84
														],
														[
															523,
															80
														],
														[
															500,
															61
														],
														[
															496,
															57
														],
														[
															484,
															49
														],
														[
															476,
															45
														],
														[
															474,
															44
														],
														[
															451,
															32
														],
														[
															347,
															15
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 64,
											"s": [
												{
													"i": [
														[
															-0.052,
															0.004
														],
														[
															5.122,
															-0.805
														],
														[
															4.83,
															-1.162
														],
														[
															4.669,
															-1.526
														],
														[
															4.636,
															-1.898
														],
														[
															2.046,
															-0.861
														],
														[
															1.992,
															-0.893
														],
														[
															1.95,
															-0.96
														],
														[
															1.92,
															-1.064
														],
														[
															8.612,
															-6.592
														],
														[
															7.564,
															-7.475
														],
														[
															6.545,
															-8.021
														],
														[
															5.556,
															-8.228
														],
														[
															2.546,
															-4.185
														],
														[
															2.341,
															-4.275
														],
														[
															2.125,
															-4.328
														],
														[
															1.897,
															-4.343
														],
														[
															2.334,
															-5.93
														],
														[
															2.116,
															-6.102
														],
														[
															1.849,
															-6.246
														],
														[
															1.533,
															-6.362
														],
														[
															1.663,
															-10.418
														],
														[
															0.966,
															-10.991
														],
														[
															0.195,
															-11.202
														],
														[
															-0.649,
															-11.052
														],
														[
															-1.883,
															-13.049
														],
														[
															-2.827,
															-12.07
														],
														[
															-3.655,
															-11.111
														],
														[
															-4.369,
															-10.171
														],
														[
															-0.247,
															-0.392
														],
														[
															-0.269,
															-0.383
														],
														[
															-0.263,
															-0.424
														],
														[
															-0.228,
															-0.517
														],
														[
															-0.188,
															-0.8
														],
														[
															-0.198,
															-0.814
														],
														[
															-0.325,
															-0.71
														],
														[
															-2.765,
															-4.854
														],
														[
															-2.562,
															-4.391
														],
														[
															-21.873,
															-20.428
														],
														[
															-28.705,
															-10.912
														],
														[
															-3.209,
															-1.164
														],
														[
															-3.539,
															-0.965
														],
														[
															-3.359,
															-0.576
														],
														[
															-0.994,
															-0.994
														],
														[
															-1.247,
															-2.366
														],
														[
															-3.541,
															-1.065
														],
														[
															-3.273,
															-0.081
														],
														[
															-3.029,
															-0.111
														],
														[
															-3.203,
															0.227
														],
														[
															-2.919,
															0.212
														],
														[
															-14.91,
															4.7
														],
														[
															-11.887,
															6.861
														],
														[
															-0.828,
															0.746
														],
														[
															-0.787,
															0.496
														],
														[
															-0.375,
															-0.067
														],
														[
															-0.26,
															0.118
														],
														[
															-0.163,
															0.451
														],
														[
															-0.185,
															0.123
														],
														[
															-0.379,
															-0.067
														],
														[
															-0.255,
															0.115
														],
														[
															-0.163,
															0.451
														],
														[
															-0.185,
															0.123
														],
														[
															-0.379,
															-0.067
														],
														[
															-0.255,
															0.115
														],
														[
															-0.163,
															0.451
														],
														[
															-0.185,
															0.123
														],
														[
															-0.379,
															-0.067
														],
														[
															-0.255,
															0.115
														],
														[
															-0.166,
															0.451
														],
														[
															-0.178,
															0.124
														],
														[
															-0.961,
															0.605
														],
														[
															-1.061,
															0.813
														],
														[
															-14.316,
															18.175
														],
														[
															-10.76,
															21.758
														],
														[
															-4.057,
															9.924
														],
														[
															-2.308,
															10.278
														],
														[
															-0.768,
															1.843
														],
														[
															-0.56,
															1.981
														],
														[
															-2.925,
															20.162
														],
														[
															-0.235,
															22.419
														],
														[
															4.342,
															25.431
														],
														[
															6.93,
															20.644
														],
														[
															1.418,
															3.663
														],
														[
															1.139,
															2.815
														],
														[
															6.317,
															11.782
														],
														[
															7.398,
															10.701
														],
														[
															22.277,
															17.801
														],
														[
															29.055,
															8.335
														],
														[
															12.145,
															1.216
														],
														[
															12.714,
															-0.935
														],
														[
															0.185,
															-0.245
														]
													],
													"o": [
														[
															-5.543,
															0.455
														],
														[
															-5.122,
															0.805
														],
														[
															-4.83,
															1.162
														],
														[
															-4.669,
															1.526
														],
														[
															-2.113,
															0.865
														],
														[
															-2.046,
															0.861
														],
														[
															-1.992,
															0.893
														],
														[
															-1.95,
															0.96
														],
														[
															-9.689,
															5.37
														],
														[
															-8.612,
															6.592
														],
														[
															-7.564,
															7.475
														],
														[
															-6.545,
															8.021
														],
														[
															-2.74,
															4.057
														],
														[
															-2.546,
															4.185
														],
														[
															-2.341,
															4.275
														],
														[
															-2.125,
															4.328
														],
														[
															-2.504,
															5.731
														],
														[
															-2.334,
															5.93
														],
														[
															-2.116,
															6.102
														],
														[
															-1.849,
															6.246
														],
														[
															-2.286,
															9.485
														],
														[
															-1.663,
															10.418
														],
														[
															-0.966,
															10.991
														],
														[
															-0.195,
															11.202
														],
														[
															0.825,
															14.049
														],
														[
															1.883,
															13.049
														],
														[
															2.827,
															12.07
														],
														[
															3.655,
															11.111
														],
														[
															0.195,
															0.452
														],
														[
															0.247,
															0.392
														],
														[
															0.269,
															0.383
														],
														[
															0.263,
															0.424
														],
														[
															0.295,
															0.669
														],
														[
															0.188,
															0.8
														],
														[
															0.198,
															0.814
														],
														[
															2.379,
															5.192
														],
														[
															2.765,
															4.854
														],
														[
															14.803,
															25.376
														],
														[
															21.873,
															20.428
														],
														[
															3.626,
															1.379
														],
														[
															3.209,
															1.164
														],
														[
															2.572,
															0.701
														],
														[
															3.359,
															0.576
														],
														[
															2.471,
															2.471
														],
														[
															1.247,
															2.366
														],
														[
															1.88,
															0.565
														],
														[
															3.273,
															0.081
														],
														[
															3.268,
															0.12
														],
														[
															3.203,
															-0.227
														],
														[
															18.472,
															-1.337
														],
														[
															14.91,
															-4.7
														],
														[
															0.902,
															-0.521
														],
														[
															0.828,
															-0.746
														],
														[
															0.239,
															-0.15
														],
														[
															0.375,
															0.067
														],
														[
															0.162,
															-0.073
														],
														[
															0.163,
															-0.451
														],
														[
															0.23,
															-0.154
														],
														[
															0.379,
															0.067
														],
														[
															0.162,
															-0.073
														],
														[
															0.163,
															-0.451
														],
														[
															0.23,
															-0.154
														],
														[
															0.379,
															0.067
														],
														[
															0.162,
															-0.073
														],
														[
															0.163,
															-0.451
														],
														[
															0.23,
															-0.154
														],
														[
															0.379,
															0.067
														],
														[
															0.158,
															-0.071
														],
														[
															0.166,
															-0.451
														],
														[
															1.096,
															-0.766
														],
														[
															0.961,
															-0.605
														],
														[
															18.976,
															-14.541
														],
														[
															14.316,
															-18.175
														],
														[
															4.463,
															-9.025
														],
														[
															4.057,
															-9.924
														],
														[
															0.37,
															-1.647
														],
														[
															0.768,
															-1.843
														],
														[
															5.065,
															-17.934
														],
														[
															2.925,
															-20.162
														],
														[
															0.3,
															-28.634
														],
														[
															-4.342,
															-25.431
														],
														[
															-1.187,
															-3.534
														],
														[
															-1.418,
															-3.663
														],
														[
															-5.332,
															-13.171
														],
														[
															-6.317,
															-11.782
														],
														[
															-14.837,
															-21.461
														],
														[
															-22.277,
															-17.801
														],
														[
															-10.707,
															-3.072
														],
														[
															-12.145,
															-1.216
														],
														[
															-0.312,
															0.023
														],
														[
															-0.185,
															0.245
														]
													],
													"v": [
														[
															346,
															16
														],
														[
															330.036,
															17.888
														],
														[
															315.141,
															20.836
														],
														[
															300.925,
															24.866
														],
														[
															287,
															30
														],
														[
															280.764,
															32.58
														],
														[
															274.71,
															35.201
														],
														[
															268.801,
															37.972
														],
														[
															263,
															41
														],
														[
															235.556,
															59.028
														],
														[
															211.301,
															80.213
														],
														[
															190.145,
															103.542
														],
														[
															172,
															128
														],
														[
															164.069,
															140.372
														],
														[
															156.737,
															153.071
														],
														[
															150.036,
															165.985
														],
														[
															144,
															179
														],
														[
															136.731,
															196.499
														],
														[
															130.043,
															214.554
														],
														[
															124.085,
															233.082
														],
														[
															119,
															252
														],
														[
															113.059,
															281.945
														],
														[
															109.097,
															314.15
														],
														[
															107.337,
															347.529
														],
														[
															108,
															381
														],
														[
															112.091,
															421.642
														],
														[
															119.185,
															459.317
														],
														[
															128.936,
															494.083
														],
														[
															141,
															526
														],
														[
															141.669,
															527.254
														],
														[
															142.45,
															528.403
														],
														[
															143.256,
															529.6
														],
														[
															144,
															531
														],
														[
															144.695,
															533.233
														],
														[
															145.244,
															535.684
														],
														[
															146,
															538
														],
														[
															153.862,
															553.1
														],
														[
															162,
															567
														],
														[
															217.073,
															636.848
														],
														[
															293,
															685
														],
														[
															303.065,
															688.81
														],
														[
															313,
															692
														],
														[
															322.683,
															693.78
														],
														[
															330,
															696
														],
														[
															334.698,
															703.554
														],
														[
															341,
															709
														],
														[
															349.138,
															709.841
														],
														[
															359,
															710
														],
														[
															368.761,
															709.749
														],
														[
															378,
															709
														],
														[
															427.939,
															699.643
														],
														[
															468,
															682
														],
														[
															470.586,
															679.982
														],
														[
															473,
															678
														],
														[
															473.984,
															677.975
														],
														[
															475,
															678
														],
														[
															475.483,
															677.038
														],
														[
															476,
															676
														],
														[
															476.981,
															675.971
														],
														[
															478,
															676
														],
														[
															478.483,
															675.038
														],
														[
															479,
															674
														],
														[
															479.981,
															673.971
														],
														[
															481,
															674
														],
														[
															481.483,
															673.038
														],
														[
															482,
															672
														],
														[
															482.981,
															671.971
														],
														[
															484,
															672
														],
														[
															484.485,
															671.04
														],
														[
															485,
															670
														],
														[
															488.026,
															668.035
														],
														[
															491,
															666
														],
														[
															540.662,
															616.913
														],
														[
															578,
															557
														],
														[
															591.117,
															528.439
														],
														[
															601,
															498
														],
														[
															602.858,
															492.75
														],
														[
															605,
															487
														],
														[
															617.123,
															429.864
														],
														[
															622,
															366
														],
														[
															615.423,
															284.508
														],
														[
															598,
															215
														],
														[
															593.965,
															203.96
														],
														[
															590,
															194
														],
														[
															572.549,
															156.647
														],
														[
															552,
															123
														],
														[
															496.163,
															62.656
														],
														[
															419,
															22
														],
														[
															384.505,
															15.495
														],
														[
															347,
															15
														],
														[
															346.227,
															15.52
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 65,
											"s": [
												{
													"i": [
														[
															-0.103,
															0.008
														],
														[
															5.07,
															-0.792
														],
														[
															5.221,
															-1.381
														],
														[
															4.376,
															-1.507
														],
														[
															3.947,
															-1.767
														],
														[
															17.685,
															-17.145
														],
														[
															12.777,
															-20.465
														],
														[
															10.365,
															-48.194
														],
														[
															-6.8,
															-55.046
														],
														[
															-4.502,
															-18.285
														],
														[
															-6.339,
															-16.375
														],
														[
															-3.683,
															-7.742
														],
														[
															-3.175,
															-7.044
														],
														[
															-0.451,
															-0.153
														],
														[
															-0.117,
															-0.21
														],
														[
															-0.636,
															-1.385
														],
														[
															-0.593,
															-0.914
														],
														[
															-0.82,
															-1.315
														],
														[
															-0.755,
															-1.252
														],
														[
															-0.45,
															-1.028
														],
														[
															-0.613,
															-0.915
														],
														[
															-0.735,
															-0.619
														],
														[
															-0.54,
															-0.745
														],
														[
															-0.798,
															-1.404
														],
														[
															-0.75,
															-0.918
														],
														[
															-0.96,
															-1.331
														],
														[
															-0.956,
															-1.2
														],
														[
															-18.368,
															-13.471
														],
														[
															-24.164,
															-7.067
														],
														[
															-3.65,
															-1.014
														],
														[
															-0.993,
															-1.242
														],
														[
															-0.216,
															-0.875
														],
														[
															-0.643,
															-0.885
														],
														[
															-0.581,
															-1.082
														],
														[
															-0.775,
															-0.431
														],
														[
															-0.677,
															-0.211
														],
														[
															-0.028,
															-0.009
														],
														[
															-3.305,
															-0.09
														],
														[
															-3.024,
															-0.094
														],
														[
															-15.452,
															4.103
														],
														[
															-11.534,
															6.173
														],
														[
															-0.771,
															0.732
														],
														[
															-0.949,
															0.553
														],
														[
															-1.215,
															0.425
														],
														[
															-1.015,
															0.645
														],
														[
															-0.346,
															0.393
														],
														[
															-0.337,
															0.252
														],
														[
															-1.519,
															0.96
														],
														[
															-1.357,
															0.987
														],
														[
															-2.853,
															2.423
														],
														[
															-2.74,
															1.235
														],
														[
															-0.179,
															0.454
														],
														[
															-0.148,
															0.123
														],
														[
															-1.905,
															2.003
														],
														[
															-2.037,
															2.037
														],
														[
															-1.734,
															1.439
														],
														[
															-1.471,
															1.652
														],
														[
															-0.108,
															0.58
														],
														[
															-0.262,
															0.336
														],
														[
															-0.58,
															0.29
														],
														[
															-0.351,
															0.417
														],
														[
															-1.907,
															2.803
														],
														[
															-1.527,
															1.594
														],
														[
															-1.015,
															1.568
														],
														[
															-0.6,
															1.33
														],
														[
															-0.451,
															0.163
														],
														[
															-0.123,
															0.185
														],
														[
															0.067,
															0.379
														],
														[
															-0.115,
															0.255
														],
														[
															-0.451,
															0.163
														],
														[
															-0.123,
															0.185
														],
														[
															-0.466,
															1.061
														],
														[
															-0.579,
															0.923
														],
														[
															-1.847,
															2.94
														],
														[
															-1.625,
															3.068
														],
														[
															-3.768,
															8.278
														],
														[
															-5.999,
															19.57
														],
														[
															2.369,
															53.887
														],
														[
															2.352,
															16.82
														],
														[
															21.466,
															40.528
														],
														[
															2.278,
															5.052
														],
														[
															0.241,
															0.399
														],
														[
															1.231,
															1.917
														],
														[
															1.278,
															1.868
														],
														[
															23.497,
															16.064
														],
														[
															0.137,
															0.131
														],
														[
															0.85,
															0.814
														],
														[
															0.85,
															0.814
														],
														[
															2.32,
															1.519
														],
														[
															7.572,
															3.507
														],
														[
															35.5,
															-2.611
														]
													],
													"o": [
														[
															-5.499,
															0.451
														],
														[
															-5.07,
															0.792
														],
														[
															-4.55,
															1.204
														],
														[
															-4.376,
															1.507
														],
														[
															-24.482,
															10.956
														],
														[
															-17.685,
															17.145
														],
														[
															-21.339,
															34.18
														],
														[
															-10.365,
															48.194
														],
														[
															2.654,
															21.486
														],
														[
															4.502,
															18.285
														],
														[
															3.093,
															7.989
														],
														[
															3.683,
															7.742
														],
														[
															0.079,
															0.177
														],
														[
															0.451,
															0.153
														],
														[
															0.863,
															1.548
														],
														[
															0.636,
															1.385
														],
														[
															0.966,
															1.49
														],
														[
															0.82,
															1.315
														],
														[
															0.588,
															0.974
														],
														[
															0.45,
															1.028
														],
														[
															0.522,
															0.779
														],
														[
															0.735,
															0.619
														],
														[
															1.06,
															1.464
														],
														[
															0.798,
															1.404
														],
														[
															1.202,
															1.475
														],
														[
															0.961,
															1.331
														],
														[
															14.364,
															18.048
														],
														[
															18.368,
															13.471
														],
														[
															2.406,
															0.704
														],
														[
															3.65,
															1.014
														],
														[
															0.493,
															0.617
														],
														[
															0.216,
															0.875
														],
														[
															0.902,
															1.241
														],
														[
															0.581,
															1.082
														],
														[
															0.264,
															0.147
														],
														[
															0.677,
															0.211
														],
														[
															1.758,
															0.546
														],
														[
															3.305,
															0.09
														],
														[
															18.66,
															0.583
														],
														[
															15.452,
															-4.103
														],
														[
															0.966,
															-0.517
														],
														[
															0.771,
															-0.733
														],
														[
															1.125,
															-0.655
														],
														[
															1.215,
															-0.425
														],
														[
															0.28,
															-0.178
														],
														[
															0.346,
															-0.393
														],
														[
															1.567,
															-1.173
														],
														[
															1.519,
															-0.96
														],
														[
															2.851,
															-2.073
														],
														[
															2.852,
															-2.423
														],
														[
															0.137,
															-0.062
														],
														[
															0.179,
															-0.454
														],
														[
															2.342,
															-1.952
														],
														[
															1.905,
															-2.003
														],
														[
															1.591,
															-1.591
														],
														[
															1.735,
															-1.439
														],
														[
															0.307,
															-0.344
														],
														[
															0.108,
															-0.58
														],
														[
															0.329,
															-0.421
														],
														[
															0.58,
															-0.29
														],
														[
															1.844,
															-2.193
														],
														[
															1.907,
															-2.803
														],
														[
															1.34,
															-1.398
														],
														[
															1.015,
															-1.568
														],
														[
															0.073,
															-0.162
														],
														[
															0.451,
															-0.163
														],
														[
															0.154,
															-0.23
														],
														[
															-0.067,
															-0.379
														],
														[
															0.073,
															-0.161
														],
														[
															0.451,
															-0.163
														],
														[
															0.556,
															-0.831
														],
														[
															0.466,
															-1.062
														],
														[
															1.988,
															-3.171
														],
														[
															1.847,
															-2.94
														],
														[
															4.379,
															-8.268
														],
														[
															8.079,
															-17.747
														],
														[
															13.294,
															-43.366
														],
														[
															-0.904,
															-20.549
														],
														[
															-7.767,
															-55.551
														],
														[
															-3.008,
															-5.679
														],
														[
															-0.154,
															-0.342
														],
														[
															-1.225,
															-2.027
														],
														[
															-1.126,
															-1.754
														],
														[
															-16.646,
															-24.328
														],
														[
															-0.063,
															-0.043
														],
														[
															-0.838,
															-0.803
														],
														[
															-0.838,
															-0.803
														],
														[
															-2.326,
															-2.229
														],
														[
															-7.525,
															-4.927
														],
														[
															-24.288,
															-11.249
														],
														[
															-0.624,
															0.046
														]
													],
													"v": [
														[
															347,
															16
														],
														[
															331.292,
															17.803
														],
														[
															316,
															21
														],
														[
															302.548,
															25.078
														],
														[
															290,
															30
														],
														[
															227.221,
															72.868
														],
														[
															182,
															130
														],
														[
															132.895,
															255.351
														],
														[
															126,
															412
														],
														[
															136.737,
															471.333
														],
														[
															153,
															523
														],
														[
															163.438,
															546.709
														],
														[
															174,
															569
														],
														[
															174.972,
															569.475
														],
														[
															176,
															570
														],
														[
															178.203,
															574.476
														],
														[
															180,
															578
														],
														[
															182.658,
															582.179
														],
														[
															185,
															586
														],
														[
															186.482,
															589.044
														],
														[
															188,
															592
														],
														[
															189.987,
															594.025
														],
														[
															192,
															596
														],
														[
															194.733,
															600.409
														],
														[
															197,
															604
														],
														[
															200.185,
															608.206
														],
														[
															203,
															612
														],
														[
															251.65,
															659.736
														],
														[
															315,
															691
														],
														[
															325.06,
															693.596
														],
														[
															333,
															697
														],
														[
															333.888,
															699.299
														],
														[
															335,
															702
														],
														[
															337.095,
															705.607
														],
														[
															339,
															708
														],
														[
															340.677,
															708.603
														],
														[
															342,
															709
														],
														[
															350.051,
															709.839
														],
														[
															360,
															710
														],
														[
															411.344,
															704.067
														],
														[
															452,
															688
														],
														[
															454.513,
															686.027
														],
														[
															457,
															684
														],
														[
															460.582,
															682.493
														],
														[
															464,
															681
														],
														[
															464.958,
															680.056
														],
														[
															466,
															679
														],
														[
															470.658,
															675.861
														],
														[
															475,
															673
														],
														[
															483.583,
															665.871
														],
														[
															492,
															660
														],
														[
															492.492,
															659.046
														],
														[
															493,
															658
														],
														[
															499.229,
															652.064
														],
														[
															505,
															646
														],
														[
															510.091,
															641.545
														],
														[
															515,
															637
														],
														[
															515.533,
															635.494
														],
														[
															516,
															634
														],
														[
															517.484,
															632.997
														],
														[
															519,
															632
														],
														[
															524.738,
															624.05
														],
														[
															530,
															617
														],
														[
															533.555,
															612.449
														],
														[
															536,
															608
														],
														[
															536.962,
															607.517
														],
														[
															538,
															607
														],
														[
															538.029,
															606.019
														],
														[
															538,
															605
														],
														[
															538.962,
															604.517
														],
														[
															540,
															604
														],
														[
															541.483,
															601.07
														],
														[
															543,
															598
														],
														[
															548.772,
															588.923
														],
														[
															554,
															580
														],
														[
															567,
															555
														],
														[
															587,
															499
														],
														[
															606,
															348
														],
														[
															602,
															295
														],
														[
															557,
															150
														],
														[
															548,
															133
														],
														[
															546,
															132
														],
														[
															543,
															125
														],
														[
															539,
															120
														],
														[
															477,
															54
														],
														[
															476,
															53
														],
														[
															473,
															51
														],
														[
															470,
															49
														],
														[
															463,
															44
														],
														[
															438,
															31
														],
														[
															348,
															15
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 66,
											"s": [
												{
													"i": [
														[
															-0.088,
															0.008
														],
														[
															8.932,
															-2.491
														],
														[
															8.557,
															-4.142
														],
														[
															5.207,
															-3.206
														],
														[
															4.434,
															-3.398
														],
														[
															1.249,
															-0.832
														],
														[
															0.798,
															-0.746
														],
														[
															1.807,
															-1.626
														],
														[
															1.844,
															-1.695
														],
														[
															1.516,
															-1.274
														],
														[
															1.317,
															-1.416
														],
														[
															0.404,
															-0.867
														],
														[
															0.709,
															-0.808
														],
														[
															0.91,
															-0.617
														],
														[
															0.685,
															-0.763
														],
														[
															1.013,
															-1.471
														],
														[
															0.782,
															-0.816
														],
														[
															0.086,
															-0.309
														],
														[
															0.325,
															-0.416
														],
														[
															1.408,
															-1.465
														],
														[
															1.144,
															-1.572
														],
														[
															0.481,
															-0.872
														],
														[
															0.528,
															-0.761
														],
														[
															2.169,
															-3.2
														],
														[
															1.432,
															-2.474
														],
														[
															0.831,
															-1.264
														],
														[
															0.748,
															-1.343
														],
														[
															0.784,
															-1.886
														],
														[
															0.904,
															-1.731
														],
														[
															5.525,
															-14.285
														],
														[
															4.007,
															-15.649
														],
														[
															2.78,
															-20.056
														],
														[
															0.522,
															-21.759
														],
														[
															-8.942,
															-37.708
														],
														[
															-14.262,
															-27.207
														],
														[
															-16.166,
															-18.124
														],
														[
															-21.14,
															-12.24
														],
														[
															-3.389,
															-1.714
														],
														[
															-3.345,
															-1.35
														],
														[
															-2.18,
															-0.619
														],
														[
															-2.337,
															-0.737
														],
														[
															-3.129,
															-0.929
														],
														[
															-0.732,
															-0.732
														],
														[
															-0.813,
															-2.021
														],
														[
															-0.582,
															-0.749
														],
														[
															-4.014,
															-0.47
														],
														[
															-3.379,
															-0.106
														],
														[
															-14.491,
															4.268
														],
														[
															-11.076,
															6.523
														],
														[
															-1.348,
															0.719
														],
														[
															-0.481,
															0.462
														],
														[
															-0.539,
															0.298
														],
														[
															-0.425,
															0.408
														],
														[
															-1.163,
															0.744
														],
														[
															-1.163,
															0.889
														],
														[
															-5.813,
															5.297
														],
														[
															-4.777,
															5.246
														],
														[
															-0.073,
															0.527
														],
														[
															-0.337,
															0.482
														],
														[
															-0.593,
															0.296
														],
														[
															-0.337,
															0.399
														],
														[
															-15.261,
															59.006
														],
														[
															8.708,
															70.486
														],
														[
															5.409,
															20.986
														],
														[
															7.488,
															17.769
														],
														[
															4.943,
															9.046
														],
														[
															5.105,
															8.028
														],
														[
															0.662,
															1.296
														],
														[
															0.583,
															0.608
														],
														[
															0.298,
															0.539
														],
														[
															0.408,
															0.425
														],
														[
															0.755,
															1.177
														],
														[
															0.863,
															1.129
														],
														[
															0.69,
															0.847
														],
														[
															0.603,
															0.78
														],
														[
															1.527,
															1.616
														],
														[
															1.51,
															1.752
														],
														[
															0.104,
															0.573
														],
														[
															0.27,
															0.347
														],
														[
															1.679,
															1.573
														],
														[
															1.049,
															1.121
														],
														[
															1.329,
															1.063
														],
														[
															1.303,
															1.272
														],
														[
															1.462,
															1.528
														],
														[
															1.589,
															1.362
														],
														[
															2.745,
															2.029
														],
														[
															2.464,
															1.692
														],
														[
															1.774,
															1.125
														],
														[
															1.893,
															1.122
														],
														[
															16.541,
															4.307
														],
														[
															20.417,
															-1.588
														]
													],
													"o": [
														[
															-9.714,
															0.893
														],
														[
															-8.932,
															2.491
														],
														[
															-5.736,
															2.777
														],
														[
															-5.207,
															3.206
														],
														[
															-1.207,
															0.925
														],
														[
															-1.249,
															0.832
														],
														[
															-1.928,
															1.803
														],
														[
															-1.807,
															1.626
														],
														[
															-1.62,
															1.489
														],
														[
															-1.516,
															1.274
														],
														[
															-0.674,
															0.725
														],
														[
															-0.404,
															0.867
														],
														[
															-0.676,
															0.769
														],
														[
															-0.91,
															0.617
														],
														[
															-1.168,
															1.302
														],
														[
															-1.012,
															1.471
														],
														[
															-0.331,
															0.346
														],
														[
															-0.086,
															0.309
														],
														[
															-1.222,
															1.567
														],
														[
															-1.408,
															1.465
														],
														[
															-0.548,
															0.752
														],
														[
															-0.481,
															0.872
														],
														[
															-1.89,
															2.727
														],
														[
															-2.169,
															3.2
														],
														[
															-0.927,
															1.602
														],
														[
															-0.831,
															1.264
														],
														[
															-0.96,
															1.726
														],
														[
															-0.784,
															1.886
														],
														[
															-6.894,
															13.209
														],
														[
															-5.525,
															14.285
														],
														[
															-4.358,
															17.017
														],
														[
															-2.78,
															20.056
														],
														[
															-1.029,
															42.961
														],
														[
															8.942,
															37.708
														],
														[
															12.195,
															23.265
														],
														[
															16.166,
															18.124
														],
														[
															3.101,
															1.795
														],
														[
															3.388,
															1.714
														],
														[
															1.946,
															0.785
														],
														[
															2.179,
															0.619
														],
														[
															1.752,
															0.553
														],
														[
															3.129,
															0.929
														],
														[
															1.168,
															1.168
														],
														[
															0.813,
															2.021
														],
														[
															1.565,
															2.014
														],
														[
															4.014,
															0.47
														],
														[
															18.961,
															0.593
														],
														[
															14.491,
															-4.267
														],
														[
															1.126,
															-0.663
														],
														[
															1.348,
															-0.719
														],
														[
															0.419,
															-0.401
														],
														[
															0.539,
															-0.298
														],
														[
															1.185,
															-1.135
														],
														[
															1.163,
															-0.744
														],
														[
															5.969,
															-4.564
														],
														[
															5.813,
															-5.297
														],
														[
															0.373,
															-0.409
														],
														[
															0.073,
															-0.527
														],
														[
															0.291,
															-0.416
														],
														[
															0.593,
															-0.296
														],
														[
															31.666,
															-37.49
														],
														[
															15.26,
															-59.006
														],
														[
															-2.877,
															-23.288
														],
														[
															-5.409,
															-20.986
														],
														[
															-4.125,
															-9.786
														],
														[
															-4.943,
															-9.047
														],
														[
															-0.767,
															-1.206
														],
														[
															-0.663,
															-1.296
														],
														[
															-0.401,
															-0.419
														],
														[
															-0.298,
															-0.539
														],
														[
															-1.115,
															-1.165
														],
														[
															-0.755,
															-1.177
														],
														[
															-0.637,
															-0.833
														],
														[
															-0.69,
															-0.847
														],
														[
															-1.38,
															-1.784
														],
														[
															-1.527,
															-1.616
														],
														[
															-0.312,
															-0.362
														],
														[
															-0.104,
															-0.573
														],
														[
															-1.236,
															-1.586
														],
														[
															-1.679,
															-1.573
														],
														[
															-1.382,
															-1.477
														],
														[
															-1.329,
															-1.063
														],
														[
															-1.563,
															-1.525
														],
														[
															-1.462,
															-1.528
														],
														[
															-2.557,
															-2.192
														],
														[
															-2.745,
															-2.029
														],
														[
															-2.01,
															-1.38
														],
														[
															-1.774,
															-1.125
														],
														[
															-12.421,
															-7.361
														],
														[
															-16.541,
															-4.307
														],
														[
															-0.633,
															0.049
														]
													],
													"v": [
														[
															347,
															16
														],
														[
															319.132,
															21.063
														],
														[
															293,
															31
														],
														[
															276.523,
															40.035
														],
														[
															262,
															50
														],
														[
															258.192,
															52.634
														],
														[
															255,
															55
														],
														[
															249.437,
															60.081
														],
														[
															244,
															65
														],
														[
															239.273,
															69.054
														],
														[
															235,
															73
														],
														[
															233.526,
															75.438
														],
														[
															232,
															78
														],
														[
															229.506,
															80.005
														],
														[
															227,
															82
														],
														[
															223.71,
															86.364
														],
														[
															221,
															90
														],
														[
															220.495,
															90.947
														],
														[
															220,
															92
														],
														[
															215.941,
															96.496
														],
														[
															212,
															101
														],
														[
															210.485,
															103.494
														],
														[
															209,
															106
														],
														[
															202.657,
															115.189
														],
														[
															197,
															124
														],
														[
															194.365,
															128.194
														],
														[
															192,
															132
														],
														[
															189.457,
															137.496
														],
														[
															187,
															143
														],
														[
															168.335,
															184.17
														],
														[
															154,
															229
														],
														[
															143.123,
															284.943
														],
														[
															138,
															348
														],
														[
															151.032,
															470.315
														],
														[
															187,
															569
														],
														[
															229.292,
															631.269
														],
														[
															285,
															677
														],
														[
															294.817,
															682.335
														],
														[
															305,
															687
														],
														[
															311.207,
															689.036
														],
														[
															318,
															691
														],
														[
															326.265,
															693.366
														],
														[
															333,
															696
														],
														[
															335.94,
															701.314
														],
														[
															338,
															706
														],
														[
															347.139,
															709.432
														],
														[
															359,
															710
														],
														[
															408.914,
															703.837
														],
														[
															447,
															687
														],
														[
															450.984,
															684.849
														],
														[
															454,
															683
														],
														[
															455.495,
															682.005
														],
														[
															457,
															681
														],
														[
															460.517,
															678.316
														],
														[
															464,
															676
														],
														[
															481.894,
															661.011
														],
														[
															498,
															645
														],
														[
															498.527,
															643.555
														],
														[
															499,
															642
														],
														[
															500.465,
															640.988
														],
														[
															502,
															640
														],
														[
															574.281,
															492.746
														],
														[
															586,
															296
														],
														[
															573.459,
															229.36
														],
														[
															554,
															171
														],
														[
															540.235,
															142.682
														],
														[
															525,
															117
														],
														[
															522.862,
															113.052
														],
														[
															521,
															110
														],
														[
															520.005,
															108.504
														],
														[
															519,
															107
														],
														[
															516.311,
															103.473
														],
														[
															514,
															100
														],
														[
															511.975,
															97.461
														],
														[
															510,
															95
														],
														[
															505.598,
															89.976
														],
														[
															501,
															85
														],
														[
															500.469,
															83.489
														],
														[
															500,
															82
														],
														[
															495.36,
															77.151
														],
														[
															491,
															73
														],
														[
															486.94,
															69.346
														],
														[
															483,
															66
														],
														[
															478.519,
															61.377
														],
														[
															474,
															57
														],
														[
															465.931,
															50.625
														],
														[
															458,
															45
														],
														[
															452.412,
															41.307
														],
														[
															447,
															38
														],
														[
															403.497,
															19.788
														],
														[
															348,
															15
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 67,
											"s": [
												{
													"i": [
														[
															-0.038,
															0.004
														],
														[
															0.167,
															-0.001
														],
														[
															0.168,
															0.005
														],
														[
															0.167,
															0.004
														],
														[
															0.165,
															-0.006
														],
														[
															4.336,
															-0.907
														],
														[
															4.167,
															-1.366
														],
														[
															3.747,
															-1.526
														],
														[
															3.078,
															-1.388
														],
														[
															0.077,
															-0.177
														],
														[
															0.076,
															-0.226
														],
														[
															0.086,
															-0.186
														],
														[
															0.107,
															-0.057
														],
														[
															0.925,
															-0.39
														],
														[
															0.941,
															-0.375
														],
														[
															0.921,
															-0.422
														],
														[
															0.864,
															-0.532
														],
														[
															0.334,
															-0.344
														],
														[
															0.318,
															-0.383
														],
														[
															0.325,
															-0.348
														],
														[
															0.353,
															-0.238
														],
														[
															0.521,
															-0.246
														],
														[
															0.52,
															-0.215
														],
														[
															0.489,
															-0.236
														],
														[
															0.427,
															-0.31
														],
														[
															0.319,
															-0.328
														],
														[
															0.296,
															-0.347
														],
														[
															0.329,
															-0.346
														],
														[
															0.418,
															-0.324
														],
														[
															0.799,
															-0.598
														],
														[
															0.734,
															-0.553
														],
														[
															0.693,
															-0.554
														],
														[
															0.677,
															-0.6
														],
														[
															1.697,
															-1.646
														],
														[
															1.586,
															-1.683
														],
														[
															1.596,
															-1.821
														],
														[
															1.728,
															-2.059
														],
														[
															1.294,
															-1.474
														],
														[
															1.293,
															-1.492
														],
														[
															1.227,
															-1.522
														],
														[
															1.096,
															-1.564
														],
														[
															4.074,
															-6.875
														],
														[
															3.618,
															-7.223
														],
														[
															3.235,
															-7.612
														],
														[
															2.925,
															-8.041
														],
														[
															4.296,
															-17.74
														],
														[
															2.358,
															-19.561
														],
														[
															0,
															-21.448
														],
														[
															-7.582,
															-36.611
														],
														[
															-13.673,
															-29.076
														],
														[
															-3.458,
															-6.1
														],
														[
															-3.196,
															-5.275
														],
														[
															-0.474,
															-1.065
														],
														[
															-0.535,
															-0.799
														],
														[
															-0.748,
															-0.638
														],
														[
															-0.5,
															-0.686
														],
														[
															-0.093,
															-0.539
														],
														[
															-0.302,
															-0.395
														],
														[
															-6.877,
															-7.658
														],
														[
															-7.264,
															-6.226
														],
														[
															-7.801,
															-4.804
														],
														[
															-8.391,
															-3.293
														],
														[
															-1.014,
															-0.321
														],
														[
															-1.023,
															-0.355
														],
														[
															-2.995,
															-0.838
														],
														[
															-0.919,
															-0.919
														],
														[
															-0.052,
															-0.235
														],
														[
															-0.352,
															-0.62
														],
														[
															-1.077,
															-1.944
														],
														[
															-2.369,
															-0.896
														],
														[
															-3.031,
															-0.116
														],
														[
															-2.64,
															-0.068
														],
														[
															-15.491,
															6.004
														],
														[
															-10.962,
															8.526
														],
														[
															-6.046,
															6.087
														],
														[
															-5.178,
															6.489
														],
														[
															-4.683,
															7.13
														],
														[
															-3.231,
															7.169
														],
														[
															-0.451,
															0.153
														],
														[
															-0.116,
															0.212
														],
														[
															-1.784,
															4.089
														],
														[
															-1.853,
															3.977
														],
														[
															-7.468,
															35.205
														],
														[
															0,
															40
														],
														[
															8.721,
															39.729
														],
														[
															17.116,
															31.38
														],
														[
															10.303,
															13.674
														],
														[
															13.655,
															11.395
														],
														[
															18.249,
															6.422
														],
														[
															22.726,
															-1.768
														],
														[
															0.179,
															-0.245
														]
													],
													"o": [
														[
															-0.164,
															0.016
														],
														[
															-0.167,
															0.001
														],
														[
															-0.168,
															-0.005
														],
														[
															-0.167,
															-0.004
														],
														[
															-4.255,
															0.148
														],
														[
															-4.336,
															0.907
														],
														[
															-4.167,
															1.366
														],
														[
															-3.747,
															1.526
														],
														[
															-0.09,
															0.041
														],
														[
															-0.077,
															0.177
														],
														[
															-0.076,
															0.226
														],
														[
															-0.086,
															0.186
														],
														[
															-0.873,
															0.468
														],
														[
															-0.925,
															0.39
														],
														[
															-0.941,
															0.375
														],
														[
															-0.921,
															0.422
														],
														[
															-0.373,
															0.23
														],
														[
															-0.334,
															0.344
														],
														[
															-0.318,
															0.383
														],
														[
															-0.325,
															0.348
														],
														[
															-0.491,
															0.331
														],
														[
															-0.521,
															0.246
														],
														[
															-0.52,
															0.215
														],
														[
															-0.489,
															0.236
														],
														[
															-0.397,
															0.288
														],
														[
															-0.319,
															0.328
														],
														[
															-0.296,
															0.347
														],
														[
															-0.329,
															0.346
														],
														[
															-0.888,
															0.688
														],
														[
															-0.799,
															0.598
														],
														[
															-0.734,
															0.553
														],
														[
															-0.693,
															0.554
														],
														[
															-1.93,
															1.709
														],
														[
															-1.697,
															1.646
														],
														[
															-1.586,
															1.683
														],
														[
															-1.596,
															1.821
														],
														[
															-1.231,
															1.468
														],
														[
															-1.294,
															1.474
														],
														[
															-1.293,
															1.492
														],
														[
															-1.227,
															1.522
														],
														[
															-4.602,
															6.566
														],
														[
															-4.074,
															6.875
														],
														[
															-3.618,
															7.223
														],
														[
															-3.235,
															7.612
														],
														[
															-5.814,
															15.984
														],
														[
															-4.296,
															17.74
														],
														[
															-2.358,
															19.561
														],
														[
															0,
															42.481
														],
														[
															7.582,
															36.611
														],
														[
															2.974,
															6.323
														],
														[
															3.457,
															6.1
														],
														[
															0.57,
															0.942
														],
														[
															0.474,
															1.065
														],
														[
															0.51,
															0.762
														],
														[
															0.748,
															0.638
														],
														[
															0.327,
															0.449
														],
														[
															0.093,
															0.539
														],
														[
															6.227,
															8.142
														],
														[
															6.877,
															7.658
														],
														[
															6.404,
															5.49
														],
														[
															7.801,
															4.804
														],
														[
															0.923,
															0.362
														],
														[
															1.013,
															0.321
														],
														[
															2.101,
															0.729
														],
														[
															2.995,
															0.838
														],
														[
															0.439,
															0.439
														],
														[
															0.052,
															0.235
														],
														[
															1.326,
															2.33
														],
														[
															1.076,
															1.944
														],
														[
															1.236,
															0.467
														],
														[
															3.031,
															0.116
														],
														[
															21.075,
															0.541
														],
														[
															15.491,
															-6.004
														],
														[
															6.639,
															-5.164
														],
														[
															6.046,
															-6.087
														],
														[
															5.036,
															-6.311
														],
														[
															4.683,
															-7.13
														],
														[
															0.08,
															-0.178
														],
														[
															0.451,
															-0.153
														],
														[
															2.011,
															-3.666
														],
														[
															1.784,
															-4.089
														],
														[
															13.13,
															-28.178
														],
														[
															7.468,
															-35.205
														],
														[
															0,
															-44.703
														],
														[
															-8.721,
															-39.729
														],
														[
															-8.133,
															-14.91
														],
														[
															-10.303,
															-13.674
														],
														[
															-13.276,
															-11.078
														],
														[
															-18.249,
															-6.422
														],
														[
															-0.321,
															0.025
														],
														[
															-0.179,
															0.245
														]
													],
													"v": [
														[
															348,
															16
														],
														[
															347.503,
															16.024
														],
														[
															347.001,
															16.015
														],
														[
															346.499,
															15.999
														],
														[
															346,
															16
														],
														[
															333.051,
															17.656
														],
														[
															320.234,
															21.14
														],
														[
															308.301,
															25.554
														],
														[
															298,
															30
														],
														[
															297.753,
															30.349
														],
														[
															297.526,
															30.975
														],
														[
															297.287,
															31.613
														],
														[
															297,
															32
														],
														[
															294.295,
															33.271
														],
														[
															291.487,
															34.403
														],
														[
															288.686,
															35.583
														],
														[
															286,
															37
														],
														[
															284.945,
															37.879
														],
														[
															283.971,
															38.988
														],
														[
															283.012,
															40.103
														],
														[
															282,
															41
														],
														[
															280.474,
															41.853
														],
														[
															278.904,
															42.531
														],
														[
															277.382,
															43.194
														],
														[
															276,
															44
														],
														[
															274.94,
															44.929
														],
														[
															274.032,
															45.946
														],
														[
															273.107,
															46.991
														],
														[
															272,
															48
														],
														[
															269.476,
															49.917
														],
														[
															267.183,
															51.632
														],
														[
															265.049,
															53.281
														],
														[
															263,
															55
														],
														[
															257.59,
															60.006
														],
														[
															252.697,
															64.974
														],
														[
															247.955,
															70.205
														],
														[
															243,
															76
														],
														[
															239.196,
															80.409
														],
														[
															235.298,
															84.856
														],
														[
															231.501,
															89.374
														],
														[
															228,
															94
														],
														[
															215.003,
															114.151
														],
														[
															203.483,
															135.288
														],
														[
															193.221,
															157.531
														],
														[
															184,
															181
														],
														[
															168.73,
															231.569
														],
														[
															158.643,
															287.503
														],
														[
															155,
															349
														],
														[
															166.745,
															468.054
														],
														[
															199,
															567
														],
														[
															208.834,
															585.786
														],
														[
															219,
															603
														],
														[
															220.527,
															606.107
														],
														[
															222,
															609
														],
														[
															224.008,
															611.057
														],
														[
															226,
															613
														],
														[
															226.519,
															614.541
														],
														[
															227,
															616
														],
														[
															246.723,
															639.937
														],
														[
															268,
															661
														],
														[
															289.509,
															676.647
														],
														[
															314,
															689
														],
														[
															316.926,
															690.006
														],
														[
															320,
															691
														],
														[
															328.387,
															693.357
														],
														[
															335,
															696
														],
														[
															335.565,
															696.865
														],
														[
															336,
															698
														],
														[
															339.218,
															704.576
														],
														[
															344,
															709
														],
														[
															350.947,
															709.8
														],
														[
															360,
															710
														],
														[
															414.584,
															700.8
														],
														[
															454,
															678
														],
														[
															473.096,
															660.994
														],
														[
															490,
															642
														],
														[
															504.854,
															621.644
														],
														[
															517,
															600
														],
														[
															517.973,
															599.526
														],
														[
															519,
															599
														],
														[
															524.618,
															587.234
														],
														[
															530,
															575
														],
														[
															561.347,
															479.366
														],
														[
															573,
															366
														],
														[
															559.837,
															238.508
														],
														[
															521,
															131
														],
														[
															493.641,
															87.863
														],
														[
															458,
															50
														],
														[
															410.588,
															22.865
														],
														[
															349,
															15
														],
														[
															348.231,
															15.521
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 68,
											"s": [
												{
													"i": [
														[
															-0.034,
															0.004
														],
														[
															2.324,
															-0.365
														],
														[
															2.187,
															-0.482
														],
														[
															2.144,
															-0.627
														],
														[
															2.196,
															-0.797
														],
														[
															0.917,
															-0.391
														],
														[
															0.885,
															-0.418
														],
														[
															0.901,
															-0.443
														],
														[
															0.963,
															-0.466
														],
														[
															0.94,
															-0.394
														],
														[
															0.936,
															-0.388
														],
														[
															0.903,
															-0.425
														],
														[
															0.841,
															-0.505
														],
														[
															0.758,
															-0.575
														],
														[
															0.745,
															-0.623
														],
														[
															0.739,
															-0.611
														],
														[
															0.74,
															-0.539
														],
														[
															2.322,
															-1.796
														],
														[
															2.226,
															-1.859
														],
														[
															2.041,
															-1.884
														],
														[
															1.767,
															-1.869
														],
														[
															5.092,
															-6.89
														],
														[
															4.507,
															-7.514
														],
														[
															3.911,
															-7.867
														],
														[
															3.304,
															-7.949
														],
														[
															1.142,
															-2.885
														],
														[
															1.089,
															-2.917
														],
														[
															1.028,
															-2.948
														],
														[
															0.958,
															-2.979
														],
														[
															3.087,
															-12.818
														],
														[
															2.133,
															-13.62
														],
														[
															1.104,
															-14.742
														],
														[
															0,
															-16.185
														],
														[
															-0.423,
															-10.188
														],
														[
															-0.839,
															-9.644
														],
														[
															-1.246,
															-9.259
														],
														[
															-1.645,
															-9.034
														],
														[
															-4.915,
															-16.545
														],
														[
															-6.347,
															-14.919
														],
														[
															-7.477,
															-12.586
														],
														[
															-1.448,
															-2.089
														],
														[
															-0.95,
															-1.528
														],
														[
															-0.098,
															-0.517
														],
														[
															-0.326,
															-0.479
														],
														[
															-0.722,
															-0.597
														],
														[
															-0.543,
															-0.773
														],
														[
															-0.502,
															-0.892
														],
														[
															-0.499,
															-0.726
														],
														[
															-0.347,
															-0.288
														],
														[
															-0.294,
															-0.385
														],
														[
															-0.086,
															-0.536
														],
														[
															-0.338,
															-0.44
														],
														[
															-1.4,
															-1.264
														],
														[
															-1.262,
															-1.459
														],
														[
															-1.116,
															-1.292
														],
														[
															-1.251,
															-1.347
														],
														[
															-3.589,
															-3.24
														],
														[
															-3.428,
															-2.574
														],
														[
															-1.127,
															-0.818
														],
														[
															-1.109,
															-0.689
														],
														[
															-0.345,
															-0.4
														],
														[
															-0.323,
															-0.215
														],
														[
															-3.518,
															-1.831
														],
														[
															-3.539,
															-1.423
														],
														[
															-1.909,
															-0.602
														],
														[
															-2.091,
															-0.679
														],
														[
															-1.282,
															-0.419
														],
														[
															-0.085,
															-0.067
														],
														[
															-0.87,
															-2.689
														],
														[
															-3.002,
															-1.275
														],
														[
															-3.049,
															-0.111
														],
														[
															-2.623,
															-0.053
														],
														[
															-8.588,
															1.955
														],
														[
															-5.308,
															2.389
														],
														[
															-2.075,
															0.797
														],
														[
															-1.688,
															0.906
														],
														[
															-0.775,
															0.724
														],
														[
															-0.927,
															0.583
														],
														[
															-12.97,
															16.389
														],
														[
															-9.1,
															18.099
														],
														[
															-5.82,
															17.525
														],
														[
															-4.083,
															18.708
														],
														[
															-0.117,
															43.532
														],
														[
															8.061,
															39.508
														],
														[
															5.652,
															17.333
														],
														[
															7.321,
															15.712
														],
														[
															9.311,
															13.936
														],
														[
															12.949,
															11.65
														],
														[
															16.763,
															6.776
														],
														[
															21.816,
															-1.92
														],
														[
															0.179,
															-0.244
														]
													],
													"o": [
														[
															-2.557,
															0.273
														],
														[
															-2.324,
															0.365
														],
														[
															-2.187,
															0.482
														],
														[
															-2.144,
															0.627
														],
														[
															-0.996,
															0.361
														],
														[
															-0.917,
															0.391
														],
														[
															-0.885,
															0.418
														],
														[
															-0.901,
															0.443
														],
														[
															-0.914,
															0.442
														],
														[
															-0.94,
															0.394
														],
														[
															-0.936,
															0.388
														],
														[
															-0.903,
															0.425
														],
														[
															-0.779,
															0.467
														],
														[
															-0.758,
															0.575
														],
														[
															-0.745,
															0.624
														],
														[
															-0.739,
															0.611
														],
														[
															-2.328,
															1.694
														],
														[
															-2.322,
															1.796
														],
														[
															-2.226,
															1.859
														],
														[
															-2.041,
															1.884
														],
														[
															-5.666,
															5.994
														],
														[
															-5.092,
															6.89
														],
														[
															-4.507,
															7.514
														],
														[
															-3.911,
															7.867
														],
														[
															-1.186,
															2.853
														],
														[
															-1.142,
															2.885
														],
														[
															-1.089,
															2.917
														],
														[
															-1.028,
															2.948
														],
														[
															-3.966,
															12.335
														],
														[
															-3.087,
															12.818
														],
														[
															-2.133,
															13.62
														],
														[
															-1.104,
															14.742
														],
														[
															0,
															10.891
														],
														[
															0.423,
															10.188
														],
														[
															0.839,
															9.644
														],
														[
															1.246,
															9.259
														],
														[
															3.181,
															17.464
														],
														[
															4.915,
															16.545
														],
														[
															6.347,
															14.919
														],
														[
															1.257,
															2.117
														],
														[
															1.448,
															2.089
														],
														[
															0.281,
															0.452
														],
														[
															0.098,
															0.517
														],
														[
															0.57,
															0.839
														],
														[
															0.722,
															0.597
														],
														[
															0.495,
															0.705
														],
														[
															0.502,
															0.892
														],
														[
															0.317,
															0.462
														],
														[
															0.347,
															0.288
														],
														[
															0.318,
															0.416
														],
														[
															0.086,
															0.536
														],
														[
															1.138,
															1.486
														],
														[
															1.4,
															1.264
														],
														[
															1.284,
															1.484
														],
														[
															1.116,
															1.292
														],
														[
															3.217,
															3.465
														],
														[
															3.589,
															3.24
														],
														[
															1.382,
															1.038
														],
														[
															1.127,
															0.818
														],
														[
															0.298,
															0.186
														],
														[
															0.344,
															0.4
														],
														[
															3.389,
															2.255
														],
														[
															3.518,
															1.831
														],
														[
															2.273,
															0.914
														],
														[
															1.909,
															0.602
														],
														[
															0.786,
															0.255
														],
														[
															1.282,
															0.419
														],
														[
															2.519,
															1.97
														],
														[
															0.87,
															2.689
														],
														[
															1.182,
															0.502
														],
														[
															3.049,
															0.111
														],
														[
															10.338,
															0.207
														],
														[
															8.588,
															-1.955
														],
														[
															2.012,
															-0.905
														],
														[
															2.075,
															-0.797
														],
														[
															0.974,
															-0.523
														],
														[
															0.775,
															-0.724
														],
														[
															18.019,
															-11.346
														],
														[
															12.97,
															-16.389
														],
														[
															7.638,
															-15.192
														],
														[
															5.82,
															-17.525
														],
														[
															8.591,
															-39.365
														],
														[
															0.117,
															-43.532
														],
														[
															-4.072,
															-19.955
														],
														[
															-5.652,
															-17.333
														],
														[
															-6.805,
															-14.606
														],
														[
															-9.311,
															-13.936
														],
														[
															-13.131,
															-11.815
														],
														[
															-16.763,
															-6.776
														],
														[
															-0.32,
															0.028
														],
														[
															-0.179,
															0.244
														]
													],
													"v": [
														[
															349,
															16
														],
														[
															341.702,
															16.95
														],
														[
															334.959,
															18.214
														],
														[
															328.487,
															19.87
														],
														[
															322,
															22
														],
														[
															319.143,
															23.129
														],
														[
															316.452,
															24.343
														],
														[
															313.785,
															25.635
														],
														[
															311,
															27
														],
														[
															308.212,
															28.244
														],
														[
															305.39,
															29.407
														],
														[
															302.624,
															30.616
														],
														[
															300,
															32
														],
														[
															297.697,
															33.579
														],
														[
															295.443,
															35.393
														],
														[
															293.218,
															37.26
														],
														[
															291,
															39
														],
														[
															284.003,
															44.245
														],
														[
															277.158,
															49.737
														],
														[
															270.734,
															55.362
														],
														[
															265,
															61
														],
														[
															248.859,
															80.393
														],
														[
															234.456,
															102.067
														],
														[
															221.826,
															125.208
														],
														[
															211,
															149
														],
														[
															207.506,
															157.608
														],
														[
															204.158,
															166.311
														],
														[
															200.981,
															175.109
														],
														[
															198,
															184
														],
														[
															187.4,
															221.65
														],
														[
															179.55,
															261.226
														],
														[
															174.675,
															303.689
														],
														[
															173,
															350
														],
														[
															173.637,
															381.578
														],
														[
															175.532,
															411.286
														],
														[
															178.661,
															439.6
														],
														[
															183,
															467
														],
														[
															195.22,
															518.191
														],
														[
															212.189,
															565.565
														],
														[
															233,
															607
														],
														[
															237.231,
															613.442
														],
														[
															241,
															619
														],
														[
															241.467,
															620.48
														],
														[
															242,
															622
														],
														[
															244.02,
															624.05
														],
														[
															246,
															626
														],
														[
															247.497,
															628.484
														],
														[
															249,
															631
														],
														[
															250.017,
															632.058
														],
														[
															251,
															633
														],
														[
															251.485,
															634.482
														],
														[
															252,
															636
														],
														[
															255.907,
															640.02
														],
														[
															260,
															644
														],
														[
															263.525,
															648.102
														],
														[
															267,
															652
														],
														[
															277.342,
															662.168
														],
														[
															288,
															671
														],
														[
															291.705,
															673.761
														],
														[
															295,
															676
														],
														[
															295.981,
															676.978
														],
														[
															297,
															678
														],
														[
															307.388,
															684.124
														],
														[
															318,
															689
														],
														[
															324.137,
															691.176
														],
														[
															330,
															693
														],
														[
															333.526,
															694.142
														],
														[
															336,
															695
														],
														[
															340.137,
															702.521
														],
														[
															345,
															709
														],
														[
															351.919,
															709.837
														],
														[
															361,
															710
														],
														[
															389.772,
															706.947
														],
														[
															411,
															700
														],
														[
															417.243,
															697.501
														],
														[
															423,
															695
														],
														[
															425.535,
															693.046
														],
														[
															428,
															691
														],
														[
															474.19,
															648.565
														],
														[
															507,
															596
														],
														[
															527.166,
															546.637
														],
														[
															542,
															492
														],
														[
															554.989,
															365.608
														],
														[
															543,
															239
														],
														[
															528.437,
															183.318
														],
														[
															509,
															134
														],
														[
															485.108,
															90.783
														],
														[
															452,
															52
														],
														[
															407.513,
															23.199
														],
														[
															350,
															15
														],
														[
															349.234,
															15.524
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 69,
											"s": [
												{
													"i": [
														[
															6.449,
															-0.724
														],
														[
															0.335,
															0.014
														],
														[
															0.33,
															-0.021
														],
														[
															4.947,
															-1.496
														],
														[
															3.607,
															-1.721
														],
														[
															1.347,
															-0.663
														],
														[
															1.128,
															-0.64
														],
														[
															0.435,
															-0.556
														],
														[
															0.67,
															-0.44
														],
														[
															0.906,
															-0.265
														],
														[
															0.678,
															-0.48
														],
														[
															0.145,
															-0.414
														],
														[
															0.206,
															-0.191
														],
														[
															0.539,
															-0.073
														],
														[
															0.45,
															-0.342
														],
														[
															0.139,
															-0.406
														],
														[
															0.219,
															-0.203
														],
														[
															0.544,
															-0.074
														],
														[
															0.435,
															-0.343
														],
														[
															1.163,
															-1.25
														],
														[
															1.151,
															-1.053
														],
														[
															1.158,
															-1.164
														],
														[
															1.086,
															-1.169
														],
														[
															4.231,
															-5.152
														],
														[
															3.632,
															-5.609
														],
														[
															6.018,
															-12.895
														],
														[
															4.626,
															-13.141
														],
														[
															5.145,
															-32.631
														],
														[
															0,
															-36.713
														],
														[
															-10.489,
															-46.093
														],
														[
															-20.044,
															-31.923
														],
														[
															-0.528,
															-0.648
														],
														[
															-0.326,
															-0.512
														],
														[
															-0.262,
															-0.877
														],
														[
															-0.452,
															-0.711
														],
														[
															-0.423,
															-0.139
														],
														[
															-0.17,
															-0.227
														],
														[
															-0.114,
															-0.559
														],
														[
															-0.24,
															-0.363
														],
														[
															-3.859,
															-4.54
														],
														[
															-3.323,
															-3.947
														],
														[
															-1.803,
															-1.549
														],
														[
															-2.044,
															-1.734
														],
														[
															-1.575,
															-1.483
														],
														[
															-1.208,
															-0.802
														],
														[
															-0.296,
															-0.362
														],
														[
															-0.369,
															-0.253
														],
														[
															-0.922,
															-0.286
														],
														[
															-0.69,
															-0.429
														],
														[
															-2.83,
															-1.655
														],
														[
															-2.306,
															-0.905
														],
														[
															-2.483,
															-0.745
														],
														[
															-0.446,
															-0.384
														],
														[
															-0.641,
															-1.255
														],
														[
															-0.589,
															-1.25
														],
														[
															-0.317,
															-1.094
														],
														[
															-1.92,
															-0.906
														],
														[
															-1.791,
															0.124
														],
														[
															-2.101,
															-0.149
														],
														[
															-8.906,
															1.814
														],
														[
															-6.937,
															3.557
														],
														[
															-7.396,
															6.635
														],
														[
															-5.63,
															6.953
														],
														[
															-1.45,
															1.737
														],
														[
															-0.86,
															1.397
														],
														[
															-0.37,
															0.291
														],
														[
															-0.236,
															0.37
														],
														[
															-0.272,
															0.898
														],
														[
															-0.422,
															0.639
														],
														[
															-0.42,
															0.136
														],
														[
															-0.175,
															0.233
														],
														[
															-0.112,
															0.557
														],
														[
															-0.248,
															0.367
														],
														[
															-1.004,
															1.471
														],
														[
															-0.857,
															1.45
														],
														[
															-1.312,
															2.276
														],
														[
															-1.322,
															2.479
														],
														[
															-1.418,
															3.318
														],
														[
															-1.588,
															3.467
														],
														[
															-6.299,
															22.72
														],
														[
															-3.595,
															25.013
														],
														[
															0.579,
															36.348
														],
														[
															5.773,
															34.211
														],
														[
															4.063,
															15.427
														],
														[
															4.923,
															13.56
														],
														[
															7.538,
															14.362
														],
														[
															9.118,
															11.775
														],
														[
															1.63,
															2.458
														],
														[
															0.751,
															0.83
														],
														[
															23.63,
															6.897
														],
														[
															4.163,
															0.602
														]
													],
													"o": [
														[
															-0.328,
															0.037
														],
														[
															-0.335,
															-0.014
														],
														[
															-4.606,
															0.296
														],
														[
															-4.947,
															1.496
														],
														[
															-1.483,
															0.708
														],
														[
															-1.347,
															0.663
														],
														[
															-0.591,
															0.335
														],
														[
															-0.435,
															0.556
														],
														[
															-0.7,
															0.459
														],
														[
															-0.906,
															0.265
														],
														[
															-0.214,
															0.151
														],
														[
															-0.145,
															0.414
														],
														[
															-0.394,
															0.367
														],
														[
															-0.539,
															0.073
														],
														[
															-0.226,
															0.172
														],
														[
															-0.139,
															0.406
														],
														[
															-0.388,
															0.361
														],
														[
															-0.544,
															0.074
														],
														[
															-1.197,
															0.946
														],
														[
															-1.163,
															1.25
														],
														[
															-1.283,
															1.174
														],
														[
															-1.158,
															1.164
														],
														[
															-4.443,
															4.783
														],
														[
															-4.231,
															5.152
														],
														[
															-7.303,
															11.279
														],
														[
															-6.018,
															12.895
														],
														[
															-9.421,
															26.762
														],
														[
															-5.145,
															32.631
														],
														[
															0,
															49.707
														],
														[
															10.489,
															46.092
														],
														[
															0.562,
															0.896
														],
														[
															0.528,
															0.648
														],
														[
															0.498,
															0.784
														],
														[
															0.262,
															0.876
														],
														[
															0.138,
															0.216
														],
														[
															0.423,
															0.139
														],
														[
															0.302,
															0.402
														],
														[
															0.115,
															0.559
														],
														[
															3.243,
															4.894
														],
														[
															3.859,
															4.54
														],
														[
															1.744,
															2.071
														],
														[
															1.803,
															1.549
														],
														[
															1.493,
															1.266
														],
														[
															1.575,
															1.483
														],
														[
															0.448,
															0.298
														],
														[
															0.296,
															0.362
														],
														[
															0.62,
															0.427
														],
														[
															0.922,
															0.286
														],
														[
															2.374,
															1.476
														],
														[
															2.83,
															1.655
														],
														[
															1.62,
															0.636
														],
														[
															2.483,
															0.745
														],
														[
															0.847,
															0.729
														],
														[
															0.641,
															1.255
														],
														[
															0.81,
															1.719
														],
														[
															0.317,
															1.094
														],
														[
															0.735,
															0.346
														],
														[
															1.791,
															-0.124
														],
														[
															11.438,
															0.812
														],
														[
															8.906,
															-1.814
														],
														[
															8.786,
															-4.505
														],
														[
															7.396,
															-6.636
														],
														[
															1.341,
															-1.656
														],
														[
															1.45,
															-1.737
														],
														[
															0.286,
															-0.465
														],
														[
															0.37,
															-0.292
														],
														[
															0.491,
															-0.77
														],
														[
															0.272,
															-0.898
														],
														[
															0.146,
															-0.221
														],
														[
															0.42,
															-0.136
														],
														[
															0.305,
															-0.407
														],
														[
															0.112,
															-0.557
														],
														[
															1.127,
															-1.667
														],
														[
															1.004,
															-1.471
														],
														[
															1.428,
															-2.418
														],
														[
															1.312,
															-2.276
														],
														[
															1.74,
															-3.262
														],
														[
															1.418,
															-3.318
														],
														[
															9.211,
															-20.106
														],
														[
															6.299,
															-22.72
														],
														[
															5.087,
															-35.396
														],
														[
															-0.579,
															-36.348
														],
														[
															-2.824,
															-16.734
														],
														[
															-4.063,
															-15.427
														],
														[
															-5.729,
															-15.779
														],
														[
															-7.538,
															-14.362
														],
														[
															-2.583,
															-3.336
														],
														[
															-0.685,
															-1.033
														],
														[
															-15.434,
															-17.058
														],
														[
															-3.992,
															-1.165
														],
														[
															-10.042,
															-1.452
														]
													],
													"v": [
														[
															350,
															16
														],
														[
															349.001,
															16.012
														],
														[
															348,
															16
														],
														[
															333.251,
															18.931
														],
														[
															320,
															24
														],
														[
															315.734,
															26.051
														],
														[
															312,
															28
														],
														[
															310.559,
															29.422
														],
														[
															309,
															31
														],
														[
															306.484,
															31.984
														],
														[
															304,
															33
														],
														[
															303.494,
															33.97
														],
														[
															303,
															35
														],
														[
															301.542,
															35.518
														],
														[
															300,
															36
														],
														[
															299.495,
															36.976
														],
														[
															299,
															38
														],
														[
															297.535,
															38.514
														],
														[
															296,
															39
														],
														[
															292.466,
															42.419
														],
														[
															289,
															46
														],
														[
															285.352,
															49.504
														],
														[
															282,
															53
														],
														[
															268.892,
															67.88
														],
														[
															257,
															84
														],
														[
															236.992,
															120.603
														],
														[
															221,
															160
														],
														[
															198.935,
															249.537
														],
														[
															191,
															354
														],
														[
															206.967,
															500.339
														],
														[
															253,
															620
														],
														[
															254.678,
															622.288
														],
														[
															256,
															624
														],
														[
															257.034,
															626.555
														],
														[
															258,
															629
														],
														[
															258.976,
															629.492
														],
														[
															260,
															630
														],
														[
															260.546,
															631.529
														],
														[
															261,
															633
														],
														[
															271.94,
															647.211
														],
														[
															283,
															660
														],
														[
															288.275,
															665.252
														],
														[
															294,
															670
														],
														[
															298.714,
															674.348
														],
														[
															303,
															678
														],
														[
															304.06,
															679.033
														],
														[
															305,
															680
														],
														[
															307.447,
															680.998
														],
														[
															310,
															682
														],
														[
															318.051,
															686.928
														],
														[
															326,
															691
														],
														[
															332.881,
															693.189
														],
														[
															338,
															695
														],
														[
															340.194,
															698.109
														],
														[
															342,
															702
														],
														[
															343.168,
															706.111
														],
														[
															346,
															709
														],
														[
															349.975,
															709.148
														],
														[
															356,
															709
														],
														[
															386.376,
															707.277
														],
														[
															410,
															699
														],
														[
															434.367,
															681.836
														],
														[
															454,
															661
														],
														[
															458.361,
															655.806
														],
														[
															462,
															651
														],
														[
															463.038,
															649.929
														],
														[
															464,
															649
														],
														[
															465.052,
															646.402
														],
														[
															466,
															644
														],
														[
															466.978,
															643.509
														],
														[
															468,
															643
														],
														[
															468.543,
															641.47
														],
														[
															469,
															640
														],
														[
															472.203,
															635.338
														],
														[
															475,
															631
														],
														[
															479.079,
															624.046
														],
														[
															483,
															617
														],
														[
															487.614,
															607.154
														],
														[
															492,
															597
														],
														[
															515.212,
															532.68
														],
														[
															530,
															461
														],
														[
															536.645,
															352.611
														],
														[
															527,
															246
														],
														[
															516.575,
															197.619
														],
														[
															503,
															154
														],
														[
															483.041,
															108.497
														],
														[
															458,
															69
														],
														[
															450,
															59
														],
														[
															448,
															57
														],
														[
															392,
															19
														],
														[
															380,
															16
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 70,
											"s": [
												{
													"i": [
														[
															9.667,
															-1.36
														],
														[
															2.764,
															-0.619
														],
														[
															2.747,
															-1.072
														],
														[
															2.381,
															-1.083
														],
														[
															1.485,
															-0.892
														],
														[
															0.621,
															-0.747
														],
														[
															0.787,
															-0.573
														],
														[
															0.539,
															-0.093
														],
														[
															0.395,
															-0.302
														],
														[
															0.32,
															-0.362
														],
														[
															0.384,
															-0.296
														],
														[
															3.391,
															-3.077
														],
														[
															2.043,
															-3.081
														],
														[
															0.333,
															-0.273
														],
														[
															0.339,
															-0.407
														],
														[
															9.92,
															-22.537
														],
														[
															6.009,
															-24.678
														],
														[
															1.16,
															-5.299
														],
														[
															1.101,
															-5.634
														],
														[
															1.166,
															-7.348
														],
														[
															0.958,
															-7.548
														],
														[
															-2.196,
															-44.551
														],
														[
															-8.683,
															-36.736
														],
														[
															-1.365,
															-5.07
														],
														[
															-1.353,
															-4.692
														],
														[
															-3.629,
															-9.57
														],
														[
															-3.7,
															-8.067
														],
														[
															-1.529,
															-2.556
														],
														[
															-1.399,
															-2.539
														],
														[
															-0.61,
															-1.556
														],
														[
															-0.825,
															-1.442
														],
														[
															-1.67,
															-2.426
														],
														[
															-1.133,
															-1.217
														],
														[
															-0.072,
															-0.529
														],
														[
															-0.337,
															-0.481
														],
														[
															-1.048,
															-1.135
														],
														[
															-0.932,
															-1.209
														],
														[
															-0.251,
															-0.682
														],
														[
															-0.52,
															-0.659
														],
														[
															-0.761,
															-0.457
														],
														[
															-0.488,
															-0.581
														],
														[
															-1.943,
															-2.402
														],
														[
															-2.144,
															-1.914
														],
														[
															-0.672,
															-0.466
														],
														[
															-0.712,
															-0.599
														],
														[
															-3.479,
															-2.357
														],
														[
															-3.775,
															-1.784
														],
														[
															-2.247,
															-0.68
														],
														[
															-0.696,
															-0.659
														],
														[
															-0.533,
															-2.246
														],
														[
															-0.997,
															-1.243
														],
														[
															-7.027,
															0
														],
														[
															-11.043,
															8.009
														],
														[
															-5.78,
															6.609
														],
														[
															-0.875,
															1.067
														],
														[
															-0.432,
															0.464
														],
														[
															-0.686,
															0.877
														],
														[
															-0.417,
															0.448
														],
														[
															-0.684,
															0.899
														],
														[
															-0.407,
															0.437
														],
														[
															-0.673,
															0.96
														],
														[
															-1.704,
															2.549
														],
														[
															-0.812,
															1.274
														],
														[
															-0.34,
															0.454
														],
														[
															-0.396,
															0.672
														],
														[
															-2.266,
															4.015
														],
														[
															-0.627,
															1.247
														],
														[
															-0.626,
															1.538
														],
														[
															-0.651,
															1.461
														],
														[
															-0.685,
															2.266
														],
														[
															-0.212,
															0.495
														],
														[
															-0.628,
															1.543
														],
														[
															-0.509,
															1.298
														],
														[
															-1.29,
															3.457
														],
														[
															-1.123,
															3.207
														],
														[
															-1.195,
															3.791
														],
														[
															-4.871,
															39.7
														],
														[
															27.818,
															82.864
														],
														[
															1.15,
															2.495
														],
														[
															0.617,
															1.339
														],
														[
															0.795,
															1.887
														],
														[
															2.104,
															4.592
														],
														[
															0.664,
															1.527
														],
														[
															0.778,
															1.539
														],
														[
															3.157,
															5.398
														],
														[
															2.356,
															3.675
														],
														[
															0.995,
															1.367
														],
														[
															9.745,
															6.464
														],
														[
															2.509,
															1.56
														],
														[
															0.666,
															0.412
														],
														[
															4.489,
															1.496
														]
													],
													"o": [
														[
															-3.196,
															0.45
														],
														[
															-2.764,
															0.62
														],
														[
															-1.992,
															0.777
														],
														[
															-2.381,
															1.083
														],
														[
															-0.728,
															0.438
														],
														[
															-0.621,
															0.747
														],
														[
															-0.449,
															0.328
														],
														[
															-0.539,
															0.093
														],
														[
															-0.336,
															0.257
														],
														[
															-0.32,
															0.362
														],
														[
															-3.391,
															2.612
														],
														[
															-3.391,
															3.077
														],
														[
															-0.331,
															0.499
														],
														[
															-0.332,
															0.273
														],
														[
															-14.31,
															17.172
														],
														[
															-9.92,
															22.537
														],
														[
															-1.258,
															5.169
														],
														[
															-1.16,
															5.299
														],
														[
															-1.38,
															7.061
														],
														[
															-1.166,
															7.347
														],
														[
															-5.466,
															43.06
														],
														[
															2.196,
															44.551
														],
														[
															1.189,
															5.03
														],
														[
															1.364,
															5.069
														],
														[
															2.783,
															9.652
														],
														[
															3.629,
															9.57
														],
														[
															1.484,
															3.236
														],
														[
															1.529,
															2.556
														],
														[
															0.735,
															1.334
														],
														[
															0.61,
															1.556
														],
														[
															1.189,
															2.077
														],
														[
															1.67,
															2.426
														],
														[
															0.376,
															0.404
														],
														[
															0.072,
															0.529
														],
														[
															0.875,
															1.251
														],
														[
															1.048,
															1.135
														],
														[
															0.474,
															0.615
														],
														[
															0.251,
															0.682
														],
														[
															0.469,
															0.592
														],
														[
															0.761,
															0.457
														],
														[
															2.083,
															2.48
														],
														[
															1.943,
															2.401
														],
														[
															0.6,
															0.535
														],
														[
															0.672,
															0.466
														],
														[
															3.31,
															2.787
														],
														[
															3.479,
															2.357
														],
														[
															1.317,
															0.622
														],
														[
															2.247,
															0.68
														],
														[
															1.871,
															1.772
														],
														[
															0.533,
															2.246
														],
														[
															2.298,
															2.866
														],
														[
															22.357,
															0
														],
														[
															7.94,
															-5.759
														],
														[
															0.66,
															-0.754
														],
														[
															0.388,
															-0.473
														],
														[
															0.726,
															-0.779
														],
														[
															0.36,
															-0.46
														],
														[
															0.733,
															-0.788
														],
														[
															0.344,
															-0.451
														],
														[
															0.753,
															-0.808
														],
														[
															1.763,
															-2.515
														],
														[
															0.901,
															-1.348
														],
														[
															0.276,
															-0.432
														],
														[
															0.56,
															-0.746
														],
														[
															2.594,
															-4.404
														],
														[
															0.702,
															-1.244
														],
														[
															0.749,
															-1.491
														],
														[
															0.542,
															-1.332
														],
														[
															1.044,
															-2.342
														],
														[
															0.11,
															-0.365
														],
														[
															0.657,
															-1.535
														],
														[
															0.585,
															-1.437
														],
														[
															1.315,
															-3.351
														],
														[
															1.215,
															-3.255
														],
														[
															1.206,
															-3.445
														],
														[
															10.651,
															-33.796
														],
														[
															13.405,
															-109.251
														],
														[
															-1.395,
															-4.156
														],
														[
															-0.774,
															-1.679
														],
														[
															-1.138,
															-2.468
														],
														[
															-2.352,
															-5.578
														],
														[
															-0.808,
															-1.764
														],
														[
															-0.682,
															-1.569
														],
														[
															-3.126,
															-6.184
														],
														[
															-2.593,
															-4.433
														],
														[
															-0.825,
															-1.288
														],
														[
															-7.339,
															-10.085
														],
														[
															-3.088,
															-2.048
														],
														[
															-0.601,
															-0.374
														],
														[
															-4.983,
															-3.085
														],
														[
															-12.799,
															-4.266
														]
													],
													"v": [
														[
															350,
															16
														],
														[
															341.164,
															17.533
														],
														[
															333,
															20
														],
														[
															326.12,
															22.914
														],
														[
															320,
															26
														],
														[
															318.044,
															27.898
														],
														[
															316,
															30
														],
														[
															314.46,
															30.519
														],
														[
															313,
															31
														],
														[
															312.036,
															31.97
														],
														[
															311,
															33
														],
														[
															300.489,
															41.649
														],
														[
															292,
															51
														],
														[
															291.006,
															52.069
														],
														[
															290,
															53
														],
														[
															253.774,
															113.371
														],
														[
															230,
															185
														],
														[
															226.381,
															200.652
														],
														[
															223,
															217
														],
														[
															219.184,
															238.635
														],
														[
															216,
															261
														],
														[
															211.389,
															394.743
														],
														[
															228,
															519
														],
														[
															231.877,
															534.254
														],
														[
															236,
															549
														],
														[
															245.813,
															578.189
														],
														[
															257,
															605
														],
														[
															261.564,
															613.523
														],
														[
															266,
															621
														],
														[
															267.933,
															625.419
														],
														[
															270,
															630
														],
														[
															274.542,
															637.145
														],
														[
															279,
															643
														],
														[
															279.53,
															644.443
														],
														[
															280,
															646
														],
														[
															282.958,
															649.531
														],
														[
															286,
															653
														],
														[
															286.965,
															654.967
														],
														[
															288,
															657
														],
														[
															289.985,
															658.509
														],
														[
															292,
															660
														],
														[
															297.954,
															667.425
														],
														[
															304,
															674
														],
														[
															305.916,
															675.452
														],
														[
															308,
															677
														],
														[
															318.15,
															684.752
														],
														[
															329,
															691
														],
														[
															334.966,
															692.972
														],
														[
															340,
															695
														],
														[
															343.155,
															701.396
														],
														[
															345,
															707
														],
														[
															364,
															710
														],
														[
															412,
															694
														],
														[
															434,
															675
														],
														[
															436,
															671
														],
														[
															438,
															670
														],
														[
															439,
															667
														],
														[
															441,
															666
														],
														[
															442,
															663
														],
														[
															444,
															662
														],
														[
															445,
															659
														],
														[
															451,
															652
														],
														[
															453,
															647
														],
														[
															455,
															646
														],
														[
															456,
															643
														],
														[
															463,
															630
														],
														[
															466,
															626
														],
														[
															467,
															621
														],
														[
															470,
															617
														],
														[
															472,
															610
														],
														[
															474,
															608
														],
														[
															475,
															603
														],
														[
															478,
															599
														],
														[
															481,
															588
														],
														[
															485,
															579
														],
														[
															488,
															568
														],
														[
															512,
															458
														],
														[
															485,
															146
														],
														[
															481,
															134
														],
														[
															479,
															129
														],
														[
															476,
															122
														],
														[
															469,
															108
														],
														[
															468,
															103
														],
														[
															465,
															99
														],
														[
															456,
															81
														],
														[
															448,
															69
														],
														[
															445,
															65
														],
														[
															418,
															35
														],
														[
															409,
															29
														],
														[
															407,
															27
														],
														[
															390,
															19
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 71,
											"s": [
												{
													"i": [
														[
															3.239,
															-0.489
														],
														[
															3.002,
															-1.007
														],
														[
															2.724,
															-1.363
														],
														[
															2.361,
															-1.549
														],
														[
															1.91,
															-1.567
														],
														[
															0.08,
															-0.172
														],
														[
															0.066,
															-0.199
														],
														[
															0.079,
															-0.177
														],
														[
															0.116,
															-0.108
														],
														[
															0.257,
															-0.072
														],
														[
															0.283,
															-0.041
														],
														[
															0.26,
															-0.073
														],
														[
															0.186,
															-0.17
														],
														[
															0.703,
															-0.852
														],
														[
															0.644,
															-0.892
														],
														[
															0.619,
															-0.844
														],
														[
															0.628,
															-0.707
														],
														[
															0.527,
															-0.581
														],
														[
															0.482,
															-0.545
														],
														[
															0.464,
															-0.566
														],
														[
															0.473,
															-0.645
														],
														[
															1.484,
															-2.187
														],
														[
															1.385,
															-2.21
														],
														[
															1.334,
															-2.293
														],
														[
															1.331,
															-2.436
														],
														[
															0.792,
															-1.405
														],
														[
															0.779,
															-1.417
														],
														[
															0.723,
															-1.428
														],
														[
															0.623,
															-1.44
														],
														[
															7.381,
															-35.991
														],
														[
															2.247,
															-39.638
														],
														[
															-3.133,
															-39.328
														],
														[
															-8.758,
															-35.062
														],
														[
															-5.015,
															-14.94
														],
														[
															-6.527,
															-13.214
														],
														[
															-8.51,
															-10.735
														],
														[
															-2.59,
															-2.842
														],
														[
															-2.408,
															-1.818
														],
														[
															-0.465,
															-0.531
														],
														[
															-0.57,
															-0.446
														],
														[
															-1.588,
															-0.905
														],
														[
															-0.53,
															-0.507
														],
														[
															-0.262,
															-0.065
														],
														[
															-0.543,
															-0.35
														],
														[
															-0.56,
															-0.638
														],
														[
															-0.385,
															-0.209
														],
														[
															-1.474,
															-0.382
														],
														[
															-0.647,
															-0.682
														],
														[
															-0.651,
															-2.635
														],
														[
															-2.312,
															-1.263
														],
														[
															-2.18,
															-0.167
														],
														[
															-1.843,
															-0.091
														],
														[
															-5.336,
															1.177
														],
														[
															-3.467,
															1.596
														],
														[
															-4.788,
															4.08
														],
														[
															-4.591,
															5.264
														],
														[
															-8.633,
															19.149
														],
														[
															-5.339,
															19.503
														],
														[
															-3.647,
															50.433
														],
														[
															4.922,
															50.861
														],
														[
															4.365,
															23.139
														],
														[
															6.258,
															19.856
														],
														[
															2.289,
															6.695
														],
														[
															2.731,
															6.513
														],
														[
															1.551,
															2.999
														],
														[
															1.493,
															2.894
														],
														[
															0.596,
															1.505
														],
														[
															0.823,
															1.445
														],
														[
															1.442,
															2.045
														],
														[
															1.036,
															1.721
														],
														[
															0.743,
															1.089
														],
														[
															0.423,
															0.638
														],
														[
															0.534,
															0.675
														],
														[
															0.312,
															0.47
														],
														[
															0.603,
															0.979
														],
														[
															0.813,
															0.916
														],
														[
															1.213,
															1.131
														],
														[
															0.971,
															1.154
														],
														[
															0.674,
															0.539
														],
														[
															1.214,
															0.547
														],
														[
															0.179,
															0.454
														],
														[
															0.148,
															0.123
														],
														[
															1.324,
															0.876
														],
														[
															0.613,
															0.587
														],
														[
															0.539,
															0.298
														],
														[
															0.425,
															0.407
														],
														[
															0.246,
															0.06
														],
														[
															0.588,
															0.349
														],
														[
															1.762,
															1.139
														],
														[
															1.358,
															0.494
														],
														[
															6.604,
															0.136
														]
													],
													"o": [
														[
															-3.192,
															0.483
														],
														[
															-3.002,
															1.007
														],
														[
															-2.724,
															1.363
														],
														[
															-2.361,
															1.549
														],
														[
															-0.118,
															0.097
														],
														[
															-0.08,
															0.172
														],
														[
															-0.066,
															0.199
														],
														[
															-0.079,
															0.177
														],
														[
															-0.18,
															0.168
														],
														[
															-0.257,
															0.072
														],
														[
															-0.283,
															0.041
														],
														[
															-0.26,
															0.073
														],
														[
															-0.796,
															0.725
														],
														[
															-0.703,
															0.852
														],
														[
															-0.644,
															0.892
														],
														[
															-0.619,
															0.844
														],
														[
															-0.599,
															0.675
														],
														[
															-0.527,
															0.581
														],
														[
															-0.482,
															0.545
														],
														[
															-0.464,
															0.566
														],
														[
															-1.63,
															2.223
														],
														[
															-1.484,
															2.187
														],
														[
															-1.385,
															2.21
														],
														[
															-1.334,
															2.293
														],
														[
															-0.761,
															1.394
														],
														[
															-0.792,
															1.405
														],
														[
															-0.779,
															1.417
														],
														[
															-0.723,
															1.428
														],
														[
															-12.271,
															28.388
														],
														[
															-7.381,
															35.991
														],
														[
															-2.247,
															39.638
														],
														[
															3.133,
															39.328
														],
														[
															3.975,
															15.913
														],
														[
															5.015,
															14.94
														],
														[
															6.527,
															13.214
														],
														[
															2.231,
															2.815
														],
														[
															2.59,
															2.842
														],
														[
															0.571,
															0.432
														],
														[
															0.465,
															0.531
														],
														[
															1.116,
															0.873
														],
														[
															1.588,
															0.905
														],
														[
															0.409,
															0.391
														],
														[
															0.262,
															0.065
														],
														[
															0.373,
															0.24
														],
														[
															0.56,
															0.638
														],
														[
															1.456,
															0.79
														],
														[
															1.474,
															0.382
														],
														[
															2.086,
															2.197
														],
														[
															0.651,
															2.635
														],
														[
															0.438,
															0.24
														],
														[
															2.18,
															0.167
														],
														[
															6.19,
															0.305
														],
														[
															5.336,
															-1.177
														],
														[
															5.255,
															-2.418
														],
														[
															4.788,
															-4.08
														],
														[
															12.129,
															-13.903
														],
														[
															8.633,
															-19.149
														],
														[
															11.334,
															-41.408
														],
														[
															3.647,
															-50.433
														],
														[
															-2.283,
															-23.588
														],
														[
															-4.365,
															-23.139
														],
														[
															-2.115,
															-6.709
														],
														[
															-2.289,
															-6.695
														],
														[
															-1.305,
															-3.112
														],
														[
															-1.551,
															-2.999
														],
														[
															-0.793,
															-1.537
														],
														[
															-0.596,
															-1.505
														],
														[
															-1.197,
															-2.1
														],
														[
															-1.442,
															-2.045
														],
														[
															-0.606,
															-1.006
														],
														[
															-0.743,
															-1.089
														],
														[
															-0.552,
															-0.831
														],
														[
															-0.534,
															-0.675
														],
														[
															-0.774,
															-1.167
														],
														[
															-0.603,
															-0.979
														],
														[
															-1.175,
															-1.324
														],
														[
															-1.213,
															-1.131
														],
														[
															-1.09,
															-1.294
														],
														[
															-0.674,
															-0.54
														],
														[
															-0.137,
															-0.062
														],
														[
															-0.179,
															-0.454
														],
														[
															-1.091,
															-0.909
														],
														[
															-1.324,
															-0.876
														],
														[
															-0.419,
															-0.401
														],
														[
															-0.539,
															-0.298
														],
														[
															-0.427,
															-0.409
														],
														[
															-0.246,
															-0.06
														],
														[
															-1.596,
															-0.948
														],
														[
															-1.762,
															-1.14
														],
														[
															-5.346,
															-1.944
														],
														[
															-6.604,
															-0.136
														]
													],
													"v": [
														[
															351,
															16
														],
														[
															341.688,
															18.277
														],
														[
															333.077,
															21.874
														],
														[
															325.428,
															26.284
														],
														[
															319,
															31
														],
														[
															318.709,
															31.415
														],
														[
															318.497,
															31.983
														],
														[
															318.285,
															32.56
														],
														[
															318,
															33
														],
														[
															317.331,
															33.344
														],
														[
															316.509,
															33.497
														],
														[
															315.682,
															33.652
														],
														[
															315,
															34
														],
														[
															312.76,
															36.388
														],
														[
															310.748,
															39.026
														],
														[
															308.862,
															41.652
														],
														[
															307,
															44
														],
														[
															305.318,
															45.869
														],
														[
															303.812,
															47.544
														],
														[
															302.399,
															49.197
														],
														[
															301,
															51
														],
														[
															296.341,
															57.6
														],
														[
															292.051,
															64.18
														],
														[
															287.985,
															70.921
														],
														[
															284,
															78
														],
														[
															281.659,
															82.198
														],
														[
															279.292,
															86.431
														],
														[
															277.029,
															90.698
														],
														[
															275,
															95
														],
														[
															245.46,
															192.558
														],
														[
															230.956,
															306.989
														],
														[
															232.225,
															426.427
														],
														[
															250,
															539
														],
														[
															263.368,
															585.468
														],
														[
															280.563,
															627.888
														],
														[
															303,
															664
														],
														[
															310.368,
															672.747
														],
														[
															318,
															680
														],
														[
															319.501,
															681.49
														],
														[
															321,
															683
														],
														[
															325.44,
															685.774
														],
														[
															329,
															688
														],
														[
															329.899,
															688.531
														],
														[
															331,
															689
														],
														[
															332.49,
															690.523
														],
														[
															334,
															692
														],
														[
															338.606,
															693.581
														],
														[
															342,
															695
														],
														[
															345.331,
															702.701
														],
														[
															349,
															709
														],
														[
															353.446,
															709.611
														],
														[
															360,
															710
														],
														[
															377.541,
															708.426
														],
														[
															391,
															704
														],
														[
															405.997,
															694.134
														],
														[
															420,
															680
														],
														[
															451.092,
															629.2
														],
														[
															472,
															570
														],
														[
															494.692,
															430.09
														],
														[
															493,
															276
														],
														[
															482.982,
															205.202
														],
														[
															467,
															140
														],
														[
															460.462,
															119.853
														],
														[
															453,
															100
														],
														[
															448.641,
															90.837
														],
														[
															444,
															82
														],
														[
															442.022,
															77.43
														],
														[
															440,
															73
														],
														[
															435.879,
															66.715
														],
														[
															432,
															61
														],
														[
															429.863,
															57.724
														],
														[
															428,
															55
														],
														[
															426.32,
															52.729
														],
														[
															425,
															51
														],
														[
															423.029,
															47.812
														],
														[
															421,
															45
														],
														[
															417.347,
															41.372
														],
														[
															414,
															38
														],
														[
															411.593,
															35.44
														],
														[
															409,
															34
														],
														[
															408.508,
															33.046
														],
														[
															408,
															32
														],
														[
															404.142,
															29.259
														],
														[
															401,
															27
														],
														[
															399.505,
															26.005
														],
														[
															398,
															25
														],
														[
															397.121,
															24.455
														],
														[
															396,
															24
														],
														[
															390.822,
															20.66
														],
														[
															386,
															18
														],
														[
															366.92,
															15.175
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 72,
											"s": [
												{
													"i": [
														[
															2.113,
															-0.387
														],
														[
															1.747,
															-0.582
														],
														[
															1.478,
															-0.716
														],
														[
															1.243,
															-0.776
														],
														[
															1.039,
															-0.762
														],
														[
															0.871,
															-0.714
														],
														[
															0.762,
															-0.703
														],
														[
															0.76,
															-0.762
														],
														[
															0.864,
															-0.892
														],
														[
															0.826,
															-0.776
														],
														[
															0.813,
															-0.763
														],
														[
															0.705,
															-0.731
														],
														[
															0.502,
															-0.679
														],
														[
															0.159,
															-0.421
														],
														[
															0.123,
															-0.446
														],
														[
															0.153,
															-0.427
														],
														[
															0.248,
															-0.364
														],
														[
															0.258,
															-0.245
														],
														[
															0.283,
															-0.239
														],
														[
															0.259,
															-0.249
														],
														[
															0.186,
															-0.277
														],
														[
															1.349,
															-2.369
														],
														[
															1.211,
															-2.421
														],
														[
															1.131,
															-2.467
														],
														[
															1.111,
															-2.506
														],
														[
															3.277,
															-9.421
														],
														[
															2.727,
															-9.952
														],
														[
															2.211,
															-10.305
														],
														[
															1.731,
															-10.481
														],
														[
															1.954,
															-27.846
														],
														[
															-0.176,
															-28.747
														],
														[
															-2.292,
															-27.527
														],
														[
															-4.394,
															-24.187
														],
														[
															-1.056,
															-5.232
														],
														[
															-1.178,
															-5.216
														],
														[
															-1.283,
															-5
														],
														[
															-1.37,
															-4.587
														],
														[
															-0.855,
															-2.488
														],
														[
															-0.884,
															-2.387
														],
														[
															-0.837,
															-2.205
														],
														[
															-0.715,
															-1.942
														],
														[
															-0.237,
															-0.839
														],
														[
															-0.226,
															-0.862
														],
														[
															-0.251,
															-0.842
														],
														[
															-0.312,
															-0.779
														],
														[
															-2.792,
															-5.689
														],
														[
															-3.198,
															-5.139
														],
														[
															-3.682,
															-4.505
														],
														[
															-4.244,
															-3.787
														],
														[
															-0.442,
															-0.501
														],
														[
															-0.468,
															-0.534
														],
														[
															-0.541,
															-0.517
														],
														[
															-0.663,
															-0.447
														],
														[
															-0.888,
															-0.389
														],
														[
															-1.01,
															-0.41
														],
														[
															-0.742,
															-0.316
														],
														[
															-0.084,
															-0.108
														],
														[
															-0.341,
															-1.329
														],
														[
															-0.191,
															-1.339
														],
														[
															-0.38,
															-1.09
														],
														[
															-0.908,
															-0.583
														],
														[
															-0.98,
															-0.123
														],
														[
															-1.472,
															-0.109
														],
														[
															-1.631,
															-0.056
														],
														[
															-1.457,
															0.035
														],
														[
															-2.483,
															0.403
														],
														[
															-2.055,
															0.693
														],
														[
															-1.795,
															0.943
														],
														[
															-1.702,
															1.154
														],
														[
															-1.211,
															0.931
														],
														[
															-1.125,
															0.96
														],
														[
															-0.976,
															0.924
														],
														[
															-0.765,
															0.822
														],
														[
															-0.073,
															0.253
														],
														[
															-0.038,
															0.277
														],
														[
															-0.071,
															0.261
														],
														[
															-0.172,
															0.205
														],
														[
															-0.846,
															0.773
														],
														[
															-0.784,
															0.736
														],
														[
															-0.572,
															0.791
														],
														[
															-0.318,
															0.732
														],
														[
															-0.36,
															0.561
														],
														[
															-7.038,
															19.869
														],
														[
															-4.483,
															20.355
														],
														[
															1.065,
															74.768
														],
														[
															15.711,
															59.498
														],
														[
															3.352,
															10.162
														],
														[
															4.597,
															10.005
														],
														[
															8.523,
															10.952
														],
														[
															11.004,
															3.348
														],
														[
															5.11,
															0.009
														]
													],
													"o": [
														[
															-2.047,
															0.375
														],
														[
															-1.747,
															0.582
														],
														[
															-1.478,
															0.716
														],
														[
															-1.242,
															0.776
														],
														[
															-1.086,
															0.796
														],
														[
															-0.871,
															0.714
														],
														[
															-0.762,
															0.703
														],
														[
															-0.76,
															0.762
														],
														[
															-0.745,
															0.769
														],
														[
															-0.826,
															0.776
														],
														[
															-0.813,
															0.763
														],
														[
															-0.705,
															0.731
														],
														[
															-0.26,
															0.352
														],
														[
															-0.159,
															0.421
														],
														[
															-0.123,
															0.446
														],
														[
															-0.153,
															0.427
														],
														[
															-0.183,
															0.268
														],
														[
															-0.258,
															0.245
														],
														[
															-0.283,
															0.239
														],
														[
															-0.259,
															0.249
														],
														[
															-1.546,
															2.309
														],
														[
															-1.349,
															2.369
														],
														[
															-1.211,
															2.421
														],
														[
															-1.131,
															2.467
														],
														[
															-3.862,
															8.711
														],
														[
															-3.277,
															9.421
														],
														[
															-2.727,
															9.952
														],
														[
															-2.211,
															10.305
														],
														[
															-4.099,
															24.825
														],
														[
															-1.954,
															27.846
														],
														[
															0.176,
															28.747
														],
														[
															2.292,
															27.527
														],
														[
															0.918,
															5.051
														],
														[
															1.056,
															5.232
														],
														[
															1.178,
															5.216
														],
														[
															1.283,
															5
														],
														[
															0.749,
															2.508
														],
														[
															0.854,
															2.488
														],
														[
															0.884,
															2.387
														],
														[
															0.837,
															2.205
														],
														[
															0.284,
															0.773
														],
														[
															0.237,
															0.839
														],
														[
															0.226,
															0.862
														],
														[
															0.251,
															0.842
														],
														[
															2.463,
															6.155
														],
														[
															2.792,
															5.689
														],
														[
															3.198,
															5.139
														],
														[
															3.682,
															4.505
														],
														[
															0.466,
															0.416
														],
														[
															0.442,
															0.501
														],
														[
															0.468,
															0.534
														],
														[
															0.541,
															0.517
														],
														[
															0.376,
															0.254
														],
														[
															0.888,
															0.389
														],
														[
															1.01,
															0.41
														],
														[
															0.742,
															0.316
														],
														[
															0.829,
															1.062
														],
														[
															0.341,
															1.329
														],
														[
															0.191,
															1.339
														],
														[
															0.38,
															1.09
														],
														[
															0.154,
															0.099
														],
														[
															0.98,
															0.123
														],
														[
															1.472,
															0.109
														],
														[
															1.631,
															0.056
														],
														[
															3.078,
															-0.074
														],
														[
															2.483,
															-0.403
														],
														[
															2.055,
															-0.693
														],
														[
															1.795,
															-0.943
														],
														[
															1.235,
															-0.837
														],
														[
															1.211,
															-0.931
														],
														[
															1.125,
															-0.96
														],
														[
															0.976,
															-0.924
														],
														[
															0.176,
															-0.189
														],
														[
															0.073,
															-0.253
														],
														[
															0.038,
															-0.277
														],
														[
															0.071,
															-0.261
														],
														[
															0.758,
															-0.904
														],
														[
															0.846,
															-0.773
														],
														[
															0.784,
															-0.736
														],
														[
															0.369,
															-0.51
														],
														[
															0.318,
															-0.732
														],
														[
															10.366,
															-16.169
														],
														[
															7.038,
															-19.869
														],
														[
															13.969,
															-63.43
														],
														[
															-1.065,
															-74.768
														],
														[
															-2.996,
															-11.346
														],
														[
															-3.352,
															-10.162
														],
														[
															-5.903,
															-12.846
														],
														[
															-8.523,
															-10.951
														],
														[
															-4.446,
															-1.352
														],
														[
															-5.11,
															-0.009
														]
													],
													"v": [
														[
															352,
															16
														],
														[
															346.317,
															17.454
														],
														[
															341.487,
															19.419
														],
														[
															337.414,
															21.675
														],
														[
															334,
															24
														],
														[
															331.091,
															26.248
														],
														[
															328.668,
															28.356
														],
														[
															326.41,
															30.536
														],
														[
															324,
															33
														],
														[
															321.62,
															35.322
														],
														[
															319.136,
															37.635
														],
														[
															316.835,
															39.88
														],
														[
															315,
															42
														],
														[
															314.388,
															43.17
														],
														[
															313.982,
															44.482
														],
														[
															313.585,
															45.803
														],
														[
															313,
															47
														],
														[
															312.327,
															47.766
														],
														[
															311.504,
															48.487
														],
														[
															310.679,
															49.215
														],
														[
															310,
															50
														],
														[
															305.672,
															57.018
														],
														[
															301.847,
															64.204
														],
														[
															298.349,
															71.539
														],
														[
															295,
															79
														],
														[
															284.3,
															106.242
														],
														[
															275.303,
															135.346
														],
														[
															267.904,
															165.777
														],
														[
															262,
															197
														],
														[
															252.924,
															276.537
														],
														[
															250.261,
															361.957
														],
														[
															253.967,
															446.899
														],
														[
															264,
															525
														],
														[
															266.965,
															540.474
														],
														[
															270.322,
															556.195
														],
														[
															274.017,
															571.569
														],
														[
															278,
															586
														],
														[
															280.424,
															593.515
														],
														[
															283.051,
															600.849
														],
														[
															285.652,
															607.759
														],
														[
															288,
															614
														],
														[
															288.774,
															616.429
														],
														[
															289.459,
															618.992
														],
														[
															290.166,
															621.559
														],
														[
															291,
															624
														],
														[
															298.863,
															641.788
														],
														[
															307.829,
															658.053
														],
														[
															318.131,
															672.541
														],
														[
															330,
															685
														],
														[
															331.35,
															686.387
														],
														[
															332.703,
															687.952
														],
														[
															334.205,
															689.541
														],
														[
															336,
															691
														],
														[
															337.994,
															691.993
														],
														[
															340.939,
															693.22
														],
														[
															343.664,
															694.336
														],
														[
															345,
															695
														],
														[
															346.67,
															698.651
														],
														[
															347.382,
															702.718
														],
														[
															348.154,
															706.426
														],
														[
															350,
															709
														],
														[
															351.785,
															709.344
														],
														[
															355.545,
															709.702
														],
														[
															360.284,
															709.959
														],
														[
															365,
															710
														],
														[
															373.299,
															709.273
														],
														[
															380.064,
															707.619
														],
														[
															385.797,
															705.155
														],
														[
															391,
															702
														],
														[
															394.685,
															699.331
														],
														[
															398.205,
															696.478
														],
														[
															401.372,
															693.635
														],
														[
															404,
															691
														],
														[
															404.356,
															690.328
														],
														[
															404.506,
															689.524
														],
														[
															404.653,
															688.708
														],
														[
															405,
															688
														],
														[
															407.444,
															685.507
														],
														[
															409.928,
															683.267
														],
														[
															412,
															681
														],
														[
															413.007,
															679.038
														],
														[
															414,
															677
														],
														[
															439.913,
															622.139
														],
														[
															457,
															561
														],
														[
															476.26,
															347.051
														],
														[
															451,
															139
														],
														[
															441.701,
															106.994
														],
														[
															430,
															77
														],
														[
															408.325,
															39.876
														],
														[
															379,
															17
														],
														[
															363.751,
															15.195
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 73,
											"s": [
												{
													"i": [
														[
															1.235,
															-0.276
														],
														[
															0.259,
															0.019
														],
														[
															0.271,
															0.034
														],
														[
															0.252,
															-0.002
														],
														[
															0.2,
															-0.088
														],
														[
															4.142,
															-4.034
														],
														[
															3.289,
															-5.206
														],
														[
															2.628,
															-5.819
														],
														[
															2.158,
															-5.872
														],
														[
															2.011,
															-6.437
														],
														[
															1.721,
															-6.497
														],
														[
															1.474,
															-6.562
														],
														[
															1.27,
															-6.631
														],
														[
															1.725,
															-10.871
														],
														[
															1.363,
															-11.083
														],
														[
															0.957,
															-11.296
														],
														[
															0.506,
															-11.509
														],
														[
															0.157,
															-16.274
														],
														[
															-0.356,
															-16.103
														],
														[
															-0.835,
															-15.528
														],
														[
															-1.28,
															-14.548
														],
														[
															-1.661,
															-12.803
														],
														[
															-2.209,
															-12.256
														],
														[
															-2.819,
															-11.7
														],
														[
															-3.49,
															-11.136
														],
														[
															-1.702,
															-4.637
														],
														[
															-1.941,
															-4.488
														],
														[
															-2.143,
															-4.107
														],
														[
															-2.31,
															-3.494
														],
														[
															-0.616,
															-0.72
														],
														[
															-0.668,
															-0.712
														],
														[
															-0.593,
															-0.636
														],
														[
															-0.393,
															-0.492
														],
														[
															-0.165,
															-0.362
														],
														[
															-0.125,
															-0.355
														],
														[
															-0.147,
															-0.316
														],
														[
															-0.231,
															-0.244
														],
														[
															-0.582,
															-0.487
														],
														[
															-0.631,
															-0.445
														],
														[
															-0.609,
															-0.36
														],
														[
															-0.515,
															-0.232
														],
														[
															-0.081,
															-0.175
														],
														[
															-0.083,
															-0.226
														],
														[
															-0.086,
															-0.188
														],
														[
															-0.09,
															-0.062
														],
														[
															-0.407,
															-0.176
														],
														[
															-0.369,
															-0.132
														],
														[
															-0.278,
															-0.14
														],
														[
															-0.133,
															-0.199
														],
														[
															-0.29,
															-1.118
														],
														[
															-0.072,
															-1.029
														],
														[
															-0.121,
															-0.897
														],
														[
															-0.437,
															-0.721
														],
														[
															-2.426,
															-0.486
														],
														[
															-3.014,
															0.101
														],
														[
															-2.581,
															0.412
														],
														[
															-1.126,
															0.447
														],
														[
															-0.214,
															0.226
														],
														[
															-0.231,
															0.295
														],
														[
															-0.277,
															0.297
														],
														[
															-0.351,
															0.23
														],
														[
															-0.472,
															0.181
														],
														[
															-0.472,
															0.143
														],
														[
															-0.389,
															0.141
														],
														[
															-0.222,
															0.175
														],
														[
															-1.116,
															1.198
														],
														[
															-0.873,
															1.221
														],
														[
															-0.82,
															1.287
														],
														[
															-0.96,
															1.397
														],
														[
															-0.721,
															0.89
														],
														[
															-0.678,
															0.878
														],
														[
															-0.503,
															0.886
														],
														[
															-0.57,
															1.693
														],
														[
															-0.817,
															1.64
														],
														[
															-0.89,
															1.478
														],
														[
															-0.613,
															1.428
														],
														[
															-3.881,
															14.498
														],
														[
															-2.84,
															14.863
														],
														[
															-3.349,
															34.159
														],
														[
															0,
															34.039
														],
														[
															2.357,
															33.368
														],
														[
															5.571,
															33.558
														],
														[
															3.273,
															14.411
														],
														[
															5.156,
															14.776
														],
														[
															4.727,
															9.683
														],
														[
															6.049,
															6.546
														],
														[
															2.026,
															1.477
														],
														[
															2.13,
															1.184
														],
														[
															0.634,
															0.578
														],
														[
															0.496,
															0.151
														],
														[
															4.555,
															-0.201
														]
													],
													"o": [
														[
															-0.215,
															0.048
														],
														[
															-0.259,
															-0.019
														],
														[
															-0.271,
															-0.034
														],
														[
															-0.252,
															0.002
														],
														[
															-5.185,
															2.302
														],
														[
															-4.142,
															4.034
														],
														[
															-3.289,
															5.206
														],
														[
															-2.628,
															5.819
														],
														[
															-2.345,
															6.381
														],
														[
															-2.011,
															6.437
														],
														[
															-1.721,
															6.497
														],
														[
															-1.474,
															6.562
														],
														[
															-2.042,
															10.659
														],
														[
															-1.725,
															10.871
														],
														[
															-1.363,
															11.083
														],
														[
															-0.957,
															11.296
														],
														[
															-0.705,
															16.041
														],
														[
															-0.157,
															16.274
														],
														[
															0.356,
															16.103
														],
														[
															0.835,
															15.528
														],
														[
															1.174,
															13.341
														],
														[
															1.661,
															12.803
														],
														[
															2.209,
															12.256
														],
														[
															2.819,
															11.7
														],
														[
															1.427,
															4.554
														],
														[
															1.702,
															4.637
														],
														[
															1.941,
															4.488
														],
														[
															2.143,
															4.107
														],
														[
															0.438,
															0.661
														],
														[
															0.616,
															0.72
														],
														[
															0.668,
															0.712
														],
														[
															0.593,
															0.636
														],
														[
															0.267,
															0.335
														],
														[
															0.165,
															0.362
														],
														[
															0.125,
															0.355
														],
														[
															0.147,
															0.316
														],
														[
															0.462,
															0.486
														],
														[
															0.582,
															0.487
														],
														[
															0.631,
															0.445
														],
														[
															0.609,
															0.36
														],
														[
															0.079,
															0.036
														],
														[
															0.081,
															0.175
														],
														[
															0.083,
															0.226
														],
														[
															0.086,
															0.188
														],
														[
															0.392,
															0.271
														],
														[
															0.407,
															0.176
														],
														[
															0.369,
															0.132
														],
														[
															0.278,
															0.14
														],
														[
															0.776,
															1.164
														],
														[
															0.29,
															1.118
														],
														[
															0.072,
															1.029
														],
														[
															0.121,
															0.897
														],
														[
															0.817,
															1.349
														],
														[
															2.426,
															0.486
														],
														[
															3.014,
															-0.101
														],
														[
															2.581,
															-0.412
														],
														[
															0.224,
															-0.089
														],
														[
															0.214,
															-0.226
														],
														[
															0.231,
															-0.295
														],
														[
															0.277,
															-0.297
														],
														[
															0.388,
															-0.255
														],
														[
															0.472,
															-0.181
														],
														[
															0.472,
															-0.143
														],
														[
															0.389,
															-0.141
														],
														[
															1.55,
															-1.22
														],
														[
															1.116,
															-1.198
														],
														[
															0.873,
															-1.221
														],
														[
															0.82,
															-1.287
														],
														[
															0.633,
															-0.921
														],
														[
															0.721,
															-0.89
														],
														[
															0.678,
															-0.878
														],
														[
															0.903,
															-1.589
														],
														[
															0.57,
															-1.693
														],
														[
															0.827,
															-1.659
														],
														[
															0.89,
															-1.478
														],
														[
															5.637,
															-13.144
														],
														[
															3.881,
															-14.498
														],
														[
															5.603,
															-29.327
														],
														[
															3.349,
															-34.159
														],
														[
															0,
															-36.969
														],
														[
															-2.357,
															-33.368
														],
														[
															-2.752,
															-16.58
														],
														[
															-3.273,
															-14.411
														],
														[
															-3.044,
															-8.722
														],
														[
															-4.727,
															-9.683
														],
														[
															-1.764,
															-1.909
														],
														[
															-2.026,
															-1.477
														],
														[
															-0.969,
															-0.538
														],
														[
															-0.634,
															-0.578
														],
														[
															-3.543,
															-1.08
														],
														[
															-4.555,
															0.201
														]
													],
													"v": [
														[
															353,
															16
														],
														[
															352.281,
															16.031
														],
														[
															351.477,
															15.939
														],
														[
															350.685,
															15.878
														],
														[
															350,
															16
														],
														[
															336.059,
															25.644
														],
														[
															324.96,
															39.644
														],
														[
															316.131,
															56.323
														],
														[
															309,
															74
														],
														[
															302.477,
															93.226
														],
														[
															296.888,
															112.625
														],
														[
															292.106,
															132.212
														],
														[
															288,
															152
														],
														[
															282.339,
															184.294
														],
														[
															277.696,
															217.225
														],
														[
															274.205,
															250.793
														],
														[
															272,
															285
														],
														[
															270.715,
															333.572
														],
														[
															271.022,
															382.238
														],
														[
															272.818,
															429.785
														],
														[
															276,
															475
														],
														[
															280.237,
															514.218
														],
														[
															286.026,
															551.808
														],
														[
															293.552,
															587.744
														],
														[
															303,
															622
														],
														[
															307.703,
															635.844
														],
														[
															313.175,
															649.59
														],
														[
															319.311,
															662.541
														],
														[
															326,
															674
														],
														[
															327.611,
															676.09
														],
														[
															329.567,
															678.254
														],
														[
															331.49,
															680.292
														],
														[
															333,
															682
														],
														[
															333.634,
															683.054
														],
														[
															334.054,
															684.137
														],
														[
															334.448,
															685.152
														],
														[
															335,
															686
														],
														[
															336.583,
															687.471
														],
														[
															338.42,
															688.881
														],
														[
															340.297,
															690.101
														],
														[
															342,
															691
														],
														[
															342.24,
															691.338
														],
														[
															342.485,
															691.961
														],
														[
															342.737,
															692.603
														],
														[
															343,
															693
														],
														[
															344.211,
															693.658
														],
														[
															345.388,
															694.108
														],
														[
															346.371,
															694.504
														],
														[
															347,
															695
														],
														[
															348.533,
															698.433
														],
														[
															349.009,
															701.664
														],
														[
															349.231,
															704.562
														],
														[
															350,
															707
														],
														[
															355.12,
															709.685
														],
														[
															363.536,
															710.194
														],
														[
															372.184,
															709.357
														],
														[
															378,
															708
														],
														[
															378.649,
															707.511
														],
														[
															379.31,
															706.712
														],
														[
															380.065,
															705.807
														],
														[
															381,
															705
														],
														[
															382.311,
															704.356
														],
														[
															383.749,
															703.881
														],
														[
															385.062,
															703.465
														],
														[
															386,
															703
														],
														[
															389.951,
															699.383
														],
														[
															392.886,
															695.766
														],
														[
															395.378,
															692.015
														],
														[
															398,
															688
														],
														[
															400.064,
															685.289
														],
														[
															402.195,
															682.641
														],
														[
															404,
															680
														],
														[
															406.064,
															675.039
														],
														[
															408,
															670
														],
														[
															410.661,
															665.327
														],
														[
															413,
															661
														],
														[
															427.097,
															619.289
														],
														[
															437,
															575
														],
														[
															450.703,
															478.534
														],
														[
															456,
															375
														],
														[
															452.678,
															270.441
														],
														[
															441,
															171
														],
														[
															432.303,
															125.147
														],
														[
															420,
															82
														],
														[
															408.254,
															53.368
														],
														[
															392,
															28
														],
														[
															386.274,
															22.956
														],
														[
															380,
															19
														],
														[
															377.645,
															17.21
														],
														[
															376,
															16
														],
														[
															362.769,
															14.983
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 74,
											"s": [
												{
													"i": [
														[
															1.017,
															-0.288
														],
														[
															0.268,
															-0.072
														],
														[
															0.225,
															-0.068
														],
														[
															0.219,
															-0.087
														],
														[
															0.251,
															-0.128
														],
														[
															1.867,
															-1.821
														],
														[
															1.629,
															-2.366
														],
														[
															1.448,
															-2.737
														],
														[
															1.323,
															-2.933
														],
														[
															2.087,
															-6.033
														],
														[
															1.674,
															-6.21
														],
														[
															1.375,
															-6.321
														],
														[
															1.19,
															-6.369
														],
														[
															0.253,
															-1.751
														],
														[
															0.222,
															-1.75
														],
														[
															0.232,
															-1.749
														],
														[
															0.285,
															-1.749
														],
														[
															0.362,
															-1.677
														],
														[
															0.379,
															-1.668
														],
														[
															0.328,
															-1.657
														],
														[
															0.208,
															-1.644
														],
														[
															0.739,
															-7.096
														],
														[
															0.644,
															-7.278
														],
														[
															0.582,
															-7.418
														],
														[
															0.556,
															-7.517
														],
														[
															0.59,
															-11.21
														],
														[
															0.285,
															-11.166
														],
														[
															-0.072,
															-11.248
														],
														[
															-0.483,
															-11.455
														],
														[
															-0.074,
															-3.998
														],
														[
															-0.042,
															-3.947
														],
														[
															-0.072,
															-3.851
														],
														[
															-0.163,
															-3.709
														],
														[
															-1.326,
															-17.533
														],
														[
															-1.983,
															-16.578
														],
														[
															-2.791,
															-15.756
														],
														[
															-3.748,
															-15.066
														],
														[
															-0.364,
															-1.311
														],
														[
															-0.355,
															-1.201
														],
														[
															-0.314,
															-1.039
														],
														[
															-0.24,
															-0.827
														],
														[
															-1.194,
															-3.618
														],
														[
															-1.315,
															-3.381
														],
														[
															-1.464,
															-3.073
														],
														[
															-1.639,
															-2.692
														],
														[
															-0.447,
															-0.556
														],
														[
															-0.463,
															-0.509
														],
														[
															-0.41,
															-0.448
														],
														[
															-0.287,
															-0.375
														],
														[
															-0.07,
															-0.253
														],
														[
															-0.044,
															-0.271
														],
														[
															-0.077,
															-0.257
														],
														[
															-0.168,
															-0.213
														],
														[
															-0.345,
															-0.257
														],
														[
															-0.346,
															-0.192
														],
														[
															-0.328,
															-0.213
														],
														[
															-0.291,
															-0.323
														],
														[
															-0.254,
															-0.345
														],
														[
															-0.239,
															-0.399
														],
														[
															-0.24,
															-0.48
														],
														[
															-0.258,
															-0.587
														],
														[
															-0.042,
															-0.729
														],
														[
															0.139,
															-0.542
														],
														[
															0.111,
															-0.416
														],
														[
															-0.124,
															-0.354
														],
														[
															-0.309,
															-0.328
														],
														[
															-0.388,
															-0.098
														],
														[
															-0.51,
															-0.096
														],
														[
															-0.674,
															-0.322
														],
														[
															-1.83,
															-0.17
														],
														[
															-1.821,
															0.344
														],
														[
															-1.706,
															0.717
														],
														[
															-1.483,
															0.948
														],
														[
															-1.477,
															1.562
														],
														[
															-1.195,
															1.702
														],
														[
															-0.903,
															1.537
														],
														[
															-2.419,
															6.297
														],
														[
															-1.671,
															5.594
														],
														[
															-3.177,
															16.905
														],
														[
															-1.859,
															15.542
														],
														[
															-0.684,
															5.728
														],
														[
															-0.51,
															5.793
														],
														[
															-1.023,
															43.248
														],
														[
															2.528,
															39.966
														],
														[
															3.663,
															30.807
														],
														[
															7.257,
															28.691
														],
														[
															2.15,
															6.561
														],
														[
															2.835,
															6.569
														],
														[
															3.772,
															5.494
														],
														[
															5.152,
															1.63
														],
														[
															3.465,
															-0.175
														]
													],
													"o": [
														[
															-0.35,
															0.099
														],
														[
															-0.268,
															0.072
														],
														[
															-0.225,
															0.068
														],
														[
															-0.219,
															0.087
														],
														[
															-2.161,
															1.102
														],
														[
															-1.867,
															1.821
														],
														[
															-1.629,
															2.366
														],
														[
															-1.448,
															2.737
														],
														[
															-2.613,
															5.793
														],
														[
															-2.087,
															6.033
														],
														[
															-1.674,
															6.21
														],
														[
															-1.375,
															6.321
														],
														[
															-0.327,
															1.752
														],
														[
															-0.253,
															1.751
														],
														[
															-0.222,
															1.75
														],
														[
															-0.232,
															1.749
														],
														[
															-0.275,
															1.684
														],
														[
															-0.362,
															1.677
														],
														[
															-0.379,
															1.668
														],
														[
															-0.328,
															1.657
														],
														[
															-0.87,
															6.873
														],
														[
															-0.739,
															7.096
														],
														[
															-0.644,
															7.278
														],
														[
															-0.582,
															7.418
														],
														[
															-0.841,
															11.38
														],
														[
															-0.59,
															11.21
														],
														[
															-0.285,
															11.166
														],
														[
															0.072,
															11.248
														],
														[
															0.169,
															4.002
														],
														[
															0.074,
															3.998
														],
														[
															0.042,
															3.947
														],
														[
															0.072,
															3.851
														],
														[
															0.818,
															18.62
														],
														[
															1.326,
															17.533
														],
														[
															1.983,
															16.578
														],
														[
															2.791,
															15.756
														],
														[
															0.341,
															1.37
														],
														[
															0.364,
															1.311
														],
														[
															0.355,
															1.201
														],
														[
															0.314,
															1.039
														],
														[
															1.1,
															3.782
														],
														[
															1.194,
															3.618
														],
														[
															1.315,
															3.381
														],
														[
															1.464,
															3.073
														],
														[
															0.36,
															0.591
														],
														[
															0.447,
															0.556
														],
														[
															0.463,
															0.509
														],
														[
															0.41,
															0.448
														],
														[
															0.156,
															0.205
														],
														[
															0.07,
															0.253
														],
														[
															0.044,
															0.271
														],
														[
															0.077,
															0.257
														],
														[
															0.325,
															0.41
														],
														[
															0.345,
															0.257
														],
														[
															0.346,
															0.192
														],
														[
															0.328,
															0.213
														],
														[
															0.285,
															0.317
														],
														[
															0.254,
															0.345
														],
														[
															0.239,
															0.399
														],
														[
															0.24,
															0.48
														],
														[
															0.43,
															0.98
														],
														[
															0.042,
															0.729
														],
														[
															-0.138,
															0.542
														],
														[
															-0.111,
															0.416
														],
														[
															0.274,
															0.785
														],
														[
															0.309,
															0.328
														],
														[
															0.388,
															0.098
														],
														[
															0.51,
															0.096
														],
														[
															1.732,
															0.826
														],
														[
															1.83,
															0.17
														],
														[
															1.821,
															-0.344
														],
														[
															1.706,
															-0.717
														],
														[
															1.747,
															-1.117
														],
														[
															1.477,
															-1.562
														],
														[
															1.195,
															-1.702
														],
														[
															3.653,
															-6.219
														],
														[
															2.419,
															-6.297
														],
														[
															4.431,
															-14.84
														],
														[
															3.178,
															-16.905
														],
														[
															0.753,
															-6.293
														],
														[
															0.684,
															-5.728
														],
														[
															3.435,
															-39.043
														],
														[
															1.023,
															-43.248
														],
														[
															-2.092,
															-33.081
														],
														[
															-3.663,
															-30.807
														],
														[
															-1.565,
															-6.186
														],
														[
															-2.15,
															-6.561
														],
														[
															-2.76,
															-6.397
														],
														[
															-3.772,
															-5.494
														],
														[
															-3.123,
															-0.988
														],
														[
															-3.465,
															0.175
														]
													],
													"v": [
														[
															354,
															16
														],
														[
															353.081,
															16.252
														],
														[
															352.351,
															16.457
														],
														[
															351.695,
															16.684
														],
														[
															351,
															17
														],
														[
															344.973,
															21.429
														],
														[
															339.743,
															27.754
														],
														[
															335.142,
															35.453
														],
														[
															331,
															44
														],
														[
															323.98,
															61.755
														],
														[
															318.366,
															80.136
														],
														[
															313.82,
															98.948
														],
														[
															310,
															118
														],
														[
															309.139,
															123.254
														],
														[
															308.437,
															128.505
														],
														[
															307.766,
															133.753
														],
														[
															307,
															139
														],
														[
															306.028,
															144.042
														],
														[
															304.899,
															149.06
														],
														[
															303.821,
															154.048
														],
														[
															303,
															159
														],
														[
															300.595,
															179.963
														],
														[
															298.529,
															201.534
														],
														[
															296.699,
															223.588
														],
														[
															295,
															246
														],
														[
															292.84,
															279.855
														],
														[
															291.514,
															313.389
														],
														[
															291.181,
															346.978
														],
														[
															292,
															381
														],
														[
															292.349,
															393.011
														],
														[
															292.509,
															404.94
														],
														[
															292.664,
															416.649
														],
														[
															293,
															428
														],
														[
															296.179,
															482.197
														],
														[
															301.105,
															533.332
														],
														[
															308.229,
															581.8
														],
														[
															318,
															628
														],
														[
															319.065,
															632.034
														],
														[
															320.151,
															635.815
														],
														[
															321.161,
															639.188
														],
														[
															322,
															642
														],
														[
															325.434,
															653.118
														],
														[
															329.192,
															663.635
														],
														[
															333.354,
															673.335
														],
														[
															338,
															682
														],
														[
															339.227,
															683.724
														],
														[
															340.61,
															685.324
														],
														[
															341.937,
															686.762
														],
														[
															343,
															688
														],
														[
															343.325,
															688.694
														],
														[
															343.482,
															689.487
														],
														[
															343.647,
															690.287
														],
														[
															344,
															691
														],
														[
															345.009,
															691.98
														],
														[
															346.051,
															692.632
														],
														[
															347.067,
															693.218
														],
														[
															348,
															694
														],
														[
															348.805,
															694.985
														],
														[
															349.541,
															696.095
														],
														[
															350.257,
															697.407
														],
														[
															351,
															699
														],
														[
															351.657,
															701.548
														],
														[
															351.46,
															703.439
														],
														[
															351.034,
															704.86
														],
														[
															351,
															706
														],
														[
															351.864,
															707.612
														],
														[
															352.899,
															708.195
														],
														[
															354.235,
															708.43
														],
														[
															356,
															709
														],
														[
															361.369,
															710.458
														],
														[
															366.873,
															710.161
														],
														[
															372.19,
															708.534
														],
														[
															377,
															706
														],
														[
															381.838,
															701.906
														],
														[
															385.85,
															696.935
														],
														[
															389,
															692
														],
														[
															397.986,
															673.031
														],
														[
															404,
															655
														],
														[
															415.429,
															606.527
														],
														[
															423,
															557
														],
														[
															425.182,
															539.125
														],
														[
															427,
															522
														],
														[
															433.973,
															396.693
														],
														[
															432,
															270
														],
														[
															423.873,
															174.208
														],
														[
															408,
															85
														],
														[
															402.453,
															65.787
														],
														[
															395,
															46
														],
														[
															385.294,
															27.425
														],
														[
															372,
															16
														],
														[
															361.421,
															15.043
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 75,
											"s": [
												{
													"i": [
														[
															0.359,
															-0.142
														],
														[
															0.783,
															-0.591
														],
														[
															0.69,
															-0.782
														],
														[
															0.603,
															-0.922
														],
														[
															0.523,
															-1.011
														],
														[
															0.45,
															-1.049
														],
														[
															0.384,
															-1.036
														],
														[
															0.325,
															-0.972
														],
														[
															0.274,
															-0.858
														],
														[
															0.074,
															-0.168
														],
														[
															0.087,
															-0.166
														],
														[
															0.095,
															-0.165
														],
														[
															0.098,
															-0.164
														],
														[
															0.095,
															-0.165
														],
														[
															0.087,
															-0.166
														],
														[
															0.073,
															-0.168
														],
														[
															0.054,
															-0.171
														],
														[
															0.102,
															-0.412
														],
														[
															0.083,
															-0.417
														],
														[
															0.071,
															-0.42
														],
														[
															0.065,
															-0.421
														],
														[
															0.067,
															-0.421
														],
														[
															0.075,
															-0.419
														],
														[
															0.09,
															-0.415
														],
														[
															0.111,
															-0.41
														],
														[
															1.132,
															-4.986
														],
														[
															0.999,
															-5.204
														],
														[
															0.877,
															-5.353
														],
														[
															0.765,
															-5.433
														],
														[
															0.663,
															-5.445
														],
														[
															0.571,
															-5.388
														],
														[
															0.488,
															-5.262
														],
														[
															0.416,
															-5.068
														],
														[
															0.552,
															-8.664
														],
														[
															0.421,
															-8.803
														],
														[
															0.306,
															-8.927
														],
														[
															0.206,
															-9.036
														],
														[
															0.122,
															-9.129
														],
														[
															0.053,
															-9.208
														],
														[
															0,
															-9.272
														],
														[
															-0.368,
															-15.938
														],
														[
															-0.694,
															-15.457
														],
														[
															-0.979,
															-15.04
														],
														[
															-1.223,
															-14.688
														],
														[
															-1.462,
															-12.653
														],
														[
															-2.169,
															-12.362
														],
														[
															-3.123,
															-11.153
														],
														[
															-4.324,
															-9.027
														],
														[
															-0.28,
															-0.28
														],
														[
															-0.303,
															-0.227
														],
														[
															-0.247,
															-0.209
														],
														[
															-0.111,
															-0.225
														],
														[
															-0.114,
															-1.01
														],
														[
															-0.014,
															-1.098
														],
														[
															-0.018,
															-0.915
														],
														[
															-0.126,
															-0.458
														],
														[
															-0.238,
															-0.334
														],
														[
															-0.298,
															-0.083
														],
														[
															-0.411,
															-0.082
														],
														[
															-0.576,
															-0.332
														],
														[
															-1.557,
															-0.175
														],
														[
															-1.598,
															0.376
														],
														[
															-1.493,
															0.863
														],
														[
															-1.24,
															1.285
														],
														[
															-0.815,
															1.417
														],
														[
															-0.609,
															1.524
														],
														[
															-0.489,
															1.47
														],
														[
															-0.457,
															1.256
														],
														[
															-0.969,
															3.285
														],
														[
															-0.742,
															3.162
														],
														[
															-0.652,
															3.296
														],
														[
															-0.697,
															3.687
														],
														[
															-1.189,
															7.408
														],
														[
															-1.001,
															7.42
														],
														[
															-0.812,
															7.302
														],
														[
															-0.621,
															7.054
														],
														[
															-1.299,
															27.905
														],
														[
															-0.286,
															28.139
														],
														[
															0.656,
															27.789
														],
														[
															1.528,
															26.857
														],
														[
															1.105,
															15.539
														],
														[
															1.63,
															15.096
														],
														[
															2.459,
															14.26
														],
														[
															3.595,
															13.028
														],
														[
															1.131,
															3.483
														],
														[
															1.382,
															3.087
														],
														[
															1.685,
															2.185
														],
														[
															2.04,
															0.779
														],
														[
															1.504,
															0.125
														],
														[
															1.505,
															-0.072
														],
														[
															1.123,
															-0.16
														]
													],
													"o": [
														[
															-0.884,
															0.349
														],
														[
															-0.783,
															0.591
														],
														[
															-0.69,
															0.782
														],
														[
															-0.603,
															0.922
														],
														[
															-0.523,
															1.011
														],
														[
															-0.45,
															1.049
														],
														[
															-0.384,
															1.036
														],
														[
															-0.325,
															0.972
														],
														[
															-0.055,
															0.172
														],
														[
															-0.074,
															0.168
														],
														[
															-0.087,
															0.166
														],
														[
															-0.095,
															0.165
														],
														[
															-0.098,
															0.164
														],
														[
															-0.095,
															0.165
														],
														[
															-0.087,
															0.166
														],
														[
															-0.073,
															0.168
														],
														[
															-0.127,
															0.406
														],
														[
															-0.102,
															0.412
														],
														[
															-0.083,
															0.417
														],
														[
															-0.071,
															0.42
														],
														[
															-0.065,
															0.421
														],
														[
															-0.067,
															0.421
														],
														[
															-0.075,
															0.419
														],
														[
															-0.09,
															0.415
														],
														[
															-1.274,
															4.7
														],
														[
															-1.132,
															4.986
														],
														[
															-0.999,
															5.204
														],
														[
															-0.877,
															5.353
														],
														[
															-0.765,
															5.433
														],
														[
															-0.663,
															5.445
														],
														[
															-0.571,
															5.388
														],
														[
															-0.488,
															5.262
														],
														[
															-0.699,
															8.511
														],
														[
															-0.552,
															8.664
														],
														[
															-0.421,
															8.803
														],
														[
															-0.306,
															8.927
														],
														[
															-0.206,
															9.036
														],
														[
															-0.122,
															9.129
														],
														[
															-0.053,
															9.208
														],
														[
															0,
															16.484
														],
														[
															0.368,
															15.938
														],
														[
															0.694,
															15.457
														],
														[
															0.979,
															15.04
														],
														[
															1.001,
															12.025
														],
														[
															1.462,
															12.653
														],
														[
															2.169,
															12.362
														],
														[
															3.123,
															11.153
														],
														[
															0.175,
															0.366
														],
														[
															0.28,
															0.28
														],
														[
															0.303,
															0.227
														],
														[
															0.247,
															0.209
														],
														[
															0.319,
															0.648
														],
														[
															0.114,
															1.01
														],
														[
															0.014,
															1.098
														],
														[
															0.018,
															0.915
														],
														[
															0.23,
															0.836
														],
														[
															0.238,
															0.334
														],
														[
															0.298,
															0.083
														],
														[
															0.411,
															0.082
														],
														[
															1.368,
															0.789
														],
														[
															1.557,
															0.175
														],
														[
															1.598,
															-0.376
														],
														[
															1.493,
															-0.863
														],
														[
															1.108,
															-1.149
														],
														[
															0.815,
															-1.417
														],
														[
															0.609,
															-1.524
														],
														[
															0.489,
															-1.47
														],
														[
															1.333,
															-3.665
														],
														[
															0.969,
															-3.285
														],
														[
															0.742,
															-3.162
														],
														[
															0.652,
															-3.296
														],
														[
															1.375,
															-7.266
														],
														[
															1.189,
															-7.408
														],
														[
															1.001,
															-7.42
														],
														[
															0.812,
															-7.302
														],
														[
															2.384,
															-27.088
														],
														[
															1.299,
															-27.905
														],
														[
															0.286,
															-28.139
														],
														[
															-0.656,
															-27.789
														],
														[
															-0.887,
															-15.587
														],
														[
															-1.105,
															-15.539
														],
														[
															-1.63,
															-15.096
														],
														[
															-2.459,
															-14.26
														],
														[
															-0.931,
															-3.374
														],
														[
															-1.131,
															-3.483
														],
														[
															-1.382,
															-3.087
														],
														[
															-1.685,
															-2.185
														],
														[
															-1.121,
															-0.428
														],
														[
															-1.504,
															-0.125
														],
														[
															-1.505,
															0.072
														],
														[
															-1.123,
															0.16
														]
													],
													"v": [
														[
															355,
															16
														],
														[
															352.5,
															17.423
														],
														[
															350.292,
															19.495
														],
														[
															348.355,
															22.063
														],
														[
															346.668,
															24.974
														],
														[
															345.21,
															28.077
														],
														[
															343.96,
															31.217
														],
														[
															342.897,
															34.242
														],
														[
															342,
															37
														],
														[
															341.806,
															37.51
														],
														[
															341.563,
															38.011
														],
														[
															341.288,
															38.507
														],
														[
															340.997,
															39
														],
														[
															340.706,
															39.493
														],
														[
															340.432,
															39.989
														],
														[
															340.191,
															40.491
														],
														[
															340,
															41
														],
														[
															339.659,
															42.228
														],
														[
															339.383,
															43.471
														],
														[
															339.155,
															44.727
														],
														[
															338.952,
															45.988
														],
														[
															338.755,
															47.251
														],
														[
															338.545,
															48.511
														],
														[
															338.299,
															49.762
														],
														[
															338,
															51
														],
														[
															334.394,
															65.546
														],
														[
															331.2,
															80.848
														],
														[
															328.388,
															96.7
														],
														[
															325.927,
															112.896
														],
														[
															323.787,
															129.23
														],
														[
															321.94,
															145.496
														],
														[
															320.354,
															161.488
														],
														[
															319,
															177
														],
														[
															317.128,
															202.766
														],
														[
															315.672,
															228.971
														],
														[
															314.585,
															255.57
														],
														[
															313.821,
															282.517
														],
														[
															313.334,
															309.768
														],
														[
															313.076,
															337.277
														],
														[
															313,
															365
														],
														[
															313.562,
															413.617
														],
														[
															315.165,
															460.693
														],
														[
															317.686,
															506.423
														],
														[
															321,
															551
														],
														[
															324.633,
															588.246
														],
														[
															330.016,
															625.997
														],
														[
															337.892,
															661.5
														],
														[
															349,
															692
														],
														[
															349.703,
															692.96
														],
														[
															350.597,
															693.712
														],
														[
															351.443,
															694.357
														],
														[
															352,
															695
														],
														[
															352.623,
															697.555
														],
														[
															352.789,
															700.785
														],
														[
															352.81,
															703.873
														],
														[
															353,
															706
														],
														[
															353.69,
															707.692
														],
														[
															354.481,
															708.255
														],
														[
															355.533,
															708.44
														],
														[
															357,
															709
														],
														[
															361.423,
															710.43
														],
														[
															366.192,
															710.112
														],
														[
															370.865,
															708.238
														],
														[
															375,
															705
														],
														[
															377.864,
															701.111
														],
														[
															379.977,
															696.661
														],
														[
															381.602,
															692.13
														],
														[
															383,
															688
														],
														[
															386.42,
															677.64
														],
														[
															388.953,
															668.033
														],
														[
															391.01,
															658.41
														],
														[
															393,
															648
														],
														[
															396.846,
															625.956
														],
														[
															400.131,
															603.682
														],
														[
															402.851,
															581.567
														],
														[
															405,
															560
														],
														[
															410.507,
															477.365
														],
														[
															412.867,
															393.153
														],
														[
															412.294,
															309.115
														],
														[
															409,
															227
														],
														[
															406.089,
															180.214
														],
														[
															402.062,
															134.163
														],
														[
															396.005,
															90.03
														],
														[
															387,
															49
														],
														[
															383.92,
															38.588
														],
														[
															380.164,
															28.607
														],
														[
															375.576,
															20.573
														],
														[
															370,
															16
														],
														[
															365.966,
															15.198
														],
														[
															361.357,
															15.145
														],
														[
															357.319,
															15.52
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 76,
											"s": [
												{
													"i": [
														[
															0.137,
															-0.083
														],
														[
															0.385,
															-0.49
														],
														[
															0.35,
															-0.681
														],
														[
															0.317,
															-0.832
														],
														[
															0.286,
															-0.942
														],
														[
															0.257,
															-1.011
														],
														[
															0.23,
															-1.04
														],
														[
															0.206,
															-1.027
														],
														[
															0.184,
															-0.974
														],
														[
															0.14,
															-0.797
														],
														[
															0.136,
															-0.829
														],
														[
															0.132,
															-0.85
														],
														[
															0.127,
															-0.861
														],
														[
															0.121,
															-0.861
														],
														[
															0.115,
															-0.852
														],
														[
															0.108,
															-0.832
														],
														[
															0.101,
															-0.802
														],
														[
															0.571,
															-5.405
														],
														[
															0.491,
															-5.511
														],
														[
															0.419,
															-5.562
														],
														[
															0.354,
															-5.56
														],
														[
															0.297,
															-5.504
														],
														[
															0.248,
															-5.394
														],
														[
															0.207,
															-5.231
														],
														[
															0.173,
															-5.013
														],
														[
															0.384,
															-14.938
														],
														[
															0.255,
															-15.148
														],
														[
															0.119,
															-15.265
														],
														[
															-0.024,
															-15.289
														],
														[
															-0.173,
															-15.221
														],
														[
															-0.329,
															-15.059
														],
														[
															-0.492,
															-14.805
														],
														[
															-0.662,
															-14.458
														],
														[
															-0.202,
															-3.809
														],
														[
															-0.232,
															-3.852
														],
														[
															-0.264,
															-3.941
														],
														[
															-0.298,
															-4.075
														],
														[
															-0.335,
															-4.255
														],
														[
															-0.375,
															-4.48
														],
														[
															-0.416,
															-4.751
														],
														[
															-0.453,
															-4.373
														],
														[
															-0.574,
															-4.419
														],
														[
															-0.709,
															-4.086
														],
														[
															-0.857,
															-3.375
														],
														[
															-0.291,
															-0.861
														],
														[
															-0.296,
															-0.797
														],
														[
															-0.232,
															-0.662
														],
														[
															-0.1,
															-0.458
														],
														[
															-0.103,
															-1.062
														],
														[
															-0.025,
															-0.911
														],
														[
															-0.035,
															-0.768
														],
														[
															-0.131,
															-0.634
														],
														[
															-0.095,
															-0.776
														],
														[
															-0.216,
															-0.439
														],
														[
															-0.638,
															-0.318
														],
														[
															-1.361,
															-0.415
														],
														[
															-0.426,
															-0.029
														],
														[
															-0.467,
															0.015
														],
														[
															-0.433,
															0.036
														],
														[
															-0.324,
															0.035
														],
														[
															-1.471,
															2.246
														],
														[
															-0.862,
															3.146
														],
														[
															-0.46,
															2.952
														],
														[
															-0.265,
															1.665
														],
														[
															-1.101,
															10.969
														],
														[
															-0.73,
															11.241
														],
														[
															-0.514,
															11.026
														],
														[
															-0.454,
															10.326
														],
														[
															-0.582,
															23.171
														],
														[
															-0.235,
															23.585
														],
														[
															0.089,
															22.871
														],
														[
															0.39,
															21.03
														],
														[
															0.345,
															13.435
														],
														[
															0.483,
															13.629
														],
														[
															0.647,
															13.129
														],
														[
															0.837,
															11.937
														],
														[
															0.518,
															7.345
														],
														[
															0.646,
															7.014
														],
														[
															0.93,
															6.787
														],
														[
															1.37,
															6.665
														],
														[
															0.501,
															1.946
														],
														[
															0.56,
															1.77
														],
														[
															0.529,
															1.189
														],
														[
															0.408,
															0.203
														],
														[
															1.168,
															0.061
														],
														[
															1.322,
															-0.057
														],
														[
															0.993,
															-0.089
														],
														[
															0.18,
															-0.037
														],
														[
															0.1,
															-0.078
														],
														[
															0.025,
															-0.091
														],
														[
															0.037,
															-0.092
														]
													],
													"o": [
														[
															-0.423,
															0.257
														],
														[
															-0.385,
															0.49
														],
														[
															-0.35,
															0.681
														],
														[
															-0.317,
															0.832
														],
														[
															-0.286,
															0.942
														],
														[
															-0.257,
															1.011
														],
														[
															-0.23,
															1.04
														],
														[
															-0.206,
															1.027
														],
														[
															-0.143,
															0.755
														],
														[
															-0.14,
															0.797
														],
														[
															-0.136,
															0.829
														],
														[
															-0.132,
															0.85
														],
														[
															-0.127,
															0.861
														],
														[
															-0.121,
															0.861
														],
														[
															-0.115,
															0.852
														],
														[
															-0.108,
															0.832
														],
														[
															-0.659,
															5.246
														],
														[
															-0.571,
															5.405
														],
														[
															-0.491,
															5.511
														],
														[
															-0.419,
															5.562
														],
														[
															-0.354,
															5.56
														],
														[
															-0.297,
															5.504
														],
														[
															-0.248,
															5.394
														],
														[
															-0.207,
															5.231
														],
														[
															-0.506,
															14.635
														],
														[
															-0.384,
															14.938
														],
														[
															-0.255,
															15.148
														],
														[
															-0.119,
															15.265
														],
														[
															0.024,
															15.289
														],
														[
															0.173,
															15.221
														],
														[
															0.329,
															15.059
														],
														[
															0.492,
															14.805
														],
														[
															0.175,
															3.812
														],
														[
															0.202,
															3.809
														],
														[
															0.232,
															3.852
														],
														[
															0.264,
															3.941
														],
														[
															0.298,
															4.075
														],
														[
															0.335,
															4.255
														],
														[
															0.375,
															4.48
														],
														[
															0.346,
															3.95
														],
														[
															0.453,
															4.373
														],
														[
															0.574,
															4.419
														],
														[
															0.709,
															4.086
														],
														[
															0.217,
															0.856
														],
														[
															0.291,
															0.861
														],
														[
															0.296,
															0.797
														],
														[
															0.232,
															0.662
														],
														[
															0.267,
															1.222
														],
														[
															0.103,
															1.062
														],
														[
															0.025,
															0.911
														],
														[
															0.035,
															0.768
														],
														[
															0.276,
															1.331
														],
														[
															0.095,
															0.776
														],
														[
															0.216,
															0.439
														],
														[
															0.638,
															0.318
														],
														[
															0.31,
															0.094
														],
														[
															0.426,
															0.029
														],
														[
															0.467,
															-0.015
														],
														[
															0.433,
															-0.036
														],
														[
															2.286,
															-0.251
														],
														[
															1.471,
															-2.246
														],
														[
															0.862,
															-3.146
														],
														[
															0.46,
															-2.952
														],
														[
															1.626,
															-10.212
														],
														[
															1.101,
															-10.969
														],
														[
															0.73,
															-11.241
														],
														[
															0.514,
															-11.026
														],
														[
															0.951,
															-21.631
														],
														[
															0.582,
															-23.171
														],
														[
															0.235,
															-23.585
														],
														[
															-0.089,
															-22.871
														],
														[
															-0.233,
															-12.548
														],
														[
															-0.345,
															-13.435
														],
														[
															-0.483,
															-13.629
														],
														[
															-0.647,
															-13.129
														],
														[
															-0.546,
															-7.781
														],
														[
															-0.518,
															-7.345
														],
														[
															-0.646,
															-7.014
														],
														[
															-0.93,
															-6.787
														],
														[
															-0.353,
															-1.717
														],
														[
															-0.501,
															-1.946
														],
														[
															-0.56,
															-1.77
														],
														[
															-0.529,
															-1.189
														],
														[
															-0.531,
															-0.264
														],
														[
															-1.168,
															-0.061
														],
														[
															-1.322,
															0.057
														],
														[
															-0.993,
															0.089
														],
														[
															-0.264,
															0.054
														],
														[
															-0.1,
															0.078
														],
														[
															-0.025,
															0.091
														],
														[
															-0.037,
															0.092
														]
													],
													"v": [
														[
															356,
															16
														],
														[
															354.788,
															17.131
														],
														[
															353.685,
															18.898
														],
														[
															352.685,
															21.178
														],
														[
															351.782,
															23.849
														],
														[
															350.969,
															26.79
														],
														[
															350.238,
															29.876
														],
														[
															349.584,
															32.987
														],
														[
															349,
															36
														],
														[
															348.577,
															38.332
														],
														[
															348.163,
															40.773
														],
														[
															347.762,
															43.293
														],
														[
															347.374,
															45.862
														],
														[
															347.003,
															48.447
														],
														[
															346.648,
															51.019
														],
														[
															346.314,
															53.547
														],
														[
															346,
															56
														],
														[
															344.156,
															71.991
														],
														[
															342.564,
															88.379
														],
														[
															341.2,
															105.002
														],
														[
															340.042,
															121.699
														],
														[
															339.067,
															138.309
														],
														[
															338.25,
															154.671
														],
														[
															337.569,
															170.621
														],
														[
															337,
															186
														],
														[
															335.663,
															230.382
														],
														[
															334.703,
															275.534
														],
														[
															334.141,
															321.176
														],
														[
															333.996,
															367.03
														],
														[
															334.289,
															412.818
														],
														[
															335.04,
															458.262
														],
														[
															336.27,
															503.082
														],
														[
															338,
															547
														],
														[
															338.564,
															558.419
														],
														[
															339.214,
															569.9
														],
														[
															339.957,
															581.578
														],
														[
															340.8,
															593.59
														],
														[
															341.75,
															606.073
														],
														[
															342.814,
															619.164
														],
														[
															344,
															633
														],
														[
															345.195,
															645.579
														],
														[
															346.733,
															658.861
														],
														[
															348.654,
															671.713
														],
														[
															351,
															683
														],
														[
															351.779,
															685.593
														],
														[
															352.676,
															688.097
														],
														[
															353.484,
															690.302
														],
														[
															354,
															692
														],
														[
															354.533,
															695.424
														],
														[
															354.704,
															698.382
														],
														[
															354.773,
															700.899
														],
														[
															355,
															703
														],
														[
															355.481,
															706.107
														],
														[
															355.872,
															707.875
														],
														[
															357.077,
															708.956
														],
														[
															360,
															710
														],
														[
															361.121,
															710.179
														],
														[
															362.479,
															710.195
														],
														[
															363.847,
															710.113
														],
														[
															365,
															710
														],
														[
															370.584,
															705.982
														],
														[
															374.032,
															697.621
														],
														[
															375.964,
															688.199
														],
														[
															377,
															681
														],
														[
															381.051,
															649.107
														],
														[
															383.758,
															615.671
														],
														[
															385.586,
															582.15
														],
														[
															387,
															550
														],
														[
															389.293,
															482.515
														],
														[
															390.512,
															412.099
														],
														[
															390.725,
															342.134
														],
														[
															390,
															276
														],
														[
															389.14,
															236.852
														],
														[
															387.906,
															196.083
														],
														[
															386.218,
															155.773
														],
														[
															384,
															118
														],
														[
															382.444,
															95.337
														],
														[
															380.736,
															73.825
														],
														[
															378.41,
															53.151
														],
														[
															375,
															33
														],
														[
															373.697,
															27.404
														],
														[
															372.082,
															21.729
														],
														[
															370.427,
															17.189
														],
														[
															369,
															15
														],
														[
															366.331,
															14.534
														],
														[
															362.474,
															14.549
														],
														[
															358.881,
															14.789
														],
														[
															357,
															15
														],
														[
															356.476,
															15.201
														],
														[
															356.309,
															15.456
														],
														[
															356.239,
															15.734
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 77,
											"s": [
												{
													"i": [
														[
															0.471,
															-0.579
														],
														[
															0.014,
															-0.063
														],
														[
															0.005,
															-0.086
														],
														[
															-0.002,
															-0.1
														],
														[
															-0.007,
															-0.106
														],
														[
															-0.009,
															-0.103
														],
														[
															-0.008,
															-0.092
														],
														[
															-0.005,
															-0.072
														],
														[
															0,
															-0.044
														],
														[
															0.055,
															-25.091
														],
														[
															0.089,
															-25.464
														],
														[
															0.103,
															-25.719
														],
														[
															0.096,
															-25.856
														],
														[
															0.069,
															-25.875
														],
														[
															0.021,
															-25.777
														],
														[
															-0.047,
															-25.56
														],
														[
															-0.136,
															-25.226
														],
														[
															-0.02,
															-0.791
														],
														[
															-0.032,
															-0.738
														],
														[
															-0.042,
															-0.684
														],
														[
															-0.049,
															-0.628
														],
														[
															-0.053,
															-0.571
														],
														[
															-0.055,
															-0.513
														],
														[
															-0.054,
															-0.454
														],
														[
															-0.05,
															-0.394
														],
														[
															0.015,
															-0.203
														],
														[
															0.045,
															-0.198
														],
														[
															0.064,
															-0.197
														],
														[
															0.072,
															-0.199
														],
														[
															0.068,
															-0.205
														],
														[
															0.053,
															-0.214
														],
														[
															0.027,
															-0.226
														],
														[
															-0.011,
															-0.242
														],
														[
															-0.074,
															-1.981
														],
														[
															-0.063,
															-2.007
														],
														[
															-0.052,
															-2.033
														],
														[
															-0.042,
															-2.06
														],
														[
															-0.032,
															-2.088
														],
														[
															-0.021,
															-2.116
														],
														[
															-0.012,
															-2.144
														],
														[
															0.121,
															-2.004
														],
														[
															-0.198,
															-1.458
														],
														[
															-0.97,
															-0.725
														],
														[
															-2.195,
															0.194
														],
														[
															-0.591,
															0.136
														],
														[
															-0.289,
															0.37
														],
														[
															-0.178,
															0.799
														],
														[
															-0.259,
															1.422
														],
														[
															-0.024,
															0.86
														],
														[
															0.036,
															0.938
														],
														[
															0.042,
															0.983
														],
														[
															-0.005,
															0.998
														],
														[
															-0.005,
															3.893
														],
														[
															0.006,
															3.536
														],
														[
															0.007,
															3.375
														],
														[
															0,
															3.411
														],
														[
															0.088,
															1.922
														],
														[
															0.021,
															1.876
														],
														[
															-0.203,
															1.391
														],
														[
															-0.582,
															0.466
														],
														[
															0.064,
															0.139
														],
														[
															0.163,
															0.112
														],
														[
															0.143,
															0.042
														],
														[
															0.003,
															-0.071
														],
														[
															-0.25,
															22.087
														],
														[
															0.084,
															21.937
														],
														[
															0.167,
															22.132
														],
														[
															0,
															22.669
														],
														[
															-0.192,
															22.123
														],
														[
															-0.103,
															21.995
														],
														[
															0.265,
															21.999
														],
														[
															0.913,
															22.136
														],
														[
															-0.043,
															0.203
														],
														[
															-0.089,
															0.147
														],
														[
															-0.127,
															0.121
														],
														[
															-0.155,
															0.124
														],
														[
															0.064,
															0.137
														],
														[
															0.165,
															0.109
														],
														[
															0.143,
															0.042
														],
														[
															-0.001,
															-0.064
														],
														[
															-0.141,
															6.097
														],
														[
															-0.161,
															6.294
														],
														[
															0.061,
															6.05
														],
														[
															0.524,
															5.366
														],
														[
															0.048,
															0.975
														],
														[
															0.173,
															0.509
														],
														[
															0.538,
															0.28
														],
														[
															1.143,
															0.287
														],
														[
															0.538,
															0.095
														],
														[
															0.718,
															0.01
														],
														[
															0.696,
															-0.215
														]
													],
													"o": [
														[
															-0.026,
															0.032
														],
														[
															-0.014,
															0.063
														],
														[
															-0.005,
															0.086
														],
														[
															0.002,
															0.1
														],
														[
															0.006,
															0.106
														],
														[
															0.009,
															0.103
														],
														[
															0.008,
															0.092
														],
														[
															0.005,
															0.072
														],
														[
															-0.001,
															24.6
														],
														[
															-0.055,
															25.091
														],
														[
															-0.089,
															25.464
														],
														[
															-0.103,
															25.719
														],
														[
															-0.096,
															25.856
														],
														[
															-0.069,
															25.875
														],
														[
															-0.021,
															25.777
														],
														[
															0.047,
															25.56
														],
														[
															0.005,
															0.843
														],
														[
															0.02,
															0.791
														],
														[
															0.032,
															0.738
														],
														[
															0.042,
															0.684
														],
														[
															0.049,
															0.628
														],
														[
															0.053,
															0.571
														],
														[
															0.055,
															0.513
														],
														[
															0.054,
															0.454
														],
														[
															0.027,
															0.211
														],
														[
															-0.015,
															0.203
														],
														[
															-0.045,
															0.198
														],
														[
															-0.064,
															0.197
														],
														[
															-0.072,
															0.199
														],
														[
															-0.068,
															0.205
														],
														[
															-0.053,
															0.214
														],
														[
															-0.027,
															0.226
														],
														[
															0.086,
															1.955
														],
														[
															0.074,
															1.981
														],
														[
															0.063,
															2.007
														],
														[
															0.052,
															2.033
														],
														[
															0.042,
															2.06
														],
														[
															0.032,
															2.088
														],
														[
															0.021,
															2.116
														],
														[
															0.013,
															2.363
														],
														[
															-0.121,
															2.004
														],
														[
															0.198,
															1.458
														],
														[
															0.97,
															0.725
														],
														[
															1.084,
															-0.096
														],
														[
															0.591,
															-0.136
														],
														[
															0.289,
															-0.37
														],
														[
															0.178,
															-0.799
														],
														[
															0.137,
															-0.752
														],
														[
															0.024,
															-0.86
														],
														[
															-0.036,
															-0.938
														],
														[
															-0.042,
															-0.984
														],
														[
															0.024,
															-4.447
														],
														[
															0.005,
															-3.893
														],
														[
															-0.006,
															-3.536
														],
														[
															-0.007,
															-3.375
														],
														[
															0,
															-1.529
														],
														[
															-0.088,
															-1.922
														],
														[
															-0.021,
															-1.876
														],
														[
															0.203,
															-1.391
														],
														[
															0.154,
															-0.124
														],
														[
															-0.064,
															-0.139
														],
														[
															-0.163,
															-0.112
														],
														[
															-0.143,
															-0.042
														],
														[
															0.835,
															-22.581
														],
														[
															0.25,
															-22.087
														],
														[
															-0.084,
															-21.937
														],
														[
															-0.167,
															-22.132
														],
														[
															0,
															-22.384
														],
														[
															0.192,
															-22.123
														],
														[
															0.103,
															-21.995
														],
														[
															-0.265,
															-21.999
														],
														[
															-0.012,
															-0.288
														],
														[
															0.043,
															-0.203
														],
														[
															0.089,
															-0.147
														],
														[
															0.127,
															-0.121
														],
														[
															0.159,
															-0.127
														],
														[
															-0.064,
															-0.137
														],
														[
															-0.165,
															-0.109
														],
														[
															-0.143,
															-0.042
														],
														[
															-0.119,
															-5.46
														],
														[
															0.141,
															-6.097
														],
														[
															0.161,
															-6.294
														],
														[
															-0.061,
															-6.05
														],
														[
															-0.164,
															-1.678
														],
														[
															-0.048,
															-0.975
														],
														[
															-0.173,
															-0.509
														],
														[
															-0.538,
															-0.28
														],
														[
															-0.155,
															-0.039
														],
														[
															-0.538,
															-0.095
														],
														[
															-0.718,
															-0.01
														],
														[
															-0.696,
															0.215
														]
													],
													"v": [
														[
															357,
															16
														],
														[
															356.94,
															16.145
														],
														[
															356.912,
															16.371
														],
														[
															356.909,
															16.652
														],
														[
															356.922,
															16.964
														],
														[
															356.945,
															17.28
														],
														[
															356.971,
															17.575
														],
														[
															356.991,
															17.824
														],
														[
															357,
															18
														],
														[
															356.911,
															92.567
														],
														[
															356.689,
															168.429
														],
														[
															356.395,
															245.233
														],
														[
															356.091,
															322.625
														],
														[
															355.838,
															400.251
														],
														[
															355.698,
															477.758
														],
														[
															355.731,
															554.792
														],
														[
															356,
															631
														],
														[
															356.037,
															633.452
														],
														[
															356.116,
															635.746
														],
														[
															356.228,
															637.88
														],
														[
															356.365,
															639.848
														],
														[
															356.519,
															641.647
														],
														[
															356.681,
															643.275
														],
														[
															356.845,
															644.727
														],
														[
															357,
															646
														],
														[
															357.015,
															646.62
														],
														[
															356.922,
															647.22
														],
														[
															356.755,
															647.812
														],
														[
															356.548,
															648.406
														],
														[
															356.335,
															649.011
														],
														[
															356.15,
															649.638
														],
														[
															356.027,
															650.298
														],
														[
															356,
															651
														],
														[
															356.24,
															656.903
														],
														[
															356.446,
															662.884
														],
														[
															356.62,
															668.944
														],
														[
															356.761,
															675.084
														],
														[
															356.871,
															681.306
														],
														[
															356.951,
															687.611
														],
														[
															357,
															694
														],
														[
															356.725,
															700.596
														],
														[
															356.727,
															705.836
														],
														[
															358.366,
															709.157
														],
														[
															363,
															710
														],
														[
															365.465,
															709.7
														],
														[
															366.738,
															708.989
														],
														[
															367.392,
															707.283
														],
														[
															368,
															704
														],
														[
															368.228,
															701.574
														],
														[
															368.198,
															698.87
														],
														[
															368.068,
															695.98
														],
														[
															368,
															693
														],
														[
															368.041,
															680.54
														],
														[
															368.036,
															669.447
														],
														[
															368.013,
															659.13
														],
														[
															368,
															649
														],
														[
															367.829,
															643.714
														],
														[
															367.627,
															637.906
														],
														[
															367.861,
															632.895
														],
														[
															369,
															630
														],
														[
															369.106,
															629.595
														],
														[
															368.736,
															629.208
														],
														[
															368.248,
															628.967
														],
														[
															368,
															629
														],
														[
															369.565,
															562.084
														],
														[
															369.752,
															496.133
														],
														[
															369.313,
															430.116
														],
														[
															369,
															363
														],
														[
															369.357,
															296.273
														],
														[
															369.87,
															230.129
														],
														[
															369.697,
															164.171
														],
														[
															368,
															98
														],
														[
															368.049,
															97.271
														],
														[
															368.25,
															96.754
														],
														[
															368.575,
															96.36
														],
														[
															369,
															96
														],
														[
															369.112,
															95.593
														],
														[
															368.737,
															95.214
														],
														[
															368.243,
															94.978
														],
														[
															368,
															95
														],
														[
															368.094,
															77.554
														],
														[
															368.607,
															58.858
														],
														[
															368.817,
															40.233
														],
														[
															368,
															23
														],
														[
															367.741,
															19.08
														],
														[
															367.469,
															16.914
														],
														[
															366.462,
															15.791
														],
														[
															364,
															15
														],
														[
															362.909,
															14.765
														],
														[
															360.974,
															14.573
														],
														[
															358.801,
															14.844
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 78,
											"s": [
												{
													"i": [
														[
															0.298,
															-0.197
														],
														[
															0.091,
															-0.071
														],
														[
															0.051,
															-0.057
														],
														[
															0.024,
															-0.052
														],
														[
															0.008,
															-0.057
														],
														[
															0.006,
															-0.072
														],
														[
															0.016,
															-0.097
														],
														[
															0.038,
															-0.132
														],
														[
															0.072,
															-0.176
														],
														[
															0.441,
															-1.418
														],
														[
															0.368,
															-1.54
														],
														[
															0.307,
															-1.641
														],
														[
															0.258,
															-1.721
														],
														[
															0.223,
															-1.781
														],
														[
															0.199,
															-1.821
														],
														[
															0.188,
															-1.84
														],
														[
															0.19,
															-1.838
														],
														[
															0.564,
															-6.145
														],
														[
															0.508,
															-6.322
														],
														[
															0.441,
															-6.422
														],
														[
															0.363,
															-6.445
														],
														[
															0.274,
															-6.391
														],
														[
															0.174,
															-6.26
														],
														[
															0.063,
															-6.052
														],
														[
															0.202,
															-7.32
														],
														[
															0.231,
															-7.454
														],
														[
															0.164,
															-7.532
														],
														[
															0,
															-7.555
														],
														[
															0.094,
															-7.524
														],
														[
															0.125,
															-7.513
														],
														[
															0.094,
															-7.482
														],
														[
															0,
															-7.433
														],
														[
															-0.188,
															-11.319
														],
														[
															-0.25,
															-11.226
														],
														[
															-0.188,
															-10.92
														],
														[
															0,
															-10.398
														],
														[
															-0.038,
															-3.792
														],
														[
															-0.08,
															-3.824
														],
														[
															-0.127,
															-3.87
														],
														[
															-0.178,
															-3.93
														],
														[
															-0.335,
															-7.127
														],
														[
															-0.398,
															-7.458
														],
														[
															-0.489,
															-7.602
														],
														[
															-0.609,
															-7.558
														],
														[
															-0.258,
															-3.467
														],
														[
															-0.25,
															-2.979
														],
														[
															-0.367,
															-3.397
														],
														[
															-0.61,
															-4.722
														],
														[
															-0.144,
															-1.421
														],
														[
															-0.234,
															-1.896
														],
														[
															-0.348,
															-2.027
														],
														[
															-0.486,
															-1.815
														],
														[
															-0.761,
															-1.629
														],
														[
															-1.041,
															-1.042
														],
														[
															-1.385,
															-0.267
														],
														[
															-1.792,
															0.696
														],
														[
															-0.381,
															0.056
														],
														[
															-0.414,
															0.059
														],
														[
															-0.326,
															0.099
														],
														[
															-0.117,
															0.175
														],
														[
															-0.028,
															1.027
														],
														[
															0.107,
															1.229
														],
														[
															0.081,
															1.087
														],
														[
															-0.105,
															0.603
														],
														[
															-0.179,
															0.336
														],
														[
															-0.222,
															0.346
														],
														[
															-0.182,
															0.337
														],
														[
															-0.058,
															0.308
														],
														[
															-1.47,
															12.433
														],
														[
															-0.98,
															12.905
														],
														[
															-0.646,
															12.644
														],
														[
															-0.466,
															11.651
														],
														[
															-0.401,
															14.561
														],
														[
															-0.215,
															14.152
														],
														[
															-0.081,
															14.765
														],
														[
															0,
															16.4
														],
														[
															0.122,
															22.776
														],
														[
															0.447,
															22.401
														],
														[
															0.977,
															22.175
														],
														[
															1.711,
															22.097
														],
														[
															0.365,
															5.328
														],
														[
															0.432,
															5.343
														],
														[
															0.601,
															5.219
														],
														[
															0.873,
															4.954
														],
														[
															0.455,
															1.918
														],
														[
															0.548,
															1.778
														],
														[
															0.57,
															1.221
														],
														[
															0.519,
															0.248
														],
														[
															1.063,
															-0.017
														],
														[
															1.384,
															-0.096
														],
														[
															1.129,
															-0.156
														]
													],
													"o": [
														[
															-0.144,
															0.095
														],
														[
															-0.091,
															0.071
														],
														[
															-0.051,
															0.057
														],
														[
															-0.024,
															0.052
														],
														[
															-0.008,
															0.057
														],
														[
															-0.006,
															0.072
														],
														[
															-0.016,
															0.097
														],
														[
															-0.038,
															0.132
														],
														[
															-0.527,
															1.277
														],
														[
															-0.441,
															1.418
														],
														[
															-0.368,
															1.54
														],
														[
															-0.307,
															1.641
														],
														[
															-0.258,
															1.721
														],
														[
															-0.223,
															1.781
														],
														[
															-0.199,
															1.821
														],
														[
															-0.188,
															1.84
														],
														[
															-0.608,
															5.891
														],
														[
															-0.564,
															6.145
														],
														[
															-0.508,
															6.322
														],
														[
															-0.441,
															6.422
														],
														[
															-0.363,
															6.445
														],
														[
															-0.274,
															6.391
														],
														[
															-0.174,
															6.26
														],
														[
															-0.075,
															7.13
														],
														[
															-0.202,
															7.32
														],
														[
															-0.231,
															7.454
														],
														[
															-0.164,
															7.532
														],
														[
															0,
															7.517
														],
														[
															-0.094,
															7.524
														],
														[
															-0.125,
															7.513
														],
														[
															-0.094,
															7.482
														],
														[
															0,
															11.196
														],
														[
															0.188,
															11.319
														],
														[
															0.25,
															11.227
														],
														[
															0.188,
															10.92
														],
														[
															0,
															3.775
														],
														[
															0.038,
															3.792
														],
														[
															0.08,
															3.824
														],
														[
															0.127,
															3.87
														],
														[
															0.3,
															6.609
														],
														[
															0.335,
															7.127
														],
														[
															0.398,
															7.458
														],
														[
															0.489,
															7.602
														],
														[
															0.392,
															4.862
														],
														[
															0.258,
															3.467
														],
														[
															0.25,
															2.979
														],
														[
															0.367,
															3.397
														],
														[
															0.078,
															0.602
														],
														[
															0.144,
															1.421
														],
														[
															0.234,
															1.896
														],
														[
															0.348,
															2.027
														],
														[
															0.543,
															2.028
														],
														[
															0.761,
															1.629
														],
														[
															1.041,
															1.042
														],
														[
															1.385,
															0.267
														],
														[
															0.226,
															-0.088
														],
														[
															0.381,
															-0.056
														],
														[
															0.414,
															-0.059
														],
														[
															0.326,
															-0.099
														],
														[
															0.323,
															-0.483
														],
														[
															0.028,
															-1.027
														],
														[
															-0.107,
															-1.228
														],
														[
															-0.081,
															-1.087
														],
														[
															0.053,
															-0.307
														],
														[
															0.179,
															-0.336
														],
														[
															0.222,
															-0.346
														],
														[
															0.182,
															-0.337
														],
														[
															2.114,
															-11.229
														],
														[
															1.47,
															-12.433
														],
														[
															0.98,
															-12.905
														],
														[
															0.646,
															-12.644
														],
														[
															0.639,
															-15.993
														],
														[
															0.401,
															-14.561
														],
														[
															0.215,
															-14.152
														],
														[
															0.081,
															-14.765
														],
														[
															0,
															-23.298
														],
														[
															-0.122,
															-22.776
														],
														[
															-0.447,
															-22.401
														],
														[
															-0.977,
															-22.175
														],
														[
															-0.4,
															-5.172
														],
														[
															-0.365,
															-5.328
														],
														[
															-0.432,
															-5.343
														],
														[
															-0.601,
															-5.219
														],
														[
															-0.289,
															-1.64
														],
														[
															-0.455,
															-1.918
														],
														[
															-0.548,
															-1.778
														],
														[
															-0.57,
															-1.221
														],
														[
															-0.167,
															-0.08
														],
														[
															-1.063,
															0.017
														],
														[
															-1.384,
															0.096
														],
														[
															-1.129,
															0.156
														]
													],
													"v": [
														[
															356,
															16
														],
														[
															355.651,
															16.245
														],
														[
															355.44,
															16.434
														],
														[
															355.331,
															16.594
														],
														[
															355.286,
															16.756
														],
														[
															355.268,
															16.948
														],
														[
															355.239,
															17.2
														],
														[
															355.162,
															17.541
														],
														[
															355,
															18
														],
														[
															353.552,
															22.048
														],
														[
															352.342,
															26.49
														],
														[
															351.334,
															31.267
														],
														[
															350.489,
															36.315
														],
														[
															349.771,
															41.574
														],
														[
															349.142,
															46.982
														],
														[
															348.564,
															52.478
														],
														[
															348,
															58
														],
														[
															346.24,
															76.073
														],
														[
															344.63,
															94.792
														],
														[
															343.204,
															113.926
														],
														[
															341.995,
															133.245
														],
														[
															341.036,
															152.518
														],
														[
															340.36,
															171.513
														],
														[
															340,
															190
														],
														[
															339.561,
															211.688
														],
														[
															338.888,
															233.862
														],
														[
															338.27,
															256.355
														],
														[
															338,
															279
														],
														[
															337.844,
															301.566
														],
														[
															337.5,
															324.126
														],
														[
															337.156,
															346.623
														],
														[
															337,
															369
														],
														[
															337.312,
															402.825
														],
														[
															338,
															436.696
														],
														[
															338.688,
															469.969
														],
														[
															339,
															502
														],
														[
															339.056,
															513.348
														],
														[
															339.232,
															524.768
														],
														[
															339.543,
															536.304
														],
														[
															340,
															548
														],
														[
															340.946,
															568.651
														],
														[
															342.037,
															590.576
														],
														[
															343.36,
															613.213
														],
														[
															345,
															636
														],
														[
															345.943,
															648.268
														],
														[
															346.673,
															657.71
														],
														[
															347.567,
															667.048
														],
														[
															349,
															679
														],
														[
															349.327,
															682.12
														],
														[
															349.888,
															687.181
														],
														[
															350.755,
															693.151
														],
														[
															352,
															699
														],
														[
															353.94,
															704.533
														],
														[
															356.627,
															708.586
														],
														[
															360.25,
															710.596
														],
														[
															365,
															710
														],
														[
															365.942,
															709.793
														],
														[
															367.165,
															709.63
														],
														[
															368.305,
															709.401
														],
														[
															369,
															709
														],
														[
															369.487,
															706.649
														],
														[
															369.328,
															703.179
														],
														[
															369.005,
															699.62
														],
														[
															369,
															697
														],
														[
															369.37,
															696.03
														],
														[
															369.993,
															695.001
														],
														[
															370.62,
															693.972
														],
														[
															371,
															693
														],
														[
															376.336,
															657.323
														],
														[
															379.972,
															619.133
														],
														[
															382.372,
															580.626
														],
														[
															384,
															544
														],
														[
															385.547,
															498.425
														],
														[
															386.459,
															455.612
														],
														[
															386.891,
															412.492
														],
														[
															387,
															366
														],
														[
															386.869,
															296.926
														],
														[
															386.066,
															229.197
														],
														[
															383.981,
															162.37
														],
														[
															380,
															96
														],
														[
															378.877,
															80.214
														],
														[
															377.708,
															64.172
														],
														[
															376.185,
															48.294
														],
														[
															374,
															33
														],
														[
															372.867,
															27.559
														],
														[
															371.345,
															21.912
														],
														[
															369.65,
															17.309
														],
														[
															368,
															15
														],
														[
															366.011,
															14.911
														],
														[
															362.197,
															15.086
														],
														[
															358.285,
															15.467
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 79,
											"s": [
												{
													"i": [
														[
															0.093,
															-0.038
														],
														[
															0.282,
															-0.046
														],
														[
															0.255,
															-0.037
														],
														[
															0.221,
															-0.097
														],
														[
															0.179,
															-0.228
														],
														[
															1.871,
															-4.287
														],
														[
															1.458,
															-4.932
														],
														[
															1.108,
															-4.929
														],
														[
															0.82,
															-4.279
														],
														[
															0.262,
															-1.841
														],
														[
															0.22,
															-1.845
														],
														[
															0.223,
															-1.831
														],
														[
															0.272,
															-1.8
														],
														[
															1.105,
															-9.356
														],
														[
															0.869,
															-9.295
														],
														[
															0.704,
															-9.166
														],
														[
															0.612,
															-8.97
														],
														[
															0.498,
															-9.891
														],
														[
															0.336,
															-10.009
														],
														[
															0.17,
															-9.988
														],
														[
															0,
															-9.83
														],
														[
															0.071,
															-12.181
														],
														[
															0.007,
															-12.018
														],
														[
															-0.193,
															-11.828
														],
														[
															-0.528,
															-11.611
														],
														[
															-0.996,
															-17.29
														],
														[
															-1.483,
															-16.918
														],
														[
															-2.245,
															-16.169
														],
														[
															-3.283,
															-15.043
														],
														[
															-0.735,
															-2.933
														],
														[
															-0.877,
															-3.033
														],
														[
															-0.954,
															-2.709
														],
														[
															-0.964,
															-1.96
														],
														[
															-0.188,
															-0.39
														],
														[
															-0.209,
															-0.427
														],
														[
															-0.166,
															-0.324
														],
														[
															-0.061,
															-0.081
														],
														[
															-1.401,
															-0.973
														],
														[
															-1.822,
															-0.751
														],
														[
															-1.884,
															-0.152
														],
														[
															-1.59,
															0.823
														],
														[
															-0.488,
															1.095
														],
														[
															-0.163,
															1.355
														],
														[
															-0.093,
															1.332
														],
														[
															-0.28,
															1.027
														],
														[
															-0.261,
															0.358
														],
														[
															-0.308,
															0.299
														],
														[
															-0.268,
															0.291
														],
														[
															-0.142,
															0.336
														],
														[
															-0.681,
															1.722
														],
														[
															-0.558,
															1.531
														],
														[
															-0.473,
															1.419
														],
														[
															-0.427,
															1.386
														],
														[
															-1.373,
															6.035
														],
														[
															-1.103,
															6.367
														],
														[
															-0.929,
															6.649
														],
														[
															-0.85,
															6.88
														],
														[
															-0.765,
															6.887
														],
														[
															-0.678,
															6.952
														],
														[
															-0.574,
															6.964
														],
														[
															-0.454,
															6.925
														],
														[
															-0.674,
															14.636
														],
														[
															-0.375,
															14.948
														],
														[
															-0.013,
															14.838
														],
														[
															0.411,
															14.306
														],
														[
															-0.086,
															0.117
														],
														[
															-0.122,
															0.045
														],
														[
															-0.1,
															0.03
														],
														[
															-0.019,
															0.073
														],
														[
															0.08,
															0.173
														],
														[
															0.138,
															0.147
														],
														[
															0.114,
															0.151
														],
														[
															0.009,
															0.184
														],
														[
															0.059,
															7.224
														],
														[
															-0.043,
															7.122
														],
														[
															0.044,
															6.962
														],
														[
															0.321,
															6.745
														],
														[
															1.116,
															17.812
														],
														[
															1.706,
															17.392
														],
														[
															2.613,
															16.384
														],
														[
															3.834,
															14.789
														],
														[
															0.999,
															3.281
														],
														[
															1.243,
															2.994
														],
														[
															1.498,
															2.091
														],
														[
															1.764,
															0.572
														],
														[
															1.257,
															0.069
														],
														[
															1.381,
															-0.034
														],
														[
															1.059,
															-0.086
														],
														[
															0.29,
															-0.087
														],
														[
															0.117,
															-0.135
														],
														[
															0.065,
															-0.123
														]
													],
													"o": [
														[
															-0.301,
															0.125
														],
														[
															-0.282,
															0.046
														],
														[
															-0.255,
															0.037
														],
														[
															-0.221,
															0.097
														],
														[
															-2.347,
															2.994
														],
														[
															-1.871,
															4.287
														],
														[
															-1.458,
															4.932
														],
														[
															-1.108,
															4.929
														],
														[
															-0.349,
															1.821
														],
														[
															-0.262,
															1.841
														],
														[
															-0.22,
															1.845
														],
														[
															-0.223,
															1.831
														],
														[
															-1.414,
															9.35
														],
														[
															-1.105,
															9.356
														],
														[
															-0.869,
															9.295
														],
														[
															-0.704,
															9.166
														],
														[
															-0.657,
															9.635
														],
														[
															-0.498,
															9.891
														],
														[
															-0.336,
															10.009
														],
														[
															-0.17,
															9.988
														],
														[
															0,
															12.318
														],
														[
															-0.071,
															12.181
														],
														[
															-0.007,
															12.018
														],
														[
															0.193,
															11.828
														],
														[
															0.785,
															17.286
														],
														[
															0.996,
															17.29
														],
														[
															1.483,
															16.918
														],
														[
															2.245,
															16.169
														],
														[
															0.526,
															2.409
														],
														[
															0.735,
															2.933
														],
														[
															0.877,
															3.033
														],
														[
															0.954,
															2.709
														],
														[
															0.104,
															0.212
														],
														[
															0.188,
															0.39
														],
														[
															0.209,
															0.427
														],
														[
															0.166,
															0.324
														],
														[
															0.624,
															0.819
														],
														[
															1.401,
															0.973
														],
														[
															1.822,
															0.751
														],
														[
															1.884,
															0.152
														],
														[
															1.07,
															-0.553
														],
														[
															0.488,
															-1.095
														],
														[
															0.162,
															-1.355
														],
														[
															0.093,
															-1.332
														],
														[
															0.128,
															-0.469
														],
														[
															0.261,
															-0.358
														],
														[
															0.308,
															-0.299
														],
														[
															0.268,
															-0.291
														],
														[
															0.841,
															-1.992
														],
														[
															0.681,
															-1.722
														],
														[
															0.558,
															-1.531
														],
														[
															0.473,
															-1.419
														],
														[
															1.739,
															-5.651
														],
														[
															1.373,
															-6.035
														],
														[
															1.103,
															-6.367
														],
														[
															0.929,
															-6.649
														],
														[
															0.836,
															-6.769
														],
														[
															0.765,
															-6.887
														],
														[
															0.678,
															-6.952
														],
														[
															0.574,
															-6.964
														],
														[
															0.911,
															-13.903
														],
														[
															0.674,
															-14.636
														],
														[
															0.375,
															-14.948
														],
														[
															0.013,
															-14.838
														],
														[
															-0.007,
															-0.248
														],
														[
															0.086,
															-0.117
														],
														[
															0.122,
															-0.045
														],
														[
															0.1,
															-0.03
														],
														[
															0.06,
															-0.229
														],
														[
															-0.08,
															-0.173
														],
														[
															-0.138,
															-0.147
														],
														[
															-0.114,
															-0.151
														],
														[
															-0.353,
															-7.268
														],
														[
															-0.06,
															-7.224
														],
														[
															0.044,
															-7.122
														],
														[
															-0.044,
															-6.962
														],
														[
															-0.84,
															-17.644
														],
														[
															-1.116,
															-17.812
														],
														[
															-1.706,
															-17.392
														],
														[
															-2.613,
															-16.384
														],
														[
															-0.765,
															-2.952
														],
														[
															-0.999,
															-3.281
														],
														[
															-1.243,
															-2.994
														],
														[
															-1.498,
															-2.091
														],
														[
															-0.686,
															-0.223
														],
														[
															-1.257,
															-0.069
														],
														[
															-1.381,
															0.034
														],
														[
															-1.059,
															0.086
														],
														[
															-0.249,
															0.074
														],
														[
															-0.117,
															0.135
														],
														[
															-0.065,
															0.123
														]
													],
													"v": [
														[
															355,
															16
														],
														[
															354.123,
															16.239
														],
														[
															353.316,
															16.346
														],
														[
															352.601,
															16.529
														],
														[
															352,
															17
														],
														[
															345.687,
															28.082
														],
														[
															340.708,
															42.071
														],
														[
															336.875,
															57.025
														],
														[
															334,
															71
														],
														[
															333.096,
															76.498
														],
														[
															332.385,
															82.031
														],
														[
															331.732,
															87.549
														],
														[
															331,
															93
														],
														[
															327.24,
															121.077
														],
														[
															324.297,
															149.07
														],
														[
															321.956,
															176.779
														],
														[
															320,
															204
														],
														[
															318.266,
															233.323
														],
														[
															317.014,
															263.207
														],
														[
															316.255,
															293.238
														],
														[
															316,
															323
														],
														[
															315.86,
															359.756
														],
														[
															315.709,
															396.061
														],
														[
															315.954,
															431.835
														],
														[
															317,
															467
														],
														[
															319.603,
															518.958
														],
														[
															323.253,
															570.364
														],
														[
															328.777,
															620.088
														],
														[
															337,
															667
														],
														[
															338.907,
															675.118
														],
														[
															341.342,
															684.172
														],
														[
															344.106,
															692.89
														],
														[
															347,
															700
														],
														[
															347.454,
															700.938
														],
														[
															348.064,
															702.198
														],
														[
															348.643,
															703.359
														],
														[
															349,
															704
														],
														[
															352.127,
															706.783
														],
														[
															357.051,
															709.463
														],
														[
															362.7,
															710.912
														],
														[
															368,
															710
														],
														[
															370.272,
															707.456
														],
														[
															371.184,
															703.711
														],
														[
															371.503,
															699.61
														],
														[
															372,
															696
														],
														[
															372.605,
															694.773
														],
														[
															373.479,
															693.801
														],
														[
															374.364,
															692.928
														],
														[
															375,
															692
														],
														[
															377.273,
															686.45
														],
														[
															379.121,
															681.591
														],
														[
															380.659,
															677.187
														],
														[
															382,
															673
														],
														[
															386.644,
															655.459
														],
														[
															390.333,
															636.843
														],
														[
															393.356,
															617.306
														],
														[
															396,
															597
														],
														[
															398.406,
															576.503
														],
														[
															400.574,
															555.732
														],
														[
															402.455,
															534.846
														],
														[
															404,
															514
														],
														[
															406.394,
															471.085
														],
														[
															407.983,
															426.604
														],
														[
															408.581,
															381.82
														],
														[
															408,
															338
														],
														[
															408.134,
															337.467
														],
														[
															408.461,
															337.239
														],
														[
															408.807,
															337.141
														],
														[
															409,
															337
														],
														[
															408.95,
															336.405
														],
														[
															408.604,
															335.933
														],
														[
															408.205,
															335.495
														],
														[
															408,
															335
														],
														[
															407.429,
															313.248
														],
														[
															407.453,
															291.716
														],
														[
															407.5,
															270.575
														],
														[
															407,
															250
														],
														[
															404.145,
															196.67
														],
														[
															399.991,
															143.718
														],
														[
															393.591,
															92.907
														],
														[
															384,
															46
														],
														[
															381.357,
															36.497
														],
														[
															377.998,
															26.931
														],
														[
															373.89,
															19.149
														],
														[
															369,
															15
														],
														[
															365.975,
															14.576
														],
														[
															361.907,
															14.536
														],
														[
															358.136,
															14.728
														],
														[
															356,
															15
														],
														[
															355.471,
															15.333
														],
														[
															355.217,
															15.739
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 80,
											"s": [
												{
													"i": [
														[
															0.463,
															-0.131
														],
														[
															0.524,
															-0.184
														],
														[
															0.427,
															-0.194
														],
														[
															0.356,
															-0.21
														],
														[
															0.309,
															-0.233
														],
														[
															0.287,
															-0.262
														],
														[
															0.29,
															-0.297
														],
														[
															0.317,
															-0.339
														],
														[
															0.37,
															-0.388
														],
														[
															0.757,
															-0.935
														],
														[
															0.663,
															-0.962
														],
														[
															0.589,
															-0.994
														],
														[
															0.533,
															-1.03
														],
														[
															0.496,
															-1.07
														],
														[
															0.478,
															-1.116
														],
														[
															0.479,
															-1.165
														],
														[
															0.499,
															-1.219
														],
														[
															0.92,
															-2.505
														],
														[
															0.828,
															-2.514
														],
														[
															0.748,
															-2.524
														],
														[
															0.679,
															-2.537
														],
														[
															0.62,
															-2.551
														],
														[
															0.573,
															-2.567
														],
														[
															0.538,
															-2.585
														],
														[
															0.513,
															-2.606
														],
														[
															0.569,
															-3.225
														],
														[
															0.533,
															-3.322
														],
														[
															0.496,
															-3.361
														],
														[
															0.459,
															-3.34
														],
														[
															0.421,
															-3.261
														],
														[
															0.382,
															-3.124
														],
														[
															0.342,
															-2.927
														],
														[
															1.766,
															-33.167
														],
														[
															-0.082,
															-34.191
														],
														[
															-2.057,
															-32.928
														],
														[
															-4.159,
															-29.379
														],
														[
															-1.331,
															-8.228
														],
														[
															-1.625,
															-8.325
														],
														[
															-1.982,
															-8.059
														],
														[
															-2.401,
															-7.431
														],
														[
															-0.845,
															-2.508
														],
														[
															-0.905,
															-2.413
														],
														[
															-0.983,
															-2.198
														],
														[
															-1.079,
															-1.863
														],
														[
															-0.663,
															-0.981
														],
														[
															-0.803,
															-1.116
														],
														[
															-0.739,
															-0.952
														],
														[
															-0.47,
															-0.489
														],
														[
															-0.978,
															-0.686
														],
														[
															-1.149,
															-0.501
														],
														[
															-1.347,
															-0.315
														],
														[
															-1.57,
															-0.126
														],
														[
															-1.13,
															-0.036
														],
														[
															-1.153,
															0.049
														],
														[
															-0.947,
															0.186
														],
														[
															-0.51,
															0.374
														],
														[
															-0.351,
															1.153
														],
														[
															-0.182,
															1.403
														],
														[
															-0.24,
															1.299
														],
														[
															-0.524,
															0.84
														],
														[
															-0.305,
															0.186
														],
														[
															-0.367,
															0.175
														],
														[
															-0.378,
															0.276
														],
														[
															-0.339,
															0.489
														],
														[
															-1.638,
															2.712
														],
														[
															-1.353,
															2.655
														],
														[
															-1.163,
															2.741
														],
														[
															-1.069,
															2.969
														],
														[
															-2.266,
															8.86
														],
														[
															-1.728,
															9.096
														],
														[
															-1.348,
															8.938
														],
														[
															-1.125,
															8.387
														],
														[
															-1.498,
															15.874
														],
														[
															-1.003,
															16.277
														],
														[
															-0.504,
															16.015
														],
														[
															0,
															15.086
														],
														[
															0.81,
															24.452
														],
														[
															1.898,
															23.8
														],
														[
															3.264,
															22.323
														],
														[
															4.908,
															20.021
														],
														[
															0.882,
															3.37
														],
														[
															0.937,
															3.142
														],
														[
															1.087,
															3.076
														],
														[
															1.332,
															3.172
														],
														[
															1.584,
															3.057
														],
														[
															1.859,
															2.686
														],
														[
															2.095,
															1.911
														],
														[
															2.293,
															0.732
														],
														[
															1.731,
															0.131
														],
														[
															1.633,
															-0.087
														],
														[
															1.211,
															-0.175
														]
													],
													"o": [
														[
															-0.645,
															0.181
														],
														[
															-0.524,
															0.184
														],
														[
															-0.427,
															0.194
														],
														[
															-0.356,
															0.21
														],
														[
															-0.309,
															0.233
														],
														[
															-0.287,
															0.262
														],
														[
															-0.29,
															0.297
														],
														[
															-0.317,
															0.339
														],
														[
															-0.869,
															0.912
														],
														[
															-0.757,
															0.935
														],
														[
															-0.663,
															0.962
														],
														[
															-0.589,
															0.994
														],
														[
															-0.533,
															1.03
														],
														[
															-0.496,
															1.07
														],
														[
															-0.478,
															1.116
														],
														[
															-0.479,
															1.165
														],
														[
															-1.023,
															2.498
														],
														[
															-0.92,
															2.505
														],
														[
															-0.828,
															2.514
														],
														[
															-0.748,
															2.524
														],
														[
															-0.679,
															2.537
														],
														[
															-0.62,
															2.551
														],
														[
															-0.573,
															2.567
														],
														[
															-0.538,
															2.585
														],
														[
															-0.604,
															3.069
														],
														[
															-0.569,
															3.225
														],
														[
															-0.533,
															3.322
														],
														[
															-0.496,
															3.361
														],
														[
															-0.459,
															3.34
														],
														[
															-0.421,
															3.261
														],
														[
															-0.382,
															3.124
														],
														[
															-3.488,
															29.858
														],
														[
															-1.766,
															33.167
														],
														[
															0.082,
															34.191
														],
														[
															2.057,
															32.928
														],
														[
															1.1,
															7.769
														],
														[
															1.331,
															8.228
														],
														[
															1.625,
															8.325
														],
														[
															1.982,
															8.059
														],
														[
															0.803,
															2.483
														],
														[
															0.845,
															2.508
														],
														[
															0.905,
															2.413
														],
														[
															0.983,
															2.198
														],
														[
															0.317,
															0.548
														],
														[
															0.663,
															0.981
														],
														[
															0.803,
															1.116
														],
														[
															0.739,
															0.952
														],
														[
															0.832,
															0.868
														],
														[
															0.978,
															0.686
														],
														[
															1.149,
															0.501
														],
														[
															1.347,
															0.315
														],
														[
															0.876,
															0.071
														],
														[
															1.13,
															0.036
														],
														[
															1.153,
															-0.049
														],
														[
															0.947,
															-0.186
														],
														[
															0.748,
															-0.548
														],
														[
															0.351,
															-1.153
														],
														[
															0.182,
															-1.403
														],
														[
															0.24,
															-1.299
														],
														[
															0.193,
															-0.31
														],
														[
															0.305,
															-0.186
														],
														[
															0.367,
															-0.175
														],
														[
															0.378,
															-0.276
														],
														[
															2.019,
															-2.911
														],
														[
															1.638,
															-2.712
														],
														[
															1.353,
															-2.655
														],
														[
															1.163,
															-2.741
														],
														[
															2.963,
															-8.23
														],
														[
															2.266,
															-8.86
														],
														[
															1.728,
															-9.096
														],
														[
															1.348,
															-8.938
														],
														[
															1.987,
															-14.805
														],
														[
															1.498,
															-15.874
														],
														[
															1.003,
															-16.277
														],
														[
															0.504,
															-16.015
														],
														[
															0,
															-24.278
														],
														[
															-0.81,
															-24.452
														],
														[
															-1.898,
															-23.8
														],
														[
															-3.264,
															-22.323
														],
														[
															-0.922,
															-3.76
														],
														[
															-0.882,
															-3.37
														],
														[
															-0.936,
															-3.142
														],
														[
															-1.087,
															-3.076
														],
														[
															-1.271,
															-3.026
														],
														[
															-1.584,
															-3.057
														],
														[
															-1.859,
															-2.686
														],
														[
															-2.095,
															-1.911
														],
														[
															-1.505,
															-0.48
														],
														[
															-1.731,
															-0.131
														],
														[
															-1.633,
															0.087
														],
														[
															-1.211,
															0.175
														]
													],
													"v": [
														[
															354,
															16
														],
														[
															352.254,
															16.547
														],
														[
															350.834,
															17.113
														],
														[
															349.666,
															17.718
														],
														[
															348.675,
															18.38
														],
														[
															347.788,
															19.12
														],
														[
															346.929,
															19.957
														],
														[
															346.024,
															20.911
														],
														[
															345,
															22
														],
														[
															342.567,
															24.768
														],
														[
															340.442,
															27.612
														],
														[
															338.568,
															30.544
														],
														[
															336.89,
															33.578
														],
														[
															335.351,
															36.728
														],
														[
															333.894,
															40.006
														],
														[
															332.462,
															43.425
														],
														[
															331,
															47
														],
														[
															328.089,
															54.504
														],
														[
															325.469,
															62.032
														],
														[
															323.108,
															69.588
														],
														[
															320.97,
															77.178
														],
														[
															319.024,
															84.809
														],
														[
															317.236,
															92.486
														],
														[
															315.573,
															100.214
														],
														[
															314,
															108
														],
														[
															312.24,
															117.457
														],
														[
															310.587,
															127.293
														],
														[
															309.042,
															137.333
														],
														[
															307.609,
															147.399
														],
														[
															306.29,
															157.317
														],
														[
															305.086,
															166.909
														],
														[
															304,
															176
														],
														[
															296.087,
															271.109
														],
														[
															293.529,
															372.718
														],
														[
															296.708,
															473.968
														],
														[
															306,
															568
														],
														[
															309.63,
															592.087
														],
														[
															314.048,
															617.007
														],
														[
															319.442,
															641.674
														],
														[
															326,
															665
														],
														[
															328.466,
															672.517
														],
														[
															331.086,
															679.93
														],
														[
															333.912,
															686.878
														],
														[
															337,
															693
														],
														[
															338.522,
															695.369
														],
														[
															340.772,
															698.588
														],
														[
															343.136,
															701.764
														],
														[
															345,
															704
														],
														[
															347.709,
															706.331
														],
														[
															350.894,
															708.113
														],
														[
															354.631,
															709.338
														],
														[
															359,
															710
														],
														[
															362.067,
															710.173
														],
														[
															365.549,
															710.167
														],
														[
															368.757,
															709.827
														],
														[
															371,
															709
														],
														[
															372.592,
															706.359
														],
														[
															373.336,
															702.437
														],
														[
															373.911,
															698.296
														],
														[
															375,
															695
														],
														[
															375.76,
															694.284
														],
														[
															376.781,
															693.769
														],
														[
															377.912,
															693.12
														],
														[
															379,
															692
														],
														[
															384.461,
															683.601
														],
														[
															388.924,
															675.587
														],
														[
															392.675,
															667.53
														],
														[
															396,
															659
														],
														[
															403.804,
															633.266
														],
														[
															409.756,
															606.234
														],
														[
															414.33,
															579.085
														],
														[
															418,
															553
														],
														[
															423.228,
															506.815
														],
														[
															426.98,
															458.422
														],
														[
															429.243,
															409.817
														],
														[
															430,
															363
														],
														[
															428.854,
															289.7
														],
														[
															424.861,
															217.115
														],
														[
															417.188,
															147.723
														],
														[
															405,
															84
														],
														[
															402.319,
															73.345
														],
														[
															399.616,
															63.618
														],
														[
															396.605,
															54.331
														],
														[
															393,
															45
														],
														[
															388.708,
															35.775
														],
														[
															383.534,
															27.06
														],
														[
															377.593,
															20.065
														],
														[
															371,
															16
														],
														[
															366.066,
															15.116
														],
														[
															360.939,
															15.084
														],
														[
															356.592,
															15.51
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 81,
											"s": [
												{
													"i": [
														[
															0.496,
															-0.105
														],
														[
															0.258,
															0.018
														],
														[
															0.269,
															0.033
														],
														[
															0.251,
															-0.001
														],
														[
															0.206,
															-0.085
														],
														[
															2.871,
															-2.316
														],
														[
															2.375,
															-2.888
														],
														[
															1.941,
															-3.128
														],
														[
															1.57,
															-3.036
														],
														[
															2.191,
															-5.214
														],
														[
															1.912,
															-5.454
														],
														[
															1.639,
															-5.513
														],
														[
															1.375,
															-5.391
														],
														[
															2.041,
															-10.342
														],
														[
															1.599,
															-10.67
														],
														[
															1.258,
															-11.118
														],
														[
															1.019,
															-11.686
														],
														[
															0.628,
															-32.767
														],
														[
															-1.65,
															-32.268
														],
														[
															-4.078,
															-30.117
														],
														[
															-6.656,
															-26.313
														],
														[
															-0.4,
															-1.708
														],
														[
															-0.397,
															-1.684
														],
														[
															-0.424,
															-1.634
														],
														[
															-0.479,
															-1.557
														],
														[
															-0.337,
															-0.746
														],
														[
															-0.371,
															-0.725
														],
														[
															-0.348,
															-0.742
														],
														[
															-0.27,
															-0.795
														],
														[
															-1.067,
															-3.171
														],
														[
															-1.113,
															-3.041
														],
														[
															-1.24,
															-2.849
														],
														[
															-1.448,
															-2.596
														],
														[
															-0.089,
															-0.086
														],
														[
															-0.127,
															-0.13
														],
														[
															-0.1,
															-0.104
														],
														[
															-0.007,
															-0.007
														],
														[
															-0.077,
															-0.136
														],
														[
															-0.03,
															-0.123
														],
														[
															-0.063,
															-0.176
														],
														[
															-0.175,
															-0.294
														],
														[
															-1.207,
															-1.726
														],
														[
															-1.313,
															-1.568
														],
														[
															-1.449,
															-1.433
														],
														[
															-1.616,
															-1.32
														],
														[
															-0.156,
															-0.266
														],
														[
															-0.143,
															-0.296
														],
														[
															-0.165,
															-0.257
														],
														[
															-0.222,
															-0.148
														],
														[
															-0.333,
															-0.079
														],
														[
															-0.345,
															-0.033
														],
														[
															-0.34,
															-0.062
														],
														[
															-0.317,
															-0.168
														],
														[
															-0.661,
															-0.361
														],
														[
															-0.754,
															-0.294
														],
														[
															-1.128,
															-0.25
														],
														[
															-4.136,
															0.182
														],
														[
															-1.293,
															1.972
														],
														[
															-0.322,
															2.255
														],
														[
															-1.339,
															1.887
														],
														[
															-0.692,
															0.194
														],
														[
															-0.14,
															0.096
														],
														[
															-0.225,
															0.228
														],
														[
															-0.068,
															0.065
														],
														[
															-0.322,
															0.093
														],
														[
															-0.384,
															0.313
														],
														[
															-1.791,
															2.629
														],
														[
															-1.549,
															1.617
														],
														[
															-0.064,
															0.261
														],
														[
															-0.35,
															0.546
														],
														[
															-6.92,
															26.086
														],
														[
															-4.227,
															29.77
														],
														[
															-1.952,
															32.081
														],
														[
															0.742,
															30.968
														],
														[
															2.594,
															29.753
														],
														[
															3.901,
															26.739
														],
														[
															0.427,
															0.812
														],
														[
															0.163,
															0.876
														],
														[
															0.4,
															3.474
														],
														[
															0.692,
															3.306
														],
														[
															0.577,
															1.469
														],
														[
															0.366,
															1.572
														],
														[
															2.724,
															9.683
														],
														[
															3.779,
															9.286
														],
														[
															0.8,
															2.165
														],
														[
															0.897,
															2.125
														],
														[
															1.213,
															1.941
														],
														[
															1.161,
															1.898
														],
														[
															4.249,
															4.47
														],
														[
															4.446,
															1.308
														],
														[
															4.267,
															-0.226
														]
													],
													"o": [
														[
															-0.219,
															0.047
														],
														[
															-0.258,
															-0.018
														],
														[
															-0.269,
															-0.033
														],
														[
															-0.251,
															0.001
														],
														[
															-3.43,
															1.411
														],
														[
															-2.871,
															2.316
														],
														[
															-2.375,
															2.888
														],
														[
															-1.941,
															3.128
														],
														[
															-2.479,
															4.794
														],
														[
															-2.191,
															5.214
														],
														[
															-1.912,
															5.454
														],
														[
															-1.639,
															5.513
														],
														[
															-2.585,
															10.135
														],
														[
															-2.041,
															10.342
														],
														[
															-1.599,
															10.67
														],
														[
															-1.258,
															11.118
														],
														[
															-2.757,
															31.614
														],
														[
															-0.628,
															32.767
														],
														[
															1.65,
															32.268
														],
														[
															4.078,
															30.117
														],
														[
															0.431,
															1.705
														],
														[
															0.4,
															1.708
														],
														[
															0.397,
															1.684
														],
														[
															0.424,
															1.634
														],
														[
															0.247,
															0.803
														],
														[
															0.337,
															0.746
														],
														[
															0.371,
															0.725
														],
														[
															0.348,
															0.742
														],
														[
															1.101,
															3.241
														],
														[
															1.067,
															3.171
														],
														[
															1.113,
															3.041
														],
														[
															1.24,
															2.849
														],
														[
															-0.015,
															-0.027
														],
														[
															0.089,
															0.086
														],
														[
															0.127,
															0.13
														],
														[
															0.1,
															0.104
														],
														[
															0.204,
															0.214
														],
														[
															0.077,
															0.136
														],
														[
															0.03,
															0.123
														],
														[
															0.063,
															0.176
														],
														[
															1.132,
															1.906
														],
														[
															1.207,
															1.726
														],
														[
															1.313,
															1.568
														],
														[
															1.449,
															1.433
														],
														[
															0.205,
															0.167
														],
														[
															0.156,
															0.266
														],
														[
															0.143,
															0.296
														],
														[
															0.165,
															0.257
														],
														[
															0.302,
															0.202
														],
														[
															0.333,
															0.079
														],
														[
															0.345,
															0.033
														],
														[
															0.34,
															0.062
														],
														[
															0.848,
															0.45
														],
														[
															0.661,
															0.361
														],
														[
															0.754,
															0.294
														],
														[
															3.164,
															0.702
														],
														[
															4.136,
															-0.182
														],
														[
															1.373,
															-2.094
														],
														[
															0.322,
															-2.255
														],
														[
															0.092,
															-0.13
														],
														[
															0.692,
															-0.194
														],
														[
															0.031,
															-0.022
														],
														[
															0.225,
															-0.228
														],
														[
															0.327,
															-0.313
														],
														[
															0.322,
															-0.093
														],
														[
															2.288,
															-1.866
														],
														[
															1.791,
															-2.629
														],
														[
															0.393,
															-0.41
														],
														[
															0.064,
															-0.261
														],
														[
															12.094,
															-18.886
														],
														[
															6.92,
															-26.086
														],
														[
															3.934,
															-27.709
														],
														[
															1.952,
															-32.081
														],
														[
															-0.725,
															-30.248
														],
														[
															-2.593,
															-29.753
														],
														[
															-0.127,
															-0.874
														],
														[
															-0.427,
															-0.812
														],
														[
															-0.706,
															-3.798
														],
														[
															-0.4,
															-3.474
														],
														[
															-0.325,
															-1.551
														],
														[
															-0.577,
															-1.469
														],
														[
															-2.325,
															-9.982
														],
														[
															-2.724,
															-9.683
														],
														[
															-0.902,
															-2.216
														],
														[
															-0.8,
															-2.165
														],
														[
															-0.987,
															-2.34
														],
														[
															-1.213,
															-1.941
														],
														[
															-3.558,
															-5.814
														],
														[
															-4.249,
															-4.47
														],
														[
															-3.436,
															-1.011
														],
														[
															-4.267,
															0.226
														]
													],
													"v": [
														[
															353,
															16
														],
														[
															352.277,
															16.031
														],
														[
															351.48,
															15.943
														],
														[
															350.693,
															15.883
														],
														[
															350,
															16
														],
														[
															340.563,
															21.673
														],
														[
															332.709,
															29.562
														],
														[
															326.251,
															38.671
														],
														[
															321,
															48
														],
														[
															313.997,
															63.057
														],
														[
															307.844,
															79.104
														],
														[
															302.519,
															95.599
														],
														[
															298,
															112
														],
														[
															291.086,
															142.685
														],
														[
															285.651,
															174.173
														],
														[
															281.391,
															206.824
														],
														[
															278,
															241
														],
														[
															272.885,
															337.985
														],
														[
															274.38,
															435.952
														],
														[
															282.936,
															529.942
														],
														[
															299,
															615
														],
														[
															300.24,
															620.126
														],
														[
															301.429,
															625.222
														],
														[
															302.653,
															630.206
														],
														[
															304,
															635
														],
														[
															304.89,
															637.315
														],
														[
															305.965,
															639.513
														],
														[
															307.058,
															641.704
														],
														[
															308,
															644
														],
														[
															311.232,
															653.634
														],
														[
															314.481,
															662.967
														],
														[
															317.989,
															671.816
														],
														[
															322,
															680
														],
														[
															322.127,
															680.106
														],
														[
															322.467,
															680.448
														],
														[
															322.823,
															680.816
														],
														[
															323,
															681
														],
														[
															323.403,
															681.507
														],
														[
															323.545,
															681.879
														],
														[
															323.664,
															682.311
														],
														[
															324,
															683
														],
														[
															327.502,
															688.443
														],
														[
															331.274,
															693.379
														],
														[
															335.41,
															697.876
														],
														[
															340,
															702
														],
														[
															340.533,
															702.668
														],
														[
															340.973,
															703.529
														],
														[
															341.427,
															704.375
														],
														[
															342,
															705
														],
														[
															342.957,
															705.402
														],
														[
															343.978,
															705.55
														],
														[
															345.011,
															705.673
														],
														[
															346,
															706
														],
														[
															348.194,
															707.212
														],
														[
															350.247,
															708.189
														],
														[
															353,
															709
														],
														[
															364.904,
															710.005
														],
														[
															374,
															707
														],
														[
															376.025,
															700.344
														],
														[
															378,
															694
														],
														[
															379.464,
															693.475
														],
														[
															381,
															693
														],
														[
															381.472,
															692.533
														],
														[
															382,
															692
														],
														[
															382.958,
															691.5
														],
														[
															384,
															691
														],
														[
															390.055,
															683.813
														],
														[
															395,
															677
														],
														[
															395.532,
															676.102
														],
														[
															396,
															675
														],
														[
															423.9,
															606.663
														],
														[
															440,
															522
														],
														[
															449.007,
															430.944
														],
														[
															451,
															335
														],
														[
															445.883,
															244.368
														],
														[
															436,
															159
														],
														[
															435.027,
															156.502
														],
														[
															434,
															154
														],
														[
															432.49,
															143.132
														],
														[
															431,
															133
														],
														[
															429.531,
															128.516
														],
														[
															428,
															124
														],
														[
															420.59,
															94.478
														],
														[
															411,
															66
														],
														[
															408.496,
															59.431
														],
														[
															406,
															53
														],
														[
															402.631,
															46.669
														],
														[
															399,
															41
														],
														[
															387.165,
															25.12
														],
														[
															374,
															16
														],
														[
															361.295,
															15.163
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 82,
											"s": [
												{
													"i": [
														[
															0.01,
															-0.002
														],
														[
															3.556,
															-1.894
														],
														[
															2.912,
															-2.598
														],
														[
															2.4,
															-2.905
														],
														[
															2.019,
															-2.814
														],
														[
															0.708,
															-1.08
														],
														[
															0.636,
															-1.053
														],
														[
															0.61,
															-1.072
														],
														[
															0.63,
															-1.135
														],
														[
															0.894,
															-1.525
														],
														[
															0.878,
															-1.514
														],
														[
															0.795,
															-1.482
														],
														[
															0.645,
															-1.429
														],
														[
															0.36,
															-1.097
														],
														[
															0.316,
															-1.095
														],
														[
															0.297,
															-0.95
														],
														[
															0.306,
															-0.664
														],
														[
															0.176,
															-0.443
														],
														[
															0.163,
															-0.436
														],
														[
															0.156,
															-0.4
														],
														[
															0.154,
															-0.335
														],
														[
															0.59,
															-1.476
														],
														[
															0.516,
															-1.438
														],
														[
															0.453,
															-1.351
														],
														[
															0.462,
															-1.84
														],
														[
															0.55,
															-1.852
														],
														[
															0.754,
															-1.658
														],
														[
															0.476,
															-1.66
														],
														[
															0.107,
															-0.985
														],
														[
															0.259,
															-0.969
														],
														[
															1.206,
															-4.757
														],
														[
															1.008,
															-4.588
														],
														[
															2.951,
															-24.601
														],
														[
															1.315,
															-26.38
														],
														[
															-3.406,
															-44.539
														],
														[
															-8.793,
															-39.325
														],
														[
															-1.52,
															-5.482
														],
														[
															-1.629,
															-5.304
														],
														[
															-1.161,
															-3.458
														],
														[
															-1.239,
															-3.533
														],
														[
															-0.436,
															-1.903
														],
														[
															-0.655,
															-1.675
														],
														[
															-0.914,
															-1.443
														],
														[
															-0.72,
															-1.629
														],
														[
															-0.067,
															-0.834
														],
														[
															-0.394,
															-0.905
														],
														[
															-1.839,
															-3.223
														],
														[
															-1.377,
															-2.193
														],
														[
															-0.772,
															-1.489
														],
														[
															-0.882,
															-1.405
														],
														[
															-0.518,
															-0.655
														],
														[
															-0.46,
															-0.635
														],
														[
															-7.039,
															-4.831
														],
														[
															-10.435,
															-0.202
														],
														[
															-2.695,
															0.174
														],
														[
															-0.589,
															0.355
														],
														[
															-0.667,
															2.716
														],
														[
															-1.749,
															2.182
														],
														[
															-0.896,
															0.21
														],
														[
															-0.954,
															0.582
														],
														[
															-0.613,
															0.74
														],
														[
															-0.732,
															0.544
														],
														[
															-1.543,
															1.134
														],
														[
															-1.264,
															1.301
														],
														[
															-1.137,
															1.545
														],
														[
															-1.14,
															1.471
														],
														[
															-3.87,
															6.798
														],
														[
															-2.179,
															7.207
														],
														[
															-0.46,
															0.392
														],
														[
															-0.105,
															0.249
														],
														[
															-0.807,
															2.785
														],
														[
															-0.687,
															2.273
														],
														[
															-0.463,
															0.389
														],
														[
															-0.092,
															0.259
														],
														[
															-0.673,
															2.457
														],
														[
															-0.515,
															1.938
														],
														[
															-0.372,
															0.796
														],
														[
															-0.275,
															0.926
														],
														[
															-2.972,
															13.762
														],
														[
															-2.307,
															14.165
														],
														[
															-1.5,
															39.788
														],
														[
															2.778,
															38.365
														],
														[
															3.106,
															21.848
														],
														[
															4.885,
															20.274
														],
														[
															4.166,
															12.74
														],
														[
															5.506,
															12.305
														],
														[
															7.467,
															9.675
														],
														[
															9.544,
															3.812
														],
														[
															5.388,
															0.503
														],
														[
															2.921,
															-0.42
														],
														[
															0.164,
															-0.238
														]
													],
													"o": [
														[
															-4.333,
															0.793
														],
														[
															-3.556,
															1.894
														],
														[
															-2.912,
															2.598
														],
														[
															-2.4,
															2.905
														],
														[
															-0.826,
															1.151
														],
														[
															-0.708,
															1.08
														],
														[
															-0.636,
															1.053
														],
														[
															-0.61,
															1.072
														],
														[
															-0.841,
															1.516
														],
														[
															-0.894,
															1.525
														],
														[
															-0.878,
															1.514
														],
														[
															-0.795,
															1.482
														],
														[
															-0.432,
															0.957
														],
														[
															-0.36,
															1.097
														],
														[
															-0.316,
															1.095
														],
														[
															-0.297,
															0.95
														],
														[
															-0.193,
															0.42
														],
														[
															-0.176,
															0.443
														],
														[
															-0.163,
															0.436
														],
														[
															-0.156,
															0.4
														],
														[
															-0.675,
															1.465
														],
														[
															-0.59,
															1.476
														],
														[
															-0.516,
															1.438
														],
														[
															-0.6,
															1.787
														],
														[
															-0.462,
															1.84
														],
														[
															-0.508,
															1.708
														],
														[
															-0.754,
															1.658
														],
														[
															-0.313,
															1.093
														],
														[
															-0.107,
															0.985
														],
														[
															-1.17,
															4.383
														],
														[
															-1.206,
															4.757
														],
														[
															-4.881,
															22.216
														],
														[
															-2.951,
															24.601
														],
														[
															-2.418,
															48.519
														],
														[
															3.406,
															44.539
														],
														[
															1.29,
															5.769
														],
														[
															1.52,
															5.482
														],
														[
															1.116,
															3.635
														],
														[
															1.161,
															3.458
														],
														[
															0.601,
															1.715
														],
														[
															0.436,
															1.903
														],
														[
															0.625,
															1.598
														],
														[
															0.914,
															1.443
														],
														[
															0.336,
															0.76
														],
														[
															0.067,
															0.834
														],
														[
															1.268,
															2.914
														],
														[
															1.839,
															3.223
														],
														[
															1.03,
															1.641
														],
														[
															0.772,
															1.488
														],
														[
															0.466,
															0.743
														],
														[
															0.518,
															0.655
														],
														[
															5.408,
															7.474
														],
														[
															7.039,
															4.831
														],
														[
															2.633,
															0.051
														],
														[
															2.695,
															-0.174
														],
														[
															1.583,
															-0.955
														],
														[
															0.667,
															-2.716
														],
														[
															0.462,
															-0.576
														],
														[
															0.896,
															-0.211
														],
														[
															0.815,
															-0.497
														],
														[
															0.613,
															-0.74
														],
														[
															1.562,
															-1.163
														],
														[
															1.543,
															-1.134
														],
														[
															1.311,
															-1.35
														],
														[
															1.137,
															-1.545
														],
														[
															4.339,
															-5.602
														],
														[
															3.87,
															-6.798
														],
														[
															0.055,
															-0.183
														],
														[
															0.46,
															-0.392
														],
														[
															1.086,
															-2.589
														],
														[
															0.807,
															-2.784
														],
														[
															0.057,
															-0.188
														],
														[
															0.463,
															-0.388
														],
														[
															0.793,
															-2.234
														],
														[
															0.673,
															-2.457
														],
														[
															0.236,
															-0.889
														],
														[
															0.372,
															-0.796
														],
														[
															3.803,
															-12.785
														],
														[
															2.972,
															-13.762
														],
														[
															5.778,
															-35.481
														],
														[
															1.5,
															-39.788
														],
														[
															-1.69,
															-23.334
														],
														[
															-3.106,
															-21.848
														],
														[
															-2.828,
															-11.735
														],
														[
															-4.166,
															-12.74
														],
														[
															-5.587,
															-12.486
														],
														[
															-7.467,
															-9.675
														],
														[
															-3.526,
															-1.409
														],
														[
															-5.388,
															-0.503
														],
														[
															-0.334,
															0.048
														],
														[
															-0.164,
															0.237
														]
													],
													"v": [
														[
															351,
															16
														],
														[
															339.199,
															20.131
														],
														[
															329.529,
															26.969
														],
														[
															321.595,
															35.322
														],
														[
															315,
															44
														],
														[
															312.711,
															47.335
														],
														[
															310.707,
															50.523
														],
														[
															308.849,
															53.7
														],
														[
															307,
															57
														],
														[
															304.38,
															61.566
														],
														[
															301.705,
															66.13
														],
														[
															299.177,
															70.628
														],
														[
															297,
															75
														],
														[
															295.819,
															78.117
														],
														[
															294.811,
															81.44
														],
														[
															293.899,
															84.543
														],
														[
															293,
															87
														],
														[
															292.448,
															88.301
														],
														[
															291.941,
															89.627
														],
														[
															291.464,
															90.89
														],
														[
															291,
															92
														],
														[
															289.106,
															96.423
														],
														[
															287.451,
															100.805
														],
														[
															286,
															105
														],
														[
															284.463,
															110.452
														],
														[
															283,
															116
														],
														[
															280.976,
															121.036
														],
														[
															279,
															126
														],
														[
															278.459,
															129.093
														],
														[
															278,
															132
														],
														[
															274.379,
															145.847
														],
														[
															271,
															160
														],
														[
															259.325,
															230.377
														],
														[
															253,
															307
														],
														[
															254.592,
															446.895
														],
														[
															273,
															573
														],
														[
															277.246,
															589.849
														],
														[
															282,
															606
														],
														[
															285.408,
															616.577
														],
														[
															289,
															627
														],
														[
															290.46,
															632.53
														],
														[
															292,
															638
														],
														[
															294.429,
															642.477
														],
														[
															297,
															647
														],
														[
															297.457,
															649.392
														],
														[
															298,
															652
														],
														[
															302.918,
															661.541
														],
														[
															308,
															670
														],
														[
															310.611,
															674.677
														],
														[
															313,
															679
														],
														[
															314.505,
															681.081
														],
														[
															316,
															683
														],
														[
															334.229,
															701.954
														],
														[
															360,
															710
														],
														[
															368.533,
															709.804
														],
														[
															374,
															709
														],
														[
															376.876,
															702.921
														],
														[
															380,
															695
														],
														[
															382.13,
															694.005
														],
														[
															385,
															693
														],
														[
															387.062,
															691.036
														],
														[
															389,
															689
														],
														[
															393.724,
															685.603
														],
														[
															398,
															682
														],
														[
															401.628,
															677.591
														],
														[
															405,
															673
														],
														[
															417.62,
															654.204
														],
														[
															427,
															633
														],
														[
															427.963,
															632.049
														],
														[
															429,
															631
														],
														[
															431.799,
															622.763
														],
														[
															434,
															615
														],
														[
															434.973,
															614.053
														],
														[
															436,
															613
														],
														[
															438.209,
															605.778
														],
														[
															440,
															599
														],
														[
															440.97,
															596.528
														],
														[
															442,
															594
														],
														[
															452.123,
															554.035
														],
														[
															460,
															512
														],
														[
															470.917,
															397.663
														],
														[
															469,
															279
														],
														[
															461.897,
															211.204
														],
														[
															450,
															148
														],
														[
															439.509,
															110.927
														],
														[
															425,
															73
														],
														[
															405.467,
															38.995
														],
														[
															380,
															18
														],
														[
															365.546,
															15.129
														],
														[
															352,
															15
														],
														[
															351.257,
															15.535
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 83,
											"s": [
												{
													"i": [
														[
															2.786,
															-0.421
														],
														[
															0.167,
															0.002
														],
														[
															0.168,
															0.012
														],
														[
															0.167,
															0.004
														],
														[
															0.163,
															-0.023
														],
														[
															2.074,
															-0.745
														],
														[
															2.004,
															-0.992
														],
														[
															1.678,
															-1.001
														],
														[
															1.097,
															-0.773
														],
														[
															1.067,
															-0.733
														],
														[
															1.027,
															-0.736
														],
														[
															0.946,
															-0.76
														],
														[
															0.825,
															-0.805
														],
														[
															0.53,
															-0.686
														],
														[
															0.464,
															-0.695
														],
														[
															0.452,
															-0.661
														],
														[
															0.494,
															-0.586
														],
														[
															0.61,
															-0.582
														],
														[
															0.632,
															-0.572
														],
														[
															0.582,
															-0.579
														],
														[
															0.457,
															-0.603
														],
														[
															0.164,
															-0.339
														],
														[
															0.156,
															-0.373
														],
														[
															0.165,
															-0.347
														],
														[
															0.188,
															-0.262
														],
														[
															0.995,
															-1.462
														],
														[
															0.968,
															-1.493
														],
														[
															0.864,
															-1.409
														],
														[
															0.684,
															-1.212
														],
														[
															0.792,
															-1.569
														],
														[
															0.716,
															-1.505
														],
														[
															0.734,
															-1.516
														],
														[
															5.24,
															-15.742
														],
														[
															3.468,
															-15.46
														],
														[
															1.151,
															-5.73
														],
														[
															1,
															-5.865
														],
														[
															1.153,
															-44.706
														],
														[
															-4.999,
															-40.74
														],
														[
															-5.523,
															-25.024
														],
														[
															-7.891,
															-20.327
														],
														[
															-3.599,
															-7.923
														],
														[
															-4.361,
															-6.955
														],
														[
															-1.817,
															-2.438
														],
														[
															-1.24,
															-1.869
														],
														[
															-0.788,
															-0.879
														],
														[
															-0.944,
															-1.121
														],
														[
															-0.505,
															-0.713
														],
														[
															-0.493,
															-0.571
														],
														[
															-2.504,
															-2.087
														],
														[
															-2.634,
															-1.933
														],
														[
															-1.347,
															-1.098
														],
														[
															-1.358,
															-0.69
														],
														[
															-3.328,
															-0.823
														],
														[
															-4.428,
															-0.562
														],
														[
															-4.719,
															-0.144
														],
														[
															-1.51,
															0.909
														],
														[
															-0.637,
															2.758
														],
														[
															-1.866,
															2.014
														],
														[
															-1.243,
															0.604
														],
														[
															-0.955,
															0.505
														],
														[
															-1.014,
															0.468
														],
														[
															-0.897,
															0.573
														],
														[
															-1.941,
															1.412
														],
														[
															-1.076,
															0.973
														],
														[
															-11.187,
															25.362
														],
														[
															-6.84,
															29.705
														],
														[
															-3.022,
															23.759
														],
														[
															-0.756,
															25.57
														],
														[
															2.253,
															33.224
														],
														[
															6.019,
															30.214
														],
														[
															2.623,
															9.957
														],
														[
															2.523,
															8.199
														],
														[
															1.138,
															3.746
														],
														[
															1.125,
															3.72
														],
														[
															0.462,
															0.39
														],
														[
															0.097,
															0.255
														],
														[
															0.427,
															1.68
														],
														[
															0.675,
															1.662
														],
														[
															1.576,
															2.993
														],
														[
															1.326,
															2.656
														],
														[
															0.591,
															1.707
														],
														[
															0.804,
															1.502
														],
														[
															0.578,
															0.449
														],
														[
															0.36,
															0.592
														],
														[
															0.258,
															0.853
														],
														[
															0.435,
															0.709
														],
														[
															1.332,
															1.973
														],
														[
															1.289,
															1.856
														],
														[
															6.918,
															6.362
														],
														[
															7.659,
															2.834
														],
														[
															6.519,
															0.13
														]
													],
													"o": [
														[
															-0.163,
															0.025
														],
														[
															-0.167,
															-0.002
														],
														[
															-0.168,
															-0.012
														],
														[
															-0.167,
															-0.004
														],
														[
															-1.889,
															0.26
														],
														[
															-2.074,
															0.745
														],
														[
															-2.004,
															0.992
														],
														[
															-1.678,
															1.001
														],
														[
															-1.068,
															0.752
														],
														[
															-1.067,
															0.733
														],
														[
															-1.027,
															0.736
														],
														[
															-0.946,
															0.76
														],
														[
															-0.65,
															0.635
														],
														[
															-0.53,
															0.686
														],
														[
															-0.464,
															0.695
														],
														[
															-0.452,
															0.661
														],
														[
															-0.514,
															0.61
														],
														[
															-0.61,
															0.582
														],
														[
															-0.632,
															0.572
														],
														[
															-0.582,
															0.579
														],
														[
															-0.186,
															0.245
														],
														[
															-0.164,
															0.339
														],
														[
															-0.156,
															0.373
														],
														[
															-0.165,
															0.347
														],
														[
															-0.945,
															1.317
														],
														[
															-0.995,
															1.462
														],
														[
															-0.968,
															1.493
														],
														[
															-0.864,
															1.409
														],
														[
															-0.964,
															1.708
														],
														[
															-0.792,
															1.569
														],
														[
															-0.716,
															1.505
														],
														[
															-6.571,
															13.572
														],
														[
															-5.24,
															15.742
														],
														[
															-1.394,
															6.216
														],
														[
															-1.151,
															5.73
														],
														[
															-6.386,
															37.438
														],
														[
															-1.153,
															44.705
														],
														[
															3.016,
															24.579
														],
														[
															5.523,
															25.024
														],
														[
															3.243,
															8.352
														],
														[
															3.599,
															7.923
														],
														[
															1.493,
															2.381
														],
														[
															1.817,
															2.438
														],
														[
															0.905,
															1.365
														],
														[
															0.788,
															0.879
														],
														[
															0.486,
															0.577
														],
														[
															0.505,
															0.713
														],
														[
															2.351,
															2.721
														],
														[
															2.504,
															2.087
														],
														[
															1.252,
															0.919
														],
														[
															1.347,
															1.098
														],
														[
															2.259,
															1.148
														],
														[
															3.328,
															0.823
														],
														[
															2.616,
															0.332
														],
														[
															4.719,
															0.144
														],
														[
															1.585,
															-0.954
														],
														[
															0.637,
															-2.758
														],
														[
															0.075,
															-0.081
														],
														[
															1.243,
															-0.604
														],
														[
															1.048,
															-0.554
														],
														[
															1.014,
															-0.468
														],
														[
															2.159,
															-1.381
														],
														[
															1.941,
															-1.412
														],
														[
															16.413,
															-14.846
														],
														[
															11.187,
															-25.362
														],
														[
															5.156,
															-22.393
														],
														[
															3.022,
															-23.759
														],
														[
															1.033,
															-34.887
														],
														[
															-2.253,
															-33.224
														],
														[
															-1.987,
															-9.974
														],
														[
															-2.623,
															-9.957
														],
														[
															-1.322,
															-4.298
														],
														[
															-1.138,
															-3.746
														],
														[
															-0.056,
															-0.186
														],
														[
															-0.462,
															-0.39
														],
														[
															-0.616,
															-1.62
														],
														[
															-0.427,
															-1.68
														],
														[
															-1.37,
															-3.373
														],
														[
															-1.576,
															-2.993
														],
														[
															-0.833,
															-1.669
														],
														[
															-0.591,
															-1.707
														],
														[
															-0.327,
															-0.611
														],
														[
															-0.578,
															-0.449
														],
														[
															-0.533,
															-0.879
														],
														[
															-0.258,
															-0.853
														],
														[
															-1.383,
															-2.254
														],
														[
															-1.332,
															-1.972
														],
														[
															-4.67,
															-6.72
														],
														[
															-6.918,
															-6.362
														],
														[
															-5.139,
															-1.901
														],
														[
															-6.519,
															-0.13
														]
													],
													"v": [
														[
															350,
															16
														],
														[
															349.504,
															16.029
														],
														[
															349.001,
															16.003
														],
														[
															348.497,
															15.976
														],
														[
															348,
															16
														],
														[
															341.993,
															17.566
														],
														[
															335.813,
															20.231
														],
														[
															330.226,
															23.28
														],
														[
															326,
															26
														],
														[
															322.786,
															28.223
														],
														[
															319.635,
															30.42
														],
														[
															316.667,
															32.658
														],
														[
															314,
															35
														],
														[
															312.242,
															36.992
														],
														[
															310.764,
															39.074
														],
														[
															309.404,
															41.118
														],
														[
															308,
															43
														],
														[
															306.297,
															44.784
														],
														[
															304.416,
															46.511
														],
														[
															302.577,
															48.232
														],
														[
															301,
															50
														],
														[
															300.479,
															50.892
														],
														[
															300.003,
															51.975
														],
														[
															299.525,
															53.071
														],
														[
															299,
															54
														],
														[
															296.071,
															58.198
														],
														[
															293.108,
															62.659
														],
														[
															290.341,
															67.04
														],
														[
															288,
															71
														],
														[
															285.389,
															75.896
														],
														[
															283.151,
															80.488
														],
														[
															281,
															85
														],
														[
															263.173,
															129.584
														],
														[
															250,
															177
														],
														[
															246.204,
															194.764
														],
														[
															243,
															212
														],
														[
															231.461,
															338.024
														],
														[
															237,
															469
														],
														[
															249.844,
															544.69
														],
														[
															270,
															614
														],
														[
															280.162,
															638.548
														],
														[
															292,
															661
														],
														[
															297.19,
															668.384
														],
														[
															302,
															675
														],
														[
															304.471,
															678.183
														],
														[
															307,
															681
														],
														[
															308.495,
															683.005
														],
														[
															310,
															685
														],
														[
															317.288,
															692.091
														],
														[
															325,
															698
														],
														[
															328.921,
															701.172
														],
														[
															333,
															704
														],
														[
															341.373,
															706.939
														],
														[
															353,
															709
														],
														[
															365.33,
															709.93
														],
														[
															376,
															709
														],
														[
															378.789,
															702.795
														],
														[
															382,
															695
														],
														[
															384.34,
															693.818
														],
														[
															388,
															692
														],
														[
															391.114,
															690.515
														],
														[
															394,
															689
														],
														[
															400.313,
															684.694
														],
														[
															405,
															681
														],
														[
															446.18,
															619.144
														],
														[
															473,
															535
														],
														[
															485.3,
															465.883
														],
														[
															491,
															392
														],
														[
															489.288,
															289.495
														],
														[
															477,
															194
														],
														[
															469.902,
															163.669
														],
														[
															462,
															136
														],
														[
															458.352,
															124.067
														],
														[
															455,
															113
														],
														[
															454.031,
															112.052
														],
														[
															453,
															111
														],
														[
															451.544,
															106.032
														],
														[
															450,
															101
														],
														[
															445.467,
															91.463
														],
														[
															441,
															83
														],
														[
															438.978,
															77.875
														],
														[
															437,
															73
														],
														[
															435.524,
															71.486
														],
														[
															434,
															70
														],
														[
															432.927,
															67.373
														],
														[
															432,
															65
														],
														[
															427.93,
															58.701
														],
														[
															424,
															53
														],
														[
															406.241,
															32.585
														],
														[
															384,
															18
														],
														[
															365.235,
															15.259
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 84,
											"s": [
												{
													"i": [
														[
															7.491,
															-1.005
														],
														[
															3.864,
															-1.392
														],
														[
															3.237,
															-1.718
														],
														[
															1.21,
															-0.439
														],
														[
															0.938,
															-0.595
														],
														[
															0.14,
															-0.424
														],
														[
															0.226,
															-0.169
														],
														[
															0.553,
															-0.107
														],
														[
															0.373,
															-0.259
														],
														[
															4.748,
															-4.683
														],
														[
															2.572,
															-4.18
														],
														[
															1.136,
															-1.409
														],
														[
															0.589,
															-0.957
														],
														[
															0.37,
															-0.292
														],
														[
															0.236,
															-0.369
														],
														[
															0.285,
															-0.918
														],
														[
															0.419,
															-0.637
														],
														[
															0.42,
															-0.136
														],
														[
															0.174,
															-0.233
														],
														[
															0.12,
															-0.563
														],
														[
															0.226,
															-0.355
														],
														[
															2.76,
															-5.252
														],
														[
															2.627,
															-5.763
														],
														[
															0.468,
															-1.134
														],
														[
															0.456,
															-0.989
														],
														[
															0.147,
															-0.515
														],
														[
															0.265,
															-0.618
														],
														[
															0.942,
															-1.504
														],
														[
															0.603,
															-1.519
														],
														[
															0.439,
															-1.918
														],
														[
															0.594,
															-1.686
														],
														[
															2.091,
															-6.263
														],
														[
															1.514,
															-5.926
														],
														[
															0.657,
															-2.848
														],
														[
															0.69,
															-2.938
														],
														[
															2.143,
															-11.69
														],
														[
															1.685,
															-12.558
														],
														[
															0.939,
															-18
														],
														[
															0,
															-18.284
														],
														[
															-5.083,
															-34.08
														],
														[
															-8.669,
															-28.676
														],
														[
															-0.687,
															-2.213
														],
														[
															-0.603,
															-1.994
														],
														[
															-0.462,
															-0.389
														],
														[
															-0.094,
															-0.257
														],
														[
															-1.084,
															-3.544
														],
														[
															-1.407,
															-3.377
														],
														[
															-3.201,
															-6.159
														],
														[
															-3.558,
															-6.032
														],
														[
															-2.861,
															-4.205
														],
														[
															-2.902,
															-3.68
														],
														[
															-3.445,
															-3.423
														],
														[
															-3.93,
															-3.137
														],
														[
															-8.271,
															-3.405
														],
														[
															-12.089,
															0.067
														],
														[
															-2.631,
															0.132
														],
														[
															-0.991,
															0.459
														],
														[
															-0.377,
															0.941
														],
														[
															-1.101,
															2.125
														],
														[
															-0.623,
															1.251
														],
														[
															-1.613,
															1.271
														],
														[
															-1.338,
															0.264
														],
														[
															-1.079,
															0.498
														],
														[
															-1.042,
															0.519
														],
														[
															-0.861,
															0.477
														],
														[
															-0.793,
															0.721
														],
														[
															-0.957,
															0.634
														],
														[
															-1.495,
															1.135
														],
														[
															-0.437,
															0.406
														],
														[
															-0.81,
															0.686
														],
														[
															-3.963,
															4.192
														],
														[
															-3.272,
															4.886
														],
														[
															-0.751,
															1.123
														],
														[
															-0.877,
															1.337
														],
														[
															-0.982,
															1.544
														],
														[
															-0.633,
															0.99
														],
														[
															-0.664,
															1.123
														],
														[
															-6.125,
															15.692
														],
														[
															-3.79,
															12.86
														],
														[
															0,
															59.345
														],
														[
															0.092,
															8.913
														],
														[
															1.681,
															19.902
														],
														[
															9.796,
															35.256
														],
														[
															1.567,
															4.929
														],
														[
															2.271,
															7.511
														],
														[
															0.205,
															0.502
														],
														[
															1.337,
															3.07
														],
														[
															5.919,
															9.933
														],
														[
															6.346,
															7.484
														],
														[
															11.605,
															5.94
														],
														[
															4.534,
															1.239
														]
													],
													"o": [
														[
															-5.308,
															0.712
														],
														[
															-3.864,
															1.392
														],
														[
															-1.224,
															0.649
														],
														[
															-1.21,
															0.439
														],
														[
															-0.216,
															0.136
														],
														[
															-0.14,
															0.424
														],
														[
															-0.414,
															0.31
														],
														[
															-0.553,
															0.108
														],
														[
															-4.434,
															3.09
														],
														[
															-4.749,
															4.682
														],
														[
															-0.865,
															1.406
														],
														[
															-1.136,
															1.409
														],
														[
															-0.286,
															0.465
														],
														[
															-0.37,
															0.292
														],
														[
															-0.44,
															0.69
														],
														[
															-0.285,
															0.918
														],
														[
															-0.145,
															0.221
														],
														[
															-0.42,
															0.137
														],
														[
															-0.294,
															0.392
														],
														[
															-0.12,
															0.563
														],
														[
															-3.332,
															5.228
														],
														[
															-2.76,
															5.252
														],
														[
															-0.672,
															1.473
														],
														[
															-0.468,
															1.134
														],
														[
															-0.149,
															0.322
														],
														[
															-0.147,
															0.515
														],
														[
															-0.627,
															1.463
														],
														[
															-0.942,
															1.504
														],
														[
															-0.651,
															1.641
														],
														[
															-0.439,
															1.918
														],
														[
															-2.123,
															6.023
														],
														[
															-2.091,
															6.263
														],
														[
															-0.683,
															2.669
														],
														[
															-0.657,
															2.848
														],
														[
															-2.743,
															11.681
														],
														[
															-2.143,
															11.69
														],
														[
															-2.243,
															16.715
														],
														[
															-0.939,
															18
														],
														[
															0,
															38.006
														],
														[
															5.083,
															34.08
														],
														[
															0.65,
															2.152
														],
														[
															0.687,
															2.213
														],
														[
															0.056,
															0.187
														],
														[
															0.462,
															0.389
														],
														[
															1.255,
															3.446
														],
														[
															1.084,
															3.544
														],
														[
															2.638,
															6.332
														],
														[
															3.201,
															6.159
														],
														[
															2.653,
															4.498
														],
														[
															2.861,
															4.205
														],
														[
															3.289,
															4.171
														],
														[
															3.445,
															3.423
														],
														[
															6.826,
															5.447
														],
														[
															8.271,
															3.405
														],
														[
															2.486,
															-0.014
														],
														[
															2.631,
															-0.132
														],
														[
															2.392,
															-1.11
														],
														[
															0.377,
															-0.942
														],
														[
															0.894,
															-1.725
														],
														[
															0.623,
															-1.251
														],
														[
															0.567,
															-0.447
														],
														[
															1.339,
															-0.264
														],
														[
															0.97,
															-0.447
														],
														[
															1.042,
															-0.519
														],
														[
															0.871,
															-0.483
														],
														[
															0.793,
															-0.721
														],
														[
															1.905,
															-1.261
														],
														[
															0.451,
															-0.342
														],
														[
															0.752,
															-0.7
														],
														[
															3.782,
															-3.204
														],
														[
															4.808,
															-5.086
														],
														[
															0.71,
															-1.06
														],
														[
															0.751,
															-1.123
														],
														[
															0.842,
															-1.284
														],
														[
															0.684,
															-1.076
														],
														[
															0.798,
															-1.247
														],
														[
															7.853,
															-13.281
														],
														[
															4.7,
															-12.041
														],
														[
															15.71,
															-53.312
														],
														[
															0,
															-11.62
														],
														[
															-0.225,
															-21.873
														],
														[
															-3.612,
															-42.771
														],
														[
															-1.334,
															-4.801
														],
														[
															-2.534,
															-7.971
														],
														[
															-0.111,
															-0.368
														],
														[
															-1.232,
															-3.02
														],
														[
															-5.16,
															-11.847
														],
														[
															-5.681,
															-9.532
														],
														[
															-9.195,
															-10.845
														],
														[
															-3.918,
															-2.005
														],
														[
															-9.357,
															-2.556
														]
													],
													"v": [
														[
															349,
															16
														],
														[
															335.446,
															19.246
														],
														[
															325,
															24
														],
														[
															321.285,
															25.541
														],
														[
															318,
															27
														],
														[
															317.508,
															27.975
														],
														[
															317,
															29
														],
														[
															315.469,
															29.538
														],
														[
															314,
															30
														],
														[
															299.604,
															42.183
														],
														[
															288,
															56
														],
														[
															284.793,
															60.337
														],
														[
															282,
															64
														],
														[
															280.962,
															65.072
														],
														[
															280,
															66
														],
														[
															278.984,
															68.54
														],
														[
															278,
															71
														],
														[
															277.022,
															71.492
														],
														[
															276,
															72
														],
														[
															275.449,
															73.528
														],
														[
															275,
															75
														],
														[
															265.971,
															90.599
														],
														[
															258,
															107
														],
														[
															256.338,
															110.863
														],
														[
															255,
															114
														],
														[
															254.587,
															115.278
														],
														[
															254,
															117
														],
														[
															251.482,
															121.457
														],
														[
															249,
															126
														],
														[
															247.458,
															131.466
														],
														[
															246,
															137
														],
														[
															239.544,
															155.573
														],
														[
															234,
															174
														],
														[
															232.006,
															182.299
														],
														[
															230,
															191
														],
														[
															222.707,
															225.843
														],
														[
															217,
															262
														],
														[
															212.318,
															314.323
														],
														[
															211,
															369
														],
														[
															218.998,
															477.498
														],
														[
															240,
															572
														],
														[
															242.036,
															578.618
														],
														[
															244,
															585
														],
														[
															244.972,
															585.947
														],
														[
															246,
															587
														],
														[
															249.386,
															597.552
														],
														[
															253,
															608
														],
														[
															261.811,
															626.725
														],
														[
															272,
															645
														],
														[
															280.313,
															658.114
														],
														[
															289,
															670
														],
														[
															299.019,
															681.275
														],
														[
															310,
															691
														],
														[
															332.052,
															704.636
														],
														[
															362,
															710
														],
														[
															370.121,
															709.834
														],
														[
															376,
															709
														],
														[
															379.469,
															706.261
														],
														[
															381,
															702
														],
														[
															382.96,
															697.659
														],
														[
															386,
															694
														],
														[
															389.116,
															693.039
														],
														[
															393,
															692
														],
														[
															396.081,
															690.523
														],
														[
															399,
															689
														],
														[
															401.435,
															687.113
														],
														[
															404,
															685
														],
														[
															410,
															682
														],
														[
															411,
															680
														],
														[
															414,
															679
														],
														[
															426,
															667
														],
														[
															440,
															650
														],
														[
															442,
															646
														],
														[
															445,
															643
														],
														[
															447,
															638
														],
														[
															450,
															635
														],
														[
															452,
															631
														],
														[
															472,
															588
														],
														[
															485,
															551
														],
														[
															511,
															377
														],
														[
															511,
															344
														],
														[
															508,
															284
														],
														[
															486,
															163
														],
														[
															482,
															148
														],
														[
															473,
															123
														],
														[
															471,
															121
														],
														[
															468,
															112
														],
														[
															451,
															79
														],
														[
															432,
															52
														],
														[
															398,
															23
														],
														[
															384,
															17
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 85,
											"s": [
												{
													"i": [
														[
															11.566,
															-1.332
														],
														[
															3.33,
															-0.608
														],
														[
															3.16,
															-1.161
														],
														[
															1.165,
															-0.755
														],
														[
															1.116,
															-0.53
														],
														[
															1.388,
															-0.435
														],
														[
															1.019,
															-0.579
														],
														[
															0.425,
															-0.548
														],
														[
															0.793,
															-0.52
														],
														[
															0.916,
															-0.276
														],
														[
															0.731,
															-0.5
														],
														[
															0.133,
															-0.416
														],
														[
															0.24,
															-0.18
														],
														[
															0.549,
															-0.101
														],
														[
															0.38,
															-0.276
														],
														[
															0.128,
															-0.41
														],
														[
															0.25,
															-0.188
														],
														[
															0.543,
															-0.091
														],
														[
															0.39,
															-0.306
														],
														[
															2.29,
															-2.399
														],
														[
															2.389,
															-2.48
														],
														[
															1.185,
															-1.127
														],
														[
															1.102,
															-1.288
														],
														[
															2.936,
															-4.139
														],
														[
															2.828,
															-4.441
														],
														[
															7.592,
															-17.863
														],
														[
															4.94,
															-19.323
														],
														[
															0.657,
															-2.85
														],
														[
															0.681,
															-2.899
														],
														[
															1.744,
															-7.862
														],
														[
															1.173,
															-7.665
														],
														[
															-8.367,
															-64.042
														],
														[
															-23.688,
															-44.461
														],
														[
															-14.528,
															-15.372
														],
														[
															-19.347,
															-5.604
														],
														[
															-3.636,
															-0.758
														],
														[
															-4.065,
															-0.274
														],
														[
															-5.024,
															0.181
														],
														[
															-1.012,
															0.469
														],
														[
															-0.854,
															2.287
														],
														[
															-1.134,
															1.715
														],
														[
															-2.104,
															0.515
														],
														[
															-2.25,
															0.923
														],
														[
															-0.974,
															0.762
														],
														[
															-1.061,
															0.522
														],
														[
															-1.161,
															0.438
														],
														[
															-1.226,
															0.692
														],
														[
															-1.431,
															1.143
														],
														[
															-0.776,
															0.582
														],
														[
															-0.549,
															0.101
														],
														[
															-0.38,
															0.276
														],
														[
															-0.128,
															0.41
														],
														[
															-0.25,
															0.188
														],
														[
															-0.541,
															0.088
														],
														[
															-0.393,
															0.315
														],
														[
															-1.16,
															1.24
														],
														[
															-1.149,
															1.068
														],
														[
															-1.859,
															1.606
														],
														[
															-1.507,
															1.664
														],
														[
															-0.42,
															0.874
														],
														[
															-0.71,
															0.832
														],
														[
															-1.242,
															1.128
														],
														[
															-0.937,
															1.204
														],
														[
															-0.957,
															1.51
														],
														[
															-1.042,
															1.507
														],
														[
															-0.526,
															0.677
														],
														[
															-0.472,
															0.678
														],
														[
															-0.752,
															1.478
														],
														[
															-0.866,
															1.471
														],
														[
															-0.407,
															0.346
														],
														[
															-0.201,
															0.322
														],
														[
															-0.095,
															0.493
														],
														[
															-0.318,
															0.544
														],
														[
															-10.115,
															52.862
														],
														[
															3.839,
															56.286
														],
														[
															0.326,
															4.495
														],
														[
															0.389,
															4.509
														],
														[
															2.091,
															12.52
														],
														[
															2.528,
															11.076
														],
														[
															0.758,
															4.042
														],
														[
															1.055,
															3.832
														],
														[
															0.978,
															3.304
														],
														[
															1.293,
															3.955
														],
														[
															10.174,
															19.438
														],
														[
															3.666,
															5.872
														],
														[
															0.656,
															1.029
														],
														[
															0.825,
															1.224
														],
														[
															2.199,
															2.909
														],
														[
															0.24,
															0.362
														],
														[
															3.928,
															4.211
														],
														[
															20.529,
															6.565
														]
													],
													"o": [
														[
															-3.52,
															0.405
														],
														[
															-3.33,
															0.608
														],
														[
															-1.225,
															0.45
														],
														[
															-1.165,
															0.755
														],
														[
															-1.43,
															0.68
														],
														[
															-1.388,
															0.435
														],
														[
															-0.507,
															0.288
														],
														[
															-0.425,
															0.548
														],
														[
															-0.605,
															0.396
														],
														[
															-0.916,
															0.276
														],
														[
															-0.227,
															0.156
														],
														[
															-0.133,
															0.416
														],
														[
															-0.423,
															0.318
														],
														[
															-0.549,
															0.101
														],
														[
															-0.236,
															0.172
														],
														[
															-0.128,
															0.41
														],
														[
															-0.44,
															0.329
														],
														[
															-0.543,
															0.091
														],
														[
															-2.452,
															1.925
														],
														[
															-2.29,
															2.399
														],
														[
															-1.159,
															1.204
														],
														[
															-1.185,
															1.127
														],
														[
															-3.427,
															4.004
														],
														[
															-2.936,
															4.139
														],
														[
															-9.694,
															15.223
														],
														[
															-7.592,
															17.863
														],
														[
															-0.69,
															2.7
														],
														[
															-0.657,
															2.85
														],
														[
															-1.851,
															7.885
														],
														[
															-1.744,
															7.862
														],
														[
															-10.154,
															66.37
														],
														[
															8.367,
															64.042
														],
														[
															9.541,
															17.909
														],
														[
															14.528,
															15.372
														],
														[
															2.389,
															0.692
														],
														[
															3.636,
															0.759
														],
														[
															2.892,
															0.195
														],
														[
															5.024,
															-0.181
														],
														[
															2.45,
															-1.136
														],
														[
															0.854,
															-2.287
														],
														[
															1.333,
															-2.017
														],
														[
															2.104,
															-0.515
														],
														[
															1.045,
															-0.428
														],
														[
															0.974,
															-0.763
														],
														[
															1.13,
															-0.555
														],
														[
															1.161,
															-0.438
														],
														[
															1.499,
															-0.846
														],
														[
															1.431,
															-1.143
														],
														[
															0.423,
															-0.318
														],
														[
															0.549,
															-0.101
														],
														[
															0.236,
															-0.172
														],
														[
															0.128,
															-0.41
														],
														[
															0.444,
															-0.333
														],
														[
															0.541,
															-0.088
														],
														[
															1.209,
															-0.971
														],
														[
															1.16,
															-1.24
														],
														[
															2.057,
															-1.91
														],
														[
															1.859,
															-1.606
														],
														[
															0.608,
															-0.671
														],
														[
															0.421,
															-0.874
														],
														[
															1.096,
															-1.284
														],
														[
															1.242,
															-1.128
														],
														[
															1.13,
															-1.454
														],
														[
															0.957,
															-1.51
														],
														[
															0.424,
															-0.613
														],
														[
															0.526,
															-0.677
														],
														[
															1.125,
															-1.615
														],
														[
															0.752,
															-1.478
														],
														[
															0.172,
															-0.292
														],
														[
															0.407,
															-0.346
														],
														[
															0.302,
															-0.486
														],
														[
															0.095,
															-0.492
														],
														[
															22.377,
															-38.267
														],
														[
															10.115,
															-52.862
														],
														[
															-0.308,
															-4.51
														],
														[
															-0.326,
															-4.495
														],
														[
															-1.11,
															-12.845
														],
														[
															-2.091,
															-12.52
														],
														[
															-0.913,
															-4.001
														],
														[
															-0.758,
															-4.042
														],
														[
															-0.942,
															-3.421
														],
														[
															-1.245,
															-4.205
														],
														[
															-7.096,
															-21.712
														],
														[
															-3.247,
															-6.203
														],
														[
															-1.125,
															-1.801
														],
														[
															-0.797,
															-1.25
														],
														[
															-2.04,
															-3.024
														],
														[
															-0.371,
															-0.49
														],
														[
															-3.407,
															-5.137
														],
														[
															-13.8,
															-14.794
														],
														[
															-13.856,
															-4.431
														]
													],
													"v": [
														[
															348,
															16
														],
														[
															337.73,
															17.433
														],
														[
															328,
															20
														],
														[
															324.419,
															21.94
														],
														[
															321,
															24
														],
														[
															316.691,
															25.576
														],
														[
															313,
															27
														],
														[
															311.714,
															28.326
														],
														[
															310,
															30
														],
														[
															307.594,
															30.922
														],
														[
															305,
															32
														],
														[
															304.509,
															32.982
														],
														[
															304,
															34
														],
														[
															302.467,
															34.531
														],
														[
															301,
															35
														],
														[
															300.511,
															35.988
														],
														[
															300,
															37
														],
														[
															298.463,
															37.517
														],
														[
															297,
															38
														],
														[
															289.953,
															44.584
														],
														[
															283,
															52
														],
														[
															279.457,
															55.437
														],
														[
															276,
															59
														],
														[
															266.551,
															71.172
														],
														[
															258,
															84
														],
														[
															231.935,
															133.925
														],
														[
															213,
															190
														],
														[
															210.993,
															198.351
														],
														[
															209,
															207
														],
														[
															203.491,
															230.665
														],
														[
															199,
															254
														],
														[
															197.119,
															453.932
														],
														[
															246,
															621
														],
														[
															282.145,
															672.728
														],
														[
															333,
															706
														],
														[
															342.243,
															708.313
														],
														[
															354,
															710
														],
														[
															367.41,
															709.998
														],
														[
															378,
															709
														],
														[
															382.487,
															703.434
														],
														[
															385,
															697
														],
														[
															390.313,
															693.679
														],
														[
															397,
															692
														],
														[
															399.988,
															690.07
														],
														[
															403,
															688
														],
														[
															406.428,
															686.602
														],
														[
															410,
															685
														],
														[
															414.542,
															681.803
														],
														[
															418,
															679
														],
														[
															419.533,
															678.469
														],
														[
															421,
															678
														],
														[
															421.489,
															677.012
														],
														[
															422,
															676
														],
														[
															423.539,
															675.486
														],
														[
															425,
															675
														],
														[
															428.545,
															671.573
														],
														[
															432,
															668
														],
														[
															437.912,
															662.815
														],
														[
															443,
															658
														],
														[
															444.423,
															655.62
														],
														[
															446,
															653
														],
														[
															449.62,
															649.439
														],
														[
															453,
															646
														],
														[
															456.066,
															641.54
														],
														[
															459,
															637
														],
														[
															460.464,
															635.048
														],
														[
															462,
															633
														],
														[
															464.694,
															628.393
														],
														[
															467,
															624
														],
														[
															467.979,
															623.023
														],
														[
															469,
															622
														],
														[
															469.488,
															620.544
														],
														[
															470,
															619
														],
														[
															519.161,
															479.514
														],
														[
															529,
															313
														],
														[
															528.062,
															299.499
														],
														[
															527,
															286
														],
														[
															522.063,
															247.673
														],
														[
															515,
															212
														],
														[
															512.607,
															199.874
														],
														[
															510,
															188
														],
														[
															506,
															178
														],
														[
															503,
															166
														],
														[
															478,
															105
														],
														[
															467,
															87
														],
														[
															464,
															83
														],
														[
															462,
															78
														],
														[
															455,
															70
														],
														[
															454,
															68
														],
														[
															443,
															54
														],
														[
															391,
															19
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 86,
											"s": [
												{
													"i": [
														[
															-0.034,
															0.004
														],
														[
															3.174,
															-0.594
														],
														[
															3.06,
															-0.794
														],
														[
															2.732,
															-0.928
														],
														[
															2.187,
															-0.996
														],
														[
															3.086,
															-1.841
														],
														[
															3.015,
															-2.152
														],
														[
															2.922,
															-2.36
														],
														[
															2.805,
															-2.464
														],
														[
															2.553,
															-2.618
														],
														[
															2.426,
															-2.808
														],
														[
															2.285,
															-2.911
														],
														[
															2.129,
															-2.927
														],
														[
															3.928,
															-6.522
														],
														[
															3.491,
															-6.91
														],
														[
															3.067,
															-7.183
														],
														[
															2.656,
															-7.341
														],
														[
															5.561,
															-29.145
														],
														[
															1.373,
															-31.774
														],
														[
															-3.793,
															-32.12
														],
														[
															-6.338,
															-24.681
														],
														[
															-9.392,
															-21.692
														],
														[
															-0.87,
															-1.651
														],
														[
															-0.769,
															-1.662
														],
														[
															-0.565,
															-1.85
														],
														[
															-0.885,
															-1.753
														],
														[
															-0.444,
															-0.161
														],
														[
															-0.138,
															-0.185
														],
														[
															-0.138,
															-0.58
														],
														[
															-0.178,
															-0.321
														],
														[
															-0.648,
															-1.376
														],
														[
															-0.597,
															-1.032
														],
														[
															-1.179,
															-2.03
														],
														[
															-1.077,
															-1.792
														],
														[
															-1.669,
															-2.238
														],
														[
															-1.707,
															-2.356
														],
														[
															-0.97,
															-1.543
														],
														[
															-1.089,
															-1.404
														],
														[
															-3.853,
															-3.879
														],
														[
															-3.992,
															-3.846
														],
														[
															-0.449,
															-0.718
														],
														[
															-0.567,
															-0.514
														],
														[
															-0.908,
															-0.457
														],
														[
															-0.761,
															-0.621
														],
														[
															-0.62,
															-0.703
														],
														[
															-0.799,
															-0.601
														],
														[
															-11.132,
															-4.366
														],
														[
															-14.086,
															-0.487
														],
														[
															-4.691,
															0.138
														],
														[
															-1.329,
															0.547
														],
														[
															-0.99,
															2.279
														],
														[
															-1.476,
															1.83
														],
														[
															-1.719,
															0.491
														],
														[
															-1.972,
															0.607
														],
														[
															-1.884,
															0.933
														],
														[
															-1.505,
															0.664
														],
														[
															-1.061,
															0.291
														],
														[
															-0.805,
															0.416
														],
														[
															-0.159,
															0.442
														],
														[
															-0.188,
															0.141
														],
														[
															-0.572,
															0.13
														],
														[
															-0.337,
															0.199
														],
														[
															-2.828,
															1.897
														],
														[
															-1.874,
															1.744
														],
														[
															-0.552,
															0.076
														],
														[
															-0.414,
															0.343
														],
														[
															-0.648,
															0.703
														],
														[
															-0.719,
															0.617
														],
														[
															-5.076,
															5.44
														],
														[
															-4.135,
															5.467
														],
														[
															-1.417,
															1.936
														],
														[
															-0.924,
															1.394
														],
														[
															-0.471,
															0.805
														],
														[
															-0.455,
															0.786
														],
														[
															-0.488,
															0.811
														],
														[
															-0.464,
															0.747
														],
														[
															-0.504,
															0.855
														],
														[
															-0.424,
															0.683
														],
														[
															-3.604,
															7.289
														],
														[
															-3.51,
															8.291
														],
														[
															-6.651,
															34.839
														],
														[
															0,
															41.366
														],
														[
															6.754,
															35.513
														],
														[
															11.985,
															28.305
														],
														[
															7.503,
															13.126
														],
														[
															10.14,
															11.687
														],
														[
															12.353,
															8.78
														],
														[
															15.836,
															3.639
														],
														[
															6.903,
															0.558
														],
														[
															7.269,
															-0.639
														],
														[
															0.179,
															-0.244
														]
													],
													"o": [
														[
															-3.071,
															0.328
														],
														[
															-3.174,
															0.594
														],
														[
															-3.06,
															0.794
														],
														[
															-2.732,
															0.928
														],
														[
															-3.134,
															1.427
														],
														[
															-3.086,
															1.841
														],
														[
															-3.015,
															2.152
														],
														[
															-2.922,
															2.36
														],
														[
															-2.667,
															2.342
														],
														[
															-2.553,
															2.618
														],
														[
															-2.426,
															2.808
														],
														[
															-2.285,
															2.911
														],
														[
															-4.379,
															6.019
														],
														[
															-3.928,
															6.522
														],
														[
															-3.491,
															6.91
														],
														[
															-3.067,
															7.183
														],
														[
															-8.769,
															24.234
														],
														[
															-5.561,
															29.145
														],
														[
															-1.373,
															31.774
														],
														[
															3.257,
															27.584
														],
														[
															6.338,
															24.681
														],
														[
															0.75,
															1.734
														],
														[
															0.87,
															1.651
														],
														[
															0.855,
															1.846
														],
														[
															0.565,
															1.85
														],
														[
															0.087,
															0.172
														],
														[
															0.444,
															0.161
														],
														[
															0.269,
															0.358
														],
														[
															0.138,
															0.58
														],
														[
															0.81,
															1.463
														],
														[
															0.648,
															1.376
														],
														[
															1.209,
															2.087
														],
														[
															1.179,
															2.03
														],
														[
															1.616,
															2.69
														],
														[
															1.669,
															2.238
														],
														[
															1.031,
															1.424
														],
														[
															0.97,
															1.543
														],
														[
															3.598,
															4.639
														],
														[
															3.853,
															3.879
														],
														[
															0.636,
															0.612
														],
														[
															0.449,
															0.719
														],
														[
															0.607,
															0.551
														],
														[
															0.908,
															0.457
														],
														[
															0.721,
															0.589
														],
														[
															0.62,
															0.703
														],
														[
															9.386,
															7.05
														],
														[
															11.132,
															4.366
														],
														[
															2.905,
															0.101
														],
														[
															4.691,
															-0.138
														],
														[
															2.564,
															-1.054
														],
														[
															0.99,
															-2.279
														],
														[
															1.154,
															-1.43
														],
														[
															1.719,
															-0.491
														],
														[
															1.96,
															-0.603
														],
														[
															1.884,
															-0.933
														],
														[
															0.95,
															-0.419
														],
														[
															1.061,
															-0.291
														],
														[
															0.177,
															-0.091
														],
														[
															0.159,
															-0.442
														],
														[
															0.375,
															-0.281
														],
														[
															0.572,
															-0.13
														],
														[
															2.814,
															-1.667
														],
														[
															2.828,
															-1.897
														],
														[
															0.38,
															-0.353
														],
														[
															0.552,
															-0.076
														],
														[
															0.689,
															-0.572
														],
														[
															0.648,
															-0.703
														],
														[
															5.56,
															-4.773
														],
														[
															5.076,
															-5.44
														],
														[
															1.407,
															-1.861
														],
														[
															1.417,
															-1.936
														],
														[
															0.659,
															-0.994
														],
														[
															0.471,
															-0.805
														],
														[
															0.583,
															-1.008
														],
														[
															0.488,
															-0.811
														],
														[
															0.558,
															-0.899
														],
														[
															0.504,
															-0.855
														],
														[
															4.072,
															-6.552
														],
														[
															3.604,
															-7.289
														],
														[
															12.396,
															-29.276
														],
														[
															6.651,
															-34.839
														],
														[
															0,
															-38.642
														],
														[
															-6.754,
															-35.513
														],
														[
															-5.846,
															-13.808
														],
														[
															-7.503,
															-13.126
														],
														[
															-9.753,
															-11.24
														],
														[
															-12.353,
															-8.78
														],
														[
															-6.12,
															-1.406
														],
														[
															-6.903,
															-0.558
														],
														[
															-0.32,
															0.028
														],
														[
															-0.179,
															0.244
														]
													],
													"v": [
														[
															347,
															16
														],
														[
															337.579,
															17.4
														],
														[
															328.174,
															19.499
														],
														[
															319.432,
															22.098
														],
														[
															312,
															25
														],
														[
															302.665,
															29.928
														],
														[
															293.508,
															35.944
														],
														[
															284.597,
															42.739
														],
														[
															276,
															50
														],
														[
															268.166,
															57.462
														],
														[
															260.694,
															65.623
														],
														[
															253.624,
															74.222
														],
														[
															247,
															83
														],
														[
															234.542,
															101.84
														],
														[
															223.416,
															122.017
														],
														[
															213.582,
															143.185
														],
														[
															205,
															165
														],
														[
															183.261,
															245.639
														],
														[
															172.615,
															337.588
														],
														[
															176,
															434
														],
														[
															190.399,
															512.419
														],
														[
															214,
															582
														],
														[
															216.486,
															587.054
														],
														[
															219,
															592
														],
														[
															220.978,
															597.571
														],
														[
															223,
															603
														],
														[
															223.961,
															603.49
														],
														[
															225,
															604
														],
														[
															225.568,
															605.528
														],
														[
															226,
															607
														],
														[
															228.16,
															611.324
														],
														[
															230,
															615
														],
														[
															233.599,
															621.222
														],
														[
															237,
															627
														],
														[
															241.932,
															634.25
														],
														[
															247,
															641
														],
														[
															249.957,
															645.515
														],
														[
															253,
															650
														],
														[
															264.204,
															662.596
														],
														[
															276,
															674
														],
														[
															277.552,
															676.074
														],
														[
															279,
															678
														],
														[
															281.385,
															679.447
														],
														[
															284,
															681
														],
														[
															285.941,
															682.991
														],
														[
															288,
															685
														],
														[
															318.475,
															702.422
														],
														[
															356,
															710
														],
														[
															368.682,
															709.986
														],
														[
															379,
															709
														],
														[
															383.816,
															703.582
														],
														[
															387,
															697
														],
														[
															391.386,
															694.382
														],
														[
															397,
															693
														],
														[
															402.842,
															690.546
														],
														[
															408,
															688
														],
														[
															411.108,
															686.997
														],
														[
															414,
															686
														],
														[
															414.491,
															685.038
														],
														[
															415,
															684
														],
														[
															416.528,
															683.439
														],
														[
															418,
															683
														],
														[
															426.705,
															677.558
														],
														[
															434,
															672
														],
														[
															435.474,
															671.493
														],
														[
															437,
															671
														],
														[
															438.978,
															669.034
														],
														[
															441,
															667
														],
														[
															457.07,
															651.52
														],
														[
															471,
															635
														],
														[
															475.362,
															629.15
														],
														[
															479,
															624
														],
														[
															480.653,
															621.344
														],
														[
															482,
															619
														],
														[
															483.589,
															616.304
														],
														[
															485,
															614
														],
														[
															486.601,
															611.338
														],
														[
															488,
															609
														],
														[
															499.422,
															588.305
														],
														[
															510,
															565
														],
														[
															538.797,
															469.067
														],
														[
															549,
															355
														],
														[
															538.488,
															242.747
														],
														[
															510,
															146
														],
														[
															490.221,
															105.409
														],
														[
															464,
															68
														],
														[
															431.062,
															37.298
														],
														[
															389,
															18
														],
														[
															369.361,
															14.966
														],
														[
															348,
															15
														],
														[
															347.234,
															15.524
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 87,
											"s": [
												{
													"i": [
														[
															-0.038,
															0.004
														],
														[
															2.535,
															-0.346
														],
														[
															2.475,
															-0.474
														],
														[
															2.452,
															-0.641
														],
														[
															2.468,
															-0.848
														],
														[
															7.594,
															-4.482
														],
														[
															6.516,
															-5.255
														],
														[
															5.219,
															-5.219
														],
														[
															5.435,
															-7.035
														],
														[
															4.274,
															-6.875
														],
														[
															0.831,
															-1.317
														],
														[
															0.825,
															-1.361
														],
														[
															1.366,
															-2.431
														],
														[
															1.132,
															-1.955
														],
														[
															0.386,
															-0.299
														],
														[
															0.194,
															-0.347
														],
														[
															1.249,
															-3.26
														],
														[
															1.354,
															-3.002
														],
														[
															1.093,
															-1.813
														],
														[
															0.774,
															-1.856
														],
														[
															0.314,
															-1.037
														],
														[
															0.358,
															-0.919
														],
														[
															0.827,
															-1.911
														],
														[
															0.706,
															-1.824
														],
														[
															0.305,
															-1.222
														],
														[
															0.384,
															-1.085
														],
														[
															0.888,
															-2.156
														],
														[
															0.681,
															-2.214
														],
														[
															0.401,
															-2.326
														],
														[
															0.695,
															-2.416
														],
														[
															0.187,
															-0.537
														],
														[
															0.187,
															-0.63
														],
														[
															1.947,
															-8.927
														],
														[
															1.593,
															-9.466
														],
														[
															1.001,
															-7.603
														],
														[
															0.687,
															-7.808
														],
														[
															-0.785,
															-21.831
														],
														[
															-2.884,
															-20.693
														],
														[
															-8.585,
															-26.31
														],
														[
															-12.416,
															-22.302
														],
														[
															-2.706,
															-4.358
														],
														[
															-2.564,
															-3.872
														],
														[
															-0.671,
															-0.775
														],
														[
															-0.659,
															-0.905
														],
														[
															-0.086,
															-0.52
														],
														[
															-0.335,
															-0.479
														],
														[
															-0.597,
															-0.292
														],
														[
															-0.321,
															-0.414
														],
														[
															-0.094,
															-0.55
														],
														[
															-0.296,
															-0.38
														],
														[
															-0.582,
															-0.289
														],
														[
															-0.344,
															-0.422
														],
														[
															-0.102,
															-0.563
														],
														[
															-0.276,
															-0.361
														],
														[
															-0.37,
															-0.339
														],
														[
															-0.284,
															-0.337
														],
														[
															-5.289,
															-4.875
														],
														[
															-5.909,
															-4.653
														],
														[
															-12.144,
															-5.193
														],
														[
															-16.445,
															-1.37
														],
														[
															-7.236,
															0.162
														],
														[
															-2.033,
															2.772
														],
														[
															-0.491,
															1.874
														],
														[
															-0.448,
															0.7
														],
														[
															-0.659,
															0.18
														],
														[
															-0.928,
															0.597
														],
														[
															-2.139,
															0.592
														],
														[
															-1.941,
															0.663
														],
														[
															-11.628,
															8.212
														],
														[
															-9.011,
															10.206
														],
														[
															-4.912,
															6.356
														],
														[
															-4.512,
															7.096
														],
														[
															-3.812,
															7.401
														],
														[
															-3.311,
															7.41
														],
														[
															-7.15,
															38.036
														],
														[
															2.109,
															44.624
														],
														[
															0.762,
															10.329
														],
														[
															1.455,
															10.12
														],
														[
															2.577,
															11.484
														],
														[
															3.009,
															10.368
														],
														[
															10.36,
															20.83
														],
														[
															13.608,
															16.731
														],
														[
															4.062,
															4.459
														],
														[
															4.033,
															3.589
														],
														[
															0.582,
															0.111
														],
														[
															0.332,
															0.255
														],
														[
															0.634,
															0.712
														],
														[
															0.622,
															0.508
														],
														[
															17.522,
															6.274
														],
														[
															22.821,
															-1.776
														],
														[
															0.179,
															-0.245
														]
													],
													"o": [
														[
															-2.633,
															0.258
														],
														[
															-2.535,
															0.346
														],
														[
															-2.475,
															0.474
														],
														[
															-2.452,
															0.641
														],
														[
															-8.451,
															2.903
														],
														[
															-7.594,
															4.482
														],
														[
															-6.516,
															5.255
														],
														[
															-5.986,
															5.986
														],
														[
															-5.435,
															7.035
														],
														[
															-0.853,
															1.371
														],
														[
															-0.831,
															1.317
														],
														[
															-1.406,
															2.32
														],
														[
															-1.366,
															2.431
														],
														[
															-0.263,
															0.455
														],
														[
															-0.386,
															0.299
														],
														[
															-1.65,
															2.96
														],
														[
															-1.249,
															3.26
														],
														[
															-0.854,
															1.894
														],
														[
															-1.093,
															1.813
														],
														[
															-0.388,
															0.931
														],
														[
															-0.314,
															1.037
														],
														[
															-0.984,
															2.531
														],
														[
															-0.827,
															1.911
														],
														[
															-0.397,
															1.025
														],
														[
															-0.305,
															1.222
														],
														[
															-0.765,
															2.162
														],
														[
															-0.888,
															2.156
														],
														[
															-0.702,
															2.281
														],
														[
															-0.401,
															2.326
														],
														[
															-0.064,
															0.222
														],
														[
															-0.187,
															0.537
														],
														[
															-2.618,
															8.827
														],
														[
															-1.947,
															8.927
														],
														[
															-1.31,
															7.78
														],
														[
															-1.001,
															7.603
														],
														[
															-2.022,
															22.982
														],
														[
															0.785,
															21.831
														],
														[
															4.245,
															30.46
														],
														[
															8.585,
															26.309
														],
														[
															2.613,
															4.694
														],
														[
															2.706,
															4.358
														],
														[
															0.657,
															0.994
														],
														[
															0.671,
															0.775
														],
														[
															0.32,
															0.44
														],
														[
															0.086,
															0.52
														],
														[
															0.291,
															0.417
														],
														[
															0.597,
															0.292
														],
														[
															0.326,
															0.42
														],
														[
															0.095,
															0.55
														],
														[
															0.328,
															0.421
														],
														[
															0.582,
															0.289
														],
														[
															0.317,
															0.388
														],
														[
															0.102,
															0.563
														],
														[
															0.236,
															0.308
														],
														[
															0.37,
															0.339
														],
														[
															4.933,
															5.846
														],
														[
															5.29,
															4.875
														],
														[
															9.981,
															7.859
														],
														[
															12.144,
															5.193
														],
														[
															5.023,
															0.418
														],
														[
															7.236,
															-0.162
														],
														[
															0.589,
															-0.803
														],
														[
															0.491,
															-1.874
														],
														[
															0.436,
															-0.682
														],
														[
															0.659,
															-0.18
														],
														[
															1.505,
															-0.967
														],
														[
															2.138,
															-0.592
														],
														[
															14.479,
															-4.947
														],
														[
															11.627,
															-8.212
														],
														[
															4.839,
															-5.481
														],
														[
															4.912,
															-6.356
														],
														[
															4.442,
															-6.986
														],
														[
															3.812,
															-7.401
														],
														[
															13.509,
															-30.235
														],
														[
															7.15,
															-38.035
														],
														[
															-0.499,
															-10.562
														],
														[
															-0.762,
															-10.329
														],
														[
															-1.681,
															-11.695
														],
														[
															-2.577,
															-11.484
														],
														[
															-6.95,
															-23.95
														],
														[
															-10.36,
															-20.83
														],
														[
															-3.72,
															-4.573
														],
														[
															-4.062,
															-4.46
														],
														[
															-0.339,
															-0.302
														],
														[
															-0.582,
															-0.111
														],
														[
															-0.844,
															-0.645
														],
														[
															-0.634,
															-0.712
														],
														[
															-13.09,
															-10.678
														],
														[
															-17.522,
															-6.274
														],
														[
															-0.321,
															0.025
														],
														[
															-0.179,
															0.245
														]
													],
													"v": [
														[
															346,
															16
														],
														[
															338.258,
															16.896
														],
														[
															330.752,
															18.115
														],
														[
															323.371,
															19.777
														],
														[
															316,
															22
														],
														[
															291.878,
															33.28
														],
														[
															270.658,
															48.087
														],
														[
															253,
															64
														],
														[
															235.716,
															83.833
														],
														[
															221,
															105
														],
														[
															218.479,
															109.008
														],
														[
															216,
															113
														],
														[
															211.794,
															120.273
														],
														[
															208,
															127
														],
														[
															206.948,
															128.081
														],
														[
															206,
															129
														],
														[
															201.778,
															138.469
														],
														[
															198,
															148
														],
														[
															194.94,
															153.528
														],
														[
															192,
															159
														],
														[
															190.977,
															162.009
														],
														[
															190,
															165
														],
														[
															187.291,
															171.53
														],
														[
															185,
															177
														],
														[
															183.991,
															180.455
														],
														[
															183,
															184
														],
														[
															180.437,
															190.461
														],
														[
															178,
															197
														],
														[
															176.494,
															203.899
														],
														[
															175,
															211
														],
														[
															174.592,
															212.195
														],
														[
															174,
															214
														],
														[
															167.231,
															240.521
														],
														[
															162,
															268
														],
														[
															158.533,
															290.98
														],
														[
															156,
															314
														],
														[
															154.32,
															381.216
														],
														[
															160,
															445
														],
														[
															179.372,
															530.119
														],
														[
															211,
															603
														],
														[
															219.037,
															616.616
														],
														[
															227,
															629
														],
														[
															228.999,
															631.566
														],
														[
															231,
															634
														],
														[
															231.489,
															635.471
														],
														[
															232,
															637
														],
														[
															233.478,
															638.002
														],
														[
															235,
															639
														],
														[
															235.522,
															640.53
														],
														[
															236,
															642
														],
														[
															237.488,
															643
														],
														[
															239,
															644
														],
														[
															239.53,
															645.52
														],
														[
															240,
															647
														],
														[
															240.964,
															647.979
														],
														[
															242,
															649
														],
														[
															257.267,
															664.895
														],
														[
															274,
															679
														],
														[
															306.652,
															698.867
														],
														[
															349,
															709
														],
														[
															369.243,
															709.892
														],
														[
															385,
															706
														],
														[
															386.606,
															701.423
														],
														[
															388,
															697
														],
														[
															389.631,
															695.936
														],
														[
															392,
															695
														],
														[
															397.673,
															692.772
														],
														[
															404,
															691
														],
														[
															443.101,
															670.944
														],
														[
															474,
															643
														],
														[
															488.745,
															625.212
														],
														[
															503,
															605
														],
														[
															515.349,
															583.318
														],
														[
															526,
															561
														],
														[
															557.713,
															458.292
														],
														[
															566,
															334
														],
														[
															564.217,
															302.668
														],
														[
															561,
															272
														],
														[
															554.496,
															237.005
														],
														[
															546,
															204
														],
														[
															519.993,
															136.587
														],
														[
															484,
															80
														],
														[
															472.235,
															66.262
														],
														[
															460,
															54
														],
														[
															458.495,
															53.464
														],
														[
															457,
															53
														],
														[
															454.834,
															50.897
														],
														[
															453,
															49
														],
														[
															407.298,
															22.66
														],
														[
															347,
															15
														],
														[
															346.231,
															15.521
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 88,
											"s": [
												{
													"i": [
														[
															-0.103,
															0.008
														],
														[
															9.527,
															-2.68
														],
														[
															8.647,
															-4.439
														],
														[
															14.385,
															-14.387
														],
														[
															10.397,
															-16.664
														],
														[
															1.159,
															-1.746
														],
														[
															1.093,
															-1.975
														],
														[
															1.429,
															-2.946
														],
														[
															1.528,
															-3.038
														],
														[
															3.743,
															-8.091
														],
														[
															2.992,
															-8.605
														],
														[
															4.959,
															-32.753
														],
														[
															-1.555,
															-32.913
														],
														[
															-9.739,
															-35.443
														],
														[
															-16.038,
															-27.786
														],
														[
															-0.979,
															-2.131
														],
														[
															-0.951,
															-1.509
														],
														[
															-0.74,
															-0.602
														],
														[
															-0.552,
															-0.82
														],
														[
															-0.444,
															-1.047
														],
														[
															-0.61,
															-0.898
														],
														[
															-1.362,
															-1.608
														],
														[
															-1.321,
															-1.755
														],
														[
															-0.084,
															-0.52
														],
														[
															-0.336,
															-0.481
														],
														[
															-0.597,
															-0.292
														],
														[
															-0.321,
															-0.414
														],
														[
															-0.094,
															-0.55
														],
														[
															-0.296,
															-0.38
														],
														[
															-0.582,
															-0.289
														],
														[
															-0.344,
															-0.421
														],
														[
															-0.099,
															-0.561
														],
														[
															-0.284,
															-0.365
														],
														[
															-1.23,
															-1.133
														],
														[
															-1.021,
															-1.106
														],
														[
															-13.914,
															-9.661
														],
														[
															-19.521,
															-5.546
														],
														[
															-5.235,
															-0.819
														],
														[
															-5.475,
															-0.422
														],
														[
															-7.311,
															0.15
														],
														[
															-2.36,
															2.815
														],
														[
															-0.883,
															2.075
														],
														[
															-0.549,
															0.604
														],
														[
															-0.423,
															-0.011
														],
														[
															-0.772,
															0.452
														],
														[
															-2.294,
															0.575
														],
														[
															-2.048,
															0.658
														],
														[
															-3.926,
															1.677
														],
														[
															-3.554,
															1.771
														],
														[
															-2.008,
															0.96
														],
														[
															-1.849,
															1.106
														],
														[
															-6.204,
															5.185
														],
														[
															-5.907,
															5.907
														],
														[
															-2.915,
															2.786
														],
														[
															-2.579,
															3.095
														],
														[
															-8.57,
															14.795
														],
														[
															-6.379,
															15.409
														],
														[
															-1.448,
															4.335
														],
														[
															-1.5,
															4.534
														],
														[
															-0.913,
															1.947
														],
														[
															-0.654,
															2.112
														],
														[
															-0.427,
															2.371
														],
														[
															-0.622,
															2.357
														],
														[
															-1.19,
															4.644
														],
														[
															-1.046,
															4.908
														],
														[
															-1.765,
															21.139
														],
														[
															1.122,
															23.393
														],
														[
															3.113,
															19.806
														],
														[
															5.544,
															18.814
														],
														[
															2.899,
															8.283
														],
														[
															3.574,
															8.268
														],
														[
															1.069,
															1.804
														],
														[
															0.88,
															1.829
														],
														[
															1.69,
															3.538
														],
														[
															1.652,
															2.55
														],
														[
															0.351,
															0.509
														],
														[
															0.267,
															0.457
														],
														[
															0.957,
															2.103
														],
														[
															1.007,
															1.597
														],
														[
															0.739,
															0.6
														],
														[
															0.535,
															0.794
														],
														[
															1.38,
															2.032
														],
														[
															7.986,
															9.045
														],
														[
															10.214,
															7.755
														],
														[
															0.962,
															0.672
														],
														[
															0.851,
															0.604
														],
														[
															0.736,
															0.457
														],
														[
															0.656,
															0.423
														],
														[
															3.296,
															1.844
														],
														[
															10.72,
															3.529
														],
														[
															22.506,
															-1.655
														]
													],
													"o": [
														[
															-10.245,
															0.841
														],
														[
															-9.527,
															2.68
														],
														[
															-19.065,
															9.788
														],
														[
															-14.385,
															14.387
														],
														[
															-1.273,
															2.04
														],
														[
															-1.159,
															1.746
														],
														[
															-1.758,
															3.178
														],
														[
															-1.429,
															2.946
														],
														[
															-4.037,
															8.031
														],
														[
															-3.743,
															8.091
														],
														[
															-8.719,
															25.073
														],
														[
															-4.959,
															32.753
														],
														[
															2.005,
															42.44
														],
														[
															9.739,
															35.443
														],
														[
															1.135,
															1.966
														],
														[
															0.978,
															2.131
														],
														[
															0.486,
															0.771
														],
														[
															0.74,
															0.602
														],
														[
															0.616,
															0.914
														],
														[
															0.444,
															1.047
														],
														[
															1.232,
															1.814
														],
														[
															1.362,
															1.608
														],
														[
															0.329,
															0.437
														],
														[
															0.084,
															0.52
														],
														[
															0.291,
															0.417
														],
														[
															0.597,
															0.292
														],
														[
															0.326,
															0.42
														],
														[
															0.095,
															0.55
														],
														[
															0.328,
															0.421
														],
														[
															0.582,
															0.289
														],
														[
															0.32,
															0.392
														],
														[
															0.099,
															0.561
														],
														[
															1.059,
															1.36
														],
														[
															1.23,
															1.134
														],
														[
															11.822,
															12.811
														],
														[
															13.914,
															9.661
														],
														[
															4.587,
															1.303
														],
														[
															5.235,
															0.819
														],
														[
															5.397,
															0.416
														],
														[
															7.311,
															-0.15
														],
														[
															0.919,
															-1.096
														],
														[
															0.883,
															-2.075
														],
														[
															0.538,
															-0.592
														],
														[
															0.423,
															0.011
														],
														[
															1.775,
															-1.042
														],
														[
															2.294,
															-0.575
														],
														[
															4.741,
															-1.522
														],
														[
															3.926,
															-1.677
														],
														[
															2.118,
															-1.055
														],
														[
															2.008,
															-0.96
														],
														[
															7.278,
															-4.354
														],
														[
															6.204,
															-5.185
														],
														[
															2.761,
															-2.762
														],
														[
															2.915,
															-2.786
														],
														[
															10.342,
															-12.411
														],
														[
															8.57,
															-14.795
														],
														[
															1.708,
															-4.127
														],
														[
															1.448,
															-4.335
														],
														[
															0.695,
															-2.099
														],
														[
															0.913,
															-1.947
														],
														[
															0.669,
															-2.159
														],
														[
															0.427,
															-2.371
														],
														[
															1.192,
															-4.515
														],
														[
															1.19,
															-4.644
														],
														[
															4.063,
															-19.052
														],
														[
															1.765,
															-21.139
														],
														[
															-1.006,
															-20.964
														],
														[
															-3.113,
															-19.806
														],
														[
															-2.829,
															-9.6
														],
														[
															-2.899,
															-8.283
														],
														[
															-0.844,
															-1.954
														],
														[
															-1.069,
															-1.804
														],
														[
															-1.587,
															-3.298
														],
														[
															-1.69,
															-3.538
														],
														[
															-0.328,
															-0.506
														],
														[
															-0.351,
															-0.509
														],
														[
															-1.163,
															-1.989
														],
														[
															-0.957,
															-2.103
														],
														[
															-0.508,
															-0.806
														],
														[
															-0.739,
															-0.6
														],
														[
															-1.35,
															-2.005
														],
														[
															-7.068,
															-10.409
														],
														[
															-9.193,
															-10.412
														],
														[
															-0.872,
															-0.662
														],
														[
															-0.832,
															-0.581
														],
														[
															-0.834,
															-0.592
														],
														[
															-0.599,
															-0.372
														],
														[
															-3.921,
															-2.53
														],
														[
															-9.785,
															-5.473
														],
														[
															-18.318,
															-6.03
														],
														[
															-0.624,
															0.046
														]
													],
													"v": [
														[
															346,
															16
														],
														[
															316.302,
															21.302
														],
														[
															289,
															32
														],
														[
															238.999,
															68.843
														],
														[
															202,
															116
														],
														[
															198.365,
															121.549
														],
														[
															195,
															127
														],
														[
															190.327,
															136.105
														],
														[
															186,
															145
														],
														[
															174.216,
															169.07
														],
														[
															164,
															194
														],
														[
															142.794,
															282.62
														],
														[
															137,
															383
														],
														[
															154.975,
															499.99
														],
														[
															194,
															595
														],
														[
															197.138,
															601.343
														],
														[
															200,
															607
														],
														[
															201.95,
															608.963
														],
														[
															204,
															611
														],
														[
															205.504,
															614.012
														],
														[
															207,
															617
														],
														[
															210.933,
															622.045
														],
														[
															215,
															627
														],
														[
															215.495,
															628.467
														],
														[
															216,
															630
														],
														[
															217.478,
															631.002
														],
														[
															219,
															632
														],
														[
															219.522,
															633.53
														],
														[
															220,
															635
														],
														[
															221.488,
															636
														],
														[
															223,
															637
														],
														[
															223.527,
															638.521
														],
														[
															224,
															640
														],
														[
															227.529,
															643.69
														],
														[
															231,
															647
														],
														[
															268.726,
															680.948
														],
														[
															318,
															704
														],
														[
															332.834,
															707.161
														],
														[
															349,
															709
														],
														[
															369.778,
															709.923
														],
														[
															386,
															706
														],
														[
															388.778,
															700.631
														],
														[
															391,
															696
														],
														[
															392.325,
															695.395
														],
														[
															394,
															695
														],
														[
															400.296,
															692.712
														],
														[
															407,
															691
														],
														[
															419.891,
															686.186
														],
														[
															431,
															681
														],
														[
															437.201,
															678.038
														],
														[
															443,
															675
														],
														[
															463.028,
															660.665
														],
														[
															481,
															644
														],
														[
															489.637,
															635.75
														],
														[
															498,
															627
														],
														[
															526.473,
															585.749
														],
														[
															549,
															540
														],
														[
															553.656,
															527.305
														],
														[
															558,
															514
														],
														[
															560.53,
															508.01
														],
														[
															563,
															502
														],
														[
															564.535,
															495.149
														],
														[
															566,
															488
														],
														[
															569.61,
															474.294
														],
														[
															573,
															460
														],
														[
															581.889,
															399.756
														],
														[
															583,
															333
														],
														[
															576.904,
															271.888
														],
														[
															564,
															214
														],
														[
															555.559,
															187.501
														],
														[
															546,
															163
														],
														[
															543.027,
															157.406
														],
														[
															540,
															152
														],
														[
															535.049,
															141.44
														],
														[
															530,
															132
														],
														[
															528.954,
															130.463
														],
														[
															528,
															129
														],
														[
															524.883,
															122.707
														],
														[
															522,
															117
														],
														[
															520.02,
															114.991
														],
														[
															518,
															113
														],
														[
															515,
															107
														],
														[
															492,
															78
														],
														[
															461,
															49
														],
														[
															458,
															48
														],
														[
															456,
															45
														],
														[
															453,
															44
														],
														[
															451,
															42
														],
														[
															440,
															36
														],
														[
															410,
															22
														],
														[
															347,
															15
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 89,
											"s": [
												{
													"i": [
														[
															18.413,
															-1.512
														],
														[
															0.335,
															0.009
														],
														[
															0.331,
															-0.009
														],
														[
															11.374,
															-3.887
														],
														[
															9.063,
															-4.085
														],
														[
															0.153,
															-0.451
														],
														[
															0.21,
															-0.117
														],
														[
															1.974,
															-0.854
														],
														[
															1.364,
															-0.615
														],
														[
															0.16,
															-0.451
														],
														[
															0.192,
															-0.123
														],
														[
															1.057,
															-0.456
														],
														[
															0.846,
															-0.589
														],
														[
															4.164,
															-3.565
														],
														[
															3.683,
															-3.496
														],
														[
															5.344,
															-5.585
														],
														[
															4.154,
															-5.471
														],
														[
															0.083,
															-0.521
														],
														[
															0.336,
															-0.481
														],
														[
															0.601,
															-0.29
														],
														[
															0.305,
															-0.423
														],
														[
															0.441,
															-1.063
														],
														[
															0.606,
															-0.876
														],
														[
															0.226,
															-0.223
														],
														[
															0.069,
															-0.072
														],
														[
															0.298,
															-0.539
														],
														[
															0.407,
															-0.425
														],
														[
															0.776,
															-1.157
														],
														[
															0.769,
															-1.196
														],
														[
															1.148,
															-1.775
														],
														[
															1.024,
															-1.747
														],
														[
															1.19,
															-2.003
														],
														[
															0.935,
															-1.755
														],
														[
															2.288,
															-5.21
														],
														[
															2.177,
															-5.142
														],
														[
															1.046,
															-2.139
														],
														[
															0.876,
															-2.226
														],
														[
															5.301,
															-32.619
														],
														[
															-1.34,
															-35.772
														],
														[
															-2.936,
															-18.68
														],
														[
															-4.498,
															-16.081
														],
														[
															-4.25,
															-11.296
														],
														[
															-4.74,
															-10.158
														],
														[
															-10.034,
															-14.554
														],
														[
															-12.062,
															-12.062
														],
														[
															-4.847,
															-4.459
														],
														[
															-4.992,
															-3.548
														],
														[
															-1.356,
															-0.69
														],
														[
															-0.485,
															-0.465
														],
														[
															-0.539,
															-0.298
														],
														[
															-0.425,
															-0.408
														],
														[
															-1.162,
															-0.793
														],
														[
															-1.177,
															-0.702
														],
														[
															-1.033,
															-0.483
														],
														[
															-0.999,
															-0.548
														],
														[
															-4.236,
															-2.091
														],
														[
															-3.982,
															-1.402
														],
														[
															-10.987,
															-1.784
														],
														[
															-11.075,
															0.298
														],
														[
															-3.287,
															0.079
														],
														[
															-1.894,
															0.602
														],
														[
															-1.151,
															1.146
														],
														[
															-1.466,
															1.803
														],
														[
															-0.169,
															0.851
														],
														[
															-0.543,
															0.635
														],
														[
															-2.174,
															0.532
														],
														[
															-2.138,
															0.512
														],
														[
															-9.208,
															4.399
														],
														[
															-7.586,
															4.871
														],
														[
															-15.197,
															17.58
														],
														[
															-11.397,
															20.955
														],
														[
															-4.932,
															12.721
														],
														[
															-3.942,
															13.482
														],
														[
															-1.394,
															4.682
														],
														[
															-1.022,
															4.476
														],
														[
															-0.975,
															5.09
														],
														[
															-0.805,
															5.233
														],
														[
															-0.996,
															10.825
														],
														[
															17.885,
															54.724
														],
														[
															15.513,
															24.396
														],
														[
															2.381,
															3.397
														],
														[
															1.434,
															1.496
														],
														[
															0.991,
															1.215
														],
														[
															0.732,
															0.964
														],
														[
															4.099,
															4.63
														],
														[
															6.435,
															5.651
														],
														[
															6.625,
															4.84
														],
														[
															1.701,
															1.211
														],
														[
															1.894,
															1.201
														],
														[
															7.901,
															3.67
														],
														[
															9.946,
															2.536
														]
													],
													"o": [
														[
															-0.33,
															0.027
														],
														[
															-0.335,
															-0.009
														],
														[
															-13.442,
															0.367
														],
														[
															-11.374,
															3.887
														],
														[
															-0.177,
															0.079
														],
														[
															-0.153,
															0.451
														],
														[
															-1.74,
															0.97
														],
														[
															-1.974,
															0.854
														],
														[
															-0.167,
															0.075
														],
														[
															-0.16,
															0.451
														],
														[
															-0.925,
															0.588
														],
														[
															-1.057,
															0.456
														],
														[
															-4.659,
															3.245
														],
														[
															-4.164,
															3.565
														],
														[
															-5.468,
															5.19
														],
														[
															-5.345,
															5.585
														],
														[
															-0.331,
															0.436
														],
														[
															-0.083,
															0.521
														],
														[
															-0.291,
															0.416
														],
														[
															-0.601,
															0.29
														],
														[
															-0.629,
															0.871
														],
														[
															-0.441,
															1.063
														],
														[
															-0.025,
															0.036
														],
														[
															-0.226,
															0.223
														],
														[
															-0.401,
															0.419
														],
														[
															-0.298,
															0.539
														],
														[
															-1.129,
															1.178
														],
														[
															-0.776,
															1.156
														],
														[
															-1.383,
															2.153
														],
														[
															-1.148,
															1.775
														],
														[
															-1.307,
															2.231
														],
														[
															-1.19,
															2.003
														],
														[
															-2.671,
															5.019
														],
														[
															-2.288,
															5.21
														],
														[
															-0.939,
															2.218
														],
														[
															-1.046,
															2.139
														],
														[
															-10.135,
															25.751
														],
														[
															-5.301,
															32.619
														],
														[
															0.757,
															20.2
														],
														[
															2.936,
															18.68
														],
														[
															3.262,
															11.659
														],
														[
															4.25,
															11.296
														],
														[
															7.803,
															16.721
														],
														[
															10.034,
															14.554
														],
														[
															4.618,
															4.618
														],
														[
															4.847,
															4.459
														],
														[
															1.091,
															0.775
														],
														[
															1.356,
															0.69
														],
														[
															0.419,
															0.401
														],
														[
															0.539,
															0.298
														],
														[
															1.174,
															1.125
														],
														[
															1.162,
															0.793
														],
														[
															0.869,
															0.519
														],
														[
															1.033,
															0.483
														],
														[
															4.076,
															2.233
														],
														[
															4.236,
															2.091
														],
														[
															8.977,
															3.16
														],
														[
															10.987,
															1.784
														],
														[
															2.957,
															-0.08
														],
														[
															3.287,
															-0.079
														],
														[
															1.929,
															-0.613
														],
														[
															1.151,
															-1.146
														],
														[
															0.782,
															-0.962
														],
														[
															0.169,
															-0.851
														],
														[
															1.164,
															-1.362
														],
														[
															2.174,
															-0.532
														],
														[
															10.58,
															-2.533
														],
														[
															9.209,
															-4.399
														],
														[
															19.815,
															-12.725
														],
														[
															15.197,
															-17.58
														],
														[
															6.328,
															-11.635
														],
														[
															4.932,
															-12.721
														],
														[
															1.404,
															-4.798
														],
														[
															1.394,
															-4.681
														],
														[
															1.104,
															-4.839
														],
														[
															0.955,
															-4.985
														],
														[
															1.574,
															-10.231
														],
														[
															6.406,
															-69.657
														],
														[
															-10.239,
															-31.33
														],
														[
															-2.237,
															-3.518
														],
														[
															-1.763,
															-2.516
														],
														[
															-1.448,
															-1.511
														],
														[
															-0.709,
															-0.869
														],
														[
															-4.046,
															-5.329
														],
														[
															-6.21,
															-7.014
														],
														[
															-6.687,
															-5.873
														],
														[
															-1.684,
															-1.23
														],
														[
															-1.965,
															-1.399
														],
														[
															-7.276,
															-4.614
														],
														[
															-9.873,
															-4.586
														],
														[
															-16.348,
															-4.168
														]
													],
													"v": [
														[
															345,
															16
														],
														[
															344.001,
															16.014
														],
														[
															343,
															16
														],
														[
															305.716,
															23.212
														],
														[
															275,
															36
														],
														[
															274.525,
															36.972
														],
														[
															274,
															38
														],
														[
															268.218,
															40.766
														],
														[
															263,
															43
														],
														[
															262.519,
															43.964
														],
														[
															262,
															45
														],
														[
															258.94,
															46.5
														],
														[
															256,
															48
														],
														[
															242.768,
															58.311
														],
														[
															231,
															69
														],
														[
															214.514,
															85.289
														],
														[
															200,
															102
														],
														[
															199.504,
															103.466
														],
														[
															199,
															105
														],
														[
															197.511,
															105.995
														],
														[
															196,
															107
														],
														[
															194.483,
															109.997
														],
														[
															193,
															113
														],
														[
															192.533,
															113.473
														],
														[
															192,
															114
														],
														[
															191.005,
															115.496
														],
														[
															190,
															117
														],
														[
															187.23,
															120.487
														],
														[
															185,
															124
														],
														[
															181.23,
															129.805
														],
														[
															178,
															135
														],
														[
															174.221,
															141.357
														],
														[
															171,
															147
														],
														[
															163.629,
															162.408
														],
														[
															157,
															178
														],
														[
															153.953,
															184.494
														],
														[
															151,
															191
														],
														[
															127.394,
															279.485
														],
														[
															121,
															383
														],
														[
															126.694,
															441.589
														],
														[
															138,
															494
														],
														[
															149.391,
															528.626
														],
														[
															163,
															561
														],
														[
															189.806,
															607.994
														],
														[
															223,
															648
														],
														[
															237.219,
															661.803
														],
														[
															252,
															674
														],
														[
															255.955,
															676.233
														],
														[
															259,
															678
														],
														[
															260.495,
															678.995
														],
														[
															262,
															680
														],
														[
															265.498,
															682.817
														],
														[
															269,
															685
														],
														[
															271.903,
															686.478
														],
														[
															275,
															688
														],
														[
															287.57,
															694.623
														],
														[
															300,
															700
														],
														[
															330.427,
															707.594
														],
														[
															364,
															710
														],
														[
															373.797,
															709.892
														],
														[
															382,
															709
														],
														[
															386.348,
															706.392
														],
														[
															390,
															702
														],
														[
															391.179,
															699.255
														],
														[
															392,
															697
														],
														[
															397.27,
															694.362
														],
														[
															404,
															693
														],
														[
															433.745,
															682.254
														],
														[
															459,
															668
														],
														[
															511.314,
															622.173
														],
														[
															551,
															564
														],
														[
															567.789,
															527.385
														],
														[
															581,
															488
														],
														[
															585.286,
															473.758
														],
														[
															589,
															460
														],
														[
															591,
															445
														],
														[
															594,
															430
														],
														[
															598,
															398
														],
														[
															577,
															210
														],
														[
															538,
															125
														],
														[
															531,
															114
														],
														[
															525,
															106
														],
														[
															522,
															102
														],
														[
															520,
															99
														],
														[
															507,
															85
														],
														[
															490,
															67
														],
														[
															470,
															51
														],
														[
															465,
															47
														],
														[
															459,
															44
														],
														[
															437,
															31
														],
														[
															404,
															20
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 90,
											"s": [
												{
													"i": [
														[
															-0.106,
															0.008
														],
														[
															10.235,
															-2.5
														],
														[
															9.454,
															-4.093
														],
														[
															8.058,
															-4.722
														],
														[
															6.799,
															-5.231
														],
														[
															2.142,
															-1.782
														],
														[
															1.395,
															-1.305
														],
														[
															1.32,
															-1.111
														],
														[
															1.288,
															-1.218
														],
														[
															2.441,
															-2.423
														],
														[
															1.862,
															-2.063
														],
														[
															0.605,
															-1.052
														],
														[
															0.779,
															-0.906
														],
														[
															1.534,
															-1.629
														],
														[
															1.359,
															-1.731
														],
														[
															2.651,
															-3.644
														],
														[
															2.423,
															-3.638
														],
														[
															0.701,
															-1.353
														],
														[
															0.457,
															-0.478
														],
														[
															0.298,
															-0.539
														],
														[
															0.407,
															-0.425
														],
														[
															1.279,
															-2.274
														],
														[
															1.127,
															-2.07
														],
														[
															2.903,
															-5.987
														],
														[
															2.322,
															-5.419
														],
														[
															0.62,
															-1.599
														],
														[
															0.658,
															-1.594
														],
														[
															4.707,
															-19.293
														],
														[
															2.218,
															-20.983
														],
														[
															0.332,
															-12.02
														],
														[
															-0.604,
															-11.857
														],
														[
															-1.357,
															-11.121
														],
														[
															-1.969,
															-10.67
														],
														[
															-2.434,
															-10.198
														],
														[
															-3.272,
															-9.408
														],
														[
															-2.663,
															-6.178
														],
														[
															-2.237,
															-5.22
														],
														[
															-1.291,
															-2.497
														],
														[
															-1.45,
															-2.777
														],
														[
															-0.931,
															-2.204
														],
														[
															-1.163,
															-2.053
														],
														[
															-0.759,
															-0.837
														],
														[
															-0.481,
															-0.799
														],
														[
															-0.419,
															-1.205
														],
														[
															-0.635,
															-1.038
														],
														[
															-0.388,
															-0.323
														],
														[
															-0.257,
															-0.396
														],
														[
															-0.34,
															-0.502
														],
														[
															-0.3,
															-0.469
														],
														[
															-1.059,
															-1.919
														],
														[
															-0.835,
															-0.872
														],
														[
															-1.004,
															-1.168
														],
														[
															-0.89,
															-1.183
														],
														[
															-2.6,
															-3.516
														],
														[
															-2.925,
															-3.38
														],
														[
															-3.177,
															-3.128
														],
														[
															-3.375,
															-3.114
														],
														[
															-3.993,
															-3.22
														],
														[
															-3.413,
															-2.784
														],
														[
															-3.241,
															-2.055
														],
														[
															-3.135,
															-1.413
														],
														[
															-0.409,
															-0.238
														],
														[
															-4.253,
															-2.097
														],
														[
															-19.359,
															-2.893
														],
														[
															-6.152,
															-0.457
														],
														[
															-6.375,
															0.214
														],
														[
															-3.953,
															1.178
														],
														[
															-2.982,
															3.691
														],
														[
															-0.368,
															0.229
														],
														[
															-1.038,
															0.493
														],
														[
															-4.666,
															1.295
														],
														[
															-22.902,
															19.633
														],
														[
															-19.545,
															79.405
														],
														[
															3.259,
															49.736
														],
														[
															17.181,
															40.765
														],
														[
															16.922,
															22.449
														],
														[
															12.61,
															11.969
														],
														[
															3.188,
															2.621
														],
														[
															0.966,
															0.675
														],
														[
															0.824,
															0.648
														],
														[
															0.965,
															0.674
														],
														[
															0.84,
															0.624
														],
														[
															0.629,
															0.602
														],
														[
															2.316,
															1.534
														],
														[
															1.38,
															0.622
														],
														[
															0.387,
															0.244
														],
														[
															2.105,
															1.241
														],
														[
															3.916,
															2.014
														],
														[
															5.14,
															1.954
														],
														[
															7.16,
															1.883
														],
														[
															24.315,
															-1.677
														]
													],
													"o": [
														[
															-11.606,
															0.907
														],
														[
															-10.235,
															2.5
														],
														[
															-8.966,
															3.882
														],
														[
															-8.059,
															4.722
														],
														[
															-2.038,
															1.568
														],
														[
															-2.142,
															1.782
														],
														[
															-1.432,
															1.34
														],
														[
															-1.32,
															1.111
														],
														[
															-2.376,
															2.246
														],
														[
															-2.441,
															2.423
														],
														[
															-0.8,
															0.886
														],
														[
															-0.605,
															1.052
														],
														[
															-1.505,
															1.754
														],
														[
															-1.534,
															1.629
														],
														[
															-2.971,
															3.785
														],
														[
															-2.651,
															3.644
														],
														[
															-0.738,
															1.109
														],
														[
															-0.701,
															1.353
														],
														[
															-0.401,
															0.419
														],
														[
															-0.298,
															0.539
														],
														[
															-1.757,
															1.834
														],
														[
															-1.279,
															2.274
														],
														[
															-3.067,
															5.631
														],
														[
															-2.903,
															5.987
														],
														[
															-0.861,
															2.008
														],
														[
															-0.62,
															1.599
														],
														[
															-6.954,
															16.845
														],
														[
															-4.707,
															19.293
														],
														[
															-1.275,
															12.063
														],
														[
															-0.332,
															12.02
														],
														[
															0.603,
															11.847
														],
														[
															1.357,
															11.121
														],
														[
															1.993,
															10.802
														],
														[
															2.434,
															10.198
														],
														[
															2.111,
															6.068
														],
														[
															2.663,
															6.178
														],
														[
															1.386,
															3.235
														],
														[
															1.291,
															2.497
														],
														[
															1.112,
															2.13
														],
														[
															0.931,
															2.204
														],
														[
															0.483,
															0.851
														],
														[
															0.759,
															0.837
														],
														[
															0.688,
															1.144
														],
														[
															0.419,
															1.205
														],
														[
															0.19,
															0.311
														],
														[
															0.388,
															0.323
														],
														[
															0.339,
															0.524
														],
														[
															0.34,
															0.502
														],
														[
															0.927,
															1.452
														],
														[
															1.059,
															1.919
														],
														[
															1.096,
															1.144
														],
														[
															1.004,
															1.168
														],
														[
															2.677,
															3.555
														],
														[
															2.6,
															3.516
														],
														[
															2.919,
															3.373
														],
														[
															3.177,
															3.128
														],
														[
															3.613,
															3.335
														],
														[
															3.993,
															3.22
														],
														[
															2.9,
															2.365
														],
														[
															3.241,
															2.055
														],
														[
															0.348,
															0.157
														],
														[
															3.819,
															2.224
														],
														[
															16.444,
															8.107
														],
														[
															5.891,
															0.88
														],
														[
															5.672,
															0.422
														],
														[
															5.972,
															-0.2
														],
														[
															6.454,
															-1.924
														],
														[
															0.324,
															-0.401
														],
														[
															0.968,
															-0.602
														],
														[
															4.284,
															-2.033
														],
														[
															33.419,
															-9.275
														],
														[
															53.447,
															-45.817
														],
														[
															9.52,
															-38.676
														],
														[
															-3.404,
															-51.947
														],
														[
															-11.671,
															-27.693
														],
														[
															-10.464,
															-13.882
														],
														[
															-2.997,
															-2.845
														],
														[
															-0.853,
															-0.701
														],
														[
															-0.834,
															-0.583
														],
														[
															-0.864,
															-0.68
														],
														[
															-0.834,
															-0.583
														],
														[
															-1.58,
															-1.173
														],
														[
															-2.33,
															-2.232
														],
														[
															-1.743,
															-1.155
														],
														[
															-0.334,
															-0.151
														],
														[
															-1.96,
															-1.239
														],
														[
															-3.905,
															-2.303
														],
														[
															-5.756,
															-2.96
														],
														[
															-7.471,
															-2.84
														],
														[
															-19.554,
															-5.142
														],
														[
															-0.625,
															0.043
														]
													],
													"v": [
														[
															344,
															16
														],
														[
															311.386,
															21.111
														],
														[
															282,
															31
														],
														[
															256.375,
															43.988
														],
														[
															234,
															59
														],
														[
															227.518,
															64.197
														],
														[
															222,
															69
														],
														[
															217.892,
															72.591
														],
														[
															214,
															76
														],
														[
															206.614,
															83.137
														],
														[
															200,
															90
														],
														[
															197.984,
															92.985
														],
														[
															196,
															96
														],
														[
															191.39,
															101.017
														],
														[
															187,
															106
														],
														[
															178.588,
															117.11
														],
														[
															171,
															128
														],
														[
															168.789,
															131.974
														],
														[
															167,
															135
														],
														[
															166.005,
															136.495
														],
														[
															165,
															138
														],
														[
															160.528,
															144.323
														],
														[
															157,
															151
														],
														[
															147.942,
															168.659
														],
														[
															140,
															186
														],
														[
															137.848,
															191.31
														],
														[
															136,
															196
														],
														[
															118.448,
															250.397
														],
														[
															108,
															311
														],
														[
															105.591,
															347.154
														],
														[
															106,
															383
														],
														[
															108.976,
															417.383
														],
														[
															114,
															450
														],
														[
															120.541,
															481.546
														],
														[
															129,
															511
														],
														[
															136.405,
															529.636
														],
														[
															144,
															547
														],
														[
															147.952,
															555.343
														],
														[
															152,
															563
														],
														[
															154.961,
															569.558
														],
														[
															158,
															576
														],
														[
															160.001,
															578.539
														],
														[
															162,
															581
														],
														[
															163.54,
															584.579
														],
														[
															165,
															588
														],
														[
															165.951,
															588.936
														],
														[
															167,
															590
														],
														[
															168.03,
															591.541
														],
														[
															169,
															593
														],
														[
															172.069,
															598.435
														],
														[
															175,
															603
														],
														[
															178.155,
															606.471
														],
														[
															181,
															610
														],
														[
															188.813,
															620.631
														],
														[
															197,
															631
														],
														[
															206.158,
															640.694
														],
														[
															216,
															650
														],
														[
															227.65,
															659.913
														],
														[
															239,
															669
														],
														[
															248.324,
															675.714
														],
														[
															258,
															681
														],
														[
															259,
															683
														],
														[
															272,
															689
														],
														[
															329,
															708
														],
														[
															347,
															709
														],
														[
															365,
															710
														],
														[
															383,
															709
														],
														[
															393,
															698
														],
														[
															394,
															695
														],
														[
															398,
															695
														],
														[
															412,
															691
														],
														[
															495,
															647
														],
														[
															602,
															462
														],
														[
															614,
															330
														],
														[
															583,
															188
														],
														[
															540,
															112
														],
														[
															505,
															74
														],
														[
															496,
															65
														],
														[
															493,
															64
														],
														[
															491,
															61
														],
														[
															488,
															60
														],
														[
															486,
															57
														],
														[
															482,
															55
														],
														[
															475,
															50
														],
														[
															471,
															48
														],
														[
															470,
															46
														],
														[
															463,
															43
														],
														[
															452,
															36
														],
														[
															433,
															28
														],
														[
															412,
															21
														],
														[
															345,
															15
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 91,
											"s": [
												{
													"i": [
														[
															-0.054,
															0.004
														],
														[
															3.621,
															-0.364
														],
														[
															3.316,
															-0.471
														],
														[
															3.162,
															-0.621
														],
														[
															3.16,
															-0.815
														],
														[
															1.851,
															-0.628
														],
														[
															1.812,
															-0.704
														],
														[
															1.806,
															-0.724
														],
														[
															1.83,
															-0.688
														],
														[
															11.204,
															-6.703
														],
														[
															9.707,
															-8.176
														],
														[
															8.4,
															-9.26
														],
														[
															7.282,
															-9.955
														],
														[
															0.46,
															-0.673
														],
														[
															0.445,
															-0.652
														],
														[
															0.388,
															-0.528
														],
														[
															0.288,
															-0.3
														],
														[
															0.206,
															-0.35
														],
														[
															0.207,
															-0.351
														],
														[
															0.272,
															-0.283
														],
														[
															0.066,
															-0.267
														],
														[
															0.349,
															-0.529
														],
														[
															1.871,
															-2.829
														],
														[
															1.588,
															-2.755
														],
														[
															3.194,
															-6.593
														],
														[
															2.682,
															-6.485
														],
														[
															0.504,
															-1.151
														],
														[
															0.49,
															-1.201
														],
														[
															5.657,
															-31.05
														],
														[
															-1.599,
															-34.364
														],
														[
															-4.514,
															-21.566
														],
														[
															-6.835,
															-18.89
														],
														[
															-17.268,
															-24.949
														],
														[
															-22.904,
															-17.741
														],
														[
															-0.782,
															-0.571
														],
														[
															-0.218,
															-0.208
														],
														[
															-0.292,
															-0.077
														],
														[
															-0.463,
															-0.338
														],
														[
															-0.79,
															-0.921
														],
														[
															-0.923,
															-0.644
														],
														[
															-1.089,
															-0.473
														],
														[
															-0.86,
															-0.558
														],
														[
															-1.971,
															-1.38
														],
														[
															-1.93,
															-1.061
														],
														[
															-1.178,
															-0.437
														],
														[
															-1.138,
															-0.622
														],
														[
															-0.803,
															-0.759
														],
														[
															-0.937,
															-0.5
														],
														[
															-1.18,
															-0.468
														],
														[
															-1.19,
															-0.545
														],
														[
															-16.587,
															-3.725
														],
														[
															-18.19,
															0.61
														],
														[
															-3.42,
															0.076
														],
														[
															-2.077,
															0.586
														],
														[
															-1.405,
															2.298
														],
														[
															-1.874,
															1.82
														],
														[
															-0.736,
															0.441
														],
														[
															-1.336,
															0.535
														],
														[
															-1.444,
															0.084
														],
														[
															-1.184,
															0.246
														],
														[
															-3.724,
															1.019
														],
														[
															-3.337,
															1.14
														],
														[
															-21.843,
															17.671
														],
														[
															-14.956,
															21.86
														],
														[
															-1.363,
															2.134
														],
														[
															-0.976,
															2.167
														],
														[
															-0.451,
															0.163
														],
														[
															-0.123,
															0.185
														],
														[
															0.067,
															0.379
														],
														[
															-0.115,
															0.255
														],
														[
															-0.451,
															0.159
														],
														[
															-0.121,
															0.196
														],
														[
															-0.468,
															1.03
														],
														[
															-0.606,
															1.038
														],
														[
															-3.4,
															6.705
														],
														[
															-2.647,
															6.744
														],
														[
															-2.478,
															6.36
														],
														[
															-1.881,
															5.94
														],
														[
															-1.197,
															3.612
														],
														[
															-0.935,
															3.524
														],
														[
															-1.806,
															10.559
														],
														[
															-1.222,
															11.13
														],
														[
															-0.161,
															12.042
														],
														[
															0.88,
															12.562
														],
														[
															13.645,
															36.324
														],
														[
															22.236,
															27.303
														],
														[
															13.293,
															11.33
														],
														[
															16.821,
															9.162
														],
														[
															20.319,
															4.951
														],
														[
															24.618,
															-1.576
														],
														[
															0.185,
															-0.246
														]
													],
													"o": [
														[
															-4.077,
															0.302
														],
														[
															-3.621,
															0.364
														],
														[
															-3.316,
															0.471
														],
														[
															-3.162,
															0.621
														],
														[
															-1.92,
															0.495
														],
														[
															-1.851,
															0.628
														],
														[
															-1.812,
															0.704
														],
														[
															-1.806,
															0.724
														],
														[
															-12.889,
															4.842
														],
														[
															-11.204,
															6.703
														],
														[
															-9.707,
															8.176
														],
														[
															-8.4,
															9.26
														],
														[
															-0.432,
															0.591
														],
														[
															-0.46,
															0.673
														],
														[
															-0.445,
															0.652
														],
														[
															-0.388,
															0.528
														],
														[
															-0.268,
															0.279
														],
														[
															-0.206,
															0.35
														],
														[
															-0.207,
															0.351
														],
														[
															-0.385,
															0.403
														],
														[
															-0.066,
															0.267
														],
														[
															-1.928,
															2.928
														],
														[
															-1.871,
															2.829
														],
														[
															-3.541,
															6.142
														],
														[
															-3.194,
															6.593
														],
														[
															-0.494,
															1.195
														],
														[
															-0.504,
															1.151
														],
														[
															-9.971,
															24.438
														],
														[
															-5.657,
															31.05
														],
														[
															1.109,
															23.846
														],
														[
															4.514,
															21.566
														],
														[
															11.023,
															30.462
														],
														[
															17.268,
															24.949
														],
														[
															0.654,
															0.506
														],
														[
															0.782,
															0.571
														],
														[
															0.37,
															0.354
														],
														[
															0.292,
															0.077
														],
														[
															0.918,
															0.67
														],
														[
															0.79,
															0.921
														],
														[
															0.786,
															0.549
														],
														[
															1.088,
															0.473
														],
														[
															2.184,
															1.418
														],
														[
															1.971,
															1.38
														],
														[
															1.148,
															0.63
														],
														[
															1.178,
															0.437
														],
														[
															0.85,
															0.464
														],
														[
															0.803,
															0.759
														],
														[
															1.09,
															0.581
														],
														[
															1.18,
															0.468
														],
														[
															12.46,
															5.708
														],
														[
															16.587,
															3.725
														],
														[
															3.243,
															-0.109
														],
														[
															3.42,
															-0.076
														],
														[
															3.507,
															-0.989
														],
														[
															1.405,
															-2.298
														],
														[
															0.722,
															-0.702
														],
														[
															0.736,
															-0.441
														],
														[
															1.039,
															-0.417
														],
														[
															1.444,
															-0.084
														],
														[
															3.767,
															-0.782
														],
														[
															3.724,
															-1.019
														],
														[
															27.674,
															-9.457
														],
														[
															21.843,
															-17.671
														],
														[
															1.572,
															-2.298
														],
														[
															1.363,
															-2.134
														],
														[
															0.073,
															-0.162
														],
														[
															0.451,
															-0.163
														],
														[
															0.154,
															-0.23
														],
														[
															-0.067,
															-0.379
														],
														[
															0.076,
															-0.169
														],
														[
															0.451,
															-0.159
														],
														[
															0.521,
															-0.841
														],
														[
															0.468,
															-1.03
														],
														[
															3.754,
															-6.435
														],
														[
															3.4,
															-6.705
														],
														[
															2.206,
															-5.621
														],
														[
															2.478,
															-6.36
														],
														[
															1.276,
															-4.029
														],
														[
															1.197,
															-3.612
														],
														[
															2.554,
															-9.634
														],
														[
															1.806,
															-10.559
														],
														[
															1.237,
															-11.269
														],
														[
															0.161,
															-12.042
														],
														[
															-3.183,
															-45.4
														],
														[
															-13.645,
															-36.324
														],
														[
															-11.009,
															-13.517
														],
														[
															-13.293,
															-11.33
														],
														[
															-16.105,
															-8.772
														],
														[
															-20.319,
															-4.951
														],
														[
															-0.313,
															0.02
														],
														[
															-0.185,
															0.246
														]
													],
													"v": [
														[
															344,
															16
														],
														[
															332.492,
															16.988
														],
														[
															322.125,
															18.229
														],
														[
															312.446,
															19.856
														],
														[
															303,
															22
														],
														[
															297.352,
															23.699
														],
														[
															291.865,
															25.712
														],
														[
															286.446,
															27.868
														],
														[
															281,
															30
														],
														[
															244.907,
															47.415
														],
														[
															213.588,
															69.831
														],
														[
															186.475,
															96.081
														],
														[
															163,
															125
														],
														[
															161.651,
															126.922
														],
														[
															160.284,
															128.936
														],
														[
															159.024,
															130.732
														],
														[
															158,
															132
														],
														[
															157.306,
															132.961
														],
														[
															156.702,
															134.031
														],
														[
															156,
															135
														],
														[
															155.473,
															135.905
														],
														[
															155,
															137
														],
														[
															149.245,
															145.629
														],
														[
															144,
															154
														],
														[
															133.856,
															173.243
														],
														[
															125,
															193
														],
														[
															123.497,
															196.496
														],
														[
															122,
															200
														],
														[
															97.823,
															284.055
														],
														[
															91,
															383
														],
														[
															99.706,
															451.217
														],
														[
															117,
															512
														],
														[
															159.59,
															595.541
														],
														[
															220,
															660
														],
														[
															222.327,
															661.724
														],
														[
															224,
															663
														],
														[
															224.931,
															663.512
														],
														[
															226,
															664
														],
														[
															228.496,
															666.519
														],
														[
															231,
															669
														],
														[
															233.945,
															670.493
														],
														[
															237,
															672
														],
														[
															243.19,
															676.268
														],
														[
															249,
															680
														],
														[
															252.507,
															681.506
														],
														[
															256,
															683
														],
														[
															258.434,
															684.973
														],
														[
															261,
															687
														],
														[
															264.425,
															688.527
														],
														[
															268,
															690
														],
														[
															312.202,
															704.738
														],
														[
															365,
															710
														],
														[
															375.374,
															709.858
														],
														[
															384,
															709
														],
														[
															390.725,
															703.623
														],
														[
															395,
															697
														],
														[
															397.04,
															695.375
														],
														[
															400,
															694
														],
														[
															403.892,
															693.372
														],
														[
															408,
															693
														],
														[
															419.322,
															690.269
														],
														[
															430,
															687
														],
														[
															504.539,
															645.302
														],
														[
															560,
															585
														],
														[
															564.447,
															578.401
														],
														[
															568,
															572
														],
														[
															568.962,
															571.517
														],
														[
															570,
															571
														],
														[
															570.029,
															570.019
														],
														[
															570,
															569
														],
														[
															570.966,
															568.52
														],
														[
															572,
															568
														],
														[
															573.436,
															565.149
														],
														[
															575,
															562
														],
														[
															585.83,
															542.232
														],
														[
															595,
															522
														],
														[
															602.243,
															503.739
														],
														[
															609,
															485
														],
														[
															612.756,
															473.621
														],
														[
															616,
															463
														],
														[
															622.499,
															432.622
														],
														[
															627,
															400
														],
														[
															629.088,
															364.97
														],
														[
															628,
															328
														],
														[
															602.29,
															205.427
														],
														[
															548,
															110
														],
														[
															511.859,
															72.733
														],
														[
															467,
															42
														],
														[
															412.385,
															20.739
														],
														[
															345,
															15
														],
														[
															344.224,
															15.518
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 92,
											"s": [
												{
													"i": [
														[
															-0.109,
															0.008
														],
														[
															0.335,
															0.006
														],
														[
															0.33,
															0
														],
														[
															11.016,
															-2.543
														],
														[
															9.899,
															-3.813
														],
														[
															21.689,
															-18.135
														],
														[
															15.471,
															-22.377
														],
														[
															7.069,
															-13.765
														],
														[
															5.527,
															-14.085
														],
														[
															1.493,
															-5.05
														],
														[
															1.094,
															-4.871
														],
														[
															0.472,
															-0.637
														],
														[
															0.07,
															-0.264
														],
														[
															1.803,
															-9.873
														],
														[
															1.278,
															-9.93
														],
														[
															-3.881,
															-32.872
														],
														[
															-8.992,
															-25.411
														],
														[
															-0.527,
															-1.137
														],
														[
															-0.454,
															-1.211
														],
														[
															-0.269,
															-1.396
														],
														[
															-0.462,
															-1.185
														],
														[
															-1.057,
															-2.186
														],
														[
															-0.949,
															-2.14
														],
														[
															-2.144,
															-4.458
														],
														[
															-2.218,
															-4.188
														],
														[
															-0.702,
															-0.962
														],
														[
															-0.63,
															-1.091
														],
														[
															-0.448,
															-1.233
														],
														[
															-0.618,
															-1.046
														],
														[
															-0.749,
															-0.838
														],
														[
															-0.499,
															-0.792
														],
														[
															0.067,
															-0.375
														],
														[
															-0.118,
															-0.26
														],
														[
															-0.451,
															-0.163
														],
														[
															-0.124,
															-0.185
														],
														[
															0.067,
															-0.379
														],
														[
															-0.115,
															-0.255
														],
														[
															-0.451,
															-0.162
														],
														[
															-0.123,
															-0.187
														],
														[
															0.067,
															-0.378
														],
														[
															-0.115,
															-0.256
														],
														[
															-0.451,
															-0.163
														],
														[
															-0.124,
															-0.185
														],
														[
															0.067,
															-0.379
														],
														[
															-0.115,
															-0.255
														],
														[
															-0.451,
															-0.163
														],
														[
															-0.124,
															-0.185
														],
														[
															0.067,
															-0.379
														],
														[
															-0.115,
															-0.255
														],
														[
															-0.451,
															-0.163
														],
														[
															-0.124,
															-0.185
														],
														[
															0.067,
															-0.379
														],
														[
															-0.115,
															-0.255
														],
														[
															-0.451,
															-0.167
														],
														[
															-0.124,
															-0.177
														],
														[
															-2.809,
															-3.886
														],
														[
															-2.992,
															-3.514
														],
														[
															-14.561,
															-11.811
														],
														[
															-18.149,
															-9.125
														],
														[
															-22.739,
															-4.551
														],
														[
															-12.357,
															-0.782
														],
														[
															-10.44,
															2.457
														],
														[
															-2.272,
															1.223
														],
														[
															-1.09,
															0.471
														],
														[
															-2.212,
															0.473
														],
														[
															-7.553,
															2.429
														],
														[
															-11.051,
															7.161
														],
														[
															-3.056,
															1.764
														],
														[
															-1.994,
															1.257
														],
														[
															-0.52,
															0.235
														],
														[
															-0.37,
															0.247
														],
														[
															-0.511,
															0.23
														],
														[
															-0.375,
															0.246
														],
														[
															-1.716,
															1.162
														],
														[
															-2.058,
															1.679
														],
														[
															-2.421,
															1.964
														],
														[
															-1.573,
															1.37
														],
														[
															-2.155,
															1.679
														],
														[
															-0.788,
															0.746
														],
														[
															-5.144,
															6.003
														],
														[
															-1.504,
															1.75
														],
														[
															-0.675,
															0.966
														],
														[
															-0.654,
															0.819
														],
														[
															-15.001,
															54.158
														],
														[
															3.768,
															52.604
														],
														[
															38.168,
															51.159
														],
														[
															2.789,
															3.329
														],
														[
															3.051,
															3.661
														],
														[
															4.185,
															3.924
														],
														[
															7.102,
															5.569
														],
														[
															75.809,
															-4.853
														]
													],
													"o": [
														[
															-0.329,
															0.024
														],
														[
															-0.335,
															-0.006
														],
														[
															-11.036,
															0.016
														],
														[
															-11.016,
															2.543
														],
														[
															-28.775,
															11.084
														],
														[
															-21.689,
															18.135
														],
														[
															-8.197,
															11.856
														],
														[
															-7.069,
															13.765
														],
														[
															-1.934,
															4.927
														],
														[
															-1.493,
															5.05
														],
														[
															-0.042,
															0.188
														],
														[
															-0.472,
															0.637
														],
														[
															-2.51,
															9.577
														],
														[
															-1.803,
															9.873
														],
														[
															-4.515,
															35.102
														],
														[
															3.881,
															32.872
														],
														[
															0.439,
															1.24
														],
														[
															0.527,
															1.137
														],
														[
															0.462,
															1.231
														],
														[
															0.269,
															1.396
														],
														[
															0.825,
															2.115
														],
														[
															1.057,
															2.186
														],
														[
															2.208,
															4.979
														],
														[
															2.144,
															4.458
														],
														[
															0.563,
															1.062
														],
														[
															0.702,
															0.962
														],
														[
															0.59,
															1.022
														],
														[
															0.448,
															1.233
														],
														[
															0.507,
															0.858
														],
														[
															0.749,
															0.838
														],
														[
															0.15,
															0.239
														],
														[
															-0.067,
															0.375
														],
														[
															0.073,
															0.162
														],
														[
															0.451,
															0.163
														],
														[
															0.154,
															0.23
														],
														[
															-0.067,
															0.379
														],
														[
															0.073,
															0.163
														],
														[
															0.451,
															0.162
														],
														[
															0.153,
															0.233
														],
														[
															-0.067,
															0.378
														],
														[
															0.073,
															0.162
														],
														[
															0.451,
															0.163
														],
														[
															0.154,
															0.23
														],
														[
															-0.067,
															0.379
														],
														[
															0.073,
															0.162
														],
														[
															0.451,
															0.163
														],
														[
															0.154,
															0.23
														],
														[
															-0.067,
															0.379
														],
														[
															0.073,
															0.162
														],
														[
															0.451,
															0.163
														],
														[
															0.154,
															0.23
														],
														[
															-0.067,
															0.379
														],
														[
															0.07,
															0.157
														],
														[
															0.451,
															0.167
														],
														[
															2.772,
															3.943
														],
														[
															2.809,
															3.886
														],
														[
															11.608,
															13.632
														],
														[
															14.561,
															11.811
														],
														[
															15.786,
															7.937
														],
														[
															11.787,
															2.359
														],
														[
															13.028,
															0.824
														],
														[
															4.053,
															-0.954
														],
														[
															1.04,
															-0.56
														],
														[
															1.933,
															-0.836
														],
														[
															8.47,
															-1.811
														],
														[
															15.077,
															-4.848
														],
														[
															3.175,
															-2.058
														],
														[
															1.817,
															-1.049
														],
														[
															0.478,
															-0.301
														],
														[
															0.324,
															-0.146
														],
														[
															0.46,
															-0.307
														],
														[
															0.327,
															-0.147
														],
														[
															1.881,
															-1.237
														],
														[
															2.979,
															-2.017
														],
														[
															3.128,
															-2.552
														],
														[
															1.685,
															-1.367
														],
														[
															2.717,
															-2.367
														],
														[
															0.838,
															-0.652
														],
														[
															6.436,
															-6.091
														],
														[
															1.561,
															-1.822
														],
														[
															0.721,
															-0.839
														],
														[
															0.582,
															-0.833
														],
														[
															29.977,
															-37.511
														],
														[
															10.904,
															-39.366
														],
														[
															-5.937,
															-82.875
														],
														[
															-3.083,
															-4.132
														],
														[
															-3.739,
															-4.463
														],
														[
															-3.752,
															-4.503
														],
														[
															-6.637,
															-6.224
														],
														[
															-41.254,
															-32.349
														],
														[
															-0.627,
															0.04
														]
													],
													"v": [
														[
															343,
															16
														],
														[
															342.001,
															16.018
														],
														[
															341,
															16
														],
														[
															307.648,
															20.152
														],
														[
															276,
															30
														],
														[
															200.522,
															74.53
														],
														[
															145,
															136
														],
														[
															121.998,
															174.828
														],
														[
															103,
															217
														],
														[
															97.87,
															232.042
														],
														[
															94,
															247
														],
														[
															93.021,
															248.442
														],
														[
															92,
															250
														],
														[
															85.576,
															279.236
														],
														[
															81,
															309
														],
														[
															80.87,
															412.269
														],
														[
															101,
															501
														],
														[
															102.488,
															504.522
														],
														[
															104,
															508
														],
														[
															105,
															512.034
														],
														[
															106,
															516
														],
														[
															108.907,
															522.481
														],
														[
															112,
															529
														],
														[
															118.492,
															543.094
														],
														[
															125,
															556
														],
														[
															126.95,
															558.979
														],
														[
															129,
															562
														],
														[
															130.479,
															565.481
														],
														[
															132,
															569
														],
														[
															134.006,
															571.55
														],
														[
															136,
															574
														],
														[
															136.025,
															574.984
														],
														[
															136,
															576
														],
														[
															136.962,
															576.483
														],
														[
															138,
															577
														],
														[
															138.029,
															577.981
														],
														[
															138,
															579
														],
														[
															138.963,
															579.482
														],
														[
															140,
															580
														],
														[
															140.028,
															580.982
														],
														[
															140,
															582
														],
														[
															140.962,
															582.483
														],
														[
															142,
															583
														],
														[
															142.029,
															583.981
														],
														[
															142,
															585
														],
														[
															142.962,
															585.483
														],
														[
															144,
															586
														],
														[
															144.029,
															586.981
														],
														[
															144,
															588
														],
														[
															144.962,
															588.483
														],
														[
															146,
															589
														],
														[
															146.029,
															589.981
														],
														[
															146,
															591
														],
														[
															146.96,
															591.485
														],
														[
															148,
															592
														],
														[
															156.335,
															603.822
														],
														[
															165,
															615
														],
														[
															204.094,
															653.381
														],
														[
															253,
															685
														],
														[
															312,
															705
														],
														[
															348,
															709
														],
														[
															388,
															708
														],
														[
															397,
															695
														],
														[
															401,
															695
														],
														[
															408,
															693
														],
														[
															431,
															687
														],
														[
															474,
															669
														],
														[
															484,
															664
														],
														[
															489,
															660
														],
														[
															491,
															660
														],
														[
															492,
															658
														],
														[
															494,
															658
														],
														[
															495,
															656
														],
														[
															501,
															653
														],
														[
															509,
															647
														],
														[
															517,
															640
														],
														[
															522,
															636
														],
														[
															530,
															630
														],
														[
															532,
															627
														],
														[
															551,
															608
														],
														[
															556,
															603
														],
														[
															557,
															600
														],
														[
															560,
															598
														],
														[
															627,
															465
														],
														[
															641,
															328
														],
														[
															569,
															125
														],
														[
															560,
															114
														],
														[
															549,
															101
														],
														[
															537,
															89
														],
														[
															517,
															71
														],
														[
															344,
															15
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 93,
											"s": [
												{
													"i": [
														[
															-0.112,
															0.008
														],
														[
															0.336,
															0.004
														],
														[
															0.328,
															0.008
														],
														[
															12.421,
															-2.997
														],
														[
															8.425,
															-3.306
														],
														[
															8.57,
															-4.158
														],
														[
															7.318,
															-4.68
														],
														[
															13.597,
															-13.1
														],
														[
															11.207,
															-15.469
														],
														[
															5.217,
															-8.309
														],
														[
															4.563,
															-9.076
														],
														[
															3.844,
															-9.725
														],
														[
															3.212,
															-10.322
														],
														[
															2.85,
															-23.864
														],
														[
															-0.983,
															-24.385
														],
														[
															-5.237,
															-21.918
														],
														[
															-8.037,
															-19.166
														],
														[
															-1.93,
															-4.721
														],
														[
															-2.304,
															-4.403
														],
														[
															-1.95,
															-3.318
														],
														[
															-1.564,
															-2.601
														],
														[
															-6.455,
															-8.827
														],
														[
															-7.35,
															-7.996
														],
														[
															-17.193,
															-12.739
														],
														[
															-20.408,
															-8.008
														],
														[
															-0.481,
															-0.393
														],
														[
															-0.48,
															-0.192
														],
														[
															-1.355,
															-0.257
														],
														[
															-1.385,
															-0.493
														],
														[
															-1.165,
															-0.55
														],
														[
															-1.176,
															-0.385
														],
														[
															-8.492,
															-1.884
														],
														[
															-8.33,
															-0.946
														],
														[
															-3.181,
															-0.116
														],
														[
															-3.204,
															-0.186
														],
														[
															-7.278,
															0.032
														],
														[
															-5.331,
															1.255
														],
														[
															-1.566,
															3.027
														],
														[
															-0.819,
															0.441
														],
														[
															-0.733,
															-0.128
														],
														[
															-0.547,
															0.232
														],
														[
															-2.718,
															0.333
														],
														[
															-2.635,
															0.608
														],
														[
															-7.148,
															2.608
														],
														[
															-6.459,
															2.735
														],
														[
															-5.31,
															2.658
														],
														[
															-4.794,
															2.842
														],
														[
															-1.336,
															0.65
														],
														[
															-1.234,
															0.557
														],
														[
															-0.163,
															0.451
														],
														[
															-0.185,
															0.123
														],
														[
															-0.379,
															-0.067
														],
														[
															-0.255,
															0.115
														],
														[
															-0.163,
															0.451
														],
														[
															-0.185,
															0.123
														],
														[
															-0.511,
															0.23
														],
														[
															-0.37,
															0.247
														],
														[
															-0.511,
															0.23
														],
														[
															-0.354,
															0.248
														],
														[
															-1.575,
															1.166
														],
														[
															-1.933,
															1.477
														],
														[
															-3.364,
															2.864
														],
														[
															-6.304,
															6.83
														],
														[
															-3.058,
															3.292
														],
														[
															-2.885,
															3.528
														],
														[
															-0.567,
															0.728
														],
														[
															-0.683,
															0.847
														],
														[
															-0.212,
															0.47
														],
														[
															-0.246,
															0.295
														],
														[
															-2.549,
															2.661
														],
														[
															-1.527,
															2.232
														],
														[
															-11.696,
															38.801
														],
														[
															4.291,
															53.805
														],
														[
															16.609,
															38.362
														],
														[
															4.139,
															8.05
														],
														[
															2.788,
															6.185
														],
														[
															0.247,
															0.37
														],
														[
															0.23,
															0.511
														],
														[
															0.246,
															0.375
														],
														[
															1.257,
															1.936
														],
														[
															1.589,
															1.659
														],
														[
															0.676,
															0.925
														],
														[
															1.38,
															1.825
														],
														[
															0.603,
															0.774
														],
														[
															0.683,
															0.847
														],
														[
															0.212,
															0.47
														],
														[
															0.675,
															0.806
														],
														[
															1.622,
															1.838
														],
														[
															1.652,
															1.804
														],
														[
															45.635,
															16.148
														],
														[
															38.912,
															-2.286
														]
													],
													"o": [
														[
															-0.327,
															0.023
														],
														[
															-0.336,
															-0.004
														],
														[
															-11.893,
															-0.296
														],
														[
															-12.42,
															2.997
														],
														[
															-9.403,
															3.689
														],
														[
															-8.57,
															4.158
														],
														[
															-17.404,
															11.129
														],
														[
															-13.597,
															13.1
														],
														[
															-5.57,
															7.688
														],
														[
															-5.217,
															8.309
														],
														[
															-4.413,
															8.779
														],
														[
															-3.844,
															9.725
														],
														[
															-6.584,
															21.16
														],
														[
															-2.85,
															23.864
														],
														[
															1.015,
															25.161
														],
														[
															5.237,
															21.918
														],
														[
															1.977,
															4.715
														],
														[
															1.93,
															4.721
														],
														[
															1.637,
															3.128
														],
														[
															1.95,
															3.318
														],
														[
															5.831,
															9.695
														],
														[
															6.455,
															8.827
														],
														[
															13.82,
															15.035
														],
														[
															17.193,
															12.739
														],
														[
															0.598,
															0.235
														],
														[
															0.48,
															0.393
														],
														[
															1.196,
															0.48
														],
														[
															1.355,
															0.257
														],
														[
															1.163,
															0.413
														],
														[
															1.165,
															0.55
														],
														[
															7.701,
															2.517
														],
														[
															8.492,
															1.884
														],
														[
															3.071,
															0.349
														],
														[
															3.181,
															0.116
														],
														[
															6.558,
															0.38
														],
														[
															7.278,
															-0.031
														],
														[
															1.917,
															-0.451
														],
														[
															1.566,
															-3.027
														],
														[
															0.519,
															-0.28
														],
														[
															0.733,
															0.128
														],
														[
															2.495,
															-1.06
														],
														[
															2.718,
															-0.333
														],
														[
															7.95,
															-1.834
														],
														[
															7.148,
															-2.608
														],
														[
															5.968,
															-2.527
														],
														[
															5.31,
															-2.658
														],
														[
															1.421,
															-0.842
														],
														[
															1.336,
															-0.65
														],
														[
															0.162,
															-0.073
														],
														[
															0.163,
															-0.451
														],
														[
															0.23,
															-0.154
														],
														[
															0.379,
															0.067
														],
														[
															0.162,
															-0.073
														],
														[
															0.163,
															-0.451
														],
														[
															0.46,
															-0.307
														],
														[
															0.324,
															-0.146
														],
														[
															0.46,
															-0.307
														],
														[
															0.314,
															-0.142
														],
														[
															1.771,
															-1.241
														],
														[
															2.064,
															-1.528
														],
														[
															3.663,
															-2.799
														],
														[
															7.119,
															-6.061
														],
														[
															3.04,
															-3.294
														],
														[
															3.113,
															-3.351
														],
														[
															0.64,
															-0.783
														],
														[
															0.656,
															-0.842
														],
														[
															0.316,
															-0.392
														],
														[
															0.124,
															-0.274
														],
														[
															3.158,
															-3.789
														],
														[
															2.17,
															-2.265
														],
														[
															20.548,
															-30.033
														],
														[
															11.806,
															-39.166
														],
														[
															-3.661,
															-45.899
														],
														[
															-3.893,
															-8.993
														],
														[
															-3.478,
															-6.764
														],
														[
															-0.146,
															-0.324
														],
														[
															-0.307,
															-0.46
														],
														[
															-0.147,
															-0.327
														],
														[
															-1.228,
															-1.867
														],
														[
															-1.933,
															-2.975
														],
														[
															-0.709,
															-0.74
														],
														[
															-1.235,
															-1.692
														],
														[
															-0.656,
															-0.868
														],
														[
															-0.656,
															-0.842
														],
														[
															-0.316,
															-0.392
														],
														[
															-0.48,
															-1.065
														],
														[
															-1.536,
															-1.834
														],
														[
															-1.519,
															-1.72
														],
														[
															-28.297,
															-30.909
														],
														[
															-28.984,
															-10.256
														],
														[
															-0.628,
															0.037
														]
													],
													"v": [
														[
															343,
															16
														],
														[
															342,
															16.023
														],
														[
															341,
															16
														],
														[
															303.399,
															20.799
														],
														[
															271,
															31
														],
														[
															243.937,
															42.758
														],
														[
															220,
															56
														],
														[
															173.853,
															92.244
														],
														[
															137,
															135
														],
														[
															120.745,
															158.959
														],
														[
															106,
															185
														],
														[
															93.599,
															212.842
														],
														[
															83,
															243
														],
														[
															68.825,
															311.082
														],
														[
															66,
															384
														],
														[
															75.733,
															454.496
														],
														[
															96,
															516
														],
														[
															101.754,
															530.234
														],
														[
															108,
															544
														],
														[
															113.555,
															553.895
														],
														[
															119,
															563
														],
														[
															137.361,
															590.774
														],
														[
															158,
															616
														],
														[
															204.559,
															658.271
														],
														[
															261,
															690
														],
														[
															262.589,
															691.032
														],
														[
															264,
															692
														],
														[
															267.858,
															692.99
														],
														[
															272,
															694
														],
														[
															275.49,
															695.522
														],
														[
															279,
															697
														],
														[
															303.528,
															703.679
														],
														[
															329,
															708
														],
														[
															338.399,
															708.622
														],
														[
															348,
															709
														],
														[
															369.421,
															709.726
														],
														[
															389,
															708
														],
														[
															394.324,
															701.493
														],
														[
															398,
															695
														],
														[
															399.98,
															694.964
														],
														[
															402,
															695
														],
														[
															409.895,
															693.161
														],
														[
															418,
															692
														],
														[
															440.618,
															685.175
														],
														[
															461,
															677
														],
														[
															477.88,
															669.236
														],
														[
															493,
															661
														],
														[
															497.14,
															658.786
														],
														[
															501,
															657
														],
														[
															501.483,
															656.038
														],
														[
															502,
															655
														],
														[
															502.981,
															654.971
														],
														[
															504,
															655
														],
														[
															504.482,
															654.038
														],
														[
															505,
															653
														],
														[
															507,
															653
														],
														[
															508,
															651
														],
														[
															510,
															651
														],
														[
															511,
															649
														],
														[
															517,
															646
														],
														[
															522,
															641
														],
														[
															533,
															633
														],
														[
															553,
															614
														],
														[
															562,
															604
														],
														[
															572,
															594
														],
														[
															573,
															591
														],
														[
															576,
															589
														],
														[
															576,
															587
														],
														[
															578,
															586
														],
														[
															587,
															573
														],
														[
															592,
															566
														],
														[
															638,
															466
														],
														[
															653,
															327
														],
														[
															623,
															202
														],
														[
															611,
															176
														],
														[
															600,
															156
														],
														[
															598,
															155
														],
														[
															598,
															153
														],
														[
															596,
															152
														],
														[
															593,
															146
														],
														[
															586,
															136
														],
														[
															585,
															134
														],
														[
															580,
															129
														],
														[
															579,
															126
														],
														[
															576,
															124
														],
														[
															576,
															122
														],
														[
															572,
															118
														],
														[
															567,
															113
														],
														[
															563,
															107
														],
														[
															447,
															29
														],
														[
															344,
															15
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 94,
											"s": [
												{
													"i": [
														[
															-0.112,
															0.008
														],
														[
															0.336,
															0.004
														],
														[
															0.328,
															0.008
														],
														[
															6.01,
															-0.979
														],
														[
															5.983,
															-1.233
														],
														[
															7.778,
															-2.343
														],
														[
															6.803,
															-2.758
														],
														[
															5.561,
															-2.604
														],
														[
															4.921,
															-2.218
														],
														[
															0.155,
															-0.451
														],
														[
															0.206,
															-0.118
														],
														[
															0.667,
															-0.069
														],
														[
															0.668,
															-0.343
														],
														[
															0.48,
															-0.599
														],
														[
															0.551,
															-0.331
														],
														[
															1.556,
															-0.684
														],
														[
															0.554,
															-0.531
														],
														[
															0.539,
															-0.298
														],
														[
															0.425,
															-0.407
														],
														[
															0.539,
															-0.298
														],
														[
															0.425,
															-0.407
														],
														[
															0.27,
															-0.067
														],
														[
															0.522,
															-0.348
														],
														[
															0.861,
															-0.97
														],
														[
															0.625,
															-0.499
														],
														[
															0.686,
															-0.256
														],
														[
															0.611,
															-0.46
														],
														[
															1.817,
															-1.515
														],
														[
															1.841,
															-1.512
														],
														[
															4.197,
															-3.728
														],
														[
															3.073,
															-3.688
														],
														[
															1.391,
															-1.298
														],
														[
															1.164,
															-1.279
														],
														[
															1.473,
															-1.855
														],
														[
															1.513,
															-1.831
														],
														[
															1.846,
															-2.226
														],
														[
															0.921,
															-2.044
														],
														[
															0.452,
															-0.168
														],
														[
															0.124,
															-0.173
														],
														[
															1.697,
															-2.597
														],
														[
															1.424,
															-2.129
														],
														[
															0.956,
															-1.612
														],
														[
															0.448,
															-0.468
														],
														[
															0.441,
															-0.86
														],
														[
															0.463,
															-0.753
														],
														[
															6.106,
															-12.891
														],
														[
															4.447,
															-13.83
														],
														[
															3.049,
															-24.376
														],
														[
															-1.097,
															-26.033
														],
														[
															-1.954,
															-11.856
														],
														[
															-2.65,
															-10.904
														],
														[
															-5.741,
															-14.925
														],
														[
															-7.063,
															-12.949
														],
														[
															-1.17,
															-2.143
														],
														[
															-0.946,
															-0.988
														],
														[
															-1.714,
															-3.802
														],
														[
															-0.247,
															-0.37
														],
														[
															-0.23,
															-0.511
														],
														[
															-0.247,
															-0.37
														],
														[
															-0.23,
															-0.511
														],
														[
															-0.247,
															-0.37
														],
														[
															-0.23,
															-0.511
														],
														[
															-0.249,
															-0.346
														],
														[
															-1.341,
															-1.817
														],
														[
															-2.987,
															-3.754
														],
														[
															-5.182,
															-5.182
														],
														[
															-40.444,
															-18.099
														],
														[
															-14.414,
															-3.608
														],
														[
															-10.959,
															-1.244
														],
														[
															-6.881,
															-0.361
														],
														[
															-9.929,
															3.228
														],
														[
															-2.024,
															1.939
														],
														[
															-1.351,
															1.579
														],
														[
															-0.997,
															0.537
														],
														[
															-1.099,
															0.446
														],
														[
															-5.278,
															1.128
														],
														[
															-15.134,
															6.259
														],
														[
															-6.63,
															3.511
														],
														[
															-27.988,
															38.262
														],
														[
															-10.942,
															35.866
														],
														[
															-1.933,
															7.29
														],
														[
															-1.265,
															5.836
														],
														[
															-0.958,
															5.558
														],
														[
															-0.742,
															6.108
														],
														[
															61.102,
															61.101
														],
														[
															4.481,
															4.081
														],
														[
															1.813,
															1.567
														],
														[
															4.21,
															1.898
														],
														[
															0.346,
															0.249
														],
														[
															22.652,
															10.328
														],
														[
															53.915,
															-3.167
														]
													],
													"o": [
														[
															-0.327,
															0.023
														],
														[
															-0.336,
															-0.004
														],
														[
															-5.975,
															-0.149
														],
														[
															-6.01,
															0.979
														],
														[
															-9.086,
															1.871
														],
														[
															-7.778,
															2.343
														],
														[
															-5.834,
															2.365
														],
														[
															-5.561,
															2.604
														],
														[
															-0.174,
															0.078
														],
														[
															-0.155,
															0.451
														],
														[
															-0.665,
															0.383
														],
														[
															-0.667,
															0.069
														],
														[
															-0.53,
															0.273
														],
														[
															-0.48,
															0.599
														],
														[
															-1.221,
															0.733
														],
														[
															-1.556,
															0.684
														],
														[
															-0.419,
															0.401
														],
														[
															-0.539,
															0.298
														],
														[
															-0.419,
															0.401
														],
														[
															-0.539,
															0.298
														],
														[
															-0.399,
															0.382
														],
														[
															-0.27,
															0.067
														],
														[
															-0.932,
															0.621
														],
														[
															-0.861,
															0.97
														],
														[
															-0.647,
															0.516
														],
														[
															-0.686,
															0.256
														],
														[
															-1.892,
															1.428
														],
														[
															-1.817,
															1.515
														],
														[
															-4.14,
															3.399
														],
														[
															-4.197,
															3.728
														],
														[
															-1.274,
															1.529
														],
														[
															-1.391,
															1.298
														],
														[
															-1.594,
															1.751
														],
														[
															-1.473,
															1.855
														],
														[
															-1.697,
															2.053
														],
														[
															-1.846,
															2.226
														],
														[
															-0.07,
															0.154
														],
														[
															-0.451,
															0.168
														],
														[
															-1.786,
															2.485
														],
														[
															-1.697,
															2.597
														],
														[
															-0.726,
															1.084
														],
														[
															-0.956,
															1.612
														],
														[
															-0.773,
															0.808
														],
														[
															-0.441,
															0.86
														],
														[
															-7.129,
															11.605
														],
														[
															-6.106,
															12.891
														],
														[
															-6.901,
															21.462
														],
														[
															-3.049,
															24.376
														],
														[
															0.534,
															12.673
														],
														[
															1.954,
															11.856
														],
														[
															3.974,
															16.349
														],
														[
															5.741,
															14.925
														],
														[
															1.146,
															2.101
														],
														[
															1.36,
															2.49
														],
														[
															3.5,
															3.653
														],
														[
															0.146,
															0.324
														],
														[
															0.307,
															0.46
														],
														[
															0.146,
															0.324
														],
														[
															0.307,
															0.46
														],
														[
															0.146,
															0.324
														],
														[
															0.307,
															0.46
														],
														[
															0.139,
															0.309
														],
														[
															1.402,
															1.951
														],
														[
															3.18,
															4.309
														],
														[
															4.867,
															6.117
														],
														[
															26.721,
															26.721
														],
														[
															13.368,
															5.982
														],
														[
															11.424,
															2.86
														],
														[
															6.653,
															0.755
														],
														[
															12.436,
															0.652
														],
														[
															3.766,
															-1.224
														],
														[
															1.021,
															-0.978
														],
														[
															1.383,
															-1.617
														],
														[
															1.037,
															-0.558
														],
														[
															4.997,
															-2.026
														],
														[
															18.765,
															-4.012
														],
														[
															7.611,
															-3.147
														],
														[
															43.148,
															-22.854
														],
														[
															20.393,
															-27.88
														],
														[
															2.577,
															-8.446
														],
														[
															1.462,
															-5.515
														],
														[
															1.148,
															-5.298
														],
														[
															0.981,
															-5.691
														],
														[
															15.464,
															-127.344
														],
														[
															-5.005,
															-5.005
														],
														[
															-1.864,
															-1.698
														],
														[
															-4.016,
															-3.47
														],
														[
															-0.309,
															-0.139
														],
														[
															-18.769,
															-13.49
														],
														[
															-36.058,
															-16.441
														],
														[
															-0.628,
															0.037
														]
													],
													"v": [
														[
															342,
															16
														],
														[
															341,
															16.023
														],
														[
															340,
															16
														],
														[
															322.006,
															17.464
														],
														[
															304,
															21
														],
														[
															278.788,
															27.335
														],
														[
															257,
															35
														],
														[
															239.816,
															42.61
														],
														[
															224,
															50
														],
														[
															223.524,
															50.97
														],
														[
															223,
															52
														],
														[
															221.002,
															52.53
														],
														[
															219,
															53
														],
														[
															217.516,
															54.457
														],
														[
															216,
															56
														],
														[
															211.5,
															58.151
														],
														[
															208,
															60
														],
														[
															206.505,
															60.995
														],
														[
															205,
															62
														],
														[
															203.505,
															62.995
														],
														[
															202,
															64
														],
														[
															201.092,
															64.526
														],
														[
															200,
															65
														],
														[
															197.27,
															67.592
														],
														[
															195,
															70
														],
														[
															192.973,
															71.042
														],
														[
															191,
															72
														],
														[
															185.462,
															76.437
														],
														[
															180,
															81
														],
														[
															167.2,
															91.784
														],
														[
															156,
															103
														],
														[
															151.917,
															107.188
														],
														[
															148,
															111
														],
														[
															143.439,
															116.44
														],
														[
															139,
															122
														],
														[
															133.419,
															128.506
														],
														[
															129,
															135
														],
														[
															128.041,
															135.486
														],
														[
															127,
															136
														],
														[
															121.729,
															143.767
														],
														[
															117,
															151
														],
														[
															114.292,
															155.462
														],
														[
															112,
															159
														],
														[
															110.267,
															161.541
														],
														[
															109,
															164
														],
														[
															88.989,
															200.831
														],
														[
															73,
															241
														],
														[
															58.002,
															310.071
														],
														[
															55,
															386
														],
														[
															58.913,
															422.827
														],
														[
															66,
															457
														],
														[
															80.683,
															504.05
														],
														[
															100,
															546
														],
														[
															104,
															552
														],
														[
															108,
															560
														],
														[
															116,
															573
														],
														[
															118,
															574
														],
														[
															118,
															576
														],
														[
															120,
															577
														],
														[
															120,
															579
														],
														[
															122,
															580
														],
														[
															122,
															582
														],
														[
															124,
															583
														],
														[
															128,
															589
														],
														[
															137,
															601
														],
														[
															152,
															618
														],
														[
															248,
															686
														],
														[
															293,
															702
														],
														[
															328,
															708
														],
														[
															348,
															709
														],
														[
															387,
															708
														],
														[
															392,
															706
														],
														[
															395,
															702
														],
														[
															399,
															695
														],
														[
															403,
															695
														],
														[
															419,
															692
														],
														[
															471,
															675
														],
														[
															491,
															665
														],
														[
															596,
															572
														],
														[
															646,
															474
														],
														[
															653,
															452
														],
														[
															656,
															435
														],
														[
															660,
															419
														],
														[
															662,
															401
														],
														[
															568,
															106
														],
														[
															554,
															91
														],
														[
															548,
															87
														],
														[
															536,
															77
														],
														[
															535,
															75
														],
														[
															476,
															40
														],
														[
															343,
															15
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 95,
											"s": [
												{
													"i": [
														[
															-0.112,
															0.008
														],
														[
															6.558,
															-0.571
														],
														[
															6.317,
															-1.267
														],
														[
															9.94,
															-3.323
														],
														[
															7.779,
															-3.609
														],
														[
															0.882,
															-0.082
														],
														[
															0.734,
															-0.329
														],
														[
															2.352,
															-1.204
														],
														[
															2.251,
															-1.132
														],
														[
															4.226,
															-2.492
														],
														[
															4.031,
															-2.563
														],
														[
															7.501,
															-5.986
														],
														[
															3.79,
															-3.253
														],
														[
															6.858,
															-7.119
														],
														[
															6.161,
															-7.741
														],
														[
															-6.417,
															-109.244
														],
														[
															-11.321,
															-28.852
														],
														[
															-3.892,
															-9.082
														],
														[
															-2.421,
															-2.527
														],
														[
															-1.974,
															-3.283
														],
														[
															-2.948,
															-4.32
														],
														[
															-2.168,
															-2.991
														],
														[
															-0.223,
															-0.494
														],
														[
															-0.248,
															-0.358
														],
														[
															-1.511,
															-3.351
														],
														[
															-0.249,
															-0.325
														],
														[
															-2.676,
															-3.064
														],
														[
															-7.519,
															-6.266
														],
														[
															-2.728,
															-2.339
														],
														[
															-1.112,
															-0.95
														],
														[
															-4.06,
															-3.124
														],
														[
															-4.093,
															-1.845
														],
														[
															-0.37,
															-0.247
														],
														[
															-0.511,
															-0.23
														],
														[
															-0.372,
															-0.247
														],
														[
															-0.512,
															-0.231
														],
														[
															-0.381,
															-0.245
														],
														[
															-1.184,
															-0.757
														],
														[
															-11.126,
															-5.112
														],
														[
															-2.479,
															-1.029
														],
														[
															-2.612,
															-1.005
														],
														[
															-0.983,
															-0.386
														],
														[
															-6.63,
															-1.85
														],
														[
															-25.663,
															-1.345
														],
														[
															-10.511,
															2.473
														],
														[
															-1.615,
															2.112
														],
														[
															-1.171,
															0.324
														],
														[
															-1.183,
															0.424
														],
														[
															-7.993,
															1.933
														],
														[
															-2.419,
															0.678
														],
														[
															-5.145,
															1.73
														],
														[
															-2.883,
															1.131
														],
														[
															-0.946,
															0.364
														],
														[
															-2.453,
															1.051
														],
														[
															-2.316,
															1.045
														],
														[
															-4.474,
															2.383
														],
														[
															-26.062,
															32.174
														],
														[
															-2.719,
															6.032
														],
														[
															-0.247,
															0.37
														],
														[
															-0.23,
															0.511
														],
														[
															-0.248,
															0.353
														],
														[
															-1.356,
															3.009
														],
														[
															-0.244,
															0.388
														],
														[
															-0.974,
															1.017
														],
														[
															-0.699,
															1.176
														],
														[
															5.9,
															85.557
														],
														[
															1.929,
															11.461
														],
														[
															2.955,
															10.73
														],
														[
															5.747,
															13.704
														],
														[
															0.989,
															2.52
														],
														[
															0.669,
															1.454
														],
														[
															5.786,
															12.834
														],
														[
															0.247,
															0.37
														],
														[
															0.23,
															0.511
														],
														[
															0.247,
															0.37
														],
														[
															0.23,
															0.511
														],
														[
															0.247,
															0.37
														],
														[
															0.23,
															0.511
														],
														[
															0.248,
															0.354
														],
														[
															0.226,
															0.501
														],
														[
															0.249,
															0.346
														],
														[
															2.252,
															2.984
														],
														[
															7.057,
															8.08
														],
														[
															1.823,
															1.887
														],
														[
															3.499,
															3.139
														],
														[
															3.676,
															3.151
														],
														[
															18.344,
															10.019
														],
														[
															6.835,
															2.682
														],
														[
															13.537,
															3.452
														],
														[
															12.238,
															1.663
														],
														[
															20.21,
															-1.187
														]
													],
													"o": [
														[
															-6.452,
															0.447
														],
														[
															-6.558,
															0.571
														],
														[
															-10.46,
															2.099
														],
														[
															-9.94,
															3.323
														],
														[
															-0.74,
															0.343
														],
														[
															-0.882,
															0.082
														],
														[
															-2.341,
															1.051
														],
														[
															-2.352,
															1.204
														],
														[
															-4.827,
															2.427
														],
														[
															-4.401,
															2.596
														],
														[
															-8.82,
															5.608
														],
														[
															-4.063,
															3.242
														],
														[
															-7.512,
															6.448
														],
														[
															-6.867,
															7.129
														],
														[
															-46.725,
															58.706
														],
														[
															2.276,
															38.746
														],
														[
															4.228,
															10.775
														],
														[
															1.792,
															4.181
														],
														[
															3.342,
															3.488
														],
														[
															3.371,
															5.604
														],
														[
															2.587,
															3.791
														],
														[
															0.313,
															0.431
														],
														[
															0.143,
															0.316
														],
														[
															2.671,
															3.854
														],
														[
															0.133,
															0.295
														],
														[
															2.968,
															3.878
														],
														[
															7.168,
															8.207
														],
														[
															3.534,
															2.945
														],
														[
															1.11,
															0.952
														],
														[
															3.716,
															3.173
														],
														[
															4.189,
															3.223
														],
														[
															0.324,
															0.146
														],
														[
															0.46,
															0.307
														],
														[
															0.325,
															0.147
														],
														[
															0.462,
															0.306
														],
														[
															0.331,
															0.149
														],
														[
															1.142,
															0.735
														],
														[
															10.73,
															6.861
														],
														[
															2.408,
															1.107
														],
														[
															2.388,
															0.992
														],
														[
															0.694,
															0.267
														],
														[
															7.635,
															2.996
														],
														[
															21.437,
															5.982
														],
														[
															15.042,
															0.788
														],
														[
															3.61,
															-0.849
														],
														[
															1.074,
															-1.404
														],
														[
															1.215,
															-0.336
														],
														[
															7.834,
															-2.806
														],
														[
															2.354,
															-0.57
														],
														[
															5.535,
															-1.551
														],
														[
															3.51,
															-1.18
														],
														[
															1.182,
															-0.464
														],
														[
															2.749,
															-1.057
														],
														[
															2.12,
															-0.909
														],
														[
															4.512,
															-2.035
														],
														[
															39.396,
															-20.99
														],
														[
															4.674,
															-5.771
														],
														[
															0.146,
															-0.324
														],
														[
															0.307,
															-0.46
														],
														[
															0.141,
															-0.313
														],
														[
															2.317,
															-3.292
														],
														[
															0.151,
															-0.335
														],
														[
															1.514,
															-2.411
														],
														[
															0.818,
															-0.854
														],
														[
															32.525,
															-54.739
														],
														[
															-0.799,
															-11.589
														],
														[
															-1.915,
															-11.381
														],
														[
															-4.263,
															-15.482
														],
														[
															-1.362,
															-3.249
														],
														[
															-0.606,
															-1.545
														],
														[
															-6.8,
															-14.776
														],
														[
															-0.146,
															-0.324
														],
														[
															-0.307,
															-0.46
														],
														[
															-0.146,
															-0.324
														],
														[
															-0.307,
															-0.46
														],
														[
															-0.146,
															-0.324
														],
														[
															-0.307,
															-0.46
														],
														[
															-0.142,
															-0.314
														],
														[
															-0.311,
															-0.443
														],
														[
															-0.139,
															-0.309
														],
														[
															-2.493,
															-3.468
														],
														[
															-7.15,
															-9.472
														],
														[
															-1.731,
															-1.982
														],
														[
															-3.234,
															-3.349
														],
														[
															-3.58,
															-3.212
														],
														[
															-16.081,
															-13.785
														],
														[
															-7.127,
															-3.893
														],
														[
															-13.548,
															-5.316
														],
														[
															-10.907,
															-2.782
														],
														[
															-18.07,
															-2.456
														],
														[
															-0.628,
															0.037
														]
													],
													"v": [
														[
															342,
															16
														],
														[
															322.398,
															17.385
														],
														[
															303,
															20
														],
														[
															271.989,
															28.367
														],
														[
															245,
															39
														],
														[
															242.495,
															39.51
														],
														[
															240,
															40
														],
														[
															232.932,
															43.44
														],
														[
															226,
															47
														],
														[
															213,
															55
														],
														[
															200,
															62
														],
														[
															176,
															80
														],
														[
															164,
															89
														],
														[
															143,
															110
														],
														[
															123,
															132
														],
														[
															45,
															387
														],
														[
															68,
															493
														],
														[
															80,
															523
														],
														[
															89,
															541
														],
														[
															96,
															553
														],
														[
															106,
															569
														],
														[
															113,
															578
														],
														[
															113,
															580
														],
														[
															115,
															581
														],
														[
															122,
															592
														],
														[
															124,
															593
														],
														[
															131,
															602
														],
														[
															154,
															626
														],
														[
															164,
															636
														],
														[
															168,
															638
														],
														[
															179,
															648
														],
														[
															193,
															657
														],
														[
															194,
															659
														],
														[
															196,
															659
														],
														[
															197,
															661
														],
														[
															199,
															661
														],
														[
															200,
															663
														],
														[
															204,
															665
														],
														[
															238,
															683
														],
														[
															245,
															687
														],
														[
															253,
															689
														],
														[
															256,
															691
														],
														[
															279,
															699
														],
														[
															348,
															709
														],
														[
															390,
															708
														],
														[
															397,
															699
														],
														[
															401,
															695
														],
														[
															405,
															695
														],
														[
															430,
															690
														],
														[
															437,
															687
														],
														[
															453,
															683
														],
														[
															464,
															679
														],
														[
															467,
															677
														],
														[
															475,
															675
														],
														[
															481,
															671
														],
														[
															495,
															665
														],
														[
															594,
															584
														],
														[
															608,
															565
														],
														[
															610,
															564
														],
														[
															610,
															562
														],
														[
															612,
															561
														],
														[
															618,
															550
														],
														[
															620,
															549
														],
														[
															624,
															541
														],
														[
															625,
															539
														],
														[
															674,
															327
														],
														[
															669,
															292
														],
														[
															662,
															259
														],
														[
															647,
															214
														],
														[
															642,
															204
														],
														[
															641,
															200
														],
														[
															619,
															160
														],
														[
															617,
															159
														],
														[
															617,
															157
														],
														[
															615,
															156
														],
														[
															615,
															154
														],
														[
															613,
															153
														],
														[
															613,
															151
														],
														[
															611,
															150
														],
														[
															611,
															148
														],
														[
															609,
															147
														],
														[
															603,
															138
														],
														[
															580,
															111
														],
														[
															575,
															105
														],
														[
															564,
															96
														],
														[
															554,
															86
														],
														[
															500,
															50
														],
														[
															476,
															38
														],
														[
															435,
															24
														],
														[
															401,
															18
														],
														[
															343,
															15
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 96,
											"s": [
												{
													"i": [
														[
															-0.115,
															0.007
														],
														[
															6.729,
															-0.574
														],
														[
															6.614,
															-1.289
														],
														[
															15.707,
															-5.926
														],
														[
															12.193,
															-6.987
														],
														[
															15.186,
															-12.693
														],
														[
															12.571,
															-15.519
														],
														[
															10.168,
															-17.597
														],
														[
															7.557,
															-20.847
														],
														[
															3.459,
															-24.993
														],
														[
															-1.764,
															-25.156
														],
														[
															-8.258,
															-26.766
														],
														[
															-12.659,
															-21.994
														],
														[
															-3.097,
															-4.512
														],
														[
															-1.953,
															-4.334
														],
														[
															-0.451,
															-0.168
														],
														[
															-0.124,
															-0.173
														],
														[
															-1.275,
															-1.957
														],
														[
															-0.638,
															-1.417
														],
														[
															-0.451,
															-0.168
														],
														[
															-0.124,
															-0.173
														],
														[
															-6.569,
															-7.177
														],
														[
															-6.44,
															-5.942
														],
														[
															-1.051,
															-0.604
														],
														[
															-0.925,
															-0.779
														],
														[
															-0.293,
															-0.565
														],
														[
															-0.406,
															-0.384
														],
														[
															-0.692,
															-0.226
														],
														[
															-0.612,
															-0.51
														],
														[
															-1.786,
															-1.741
														],
														[
															-1.928,
															-1.426
														],
														[
															-0.988,
															-0.635
														],
														[
															-1.067,
															-0.738
														],
														[
															-1.591,
															-0.934
														],
														[
															-0.501,
															-0.481
														],
														[
															-0.539,
															-0.298
														],
														[
															-0.425,
															-0.408
														],
														[
															-0.539,
															-0.298
														],
														[
															-0.425,
															-0.408
														],
														[
															-0.262,
															-0.065
														],
														[
															-0.543,
															-0.35
														],
														[
															-0.499,
															-0.592
														],
														[
															-0.491,
															-0.303
														],
														[
															-1.768,
															-0.8
														],
														[
															-1.202,
															-0.736
														],
														[
															-5.321,
															-2.623
														],
														[
															-5.636,
															-2.394
														],
														[
															-10.887,
															-3.215
														],
														[
															-12.015,
															-2.132
														],
														[
															-14.301,
															-0.672
														],
														[
															-11.808,
															1.817
														],
														[
															-0.692,
															0.2
														],
														[
															-1.018,
															0.861
														],
														[
															-1.398,
															2.232
														],
														[
															-1.657,
															0.591
														],
														[
															-2.196,
															0.228
														],
														[
															-2.16,
															0.352
														],
														[
															-6.689,
															1.696
														],
														[
															-6.194,
															2.064
														],
														[
															-15.545,
															8.293
														],
														[
															-13.181,
															9.949
														],
														[
															-6.917,
															6.584
														],
														[
															-6.505,
															6.753
														],
														[
															-12.457,
															21.157
														],
														[
															-8.552,
															26.118
														],
														[
															-3.21,
															23.872
														],
														[
															2.474,
															27.251
														],
														[
															6.767,
															22.569
														],
														[
															9.647,
															17.562
														],
														[
															1.112,
															2.118
														],
														[
															1.183,
															2.035
														],
														[
															0.267,
															0.806
														],
														[
															0.343,
															0.762
														],
														[
															0.451,
															0.157
														],
														[
															0.12,
															0.201
														],
														[
															0.688,
															1.563
														],
														[
															0.532,
															0.555
														],
														[
															0.298,
															0.539
														],
														[
															0.408,
															0.425
														],
														[
															0.298,
															0.539
														],
														[
															0.408,
															0.425
														],
														[
															0.298,
															0.539
														],
														[
															0.408,
															0.425
														],
														[
															0.954,
															1.354
														],
														[
															0.966,
															1.311
														],
														[
															2.163,
															2.833
														],
														[
															2.099,
															2.613
														],
														[
															2.307,
															2.64
														],
														[
															2.448,
															2.548
														],
														[
															43.791,
															18.129
														],
														[
															53.934,
															-2.867
														]
													],
													"o": [
														[
															-6.469,
															0.416
														],
														[
															-6.729,
															0.574
														],
														[
															-16.981,
															3.309
														],
														[
															-15.707,
															5.926
														],
														[
															-18.686,
															10.709
														],
														[
															-15.186,
															12.693
														],
														[
															-12.77,
															15.765
														],
														[
															-10.168,
															17.597
														],
														[
															-7.928,
															21.873
														],
														[
															-3.459,
															24.993
														],
														[
															2.309,
															32.942
														],
														[
															8.258,
															26.766
														],
														[
															2.659,
															4.619
														],
														[
															3.097,
															4.512
														],
														[
															0.07,
															0.154
														],
														[
															0.451,
															0.168
														],
														[
															1.262,
															1.756
														],
														[
															1.275,
															1.957
														],
														[
															0.07,
															0.154
														],
														[
															0.451,
															0.168
														],
														[
															5.283,
															7.351
														],
														[
															6.569,
															7.177
														],
														[
															0.871,
															0.804
														],
														[
															1.051,
															0.604
														],
														[
															0.422,
															0.355
														],
														[
															0.293,
															0.565
														],
														[
															0.621,
															0.587
														],
														[
															0.692,
															0.226
														],
														[
															1.929,
															1.61
														],
														[
															1.786,
															1.741
														],
														[
															0.978,
															0.724
														],
														[
															0.989,
															0.635
														],
														[
															1.133,
															0.784
														],
														[
															1.591,
															0.934
														],
														[
															0.419,
															0.401
														],
														[
															0.539,
															0.298
														],
														[
															0.419,
															0.401
														],
														[
															0.539,
															0.298
														],
														[
															0.409,
															0.391
														],
														[
															0.262,
															0.065
														],
														[
															0.513,
															0.331
														],
														[
															0.499,
															0.592
														],
														[
															1.725,
															1.063
														],
														[
															1.768,
															0.8
														],
														[
															5.079,
															3.114
														],
														[
															5.322,
															2.623
														],
														[
															9.437,
															4.009
														],
														[
															10.887,
															3.215
														],
														[
															11.99,
															2.128
														],
														[
															14.301,
															0.672
														],
														[
															2.216,
															-0.341
														],
														[
															0.692,
															-0.2
														],
														[
															1.751,
															-1.482
														],
														[
															1.398,
															-2.232
														],
														[
															2.057,
															-0.734
														],
														[
															2.196,
															-0.228
														],
														[
															7.052,
															-1.15
														],
														[
															6.689,
															-1.696
														],
														[
															17.64,
															-5.88
														],
														[
															15.545,
															-8.293
														],
														[
															7.829,
															-5.909
														],
														[
															6.917,
															-6.585
														],
														[
															16.622,
															-17.256
														],
														[
															12.457,
															-21.157
														],
														[
															6.634,
															-20.261
														],
														[
															3.21,
															-23.872
														],
														[
															-2.284,
															-25.162
														],
														[
															-6.767,
															-22.569
														],
														[
															-1.369,
															-2.492
														],
														[
															-1.112,
															-2.118
														],
														[
															-0.59,
															-1.016
														],
														[
															-0.267,
															-0.806
														],
														[
															-0.077,
															-0.171
														],
														[
															-0.45,
															-0.157
														],
														[
															-0.715,
															-1.192
														],
														[
															-0.688,
															-1.563
														],
														[
															-0.401,
															-0.419
														],
														[
															-0.298,
															-0.539
														],
														[
															-0.401,
															-0.419
														],
														[
															-0.298,
															-0.539
														],
														[
															-0.401,
															-0.419
														],
														[
															-0.298,
															-0.539
														],
														[
															-1.219,
															-1.272
														],
														[
															-0.954,
															-1.354
														],
														[
															-2.25,
															-3.055
														],
														[
															-2.163,
															-2.833
														],
														[
															-2.323,
															-2.892
														],
														[
															-2.307,
															-2.64
														],
														[
															-29.018,
															-30.206
														],
														[
															-38.247,
															-15.834
														],
														[
															-0.629,
															0.033
														]
													],
													"v": [
														[
															342,
															16
														],
														[
															322.109,
															17.346
														],
														[
															302,
															20
														],
														[
															252.409,
															34.242
														],
														[
															210,
															54
														],
														[
															159.413,
															88.892
														],
														[
															118,
															131
														],
														[
															83.59,
															180.688
														],
														[
															57,
															238
														],
														[
															39.731,
															309.037
														],
														[
															37,
															385
														],
														[
															53.238,
															474.211
														],
														[
															85,
															547
														],
														[
															94.029,
															560.714
														],
														[
															102,
															574
														],
														[
															102.959,
															574.486
														],
														[
															104,
															575
														],
														[
															107.968,
															580.755
														],
														[
															111,
															586
														],
														[
															111.959,
															586.486
														],
														[
															113,
															587
														],
														[
															131.133,
															609.056
														],
														[
															151,
															629
														],
														[
															153.959,
															631.019
														],
														[
															157,
															633
														],
														[
															158.012,
															634.478
														],
														[
															159,
															636
														],
														[
															161.007,
															637.057
														],
														[
															163,
															638
														],
														[
															168.501,
															643.138
														],
														[
															174,
															648
														],
														[
															176.933,
															649.989
														],
														[
															180,
															652
														],
														[
															184.474,
															654.727
														],
														[
															188,
															657
														],
														[
															189.495,
															657.995
														],
														[
															191,
															659
														],
														[
															192.495,
															659.995
														],
														[
															194,
															661
														],
														[
															194.899,
															661.531
														],
														[
															196,
															662
														],
														[
															197.517,
															663.521
														],
														[
															199,
															665
														],
														[
															204.393,
															667.745
														],
														[
															209,
															670
														],
														[
															224.582,
															678.54
														],
														[
															241,
															686
														],
														[
															271.567,
															696.907
														],
														[
															306,
															705
														],
														[
															346.637,
															709.459
														],
														[
															387,
															708
														],
														[
															390.899,
															707.39
														],
														[
															393,
															706
														],
														[
															397.571,
															699.832
														],
														[
															402,
															695
														],
														[
															408.423,
															693.714
														],
														[
															415,
															693
														],
														[
															435.643,
															688.686
														],
														[
															455,
															683
														],
														[
															504.845,
															661.552
														],
														[
															548,
															634
														],
														[
															569.993,
															615.132
														],
														[
															590,
															595
														],
														[
															633.553,
															537.647
														],
														[
															665,
															467
														],
														[
															680.331,
															400.743
														],
														[
															682,
															324
														],
														[
															668.022,
															251.8
														],
														[
															643,
															191
														],
														[
															639.36,
															184.157
														],
														[
															636,
															178
														],
														[
															634.815,
															175.31
														],
														[
															634,
															173
														],
														[
															633.032,
															172.522
														],
														[
															632,
															172
														],
														[
															629.863,
															167.523
														],
														[
															628,
															164
														],
														[
															627.005,
															162.505
														],
														[
															626,
															161
														],
														[
															625.005,
															159.505
														],
														[
															624,
															158
														],
														[
															623.005,
															156.505
														],
														[
															622,
															155
														],
														[
															618.81,
															151.029
														],
														[
															616,
															147
														],
														[
															609.387,
															138.169
														],
														[
															603,
															130
														],
														[
															596.094,
															121.742
														],
														[
															589,
															114
														],
														[
															481,
															39
														],
														[
															343,
															15
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 97,
											"s": [
												{
													"i": [
														[
															-0.115,
															0.007
														],
														[
															0.337,
															0.002
														],
														[
															0.326,
															0.014
														],
														[
															3.137,
															-0.429
														],
														[
															3.286,
															-0.425
														],
														[
															3.155,
															-0.246
														],
														[
															3.06,
															-0.586
														],
														[
															5.681,
															-1.564
														],
														[
															5.255,
															-1.59
														],
														[
															23.803,
															-15.259
														],
														[
															18.352,
															-19.752
														],
														[
															4.03,
															-4.882
														],
														[
															3.529,
															-4.79
														],
														[
															2.101,
															-3.074
														],
														[
															2.185,
															-3.432
														],
														[
															0.948,
															-1.594
														],
														[
															0.517,
															-0.54
														],
														[
															1.013,
															-2.006
														],
														[
															1.151,
															-2.099
														],
														[
															2.817,
															-5.419
														],
														[
															2.091,
															-4.507
														],
														[
															0.098,
															-0.903
														],
														[
															0.277,
															-0.679
														],
														[
															0.774,
															-1.193
														],
														[
															0.436,
															-1.079
														],
														[
															0.135,
															-0.701
														],
														[
															0.177,
															-0.487
														],
														[
															1.187,
															-3.312
														],
														[
															1.096,
															-3.568
														],
														[
															1.153,
															-4.781
														],
														[
															0.883,
															-4.983
														],
														[
															0.443,
															-0.698
														],
														[
															0.117,
															-0.576
														],
														[
															0.477,
															-3.213
														],
														[
															0.472,
															-3.106
														],
														[
															0.532,
															-13.534
														],
														[
															-1.069,
															-14.089
														],
														[
															-4.279,
															-18.591
														],
														[
															-6.242,
															-16.006
														],
														[
															-0.916,
															-1.914
														],
														[
															-0.642,
															-1.562
														],
														[
															-2.211,
															-4.042
														],
														[
															-2.156,
															-3.968
														],
														[
															-1.094,
															-2.351
														],
														[
															-1.322,
															-2.197
														],
														[
															-2.271,
															-3.239
														],
														[
															-1.919,
															-2.726
														],
														[
															-1.459,
															-1.933
														],
														[
															-1.462,
															-1.851
														],
														[
															-0.894,
															-1.447
														],
														[
															-0.427,
															-0.947
														],
														[
															-0.454,
															-0.18
														],
														[
															-0.123,
															-0.145
														],
														[
															-0.457,
															-0.808
														],
														[
															-0.368,
															-0.817
														],
														[
															-0.454,
															-0.18
														],
														[
															-0.123,
															-0.145
														],
														[
															-0.457,
															-0.808
														],
														[
															-0.368,
															-0.817
														],
														[
															-0.454,
															-0.179
														],
														[
															-0.123,
															-0.148
														],
														[
															-3.176,
															-3.022
														],
														[
															-3.231,
															-3.231
														],
														[
															-43.304,
															-17.269
														],
														[
															-25.083,
															-3.927
														],
														[
															-13.686,
															-0.637
														],
														[
															-10.508,
															2.473
														],
														[
															-1.015,
															1.649
														],
														[
															-0.784,
															0.851
														],
														[
															-0.407,
															0.253
														],
														[
															-1.027,
															0.255
														],
														[
															-4.203,
															0.686
														],
														[
															-8.26,
															2.538
														],
														[
															-2.478,
															0.798
														],
														[
															-4.649,
															1.824
														],
														[
															-15.803,
															9.672
														],
														[
															-24.135,
															30.738
														],
														[
															-13.733,
															41.495
														],
														[
															5.262,
															55.055
														],
														[
															19.398,
															36.129
														],
														[
															1.213,
															2.186
														],
														[
															2.521,
															2.631
														],
														[
															0.814,
															0.85
														],
														[
															0.723,
															0.755
														],
														[
															0.814,
															0.85
														],
														[
															0.696,
															1.044
														],
														[
															0.997,
															1.25
														],
														[
															0.921,
															1.221
														],
														[
															14.798,
															13.878
														],
														[
															67.563,
															12.275
														],
														[
															27.653,
															-1.47
														]
													],
													"o": [
														[
															-0.326,
															0.021
														],
														[
															-0.337,
															-0.002
														],
														[
															-3.168,
															-0.142
														],
														[
															-3.137,
															0.429
														],
														[
															-3.322,
															0.43
														],
														[
															-3.155,
															0.246
														],
														[
															-6.019,
															1.153
														],
														[
															-5.681,
															1.564
														],
														[
															-30.438,
															9.209
														],
														[
															-23.803,
															15.26
														],
														[
															-4.35,
															4.682
														],
														[
															-4.03,
															4.882
														],
														[
															-2.412,
															3.274
														],
														[
															-2.101,
															3.074
														],
														[
															-0.691,
															1.086
														],
														[
															-0.948,
															1.594
														],
														[
															-1.797,
															1.876
														],
														[
															-1.013,
															2.006
														],
														[
															-2.641,
															4.815
														],
														[
															-2.817,
															5.419
														],
														[
															-0.329,
															0.71
														],
														[
															-0.098,
															0.903
														],
														[
															-0.469,
															1.149
														],
														[
															-0.774,
															1.193
														],
														[
															-0.285,
															0.707
														],
														[
															-0.134,
															0.701
														],
														[
															-1.155,
															3.183
														],
														[
															-1.187,
															3.312
														],
														[
															-1.504,
															4.895
														],
														[
															-1.153,
															4.781
														],
														[
															-0.112,
															0.634
														],
														[
															-0.443,
															0.698
														],
														[
															-0.619,
															3.041
														],
														[
															-0.477,
															3.213
														],
														[
															-1.943,
															12.774
														],
														[
															-0.532,
															13.534
														],
														[
															1.641,
															21.628
														],
														[
															4.279,
															18.591
														],
														[
															0.695,
															1.781
														],
														[
															0.916,
															1.914
														],
														[
															2.001,
															4.864
														],
														[
															2.211,
															4.042
														],
														[
															1.303,
															2.4
														],
														[
															1.094,
															2.351
														],
														[
															1.996,
															3.317
														],
														[
															2.271,
															3.239
														],
														[
															1.702,
															2.418
														],
														[
															1.459,
															1.933
														],
														[
															0.998,
															1.264
														],
														[
															0.894,
															1.447
														],
														[
															0.061,
															0.135
														],
														[
															0.454,
															0.18
														],
														[
															0.804,
															0.95
														],
														[
															0.457,
															0.808
														],
														[
															0.061,
															0.135
														],
														[
															0.454,
															0.18
														],
														[
															0.804,
															0.95
														],
														[
															0.457,
															0.808
														],
														[
															0.062,
															0.137
														],
														[
															0.454,
															0.179
														],
														[
															3.066,
															3.68
														],
														[
															3.176,
															3.022
														],
														[
															27.776,
															27.776
														],
														[
															17.977,
															7.169
														],
														[
															12.162,
															1.904
														],
														[
															15.378,
															0.715
														],
														[
															2.757,
															-0.649
														],
														[
															0.676,
															-1.098
														],
														[
															0.385,
															-0.418
														],
														[
															0.88,
															-0.547
														],
														[
															3.475,
															-0.864
														],
														[
															11.013,
															-1.796
														],
														[
															2.59,
															-0.796
														],
														[
															6.994,
															-2.253
														],
														[
															18.89,
															-7.412
														],
														[
															32.116,
															-19.657
														],
														[
															22.882,
															-29.141
														],
														[
															13.452,
															-40.645
														],
														[
															-4.935,
															-51.638
														],
														[
															-1.1,
															-2.048
														],
														[
															-2.463,
															-4.436
														],
														[
															-0.803,
															-0.838
														],
														[
															-1.574,
															-1.643
														],
														[
															-0.803,
															-0.838
														],
														[
															-0.765,
															-0.798
														],
														[
															-1.243,
															-1.864
														],
														[
															-1.032,
															-1.293
														],
														[
															-11.585,
															-15.347
														],
														[
															-42.048,
															-39.433
														],
														[
															-23.006,
															-4.18
														],
														[
															-0.629,
															0.033
														]
													],
													"v": [
														[
															341,
															16
														],
														[
															340,
															16.027
														],
														[
															339,
															16
														],
														[
															329.588,
															16.574
														],
														[
															320,
															18
														],
														[
															310.304,
															18.883
														],
														[
															301,
															20
														],
														[
															283.427,
															24.172
														],
														[
															267,
															29
														],
														[
															185.936,
															66.093
														],
														[
															123,
															119
														],
														[
															110.385,
															133.419
														],
														[
															99,
															148
														],
														[
															92.33,
															157.381
														],
														[
															86,
															167
														],
														[
															83.369,
															171.41
														],
														[
															81,
															175
														],
														[
															77.015,
															180.833
														],
														[
															74,
															187
														],
														[
															65.588,
															202.73
														],
														[
															58,
															218
														],
														[
															57.461,
															220.523
														],
														[
															57,
															223
														],
														[
															54.975,
															226.552
														],
														[
															53,
															230
														],
														[
															52.418,
															232.165
														],
														[
															52,
															234
														],
														[
															48.456,
															243.712
														],
														[
															45,
															254
														],
														[
															41.035,
															268.434
														],
														[
															38,
															283
														],
														[
															37.003,
															285.043
														],
														[
															36,
															287
														],
														[
															34.39,
															296.451
														],
														[
															33,
															306
														],
														[
															29.241,
															345.513
														],
														[
															30,
															387
														],
														[
															39.049,
															447.216
														],
														[
															55,
															499
														],
														[
															57.539,
															504.664
														],
														[
															60,
															510
														],
														[
															66.384,
															523.172
														],
														[
															73,
															535
														],
														[
															76.486,
															542.152
														],
														[
															80,
															549
														],
														[
															86.558,
															558.943
														],
														[
															93,
															568
														],
														[
															97.68,
															574.425
														],
														[
															102,
															580
														],
														[
															104.928,
															584.238
														],
														[
															107,
															588
														],
														[
															107.954,
															588.493
														],
														[
															109,
															589
														],
														[
															110.827,
															591.6
														],
														[
															112,
															594
														],
														[
															112.954,
															594.493
														],
														[
															114,
															595
														],
														[
															115.827,
															597.6
														],
														[
															117,
															600
														],
														[
															117.954,
															600.492
														],
														[
															119,
															601
														],
														[
															128.377,
															610.837
														],
														[
															138,
															620
														],
														[
															242,
															687
														],
														[
															308,
															706
														],
														[
															348,
															709
														],
														[
															391,
															708
														],
														[
															398,
															700
														],
														[
															400,
															698
														],
														[
															401,
															695
														],
														[
															405,
															695
														],
														[
															416,
															693
														],
														[
															448,
															685
														],
														[
															456,
															683
														],
														[
															475,
															676
														],
														[
															527,
															651
														],
														[
															614,
															574
														],
														[
															672,
															468
														],
														[
															689,
															323
														],
														[
															649,
															190
														],
														[
															645,
															184
														],
														[
															637,
															169
														],
														[
															635,
															166
														],
														[
															631,
															160
														],
														[
															629,
															157
														],
														[
															628,
															155
														],
														[
															623,
															150
														],
														[
															621,
															146
														],
														[
															582,
															103
														],
														[
															419,
															20
														],
														[
															342,
															15
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 98,
											"s": [
												{
													"i": [
														[
															-0.115,
															0.007
														],
														[
															0.337,
															0.002
														],
														[
															0.326,
															0.014
														],
														[
															5.097,
															-0.677
														],
														[
															3.643,
															-0.514
														],
														[
															12.572,
															-3.577
														],
														[
															11.216,
															-4.651
														],
														[
															4.784,
															-2.346
														],
														[
															4.623,
															-2.442
														],
														[
															2.344,
															-1.105
														],
														[
															2.212,
															-1.306
														],
														[
															2.124,
															-1.551
														],
														[
															2.206,
															-1.439
														],
														[
															17.395,
															-18.33
														],
														[
															13.388,
															-22.313
														],
														[
															9.172,
															-34.917
														],
														[
															-3.239,
															-41.416
														],
														[
															-1.304,
															-9.285
														],
														[
															-1.982,
															-8.607
														],
														[
															-1.182,
															-4.127
														],
														[
															-1.215,
															-3.899
														],
														[
															-0.805,
															-2.886
														],
														[
															-0.922,
															-2.693
														],
														[
															-0.97,
															-1.978
														],
														[
															-0.507,
															-1.292
														],
														[
															-1.285,
															-3.068
														],
														[
															-1.425,
															-3.067
														],
														[
															-3.189,
															-5.859
														],
														[
															-3.398,
															-5.435
														],
														[
															-2.215,
															-3.216
														],
														[
															-2.029,
															-2.757
														],
														[
															-0.867,
															-1.376
														],
														[
															-0.485,
															-1.075
														],
														[
															-0.451,
															-0.168
														],
														[
															-0.124,
															-0.173
														],
														[
															-6.397,
															-7.186
														],
														[
															-6.757,
															-6.389
														],
														[
															-1.168,
															-0.841
														],
														[
															-1.141,
															-0.514
														],
														[
															-0.18,
															-0.454
														],
														[
															-0.145,
															-0.123
														],
														[
															-0.967,
															-0.818
														],
														[
															-0.96,
															-0.736
														],
														[
															-1.937,
															-1.499
														],
														[
															-1.547,
															-0.697
														],
														[
															-0.168,
															-0.452
														],
														[
															-0.173,
															-0.125
														],
														[
															-0.988,
															-0.64
														],
														[
															-0.867,
															-0.592
														],
														[
															-0.926,
															-0.833
														],
														[
															-0.893,
															-0.712
														],
														[
															-0.726,
															-0.296
														],
														[
															-0.531,
															-0.363
														],
														[
															-5.63,
															-3.275
														],
														[
															-5.955,
															-3.121
														],
														[
															-10.221,
															-3.963
														],
														[
															-11.423,
															-3.065
														],
														[
															-21.268,
															-2.191
														],
														[
															-18.43,
															2.923
														],
														[
															-0.809,
															1.159
														],
														[
															-1.066,
															1.093
														],
														[
															-0.388,
															0.899
														],
														[
															-0.619,
															0.556
														],
														[
															-3.194,
															0.505
														],
														[
															-2.485,
															0.418
														],
														[
															-6.921,
															1.701
														],
														[
															-6.274,
															2.01
														],
														[
															-3.35,
															1.26
														],
														[
															-2.272,
															0.891
														],
														[
															-8.271,
															3.846
														],
														[
															-7.24,
															4.214
														],
														[
															-0.722,
															0.336
														],
														[
															-0.534,
															0.321
														],
														[
															-4.365,
															3.125
														],
														[
															-4.188,
															1.888
														],
														[
															-0.168,
															0.452
														],
														[
															-0.173,
															0.125
														],
														[
															-3.262,
															2.633
														],
														[
															-3.192,
															2.766
														],
														[
															-16.63,
															24.27
														],
														[
															-11.014,
															31.453
														],
														[
															-3.312,
															24.215
														],
														[
															2.352,
															27.858
														],
														[
															2.251,
															11.302
														],
														[
															29.607,
															37.86
														],
														[
															15.188,
															13.83
														],
														[
															1.791,
															1.557
														],
														[
															1.748,
															1.499
														],
														[
															7.6,
															5.328
														],
														[
															51.31,
															9.659
														],
														[
															27.82,
															-1.479
														]
													],
													"o": [
														[
															-0.326,
															0.021
														],
														[
															-0.337,
															-0.002
														],
														[
															-4.969,
															-0.223
														],
														[
															-5.097,
															0.677
														],
														[
															-14.494,
															2.043
														],
														[
															-12.572,
															3.577
														],
														[
															-5.243,
															2.174
														],
														[
															-4.784,
															2.346
														],
														[
															-2.411,
															1.273
														],
														[
															-2.344,
															1.105
														],
														[
															-2.296,
															1.356
														],
														[
															-2.124,
															1.551
														],
														[
															-22.032,
															14.368
														],
														[
															-17.395,
															18.33
														],
														[
															-15.55,
															25.917
														],
														[
															-9.172,
															34.917
														],
														[
															0.802,
															10.254
														],
														[
															1.304,
															9.285
														],
														[
															1.058,
															4.591
														],
														[
															1.182,
															4.127
														],
														[
															0.861,
															2.762
														],
														[
															0.804,
															2.886
														],
														[
															0.615,
															1.797
														],
														[
															0.97,
															1.978
														],
														[
															1.436,
															3.661
														],
														[
															1.285,
															3.068
														],
														[
															2.846,
															6.128
														],
														[
															3.189,
															5.859
														],
														[
															2.112,
															3.378
														],
														[
															2.215,
															3.216
														],
														[
															1.045,
															1.42
														],
														[
															0.867,
															1.376
														],
														[
															0.07,
															0.154
														],
														[
															0.451,
															0.168
														],
														[
															5.653,
															7.865
														],
														[
															6.397,
															7.187
														],
														[
															1.185,
															1.121
														],
														[
															1.168,
															0.841
														],
														[
															0.135,
															0.061
														],
														[
															0.18,
															0.454
														],
														[
															1.171,
															0.991
														],
														[
															0.967,
															0.818
														],
														[
															1.704,
															1.305
														],
														[
															1.937,
															1.499
														],
														[
															0.154,
															0.07
														],
														[
															0.168,
															0.451
														],
														[
															1.18,
															0.848
														],
														[
															0.988,
															0.64
														],
														[
															1.402,
															0.957
														],
														[
															0.926,
															0.833
														],
														[
															0.565,
															0.452
														],
														[
															0.726,
															0.296
														],
														[
															5.525,
															3.779
														],
														[
															5.63,
															3.275
														],
														[
															9.695,
															5.082
														],
														[
															10.22,
															3.963
														],
														[
															15.498,
															4.159
														],
														[
															21.268,
															2.191
														],
														[
															1.697,
															-0.269
														],
														[
															0.809,
															-1.159
														],
														[
															0.828,
															-0.85
														],
														[
															0.388,
															-0.899
														],
														[
															1.739,
															-1.561
														],
														[
															3.194,
															-0.505
														],
														[
															7.04,
															-1.186
														],
														[
															6.921,
															-1.701
														],
														[
															3.33,
															-1.067
														],
														[
															3.35,
															-1.26
														],
														[
															8.677,
															-3.404
														],
														[
															8.271,
															-3.846
														],
														[
															0.577,
															-0.336
														],
														[
															0.722,
															-0.336
														],
														[
															4.354,
															-2.612
														],
														[
															4.365,
															-3.125
														],
														[
															0.154,
															-0.07
														],
														[
															0.168,
															-0.451
														],
														[
															3.762,
															-2.704
														],
														[
															3.261,
															-2.633
														],
														[
															22.466,
															-19.467
														],
														[
															16.63,
															-24.27
														],
														[
															7.103,
															-20.284
														],
														[
															3.312,
															-24.215
														],
														[
															-0.986,
															-11.68
														],
														[
															-11.501,
															-57.738
														],
														[
															-11.677,
															-14.932
														],
														[
															-1.658,
															-1.509
														],
														[
															-1.865,
															-1.62
														],
														[
															-7.687,
															-6.59
														],
														[
															-36.885,
															-25.855
														],
														[
															-23.516,
															-4.427
														],
														[
															-0.629,
															0.033
														]
													],
													"v": [
														[
															341,
															16
														],
														[
															340,
															16.027
														],
														[
															339,
															16
														],
														[
															323.505,
															16.948
														],
														[
															310,
															19
														],
														[
															269.542,
															27.544
														],
														[
															234,
															40
														],
														[
															219.035,
															46.799
														],
														[
															205,
															54
														],
														[
															197.851,
															57.475
														],
														[
															191,
															61
														],
														[
															184.432,
															65.439
														],
														[
															178,
															70
														],
														[
															119.017,
															119.041
														],
														[
															73,
															180
														],
														[
															34.409,
															271.876
														],
														[
															24,
															387
														],
														[
															27.115,
															416.235
														],
														[
															32,
															443
														],
														[
															35.382,
															456.019
														],
														[
															39,
															468
														],
														[
															41.454,
															476.552
														],
														[
															44,
															485
														],
														[
															46.581,
															490.879
														],
														[
															49,
															496
														],
														[
															53.009,
															505.946
														],
														[
															57,
															515
														],
														[
															66.086,
															533.02
														],
														[
															76,
															550
														],
														[
															82.562,
															559.966
														],
														[
															89,
															569
														],
														[
															91.92,
															573.259
														],
														[
															94,
															577
														],
														[
															94.959,
															577.486
														],
														[
															96,
															578
														],
														[
															114.172,
															600.608
														],
														[
															134,
															621
														],
														[
															137.533,
															623.955
														],
														[
															141,
															626
														],
														[
															141.493,
															626.953
														],
														[
															142,
															628
														],
														[
															145.158,
															630.692
														],
														[
															148,
															633
														],
														[
															153.618,
															637.456
														],
														[
															159,
															641
														],
														[
															159.486,
															641.959
														],
														[
															160,
															643
														],
														[
															163.235,
															645.192
														],
														[
															166,
															647
														],
														[
															169.382,
															649.683
														],
														[
															172,
															652
														],
														[
															174.025,
															653.066
														],
														[
															176,
															654
														],
														[
															192.678,
															664.493
														],
														[
															210,
															674
														],
														[
															239.703,
															687.512
														],
														[
															272,
															698
														],
														[
															329.3,
															708.312
														],
														[
															391,
															708
														],
														[
															394.473,
															705.618
														],
														[
															397,
															702
														],
														[
															398.657,
															699.28
														],
														[
															400,
															697
														],
														[
															407.941,
															694.143
														],
														[
															417,
															693
														],
														[
															438.074,
															688.619
														],
														[
															458,
															683
														],
														[
															468.294,
															679.368
														],
														[
															477,
															676
														],
														[
															502.578,
															665.107
														],
														[
															526,
															653
														],
														[
															528.033,
															651.988
														],
														[
															530,
															651
														],
														[
															543.125,
															641.957
														],
														[
															556,
															634
														],
														[
															556.486,
															633.041
														],
														[
															557,
															632
														],
														[
															567.428,
															624.047
														],
														[
															577,
															616
														],
														[
															635.589,
															550.989
														],
														[
															677,
															468
														],
														[
															693.092,
															401.18
														],
														[
															695,
															323
														],
														[
															689,
															288
														],
														[
															625,
															146
														],
														[
															586,
															102
														],
														[
															580,
															98
														],
														[
															575,
															93
														],
														[
															552,
															75
														],
														[
															420,
															20
														],
														[
															342,
															15
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 99,
											"s": [
												{
													"i": [
														[
															-0.115,
															0.007
														],
														[
															3.62,
															-0.076
														],
														[
															3.879,
															-0.462
														],
														[
															12.475,
															-3.153
														],
														[
															10.068,
															-3.838
														],
														[
															1.299,
															-0.483
														],
														[
															1.094,
															-0.417
														],
														[
															1.812,
															-0.762
														],
														[
															2.007,
															-0.907
														],
														[
															1.361,
															-0.46
														],
														[
															1.23,
															-0.559
														],
														[
															4.55,
															-2.502
														],
														[
															4.375,
															-2.526
														],
														[
															4.49,
															-2.799
														],
														[
															4.117,
															-2.962
														],
														[
															2.396,
															-1.848
														],
														[
															2.114,
															-0.953
														],
														[
															0.179,
															-0.454
														],
														[
															0.147,
															-0.123
														],
														[
															1.487,
															-1.102
														],
														[
															1.44,
															-1.249
														],
														[
															1.334,
															-1.425
														],
														[
															1.137,
															-0.974
														],
														[
															0.729,
															-0.26
														],
														[
															0.573,
															-0.521
														],
														[
															3.443,
															-3.91
														],
														[
															3.413,
															-3.886
														],
														[
															10.877,
															-17.673
														],
														[
															8.086,
															-22.042
														],
														[
															1.881,
															-5.302
														],
														[
															1.553,
															-5.551
														],
														[
															1.066,
															-27.219
														],
														[
															-4.611,
															-24.432
														],
														[
															-18.543,
															-32.479
														],
														[
															-25.861,
															-23.867
														],
														[
															-1.051,
															-0.604
														],
														[
															-0.925,
															-0.779
														],
														[
															-0.293,
															-0.565
														],
														[
															-0.406,
															-0.384
														],
														[
															-0.729,
															-0.258
														],
														[
															-0.575,
															-0.486
														],
														[
															-0.293,
															-0.565
														],
														[
															-0.407,
															-0.385
														],
														[
															-0.69,
															-0.228
														],
														[
															-0.654,
															-0.536
														],
														[
															-0.289,
															-0.573
														],
														[
															-0.421,
															-0.361
														],
														[
															-0.715,
															-0.269
														],
														[
															-0.584,
															-0.447
														],
														[
															-4.126,
															-3.034
														],
														[
															-4.416,
															-2.745
														],
														[
															-4.709,
															-2.472
														],
														[
															-4.814,
															-2.406
														],
														[
															-4.968,
															-2.388
														],
														[
															-5.239,
															-2.005
														],
														[
															-1.374,
															-0.27
														],
														[
															-1.314,
															-0.462
														],
														[
															-1.316,
															-0.518
														],
														[
															-1.395,
															-0.457
														],
														[
															-19.245,
															-2.928
														],
														[
															-20.009,
															0.953
														],
														[
															-4.106,
															-0.043
														],
														[
															-2.951,
															0.952
														],
														[
															-0.275,
															0.375
														],
														[
															-0.373,
															0.327
														],
														[
															-1.465,
															2.284
														],
														[
															-1.485,
															0.41
														],
														[
															-0.696,
															-0.092
														],
														[
															-0.603,
															0.198
														],
														[
															-2.873,
															0.386
														],
														[
															-2.749,
															0.548
														],
														[
															-17.753,
															6.804
														],
														[
															-15.019,
															8.807
														],
														[
															-15.117,
															12.748
														],
														[
															-12.669,
															15.121
														],
														[
															-5.639,
															8.179
														],
														[
															-5.159,
															8.785
														],
														[
															-4.624,
															10.113
														],
														[
															-3.979,
															10.14
														],
														[
															-0.996,
															3.298
														],
														[
															-0.723,
															2.514
														],
														[
															-1.995,
															20.718
														],
														[
															2.133,
															23.193
														],
														[
															6.39,
															21.085
														],
														[
															10.216,
															19.488
														],
														[
															30.928,
															27.788
														],
														[
															17.137,
															10.714
														],
														[
															1.049,
															1.005
														],
														[
															1.176,
															0.699
														],
														[
															15.787,
															6.195
														],
														[
															53.335,
															-2.835
														]
													],
													"o": [
														[
															-3.641,
															0.235
														],
														[
															-3.62,
															0.076
														],
														[
															-13.033,
															1.55
														],
														[
															-12.475,
															3.153
														],
														[
															-1.709,
															0.651
														],
														[
															-1.299,
															0.483
														],
														[
															-2.744,
															1.046
														],
														[
															-1.812,
															0.762
														],
														[
															-1.328,
															0.6
														],
														[
															-1.361,
															0.46
														],
														[
															-5.424,
															2.465
														],
														[
															-4.55,
															2.502
														],
														[
															-4.921,
															2.84
														],
														[
															-4.49,
															2.799
														],
														[
															-2.301,
															1.656
														],
														[
															-2.396,
															1.848
														],
														[
															-0.137,
															0.062
														],
														[
															-0.179,
															0.454
														],
														[
															-1.613,
															1.344
														],
														[
															-1.487,
															1.102
														],
														[
															-1.526,
															1.325
														],
														[
															-1.334,
															1.425
														],
														[
															-0.512,
															0.439
														],
														[
															-0.729,
															0.26
														],
														[
															-3.815,
															3.474
														],
														[
															-3.443,
															3.91
														],
														[
															-13.406,
															15.266
														],
														[
															-10.877,
															17.673
														],
														[
															-1.922,
															5.239
														],
														[
															-1.881,
															5.302
														],
														[
															-6.348,
															22.692
														],
														[
															-1.066,
															27.219
														],
														[
															7.968,
															42.219
														],
														[
															18.543,
															32.479
														],
														[
															0.871,
															0.804
														],
														[
															1.051,
															0.604
														],
														[
															0.422,
															0.355
														],
														[
															0.293,
															0.565
														],
														[
															0.51,
															0.483
														],
														[
															0.729,
															0.258
														],
														[
															0.422,
															0.356
														],
														[
															0.293,
															0.565
														],
														[
															0.584,
															0.552
														],
														[
															0.69,
															0.228
														],
														[
															0.422,
															0.346
														],
														[
															0.289,
															0.573
														],
														[
															0.557,
															0.477
														],
														[
															0.715,
															0.269
														],
														[
															4.08,
															3.118
														],
														[
															4.126,
															3.034
														],
														[
															4.351,
															2.706
														],
														[
															4.709,
															2.472
														],
														[
															4.888,
															2.442
														],
														[
															4.968,
															2.388
														],
														[
															1.19,
															0.456
														],
														[
															1.374,
															0.27
														],
														[
															1.341,
															0.471
														],
														[
															1.316,
															0.518
														],
														[
															16.012,
															5.243
														],
														[
															19.245,
															2.928
														],
														[
															4.625,
															-0.22
														],
														[
															4.106,
															0.043
														],
														[
															0.528,
															-0.17
														],
														[
															0.275,
															-0.375
														],
														[
															1.655,
															-1.455
														],
														[
															1.465,
															-2.284
														],
														[
															0.613,
															-0.169
														],
														[
															0.696,
															0.092
														],
														[
															2.761,
															-0.909
														],
														[
															2.873,
															-0.386
														],
														[
															19.967,
															-3.977
														],
														[
															17.753,
															-6.804
														],
														[
															16.861,
															-9.888
														],
														[
															15.117,
															-12.748
														],
														[
															6.283,
															-7.499
														],
														[
															5.639,
															-8.179
														],
														[
															5.524,
															-9.408
														],
														[
															4.624,
															-10.113
														],
														[
															1.293,
															-3.295
														],
														[
															0.996,
															-3.298
														],
														[
															5.155,
															-17.937
														],
														[
															1.995,
															-20.718
														],
														[
															-2.223,
															-24.173
														],
														[
															-6.39,
															-21.085
														],
														[
															-18.818,
															-35.898
														],
														[
															-14.282,
															-12.832
														],
														[
															-2.276,
															-1.423
														],
														[
															-0.854,
															-0.818
														],
														[
															-15.142,
															-8.997
														],
														[
															-37.236,
															-14.612
														],
														[
															-0.629,
															0.033
														]
													],
													"v": [
														[
															341,
															16
														],
														[
															330.178,
															16.33
														],
														[
															319,
															17
														],
														[
															280.277,
															24.284
														],
														[
															246,
															35
														],
														[
															241.539,
															36.676
														],
														[
															238,
															38
														],
														[
															231.447,
															40.604
														],
														[
															226,
															43
														],
														[
															221.926,
															44.531
														],
														[
															218,
															46
														],
														[
															203.213,
															53.455
														],
														[
															190,
															61
														],
														[
															175.897,
															69.409
														],
														[
															163,
															78
														],
														[
															155.86,
															83.527
														],
														[
															149,
															88
														],
														[
															148.508,
															88.954
														],
														[
															148,
															90
														],
														[
															143.37,
															93.571
														],
														[
															139,
															97
														],
														[
															134.708,
															101.263
														],
														[
															131,
															105
														],
														[
															129.045,
															105.939
														],
														[
															127,
															107
														],
														[
															116.199,
															118.191
														],
														[
															106,
															130
														],
														[
															69.51,
															178.918
														],
														[
															41,
															238
														],
														[
															35.223,
															253.766
														],
														[
															30,
															270
														],
														[
															18.782,
															346.695
														],
														[
															24,
															426
														],
														[
															64.58,
															537.764
														],
														[
															132,
															622
														],
														[
															134.959,
															624.019
														],
														[
															138,
															626
														],
														[
															139.012,
															627.478
														],
														[
															140,
															629
														],
														[
															141.952,
															629.998
														],
														[
															144,
															631
														],
														[
															145.011,
															632.479
														],
														[
															146,
															634
														],
														[
															147.947,
															635.012
														],
														[
															150,
															636
														],
														[
															151.001,
															637.489
														],
														[
															152,
															639
														],
														[
															153.979,
															640.023
														],
														[
															156,
															641
														],
														[
															168.248,
															650.279
														],
														[
															181,
															659
														],
														[
															194.653,
															666.725
														],
														[
															209,
															674
														],
														[
															223.736,
															681.329
														],
														[
															239,
															688
														],
														[
															242.907,
															688.995
														],
														[
															247,
															690
														],
														[
															250.959,
															691.511
														],
														[
															255,
															693
														],
														[
															308.502,
															705.647
														],
														[
															368,
															709
														],
														[
															381.255,
															709.049
														],
														[
															392,
															708
														],
														[
															393.116,
															707.118
														],
														[
															394,
															706
														],
														[
															398.628,
															699.717
														],
														[
															403,
															695
														],
														[
															405.007,
															695.022
														],
														[
															407,
															695
														],
														[
															415.509,
															693.229
														],
														[
															424,
															692
														],
														[
															480.712,
															675.622
														],
														[
															530,
															652
														],
														[
															578.144,
															617.925
														],
														[
															620,
															576
														],
														[
															637.843,
															552.465
														],
														[
															654,
															527
														],
														[
															669.159,
															497.549
														],
														[
															682,
															467
														],
														[
															685.428,
															456.915
														],
														[
															688,
															448
														],
														[
															698.966,
															389.943
														],
														[
															699,
															324
														],
														[
															685.994,
															256.486
														],
														[
															661,
															196
														],
														[
															588,
															102
														],
														[
															541,
															66
														],
														[
															533,
															62
														],
														[
															531,
															61
														],
														[
															482,
															37
														],
														[
															342,
															15
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 100,
											"s": [
												{
													"i": [
														[
															-0.119,
															0.007
														],
														[
															6.861,
															-0.608
														],
														[
															6.871,
															-1.172
														],
														[
															16.464,
															-5.754
														],
														[
															13.401,
															-6.788
														],
														[
															2.985,
															-1.552
														],
														[
															2.156,
															-1.322
														],
														[
															1.957,
															-1.189
														],
														[
															1.931,
															-0.87
														],
														[
															0.161,
															-0.451
														],
														[
															0.19,
															-0.123
														],
														[
															0.689,
															-0.298
														],
														[
															0.679,
															-0.444
														],
														[
															2.124,
															-1.466
														],
														[
															1.975,
															-1.483
														],
														[
															2.994,
															-2.293
														],
														[
															2.848,
															-2.441
														],
														[
															1.362,
															-1.453
														],
														[
															1.102,
															-0.945
														],
														[
															0.731,
															-0.262
														],
														[
															0.559,
															-0.51
														],
														[
															3.305,
															-3.338
														],
														[
															2.588,
															-2.74
														],
														[
															0.265,
															-0.744
														],
														[
															0.475,
															-0.534
														],
														[
															0.859,
															-0.812
														],
														[
															0.794,
															-0.887
														],
														[
															7.921,
															-11.952
														],
														[
															6.648,
															-13.384
														],
														[
															2.406,
															-4.999
														],
														[
															1.99,
															-5.202
														],
														[
															0.258,
															-1.34
														],
														[
															0.487,
															-1.384
														],
														[
															0.516,
															-1.319
														],
														[
															0.448,
															-1.334
														],
														[
															2.142,
															-8.761
														],
														[
															1.529,
															-9.316
														],
														[
															-13.19,
															-45.969
														],
														[
															-24.465,
															-30.947
														],
														[
															-1.457,
															-2.027
														],
														[
															-1.609,
															-1.913
														],
														[
															-2.334,
															-2.363
														],
														[
															-1.623,
															-2.12
														],
														[
															-3.382,
															-3.001
														],
														[
															-3.468,
															-3.07
														],
														[
															-3.865,
															-3.169
														],
														[
															-8.574,
															-5.879
														],
														[
															-0.999,
															-0.957
														],
														[
															-1.087,
															-0.7
														],
														[
															-0.982,
															-0.605
														],
														[
															-2.363,
															-1.449
														],
														[
															-2.037,
															-1.249
														],
														[
															-19.011,
															-6.091
														],
														[
															-5.964,
															-1.642
														],
														[
															-28.335,
															-1.503
														],
														[
															-9.883,
															2.409
														],
														[
															-1.958,
															1.721
														],
														[
															-1.184,
															1.271
														],
														[
															-0.637,
															0.599
														],
														[
															-3.344,
															1.194
														],
														[
															-5.479,
															1.034
														],
														[
															-15.887,
															6.094
														],
														[
															-10.933,
															5.497
														],
														[
															-4.473,
															2.571
														],
														[
															-2.095,
															1.245
														],
														[
															-6.67,
															3.007
														],
														[
															-0.37,
															0.247
														],
														[
															-0.511,
															0.23
														],
														[
															-0.362,
															0.248
														],
														[
															-0.506,
															0.228
														],
														[
															-0.358,
															0.248
														],
														[
															-6.282,
															5.201
														],
														[
															-0.865,
															0.69
														],
														[
															-1.246,
															1.141
														],
														[
															-3.482,
															3.482
														],
														[
															-6.459,
															7.525
														],
														[
															-1.598,
															1.969
														],
														[
															-1.466,
															1.88
														],
														[
															-1.522,
															2.065
														],
														[
															-4.352,
															6.674
														],
														[
															-6.566,
															14.114
														],
														[
															5.828,
															71.331
														],
														[
															20.635,
															39.075
														],
														[
															5.459,
															8.406
														],
														[
															6.27,
															7.857
														],
														[
															7.049,
															7.338
														],
														[
															3.52,
															3.52
														],
														[
															4.395,
															1.981
														],
														[
															0.295,
															0.246
														],
														[
															16.126,
															9.926
														],
														[
															83.308,
															-3.936
														]
													],
													"o": [
														[
															-6.683,
															0.395
														],
														[
															-6.861,
															0.608
														],
														[
															-18.743,
															3.197
														],
														[
															-16.464,
															5.754
														],
														[
															-2.905,
															1.471
														],
														[
															-2.985,
															1.552
														],
														[
															-2.24,
															1.373
														],
														[
															-1.957,
															1.189
														],
														[
															-0.166,
															0.075
														],
														[
															-0.161,
															0.451
														],
														[
															-0.565,
															0.364
														],
														[
															-0.689,
															0.298
														],
														[
															-2.53,
															1.654
														],
														[
															-2.124,
															1.466
														],
														[
															-3.177,
															2.386
														],
														[
															-2.994,
															2.293
														],
														[
															-1.451,
															1.243
														],
														[
															-1.362,
															1.453
														],
														[
															-0.516,
															0.441
														],
														[
															-0.731,
															0.262
														],
														[
															-3.191,
															2.906
														],
														[
															-3.305,
															3.338
														],
														[
															-0.464,
															0.491
														],
														[
															-0.265,
															0.744
														],
														[
															-0.769,
															0.864
														],
														[
															-0.859,
															0.812
														],
														[
															-9.668,
															10.807
														],
														[
															-7.921,
															11.952
														],
														[
															-2.386,
															4.803
														],
														[
															-2.406,
															4.999
														],
														[
															-0.481,
															1.257
														],
														[
															-0.258,
															1.34
														],
														[
															-0.489,
															1.389
														],
														[
															-0.516,
															1.319
														],
														[
															-2.901,
															8.639
														],
														[
															-2.143,
															8.761
														],
														[
															-9.225,
															56.179
														],
														[
															13.19,
															45.969
														],
														[
															1.564,
															1.978
														],
														[
															1.457,
															2.027
														],
														[
															2.043,
															2.429
														],
														[
															2.334,
															2.363
														],
														[
															3.005,
															3.926
														],
														[
															3.382,
															3.001
														],
														[
															3.68,
															3.258
														],
														[
															8.351,
															6.848
														],
														[
															2.268,
															1.555
														],
														[
															0.817,
															0.783
														],
														[
															1.026,
															0.661
														],
														[
															3.374,
															2.08
														],
														[
															2.803,
															1.719
														],
														[
															16.941,
															10.388
														],
														[
															5.526,
															1.77
														],
														[
															23.647,
															6.511
														],
														[
															11.351,
															0.602
														],
														[
															3.539,
															-0.863
														],
														[
															2.083,
															-1.831
														],
														[
															0.602,
															-0.646
														],
														[
															1.858,
															-1.746
														],
														[
															5.17,
															-1.845
														],
														[
															19.914,
															-3.758
														],
														[
															12.976,
															-4.978
														],
														[
															4.717,
															-2.372
														],
														[
															2.129,
															-1.223
														],
														[
															6.88,
															-4.088
														],
														[
															0.324,
															-0.146
														],
														[
															0.46,
															-0.307
														],
														[
															0.319,
															-0.144
														],
														[
															0.452,
															-0.309
														],
														[
															0.316,
															-0.143
														],
														[
															7.31,
															-5.066
														],
														[
															0.841,
															-0.696
														],
														[
															1.352,
															-1.079
														],
														[
															3.556,
															-3.255
														],
														[
															6.994,
															-6.994
														],
														[
															1.574,
															-1.833
														],
														[
															1.509,
															-1.859
														],
														[
															1.472,
															-1.887
														],
														[
															4.769,
															-6.472
														],
														[
															8.543,
															-13.1
														],
														[
															22.416,
															-48.182
														],
														[
															-3.987,
															-48.795
														],
														[
															-4.955,
															-9.383
														],
														[
															-5.505,
															-8.477
														],
														[
															-6.063,
															-7.597
														],
														[
															-3.274,
															-3.408
														],
														[
															-4.025,
															-4.025
														],
														[
															-0.274,
															-0.124
														],
														[
															-14.561,
															-12.134
														],
														[
															-51.019,
															-31.405
														],
														[
															-0.63,
															0.03
														]
													],
													"v": [
														[
															342,
															16
														],
														[
															321.641,
															17.417
														],
														[
															301,
															20
														],
														[
															247.994,
															33.807
														],
														[
															203,
															53
														],
														[
															193.938,
															57.612
														],
														[
															186,
															62
														],
														[
															179.769,
															65.877
														],
														[
															174,
															69
														],
														[
															173.519,
															69.964
														],
														[
															173,
															71
														],
														[
															171.085,
															71.94
														],
														[
															169,
															73
														],
														[
															162.084,
															77.628
														],
														[
															156,
															82
														],
														[
															146.753,
															88.958
														],
														[
															138,
															96
														],
														[
															133.739,
															100.224
														],
														[
															130,
															104
														],
														[
															128.033,
															104.949
														],
														[
															126,
															106
														],
														[
															116.048,
															115.624
														],
														[
															107,
															125
														],
														[
															106.009,
															126.968
														],
														[
															105,
															129
														],
														[
															102.519,
															131.482
														],
														[
															100,
															134
														],
														[
															73.735,
															168.067
														],
														[
															52,
															206
														],
														[
															44.703,
															220.701
														],
														[
															38,
															236
														],
														[
															37.005,
															239.905
														],
														[
															36,
															244
														],
														[
															34.469,
															248.042
														],
														[
															33,
															252
														],
														[
															25.472,
															277.993
														],
														[
															20,
															305
														],
														[
															28.733,
															459.424
														],
														[
															88,
															576
														],
														[
															92.466,
															582.049
														],
														[
															97,
															588
														],
														[
															103.816,
															595.232
														],
														[
															110,
															602
														],
														[
															119.653,
															612.142
														],
														[
															130,
															621
														],
														[
															141,
															631
														],
														[
															166,
															650
														],
														[
															174,
															655
														],
														[
															176,
															656
														],
														[
															179,
															659
														],
														[
															189,
															664
														],
														[
															196,
															668
														],
														[
															253,
															693
														],
														[
															270,
															698
														],
														[
															347,
															709
														],
														[
															389,
															708
														],
														[
															394,
															706
														],
														[
															399,
															700
														],
														[
															400,
															697
														],
														[
															406,
															695
														],
														[
															423,
															692
														],
														[
															480,
															676
														],
														[
															517,
															660
														],
														[
															530,
															652
														],
														[
															537,
															649
														],
														[
															557,
															636
														],
														[
															558,
															634
														],
														[
															560,
															634
														],
														[
															561,
															632
														],
														[
															563,
															632
														],
														[
															564,
															630
														],
														[
															585,
															614
														],
														[
															587,
															611
														],
														[
															591,
															609
														],
														[
															601,
															598
														],
														[
															622,
															577
														],
														[
															626,
															571
														],
														[
															631,
															566
														],
														[
															635,
															560
														],
														[
															648,
															541
														],
														[
															671,
															501
														],
														[
															702,
															326
														],
														[
															664,
															197
														],
														[
															649,
															170
														],
														[
															631,
															146
														],
														[
															612,
															123
														],
														[
															601,
															113
														],
														[
															589,
															102
														],
														[
															588,
															100
														],
														[
															543,
															67
														],
														[
															343,
															15
														]
													],
													"c": true
												}
											],
											"h": 1
										}
									]
								},
								"o": {
									"a": 0,
									"k": 100
								},
								"x": {
									"a": 0,
									"k": 0
								},
								"nm": "Mask 1"
							},
							{
								"inv": false,
								"mode": "s",
								"pt": {
									"a": 1,
									"k": [
										{
											"t": 0,
											"s": [
												{
													"i": [
														[
															6.505,
															-1.166
														],
														[
															24.181,
															-10.96
														],
														[
															18.82,
															-14.879
														],
														[
															18.004,
															-23.321
														],
														[
															12.065,
															-30.807
														],
														[
															4.183,
															-24.059
														],
														[
															-1.675,
															-26.477
														],
														[
															-1.764,
															-11.938
														],
														[
															-3.105,
															-10.949
														],
														[
															-3.819,
															-10.221
														],
														[
															-4.635,
															-9.22
														],
														[
															-19.769,
															-22.252
														],
														[
															-24.97,
															-16.238
														],
														[
															-29.446,
															-9.7
														],
														[
															-36.678,
															-0.543
														],
														[
															-4.481,
															0.117
														],
														[
															-1.799,
															0.581
														],
														[
															-0.275,
															0.375
														],
														[
															-0.373,
															0.327
														],
														[
															-0.842,
															1.112
														],
														[
															-0.592,
															0.635
														],
														[
															-0.115,
															0.624
														],
														[
															-0.282,
															0.226
														],
														[
															-2.79,
															0.355
														],
														[
															-2.246,
															0.305
														],
														[
															-4.176,
															0.854
														],
														[
															-4.145,
															0.887
														],
														[
															-2.832,
															0.404
														],
														[
															-2.801,
															0.772
														],
														[
															-1.126,
															0.57
														],
														[
															-1.264,
															0.38
														],
														[
															-14.182,
															6.359
														],
														[
															-12.123,
															7.699
														],
														[
															-1.615,
															0.97
														],
														[
															-0.44,
															0.421
														],
														[
															-0.539,
															0.298
														],
														[
															-0.425,
															0.408
														],
														[
															-0.282,
															0.073
														],
														[
															-0.487,
															0.343
														],
														[
															-0.827,
															0.947
														],
														[
															-0.831,
															0.607
														],
														[
															-0.385,
															-0.067
														],
														[
															-0.246,
															0.111
														],
														[
															-0.168,
															0.452
														],
														[
															-0.173,
															0.125
														],
														[
															-1.904,
															1.247
														],
														[
															-1.571,
															0.708
														],
														[
															-0.766,
															0.856
														],
														[
															-0.403,
															0.337
														],
														[
															-0.806,
															0.872
														],
														[
															-0.913,
															0.79
														],
														[
															-1.058,
															0.615
														],
														[
															-0.848,
															0.74
														],
														[
															-0.776,
															1.062
														],
														[
															-0.909,
															0.891
														],
														[
															-3.243,
															2.916
														],
														[
															-2.188,
															2.553
														],
														[
															-0.259,
															0.723
														],
														[
															-0.551,
															0.628
														],
														[
															-1.812,
															1.958
														],
														[
															-0.954,
															2.117
														],
														[
															-0.454,
															0.179
														],
														[
															-0.123,
															0.148
														],
														[
															-3.71,
															5.644
														],
														[
															-3.664,
															6.03
														],
														[
															-8.639,
															31.88
														],
														[
															2.133,
															39.851
														],
														[
															4.134,
															16.834
														],
														[
															5.458,
															13.867
														],
														[
															3.135,
															6.756
														],
														[
															2.769,
															6.143
														],
														[
															0.451,
															0.155
														],
														[
															0.119,
															0.206
														],
														[
															0.824,
															1.78
														],
														[
															0.726,
															1.183
														],
														[
															0.52,
															0.919
														],
														[
															0.304,
															0.317
														],
														[
															0.298,
															0.539
														],
														[
															0.408,
															0.425
														],
														[
															0.298,
															0.539
														],
														[
															0.408,
															0.425
														],
														[
															0.298,
															0.539
														],
														[
															0.408,
															0.425
														],
														[
															0.071,
															0.279
														],
														[
															0.345,
															0.498
														],
														[
															0.918,
															0.787
														],
														[
															0.661,
															0.891
														],
														[
															-0.067,
															0.386
														],
														[
															0.11,
															0.245
														],
														[
															0.451,
															0.166
														],
														[
															0.124,
															0.179
														],
														[
															6.916,
															7.667
														],
														[
															8.292,
															7.611
														],
														[
															16.784,
															10.525
														],
														[
															19.952,
															8.127
														],
														[
															23.411,
															4.379
														],
														[
															27.811,
															-1.478
														],
														[
															0.186,
															-0.247
														],
														[
															-0.058,
															0.004
														],
														[
															6.479,
															-0.603
														]
													],
													"o": [
														[
															-29.457,
															5.283
														],
														[
															-24.18,
															10.96
														],
														[
															-23.921,
															18.91
														],
														[
															-18.004,
															23.321
														],
														[
															-7.944,
															20.286
														],
														[
															-4.183,
															24.059
														],
														[
															0.841,
															13.299
														],
														[
															1.764,
															11.938
														],
														[
															3.09,
															10.898
														],
														[
															3.819,
															10.221
														],
														[
															13.954,
															27.755
														],
														[
															19.769,
															22.252
														],
														[
															22.538,
															14.657
														],
														[
															29.446,
															9.7
														],
														[
															3.279,
															0.048
														],
														[
															4.481,
															-0.117
														],
														[
															0.528,
															-0.17
														],
														[
															0.275,
															-0.375
														],
														[
															1.042,
															-0.916
														],
														[
															0.842,
															-1.112
														],
														[
															0.26,
															-0.279
														],
														[
															0.115,
															-0.624
														],
														[
															1.594,
															-1.276
														],
														[
															2.79,
															-0.355
														],
														[
															5.149,
															-0.698
														],
														[
															4.176,
															-0.854
														],
														[
															2.87,
															-0.613
														],
														[
															2.832,
															-0.404
														],
														[
															1.231,
															-0.339
														],
														[
															1.126,
															-0.57
														],
														[
															16.148,
															-4.865
														],
														[
															14.182,
															-6.359
														],
														[
															1.101,
															-0.699
														],
														[
															1.615,
															-0.97
														],
														[
															0.419,
															-0.401
														],
														[
															0.539,
															-0.298
														],
														[
															0.383,
															-0.366
														],
														[
															0.282,
															-0.073
														],
														[
															0.863,
															-0.607
														],
														[
															0.827,
															-0.947
														],
														[
															0.215,
															-0.157
														],
														[
															0.385,
															0.067
														],
														[
															0.154,
															-0.07
														],
														[
															0.168,
															-0.451
														],
														[
															1.815,
															-1.304
														],
														[
															1.904,
															-1.247
														],
														[
															0.533,
															-0.24
														],
														[
															0.766,
															-0.856
														],
														[
															0.863,
															-0.723
														],
														[
															0.806,
															-0.872
														],
														[
															0.923,
															-0.798
														],
														[
															1.058,
															-0.615
														],
														[
															0.988,
															-0.863
														],
														[
															0.776,
															-1.061
														],
														[
															2.839,
															-2.783
														],
														[
															3.243,
															-2.916
														],
														[
															0.411,
															-0.481
														],
														[
															0.259,
															-0.723
														],
														[
															1.8,
															-2.052
														],
														[
															1.812,
															-1.958
														],
														[
															0.062,
															-0.137
														],
														[
															0.454,
															-0.179
														],
														[
															4.495,
															-5.394
														],
														[
															3.71,
															-5.644
														],
														[
															15.577,
															-25.63
														],
														[
															8.639,
															-31.88
														],
														[
															-1.006,
															-18.797
														],
														[
															-4.134,
															-16.834
														],
														[
															-2.689,
															-6.833
														],
														[
															-3.135,
															-6.756
														],
														[
															-0.079,
															-0.174
														],
														[
															-0.451,
															-0.155
														],
														[
															-0.979,
															-1.696
														],
														[
															-0.824,
															-1.78
														],
														[
															-0.617,
															-1.006
														],
														[
															-0.52,
															-0.919
														],
														[
															-0.401,
															-0.419
														],
														[
															-0.298,
															-0.539
														],
														[
															-0.401,
															-0.419
														],
														[
															-0.298,
															-0.539
														],
														[
															-0.401,
															-0.419
														],
														[
															-0.298,
															-0.539
														],
														[
															-0.371,
															-0.387
														],
														[
															-0.071,
															-0.279
														],
														[
															-0.667,
															-0.962
														],
														[
															-0.918,
															-0.787
														],
														[
															-0.157,
															-0.212
														],
														[
															0.067,
															-0.386
														],
														[
															-0.072,
															-0.158
														],
														[
															-0.451,
															-0.166
														],
														[
															-6.044,
															-8.722
														],
														[
															-6.916,
															-7.667
														],
														[
															-13.913,
															-12.771
														],
														[
															-16.784,
															-10.525
														],
														[
															-19.546,
															-7.962
														],
														[
															-23.411,
															-4.379
														],
														[
															-0.315,
															0.017
														],
														[
															-0.186,
															0.247
														],
														[
															-6.579,
															0.424
														],
														[
															-6.479,
															0.602
														]
													],
													"v": [
														[
															303,
															30
														],
														[
															222.522,
															54.803
														],
														[
															158,
															94
														],
														[
															95.108,
															156.577
														],
														[
															50,
															237
														],
														[
															31.285,
															303.856
														],
														[
															27,
															380
														],
														[
															30.802,
															417.763
														],
														[
															38,
															452
														],
														[
															48.341,
															483.759
														],
														[
															61,
															513
														],
														[
															111.738,
															588.138
														],
														[
															179,
															646
														],
														[
															256.895,
															683.585
														],
														[
															356,
															700
														],
														[
															368.61,
															699.972
														],
														[
															379,
															699
														],
														[
															380.116,
															698.118
														],
														[
															381,
															697
														],
														[
															383.837,
															693.79
														],
														[
															386,
															691
														],
														[
															386.483,
															689.46
														],
														[
															387,
															688
														],
														[
															394.011,
															685.772
														],
														[
															402,
															685
														],
														[
															415.753,
															682.641
														],
														[
															428,
															680
														],
														[
															436.552,
															678.619
														],
														[
															445,
															677
														],
														[
															448.476,
															675.531
														],
														[
															452,
															674
														],
														[
															497.518,
															657.126
														],
														[
															537,
															636
														],
														[
															541.496,
															633.292
														],
														[
															545,
															631
														],
														[
															546.495,
															630.005
														],
														[
															548,
															629
														],
														[
															548.922,
															628.482
														],
														[
															550,
															628
														],
														[
															552.524,
															625.5
														],
														[
															555,
															623
														],
														[
															555.976,
															622.966
														],
														[
															557,
															623
														],
														[
															557.486,
															622.041
														],
														[
															558,
															621
														],
														[
															563.683,
															617.053
														],
														[
															569,
															614
														],
														[
															571.097,
															612.073
														],
														[
															573,
															610
														],
														[
															575.463,
															607.55
														],
														[
															578,
															605
														],
														[
															581.056,
															602.957
														],
														[
															584,
															601
														],
														[
															586.559,
															598.021
														],
														[
															589,
															595
														],
														[
															598.488,
															586.327
														],
														[
															607,
															578
														],
														[
															607.895,
															576.111
														],
														[
															609,
															574
														],
														[
															614.634,
															568.049
														],
														[
															619,
															562
														],
														[
															619.954,
															561.508
														],
														[
															621,
															561
														],
														[
															633.123,
															544.477
														],
														[
															644,
															527
														],
														[
															681.283,
															441.165
														],
														[
															692,
															334
														],
														[
															683.839,
															280.303
														],
														[
															669,
															234
														],
														[
															660.06,
															213.482
														],
														[
															651,
															194
														],
														[
															650.03,
															193.524
														],
														[
															649,
															193
														],
														[
															646.31,
															187.616
														],
														[
															644,
															183
														],
														[
															642.265,
															179.984
														],
														[
															641,
															178
														],
														[
															640.005,
															176.505
														],
														[
															639,
															175
														],
														[
															638.005,
															173.505
														],
														[
															637,
															172
														],
														[
															636.005,
															170.505
														],
														[
															635,
															169
														],
														[
															634.481,
															168.083
														],
														[
															634,
															167
														],
														[
															631.496,
															164.446
														],
														[
															629,
															162
														],
														[
															628.965,
															161.025
														],
														[
															629,
															160
														],
														[
															628.039,
															159.516
														],
														[
															627,
															159
														],
														[
															607.685,
															134.667
														],
														[
															585,
															112
														],
														[
															539.03,
															77.017
														],
														[
															484,
															49
														],
														[
															419.699,
															29.92
														],
														[
															343,
															25
														],
														[
															342.221,
															25.515
														],
														[
															342,
															26
														],
														[
															322.445,
															27.443
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 1,
											"s": [
												{
													"i": [
														[
															12.92,
															-2.371
														],
														[
															11.659,
															-3.371
														],
														[
															9.834,
															-4.215
														],
														[
															1.173,
															-0.507
														],
														[
															1.025,
															-0.422
														],
														[
															5.388,
															-2.723
														],
														[
															4.823,
															-2.792
														],
														[
															6.332,
															-4.128
														],
														[
															5.921,
															-4.581
														],
														[
															17.997,
															-23.462
														],
														[
															12.05,
															-30.617
														],
														[
															4.257,
															-23.951
														],
														[
															-1.16,
															-27.53
														],
														[
															-2.118,
															-11.823
														],
														[
															-2.986,
															-10.889
														],
														[
															-9.271,
															-18.796
														],
														[
															-11.847,
															-15.695
														],
														[
															-10.384,
															-10.47
														],
														[
															-11.375,
															-9.079
														],
														[
															-4.366,
															-3.188
														],
														[
															-4.504,
															-2.03
														],
														[
															-0.163,
															-0.451
														],
														[
															-0.185,
															-0.123
														],
														[
															-0.379,
															0.067
														],
														[
															-0.255,
															-0.115
														],
														[
															-0.161,
															-0.451
														],
														[
															-0.192,
															-0.122
														],
														[
															-0.376,
															0.067
														],
														[
															-0.259,
															-0.117
														],
														[
															-0.155,
															-0.451
														],
														[
															-0.206,
															-0.119
														],
														[
															-0.686,
															-0.319
														],
														[
															-0.631,
															-0.361
														],
														[
															-4.696,
															-2.303
														],
														[
															-4.559,
															-2.124
														],
														[
															-1.128,
															-0.467
														],
														[
															-1.269,
															-0.563
														],
														[
															-1.151,
															-0.745
														],
														[
															-1.258,
															-0.516
														],
														[
															-1.348,
															-0.244
														],
														[
															-1.356,
															-0.51
														],
														[
															-0.541,
															-0.421
														],
														[
															-0.492,
															-0.188
														],
														[
															-0.814,
															-0.089
														],
														[
															-0.855,
															-0.307
														],
														[
															-2.489,
															-1.092
														],
														[
															-2.592,
															-0.753
														],
														[
															-5.716,
															-1.336
														],
														[
															-5.851,
															-1.123
														],
														[
															-14.465,
															-1.14
														],
														[
															-10.828,
															1.54
														],
														[
															-0.554,
															0.232
														],
														[
															-1.008,
															0.817
														],
														[
															-1.184,
															1.796
														],
														[
															-0.947,
															0.747
														],
														[
															-4.61,
															0.625
														],
														[
															-18.556,
															5.967
														],
														[
															-17.964,
															9.813
														],
														[
															-8.584,
															5.724
														],
														[
															-5.73,
															2.584
														],
														[
															-0.358,
															0.248
														],
														[
															-2.956,
															2.412
														],
														[
															-3.42,
															3.01
														],
														[
															-7.718,
															8.847
														],
														[
															-15.416,
															39.824
														],
														[
															4.312,
															55.413
														],
														[
															6.568,
															21.387
														],
														[
															2.669,
															7.283
														],
														[
															0.257,
															0.664
														],
														[
															0.569,
															1.419
														],
														[
															2.163,
															4.722
														],
														[
															0.424,
															0.99
														],
														[
															2.685,
															4.725
														],
														[
															0.687,
															1.523
														],
														[
															0.237,
															0.411
														],
														[
															1.208,
															1.996
														],
														[
															1.13,
															2.507
														],
														[
															0.247,
															0.37
														],
														[
															0.23,
															0.511
														],
														[
															0.247,
															0.37
														],
														[
															0.23,
															0.511
														],
														[
															0.247,
															0.37
														],
														[
															0.23,
															0.511
														],
														[
															0.248,
															0.355
														],
														[
															0.226,
															0.501
														],
														[
															0.249,
															0.346
														],
														[
															1.416,
															3.141
														],
														[
															0.246,
															0.295
														],
														[
															3.666,
															4.156
														],
														[
															0.78,
															0.826
														],
														[
															0.987,
															1.087
														],
														[
															7.655,
															6.777
														],
														[
															4.198,
															1.892
														],
														[
															0.295,
															0.246
														],
														[
															8.302,
															5.22
														],
														[
															0.839,
															0.803
														],
														[
															1.506,
															0.925
														],
														[
															7.039,
															3.507
														],
														[
															68.686,
															-3.651
														],
														[
															-0.115,
															0.007
														]
													],
													"o": [
														[
															-12.53,
															2.3
														],
														[
															-11.659,
															3.371
														],
														[
															-1.283,
															0.55
														],
														[
															-1.173,
															0.507
														],
														[
															-5.626,
															2.314
														],
														[
															-5.388,
															2.723
														],
														[
															-6.752,
															3.909
														],
														[
															-6.332,
															4.128
														],
														[
															-23.962,
															18.536
														],
														[
															-17.997,
															23.462
														],
														[
															-8.134,
															20.667
														],
														[
															-4.257,
															23.951
														],
														[
															0.541,
															12.818
														],
														[
															2.118,
															11.823
														],
														[
															6.067,
															22.12
														],
														[
															9.271,
															18.796
														],
														[
															9.09,
															12.043
														],
														[
															10.384,
															10.47
														],
														[
															4.034,
															3.219
														],
														[
															4.366,
															3.188
														],
														[
															0.162,
															0.073
														],
														[
															0.163,
															0.451
														],
														[
															0.23,
															0.154
														],
														[
															0.379,
															-0.067
														],
														[
															0.166,
															0.075
														],
														[
															0.16,
															0.451
														],
														[
															0.237,
															0.151
														],
														[
															0.376,
															-0.067
														],
														[
															0.174,
															0.079
														],
														[
															0.155,
															0.451
														],
														[
															0.625,
															0.362
														],
														[
															0.686,
															0.319
														],
														[
															4.656,
															2.664
														],
														[
															4.696,
															2.303
														],
														[
															1.218,
															0.567
														],
														[
															1.128,
															0.467
														],
														[
															1.138,
															0.505
														],
														[
															1.151,
															0.745
														],
														[
															1.254,
															0.514
														],
														[
															1.348,
															0.244
														],
														[
															0.344,
															0.13
														],
														[
															0.541,
															0.421
														],
														[
															0.888,
															0.339
														],
														[
															0.814,
															0.089
														],
														[
															2.45,
															0.879
														],
														[
															2.489,
															1.092
														],
														[
															5.284,
															1.534
														],
														[
															5.716,
															1.336
														],
														[
															10.31,
															1.98
														],
														[
															14.465,
															1.14
														],
														[
															1.775,
															-0.253
														],
														[
															0.554,
															-0.232
														],
														[
															1.317,
															-1.068
														],
														[
															1.184,
															-1.796
														],
														[
															3.087,
															-2.437
														],
														[
															21.518,
															-2.92
														],
														[
															20.407,
															-6.562
														],
														[
															8.695,
															-4.749
														],
														[
															6.171,
															-4.115
														],
														[
															0.317,
															-0.143
														],
														[
															3.754,
															-2.602
														],
														[
															4.216,
															-3.44
														],
														[
															9.187,
															-8.087
														],
														[
															24.961,
															-28.614
														],
														[
															15.354,
															-39.662
														],
														[
															-1.943,
															-24.969
														],
														[
															-2.428,
															-7.905
														],
														[
															-0.202,
															-0.55
														],
														[
															-0.632,
															-1.632
														],
														[
															-1.829,
															-4.555
														],
														[
															-0.629,
															-1.373
														],
														[
															-2.625,
															-6.126
														],
														[
															-1.159,
															-2.039
														],
														[
															-0.157,
															-0.349
														],
														[
															-1.316,
															-2.281
														],
														[
															-1.75,
															-2.891
														],
														[
															-0.146,
															-0.324
														],
														[
															-0.307,
															-0.46
														],
														[
															-0.146,
															-0.324
														],
														[
															-0.307,
															-0.46
														],
														[
															-0.146,
															-0.324
														],
														[
															-0.307,
															-0.46
														],
														[
															-0.142,
															-0.314
														],
														[
															-0.311,
															-0.443
														],
														[
															-0.139,
															-0.309
														],
														[
															-2.609,
															-3.63
														],
														[
															-0.124,
															-0.274
														],
														[
															-4.085,
															-4.901
														],
														[
															-0.744,
															-0.844
														],
														[
															-1.112,
															-1.177
														],
														[
															-6.475,
															-7.13
														],
														[
															-3.974,
															-3.518
														],
														[
															-0.274,
															-0.124
														],
														[
															-8.265,
															-6.888
														],
														[
															-2.08,
															-1.308
														],
														[
															-1.615,
															-1.547
														],
														[
															-6.741,
															-4.141
														],
														[
															-44.245,
															-22.045
														],
														[
															-0.629,
															0.033
														],
														[
															-13.04,
															0.84
														]
													],
													"v": [
														[
															302,
															30
														],
														[
															265.478,
															38.564
														],
														[
															233,
															50
														],
														[
															229.307,
															51.596
														],
														[
															226,
															53
														],
														[
															209.397,
															60.642
														],
														[
															194,
															69
														],
														[
															174.377,
															80.996
														],
														[
															156,
															94
														],
														[
															93.066,
															156.439
														],
														[
															48,
															237
														],
														[
															29.029,
															303.853
														],
														[
															24,
															381
														],
														[
															28.166,
															417.947
														],
														[
															36,
															452
														],
														[
															59.165,
															513.319
														],
														[
															91,
															565
														],
														[
															120.286,
															598.723
														],
														[
															153,
															628
														],
														[
															165.647,
															637.892
														],
														[
															179,
															646
														],
														[
															179.483,
															646.962
														],
														[
															180,
															648
														],
														[
															180.981,
															648.029
														],
														[
															182,
															648
														],
														[
															182.481,
															648.964
														],
														[
															183,
															650
														],
														[
															183.983,
															650.026
														],
														[
															185,
															650
														],
														[
															185.477,
															650.97
														],
														[
															186,
															652
														],
														[
															187.996,
															653.001
														],
														[
															190,
															654
														],
														[
															204.073,
															661.405
														],
														[
															218,
															668
														],
														[
															221.462,
															669.503
														],
														[
															225,
															671
														],
														[
															228.41,
															672.991
														],
														[
															232,
															675
														],
														[
															235.923,
															676.004
														],
														[
															240,
															677
														],
														[
															241.389,
															677.957
														],
														[
															243,
															679
														],
														[
															245.525,
															679.524
														],
														[
															248,
															680
														],
														[
															255.393,
															683.095
														],
														[
															263,
															686
														],
														[
															279.574,
															690.308
														],
														[
															297,
															694
														],
														[
															336.111,
															699.14
														],
														[
															376,
															699
														],
														[
															379.075,
															698.424
														],
														[
															381,
															697
														],
														[
															384.778,
															692.259
														],
														[
															388,
															688
														],
														[
															403,
															685
														],
														[
															462,
															672
														],
														[
															519,
															647
														],
														[
															545,
															632
														],
														[
															564,
															619
														],
														[
															565,
															617
														],
														[
															574,
															610
														],
														[
															585,
															601
														],
														[
															611,
															575
														],
														[
															673,
															473
														],
														[
															694,
															331
														],
														[
															681,
															262
														],
														[
															674,
															239
														],
														[
															672,
															236
														],
														[
															671,
															231
														],
														[
															664,
															218
														],
														[
															663,
															214
														],
														[
															654,
															197
														],
														[
															652,
															192
														],
														[
															650,
															191
														],
														[
															647,
															184
														],
														[
															642,
															176
														],
														[
															640,
															175
														],
														[
															640,
															173
														],
														[
															638,
															172
														],
														[
															638,
															170
														],
														[
															636,
															169
														],
														[
															636,
															167
														],
														[
															634,
															166
														],
														[
															634,
															164
														],
														[
															632,
															163
														],
														[
															625,
															152
														],
														[
															623,
															151
														],
														[
															612,
															137
														],
														[
															609,
															135
														],
														[
															607,
															131
														],
														[
															585,
															111
														],
														[
															573,
															101
														],
														[
															572,
															99
														],
														[
															545,
															80
														],
														[
															537,
															75
														],
														[
															532,
															72
														],
														[
															512,
															61
														],
														[
															342,
															25
														],
														[
															341,
															26
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 2,
											"s": [
												{
													"i": [
														[
															6.658,
															-1.172
														],
														[
															2.93,
															-0.613
														],
														[
															2.873,
															-0.684
														],
														[
															2.756,
															-0.729
														],
														[
															2.58,
															-0.749
														],
														[
															14.625,
															-6.626
														],
														[
															12.901,
															-8.186
														],
														[
															11.325,
															-9.467
														],
														[
															9.897,
															-10.469
														],
														[
															3.177,
															-3.846
														],
														[
															3.02,
															-4.079
														],
														[
															2.833,
															-4.193
														],
														[
															2.615,
															-4.19
														],
														[
															2.206,
															-3.646
														],
														[
															2.137,
															-3.791
														],
														[
															1.863,
															-3.75
														],
														[
															1.382,
															-3.522
														],
														[
															0.096,
															-0.619
														],
														[
															0.312,
															-0.746
														],
														[
															0.75,
															-1.143
														],
														[
															0.471,
															-1.159
														],
														[
															0.28,
															-1.42
														],
														[
															0.413,
															-1.173
														],
														[
															0.523,
															-1.339
														],
														[
															0.425,
															-1.266
														],
														[
															3.21,
															-21.492
														],
														[
															-1.036,
															-24.582
														],
														[
															-2.107,
															-12.191
														],
														[
															-3.039,
															-10.594
														],
														[
															-9.463,
															-18.681
														],
														[
															-11.922,
															-15.58
														],
														[
															-26.264,
															-19.393
														],
														[
															-33.201,
															-11.626
														],
														[
															-17.925,
															-3.3
														],
														[
															-19.834,
															-0.383
														],
														[
															-4.847,
															0.37
														],
														[
															-1.865,
															1.61
														],
														[
															-1.212,
															1.832
														],
														[
															-1.03,
															0.707
														],
														[
															-2.711,
															0.361
														],
														[
															-2.37,
															0.33
														],
														[
															-6.838,
															1.519
														],
														[
															-6.622,
															1.809
														],
														[
															-2.901,
															0.601
														],
														[
															-2.673,
															0.853
														],
														[
															-2.285,
															1.075
														],
														[
															-2.38,
															0.909
														],
														[
															-1.346,
															0.246
														],
														[
															-1.319,
															0.519
														],
														[
															-1.119,
															0.74
														],
														[
															-1.313,
															0.562
														],
														[
															-0.69,
															0.117
														],
														[
															-0.517,
															0.221
														],
														[
															-7.332,
															3.999
														],
														[
															-6.207,
															3.803
														],
														[
															-2.576,
															1.557
														],
														[
															-1.469,
															1.408
														],
														[
															-0.539,
															0.298
														],
														[
															-0.425,
															0.408
														],
														[
															-1.165,
															0.998
														],
														[
															-1.174,
															0.892
														],
														[
															-1.958,
															1.423
														],
														[
															-1.839,
															1.541
														],
														[
															-0.512,
															0.301
														],
														[
															-0.474,
															0.395
														],
														[
															-1.75,
															1.886
														],
														[
															-1.293,
															1.032
														],
														[
															-0.716,
															0.256
														],
														[
															-0.587,
															0.538
														],
														[
															-3.289,
															3.751
														],
														[
															-3.207,
															3.667
														],
														[
															-3.235,
															3.619
														],
														[
															-2.863,
															3.871
														],
														[
															-1.298,
															2.014
														],
														[
															-1.397,
															2.038
														],
														[
															-1.318,
															2.193
														],
														[
															-1.346,
															2.215
														],
														[
															-9.013,
															32.637
														],
														[
															3.327,
															41.314
														],
														[
															15.612,
															33.229
														],
														[
															22.174,
															24.124
														],
														[
															1.623,
															1.873
														],
														[
															1.852,
															1.709
														],
														[
															1.046,
															0.592
														],
														[
															0.927,
															0.81
														],
														[
															2.521,
															2.502
														],
														[
															2.977,
															2.425
														],
														[
															6.003,
															4.354
														],
														[
															6.235,
															3.898
														],
														[
															1.577,
															0.69
														],
														[
															0.551,
															0.528
														],
														[
															0.246,
															0.06
														],
														[
															0.588,
															0.35
														],
														[
															7.501,
															3.676
														],
														[
															7.786,
															3.009
														],
														[
															23.585,
															4.196
														],
														[
															27.755,
															-1.475
														],
														[
															0.186,
															-0.247
														],
														[
															-0.058,
															0.004
														],
														[
															6.676,
															-0.6
														]
													],
													"o": [
														[
															-2.928,
															0.516
														],
														[
															-2.93,
															0.613
														],
														[
															-2.873,
															0.684
														],
														[
															-2.756,
															0.729
														],
														[
															-16.498,
															4.788
														],
														[
															-14.625,
															6.626
														],
														[
															-12.901,
															8.186
														],
														[
															-11.325,
															9.467
														],
														[
															-3.304,
															3.495
														],
														[
															-3.177,
															3.846
														],
														[
															-3.02,
															4.079
														],
														[
															-2.833,
															4.193
														],
														[
															-2.068,
															3.312
														],
														[
															-2.206,
															3.646
														],
														[
															-2.137,
															3.791
														],
														[
															-1.863,
															3.75
														],
														[
															-0.305,
															0.779
														],
														[
															-0.096,
															0.619
														],
														[
															-0.531,
															1.268
														],
														[
															-0.75,
															1.143
														],
														[
															-0.466,
															1.147
														],
														[
															-0.28,
															1.42
														],
														[
															-0.485,
															1.379
														],
														[
															-0.523,
															1.339
														],
														[
															-6.194,
															18.451
														],
														[
															-3.21,
															21.492
														],
														[
															0.533,
															12.644
														],
														[
															2.107,
															12.191
														],
														[
															6.224,
															21.698
														],
														[
															9.463,
															18.681
														],
														[
															19.743,
															25.802
														],
														[
															26.264,
															19.393
														],
														[
															15.466,
															5.416
														],
														[
															17.925,
															3.3
														],
														[
															4.746,
															0.091
														],
														[
															4.847,
															-0.37
														],
														[
															1.121,
															-0.967
														],
														[
															1.212,
															-1.832
														],
														[
															1.786,
															-1.225
														],
														[
															2.711,
															-0.361
														],
														[
															8.025,
															-1.115
														],
														[
															6.838,
															-1.519
														],
														[
															2.721,
															-0.744
														],
														[
															2.901,
															-0.601
														],
														[
															2.481,
															-0.792
														],
														[
															2.285,
															-1.075
														],
														[
															1.296,
															-0.495
														],
														[
															1.346,
															-0.246
														],
														[
															1.211,
															-0.476
														],
														[
															1.119,
															-0.74
														],
														[
															0.724,
															-0.31
														],
														[
															0.69,
															-0.117
														],
														[
															7.465,
															-3.199
														],
														[
															7.332,
															-3.999
														],
														[
															2.228,
															-1.365
														],
														[
															2.576,
															-1.557
														],
														[
															0.419,
															-0.401
														],
														[
															0.539,
															-0.298
														],
														[
															1.165,
															-1.116
														],
														[
															1.165,
															-0.998
														],
														[
															2.329,
															-1.769
														],
														[
															1.958,
															-1.423
														],
														[
															0.478,
															-0.4
														],
														[
															0.512,
															-0.301
														],
														[
															1.708,
															-1.423
														],
														[
															1.75,
															-1.886
														],
														[
															0.55,
															-0.439
														],
														[
															0.716,
															-0.256
														],
														[
															3.639,
															-3.331
														],
														[
															3.289,
															-3.751
														],
														[
															3.196,
															-3.654
														],
														[
															3.235,
															-3.619
														],
														[
															1.409,
															-1.906
														],
														[
															1.298,
															-2.014
														],
														[
															1.381,
															-2.014
														],
														[
															1.318,
															-2.193
														],
														[
															15.276,
															-25.136
														],
														[
															9.013,
															-32.638
														],
														[
															-3.38,
															-41.961
														],
														[
															-15.612,
															-33.229
														],
														[
															-1.655,
															-1.8
														],
														[
															-1.623,
															-1.873
														],
														[
															-0.89,
															-0.821
														],
														[
															-1.046,
															-0.592
														],
														[
															-2.938,
															-2.567
														],
														[
															-2.521,
															-2.502
														],
														[
															-5.755,
															-4.688
														],
														[
															-6.002,
															-4.354
														],
														[
															-1.139,
															-0.713
														],
														[
															-1.577,
															-0.69
														],
														[
															-0.427,
															-0.409
														],
														[
															-0.246,
															-0.06
														],
														[
															-7.211,
															-4.285
														],
														[
															-7.501,
															-3.677
														],
														[
															-19.903,
															-7.691
														],
														[
															-23.585,
															-4.196
														],
														[
															-0.315,
															0.017
														],
														[
															-0.186,
															0.247
														],
														[
															-6.639,
															0.428
														],
														[
															-6.676,
															0.6
														]
													],
													"v": [
														[
															301,
															30
														],
														[
															292.197,
															31.699
														],
														[
															283.478,
															33.651
														],
														[
															275.02,
															35.777
														],
														[
															267,
															38
														],
														[
															220.353,
															55.19
														],
														[
															179.1,
															77.478
														],
														[
															142.797,
															104.026
														],
														[
															111,
															134
														],
														[
															101.271,
															145.041
														],
														[
															91.967,
															156.958
														],
														[
															83.18,
															169.396
														],
														[
															75,
															182
														],
														[
															68.538,
															192.484
														],
														[
															61.971,
															203.686
														],
														[
															55.919,
															215.045
														],
														[
															51,
															226
														],
														[
															50.505,
															228.025
														],
														[
															50,
															230
														],
														[
															47.955,
															233.582
														],
														[
															46,
															237
														],
														[
															44.96,
															240.981
														],
														[
															44,
															245
														],
														[
															42.455,
															249.085
														],
														[
															41,
															253
														],
														[
															26.577,
															312.902
														],
														[
															23,
															382
														],
														[
															27.12,
															419.538
														],
														[
															35,
															454
														],
														[
															58.727,
															514.589
														],
														[
															91,
															566
														],
														[
															159.907,
															634.132
														],
														[
															249,
															681
														],
														[
															299.224,
															694.275
														],
														[
															356,
															700
														],
														[
															371.161,
															699.776
														],
														[
															382,
															697
														],
														[
															385.568,
															692.305
														],
														[
															389,
															688
														],
														[
															396.062,
															685.828
														],
														[
															404,
															685
														],
														[
															426.052,
															681.02
														],
														[
															446,
															676
														],
														[
															454.536,
															674.082
														],
														[
															463,
															672
														],
														[
															470.075,
															669.088
														],
														[
															477,
															666
														],
														[
															480.982,
															665.018
														],
														[
															485,
															664
														],
														[
															488.423,
															662.064
														],
														[
															492,
															660
														],
														[
															494.155,
															659.434
														],
														[
															496,
															659
														],
														[
															518.443,
															647.953
														],
														[
															539,
															636
														],
														[
															546.57,
															631.532
														],
														[
															553,
															627
														],
														[
															554.495,
															626.005
														],
														[
															556,
															625
														],
														[
															559.493,
															621.832
														],
														[
															563,
															619
														],
														[
															569.367,
															614.329
														],
														[
															575,
															610
														],
														[
															576.503,
															608.996
														],
														[
															578,
															608
														],
														[
															583.312,
															602.706
														],
														[
															588,
															598
														],
														[
															589.972,
															597.074
														],
														[
															592,
															596
														],
														[
															602.324,
															585.252
														],
														[
															612,
															574
														],
														[
															621.75,
															563.163
														],
														[
															631,
															552
														],
														[
															635.009,
															546.099
														],
														[
															639,
															540
														],
														[
															643.027,
															533.65
														],
														[
															647,
															527
														],
														[
															684.953,
															440.634
														],
														[
															695,
															330
														],
														[
															665.096,
															217.123
														],
														[
															607,
															131
														],
														[
															602.148,
															125.431
														],
														[
															597,
															120
														],
														[
															594.028,
															117.992
														],
														[
															591,
															116
														],
														[
															583.029,
															108.394
														],
														[
															575,
															101
														],
														[
															557.359,
															87.408
														],
														[
															539,
															75
														],
														[
															534.559,
															72.862
														],
														[
															531,
															71
														],
														[
															530.121,
															70.455
														],
														[
															529,
															70
														],
														[
															506.931,
															58.043
														],
														[
															484,
															48
														],
														[
															418.89,
															29.625
														],
														[
															342,
															25
														],
														[
															341.221,
															25.515
														],
														[
															341,
															26
														],
														[
															321.014,
															27.441
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 3,
											"s": [
												{
													"i": [
														[
															13.331,
															-2.447
														],
														[
															20.181,
															-8.078
														],
														[
															16.484,
															-10.32
														],
														[
															2.369,
															-1.637
														],
														[
															2.171,
															-0.979
														],
														[
															0.163,
															-0.451
														],
														[
															0.185,
															-0.124
														],
														[
															0.379,
															0.067
														],
														[
															0.255,
															-0.115
														],
														[
															0.168,
															-0.451
														],
														[
															0.173,
															-0.124
														],
														[
															1.953,
															-1.46
														],
														[
															1.803,
															-1.452
														],
														[
															0.503,
															-0.308
														],
														[
															0.496,
															-0.374
														],
														[
															0.455,
															-0.517
														],
														[
															0.55,
															-0.458
														],
														[
															1.047,
															-0.61
														],
														[
															0.894,
															-0.794
														],
														[
															1.049,
															-1.033
														],
														[
															1.428,
															-0.644
														],
														[
															0.179,
															-0.454
														],
														[
															0.147,
															-0.123
														],
														[
															2.891,
															-2.673
														],
														[
															1.835,
															-2.142
														],
														[
															0.263,
															-0.729
														],
														[
															0.505,
															-0.566
														],
														[
															3.706,
															-4.031
														],
														[
															1.891,
															-4.195
														],
														[
															0.451,
															-0.168
														],
														[
															0.124,
															-0.173
														],
														[
															1.268,
															-2.153
														],
														[
															0.838,
															-0.875
														],
														[
															0.298,
															-0.539
														],
														[
															0.407,
															-0.425
														],
														[
															1,
															-1.367
														],
														[
															0.83,
															-1.31
														],
														[
															-0.067,
															-0.376
														],
														[
															0.117,
															-0.26
														],
														[
															0.247,
															-0.37
														],
														[
															0.23,
															-0.511
														],
														[
															0.241,
															-0.4
														],
														[
															0.677,
															-1.318
														],
														[
															0.619,
															-1.076
														],
														[
															1.151,
															-2.114
														],
														[
															-3.59,
															-67.615
														],
														[
															-18.789,
															-37.995
														],
														[
															-23.278,
															-24.393
														],
														[
															-4.91,
															-4.393
														],
														[
															-2.012,
															-1.688
														],
														[
															-3.903,
															-3.065
														],
														[
															-1.878,
															-1.384
														],
														[
															-6.493,
															-4.169
														],
														[
															-73.654,
															-1.988
														],
														[
															-3.472,
															3.117
														],
														[
															-1.96,
															1.848
														],
														[
															-1.607,
															1.069
														],
														[
															-6.852,
															1.181
														],
														[
															-19.199,
															7.055
														],
														[
															-13.741,
															7.484
														],
														[
															-2.093,
															1.202
														],
														[
															-1.001,
															0.959
														],
														[
															-1.482,
															0.96
														],
														[
															-2.109,
															1.383
														],
														[
															-2.173,
															1.488
														],
														[
															-1.983,
															1.439
														],
														[
															-0.494,
															0.223
														],
														[
															-0.346,
															0.249
														],
														[
															-4.524,
															3.692
														],
														[
															-1.785,
															1.531
														],
														[
															-1.839,
															1.606
														],
														[
															-1.813,
															1.777
														],
														[
															-4.799,
															5.08
														],
														[
															-1.042,
															1.192
														],
														[
															-2.922,
															3.554
														],
														[
															-1.445,
															1.883
														],
														[
															-4.662,
															7.416
														],
														[
															-0.87,
															0.909
														],
														[
															-0.891,
															1.525
														],
														[
															-4.448,
															11.336
														],
														[
															-1.533,
															3.907
														],
														[
															-1.858,
															6.166
														],
														[
															-0.687,
															3.091
														],
														[
															-1.714,
															10.384
														],
														[
															2.264,
															28.384
														],
														[
															8.82,
															24.415
														],
														[
															0.907,
															2.41
														],
														[
															1.036,
															2.539
														],
														[
															0.455,
															1.062
														],
														[
															1.016,
															2.371
														],
														[
															3.938,
															7.128
														],
														[
															23.789,
															21.782
														],
														[
															2.041,
															1.8
														],
														[
															3.735,
															3.071
														],
														[
															1.79,
															1.374
														],
														[
															7.672,
															5.157
														],
														[
															4.776,
															2.744
														],
														[
															1.991,
															1.085
														],
														[
															76.191,
															-4.05
														],
														[
															-0.115,
															0.007
														]
													],
													"o": [
														[
															-23.791,
															4.367
														],
														[
															-20.181,
															8.078
														],
														[
															-2.353,
															1.473
														],
														[
															-2.369,
															1.637
														],
														[
															-0.162,
															0.073
														],
														[
															-0.163,
															0.451
														],
														[
															-0.23,
															0.154
														],
														[
															-0.379,
															-0.067
														],
														[
															-0.154,
															0.07
														],
														[
															-0.168,
															0.451
														],
														[
															-2.385,
															1.709
														],
														[
															-1.953,
															1.46
														],
														[
															-0.491,
															0.395
														],
														[
															-0.503,
															0.308
														],
														[
															-0.628,
															0.475
														],
														[
															-0.455,
															0.517
														],
														[
															-0.92,
															0.766
														],
														[
															-1.047,
															0.61
														],
														[
															-1.375,
															1.223
														],
														[
															-1.049,
															1.033
														],
														[
															-0.137,
															0.062
														],
														[
															-0.179,
															0.454
														],
														[
															-2.599,
															2.166
														],
														[
															-2.891,
															2.673
														],
														[
															-0.443,
															0.517
														],
														[
															-0.263,
															0.729
														],
														[
															-3.286,
															3.682
														],
														[
															-3.706,
															4.031
														],
														[
															-0.07,
															0.154
														],
														[
															-0.451,
															0.168
														],
														[
															-1.089,
															1.515
														],
														[
															-1.268,
															2.153
														],
														[
															-0.401,
															0.419
														],
														[
															-0.298,
															0.539
														],
														[
															-1.171,
															1.221
														],
														[
															-1,
															1.367
														],
														[
															-0.151,
															0.238
														],
														[
															0.067,
															0.376
														],
														[
															-0.146,
															0.324
														],
														[
															-0.307,
															0.46
														],
														[
															-0.154,
															0.342
														],
														[
															-0.779,
															1.293
														],
														[
															-0.529,
															1.029
														],
														[
															-1.295,
															2.25
														],
														[
															-25.819,
															47.416
														],
														[
															2.812,
															52.971
														],
														[
															16.391,
															33.146
														],
														[
															5.216,
															5.466
														],
														[
															1.92,
															1.718
														],
														[
															3.764,
															3.158
														],
														[
															1.744,
															1.369
														],
														[
															6.382,
															4.703
														],
														[
															45.69,
															29.34
														],
														[
															9.066,
															0.245
														],
														[
															1.13,
															-1.015
														],
														[
															2.047,
															-1.93
														],
														[
															5.26,
															-3.499
														],
														[
															23.04,
															-3.972
														],
														[
															15.626,
															-5.742
														],
														[
															2.156,
															-1.174
														],
														[
															2.467,
															-1.417
														],
														[
															1.619,
															-1.551
														],
														[
															2.13,
															-1.379
														],
														[
															2.297,
															-1.506
														],
														[
															1.855,
															-1.271
														],
														[
															0.431,
															-0.313
														],
														[
															0.309,
															-0.139
														],
														[
															5.539,
															-3.981
														],
														[
															1.921,
															-1.568
														],
														[
															1.818,
															-1.558
														],
														[
															1.904,
															-1.663
														],
														[
															5.805,
															-5.689
														],
														[
															0.855,
															-0.905
														],
														[
															3.195,
															-3.652
														],
														[
															1.499,
															-1.823
														],
														[
															5.855,
															-7.631
														],
														[
															1.275,
															-2.028
														],
														[
															1.542,
															-1.61
														],
														[
															6.477,
															-11.084
														],
														[
															2.089,
															-5.323
														],
														[
															2.625,
															-6.69
														],
														[
															1.157,
															-3.839
														],
														[
															2.229,
															-10.031
														],
														[
															3.897,
															-23.602
														],
														[
															-2.537,
															-31.812
														],
														[
															-0.859,
															-2.377
														],
														[
															-0.963,
															-2.558
														],
														[
															-0.609,
															-1.493
														],
														[
															-1.17,
															-2.731
														],
														[
															-3.36,
															-7.84
														],
														[
															-16.728,
															-30.281
														],
														[
															-2.244,
															-2.055
														],
														[
															-3.536,
															-3.118
														],
														[
															-1.724,
															-1.417
														],
														[
															-7.8,
															-5.984
														],
														[
															-4.794,
															-3.222
														],
														[
															-2.058,
															-1.183
														],
														[
															-47.743,
															-26.004
														],
														[
															-0.629,
															0.033
														],
														[
															-13.264,
															0.854
														]
													],
													"v": [
														[
															301,
															30
														],
														[
															235.02,
															49.035
														],
														[
															180,
															77
														],
														[
															172.864,
															81.87
														],
														[
															166,
															86
														],
														[
															165.517,
															86.962
														],
														[
															165,
															88
														],
														[
															164.019,
															88.029
														],
														[
															163,
															88
														],
														[
															162.514,
															88.959
														],
														[
															162,
															90
														],
														[
															155.563,
															94.693
														],
														[
															150,
															99
														],
														[
															148.504,
															100.015
														],
														[
															147,
															101
														],
														[
															145.442,
															102.512
														],
														[
															144,
															104
														],
														[
															140.98,
															105.978
														],
														[
															138,
															108
														],
														[
															134.539,
															111.435
														],
														[
															131,
															114
														],
														[
															130.508,
															114.954
														],
														[
															130,
															116
														],
														[
															121.427,
															123.518
														],
														[
															114,
															131
														],
														[
															113.047,
															132.963
														],
														[
															112,
															135
														],
														[
															100.954,
															146.615
														],
														[
															92,
															159
														],
														[
															91.041,
															159.486
														],
														[
															90,
															160
														],
														[
															86.312,
															165.98
														],
														[
															83,
															171
														],
														[
															82.005,
															172.495
														],
														[
															81,
															174
														],
														[
															77.745,
															177.934
														],
														[
															75,
															182
														],
														[
															74.974,
															182.984
														],
														[
															75,
															184
														],
														[
															73,
															185
														],
														[
															73,
															187
														],
														[
															71,
															188
														],
														[
															70,
															192
														],
														[
															67,
															195
														],
														[
															64,
															202
														],
														[
															24,
															380
														],
														[
															59,
															513
														],
														[
															120,
															599
														],
														[
															136,
															614
														],
														[
															142,
															619
														],
														[
															153,
															629
														],
														[
															159,
															633
														],
														[
															178,
															646
														],
														[
															355,
															700
														],
														[
															382,
															697
														],
														[
															385,
															692
														],
														[
															389,
															688
														],
														[
															413,
															684
														],
														[
															477,
															666
														],
														[
															520,
															647
														],
														[
															526,
															643
														],
														[
															534,
															639
														],
														[
															539,
															636
														],
														[
															545,
															631
														],
														[
															552,
															628
														],
														[
															557,
															623
														],
														[
															559,
															623
														],
														[
															560,
															621
														],
														[
															575,
															610
														],
														[
															580,
															605
														],
														[
															586,
															601
														],
														[
															591,
															595
														],
														[
															609,
															578
														],
														[
															611,
															574
														],
														[
															621,
															564
														],
														[
															625,
															558
														],
														[
															642,
															534
														],
														[
															647,
															526
														],
														[
															650,
															521
														],
														[
															669,
															484
														],
														[
															675,
															469
														],
														[
															681,
															450
														],
														[
															685,
															438
														],
														[
															691,
															408
														],
														[
															694,
															330
														],
														[
															676,
															246
														],
														[
															674,
															238
														],
														[
															670,
															231
														],
														[
															669,
															227
														],
														[
															666,
															220
														],
														[
															654,
															196
														],
														[
															591,
															116
														],
														[
															585,
															111
														],
														[
															575,
															101
														],
														[
															569,
															97
														],
														[
															545,
															80
														],
														[
															532,
															72
														],
														[
															526,
															68
														],
														[
															342,
															25
														],
														[
															341,
															26
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 4,
											"s": [
												{
													"i": [
														[
															12.596,
															-2.288
														],
														[
															15.755,
															-5.495
														],
														[
															13.118,
															-6.776
														],
														[
															8.509,
															-5.333
														],
														[
															7.564,
															-5.811
														],
														[
															1.117,
															-0.864
														],
														[
															1.268,
															-0.572
														],
														[
															0.172,
															-0.452
														],
														[
															0.162,
															-0.124
														],
														[
															1.387,
															-1.04
														],
														[
															1.516,
															-1.356
														],
														[
															2.61,
															-2.688
														],
														[
															2.606,
															-2.606
														],
														[
															1.873,
															-1.581
														],
														[
															1.702,
															-1.869
														],
														[
															0.603,
															-1.054
														],
														[
															0.777,
															-0.894
														],
														[
															0.873,
															-0.813
														],
														[
															0.763,
															-0.889
														],
														[
															3.711,
															-5.137
														],
														[
															3.104,
															-4.724
														],
														[
															0.961,
															-1.612
														],
														[
															0.431,
															-0.451
														],
														[
															0.442,
															-0.859
														],
														[
															0.458,
															-0.756
														],
														[
															3.438,
															-6.465
														],
														[
															2.66,
															-6.209
														],
														[
															0.096,
															-0.638
														],
														[
															0.343,
															-0.814
														],
														[
															0.955,
															-2.434
														],
														[
															0.857,
															-2.339
														],
														[
															0.257,
															-0.664
														],
														[
															0.588,
															-1.714
														],
														[
															2.892,
															-17.663
														],
														[
															-1.176,
															-27.898
														],
														[
															-5.786,
															-21.562
														],
														[
															-27.486,
															-33.431
														],
														[
															-3.263,
															-3.681
														],
														[
															-7.099,
															-6.464
														],
														[
															-1.788,
															-1.628
														],
														[
															-4.22,
															-1.902
														],
														[
															-0.325,
															-0.249
														],
														[
															-3.138,
															-2.497
														],
														[
															-2.095,
															-0.944
														],
														[
															-0.37,
															-0.247
														],
														[
															-0.511,
															-0.23
														],
														[
															-0.372,
															-0.247
														],
														[
															-0.512,
															-0.231
														],
														[
															-0.381,
															-0.245
														],
														[
															-1.186,
															-0.768
														],
														[
															-73.699,
															-1.092
														],
														[
															-4.361,
															1.026
														],
														[
															-0.842,
															0.744
														],
														[
															-2.688,
															2.133
														],
														[
															-0.309,
															0.309
														],
														[
															-0.413,
															0.177
														],
														[
															-4.032,
															0.547
														],
														[
															-7.032,
															1.247
														],
														[
															-1.175,
															0.262
														],
														[
															-5.517,
															1.519
														],
														[
															-2.425,
															0.731
														],
														[
															-20.729,
															11.54
														],
														[
															-8.488,
															5.512
														],
														[
															-1.625,
															1.556
														],
														[
															-2.781,
															1.254
														],
														[
															-0.325,
															0.249
														],
														[
															-0.844,
															0.682
														],
														[
															-4.174,
															1.882
														],
														[
															-0.295,
															0.246
														],
														[
															-2.785,
															2.536
														],
														[
															-1.949,
															1.775
														],
														[
															-3.075,
															3.357
														],
														[
															-1.709,
															1.877
														],
														[
															-1.555,
															1.856
														],
														[
															-1.54,
															1.861
														],
														[
															-6.333,
															10.328
														],
														[
															-0.559,
															0.584
														],
														[
															-0.891,
															1.525
														],
														[
															-4.483,
															11.424
														],
														[
															-1.533,
															3.907
														],
														[
															-1.093,
															3.475
														],
														[
															-1.596,
															5.695
														],
														[
															-0.57,
															2.354
														],
														[
															-1.449,
															8.634
														],
														[
															2.203,
															27.626
														],
														[
															23.983,
															38.467
														],
														[
															0.962,
															1.004
														],
														[
															0.814,
															0.85
														],
														[
															0.814,
															0.85
														],
														[
															0.814,
															0.85
														],
														[
															0.69,
															0.995
														],
														[
															1.311,
															1.766
														],
														[
															0.22,
															0.489
														],
														[
															0.248,
															0.358
														],
														[
															2.467,
															3.023
														],
														[
															2.904,
															3.325
														],
														[
															1.81,
															1.914
														],
														[
															79.355,
															14.121
														],
														[
															27.432,
															-1.611
														],
														[
															-0.112,
															0.008
														]
													],
													"o": [
														[
															-17.86,
															3.245
														],
														[
															-15.756,
															5.495
														],
														[
															-9.401,
															4.856
														],
														[
															-8.509,
															5.333
														],
														[
															-1.263,
															0.971
														],
														[
															-1.117,
															0.864
														],
														[
															-0.147,
															0.066
														],
														[
															-0.173,
															0.452
														],
														[
															-1.938,
															1.483
														],
														[
															-1.387,
															1.04
														],
														[
															-2.953,
															2.642
														],
														[
															-2.61,
															2.688
														],
														[
															-1.805,
															1.805
														],
														[
															-1.873,
															1.582
														],
														[
															-0.809,
															0.889
														],
														[
															-0.603,
															1.054
														],
														[
															-0.746,
															0.858
														],
														[
															-0.873,
															0.813
														],
														[
															-4.053,
															4.728
														],
														[
															-3.711,
															5.137
														],
														[
															-0.725,
															1.103
														],
														[
															-0.961,
															1.612
														],
														[
															-0.773,
															0.807
														],
														[
															-0.442,
															0.859
														],
														[
															-3.59,
															5.932
														],
														[
															-3.437,
															6.465
														],
														[
															-0.271,
															0.632
														],
														[
															-0.096,
															0.638
														],
														[
															-0.901,
															2.133
														],
														[
															-0.908,
															2.314
														],
														[
															-0.202,
															0.55
														],
														[
															-0.574,
															1.482
														],
														[
															-5.557,
															16.207
														],
														[
															-4.048,
															24.723
														],
														[
															1.072,
															25.438
														],
														[
															13.179,
															49.114
														],
														[
															3.16,
															3.844
														],
														[
															6.706,
															7.565
														],
														[
															1.809,
															1.647
														],
														[
															3.962,
															3.609
														],
														[
															0.295,
															0.133
														],
														[
															3.85,
															2.947
														],
														[
															2.723,
															2.167
														],
														[
															0.324,
															0.146
														],
														[
															0.46,
															0.307
														],
														[
															0.325,
															0.147
														],
														[
															0.462,
															0.306
														],
														[
															0.331,
															0.149
														],
														[
															1.147,
															0.738
														],
														[
															45.379,
															29.386
														],
														[
															7.321,
															0.108
														],
														[
															1.375,
															-0.323
														],
														[
															3.114,
															-2.749
														],
														[
															0.337,
															-0.267
														],
														[
															0.304,
															-0.304
														],
														[
															3.269,
															-1.401
														],
														[
															8.323,
															-1.129
														],
														[
															1.287,
															-0.228
														],
														[
															5.674,
															-1.264
														],
														[
															2.482,
															-0.683
														],
														[
															25.164,
															-7.581
														],
														[
															8.699,
															-4.843
														],
														[
															2.771,
															-1.8
														],
														[
															2.81,
															-2.692
														],
														[
															0.295,
															-0.133
														],
														[
															1.132,
															-0.866
														],
														[
															4.106,
															-3.317
														],
														[
															0.274,
															-0.124
														],
														[
															3.293,
															-2.744
														],
														[
															1.807,
															-1.646
														],
														[
															3.827,
															-3.485
														],
														[
															1.715,
															-1.872
														],
														[
															1.596,
															-1.752
														],
														[
															1.56,
															-1.862
														],
														[
															8.312,
															-10.042
														],
														[
															1.147,
															-1.87
														],
														[
															1.542,
															-1.61
														],
														[
															6.472,
															-11.075
														],
														[
															2.089,
															-5.323
														],
														[
															1.656,
															-4.219
														],
														[
															1.677,
															-5.331
														],
														[
															0.678,
															-2.419
														],
														[
															2.336,
															-9.657
														],
														[
															3.927,
															-23.396
														],
														[
															-4.688,
															-58.776
														],
														[
															-1.435,
															-2.301
														],
														[
															-0.803,
															-0.838
														],
														[
															-0.803,
															-0.838
														],
														[
															-0.803,
															-0.838
														],
														[
															-0.743,
															-0.775
														],
														[
															-1.272,
															-1.834
														],
														[
															-0.314,
															-0.423
														],
														[
															-0.143,
															-0.317
														],
														[
															-2.624,
															-3.786
														],
														[
															-3.267,
															-4.004
														],
														[
															-1.737,
															-1.988
														],
														[
															-45.223,
															-47.835
														],
														[
															-23.05,
															-4.102
														],
														[
															-0.628,
															0.037
														],
														[
															-13.127,
															0.91
														]
													],
													"v": [
														[
															302,
															30
														],
														[
															251.444,
															43.352
														],
														[
															208,
															62
														],
														[
															181.122,
															77.283
														],
														[
															157,
															94
														],
														[
															153.503,
															96.799
														],
														[
															150,
															99
														],
														[
															149.511,
															99.957
														],
														[
															149,
															101
														],
														[
															144.184,
															104.595
														],
														[
															140,
															108
														],
														[
															131.74,
															116.027
														],
														[
															124,
															124
														],
														[
															118.423,
															128.952
														],
														[
															113,
															134
														],
														[
															110.976,
															136.996
														],
														[
															109,
															140
														],
														[
															106.512,
															142.477
														],
														[
															104,
															145
														],
														[
															92.289,
															160.003
														],
														[
															82,
															175
														],
														[
															79.28,
															179.489
														],
														[
															77,
															183
														],
														[
															75.263,
															185.538
														],
														[
															74,
															188
														],
														[
															63.303,
															206.793
														],
														[
															54,
															226
														],
														[
															53.554,
															227.864
														],
														[
															53,
															230
														],
														[
															49,
															237
														],
														[
															47,
															245
														],
														[
															45,
															248
														],
														[
															44,
															253
														],
														[
															31,
															303
														],
														[
															26,
															382
														],
														[
															38,
															453
														],
														[
															102,
															577
														],
														[
															112,
															588
														],
														[
															132,
															610
														],
														[
															138,
															614
														],
														[
															150,
															624
														],
														[
															151,
															626
														],
														[
															160,
															633
														],
														[
															168,
															638
														],
														[
															169,
															640
														],
														[
															171,
															640
														],
														[
															172,
															642
														],
														[
															174,
															642
														],
														[
															175,
															644
														],
														[
															179,
															646
														],
														[
															356,
															700
														],
														[
															379,
															699
														],
														[
															381,
															697
														],
														[
															388,
															689
														],
														[
															388,
															687
														],
														[
															390,
															687
														],
														[
															402,
															685
														],
														[
															424,
															682
														],
														[
															428,
															680
														],
														[
															445,
															677
														],
														[
															452,
															674
														],
														[
															518,
															647
														],
														[
															544,
															632
														],
														[
															554,
															625
														],
														[
															563,
															619
														],
														[
															564,
															617
														],
														[
															568,
															615
														],
														[
															580,
															605
														],
														[
															581,
															603
														],
														[
															589,
															595
														],
														[
															595,
															591
														],
														[
															604,
															580
														],
														[
															610,
															575
														],
														[
															614,
															569
														],
														[
															619,
															564
														],
														[
															642,
															531
														],
														[
															645,
															526
														],
														[
															648,
															521
														],
														[
															667,
															484
														],
														[
															673,
															469
														],
														[
															677,
															458
														],
														[
															681,
															441
														],
														[
															684,
															434
														],
														[
															689,
															408
														],
														[
															692,
															331
														],
														[
															645,
															184
														],
														[
															640,
															176
														],
														[
															638,
															173
														],
														[
															636,
															170
														],
														[
															634,
															167
														],
														[
															633,
															165
														],
														[
															628,
															160
														],
														[
															628,
															158
														],
														[
															626,
															157
														],
														[
															619,
															148
														],
														[
															610,
															137
														],
														[
															605,
															131
														],
														[
															419,
															30
														],
														[
															342,
															25
														],
														[
															341,
															26
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 5,
											"s": [
												{
													"i": [
														[
															12.806,
															-2.327
														],
														[
															21.243,
															-9.147
														],
														[
															17.164,
															-11.712
														],
														[
															0.757,
															-0.332
														],
														[
															0.448,
															-0.316
														],
														[
															0.769,
															-0.902
														],
														[
															0.931,
															-0.692
														],
														[
															0.386,
															0.067
														],
														[
															0.245,
															-0.11
														],
														[
															0.166,
															-0.451
														],
														[
															0.179,
															-0.124
														],
														[
															0.704,
															-0.282
														],
														[
															0.534,
															-0.419
														],
														[
															1.786,
															-1.721
														],
														[
															1.883,
															-1.567
														],
														[
															1.047,
															-0.61
														],
														[
															0.894,
															-0.794
														],
														[
															2.654,
															-2.704
														],
														[
															2.505,
															-2.626
														],
														[
															1.663,
															-1.865
														],
														[
															1.743,
															-1.858
														],
														[
															4.182,
															-5.303
														],
														[
															3.75,
															-4.964
														],
														[
															0.565,
															-0.492
														],
														[
															0.327,
															-0.484
														],
														[
															0.679,
															-1.578
														],
														[
															0.489,
															-0.511
														],
														[
															0.652,
															-0.805
														],
														[
															0.549,
															-0.899
														],
														[
															0.693,
															-1.57
														],
														[
															0.486,
															-0.507
														],
														[
															0.427,
															-0.828
														],
														[
															0.489,
															-0.846
														],
														[
															2.287,
															-4.576
														],
														[
															2.172,
															-5.058
														],
														[
															0.939,
															-1.797
														],
														[
															0.501,
															-1.079
														],
														[
															0.089,
															-0.87
														],
														[
															0.317,
															-0.817
														],
														[
															1.914,
															-4.977
														],
														[
															1.475,
															-5.283
														],
														[
															1.376,
															-5.701
														],
														[
															0.983,
															-5.777
														],
														[
															-1.367,
															-26.12
														],
														[
															-5.735,
															-20.827
														],
														[
															-19.542,
															-29.363
														],
														[
															-26.542,
															-21.183
														],
														[
															-4.436,
															-3.224
														],
														[
															-4.274,
															-1.927
														],
														[
															-0.163,
															-0.451
														],
														[
															-0.185,
															-0.123
														],
														[
															-0.379,
															0.067
														],
														[
															-0.255,
															-0.115
														],
														[
															-0.158,
															-0.451
														],
														[
															-0.197,
															-0.121
														],
														[
															-1.236,
															-0.44
														],
														[
															-1.06,
															-0.625
														],
														[
															-2.132,
															-1.375
														],
														[
															-2.265,
															-1.199
														],
														[
															-2.335,
															-1.165
														],
														[
															-2.397,
															-1.141
														],
														[
															-2.353,
															-1.232
														],
														[
															-2.04,
															-0.861
														],
														[
															-1.4,
															-0.258
														],
														[
															-1.24,
															-0.477
														],
														[
															-0.54,
															-0.418
														],
														[
															-0.492,
															-0.193
														],
														[
															-0.612,
															-0.106
														],
														[
															-0.768,
															-0.269
														],
														[
															-17.576,
															-3.511
														],
														[
															-20.111,
															-0.497
														],
														[
															-4.144,
															0.135
														],
														[
															-2.373,
															0.558
														],
														[
															-1.502,
															2.426
														],
														[
															-1.068,
															0.843
														],
														[
															-2.774,
															0.357
														],
														[
															-2.322,
															0.323
														],
														[
															-1.543,
															0.141
														],
														[
															-1.414,
															0.238
														],
														[
															-2.663,
															0.739
														],
														[
															-2.616,
															0.582
														],
														[
															-2.877,
															0.406
														],
														[
															-2.678,
															0.75
														],
														[
															-1.121,
															0.567
														],
														[
															-1.265,
															0.38
														],
														[
															-5.552,
															2.179
														],
														[
															-0.946,
															0.364
														],
														[
															-2.577,
															1.015
														],
														[
															-2.626,
															1.128
														],
														[
															-4.544,
															2.247
														],
														[
															-29.168,
															33.663
														],
														[
															-14.866,
															40.526
														],
														[
															2.795,
															56.091
														],
														[
															3.606,
															15.556
														],
														[
															1.96,
															6.379
														],
														[
															13.986,
															22.151
														],
														[
															5.959,
															7.788
														],
														[
															58.895,
															23.525
														],
														[
															55.399,
															-2.944
														],
														[
															-0.115,
															0.007
														]
													],
													"o": [
														[
															-25.863,
															4.698
														],
														[
															-21.243,
															9.147
														],
														[
															-0.523,
															0.357
														],
														[
															-0.757,
															0.332
														],
														[
															-0.994,
															0.701
														],
														[
															-0.769,
															0.902
														],
														[
															-0.212,
															0.157
														],
														[
															-0.386,
															-0.067
														],
														[
															-0.159,
															0.072
														],
														[
															-0.166,
															0.451
														],
														[
															-0.651,
															0.451
														],
														[
															-0.704,
															0.282
														],
														[
															-1.974,
															1.549
														],
														[
															-1.786,
															1.721
														],
														[
															-0.92,
															0.766
														],
														[
															-1.047,
															0.61
														],
														[
															-2.879,
															2.559
														],
														[
															-2.654,
															2.704
														],
														[
															-1.603,
															1.68
														],
														[
															-1.663,
															1.865
														],
														[
															-4.523,
															4.823
														],
														[
															-4.182,
															5.303
														],
														[
															-0.415,
															0.548
														],
														[
															-0.565,
															0.492
														],
														[
															-0.793,
															1.176
														],
														[
															-0.679,
															1.578
														],
														[
															-0.844,
															0.881
														],
														[
															-0.652,
															0.805
														],
														[
															-0.743,
															1.215
														],
														[
															-0.693,
															1.57
														],
														[
															-0.805,
															0.841
														],
														[
															-0.427,
															0.828
														],
														[
															-2.678,
															4.639
														],
														[
															-2.287,
															4.576
														],
														[
															-0.745,
															1.734
														],
														[
															-0.939,
															1.797
														],
														[
															-0.326,
															0.704
														],
														[
															-0.089,
															0.87
														],
														[
															-1.867,
															4.808
														],
														[
															-1.914,
															4.977
														],
														[
															-1.513,
															5.418
														],
														[
															-1.376,
															5.701
														],
														[
															-4.201,
															24.694
														],
														[
															1.366,
															26.12
														],
														[
															10.29,
															37.367
														],
														[
															19.542,
															29.363
														],
														[
															3.982,
															3.178
														],
														[
															4.436,
															3.224
														],
														[
															0.162,
															0.073
														],
														[
															0.163,
															0.451
														],
														[
															0.23,
															0.154
														],
														[
															0.379,
															-0.067
														],
														[
															0.169,
															0.077
														],
														[
															0.158,
															0.451
														],
														[
															0.998,
															0.613
														],
														[
															1.236,
															0.441
														],
														[
															2.207,
															1.302
														],
														[
															2.132,
															1.375
														],
														[
															2.264,
															1.199
														],
														[
															2.335,
															1.165
														],
														[
															2.547,
															1.212
														],
														[
															2.353,
															1.232
														],
														[
															1.161,
															0.49
														],
														[
															1.4,
															0.258
														],
														[
															0.347,
															0.134
														],
														[
															0.54,
															0.418
														],
														[
															0.782,
															0.307
														],
														[
															0.613,
															0.106
														],
														[
															15.586,
															5.458
														],
														[
															17.576,
															3.511
														],
														[
															4.049,
															0.1
														],
														[
															4.144,
															-0.135
														],
														[
															1.923,
															-0.452
														],
														[
															1.502,
															-2.426
														],
														[
															1.582,
															-1.25
														],
														[
															2.774,
															-0.357
														],
														[
															1.413,
															-0.197
														],
														[
															1.543,
															-0.141
														],
														[
															2.731,
															-0.461
														],
														[
															2.663,
															-0.739
														],
														[
															2.813,
															-0.627
														],
														[
															2.877,
															-0.406
														],
														[
															1.25,
															-0.351
														],
														[
															1.121,
															-0.567
														],
														[
															7.233,
															-2.175
														],
														[
															1.182,
															-0.464
														],
														[
															2.646,
															-1.018
														],
														[
															2.422,
															-0.954
														],
														[
															4.807,
															-2.065
														],
														[
															41.652,
															-20.597
														],
														[
															24.968,
															-28.815
														],
														[
															14.414,
															-39.293
														],
														[
															-0.887,
															-17.799
														],
														[
															-1.997,
															-8.614
														],
														[
															-8.751,
															-28.478
														],
														[
															-5.307,
															-8.404
														],
														[
															-35.02,
															-45.767
														],
														[
															-39.087,
															-15.613
														],
														[
															-0.629,
															0.033
														],
														[
															-12.942,
															0.833
														]
													],
													"v": [
														[
															303,
															30
														],
														[
															232.475,
															51.24
														],
														[
															175,
															83
														],
														[
															172.944,
															84.03
														],
														[
															171,
															85
														],
														[
															168.453,
															87.506
														],
														[
															166,
															90
														],
														[
															165.025,
															90.035
														],
														[
															164,
															90
														],
														[
															163.515,
															90.961
														],
														[
															163,
															92
														],
														[
															160.912,
															93.024
														],
														[
															159,
															94
														],
														[
															153.432,
															98.987
														],
														[
															148,
															104
														],
														[
															144.98,
															105.978
														],
														[
															142,
															108
														],
														[
															133.72,
															115.95
														],
														[
															126,
															124
														],
														[
															121.105,
															129.367
														],
														[
															116,
															135
														],
														[
															102.92,
															150.394
														],
														[
															91,
															166
														],
														[
															89.434,
															167.548
														],
														[
															88,
															169
														],
														[
															85.772,
															173.499
														],
														[
															84,
															177
														],
														[
															81.779,
															179.486
														],
														[
															80,
															182
														],
														[
															77.807,
															186.531
														],
														[
															76,
															190
														],
														[
															74.263,
															192.496
														],
														[
															73,
															195
														],
														[
															65.621,
															208.686
														],
														[
															59,
															223
														],
														[
															56.317,
															228.491
														],
														[
															54,
															233
														],
														[
															53.493,
															235.415
														],
														[
															53,
															238
														],
														[
															47.206,
															252.644
														],
														[
															42,
															268
														],
														[
															37.602,
															284.731
														],
														[
															34,
															302
														],
														[
															30.048,
															379.9
														],
														[
															41,
															452
														],
														[
															86.311,
															552.138
														],
														[
															156,
															628
														],
														[
															168.781,
															637.939
														],
														[
															182,
															646
														],
														[
															182.483,
															646.962
														],
														[
															183,
															648
														],
														[
															183.981,
															648.029
														],
														[
															185,
															648
														],
														[
															185.479,
															648.967
														],
														[
															186,
															650
														],
														[
															189.453,
															651.491
														],
														[
															193,
															653
														],
														[
															199.457,
															657.077
														],
														[
															206,
															661
														],
														[
															212.9,
															664.543
														],
														[
															220,
															668
														],
														[
															227.381,
															671.764
														],
														[
															234,
															675
														],
														[
															237.941,
															676.009
														],
														[
															242,
															677
														],
														[
															243.392,
															677.955
														],
														[
															245,
															679
														],
														[
															247.01,
															679.529
														],
														[
															249,
															680
														],
														[
															298.606,
															693.721
														],
														[
															355,
															700
														],
														[
															367.757,
															699.994
														],
														[
															378,
															699
														],
														[
															383.141,
															693.793
														],
														[
															387,
															688
														],
														[
															393.945,
															685.805
														],
														[
															402,
															685
														],
														[
															406.499,
															684.531
														],
														[
															411,
															684
														],
														[
															419.086,
															682.091
														],
														[
															427,
															680
														],
														[
															435.601,
															678.593
														],
														[
															444,
															677
														],
														[
															447.489,
															675.523
														],
														[
															451,
															674
														],
														[
															471,
															668
														],
														[
															474,
															666
														],
														[
															482,
															664
														],
														[
															489,
															660
														],
														[
															503,
															654
														],
														[
															607,
															574
														],
														[
															668,
															472
														],
														[
															689,
															332
														],
														[
															681,
															280
														],
														[
															674,
															256
														],
														[
															639,
															179
														],
														[
															622,
															155
														],
														[
															483,
															49
														],
														[
															343,
															25
														],
														[
															342,
															26
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 6,
											"s": [
												{
													"i": [
														[
															6.34,
															-1.212
														],
														[
															8.855,
															-2.505
														],
														[
															8.282,
															-3.096
														],
														[
															7.536,
															-3.543
														],
														[
															6.618,
															-3.846
														],
														[
															0.445,
															-0.189
														],
														[
															0.403,
															-0.133
														],
														[
															0.382,
															-0.128
														],
														[
															0.381,
															-0.172
														],
														[
															0.078,
															-0.176
														],
														[
															0.078,
															-0.225
														],
														[
															0.086,
															-0.187
														],
														[
															0.1,
															-0.06
														],
														[
															1.502,
															-0.645
														],
														[
															0.625,
															-0.599
														],
														[
															1.217,
															-0.621
														],
														[
															1.041,
															-0.469
														],
														[
															0.163,
															-0.451
														],
														[
															0.185,
															-0.124
														],
														[
															0.379,
															0.067
														],
														[
															0.255,
															-0.115
														],
														[
															0.166,
															-0.451
														],
														[
															0.179,
															-0.124
														],
														[
															0.381,
															0.067
														],
														[
															0.251,
															-0.114
														],
														[
															0.727,
															-0.846
														],
														[
															0.443,
															-0.321
														],
														[
															9.16,
															-8.082
														],
														[
															8.135,
															-9.263
														],
														[
															2.976,
															-3.862
														],
														[
															2.855,
															-3.861
														],
														[
															0.569,
															-0.77
														],
														[
															0.203,
															-0.213
														],
														[
															0.298,
															-0.539
														],
														[
															0.407,
															-0.425
														],
														[
															0.298,
															-0.539
														],
														[
															0.407,
															-0.425
														],
														[
															0.298,
															-0.539
														],
														[
															0.407,
															-0.425
														],
														[
															0.298,
															-0.539
														],
														[
															0.407,
															-0.425
														],
														[
															0.298,
															-0.539
														],
														[
															0.407,
															-0.425
														],
														[
															0.065,
															-0.262
														],
														[
															0.35,
															-0.543
														],
														[
															0.593,
															-0.5
														],
														[
															0.299,
															-0.489
														],
														[
															0.445,
															-1.244
														],
														[
															0.596,
															-1.002
														],
														[
															0.693,
															-0.976
														],
														[
															0.592,
															-1.022
														],
														[
															2.326,
															-4.676
														],
														[
															1.978,
															-4.599
														],
														[
															5.399,
															-26.767
														],
														[
															-1.752,
															-29.647
														],
														[
															-5.878,
															-21.776
														],
														[
															-8.992,
															-18.572
														],
														[
															-11.489,
															-16.017
														],
														[
															-14.037,
															-13.324
														],
														[
															-16.133,
															-10.944
														],
														[
															-20.522,
															-8.984
														],
														[
															-16.933,
															-4.485
														],
														[
															-18.278,
															-1.372
														],
														[
															-5.112,
															-0.236
														],
														[
															-4.634,
															0.313
														],
														[
															-2.378,
															0.119
														],
														[
															-1.134,
															0.366
														],
														[
															-0.275,
															0.375
														],
														[
															-0.373,
															0.327
														],
														[
															-1.115,
															1.746
														],
														[
															-1.127,
															0.774
														],
														[
															-4.455,
															0.391
														],
														[
															-3.512,
															0.606
														],
														[
															-9.279,
															2.63
														],
														[
															-8.271,
															2.824
														],
														[
															-4.273,
															1.779
														],
														[
															-3.626,
															1.423
														],
														[
															-0.471,
															0.382
														],
														[
															-0.497,
															0.228
														],
														[
															-18.352,
															13.915
														],
														[
															-14.921,
															17.407
														],
														[
															-10.245,
															17.082
														],
														[
															-7.085,
															19.749
														],
														[
															-3.698,
															23.284
														],
														[
															1.923,
															26.99
														],
														[
															6.054,
															21.016
														],
														[
															9.026,
															18.252
														],
														[
															18.029,
															20.396
														],
														[
															22.63,
															15.617
														],
														[
															1.591,
															0.934
														],
														[
															0.502,
															0.481
														],
														[
															0.861,
															0.438
														],
														[
															0.746,
															0.474
														],
														[
															7.825,
															3.98
														],
														[
															8.294,
															3.379
														],
														[
															23.165,
															4.517
														],
														[
															26.896,
															-1.58
														],
														[
															0.186,
															-0.246
														],
														[
															-0.056,
															0.004
														],
														[
															6.56,
															-0.586
														]
													],
													"o": [
														[
															-9.255,
															1.768
														],
														[
															-8.855,
															2.505
														],
														[
															-8.282,
															3.096
														],
														[
															-7.536,
															3.543
														],
														[
															-0.508,
															0.295
														],
														[
															-0.445,
															0.189
														],
														[
															-0.403,
															0.133
														],
														[
															-0.382,
															0.128
														],
														[
															-0.086,
															0.039
														],
														[
															-0.078,
															0.176
														],
														[
															-0.078,
															0.225
														],
														[
															-0.086,
															0.187
														],
														[
															-1.367,
															0.82
														],
														[
															-1.502,
															0.645
														],
														[
															-1.091,
															1.046
														],
														[
															-1.217,
															0.621
														],
														[
															-0.162,
															0.073
														],
														[
															-0.163,
															0.451
														],
														[
															-0.23,
															0.154
														],
														[
															-0.379,
															-0.067
														],
														[
															-0.159,
															0.072
														],
														[
															-0.166,
															0.451
														],
														[
															-0.224,
															0.155
														],
														[
															-0.381,
															-0.067
														],
														[
															-0.65,
															0.293
														],
														[
															-0.727,
															0.846
														],
														[
															-10.226,
															7.409
														],
														[
															-9.16,
															8.082
														],
														[
															-3.24,
															3.69
														],
														[
															-2.976,
															3.862
														],
														[
															-0.522,
															0.706
														],
														[
															-0.569,
															0.77
														],
														[
															-0.401,
															0.419
														],
														[
															-0.298,
															0.539
														],
														[
															-0.401,
															0.419
														],
														[
															-0.298,
															0.539
														],
														[
															-0.401,
															0.419
														],
														[
															-0.298,
															0.539
														],
														[
															-0.401,
															0.419
														],
														[
															-0.298,
															0.539
														],
														[
															-0.401,
															0.419
														],
														[
															-0.298,
															0.539
														],
														[
															-0.392,
															0.409
														],
														[
															-0.065,
															0.262
														],
														[
															-0.329,
															0.511
														],
														[
															-0.593,
															0.5
														],
														[
															-0.624,
															1.02
														],
														[
															-0.445,
															1.244
														],
														[
															-0.638,
															1.074
														],
														[
															-0.692,
															0.976
														],
														[
															-2.719,
															4.697
														],
														[
															-2.326,
															4.676
														],
														[
															-9.157,
															21.285
														],
														[
															-5.399,
															26.767
														],
														[
															1.497,
															25.322
														],
														[
															5.878,
															21.776
														],
														[
															9.009,
															18.608
														],
														[
															11.489,
															16.017
														],
														[
															13.948,
															13.239
														],
														[
															16.133,
															10.944
														],
														[
															12.988,
															5.686
														],
														[
															16.933,
															4.485
														],
														[
															4.917,
															0.369
														],
														[
															5.112,
															0.236
														],
														[
															2.356,
															-0.159
														],
														[
															2.378,
															-0.119
														],
														[
															0.528,
															-0.17
														],
														[
															0.275,
															-0.375
														],
														[
															1.411,
															-1.24
														],
														[
															1.115,
															-1.746
														],
														[
															2.668,
															-1.831
														],
														[
															4.455,
															-0.391
														],
														[
															9.611,
															-1.657
														],
														[
															9.279,
															-2.63
														],
														[
															4.283,
															-1.462
														],
														[
															4.273,
															-1.779
														],
														[
															0.619,
															-0.243
														],
														[
															0.471,
															-0.382
														],
														[
															21.67,
															-9.932
														],
														[
															18.352,
															-13.915
														],
														[
															11.935,
															-13.923
														],
														[
															10.245,
															-17.082
														],
														[
															7.13,
															-19.874
														],
														[
															3.698,
															-23.284
														],
														[
															-1.759,
															-24.685
														],
														[
															-6.054,
															-21.016
														],
														[
															-13.253,
															-26.799
														],
														[
															-18.029,
															-20.396
														],
														[
															-1.134,
															-0.782
														],
														[
															-1.591,
															-0.934
														],
														[
															-0.808,
															-0.775
														],
														[
															-0.861,
															-0.438
														],
														[
															-7.405,
															-4.701
														],
														[
															-7.825,
															-3.98
														],
														[
															-18.445,
															-7.513
														],
														[
															-23.165,
															-4.517
														],
														[
															-0.314,
															0.018
														],
														[
															-0.185,
															0.246
														],
														[
															-6.419,
															0.445
														],
														[
															-6.56,
															0.586
														]
													],
													"v": [
														[
															303,
															30
														],
														[
															275.791,
															36.446
														],
														[
															250.043,
															44.884
														],
														[
															226.273,
															54.88
														],
														[
															205,
															66
														],
														[
															203.576,
															66.714
														],
														[
															202.31,
															67.185
														],
														[
															201.139,
															67.564
														],
														[
															200,
															68
														],
														[
															199.755,
															68.344
														],
														[
															199.522,
															68.968
														],
														[
															199.277,
															69.608
														],
														[
															199,
															70
														],
														[
															194.444,
															72.166
														],
														[
															191,
															74
														],
														[
															187.462,
															76.432
														],
														[
															184,
															78
														],
														[
															183.517,
															78.962
														],
														[
															183,
															80
														],
														[
															182.019,
															80.029
														],
														[
															181,
															80
														],
														[
															180.515,
															80.961
														],
														[
															180,
															82
														],
														[
															179.021,
															82.031
														],
														[
															178,
															82
														],
														[
															175.844,
															83.979
														],
														[
															174,
															86
														],
														[
															144.932,
															109.109
														],
														[
															119,
															135
														],
														[
															109.711,
															146.372
														],
														[
															101,
															158
														],
														[
															99.261,
															160.37
														],
														[
															98,
															162
														],
														[
															97.005,
															163.495
														],
														[
															96,
															165
														],
														[
															95.005,
															166.495
														],
														[
															94,
															168
														],
														[
															93.005,
															169.495
														],
														[
															92,
															171
														],
														[
															91.005,
															172.495
														],
														[
															90,
															174
														],
														[
															89.005,
															175.495
														],
														[
															88,
															177
														],
														[
															87.469,
															177.899
														],
														[
															87,
															179
														],
														[
															85.477,
															180.517
														],
														[
															84,
															182
														],
														[
															82.478,
															185.514
														],
														[
															81,
															189
														],
														[
															78.965,
															192.039
														],
														[
															77,
															195
														],
														[
															69.445,
															209.074
														],
														[
															63,
															223
														],
														[
															40.318,
															295.729
														],
														[
															34,
															381
														],
														[
															45.379,
															451.562
														],
														[
															68,
															512
														],
														[
															98.729,
															563.963
														],
														[
															137,
															608
														],
														[
															181.57,
															644.192
														],
														[
															236,
															674
														],
														[
															281.533,
															689.735
														],
														[
															335,
															699
														],
														[
															350.212,
															700.011
														],
														[
															365,
															700
														],
														[
															372.416,
															699.655
														],
														[
															378,
															699
														],
														[
															379.116,
															698.118
														],
														[
															380,
															697
														],
														[
															383.713,
															692.15
														],
														[
															387,
															688
														],
														[
															398.368,
															685.081
														],
														[
															411,
															684
														],
														[
															439.505,
															677.375
														],
														[
															466,
															669
														],
														[
															478.992,
															663.97
														],
														[
															491,
															659
														],
														[
															492.591,
															657.989
														],
														[
															494,
															657
														],
														[
															554.061,
															621.106
														],
														[
															604,
															574
														],
														[
															637.637,
															527.37
														],
														[
															664,
															472
														],
														[
															680.79,
															407.337
														],
														[
															684,
															332
														],
														[
															671.95,
															263.676
														],
														[
															649,
															205
														],
														[
															602.034,
															134.613
														],
														[
															541,
															81
														],
														[
															536.526,
															78.274
														],
														[
															533,
															76
														],
														[
															530.453,
															74.274
														],
														[
															528,
															73
														],
														[
															505.167,
															60.008
														],
														[
															481,
															49
														],
														[
															418.339,
															30.18
														],
														[
															343,
															25
														],
														[
															342.222,
															25.517
														],
														[
															342,
															26
														],
														[
															322.44,
															27.425
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 7,
											"s": [
												{
													"i": [
														[
															12.52,
															-2.416
														],
														[
															10.447,
															-3.21
														],
														[
															9.428,
															-3.885
														],
														[
															4.764,
															-2.205
														],
														[
															4.033,
															-2.158
														],
														[
															1.974,
															-1.423
														],
														[
															2.022,
															-1.193
														],
														[
															1.568,
															-0.699
														],
														[
															0.504,
															-0.483
														],
														[
															0.843,
															-0.667
														],
														[
															0.783,
															-0.52
														],
														[
															6.679,
															-5.222
														],
														[
															5.945,
															-5.233
														],
														[
															2.998,
															-2.916
														],
														[
															1.351,
															-2.999
														],
														[
															0.454,
															-0.179
														],
														[
															0.123,
															-0.148
														],
														[
															1.406,
															-1.578
														],
														[
															0.82,
															-1.817
														],
														[
															0.454,
															-0.179
														],
														[
															0.123,
															-0.147
														],
														[
															1.245,
															-1.726
														],
														[
															0.66,
															-1.463
														],
														[
															0.454,
															-0.179
														],
														[
															0.123,
															-0.147
														],
														[
															1.534,
															-2.44
														],
														[
															1.252,
															-1.307
														],
														[
															0.298,
															-0.539
														],
														[
															0.407,
															-0.425
														],
														[
															0.298,
															-0.539
														],
														[
															0.407,
															-0.425
														],
														[
															0.298,
															-0.539
														],
														[
															0.407,
															-0.425
														],
														[
															0.298,
															-0.539
														],
														[
															0.407,
															-0.425
														],
														[
															0.441,
															-0.86
														],
														[
															0.462,
															-0.754
														],
														[
															0.537,
															-0.943
														],
														[
															0.279,
															-0.292
														],
														[
															0.891,
															-1.525
														],
														[
															3.288,
															-6.907
														],
														[
															5.734,
															-33.977
														],
														[
															-5.172,
															-35.34
														],
														[
															-9.525,
															-23.007
														],
														[
															-4.349,
															-8.585
														],
														[
															-1.514,
															-2.468
														],
														[
															-3.401,
															-5.455
														],
														[
															-25.29,
															-20.764
														],
														[
															-8.172,
															-5.619
														],
														[
															-10.338,
															-5.647
														],
														[
															-9.242,
															-3.627
														],
														[
															-6.628,
															-2.131
														],
														[
															-31.216,
															-1.092
														],
														[
															-4.388,
															1.09
														],
														[
															-1.396,
															2.105
														],
														[
															-0.623,
															0.94
														],
														[
															-0.399,
															0.399
														],
														[
															-0.413,
															0.177
														],
														[
															-4.392,
															0.633
														],
														[
															-21.148,
															8.227
														],
														[
															-13.017,
															7.3
														],
														[
															-8.014,
															5.449
														],
														[
															-15.068,
															18.082
														],
														[
															-1.62,
															3.594
														],
														[
															-0.246,
															0.295
														],
														[
															-1.318,
															2.925
														],
														[
															-0.249,
															0.346
														],
														[
															-7.238,
															13.25
														],
														[
															-3.299,
															6.856
														],
														[
															-1.789,
															4.406
														],
														[
															-0.883,
															2.356
														],
														[
															-0.831,
															2.347
														],
														[
															3.863,
															54.214
														],
														[
															6.317,
															20.705
														],
														[
															2.719,
															6.929
														],
														[
															4.676,
															8.562
														],
														[
															2.355,
															5.224
														],
														[
															0.242,
															0.397
														],
														[
															1.063,
															1.109
														],
														[
															0.815,
															0.85
														],
														[
															0.815,
															0.85
														],
														[
															0.815,
															0.85
														],
														[
															0.686,
															0.975
														],
														[
															1.383,
															1.893
														],
														[
															0.222,
															0.492
														],
														[
															0.249,
															0.346
														],
														[
															8.749,
															9.083
														],
														[
															8.376,
															7.017
														],
														[
															3.393,
															2.641
														],
														[
															1.903,
															1.823
														],
														[
															0.85,
															0.814
														],
														[
															0.85,
															0.815
														],
														[
															0.85,
															0.815
														],
														[
															0.85,
															0.814
														],
														[
															0.85,
															0.815
														],
														[
															1.515,
															0.909
														],
														[
															5.328,
															2.926
														],
														[
															7.084,
															2.78
														],
														[
															51.635,
															-3.033
														],
														[
															-0.112,
															0.008
														]
													],
													"o": [
														[
															-11.783,
															2.274
														],
														[
															-10.447,
															3.21
														],
														[
															-4.909,
															2.023
														],
														[
															-4.764,
															2.205
														],
														[
															-2.084,
															1.115
														],
														[
															-1.974,
															1.423
														],
														[
															-1.226,
															0.723
														],
														[
															-1.568,
															0.699
														],
														[
															-0.846,
															0.81
														],
														[
															-0.843,
															0.667
														],
														[
															-7.339,
															4.88
														],
														[
															-6.679,
															5.222
														],
														[
															-2.656,
															2.338
														],
														[
															-2.998,
															2.916
														],
														[
															-0.062,
															0.137
														],
														[
															-0.454,
															0.179
														],
														[
															-1.558,
															1.87
														],
														[
															-1.406,
															1.578
														],
														[
															-0.062,
															0.137
														],
														[
															-0.454,
															0.179
														],
														[
															-1.362,
															1.635
														],
														[
															-1.245,
															1.726
														],
														[
															-0.062,
															0.137
														],
														[
															-0.454,
															0.179
														],
														[
															-1.611,
															1.933
														],
														[
															-1.534,
															2.44
														],
														[
															-0.401,
															0.419
														],
														[
															-0.298,
															0.539
														],
														[
															-0.401,
															0.419
														],
														[
															-0.298,
															0.539
														],
														[
															-0.401,
															0.419
														],
														[
															-0.298,
															0.539
														],
														[
															-0.401,
															0.419
														],
														[
															-0.298,
															0.539
														],
														[
															-0.773,
															0.808
														],
														[
															-0.441,
															0.86
														],
														[
															-0.573,
															0.935
														],
														[
															-0.537,
															0.943
														],
														[
															-1.542,
															1.61
														],
														[
															-3.915,
															6.699
														],
														[
															-13.178,
															27.682
														],
														[
															-6.009,
															35.606
														],
														[
															4.313,
															29.472
														],
														[
															4.232,
															10.222
														],
														[
															1.761,
															3.477
														],
														[
															3.597,
															5.867
														],
														[
															18.283,
															29.326
														],
														[
															7.514,
															6.169
														],
														[
															10.058,
															6.916
														],
														[
															9.192,
															5.021
														],
														[
															6.774,
															2.658
														],
														[
															25.815,
															8.301
														],
														[
															7.228,
															0.253
														],
														[
															3.997,
															-0.993
														],
														[
															1.103,
															-1.662
														],
														[
															0.783,
															-1.18
														],
														[
															0.304,
															-0.304
														],
														[
															3.369,
															-1.444
														],
														[
															26.783,
															-3.86
														],
														[
															14.753,
															-5.74
														],
														[
															8.208,
															-4.603
														],
														[
															20.497,
															-13.937
														],
														[
															3.223,
															-3.868
														],
														[
															0.124,
															-0.274
														],
														[
															2.725,
															-3.27
														],
														[
															0.139,
															-0.309
														],
														[
															9.277,
															-12.907
														],
														[
															3.61,
															-6.609
														],
														[
															2.145,
															-4.458
														],
														[
															1.031,
															-2.54
														],
														[
															0.924,
															-2.464
														],
														[
															13.798,
															-38.996
														],
														[
															-1.992,
															-27.959
														],
														[
															-2.753,
															-9.023
														],
														[
															-4.391,
															-11.192
														],
														[
															-3.36,
															-6.152
														],
														[
															-0.154,
															-0.34
														],
														[
															-1.443,
															-2.367
														],
														[
															-0.803,
															-0.838
														],
														[
															-0.803,
															-0.838
														],
														[
															-0.803,
															-0.838
														],
														[
															-0.734,
															-0.766
														],
														[
															-1.269,
															-1.803
														],
														[
															-0.313,
															-0.429
														],
														[
															-0.139,
															-0.309
														],
														[
															-8.153,
															-11.344
														],
														[
															-8.372,
															-8.691
														],
														[
															-3.912,
															-3.277
														],
														[
															-2.994,
															-2.33
														],
														[
															-0.838,
															-0.803
														],
														[
															-0.838,
															-0.803
														],
														[
															-0.838,
															-0.803
														],
														[
															-0.838,
															-0.803
														],
														[
															-0.838,
															-0.803
														],
														[
															-1.613,
															-1.545
														],
														[
															-6.206,
															-3.724
														],
														[
															-7.666,
															-4.211
														],
														[
															-36.217,
															-14.212
														],
														[
															-0.628,
															0.037
														],
														[
															-12.624,
															0.875
														]
													],
													"v": [
														[
															305,
															30
														],
														[
															271.734,
															38.292
														],
														[
															242,
															49
														],
														[
															227.343,
															55.398
														],
														[
															214,
															62
														],
														[
															207.954,
															65.941
														],
														[
															202,
															70
														],
														[
															197.458,
															72.18
														],
														[
															194,
															74
														],
														[
															191.453,
															76.218
														],
														[
															189,
															78
														],
														[
															167.955,
															93.235
														],
														[
															149,
															109
														],
														[
															140.021,
															117.005
														],
														[
															133,
															126
														],
														[
															132.046,
															126.492
														],
														[
															131,
															127
														],
														[
															126.446,
															132.039
														],
														[
															123,
															137
														],
														[
															122.046,
															137.492
														],
														[
															121,
															138
														],
														[
															116.973,
															143.129
														],
														[
															114,
															148
														],
														[
															113.046,
															148.492
														],
														[
															112,
															149
														],
														[
															107.231,
															155.969
														],
														[
															103,
															162
														],
														[
															102.005,
															163.495
														],
														[
															101,
															165
														],
														[
															100.005,
															166.495
														],
														[
															99,
															168
														],
														[
															98.005,
															169.495
														],
														[
															97,
															171
														],
														[
															96.005,
															172.495
														],
														[
															95,
															174
														],
														[
															93.266,
															176.541
														],
														[
															92,
															179
														],
														[
															90.279,
															181.982
														],
														[
															89,
															184
														],
														[
															86,
															189
														],
														[
															75,
															209
														],
														[
															45,
															302
														],
														[
															44,
															415
														],
														[
															66,
															495
														],
														[
															79,
															523
														],
														[
															84,
															533
														],
														[
															94,
															549
														],
														[
															161,
															626
														],
														[
															184,
															644
														],
														[
															216,
															663
														],
														[
															247,
															678
														],
														[
															266,
															685
														],
														[
															353,
															700
														],
														[
															375,
															699
														],
														[
															381,
															695
														],
														[
															384,
															691
														],
														[
															386,
															687
														],
														[
															388,
															687
														],
														[
															400,
															685
														],
														[
															471,
															666
														],
														[
															512,
															647
														],
														[
															536,
															631
														],
														[
															592,
															582
														],
														[
															600,
															572
														],
														[
															602,
															571
														],
														[
															609,
															561
														],
														[
															611,
															560
														],
														[
															636,
															520
														],
														[
															646,
															500
														],
														[
															653,
															487
														],
														[
															655,
															479
														],
														[
															658,
															472
														],
														[
															678,
															333
														],
														[
															664,
															257
														],
														[
															655,
															231
														],
														[
															641,
															200
														],
														[
															632,
															182
														],
														[
															630,
															181
														],
														[
															626,
															173
														],
														[
															624,
															170
														],
														[
															622,
															167
														],
														[
															620,
															164
														],
														[
															619,
															162
														],
														[
															614,
															157
														],
														[
															614,
															155
														],
														[
															612,
															154
														],
														[
															587,
															124
														],
														[
															561,
															99
														],
														[
															550,
															90
														],
														[
															540,
															83
														],
														[
															537,
															81
														],
														[
															534,
															79
														],
														[
															531,
															77
														],
														[
															528,
															75
														],
														[
															525,
															73
														],
														[
															520,
															70
														],
														[
															501,
															59
														],
														[
															477,
															48
														],
														[
															344,
															25
														],
														[
															343,
															26
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 8,
											"s": [
												{
													"i": [
														[
															12.41,
															-2.413
														],
														[
															11.622,
															-3.861
														],
														[
															9.387,
															-4.2
														],
														[
															1.184,
															-0.489
														],
														[
															1.115,
															-0.531
														],
														[
															2.095,
															-1.407
														],
														[
															2.162,
															-1.2
														],
														[
															1.171,
															-0.421
														],
														[
															1.132,
															-0.658
														],
														[
															5.102,
															-3.417
														],
														[
															4.411,
															-3.32
														],
														[
															2.191,
															-1.86
														],
														[
															2.08,
															-0.938
														],
														[
															0.179,
															-0.454
														],
														[
															0.147,
															-0.123
														],
														[
															1.29,
															-1.142
														],
														[
															1.292,
															-1.145
														],
														[
															1.905,
															-1.449
														],
														[
															1.661,
															-1.679
														],
														[
															1.415,
															-1.877
														],
														[
															1.69,
															-1.827
														],
														[
															1.679,
															-1.82
														],
														[
															1.624,
															-1.928
														],
														[
															1.507,
															-1.837
														],
														[
															1.431,
															-1.826
														],
														[
															0.326,
															-0.518
														],
														[
															0.355,
															-0.493
														],
														[
															1.253,
															-1.306
														],
														[
															0.947,
															-1.332
														],
														[
															-0.067,
															-0.383
														],
														[
															0.112,
															-0.249
														],
														[
															0.451,
															-0.168
														],
														[
															0.124,
															-0.173
														],
														[
															1.012,
															-1.921
														],
														[
															0.731,
															-1.62
														],
														[
															0.451,
															-0.163
														],
														[
															0.124,
															-0.185
														],
														[
															-0.067,
															-0.379
														],
														[
															0.115,
															-0.255
														],
														[
															0.451,
															-0.159
														],
														[
															0.121,
															-0.195
														],
														[
															0.061,
															-0.682
														],
														[
															0.361,
															-0.638
														],
														[
															0.604,
															-0.494
														],
														[
															0.282,
															-0.493
														],
														[
															0.447,
															-1.207
														],
														[
															0.632,
															-1.157
														],
														[
															0.715,
															-0.978
														],
														[
															0.584,
															-1.07
														],
														[
															1.883,
															-4.152
														],
														[
															1.445,
															-3.683
														],
														[
															0.391,
															-0.479
														],
														[
															0.198,
															-0.483
														],
														[
															0.265,
															-1.416
														],
														[
															0.465,
															-1.182
														],
														[
															0.764,
															-1.135
														],
														[
															0.43,
															-1.161
														],
														[
															0.291,
															-1.401
														],
														[
															0.398,
															-1.216
														],
														[
															1.185,
															-3.815
														],
														[
															1.044,
															-4.026
														],
														[
															2.113,
															-11.516
														],
														[
															0.691,
															-11.911
														],
														[
															-5.641,
															-28.2
														],
														[
															-10.459,
															-23.297
														],
														[
															-7.733,
															-12.546
														],
														[
															-8.807,
															-10.872
														],
														[
															-18.631,
															-14.814
														],
														[
															-24.279,
															-10.985
														],
														[
															-19.613,
															-4.909
														],
														[
															-20.886,
															-0.731
														],
														[
															-4.177,
															0.139
														],
														[
															-2.463,
															0.58
														],
														[
															-2.173,
															1.715
														],
														[
															-6.573,
															1.176
														],
														[
															-5.022,
															1.215
														],
														[
															-39.073,
															39.073
														],
														[
															-1.729,
															3.835
														],
														[
															-0.246,
															0.295
														],
														[
															-4.705,
															6.267
														],
														[
															-1.003,
															1.047
														],
														[
															-0.815,
															0.85
														],
														[
															-0.814,
															0.85
														],
														[
															-0.815,
															0.85
														],
														[
															-0.815,
															0.85
														],
														[
															-0.815,
															0.85
														],
														[
															-2.477,
															4.463
														],
														[
															-6.68,
															20.16
														],
														[
															-3.376,
															21.319
														],
														[
															1.141,
															27.08
														],
														[
															16.718,
															36.723
														],
														[
															1.952,
															2.038
														],
														[
															0.699,
															1.176
														],
														[
															1.526,
															2.655
														],
														[
															1.215,
															2.045
														],
														[
															1.308,
															1.995
														],
														[
															16.354,
															16.354
														],
														[
															64.369,
															12.977
														],
														[
															26.407,
															-1.551
														],
														[
															-0.112,
															0.008
														]
													],
													"o": [
														[
															-12.124,
															2.357
														],
														[
															-11.622,
															3.861
														],
														[
															-1.149,
															0.514
														],
														[
															-1.184,
															0.489
														],
														[
															-2.459,
															1.171
														],
														[
															-2.095,
															1.407
														],
														[
															-1.185,
															0.657
														],
														[
															-1.171,
															0.421
														],
														[
															-5.181,
															3.011
														],
														[
															-5.102,
															3.417
														],
														[
															-2.156,
															1.623
														],
														[
															-2.191,
															1.86
														],
														[
															-0.137,
															0.062
														],
														[
															-0.179,
															0.454
														],
														[
															-1.546,
															1.288
														],
														[
															-1.291,
															1.142
														],
														[
															-1.72,
															1.525
														],
														[
															-1.905,
															1.449
														],
														[
															-1.649,
															1.667
														],
														[
															-1.415,
															1.877
														],
														[
															-1.658,
															1.792
														],
														[
															-1.679,
															1.82
														],
														[
															-1.54,
															1.827
														],
														[
															-1.507,
															1.837
														],
														[
															-0.342,
															0.436
														],
														[
															-0.326,
															0.518
														],
														[
															-1.039,
															1.445
														],
														[
															-1.253,
															1.306
														],
														[
															-0.156,
															0.219
														],
														[
															0.067,
															0.383
														],
														[
															-0.07,
															0.154
														],
														[
															-0.451,
															0.168
														],
														[
															-1.219,
															1.697
														],
														[
															-1.013,
															1.921
														],
														[
															-0.073,
															0.162
														],
														[
															-0.451,
															0.163
														],
														[
															-0.154,
															0.23
														],
														[
															0.067,
															0.379
														],
														[
															-0.076,
															0.168
														],
														[
															-0.451,
															0.159
														],
														[
															-0.395,
															0.633
														],
														[
															-0.061,
															0.682
														],
														[
															-0.3,
															0.531
														],
														[
															-0.604,
															0.494
														],
														[
															-0.581,
															1.013
														],
														[
															-0.447,
															1.207
														],
														[
															-0.556,
															1.019
														],
														[
															-0.715,
															0.978
														],
														[
															-2.023,
															3.709
														],
														[
															-1.883,
															4.152
														],
														[
															-0.236,
															0.602
														],
														[
															-0.391,
															0.479
														],
														[
															-0.474,
															1.153
														],
														[
															-0.265,
															1.416
														],
														[
															-0.513,
															1.302
														],
														[
															-0.764,
															1.135
														],
														[
															-0.439,
															1.18
														],
														[
															-0.291,
															1.401
														],
														[
															-1.216,
															3.713
														],
														[
															-1.185,
															3.815
														],
														[
															-2.859,
															11.026
														],
														[
															-2.113,
															11.516
														],
														[
															-2.024,
															34.901
														],
														[
															5.641,
															28.2
														],
														[
															6.26,
															13.946
														],
														[
															7.733,
															12.546
														],
														[
															15.195,
															18.759
														],
														[
															18.631,
															14.814
														],
														[
															14.662,
															6.634
														],
														[
															19.613,
															4.909
														],
														[
															3.83,
															0.134
														],
														[
															4.177,
															-0.139
														],
														[
															3.975,
															-0.935
														],
														[
															4.684,
															-3.698
														],
														[
															5.424,
															-0.97
														],
														[
															63.955,
															-15.478
														],
														[
															3.583,
															-3.583
														],
														[
															0.124,
															-0.274
														],
														[
															5.417,
															-6.5
														],
														[
															1.689,
															-2.25
														],
														[
															0.803,
															-0.838
														],
														[
															0.803,
															-0.838
														],
														[
															0.803,
															-0.838
														],
														[
															0.803,
															-0.838
														],
														[
															0.803,
															-0.838
														],
														[
															3.741,
															-3.905
														],
														[
															10.284,
															-18.527
														],
														[
															6.165,
															-18.607
														],
														[
															3.545,
															-22.389
														],
														[
															-1.945,
															-46.137
														],
														[
															-1.857,
															-4.08
														],
														[
															-0.819,
															-0.854
														],
														[
															-1.941,
															-3.266
														],
														[
															-1.238,
															-2.155
														],
														[
															-1.272,
															-2.141
														],
														[
															-13.554,
															-20.668
														],
														[
															-38.13,
															-38.13
														],
														[
															-22.357,
															-4.507
														],
														[
															-0.628,
															0.037
														],
														[
															-12.529,
															0.869
														]
													],
													"v": [
														[
															306,
															30
														],
														[
															269.948,
															39.618
														],
														[
															238,
															52
														],
														[
															234.475,
															53.487
														],
														[
															231,
															55
														],
														[
															224.278,
															58.977
														],
														[
															218,
															63
														],
														[
															214.46,
															64.5
														],
														[
															211,
															66
														],
														[
															195.422,
															75.768
														],
														[
															181,
															86
														],
														[
															174.443,
															91.514
														],
														[
															168,
															96
														],
														[
															167.508,
															96.954
														],
														[
															167,
															98
														],
														[
															162.81,
															101.607
														],
														[
															159,
															105
														],
														[
															153.456,
															109.384
														],
														[
															148,
															114
														],
														[
															143.531,
															119.381
														],
														[
															139,
															125
														],
														[
															133.975,
															130.398
														],
														[
															129,
															136
														],
														[
															124.419,
															141.502
														],
														[
															120,
															147
														],
														[
															119.009,
															148.457
														],
														[
															118,
															150
														],
														[
															114.431,
															154.085
														],
														[
															111,
															158
														],
														[
															110.967,
															158.977
														],
														[
															111,
															160
														],
														[
															110.041,
															160.486
														],
														[
															109,
															161
														],
														[
															105.633,
															166.557
														],
														[
															103,
															172
														],
														[
															102.038,
															172.483
														],
														[
															101,
															173
														],
														[
															100.971,
															173.981
														],
														[
															101,
															175
														],
														[
															100.034,
															175.48
														],
														[
															99,
															176
														],
														[
															98.474,
															177.997
														],
														[
															98,
															180
														],
														[
															96.487,
															181.528
														],
														[
															95,
															183
														],
														[
															93.538,
															186.392
														],
														[
															92,
															190
														],
														[
															90.021,
															192.961
														],
														[
															88,
															196
														],
														[
															82.066,
															208.02
														],
														[
															77,
															220
														],
														[
															75.972,
															221.589
														],
														[
															75,
															223
														],
														[
															73.994,
															226.978
														],
														[
															73,
															231
														],
														[
															70.939,
															234.606
														],
														[
															69,
															238
														],
														[
															67.97,
															241.973
														],
														[
															67,
															246
														],
														[
															63.37,
															257.265
														],
														[
															60,
															269
														],
														[
															52.374,
															302.837
														],
														[
															48,
															338
														],
														[
															54.138,
															432.203
														],
														[
															79,
															509
														],
														[
															100.09,
															548.805
														],
														[
															125,
															584
														],
														[
															175.187,
															634.331
														],
														[
															239,
															673
														],
														[
															291.332,
															690.927
														],
														[
															353,
															700
														],
														[
															365.525,
															700.035
														],
														[
															376,
															699
														],
														[
															385,
															688
														],
														[
															408,
															684
														],
														[
															424,
															680
														],
														[
															576,
															594
														],
														[
															586,
															582
														],
														[
															588,
															581
														],
														[
															603,
															562
														],
														[
															608,
															555
														],
														[
															610,
															552
														],
														[
															612,
															549
														],
														[
															614,
															546
														],
														[
															616,
															543
														],
														[
															618,
															540
														],
														[
															627,
															526
														],
														[
															654,
															465
														],
														[
															667,
															408
														],
														[
															671,
															334
														],
														[
															639,
															208
														],
														[
															632,
															194
														],
														[
															631,
															192
														],
														[
															625,
															183
														],
														[
															622,
															176
														],
														[
															618,
															170
														],
														[
															573,
															115
														],
														[
															419,
															31
														],
														[
															345,
															25
														],
														[
															344,
															26
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 9,
											"s": [
												{
													"i": [
														[
															11.995,
															-2.43
														],
														[
															9.702,
															-3.118
														],
														[
															8.158,
															-3.496
														],
														[
															1.074,
															-0.472
														],
														[
															1.275,
															-0.501
														],
														[
															0.471,
															-0.382
														],
														[
															0.497,
															-0.228
														],
														[
															11.237,
															-7.297
														],
														[
															9.422,
															-8.023
														],
														[
															1.612,
															-1.718
														],
														[
															1.778,
															-1.618
														],
														[
															1.073,
															-0.611
														],
														[
															0.841,
															-0.766
														],
														[
															0.84,
															-1.22
														],
														[
															0.481,
															-1.066
														],
														[
															0.454,
															-0.179
														],
														[
															0.123,
															-0.148
														],
														[
															3.667,
															-4.037
														],
														[
															2.945,
															-3.784
														],
														[
															1.228,
															-1.884
														],
														[
															0.9,
															-0.94
														],
														[
															0.298,
															-0.539
														],
														[
															0.407,
															-0.425
														],
														[
															0.067,
															-0.27
														],
														[
															0.348,
															-0.522
														],
														[
															1.018,
															-0.902
														],
														[
															0.347,
															-0.521
														],
														[
															0.226,
															-0.889
														],
														[
															0.447,
															-0.466
														],
														[
															0.298,
															-0.539
														],
														[
															0.407,
															-0.425
														],
														[
															0.062,
															-0.251
														],
														[
															0.35,
															-0.573
														],
														[
															1.387,
															-1.953
														],
														[
															1.184,
															-2.112
														],
														[
															8.304,
															-32.764
														],
														[
															-1.987,
															-37.385
														],
														[
															-1.458,
															-11.592
														],
														[
															-2.487,
															-10.803
														],
														[
															-3.334,
															-9.961
														],
														[
															-4.17,
															-9.318
														],
														[
															-10.343,
															-16.096
														],
														[
															-13.305,
															-14.016
														],
														[
															-14.934,
															-11.341
														],
														[
															-19.416,
															-9.103
														],
														[
															-9.749,
															-3.646
														],
														[
															-11.773,
															-2.558
														],
														[
															-5.941,
															-0.842
														],
														[
															-6.12,
															-0.522
														],
														[
															-7.062,
															-0.341
														],
														[
															-5.594,
															0.888
														],
														[
															-1.476,
															2.159
														],
														[
															-1.138,
															1.053
														],
														[
															-0.714,
															0.516
														],
														[
															-1.51,
															0.35
														],
														[
															-1.655,
															0.083
														],
														[
															-1.613,
															0.258
														],
														[
															-4.211,
															0.829
														],
														[
															-4.004,
															1.021
														],
														[
															-3.726,
															1.24
														],
														[
															-3.091,
															1.02
														],
														[
															-5.689,
															2.275
														],
														[
															-5.595,
															2.708
														],
														[
															-5.299,
															2.875
														],
														[
															-4.549,
															2.955
														],
														[
															-2.448,
															1.632
														],
														[
															-1.255,
															1.203
														],
														[
															-0.539,
															0.298
														],
														[
															-0.425,
															0.408
														],
														[
															-0.659,
															0.445
														],
														[
															-0.608,
															0.495
														],
														[
															-2.343,
															1.778
														],
														[
															-2.14,
															1.86
														],
														[
															-0.828,
															0.873
														],
														[
															-0.844,
															0.775
														],
														[
															-6.397,
															6.64
														],
														[
															-5.731,
															7.298
														],
														[
															-9.369,
															16.884
														],
														[
															-6.558,
															19.5
														],
														[
															-3.33,
															22.815
														],
														[
															1.88,
															26.237
														],
														[
															1.585,
															11.349
														],
														[
															2.793,
															10.491
														],
														[
															2.117,
															6.215
														],
														[
															1.858,
															4.843
														],
														[
															0.605,
															1.77
														],
														[
															0.719,
															1.678
														],
														[
															0.477,
															1.112
														],
														[
															0.508,
															1.185
														],
														[
															1.388,
															2.672
														],
														[
															1.24,
															2.488
														],
														[
															9.36,
															13.151
														],
														[
															11.784,
															11.784
														],
														[
															4.985,
															4.768
														],
														[
															5.167,
															4.035
														],
														[
															3.524,
															2.874
														],
														[
															1.025,
															0.716
														],
														[
															16.068,
															7.19
														],
														[
															52.047,
															-3.057
														],
														[
															-0.112,
															0.008
														]
													],
													"o": [
														[
															-10.034,
															2.032
														],
														[
															-9.702,
															3.118
														],
														[
															-1.428,
															0.611
														],
														[
															-1.074,
															0.472
														],
														[
															-0.618,
															0.243
														],
														[
															-0.471,
															0.382
														],
														[
															-12.632,
															5.79
														],
														[
															-11.237,
															7.297
														],
														[
															-1.773,
															1.51
														],
														[
															-1.612,
															1.718
														],
														[
															-0.866,
															0.788
														],
														[
															-1.073,
															0.611
														],
														[
															-1.159,
															1.055
														],
														[
															-0.84,
															1.22
														],
														[
															-0.062,
															0.137
														],
														[
															-0.454,
															0.179
														],
														[
															-3.388,
															4.066
														],
														[
															-3.667,
															4.037
														],
														[
															-1.187,
															1.525
														],
														[
															-1.228,
															1.884
														],
														[
															-0.401,
															0.419
														],
														[
															-0.298,
															0.539
														],
														[
															-0.382,
															0.399
														],
														[
															-0.067,
															0.27
														],
														[
															-0.581,
															0.87
														],
														[
															-1.018,
															0.902
														],
														[
															-0.651,
															0.977
														],
														[
															-0.226,
															0.889
														],
														[
															-0.401,
															0.419
														],
														[
															-0.298,
															0.539
														],
														[
															-0.404,
															0.421
														],
														[
															-0.061,
															0.251
														],
														[
															-1.267,
															2.076
														],
														[
															-1.387,
															1.953
														],
														[
															-13.773,
															24.56
														],
														[
															-8.304,
															32.764
														],
														[
															0.682,
															12.829
														],
														[
															1.458,
															11.592
														],
														[
															2.496,
															10.839
														],
														[
															3.334,
															9.961
														],
														[
															8.323,
															18.6
														],
														[
															10.343,
															16.096
														],
														[
															12.847,
															13.534
														],
														[
															14.934,
															11.341
														],
														[
															8.233,
															3.86
														],
														[
															9.749,
															3.646
														],
														[
															5.113,
															1.111
														],
														[
															5.942,
															0.842
														],
														[
															6.161,
															0.525
														],
														[
															7.062,
															0.341
														],
														[
															1.959,
															-0.311
														],
														[
															1.476,
															-2.159
														],
														[
															0.635,
															-0.587
														],
														[
															0.714,
															-0.516
														],
														[
															1.768,
															-0.409
														],
														[
															1.655,
															-0.083
														],
														[
															4.151,
															-0.663
														],
														[
															4.211,
															-0.829
														],
														[
															4.006,
															-1.022
														],
														[
															3.726,
															-1.24
														],
														[
															6.648,
															-2.193
														],
														[
															5.689,
															-2.275
														],
														[
															5.254,
															-2.543
														],
														[
															5.299,
															-2.875
														],
														[
															1.952,
															-1.269
														],
														[
															2.448,
															-1.632
														],
														[
															0.419,
															-0.401
														],
														[
															0.539,
															-0.298
														],
														[
															0.755,
															-0.724
														],
														[
															0.659,
															-0.445
														],
														[
															2.488,
															-2.029
														],
														[
															2.343,
															-1.778
														],
														[
															0.844,
															-0.733
														],
														[
															0.828,
															-0.873
														],
														[
															6.683,
															-6.142
														],
														[
															6.397,
															-6.64
														],
														[
															10.966,
															-13.965
														],
														[
															9.369,
															-16.884
														],
														[
															6.56,
															-19.504
														],
														[
															3.33,
															-22.815
														],
														[
															-0.868,
															-12.113
														],
														[
															-1.585,
															-11.349
														],
														[
															-1.676,
															-6.295
														],
														[
															-2.117,
															-6.215
														],
														[
															-0.86,
															-2.241
														],
														[
															-0.605,
															-1.77
														],
														[
															-0.585,
															-1.365
														],
														[
															-0.477,
															-1.112
														],
														[
															-1.209,
															-2.822
														],
														[
															-1.388,
															-2.673
														],
														[
															-7.777,
															-15.609
														],
														[
															-9.36,
															-13.152
														],
														[
															-4.892,
															-4.892
														],
														[
															-4.985,
															-4.768
														],
														[
															-4.541,
															-3.546
														],
														[
															-0.891,
															-0.727
														],
														[
															-13.94,
															-9.739
														],
														[
															-34.937,
															-15.634
														],
														[
															-0.628,
															0.037
														],
														[
															-12.465,
															0.864
														]
													],
													"v": [
														[
															308,
															30
														],
														[
															278.093,
															37.902
														],
														[
															251,
															48
														],
														[
															247.386,
															49.583
														],
														[
															244,
															51
														],
														[
															242.409,
															52.011
														],
														[
															241,
															53
														],
														[
															205.093,
															72.825
														],
														[
															174,
															96
														],
														[
															169.003,
															100.919
														],
														[
															164,
															106
														],
														[
															160.981,
															108.017
														],
														[
															158,
															110
														],
														[
															154.992,
															113.492
														],
														[
															153,
															117
														],
														[
															152.046,
															117.492
														],
														[
															151,
															118
														],
														[
															140.168,
															130.211
														],
														[
															130,
															142
														],
														[
															126.285,
															147.439
														],
														[
															123,
															152
														],
														[
															122.005,
															153.495
														],
														[
															121,
															155
														],
														[
															120.474,
															155.908
														],
														[
															120,
															157
														],
														[
															117.325,
															159.762
														],
														[
															115,
															162
														],
														[
															113.847,
															164.883
														],
														[
															113,
															167
														],
														[
															112.005,
															168.495
														],
														[
															111,
															170
														],
														[
															110.459,
															170.886
														],
														[
															110,
															172
														],
														[
															105.938,
															177.973
														],
														[
															102,
															184
														],
														[
															67.68,
															270.88
														],
														[
															57,
															377
														],
														[
															60.146,
															413.52
														],
														[
															66,
															447
														],
														[
															74.745,
															478.14
														],
														[
															86,
															507
														],
														[
															113.764,
															558.938
														],
														[
															149,
															604
														],
														[
															190.073,
															641.324
														],
														[
															241,
															672
														],
														[
															267.845,
															683.477
														],
														[
															300,
															693
														],
														[
															316.745,
															695.942
														],
														[
															335,
															698
														],
														[
															355.425,
															699.559
														],
														[
															375,
															699
														],
														[
															380.116,
															694.557
														],
														[
															384,
															689
														],
														[
															385.843,
															687.322
														],
														[
															389,
															686
														],
														[
															394.116,
															685.386
														],
														[
															399,
															685
														],
														[
															411.611,
															682.768
														],
														[
															424,
															680
														],
														[
															435.686,
															676.499
														],
														[
															446,
															673
														],
														[
															464.289,
															666.387
														],
														[
															481,
															659
														],
														[
															497.028,
															650.809
														],
														[
															512,
															642
														],
														[
															519.023,
															637.451
														],
														[
															525,
															633
														],
														[
															526.495,
															632.005
														],
														[
															528,
															631
														],
														[
															530.111,
															629.329
														],
														[
															532,
															628
														],
														[
															539.261,
															622.372
														],
														[
															546,
															617
														],
														[
															548.5,
															614.532
														],
														[
															551,
															612
														],
														[
															570.714,
															592.867
														],
														[
															589,
															572
														],
														[
															619.806,
															525.651
														],
														[
															644,
															471
														],
														[
															659.329,
															407.55
														],
														[
															662,
															334
														],
														[
															658.444,
															298.784
														],
														[
															652,
															266
														],
														[
															646.137,
															246.911
														],
														[
															640,
															230
														],
														[
															637.894,
															224.078
														],
														[
															636,
															219
														],
														[
															634.442,
															215.365
														],
														[
															633,
															212
														],
														[
															629.023,
															203.75
														],
														[
															625,
															196
														],
														[
															599.505,
															153.131
														],
														[
															568,
															116
														],
														[
															553.206,
															101.357
														],
														[
															538,
															88
														],
														[
															524,
															78
														],
														[
															521,
															76
														],
														[
															477,
															51
														],
														[
															346,
															25
														],
														[
															345,
															26
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 10,
											"s": [
												{
													"i": [
														[
															0.656,
															0.016
														],
														[
															11.021,
															-2.538
														],
														[
															15.413,
															-6.919
														],
														[
															2.426,
															-2.324
														],
														[
															1.176,
															-0.699
														],
														[
															4.63,
															-2.87
														],
														[
															5.572,
															-4.104
														],
														[
															3.885,
															-1.751
														],
														[
															0.295,
															-0.246
														],
														[
															3.946,
															-3.381
														],
														[
															5.131,
															-5.56
														],
														[
															1.789,
															-3.969
														],
														[
															0.246,
															-0.295
														],
														[
															2.062,
															-3.016
														],
														[
															1.907,
															-2.621
														],
														[
															2.473,
															-3.745
														],
														[
															2.924,
															-5.324
														],
														[
															1.177,
															-2.154
														],
														[
															0.906,
															-1.624
														],
														[
															1.159,
															-2.288
														],
														[
															2.747,
															-7.001
														],
														[
															0.573,
															-1.521
														],
														[
															1.727,
															-4.898
														],
														[
															3.44,
															-22.618
														],
														[
															-1.132,
															-24.929
														],
														[
															-24.63,
															-44.37
														],
														[
															-1.451,
															-3.218
														],
														[
															-0.242,
															-0.395
														],
														[
															-1.276,
															-2.058
														],
														[
															-5.312,
															-6.718
														],
														[
															-6.598,
															-6.887
														],
														[
															-0.515,
															-0.545
														],
														[
															-3.491,
															-3.222
														],
														[
															-4.766,
															-3.971
														],
														[
															-0.378,
															-0.362
														],
														[
															-0.813,
															-0.643
														],
														[
															-3.765,
															-2.654
														],
														[
															-0.5,
															-0.225
														],
														[
															-0.37,
															-0.247
														],
														[
															-0.511,
															-0.23
														],
														[
															-0.355,
															-0.248
														],
														[
															-2.162,
															-0.975
														],
														[
															-0.37,
															-0.247
														],
														[
															-0.511,
															-0.23
														],
														[
															-0.407,
															-0.239
														],
														[
															-2.159,
															-1.202
														],
														[
															-4.583,
															-2.301
														],
														[
															-25.888,
															-4.643
														],
														[
															-6.125,
															-0.622
														],
														[
															-9.635,
															2.674
														],
														[
															-1.574,
															1.172
														],
														[
															-0.163,
															0.262
														],
														[
															-1.29,
															1.018
														],
														[
															-6.28,
															1.221
														],
														[
															-2.161,
															0.498
														],
														[
															-11.784,
															4.404
														],
														[
															-8.722,
															4.281
														],
														[
															-6.984,
															3.148
														],
														[
															-0.385,
															0.245
														],
														[
															-1.724,
															1.12
														],
														[
															-11.626,
															10.686
														],
														[
															-8.018,
															9.608
														],
														[
															-1.554,
															2.007
														],
														[
															-1.305,
															1.732
														],
														[
															-0.672,
															0.962
														],
														[
															-0.602,
															0.852
														],
														[
															-0.225,
															0.499
														],
														[
															-0.247,
															0.37
														],
														[
															-0.23,
															0.511
														],
														[
															-0.248,
															0.353
														],
														[
															-0.928,
															0.968
														],
														[
															-0.814,
															0.85
														],
														[
															-1.458,
															2.375
														],
														[
															-0.687,
															1.523
														],
														[
															-0.238,
															0.411
														],
														[
															-1.24,
															2.246
														],
														[
															3.592,
															81.693
														],
														[
															14.001,
															32.669
														],
														[
															1.459,
															3.273
														],
														[
															0.434,
															1.012
														],
														[
															2.888,
															5.28
														],
														[
															2.259,
															5.011
														],
														[
															0.239,
															0.407
														],
														[
															1.274,
															1.97
														],
														[
															1.282,
															1.874
														],
														[
															19.5,
															16.709
														],
														[
															2.273,
															1.024
														],
														[
															0.295,
															0.246
														],
														[
															2.789,
															2.275
														],
														[
															1.034,
															0.991
														],
														[
															2.161,
															1.38
														],
														[
															3.975,
															2.356
														],
														[
															8.774,
															3.743
														],
														[
															1.03,
															0.404
														],
														[
															11.392,
															3.499
														],
														[
															2.558,
															0.645
														],
														[
															2.948,
															0.679
														],
														[
															5.054,
															0.789
														],
														[
															19.093,
															-1.122
														],
														[
															-0.112,
															0.008
														]
													],
													"o": [
														[
															-15.19,
															-0.378
														],
														[
															-18.978,
															4.37
														],
														[
															-4.678,
															2.1
														],
														[
															-0.854,
															0.818
														],
														[
															-5.264,
															3.128
														],
														[
															-6.295,
															3.902
														],
														[
															-4.072,
															2.999
														],
														[
															-0.274,
															0.124
														],
														[
															-4.734,
															3.945
														],
														[
															-5.837,
															5.002
														],
														[
															-3.513,
															3.806
														],
														[
															-0.124,
															0.274
														],
														[
															-3.094,
															3.713
														],
														[
															-2.017,
															2.95
														],
														[
															-2.693,
															3.702
														],
														[
															-4.098,
															6.206
														],
														[
															-1.097,
															1.996
														],
														[
															-1.018,
															1.863
														],
														[
															-1.301,
															2.331
														],
														[
															-3.908,
															7.716
														],
														[
															-0.614,
															1.564
														],
														[
															-1.816,
															4.818
														],
														[
															-6.696,
															18.988
														],
														[
															-3.651,
															24.004
														],
														[
															3.03,
															66.706
														],
														[
															2.088,
															3.761
														],
														[
															0.153,
															0.339
														],
														[
															1.184,
															1.929
														],
														[
															5.199,
															8.386
														],
														[
															6.698,
															8.472
														],
														[
															0.496,
															0.518
														],
														[
															3.256,
															3.444
														],
														[
															5.203,
															4.802
														],
														[
															1.263,
															1.052
														],
														[
															0.68,
															0.652
														],
														[
															3.559,
															2.813
														],
														[
															0.441,
															0.311
														],
														[
															0.324,
															0.146
														],
														[
															0.46,
															0.307
														],
														[
															0.314,
															0.142
														],
														[
															2.417,
															1.691
														],
														[
															0.324,
															0.146
														],
														[
															0.46,
															0.307
														],
														[
															0.346,
															0.156
														],
														[
															2.039,
															1.198
														],
														[
															4.351,
															2.422
														],
														[
															20.998,
															10.541
														],
														[
															5.662,
															1.015
														],
														[
															13.241,
															1.346
														],
														[
															3.128,
															-0.868
														],
														[
															0.252,
															-0.188
														],
														[
															1.399,
															-2.25
														],
														[
															4.642,
															-3.665
														],
														[
															2.241,
															-0.436
														],
														[
															13.329,
															-3.069
														],
														[
															9.05,
															-3.382
														],
														[
															7.996,
															-3.924
														],
														[
															0.333,
															-0.15
														],
														[
															1.849,
															-1.176
														],
														[
															14.054,
															-9.128
														],
														[
															9.812,
															-9.019
														],
														[
															1.576,
															-1.889
														],
														[
															1.404,
															-1.813
														],
														[
															0.659,
															-0.874
														],
														[
															0.581,
															-0.832
														],
														[
															0.311,
															-0.441
														],
														[
															0.146,
															-0.324
														],
														[
															0.307,
															-0.46
														],
														[
															0.141,
															-0.313
														],
														[
															1.541,
															-2.189
														],
														[
															0.803,
															-0.838
														],
														[
															2.176,
															-2.271
														],
														[
															1.232,
															-2.006
														],
														[
															0.157,
															-0.348
														],
														[
															1.265,
															-2.188
														],
														[
															27.867,
															-50.446
														],
														[
															-1.973,
															-44.868
														],
														[
															-1.415,
															-3.302
														],
														[
															-0.334,
															-0.75
														],
														[
															-2.651,
															-6.185
														],
														[
															-3.005,
															-5.493
														],
														[
															-0.156,
															-0.346
														],
														[
															-1.242,
															-2.114
														],
														[
															-1.136,
															-1.757
														],
														[
															-15.212,
															-22.234
														],
														[
															-2.479,
															-2.124
														],
														[
															-0.274,
															-0.124
														],
														[
															-3.644,
															-3.037
														],
														[
															-2.059,
															-1.68
														],
														[
															-2.123,
															-2.034
														],
														[
															-4.442,
															-2.837
														],
														[
															-8.54,
															-5.062
														],
														[
															-0.747,
															-0.319
														],
														[
															-11.15,
															-4.375
														],
														[
															-2.5,
															-0.768
														],
														[
															-2.621,
															-0.661
														],
														[
															-4.924,
															-1.134
														],
														[
															-16.781,
															-2.62
														],
														[
															-0.628,
															0.037
														],
														[
															-0.655,
															0.045
														]
													],
													"v": [
														[
															344,
															26
														],
														[
															302,
															32
														],
														[
															251,
															50
														],
														[
															236,
															57
														],
														[
															234,
															58
														],
														[
															219,
															67
														],
														[
															201,
															79
														],
														[
															189,
															88
														],
														[
															188,
															90
														],
														[
															175,
															101
														],
														[
															160,
															116
														],
														[
															150,
															128
														],
														[
															148,
															129
														],
														[
															140,
															140
														],
														[
															133,
															148
														],
														[
															125,
															160
														],
														[
															114,
															178
														],
														[
															111,
															185
														],
														[
															107,
															190
														],
														[
															104,
															197
														],
														[
															93,
															221
														],
														[
															92,
															225
														],
														[
															86,
															239
														],
														[
															71,
															303
														],
														[
															66,
															377
														],
														[
															113,
															545
														],
														[
															119,
															556
														],
														[
															121,
															557
														],
														[
															124,
															563
														],
														[
															141,
															586
														],
														[
															162,
															611
														],
														[
															163,
															613
														],
														[
															174,
															622
														],
														[
															189,
															636
														],
														[
															193,
															639
														],
														[
															195,
															640
														],
														[
															205,
															649
														],
														[
															207,
															649
														],
														[
															208,
															651
														],
														[
															210,
															651
														],
														[
															211,
															653
														],
														[
															219,
															657
														],
														[
															220,
															659
														],
														[
															222,
															659
														],
														[
															223,
															661
														],
														[
															230,
															664
														],
														[
															243,
															671
														],
														[
															316,
															696
														],
														[
															334,
															698
														],
														[
															371,
															699
														],
														[
															377,
															698
														],
														[
															378,
															695
														],
														[
															383,
															688
														],
														[
															406,
															684
														],
														[
															413,
															682
														],
														[
															450,
															671
														],
														[
															476,
															659
														],
														[
															500,
															647
														],
														[
															501,
															645
														],
														[
															507,
															642
														],
														[
															545,
															612
														],
														[
															573,
															583
														],
														[
															577,
															577
														],
														[
															582,
															572
														],
														[
															583,
															569
														],
														[
															586,
															567
														],
														[
															586,
															565
														],
														[
															588,
															564
														],
														[
															588,
															562
														],
														[
															590,
															561
														],
														[
															594,
															554
														],
														[
															596,
															551
														],
														[
															601,
															544
														],
														[
															603,
															539
														],
														[
															605,
															538
														],
														[
															608,
															531
														],
														[
															653,
															335
														],
														[
															625,
															214
														],
														[
															621,
															204
														],
														[
															619,
															201
														],
														[
															611,
															185
														],
														[
															602,
															168
														],
														[
															600,
															167
														],
														[
															597,
															160
														],
														[
															593,
															155
														],
														[
															539,
															94
														],
														[
															532,
															89
														],
														[
															531,
															87
														],
														[
															520,
															79
														],
														[
															513,
															74
														],
														[
															506,
															69
														],
														[
															494,
															62
														],
														[
															468,
															49
														],
														[
															465,
															47
														],
														[
															433,
															36
														],
														[
															426,
															33
														],
														[
															417,
															32
														],
														[
															402,
															28
														],
														[
															347,
															25
														],
														[
															346,
															26
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 11,
											"s": [
												{
													"i": [
														[
															6.608,
															-0.982
														],
														[
															5.286,
															-0.922
														],
														[
															5.028,
															-1.445
														],
														[
															14.788,
															-7.881
														],
														[
															12.026,
															-9.354
														],
														[
															1.863,
															-1.279
														],
														[
															1.719,
															-1.462
														],
														[
															3.327,
															-3.196
														],
														[
															3.073,
															-3.139
														],
														[
															2.44,
															-2.582
														],
														[
															1.897,
															-2.276
														],
														[
															1.495,
															-1.829
														],
														[
															1.359,
															-1.692
														],
														[
															3.309,
															-4.64
														],
														[
															3.105,
															-4.882
														],
														[
															2.322,
															-4.232
														],
														[
															2.185,
															-4.101
														],
														[
															3.835,
															-9.153
														],
														[
															3.222,
															-10.057
														],
														[
															3.487,
															-23.08
														],
														[
															-1.134,
															-24.377
														],
														[
															-2.473,
															-15.28
														],
														[
															-3.342,
															-13.452
														],
														[
															-0.582,
															-1.147
														],
														[
															-0.378,
															-1.22
														],
														[
															-0.597,
															-2.509
														],
														[
															-0.821,
															-2.41
														],
														[
															-5.236,
															-11.009
														],
														[
															-6.032,
															-10.14
														],
														[
															-3.252,
															-4.993
														],
														[
															-3.069,
															-4.113
														],
														[
															-1.537,
															-1.834
														],
														[
															-1.348,
															-1.651
														],
														[
															-0.625,
															-1.046
														],
														[
															-0.728,
															-0.87
														],
														[
															-3.25,
															-3.114
														],
														[
															-3.213,
															-3.213
														],
														[
															-3.303,
															-3.2
														],
														[
															-3.549,
															-2.962
														],
														[
															-7.884,
															-5.173
														],
														[
															-8.517,
															-4.511
														],
														[
															-18.236,
															-5.366
														],
														[
															-19.871,
															-0.554
														],
														[
															-4.484,
															0.127
														],
														[
															-1.178,
															0.573
														],
														[
															-0.076,
															0.615
														],
														[
															-0.293,
															0.342
														],
														[
															-0.469,
															0.671
														],
														[
															-0.49,
															0.572
														],
														[
															-0.457,
															0.699
														],
														[
															-0.539,
															0.467
														],
														[
															-2.343,
															0.353
														],
														[
															-2.198,
															0.349
														],
														[
															-3.726,
															0.83
														],
														[
															-3.56,
															0.959
														],
														[
															-9.16,
															3.477
														],
														[
															-8.139,
															4.336
														],
														[
															-16.662,
															14.699
														],
														[
															-13.486,
															18.087
														],
														[
															-4.64,
															7.663
														],
														[
															-3.452,
															7.659
														],
														[
															-0.452,
															0.149
														],
														[
															-0.111,
															0.221
														],
														[
															-0.247,
															1.219
														],
														[
															-0.481,
															1.075
														],
														[
															-1.504,
															2.87
														],
														[
															-0.891,
															2.079
														],
														[
															-0.628,
															1.598
														],
														[
															-0.629,
															1.603
														],
														[
															-2.004,
															6.002
														],
														[
															-1.697,
															6.161
														],
														[
															-1.714,
															7.882
														],
														[
															-1.096,
															8.043
														],
														[
															2.726,
															29.229
														],
														[
															7.113,
															22.611
														],
														[
															1.45,
															3.399
														],
														[
															1.055,
															2.762
														],
														[
															0.261,
															1.394
														],
														[
															0.478,
															1.177
														],
														[
															0.527,
															0.979
														],
														[
															0.47,
															1.043
														],
														[
															14.662,
															19.762
														],
														[
															18.473,
															15.798
														],
														[
															1.389,
															0.998
														],
														[
															1.076,
															0.839
														],
														[
															0.288,
															0.585
														],
														[
															0.429,
															0.332
														],
														[
															0.389,
															-0.066
														],
														[
															0.24,
															0.108
														],
														[
															0.168,
															0.451
														],
														[
															0.173,
															0.124
														],
														[
															1.95,
															1.057
														],
														[
															0.802,
															0.767
														],
														[
															0.539,
															0.298
														],
														[
															0.425,
															0.407
														],
														[
															2.373,
															1.515
														],
														[
															6.785,
															3.483
														],
														[
															20.567,
															4.999
														],
														[
															25.022,
															-1.602
														],
														[
															-0.109,
															0.008
														]
													],
													"o": [
														[
															-5.831,
															0.866
														],
														[
															-5.285,
															0.922
														],
														[
															-17.822,
															5.123
														],
														[
															-14.788,
															7.881
														],
														[
															-1.829,
															1.422
														],
														[
															-1.863,
															1.279
														],
														[
															-3.62,
															3.078
														],
														[
															-3.327,
															3.196
														],
														[
															-2.344,
															2.394
														],
														[
															-2.44,
															2.582
														],
														[
															-1.659,
															1.991
														],
														[
															-1.495,
															1.829
														],
														[
															-3.661,
															4.558
														],
														[
															-3.309,
															4.64
														],
														[
															-2.525,
															3.972
														],
														[
															-2.322,
															4.232
														],
														[
															-4.439,
															8.331
														],
														[
															-3.835,
															9.153
														],
														[
															-6.184,
															19.303
														],
														[
															-3.487,
															23.08
														],
														[
															0.764,
															16.429
														],
														[
															2.473,
															15.28
														],
														[
															0.296,
															1.191
														],
														[
															0.582,
															1.147
														],
														[
															0.792,
															2.555
														],
														[
															0.597,
															2.509
														],
														[
															4.026,
															11.824
														],
														[
															5.236,
															11.009
														],
														[
															2.924,
															4.916
														],
														[
															3.252,
															4.993
														],
														[
															1.502,
															2.014
														],
														[
															1.537,
															1.834
														],
														[
															0.772,
															0.947
														],
														[
															0.625,
															1.046
														],
														[
															2.786,
															3.33
														],
														[
															3.25,
															3.114
														],
														[
															3.238,
															3.238
														],
														[
															3.303,
															3.2
														],
														[
															6.946,
															5.796
														],
														[
															7.884,
															5.173
														],
														[
															13.183,
															6.983
														],
														[
															18.236,
															5.366
														],
														[
															2.885,
															0.081
														],
														[
															4.484,
															-0.127
														],
														[
															0.402,
															-0.196
														],
														[
															0.076,
															-0.615
														],
														[
															0.635,
															-0.743
														],
														[
															0.469,
															-0.671
														],
														[
															0.633,
															-0.738
														],
														[
															0.457,
															-0.698
														],
														[
															1.432,
															-1.241
														],
														[
															2.343,
															-0.353
														],
														[
															4.536,
															-0.719
														],
														[
															3.726,
															-0.831
														],
														[
															10.222,
															-2.754
														],
														[
															9.16,
															-3.477
														],
														[
															20.865,
															-11.116
														],
														[
															16.662,
															-14.699
														],
														[
															4.986,
															-6.688
														],
														[
															4.64,
															-7.663
														],
														[
															0.082,
															-0.183
														],
														[
															0.452,
															-0.149
														],
														[
															0.529,
															-1.048
														],
														[
															0.247,
															-1.219
														],
														[
															1.092,
															-2.442
														],
														[
															1.504,
															-2.87
														],
														[
															0.86,
															-2.006
														],
														[
															0.628,
															-1.598
														],
														[
															2.286,
															-5.832
														],
														[
															2.004,
															-6.002
														],
														[
															2.045,
															-7.428
														],
														[
															1.715,
															-7.882
														],
														[
															4.019,
															-29.473
														],
														[
															-2.726,
															-29.229
														],
														[
															-1.145,
															-3.64
														],
														[
															-1.45,
															-3.399
														],
														[
															-0.477,
															-1.249
														],
														[
															-0.261,
															-1.394
														],
														[
															-0.423,
															-1.04
														],
														[
															-0.527,
															-0.979
														],
														[
															-10.879,
															-24.154
														],
														[
															-14.662,
															-19.762
														],
														[
															-1.367,
															-1.169
														],
														[
															-1.389,
															-0.998
														],
														[
															-0.42,
															-0.328
														],
														[
															-0.288,
															-0.585
														],
														[
															-0.204,
															-0.157
														],
														[
															-0.389,
															0.066
														],
														[
															-0.154,
															-0.07
														],
														[
															-0.168,
															-0.451
														],
														[
															-1.4,
															-1.006
														],
														[
															-1.95,
															-1.057
														],
														[
															-0.419,
															-0.401
														],
														[
															-0.539,
															-0.298
														],
														[
															-2.291,
															-2.195
														],
														[
															-6.3,
															-4.023
														],
														[
															-16.59,
															-8.517
														],
														[
															-20.347,
															-4.945
														],
														[
															-0.627,
															0.04
														],
														[
															-7.439,
															0.55
														]
													],
													"v": [
														[
															328,
															28
														],
														[
															311.398,
															30.566
														],
														[
															296,
															34
														],
														[
															247.153,
															53.826
														],
														[
															207,
															80
														],
														[
															201.418,
															83.97
														],
														[
															196,
															88
														],
														[
															185.59,
															97.453
														],
														[
															176,
															107
														],
														[
															168.665,
															114.588
														],
														[
															162,
															122
														],
														[
															157.275,
															127.724
														],
														[
															153,
															133
														],
														[
															142.583,
															146.757
														],
														[
															133,
															161
														],
														[
															125.745,
															173.403
														],
														[
															119,
															186
														],
														[
															106.588,
															212.205
														],
														[
															96,
															241
														],
														[
															81.011,
															305.194
														],
														[
															77,
															377
														],
														[
															82.067,
															424.733
														],
														[
															91,
															468
														],
														[
															92.439,
															471.479
														],
														[
															94,
															475
														],
														[
															95.979,
															482.609
														],
														[
															98,
															490
														],
														[
															111.995,
															524.263
														],
														[
															129,
															556
														],
														[
															138.392,
															571.102
														],
														[
															148,
															585
														],
														[
															152.616,
															590.772
														],
														[
															157,
															596
														],
														[
															159.033,
															599.057
														],
														[
															161,
															602
														],
														[
															170.18,
															611.588
														],
														[
															180,
															621
														],
														[
															189.767,
															630.707
														],
														[
															200,
															640
														],
														[
															222.322,
															656.464
														],
														[
															247,
															671
														],
														[
															294.984,
															690.321
														],
														[
															353,
															700
														],
														[
															365.28,
															699.99
														],
														[
															375,
															699
														],
														[
															375.582,
															697.61
														],
														[
															376,
															696
														],
														[
															377.608,
															693.871
														],
														[
															379,
															692
														],
														[
															380.57,
															689.797
														],
														[
															382,
															688
														],
														[
															387.925,
															685.831
														],
														[
															395,
															685
														],
														[
															407.232,
															682.68
														],
														[
															418,
															680
														],
														[
															447.062,
															670.687
														],
														[
															473,
															659
														],
														[
															529.034,
															620.228
														],
														[
															574,
															571
														],
														[
															588.65,
															549.229
														],
														[
															601,
															526
														],
														[
															601.978,
															525.529
														],
														[
															603,
															525
														],
														[
															604.036,
															521.52
														],
														[
															605,
															518
														],
														[
															609.151,
															509.728
														],
														[
															613,
															502
														],
														[
															615.173,
															496.698
														],
														[
															617,
															492
														],
														[
															623.442,
															474.247
														],
														[
															629,
															456
														],
														[
															634.712,
															432.962
														],
														[
															639,
															409
														],
														[
															640.349,
															319.354
														],
														[
															625,
															240
														],
														[
															620.933,
															229.342
														],
														[
															617,
															220
														],
														[
															616.001,
															215.946
														],
														[
															615,
															212
														],
														[
															613.536,
															209.003
														],
														[
															612,
															206
														],
														[
															573.695,
															140.233
														],
														[
															524,
															87
														],
														[
															519.782,
															83.752
														],
														[
															516,
															81
														],
														[
															515.007,
															79.503
														],
														[
															514,
															78
														],
														[
															513.027,
															77.963
														],
														[
															512,
															78
														],
														[
															511.514,
															77.041
														],
														[
															511,
															76
														],
														[
															505.551,
															72.821
														],
														[
															501,
															70
														],
														[
															499.505,
															69.005
														],
														[
															498,
															68
														],
														[
															491,
															63
														],
														[
															472,
															53
														],
														[
															417,
															32
														],
														[
															348,
															25
														],
														[
															347,
															26
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 12,
											"s": [
												{
													"i": [
														[
															0.66,
															-0.001
														],
														[
															8.835,
															-1.848
														],
														[
															7.101,
															-1.594
														],
														[
															0.636,
															-0.468
														],
														[
															0.265,
															-0.085
														],
														[
															9.651,
															-4.761
														],
														[
															7.987,
															-5.274
														],
														[
															12.711,
															-12.49
														],
														[
															10.218,
															-14.517
														],
														[
															9.085,
															-19.353
														],
														[
															5.853,
															-21.812
														],
														[
															1.157,
															-5.149
														],
														[
															0.99,
															-5.259
														],
														[
															0.986,
															-8.553
														],
														[
															0.558,
															-8.823
														],
														[
															-5.367,
															-29.646
														],
														[
															-9.73,
															-23.654
														],
														[
															-3.437,
															-7.219
														],
														[
															-3.464,
															-5.346
														],
														[
															-1.202,
															-2.205
														],
														[
															-0.972,
															-1.299
														],
														[
															-0.321,
															-0.491
														],
														[
															-0.336,
															-0.527
														],
														[
															-11.821,
															-13.348
														],
														[
															-13.593,
															-9.293
														],
														[
															-1.322,
															-1.277
														],
														[
															-1.244,
															-0.888
														],
														[
															-1.356,
															-0.689
														],
														[
															-0.486,
															-0.465
														],
														[
															-0.539,
															-0.298
														],
														[
															-0.425,
															-0.408
														],
														[
															-1.173,
															-0.807
														],
														[
															-1.186,
															-0.695
														],
														[
															-1.597,
															-0.851
														],
														[
															-1.013,
															-0.657
														],
														[
															-1.673,
															-0.784
														],
														[
															-1.703,
															-0.825
														],
														[
															-12.015,
															-3.777
														],
														[
															-14.242,
															-1.712
														],
														[
															-6.097,
															-0.384
														],
														[
															-4.145,
															1.313
														],
														[
															-0.556,
															0.123
														],
														[
															-0.982,
															0.941
														],
														[
															-0.451,
															0.681
														],
														[
															-0.751,
															0.846
														],
														[
															-0.374,
															1.094
														],
														[
															-0.553,
															0.553
														],
														[
															-0.408,
															-0.066
														],
														[
															-0.208,
															0.104
														],
														[
															-1.968,
															0.257
														],
														[
															-1.739,
															0.275
														],
														[
															-2.423,
															0.489
														],
														[
															-2.185,
															0.548
														],
														[
															-20.418,
															12.383
														],
														[
															-15.731,
															16.05
														],
														[
															-3.808,
															4.079
														],
														[
															-2.998,
															3.839
														],
														[
															-0.682,
															0.834
														],
														[
															-0.632,
															0.844
														],
														[
															-0.084,
															0.521
														],
														[
															-0.336,
															0.481
														],
														[
															-0.602,
															0.29
														],
														[
															-0.301,
															0.426
														],
														[
															0.067,
															0.383
														],
														[
															-0.112,
															0.25
														],
														[
															-0.451,
															0.163
														],
														[
															-0.123,
															0.185
														],
														[
															0.067,
															0.379
														],
														[
															-0.115,
															0.255
														],
														[
															-0.451,
															0.167
														],
														[
															-0.124,
															0.177
														],
														[
															-2.299,
															3.861
														],
														[
															-2.327,
															4.037
														],
														[
															-8.805,
															34.343
														],
														[
															1.247,
															44.821
														],
														[
															2.199,
															13.713
														],
														[
															2.813,
															11.122
														],
														[
															2.727,
															8.407
														],
														[
															2.937,
															6.853
														],
														[
															0.513,
															0.948
														],
														[
															0.462,
															1.072
														],
														[
															0.276,
															1.235
														],
														[
															0.457,
															1.043
														],
														[
															0.746,
															0.948
														],
														[
															0.527,
															1.096
														],
														[
															1.92,
															3.972
														],
														[
															1.521,
															3.374
														],
														[
															0.451,
															0.156
														],
														[
															0.12,
															0.203
														],
														[
															0.472,
															1.026
														],
														[
															0.555,
															0.952
														],
														[
															1.145,
															1.774
														],
														[
															1.125,
															1.685
														],
														[
															3.25,
															4.387
														],
														[
															3.707,
															4.516
														],
														[
															15.048,
															12.274
														],
														[
															9.26,
															5.572
														],
														[
															2.351,
															1.271
														],
														[
															48.211,
															-3.086
														],
														[
															-0.109,
															0.008
														]
													],
													"o": [
														[
															-8.558,
															0.012
														],
														[
															-8.835,
															1.848
														],
														[
															-0.191,
															0.043
														],
														[
															-0.636,
															0.468
														],
														[
															-11.409,
															3.68
														],
														[
															-9.651,
															4.761
														],
														[
															-15.938,
															10.525
														],
														[
															-12.711,
															12.49
														],
														[
															-11.806,
															16.774
														],
														[
															-9.085,
															19.353
														],
														[
															-1.38,
															5.143
														],
														[
															-1.157,
															5.149
														],
														[
															-1.499,
															7.964
														],
														[
															-0.986,
															8.553
														],
														[
															-2.199,
															34.762
														],
														[
															5.367,
															29.646
														],
														[
															2.787,
															6.776
														],
														[
															3.437,
															7.22
														],
														[
															1.219,
															1.881
														],
														[
															1.202,
															2.205
														],
														[
															0.382,
															0.51
														],
														[
															0.321,
															0.491
														],
														[
															9.123,
															14.315
														],
														[
															11.821,
															13.348
														],
														[
															1.469,
															1.004
														],
														[
															1.322,
															1.277
														],
														[
															1.09,
															0.778
														],
														[
															1.356,
															0.689
														],
														[
															0.419,
															0.401
														],
														[
															0.539,
															0.298
														],
														[
															1.123,
															1.075
														],
														[
															1.173,
															0.807
														],
														[
															1.601,
															0.938
														],
														[
															1.597,
															0.851
														],
														[
															1.604,
															1.039
														],
														[
															1.673,
															0.784
														],
														[
															10.7,
															5.18
														],
														[
															12.015,
															3.777
														],
														[
															6.466,
															0.777
														],
														[
															6.097,
															0.384
														],
														[
															1.793,
															-0.568
														],
														[
															0.556,
															-0.123
														],
														[
															0.447,
															-0.428
														],
														[
															0.45,
															-0.681
														],
														[
															0.951,
															-1.072
														],
														[
															0.374,
															-1.094
														],
														[
															0.159,
															-0.159
														],
														[
															0.408,
															0.066
														],
														[
															1.391,
															-0.696
														],
														[
															1.968,
															-0.257
														],
														[
															3.125,
															-0.495
														],
														[
															2.423,
															-0.489
														],
														[
															25.596,
															-6.417
														],
														[
															20.418,
															-12.383
														],
														[
															3.769,
															-3.845
														],
														[
															3.808,
															-4.079
														],
														[
															0.64,
															-0.82
														],
														[
															0.682,
															-0.834
														],
														[
															0.327,
															-0.438
														],
														[
															0.084,
															-0.52
														],
														[
															0.291,
															-0.416
														],
														[
															0.602,
															-0.289
														],
														[
															0.156,
															-0.221
														],
														[
															-0.067,
															-0.383
														],
														[
															0.073,
															-0.162
														],
														[
															0.451,
															-0.163
														],
														[
															0.154,
															-0.23
														],
														[
															-0.067,
															-0.379
														],
														[
															0.071,
															-0.157
														],
														[
															0.451,
															-0.167
														],
														[
															2.477,
															-3.519
														],
														[
															2.299,
															-3.861
														],
														[
															16.027,
															-27.807
														],
														[
															8.805,
															-34.343
														],
														[
															-0.39,
															-14.027
														],
														[
															-2.199,
															-13.713
														],
														[
															-2.155,
															-8.519
														],
														[
															-2.727,
															-8.407
														],
														[
															-0.486,
															-1.135
														],
														[
															-0.513,
															-0.948
														],
														[
															-0.438,
															-1.018
														],
														[
															-0.276,
															-1.235
														],
														[
															-0.487,
															-1.111
														],
														[
															-0.746,
															-0.948
														],
														[
															-1.798,
															-3.738
														],
														[
															-1.92,
															-3.972
														],
														[
															-0.078,
															-0.173
														],
														[
															-0.451,
															-0.156
														],
														[
															-0.556,
															-0.945
														],
														[
															-0.472,
															-1.026
														],
														[
															-1.295,
															-2.219
														],
														[
															-1.145,
															-1.774
														],
														[
															-3.294,
															-4.935
														],
														[
															-3.25,
															-4.387
														],
														[
															-13.32,
															-16.223
														],
														[
															-9.155,
															-7.467
														],
														[
															-2.023,
															-1.218
														],
														[
															-30.537,
															-16.511
														],
														[
															-0.627,
															0.04
														],
														[
															-0.658,
															0.049
														]
													],
													"v": [
														[
															346,
															26
														],
														[
															319.407,
															29.314
														],
														[
															295,
															35
														],
														[
															293.556,
															35.968
														],
														[
															292,
															37
														],
														[
															260.433,
															49.805
														],
														[
															234,
															65
														],
														[
															191.21,
															99.506
														],
														[
															157,
															140
														],
														[
															125.535,
															194.221
														],
														[
															103,
															256
														],
														[
															99.208,
															271.413
														],
														[
															96,
															287
														],
														[
															92.294,
															311.856
														],
														[
															90,
															338
														],
														[
															95.554,
															434.831
														],
														[
															119,
															515
														],
														[
															128.492,
															536.572
														],
														[
															139,
															556
														],
														[
															142.685,
															562.437
														],
														[
															146,
															568
														],
														[
															147.034,
															569.487
														],
														[
															148,
															571
														],
														[
															179.647,
															613.266
														],
														[
															218,
															648
														],
														[
															222.168,
															651.587
														],
														[
															226,
															655
														],
														[
															229.953,
															657.235
														],
														[
															233,
															659
														],
														[
															234.495,
															659.995
														],
														[
															236,
															661
														],
														[
															239.452,
															663.785
														],
														[
															243,
															666
														],
														[
															247.941,
															668.711
														],
														[
															252,
															671
														],
														[
															256.925,
															673.661
														],
														[
															262,
															676
														],
														[
															295.843,
															689.601
														],
														[
															335,
															698
														],
														[
															354.24,
															700.068
														],
														[
															370,
															699
														],
														[
															373.108,
															698.28
														],
														[
															375,
															697
														],
														[
															376.272,
															695.313
														],
														[
															378,
															693
														],
														[
															379.798,
															689.61
														],
														[
															381,
															687
														],
														[
															381.963,
															686.959
														],
														[
															383,
															687
														],
														[
															388.239,
															685.685
														],
														[
															394,
															685
														],
														[
															402.206,
															683.539
														],
														[
															409,
															682
														],
														[
															477.899,
															653.224
														],
														[
															532,
															610
														],
														[
															543.578,
															597.995
														],
														[
															554,
															586
														],
														[
															556.006,
															583.518
														],
														[
															558,
															581
														],
														[
															558.494,
															579.532
														],
														[
															559,
															578
														],
														[
															560.492,
															577.007
														],
														[
															562,
															576
														],
														[
															562.032,
															575.022
														],
														[
															562,
															574
														],
														[
															562.962,
															573.517
														],
														[
															564,
															573
														],
														[
															564.029,
															572.019
														],
														[
															564,
															571
														],
														[
															564.96,
															570.515
														],
														[
															566,
															570
														],
														[
															573.112,
															558.888
														],
														[
															580,
															547
														],
														[
															617.956,
															454.76
														],
														[
															630,
															337
														],
														[
															625.817,
															294.821
														],
														[
															618,
															257
														],
														[
															610.587,
															231.25
														],
														[
															602,
															208
														],
														[
															600.482,
															204.953
														],
														[
															599,
															202
														],
														[
															598.014,
															198.518
														],
														[
															597,
															195
														],
														[
															595.03,
															191.989
														],
														[
															593,
															189
														],
														[
															587.292,
															177.227
														],
														[
															582,
															166
														],
														[
															581.031,
															165.522
														],
														[
															580,
															165
														],
														[
															578.499,
															162.005
														],
														[
															577,
															159
														],
														[
															573.372,
															153.099
														],
														[
															570,
															148
														],
														[
															560.31,
															134.185
														],
														[
															550,
															121
														],
														[
															506,
															78
														],
														[
															476,
															57
														],
														[
															469,
															54
														],
														[
															349,
															25
														],
														[
															348,
															26
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 13,
											"s": [
												{
													"i": [
														[
															14.518,
															-10.233
														],
														[
															6.719,
															-5.787
														],
														[
															6.086,
															-6.307
														],
														[
															5.448,
															-6.742
														],
														[
															4.808,
															-7.09
														],
														[
															6.312,
															-12.231
														],
														[
															5.081,
															-13.508
														],
														[
															3.729,
															-14.773
														],
														[
															2.255,
															-16.026
														],
														[
															0.261,
															-17.578
														],
														[
															-1.682,
															-16.867
														],
														[
															-3.352,
															-15.481
														],
														[
															-4.748,
															-13.418
														],
														[
															-3.748,
															-8.694
														],
														[
															-4.228,
															-8.122
														],
														[
															-4.741,
															-7.617
														],
														[
															-5.288,
															-7.179
														],
														[
															-5.647,
															-6.391
														],
														[
															-6.349,
															-5.922
														],
														[
															-7.153,
															-5.445
														],
														[
															-8.058,
															-4.96
														],
														[
															-7.287,
															-3.449
														],
														[
															-8.264,
															-2.761
														],
														[
															-9.22,
															-1.806
														],
														[
															-10.154,
															-0.585
														],
														[
															-1.566,
															-0.125
														],
														[
															-1.442,
															-0.062
														],
														[
															-1.28,
															0.094
														],
														[
															-1.081,
															0.342
														],
														[
															-0.478,
															0.091
														],
														[
															-0.281,
															0.061
														],
														[
															-0.288,
															0.19
														],
														[
															-0.498,
															0.477
														],
														[
															-0.21,
															0.286
														],
														[
															-0.23,
															0.345
														],
														[
															-0.28,
															0.386
														],
														[
															-0.359,
															0.41
														],
														[
															-0.189,
															0.479
														],
														[
															-0.091,
															0.45
														],
														[
															-0.107,
															0.371
														],
														[
															-0.236,
															0.241
														],
														[
															-1.126,
															0.342
														],
														[
															-1.348,
															0.165
														],
														[
															-1.298,
															0.116
														],
														[
															-0.977,
															0.193
														],
														[
															-3.089,
															0.757
														],
														[
															-2.959,
															0.857
														],
														[
															-2.765,
															0.921
														],
														[
															-2.508,
															0.95
														],
														[
															-9.634,
															5.197
														],
														[
															-9.281,
															6.977
														],
														[
															-11.506,
															12.372
														],
														[
															-9.821,
															14.872
														],
														[
															-7.527,
															16.64
														],
														[
															-5.409,
															19.077
														],
														[
															-2.576,
															21.565
														],
														[
															0.601,
															25.063
														],
														[
															2.396,
															15.035
														],
														[
															3.022,
															13.46
														],
														[
															0.47,
															0.637
														],
														[
															0.076,
															0.265
														],
														[
															-0.079,
															0.689
														],
														[
															0.14,
															0.627
														],
														[
															0.793,
															1.736
														],
														[
															0.488,
															1.549
														],
														[
															1.134,
															3.462
														],
														[
															1.221,
															3.212
														],
														[
															0.815,
															2.159
														],
														[
															0.873,
															2.089
														],
														[
															7.267,
															12.063
														],
														[
															9.014,
															11.589
														],
														[
															0.082,
															0.521
														],
														[
															0.337,
															0.482
														],
														[
															0.595,
															0.294
														],
														[
															0.33,
															0.407
														],
														[
															4.968,
															5.556
														],
														[
															5.349,
															4.87
														],
														[
															0.527,
															0.073
														],
														[
															0.482,
															0.337
														],
														[
															1.112,
															1.264
														],
														[
															1.166,
															0.977
														],
														[
															4.522,
															3.327
														],
														[
															3.972,
															2.39
														],
														[
															1.227,
															0.442
														],
														[
															1.074,
															0.62
														],
														[
															0.333,
															0.397
														],
														[
															0.376,
															0.244
														],
														[
															2.589,
															1.356
														],
														[
															2.312,
															1.067
														],
														[
															1.243,
															0.271
														],
														[
															1.071,
															0.473
														],
														[
															1.974,
															1.089
														],
														[
															2.118,
															0.767
														],
														[
															2.342,
															0.623
														],
														[
															2.417,
															0.708
														],
														[
															10.956,
															1.487
														],
														[
															11.475,
															-0.791
														],
														[
															0.185,
															-0.246
														],
														[
															-0.053,
															0.004
														],
														[
															18.058,
															-6.757
														]
													],
													"o": [
														[
															-7.35,
															5.18
														],
														[
															-6.719,
															5.787
														],
														[
															-6.086,
															6.307
														],
														[
															-5.448,
															6.742
														],
														[
															-7.421,
															10.944
														],
														[
															-6.312,
															12.231
														],
														[
															-5.081,
															13.508
														],
														[
															-3.729,
															14.773
														],
														[
															-2.478,
															17.613
														],
														[
															-0.261,
															17.578
														],
														[
															1.682,
															16.867
														],
														[
															3.352,
															15.481
														],
														[
															3.302,
															9.332
														],
														[
															3.748,
															8.694
														],
														[
															4.228,
															8.122
														],
														[
															4.741,
															7.617
														],
														[
															5.047,
															6.852
														],
														[
															5.647,
															6.391
														],
														[
															6.349,
															5.922
														],
														[
															7.153,
															5.445
														],
														[
															6.288,
															3.871
														],
														[
															7.287,
															3.449
														],
														[
															8.264,
															2.761
														],
														[
															9.22,
															1.806
														],
														[
															1.653,
															0.095
														],
														[
															1.566,
															0.125
														],
														[
															1.442,
															0.062
														],
														[
															1.28,
															-0.094
														],
														[
															0.878,
															-0.278
														],
														[
															0.478,
															-0.091
														],
														[
															0.281,
															-0.061
														],
														[
															0.288,
															-0.19
														],
														[
															0.221,
															-0.211
														],
														[
															0.21,
															-0.286
														],
														[
															0.23,
															-0.345
														],
														[
															0.28,
															-0.386
														],
														[
															0.4,
															-0.457
														],
														[
															0.189,
															-0.479
														],
														[
															0.091,
															-0.45
														],
														[
															0.107,
															-0.371
														],
														[
															0.632,
															-0.645
														],
														[
															1.126,
															-0.342
														],
														[
															1.348,
															-0.165
														],
														[
															1.298,
															-0.116
														],
														[
															3.158,
															-0.624
														],
														[
															3.089,
															-0.757
														],
														[
															2.959,
															-0.857
														],
														[
															2.765,
															-0.921
														],
														[
															11.182,
															-4.236
														],
														[
															9.634,
															-5.197
														],
														[
															14.155,
															-10.641
														],
														[
															11.506,
															-12.372
														],
														[
															9.485,
															-14.362
														],
														[
															7.526,
															-16.64
														],
														[
															5.296,
															-18.675
														],
														[
															2.576,
															-21.565
														],
														[
															-0.393,
															-16.399
														],
														[
															-2.396,
															-15.035
														],
														[
															-0.043,
															-0.189
														],
														[
															-0.47,
															-0.637
														],
														[
															-0.177,
															-0.617
														],
														[
															0.079,
															-0.689
														],
														[
															-0.339,
															-1.508
														],
														[
															-0.793,
															-1.736
														],
														[
															-1.241,
															-3.939
														],
														[
															-1.134,
															-3.462
														],
														[
															-0.865,
															-2.276
														],
														[
															-0.815,
															-2.159
														],
														[
															-5.918,
															-14.159
														],
														[
															-7.267,
															-12.063
														],
														[
															-0.337,
															-0.434
														],
														[
															-0.082,
															-0.521
														],
														[
															-0.291,
															-0.416
														],
														[
															-0.595,
															-0.294
														],
														[
															-4.781,
															-5.906
														],
														[
															-4.968,
															-5.556
														],
														[
															-0.409,
															-0.373
														],
														[
															-0.527,
															-0.073
														],
														[
															-1.387,
															-0.969
														],
														[
															-1.112,
															-1.264
														],
														[
															-3.94,
															-3.302
														],
														[
															-4.522,
															-3.327
														],
														[
															-1.017,
															-0.612
														],
														[
															-1.227,
															-0.442
														],
														[
															-0.291,
															-0.168
														],
														[
															-0.333,
															-0.397
														],
														[
															-2.331,
															-1.51
														],
														[
															-2.589,
															-1.356
														],
														[
															-0.959,
															-0.442
														],
														[
															-1.243,
															-0.271
														],
														[
															-1.988,
															-0.879
														],
														[
															-1.974,
															-1.089
														],
														[
															-2.214,
															-0.802
														],
														[
															-2.342,
															-0.623
														],
														[
															-9.702,
															-2.843
														],
														[
															-10.956,
															-1.487
														],
														[
															-0.312,
															0.021
														],
														[
															-0.185,
															0.246
														],
														[
															-22.252,
															1.74
														],
														[
															-18.058,
															6.757
														]
													],
													"v": [
														[
															240,
															65
														],
														[
															218.895,
															81.472
														],
														[
															199.687,
															99.635
														],
														[
															182.385,
															119.23
														],
														[
															167,
															140
														],
														[
															146.371,
															174.765
														],
														[
															129.251,
															213.376
														],
														[
															116.005,
															255.799
														],
														[
															107,
															302
														],
														[
															102.961,
															354.955
														],
														[
															105.161,
															406.792
														],
														[
															112.782,
															455.482
														],
														[
															125,
															499
														],
														[
															135.567,
															526.021
														],
														[
															147.521,
															551.228
														],
														[
															160.966,
															574.821
														],
														[
															176,
															597
														],
														[
															192.015,
															616.866
														],
														[
															209.983,
															635.338
														],
														[
															230.21,
															652.39
														],
														[
															253,
															668
														],
														[
															273.368,
															679.047
														],
														[
															296.701,
															688.429
														],
														[
															322.933,
															695.347
														],
														[
															352,
															699
														],
														[
															356.837,
															699.353
														],
														[
															361.357,
															699.657
														],
														[
															365.449,
															699.632
														],
														[
															369,
															699
														],
														[
															370.983,
															698.486
														],
														[
															372.07,
															698.298
														],
														[
															372.872,
															697.961
														],
														[
															374,
															697
														],
														[
															374.639,
															696.249
														],
														[
															375.292,
															695.298
														],
														[
															376.049,
															694.198
														],
														[
															377,
															693
														],
														[
															377.855,
															691.583
														],
														[
															378.246,
															690.176
														],
														[
															378.514,
															688.931
														],
														[
															379,
															688
														],
														[
															381.705,
															686.55
														],
														[
															385.483,
															685.821
														],
														[
															389.52,
															685.431
														],
														[
															393,
															685
														],
														[
															402.386,
															682.92
														],
														[
															411.474,
															680.49
														],
														[
															420.075,
															677.815
														],
														[
															428,
															675
														],
														[
															458.925,
															661.056
														],
														[
															487,
															643
														],
														[
															525.25,
															608.673
														],
														[
															557,
															568
														],
														[
															582.556,
															521.536
														],
														[
															602,
															468
														],
														[
															613.922,
															407.791
														],
														[
															617,
															338
														],
														[
															612.472,
															290.795
														],
														[
															604,
															248
														],
														[
															603.025,
															246.557
														],
														[
															602,
															245
														],
														[
															601.973,
															243.008
														],
														[
															602,
															241
														],
														[
															600.112,
															236.031
														],
														[
															598,
															231
														],
														[
															594.485,
															219.955
														],
														[
															591,
															210
														],
														[
															588.506,
															203.36
														],
														[
															586,
															197
														],
														[
															566.322,
															158.072
														],
														[
															542,
															123
														],
														[
															541.5,
															121.536
														],
														[
															541,
															120
														],
														[
															539.529,
															118.993
														],
														[
															538,
															118
														],
														[
															523.426,
															100.723
														],
														[
															508,
															85
														],
														[
															506.555,
															84.473
														],
														[
															505,
															84
														],
														[
															501.334,
															80.505
														],
														[
															498,
															77
														],
														[
															485.024,
															66.816
														],
														[
															472,
															58
														],
														[
															468.543,
															56.506
														],
														[
															465,
															55
														],
														[
															464.064,
															54.057
														],
														[
															463,
															53
														],
														[
															455.486,
															48.668
														],
														[
															448,
															45
														],
														[
															444.584,
															44.023
														],
														[
															441,
															43
														],
														[
															435.098,
															39.916
														],
														[
															429,
															37
														],
														[
															422.152,
															34.93
														],
														[
															415,
															33
														],
														[
															383.83,
															26.275
														],
														[
															350,
															25
														],
														[
															349.226,
															25.519
														],
														[
															349,
															26
														],
														[
															288.699,
															39.131
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 14,
											"s": [
												{
													"i": [
														[
															11.19,
															-3.027
														],
														[
															5.733,
															-2.118
														],
														[
															4.302,
															-1.969
														],
														[
															3.553,
															-1.972
														],
														[
															2.419,
															-1.567
														],
														[
															0.507,
															-0.349
														],
														[
															0.46,
															-0.275
														],
														[
															2.597,
															-1.812
														],
														[
															2.487,
															-1.885
														],
														[
															7.681,
															-7.343
														],
														[
															6.399,
															-7.9
														],
														[
															7.117,
															-11.326
														],
														[
															5.476,
															-11.752
														],
														[
															1.056,
															-2.011
														],
														[
															0.873,
															-2.018
														],
														[
															2.842,
															-8.625
														],
														[
															2.339,
															-7.885
														],
														[
															0.322,
															-1.149
														],
														[
															0.343,
															-1.155
														],
														[
															1.73,
															-9.376
														],
														[
															1.305,
															-10.147
														],
														[
															0.672,
															-11.514
														],
														[
															-0.124,
															-11.799
														],
														[
															-5.423,
															-25.242
														],
														[
															-8.008,
															-20.347
														],
														[
															-3.791,
															-8.184
														],
														[
															-4.368,
															-7.448
														],
														[
															-2.006,
															-3.074
														],
														[
															-1.222,
															-2.712
														],
														[
															-0.451,
															-0.163
														],
														[
															-0.124,
															-0.185
														],
														[
															0.067,
															-0.379
														],
														[
															-0.115,
															-0.255
														],
														[
															-0.451,
															-0.163
														],
														[
															-0.124,
															-0.185
														],
														[
															-0.413,
															-1.007
														],
														[
															-0.688,
															-0.987
														],
														[
															-0.72,
															-0.866
														],
														[
															-0.572,
															-0.753
														],
														[
															-11.777,
															-11.015
														],
														[
															-13.272,
															-8.281
														],
														[
															-1.023,
															-0.462
														],
														[
															-1.006,
															-0.589
														],
														[
															-1.79,
															-1.234
														],
														[
															-2.022,
															-1.003
														],
														[
															-2.224,
															-0.787
														],
														[
															-2.207,
															-0.912
														],
														[
															-6.778,
															-1.963
														],
														[
															-8.216,
															-1.39
														],
														[
															-5.703,
															-0.545
														],
														[
															-4.353,
															1.168
														],
														[
															-0.872,
															0.182
														],
														[
															-0.867,
															1.561
														],
														[
															-0.617,
															1.19
														],
														[
															-0.753,
															0.838
														],
														[
															-2.026,
															0.479
														],
														[
															-2.455,
															0.478
														],
														[
															-2.49,
															0.454
														],
														[
															-2.44,
															0.678
														],
														[
															-0.965,
															0.589
														],
														[
															-1.072,
															0.346
														],
														[
															-4.395,
															1.424
														],
														[
															-4.126,
															1.917
														],
														[
															-4.825,
															2.797
														],
														[
															-3.998,
															2.627
														],
														[
															-0.819,
															0.706
														],
														[
															-0.909,
															0.639
														],
														[
															-0.52,
															0.089
														],
														[
															-0.477,
															0.333
														],
														[
															-0.29,
															0.6
														],
														[
															-0.423,
															0.308
														],
														[
															-0.672,
															0.236
														],
														[
															-0.435,
															0.417
														],
														[
															-0.985,
															0.781
														],
														[
															-0.993,
															0.854
														],
														[
															-5.448,
															5.218
														],
														[
															-4.583,
															5.289
														],
														[
															-12.018,
															23.393
														],
														[
															-7.527,
															27.498
														],
														[
															-2.31,
															21.206
														],
														[
															0.26,
															24.832
														],
														[
															3.615,
															19.871
														],
														[
															6.314,
															18.809
														],
														[
															6.299,
															13.122
														],
														[
															7.009,
															11.233
														],
														[
															0.476,
															1.073
														],
														[
															0.548,
															0.827
														],
														[
															1.389,
															1.618
														],
														[
															1.248,
															1.721
														],
														[
															0.606,
															0.792
														],
														[
															4.653,
															5.362
														],
														[
															6.076,
															5.562
														],
														[
															1.615,
															1.372
														],
														[
															1.778,
															1.598
														],
														[
															10.873,
															6.914
														],
														[
															8.4,
															3.981
														],
														[
															8.915,
															2.82
														],
														[
															4.932,
															1.176
														],
														[
															5.044,
															0.707
														],
														[
															8.767,
															-0.686
														]
													],
													"o": [
														[
															-5.765,
															1.559
														],
														[
															-5.733,
															2.118
														],
														[
															-3.37,
															1.543
														],
														[
															-3.553,
															1.972
														],
														[
															-0.51,
															0.331
														],
														[
															-0.507,
															0.349
														],
														[
															-3.127,
															1.865
														],
														[
															-2.596,
															1.812
														],
														[
															-8.875,
															6.726
														],
														[
															-7.681,
															7.344
														],
														[
															-8.055,
															9.944
														],
														[
															-7.117,
															11.326
														],
														[
															-0.903,
															1.938
														],
														[
															-1.056,
															2.011
														],
														[
															-3.293,
															7.618
														],
														[
															-2.842,
															8.624
														],
														[
															-0.37,
															1.249
														],
														[
															-0.322,
															1.149
														],
														[
															-2.774,
															9.35
														],
														[
															-1.73,
															9.376
														],
														[
															-1.434,
															11.144
														],
														[
															-0.672,
															11.514
														],
														[
															0.3,
															28.683
														],
														[
															5.423,
															25.242
														],
														[
															3.47,
															8.817
														],
														[
															3.791,
															8.184
														],
														[
															1.754,
															2.991
														],
														[
															2.006,
															3.074
														],
														[
															0.073,
															0.162
														],
														[
															0.451,
															0.163
														],
														[
															0.154,
															0.23
														],
														[
															-0.067,
															0.379
														],
														[
															0.073,
															0.161
														],
														[
															0.451,
															0.163
														],
														[
															0.659,
															0.985
														],
														[
															0.413,
															1.007
														],
														[
															0.546,
															0.785
														],
														[
															0.72,
															0.866
														],
														[
															9.62,
															12.659
														],
														[
															11.777,
															11.015
														],
														[
															0.903,
															0.563
														],
														[
															1.023,
															0.462
														],
														[
															1.818,
															1.063
														],
														[
															1.79,
															1.233
														],
														[
															1.898,
															0.942
														],
														[
															2.224,
															0.787
														],
														[
															6.673,
															2.758
														],
														[
															6.778,
															1.963
														],
														[
															5.834,
															0.987
														],
														[
															5.703,
															0.545
														],
														[
															2.644,
															-0.709
														],
														[
															0.872,
															-0.182
														],
														[
															0.779,
															-1.402
														],
														[
															0.617,
															-1.19
														],
														[
															1.442,
															-1.605
														],
														[
															2.026,
															-0.479
														],
														[
															2.601,
															-0.507
														],
														[
															2.49,
															-0.454
														],
														[
															1.07,
															-0.298
														],
														[
															0.965,
															-0.589
														],
														[
															4.294,
															-1.389
														],
														[
															4.395,
															-1.424
														],
														[
															4.702,
															-2.184
														],
														[
															4.825,
															-2.797
														],
														[
															0.815,
															-0.536
														],
														[
															0.819,
															-0.706
														],
														[
															0.442,
															-0.311
														],
														[
															0.52,
															-0.089
														],
														[
															0.417,
															-0.291
														],
														[
															0.29,
															-0.6
														],
														[
															0.878,
															-0.639
														],
														[
															0.672,
															-0.236
														],
														[
															1.068,
															-1.024
														],
														[
															0.985,
															-0.781
														],
														[
															5.625,
															-4.84
														],
														[
															5.448,
															-5.218
														],
														[
															16.401,
															-18.929
														],
														[
															12.018,
															-23.393
														],
														[
															5.021,
															-18.342
														],
														[
															2.31,
															-21.206
														],
														[
															-0.227,
															-21.706
														],
														[
															-3.615,
															-19.871
														],
														[
															-4.793,
															-14.279
														],
														[
															-6.299,
															-13.122
														],
														[
															-0.549,
															-0.88
														],
														[
															-0.476,
															-1.073
														],
														[
															-1.196,
															-1.808
														],
														[
															-1.389,
															-1.618
														],
														[
															-0.655,
															-0.903
														],
														[
															-4.663,
															-6.097
														],
														[
															-5.466,
															-6.3
														],
														[
															-1.578,
															-1.445
														],
														[
															-1.594,
															-1.354
														],
														[
															-9.601,
															-8.626
														],
														[
															-6.728,
															-4.278
														],
														[
															-7.958,
															-3.771
														],
														[
															-4.133,
															-1.307
														],
														[
															-4.922,
															-1.173
														],
														[
															-11.688,
															-1.639
														],
														[
															-11.234,
															0.878
														]
													],
													"v": [
														[
															317,
															31
														],
														[
															299.402,
															36.693
														],
														[
															284,
															43
														],
														[
															273.287,
															48.481
														],
														[
															264,
															54
														],
														[
															262.463,
															55.042
														],
														[
															261,
															56
														],
														[
															252.52,
															61.485
														],
														[
															245,
															67
														],
														[
															220.144,
															88.119
														],
														[
															199,
															111
														],
														[
															176.066,
															143.143
														],
														[
															157,
															178
														],
														[
															153.977,
															183.94
														],
														[
															151,
															190
														],
														[
															141.785,
															214.8
														],
														[
															134,
															240
														],
														[
															132.979,
															243.57
														],
														[
															132,
															247
														],
														[
															125.399,
															274.902
														],
														[
															121,
															304
														],
														[
															117.832,
															338.009
														],
														[
															117,
															373
														],
														[
															126.219,
															454.252
														],
														[
															147,
															523
														],
														[
															157.827,
															548.526
														],
														[
															170,
															572
														],
														[
															175.899,
															581.21
														],
														[
															181,
															590
														],
														[
															181.962,
															590.483
														],
														[
															183,
															591
														],
														[
															183.029,
															591.981
														],
														[
															183,
															593
														],
														[
															183.962,
															593.483
														],
														[
															185,
															594
														],
														[
															186.479,
															596.998
														],
														[
															188,
															600
														],
														[
															189.981,
															602.524
														],
														[
															192,
															605
														],
														[
															224.262,
															640.784
														],
														[
															262,
															670
														],
														[
															264.922,
															671.481
														],
														[
															268,
															673
														],
														[
															273.348,
															676.546
														],
														[
															279,
															680
														],
														[
															285.269,
															682.522
														],
														[
															292,
															685
														],
														[
															311.842,
															692.026
														],
														[
															334,
															697
														],
														[
															351.61,
															699.617
														],
														[
															367,
															699
														],
														[
															371.832,
															698.139
														],
														[
															374,
															696
														],
														[
															376.019,
															692.077
														],
														[
															378,
															689
														],
														[
															383.24,
															686.155
														],
														[
															390,
															685
														],
														[
															397.621,
															683.629
														],
														[
															405,
															682
														],
														[
															407.999,
															680.537
														],
														[
															411,
															679
														],
														[
															424.126,
															674.896
														],
														[
															437,
															670
														],
														[
															451.528,
															662.332
														],
														[
															465,
															654
														],
														[
															467.43,
															652.078
														],
														[
															470,
															650
														],
														[
															471.474,
															649.517
														],
														[
															473,
															649
														],
														[
															473.995,
															647.512
														],
														[
															475,
															646
														],
														[
															477.332,
															644.834
														],
														[
															479,
															644
														],
														[
															482.057,
															641.373
														],
														[
															485,
															639
														],
														[
															501.782,
															623.837
														],
														[
															517,
															608
														],
														[
															559.656,
															544.427
														],
														[
															589,
															468
														],
														[
															599.961,
															408.868
														],
														[
															603,
															340
														],
														[
															597.065,
															277.828
														],
														[
															582,
															220
														],
														[
															565.161,
															178.716
														],
														[
															545,
															142
														],
														[
															543.499,
															138.96
														],
														[
															542,
															136
														],
														[
															538.039,
															130.934
														],
														[
															534,
															126
														],
														[
															533,
															123
														],
														[
															519,
															106
														],
														[
															502,
															87
														],
														[
															497,
															84
														],
														[
															493,
															79
														],
														[
															462,
															56
														],
														[
															439,
															44
														],
														[
															414,
															33
														],
														[
															400,
															30
														],
														[
															385,
															27
														],
														[
															350,
															26
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 15,
											"s": [
												{
													"i": [
														[
															17.9,
															-8.213
														],
														[
															15.803,
															-14.834
														],
														[
															12.186,
															-17.754
														],
														[
															1.113,
															-1.748
														],
														[
															1.138,
															-1.952
														],
														[
															1.88,
															-3.579
														],
														[
															1.423,
															-3.156
														],
														[
															0.452,
															-0.149
														],
														[
															0.112,
															-0.221
														],
														[
															0.241,
															-1.231
														],
														[
															0.531,
															-1.081
														],
														[
															1.05,
															-1.79
														],
														[
															0.858,
															-1.925
														],
														[
															3.185,
															-8.698
														],
														[
															2.537,
															-8.862
														],
														[
															3.253,
															-24.758
														],
														[
															-0.543,
															-22.651
														],
														[
															-3.126,
															-19.775
														],
														[
															-3.964,
															-17.661
														],
														[
															-0.47,
															-0.636
														],
														[
															-0.077,
															-0.265
														],
														[
															-1.267,
															-4.514
														],
														[
															-1.587,
															-4.295
														],
														[
															-2.771,
															-6.049
														],
														[
															-2.519,
															-5.315
														],
														[
															-4.373,
															-7.563
														],
														[
															-4.651,
															-6.608
														],
														[
															-0.089,
															-0.52
														],
														[
															-0.334,
															-0.477
														],
														[
															-0.6,
															-0.29
														],
														[
															-0.308,
															-0.423
														],
														[
															-0.445,
															-1.089
														],
														[
															-0.603,
															-0.798
														],
														[
															-0.738,
															-0.665
														],
														[
															-0.55,
															-0.682
														],
														[
															-7.105,
															-7.348
														],
														[
															-7.581,
															-5.183
														],
														[
															-0.225,
															-0.228
														],
														[
															-0.069,
															-0.065
														],
														[
															-0.659,
															-0.445
														],
														[
															-0.607,
															-0.495
														],
														[
															-1.13,
															-1.036
														],
														[
															-1.171,
															-0.788
														],
														[
															-1.045,
															-0.456
														],
														[
															-1.01,
															-0.63
														],
														[
															-10.146,
															-4.181
														],
														[
															-12.984,
															-2.396
														],
														[
															-5.661,
															-0.534
														],
														[
															-3.64,
															1.188
														],
														[
															-0.711,
															-0.034
														],
														[
															-0.776,
															0.683
														],
														[
															-0.224,
															0.936
														],
														[
															-0.709,
															0.909
														],
														[
															-0.521,
															1.011
														],
														[
															-0.851,
															0.593
														],
														[
															-1.817,
															0.21
														],
														[
															-1.541,
															0.329
														],
														[
															-6.69,
															2.272
														],
														[
															-5.325,
															2.438
														],
														[
															-5.105,
															2.978
														],
														[
															-4.283,
															2.662
														],
														[
															-0.346,
															0.399
														],
														[
															-0.32,
															0.218
														],
														[
															-0.521,
															0.091
														],
														[
															-0.475,
															0.332
														],
														[
															-0.291,
															0.598
														],
														[
															-0.418,
															0.316
														],
														[
															-0.545,
															0.093
														],
														[
															-0.387,
															0.302
														],
														[
															-0.289,
															0.582
														],
														[
															-0.422,
															0.344
														],
														[
															-0.561,
															0.099
														],
														[
															-0.365,
															0.284
														],
														[
															-0.291,
															0.579
														],
														[
															-0.413,
															0.355
														],
														[
															-0.879,
															0.434
														],
														[
															-0.75,
															0.637
														],
														[
															-2.138,
															2.228
														],
														[
															-2.06,
															2.061
														],
														[
															-1.966,
															2.382
														],
														[
															-1.835,
															2.172
														],
														[
															-2.066,
															2.313
														],
														[
															-1.693,
															2.328
														],
														[
															-1.107,
															1.597
														],
														[
															-5.427,
															9.538
														],
														[
															1.449,
															94.874
														],
														[
															11.948,
															38.191
														],
														[
															10.783,
															19.018
														],
														[
															4.106,
															6.83
														],
														[
															1.05,
															1.58
														],
														[
															1.16,
															1.603
														],
														[
															2.331,
															3.017
														],
														[
															2.724,
															3.34
														],
														[
															3.715,
															3.998
														],
														[
															13.657,
															9.666
														],
														[
															8.206,
															3.935
														],
														[
															2.279,
															1.007
														],
														[
															4.11,
															1.447
														],
														[
															21.006,
															-1.545
														],
														[
															-0.103,
															0.008
														]
													],
													"o": [
														[
															-21.602,
															9.911
														],
														[
															-15.803,
															14.834
														],
														[
															-1.411,
															2.055
														],
														[
															-1.113,
															1.748
														],
														[
															-2.058,
															3.529
														],
														[
															-1.88,
															3.579
														],
														[
															-0.082,
															0.182
														],
														[
															-0.451,
															0.149
														],
														[
															-0.505,
															0.994
														],
														[
															-0.241,
															1.231
														],
														[
															-0.94,
															1.913
														],
														[
															-1.05,
															1.791
														],
														[
															-3.724,
															8.346
														],
														[
															-3.185,
															8.698
														],
														[
															-5.531,
															19.318
														],
														[
															-3.253,
															24.758
														],
														[
															0.533,
															22.24
														],
														[
															3.126,
															19.775
														],
														[
															0.043,
															0.19
														],
														[
															0.47,
															0.636
														],
														[
															1.347,
															4.65
														],
														[
															1.267,
															4.514
														],
														[
															2.397,
															6.489
														],
														[
															2.771,
															6.049
														],
														[
															3.857,
															8.139
														],
														[
															4.373,
															7.563
														],
														[
															0.311,
															0.442
														],
														[
															0.089,
															0.52
														],
														[
															0.291,
															0.417
														],
														[
															0.6,
															0.29
														],
														[
															0.615,
															0.846
														],
														[
															0.445,
															1.089
														],
														[
															0.496,
															0.657
														],
														[
															0.738,
															0.665
														],
														[
															6,
															7.426
														],
														[
															7.105,
															7.348
														],
														[
															0.031,
															0.022
														],
														[
															0.225,
															0.228
														],
														[
															0.756,
															0.724
														],
														[
															0.659,
															0.445
														],
														[
															1.308,
															1.067
														],
														[
															1.13,
															1.036
														],
														[
															0.809,
															0.545
														],
														[
															1.045,
															0.456
														],
														[
															9.433,
															5.88
														],
														[
															10.146,
															4.181
														],
														[
															5.717,
															1.054
														],
														[
															5.661,
															0.534
														],
														[
															1.38,
															-0.451
														],
														[
															0.711,
															0.034
														],
														[
															0.394,
															-0.346
														],
														[
															0.224,
															-0.936
														],
														[
															1.064,
															-1.362
														],
														[
															0.521,
															-1.011
														],
														[
															1.19,
															-0.83
														],
														[
															1.817,
															-0.211
														],
														[
															6.916,
															-1.475
														],
														[
															6.69,
															-2.272
														],
														[
															5.298,
															-2.426
														],
														[
															5.105,
															-2.978
														],
														[
															0.298,
															-0.185
														],
														[
															0.346,
															-0.399
														],
														[
															0.443,
															-0.303
														],
														[
															0.521,
															-0.091
														],
														[
															0.417,
															-0.292
														],
														[
															0.291,
															-0.598
														],
														[
															0.434,
															-0.328
														],
														[
															0.545,
															-0.093
														],
														[
															0.422,
															-0.328
														],
														[
															0.289,
															-0.582
														],
														[
															0.393,
															-0.321
														],
														[
															0.561,
															-0.099
														],
														[
															0.422,
															-0.328
														],
														[
															0.291,
															-0.579
														],
														[
															0.733,
															-0.629
														],
														[
															0.879,
															-0.434
														],
														[
															2.389,
															-2.028
														],
														[
															2.138,
															-2.228
														],
														[
															2.3,
															-2.301
														],
														[
															1.966,
															-2.382
														],
														[
															2.043,
															-2.419
														],
														[
															2.066,
															-2.313
														],
														[
															1.186,
															-1.63
														],
														[
															6.074,
															-8.763
														],
														[
															32.96,
															-57.931
														],
														[
															-0.655,
															-42.906
														],
														[
															-7.211,
															-23.049
														],
														[
															-4.513,
															-7.959
														],
														[
															-1.215,
															-2.021
														],
														[
															-1.088,
															-1.637
														],
														[
															-2.833,
															-3.914
														],
														[
															-3.288,
															-4.255
														],
														[
															-3.66,
															-4.487
														],
														[
															-11.03,
															-11.872
														],
														[
															-7.237,
															-5.122
														],
														[
															-2.002,
															-0.96
														],
														[
															-3.871,
															-1.711
														],
														[
															-17.768,
															-6.255
														],
														[
															-0.624,
															0.046
														],
														[
															-20.271,
															1.664
														]
													],
													"v": [
														[
															294,
															41
														],
														[
															238.438,
															78.618
														],
														[
															197,
															128
														],
														[
															193.296,
															133.577
														],
														[
															190,
															139
														],
														[
															184.023,
															149.78
														],
														[
															179,
															160
														],
														[
															178.022,
															160.471
														],
														[
															177,
															161
														],
														[
															176.019,
															164.435
														],
														[
															175,
															168
														],
														[
															171.939,
															173.491
														],
														[
															169,
															179
														],
														[
															158.61,
															204.614
														],
														[
															150,
															231
														],
														[
															136.445,
															299
														],
														[
															132,
															372
														],
														[
															137.926,
															434.935
														],
														[
															149,
															491
														],
														[
															149.974,
															492.443
														],
														[
															151,
															494
														],
														[
															154.82,
															507.766
														],
														[
															159,
															521
														],
														[
															166.908,
															539.88
														],
														[
															175,
															557
														],
														[
															187.404,
															580.648
														],
														[
															201,
															602
														],
														[
															201.483,
															603.474
														],
														[
															202,
															605
														],
														[
															203.488,
															605.995
														],
														[
															205,
															607
														],
														[
															206.509,
															610.036
														],
														[
															208,
															613
														],
														[
															209.959,
															614.981
														],
														[
															212,
															617
														],
														[
															231.814,
															639.682
														],
														[
															254,
															659
														],
														[
															254.472,
															659.467
														],
														[
															255,
															660
														],
														[
															257.111,
															661.671
														],
														[
															259,
															663
														],
														[
															262.603,
															666.209
														],
														[
															266,
															669
														],
														[
															268.85,
															670.437
														],
														[
															272,
															672
														],
														[
															300.837,
															687.114
														],
														[
															335,
															697
														],
														[
															352.558,
															699.682
														],
														[
															367,
															699
														],
														[
															369.953,
															698.674
														],
														[
															372,
															698
														],
														[
															372.763,
															695.921
														],
														[
															374,
															693
														],
														[
															376.16,
															689.423
														],
														[
															378,
															687
														],
														[
															382.737,
															685.624
														],
														[
															388,
															685
														],
														[
															408.693,
															679.223
														],
														[
															427,
															672
														],
														[
															442.762,
															663.677
														],
														[
															457,
															655
														],
														[
															457.983,
															654.025
														],
														[
															459,
															653
														],
														[
															460.477,
															652.522
														],
														[
															462,
															652
														],
														[
															462.999,
															650.518
														],
														[
															464,
															649
														],
														[
															465.535,
															648.48
														],
														[
															467,
															648
														],
														[
															468,
															646.512
														],
														[
															469,
															645
														],
														[
															470.521,
															644.473
														],
														[
															472,
															644
														],
														[
															473.006,
															642.52
														],
														[
															474,
															641
														],
														[
															476.487,
															639.506
														],
														[
															479,
															638
														],
														[
															485.746,
															631.524
														],
														[
															492,
															625
														],
														[
															498.349,
															617.904
														],
														[
															504,
															611
														],
														[
															510.263,
															603.931
														],
														[
															516,
															597
														],
														[
															519,
															592
														],
														[
															536,
															565
														],
														[
															588,
															342
														],
														[
															569,
															223
														],
														[
															542,
															156
														],
														[
															529,
															134
														],
														[
															526,
															128
														],
														[
															522,
															124
														],
														[
															515,
															114
														],
														[
															506,
															102
														],
														[
															495,
															90
														],
														[
															458,
															58
														],
														[
															432,
															42
														],
														[
															425,
															40
														],
														[
															413,
															34
														],
														[
															352,
															25
														],
														[
															351,
															26
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 16,
											"s": [
												{
													"i": [
														[
															10.357,
															-3.336
														],
														[
															5.012,
															-1.965
														],
														[
															4.358,
															-2.34
														],
														[
															0.805,
															-0.744
														],
														[
															0.912,
															-0.558
														],
														[
															0.523,
															-0.11
														],
														[
															0.413,
															-0.257
														],
														[
															0.343,
															-0.401
														],
														[
															0.328,
															-0.212
														],
														[
															1.022,
															-0.432
														],
														[
															0.942,
															-0.644
														],
														[
															1.455,
															-1.417
														],
														[
															1.53,
															-1.204
														],
														[
															0.553,
															-0.096
														],
														[
															0.375,
															-0.293
														],
														[
															0.29,
															-0.581
														],
														[
															0.42,
															-0.347
														],
														[
															0.523,
															-0.078
														],
														[
															0.483,
															-0.338
														],
														[
															0.302,
															-0.59
														],
														[
															0.38,
															-0.352
														],
														[
															8.091,
															-9.616
														],
														[
															6.272,
															-10.835
														],
														[
															0.835,
															-1.289
														],
														[
															0.827,
															-1.404
														],
														[
															1.508,
															-2.939
														],
														[
															1.27,
															-2.359
														],
														[
															1.83,
															-3.821
														],
														[
															1.584,
															-3.819
														],
														[
															0.861,
															-1.995
														],
														[
															0.694,
															-1.94
														],
														[
															1.827,
															-5.154
														],
														[
															1.656,
															-5.696
														],
														[
															3.68,
															-26.197
														],
														[
															-0.822,
															-26.221
														],
														[
															-5.803,
															-28.586
														],
														[
															-9.752,
															-23.596
														],
														[
															-1.615,
															-4.037
														],
														[
															-1.846,
															-3.755
														],
														[
															-1.962,
															-3.581
														],
														[
															-1.412,
															-3.134
														],
														[
															-0.451,
															-0.156
														],
														[
															-0.12,
															-0.203
														],
														[
															-0.117,
															-0.523
														],
														[
															-0.238,
															-0.411
														],
														[
															-0.839,
															-1.311
														],
														[
															-0.829,
															-1.346
														],
														[
															-3.279,
															-4.664
														],
														[
															-3.048,
															-3.737
														],
														[
															-0.944,
															-1.085
														],
														[
															-1.045,
															-1.215
														],
														[
															-5.206,
															-5.064
														],
														[
															-5.464,
															-4.266
														],
														[
															-11.652,
															-5.882
														],
														[
															-13.775,
															-2.744
														],
														[
															-7.022,
															-0.418
														],
														[
															-2.208,
															2.611
														],
														[
															-0.161,
															0.804
														],
														[
															-0.784,
															1.11
														],
														[
															-0.838,
															0.726
														],
														[
															-2.162,
															0.992
														],
														[
															-2.287,
															0.396
														],
														[
															-1.939,
															0.538
														],
														[
															-5.729,
															2.435
														],
														[
															-5.841,
															3.252
														],
														[
															-15.889,
															17.84
														],
														[
															-11.292,
															21.864
														],
														[
															-0.805,
															1.858
														],
														[
															-0.851,
															1.769
														],
														[
															-1.069,
															1.805
														],
														[
															-0.837,
															1.938
														],
														[
															-3.47,
															10.516
														],
														[
															-2.776,
															10.886
														],
														[
															-0.922,
															3.607
														],
														[
															-0.525,
															2.491
														],
														[
															-1.712,
															25.105
														],
														[
															2.378,
															25.091
														],
														[
															9.707,
															30.62
														],
														[
															14.787,
															23.787
														],
														[
															0.098,
															0.517
														],
														[
															0.325,
															0.48
														],
														[
															0.731,
															0.599
														],
														[
															0.514,
															0.773
														],
														[
															0.124,
															0.547
														],
														[
															0.216,
															0.374
														],
														[
															0.362,
															0.276
														],
														[
															0.26,
															0.394
														],
														[
															0.429,
															1.03
														],
														[
															0.651,
															0.923
														],
														[
															1.419,
															1.469
														],
														[
															1.209,
															1.546
														],
														[
															2.535,
															2.978
														],
														[
															2.772,
															2.984
														],
														[
															5.892,
															5.051
														],
														[
															1.629,
															1.524
														],
														[
															2.442,
															1.834
														],
														[
															5.284,
															3.059
														],
														[
															6.793,
															2.652
														],
														[
															20.343,
															-1.583
														],
														[
															-0.088,
															0.008
														]
													],
													"o": [
														[
															-5.592,
															1.802
														],
														[
															-5.012,
															1.965
														],
														[
															-0.866,
															0.465
														],
														[
															-0.805,
															0.744
														],
														[
															-0.495,
															0.302
														],
														[
															-0.523,
															0.11
														],
														[
															-0.299,
															0.186
														],
														[
															-0.343,
															0.401
														],
														[
															-0.972,
															0.627
														],
														[
															-1.022,
															0.432
														],
														[
															-1.649,
															1.127
														],
														[
															-1.455,
															1.417
														],
														[
															-0.412,
															0.325
														],
														[
															-0.553,
															0.096
														],
														[
															-0.422,
															0.328
														],
														[
															-0.29,
															0.581
														],
														[
															-0.425,
															0.352
														],
														[
															-0.523,
															0.078
														],
														[
															-0.411,
															0.287
														],
														[
															-0.303,
															0.59
														],
														[
															-9.364,
															8.701
														],
														[
															-8.091,
															9.616
														],
														[
															-0.834,
															1.44
														],
														[
															-0.835,
															1.289
														],
														[
															-1.699,
															2.885
														],
														[
															-1.508,
															2.939
														],
														[
															-2.097,
															3.897
														],
														[
															-1.83,
															3.821
														],
														[
															-0.863,
															2.079
														],
														[
															-0.861,
															1.995
														],
														[
															-2.035,
															5.689
														],
														[
															-1.827,
															5.154
														],
														[
															-6.103,
															20.99
														],
														[
															-3.68,
															26.197
														],
														[
															1.037,
															33.06
														],
														[
															5.803,
															28.586
														],
														[
															1.694,
															4.098
														],
														[
															1.615,
															4.037
														],
														[
															1.742,
															3.543
														],
														[
															1.962,
															3.581
														],
														[
															0.078,
															0.173
														],
														[
															0.451,
															0.156
														],
														[
															0.293,
															0.498
														],
														[
															0.117,
															0.523
														],
														[
															0.817,
															1.411
														],
														[
															0.839,
															1.311
														],
														[
															2.834,
															4.605
														],
														[
															3.279,
															4.664
														],
														[
															1.178,
															1.445
														],
														[
															0.944,
															1.085
														],
														[
															4.712,
															5.476
														],
														[
															5.206,
															5.064
														],
														[
															8.616,
															6.729
														],
														[
															11.652,
															5.882
														],
														[
															4.703,
															0.937
														],
														[
															7.022,
															0.418
														],
														[
															0.571,
															-0.675
														],
														[
															0.161,
															-0.804
														],
														[
															1.486,
															-2.104
														],
														[
															0.838,
															-0.726
														],
														[
															1.912,
															-0.878
														],
														[
															2.287,
															-0.396
														],
														[
															7.244,
															-2.01
														],
														[
															5.729,
															-2.434
														],
														[
															21.15,
															-11.774
														],
														[
															15.889,
															-17.84
														],
														[
															0.928,
															-1.798
														],
														[
															0.805,
															-1.858
														],
														[
															0.886,
															-1.841
														],
														[
															1.069,
															-1.805
														],
														[
															4.344,
															-10.049
														],
														[
															3.47,
															-10.516
														],
														[
															0.785,
															-3.079
														],
														[
															0.922,
															-3.607
														],
														[
															4.528,
															-21.49
														],
														[
															1.712,
															-25.105
														],
														[
															-3.386,
															-35.731
														],
														[
															-9.707,
															-30.62
														],
														[
															-0.281,
															-0.452
														],
														[
															-0.098,
															-0.517
														],
														[
															-0.563,
															-0.829
														],
														[
															-0.731,
															-0.599
														],
														[
															-0.289,
															-0.435
														],
														[
															-0.123,
															-0.548
														],
														[
															-0.292,
															-0.504
														],
														[
															-0.362,
															-0.276
														],
														[
															-0.634,
															-0.958
														],
														[
															-0.429,
															-1.03
														],
														[
															-1.113,
															-1.579
														],
														[
															-1.419,
															-1.469
														],
														[
															-2.642,
															-3.378
														],
														[
															-2.462,
															-2.891
														],
														[
															-5.75,
															-6.189
														],
														[
															-2.346,
															-2.011
														],
														[
															-2.661,
															-2.489
														],
														[
															-5.428,
															-4.077
														],
														[
															-6.087,
															-3.524
														],
														[
															-16.836,
															-6.572
														],
														[
															-0.633,
															0.049
														],
														[
															-11.563,
															1.063
														]
													],
													"v": [
														[
															322,
															32
														],
														[
															306.075,
															37.597
														],
														[
															292,
															44
														],
														[
															289.534,
															45.931
														],
														[
															287,
															48
														],
														[
															285.438,
															48.534
														],
														[
															284,
															49
														],
														[
															283.021,
															49.981
														],
														[
															282,
															51
														],
														[
															278.978,
															52.487
														],
														[
															276,
															54
														],
														[
															271.411,
															57.942
														],
														[
															267,
															62
														],
														[
															265.473,
															62.524
														],
														[
															264,
															63
														],
														[
															262.999,
															64.486
														],
														[
															262,
															66
														],
														[
															260.543,
															66.511
														],
														[
															259,
															67
														],
														[
															257.977,
															68.451
														],
														[
															257,
															70
														],
														[
															230.681,
															97.399
														],
														[
															209,
															128
														],
														[
															206.495,
															132.027
														],
														[
															204,
															136
														],
														[
															199.178,
															144.894
														],
														[
															195,
															153
														],
														[
															189.115,
															164.558
														],
														[
															184,
															176
														],
														[
															181.374,
															182.104
														],
														[
															179,
															188
														],
														[
															173.216,
															203.994
														],
														[
															168,
															220
														],
														[
															152.805,
															292.077
														],
														[
															148,
															372
														],
														[
															158.463,
															464.598
														],
														[
															182,
															543
														],
														[
															186.886,
															555.257
														],
														[
															192,
															567
														],
														[
															197.747,
															577.807
														],
														[
															203,
															588
														],
														[
															203.969,
															588.477
														],
														[
															205,
															589
														],
														[
															205.541,
															590.565
														],
														[
															206,
															592
														],
														[
															208.491,
															596.049
														],
														[
															211,
															600
														],
														[
															220.339,
															614.151
														],
														[
															230,
															627
														],
														[
															233.1,
															630.673
														],
														[
															236,
															634
														],
														[
															250.936,
															649.908
														],
														[
															267,
															664
														],
														[
															297.631,
															683.489
														],
														[
															336,
															697
														],
														[
															355.371,
															699.661
														],
														[
															371,
															697
														],
														[
															371.84,
															694.826
														],
														[
															373,
															692
														],
														[
															375.993,
															688.166
														],
														[
															380,
															686
														],
														[
															386.48,
															684.245
														],
														[
															393,
															683
														],
														[
															412.053,
															676.431
														],
														[
															429,
															668
														],
														[
															484.394,
															623.067
														],
														[
															525,
															563
														],
														[
															527.558,
															557.479
														],
														[
															530,
															552
														],
														[
															533.036,
															546.572
														],
														[
															536,
															541
														],
														[
															547.676,
															510.128
														],
														[
															557,
															478
														],
														[
															559.695,
															467.559
														],
														[
															562,
															458
														],
														[
															571.679,
															387.2
														],
														[
															571,
															311
														],
														[
															551.051,
															211.042
														],
														[
															514,
															129
														],
														[
															513.533,
															127.52
														],
														[
															513,
															126
														],
														[
															510.963,
															123.958
														],
														[
															509,
															122
														],
														[
															508.445,
															120.454
														],
														[
															508,
															119
														],
														[
															506.976,
															117.918
														],
														[
															506,
															117
														],
														[
															504.513,
															113.974
														],
														[
															503,
															111
														],
														[
															499.072,
															106.475
														],
														[
															495,
															102
														],
														[
															488,
															92
														],
														[
															480,
															84
														],
														[
															463,
															67
														],
														[
															456,
															62
														],
														[
															449,
															56
														],
														[
															431,
															45
														],
														[
															411,
															35
														],
														[
															353,
															25
														],
														[
															352,
															26
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 17,
											"s": [
												{
													"i": [
														[
															14.143,
															-8.188
														],
														[
															0.51,
															-0.102
														],
														[
															0.496,
															-0.32
														],
														[
															0.601,
															-0.739
														],
														[
															0.764,
															-0.511
														],
														[
															0.541,
															-0.115
														],
														[
															0.387,
															-0.24
														],
														[
															0.348,
															-0.399
														],
														[
															0.314,
															-0.222
														],
														[
															1.688,
															-1.151
														],
														[
															1.505,
															-1.165
														],
														[
															0.673,
															-0.729
														],
														[
															0.64,
															-0.567
														],
														[
															11.828,
															-17.565
														],
														[
															7.94,
															-18.781
														],
														[
															1.732,
															-5.065
														],
														[
															1.808,
															-5.385
														],
														[
															4.716,
															-29.765
														],
														[
															-0.753,
															-31.44
														],
														[
															-2.558,
															-19.576
														],
														[
															-4.279,
															-18.224
														],
														[
															-9.476,
															-22.481
														],
														[
															-13.106,
															-17.57
														],
														[
															-0.084,
															-0.521
														],
														[
															-0.335,
															-0.481
														],
														[
															-0.599,
															-0.291
														],
														[
															-0.313,
															-0.419
														],
														[
															-0.094,
															-0.544
														],
														[
															-0.297,
															-0.388
														],
														[
															-0.364,
															-0.325
														],
														[
															-0.293,
															-0.371
														],
														[
															-0.826,
															-1.206
														],
														[
															-0.716,
															-0.936
														],
														[
															-0.366,
															-0.33
														],
														[
															-0.29,
															-0.358
														],
														[
															-3.644,
															-3.806
														],
														[
															-3.362,
															-3
														],
														[
															-0.927,
															-0.476
														],
														[
															-0.688,
															-0.559
														],
														[
															-0.618,
															-0.696
														],
														[
															-0.784,
															-0.61
														],
														[
															-8.985,
															-4.459
														],
														[
															-11.832,
															-2.766
														],
														[
															-6.292,
															-0.641
														],
														[
															-2.084,
															2.907
														],
														[
															-0.291,
															0.677
														],
														[
															-0.52,
															0.852
														],
														[
															-0.349,
															1.003
														],
														[
															-0.827,
															0.717
														],
														[
															-1.248,
															0.356
														],
														[
															-0.467,
															0.104
														],
														[
															-2.127,
															0.452
														],
														[
															-2.015,
															0.642
														],
														[
															-8.604,
															5.218
														],
														[
															-7.894,
															6.721
														],
														[
															-3.799,
															3.862
														],
														[
															-3.464,
															3.855
														],
														[
															-1.116,
															1.044
														],
														[
															-0.575,
															0.752
														],
														[
															-0.087,
															0.539
														],
														[
															-0.337,
															0.433
														],
														[
															-1.224,
															1.301
														],
														[
															-0.98,
															1.351
														],
														[
															-0.461,
															0.842
														],
														[
															-0.578,
															0.834
														],
														[
															-0.95,
															1.08
														],
														[
															-0.451,
															0.601
														],
														[
															-0.123,
															0.566
														],
														[
															-0.217,
															0.35
														],
														[
															-3.728,
															6.887
														],
														[
															-3.022,
															6.921
														],
														[
															-0.568,
															0.83
														],
														[
															-0.366,
															0.855
														],
														[
															-0.861,
															2.618
														],
														[
															-0.659,
															1.43
														],
														[
															-1.34,
															3.33
														],
														[
															-1.115,
															3.37
														],
														[
															-3.439,
															43.262
														],
														[
															7.106,
															41.656
														],
														[
															2.603,
															10.782
														],
														[
															2.716,
															8.895
														],
														[
															5.499,
															12.83
														],
														[
															6.62,
															11.322
														],
														[
															0.774,
															1.709
														],
														[
															0.933,
															1.507
														],
														[
															0.402,
															0.342
														],
														[
															0.207,
															0.332
														],
														[
															0.098,
															0.517
														],
														[
															0.326,
															0.48
														],
														[
															0.758,
															0.641
														],
														[
															0.502,
															0.751
														],
														[
															0.242,
															0.862
														],
														[
															0.503,
															0.766
														],
														[
															0.744,
															0.63
														],
														[
															0.526,
															0.717
														],
														[
															3.421,
															4.342
														],
														[
															3.921,
															4.006
														],
														[
															2.859,
															2.481
														],
														[
															3.028,
															2.486
														],
														[
															35.843,
															-3.832
														]
													],
													"o": [
														[
															-0.466,
															0.27
														],
														[
															-0.51,
															0.102
														],
														[
															-0.831,
															0.535
														],
														[
															-0.601,
															0.739
														],
														[
															-0.449,
															0.3
														],
														[
															-0.541,
															0.115
														],
														[
															-0.296,
															0.183
														],
														[
															-0.348,
															0.399
														],
														[
															-1.741,
															1.23
														],
														[
															-1.688,
															1.151
														],
														[
															-0.669,
															0.518
														],
														[
															-0.673,
															0.729
														],
														[
															-15.746,
															13.959
														],
														[
															-11.828,
															17.565
														],
														[
															-2.265,
															5.357
														],
														[
															-1.732,
															5.065
														],
														[
															-7.889,
															23.5
														],
														[
															-4.716,
															29.765
														],
														[
															0.49,
															20.473
														],
														[
															2.558,
															19.576
														],
														[
															5.99,
															25.506
														],
														[
															9.476,
															22.481
														],
														[
															0.327,
															0.438
														],
														[
															0.084,
															0.52
														],
														[
															0.291,
															0.417
														],
														[
															0.599,
															0.291
														],
														[
															0.326,
															0.437
														],
														[
															0.094,
															0.544
														],
														[
															0.251,
															0.329
														],
														[
															0.364,
															0.325
														],
														[
															0.98,
															1.24
														],
														[
															0.826,
															1.206
														],
														[
															0.245,
															0.321
														],
														[
															0.366,
															0.33
														],
														[
															3.061,
															3.776
														],
														[
															3.644,
															3.806
														],
														[
															0.603,
															0.538
														],
														[
															0.927,
															0.476
														],
														[
															0.744,
															0.604
														],
														[
															0.618,
															0.696
														],
														[
															8.228,
															6.399
														],
														[
															8.985,
															4.458
														],
														[
															5.746,
															1.343
														],
														[
															6.292,
															0.641
														],
														[
															0.315,
															-0.439
														],
														[
															0.291,
															-0.677
														],
														[
															0.776,
															-1.271
														],
														[
															0.349,
															-1.003
														],
														[
															0.543,
															-0.471
														],
														[
															1.248,
															-0.356
														],
														[
															2.476,
															-0.55
														],
														[
															2.127,
															-0.452
														],
														[
															10.69,
															-3.406
														],
														[
															8.604,
															-5.218
														],
														[
															4.339,
															-3.695
														],
														[
															3.799,
															-3.863
														],
														[
															0.962,
															-1.071
														],
														[
															1.116,
															-1.044
														],
														[
															0.315,
															-0.412
														],
														[
															0.087,
															-0.539
														],
														[
															1.125,
															-1.443
														],
														[
															1.224,
															-1.301
														],
														[
															0.577,
															-0.796
														],
														[
															0.461,
															-0.842
														],
														[
															0.749,
															-1.081
														],
														[
															0.95,
															-1.08
														],
														[
															0.29,
															-0.387
														],
														[
															0.123,
															-0.566
														],
														[
															4.068,
															-6.533
														],
														[
															3.728,
															-6.887
														],
														[
															0.361,
															-0.827
														],
														[
															0.568,
															-0.829
														],
														[
															0.898,
															-2.096
														],
														[
															0.861,
															-2.619
														],
														[
															1.525,
															-3.308
														],
														[
															1.34,
															-3.33
														],
														[
															11.351,
															-34.297
														],
														[
															3.439,
															-43.262
														],
														[
															-1.872,
															-10.976
														],
														[
															-2.603,
															-10.782
														],
														[
															-4.383,
															-14.359
														],
														[
															-5.499,
															-12.83
														],
														[
															-0.969,
															-1.656
														],
														[
															-0.774,
															-1.709
														],
														[
															-0.186,
															-0.3
														],
														[
															-0.402,
															-0.342
														],
														[
															-0.281,
															-0.453
														],
														[
															-0.098,
															-0.517
														],
														[
															-0.466,
															-0.686
														],
														[
															-0.758,
															-0.641
														],
														[
															-0.528,
															-0.787
														],
														[
															-0.242,
															-0.862
														],
														[
															-0.5,
															-0.761
														],
														[
															-0.743,
															-0.63
														],
														[
															-3.397,
															-4.627
														],
														[
															-3.421,
															-4.342
														],
														[
															-2.537,
															-2.591
														],
														[
															-2.859,
															-2.481
														],
														[
															-20.625,
															-16.934
														],
														[
															-21.907,
															2.342
														]
													],
													"v": [
														[
															299,
															44
														],
														[
															297.523,
															44.462
														],
														[
															296,
															45
														],
														[
															293.95,
															47.019
														],
														[
															292,
															49
														],
														[
															290.454,
															49.545
														],
														[
															289,
															50
														],
														[
															288.014,
															50.971
														],
														[
															287,
															52
														],
														[
															281.823,
															55.549
														],
														[
															277,
															59
														],
														[
															274.978,
															60.963
														],
														[
															273,
															63
														],
														[
															231.645,
															110.883
														],
														[
															202,
															166
														],
														[
															196.157,
															181.479
														],
														[
															191,
															197
														],
														[
															171.518,
															278.045
														],
														[
															165,
															371
														],
														[
															169.658,
															431.187
														],
														[
															180,
															488
														],
														[
															203.163,
															560.452
														],
														[
															237,
															621
														],
														[
															237.493,
															622.468
														],
														[
															238,
															624
														],
														[
															239.484,
															624.998
														],
														[
															241,
															626
														],
														[
															241.522,
															627.536
														],
														[
															242,
															629
														],
														[
															242.968,
															629.968
														],
														[
															244,
															631
														],
														[
															246.698,
															634.728
														],
														[
															249,
															638
														],
														[
															249.966,
															638.972
														],
														[
															251,
															640
														],
														[
															261.274,
															651.582
														],
														[
															272,
															662
														],
														[
															274.437,
															663.485
														],
														[
															277,
															665
														],
														[
															278.969,
															666.996
														],
														[
															281,
															669
														],
														[
															306.297,
															685.225
														],
														[
															337,
															696
														],
														[
															356.246,
															699.688
														],
														[
															370,
															697
														],
														[
															370.846,
															695.309
														],
														[
															372,
															693
														],
														[
															373.462,
															689.584
														],
														[
															375,
															687
														],
														[
															378.057,
															685.725
														],
														[
															381,
															685
														],
														[
															387.845,
															683.569
														],
														[
															394,
															682
														],
														[
															422.597,
															668.987
														],
														[
															447,
															651
														],
														[
															459.156,
															639.62
														],
														[
															470,
															628
														],
														[
															473.29,
															624.761
														],
														[
															476,
															622
														],
														[
															476.484,
															620.515
														],
														[
															477,
															619
														],
														[
															480.609,
															614.931
														],
														[
															484,
															611
														],
														[
															485.5,
															608.529
														],
														[
															487,
															606
														],
														[
															489.724,
															602.64
														],
														[
															492,
															600
														],
														[
															492.554,
															598.472
														],
														[
															493,
															597
														],
														[
															504.785,
															576.791
														],
														[
															515,
															556
														],
														[
															516.496,
															553.521
														],
														[
															518,
															551
														],
														[
															520.679,
															543.501
														],
														[
															523,
															537
														],
														[
															527.307,
															527.046
														],
														[
															531,
															517
														],
														[
															553.842,
															398.019
														],
														[
															549,
															268
														],
														[
															542.132,
															234.939
														],
														[
															534,
															205
														],
														[
															519.178,
															164.222
														],
														[
															501,
															128
														],
														[
															498.474,
															122.889
														],
														[
															496,
															118
														],
														[
															495.015,
															117.024
														],
														[
															494,
															116
														],
														[
															493.533,
															114.52
														],
														[
															493,
															113
														],
														[
															491.028,
															111.048
														],
														[
															489,
															109
														],
														[
															487.982,
															106.484
														],
														[
															487,
															104
														],
														[
															485.019,
															101.967
														],
														[
															483,
															100
														],
														[
															472.893,
															86.534
														],
														[
															462,
															74
														],
														[
															453.868,
															66.421
														],
														[
															445,
															59
														],
														[
															353,
															26
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 18,
											"s": [
												{
													"i": [
														[
															6.75,
															-4.292
														],
														[
															3.026,
															-2.382
														],
														[
															2.791,
															-2.56
														],
														[
															2.62,
															-2.648
														],
														[
															2.512,
															-2.647
														],
														[
															4.596,
															-6.104
														],
														[
															3.924,
															-6.512
														],
														[
															3.49,
															-7.027
														],
														[
															3.296,
															-7.649
														],
														[
															2.841,
															-7.656
														],
														[
															2.522,
															-8.123
														],
														[
															2.17,
															-8.655
														],
														[
															1.786,
															-9.255
														],
														[
															1.609,
															-19.961
														],
														[
															-0.21,
															-20.48
														],
														[
															-1.964,
															-19.654
														],
														[
															-3.652,
															-17.482
														],
														[
															-2.329,
															-8.486
														],
														[
															-2.757,
															-8.255
														],
														[
															-3.049,
															-7.767
														],
														[
															-3.207,
															-7.022
														],
														[
															-3.608,
															-6.753
														],
														[
															-4.168,
															-6.475
														],
														[
															-4.851,
															-6.109
														],
														[
															-5.656,
															-5.656
														],
														[
															-1.568,
															-1.486
														],
														[
															-1.7,
															-1.534
														],
														[
															-1.657,
															-1.406
														],
														[
															-1.441,
															-1.101
														],
														[
															-0.249,
															-0.072
														],
														[
															-0.264,
															-0.042
														],
														[
															-0.258,
															-0.074
														],
														[
															-0.232,
															-0.169
														],
														[
															-0.324,
															-0.347
														],
														[
															-0.328,
															-0.382
														],
														[
															-0.34,
															-0.344
														],
														[
															-0.36,
															-0.234
														],
														[
															-0.263,
															-0.083
														],
														[
															-0.267,
															-0.057
														],
														[
															-0.246,
															-0.07
														],
														[
															-0.198,
															-0.123
														],
														[
															-1.05,
															-0.623
														],
														[
															-1.019,
															-0.556
														],
														[
															-1.085,
															-0.53
														],
														[
															-1.247,
															-0.544
														],
														[
															-0.415,
															-0.262
														],
														[
															-0.421,
															-0.289
														],
														[
															-0.42,
															-0.258
														],
														[
															-0.413,
															-0.167
														],
														[
															-4.168,
															-1.186
														],
														[
															-4.598,
															-0.821
														],
														[
															-3.631,
															0.15
														],
														[
															-1.267,
															1.728
														],
														[
															-0.24,
															0.791
														],
														[
															-0.194,
															0.881
														],
														[
															-0.232,
															0.775
														],
														[
															-0.354,
															0.472
														],
														[
															-0.791,
															0.321
														],
														[
															-0.97,
															0.19
														],
														[
															-0.944,
															0.149
														],
														[
															-0.713,
															0.197
														],
														[
															-3.276,
															1.281
														],
														[
															-3.003,
															1.518
														],
														[
															-2.85,
															1.728
														],
														[
															-2.819,
															1.911
														],
														[
															-2.716,
															2
														],
														[
															-2.615,
															2.133
														],
														[
															-2.341,
															2.191
														],
														[
															-1.895,
															2.175
														],
														[
															-0.405,
															0.853
														],
														[
															-0.661,
															0.765
														],
														[
															-0.746,
															0.456
														],
														[
															-0.509,
															0.589
														],
														[
															-0.441,
															0.881
														],
														[
															-0.602,
															0.74
														],
														[
															-3.294,
															4.567
														],
														[
															-3.077,
															5.13
														],
														[
															-10.035,
															42.644
														],
														[
															0.592,
															51.005
														],
														[
															7.117,
															34.666
														],
														[
															12.097,
															25.87
														],
														[
															0.46,
															1.251
														],
														[
															0.437,
															1.446
														],
														[
															0.459,
															0.393
														],
														[
															0.108,
															0.245
														],
														[
															0.674,
															1.353
														],
														[
															0.56,
															0.9
														],
														[
															0.095,
															0.489
														],
														[
															0.315,
															0.554
														],
														[
															4.265,
															6.453
														],
														[
															4.135,
															5.505
														],
														[
															1.763,
															2.069
														],
														[
															2.001,
															2.134
														],
														[
															3.899,
															3.864
														],
														[
															4.471,
															3.352
														],
														[
															12.03,
															4.841
														],
														[
															13.376,
															-0.742
														],
														[
															0.371,
															-0.242
														],
														[
															0.087,
															-0.008
														],
														[
															8.149,
															-2.944
														]
													],
													"o": [
														[
															-3.324,
															2.114
														],
														[
															-3.026,
															2.382
														],
														[
															-2.791,
															2.56
														],
														[
															-2.62,
															2.648
														],
														[
															-5.508,
															5.803
														],
														[
															-4.597,
															6.104
														],
														[
															-3.924,
															6.512
														],
														[
															-3.49,
															7.027
														],
														[
															-3.126,
															7.255
														],
														[
															-2.841,
															7.656
														],
														[
															-2.522,
															8.123
														],
														[
															-2.17,
															8.655
														],
														[
															-3.493,
															18.097
														],
														[
															-1.609,
															19.961
														],
														[
															0.21,
															20.48
														],
														[
															1.964,
															19.654
														],
														[
															1.767,
															8.459
														],
														[
															2.329,
															8.486
														],
														[
															2.757,
															8.255
														],
														[
															3.049,
															7.767
														],
														[
															3.171,
															6.944
														],
														[
															3.608,
															6.753
														],
														[
															4.168,
															6.475
														],
														[
															4.851,
															6.109
														],
														[
															1.261,
															1.261
														],
														[
															1.568,
															1.486
														],
														[
															1.7,
															1.534
														],
														[
															1.657,
															1.406
														],
														[
															0.214,
															0.163
														],
														[
															0.249,
															0.072
														],
														[
															0.264,
															0.042
														],
														[
															0.258,
															0.074
														],
														[
															0.329,
															0.24
														],
														[
															0.324,
															0.347
														],
														[
															0.328,
															0.382
														],
														[
															0.34,
															0.344
														],
														[
															0.233,
															0.151
														],
														[
															0.263,
															0.083
														],
														[
															0.267,
															0.056
														],
														[
															0.246,
															0.07
														],
														[
															1.176,
															0.731
														],
														[
															1.05,
															0.623
														],
														[
															1.019,
															0.556
														],
														[
															1.085,
															0.53
														],
														[
															0.403,
															0.176
														],
														[
															0.415,
															0.262
														],
														[
															0.421,
															0.289
														],
														[
															0.42,
															0.258
														],
														[
															2.341,
															0.944
														],
														[
															4.168,
															1.186
														],
														[
															4.598,
															0.821
														],
														[
															3.631,
															-0.15
														],
														[
															0.37,
															-0.504
														],
														[
															0.24,
															-0.791
														],
														[
															0.194,
															-0.881
														],
														[
															0.232,
															-0.775
														],
														[
															0.407,
															-0.542
														],
														[
															0.791,
															-0.321
														],
														[
															0.97,
															-0.19
														],
														[
															0.944,
															-0.149
														],
														[
															3.671,
															-1.016
														],
														[
															3.276,
															-1.281
														],
														[
															3.003,
															-1.518
														],
														[
															2.85,
															-1.728
														],
														[
															2.645,
															-1.793
														],
														[
															2.716,
															-2
														],
														[
															2.615,
															-2.133
														],
														[
															2.341,
															-2.191
														],
														[
															0.716,
															-0.822
														],
														[
															0.406,
															-0.853
														],
														[
															0.509,
															-0.589
														],
														[
															0.746,
															-0.456
														],
														[
															0.635,
															-0.736
														],
														[
															0.44,
															-0.881
														],
														[
															3.747,
															-4.602
														],
														[
															3.294,
															-4.567
														],
														[
															19.451,
															-32.418
														],
														[
															10.035,
															-42.644
														],
														[
															-0.435,
															-37.465
														],
														[
															-7.117,
															-34.666
														],
														[
															-0.724,
															-1.548
														],
														[
															-0.46,
															-1.251
														],
														[
															-0.055,
															-0.181
														],
														[
															-0.459,
															-0.393
														],
														[
															-0.743,
															-1.689
														],
														[
															-0.674,
															-1.353
														],
														[
															-0.305,
															-0.49
														],
														[
															-0.095,
															-0.489
														],
														[
															-3.804,
															-6.683
														],
														[
															-4.265,
															-6.453
														],
														[
															-1.946,
															-2.591
														],
														[
															-1.763,
															-2.069
														],
														[
															-3.933,
															-4.194
														],
														[
															-3.899,
															-3.864
														],
														[
															-8.505,
															-6.377
														],
														[
															-12.03,
															-4.841
														],
														[
															-0.43,
															0.024
														],
														[
															-0.371,
															0.242
														],
														[
															-9.653,
															0.932
														],
														[
															-8.149,
															2.944
														]
													],
													"v": [
														[
															306,
															43
														],
														[
															296.492,
															49.765
														],
														[
															287.782,
															57.201
														],
														[
															279.682,
															65.035
														],
														[
															272,
															73
														],
														[
															256.903,
															90.833
														],
														[
															244.182,
															109.731
														],
														[
															233.12,
															130.013
														],
														[
															223,
															152
														],
														[
															214.042,
															174.35
														],
														[
															205.99,
															198.001
														],
														[
															198.943,
															223.152
														],
														[
															193,
															250
														],
														[
															185.365,
															307.424
														],
														[
															183.284,
															368.423
														],
														[
															186.561,
															428.96
														],
														[
															195,
															485
														],
														[
															201.178,
															510.48
														],
														[
															208.841,
															535.656
														],
														[
															217.583,
															559.753
														],
														[
															227,
															582
														],
														[
															237.139,
															602.568
														],
														[
															248.773,
															622.432
														],
														[
															262.27,
															641.33
														],
														[
															278,
															659
														],
														[
															282.286,
															663.165
														],
														[
															287.231,
															667.739
														],
														[
															292.31,
															672.194
														],
														[
															297,
															676
														],
														[
															297.699,
															676.337
														],
														[
															298.473,
															676.492
														],
														[
															299.26,
															676.651
														],
														[
															300,
															677
														],
														[
															300.977,
															677.898
														],
														[
															301.953,
															679.009
														],
														[
															302.952,
															680.116
														],
														[
															304,
															681
														],
														[
															304.75,
															681.341
														],
														[
															305.552,
															681.541
														],
														[
															306.328,
															681.721
														],
														[
															307,
															682
														],
														[
															310.315,
															684.021
														],
														[
															313.394,
															685.78
														],
														[
															316.526,
															687.399
														],
														[
															320,
															689
														],
														[
															321.229,
															689.672
														],
														[
															322.485,
															690.514
														],
														[
															323.749,
															691.349
														],
														[
															325,
															692
														],
														[
															335.113,
															695.347
														],
														[
															348.611,
															698.508
														],
														[
															361.303,
															699.666
														],
														[
															369,
															697
														],
														[
															369.894,
															695.008
														],
														[
															370.524,
															692.452
														],
														[
															371.142,
															689.92
														],
														[
															372,
															688
														],
														[
															373.848,
															686.727
														],
														[
															376.54,
															685.983
														],
														[
															379.462,
															685.497
														],
														[
															382,
															685
														],
														[
															392.39,
															681.548
														],
														[
															401.778,
															677.343
														],
														[
															410.527,
															672.466
														],
														[
															419,
															667
														],
														[
															427.085,
															661.291
														],
														[
															435.124,
															655.072
														],
														[
															442.602,
															648.567
														],
														[
															449,
															642
														],
														[
															450.541,
															639.457
														],
														[
															452,
															637
														],
														[
															454,
															635.5
														],
														[
															456,
															634
														],
														[
															457.525,
															631.503
														],
														[
															459,
															629
														],
														[
															469.502,
															615.396
														],
														[
															479,
															601
														],
														[
															523.532,
															487.94
														],
														[
															538,
															347
														],
														[
															526.246,
															237.303
														],
														[
															497,
															145
														],
														[
															495.285,
															140.923
														],
														[
															494,
															137
														],
														[
															493.04,
															136.048
														],
														[
															492,
															135
														],
														[
															489.863,
															130.408
														],
														[
															488,
															127
														],
														[
															487.508,
															125.548
														],
														[
															487,
															124
														],
														[
															474.748,
															104.116
														],
														[
															462,
															86
														],
														[
															456.542,
															79.157
														],
														[
															451,
															73
														],
														[
															439.403,
															60.868
														],
														[
															427,
															50
														],
														[
															395.653,
															32.161
														],
														[
															357,
															25
														],
														[
															355.743,
															25.512
														],
														[
															355,
															26
														],
														[
															328.323,
															31.98
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 19,
											"s": [
												{
													"i": [
														[
															3.178,
															-1.168
														],
														[
															1.526,
															-0.666
														],
														[
															1.629,
															-0.789
														],
														[
															1.289,
															-0.728
														],
														[
															0.505,
															-0.484
														],
														[
															0.618,
															-0.41
														],
														[
															0.623,
															-0.316
														],
														[
															0.569,
															-0.248
														],
														[
															0.455,
															-0.205
														],
														[
															0.081,
															-0.175
														],
														[
															0.083,
															-0.226
														],
														[
															0.086,
															-0.188
														],
														[
															0.09,
															-0.062
														],
														[
															0.872,
															-0.579
														],
														[
															0.808,
															-0.544
														],
														[
															0.782,
															-0.567
														],
														[
															0.793,
															-0.651
														],
														[
															1.497,
															-1.317
														],
														[
															1.445,
															-1.401
														],
														[
															1.226,
															-1.383
														],
														[
															0.838,
															-1.264
														],
														[
															0.166,
															-0.171
														],
														[
															0.166,
															-0.137
														],
														[
															0.168,
															-0.148
														],
														[
															0.169,
															-0.203
														],
														[
															2.702,
															-3.669
														],
														[
															2.491,
															-3.831
														],
														[
															2.294,
															-3.996
														],
														[
															2.11,
															-4.166
														],
														[
															4.787,
															-12.007
														],
														[
															3.75,
															-12.708
														],
														[
															2.838,
															-13.847
														],
														[
															2.05,
															-15.424
														],
														[
															0.865,
															-7.584
														],
														[
															0.654,
															-7.748
														],
														[
															0.337,
															-7.79
														],
														[
															-0.086,
															-7.708
														],
														[
															-0.432,
															-9.79
														],
														[
															-0.801,
															-9.622
														],
														[
															-1.219,
															-9.396
														],
														[
															-1.685,
															-9.112
														],
														[
															-0.923,
															-4.204
														],
														[
															-1.026,
															-4.174
														],
														[
															-1.09,
															-4.133
														],
														[
															-1.115,
															-4.082
														],
														[
															-1.151,
															-4.112
														],
														[
															-1.214,
															-4.019
														],
														[
															-1.331,
															-3.898
														],
														[
															-1.502,
															-3.747
														],
														[
															-1.715,
															-3.457
														],
														[
															-1.706,
															-3.601
														],
														[
															-1.625,
															-3.558
														],
														[
															-1.864,
															-3.314
														],
														[
															-4.356,
															-6.129
														],
														[
															-4.871,
															-5.892
														],
														[
															-5.301,
															-5.003
														],
														[
															-7.46,
															-4.744
														],
														[
															-9.424,
															-3.166
														],
														[
															-6.481,
															1.731
														],
														[
															0.024,
															0.328
														],
														[
															-0.378,
															0.496
														],
														[
															-0.796,
															2.001
														],
														[
															-0.863,
															0.748
														],
														[
															-1.104,
															0.391
														],
														[
															-0.13,
															0.039
														],
														[
															-1.555,
															0.423
														],
														[
															-1.702,
															0.674
														],
														[
															-2.529,
															1.413
														],
														[
															-1.861,
															1.151
														],
														[
															-0.855,
															0.248
														],
														[
															-0.783,
															0.513
														],
														[
															-1.165,
															1.084
														],
														[
															-1.144,
															0.883
														],
														[
															-6.193,
															6.75
														],
														[
															-5.524,
															8.057
														],
														[
															-11.517,
															42.597
														],
														[
															-1.294,
															46.514
														],
														[
															4.917,
															35.144
														],
														[
															9.426,
															28.077
														],
														[
															5.87,
															12.87
														],
														[
															6.903,
															10.767
														],
														[
															0.536,
															0.671
														],
														[
															0.452,
															0.686
														],
														[
															0.529,
															0.66
														],
														[
															0.317,
															0.496
														],
														[
															0.287,
															0.937
														],
														[
															0.459,
															0.635
														],
														[
															0.528,
															0.46
														],
														[
															0.475,
															0.586
														],
														[
															4.223,
															4.903
														],
														[
															3.86,
															2.375
														],
														[
															1.826,
															1.638
														],
														[
															1.624,
															1.172
														],
														[
															5.469,
															2.594
														],
														[
															5.597,
															1.36
														],
														[
															1.011,
															0.397
														],
														[
															1.03,
															0.187
														],
														[
															3.106,
															-0.11
														],
														[
															1.399,
															-0.133
														],
														[
															3.343,
															-0.625
														]
													],
													"o": [
														[
															-0.978,
															0.359
														],
														[
															-1.526,
															0.666
														],
														[
															-1.629,
															0.789
														],
														[
															-1.289,
															0.728
														],
														[
															-0.553,
															0.53
														],
														[
															-0.618,
															0.41
														],
														[
															-0.623,
															0.316
														],
														[
															-0.569,
															0.248
														],
														[
															-0.079,
															0.036
														],
														[
															-0.081,
															0.175
														],
														[
															-0.083,
															0.226
														],
														[
															-0.086,
															0.188
														],
														[
															-0.974,
															0.675
														],
														[
															-0.872,
															0.579
														],
														[
															-0.808,
															0.544
														],
														[
															-0.782,
															0.567
														],
														[
															-1.381,
															1.133
														],
														[
															-1.497,
															1.317
														],
														[
															-1.445,
															1.401
														],
														[
															-1.226,
															1.383
														],
														[
															-0.166,
															0.25
														],
														[
															-0.166,
															0.171
														],
														[
															-0.166,
															0.137
														],
														[
															-0.168,
															0.148
														],
														[
															-2.927,
															3.512
														],
														[
															-2.702,
															3.669
														],
														[
															-2.491,
															3.831
														],
														[
															-2.294,
															3.996
														],
														[
															-5.95,
															11.746
														],
														[
															-4.787,
															12.007
														],
														[
															-3.75,
															12.707
														],
														[
															-2.838,
															13.846
														],
														[
															-0.97,
															7.298
														],
														[
															-0.865,
															7.584
														],
														[
															-0.654,
															7.748
														],
														[
															-0.337,
															7.79
														],
														[
															0.111,
															9.9
														],
														[
															0.432,
															9.79
														],
														[
															0.801,
															9.622
														],
														[
															1.219,
															9.396
														],
														[
															0.781,
															4.223
														],
														[
															0.923,
															4.204
														],
														[
															1.026,
															4.174
														],
														[
															1.09,
															4.133
														],
														[
															1.141,
															4.176
														],
														[
															1.151,
															4.112
														],
														[
															1.214,
															4.019
														],
														[
															1.331,
															3.898
														],
														[
															1.432,
															3.573
														],
														[
															1.715,
															3.457
														],
														[
															1.637,
															3.456
														],
														[
															1.625,
															3.558
														],
														[
															3.707,
															6.591
														],
														[
															4.356,
															6.129
														],
														[
															4.335,
															5.244
														],
														[
															5.301,
															5.003
														],
														[
															4.823,
															3.067
														],
														[
															9.424,
															3.166
														],
														[
															0.717,
															-0.192
														],
														[
															-0.024,
															-0.328
														],
														[
															0.951,
															-1.247
														],
														[
															0.796,
															-2.001
														],
														[
															0.456,
															-0.395
														],
														[
															1.104,
															-0.391
														],
														[
															2.079,
															-0.633
														],
														[
															1.555,
															-0.423
														],
														[
															3.022,
															-1.197
														],
														[
															2.529,
															-1.413
														],
														[
															0.798,
															-0.494
														],
														[
															0.855,
															-0.248
														],
														[
															1.194,
															-0.782
														],
														[
															1.165,
															-1.084
														],
														[
															7.702,
															-5.942
														],
														[
															6.193,
															-6.75
														],
														[
															20.636,
															-30.098
														],
														[
															11.517,
															-42.597
														],
														[
															1.095,
															-39.346
														],
														[
															-4.917,
															-35.144
														],
														[
															-4.618,
															-13.754
														],
														[
															-5.87,
															-12.87
														],
														[
															-0.404,
															-0.63
														],
														[
															-0.536,
															-0.671
														],
														[
															-0.568,
															-0.864
														],
														[
															-0.529,
															-0.66
														],
														[
															-0.394,
															-0.618
														],
														[
															-0.287,
															-0.937
														],
														[
															-0.415,
															-0.573
														],
														[
															-0.528,
															-0.46
														],
														[
															-3.25,
															-4.011
														],
														[
															-4.223,
															-4.903
														],
														[
															-2.072,
															-1.275
														],
														[
															-1.826,
															-1.638
														],
														[
															-4.526,
															-3.266
														],
														[
															-5.469,
															-2.594
														],
														[
															-0.927,
															-0.225
														],
														[
															-1.011,
															-0.397
														],
														[
															-3.179,
															-0.575
														],
														[
															-3.106,
															0.11
														],
														[
															-3.452,
															0.33
														],
														[
															-3.342,
															0.626
														]
													],
													"v": [
														[
															336,
															30
														],
														[
															332.134,
															31.584
														],
														[
															327.291,
															33.813
														],
														[
															322.802,
															36.136
														],
														[
															320,
															38
														],
														[
															318.229,
															39.404
														],
														[
															316.353,
															40.487
														],
														[
															314.55,
															41.327
														],
														[
															313,
															42
														],
														[
															312.76,
															42.338
														],
														[
															312.515,
															42.961
														],
														[
															312.263,
															43.603
														],
														[
															312,
															44
														],
														[
															309.241,
															45.867
														],
														[
															306.73,
															47.536
														],
														[
															304.354,
															49.188
														],
														[
															302,
															51
														],
														[
															297.642,
															54.7
														],
														[
															293.187,
															58.802
														],
														[
															289.138,
															63.004
														],
														[
															286,
															67
														],
														[
															285.504,
															67.619
														],
														[
															285.006,
															68.069
														],
														[
															284.505,
															68.485
														],
														[
															284,
															69
														],
														[
															275.561,
															79.771
														],
														[
															267.775,
															91.019
														],
														[
															260.602,
															102.758
														],
														[
															254,
															115
														],
														[
															237.925,
															150.52
														],
														[
															225.15,
															187.482
														],
														[
															215.3,
															227.204
														],
														[
															208,
															271
														],
														[
															205.221,
															293.354
														],
														[
															202.916,
															316.384
														],
														[
															201.403,
															339.722
														],
														[
															201,
															363
														],
														[
															201.802,
															392.549
														],
														[
															203.639,
															421.681
														],
														[
															206.656,
															450.223
														],
														[
															211,
															478
														],
														[
															213.566,
															490.642
														],
														[
															216.499,
															503.211
														],
														[
															219.682,
															515.674
														],
														[
															223,
															528
														],
														[
															226.425,
															540.439
														],
														[
															229.959,
															552.644
														],
														[
															233.764,
															564.526
														],
														[
															238,
															576
														],
														[
															242.794,
															586.48
														],
														[
															248,
															597
														],
														[
															252.83,
															607.606
														],
														[
															258,
															618
														],
														[
															270.127,
															637.024
														],
														[
															284,
															655
														],
														[
															298.156,
															670.375
														],
														[
															317,
															685
														],
														[
															340.256,
															695.598
														],
														[
															366,
															699
														],
														[
															366.754,
															698.228
														],
														[
															367,
															697
														],
														[
															369.566,
															691.626
														],
														[
															372,
															687
														],
														[
															374.745,
															685.733
														],
														[
															377,
															685
														],
														[
															382.284,
															683.531
														],
														[
															387,
															682
														],
														[
															395.371,
															677.966
														],
														[
															402,
															674
														],
														[
															404.512,
															673.014
														],
														[
															407,
															672
														],
														[
															410.537,
															669.076
														],
														[
															414,
															666
														],
														[
															434.634,
															647.086
														],
														[
															452,
															625
														],
														[
															500.506,
															513.812
														],
														[
															520,
															378
														],
														[
															513.891,
															265.548
														],
														[
															492,
															170
														],
														[
															476.214,
															129.759
														],
														[
															457,
															94
														],
														[
															455.536,
															92.042
														],
														[
															454,
															90
														],
														[
															452.311,
															87.724
														],
														[
															451,
															86
														],
														[
															450.049,
															83.513
														],
														[
															449,
															81
														],
														[
															447.545,
															79.509
														],
														[
															446,
															78
														],
														[
															434.457,
															63.773
														],
														[
															422,
															52
														],
														[
															416.164,
															47.422
														],
														[
															411,
															43
														],
														[
															395.803,
															34.07
														],
														[
															379,
															28
														],
														[
															376.078,
															26.971
														],
														[
															373,
															26
														],
														[
															363.165,
															25.469
														],
														[
															356,
															26
														],
														[
															345.794,
															27.371
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 20,
											"s": [
												{
													"i": [
														[
															2.889,
															-1.233
														],
														[
															0.266,
															-0.164
														],
														[
															0.328,
															-0.216
														],
														[
															0.273,
															-0.194
														],
														[
															0.102,
															-0.097
														],
														[
															0.136,
															-0.077
														],
														[
															0.123,
															-0.03
														],
														[
															0.176,
															-0.063
														],
														[
															0.294,
															-0.175
														],
														[
															2.911,
															-2.231
														],
														[
															2.626,
															-2.46
														],
														[
															2.402,
															-2.624
														],
														[
															2.239,
															-2.723
														],
														[
															2.739,
															-3.83
														],
														[
															2.509,
															-4.026
														],
														[
															2.265,
															-4.183
														],
														[
															2.007,
															-4.302
														],
														[
															4.593,
															-13.038
														],
														[
															3.557,
															-13.922
														],
														[
															2.561,
															-14.798
														],
														[
															1.605,
															-15.667
														],
														[
															0.532,
															-8.297
														],
														[
															0.29,
															-8.41
														],
														[
															0.113,
															-8.533
														],
														[
															0,
															-8.666
														],
														[
															-1.145,
															-14.658
														],
														[
															-2.066,
															-14.092
														],
														[
															-2.763,
															-13.013
														],
														[
															-3.238,
															-11.42
														],
														[
															-0.873,
															-3.112
														],
														[
															-0.867,
															-2.943
														],
														[
															-0.935,
															-2.859
														],
														[
															-1.08,
															-2.86
														],
														[
															-0.767,
															-2.026
														],
														[
															-0.798,
															-2.067
														],
														[
															-0.757,
															-1.882
														],
														[
															-0.644,
															-1.473
														],
														[
															-1.278,
															-2.657
														],
														[
															-1.351,
															-2.597
														],
														[
															-1.397,
															-2.517
														],
														[
															-1.417,
															-2.416
														],
														[
															-2.224,
															-3.314
														],
														[
															-2.364,
															-3.112
														],
														[
															-2.458,
															-2.867
														],
														[
															-2.505,
															-2.58
														],
														[
															-1.146,
															-1.065
														],
														[
															-1.161,
															-0.982
														],
														[
															-1.184,
															-0.927
														],
														[
															-1.215,
															-0.897
														],
														[
															-1.324,
															-1.061
														],
														[
															-1.404,
															-0.798
														],
														[
															-6.983,
															-2.362
														],
														[
															-3.792,
															1.743
														],
														[
															-0.041,
															0.285
														],
														[
															-0.573,
															1.281
														],
														[
															-0.489,
															1.183
														],
														[
															-0.499,
															1.048
														],
														[
															-0.326,
															0.281
														],
														[
															-1.224,
															0.885
														],
														[
															-1.316,
															0.288
														],
														[
															-1.121,
															0.403
														],
														[
															-3.262,
															1.77
														],
														[
															-2.369,
															1.633
														],
														[
															-7.744,
															9.498
														],
														[
															-6.442,
															11.404
														],
														[
															-5.555,
															13.937
														],
														[
															-3.995,
															14.24
														],
														[
															-4.201,
															33.337
														],
														[
															1.466,
															33.339
														],
														[
															-0.097,
															4.365
														],
														[
															0.197,
															4.183
														],
														[
															1.106,
															9.758
														],
														[
															1.103,
															8.949
														],
														[
															0.814,
															5.731
														],
														[
															1.047,
															5.427
														],
														[
															9.358,
															25.472
														],
														[
															14.058,
															19.565
														],
														[
															1.029,
															1.137
														],
														[
															0.951,
															1.157
														],
														[
															0.267,
															0.715
														],
														[
															0.466,
															0.572
														],
														[
															0.754,
															0.456
														],
														[
															0.501,
															0.582
														],
														[
															0.242,
															0.705
														],
														[
															0.507,
															0.572
														],
														[
															1.728,
															1.732
														],
														[
															1.534,
															1.322
														],
														[
															0.575,
															0.107
														],
														[
															0.344,
															0.263
														],
														[
															0.327,
															0.365
														],
														[
															0.366,
															0.293
														],
														[
															1.175,
															0.837
														],
														[
															1.048,
															0.651
														],
														[
															0.342,
															0.402
														],
														[
															0.333,
															0.206
														],
														[
															6.34,
															2.037
														],
														[
															6.024,
															-0.004
														],
														[
															0.346,
															-0.246
														],
														[
															0.134,
															-0.015
														],
														[
															3.675,
															-1.067
														]
													],
													"o": [
														[
															-0.086,
															0.037
														],
														[
															-0.266,
															0.164
														],
														[
															-0.328,
															0.216
														],
														[
															-0.273,
															0.194
														],
														[
															-0.214,
															0.204
														],
														[
															-0.136,
															0.077
														],
														[
															-0.123,
															0.03
														],
														[
															-0.176,
															0.063
														],
														[
															-3.258,
															1.936
														],
														[
															-2.911,
															2.231
														],
														[
															-2.626,
															2.46
														],
														[
															-2.402,
															2.624
														],
														[
															-2.955,
															3.594
														],
														[
															-2.739,
															3.83
														],
														[
															-2.509,
															4.026
														],
														[
															-2.265,
															4.183
														],
														[
															-5.668,
															12.145
														],
														[
															-4.593,
															13.038
														],
														[
															-3.557,
															13.922
														],
														[
															-2.561,
															14.798
														],
														[
															-0.839,
															8.192
														],
														[
															-0.532,
															8.297
														],
														[
															-0.29,
															8.41
														],
														[
															-0.113,
															8.533
														],
														[
															0,
															14.711
														],
														[
															1.145,
															14.658
														],
														[
															2.066,
															14.092
														],
														[
															2.763,
															13.013
														],
														[
															0.954,
															3.366
														],
														[
															0.873,
															3.112
														],
														[
															0.867,
															2.943
														],
														[
															0.935,
															2.859
														],
														[
															0.665,
															1.762
														],
														[
															0.767,
															2.026
														],
														[
															0.798,
															2.066
														],
														[
															0.757,
															1.882
														],
														[
															1.179,
															2.696
														],
														[
															1.278,
															2.657
														],
														[
															1.351,
															2.597
														],
														[
															1.397,
															2.517
														],
														[
															2.037,
															3.473
														],
														[
															2.224,
															3.314
														],
														[
															2.364,
															3.112
														],
														[
															2.458,
															2.867
														],
														[
															1.139,
															1.173
														],
														[
															1.146,
															1.065
														],
														[
															1.161,
															0.982
														],
														[
															1.184,
															0.927
														],
														[
															1.299,
															0.959
														],
														[
															1.324,
															1.061
														],
														[
															2.277,
															1.293
														],
														[
															6.983,
															2.362
														],
														[
															1.261,
															-0.58
														],
														[
															0.042,
															-0.285
														],
														[
															0.547,
															-1.221
														],
														[
															0.489,
															-1.183
														],
														[
															0.472,
															-0.991
														],
														[
															0.326,
															-0.281
														],
														[
															0.615,
															-0.445
														],
														[
															1.316,
															-0.288
														],
														[
															3.582,
															-1.287
														],
														[
															3.262,
															-1.77
														],
														[
															9.581,
															-6.606
														],
														[
															7.744,
															-9.498
														],
														[
															6.785,
															-12.013
														],
														[
															5.555,
															-13.937
														],
														[
															7.663,
															-27.312
														],
														[
															4.201,
															-33.337
														],
														[
															-0.192,
															-4.357
														],
														[
															0.097,
															-4.365
														],
														[
															-0.474,
															-10.019
														],
														[
															-1.106,
															-9.758
														],
														[
															-0.697,
															-5.65
														],
														[
															-0.814,
															-5.731
														],
														[
															-5.509,
															-28.547
														],
														[
															-9.358,
															-25.472
														],
														[
															-0.931,
															-1.296
														],
														[
															-1.029,
															-1.137
														],
														[
															-0.468,
															-0.57
														],
														[
															-0.267,
															-0.715
														],
														[
															-0.483,
															-0.593
														],
														[
															-0.754,
															-0.456
														],
														[
															-0.523,
															-0.607
														],
														[
															-0.242,
															-0.705
														],
														[
															-1.555,
															-1.752
														],
														[
															-1.728,
															-1.732
														],
														[
															-0.358,
															-0.308
														],
														[
															-0.575,
															-0.107
														],
														[
															-0.326,
															-0.249
														],
														[
															-0.327,
															-0.365
														],
														[
															-1.252,
															-0.998
														],
														[
															-1.175,
															-0.838
														],
														[
															-0.3,
															-0.187
														],
														[
															-0.342,
															-0.402
														],
														[
															-4.616,
															-2.858
														],
														[
															-6.34,
															-2.037
														],
														[
															-0.483,
															0.001
														],
														[
															-0.346,
															0.246
														],
														[
															-4.409,
															0.499
														],
														[
															-3.675,
															1.067
														]
													],
													"v": [
														[
															335,
															32
														],
														[
															334.443,
															32.32
														],
														[
															333.524,
															32.909
														],
														[
															332.592,
															33.544
														],
														[
															332,
															34
														],
														[
															331.493,
															34.403
														],
														[
															331.121,
															34.545
														],
														[
															330.689,
															34.664
														],
														[
															330,
															35
														],
														[
															320.762,
															41.266
														],
														[
															312.472,
															48.319
														],
														[
															304.946,
															55.962
														],
														[
															298,
															64
														],
														[
															289.455,
															75.146
														],
														[
															281.579,
															86.939
														],
														[
															274.413,
															99.263
														],
														[
															268,
															112
														],
														[
															252.619,
															149.777
														],
														[
															240.405,
															190.218
														],
														[
															231.239,
															233.3
														],
														[
															225,
															279
														],
														[
															222.959,
															303.732
														],
														[
															221.741,
															328.79
														],
														[
															221.153,
															354.204
														],
														[
															221,
															380
														],
														[
															222.773,
															424.181
														],
														[
															227.644,
															467.435
														],
														[
															234.943,
															508.222
														],
														[
															244,
															545
														],
														[
															246.722,
															554.697
														],
														[
															249.312,
															563.759
														],
														[
															251.996,
															572.442
														],
														[
															255,
															581
														],
														[
															257.166,
															586.738
														],
														[
															259.531,
															592.934
														],
														[
															261.881,
															598.912
														],
														[
															264,
															604
														],
														[
															267.692,
															612.035
														],
														[
															271.643,
															619.92
														],
														[
															275.772,
															627.595
														],
														[
															280,
															635
														],
														[
															286.403,
															645.191
														],
														[
															293.297,
															654.84
														],
														[
															300.543,
															663.818
														],
														[
															308,
															672
														],
														[
															311.427,
															675.35
														],
														[
															314.886,
															678.414
														],
														[
															318.403,
															681.271
														],
														[
															322,
															684
														],
														[
															325.921,
															687.121
														],
														[
															330,
															690
														],
														[
															345.864,
															696.777
														],
														[
															364,
															699
														],
														[
															365.516,
															698.026
														],
														[
															366,
															696
														],
														[
															367.536,
															692.37
														],
														[
															369,
															689
														],
														[
															369.936,
															687.42
														],
														[
															372,
															686
														],
														[
															375.12,
															684.969
														],
														[
															379,
															684
														],
														[
															389.41,
															679.26
														],
														[
															398,
															674
														],
														[
															423.855,
															649.599
														],
														[
															445,
															618
														],
														[
															463.592,
															578.671
														],
														[
															478,
															536
														],
														[
															496.347,
															443.52
														],
														[
															501,
															342
														],
														[
															501.005,
															328.869
														],
														[
															501,
															316
														],
														[
															498.472,
															286.197
														],
														[
															495,
															258
														],
														[
															492.763,
															240.832
														],
														[
															490,
															224
														],
														[
															467.912,
															142.263
														],
														[
															433,
															74
														],
														[
															430.015,
															70.396
														],
														[
															427,
															67
														],
														[
															425.999,
															65.002
														],
														[
															425,
															63
														],
														[
															423.014,
															61.491
														],
														[
															421,
															60
														],
														[
															419.988,
															57.973
														],
														[
															419,
															56
														],
														[
															413.984,
															50.678
														],
														[
															409,
															46
														],
														[
															407.489,
															45.466
														],
														[
															406,
															45
														],
														[
															405.031,
															44.033
														],
														[
															404,
															43
														],
														[
															400.347,
															40.24
														],
														[
															397,
															38
														],
														[
															396.024,
															37.014
														],
														[
															395,
															36
														],
														[
															378.056,
															28.354
														],
														[
															359,
															25
														],
														[
															357.738,
															25.489
														],
														[
															357,
															26
														],
														[
															344.86,
															28.45
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 21,
											"s": [
												{
													"i": [
														[
															1.802,
															-0.62
														],
														[
															1.107,
															-0.475
														],
														[
															0.897,
															-0.478
														],
														[
															0.842,
															-0.513
														],
														[
															0.942,
															-0.582
														],
														[
															0.428,
															-0.152
														],
														[
															0.456,
															-0.137
														],
														[
															0.425,
															-0.167
														],
														[
															0.336,
															-0.241
														],
														[
															0.58,
															-0.567
														],
														[
															0.586,
															-0.639
														],
														[
															0.588,
															-0.628
														],
														[
															0.586,
															-0.532
														],
														[
															2.268,
															-2.447
														],
														[
															2.024,
															-2.561
														],
														[
															1.869,
															-2.709
														],
														[
															1.804,
															-2.889
														],
														[
															0.88,
															-1.498
														],
														[
															0.824,
															-1.491
														],
														[
															0.782,
															-1.497
														],
														[
															0.754,
															-1.517
														],
														[
															3.98,
															-10.16
														],
														[
															3.108,
															-10.399
														],
														[
															2.449,
															-10.915
														],
														[
															2.002,
															-11.707
														],
														[
															1.745,
															-30.667
														],
														[
															-1.311,
															-30.689
														],
														[
															-4.276,
															-28.678
														],
														[
															-7.149,
															-24.632
														],
														[
															-2.632,
															-7.588
														],
														[
															-3.144,
															-7.449
														],
														[
															-3.69,
															-7.012
														],
														[
															-4.27,
															-6.276
														],
														[
															-2.069,
															-2.634
														],
														[
															-2.245,
															-2.439
														],
														[
															-2.428,
															-2.211
														],
														[
															-2.62,
															-1.949
														],
														[
															-2.533,
															-1.541
														],
														[
															-2.946,
															-1.402
														],
														[
															-2.691,
															-0.66
														],
														[
															-1.765,
															0.686
														],
														[
															-0.573,
															0.732
														],
														[
															-0.212,
															0.892
														],
														[
															-0.158,
															0.964
														],
														[
															-0.411,
															0.948
														],
														[
															-0.699,
															0.51
														],
														[
															-0.893,
															0.274
														],
														[
															-0.997,
															0.252
														],
														[
															-1.013,
															0.445
														],
														[
															-0.779,
															0.442
														],
														[
															-0.686,
															0.455
														],
														[
															-0.564,
															0.411
														],
														[
															-0.413,
															0.309
														],
														[
															-1.31,
															0.963
														],
														[
															-1.194,
															0.918
														],
														[
															-1.162,
															0.996
														],
														[
															-1.215,
															1.196
														],
														[
															-6.492,
															10.213
														],
														[
															-5.152,
															12.029
														],
														[
															-4.085,
															13.426
														],
														[
															-3.288,
															14.405
														],
														[
															-2.866,
															33.646
														],
														[
															1.084,
															34.053
														],
														[
															4.907,
															31.631
														],
														[
															8.606,
															26.379
														],
														[
															0.481,
															1.511
														],
														[
															0.493,
															1.519
														],
														[
															0.515,
															1.498
														],
														[
															0.548,
															1.449
														],
														[
															0.332,
															0.658
														],
														[
															0.361,
															0.649
														],
														[
															0.348,
															0.667
														],
														[
															0.294,
															0.71
														],
														[
															0.239,
															0.855
														],
														[
															0.209,
															0.864
														],
														[
															0.24,
															0.827
														],
														[
															0.334,
															0.744
														],
														[
															0.327,
															0.665
														],
														[
															0.344,
															0.671
														],
														[
															0.345,
															0.67
														],
														[
															0.33,
															0.663
														],
														[
															2.205,
															3.932
														],
														[
															2.367,
															3.745
														],
														[
															2.479,
															3.441
														],
														[
															2.54,
															3.019
														],
														[
															0.499,
															0.614
														],
														[
															0.499,
															0.603
														],
														[
															0.501,
															0.563
														],
														[
															0.505,
															0.493
														],
														[
															0.419,
															0.243
														],
														[
															0.472,
															0.235
														],
														[
															0.442,
															0.249
														],
														[
															0.329,
															0.287
														],
														[
															0.587,
															0.661
														],
														[
															0.802,
															0.614
														],
														[
															5.655,
															2.594
														],
														[
															5.635,
															-0.245
														],
														[
															0.171,
															-0.247
														],
														[
															-0.025,
															0.002
														],
														[
															1.252,
															-0.295
														]
													],
													"o": [
														[
															-1.471,
															0.506
														],
														[
															-1.107,
															0.475
														],
														[
															-0.897,
															0.478
														],
														[
															-0.842,
															0.513
														],
														[
															-0.342,
															0.211
														],
														[
															-0.428,
															0.152
														],
														[
															-0.456,
															0.137
														],
														[
															-0.425,
															0.167
														],
														[
															-0.571,
															0.411
														],
														[
															-0.58,
															0.567
														],
														[
															-0.586,
															0.639
														],
														[
															-0.588,
															0.628
														],
														[
															-2.602,
															2.366
														],
														[
															-2.268,
															2.447
														],
														[
															-2.024,
															2.561
														],
														[
															-1.869,
															2.709
														],
														[
															-0.949,
															1.52
														],
														[
															-0.88,
															1.498
														],
														[
															-0.824,
															1.491
														],
														[
															-0.782,
															1.497
														],
														[
															-5.065,
															10.197
														],
														[
															-3.98,
															10.16
														],
														[
															-3.108,
															10.399
														],
														[
															-2.449,
															10.915
														],
														[
															-4.894,
															28.611
														],
														[
															-1.745,
															30.667
														],
														[
															1.311,
															30.689
														],
														[
															4.276,
															28.678
														],
														[
															2.156,
															7.428
														],
														[
															2.632,
															7.588
														],
														[
															3.144,
															7.449
														],
														[
															3.69,
															7.012
														],
														[
															1.902,
															2.795
														],
														[
															2.069,
															2.634
														],
														[
															2.244,
															2.439
														],
														[
															2.428,
															2.211
														],
														[
															1.449,
															1.078
														],
														[
															2.533,
															1.541
														],
														[
															2.946,
															1.402
														],
														[
															2.691,
															0.66
														],
														[
															1.242,
															-0.482
														],
														[
															0.573,
															-0.732
														],
														[
															0.212,
															-0.892
														],
														[
															0.158,
															-0.964
														],
														[
															0.417,
															-0.961
														],
														[
															0.699,
															-0.51
														],
														[
															0.893,
															-0.274
														],
														[
															0.997,
															-0.252
														],
														[
															0.843,
															-0.37
														],
														[
															0.779,
															-0.442
														],
														[
															0.686,
															-0.455
														],
														[
															0.564,
															-0.411
														],
														[
															1.51,
															-1.13
														],
														[
															1.31,
															-0.963
														],
														[
															1.194,
															-0.919
														],
														[
															1.162,
															-0.996
														],
														[
															8.102,
															-7.978
														],
														[
															6.492,
															-10.213
														],
														[
															5.153,
															-12.029
														],
														[
															4.085,
															-13.426
														],
														[
															6.94,
															-30.408
														],
														[
															2.866,
															-33.646
														],
														[
															-1.084,
															-34.053
														],
														[
															-4.907,
															-31.631
														],
														[
															-0.481,
															-1.474
														],
														[
															-0.481,
															-1.511
														],
														[
															-0.493,
															-1.519
														],
														[
															-0.515,
															-1.498
														],
														[
															-0.262,
															-0.693
														],
														[
															-0.332,
															-0.658
														],
														[
															-0.361,
															-0.649
														],
														[
															-0.348,
															-0.667
														],
														[
															-0.331,
															-0.8
														],
														[
															-0.239,
															-0.855
														],
														[
															-0.209,
															-0.864
														],
														[
															-0.24,
															-0.827
														],
														[
															-0.293,
															-0.653
														],
														[
															-0.327,
															-0.665
														],
														[
															-0.344,
															-0.671
														],
														[
															-0.345,
															-0.67
														],
														[
															-1.991,
															-4.001
														],
														[
															-2.205,
															-3.932
														],
														[
															-2.367,
															-3.745
														],
														[
															-2.479,
															-3.441
														],
														[
															-0.5,
															-0.595
														],
														[
															-0.499,
															-0.614
														],
														[
															-0.499,
															-0.603
														],
														[
															-0.501,
															-0.563
														],
														[
															-0.282,
															-0.275
														],
														[
															-0.419,
															-0.243
														],
														[
															-0.472,
															-0.235
														],
														[
															-0.442,
															-0.249
														],
														[
															-0.851,
															-0.742
														],
														[
															-0.587,
															-0.661
														],
														[
															-3.746,
															-2.87
														],
														[
															-5.655,
															-2.594
														],
														[
															-0.342,
															0.015
														],
														[
															-0.171,
															0.247
														],
														[
															-2.19,
															0.198
														],
														[
															-1.252,
															0.295
														]
													],
													"v": [
														[
															350,
															28
														],
														[
															346.172,
															29.465
														],
														[
															343.206,
															30.886
														],
														[
															340.636,
															32.364
														],
														[
															338,
															34
														],
														[
															336.831,
															34.533
														],
														[
															335.491,
															34.955
														],
														[
															334.155,
															35.399
														],
														[
															333,
															36
														],
														[
															331.272,
															37.488
														],
														[
															329.522,
															39.318
														],
														[
															327.761,
															41.239
														],
														[
															326,
															43
														],
														[
															318.718,
															50.211
														],
														[
															312.303,
															57.715
														],
														[
															306.487,
															65.612
														],
														[
															301,
															74
														],
														[
															298.26,
															78.524
														],
														[
															295.707,
															83.005
														],
														[
															293.3,
															87.483
														],
														[
															291,
															92
														],
														[
															277.485,
															122.465
														],
														[
															266.906,
															153.235
														],
														[
															258.623,
															185.137
														],
														[
															252,
															219
														],
														[
															242.065,
															308.426
														],
														[
															241.437,
															400.969
														],
														[
															249.84,
															490.527
														],
														[
															267,
															571
														],
														[
															274.173,
															593.597
														],
														[
															282.827,
															616.227
														],
														[
															293.068,
															637.993
														],
														[
															305,
															658
														],
														[
															310.954,
															666.151
														],
														[
															317.422,
															673.768
														],
														[
															324.429,
															680.751
														],
														[
															332,
															687
														],
														[
															338.14,
															691.08
														],
														[
															346.526,
															695.646
														],
														[
															355.148,
															698.888
														],
														[
															362,
															699
														],
														[
															364.646,
															697.157
														],
														[
															365.747,
															694.698
														],
														[
															366.224,
															691.891
														],
														[
															367,
															689
														],
														[
															368.696,
															686.847
														],
														[
															371.106,
															685.726
														],
														[
															373.963,
															684.992
														],
														[
															377,
															684
														],
														[
															379.44,
															682.767
														],
														[
															381.645,
															681.407
														],
														[
															383.528,
															680.094
														],
														[
															385,
															679
														],
														[
															389.209,
															675.891
														],
														[
															392.943,
															673.099
														],
														[
															396.456,
															670.258
														],
														[
															400,
															667
														],
														[
															421.823,
															639.608
														],
														[
															439.221,
															606.14
														],
														[
															453.009,
															567.852
														],
														[
															464,
															526
														],
														[
															478.678,
															429.213
														],
														[
															481.319,
															326.957
														],
														[
															472.302,
															227.723
														],
														[
															452,
															140
														],
														[
															450.559,
															135.515
														],
														[
															449.101,
															130.962
														],
														[
															447.592,
															126.428
														],
														[
															446,
															122
														],
														[
															445.098,
															119.98
														],
														[
															444.048,
															118.026
														],
														[
															442.974,
															116.059
														],
														[
															442,
															114
														],
														[
															441.161,
															111.507
														],
														[
															440.505,
															108.917
														],
														[
															439.846,
															106.369
														],
														[
															439,
															104
														],
														[
															438.066,
															102.021
														],
														[
															437.055,
															100.015
														],
														[
															436.017,
															98.002
														],
														[
															435,
															96
														],
														[
															428.693,
															84.071
														],
														[
															421.823,
															72.526
														],
														[
															414.541,
															61.718
														],
														[
															407,
															52
														],
														[
															405.502,
															50.18
														],
														[
															404.007,
															48.347
														],
														[
															402.508,
															46.591
														],
														[
															401,
															45
														],
														[
															399.928,
															44.228
														],
														[
															398.571,
															43.518
														],
														[
															397.178,
															42.798
														],
														[
															396,
															42
														],
														[
															393.964,
															39.905
														],
														[
															392,
															38
														],
														[
															377.416,
															29.163
														],
														[
															360,
															25
														],
														[
															359.224,
															25.513
														],
														[
															359,
															26
														],
														[
															354.209,
															26.683
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 22,
											"s": [
												{
													"i": [
														[
															3.581,
															-3.959
														],
														[
															2.815,
															-4.292
														],
														[
															2.55,
															-4.805
														],
														[
															2.21,
															-4.861
														],
														[
															1.796,
															-4.46
														],
														[
															0.178,
															-0.589
														],
														[
															0.151,
															-0.594
														],
														[
															0.148,
															-0.583
														],
														[
															0.168,
															-0.556
														],
														[
															0.178,
															-0.165
														],
														[
															0.231,
															-0.194
														],
														[
															0.187,
															-0.182
														],
														[
															0.047,
															-0.129
														],
														[
															0.705,
															-2.339
														],
														[
															0.636,
															-2.371
														],
														[
															0.613,
															-2.347
														],
														[
															0.636,
															-2.266
														],
														[
															3.472,
															-17.979
														],
														[
															2.37,
															-19.197
														],
														[
															1.213,
															-19.744
														],
														[
															0,
															-19.622
														],
														[
															-0.67,
															-15.089
														],
														[
															-1.336,
															-14.637
														],
														[
															-1.998,
															-14.229
														],
														[
															-2.656,
															-13.866
														],
														[
															-3.734,
															-14.48
														],
														[
															-5.07,
															-13.402
														],
														[
															-6.801,
															-11.345
														],
														[
															-8.928,
															-8.312
														],
														[
															-0.245,
															-0.076
														],
														[
															-0.265,
															-0.036
														],
														[
															-0.263,
															-0.067
														],
														[
															-0.237,
															-0.169
														],
														[
															-0.24,
															-0.261
														],
														[
															-0.215,
															-0.269
														],
														[
															-0.243,
															-0.248
														],
														[
															-0.322,
															-0.199
														],
														[
															-1.372,
															-0.631
														],
														[
															-1.524,
															-0.555
														],
														[
															-1.265,
															-0.271
														],
														[
															-0.595,
															0.219
														],
														[
															-0.395,
															0.296
														],
														[
															-0.233,
															0.433
														],
														[
															-0.222,
															0.67
														],
														[
															-0.361,
															1.009
														],
														[
															-0.132,
															0.58
														],
														[
															-0.164,
															0.558
														],
														[
															-0.325,
															0.574
														],
														[
															-0.615,
															0.627
														],
														[
															-0.332,
															0.092
														],
														[
															-0.391,
															0.047
														],
														[
															-0.363,
															0.057
														],
														[
															-0.25,
															0.121
														],
														[
															-0.982,
															0.641
														],
														[
															-0.92,
															0.661
														],
														[
															-0.854,
															0.565
														],
														[
															-0.782,
															0.352
														],
														[
															-0.084,
															0.174
														],
														[
															-0.09,
															0.227
														],
														[
															-0.086,
															0.19
														],
														[
															-0.072,
															0.062
														],
														[
															-1.274,
															1.208
														],
														[
															-1.123,
															1.212
														],
														[
															-1.037,
															1.273
														],
														[
															-1.016,
															1.39
														],
														[
															-0.241,
															0.228
														],
														[
															-0.268,
															0.229
														],
														[
															-0.268,
															0.262
														],
														[
															-0.241,
															0.326
														],
														[
															-0.163,
															0.422
														],
														[
															-0.133,
															0.456
														],
														[
															-0.154,
															0.431
														],
														[
															-0.225,
															0.348
														],
														[
															-0.26,
															0.247
														],
														[
															-0.277,
															0.223
														],
														[
															-0.254,
															0.239
														],
														[
															-0.189,
															0.296
														],
														[
															-0.328,
															0.712
														],
														[
															-0.324,
															0.58
														],
														[
															-2.739,
															5.835
														],
														[
															-2.009,
															5.233
														],
														[
															-3.934,
															14.924
														],
														[
															-2.886,
															15.292
														],
														[
															-2.367,
															22.756
														],
														[
															-0.462,
															23.4
														],
														[
															3.834,
															40.442
														],
														[
															8.526,
															33.703
														],
														[
															2.521,
															8.048
														],
														[
															2.76,
															7.285
														],
														[
															0.895,
															2.4
														],
														[
															0.662,
															1.4
														],
														[
															3.476,
															6.056
														],
														[
															4.106,
															5.454
														],
														[
															4.47,
															3.926
														],
														[
															5.146,
															2.016
														],
														[
															1.844,
															0.639
														],
														[
															1.409,
															-0.03
														],
														[
															0.165,
															-0.248
														],
														[
															-0.016,
															0.002
														],
														[
															5.181,
															-3.634
														]
													],
													"o": [
														[
															-3.004,
															3.322
														],
														[
															-2.815,
															4.292
														],
														[
															-2.55,
															4.805
														],
														[
															-2.21,
															4.861
														],
														[
															-0.229,
															0.568
														],
														[
															-0.178,
															0.589
														],
														[
															-0.151,
															0.594
														],
														[
															-0.148,
															0.583
														],
														[
															-0.028,
															0.094
														],
														[
															-0.178,
															0.165
														],
														[
															-0.231,
															0.194
														],
														[
															-0.187,
															0.182
														],
														[
															-0.819,
															2.249
														],
														[
															-0.705,
															2.339
														],
														[
															-0.636,
															2.371
														],
														[
															-0.613,
															2.347
														],
														[
															-4.518,
															16.091
														],
														[
															-3.472,
															17.979
														],
														[
															-2.37,
															19.197
														],
														[
															-1.213,
															19.744
														],
														[
															0,
															15.586
														],
														[
															0.67,
															15.089
														],
														[
															1.336,
															14.637
														],
														[
															1.998,
															14.229
														],
														[
															2.793,
															14.582
														],
														[
															3.734,
															14.48
														],
														[
															5.07,
															13.402
														],
														[
															6.801,
															11.345
														],
														[
															0.201,
															0.187
														],
														[
															0.245,
															0.076
														],
														[
															0.266,
															0.036
														],
														[
															0.263,
															0.067
														],
														[
															0.317,
															0.226
														],
														[
															0.24,
															0.261
														],
														[
															0.215,
															0.269
														],
														[
															0.243,
															0.248
														],
														[
															0.81,
															0.501
														],
														[
															1.372,
															0.631
														],
														[
															1.524,
															0.555
														],
														[
															1.265,
															0.271
														],
														[
															0.708,
															-0.261
														],
														[
															0.395,
															-0.296
														],
														[
															0.233,
															-0.433
														],
														[
															0.222,
															-0.67
														],
														[
															0.23,
															-0.641
														],
														[
															0.132,
															-0.58
														],
														[
															0.164,
															-0.558
														],
														[
															0.325,
															-0.574
														],
														[
															0.188,
															-0.192
														],
														[
															0.332,
															-0.092
														],
														[
															0.391,
															-0.047
														],
														[
															0.363,
															-0.057
														],
														[
															1.038,
															-0.505
														],
														[
															0.982,
															-0.641
														],
														[
															0.92,
															-0.661
														],
														[
															0.854,
															-0.565
														],
														[
															0.068,
															-0.03
														],
														[
															0.084,
															-0.174
														],
														[
															0.09,
															-0.227
														],
														[
															0.086,
															-0.189
														],
														[
															1.491,
															-1.262
														],
														[
															1.275,
															-1.208
														],
														[
															1.123,
															-1.212
														],
														[
															1.037,
															-1.273
														],
														[
															0.188,
															-0.257
														],
														[
															0.241,
															-0.228
														],
														[
															0.268,
															-0.229
														],
														[
															0.268,
															-0.262
														],
														[
															0.243,
															-0.329
														],
														[
															0.163,
															-0.422
														],
														[
															0.133,
															-0.456
														],
														[
															0.154,
															-0.431
														],
														[
															0.202,
															-0.313
														],
														[
															0.26,
															-0.247
														],
														[
															0.277,
															-0.223
														],
														[
															0.254,
															-0.239
														],
														[
															0.366,
															-0.572
														],
														[
															0.327,
															-0.712
														],
														[
															3.034,
															-5.427
														],
														[
															2.739,
															-5.835
														],
														[
															5.379,
															-14.014
														],
														[
															3.934,
															-14.923
														],
														[
															4.072,
															-21.576
														],
														[
															2.366,
															-22.756
														],
														[
															0.861,
															-43.526
														],
														[
															-3.834,
															-40.442
														],
														[
															-2.156,
															-8.525
														],
														[
															-2.521,
															-8.047
														],
														[
															-0.757,
															-1.999
														],
														[
															-0.895,
															-2.4
														],
														[
															-2.988,
															-6.322
														],
														[
															-3.476,
															-6.056
														],
														[
															-3.975,
															-5.281
														],
														[
															-4.47,
															-3.926
														],
														[
															-1.216,
															-0.476
														],
														[
															-1.844,
															-0.639
														],
														[
															-0.356,
															0.008
														],
														[
															-0.165,
															0.248
														],
														[
															-5.697,
															0.505
														],
														[
															-5.181,
															3.634
														]
													],
													"v": [
														[
															330,
															45
														],
														[
															321.253,
															56.534
														],
														[
															313.187,
															70.293
														],
														[
															306.028,
															84.905
														],
														[
															300,
															99
														],
														[
															299.396,
															100.739
														],
														[
															298.909,
															102.517
														],
														[
															298.468,
															104.287
														],
														[
															298,
															106
														],
														[
															297.666,
															106.398
														],
														[
															297.028,
															106.947
														],
														[
															296.376,
															107.523
														],
														[
															296,
															108
														],
														[
															293.725,
															114.895
														],
														[
															291.725,
															121.975
														],
														[
															289.862,
															129.067
														],
														[
															288,
															136
														],
														[
															276,
															187.272
														],
														[
															267.223,
															243.203
														],
														[
															261.833,
															301.782
														],
														[
															260,
															361
														],
														[
															261.006,
															407.001
														],
														[
															264.016,
															451.58
														],
														[
															269.018,
															494.869
														],
														[
															276,
															537
														],
														[
															285.691,
															580.837
														],
														[
															298.798,
															622.905
														],
														[
															316.505,
															660.269
														],
														[
															340,
															690
														],
														[
															340.675,
															690.377
														],
														[
															341.446,
															690.527
														],
														[
															342.244,
															690.664
														],
														[
															343,
															691
														],
														[
															343.822,
															691.738
														],
														[
															344.492,
															692.54
														],
														[
															345.166,
															693.322
														],
														[
															346,
															694
														],
														[
															349.376,
															695.75
														],
														[
															353.823,
															697.58
														],
														[
															358.109,
															698.871
														],
														[
															361,
															699
														],
														[
															362.616,
															698.189
														],
														[
															363.52,
															697.122
														],
														[
															364.163,
															695.493
														],
														[
															365,
															693
														],
														[
															365.51,
															691.177
														],
														[
															365.922,
															689.479
														],
														[
															366.623,
															687.792
														],
														[
															368,
															686
														],
														[
															368.801,
															685.589
														],
														[
															369.907,
															685.395
														],
														[
															371.06,
															685.253
														],
														[
															372,
															685
														],
														[
															375.03,
															683.252
														],
														[
															377.884,
															681.271
														],
														[
															380.546,
															679.405
														],
														[
															383,
															678
														],
														[
															383.23,
															677.671
														],
														[
															383.493,
															677.047
														],
														[
															383.76,
															676.399
														],
														[
															384,
															676
														],
														[
															388.133,
															672.309
														],
														[
															391.713,
															668.693
														],
														[
															394.936,
															664.98
														],
														[
															398,
															661
														],
														[
															398.65,
															660.281
														],
														[
															399.42,
															659.603
														],
														[
															400.23,
															658.874
														],
														[
															401,
															658
														],
														[
															401.597,
															656.859
														],
														[
															402.028,
															655.528
														],
														[
															402.445,
															654.183
														],
														[
															403,
															653
														],
														[
															403.704,
															652.17
														],
														[
															404.519,
															651.475
														],
														[
															405.326,
															650.792
														],
														[
															406,
															650
														],
														[
															407.032,
															648.006
														],
														[
															408,
															646
														],
														[
															416.769,
															628.854
														],
														[
															424,
															612
														],
														[
															437.87,
															568.458
														],
														[
															448,
															523
														],
														[
															457.707,
															456.368
														],
														[
															462,
															387
														],
														[
															457.54,
															260.133
														],
														[
															439,
															148
														],
														[
															431.952,
															123.069
														],
														[
															424,
															100
														],
														[
															421.428,
															93.051
														],
														[
															419,
															87
														],
														[
															409.338,
															68.349
														],
														[
															398,
															51
														],
														[
															385.378,
															37.052
														],
														[
															371,
															28
														],
														[
															366.145,
															26.12
														],
														[
															361,
															25
														],
														[
															360.221,
															25.507
														],
														[
															360,
															26
														],
														[
															343.413,
															32.91
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 23,
											"s": [
												{
													"i": [
														[
															0.492,
															-0.302
														],
														[
															0.487,
															-0.362
														],
														[
															0.439,
															-0.367
														],
														[
															0.357,
															-0.321
														],
														[
															0.242,
															-0.225
														],
														[
															0.254,
															-0.073
														],
														[
															0.279,
															-0.039
														],
														[
															0.26,
															-0.072
														],
														[
															0.197,
															-0.171
														],
														[
															1.131,
															-1.365
														],
														[
															1.122,
															-1.61
														],
														[
															0.93,
															-1.565
														],
														[
															0.554,
															-1.228
														],
														[
															0.175,
															-0.08
														],
														[
															0.225,
															-0.082
														],
														[
															0.188,
															-0.086
														],
														[
															0.062,
															-0.093
														],
														[
															-0.004,
															-0.169
														],
														[
															-0.034,
															-0.189
														],
														[
															-0.013,
															-0.176
														],
														[
															0.058,
															-0.128
														],
														[
															0.176,
															-0.078
														],
														[
															0.225,
															-0.078
														],
														[
															0.186,
															-0.086
														],
														[
															0.059,
															-0.103
														],
														[
															0.332,
															-0.636
														],
														[
															0.329,
															-0.673
														],
														[
															0.333,
															-0.7
														],
														[
															0.343,
															-0.719
														],
														[
															0.637,
															-1.487
														],
														[
															0.59,
															-1.475
														],
														[
															0.533,
															-1.375
														],
														[
															0.467,
															-1.187
														],
														[
															3.377,
															-11.908
														],
														[
															2.601,
															-12.654
														],
														[
															1.924,
															-13.044
														],
														[
															1.345,
															-13.077
														],
														[
															1.009,
															-13.368
														],
														[
															0.626,
															-13.683
														],
														[
															0.179,
															-13.848
														],
														[
															-0.332,
															-13.863
														],
														[
															-0.487,
															-9.75
														],
														[
															-0.694,
															-9.486
														],
														[
															-0.86,
															-9.118
														],
														[
															-0.985,
															-8.647
														],
														[
															-0.472,
															-3.574
														],
														[
															-0.512,
															-3.504
														],
														[
															-0.534,
															-3.429
														],
														[
															-0.538,
															-3.346
														],
														[
															-0.673,
															-3.436
														],
														[
															-0.721,
															-3.595
														],
														[
															-1.233,
															-6.713
														],
														[
															-1.768,
															-6.668
														],
														[
															-1.061,
															-3.018
														],
														[
															-0.962,
															-2.939
														],
														[
															-0.935,
															-3.149
														],
														[
															-1.196,
															-3.152
														],
														[
															-0.701,
															-1.231
														],
														[
															-0.4,
															-0.981
														],
														[
															-0.403,
															-1.494
														],
														[
															-0.953,
															-1.957
														],
														[
															-2.589,
															-4.074
														],
														[
															-2.296,
															-2.93
														],
														[
															-0.543,
															-0.489
														],
														[
															-0.5,
															-0.625
														],
														[
															-0.254,
															-0.724
														],
														[
															-0.433,
															-0.417
														],
														[
															-0.723,
															-0.26
														],
														[
															-0.653,
															-0.524
														],
														[
															-0.454,
															-0.539
														],
														[
															-0.607,
															-0.38
														],
														[
															-1.673,
															-0.732
														],
														[
															-0.338,
															0.16
														],
														[
															-0.073,
															1.11
														],
														[
															-0.516,
															1.998
														],
														[
															-1.23,
															1.094
														],
														[
															-2.276,
															1.512
														],
														[
															-1.733,
															1.343
														],
														[
															-1.216,
															1.399
														],
														[
															-0.105,
															0.575
														],
														[
															-0.268,
															0.344
														],
														[
															-0.764,
															0.685
														],
														[
															-0.339,
															0.485
														],
														[
															-5.029,
															13.472
														],
														[
															-3.529,
															13.588
														],
														[
															-0.865,
															3.137
														],
														[
															-0.707,
															3.253
														],
														[
															-2.811,
															23.191
														],
														[
															-1.836,
															25.621
														],
														[
															0.693,
															31.371
														],
														[
															2.563,
															29.929
														],
														[
															5.36,
															27.352
														],
														[
															9.048,
															23.258
														],
														[
															2.642,
															5.704
														],
														[
															3.519,
															5.27
														],
														[
															4.739,
															3.875
														],
														[
															5.393,
															0.032
														],
														[
															0.3,
															-0.237
														],
														[
															0.234,
															-0.054
														],
														[
															0.447,
															-0.133
														]
													],
													"o": [
														[
															-0.503,
															0.308
														],
														[
															-0.487,
															0.362
														],
														[
															-0.439,
															0.367
														],
														[
															-0.357,
															0.321
														],
														[
															-0.185,
															0.173
														],
														[
															-0.254,
															0.073
														],
														[
															-0.279,
															0.039
														],
														[
															-0.26,
															0.072
														],
														[
															-0.957,
															0.83
														],
														[
															-1.131,
															1.365
														],
														[
															-1.122,
															1.61
														],
														[
															-0.93,
															1.565
														],
														[
															-0.036,
															0.081
														],
														[
															-0.175,
															0.08
														],
														[
															-0.225,
															0.082
														],
														[
															-0.188,
															0.086
														],
														[
															-0.077,
															0.115
														],
														[
															0.004,
															0.169
														],
														[
															0.034,
															0.189
														],
														[
															0.013,
															0.176
														],
														[
															-0.039,
															0.087
														],
														[
															-0.176,
															0.078
														],
														[
															-0.225,
															0.078
														],
														[
															-0.186,
															0.086
														],
														[
															-0.34,
															0.59
														],
														[
															-0.332,
															0.636
														],
														[
															-0.329,
															0.673
														],
														[
															-0.333,
															0.7
														],
														[
															-0.673,
															1.411
														],
														[
															-0.637,
															1.487
														],
														[
															-0.59,
															1.476
														],
														[
															-0.533,
															1.375
														],
														[
															-4.25,
															10.805
														],
														[
															-3.377,
															11.908
														],
														[
															-2.601,
															12.655
														],
														[
															-1.924,
															13.044
														],
														[
															-1.327,
															12.903
														],
														[
															-1.009,
															13.368
														],
														[
															-0.626,
															13.683
														],
														[
															-0.179,
															13.848
														],
														[
															0.238,
															9.911
														],
														[
															0.487,
															9.75
														],
														[
															0.694,
															9.486
														],
														[
															0.86,
															9.118
														],
														[
															0.414,
															3.636
														],
														[
															0.472,
															3.574
														],
														[
															0.512,
															3.504
														],
														[
															0.534,
															3.429
														],
														[
															0.588,
															3.66
														],
														[
															0.673,
															3.436
														],
														[
															1.3,
															6.481
														],
														[
															1.233,
															6.713
														],
														[
															0.793,
															2.99
														],
														[
															1.061,
															3.018
														],
														[
															1.065,
															3.253
														],
														[
															0.935,
															3.149
														],
														[
															0.796,
															2.096
														],
														[
															0.701,
															1.231
														],
														[
															0.437,
															1.068
														],
														[
															0.403,
															1.494
														],
														[
															1.35,
															2.772
														],
														[
															2.589,
															4.074
														],
														[
															0.328,
															0.419
														],
														[
															0.543,
															0.489
														],
														[
															0.551,
															0.687
														],
														[
															0.254,
															0.724
														],
														[
															0.454,
															0.437
														],
														[
															0.723,
															0.26
														],
														[
															0.577,
															0.463
														],
														[
															0.454,
															0.539
														],
														[
															1.971,
															1.234
														],
														[
															1.673,
															0.732
														],
														[
															1.192,
															-0.563
														],
														[
															0.073,
															-1.11
														],
														[
															0.803,
															-3.111
														],
														[
															1.23,
															-1.094
														],
														[
															1.851,
															-1.229
														],
														[
															1.733,
															-1.343
														],
														[
															0.311,
															-0.358
														],
														[
															0.105,
															-0.575
														],
														[
															0.604,
															-0.775
														],
														[
															0.764,
															-0.685
														],
														[
															7.356,
															-10.523
														],
														[
															5.029,
															-13.472
														],
														[
															0.831,
															-3.2
														],
														[
															0.865,
															-3.137
														],
														[
															4.918,
															-22.615
														],
														[
															2.812,
															-23.191
														],
														[
															2.334,
															-32.588
														],
														[
															-0.693,
															-31.371
														],
														[
															-2.512,
															-29.335
														],
														[
															-5.36,
															-27.352
														],
														[
															-1.913,
															-4.916
														],
														[
															-2.642,
															-5.704
														],
														[
															-3.65,
															-5.466
														],
														[
															-4.739,
															-3.875
														],
														[
															-0.565,
															-0.004
														],
														[
															-0.3,
															0.237
														],
														[
															-0.721,
															0.166
														],
														[
															-0.447,
															0.133
														]
													],
													"v": [
														[
															355,
															28
														],
														[
															353.506,
															29.018
														],
														[
															352.108,
															30.124
														],
														[
															350.906,
															31.168
														],
														[
															350,
															32
														],
														[
															349.329,
															32.351
														],
														[
															348.518,
															32.502
														],
														[
															347.697,
															32.652
														],
														[
															347,
															33
														],
														[
															343.822,
															36.365
														],
														[
															340.396,
															40.902
														],
														[
															337.271,
															45.737
														],
														[
															335,
															50
														],
														[
															334.661,
															50.241
														],
														[
															334.038,
															50.483
														],
														[
															333.396,
															50.733
														],
														[
															333,
															51
														],
														[
															332.903,
															51.435
														],
														[
															332.971,
															51.981
														],
														[
															333.054,
															52.537
														],
														[
															333,
															53
														],
														[
															332.655,
															53.246
														],
														[
															332.03,
															53.477
														],
														[
															331.391,
															53.719
														],
														[
															331,
															54
														],
														[
															329.994,
															55.841
														],
														[
															329.004,
															57.806
														],
														[
															328.012,
															59.869
														],
														[
															327,
															62
														],
														[
															325.032,
															66.37
														],
														[
															323.19,
															70.837
														],
														[
															321.503,
															75.135
														],
														[
															320,
															79
														],
														[
															308.585,
															113.158
														],
														[
															299.642,
															150.09
														],
														[
															292.879,
															188.728
														],
														[
															288,
															228
														],
														[
															284.48,
															267.444
														],
														[
															282.012,
															308.06
														],
														[
															280.787,
															349.395
														],
														[
															281,
															391
														],
														[
															282.097,
															420.517
														],
														[
															283.879,
															449.396
														],
														[
															286.221,
															477.327
														],
														[
															289,
															504
														],
														[
															290.334,
															514.816
														],
														[
															291.815,
															525.435
														],
														[
															293.388,
															535.836
														],
														[
															295,
															546
														],
														[
															296.9,
															556.549
														],
														[
															299,
															567
														],
														[
															302.649,
															586.86
														],
														[
															307,
															607
														],
														[
															309.873,
															616.037
														],
														[
															313,
															625
														],
														[
															315.902,
															634.575
														],
														[
															319,
															644
														],
														[
															321.296,
															648.837
														],
														[
															323,
															652
														],
														[
															324.113,
															655.834
														],
														[
															326,
															661
														],
														[
															332.291,
															671.881
														],
														[
															340,
															683
														],
														[
															341.371,
															684.346
														],
														[
															343,
															686
														],
														[
															344.088,
															688.202
														],
														[
															345,
															690
														],
														[
															346.851,
															690.935
														],
														[
															349,
															692
														],
														[
															350.478,
															693.562
														],
														[
															352,
															695
														],
														[
															357.725,
															698.045
														],
														[
															361,
															699
														],
														[
															362.507,
															696.577
														],
														[
															363,
															692
														],
														[
															365.895,
															686.3
														],
														[
															371,
															683
														],
														[
															376.476,
															679.128
														],
														[
															381,
															675
														],
														[
															381.532,
															673.49
														],
														[
															382,
															672
														],
														[
															384.199,
															669.782
														],
														[
															386,
															668
														],
														[
															404.37,
															631.299
														],
														[
															417,
															590
														],
														[
															419.593,
															580.539
														],
														[
															422,
															571
														],
														[
															433.312,
															502.755
														],
														[
															440,
															430
														],
														[
															442.173,
															334.006
														],
														[
															437,
															242
														],
														[
															425.402,
															156.442
														],
														[
															404,
															80
														],
														[
															397.205,
															63.765
														],
														[
															388,
															47
														],
														[
															375.307,
															32.424
														],
														[
															360,
															26
														],
														[
															358.751,
															26.457
														],
														[
															358,
															27
														],
														[
															356.328,
															27.398
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 24,
											"s": [
												{
													"i": [
														[
															-0.788,
															0.647
														],
														[
															-0.162,
															0.093
														],
														[
															-0.184,
															0.083
														],
														[
															-0.196,
															0.077
														],
														[
															-0.196,
															0.074
														],
														[
															-0.185,
															0.075
														],
														[
															-0.164,
															0.079
														],
														[
															-0.131,
															0.086
														],
														[
															-0.087,
															0.097
														],
														[
															-0.088,
															0.143
														],
														[
															-0.074,
															0.16
														],
														[
															-0.066,
															0.172
														],
														[
															-0.066,
															0.18
														],
														[
															-0.071,
															0.182
														],
														[
															-0.084,
															0.18
														],
														[
															-0.103,
															0.173
														],
														[
															-0.129,
															0.161
														],
														[
															-0.13,
															0.138
														],
														[
															-0.136,
															0.13
														],
														[
															-0.138,
															0.123
														],
														[
															-0.136,
															0.119
														],
														[
															-0.13,
															0.117
														],
														[
															-0.12,
															0.117
														],
														[
															-0.106,
															0.12
														],
														[
															-0.087,
															0.125
														],
														[
															-0.731,
															1.205
														],
														[
															-0.603,
															1.169
														],
														[
															-0.57,
															1.255
														],
														[
															-0.634,
															1.462
														],
														[
															-1.799,
															5.031
														],
														[
															-1.569,
															5.284
														],
														[
															-1.361,
															5.486
														],
														[
															-1.175,
															5.637
														],
														[
															-1.657,
															10.065
														],
														[
															-1.283,
															10.207
														],
														[
															-0.984,
															10.539
														],
														[
															-0.763,
															11.059
														],
														[
															-0.267,
															3.649
														],
														[
															-0.264,
															3.677
														],
														[
															-0.24,
															3.689
														],
														[
															-0.196,
															3.687
														],
														[
															-0.191,
															18.708
														],
														[
															0.496,
															18.529
														],
														[
															1.063,
															18.181
														],
														[
															1.513,
															17.665
														],
														[
															0.377,
															3.548
														],
														[
															0.429,
															3.503
														],
														[
															0.462,
															3.453
														],
														[
															0.478,
															3.399
														],
														[
															1.339,
															8.263
														],
														[
															1.627,
															8.255
														],
														[
															1.975,
															7.864
														],
														[
															2.381,
															7.092
														],
														[
															0.672,
															1.843
														],
														[
															0.69,
															1.786
														],
														[
															0.673,
															1.675
														],
														[
															0.621,
															1.51
														],
														[
															0.924,
															1.694
														],
														[
															1.038,
															1.522
														],
														[
															1.095,
															1.317
														],
														[
															1.096,
															1.079
														],
														[
															0.939,
															0.834
														],
														[
															0.911,
															0.433
														],
														[
															1.016,
															-0.117
														],
														[
															1.256,
															-0.817
														],
														[
															1.162,
															-1.201
														],
														[
															0.995,
															-1.363
														],
														[
															0.835,
															-1.355
														],
														[
															0.683,
															-1.179
														],
														[
															0.913,
															-1.9
														],
														[
															0.819,
															-1.96
														],
														[
															0.747,
															-1.955
														],
														[
															0.695,
															-1.886
														],
														[
															1.302,
															-4.119
														],
														[
															1.172,
															-4.301
														],
														[
															1.034,
															-4.406
														],
														[
															0.888,
															-4.436
														],
														[
															2.627,
															-20.959
														],
														[
															1.497,
															-21.903
														],
														[
															0.622,
															-22.868
														],
														[
															0,
															-23.853
														],
														[
															-0.572,
															-15.225
														],
														[
															-1.058,
															-14.83
														],
														[
															-1.457,
															-14.189
														],
														[
															-1.768,
															-13.304
														],
														[
															-1.191,
															-7.676
														],
														[
															-1.383,
															-7.383
														],
														[
															-1.625,
															-7.015
														],
														[
															-1.918,
															-6.574
														],
														[
															-1.445,
															-4.207
														],
														[
															-1.659,
															-3.963
														],
														[
															-1.884,
															-3.524
														],
														[
															-2.12,
															-2.891
														],
														[
															-0.725,
															-0.825
														],
														[
															-0.823,
															-0.71
														],
														[
															-0.936,
															-0.53
														],
														[
															-1.065,
															-0.284
														],
														[
															-0.178,
															1.348
														],
														[
															-0.237,
															1.021
														],
														[
															-0.44,
															0.787
														]
													],
													"o": [
														[
															0.129,
															-0.105
														],
														[
															0.162,
															-0.093
														],
														[
															0.184,
															-0.083
														],
														[
															0.196,
															-0.077
														],
														[
															0.196,
															-0.074
														],
														[
															0.185,
															-0.075
														],
														[
															0.164,
															-0.079
														],
														[
															0.131,
															-0.086
														],
														[
															0.109,
															-0.121
														],
														[
															0.088,
															-0.143
														],
														[
															0.074,
															-0.16
														],
														[
															0.066,
															-0.172
														],
														[
															0.066,
															-0.18
														],
														[
															0.071,
															-0.182
														],
														[
															0.084,
															-0.18
														],
														[
															0.103,
															-0.173
														],
														[
															0.12,
															-0.149
														],
														[
															0.13,
															-0.138
														],
														[
															0.136,
															-0.13
														],
														[
															0.138,
															-0.123
														],
														[
															0.136,
															-0.119
														],
														[
															0.13,
															-0.117
														],
														[
															0.12,
															-0.117
														],
														[
															0.106,
															-0.12
														],
														[
															0.956,
															-1.362
														],
														[
															0.731,
															-1.205
														],
														[
															0.603,
															-1.169
														],
														[
															0.57,
															-1.255
														],
														[
															2.05,
															-4.727
														],
														[
															1.799,
															-5.031
														],
														[
															1.569,
															-5.284
														],
														[
															1.361,
															-5.486
														],
														[
															2.107,
															-10.111
														],
														[
															1.657,
															-10.065
														],
														[
															1.283,
															-10.207
														],
														[
															0.984,
															-10.539
														],
														[
															0.249,
															-3.606
														],
														[
															0.267,
															-3.649
														],
														[
															0.264,
															-3.677
														],
														[
															0.24,
															-3.689
														],
														[
															0.995,
															-18.719
														],
														[
															0.191,
															-18.708
														],
														[
															-0.496,
															-18.529
														],
														[
															-1.063,
															-18.181
														],
														[
															-0.307,
															-3.588
														],
														[
															-0.377,
															-3.548
														],
														[
															-0.429,
															-3.503
														],
														[
															-0.462,
															-3.453
														],
														[
															-1.11,
															-7.89
														],
														[
															-1.339,
															-8.263
														],
														[
															-1.627,
															-8.255
														],
														[
															-1.975,
															-7.864
														],
														[
															-0.62,
															-1.846
														],
														[
															-0.672,
															-1.843
														],
														[
															-0.69,
															-1.786
														],
														[
															-0.673,
															-1.675
														],
														[
															-0.754,
															-1.832
														],
														[
															-0.924,
															-1.694
														],
														[
															-1.038,
															-1.522
														],
														[
															-1.095,
															-1.317
														],
														[
															-1.101,
															-1.084
														],
														[
															-0.939,
															-0.834
														],
														[
															-0.911,
															-0.433
														],
														[
															-1.016,
															0.117
														],
														[
															-1.337,
															0.87
														],
														[
															-1.162,
															1.201
														],
														[
															-0.995,
															1.363
														],
														[
															-0.835,
															1.355
														],
														[
															-1.028,
															1.776
														],
														[
															-0.913,
															1.9
														],
														[
															-0.819,
															1.96
														],
														[
															-0.747,
															1.955
														],
														[
															-1.423,
															3.861
														],
														[
															-1.302,
															4.119
														],
														[
															-1.172,
															4.301
														],
														[
															-1.034,
															4.406
														],
														[
															-4.01,
															20.035
														],
														[
															-2.627,
															20.959
														],
														[
															-1.497,
															21.903
														],
														[
															-0.622,
															22.868
														],
														[
															0,
															15.376
														],
														[
															0.572,
															15.225
														],
														[
															1.058,
															14.83
														],
														[
															1.457,
															14.189
														],
														[
															1.049,
															7.896
														],
														[
															1.191,
															7.676
														],
														[
															1.383,
															7.383
														],
														[
															1.625,
															7.015
														],
														[
															1.243,
															4.257
														],
														[
															1.445,
															4.207
														],
														[
															1.659,
															3.963
														],
														[
															1.884,
															3.524
														],
														[
															0.642,
															0.876
														],
														[
															0.725,
															0.825
														],
														[
															0.823,
															0.71
														],
														[
															0.936,
															0.53
														],
														[
															0.265,
															-1.768
														],
														[
															0.178,
															-1.348
														],
														[
															0.237,
															-1.021
														],
														[
															0.44,
															-0.787
														]
													],
													"v": [
														[
															365,
															685
														],
														[
															365.438,
															684.704
														],
														[
															365.96,
															684.441
														],
														[
															366.533,
															684.201
														],
														[
															367.123,
															683.975
														],
														[
															367.698,
															683.752
														],
														[
															368.225,
															683.521
														],
														[
															368.67,
															683.274
														],
														[
															369,
															683
														],
														[
															369.294,
															682.603
														],
														[
															369.536,
															682.147
														],
														[
															369.744,
															681.648
														],
														[
															369.941,
															681.119
														],
														[
															370.144,
															680.575
														],
														[
															370.376,
															680.031
														],
														[
															370.654,
															679.501
														],
														[
															371,
															679
														],
														[
															371.376,
															678.569
														],
														[
															371.775,
															678.167
														],
														[
															372.186,
															677.789
														],
														[
															372.597,
															677.426
														],
														[
															372.996,
															677.073
														],
														[
															373.371,
															676.722
														],
														[
															373.709,
															676.366
														],
														[
															374,
															676
														],
														[
															376.506,
															672.18
														],
														[
															378.482,
															668.65
														],
														[
															380.217,
															665.045
														],
														[
															382,
															661
														],
														[
															387.768,
															646.351
														],
														[
															392.813,
															630.865
														],
														[
															397.202,
															614.697
														],
														[
															401,
															598
														],
														[
															406.627,
															567.783
														],
														[
															411.017,
															537.422
														],
														[
															414.399,
															506.349
														],
														[
															417,
															474
														],
														[
															417.778,
															463.113
														],
														[
															418.579,
															452.121
														],
														[
															419.34,
															441.068
														],
														[
															420,
															430
														],
														[
															421.749,
															373.817
														],
														[
															421.262,
															317.919
														],
														[
															418.894,
															262.812
														],
														[
															415,
															209
														],
														[
															413.969,
															198.294
														],
														[
															412.757,
															187.716
														],
														[
															411.415,
															177.279
														],
														[
															410,
															167
														],
														[
															406.341,
															142.675
														],
														[
															401.906,
															117.803
														],
														[
															396.518,
															93.529
														],
														[
															390,
															71
														],
														[
															388.053,
															65.453
														],
														[
															386.002,
															59.996
														],
														[
															383.949,
															54.791
														],
														[
															382,
															50
														],
														[
															379.47,
															44.703
														],
														[
															376.514,
															39.871
														],
														[
															373.301,
															35.604
														],
														[
															370,
															32
														],
														[
															366.973,
															29.085
														],
														[
															364.232,
															27.147
														],
														[
															361.375,
															26.636
														],
														[
															358,
															28
														],
														[
															354.253,
															31.149
														],
														[
															351.018,
															35.037
														],
														[
															348.275,
															39.156
														],
														[
															346,
															43
														],
														[
															343.094,
															48.529
														],
														[
															340.5,
															54.334
														],
														[
															338.157,
															60.222
														],
														[
															336,
															66
														],
														[
															331.912,
															77.989
														],
														[
															328.198,
															90.637
														],
														[
															324.886,
															103.717
														],
														[
															322,
															117
														],
														[
															312.108,
															178.486
														],
														[
															305.985,
															242.774
														],
														[
															302.869,
															309.925
														],
														[
															302,
															380
														],
														[
															302.88,
															425.964
														],
														[
															305.348,
															471.108
														],
														[
															309.141,
															514.698
														],
														[
															314,
															556
														],
														[
															317.348,
															579.377
														],
														[
															321.197,
															601.983
														],
														[
															325.697,
															623.598
														],
														[
															331,
															644
														],
														[
															335.029,
															656.745
														],
														[
															339.683,
															669.049
														],
														[
															344.996,
															680.328
														],
														[
															351,
															690
														],
														[
															353.047,
															692.568
														],
														[
															355.366,
															694.887
														],
														[
															358.002,
															696.763
														],
														[
															361,
															698
														],
														[
															361.629,
															693.349
														],
														[
															362.215,
															689.818
														],
														[
															363.194,
															687.128
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 25,
											"s": [
												{
													"i": [
														[
															-0.333,
															0.712
														],
														[
															-0.176,
															0.29
														],
														[
															-0.208,
															0.292
														],
														[
															-0.228,
															0.294
														],
														[
															-0.238,
															0.294
														],
														[
															-0.236,
															0.294
														],
														[
															-0.224,
															0.293
														],
														[
															-0.2,
															0.29
														],
														[
															-0.166,
															0.287
														],
														[
															-0.927,
															1.996
														],
														[
															-0.806,
															2.125
														],
														[
															-0.704,
															2.231
														],
														[
															-0.619,
															2.313
														],
														[
															-0.552,
															2.372
														],
														[
															-0.503,
															2.406
														],
														[
															-0.472,
															2.418
														],
														[
															-0.458,
															2.405
														],
														[
															-0.539,
															3.291
														],
														[
															-0.477,
															3.359
														],
														[
															-0.426,
															3.421
														],
														[
															-0.386,
															3.476
														],
														[
															-0.358,
															3.524
														],
														[
															-0.341,
															3.566
														],
														[
															-0.335,
															3.602
														],
														[
															-0.341,
															3.631
														],
														[
															-0.989,
															14.343
														],
														[
															-0.686,
															14.785
														],
														[
															-0.384,
															15.08
														],
														[
															-0.082,
															15.227
														],
														[
															0.219,
															15.227
														],
														[
															0.52,
															15.078
														],
														[
															0.821,
															14.782
														],
														[
															1.121,
															14.338
														],
														[
															0.306,
															3.354
														],
														[
															0.351,
															3.42
														],
														[
															0.392,
															3.469
														],
														[
															0.429,
															3.502
														],
														[
															0.461,
															3.519
														],
														[
															0.488,
															3.519
														],
														[
															0.511,
															3.502
														],
														[
															0.529,
															3.469
														],
														[
															0.245,
															1.665
														],
														[
															0.249,
															1.695
														],
														[
															0.259,
															1.709
														],
														[
															0.275,
															1.707
														],
														[
															0.298,
															1.691
														],
														[
															0.326,
															1.659
														],
														[
															0.361,
															1.612
														],
														[
															0.402,
															1.55
														],
														[
															0.22,
															0.734
														],
														[
															0.241,
															0.722
														],
														[
															0.256,
															0.711
														],
														[
															0.265,
															0.703
														],
														[
															0.269,
															0.697
														],
														[
															0.267,
															0.692
														],
														[
															0.259,
															0.69
														],
														[
															0.245,
															0.689
														],
														[
															0.869,
															2.466
														],
														[
															1.115,
															2.125
														],
														[
															1.313,
															0.597
														],
														[
															1.463,
															-2.12
														],
														[
															1.35,
															-3.035
														],
														[
															1.086,
															-3.395
														],
														[
															0.818,
															-3.413
														],
														[
															0.547,
															-3.087
														],
														[
															0.179,
															-0.345
														],
														[
															0.218,
															-0.332
														],
														[
															0.18,
															-0.321
														],
														[
															0.064,
															-0.313
														],
														[
															0.444,
															-2.517
														],
														[
															0.4,
															-2.519
														],
														[
															0.382,
															-2.492
														],
														[
															0.387,
															-2.438
														],
														[
															1.607,
															-13.922
														],
														[
															1.132,
															-13.951
														],
														[
															0.835,
															-14.303
														],
														[
															0.713,
															-14.978
														],
														[
															0.16,
															-7.485
														],
														[
															0.037,
															-7.525
														],
														[
															-0.016,
															-7.527
														],
														[
															0,
															-7.492
														],
														[
															-0.307,
															-15.297
														],
														[
															-0.596,
															-14.944
														],
														[
															-0.866,
															-14.425
														],
														[
															-1.117,
															-13.739
														],
														[
															-0.783,
															-8.884
														],
														[
															-0.935,
															-8.665
														],
														[
															-1.184,
															-8.324
														],
														[
															-1.532,
															-7.86
														],
														[
															-0.407,
															-1.505
														],
														[
															-0.459,
															-1.503
														],
														[
															-0.447,
															-1.496
														],
														[
															-0.373,
															-1.486
														],
														[
															-0.736,
															-3.041
														],
														[
															-0.933,
															-2.911
														],
														[
															-1.355,
															-2.665
														],
														[
															-2.003,
															-2.301
														],
														[
															-0.111,
															0.767
														],
														[
															-0.13,
															0.753
														],
														[
															-0.204,
															0.735
														]
													],
													"o": [
														[
															0.134,
															-0.286
														],
														[
															0.176,
															-0.29
														],
														[
															0.208,
															-0.292
														],
														[
															0.228,
															-0.294
														],
														[
															0.238,
															-0.294
														],
														[
															0.236,
															-0.294
														],
														[
															0.224,
															-0.293
														],
														[
															0.2,
															-0.29
														],
														[
															1.065,
															-1.842
														],
														[
															0.927,
															-1.996
														],
														[
															0.806,
															-2.125
														],
														[
															0.704,
															-2.231
														],
														[
															0.619,
															-2.313
														],
														[
															0.552,
															-2.372
														],
														[
															0.503,
															-2.406
														],
														[
															0.472,
															-2.418
														],
														[
															0.613,
															-3.216
														],
														[
															0.539,
															-3.291
														],
														[
															0.477,
															-3.359
														],
														[
															0.426,
															-3.421
														],
														[
															0.386,
															-3.476
														],
														[
															0.358,
															-3.524
														],
														[
															0.341,
															-3.566
														],
														[
															0.335,
															-3.602
														],
														[
															1.292,
															-13.753
														],
														[
															0.989,
															-14.343
														],
														[
															0.686,
															-14.785
														],
														[
															0.384,
															-15.08
														],
														[
															0.082,
															-15.227
														],
														[
															-0.219,
															-15.227
														],
														[
															-0.52,
															-15.078
														],
														[
															-0.821,
															-14.782
														],
														[
															-0.256,
															-3.271
														],
														[
															-0.306,
															-3.354
														],
														[
															-0.351,
															-3.42
														],
														[
															-0.392,
															-3.469
														],
														[
															-0.429,
															-3.503
														],
														[
															-0.461,
															-3.519
														],
														[
															-0.488,
															-3.519
														],
														[
															-0.511,
															-3.502
														],
														[
															-0.247,
															-1.621
														],
														[
															-0.245,
															-1.665
														],
														[
															-0.249,
															-1.695
														],
														[
															-0.259,
															-1.709
														],
														[
															-0.275,
															-1.707
														],
														[
															-0.298,
															-1.691
														],
														[
															-0.326,
															-1.659
														],
														[
															-0.361,
															-1.612
														],
														[
															-0.194,
															-0.748
														],
														[
															-0.22,
															-0.734
														],
														[
															-0.241,
															-0.722
														],
														[
															-0.256,
															-0.711
														],
														[
															-0.265,
															-0.703
														],
														[
															-0.269,
															-0.697
														],
														[
															-0.267,
															-0.692
														],
														[
															-0.259,
															-0.69
														],
														[
															-0.575,
															-1.619
														],
														[
															-0.869,
															-2.466
														],
														[
															-1.115,
															-2.125
														],
														[
															-1.314,
															-0.597
														],
														[
															-1.61,
															2.332
														],
														[
															-1.35,
															3.035
														],
														[
															-1.086,
															3.395
														],
														[
															-0.818,
															3.413
														],
														[
															-0.064,
															0.36
														],
														[
															-0.179,
															0.345
														],
														[
															-0.218,
															0.332
														],
														[
															-0.18,
															0.321
														],
														[
															-0.511,
															2.488
														],
														[
															-0.444,
															2.517
														],
														[
															-0.4,
															2.519
														],
														[
															-0.382,
															2.492
														],
														[
															-2.257,
															14.216
														],
														[
															-1.607,
															13.922
														],
														[
															-1.132,
															13.951
														],
														[
															-0.835,
															14.303
														],
														[
															-0.353,
															7.408
														],
														[
															-0.16,
															7.485
														],
														[
															-0.037,
															7.525
														],
														[
															0.016,
															7.527
														],
														[
															0,
															15.484
														],
														[
															0.307,
															15.297
														],
														[
															0.596,
															14.944
														],
														[
															0.866,
															14.425
														],
														[
															0.73,
															8.979
														],
														[
															0.783,
															8.884
														],
														[
															0.935,
															8.665
														],
														[
															1.184,
															8.324
														],
														[
															0.293,
															1.505
														],
														[
															0.407,
															1.505
														],
														[
															0.459,
															1.502
														],
														[
															0.447,
															1.496
														],
														[
															0.766,
															3.053
														],
														[
															0.736,
															3.041
														],
														[
															0.933,
															2.911
														],
														[
															1.355,
															2.665
														],
														[
															0.149,
															-0.776
														],
														[
															0.111,
															-0.767
														],
														[
															0.13,
															-0.753
														],
														[
															0.203,
															-0.735
														]
													],
													"v": [
														[
															362,
															686
														],
														[
															362.468,
															685.136
														],
														[
															363.047,
															684.264
														],
														[
															363.703,
															683.385
														],
														[
															364.404,
															682.503
														],
														[
															365.118,
															681.62
														],
														[
															365.81,
															680.74
														],
														[
															366.448,
															679.866
														],
														[
															367,
															679
														],
														[
															369.983,
															673.237
														],
														[
															372.578,
															667.05
														],
														[
															374.839,
															660.51
														],
														[
															376.82,
															653.688
														],
														[
															378.572,
															646.655
														],
														[
															380.151,
															639.481
														],
														[
															381.609,
															632.24
														],
														[
															383,
															625
														],
														[
															384.726,
															615.237
														],
														[
															386.248,
															605.26
														],
														[
															387.6,
															595.089
														],
														[
															388.816,
															584.743
														],
														[
															389.93,
															574.241
														],
														[
															390.976,
															563.604
														],
														[
															391.988,
															552.85
														],
														[
															393,
															542
														],
														[
															396.422,
															499.819
														],
														[
															398.935,
															456.09
														],
														[
															400.541,
															411.254
														],
														[
															401.24,
															365.757
														],
														[
															401.035,
															320.039
														],
														[
															399.925,
															274.545
														],
														[
															397.913,
															229.718
														],
														[
															395,
															186
														],
														[
															394.157,
															176.059
														],
														[
															393.17,
															165.895
														],
														[
															392.053,
															155.558
														],
														[
															390.821,
															145.096
														],
														[
															389.485,
															134.559
														],
														[
															388.061,
															123.998
														],
														[
															386.561,
															113.462
														],
														[
															385,
															103
														],
														[
															384.263,
															98.067
														],
														[
															383.524,
															93.023
														],
														[
															382.763,
															87.914
														],
														[
															381.964,
															82.786
														],
														[
															381.106,
															77.685
														],
														[
															380.172,
															72.657
														],
														[
															379.142,
															67.746
														],
														[
															378,
															63
														],
														[
															377.377,
															60.777
														],
														[
															376.683,
															58.594
														],
														[
															375.936,
															56.444
														],
														[
															375.152,
															54.323
														],
														[
															374.35,
															52.224
														],
														[
															373.545,
															50.141
														],
														[
															372.756,
															48.068
														],
														[
															372,
															46
														],
														[
															369.822,
															39.576
														],
														[
															366.833,
															32.392
														],
														[
															363.177,
															28.013
														],
														[
															359,
															30
														],
														[
															354.56,
															38.136
														],
														[
															350.906,
															47.867
														],
														[
															348.049,
															58.165
														],
														[
															346,
															68
														],
														[
															345.616,
															69.057
														],
														[
															345.001,
															70.071
														],
														[
															344.385,
															71.05
														],
														[
															344,
															72
														],
														[
															342.574,
															79.515
														],
														[
															341.314,
															87.075
														],
														[
															340.147,
															94.598
														],
														[
															339,
															102
														],
														[
															333.248,
															144.127
														],
														[
															329.184,
															185.857
														],
														[
															326.278,
															228.158
														],
														[
															324,
															272
														],
														[
															323.248,
															294.35
														],
														[
															322.971,
															316.875
														],
														[
															322.958,
															339.462
														],
														[
															323,
															362
														],
														[
															323.465,
															408.213
														],
														[
															324.824,
															453.617
														],
														[
															327.021,
															497.712
														],
														[
															330,
															540
														],
														[
															332.245,
															566.825
														],
														[
															334.797,
															593.179
														],
														[
															337.951,
															618.694
														],
														[
															342,
															643
														],
														[
															343.067,
															647.516
														],
														[
															344.381,
															652.029
														],
														[
															345.755,
															656.527
														],
														[
															347,
															661
														],
														[
															349.197,
															670.17
														],
														[
															351.644,
															679.128
														],
														[
															355.019,
															687.521
														],
														[
															360,
															695
														],
														[
															360.376,
															692.684
														],
														[
															360.723,
															690.403
														],
														[
															361.209,
															688.171
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 26,
											"s": [
												{
													"i": [
														[
															0.255,
															-3.506
														],
														[
															0.352,
															-5.327
														],
														[
															0.322,
															-5.39
														],
														[
															0.293,
															-5.444
														],
														[
															0.265,
															-5.489
														],
														[
															0.237,
															-5.525
														],
														[
															0.21,
															-5.551
														],
														[
															0.184,
															-5.569
														],
														[
															0.158,
															-5.577
														],
														[
															0.134,
															-5.577
														],
														[
															0.11,
															-5.567
														],
														[
															0.086,
															-5.548
														],
														[
															0.064,
															-5.52
														],
														[
															0.042,
															-5.483
														],
														[
															0.02,
															-5.436
														],
														[
															0,
															-5.381
														],
														[
															-0.021,
															-6.525
														],
														[
															-0.045,
															-6.541
														],
														[
															-0.071,
															-6.547
														],
														[
															-0.1,
															-6.544
														],
														[
															-0.131,
															-6.532
														],
														[
															-0.165,
															-6.512
														],
														[
															-0.201,
															-6.482
														],
														[
															-0.24,
															-6.442
														],
														[
															-0.282,
															-6.394
														],
														[
															-0.326,
															-6.337
														],
														[
															-0.372,
															-6.27
														],
														[
															-0.422,
															-6.195
														],
														[
															-0.473,
															-6.11
														],
														[
															-0.527,
															-6.017
														],
														[
															-0.584,
															-5.914
														],
														[
															-0.08,
															-0.854
														],
														[
															-0.077,
															-0.85
														],
														[
															-0.077,
															-0.847
														],
														[
															-0.08,
															-0.843
														],
														[
															-0.085,
															-0.838
														],
														[
															-0.093,
															-0.833
														],
														[
															-0.103,
															-0.828
														],
														[
															-0.116,
															-0.823
														],
														[
															-0.132,
															-0.817
														],
														[
															-0.15,
															-0.811
														],
														[
															-0.17,
															-0.804
														],
														[
															-0.193,
															-0.797
														],
														[
															-0.219,
															-0.79
														],
														[
															-0.247,
															-0.782
														],
														[
															-0.278,
															-0.774
														],
														[
															-0.394,
															1.565
														],
														[
															-0.363,
															1.583
														],
														[
															-0.334,
															1.599
														],
														[
															-0.306,
															1.614
														],
														[
															-0.281,
															1.628
														],
														[
															-0.257,
															1.64
														],
														[
															-0.236,
															1.651
														],
														[
															-0.216,
															1.661
														],
														[
															-0.199,
															1.67
														],
														[
															-0.183,
															1.677
														],
														[
															-0.17,
															1.683
														],
														[
															-0.158,
															1.688
														],
														[
															-0.149,
															1.692
														],
														[
															-0.141,
															1.694
														],
														[
															-0.135,
															1.695
														],
														[
															-0.602,
															8.987
														],
														[
															-0.504,
															9.109
														],
														[
															-0.411,
															9.213
														],
														[
															-0.324,
															9.298
														],
														[
															-0.242,
															9.363
														],
														[
															-0.165,
															9.41
														],
														[
															-0.094,
															9.438
														],
														[
															-0.028,
															9.447
														],
														[
															0.032,
															9.436
														],
														[
															0.087,
															9.407
														],
														[
															0.137,
															9.359
														],
														[
															0.181,
															9.292
														],
														[
															0.22,
															9.206
														],
														[
															0.253,
															9.101
														],
														[
															0.282,
															8.977
														],
														[
															0.226,
															6.08
														],
														[
															0.275,
															6.038
														],
														[
															0.34,
															5.985
														],
														[
															0.421,
															5.922
														],
														[
															0.516,
															5.849
														],
														[
															0.627,
															5.765
														],
														[
															0.754,
															5.671
														],
														[
															0.896,
															5.566
														],
														[
															1.053,
															5.451
														],
														[
															0.01,
															0.074
														],
														[
															0.015,
															0.068
														],
														[
															0.023,
															0.06
														],
														[
															0.034,
															0.049
														],
														[
															0.048,
															0.035
														],
														[
															0.065,
															0.019
														],
														[
															0.084,
															-0.001
														],
														[
															0.106,
															-0.023
														],
														[
															0.659,
															-3.05
														],
														[
															0.539,
															-3.157
														],
														[
															0.44,
															-3.25
														],
														[
															0.361,
															-3.329
														],
														[
															0.303,
															-3.394
														],
														[
															0.267,
															-3.445
														],
														[
															0.251,
															-3.483
														]
													],
													"o": [
														[
															-0.383,
															5.255
														],
														[
															-0.352,
															5.327
														],
														[
															-0.322,
															5.39
														],
														[
															-0.293,
															5.444
														],
														[
															-0.265,
															5.489
														],
														[
															-0.237,
															5.525
														],
														[
															-0.21,
															5.551
														],
														[
															-0.184,
															5.569
														],
														[
															-0.158,
															5.577
														],
														[
															-0.134,
															5.577
														],
														[
															-0.11,
															5.567
														],
														[
															-0.086,
															5.548
														],
														[
															-0.064,
															5.52
														],
														[
															-0.042,
															5.483
														],
														[
															-0.02,
															5.436
														],
														[
															0,
															6.5
														],
														[
															0.021,
															6.525
														],
														[
															0.045,
															6.541
														],
														[
															0.071,
															6.547
														],
														[
															0.1,
															6.544
														],
														[
															0.131,
															6.532
														],
														[
															0.165,
															6.512
														],
														[
															0.201,
															6.482
														],
														[
															0.24,
															6.442
														],
														[
															0.282,
															6.394
														],
														[
															0.326,
															6.337
														],
														[
															0.372,
															6.27
														],
														[
															0.422,
															6.195
														],
														[
															0.473,
															6.11
														],
														[
															0.527,
															6.017
														],
														[
															0.085,
															0.857
														],
														[
															0.08,
															0.854
														],
														[
															0.077,
															0.85
														],
														[
															0.077,
															0.847
														],
														[
															0.08,
															0.843
														],
														[
															0.085,
															0.838
														],
														[
															0.093,
															0.833
														],
														[
															0.103,
															0.828
														],
														[
															0.116,
															0.823
														],
														[
															0.132,
															0.817
														],
														[
															0.15,
															0.811
														],
														[
															0.17,
															0.804
														],
														[
															0.193,
															0.797
														],
														[
															0.219,
															0.79
														],
														[
															0.247,
															0.782
														],
														[
															0.428,
															-1.547
														],
														[
															0.394,
															-1.565
														],
														[
															0.363,
															-1.583
														],
														[
															0.334,
															-1.599
														],
														[
															0.306,
															-1.614
														],
														[
															0.281,
															-1.628
														],
														[
															0.257,
															-1.64
														],
														[
															0.236,
															-1.651
														],
														[
															0.216,
															-1.661
														],
														[
															0.199,
															-1.67
														],
														[
															0.183,
															-1.677
														],
														[
															0.17,
															-1.683
														],
														[
															0.158,
															-1.688
														],
														[
															0.149,
															-1.692
														],
														[
															0.141,
															-1.694
														],
														[
															0.705,
															-8.845
														],
														[
															0.602,
															-8.987
														],
														[
															0.504,
															-9.109
														],
														[
															0.411,
															-9.213
														],
														[
															0.324,
															-9.298
														],
														[
															0.242,
															-9.363
														],
														[
															0.165,
															-9.41
														],
														[
															0.094,
															-9.438
														],
														[
															0.028,
															-9.447
														],
														[
															-0.032,
															-9.436
														],
														[
															-0.087,
															-9.407
														],
														[
															-0.137,
															-9.359
														],
														[
															-0.181,
															-9.292
														],
														[
															-0.22,
															-9.206
														],
														[
															-0.253,
															-9.101
														],
														[
															-0.192,
															-6.112
														],
														[
															-0.226,
															-6.08
														],
														[
															-0.275,
															-6.038
														],
														[
															-0.34,
															-5.985
														],
														[
															-0.421,
															-5.922
														],
														[
															-0.516,
															-5.849
														],
														[
															-0.627,
															-5.765
														],
														[
															-0.754,
															-5.671
														],
														[
															-0.896,
															-5.566
														],
														[
															-0.007,
															-0.076
														],
														[
															-0.01,
															-0.074
														],
														[
															-0.015,
															-0.068
														],
														[
															-0.023,
															-0.06
														],
														[
															-0.034,
															-0.049
														],
														[
															-0.048,
															-0.035
														],
														[
															-0.065,
															-0.019
														],
														[
															-0.084,
															0.001
														],
														[
															-0.8,
															2.929
														],
														[
															-0.659,
															3.05
														],
														[
															-0.539,
															3.157
														],
														[
															-0.44,
															3.25
														],
														[
															-0.361,
															3.329
														],
														[
															-0.303,
															3.394
														],
														[
															-0.267,
															3.445
														],
														[
															-0.251,
															3.483
														]
													],
													"v": [
														[
															352,
															113
														],
														[
															350.898,
															128.876
														],
														[
															349.887,
															144.955
														],
														[
															348.965,
															161.209
														],
														[
															348.128,
															177.611
														],
														[
															347.376,
															194.134
														],
														[
															346.705,
															210.751
														],
														[
															346.114,
															227.434
														],
														[
															345.601,
															244.156
														],
														[
															345.163,
															260.889
														],
														[
															344.799,
															277.606
														],
														[
															344.506,
															294.281
														],
														[
															344.281,
															310.884
														],
														[
															344.124,
															327.391
														],
														[
															344.031,
															343.771
														],
														[
															344,
															360
														],
														[
															344.031,
															379.54
														],
														[
															344.129,
															399.141
														],
														[
															344.303,
															418.774
														],
														[
															344.559,
															438.413
														],
														[
															344.905,
															458.031
														],
														[
															345.348,
															477.599
														],
														[
															345.897,
															497.091
														],
														[
															346.56,
															516.479
														],
														[
															347.342,
															535.736
														],
														[
															348.253,
															554.835
														],
														[
															349.3,
															573.749
														],
														[
															350.491,
															592.449
														],
														[
															351.833,
															610.909
														],
														[
															353.333,
															629.102
														],
														[
															355,
															647
														],
														[
															355.246,
															649.566
														],
														[
															355.48,
															652.123
														],
														[
															355.711,
															654.669
														],
														[
															355.946,
															657.203
														],
														[
															356.193,
															659.724
														],
														[
															356.46,
															662.232
														],
														[
															356.753,
															664.724
														],
														[
															357.081,
															667.2
														],
														[
															357.452,
															669.66
														],
														[
															357.873,
															672.101
														],
														[
															358.352,
															674.523
														],
														[
															358.897,
															676.925
														],
														[
															359.514,
															679.306
														],
														[
															360.213,
															681.665
														],
														[
															361,
															684
														],
														[
															362.233,
															679.331
														],
														[
															363.369,
															674.609
														],
														[
															364.413,
															669.836
														],
														[
															365.373,
															665.016
														],
														[
															366.253,
															660.153
														],
														[
															367.06,
															655.251
														],
														[
															367.8,
															650.314
														],
														[
															368.478,
															645.346
														],
														[
															369.1,
															640.349
														],
														[
															369.673,
															635.329
														],
														[
															370.202,
															630.288
														],
														[
															370.693,
															625.232
														],
														[
															371.153,
															620.162
														],
														[
															371.586,
															615.084
														],
														[
															372,
															610
														],
														[
															373.96,
															583.248
														],
														[
															375.617,
															556.099
														],
														[
															376.989,
															528.611
														],
														[
															378.09,
															500.84
														],
														[
															378.938,
															472.844
														],
														[
															379.548,
															444.679
														],
														[
															379.936,
															416.402
														],
														[
															380.119,
															388.071
														],
														[
															380.112,
															359.742
														],
														[
															379.932,
															331.471
														],
														[
															379.596,
															303.317
														],
														[
															379.118,
															275.336
														],
														[
															378.515,
															247.585
														],
														[
															377.804,
															220.12
														],
														[
															377,
															193
														],
														[
															376.378,
															174.71
														],
														[
															375.63,
															156.53
														],
														[
															374.71,
															138.493
														],
														[
															373.572,
															120.628
														],
														[
															372.17,
															102.969
														],
														[
															370.458,
															85.545
														],
														[
															368.39,
															68.388
														],
														[
															365.919,
															51.529
														],
														[
															363,
															35
														],
														[
															362.976,
															34.774
														],
														[
															362.939,
															34.561
														],
														[
															362.883,
															34.367
														],
														[
															362.798,
															34.202
														],
														[
															362.675,
															34.075
														],
														[
															362.507,
															33.993
														],
														[
															362.285,
															33.965
														],
														[
															362,
															34
														],
														[
															359.817,
															42.971
														],
														[
															358.025,
															52.284
														],
														[
															356.562,
															61.897
														],
														[
															355.366,
															71.767
														],
														[
															354.374,
															81.855
														],
														[
															353.524,
															92.117
														],
														[
															352.753,
															102.513
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 28,
											"s": [
												{
													"i": [
														[
															0.246,
															-3.454
														],
														[
															0.142,
															-2.185
														],
														[
															0.131,
															-2.196
														],
														[
															0.121,
															-2.206
														],
														[
															0.113,
															-2.214
														],
														[
															0.107,
															-2.222
														],
														[
															0.102,
															-2.229
														],
														[
															0.098,
															-2.234
														],
														[
															0.097,
															-2.239
														],
														[
															0.096,
															-2.242
														],
														[
															0.097,
															-2.244
														],
														[
															0.1,
															-2.246
														],
														[
															0.105,
															-2.246
														],
														[
															0.085,
															-3.435
														],
														[
															0.031,
															-3.453
														],
														[
															-0.001,
															-3.466
														],
														[
															-0.013,
															-3.473
														],
														[
															-0.005,
															-3.475
														],
														[
															0.025,
															-3.471
														],
														[
															0.075,
															-3.462
														],
														[
															0.145,
															-3.447
														],
														[
															0.108,
															-3.493
														],
														[
															0.075,
															-3.478
														],
														[
															0.047,
															-3.465
														],
														[
															0.026,
															-3.454
														],
														[
															0.01,
															-3.444
														],
														[
															0.001,
															-3.436
														],
														[
															-0.003,
															-3.43
														],
														[
															0,
															-3.425
														],
														[
															-0.062,
															-12.034
														],
														[
															-0.143,
															-12.006
														],
														[
															-0.244,
															-11.942
														],
														[
															-0.364,
															-11.844
														],
														[
															-0.504,
															-11.71
														],
														[
															-0.664,
															-11.541
														],
														[
															-0.844,
															-11.337
														],
														[
															-1.043,
															-11.098
														],
														[
															-0.138,
															-1.527
														],
														[
															-0.148,
															-1.53
														],
														[
															-0.173,
															-1.527
														],
														[
															-0.211,
															-1.517
														],
														[
															-0.265,
															-1.501
														],
														[
															-0.333,
															-1.478
														],
														[
															-0.415,
															-1.449
														],
														[
															-0.512,
															-1.413
														],
														[
															-0.722,
															6.364
														],
														[
															-0.588,
															6.432
														],
														[
															-0.478,
															6.495
														],
														[
															-0.393,
															6.553
														],
														[
															-0.333,
															6.608
														],
														[
															-0.296,
															6.657
														],
														[
															-0.284,
															6.703
														],
														[
															-0.297,
															6.744
														],
														[
															-0.08,
															3.344
														],
														[
															-0.032,
															3.36
														],
														[
															-0.003,
															3.373
														],
														[
															0.008,
															3.383
														],
														[
															0,
															3.39
														],
														[
															-0.027,
															3.394
														],
														[
															-0.072,
															3.395
														],
														[
															-0.135,
															3.393
														],
														[
															-0.101,
															3.369
														],
														[
															-0.072,
															3.367
														],
														[
															-0.048,
															3.367
														],
														[
															-0.029,
															3.37
														],
														[
															-0.015,
															3.374
														],
														[
															-0.005,
															3.38
														],
														[
															0,
															3.388
														],
														[
															0,
															3.399
														],
														[
															0.033,
															10.395
														],
														[
															0.079,
															10.392
														],
														[
															0.139,
															10.366
														],
														[
															0.213,
															10.315
														],
														[
															0.301,
															10.239
														],
														[
															0.402,
															10.14
														],
														[
															0.518,
															10.016
														],
														[
															0.647,
															9.868
														],
														[
															0.235,
															3.262
														],
														[
															0.26,
															3.249
														],
														[
															0.289,
															3.234
														],
														[
															0.322,
															3.216
														],
														[
															0.36,
															3.195
														],
														[
															0.401,
															3.171
														],
														[
															0.447,
															3.145
														],
														[
															0.496,
															3.116
														],
														[
															0.01,
															0.074
														],
														[
															0.015,
															0.068
														],
														[
															0.023,
															0.06
														],
														[
															0.034,
															0.049
														],
														[
															0.048,
															0.035
														],
														[
															0.065,
															0.019
														],
														[
															0.084,
															-0.001
														],
														[
															0.106,
															-0.023
														],
														[
															0.47,
															-3.219
														],
														[
															0.401,
															-3.227
														],
														[
															0.345,
															-3.244
														],
														[
															0.301,
															-3.269
														],
														[
															0.269,
															-3.303
														],
														[
															0.249,
															-3.345
														],
														[
															0.241,
															-3.395
														]
													],
													"o": [
														[
															-0.155,
															2.173
														],
														[
															-0.142,
															2.185
														],
														[
															-0.131,
															2.196
														],
														[
															-0.121,
															2.206
														],
														[
															-0.113,
															2.214
														],
														[
															-0.107,
															2.222
														],
														[
															-0.102,
															2.229
														],
														[
															-0.098,
															2.234
														],
														[
															-0.097,
															2.239
														],
														[
															-0.096,
															2.242
														],
														[
															-0.097,
															2.244
														],
														[
															-0.1,
															2.246
														],
														[
															-0.159,
															3.411
														],
														[
															-0.085,
															3.435
														],
														[
															-0.031,
															3.453
														],
														[
															0.001,
															3.466
														],
														[
															0.013,
															3.473
														],
														[
															0.005,
															3.475
														],
														[
															-0.025,
															3.471
														],
														[
															-0.075,
															3.462
														],
														[
															-0.148,
															3.509
														],
														[
															-0.108,
															3.493
														],
														[
															-0.075,
															3.478
														],
														[
															-0.047,
															3.465
														],
														[
															-0.026,
															3.454
														],
														[
															-0.01,
															3.444
														],
														[
															-0.001,
															3.436
														],
														[
															0.003,
															3.43
														],
														[
															0,
															12.027
														],
														[
															0.062,
															12.034
														],
														[
															0.143,
															12.006
														],
														[
															0.244,
															11.942
														],
														[
															0.364,
															11.844
														],
														[
															0.504,
															11.71
														],
														[
															0.664,
															11.541
														],
														[
															0.844,
															11.337
														],
														[
															0.143,
															1.517
														],
														[
															0.138,
															1.527
														],
														[
															0.148,
															1.53
														],
														[
															0.173,
															1.527
														],
														[
															0.211,
															1.517
														],
														[
															0.265,
															1.501
														],
														[
															0.333,
															1.478
														],
														[
															0.415,
															1.449
														],
														[
															0.88,
															-6.293
														],
														[
															0.722,
															-6.364
														],
														[
															0.588,
															-6.432
														],
														[
															0.478,
															-6.495
														],
														[
															0.393,
															-6.553
														],
														[
															0.333,
															-6.608
														],
														[
															0.296,
															-6.657
														],
														[
															0.284,
															-6.703
														],
														[
															0.146,
															-3.326
														],
														[
															0.08,
															-3.344
														],
														[
															0.032,
															-3.36
														],
														[
															0.003,
															-3.373
														],
														[
															-0.008,
															-3.383
														],
														[
															0,
															-3.39
														],
														[
															0.027,
															-3.394
														],
														[
															0.072,
															-3.395
														],
														[
															0.134,
															-3.373
														],
														[
															0.101,
															-3.369
														],
														[
															0.072,
															-3.367
														],
														[
															0.048,
															-3.367
														],
														[
															0.029,
															-3.37
														],
														[
															0.015,
															-3.374
														],
														[
															0.005,
															-3.38
														],
														[
															0,
															-3.388
														],
														[
															0,
															-10.373
														],
														[
															-0.033,
															-10.395
														],
														[
															-0.079,
															-10.392
														],
														[
															-0.139,
															-10.366
														],
														[
															-0.213,
															-10.315
														],
														[
															-0.301,
															-10.239
														],
														[
															-0.402,
															-10.14
														],
														[
															-0.518,
															-10.016
														],
														[
															-0.214,
															-3.272
														],
														[
															-0.235,
															-3.262
														],
														[
															-0.26,
															-3.249
														],
														[
															-0.289,
															-3.234
														],
														[
															-0.322,
															-3.216
														],
														[
															-0.36,
															-3.195
														],
														[
															-0.401,
															-3.171
														],
														[
															-0.447,
															-3.145
														],
														[
															-0.007,
															-0.076
														],
														[
															-0.01,
															-0.074
														],
														[
															-0.015,
															-0.068
														],
														[
															-0.023,
															-0.06
														],
														[
															-0.034,
															-0.049
														],
														[
															-0.048,
															-0.035
														],
														[
															-0.065,
															-0.019
														],
														[
															-0.084,
															0.001
														],
														[
															-0.551,
															3.219
														],
														[
															-0.47,
															3.219
														],
														[
															-0.401,
															3.227
														],
														[
															-0.345,
															3.244
														],
														[
															-0.301,
															3.269
														],
														[
															-0.269,
															3.303
														],
														[
															-0.249,
															3.345
														],
														[
															-0.241,
															3.395
														]
													],
													"v": [
														[
															354,
															116
														],
														[
															353.555,
															122.536
														],
														[
															353.146,
															129.107
														],
														[
															352.768,
															135.709
														],
														[
															352.416,
															142.34
														],
														[
															352.086,
															148.995
														],
														[
															351.774,
															155.671
														],
														[
															351.474,
															162.366
														],
														[
															351.181,
															169.076
														],
														[
															350.893,
															175.798
														],
														[
															350.603,
															182.528
														],
														[
															350.307,
															189.263
														],
														[
															350,
															196
														],
														[
															349.64,
															206.27
														],
														[
															349.472,
															216.603
														],
														[
															349.432,
															226.982
														],
														[
															349.46,
															237.392
														],
														[
															349.492,
															247.815
														],
														[
															349.468,
															258.235
														],
														[
															349.325,
															268.635
														],
														[
															349,
															279
														],
														[
															348.617,
															289.503
														],
														[
															348.345,
															299.959
														],
														[
															348.164,
															310.374
														],
														[
															348.056,
															320.753
														],
														[
															348.004,
															331.1
														],
														[
															347.99,
															341.42
														],
														[
															347.994,
															351.719
														],
														[
															348,
															362
														],
														[
															348.087,
															398.101
														],
														[
															348.389,
															434.17
														],
														[
															348.964,
															470.101
														],
														[
															349.871,
															505.789
														],
														[
															351.17,
															541.129
														],
														[
															352.918,
															576.014
														],
														[
															355.175,
															610.339
														],
														[
															358,
															644
														],
														[
															358.418,
															648.568
														],
														[
															358.843,
															653.156
														],
														[
															359.321,
															657.744
														],
														[
															359.893,
															662.312
														],
														[
															360.604,
															666.841
														],
														[
															361.496,
															671.312
														],
														[
															362.614,
															675.705
														],
														[
															364,
															680
														],
														[
															366.397,
															661.014
														],
														[
															368.356,
															641.819
														],
														[
															369.949,
															622.428
														],
														[
															371.251,
															602.855
														],
														[
															372.334,
															583.112
														],
														[
															373.271,
															563.214
														],
														[
															374.135,
															543.172
														],
														[
															375,
															523
														],
														[
															375.335,
															512.995
														],
														[
															375.498,
															502.937
														],
														[
															375.545,
															492.837
														],
														[
															375.533,
															482.702
														],
														[
															375.517,
															472.543
														],
														[
															375.552,
															462.366
														],
														[
															375.694,
															452.183
														],
														[
															376,
															442
														],
														[
															376.352,
															431.887
														],
														[
															376.61,
															421.783
														],
														[
															376.789,
															411.682
														],
														[
															376.903,
															401.577
														],
														[
															376.967,
															391.462
														],
														[
															376.995,
															381.332
														],
														[
															377.001,
															371.18
														],
														[
															377,
															361
														],
														[
															376.954,
															329.842
														],
														[
															376.79,
															298.655
														],
														[
															376.466,
															267.511
														],
														[
															375.94,
															236.485
														],
														[
															375.172,
															205.648
														],
														[
															374.12,
															175.073
														],
														[
															372.743,
															144.833
														],
														[
															371,
															115
														],
														[
															370.327,
															105.199
														],
														[
															369.585,
															95.433
														],
														[
															368.762,
															85.708
														],
														[
															367.846,
															76.033
														],
														[
															366.825,
															66.417
														],
														[
															365.685,
															56.868
														],
														[
															364.414,
															47.392
														],
														[
															363,
															38
														],
														[
															362.976,
															37.774
														],
														[
															362.939,
															37.561
														],
														[
															362.883,
															37.367
														],
														[
															362.798,
															37.202
														],
														[
															362.675,
															37.075
														],
														[
															362.507,
															36.993
														],
														[
															362.285,
															36.965
														],
														[
															362,
															37
														],
														[
															360.47,
															46.654
														],
														[
															359.166,
															56.321
														],
														[
															358.049,
															66.026
														],
														[
															357.084,
															75.795
														],
														[
															356.233,
															85.651
														],
														[
															355.46,
															95.621
														],
														[
															354.728,
															105.729
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 29,
											"s": [
												{
													"i": [
														[
															-0.998,
															14.478
														],
														[
															-0.859,
															17.061
														],
														[
															-0.558,
															17.598
														],
														[
															-0.221,
															17.892
														],
														[
															0.152,
															17.942
														],
														[
															0.563,
															17.748
														],
														[
															1.01,
															17.31
														],
														[
															1.493,
															16.629
														],
														[
															2.013,
															15.703
														],
														[
															0.228,
															1.728
														],
														[
															0.23,
															1.691
														],
														[
															0.236,
															1.663
														],
														[
															0.243,
															1.643
														],
														[
															0.254,
															1.633
														],
														[
															0.266,
															1.631
														],
														[
															0.281,
															1.638
														],
														[
															0.299,
															1.653
														],
														[
															0.444,
															2.436
														],
														[
															0.482,
															2.468
														],
														[
															0.54,
															2.442
														],
														[
															0.616,
															2.36
														],
														[
															0.711,
															2.221
														],
														[
															0.826,
															2.025
														],
														[
															0.959,
															1.772
														],
														[
															1.112,
															1.462
														],
														[
															0.206,
															0.085
														],
														[
															0.24,
															-0.012
														],
														[
															0.256,
															-0.087
														],
														[
															0.255,
															-0.141
														],
														[
															0.236,
															-0.173
														],
														[
															0.2,
															-0.183
														],
														[
															0.146,
															-0.173
														],
														[
															0.075,
															-0.14
														],
														[
															0.978,
															-2.384
														],
														[
															0.85,
															-2.627
														],
														[
															0.742,
															-2.836
														],
														[
															0.654,
															-3.009
														],
														[
															0.587,
															-3.148
														],
														[
															0.54,
															-3.252
														],
														[
															0.514,
															-3.322
														],
														[
															0.508,
															-3.356
														],
														[
															0.466,
															-3.271
														],
														[
															0.442,
															-3.298
														],
														[
															0.414,
															-3.308
														],
														[
															0.383,
															-3.299
														],
														[
															0.349,
															-3.272
														],
														[
															0.312,
															-3.226
														],
														[
															0.272,
															-3.163
														],
														[
															0.229,
															-3.081
														],
														[
															0.443,
															-6.891
														],
														[
															0.377,
															-6.923
														],
														[
															0.312,
															-6.964
														],
														[
															0.247,
															-7.016
														],
														[
															0.184,
															-7.077
														],
														[
															0.122,
															-7.148
														],
														[
															0.06,
															-7.228
														],
														[
															0,
															-7.319
														],
														[
															-0.102,
															-10.781
														],
														[
															-0.22,
															-10.704
														],
														[
															-0.353,
															-10.589
														],
														[
															-0.501,
															-10.435
														],
														[
															-0.664,
															-10.243
														],
														[
															-0.843,
															-10.014
														],
														[
															-1.037,
															-9.746
														],
														[
															-1.246,
															-9.44
														],
														[
															-0.466,
															-3.662
														],
														[
															-0.477,
															-3.601
														],
														[
															-0.523,
															-3.514
														],
														[
															-0.602,
															-3.399
														],
														[
															-0.178,
															-0.345
														],
														[
															-0.213,
															-0.308
														],
														[
															-0.178,
															-0.309
														],
														[
															-0.075,
															-0.348
														],
														[
															0.006,
															-0.418
														],
														[
															0.039,
															-0.425
														],
														[
															0.013,
															-0.42
														],
														[
															-0.071,
															-0.402
														],
														[
															-0.172,
															-0.328
														],
														[
															-0.216,
															-0.342
														],
														[
															-0.186,
															-0.343
														],
														[
															-0.081,
															-0.331
														],
														[
															-0.542,
															-2.197
														],
														[
															-0.561,
															-2.051
														],
														[
															-0.614,
															-1.828
														],
														[
															-0.7,
															-1.53
														],
														[
															-0.254,
															-0.514
														],
														[
															-0.261,
															-0.509
														],
														[
															-0.252,
															-0.491
														],
														[
															-0.227,
															-0.458
														],
														[
															-0.356,
															-0.401
														],
														[
															-0.392,
															-0.383
														],
														[
															-0.34,
															-0.415
														],
														[
															-0.2,
															-0.498
														],
														[
															0.066,
															-0.676
														],
														[
															0.042,
															-0.667
														],
														[
															-0.295,
															-0.532
														],
														[
															-0.945,
															-0.272
														],
														[
															-2.94,
															12.219
														],
														[
															-1.914,
															13.306
														],
														[
															-1.267,
															14.059
														]
													],
													"o": [
														[
															1.123,
															-16.28
														],
														[
															0.859,
															-17.061
														],
														[
															0.558,
															-17.598
														],
														[
															0.221,
															-17.892
														],
														[
															-0.152,
															-17.942
														],
														[
															-0.563,
															-17.748
														],
														[
															-1.01,
															-17.31
														],
														[
															-1.493,
															-16.629
														],
														[
															-0.227,
															-1.773
														],
														[
															-0.228,
															-1.728
														],
														[
															-0.23,
															-1.691
														],
														[
															-0.236,
															-1.663
														],
														[
															-0.243,
															-1.643
														],
														[
															-0.254,
															-1.633
														],
														[
															-0.266,
															-1.631
														],
														[
															-0.281,
															-1.638
														],
														[
															-0.424,
															-2.347
														],
														[
															-0.444,
															-2.436
														],
														[
															-0.482,
															-2.468
														],
														[
															-0.54,
															-2.442
														],
														[
															-0.616,
															-2.36
														],
														[
															-0.711,
															-2.221
														],
														[
															-0.826,
															-2.025
														],
														[
															-0.959,
															-1.772
														],
														[
															-0.154,
															-0.203
														],
														[
															-0.206,
															-0.085
														],
														[
															-0.24,
															0.012
														],
														[
															-0.256,
															0.087
														],
														[
															-0.255,
															0.141
														],
														[
															-0.236,
															0.173
														],
														[
															-0.2,
															0.183
														],
														[
															-0.146,
															0.173
														],
														[
															-1.127,
															2.106
														],
														[
															-0.978,
															2.384
														],
														[
															-0.85,
															2.627
														],
														[
															-0.742,
															2.836
														],
														[
															-0.654,
															3.009
														],
														[
															-0.587,
															3.148
														],
														[
															-0.54,
															3.252
														],
														[
															-0.514,
															3.322
														],
														[
															-0.488,
															3.225
														],
														[
															-0.466,
															3.271
														],
														[
															-0.442,
															3.298
														],
														[
															-0.414,
															3.308
														],
														[
															-0.383,
															3.299
														],
														[
															-0.349,
															3.272
														],
														[
															-0.312,
															3.226
														],
														[
															-0.272,
															3.163
														],
														[
															-0.51,
															6.869
														],
														[
															-0.443,
															6.891
														],
														[
															-0.377,
															6.923
														],
														[
															-0.312,
															6.964
														],
														[
															-0.247,
															7.016
														],
														[
															-0.184,
															7.077
														],
														[
															-0.122,
															7.148
														],
														[
															-0.06,
															7.228
														],
														[
															0,
															10.82
														],
														[
															0.102,
															10.781
														],
														[
															0.22,
															10.704
														],
														[
															0.353,
															10.589
														],
														[
															0.501,
															10.435
														],
														[
															0.664,
															10.243
														],
														[
															0.843,
															10.014
														],
														[
															1.037,
															9.746
														],
														[
															0.488,
															3.696
														],
														[
															0.466,
															3.662
														],
														[
															0.477,
															3.601
														],
														[
															0.523,
															3.514
														],
														[
															0.075,
															0.42
														],
														[
															0.178,
															0.345
														],
														[
															0.213,
															0.308
														],
														[
															0.178,
															0.309
														],
														[
															0.086,
															0.399
														],
														[
															-0.006,
															0.418
														],
														[
															-0.039,
															0.425
														],
														[
															-0.013,
															0.42
														],
														[
															0.053,
															0.299
														],
														[
															0.172,
															0.328
														],
														[
															0.216,
															0.342
														],
														[
															0.186,
															0.343
														],
														[
															0.556,
															2.267
														],
														[
															0.542,
															2.197
														],
														[
															0.561,
															2.051
														],
														[
															0.614,
															1.828
														],
														[
															0.231,
															0.504
														],
														[
															0.254,
															0.514
														],
														[
															0.261,
															0.509
														],
														[
															0.252,
															0.491
														],
														[
															0.233,
															0.47
														],
														[
															0.356,
															0.401
														],
														[
															0.392,
															0.383
														],
														[
															0.34,
															0.415
														],
														[
															0.224,
															0.56
														],
														[
															-0.066,
															0.676
														],
														[
															-0.042,
															0.667
														],
														[
															0.295,
															0.532
														],
														[
															4.344,
															-10.798
														],
														[
															2.94,
															-12.219
														],
														[
															1.914,
															-13.306
														],
														[
															1.267,
															-14.059
														]
													],
													"v": [
														[
															392,
															537
														],
														[
															394.981,
															486.928
														],
														[
															397.116,
															434.878
														],
														[
															398.295,
															381.582
														],
														[
															398.407,
															327.771
														],
														[
															397.344,
															274.176
														],
														[
															394.995,
															221.528
														],
														[
															391.25,
															170.559
														],
														[
															386,
															122
														],
														[
															385.318,
															116.75
														],
														[
															384.631,
															111.624
														],
														[
															383.933,
															106.596
														],
														[
															383.214,
															101.639
														],
														[
															382.47,
															96.727
														],
														[
															381.69,
															91.835
														],
														[
															380.87,
															86.934
														],
														[
															380,
															82
														],
														[
															378.703,
															74.811
														],
														[
															377.319,
															67.442
														],
														[
															375.791,
															60.063
														],
														[
															374.062,
															52.845
														],
														[
															372.076,
															45.959
														],
														[
															369.775,
															39.576
														],
														[
															367.102,
															33.866
														],
														[
															364,
															29
														],
														[
															363.455,
															28.574
														],
														[
															362.783,
															28.47
														],
														[
															362.034,
															28.624
														],
														[
															361.262,
															28.971
														],
														[
															360.52,
															29.447
														],
														[
															359.861,
															29.986
														],
														[
															359.336,
															30.526
														],
														[
															359,
															31
														],
														[
															355.848,
															37.745
														],
														[
															353.112,
															45.271
														],
														[
															350.731,
															53.474
														],
														[
															348.643,
															62.251
														],
														[
															346.787,
															71.496
														],
														[
															345.102,
															81.105
														],
														[
															343.526,
															90.975
														],
														[
															342,
															101
														],
														[
															340.568,
															110.747
														],
														[
															339.206,
															120.605
														],
														[
															337.921,
															130.518
														],
														[
															336.724,
															140.432
														],
														[
															335.624,
															150.291
														],
														[
															334.631,
															160.043
														],
														[
															333.753,
															169.63
														],
														[
															333,
															179
														],
														[
															331.57,
															199.637
														],
														[
															330.34,
															220.354
														],
														[
															329.307,
															241.182
														],
														[
															328.469,
															262.149
														],
														[
															327.822,
															283.285
														],
														[
															327.363,
															304.62
														],
														[
															327.09,
															326.182
														],
														[
															327,
															348
														],
														[
															327.15,
															380.411
														],
														[
															327.629,
															412.648
														],
														[
															328.484,
															444.597
														],
														[
															329.761,
															476.141
														],
														[
															331.504,
															507.169
														],
														[
															333.762,
															537.564
														],
														[
															336.578,
															567.212
														],
														[
															340,
															596
														],
														[
															341.422,
															607.043
														],
														[
															342.828,
															617.945
														],
														[
															344.32,
															628.625
														],
														[
															346,
															639
														],
														[
															346.396,
															640.138
														],
														[
															347,
															641.108
														],
														[
															347.603,
															642.024
														],
														[
															348,
															643
														],
														[
															348.105,
															644.228
														],
														[
															348.022,
															645.495
														],
														[
															347.928,
															646.765
														],
														[
															348,
															648
														],
														[
															348.356,
															648.944
														],
														[
															348.958,
															649.953
														],
														[
															349.581,
															650.985
														],
														[
															350,
															652
														],
														[
															351.638,
															658.716
														],
														[
															353.283,
															665.107
														],
														[
															355.037,
															670.944
														],
														[
															357,
															676
														],
														[
															357.73,
															677.53
														],
														[
															358.506,
															679.069
														],
														[
															359.278,
															680.573
														],
														[
															360,
															682
														],
														[
															360.905,
															683.294
														],
														[
															362.049,
															684.458
														],
														[
															363.169,
															685.643
														],
														[
															364,
															687
														],
														[
															364.159,
															688.886
														],
														[
															363.919,
															690.932
														],
														[
															364.219,
															692.762
														],
														[
															366,
															694
														],
														[
															376.832,
															659.39
														],
														[
															384.019,
															621.019
														],
														[
															388.697,
															579.889
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 30,
											"s": [
												{
													"i": [
														[
															-1.553,
															6.338
														],
														[
															-0.733,
															3.333
														],
														[
															-0.672,
															3.399
														],
														[
															-0.617,
															3.46
														],
														[
															-0.568,
															3.514
														],
														[
															-0.524,
															3.564
														],
														[
															-0.487,
															3.608
														],
														[
															-0.455,
															3.647
														],
														[
															-0.43,
															3.68
														],
														[
															-0.726,
															7.268
														],
														[
															-0.624,
															7.441
														],
														[
															-0.521,
															7.6
														],
														[
															-0.418,
															7.745
														],
														[
															-0.314,
															7.877
														],
														[
															-0.21,
															7.994
														],
														[
															-0.105,
															8.098
														],
														[
															0,
															8.188
														],
														[
															0.171,
															12.004
														],
														[
															0.378,
															11.775
														],
														[
															0.622,
															11.526
														],
														[
															0.903,
															11.259
														],
														[
															1.22,
															10.972
														],
														[
															1.573,
															10.667
														],
														[
															1.963,
															10.343
														],
														[
															2.389,
															10.001
														],
														[
															0.381,
															1.472
														],
														[
															0.415,
															1.519
														],
														[
															0.438,
															1.538
														],
														[
															0.449,
															1.531
														],
														[
															0.447,
															1.496
														],
														[
															0.434,
															1.434
														],
														[
															0.409,
															1.345
														],
														[
															0.371,
															1.229
														],
														[
															0.177,
															0.165
														],
														[
															0.231,
															0.195
														],
														[
															0.188,
															0.182
														],
														[
															0.049,
															0.127
														],
														[
															0.223,
															0.741
														],
														[
															0.217,
															0.759
														],
														[
															0.261,
															0.764
														],
														[
															0.354,
															0.755
														],
														[
															0.595,
															1.003
														],
														[
															0.618,
															0.907
														],
														[
															0.588,
															0.826
														],
														[
															0.507,
															0.758
														],
														[
															0.549,
															0.781
														],
														[
															0.554,
															0.673
														],
														[
															0.603,
															0.555
														],
														[
															0.696,
															0.428
														],
														[
															0.605,
															0.238
														],
														[
															0.402,
															-0.125
														],
														[
															0.471,
															-0.426
														],
														[
															0.811,
															-0.663
														],
														[
															0.175,
															0.01
														],
														[
															0.2,
															0.041
														],
														[
															0.175,
															0.01
														],
														[
															0.099,
															-0.082
														],
														[
															0.757,
															-0.942
														],
														[
															0.774,
															-1.169
														],
														[
															0.755,
															-1.268
														],
														[
															0.701,
															-1.239
														],
														[
															0.617,
															-1.291
														],
														[
															0.562,
															-1.335
														],
														[
															0.539,
															-1.377
														],
														[
															0.547,
															-1.416
														],
														[
															2.485,
															-9.261
														],
														[
															1.899,
															-9.768
														],
														[
															1.465,
															-9.873
														],
														[
															1.183,
															-9.575
														],
														[
															1.57,
															-21.457
														],
														[
															0.707,
															-22.178
														],
														[
															-0.092,
															-22.382
														],
														[
															-0.827,
															-22.068
														],
														[
															-0.229,
															-3.635
														],
														[
															-0.278,
															-3.59
														],
														[
															-0.285,
															-3.535
														],
														[
															-0.249,
															-3.471
														],
														[
															-0.927,
															-10.551
														],
														[
															-1.17,
															-10.107
														],
														[
															-1.533,
															-9.877
														],
														[
															-2.017,
															-9.862
														],
														[
															-1.986,
															-7.8
														],
														[
															-2.462,
															-7.082
														],
														[
															-3.12,
															-6.116
														],
														[
															-3.96,
															-4.901
														],
														[
															-0.252,
															-0.167
														],
														[
															-0.284,
															-0.15
														],
														[
															-0.265,
															-0.158
														],
														[
															-0.196,
															-0.19
														],
														[
															-0.197,
															-0.281
														],
														[
															-0.068,
															-0.242
														],
														[
															-0.087,
															-0.34
														],
														[
															-0.254,
															-0.575
														],
														[
															-0.115,
															-0.775
														],
														[
															-0.099,
															-0.745
														],
														[
															-0.309,
															-0.722
														],
														[
															-0.746,
															-0.707
														],
														[
															-3.143,
															5.06
														],
														[
															-2.274,
															5.778
														],
														[
															-1.744,
															6.203
														]
													],
													"o": [
														[
															0.8,
															-3.262
														],
														[
															0.733,
															-3.333
														],
														[
															0.672,
															-3.399
														],
														[
															0.617,
															-3.46
														],
														[
															0.568,
															-3.514
														],
														[
															0.524,
															-3.564
														],
														[
															0.487,
															-3.608
														],
														[
															0.455,
															-3.647
														],
														[
															0.827,
															-7.081
														],
														[
															0.726,
															-7.268
														],
														[
															0.624,
															-7.441
														],
														[
															0.521,
															-7.6
														],
														[
															0.418,
															-7.745
														],
														[
															0.314,
															-7.877
														],
														[
															0.21,
															-7.994
														],
														[
															0.105,
															-8.098
														],
														[
															0,
															-12.215
														],
														[
															-0.171,
															-12.004
														],
														[
															-0.378,
															-11.775
														],
														[
															-0.622,
															-11.526
														],
														[
															-0.903,
															-11.259
														],
														[
															-1.22,
															-10.972
														],
														[
															-1.573,
															-10.667
														],
														[
															-1.963,
															-10.343
														],
														[
															-0.334,
															-1.399
														],
														[
															-0.381,
															-1.472
														],
														[
															-0.415,
															-1.519
														],
														[
															-0.438,
															-1.538
														],
														[
															-0.449,
															-1.531
														],
														[
															-0.447,
															-1.496
														],
														[
															-0.434,
															-1.434
														],
														[
															-0.409,
															-1.345
														],
														[
															-0.028,
															-0.093
														],
														[
															-0.177,
															-0.165
														],
														[
															-0.231,
															-0.195
														],
														[
															-0.188,
															-0.182
														],
														[
															-0.277,
															-0.709
														],
														[
															-0.223,
															-0.741
														],
														[
															-0.217,
															-0.759
														],
														[
															-0.261,
															-0.764
														],
														[
															-0.522,
															-1.112
														],
														[
															-0.595,
															-1.003
														],
														[
															-0.618,
															-0.907
														],
														[
															-0.588,
															-0.826
														],
														[
															-0.589,
															-0.88
														],
														[
															-0.549,
															-0.781
														],
														[
															-0.554,
															-0.673
														],
														[
															-0.603,
															-0.555
														],
														[
															-1.079,
															-0.664
														],
														[
															-0.605,
															-0.238
														],
														[
															-0.402,
															0.125
														],
														[
															-0.471,
															0.426
														],
														[
															-0.1,
															0.081
														],
														[
															-0.175,
															-0.01
														],
														[
															-0.2,
															-0.041
														],
														[
															-0.175,
															-0.01
														],
														[
															-0.704,
															0.586
														],
														[
															-0.757,
															0.942
														],
														[
															-0.774,
															1.169
														],
														[
															-0.755,
															1.268
														],
														[
															-0.704,
															1.245
														],
														[
															-0.617,
															1.291
														],
														[
															-0.562,
															1.335
														],
														[
															-0.539,
															1.377
														],
														[
															-3.222,
															8.352
														],
														[
															-2.485,
															9.261
														],
														[
															-1.899,
															9.768
														],
														[
															-1.465,
															9.873
														],
														[
															-2.498,
															20.219
														],
														[
															-1.57,
															21.457
														],
														[
															-0.707,
															22.178
														],
														[
															0.092,
															22.382
														],
														[
															0.137,
															3.671
														],
														[
															0.229,
															3.635
														],
														[
															0.278,
															3.59
														],
														[
															0.285,
															3.535
														],
														[
															0.803,
															11.21
														],
														[
															0.927,
															10.551
														],
														[
															1.17,
															10.107
														],
														[
															1.533,
															9.877
														],
														[
															1.691,
															8.269
														],
														[
															1.986,
															7.8
														],
														[
															2.462,
															7.082
														],
														[
															3.12,
															6.116
														],
														[
															0.168,
															0.208
														],
														[
															0.252,
															0.167
														],
														[
															0.284,
															0.15
														],
														[
															0.265,
															0.158
														],
														[
															0.472,
															0.458
														],
														[
															0.197,
															0.281
														],
														[
															0.068,
															0.242
														],
														[
															0.087,
															0.34
														],
														[
															0.359,
															0.813
														],
														[
															0.115,
															0.775
														],
														[
															0.099,
															0.745
														],
														[
															0.309,
															0.722
														],
														[
															4.352,
															-4.052
														],
														[
															3.143,
															-5.06
														],
														[
															2.274,
															-5.778
														],
														[
															1.744,
															-6.203
														]
													],
													"v": [
														[
															395,
															631
														],
														[
															397.297,
															621.105
														],
														[
															399.403,
															611.005
														],
														[
															401.334,
															600.715
														],
														[
															403.109,
															590.253
														],
														[
															404.746,
															579.634
														],
														[
															406.261,
															568.875
														],
														[
															407.673,
															557.991
														],
														[
															409,
															547
														],
														[
															411.33,
															525.474
														],
														[
															413.354,
															503.408
														],
														[
															415.072,
															480.844
														],
														[
															416.482,
															457.823
														],
														[
															417.581,
															434.386
														],
														[
															418.368,
															410.576
														],
														[
															418.842,
															386.433
														],
														[
															419,
															362
														],
														[
															418.753,
															325.666
														],
														[
															417.938,
															289.993
														],
														[
															416.446,
															255.038
														],
														[
															414.168,
															220.856
														],
														[
															410.994,
															187.505
														],
														[
															406.814,
															155.041
														],
														[
															401.519,
															123.521
														],
														[
															395,
															93
														],
														[
															393.925,
															88.687
														],
														[
															392.728,
															84.193
														],
														[
															391.445,
															79.601
														],
														[
															390.112,
															74.991
														],
														[
															388.765,
															70.444
														],
														[
															387.44,
															66.043
														],
														[
															386.173,
															61.868
														],
														[
															385,
															58
														],
														[
															384.668,
															57.602
														],
														[
															384.032,
															57.051
														],
														[
															383.38,
															56.474
														],
														[
															383,
															56
														],
														[
															382.263,
															53.821
														],
														[
															381.615,
															51.568
														],
														[
															380.91,
															49.281
														],
														[
															380,
															47
														],
														[
															378.311,
															43.83
														],
														[
															376.479,
															40.968
														],
														[
															374.657,
															38.372
														],
														[
															373,
															36
														],
														[
															371.303,
															33.506
														],
														[
															369.66,
															31.323
														],
														[
															367.936,
															29.478
														],
														[
															366,
															28
														],
														[
															363.541,
															26.663
														],
														[
															362.097,
															26.509
														],
														[
															360.855,
															27.352
														],
														[
															359,
															29
														],
														[
															358.575,
															29.091
														],
														[
															357.999,
															28.999
														],
														[
															357.423,
															28.907
														],
														[
															357,
															29
														],
														[
															354.8,
															31.323
														],
														[
															352.495,
															34.521
														],
														[
															350.193,
															38.208
														],
														[
															348,
															42
														],
														[
															346.026,
															45.803
														],
														[
															344.264,
															49.742
														],
														[
															342.62,
															53.81
														],
														[
															341,
															58
														],
														[
															332.477,
															84.521
														],
														[
															325.941,
															113.166
														],
														[
															320.934,
															142.728
														],
														[
															317,
															172
														],
														[
															310.913,
															234.644
														],
														[
															307.513,
															300.227
														],
														[
															306.606,
															367.196
														],
														[
															308,
															434
														],
														[
															308.561,
															444.96
														],
														[
															309.333,
															455.799
														],
														[
															310.189,
															466.488
														],
														[
															311,
															477
														],
														[
															313.564,
															509.588
														],
														[
															316.679,
															540.522
														],
														[
															320.705,
															570.445
														],
														[
															326,
															600
														],
														[
															331.47,
															624.166
														],
														[
															338.097,
															646.552
														],
														[
															346.426,
															666.412
														],
														[
															357,
															683
														],
														[
															357.643,
															683.557
														],
														[
															358.459,
															684.027
														],
														[
															359.296,
															684.484
														],
														[
															360,
															685
														],
														[
															360.967,
															686.075
														],
														[
															361.328,
															686.825
														],
														[
															361.525,
															687.662
														],
														[
															362,
															689
														],
														[
															362.655,
															691.381
														],
														[
															362.92,
															693.659
														],
														[
															363.474,
															695.858
														],
														[
															365,
															698
														],
														[
															376.158,
															684.259
														],
														[
															384.198,
															667.929
														],
														[
															390.139,
															649.884
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 31,
											"s": [
												{
													"i": [
														[
															0.179,
															-0.1
														],
														[
															1.989,
															-1.667
														],
														[
															1.689,
															-1.954
														],
														[
															1.48,
															-2.185
														],
														[
															1.363,
															-2.361
														],
														[
															2.183,
															-4.667
														],
														[
															1.929,
															-4.957
														],
														[
															1.656,
															-5.062
														],
														[
															1.365,
															-4.982
														],
														[
															0.629,
															-2.384
														],
														[
															0.578,
															-2.303
														],
														[
															0.535,
															-2.268
														],
														[
															0.499,
															-2.278
														],
														[
															0.635,
															-3.356
														],
														[
															0.562,
															-3.335
														],
														[
															0.521,
															-3.312
														],
														[
															0.511,
															-3.286
														],
														[
															1.607,
															-13.702
														],
														[
															1.107,
															-14.289
														],
														[
															0.571,
															-15.067
														],
														[
															0,
															-16.038
														],
														[
															-0.466,
															-15.367
														],
														[
															-0.922,
															-14.602
														],
														[
															-1.371,
															-13.809
														],
														[
															-1.81,
															-12.988
														],
														[
															-1.956,
															-10.22
														],
														[
															-2.476,
															-10.107
														],
														[
															-2.907,
															-9.333
														],
														[
															-3.25,
															-7.9
														],
														[
															-1.24,
															-2.716
														],
														[
															-1.398,
															-2.715
														],
														[
															-1.459,
															-2.392
														],
														[
															-1.424,
															-1.746
														],
														[
															-0.589,
															-0.717
														],
														[
															-0.58,
															-0.678
														],
														[
															-0.576,
															-0.622
														],
														[
															-0.577,
															-0.549
														],
														[
															-0.65,
															-0.462
														],
														[
															-0.651,
															-0.411
														],
														[
															-0.551,
															-0.369
														],
														[
															-0.349,
															-0.334
														],
														[
															-0.486,
															-0.269
														],
														[
															-0.515,
															-0.247
														],
														[
															-0.397,
															-0.229
														],
														[
															-0.131,
															-0.216
														],
														[
															-0.112,
															-1.156
														],
														[
															-0.035,
															-1.269
														],
														[
															-0.156,
															-0.979
														],
														[
															-0.474,
															-0.284
														],
														[
															-0.327,
															0.036
														],
														[
															-0.526,
															0.07
														],
														[
															-0.561,
															0.124
														],
														[
															-0.431,
															0.197
														],
														[
															-0.648,
															0.413
														],
														[
															-0.631,
															0.472
														],
														[
															-0.543,
															0.448
														],
														[
															-0.383,
															0.34
														],
														[
															-1.135,
															1.199
														],
														[
															-1.087,
															1.285
														],
														[
															-0.908,
															1.194
														],
														[
															-0.6,
															0.924
														],
														[
															-0.149,
															0.4
														],
														[
															-0.12,
															0.415
														],
														[
															-0.16,
															0.433
														],
														[
															-0.272,
															0.452
														],
														[
															-0.261,
															0.243
														],
														[
															-0.288,
															0.227
														],
														[
															-0.258,
															0.245
														],
														[
															-0.171,
															0.299
														],
														[
															-0.16,
															0.405
														],
														[
															-0.141,
															0.423
														],
														[
															-0.161,
															0.431
														],
														[
															-0.219,
															0.429
														],
														[
															-2.216,
															5.548
														],
														[
															-1.889,
															5.811
														],
														[
															-1.604,
															5.858
														],
														[
															-1.359,
															5.688
														],
														[
															-2.92,
															18.82
														],
														[
															-1.857,
															20.038
														],
														[
															-0.884,
															20.699
														],
														[
															0,
															20.803
														],
														[
															0.836,
															20.81
														],
														[
															1.819,
															19.567
														],
														[
															2.948,
															18.473
														],
														[
															4.224,
															17.529
														],
														[
															1.884,
															6.658
														],
														[
															2.228,
															6.308
														],
														[
															2.73,
															5.996
														],
														[
															3.39,
															5.723
														],
														[
															2.021,
															2.727
														],
														[
															2.335,
															2.23
														],
														[
															2.647,
															1.388
														],
														[
															2.957,
															0.202
														],
														[
															0.205,
															-0.081
														],
														[
															0.147,
															-0.123
														],
														[
															0.119,
															-0.105
														],
														[
															0.12,
															-0.027
														],
														[
															0.188,
															-0.076
														],
														[
															0.129,
															-0.083
														],
														[
															0.126,
															-0.091
														]
													],
													"o": [
														[
															-2.382,
															1.324
														],
														[
															-1.989,
															1.667
														],
														[
															-1.689,
															1.954
														],
														[
															-1.48,
															2.185
														],
														[
															-2.42,
															4.192
														],
														[
															-2.183,
															4.667
														],
														[
															-1.929,
															4.957
														],
														[
															-1.656,
															5.062
														],
														[
															-0.687,
															2.509
														],
														[
															-0.629,
															2.384
														],
														[
															-0.578,
															2.303
														],
														[
															-0.535,
															2.268
														],
														[
															-0.74,
															3.375
														],
														[
															-0.635,
															3.356
														],
														[
															-0.562,
															3.335
														],
														[
															-0.521,
															3.312
														],
														[
															-2.072,
															13.308
														],
														[
															-1.607,
															13.702
														],
														[
															-1.107,
															14.289
														],
														[
															-0.571,
															15.067
														],
														[
															0,
															16.105
														],
														[
															0.466,
															15.367
														],
														[
															0.922,
															14.602
														],
														[
															1.371,
															13.809
														],
														[
															1.348,
															9.673
														],
														[
															1.956,
															10.22
														],
														[
															2.475,
															10.107
														],
														[
															2.907,
															9.333
														],
														[
															0.985,
															2.394
														],
														[
															1.24,
															2.716
														],
														[
															1.398,
															2.715
														],
														[
															1.459,
															2.392
														],
														[
															0.603,
															0.739
														],
														[
															0.589,
															0.717
														],
														[
															0.58,
															0.678
														],
														[
															0.576,
															0.622
														],
														[
															0.547,
															0.52
														],
														[
															0.65,
															0.462
														],
														[
															0.651,
															0.411
														],
														[
															0.551,
															0.369
														],
														[
															0.308,
															0.295
														],
														[
															0.486,
															0.269
														],
														[
															0.515,
															0.247
														],
														[
															0.397,
															0.229
														],
														[
															0.387,
															0.638
														],
														[
															0.112,
															1.156
														],
														[
															0.035,
															1.269
														],
														[
															0.156,
															0.979
														],
														[
															-0.036,
															-0.022
														],
														[
															0.327,
															-0.036
														],
														[
															0.526,
															-0.07
														],
														[
															0.561,
															-0.124
														],
														[
															0.592,
															-0.27
														],
														[
															0.648,
															-0.413
														],
														[
															0.631,
															-0.472
														],
														[
															0.543,
															-0.448
														],
														[
															1.054,
															-0.935
														],
														[
															1.135,
															-1.199
														],
														[
															1.087,
															-1.285
														],
														[
															0.908,
															-1.194
														],
														[
															0.25,
															-0.386
														],
														[
															0.149,
															-0.4
														],
														[
															0.12,
															-0.415
														],
														[
															0.16,
															-0.433
														],
														[
															0.177,
															-0.295
														],
														[
															0.261,
															-0.243
														],
														[
															0.288,
															-0.227
														],
														[
															0.258,
															-0.245
														],
														[
															0.216,
															-0.377
														],
														[
															0.16,
															-0.405
														],
														[
															0.141,
															-0.423
														],
														[
															0.161,
															-0.431
														],
														[
															2.584,
															-5.068
														],
														[
															2.216,
															-5.548
														],
														[
															1.889,
															-5.811
														],
														[
															1.604,
															-5.857
														],
														[
															4.072,
															-17.045
														],
														[
															2.92,
															-18.82
														],
														[
															1.857,
															-20.038
														],
														[
															0.884,
															-20.699
														],
														[
															0,
															-22.202
														],
														[
															-0.836,
															-20.81
														],
														[
															-1.819,
															-19.567
														],
														[
															-2.948,
															-18.473
														],
														[
															-1.698,
															-7.045
														],
														[
															-1.884,
															-6.658
														],
														[
															-2.228,
															-6.308
														],
														[
															-2.73,
															-5.996
														],
														[
															-1.704,
															-2.878
														],
														[
															-2.021,
															-2.727
														],
														[
															-2.335,
															-2.23
														],
														[
															-2.647,
															-1.388
														],
														[
															-0.291,
															-0.02
														],
														[
															-0.205,
															0.081
														],
														[
															-0.147,
															0.123
														],
														[
															-0.119,
															0.105
														],
														[
															-0.303,
															0.069
														],
														[
															-0.188,
															0.076
														],
														[
															-0.129,
															0.083
														],
														[
															-0.126,
															0.091
														]
													],
													"v": [
														[
															357,
															28
														],
														[
															350.467,
															32.5
														],
														[
															344.972,
															37.945
														],
														[
															340.241,
															44.167
														],
														[
															336,
															51
														],
														[
															329.091,
															64.334
														],
														[
															322.918,
															78.815
														],
														[
															317.536,
															93.888
														],
														[
															313,
															109
														],
														[
															311.027,
															116.328
														],
														[
															309.218,
															123.347
														],
														[
															307.55,
															130.193
														],
														[
															306,
															137
														],
														[
															303.946,
															147.096
														],
														[
															302.158,
															157.133
														],
														[
															300.541,
															167.103
														],
														[
															299,
															177
														],
														[
															293.473,
															217.467
														],
														[
															289.393,
															259.406
														],
														[
															286.866,
															303.391
														],
														[
															286,
															350
														],
														[
															286.7,
															397.215
														],
														[
															288.785,
															442.175
														],
														[
															292.226,
															484.798
														],
														[
															297,
															525
														],
														[
															301.978,
															555.005
														],
														[
															308.648,
															585.66
														],
														[
															316.743,
															614.985
														],
														[
															326,
															641
														],
														[
															329.361,
															648.746
														],
														[
															333.341,
															656.973
														],
														[
															337.651,
															664.713
														],
														[
															342,
															671
														],
														[
															343.787,
															673.188
														],
														[
															345.539,
															675.285
														],
														[
															347.272,
															677.24
														],
														[
															349,
															679
														],
														[
															350.821,
															680.472
														],
														[
															352.797,
															681.779
														],
														[
															354.625,
															682.947
														],
														[
															356,
															684
														],
														[
															357.228,
															684.846
														],
														[
															358.767,
															685.62
														],
														[
															360.172,
															686.333
														],
														[
															361,
															687
														],
														[
															361.698,
															689.792
														],
														[
															361.87,
															693.531
														],
														[
															362.106,
															697.005
														],
														[
															363,
															699
														],
														[
															363.478,
															698.918
														],
														[
															364.8,
															698.762
														],
														[
															366.471,
															698.476
														],
														[
															368,
															698
														],
														[
															369.878,
															696.954
														],
														[
															371.814,
															695.604
														],
														[
															373.593,
															694.203
														],
														[
															375,
															693
														],
														[
															378.316,
															689.754
														],
														[
															381.681,
															685.984
														],
														[
															384.706,
															682.221
														],
														[
															387,
															679
														],
														[
															387.582,
															677.822
														],
														[
															387.968,
															676.6
														],
														[
															388.37,
															675.327
														],
														[
															389,
															674
														],
														[
															389.672,
															673.202
														],
														[
															390.51,
															672.506
														],
														[
															391.343,
															671.807
														],
														[
															392,
															671
														],
														[
															392.553,
															669.824
														],
														[
															392.995,
															668.578
														],
														[
															393.44,
															667.294
														],
														[
															394,
															666
														],
														[
															401.189,
															650.021
														],
														[
															407.337,
															632.928
														],
														[
															412.566,
															615.372
														],
														[
															417,
															598
														],
														[
															427.466,
															544.063
														],
														[
															434.608,
															485.637
														],
														[
															438.697,
															424.392
														],
														[
															440,
															362
														],
														[
															438.782,
															297.518
														],
														[
															434.836,
															236.989
														],
														[
															427.722,
															179.965
														],
														[
															417,
															126
														],
														[
															411.667,
															105.455
														],
														[
															405.538,
															86.016
														],
														[
															398.14,
															67.569
														],
														[
															389,
															50
														],
														[
															383.412,
															41.507
														],
														[
															376.878,
															33.986
														],
														[
															369.405,
															28.471
														],
														[
															361,
															26
														],
														[
															360.264,
															26.107
														],
														[
															359.744,
															26.429
														],
														[
															359.351,
															26.786
														],
														[
															359,
															27
														],
														[
															358.277,
															27.217
														],
														[
															357.815,
															27.454
														],
														[
															357.445,
															27.714
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 32,
											"s": [
												{
													"i": [
														[
															0.401,
															-0.139
														],
														[
															5.299,
															-4.393
														],
														[
															4.234,
															-5.763
														],
														[
															3.318,
															-6.364
														],
														[
															2.552,
															-6.195
														],
														[
															0.239,
															-0.729
														],
														[
															0.227,
															-0.755
														],
														[
															0.249,
															-0.773
														],
														[
															0.306,
															-0.784
														],
														[
															0.35,
															-0.672
														],
														[
															0.38,
															-0.682
														],
														[
															0.34,
															-0.669
														],
														[
															0.231,
															-0.633
														],
														[
															0.425,
															-1.568
														],
														[
															0.364,
															-1.586
														],
														[
															0.382,
															-1.6
														],
														[
															0.479,
															-1.61
														],
														[
															0.526,
															-1.504
														],
														[
															0.54,
															-1.497
														],
														[
															0.494,
															-1.494
														],
														[
															0.389,
															-1.495
														],
														[
															0.712,
															-3.327
														],
														[
															0.627,
															-3.346
														],
														[
															0.602,
															-3.346
														],
														[
															0.635,
															-3.326
														],
														[
															1.15,
															-6.725
														],
														[
															1.022,
															-6.973
														],
														[
															0.861,
															-7.262
														],
														[
															0.668,
															-7.591
														],
														[
															0.353,
															-23.536
														],
														[
															-1.172,
															-23.137
														],
														[
															-2.564,
															-21.658
														],
														[
															-3.822,
															-19.097
														],
														[
															-1.516,
															-6.333
														],
														[
															-1.761,
															-6.31
														],
														[
															-1.99,
															-6.197
														],
														[
															-2.203,
															-5.995
														],
														[
															-0.561,
															-1.42
														],
														[
															-0.578,
															-1.385
														],
														[
															-0.603,
															-1.398
														],
														[
															-0.637,
															-1.457
														],
														[
															-0.162,
															-0.313
														],
														[
															-0.176,
															-0.327
														],
														[
															-0.175,
															-0.35
														],
														[
															-0.162,
															-0.383
														],
														[
															-0.074,
															-0.438
														],
														[
															-0.053,
															-0.466
														],
														[
															-0.077,
															-0.42
														],
														[
															-0.148,
															-0.3
														],
														[
															-0.417,
															-0.578
														],
														[
															-0.458,
															-0.558
														],
														[
															-0.437,
															-0.576
														],
														[
															-0.353,
															-0.633
														],
														[
															-0.318,
															-0.67
														],
														[
															-0.305,
															-0.667
														],
														[
															-0.334,
															-0.664
														],
														[
															-0.406,
															-0.66
														],
														[
															-0.816,
															-1.211
														],
														[
															-0.832,
															-1.145
														],
														[
															-0.849,
															-1.112
														],
														[
															-0.87,
															-1.111
														],
														[
															-0.546,
															-0.492
														],
														[
															-0.452,
															-0.563
														],
														[
															-0.26,
															-0.724
														],
														[
															-0.438,
															-0.452
														],
														[
															-1.522,
															-1.021
														],
														[
															-0.788,
															-0.755
														],
														[
															-0.28,
															-0.072
														],
														[
															-0.494,
															-0.344
														],
														[
															-0.57,
															-0.734
														],
														[
															-1.135,
															-0.658
														],
														[
															-1.402,
															-0.263
														],
														[
															-0.262,
															-0.293
														],
														[
															-0.104,
															-1.434
														],
														[
															-0.337,
															-0.871
														],
														[
															-0.631,
															-0.582
														],
														[
															-1.603,
															-0.425
														],
														[
															-3.414,
															1.85
														],
														[
															-2.589,
															2.067
														],
														[
															-2.143,
															2.419
														],
														[
															-1.602,
															2.068
														],
														[
															-4.844,
															10.283
														],
														[
															-3.87,
															11.86
														],
														[
															-1.405,
															4.473
														],
														[
															-0.962,
															3.764
														],
														[
															-1.83,
															8.167
														],
														[
															-1.49,
															8.756
														],
														[
															-2.596,
															29.129
														],
														[
															0,
															31.342
														],
														[
															4.623,
															38.823
														],
														[
															8.509,
															31.778
														],
														[
															1.7,
															5.222
														],
														[
															1.776,
															4.802
														],
														[
															6.786,
															11.768
														],
														[
															9.206,
															7.356
														],
														[
															3.635,
															2.038
														],
														[
															3.158,
															0.01
														],
														[
															0.166,
															-0.251
														],
														[
															-0.023,
															0.002
														],
														[
															0.543,
															0.042
														]
													],
													"o": [
														[
															-6.513,
															2.253
														],
														[
															-5.299,
															4.393
														],
														[
															-4.234,
															5.763
														],
														[
															-3.318,
															6.364
														],
														[
															-0.287,
															0.697
														],
														[
															-0.239,
															0.729
														],
														[
															-0.227,
															0.755
														],
														[
															-0.249,
															0.773
														],
														[
															-0.25,
															0.639
														],
														[
															-0.35,
															0.672
														],
														[
															-0.38,
															0.682
														],
														[
															-0.34,
															0.669
														],
														[
															-0.564,
															1.547
														],
														[
															-0.425,
															1.568
														],
														[
															-0.364,
															1.586
														],
														[
															-0.382,
															1.6
														],
														[
															-0.451,
															1.516
														],
														[
															-0.526,
															1.504
														],
														[
															-0.54,
															1.497
														],
														[
															-0.494,
															1.494
														],
														[
															-0.855,
															3.289
														],
														[
															-0.712,
															3.327
														],
														[
															-0.627,
															3.346
														],
														[
															-0.602,
															3.346
														],
														[
															-1.245,
															6.518
														],
														[
															-1.15,
															6.725
														],
														[
															-1.022,
															6.973
														],
														[
															-0.861,
															7.262
														],
														[
															-2.011,
															22.854
														],
														[
															-0.353,
															23.536
														],
														[
															1.172,
															23.137
														],
														[
															2.564,
															21.658
														],
														[
															1.254,
															6.266
														],
														[
															1.516,
															6.333
														],
														[
															1.761,
															6.31
														],
														[
															1.99,
															6.197
														],
														[
															0.552,
															1.502
														],
														[
															0.561,
															1.42
														],
														[
															0.578,
															1.385
														],
														[
															0.603,
															1.398
														],
														[
															0.135,
															0.31
														],
														[
															0.162,
															0.313
														],
														[
															0.176,
															0.327
														],
														[
															0.175,
															0.35
														],
														[
															0.142,
															0.337
														],
														[
															0.074,
															0.438
														],
														[
															0.053,
															0.466
														],
														[
															0.077,
															0.42
														],
														[
															0.314,
															0.637
														],
														[
															0.417,
															0.578
														],
														[
															0.458,
															0.558
														],
														[
															0.437,
															0.576
														],
														[
															0.375,
															0.672
														],
														[
															0.318,
															0.67
														],
														[
															0.305,
															0.667
														],
														[
															0.334,
															0.664
														],
														[
															0.804,
															1.308
														],
														[
															0.816,
															1.211
														],
														[
															0.832,
															1.145
														],
														[
															0.849,
															1.112
														],
														[
															0.366,
															0.467
														],
														[
															0.546,
															0.492
														],
														[
															0.523,
															0.652
														],
														[
															0.26,
															0.724
														],
														[
															1.124,
															1.162
														],
														[
															1.522,
															1.021
														],
														[
															0.385,
															0.37
														],
														[
															0.28,
															0.072
														],
														[
															0.583,
															0.407
														],
														[
															0.57,
															0.734
														],
														[
															1.13,
															0.654
														],
														[
															1.402,
															0.263
														],
														[
															1.245,
															1.393
														],
														[
															0.104,
															1.434
														],
														[
															0.871,
															2.248
														],
														[
															0.631,
															0.582
														],
														[
															1.754,
															0.465
														],
														[
															3.414,
															-1.85
														],
														[
															2.827,
															-2.256
														],
														[
															2.143,
															-2.419
														],
														[
															7.754,
															-10.01
														],
														[
															4.844,
															-10.283
														],
														[
															1.418,
															-4.345
														],
														[
															1.405,
															-4.473
														],
														[
															2.192,
															-8.575
														],
														[
															1.83,
															-8.167
														],
														[
															4.617,
															-27.141
														],
														[
															2.596,
															-29.129
														],
														[
															0,
															-41.93
														],
														[
															-4.623,
															-38.823
														],
														[
															-1.422,
															-5.31
														],
														[
															-1.7,
															-5.222
														],
														[
															-4.651,
															-12.572
														],
														[
															-6.786,
															-11.768
														],
														[
															-2.303,
															-1.84
														],
														[
															-3.635,
															-2.037
														],
														[
															-0.359,
															-0.001
														],
														[
															-0.166,
															0.251
														],
														[
															-0.427,
															0.029
														],
														[
															-0.543,
															-0.042
														]
													],
													"v": [
														[
															359,
															26
														],
														[
															341.32,
															36.162
														],
														[
															327.058,
															51.588
														],
														[
															315.768,
															69.97
														],
														[
															307,
															89
														],
														[
															306.219,
															91.141
														],
														[
															305.529,
															93.369
														],
														[
															304.824,
															95.662
														],
														[
															304,
															98
														],
														[
															303.084,
															99.972
														],
														[
															301.972,
															102.009
														],
														[
															300.874,
															104.041
														],
														[
															300,
															106
														],
														[
															298.537,
															110.674
														],
														[
															297.373,
															115.406
														],
														[
															296.272,
															120.185
														],
														[
															295,
															125
														],
														[
															293.52,
															129.529
														],
														[
															291.907,
															134.03
														],
														[
															290.34,
															138.517
														],
														[
															289,
															143
														],
														[
															286.665,
															152.929
														],
														[
															284.671,
															162.945
														],
														[
															282.842,
															172.988
														],
														[
															281,
															183
														],
														[
															277.399,
															202.854
														],
														[
															274.134,
															223.39
														],
														[
															271.302,
															244.731
														],
														[
															269,
															267
														],
														[
															265.487,
															336.855
														],
														[
															266.749,
															407.135
														],
														[
															272.387,
															474.597
														],
														[
															282,
															536
														],
														[
															286.159,
															554.92
														],
														[
															291.077,
															573.907
														],
														[
															296.707,
															592.69
														],
														[
															303,
															611
														],
														[
															304.667,
															615.371
														],
														[
															306.372,
															619.567
														],
														[
															308.142,
															623.73
														],
														[
															310,
															628
														],
														[
															310.45,
															628.932
														],
														[
															310.961,
															629.89
														],
														[
															311.491,
															630.902
														],
														[
															312,
															632
														],
														[
															312.313,
															633.182
														],
														[
															312.492,
															634.557
														],
														[
															312.675,
															635.903
														],
														[
															313,
															637
														],
														[
															314.112,
															638.813
														],
														[
															315.442,
															640.506
														],
														[
															316.8,
															642.197
														],
														[
															318,
															644
														],
														[
															319.029,
															646.012
														],
														[
															319.953,
															648.017
														],
														[
															320.901,
															650.014
														],
														[
															322,
															652
														],
														[
															324.43,
															655.769
														],
														[
															326.901,
															659.295
														],
														[
															329.422,
															662.674
														],
														[
															332,
															666
														],
														[
															333.436,
															667.428
														],
														[
															335,
															669
														],
														[
															336.064,
															671.15
														],
														[
															337,
															673
														],
														[
															341.252,
															676.306
														],
														[
															345,
															679
														],
														[
															345.919,
															679.519
														],
														[
															347,
															680
														],
														[
															348.586,
															681.812
														],
														[
															351,
															684
														],
														[
															355.151,
															685.272
														],
														[
															358,
															686
														],
														[
															359.681,
															690.391
														],
														[
															360,
															694
														],
														[
															361.951,
															697.868
														],
														[
															365,
															699
														],
														[
															373.373,
															696.398
														],
														[
															383,
															690
														],
														[
															390.419,
															682.859
														],
														[
															396,
															676
														],
														[
															414.413,
															645.888
														],
														[
															427,
															613
														],
														[
															431.342,
															599.564
														],
														[
															435,
															587
														],
														[
															441.026,
															562.136
														],
														[
															446,
															537
														],
														[
															456.963,
															452.651
														],
														[
															461,
															362
														],
														[
															453.882,
															239.885
														],
														[
															434,
															133
														],
														[
															429.266,
															117.119
														],
														[
															424,
															102
														],
														[
															406.915,
															64.588
														],
														[
															383,
															35
														],
														[
															373.642,
															28.627
														],
														[
															363,
															25
														],
														[
															362.214,
															25.5
														],
														[
															362,
															26
														],
														[
															360.481,
															25.918
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 33,
											"s": [
												{
													"i": [
														[
															3.025,
															-2.17
														],
														[
															1.51,
															-1.262
														],
														[
															1.407,
															-1.342
														],
														[
															1.318,
															-1.409
														],
														[
															1.245,
															-1.462
														],
														[
															4.902,
															-8.292
														],
														[
															4.045,
															-9.2
														],
														[
															3.245,
															-9.558
														],
														[
															2.504,
															-9.367
														],
														[
															2.912,
															-14.369
														],
														[
															2.118,
															-15.363
														],
														[
															1.147,
															-16.188
														],
														[
															0,
															-16.842
														],
														[
															-0.158,
															-8.375
														],
														[
															-0.327,
															-8.233
														],
														[
															-0.505,
															-8.116
														],
														[
															-0.694,
															-8.025
														],
														[
															-2.097,
															-14.075
														],
														[
															-2.926,
															-13.363
														],
														[
															-3.742,
															-12.357
														],
														[
															-4.542,
															-11.056
														],
														[
															-0.065,
															-0.397
														],
														[
															-0.036,
															-0.408
														],
														[
															-0.078,
															-0.432
														],
														[
															-0.191,
															-0.468
														],
														[
															-0.259,
															-0.33
														],
														[
															-0.303,
															-0.331
														],
														[
															-0.267,
															-0.335
														],
														[
															-0.151,
															-0.343
														],
														[
															-0.079,
															-0.434
														],
														[
															-0.046,
															-0.444
														],
														[
															-0.069,
															-0.413
														],
														[
															-0.149,
															-0.341
														],
														[
															-0.259,
															-0.327
														],
														[
															-0.29,
															-0.308
														],
														[
															-0.261,
															-0.326
														],
														[
															-0.173,
															-0.384
														],
														[
															-0.077,
															-0.42
														],
														[
															-0.043,
															-0.433
														],
														[
															-0.07,
															-0.422
														],
														[
															-0.157,
															-0.386
														],
														[
															-0.257,
															-0.342
														],
														[
															-0.284,
															-0.298
														],
														[
															-0.26,
															-0.307
														],
														[
															-0.185,
															-0.368
														],
														[
															-2.803,
															-4.67
														],
														[
															-3.154,
															-4.272
														],
														[
															-3.524,
															-3.716
														],
														[
															-3.913,
															-3.002
														],
														[
															-1.046,
															-0.732
														],
														[
															-1.028,
															-0.633
														],
														[
															-1.093,
															-0.585
														],
														[
															-1.241,
															-0.587
														],
														[
															-0.514,
															-0.401
														],
														[
															-0.544,
															-0.207
														],
														[
															-1.014,
															-0.155
														],
														[
															-0.039,
															-0.037
														],
														[
															-0.451,
															-1.309
														],
														[
															-0.399,
															-1.01
														],
														[
															-0.094,
															-1.206
														],
														[
															-0.288,
															-0.327
														],
														[
															-0.642,
															0.072
														],
														[
															-0.26,
															-0.094
														],
														[
															-5.428,
															2.391
														],
														[
															-2.192,
															1.558
														],
														[
															-1.205,
															1.07
														],
														[
															-0.889,
															0.801
														],
														[
															-4.721,
															6.754
														],
														[
															-4.436,
															7.968
														],
														[
															-3.219,
															7.206
														],
														[
															-2.51,
															6.683
														],
														[
															-0.5,
															1.545
														],
														[
															-0.482,
															1.442
														],
														[
															-3.833,
															16.967
														],
														[
															-2.567,
															16.878
														],
														[
															-1.423,
															23.343
														],
														[
															0,
															23.87
														],
														[
															3.438,
															29.826
														],
														[
															6.25,
															26.326
														],
														[
															4.779,
															14.072
														],
														[
															5.591,
															11.84
														],
														[
															3.731,
															6.318
														],
														[
															4.082,
															4.384
														],
														[
															0.074,
															0.544
														],
														[
															0.344,
															0.436
														],
														[
															1.06,
															0.977
														],
														[
															0.938,
															1.052
														],
														[
															0.991,
															1.229
														],
														[
															0.958,
															0.873
														],
														[
															0.587,
															0.114
														],
														[
															0.325,
															0.248
														],
														[
															0.333,
															0.367
														],
														[
															0.351,
															0.288
														],
														[
															1.215,
															0.86
														],
														[
															0.985,
															0.612
														],
														[
															2.196,
															1.072
														],
														[
															3.426,
															0.979
														],
														[
															1.725,
															0.091
														],
														[
															1.389,
															-0.138
														],
														[
															3.877,
															-1.822
														]
													],
													"o": [
														[
															-1.629,
															1.169
														],
														[
															-1.51,
															1.262
														],
														[
															-1.407,
															1.342
														],
														[
															-1.318,
															1.409
														],
														[
															-5.818,
															6.833
														],
														[
															-4.902,
															8.292
														],
														[
															-4.045,
															9.2
														],
														[
															-3.245,
															9.558
														],
														[
															-3.529,
															13.204
														],
														[
															-2.912,
															14.369
														],
														[
															-2.118,
															15.363
														],
														[
															-1.147,
															16.188
														],
														[
															0,
															8.544
														],
														[
															0.158,
															8.375
														],
														[
															0.327,
															8.233
														],
														[
															0.505,
															8.116
														],
														[
															1.252,
															14.491
														],
														[
															2.097,
															14.075
														],
														[
															2.926,
															13.363
														],
														[
															3.742,
															12.357
														],
														[
															0.164,
															0.399
														],
														[
															0.065,
															0.397
														],
														[
															0.036,
															0.408
														],
														[
															0.078,
															0.432
														],
														[
															0.135,
															0.333
														],
														[
															0.259,
															0.33
														],
														[
															0.303,
															0.331
														],
														[
															0.267,
															0.335
														],
														[
															0.169,
															0.382
														],
														[
															0.079,
															0.434
														],
														[
															0.046,
															0.444
														],
														[
															0.069,
															0.413
														],
														[
															0.168,
															0.386
														],
														[
															0.259,
															0.327
														],
														[
															0.29,
															0.308
														],
														[
															0.261,
															0.326
														],
														[
															0.172,
															0.381
														],
														[
															0.077,
															0.42
														],
														[
															0.043,
															0.433
														],
														[
															0.07,
															0.422
														],
														[
															0.178,
															0.438
														],
														[
															0.257,
															0.342
														],
														[
															0.284,
															0.298
														],
														[
															0.26,
															0.307
														],
														[
															2.472,
															4.91
														],
														[
															2.803,
															4.67
														],
														[
															3.154,
															4.272
														],
														[
															3.524,
															3.716
														],
														[
															1.147,
															0.88
														],
														[
															1.046,
															0.732
														],
														[
															1.028,
															0.633
														],
														[
															1.093,
															0.585
														],
														[
															0.4,
															0.189
														],
														[
															0.514,
															0.401
														],
														[
															0.903,
															0.344
														],
														[
															1.014,
															0.155
														],
														[
															0.796,
															0.753
														],
														[
															0.451,
															1.309
														],
														[
															0.336,
															0.85
														],
														[
															0.094,
															1.206
														],
														[
															0.172,
															0.195
														],
														[
															0.642,
															-0.072
														],
														[
															3.096,
															1.125
														],
														[
															5.428,
															-2.391
														],
														[
															1.292,
															-0.918
														],
														[
															1.205,
															-1.07
														],
														[
															6.678,
															-6.016
														],
														[
															4.721,
															-6.754
														],
														[
															3.615,
															-6.494
														],
														[
															3.219,
															-7.206
														],
														[
															0.517,
															-1.376
														],
														[
															0.5,
															-1.545
														],
														[
															5.102,
															-15.253
														],
														[
															3.833,
															-16.967
														],
														[
															3.31,
															-21.759
														],
														[
															1.423,
															-23.343
														],
														[
															0,
															-30.369
														],
														[
															-3.438,
															-29.827
														],
														[
															-3.293,
															-13.87
														],
														[
															-4.779,
															-14.072
														],
														[
															-2.996,
															-6.344
														],
														[
															-3.731,
															-6.318
														],
														[
															-0.362,
															-0.389
														],
														[
															-0.074,
															-0.544
														],
														[
															-0.82,
															-1.041
														],
														[
															-1.06,
															-0.977
														],
														[
															-1.079,
															-1.21
														],
														[
															-0.991,
															-1.229
														],
														[
															-0.327,
															-0.297
														],
														[
															-0.587,
															-0.114
														],
														[
															-0.317,
															-0.242
														],
														[
															-0.333,
															-0.367
														],
														[
															-1.156,
															-0.95
														],
														[
															-1.215,
															-0.859
														],
														[
															-2.789,
															-1.734
														],
														[
															-2.196,
															-1.072
														],
														[
															-2.712,
															-0.774
														],
														[
															-1.725,
															-0.091
														],
														[
															-5.466,
															0.542
														],
														[
															-3.877,
															1.822
														]
													],
													"v": [
														[
															336,
															36
														],
														[
															331.295,
															39.649
														],
														[
															326.924,
															43.56
														],
														[
															322.841,
															47.69
														],
														[
															319,
															52
														],
														[
															302.934,
															74.825
														],
														[
															289.528,
															101.2
														],
														[
															278.608,
															129.475
														],
														[
															270,
															158
														],
														[
															260.295,
															199.403
														],
														[
															252.707,
															244.044
														],
														[
															247.765,
															291.413
														],
														[
															246,
															341
														],
														[
															246.235,
															366.373
														],
														[
															246.96,
															391.278
														],
														[
															248.205,
															415.794
														],
														[
															250,
															440
														],
														[
															255.027,
															482.922
														],
														[
															262.565,
															524.153
														],
														[
															272.571,
															562.807
														],
														[
															285,
															598
														],
														[
															285.325,
															599.191
														],
														[
															285.46,
															600.396
														],
														[
															285.614,
															601.653
														],
														[
															286,
															603
														],
														[
															286.612,
															603.995
														],
														[
															287.476,
															604.986
														],
														[
															288.352,
															605.984
														],
														[
															289,
															607
														],
														[
															289.358,
															608.235
														],
														[
															289.531,
															609.562
														],
														[
															289.688,
															610.858
														],
														[
															290,
															612
														],
														[
															290.654,
															613.06
														],
														[
															291.492,
															614.003
														],
														[
															292.333,
															614.944
														],
														[
															293,
															616
														],
														[
															293.358,
															617.207
														],
														[
															293.522,
															618.493
														],
														[
															293.675,
															619.782
														],
														[
															294,
															621
														],
														[
															294.665,
															622.158
														],
														[
															295.49,
															623.106
														],
														[
															296.319,
															624.001
														],
														[
															297,
															625
														],
														[
															304.908,
															639.409
														],
														[
															313.839,
															652.861
														],
														[
															323.85,
															664.883
														],
														[
															335,
															675
														],
														[
															338.268,
															677.404
														],
														[
															341.358,
															679.439
														],
														[
															344.519,
															681.254
														],
														[
															348,
															683
														],
														[
															349.392,
															683.986
														],
														[
															351,
															685
														],
														[
															354.148,
															685.731
														],
														[
															356,
															686
														],
														[
															357.798,
															689.306
														],
														[
															359,
															693
														],
														[
															359.536,
															696.391
														],
														[
															360,
															699
														],
														[
															361.434,
															699.075
														],
														[
															363,
															699
														],
														[
															377.178,
															696.012
														],
														[
															390,
															689
														],
														[
															393.802,
															685.912
														],
														[
															397,
															683
														],
														[
															413.682,
															663.964
														],
														[
															427,
															642
														],
														[
															437.329,
															621.142
														],
														[
															446,
															600
														],
														[
															447.526,
															595.55
														],
														[
															449,
															591
														],
														[
															462.402,
															542.219
														],
														[
															472,
															491
														],
														[
															478.982,
															423.083
														],
														[
															481,
															352
														],
														[
															475.687,
															260.968
														],
														[
															461,
															176
														],
														[
															448.724,
															133.478
														],
														[
															433,
															94
														],
														[
															422.815,
															74.53
														],
														[
															411,
															58
														],
														[
															410.486,
															56.536
														],
														[
															410,
															55
														],
														[
															407.089,
															52.008
														],
														[
															404,
															49
														],
														[
															400.91,
															45.247
														],
														[
															398,
															42
														],
														[
															396.498,
															41.463
														],
														[
															395,
															41
														],
														[
															394.026,
															40.035
														],
														[
															393,
															39
														],
														[
															389.372,
															36.247
														],
														[
															386,
															34
														],
														[
															378.977,
															29.933
														],
														[
															371,
															27
														],
														[
															364.508,
															25.816
														],
														[
															360,
															26
														],
														[
															346.169,
															29.779
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 34,
											"s": [
												{
													"i": [
														[
															2.81,
															-1.486
														],
														[
															0.237,
															-0.25
														],
														[
															0.241,
															-0.298
														],
														[
															0.259,
															-0.274
														],
														[
															0.288,
															-0.178
														],
														[
															0.437,
															-0.159
														],
														[
															0.431,
															-0.123
														],
														[
															0.403,
															-0.152
														],
														[
															0.353,
															-0.248
														],
														[
															0.245,
															-0.247
														],
														[
															0.252,
															-0.282
														],
														[
															0.256,
															-0.269
														],
														[
															0.257,
															-0.209
														],
														[
															1.588,
															-1.298
														],
														[
															1.543,
															-1.329
														],
														[
															1.433,
															-1.367
														],
														[
															1.259,
															-1.411
														],
														[
															0.152,
															-0.328
														],
														[
															0.145,
															-0.376
														],
														[
															0.17,
															-0.36
														],
														[
															0.228,
															-0.28
														],
														[
															0.355,
															-0.253
														],
														[
															0.392,
															-0.24
														],
														[
															0.341,
															-0.242
														],
														[
															0.203,
															-0.259
														],
														[
															0.17,
															-0.346
														],
														[
															0.158,
															-0.378
														],
														[
															0.159,
															-0.343
														],
														[
															0.173,
															-0.24
														],
														[
															1.241,
															-1.68
														],
														[
															1.213,
															-1.675
														],
														[
															1.115,
															-1.658
														],
														[
															0.948,
															-1.629
														],
														[
															0.33,
															-0.747
														],
														[
															0.309,
															-0.781
														],
														[
															0.324,
															-0.768
														],
														[
															0.376,
															-0.709
														],
														[
															1.126,
															-2.21
														],
														[
															1.091,
															-2.251
														],
														[
															1.044,
															-2.291
														],
														[
															0.986,
															-2.328
														],
														[
															3.278,
															-9.713
														],
														[
															2.614,
															-10.153
														],
														[
															2.154,
															-11.113
														],
														[
															1.899,
															-12.594
														],
														[
															1.135,
															-12.266
														],
														[
															0.483,
															-12.454
														],
														[
															-0.143,
															-12.586
														],
														[
															-0.744,
															-12.663
														],
														[
															-1.212,
															-11.643
														],
														[
															-1.688,
															-11.124
														],
														[
															-2.132,
															-10.419
														],
														[
															-2.544,
															-9.528
														],
														[
															-2.217,
															-7.129
														],
														[
															-2.54,
															-6.868
														],
														[
															-2.928,
															-6.555
														],
														[
															-3.381,
															-6.189
														],
														[
															-3.565,
															-5.711
														],
														[
															-3.866,
															-5.123
														],
														[
															-4.243,
															-4.35
														],
														[
															-4.695,
															-3.392
														],
														[
															-1.047,
															-0.605
														],
														[
															-1.115,
															-0.565
														],
														[
															-1.136,
															-0.553
														],
														[
															-1.109,
															-0.567
														],
														[
															-0.481,
															-0.352
														],
														[
															-0.49,
															-0.382
														],
														[
															-0.514,
															-0.339
														],
														[
															-0.552,
															-0.223
														],
														[
															-0.922,
															-0.185
														],
														[
															-0.839,
															-0.106
														],
														[
															-0.622,
															-0.119
														],
														[
															-0.273,
															-0.221
														],
														[
															-0.576,
															-1.997
														],
														[
															-0.944,
															-1.59
														],
														[
															-0.279,
															-0.014
														],
														[
															-2.106,
															-0.631
														],
														[
															-1.761,
															0.239
														],
														[
															-1.885,
															0.365
														],
														[
															-2.504,
															1.023
														],
														[
															-2.288,
															1.195
														],
														[
															-4.706,
															3.524
														],
														[
															-3.845,
															4.121
														],
														[
															-6.656,
															10.821
														],
														[
															-5.452,
															12.223
														],
														[
															-6.494,
															28.3
														],
														[
															-3.019,
															32.13
														],
														[
															1.24,
															35.105
														],
														[
															5.381,
															31.044
														],
														[
															3.486,
															13.089
														],
														[
															3.646,
															11.751
														],
														[
															5.163,
															11.264
														],
														[
															6.419,
															10.282
														],
														[
															9.584,
															9.78
														],
														[
															12.625,
															4.602
														],
														[
															1.056,
															0.361
														],
														[
															0.926,
															0.245
														],
														[
															2.847,
															0.091
														],
														[
															1.591,
															-0.162
														],
														[
															4.224,
															-1.27
														]
													],
													"o": [
														[
															-0.246,
															0.13
														],
														[
															-0.237,
															0.25
														],
														[
															-0.241,
															0.298
														],
														[
															-0.259,
															0.274
														],
														[
															-0.422,
															0.261
														],
														[
															-0.437,
															0.159
														],
														[
															-0.431,
															0.123
														],
														[
															-0.403,
															0.152
														],
														[
															-0.236,
															0.165
														],
														[
															-0.245,
															0.247
														],
														[
															-0.252,
															0.282
														],
														[
															-0.256,
															0.269
														],
														[
															-1.57,
															1.272
														],
														[
															-1.588,
															1.298
														],
														[
															-1.543,
															1.329
														],
														[
															-1.433,
															1.367
														],
														[
															-0.192,
															0.215
														],
														[
															-0.152,
															0.328
														],
														[
															-0.145,
															0.376
														],
														[
															-0.17,
															0.36
														],
														[
															-0.229,
															0.281
														],
														[
															-0.355,
															0.253
														],
														[
															-0.392,
															0.24
														],
														[
															-0.341,
															0.242
														],
														[
															-0.195,
															0.248
														],
														[
															-0.17,
															0.346
														],
														[
															-0.158,
															0.378
														],
														[
															-0.159,
															0.343
														],
														[
															-1.2,
															1.673
														],
														[
															-1.241,
															1.68
														],
														[
															-1.213,
															1.675
														],
														[
															-1.115,
															1.658
														],
														[
															-0.388,
															0.667
														],
														[
															-0.33,
															0.747
														],
														[
															-0.309,
															0.781
														],
														[
															-0.324,
															0.768
														],
														[
															-1.149,
															2.166
														],
														[
															-1.126,
															2.21
														],
														[
															-1.091,
															2.251
														],
														[
															-1.044,
															2.291
														],
														[
															-4.147,
															9.794
														],
														[
															-3.278,
															9.713
														],
														[
															-2.614,
															10.153
														],
														[
															-2.154,
															11.113
														],
														[
															-1.812,
															12.022
														],
														[
															-1.135,
															12.266
														],
														[
															-0.483,
															12.454
														],
														[
															0.143,
															12.586
														],
														[
															0.703,
															11.975
														],
														[
															1.212,
															11.643
														],
														[
															1.688,
															11.124
														],
														[
															2.132,
															10.419
														],
														[
															1.959,
															7.337
														],
														[
															2.217,
															7.129
														],
														[
															2.54,
															6.868
														],
														[
															2.928,
															6.555
														],
														[
															3.34,
															6.115
														],
														[
															3.565,
															5.711
														],
														[
															3.866,
															5.123
														],
														[
															4.243,
															4.35
														],
														[
															0.93,
															0.672
														],
														[
															1.047,
															0.605
														],
														[
															1.115,
															0.565
														],
														[
															1.136,
															0.553
														],
														[
															0.487,
															0.249
														],
														[
															0.481,
															0.352
														],
														[
															0.49,
															0.382
														],
														[
															0.514,
															0.339
														],
														[
															0.872,
															0.353
														],
														[
															0.922,
															0.185
														],
														[
															0.839,
															0.106
														],
														[
															0.622,
															0.119
														],
														[
															1.752,
															1.421
														],
														[
															0.576,
															1.997
														],
														[
															0.78,
															1.313
														],
														[
															0.279,
															0.014
														],
														[
															1.071,
															0.321
														],
														[
															1.761,
															-0.239
														],
														[
															3.695,
															-0.715
														],
														[
															2.504,
															-1.023
														],
														[
															5.332,
															-2.784
														],
														[
															4.706,
															-3.524
														],
														[
															7.924,
															-8.495
														],
														[
															6.656,
															-10.821
														],
														[
															11.005,
															-24.669
														],
														[
															6.494,
															-28.3
														],
														[
															3.339,
															-35.537
														],
														[
															-1.24,
															-35.105
														],
														[
															-2.408,
															-13.892
														],
														[
															-3.486,
															-13.089
														],
														[
															-3.929,
															-12.663
														],
														[
															-5.163,
															-11.264
														],
														[
															-7.041,
															-11.278
														],
														[
															-9.584,
															-9.78
														],
														[
															-0.85,
															-0.309
														],
														[
															-1.056,
															-0.361
														],
														[
															-3.02,
															-0.799
														],
														[
															-2.847,
															-0.091
														],
														[
															-4.293,
															0.435
														],
														[
															-4.224,
															1.27
														]
													],
													"v": [
														[
															335,
															33
														],
														[
															334.279,
															33.588
														],
														[
															333.564,
															34.427
														],
														[
															332.817,
															35.303
														],
														[
															332,
															36
														],
														[
															330.705,
															36.614
														],
														[
															329.397,
															37.02
														],
														[
															328.14,
															37.416
														],
														[
															327,
															38
														],
														[
															326.279,
															38.63
														],
														[
															325.533,
															39.435
														],
														[
															324.771,
															40.272
														],
														[
															324,
															41
														],
														[
															319.246,
															44.853
														],
														[
															314.534,
															48.791
														],
														[
															310.054,
															52.834
														],
														[
															306,
															57
														],
														[
															305.491,
															57.831
														],
														[
															305.053,
															58.903
														],
														[
															304.589,
															60.024
														],
														[
															304,
															61
														],
														[
															303.103,
															61.797
														],
														[
															301.961,
															62.533
														],
														[
															300.838,
															63.253
														],
														[
															300,
															64
														],
														[
															299.456,
															64.908
														],
														[
															298.967,
															66.012
														],
														[
															298.494,
															67.109
														],
														[
															298,
															68
														],
														[
															294.321,
															73.032
														],
														[
															290.622,
															78.066
														],
														[
															287.113,
															83.067
														],
														[
															284,
															88
														],
														[
															282.932,
															90.133
														],
														[
															281.982,
															92.437
														],
														[
															281.042,
															94.772
														],
														[
															280,
															97
														],
														[
															276.583,
															103.564
														],
														[
															273.254,
															110.256
														],
														[
															270.048,
															117.07
														],
														[
															267,
															124
														],
														[
															255.914,
															153.131
														],
														[
															247.128,
															182.8
														],
														[
															240.028,
															214.569
														],
														[
															234,
															250
														],
														[
															229.586,
															286.446
														],
														[
															227.166,
															323.538
														],
														[
															226.663,
															361.112
														],
														[
															228,
															399
														],
														[
															230.881,
															434.473
														],
														[
															235.24,
															468.671
														],
														[
															240.978,
															501.033
														],
														[
															248,
															531
														],
														[
															254.248,
															552.713
														],
														[
															261.367,
															573.723
														],
														[
															269.553,
															593.871
														],
														[
															279,
															613
														],
														[
															289.339,
															630.785
														],
														[
															300.468,
															647.084
														],
														[
															312.613,
															661.34
														],
														[
															326,
															673
														],
														[
															328.976,
															674.908
														],
														[
															332.231,
															676.656
														],
														[
															335.621,
															678.326
														],
														[
															339,
															680
														],
														[
															340.449,
															680.92
														],
														[
															341.903,
															682.039
														],
														[
															343.406,
															683.138
														],
														[
															345,
															684
														],
														[
															347.724,
															684.784
														],
														[
															350.399,
															685.198
														],
														[
															352.624,
															685.513
														],
														[
															354,
															686
														],
														[
															357.106,
															691.374
														],
														[
															359,
															697
														],
														[
															360.006,
															698.511
														],
														[
															363,
															699
														],
														[
															367.389,
															699.014
														],
														[
															373,
															698
														],
														[
															382.055,
															695.36
														],
														[
															389,
															692
														],
														[
															404.116,
															682.503
														],
														[
															417,
															671
														],
														[
															438.854,
															641.796
														],
														[
															457,
															607
														],
														[
															482.99,
															527.596
														],
														[
															497,
															437
														],
														[
															500.041,
															330.13
														],
														[
															490,
															230
														],
														[
															480.928,
															189.395
														],
														[
															470,
															152
														],
														[
															456.368,
															116.214
														],
														[
															439,
															84
														],
														[
															414.188,
															51.493
														],
														[
															381,
															29
														],
														[
															378.057,
															27.952
														],
														[
															375,
															27
														],
														[
															365.928,
															25.78
														],
														[
															359,
															26
														],
														[
															345.889,
															28.712
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 35,
											"s": [
												{
													"i": [
														[
															8.515,
															-5.067
														],
														[
															0.635,
															-0.527
														],
														[
															0.529,
															-0.337
														],
														[
															0.936,
															-0.286
														],
														[
															0.587,
															-0.43
														],
														[
															1.113,
															-1.249
														],
														[
															1.31,
															-1.097
														],
														[
															1.403,
															-0.974
														],
														[
															1.105,
															-1.03
														],
														[
															0.961,
															-1.202
														],
														[
															1.067,
															-1.177
														],
														[
															1.428,
															-1.536
														],
														[
															0.822,
															-1.239
														],
														[
															1.697,
															-2.166
														],
														[
															0.964,
															-1.454
														],
														[
															0.593,
															-0.876
														],
														[
															0.799,
															-1.246
														],
														[
															0.527,
															-0.645
														],
														[
															0.402,
															-0.653
														],
														[
															0.287,
															-0.902
														],
														[
															0.411,
															-0.674
														],
														[
															0.527,
															-0.624
														],
														[
															0.435,
															-0.752
														],
														[
															2.924,
															-6.301
														],
														[
															2.742,
															-6.633
														],
														[
															4.945,
															-17.927
														],
														[
															3.392,
															-20.769
														],
														[
															1.3,
															-21.138
														],
														[
															-0.413,
															-19.769
														],
														[
															-7.19,
															-34.642
														],
														[
															-12.398,
															-28.143
														],
														[
															-3.829,
															-6.73
														],
														[
															-3.509,
															-5.875
														],
														[
															-0.701,
															-1.019
														],
														[
															-0.494,
															-0.745
														],
														[
															-0.362,
															-0.296
														],
														[
															-0.253,
															-0.369
														],
														[
															-0.298,
															-0.966
														],
														[
															-0.412,
															-0.561
														],
														[
															-1.255,
															-1.119
														],
														[
															-1.015,
															-1.21
														],
														[
															-0.189,
															-0.42
														],
														[
															-0.091,
															-0.136
														],
														[
															-0.82,
															-0.938
														],
														[
															-0.901,
															-1.01
														],
														[
															-4.854,
															-4.188
														],
														[
															-4.692,
															-2.888
														],
														[
															-0.298,
															-0.376
														],
														[
															-0.357,
															-0.218
														],
														[
															-2.481,
															-0.977
														],
														[
															-2.243,
															-0.974
														],
														[
															-1.133,
															-0.517
														],
														[
															-1.31,
															-0.429
														],
														[
															-0.593,
															-0.128
														],
														[
															-0.938,
															-0.262
														],
														[
															-1.013,
															-0.24
														],
														[
															-0.126,
															-0.09
														],
														[
															-0.845,
															-2.728
														],
														[
															-1.551,
															-0.62
														],
														[
															-0.532,
															0.082
														],
														[
															-0.441,
															-0.153
														],
														[
															-4.004,
															0.89
														],
														[
															-4.202,
															1.406
														],
														[
															-5.178,
															3.042
														],
														[
															-4.427,
															3.535
														],
														[
															-0.32,
															0.359
														],
														[
															-0.341,
															0.261
														],
														[
															-0.56,
															0.095
														],
														[
															-0.376,
															0.33
														],
														[
															-1.104,
															1.39
														],
														[
															-1.201,
															1.231
														],
														[
															-1.084,
															0.782
														],
														[
															-0.601,
															0.786
														],
														[
															-0.093,
															0.557
														],
														[
															-0.331,
															0.384
														],
														[
															-1.222,
															1.116
														],
														[
															-1.005,
															1.25
														],
														[
															-4.199,
															7.254
														],
														[
															-1.535,
															2.721
														],
														[
															-5.027,
															11.929
														],
														[
															-6.522,
															31.297
														],
														[
															27.845,
															93.247
														],
														[
															1.174,
															3.527
														],
														[
															1.401,
															3.04
														],
														[
															4.179,
															8.805
														],
														[
															3.499,
															6.591
														],
														[
															1.8,
															3.008
														],
														[
															0.323,
															0.431
														],
														[
															0.452,
															0.709
														],
														[
															3.902,
															5.103
														],
														[
															0.673,
															0.849
														],
														[
															1.228,
															1.421
														],
														[
															1.283,
															1.401
														],
														[
															5.545,
															4.634
														],
														[
															1.533,
															1.122
														],
														[
															1.491,
															0.98
														],
														[
															1.414,
															0.832
														],
														[
															3.07,
															1.384
														],
														[
															3.163,
															1.015
														],
														[
															6.43,
															-0.569
														]
													],
													"o": [
														[
															-0.933,
															0.555
														],
														[
															-0.635,
															0.527
														],
														[
															-0.667,
															0.425
														],
														[
															-0.936,
															0.286
														],
														[
															-1.24,
															0.907
														],
														[
															-1.113,
															1.249
														],
														[
															-1.284,
															1.075
														],
														[
															-1.403,
															0.974
														],
														[
															-1.088,
															1.015
														],
														[
															-0.961,
															1.202
														],
														[
															-1.469,
															1.619
														],
														[
															-1.427,
															1.536
														],
														[
															-1.249,
															1.882
														],
														[
															-1.697,
															2.166
														],
														[
															-0.83,
															1.251
														],
														[
															-0.593,
															0.876
														],
														[
															-0.491,
															0.767
														],
														[
															-0.527,
															0.645
														],
														[
															-0.442,
															0.718
														],
														[
															-0.287,
															0.902
														],
														[
															-0.457,
															0.751
														],
														[
															-0.527,
															0.624
														],
														[
															-3.563,
															6.165
														],
														[
															-2.924,
															6.301
														],
														[
															-6.829,
															16.524
														],
														[
															-4.945,
															17.927
														],
														[
															-3.213,
															19.677
														],
														[
															-1.3,
															21.138
														],
														[
															0.843,
															40.291
														],
														[
															7.19,
															34.641
														],
														[
															3.174,
															7.206
														],
														[
															3.829,
															6.73
														],
														[
															0.703,
															1.178
														],
														[
															0.701,
															1.019
														],
														[
															0.298,
															0.448
														],
														[
															0.362,
															0.296
														],
														[
															0.397,
															0.577
														],
														[
															0.298,
															0.966
														],
														[
															0.966,
															1.313
														],
														[
															1.255,
															1.119
														],
														[
															0.154,
															0.185
														],
														[
															0.189,
															0.42
														],
														[
															0.82,
															1.236
														],
														[
															0.82,
															0.938
														],
														[
															3.893,
															4.361
														],
														[
															4.854,
															4.188
														],
														[
															0.452,
															0.278
														],
														[
															0.298,
															0.376
														],
														[
															1.832,
															1.119
														],
														[
															2.481,
															0.977
														],
														[
															1.156,
															0.502
														],
														[
															1.133,
															0.517
														],
														[
															0.69,
															0.226
														],
														[
															0.593,
															0.128
														],
														[
															-0.179,
															-0.05
														],
														[
															1.013,
															0.24
														],
														[
															2.067,
															1.467
														],
														[
															0.845,
															2.728
														],
														[
															0.433,
															0.173
														],
														[
															0.532,
															-0.082
														],
														[
															2.782,
															0.966
														],
														[
															4.004,
															-0.89
														],
														[
															6.861,
															-2.295
														],
														[
															5.178,
															-3.042
														],
														[
															0.381,
															-0.304
														],
														[
															0.32,
															-0.359
														],
														[
															0.382,
															-0.292
														],
														[
															0.56,
															-0.095
														],
														[
															1.385,
															-1.211
														],
														[
															1.104,
															-1.39
														],
														[
															1.061,
															-1.087
														],
														[
															1.084,
															-0.782
														],
														[
															0.296,
															-0.387
														],
														[
															0.093,
															-0.557
														],
														[
															1.108,
															-1.286
														],
														[
															1.222,
															-1.116
														],
														[
															5.911,
															-7.352
														],
														[
															1.542,
															-2.663
														],
														[
															6.172,
															-10.938
														],
														[
															11.988,
															-28.451
														],
														[
															20.688,
															-99.269
														],
														[
															-1.046,
															-3.504
														],
														[
															-1.525,
															-4.583
														],
														[
															-4.516,
															-9.799
														],
														[
															-3.515,
															-7.406
														],
														[
															-1.697,
															-3.196
														],
														[
															-0.245,
															-0.41
														],
														[
															-0.589,
															-0.785
														],
														[
															-4.125,
															-6.472
														],
														[
															-0.624,
															-0.816
														],
														[
															-0.979,
															-1.235
														],
														[
															-1.257,
															-1.455
														],
														[
															-5.475,
															-5.98
														],
														[
															-1.574,
															-1.316
														],
														[
															-1.428,
															-1.045
														],
														[
															-1.797,
															-1.181
														],
														[
															-2.401,
															-1.412
														],
														[
															-3.235,
															-1.459
														],
														[
															-9.475,
															-3.041
														],
														[
															-13.963,
															1.236
														]
													],
													"v": [
														[
															323,
															38
														],
														[
															320.698,
															39.663
														],
														[
															319,
															41
														],
														[
															316.44,
															41.997
														],
														[
															314,
															43
														],
														[
															310.553,
															46.357
														],
														[
															307,
															50
														],
														[
															302.866,
															53.033
														],
														[
															299,
															56
														],
														[
															295.984,
															59.379
														],
														[
															293,
															63
														],
														[
															288.515,
															67.785
														],
														[
															285,
															72
														],
														[
															280.287,
															78.321
														],
														[
															276,
															84
														],
														[
															273.977,
															87.003
														],
														[
															272,
															90
														],
														[
															270.433,
															92.085
														],
														[
															269,
															94
														],
														[
															267.977,
															96.533
														],
														[
															267,
															99
														],
														[
															265.483,
															100.999
														],
														[
															264,
															103
														],
														[
															254.383,
															121.649
														],
														[
															246,
															141
														],
														[
															228.422,
															192.316
														],
														[
															216,
															250
														],
														[
															209.28,
															311.931
														],
														[
															208,
															374
														],
														[
															220.333,
															486.611
														],
														[
															250,
															581
														],
														[
															260.75,
															601.998
														],
														[
															272,
															621
														],
														[
															274.157,
															624.325
														],
														[
															276,
															627
														],
														[
															277.033,
															628.06
														],
														[
															278,
															629
														],
														[
															278.988,
															631.512
														],
														[
															280,
															634
														],
														[
															283.463,
															637.577
														],
														[
															287,
															641
														],
														[
															287.548,
															642.036
														],
														[
															288,
															643
														],
														[
															290.438,
															646.169
														],
														[
															293,
															649
														],
														[
															306.4,
															662.105
														],
														[
															321,
															673
														],
														[
															322.071,
															674.045
														],
														[
															323,
															675
														],
														[
															329.692,
															678.108
														],
														[
															337,
															681
														],
														[
															340.384,
															682.555
														],
														[
															344,
															684
														],
														[
															345.814,
															684.473
														],
														[
															348,
															685
														],
														[
															349.771,
															685.395
														],
														[
															352,
															686
														],
														[
															355.887,
															693.135
														],
														[
															359,
															699
														],
														[
															360.494,
															699.015
														],
														[
															362,
															699
														],
														[
															372.435,
															698.779
														],
														[
															385,
															695
														],
														[
															402.826,
															686.93
														],
														[
															417,
															677
														],
														[
															418.03,
															675.967
														],
														[
															419,
															675
														],
														[
															420.504,
															674.528
														],
														[
															422,
															674
														],
														[
															425.638,
															670.015
														],
														[
															429,
															666
														],
														[
															432.345,
															663.274
														],
														[
															435,
															661
														],
														[
															435.473,
															659.498
														],
														[
															436,
															658
														],
														[
															439.578,
															654.472
														],
														[
															443,
															651
														],
														[
															459,
															627
														],
														[
															463,
															620
														],
														[
															480,
															585
														],
														[
															507,
															495
														],
														[
															495,
															180
														],
														[
															491,
															170
														],
														[
															487,
															156
														],
														[
															475,
															128
														],
														[
															465,
															108
														],
														[
															460,
															98
														],
														[
															458,
															97
														],
														[
															457,
															94
														],
														[
															443,
															75
														],
														[
															442,
															72
														],
														[
															438,
															69
														],
														[
															435,
															64
														],
														[
															416,
															47
														],
														[
															412,
															43
														],
														[
															407,
															41
														],
														[
															403,
															37
														],
														[
															394,
															33
														],
														[
															384,
															29
														],
														[
															358,
															26
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 36,
											"s": [
												{
													"i": [
														[
															4.339,
															-1.713
														],
														[
															0.835,
															-0.398
														],
														[
															0.812,
															-0.428
														],
														[
															0.821,
															-0.441
														],
														[
															0.862,
															-0.438
														],
														[
															0.943,
															-0.398
														],
														[
															0.949,
															-0.388
														],
														[
															0.906,
															-0.421
														],
														[
															0.816,
															-0.498
														],
														[
															0.556,
															-0.45
														],
														[
															0.547,
															-0.489
														],
														[
															0.467,
															-0.42
														],
														[
															0.318,
															-0.243
														],
														[
															0.25,
															-0.071
														],
														[
															0.266,
															-0.042
														],
														[
															0.258,
															-0.075
														],
														[
															0.226,
															-0.169
														],
														[
															0.55,
															-0.551
														],
														[
															0.514,
															-0.572
														],
														[
															0.457,
															-0.485
														],
														[
															0.378,
															-0.289
														],
														[
															0.257,
															-0.07
														],
														[
															0.279,
															-0.047
														],
														[
															0.257,
															-0.079
														],
														[
															0.192,
															-0.165
														],
														[
															1.322,
															-1.354
														],
														[
															1.251,
															-1.403
														],
														[
															1.178,
															-1.348
														],
														[
															1.103,
															-1.188
														],
														[
															4.221,
															-5.496
														],
														[
															3.783,
															-5.912
														],
														[
															3.295,
															-6.21
														],
														[
															2.758,
															-6.391
														],
														[
															0.934,
															-2.183
														],
														[
															0.921,
															-2.224
														],
														[
															0.901,
															-2.304
														],
														[
															0.875,
															-2.423
														],
														[
															3.893,
															-14.162
														],
														[
															2.809,
															-15.305
														],
														[
															1.511,
															-16.615
														],
														[
															0,
															-18.093
														],
														[
															-3.784,
															-27.411
														],
														[
															-7.277,
															-24.329
														],
														[
															-10.48,
															-20.378
														],
														[
															-13.392,
															-15.559
														],
														[
															-2.978,
															-3.104
														],
														[
															-2.658,
															-1.763
														],
														[
															-1.881,
															-1.625
														],
														[
															-1.52,
															-1.2
														],
														[
															-1.526,
															-0.981
														],
														[
															-1.365,
															-0.869
														],
														[
															-2.885,
															-1.508
														],
														[
															-3.424,
															-1.035
														],
														[
															-0.391,
															-0.461
														],
														[
															-0.25,
															-0.102
														],
														[
															-1.901,
															-0.626
														],
														[
															-2.13,
															-0.569
														],
														[
															-1.369,
															-0.095
														],
														[
															-0.586,
															-0.368
														],
														[
															-0.659,
															-1.187
														],
														[
															-0.764,
															-1.246
														],
														[
															0.045,
															-0.829
														],
														[
															-0.47,
															-0.524
														],
														[
															-0.767,
															0.025
														],
														[
															-1.368,
															-0.473
														],
														[
															-4.47,
															0.706
														],
														[
															-4.197,
															1.188
														],
														[
															-9.535,
															6.182
														],
														[
															-6.882,
															6.882
														],
														[
															-4.046,
															4.888
														],
														[
															-3.243,
															4.873
														],
														[
															-0.956,
															1.077
														],
														[
															-0.45,
															0.6
														],
														[
															-0.112,
															0.557
														],
														[
															-0.248,
															0.367
														],
														[
															-0.393,
															0.335
														],
														[
															-0.216,
															0.348
														],
														[
															-0.096,
															0.504
														],
														[
															-0.323,
															0.514
														],
														[
															-3.057,
															5.387
														],
														[
															-1.664,
															5.506
														],
														[
															-0.459,
															0.393
														],
														[
															-0.108,
															0.245
														],
														[
															-7.217,
															32.32
														],
														[
															-1.84,
															37.752
														],
														[
															1.826,
															24.238
														],
														[
															3.822,
															19.956
														],
														[
															3.142,
															12.507
														],
														[
															3.904,
															10.771
														],
														[
															14.154,
															22.112
														],
														[
															20.2,
															14.218
														],
														[
															3.18,
															2.08
														],
														[
															3.176,
															1.493
														],
														[
															2.217,
															0.635
														],
														[
															1.328,
															0.612
														],
														[
															1.376,
															0.524
														],
														[
															1.177,
															0.294
														],
														[
															4.764,
															0.285
														],
														[
															3.266,
															-0.305
														],
														[
															4.193,
															-0.958
														]
													],
													"o": [
														[
															-0.89,
															0.351
														],
														[
															-0.835,
															0.398
														],
														[
															-0.812,
															0.428
														],
														[
															-0.821,
															0.441
														],
														[
															-0.889,
															0.451
														],
														[
															-0.943,
															0.398
														],
														[
															-0.949,
															0.388
														],
														[
															-0.906,
															0.421
														],
														[
															-0.495,
															0.303
														],
														[
															-0.556,
															0.45
														],
														[
															-0.547,
															0.489
														],
														[
															-0.467,
															0.42
														],
														[
															-0.211,
															0.161
														],
														[
															-0.25,
															0.071
														],
														[
															-0.266,
															0.042
														],
														[
															-0.258,
															0.075
														],
														[
															-0.564,
															0.421
														],
														[
															-0.55,
															0.551
														],
														[
															-0.514,
															0.572
														],
														[
															-0.457,
															0.485
														],
														[
															-0.193,
															0.148
														],
														[
															-0.257,
															0.07
														],
														[
															-0.279,
															0.047
														],
														[
															-0.257,
															0.079
														],
														[
															-1.392,
															1.2
														],
														[
															-1.323,
															1.354
														],
														[
															-1.251,
															1.403
														],
														[
															-1.178,
															1.348
														],
														[
															-4.61,
															4.962
														],
														[
															-4.221,
															5.496
														],
														[
															-3.783,
															5.912
														],
														[
															-3.295,
															6.21
														],
														[
															-0.942,
															2.183
														],
														[
															-0.934,
															2.183
														],
														[
															-0.921,
															2.224
														],
														[
															-0.901,
															2.304
														],
														[
															-4.764,
															13.188
														],
														[
															-3.893,
															14.162
														],
														[
															-2.809,
															15.305
														],
														[
															-1.511,
															16.615
														],
														[
															0,
															29.625
														],
														[
															3.784,
															27.411
														],
														[
															7.277,
															24.329
														],
														[
															10.48,
															20.378
														],
														[
															2.429,
															2.822
														],
														[
															2.978,
															3.104
														],
														[
															1.957,
															1.298
														],
														[
															1.881,
															1.625
														],
														[
															1.531,
															1.208
														],
														[
															1.526,
															0.981
														],
														[
															3.038,
															1.933
														],
														[
															2.885,
															1.508
														],
														[
															0.184,
															0.055
														],
														[
															0.391,
															0.461
														],
														[
															2.267,
															0.929
														],
														[
															1.901,
															0.625
														],
														[
															0.94,
															0.251
														],
														[
															1.369,
															0.095
														],
														[
															1.601,
															1.007
														],
														[
															0.659,
															1.187
														],
														[
															0.711,
															1.159
														],
														[
															-0.045,
															0.829
														],
														[
															0.563,
															0.629
														],
														[
															0.767,
															-0.025
														],
														[
															2.922,
															1.011
														],
														[
															4.47,
															-0.706
														],
														[
															11.977,
															-3.389
														],
														[
															9.535,
															-6.182
														],
														[
															4.574,
															-4.574
														],
														[
															4.046,
															-4.888
														],
														[
															0.727,
															-1.093
														],
														[
															0.956,
															-1.077
														],
														[
															0.305,
															-0.407
														],
														[
															0.112,
															-0.557
														],
														[
															0.211,
															-0.312
														],
														[
															0.393,
															-0.335
														],
														[
															0.293,
															-0.471
														],
														[
															0.096,
															-0.504
														],
														[
															3.108,
															-4.947
														],
														[
															3.057,
															-5.387
														],
														[
															0.055,
															-0.182
														],
														[
															0.459,
															-0.393
														],
														[
															12.293,
															-27.968
														],
														[
															7.217,
															-32.32
														],
														[
															1.125,
															-23.091
														],
														[
															-1.826,
															-24.238
														],
														[
															-2.529,
															-13.202
														],
														[
															-3.142,
															-12.507
														],
														[
															-9.183,
															-25.332
														],
														[
															-14.154,
															-22.112
														],
														[
															-3.105,
															-2.185
														],
														[
															-3.18,
															-2.08
														],
														[
															-1.802,
															-0.847
														],
														[
															-2.217,
															-0.635
														],
														[
															-1.321,
															-0.608
														],
														[
															-1.376,
															-0.524
														],
														[
															-4.678,
															-1.166
														],
														[
															-4.764,
															-0.285
														],
														[
															-4.89,
															0.456
														],
														[
															-4.192,
															0.958
														]
													],
													"v": [
														[
															331,
															32
														],
														[
															328.421,
															33.128
														],
														[
															325.959,
															34.37
														],
														[
															323.517,
															35.678
														],
														[
															321,
															37
														],
														[
															318.24,
															38.262
														],
														[
															315.39,
															39.429
														],
														[
															312.595,
															40.631
														],
														[
															310,
															42
														],
														[
															308.406,
															43.155
														],
														[
															306.734,
															44.589
														],
														[
															305.196,
															45.979
														],
														[
															304,
															47
														],
														[
															303.302,
															47.333
														],
														[
															302.523,
															47.488
														],
														[
															301.732,
															47.649
														],
														[
															301,
															48
														],
														[
															299.323,
															49.486
														],
														[
															297.72,
															51.199
														],
														[
															296.258,
															52.812
														],
														[
															295,
															54
														],
														[
															294.313,
															54.312
														],
														[
															293.498,
															54.473
														],
														[
															292.684,
															54.648
														],
														[
															292,
															55
														],
														[
															287.927,
															58.857
														],
														[
															284.067,
															63.019
														],
														[
															280.423,
															67.171
														],
														[
															277,
															71
														],
														[
															263.74,
															86.716
														],
														[
															251.722,
															103.857
														],
														[
															241.093,
															122.069
														],
														[
															232,
															141
														],
														[
															229.184,
															147.538
														],
														[
															226.4,
															154.138
														],
														[
															223.666,
															160.919
														],
														[
															221,
															168
														],
														[
															207.961,
															208.983
														],
														[
															197.854,
															253.142
														],
														[
															191.32,
															300.98
														],
														[
															189,
															353
														],
														[
															194.748,
															438.771
														],
														[
															211.412,
															516.598
														],
														[
															238.12,
															583.876
														],
														[
															274,
															638
														],
														[
															282.329,
															647.295
														],
														[
															291,
															655
														],
														[
															296.827,
															659.573
														],
														[
															302,
															664
														],
														[
															306.625,
															667.255
														],
														[
															311,
															670
														],
														[
															319.71,
															675.173
														],
														[
															329,
															679
														],
														[
															329.95,
															679.965
														],
														[
															331,
															681
														],
														[
															337.102,
															683.27
														],
														[
															343,
															685
														],
														[
															346.765,
															685.412
														],
														[
															350,
															686
														],
														[
															353.128,
															689.321
														],
														[
															355,
															693
														],
														[
															355.681,
															695.976
														],
														[
															356,
															698
														],
														[
															357.897,
															698.617
														],
														[
															361,
															699
														],
														[
															372.543,
															699.149
														],
														[
															386,
															696
														],
														[
															418.321,
															681.119
														],
														[
															443,
															661
														],
														[
															455.999,
															646.725
														],
														[
															467,
															632
														],
														[
															469.709,
															628.63
														],
														[
															472,
															626
														],
														[
															472.543,
															624.47
														],
														[
															473,
															623
														],
														[
															473.996,
															622.027
														],
														[
															475,
															621
														],
														[
															475.477,
															619.533
														],
														[
															476,
															618
														],
														[
															485.583,
															602.419
														],
														[
															493,
															586
														],
														[
															493.96,
															585.048
														],
														[
															495,
															584
														],
														[
															524.34,
															493.838
														],
														[
															538,
															389
														],
														[
															536.711,
															316.648
														],
														[
															528,
															249
														],
														[
															519.531,
															210.177
														],
														[
															509,
															175
														],
														[
															474.263,
															102.664
														],
														[
															423,
															47
														],
														[
															413.554,
															40.481
														],
														[
															404,
															35
														],
														[
															397.644,
															32.823
														],
														[
															392,
															31
														],
														[
															387.892,
															29.264
														],
														[
															384,
															28
														],
														[
															369.441,
															25.897
														],
														[
															357,
															26
														],
														[
															343.587,
															28.057
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 37,
											"s": [
												{
													"i": [
														[
															2.673,
															-0.588
														],
														[
															1.68,
															-0.499
														],
														[
															1.5,
															-0.536
														],
														[
															1.32,
															-0.519
														],
														[
															1.139,
															-0.447
														],
														[
															0.514,
															-0.159
														],
														[
															0.492,
															-0.142
														],
														[
															0.483,
															-0.161
														],
														[
															0.484,
															-0.218
														],
														[
															4.284,
															-2.522
														],
														[
															3.886,
															-2.815
														],
														[
															3.534,
															-3.011
														],
														[
															3.228,
															-3.11
														],
														[
															7.958,
															-10.731
														],
														[
															6.534,
															-12.091
														],
														[
															5.184,
															-13.189
														],
														[
															3.908,
															-14.026
														],
														[
															0.808,
															-3.211
														],
														[
															0.711,
															-3.136
														],
														[
															0.673,
															-3.231
														],
														[
															0.694,
															-3.498
														],
														[
															0.259,
															-1.07
														],
														[
															0.276,
															-1.095
														],
														[
															0.254,
															-1.102
														],
														[
															0.192,
															-1.092
														],
														[
															1.117,
															-17.596
														],
														[
															-0.429,
															-17.95
														],
														[
															-1.832,
															-17.004
														],
														[
															-3.09,
															-14.759
														],
														[
															-0.175,
															-0.502
														],
														[
															-0.202,
															-0.519
														],
														[
															-0.176,
															-0.508
														],
														[
															-0.099,
															-0.467
														],
														[
															-0.413,
															-1.669
														],
														[
															-0.415,
															-1.5
														],
														[
															-0.419,
															-1.456
														],
														[
															-0.426,
															-1.537
														],
														[
															-1.765,
															-5.706
														],
														[
															-1.909,
															-5.458
														],
														[
															-2.065,
															-5.148
														],
														[
															-2.233,
															-4.774
														],
														[
															-1.042,
															-2.19
														],
														[
															-1.083,
															-2.197
														],
														[
															-1.125,
															-2.158
														],
														[
															-1.167,
															-2.075
														],
														[
															-0.971,
															-1.522
														],
														[
															-1,
															-1.487
														],
														[
															-0.904,
															-1.347
														],
														[
															-0.684,
															-1.1
														],
														[
															-0.069,
															-0.248
														],
														[
															-0.049,
															-0.257
														],
														[
															-0.08,
															-0.256
														],
														[
															-0.163,
															-0.243
														],
														[
															-0.345,
															-0.339
														],
														[
															-0.374,
															-0.319
														],
														[
															-0.342,
															-0.32
														],
														[
															-0.25,
															-0.343
														],
														[
															-0.077,
															-0.262
														],
														[
															-0.046,
															-0.269
														],
														[
															-0.071,
															-0.248
														],
														[
															-0.151,
															-0.197
														],
														[
															-4.048,
															-4.74
														],
														[
															-4.012,
															-4.077
														],
														[
															-5.555,
															-4.635
														],
														[
															-5.706,
															-3.303
														],
														[
															-0.788,
															-0.483
														],
														[
															-0.755,
															-0.437
														],
														[
															-0.788,
															-0.483
														],
														[
															-0.755,
															-0.437
														],
														[
															-4.127,
															-1.487
														],
														[
															-5.036,
															-1.473
														],
														[
															-3.183,
															-0.991
														],
														[
															-0.716,
															-1.289
														],
														[
															-0.406,
															-1.771
														],
														[
															-0.628,
															-0.575
														],
														[
															-0.761,
															0.017
														],
														[
															-1.222,
															-0.398
														],
														[
															-4.938,
															0.755
														],
														[
															-4.625,
															1.158
														],
														[
															-3.933,
															1.446
														],
														[
															-4.014,
															1.902
														],
														[
															-15.71,
															18.316
														],
														[
															-10.347,
															20.925
														],
														[
															-8.34,
															37.014
														],
														[
															-0.122,
															41.587
														],
														[
															4.978,
															29.778
														],
														[
															8.178,
															23.356
														],
														[
															11.195,
															19.588
														],
														[
															15.086,
															15.412
														],
														[
															1.487,
															1.277
														],
														[
															1.632,
															1.445
														],
														[
															1.277,
															1.385
														],
														[
															1.5,
															1.228
														],
														[
															6.317,
															3.752
														],
														[
															6.418,
															2.639
														],
														[
															3.245,
															1.258
														],
														[
															3.063,
															0.751
														],
														[
															5.77,
															0.274
														],
														[
															3.74,
															-0.367
														],
														[
															2.371,
															-0.283
														]
													],
													"o": [
														[
															-1.859,
															0.409
														],
														[
															-1.68,
															0.499
														],
														[
															-1.5,
															0.536
														],
														[
															-1.32,
															0.519
														],
														[
															-0.546,
															0.214
														],
														[
															-0.514,
															0.159
														],
														[
															-0.492,
															0.142
														],
														[
															-0.483,
															0.161
														],
														[
															-4.727,
															2.132
														],
														[
															-4.284,
															2.522
														],
														[
															-3.886,
															2.815
														],
														[
															-3.534,
															3.011
														],
														[
															-9.457,
															9.109
														],
														[
															-7.958,
															10.731
														],
														[
															-6.534,
															12.091
														],
														[
															-5.184,
															13.189
														],
														[
															-0.964,
															3.459
														],
														[
															-0.808,
															3.211
														],
														[
															-0.711,
															3.136
														],
														[
															-0.673,
															3.231
														],
														[
															-0.204,
															1.028
														],
														[
															-0.259,
															1.07
														],
														[
															-0.276,
															1.095
														],
														[
															-0.254,
															1.102
														],
														[
															-2.808,
															15.943
														],
														[
															-1.117,
															17.596
														],
														[
															0.429,
															17.95
														],
														[
															1.832,
															17.004
														],
														[
															0.095,
															0.455
														],
														[
															0.175,
															0.502
														],
														[
															0.202,
															0.519
														],
														[
															0.176,
															0.508
														],
														[
															0.413,
															1.963
														],
														[
															0.413,
															1.669
														],
														[
															0.415,
															1.5
														],
														[
															0.419,
															1.456
														],
														[
															1.632,
															5.892
														],
														[
															1.765,
															5.706
														],
														[
															1.909,
															5.458
														],
														[
															2.065,
															5.148
														],
														[
															1,
															2.138
														],
														[
															1.042,
															2.19
														],
														[
															1.083,
															2.197
														],
														[
															1.125,
															2.158
														],
														[
															0.816,
															1.451
														],
														[
															0.971,
															1.522
														],
														[
															1,
															1.487
														],
														[
															0.904,
															1.347
														],
														[
															0.142,
															0.228
														],
														[
															0.069,
															0.248
														],
														[
															0.049,
															0.257
														],
														[
															0.08,
															0.256
														],
														[
															0.255,
															0.381
														],
														[
															0.345,
															0.339
														],
														[
															0.374,
															0.319
														],
														[
															0.342,
															0.32
														],
														[
															0.164,
															0.225
														],
														[
															0.077,
															0.262
														],
														[
															0.046,
															0.269
														],
														[
															0.071,
															0.248
														],
														[
															3.795,
															4.962
														],
														[
															4.048,
															4.74
														],
														[
															5.075,
															5.157
														],
														[
															5.555,
															4.635
														],
														[
															1.093,
															0.633
														],
														[
															0.788,
															0.483
														],
														[
															1.093,
															0.633
														],
														[
															0.788,
															0.483
														],
														[
															4.456,
															2.58
														],
														[
															4.127,
															1.487
														],
														[
															2.549,
															0.745
														],
														[
															3.184,
															0.991
														],
														[
															0.746,
															1.342
														],
														[
															0.406,
															1.771
														],
														[
															0.732,
															0.671
														],
														[
															0.761,
															-0.017
														],
														[
															3.624,
															1.178
														],
														[
															4.938,
															-0.755
														],
														[
															5.255,
															-1.315
														],
														[
															3.933,
															-1.446
														],
														[
															22.812,
															-10.81
														],
														[
															15.71,
															-18.316
														],
														[
															14.517,
															-29.357
														],
														[
															8.34,
															-37.014
														],
														[
															0.09,
															-30.533
														],
														[
															-4.978,
															-29.778
														],
														[
															-8.137,
															-23.235
														],
														[
															-11.194,
															-19.588
														],
														[
															-1.418,
															-1.449
														],
														[
															-1.487,
															-1.277
														],
														[
															-1.39,
															-1.231
														],
														[
															-1.278,
															-1.385
														],
														[
															-5.314,
															-4.352
														],
														[
															-6.317,
															-3.752
														],
														[
															-2.959,
															-1.217
														],
														[
															-3.245,
															-1.258
														],
														[
															-5.179,
															-1.27
														],
														[
															-5.77,
															-0.274
														],
														[
															-2.841,
															0.279
														],
														[
															-2.371,
															0.283
														]
													],
													"v": [
														[
															341,
															28
														],
														[
															335.691,
															29.376
														],
														[
															330.92,
															30.942
														],
														[
															326.689,
															32.538
														],
														[
															323,
															34
														],
														[
															321.414,
															34.551
														],
														[
															319.907,
															34.994
														],
														[
															318.448,
															35.44
														],
														[
															317,
															36
														],
														[
															303.495,
															43.005
														],
														[
															291.252,
															51.033
														],
														[
															280.132,
															59.795
														],
														[
															270,
															69
														],
														[
															243.896,
															98.826
														],
														[
															222.177,
															133.125
														],
														[
															204.619,
															171.112
														],
														[
															191,
															212
														],
														[
															188.358,
															221.962
														],
														[
															186.095,
															231.44
														],
														[
															184.034,
															240.948
														],
														[
															182,
															251
														],
														[
															181.296,
															254.152
														],
														[
															180.483,
															257.404
														],
														[
															179.679,
															260.705
														],
														[
															179,
															264
														],
														[
															173.149,
															314.633
														],
														[
															172.153,
															368.276
														],
														[
															175.581,
															421.031
														],
														[
															183,
															469
														],
														[
															183.418,
															470.442
														],
														[
															183.995,
															471.981
														],
														[
															184.575,
															473.53
														],
														[
															185,
															475
														],
														[
															186.24,
															480.416
														],
														[
															187.482,
															485.139
														],
														[
															188.733,
															489.542
														],
														[
															190,
															494
														],
														[
															195.092,
															511.413
														],
														[
															200.599,
															528.176
														],
														[
															206.556,
															544.101
														],
														[
															213,
															559
														],
														[
															216.062,
															565.503
														],
														[
															219.249,
															572.095
														],
														[
															222.562,
															578.639
														],
														[
															226,
															585
														],
														[
															228.711,
															589.486
														],
														[
															231.698,
															594.026
														],
														[
															234.586,
															598.304
														],
														[
															237,
															602
														],
														[
															237.304,
															602.717
														],
														[
															237.469,
															603.477
														],
														[
															237.649,
															604.249
														],
														[
															238,
															605
														],
														[
															238.915,
															606.075
														],
														[
															240.008,
															607.057
														],
														[
															241.097,
															608.011
														],
														[
															242,
															609
														],
														[
															242.348,
															609.737
														],
														[
															242.519,
															610.541
														],
														[
															242.681,
															611.324
														],
														[
															243,
															612
														],
														[
															254.837,
															626.664
														],
														[
															267,
															640
														],
														[
															283.026,
															654.89
														],
														[
															300,
															667
														],
														[
															302.754,
															668.647
														],
														[
															305,
															670
														],
														[
															307.754,
															671.647
														],
														[
															310,
															673
														],
														[
															322.565,
															678.83
														],
														[
															336,
															683
														],
														[
															345.375,
															685.592
														],
														[
															352,
															689
														],
														[
															353.589,
															694.076
														],
														[
															355,
															698
														],
														[
															357.133,
															698.705
														],
														[
															360,
															699
														],
														[
															373.249,
															699.252
														],
														[
															388,
															696
														],
														[
															401.431,
															691.94
														],
														[
															413,
															687
														],
														[
															470.348,
															642.086
														],
														[
															509,
															582
														],
														[
															543.796,
															481.673
														],
														[
															557,
															363
														],
														[
															549.201,
															271.117
														],
														[
															529,
															190
														],
														[
															500.212,
															125.632
														],
														[
															461,
															73
														],
														[
															456.66,
															68.997
														],
														[
															452,
															65
														],
														[
															448.082,
															60.998
														],
														[
															444,
															57
														],
														[
															426.328,
															44.716
														],
														[
															407,
															35
														],
														[
															397.578,
															31.15
														],
														[
															388,
															28
														],
														[
															370.921,
															25.773
														],
														[
															356,
															26
														],
														[
															348.374,
															26.768
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 38,
											"s": [
												{
													"i": [
														[
															4.743,
															-1.424
														],
														[
															2.999,
															-1.14
														],
														[
															2.863,
															-1.291
														],
														[
															2.682,
															-1.381
														],
														[
															2.456,
															-1.409
														],
														[
															5.489,
															-4.157
														],
														[
															4.895,
															-4.644
														],
														[
															4.459,
															-5.039
														],
														[
															4.18,
															-5.345
														],
														[
															6.249,
															-10.304
														],
														[
															5.288,
															-11.285
														],
														[
															4.27,
															-12.088
														],
														[
															3.196,
															-12.715
														],
														[
															1.704,
															-9.405
														],
														[
															1.227,
															-10.047
														],
														[
															0.659,
															-10.244
														],
														[
															0,
															-9.995
														],
														[
															-0.557,
															-10.363
														],
														[
															-1.095,
															-9.872
														],
														[
															-1.616,
															-9.323
														],
														[
															-2.118,
															-8.716
														],
														[
															-5.898,
															-16.066
														],
														[
															-7.569,
															-14.412
														],
														[
															-9.262,
															-12.515
														],
														[
															-10.976,
															-10.376
														],
														[
															-0.739,
															-0.588
														],
														[
															-0.755,
															-0.55
														],
														[
															-0.763,
															-0.562
														],
														[
															-0.764,
															-0.624
														],
														[
															-0.736,
															-0.683
														],
														[
															-0.724,
															-0.689
														],
														[
															-0.751,
															-0.662
														],
														[
															-0.817,
															-0.602
														],
														[
															-3.4,
															-2.145
														],
														[
															-3.563,
															-1.904
														],
														[
															-3.756,
															-1.682
														],
														[
															-3.979,
															-1.479
														],
														[
															-1.533,
															-0.557
														],
														[
															-1.576,
															-0.54
														],
														[
															-1.505,
															-0.464
														],
														[
															-1.319,
															-0.326
														],
														[
															-0.737,
															-0.053
														],
														[
															-0.714,
															-0.024
														],
														[
															-0.621,
															-0.084
														],
														[
															-0.455,
															-0.233
														],
														[
															-0.563,
															-0.466
														],
														[
															-0.29,
															-0.487
														],
														[
															-0.332,
															-0.653
														],
														[
															-0.689,
															-0.964
														],
														[
															-0.194,
															-0.399
														],
														[
															-0.12,
															-0.329
														],
														[
															-0.116,
															-0.266
														],
														[
															-0.183,
															-0.209
														],
														[
															-3.699,
															-0.041
														],
														[
															-3.325,
															0.319
														],
														[
															-10.88,
															3.913
														],
														[
															-8.115,
															5.16
														],
														[
															-7.635,
															6.823
														],
														[
															-6.533,
															7.032
														],
														[
															-1.035,
															1.251
														],
														[
															-0.759,
															0.812
														],
														[
															-1.7,
															2.033
														],
														[
															-1.442,
															1.99
														],
														[
															-3.679,
															6.047
														],
														[
															-3.324,
															5.348
														],
														[
															-0.095,
															0.486
														],
														[
															-0.314,
															0.561
														],
														[
															-4.071,
															9.183
														],
														[
															-3.093,
															9.005
														],
														[
															-4.792,
															27.444
														],
														[
															0.167,
															30.945
														],
														[
															9.434,
															37.418
														],
														[
															16.026,
															28.787
														],
														[
															2.759,
															4.451
														],
														[
															2.518,
															3.803
														],
														[
															0.691,
															0.804
														],
														[
															0.632,
															0.868
														],
														[
															0.086,
															0.52
														],
														[
															0.334,
															0.479
														],
														[
															0.6,
															0.29
														],
														[
															0.308,
															0.422
														],
														[
															0.236,
															0.672
														],
														[
															0.417,
															0.435
														],
														[
															0.759,
															0.96
														],
														[
															0.921,
															1.07
														],
														[
															2.172,
															2.323
														],
														[
															2.142,
															2.189
														],
														[
															1.5,
															1.286
														],
														[
															1.555,
															1.382
														],
														[
															1.434,
															1.555
														],
														[
															1.63,
															1.327
														],
														[
															0.911,
															0.483
														],
														[
															0.714,
															0.546
														],
														[
															0.788,
															0.658
														],
														[
															0.882,
															0.63
														],
														[
															15.812,
															5.928
														],
														[
															18.094,
															-1.331
														],
														[
															0.185,
															-0.245
														],
														[
															-0.052,
															0.004
														],
														[
															4.749,
															-0.786
														]
													],
													"o": [
														[
															-3.09,
															0.928
														],
														[
															-2.999,
															1.14
														],
														[
															-2.863,
															1.291
														],
														[
															-2.682,
															1.381
														],
														[
															-6.239,
															3.581
														],
														[
															-5.489,
															4.157
														],
														[
															-4.895,
															4.644
														],
														[
															-4.459,
															5.039
														],
														[
															-7.153,
															9.147
														],
														[
															-6.249,
															10.304
														],
														[
															-5.288,
															11.285
														],
														[
															-4.27,
															12.088
														],
														[
															-2.09,
															8.317
														],
														[
															-1.704,
															9.405
														],
														[
															-1.227,
															10.047
														],
														[
															-0.659,
															10.244
														],
														[
															0,
															10.797
														],
														[
															0.557,
															10.363
														],
														[
															1.095,
															9.872
														],
														[
															1.616,
															9.323
														],
														[
															4.248,
															17.476
														],
														[
															5.898,
															16.066
														],
														[
															7.569,
															14.412
														],
														[
															9.262,
															12.515
														],
														[
															0.716,
															0.677
														],
														[
															0.739,
															0.588
														],
														[
															0.755,
															0.55
														],
														[
															0.763,
															0.562
														],
														[
															0.788,
															0.644
														],
														[
															0.736,
															0.683
														],
														[
															0.724,
															0.689
														],
														[
															0.751,
															0.662
														],
														[
															3.267,
															2.407
														],
														[
															3.401,
															2.145
														],
														[
															3.563,
															1.904
														],
														[
															3.756,
															1.682
														],
														[
															1.376,
															0.512
														],
														[
															1.533,
															0.557
														],
														[
															1.576,
															0.54
														],
														[
															1.505,
															0.464
														],
														[
															0.687,
															0.17
														],
														[
															0.737,
															0.053
														],
														[
															0.715,
															0.024
														],
														[
															0.621,
															0.084
														],
														[
															1.153,
															0.59
														],
														[
															0.563,
															0.466
														],
														[
															0.29,
															0.487
														],
														[
															0.332,
															0.653
														],
														[
															0.339,
															0.475
														],
														[
															0.194,
															0.399
														],
														[
															0.12,
															0.329
														],
														[
															0.116,
															0.266
														],
														[
															1.881,
															2.157
														],
														[
															3.699,
															0.041
														],
														[
															12.365,
															-1.186
														],
														[
															10.88,
															-3.913
														],
														[
															8.927,
															-5.676
														],
														[
															7.635,
															-6.823
														],
														[
															1.101,
															-1.185
														],
														[
															1.035,
															-1.251
														],
														[
															1.758,
															-1.88
														],
														[
															1.7,
															-2.033
														],
														[
															3.96,
															-5.466
														],
														[
															3.679,
															-6.047
														],
														[
															0.307,
															-0.494
														],
														[
															0.095,
															-0.486
														],
														[
															4.621,
															-8.262
														],
														[
															4.071,
															-9.183
														],
														[
															7.997,
															-23.28
														],
														[
															4.792,
															-27.444
														],
														[
															-0.24,
															-44.541
														],
														[
															-9.434,
															-37.418
														],
														[
															-2.445,
															-4.392
														],
														[
															-2.759,
															-4.451
														],
														[
															-0.605,
															-0.914
														],
														[
															-0.691,
															-0.804
														],
														[
															-0.32,
															-0.44
														],
														[
															-0.086,
															-0.52
														],
														[
															-0.291,
															-0.416
														],
														[
															-0.6,
															-0.29
														],
														[
															-0.639,
															-0.878
														],
														[
															-0.236,
															-0.672
														],
														[
															-1.043,
															-1.09
														],
														[
															-0.759,
															-0.96
														],
														[
															-2.169,
															-2.521
														],
														[
															-2.172,
															-2.323
														],
														[
															-1.445,
															-1.475
														],
														[
															-1.5,
															-1.286
														],
														[
															-1.635,
															-1.453
														],
														[
															-1.434,
															-1.555
														],
														[
															-0.644,
															-0.524
														],
														[
															-0.911,
															-0.483
														],
														[
															-0.964,
															-0.736
														],
														[
															-0.788,
															-0.659
														],
														[
															-10.659,
															-7.617
														],
														[
															-15.812,
															-5.928
														],
														[
															-0.312,
															0.023
														],
														[
															-0.185,
															0.245
														],
														[
															-5.262,
															0.432
														],
														[
															-4.749,
															0.786
														]
													],
													"v": [
														[
															326,
															31
														],
														[
															316.855,
															34.117
														],
														[
															308.049,
															37.778
														],
														[
															299.719,
															41.8
														],
														[
															292,
															46
														],
														[
															274.447,
															57.63
														],
														[
															258.911,
															70.854
														],
														[
															244.919,
															85.401
														],
														[
															232,
															101
														],
														[
															211.884,
															130.22
														],
														[
															194.565,
															162.647
														],
														[
															180.214,
															197.751
														],
														[
															169,
															235
														],
														[
															163.285,
															261.694
														],
														[
															158.864,
															290.982
														],
														[
															156.012,
															321.53
														],
														[
															155,
															352
														],
														[
															155.84,
															383.755
														],
														[
															158.323,
															414.122
														],
														[
															162.394,
															442.928
														],
														[
															168,
															470
														],
														[
															183.213,
															520.373
														],
														[
															203.408,
															566.15
														],
														[
															228.649,
															606.602
														],
														[
															259,
															641
														],
														[
															261.184,
															642.884
														],
														[
															263.427,
															644.578
														],
														[
															265.706,
															646.233
														],
														[
															268,
															648
														],
														[
															270.277,
															649.998
														],
														[
															272.457,
															652.063
														],
														[
															274.658,
															654.097
														],
														[
															277,
															656
														],
														[
															286.994,
															662.822
														],
														[
															297.433,
															668.89
														],
														[
															308.405,
															674.263
														],
														[
															320,
															679
														],
														[
															324.392,
															680.618
														],
														[
															329.085,
															682.278
														],
														[
															333.735,
															683.8
														],
														[
															338,
															685
														],
														[
															340.153,
															685.312
														],
														[
															342.348,
															685.405
														],
														[
															344.369,
															685.546
														],
														[
															346,
															686
														],
														[
															348.495,
															687.547
														],
														[
															349.695,
															688.939
														],
														[
															350.548,
															690.612
														],
														[
															352,
															693
														],
														[
															352.783,
															694.308
														],
														[
															353.236,
															695.398
														],
														[
															353.571,
															696.289
														],
														[
															354,
															697
														],
														[
															362.918,
															699.857
														],
														[
															374,
															699
														],
														[
															409.188,
															690.981
														],
														[
															438,
															677
														],
														[
															462.796,
															658.017
														],
														[
															484,
															637
														],
														[
															487.256,
															633.22
														],
														[
															490,
															630
														],
														[
															495.237,
															624.082
														],
														[
															500,
															618
														],
														[
															511.477,
															600.412
														],
														[
															522,
															583
														],
														[
															522.495,
															581.551
														],
														[
															523,
															580
														],
														[
															536.146,
															553.558
														],
														[
															547,
															526
														],
														[
															566.623,
															449.749
														],
														[
															574,
															362
														],
														[
															558.84,
															238.685
														],
														[
															520,
															139
														],
														[
															512.055,
															125.559
														],
														[
															504,
															113
														],
														[
															502.02,
															110.466
														],
														[
															500,
															108
														],
														[
															499.511,
															106.529
														],
														[
															499,
															105
														],
														[
															497.512,
															104.004
														],
														[
															496,
															103
														],
														[
															494.834,
															100.668
														],
														[
															494,
															99
														],
														[
															491.408,
															95.985
														],
														[
															489,
															93
														],
														[
															482.48,
															85.751
														],
														[
															476,
															79
														],
														[
															471.583,
															74.93
														],
														[
															467,
															71
														],
														[
															462.496,
															66.405
														],
														[
															458,
															62
														],
														[
															455.553,
															60.516
														],
														[
															453,
															59
														],
														[
															450.438,
															56.921
														],
														[
															448,
															55
														],
														[
															407.576,
															33.289
														],
														[
															356,
															25
														],
														[
															355.227,
															25.52
														],
														[
															355,
															26
														],
														[
															340.11,
															27.756
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 39,
											"s": [
												{
													"i": [
														[
															0.658,
															0.003
														],
														[
															9.05,
															-2.693
														],
														[
															7.508,
															-3.276
														],
														[
															2.721,
															-1.375
														],
														[
															2.201,
															-1.228
														],
														[
															1.058,
															-0.492
														],
														[
															0.813,
															-0.502
														],
														[
															0.604,
															-0.744
														],
														[
															0.815,
															-0.549
														],
														[
															1.064,
															-0.45
														],
														[
															0.921,
															-0.645
														],
														[
															1.5,
															-1.101
														],
														[
															0.757,
															-0.725
														],
														[
															1.686,
															-1.504
														],
														[
															1.685,
															-1.48
														],
														[
															1.536,
															-1.355
														],
														[
															1.394,
															-1.294
														],
														[
															2.953,
															-2.921
														],
														[
															2.316,
															-2.648
														],
														[
															0.109,
															-0.578
														],
														[
															0.259,
															-0.339
														],
														[
															0.366,
															-0.33
														],
														[
															0.29,
															-0.358
														],
														[
															1.539,
															-2.055
														],
														[
															1.191,
															-1.742
														],
														[
															1.07,
															-1.13
														],
														[
															0.793,
															-1.122
														],
														[
															0.439,
															-1.044
														],
														[
															0.612,
															-0.929
														],
														[
															0.778,
															-0.66
														],
														[
															0.426,
															-0.659
														],
														[
															0.469,
															-1.048
														],
														[
															0.51,
															-0.862
														],
														[
															9.855,
															-35.663
														],
														[
															0,
															-43.353
														],
														[
															-3.103,
															-22.069
														],
														[
															-5.59,
															-19.262
														],
														[
															-6.307,
															-14.443
														],
														[
															-7.177,
															-12.396
														],
														[
															-0.483,
															-0.788
														],
														[
															-0.437,
															-0.755
														],
														[
															-0.102,
															-0.505
														],
														[
															-0.32,
															-0.507
														],
														[
															-0.762,
															-0.635
														],
														[
															-0.48,
															-0.712
														],
														[
															-0.442,
															-1.045
														],
														[
															-0.595,
															-0.876
														],
														[
															-1.159,
															-1.665
														],
														[
															-1.257,
															-1.707
														],
														[
															-1.388,
															-1.46
														],
														[
															-1.299,
															-1.6
														],
														[
															-0.412,
															-0.84
														],
														[
															-0.704,
															-0.844
														],
														[
															-2.183,
															-2.077
														],
														[
															-2.142,
															-2.142
														],
														[
															-2.748,
															-2.87
														],
														[
															-2.94,
															-2.45
														],
														[
															-4.805,
															-3.361
														],
														[
															-4.603,
															-2.075
														],
														[
															-0.411,
															-0.237
														],
														[
															-2.271,
															-1.024
														],
														[
															-0.44,
															-0.224
														],
														[
															-3.878,
															-1.603
														],
														[
															-9.939,
															-2.043
														],
														[
															-1.298,
															-0.66
														],
														[
															-2.072,
															-2.634
														],
														[
															-0.754,
															-0.6
														],
														[
															-3.648,
															-0.95
														],
														[
															-11.229,
															2.135
														],
														[
															-22.714,
															21.018
														],
														[
															-5.977,
															7.331
														],
														[
															-2.387,
															3.121
														],
														[
															-1.213,
															1.704
														],
														[
															-1.265,
															1.803
														],
														[
															-1.173,
															1.737
														],
														[
															-8.892,
															21.102
														],
														[
															-6.354,
															30.135
														],
														[
															-1.353,
															10.145
														],
														[
															27.05,
															63.681
														],
														[
															1.864,
															4.013
														],
														[
															1.115,
															2.473
														],
														[
															0.226,
															0.437
														],
														[
															2.116,
															3.8
														],
														[
															1.116,
															2.476
														],
														[
															0.243,
															0.394
														],
														[
															0.461,
															0.796
														],
														[
															2.03,
															2.99
														],
														[
															2.581,
															3.438
														],
														[
															0.606,
															0.778
														],
														[
															0.659,
															0.861
														],
														[
															0.801,
															0.836
														],
														[
															0.631,
															0.781
														],
														[
															2.84,
															3.282
														],
														[
															2.802,
															2.901
														],
														[
															1.464,
															1.308
														],
														[
															6.072,
															4.643
														],
														[
															19.514,
															7.146
														],
														[
															10.193,
															1.734
														],
														[
															11.402,
															-0.786
														],
														[
															-0.106,
															0.008
														]
													],
													"o": [
														[
															-9.292,
															-0.047
														],
														[
															-9.05,
															2.693
														],
														[
															-2.916,
															1.272
														],
														[
															-2.721,
															1.375
														],
														[
															-0.952,
															0.532
														],
														[
															-1.059,
															0.492
														],
														[
															-0.769,
															0.474
														],
														[
															-0.604,
															0.744
														],
														[
															-0.824,
															0.555
														],
														[
															-1.064,
															0.45
														],
														[
															-1.243,
															0.871
														],
														[
															-1.5,
															1.101
														],
														[
															-1.572,
															1.507
														],
														[
															-1.686,
															1.504
														],
														[
															-1.462,
															1.284
														],
														[
															-1.536,
															1.356
														],
														[
															-2.87,
															2.667
														],
														[
															-2.953,
															2.921
														],
														[
															-0.306,
															0.35
														],
														[
															-0.109,
															0.578
														],
														[
															-0.245,
															0.321
														],
														[
															-0.366,
															0.33
														],
														[
															-1.651,
															2.037
														],
														[
															-1.539,
															2.055
														],
														[
															-0.928,
															1.358
														],
														[
															-1.07,
															1.13
														],
														[
															-0.631,
															0.893
														],
														[
															-0.439,
															1.044
														],
														[
															-0.461,
															0.701
														],
														[
															-0.778,
															0.66
														],
														[
															-0.612,
															0.947
														],
														[
															-0.469,
															1.048
														],
														[
															-16.582,
															27.993
														],
														[
															-9.855,
															35.663
														],
														[
															0,
															25.464
														],
														[
															3.102,
															22.069
														],
														[
															4.595,
															15.833
														],
														[
															6.307,
															14.443
														],
														[
															0.633,
															1.093
														],
														[
															0.483,
															0.788
														],
														[
															0.273,
															0.471
														],
														[
															0.102,
															0.505
														],
														[
															0.471,
															0.747
														],
														[
															0.762,
															0.635
														],
														[
															0.637,
															0.946
														],
														[
															0.442,
															1.045
														],
														[
															1.108,
															1.632
														],
														[
															1.159,
															1.665
														],
														[
															1.15,
															1.562
														],
														[
															1.388,
															1.46
														],
														[
															0.647,
															0.796
														],
														[
															0.412,
															0.84
														],
														[
															2.126,
															2.551
														],
														[
															2.183,
															2.077
														],
														[
															3.069,
															3.068
														],
														[
															2.748,
															2.87
														],
														[
															4.175,
															3.479
														],
														[
															4.805,
															3.361
														],
														[
															0.349,
															0.157
														],
														[
															3.222,
															1.86
														],
														[
															0.364,
															0.164
														],
														[
															3.547,
															1.807
														],
														[
															9.431,
															3.898
														],
														[
															2.561,
															0.527
														],
														[
															3.435,
															1.748
														],
														[
															1.584,
															2.013
														],
														[
															1.795,
															1.427
														],
														[
															8.567,
															2.23
														],
														[
															39.529,
															-7.516
														],
														[
															8.023,
															-7.424
														],
														[
															2.927,
															-3.591
														],
														[
															1.444,
															-1.888
														],
														[
															1.275,
															-1.792
														],
														[
															1.249,
															-1.781
														],
														[
															12.241,
															-18.129
														],
														[
															10.962,
															-26.015
														],
														[
															2.011,
															-9.536
														],
														[
															12.029,
															-90.215
														],
														[
															-1.773,
															-4.173
														],
														[
															-1.706,
															-3.672
														],
														[
															-0.163,
															-0.363
														],
														[
															-2.096,
															-4.059
														],
														[
															-1.85,
															-3.323
														],
														[
															-0.153,
															-0.339
														],
														[
															-0.586,
															-0.951
														],
														[
															-1.718,
															-2.968
														],
														[
															-2.334,
															-3.437
														],
														[
															-0.657,
															-0.875
														],
														[
															-0.654,
															-0.84
														],
														[
															-1.281,
															-1.675
														],
														[
															-0.635,
															-0.663
														],
														[
															-2.542,
															-3.147
														],
														[
															-2.826,
															-3.265
														],
														[
															-1.511,
															-1.564
														],
														[
															-6.393,
															-5.713
														],
														[
															-13.964,
															-10.678
														],
														[
															-8.761,
															-3.208
														],
														[
															-10.983,
															-1.868
														],
														[
															-0.625,
															0.043
														],
														[
															-0.656,
															0.051
														]
													],
													"v": [
														[
															352,
															26
														],
														[
															324.162,
															30.507
														],
														[
															299,
															40
														],
														[
															290.464,
															44.033
														],
														[
															283,
															48
														],
														[
															279.896,
															49.523
														],
														[
															277,
															51
														],
														[
															275.034,
															52.944
														],
														[
															273,
															55
														],
														[
															270.073,
															56.432
														],
														[
															267,
															58
														],
														[
															262.636,
															61.109
														],
														[
															259,
															64
														],
														[
															254.084,
															68.52
														],
														[
															249,
															73
														],
														[
															244.449,
															76.992
														],
														[
															240,
															81
														],
														[
															231.084,
															89.514
														],
														[
															223,
															98
														],
														[
															222.465,
															99.508
														],
														[
															222,
															101
														],
														[
															221.034,
															101.972
														],
														[
															220,
															103
														],
														[
															215.155,
															109.222
														],
														[
															211,
															115
														],
														[
															207.899,
															118.677
														],
														[
															205,
															122
														],
														[
															203.485,
															124.973
														],
														[
															202,
															128
														],
														[
															199.974,
															130.031
														],
														[
															198,
															132
														],
														[
															196.424,
															135.064
														],
														[
															195,
															138
														],
														[
															154.564,
															233.48
														],
														[
															139,
															352
														],
														[
															143.808,
															423.151
														],
														[
															157,
															485
														],
														[
															173.564,
															530.578
														],
														[
															194,
															571
														],
														[
															195.647,
															573.754
														],
														[
															197,
															576
														],
														[
															197.465,
															577.473
														],
														[
															198,
															579
														],
														[
															199.994,
															581.027
														],
														[
															202,
															583
														],
														[
															203.531,
															586.052
														],
														[
															205,
															589
														],
														[
															208.388,
															593.944
														],
														[
															212,
															599
														],
														[
															215.888,
															603.471
														],
														[
															220,
															608
														],
														[
															221.457,
															610.464
														],
														[
															223,
															613
														],
														[
															229.488,
															619.806
														],
														[
															236,
															626
														],
														[
															244.596,
															634.964
														],
														[
															253,
															643
														],
														[
															266.679,
															653.553
														],
														[
															281,
															662
														],
														[
															282,
															664
														],
														[
															292,
															668
														],
														[
															293,
															670
														],
														[
															305,
															675
														],
														[
															337,
															685
														],
														[
															345,
															686
														],
														[
															351,
															693
														],
														[
															353,
															698
														],
														[
															359,
															699
														],
														[
															390,
															697
														],
														[
															483,
															648
														],
														[
															505,
															625
														],
														[
															513,
															615
														],
														[
															517,
															610
														],
														[
															520,
															604
														],
														[
															524,
															599
														],
														[
															555,
															541
														],
														[
															580,
															459
														],
														[
															586,
															429
														],
														[
															555,
															183
														],
														[
															549,
															171
														],
														[
															545,
															160
														],
														[
															543,
															159
														],
														[
															537,
															147
														],
														[
															532,
															137
														],
														[
															530,
															136
														],
														[
															529,
															133
														],
														[
															524,
															125
														],
														[
															516,
															115
														],
														[
															515,
															112
														],
														[
															512,
															110
														],
														[
															510,
															106
														],
														[
															509,
															104
														],
														[
															500,
															95
														],
														[
															492,
															85
														],
														[
															487,
															81
														],
														[
															468,
															64
														],
														[
															417,
															35
														],
														[
															388,
															28
														],
														[
															355,
															25
														],
														[
															354,
															26
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 40,
											"s": [
												{
													"i": [
														[
															5.524,
															-1.659
														],
														[
															0.491,
															-0.253
														],
														[
															0.503,
															-0.296
														],
														[
															0.51,
															-0.269
														],
														[
															0.514,
															-0.175
														],
														[
															1.212,
															-0.319
														],
														[
															1.17,
															-0.285
														],
														[
															1.123,
															-0.324
														],
														[
															1.071,
															-0.435
														],
														[
															0.934,
															-0.497
														],
														[
															0.907,
															-0.539
														],
														[
															0.895,
															-0.523
														],
														[
															0.897,
															-0.447
														],
														[
															1.903,
															-0.966
														],
														[
															1.833,
															-0.979
														],
														[
															1.763,
															-1.024
														],
														[
															1.694,
															-1.1
														],
														[
															2.548,
															-1.888
														],
														[
															2.061,
															-1.666
														],
														[
															5.432,
															-4.844
														],
														[
															4.586,
															-5.029
														],
														[
															7.229,
															-10.104
														],
														[
															5.826,
															-10.525
														],
														[
															1.547,
															-2.868
														],
														[
															1.228,
															-2.659
														],
														[
															0.254,
															-1.21
														],
														[
															0.49,
															-1.093
														],
														[
															1.077,
															-1.775
														],
														[
															0.848,
															-2.022
														],
														[
															1.433,
															-4.1
														],
														[
															1.46,
															-4.29
														],
														[
															1.028,
															-3.479
														],
														[
															0.76,
															-2.775
														],
														[
															1.273,
															-4.775
														],
														[
															0.775,
															-3.77
														],
														[
															0.627,
															-3.679
														],
														[
															0.601,
															-3.942
														],
														[
															0.851,
															-10.828
														],
														[
															0,
															-11.232
														],
														[
															-10.189,
															-36.011
														],
														[
															-17.243,
															-27.619
														],
														[
															-8.458,
															-10.435
														],
														[
															-9.266,
															-8.205
														],
														[
															-1.221,
															-1.021
														],
														[
															-0.867,
															-0.811
														],
														[
															-1.123,
															-0.894
														],
														[
															-0.553,
															-0.53
														],
														[
															-0.305,
															-0.084
														],
														[
															-0.427,
															-0.328
														],
														[
															-1.439,
															-1.4
														],
														[
															-1.591,
															-1.132
														],
														[
															-0.534,
															-0.091
														],
														[
															-0.401,
															-0.307
														],
														[
															-1.8,
															-1.272
														],
														[
															-1.233,
															-0.714
														],
														[
															-1.277,
															-0.838
														],
														[
															-1.329,
															-0.745
														],
														[
															-9.916,
															-3.622
														],
														[
															-10.106,
															-1.895
														],
														[
															-1.528,
															-0.107
														],
														[
															-0.797,
															-0.365
														],
														[
															-1.351,
															-1.679
														],
														[
															-0.596,
															-1.366
														],
														[
															-0.786,
															-0.209
														],
														[
															-2.797,
															-0.736
														],
														[
															-5.445,
															0.571
														],
														[
															-5.663,
															0.917
														],
														[
															-9.186,
															3.115
														],
														[
															-7.678,
															3.825
														],
														[
															-3.218,
															1.77
														],
														[
															-2.775,
															1.251
														],
														[
															-0.163,
															0.451
														],
														[
															-0.185,
															0.123
														],
														[
															-0.379,
															-0.067
														],
														[
															-0.255,
															0.115
														],
														[
															-0.165,
															0.451
														],
														[
															-0.182,
															0.124
														],
														[
															-1.012,
															0.41
														],
														[
															-0.977,
															0.696
														],
														[
															-0.833,
															0.695
														],
														[
															-0.823,
															0.62
														],
														[
															-17.985,
															28.492
														],
														[
															-10.147,
															34.499
														],
														[
															-3.093,
															21.329
														],
														[
															0,
															24.552
														],
														[
															11.501,
															38.083
														],
														[
															18.996,
															28.566
														],
														[
															12.098,
															12.471
														],
														[
															15.135,
															9.87
														],
														[
															1.82,
															1.169
														],
														[
															1.913,
															1.148
														],
														[
															3.899,
															1.938
														],
														[
															4.4,
															1.845
														],
														[
															7.174,
															2.25
														],
														[
															7.577,
															1.18
														],
														[
															5.847,
															0.383
														],
														[
															6.096,
															-0.39
														],
														[
															0.185,
															-0.246
														],
														[
															-0.054,
															0.004
														],
														[
															6.532,
															-0.968
														]
													],
													"o": [
														[
															-0.476,
															0.143
														],
														[
															-0.491,
															0.253
														],
														[
															-0.503,
															0.296
														],
														[
															-0.51,
															0.269
														],
														[
															-1.248,
															0.424
														],
														[
															-1.212,
															0.319
														],
														[
															-1.17,
															0.285
														],
														[
															-1.123,
															0.324
														],
														[
															-0.975,
															0.396
														],
														[
															-0.934,
															0.497
														],
														[
															-0.907,
															0.539
														],
														[
															-0.895,
															0.523
														],
														[
															-1.974,
															0.983
														],
														[
															-1.903,
															0.966
														],
														[
															-1.833,
															0.979
														],
														[
															-1.763,
															1.024
														],
														[
															-2.745,
															1.782
														],
														[
															-2.548,
															1.888
														],
														[
															-5.685,
															4.594
														],
														[
															-5.432,
															4.844
														],
														[
															-8.259,
															9.058
														],
														[
															-7.229,
															10.104
														],
														[
															-1.587,
															2.867
														],
														[
															-1.546,
															2.868
														],
														[
															-0.493,
															1.068
														],
														[
															-0.254,
															1.21
														],
														[
															-0.843,
															1.876
														],
														[
															-1.077,
															1.775
														],
														[
															-1.808,
															4.311
														],
														[
															-1.433,
															4.1
														],
														[
															-1.126,
															3.307
														],
														[
															-1.028,
															3.479
														],
														[
															-1.132,
															4.131
														],
														[
															-1.273,
															4.775
														],
														[
															-0.892,
															4.341
														],
														[
															-0.626,
															3.679
														],
														[
															-1.595,
															10.454
														],
														[
															-0.851,
															10.828
														],
														[
															0,
															46.337
														],
														[
															10.189,
															36.011
														],
														[
															6.903,
															11.057
														],
														[
															8.458,
															10.435
														],
														[
															1.247,
															1.104
														],
														[
															1.221,
															1.021
														],
														[
															0.954,
															0.892
														],
														[
															1.123,
															0.894
														],
														[
															0.351,
															0.337
														],
														[
															0.305,
															0.084
														],
														[
															1.653,
															1.269
														],
														[
															1.439,
															1.4
														],
														[
															0.462,
															0.329
														],
														[
															0.534,
															0.091
														],
														[
															1.568,
															1.199
														],
														[
															1.8,
															1.272
														],
														[
															1.561,
															0.904
														],
														[
															1.278,
															0.838
														],
														[
															8.231,
															4.615
														],
														[
															9.916,
															3.622
														],
														[
															1.091,
															0.205
														],
														[
															1.528,
															0.108
														],
														[
															1.999,
															0.917
														],
														[
															1.351,
															1.679
														],
														[
															1.058,
															2.428
														],
														[
															0.786,
															0.209
														],
														[
															4.557,
															1.2
														],
														[
															5.445,
															-0.571
														],
														[
															10.578,
															-1.713
														],
														[
															9.186,
															-3.115
														],
														[
															3.351,
															-1.67
														],
														[
															3.218,
															-1.77
														],
														[
															0.162,
															-0.073
														],
														[
															0.163,
															-0.451
														],
														[
															0.23,
															-0.154
														],
														[
															0.379,
															0.067
														],
														[
															0.16,
															-0.072
														],
														[
															0.165,
															-0.451
														],
														[
															0.975,
															-0.663
														],
														[
															1.012,
															-0.41
														],
														[
															0.843,
															-0.6
														],
														[
															0.833,
															-0.695
														],
														[
															25.912,
															-19.533
														],
														[
															17.985,
															-28.492
														],
														[
															5.628,
															-19.134
														],
														[
															3.093,
															-21.329
														],
														[
															0,
															-47.102
														],
														[
															-11.501,
															-38.083
														],
														[
															-9.473,
															-14.244
														],
														[
															-12.098,
															-12.471
														],
														[
															-1.807,
															-1.178
														],
														[
															-1.82,
															-1.169
														],
														[
															-4.006,
															-2.404
														],
														[
															-3.899,
															-1.938
														],
														[
															-6.728,
															-2.822
														],
														[
															-7.174,
															-2.25
														],
														[
															-5.516,
															-0.858
														],
														[
															-5.847,
															-0.383
														],
														[
															-0.313,
															0.02
														],
														[
															-0.185,
															0.246
														],
														[
															-6.347,
															0.47
														],
														[
															-6.532,
															0.968
														]
													],
													"v": [
														[
															315,
															32
														],
														[
															313.549,
															32.611
														],
														[
															312.058,
															33.452
														],
														[
															310.537,
															34.317
														],
														[
															309,
															35
														],
														[
															305.309,
															36.096
														],
														[
															301.735,
															36.984
														],
														[
															298.293,
															37.88
														],
														[
															295,
															39
														],
														[
															292.14,
															40.354
														],
														[
															289.382,
															41.924
														],
														[
															286.683,
															43.531
														],
														[
															284,
															45
														],
														[
															278.185,
															47.915
														],
														[
															272.58,
															50.825
														],
														[
															267.185,
															53.822
														],
														[
															262,
															57
														],
														[
															253.987,
															62.587
														],
														[
															247,
															68
														],
														[
															230.176,
															82.173
														],
														[
															215,
															97
														],
														[
															191.675,
															125.899
														],
														[
															172,
															157
														],
														[
															167.231,
															165.656
														],
														[
															163,
															174
														],
														[
															161.998,
															177.482
														],
														[
															161,
															181
														],
														[
															158.004,
															186.391
														],
														[
															155,
															192
														],
														[
															150.239,
															204.516
														],
														[
															146,
															217
														],
														[
															142.726,
															227.399
														],
														[
															140,
															237
														],
														[
															136.232,
															250.77
														],
														[
															133,
															264
														],
														[
															130.782,
															275.8
														],
														[
															129,
															287
														],
														[
															125.304,
															318.917
														],
														[
															124,
															352
														],
														[
															140.068,
															475.039
														],
														[
															182,
															570
														],
														[
															205.228,
															602.639
														],
														[
															232,
															631
														],
														[
															235.785,
															634.22
														],
														[
															239,
															637
														],
														[
															242.3,
															639.772
														],
														[
															245,
															642
														],
														[
															245.943,
															642.506
														],
														[
															247,
															643
														],
														[
															251.546,
															647.103
														],
														[
															256,
															651
														],
														[
															257.545,
															651.516
														],
														[
															259,
															652
														],
														[
															264.252,
															655.864
														],
														[
															269,
															659
														],
														[
															273.174,
															661.619
														],
														[
															277,
															664
														],
														[
															304.593,
															676.54
														],
														[
															335,
															685
														],
														[
															339.22,
															685.379
														],
														[
															343,
															686
														],
														[
															348.053,
															690.163
														],
														[
															351,
															695
														],
														[
															353.196,
															698.268
														],
														[
															358,
															699
														],
														[
															373.171,
															699.588
														],
														[
															390,
															697
														],
														[
															419.675,
															689.584
														],
														[
															445,
															679
														],
														[
															454.932,
															673.686
														],
														[
															464,
															669
														],
														[
															464.483,
															668.038
														],
														[
															465,
															667
														],
														[
															465.981,
															666.971
														],
														[
															467,
															667
														],
														[
															467.483,
															666.039
														],
														[
															468,
															665
														],
														[
															470.998,
															663.524
														],
														[
															474,
															662
														],
														[
															476.515,
															660.015
														],
														[
															479,
															658
														],
														[
															544.824,
															585.225
														],
														[
															587,
															490
														],
														[
															600.221,
															429.564
														],
														[
															605,
															361
														],
														[
															586.747,
															233.098
														],
														[
															540,
															133
														],
														[
															507.747,
															92.72
														],
														[
															467,
															59
														],
														[
															461.579,
															55.477
														],
														[
															456,
															52
														],
														[
															444.296,
															45.581
														],
														[
															432,
															40
														],
														[
															411.137,
															32.269
														],
														[
															389,
															27
														],
														[
															371.935,
															25.064
														],
														[
															354,
															25
														],
														[
															353.224,
															25.518
														],
														[
															353,
															26
														],
														[
															333.382,
															28.108
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 41,
											"s": [
												{
													"i": [
														[
															0.66,
															-0.001
														],
														[
															9.587,
															-2.423
														],
														[
															8.697,
															-3.294
														],
														[
															3.973,
															-1.826
														],
														[
															3.72,
															-2.032
														],
														[
															3.847,
															-2.085
														],
														[
															3.446,
															-2.386
														],
														[
															0.628,
															-0.74
														],
														[
															0.754,
															-0.534
														],
														[
															0.664,
															-0.235
														],
														[
															0.444,
															-0.425
														],
														[
															0.659,
															-0.445
														],
														[
															0.608,
															-0.495
														],
														[
															0.825,
															-0.634
														],
														[
															0.666,
															-0.623
														],
														[
															1.996,
															-1.814
														],
														[
															1.989,
															-1.848
														],
														[
															7.351,
															-8.39
														],
														[
															5.607,
															-9.02
														],
														[
															1.583,
															-2.183
														],
														[
															1.209,
															-1.923
														],
														[
															3.439,
															-6.636
														],
														[
															3.113,
															-6.88
														],
														[
															1.414,
															-3.339
														],
														[
															0.988,
															-2.644
														],
														[
															1.126,
															-3.215
														],
														[
															1.077,
															-3.343
														],
														[
															3.563,
															-21.053
														],
														[
															0.263,
															-20.764
														],
														[
															-0.915,
															-10.896
														],
														[
															-1.484,
															-10.082
														],
														[
															-5.427,
															-18.265
														],
														[
															-7.214,
															-16.045
														],
														[
															-4.419,
															-7.464
														],
														[
															-4.649,
															-6.971
														],
														[
															-5.121,
															-6.639
														],
														[
															-5.646,
															-6.142
														],
														[
															-3.001,
															-2.752
														],
														[
															-3.139,
															-2.882
														],
														[
															-1.459,
															-1.564
														],
														[
															-1.604,
															-1.312
														],
														[
															-0.561,
															-0.099
														],
														[
															-0.364,
															-0.284
														],
														[
															-0.287,
															-0.586
														],
														[
															-0.43,
															-0.33
														],
														[
															-1.092,
															-0.449
														],
														[
															-0.866,
															-0.62
														],
														[
															-0.601,
															-0.723
														],
														[
															-0.805,
															-0.542
														],
														[
															-1.059,
															-0.458
														],
														[
															-0.931,
															-0.607
														],
														[
															-1.824,
															-1.175
														],
														[
															-1.897,
															-1.119
														],
														[
															-0.992,
															-0.459
														],
														[
															-1.04,
															-0.58
														],
														[
															-0.781,
															-0.749
														],
														[
															-0.959,
															-0.494
														],
														[
															-2.188,
															-0.75
														],
														[
															-2.262,
															-0.981
														],
														[
															-0.813,
															-0.568
														],
														[
															-0.918,
															-0.368
														],
														[
															-7.216,
															-2.044
														],
														[
															-6.761,
															-1.267
														],
														[
															-2.372,
															-0.382
														],
														[
															-0.967,
															-0.995
														],
														[
															-0.17,
															-0.887
														],
														[
															-0.796,
															-0.911
														],
														[
															-0.397,
															-0.622
														],
														[
															-0.492,
															-0.456
														],
														[
															-0.633,
															-0.075
														],
														[
															-2.289,
															-0.608
														],
														[
															-8.98,
															1.586
														],
														[
															-2.757,
															0.649
														],
														[
															-4.269,
															1.299
														],
														[
															-1.247,
															0.28
														],
														[
															-0.53,
															0.177
														],
														[
															-29.115,
															39.532
														],
														[
															-12.243,
															37.869
														],
														[
															0.264,
															49.097
														],
														[
															14.867,
															40.945
														],
														[
															6.297,
															12.431
														],
														[
															3.245,
															7.2
														],
														[
															0.242,
															0.397
														],
														[
															1.193,
															1.876
														],
														[
															1.219,
															1.856
														],
														[
															0.659,
															0.943
														],
														[
															0.602,
															0.852
														],
														[
															0.225,
															0.499
														],
														[
															0.247,
															0.37
														],
														[
															0.23,
															0.511
														],
														[
															0.249,
															0.335
														],
														[
															5.889,
															6.778
														],
														[
															4.684,
															4.517
														],
														[
															0.844,
															0.837
														],
														[
															15.194,
															6.849
														],
														[
															0.394,
															0.243
														],
														[
															2.07,
															1.172
														],
														[
															11.641,
															4.41
														],
														[
															29.302,
															-1.876
														],
														[
															-0.109,
															0.008
														]
													],
													"o": [
														[
															-9.957,
															0.014
														],
														[
															-9.587,
															2.423
														],
														[
															-4.389,
															1.663
														],
														[
															-3.973,
															1.826
														],
														[
															-4.164,
															2.275
														],
														[
															-3.847,
															2.085
														],
														[
															-0.734,
															0.508
														],
														[
															-0.628,
															0.74
														],
														[
															-0.899,
															0.636
														],
														[
															-0.664,
															0.235
														],
														[
															-0.755,
															0.724
														],
														[
															-0.659,
															0.445
														],
														[
															-1.033,
															0.843
														],
														[
															-0.825,
															0.634
														],
														[
															-2.026,
															1.895
														],
														[
															-1.996,
															1.814
														],
														[
															-7.988,
															7.422
														],
														[
															-7.351,
															8.39
														],
														[
															-1.458,
															2.346
														],
														[
															-1.583,
															2.183
														],
														[
															-4.133,
															6.577
														],
														[
															-3.439,
															6.636
														],
														[
															-1.357,
															3
														],
														[
															-1.414,
															3.339
														],
														[
															-1.418,
															3.796
														],
														[
															-1.126,
															3.215
														],
														[
															-5.484,
															17.024
														],
														[
															-3.563,
															21.053
														],
														[
															-0.144,
															11.335
														],
														[
															0.915,
															10.896
														],
														[
															3.077,
															20.893
														],
														[
															5.427,
															18.265
														],
														[
															3.675,
															8.174
														],
														[
															4.419,
															7.464
														],
														[
															4.87,
															7.303
														],
														[
															5.121,
															6.639
														],
														[
															2.857,
															3.109
														],
														[
															3.001,
															2.752
														],
														[
															1.562,
															1.434
														],
														[
															1.459,
															1.564
														],
														[
															0.392,
															0.32
														],
														[
															0.561,
															0.099
														],
														[
															0.42,
															0.327
														],
														[
															0.287,
															0.586
														],
														[
															0.765,
															0.585
														],
														[
															1.092,
															0.449
														],
														[
															0.792,
															0.567
														],
														[
															0.601,
															0.723
														],
														[
															0.835,
															0.562
														],
														[
															1.059,
															0.458
														],
														[
															1.808,
															1.179
														],
														[
															1.824,
															1.175
														],
														[
															0.992,
															0.586
														],
														[
															0.992,
															0.459
														],
														[
															0.914,
															0.51
														],
														[
															0.781,
															0.749
														],
														[
															1.985,
															1.021
														],
														[
															2.188,
															0.75
														],
														[
															0.83,
															0.36
														],
														[
															0.813,
															0.568
														],
														[
															6.375,
															2.555
														],
														[
															7.216,
															2.044
														],
														[
															2.546,
															0.477
														],
														[
															2.372,
															0.382
														],
														[
															0.524,
															0.539
														],
														[
															0.17,
															0.887
														],
														[
															0.921,
															1.055
														],
														[
															0.397,
															0.622
														],
														[
															1.178,
															1.091
														],
														[
															0.633,
															0.075
														],
														[
															11.369,
															3.02
														],
														[
															2.821,
															-0.498
														],
														[
															4.99,
															-1.174
														],
														[
															1.22,
															-0.371
														],
														[
															0.382,
															-0.086
														],
														[
															54.51,
															-18.255
														],
														[
															21.327,
															-28.957
														],
														[
															12.336,
															-38.156
														],
														[
															-0.281,
															-52.199
														],
														[
															-5.286,
															-14.558
														],
														[
															-3.917,
															-7.732
														],
														[
															-0.153,
															-0.34
														],
														[
															-1.188,
															-1.949
														],
														[
															-1.307,
															-2.056
														],
														[
															-0.584,
															-0.889
														],
														[
															-0.581,
															-0.832
														],
														[
															-0.311,
															-0.441
														],
														[
															-0.146,
															-0.324
														],
														[
															-0.307,
															-0.46
														],
														[
															-0.136,
															-0.302
														],
														[
															-5.364,
															-7.224
														],
														[
															-4.866,
															-5.601
														],
														[
															-0.858,
															-0.828
														],
														[
															-11.815,
															-11.721
														],
														[
															-0.339,
															-0.153
														],
														[
															-1.768,
															-1.09
														],
														[
															-10.665,
															-6.035
														],
														[
															-22.702,
															-8.599
														],
														[
															-0.627,
															0.04
														],
														[
															-0.658,
															0.049
														]
													],
													"v": [
														[
															350,
															26
														],
														[
															320.555,
															30.04
														],
														[
															293,
															39
														],
														[
															280.498,
															44.223
														],
														[
															269,
															50
														],
														[
															256.961,
															56.417
														],
														[
															246,
															63
														],
														[
															244.015,
															64.981
														],
														[
															242,
															67
														],
														[
															239.659,
															68.158
														],
														[
															238,
															69
														],
														[
															235.889,
															70.671
														],
														[
															234,
															72
														],
														[
															231.225,
															74.165
														],
														[
															229,
															76
														],
														[
															222.972,
															81.536
														],
														[
															217,
															87
														],
														[
															193.714,
															110.801
														],
														[
															174,
															137
														],
														[
															169.313,
															143.817
														],
														[
															165,
															150
														],
														[
															153.734,
															169.772
														],
														[
															144,
															190
														],
														[
															139.723,
															199.766
														],
														[
															136,
															209
														],
														[
															132.244,
															219.34
														],
														[
															129,
															229
														],
														[
															115.085,
															287.195
														],
														[
															109,
															351
														],
														[
															110.279,
															384.44
														],
														[
															114,
															416
														],
														[
															126.897,
															474.636
														],
														[
															146,
															526
														],
														[
															158.269,
															549.402
														],
														[
															172,
															571
														],
														[
															186.918,
															591.871
														],
														[
															203,
															611
														],
														[
															211.788,
															619.67
														],
														[
															221,
															628
														],
														[
															225.469,
															632.592
														],
														[
															230,
															637
														],
														[
															231.521,
															637.527
														],
														[
															233,
															638
														],
														[
															233.992,
															639.498
														],
														[
															235,
															641
														],
														[
															237.924,
															642.473
														],
														[
															241,
															644
														],
														[
															242.991,
															646.019
														],
														[
															245,
															648
														],
														[
															247.928,
															649.467
														],
														[
															251,
															651
														],
														[
															256.433,
															654.545
														],
														[
															262,
															658
														],
														[
															264.964,
															659.505
														],
														[
															268,
															661
														],
														[
															270.466,
															663.012
														],
														[
															273,
															665
														],
														[
															279.292,
															667.53
														],
														[
															286,
															670
														],
														[
															288.434,
															671.494
														],
														[
															291,
															673
														],
														[
															311.71,
															679.966
														],
														[
															333,
															685
														],
														[
															340.684,
															686.112
														],
														[
															346,
															688
														],
														[
															346.796,
															690.221
														],
														[
															348,
															693
														],
														[
															349.822,
															695.45
														],
														[
															351,
															697
														],
														[
															353.167,
															698.363
														],
														[
															357,
															699
														],
														[
															398,
															696
														],
														[
															407,
															695
														],
														[
															421,
															690
														],
														[
															425,
															690
														],
														[
															428,
															688
														],
														[
															550,
															593
														],
														[
															600,
															492
														],
														[
															620,
															361
														],
														[
															595,
															218
														],
														[
															578,
															178
														],
														[
															566,
															155
														],
														[
															564,
															154
														],
														[
															561,
															148
														],
														[
															557,
															142
														],
														[
															556,
															139
														],
														[
															553,
															137
														],
														[
															553,
															135
														],
														[
															551,
															134
														],
														[
															551,
															132
														],
														[
															549,
															131
														],
														[
															533,
															110
														],
														[
															517,
															93
														],
														[
															514,
															91
														],
														[
															473,
															59
														],
														[
															472,
															57
														],
														[
															466,
															54
														],
														[
															434,
															39
														],
														[
															353,
															25
														],
														[
															352,
															26
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 42,
											"s": [
												{
													"i": [
														[
															0.656,
															0.016
														],
														[
															9.937,
															-2.519
														],
														[
															9.163,
															-3.175
														],
														[
															1.159,
															-0.286
														],
														[
															1.154,
															-0.439
														],
														[
															3.259,
															-1.341
														],
														[
															2.846,
															-1.45
														],
														[
															1.813,
															-1.249
														],
														[
															1.768,
															-0.995
														],
														[
															1.031,
															-0.481
														],
														[
															0.909,
															-0.53
														],
														[
															1.775,
															-1.138
														],
														[
															1.681,
															-1.154
														],
														[
															0.791,
															-0.676
														],
														[
															0.867,
															-0.631
														],
														[
															0.52,
															-0.086
														],
														[
															0.479,
															-0.334
														],
														[
															0.29,
															-0.6
														],
														[
															0.423,
															-0.308
														],
														[
															0.672,
															-0.236
														],
														[
															0.435,
															-0.417
														],
														[
															0.31,
															-0.086
														],
														[
															0.416,
															-0.325
														],
														[
															1.417,
															-1.566
														],
														[
															1.66,
															-1.431
														],
														[
															0.573,
															-0.104
														],
														[
															0.347,
															-0.27
														],
														[
															0.296,
															-0.575
														],
														[
															0.396,
															-0.371
														],
														[
															6.461,
															-7.056
														],
														[
															5.865,
															-7.93
														],
														[
															12.312,
															-36.299
														],
														[
															1.284,
															-46.127
														],
														[
															-0.435,
															-5.656
														],
														[
															-0.419,
															-5.673
														],
														[
															-9.327,
															-28.386
														],
														[
															-14.103,
															-22.437
														],
														[
															-1.141,
															-1.814
														],
														[
															-1.196,
															-1.766
														],
														[
															-0.587,
															-0.779
														],
														[
															-0.18,
															-0.188
														],
														[
															-0.745,
															-1.163
														],
														[
															-0.907,
															-1.187
														],
														[
															-5.776,
															-6.537
														],
														[
															-5.787,
															-5.172
														],
														[
															-2.265,
															-2.172
														],
														[
															-2.394,
															-2.038
														],
														[
															-18.471,
															-9.367
														],
														[
															-20.809,
															-4.346
														],
														[
															-3.917,
															-0.591
														],
														[
															-1.501,
															-1.834
														],
														[
															-0.214,
															-0.914
														],
														[
															-0.644,
															-0.733
														],
														[
															-0.393,
															-0.118
														],
														[
															-0.208,
															-0.277
														],
														[
															-0.036,
															-0.543
														],
														[
															-0.493,
															-0.343
														],
														[
															-0.897,
															0.008
														],
														[
															-1.515,
															-0.406
														],
														[
															-2.763,
															0.121
														],
														[
															-3.4,
															0.197
														],
														[
															-8.096,
															1.297
														],
														[
															-7.628,
															2.235
														],
														[
															-22.019,
															16.539
														],
														[
															-16.327,
															20.878
														],
														[
															-6.952,
															11.658
														],
														[
															-5.217,
															12.173
														],
														[
															-0.608,
															1.568
														],
														[
															-0.801,
															1.936
														],
														[
															-2.797,
															8.336
														],
														[
															-2.394,
															9.387
														],
														[
															-2.24,
															17.154
														],
														[
															0,
															19.538
														],
														[
															9.312,
															33.37
														],
														[
															14.752,
															25.155
														],
														[
															0.738,
															1.367
														],
														[
															0.385,
															0.402
														],
														[
															0.298,
															0.539
														],
														[
															0.408,
															0.425
														],
														[
															0.788,
															1.188
														],
														[
															0.764,
															1.115
														],
														[
															2.422,
															3.424
														],
														[
															1.982,
															2.899
														],
														[
															0.228,
															0.225
														],
														[
															0.065,
															0.069
														],
														[
															0.952,
															1.151
														],
														[
															1.017,
															1.172
														],
														[
															3.895,
															4.339
														],
														[
															3.746,
															3.412
														],
														[
															1.045,
															0.593
														],
														[
															0.89,
															0.781
														],
														[
															0.625,
															0.921
														],
														[
															0.701,
															0.617
														],
														[
															1.837,
															1.472
														],
														[
															1.777,
															1.703
														],
														[
															4.606,
															2.933
														],
														[
															17.204,
															6.204
														],
														[
															11.259,
															2.385
														],
														[
															18.789,
															-1.104
														],
														[
															-0.112,
															0.008
														]
													],
													"o": [
														[
															-10.091,
															-0.251
														],
														[
															-9.936,
															2.519
														],
														[
															-1.208,
															0.419
														],
														[
															-1.16,
															0.286
														],
														[
															-3.118,
															1.185
														],
														[
															-3.259,
															1.341
														],
														[
															-1.98,
															1.009
														],
														[
															-1.813,
															1.249
														],
														[
															-0.969,
															0.545
														],
														[
															-1.031,
															0.481
														],
														[
															-2.219,
															1.294
														],
														[
															-1.775,
															1.138
														],
														[
															-0.971,
															0.666
														],
														[
															-0.791,
															0.676
														],
														[
															-0.44,
															0.32
														],
														[
															-0.52,
															0.086
														],
														[
															-0.416,
															0.291
														],
														[
															-0.29,
															0.6
														],
														[
															-0.878,
															0.638
														],
														[
															-0.672,
															0.236
														],
														[
															-0.345,
															0.331
														],
														[
															-0.31,
															0.086
														],
														[
															-1.671,
															1.304
														],
														[
															-1.417,
															1.566
														],
														[
															-0.362,
															0.312
														],
														[
															-0.573,
															0.104
														],
														[
															-0.419,
															0.327
														],
														[
															-0.296,
															0.576
														],
														[
															-7.291,
															6.844
														],
														[
															-6.461,
															7.056
														],
														[
															-20.468,
															27.677
														],
														[
															-12.312,
															36.299
														],
														[
															-0.159,
															5.704
														],
														[
															0.435,
															5.656
														],
														[
															2.59,
															35.018
														],
														[
															9.327,
															28.386
														],
														[
															1.242,
															1.976
														],
														[
															1.141,
															1.814
														],
														[
															0.473,
															0.698
														],
														[
															0.587,
															0.779
														],
														[
															1.111,
															1.159
														],
														[
															0.745,
															1.163
														],
														[
															5.108,
															6.679
														],
														[
															5.776,
															6.537
														],
														[
															2.546,
															2.275
														],
														[
															2.265,
															2.172
														],
														[
															14.308,
															12.183
														],
														[
															18.471,
															9.367
														],
														[
															3.832,
															0.801
														],
														[
															3.917,
															0.591
														],
														[
															0.5,
															0.611
														],
														[
															0.214,
															0.914
														],
														[
															0.221,
															0.252
														],
														[
															0.393,
															0.118
														],
														[
															0.364,
															0.485
														],
														[
															0.036,
															0.543
														],
														[
															0.898,
															0.625
														],
														[
															0.897,
															-0.008
														],
														[
															2.548,
															0.682
														],
														[
															2.763,
															-0.121
														],
														[
															9.988,
															-0.577
														],
														[
															8.096,
															-1.297
														],
														[
															30.599,
															-8.966
														],
														[
															22.019,
															-16.539
														],
														[
															7.973,
															-10.196
														],
														[
															6.952,
															-11.658
														],
														[
															0.767,
															-1.791
														],
														[
															0.608,
															-1.568
														],
														[
															3.42,
															-8.271
														],
														[
															2.796,
															-8.336
														],
														[
															4.041,
															-15.846
														],
														[
															2.24,
															-17.154
														],
														[
															0,
															-39.364
														],
														[
															-9.312,
															-33.37
														],
														[
															-0.663,
															-1.13
														],
														[
															-0.738,
															-1.367
														],
														[
															-0.401,
															-0.419
														],
														[
															-0.298,
															-0.539
														],
														[
															-1.085,
															-1.132
														],
														[
															-0.788,
															-1.188
														],
														[
															-2.329,
															-3.404
														],
														[
															-2.422,
															-3.424
														],
														[
															-0.022,
															-0.031
														],
														[
															-0.228,
															-0.225
														],
														[
															-1.173,
															-1.225
														],
														[
															-0.952,
															-1.151
														],
														[
															-3.673,
															-4.233
														],
														[
															-3.895,
															-4.339
														],
														[
															-0.93,
															-0.847
														],
														[
															-1.045,
															-0.593
														],
														[
															-0.797,
															-0.699
														],
														[
															-0.625,
															-0.921
														],
														[
															-1.808,
															-1.589
														],
														[
															-2.786,
															-2.232
														],
														[
															-4.114,
															-3.942
														],
														[
															-15.227,
															-9.696
														],
														[
															-10.628,
															-3.833
														],
														[
															-16.25,
															-3.442
														],
														[
															-0.628,
															0.037
														],
														[
															-0.655,
															0.045
														]
													],
													"v": [
														[
															349,
															26
														],
														[
															318.804,
															29.93
														],
														[
															290,
															39
														],
														[
															286.46,
															39.985
														],
														[
															283,
															41
														],
														[
															273.296,
															44.801
														],
														[
															264,
															49
														],
														[
															258.341,
															52.511
														],
														[
															253,
															56
														],
														[
															249.955,
															57.511
														],
														[
															247,
															59
														],
														[
															241.097,
															62.605
														],
														[
															236,
															66
														],
														[
															233.422,
															68.026
														],
														[
															231,
															70
														],
														[
															229.529,
															70.489
														],
														[
															228,
															71
														],
														[
															227.005,
															72.488
														],
														[
															226,
															74
														],
														[
															223.668,
															75.166
														],
														[
															222,
															76
														],
														[
															221.053,
															76.505
														],
														[
															220,
															77
														],
														[
															215.492,
															81.405
														],
														[
															211,
															86
														],
														[
															209.489,
															86.531
														],
														[
															208,
															87
														],
														[
															206.983,
															88.466
														],
														[
															206,
															90
														],
														[
															185.43,
															110.685
														],
														[
															167,
															133
														],
														[
															117.112,
															228.662
														],
														[
															96,
															352
														],
														[
															96.566,
															369.024
														],
														[
															98,
															386
														],
														[
															116.365,
															480.936
														],
														[
															152,
															557
														],
														[
															155.535,
															562.657
														],
														[
															159,
															568
														],
														[
															160.719,
															570.383
														],
														[
															162,
															572
														],
														[
															164.653,
															575.479
														],
														[
															167,
															579
														],
														[
															183.49,
															599.13
														],
														[
															201,
															617
														],
														[
															208.114,
															623.677
														],
														[
															215,
															630
														],
														[
															264.625,
															662.878
														],
														[
															324,
															684
														],
														[
															336.248,
															685.725
														],
														[
															345,
															689
														],
														[
															345.893,
															691.409
														],
														[
															347,
															694
														],
														[
															348.01,
															694.481
														],
														[
															349,
															695
														],
														[
															349.404,
															696.606
														],
														[
															350,
															698
														],
														[
															352.537,
															698.665
														],
														[
															356,
															699
														],
														[
															363.86,
															699.659
														],
														[
															373,
															699
														],
														[
															399.77,
															696.244
														],
														[
															423,
															691
														],
														[
															501.204,
															651.934
														],
														[
															558,
															595
														],
														[
															580.567,
															561.984
														],
														[
															599,
															526
														],
														[
															600.975,
															521.108
														],
														[
															603,
															516
														],
														[
															612.27,
															491.337
														],
														[
															620,
															465
														],
														[
															629.531,
															415.769
														],
														[
															633,
															361
														],
														[
															618.064,
															251.343
														],
														[
															581,
															163
														],
														[
															578.792,
															158.954
														],
														[
															577,
															156
														],
														[
															576.005,
															154.505
														],
														[
															575,
															153
														],
														[
															572.259,
															149.487
														],
														[
															570,
															146
														],
														[
															562.74,
															135.621
														],
														[
															556,
															126
														],
														[
															555.533,
															125.528
														],
														[
															555,
															125
														],
														[
															551.883,
															121.461
														],
														[
															549,
															118
														],
														[
															537.554,
															104.883
														],
														[
															526,
															93
														],
														[
															522.97,
															90.951
														],
														[
															520,
															89
														],
														[
															517.928,
															86.438
														],
														[
															516,
															84
														],
														[
															510,
															80
														],
														[
															501,
															73
														],
														[
															488,
															64
														],
														[
															437,
															38
														],
														[
															406,
															30
														],
														[
															352,
															25
														],
														[
															351,
															26
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 43,
											"s": [
												{
													"i": [
														[
															5.651,
															-1.166
														],
														[
															7.204,
															-2.301
														],
														[
															6.653,
															-2.809
														],
														[
															5.998,
															-3.103
														],
														[
															5.238,
															-3.183
														],
														[
															7.186,
															-5.303
														],
														[
															6.431,
															-5.737
														],
														[
															5.78,
															-6.19
														],
														[
															5.232,
															-6.663
														],
														[
															8.862,
															-15.896
														],
														[
															6.561,
															-18.268
														],
														[
															3.793,
															-20.738
														],
														[
															0.558,
															-23.306
														],
														[
															-0.548,
															-8.768
														],
														[
															-1.127,
															-8.22
														],
														[
															-1.515,
															-7.592
														],
														[
															-1.713,
															-6.885
														],
														[
															-4.17,
															-11.579
														],
														[
															-5.044,
															-10.569
														],
														[
															-5.727,
															-9.455
														],
														[
															-6.219,
															-8.238
														],
														[
															-5.708,
															-6.466
														],
														[
															-6.252,
															-5.922
														],
														[
															-6.918,
															-5.37
														],
														[
															-7.707,
															-4.812
														],
														[
															-7.621,
															-4.02
														],
														[
															-8.154,
															-3.36
														],
														[
															-8.831,
															-2.535
														],
														[
															-9.652,
															-1.546
														],
														[
															-1.333,
															-0.236
														],
														[
															-1.057,
															-0.283
														],
														[
															-0.82,
															-0.406
														],
														[
															-0.624,
															-0.604
														],
														[
															-0.555,
															-0.864
														],
														[
															-0.546,
															-0.95
														],
														[
															-0.468,
															-0.736
														],
														[
															-0.321,
															-0.222
														],
														[
															-0.444,
															-0.09
														],
														[
															-0.501,
															0.019
														],
														[
															-0.681,
															-0.025
														],
														[
															-0.985,
															-0.223
														],
														[
															-1.373,
															-0.085
														],
														[
															-1.39,
															0.058
														],
														[
															-1.447,
															0.114
														],
														[
															-1.543,
															0.083
														],
														[
															-5.861,
															0.681
														],
														[
															-5.391,
															1.005
														],
														[
															-5.085,
															1.322
														],
														[
															-4.942,
															1.63
														],
														[
															-5.922,
															2.477
														],
														[
															-5.482,
															2.789
														],
														[
															-5.069,
															3.042
														],
														[
															-4.683,
															3.237
														],
														[
															-1.111,
															0.846
														],
														[
															-1.085,
															0.813
														],
														[
															-1.056,
															0.685
														],
														[
															-1.025,
															0.462
														],
														[
															-0.084,
															0.174
														],
														[
															-0.089,
															0.227
														],
														[
															-0.086,
															0.189
														],
														[
															-0.074,
															0.062
														],
														[
															-0.98,
															0.719
														],
														[
															-0.969,
															0.671
														],
														[
															-0.879,
															0.616
														],
														[
															-0.712,
															0.554
														],
														[
															-0.733,
															0.755
														],
														[
															-0.682,
															0.728
														],
														[
															-0.733,
															0.609
														],
														[
															-0.886,
															0.399
														],
														[
															-0.369,
															0.348
														],
														[
															-0.402,
															0.436
														],
														[
															-0.331,
															0.37
														],
														[
															-0.159,
															0.15
														],
														[
															-0.787,
															0.935
														],
														[
															-0.705,
															0.942
														],
														[
															-0.69,
															0.911
														],
														[
															-0.743,
															0.842
														],
														[
															-0.416,
															0.412
														],
														[
															-0.431,
															0.408
														],
														[
															-0.424,
															0.417
														],
														[
															-0.396,
															0.438
														],
														[
															-3.277,
															3.902
														],
														[
															-1.779,
															3.948
														],
														[
															-0.452,
															0.168
														],
														[
															-0.125,
															0.173
														],
														[
															-3.452,
															5.666
														],
														[
															-3.272,
															5.878
														],
														[
															-8.619,
															31.552
														],
														[
															0.19,
															36.158
														],
														[
															4.121,
															22.289
														],
														[
															7.385,
															20.132
														],
														[
															9.373,
															16.378
														],
														[
															11.966,
															14.933
														],
														[
															14.278,
															12.073
														],
														[
															17.55,
															9.559
														],
														[
															21.755,
															5.667
														],
														[
															24.839,
															-1.459
														],
														[
															0.186,
															-0.246
														],
														[
															-0.056,
															0.004
														],
														[
															5.632,
															-0.608
														]
													],
													"o": [
														[
															-7.65,
															1.579
														],
														[
															-7.204,
															2.301
														],
														[
															-6.653,
															2.809
														],
														[
															-5.998,
															3.103
														],
														[
															-8.045,
															4.889
														],
														[
															-7.186,
															5.303
														],
														[
															-6.431,
															5.737
														],
														[
															-5.78,
															6.19
														],
														[
															-10.697,
															13.623
														],
														[
															-8.862,
															15.896
														],
														[
															-6.561,
															18.268
														],
														[
															-3.793,
															20.738
														],
														[
															-0.221,
															9.235
														],
														[
															0.548,
															8.768
														],
														[
															1.127,
															8.22
														],
														[
															1.515,
															7.592
														],
														[
															3.106,
															12.486
														],
														[
															4.17,
															11.579
														],
														[
															5.044,
															10.569
														],
														[
															5.727,
															9.455
														],
														[
															5.286,
															7.002
														],
														[
															5.708,
															6.466
														],
														[
															6.252,
															5.922
														],
														[
															6.918,
															5.37
														],
														[
															7.233,
															4.515
														],
														[
															7.621,
															4.02
														],
														[
															8.154,
															3.36
														],
														[
															8.831,
															2.535
														],
														[
															1.65,
															0.264
														],
														[
															1.333,
															0.236
														],
														[
															1.057,
															0.283
														],
														[
															0.82,
															0.406
														],
														[
															0.495,
															0.479
														],
														[
															0.555,
															0.864
														],
														[
															0.546,
															0.95
														],
														[
															0.468,
															0.736
														],
														[
															0.511,
															0.353
														],
														[
															0.444,
															0.09
														],
														[
															0.501,
															-0.019
														],
														[
															0.681,
															0.025
														],
														[
															1.397,
															0.317
														],
														[
															1.373,
															0.085
														],
														[
															1.39,
															-0.058
														],
														[
															1.447,
															-0.114
														],
														[
															6.495,
															-0.348
														],
														[
															5.861,
															-0.681
														],
														[
															5.391,
															-1.006
														],
														[
															5.085,
															-1.322
														],
														[
															6.389,
															-2.107
														],
														[
															5.922,
															-2.477
														],
														[
															5.482,
															-2.789
														],
														[
															5.069,
															-3.042
														],
														[
															1.135,
															-0.784
														],
														[
															1.111,
															-0.846
														],
														[
															1.085,
															-0.813
														],
														[
															1.056,
															-0.685
														],
														[
															0.068,
															-0.031
														],
														[
															0.084,
															-0.174
														],
														[
															0.089,
															-0.227
														],
														[
															0.086,
															-0.189
														],
														[
															0.913,
															-0.761
														],
														[
															0.98,
															-0.719
														],
														[
															0.969,
															-0.671
														],
														[
															0.879,
															-0.616
														],
														[
															0.886,
															-0.69
														],
														[
															0.733,
															-0.755
														],
														[
															0.682,
															-0.728
														],
														[
															0.733,
															-0.609
														],
														[
															0.235,
															-0.106
														],
														[
															0.369,
															-0.348
														],
														[
															0.402,
															-0.436
														],
														[
															0.331,
															-0.37
														],
														[
															0.938,
															-0.891
														],
														[
															0.787,
															-0.935
														],
														[
															0.705,
															-0.942
														],
														[
															0.69,
															-0.911
														],
														[
															0.38,
															-0.43
														],
														[
															0.416,
															-0.412
														],
														[
															0.431,
															-0.408
														],
														[
															0.424,
															-0.417
														],
														[
															3.111,
															-3.444
														],
														[
															3.277,
															-3.902
														],
														[
															0.07,
															-0.154
														],
														[
															0.451,
															-0.168
														],
														[
															3.922,
															-5.457
														],
														[
															3.452,
															-5.666
														],
														[
															13.714,
															-24.634
														],
														[
															8.619,
															-31.552
														],
														[
															-0.13,
															-24.71
														],
														[
															-4.121,
															-22.289
														],
														[
															-7.541,
															-20.556
														],
														[
															-9.373,
															-16.378
														],
														[
															-11.337,
															-14.148
														],
														[
															-14.278,
															-12.073
														],
														[
															-16.142,
															-8.792
														],
														[
															-21.755,
															-5.667
														],
														[
															-0.314,
															0.018
														],
														[
															-0.185,
															0.246
														],
														[
															-5.822,
															0.404
														],
														[
															-5.632,
															0.607
														]
													],
													"v": [
														[
															316,
															30
														],
														[
															293.693,
															35.875
														],
														[
															272.881,
															43.595
														],
														[
															253.879,
															52.517
														],
														[
															237,
															62
														],
														[
															214.18,
															77.283
														],
														[
															193.781,
															93.839
														],
														[
															175.491,
															111.725
														],
														[
															159,
															131
														],
														[
															129.545,
															175.253
														],
														[
															106.293,
															226.475
														],
														[
															90.644,
															284.959
														],
														[
															84,
															351
														],
														[
															84.538,
															378.024
														],
														[
															87.099,
															403.526
														],
														[
															91.111,
															427.265
														],
														[
															96,
															449
														],
														[
															106.962,
															485.123
														],
														[
															120.831,
															518.371
														],
														[
															137.034,
															548.434
														],
														[
															155,
															575
														],
														[
															171.459,
															595.204
														],
														[
															189.369,
															613.786
														],
														[
															209.093,
															630.726
														],
														[
															231,
															646
														],
														[
															253.245,
															658.844
														],
														[
															276.871,
															669.954
														],
														[
															302.312,
															678.837
														],
														[
															330,
															685
														],
														[
															334.465,
															685.731
														],
														[
															338.04,
															686.491
														],
														[
															340.845,
															687.505
														],
														[
															343,
															689
														],
														[
															344.592,
															691.09
														],
														[
															346.261,
															693.886
														],
														[
															347.799,
															696.489
														],
														[
															349,
															698
														],
														[
															350.402,
															698.626
														],
														[
															351.789,
															698.694
														],
														[
															353.531,
															698.665
														],
														[
															356,
															699
														],
														[
															360.145,
															699.581
														],
														[
															364.28,
															699.599
														],
														[
															368.525,
															699.318
														],
														[
															373,
															699
														],
														[
															391.492,
															697.455
														],
														[
															408.328,
															694.923
														],
														[
															424,
															691.43
														],
														[
															439,
															687
														],
														[
															457.46,
															680.109
														],
														[
															474.56,
															672.195
														],
														[
															490.38,
															663.434
														],
														[
															505,
															654
														],
														[
															508.369,
															651.53
														],
														[
															511.664,
															649.017
														],
														[
															514.877,
															646.745
														],
														[
															518,
															645
														],
														[
															518.23,
															644.67
														],
														[
															518.492,
															644.046
														],
														[
															518.758,
															643.399
														],
														[
															519,
															643
														],
														[
															521.859,
															640.778
														],
														[
															524.802,
															638.691
														],
														[
															527.593,
															636.758
														],
														[
															530,
															635
														],
														[
															532.403,
															632.81
														],
														[
															534.501,
															630.563
														],
														[
															536.598,
															628.535
														],
														[
															539,
															627
														],
														[
															539.932,
															626.281
														],
														[
															541.114,
															625.067
														],
														[
															542.239,
															623.819
														],
														[
															543,
															623
														],
														[
															545.572,
															620.252
														],
														[
															547.793,
															617.427
														],
														[
															549.868,
															614.638
														],
														[
															552,
															612
														],
														[
															553.199,
															610.74
														],
														[
															554.475,
															609.512
														],
														[
															555.764,
															608.279
														],
														[
															557,
															607
														],
														[
															566.999,
															595.878
														],
														[
															575,
															584
														],
														[
															575.959,
															583.514
														],
														[
															577,
															583
														],
														[
															587.988,
															566.315
														],
														[
															598,
															549
														],
														[
															632.428,
															464.143
														],
														[
															646,
															362
														],
														[
															639.441,
															291.567
														],
														[
															622,
															228
														],
														[
															596.818,
															173.282
														],
														[
															565,
															127
														],
														[
															526.659,
															87.558
														],
														[
															479,
															55
														],
														[
															421.522,
															32.312
														],
														[
															351,
															25
														],
														[
															350.222,
															25.517
														],
														[
															350,
															26
														],
														[
															332.872,
															27.428
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 44,
											"s": [
												{
													"i": [
														[
															11.229,
															-2.307
														],
														[
															27.097,
															-17.588
														],
														[
															18.106,
															-22.351
														],
														[
															14.029,
															-36.631
														],
														[
															0.936,
															-47.38
														],
														[
															-3.815,
															-21.426
														],
														[
															-6.225,
															-17.9
														],
														[
															-3.891,
															-8.433
														],
														[
															-3.416,
															-7.577
														],
														[
															-0.451,
															-0.153
														],
														[
															-0.117,
															-0.21
														],
														[
															-0.944,
															-2.035
														],
														[
															-1.152,
															-1.937
														],
														[
															-0.314,
															-0.649
														],
														[
															-0.287,
															-0.638
														],
														[
															-0.451,
															-0.156
														],
														[
															-0.12,
															-0.202
														],
														[
															-0.425,
															-1.234
														],
														[
															-0.637,
															-0.952
														],
														[
															-0.688,
															-0.8
														],
														[
															-0.661,
															-0.923
														],
														[
															-2.409,
															-3.315
														],
														[
															-2.081,
															-2.551
														],
														[
															-1.899,
															-2.019
														],
														[
															-1.606,
															-1.721
														],
														[
															-0.591,
															-1.056
														],
														[
															-0.817,
															-0.898
														],
														[
															-2.996,
															-2.787
														],
														[
															-2.478,
															-2.065
														],
														[
															-1.947,
															-1.872
														],
														[
															-2.077,
															-1.734
														],
														[
															-5.486,
															-3.996
														],
														[
															-5.781,
															-3.614
														],
														[
															-1.063,
															-0.486
														],
														[
															-0.9,
															-0.525
														],
														[
															-2.938,
															-1.653
														],
														[
															-3.01,
															-1.497
														],
														[
															-2.147,
															-0.989
														],
														[
															-2.222,
															-0.956
														],
														[
															-0.989,
															-0.54
														],
														[
															-1.081,
															-0.426
														],
														[
															-1.399,
															-0.267
														],
														[
															-1.224,
															-0.467
														],
														[
															-2.097,
															-0.848
														],
														[
															-2.32,
															-0.734
														],
														[
															-6.356,
															-1.518
														],
														[
															-6.43,
															-0.985
														],
														[
															-1.651,
															-0.1
														],
														[
															-1.099,
															-0.401
														],
														[
															-0.844,
															-1.036
														],
														[
															-1.741,
															-1.801
														],
														[
															-0.626,
															-1.078
														],
														[
															-1.182,
															-0.327
														],
														[
															-0.69,
															0.085
														],
														[
															-0.621,
															-0.168
														],
														[
															-6.485,
															0.423
														],
														[
															-6.038,
															0.663
														],
														[
															-15.452,
															4.971
														],
														[
															-12.197,
															6.141
														],
														[
															-3.559,
															1.94
														],
														[
															-3.129,
															1.41
														],
														[
															-0.163,
															0.451
														],
														[
															-0.185,
															0.123
														],
														[
															-0.379,
															-0.067
														],
														[
															-0.255,
															0.115
														],
														[
															-0.162,
															0.451
														],
														[
															-0.188,
															0.123
														],
														[
															-0.378,
															-0.067
														],
														[
															-0.256,
															0.115
														],
														[
															-0.163,
															0.451
														],
														[
															-0.185,
															0.123
														],
														[
															-0.379,
															-0.067
														],
														[
															-0.255,
															0.115
														],
														[
															-0.166,
															0.451
														],
														[
															-0.179,
															0.124
														],
														[
															-0.381,
															-0.067
														],
														[
															-0.252,
															0.113
														],
														[
															-0.168,
															0.452
														],
														[
															-0.173,
															0.125
														],
														[
															-2.379,
															1.539
														],
														[
															-1.416,
															1.356
														],
														[
															-0.323,
															0.094
														],
														[
															-0.382,
															0.312
														],
														[
															-1.628,
															1.767
														],
														[
															-1.725,
															1.49
														],
														[
															-1.017,
															0.572
														],
														[
															-0.954,
															0.869
														],
														[
															-2.514,
															2.526
														],
														[
															-2.284,
															2.474
														],
														[
															-1.62,
															1.854
														],
														[
															-1.653,
															1.89
														],
														[
															-1.501,
															1.84
														],
														[
															-1.045,
															2.317
														],
														[
															-0.731,
															0.996
														],
														[
															-11.559,
															31.457
														],
														[
															0.557,
															53.23
														],
														[
															47.149,
															54.78
														],
														[
															70.597,
															12.432
														],
														[
															19.862,
															-1.167
														],
														[
															-0.112,
															0.008
														]
													],
													"o": [
														[
															-35.507,
															7.296
														],
														[
															-27.097,
															17.588
														],
														[
															-21.949,
															27.096
														],
														[
															-14.029,
															36.631
														],
														[
															-0.483,
															24.397
														],
														[
															3.814,
															21.426
														],
														[
															3.022,
															8.689
														],
														[
															3.891,
															8.433
														],
														[
															0.079,
															0.177
														],
														[
															0.451,
															0.153
														],
														[
															1.073,
															1.925
														],
														[
															0.944,
															2.035
														],
														[
															0.455,
															0.764
														],
														[
															0.314,
															0.649
														],
														[
															0.078,
															0.173
														],
														[
															0.451,
															0.156
														],
														[
															0.661,
															1.114
														],
														[
															0.425,
															1.234
														],
														[
															0.587,
															0.877
														],
														[
															0.688,
															0.8
														],
														[
															2.284,
															3.189
														],
														[
															2.409,
															3.315
														],
														[
															1.796,
															2.202
														],
														[
															1.899,
															2.019
														],
														[
															0.819,
															0.877
														],
														[
															0.591,
															1.056
														],
														[
															2.537,
															2.786
														],
														[
															2.996,
															2.787
														],
														[
															2.136,
															1.78
														],
														[
															1.947,
															1.872
														],
														[
															5.274,
															4.401
														],
														[
															5.486,
															3.996
														],
														[
															0.847,
															0.529
														],
														[
															1.063,
															0.486
														],
														[
															3.239,
															1.889
														],
														[
															2.938,
															1.653
														],
														[
															2.191,
															1.09
														],
														[
															2.147,
															0.988
														],
														[
															0.963,
															0.414
														],
														[
															0.989,
															0.54
														],
														[
															1.179,
															0.465
														],
														[
															1.399,
															0.267
														],
														[
															2.291,
															0.875
														],
														[
															2.097,
															0.848
														],
														[
															6.144,
															1.943
														],
														[
															6.356,
															1.518
														],
														[
															1.299,
															0.199
														],
														[
															1.651,
															0.1
														],
														[
															2.884,
															1.054
														],
														[
															0.844,
															1.036
														],
														[
															1.315,
															1.36
														],
														[
															0.626,
															1.078
														],
														[
															0.62,
															0.171
														],
														[
															0.69,
															-0.085
														],
														[
															5.02,
															1.355
														],
														[
															6.485,
															-0.423
														],
														[
															17.995,
															-1.976
														],
														[
															15.452,
															-4.971
														],
														[
															3.635,
															-1.831
														],
														[
															3.559,
															-1.94
														],
														[
															0.162,
															-0.073
														],
														[
															0.163,
															-0.451
														],
														[
															0.23,
															-0.154
														],
														[
															0.379,
															0.067
														],
														[
															0.163,
															-0.073
														],
														[
															0.162,
															-0.451
														],
														[
															0.232,
															-0.153
														],
														[
															0.378,
															0.067
														],
														[
															0.162,
															-0.073
														],
														[
															0.163,
															-0.451
														],
														[
															0.23,
															-0.154
														],
														[
															0.379,
															0.067
														],
														[
															0.159,
															-0.072
														],
														[
															0.166,
															-0.451
														],
														[
															0.224,
															-0.155
														],
														[
															0.381,
															0.067
														],
														[
															0.154,
															-0.07
														],
														[
															0.168,
															-0.451
														],
														[
															2.068,
															-1.486
														],
														[
															2.379,
															-1.539
														],
														[
															0.326,
															-0.312
														],
														[
															0.323,
															-0.094
														],
														[
															1.762,
															-1.44
														],
														[
															1.629,
															-1.767
														],
														[
															0.977,
															-0.844
														],
														[
															1.017,
															-0.572
														],
														[
															2.66,
															-2.423
														],
														[
															2.514,
															-2.526
														],
														[
															1.642,
															-1.78
														],
														[
															1.652,
															-1.891
														],
														[
															1.487,
															-1.7
														],
														[
															2.035,
															-2.494
														],
														[
															0.54,
															-1.199
														],
														[
															18.816,
															-25.626
														],
														[
															14.662,
															-39.903
														],
														[
															-1.056,
															-100.81
														],
														[
															-38.376,
															-44.587
														],
														[
															-16.501,
															-2.906
														],
														[
															-0.628,
															0.037
														],
														[
															-12.268,
															0.851
														]
													],
													"v": [
														[
															314,
															30
														],
														[
															219.949,
															68.709
														],
														[
															152,
															130
														],
														[
															96.741,
															225.288
														],
														[
															73,
															351
														],
														[
															78.47,
															419.872
														],
														[
															94,
															479
														],
														[
															104.704,
															504.834
														],
														[
															116,
															529
														],
														[
															116.972,
															529.475
														],
														[
															118,
															530
														],
														[
															120.941,
															535.991
														],
														[
															124,
															542
														],
														[
															125.126,
															544.095
														],
														[
															126,
															546
														],
														[
															126.968,
															546.478
														],
														[
															128,
															547
														],
														[
															129.517,
															550.622
														],
														[
															131,
															554
														],
														[
															132.945,
															556.466
														],
														[
															135,
															559
														],
														[
															142.153,
															568.979
														],
														[
															149,
															578
														],
														[
															154.643,
															584.361
														],
														[
															160,
															590
														],
														[
															162.001,
															592.985
														],
														[
															164,
															596
														],
														[
															172.544,
															604.541
														],
														[
															181,
															612
														],
														[
															187.044,
															617.535
														],
														[
															193,
															623
														],
														[
															209.12,
															635.59
														],
														[
															226,
															647
														],
														[
															228.96,
															648.503
														],
														[
															232,
															650
														],
														[
															241.171,
															655.294
														],
														[
															250,
															660
														],
														[
															256.476,
															663.101
														],
														[
															263,
															666
														],
														[
															265.912,
															667.492
														],
														[
															269,
															669
														],
														[
															272.967,
															669.998
														],
														[
															277,
															671
														],
														[
															283.478,
															673.606
														],
														[
															290,
															676
														],
														[
															308.786,
															681.219
														],
														[
															328,
															685
														],
														[
															332.65,
															685.348
														],
														[
															337,
															686
														],
														[
															341.857,
															688.94
														],
														[
															345,
															693
														],
														[
															347.6,
															696.775
														],
														[
															350,
															699
														],
														[
															351.999,
															699.003
														],
														[
															354,
															699
														],
														[
															371.736,
															700.014
														],
														[
															391,
															698
														],
														[
															441.348,
															687.124
														],
														[
															483,
															670
														],
														[
															493.88,
															664.185
														],
														[
															504,
															659
														],
														[
															504.483,
															658.038
														],
														[
															505,
															657
														],
														[
															505.981,
															656.971
														],
														[
															507,
															657
														],
														[
															507.482,
															656.037
														],
														[
															508,
															655
														],
														[
															508.982,
															654.972
														],
														[
															510,
															655
														],
														[
															510.483,
															654.038
														],
														[
															511,
															653
														],
														[
															511.981,
															652.971
														],
														[
															513,
															653
														],
														[
															513.485,
															652.039
														],
														[
															514,
															651
														],
														[
															514.979,
															650.969
														],
														[
															516,
															651
														],
														[
															516.486,
															650.041
														],
														[
															517,
															649
														],
														[
															523.989,
															644.402
														],
														[
															530,
															640
														],
														[
															530.958,
															639.5
														],
														[
															532,
															639
														],
														[
															537.028,
															634.038
														],
														[
															542,
															629
														],
														[
															545.018,
															627.018
														],
														[
															548,
															625
														],
														[
															555.782,
															617.539
														],
														[
															563,
															610
														],
														[
															567,
															604
														],
														[
															573,
															599
														],
														[
															577,
															593
														],
														[
															582,
															586
														],
														[
															586,
															582
														],
														[
															632,
															497
														],
														[
															657,
															361
														],
														[
															572,
															125
														],
														[
															407,
															29
														],
														[
															350,
															25
														],
														[
															349,
															26
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 45,
											"s": [
												{
													"i": [
														[
															12.037,
															-2.311
														],
														[
															18.707,
															-8.559
														],
														[
															14.769,
															-10.463
														],
														[
															1.012,
															-0.648
														],
														[
															0.923,
															-0.679
														],
														[
															1.6,
															-1.545
														],
														[
															1.706,
															-1.425
														],
														[
															0.523,
															-0.077
														],
														[
															0.483,
															-0.338
														],
														[
															0.295,
															-0.594
														],
														[
															0.404,
															-0.334
														],
														[
															2.37,
															-2.247
														],
														[
															2.594,
															-2.594
														],
														[
															3.244,
															-3.119
														],
														[
															3.005,
															-3.506
														],
														[
															1.749,
															-2.354
														],
														[
															1.329,
															-1.63
														],
														[
															1.579,
															-2.269
														],
														[
															1.615,
															-2.385
														],
														[
															0.587,
															-0.779
														],
														[
															0.18,
															-0.188
														],
														[
															0.788,
															-1.166
														],
														[
															0.775,
															-1.214
														],
														[
															1.134,
															-1.988
														],
														[
															1.114,
															-1.933
														],
														[
															1.647,
															-3.155
														],
														[
															1.607,
															-3.254
														],
														[
															2.037,
															-4.328
														],
														[
															1.821,
															-4.573
														],
														[
															3.611,
															-34.029
														],
														[
															-6.244,
															-33.76
														],
														[
															-12.404,
															-26.061
														],
														[
															-16.528,
															-20.103
														],
														[
															-4.273,
															-4.74
														],
														[
															-4.124,
															-3.437
														],
														[
															-4.152,
															-3.632
														],
														[
															-0.684,
															-0.533
														],
														[
															-0.843,
															-0.69
														],
														[
															-1.877,
															-1.484
														],
														[
															-4.822,
															-3.416
														],
														[
															-2.999,
															-1.352
														],
														[
															-0.396,
															-0.242
														],
														[
															-2.203,
															-1.29
														],
														[
															-1.725,
															-0.963
														],
														[
															-2.285,
															-1.248
														],
														[
															-4.152,
															-1.959
														],
														[
															-2.097,
															-0.89
														],
														[
															-0.988,
															-0.424
														],
														[
															-3.124,
															-1.225
														],
														[
															-16.656,
															-3.214
														],
														[
															-2.83,
															-0.431
														],
														[
															-2.16,
															-0.741
														],
														[
															-3.551,
															-3.303
														],
														[
															-4.386,
															-1.203
														],
														[
															-6.318,
															0.202
														],
														[
															-11.375,
															1.946
														],
														[
															-5.705,
															1.343
														],
														[
															-1.586,
															0.352
														],
														[
															-3.696,
															1.056
														],
														[
															-13.471,
															6.571
														],
														[
															-9.82,
															4.427
														],
														[
															-0.384,
															0.245
														],
														[
															-0.518,
															0.234
														],
														[
															-0.37,
															0.247
														],
														[
															-0.511,
															0.23
														],
														[
															-0.353,
															0.248
														],
														[
															-3.968,
															1.789
														],
														[
															-0.295,
															0.246
														],
														[
															-3.01,
															1.357
														],
														[
															-1.202,
															1.03
														],
														[
															-1.119,
															1.019
														],
														[
															-2.309,
															5.121
														],
														[
															-0.997,
															1.127
														],
														[
															-15.266,
															38.344
														],
														[
															0.29,
															53.855
														],
														[
															6.856,
															26.39
														],
														[
															3.311,
															9.62
														],
														[
															0.926,
															2.459
														],
														[
															1.036,
															2.539
														],
														[
															0.455,
															1.062
														],
														[
															1.016,
															2.371
														],
														[
															2.763,
															5.495
														],
														[
															1.088,
															1.992
														],
														[
															3.969,
															6.339
														],
														[
															6.874,
															8.693
														],
														[
															1.521,
															1.828
														],
														[
															1.695,
															2.048
														],
														[
															0.723,
															0.844
														],
														[
															0.773,
															0.849
														],
														[
															10.393,
															8.673
														],
														[
															2.271,
															1.024
														],
														[
															0.325,
															0.249
														],
														[
															0.82,
															0.62
														],
														[
															1.966,
															1.436
														],
														[
															0.492,
															0.222
														],
														[
															1.156,
															0.794
														],
														[
															18.259,
															7.523
														],
														[
															16.426,
															3.807
														],
														[
															26.787,
															-1.424
														],
														[
															-0.115,
															0.007
														]
													],
													"o": [
														[
															-22.401,
															4.302
														],
														[
															-18.708,
															8.559
														],
														[
															-1.029,
															0.73
														],
														[
															-1.012,
															0.648
														],
														[
															-1.894,
															1.395
														],
														[
															-1.6,
															1.545
														],
														[
															-0.424,
															0.355
														],
														[
															-0.523,
															0.077
														],
														[
															-0.416,
															0.291
														],
														[
															-0.295,
															0.594
														],
														[
															-2.926,
															2.419
														],
														[
															-2.37,
															2.247
														],
														[
															-3.017,
															3.017
														],
														[
															-3.244,
															3.119
														],
														[
															-1.677,
															1.956
														],
														[
															-1.749,
															2.354
														],
														[
															-2.07,
															2.538
														],
														[
															-1.578,
															2.269
														],
														[
															-0.473,
															0.698
														],
														[
															-0.587,
															0.779
														],
														[
															-1.074,
															1.121
														],
														[
															-0.788,
															1.166
														],
														[
															-1.351,
															2.116
														],
														[
															-1.134,
															1.988
														],
														[
															-1.803,
															3.128
														],
														[
															-1.648,
															3.155
														],
														[
															-2.031,
															4.114
														],
														[
															-2.037,
															4.328
														],
														[
															-10.799,
															27.123
														],
														[
															-3.611,
															34.029
														],
														[
															5.855,
															31.654
														],
														[
															12.404,
															26.061
														],
														[
															3.784,
															4.602
														],
														[
															4.273,
															4.74
														],
														[
															4.488,
															3.74
														],
														[
															0.708,
															0.619
														],
														[
															0.843,
															0.656
														],
														[
															1.839,
															1.506
														],
														[
															5.442,
															4.302
														],
														[
															3.333,
															2.361
														],
														[
															0.34,
															0.153
														],
														[
															2.141,
															1.311
														],
														[
															1.848,
															1.082
														],
														[
															2.358,
															1.316
														],
														[
															4.104,
															2.242
														],
														[
															1.964,
															0.927
														],
														[
															0.724,
															0.307
														],
														[
															3.993,
															1.711
														],
														[
															15.725,
															6.165
														],
														[
															2.334,
															0.45
														],
														[
															2.606,
															0.396
														],
														[
															6.622,
															2.271
														],
														[
															2.25,
															2.093
														],
														[
															5.106,
															1.4
														],
														[
															12.734,
															-0.408
														],
														[
															5.65,
															-0.966
														],
														[
															1.581,
															-0.372
														],
														[
															3.232,
															-0.718
														],
														[
															16.502,
															-4.716
														],
														[
															10.945,
															-5.339
														],
														[
															0.332,
															-0.15
														],
														[
															0.474,
															-0.303
														],
														[
															0.324,
															-0.146
														],
														[
															0.46,
															-0.307
														],
														[
															0.313,
															-0.141
														],
														[
															4.457,
															-3.133
														],
														[
															0.274,
															-0.124
														],
														[
															3.122,
															-2.602
														],
														[
															2.229,
															-1.005
														],
														[
															1.031,
															-0.883
														],
														[
															4.725,
															-4.302
														],
														[
															0.767,
															-1.702
														],
														[
															25.378,
															-28.665
														],
														[
															15.711,
															-39.462
														],
														[
															-0.172,
															-32.012
														],
														[
															-2.826,
															-10.876
														],
														[
															-0.92,
															-2.672
														],
														[
															-0.963,
															-2.558
														],
														[
															-0.609,
															-1.493
														],
														[
															-1.17,
															-2.731
														],
														[
															-2.491,
															-5.813
														],
														[
															-1.075,
															-2.138
														],
														[
															-4.074,
															-7.46
														],
														[
															-6.182,
															-9.873
														],
														[
															-1.345,
															-1.701
														],
														[
															-1.611,
															-1.936
														],
														[
															-0.699,
															-0.844
														],
														[
															-0.934,
															-1.089
														],
														[
															-9.642,
															-10.589
														],
														[
															-2.487,
															-2.076
														],
														[
															-0.295,
															-0.133
														],
														[
															-1.034,
															-0.791
														],
														[
															-1.869,
															-1.413
														],
														[
															-0.429,
															-0.313
														],
														[
															-1.33,
															-0.6
														],
														[
															-16.175,
															-11.106
														],
														[
															-14.651,
															-6.036
														],
														[
															-22.909,
															-5.31
														],
														[
															-0.629,
															0.033
														],
														[
															-12.306,
															0.792
														]
													],
													"v": [
														[
															312,
															30
														],
														[
															250.276,
															49.879
														],
														[
															200,
															79
														],
														[
															196.92,
															81.038
														],
														[
															194,
															83
														],
														[
															188.859,
															87.477
														],
														[
															184,
															92
														],
														[
															182.544,
															92.513
														],
														[
															181,
															93
														],
														[
															179.991,
															94.468
														],
														[
															179,
															96
														],
														[
															171.251,
															102.869
														],
														[
															164,
															110
														],
														[
															154.492,
															119.133
														],
														[
															145,
															129
														],
														[
															139.739,
															135.745
														],
														[
															135,
															142
														],
														[
															129.659,
															149.115
														],
														[
															125,
															156
														],
														[
															123.281,
															158.382
														],
														[
															122,
															160
														],
														[
															119.276,
															163.43
														],
														[
															117,
															167
														],
														[
															113.323,
															173.137
														],
														[
															110,
															179
														],
														[
															104.853,
															188.405
														],
														[
															100,
															198
														],
														[
															93.842,
															210.655
														],
														[
															88,
															224
														],
														[
															65.718,
															317.522
														],
														[
															69,
															421
														],
														[
															96.995,
															507.663
														],
														[
															141,
															577
														],
														[
															153.245,
															591.374
														],
														[
															166,
															604
														],
														[
															178,
															616
														],
														[
															181,
															617
														],
														[
															183,
															620
														],
														[
															189,
															624
														],
														[
															205,
															636
														],
														[
															215,
															642
														],
														[
															216,
															644
														],
														[
															223,
															647
														],
														[
															228,
															651
														],
														[
															235,
															654
														],
														[
															247,
															661
														],
														[
															254,
															663
														],
														[
															257,
															665
														],
														[
															267,
															669
														],
														[
															319,
															684
														],
														[
															327,
															685
														],
														[
															336,
															686
														],
														[
															347,
															697
														],
														[
															353,
															699
														],
														[
															372,
															700
														],
														[
															408,
															696
														],
														[
															425,
															692
														],
														[
															430,
															692
														],
														[
															441,
															688
														],
														[
															486,
															671
														],
														[
															517,
															654
														],
														[
															518,
															652
														],
														[
															520,
															652
														],
														[
															521,
															650
														],
														[
															523,
															650
														],
														[
															524,
															648
														],
														[
															538,
															639
														],
														[
															539,
															637
														],
														[
															549,
															630
														],
														[
															555,
															623
														],
														[
															559,
															621
														],
														[
															574,
															604
														],
														[
															579,
															600
														],
														[
															641,
															499
														],
														[
															667,
															361
														],
														[
															656,
															271
														],
														[
															646,
															240
														],
														[
															644,
															232
														],
														[
															640,
															225
														],
														[
															639,
															221
														],
														[
															636,
															214
														],
														[
															628,
															196
														],
														[
															624,
															190
														],
														[
															613,
															170
														],
														[
															592,
															140
														],
														[
															587,
															135
														],
														[
															583,
															129
														],
														[
															580,
															127
														],
														[
															578,
															123
														],
														[
															547,
															94
														],
														[
															540,
															89
														],
														[
															539,
															87
														],
														[
															535,
															85
														],
														[
															530,
															80
														],
														[
															528,
															80
														],
														[
															524,
															76
														],
														[
															471,
															47
														],
														[
															424,
															32
														],
														[
															349,
															25
														],
														[
															348,
															26
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 46,
											"s": [
												{
													"i": [
														[
															12.139,
															-2.291
														],
														[
															5.595,
															-1.404
														],
														[
															5.28,
															-1.186
														],
														[
															0.636,
															-0.469
														],
														[
															0.265,
															-0.081
														],
														[
															3.022,
															-0.971
														],
														[
															2.475,
															-1.061
														],
														[
															1.666,
															-0.649
														],
														[
															1.673,
															-0.692
														],
														[
															7.463,
															-4.155
														],
														[
															6.312,
															-4.14
														],
														[
															2.871,
															-2.011
														],
														[
															2.512,
															-1.987
														],
														[
															0.825,
															-0.916
														],
														[
															0.86,
															-0.673
														],
														[
															0.552,
															-0.095
														],
														[
															0.377,
															-0.293
														],
														[
															0.289,
															-0.583
														],
														[
															0.423,
															-0.341
														],
														[
															0.392,
															0.066
														],
														[
															0.235,
															-0.106
														],
														[
															0.179,
															-0.454
														],
														[
															0.147,
															-0.123
														],
														[
															10.963,
															-12.709
														],
														[
															8.509,
															-13.629
														],
														[
															4.388,
															-8.057
														],
														[
															3.004,
															-7.654
														],
														[
															4.873,
															-22.006
														],
														[
															0,
															-24.846
														],
														[
															-0.997,
															-11.532
														],
														[
															-2.014,
															-10.918
														],
														[
															-2.851,
															-9.973
														],
														[
															-3.608,
															-9.319
														],
														[
															-16.04,
															-22.396
														],
														[
															-20.863,
															-17.06
														],
														[
															-7.422,
															-5.41
														],
														[
															-8.226,
															-4.566
														],
														[
															-17.824,
															-6.367
														],
														[
															-20.168,
															-2.907
														],
														[
															-1.633,
															-0.107
														],
														[
															-1.135,
															-0.381
														],
														[
															-1.311,
															-1.345
														],
														[
															-1.054,
															-1.713
														],
														[
															-0.318,
															-0.256
														],
														[
															-0.392,
															-0.426
														],
														[
															-0.151,
															-0.666
														],
														[
															-0.203,
															-0.127
														],
														[
															-0.769,
															0.091
														],
														[
															-0.501,
															-0.101
														],
														[
															-6.763,
															0.409
														],
														[
															-6.879,
															0.587
														],
														[
															-13.963,
															3.506
														],
														[
															-11.385,
															4.63
														],
														[
															-1.79,
															0.946
														],
														[
															-1.103,
															0.512
														],
														[
															-0.918,
															0.097
														],
														[
															-0.637,
															0.292
														],
														[
															-4.317,
															2.592
														],
														[
															-4.212,
															2.56
														],
														[
															-7.136,
															5.056
														],
														[
															-5.983,
															5.233
														],
														[
															-10.388,
															12.03
														],
														[
															-8.962,
															13.956
														],
														[
															-4.304,
															7.449
														],
														[
															-2.664,
															6.788
														],
														[
															-0.094,
															0.62
														],
														[
															-0.317,
															0.742
														],
														[
															-0.736,
															1.128
														],
														[
															-0.523,
															1.245
														],
														[
															-2.203,
															6.604
														],
														[
															-1.695,
															5.639
														],
														[
															-0.292,
															1.502
														],
														[
															-0.409,
															1.575
														],
														[
															-2.172,
															15.53
														],
														[
															0.234,
															16.212
														],
														[
															4.768,
															22.806
														],
														[
															8.546,
															20.12
														],
														[
															4.857,
															8.95
														],
														[
															5.277,
															8.093
														],
														[
															5.945,
															7.913
														],
														[
															6.885,
															7.166
														],
														[
															3.529,
															3.354
														],
														[
															3.678,
															3.248
														],
														[
															1.337,
															1.2
														],
														[
															1.2,
															0.918
														],
														[
															1.425,
															1.129
														],
														[
															1.59,
															1.172
														],
														[
															5.102,
															3.5
														],
														[
															5.576,
															3.303
														],
														[
															5.26,
															2.728
														],
														[
															4.962,
															2.127
														],
														[
															0.482,
															0.384
														],
														[
															0.481,
															0.21
														],
														[
															2.434,
															0.73
														],
														[
															2.581,
															0.908
														],
														[
															1.308,
															0.512
														],
														[
															1.31,
															0.439
														],
														[
															18.235,
															2.966
														],
														[
															20.495,
															-1.09
														],
														[
															-0.115,
															0.007
														]
													],
													"o": [
														[
															-6.339,
															1.197
														],
														[
															-5.595,
															1.404
														],
														[
															-0.19,
															0.043
														],
														[
															-0.636,
															0.469
														],
														[
															-3.438,
															1.054
														],
														[
															-3.022,
															0.971
														],
														[
															-1.665,
															0.713
														],
														[
															-1.666,
															0.649
														],
														[
															-7.834,
															3.239
														],
														[
															-7.463,
															4.155
														],
														[
															-3.005,
															1.971
														],
														[
															-2.871,
															2.011
														],
														[
															-0.838,
															0.663
														],
														[
															-0.826,
															0.916
														],
														[
															-0.415,
															0.325
														],
														[
															-0.552,
															0.095
														],
														[
															-0.421,
															0.328
														],
														[
															-0.289,
															0.583
														],
														[
															-0.196,
															0.158
														],
														[
															-0.392,
															-0.066
														],
														[
															-0.137,
															0.062
														],
														[
															-0.179,
															0.454
														],
														[
															-12.639,
															10.533
														],
														[
															-10.963,
															12.709
														],
														[
															-4.444,
															7.118
														],
														[
															-4.388,
															8.057
														],
														[
															-7.507,
															19.131
														],
														[
															-4.873,
															22.006
														],
														[
															0,
															12.953
														],
														[
															0.996,
															11.532
														],
														[
															1.99,
															10.789
														],
														[
															2.85,
															9.973
														],
														[
															10.977,
															28.355
														],
														[
															16.04,
															22.396
														],
														[
															7.085,
															5.794
														],
														[
															7.422,
															5.41
														],
														[
															15.536,
															8.624
														],
														[
															17.824,
															6.367
														],
														[
															1.334,
															0.192
														],
														[
															1.633,
															0.106
														],
														[
															2.701,
															0.908
														],
														[
															1.311,
															1.345
														],
														[
															0.338,
															0.549
														],
														[
															0.317,
															0.256
														],
														[
															0.192,
															0.209
														],
														[
															0.151,
															0.666
														],
														[
															0.424,
															0.264
														],
														[
															0.769,
															-0.091
														],
														[
															6.069,
															1.223
														],
														[
															6.763,
															-0.409
														],
														[
															15.764,
															-1.344
														],
														[
															13.963,
															-3.506
														],
														[
															1.736,
															-0.706
														],
														[
															1.79,
															-0.945
														],
														[
															0.689,
															-0.32
														],
														[
															0.918,
															-0.097
														],
														[
															4.522,
															-2.072
														],
														[
															4.317,
															-2.592
														],
														[
															7.474,
															-4.542
														],
														[
															7.136,
															-5.056
														],
														[
															12.488,
															-10.923
														],
														[
															10.388,
															-12.03
														],
														[
															4.119,
															-6.413
														],
														[
															4.304,
															-7.449
														],
														[
															0.305,
															-0.778
														],
														[
															0.094,
															-0.62
														],
														[
															0.532,
															-1.243
														],
														[
															0.736,
															-1.128
														],
														[
															2.493,
															-5.945
														],
														[
															2.203,
															-6.604
														],
														[
															0.426,
															-1.416
														],
														[
															0.291,
															-1.502
														],
														[
															3.544,
															-13.669
														],
														[
															2.172,
															-15.529
														],
														[
															-0.384,
															-26.655
														],
														[
															-4.768,
															-22.806
														],
														[
															-4.293,
															-10.108
														],
														[
															-4.857,
															-8.95
														],
														[
															-5.337,
															-8.183
														],
														[
															-5.945,
															-7.913
														],
														[
															-3.205,
															-3.336
														],
														[
															-3.529,
															-3.354
														],
														[
															-1.452,
															-1.282
														],
														[
															-1.337,
															-1.2
														],
														[
															-1.711,
															-1.31
														],
														[
															-1.425,
															-1.13
														],
														[
															-5.016,
															-3.697
														],
														[
															-5.102,
															-3.5
														],
														[
															-4.999,
															-2.961
														],
														[
															-5.26,
															-2.728
														],
														[
															-0.59,
															-0.253
														],
														[
															-0.482,
															-0.384
														],
														[
															-2.685,
															-1.172
														],
														[
															-2.434,
															-0.73
														],
														[
															-1.457,
															-0.513
														],
														[
															-1.308,
															-0.512
														],
														[
															-15.563,
															-5.225
														],
														[
															-18.235,
															-2.966
														],
														[
															-0.629,
															0.033
														],
														[
															-12.758,
															0.821
														]
													],
													"v": [
														[
															311,
															30
														],
														[
															293.206,
															34.008
														],
														[
															277,
															38
														],
														[
															275.557,
															38.971
														],
														[
															274,
															40
														],
														[
															264.278,
															42.995
														],
														[
															256,
															46
														],
														[
															251.006,
															48.016
														],
														[
															246,
															50
														],
														[
															222.859,
															61.325
														],
														[
															202,
															74
														],
														[
															193.131,
															79.988
														],
														[
															185,
															86
														],
														[
															182.517,
															88.492
														],
														[
															180,
															91
														],
														[
															178.471,
															91.524
														],
														[
															177,
															92
														],
														[
															176.002,
															93.49
														],
														[
															175,
															95
														],
														[
															174.029,
															95.039
														],
														[
															173,
															95
														],
														[
															172.508,
															95.954
														],
														[
															172,
															97
														],
														[
															136.402,
															132.178
														],
														[
															107,
															172
														],
														[
															93.42,
															195.098
														],
														[
															82,
															219
														],
														[
															62.87,
															280.714
														],
														[
															55,
															351
														],
														[
															56.49,
															387.527
														],
														[
															61,
															421
														],
														[
															68.287,
															452.103
														],
														[
															78,
															481
														],
														[
															118.585,
															556.971
														],
														[
															174,
															616
														],
														[
															195.645,
															632.921
														],
														[
															219,
															648
														],
														[
															269.026,
															670.788
														],
														[
															326,
															685
														],
														[
															330.65,
															685.358
														],
														[
															335,
															686
														],
														[
															340.735,
															689.396
														],
														[
															344,
															694
														],
														[
															344.96,
															695.093
														],
														[
															346,
															696
														],
														[
															346.492,
															697.562
														],
														[
															347,
															699
														],
														[
															348.942,
															699.122
														],
														[
															351,
															699
														],
														[
															370.393,
															699.857
														],
														[
															391,
															698
														],
														[
															435.785,
															690.465
														],
														[
															474,
															678
														],
														[
															479.475,
															675.354
														],
														[
															484,
															673
														],
														[
															486.539,
															672.479
														],
														[
															489,
															672
														],
														[
															502.232,
															664.866
														],
														[
															515,
															657
														],
														[
															537.119,
															642.518
														],
														[
															557,
															627
														],
														[
															591.145,
															592.775
														],
														[
															620,
															554
														],
														[
															633.091,
															532.781
														],
														[
															644,
															511
														],
														[
															644.491,
															508.973
														],
														[
															645,
															507
														],
														[
															647.007,
															503.502
														],
														[
															649,
															500
														],
														[
															656.098,
															480.77
														],
														[
															662,
															462
														],
														[
															663.013,
															457.62
														],
														[
															664,
															453
														],
														[
															672.833,
															408.907
														],
														[
															676,
															361
														],
														[
															668.122,
															287.098
														],
														[
															648,
															223
														],
														[
															634.238,
															194.489
														],
														[
															619,
															169
														],
														[
															602.161,
															144.737
														],
														[
															583,
															122
														],
														[
															572.855,
															111.934
														],
														[
															562,
															102
														],
														[
															557.811,
															98.227
														],
														[
															554,
															95
														],
														[
															549.409,
															91.397
														],
														[
															545,
															88
														],
														[
															529.92,
															77.205
														],
														[
															514,
															67
														],
														[
															498.472,
															58.374
														],
														[
															483,
															51
														],
														[
															481.419,
															49.968
														],
														[
															480,
															49
														],
														[
															472.422,
															46.302
														],
														[
															465,
															44
														],
														[
															460.89,
															42.445
														],
														[
															457,
															41
														],
														[
															406.199,
															28.264
														],
														[
															348,
															25
														],
														[
															347,
															26
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 47,
											"s": [
												{
													"i": [
														[
															0.65,
															0.037
														],
														[
															5.667,
															-0.84
														],
														[
															5.726,
															-0.963
														],
														[
															10.085,
															-2.836
														],
														[
															9.11,
															-3.71
														],
														[
															5.197,
															-2.453
														],
														[
															3.507,
															-2.273
														],
														[
															1.69,
															-0.76
														],
														[
															1.632,
															-0.917
														],
														[
															2,
															-1.398
														],
														[
															1.963,
															-1.261
														],
														[
															12.234,
															-10.532
														],
														[
															10.156,
															-11.944
														],
														[
															1.272,
															-1.855
														],
														[
															1.417,
															-1.823
														],
														[
															1.27,
															-1.682
														],
														[
															0.802,
															-0.837
														],
														[
															0.298,
															-0.539
														],
														[
															0.407,
															-0.425
														],
														[
															0.067,
															-0.27
														],
														[
															0.348,
															-0.522
														],
														[
															1.027,
															-0.916
														],
														[
															0.332,
															-0.497
														],
														[
															0.051,
															-0.701
														],
														[
															0.394,
															-0.592
														],
														[
															0.726,
															-0.835
														],
														[
															0.538,
															-0.822
														],
														[
															2.748,
															-5.344
														],
														[
															2.63,
															-5.466
														],
														[
															1.244,
															-2.129
														],
														[
															0.986,
															-2.325
														],
														[
															4.721,
															-21.855
														],
														[
															0.465,
															-23.542
														],
														[
															-4.332,
															-21.795
														],
														[
															-7.178,
															-18.18
														],
														[
															-9.881,
															-16.03
														],
														[
															-11.915,
															-13.732
														],
														[
															-23.361,
															-15.867
														],
														[
															-28.435,
															-9.648
														],
														[
															-3.171,
															-1.119
														],
														[
															-2.384,
															-0.53
														],
														[
															-3.199,
															-0.628
														],
														[
															-3.506,
															-0.666
														],
														[
															-1.346,
															-0.377
														],
														[
															-1.286,
															-0.238
														],
														[
															-4.448,
															-0.494
														],
														[
															-1.744,
															-1.385
														],
														[
															-0.365,
															-0.907
														],
														[
															-0.841,
															-0.817
														],
														[
															-0.81,
															-1.055
														],
														[
															-1.295,
															-0.358
														],
														[
															-0.689,
															0.082
														],
														[
															-0.625,
															-0.155
														],
														[
															-3.254,
															-0.113
														],
														[
															-3.38,
															0.097
														],
														[
															-6.281,
															0.732
														],
														[
															-5.692,
															0.866
														],
														[
															-20.135,
															7.88
														],
														[
															-16.409,
															10.67
														],
														[
															-2.319,
															1.595
														],
														[
															-2.257,
															1.017
														],
														[
															-0.168,
															0.452
														],
														[
															-0.173,
															0.125
														],
														[
															-2.477,
															1.791
														],
														[
															-2.308,
															1.836
														],
														[
															-1.004,
															0.839
														],
														[
															-0.989,
															0.851
														],
														[
															-14.683,
															20.415
														],
														[
															-10.454,
															24.147
														],
														[
															-4.829,
															22.956
														],
														[
															0,
															28.119
														],
														[
															3.013,
															18.045
														],
														[
															4.948,
															15.389
														],
														[
															2.285,
															5.884
														],
														[
															1.986,
															4.635
														],
														[
															0.793,
															1.74
														],
														[
															0.856,
															1.769
														],
														[
															7.589,
															11.731
														],
														[
															8.37,
															10.115
														],
														[
															0.572,
															0.289
														],
														[
															0.362,
															0.422
														],
														[
															0.262,
															0.731
														],
														[
															0.486,
															0.534
														],
														[
															1.459,
															1.141
														],
														[
															0.916,
															1.069
														],
														[
															1.12,
															1.204
														],
														[
															3.666,
															3.406
														],
														[
															5.438,
															4.661
														],
														[
															1.159,
															0.906
														],
														[
															1.876,
															1.425
														],
														[
															0.987,
															0.946
														],
														[
															0.85,
															0.815
														],
														[
															2.666,
															1.695
														],
														[
															1.52,
															0.685
														],
														[
															0.403,
															0.24
														],
														[
															1.291,
															0.73
														],
														[
															1.021,
															0.589
														],
														[
															9.485,
															4.325
														],
														[
															54.989,
															-2.598
														],
														[
															-0.119,
															0.007
														]
													],
													"o": [
														[
															-5.606,
															-0.322
														],
														[
															-5.667,
															0.84
														],
														[
															-11.55,
															1.944
														],
														[
															-10.085,
															2.836
														],
														[
															-4.706,
															1.917
														],
														[
															-5.197,
															2.453
														],
														[
															-1.609,
															1.043
														],
														[
															-1.69,
															0.76
														],
														[
															-2.038,
															1.146
														],
														[
															-2,
															1.398
														],
														[
															-13.906,
															8.93
														],
														[
															-12.234,
															10.532
														],
														[
															-1.495,
															1.758
														],
														[
															-1.272,
															1.855
														],
														[
															-1.117,
															1.436
														],
														[
															-1.27,
															1.682
														],
														[
															-0.401,
															0.419
														],
														[
															-0.298,
															0.539
														],
														[
															-0.382,
															0.399
														],
														[
															-0.067,
															0.27
														],
														[
															-0.559,
															0.839
														],
														[
															-1.027,
															0.916
														],
														[
															-0.402,
															0.603
														],
														[
															-0.051,
															0.701
														],
														[
															-0.558,
															0.839
														],
														[
															-0.726,
															0.835
														],
														[
															-3.379,
															5.159
														],
														[
															-2.748,
															5.344
														],
														[
															-1.04,
															2.161
														],
														[
															-1.243,
															2.129
														],
														[
															-7.649,
															18.037
														],
														[
															-4.721,
															21.855
														],
														[
															-0.507,
															25.64
														],
														[
															4.332,
															21.795
														],
														[
															7.561,
															19.148
														],
														[
															9.881,
															16.03
														],
														[
															18.12,
															20.884
														],
														[
															23.361,
															15.867
														],
														[
															2.93,
															0.994
														],
														[
															3.171,
															1.119
														],
														[
															3.7,
															0.822
														],
														[
															3.199,
															0.628
														],
														[
															1.332,
															0.253
														],
														[
															1.346,
															0.377
														],
														[
															3.464,
															0.64
														],
														[
															4.448,
															0.493
														],
														[
															0.697,
															0.553
														],
														[
															0.365,
															0.907
														],
														[
															1.464,
															1.421
														],
														[
															0.81,
															1.055
														],
														[
															0.62,
															0.171
														],
														[
															0.688,
															-0.082
														],
														[
															2.606,
															0.646
														],
														[
															3.254,
															0.113
														],
														[
															7.185,
															-0.207
														],
														[
															6.281,
															-0.732
														],
														[
															25.05,
															-3.81
														],
														[
															20.135,
															-7.88
														],
														[
															2.465,
															-1.603
														],
														[
															2.319,
															-1.595
														],
														[
															0.154,
															-0.07
														],
														[
															0.168,
															-0.451
														],
														[
															2.784,
															-2.001
														],
														[
															2.477,
															-1.791
														],
														[
															0.997,
															-0.793
														],
														[
															1.003,
															-0.839
														],
														[
															18.813,
															-16.193
														],
														[
															14.683,
															-20.415
														],
														[
															8.685,
															-20.059
														],
														[
															4.829,
															-22.956
														],
														[
															0,
															-20.429
														],
														[
															-3.013,
															-18.045
														],
														[
															-1.875,
															-5.831
														],
														[
															-2.285,
															-5.884
														],
														[
															-0.974,
															-2.271
														],
														[
															-0.793,
															-1.74
														],
														[
															-6.275,
															-12.963
														],
														[
															-7.589,
															-11.73
														],
														[
															-0.35,
															-0.422
														],
														[
															-0.572,
															-0.289
														],
														[
															-0.466,
															-0.543
														],
														[
															-0.262,
															-0.731
														],
														[
															-1.246,
															-1.368
														],
														[
															-1.46,
															-1.141
														],
														[
															-1.027,
															-1.198
														],
														[
															-3.134,
															-3.369
														],
														[
															-6.099,
															-5.666
														],
														[
															-1.114,
															-0.955
														],
														[
															-1.858,
															-1.453
														],
														[
															-2.172,
															-1.65
														],
														[
															-0.838,
															-0.803
														],
														[
															-2.522,
															-2.416
														],
														[
															-1.987,
															-1.264
														],
														[
															-0.344,
															-0.155
														],
														[
															-1.301,
															-0.775
														],
														[
															-0.956,
															-0.54
														],
														[
															-8.894,
															-5.134
														],
														[
															-38.783,
															-17.684
														],
														[
															-0.63,
															0.03
														],
														[
															-0.65,
															0.038
														]
													],
													"v": [
														[
															345,
															26
														],
														[
															328.09,
															27.036
														],
														[
															311,
															30
														],
														[
															278.669,
															37.175
														],
														[
															250,
															47
														],
														[
															234.601,
															53.733
														],
														[
															221,
															61
														],
														[
															216.017,
															63.594
														],
														[
															211,
															66
														],
														[
															204.944,
															69.914
														],
														[
															199,
															74
														],
														[
															159.687,
															103.24
														],
														[
															126,
															137
														],
														[
															121.942,
															142.452
														],
														[
															118,
															148
														],
														[
															114.263,
															152.95
														],
														[
															111,
															157
														],
														[
															110.005,
															158.495
														],
														[
															109,
															160
														],
														[
															108.474,
															160.908
														],
														[
															108,
															162
														],
														[
															105.329,
															164.756
														],
														[
															103,
															167
														],
														[
															102.494,
															169.008
														],
														[
															102,
															171
														],
														[
															99.985,
															173.513
														],
														[
															98,
															176
														],
														[
															88.939,
															191.77
														],
														[
															81,
															208
														],
														[
															77.459,
															214.377
														],
														[
															74,
															221
														],
														[
															55.112,
															281.371
														],
														[
															47,
															350
														],
														[
															53.236,
															421.095
														],
														[
															71,
															481
														],
														[
															97.234,
															533.562
														],
														[
															130,
															578
														],
														[
															192.264,
															633.427
														],
														[
															270,
															672
														],
														[
															279.41,
															675.348
														],
														[
															288,
															678
														],
														[
															298.145,
															680.117
														],
														[
															308,
															682
														],
														[
															312.035,
															683.011
														],
														[
															316,
															684
														],
														[
															328.79,
															685.441
														],
														[
															339,
															688
														],
														[
															340.391,
															690.302
														],
														[
															342,
															693
														],
														[
															345.126,
															696.798
														],
														[
															348,
															699
														],
														[
															349.996,
															699.012
														],
														[
															352,
															699
														],
														[
															360.919,
															700.057
														],
														[
															371,
															700
														],
														[
															391.119,
															698.495
														],
														[
															409,
															696
														],
														[
															476.481,
															678.145
														],
														[
															531,
															650
														],
														[
															538.156,
															645.061
														],
														[
															545,
															641
														],
														[
															545.486,
															640.041
														],
														[
															546,
															639
														],
														[
															553.858,
															633.376
														],
														[
															561,
															628
														],
														[
															564.006,
															625.543
														],
														[
															567,
															623
														],
														[
															617.27,
															567.965
														],
														[
															655,
															501
														],
														[
															675.513,
															437.045
														],
														[
															683,
															361
														],
														[
															678.211,
															303.22
														],
														[
															666,
															253
														],
														[
															659.583,
															235.103
														],
														[
															653,
															219
														],
														[
															650.412,
															213.123
														],
														[
															648,
															208
														],
														[
															627.071,
															170.864
														],
														[
															603,
															138
														],
														[
															601.509,
															137
														],
														[
															600,
															136
														],
														[
															599.015,
															133.993
														],
														[
															598,
															132
														],
														[
															593.753,
															128.275
														],
														[
															590,
															125
														],
														[
															588,
															121
														],
														[
															577,
															111
														],
														[
															558,
															94
														],
														[
															554,
															92
														],
														[
															549,
															87
														],
														[
															541,
															82
														],
														[
															538,
															80
														],
														[
															530,
															74
														],
														[
															525,
															72
														],
														[
															524,
															70
														],
														[
															520,
															69
														],
														[
															517,
															66
														],
														[
															489,
															52
														],
														[
															348,
															25
														],
														[
															347,
															26
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 48,
											"s": [
												{
													"i": [
														[
															0.65,
															0.037
														],
														[
															5.865,
															-0.824
														],
														[
															5.815,
															-1.032
														],
														[
															14.778,
															-4.978
														],
														[
															12.144,
															-6.114
														],
														[
															8.007,
															-5.054
														],
														[
															6.928,
															-5.23
														],
														[
															1.676,
															-1.273
														],
														[
															0.855,
															-0.819
														],
														[
															0.323,
															-0.094
														],
														[
															0.382,
															-0.312
														],
														[
															1.629,
															-1.766
														],
														[
															1.721,
															-1.495
														],
														[
															1.864,
															-1.432
														],
														[
															1.753,
															-1.716
														],
														[
															3.878,
															-4.456
														],
														[
															3.344,
															-4.119
														],
														[
															0.907,
															-0.823
														],
														[
															0.673,
															-0.846
														],
														[
															5.172,
															-7.857
														],
														[
															4.428,
															-8.178
														],
														[
															7.45,
															-26.311
														],
														[
															0,
															-30.076
														],
														[
															-9.032,
															-30.236
														],
														[
															-14.87,
															-23.785
														],
														[
															-12.455,
															-13.956
														],
														[
															-14.125,
															-11.091
														],
														[
															-2.748,
															-1.89
														],
														[
															-1.699,
															-1.628
														],
														[
															-0.539,
															-0.298
														],
														[
															-0.425,
															-0.408
														],
														[
															-0.539,
															-0.298
														],
														[
															-0.425,
															-0.408
														],
														[
															-0.539,
															-0.298
														],
														[
															-0.425,
															-0.408
														],
														[
															-0.539,
															-0.298
														],
														[
															-0.425,
															-0.408
														],
														[
															-0.539,
															-0.298
														],
														[
															-0.425,
															-0.408
														],
														[
															-1.957,
															-1.154
														],
														[
															-1.601,
															-0.88
														],
														[
															-1.165,
															-0.43
														],
														[
															-1.218,
															-0.665
														],
														[
															-0.771,
															-0.736
														],
														[
															-0.962,
															-0.537
														],
														[
															-1.215,
															-0.471
														],
														[
															-1.126,
															-0.55
														],
														[
															-6.987,
															-2.81
														],
														[
															-7.197,
															-2.416
														],
														[
															-3.888,
															-1.275
														],
														[
															-2.812,
															-0.68
														],
														[
															-1.455,
															-0.065
														],
														[
															-1.626,
															-0.362
														],
														[
															-2.676,
															-0.737
														],
														[
															-2.818,
															-0.499
														],
														[
															-4.404,
															-0.51
														],
														[
															-1.749,
															-1.315
														],
														[
															-1.541,
															-2.371
														],
														[
															-1.303,
															-0.361
														],
														[
															-0.689,
															0.083
														],
														[
															-0.624,
															-0.161
														],
														[
															-3.455,
															-0.109
														],
														[
															-3.54,
															0.119
														],
														[
															-9.201,
															1.191
														],
														[
															-8.624,
															1.882
														],
														[
															-10.767,
															3.307
														],
														[
															-9.394,
															4.035
														],
														[
															-9.022,
															5.264
														],
														[
															-8.088,
															5.725
														],
														[
															-13.342,
															13.13
														],
														[
															-10.699,
															15.204
														],
														[
															-0.929,
															1.59
														],
														[
															-0.485,
															0.506
														],
														[
															-0.298,
															0.539
														],
														[
															-0.408,
															0.425
														],
														[
															-1.003,
															1.37
														],
														[
															-0.805,
															1.288
														],
														[
															-0.679,
															1.556
														],
														[
															-0.502,
															0.524
														],
														[
															-0.059,
															0.242
														],
														[
															-0.349,
															0.601
														],
														[
															-1.7,
															2.773
														],
														[
															-1.47,
															2.923
														],
														[
															-0.457,
															1.386
														],
														[
															-0.555,
															1.229
														],
														[
															-4.821,
															14.93
														],
														[
															-2.738,
															16.051
														],
														[
															-0.907,
															10.004
														],
														[
															0.137,
															10.134
														],
														[
															10.759,
															32.422
														],
														[
															16.423,
															24.186
														],
														[
															14.405,
															14.375
														],
														[
															16.291,
															11.17
														],
														[
															15.993,
															7.421
														],
														[
															1.535,
															0.678
														],
														[
															2.768,
															1.055
														],
														[
															2.187,
															0.858
														],
														[
															1.534,
															0.543
														],
														[
															46.206,
															-2.183
														],
														[
															-0.119,
															0.007
														]
													],
													"o": [
														[
															-5.724,
															-0.328
														],
														[
															-5.865,
															0.824
														],
														[
															-16.746,
															2.972
														],
														[
															-14.777,
															4.978
														],
														[
															-9.043,
															4.553
														],
														[
															-8.007,
															5.054
														],
														[
															-1.442,
															1.088
														],
														[
															-1.676,
															1.273
														],
														[
															-0.326,
															0.312
														],
														[
															-0.323,
															0.094
														],
														[
															-1.762,
															1.441
														],
														[
															-1.629,
															1.766
														],
														[
															-1.791,
															1.556
														],
														[
															-1.864,
															1.432
														],
														[
															-4.145,
															4.058
														],
														[
															-3.878,
															4.456
														],
														[
															-0.698,
															0.861
														],
														[
															-0.907,
															0.823
														],
														[
															-5.883,
															7.392
														],
														[
															-5.172,
															7.857
														],
														[
															-11.198,
															20.681
														],
														[
															-7.45,
															26.311
														],
														[
															0,
															39.272
														],
														[
															9.032,
															30.236
														],
														[
															10.055,
															16.083
														],
														[
															12.455,
															13.956
														],
														[
															2.308,
															1.812
														],
														[
															2.748,
															1.89
														],
														[
															0.419,
															0.401
														],
														[
															0.539,
															0.298
														],
														[
															0.419,
															0.401
														],
														[
															0.539,
															0.298
														],
														[
															0.419,
															0.401
														],
														[
															0.539,
															0.298
														],
														[
															0.419,
															0.401
														],
														[
															0.539,
															0.298
														],
														[
															0.419,
															0.401
														],
														[
															0.539,
															0.298
														],
														[
															1.57,
															1.504
														],
														[
															1.957,
															1.154
														],
														[
															1.121,
															0.616
														],
														[
															1.165,
															0.43
														],
														[
															0.954,
															0.521
														],
														[
															0.771,
															0.736
														],
														[
															1.012,
															0.565
														],
														[
															1.215,
															0.471
														],
														[
															6.853,
															3.343
														],
														[
															6.987,
															2.81
														],
														[
															3.636,
															1.221
														],
														[
															3.888,
															1.275
														],
														[
															1.554,
															0.376
														],
														[
															1.455,
															0.066
														],
														[
															2.478,
															0.552
														],
														[
															2.676,
															0.737
														],
														[
															3.635,
															0.644
														],
														[
															4.404,
															0.51
														],
														[
															1.533,
															1.154
														],
														[
															1.541,
															2.371
														],
														[
															0.62,
															0.171
														],
														[
															0.689,
															-0.083
														],
														[
															2.638,
															0.681
														],
														[
															3.455,
															0.109
														],
														[
															10.571,
															-0.354
														],
														[
															9.202,
															-1.191
														],
														[
															12.537,
															-2.736
														],
														[
															10.767,
															-3.307
														],
														[
															9.826,
															-4.221
														],
														[
															9.022,
															-5.264
														],
														[
															15.933,
															-11.277
														],
														[
															13.342,
															-13.13
														],
														[
															0.797,
															-1.132
														],
														[
															0.93,
															-1.59
														],
														[
															0.401,
															-0.419
														],
														[
															0.298,
															-0.539
														],
														[
															1.183,
															-1.234
														],
														[
															1.003,
															-1.37
														],
														[
															0.782,
															-1.251
														],
														[
															0.679,
															-1.556
														],
														[
															0.414,
															-0.432
														],
														[
															0.059,
															-0.242
														],
														[
															1.729,
															-2.985
														],
														[
															1.7,
															-2.773
														],
														[
															0.616,
															-1.226
														],
														[
															0.457,
															-1.386
														],
														[
															5.979,
															-13.231
														],
														[
															4.821,
															-14.93
														],
														[
															1.51,
															-8.851
														],
														[
															0.907,
															-10.004
														],
														[
															-0.542,
															-40.124
														],
														[
															-10.759,
															-32.422
														],
														[
															-11.09,
															-16.332
														],
														[
															-14.405,
															-14.375
														],
														[
															-15.18,
															-10.408
														],
														[
															-1.358,
															-0.63
														],
														[
															-3.241,
															-1.432
														],
														[
															-3.35,
															-1.277
														],
														[
															-1.564,
															-0.614
														],
														[
															-33.397,
															-11.817
														],
														[
															-0.63,
															0.03
														],
														[
															-0.65,
															0.038
														]
													],
													"v": [
														[
															344,
															26
														],
														[
															326.569,
															26.98
														],
														[
															309,
															30
														],
														[
															261.548,
															42.143
														],
														[
															221,
															59
														],
														[
															195.414,
															73.493
														],
														[
															173,
															89
														],
														[
															168.06,
															92.702
														],
														[
															164,
															96
														],
														[
															163.042,
															96.5
														],
														[
															162,
															97
														],
														[
															156.97,
															101.959
														],
														[
															152,
															107
														],
														[
															146.471,
															111.38
														],
														[
															141,
															116
														],
														[
															128.899,
															128.954
														],
														[
															118,
															142
														],
														[
															115.481,
															144.511
														],
														[
															113,
															147
														],
														[
															96.409,
															169.911
														],
														[
															82,
															194
														],
														[
															53.101,
															264.954
														],
														[
															41,
															350
														],
														[
															55.347,
															453.615
														],
														[
															92,
															534
														],
														[
															125.948,
															579.244
														],
														[
															166,
															617
														],
														[
															173.957,
															622.639
														],
														[
															181,
															628
														],
														[
															182.495,
															628.995
														],
														[
															184,
															630
														],
														[
															185.495,
															630.995
														],
														[
															187,
															632
														],
														[
															188.495,
															632.995
														],
														[
															190,
															634
														],
														[
															191.495,
															634.995
														],
														[
															193,
															636
														],
														[
															194.495,
															636.995
														],
														[
															196,
															638
														],
														[
															201.476,
															641.968
														],
														[
															207,
															645
														],
														[
															210.428,
															646.463
														],
														[
															214,
															648
														],
														[
															216.494,
															649.988
														],
														[
															219,
															652
														],
														[
															222.415,
															653.512
														],
														[
															226,
															655
														],
														[
															246.742,
															664.196
														],
														[
															268,
															672
														],
														[
															279.618,
															675.905
														],
														[
															290,
															679
														],
														[
															294.446,
															679.51
														],
														[
															299,
															680
														],
														[
															306.745,
															682.04
														],
														[
															315,
															684
														],
														[
															327.915,
															685.496
														],
														[
															338,
															688
														],
														[
															342.673,
															694.095
														],
														[
															347,
															699
														],
														[
															348.997,
															699.008
														],
														[
															351,
															699
														],
														[
															360.324,
															700.1
														],
														[
															371,
															700
														],
														[
															400.46,
															697.646
														],
														[
															427,
															693
														],
														[
															461.858,
															683.974
														],
														[
															492,
															673
														],
														[
															520.303,
															658.628
														],
														[
															546,
															642
														],
														[
															589.925,
															605.445
														],
														[
															626,
															563
														],
														[
															628.734,
															558.531
														],
														[
															631,
															555
														],
														[
															631.995,
															553.505
														],
														[
															633,
															552
														],
														[
															636.283,
															548.041
														],
														[
															639,
															544
														],
														[
															641.21,
															539.455
														],
														[
															643,
															536
														],
														[
															643.549,
															535.127
														],
														[
															644,
															534
														],
														[
															649.195,
															525.454
														],
														[
															654,
															517
														],
														[
															655.545,
															513.003
														],
														[
															657,
															509
														],
														[
															673.431,
															466.615
														],
														[
															685,
															420
														],
														[
															688.735,
															391.463
														],
														[
															690,
															361
														],
														[
															671.911,
															252.047
														],
														[
															630,
															167
														],
														[
															591.401,
															120.629
														],
														[
															545,
															82
														],
														[
															495,
															53
														],
														[
															490,
															52
														],
														[
															480,
															47
														],
														[
															472,
															44
														],
														[
															468,
															43
														],
														[
															347,
															25
														],
														[
															346,
															26
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 49,
											"s": [
												{
													"i": [
														[
															0.65,
															0.037
														],
														[
															5.822,
															-0.847
														],
														[
															5.863,
															-0.95
														],
														[
															23.145,
															-10.244
														],
														[
															18,
															-13.422
														],
														[
															7.036,
															-6.127
														],
														[
															6.312,
															-6.868
														],
														[
															3.925,
															-4.353
														],
														[
															3.185,
															-4.113
														],
														[
															1.898,
															-2.999
														],
														[
															1.608,
															-1.678
														],
														[
															0.789,
															-1.17
														],
														[
															0.751,
															-1.179
														],
														[
															4.524,
															-8.72
														],
														[
															3.706,
															-8.962
														],
														[
															1.008,
															-2.253
														],
														[
															0.869,
															-2.332
														],
														[
															1.756,
															-6.447
														],
														[
															1.673,
															-7.032
														],
														[
															0.734,
															-2.495
														],
														[
															0.457,
															-2.471
														],
														[
															-7.317,
															-38.01
														],
														[
															-14.598,
															-26.425
														],
														[
															-0.719,
															-1.004
														],
														[
															-0.608,
															-1.049
														],
														[
															-0.695,
															-1.556
														],
														[
															-0.489,
															-0.51
														],
														[
															-0.298,
															-0.539
														],
														[
															-0.407,
															-0.425
														],
														[
															-0.776,
															-1.165
														],
														[
															-0.79,
															-1.183
														],
														[
															-2.914,
															-3.902
														],
														[
															-2.633,
															-3.33
														],
														[
															-0.621,
															-1.033
														],
														[
															-0.769,
															-0.923
														],
														[
															-1.741,
															-1.62
														],
														[
															-1.541,
															-1.726
														],
														[
															-0.073,
															-0.526
														],
														[
															-0.338,
															-0.483
														],
														[
															-0.591,
															-0.3
														],
														[
															-0.348,
															-0.387
														],
														[
															-5.316,
															-4.893
														],
														[
															-5.007,
															-4.173
														],
														[
															-1.391,
															-0.997
														],
														[
															-1.028,
															-0.838
														],
														[
															-1.641,
															-1.202
														],
														[
															-1.673,
															-0.755
														],
														[
															-0.163,
															-0.451
														],
														[
															-0.185,
															-0.123
														],
														[
															-0.379,
															0.067
														],
														[
															-0.255,
															-0.115
														],
														[
															-0.166,
															-0.451
														],
														[
															-0.178,
															-0.124
														],
														[
															-1.989,
															-1.344
														],
														[
															-1.948,
															-1.158
														],
														[
															-1.588,
															-0.71
														],
														[
															-0.495,
															-0.474
														],
														[
															-1.176,
															-0.699
														],
														[
															-23.295,
															-7.627
														],
														[
															-4.044,
															-1.114
														],
														[
															-5.815,
															-1.295
														],
														[
															-5.826,
															-1.018
														],
														[
															-3.85,
															-2.548
														],
														[
															-2.296,
															-1.982
														],
														[
															-3.717,
															-0.339
														],
														[
															-7.922,
															0.306
														],
														[
															-17.367,
															3.619
														],
														[
															-29.88,
															18.341
														],
														[
															-4.143,
															1.867
														],
														[
															-0.37,
															0.247
														],
														[
															-0.511,
															0.23
														],
														[
															-0.362,
															0.248
														],
														[
															-0.506,
															0.228
														],
														[
															-0.358,
															0.248
														],
														[
															-5.221,
															4.292
														],
														[
															-9.539,
															11.448
														],
														[
															-1.722,
															3.82
														],
														[
															-0.7,
															0.881
														],
														[
															-12.532,
															27.916
														],
														[
															0.824,
															53.952
														],
														[
															13.481,
															35
														],
														[
															7.341,
															13.015
														],
														[
															1.994,
															4.424
														],
														[
															0.245,
															0.381
														],
														[
															0.854,
															1.307
														],
														[
															2.626,
															3.578
														],
														[
															1.644,
															2.166
														],
														[
															0.673,
															0.843
														],
														[
															0.977,
															1.22
														],
														[
															23.41,
															16.406
														],
														[
															1.011,
															0.968
														],
														[
															0.85,
															0.815
														],
														[
															1.068,
															0.698
														],
														[
															2.073,
															1.278
														],
														[
															0.524,
															0.236
														],
														[
															0.411,
															0.238
														],
														[
															1.193,
															0.685
														],
														[
															7.073,
															3.44
														],
														[
															63.516,
															-3.001
														],
														[
															-0.119,
															0.007
														]
													],
													"o": [
														[
															-5.85,
															-0.335
														],
														[
															-5.822,
															0.846
														],
														[
															-28.418,
															4.602
														],
														[
															-23.145,
															10.244
														],
														[
															-7.541,
															5.623
														],
														[
															-7.037,
															6.127
														],
														[
															-4.113,
															4.475
														],
														[
															-3.925,
															4.353
														],
														[
															-1.799,
															2.325
														],
														[
															-1.898,
															2.999
														],
														[
															-1.094,
															1.142
														],
														[
															-0.789,
															1.17
														],
														[
															-5.198,
															8.157
														],
														[
															-4.524,
															8.72
														],
														[
															-1.098,
															2.656
														],
														[
															-1.008,
															2.253
														],
														[
															-2.303,
															6.18
														],
														[
															-1.756,
															6.447
														],
														[
															-0.606,
															2.548
														],
														[
															-0.734,
															2.495
														],
														[
															-7.867,
															42.534
														],
														[
															7.317,
															38.01
														],
														[
															0.517,
															0.937
														],
														[
															0.719,
															1.004
														],
														[
															0.733,
															1.265
														],
														[
															0.694,
															1.556
														],
														[
															0.401,
															0.419
														],
														[
															0.298,
															0.539
														],
														[
															1.108,
															1.156
														],
														[
															0.776,
															1.165
														],
														[
															2.71,
															4.061
														],
														[
															2.914,
															3.902
														],
														[
															0.746,
															0.943
														],
														[
															0.621,
															1.033
														],
														[
															1.495,
															1.794
														],
														[
															1.741,
															1.62
														],
														[
															0.368,
															0.413
														],
														[
															0.074,
															0.526
														],
														[
															0.288,
															0.413
														],
														[
															0.591,
															0.3
														],
														[
															4.729,
															5.255
														],
														[
															5.316,
															4.893
														],
														[
															1.407,
															1.173
														],
														[
															1.391,
															0.997
														],
														[
															1.764,
															1.439
														],
														[
															1.641,
															1.202
														],
														[
															0.162,
															0.073
														],
														[
															0.163,
															0.451
														],
														[
															0.23,
															0.154
														],
														[
															0.379,
															-0.067
														],
														[
															0.157,
															0.071
														],
														[
															0.166,
															0.451
														],
														[
															2.096,
															1.466
														],
														[
															1.989,
															1.344
														],
														[
															1.154,
															0.686
														],
														[
															1.588,
															0.71
														],
														[
															0.854,
															0.818
														],
														[
															19.832,
															11.784
														],
														[
															5.204,
															1.704
														],
														[
															5.489,
															1.511
														],
														[
															5.164,
															1.15
														],
														[
															7.312,
															1.277
														],
														[
															2.991,
															1.98
														],
														[
															1.76,
															1.519
														],
														[
															7.08,
															0.647
														],
														[
															21.186,
															-0.818
														],
														[
															42.932,
															-8.947
														],
														[
															5.038,
															-3.092
														],
														[
															0.324,
															-0.146
														],
														[
															0.46,
															-0.307
														],
														[
															0.319,
															-0.144
														],
														[
															0.452,
															-0.309
														],
														[
															0.317,
															-0.143
														],
														[
															6.003,
															-4.16
														],
														[
															12.398,
															-10.194
														],
														[
															3.179,
															-3.815
														],
														[
															0.504,
															-1.119
														],
														[
															17.942,
															-22.569
														],
														[
															17.31,
															-38.56
														],
														[
															-0.745,
															-48.811
														],
														[
															-5.816,
															-15.098
														],
														[
															-2.741,
															-4.859
														],
														[
															-0.149,
															-0.331
														],
														[
															-0.718,
															-1.115
														],
														[
															-3.036,
															-4.645
														],
														[
															-1.731,
															-2.358
														],
														[
															-0.638,
															-0.841
														],
														[
															-1.048,
															-1.313
														],
														[
															-18.377,
															-22.951
														],
														[
															-2.265,
															-1.587
														],
														[
															-0.838,
															-0.803
														],
														[
															-0.809,
															-0.775
														],
														[
															-2.116,
															-1.383
														],
														[
															-0.485,
															-0.299
														],
														[
															-0.348,
															-0.157
														],
														[
															-1.379,
															-0.797
														],
														[
															-7.034,
															-4.037
														],
														[
															-42.345,
															-20.594
														],
														[
															-0.63,
															0.03
														],
														[
															-0.65,
															0.038
														]
													],
													"v": [
														[
															344,
															26
														],
														[
															326.51,
															27.036
														],
														[
															309,
															30
														],
														[
															231.686,
															52.885
														],
														[
															170,
															89
														],
														[
															148.078,
															106.567
														],
														[
															128,
															126
														],
														[
															115.804,
															139.271
														],
														[
															105,
															152
														],
														[
															99.356,
															160.485
														],
														[
															94,
															168
														],
														[
															91.242,
															171.473
														],
														[
															89,
															175
														],
														[
															74.381,
															200.397
														],
														[
															62,
															227
														],
														[
															58.828,
															234.243
														],
														[
															56,
															241
														],
														[
															50.028,
															259.861
														],
														[
															45,
															280
														],
														[
															42.888,
															287.558
														],
														[
															41,
															295
														],
														[
															42.152,
															417.581
														],
														[
															77,
															516
														],
														[
															78.933,
															518.916
														],
														[
															81,
															522
														],
														[
															83.182,
															526.566
														],
														[
															85,
															530
														],
														[
															85.995,
															531.495
														],
														[
															87,
															533
														],
														[
															89.739,
															536.48
														],
														[
															92,
															540
														],
														[
															100.558,
															552.048
														],
														[
															109,
															563
														],
														[
															110.982,
															566.015
														],
														[
															113,
															569
														],
														[
															117.966,
															574.051
														],
														[
															123,
															579
														],
														[
															123.523,
															580.448
														],
														[
															124,
															582
														],
														[
															125.455,
															583.02
														],
														[
															127,
															584
														],
														[
															142.291,
															599.312
														],
														[
															158,
															613
														],
														[
															162.285,
															616.251
														],
														[
															166,
															619
														],
														[
															171.068,
															623.013
														],
														[
															176,
															626
														],
														[
															176.483,
															626.962
														],
														[
															177,
															628
														],
														[
															177.981,
															628.029
														],
														[
															179,
															628
														],
														[
															179.485,
															628.96
														],
														[
															180,
															630
														],
														[
															186.111,
															634.231
														],
														[
															192,
															638
														],
														[
															196.495,
															640.159
														],
														[
															200,
															642
														],
														[
															202,
															643
														],
														[
															267,
															672
														],
														[
															281,
															677
														],
														[
															298,
															680
														],
														[
															314,
															684
														],
														[
															337,
															688
														],
														[
															344,
															697
														],
														[
															350,
															699
														],
														[
															372,
															700
														],
														[
															429,
															693
														],
														[
															535,
															651
														],
														[
															550,
															642
														],
														[
															551,
															640
														],
														[
															553,
															640
														],
														[
															554,
															638
														],
														[
															556,
															638
														],
														[
															557,
															636
														],
														[
															573,
															624
														],
														[
															608,
															590
														],
														[
															616,
															580
														],
														[
															620,
															576
														],
														[
															665,
															502
														],
														[
															695,
															361
														],
														[
															671,
															236
														],
														[
															650,
															193
														],
														[
															642,
															178
														],
														[
															640,
															177
														],
														[
															638,
															173
														],
														[
															629,
															161
														],
														[
															625,
															154
														],
														[
															622,
															152
														],
														[
															620,
															148
														],
														[
															554,
															86
														],
														[
															546,
															81
														],
														[
															543,
															79
														],
														[
															541,
															78
														],
														[
															535,
															73
														],
														[
															533,
															73
														],
														[
															532,
															71
														],
														[
															528,
															69
														],
														[
															507,
															58
														],
														[
															347,
															25
														],
														[
															346,
															26
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 50,
											"s": [
												{
													"i": [
														[
															0.65,
															0.037
														],
														[
															5.87,
															-0.851
														],
														[
															5.676,
															-0.932
														],
														[
															18.168,
															-6.715
														],
														[
															14.808,
															-8.605
														],
														[
															0.806,
															-0.267
														],
														[
															0.762,
															-0.344
														],
														[
															0.157,
															-0.451
														],
														[
															0.201,
															-0.12
														],
														[
															1.54,
															-0.673
														],
														[
															0.572,
															-0.547
														],
														[
															0.539,
															-0.298
														],
														[
															0.425,
															-0.407
														],
														[
															0.539,
															-0.298
														],
														[
															0.425,
															-0.407
														],
														[
															0.539,
															-0.298
														],
														[
															0.425,
															-0.407
														],
														[
															0.282,
															-0.073
														],
														[
															0.488,
															-0.343
														],
														[
															0.773,
															-0.913
														],
														[
															0.931,
															-0.661
														],
														[
															0.383,
															0.067
														],
														[
															0.249,
															-0.112
														],
														[
															0.163,
															-0.451
														],
														[
															0.185,
															-0.124
														],
														[
															0.379,
															0.067
														],
														[
															0.255,
															-0.115
														],
														[
															0.17,
															-0.452
														],
														[
															0.169,
															-0.124
														],
														[
															9.496,
															-9.02
														],
														[
															7.787,
															-9.409
														],
														[
															13.316,
															-34.019
														],
														[
															1.2,
															-43.112
														],
														[
															-4.784,
															-22.269
														],
														[
															-7.587,
															-18.005
														],
														[
															-10.405,
															-16.113
														],
														[
															-12.391,
															-13.589
														],
														[
															-15.134,
															-11.563
														],
														[
															-16.873,
															-8.937
														],
														[
															-18.629,
															-6.029
														],
														[
															-21.572,
															-2.928
														],
														[
															-1.613,
															-0.113
														],
														[
															-1.094,
															-0.35
														],
														[
															-1.25,
															-1.195
														],
														[
															-1.557,
															-1.437
														],
														[
															-0.317,
															-0.897
														],
														[
															-0.728,
															-0.485
														],
														[
															-1.02,
															0.019
														],
														[
															-1.956,
															-0.433
														],
														[
															-3.388,
															-0.116
														],
														[
															-3.519,
															0.111
														],
														[
															-9.596,
															1.21
														],
														[
															-8.831,
															1.819
														],
														[
															-5.886,
															1.264
														],
														[
															-5.361,
															1.687
														],
														[
															-5.178,
															2.065
														],
														[
															-4.717,
															1.987
														],
														[
															-8.3,
															4.465
														],
														[
															-7.107,
															4.475
														],
														[
															-1.617,
															0.972
														],
														[
															-0.45,
															0.432
														],
														[
															-0.27,
															0.067
														],
														[
															-0.522,
															0.348
														],
														[
															-0.861,
															0.97
														],
														[
															-0.625,
															0.498
														],
														[
															-0.686,
															0.256
														],
														[
															-0.611,
															0.461
														],
														[
															-18.178,
															22.687
														],
														[
															-11.639,
															27.159
														],
														[
															-0.096,
															0.638
														],
														[
															-0.343,
															0.814
														],
														[
															-0.748,
															1.132
														],
														[
															-0.487,
															1.241
														],
														[
															-0.134,
															0.696
														],
														[
															-0.18,
															0.495
														],
														[
															-2.361,
															7.568
														],
														[
															-1.768,
															8.047
														],
														[
															-1.618,
															12.743
														],
														[
															0.062,
															13.241
														],
														[
															6.885,
															25.858
														],
														[
															10.317,
															20.368
														],
														[
															2.646,
															4.643
														],
														[
															1.224,
															2.022
														],
														[
															1.155,
															2.562
														],
														[
															0.245,
															0.381
														],
														[
															0.743,
															1.136
														],
														[
															0.728,
															1.068
														],
														[
															2.195,
															3.028
														],
														[
															0.223,
															0.494
														],
														[
															0.248,
															0.358
														],
														[
															1.021,
															1.329
														],
														[
															0.676,
															0.847
														],
														[
															0.977,
															1.22
														],
														[
															9.529,
															9.529
														],
														[
															4.503,
															2.03
														],
														[
															0.29,
															0.245
														],
														[
															4.529,
															3.475
														],
														[
															6.597,
															4.381
														],
														[
															85.106,
															-4.021
														],
														[
															-0.119,
															0.007
														]
													],
													"o": [
														[
															-5.842,
															-0.335
														],
														[
															-5.87,
															0.851
														],
														[
															-21.517,
															3.533
														],
														[
															-18.169,
															6.715
														],
														[
															-1.016,
															0.59
														],
														[
															-0.806,
															0.267
														],
														[
															-0.171,
															0.078
														],
														[
															-0.157,
															0.451
														],
														[
															-1.267,
															0.76
														],
														[
															-1.54,
															0.673
														],
														[
															-0.419,
															0.401
														],
														[
															-0.539,
															0.298
														],
														[
															-0.419,
															0.401
														],
														[
															-0.539,
															0.298
														],
														[
															-0.419,
															0.401
														],
														[
															-0.539,
															0.298
														],
														[
															-0.383,
															0.367
														],
														[
															-0.282,
															0.073
														],
														[
															-0.976,
															0.687
														],
														[
															-0.773,
															0.913
														],
														[
															-0.219,
															0.156
														],
														[
															-0.383,
															-0.067
														],
														[
															-0.162,
															0.073
														],
														[
															-0.163,
															0.451
														],
														[
															-0.23,
															0.154
														],
														[
															-0.379,
															-0.067
														],
														[
															-0.152,
															0.069
														],
														[
															-0.17,
															0.452
														],
														[
															-10.23,
															7.511
														],
														[
															-9.496,
															9.02
														],
														[
															-20.537,
															24.81
														],
														[
															-13.316,
															34.019
														],
														[
															-0.721,
															25.921
														],
														[
															4.784,
															22.269
														],
														[
															7.989,
															18.959
														],
														[
															10.405,
															16.113
														],
														[
															12.593,
															13.811
														],
														[
															15.134,
															11.563
														],
														[
															16.913,
															8.958
														],
														[
															18.629,
															6.029
														],
														[
															1.456,
															0.197
														],
														[
															1.613,
															0.113
														],
														[
															2.445,
															0.782
														],
														[
															1.249,
															1.195
														],
														[
															1.004,
															0.927
														],
														[
															0.317,
															0.897
														],
														[
															0.965,
															0.642
														],
														[
															1.02,
															-0.019
														],
														[
															2.929,
															0.648
														],
														[
															3.388,
															0.116
														],
														[
															10.784,
															-0.342
														],
														[
															9.596,
															-1.21
														],
														[
															6.096,
															-1.255
														],
														[
															5.886,
															-1.264
														],
														[
															5.57,
															-1.752
														],
														[
															5.178,
															-2.065
														],
														[
															8.693,
															-3.663
														],
														[
															8.3,
															-4.465
														],
														[
															1.083,
															-0.682
														],
														[
															1.617,
															-0.972
														],
														[
															0.399,
															-0.382
														],
														[
															0.27,
															-0.067
														],
														[
															0.932,
															-0.621
														],
														[
															0.861,
															-0.97
														],
														[
															0.647,
															-0.516
														],
														[
															0.686,
															-0.256
														],
														[
															22.648,
															-17.095
														],
														[
															18.178,
															-22.687
														],
														[
															0.271,
															-0.632
														],
														[
															0.096,
															-0.638
														],
														[
															0.521,
															-1.232
														],
														[
															0.748,
															-1.132
														],
														[
															0.283,
															-0.721
														],
														[
															0.134,
															-0.696
														],
														[
															2.788,
															-7.682
														],
														[
															2.361,
															-7.568
														],
														[
															2.591,
															-11.788
														],
														[
															1.618,
															-12.743
														],
														[
															-0.145,
															-31.202
														],
														[
															-6.885,
															-25.858
														],
														[
															-2.556,
															-5.045
														],
														[
															-1.279,
															-2.245
														],
														[
															-1.749,
															-2.891
														],
														[
															-0.149,
															-0.331
														],
														[
															-0.823,
															-1.278
														],
														[
															-0.725,
															-1.109
														],
														[
															-2.566,
															-3.761
														],
														[
															-0.313,
															-0.431
														],
														[
															-0.143,
															-0.317
														],
														[
															-0.898,
															-1.296
														],
														[
															-0.647,
															-0.842
														],
														[
															-1.048,
															-1.313
														],
														[
															-8.367,
															-10.449
														],
														[
															-3.988,
															-3.988
														],
														[
															-0.27,
															-0.122
														],
														[
															-5.051,
															-4.273
														],
														[
															-6.457,
															-4.954
														],
														[
															-50.53,
															-33.555
														],
														[
															-0.63,
															0.03
														],
														[
															-0.65,
															0.038
														]
													],
													"v": [
														[
															343,
															26
														],
														[
															325.375,
															27.049
														],
														[
															308,
															30
														],
														[
															248.468,
															45.696
														],
														[
															199,
															69
														],
														[
															196.31,
															70.185
														],
														[
															194,
															71
														],
														[
															193.522,
															71.968
														],
														[
															193,
															73
														],
														[
															188.478,
															75.159
														],
														[
															185,
															77
														],
														[
															183.505,
															77.995
														],
														[
															182,
															79
														],
														[
															180.505,
															79.995
														],
														[
															179,
															81
														],
														[
															177.505,
															81.995
														],
														[
															176,
															83
														],
														[
															175.078,
															83.518
														],
														[
															174,
															84
														],
														[
															171.467,
															86.519
														],
														[
															169,
															89
														],
														[
															168.022,
															89.032
														],
														[
															167,
															89
														],
														[
															166.517,
															89.962
														],
														[
															166,
															91
														],
														[
															165.019,
															91.029
														],
														[
															164,
															91
														],
														[
															163.513,
															91.958
														],
														[
															163,
															93
														],
														[
															133.168,
															118.077
														],
														[
															107,
															146
														],
														[
															54.997,
															234.274
														],
														[
															32,
															350
														],
														[
															38.769,
															422.437
														],
														[
															58,
															483
														],
														[
															85.699,
															535.528
														],
														[
															120,
															580
														],
														[
															161.79,
															618.156
														],
														[
															210,
															649
														],
														[
															263.006,
															671.523
														],
														[
															323,
															685
														],
														[
															327.771,
															685.386
														],
														[
															332,
															686
														],
														[
															337.166,
															689.009
														],
														[
															341,
															693
														],
														[
															342.707,
															695.831
														],
														[
															344,
															698
														],
														[
															346.757,
															698.657
														],
														[
															351,
															699
														],
														[
															360.557,
															700.07
														],
														[
															371,
															700
														],
														[
															401.465,
															697.608
														],
														[
															429,
															693
														],
														[
															447.051,
															689.323
														],
														[
															464,
															685
														],
														[
															480.139,
															679.177
														],
														[
															495,
															673
														],
														[
															520.69,
															660.609
														],
														[
															544,
															647
														],
														[
															548.475,
															644.312
														],
														[
															552,
															642
														],
														[
															552.908,
															641.474
														],
														[
															554,
															641
														],
														[
															556.73,
															638.408
														],
														[
															559,
															636
														],
														[
															561.027,
															634.958
														],
														[
															563,
															634
														],
														[
															624.756,
															574.048
														],
														[
															670,
															499
														],
														[
															670.446,
															497.136
														],
														[
															671,
															495
														],
														[
															673.025,
															491.507
														],
														[
															675,
															488
														],
														[
															675.577,
															485.831
														],
														[
															676,
															484
														],
														[
															683.765,
															461.274
														],
														[
															690,
															438
														],
														[
															696.489,
															401.09
														],
														[
															699,
															362
														],
														[
															687.629,
															276.374
														],
														[
															661,
															207
														],
														[
															653,
															193
														],
														[
															650,
															186
														],
														[
															645,
															178
														],
														[
															643,
															177
														],
														[
															641,
															173
														],
														[
															639,
															170
														],
														[
															632,
															161
														],
														[
															632,
															159
														],
														[
															630,
															158
														],
														[
															628,
															154
														],
														[
															625,
															152
														],
														[
															623,
															148
														],
														[
															596,
															120
														],
														[
															584,
															109
														],
														[
															583,
															107
														],
														[
															568,
															95
														],
														[
															549,
															81
														],
														[
															346,
															25
														],
														[
															345,
															26
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 51,
											"s": [
												{
													"i": [
														[
															0.65,
															0.037
														],
														[
															5.82,
															-0.844
														],
														[
															5.803,
															-0.963
														],
														[
															12.367,
															-3.53
														],
														[
															10.692,
															-4.582
														],
														[
															1.112,
															-0.477
														],
														[
															1.185,
															-0.508
														],
														[
															1.112,
															-0.477
														],
														[
															1.185,
															-0.508
														],
														[
															0.476,
															-0.377
														],
														[
															0.493,
															-0.233
														],
														[
															15.032,
															-10.894
														],
														[
															13.007,
															-13.007
														],
														[
															2.952,
															-3.555
														],
														[
															2.9,
															-3.485
														],
														[
															0.855,
															-0.762
														],
														[
															0.804,
															-1.017
														],
														[
															1.23,
															-1.893
														],
														[
															0.921,
															-0.962
														],
														[
															0.08,
															-0.299
														],
														[
															0.333,
															-0.444
														],
														[
															0.915,
															-0.786
														],
														[
															0.673,
															-0.972
														],
														[
															-0.067,
															-0.381
														],
														[
															0.114,
															-0.251
														],
														[
															0.451,
															-0.163
														],
														[
															0.124,
															-0.185
														],
														[
															-0.067,
															-0.379
														],
														[
															0.115,
															-0.255
														],
														[
															0.451,
															-0.163
														],
														[
															0.124,
															-0.185
														],
														[
															-0.067,
															-0.379
														],
														[
															0.115,
															-0.255
														],
														[
															0.451,
															-0.163
														],
														[
															0.124,
															-0.185
														],
														[
															-0.067,
															-0.379
														],
														[
															0.115,
															-0.255
														],
														[
															0.451,
															-0.16
														],
														[
															0.122,
															-0.194
														],
														[
															0.452,
															-1.263
														],
														[
															0.605,
															-1.019
														],
														[
															0.678,
															-0.952
														],
														[
															0.612,
															-1.052
														],
														[
															3.651,
															-7.446
														],
														[
															2.686,
															-6.846
														],
														[
															3.946,
															-19.183
														],
														[
															0,
															-20.431
														],
														[
															-1.645,
															-14.635
														],
														[
															-3.419,
															-13.159
														],
														[
															-2.424,
															-7.064
														],
														[
															-2.517,
															-5.874
														],
														[
															-0.608,
															-1.568
														],
														[
															-0.8,
															-1.935
														],
														[
															-1.692,
															-3.26
														],
														[
															-1.682,
															-3.208
														],
														[
															-36.643,
															-28.345
														],
														[
															-1.071,
															-1.026
														],
														[
															-1.044,
															-0.696
														],
														[
															-2.414,
															-1.698
														],
														[
															-0.5,
															-0.225
														],
														[
															-0.37,
															-0.247
														],
														[
															-0.511,
															-0.23
														],
														[
															-0.38,
															-0.245
														],
														[
															-1.052,
															-1.008
														],
														[
															-1.523,
															-0.894
														],
														[
															-25.188,
															-7.997
														],
														[
															-2.98,
															-0.864
														],
														[
															-2.408,
															-0.663
														],
														[
															-5.677,
															-1.214
														],
														[
															-5.411,
															-0.968
														],
														[
															-4.965,
															-1.185
														],
														[
															-5.713,
															-1.58
														],
														[
															-1.253,
															-0.302
														],
														[
															-6.855,
															0.185
														],
														[
															-26.305,
															8.139
														],
														[
															-9.319,
															3.657
														],
														[
															-3.715,
															1.728
														],
														[
															-10.44,
															6.465
														],
														[
															-0.89,
															0.853
														],
														[
															-1.044,
															0.696
														],
														[
															-1.25,
															0.997
														],
														[
															-1.031,
															0.753
														],
														[
															-4.083,
															1.84
														],
														[
															-0.29,
															0.245
														],
														[
															-1.633,
															0.736
														],
														[
															-0.29,
															0.245
														],
														[
															-4.597,
															4.416
														],
														[
															-3.378,
															3.602
														],
														[
															-1.964,
															4.358
														],
														[
															-0.679,
															0.818
														],
														[
															-3.681,
															8.165
														],
														[
															-0.245,
															0.381
														],
														[
															-0.726,
															1.117
														],
														[
															0,
															75.022
														],
														[
															25.411,
															43.896
														],
														[
															31.689,
															25.635
														],
														[
															24.685,
															10.154
														],
														[
															1.263,
															0.558
														],
														[
															60.865,
															-2.876
														],
														[
															-0.119,
															0.007
														]
													],
													"o": [
														[
															-5.916,
															-0.34
														],
														[
															-5.82,
															0.844
														],
														[
															-13.839,
															2.297
														],
														[
															-12.367,
															3.53
														],
														[
															-1.365,
															0.585
														],
														[
															-1.112,
															0.477
														],
														[
															-1.365,
															0.585
														],
														[
															-1.112,
															0.477
														],
														[
															-0.603,
															0.258
														],
														[
															-0.476,
															0.377
														],
														[
															-19.866,
															9.415
														],
														[
															-15.032,
															10.895
														],
														[
															-3.293,
															3.293
														],
														[
															-2.952,
															3.555
														],
														[
															-0.777,
															0.933
														],
														[
															-0.855,
															0.762
														],
														[
															-1.159,
															1.466
														],
														[
															-1.23,
															1.893
														],
														[
															-0.346,
															0.361
														],
														[
															-0.08,
															0.299
														],
														[
															-0.665,
															0.886
														],
														[
															-0.915,
															0.786
														],
														[
															-0.155,
															0.224
														],
														[
															0.067,
															0.381
														],
														[
															-0.073,
															0.162
														],
														[
															-0.451,
															0.163
														],
														[
															-0.154,
															0.23
														],
														[
															0.067,
															0.379
														],
														[
															-0.073,
															0.162
														],
														[
															-0.451,
															0.163
														],
														[
															-0.154,
															0.23
														],
														[
															0.067,
															0.379
														],
														[
															-0.073,
															0.162
														],
														[
															-0.451,
															0.163
														],
														[
															-0.154,
															0.23
														],
														[
															0.067,
															0.379
														],
														[
															-0.076,
															0.168
														],
														[
															-0.451,
															0.16
														],
														[
															-0.585,
															0.928
														],
														[
															-0.452,
															1.263
														],
														[
															-0.677,
															1.139
														],
														[
															-0.678,
															0.952
														],
														[
															-3.709,
															6.37
														],
														[
															-3.651,
															7.446
														],
														[
															-6.215,
															15.838
														],
														[
															-3.946,
															19.183
														],
														[
															0,
															17.3
														],
														[
															1.645,
															14.635
														],
														[
															1.785,
															6.871
														],
														[
															2.424,
															7.064
														],
														[
															0.767,
															1.791
														],
														[
															0.608,
															1.568
														],
														[
															1.551,
															3.75
														],
														[
															1.692,
															3.26
														],
														[
															22.719,
															43.34
														],
														[
															2.254,
															1.744
														],
														[
															0.798,
															0.765
														],
														[
															2.798,
															1.865
														],
														[
															0.442,
															0.311
														],
														[
															0.324,
															0.146
														],
														[
															0.46,
															0.307
														],
														[
															0.33,
															0.149
														],
														[
															2.252,
															1.456
														],
														[
															1.61,
															1.543
														],
														[
															21.713,
															12.752
														],
														[
															2.734,
															0.868
														],
														[
															2.273,
															0.659
														],
														[
															5.511,
															1.518
														],
														[
															5.21,
															1.114
														],
														[
															6.294,
															1.126
														],
														[
															8.205,
															1.958
														],
														[
															1.241,
															0.343
														],
														[
															5.407,
															1.303
														],
														[
															35.544,
															-0.959
														],
														[
															12.636,
															-3.91
														],
														[
															4.779,
															-1.875
														],
														[
															12.715,
															-5.915
														],
														[
															2.163,
															-1.339
														],
														[
															0.798,
															-0.765
														],
														[
															1.864,
															-1.243
														],
														[
															1.165,
															-0.929
														],
														[
															4.442,
															-3.245
														],
														[
															0.27,
															-0.122
														],
														[
															1.901,
															-1.608
														],
														[
															0.27,
															-0.122
														],
														[
															5.207,
															-4.405
														],
														[
															3.556,
															-3.416
														],
														[
															3.821,
															-4.074
														],
														[
															0.484,
															-1.073
														],
														[
															6.238,
															-7.508
														],
														[
															0.149,
															-0.331
														],
														[
															0.652,
															-1.012
														],
														[
															31.198,
															-47.975
														],
														[
															0,
															-68.608
														],
														[
															-21.14,
															-36.518
														],
														[
															-20.391,
															-16.495
														],
														[
															-1.507,
															-0.62
														],
														[
															-42.788,
															-18.895
														],
														[
															-0.63,
															0.03
														],
														[
															-0.65,
															0.038
														]
													],
													"v": [
														[
															343,
															26
														],
														[
															325.416,
															27.023
														],
														[
															308,
															30
														],
														[
															268.64,
															38.786
														],
														[
															234,
															51
														],
														[
															230.365,
															52.558
														],
														[
															227,
															54
														],
														[
															223.365,
															55.558
														],
														[
															220,
															57
														],
														[
															218.417,
															58.019
														],
														[
															217,
															59
														],
														[
															165.356,
															89.305
														],
														[
															124,
															125
														],
														[
															114.706,
															135.356
														],
														[
															106,
															146
														],
														[
															103.521,
															148.437
														],
														[
															101,
															151
														],
														[
															97.322,
															156.378
														],
														[
															94,
															161
														],
														[
															93.491,
															161.937
														],
														[
															93,
															163
														],
														[
															90.507,
															165.435
														],
														[
															88,
															168
														],
														[
															87.969,
															168.979
														],
														[
															88,
															170
														],
														[
															87.038,
															170.483
														],
														[
															86,
															171
														],
														[
															85.971,
															171.981
														],
														[
															86,
															173
														],
														[
															85.038,
															173.483
														],
														[
															84,
															174
														],
														[
															83.971,
															174.981
														],
														[
															84,
															176
														],
														[
															83.038,
															176.483
														],
														[
															82,
															177
														],
														[
															81.971,
															177.981
														],
														[
															82,
															179
														],
														[
															81.035,
															179.481
														],
														[
															80,
															180
														],
														[
															78.515,
															183.432
														],
														[
															77,
															187
														],
														[
															74.952,
															190.066
														],
														[
															73,
															193
														],
														[
															61.733,
															214.143
														],
														[
															52,
															236
														],
														[
															36.339,
															289.055
														],
														[
															30,
															349
														],
														[
															32.436,
															396.605
														],
														[
															40,
															438
														],
														[
															46.451,
															459.248
														],
														[
															54,
															479
														],
														[
															55.975,
															483.892
														],
														[
															58,
															489
														],
														[
															62.902,
															499.407
														],
														[
															68,
															509
														],
														[
															159,
															617
														],
														[
															166,
															622
														],
														[
															168,
															623
														],
														[
															176,
															630
														],
														[
															178,
															630
														],
														[
															179,
															632
														],
														[
															181,
															632
														],
														[
															182,
															634
														],
														[
															190,
															638
														],
														[
															195,
															641
														],
														[
															264,
															672
														],
														[
															272,
															674
														],
														[
															279,
															677
														],
														[
															296,
															680
														],
														[
															312,
															684
														],
														[
															332,
															686
														],
														[
															346,
															699
														],
														[
															350,
															699
														],
														[
															370,
															700
														],
														[
															463,
															685
														],
														[
															498,
															672
														],
														[
															509,
															667
														],
														[
															544,
															648
														],
														[
															552,
															643
														],
														[
															554,
															642
														],
														[
															559,
															637
														],
														[
															563,
															635
														],
														[
															577,
															625
														],
														[
															578,
															623
														],
														[
															583,
															620
														],
														[
															584,
															618
														],
														[
															599,
															605
														],
														[
															609,
															594
														],
														[
															620,
															581
														],
														[
															624,
															577
														],
														[
															643,
															551
														],
														[
															645,
															550
														],
														[
															647,
															546
														],
														[
															701,
															361
														],
														[
															655,
															192
														],
														[
															575,
															99
														],
														[
															505,
															56
														],
														[
															501,
															54
														],
														[
															346,
															25
														],
														[
															345,
															26
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 52,
											"s": [
												{
													"i": [
														[
															12.588,
															-2.039
														],
														[
															26.327,
															-12.493
														],
														[
															19.971,
															-16.73
														],
														[
															2.635,
															-2.297
														],
														[
															2.615,
															-2.43
														],
														[
															12.164,
															-16.861
														],
														[
															10.09,
															-21.457
														],
														[
															5.14,
															-22.169
														],
														[
															0,
															-24.374
														],
														[
															-4.523,
															-21.962
														],
														[
															-7.907,
															-18.438
														],
														[
															-7.567,
															-12.497
														],
														[
															-8.662,
															-10.854
														],
														[
															-2.965,
															-3.73
														],
														[
															-3.153,
															-3.335
														],
														[
															-7.032,
															-6.138
														],
														[
															-7.343,
															-5.543
														],
														[
															-0.769,
															-0.565
														],
														[
															-0.218,
															-0.208
														],
														[
															-0.299,
															-0.08
														],
														[
															-0.444,
															-0.333
														],
														[
															-0.786,
															-0.915
														],
														[
															-0.922,
															-0.639
														],
														[
															-0.381,
															0.067
														],
														[
															-0.251,
															-0.113
														],
														[
															-0.163,
															-0.451
														],
														[
															-0.185,
															-0.123
														],
														[
															-0.379,
															0.067
														],
														[
															-0.255,
															-0.115
														],
														[
															-0.163,
															-0.451
														],
														[
															-0.185,
															-0.123
														],
														[
															-0.379,
															0.067
														],
														[
															-0.255,
															-0.115
														],
														[
															-0.163,
															-0.451
														],
														[
															-0.185,
															-0.123
														],
														[
															-0.379,
															0.067
														],
														[
															-0.255,
															-0.115
														],
														[
															-0.161,
															-0.451
														],
														[
															-0.19,
															-0.123
														],
														[
															-1.559,
															-0.674
														],
														[
															-0.525,
															-0.504
														],
														[
															-0.828,
															-0.427
														],
														[
															-0.846,
															-0.488
														],
														[
															-14.138,
															-5.895
														],
														[
															-15.575,
															-3.988
														],
														[
															-7.04,
															-1.341
														],
														[
															-7.154,
															-0.923
														],
														[
															-2.642,
															-0.318
														],
														[
															-0.476,
															-0.476
														],
														[
															0.081,
															-0.428
														],
														[
															-0.168,
															-0.133
														],
														[
															-1.672,
															-2.163
														],
														[
															-0.936,
															-0.259
														],
														[
															-0.689,
															0.084
														],
														[
															-0.623,
															-0.163
														],
														[
															-3.475,
															-0.091
														],
														[
															-3.478,
															0.056
														],
														[
															-9.782,
															1.021
														],
														[
															-9.072,
															1.742
														],
														[
															-20.165,
															8.43
														],
														[
															-17.165,
															11.447
														],
														[
															-20.017,
															23.269
														],
														[
															-13.75,
															29.465
														],
														[
															-5.398,
															23.824
														],
														[
															0,
															27.548
														],
														[
															1.562,
															12.797
														],
														[
															2.753,
															11.572
														],
														[
															4.189,
															11.405
														],
														[
															4.317,
															10.072
														],
														[
															0.46,
															1.129
														],
														[
															0.579,
															1.126
														],
														[
															0.6,
															0.464
														],
														[
															0.33,
															0.614
														],
														[
															1.085,
															2.551
														],
														[
															1.334,
															2.328
														],
														[
															2.318,
															3.236
														],
														[
															1.819,
															2.726
														],
														[
															0.864,
															1.496
														],
														[
															0.648,
															0.676
														],
														[
															0.067,
															0.27
														],
														[
															0.348,
															0.522
														],
														[
															1.083,
															1.264
														],
														[
															0.831,
															1.049
														],
														[
															11.512,
															11.284
														],
														[
															3.753,
															3.217
														],
														[
															1.179,
															0.974
														],
														[
															0.844,
															0.723
														],
														[
															1.15,
															0.916
														],
														[
															1.898,
															1.442
														],
														[
															3.907,
															2.738
														],
														[
															1.124,
															1.077
														],
														[
															0.85,
															0.814
														],
														[
															1.507,
															0.924
														],
														[
															0.584,
															0.559
														],
														[
															1.087,
															0.7
														],
														[
															0.923,
															0.521
														],
														[
															2.59,
															1.33
														],
														[
															10.296,
															4.04
														],
														[
															56.207,
															-2.987
														],
														[
															-0.115,
															0.007
														]
													],
													"o": [
														[
															-32.719,
															5.299
														],
														[
															-26.327,
															12.493
														],
														[
															-2.844,
															2.383
														],
														[
															-2.635,
															2.297
														],
														[
															-16.253,
															15.101
														],
														[
															-12.164,
															16.861
														],
														[
															-8.441,
															17.95
														],
														[
															-5.14,
															22.169
														],
														[
															0,
															26.714
														],
														[
															4.523,
															21.962
														],
														[
															6.071,
															14.156
														],
														[
															7.567,
															12.497
														],
														[
															2.988,
															3.744
														],
														[
															2.965,
															3.73
														],
														[
															6.528,
															6.906
														],
														[
															7.032,
															6.138
														],
														[
															0.707,
															0.534
														],
														[
															0.769,
															0.564
														],
														[
															0.361,
															0.346
														],
														[
															0.299,
															0.08
														],
														[
															0.933,
															0.699
														],
														[
															0.786,
															0.915
														],
														[
															0.224,
															0.155
														],
														[
															0.381,
															-0.067
														],
														[
															0.162,
															0.073
														],
														[
															0.163,
															0.451
														],
														[
															0.23,
															0.154
														],
														[
															0.379,
															-0.067
														],
														[
															0.162,
															0.073
														],
														[
															0.163,
															0.451
														],
														[
															0.23,
															0.154
														],
														[
															0.379,
															-0.067
														],
														[
															0.162,
															0.073
														],
														[
															0.163,
															0.451
														],
														[
															0.23,
															0.154
														],
														[
															0.379,
															-0.067
														],
														[
															0.165,
															0.074
														],
														[
															0.161,
															0.451
														],
														[
															1.238,
															0.801
														],
														[
															1.559,
															0.674
														],
														[
															0.841,
															0.805
														],
														[
															0.828,
															0.427
														],
														[
															12.874,
															7.431
														],
														[
															14.138,
															5.895
														],
														[
															6.685,
															1.712
														],
														[
															7.04,
															1.341
														],
														[
															1.954,
															0.252
														],
														[
															2.642,
															0.318
														],
														[
															0.154,
															0.154
														],
														[
															-0.081,
															0.428
														],
														[
															1.378,
															1.091
														],
														[
															1.671,
															2.162
														],
														[
															0.62,
															0.171
														],
														[
															0.689,
															-0.084
														],
														[
															2.624,
															0.69
														],
														[
															3.475,
															0.091
														],
														[
															10.798,
															-0.174
														],
														[
															9.783,
															-1.021
														],
														[
															25.176,
															-4.834
														],
														[
															20.165,
															-8.43
														],
														[
															26.183,
															-17.46
														],
														[
															20.017,
															-23.269
														],
														[
															9.407,
															-20.156
														],
														[
															5.398,
															-23.824
														],
														[
															0,
															-14.24
														],
														[
															-1.562,
															-12.797
														],
														[
															-2.928,
															-12.306
														],
														[
															-4.189,
															-11.405
														],
														[
															-0.581,
															-1.356
														],
														[
															-0.46,
															-1.129
														],
														[
															-0.272,
															-0.53
														],
														[
															-0.6,
															-0.464
														],
														[
															-1.327,
															-2.468
														],
														[
															-1.085,
															-2.551
														],
														[
															-1.908,
															-3.329
														],
														[
															-2.318,
															-3.236
														],
														[
															-0.894,
															-1.341
														],
														[
															-0.865,
															-1.496
														],
														[
															-0.382,
															-0.399
														],
														[
															-0.067,
															-0.27
														],
														[
															-1.32,
															-1.98
														],
														[
															-1.014,
															-1.183
														],
														[
															-10.119,
															-12.783
														],
														[
															-4.289,
															-4.204
														],
														[
															-1.04,
															-0.891
														],
														[
															-0.844,
															-0.698
														],
														[
															-1.114,
															-0.955
														],
														[
															-1.939,
															-1.543
														],
														[
															-4.543,
															-3.452
														],
														[
															-2.398,
															-1.68
														],
														[
															-0.838,
															-0.803
														],
														[
															-1.615,
															-1.547
														],
														[
															-1.87,
															-1.147
														],
														[
															-0.817,
															-0.783
														],
														[
															-0.968,
															-0.623
														],
														[
															-2.226,
															-1.256
														],
														[
															-10.201,
															-5.237
														],
														[
															-39.764,
															-15.604
														],
														[
															-0.629,
															0.033
														],
														[
															-12.964,
															0.835
														]
													],
													"v": [
														[
															307,
															30
														],
														[
															218.439,
															57.426
														],
														[
															149,
															102
														],
														[
															140.828,
															108.965
														],
														[
															133,
															116
														],
														[
															90.878,
															163.233
														],
														[
															58,
															220
														],
														[
															37.169,
															280.682
														],
														[
															29,
															351
														],
														[
															36.07,
															423.708
														],
														[
															55,
															484
														],
														[
															75.556,
															523.976
														],
														[
															100,
															559
														],
														[
															108.876,
															570.307
														],
														[
															118,
															581
														],
														[
															138.389,
															600.522
														],
														[
															160,
															618
														],
														[
															162.367,
															619.744
														],
														[
															164,
															621
														],
														[
															164.937,
															621.509
														],
														[
															166,
															622
														],
														[
															168.508,
															624.545
														],
														[
															171,
															627
														],
														[
															171.979,
															627.031
														],
														[
															173,
															627
														],
														[
															173.483,
															627.962
														],
														[
															174,
															629
														],
														[
															174.981,
															629.029
														],
														[
															176,
															629
														],
														[
															176.483,
															629.962
														],
														[
															177,
															631
														],
														[
															177.981,
															631.029
														],
														[
															179,
															631
														],
														[
															179.483,
															631.962
														],
														[
															180,
															633
														],
														[
															180.981,
															633.029
														],
														[
															182,
															633
														],
														[
															182.481,
															633.964
														],
														[
															183,
															635
														],
														[
															187.534,
															637.223
														],
														[
															191,
															639
														],
														[
															193.496,
															640.737
														],
														[
															196,
															642
														],
														[
															236.474,
															662.082
														],
														[
															281,
															677
														],
														[
															301.648,
															681.592
														],
														[
															323,
															685
														],
														[
															330.609,
															685.832
														],
														[
															336,
															687
														],
														[
															335.99,
															688.016
														],
														[
															336,
															689
														],
														[
															340.832,
															694.624
														],
														[
															345,
															699
														],
														[
															346.998,
															699.006
														],
														[
															349,
															699
														],
														[
															358.359,
															700.06
														],
														[
															369,
															700
														],
														[
															399.794,
															698.176
														],
														[
															428,
															694
														],
														[
															495.508,
															673.959
														],
														[
															551,
															644
														],
														[
															620.324,
															583.003
														],
														[
															671,
															504
														],
														[
															693.555,
															438.044
														],
														[
															702,
															361
														],
														[
															699.565,
															320.499
														],
														[
															693,
															284
														],
														[
															682.042,
															248.325
														],
														[
															669,
															216
														],
														[
															667.498,
															212.328
														],
														[
															666,
															209
														],
														[
															664.543,
															207.563
														],
														[
															663,
															206
														],
														[
															659.506,
															198.395
														],
														[
															656,
															191
														],
														[
															649.433,
															181.048
														],
														[
															643,
															172
														],
														[
															640.315,
															167.501
														],
														[
															638,
															164
														],
														[
															637.474,
															163.092
														],
														[
															637,
															162
														],
														[
															632,
															157
														],
														[
															630,
															153
														],
														[
															598,
															119
														],
														[
															585,
															106
														],
														[
															581,
															104
														],
														[
															579,
															101
														],
														[
															575,
															99
														],
														[
															570,
															94
														],
														[
															557,
															85
														],
														[
															549,
															80
														],
														[
															546,
															78
														],
														[
															541,
															75
														],
														[
															536,
															72
														],
														[
															534,
															71
														],
														[
															531,
															68
														],
														[
															523,
															65
														],
														[
															490,
															49
														],
														[
															345,
															25
														],
														[
															344,
															26
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 53,
											"s": [
												{
													"i": [
														[
															0.652,
															0.029
														],
														[
															5.828,
															-0.836
														],
														[
															5.726,
															-0.922
														],
														[
															13.035,
															-3.712
														],
														[
															11.358,
															-4.816
														],
														[
															2.118,
															-1.238
														],
														[
															2.245,
															-1.08
														],
														[
															2.135,
															-0.845
														],
														[
															1.481,
															-0.668
														],
														[
															0.152,
															-0.451
														],
														[
															0.214,
															-0.115
														],
														[
															1.183,
															-0.445
														],
														[
															1.118,
															-0.6
														],
														[
															0.955,
															-0.693
														],
														[
															1.088,
															-0.642
														],
														[
															1.568,
															-0.699
														],
														[
															0.504,
															-0.483
														],
														[
															0.539,
															-0.298
														],
														[
															0.425,
															-0.407
														],
														[
															0.274,
															-0.069
														],
														[
															0.51,
															-0.346
														],
														[
															0.809,
															-0.941
														],
														[
															0.875,
															-0.632
														],
														[
															0.384,
															0.067
														],
														[
															0.248,
															-0.112
														],
														[
															0.163,
															-0.451
														],
														[
															0.185,
															-0.124
														],
														[
															0.379,
															0.067
														],
														[
															0.255,
															-0.115
														],
														[
															0.168,
															-0.451
														],
														[
															0.174,
															-0.124
														],
														[
															0.383,
															0.067
														],
														[
															0.249,
															-0.112
														],
														[
															0.168,
															-0.451
														],
														[
															0.173,
															-0.124
														],
														[
															1.449,
															-0.901
														],
														[
															1.472,
															-1.15
														],
														[
															5.052,
															-4.87
														],
														[
															4.99,
															-4.99
														],
														[
															10.492,
															-15.081
														],
														[
															8.898,
															-19.543
														],
														[
															5.233,
															-28.291
														],
														[
															-3.286,
															-31.092
														],
														[
															-0.812,
															-5.89
														],
														[
															-1.111,
															-5.379
														],
														[
															-1.577,
															-5.164
														],
														[
															-1.582,
															-4.976
														],
														[
															-1.609,
															-5.059
														],
														[
															-1.901,
															-4.532
														],
														[
															-1.263,
															-2.154
														],
														[
															-1.024,
															-2.185
														],
														[
															-0.119,
															-0.71
														],
														[
															-0.209,
															-0.487
														],
														[
															-0.369,
															-0.471
														],
														[
															-0.258,
															-0.501
														],
														[
															-0.461,
															-1.202
														],
														[
															-0.551,
															-1.021
														],
														[
															-15.418,
															-17.956
														],
														[
															-18.545,
															-14.346
														],
														[
															-16.486,
															-8.734
														],
														[
															-17.892,
															-6.11
														],
														[
															-3.771,
															-1.143
														],
														[
															-3.767,
															-1.011
														],
														[
															-7.082,
															-1.33
														],
														[
															-7.091,
															-0.915
														],
														[
															-2.146,
															-0.699
														],
														[
															-2.915,
															-2.741
														],
														[
															-2.63,
															-0.727
														],
														[
															-1.253,
															-0.302
														],
														[
															-7.13,
															0.192
														],
														[
															-17.771,
															3.463
														],
														[
															-32.122,
															20.225
														],
														[
															-0.875,
															0.838
														],
														[
															-0.85,
															0.815
														],
														[
															-2.67,
															1.967
														],
														[
															-4.046,
															1.824
														],
														[
															-0.29,
															0.245
														],
														[
															-1.633,
															0.736
														],
														[
															-0.29,
															0.245
														],
														[
															-1.921,
															1.471
														],
														[
															-9.508,
															11.756
														],
														[
															-3.052,
															6.77
														],
														[
															-0.247,
															0.37
														],
														[
															-0.23,
															0.511
														],
														[
															-0.247,
															0.372
														],
														[
															-0.231,
															0.512
														],
														[
															-0.245,
															0.381
														],
														[
															-0.724,
															1.133
														],
														[
															-1.664,
															2.713
														],
														[
															-1.221,
															1.991
														],
														[
															-2.023,
															3.803
														],
														[
															-3.731,
															9.16
														],
														[
															0,
															49.558
														],
														[
															18.601,
															40.417
														],
														[
															30.164,
															30.164
														],
														[
															17.476,
															11.444
														],
														[
															13.725,
															6.474
														],
														[
															5.319,
															2.23
														],
														[
															57.469,
															-3.055
														],
														[
															-0.115,
															0.007
														]
													],
													"o": [
														[
															-5.962,
															-0.267
														],
														[
															-5.828,
															0.836
														],
														[
															-14.501,
															2.335
														],
														[
															-13.035,
															3.712
														],
														[
															-2.284,
															0.969
														],
														[
															-2.118,
															1.238
														],
														[
															-1.98,
															0.953
														],
														[
															-2.135,
															0.845
														],
														[
															-0.179,
															0.081
														],
														[
															-0.152,
															0.451
														],
														[
															-1.149,
															0.618
														],
														[
															-1.183,
															0.445
														],
														[
															-1.093,
															0.587
														],
														[
															-0.955,
															0.693
														],
														[
															-1.226,
															0.723
														],
														[
															-1.568,
															0.699
														],
														[
															-0.419,
															0.401
														],
														[
															-0.539,
															0.298
														],
														[
															-0.394,
															0.377
														],
														[
															-0.274,
															0.069
														],
														[
															-0.888,
															0.603
														],
														[
															-0.809,
															0.941
														],
														[
															-0.216,
															0.156
														],
														[
															-0.384,
															-0.067
														],
														[
															-0.162,
															0.073
														],
														[
															-0.163,
															0.451
														],
														[
															-0.23,
															0.154
														],
														[
															-0.379,
															-0.067
														],
														[
															-0.155,
															0.07
														],
														[
															-0.168,
															0.451
														],
														[
															-0.218,
															0.156
														],
														[
															-0.383,
															-0.067
														],
														[
															-0.154,
															0.07
														],
														[
															-0.168,
															0.451
														],
														[
															-1.733,
															1.245
														],
														[
															-1.449,
															0.901
														],
														[
															-5.801,
															4.531
														],
														[
															-5.052,
															4.87
														],
														[
															-14.133,
															14.133
														],
														[
															-10.492,
															15.081
														],
														[
															-10.354,
															22.744
														],
														[
															-5.233,
															28.291
														],
														[
															0.64,
															6.062
														],
														[
															0.812,
															5.89
														],
														[
															1.108,
															5.369
														],
														[
															1.577,
															5.164
														],
														[
															1.665,
															5.233
														],
														[
															1.609,
															5.059
														],
														[
															0.922,
															2.2
														],
														[
															1.263,
															2.154
														],
														[
															0.316,
															0.673
														],
														[
															0.119,
															0.71
														],
														[
															0.264,
															0.616
														],
														[
															0.369,
															0.471
														],
														[
															0.603,
															1.17
														],
														[
															0.461,
															1.202
														],
														[
															11.785,
															21.829
														],
														[
															15.418,
															17.957
														],
														[
															14.162,
															10.955
														],
														[
															16.486,
															8.734
														],
														[
															4.15,
															1.417
														],
														[
															3.771,
															1.143
														],
														[
															6.579,
															1.765
														],
														[
															7.082,
															1.33
														],
														[
															2.877,
															0.371
														],
														[
															4.692,
															1.528
														],
														[
															2.746,
															2.582
														],
														[
															1.241,
															0.343
														],
														[
															5.602,
															1.35
														],
														[
															21.379,
															-0.577
														],
														[
															46.189,
															-9.002
														],
														[
															2.203,
															-1.387
														],
														[
															0.838,
															-0.803
														],
														[
															2.671,
															-2.559
														],
														[
															4.344,
															-3.199
														],
														[
															0.27,
															-0.122
														],
														[
															1.901,
															-1.608
														],
														[
															0.27,
															-0.122
														],
														[
															2.344,
															-1.983
														],
														[
															12.906,
															-9.879
														],
														[
															5.168,
															-6.39
														],
														[
															0.146,
															-0.324
														],
														[
															0.307,
															-0.46
														],
														[
															0.147,
															-0.325
														],
														[
															0.306,
															-0.462
														],
														[
															0.149,
															-0.331
														],
														[
															0.817,
															-1.27
														],
														[
															2.258,
															-3.531
														],
														[
															1.656,
															-2.701
														],
														[
															2.53,
															-4.125
														],
														[
															5.027,
															-9.449
														],
														[
															14.881,
															-36.533
														],
														[
															0,
															-56.093
														],
														[
															-19.549,
															-42.476
														],
														[
															-14.138,
															-14.138
														],
														[
															-13.278,
															-8.695
														],
														[
															-4.96,
															-2.34
														],
														[
															-41.139,
															-17.252
														],
														[
															-0.629,
															0.033
														],
														[
															-0.652,
															0.042
														]
													],
													"v": [
														[
															343,
															26
														],
														[
															325.324,
															27.108
														],
														[
															308,
															30
														],
														[
															266.642,
															39.139
														],
														[
															230,
															52
														],
														[
															223.47,
															55.417
														],
														[
															217,
															59
														],
														[
															210.626,
															61.714
														],
														[
															205,
															64
														],
														[
															204.527,
															64.974
														],
														[
															204,
															66
														],
														[
															200.477,
															67.513
														],
														[
															197,
															69
														],
														[
															193.996,
															70.959
														],
														[
															191,
															73
														],
														[
															186.458,
															75.18
														],
														[
															183,
															77
														],
														[
															181.505,
															77.995
														],
														[
															180,
															79
														],
														[
															179.087,
															79.523
														],
														[
															178,
															80
														],
														[
															175.49,
															82.479
														],
														[
															173,
															85
														],
														[
															172.023,
															85.034
														],
														[
															171,
															85
														],
														[
															170.517,
															85.962
														],
														[
															170,
															87
														],
														[
															169.019,
															87.029
														],
														[
															168,
															87
														],
														[
															167.514,
															87.959
														],
														[
															167,
															89
														],
														[
															166.023,
															89.033
														],
														[
															165,
															89
														],
														[
															164.514,
															89.959
														],
														[
															164,
															91
														],
														[
															159.305,
															94.072
														],
														[
															155,
															97
														],
														[
															138.892,
															111.155
														],
														[
															124,
															126
														],
														[
															87.573,
															168.942
														],
														[
															59,
															220
														],
														[
															34.77,
															297.239
														],
														[
															31,
															387
														],
														[
															33.148,
															405.013
														],
														[
															36,
															422
														],
														[
															40.145,
															437.794
														],
														[
															45,
															453
														],
														[
															49.823,
															468.526
														],
														[
															55,
															483
														],
														[
															58.424,
															489.511
														],
														[
															62,
															496
														],
														[
															62.58,
															498.14
														],
														[
															63,
															500
														],
														[
															64.004,
															501.586
														],
														[
															65,
															503
														],
														[
															66.539,
															506.612
														],
														[
															68,
															510
														],
														[
															108.93,
															569.612
														],
														[
															160,
															618
														],
														[
															206.202,
															647.634
														],
														[
															258,
															670
														],
														[
															269.787,
															673.804
														],
														[
															281,
															677
														],
														[
															301.616,
															681.638
														],
														[
															323,
															685
														],
														[
															332,
															686
														],
														[
															340,
															693
														],
														[
															346,
															699
														],
														[
															350,
															699
														],
														[
															370,
															700
														],
														[
															429,
															694
														],
														[
															544,
															648
														],
														[
															552,
															643
														],
														[
															555,
															641
														],
														[
															563,
															635
														],
														[
															577,
															625
														],
														[
															578,
															623
														],
														[
															583,
															620
														],
														[
															584,
															618
														],
														[
															590,
															613
														],
														[
															624,
															577
														],
														[
															639,
															557
														],
														[
															641,
															556
														],
														[
															641,
															554
														],
														[
															643,
															553
														],
														[
															643,
															551
														],
														[
															645,
															550
														],
														[
															647,
															546
														],
														[
															653,
															536
														],
														[
															657,
															529
														],
														[
															663,
															518
														],
														[
															677,
															489
														],
														[
															701,
															361
														],
														[
															670,
															220
														],
														[
															598,
															119
														],
														[
															550,
															81
														],
														[
															509,
															57
														],
														[
															493,
															51
														],
														[
															346,
															25
														],
														[
															345,
															26
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 54,
											"s": [
												{
													"i": [
														[
															12.485,
															-2.022
														],
														[
															5.543,
															-1.161
														],
														[
															5,
															-1.412
														],
														[
															4.826,
															-1.716
														],
														[
															4.555,
															-1.683
														],
														[
															2.506,
															-0.754
														],
														[
															2.38,
															-1.026
														],
														[
															2.124,
															-1.235
														],
														[
															2.231,
															-1.08
														],
														[
															3.28,
															-1.749
														],
														[
															2.57,
															-1.404
														],
														[
															1.55,
															-0.702
														],
														[
															0.508,
															-0.487
														],
														[
															0.246,
															-0.06
														],
														[
															0.588,
															-0.35
														],
														[
															4.363,
															-3.316
														],
														[
															3.815,
															-2.923
														],
														[
															0.388,
															0.066
														],
														[
															0.241,
															-0.108
														],
														[
															0.179,
															-0.454
														],
														[
															0.147,
															-0.123
														],
														[
															2.344,
															-1.767
														],
														[
															2.18,
															-1.892
														],
														[
															1.997,
															-1.841
														],
														[
															2.024,
															-0.912
														],
														[
															0.179,
															-0.454
														],
														[
															0.147,
															-0.123
														],
														[
															2.011,
															-2.036
														],
														[
															1.666,
															-1.945
														],
														[
															2.367,
															-2.642
														],
														[
															2.123,
															-2.625
														],
														[
															7.511,
															-11.928
														],
														[
															6.573,
															-14.69
														],
														[
															5.216,
															-21.829
														],
														[
															0,
															-24.507
														],
														[
															-1.16,
															-11.859
														],
														[
															-2.358,
															-11.236
														],
														[
															-3.554,
															-11.344
														],
														[
															-4.221,
															-9.409
														],
														[
															-5.853,
															-12.985
														],
														[
															-0.247,
															-0.37
														],
														[
															-0.23,
															-0.511
														],
														[
															-0.246,
															-0.374
														],
														[
															-0.231,
															-0.513
														],
														[
															-0.247,
															-0.37
														],
														[
															-0.23,
															-0.511
														],
														[
															-0.247,
															-0.37
														],
														[
															-0.23,
															-0.511
														],
														[
															-0.247,
															-0.37
														],
														[
															-0.23,
															-0.511
														],
														[
															-0.248,
															-0.354
														],
														[
															-0.226,
															-0.501
														],
														[
															-0.249,
															-0.346
														],
														[
															-6.791,
															-8.15
														],
														[
															-7.932,
															-7.281
														],
														[
															-4.95,
															-3.976
														],
														[
															-3.427,
															-2.53
														],
														[
															-2.02,
															-1.388
														],
														[
															-4.026,
															-2.6
														],
														[
															-2.152,
															-1.279
														],
														[
															-0.978,
															-0.937
														],
														[
															-1.525,
															-0.891
														],
														[
															-21.918,
															-6.782
														],
														[
															-5.118,
															-1.137
														],
														[
															-10.385,
															-1.743
														],
														[
															-3.638,
															-2.872
														],
														[
															-1.874,
															-1.753
														],
														[
															-2.374,
															-0.713
														],
														[
															-1.562,
															-0.35
														],
														[
															-6.863,
															0.252
														],
														[
															-18.06,
															3.425
														],
														[
															-41.473,
															40.595
														],
														[
															-3.414,
															3.684
														],
														[
															-3.297,
															3.919
														],
														[
															-3.229,
															4.085
														],
														[
															-1.702,
															2.495
														],
														[
															-0.696,
															1.008
														],
														[
															-1.306,
															1.927
														],
														[
															-0.703,
															1.243
														],
														[
															-0.657,
															1.017
														],
														[
															-2.675,
															4.736
														],
														[
															-1.648,
															2.915
														],
														[
															-0.529,
															1.012
														],
														[
															-1.281,
															2.834
														],
														[
															-1.093,
															2.438
														],
														[
															0,
															54.813
														],
														[
															31.549,
															47.871
														],
														[
															1.114,
															2.47
														],
														[
															0.249,
															0.346
														],
														[
															1.416,
															3.141
														],
														[
															0.249,
															0.325
														],
														[
															1.759,
															1.862
														],
														[
															1.004,
															1.148
														],
														[
															1.826,
															2.13
														],
														[
															1.042,
															1.145
														],
														[
															5.798,
															4.438
														],
														[
															1.113,
															0.974
														],
														[
															35.035,
															14.763
														],
														[
															57.298,
															-3.045
														],
														[
															-0.115,
															0.007
														]
													],
													"o": [
														[
															-5.827,
															0.944
														],
														[
															-5.543,
															1.161
														],
														[
															-5.142,
															1.453
														],
														[
															-4.826,
															1.716
														],
														[
															-2.596,
															0.959
														],
														[
															-2.506,
															0.754
														],
														[
															-2.274,
															0.98
														],
														[
															-2.124,
															1.235
														],
														[
															-3.308,
															1.601
														],
														[
															-3.281,
															1.749
														],
														[
															-1.291,
															0.704
														],
														[
															-1.55,
															0.702
														],
														[
															-0.427,
															0.409
														],
														[
															-0.246,
															0.06
														],
														[
															-4.731,
															2.811
														],
														[
															-4.363,
															3.316
														],
														[
															-0.206,
															0.157
														],
														[
															-0.388,
															-0.067
														],
														[
															-0.137,
															0.062
														],
														[
															-0.179,
															0.454
														],
														[
															-2.446,
															2.038
														],
														[
															-2.344,
															1.767
														],
														[
															-1.988,
															1.725
														],
														[
															-1.997,
															1.841
														],
														[
															-0.137,
															0.062
														],
														[
															-0.179,
															0.454
														],
														[
															-2.292,
															1.91
														],
														[
															-2.01,
															2.036
														],
														[
															-2.407,
															2.81
														],
														[
															-2.367,
															2.641
														],
														[
															-9.382,
															11.597
														],
														[
															-7.511,
															11.928
														],
														[
															-8.135,
															18.178
														],
														[
															-5.216,
															21.829
														],
														[
															0,
															13.327
														],
														[
															1.16,
															11.859
														],
														[
															2.563,
															12.213
														],
														[
															3.554,
															11.344
														],
														[
															6.438,
															14.352
														],
														[
															0.146,
															0.324
														],
														[
															0.307,
															0.46
														],
														[
															0.147,
															0.327
														],
														[
															0.306,
															0.465
														],
														[
															0.146,
															0.324
														],
														[
															0.307,
															0.46
														],
														[
															0.146,
															0.324
														],
														[
															0.307,
															0.46
														],
														[
															0.146,
															0.324
														],
														[
															0.307,
															0.46
														],
														[
															0.142,
															0.314
														],
														[
															0.311,
															0.443
														],
														[
															0.139,
															0.309
														],
														[
															7.036,
															9.789
														],
														[
															6.676,
															8.012
														],
														[
															5.38,
															4.938
														],
														[
															3.988,
															3.203
														],
														[
															2.117,
															1.563
														],
														[
															4.126,
															2.837
														],
														[
															2.017,
															1.302
														],
														[
															2.358,
															1.401
														],
														[
															1.61,
															1.542
														],
														[
															18.704,
															10.93
														],
														[
															6.717,
															2.078
														],
														[
															9.974,
															2.216
														],
														[
															7.13,
															1.197
														],
														[
															1.584,
															1.251
														],
														[
															2.926,
															2.737
														],
														[
															1.529,
															0.459
														],
														[
															5.82,
															1.305
														],
														[
															21.955,
															-0.807
														],
														[
															72.665,
															-13.782
														],
														[
															3.581,
															-3.506
														],
														[
															3.469,
															-3.743
														],
														[
															3.219,
															-3.826
														],
														[
															2.506,
															-3.17
														],
														[
															0.697,
															-1.022
														],
														[
															1.286,
															-1.862
														],
														[
															0.812,
															-1.197
														],
														[
															0.704,
															-1.245
														],
														[
															2.896,
															-4.485
														],
														[
															1.938,
															-3.432
														],
														[
															0.602,
															-1.064
														],
														[
															1.295,
															-2.473
														],
														[
															1.081,
															-2.392
														],
														[
															17.973,
															-40.101
														],
														[
															0,
															-78.824
														],
														[
															-1.967,
															-2.984
														],
														[
															-0.139,
															-0.309
														],
														[
															-2.609,
															-3.63
														],
														[
															-0.133,
															-0.295
														],
														[
															-2.28,
															-2.979
														],
														[
															-1.14,
															-1.207
														],
														[
															-2.428,
															-2.776
														],
														[
															-0.878,
															-1.025
														],
														[
															-5.772,
															-6.339
														],
														[
															-1.272,
															-0.973
														],
														[
															-27.126,
															-23.727
														],
														[
															-40.839,
															-17.209
														],
														[
															-0.629,
															0.033
														],
														[
															-12.931,
															0.833
														]
													],
													"v": [
														[
															308,
															30
														],
														[
															290.879,
															33.149
														],
														[
															275,
															37
														],
														[
															260.06,
															41.828
														],
														[
															246,
															47
														],
														[
															238.337,
															49.45
														],
														[
															231,
															52
														],
														[
															224.467,
															55.425
														],
														[
															218,
															59
														],
														[
															207.947,
															64.148
														],
														[
															199,
															69
														],
														[
															194.413,
															71.163
														],
														[
															191,
															73
														],
														[
															190.121,
															73.545
														],
														[
															189,
															74
														],
														[
															175.313,
															83.416
														],
														[
															163,
															93
														],
														[
															162.027,
															93.037
														],
														[
															161,
															93
														],
														[
															160.508,
															93.954
														],
														[
															160,
															95
														],
														[
															152.8,
															100.61
														],
														[
															146,
															106
														],
														[
															140.027,
															111.61
														],
														[
															134,
															116
														],
														[
															133.508,
															116.954
														],
														[
															133,
															118
														],
														[
															126.53,
															123.974
														],
														[
															121,
															130
														],
														[
															113.787,
															138.139
														],
														[
															107,
															146
														],
														[
															81.894,
															180.681
														],
														[
															61,
															220
														],
														[
															40.399,
															280.253
														],
														[
															32,
															350
														],
														[
															33.731,
															387.568
														],
														[
															39,
															422
														],
														[
															48.257,
															457.603
														],
														[
															60,
															489
														],
														[
															81,
															530
														],
														[
															83,
															531
														],
														[
															83,
															533
														],
														[
															85,
															534
														],
														[
															85,
															536
														],
														[
															87,
															537
														],
														[
															87,
															539
														],
														[
															89,
															540
														],
														[
															89,
															542
														],
														[
															91,
															543
														],
														[
															91,
															545
														],
														[
															93,
															546
														],
														[
															93,
															548
														],
														[
															95,
															549
														],
														[
															117,
															577
														],
														[
															139,
															599
														],
														[
															155,
															613
														],
														[
															166,
															622
														],
														[
															172,
															626
														],
														[
															184,
															634
														],
														[
															190,
															638
														],
														[
															198,
															642
														],
														[
															203,
															645
														],
														[
															265,
															672
														],
														[
															284,
															678
														],
														[
															313,
															684
														],
														[
															337,
															688
														],
														[
															340,
															693
														],
														[
															346,
															699
														],
														[
															351,
															699
														],
														[
															371,
															700
														],
														[
															429,
															693
														],
														[
															598,
															604
														],
														[
															608,
															593
														],
														[
															619,
															582
														],
														[
															628,
															570
														],
														[
															635,
															561
														],
														[
															637,
															557
														],
														[
															642,
															552
														],
														[
															643,
															548
														],
														[
															646,
															545
														],
														[
															654,
															531
														],
														[
															659,
															521
														],
														[
															662,
															518
														],
														[
															665,
															510
														],
														[
															669,
															503
														],
														[
															699,
															361
														],
														[
															641,
															172
														],
														[
															636,
															164
														],
														[
															634,
															163
														],
														[
															627,
															152
														],
														[
															625,
															151
														],
														[
															620,
															145
														],
														[
															618,
															141
														],
														[
															610,
															134
														],
														[
															608,
															130
														],
														[
															589,
															112
														],
														[
															586,
															109
														],
														[
															493,
															51
														],
														[
															346,
															25
														],
														[
															345,
															26
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 55,
											"s": [
												{
													"i": [
														[
															0.652,
															0.029
														],
														[
															5.87,
															-0.832
														],
														[
															5.635,
															-0.935
														],
														[
															26.725,
															-13.194
														],
														[
															20.363,
															-17.621
														],
														[
															3.27,
															-3.391
														],
														[
															3.313,
															-3.313
														],
														[
															0.886,
															-0.623
														],
														[
															0.715,
															-0.766
														],
														[
															0.591,
															-1.047
														],
														[
															0.811,
															-0.925
														],
														[
															1.809,
															-1.948
														],
														[
															0.981,
															-2.177
														],
														[
															0.454,
															-0.179
														],
														[
															0.123,
															-0.147
														],
														[
															1.983,
															-2.805
														],
														[
															1.078,
															-2.393
														],
														[
															0.451,
															-0.163
														],
														[
															0.124,
															-0.185
														],
														[
															-0.067,
															-0.379
														],
														[
															0.115,
															-0.255
														],
														[
															0.451,
															-0.165
														],
														[
															0.124,
															-0.181
														],
														[
															0.464,
															-1.071
														],
														[
															0.6,
															-0.924
														],
														[
															2.486,
															-4.142
														],
														[
															2.299,
															-4.186
														],
														[
															1.175,
															-2.095
														],
														[
															1.043,
															-2.333
														],
														[
															0.509,
															-1.213
														],
														[
															0.492,
															-1.094
														],
														[
															5.035,
															-21.919
														],
														[
															0.671,
															-24.108
														],
														[
															-3.748,
															-19.916
														],
														[
															-5.633,
															-15.92
														],
														[
															-0.547,
															-1.194
														],
														[
															-0.422,
															-1.125
														],
														[
															-0.251,
															-1.361
														],
														[
															-0.482,
															-1.187
														],
														[
															-0.541,
															-1.007
														],
														[
															-0.431,
															-0.971
														],
														[
															-3.739,
															-6.872
														],
														[
															-2.888,
															-6.406
														],
														[
															-0.247,
															-0.37
														],
														[
															-0.23,
															-0.511
														],
														[
															-0.246,
															-0.374
														],
														[
															-1.217,
															-1.874
														],
														[
															-1.686,
															-1.759
														],
														[
															-3.125,
															-3.911
														],
														[
															-1.043,
															-2.313
														],
														[
															-0.246,
															-0.295
														],
														[
															-8.803,
															-8.322
														],
														[
															-7.446,
															-5.943
														],
														[
															-1.639,
															-1.57
														],
														[
															-0.85,
															-0.815
														],
														[
															-0.85,
															-0.815
														],
														[
															-0.85,
															-0.815
														],
														[
															-0.85,
															-0.815
														],
														[
															-0.85,
															-0.815
														],
														[
															-0.85,
															-0.815
														],
														[
															-0.85,
															-0.815
														],
														[
															-3.12,
															-1.724
														],
														[
															-2.283,
															-1.267
														],
														[
															-1.928,
															-1.076
														],
														[
															-2.249,
															-1.073
														],
														[
															-15.057,
															-4.868
														],
														[
															-5.04,
															-1.12
														],
														[
															-10.2,
															-1.796
														],
														[
															-3.744,
															-2.583
														],
														[
															-2.505,
															-0.911
														],
														[
															-1.213,
															-0.333
														],
														[
															-7.141,
															0.177
														],
														[
															-18.714,
															4.098
														],
														[
															-38.672,
															38.672
														],
														[
															-18.135,
															39.774
														],
														[
															0,
															54.123
														],
														[
															12.007,
															31.301
														],
														[
															0.989,
															2.546
														],
														[
															1.952,
															4.396
														],
														[
															2.329,
															4.53
														],
														[
															2.649,
															4.518
														],
														[
															3.801,
															5.863
														],
														[
															2.828,
															6.275
														],
														[
															0.249,
															0.325
														],
														[
															1.759,
															1.862
														],
														[
															0.865,
															1.027
														],
														[
															1.72,
															1.954
														],
														[
															25.456,
															16.004
														],
														[
															0.839,
															0.803
														],
														[
															1.087,
															0.7
														],
														[
															0.955,
															0.565
														],
														[
															1.326,
															0.681
														],
														[
															1.197,
															0.657
														],
														[
															6.697,
															3.027
														],
														[
															2.465,
															1.024
														],
														[
															2.598,
															1.023
														],
														[
															2.367,
															0.879
														],
														[
															5.711,
															1.836
														],
														[
															42.663,
															-2.268
														],
														[
															-0.115,
															0.007
														]
													],
													"o": [
														[
															-5.885,
															-0.264
														],
														[
															-5.87,
															0.832
														],
														[
															-33.737,
															5.601
														],
														[
															-26.725,
															13.195
														],
														[
															-3.608,
															3.123
														],
														[
															-3.27,
															3.391
														],
														[
															-0.743,
															0.743
														],
														[
															-0.886,
															0.623
														],
														[
															-0.827,
															0.885
														],
														[
															-0.591,
															1.047
														],
														[
															-1.782,
															2.032
														],
														[
															-1.809,
															1.948
														],
														[
															-0.062,
															0.137
														],
														[
															-0.454,
															0.179
														],
														[
															-1.99,
															2.388
														],
														[
															-1.983,
															2.805
														],
														[
															-0.073,
															0.162
														],
														[
															-0.451,
															0.163
														],
														[
															-0.154,
															0.23
														],
														[
															0.067,
															0.379
														],
														[
															-0.072,
															0.159
														],
														[
															-0.451,
															0.165
														],
														[
															-0.542,
															0.793
														],
														[
															-0.464,
															1.071
														],
														[
															-2.757,
															4.245
														],
														[
															-2.486,
															4.142
														],
														[
															-1.257,
															2.289
														],
														[
															-1.175,
															2.095
														],
														[
															-0.472,
															1.055
														],
														[
															-0.509,
															1.213
														],
														[
															-8.19,
															18.215
														],
														[
															-5.035,
															21.919
														],
														[
															-0.623,
															22.415
														],
														[
															3.748,
															19.916
														],
														[
															0.39,
															1.101
														],
														[
															0.547,
															1.193
														],
														[
															0.514,
															1.369
														],
														[
															0.251,
															1.361
														],
														[
															0.406,
															0.999
														],
														[
															0.541,
															1.007
														],
														[
															3.156,
															7.108
														],
														[
															3.739,
															6.872
														],
														[
															0.146,
															0.324
														],
														[
															0.307,
															0.46
														],
														[
															0.147,
															0.327
														],
														[
															1.291,
															1.963
														],
														[
															2.05,
															3.156
														],
														[
															3.957,
															4.13
														],
														[
															2.055,
															2.572
														],
														[
															0.124,
															0.274
														],
														[
															8.136,
															9.764
														],
														[
															6.873,
															6.498
														],
														[
															2.656,
															2.12
														],
														[
															0.838,
															0.803
														],
														[
															0.838,
															0.803
														],
														[
															0.838,
															0.803
														],
														[
															0.838,
															0.803
														],
														[
															0.838,
															0.803
														],
														[
															0.838,
															0.803
														],
														[
															0.838,
															0.803
														],
														[
															3.114,
															2.984
														],
														[
															2.167,
															1.197
														],
														[
															1.904,
															1.057
														],
														[
															2.015,
															1.124
														],
														[
															14.127,
															6.736
														],
														[
															6.371,
															2.06
														],
														[
															9.922,
															2.205
														],
														[
															7.412,
															1.305
														],
														[
															3.205,
															2.211
														],
														[
															1.178,
															0.428
														],
														[
															5.053,
															1.386
														],
														[
															23.747,
															-0.587
														],
														[
															66.771,
															-14.62
														],
														[
															29.436,
															-29.437
														],
														[
															18.135,
															-39.774
														],
														[
															0,
															-44.057
														],
														[
															-1.004,
															-2.618
														],
														[
															-2.207,
															-5.682
														],
														[
															-2.295,
															-5.168
														],
														[
															-2.544,
															-4.948
														],
														[
															-4.053,
															-6.911
														],
														[
															-4.162,
															-6.421
														],
														[
															-0.133,
															-0.295
														],
														[
															-2.28,
															-2.979
														],
														[
															-1.065,
															-1.127
														],
														[
															-1.53,
															-1.816
														],
														[
															-19.533,
															-22.19
														],
														[
															-2.08,
															-1.308
														],
														[
															-0.817,
															-0.783
														],
														[
															-0.999,
															-0.643
														],
														[
															-1.308,
															-0.773
														],
														[
															-1.496,
															-0.769
														],
														[
															-6.916,
															-3.794
														],
														[
															-2.422,
															-1.094
														],
														[
															-2.384,
															-0.99
														],
														[
															-2.551,
															-1.005
														],
														[
															-5.635,
															-2.092
														],
														[
															-32.008,
															-10.292
														],
														[
															-0.629,
															0.033
														],
														[
															-0.652,
															0.042
														]
													],
													"v": [
														[
															344,
															26
														],
														[
															326.312,
															27.1
														],
														[
															309,
															30
														],
														[
															218.47,
															58.985
														],
														[
															148,
															106
														],
														[
															137.778,
															115.857
														],
														[
															128,
															126
														],
														[
															125.479,
															127.983
														],
														[
															123,
															130
														],
														[
															120.988,
															132.97
														],
														[
															119,
															136
														],
														[
															113.399,
															141.892
														],
														[
															109,
															148
														],
														[
															108.046,
															148.492
														],
														[
															107,
															149
														],
														[
															100.816,
															156.997
														],
														[
															96,
															165
														],
														[
															95.038,
															165.483
														],
														[
															94,
															166
														],
														[
															93.971,
															166.981
														],
														[
															94,
															168
														],
														[
															93.039,
															168.484
														],
														[
															92,
															169
														],
														[
															90.544,
															171.901
														],
														[
															89,
															175
														],
														[
															81.156,
															187.544
														],
														[
															74,
															200
														],
														[
															70.34,
															206.467
														],
														[
															67,
															213
														],
														[
															65.515,
															216.47
														],
														[
															64,
															220
														],
														[
															43.861,
															280.58
														],
														[
															35,
															350
														],
														[
															40.308,
															413.871
														],
														[
															55,
															468
														],
														[
															56.476,
															471.483
														],
														[
															58,
															475
														],
														[
															59.024,
															479.137
														],
														[
															60,
															483
														],
														[
															61.481,
															486.021
														],
														[
															63,
															489
														],
														[
															73.701,
															510.027
														],
														[
															84,
															530
														],
														[
															86,
															531
														],
														[
															86,
															533
														],
														[
															88,
															534
														],
														[
															91,
															540
														],
														[
															98,
															550
														],
														[
															108,
															563
														],
														[
															113,
															570
														],
														[
															115,
															571
														],
														[
															141,
															599
														],
														[
															163,
															617
														],
														[
															172,
															624
														],
														[
															175,
															626
														],
														[
															178,
															628
														],
														[
															181,
															630
														],
														[
															184,
															632
														],
														[
															187,
															634
														],
														[
															190,
															636
														],
														[
															193,
															638
														],
														[
															204,
															645
														],
														[
															211,
															648
														],
														[
															216,
															652
														],
														[
															223,
															655
														],
														[
															266,
															672
														],
														[
															285,
															678
														],
														[
															314,
															684
														],
														[
															337,
															688
														],
														[
															346,
															699
														],
														[
															350,
															699
														],
														[
															370,
															700
														],
														[
															436,
															692
														],
														[
															595,
															604
														],
														[
															665,
															503
														],
														[
															696,
															362
														],
														[
															675,
															245
														],
														[
															672,
															237
														],
														[
															665,
															222
														],
														[
															659,
															207
														],
														[
															651,
															193
														],
														[
															639,
															173
														],
														[
															625,
															153
														],
														[
															623,
															152
														],
														[
															618,
															146
														],
														[
															616,
															142
														],
														[
															611,
															137
														],
														[
															542,
															78
														],
														[
															534,
															73
														],
														[
															532,
															72
														],
														[
															529,
															69
														],
														[
															525,
															68
														],
														[
															522,
															65
														],
														[
															500,
															55
														],
														[
															493,
															51
														],
														[
															485,
															49
														],
														[
															478,
															45
														],
														[
															461,
															40
														],
														[
															347,
															25
														],
														[
															346,
															26
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 56,
											"s": [
												{
													"i": [
														[
															12.296,
															-2.16
														],
														[
															16.803,
															-6.185
														],
														[
															14.129,
															-7.809
														],
														[
															0.969,
															-0.7
														],
														[
															1.082,
															-0.625
														],
														[
															1.215,
															-0.431
														],
														[
															1.06,
															-0.653
														],
														[
															0.322,
															-0.387
														],
														[
															0.399,
															-0.258
														],
														[
															3.491,
															-2.287
														],
														[
															3.304,
															-2.434
														],
														[
															1.586,
															-1.539
														],
														[
															1.831,
															-1.499
														],
														[
															1.025,
															-0.612
														],
														[
															0.937,
															-0.764
														],
														[
															0.802,
															-0.864
														],
														[
															0.86,
															-0.782
														],
														[
															3.594,
															-3.108
														],
														[
															2.85,
															-3.138
														],
														[
															0.11,
															-0.584
														],
														[
															0.257,
															-0.329
														],
														[
															1.455,
															-1.364
														],
														[
															0.798,
															-1.771
														],
														[
															0.454,
															-0.179
														],
														[
															0.123,
															-0.147
														],
														[
															1.34,
															-1.935
														],
														[
															1.12,
															-1.437
														],
														[
															0.585,
															-0.288
														],
														[
															0.332,
															-0.43
														],
														[
															-0.066,
															-0.389
														],
														[
															0.108,
															-0.24
														],
														[
															0.451,
															-0.168
														],
														[
															0.124,
															-0.173
														],
														[
															12.112,
															-32.668
														],
														[
															0.216,
															-40.208
														],
														[
															-4.411,
															-21.819
														],
														[
															-7.498,
															-18.379
														],
														[
															-10.06,
															-16.043
														],
														[
															-11.957,
															-13.707
														],
														[
															-4.162,
															-4.165
														],
														[
															-3.756,
															-3.218
														],
														[
															-1.814,
															-1.468
														],
														[
															-1.77,
															-1.437
														],
														[
															-0.823,
															-0.907
														],
														[
															-0.846,
															-0.673
														],
														[
															-5.973,
															-4.046
														],
														[
															-5.611,
															-3.439
														],
														[
															-11.352,
															-5.141
														],
														[
															-12.055,
															-3.976
														],
														[
															-3.806,
															-1.257
														],
														[
															-2.977,
															-0.721
														],
														[
															-1.513,
															-0.079
														],
														[
															-1.508,
															-0.336
														],
														[
															-2.691,
															-0.74
														],
														[
															-2.745,
															-0.484
														],
														[
															-4.38,
															-0.501
														],
														[
															-1.791,
															-1.347
														],
														[
															-1.407,
															-2.303
														],
														[
															-1.572,
															-0.435
														],
														[
															-0.689,
															0.082
														],
														[
															-0.625,
															-0.159
														],
														[
															-3.44,
															-0.104
														],
														[
															-3.478,
															0.116
														],
														[
															-9.303,
															1.213
														],
														[
															-8.965,
															1.786
														],
														[
															-8.154,
															2.349
														],
														[
															-7.465,
															2.827
														],
														[
															-4.904,
															2.121
														],
														[
															-4.68,
															2.353
														],
														[
															-2.374,
															1.154
														],
														[
															-2.156,
															1.202
														],
														[
															-0.029,
															0.028
														],
														[
															-1.512,
															0.915
														],
														[
															-6.079,
															4.279
														],
														[
															-23.693,
															41.932
														],
														[
															-1.306,
															2.346
														],
														[
															-3.366,
															7.246
														],
														[
															-1.381,
															3.222
														],
														[
															-0.777,
															2.142
														],
														[
															-1.451,
															4.124
														],
														[
															-0.895,
															2.667
														],
														[
															-2.674,
															13.304
														],
														[
															24.873,
															56.46
														],
														[
															8.423,
															12.344
														],
														[
															0.831,
															1.277
														],
														[
															1.408,
															2.062
														],
														[
															18.021,
															16.213
														],
														[
															3.745,
															3.066
														],
														[
															9.608,
															6.458
														],
														[
															2.102,
															1.326
														],
														[
															2.065,
															1.201
														],
														[
															0.939,
															0.576
														],
														[
															5.934,
															2.89
														],
														[
															2.786,
															1.265
														],
														[
															2.46,
															1.06
														],
														[
															2.846,
															1.121
														],
														[
															2.564,
															0.952
														],
														[
															5.222,
															1.707
														],
														[
															41.473,
															-2.436
														],
														[
															-0.112,
															0.008
														]
													],
													"o": [
														[
															-19.659,
															3.453
														],
														[
															-16.803,
															6.185
														],
														[
															-1.041,
															0.575
														],
														[
															-0.969,
															0.7
														],
														[
															-1.079,
															0.624
														],
														[
															-1.215,
															0.431
														],
														[
															-0.314,
															0.194
														],
														[
															-0.322,
															0.387
														],
														[
															-3.733,
															2.419
														],
														[
															-3.491,
															2.287
														],
														[
															-1.827,
															1.345
														],
														[
															-1.586,
															1.539
														],
														[
															-0.962,
															0.787
														],
														[
															-1.025,
															0.612
														],
														[
															-0.933,
															0.762
														],
														[
															-0.802,
															0.864
														],
														[
															-3.772,
															3.431
														],
														[
															-3.594,
															3.108
														],
														[
															-0.302,
															0.333
														],
														[
															-0.11,
															0.584
														],
														[
															-1.38,
															1.772
														],
														[
															-1.455,
															1.364
														],
														[
															-0.062,
															0.137
														],
														[
															-0.454,
															0.179
														],
														[
															-1.52,
															1.825
														],
														[
															-1.34,
															1.935
														],
														[
															-0.328,
															0.42
														],
														[
															-0.585,
															0.288
														],
														[
															-0.157,
															0.204
														],
														[
															0.066,
															0.389
														],
														[
															-0.07,
															0.154
														],
														[
															-0.451,
															0.168
														],
														[
															-17.335,
															24.118
														],
														[
															-12.112,
															32.668
														],
														[
															-0.142,
															26.346
														],
														[
															4.411,
															21.819
														],
														[
															7.802,
															19.122
														],
														[
															10.06,
															16.043
														],
														[
															3.597,
															4.123
														],
														[
															4.162,
															4.164
														],
														[
															1.972,
															1.69
														],
														[
															1.814,
															1.468
														],
														[
															0.861,
															0.698
														],
														[
															0.823,
															0.907
														],
														[
															5.499,
															4.377
														],
														[
															5.973,
															4.046
														],
														[
															10.538,
															6.459
														],
														[
															11.352,
															5.141
														],
														[
															3.8,
															1.253
														],
														[
															3.806,
															1.257
														],
														[
															1.44,
															0.349
														],
														[
															1.513,
															0.079
														],
														[
															2.492,
															0.555
														],
														[
															2.691,
															0.74
														],
														[
															3.692,
															0.65
														],
														[
															4.38,
															0.501
														],
														[
															1.8,
															1.354
														],
														[
															1.407,
															2.303
														],
														[
															0.62,
															0.171
														],
														[
															0.689,
															-0.082
														],
														[
															2.761,
															0.7
														],
														[
															3.44,
															0.104
														],
														[
															10.824,
															-0.362
														],
														[
															9.303,
															-1.213
														],
														[
															8.918,
															-1.776
														],
														[
															8.154,
															-2.349
														],
														[
															5.706,
															-2.161
														],
														[
															4.904,
															-2.121
														],
														[
															2.348,
															-1.18
														],
														[
															2.374,
															-1.154
														],
														[
															-0.109,
															0.061
														],
														[
															1.614,
															-1.546
														],
														[
															7.029,
															-4.253
														],
														[
															39.826,
															-28.032
														],
														[
															1.357,
															-2.401
														],
														[
															3.909,
															-7.021
														],
														[
															1.706,
															-3.673
														],
														[
															1.097,
															-2.56
														],
														[
															1.485,
															-4.094
														],
														[
															0.977,
															-2.778
														],
														[
															4.468,
															-13.31
														],
														[
															15.102,
															-75.14
														],
														[
															-6.907,
															-15.679
														],
														[
															-0.772,
															-1.131
														],
														[
															-1.344,
															-2.065
														],
														[
															-14.34,
															-21.003
														],
														[
															-3.62,
															-3.257
														],
														[
															-9.661,
															-7.911
														],
														[
															-2.082,
															-1.399
														],
														[
															-2.021,
															-1.274
														],
														[
															-0.787,
															-0.458
														],
														[
															-5.893,
															-3.614
														],
														[
															-2.491,
															-1.213
														],
														[
															-2.416,
															-1.097
														],
														[
															-2.525,
															-1.088
														],
														[
															-2.354,
															-0.927
														],
														[
															-5.156,
															-1.914
														],
														[
															-31.34,
															-10.243
														],
														[
															-0.628,
															0.037
														],
														[
															-12.791,
															0.887
														]
													],
													"v": [
														[
															309,
															30
														],
														[
															254.353,
															44.733
														],
														[
															208,
															66
														],
														[
															205.031,
															67.963
														],
														[
															202,
															70
														],
														[
															198.485,
															71.478
														],
														[
															195,
															73
														],
														[
															194.064,
															73.952
														],
														[
															193,
															75
														],
														[
															182.178,
															81.989
														],
														[
															172,
															89
														],
														[
															167.003,
															93.385
														],
														[
															162,
															98
														],
														[
															158.982,
															100.017
														],
														[
															156,
															102
														],
														[
															153.445,
															104.485
														],
														[
															151,
															107
														],
														[
															139.808,
															116.72
														],
														[
															130,
															126
														],
														[
															129.466,
															127.503
														],
														[
															129,
															129
														],
														[
															124.564,
															133.501
														],
														[
															121,
															138
														],
														[
															120.046,
															138.492
														],
														[
															119,
															139
														],
														[
															114.7,
															144.791
														],
														[
															111,
															150
														],
														[
															109.503,
															150.993
														],
														[
															108,
															152
														],
														[
															107.963,
															152.973
														],
														[
															108,
															154
														],
														[
															107.041,
															154.486
														],
														[
															106,
															155
														],
														[
															60.16,
															240.433
														],
														[
															40,
															350
														],
														[
															46.77,
															421.975
														],
														[
															65,
															482
														],
														[
															91.883,
															534.561
														],
														[
															125,
															579
														],
														[
															136.881,
															591.679
														],
														[
															149,
															603
														],
														[
															154.652,
															607.69
														],
														[
															160,
															612
														],
														[
															162.511,
															614.519
														],
														[
															165,
															617
														],
														[
															182.416,
															629.703
														],
														[
															200,
															641
														],
														[
															232.863,
															658.363
														],
														[
															268,
															672
														],
														[
															279.617,
															675.899
														],
														[
															290,
															679
														],
														[
															294.449,
															679.509
														],
														[
															299,
															680
														],
														[
															306.81,
															682.054
														],
														[
															315,
															684
														],
														[
															327.926,
															685.477
														],
														[
															338,
															688
														],
														[
															342.672,
															694.19
														],
														[
															347,
															699
														],
														[
															348.997,
															699.01
														],
														[
															351,
															699
														],
														[
															360.462,
															700.112
														],
														[
															371,
															700
														],
														[
															400.894,
															697.568
														],
														[
															428,
															693
														],
														[
															453.589,
															686.788
														],
														[
															477,
															679
														],
														[
															492.769,
															672.644
														],
														[
															507,
															666
														],
														[
															514.144,
															662.516
														],
														[
															521,
															659
														],
														[
															522,
															658
														],
														[
															527,
															655
														],
														[
															547,
															642
														],
														[
															643,
															537
														],
														[
															647,
															530
														],
														[
															658,
															509
														],
														[
															663,
															498
														],
														[
															666,
															491
														],
														[
															670,
															479
														],
														[
															673,
															471
														],
														[
															684,
															429
														],
														[
															661,
															221
														],
														[
															637,
															177
														],
														[
															635,
															173
														],
														[
															630,
															167
														],
														[
															581,
															110
														],
														[
															570,
															100
														],
														[
															539,
															78
														],
														[
															533,
															73
														],
														[
															526,
															70
														],
														[
															523,
															68
														],
														[
															506,
															58
														],
														[
															498,
															55
														],
														[
															491,
															51
														],
														[
															483,
															49
														],
														[
															476,
															45
														],
														[
															460,
															40
														],
														[
															347,
															25
														],
														[
															346,
															26
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 57,
											"s": [
												{
													"i": [
														[
															0.652,
															0.029
														],
														[
															5.693,
															-0.829
														],
														[
															5.603,
															-0.935
														],
														[
															5.385,
															-1.16
														],
														[
															4.791,
															-1.412
														],
														[
															9.419,
															-3.695
														],
														[
															7.964,
															-4.169
														],
														[
															3.376,
															-1.956
														],
														[
															3.085,
															-1.391
														],
														[
															0.163,
															-0.451
														],
														[
															0.185,
															-0.124
														],
														[
															0.379,
															0.067
														],
														[
															0.255,
															-0.115
														],
														[
															0.16,
															-0.451
														],
														[
															0.194,
															-0.122
														],
														[
															1.054,
															-0.468
														],
														[
															0.839,
															-0.534
														],
														[
															1.986,
															-1.31
														],
														[
															1.794,
															-1.325
														],
														[
															0.787,
															-0.901
														],
														[
															0.95,
															-0.73
														],
														[
															0.548,
															-0.094
														],
														[
															0.382,
															-0.298
														],
														[
															0.289,
															-0.583
														],
														[
															0.423,
															-0.341
														],
														[
															0.392,
															0.066
														],
														[
															0.235,
															-0.106
														],
														[
															0.76,
															-0.853
														],
														[
															0.416,
															-0.343
														],
														[
															8.873,
															-9.452
														],
														[
															7.008,
															-9.381
														],
														[
															0.874,
															-1.292
														],
														[
															0.614,
															-0.641
														],
														[
															0.298,
															-0.539
														],
														[
															0.407,
															-0.425
														],
														[
															0.298,
															-0.539
														],
														[
															0.407,
															-0.425
														],
														[
															0.298,
															-0.539
														],
														[
															0.407,
															-0.425
														],
														[
															0.779,
															-1.157
														],
														[
															0.772,
															-1.212
														],
														[
															0.679,
															-0.983
														],
														[
															0.626,
															-1.041
														],
														[
															0.695,
															-1.569
														],
														[
															0.484,
															-0.505
														],
														[
															1.293,
															-3.137
														],
														[
															1.469,
															-2.992
														],
														[
															1.24,
															-2.129
														],
														[
															0.951,
															-2.267
														],
														[
															4.831,
															-21.879
														],
														[
															0.127,
															-23.483
														],
														[
															-4.224,
															-21.704
														],
														[
															-7.244,
															-18.435
														],
														[
															-9.906,
															-16.123
														],
														[
															-11.895,
															-13.473
														],
														[
															-33.079,
															-18.793
														],
														[
															-36.058,
															-6.45
														],
														[
															-3.762,
															-2.97
														],
														[
															-1.796,
															-1.691
														],
														[
															-2.518,
															-0.756
														],
														[
															-1.563,
															-0.341
														],
														[
															-13.626,
															1.161
														],
														[
															-29.293,
															15.63
														],
														[
															-2.992,
															1.537
														],
														[
															-1.09,
															0.641
														],
														[
															-1.144,
															1.096
														],
														[
															-2.082,
															0.939
														],
														[
															-0.37,
															0.247
														],
														[
															-0.511,
															0.23
														],
														[
															-0.362,
															0.248
														],
														[
															-0.506,
															0.228
														],
														[
															-0.358,
															0.248
														],
														[
															-1.111,
															0.804
														],
														[
															-12.989,
															13.521
														],
														[
															-1.8,
															2.352
														],
														[
															-0.96,
															1.109
														],
														[
															-1.677,
															2.063
														],
														[
															-0.719,
															0.839
														],
														[
															-0.916,
															1.15
														],
														[
															-1.692,
															2.446
														],
														[
															-0.723,
															0.99
														],
														[
															-1.321,
															1.878
														],
														[
															-0.225,
															0.5
														],
														[
															-0.245,
															0.381
														],
														[
															-0.735,
															1.135
														],
														[
															-6.442,
															13.511
														],
														[
															-1.885,
															4.803
														],
														[
															-2.709,
															8.82
														],
														[
															-2.434,
															11.357
														],
														[
															10.447,
															45.073
														],
														[
															8.35,
															19.911
														],
														[
															0.401,
															1.022
														],
														[
															1.782,
															3.604
														],
														[
															33.148,
															28.225
														],
														[
															9.488,
															6.377
														],
														[
															2.11,
															1.365
														],
														[
															1.18,
															1.131
														],
														[
															4.258,
															2.335
														],
														[
															64.755,
															-3.442
														],
														[
															-0.115,
															0.007
														]
													],
													"o": [
														[
															-5.626,
															-0.252
														],
														[
															-5.693,
															0.829
														],
														[
															-5.668,
															0.947
														],
														[
															-5.385,
															1.16
														],
														[
															-10.359,
															3.053
														],
														[
															-9.419,
															3.695
														],
														[
															-3.411,
															1.785
														],
														[
															-3.376,
															1.956
														],
														[
															-0.162,
															0.073
														],
														[
															-0.163,
															0.451
														],
														[
															-0.23,
															0.154
														],
														[
															-0.379,
															-0.067
														],
														[
															-0.168,
															0.076
														],
														[
															-0.16,
															0.451
														],
														[
															-0.945,
															0.596
														],
														[
															-1.054,
															0.468
														],
														[
															-2.26,
															1.436
														],
														[
															-1.987,
															1.31
														],
														[
															-0.904,
															0.667
														],
														[
															-0.787,
															0.901
														],
														[
															-0.425,
															0.327
														],
														[
															-0.548,
															0.094
														],
														[
															-0.421,
															0.328
														],
														[
															-0.289,
															0.583
														],
														[
															-0.196,
															0.158
														],
														[
															-0.392,
															-0.066
														],
														[
															-0.542,
															0.245
														],
														[
															-0.76,
															0.853
														],
														[
															-9.5,
															7.81
														],
														[
															-8.873,
															9.452
														],
														[
															-0.891,
															1.192
														],
														[
															-0.874,
															1.292
														],
														[
															-0.401,
															0.419
														],
														[
															-0.298,
															0.539
														],
														[
															-0.401,
															0.419
														],
														[
															-0.298,
															0.539
														],
														[
															-0.401,
															0.419
														],
														[
															-0.298,
															0.539
														],
														[
															-1.112,
															1.161
														],
														[
															-0.779,
															1.157
														],
														[
															-0.656,
															1.029
														],
														[
															-0.68,
															0.983
														],
														[
															-0.734,
															1.22
														],
														[
															-0.695,
															1.569
														],
														[
															-2.358,
															2.461
														],
														[
															-1.293,
															3.137
														],
														[
															-1.088,
															2.216
														],
														[
															-1.24,
															2.129
														],
														[
															-7.549,
															18
														],
														[
															-4.831,
															21.879
														],
														[
															-0.139,
															25.748
														],
														[
															4.224,
															21.704
														],
														[
															7.48,
															19.036
														],
														[
															9.906,
															16.123
														],
														[
															24.454,
															27.696
														],
														[
															29.067,
															16.514
														],
														[
															7.223,
															1.292
														],
														[
															1.247,
															0.985
														],
														[
															2.761,
															2.599
														],
														[
															1.528,
															0.459
														],
														[
															11.526,
															2.515
														],
														[
															44.861,
															-3.824
														],
														[
															3.361,
															-1.793
														],
														[
															1.046,
															-0.537
														],
														[
															2.554,
															-1.502
														],
														[
															2.183,
															-2.092
														],
														[
															0.324,
															-0.146
														],
														[
															0.46,
															-0.307
														],
														[
															0.319,
															-0.144
														],
														[
															0.452,
															-0.309
														],
														[
															0.316,
															-0.143
														],
														[
															1.312,
															-0.909
														],
														[
															16.52,
															-11.953
														],
														[
															2.641,
															-2.749
														],
														[
															0.968,
															-1.265
														],
														[
															1.661,
															-1.92
														],
														[
															0.686,
															-0.844
														],
														[
															0.955,
															-1.114
														],
														[
															2.324,
															-2.92
														],
														[
															0.754,
															-1.09
														],
														[
															1.35,
															-1.848
														],
														[
															0.311,
															-0.442
														],
														[
															0.149,
															-0.331
														],
														[
															0.82,
															-1.275
														],
														[
															8.392,
															-12.96
														],
														[
															2.87,
															-6.019
														],
														[
															3.688,
															-9.398
														],
														[
															3.206,
															-10.44
														],
														[
															10.113,
															-47.193
														],
														[
															-5.236,
															-22.59
														],
														[
															-0.31,
															-0.738
														],
														[
															-1.856,
															-4.729
														],
														[
															-20.726,
															-41.913
														],
														[
															-9.054,
															-7.71
														],
														[
															-2.225,
															-1.495
														],
														[
															-2.291,
															-1.482
														],
														[
															-3.783,
															-3.624
														],
														[
															-41.054,
															-22.514
														],
														[
															-0.629,
															0.033
														],
														[
															-0.652,
															0.042
														]
													],
													"v": [
														[
															345,
															26
														],
														[
															327.983,
															27.109
														],
														[
															311,
															30
														],
														[
															294.342,
															33.151
														],
														[
															279,
															37
														],
														[
															249.204,
															47.163
														],
														[
															223,
															59
														],
														[
															212.755,
															64.796
														],
														[
															203,
															70
														],
														[
															202.517,
															70.962
														],
														[
															202,
															72
														],
														[
															201.019,
															72.029
														],
														[
															200,
															72
														],
														[
															199.519,
															72.965
														],
														[
															199,
															74
														],
														[
															195.921,
															75.547
														],
														[
															193,
															77
														],
														[
															186.651,
															81.084
														],
														[
															181,
															85
														],
														[
															178.534,
															87.453
														],
														[
															176,
															90
														],
														[
															174.468,
															90.521
														],
														[
															173,
															91
														],
														[
															172.002,
															92.49
														],
														[
															171,
															94
														],
														[
															170.029,
															94.039
														],
														[
															169,
															94
														],
														[
															166.906,
															95.927
														],
														[
															165,
															98
														],
														[
															137.131,
															124.322
														],
														[
															113,
															153
														],
														[
															110.293,
															156.913
														],
														[
															108,
															160
														],
														[
															107.005,
															161.495
														],
														[
															106,
															163
														],
														[
															105.005,
															164.495
														],
														[
															104,
															166
														],
														[
															103.005,
															167.495
														],
														[
															102,
															169
														],
														[
															99.245,
															172.462
														],
														[
															97,
															176
														],
														[
															94.978,
															178.991
														],
														[
															93,
															182
														],
														[
															90.812,
															186.536
														],
														[
															89,
															190
														],
														[
															83.833,
															198.602
														],
														[
															80,
															208
														],
														[
															76.397,
															214.462
														],
														[
															73,
															221
														],
														[
															53.933,
															281.388
														],
														[
															46,
															350
														],
														[
															52.463,
															420.984
														],
														[
															70,
															481
														],
														[
															96.188,
															533.673
														],
														[
															129,
															578
														],
														[
															215,
															648
														],
														[
															315,
															684
														],
														[
															339,
															688
														],
														[
															342,
															693
														],
														[
															348,
															699
														],
														[
															353,
															699
														],
														[
															392,
															698
														],
														[
															506,
															665
														],
														[
															516,
															660
														],
														[
															519,
															657
														],
														[
															527,
															653
														],
														[
															534,
															649
														],
														[
															535,
															647
														],
														[
															537,
															647
														],
														[
															538,
															645
														],
														[
															540,
															645
														],
														[
															541,
															643
														],
														[
															545,
															641
														],
														[
															590,
															602
														],
														[
															597,
															594
														],
														[
															600,
															591
														],
														[
															604,
															585
														],
														[
															607,
															583
														],
														[
															609,
															579
														],
														[
															616,
															571
														],
														[
															618,
															567
														],
														[
															623,
															562
														],
														[
															623,
															560
														],
														[
															625,
															559
														],
														[
															627,
															555
														],
														[
															650,
															515
														],
														[
															658,
															497
														],
														[
															668,
															470
														],
														[
															677,
															437
														],
														[
															676,
															286
														],
														[
															656,
															222
														],
														[
															654,
															219
														],
														[
															649,
															208
														],
														[
															567,
															101
														],
														[
															537,
															79
														],
														[
															531,
															74
														],
														[
															523,
															70
														],
														[
															511,
															63
														],
														[
															348,
															25
														],
														[
															347,
															26
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 58,
											"s": [
												{
													"i": [
														[
															11.64,
															-2.147
														],
														[
															14.529,
															-5.146
														],
														[
															11.882,
															-6.462
														],
														[
															14.342,
															-11.563
														],
														[
															10.884,
															-12.097
														],
														[
															9.65,
															-15.14
														],
														[
															7.267,
															-16.955
														],
														[
															0.62,
															-1.599
														],
														[
															0.658,
															-1.594
														],
														[
															4.069,
															-20.575
														],
														[
															0.712,
															-22.714
														],
														[
															-2.606,
															-16.957
														],
														[
															-4.169,
															-14.228
														],
														[
															-17.932,
															-27.378
														],
														[
															-24.127,
															-19.863
														],
														[
															-0.838,
															-0.659
														],
														[
															-0.828,
															-0.688
														],
														[
															-1.661,
															-1.23
														],
														[
															-0.962,
															-0.921
														],
														[
															-0.287,
															-0.075
														],
														[
															-0.475,
															-0.341
														],
														[
															-0.75,
															-0.896
														],
														[
															-0.971,
															-0.678
														],
														[
															-1.054,
															-0.449
														],
														[
															-0.897,
															-0.582
														],
														[
															-2.94,
															-2.045
														],
														[
															-3.031,
															-1.735
														],
														[
															-11.236,
															-4.516
														],
														[
															-12.03,
															-3.627
														],
														[
															-1.869,
															-0.76
														],
														[
															-1.319,
															-0.293
														],
														[
															-0.854,
															0.09
														],
														[
															-0.791,
															-0.186
														],
														[
															-2.497,
															-0.738
														],
														[
															-2.618,
															-0.484
														],
														[
															-1.485,
															-0.125
														],
														[
															-1.624,
															-0.234
														],
														[
															-1.659,
															-0.112
														],
														[
															-1.07,
															-0.367
														],
														[
															-1.038,
															-1.173
														],
														[
															-1.459,
															-1.488
														],
														[
															-0.705,
															-1.097
														],
														[
															-0.935,
															-0.34
														],
														[
															-0.701,
															0.096
														],
														[
															-0.606,
															-0.168
														],
														[
															-3.33,
															-0.101
														],
														[
															-3.196,
															0.096
														],
														[
															-21.974,
															6.36
														],
														[
															-16.985,
															8.772
														],
														[
															-1.546,
															0.711
														],
														[
															-0.498,
															0.476
														],
														[
															-0.262,
															0.065
														],
														[
															-0.543,
															0.35
														],
														[
															-0.504,
															0.597
														],
														[
															-0.481,
															0.288
														],
														[
															-1.228,
															0.436
														],
														[
															-0.979,
															0.592
														],
														[
															-2.515,
															1.134
														],
														[
															-0.37,
															0.247
														],
														[
															-0.511,
															0.23
														],
														[
															-0.358,
															0.248
														],
														[
															-3.991,
															1.799
														],
														[
															-0.833,
															0.685
														],
														[
															-9.287,
															10.144
														],
														[
															-1.594,
															1.806
														],
														[
															-1.954,
															4.335
														],
														[
															-0.249,
															0.325
														],
														[
															-2.425,
															3.166
														],
														[
															-0.705,
															1.034
														],
														[
															-0.729,
															1.027
														],
														[
															-1.258,
															1.789
														],
														[
															-0.225,
															0.5
														],
														[
															-0.245,
															0.381
														],
														[
															-0.83,
															1.305
														],
														[
															-7.104,
															15.462
														],
														[
															-1.022,
															2.461
														],
														[
															-1.026,
															2.667
														],
														[
															-0.386,
															0.983
														],
														[
															-1.878,
															6.73
														],
														[
															0,
															39.408
														],
														[
															23.529,
															44.163
														],
														[
															2.6,
															4.409
														],
														[
															0.965,
															1.007
														],
														[
															0.939,
															2.082
														],
														[
															0.247,
															0.37
														],
														[
															0.23,
															0.511
														],
														[
															0.248,
															0.358
														],
														[
															0.227,
															0.503
														],
														[
															0.642,
															0.886
														],
														[
															18.375,
															15.944
														],
														[
															2.353,
															1.06
														],
														[
															0.29,
															0.245
														],
														[
															1.81,
															0.816
														],
														[
															0.346,
															0.249
														],
														[
															3.254,
															1.467
														],
														[
															0.346,
															0.249
														],
														[
															12.725,
															6.219
														],
														[
															7.123,
															2.795
														],
														[
															46.154,
															-2.711
														],
														[
															-0.112,
															0.008
														]
													],
													"o": [
														[
															-16.004,
															2.953
														],
														[
															-14.529,
															5.146
														],
														[
															-17.748,
															9.652
														],
														[
															-14.342,
															11.563
														],
														[
															-12.133,
															13.486
														],
														[
															-9.65,
															15.14
														],
														[
															-0.861,
															2.008
														],
														[
															-0.62,
															1.599
														],
														[
															-7.013,
															16.987
														],
														[
															-4.069,
															20.575
														],
														[
															-0.594,
															18.943
														],
														[
															2.606,
															16.957
														],
														[
															10.145,
															34.624
														],
														[
															17.932,
															27.378
														],
														[
															0.82,
															0.675
														],
														[
															0.838,
															0.659
														],
														[
															1.395,
															1.159
														],
														[
															1.661,
															1.23
														],
														[
															0.376,
															0.361
														],
														[
															0.287,
															0.075
														],
														[
															1.03,
															0.739
														],
														[
															0.75,
															0.896
														],
														[
															0.889,
															0.62
														],
														[
															1.054,
															0.449
														],
														[
															3.209,
															2.084
														],
														[
															2.94,
															2.045
														],
														[
															11.025,
															6.309
														],
														[
															11.236,
															4.516
														],
														[
															2.206,
															0.665
														],
														[
															1.869,
															0.761
														],
														[
															0.793,
															0.176
														],
														[
															0.854,
															-0.091
														],
														[
															2.395,
															0.564
														],
														[
															2.497,
															0.738
														],
														[
															1.438,
															0.266
														],
														[
															1.485,
															0.125
														],
														[
															1.293,
															0.187
														],
														[
															1.659,
															0.112
														],
														[
															2.388,
															0.819
														],
														[
															1.038,
															1.173
														],
														[
															1.245,
															1.27
														],
														[
															0.705,
															1.098
														],
														[
															0.589,
															0.215
														],
														[
															0.701,
															-0.096
														],
														[
															2.485,
															0.691
														],
														[
															3.33,
															0.101
														],
														[
															26.119,
															-0.788
														],
														[
															21.974,
															-6.36
														],
														[
															1.318,
															-0.681
														],
														[
															1.546,
															-0.711
														],
														[
															0.409,
															-0.391
														],
														[
															0.262,
															-0.065
														],
														[
															0.504,
															-0.324
														],
														[
															0.504,
															-0.597
														],
														[
															1.11,
															-0.663
														],
														[
															1.228,
															-0.436
														],
														[
															2.861,
															-1.731
														],
														[
															0.324,
															-0.146
														],
														[
															0.46,
															-0.307
														],
														[
															0.317,
															-0.143
														],
														[
															4.655,
															-3.221
														],
														[
															1.084,
															-0.489
														],
														[
															11.427,
															-9.395
														],
														[
															1.57,
															-1.715
														],
														[
															3.654,
															-4.14
														],
														[
															0.133,
															-0.295
														],
														[
															2.937,
															-3.837
														],
														[
															0.774,
															-1.01
														],
														[
															0.759,
															-1.113
														],
														[
															1.343,
															-1.892
														],
														[
															0.311,
															-0.442
														],
														[
															0.149,
															-0.331
														],
														[
															0.711,
															-1.104
														],
														[
															9.32,
															-14.657
														],
														[
															1.107,
															-2.41
														],
														[
															0.992,
															-2.388
														],
														[
															0.267,
															-0.694
														],
														[
															2.926,
															-7.457
														],
														[
															9.09,
															-32.57
														],
														[
															0,
															-66.43
														],
														[
															-2.462,
															-4.62
														],
														[
															-1.446,
															-2.452
														],
														[
															-2.092,
															-2.183
														],
														[
															-0.146,
															-0.324
														],
														[
															-0.307,
															-0.46
														],
														[
															-0.143,
															-0.317
														],
														[
															-0.31,
															-0.447
														],
														[
															-0.586,
															-1.301
														],
														[
															-14.841,
															-20.485
														],
														[
															-2.507,
															-2.175
														],
														[
															-0.27,
															-0.122
														],
														[
															-1.986,
															-1.68
														],
														[
															-0.309,
															-0.139
														],
														[
															-3.725,
															-2.678
														],
														[
															-0.309,
															-0.139
														],
														[
															-12.102,
															-8.698
														],
														[
															-8.107,
															-3.962
														],
														[
															-33.18,
															-13.02
														],
														[
															-0.628,
															0.037
														],
														[
															-12.634,
															0.876
														]
													],
													"v": [
														[
															311,
															30
														],
														[
															264.909,
															42.368
														],
														[
															225,
															60
														],
														[
															176.852,
															92.166
														],
														[
															139,
															128
														],
														[
															106.35,
															170.898
														],
														[
															81,
															219
														],
														[
															78.848,
															224.31
														],
														[
															77,
															229
														],
														[
															60.275,
															285.705
														],
														[
															53,
															351
														],
														[
															56.428,
															405.037
														],
														[
															67,
															452
														],
														[
															109.513,
															545.07
														],
														[
															173,
															616
														],
														[
															175.494,
															617.99
														],
														[
															178,
															620
														],
														[
															182.825,
															623.679
														],
														[
															187,
															627
														],
														[
															187.926,
															627.515
														],
														[
															189,
															628
														],
														[
															191.544,
															630.546
														],
														[
															194,
															633
														],
														[
															196.994,
															634.529
														],
														[
															200,
															636
														],
														[
															209.133,
															642.262
														],
														[
															218,
															648
														],
														[
															251.246,
															664.012
														],
														[
															286,
															676
														],
														[
															292.165,
															678.279
														],
														[
															297,
															680
														],
														[
															299.502,
															679.993
														],
														[
															302,
															680
														],
														[
															309.333,
															682.06
														],
														[
															317,
															684
														],
														[
															321.361,
															684.524
														],
														[
															326,
															685
														],
														[
															330.667,
															685.365
														],
														[
															335,
															686
														],
														[
															339.697,
															688.998
														],
														[
															343,
															693
														],
														[
															345.733,
															696.697
														],
														[
															348,
															699
														],
														[
															349.987,
															699.034
														],
														[
															352,
															699
														],
														[
															360.967,
															700.091
														],
														[
															371,
															700
														],
														[
															443.351,
															688.488
														],
														[
															502,
															665
														],
														[
															506.616,
															662.847
														],
														[
															510,
															661
														],
														[
															510.899,
															660.469
														],
														[
															512,
															660
														],
														[
															513.516,
															658.473
														],
														[
															515,
															657
														],
														[
															518.598,
															655.447
														],
														[
															522,
															654
														],
														[
															530,
															649
														],
														[
															531,
															647
														],
														[
															533,
															647
														],
														[
															534,
															645
														],
														[
															548,
															636
														],
														[
															552,
															632
														],
														[
															585,
															602
														],
														[
															589,
															596
														],
														[
															599,
															584
														],
														[
															601,
															583
														],
														[
															608,
															574
														],
														[
															610,
															571
														],
														[
															612,
															567
														],
														[
															617,
															562
														],
														[
															617,
															560
														],
														[
															619,
															559
														],
														[
															621,
															555
														],
														[
															646,
															508
														],
														[
															650,
															501
														],
														[
															652,
															493
														],
														[
															654,
															490
														],
														[
															662,
															467
														],
														[
															677,
															361
														],
														[
															636,
															195
														],
														[
															628,
															182
														],
														[
															624,
															174
														],
														[
															620,
															167
														],
														[
															618,
															166
														],
														[
															618,
															164
														],
														[
															616,
															163
														],
														[
															616,
															161
														],
														[
															612,
															157
														],
														[
															563,
															102
														],
														[
															556,
															97
														],
														[
															555,
															95
														],
														[
															550,
															92
														],
														[
															549,
															90
														],
														[
															538,
															83
														],
														[
															537,
															81
														],
														[
															495,
															56
														],
														[
															470,
															45
														],
														[
															348,
															25
														],
														[
															347,
															26
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 59,
											"s": [
												{
													"i": [
														[
															11.527,
															-2.252
														],
														[
															13.601,
															-5.134
														],
														[
															12.023,
															-5.419
														],
														[
															0.153,
															-0.451
														],
														[
															0.21,
															-0.117
														],
														[
															2.672,
															-1.318
														],
														[
															1.703,
															-1.275
														],
														[
															0.491,
															-0.318
														],
														[
															0.524,
															-0.344
														],
														[
															10.48,
															-8.808
														],
														[
															8.687,
															-9.308
														],
														[
															0.591,
															-1.044
														],
														[
															0.808,
															-0.935
														],
														[
															1.52,
															-1.624
														],
														[
															1.348,
															-1.689
														],
														[
															2.646,
															-3.665
														],
														[
															2.429,
															-3.598
														],
														[
															0.714,
															-0.82
														],
														[
															0.572,
															-0.877
														],
														[
															0.412,
															-1.214
														],
														[
															0.689,
															-1.13
														],
														[
															0.389,
															-0.324
														],
														[
															0.255,
															-0.394
														],
														[
															1.221,
															-2.183
														],
														[
															0.876,
															-1.351
														],
														[
															0.788,
															-1.689
														],
														[
															0.82,
															-1.657
														],
														[
															6.693,
															-25.912
														],
														[
															0,
															-29.668
														],
														[
															-4.359,
															-22.566
														],
														[
															-7.562,
															-18.68
														],
														[
															-8.857,
															-14.961
														],
														[
															-10.578,
															-12.884
														],
														[
															-4.242,
															-4.707
														],
														[
															-4.185,
															-3.487
														],
														[
															-1.92,
															-2.079
														],
														[
															-2.076,
															-1.816
														],
														[
															-0.576,
															-0.106
														],
														[
															-0.342,
															-0.266
														],
														[
															-0.289,
															-0.582
														],
														[
															-0.421,
															-0.345
														],
														[
															-1.072,
															-0.656
														],
														[
															-0.865,
															-0.684
														],
														[
															-3.669,
															-2.677
														],
														[
															-3.626,
															-2.371
														],
														[
															-1.356,
															-0.709
														],
														[
															-0.438,
															-0.419
														],
														[
															-0.539,
															-0.298
														],
														[
															-0.425,
															-0.408
														],
														[
															-1.225,
															-0.853
														],
														[
															-1.06,
															-0.591
														],
														[
															-1.203,
															-0.452
														],
														[
															-1.096,
															-0.584
														],
														[
															-3.227,
															-1.499
														],
														[
															-2.873,
															-1.291
														],
														[
															-8.13,
															-2.758
														],
														[
															-9.383,
															-2.329
														],
														[
															-3.975,
															-0.857
														],
														[
															-4.201,
															-0.606
														],
														[
															-1.667,
															-0.111
														],
														[
															-1.052,
															-0.371
														],
														[
															-1.038,
															-1.163
														],
														[
															-1.452,
															-1.502
														],
														[
															-0.626,
															-1.078
														],
														[
															-1.182,
															-0.327
														],
														[
															-0.69,
															0.084
														],
														[
															-0.621,
															-0.166
														],
														[
															-3.291,
															-0.105
														],
														[
															-3.284,
															0.102
														],
														[
															-13.115,
															2.607
														],
														[
															-10.478,
															3.131
														],
														[
															-6.231,
															2.583
														],
														[
															-5.411,
															2.676
														],
														[
															-12.008,
															8.294
														],
														[
															-10.539,
															9.688
														],
														[
															-3.157,
															2.875
														],
														[
															-2.284,
															2.664
														],
														[
															-0.261,
															0.725
														],
														[
															-0.481,
															0.548
														],
														[
															-1.762,
															1.631
														],
														[
															-1.422,
															1.73
														],
														[
															-1.648,
															2.072
														],
														[
															-1.57,
															2.083
														],
														[
															-2.731,
															2.851
														],
														[
															-0.814,
															0.85
														],
														[
															-0.7,
															1.089
														],
														[
															-1.265,
															2.044
														],
														[
															-1.188,
															1.999
														],
														[
															-1.184,
															2.045
														],
														[
															-5.972,
															14.662
														],
														[
															0,
															54.106
														],
														[
															30.341,
															49.011
														],
														[
															6.966,
															8.672
														],
														[
															2.882,
															3.481
														],
														[
															0.69,
															0.865
														],
														[
															1.075,
															1.174
														],
														[
															7.187,
															6.677
														],
														[
															27.493,
															13.109
														],
														[
															53.336,
															-3.133
														],
														[
															-0.112,
															0.008
														]
													],
													"o": [
														[
															-15.575,
															3.043
														],
														[
															-13.601,
															5.134
														],
														[
															-0.177,
															0.079
														],
														[
															-0.153,
															0.451
														],
														[
															-2.609,
															1.455
														],
														[
															-2.672,
															1.318
														],
														[
															-0.512,
															0.383
														],
														[
															-0.491,
															0.318
														],
														[
															-11.392,
															7.459
														],
														[
															-10.48,
															8.808
														],
														[
															-0.829,
															0.888
														],
														[
															-0.59,
															1.044
														],
														[
															-1.57,
															1.817
														],
														[
															-1.52,
															1.624
														],
														[
															-2.985,
															3.74
														],
														[
															-2.646,
															3.666
														],
														[
															-0.571,
															0.844
														],
														[
															-0.714,
															0.82
														],
														[
															-0.662,
															1.016
														],
														[
															-0.412,
															1.214
														],
														[
															-0.189,
															0.31
														],
														[
															-0.389,
															0.324
														],
														[
															-1.242,
															1.917
														],
														[
															-1.221,
															2.183
														],
														[
															-1.029,
															1.589
														],
														[
															-0.788,
															1.689
														],
														[
															-10.228,
															20.683
														],
														[
															-6.693,
															25.912
														],
														[
															0,
															27.058
														],
														[
															4.359,
															22.565
														],
														[
															6.993,
															17.272
														],
														[
															8.857,
															14.961
														],
														[
															3.846,
															4.685
														],
														[
															4.242,
															4.707
														],
														[
															2.244,
															1.87
														],
														[
															1.92,
															2.078
														],
														[
															0.354,
															0.31
														],
														[
															0.576,
															0.106
														],
														[
															0.421,
															0.328
														],
														[
															0.289,
															0.582
														],
														[
															0.846,
															0.693
														],
														[
															1.072,
															0.656
														],
														[
															3.697,
															2.922
														],
														[
															3.669,
															2.677
														],
														[
															1.137,
															0.744
														],
														[
															1.356,
															0.709
														],
														[
															0.419,
															0.401
														],
														[
															0.539,
															0.298
														],
														[
															1.041,
															0.997
														],
														[
															1.225,
															0.853
														],
														[
															1.092,
															0.61
														],
														[
															1.203,
															0.452
														],
														[
															3.218,
															1.714
														],
														[
															3.227,
															1.499
														],
														[
															8.096,
															3.639
														],
														[
															8.13,
															2.758
														],
														[
															3.899,
															0.968
														],
														[
															3.975,
															0.857
														],
														[
															1.281,
															0.185
														],
														[
															1.667,
															0.111
														],
														[
															2.397,
															0.845
														],
														[
															1.038,
															1.163
														],
														[
															1.315,
															1.361
														],
														[
															0.626,
															1.078
														],
														[
															0.62,
															0.171
														],
														[
															0.69,
															-0.084
														],
														[
															2.553,
															0.681
														],
														[
															3.291,
															0.105
														],
														[
															14.062,
															-0.44
														],
														[
															13.115,
															-2.607
														],
														[
															6.666,
															-1.992
														],
														[
															6.231,
															-2.583
														],
														[
															14.428,
															-7.135
														],
														[
															12.008,
															-8.294
														],
														[
															3.087,
															-2.837
														],
														[
															3.157,
															-2.875
														],
														[
															0.475,
															-0.554
														],
														[
															0.261,
															-0.725
														],
														[
															1.531,
															-1.745
														],
														[
															1.762,
															-1.631
														],
														[
															1.583,
															-1.926
														],
														[
															1.517,
															-1.906
														],
														[
															3.015,
															-4
														],
														[
															0.803,
															-0.838
														],
														[
															0.784,
															-0.818
														],
														[
															1.28,
															-1.991
														],
														[
															1.255,
															-2.027
														],
														[
															1.276,
															-2.148
														],
														[
															8.025,
															-13.863
														],
														[
															16.145,
															-39.636
														],
														[
															0,
															-79.665
														],
														[
															-6.235,
															-10.072
														],
														[
															-3.14,
															-3.91
														],
														[
															-0.696,
															-0.841
														],
														[
															-0.878,
															-1.1
														],
														[
															-6.287,
															-6.867
														],
														[
															-21.308,
															-19.797
														],
														[
															-35.81,
															-17.074
														],
														[
															-0.628,
															0.037
														],
														[
															-12.514,
															0.868
														]
													],
													"v": [
														[
															312,
															30
														],
														[
															268.336,
															42.718
														],
														[
															230,
															59
														],
														[
															229.525,
															59.972
														],
														[
															229,
															61
														],
														[
															220.82,
															65.135
														],
														[
															214,
															69
														],
														[
															212.51,
															70.03
														],
														[
															211,
															71
														],
														[
															177.971,
															95.614
														],
														[
															149,
															123
														],
														[
															146.984,
															125.965
														],
														[
															145,
															129
														],
														[
															140.334,
															134.096
														],
														[
															136,
															139
														],
														[
															127.583,
															150.106
														],
														[
															120,
															161
														],
														[
															118.001,
															163.476
														],
														[
															116,
															166
														],
														[
															114.52,
															169.414
														],
														[
															113,
															173
														],
														[
															112.05,
															173.937
														],
														[
															111,
															175
														],
														[
															107.225,
															181.424
														],
														[
															104,
															187
														],
														[
															101.343,
															191.949
														],
														[
															99,
															197
														],
														[
															72.829,
															267.262
														],
														[
															62,
															351
														],
														[
															68.828,
															425.284
														],
														[
															87,
															487
														],
														[
															110.811,
															535.291
														],
														[
															140,
															577
														],
														[
															152.246,
															591.398
														],
														[
															165,
															604
														],
														[
															171.126,
															610.041
														],
														[
															177,
															616
														],
														[
															178.509,
															616.532
														],
														[
															180,
															617
														],
														[
															181,
															618.487
														],
														[
															182,
															620
														],
														[
															184.985,
															622.007
														],
														[
															188,
															624
														],
														[
															199.053,
															632.413
														],
														[
															210,
															640
														],
														[
															214.024,
															642.243
														],
														[
															217,
															644
														],
														[
															218.495,
															644.995
														],
														[
															220,
															646
														],
														[
															223.486,
															648.804
														],
														[
															227,
															651
														],
														[
															230.497,
															652.519
														],
														[
															234,
															654
														],
														[
															243.759,
															658.817
														],
														[
															253,
															663
														],
														[
															277.035,
															672.483
														],
														[
															303,
															680
														],
														[
															314.774,
															682.772
														],
														[
															327,
															685
														],
														[
															331.672,
															685.36
														],
														[
															336,
															686
														],
														[
															340.709,
															689.008
														],
														[
															344,
															693
														],
														[
															346.6,
															696.775
														],
														[
															349,
															699
														],
														[
															350.999,
															699.004
														],
														[
															353,
															699
														],
														[
															361.951,
															700.088
														],
														[
															372,
															700
														],
														[
															413.188,
															695.019
														],
														[
															449,
															686
														],
														[
															468.441,
															679.013
														],
														[
															486,
															671
														],
														[
															525.417,
															647.914
														],
														[
															559,
															621
														],
														[
															568.602,
															612.371
														],
														[
															577,
															604
														],
														[
															577.995,
															601.995
														],
														[
															579,
															600
														],
														[
															584.082,
															594.988
														],
														[
															589,
															590
														],
														[
															593,
															584
														],
														[
															598,
															578
														],
														[
															607,
															565
														],
														[
															609,
															562
														],
														[
															610,
															560
														],
														[
															615,
															554
														],
														[
															618,
															547
														],
														[
															622,
															541
														],
														[
															642,
															499
														],
														[
															668,
															361
														],
														[
															614,
															170
														],
														[
															593,
															140
														],
														[
															584,
															129
														],
														[
															581,
															127
														],
														[
															579,
															123
														],
														[
															558,
															103
														],
														[
															485,
															53
														],
														[
															349,
															25
														],
														[
															348,
															26
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 60,
											"s": [
												{
													"i": [
														[
															0.33,
															-0.001
														],
														[
															5.493,
															-0.637
														],
														[
															5.313,
															-1.106
														],
														[
															5.039,
															-1.416
														],
														[
															4.669,
															-1.567
														],
														[
															14.876,
															-8.197
														],
														[
															12.647,
															-10.14
														],
														[
															10.572,
															-11.623
														],
														[
															8.653,
															-12.647
														],
														[
															3.756,
															-6.501
														],
														[
															3.322,
															-6.842
														],
														[
															2.905,
															-7.17
														],
														[
															2.504,
															-7.485
														],
														[
															0.431,
															-1.163
														],
														[
															0.442,
															-1.174
														],
														[
															0.415,
															-1.174
														],
														[
															0.35,
															-1.163
														],
														[
															2.079,
															-10.813
														],
														[
															1.12,
															-11.375
														],
														[
															0.106,
															-11.625
														],
														[
															-0.963,
															-11.561
														],
														[
															-3.415,
															-15.292
														],
														[
															-4.841,
															-13.825
														],
														[
															-3.821,
															-8.681
														],
														[
															-4.44,
															-7.918
														],
														[
															-1.939,
															-2.878
														],
														[
															-1.525,
															-2.418
														],
														[
															0.067,
															-0.375
														],
														[
															-0.118,
															-0.26
														],
														[
															-0.451,
															-0.163
														],
														[
															-0.124,
															-0.185
														],
														[
															0.067,
															-0.379
														],
														[
															-0.115,
															-0.255
														],
														[
															-0.451,
															-0.163
														],
														[
															-0.124,
															-0.185
														],
														[
															-0.427,
															-1.026
														],
														[
															-0.678,
															-0.981
														],
														[
															-0.226,
															-0.223
														],
														[
															-0.069,
															-0.072
														],
														[
															-0.298,
															-0.539
														],
														[
															-0.407,
															-0.425
														],
														[
															-0.445,
															-0.659
														],
														[
															-0.495,
															-0.608
														],
														[
															-1.188,
															-1.297
														],
														[
															-1.012,
															-1.293
														],
														[
															-0.081,
															-0.521
														],
														[
															-0.337,
															-0.482
														],
														[
															-0.596,
															-0.293
														],
														[
															-0.324,
															-0.412
														],
														[
															-0.081,
															-0.521
														],
														[
															-0.337,
															-0.483
														],
														[
															-0.593,
															-0.297
														],
														[
															-0.338,
															-0.399
														],
														[
															-4.615,
															-4.79
														],
														[
															-5.012,
															-4.504
														],
														[
															-18.1,
															-10.348
														],
														[
															-20.93,
															-6.428
														],
														[
															-6.251,
															-1.51
														],
														[
															-6.651,
															-1.012
														],
														[
															-1.685,
															-0.108
														],
														[
															-0.904,
															-0.361
														],
														[
															-0.592,
															-0.511
														],
														[
															-0.538,
															-0.521
														],
														[
															-1.116,
															-1.915
														],
														[
															-0.539,
															-0.372
														],
														[
															-1.005,
															0.043
														],
														[
															-1.915,
															-0.435
														],
														[
															-6.329,
															0.369
														],
														[
															-6.351,
															0.734
														],
														[
															-23.194,
															10.529
														],
														[
															-17.953,
															14.387
														],
														[
															-6.832,
															6.67
														],
														[
															-5.933,
															7.119
														],
														[
															-5.643,
															7.482
														],
														[
															-3.688,
															8.183
														],
														[
															-0.451,
															0.156
														],
														[
															-0.12,
															0.204
														],
														[
															-0.462,
															1.241
														],
														[
															-0.581,
															1.062
														],
														[
															-0.706,
															0.961
														],
														[
															-0.586,
															1.073
														],
														[
															-2.124,
															4.452
														],
														[
															-2.039,
															4.673
														],
														[
															-3.986,
															12.943
														],
														[
															-2.844,
															14.28
														],
														[
															3.446,
															35.246
														],
														[
															10.226,
															26.829
														],
														[
															0.444,
															1.207
														],
														[
															0.482,
															1.228
														],
														[
															4.183,
															8.481
														],
														[
															4.637,
															7.828
														],
														[
															5.691,
															7.831
														],
														[
															6.129,
															7.054
														],
														[
															19.868,
															14.273
														],
														[
															23.875,
															9.044
														],
														[
															17.924,
															3.224
														],
														[
															19.225,
															-1.23
														],
														[
															0.185,
															-0.246
														],
														[
															-0.054,
															0.004
														],
														[
															0.335,
															0.006
														]
													],
													"o": [
														[
															-5.578,
															0.008
														],
														[
															-5.493,
															0.637
														],
														[
															-5.313,
															1.106
														],
														[
															-5.039,
															1.416
														],
														[
															-17.261,
															5.795
														],
														[
															-14.876,
															8.197
														],
														[
															-12.647,
															10.14
														],
														[
															-10.572,
															11.623
														],
														[
															-4.207,
															6.148
														],
														[
															-3.756,
															6.501
														],
														[
															-3.322,
															6.842
														],
														[
															-2.905,
															7.17
														],
														[
															-0.382,
															1.141
														],
														[
															-0.431,
															1.163
														],
														[
															-0.442,
															1.174
														],
														[
															-0.415,
															1.174
														],
														[
															-2.984,
															9.938
														],
														[
															-2.079,
															10.813
														],
														[
															-1.12,
															11.375
														],
														[
															-0.106,
															11.625
														],
														[
															1.499,
															18.007
														],
														[
															3.415,
															15.292
														],
														[
															3.276,
															9.357
														],
														[
															3.821,
															8.681
														],
														[
															1.721,
															3.07
														],
														[
															1.939,
															2.878
														],
														[
															0.15,
															0.239
														],
														[
															-0.067,
															0.375
														],
														[
															0.073,
															0.162
														],
														[
															0.451,
															0.163
														],
														[
															0.154,
															0.23
														],
														[
															-0.067,
															0.379
														],
														[
															0.073,
															0.161
														],
														[
															0.451,
															0.163
														],
														[
															0.613,
															0.917
														],
														[
															0.427,
															1.026
														],
														[
															0.025,
															0.036
														],
														[
															0.226,
															0.223
														],
														[
															0.401,
															0.419
														],
														[
															0.298,
															0.539
														],
														[
															0.724,
															0.755
														],
														[
															0.445,
															0.659
														],
														[
															1.238,
															1.517
														],
														[
															1.188,
															1.297
														],
														[
															0.339,
															0.433
														],
														[
															0.081,
															0.521
														],
														[
															0.291,
															0.417
														],
														[
															0.596,
															0.293
														],
														[
															0.34,
															0.432
														],
														[
															0.081,
															0.521
														],
														[
															0.29,
															0.415
														],
														[
															0.593,
															0.297
														],
														[
															4.527,
															5.338
														],
														[
															4.615,
															4.79
														],
														[
															14.668,
															13.179
														],
														[
															18.101,
															10.348
														],
														[
															6.345,
															1.948
														],
														[
															6.251,
															1.51
														],
														[
															1.355,
															0.206
														],
														[
															1.685,
															0.108
														],
														[
															1.094,
															0.437
														],
														[
															0.592,
															0.511
														],
														[
															0.999,
															0.966
														],
														[
															1.116,
															1.915
														],
														[
															1.067,
															0.737
														],
														[
															1.005,
															-0.043
														],
														[
															5.331,
															1.208
														],
														[
															6.329,
															-0.369
														],
														[
															30.273,
															-3.499
														],
														[
															23.194,
															-10.529
														],
														[
															7.74,
															-6.202
														],
														[
															6.832,
															-6.67
														],
														[
															5.74,
															-6.889
														],
														[
															5.643,
															-7.482
														],
														[
															0.078,
															-0.173
														],
														[
															0.451,
															-0.156
														],
														[
															0.57,
															-0.975
														],
														[
															0.462,
															-1.241
														],
														[
															0.592,
															-1.084
														],
														[
															0.706,
															-0.961
														],
														[
															2.465,
															-4.518
														],
														[
															2.124,
															-4.452
														],
														[
															5.214,
															-11.947
														],
														[
															3.986,
															-12.943
														],
														[
															7.01,
															-35.188
														],
														[
															-3.446,
															-35.246
														],
														[
															-0.741,
															-1.945
														],
														[
															-0.444,
															-1.207
														],
														[
															-3.629,
															-9.248
														],
														[
															-4.183,
															-8.481
														],
														[
															-5.108,
															-8.623
														],
														[
															-5.691,
															-7.831
														],
														[
															-14.652,
															-16.864
														],
														[
															-19.868,
															-14.273
														],
														[
															-14.078,
															-5.332
														],
														[
															-17.924,
															-3.224
														],
														[
															-0.313,
															0.02
														],
														[
															-0.185,
															0.246
														],
														[
															-0.329,
															0.024
														],
														[
															-0.335,
															-0.006
														]
													],
													"v": [
														[
															347,
															26
														],
														[
															330.37,
															27.007
														],
														[
															314.137,
															29.661
														],
														[
															298.586,
															33.484
														],
														[
															284,
															38
														],
														[
															235.833,
															59.102
														],
														[
															194.588,
															86.722
														],
														[
															159.798,
															119.481
														],
														[
															131,
															156
														],
														[
															119.06,
															174.977
														],
														[
															108.446,
															194.994
														],
														[
															99.109,
															216.015
														],
														[
															91,
															238
														],
														[
															89.771,
															241.458
														],
														[
															88.452,
															244.966
														],
														[
															87.156,
															248.491
														],
														[
															86,
															252
														],
														[
															78.391,
															283.205
														],
														[
															73.58,
															316.565
														],
														[
															71.728,
															351.144
														],
														[
															73,
															386
														],
														[
															80.494,
															435.637
														],
														[
															93,
															479
														],
														[
															103.627,
															506.08
														],
														[
															116,
															531
														],
														[
															121.648,
															539.989
														],
														[
															127,
															548
														],
														[
															127.025,
															548.984
														],
														[
															127,
															550
														],
														[
															127.962,
															550.483
														],
														[
															129,
															551
														],
														[
															129.029,
															551.981
														],
														[
															129,
															553
														],
														[
															129.962,
															553.483
														],
														[
															131,
															554
														],
														[
															132.451,
															556.952
														],
														[
															134,
															560
														],
														[
															134.467,
															560.473
														],
														[
															135,
															561
														],
														[
															135.995,
															562.495
														],
														[
															137,
															564
														],
														[
															138.671,
															566.111
														],
														[
															140,
															568
														],
														[
															143.67,
															572.168
														],
														[
															147,
															576
														],
														[
															147.501,
															577.463
														],
														[
															148,
															579
														],
														[
															149.476,
															580.004
														],
														[
															151,
															581
														],
														[
															151.502,
															582.462
														],
														[
															152,
															584
														],
														[
															153.464,
															585.012
														],
														[
															155,
															586
														],
														[
															168.636,
															601.126
														],
														[
															183,
															615
														],
														[
															232.303,
															650.563
														],
														[
															291,
															676
														],
														[
															309.77,
															681.202
														],
														[
															329,
															685
														],
														[
															333.838,
															685.384
														],
														[
															338,
															686
														],
														[
															340.417,
															687.437
														],
														[
															342,
															689
														],
														[
															345.345,
															693.946
														],
														[
															348,
															698
														],
														[
															350.864,
															698.727
														],
														[
															355,
															699
														],
														[
															372.734,
															699.957
														],
														[
															392,
															698
														],
														[
															471.74,
															676.166
														],
														[
															533,
															638
														],
														[
															554.856,
															618.687
														],
														[
															574,
															598
														],
														[
															591.539,
															576.471
														],
														[
															606,
															553
														],
														[
															606.969,
															552.523
														],
														[
															608,
															552
														],
														[
															609.492,
															548.566
														],
														[
															611,
															545
														],
														[
															613.005,
															541.992
														],
														[
															615,
															539
														],
														[
															621.819,
															525.616
														],
														[
															628,
															512
														],
														[
															641.777,
															474.75
														],
														[
															652,
															434
														],
														[
															656.427,
															326.231
														],
														[
															635,
															231
														],
														[
															633.305,
															226.462
														],
														[
															632,
															223
														],
														[
															620.256,
															196.435
														],
														[
															607,
															172
														],
														[
															590.765,
															147.323
														],
														[
															573,
															125
														],
														[
															520.917,
															77.635
														],
														[
															455,
															42
														],
														[
															406.36,
															28.578
														],
														[
															350,
															25
														],
														[
															349.224,
															25.518
														],
														[
															349,
															26
														],
														[
															348.001,
															26.018
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 61,
											"s": [
												{
													"i": [
														[
															19.197,
															-6.594
														],
														[
															6.148,
															-2.511
														],
														[
															4.536,
															-2.939
														],
														[
															2.84,
															-1.276
														],
														[
															2.245,
															-1.343
														],
														[
															0.801,
															-0.725
														],
														[
															0.954,
															-0.596
														],
														[
															1.795,
															-1.119
														],
														[
															1.664,
															-1.179
														],
														[
															7.559,
															-6.53
														],
														[
															6.447,
															-6.986
														],
														[
															14.65,
															-28.673
														],
														[
															6.81,
															-35.995
														],
														[
															1.142,
															-11.216
														],
														[
															0.392,
															-11.358
														],
														[
															-1.159,
															-11.231
														],
														[
															-1.766,
															-10.436
														],
														[
															-0.947,
															-5.127
														],
														[
															-1.294,
															-5.053
														],
														[
															-3.161,
															-9.031
														],
														[
															-3.678,
															-8.416
														],
														[
															-2.977,
															-6.218
														],
														[
															-3.248,
															-5.619
														],
														[
															-0.736,
															-1.362
														],
														[
															-0.406,
															-0.425
														],
														[
															-0.298,
															-0.539
														],
														[
															-0.407,
															-0.425
														],
														[
															-1.694,
															-2.848
														],
														[
															-1.331,
															-1.631
														],
														[
															-1.341,
															-1.943
														],
														[
															-1.137,
															-1.394
														],
														[
															-0.636,
															-0.804
														],
														[
															-0.596,
															-0.731
														],
														[
															-0.634,
															-0.825
														],
														[
															-0.623,
															-0.666
														],
														[
															-1.116,
															-1.302
														],
														[
															-1.173,
															-1.336
														],
														[
															-4.679,
															-4.446
														],
														[
															-4.762,
															-4.065
														],
														[
															-1.658,
															-1.563
														],
														[
															-1.721,
															-1.342
														],
														[
															-0.521,
															-0.081
														],
														[
															-0.482,
															-0.337
														],
														[
															-0.29,
															-0.6
														],
														[
															-0.423,
															-0.308
														],
														[
															-1.081,
															-0.446
														],
														[
															-0.821,
															-0.596
														],
														[
															-0.79,
															-0.669
														],
														[
															-0.914,
															-0.654
														],
														[
															-1.01,
															-0.666
														],
														[
															-1.031,
															-0.669
														],
														[
															-16.469,
															-6.719
														],
														[
															-18.916,
															-2.896
														],
														[
															-1.612,
															-0.094
														],
														[
															-1.107,
															-0.405
														],
														[
															-0.85,
															-1.038
														],
														[
															-1.716,
															-1.793
														],
														[
															-0.548,
															-1.042
														],
														[
															-1.431,
															-0.396
														],
														[
															-0.69,
															0.084
														],
														[
															-0.622,
															-0.165
														],
														[
															-6.331,
															0.382
														],
														[
															-5.97,
															0.72
														],
														[
															-10.529,
															2.748
														],
														[
															-8.969,
															3.571
														],
														[
															-12.319,
															7.573
														],
														[
															-10.36,
															8.988
														],
														[
															-3.549,
															3.149
														],
														[
															-3.245,
															3.315
														],
														[
															-1.434,
															1.865
														],
														[
															-1.587,
															1.827
														],
														[
															-1.738,
															1.596
														],
														[
															-1.474,
															1.802
														],
														[
															-0.099,
															0.561
														],
														[
															-0.284,
															0.364
														],
														[
															-0.585,
															0.288
														],
														[
															-0.332,
															0.429
														],
														[
															0.066,
															0.389
														],
														[
															-0.108,
															0.24
														],
														[
															-0.452,
															0.168
														],
														[
															-0.125,
															0.173
														],
														[
															-4.217,
															6.43
														],
														[
															-2.854,
															6.332
														],
														[
															-0.451,
															0.153
														],
														[
															-0.116,
															0.212
														],
														[
															-0.439,
															1.176
														],
														[
															-0.642,
															1.197
														],
														[
															-1.675,
															3.33
														],
														[
															-1.542,
															3.408
														],
														[
															-4.665,
															14.981
														],
														[
															-3.047,
															17.168
														],
														[
															-1.275,
															11.88
														],
														[
															0.078,
															12.327
														],
														[
															14.431,
															39.7
														],
														[
															22.973,
															27.531
														],
														[
															24.034,
															16.408
														],
														[
															30.869,
															8.003
														],
														[
															12.061,
															1.49
														],
														[
															12.742,
															-0.816
														],
														[
															-0.109,
															0.008
														]
													],
													"o": [
														[
															-5.87,
															2.017
														],
														[
															-6.148,
															2.511
														],
														[
															-2.396,
															1.552
														],
														[
															-2.84,
															1.276
														],
														[
															-0.844,
															0.505
														],
														[
															-0.801,
															0.725
														],
														[
															-2.154,
															1.344
														],
														[
															-1.795,
															1.119
														],
														[
															-8.319,
															5.894
														],
														[
															-7.559,
															6.53
														],
														[
															-20.59,
															22.31
														],
														[
															-14.65,
															28.674
														],
														[
															-2.04,
															10.78
														],
														[
															-1.142,
															11.216
														],
														[
															-0.403,
															11.64
														],
														[
															1.159,
															11.231
														],
														[
															0.92,
															5.437
														],
														[
															0.947,
															5.127
														],
														[
															2.679,
															10.461
														],
														[
															3.161,
															9.031
														],
														[
															2.844,
															6.507
														],
														[
															2.977,
															6.218
														],
														[
															0.651,
															1.126
														],
														[
															0.736,
															1.362
														],
														[
															0.401,
															0.419
														],
														[
															0.298,
															0.539
														],
														[
															1.894,
															1.977
														],
														[
															1.694,
															2.848
														],
														[
															1.498,
															1.836
														],
														[
															1.341,
															1.943
														],
														[
															0.858,
															1.052
														],
														[
															0.636,
															0.804
														],
														[
															0.843,
															1.033
														],
														[
															0.634,
															0.825
														],
														[
															1.361,
															1.455
														],
														[
															1.116,
															1.302
														],
														[
															4.522,
															5.149
														],
														[
															4.679,
															4.446
														],
														[
															1.647,
															1.407
														],
														[
															1.658,
															1.563
														],
														[
															0.433,
															0.338
														],
														[
															0.521,
															0.081
														],
														[
															0.416,
															0.291
														],
														[
															0.29,
															0.6
														],
														[
															0.855,
															0.621
														],
														[
															1.081,
															0.446
														],
														[
															0.925,
															0.671
														],
														[
															0.79,
															0.668
														],
														[
															0.93,
															0.666
														],
														[
															1.01,
															0.666
														],
														[
															14.209,
															9.227
														],
														[
															16.469,
															6.719
														],
														[
															1.445,
															0.221
														],
														[
															1.612,
															0.093
														],
														[
															2.882,
															1.053
														],
														[
															0.85,
															1.038
														],
														[
															1.376,
															1.437
														],
														[
															0.548,
															1.042
														],
														[
															0.62,
															0.171
														],
														[
															0.69,
															-0.084
														],
														[
															4.704,
															1.247
														],
														[
															6.331,
															-0.382
														],
														[
															11.913,
															-1.437
														],
														[
															10.529,
															-2.748
														],
														[
															14.363,
															-5.718
														],
														[
															12.32,
															-7.573
														],
														[
															3.559,
															-3.088
														],
														[
															3.549,
															-3.149
														],
														[
															1.678,
															-1.714
														],
														[
															1.434,
															-1.865
														],
														[
															1.575,
															-1.812
														],
														[
															1.738,
															-1.596
														],
														[
															0.32,
															-0.391
														],
														[
															0.099,
															-0.561
														],
														[
															0.327,
															-0.42
														],
														[
															0.585,
															-0.288
														],
														[
															0.158,
															-0.204
														],
														[
															-0.066,
															-0.389
														],
														[
															0.07,
															-0.154
														],
														[
															0.451,
															-0.168
														],
														[
															4.276,
															-5.95
														],
														[
															4.217,
															-6.43
														],
														[
															0.08,
															-0.178
														],
														[
															0.451,
															-0.153
														],
														[
															0.602,
															-1.098
														],
														[
															0.439,
															-1.176
														],
														[
															1.757,
															-3.273
														],
														[
															1.675,
															-3.33
														],
														[
															6.292,
															-13.907
														],
														[
															4.665,
															-14.981
														],
														[
															1.979,
															-11.152
														],
														[
															1.275,
															-11.88
														],
														[
															-0.303,
															-47.672
														],
														[
															-14.431,
															-39.7
														],
														[
															-16.995,
															-20.366
														],
														[
															-24.034,
															-16.408
														],
														[
															-11.014,
															-2.855
														],
														[
															-12.061,
															-1.49
														],
														[
															-0.627,
															0.04
														],
														[
															-22.628,
															1.673
														]
													],
													"v": [
														[
															287,
															38
														],
														[
															268.5,
															44.808
														],
														[
															252,
															53
														],
														[
															243.887,
															57.157
														],
														[
															236,
															61
														],
														[
															233.583,
															62.932
														],
														[
															231,
															65
														],
														[
															225.132,
															68.624
														],
														[
															220,
															72
														],
														[
															196.097,
															90.681
														],
														[
															175,
															111
														],
														[
															121.665,
															187.236
														],
														[
															89,
															284
														],
														[
															84.265,
															317.067
														],
														[
															82,
															351
														],
														[
															83.374,
															385.403
														],
														[
															88,
															418
														],
														[
															90.719,
															433.788
														],
														[
															94,
															449
														],
														[
															102.75,
															478.034
														],
														[
															113,
															504
														],
														[
															121.697,
															523.166
														],
														[
															131,
															541
														],
														[
															133.183,
															545.026
														],
														[
															135,
															548
														],
														[
															135.995,
															549.495
														],
														[
															137,
															551
														],
														[
															142.423,
															558.76
														],
														[
															147,
															566
														],
														[
															151.271,
															571.832
														],
														[
															155,
															577
														],
														[
															157.196,
															579.74
														],
														[
															159,
															582
														],
														[
															161.165,
															584.775
														],
														[
															163,
															587
														],
														[
															166.641,
															591.089
														],
														[
															170,
															595
														],
														[
															183.821,
															609.313
														],
														[
															198,
															622
														],
														[
															202.945,
															626.548
														],
														[
															208,
															631
														],
														[
															209.463,
															631.501
														],
														[
															211,
															632
														],
														[
															211.995,
															633.488
														],
														[
															213,
															635
														],
														[
															216.025,
															636.519
														],
														[
															219,
															638
														],
														[
															221.509,
															640.013
														],
														[
															224,
															642
														],
														[
															226.924,
															643.997
														],
														[
															230,
															646
														],
														[
															275.969,
															670.249
														],
														[
															329,
															685
														],
														[
															333.753,
															685.362
														],
														[
															338,
															686
														],
														[
															342.874,
															688.946
														],
														[
															346,
															693
														],
														[
															348.459,
															696.781
														],
														[
															351,
															699
														],
														[
															352.998,
															699.005
														],
														[
															355,
															699
														],
														[
															372.051,
															699.976
														],
														[
															391,
															698
														],
														[
															424.709,
															691.6
														],
														[
															454,
															682
														],
														[
															494.002,
															661.952
														],
														[
															528,
															637
														],
														[
															538.736,
															627.67
														],
														[
															549,
															618
														],
														[
															553.568,
															612.584
														],
														[
															558,
															607
														],
														[
															563.076,
															601.992
														],
														[
															568,
															597
														],
														[
															568.527,
															595.479
														],
														[
															569,
															594
														],
														[
															570.497,
															593.007
														],
														[
															572,
															592
														],
														[
															572.037,
															591.027
														],
														[
															572,
															590
														],
														[
															572.959,
															589.514
														],
														[
															574,
															589
														],
														[
															587.067,
															570.286
														],
														[
															598,
															551
														],
														[
															598.973,
															550.526
														],
														[
															600,
															550
														],
														[
															601.47,
															546.574
														],
														[
															603,
															543
														],
														[
															608.162,
															533.101
														],
														[
															613,
															523
														],
														[
															629.434,
															479.946
														],
														[
															641,
															432
														],
														[
															646.043,
															397.381
														],
														[
															648,
															361
														],
														[
															624.503,
															228.894
														],
														[
															567,
															127
														],
														[
															505.406,
															70.728
														],
														[
															423,
															33
														],
														[
															388.296,
															26.247
														],
														[
															351,
															25
														],
														[
															350,
															26
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 62,
											"s": [
												{
													"i": [
														[
															11.148,
															-2.411
														],
														[
															7.928,
															-2.825
														],
														[
															6.799,
															-2.865
														],
														[
															3.927,
															-2.341
														],
														[
															3.116,
															-1.875
														],
														[
															1.255,
															-0.446
														],
														[
															0.88,
															-0.555
														],
														[
															0.347,
															-0.393
														],
														[
															0.334,
															-0.251
														],
														[
															2.211,
															-1.343
														],
														[
															1.272,
															-1.219
														],
														[
															0.659,
															-0.445
														],
														[
															0.608,
															-0.495
														],
														[
															0.804,
															-0.637
														],
														[
															0.731,
															-0.596
														],
														[
															0.825,
															-0.634
														],
														[
															0.666,
															-0.623
														],
														[
															1.978,
															-1.802
														],
														[
															2.013,
															-1.85
														],
														[
															5.056,
															-5.615
														],
														[
															4.282,
															-5.487
														],
														[
															0.916,
															-0.812
														],
														[
															0.611,
															-0.822
														],
														[
															0.416,
															-1.041
														],
														[
															0.685,
															-0.962
														],
														[
															0.71,
															-0.837
														],
														[
															0.573,
															-0.829
														],
														[
															2.338,
															-3.68
														],
														[
															2.064,
															-3.544
														],
														[
															1.372,
															-2.47
														],
														[
															1.1,
															-1.697
														],
														[
															1.033,
															-2.703
														],
														[
															1.227,
															-2.659
														],
														[
															0.521,
															-0.996
														],
														[
															0.459,
															-1.026
														],
														[
															1.396,
															-3.305
														],
														[
															1.035,
															-2.692
														],
														[
															1.811,
															-5.844
														],
														[
															1.648,
															-6.14
														],
														[
															0.848,
															-3.775
														],
														[
															0.567,
															-3.023
														],
														[
															0.666,
															-3.699
														],
														[
															0.523,
															-3.857
														],
														[
															-0.173,
															-20.213
														],
														[
															-2.866,
															-18.255
														],
														[
															-9.476,
															-23.973
														],
														[
															-12.584,
															-19.378
														],
														[
															-0.463,
															-1.075
														],
														[
															-0.581,
															-0.827
														],
														[
															-0.911,
															-0.775
														],
														[
															-0.701,
															-0.966
														],
														[
															-0.448,
															-1.084
														],
														[
															-0.576,
															-0.791
														],
														[
															-0.376,
															-0.34
														],
														[
															-0.276,
															-0.338
														],
														[
															-1.367,
															-1.725
														],
														[
															-1.094,
															-1.341
														],
														[
															-1.825,
															-1.94
														],
														[
															-1.867,
															-1.99
														],
														[
															-3.007,
															-3.009
														],
														[
															-2.938,
															-2.729
														],
														[
															-1.251,
															-1.035
														],
														[
															-0.811,
															-0.759
														],
														[
															-0.87,
															-0.644
														],
														[
															-0.602,
															-0.563
														],
														[
															-0.87,
															-0.644
														],
														[
															-0.602,
															-0.563
														],
														[
															-0.808,
															-0.61
														],
														[
															-0.784,
															-0.64
														],
														[
															-1.363,
															-0.916
														],
														[
															-0.517,
															-0.495
														],
														[
															-1.129,
															-0.754
														],
														[
															-1.25,
															-0.803
														],
														[
															-1.851,
															-1.191
														],
														[
															-1.639,
															-0.978
														],
														[
															-4.169,
															-2.031
														],
														[
															-3.537,
															-1.619
														],
														[
															-3.314,
															-1.081
														],
														[
															-3.555,
															-1.217
														],
														[
															-1.034,
															-0.595
														],
														[
															-0.965,
															-0.314
														],
														[
															-5.098,
															-1.209
														],
														[
															-4.205,
															-0.73
														],
														[
															-2.56,
															-2.293
														],
														[
															-1.359,
															-0.904
														],
														[
															-4.093,
															-0.915
														],
														[
															-6.767,
															0.449
														],
														[
															-26.771,
															15.699
														],
														[
															-27.06,
															49.61
														],
														[
															-1.899,
															3.99
														],
														[
															-1.065,
															2.429
														],
														[
															-0.952,
															2.219
														],
														[
															-0.931,
															2.251
														],
														[
															-2.663,
															7.919
														],
														[
															-0.781,
															2.547
														],
														[
															0,
															46.336
														],
														[
															43.351,
															55.51
														],
														[
															34.176,
															19.699
														],
														[
															48.576,
															-3.109
														],
														[
															-0.109,
															0.008
														]
													],
													"o": [
														[
															-8.491,
															1.837
														],
														[
															-7.928,
															2.825
														],
														[
															-4.178,
															1.761
														],
														[
															-3.926,
															2.341
														],
														[
															-1.099,
															0.661
														],
														[
															-1.255,
															0.446
														],
														[
															-0.278,
															0.175
														],
														[
															-0.347,
															0.394
														],
														[
															-1.885,
															1.41
														],
														[
															-2.211,
															1.343
														],
														[
															-0.755,
															0.724
														],
														[
															-0.659,
															0.445
														],
														[
															-1.052,
															0.858
														],
														[
															-0.804,
															0.636
														],
														[
															-1.033,
															0.843
														],
														[
															-0.825,
															0.634
														],
														[
															-2.076,
															1.941
														],
														[
															-1.978,
															1.802
														],
														[
															-5.496,
															5.052
														],
														[
															-5.055,
															5.615
														],
														[
															-0.727,
															0.931
														],
														[
															-0.916,
															0.811
														],
														[
															-0.65,
															0.875
														],
														[
															-0.416,
															1.041
														],
														[
															-0.584,
															0.821
														],
														[
															-0.71,
															0.837
														],
														[
															-2.584,
															3.737
														],
														[
															-2.338,
															3.68
														],
														[
															-1.411,
															2.424
														],
														[
															-1.372,
															2.47
														],
														[
															-1.639,
															2.529
														],
														[
															-1.034,
															2.703
														],
														[
															-0.457,
															0.99
														],
														[
															-0.521,
															0.996
														],
														[
															-1.382,
															3.088
														],
														[
															-1.396,
															3.305
														],
														[
															-2.108,
															5.486
														],
														[
															-1.811,
															5.844
														],
														[
															-1.041,
															3.878
														],
														[
															-0.848,
															3.775
														],
														[
															-0.815,
															4.346
														],
														[
															-0.666,
															3.699
														],
														[
															-2.559,
															18.892
														],
														[
															0.173,
															20.213
														],
														[
															4.511,
															28.731
														],
														[
															9.476,
															23.973
														],
														[
															0.567,
															0.872
														],
														[
															0.463,
															1.075
														],
														[
															0.656,
															0.933
														],
														[
															0.911,
															0.775
														],
														[
															0.632,
															0.871
														],
														[
															0.448,
															1.085
														],
														[
															0.219,
															0.302
														],
														[
															0.376,
															0.34
														],
														[
															1.436,
															1.761
														],
														[
															1.367,
															1.725
														],
														[
															1.834,
															2.248
														],
														[
															1.825,
															1.94
														],
														[
															3.034,
															3.236
														],
														[
															3.007,
															3.009
														],
														[
															1.185,
															1.101
														],
														[
															1.251,
															1.035
														],
														[
															0.918,
															0.859
														],
														[
															0.87,
															0.645
														],
														[
															0.918,
															0.859
														],
														[
															0.87,
															0.645
														],
														[
															0.984,
															0.92
														],
														[
															0.808,
															0.61
														],
														[
															1.029,
															0.84
														],
														[
															1.363,
															0.916
														],
														[
															1.233,
															1.182
														],
														[
															1.129,
															0.754
														],
														[
															1.954,
															1.256
														],
														[
															1.852,
															1.191
														],
														[
															3.786,
															2.259
														],
														[
															4.169,
															2.03
														],
														[
															3.19,
															1.461
														],
														[
															3.314,
															1.081
														],
														[
															0.898,
															0.308
														],
														[
															1.034,
															0.595
														],
														[
															4.403,
															1.433
														],
														[
															5.098,
															1.209
														],
														[
															5.717,
															0.992
														],
														[
															2.025,
															1.813
														],
														[
															2.05,
															1.364
														],
														[
															5.471,
															1.224
														],
														[
															42.548,
															-2.82
														],
														[
															51.272,
															-30.067
														],
														[
															2.171,
															-3.981
														],
														[
															1.131,
															-2.376
														],
														[
															0.881,
															-2.009
														],
														[
															0.92,
															-2.144
														],
														[
															3.714,
															-8.983
														],
														[
															0.83,
															-2.467
														],
														[
															11.069,
															-36.109
														],
														[
															0,
															-97.681
														],
														[
															-21.852,
															-27.981
														],
														[
															-30.287,
															-17.457
														],
														[
															-0.627,
															0.04
														],
														[
															-11.402,
															0.843
														]
													],
													"v": [
														[
															317,
															30
														],
														[
															292.231,
															37.228
														],
														[
															270,
															46
														],
														[
															257.703,
															52.414
														],
														[
															247,
															59
														],
														[
															243.336,
															60.579
														],
														[
															240,
															62
														],
														[
															239.042,
															62.944
														],
														[
															238,
															64
														],
														[
															231.541,
															68.144
														],
														[
															226,
															72
														],
														[
															223.889,
															73.671
														],
														[
															222,
															75
														],
														[
															219.26,
															77.196
														],
														[
															217,
															79
														],
														[
															214.225,
															81.165
														],
														[
															212,
															83
														],
														[
															205.953,
															88.569
														],
														[
															200,
															94
														],
														[
															184.089,
															110.174
														],
														[
															170,
															127
														],
														[
															167.413,
															129.582
														],
														[
															165,
															132
														],
														[
															163.526,
															134.935
														],
														[
															162,
															138
														],
														[
															159.992,
															140.494
														],
														[
															158,
															143
														],
														[
															150.61,
															154.144
														],
														[
															144,
															165
														],
														[
															139.766,
															172.545
														],
														[
															136,
															179
														],
														[
															132.191,
															186.903
														],
														[
															129,
															195
														],
														[
															127.501,
															197.973
														],
														[
															126,
															201
														],
														[
															121.739,
															210.797
														],
														[
															118,
															220
														],
														[
															112.155,
															237.009
														],
														[
															107,
															255
														],
														[
															104.145,
															266.641
														],
														[
															102,
															277
														],
														[
															99.781,
															288.866
														],
														[
															98,
															300
														],
														[
															94.431,
															359.478
														],
														[
															99,
															418
														],
														[
															120.445,
															497.014
														],
														[
															154,
															562
														],
														[
															155.489,
															565.034
														],
														[
															157,
															568
														],
														[
															159.466,
															570.475
														],
														[
															162,
															573
														],
														[
															163.542,
															576.06
														],
														[
															165,
															579
														],
														[
															165.958,
															579.973
														],
														[
															167,
															581
														],
														[
															171.257,
															586.315
														],
														[
															175,
															591
														],
														[
															180.476,
															597.193
														],
														[
															186,
															603
														],
														[
															195.073,
															612.38
														],
														[
															204,
															621
														],
														[
															207.78,
															624.256
														],
														[
															211,
															627
														],
														[
															213.737,
															629.222
														],
														[
															216,
															631
														],
														[
															218.737,
															633.222
														],
														[
															221,
															635
														],
														[
															223.65,
															637.21
														],
														[
															226,
															639
														],
														[
															229.884,
															641.758
														],
														[
															233,
															644
														],
														[
															236.488,
															646.784
														],
														[
															240,
															649
														],
														[
															245.736,
															652.708
														],
														[
															251,
															656
														],
														[
															263.187,
															662.48
														],
														[
															275,
															668
														],
														[
															284.726,
															671.683
														],
														[
															295,
															675
														],
														[
															297.95,
															676.495
														],
														[
															301,
															678
														],
														[
															315.649,
															682.028
														],
														[
															330,
															685
														],
														[
															344,
															688
														],
														[
															350,
															698
														],
														[
															357,
															699
														],
														[
															374,
															699
														],
														[
															478,
															668
														],
														[
															590,
															548
														],
														[
															597,
															536
														],
														[
															599,
															529
														],
														[
															603,
															523
														],
														[
															605,
															516
														],
														[
															616,
															488
														],
														[
															618,
															480
														],
														[
															635,
															361
														],
														[
															559,
															128
														],
														[
															476,
															56
														],
														[
															352,
															25
														],
														[
															351,
															26
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 63,
											"s": [
												{
													"i": [
														[
															0.663,
															-0.022
														],
														[
															9.689,
															-2.328
														],
														[
															8.524,
															-3.338
														],
														[
															6.955,
															-3.58
														],
														[
															5.724,
															-3.761
														],
														[
															1.079,
															-0.471
														],
														[
															0.814,
															-0.544
														],
														[
															0.577,
															-0.716
														],
														[
															0.898,
															-0.605
														],
														[
															1.071,
															-0.45
														],
														[
															0.858,
															-0.623
														],
														[
															0.839,
															-0.69
														],
														[
															0.808,
															-0.632
														],
														[
															2.216,
															-2.171
														],
														[
															2.366,
															-2.154
														],
														[
															2.212,
															-1.664
														],
														[
															1.188,
															-1.553
														],
														[
															0.091,
															-0.552
														],
														[
															0.334,
															-0.398
														],
														[
															0.916,
															-0.618
														],
														[
															0.686,
															-0.752
														],
														[
															2.358,
															-2.933
														],
														[
															1.988,
															-2.437
														],
														[
															1.644,
															-2.127
														],
														[
															1.525,
															-2.166
														],
														[
															11.606,
															-36.211
														],
														[
															1.09,
															-45.472
														],
														[
															-0.92,
															-11.016
														],
														[
															-1.596,
															-10.37
														],
														[
															-9.409,
															-24.736
														],
														[
															-12.791,
															-20.35
														],
														[
															-1.196,
															-1.64
														],
														[
															-1.024,
															-1.546
														],
														[
															-0.692,
															-0.807
														],
														[
															-0.635,
															-0.872
														],
														[
															-0.086,
															-0.52
														],
														[
															-0.335,
															-0.479
														],
														[
															-0.597,
															-0.292
														],
														[
															-0.321,
															-0.414
														],
														[
															-0.094,
															-0.55
														],
														[
															-0.296,
															-0.38
														],
														[
															-0.584,
															-0.288
														],
														[
															-0.337,
															-0.427
														],
														[
															-0.096,
															-0.554
														],
														[
															-0.291,
															-0.374
														],
														[
															-0.582,
															-0.289
														],
														[
															-0.344,
															-0.422
														],
														[
															-0.099,
															-0.56
														],
														[
															-0.284,
															-0.365
														],
														[
															-0.579,
															-0.292
														],
														[
															-0.356,
															-0.412
														],
														[
															-1.3,
															-1.726
														],
														[
															-1.445,
															-1.529
														],
														[
															-3.035,
															-2.864
														],
														[
															-3.188,
															-2.715
														],
														[
															-6.773,
															-4.956
														],
														[
															-7.023,
															-3.166
														],
														[
															-0.153,
															-0.451
														],
														[
															-0.21,
															-0.117
														],
														[
															-2.051,
															-0.998
														],
														[
															-1.965,
															-0.988
														],
														[
															-3.111,
															-1.267
														],
														[
															-3.219,
															-1.256
														],
														[
															-14.722,
															-2.299
														],
														[
															-1.462,
															-0.672
														],
														[
															-2.389,
															-3.099
														],
														[
															-0.663,
															-0.76
														],
														[
															-7.099,
															0.287
														],
														[
															-15.306,
															4.502
														],
														[
															-11.055,
															7.163
														],
														[
															-2.648,
															1.715
														],
														[
															-6.169,
															4.778
														],
														[
															-4.371,
															4.08
														],
														[
															-1.735,
															1.58
														],
														[
															-5.955,
															6.593
														],
														[
															-9.312,
															15.345
														],
														[
															-4.257,
															8.467
														],
														[
															-1.955,
															4.248
														],
														[
															-1.923,
															4.676
														],
														[
															-0.808,
															2.103
														],
														[
															-1.719,
															4.844
														],
														[
															-3.152,
															12.97
														],
														[
															-1.877,
															21.722
														],
														[
															18.226,
															50.802
														],
														[
															0.85,
															2.159
														],
														[
															0.962,
															2.315
														],
														[
															0.944,
															2.126
														],
														[
															1.832,
															4.126
														],
														[
															3.535,
															6.169
														],
														[
															8.458,
															11.06
														],
														[
															1.298,
															1.653
														],
														[
															9.686,
															8.939
														],
														[
															1.762,
															1.51
														],
														[
															1.75,
															1.504
														],
														[
															0.966,
															0.675
														],
														[
															0.819,
															0.654
														],
														[
															11.117,
															6.409
														],
														[
															6.743,
															3.008
														],
														[
															35.252,
															-2.431
														],
														[
															-0.106,
															0.008
														]
													],
													"o": [
														[
															-10.721,
															0.352
														],
														[
															-9.689,
															2.328
														],
														[
															-7.456,
															2.92
														],
														[
															-6.955,
															3.58
														],
														[
															-0.87,
															0.572
														],
														[
															-1.079,
															0.471
														],
														[
															-0.795,
															0.532
														],
														[
															-0.577,
															0.716
														],
														[
															-0.858,
															0.578
														],
														[
															-1.071,
															0.45
														],
														[
															-0.838,
															0.608
														],
														[
															-0.839,
															0.69
														],
														[
															-2.768,
															2.162
														],
														[
															-2.217,
															2.171
														],
														[
															-1.966,
															1.79
														],
														[
															-2.212,
															1.664
														],
														[
															-0.301,
															0.394
														],
														[
															-0.091,
															0.552
														],
														[
															-0.651,
															0.778
														],
														[
															-0.916,
															0.617
														],
														[
															-2.58,
															2.829
														],
														[
															-2.358,
															2.933
														],
														[
															-1.897,
															2.326
														],
														[
															-1.644,
															2.127
														],
														[
															-19.486,
															27.684
														],
														[
															-11.606,
															36.211
														],
														[
															-0.277,
															11.566
														],
														[
															0.92,
															11.016
														],
														[
															4.571,
															29.705
														],
														[
															9.409,
															24.736
														],
														[
															1.19,
															1.894
														],
														[
															1.196,
															1.64
														],
														[
															0.597,
															0.902
														],
														[
															0.692,
															0.806
														],
														[
															0.32,
															0.44
														],
														[
															0.086,
															0.52
														],
														[
															0.291,
															0.417
														],
														[
															0.597,
															0.292
														],
														[
															0.326,
															0.42
														],
														[
															0.095,
															0.55
														],
														[
															0.328,
															0.421
														],
														[
															0.584,
															0.288
														],
														[
															0.324,
															0.41
														],
														[
															0.096,
															0.554
														],
														[
															0.328,
															0.421
														],
														[
															0.582,
															0.289
														],
														[
															0.32,
															0.393
														],
														[
															0.099,
															0.561
														],
														[
															0.328,
															0.421
														],
														[
															0.579,
															0.292
														],
														[
															1.355,
															1.566
														],
														[
															1.3,
															1.726
														],
														[
															2.673,
															2.828
														],
														[
															3.035,
															2.864
														],
														[
															5.886,
															5.012
														],
														[
															6.773,
															4.956
														],
														[
															0.177,
															0.08
														],
														[
															0.153,
															0.451
														],
														[
															1.831,
															1.021
														],
														[
															2.051,
															0.998
														],
														[
															3.336,
															1.677
														],
														[
															3.111,
															1.267
														],
														[
															12.826,
															5.005
														],
														[
															2.733,
															0.427
														],
														[
															3.395,
															1.56
														],
														[
															1.154,
															1.497
														],
														[
															3.884,
															4.45
														],
														[
															19.191,
															-0.777
														],
														[
															15.798,
															-4.646
														],
														[
															3.889,
															-2.52
														],
														[
															7.274,
															-4.713
														],
														[
															5.621,
															-4.354
														],
														[
															1.708,
															-1.594
														],
														[
															6.471,
															-5.892
														],
														[
															12.443,
															-13.775
														],
														[
															4.807,
															-7.921
														],
														[
															2.104,
															-4.184
														],
														[
															2.043,
															-4.438
														],
														[
															0.818,
															-1.988
														],
														[
															1.923,
															-5.005
														],
														[
															4.114,
															-11.595
														],
														[
															5.089,
															-20.938
														],
														[
															5.9,
															-68.273
														],
														[
															-0.719,
															-2.005
														],
														[
															-0.95,
															-2.413
														],
														[
															-0.877,
															-2.111
														],
														[
															-2.148,
															-4.84
														],
														[
															-3.201,
															-7.21
														],
														[
															-7.888,
															-13.764
														],
														[
															-1.199,
															-1.568
														],
														[
															-8.32,
															-10.596
														],
														[
															-1.622,
															-1.497
														],
														[
															-1.822,
															-1.561
														],
														[
															-0.839,
															-0.721
														],
														[
															-0.833,
															-0.582
														],
														[
															-10.68,
															-8.535
														],
														[
															-6.251,
															-3.603
														],
														[
															-25.391,
															-11.327
														],
														[
															-0.625,
															0.043
														],
														[
															-0.661,
															0.052
														]
													],
													"v": [
														[
															350,
															26
														],
														[
															319.351,
															30.261
														],
														[
															292,
															39
														],
														[
															270.201,
															48.87
														],
														[
															251,
															60
														],
														[
															247.958,
															61.52
														],
														[
															245,
															63
														],
														[
															243.077,
															64.946
														],
														[
															241,
															67
														],
														[
															238.001,
															68.466
														],
														[
															235,
															70
														],
														[
															232.478,
															71.982
														],
														[
															230,
															74
														],
														[
															222.699,
															80.506
														],
														[
															216,
															87
														],
														[
															209.416,
															92.177
														],
														[
															204,
															97
														],
														[
															203.524,
															98.497
														],
														[
															203,
															100
														],
														[
															200.526,
															102.019
														],
														[
															198,
															104
														],
														[
															190.556,
															112.794
														],
														[
															184,
															121
														],
														[
															178.721,
															127.62
														],
														[
															174,
															134
														],
														[
															126.703,
															229.659
														],
														[
															107,
															352
														],
														[
															108.096,
															385.897
														],
														[
															112,
															418
														],
														[
															133.335,
															499.516
														],
														[
															167,
															567
														],
														[
															170.625,
															572.261
														],
														[
															174,
															577
														],
														[
															175.972,
															579.523
														],
														[
															178,
															582
														],
														[
															178.489,
															583.471
														],
														[
															179,
															585
														],
														[
															180.478,
															586.002
														],
														[
															182,
															587
														],
														[
															182.522,
															588.53
														],
														[
															183,
															590
														],
														[
															184.493,
															590.996
														],
														[
															186,
															592
														],
														[
															186.524,
															593.527
														],
														[
															187,
															595
														],
														[
															188.488,
															596
														],
														[
															190,
															597
														],
														[
															190.527,
															598.521
														],
														[
															191,
															600
														],
														[
															192.479,
															601.007
														],
														[
															194,
															602
														],
														[
															197.932,
															607.028
														],
														[
															202,
															612
														],
														[
															210.614,
															620.585
														],
														[
															220,
															629
														],
														[
															239.147,
															644.385
														],
														[
															260,
															657
														],
														[
															260.475,
															657.972
														],
														[
															261,
															659
														],
														[
															266.899,
															662.024
														],
														[
															273,
															665
														],
														[
															282.587,
															669.316
														],
														[
															292,
															673
														],
														[
															334,
															685
														],
														[
															342,
															686
														],
														[
															348,
															693
														],
														[
															350,
															697
														],
														[
															371,
															699
														],
														[
															420,
															691
														],
														[
															463,
															673
														],
														[
															475,
															666
														],
														[
															495,
															652
														],
														[
															510,
															639
														],
														[
															516,
															635
														],
														[
															534,
															615
														],
														[
															566,
															572
														],
														[
															579,
															547
														],
														[
															586,
															535
														],
														[
															591,
															521
														],
														[
															594,
															515
														],
														[
															599,
															501
														],
														[
															610,
															464
														],
														[
															621,
															399
														],
														[
															597,
															217
														],
														[
															594,
															211
														],
														[
															592,
															203
														],
														[
															589,
															197
														],
														[
															583,
															184
														],
														[
															573,
															165
														],
														[
															547,
															125
														],
														[
															543,
															120
														],
														[
															516,
															90
														],
														[
															511,
															86
														],
														[
															506,
															81
														],
														[
															503,
															80
														],
														[
															501,
															77
														],
														[
															467,
															54
														],
														[
															448,
															44
														],
														[
															353,
															25
														],
														[
															352,
															26
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 64,
											"s": [
												{
													"i": [
														[
															8.372,
															-3.489
														],
														[
															4.382,
															-2.255
														],
														[
															4.158,
															-2.505
														],
														[
															3.821,
															-2.622
														],
														[
															3.374,
															-2.607
														],
														[
															0.425,
															-0.338
														],
														[
															0.421,
															-0.34
														],
														[
															0.411,
															-0.332
														],
														[
															0.394,
															-0.314
														],
														[
															0.433,
															-0.247
														],
														[
															0.431,
															-0.216
														],
														[
															0.408,
															-0.236
														],
														[
															0.362,
															-0.308
														],
														[
															0.318,
															-0.417
														],
														[
															0.315,
															-0.466
														],
														[
															0.34,
															-0.441
														],
														[
															0.391,
															-0.341
														],
														[
															0.261,
															-0.082
														],
														[
															0.289,
															-0.054
														],
														[
															0.258,
															-0.07
														],
														[
															0.169,
															-0.13
														],
														[
															0.169,
															-0.166
														],
														[
															0.18,
															-0.19
														],
														[
															0.171,
															-0.179
														],
														[
															0.142,
															-0.133
														],
														[
															2.113,
															-2.364
														],
														[
															2.115,
															-2.276
														],
														[
															5.198,
															-6.528
														],
														[
															4.361,
															-6.594
														],
														[
															2.363,
															-4.168
														],
														[
															2.091,
															-3.613
														],
														[
															2.226,
															-4.471
														],
														[
															1.81,
															-4.163
														],
														[
															6.048,
															-27.54
														],
														[
															0.785,
															-32.795
														],
														[
															-3.134,
															-20.483
														],
														[
															-4.993,
															-18.026
														],
														[
															-5.167,
															-13.174
														],
														[
															-6.498,
															-10.453
														],
														[
															-1.272,
															-2.298
														],
														[
															-1.306,
															-2.222
														],
														[
															-5.459,
															-7.486
														],
														[
															-6.378,
															-6.911
														],
														[
															-2.781,
															-3.031
														],
														[
															-3.097,
															-2.866
														],
														[
															-17.991,
															-9.966
														],
														[
															-21.97,
															-4.119
														],
														[
															-1.508,
															-0.11
														],
														[
															-0.715,
															-0.324
														],
														[
															-0.724,
															-1.13
														],
														[
															-1.187,
															-1.61
														],
														[
															-0.263,
															-0.684
														],
														[
															-0.357,
															-0.461
														],
														[
															-3.884,
															0.024
														],
														[
															-3.673,
															0.211
														],
														[
															-8.857,
															1.939
														],
														[
															-7.144,
															2.644
														],
														[
															-2.139,
															0.802
														],
														[
															-1.869,
															0.839
														],
														[
															-4.947,
															2.879
														],
														[
															-4.473,
															2.909
														],
														[
															-1.082,
															0.468
														],
														[
															-0.792,
															0.555
														],
														[
															-0.811,
															0.684
														],
														[
															-0.791,
															0.588
														],
														[
															-3.273,
															2.823
														],
														[
															-3.179,
															2.935
														],
														[
															-4.429,
															4.773
														],
														[
															-4.192,
															5.209
														],
														[
															-10.509,
															20.257
														],
														[
															-7.062,
															23.692
														],
														[
															-3.343,
															21.451
														],
														[
															0,
															24.315
														],
														[
															6.957,
															30.663
														],
														[
															11.172,
															24.578
														],
														[
															11.76,
															16.48
														],
														[
															13.594,
															12.681
														],
														[
															2.314,
															1.694
														],
														[
															1.74,
															1.356
														],
														[
															0.289,
															0.582
														],
														[
															0.422,
															0.344
														],
														[
															0.56,
															0.099
														],
														[
															0.365,
															0.284
														],
														[
															0.287,
															0.586
														],
														[
															0.432,
															0.328
														],
														[
															1.097,
															0.459
														],
														[
															0.881,
															0.61
														],
														[
															0.223,
															0.226
														],
														[
															0.072,
															0.069
														],
														[
															0.539,
															0.298
														],
														[
															0.425,
															0.407
														],
														[
															1.171,
															0.803
														],
														[
															1.187,
															0.708
														],
														[
															1.031,
															0.475
														],
														[
															0.974,
															0.562
														],
														[
															6.54,
															3.172
														],
														[
															6.19,
															2.049
														],
														[
															11.647,
															1.469
														],
														[
															10.514,
															-0.822
														],
														[
															9.765,
															-2.171
														]
													],
													"o": [
														[
															-4.496,
															1.873
														],
														[
															-4.382,
															2.255
														],
														[
															-4.158,
															2.505
														],
														[
															-3.821,
															2.622
														],
														[
															-0.422,
															0.326
														],
														[
															-0.425,
															0.338
														],
														[
															-0.421,
															0.34
														],
														[
															-0.411,
															0.332
														],
														[
															-0.412,
															0.329
														],
														[
															-0.433,
															0.247
														],
														[
															-0.431,
															0.216
														],
														[
															-0.408,
															0.236
														],
														[
															-0.348,
															0.295
														],
														[
															-0.318,
															0.417
														],
														[
															-0.315,
															0.466
														],
														[
															-0.34,
															0.441
														],
														[
															-0.175,
															0.153
														],
														[
															-0.261,
															0.082
														],
														[
															-0.289,
															0.054
														],
														[
															-0.258,
															0.07
														],
														[
															-0.138,
															0.106
														],
														[
															-0.169,
															0.166
														],
														[
															-0.18,
															0.19
														],
														[
															-0.171,
															0.179
														],
														[
															-2.431,
															2.269
														],
														[
															-2.113,
															2.364
														],
														[
															-5.846,
															6.293
														],
														[
															-5.198,
															6.528
														],
														[
															-2.458,
															3.717
														],
														[
															-2.363,
															4.168
														],
														[
															-2.287,
															3.951
														],
														[
															-2.225,
															4.471
														],
														[
															-10.023,
															23.046
														],
														[
															-6.048,
															27.54
														],
														[
															-0.528,
															22.041
														],
														[
															3.134,
															20.483
														],
														[
															3.836,
															13.85
														],
														[
															5.167,
															13.174
														],
														[
															1.606,
															2.584
														],
														[
															1.272,
															2.298
														],
														[
															4.787,
															8.145
														],
														[
															5.459,
															7.486
														],
														[
															2.779,
															3.011
														],
														[
															2.781,
															3.031
														],
														[
															14.066,
															13.016
														],
														[
															17.991,
															9.966
														],
														[
															1.251,
															0.235
														],
														[
															1.508,
															0.11
														],
														[
															1.917,
															0.87
														],
														[
															0.724,
															1.13
														],
														[
															0.591,
															0.802
														],
														[
															0.263,
															0.684
														],
														[
															1.792,
															2.308
														],
														[
															3.884,
															-0.024
														],
														[
															10.43,
															-0.598
														],
														[
															8.856,
															-1.939
														],
														[
															2.575,
															-0.953
														],
														[
															2.139,
															-0.802
														],
														[
															5.74,
															-2.574
														],
														[
															4.947,
															-2.879
														],
														[
															0.881,
															-0.573
														],
														[
															1.082,
															-0.468
														],
														[
															0.966,
															-0.678
														],
														[
															0.811,
															-0.684
														],
														[
															3.728,
															-2.772
														],
														[
															3.273,
															-2.823
														],
														[
															5.091,
															-4.698
														],
														[
															4.429,
															-4.773
														],
														[
															13.901,
															-17.278
														],
														[
															10.509,
															-20.257
														],
														[
															5.627,
															-18.88
														],
														[
															3.343,
															-21.451
														],
														[
															0,
															-34.769
														],
														[
															-6.957,
															-30.663
														],
														[
															-8.364,
															-18.4
														],
														[
															-11.76,
															-16.48
														],
														[
															-2.004,
															-1.869
														],
														[
															-2.314,
															-1.694
														],
														[
															-0.422,
															-0.328
														],
														[
															-0.289,
															-0.582
														],
														[
															-0.393,
															-0.321
														],
														[
															-0.56,
															-0.099
														],
														[
															-0.419,
															-0.327
														],
														[
															-0.287,
															-0.586
														],
														[
															-0.731,
															-0.554
														],
														[
															-1.097,
															-0.459
														],
														[
															-0.036,
															-0.026
														],
														[
															-0.223,
															-0.226
														],
														[
															-0.419,
															-0.401
														],
														[
															-0.539,
															-0.298
														],
														[
															-1.127,
															-1.081
														],
														[
															-1.171,
															-0.803
														],
														[
															-0.9,
															-0.537
														],
														[
															-1.031,
															-0.475
														],
														[
															-5.651,
															-3.262
														],
														[
															-6.54,
															-3.172
														],
														[
															-8.899,
															-2.945
														],
														[
															-11.647,
															-1.469
														],
														[
															-10.568,
															0.826
														],
														[
															-9.765,
															2.171
														]
													],
													"v": [
														[
															295,
															39
														],
														[
															281.655,
															45.226
														],
														[
															268.817,
															52.399
														],
														[
															256.821,
															60.123
														],
														[
															246,
															68
														],
														[
															244.728,
															68.999
														],
														[
															243.458,
															70.018
														],
														[
															242.208,
															71.029
														],
														[
															241,
															72
														],
														[
															239.726,
															72.851
														],
														[
															238.425,
															73.533
														],
														[
															237.161,
															74.198
														],
														[
															236,
															75
														],
														[
															235.008,
															76.087
														],
														[
															234.064,
															77.431
														],
														[
															233.088,
															78.809
														],
														[
															232,
															80
														],
														[
															231.332,
															80.342
														],
														[
															230.492,
															80.535
														],
														[
															229.656,
															80.711
														],
														[
															229,
															81
														],
														[
															228.535,
															81.416
														],
														[
															228.006,
															81.959
														],
														[
															227.475,
															82.523
														],
														[
															227,
															83
														],
														[
															220.262,
															89.995
														],
														[
															214,
															97
														],
														[
															197.386,
															116.274
														],
														[
															183,
															136
														],
														[
															175.725,
															148.078
														],
														[
															169,
															160
														],
														[
															162.142,
															172.841
														],
														[
															156,
															186
														],
														[
															131.572,
															261.688
														],
														[
															121,
															352
														],
														[
															125.359,
															416.011
														],
														[
															138,
															474
														],
														[
															151.504,
															515.047
														],
														[
															169,
															551
														],
														[
															173.225,
															558.272
														],
														[
															177,
															565
														],
														[
															192.307,
															588.425
														],
														[
															210,
															610
														],
														[
															218.261,
															619.109
														],
														[
															227,
															628
														],
														[
															275.072,
															663.173
														],
														[
															335,
															685
														],
														[
															339.402,
															685.433
														],
														[
															343,
															686
														],
														[
															346.548,
															688.945
														],
														[
															349,
															693
														],
														[
															350.175,
															695.256
														],
														[
															351,
															697
														],
														[
															360.089,
															699.889
														],
														[
															372,
															699
														],
														[
															400.965,
															695.035
														],
														[
															425,
															688
														],
														[
															432.029,
															685.414
														],
														[
															438,
															683
														],
														[
															453.95,
															674.751
														],
														[
															468,
															666
														],
														[
															471.067,
															664.487
														],
														[
															474,
															663
														],
														[
															476.631,
															660.933
														],
														[
															479,
															659
														],
														[
															489.411,
															650.622
														],
														[
															499,
															642
														],
														[
															513.175,
															627.883
														],
														[
															526,
															613
														],
														[
															562.63,
															556.811
														],
														[
															589,
															491
														],
														[
															602.72,
															430.577
														],
														[
															608,
															362
														],
														[
															596.879,
															263.357
														],
														[
															569,
															180
														],
														[
															538.423,
															127.21
														],
														[
															500,
															83
														],
														[
															493.302,
															77.615
														],
														[
															487,
															73
														],
														[
															486,
															71.512
														],
														[
															485,
															70
														],
														[
															483.479,
															69.473
														],
														[
															482,
															69
														],
														[
															481.009,
															67.5
														],
														[
															480,
															66
														],
														[
															477.113,
															64.542
														],
														[
															474,
															63
														],
														[
															473.527,
															62.533
														],
														[
															473,
															62
														],
														[
															471.505,
															61.004
														],
														[
															470,
															60
														],
														[
															466.545,
															57.221
														],
														[
															463,
															55
														],
														[
															460.055,
															53.519
														],
														[
															457,
															52
														],
														[
															438.404,
															42.09
														],
														[
															419,
															34
														],
														[
															387.212,
															27.175
														],
														[
															353,
															26
														],
														[
															322.353,
															30.503
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 65,
											"s": [
												{
													"i": [
														[
															9.673,
															-5.191
														],
														[
															0.413,
															-0.336
														],
														[
															0.386,
															-0.365
														],
														[
															0.405,
															-0.346
														],
														[
															0.469,
															-0.281
														],
														[
															0.945,
															-0.485
														],
														[
															0.937,
															-0.468
														],
														[
															0.899,
															-0.498
														],
														[
															0.83,
															-0.577
														],
														[
															0.742,
															-0.663
														],
														[
															0.714,
															-0.701
														],
														[
															0.74,
															-0.687
														],
														[
															0.82,
															-0.623
														],
														[
															0.261,
															-0.078
														],
														[
															0.274,
															-0.048
														],
														[
															0.25,
															-0.07
														],
														[
															0.192,
															-0.147
														],
														[
															6.079,
															-6.263
														],
														[
															5.056,
															-5.877
														],
														[
															0.658,
															-0.838
														],
														[
															0.654,
															-0.816
														],
														[
															0.711,
															-0.63
														],
														[
															0.559,
															-0.737
														],
														[
															0.429,
															-1.067
														],
														[
															0.653,
															-0.903
														],
														[
															0.726,
															-0.617
														],
														[
															0.539,
															-0.763
														],
														[
															0.432,
															-1.038
														],
														[
															0.66,
															-0.986
														],
														[
															0.729,
															-0.597
														],
														[
															0.543,
															-0.806
														],
														[
															0.437,
															-1.018
														],
														[
															0.608,
															-0.973
														],
														[
															9.869,
															-35.565
														],
														[
															0.859,
															-43.444
														],
														[
															-2.706,
															-20.285
														],
														[
															-4.616,
															-17.661
														],
														[
															-6.974,
															-16.541
														],
														[
															-8.246,
															-14.243
														],
														[
															-0.801,
															-1.253
														],
														[
															-0.877,
															-1.406
														],
														[
															-1.358,
															-2.312
														],
														[
															-1.218,
															-1.592
														],
														[
															-3.527,
															-4.392
														],
														[
															-3.428,
															-3.903
														],
														[
															-2.853,
															-2.834
														],
														[
															-2.836,
															-2.531
														],
														[
															-1.478,
															-1.327
														],
														[
															-1.487,
															-1.265
														],
														[
															-1.253,
															-0.81
														],
														[
															-0.813,
															-0.761
														],
														[
															-2.728,
															-1.974
														],
														[
															-2.02,
															-1.169
														],
														[
															-1.247,
															-0.82
														],
														[
															-1.448,
															-0.814
														],
														[
															-5.822,
															-2.715
														],
														[
															-6.254,
															-2.07
														],
														[
															-2.219,
															-0.704
														],
														[
															-2.279,
															-0.572
														],
														[
															-3.216,
															-0.569
														],
														[
															-1.481,
															-1.807
														],
														[
															-0.657,
															-1.574
														],
														[
															-0.469,
															-0.604
														],
														[
															-0.658,
															-0.106
														],
														[
															-1.576,
															-0.557
														],
														[
															-5.54,
															0.592
														],
														[
															-5.185,
															0.925
														],
														[
															-4.952,
															1.137
														],
														[
															-4.262,
															1.574
														],
														[
															-8.638,
															4.969
														],
														[
															-6.782,
															5.187
														],
														[
															-4.704,
															4.44
														],
														[
															-4.048,
															4.313
														],
														[
															-2.185,
															2.293
														],
														[
															-2.025,
															2.447
														],
														[
															-4.868,
															7.35
														],
														[
															-4.099,
															7.039
														],
														[
															-2.964,
															5.962
														],
														[
															-2.7,
															6.237
														],
														[
															-6.317,
															30.044
														],
														[
															0,
															35.039
														],
														[
															9.618,
															36.368
														],
														[
															15.529,
															26.826
														],
														[
															1.624,
															2.809
														],
														[
															1.69,
															2.63
														],
														[
															0.701,
															0.802
														],
														[
															0.657,
															0.956
														],
														[
															0.452,
															1.072
														],
														[
															0.64,
															0.913
														],
														[
															0.697,
															0.831
														],
														[
															0.623,
															0.838
														],
														[
															6.703,
															7.208
														],
														[
															6.685,
															5.767
														],
														[
															10.22,
															6.237
														],
														[
															12.424,
															4.55
														],
														[
															10.494,
															1.864
														],
														[
															10.893,
															-0.802
														],
														[
															0.185,
															-0.245
														],
														[
															-0.052,
															0.004
														],
														[
															11.739,
															-3.657
														]
													],
													"o": [
														[
															-0.486,
															0.261
														],
														[
															-0.413,
															0.336
														],
														[
															-0.386,
															0.365
														],
														[
															-0.405,
															0.346
														],
														[
															-0.921,
															0.551
														],
														[
															-0.945,
															0.485
														],
														[
															-0.937,
															0.468
														],
														[
															-0.899,
															0.498
														],
														[
															-0.826,
															0.574
														],
														[
															-0.742,
															0.663
														],
														[
															-0.714,
															0.701
														],
														[
															-0.74,
															0.687
														],
														[
															-0.214,
															0.162
														],
														[
															-0.261,
															0.078
														],
														[
															-0.274,
															0.048
														],
														[
															-0.25,
															0.07
														],
														[
															-6.629,
															5.069
														],
														[
															-6.079,
															6.263
														],
														[
															-0.714,
															0.83
														],
														[
															-0.658,
															0.838
														],
														[
															-0.596,
															0.745
														],
														[
															-0.711,
															0.63
														],
														[
															-0.63,
															0.831
														],
														[
															-0.429,
															1.067
														],
														[
															-0.555,
															0.768
														],
														[
															-0.726,
															0.617
														],
														[
															-0.61,
															0.863
														],
														[
															-0.433,
															1.038
														],
														[
															-0.541,
															0.808
														],
														[
															-0.729,
															0.597
														],
														[
															-0.644,
															0.957
														],
														[
															-0.437,
															1.018
														],
														[
															-17.666,
															28.297
														],
														[
															-9.869,
															35.565
														],
														[
															-0.439,
															22.197
														],
														[
															2.706,
															20.286
														],
														[
															4.86,
															18.593
														],
														[
															6.974,
															16.541
														],
														[
															0.917,
															1.583
														],
														[
															0.801,
															1.253
														],
														[
															1.348,
															2.159
														],
														[
															1.358,
															2.312
														],
														[
															3.463,
															4.529
														],
														[
															3.527,
															4.392
														],
														[
															2.752,
															3.134
														],
														[
															2.853,
															2.834
														],
														[
															1.6,
															1.428
														],
														[
															1.478,
															1.327
														],
														[
															1.175,
															1.001
														],
														[
															1.253,
															0.809
														],
														[
															2.069,
															1.936
														],
														[
															2.728,
															1.974
														],
														[
															1.563,
															0.906
														],
														[
															1.247,
															0.82
														],
														[
															5.456,
															3.068
														],
														[
															5.822,
															2.715
														],
														[
															1.846,
															0.611
														],
														[
															2.219,
															0.704
														],
														[
															3.656,
															0.917
														],
														[
															3.215,
															0.569
														],
														[
															0.901,
															1.099
														],
														[
															0.657,
															1.574
														],
														[
															0.793,
															1.021
														],
														[
															0.658,
															0.106
														],
														[
															3.657,
															1.293
														],
														[
															5.54,
															-0.592
														],
														[
															4.928,
															-0.879
														],
														[
															4.953,
															-1.137
														],
														[
															10.666,
															-3.939
														],
														[
															8.638,
															-4.969
														],
														[
															5.137,
															-3.928
														],
														[
															4.704,
															-4.44
														],
														[
															2.233,
															-2.38
														],
														[
															2.185,
															-2.293
														],
														[
															5.43,
															-6.561
														],
														[
															4.868,
															-7.35
														],
														[
															3.445,
															-5.916
														],
														[
															2.964,
															-5.962
														],
														[
															10.731,
															-24.784
														],
														[
															6.317,
															-30.044
														],
														[
															0,
															-42.701
														],
														[
															-9.618,
															-36.368
														],
														[
															-1.813,
															-3.132
														],
														[
															-1.624,
															-2.809
														],
														[
															-0.538,
															-0.837
														],
														[
															-0.701,
															-0.802
														],
														[
															-0.55,
															-0.8
														],
														[
															-0.452,
															-1.072
														],
														[
															-0.589,
															-0.84
														],
														[
															-0.697,
															-0.831
														],
														[
															-5.502,
															-7.4
														],
														[
															-6.703,
															-7.208
														],
														[
															-8.696,
															-7.502
														],
														[
															-10.22,
															-6.237
														],
														[
															-9.13,
															-3.343
														],
														[
															-10.494,
															-1.864
														],
														[
															-0.312,
															0.023
														],
														[
															-0.185,
															0.245
														],
														[
															-14.37,
															1.18
														],
														[
															-11.739,
															3.657
														]
													],
													"v": [
														[
															283,
															47
														],
														[
															281.661,
															47.908
														],
														[
															280.473,
															48.971
														],
														[
															279.299,
															50.048
														],
														[
															278,
															51
														],
														[
															275.193,
															52.543
														],
														[
															272.363,
															53.961
														],
														[
															269.601,
															55.398
														],
														[
															267,
															57
														],
														[
															264.662,
															58.868
														],
														[
															262.492,
															60.927
														],
														[
															260.326,
															63.022
														],
														[
															258,
															65
														],
														[
															257.278,
															65.348
														],
														[
															256.467,
															65.524
														],
														[
															255.672,
															65.688
														],
														[
															255,
															66
														],
														[
															235.821,
															83.394
														],
														[
															219,
															102
														],
														[
															216.955,
															104.51
														],
														[
															215,
															107
														],
														[
															212.972,
															109.006
														],
														[
															211,
															111
														],
														[
															209.517,
															113.946
														],
														[
															208,
															117
														],
														[
															205.988,
															119.004
														],
														[
															204,
															121
														],
														[
															202.538,
															123.908
														],
														[
															201,
															127
														],
														[
															199.002,
															129.001
														],
														[
															197,
															131
														],
														[
															195.473,
															133.988
														],
														[
															194,
															137
														],
														[
															152.395,
															232.639
														],
														[
															136,
															351
														],
														[
															139.709,
															414.903
														],
														[
															151,
															472
														],
														[
															168.961,
															524.763
														],
														[
															192,
															571
														],
														[
															194.53,
															575.134
														],
														[
															197,
															579
														],
														[
															201.097,
															585.925
														],
														[
															205,
															592
														],
														[
															215.526,
															605.469
														],
														[
															226,
															618
														],
														[
															234.437,
															626.952
														],
														[
															243,
															635
														],
														[
															247.585,
															639.121
														],
														[
															252,
															643
														],
														[
															255.772,
															645.68
														],
														[
															259,
															648
														],
														[
															266.537,
															654.075
														],
														[
															274,
															659
														],
														[
															278.087,
															661.568
														],
														[
															282,
															664
														],
														[
															298.901,
															672.749
														],
														[
															317,
															680
														],
														[
															323.175,
															682.03
														],
														[
															330,
															684
														],
														[
															340.631,
															685.833
														],
														[
															348,
															689
														],
														[
															350.324,
															693.371
														],
														[
															352,
															697
														],
														[
															353.913,
															698.348
														],
														[
															357,
															699
														],
														[
															371.354,
															699.663
														],
														[
															388,
															697
														],
														[
															402.999,
															694.022
														],
														[
															417,
															690
														],
														[
															445.913,
															676.436
														],
														[
															469,
															661
														],
														[
															483.816,
															648.288
														],
														[
															497,
															635
														],
														[
															503.656,
															628.051
														],
														[
															510,
															621
														],
														[
															525.499,
															599.859
														],
														[
															539,
															578
														],
														[
															548.558,
															560.241
														],
														[
															557,
															542
														],
														[
															583.048,
															459.692
														],
														[
															593,
															362
														],
														[
															577.647,
															242.594
														],
														[
															539,
															147
														],
														[
															533.908,
															138.123
														],
														[
															529,
															130
														],
														[
															527.09,
															127.589
														],
														[
															525,
															125
														],
														[
															523.568,
															122.085
														],
														[
															522,
															119
														],
														[
															520.026,
															116.499
														],
														[
															518,
															114
														],
														[
															499.387,
															91.776
														],
														[
															479,
															72
														],
														[
															450.796,
															51.286
														],
														[
															417,
															35
														],
														[
															387.322,
															26.891
														],
														[
															355,
															25
														],
														[
															354.227,
															25.52
														],
														[
															354,
															26
														],
														[
															314.977,
															33.491
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 66,
											"s": [
												{
													"i": [
														[
															9.559,
															-2.812
														],
														[
															5.632,
															-2.581
														],
														[
															4.803,
															-2.713
														],
														[
															1.873,
															-0.961
														],
														[
															1.657,
															-1.113
														],
														[
															0.597,
															-0.718
														],
														[
															0.827,
															-0.603
														],
														[
															0.539,
															-0.093
														],
														[
															0.395,
															-0.302
														],
														[
															1.816,
															-1.748
														],
														[
															1.696,
															-1.448
														],
														[
															0.881,
															-0.432
														],
														[
															0.728,
															-0.635
														],
														[
															0.632,
															-0.663
														],
														[
															0.704,
															-0.676
														],
														[
															4.563,
															-5.296
														],
														[
															3.818,
															-5.083
														],
														[
															0.841,
															-1.16
														],
														[
															0.656,
															-1.054
														],
														[
															0.401,
															-0.343
														],
														[
															0.212,
															-0.328
														],
														[
															0.474,
															-1.08
														],
														[
															0.545,
															-0.814
														],
														[
															0.758,
															-0.641
														],
														[
															0.466,
															-0.686
														],
														[
															0.116,
															-0.544
														],
														[
															0.238,
															-0.382
														],
														[
															0.504,
															-0.855
														],
														[
															0.424,
															-0.683
														],
														[
															0.837,
															-1.308
														],
														[
															0.796,
															-1.39
														],
														[
															6.106,
															-15.767
														],
														[
															4.409,
															-17.685
														],
														[
															2.737,
															-20.29
														],
														[
															0,
															-19.583
														],
														[
															-0.709,
															-10.274
														],
														[
															-1.165,
															-9.826
														],
														[
															-0.932,
															-7.223
														],
														[
															-1.379,
															-6.586
														],
														[
															-0.754,
															-2.151
														],
														[
															-0.518,
															-2.178
														],
														[
															-2.463,
															-8.469
														],
														[
															-2.963,
															-7.94
														],
														[
															-1.174,
															-2.761
														],
														[
															-1.091,
															-2.702
														],
														[
															-0.834,
															-2.014
														],
														[
															-0.832,
															-1.885
														],
														[
															-1.273,
															-2.68
														],
														[
															-0.883,
															-1.959
														],
														[
															-0.451,
															-0.152
														],
														[
															-0.115,
															-0.215
														],
														[
															-0.767,
															-1.87
														],
														[
															-0.955,
															-1.698
														],
														[
															-1.407,
															-2.242
														],
														[
															-1.094,
															-1.76
														],
														[
															-0.4,
															-0.345
														],
														[
															-0.215,
															-0.323
														],
														[
															-8.355,
															-9.592
														],
														[
															-9.356,
															-7.776
														],
														[
															-3.227,
															-2.383
														],
														[
															-3.043,
															-1.936
														],
														[
															-8.943,
															-3.803
														],
														[
															-8.865,
															-2.107
														],
														[
															-1.527,
															-0.09
														],
														[
															-0.657,
															-0.348
														],
														[
															-1.151,
															-1.698
														],
														[
															-0.596,
															-1.257
														],
														[
															-0.553,
															-0.225
														],
														[
															-2.707,
															-0.817
														],
														[
															-5.223,
															0.502
														],
														[
															-5.374,
															1.12
														],
														[
															-6.618,
															2.551
														],
														[
															-4.807,
															2.395
														],
														[
															-2.013,
															0.963
														],
														[
															-1.799,
															1.077
														],
														[
															-2.493,
															1.912
														],
														[
															-2.149,
															1.631
														],
														[
															-0.521,
															0.083
														],
														[
															-0.481,
															0.336
														],
														[
															-0.294,
															0.595
														],
														[
															-0.406,
															0.331
														],
														[
															-0.867,
															0.435
														],
														[
															-0.727,
															0.606
														],
														[
															-2.104,
															2.205
														],
														[
															-2.159,
															2.159
														],
														[
															-7.451,
															9.989
														],
														[
															-6.273,
															11.121
														],
														[
															-9.285,
															37.171
														],
														[
															0.099,
															45.176
														],
														[
															0.691,
															10.732
														],
														[
															1.305,
															10.639
														],
														[
															0.69,
															4.526
														],
														[
															6.971,
															22.28
														],
														[
															2.232,
															5.87
														],
														[
															1.518,
															4.011
														],
														[
															2.88,
															6.124
														],
														[
															4.305,
															7.448
														],
														[
															48.51,
															19.377
														],
														[
															21.038,
															-1.547
														],
														[
															-0.103,
															0.008
														]
													],
													"o": [
														[
															-6.669,
															1.962
														],
														[
															-5.632,
															2.581
														],
														[
															-1.85,
															1.044
														],
														[
															-1.873,
															0.961
														],
														[
															-0.785,
															0.527
														],
														[
															-0.597,
															0.718
														],
														[
															-0.449,
															0.328
														],
														[
															-0.539,
															0.093
														],
														[
															-2.041,
															1.561
														],
														[
															-1.816,
															1.748
														],
														[
															-0.748,
															0.638
														],
														[
															-0.881,
															0.432
														],
														[
															-0.769,
															0.671
														],
														[
															-0.632,
															0.663
														],
														[
															-4.928,
															4.735
														],
														[
															-4.563,
															5.296
														],
														[
															-0.981,
															1.306
														],
														[
															-0.841,
															1.16
														],
														[
															-0.186,
															0.299
														],
														[
															-0.401,
															0.343
														],
														[
															-0.56,
															0.867
														],
														[
															-0.474,
															1.08
														],
														[
															-0.502,
															0.751
														],
														[
															-0.758,
															0.641
														],
														[
															-0.299,
															0.441
														],
														[
															-0.116,
															0.544
														],
														[
															-0.558,
															0.898
														],
														[
															-0.504,
															0.855
														],
														[
															-0.856,
															1.377
														],
														[
															-0.837,
															1.308
														],
														[
															-8.166,
															14.248
														],
														[
															-6.107,
															15.767
														],
														[
															-4.053,
															16.257
														],
														[
															-2.737,
															20.29
														],
														[
															0,
															11.078
														],
														[
															0.709,
															10.274
														],
														[
															0.892,
															7.523
														],
														[
															0.932,
															7.223
														],
														[
															0.464,
															2.217
														],
														[
															0.754,
															2.151
														],
														[
															2.185,
															9.183
														],
														[
															2.463,
															8.469
														],
														[
															1.214,
															3.253
														],
														[
															1.174,
															2.761
														],
														[
															0.831,
															2.057
														],
														[
															0.834,
															2.014
														],
														[
															1.025,
															2.321
														],
														[
															1.273,
															2.68
														],
														[
															0.081,
															0.179
														],
														[
															0.451,
															0.152
														],
														[
															0.978,
															1.821
														],
														[
															0.767,
															1.87
														],
														[
															1.279,
															2.274
														],
														[
															1.407,
															2.241
														],
														[
															0.185,
															0.298
														],
														[
															0.4,
															0.345
														],
														[
															7.224,
															10.857
														],
														[
															8.355,
															9.592
														],
														[
															3.047,
															2.533
														],
														[
															3.227,
															2.383
														],
														[
															7.361,
															4.681
														],
														[
															8.943,
															3.803
														],
														[
															1.236,
															0.293
														],
														[
															1.527,
															0.09
														],
														[
															1.799,
															0.952
														],
														[
															1.151,
															1.698
														],
														[
															1.081,
															2.283
														],
														[
															0.553,
															0.225
														],
														[
															3.736,
															1.127
														],
														[
															5.223,
															-0.502
														],
														[
															6.721,
															-1.4
														],
														[
															6.618,
															-2.551
														],
														[
															2.149,
															-1.071
														],
														[
															2.013,
															-0.963
														],
														[
															2.878,
															-1.722
														],
														[
															2.493,
															-1.912
														],
														[
															0.436,
															-0.331
														],
														[
															0.521,
															-0.083
														],
														[
															0.417,
															-0.291
														],
														[
															0.294,
															-0.595
														],
														[
															0.805,
															-0.654
														],
														[
															0.867,
															-0.435
														],
														[
															2.425,
															-2.022
														],
														[
															2.104,
															-2.205
														],
														[
															8.922,
															-8.922
														],
														[
															7.451,
															-9.989
														],
														[
															16.91,
															-29.98
														],
														[
															9.241,
															-36.996
														],
														[
															-0.023,
															-10.652
														],
														[
															-0.706,
															-10.97
														],
														[
															-0.573,
															-4.666
														],
														[
															-4.014,
															-26.316
														],
														[
															-2.072,
															-6.623
														],
														[
															-1.618,
															-4.256
														],
														[
															-2.857,
															-7.552
														],
														[
															-3.602,
															-7.659
														],
														[
															-24.081,
															-41.659
														],
														[
															-17.299,
															-6.91
														],
														[
															-0.624,
															0.046
														],
														[
															-10.429,
															0.856
														]
													],
													"v": [
														[
															326,
															31
														],
														[
															307.6,
															37.936
														],
														[
															292,
															46
														],
														[
															286.356,
															48.949
														],
														[
															281,
															52
														],
														[
															279.032,
															53.943
														],
														[
															277,
															56
														],
														[
															275.46,
															56.519
														],
														[
															274,
															57
														],
														[
															268.242,
															62.084
														],
														[
															263,
															67
														],
														[
															260.486,
															68.503
														],
														[
															258,
															70
														],
														[
															255.951,
															71.996
														],
														[
															254,
															74
														],
														[
															239.667,
															89.239
														],
														[
															227,
															105
														],
														[
															224.256,
															108.689
														],
														[
															222,
															112
														],
														[
															221.019,
															112.979
														],
														[
															220,
															114
														],
														[
															218.489,
															117.04
														],
														[
															217,
															120
														],
														[
															214.972,
															122.048
														],
														[
															213,
															124
														],
														[
															212.454,
															125.544
														],
														[
															212,
															127
														],
														[
															210.399,
															129.662
														],
														[
															209,
															132
														],
														[
															206.455,
															135.991
														],
														[
															204,
															140
														],
														[
															182.682,
															184.922
														],
														[
															167,
															235
														],
														[
															156.461,
															291.005
														],
														[
															152,
															352
														],
														[
															153.127,
															383.939
														],
														[
															156,
															414
														],
														[
															158.634,
															436.203
														],
														[
															162,
															457
														],
														[
															163.96,
															463.53
														],
														[
															166,
															470
														],
														[
															172.916,
															496.432
														],
														[
															181,
															521
														],
														[
															184.591,
															529.912
														],
														[
															188,
															538
														],
														[
															190.498,
															544.129
														],
														[
															193,
															550
														],
														[
															196.607,
															557.771
														],
														[
															200,
															565
														],
														[
															200.974,
															565.473
														],
														[
															202,
															566
														],
														[
															204.518,
															571.591
														],
														[
															207,
															577
														],
														[
															211.139,
															583.886
														],
														[
															215,
															590
														],
														[
															215.978,
															590.981
														],
														[
															217,
															592
														],
														[
															240.401,
															622.811
														],
														[
															267,
															649
														],
														[
															276.503,
															656.448
														],
														[
															286,
															663
														],
														[
															310.873,
															675.931
														],
														[
															338,
															685
														],
														[
															342.434,
															685.459
														],
														[
															346,
															686
														],
														[
															350.403,
															690.271
														],
														[
															353,
															695
														],
														[
															354.781,
															698.1
														],
														[
															359,
															699
														],
														[
															372.771,
															699.685
														],
														[
															389,
															697
														],
														[
															409.435,
															690.746
														],
														[
															427,
															683
														],
														[
															433.263,
															680.004
														],
														[
															439,
															677
														],
														[
															447.047,
															671.432
														],
														[
															454,
															666
														],
														[
															455.466,
															665.504
														],
														[
															457,
															665
														],
														[
															458.007,
															663.53
														],
														[
															459,
															662
														],
														[
															461.558,
															660.464
														],
														[
															464,
															659
														],
														[
															470.7,
															652.603
														],
														[
															477,
															646
														],
														[
															501.487,
															617.65
														],
														[
															522,
															586
														],
														[
															561,
															486
														],
														[
															577,
															362
														],
														[
															575,
															330
														],
														[
															573,
															297
														],
														[
															570,
															283
														],
														[
															554,
															211
														],
														[
															547,
															192
														],
														[
															542,
															180
														],
														[
															534,
															161
														],
														[
															522,
															138
														],
														[
															415,
															36
														],
														[
															356,
															25
														],
														[
															355,
															26
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 67,
											"s": [
												{
													"i": [
														[
															0.661,
															-0.02
														],
														[
															8.545,
															-2.848
														],
														[
															6.124,
															-3.345
														],
														[
															1.237,
															-0.954
														],
														[
															0.823,
															-0.512
														],
														[
															0.508,
															-0.097
														],
														[
															0.502,
															-0.325
														],
														[
															0.658,
															-0.774
														],
														[
															0.658,
															-0.447
														],
														[
															0.544,
															-0.116
														],
														[
															0.382,
															-0.237
														],
														[
															0.351,
															-0.398
														],
														[
															0.303,
															-0.228
														],
														[
															7.735,
															-8.12
														],
														[
															6.631,
															-9.421
														],
														[
															9.392,
															-22.372
														],
														[
															5.989,
															-26.416
														],
														[
															2.294,
															-19.267
														],
														[
															0,
															-21.063
														],
														[
															-4.529,
															-27.696
														],
														[
															-7.886,
															-23.489
														],
														[
															-1.889,
															-4.894
														],
														[
															-1.698,
															-4.225
														],
														[
															-0.845,
															-1.774
														],
														[
															-0.713,
															-1.65
														],
														[
															-0.289,
															-1.034
														],
														[
															-0.439,
															-0.922
														],
														[
															-1.641,
															-2.544
														],
														[
															-1.178,
															-2.182
														],
														[
															-0.738,
															-1.843
														],
														[
															-0.976,
															-1.643
														],
														[
															-0.784,
															-0.643
														],
														[
															-0.447,
															-0.725
														],
														[
															-0.596,
															-1.348
														],
														[
															-0.672,
															-1.081
														],
														[
															-0.399,
															-0.346
														],
														[
															-0.22,
															-0.317
														],
														[
															-8.116,
															-8.852
														],
														[
															-9.714,
															-7.296
														],
														[
															-2.083,
															-1.382
														],
														[
															-1.655,
															-0.958
														],
														[
															-0.788,
															-0.483
														],
														[
															-0.755,
															-0.437
														],
														[
															-6.273,
															-2.57
														],
														[
															-6.353,
															-1.502
														],
														[
															-1.306,
															-0.086
														],
														[
															-0.673,
															-0.394
														],
														[
															-1.002,
															-2.167
														],
														[
															-1.036,
															-1.187
														],
														[
															-0.517,
															-0.077
														],
														[
															-2.01,
															-0.635
														],
														[
															-4.903,
															0.761
														],
														[
															-4.663,
															1.131
														],
														[
															-3.06,
															0.975
														],
														[
															-2.828,
															1.146
														],
														[
															-2.945,
															1.384
														],
														[
															-2.38,
															1.311
														],
														[
															-2.209,
															1.394
														],
														[
															-1.819,
															1.131
														],
														[
															-0.348,
															0.399
														],
														[
															-0.314,
															0.222
														],
														[
															-2.21,
															1.619
														],
														[
															-1.275,
															1.192
														],
														[
															-3.192,
															3.147
														],
														[
															-2.971,
															3.365
														],
														[
															-12.42,
															26.88
														],
														[
															-7.373,
															32.023
														],
														[
															-2.424,
															20.265
														],
														[
															0,
															21.254
														],
														[
															5.886,
															31.832
														],
														[
															9.456,
															24.589
														],
														[
															3.973,
															8.239
														],
														[
															3.933,
															6.794
														],
														[
															0.831,
															1.286
														],
														[
															0.746,
															1.248
														],
														[
															0.949,
															1.878
														],
														[
															1.144,
															1.71
														],
														[
															0.734,
															0.613
														],
														[
															0.528,
															0.747
														],
														[
															0.418,
															1.04
														],
														[
															0.665,
															0.9
														],
														[
															1.399,
															1.476
														],
														[
															1.276,
															1.573
														],
														[
															0.784,
															1.209
														],
														[
															0.812,
															0.868
														],
														[
															1.796,
															1.763
														],
														[
															1.88,
															1.88
														],
														[
															1.251,
															1.54
														],
														[
															1.442,
															1.287
														],
														[
															0.902,
															0.455
														],
														[
															0.787,
															0.64
														],
														[
															0.621,
															0.697
														],
														[
															0.743,
															0.582
														],
														[
															4,
															2.558
														],
														[
															3.512,
															2.034
														],
														[
															2.248,
															1.132
														],
														[
															2.601,
															1.079
														],
														[
															5.716,
															1.283
														],
														[
															0.527,
															0.129
														],
														[
															8.059,
															-0.741
														]
													],
													"o": [
														[
															-8.697,
															0.261
														],
														[
															-8.545,
															2.848
														],
														[
															-1.229,
															0.672
														],
														[
															-1.237,
															0.954
														],
														[
															-0.464,
															0.288
														],
														[
															-0.508,
															0.097
														],
														[
															-0.709,
															0.459
														],
														[
															-0.658,
															0.774
														],
														[
															-0.441,
															0.299
														],
														[
															-0.544,
															0.116
														],
														[
															-0.292,
															0.181
														],
														[
															-0.351,
															0.398
														],
														[
															-9.429,
															7.098
														],
														[
															-7.735,
															8.12
														],
														[
															-13.442,
															19.097
														],
														[
															-9.392,
															22.372
														],
														[
															-3.825,
															16.869
														],
														[
															-2.294,
															19.267
														],
														[
															0,
															31.727
														],
														[
															4.529,
															27.696
														],
														[
															1.745,
															5.197
														],
														[
															1.889,
															4.894
														],
														[
															0.906,
															2.253
														],
														[
															0.845,
															1.774
														],
														[
															0.406,
															0.94
														],
														[
															0.289,
															1.034
														],
														[
															1.257,
															2.64
														],
														[
															1.641,
															2.544
														],
														[
															1.072,
															1.985
														],
														[
															0.738,
															1.843
														],
														[
															0.418,
															0.704
														],
														[
															0.784,
															0.643
														],
														[
															0.942,
															1.529
														],
														[
															0.596,
															1.347
														],
														[
															0.185,
															0.296
														],
														[
															0.399,
															0.347
														],
														[
															7.82,
															11.295
														],
														[
															8.116,
															8.852
														],
														[
															2.014,
															1.513
														],
														[
															2.083,
															1.382
														],
														[
															1.093,
															0.633
														],
														[
															0.788,
															0.483
														],
														[
															5.556,
															3.216
														],
														[
															6.273,
															2.571
														],
														[
															1.102,
															0.26
														],
														[
															1.306,
															0.086
														],
														[
															1.954,
															1.146
														],
														[
															1.002,
															2.167
														],
														[
															0.921,
															1.055
														],
														[
															0.517,
															0.078
														],
														[
															3.726,
															1.177
														],
														[
															4.903,
															-0.761
														],
														[
															3.93,
															-0.953
														],
														[
															3.06,
															-0.975
														],
														[
															2.842,
															-1.151
														],
														[
															2.945,
															-1.384
														],
														[
															2.344,
															-1.292
														],
														[
															2.209,
															-1.394
														],
														[
															0.296,
															-0.183
														],
														[
															0.348,
															-0.399
														],
														[
															1.884,
															-1.331
														],
														[
															2.21,
															-1.619
														],
														[
															3.259,
															-3.048
														],
														[
															3.192,
															-3.147
														],
														[
															18.946,
															-21.457
														],
														[
															12.42,
															-26.88
														],
														[
															4.303,
															-18.685
														],
														[
															2.424,
															-20.265
														],
														[
															0,
															-33.084
														],
														[
															-5.886,
															-31.832
														],
														[
															-3.173,
															-8.25
														],
														[
															-3.973,
															-8.239
														],
														[
															-0.931,
															-1.608
														],
														[
															-0.831,
															-1.286
														],
														[
															-1.062,
															-1.776
														],
														[
															-0.948,
															-1.879
														],
														[
															-0.536,
															-0.802
														],
														[
															-0.734,
															-0.613
														],
														[
															-0.664,
															-0.94
														],
														[
															-0.418,
															-1.04
														],
														[
															-1.126,
															-1.523
														],
														[
															-1.399,
															-1.476
														],
														[
															-1.05,
															-1.294
														],
														[
															-0.784,
															-1.209
														],
														[
															-1.935,
															-2.069
														],
														[
															-1.796,
															-1.763
														],
														[
															-1.554,
															-1.554
														],
														[
															-1.251,
															-1.54
														],
														[
															-0.606,
															-0.541
														],
														[
															-0.902,
															-0.455
														],
														[
															-0.775,
															-0.63
														],
														[
															-0.621,
															-0.697
														],
														[
															-3.489,
															-2.736
														],
														[
															-4,
															-2.558
														],
														[
															-2.405,
															-1.393
														],
														[
															-2.248,
															-1.132
														],
														[
															-5.075,
															-2.105
														],
														[
															-0.372,
															-0.083
														],
														[
															-9.833,
															-2.41
														],
														[
															-0.658,
															0.061
														]
													],
													"v": [
														[
															354,
															26
														],
														[
															327.57,
															31.187
														],
														[
															305,
															41
														],
														[
															301.196,
															43.62
														],
														[
															298,
															46
														],
														[
															296.528,
															46.473
														],
														[
															295,
															47
														],
														[
															292.962,
															49.009
														],
														[
															291,
															51
														],
														[
															289.456,
															51.546
														],
														[
															288,
															52
														],
														[
															287.009,
															52.965
														],
														[
															286,
															54
														],
														[
															260.401,
															76.758
														],
														[
															239,
															103
														],
														[
															204.911,
															165.011
														],
														[
															182,
															238
														],
														[
															172.632,
															292.354
														],
														[
															169,
															353
														],
														[
															176.086,
															442.178
														],
														[
															195,
															519
														],
														[
															200.535,
															534.23
														],
														[
															206,
															548
														],
														[
															208.645,
															553.952
														],
														[
															211,
															559
														],
														[
															211.975,
															562.014
														],
														[
															213,
															565
														],
														[
															217.56,
															572.844
														],
														[
															222,
															580
														],
														[
															224.572,
															585.757
														],
														[
															227,
															591
														],
														[
															228.979,
															592.985
														],
														[
															231,
															595
														],
														[
															233.203,
															599.336
														],
														[
															235,
															603
														],
														[
															235.973,
															603.984
														],
														[
															237,
															605
														],
														[
															260.579,
															634.999
														],
														[
															287,
															659
														],
														[
															293.269,
															663.415
														],
														[
															299,
															667
														],
														[
															301.754,
															668.647
														],
														[
															304,
															670
														],
														[
															321.902,
															678.786
														],
														[
															341,
															685
														],
														[
															344.822,
															685.399
														],
														[
															348,
															686
														],
														[
															352.189,
															691.469
														],
														[
															355,
															697
														],
														[
															356.683,
															698.316
														],
														[
															360,
															699
														],
														[
															373.297,
															699.231
														],
														[
															388,
															696
														],
														[
															398.327,
															693.145
														],
														[
															407,
															690
														],
														[
															415.847,
															686.12
														],
														[
															424,
															682
														],
														[
															430.893,
															677.88
														],
														[
															437,
															674
														],
														[
															437.986,
															673.029
														],
														[
															439,
															672
														],
														[
															445.456,
															667.397
														],
														[
															451,
															663
														],
														[
															460.716,
															653.738
														],
														[
															470,
															644
														],
														[
															516.679,
															571.424
														],
														[
															546,
															483
														],
														[
															556.227,
															424.427
														],
														[
															560,
															362
														],
														[
															550.592,
															263.129
														],
														[
															527,
															177
														],
														[
															516.071,
															151.908
														],
														[
															504,
															129
														],
														[
															501.362,
															124.729
														],
														[
															499,
															121
														],
														[
															496.061,
															115.451
														],
														[
															493,
															110
														],
														[
															490.994,
															107.959
														],
														[
															489,
															106
														],
														[
															487.501,
															102.97
														],
														[
															486,
															100
														],
														[
															482.113,
															95.538
														],
														[
															478,
															91
														],
														[
															475.322,
															87.18
														],
														[
															473,
															84
														],
														[
															467.458,
															78.358
														],
														[
															462,
															73
														],
														[
															457.916,
															68.3
														],
														[
															454,
															64
														],
														[
															451.635,
															62.574
														],
														[
															449,
															61
														],
														[
															446.976,
															58.964
														],
														[
															445,
															57
														],
														[
															433.518,
															48.973
														],
														[
															422,
															42
														],
														[
															415.147,
															38.264
														],
														[
															408,
															35
														],
														[
															392,
															30
														],
														[
															389,
															28
														],
														[
															356,
															26
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 68,
											"s": [
												{
													"i": [
														[
															3.031,
															-1.397
														],
														[
															2.415,
															-1.218
														],
														[
															2.319,
															-1.28
														],
														[
															2.12,
															-1.298
														],
														[
															1.817,
															-1.27
														],
														[
															0.9,
															-0.731
														],
														[
															0.871,
															-0.741
														],
														[
															0.785,
															-0.639
														],
														[
															0.644,
															-0.427
														],
														[
															0.89,
															-0.775
														],
														[
															0.815,
															-0.807
														],
														[
															0.768,
															-0.754
														],
														[
															0.748,
															-0.615
														],
														[
															0.338,
															-0.322
														],
														[
															0.315,
															-0.33
														],
														[
															0.319,
															-0.343
														],
														[
															0.351,
															-0.36
														],
														[
															4.458,
															-5.66
														],
														[
															3.972,
															-6.077
														],
														[
															3.528,
															-6.379
														],
														[
															3.125,
															-6.565
														],
														[
															0.425,
															-0.819
														],
														[
															0.43,
															-0.819
														],
														[
															0.415,
															-0.84
														],
														[
															0.381,
															-0.883
														],
														[
															0.353,
															-1.055
														],
														[
															0.307,
															-1.039
														],
														[
															0.301,
															-0.964
														],
														[
															0.333,
															-0.831
														],
														[
															0.459,
															-0.893
														],
														[
															0.486,
															-0.886
														],
														[
															0.409,
															-0.8
														],
														[
															0.228,
															-0.635
														],
														[
															0.627,
															-1.989
														],
														[
															0.562,
															-1.934
														],
														[
															0.529,
															-1.853
														],
														[
															0.529,
															-1.746
														],
														[
															0.246,
															-0.99
														],
														[
															0.229,
															-1.003
														],
														[
															0.243,
															-1.012
														],
														[
															0.289,
															-1.016
														],
														[
															0.352,
															-0.909
														],
														[
															0.372,
															-0.893
														],
														[
															0.334,
															-0.913
														],
														[
															0.238,
															-0.968
														],
														[
															0.631,
															-3.179
														],
														[
															0.525,
															-3.105
														],
														[
															0.506,
															-3.123
														],
														[
															0.574,
															-3.234
														],
														[
															1.374,
															-13.92
														],
														[
															0.471,
															-14.585
														],
														[
															-0.514,
															-14.373
														],
														[
															-1.58,
															-13.283
														],
														[
															-0.662,
															-4.289
														],
														[
															-0.774,
															-4.256
														],
														[
															-0.85,
															-4.214
														],
														[
															-0.89,
															-4.163
														],
														[
															-0.388,
															-2.116
														],
														[
															-0.382,
															-2.107
														],
														[
															-0.428,
															-2.063
														],
														[
															-0.526,
															-1.982
														],
														[
															-0.57,
															-1.953
														],
														[
															-0.594,
															-1.911
														],
														[
															-0.601,
															-1.877
														],
														[
															-0.594,
															-1.852
														],
														[
															-10.785,
															-19.921
														],
														[
															-13.525,
															-14.422
														],
														[
															-5.072,
															-4.551
														],
														[
															-6.615,
															-4.362
														],
														[
															-6.11,
															-3.016
														],
														[
															-6.464,
															-1.577
														],
														[
															-1.373,
															-0.109
														],
														[
															-0.495,
															-0.317
														],
														[
															-0.766,
															-1.286
														],
														[
															-0.647,
															-1.027
														],
														[
															0.065,
															-0.823
														],
														[
															-0.537,
															-0.561
														],
														[
															-0.659,
															0.078
														],
														[
															-1.619,
															-0.534
														],
														[
															-5.105,
															0.837
														],
														[
															-2.993,
															0.834
														],
														[
															-3.886,
															1.757
														],
														[
															-3.476,
															1.863
														],
														[
															-6.2,
															4.76
														],
														[
															-4.794,
															4.99
														],
														[
															-8.301,
															13.247
														],
														[
															-6.477,
															14.229
														],
														[
															-5.552,
															57.794
														],
														[
															11.985,
															58.189
														],
														[
															5.223,
															16.639
														],
														[
															6.202,
															13.475
														],
														[
															12.192,
															16.851
														],
														[
															15.889,
															11.463
														],
														[
															3.219,
															1.913
														],
														[
															2.445,
															1.416
														],
														[
															3.371,
															1.303
														],
														[
															3.445,
															1.009
														],
														[
															5.441,
															0.482
														],
														[
															4.191,
															-0.404
														],
														[
															5.093,
															-1.04
														]
													],
													"o": [
														[
															-2.408,
															1.109
														],
														[
															-2.415,
															1.218
														],
														[
															-2.319,
															1.28
														],
														[
															-2.12,
															1.298
														],
														[
															-0.874,
															0.611
														],
														[
															-0.9,
															0.731
														],
														[
															-0.871,
															0.741
														],
														[
															-0.785,
															0.639
														],
														[
															-0.991,
															0.657
														],
														[
															-0.89,
															0.775
														],
														[
															-0.815,
															0.807
														],
														[
															-0.768,
															0.754
														],
														[
															-0.388,
															0.319
														],
														[
															-0.338,
															0.322
														],
														[
															-0.315,
															0.33
														],
														[
															-0.319,
															0.343
														],
														[
															-4.985,
															5.127
														],
														[
															-4.458,
															5.66
														],
														[
															-3.972,
															6.077
														],
														[
															-3.528,
															6.379
														],
														[
															-0.4,
															0.841
														],
														[
															-0.425,
															0.819
														],
														[
															-0.43,
															0.819
														],
														[
															-0.415,
															0.84
														],
														[
															-0.437,
															1.013
														],
														[
															-0.353,
															1.055
														],
														[
															-0.307,
															1.039
														],
														[
															-0.301,
															0.964
														],
														[
															-0.329,
															0.822
														],
														[
															-0.459,
															0.893
														],
														[
															-0.486,
															0.886
														],
														[
															-0.409,
															0.8
														],
														[
															-0.724,
															2.018
														],
														[
															-0.627,
															1.989
														],
														[
															-0.562,
															1.934
														],
														[
															-0.529,
															1.853
														],
														[
															-0.294,
															0.971
														],
														[
															-0.246,
															0.99
														],
														[
															-0.229,
															1.003
														],
														[
															-0.243,
															1.012
														],
														[
															-0.273,
															0.96
														],
														[
															-0.352,
															0.909
														],
														[
															-0.372,
															0.893
														],
														[
															-0.334,
															0.913
														],
														[
															-0.824,
															3.346
														],
														[
															-0.631,
															3.179
														],
														[
															-0.525,
															3.105
														],
														[
															-0.506,
															3.123
														],
														[
															-2.197,
															12.377
														],
														[
															-1.374,
															13.92
														],
														[
															-0.471,
															14.585
														],
														[
															0.514,
															14.373
														],
														[
															0.513,
															4.312
														],
														[
															0.662,
															4.289
														],
														[
															0.774,
															4.256
														],
														[
															0.85,
															4.214
														],
														[
															0.447,
															2.089
														],
														[
															0.388,
															2.116
														],
														[
															0.382,
															2.107
														],
														[
															0.428,
															2.063
														],
														[
															0.531,
															2.005
														],
														[
															0.57,
															1.953
														],
														[
															0.594,
															1.911
														],
														[
															0.601,
															1.877
														],
														[
															7.335,
															22.894
														],
														[
															10.785,
															19.921
														],
														[
															5.097,
															5.436
														],
														[
															5.072,
															4.551
														],
														[
															5.095,
															3.36
														],
														[
															6.11,
															3.016
														],
														[
															1.015,
															0.247
														],
														[
															1.373,
															0.109
														],
														[
															1.29,
															0.827
														],
														[
															0.766,
															1.286
														],
														[
															0.722,
															1.148
														],
														[
															-0.065,
															0.823
														],
														[
															0.744,
															0.777
														],
														[
															0.659,
															-0.078
														],
														[
															3.587,
															1.183
														],
														[
															5.105,
															-0.837
														],
														[
															3.981,
															-1.109
														],
														[
															3.886,
															-1.757
														],
														[
															7.404,
															-3.968
														],
														[
															6.2,
															-4.76
														],
														[
															11.318,
															-11.782
														],
														[
															8.301,
															-13.247
														],
														[
															20.776,
															-45.637
														],
														[
															5.552,
															-57.794
														],
														[
															-3.907,
															-18.97
														],
														[
															-5.223,
															-16.639
														],
														[
															-8.346,
															-18.134
														],
														[
															-12.191,
															-16.851
														],
														[
															-2.68,
															-1.934
														],
														[
															-3.219,
															-1.913
														],
														[
															-3.07,
															-1.778
														],
														[
															-3.371,
															-1.303
														],
														[
															-5.043,
															-1.477
														],
														[
															-5.441,
															-0.482
														],
														[
															-4.598,
															0.444
														],
														[
															-5.093,
															1.04
														]
													],
													"v": [
														[
															329,
															32
														],
														[
															321.741,
															35.502
														],
														[
															314.614,
															39.26
														],
														[
															307.931,
															43.138
														],
														[
															302,
															47
														],
														[
															299.325,
															49.04
														],
														[
															296.655,
															51.275
														],
														[
															294.157,
															53.373
														],
														[
															292,
															55
														],
														[
															289.186,
															57.17
														],
														[
															286.636,
															59.563
														],
														[
															284.268,
															61.925
														],
														[
															282,
															64
														],
														[
															280.917,
															64.961
														],
														[
															279.943,
															65.939
														],
														[
															278.998,
															66.947
														],
														[
															278,
															68
														],
														[
															263.846,
															84.209
														],
														[
															251.21,
															101.843
														],
														[
															239.97,
															120.555
														],
														[
															230,
															140
														],
														[
															228.757,
															142.485
														],
														[
															227.47,
															144.937
														],
														[
															226.198,
															147.421
														],
														[
															225,
															150
														],
														[
															223.825,
															153.118
														],
														[
															222.844,
															156.273
														],
														[
															221.941,
															159.292
														],
														[
															221,
															162
														],
														[
															219.791,
															164.592
														],
														[
															218.348,
															167.281
														],
														[
															216.981,
															169.828
														],
														[
															216,
															172
														],
														[
															213.982,
															178.017
														],
														[
															212.208,
															183.908
														],
														[
															210.58,
															189.595
														],
														[
															209,
															195
														],
														[
															208.197,
															197.943
														],
														[
															207.492,
															200.933
														],
														[
															206.791,
															203.957
														],
														[
															206,
															207
														],
														[
															205.048,
															209.794
														],
														[
															203.947,
															212.488
														],
														[
															202.873,
															215.188
														],
														[
															202,
															218
														],
														[
															199.839,
															227.766
														],
														[
															198.125,
															237.169
														],
														[
															196.599,
															246.488
														],
														[
															195,
															256
														],
														[
															189.623,
															295.665
														],
														[
															186.835,
															338.641
														],
														[
															186.88,
															382.297
														],
														[
															190,
															424
														],
														[
															191.771,
															436.904
														],
														[
															193.934,
															449.723
														],
														[
															196.38,
															462.431
														],
														[
															199,
															475
														],
														[
															200.239,
															481.315
														],
														[
															201.382,
															487.659
														],
														[
															202.583,
															493.923
														],
														[
															204,
															500
														],
														[
															205.657,
															505.935
														],
														[
															207.407,
															511.729
														],
														[
															209.204,
															517.408
														],
														[
															211,
															523
														],
														[
															238.357,
															587.854
														],
														[
															275,
															640
														],
														[
															289.862,
															654.805
														],
														[
															307,
															668
														],
														[
															323.973,
															677.837
														],
														[
															343,
															685
														],
														[
															346.89,
															685.447
														],
														[
															350,
															686
														],
														[
															352.983,
															689.35
														],
														[
															355,
															693
														],
														[
															355.639,
															695.94
														],
														[
															356,
															698
														],
														[
															357.844,
															698.682
														],
														[
															361,
															699
														],
														[
															374.946,
															699.013
														],
														[
															388,
															696
														],
														[
															399.878,
															691.566
														],
														[
															411,
															686
														],
														[
															431.457,
															672.767
														],
														[
															448,
															658
														],
														[
															477.131,
															620.335
														],
														[
															499,
															579
														],
														[
															539.071,
															420.914
														],
														[
															530,
															244
														],
														[
															516.221,
															190.379
														],
														[
															499,
															145
														],
														[
															468.157,
															91.497
														],
														[
															426,
															48
														],
														[
															416.823,
															42.111
														],
														[
															408,
															37
														],
														[
															398.281,
															32.424
														],
														[
															388,
															29
														],
														[
															371.861,
															26.089
														],
														[
															357,
															26
														],
														[
															341.825,
															28.285
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 69,
											"s": [
												{
													"i": [
														[
															5.487,
															-3.177
														],
														[
															0.59,
															-0.371
														],
														[
															0.6,
															-0.397
														],
														[
															0.46,
															-0.328
														],
														[
															0.17,
															-0.163
														],
														[
															0.414,
															-0.34
														],
														[
															0.387,
															-0.286
														],
														[
															0.405,
															-0.303
														],
														[
															0.467,
															-0.39
														],
														[
															0.858,
															-0.828
														],
														[
															0.784,
															-0.826
														],
														[
															0.784,
															-0.835
														],
														[
															0.856,
															-0.856
														],
														[
															1.118,
															-1.051
														],
														[
															1.119,
															-1.066
														],
														[
															1.067,
															-1.107
														],
														[
															0.961,
															-1.173
														],
														[
															5.601,
															-9.188
														],
														[
															4.757,
															-10.107
														],
														[
															3.902,
															-10.616
														],
														[
															3.038,
															-10.715
														],
														[
															0.814,
															-3.106
														],
														[
															0.737,
															-3.049
														],
														[
															0.679,
															-3.043
														],
														[
															0.642,
															-3.089
														],
														[
															0.549,
															-2.769
														],
														[
															0.503,
															-2.727
														],
														[
															0.452,
															-2.719
														],
														[
															0.397,
															-2.747
														],
														[
															0.019,
															-31.384
														],
														[
															-4.204,
															-30.069
														],
														[
															-8.247,
															-26.65
														],
														[
															-12.107,
															-21.129
														],
														[
															-0.855,
															-1.498
														],
														[
															-0.814,
															-1.402
														],
														[
															-0.802,
															-1.328
														],
														[
															-0.818,
															-1.277
														],
														[
															-1.239,
															-1.738
														],
														[
															-1.268,
															-1.652
														],
														[
															-1.27,
															-1.588
														],
														[
															-1.244,
															-1.546
														],
														[
															-0.493,
															-0.688
														],
														[
															-0.494,
															-0.701
														],
														[
															-0.504,
															-0.662
														],
														[
															-0.523,
															-0.571
														],
														[
															-2.818,
															-2.515
														],
														[
															-3.049,
															-2.318
														],
														[
															-3.081,
															-2.019
														],
														[
															-2.914,
															-1.618
														],
														[
															-1.493,
															-0.844
														],
														[
															-1.597,
															-0.849
														],
														[
															-1.555,
															-0.705
														],
														[
															-1.368,
															-0.412
														],
														[
															-0.822,
															-0.086
														],
														[
															-0.75,
															-0.026
														],
														[
															-0.553,
															-0.052
														],
														[
															-0.23,
															-0.163
														],
														[
															-0.534,
															-1.259
														],
														[
															-0.57,
															-1.053
														],
														[
															0.006,
															-0.855
														],
														[
															-0.429,
															-0.479
														],
														[
															-0.767,
															0.022
														],
														[
															-1.372,
															-0.464
														],
														[
															-4.658,
															0.927
														],
														[
															-3.639,
															1.213
														],
														[
															-3.606,
															1.767
														],
														[
															-2.431,
															1.552
														],
														[
															-7.022,
															7.268
														],
														[
															-5.608,
															7.625
														],
														[
															-1.565,
															2
														],
														[
															-1.166,
															1.857
														],
														[
															-0.281,
															0.895
														],
														[
															-0.445,
															0.729
														],
														[
															-0.427,
															0.143
														],
														[
															-0.164,
															0.219
														],
														[
															-0.122,
															0.565
														],
														[
															-0.221,
															0.351
														],
														[
															-0.807,
															1.487
														],
														[
															-0.788,
															1.486
														],
														[
															-2.155,
															4.452
														],
														[
															-1.278,
															4.227
														],
														[
															-0.46,
															0.391
														],
														[
															-0.103,
															0.25
														],
														[
															-4.157,
															13.392
														],
														[
															-3.222,
															13.994
														],
														[
															-1.546,
															7.887
														],
														[
															-1.088,
															7.956
														],
														[
															2.28,
															44.177
														],
														[
															9.663,
															36.008
														],
														[
															11.881,
															24.472
														],
														[
															17.905,
															17.906
														],
														[
															3.114,
															2.637
														],
														[
															3.457,
															2.367
														],
														[
															4.211,
															2.109
														],
														[
															4.876,
															1.631
														],
														[
															1.165,
															0.579
														],
														[
															1.103,
															0.27
														],
														[
															3.783,
															0.078
														],
														[
															2.199,
															-0.21
														],
														[
															6.707,
															-2.748
														]
													],
													"o": [
														[
															-0.43,
															0.249
														],
														[
															-0.59,
															0.371
														],
														[
															-0.6,
															0.397
														],
														[
															-0.46,
															0.328
														],
														[
															-0.484,
															0.464
														],
														[
															-0.414,
															0.34
														],
														[
															-0.387,
															0.286
														],
														[
															-0.405,
															0.303
														],
														[
															-1.006,
															0.84
														],
														[
															-0.858,
															0.828
														],
														[
															-0.784,
															0.826
														],
														[
															-0.784,
															0.835
														],
														[
															-1.062,
															1.062
														],
														[
															-1.118,
															1.051
														],
														[
															-1.119,
															1.066
														],
														[
															-1.067,
															1.107
														],
														[
															-6.435,
															7.859
														],
														[
															-5.601,
															9.188
														],
														[
															-4.757,
															10.107
														],
														[
															-3.902,
															10.616
														],
														[
															-0.911,
															3.215
														],
														[
															-0.814,
															3.106
														],
														[
															-0.737,
															3.049
														],
														[
															-0.679,
															3.043
														],
														[
															-0.592,
															2.846
														],
														[
															-0.549,
															2.769
														],
														[
															-0.503,
															2.727
														],
														[
															-0.452,
															2.719
														],
														[
															-4.424,
															30.596
														],
														[
															-0.019,
															31.384
														],
														[
															4.204,
															30.069
														],
														[
															8.247,
															26.65
														],
														[
															0.926,
															1.616
														],
														[
															0.855,
															1.498
														],
														[
															0.814,
															1.402
														],
														[
															0.802,
															1.328
														],
														[
															1.183,
															1.846
														],
														[
															1.239,
															1.738
														],
														[
															1.268,
															1.652
														],
														[
															1.27,
															1.588
														],
														[
															0.501,
															0.624
														],
														[
															0.493,
															0.688
														],
														[
															0.494,
															0.701
														],
														[
															0.504,
															0.662
														],
														[
															2.388,
															2.608
														],
														[
															2.818,
															2.515
														],
														[
															3.049,
															2.318
														],
														[
															3.081,
															2.019
														],
														[
															1.245,
															0.691
														],
														[
															1.493,
															0.844
														],
														[
															1.597,
															0.849
														],
														[
															1.555,
															0.705
														],
														[
															0.768,
															0.231
														],
														[
															0.822,
															0.086
														],
														[
															0.75,
															0.026
														],
														[
															0.553,
															0.052
														],
														[
															1.293,
															0.913
														],
														[
															0.534,
															1.259
														],
														[
															0.596,
															1.101
														],
														[
															-0.006,
															0.855
														],
														[
															0.56,
															0.625
														],
														[
															0.767,
															-0.022
														],
														[
															2.729,
															0.921
														],
														[
															4.658,
															-0.927
														],
														[
															4.144,
															-1.381
														],
														[
															3.606,
															-1.767
														],
														[
															8.303,
															-5.302
														],
														[
															7.022,
															-7.268
														],
														[
															1.575,
															-2.141
														],
														[
															1.565,
															-2
														],
														[
															0.433,
															-0.689
														],
														[
															0.281,
															-0.895
														],
														[
															0.127,
															-0.208
														],
														[
															0.427,
															-0.143
														],
														[
															0.292,
															-0.389
														],
														[
															0.122,
															-0.565
														],
														[
															0.984,
															-1.567
														],
														[
															0.807,
															-1.487
														],
														[
															2.101,
															-3.964
														],
														[
															2.155,
															-4.452
														],
														[
															0.055,
															-0.184
														],
														[
															0.46,
															-0.392
														],
														[
															5.151,
															-12.438
														],
														[
															4.157,
															-13.392
														],
														[
															1.726,
															-7.498
														],
														[
															1.546,
															-7.887
														],
														[
															5.784,
															-42.283
														],
														[
															-2.28,
															-44.177
														],
														[
															-7.569,
															-28.207
														],
														[
															-11.881,
															-24.472
														],
														[
															-3.087,
															-3.087
														],
														[
															-3.114,
															-2.637
														],
														[
															-4.281,
															-2.931
														],
														[
															-4.211,
															-2.11
														],
														[
															-1.236,
															-0.413
														],
														[
															-1.165,
															-0.579
														],
														[
															-3.67,
															-0.899
														],
														[
															-3.783,
															-0.078
														],
														[
															-8.686,
															0.831
														],
														[
															-6.707,
															2.748
														]
													],
													"v": [
														[
															317,
															41
														],
														[
															315.433,
															41.953
														],
														[
															313.61,
															43.129
														],
														[
															311.982,
															44.24
														],
														[
															311,
															45
														],
														[
															309.664,
															46.188
														],
														[
															308.474,
															47.111
														],
														[
															307.297,
															47.977
														],
														[
															306,
															49
														],
														[
															303.222,
															51.499
														],
														[
															300.776,
															53.977
														],
														[
															298.442,
															56.466
														],
														[
															296,
															59
														],
														[
															292.717,
															62.163
														],
														[
															289.348,
															65.332
														],
														[
															286.055,
															68.586
														],
														[
															283,
															72
														],
														[
															264.943,
															97.672
														],
														[
															249.404,
															126.716
														],
														[
															236.412,
															157.902
														],
														[
															226,
															190
														],
														[
															223.417,
															199.469
														],
														[
															221.097,
															208.689
														],
														[
															218.978,
															217.814
														],
														[
															217,
															227
														],
														[
															215.287,
															235.414
														],
														[
															213.708,
															243.649
														],
														[
															212.275,
															251.809
														],
														[
															211,
															260
														],
														[
															204.38,
															353.497
														],
														[
															210.702,
															446.201
														],
														[
															229.424,
															531.805
														],
														[
															260,
															604
														],
														[
															262.665,
															608.666
														],
														[
															265.162,
															613.009
														],
														[
															267.577,
															617.098
														],
														[
															270,
															621
														],
														[
															273.641,
															626.37
														],
														[
															277.409,
															631.449
														],
														[
															281.223,
															636.304
														],
														[
															285,
															641
														],
														[
															286.49,
															642.981
														],
														[
															287.968,
															645.078
														],
														[
															289.462,
															647.137
														],
														[
															291,
															649
														],
														[
															298.859,
															656.71
														],
														[
															307.711,
															663.986
														],
														[
															316.957,
															670.518
														],
														[
															326,
															676
														],
														[
															330.143,
															678.34
														],
														[
															334.814,
															680.917
														],
														[
															339.579,
															683.286
														],
														[
															344,
															685
														],
														[
															346.416,
															685.455
														],
														[
															348.807,
															685.603
														],
														[
															350.793,
															685.699
														],
														[
															352,
															686
														],
														[
															354.542,
															689.396
														],
														[
															356,
															693
														],
														[
															356.625,
															695.967
														],
														[
															357,
															698
														],
														[
															358.891,
															698.621
														],
														[
															362,
															699
														],
														[
															373.818,
															698.601
														],
														[
															387,
															695
														],
														[
															398.785,
															690.128
														],
														[
															408,
															685
														],
														[
															431.021,
															665.743
														],
														[
															450,
															643
														],
														[
															454.806,
															636.787
														],
														[
															459,
															631
														],
														[
															459.991,
															628.53
														],
														[
															461,
															626
														],
														[
															461.972,
															625.508
														],
														[
															463,
															625
														],
														[
															463.553,
															623.471
														],
														[
															464,
															622
														],
														[
															466.647,
															617.438
														],
														[
															469,
															613
														],
														[
															475.617,
															600.198
														],
														[
															481,
															587
														],
														[
															481.964,
															586.05
														],
														[
															483,
															585
														],
														[
															496.947,
															546.167
														],
														[
															508,
															505
														],
														[
															512.979,
															481.843
														],
														[
															517,
															458
														],
														[
															522.084,
															325.794
														],
														[
															504,
															203
														],
														[
															475.252,
															123.274
														],
														[
															431,
															59
														],
														[
															421.778,
															50.46
														],
														[
															412,
															43
														],
														[
															399.446,
															35.525
														],
														[
															386,
															30
														],
														[
															382.4,
															28.393
														],
														[
															379,
															27
														],
														[
															367.397,
															25.668
														],
														[
															358,
															26
														],
														[
															335.101,
															31.74
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 70,
											"s": [
												{
													"i": [
														[
															3.681,
															-2.776
														],
														[
															0.348,
															-0.258
														],
														[
															0.349,
															-0.259
														],
														[
															0.326,
															-0.246
														],
														[
															0.281,
															-0.22
														],
														[
															7.394,
															-9.261
														],
														[
															5.875,
															-10.771
														],
														[
															4.668,
															-11.75
														],
														[
															3.774,
															-12.197
														],
														[
															3.16,
															-14.436
														],
														[
															2.286,
															-15.816
														],
														[
															1.233,
															-16.597
														],
														[
															0,
															-16.779
														],
														[
															-1.673,
															-20.461
														],
														[
															-3.238,
															-18.977
														],
														[
															-4.696,
															-17.277
														],
														[
															-6.046,
															-15.362
														],
														[
															-0.079,
															-0.435
														],
														[
															-0.049,
															-0.435
														],
														[
															-0.071,
															-0.408
														],
														[
															-0.143,
															-0.352
														],
														[
															-0.259,
															-0.328
														],
														[
															-0.295,
															-0.311
														],
														[
															-0.264,
															-0.327
														],
														[
															-0.164,
															-0.378
														],
														[
															-0.063,
															-0.399
														],
														[
															-0.034,
															-0.415
														],
														[
															-0.079,
															-0.434
														],
														[
															-0.198,
															-0.455
														],
														[
															-0.598,
															-0.656
														],
														[
															-0.313,
															-0.698
														],
														[
															-0.066,
															-0.835
														],
														[
															-0.334,
															-0.769
														],
														[
															-0.57,
															-0.612
														],
														[
															-0.38,
															-0.77
														],
														[
															-2.257,
															-4.316
														],
														[
															-2.667,
															-4.067
														],
														[
															-0.575,
															-0.483
														],
														[
															-0.345,
															-0.525
														],
														[
															-0.258,
															-0.894
														],
														[
															-0.438,
															-0.618
														],
														[
															-0.414,
															-0.145
														],
														[
															-0.191,
															-0.206
														],
														[
															-0.073,
															-0.539
														],
														[
															-0.342,
															-0.449
														],
														[
															-0.406,
															-0.139
														],
														[
															-0.203,
															-0.218
														],
														[
															-0.53,
															-0.983
														],
														[
															-0.887,
															-1.002
														],
														[
															-5.38,
															-4.802
														],
														[
															-5.957,
															-2.686
														],
														[
															-0.155,
															-0.451
														],
														[
															-0.206,
															-0.119
														],
														[
															-0.718,
															-0.347
														],
														[
															-0.477,
															-0.237
														],
														[
															-1.203,
															-0.518
														],
														[
															-1.296,
															-0.483
														],
														[
															-1.806,
															-0.297
														],
														[
															-0.349,
															-0.282
														],
														[
															-0.501,
															-2.629
														],
														[
															-1.821,
															-0.728
														],
														[
															-6.817,
															2.621
														],
														[
															-2.624,
															1.56
														],
														[
															-0.646,
															0.533
														],
														[
															-0.673,
															0.429
														],
														[
															-0.907,
															0.267
														],
														[
															-0.552,
															0.411
														],
														[
															-0.496,
															0.548
														],
														[
															-0.565,
															0.471
														],
														[
															-3.854,
															4.033
														],
														[
															-3.25,
															4.247
														],
														[
															-6.087,
															11.739
														],
														[
															-4.834,
															12.827
														],
														[
															-1.62,
															4.175
														],
														[
															-1.029,
															3.341
														],
														[
															-0.107,
															1.026
														],
														[
															-0.292,
															0.988
														],
														[
															-0.743,
															1.619
														],
														[
															-0.501,
															1.74
														],
														[
															-0.262,
															1.883
														],
														[
															-0.462,
															1.771
														],
														[
															-0.539,
															1.656
														],
														[
															-0.399,
															1.671
														],
														[
															-3,
															29.088
														],
														[
															0,
															29.538
														],
														[
															4.098,
															30.231
														],
														[
															6.607,
															24.536
														],
														[
															1.703,
															4.912
														],
														[
															1.726,
															4.929
														],
														[
															1.557,
															4.185
														],
														[
															1.353,
															3.211
														],
														[
															1.181,
															2.224
														],
														[
															1.106,
															2.335
														],
														[
															3.721,
															6.386
														],
														[
															3.818,
															5.494
														],
														[
															12.133,
															8.978
														],
														[
															16.195,
															0.624
														],
														[
															0.342,
															-0.251
														],
														[
															0.135,
															-0.014
														],
														[
															5.663,
															-2.392
														]
													],
													"o": [
														[
															-0.324,
															0.245
														],
														[
															-0.348,
															0.258
														],
														[
															-0.349,
															0.259
														],
														[
															-0.326,
															0.246
														],
														[
															-9.226,
															7.218
														],
														[
															-7.394,
															9.261
														],
														[
															-5.875,
															10.771
														],
														[
															-4.668,
															11.75
														],
														[
															-3.854,
															12.457
														],
														[
															-3.16,
															14.436
														],
														[
															-2.286,
															15.816
														],
														[
															-1.233,
															16.597
														],
														[
															0,
															21.73
														],
														[
															1.673,
															20.461
														],
														[
															3.238,
															18.977
														],
														[
															4.696,
															17.277
														],
														[
															0.16,
															0.406
														],
														[
															0.079,
															0.435
														],
														[
															0.049,
															0.435
														],
														[
															0.071,
															0.408
														],
														[
															0.154,
															0.38
														],
														[
															0.259,
															0.328
														],
														[
															0.295,
															0.311
														],
														[
															0.264,
															0.327
														],
														[
															0.167,
															0.384
														],
														[
															0.063,
															0.399
														],
														[
															0.034,
															0.415
														],
														[
															0.079,
															0.434
														],
														[
															0.294,
															0.677
														],
														[
															0.598,
															0.656
														],
														[
															0.4,
															0.892
														],
														[
															0.066,
															0.835
														],
														[
															0.341,
															0.782
														],
														[
															0.57,
															0.612
														],
														[
															2.306,
															4.671
														],
														[
															2.257,
															4.316
														],
														[
															0.356,
															0.543
														],
														[
															0.575,
															0.483
														],
														[
															0.53,
															0.808
														],
														[
															0.258,
															0.894
														],
														[
															0.151,
															0.214
														],
														[
															0.414,
															0.145
														],
														[
															0.366,
															0.394
														],
														[
															0.073,
															0.539
														],
														[
															0.172,
															0.226
														],
														[
															0.406,
															0.139
														],
														[
															0.993,
															1.067
														],
														[
															0.53,
															0.983
														],
														[
															4.524,
															5.108
														],
														[
															5.38,
															4.802
														],
														[
															0.174,
															0.079
														],
														[
															0.155,
															0.451
														],
														[
															0.65,
															0.376
														],
														[
															0.718,
															0.347
														],
														[
															0.893,
															0.444
														],
														[
															1.203,
															0.518
														],
														[
															1.427,
															0.532
														],
														[
															1.806,
															0.297
														],
														[
															2.174,
															1.756
														],
														[
															0.501,
															2.629
														],
														[
															5.11,
															2.043
														],
														[
															6.817,
															-2.621
														],
														[
															0.742,
															-0.441
														],
														[
															0.646,
															-0.533
														],
														[
															0.819,
															-0.522
														],
														[
															0.907,
															-0.267
														],
														[
															0.45,
															-0.336
														],
														[
															0.496,
															-0.548
														],
														[
															4.334,
															-3.621
														],
														[
															3.854,
															-4.033
														],
														[
															7.817,
															-10.216
														],
														[
															6.087,
															-11.739
														],
														[
															1.491,
															-3.957
														],
														[
															1.62,
															-4.175
														],
														[
															0.279,
															-0.909
														],
														[
															0.107,
															-1.026
														],
														[
															0.527,
															-1.785
														],
														[
															0.743,
															-1.619
														],
														[
															0.49,
															-1.699
														],
														[
															0.262,
															-1.883
														],
														[
															0.445,
															-1.706
														],
														[
															0.539,
															-1.656
														],
														[
															6,
															-25.111
														],
														[
															3,
															-29.088
														],
														[
															0,
															-31.539
														],
														[
															-4.098,
															-30.231
														],
														[
															-1.461,
															-5.425
														],
														[
															-1.703,
															-4.911
														],
														[
															-1.418,
															-4.049
														],
														[
															-1.557,
															-4.185
														],
														[
															-1.168,
															-2.77
														],
														[
															-1.181,
															-2.224
														],
														[
															-3.3,
															-6.963
														],
														[
															-3.721,
															-6.386
														],
														[
															-7.274,
															-10.465
														],
														[
															-12.133,
															-8.978
														],
														[
															-0.495,
															-0.019
														],
														[
															-0.342,
															0.251
														],
														[
															-6.666,
															0.657
														],
														[
															-5.663,
															2.392
														]
													],
													"v": [
														[
															326,
															39
														],
														[
															324.986,
															39.757
														],
														[
															323.936,
															40.536
														],
														[
															322.918,
															41.297
														],
														[
															322,
															42
														],
														[
															297.148,
															66.851
														],
														[
															277.322,
															97.031
														],
														[
															261.585,
															130.947
														],
														[
															249,
															167
														],
														[
															238.433,
															207.489
														],
														[
															230.219,
															253.017
														],
														[
															224.894,
															301.786
														],
														[
															223,
															352
														],
														[
															225.536,
															415.34
														],
														[
															232.931,
															474.551
														],
														[
															244.859,
															528.986
														],
														[
															261,
															578
														],
														[
															261.346,
															579.269
														],
														[
															261.525,
															580.581
														],
														[
															261.692,
															581.852
														],
														[
															262,
															583
														],
														[
															262.637,
															584.054
														],
														[
															263.486,
															585.004
														],
														[
															264.341,
															585.952
														],
														[
															265,
															587
														],
														[
															265.326,
															588.173
														],
														[
															265.454,
															589.394
														],
														[
															265.604,
															590.668
														],
														[
															266,
															592
														],
														[
															267.486,
															593.984
														],
														[
															269,
															596
														],
														[
															269.55,
															598.593
														],
														[
															270,
															601
														],
														[
															271.47,
															603.009
														],
														[
															273,
															605
														],
														[
															279.729,
															618.453
														],
														[
															287,
															631
														],
														[
															288.509,
															632.514
														],
														[
															290,
															634
														],
														[
															291.069,
															636.642
														],
														[
															292,
															639
														],
														[
															292.97,
															639.506
														],
														[
															294,
															640
														],
														[
															294.518,
															641.458
														],
														[
															295,
															643
														],
														[
															295.976,
															643.505
														],
														[
															297,
															644
														],
														[
															299.08,
															647.049
														],
														[
															301,
															650
														],
														[
															315.925,
															665.317
														],
														[
															333,
															677
														],
														[
															333.477,
															677.97
														],
														[
															334,
															679
														],
														[
															336.13,
															680.104
														],
														[
															338,
															681
														],
														[
															341.197,
															682.471
														],
														[
															345,
															684
														],
														[
															350.308,
															685.188
														],
														[
															354,
															686
														],
														[
															357.265,
															693.271
														],
														[
															360,
															699
														],
														[
															379.365,
															696.703
														],
														[
															395,
															689
														],
														[
															397.052,
															687.491
														],
														[
															399,
															686
														],
														[
															401.701,
															684.917
														],
														[
															404,
															684
														],
														[
															405.414,
															682.602
														],
														[
															407,
															681
														],
														[
															419.313,
															669.47
														],
														[
															430,
															657
														],
														[
															450.737,
															623.958
														],
														[
															467,
															587
														],
														[
															471.847,
															574.538
														],
														[
															476,
															563
														],
														[
															476.491,
															560.06
														],
														[
															477,
															557
														],
														[
															479.019,
															551.966
														],
														[
															481,
															547
														],
														[
															482.021,
															541.553
														],
														[
															483,
															536
														],
														[
															484.534,
															530.974
														],
														[
															486,
															526
														],
														[
															499.5,
															443.82
														],
														[
															504,
															355
														],
														[
															497.456,
															261.248
														],
														[
															481,
															178
														],
														[
															476.199,
															162.628
														],
														[
															471,
															148
														],
														[
															466.452,
															135.371
														],
														[
															462,
															124
														],
														[
															458.454,
															116.673
														],
														[
															455,
															110
														],
														[
															444.389,
															89.898
														],
														[
															433,
															72
														],
														[
															403.691,
															41.119
														],
														[
															361,
															25
														],
														[
															359.73,
															25.476
														],
														[
															359,
															26
														],
														[
															340.261,
															30.91
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 71,
											"s": [
												{
													"i": [
														[
															1.803,
															-0.621
														],
														[
															0.953,
															-0.405
														],
														[
															0.69,
															-0.377
														],
														[
															0.642,
															-0.409
														],
														[
															0.81,
															-0.501
														],
														[
															0.437,
															-0.159
														],
														[
															0.43,
															-0.123
														],
														[
															0.403,
															-0.152
														],
														[
															0.357,
															-0.247
														],
														[
															0.592,
															-0.494
														],
														[
															0.602,
															-0.541
														],
														[
															0.583,
															-0.527
														],
														[
															0.538,
															-0.451
														],
														[
															5.41,
															-7.142
														],
														[
															4.442,
															-8.202
														],
														[
															3.686,
															-8.709
														],
														[
															3.141,
															-8.663
														],
														[
															0.079,
															-0.509
														],
														[
															0.045,
															-0.519
														],
														[
															0.068,
															-0.5
														],
														[
															0.149,
															-0.453
														],
														[
															0.353,
															-0.754
														],
														[
															0.377,
															-0.733
														],
														[
															0.336,
															-0.738
														],
														[
															0.229,
															-0.768
														],
														[
															0.241,
															-1.852
														],
														[
															0.525,
															-1.873
														],
														[
															0.407,
															-0.669
														],
														[
															0.175,
															-0.62
														],
														[
															0.12,
															-1.021
														],
														[
															0.243,
															-0.933
														],
														[
															2.567,
															-12.794
														],
														[
															1.611,
															-12.817
														],
														[
															-3.163,
															-52.002
														],
														[
															-11.918,
															-43.711
														],
														[
															-8.047,
															-18.331
														],
														[
															-11.339,
															-13.606
														],
														[
															-2.655,
															-2.625
														],
														[
															-2.345,
															-1.057
														],
														[
															-0.175,
															-0.453
														],
														[
															-0.156,
															-0.124
														],
														[
															-3.047,
															-1.781
														],
														[
															-2.552,
															-1.084
														],
														[
															-1.141,
															-0.97
														],
														[
															-1.344,
															-3.381
														],
														[
															-0.094,
															-1.206
														],
														[
															-0.288,
															-0.329
														],
														[
															-0.643,
															0.072
														],
														[
															-0.259,
															-0.092
														],
														[
															-5.818,
															2.623
														],
														[
															-2.336,
															1.721
														],
														[
															-0.856,
															0.958
														],
														[
															-0.579,
															0.435
														],
														[
															-0.536,
															0.077
														],
														[
															-0.399,
															0.35
														],
														[
															-1.938,
															2.222
														],
														[
															-1.331,
															1.429
														],
														[
															-0.583,
															1.031
														],
														[
															-0.698,
															0.836
														],
														[
															-1.22,
															1.78
														],
														[
															-0.805,
															1.308
														],
														[
															-0.375,
															0.296
														],
														[
															-0.222,
															0.36
														],
														[
															-0.58,
															1.537
														],
														[
															-0.825,
															1.465
														],
														[
															-0.539,
															0.626
														],
														[
															-0.444,
															0.786
														],
														[
															-0.293,
															0.861
														],
														[
															-0.409,
															0.819
														],
														[
															-3.86,
															9.772
														],
														[
															-3.072,
															9.931
														],
														[
															-4.107,
															22.865
														],
														[
															-2.139,
															24.754
														],
														[
															-0.714,
															12.754
														],
														[
															0,
															12.743
														],
														[
															0.731,
															12.762
														],
														[
															1.075,
															12.663
														],
														[
															5.337,
															26.33
														],
														[
															8.176,
															22.478
														],
														[
															1.005,
															3.023
														],
														[
															0.924,
															2.005
														],
														[
															0.507,
															1.212
														],
														[
															0.405,
															0.927
														],
														[
															2.867,
															5.113
														],
														[
															3.017,
															4.791
														],
														[
															3.962,
															5.301
														],
														[
															4.416,
															3.862
														],
														[
															0.703,
															0.25
														],
														[
															0.697,
															0.571
														],
														[
															0.133,
															0.398
														],
														[
															0.232,
															0.216
														],
														[
															0.533,
															0.072
														],
														[
															0.469,
															0.339
														],
														[
															1.328,
															1.088
														],
														[
															1.368,
															0.695
														],
														[
															3.544,
															1.014
														],
														[
															3.555,
															0.281
														],
														[
															0.334,
															-0.257
														],
														[
															0.149,
															-0.014
														],
														[
															1.252,
															-0.291
														]
													],
													"o": [
														[
															-1.432,
															0.493
														],
														[
															-0.953,
															0.405
														],
														[
															-0.69,
															0.377
														],
														[
															-0.642,
															0.409
														],
														[
															-0.423,
															0.262
														],
														[
															-0.437,
															0.159
														],
														[
															-0.43,
															0.123
														],
														[
															-0.403,
															0.152
														],
														[
															-0.556,
															0.385
														],
														[
															-0.592,
															0.494
														],
														[
															-0.602,
															0.541
														],
														[
															-0.583,
															0.527
														],
														[
															-6.59,
															5.529
														],
														[
															-5.41,
															7.142
														],
														[
															-4.442,
															8.202
														],
														[
															-3.686,
															8.709
														],
														[
															-0.171,
															0.472
														],
														[
															-0.079,
															0.509
														],
														[
															-0.045,
															0.519
														],
														[
															-0.068,
															0.5
														],
														[
															-0.262,
															0.799
														],
														[
															-0.353,
															0.754
														],
														[
															-0.377,
															0.733
														],
														[
															-0.336,
															0.738
														],
														[
															-0.512,
															1.719
														],
														[
															-0.241,
															1.852
														],
														[
															-0.197,
															0.705
														],
														[
															-0.407,
															0.669
														],
														[
															-0.278,
															0.981
														],
														[
															-0.12,
															1.021
														],
														[
															-3.122,
															12.008
														],
														[
															-2.567,
															12.794
														],
														[
															-6.57,
															52.28
														],
														[
															3.163,
															52.002
														],
														[
															5.472,
															20.071
														],
														[
															8.047,
															18.331
														],
														[
															2.036,
															2.443
														],
														[
															2.655,
															2.625
														],
														[
															0.143,
															0.064
														],
														[
															0.175,
															0.453
														],
														[
															2.26,
															1.792
														],
														[
															3.047,
															1.781
														],
														[
															4.091,
															1.739
														],
														[
															1.141,
															0.97
														],
														[
															0.337,
															0.849
														],
														[
															0.094,
															1.206
														],
														[
															0.171,
															0.194
														],
														[
															0.643,
															-0.072
														],
														[
															3.392,
															1.213
														],
														[
															5.818,
															-2.623
														],
														[
															0.996,
															-0.734
														],
														[
															0.856,
															-0.958
														],
														[
															0.459,
															-0.344
														],
														[
															0.535,
															-0.077
														],
														[
															1.917,
															-1.681
														],
														[
															1.938,
															-2.222
														],
														[
															0.969,
															-1.041
														],
														[
															0.583,
															-1.031
														],
														[
															1.315,
															-1.573
														],
														[
															1.22,
															-1.78
														],
														[
															0.279,
															-0.455
														],
														[
															0.375,
															-0.296
														],
														[
															0.856,
															-1.389
														],
														[
															0.58,
															-1.537
														],
														[
															0.4,
															-0.711
														],
														[
															0.539,
															-0.626
														],
														[
															0.417,
															-0.739
														],
														[
															0.293,
															-0.861
														],
														[
															4.488,
															-8.979
														],
														[
															3.86,
															-9.772
														],
														[
															6.431,
															-20.785
														],
														[
															4.107,
															-22.865
														],
														[
															1.144,
															-13.241
														],
														[
															0.714,
															-12.754
														],
														[
															0,
															-13.288
														],
														[
															-0.731,
															-12.762
														],
														[
															-2.477,
															-29.202
														],
														[
															-5.337,
															-26.33
														],
														[
															-1.056,
															-2.903
														],
														[
															-1.005,
															-3.023
														],
														[
															-0.565,
															-1.227
														],
														[
															-0.507,
															-1.212
														],
														[
															-2.517,
															-5.755
														],
														[
															-2.867,
															-5.113
														],
														[
															-3.736,
															-5.934
														],
														[
															-3.962,
															-5.301
														],
														[
															-0.491,
															-0.43
														],
														[
															-0.703,
															-0.25
														],
														[
															-0.236,
															-0.194
														],
														[
															-0.133,
															-0.398
														],
														[
															-0.4,
															-0.373
														],
														[
															-0.533,
															-0.072
														],
														[
															-1.32,
															-0.954
														],
														[
															-1.328,
															-1.088
														],
														[
															-3.27,
															-1.662
														],
														[
															-3.544,
															-1.014
														],
														[
															-0.514,
															-0.041
														],
														[
															-0.334,
															0.256
														],
														[
															-2.187,
															0.215
														],
														[
															-1.252,
															0.291
														]
													],
													"v": [
														[
															351,
															28
														],
														[
															347.477,
															29.332
														],
														[
															345.067,
															30.488
														],
														[
															343.124,
															31.651
														],
														[
															341,
															33
														],
														[
															339.705,
															33.616
														],
														[
															338.4,
															34.023
														],
														[
															337.145,
															34.418
														],
														[
															336,
															35
														],
														[
															334.271,
															36.333
														],
														[
															332.473,
															37.901
														],
														[
															330.688,
															39.518
														],
														[
															329,
															41
														],
														[
															311.052,
															60.144
														],
														[
															296.326,
															83.298
														],
														[
															284.187,
															108.803
														],
														[
															274,
															135
														],
														[
															273.639,
															136.479
														],
														[
															273.467,
															138.029
														],
														[
															273.311,
															139.563
														],
														[
															273,
															141
														],
														[
															272.061,
															143.323
														],
														[
															270.949,
															145.547
														],
														[
															269.863,
															147.748
														],
														[
															269,
															150
														],
														[
															268.01,
															155.385
														],
														[
															267,
															161
														],
														[
															265.984,
															163.064
														],
														[
															265,
															165
														],
														[
															264.474,
															168.036
														],
														[
															264,
															171
														],
														[
															255.366,
															208.393
														],
														[
															249,
															247
														],
														[
															244.135,
															405.427
														],
														[
															267,
															551
														],
														[
															287.1,
															609.348
														],
														[
															316,
															658
														],
														[
															323.268,
															666.039
														],
														[
															331,
															672
														],
														[
															331.49,
															672.955
														],
														[
															332,
															674
														],
														[
															340.281,
															679.531
														],
														[
															349,
															684
														],
														[
															356.06,
															687.268
														],
														[
															359,
															693
														],
														[
															359.537,
															696.39
														],
														[
															360,
															699
														],
														[
															361.434,
															699.076
														],
														[
															363,
															699
														],
														[
															378.292,
															695.7
														],
														[
															392,
															688
														],
														[
															394.813,
															685.275
														],
														[
															397,
															683
														],
														[
															398.546,
															682.504
														],
														[
															400,
															682
														],
														[
															405.939,
															675.811
														],
														[
															411,
															670
														],
														[
															413.203,
															666.847
														],
														[
															415,
															664
														],
														[
															418.882,
															658.801
														],
														[
															422,
															654
														],
														[
															423.043,
															652.929
														],
														[
															424,
															652
														],
														[
															426.024,
															647.557
														],
														[
															428,
															643
														],
														[
															429.467,
															641.057
														],
														[
															431,
															639
														],
														[
															432.006,
															636.56
														],
														[
															433,
															634
														],
														[
															445.561,
															605.714
														],
														[
															456,
															576
														],
														[
															471.719,
															510.477
														],
														[
															481,
															439
														],
														[
															483.858,
															400.126
														],
														[
															485,
															362
														],
														[
															483.806,
															323.031
														],
														[
															481,
															285
														],
														[
															469.274,
															201.457
														],
														[
															449,
															128
														],
														[
															445.901,
															118.827
														],
														[
															443,
															111
														],
														[
															441.38,
															107.275
														],
														[
															440,
															104
														],
														[
															431.875,
															87.777
														],
														[
															423,
															73
														],
														[
															411.51,
															55.947
														],
														[
															399,
															42
														],
														[
															397.154,
															41.106
														],
														[
															395,
															40
														],
														[
															394.497,
															39.017
														],
														[
															394,
															38
														],
														[
															392.551,
															37.474
														],
														[
															391,
															37
														],
														[
															387.036,
															33.806
														],
														[
															383,
															31
														],
														[
															372.713,
															26.965
														],
														[
															362,
															25
														],
														[
															360.726,
															25.459
														],
														[
															360,
															26
														],
														[
															355.212,
															26.695
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 72,
											"s": [
												{
													"i": [
														[
															3.582,
															-6.294
														],
														[
															1.89,
															-3.629
														],
														[
															1.729,
															-3.689
														],
														[
															1.599,
															-3.841
														],
														[
															1.5,
															-4.083
														],
														[
															1.912,
															-6.206
														],
														[
															1.639,
															-6.292
														],
														[
															1.408,
															-6.315
														],
														[
															1.217,
															-6.275
														],
														[
															2.459,
															-35.787
														],
														[
															-1.338,
															-36.314
														],
														[
															-5.128,
															-33.87
														],
														[
															-8.911,
															-28.457
														],
														[
															-0.591,
															-1.489
														],
														[
															-0.612,
															-1.367
														],
														[
															-0.59,
															-1.319
														],
														[
															-0.526,
															-1.347
														],
														[
															-1.194,
															-2.893
														],
														[
															-1.226,
															-2.737
														],
														[
															-1.294,
															-2.6
														],
														[
															-1.397,
															-2.483
														],
														[
															-0.328,
															-0.69
														],
														[
															-0.316,
															-0.692
														],
														[
															-0.33,
															-0.656
														],
														[
															-0.37,
															-0.582
														],
														[
															-1.919,
															-2.628
														],
														[
															-2.236,
															-2.591
														],
														[
															-2.324,
															-2.043
														],
														[
															-2.183,
															-0.984
														],
														[
															-0.081,
															-0.175
														],
														[
															-0.083,
															-0.226
														],
														[
															-0.086,
															-0.188
														],
														[
															-0.09,
															-0.062
														],
														[
															-0.34,
															-0.178
														],
														[
															-0.344,
															-0.154
														],
														[
															-0.332,
															-0.149
														],
														[
															-0.303,
															-0.164
														],
														[
															-0.816,
															-0.325
														],
														[
															-0.942,
															-0.35
														],
														[
															-0.655,
															-0.225
														],
														[
															0.045,
															0.051
														],
														[
															-0.311,
															-0.994
														],
														[
															-0.14,
															-1.054
														],
														[
															-0.134,
															-0.907
														],
														[
															-0.293,
															-0.555
														],
														[
															-0.125,
															-0.223
														],
														[
															-0.127,
															-0.045
														],
														[
															-0.313,
															-0.049
														],
														[
															-0.684,
															-0.236
														],
														[
															-1.379,
															0.338
														],
														[
															-1.608,
															0.806
														],
														[
															-1.675,
															1.065
														],
														[
															-1.579,
															1.115
														],
														[
															-2.369,
															2.249
														],
														[
															-1.955,
															2.409
														],
														[
															-1.733,
															2.581
														],
														[
															-1.704,
															2.764
														],
														[
															-0.91,
															1.45
														],
														[
															-0.863,
															1.418
														],
														[
															-0.772,
															1.385
														],
														[
															-0.636,
															1.348
														],
														[
															-0.078,
															0.419
														],
														[
															-0.041,
															0.434
														],
														[
															-0.067,
															0.423
														],
														[
															-0.157,
															0.386
														],
														[
															-0.265,
															0.341
														],
														[
															-0.303,
															0.327
														],
														[
															-0.261,
															0.322
														],
														[
															-0.139,
															0.327
														],
														[
															-2.369,
															6.795
														],
														[
															-2.09,
															7.108
														],
														[
															-1.801,
															7.134
														],
														[
															-1.503,
															6.874
														],
														[
															-1.263,
															6.792
														],
														[
															-1.07,
															6.835
														],
														[
															-0.898,
															6.876
														],
														[
															-0.745,
															6.913
														],
														[
															-0.513,
															29.442
														],
														[
															1.861,
															28.869
														],
														[
															4.068,
															26.617
														],
														[
															6.11,
															22.688
														],
														[
															0.593,
															1.753
														],
														[
															0.626,
															1.666
														],
														[
															0.595,
															1.58
														],
														[
															0.501,
															1.494
														],
														[
															0.235,
															0.921
														],
														[
															0.219,
															0.932
														],
														[
															0.25,
															0.92
														],
														[
															0.327,
															0.885
														],
														[
															3.675,
															7.991
														],
														[
															4.62,
															7.309
														],
														[
															5.635,
															5.539
														],
														[
															6.721,
															2.68
														],
														[
															0.832,
															0.331
														],
														[
															0.923,
															0.318
														],
														[
															0.88,
															0.203
														],
														[
															0.702,
															-0.015
														],
														[
															0.165,
															-0.248
														],
														[
															-0.016,
															0.002
														],
														[
															7.361,
															-7.227
														]
													],
													"o": [
														[
															-2.082,
															3.66
														],
														[
															-1.89,
															3.629
														],
														[
															-1.729,
															3.689
														],
														[
															-1.599,
															3.841
														],
														[
															-2.226,
															6.058
														],
														[
															-1.912,
															6.206
														],
														[
															-1.639,
															6.292
														],
														[
															-1.408,
															6.315
														],
														[
															-6.262,
															32.289
														],
														[
															-2.459,
															35.787
														],
														[
															1.338,
															36.314
														],
														[
															5.128,
															33.87
														],
														[
															0.528,
															1.686
														],
														[
															0.591,
															1.489
														],
														[
															0.612,
															1.367
														],
														[
															0.59,
															1.319
														],
														[
															1.198,
															3.069
														],
														[
															1.194,
															2.893
														],
														[
															1.226,
															2.737
														],
														[
															1.294,
															2.6
														],
														[
															0.365,
															0.649
														],
														[
															0.328,
															0.69
														],
														[
															0.316,
															0.692
														],
														[
															0.33,
															0.656
														],
														[
															1.371,
															2.154
														],
														[
															1.919,
															2.628
														],
														[
															2.236,
															2.591
														],
														[
															2.324,
															2.043
														],
														[
															0.079,
															0.036
														],
														[
															0.081,
															0.175
														],
														[
															0.083,
															0.226
														],
														[
															0.086,
															0.188
														],
														[
															0.32,
															0.221
														],
														[
															0.34,
															0.178
														],
														[
															0.344,
															0.154
														],
														[
															0.332,
															0.149
														],
														[
															0.276,
															0.149
														],
														[
															0.816,
															0.325
														],
														[
															0.942,
															0.35
														],
														[
															0.655,
															0.225
														],
														[
															0.647,
															0.73
														],
														[
															0.311,
															0.994
														],
														[
															0.14,
															1.054
														],
														[
															0.134,
															0.907
														],
														[
															0.309,
															0.585
														],
														[
															0.125,
															0.223
														],
														[
															0.127,
															0.045
														],
														[
															0.313,
															0.049
														],
														[
															0.986,
															0.34
														],
														[
															1.379,
															-0.338
														],
														[
															1.608,
															-0.806
														],
														[
															1.675,
															-1.065
														],
														[
															2.976,
															-2.1
														],
														[
															2.369,
															-2.249
														],
														[
															1.955,
															-2.409
														],
														[
															1.733,
															-2.581
														],
														[
															0.911,
															-1.478
														],
														[
															0.91,
															-1.45
														],
														[
															0.863,
															-1.419
														],
														[
															0.772,
															-1.385
														],
														[
															0.178,
															-0.378
														],
														[
															0.078,
															-0.419
														],
														[
															0.041,
															-0.434
														],
														[
															0.067,
															-0.423
														],
														[
															0.148,
															-0.365
														],
														[
															0.265,
															-0.341
														],
														[
															0.303,
															-0.327
														],
														[
															0.261,
															-0.322
														],
														[
															2.639,
															-6.196
														],
														[
															2.369,
															-6.795
														],
														[
															2.09,
															-7.108
														],
														[
															1.801,
															-7.134
														],
														[
															1.475,
															-6.746
														],
														[
															1.263,
															-6.792
														],
														[
															1.07,
															-6.835
														],
														[
															0.898,
															-6.876
														],
														[
															3.053,
															-28.338
														],
														[
															0.513,
															-29.442
														],
														[
															-1.861,
															-28.869
														],
														[
															-4.068,
															-26.617
														],
														[
															-0.496,
															-1.841
														],
														[
															-0.593,
															-1.753
														],
														[
															-0.626,
															-1.666
														],
														[
															-0.595,
															-1.58
														],
														[
															-0.298,
															-0.888
														],
														[
															-0.235,
															-0.921
														],
														[
															-0.219,
															-0.932
														],
														[
															-0.25,
															-0.92
														],
														[
															-2.801,
															-7.584
														],
														[
															-3.675,
															-7.991
														],
														[
															-4.62,
															-7.309
														],
														[
															-5.635,
															-5.539
														],
														[
															-0.605,
															-0.241
														],
														[
															-0.832,
															-0.331
														],
														[
															-0.923,
															-0.318
														],
														[
															-0.88,
															-0.203
														],
														[
															-0.356,
															0.008
														],
														[
															-0.165,
															0.248
														],
														[
															-8.975,
															0.796
														],
														[
															-7.361,
															7.227
														]
													],
													"v": [
														[
															319,
															62
														],
														[
															313.049,
															72.91
														],
														[
															307.627,
															83.865
														],
														[
															302.642,
															95.137
														],
														[
															298,
															107
														],
														[
															291.803,
															125.412
														],
														[
															286.486,
															144.175
														],
														[
															281.927,
															163.1
														],
														[
															278,
															182
														],
														[
															264.921,
															284.856
														],
														[
															263.241,
															393.749
														],
														[
															272.941,
															499.767
														],
														[
															294,
															594
														],
														[
															295.689,
															598.744
														],
														[
															297.503,
															603.009
														],
														[
															299.316,
															607.019
														],
														[
															301,
															611
														],
														[
															304.58,
															619.938
														],
														[
															308.202,
															628.379
														],
														[
															311.973,
															636.38
														],
														[
															316,
															644
														],
														[
															317.032,
															646.017
														],
														[
															317.992,
															648.101
														],
														[
															318.955,
															650.133
														],
														[
															320,
															652
														],
														[
															324.993,
															659.3
														],
														[
															331.283,
															667.255
														],
														[
															338.181,
															674.332
														],
														[
															345,
															679
														],
														[
															345.24,
															679.338
														],
														[
															345.485,
															679.961
														],
														[
															345.737,
															680.603
														],
														[
															346,
															681
														],
														[
															346.994,
															681.594
														],
														[
															348.025,
															682.087
														],
														[
															349.044,
															682.536
														],
														[
															350,
															683
														],
														[
															351.742,
															683.749
														],
														[
															354.483,
															684.8
														],
														[
															356.982,
															685.701
														],
														[
															358,
															686
														],
														[
															359.395,
															688.637
														],
														[
															360.03,
															691.761
														],
														[
															360.4,
															694.754
														],
														[
															361,
															697
														],
														[
															361.605,
															698.167
														],
														[
															361.936,
															698.524
														],
														[
															362.55,
															698.619
														],
														[
															364,
															699
														],
														[
															367.589,
															698.951
														],
														[
															372.111,
															697.182
														],
														[
															377.077,
															694.323
														],
														[
															382,
															691
														],
														[
															389.969,
															684.479
														],
														[
															396.407,
															677.496
														],
														[
															401.892,
															670.015
														],
														[
															407,
															662
														],
														[
															409.743,
															657.607
														],
														[
															412.413,
															653.304
														],
														[
															414.877,
															649.099
														],
														[
															417,
															645
														],
														[
															417.369,
															643.798
														],
														[
															417.532,
															642.512
														],
														[
															417.679,
															641.22
														],
														[
															418,
															640
														],
														[
															418.64,
															638.944
														],
														[
															419.513,
															637.944
														],
														[
															420.379,
															636.973
														],
														[
															421,
															636
														],
														[
															428.514,
															616.443
														],
														[
															435.204,
															595.517
														],
														[
															441.042,
															574.084
														],
														[
															446,
															553
														],
														[
															450.101,
															532.692
														],
														[
															453.595,
															512.25
														],
														[
															456.542,
															491.683
														],
														[
															459,
															471
														],
														[
															464.307,
															383.91
														],
														[
															462.244,
															296.024
														],
														[
															453.309,
															212.376
														],
														[
															438,
															138
														],
														[
															436.351,
															132.609
														],
														[
															434.508,
															127.48
														],
														[
															432.66,
															122.611
														],
														[
															431,
															118
														],
														[
															430.213,
															115.282
														],
														[
															429.544,
															112.497
														],
														[
															428.853,
															109.713
														],
														[
															428,
															107
														],
														[
															418.304,
															83.365
														],
														[
															405.879,
															60.144
														],
														[
															390.515,
															40.6
														],
														[
															372,
															28
														],
														[
															369.812,
															27.116
														],
														[
															367.146,
															26.116
														],
														[
															364.407,
															25.308
														],
														[
															362,
															25
														],
														[
															361.221,
															25.507
														],
														[
															361,
															26
														],
														[
															335.955,
															39.876
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 73,
											"s": [
												{
													"i": [
														[
															0.507,
															-0.245
														],
														[
															1.132,
															-0.763
														],
														[
															0.939,
															-0.838
														],
														[
															0.838,
															-0.906
														],
														[
															0.828,
															-0.968
														],
														[
															0.734,
															-0.871
														],
														[
															0.701,
															-0.862
														],
														[
															0.616,
															-0.81
														],
														[
															0.48,
															-0.716
														],
														[
															1.293,
															-2.315
														],
														[
															1.151,
															-2.381
														],
														[
															1.033,
															-2.376
														],
														[
															0.938,
															-2.299
														],
														[
															1.59,
															-4.453
														],
														[
															1.411,
															-4.519
														],
														[
															1.24,
															-4.557
														],
														[
															1.079,
															-4.565
														],
														[
															0.716,
															-3.353
														],
														[
															0.66,
															-3.357
														],
														[
															0.614,
															-3.325
														],
														[
															0.578,
															-3.258
														],
														[
															1.642,
															-13.909
														],
														[
															1.062,
															-14.231
														],
														[
															0.764,
															-15.082
														],
														[
															0.748,
															-16.462
														],
														[
															-0.062,
															-3.829
														],
														[
															-0.168,
															-3.85
														],
														[
															-0.147,
															-3.846
														],
														[
															0,
															-3.817
														],
														[
															-0.105,
															-3.867
														],
														[
															-0.184,
															-3.843
														],
														[
															-0.237,
															-3.804
														],
														[
															-0.263,
															-3.75
														],
														[
															-1.636,
															-15.286
														],
														[
															-2.269,
															-14.655
														],
														[
															-2.999,
															-13.792
														],
														[
															-3.825,
															-12.696
														],
														[
															-0.249,
															-0.766
														],
														[
															-0.259,
															-0.763
														],
														[
															-0.255,
															-0.74
														],
														[
															-0.239,
															-0.698
														],
														[
															-1.627,
															-4.011
														],
														[
															-1.805,
															-3.861
														],
														[
															-1.901,
															-3.544
														],
														[
															-1.913,
															-3.061
														],
														[
															-1.02,
															-1.328
														],
														[
															-1.121,
															-1.26
														],
														[
															-1.166,
															-1.178
														],
														[
															-1.154,
															-1.079
														],
														[
															-0.36,
															-0.265
														],
														[
															-0.332,
															-0.217
														],
														[
															-0.306,
															-0.218
														],
														[
															-0.282,
															-0.27
														],
														[
															-0.254,
															-0.161
														],
														[
															-0.269,
															-0.149
														],
														[
															-0.256,
															-0.163
														],
														[
															-0.212,
															-0.204
														],
														[
															-0.186,
															-0.089
														],
														[
															-0.227,
															-0.1
														],
														[
															-0.177,
															-0.086
														],
														[
															-0.037,
															-0.046
														],
														[
															-0.357,
															-1.336
														],
														[
															-0.179,
															-1.204
														],
														[
															-0.482,
															-0.891
														],
														[
															-1.267,
															-0.397
														],
														[
															-1.158,
															0.57
														],
														[
															-1.321,
															0.871
														],
														[
															-1.002,
															0.74
														],
														[
															-0.202,
															0.179
														],
														[
															-1.125,
															1.182
														],
														[
															-1.074,
															1.267
														],
														[
															-0.912,
															1.202
														],
														[
															-0.64,
															0.986
														],
														[
															-0.233,
															0.824
														],
														[
															-0.51,
															0.849
														],
														[
															-0.574,
															0.45
														],
														[
															-0.372,
															0.65
														],
														[
															-0.287,
															0.856
														],
														[
															-0.404,
															0.793
														],
														[
															-2.872,
															7.696
														],
														[
															-2.528,
															8.4
														],
														[
															-1.052,
															3.338
														],
														[
															-0.798,
															3.341
														],
														[
															-0.593,
															3.699
														],
														[
															-0.784,
															3.664
														],
														[
															-2.558,
															54.347
														],
														[
															4.073,
															50.582
														],
														[
															5.988,
															31.93
														],
														[
															10.391,
															25.291
														],
														[
															0.092,
															0.865
														],
														[
															0.313,
															0.77
														],
														[
															0.595,
															0.648
														],
														[
															0.347,
															0.733
														],
														[
															1.806,
															3.596
														],
														[
															2.012,
															2.896
														],
														[
															1.497,
															1.849
														],
														[
															1.606,
															1.581
														],
														[
															3.252,
															1.355
														],
														[
															3.583,
															-0.776
														],
														[
															0.441,
															-0.149
														]
													],
													"o": [
														[
															-1.416,
															0.683
														],
														[
															-1.132,
															0.763
														],
														[
															-0.939,
															0.837
														],
														[
															-0.838,
															0.906
														],
														[
															-0.716,
															0.837
														],
														[
															-0.734,
															0.871
														],
														[
															-0.701,
															0.862
														],
														[
															-0.616,
															0.81
														],
														[
															-1.458,
															2.177
														],
														[
															-1.293,
															2.315
														],
														[
															-1.151,
															2.381
														],
														[
															-1.033,
															2.376
														],
														[
															-1.778,
															4.358
														],
														[
															-1.59,
															4.453
														],
														[
															-1.411,
															4.519
														],
														[
															-1.24,
															4.557
														],
														[
															-0.783,
															3.314
														],
														[
															-0.716,
															3.353
														],
														[
															-0.66,
															3.357
														],
														[
															-0.614,
															3.325
														],
														[
															-2.505,
															14.115
														],
														[
															-1.642,
															13.909
														],
														[
															-1.062,
															14.231
														],
														[
															-0.764,
															15.082
														],
														[
															-0.172,
															3.784
														],
														[
															0.062,
															3.829
														],
														[
															0.168,
															3.85
														],
														[
															0.147,
															3.846
														],
														[
															0,
															3.876
														],
														[
															0.105,
															3.867
														],
														[
															0.184,
															3.843
														],
														[
															0.237,
															3.804
														],
														[
															1.1,
															15.684
														],
														[
															1.636,
															15.286
														],
														[
															2.269,
															14.655
														],
														[
															2.999,
															13.792
														],
														[
															0.226,
															0.751
														],
														[
															0.249,
															0.766
														],
														[
															0.259,
															0.763
														],
														[
															0.255,
															0.74
														],
														[
															1.365,
															3.996
														],
														[
															1.627,
															4.011
														],
														[
															1.805,
															3.861
														],
														[
															1.901,
															3.544
														],
														[
															0.862,
															1.379
														],
														[
															1.02,
															1.328
														],
														[
															1.121,
															1.26
														],
														[
															1.166,
															1.178
														],
														[
															0.389,
															0.364
														],
														[
															0.36,
															0.265
														],
														[
															0.332,
															0.217
														],
														[
															0.306,
															0.218
														],
														[
															0.209,
															0.201
														],
														[
															0.254,
															0.161
														],
														[
															0.269,
															0.149
														],
														[
															0.256,
															0.163
														],
														[
															0.055,
															0.053
														],
														[
															0.186,
															0.089
														],
														[
															0.227,
															0.1
														],
														[
															0.177,
															0.086
														],
														[
															1.017,
															1.286
														],
														[
															0.357,
															1.336
														],
														[
															0.179,
															1.204
														],
														[
															0.482,
															0.891
														],
														[
															0.514,
															0.161
														],
														[
															1.158,
															-0.57
														],
														[
															1.321,
															-0.871
														],
														[
															1.002,
															-0.74
														],
														[
															1.065,
															-0.945
														],
														[
															1.125,
															-1.182
														],
														[
															1.074,
															-1.267
														],
														[
															0.912,
															-1.202
														],
														[
															0.557,
															-0.857
														],
														[
															0.233,
															-0.824
														],
														[
															0.331,
															-0.551
														],
														[
															0.574,
															-0.45
														],
														[
															0.447,
															-0.783
														],
														[
															0.287,
															-0.856
														],
														[
															3.983,
															-7.815
														],
														[
															2.872,
															-7.696
														],
														[
															0.995,
															-3.308
														],
														[
															1.052,
															-3.338
														],
														[
															0.846,
															-3.542
														],
														[
															0.593,
															-3.698
														],
														[
															9.841,
															-46.029
														],
														[
															2.558,
															-54.347
														],
														[
															-2.657,
															-32.99
														],
														[
															-5.988,
															-31.93
														],
														[
															-0.317,
															-0.77
														],
														[
															-0.092,
															-0.865
														],
														[
															-0.274,
															-0.674
														],
														[
															-0.595,
															-0.648
														],
														[
															-1.764,
															-3.721
														],
														[
															-1.806,
															-3.596
														],
														[
															-1.406,
															-2.023
														],
														[
															-1.497,
															-1.849
														],
														[
															-3.409,
															-3.355
														],
														[
															-3.252,
															-1.355
														],
														[
															-0.727,
															0.157
														],
														[
															-0.441,
															0.149
														]
													],
													"v": [
														[
															356,
															28
														],
														[
															352.202,
															30.17
														],
														[
															349.119,
															32.573
														],
														[
															346.477,
															35.189
														],
														[
															344,
															38
														],
														[
															341.811,
															40.571
														],
														[
															339.645,
															43.181
														],
														[
															337.656,
															45.7
														],
														[
															336,
															48
														],
														[
															331.88,
															54.756
														],
														[
															328.22,
															61.818
														],
														[
															324.95,
															68.971
														],
														[
															322,
															76
														],
														[
															316.95,
															89.223
														],
														[
															312.451,
															102.689
														],
														[
															308.477,
															116.31
														],
														[
															305,
															130
														],
														[
															302.754,
															140.01
														],
														[
															300.692,
															150.084
														],
														[
															298.785,
															160.116
														],
														[
															297,
															170
														],
														[
															290.849,
															211.903
														],
														[
															286.864,
															253.98
														],
														[
															284.196,
															297.817
														],
														[
															282,
															345
														],
														[
															281.866,
															356.425
														],
														[
															282.242,
															367.949
														],
														[
															282.747,
															379.499
														],
														[
															283,
															391
														],
														[
															283.165,
															402.619
														],
														[
															283.606,
															414.189
														],
														[
															284.244,
															425.664
														],
														[
															285,
															437
														],
														[
															289.079,
															483.513
														],
														[
															294.911,
															528.483
														],
														[
															302.788,
															571.211
														],
														[
															313,
															611
														],
														[
															313.716,
															613.281
														],
														[
															314.482,
															615.579
														],
														[
															315.256,
															617.838
														],
														[
															316,
															620
														],
														[
															320.509,
															632.053
														],
														[
															325.678,
															643.903
														],
														[
															331.258,
															655.051
														],
														[
															337,
															665
														],
														[
															339.837,
															669.064
														],
														[
															343.062,
															672.95
														],
														[
															346.507,
															676.611
														],
														[
															350,
															680
														],
														[
															351.123,
															680.931
														],
														[
															352.161,
															681.641
														],
														[
															353.118,
															682.28
														],
														[
															354,
															683
														],
														[
															354.703,
															683.537
														],
														[
															355.495,
															683.995
														],
														[
															356.291,
															684.457
														],
														[
															357,
															685
														],
														[
															357.384,
															685.219
														],
														[
															358.027,
															685.51
														],
														[
															358.657,
															685.796
														],
														[
															359,
															686
														],
														[
															360.94,
															689.977
														],
														[
															361.624,
															693.833
														],
														[
															362.496,
															697.022
														],
														[
															365,
															699
														],
														[
															367.629,
															698.279
														],
														[
															371.468,
															696.01
														],
														[
															375.074,
															693.487
														],
														[
															377,
															692
														],
														[
															380.311,
															688.773
														],
														[
															383.637,
															685.061
														],
														[
															386.644,
															681.32
														],
														[
															389,
															678
														],
														[
															390.035,
															675.494
														],
														[
															391,
															673
														],
														[
															392.469,
															671.575
														],
														[
															394,
															670
														],
														[
															395.032,
															667.508
														],
														[
															396,
															665
														],
														[
															406.092,
															641.939
														],
														[
															414,
															618
														],
														[
															417.148,
															608.025
														],
														[
															420,
															598
														],
														[
															422.047,
															587.092
														],
														[
															424,
															576
														],
														[
															442.435,
															422.415
														],
														[
															440,
															262
														],
														[
															427.3,
															163.226
														],
														[
															403,
															76
														],
														[
															402.498,
															73.5
														],
														[
															402,
															71
														],
														[
															400.555,
															69.044
														],
														[
															399,
															67
														],
														[
															393.687,
															55.881
														],
														[
															388,
															46
														],
														[
															383.65,
															40.168
														],
														[
															379,
															35
														],
														[
															369.131,
															27.902
														],
														[
															359,
															27
														],
														[
															357.335,
															27.435
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 74,
											"s": [
												{
													"i": [
														[
															-1.596,
															6.391
														],
														[
															-0.759,
															3.337
														],
														[
															-0.708,
															3.409
														],
														[
															-0.66,
															3.471
														],
														[
															-0.616,
															3.524
														],
														[
															-0.575,
															3.569
														],
														[
															-0.537,
															3.603
														],
														[
															-0.503,
															3.629
														],
														[
															-0.472,
															3.646
														],
														[
															-0.811,
															7.377
														],
														[
															-0.69,
															7.531
														],
														[
															-0.572,
															7.662
														],
														[
															-0.454,
															7.77
														],
														[
															-0.339,
															7.855
														],
														[
															-0.224,
															7.917
														],
														[
															-0.111,
															7.955
														],
														[
															0,
															7.97
														],
														[
															0.101,
															8.028
														],
														[
															0.209,
															7.988
														],
														[
															0.322,
															7.928
														],
														[
															0.442,
															7.847
														],
														[
															0.568,
															7.745
														],
														[
															0.7,
															7.623
														],
														[
															0.838,
															7.479
														],
														[
															0.982,
															7.315
														],
														[
															0.746,
															5.259
														],
														[
															0.823,
															5.279
														],
														[
															0.925,
															5.25
														],
														[
															1.054,
															5.172
														],
														[
															1.21,
															5.045
														],
														[
															1.392,
															4.869
														],
														[
															1.601,
															4.644
														],
														[
															1.836,
															4.371
														],
														[
															0.707,
															1.501
														],
														[
															0.927,
															1.757
														],
														[
															1.097,
															1.812
														],
														[
															1.216,
															1.664
														],
														[
															1.286,
															1.314
														],
														[
															1.306,
															0.762
														],
														[
															1.276,
															0.008
														],
														[
															1.197,
															-0.948
														],
														[
															1.625,
															-1.837
														],
														[
															1.478,
															-2.205
														],
														[
															1.343,
															-2.518
														],
														[
															1.219,
															-2.774
														],
														[
															1.107,
															-2.975
														],
														[
															1.007,
															-3.119
														],
														[
															0.918,
															-3.208
														],
														[
															0.84,
															-3.241
														],
														[
															1.451,
															-6.54
														],
														[
															1.232,
															-6.563
														],
														[
															1.042,
															-6.618
														],
														[
															0.881,
															-6.705
														],
														[
															0.749,
															-6.825
														],
														[
															0.646,
															-6.977
														],
														[
															0.571,
															-7.162
														],
														[
															0.526,
															-7.378
														],
														[
															0.544,
															-13.098
														],
														[
															0.19,
															-13.278
														],
														[
															-0.154,
															-13.308
														],
														[
															-0.487,
															-13.189
														],
														[
															-0.809,
															-12.922
														],
														[
															-1.121,
															-12.505
														],
														[
															-1.422,
															-11.939
														],
														[
															-1.712,
															-11.223
														],
														[
															-0.494,
															-2.952
														],
														[
															-0.531,
															-2.919
														],
														[
															-0.564,
															-2.876
														],
														[
															-0.594,
															-2.821
														],
														[
															-0.619,
															-2.755
														],
														[
															-0.641,
															-2.679
														],
														[
															-0.658,
															-2.591
														],
														[
															-0.672,
															-2.493
														],
														[
															-0.435,
															-1.554
														],
														[
															-0.451,
															-1.535
														],
														[
															-0.47,
															-1.509
														],
														[
															-0.492,
															-1.477
														],
														[
															-0.517,
															-1.437
														],
														[
															-0.545,
															-1.391
														],
														[
															-0.576,
															-1.338
														],
														[
															-0.61,
															-1.278
														],
														[
															-0.328,
															-0.689
														],
														[
															-0.341,
															-0.697
														],
														[
															-0.343,
															-0.659
														],
														[
															-0.334,
															-0.577
														],
														[
															-0.79,
															-1.018
														],
														[
															-0.885,
															-0.988
														],
														[
															-0.902,
															-0.976
														],
														[
															-0.841,
															-0.983
														],
														[
															-0.466,
															-0.459
														],
														[
															-0.409,
															-0.417
														],
														[
															-0.363,
															-0.499
														],
														[
															-0.33,
															-0.706
														],
														[
															-0.08,
															-0.794
														],
														[
															-0.076,
															-0.79
														],
														[
															-0.333,
															-0.726
														],
														[
															-0.85,
															-0.6
														],
														[
															-3.358,
															4.898
														],
														[
															-2.458,
															5.708
														],
														[
															-1.87,
															6.206
														]
													],
													"o": [
														[
															0.813,
															-3.256
														],
														[
															0.759,
															-3.337
														],
														[
															0.708,
															-3.409
														],
														[
															0.66,
															-3.471
														],
														[
															0.616,
															-3.524
														],
														[
															0.575,
															-3.569
														],
														[
															0.537,
															-3.603
														],
														[
															0.503,
															-3.629
														],
														[
															0.932,
															-7.199
														],
														[
															0.811,
															-7.377
														],
														[
															0.69,
															-7.531
														],
														[
															0.572,
															-7.662
														],
														[
															0.454,
															-7.77
														],
														[
															0.339,
															-7.855
														],
														[
															0.224,
															-7.917
														],
														[
															0.111,
															-7.955
														],
														[
															0,
															-8.046
														],
														[
															-0.101,
															-8.028
														],
														[
															-0.209,
															-7.988
														],
														[
															-0.322,
															-7.928
														],
														[
															-0.442,
															-7.847
														],
														[
															-0.568,
															-7.745
														],
														[
															-0.7,
															-7.623
														],
														[
															-0.838,
															-7.479
														],
														[
															-0.697,
															-5.191
														],
														[
															-0.746,
															-5.259
														],
														[
															-0.823,
															-5.279
														],
														[
															-0.925,
															-5.25
														],
														[
															-1.054,
															-5.172
														],
														[
															-1.21,
															-5.045
														],
														[
															-1.392,
															-4.869
														],
														[
															-1.601,
															-4.644
														],
														[
															-0.438,
															-1.042
														],
														[
															-0.707,
															-1.501
														],
														[
															-0.927,
															-1.757
														],
														[
															-1.097,
															-1.812
														],
														[
															-1.216,
															-1.664
														],
														[
															-1.286,
															-1.314
														],
														[
															-1.306,
															-0.762
														],
														[
															-1.276,
															-0.008
														],
														[
															-1.783,
															1.413
														],
														[
															-1.625,
															1.837
														],
														[
															-1.478,
															2.205
														],
														[
															-1.343,
															2.518
														],
														[
															-1.219,
															2.774
														],
														[
															-1.107,
															2.975
														],
														[
															-1.007,
															3.119
														],
														[
															-0.918,
															3.208
														],
														[
															-1.698,
															6.55
														],
														[
															-1.451,
															6.54
														],
														[
															-1.232,
															6.563
														],
														[
															-1.042,
															6.618
														],
														[
															-0.881,
															6.705
														],
														[
															-0.749,
															6.825
														],
														[
															-0.646,
															6.977
														],
														[
															-0.571,
															7.162
														],
														[
															-0.91,
															12.769
														],
														[
															-0.544,
															13.098
														],
														[
															-0.19,
															13.278
														],
														[
															0.154,
															13.308
														],
														[
															0.487,
															13.189
														],
														[
															0.809,
															12.922
														],
														[
															1.121,
															12.505
														],
														[
															1.422,
															11.939
														],
														[
															0.454,
															2.973
														],
														[
															0.494,
															2.952
														],
														[
															0.531,
															2.919
														],
														[
															0.564,
															2.876
														],
														[
															0.594,
															2.821
														],
														[
															0.619,
															2.755
														],
														[
															0.641,
															2.679
														],
														[
															0.658,
															2.591
														],
														[
															0.422,
															1.566
														],
														[
															0.435,
															1.554
														],
														[
															0.451,
															1.535
														],
														[
															0.47,
															1.509
														],
														[
															0.492,
															1.477
														],
														[
															0.517,
															1.437
														],
														[
															0.545,
															1.391
														],
														[
															0.576,
															1.338
														],
														[
															0.304,
															0.637
														],
														[
															0.328,
															0.689
														],
														[
															0.341,
															0.697
														],
														[
															0.343,
															0.659
														],
														[
															0.618,
															1.067
														],
														[
															0.79,
															1.018
														],
														[
															0.885,
															0.988
														],
														[
															0.902,
															0.976
														],
														[
															0.536,
															0.625
														],
														[
															0.466,
															0.459
														],
														[
															0.409,
															0.417
														],
														[
															0.363,
															0.499
														],
														[
															0.345,
															0.738
														],
														[
															0.08,
															0.794
														],
														[
															0.076,
															0.791
														],
														[
															0.333,
															0.726
														],
														[
															4.572,
															-3.777
														],
														[
															3.358,
															-4.898
														],
														[
															2.458,
															-5.708
														],
														[
															1.87,
															-6.206
														]
													],
													"v": [
														[
															397,
															632
														],
														[
															399.358,
															622.107
														],
														[
															401.558,
															611.986
														],
														[
															403.61,
															601.664
														],
														[
															405.524,
															591.168
														],
														[
															407.31,
															580.526
														],
														[
															408.978,
															569.766
														],
														[
															410.538,
															558.915
														],
														[
															412,
															548
														],
														[
															414.614,
															526.131
														],
														[
															416.865,
															503.763
														],
														[
															418.757,
															480.967
														],
														[
															420.296,
															457.813
														],
														[
															421.486,
															434.369
														],
														[
															422.33,
															410.706
														],
														[
															422.833,
															386.893
														],
														[
															423,
															363
														],
														[
															422.849,
															338.884
														],
														[
															422.386,
															314.854
														],
														[
															421.59,
															290.974
														],
														[
															420.445,
															267.305
														],
														[
															418.931,
															243.911
														],
														[
															417.032,
															220.854
														],
														[
															414.727,
															198.196
														],
														[
															412,
															176
														],
														[
															409.842,
															160.313
														],
														[
															407.496,
															144.492
														],
														[
															404.881,
															128.686
														],
														[
															401.918,
															113.04
														],
														[
															398.528,
															97.701
														],
														[
															394.631,
															82.817
														],
														[
															390.148,
															68.535
														],
														[
															385,
															55
														],
														[
															383.27,
															51.136
														],
														[
															380.807,
															46.198
														],
														[
															377.759,
															40.795
														],
														[
															374.277,
															35.53
														],
														[
															370.51,
															31.012
														],
														[
															366.609,
															27.847
														],
														[
															362.722,
															26.641
														],
														[
															359,
															28
														],
														[
															353.892,
															32.888
														],
														[
															349.241,
															38.965
														],
														[
															345.012,
															46.063
														],
														[
															341.172,
															54.014
														],
														[
															337.685,
															62.651
														],
														[
															334.518,
															71.807
														],
														[
															331.634,
															81.312
														],
														[
															329,
															91
														],
														[
															324.284,
															110.628
														],
														[
															320.266,
															130.275
														],
														[
															316.861,
															150.039
														],
														[
															313.982,
															170.016
														],
														[
															311.543,
															190.303
														],
														[
															309.458,
															210.998
														],
														[
															307.639,
															232.198
														],
														[
															306,
															254
														],
														[
															303.821,
															292.837
														],
														[
															302.722,
															332.438
														],
														[
															302.671,
															372.353
														],
														[
															303.635,
															412.137
														],
														[
															305.582,
															451.341
														],
														[
															308.48,
															489.518
														],
														[
															312.297,
															526.22
														],
														[
															317,
															561
														],
														[
															318.423,
															569.89
														],
														[
															319.962,
															578.699
														],
														[
															321.606,
															587.394
														],
														[
															323.343,
															595.942
														],
														[
															325.163,
															604.309
														],
														[
															327.053,
															612.463
														],
														[
															329.003,
															620.371
														],
														[
															331,
															628
														],
														[
															332.285,
															632.681
														],
														[
															333.614,
															637.315
														],
														[
															334.995,
															641.883
														],
														[
															336.437,
															646.363
														],
														[
															337.95,
															650.736
														],
														[
															339.542,
															654.98
														],
														[
															341.222,
															659.075
														],
														[
															343,
															663
														],
														[
															343.95,
															665
														],
														[
															344.955,
															667.09
														],
														[
															345.982,
															669.135
														],
														[
															347,
															671
														],
														[
															349.131,
															674.122
														],
														[
															351.664,
															677.125
														],
														[
															354.365,
															680.066
														],
														[
															357,
															683
														],
														[
															358.499,
															684.596
														],
														[
															359.808,
															685.879
														],
														[
															360.963,
															687.223
														],
														[
															362,
															689
														],
														[
															362.573,
															691.314
														],
														[
															362.743,
															693.706
														],
														[
															363.291,
															695.996
														],
														[
															365,
															698
														],
														[
															376.818,
															684.909
														],
														[
															385.464,
															668.922
														],
														[
															391.878,
															650.973
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 75,
											"s": [
												{
													"i": [
														[
															-0.302,
															0.591
														],
														[
															-0.255,
															0.542
														],
														[
															-0.242,
															0.548
														],
														[
															-0.227,
															0.544
														],
														[
															-0.211,
															0.529
														],
														[
															-0.194,
															0.503
														],
														[
															-0.176,
															0.466
														],
														[
															-0.157,
															0.419
														],
														[
															-0.137,
															0.36
														],
														[
															-0.053,
															0.195
														],
														[
															-0.039,
															0.201
														],
														[
															-0.031,
															0.205
														],
														[
															-0.027,
															0.21
														],
														[
															-0.03,
															0.213
														],
														[
															-0.037,
															0.217
														],
														[
															-0.05,
															0.22
														],
														[
															-0.068,
															0.222
														],
														[
															-0.715,
															2.68
														],
														[
															-0.635,
															2.738
														],
														[
															-0.568,
															2.792
														],
														[
															-0.511,
															2.843
														],
														[
															-0.466,
															2.89
														],
														[
															-0.433,
															2.933
														],
														[
															-0.411,
															2.974
														],
														[
															-0.4,
															3.01
														],
														[
															-0.33,
															2.565
														],
														[
															-0.322,
															2.595
														],
														[
															-0.311,
															2.619
														],
														[
															-0.298,
															2.638
														],
														[
															-0.283,
															2.653
														],
														[
															-0.264,
															2.662
														],
														[
															-0.244,
															2.666
														],
														[
															-0.221,
															2.666
														],
														[
															-0.866,
															14.487
														],
														[
															-0.574,
															14.846
														],
														[
															-0.283,
															15.076
														],
														[
															0.005,
															15.177
														],
														[
															0.292,
															15.149
														],
														[
															0.576,
															14.992
														],
														[
															0.859,
															14.707
														],
														[
															1.14,
															14.292
														],
														[
															0.452,
															5.177
														],
														[
															0.516,
															5.269
														],
														[
															0.591,
															5.296
														],
														[
															0.677,
															5.257
														],
														[
															0.776,
															5.154
														],
														[
															0.885,
															4.985
														],
														[
															1.007,
															4.75
														],
														[
															1.14,
															4.451
														],
														[
															0.461,
															1.723
														],
														[
															0.476,
															1.661
														],
														[
															0.497,
															1.578
														],
														[
															0.525,
															1.473
														],
														[
															0.559,
															1.348
														],
														[
															0.599,
															1.201
														],
														[
															0.646,
															1.032
														],
														[
															0.698,
															0.843
														],
														[
															0.431,
															0.253
														],
														[
															0.369,
															-0.029
														],
														[
															0.316,
															-0.243
														],
														[
															0.271,
															-0.389
														],
														[
															0.233,
															-0.468
														],
														[
															0.203,
															-0.478
														],
														[
															0.182,
															-0.421
														],
														[
															0.168,
															-0.296
														],
														[
															0.272,
															-0.251
														],
														[
															0.306,
															-0.243
														],
														[
															0.256,
															-0.245
														],
														[
															0.121,
															-0.258
														],
														[
															0.076,
															-0.407
														],
														[
															0.05,
															-0.448
														],
														[
															0.074,
															-0.442
														],
														[
															0.148,
															-0.389
														],
														[
															0.621,
															-1.759
														],
														[
															0.581,
															-1.804
														],
														[
															0.544,
															-1.894
														],
														[
															0.513,
															-2.026
														],
														[
															1.78,
															-10.061
														],
														[
															1.351,
															-10.501
														],
														[
															1.021,
															-10.44
														],
														[
															0.788,
															-9.878
														],
														[
															0.773,
															-14.769
														],
														[
															0.469,
															-15.122
														],
														[
															0.211,
															-15.167
														],
														[
															0,
															-14.905
														],
														[
															-0.632,
															-22.65
														],
														[
															-1.406,
															-21.728
														],
														[
															-2.321,
															-20.589
														],
														[
															-3.378,
															-19.233
														],
														[
															-0.947,
															-4.816
														],
														[
															-1.169,
															-4.622
														],
														[
															-1.512,
															-4.245
														],
														[
															-1.978,
															-3.685
														],
														[
															-0.933,
															-1.287
														],
														[
															-0.823,
															-1.371
														],
														[
															-0.354,
															-1.524
														],
														[
															0.475,
															-1.745
														],
														[
															-0.515,
															0.409
														],
														[
															-0.363,
															0.56
														],
														[
															-0.292,
															0.621
														]
													],
													"o": [
														[
															0.268,
															-0.524
														],
														[
															0.255,
															-0.542
														],
														[
															0.242,
															-0.548
														],
														[
															0.227,
															-0.544
														],
														[
															0.211,
															-0.529
														],
														[
															0.194,
															-0.503
														],
														[
															0.176,
															-0.466
														],
														[
															0.157,
															-0.419
														],
														[
															0.072,
															-0.189
														],
														[
															0.053,
															-0.195
														],
														[
															0.039,
															-0.201
														],
														[
															0.031,
															-0.205
														],
														[
															0.027,
															-0.21
														],
														[
															0.03,
															-0.213
														],
														[
															0.037,
															-0.217
														],
														[
															0.05,
															-0.22
														],
														[
															0.805,
															-2.619
														],
														[
															0.715,
															-2.68
														],
														[
															0.635,
															-2.738
														],
														[
															0.568,
															-2.792
														],
														[
															0.511,
															-2.843
														],
														[
															0.466,
															-2.89
														],
														[
															0.433,
															-2.933
														],
														[
															0.411,
															-2.974
														],
														[
															0.336,
															-2.531
														],
														[
															0.33,
															-2.565
														],
														[
															0.322,
															-2.595
														],
														[
															0.311,
															-2.619
														],
														[
															0.298,
															-2.638
														],
														[
															0.283,
															-2.653
														],
														[
															0.264,
															-2.662
														],
														[
															0.244,
															-2.666
														],
														[
															1.16,
															-13.999
														],
														[
															0.866,
															-14.487
														],
														[
															0.574,
															-14.846
														],
														[
															0.283,
															-15.076
														],
														[
															-0.005,
															-15.177
														],
														[
															-0.292,
															-15.149
														],
														[
															-0.576,
															-14.992
														],
														[
															-0.859,
															-14.707
														],
														[
															-0.4,
															-5.02
														],
														[
															-0.452,
															-5.177
														],
														[
															-0.516,
															-5.269
														],
														[
															-0.591,
															-5.296
														],
														[
															-0.677,
															-5.257
														],
														[
															-0.776,
															-5.154
														],
														[
															-0.885,
															-4.985
														],
														[
															-1.007,
															-4.75
														],
														[
															-0.452,
															-1.764
														],
														[
															-0.461,
															-1.723
														],
														[
															-0.476,
															-1.661
														],
														[
															-0.497,
															-1.578
														],
														[
															-0.525,
															-1.473
														],
														[
															-0.559,
															-1.348
														],
														[
															-0.599,
															-1.201
														],
														[
															-0.646,
															-1.032
														],
														[
															-0.5,
															-0.603
														],
														[
															-0.431,
															-0.253
														],
														[
															-0.369,
															0.029
														],
														[
															-0.316,
															0.243
														],
														[
															-0.271,
															0.389
														],
														[
															-0.233,
															0.468
														],
														[
															-0.203,
															0.478
														],
														[
															-0.182,
															0.421
														],
														[
															-0.153,
															0.27
														],
														[
															-0.272,
															0.251
														],
														[
															-0.306,
															0.243
														],
														[
															-0.256,
															0.245
														],
														[
															-0.15,
															0.32
														],
														[
															-0.076,
															0.407
														],
														[
															-0.05,
															0.448
														],
														[
															-0.074,
															0.442
														],
														[
															-0.665,
															1.757
														],
														[
															-0.621,
															1.759
														],
														[
															-0.581,
															1.804
														],
														[
															-0.544,
															1.894
														],
														[
															-2.307,
															9.12
														],
														[
															-1.78,
															10.061
														],
														[
															-1.351,
															10.5
														],
														[
															-1.021,
															10.44
														],
														[
															-1.125,
															14.108
														],
														[
															-0.773,
															14.769
														],
														[
															-0.469,
															15.122
														],
														[
															-0.211,
															15.167
														],
														[
															0,
															23.356
														],
														[
															0.632,
															22.65
														],
														[
															1.405,
															21.728
														],
														[
															2.321,
															20.589
														],
														[
															0.847,
															4.826
														],
														[
															0.947,
															4.816
														],
														[
															1.169,
															4.622
														],
														[
															1.512,
															4.245
														],
														[
															0.682,
															1.271
														],
														[
															0.933,
															1.287
														],
														[
															0.823,
															1.371
														],
														[
															0.354,
															1.524
														],
														[
															0.748,
															-0.167
														],
														[
															0.515,
															-0.409
														],
														[
															0.363,
															-0.56
														],
														[
															0.292,
															-0.621
														]
													],
													"v": [
														[
															369,
															689
														],
														[
															369.785,
															687.399
														],
														[
															370.531,
															685.761
														],
														[
															371.234,
															684.12
														],
														[
															371.892,
															682.508
														],
														[
															372.5,
															680.957
														],
														[
															373.057,
															679.501
														],
														[
															373.558,
															678.171
														],
														[
															374,
															677
														],
														[
															374.187,
															676.423
														],
														[
															374.323,
															675.829
														],
														[
															374.426,
															675.22
														],
														[
															374.512,
															674.597
														],
														[
															374.596,
															673.963
														],
														[
															374.695,
															673.317
														],
														[
															374.824,
															672.662
														],
														[
															375,
															672
														],
														[
															377.277,
															664.05
														],
														[
															379.3,
															655.922
														],
														[
															381.101,
															647.626
														],
														[
															382.716,
															639.173
														],
														[
															384.18,
															630.573
														],
														[
															385.525,
															621.838
														],
														[
															386.787,
															612.976
														],
														[
															388,
															604
														],
														[
															389.001,
															596.354
														],
														[
															389.98,
															588.613
														],
														[
															390.931,
															580.791
														],
														[
															391.846,
															572.904
														],
														[
															392.718,
															564.967
														],
														[
															393.539,
															556.994
														],
														[
															394.302,
															549
														],
														[
															395,
															541
														],
														[
															398.039,
															498.238
														],
														[
															400.198,
															454.206
														],
														[
															401.483,
															409.29
														],
														[
															401.9,
															363.877
														],
														[
															401.455,
															318.355
														],
														[
															400.152,
															273.111
														],
														[
															397.999,
															228.53
														],
														[
															395,
															185
														],
														[
															393.724,
															169.688
														],
														[
															392.275,
															154.003
														],
														[
															390.618,
															138.139
														],
														[
															388.718,
															122.293
														],
														[
															386.541,
															106.66
														],
														[
															384.052,
															91.437
														],
														[
															381.217,
															76.818
														],
														[
															378,
															63
														],
														[
															376.633,
															57.764
														],
														[
															375.23,
															52.683
														],
														[
															373.772,
															47.819
														],
														[
															372.24,
															43.237
														],
														[
															370.616,
															39
														],
														[
															368.88,
															35.173
														],
														[
															367.014,
															31.818
														],
														[
															365,
															29
														],
														[
															363.607,
															27.733
														],
														[
															362.409,
															27.413
														],
														[
															361.382,
															27.837
														],
														[
															360.504,
															28.802
														],
														[
															359.75,
															30.104
														],
														[
															359.097,
															31.54
														],
														[
															358.522,
															32.906
														],
														[
															358,
															34
														],
														[
															357.341,
															34.78
														],
														[
															356.452,
															35.519
														],
														[
															355.587,
															36.248
														],
														[
															355,
															37
														],
														[
															354.673,
															38.102
														],
														[
															354.496,
															39.395
														],
														[
															354.321,
															40.741
														],
														[
															354,
															42
														],
														[
															352.072,
															47.262
														],
														[
															350.271,
															52.595
														],
														[
															348.584,
															58.131
														],
														[
															347,
															64
														],
														[
															340.894,
															92.896
														],
														[
															336.222,
															123.863
														],
														[
															332.688,
															155.398
														],
														[
															330,
															186
														],
														[
															327.164,
															229.392
														],
														[
															325.312,
															274.304
														],
														[
															324.305,
															319.814
														],
														[
															324,
															365
														],
														[
															324.912,
															434.064
														],
														[
															327.933,
															500.685
														],
														[
															333.487,
															564.214
														],
														[
															342,
															624
														],
														[
															344.661,
															638.508
														],
														[
															347.804,
															652.711
														],
														[
															351.795,
															666.058
														],
														[
															357,
															678
														],
														[
															359.512,
															681.819
														],
														[
															362.236,
															685.789
														],
														[
															364.092,
															690.115
														],
														[
															364,
															695
														],
														[
															365.874,
															694.113
														],
														[
															367.169,
															692.636
														],
														[
															368.13,
															690.841
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 76,
											"s": [
												{
													"i": [
														[
															0.141,
															-0.924
														],
														[
															0.176,
															-1.232
														],
														[
															0.166,
															-1.243
														],
														[
															0.158,
															-1.253
														],
														[
															0.15,
															-1.263
														],
														[
															0.142,
															-1.272
														],
														[
															0.136,
															-1.281
														],
														[
															0.13,
															-1.29
														],
														[
															0.124,
															-1.298
														],
														[
															0.12,
															-1.305
														],
														[
															0.116,
															-1.312
														],
														[
															0.113,
															-1.318
														],
														[
															0.11,
															-1.324
														],
														[
															0.108,
															-1.329
														],
														[
															0.107,
															-1.334
														],
														[
															0.107,
															-1.338
														],
														[
															0.082,
															-0.988
														],
														[
															0.085,
															-0.992
														],
														[
															0.086,
															-0.996
														],
														[
															0.087,
															-1
														],
														[
															0.087,
															-1.002
														],
														[
															0.085,
															-1.004
														],
														[
															0.083,
															-1.006
														],
														[
															0.079,
															-1.006
														],
														[
															0.075,
															-1.006
														],
														[
															0.069,
															-1.005
														],
														[
															0.063,
															-1.003
														],
														[
															0.055,
															-1.001
														],
														[
															0.046,
															-0.998
														],
														[
															0.55,
															-15.789
														],
														[
															0.375,
															-15.867
														],
														[
															0.203,
															-15.896
														],
														[
															0.033,
															-15.878
														],
														[
															-0.133,
															-15.812
														],
														[
															-0.296,
															-15.698
														],
														[
															-0.456,
															-15.535
														],
														[
															-0.612,
															-15.325
														],
														[
															-0.261,
															-5.973
														],
														[
															-0.304,
															-5.944
														],
														[
															-0.366,
															-5.884
														],
														[
															-0.447,
															-5.792
														],
														[
															-0.549,
															-5.669
														],
														[
															-0.67,
															-5.514
														],
														[
															-0.811,
															-5.328
														],
														[
															-0.972,
															-5.111
														],
														[
															-0.098,
															-0.727
														],
														[
															-0.089,
															-0.752
														],
														[
															-0.104,
															-0.76
														],
														[
															-0.144,
															-0.752
														],
														[
															-0.208,
															-0.728
														],
														[
															-0.296,
															-0.687
														],
														[
															-0.408,
															-0.629
														],
														[
															-0.544,
															-0.555
														],
														[
															-0.815,
															6.339
														],
														[
															-0.694,
															6.443
														],
														[
															-0.589,
															6.535
														],
														[
															-0.5,
															6.616
														],
														[
															-0.426,
															6.684
														],
														[
															-0.368,
															6.74
														],
														[
															-0.326,
															6.784
														],
														[
															-0.3,
															6.816
														],
														[
															-0.137,
															3.429
														],
														[
															-0.122,
															3.441
														],
														[
															-0.105,
															3.451
														],
														[
															-0.087,
															3.461
														],
														[
															-0.068,
															3.469
														],
														[
															-0.047,
															3.477
														],
														[
															-0.024,
															3.484
														],
														[
															0,
															3.49
														],
														[
															-0.016,
															10.625
														],
														[
															-0.01,
															10.548
														],
														[
															0.018,
															10.475
														],
														[
															0.067,
															10.406
														],
														[
															0.138,
															10.341
														],
														[
															0.231,
															10.28
														],
														[
															0.345,
															10.223
														],
														[
															0.481,
															10.169
														],
														[
															0.284,
															6.816
														],
														[
															0.292,
															6.769
														],
														[
															0.349,
															6.706
														],
														[
															0.454,
															6.627
														],
														[
															0.608,
															6.531
														],
														[
															0.81,
															6.419
														],
														[
															1.061,
															6.291
														],
														[
															1.359,
															6.146
														],
														[
															0.01,
															0.074
														],
														[
															0.015,
															0.068
														],
														[
															0.023,
															0.06
														],
														[
															0.034,
															0.049
														],
														[
															0.048,
															0.035
														],
														[
															0.065,
															0.019
														],
														[
															0.084,
															-0.001
														],
														[
															0.106,
															-0.023
														],
														[
															0.216,
															-0.822
														],
														[
															0.19,
															-0.845
														],
														[
															0.169,
															-0.865
														],
														[
															0.153,
															-0.882
														],
														[
															0.142,
															-0.897
														],
														[
															0.137,
															-0.908
														],
														[
															0.136,
															-0.918
														]
													],
													"o": [
														[
															-0.186,
															1.22
														],
														[
															-0.176,
															1.232
														],
														[
															-0.166,
															1.243
														],
														[
															-0.158,
															1.253
														],
														[
															-0.15,
															1.263
														],
														[
															-0.142,
															1.272
														],
														[
															-0.136,
															1.281
														],
														[
															-0.13,
															1.29
														],
														[
															-0.124,
															1.298
														],
														[
															-0.12,
															1.305
														],
														[
															-0.116,
															1.312
														],
														[
															-0.113,
															1.318
														],
														[
															-0.11,
															1.324
														],
														[
															-0.108,
															1.329
														],
														[
															-0.107,
															1.334
														],
														[
															-0.078,
															0.982
														],
														[
															-0.082,
															0.988
														],
														[
															-0.085,
															0.992
														],
														[
															-0.086,
															0.996
														],
														[
															-0.087,
															1
														],
														[
															-0.087,
															1.002
														],
														[
															-0.085,
															1.004
														],
														[
															-0.083,
															1.006
														],
														[
															-0.079,
															1.006
														],
														[
															-0.075,
															1.006
														],
														[
															-0.069,
															1.005
														],
														[
															-0.063,
															1.003
														],
														[
															-0.055,
															1.001
														],
														[
															-0.729,
															15.663
														],
														[
															-0.55,
															15.789
														],
														[
															-0.375,
															15.867
														],
														[
															-0.203,
															15.896
														],
														[
															-0.033,
															15.878
														],
														[
															0.133,
															15.812
														],
														[
															0.296,
															15.698
														],
														[
															0.456,
															15.535
														],
														[
															0.239,
															5.971
														],
														[
															0.261,
															5.973
														],
														[
															0.304,
															5.944
														],
														[
															0.366,
															5.884
														],
														[
															0.447,
															5.792
														],
														[
															0.549,
															5.669
														],
														[
															0.67,
															5.514
														],
														[
															0.811,
															5.328
														],
														[
															0.13,
															0.685
														],
														[
															0.098,
															0.727
														],
														[
															0.089,
															0.752
														],
														[
															0.104,
															0.76
														],
														[
															0.144,
															0.752
														],
														[
															0.208,
															0.728
														],
														[
															0.296,
															0.687
														],
														[
															0.408,
															0.629
														],
														[
															0.951,
															-6.222
														],
														[
															0.815,
															-6.339
														],
														[
															0.694,
															-6.443
														],
														[
															0.589,
															-6.535
														],
														[
															0.5,
															-6.616
														],
														[
															0.426,
															-6.684
														],
														[
															0.368,
															-6.74
														],
														[
															0.326,
															-6.784
														],
														[
															0.15,
															-3.417
														],
														[
															0.137,
															-3.429
														],
														[
															0.122,
															-3.441
														],
														[
															0.105,
															-3.451
														],
														[
															0.087,
															-3.461
														],
														[
															0.068,
															-3.469
														],
														[
															0.047,
															-3.477
														],
														[
															0.024,
															-3.484
														],
														[
															0,
															-10.705
														],
														[
															0.016,
															-10.625
														],
														[
															0.01,
															-10.548
														],
														[
															-0.018,
															-10.475
														],
														[
															-0.067,
															-10.406
														],
														[
															-0.138,
															-10.341
														],
														[
															-0.231,
															-10.28
														],
														[
															-0.345,
															-10.223
														],
														[
															-0.324,
															-6.846
														],
														[
															-0.284,
															-6.816
														],
														[
															-0.292,
															-6.769
														],
														[
															-0.349,
															-6.706
														],
														[
															-0.454,
															-6.627
														],
														[
															-0.608,
															-6.531
														],
														[
															-0.81,
															-6.419
														],
														[
															-1.061,
															-6.291
														],
														[
															-0.007,
															-0.076
														],
														[
															-0.01,
															-0.074
														],
														[
															-0.015,
															-0.068
														],
														[
															-0.023,
															-0.06
														],
														[
															-0.034,
															-0.049
														],
														[
															-0.048,
															-0.035
														],
														[
															-0.065,
															-0.019
														],
														[
															-0.084,
															0.001
														],
														[
															-0.247,
															0.797
														],
														[
															-0.216,
															0.822
														],
														[
															-0.19,
															0.845
														],
														[
															-0.169,
															0.865
														],
														[
															-0.153,
															0.882
														],
														[
															-0.142,
															0.897
														],
														[
															-0.137,
															0.909
														],
														[
															-0.136,
															0.918
														]
													],
													"v": [
														[
															358,
															55
														],
														[
															357.457,
															58.677
														],
														[
															356.944,
															62.389
														],
														[
															356.458,
															66.132
														],
														[
															355.997,
															69.907
														],
														[
															355.559,
															73.71
														],
														[
															355.143,
															77.541
														],
														[
															354.746,
															81.398
														],
														[
															354.365,
															85.279
														],
														[
															354,
															89.183
														],
														[
															353.647,
															93.109
														],
														[
															353.304,
															97.054
														],
														[
															352.971,
															101.017
														],
														[
															352.644,
															104.997
														],
														[
															352.321,
															108.992
														],
														[
															352,
															113
														],
														[
															351.759,
															115.955
														],
														[
															351.509,
															118.925
														],
														[
															351.252,
															121.909
														],
														[
															350.991,
															124.903
														],
														[
															350.73,
															127.907
														],
														[
															350.472,
															130.918
														],
														[
															350.219,
															133.933
														],
														[
															349.975,
															136.95
														],
														[
															349.744,
															139.968
														],
														[
															349.527,
															142.984
														],
														[
															349.329,
															145.996
														],
														[
															349.152,
															149.002
														],
														[
															349,
															152
														],
														[
															347.082,
															199.189
														],
														[
															345.696,
															246.684
														],
														[
															344.83,
															294.341
														],
														[
															344.477,
															342.014
														],
														[
															344.626,
															389.561
														],
														[
															345.269,
															436.837
														],
														[
															346.397,
															483.698
														],
														[
															348,
															530
														],
														[
															348.745,
															547.924
														],
														[
															349.587,
															565.809
														],
														[
															350.586,
															583.559
														],
														[
															351.801,
															601.081
														],
														[
															353.29,
															618.28
														],
														[
															355.114,
															635.063
														],
														[
															357.331,
															651.334
														],
														[
															360,
															667
														],
														[
															360.336,
															669.122
														],
														[
															360.609,
															671.345
														],
														[
															360.893,
															673.617
														],
														[
															361.26,
															675.89
														],
														[
															361.781,
															678.115
														],
														[
															362.53,
															680.241
														],
														[
															363.579,
															682.219
														],
														[
															365,
															684
														],
														[
															367.644,
															665.156
														],
														[
															369.903,
															645.98
														],
														[
															371.824,
															626.51
														],
														[
															373.453,
															606.78
														],
														[
															374.839,
															586.829
														],
														[
															376.027,
															566.69
														],
														[
															377.065,
															546.402
														],
														[
															378,
															526
														],
														[
															378.431,
															515.73
														],
														[
															378.82,
															505.424
														],
														[
															379.161,
															495.086
														],
														[
															379.451,
															484.718
														],
														[
															379.684,
															474.323
														],
														[
															379.857,
															463.903
														],
														[
															379.963,
															453.461
														],
														[
															380,
															443
														],
														[
															380.029,
															411.007
														],
														[
															380.072,
															379.248
														],
														[
															380.064,
															347.714
														],
														[
															379.941,
															316.392
														],
														[
															379.638,
															285.272
														],
														[
															379.09,
															254.34
														],
														[
															378.233,
															223.587
														],
														[
															377,
															193
														],
														[
															376.101,
															172.503
														],
														[
															375.25,
															152.121
														],
														[
															374.3,
															131.904
														],
														[
															373.108,
															111.899
														],
														[
															371.526,
															92.158
														],
														[
															369.411,
															72.728
														],
														[
															366.618,
															53.659
														],
														[
															363,
															35
														],
														[
															362.976,
															34.774
														],
														[
															362.939,
															34.561
														],
														[
															362.883,
															34.367
														],
														[
															362.797,
															34.202
														],
														[
															362.675,
															34.075
														],
														[
															362.507,
															33.993
														],
														[
															362.285,
															33.965
														],
														[
															362,
															34
														],
														[
															361.307,
															36.43
														],
														[
															360.699,
															38.932
														],
														[
															360.163,
															41.498
														],
														[
															359.681,
															44.12
														],
														[
															359.24,
															46.789
														],
														[
															358.822,
															49.497
														],
														[
															358.414,
															52.237
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 78,
											"s": [
												{
													"i": [
														[
															0.242,
															-3.399
														],
														[
															0.327,
															-5.271
														],
														[
															0.286,
															-5.323
														],
														[
															0.247,
															-5.369
														],
														[
															0.211,
															-5.409
														],
														[
															0.178,
															-5.443
														],
														[
															0.147,
															-5.471
														],
														[
															0.12,
															-5.492
														],
														[
															0.095,
															-5.508
														],
														[
															0.073,
															-5.518
														],
														[
															0.054,
															-5.522
														],
														[
															0.038,
															-5.519
														],
														[
															0.024,
															-5.511
														],
														[
															0.013,
															-5.496
														],
														[
															0.005,
															-5.476
														],
														[
															0,
															-5.449
														],
														[
															-0.015,
															-7.411
														],
														[
															-0.035,
															-7.399
														],
														[
															-0.059,
															-7.379
														],
														[
															-0.088,
															-7.351
														],
														[
															-0.121,
															-7.314
														],
														[
															-0.159,
															-7.27
														],
														[
															-0.201,
															-7.217
														],
														[
															-0.248,
															-7.156
														],
														[
															-0.3,
															-7.087
														],
														[
															-0.356,
															-7.01
														],
														[
															-0.416,
															-6.924
														],
														[
															-0.481,
															-6.831
														],
														[
															-0.551,
															-6.729
														],
														[
															-0.625,
															-6.619
														],
														[
															-0.704,
															-6.501
														],
														[
															-0.17,
															0.074
														],
														[
															-0.144,
															0.104
														],
														[
															-0.121,
															0.13
														],
														[
															-0.1,
															0.151
														],
														[
															-0.081,
															0.169
														],
														[
															-0.065,
															0.182
														],
														[
															-0.051,
															0.192
														],
														[
															-0.039,
															0.197
														],
														[
															-0.03,
															0.198
														],
														[
															-0.023,
															0.194
														],
														[
															-0.018,
															0.187
														],
														[
															-0.016,
															0.175
														],
														[
															-0.016,
															0.159
														],
														[
															-0.018,
															0.139
														],
														[
															-0.023,
															0.115
														],
														[
															-0.264,
															1.46
														],
														[
															-0.237,
															1.463
														],
														[
															-0.213,
															1.466
														],
														[
															-0.191,
															1.47
														],
														[
															-0.171,
															1.474
														],
														[
															-0.154,
															1.478
														],
														[
															-0.139,
															1.483
														],
														[
															-0.127,
															1.488
														],
														[
															-0.117,
															1.494
														],
														[
															-0.11,
															1.499
														],
														[
															-0.105,
															1.506
														],
														[
															-0.102,
															1.512
														],
														[
															-0.102,
															1.519
														],
														[
															-0.104,
															1.526
														],
														[
															-0.109,
															1.534
														],
														[
															-0.222,
															3.342
														],
														[
															-0.206,
															3.354
														],
														[
															-0.189,
															3.366
														],
														[
															-0.17,
															3.377
														],
														[
															-0.15,
															3.387
														],
														[
															-0.129,
															3.397
														],
														[
															-0.106,
															3.406
														],
														[
															-0.082,
															3.414
														],
														[
															-0.281,
															13.693
														],
														[
															-0.219,
															13.72
														],
														[
															-0.14,
															13.729
														],
														[
															-0.045,
															13.718
														],
														[
															0.068,
															13.688
														],
														[
															0.197,
															13.638
														],
														[
															0.343,
															13.57
														],
														[
															0.505,
															13.483
														],
														[
															0.243,
															6.819
														],
														[
															0.259,
															6.771
														],
														[
															0.304,
															6.715
														],
														[
															0.379,
															6.649
														],
														[
															0.484,
															6.574
														],
														[
															0.618,
															6.491
														],
														[
															0.782,
															6.398
														],
														[
															0.976,
															6.296
														],
														[
															0.01,
															0.074
														],
														[
															0.015,
															0.068
														],
														[
															0.023,
															0.06
														],
														[
															0.034,
															0.049
														],
														[
															0.048,
															0.035
														],
														[
															0.065,
															0.019
														],
														[
															0.084,
															-0.001
														],
														[
															0.106,
															-0.023
														],
														[
															0.501,
															-3.172
														],
														[
															0.413,
															-3.187
														],
														[
															0.342,
															-3.208
														],
														[
															0.288,
															-3.234
														],
														[
															0.251,
															-3.267
														],
														[
															0.231,
															-3.305
														],
														[
															0.228,
															-3.349
														]
													],
													"o": [
														[
															-0.371,
															5.213
														],
														[
															-0.327,
															5.271
														],
														[
															-0.286,
															5.323
														],
														[
															-0.247,
															5.369
														],
														[
															-0.211,
															5.409
														],
														[
															-0.178,
															5.443
														],
														[
															-0.147,
															5.471
														],
														[
															-0.12,
															5.492
														],
														[
															-0.095,
															5.508
														],
														[
															-0.073,
															5.518
														],
														[
															-0.054,
															5.522
														],
														[
															-0.038,
															5.519
														],
														[
															-0.024,
															5.511
														],
														[
															-0.013,
															5.496
														],
														[
															-0.005,
															5.476
														],
														[
															0,
															7.415
														],
														[
															0.015,
															7.411
														],
														[
															0.035,
															7.399
														],
														[
															0.059,
															7.379
														],
														[
															0.088,
															7.351
														],
														[
															0.121,
															7.314
														],
														[
															0.159,
															7.27
														],
														[
															0.201,
															7.217
														],
														[
															0.248,
															7.156
														],
														[
															0.3,
															7.087
														],
														[
															0.356,
															7.01
														],
														[
															0.416,
															6.924
														],
														[
															0.481,
															6.831
														],
														[
															0.551,
															6.729
														],
														[
															0.625,
															6.619
														],
														[
															0.197,
															-0.039
														],
														[
															0.17,
															-0.074
														],
														[
															0.144,
															-0.104
														],
														[
															0.121,
															-0.13
														],
														[
															0.1,
															-0.151
														],
														[
															0.081,
															-0.169
														],
														[
															0.065,
															-0.182
														],
														[
															0.051,
															-0.192
														],
														[
															0.039,
															-0.197
														],
														[
															0.03,
															-0.198
														],
														[
															0.023,
															-0.194
														],
														[
															0.018,
															-0.187
														],
														[
															0.016,
															-0.175
														],
														[
															0.016,
															-0.159
														],
														[
															0.018,
															-0.139
														],
														[
															0.293,
															-1.457
														],
														[
															0.264,
															-1.46
														],
														[
															0.237,
															-1.463
														],
														[
															0.213,
															-1.466
														],
														[
															0.191,
															-1.47
														],
														[
															0.171,
															-1.474
														],
														[
															0.154,
															-1.478
														],
														[
															0.139,
															-1.483
														],
														[
															0.127,
															-1.488
														],
														[
															0.117,
															-1.494
														],
														[
															0.11,
															-1.499
														],
														[
															0.105,
															-1.506
														],
														[
															0.102,
															-1.512
														],
														[
															0.102,
															-1.519
														],
														[
															0.104,
															-1.526
														],
														[
															0.237,
															-3.329
														],
														[
															0.222,
															-3.342
														],
														[
															0.206,
															-3.354
														],
														[
															0.189,
															-3.366
														],
														[
															0.17,
															-3.377
														],
														[
															0.15,
															-3.387
														],
														[
															0.129,
															-3.397
														],
														[
															0.106,
															-3.406
														],
														[
															0.327,
															-13.647
														],
														[
															0.281,
															-13.693
														],
														[
															0.219,
															-13.72
														],
														[
															0.14,
															-13.729
														],
														[
															0.044,
															-13.718
														],
														[
															-0.068,
															-13.688
														],
														[
															-0.197,
															-13.638
														],
														[
															-0.342,
															-13.57
														],
														[
															-0.257,
															-6.857
														],
														[
															-0.243,
															-6.819
														],
														[
															-0.259,
															-6.771
														],
														[
															-0.304,
															-6.715
														],
														[
															-0.379,
															-6.649
														],
														[
															-0.484,
															-6.574
														],
														[
															-0.618,
															-6.491
														],
														[
															-0.782,
															-6.398
														],
														[
															-0.007,
															-0.076
														],
														[
															-0.01,
															-0.074
														],
														[
															-0.015,
															-0.068
														],
														[
															-0.023,
															-0.06
														],
														[
															-0.034,
															-0.049
														],
														[
															-0.048,
															-0.035
														],
														[
															-0.065,
															-0.019
														],
														[
															-0.084,
															0.001
														],
														[
															-0.606,
															3.163
														],
														[
															-0.501,
															3.172
														],
														[
															-0.413,
															3.187
														],
														[
															-0.342,
															3.208
														],
														[
															-0.288,
															3.234
														],
														[
															-0.251,
															3.267
														],
														[
															-0.231,
															3.305
														],
														[
															-0.228,
															3.349
														]
													],
													"v": [
														[
															354,
															115
														],
														[
															352.953,
															130.728
														],
														[
															352.035,
															146.62
														],
														[
															351.237,
															162.66
														],
														[
															350.551,
															178.828
														],
														[
															349.968,
															195.108
														],
														[
															349.481,
															211.479
														],
														[
															349.081,
															227.926
														],
														[
															348.759,
															244.428
														],
														[
															348.508,
															260.969
														],
														[
															348.318,
															277.53
														],
														[
															348.181,
															294.092
														],
														[
															348.089,
															310.639
														],
														[
															348.034,
															327.151
														],
														[
															348.007,
															343.611
														],
														[
															348,
															360
														],
														[
															348.021,
															382.242
														],
														[
															348.095,
															404.459
														],
														[
															348.234,
															426.629
														],
														[
															348.453,
															448.726
														],
														[
															348.764,
															470.726
														],
														[
															349.183,
															492.604
														],
														[
															349.721,
															514.337
														],
														[
															350.394,
															535.899
														],
														[
															351.214,
															557.265
														],
														[
															352.196,
															578.413
														],
														[
															353.352,
															599.316
														],
														[
															354.697,
															619.951
														],
														[
															356.244,
															640.293
														],
														[
															358.007,
															660.317
														],
														[
															360,
															680
														],
														[
															360.55,
															679.829
														],
														[
															361.02,
															679.562
														],
														[
															361.416,
															679.211
														],
														[
															361.746,
															678.788
														],
														[
															362.017,
															678.306
														],
														[
															362.236,
															677.778
														],
														[
															362.409,
															677.216
														],
														[
															362.544,
															676.632
														],
														[
															362.647,
															676.039
														],
														[
															362.726,
															675.45
														],
														[
															362.788,
															674.878
														],
														[
															362.839,
															674.334
														],
														[
															362.887,
															673.831
														],
														[
															362.938,
															673.382
														],
														[
															363,
															673
														],
														[
															363.836,
															668.624
														],
														[
															364.587,
															664.24
														],
														[
															365.261,
															659.847
														],
														[
															365.865,
															655.443
														],
														[
															366.407,
															651.027
														],
														[
															366.894,
															646.599
														],
														[
															367.332,
															642.157
														],
														[
															367.731,
															637.7
														],
														[
															368.096,
															633.227
														],
														[
															368.435,
															628.738
														],
														[
															368.756,
															624.23
														],
														[
															369.065,
															619.704
														],
														[
															369.371,
															615.157
														],
														[
															369.68,
															610.59
														],
														[
															370,
															606
														],
														[
															370.69,
															595.994
														],
														[
															371.333,
															585.95
														],
														[
															371.927,
															575.87
														],
														[
															372.466,
															565.756
														],
														[
															372.947,
															555.61
														],
														[
															373.366,
															545.434
														],
														[
															373.718,
															535.23
														],
														[
															374,
															525
														],
														[
															374.916,
															483.986
														],
														[
															375.671,
															442.86
														],
														[
															376.214,
															401.682
														],
														[
															376.495,
															360.508
														],
														[
															376.464,
															319.395
														],
														[
															376.072,
															278.401
														],
														[
															375.267,
															237.584
														],
														[
															374,
															197
														],
														[
															373.258,
															176.483
														],
														[
															372.512,
															156.096
														],
														[
															371.675,
															135.865
														],
														[
															370.657,
															115.817
														],
														[
															369.369,
															95.98
														],
														[
															367.723,
															76.379
														],
														[
															365.63,
															57.044
														],
														[
															363,
															38
														],
														[
															362.976,
															37.774
														],
														[
															362.939,
															37.561
														],
														[
															362.883,
															37.367
														],
														[
															362.798,
															37.202
														],
														[
															362.675,
															37.075
														],
														[
															362.507,
															36.993
														],
														[
															362.285,
															36.965
														],
														[
															362,
															37
														],
														[
															360.344,
															46.502
														],
														[
															358.977,
															56.04
														],
														[
															357.849,
															65.631
														],
														[
															356.908,
															75.293
														],
														[
															356.104,
															85.043
														],
														[
															355.385,
															94.9
														],
														[
															354.701,
															104.879
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 79,
											"s": [
												{
													"i": [
														[
															-0.63,
															1.654
														],
														[
															-0.097,
															0.337
														],
														[
															-0.081,
															0.356
														],
														[
															-0.07,
															0.372
														],
														[
															-0.066,
															0.384
														],
														[
															-0.069,
															0.393
														],
														[
															-0.078,
															0.398
														],
														[
															-0.093,
															0.4
														],
														[
															-0.114,
															0.399
														],
														[
															-0.306,
															1.039
														],
														[
															-0.315,
															1.061
														],
														[
															-0.316,
															1.079
														],
														[
															-0.311,
															1.093
														],
														[
															-0.298,
															1.104
														],
														[
															-0.278,
															1.111
														],
														[
															-0.251,
															1.114
														],
														[
															-0.217,
															1.114
														],
														[
															-0.784,
															4.79
														],
														[
															-0.678,
															4.914
														],
														[
															-0.585,
															5.01
														],
														[
															-0.506,
															5.077
														],
														[
															-0.44,
															5.115
														],
														[
															-0.388,
															5.124
														],
														[
															-0.349,
															5.104
														],
														[
															-0.324,
															5.056
														],
														[
															-0.4,
															6.804
														],
														[
															-0.365,
															6.93
														],
														[
															-0.323,
															7.031
														],
														[
															-0.272,
															7.107
														],
														[
															-0.213,
															7.159
														],
														[
															-0.146,
															7.187
														],
														[
															-0.07,
															7.189
														],
														[
															0.014,
															7.167
														],
														[
															0.029,
															1.59
														],
														[
															0.047,
															1.641
														],
														[
															0.058,
															1.686
														],
														[
															0.062,
															1.725
														],
														[
															0.058,
															1.757
														],
														[
															0.046,
															1.784
														],
														[
															0.027,
															1.804
														],
														[
															0,
															1.819
														],
														[
															0.09,
															5.457
														],
														[
															0.167,
															5.426
														],
														[
															0.232,
															5.382
														],
														[
															0.284,
															5.326
														],
														[
															0.323,
															5.257
														],
														[
															0.35,
															5.174
														],
														[
															0.364,
															5.08
														],
														[
															0.366,
															4.972
														],
														[
															0.398,
															5.016
														],
														[
															0.449,
															5.089
														],
														[
															0.513,
															5.106
														],
														[
															0.59,
															5.066
														],
														[
															0.68,
															4.971
														],
														[
															0.784,
															4.819
														],
														[
															0.9,
															4.611
														],
														[
															1.03,
															4.347
														],
														[
															0.892,
															3.212
														],
														[
															1.002,
															2.904
														],
														[
															1.109,
															2.365
														],
														[
															1.213,
															1.595
														],
														[
															0.183,
															0.099
														],
														[
															0.237,
															0.116
														],
														[
															0.186,
															0.085
														],
														[
															0.029,
															0.003
														],
														[
															0.209,
															-0.217
														],
														[
															0.067,
															-0.347
														],
														[
															0.074,
															-0.331
														],
														[
															0.231,
															-0.169
														],
														[
															0.851,
															-1.484
														],
														[
															0.579,
															-1.77
														],
														[
															0.438,
															-1.776
														],
														[
															0.429,
															-1.502
														],
														[
															1.26,
															-5.266
														],
														[
															1.106,
															-5.532
														],
														[
															0.918,
															-5.625
														],
														[
															0.697,
															-5.544
														],
														[
															0.677,
															-6.884
														],
														[
															0.552,
															-6.955
														],
														[
															0.474,
															-6.968
														],
														[
															0.443,
															-6.923
														],
														[
															0.746,
															-14.365
														],
														[
															0.549,
															-14.662
														],
														[
															0.279,
															-14.466
														],
														[
															-0.065,
															-13.779
														],
														[
															-0.375,
															-14.439
														],
														[
															-0.623,
															-14.391
														],
														[
															-0.812,
															-14.131
														],
														[
															-0.942,
															-13.66
														],
														[
															-0.9,
															-10.453
														],
														[
															-1.175,
															-10.09
														],
														[
															-1.563,
															-9.592
														],
														[
															-2.063,
															-8.958
														],
														[
															-0.746,
															-2.907
														],
														[
															-0.926,
															-2.8
														],
														[
															-1.217,
															-2.619
														],
														[
															-1.62,
															-2.361
														],
														[
															-0.748,
															1.974
														],
														[
															-1.083,
															1.765
														],
														[
															-1.043,
															1.659
														]
													],
													"o": [
														[
															0.12,
															-0.315
														],
														[
															0.097,
															-0.337
														],
														[
															0.081,
															-0.356
														],
														[
															0.07,
															-0.372
														],
														[
															0.066,
															-0.384
														],
														[
															0.069,
															-0.393
														],
														[
															0.078,
															-0.398
														],
														[
															0.093,
															-0.4
														],
														[
															0.29,
															-1.013
														],
														[
															0.306,
															-1.039
														],
														[
															0.315,
															-1.061
														],
														[
															0.316,
															-1.079
														],
														[
															0.311,
															-1.093
														],
														[
															0.298,
															-1.104
														],
														[
															0.278,
															-1.111
														],
														[
															0.251,
															-1.114
														],
														[
															0.904,
															-4.637
														],
														[
															0.784,
															-4.79
														],
														[
															0.678,
															-4.914
														],
														[
															0.585,
															-5.01
														],
														[
															0.506,
															-5.077
														],
														[
															0.44,
															-5.115
														],
														[
															0.388,
															-5.124
														],
														[
															0.349,
															-5.104
														],
														[
															0.426,
															-6.654
														],
														[
															0.4,
															-6.804
														],
														[
															0.365,
															-6.93
														],
														[
															0.323,
															-7.031
														],
														[
															0.272,
															-7.107
														],
														[
															0.213,
															-7.159
														],
														[
															0.146,
															-7.186
														],
														[
															0.07,
															-7.189
														],
														[
															-0.003,
															-1.533
														],
														[
															-0.029,
															-1.59
														],
														[
															-0.047,
															-1.641
														],
														[
															-0.058,
															-1.686
														],
														[
															-0.062,
															-1.725
														],
														[
															-0.058,
															-1.757
														],
														[
															-0.046,
															-1.784
														],
														[
															-0.027,
															-1.804
														],
														[
															0,
															-5.475
														],
														[
															-0.09,
															-5.457
														],
														[
															-0.167,
															-5.426
														],
														[
															-0.232,
															-5.382
														],
														[
															-0.284,
															-5.326
														],
														[
															-0.323,
															-5.257
														],
														[
															-0.35,
															-5.174
														],
														[
															-0.364,
															-5.08
														],
														[
															-0.36,
															-4.887
														],
														[
															-0.398,
															-5.016
														],
														[
															-0.449,
															-5.089
														],
														[
															-0.513,
															-5.106
														],
														[
															-0.59,
															-5.066
														],
														[
															-0.68,
															-4.971
														],
														[
															-0.784,
															-4.819
														],
														[
															-0.9,
															-4.611
														],
														[
															-0.779,
															-3.288
														],
														[
															-0.892,
															-3.212
														],
														[
															-1.002,
															-2.904
														],
														[
															-1.109,
															-2.365
														],
														[
															-0.024,
															-0.031
														],
														[
															-0.183,
															-0.099
														],
														[
															-0.237,
															-0.116
														],
														[
															-0.186,
															-0.085
														],
														[
															-0.501,
															-0.058
														],
														[
															-0.209,
															0.217
														],
														[
															-0.067,
															0.347
														],
														[
															-0.074,
															0.331
														],
														[
															-1.255,
															0.919
														],
														[
															-0.851,
															1.484
														],
														[
															-0.579,
															1.77
														],
														[
															-0.438,
															1.776
														],
														[
															-1.38,
															4.826
														],
														[
															-1.26,
															5.266
														],
														[
															-1.106,
															5.532
														],
														[
															-0.918,
															5.625
														],
														[
															-0.849,
															6.755
														],
														[
															-0.677,
															6.884
														],
														[
															-0.552,
															6.955
														],
														[
															-0.474,
															6.968
														],
														[
															-0.869,
															13.575
														],
														[
															-0.746,
															14.365
														],
														[
															-0.549,
															14.662
														],
														[
															-0.279,
															14.466
														],
														[
															0.067,
															14.276
														],
														[
															0.375,
															14.439
														],
														[
															0.623,
															14.391
														],
														[
															0.812,
															14.131
														],
														[
															0.736,
															10.68
														],
														[
															0.9,
															10.453
														],
														[
															1.175,
															10.09
														],
														[
															1.563,
															9.592
														],
														[
															0.676,
															2.937
														],
														[
															0.746,
															2.907
														],
														[
															0.926,
															2.801
														],
														[
															1.217,
															2.619
														],
														[
															0.039,
															-2.285
														],
														[
															0.748,
															-1.974
														],
														[
															1.083,
															-1.765
														],
														[
															1.043,
															-1.659
														]
													],
													"v": [
														[
															370,
															672
														],
														[
															370.324,
															671.02
														],
														[
															370.59,
															669.978
														],
														[
															370.814,
															668.886
														],
														[
															371.018,
															667.751
														],
														[
															371.219,
															666.586
														],
														[
															371.437,
															665.398
														],
														[
															371.691,
															664.2
														],
														[
															372,
															663
														],
														[
															372.895,
															659.922
														],
														[
															373.827,
															656.772
														],
														[
															374.775,
															653.562
														],
														[
															375.718,
															650.303
														],
														[
															376.633,
															647.006
														],
														[
															377.499,
															643.682
														],
														[
															378.296,
															640.343
														],
														[
															379,
															637
														],
														[
															381.528,
															622.853
														],
														[
															383.717,
															608.289
														],
														[
															385.607,
															593.395
														],
														[
															387.24,
															578.257
														],
														[
															388.655,
															562.963
														],
														[
															389.893,
															547.597
														],
														[
															390.995,
															532.248
														],
														[
															392,
															517
														],
														[
															393.24,
															496.808
														],
														[
															394.39,
															476.201
														],
														[
															395.424,
															455.254
														],
														[
															396.318,
															434.041
														],
														[
															397.048,
															412.635
														],
														[
															397.588,
															391.111
														],
														[
															397.913,
															369.541
														],
														[
															398,
															348
														],
														[
															397.95,
															343.314
														],
														[
															397.834,
															338.467
														],
														[
															397.673,
															333.475
														],
														[
															397.491,
															328.358
														],
														[
															397.31,
															323.134
														],
														[
															397.153,
															317.82
														],
														[
															397.042,
															312.436
														],
														[
															397,
															307
														],
														[
															396.862,
															290.6
														],
														[
															396.474,
															274.272
														],
														[
															395.873,
															258.057
														],
														[
															395.097,
															241.991
														],
														[
															394.184,
															226.115
														],
														[
															393.172,
															210.465
														],
														[
															392.098,
															195.08
														],
														[
															391,
															180
														],
														[
															389.868,
															165.131
														],
														[
															388.601,
															149.959
														],
														[
															387.162,
															134.653
														],
														[
															385.511,
															119.381
														],
														[
															383.608,
															104.311
														],
														[
															381.415,
															89.612
														],
														[
															378.892,
															75.452
														],
														[
															376,
															62
														],
														[
															373.493,
															52.193
														],
														[
															370.651,
															42.961
														],
														[
															367.484,
															34.999
														],
														[
															364,
															29
														],
														[
															363.664,
															28.793
														],
														[
															363.008,
															28.458
														],
														[
															362.348,
															28.144
														],
														[
															362,
															28
														],
														[
															360.972,
															28.276
														],
														[
															360.595,
															29.159
														],
														[
															360.42,
															30.213
														],
														[
															360,
															31
														],
														[
															356.873,
															34.675
														],
														[
															354.761,
															39.625
														],
														[
															353.269,
															45.013
														],
														[
															352,
															50
														],
														[
															348.032,
															65.181
														],
														[
															344.475,
															81.422
														],
														[
															341.431,
															98.202
														],
														[
															339,
															115
														],
														[
															336.723,
															135.474
														],
														[
															334.891,
															156.248
														],
														[
															333.364,
															177.148
														],
														[
															332,
															198
														],
														[
															329.56,
															240.033
														],
														[
															327.599,
															283.695
														],
														[
															326.339,
															327.51
														],
														[
															326,
															370
														],
														[
															326.678,
															413.126
														],
														[
															328.188,
															456.425
														],
														[
															330.355,
															499.261
														],
														[
															333,
															541
														],
														[
															335.426,
															572.733
														],
														[
															338.511,
															603.583
														],
														[
															342.59,
															633.14
														],
														[
															348,
															661
														],
														[
															350.105,
															669.784
														],
														[
															352.585,
															678.364
														],
														[
															355.772,
															686.512
														],
														[
															360,
															694
														],
														[
															361.274,
															687.637
														],
														[
															364.113,
															682.054
														],
														[
															367.397,
															676.944
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 80,
											"s": [
												{
													"i": [
														[
															-0.457,
															0.916
														],
														[
															-0.105,
															0.085
														],
														[
															-0.146,
															0.072
														],
														[
															-0.176,
															0.065
														],
														[
															-0.196,
															0.066
														],
														[
															-0.204,
															0.072
														],
														[
															-0.202,
															0.086
														],
														[
															-0.189,
															0.106
														],
														[
															-0.165,
															0.132
														],
														[
															-0.156,
															0.138
														],
														[
															-0.156,
															0.147
														],
														[
															-0.15,
															0.149
														],
														[
															-0.138,
															0.144
														],
														[
															-0.122,
															0.132
														],
														[
															-0.101,
															0.112
														],
														[
															-0.075,
															0.086
														],
														[
															-0.044,
															0.052
														],
														[
															-1.249,
															1.845
														],
														[
															-1.096,
															1.975
														],
														[
															-0.965,
															2.086
														],
														[
															-0.857,
															2.177
														],
														[
															-0.771,
															2.249
														],
														[
															-0.708,
															2.301
														],
														[
															-0.666,
															2.333
														],
														[
															-0.647,
															2.345
														],
														[
															-0.813,
															3.212
														],
														[
															-0.763,
															3.291
														],
														[
															-0.714,
															3.364
														],
														[
															-0.665,
															3.431
														],
														[
															-0.617,
															3.493
														],
														[
															-0.569,
															3.55
														],
														[
															-0.522,
															3.601
														],
														[
															-0.475,
															3.647
														],
														[
															-1.583,
															17.872
														],
														[
															-0.973,
															18.665
														],
														[
															-0.348,
															19.083
														],
														[
															0.293,
															19.126
														],
														[
															0.948,
															18.793
														],
														[
															1.619,
															18.085
														],
														[
															2.305,
															17.002
														],
														[
															3.007,
															15.543
														],
														[
															0.187,
															0.851
														],
														[
															0.203,
															0.841
														],
														[
															0.214,
															0.832
														],
														[
															0.22,
															0.827
														],
														[
															0.222,
															0.823
														],
														[
															0.22,
															0.823
														],
														[
															0.213,
															0.824
														],
														[
															0.202,
															0.828
														],
														[
															0.668,
															2.677
														],
														[
															0.705,
															2.658
														],
														[
															0.759,
															2.604
														],
														[
															0.83,
															2.513
														],
														[
															0.918,
															2.386
														],
														[
															1.023,
															2.223
														],
														[
															1.144,
															2.024
														],
														[
															1.283,
															1.789
														],
														[
															0.504,
															0.672
														],
														[
															0.541,
															0.651
														],
														[
															0.572,
															0.581
														],
														[
															0.598,
															0.463
														],
														[
															0.618,
															0.296
														],
														[
															0.633,
															0.081
														],
														[
															0.643,
															-0.183
														],
														[
															0.647,
															-0.495
														],
														[
															0.889,
															-0.867
														],
														[
															0.867,
															-1.025
														],
														[
															0.839,
															-1.166
														],
														[
															0.806,
															-1.292
														],
														[
															0.767,
															-1.402
														],
														[
															0.724,
															-1.497
														],
														[
															0.675,
															-1.575
														],
														[
															0.62,
															-1.637
														],
														[
															2.61,
															-9.969
														],
														[
															1.986,
															-10.506
														],
														[
															1.508,
															-10.534
														],
														[
															1.174,
															-10.052
														],
														[
															1.254,
															-15.339
														],
														[
															0.828,
															-15.697
														],
														[
															0.41,
															-15.509
														],
														[
															0,
															-14.777
														],
														[
															-0.409,
															-15.79
														],
														[
															-0.827,
															-15.399
														],
														[
															-1.255,
															-14.909
														],
														[
															-1.691,
															-14.32
														],
														[
															-0.768,
															-5.455
														],
														[
															-0.863,
															-5.384
														],
														[
															-0.913,
															-5.112
														],
														[
															-0.92,
															-4.64
														],
														[
															-1.139,
															-5.005
														],
														[
															-1.306,
															-4.861
														],
														[
															-1.514,
															-4.676
														],
														[
															-1.763,
															-4.449
														],
														[
															-1.284,
															-2.785
														],
														[
															-1.582,
															-2.553
														],
														[
															-2.007,
															-2.117
														],
														[
															-2.561,
															-1.476
														],
														[
															-0.035,
															0.931
														],
														[
															0.102,
															0.898
														],
														[
															-0.038,
															0.893
														]
													],
													"o": [
														[
															0.053,
															-0.105
														],
														[
															0.105,
															-0.085
														],
														[
															0.146,
															-0.072
														],
														[
															0.176,
															-0.065
														],
														[
															0.196,
															-0.066
														],
														[
															0.204,
															-0.072
														],
														[
															0.202,
															-0.086
														],
														[
															0.189,
															-0.106
														],
														[
															0.152,
															-0.122
														],
														[
															0.156,
															-0.138
														],
														[
															0.156,
															-0.147
														],
														[
															0.15,
															-0.149
														],
														[
															0.138,
															-0.144
														],
														[
															0.122,
															-0.132
														],
														[
															0.101,
															-0.112
														],
														[
															0.075,
															-0.086
														],
														[
															1.424,
															-1.695
														],
														[
															1.249,
															-1.845
														],
														[
															1.096,
															-1.975
														],
														[
															0.965,
															-2.086
														],
														[
															0.857,
															-2.177
														],
														[
															0.771,
															-2.249
														],
														[
															0.708,
															-2.301
														],
														[
															0.666,
															-2.333
														],
														[
															0.863,
															-3.128
														],
														[
															0.813,
															-3.212
														],
														[
															0.763,
															-3.291
														],
														[
															0.714,
															-3.364
														],
														[
															0.665,
															-3.431
														],
														[
															0.617,
															-3.493
														],
														[
															0.569,
															-3.55
														],
														[
															0.522,
															-3.601
														],
														[
															2.177,
															-16.704
														],
														[
															1.583,
															-17.872
														],
														[
															0.973,
															-18.665
														],
														[
															0.348,
															-19.083
														],
														[
															-0.293,
															-19.126
														],
														[
															-0.948,
															-18.793
														],
														[
															-1.619,
															-18.085
														],
														[
															-2.305,
															-17.002
														],
														[
															-0.167,
															-0.865
														],
														[
															-0.187,
															-0.851
														],
														[
															-0.203,
															-0.841
														],
														[
															-0.214,
															-0.832
														],
														[
															-0.22,
															-0.827
														],
														[
															-0.222,
															-0.823
														],
														[
															-0.22,
															-0.823
														],
														[
															-0.213,
															-0.824
														],
														[
															-0.648,
															-2.659
														],
														[
															-0.668,
															-2.677
														],
														[
															-0.705,
															-2.658
														],
														[
															-0.759,
															-2.604
														],
														[
															-0.83,
															-2.513
														],
														[
															-0.918,
															-2.386
														],
														[
															-1.023,
															-2.223
														],
														[
															-1.144,
															-2.024
														],
														[
															-0.462,
															-0.645
														],
														[
															-0.504,
															-0.672
														],
														[
															-0.541,
															-0.651
														],
														[
															-0.572,
															-0.581
														],
														[
															-0.598,
															-0.463
														],
														[
															-0.618,
															-0.296
														],
														[
															-0.633,
															-0.081
														],
														[
															-0.643,
															0.183
														],
														[
															-0.906,
															0.693
														],
														[
															-0.889,
															0.867
														],
														[
															-0.867,
															1.025
														],
														[
															-0.839,
															1.166
														],
														[
															-0.806,
															1.292
														],
														[
															-0.767,
															1.402
														],
														[
															-0.724,
															1.497
														],
														[
															-0.675,
															1.575
														],
														[
															-3.38,
															8.923
														],
														[
															-2.61,
															9.969
														],
														[
															-1.986,
															10.506
														],
														[
															-1.508,
															10.534
														],
														[
															-1.687,
															14.437
														],
														[
															-1.254,
															15.339
														],
														[
															-0.828,
															15.697
														],
														[
															-0.41,
															15.509
														],
														[
															0,
															16.082
														],
														[
															0.409,
															15.79
														],
														[
															0.827,
															15.399
														],
														[
															1.255,
															14.909
														],
														[
															0.629,
															5.324
														],
														[
															0.768,
															5.455
														],
														[
															0.863,
															5.384
														],
														[
															0.913,
															5.112
														],
														[
															1.012,
															5.107
														],
														[
															1.139,
															5.005
														],
														[
															1.306,
															4.861
														],
														[
															1.514,
															4.676
														],
														[
															1.113,
															2.811
														],
														[
															1.284,
															2.785
														],
														[
															1.581,
															2.553
														],
														[
															2.007,
															2.117
														],
														[
															0.451,
															-0.991
														],
														[
															0.035,
															-0.931
														],
														[
															-0.102,
															-0.898
														],
														[
															0.038,
															-0.893
														]
													],
													"v": [
														[
															362,
															687
														],
														[
															362.238,
															686.716
														],
														[
															362.616,
															686.482
														],
														[
															363.102,
															686.277
														],
														[
															363.662,
															686.082
														],
														[
															364.264,
															685.877
														],
														[
															364.876,
															685.641
														],
														[
															365.466,
															685.356
														],
														[
															366,
															685
														],
														[
															366.465,
															684.607
														],
														[
															366.934,
															684.177
														],
														[
															367.393,
															683.731
														],
														[
															367.826,
															683.289
														],
														[
															368.219,
															682.874
														],
														[
															368.555,
															682.507
														],
														[
															368.821,
															682.208
														],
														[
															369,
															682
														],
														[
															373.003,
															676.686
														],
														[
															376.515,
															670.95
														],
														[
															379.601,
															664.853
														],
														[
															382.33,
															658.452
														],
														[
															384.767,
															651.808
														],
														[
															386.98,
															644.978
														],
														[
															389.035,
															638.023
														],
														[
															391,
															631
														],
														[
															393.514,
															621.488
														],
														[
															395.878,
															611.733
														],
														[
															398.094,
															601.75
														],
														[
															400.163,
															591.556
														],
														[
															402.087,
															581.167
														],
														[
															403.867,
															570.601
														],
														[
															405.504,
															559.873
														],
														[
															407,
															549
														],
														[
															412.644,
															497.041
														],
														[
															416.481,
															442.14
														],
														[
															418.466,
															385.424
														],
														[
															418.552,
															328.017
														],
														[
															416.695,
															271.046
														],
														[
															412.848,
															215.635
														],
														[
															406.965,
															162.911
														],
														[
															399,
															114
														],
														[
															398.467,
															111.427
														],
														[
															397.881,
															108.889
														],
														[
															397.256,
															106.38
														],
														[
															396.603,
															103.892
														],
														[
															395.939,
															101.417
														],
														[
															395.274,
															98.948
														],
														[
															394.623,
															96.479
														],
														[
															394,
															94
														],
														[
															392.031,
															85.987
														],
														[
															389.976,
															77.975
														],
														[
															387.785,
															70.074
														],
														[
															385.406,
															62.39
														],
														[
															382.789,
															55.033
														],
														[
															379.882,
															48.11
														],
														[
															376.636,
															41.729
														],
														[
															373,
															36
														],
														[
															371.549,
															34.013
														],
														[
															369.98,
															32.018
														],
														[
															368.31,
															30.159
														],
														[
															366.554,
															28.582
														],
														[
															364.729,
															27.432
														],
														[
															362.851,
															26.855
														],
														[
															360.936,
															26.996
														],
														[
															359,
															28
														],
														[
															356.305,
															30.344
														],
														[
															353.67,
															33.185
														],
														[
															351.11,
															36.476
														],
														[
															348.642,
															40.168
														],
														[
															346.28,
															44.214
														],
														[
															344.042,
															48.566
														],
														[
															341.944,
															53.178
														],
														[
															340,
															58
														],
														[
															331.051,
															86.465
														],
														[
															324.192,
															117.306
														],
														[
															318.987,
															148.994
														],
														[
															315,
															180
														],
														[
															310.591,
															224.801
														],
														[
															307.47,
															271.49
														],
														[
															305.614,
															318.435
														],
														[
															305,
															364
														],
														[
															305.611,
															411.833
														],
														[
															307.464,
															458.643
														],
														[
															310.584,
															504.131
														],
														[
															315,
															548
														],
														[
															317.106,
															564.219
														],
														[
															319.564,
															580.527
														],
														[
															322.239,
															596.321
														],
														[
															325,
															611
														],
														[
															328.217,
															626.179
														],
														[
															331.875,
															640.987
														],
														[
															336.095,
															655.302
														],
														[
															341,
															669
														],
														[
															344.564,
															677.445
														],
														[
															348.829,
															685.503
														],
														[
															354.18,
															692.559
														],
														[
															361,
															698
														],
														[
															361.661,
															695.124
														],
														[
															361.491,
															692.388
														],
														[
															361.326,
															689.707
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 81,
											"s": [
												{
													"i": [
														[
															0.254,
															-0.122
														],
														[
															1.662,
															-1.242
														],
														[
															1.38,
															-1.484
														],
														[
															1.278,
															-1.75
														],
														[
															1.356,
															-2.04
														],
														[
															4.365,
															-10.893
														],
														[
															3.275,
															-12.156
														],
														[
															2.398,
															-12.31
														],
														[
															1.732,
															-11.354
														],
														[
															0.989,
															-7.576
														],
														[
															0.866,
															-7.823
														],
														[
															0.694,
															-7.71
														],
														[
															0.474,
															-7.239
														],
														[
															0.238,
															-4.1
														],
														[
															0.183,
															-4.086
														],
														[
															0.103,
															-4.068
														],
														[
															0,
															-4.047
														],
														[
															0.049,
															-11.807
														],
														[
															-0.111,
															-11.716
														],
														[
															-0.479,
															-11.926
														],
														[
															-1.055,
															-12.438
														],
														[
															-2.116,
															-17.021
														],
														[
															-3.01,
															-16.306
														],
														[
															-4.14,
															-15.007
														],
														[
															-5.504,
															-13.124
														],
														[
															-0.151,
															-0.288
														],
														[
															-0.172,
															-0.314
														],
														[
															-0.185,
															-0.369
														],
														[
															-0.192,
															-0.454
														],
														[
															-0.55,
															-1.107
														],
														[
															-0.575,
															-1.025
														],
														[
															-0.612,
															-1.031
														],
														[
															-0.662,
															-1.124
														],
														[
															-0.572,
															-0.965
														],
														[
															-0.564,
															-0.908
														],
														[
															-0.585,
															-0.864
														],
														[
															-0.635,
															-0.834
														],
														[
															-0.175,
															-0.076
														],
														[
															-0.203,
															-0.063
														],
														[
															-0.177,
															-0.08
														],
														[
															-0.096,
															-0.129
														],
														[
															-0.068,
															-0.263
														],
														[
															-0.033,
															-0.266
														],
														[
															-0.074,
															-0.245
														],
														[
															-0.19,
															-0.2
														],
														[
															-0.464,
															-0.395
														],
														[
															-0.493,
															-0.381
														],
														[
															-0.407,
															-0.295
														],
														[
															-0.208,
															-0.138
														],
														[
															-1.077,
															-0.717
														],
														[
															-1.081,
															-0.655
														],
														[
															-0.839,
															-0.36
														],
														[
															-0.349,
															0.166
														],
														[
															-0.228,
															0.928
														],
														[
															-0.17,
															1.291
														],
														[
															-0.357,
															1.342
														],
														[
															-0.789,
															1.081
														],
														[
															-0.272,
															0.094
														],
														[
															-0.352,
															0.104
														],
														[
															-0.279,
															0.083
														],
														[
															-0.053,
															0.031
														],
														[
															-1.799,
															1.546
														],
														[
															-1.559,
															1.735
														],
														[
															-1.231,
															1.697
														],
														[
															-0.814,
															1.43
														],
														[
															-1.261,
															2.308
														],
														[
															-1.177,
															2.311
														],
														[
															-1.077,
															2.347
														],
														[
															-0.962,
															2.418
														],
														[
															-1.084,
															3.055
														],
														[
															-1.006,
															3.134
														],
														[
															-0.918,
															3.137
														],
														[
															-0.822,
															3.064
														],
														[
															-4.117,
															28.8
														],
														[
															-1.657,
															30.59
														],
														[
															0.538,
															30.871
														],
														[
															2.468,
															29.64
														],
														[
															2.041,
															16.059
														],
														[
															2.989,
															15.37
														],
														[
															4.204,
															14.251
														],
														[
															5.684,
															12.702
														],
														[
															1.026,
															2.144
														],
														[
															1.091,
															2.066
														],
														[
															1.144,
															1.888
														],
														[
															1.186,
															1.612
														],
														[
															0.473,
															0.505
														],
														[
															0.51,
															0.474
														],
														[
															0.532,
															0.482
														],
														[
															0.539,
															0.529
														],
														[
															1.172,
															1.001
														],
														[
															1.264,
															0.785
														],
														[
															1.46,
															0.517
														],
														[
															1.761,
															0.195
														],
														[
															0.207,
															-0.081
														],
														[
															0.151,
															-0.128
														],
														[
															0.119,
															-0.108
														],
														[
															0.111,
															-0.021
														],
														[
															0.271,
															-0.069
														],
														[
															0.22,
															-0.077
														],
														[
															0.214,
															-0.094
														]
													],
													"o": [
														[
															-2.124,
															1.024
														],
														[
															-1.662,
															1.242
														],
														[
															-1.38,
															1.484
														],
														[
															-1.278,
															1.75
														],
														[
															-5.667,
															8.522
														],
														[
															-4.365,
															10.893
														],
														[
															-3.275,
															12.156
														],
														[
															-2.398,
															12.31
														],
														[
															-1.063,
															6.97
														],
														[
															-0.989,
															7.576
														],
														[
															-0.866,
															7.823
														],
														[
															-0.694,
															7.71
														],
														[
															-0.269,
															4.111
														],
														[
															-0.238,
															4.1
														],
														[
															-0.183,
															4.086
														],
														[
															-0.103,
															4.068
														],
														[
															0,
															12.199
														],
														[
															-0.049,
															11.807
														],
														[
															0.111,
															11.716
														],
														[
															0.479,
															11.926
														],
														[
															1.455,
															17.151
														],
														[
															2.116,
															17.021
														],
														[
															3.01,
															16.306
														],
														[
															4.14,
															15.007
														],
														[
															0.122,
															0.291
														],
														[
															0.151,
															0.288
														],
														[
															0.172,
															0.314
														],
														[
															0.185,
															0.369
														],
														[
															0.537,
															1.274
														],
														[
															0.55,
															1.107
														],
														[
															0.575,
															1.025
														],
														[
															0.612,
															1.031
														],
														[
															0.61,
															1.036
														],
														[
															0.572,
															0.965
														],
														[
															0.564,
															0.908
														],
														[
															0.585,
															0.864
														],
														[
															0.092,
															0.121
														],
														[
															0.175,
															0.076
														],
														[
															0.203,
															0.063
														],
														[
															0.177,
															0.08
														],
														[
															0.177,
															0.236
														],
														[
															0.068,
															0.263
														],
														[
															0.033,
															0.266
														],
														[
															0.074,
															0.245
														],
														[
															0.322,
															0.338
														],
														[
															0.464,
															0.395
														],
														[
															0.493,
															0.381
														],
														[
															0.407,
															0.295
														],
														[
															0.826,
															0.548
														],
														[
															1.077,
															0.717
														],
														[
															1.081,
															0.655
														],
														[
															0.839,
															0.36
														],
														[
															0.532,
															-0.253
														],
														[
															0.228,
															-0.928
														],
														[
															0.17,
															-1.291
														],
														[
															0.357,
															-1.342
														],
														[
															0.038,
															-0.052
														],
														[
															0.272,
															-0.094
														],
														[
															0.352,
															-0.104
														],
														[
															0.279,
															-0.083
														],
														[
															1.949,
															-1.129
														],
														[
															1.799,
															-1.546
														],
														[
															1.559,
															-1.735
														],
														[
															1.231,
															-1.697
														],
														[
															1.331,
															-2.34
														],
														[
															1.261,
															-2.308
														],
														[
															1.177,
															-2.311
														],
														[
															1.077,
															-2.347
														],
														[
															1.154,
															-2.899
														],
														[
															1.084,
															-3.055
														],
														[
															1.006,
															-3.134
														],
														[
															0.918,
															-3.137
														],
														[
															6.842,
															-25.499
														],
														[
															4.117,
															-28.8
														],
														[
															1.657,
															-30.59
														],
														[
															-0.538,
															-30.871
														],
														[
															-1.359,
															-16.318
														],
														[
															-2.041,
															-16.059
														],
														[
															-2.989,
															-15.37
														],
														[
															-4.204,
															-14.251
														],
														[
															-0.951,
															-2.124
														],
														[
															-1.026,
															-2.144
														],
														[
															-1.091,
															-2.066
														],
														[
															-1.144,
															-1.888
														],
														[
															-0.423,
															-0.574
														],
														[
															-0.473,
															-0.505
														],
														[
															-0.51,
															-0.474
														],
														[
															-0.532,
															-0.482
														],
														[
															-1.185,
															-1.163
														],
														[
															-1.172,
															-1.001
														],
														[
															-1.264,
															-0.786
														],
														[
															-1.46,
															-0.517
														],
														[
															-0.287,
															-0.032
														],
														[
															-0.207,
															0.081
														],
														[
															-0.151,
															0.128
														],
														[
															-0.119,
															0.108
														],
														[
															-0.367,
															0.072
														],
														[
															-0.271,
															0.069
														],
														[
															-0.22,
															0.077
														],
														[
															-0.214,
															0.094
														]
													],
													"v": [
														[
															356,
															28
														],
														[
															350.366,
															31.393
														],
														[
															345.848,
															35.476
														],
														[
															341.907,
															40.321
														],
														[
															338,
															46
														],
														[
															323.005,
															75.4
														],
														[
															311.598,
															110.251
														],
														[
															303.141,
															147.227
														],
														[
															297,
															183
														],
														[
															293.91,
															204.909
														],
														[
															291.116,
															228.096
														],
														[
															288.765,
															251.486
														],
														[
															287,
															274
														],
														[
															286.233,
															286.316
														],
														[
															285.596,
															298.595
														],
														[
															285.161,
															310.826
														],
														[
															285,
															323
														],
														[
															284.875,
															358.934
														],
														[
															284.917,
															394.142
														],
														[
															285.751,
															429.53
														],
														[
															288,
															466
														],
														[
															293.298,
															517.404
														],
														[
															300.928,
															567.541
														],
														[
															311.594,
															614.657
														],
														[
															326,
															657
														],
														[
															326.411,
															657.861
														],
														[
															326.896,
															658.755
														],
														[
															327.433,
															659.772
														],
														[
															328,
															661
														],
														[
															329.628,
															664.55
														],
														[
															331.313,
															667.726
														],
														[
															333.092,
															670.789
														],
														[
															335,
															674
														],
														[
															336.767,
															676.998
														],
														[
															338.463,
															679.803
														],
														[
															340.178,
															682.457
														],
														[
															342,
															685
														],
														[
															342.413,
															685.288
														],
														[
															342.993,
															685.488
														],
														[
															343.576,
															685.694
														],
														[
															344,
															686
														],
														[
															344.348,
															686.754
														],
														[
															344.481,
															687.554
														],
														[
															344.623,
															688.327
														],
														[
															345,
															689
														],
														[
															346.207,
															690.118
														],
														[
															347.67,
															691.3
														],
														[
															349.048,
															692.332
														],
														[
															350,
															693
														],
														[
															352.916,
															694.956
														],
														[
															356.216,
															697.071
														],
														[
															359.157,
															698.651
														],
														[
															361,
															699
														],
														[
															362.079,
															697.15
														],
														[
															362.615,
															693.742
														],
														[
															363.343,
															689.713
														],
														[
															365,
															686
														],
														[
															365.503,
															685.773
														],
														[
															366.477,
															685.468
														],
														[
															367.463,
															685.179
														],
														[
															368,
															685
														],
														[
															373.644,
															680.932
														],
														[
															378.703,
															675.953
														],
														[
															382.911,
															670.748
														],
														[
															386,
															666
														],
														[
															389.893,
															659.036
														],
														[
															393.553,
															652.116
														],
														[
															396.937,
															645.138
														],
														[
															400,
															638
														],
														[
															403.36,
															629.05
														],
														[
															406.498,
															619.748
														],
														[
															409.387,
															610.321
														],
														[
															412,
															601
														],
														[
															428.372,
															519.175
														],
														[
															436.965,
															429.713
														],
														[
															438.576,
															337.144
														],
														[
															434,
															246
														],
														[
															428.967,
															197.328
														],
														[
															421.489,
															150.077
														],
														[
															410.766,
															105.538
														],
														[
															396,
															65
														],
														[
															393.032,
															58.572
														],
														[
															389.853,
															52.232
														],
														[
															386.498,
															46.276
														],
														[
															383,
															41
														],
														[
															381.653,
															39.391
														],
														[
															380.175,
															37.932
														],
														[
															378.61,
															36.508
														],
														[
															377,
															35
														],
														[
															373.491,
															31.741
														],
														[
															369.865,
															29.049
														],
														[
															365.806,
															27.082
														],
														[
															361,
															26
														],
														[
															360.265,
															26.091
														],
														[
															359.736,
															26.42
														],
														[
															359.338,
															26.79
														],
														[
															359,
															27
														],
														[
															358.055,
															27.208
														],
														[
															357.33,
															27.424
														],
														[
															356.691,
															27.678
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 82,
											"s": [
												{
													"i": [
														[
															3.227,
															-5.245
														],
														[
															0.177,
															-0.173
														],
														[
															0.184,
															-0.145
														],
														[
															0.165,
															-0.149
														],
														[
															0.12,
															-0.186
														],
														[
															0.329,
															-0.75
														],
														[
															0.301,
															-0.797
														],
														[
															0.321,
															-0.774
														],
														[
															0.391,
															-0.679
														],
														[
															0.26,
															-0.244
														],
														[
															0.291,
															-0.228
														],
														[
															0.26,
															-0.244
														],
														[
															0.168,
															-0.295
														],
														[
															0.16,
															-0.406
														],
														[
															0.145,
															-0.429
														],
														[
															0.162,
															-0.433
														],
														[
															0.212,
															-0.419
														],
														[
															2.061,
															-4.777
														],
														[
															1.825,
															-4.896
														],
														[
															1.602,
															-4.921
														],
														[
															1.389,
															-4.852
														],
														[
															0.916,
															-3.659
														],
														[
															0.814,
															-3.615
														],
														[
															0.741,
															-3.523
														],
														[
															0.696,
															-3.385
														],
														[
															2.866,
															-33.123
														],
														[
															-0.266,
															-34.178
														],
														[
															-3.374,
															-32.466
														],
														[
															-6.459,
															-27.988
														],
														[
															-1.558,
															-6.168
														],
														[
															-1.736,
															-6.054
														],
														[
															-1.935,
															-5.734
														],
														[
															-2.155,
															-5.208
														],
														[
															-0.417,
															-0.74
														],
														[
															-0.449,
															-0.716
														],
														[
															-0.433,
															-0.743
														],
														[
															-0.369,
															-0.822
														],
														[
															-0.074,
															-0.421
														],
														[
															-0.043,
															-0.44
														],
														[
															-0.073,
															-0.424
														],
														[
															-0.162,
															-0.372
														],
														[
															-0.253,
															-0.331
														],
														[
															-0.287,
															-0.314
														],
														[
															-0.265,
															-0.327
														],
														[
															-0.188,
															-0.368
														],
														[
															-0.315,
															-0.754
														],
														[
															-0.296,
															-0.749
														],
														[
															-0.333,
															-0.745
														],
														[
															-0.427,
															-0.745
														],
														[
															-0.257,
															-0.245
														],
														[
															-0.287,
															-0.226
														],
														[
															-0.261,
															-0.243
														],
														[
															-0.18,
															-0.296
														],
														[
															-0.149,
															-0.417
														],
														[
															-0.117,
															-0.416
														],
														[
															-0.16,
															-0.415
														],
														[
															-0.278,
															-0.417
														],
														[
															-1.782,
															-2.248
														],
														[
															-1.985,
															-2.112
														],
														[
															-2.085,
															-1.807
														],
														[
															-2.083,
															-1.336
														],
														[
															-1.35,
															-0.756
														],
														[
															-1.474,
															-0.676
														],
														[
															-1.262,
															-0.332
														],
														[
															-0.715,
															0.275
														],
														[
															-0.398,
															0.338
														],
														[
															-0.259,
															0.471
														],
														[
															-0.232,
															0.647
														],
														[
															-0.317,
															0.868
														],
														[
															-0.093,
															0.38
														],
														[
															-0.07,
															0.357
														],
														[
															-0.068,
															0.299
														],
														[
															-0.084,
															0.205
														],
														[
															-0.599,
															0.581
														],
														[
															-0.739,
															0.302
														],
														[
															-0.896,
															0.32
														],
														[
															-1.068,
															0.635
														],
														[
															-0.408,
															0.289
														],
														[
															-0.39,
															0.3
														],
														[
															-0.287,
															0.236
														],
														[
															-0.1,
															0.095
														],
														[
															-1.471,
															1.434
														],
														[
															-1.346,
															1.393
														],
														[
															-1.202,
															1.387
														],
														[
															-1.039,
															1.417
														],
														[
															-2.201,
															3.582
														],
														[
															-1.946,
															3.732
														],
														[
															-1.772,
															3.909
														],
														[
															-1.678,
															4.112
														],
														[
															-1.192,
															2.998
														],
														[
															-1.007,
															3.001
														],
														[
															-2.487,
															76.253
														],
														[
															13.367,
															64.141
														],
														[
															4.64,
															15.619
														],
														[
															7.817,
															16.148
														],
														[
															8.108,
															9.574
														],
														[
															11.078,
															2.362
														],
														[
															0.497,
															-0.284
														],
														[
															0.252,
															-0.027
														],
														[
															6.242,
															-5.73
														]
													],
													"o": [
														[
															-0.144,
															0.234
														],
														[
															-0.177,
															0.173
														],
														[
															-0.184,
															0.145
														],
														[
															-0.165,
															0.149
														],
														[
															-0.407,
															0.632
														],
														[
															-0.329,
															0.75
														],
														[
															-0.301,
															0.797
														],
														[
															-0.321,
															0.774
														],
														[
															-0.169,
															0.295
														],
														[
															-0.26,
															0.244
														],
														[
															-0.291,
															0.227
														],
														[
															-0.26,
															0.244
														],
														[
															-0.209,
															0.365
														],
														[
															-0.16,
															0.406
														],
														[
															-0.145,
															0.429
														],
														[
															-0.162,
															0.433
														],
														[
															-2.309,
															4.565
														],
														[
															-2.061,
															4.777
														],
														[
															-1.826,
															4.896
														],
														[
															-1.601,
															4.921
														],
														[
															-1.047,
															3.656
														],
														[
															-0.916,
															3.659
														],
														[
															-0.814,
															3.615
														],
														[
															-0.741,
															3.523
														],
														[
															-6.021,
															29.301
														],
														[
															-2.866,
															33.123
														],
														[
															0.265,
															34.178
														],
														[
															3.374,
															32.466
														],
														[
															1.402,
															6.076
														],
														[
															1.558,
															6.168
														],
														[
															1.736,
															6.054
														],
														[
															1.935,
															5.734
														],
														[
															0.337,
															0.814
														],
														[
															0.417,
															0.74
														],
														[
															0.449,
															0.716
														],
														[
															0.433,
															0.743
														],
														[
															0.164,
															0.366
														],
														[
															0.074,
															0.421
														],
														[
															0.043,
															0.44
														],
														[
															0.073,
															0.424
														],
														[
															0.163,
															0.376
														],
														[
															0.253,
															0.331
														],
														[
															0.287,
															0.314
														],
														[
															0.266,
															0.327
														],
														[
															0.39,
															0.761
														],
														[
															0.315,
															0.754
														],
														[
															0.296,
															0.748
														],
														[
															0.333,
															0.745
														],
														[
															0.172,
															0.301
														],
														[
															0.257,
															0.245
														],
														[
															0.287,
															0.226
														],
														[
															0.261,
															0.243
														],
														[
															0.255,
															0.421
														],
														[
															0.149,
															0.417
														],
														[
															0.117,
															0.416
														],
														[
															0.16,
															0.415
														],
														[
															1.478,
															2.217
														],
														[
															1.782,
															2.248
														],
														[
															1.985,
															2.112
														],
														[
															2.085,
															1.807
														],
														[
															0.89,
															0.571
														],
														[
															1.35,
															0.756
														],
														[
															1.474,
															0.676
														],
														[
															1.262,
															0.332
														],
														[
															0.649,
															-0.25
														],
														[
															0.398,
															-0.338
														],
														[
															0.259,
															-0.471
														],
														[
															0.232,
															-0.647
														],
														[
															0.134,
															-0.366
														],
														[
															0.093,
															-0.38
														],
														[
															0.07,
															-0.357
														],
														[
															0.068,
															-0.299
														],
														[
															0.475,
															-1.156
														],
														[
															0.599,
															-0.581
														],
														[
															0.739,
															-0.302
														],
														[
															0.896,
															-0.32
														],
														[
															0.341,
															-0.203
														],
														[
															0.408,
															-0.289
														],
														[
															0.39,
															-0.3
														],
														[
															0.287,
															-0.236
														],
														[
															1.577,
															-1.511
														],
														[
															1.471,
															-1.434
														],
														[
															1.346,
															-1.393
														],
														[
															1.202,
															-1.387
														],
														[
															2.537,
															-3.459
														],
														[
															2.201,
															-3.582
														],
														[
															1.946,
															-3.732
														],
														[
															1.772,
															-3.909
														],
														[
															1.226,
															-3.006
														],
														[
															1.191,
															-2.998
														],
														[
															19.42,
															-57.847
														],
														[
															2.487,
															-76.253
														],
														[
															-3.621,
															-17.378
														],
														[
															-4.64,
															-15.619
														],
														[
															-5.491,
															-11.343
														],
														[
															-8.108,
															-9.574
														],
														[
															-0.76,
															-0.162
														],
														[
															-0.497,
															0.284
														],
														[
															-7.803,
															0.833
														],
														[
															-6.242,
															5.73
														]
													],
													"v": [
														[
															324,
															55
														],
														[
															323.512,
															55.602
														],
														[
															322.964,
															56.072
														],
														[
															322.434,
															56.505
														],
														[
															322,
															57
														],
														[
															320.908,
															59.091
														],
														[
															319.976,
															61.429
														],
														[
															319.055,
															63.803
														],
														[
															318,
															66
														],
														[
															317.34,
															66.801
														],
														[
															316.498,
															67.5
														],
														[
															315.658,
															68.199
														],
														[
															315,
															69
														],
														[
															314.454,
															70.162
														],
														[
															314.005,
															71.42
														],
														[
															313.553,
															72.717
														],
														[
															313,
															74
														],
														[
															306.448,
															88.036
														],
														[
															300.621,
															102.57
														],
														[
															295.483,
															117.318
														],
														[
															291,
															132
														],
														[
															288.062,
															142.984
														],
														[
															285.473,
															153.906
														],
														[
															283.148,
															164.625
														],
														[
															281,
															175
														],
														[
															267.676,
															269.327
														],
														[
															263.781,
															370.969
														],
														[
															269.245,
															471.627
														],
														[
															284,
															563
														],
														[
															288.435,
															581.418
														],
														[
															293.371,
															599.802
														],
														[
															298.871,
															617.535
														],
														[
															305,
															634
														],
														[
															306.143,
															636.318
														],
														[
															307.452,
															638.489
														],
														[
															308.786,
															640.665
														],
														[
															310,
															643
														],
														[
															310.342,
															644.189
														],
														[
															310.503,
															645.49
														],
														[
															310.663,
															646.796
														],
														[
															311,
															648
														],
														[
															311.639,
															649.053
														],
														[
															312.462,
															650.012
														],
														[
															313.305,
															650.966
														],
														[
															314,
															652
														],
														[
															315.043,
															654.272
														],
														[
															315.945,
															656.525
														],
														[
															316.874,
															658.765
														],
														[
															318,
															661
														],
														[
															318.658,
															661.809
														],
														[
															319.488,
															662.506
														],
														[
															320.324,
															663.2
														],
														[
															321,
															664
														],
														[
															321.588,
															665.257
														],
														[
															321.967,
															666.506
														],
														[
															322.363,
															667.753
														],
														[
															323,
															669
														],
														[
															327.916,
															675.741
														],
														[
															333.593,
															682.323
														],
														[
															339.722,
															688.243
														],
														[
															346,
															693
														],
														[
															349.444,
															695.056
														],
														[
															353.763,
															697.27
														],
														[
															357.951,
															698.849
														],
														[
															361,
															699
														],
														[
															362.542,
															698.129
														],
														[
															363.498,
															696.927
														],
														[
															364.205,
															695.262
														],
														[
															365,
															693
														],
														[
															365.335,
															691.872
														],
														[
															365.575,
															690.757
														],
														[
															365.777,
															689.764
														],
														[
															366,
															689
														],
														[
															367.606,
															686.468
														],
														[
															369.609,
															685.218
														],
														[
															372.058,
															684.358
														],
														[
															375,
															683
														],
														[
															376.145,
															682.243
														],
														[
															377.362,
															681.339
														],
														[
															378.399,
															680.516
														],
														[
															379,
															680
														],
														[
															383.577,
															675.591
														],
														[
															387.807,
															671.359
														],
														[
															391.633,
															667.197
														],
														[
															395,
															663
														],
														[
															402.088,
															652.444
														],
														[
															408.289,
															641.478
														],
														[
															413.846,
															630.024
														],
														[
															419,
															618
														],
														[
															422.664,
															608.996
														],
														[
															426,
															600
														],
														[
															458.59,
															391.22
														],
														[
															442,
															173
														],
														[
															430.147,
															124.077
														],
														[
															412,
															77
														],
														[
															391.69,
															44.265
														],
														[
															363,
															25
														],
														[
															361.119,
															25.358
														],
														[
															360,
															26
														],
														[
															338.568,
															37.191
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 83,
											"s": [
												{
													"i": [
														[
															2.269,
															-1.194
														],
														[
															0.215,
															-0.23
														],
														[
															0.195,
															-0.267
														],
														[
															0.257,
															-0.278
														],
														[
															0.403,
															-0.264
														],
														[
															0.436,
															-0.159
														],
														[
															0.479,
															-0.149
														],
														[
															0.429,
															-0.165
														],
														[
															0.286,
															-0.209
														],
														[
															0.246,
															-0.247
														],
														[
															0.252,
															-0.278
														],
														[
															0.255,
															-0.267
														],
														[
															0.255,
															-0.213
														],
														[
															1.42,
															-1.355
														],
														[
															1.298,
															-1.401
														],
														[
															1.229,
															-1.471
														],
														[
															1.212,
															-1.564
														],
														[
															3.401,
															-5.39
														],
														[
															2.99,
															-5.737
														],
														[
															2.594,
															-5.978
														],
														[
															2.212,
															-6.114
														],
														[
															1.084,
															-3.458
														],
														[
															0.967,
															-3.432
														],
														[
															0.899,
															-3.383
														],
														[
															0.881,
															-3.311
														],
														[
															4.019,
															-40.16
														],
														[
															-2.034,
															-43.714
														],
														[
															-6.032,
															-33.601
														],
														[
															-10.168,
															-27.954
														],
														[
															-0.443,
															-1.7
														],
														[
															-0.62,
															-1.537
														],
														[
															-0.929,
															-1.492
														],
														[
															-0.671,
															-1.518
														],
														[
															-0.087,
															-0.878
														],
														[
															-0.326,
															-0.748
														],
														[
															-1.217,
															-2.117
														],
														[
															-1.127,
															-2.226
														],
														[
															-1.215,
															-2.029
														],
														[
															-0.948,
															-1.534
														],
														[
															-0.297,
															-0.93
														],
														[
															-0.411,
															-0.635
														],
														[
															-1.088,
															-1.14
														],
														[
															-0.857,
															-1.216
														],
														[
															-0.277,
															-0.686
														],
														[
															-0.448,
															-0.625
														],
														[
															-1.04,
															-1.143
														],
														[
															-0.851,
															-1.05
														],
														[
															-2.107,
															-2.008
														],
														[
															-1.839,
															-0.83
														],
														[
															-0.166,
															-0.451
														],
														[
															-0.179,
															-0.124
														],
														[
															-5.939,
															-2.937
														],
														[
															-3.733,
															1.49
														],
														[
															-0.404,
															0.884
														],
														[
															-0.693,
															1.789
														],
														[
															-0.353,
															1.165
														],
														[
															-1.078,
															1.027
														],
														[
															-1.281,
															0.392
														],
														[
															-0.822,
															0.38
														],
														[
															-5.719,
															5.127
														],
														[
															-4.388,
															5.925
														],
														[
															-0.514,
															0.431
														],
														[
															-0.448,
															0.606
														],
														[
															-0.241,
															0.885
														],
														[
															-0.514,
															0.755
														],
														[
															-0.569,
															0.488
														],
														[
															-0.373,
															0.529
														],
														[
															-1.079,
															2.17
														],
														[
															-1.213,
															2.227
														],
														[
															-7.018,
															23.411
														],
														[
															-4.187,
															25.639
														],
														[
															-0.983,
															7.615
														],
														[
															-0.808,
															7.821
														],
														[
															3.108,
															48.769
														],
														[
															10.575,
															39.41
														],
														[
															4.62,
															12.828
														],
														[
															6.155,
															12.151
														],
														[
															2.134,
															3.471
														],
														[
															1.74,
															2.713
														],
														[
															1.297,
															1.643
														],
														[
															0.827,
															0.889
														],
														[
															0.075,
															0.549
														],
														[
															0.344,
															0.421
														],
														[
															1.281,
															0.971
														],
														[
															1.025,
															1.076
														],
														[
															0.267,
															0.763
														],
														[
															0.431,
															0.42
														],
														[
															0.387,
															0.162
														],
														[
															0.241,
															0.148
														],
														[
															1.216,
															1.161
														],
														[
															0.841,
															0.558
														],
														[
															0.908,
															0.627
														],
														[
															1.185,
															0.708
														],
														[
															1.178,
															0.48
														],
														[
															2.207,
															0.836
														],
														[
															0.622,
															0.371
														],
														[
															0.69,
															0.206
														],
														[
															2.099,
															0.092
														],
														[
															1.127,
															-0.109
														],
														[
															2.86,
															-0.872
														]
													],
													"o": [
														[
															-0.318,
															0.168
														],
														[
															-0.215,
															0.23
														],
														[
															-0.195,
															0.267
														],
														[
															-0.257,
															0.278
														],
														[
															-0.299,
															0.196
														],
														[
															-0.436,
															0.159
														],
														[
															-0.479,
															0.149
														],
														[
															-0.429,
															0.165
														],
														[
															-0.238,
															0.174
														],
														[
															-0.246,
															0.247
														],
														[
															-0.252,
															0.278
														],
														[
															-0.255,
															0.267
														],
														[
															-1.595,
															1.333
														],
														[
															-1.42,
															1.355
														],
														[
															-1.298,
															1.401
														],
														[
															-1.229,
															1.471
														],
														[
															-3.826,
															4.939
														],
														[
															-3.401,
															5.39
														],
														[
															-2.99,
															5.737
														],
														[
															-2.594,
															5.978
														],
														[
															-1.252,
															3.46
														],
														[
															-1.084,
															3.458
														],
														[
															-0.967,
															3.432
														],
														[
															-0.899,
															3.383
														],
														[
															-8.957,
															33.648
														],
														[
															-4.019,
															40.16
														],
														[
															1.704,
															36.643
														],
														[
															6.032,
															33.601
														],
														[
															0.606,
															1.664
														],
														[
															0.444,
															1.7
														],
														[
															0.611,
															1.515
														],
														[
															0.929,
															1.492
														],
														[
															0.327,
															0.738
														],
														[
															0.087,
															0.878
														],
														[
															1.002,
															2.304
														],
														[
															1.217,
															2.117
														],
														[
															1.19,
															2.349
														],
														[
															1.215,
															2.029
														],
														[
															0.399,
															0.646
														],
														[
															0.297,
															0.93
														],
														[
															0.792,
															1.225
														],
														[
															1.088,
															1.14
														],
														[
															0.445,
															0.631
														],
														[
															0.277,
															0.686
														],
														[
															0.99,
															1.38
														],
														[
															1.04,
															1.143
														],
														[
															1.734,
															2.14
														],
														[
															2.107,
															2.007
														],
														[
															0.159,
															0.072
														],
														[
															0.166,
															0.451
														],
														[
															2.513,
															1.741
														],
														[
															5.938,
															2.937
														],
														[
															1.691,
															-0.675
														],
														[
															0.404,
															-0.884
														],
														[
															0.509,
															-1.313
														],
														[
															0.353,
															-1.165
														],
														[
															0.054,
															-0.052
														],
														[
															1.281,
															-0.392
														],
														[
															7.735,
															-3.569
														],
														[
															5.719,
															-5.127
														],
														[
															0.497,
															-0.671
														],
														[
															0.514,
															-0.431
														],
														[
															0.52,
															-0.704
														],
														[
															0.241,
															-0.885
														],
														[
															0.353,
															-0.518
														],
														[
															0.569,
															-0.488
														],
														[
															1.473,
															-2.092
														],
														[
															1.079,
															-2.17
														],
														[
															10.739,
															-19.717
														],
														[
															7.019,
															-23.411
														],
														[
															1.26,
															-7.719
														],
														[
															0.983,
															-7.615
														],
														[
															5.009,
															-48.512
														],
														[
															-3.108,
															-48.769
														],
														[
															-3.364,
															-12.536
														],
														[
															-4.62,
															-12.828
														],
														[
															-1.724,
															-3.402
														],
														[
															-2.134,
															-3.471
														],
														[
															-0.986,
															-1.538
														],
														[
															-1.297,
															-1.643
														],
														[
															-0.356,
															-0.383
														],
														[
															-0.075,
															-0.549
														],
														[
															-0.851,
															-1.041
														],
														[
															-1.281,
															-0.971
														],
														[
															-0.502,
															-0.528
														],
														[
															-0.267,
															-0.763
														],
														[
															-0.211,
															-0.205
														],
														[
															-0.387,
															-0.162
														],
														[
															-1.297,
															-0.798
														],
														[
															-1.215,
															-1.161
														],
														[
															-1.183,
															-0.785
														],
														[
															-0.908,
															-0.627
														],
														[
															-2.08,
															-1.242
														],
														[
															-1.178,
															-0.481
														],
														[
															-0.825,
															-0.312
														],
														[
															-0.622,
															-0.37
														],
														[
															-2.475,
															-0.739
														],
														[
															-2.099,
															-0.092
														],
														[
															-3.293,
															0.318
														],
														[
															-2.859,
															0.872
														]
													],
													"v": [
														[
															342,
															31
														],
														[
															341.221,
															31.603
														],
														[
															340.627,
															32.355
														],
														[
															339.969,
															33.18
														],
														[
															339,
															34
														],
														[
															337.875,
															34.526
														],
														[
															336.48,
															34.98
														],
														[
															335.095,
															35.445
														],
														[
															334,
															36
														],
														[
															333.274,
															36.642
														],
														[
															332.526,
															37.441
														],
														[
															331.765,
															38.269
														],
														[
															331,
															39
														],
														[
															326.49,
															43.026
														],
														[
															322.425,
															47.153
														],
														[
															318.648,
															51.453
														],
														[
															315,
															56
														],
														[
															304.163,
															71.521
														],
														[
															294.579,
															88.238
														],
														[
															286.206,
															105.836
														],
														[
															279,
															124
														],
														[
															275.508,
															134.382
														],
														[
															272.444,
															144.724
														],
														[
															269.658,
															154.953
														],
														[
															267,
															165
														],
														[
															247.257,
															276.45
														],
														[
															244,
															403
														],
														[
															255.653,
															509.017
														],
														[
															280,
															602
														],
														[
															281.489,
															607.096
														],
														[
															283,
															612
														],
														[
															285.455,
															616.498
														],
														[
															288,
															621
														],
														[
															288.501,
															623.493
														],
														[
															289,
															626
														],
														[
															292.406,
															632.558
														],
														[
															296,
															639
														],
														[
															299.681,
															645.612
														],
														[
															303,
															651
														],
														[
															303.991,
															653.507
														],
														[
															305,
															656
														],
														[
															307.951,
															659.506
														],
														[
															311,
															663
														],
														[
															311.997,
															665.005
														],
														[
															313,
															667
														],
														[
															316.104,
															670.747
														],
														[
															319,
															674
														],
														[
															324.921,
															680.483
														],
														[
															331,
															685
														],
														[
															331.485,
															685.961
														],
														[
															332,
															687
														],
														[
															346.085,
															695.424
														],
														[
															362,
															699
														],
														[
															364.749,
															696.836
														],
														[
															366,
															693
														],
														[
															367.073,
															689.285
														],
														[
															369,
															686
														],
														[
															371.424,
															685.246
														],
														[
															375,
															684
														],
														[
															395.01,
															670.767
														],
														[
															410,
															654
														],
														[
															411.536,
															652.452
														],
														[
															413,
															651
														],
														[
															414.005,
															648.539
														],
														[
															415,
															646
														],
														[
															416.485,
															644.508
														],
														[
															418,
															643
														],
														[
															421.695,
															636.602
														],
														[
															425,
															630
														],
														[
															451.414,
															564.942
														],
														[
															468,
															491
														],
														[
															471.34,
															468.077
														],
														[
															474,
															445
														],
														[
															476.688,
															296.673
														],
														[
															456,
															162
														],
														[
															444.094,
															123.711
														],
														[
															428,
															86
														],
														[
															422.012,
															75.484
														],
														[
															416,
															66
														],
														[
															412.381,
															61.013
														],
														[
															409,
															57
														],
														[
															408.491,
															55.529
														],
														[
															408,
															54
														],
														[
															404.631,
															51.027
														],
														[
															401,
															48
														],
														[
															399.947,
															45.919
														],
														[
															399,
															44
														],
														[
															398.023,
															43.458
														],
														[
															397,
															43
														],
														[
															393.159,
															39.82
														],
														[
															390,
															37
														],
														[
															387.001,
															34.942
														],
														[
															384,
															33
														],
														[
															379.595,
															30.696
														],
														[
															375,
															29
														],
														[
															372.899,
															27.92
														],
														[
															371,
															27
														],
														[
															363.989,
															25.864
														],
														[
															359,
															26
														],
														[
															349.732,
															27.843
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 84,
											"s": [
												{
													"i": [
														[
															3.019,
															-1.649
														],
														[
															0.233,
															-0.243
														],
														[
															0.217,
															-0.279
														],
														[
															0.251,
															-0.272
														],
														[
															0.335,
															-0.219
														],
														[
															0.427,
															-0.156
														],
														[
															0.45,
															-0.133
														],
														[
															0.423,
															-0.16
														],
														[
															0.346,
															-0.238
														],
														[
															0.598,
															-0.496
														],
														[
															0.579,
															-0.525
														],
														[
															0.566,
															-0.516
														],
														[
															0.559,
															-0.47
														],
														[
															1.681,
															-1.488
														],
														[
															1.639,
															-1.581
														],
														[
															1.388,
															-1.553
														],
														[
															0.93,
															-1.403
														],
														[
															0.556,
															-0.73
														],
														[
															0.562,
															-0.708
														],
														[
															0.475,
															-0.625
														],
														[
															0.295,
															-0.479
														],
														[
															0.172,
															-0.172
														],
														[
															0.176,
															-0.139
														],
														[
															0.166,
															-0.147
														],
														[
															0.141,
															-0.198
														],
														[
															2.53,
															-4.295
														],
														[
															2.036,
															-3.834
														],
														[
															5.597,
															-15.016
														],
														[
															3.754,
															-15.026
														],
														[
															2.942,
															-15.492
														],
														[
															1.718,
															-14.964
														],
														[
															-0.231,
															-30.505
														],
														[
															-3.366,
															-28.303
														],
														[
															-1.147,
															-7.9
														],
														[
															-1.485,
															-7.62
														],
														[
															-2.122,
															-8.278
														],
														[
															-1.954,
															-6.895
														],
														[
															-0.819,
															-2.556
														],
														[
															-0.801,
															-2.519
														],
														[
															-0.816,
															-3.102
														],
														[
															-0.791,
															-2.615
														],
														[
															-0.461,
															-0.39
														],
														[
															-0.098,
															-0.255
														],
														[
															-0.452,
															-1.733
														],
														[
															-0.595,
															-1.521
														],
														[
															-1.047,
															-2.396
														],
														[
															-0.807,
															-1.844
														],
														[
															-1.151,
															-2.245
														],
														[
															-1.221,
															-2.329
														],
														[
															-3.915,
															-6.323
														],
														[
															-3.966,
															-5.271
														],
														[
															-0.407,
															-0.14
														],
														[
															-0.202,
															-0.216
														],
														[
															-0.077,
															-0.554
														],
														[
															-0.344,
															-0.407
														],
														[
															-1.226,
															-1.174
														],
														[
															-1.1,
															-1.123
														],
														[
															-3.117,
															-2.606
														],
														[
															-2.826,
															-1.812
														],
														[
															-0.658,
															-0.539
														],
														[
															-0.68,
															-0.405
														],
														[
															-7.431,
															-2.312
														],
														[
															-2.494,
															2.903
														],
														[
															-0.018,
															0.88
														],
														[
															-0.534,
															1.021
														],
														[
															-0.354,
															0.954
														],
														[
															-0.81,
															0.702
														],
														[
															-2.578,
															0.671
														],
														[
															-2.196,
															1.024
														],
														[
															-2.463,
															1.63
														],
														[
															-1.56,
															1.273
														],
														[
															-0.654,
															0.464
														],
														[
															-0.644,
															0.541
														],
														[
															-6.647,
															8.625
														],
														[
															-5.635,
															10.123
														],
														[
															-9.047,
															45.686
														],
														[
															0,
															49.464
														],
														[
															8.08,
															41.54
														],
														[
															15.678,
															31.897
														],
														[
															1.168,
															2.106
														],
														[
															1.097,
															2.071
														],
														[
															0.548,
															0.631
														],
														[
															0.298,
															0.517
														],
														[
															0.58,
															1.55
														],
														[
															0.831,
															1.329
														],
														[
															0.585,
															0.502
														],
														[
															0.352,
															0.5
														],
														[
															1.234,
															1.964
														],
														[
															1.514,
															1.944
														],
														[
															1.226,
															1.112
														],
														[
															1.111,
															1.286
														],
														[
															0.241,
															0.692
														],
														[
															0.464,
															0.569
														],
														[
															0.702,
															0.427
														],
														[
															0.687,
															0.671
														],
														[
															9.216,
															5.235
														],
														[
															10.399,
															-0.545
														],
														[
															0.173,
															-0.246
														],
														[
															-0.029,
															0.002
														],
														[
															4.093,
															-1.232
														]
													],
													"o": [
														[
															-0.298,
															0.163
														],
														[
															-0.233,
															0.243
														],
														[
															-0.217,
															0.279
														],
														[
															-0.251,
															0.272
														],
														[
															-0.353,
															0.231
														],
														[
															-0.427,
															0.156
														],
														[
															-0.45,
															0.133
														],
														[
															-0.423,
															0.16
														],
														[
															-0.624,
															0.43
														],
														[
															-0.598,
															0.496
														],
														[
															-0.579,
															0.525
														],
														[
															-0.566,
															0.516
														],
														[
															-1.515,
															1.273
														],
														[
															-1.681,
															1.488
														],
														[
															-1.638,
															1.581
														],
														[
															-1.388,
															1.553
														],
														[
															-0.457,
															0.689
														],
														[
															-0.556,
															0.73
														],
														[
															-0.562,
															0.708
														],
														[
															-0.475,
															0.625
														],
														[
															-0.153,
															0.248
														],
														[
															-0.172,
															0.172
														],
														[
															-0.176,
															0.138
														],
														[
															-0.166,
															0.147
														],
														[
															-2.846,
															3.987
														],
														[
															-2.53,
															4.295
														],
														[
															-6.857,
															12.912
														],
														[
															-5.597,
															15.016
														],
														[
															-3.514,
															14.069
														],
														[
															-2.942,
															15.492
														],
														[
															-3.291,
															28.675
														],
														[
															0.231,
															30.505
														],
														[
															0.925,
															7.779
														],
														[
															1.148,
															7.9
														],
														[
															1.558,
															7.993
														],
														[
															2.122,
															8.278
														],
														[
															0.924,
															3.259
														],
														[
															0.819,
															2.556
														],
														[
															0.947,
															2.977
														],
														[
															0.816,
															3.102
														],
														[
															0.056,
															0.186
														],
														[
															0.462,
															0.39
														],
														[
															0.595,
															1.546
														],
														[
															0.452,
															1.733
														],
														[
															1.006,
															2.572
														],
														[
															1.047,
															2.396
														],
														[
															1.176,
															2.689
														],
														[
															1.151,
															2.245
														],
														[
															3.375,
															6.438
														],
														[
															3.915,
															6.323
														],
														[
															0.168,
															0.224
														],
														[
															0.408,
															0.14
														],
														[
															0.351,
															0.377
														],
														[
															0.076,
															0.554
														],
														[
															0.995,
															1.179
														],
														[
															1.226,
															1.174
														],
														[
															2.706,
															2.764
														],
														[
															3.117,
															2.606
														],
														[
															0.686,
															0.44
														],
														[
															0.658,
															0.539
														],
														[
															2.784,
															1.656
														],
														[
															7.431,
															2.312
														],
														[
															0.394,
															-0.459
														],
														[
															0.018,
															-0.88
														],
														[
															0.775,
															-1.48
														],
														[
															0.354,
															-0.955
														],
														[
															1.493,
															-1.294
														],
														[
															2.578,
															-0.671
														],
														[
															2.589,
															-1.207
														],
														[
															2.463,
															-1.63
														],
														[
															0.741,
															-0.605
														],
														[
															0.654,
															-0.464
														],
														[
															8.778,
															-7.378
														],
														[
															6.647,
															-8.625
														],
														[
															18.812,
															-33.792
														],
														[
															9.047,
															-45.686
														],
														[
															0,
															-47.942
														],
														[
															-8.081,
															-41.54
														],
														[
															-1.231,
															-2.504
														],
														[
															-1.168,
															-2.106
														],
														[
															-0.509,
															-0.96
														],
														[
															-0.548,
															-0.631
														],
														[
															-0.85,
															-1.471
														],
														[
															-0.58,
															-1.55
														],
														[
															-0.308,
															-0.492
														],
														[
															-0.585,
															-0.502
														],
														[
															-1.549,
															-2.201
														],
														[
															-1.234,
															-1.964
														],
														[
															-0.986,
															-1.267
														],
														[
															-1.226,
															-1.112
														],
														[
															-0.572,
															-0.662
														],
														[
															-0.241,
															-0.692
														],
														[
															-0.506,
															-0.621
														],
														[
															-0.702,
															-0.427
														],
														[
															-5.736,
															-5.604
														],
														[
															-9.216,
															-5.235
														],
														[
															-0.336,
															0.017
														],
														[
															-0.173,
															0.246
														],
														[
															-4.608,
															0.423
														],
														[
															-4.093,
															1.232
														]
													],
													"v": [
														[
															334,
															33
														],
														[
															333.217,
															33.62
														],
														[
															332.555,
															34.415
														],
														[
															331.866,
															35.252
														],
														[
															331,
															36
														],
														[
															329.818,
															36.569
														],
														[
															328.49,
															36.99
														],
														[
															327.167,
															37.416
														],
														[
															326,
															38
														],
														[
															324.168,
															39.398
														],
														[
															322.403,
															40.94
														],
														[
															320.687,
															42.511
														],
														[
															319,
															44
														],
														[
															314.154,
															48.172
														],
														[
															309.123,
															52.806
														],
														[
															304.53,
															57.537
														],
														[
															301,
															62
														],
														[
															299.458,
															64.143
														],
														[
															297.757,
															66.315
														],
														[
															296.178,
															68.33
														],
														[
															295,
															70
														],
														[
															294.51,
															70.619
														],
														[
															293.983,
															71.074
														],
														[
															293.465,
															71.492
														],
														[
															293,
															72
														],
														[
															284.893,
															84.615
														],
														[
															278,
															97
														],
														[
															259.172,
															139.414
														],
														[
															245,
															185
														],
														[
															235.153,
															229.828
														],
														[
															228,
															276
														],
														[
															223.508,
															365.779
														],
														[
															229,
															455
														],
														[
															232.08,
															478.62
														],
														[
															236,
															502
														],
														[
															241.703,
															526.824
														],
														[
															248,
															550
														],
														[
															250.592,
															558.555
														],
														[
															253,
															566
														],
														[
															255.617,
															575.271
														],
														[
															258,
															584
														],
														[
															258.968,
															584.949
														],
														[
															260,
															586
														],
														[
															261.5,
															591.019
														],
														[
															263,
															596
														],
														[
															266.15,
															603.546
														],
														[
															269,
															610
														],
														[
															272.467,
															617.271
														],
														[
															276,
															624
														],
														[
															287.056,
															643.375
														],
														[
															299,
															661
														],
														[
															299.975,
															661.506
														],
														[
															301,
															662
														],
														[
															301.505,
															663.477
														],
														[
															302,
															665
														],
														[
															305.422,
															668.542
														],
														[
															309,
															672
														],
														[
															317.91,
															680.215
														],
														[
															327,
															687
														],
														[
															329.004,
															688.526
														],
														[
															331,
															690
														],
														[
															348.717,
															697.419
														],
														[
															366,
															698
														],
														[
															366.395,
															695.921
														],
														[
															367,
															693
														],
														[
															368.474,
															689.417
														],
														[
															370,
															687
														],
														[
															376.473,
															684.297
														],
														[
															384,
															682
														],
														[
															391.772,
															677.55
														],
														[
															398,
															673
														],
														[
															400.073,
															671.452
														],
														[
															402,
															670
														],
														[
															424.857,
															646.059
														],
														[
															443,
															618
														],
														[
															484.609,
															496.754
														],
														[
															498,
															352
														],
														[
															485.759,
															216.966
														],
														[
															450,
															106
														],
														[
															446.4,
															99.176
														],
														[
															443,
															93
														],
														[
															441.342,
															90.667
														],
														[
															440,
															89
														],
														[
															437.986,
															84.393
														],
														[
															436,
															80
														],
														[
															434.533,
															78.506
														],
														[
															433,
															77
														],
														[
															428.973,
															70.807
														],
														[
															425,
															65
														],
														[
															421.593,
															61.515
														],
														[
															418,
															58
														],
														[
															416.919,
															55.931
														],
														[
															416,
															54
														],
														[
															414.135,
															52.537
														],
														[
															412,
															51
														],
														[
															388.998,
															33.388
														],
														[
															359,
															25
														],
														[
															358.226,
															25.515
														],
														[
															358,
															26
														],
														[
															344.808,
															28.581
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 85,
											"s": [
												{
													"i": [
														[
															4.997,
															-3.478
														],
														[
															8.273,
															-9.445
														],
														[
															6.827,
															-11.412
														],
														[
															5.516,
															-12.761
														],
														[
															4.339,
															-13.492
														],
														[
															1.908,
															-7.061
														],
														[
															1.647,
															-7.315
														],
														[
															1.416,
															-7.596
														],
														[
															1.213,
															-7.904
														],
														[
															-0.371,
															-35.972
														],
														[
															-5.775,
															-33.777
														],
														[
															-10.767,
															-28.916
														],
														[
															-15.345,
															-21.39
														],
														[
															-0.708,
															-0.835
														],
														[
															-0.724,
															-0.78
														],
														[
															-0.654,
															-0.68
														],
														[
															-0.498,
															-0.534
														],
														[
															-0.073,
															-0.255
														],
														[
															-0.039,
															-0.28
														],
														[
															-0.072,
															-0.26
														],
														[
															-0.171,
															-0.196
														],
														[
															-1.881,
															-1.863
														],
														[
															-1.965,
															-1.809
														],
														[
															-1.852,
															-1.666
														],
														[
															-1.54,
															-1.434
														],
														[
															-0.248,
															-0.075
														],
														[
															-0.27,
															-0.036
														],
														[
															-0.262,
															-0.069
														],
														[
															-0.225,
															-0.171
														],
														[
															-0.517,
															-0.461
														],
														[
															-0.501,
															-0.457
														],
														[
															-0.483,
															-0.393
														],
														[
															-0.464,
															-0.269
														],
														[
															-0.453,
															-0.272
														],
														[
															-0.394,
															-0.241
														],
														[
															-0.369,
															-0.223
														],
														[
															-0.377,
															-0.218
														],
														[
															-0.672,
															-0.356
														],
														[
															-0.633,
															-0.309
														],
														[
															-0.644,
															-0.298
														],
														[
															-0.705,
															-0.324
														],
														[
															-3.09,
															-0.994
														],
														[
															-3.382,
															-0.758
														],
														[
															-2.976,
															-0.261
														],
														[
															-1.872,
															0.5
														],
														[
															-0.426,
															0.968
														],
														[
															-0.291,
															1.258
														],
														[
															-0.219,
															1.036
														],
														[
															-0.212,
															0.302
														],
														[
															-1.116,
															0.492
														],
														[
															-1.399,
															0.367
														],
														[
															-1.333,
															0.317
														],
														[
															-0.918,
															0.341
														],
														[
															-2.472,
															1.18
														],
														[
															-2.26,
															1.297
														],
														[
															-2.033,
															1.344
														],
														[
															-1.789,
															1.32
														],
														[
															-4.457,
															4.368
														],
														[
															-4.036,
															4.985
														],
														[
															-3.686,
															5.499
														],
														[
															-3.407,
															5.91
														],
														[
															-5.329,
															12.719
														],
														[
															-4.218,
															13.922
														],
														[
															-3.155,
															14.867
														],
														[
															-2.141,
															15.554
														],
														[
															-0.773,
															8.286
														],
														[
															-0.47,
															8.47
														],
														[
															-0.212,
															8.699
														],
														[
															0,
															8.973
														],
														[
															1.718,
															17.478
														],
														[
															3.124,
															16.593
														],
														[
															4.219,
															15.068
														],
														[
															5.004,
															12.905
														],
														[
															1.715,
															3.989
														],
														[
															1.841,
															3.864
														],
														[
															1.956,
															3.693
														],
														[
															2.058,
															3.475
														],
														[
															0.414,
															0.666
														],
														[
															0.418,
															0.657
														],
														[
															0.42,
															0.663
														],
														[
															0.419,
															0.682
														],
														[
															0.527,
															0.643
														],
														[
															0.331,
															0.519
														],
														[
															0.266,
															0.895
														],
														[
															0.478,
															0.7
														],
														[
															0.561,
															0.487
														],
														[
															0.419,
															0.56
														],
														[
															0.481,
															0.642
														],
														[
															0.538,
															0.713
														],
														[
															6.211,
															6.279
														],
														[
															6.817,
															4.8
														],
														[
															1.48,
															0.76
														],
														[
															1.478,
															0.834
														],
														[
															1.317,
															0.664
														],
														[
															1.284,
															0.528
														],
														[
															5.434,
															1.254
														],
														[
															5.511,
															0.027
														],
														[
															0.35,
															-0.247
														],
														[
															0.124,
															-0.012
														],
														[
															6.796,
															-2.908
														]
													],
													"o": [
														[
															-9.852,
															6.859
														],
														[
															-8.273,
															9.445
														],
														[
															-6.827,
															11.412
														],
														[
															-5.516,
															12.761
														],
														[
															-2.198,
															6.835
														],
														[
															-1.908,
															7.061
														],
														[
															-1.647,
															7.315
														],
														[
															-1.416,
															7.596
														],
														[
															-5.447,
															35.503
														],
														[
															0.371,
															35.972
														],
														[
															5.775,
															33.777
														],
														[
															10.767,
															28.916
														],
														[
															0.606,
															0.844
														],
														[
															0.708,
															0.835
														],
														[
															0.724,
															0.78
														],
														[
															0.654,
															0.68
														],
														[
															0.172,
															0.185
														],
														[
															0.073,
															0.255
														],
														[
															0.039,
															0.28
														],
														[
															0.072,
															0.26
														],
														[
															1.599,
															1.828
														],
														[
															1.881,
															1.863
														],
														[
															1.965,
															1.809
														],
														[
															1.852,
															1.666
														],
														[
															0.197,
															0.183
														],
														[
															0.248,
															0.075
														],
														[
															0.27,
															0.036
														],
														[
															0.262,
															0.069
														],
														[
															0.533,
															0.405
														],
														[
															0.517,
															0.461
														],
														[
															0.501,
															0.457
														],
														[
															0.483,
															0.393
														],
														[
															0.546,
															0.317
														],
														[
															0.453,
															0.272
														],
														[
															0.394,
															0.241
														],
														[
															0.369,
															0.223
														],
														[
															0.762,
															0.441
														],
														[
															0.672,
															0.356
														],
														[
															0.633,
															0.309
														],
														[
															0.644,
															0.298
														],
														[
															2.1,
															0.966
														],
														[
															3.09,
															0.994
														],
														[
															3.382,
															0.758
														],
														[
															2.976,
															0.261
														],
														[
															0.625,
															-0.167
														],
														[
															0.426,
															-0.968
														],
														[
															0.291,
															-1.258
														],
														[
															0.219,
															-1.036
														],
														[
															0.485,
															-0.691
														],
														[
															1.116,
															-0.492
														],
														[
															1.399,
															-0.367
														],
														[
															1.333,
															-0.317
														],
														[
															2.668,
															-0.992
														],
														[
															2.472,
															-1.18
														],
														[
															2.26,
															-1.297
														],
														[
															2.033,
															-1.344
														],
														[
															4.947,
															-3.649
														],
														[
															4.457,
															-4.368
														],
														[
															4.036,
															-4.985
														],
														[
															3.686,
															-5.499
														],
														[
															6.489,
															-11.258
														],
														[
															5.329,
															-12.719
														],
														[
															4.218,
															-13.922
														],
														[
															3.155,
															-14.867
														],
														[
															1.121,
															-8.146
														],
														[
															0.773,
															-8.286
														],
														[
															0.47,
															-8.47
														],
														[
															0.212,
															-8.699
														],
														[
															0,
															-17.724
														],
														[
															-1.718,
															-17.478
														],
														[
															-3.124,
															-16.593
														],
														[
															-4.219,
															-15.068
														],
														[
															-1.577,
															-4.067
														],
														[
															-1.715,
															-3.989
														],
														[
															-1.841,
															-3.864
														],
														[
															-1.956,
															-3.693
														],
														[
															-0.408,
															-0.689
														],
														[
															-0.414,
															-0.666
														],
														[
															-0.418,
															-0.657
														],
														[
															-0.42,
															-0.663
														],
														[
															-0.56,
															-0.91
														],
														[
															-0.527,
															-0.642
														],
														[
															-0.458,
															-0.719
														],
														[
															-0.266,
															-0.895
														],
														[
															-0.337,
															-0.493
														],
														[
															-0.561,
															-0.487
														],
														[
															-0.538,
															-0.719
														],
														[
															-0.481,
															-0.642
														],
														[
															-5.339,
															-7.082
														],
														[
															-6.211,
															-6.279
														],
														[
															-1.6,
															-1.127
														],
														[
															-1.48,
															-0.76
														],
														[
															-1.448,
															-0.817
														],
														[
															-1.317,
															-0.664
														],
														[
															-4.753,
															-1.955
														],
														[
															-5.434,
															-1.254
														],
														[
															-0.477,
															-0.002
														],
														[
															-0.35,
															0.247
														],
														[
															-8.818,
															0.887
														],
														[
															-6.796,
															2.909
														]
													],
													"v": [
														[
															315,
															42
														],
														[
															287.846,
															66.61
														],
														[
															265.229,
															98.05
														],
														[
															246.748,
															134.465
														],
														[
															232,
															174
														],
														[
															225.848,
															194.838
														],
														[
															220.523,
															216.396
														],
														[
															215.935,
															238.756
														],
														[
															212,
															262
														],
														[
															204.489,
															369.879
														],
														[
															213.811,
															475.169
														],
														[
															238.728,
															569.874
														],
														[
															278,
															646
														],
														[
															279.992,
															648.53
														],
														[
															282.162,
															650.964
														],
														[
															284.251,
															653.167
														],
														[
															286,
															655
														],
														[
															286.35,
															655.671
														],
														[
															286.502,
															656.484
														],
														[
															286.652,
															657.305
														],
														[
															287,
															658
														],
														[
															292.27,
															663.56
														],
														[
															298.088,
															669.091
														],
														[
															303.862,
															674.327
														],
														[
															309,
															679
														],
														[
															309.675,
															679.369
														],
														[
															310.458,
															679.518
														],
														[
															311.263,
															679.658
														],
														[
															312,
															680
														],
														[
															313.575,
															681.314
														],
														[
															315.103,
															682.705
														],
														[
															316.579,
															683.993
														],
														[
															318,
															685
														],
														[
															319.491,
															685.88
														],
														[
															320.754,
															686.647
														],
														[
															321.89,
															687.341
														],
														[
															323,
															688
														],
														[
															325.139,
															689.187
														],
														[
															327.085,
															690.175
														],
														[
															328.988,
															691.075
														],
														[
															331,
															692
														],
														[
															338.96,
															695.005
														],
														[
															348.842,
															697.699
														],
														[
															358.553,
															699.293
														],
														[
															366,
															699
														],
														[
															367.56,
															697.17
														],
														[
															368.62,
															693.702
														],
														[
															369.37,
															690.134
														],
														[
															370,
															688
														],
														[
															372.488,
															686.244
														],
														[
															376.349,
															684.975
														],
														[
															380.535,
															683.969
														],
														[
															384,
															683
														],
														[
															391.715,
															679.725
														],
														[
															398.818,
															675.992
														],
														[
															405.262,
															672.013
														],
														[
															411,
															668
														],
														[
															425.089,
															655.948
														],
														[
															437.811,
															641.892
														],
														[
															449.378,
															626.14
														],
														[
															460,
															609
														],
														[
															477.715,
															572.97
														],
														[
															492.023,
															532.944
														],
														[
															503.069,
															489.696
														],
														[
															511,
															444
														],
														[
															513.83,
															419.364
														],
														[
															515.682,
															394.241
														],
														[
															516.693,
															368.497
														],
														[
															517,
															342
														],
														[
															514.346,
															289.037
														],
														[
															507.006,
															237.771
														],
														[
															495.913,
															190.119
														],
														[
															482,
															148
														],
														[
															477.059,
															135.903
														],
														[
															471.722,
															124.111
														],
														[
															466.024,
															112.763
														],
														[
															460,
															102
														],
														[
															458.766,
															99.971
														],
														[
															457.517,
															97.99
														],
														[
															456.26,
															96.013
														],
														[
															455,
															94
														],
														[
															453.328,
															91.707
														],
														[
															452,
															90
														],
														[
															451.015,
															87.486
														],
														[
															450,
															85
														],
														[
															448.562,
															83.551
														],
														[
															447,
															82
														],
														[
															445.5,
															79.996
														],
														[
															444,
															78
														],
														[
															426.609,
															57.788
														],
														[
															407,
															41
														],
														[
															402.409,
															38.281
														],
														[
															398,
															36
														],
														[
															393.877,
															33.783
														],
														[
															390,
															32
														],
														[
															374.569,
															27.054
														],
														[
															358,
															25
														],
														[
															356.735,
															25.489
														],
														[
															356,
															26
														],
														[
															332.634,
															32.057
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 86,
											"s": [
												{
													"i": [
														[
															3.962,
															-1.397
														],
														[
															3.395,
															-1.636
														],
														[
															3.298,
															-1.977
														],
														[
															3.129,
															-2.227
														],
														[
															2.889,
															-2.388
														],
														[
															0.249,
															-0.347
														],
														[
															0.224,
															-0.374
														],
														[
															0.238,
															-0.34
														],
														[
															0.292,
															-0.244
														],
														[
															0.261,
															-0.081
														],
														[
															0.284,
															-0.052
														],
														[
															0.256,
															-0.07
														],
														[
															0.177,
															-0.135
														],
														[
															1.196,
															-1.186
														],
														[
															1.149,
															-1.299
														],
														[
															1.004,
															-1.213
														],
														[
															0.761,
															-0.929
														],
														[
															0.341,
															-0.335
														],
														[
															0.343,
															-0.31
														],
														[
															0.331,
															-0.319
														],
														[
															0.304,
															-0.364
														],
														[
															4.731,
															-7.116
														],
														[
															4.161,
															-7.648
														],
														[
															3.6,
															-7.958
														],
														[
															3.048,
															-8.046
														],
														[
															2.588,
															-8.382
														],
														[
															2.174,
															-8.797
														],
														[
															1.749,
															-9.142
														],
														[
															1.312,
															-9.416
														],
														[
															0.609,
															-4.075
														],
														[
															0.56,
															-4.082
														],
														[
															0.421,
															-4.091
														],
														[
															0.191,
															-4.102
														],
														[
															-1.305,
															-24.294
														],
														[
															-3.73,
															-22.24
														],
														[
															-6.06,
															-19.951
														],
														[
															-8.296,
															-17.427
														],
														[
															-3.586,
															-6.459
														],
														[
															-4.104,
															-6.21
														],
														[
															-4.716,
															-5.896
														],
														[
															-5.421,
															-5.516
														],
														[
															-2.533,
															-2.349
														],
														[
															-2.839,
															-2.274
														],
														[
															-3.261,
															-2.163
														],
														[
															-3.8,
															-2.015
														],
														[
															-4.238,
															-1.653
														],
														[
															-4.916,
															-1.379
														],
														[
															-4.595,
															-0.537
														],
														[
															-3.274,
															0.874
														],
														[
															-0.102,
															0.128
														],
														[
															0.012,
															0.164
														],
														[
															-0.017,
															0.204
														],
														[
															-0.189,
															0.248
														],
														[
															-0.443,
															0.951
														],
														[
															-0.433,
															1.035
														],
														[
															-0.398,
															0.817
														],
														[
															-0.34,
															0.295
														],
														[
															-0.603,
															0.195
														],
														[
															-0.717,
															0.112
														],
														[
															-0.755,
															0.111
														],
														[
															-0.718,
															0.192
														],
														[
															-1.749,
															0.605
														],
														[
															-1.615,
															0.625
														],
														[
															-1.558,
															0.582
														],
														[
															-1.579,
															0.477
														],
														[
															-0.167,
															0.174
														],
														[
															-0.199,
															0.229
														],
														[
															-0.182,
															0.19
														],
														[
															-0.116,
															0.059
														],
														[
															-1.167,
															0.6
														],
														[
															-1.15,
															0.612
														],
														[
															-1.033,
															0.581
														],
														[
															-0.816,
															0.507
														],
														[
															-0.166,
															0.171
														],
														[
															-0.173,
															0.2
														],
														[
															-0.171,
															0.179
														],
														[
															-0.159,
															0.11
														],
														[
															-2.874,
															2.271
														],
														[
															-2.705,
															2.46
														],
														[
															-2.604,
															2.709
														],
														[
															-2.57,
															3.018
														],
														[
															-11.737,
															25.188
														],
														[
															-7.102,
															30.108
														],
														[
															-1.939,
															33.366
														],
														[
															3.752,
															34.961
														],
														[
															1.97,
															11.143
														],
														[
															2.579,
															10.585
														],
														[
															3.07,
															9.899
														],
														[
															3.442,
															9.085
														],
														[
															4.57,
															9.585
														],
														[
															5.499,
															8.941
														],
														[
															6.555,
															8.011
														],
														[
															7.736,
															6.793
														],
														[
															2.237,
															1.804
														],
														[
															2.311,
															1.671
														],
														[
															2.418,
															1.532
														],
														[
															2.558,
															1.386
														],
														[
															9.001,
															2.154
														],
														[
															8.201,
															-0.836
														],
														[
															3.981,
															-0.796
														]
													],
													"o": [
														[
															-3.419,
															1.206
														],
														[
															-3.395,
															1.636
														],
														[
															-3.298,
															1.977
														],
														[
															-3.129,
															2.227
														],
														[
															-0.312,
															0.258
														],
														[
															-0.249,
															0.347
														],
														[
															-0.224,
															0.374
														],
														[
															-0.238,
															0.34
														],
														[
															-0.187,
															0.157
														],
														[
															-0.261,
															0.081
														],
														[
															-0.284,
															0.052
														],
														[
															-0.256,
															0.07
														],
														[
															-1.144,
															0.875
														],
														[
															-1.196,
															1.186
														],
														[
															-1.149,
															1.299
														],
														[
															-1.004,
															1.213
														],
														[
															-0.325,
															0.397
														],
														[
															-0.341,
															0.335
														],
														[
															-0.343,
															0.31
														],
														[
															-0.331,
															0.319
														],
														[
															-5.31,
															6.362
														],
														[
															-4.731,
															7.116
														],
														[
															-4.161,
															7.648
														],
														[
															-3.6,
															7.958
														],
														[
															-2.991,
															7.897
														],
														[
															-2.588,
															8.382
														],
														[
															-2.174,
															8.797
														],
														[
															-1.749,
															9.141
														],
														[
															-0.567,
															4.07
														],
														[
															-0.609,
															4.075
														],
														[
															-0.56,
															4.082
														],
														[
															-0.421,
															4.091
														],
														[
															-1.215,
															26.113
														],
														[
															1.305,
															24.294
														],
														[
															3.73,
															22.24
														],
														[
															6.06,
															19.951
														],
														[
															3.162,
															6.643
														],
														[
															3.586,
															6.459
														],
														[
															4.104,
															6.21
														],
														[
															4.716,
															5.896
														],
														[
															2.345,
															2.387
														],
														[
															2.533,
															2.349
														],
														[
															2.839,
															2.274
														],
														[
															3.261,
															2.163
														],
														[
															2.561,
															1.358
														],
														[
															4.238,
															1.653
														],
														[
															4.916,
															1.379
														],
														[
															4.595,
															0.537
														],
														[
															0.358,
															-0.096
														],
														[
															0.102,
															-0.128
														],
														[
															-0.012,
															-0.164
														],
														[
															0.017,
															-0.204
														],
														[
															0.43,
															-0.564
														],
														[
															0.443,
															-0.951
														],
														[
															0.432,
															-1.035
														],
														[
															0.398,
															-0.817
														],
														[
															0.415,
															-0.36
														],
														[
															0.603,
															-0.195
														],
														[
															0.717,
															-0.112
														],
														[
															0.755,
															-0.111
														],
														[
															1.962,
															-0.524
														],
														[
															1.749,
															-0.605
														],
														[
															1.615,
															-0.625
														],
														[
															1.558,
															-0.582
														],
														[
															0.087,
															-0.026
														],
														[
															0.167,
															-0.174
														],
														[
															0.199,
															-0.229
														],
														[
															0.182,
															-0.19
														],
														[
															1.084,
															-0.545
														],
														[
															1.167,
															-0.6
														],
														[
															1.15,
															-0.612
														],
														[
															1.033,
															-0.581
														],
														[
															0.149,
															-0.092
														],
														[
															0.166,
															-0.171
														],
														[
															0.173,
															-0.2
														],
														[
															0.171,
															-0.179
														],
														[
															3.11,
															-2.141
														],
														[
															2.874,
															-2.271
														],
														[
															2.705,
															-2.46
														],
														[
															2.604,
															-2.709
														],
														[
															15.842,
															-18.605
														],
														[
															11.737,
															-25.188
														],
														[
															7.102,
															-30.108
														],
														[
															1.94,
															-33.366
														],
														[
															-1.242,
															-11.573
														],
														[
															-1.97,
															-11.143
														],
														[
															-2.579,
															-10.585
														],
														[
															-3.07,
															-9.899
														],
														[
															-3.766,
															-9.941
														],
														[
															-4.57,
															-9.585
														],
														[
															-5.499,
															-8.941
														],
														[
															-6.555,
															-8.011
														],
														[
															-2.197,
															-1.93
														],
														[
															-2.237,
															-1.804
														],
														[
															-2.311,
															-1.671
														],
														[
															-2.418,
															-1.532
														],
														[
															-7.797,
															-4.221
														],
														[
															-9.001,
															-2.154
														],
														[
															-4.115,
															0.419
														],
														[
															-3.981,
															0.796
														]
													],
													"v": [
														[
															331,
															31
														],
														[
															320.761,
															35.285
														],
														[
															310.704,
															40.727
														],
														[
															301.045,
															47.055
														],
														[
															292,
															54
														],
														[
															291.168,
															54.923
														],
														[
															290.469,
															56.021
														],
														[
															289.785,
															57.108
														],
														[
															289,
															58
														],
														[
															288.315,
															58.344
														],
														[
															287.484,
															58.532
														],
														[
															286.661,
															58.704
														],
														[
															286,
															59
														],
														[
															282.465,
															62.142
														],
														[
															278.925,
															65.919
														],
														[
															275.672,
															69.736
														],
														[
															273,
															73
														],
														[
															271.998,
															74.089
														],
														[
															270.969,
															75.048
														],
														[
															269.956,
															75.983
														],
														[
															269,
															77
														],
														[
															253.941,
															97.272
														],
														[
															240.607,
															119.474
														],
														[
															228.969,
															142.939
														],
														[
															219,
															167
														],
														[
															210.628,
															191.435
														],
														[
															203.481,
															217.222
														],
														[
															197.594,
															244.147
														],
														[
															193,
															272
														],
														[
															191.213,
															284.217
														],
														[
															189.435,
															296.452
														],
														[
															187.94,
															308.711
														],
														[
															187,
															321
														],
														[
															187.158,
															396.669
														],
														[
															194.733,
															466.529
														],
														[
															209.441,
															529.874
														],
														[
															231,
															586
														],
														[
															241.1,
															605.669
														],
														[
															252.612,
															624.69
														],
														[
															265.819,
															642.866
														],
														[
															281,
															660
														],
														[
															288.289,
															667.112
														],
														[
															296.318,
															674.057
														],
														[
															305.438,
															680.722
														],
														[
															316,
															687
														],
														[
															326.449,
															691.659
														],
														[
															340.43,
															696.348
														],
														[
															354.947,
															699.364
														],
														[
															367,
															699
														],
														[
															367.655,
															698.665
														],
														[
															367.754,
															698.228
														],
														[
															367.726,
															697.677
														],
														[
															368,
															697
														],
														[
															369.316,
															694.652
														],
														[
															370.635,
															691.596
														],
														[
															371.887,
															688.743
														],
														[
															373,
															687
														],
														[
															374.547,
															686.188
														],
														[
															376.546,
															685.748
														],
														[
															378.772,
															685.434
														],
														[
															381,
															685
														],
														[
															386.547,
															683.29
														],
														[
															391.573,
															681.43
														],
														[
															396.313,
															679.605
														],
														[
															401,
															678
														],
														[
															401.394,
															677.676
														],
														[
															401.956,
															677.048
														],
														[
															402.54,
															676.396
														],
														[
															403,
															676
														],
														[
															406.401,
															674.271
														],
														[
															409.902,
															672.443
														],
														[
															413.201,
															670.643
														],
														[
															416,
															669
														],
														[
															416.474,
															668.593
														],
														[
															416.984,
															668.026
														],
														[
															417.502,
															667.445
														],
														[
															418,
															667
														],
														[
															426.959,
															660.397
														],
														[
															435.31,
															653.316
														],
														[
															443.256,
															645.577
														],
														[
															451,
															637
														],
														[
															492.501,
															570.894
														],
														[
															520.892,
															487.534
														],
														[
															534.587,
															391.907
														],
														[
															532,
															289
														],
														[
															527.152,
															254.893
														],
														[
															520.299,
															222.268
														],
														[
															511.796,
															191.508
														],
														[
															502,
															163
														],
														[
															489.528,
															133.639
														],
														[
															474.455,
															105.778
														],
														[
															456.405,
															80.278
														],
														[
															435,
															58
														],
														[
															428.356,
															52.398
														],
														[
															421.542,
															47.184
														],
														[
															414.457,
															42.378
														],
														[
															407,
															38
														],
														[
															381.303,
															28.207
														],
														[
															355,
															26
														],
														[
															342.885,
															27.767
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 87,
											"s": [
												{
													"i": [
														[
															0.33,
															-0.011
														],
														[
															4.804,
															-1.159
														],
														[
															4.534,
															-1.761
														],
														[
															3.964,
															-1.971
														],
														[
															3.091,
															-1.79
														],
														[
															0.247,
															-0.069
														],
														[
															0.255,
															-0.051
														],
														[
															0.255,
															-0.082
														],
														[
															0.248,
															-0.16
														],
														[
															0.323,
															-0.339
														],
														[
															0.322,
															-0.383
														],
														[
															0.338,
															-0.353
														],
														[
															0.37,
															-0.248
														],
														[
															0.263,
															-0.084
														],
														[
															0.27,
															-0.057
														],
														[
															0.247,
															-0.069
														],
														[
															0.193,
															-0.12
														],
														[
															0.166,
															-0.17
														],
														[
															0.174,
															-0.199
														],
														[
															0.171,
															-0.18
														],
														[
															0.157,
															-0.111
														],
														[
															2.083,
															-1.587
														],
														[
															2.003,
															-1.645
														],
														[
															1.793,
															-1.61
														],
														[
															1.455,
															-1.482
														],
														[
															1.285,
															-1.486
														],
														[
															1.228,
															-1.529
														],
														[
															1.204,
															-1.528
														],
														[
															1.212,
															-1.484
														],
														[
															0.343,
															-0.326
														],
														[
															0.347,
															-0.305
														],
														[
															0.33,
															-0.326
														],
														[
															0.292,
															-0.389
														],
														[
															0.459,
															-0.856
														],
														[
															0.601,
															-0.826
														],
														[
															0.718,
															-0.597
														],
														[
															0.568,
															-0.844
														],
														[
															0.477,
															-1.093
														],
														[
															0.561,
															-0.841
														],
														[
															2.204,
															-3.288
														],
														[
															1.916,
															-3.453
														],
														[
															9.531,
															-40.523
														],
														[
															-0.508,
															-48.588
														],
														[
															-8.57,
															-36.313
														],
														[
															-14.284,
															-28.2
														],
														[
															-11.636,
															-15.012
														],
														[
															-14.357,
															-10.967
														],
														[
															-0.521,
															-0.083
														],
														[
															-0.481,
															-0.337
														],
														[
															-0.289,
															-0.604
														],
														[
															-0.429,
															-0.294
														],
														[
															-0.546,
															-0.116
														],
														[
															-0.38,
															-0.236
														],
														[
															-0.855,
															-0.504
														],
														[
															-0.683,
															-0.425
														],
														[
															-0.339,
															-0.404
														],
														[
															-0.341,
															-0.197
														],
														[
															-5.716,
															-2.235
														],
														[
															-7.567,
															-1.835
														],
														[
															-6.293,
															-0.616
														],
														[
															-2.095,
															2.856
														],
														[
															-0.282,
															0.673
														],
														[
															-0.498,
															0.797
														],
														[
															-0.345,
															1
														],
														[
															-0.805,
															0.698
														],
														[
															-1.637,
															0.195
														],
														[
															-1.51,
															0.403
														],
														[
															-6.444,
															2.873
														],
														[
															-5.677,
															3.495
														],
														[
															-15.184,
															19.419
														],
														[
															-9.434,
															22.116
														],
														[
															-0.828,
															1.766
														],
														[
															-0.712,
															1.649
														],
														[
															-2.213,
															6.926
														],
														[
															-2.12,
															7.275
														],
														[
															-0.715,
															1.972
														],
														[
															-0.536,
															2.042
														],
														[
															-2.847,
															24.014
														],
														[
															0.15,
															27.981
														],
														[
															3.758,
															23.757
														],
														[
															5.83,
															19.524
														],
														[
															2.216,
															6.015
														],
														[
															2.237,
															5.582
														],
														[
															2.45,
															5.526
														],
														[
															2.096,
															4.649
														],
														[
															0.451,
															0.152
														],
														[
															0.115,
															0.214
														],
														[
															1.75,
															3.528
														],
														[
															2.106,
															3.362
														],
														[
															2.185,
															3.182
														],
														[
															2.269,
															3.094
														],
														[
															2.575,
															2.796
														],
														[
															2.534,
															2.862
														],
														[
															2.596,
															2.86
														],
														[
															2.967,
															2.567
														],
														[
															15.91,
															7.248
														],
														[
															18.652,
															-1.257
														],
														[
															0.175,
															-0.245
														],
														[
															-0.031,
															0.003
														],
														[
															0.335,
															0.011
														]
													],
													"o": [
														[
															-4.772,
															0.166
														],
														[
															-4.804,
															1.159
														],
														[
															-4.534,
															1.761
														],
														[
															-3.964,
															1.971
														],
														[
															-0.233,
															0.135
														],
														[
															-0.247,
															0.069
														],
														[
															-0.255,
															0.051
														],
														[
															-0.255,
															0.082
														],
														[
															-0.342,
															0.221
														],
														[
															-0.323,
															0.339
														],
														[
															-0.322,
															0.383
														],
														[
															-0.338,
															0.353
														],
														[
															-0.225,
															0.15
														],
														[
															-0.263,
															0.084
														],
														[
															-0.271,
															0.057
														],
														[
															-0.247,
															0.069
														],
														[
															-0.148,
															0.092
														],
														[
															-0.166,
															0.17
														],
														[
															-0.174,
															0.199
														],
														[
															-0.171,
															0.18
														],
														[
															-2.034,
															1.437
														],
														[
															-2.083,
															1.587
														],
														[
															-2.003,
															1.645
														],
														[
															-1.793,
															1.61
														],
														[
															-1.374,
															1.4
														],
														[
															-1.285,
															1.486
														],
														[
															-1.228,
															1.529
														],
														[
															-1.204,
															1.528
														],
														[
															-0.319,
															0.39
														],
														[
															-0.343,
															0.326
														],
														[
															-0.347,
															0.305
														],
														[
															-0.33,
															0.326
														],
														[
															-0.564,
															0.751
														],
														[
															-0.459,
															0.856
														],
														[
															-0.559,
															0.769
														],
														[
															-0.718,
															0.597
														],
														[
															-0.531,
															0.787
														],
														[
															-0.477,
															1.093
														],
														[
															-2.266,
															3.398
														],
														[
															-2.204,
															3.287
														],
														[
															-17.386,
															31.32
														],
														[
															-9.531,
															40.523
														],
														[
															0.435,
															41.548
														],
														[
															8.57,
															36.313
														],
														[
															8.097,
															15.986
														],
														[
															11.636,
															15.012
														],
														[
															0.435,
															0.332
														],
														[
															0.521,
															0.083
														],
														[
															0.415,
															0.29
														],
														[
															0.289,
															0.604
														],
														[
															0.436,
															0.299
														],
														[
															0.546,
															0.116
														],
														[
															0.899,
															0.558
														],
														[
															0.855,
															0.504
														],
														[
															0.302,
															0.188
														],
														[
															0.339,
															0.404
														],
														[
															5.568,
															3.224
														],
														[
															5.716,
															2.235
														],
														[
															5.735,
															1.391
														],
														[
															6.292,
															0.616
														],
														[
															0.374,
															-0.509
														],
														[
															0.282,
															-0.673
														],
														[
															0.815,
															-1.304
														],
														[
															0.345,
															-1
														],
														[
															0.94,
															-0.815
														],
														[
															1.637,
															-0.196
														],
														[
															7.548,
															-2.015
														],
														[
															6.444,
															-2.872
														],
														[
															19.829,
															-12.206
														],
														[
															15.184,
															-19.419
														],
														[
															0.975,
															-2.284
														],
														[
															0.828,
															-1.767
														],
														[
															3.03,
															-7.021
														],
														[
															2.213,
															-6.926
														],
														[
															0.603,
															-2.072
														],
														[
															0.715,
															-1.972
														],
														[
															5.764,
															-21.962
														],
														[
															2.847,
															-24.014
														],
														[
															-0.137,
															-25.447
														],
														[
															-3.758,
															-23.757
														],
														[
															-1.899,
															-6.358
														],
														[
															-2.216,
															-6.015
														],
														[
															-2.103,
															-5.249
														],
														[
															-2.45,
															-5.526
														],
														[
															-0.081,
															-0.179
														],
														[
															-0.451,
															-0.152
														],
														[
															-1.896,
															-3.527
														],
														[
															-1.75,
															-3.528
														],
														[
															-1.988,
															-3.177
														],
														[
															-2.185,
															-3.182
														],
														[
															-2.167,
															-2.954
														],
														[
															-2.575,
															-2.796
														],
														[
															-2.649,
															-2.992
														],
														[
															-2.596,
															-2.86
														],
														[
															-10.707,
															-9.265
														],
														[
															-15.91,
															-7.248
														],
														[
															-0.329,
															0.022
														],
														[
															-0.175,
															0.245
														],
														[
															-0.328,
															0.032
														],
														[
															-0.335,
															-0.011
														]
													],
													"v": [
														[
															352,
															26
														],
														[
															337.562,
															28.085
														],
														[
															323.48,
															32.564
														],
														[
															310.658,
															38.26
														],
														[
															300,
															44
														],
														[
															299.278,
															44.293
														],
														[
															298.523,
															44.462
														],
														[
															297.757,
															44.649
														],
														[
															297,
															45
														],
														[
															296.007,
															45.858
														],
														[
															295.043,
															46.959
														],
														[
															294.058,
															48.081
														],
														[
															293,
															49
														],
														[
															292.261,
															49.342
														],
														[
															291.454,
															49.545
														],
														[
															290.669,
															49.725
														],
														[
															290,
															50
														],
														[
															289.526,
															50.405
														],
														[
															289.014,
															50.971
														],
														[
															288.494,
															51.552
														],
														[
															288,
															52
														],
														[
															281.793,
															56.559
														],
														[
															275.632,
															61.431
														],
														[
															269.905,
															66.338
														],
														[
															265,
															71
														],
														[
															261.019,
															75.34
														],
														[
															257.257,
															79.873
														],
														[
															253.617,
															84.47
														],
														[
															250,
															89
														],
														[
															249.002,
															90.064
														],
														[
															247.961,
															91.001
														],
														[
															246.939,
															91.938
														],
														[
															246,
															93
														],
														[
															244.528,
															95.443
														],
														[
															243,
															98
														],
														[
															241.007,
															99.944
														],
														[
															239,
															102
														],
														[
															237.523,
															104.959
														],
														[
															236,
															108
														],
														[
															229.238,
															117.959
														],
														[
															223,
															128
														],
														[
															182.079,
															236.049
														],
														[
															168,
															370
														],
														[
															182.113,
															487.511
														],
														[
															217,
															585
														],
														[
															246.805,
															632.264
														],
														[
															286,
															672
														],
														[
															287.466,
															672.497
														],
														[
															289,
															673
														],
														[
															289.99,
															674.497
														],
														[
															291,
															676
														],
														[
															292.542,
															676.548
														],
														[
															294,
															677
														],
														[
															296.662,
															678.601
														],
														[
															299,
															680
														],
														[
															299.971,
															680.993
														],
														[
															301,
															682
														],
														[
															317.501,
															690.041
														],
														[
															337,
															696
														],
														[
															356.23,
															699.686
														],
														[
															370,
															697
														],
														[
															370.907,
															695.216
														],
														[
															372,
															693
														],
														[
															373.507,
															689.546
														],
														[
															375,
															687
														],
														[
															379.073,
															685.691
														],
														[
															384,
															685
														],
														[
															404.903,
															677.609
														],
														[
															423,
															668
														],
														[
															475.796,
															619.433
														],
														[
															513,
															556
														],
														[
															515.697,
															550.024
														],
														[
															518,
															545
														],
														[
															525.683,
															524.19
														],
														[
															532,
															503
														],
														[
															534.051,
															496.978
														],
														[
															536,
															491
														],
														[
															548.936,
															422.514
														],
														[
															553,
															345
														],
														[
															546.77,
															270.557
														],
														[
															532,
															205
														],
														[
															525.754,
															186.418
														],
														[
															519,
															169
														],
														[
															511.994,
															152.55
														],
														[
															505,
															137
														],
														[
															504.026,
															136.527
														],
														[
															503,
															136
														],
														[
															497.657,
															125.377
														],
														[
															492,
															115
														],
														[
															485.711,
															105.438
														],
														[
															479,
															96
														],
														[
															471.775,
															87.431
														],
														[
															464,
															79
														],
														[
															456.238,
															70.182
														],
														[
															448,
															62
														],
														[
															407.459,
															35.608
														],
														[
															355,
															25
														],
														[
															354.229,
															25.519
														],
														[
															354,
															26
														],
														[
															353.001,
															26.015
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 88,
											"s": [
												{
													"i": [
														[
															8.337,
															-4.306
														],
														[
															8.217,
															-6.165
														],
														[
															7.018,
															-7.14
														],
														[
															6.042,
															-7.905
														],
														[
															5.289,
															-8.46
														],
														[
															1.014,
															-1.784
														],
														[
															0.972,
															-1.826
														],
														[
															0.973,
															-1.879
														],
														[
															1.014,
															-1.944
														],
														[
															4.93,
															-12.151
														],
														[
															3.907,
															-13.144
														],
														[
															2.774,
															-14.171
														],
														[
															1.529,
															-15.232
														],
														[
															0.392,
															-5.451
														],
														[
															0.247,
															-5.452
														],
														[
															0.107,
															-5.4
														],
														[
															-0.029,
															-5.296
														],
														[
															-2.739,
															-20.055
														],
														[
															-4.895,
															-18.298
														],
														[
															-6.583,
															-16.219
														],
														[
															-7.805,
															-13.817
														],
														[
															-6.809,
															-9.418
														],
														[
															-8.105,
															-8.554
														],
														[
															-9.369,
															-7.109
														],
														[
															-10.599,
															-5.083
														],
														[
															-0.56,
															-0.155
														],
														[
															-0.593,
															-0.125
														],
														[
															-0.611,
															-0.158
														],
														[
															-0.615,
															-0.252
														],
														[
															-0.399,
															-0.259
														],
														[
															-0.413,
															-0.293
														],
														[
															-0.433,
															-0.263
														],
														[
															-0.458,
															-0.167
														],
														[
															-0.579,
															-0.169
														],
														[
															-0.595,
															-0.156
														],
														[
															-0.594,
															-0.159
														],
														[
															-0.575,
															-0.179
														],
														[
															-1.081,
															-0.362
														],
														[
															-1.084,
															-0.355
														],
														[
															-1.086,
															-0.316
														],
														[
															-1.087,
															-0.244
														],
														[
															-3.373,
															-0.511
														],
														[
															-3.696,
															-0.279
														],
														[
															-2.975,
															0.247
														],
														[
															-1.211,
															1.065
														],
														[
															-0.38,
															0.93
														],
														[
															-0.386,
															1.14
														],
														[
															-0.313,
															0.89
														],
														[
															-0.162,
															0.179
														],
														[
															-0.97,
															0.335
														],
														[
															-1.142,
															0.159
														],
														[
															-1.101,
															0.12
														],
														[
															-0.847,
															0.216
														],
														[
															-9.088,
															4.213
														],
														[
															-8.032,
															5.439
														],
														[
															-6.928,
															6.257
														],
														[
															-5.776,
															6.667
														],
														[
															-3.189,
															4.288
														],
														[
															-3,
															4.471
														],
														[
															-2.811,
															4.448
														],
														[
															-2.622,
															4.218
														],
														[
															-0.095,
															0.486
														],
														[
															-0.314,
															0.561
														],
														[
															-6.317,
															17.301
														],
														[
															-4.354,
															19.817
														],
														[
															-2.21,
															20.403
														],
														[
															0.832,
															22.216
														],
														[
															5.871,
															28.246
														],
														[
															9.377,
															22.65
														],
														[
															1.652,
															3.871
														],
														[
															1.795,
															3.652
														],
														[
															3.039,
															4.971
														],
														[
															2.396,
															4.138
														],
														[
															0.103,
															0.509
														],
														[
															0.32,
															0.499
														],
														[
															0.759,
															0.634
														],
														[
															0.499,
															0.741
														],
														[
															0.454,
															1.069
														],
														[
															0.584,
															0.831
														],
														[
															0.739,
															0.636
														],
														[
															0.506,
															0.695
														],
														[
															0.093,
															0.539
														],
														[
															0.302,
															0.395
														],
														[
															0.361,
															0.318
														],
														[
															0.297,
															0.39
														],
														[
															2.495,
															3.015
														],
														[
															2.552,
															2.699
														],
														[
															2.86,
															2.878
														],
														[
															2.749,
															2.516
														],
														[
															0.828,
															0.388
														],
														[
															0.899,
															0.724
														],
														[
															1.458,
															1.394
														],
														[
															1.486,
															1.072
														],
														[
															3.155,
															1.844
														],
														[
															2.596,
															1.614
														],
														[
															13.55,
															3.883
														],
														[
															13.879,
															-1.08
														],
														[
															0.179,
															-0.245
														],
														[
															-0.038,
															0.004
														],
														[
															8.944,
															-2.681
														]
													],
													"o": [
														[
															-9.64,
															4.979
														],
														[
															-8.217,
															6.165
														],
														[
															-7.018,
															7.14
														],
														[
															-6.042,
															7.905
														],
														[
															-1.096,
															1.754
														],
														[
															-1.014,
															1.784
														],
														[
															-0.972,
															1.826
														],
														[
															-0.973,
															1.879
														],
														[
															-5.841,
															11.193
														],
														[
															-4.93,
															12.151
														],
														[
															-3.907,
															13.144
														],
														[
															-2.774,
															14.171
														],
														[
															-0.542,
															5.396
														],
														[
															-0.392,
															5.451
														],
														[
															-0.247,
															5.452
														],
														[
															-0.107,
															5.4
														],
														[
															0.115,
															21.489
														],
														[
															2.739,
															20.055
														],
														[
															4.895,
															18.298
														],
														[
															6.583,
															16.219
														],
														[
															5.479,
															9.701
														],
														[
															6.809,
															9.418
														],
														[
															8.105,
															8.554
														],
														[
															9.369,
															7.109
														],
														[
															0.512,
															0.246
														],
														[
															0.56,
															0.155
														],
														[
															0.593,
															0.125
														],
														[
															0.611,
															0.158
														],
														[
															0.39,
															0.16
														],
														[
															0.399,
															0.259
														],
														[
															0.413,
															0.293
														],
														[
															0.433,
															0.263
														],
														[
															0.545,
															0.199
														],
														[
															0.579,
															0.169
														],
														[
															0.595,
															0.156
														],
														[
															0.594,
															0.159
														],
														[
															1.076,
															0.335
														],
														[
															1.081,
															0.362
														],
														[
															1.084,
															0.355
														],
														[
															1.086,
															0.316
														],
														[
															2.007,
															0.45
														],
														[
															3.373,
															0.511
														],
														[
															3.696,
															0.279
														],
														[
															2.975,
															-0.247
														],
														[
															0.296,
															-0.26
														],
														[
															0.38,
															-0.93
														],
														[
															0.386,
															-1.14
														],
														[
															0.313,
															-0.89
														],
														[
															0.584,
															-0.646
														],
														[
															0.97,
															-0.335
														],
														[
															1.142,
															-0.159
														],
														[
															1.101,
															-0.12
														],
														[
															10.096,
															-2.578
														],
														[
															9.088,
															-4.213
														],
														[
															8.032,
															-5.439
														],
														[
															6.928,
															-6.257
														],
														[
															3.376,
															-3.897
														],
														[
															3.189,
															-4.288
														],
														[
															3,
															-4.471
														],
														[
															2.811,
															-4.448
														],
														[
															0.307,
															-0.494
														],
														[
															0.095,
															-0.486
														],
														[
															8.377,
															-14.978
														],
														[
															6.317,
															-17.301
														],
														[
															3.994,
															-18.174
														],
														[
															2.21,
															-20.403
														],
														[
															-1.138,
															-30.366
														],
														[
															-5.871,
															-28.246
														],
														[
															-1.599,
															-3.862
														],
														[
															-1.652,
															-3.871
														],
														[
															-2.447,
															-4.979
														],
														[
															-3.039,
															-4.971
														],
														[
															-0.27,
															-0.466
														],
														[
															-0.103,
															-0.509
														],
														[
															-0.464,
															-0.724
														],
														[
															-0.759,
															-0.634
														],
														[
															-0.601,
															-0.892
														],
														[
															-0.454,
															-1.069
														],
														[
															-0.536,
															-0.762
														],
														[
															-0.739,
															-0.636
														],
														[
															-0.327,
															-0.45
														],
														[
															-0.093,
															-0.539
														],
														[
															-0.259,
															-0.339
														],
														[
															-0.361,
															-0.318
														],
														[
															-2.466,
															-3.241
														],
														[
															-2.495,
															-3.015
														],
														[
															-2.81,
															-2.973
														],
														[
															-2.86,
															-2.878
														],
														[
															-0.789,
															-0.722
														],
														[
															-0.828,
															-0.389
														],
														[
															-1.681,
															-1.353
														],
														[
															-1.458,
															-1.394
														],
														[
															-2.784,
															-2.009
														],
														[
															-3.155,
															-1.844
														],
														[
															-8.923,
															-5.547
														],
														[
															-13.55,
															-3.883
														],
														[
															-0.321,
															0.025
														],
														[
															-0.179,
															0.245
														],
														[
															-9.886,
															0.968
														],
														[
															-8.944,
															2.681
														]
													],
													"v": [
														[
															298,
															42
														],
														[
															271.27,
															58.768
														],
														[
															248.474,
															78.779
														],
														[
															228.94,
															101.4
														],
														[
															212,
															126
														],
														[
															208.845,
															131.303
														],
														[
															205.877,
															136.715
														],
														[
															202.97,
															142.268
														],
														[
															200,
															148
														],
														[
															183.816,
															183.007
														],
														[
															170.532,
															220.941
														],
														[
															160.483,
															261.904
														],
														[
															154,
															306
														],
														[
															152.601,
															322.283
														],
														[
															151.645,
															338.65
														],
														[
															151.116,
															354.942
														],
														[
															151,
															371
														],
														[
															155.399,
															433.397
														],
														[
															166.966,
															491.008
														],
														[
															184.301,
															542.865
														],
														[
															206,
															588
														],
														[
															224.44,
															616.823
														],
														[
															246.82,
															643.927
														],
														[
															273.04,
															667.567
														],
														[
															303,
															686
														],
														[
															304.613,
															686.585
														],
														[
															306.346,
															686.99
														],
														[
															308.156,
															687.4
														],
														[
															310,
															688
														],
														[
															311.181,
															688.644
														],
														[
															312.397,
															689.489
														],
														[
															313.665,
															690.339
														],
														[
															315,
															691
														],
														[
															316.691,
															691.547
														],
														[
															318.456,
															692.03
														],
														[
															320.243,
															692.498
														],
														[
															322,
															693
														],
														[
															325.235,
															694.053
														],
														[
															328.483,
															695.137
														],
														[
															331.739,
															696.152
														],
														[
															335,
															697
														],
														[
															343.33,
															698.515
														],
														[
															354.194,
															699.773
														],
														[
															364.461,
															699.895
														],
														[
															371,
															698
														],
														[
															372.032,
															696.099
														],
														[
															373.2,
															692.879
														],
														[
															374.267,
															689.719
														],
														[
															375,
															688
														],
														[
															377.384,
															686.563
														],
														[
															380.605,
															685.856
														],
														[
															384.023,
															685.471
														],
														[
															387,
															685
														],
														[
															415.787,
															674.712
														],
														[
															441.478,
															660.132
														],
														[
															463.931,
															642.487
														],
														[
															483,
															623
														],
														[
															492.848,
															610.672
														],
														[
															502.132,
															597.482
														],
														[
															510.85,
															584.051
														],
														[
															519,
															571
														],
														[
															519.495,
															569.551
														],
														[
															520,
															568
														],
														[
															542.017,
															519.63
														],
														[
															558,
															464
														],
														[
															567.619,
															406.031
														],
														[
															570,
															342
														],
														[
															559.18,
															253.213
														],
														[
															536,
															176
														],
														[
															531.147,
															164.343
														],
														[
															526,
															153
														],
														[
															517.461,
															137.87
														],
														[
															509,
															124
														],
														[
															508.537,
															122.524
														],
														[
															508,
															121
														],
														[
															506.026,
															119.013
														],
														[
															504,
															117
														],
														[
															502.488,
															113.954
														],
														[
															501,
															111
														],
														[
															498.978,
															108.949
														],
														[
															497,
															107
														],
														[
															496.481,
															105.459
														],
														[
															496,
															104
														],
														[
															495.029,
															103.039
														],
														[
															494,
															102
														],
														[
															486.564,
															92.593
														],
														[
															479,
															84
														],
														[
															470.454,
															75.157
														],
														[
															462,
															67
														],
														[
															459.582,
															65.501
														],
														[
															457,
															64
														],
														[
															452.353,
															59.789
														],
														[
															448,
															56
														],
														[
															438.859,
															50.203
														],
														[
															430,
															45
														],
														[
															395.217,
															30.03
														],
														[
															353,
															25
														],
														[
															352.231,
															25.521
														],
														[
															352,
															26
														],
														[
															323.839,
															31.497
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 89,
											"s": [
												{
													"i": [
														[
															0.662,
															-0.025
														],
														[
															13.831,
															-5.574
														],
														[
															9.88,
															-6.142
														],
														[
															1.072,
															-1.04
														],
														[
															1.277,
															-0.947
														],
														[
															1.11,
															-0.456
														],
														[
															0.732,
															-0.56
														],
														[
															0.361,
															-0.381
														],
														[
															0.283,
															-0.265
														],
														[
															1.557,
															-1.389
														],
														[
															1.248,
															-1.018
														],
														[
															7.121,
															-8.587
														],
														[
															5.988,
															-8.697
														],
														[
															2.581,
															-4.159
														],
														[
															2.079,
															-3.589
														],
														[
															0.839,
															-1.254
														],
														[
															0.791,
															-1.512
														],
														[
															2.621,
															-6.201
														],
														[
															2.422,
															-6.288
														],
														[
															4.766,
															-18.372
														],
														[
															2.303,
															-21.295
														],
														[
															0.444,
															-11.284
														],
														[
															0,
															-10.545
														],
														[
															-3.252,
															-20.291
														],
														[
															-4.993,
															-17.847
														],
														[
															-2.16,
															-6.496
														],
														[
															-2.421,
															-6.082
														],
														[
															-1.9,
															-4.018
														],
														[
															-1.678,
															-3.601
														],
														[
															-3.444,
															-6.35
														],
														[
															-3.281,
															-5.278
														],
														[
															-1.543,
															-2.185
														],
														[
															-1.359,
															-1.896
														],
														[
															-1.57,
															-2.105
														],
														[
															-1.264,
															-1.55
														],
														[
															-1.842,
															-1.925
														],
														[
															-1.789,
															-2.039
														],
														[
															-0.431,
															-0.886
														],
														[
															-0.635,
															-0.722
														],
														[
															-0.884,
															-0.607
														],
														[
															-0.786,
															-0.802
														],
														[
															-7.414,
															-5.949
														],
														[
															-7.851,
															-4.58
														],
														[
															-2.755,
															-1.465
														],
														[
															-2.931,
															-1.363
														],
														[
															-6.476,
															-2.154
														],
														[
															-7.857,
															-1.483
														],
														[
															-5.664,
															-0.546
														],
														[
															-3.78,
															1.235
														],
														[
															-0.713,
															-0.027
														],
														[
															-0.736,
															0.648
														],
														[
															-0.774,
															2.282
														],
														[
															-0.336,
															0.371
														],
														[
															-2.269,
															0.339
														],
														[
															-1.78,
															0.38
														],
														[
															-7.255,
															2.696
														],
														[
															-6.663,
															3.441
														],
														[
															-4.178,
															2.364
														],
														[
															-3.143,
															2.403
														],
														[
															-1.108,
															1.013
														],
														[
															-1.257,
															0.947
														],
														[
															-0.521,
															0.084
														],
														[
															-0.481,
															0.336
														],
														[
															-0.293,
															0.596
														],
														[
															-0.412,
															0.324
														],
														[
															-0.521,
															0.081
														],
														[
															-0.482,
															0.337
														],
														[
															-0.296,
															0.593
														],
														[
															-0.4,
															0.336
														],
														[
															-5.704,
															5.856
														],
														[
															-5.031,
															6.417
														],
														[
															-4.521,
															6.746
														],
														[
															-3.096,
															6.869
														],
														[
															-0.451,
															0.153
														],
														[
															-0.116,
															0.212
														],
														[
															-1.8,
															3.858
														],
														[
															-1.841,
															4.001
														],
														[
															-6.293,
															22.288
														],
														[
															-2.654,
															25.909
														],
														[
															6.31,
															39.558
														],
														[
															14.331,
															31.138
														],
														[
															3.634,
															6.621
														],
														[
															3.332,
															5.713
														],
														[
															0.478,
															1.056
														],
														[
															0.529,
															0.817
														],
														[
															0.735,
															0.598
														],
														[
															0.538,
															0.799
														],
														[
															0.407,
															1.005
														],
														[
															0.719,
															1.008
														],
														[
															1.436,
															1.489
														],
														[
															1.183,
															1.54
														],
														[
															0.097,
															0.55
														],
														[
															0.291,
															0.38
														],
														[
															0.364,
															0.325
														],
														[
															0.293,
															0.373
														],
														[
															8.276,
															7.783
														],
														[
															9.052,
															6.172
														],
														[
															17.252,
															5.999
														],
														[
															21.039,
															-1.637
														],
														[
															-0.101,
															0.009
														]
													],
													"o": [
														[
															-14.795,
															0.561
														],
														[
															-13.831,
															5.574
														],
														[
															-1.436,
															0.892
														],
														[
															-1.072,
															1.04
														],
														[
															-0.829,
															0.614
														],
														[
															-1.11,
															0.456
														],
														[
															-0.275,
															0.21
														],
														[
															-0.36,
															0.381
														],
														[
															-1.522,
															1.424
														],
														[
															-1.557,
															1.389
														],
														[
															-8.526,
															6.954
														],
														[
															-7.121,
															8.587
														],
														[
															-2.598,
															3.774
														],
														[
															-2.581,
															4.159
														],
														[
															-0.853,
															1.474
														],
														[
															-0.839,
															1.254
														],
														[
															-3.094,
															5.909
														],
														[
															-2.621,
															6.201
														],
														[
															-6.632,
															17.219
														],
														[
															-4.766,
															18.372
														],
														[
															-1.224,
															11.317
														],
														[
															-0.444,
															11.284
														],
														[
															0,
															22.99
														],
														[
															3.252,
															20.291
														],
														[
															1.94,
															6.935
														],
														[
															2.16,
															6.496
														],
														[
															1.722,
															4.325
														],
														[
															1.9,
															4.018
														],
														[
															2.945,
															6.321
														],
														[
															3.444,
															6.35
														],
														[
															1.469,
															2.363
														],
														[
															1.543,
															2.185
														],
														[
															1.455,
															2.03
														],
														[
															1.57,
															2.105
														],
														[
															1.844,
															2.26
														],
														[
															1.842,
															1.925
														],
														[
															0.643,
															0.734
														],
														[
															0.431,
															0.886
														],
														[
															0.678,
															0.772
														],
														[
															0.884,
															0.607
														],
														[
															6.494,
															6.625
														],
														[
															7.414,
															5.949
														],
														[
															3.048,
															1.778
														],
														[
															2.755,
															1.465
														],
														[
															6.24,
															2.903
														],
														[
															6.476,
															2.154
														],
														[
															5.563,
															1.05
														],
														[
															5.664,
															0.546
														],
														[
															1.412,
															-0.461
														],
														[
															0.713,
															0.027
														],
														[
															0.568,
															-0.5
														],
														[
															0.774,
															-2.282
														],
														[
															1.144,
															-1.264
														],
														[
															2.269,
															-0.339
														],
														[
															8.318,
															-1.774
														],
														[
															7.255,
															-2.696
														],
														[
															4.144,
															-2.14
														],
														[
															4.178,
															-2.364
														],
														[
															1.31,
															-1.001
														],
														[
															1.108,
															-1.013
														],
														[
															0.437,
															-0.329
														],
														[
															0.521,
															-0.084
														],
														[
															0.417,
															-0.292
														],
														[
															0.293,
															-0.596
														],
														[
															0.432,
															-0.34
														],
														[
															0.521,
															-0.081
														],
														[
															0.416,
															-0.291
														],
														[
															0.296,
															-0.593
														],
														[
															6.151,
															-5.16
														],
														[
															5.704,
															-5.856
														],
														[
															4.821,
															-6.148
														],
														[
															4.521,
															-6.746
														],
														[
															0.08,
															-0.178
														],
														[
															0.451,
															-0.152
														],
														[
															1.957,
															-3.567
														],
														[
															1.8,
															-3.858
														],
														[
															9.176,
															-19.938
														],
														[
															6.293,
															-22.288
														],
														[
															4.572,
															-44.63
														],
														[
															-6.31,
															-39.558
														],
														[
															-3.13,
															-6.803
														],
														[
															-3.634,
															-6.621
														],
														[
															-0.558,
															-0.957
														],
														[
															-0.478,
															-1.056
														],
														[
															-0.522,
															-0.807
														],
														[
															-0.735,
															-0.598
														],
														[
															-0.654,
															-0.971
														],
														[
															-0.407,
															-1.005
														],
														[
															-1.074,
															-1.505
														],
														[
															-1.436,
															-1.489
														],
														[
															-0.323,
															-0.422
														],
														[
															-0.096,
															-0.55
														],
														[
															-0.251,
															-0.329
														],
														[
															-0.364,
															-0.325
														],
														[
															-6.846,
															-8.695
														],
														[
															-8.276,
															-7.784
														],
														[
															-12.519,
															-8.536
														],
														[
															-17.833,
															-6.201
														],
														[
															-0.623,
															0.048
														],
														[
															-0.66,
															0.057
														]
													],
													"v": [
														[
															349,
															26
														],
														[
															305.313,
															36.315
														],
														[
															269,
															55
														],
														[
															265.381,
															57.959
														],
														[
															262,
															61
														],
														[
															258.928,
															62.541
														],
														[
															256,
															64
														],
														[
															255.006,
															64.959
														],
														[
															254,
															66
														],
														[
															249.294,
															70.305
														],
														[
															245,
															74
														],
														[
															221.596,
															97.693
														],
														[
															202,
															124
														],
														[
															194.11,
															136.138
														],
														[
															187,
															148
														],
														[
															184.454,
															151.971
														],
														[
															182,
															156
														],
														[
															173.496,
															174.216
														],
														[
															166,
															193
														],
														[
															148.753,
															245.943
														],
														[
															138,
															305
														],
														[
															135.582,
															339.079
														],
														[
															135,
															372
														],
														[
															140.256,
															436.856
														],
														[
															153,
															494
														],
														[
															159.139,
															514.139
														],
														[
															166,
															533
														],
														[
															171.533,
															545.543
														],
														[
															177,
															557
														],
														[
															186.748,
															576.282
														],
														[
															197,
															594
														],
														[
															201.583,
															600.85
														],
														[
															206,
															607
														],
														[
															210.643,
															613.36
														],
														[
															215,
															619
														],
														[
															220.541,
															625.166
														],
														[
															226,
															631
														],
														[
															227.506,
															633.509
														],
														[
															229,
															636
														],
														[
															231.419,
															637.977
														],
														[
															234,
															640
														],
														[
															254.982,
															659.034
														],
														[
															278,
															675
														],
														[
															286.587,
															679.811
														],
														[
															295,
															684
														],
														[
															313.787,
															691.565
														],
														[
															335,
															697
														],
														[
															352.338,
															699.713
														],
														[
															367,
															699
														],
														[
															370.007,
															698.64
														],
														[
															372,
															698
														],
														[
															374.175,
															692.903
														],
														[
															376,
															688
														],
														[
															381.523,
															685.836
														],
														[
															388,
															685
														],
														[
															411.242,
															678.251
														],
														[
															432,
															669
														],
														[
															444.751,
															662.197
														],
														[
															456,
															655
														],
														[
															459.539,
															651.96
														],
														[
															463,
															649
														],
														[
															464.467,
															648.505
														],
														[
															466,
															648
														],
														[
															467.004,
															646.524
														],
														[
															468,
															645
														],
														[
															469.462,
															644.498
														],
														[
															471,
															644
														],
														[
															472.011,
															642.534
														],
														[
															473,
															641
														],
														[
															490.84,
															624.442
														],
														[
															507,
															606
														],
														[
															521.294,
															586.54
														],
														[
															533,
															566
														],
														[
															533.973,
															565.525
														],
														[
															535,
															565
														],
														[
															540.587,
															553.825
														],
														[
															546,
															542
														],
														[
															569.391,
															478.978
														],
														[
															583,
															407
														],
														[
															579.677,
															279.882
														],
														[
															548,
															173
														],
														[
															537.651,
															152.683
														],
														[
															527,
															134
														],
														[
															525.478,
															130.895
														],
														[
															524,
															128
														],
														[
															522.012,
															125.994
														],
														[
															520,
															124
														],
														[
															518.549,
															121.028
														],
														[
															517,
															118
														],
														[
															513.082,
															113.526
														],
														[
															509,
															109
														],
														[
															508.475,
															107.469
														],
														[
															508,
															106
														],
														[
															507.032,
															105.033
														],
														[
															506,
															104
														],
														[
															483.154,
															79.108
														],
														[
															457,
															58
														],
														[
															412,
															34
														],
														[
															352,
															25
														],
														[
															351,
															26
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 90,
											"s": [
												{
													"i": [
														[
															13.697,
															-5.628
														],
														[
															2.199,
															-0.792
														],
														[
															2.029,
															-0.936
														],
														[
															1.055,
															-0.532
														],
														[
															0.825,
															-0.431
														],
														[
															8.626,
															-6.435
														],
														[
															7.489,
															-7.023
														],
														[
															7.604,
															-9.137
														],
														[
															6.103,
															-9.498
														],
														[
															0.881,
															-1.428
														],
														[
															0.609,
															-0.94
														],
														[
															3.84,
															-7.659
														],
														[
															3.141,
															-7.417
														],
														[
															2.548,
															-7.404
														],
														[
															2.008,
															-6.77
														],
														[
															0.322,
															-1.149
														],
														[
															0.343,
															-1.155
														],
														[
															2.134,
															-10.643
														],
														[
															1.45,
															-11.268
														],
														[
															-2.873,
															-32.03
														],
														[
															-7.821,
															-26.361
														],
														[
															-1.864,
															-4.937
														],
														[
															-1.956,
															-4.896
														],
														[
															-6.864,
															-12.9
														],
														[
															-8.013,
															-10.554
														],
														[
															-0.083,
															-0.521
														],
														[
															-0.336,
															-0.481
														],
														[
															-0.598,
															-0.292
														],
														[
															-0.317,
															-0.417
														],
														[
															-0.111,
															-0.558
														],
														[
															-0.25,
															-0.365
														],
														[
															-1.006,
															-1.184
														],
														[
															-0.391,
															-0.408
														],
														[
															-0.092,
															-0.32
														],
														[
															-0.315,
															-0.39
														],
														[
															-1.586,
															-1.458
														],
														[
															-1.371,
															-1.577
														],
														[
															-1.269,
															-1.7
														],
														[
															-1.495,
															-1.557
														],
														[
															-3.195,
															-2.785
														],
														[
															-3.325,
															-2.846
														],
														[
															-4.508,
															-3.278
														],
														[
															-4.015,
															-2.505
														],
														[
															-6.862,
															-3.192
														],
														[
															-8.565,
															-2.875
														],
														[
															-4.864,
															-1.189
														],
														[
															-5.526,
															-0.895
														],
														[
															-5.771,
															-0.59
														],
														[
															-4.028,
															1.314
														],
														[
															-0.702,
															-0.042
														],
														[
															-0.82,
															0.721
														],
														[
															-0.166,
															0.873
														],
														[
															-0.846,
															1.079
														],
														[
															-0.532,
															1.023
														],
														[
															-0.827,
															0.577
														],
														[
															-1.789,
															0.213
														],
														[
															-1.659,
															0.32
														],
														[
															-3.742,
															0.811
														],
														[
															-3.356,
															1.046
														],
														[
															-2.002,
															0.901
														],
														[
															-1.938,
															0.754
														],
														[
															-6.897,
															3.558
														],
														[
															-5.786,
															3.802
														],
														[
															-1.66,
															1.41
														],
														[
															-1.506,
															1.144
														],
														[
															-0.521,
															0.083
														],
														[
															-0.481,
															0.336
														],
														[
															-0.292,
															0.597
														],
														[
															-0.416,
															0.319
														],
														[
															-0.55,
															0.096
														],
														[
															-0.38,
															0.291
														],
														[
															-0.325,
															0.364
														],
														[
															-0.373,
															0.293
														],
														[
															-2.266,
															2.197
														],
														[
															-2.291,
															2.128
														],
														[
															-7.747,
															9.849
														],
														[
															-6.707,
															10.957
														],
														[
															-4.485,
															8.89
														],
														[
															-3.238,
															8.559
														],
														[
															-1.132,
															3.294
														],
														[
															-1.11,
															3.226
														],
														[
															-0.84,
															2.8
														],
														[
															-0.67,
															2.986
														],
														[
															-0.471,
															0.637
														],
														[
															-0.073,
															0.265
														],
														[
															0.078,
															0.688
														],
														[
															-0.141,
															0.629
														],
														[
															-0.146,
															0.53
														],
														[
															-1.087,
															4.722
														],
														[
															1.665,
															41.655
														],
														[
															57.144,
															57.144
														],
														[
															4.271,
															3.996
														],
														[
															1.204,
															1.126
														],
														[
															1.569,
															1.28
														],
														[
															2.772,
															1.903
														],
														[
															2.275,
															1.317
														],
														[
															2.946,
															1.633
														],
														[
															17.782,
															4.121
														],
														[
															5.068,
															0.778
														],
														[
															8.875,
															-0.729
														]
													],
													"o": [
														[
															-2.177,
															0.895
														],
														[
															-2.199,
															0.792
														],
														[
															-0.955,
															0.441
														],
														[
															-1.055,
															0.532
														],
														[
															-10.008,
															5.239
														],
														[
															-8.626,
															6.435
														],
														[
															-8.481,
															7.953
														],
														[
															-7.604,
															9.137
														],
														[
															-0.866,
															1.348
														],
														[
															-0.881,
															1.428
														],
														[
															-4.501,
															6.947
														],
														[
															-3.84,
															7.659
														],
														[
															-2.8,
															6.614
														],
														[
															-2.548,
															7.404
														],
														[
															-0.37,
															1.249
														],
														[
															-0.322,
															1.149
														],
														[
															-3.014,
															10.159
														],
														[
															-2.134,
															10.643
														],
														[
															-4.311,
															33.519
														],
														[
															2.873,
															32.03
														],
														[
															1.589,
															5.358
														],
														[
															1.864,
															4.937
														],
														[
															5.531,
															13.847
														],
														[
															6.864,
															12.9
														],
														[
															0.331,
															0.436
														],
														[
															0.083,
															0.521
														],
														[
															0.291,
															0.417
														],
														[
															0.598,
															0.292
														],
														[
															0.305,
															0.403
														],
														[
															0.111,
															0.558
														],
														[
															0.585,
															0.856
														],
														[
															1.006,
															1.184
														],
														[
															0.317,
															0.331
														],
														[
															0.092,
															0.32
														],
														[
															1.286,
															1.591
														],
														[
															1.586,
															1.458
														],
														[
															1.428,
															1.644
														],
														[
															1.269,
															1.7
														],
														[
															2.894,
															3.013
														],
														[
															3.195,
															2.785
														],
														[
															3.954,
															3.385
														],
														[
															4.508,
															3.278
														],
														[
															6.986,
															4.359
														],
														[
															6.863,
															3.192
														],
														[
															4.017,
															1.349
														],
														[
															4.864,
															1.189
														],
														[
															5.887,
															0.954
														],
														[
															5.771,
															0.59
														],
														[
															1.373,
															-0.448
														],
														[
															0.702,
															0.042
														],
														[
															0.488,
															-0.429
														],
														[
															0.166,
															-0.873
														],
														[
															1.043,
															-1.332
														],
														[
															0.532,
															-1.023
														],
														[
															1.185,
															-0.827
														],
														[
															1.789,
															-0.213
														],
														[
															3.677,
															-0.709
														],
														[
															3.742,
															-0.811
														],
														[
															2.054,
															-0.64
														],
														[
															2.002,
															-0.901
														],
														[
															7.627,
															-2.967
														],
														[
															6.897,
															-3.558
														],
														[
															1.852,
															-1.216
														],
														[
															1.66,
															-1.41
														],
														[
															0.436,
															-0.331
														],
														[
															0.521,
															-0.083
														],
														[
															0.417,
															-0.292
														],
														[
															0.292,
															-0.597
														],
														[
															0.422,
															-0.323
														],
														[
															0.55,
															-0.096
														],
														[
															0.329,
															-0.252
														],
														[
															0.325,
															-0.364
														],
														[
															2.646,
															-2.083
														],
														[
															2.266,
															-2.197
														],
														[
															9.307,
															-8.647
														],
														[
															7.747,
															-9.849
														],
														[
															4.822,
															-7.879
														],
														[
															4.485,
															-8.89
														],
														[
															1.361,
															-3.598
														],
														[
															1.132,
															-3.294
														],
														[
															0.969,
															-2.815
														],
														[
															0.84,
															-2.8
														],
														[
															0.043,
															-0.188
														],
														[
															0.471,
															-0.637
														],
														[
															0.173,
															-0.62
														],
														[
															-0.078,
															-0.688
														],
														[
															0.085,
															-0.377
														],
														[
															1.174,
															-4.262
														],
														[
															7.82,
															-33.963
														],
														[
															-4.327,
															-108.26
														],
														[
															-4.878,
															-4.878
														],
														[
															-1.836,
															-1.717
														],
														[
															-1.968,
															-1.841
														],
														[
															-2.927,
															-2.388
														],
														[
															-2.959,
															-2.031
														],
														[
															-2.922,
															-1.692
														],
														[
															-15.345,
															-8.506
														],
														[
															-4.627,
															-1.072
														],
														[
															-11.058,
															-1.697
														],
														[
															-19.702,
															1.617
														]
													],
													"v": [
														[
															297,
															38
														],
														[
															290.389,
															40.468
														],
														[
															284,
															43
														],
														[
															280.902,
															44.507
														],
														[
															278,
															46
														],
														[
															250.111,
															63.662
														],
														[
															226,
															84
														],
														[
															201.717,
															109.842
														],
														[
															181,
															138
														],
														[
															178.308,
															142.306
														],
														[
															176,
															146
														],
														[
															163.48,
															168.147
														],
														[
															153,
															191
														],
														[
															144.906,
															212.383
														],
														[
															138,
															234
														],
														[
															136.979,
															237.57
														],
														[
															136,
															241
														],
														[
															128.327,
															272.169
														],
														[
															123,
															305
														],
														[
															121.401,
															404.368
														],
														[
															138,
															493
														],
														[
															143.226,
															508.346
														],
														[
															149,
															523
														],
														[
															167.638,
															563.47
														],
														[
															190,
															599
														],
														[
															190.496,
															600.466
														],
														[
															191,
															602
														],
														[
															192.481,
															603
														],
														[
															194,
															604
														],
														[
															194.542,
															605.529
														],
														[
															195,
															607
														],
														[
															197.646,
															610.336
														],
														[
															200,
															613
														],
														[
															200.502,
															613.955
														],
														[
															201,
															615
														],
														[
															205.436,
															619.51
														],
														[
															210,
															624
														],
														[
															213.95,
															629.066
														],
														[
															218,
															634
														],
														[
															227.178,
															642.625
														],
														[
															237,
															651
														],
														[
															249.955,
															661.16
														],
														[
															263,
															670
														],
														[
															283.316,
															681.112
														],
														[
															306,
															690
														],
														[
															319.368,
															693.84
														],
														[
															335,
															697
														],
														[
															352.895,
															699.701
														],
														[
															368,
															699
														],
														[
															370.914,
															698.705
														],
														[
															373,
															698
														],
														[
															373.732,
															695.987
														],
														[
															375,
															693
														],
														[
															377.162,
															689.434
														],
														[
															379,
															687
														],
														[
															383.645,
															685.62
														],
														[
															389,
															685
														],
														[
															400.24,
															682.753
														],
														[
															411,
															680
														],
														[
															417.087,
															677.585
														],
														[
															423,
															675
														],
														[
															444.88,
															665.126
														],
														[
															464,
															654
														],
														[
															469.259,
															649.945
														],
														[
															474,
															646
														],
														[
															475.466,
															645.504
														],
														[
															477,
															645
														],
														[
															478.001,
															643.521
														],
														[
															479,
															642
														],
														[
															480.531,
															641.475
														],
														[
															482,
															641
														],
														[
															482.967,
															640.031
														],
														[
															484,
															639
														],
														[
															491.267,
															632.533
														],
														[
															498,
															626
														],
														[
															523.45,
															598.233
														],
														[
															545,
															567
														],
														[
															559.188,
															541.51
														],
														[
															571,
															515
														],
														[
															574.689,
															504.721
														],
														[
															578,
															495
														],
														[
															580.724,
															486.628
														],
														[
															583,
															478
														],
														[
															583.977,
															476.557
														],
														[
															585,
															475
														],
														[
															585.024,
															473.007
														],
														[
															585,
															471
														],
														[
															587,
															468
														],
														[
															590,
															454
														],
														[
															601,
															340
														],
														[
															501,
															88
														],
														[
															485,
															74
														],
														[
															480,
															70
														],
														[
															475,
															66
														],
														[
															467,
															60
														],
														[
															459,
															55
														],
														[
															451,
															50
														],
														[
															400,
															30
														],
														[
															385,
															27
														],
														[
															350,
															26
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 91,
											"s": [
												{
													"i": [
														[
															16.896,
															-15.698
														],
														[
															1.252,
															-1.187
														],
														[
															1.181,
															-1.165
														],
														[
															1.088,
															-1.146
														],
														[
															0.974,
															-1.129
														],
														[
															1.491,
															-1.711
														],
														[
															1.47,
															-1.705
														],
														[
															1.369,
															-1.641
														],
														[
															1.188,
															-1.52
														],
														[
															0.344,
															-0.42
														],
														[
															0.345,
															-0.42
														],
														[
															0.328,
															-0.415
														],
														[
															0.293,
															-0.405
														],
														[
															0.249,
															-0.511
														],
														[
															0.225,
															-0.537
														],
														[
															0.239,
															-0.508
														],
														[
															0.289,
															-0.422
														],
														[
															0.085,
															-0.086
														],
														[
															0.114,
															-0.112
														],
														[
															0.096,
															-0.095
														],
														[
															0.033,
															-0.035
														],
														[
															0.161,
															-0.254
														],
														[
															0.149,
															-0.269
														],
														[
															0.163,
															-0.256
														],
														[
															0.204,
															-0.212
														],
														[
															0.777,
															-1.173
														],
														[
															0.807,
															-1.176
														],
														[
															0.274,
															-0.611
														],
														[
															0.311,
															-0.69
														],
														[
															0.451,
															-0.158
														],
														[
															0.121,
															-0.197
														],
														[
															0.853,
															-2.018
														],
														[
															0.593,
															-1.315
														],
														[
															0.451,
															-0.153
														],
														[
															0.117,
															-0.212
														],
														[
															0.978,
															-2.017
														],
														[
															1.042,
															-2.026
														],
														[
															7.519,
															-33.133
														],
														[
															-0.598,
															-39.171
														],
														[
															-3.863,
															-20.807
														],
														[
															-6.191,
															-18.443
														],
														[
															-8.31,
															-16.332
														],
														[
															-10.547,
															-14.164
														],
														[
															-13.649,
															-12.718
														],
														[
															-16.683,
															-9.732
														],
														[
															-2.956,
															-1.69
														],
														[
															-3.066,
															-1.424
														],
														[
															-12.304,
															-3.054
														],
														[
															-14.352,
															-0.939
														],
														[
															-4.202,
															-0.089
														],
														[
															-2.174,
															1.62
														],
														[
															-0.198,
															0.694
														],
														[
															-0.082,
															0.131
														],
														[
															-0.398,
															0.367
														],
														[
															-0.239,
															0.261
														],
														[
															-0.185,
															0.924
														],
														[
															-0.5,
															0.476
														],
														[
															-2.69,
															0.342
														],
														[
															-1.937,
															0.392
														],
														[
															-3.036,
															0.688
														],
														[
															-2.837,
															0.637
														],
														[
															-0.636,
															0.469
														],
														[
															-0.265,
															0.082
														],
														[
															-6.531,
															2.464
														],
														[
															-5.644,
															2.902
														],
														[
															-2.896,
															1.732
														],
														[
															-2.499,
															1.571
														],
														[
															-1.888,
															1.174
														],
														[
															-1.644,
															1.17
														],
														[
															-0.829,
															0.693
														],
														[
															-0.841,
															0.628
														],
														[
															-8.892,
															9.033
														],
														[
															-7.788,
															9.933
														],
														[
															-1.352,
															1.634
														],
														[
															-1.272,
															1.779
														],
														[
															-0.455,
															1.074
														],
														[
															-0.572,
															0.852
														],
														[
															-0.61,
															0.29
														],
														[
															-0.284,
															0.427
														],
														[
															-0.052,
															0.7
														],
														[
															-0.389,
															0.596
														],
														[
															-0.733,
															0.831
														],
														[
															-0.532,
															0.852
														],
														[
															-1.626,
															2.756
														],
														[
															-1.58,
															2.899
														],
														[
															-0.996,
															2.018
														],
														[
															-0.987,
															2.04
														],
														[
															-7.245,
															32.403
														],
														[
															1.482,
															39.57
														],
														[
															1.381,
															10.615
														],
														[
															2.057,
															10.327
														],
														[
															10.974,
															24.86
														],
														[
															16.032,
															21.065
														],
														[
															12.68,
															11.5
														],
														[
															15.331,
															8.926
														],
														[
															19.463,
															5.796
														],
														[
															22.745,
															-1.569
														],
														[
															0.185,
															-0.246
														],
														[
															-0.053,
															0.004
														],
														[
															22.521,
															-11.469
														]
													],
													"o": [
														[
															-1.303,
															1.211
														],
														[
															-1.252,
															1.187
														],
														[
															-1.181,
															1.165
														],
														[
															-1.088,
															1.146
														],
														[
															-1.433,
															1.661
														],
														[
															-1.491,
															1.711
														],
														[
															-1.47,
															1.705
														],
														[
															-1.369,
															1.641
														],
														[
															-0.325,
															0.416
														],
														[
															-0.344,
															0.42
														],
														[
															-0.346,
															0.42
														],
														[
															-0.328,
															0.415
														],
														[
															-0.31,
															0.428
														],
														[
															-0.249,
															0.511
														],
														[
															-0.225,
															0.537
														],
														[
															-0.239,
															0.508
														],
														[
															-0.011,
															0.016
														],
														[
															-0.085,
															0.086
														],
														[
															-0.114,
															0.112
														],
														[
															-0.096,
															0.095
														],
														[
															-0.201,
															0.209
														],
														[
															-0.161,
															0.254
														],
														[
															-0.149,
															0.269
														],
														[
															-0.163,
															0.256
														],
														[
															-1.084,
															1.132
														],
														[
															-0.777,
															1.173
														],
														[
															-0.594,
															0.865
														],
														[
															-0.274,
															0.611
														],
														[
															-0.077,
															0.169
														],
														[
															-0.45,
															0.158
														],
														[
															-0.993,
															1.612
														],
														[
															-0.853,
															2.018
														],
														[
															-0.08,
															0.178
														],
														[
															-0.451,
															0.153
														],
														[
															-1.046,
															1.906
														],
														[
															-0.978,
															2.017
														],
														[
															-13.522,
															26.298
														],
														[
															-7.519,
															33.133
														],
														[
															0.356,
															23.327
														],
														[
															3.863,
															20.807
														],
														[
															6.214,
															18.508
														],
														[
															8.31,
															16.332
														],
														[
															10.721,
															14.397
														],
														[
															13.649,
															12.718
														],
														[
															3.111,
															1.815
														],
														[
															2.956,
															1.69
														],
														[
															10.433,
															4.846
														],
														[
															12.304,
															3.054
														],
														[
															4.018,
															0.263
														],
														[
															4.202,
															0.089
														],
														[
															0.126,
															-0.094
														],
														[
															0.198,
															-0.694
														],
														[
															0.169,
															-0.272
														],
														[
															0.398,
															-0.367
														],
														[
															0.76,
															-0.83
														],
														[
															0.185,
															-0.924
														],
														[
															1.303,
															-1.24
														],
														[
															2.69,
															-0.342
														],
														[
															3.02,
															-0.612
														],
														[
															3.036,
															-0.688
														],
														[
															0.19,
															-0.043
														],
														[
															0.636,
															-0.469
														],
														[
															7.231,
															-2.241
														],
														[
															6.531,
															-2.464
														],
														[
															2.916,
															-1.5
														],
														[
															2.896,
															-1.732
														],
														[
															1.804,
															-1.134
														],
														[
															1.888,
															-1.174
														],
														[
															0.842,
															-0.6
														],
														[
															0.829,
															-0.693
														],
														[
															10.644,
															-7.936
														],
														[
															8.892,
															-9.033
														],
														[
															1.322,
															-1.686
														],
														[
															1.352,
															-1.634
														],
														[
															0.609,
															-0.851
														],
														[
															0.455,
															-1.074
														],
														[
															0.277,
															-0.413
														],
														[
															0.61,
															-0.29
														],
														[
															0.402,
															-0.604
														],
														[
															0.052,
															-0.7
														],
														[
															0.538,
															-0.823
														],
														[
															0.733,
															-0.831
														],
														[
															1.918,
															-3.074
														],
														[
															1.626,
															-2.757
														],
														[
															1.029,
															-1.889
														],
														[
															0.996,
															-2.018
														],
														[
															12.5,
															-25.82
														],
														[
															7.245,
															-32.403
														],
														[
															-0.42,
															-11.214
														],
														[
															-1.381,
															-10.615
														],
														[
															-6.074,
															-30.495
														],
														[
															-10.974,
															-24.86
														],
														[
															-9.949,
															-13.073
														],
														[
															-12.68,
															-11.5
														],
														[
															-14.401,
															-8.385
														],
														[
															-19.464,
															-5.796
														],
														[
															-0.312,
															0.021
														],
														[
															-0.185,
															0.246
														],
														[
															-31.02,
															2.426
														],
														[
															-22.521,
															11.469
														]
													],
													"v": [
														[
															211,
															90
														],
														[
															207.162,
															93.596
														],
														[
															203.506,
															97.123
														],
														[
															200.098,
															100.588
														],
														[
															197,
															104
														],
														[
															192.593,
															109.073
														],
														[
															188.132,
															114.212
														],
														[
															183.854,
															119.244
														],
														[
															180,
															124
														],
														[
															178.991,
															125.256
														],
														[
															177.952,
															126.517
														],
														[
															176.937,
															127.769
														],
														[
															176,
															129
														],
														[
															175.172,
															130.422
														],
														[
															174.47,
															132.009
														],
														[
															173.783,
															133.591
														],
														[
															173,
															135
														],
														[
															172.843,
															135.164
														],
														[
															172.533,
															135.472
														],
														[
															172.206,
															135.794
														],
														[
															172,
															136
														],
														[
															171.463,
															136.703
														],
														[
															171.004,
															137.495
														],
														[
															170.543,
															138.291
														],
														[
															170,
															139
														],
														[
															167.292,
															142.467
														],
														[
															165,
															146
														],
														[
															163.788,
															148.131
														],
														[
															163,
															150
														],
														[
															162.034,
															150.479
														],
														[
															161,
															151
														],
														[
															158.2,
															156.722
														],
														[
															156,
															162
														],
														[
															155.027,
															162.475
														],
														[
															154,
															163
														],
														[
															150.997,
															168.91
														],
														[
															148,
															175
														],
														[
															115.91,
															264.345
														],
														[
															105,
															373
														],
														[
															111.623,
															439.163
														],
														[
															127,
															498
														],
														[
															148.75,
															550.258
														],
														[
															177,
															596
														],
														[
															213.528,
															636.999
														],
														[
															259,
															671
														],
														[
															268.034,
															676.293
														],
														[
															277,
															681
														],
														[
															311.06,
															692.93
														],
														[
															351,
															699
														],
														[
															363.883,
															699.912
														],
														[
															374,
															698
														],
														[
															374.533,
															696.528
														],
														[
															375,
															695
														],
														[
															375.947,
															693.992
														],
														[
															377,
															693
														],
														[
															378.195,
															690.234
														],
														[
															379,
															688
														],
														[
															385.525,
															685.864
														],
														[
															393,
															685
														],
														[
															402.138,
															683.019
														],
														[
															411,
															681
														],
														[
															412.444,
															680.03
														],
														[
															414,
															679
														],
														[
															434.691,
															671.995
														],
														[
															453,
															664
														],
														[
															461.813,
															659.054
														],
														[
															470,
															654
														],
														[
															475.62,
															650.527
														],
														[
															481,
															647
														],
														[
															483.5,
															645.021
														],
														[
															486,
															643
														],
														[
															515.141,
															617.497
														],
														[
															540,
															589
														],
														[
															544.038,
															584.07
														],
														[
															548,
															579
														],
														[
															549.527,
															576
														],
														[
															551,
															573
														],
														[
															552.495,
															572.01
														],
														[
															554,
															571
														],
														[
															554.51,
															568.994
														],
														[
															555,
															567
														],
														[
															557.004,
															564.522
														],
														[
															559,
															562
														],
														[
															564.254,
															553.369
														],
														[
															569,
															545
														],
														[
															572.031,
															539.113
														],
														[
															575,
															533
														],
														[
															605.486,
															445.812
														],
														[
															615,
															338
														],
														[
															612.228,
															305.334
														],
														[
															607,
															274
														],
														[
															581.468,
															191.428
														],
														[
															541,
															123
														],
														[
															507.036,
															85.89
														],
														[
															465,
															55
														],
														[
															413.757,
															32.535
														],
														[
															350,
															25
														],
														[
															349.226,
															25.519
														],
														[
															349,
															26
														],
														[
															269.407,
															48.046
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 92,
											"s": [
												{
													"i": [
														[
															0.66,
															-0.001
														],
														[
															5.309,
															-0.94
														],
														[
															5.231,
															-1.231
														],
														[
															6.085,
															-1.859
														],
														[
															5.188,
															-2.04
														],
														[
															5.36,
															-2.727
														],
														[
															4.716,
															-2.793
														],
														[
															1.405,
															-0.764
														],
														[
															0.351,
															-0.337
														],
														[
															0.539,
															-0.298
														],
														[
															0.425,
															-0.407
														],
														[
															1.159,
															-0.757
														],
														[
															1.21,
															-0.868
														],
														[
															10.958,
															-10.63
														],
														[
															8.072,
															-11.807
														],
														[
															0.228,
															-0.225
														],
														[
															0.065,
															-0.069
														],
														[
															0.079,
															-0.295
														],
														[
															0.335,
															-0.454
														],
														[
															0.902,
															-0.766
														],
														[
															0.635,
															-0.917
														],
														[
															0.467,
															-1.081
														],
														[
															0.56,
															-0.853
														],
														[
															0.702,
															-0.796
														],
														[
															0.596,
															-0.909
														],
														[
															5.296,
															-10.556
														],
														[
															4.34,
															-10.9
														],
														[
															4.883,
															-27.304
														],
														[
															-1.268,
															-28.842
														],
														[
															-1.098,
															-11.267
														],
														[
															-2.066,
															-10.576
														],
														[
															-0.704,
															-3.516
														],
														[
															-0.644,
															-2.173
														],
														[
															-0.672,
															-2.643
														],
														[
															-0.566,
															-1.909
														],
														[
															-0.723,
															-1.856
														],
														[
															-0.514,
															-1.581
														],
														[
															-1.131,
															-3.486
														],
														[
															-1.257,
															-3.305
														],
														[
															-1.956,
															-4.558
														],
														[
															-1.572,
															-3.54
														],
														[
															-1.671,
															-3.076
														],
														[
															-1.722,
															-3.103
														],
														[
															-4.974,
															-7.716
														],
														[
															-5.63,
															-7.073
														],
														[
															-24.97,
															-16.905
														],
														[
															-32.868,
															-6.706
														],
														[
															-2.66,
															-0.534
														],
														[
															-2.745,
															-0.33
														],
														[
															-6.18,
															-0.384
														],
														[
															-3.971,
															1.295
														],
														[
															-0.589,
															0.13
														],
														[
															-0.977,
															0.937
														],
														[
															-0.46,
															0.682
														],
														[
															-0.722,
															0.854
														],
														[
															-0.241,
															0.966
														],
														[
															-0.4,
															0.384
														],
														[
															-2.436,
															0.374
														],
														[
															-2.038,
															0.337
														],
														[
															-3.52,
															0.834
														],
														[
															-3.443,
															0.924
														],
														[
															-2.377,
															0.653
														],
														[
															-2.235,
															0.781
														],
														[
															-0.976,
															0.556
														],
														[
															-1.003,
															0.395
														],
														[
															-1.369,
															0.247
														],
														[
															-1.196,
															0.491
														],
														[
															-1.015,
															0.54
														],
														[
															-0.898,
															0.411
														],
														[
															-3.222,
															1.486
														],
														[
															-2.905,
															1.587
														],
														[
															-0.784,
															0.729
														],
														[
															-0.936,
															0.575
														],
														[
															-1.072,
															0.484
														],
														[
															-0.876,
															0.548
														],
														[
															-1.214,
															0.708
														],
														[
															-0.986,
															0.445
														],
														[
															-0.163,
															0.451
														],
														[
															-0.185,
															0.123
														],
														[
															-0.379,
															-0.067
														],
														[
															-0.255,
															0.115
														],
														[
															-0.165,
															0.451
														],
														[
															-0.182,
															0.124
														],
														[
															-1.072,
															0.452
														],
														[
															-0.826,
															0.587
														],
														[
															-0.805,
															0.672
														],
														[
															-0.843,
															0.645
														],
														[
															-6.109,
															5.57
														],
														[
															-2.593,
															1.169
														],
														[
															-0.537,
															0.55
														],
														[
															-0.669,
															0.958
														],
														[
															-0.693,
															0.776
														],
														[
															-15.595,
															32.213
														],
														[
															2.401,
															76.545
														],
														[
															25.998,
															44.911
														],
														[
															42.788,
															25.066
														],
														[
															7.774,
															3.051
														],
														[
															7.733,
															2.41
														],
														[
															2.399,
															0.641
														],
														[
															22.115,
															-1.635
														]
													],
													"o": [
														[
															-5.533,
															0.008
														],
														[
															-5.309,
															0.94
														],
														[
															-6.474,
															1.523
														],
														[
															-6.085,
															1.859
														],
														[
															-5.846,
															2.299
														],
														[
															-5.359,
															2.727
														],
														[
															-1.027,
															0.608
														],
														[
															-1.405,
															0.764
														],
														[
															-0.419,
															0.401
														],
														[
															-0.539,
															0.298
														],
														[
															-1.154,
															1.105
														],
														[
															-1.159,
															0.757
														],
														[
															-12.097,
															8.672
														],
														[
															-10.958,
															10.63
														],
														[
															-0.022,
															0.031
														],
														[
															-0.228,
															0.225
														],
														[
															-0.35,
															0.365
														],
														[
															-0.079,
															0.295
														],
														[
															-0.756,
															1.021
														],
														[
															-0.902,
															0.766
														],
														[
															-0.571,
															0.823
														],
														[
															-0.467,
															1.081
														],
														[
															-0.597,
															0.909
														],
														[
															-0.702,
															0.796
														],
														[
															-6.476,
															9.874
														],
														[
															-5.296,
															10.556
														],
														[
															-8.735,
															21.94
														],
														[
															-4.883,
															27.304
														],
														[
															0.543,
															12.356
														],
														[
															1.098,
															11.267
														],
														[
															0.54,
															2.762
														],
														[
															0.704,
															3.516
														],
														[
															0.748,
															2.519
														],
														[
															0.672,
															2.643
														],
														[
															0.593,
															1.997
														],
														[
															0.723,
															1.856
														],
														[
															1.221,
															3.75
														],
														[
															1.131,
															3.486
														],
														[
															1.606,
															4.226
														],
														[
															1.956,
															4.558
														],
														[
															1.595,
															3.592
														],
														[
															1.671,
															3.076
														],
														[
															4.475,
															8.061
														],
														[
															4.974,
															7.716
														],
														[
															17.252,
															21.676
														],
														[
															24.97,
															16.905
														],
														[
															2.615,
															0.534
														],
														[
															2.66,
															0.534
														],
														[
															6.31,
															0.759
														],
														[
															6.18,
															0.384
														],
														[
															1.668,
															-0.544
														],
														[
															0.589,
															-0.13
														],
														[
															0.438,
															-0.419
														],
														[
															0.46,
															-0.682
														],
														[
															0.635,
															-0.75
														],
														[
															0.241,
															-0.966
														],
														[
															1.218,
															-1.167
														],
														[
															2.436,
															-0.374
														],
														[
															4.475,
															-0.741
														],
														[
															3.52,
															-0.834
														],
														[
															2.258,
															-0.606
														],
														[
															2.377,
															-0.653
														],
														[
															1.094,
															-0.382
														],
														[
															0.976,
															-0.556
														],
														[
															1.328,
															-0.523
														],
														[
															1.369,
															-0.246
														],
														[
															1.042,
															-0.428
														],
														[
															1.015,
															-0.54
														],
														[
															3.207,
															-1.468
														],
														[
															3.222,
															-1.486
														],
														[
															0.93,
															-0.508
														],
														[
															0.784,
															-0.729
														],
														[
															0.837,
															-0.514
														],
														[
															1.072,
															-0.484
														],
														[
															1.16,
															-0.725
														],
														[
															1.214,
															-0.708
														],
														[
															0.162,
															-0.073
														],
														[
															0.163,
															-0.451
														],
														[
															0.23,
															-0.154
														],
														[
															0.379,
															0.067
														],
														[
															0.16,
															-0.072
														],
														[
															0.165,
															-0.451
														],
														[
															0.886,
															-0.603
														],
														[
															1.072,
															-0.452
														],
														[
															0.938,
															-0.668
														],
														[
															0.805,
															-0.672
														],
														[
															7.163,
															-5.481
														],
														[
															2.615,
															-2.384
														],
														[
															0.863,
															-0.389
														],
														[
															0.77,
															-0.788
														],
														[
															0.577,
															-0.826
														],
														[
															22.729,
															-25.433
														],
														[
															24.245,
															-50.08
														],
														[
															-2.086,
															-66.487
														],
														[
															-25.377,
															-43.837
														],
														[
															-8.534,
															-4.999
														],
														[
															-8.399,
															-3.296
														],
														[
															-2.249,
															-0.701
														],
														[
															-19.336,
															-5.168
														],
														[
															-0.658,
															0.049
														]
													],
													"v": [
														[
															346,
															26
														],
														[
															329.774,
															27.583
														],
														[
															314,
															31
														],
														[
															295.036,
															36.113
														],
														[
															278,
															42
														],
														[
															261.152,
															49.629
														],
														[
															246,
															58
														],
														[
															241.993,
															60.204
														],
														[
															239,
															62
														],
														[
															237.505,
															62.995
														],
														[
															236,
															64
														],
														[
															232.542,
															66.678
														],
														[
															229,
															69
														],
														[
															193.981,
															98.149
														],
														[
															165,
															132
														],
														[
															164.533,
															132.472
														],
														[
															164,
															133
														],
														[
															163.489,
															133.934
														],
														[
															163,
															135
														],
														[
															160.41,
															137.578
														],
														[
															158,
															140
														],
														[
															156.492,
															142.978
														],
														[
															155,
															146
														],
														[
															152.999,
															148.5
														],
														[
															151,
															151
														],
														[
															133.398,
															181.73
														],
														[
															119,
															214
														],
														[
															97.998,
															288.823
														],
														[
															92,
															374
														],
														[
															94.358,
															409.335
														],
														[
															99,
															442
														],
														[
															100.921,
															451.941
														],
														[
															103,
															461
														],
														[
															105.136,
															468.958
														],
														[
															107,
															476
														],
														[
															109.059,
															481.812
														],
														[
															111,
															487
														],
														[
															114.473,
															497.833
														],
														[
															118,
															508
														],
														[
															123.526,
															521.515
														],
														[
															129,
															534
														],
														[
															133.904,
															543.867
														],
														[
															139,
															553
														],
														[
															153.133,
															576.741
														],
														[
															169,
															599
														],
														[
															232.288,
															658.227
														],
														[
															319,
															695
														],
														[
															326.903,
															696.653
														],
														[
															335,
															698
														],
														[
															354.254,
															700.041
														],
														[
															370,
															699
														],
														[
															373.018,
															698.294
														],
														[
															375,
															697
														],
														[
															376.287,
															695.326
														],
														[
															378,
															693
														],
														[
															379.176,
															690.225
														],
														[
															380,
															688
														],
														[
															385.885,
															685.878
														],
														[
															393,
															685
														],
														[
															404.774,
															682.637
														],
														[
															415,
															680
														],
														[
															422.018,
															678.131
														],
														[
															429,
															676
														],
														[
															432.068,
															674.509
														],
														[
															435,
															673
														],
														[
															439.099,
															671.976
														],
														[
															443,
															671
														],
														[
															446.108,
															669.487
														],
														[
															449,
															668
														],
														[
															458.726,
															663.589
														],
														[
															468,
															659
														],
														[
															470.495,
															657.051
														],
														[
															473,
															655
														],
														[
															475.97,
															653.525
														],
														[
															479,
															652
														],
														[
															482.63,
															649.79
														],
														[
															486,
															648
														],
														[
															486.483,
															647.038
														],
														[
															487,
															646
														],
														[
															487.981,
															645.971
														],
														[
															489,
															646
														],
														[
															489.483,
															645.039
														],
														[
															490,
															644
														],
														[
															493.045,
															642.488
														],
														[
															496,
															641
														],
														[
															498.571,
															638.983
														],
														[
															501,
															637
														],
														[
															521,
															620
														],
														[
															527,
															615
														],
														[
															531,
															611
														],
														[
															532,
															608
														],
														[
															535,
															606
														],
														[
															591,
															523
														],
														[
															628,
															338
														],
														[
															579,
															165
														],
														[
															475,
															57
														],
														[
															447,
															43
														],
														[
															423,
															35
														],
														[
															416,
															32
														],
														[
															348,
															26
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 93,
											"s": [
												{
													"i": [
														[
															11.784,
															-2.695
														],
														[
															5.175,
															-1.263
														],
														[
															4.808,
															-1.692
														],
														[
															6.545,
															-3.078
														],
														[
															5.799,
															-3.214
														],
														[
															1.901,
															-1.07
														],
														[
															1.575,
															-0.71
														],
														[
															0.159,
															-0.451
														],
														[
															0.195,
															-0.121
														],
														[
															1.037,
															-0.454
														],
														[
															0.896,
															-0.59
														],
														[
															13.962,
															-14.033
														],
														[
															10.273,
															-15.406
														],
														[
															0.701,
															-1.353
														],
														[
															0.457,
															-0.478
														],
														[
															0.298,
															-0.539
														],
														[
															0.407,
															-0.425
														],
														[
															0.806,
															-1.173
														],
														[
															0.686,
															-1.171
														],
														[
															0.703,
															-1.571
														],
														[
															0.477,
															-0.498
														],
														[
															0.06,
															-0.246
														],
														[
															0.35,
															-0.588
														],
														[
															4.649,
															-10.623
														],
														[
															3.639,
															-11.805
														],
														[
															3.52,
															-22.813
														],
														[
															-1.069,
															-24.321
														],
														[
															-2.022,
															-14.186
														],
														[
															-3.261,
															-12.424
														],
														[
															-1.532,
															-4.82
														],
														[
															-1.477,
															-4.4
														],
														[
															-5.766,
															-12.11
														],
														[
															-6.472,
															-10.264
														],
														[
															0.067,
															-0.375
														],
														[
															-0.118,
															-0.26
														],
														[
															-0.451,
															-0.163
														],
														[
															-0.124,
															-0.185
														],
														[
															0.067,
															-0.379
														],
														[
															-0.115,
															-0.255
														],
														[
															-0.451,
															-0.162
														],
														[
															-0.123,
															-0.187
														],
														[
															-0.435,
															-1.019
														],
														[
															-0.65,
															-1.001
														],
														[
															-3.544,
															-4.712
														],
														[
															-3.596,
															-4.178
														],
														[
															-4.748,
															-4.912
														],
														[
															-4.597,
															-4.226
														],
														[
															-0.828,
															-0.873
														],
														[
															-0.844,
															-0.733
														],
														[
															-1.04,
															-0.61
														],
														[
															-0.924,
															-0.764
														],
														[
															-1.627,
															-1.563
														],
														[
															-1.791,
															-1.341
														],
														[
															-0.52,
															-0.084
														],
														[
															-0.481,
															-0.336
														],
														[
															-0.29,
															-0.602
														],
														[
															-0.426,
															-0.301
														],
														[
															-0.382,
															0.067
														],
														[
															-0.25,
															-0.112
														],
														[
															-0.163,
															-0.451
														],
														[
															-0.185,
															-0.123
														],
														[
															-0.379,
															0.067
														],
														[
															-0.255,
															-0.115
														],
														[
															-0.165,
															-0.451
														],
														[
															-0.181,
															-0.124
														],
														[
															-1.046,
															-0.448
														],
														[
															-0.983,
															-0.639
														],
														[
															-31.596,
															-8.259
														],
														[
															-12.338,
															-1.355
														],
														[
															-5.882,
															-0.225
														],
														[
															-4.796,
															1.503
														],
														[
															-1.964,
															1.881
														],
														[
															-1.502,
															1.693
														],
														[
															-1.208,
															1.208
														],
														[
															-0.416,
															0.208
														],
														[
															-3.717,
															0.589
														],
														[
															-16.101,
															6.891
														],
														[
															-6.095,
															3.262
														],
														[
															-1.728,
															1.007
														],
														[
															-2.176,
															1.274
														],
														[
															-1.937,
															0.873
														],
														[
															-0.371,
															0.247
														],
														[
															-0.511,
															0.23
														],
														[
															-0.369,
															0.247
														],
														[
															-1.712,
															1.125
														],
														[
															-1.78,
															1.302
														],
														[
															-22.347,
															54.043
														],
														[
															-0.973,
															2.388
														],
														[
															2.792,
															63.51
														],
														[
															49.851,
															52.52
														],
														[
															6.534,
															5.662
														],
														[
															1.753,
															1.68
														],
														[
															0.813,
															0.643
														],
														[
															3.641,
															2.599
														],
														[
															0.971,
															0.93
														],
														[
															0.85,
															0.815
														],
														[
															2.222,
															1.455
														],
														[
															15.043,
															5.785
														],
														[
															36.821,
															-2.357
														],
														[
															-0.109,
															0.008
														]
													],
													"o": [
														[
															-5.49,
															1.256
														],
														[
															-5.175,
															1.263
														],
														[
															-7.023,
															2.472
														],
														[
															-6.545,
															3.079
														],
														[
															-1.821,
															1.01
														],
														[
															-1.901,
															1.07
														],
														[
															-0.168,
															0.076
														],
														[
															-0.159,
															0.451
														],
														[
															-0.956,
															0.595
														],
														[
															-1.037,
															0.454
														],
														[
															-15.88,
															10.462
														],
														[
															-13.962,
															14.033
														],
														[
															-0.74,
															1.109
														],
														[
															-0.701,
															1.353
														],
														[
															-0.401,
															0.419
														],
														[
															-0.298,
															0.539
														],
														[
															-1.091,
															1.138
														],
														[
															-0.806,
															1.173
														],
														[
															-0.713,
															1.217
														],
														[
															-0.703,
															1.571
														],
														[
															-0.41,
															0.427
														],
														[
															-0.06,
															0.246
														],
														[
															-5.766,
															9.704
														],
														[
															-4.649,
															10.623
														],
														[
															-5.988,
															19.425
														],
														[
															-3.52,
															22.813
														],
														[
															0.652,
															14.83
														],
														[
															2.022,
															14.186
														],
														[
															1.396,
															5.318
														],
														[
															1.532,
															4.82
														],
														[
															4.463,
															13.295
														],
														[
															5.766,
															12.11
														],
														[
															0.15,
															0.239
														],
														[
															-0.067,
															0.375
														],
														[
															0.073,
															0.162
														],
														[
															0.451,
															0.163
														],
														[
															0.154,
															0.23
														],
														[
															-0.067,
															0.379
														],
														[
															0.073,
															0.163
														],
														[
															0.451,
															0.162
														],
														[
															0.608,
															0.925
														],
														[
															0.435,
															1.019
														],
														[
															3.23,
															4.974
														],
														[
															3.544,
															4.712
														],
														[
															4.411,
															5.125
														],
														[
															4.748,
															4.912
														],
														[
															0.844,
															0.775
														],
														[
															0.828,
															0.873
														],
														[
															0.916,
															0.795
														],
														[
															1.04,
															0.61
														],
														[
															1.701,
															1.408
														],
														[
															1.627,
															1.563
														],
														[
															0.438,
															0.327
														],
														[
															0.52,
															0.084
														],
														[
															0.416,
															0.291
														],
														[
															0.29,
															0.602
														],
														[
															0.221,
															0.156
														],
														[
															0.382,
															-0.067
														],
														[
															0.162,
															0.073
														],
														[
															0.163,
															0.451
														],
														[
															0.23,
															0.154
														],
														[
															0.379,
															-0.067
														],
														[
															0.159,
															0.072
														],
														[
															0.165,
															0.451
														],
														[
															0.832,
															0.569
														],
														[
															1.046,
															0.448
														],
														[
															22.48,
															14.601
														],
														[
															9.188,
															2.402
														],
														[
															5.922,
															0.65
														],
														[
															6.963,
															0.267
														],
														[
															3.593,
															-1.126
														],
														[
															0.894,
															-0.857
														],
														[
															1.988,
															-2.242
														],
														[
															0.317,
															-0.317
														],
														[
															2.875,
															-1.438
														],
														[
															21.392,
															-3.391
														],
														[
															6.969,
															-2.983
														],
														[
															1.759,
															-0.941
														],
														[
															2.215,
															-1.291
														],
														[
															2.652,
															-1.553
														],
														[
															0.324,
															-0.146
														],
														[
															0.46,
															-0.307
														],
														[
															0.324,
															-0.146
														],
														[
															1.92,
															-1.285
														],
														[
															1.897,
															-1.246
														],
														[
															44.876,
															-32.826
														],
														[
															0.905,
															-2.189
														],
														[
															18.282,
															-44.881
														],
														[
															-4.285,
															-97.476
														],
														[
															-6.437,
															-6.781
														],
														[
															-2.702,
															-2.341
														],
														[
															-0.68,
															-0.652
														],
														[
															-3.641,
															-2.879
														],
														[
															-2.18,
															-1.556
														],
														[
															-0.838,
															-0.803
														],
														[
															-2.285,
															-2.189
														],
														[
															-13.29,
															-8.702
														],
														[
															-26.6,
															-10.229
														],
														[
															-0.627,
															0.04
														],
														[
															-12.8,
															0.946
														]
													],
													"v": [
														[
															312,
															31
														],
														[
															295.989,
															34.673
														],
														[
															281,
															39
														],
														[
															260.582,
															47.444
														],
														[
															242,
															57
														],
														[
															236.315,
															60.225
														],
														[
															231,
															63
														],
														[
															230.52,
															63.966
														],
														[
															230,
															65
														],
														[
															226.955,
															66.504
														],
														[
															224,
															68
														],
														[
															178.794,
															105.292
														],
														[
															142,
															150
														],
														[
															139.788,
															153.974
														],
														[
															138,
															157
														],
														[
															137.005,
															158.495
														],
														[
															136,
															160
														],
														[
															133.197,
															163.476
														],
														[
															131,
															167
														],
														[
															128.823,
															171.54
														],
														[
															127,
															175
														],
														[
															126.455,
															175.879
														],
														[
															126,
															177
														],
														[
															110.405,
															207.424
														],
														[
															98,
															241
														],
														[
															83.207,
															304.829
														],
														[
															79,
															376
														],
														[
															83.044,
															419.804
														],
														[
															91,
															460
														],
														[
															95.439,
															475.189
														],
														[
															100,
															489
														],
														[
															115.493,
															527.273
														],
														[
															134,
															561
														],
														[
															134.025,
															561.984
														],
														[
															134,
															563
														],
														[
															134.962,
															563.483
														],
														[
															136,
															564
														],
														[
															136.029,
															564.981
														],
														[
															136,
															566
														],
														[
															136.963,
															566.482
														],
														[
															138,
															567
														],
														[
															139.469,
															569.943
														],
														[
															141,
															573
														],
														[
															151.226,
															587.597
														],
														[
															162,
															601
														],
														[
															175.861,
															616.175
														],
														[
															190,
															630
														],
														[
															192.5,
															632.532
														],
														[
															195,
															635
														],
														[
															197.994,
															637.023
														],
														[
															201,
															639
														],
														[
															205.933,
															643.551
														],
														[
															211,
															648
														],
														[
															212.468,
															648.494
														],
														[
															214,
															649
														],
														[
															214.993,
															650.492
														],
														[
															216,
															652
														],
														[
															216.978,
															652.032
														],
														[
															218,
															652
														],
														[
															218.483,
															652.962
														],
														[
															219,
															654
														],
														[
															219.981,
															654.029
														],
														[
															221,
															654
														],
														[
															221.484,
															654.961
														],
														[
															222,
															656
														],
														[
															224.887,
															657.448
														],
														[
															228,
															659
														],
														[
															302,
															692
														],
														[
															335,
															698
														],
														[
															353,
															699
														],
														[
															371,
															699
														],
														[
															376,
															697
														],
														[
															379,
															693
														],
														[
															382,
															687
														],
														[
															384,
															687
														],
														[
															395,
															685
														],
														[
															453,
															668
														],
														[
															473,
															659
														],
														[
															478,
															655
														],
														[
															485,
															652
														],
														[
															492,
															648
														],
														[
															493,
															646
														],
														[
															495,
															646
														],
														[
															496,
															644
														],
														[
															502,
															641
														],
														[
															507,
															637
														],
														[
															610,
															504
														],
														[
															613,
															497
														],
														[
															640,
															337
														],
														[
															547,
															110
														],
														[
															528,
															91
														],
														[
															519,
															84
														],
														[
															517,
															83
														],
														[
															507,
															74
														],
														[
															500,
															70
														],
														[
															497,
															68
														],
														[
															490,
															63
														],
														[
															446,
															41
														],
														[
															348,
															25
														],
														[
															347,
															26
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 94,
											"s": [
												{
													"i": [
														[
															20.024,
															-6.842
														],
														[
															6.889,
															-2.812
														],
														[
															5.976,
															-3.198
														],
														[
															1.94,
															-1.404
														],
														[
															2.062,
															-1.216
														],
														[
															1.026,
															-0.463
														],
														[
															0.944,
															-0.585
														],
														[
															3.015,
															-1.999
														],
														[
															2.767,
															-2.037
														],
														[
															2.015,
															-1.662
														],
														[
															1.927,
															-0.868
														],
														[
															0.179,
															-0.454
														],
														[
															0.147,
															-0.123
														],
														[
															4.688,
															-4.318
														],
														[
															4.205,
															-4.526
														],
														[
															2.37,
															-2.72
														],
														[
															2.034,
															-2.441
														],
														[
															0.997,
															-1.391
														],
														[
															0.838,
															-1.028
														],
														[
															1.213,
															-1.661
														],
														[
															0.731,
															-1.621
														],
														[
															0.451,
															-0.163
														],
														[
															0.124,
															-0.185
														],
														[
															-0.067,
															-0.379
														],
														[
															0.115,
															-0.255
														],
														[
															0.451,
															-0.163
														],
														[
															0.124,
															-0.185
														],
														[
															-0.067,
															-0.379
														],
														[
															0.115,
															-0.255
														],
														[
															0.451,
															-0.163
														],
														[
															0.124,
															-0.185
														],
														[
															-0.067,
															-0.379
														],
														[
															0.115,
															-0.255
														],
														[
															0.451,
															-0.162
														],
														[
															0.123,
															-0.188
														],
														[
															0.436,
															-1.011
														],
														[
															0.62,
															-0.99
														],
														[
															10.034,
															-35.378
														],
														[
															-1.618,
															-43.199
														],
														[
															-4.862,
															-21.472
														],
														[
															-7.632,
															-18.554
														],
														[
															-16.719,
															-22.525
														],
														[
															-21.649,
															-16.999
														],
														[
															-7.16,
															-4.535
														],
														[
															-7.01,
															-3.872
														],
														[
															-2.69,
															-1.357
														],
														[
															-2.62,
															-1.122
														],
														[
															-1.074,
															-0.472
														],
														[
															-1.275,
															-0.5
														],
														[
															-0.484,
															-0.396
														],
														[
															-0.474,
															-0.182
														],
														[
															-2.655,
															-1.021
														],
														[
															-2.157,
															-0.751
														],
														[
															-12.467,
															-2.184
														],
														[
															-11.231,
															-0.359
														],
														[
															-4.502,
															1.427
														],
														[
															-1.918,
															1.811
														],
														[
															-2.456,
															1.364
														],
														[
															-0.233,
															0.089
														],
														[
															-2.3,
															0.329
														],
														[
															-25.762,
															14.301
														],
														[
															-3.092,
															1.394
														],
														[
															-0.395,
															0.242
														],
														[
															-1.759,
															1.09
														],
														[
															-1.912,
															1.322
														],
														[
															-17.805,
															22.165
														],
														[
															-1.354,
															1.784
														],
														[
															-1.236,
															1.706
														],
														[
															-1.371,
															1.931
														],
														[
															-1.271,
															1.956
														],
														[
															-1.155,
															1.852
														],
														[
															-1.214,
															1.922
														],
														[
															-1.202,
															2.055
														],
														[
															-4.904,
															11.442
														],
														[
															-1.496,
															3.849
														],
														[
															3.181,
															59.844
														],
														[
															16.827,
															37.511
														],
														[
															1.096,
															2.288
														],
														[
															2.09,
															3.945
														],
														[
															2.379,
															4.152
														],
														[
															2.498,
															4.007
														],
														[
															1.303,
															1.912
														],
														[
															1.339,
															1.887
														],
														[
															1.39,
															1.919
														],
														[
															1.529,
															1.991
														],
														[
															0.596,
															0.765
														],
														[
															0.683,
															0.847
														],
														[
															0.212,
															0.47
														],
														[
															0.685,
															0.833
														],
														[
															11.072,
															9.469
														],
														[
															1.826,
															1.519
														],
														[
															1.856,
															1.778
														],
														[
															1.113,
															1.042
														],
														[
															1.127,
															1.08
														],
														[
															0.85,
															0.815
														],
														[
															1.215,
															0.991
														],
														[
															1.049,
															0.707
														],
														[
															34.252,
															7.939
														],
														[
															25.703,
															-1.645
														],
														[
															-0.109,
															0.008
														]
													],
													"o": [
														[
															-7.469,
															2.552
														],
														[
															-6.889,
															2.812
														],
														[
															-2.178,
															1.166
														],
														[
															-1.94,
															1.404
														],
														[
															-0.954,
															0.562
														],
														[
															-1.026,
															0.463
														],
														[
															-3.173,
															1.967
														],
														[
															-3.015,
															1.999
														],
														[
															-2.014,
															1.483
														],
														[
															-2.015,
															1.662
														],
														[
															-0.137,
															0.062
														],
														[
															-0.179,
															0.454
														],
														[
															-5.042,
															4.202
														],
														[
															-4.688,
															4.318
														],
														[
															-2.488,
															2.678
														],
														[
															-2.369,
															2.72
														],
														[
															-1.173,
															1.407
														],
														[
															-0.997,
															1.391
														],
														[
															-1.416,
															1.737
														],
														[
															-1.213,
															1.661
														],
														[
															-0.073,
															0.162
														],
														[
															-0.451,
															0.163
														],
														[
															-0.154,
															0.23
														],
														[
															0.067,
															0.379
														],
														[
															-0.073,
															0.162
														],
														[
															-0.451,
															0.163
														],
														[
															-0.154,
															0.23
														],
														[
															0.067,
															0.379
														],
														[
															-0.073,
															0.162
														],
														[
															-0.451,
															0.163
														],
														[
															-0.154,
															0.23
														],
														[
															0.067,
															0.379
														],
														[
															-0.074,
															0.163
														],
														[
															-0.451,
															0.162
														],
														[
															-0.635,
															0.968
														],
														[
															-0.436,
															1.011
														],
														[
															-16.48,
															26.291
														],
														[
															-10.034,
															35.378
														],
														[
															0.919,
															24.558
														],
														[
															4.862,
															21.472
														],
														[
															11.475,
															27.899
														],
														[
															16.719,
															22.525
														],
														[
															6.35,
															4.986
														],
														[
															7.16,
															4.535
														],
														[
															2.621,
															1.448
														],
														[
															2.69,
															1.357
														],
														[
															1.428,
															0.611
														],
														[
															1.074,
															0.472
														],
														[
															0.591,
															0.232
														],
														[
															0.484,
															0.397
														],
														[
															2.647,
															1.019
														],
														[
															2.206,
															0.848
														],
														[
															12.632,
															4.395
														],
														[
															11.889,
															2.083
														],
														[
															6.609,
															0.211
														],
														[
															3.796,
															-1.203
														],
														[
															2.583,
															-2.44
														],
														[
															0.655,
															-0.364
														],
														[
															1.749,
															-0.664
														],
														[
															36.205,
															-5.177
														],
														[
															3.611,
															-2.005
														],
														[
															0.339,
															-0.153
														],
														[
															1.886,
															-1.158
														],
														[
															2.095,
															-1.299
														],
														[
															24.54,
															-16.966
														],
														[
															1.549,
															-1.928
														],
														[
															1.222,
															-1.61
														],
														[
															1.507,
															-2.081
														],
														[
															1.241,
															-1.749
														],
														[
															1.209,
															-1.861
														],
														[
															1.16,
															-1.861
														],
														[
															1.225,
															-1.938
														],
														[
															6.526,
															-11.16
														],
														[
															1.518,
															-3.543
														],
														[
															17.042,
															-43.837
														],
														[
															-2.61,
															-49.101
														],
														[
															-0.977,
															-2.178
														],
														[
															-1.982,
															-4.138
														],
														[
															-2.319,
															-4.379
														],
														[
															-2.314,
															-4.038
														],
														[
															-1.295,
															-2.078
														],
														[
															-1.227,
															-1.801
														],
														[
															-1.383,
															-1.949
														],
														[
															-1.27,
															-1.753
														],
														[
															-0.653,
															-0.851
														],
														[
															-0.656,
															-0.842
														],
														[
															-0.316,
															-0.392
														],
														[
															-0.489,
															-1.084
														],
														[
															-9.76,
															-11.871
														],
														[
															-1.901,
															-1.626
														],
														[
															-2.795,
															-2.326
														],
														[
															-1.492,
															-1.429
														],
														[
															-1.555,
															-1.455
														],
														[
															-0.838,
															-0.803
														],
														[
															-1.511,
															-1.448
														],
														[
															-0.899,
															-0.733
														],
														[
															-25.511,
															-17.21
														],
														[
															-21.391,
															-4.958
														],
														[
															-0.627,
															0.04
														],
														[
															-24.63,
															1.821
														]
													],
													"v": [
														[
															279,
															39
														],
														[
															257.381,
															47.015
														],
														[
															238,
															56
														],
														[
															231.913,
															59.962
														],
														[
															226,
															64
														],
														[
															222.992,
															65.483
														],
														[
															220,
															67
														],
														[
															210.695,
															72.947
														],
														[
															202,
															79
														],
														[
															195.934,
															83.961
														],
														[
															190,
															88
														],
														[
															189.508,
															88.954
														],
														[
															189,
															90
														],
														[
															174.372,
															102.757
														],
														[
															161,
															116
														],
														[
															153.659,
															124.178
														],
														[
															147,
															132
														],
														[
															143.749,
															136.285
														],
														[
															141,
															140
														],
														[
															136.986,
															145.086
														],
														[
															134,
															150
														],
														[
															133.038,
															150.483
														],
														[
															132,
															151
														],
														[
															131.971,
															151.981
														],
														[
															132,
															153
														],
														[
															131.038,
															153.483
														],
														[
															130,
															154
														],
														[
															129.971,
															154.981
														],
														[
															130,
															156
														],
														[
															129.038,
															156.483
														],
														[
															128,
															157
														],
														[
															127.971,
															157.981
														],
														[
															128,
															159
														],
														[
															127.037,
															159.482
														],
														[
															126,
															160
														],
														[
															124.489,
															162.983
														],
														[
															123,
															166
														],
														[
															81.927,
															258.819
														],
														[
															68,
															377
														],
														[
															76.966,
															446.002
														],
														[
															96,
															506
														],
														[
															138.37,
															581.675
														],
														[
															196,
															641
														],
														[
															216.505,
															655.335
														],
														[
															238,
															668
														],
														[
															246.001,
															672.244
														],
														[
															254,
															676
														],
														[
															257.614,
															677.583
														],
														[
															261,
															679
														],
														[
															262.588,
															680.037
														],
														[
															264,
															681
														],
														[
															272,
															683
														],
														[
															278,
															686
														],
														[
															317,
															696
														],
														[
															353,
															700
														],
														[
															372,
															699
														],
														[
															377,
															697
														],
														[
															384,
															687
														],
														[
															387,
															686
														],
														[
															395,
															685
														],
														[
															488,
															653
														],
														[
															499,
															647
														],
														[
															500,
															645
														],
														[
															506,
															642
														],
														[
															512,
															638
														],
														[
															576,
															577
														],
														[
															581,
															572
														],
														[
															584,
															566
														],
														[
															589,
															561
														],
														[
															592,
															555
														],
														[
															596,
															549
														],
														[
															600,
															544
														],
														[
															603,
															537
														],
														[
															621,
															502
														],
														[
															625,
															492
														],
														[
															651,
															338
														],
														[
															620,
															206
														],
														[
															617,
															199
														],
														[
															610,
															187
														],
														[
															604,
															174
														],
														[
															596,
															162
														],
														[
															593,
															156
														],
														[
															588,
															151
														],
														[
															585,
															145
														],
														[
															580,
															140
														],
														[
															579,
															137
														],
														[
															576,
															135
														],
														[
															576,
															133
														],
														[
															572,
															129
														],
														[
															539,
															95
														],
														[
															534,
															90
														],
														[
															524,
															83
														],
														[
															520,
															80
														],
														[
															516,
															77
														],
														[
															513,
															75
														],
														[
															509,
															72
														],
														[
															506,
															70
														],
														[
															418,
															32
														],
														[
															347,
															25
														],
														[
															346,
															26
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 95,
											"s": [
												{
													"i": [
														[
															0.656,
															0.016
														],
														[
															4.547,
															-0.65
														],
														[
															3.195,
															-0.515
														],
														[
															11.347,
															-3.544
														],
														[
															10.225,
															-4.662
														],
														[
															3.361,
															-1.689
														],
														[
															2.8,
															-1.529
														],
														[
															1.207,
															-0.447
														],
														[
															1.013,
															-0.581
														],
														[
															0.794,
															-0.732
														],
														[
															0.951,
															-0.572
														],
														[
															1.562,
															-0.69
														],
														[
															0.521,
															-0.499
														],
														[
															0.27,
															-0.067
														],
														[
															0.522,
															-0.348
														],
														[
															1.334,
															-1.294
														],
														[
															1.24,
															-0.874
														],
														[
															0.382,
															0.067
														],
														[
															0.25,
															-0.112
														],
														[
															0.163,
															-0.451
														],
														[
															0.185,
															-0.124
														],
														[
															0.379,
															0.067
														],
														[
															0.255,
															-0.115
														],
														[
															0.17,
															-0.452
														],
														[
															0.169,
															-0.124
														],
														[
															9.809,
															-9.586
														],
														[
															7.892,
															-9.674
														],
														[
															1.221,
															-1.677
														],
														[
															0.706,
															-1.566
														],
														[
															0.451,
															-0.168
														],
														[
															0.124,
															-0.173
														],
														[
															0.971,
															-1.494
														],
														[
															0.954,
															-1.407
														],
														[
															6.611,
															-13.125
														],
														[
															5.245,
															-15.243
														],
														[
															3.761,
															-23.261
														],
														[
															-0.968,
															-25.837
														],
														[
															-3.731,
															-17.929
														],
														[
															-5.298,
															-15.517
														],
														[
															-0.702,
															-1.933
														],
														[
															-0.584,
															-1.489
														],
														[
															-0.397,
															-0.484
														],
														[
															-0.182,
															-0.474
														],
														[
															-0.261,
															-1.409
														],
														[
															-0.503,
															-1.192
														],
														[
															-1.256,
															-2.148
														],
														[
															-1.062,
															-2.242
														],
														[
															-0.931,
															-2.369
														],
														[
															-1.169,
															-2.185
														],
														[
															-1.429,
															-1.981
														],
														[
															-1.18,
															-2.015
														],
														[
															-0.691,
															-1.56
														],
														[
															-0.533,
															-0.557
														],
														[
															-0.298,
															-0.539
														],
														[
															-0.407,
															-0.425
														],
														[
															-0.713,
															-1.2
														],
														[
															-0.362,
															-0.378
														],
														[
															-0.298,
															-0.539
														],
														[
															-0.407,
															-0.425
														],
														[
															-0.298,
															-0.539
														],
														[
															-0.407,
															-0.425
														],
														[
															-0.071,
															-0.279
														],
														[
															-0.345,
															-0.497
														],
														[
															-0.915,
															-0.785
														],
														[
															-0.665,
															-0.886
														],
														[
															0.067,
															-0.387
														],
														[
															-0.109,
															-0.244
														],
														[
															-0.249,
															-0.346
														],
														[
															-24.017,
															-18.08
														],
														[
															-18.777,
															-8.898
														],
														[
															-4.573,
															-1.96
														],
														[
															-3.789,
															-1.309
														],
														[
															-29.615,
															-0.76
														],
														[
															-3.527,
															1.126
														],
														[
															-1.805,
															1.805
														],
														[
															-1.489,
															1.614
														],
														[
															-1.106,
															1.106
														],
														[
															-0.413,
															0.177
														],
														[
															-3.927,
															0.589
														],
														[
															-34.464,
															25.873
														],
														[
															-4.677,
															3.817
														],
														[
															-8.331,
															8.499
														],
														[
															-1.45,
															1.607
														],
														[
															-1.531,
															1.783
														],
														[
															-1.486,
															1.85
														],
														[
															-1.684,
															2.064
														],
														[
															-1.43,
															3.172
														],
														[
															-0.247,
															0.37
														],
														[
															-0.23,
															0.511
														],
														[
															-0.248,
															0.355
														],
														[
															-3.728,
															6.057
														],
														[
															-3.925,
															7.986
														],
														[
															3.281,
															74.613
														],
														[
															29.376,
															43.383
														],
														[
															24.356,
															19.021
														],
														[
															3.536,
															2.884
														],
														[
															7.079,
															4.205
														],
														[
															9.277,
															4.23
														],
														[
															52.042,
															-3.057
														],
														[
															-0.112,
															0.008
														]
													],
													"o": [
														[
															-4.616,
															-0.114
														],
														[
															-4.547,
															0.65
														],
														[
															-13.387,
															2.16
														],
														[
															-11.347,
															3.544
														],
														[
															-3.758,
															1.713
														],
														[
															-3.361,
															1.689
														],
														[
															-1.157,
															0.632
														],
														[
															-1.207,
															0.447
														],
														[
															-0.874,
															0.501
														],
														[
															-0.794,
															0.732
														],
														[
															-1.233,
															0.742
														],
														[
															-1.562,
															0.69
														],
														[
															-0.399,
															0.382
														],
														[
															-0.27,
															0.067
														],
														[
															-1.423,
															0.948
														],
														[
															-1.334,
															1.294
														],
														[
															-0.221,
															0.156
														],
														[
															-0.382,
															-0.067
														],
														[
															-0.162,
															0.073
														],
														[
															-0.163,
															0.451
														],
														[
															-0.23,
															0.154
														],
														[
															-0.379,
															-0.067
														],
														[
															-0.152,
															0.069
														],
														[
															-0.17,
															0.452
														],
														[
															-10.871,
															7.982
														],
														[
															-9.809,
															9.586
														],
														[
															-1.408,
															1.726
														],
														[
															-1.221,
															1.677
														],
														[
															-0.07,
															0.154
														],
														[
															-0.451,
															0.168
														],
														[
															-1.161,
															1.616
														],
														[
															-0.971,
															1.494
														],
														[
															-8.311,
															12.257
														],
														[
															-6.611,
															13.125
														],
														[
															-6.923,
															20.119
														],
														[
															-3.761,
															23.261
														],
														[
															0.778,
															20.769
														],
														[
															3.731,
															17.929
														],
														[
															0.608,
															1.781
														],
														[
															0.702,
															1.932
														],
														[
															0.232,
															0.591
														],
														[
															0.397,
															0.484
														],
														[
															0.451,
															1.172
														],
														[
															0.261,
															1.409
														],
														[
															0.914,
															2.165
														],
														[
															1.256,
															2.148
														],
														[
															1.108,
															2.339
														],
														[
															0.93,
															2.369
														],
														[
															1.104,
															2.062
														],
														[
															1.429,
															1.981
														],
														[
															0.705,
															1.204
														],
														[
															0.691,
															1.56
														],
														[
															0.401,
															0.419
														],
														[
															0.298,
															0.539
														],
														[
															0.787,
															0.822
														],
														[
															0.713,
															1.2
														],
														[
															0.401,
															0.419
														],
														[
															0.298,
															0.539
														],
														[
															0.401,
															0.419
														],
														[
															0.298,
															0.539
														],
														[
															0.371,
															0.388
														],
														[
															0.071,
															0.279
														],
														[
															0.673,
															0.972
														],
														[
															0.915,
															0.786
														],
														[
															0.157,
															0.209
														],
														[
															-0.067,
															0.387
														],
														[
															0.139,
															0.309
														],
														[
															17.735,
															24.674
														],
														[
															15.09,
															11.36
														],
														[
															5.408,
															2.563
														],
														[
															4.303,
															1.844
														],
														[
															23.21,
															8.015
														],
														[
															6.188,
															0.159
														],
														[
															3.225,
															-1.029
														],
														[
															1.035,
															-1.035
														],
														[
															1.942,
															-2.105
														],
														[
															0.304,
															-0.304
														],
														[
															3.211,
															-1.376
														],
														[
															53.405,
															-8.007
														],
														[
															5.691,
															-4.272
														],
														[
															9.464,
															-7.723
														],
														[
															1.435,
															-1.464
														],
														[
															1.379,
															-1.528
														],
														[
															1.491,
															-1.737
														],
														[
															2.305,
															-2.869
														],
														[
															2.948,
															-3.614
														],
														[
															0.146,
															-0.324
														],
														[
															0.307,
															-0.46
														],
														[
															0.142,
															-0.314
														],
														[
															4.16,
															-5.945
														],
														[
															5.035,
															-8.18
														],
														[
															23.675,
															-48.166
														],
														[
															-3.015,
															-68.566
														],
														[
															-17.942,
															-26.498
														],
														[
															-4.51,
															-3.522
														],
														[
															-6.824,
															-5.566
														],
														[
															-8.182,
															-4.86
														],
														[
															-35.469,
															-16.173
														],
														[
															-0.628,
															0.037
														],
														[
															-0.655,
															0.045
														]
													],
													"v": [
														[
															343,
															26
														],
														[
															328.934,
															27.027
														],
														[
															317,
															29
														],
														[
															280.128,
															37.624
														],
														[
															248,
															50
														],
														[
															237.281,
															55.138
														],
														[
															228,
															60
														],
														[
															224.392,
															61.538
														],
														[
															221,
															63
														],
														[
															218.558,
															64.946
														],
														[
															216,
															67
														],
														[
															211.466,
															69.181
														],
														[
															208,
															71
														],
														[
															207.092,
															71.526
														],
														[
															206,
															72
														],
														[
															201.863,
															75.555
														],
														[
															198,
															79
														],
														[
															197.022,
															79.032
														],
														[
															196,
															79
														],
														[
															195.517,
															79.962
														],
														[
															195,
															81
														],
														[
															194.019,
															81.029
														],
														[
															193,
															81
														],
														[
															192.513,
															81.958
														],
														[
															192,
															83
														],
														[
															160.765,
															109.731
														],
														[
															134,
															139
														],
														[
															129.974,
															144.12
														],
														[
															127,
															149
														],
														[
															126.041,
															149.486
														],
														[
															125,
															150
														],
														[
															121.845,
															154.656
														],
														[
															119,
															159
														],
														[
															96.701,
															196.76
														],
														[
															79,
															239
														],
														[
															62.582,
															304.211
														],
														[
															58,
															378
														],
														[
															65.11,
															435.939
														],
														[
															79,
															486
														],
														[
															81.018,
															491.719
														],
														[
															83,
															497
														],
														[
															84.037,
															498.588
														],
														[
															85,
															500
														],
														[
															85.961,
															503.985
														],
														[
															87,
															508
														],
														[
															90.389,
															514.442
														],
														[
															94,
															521
														],
														[
															96.954,
															528.115
														],
														[
															100,
															535
														],
														[
															103.943,
															541.035
														],
														[
															108,
															547
														],
														[
															110.129,
															551.485
														],
														[
															112,
															555
														],
														[
															112.995,
															556.495
														],
														[
															114,
															558
														],
														[
															116.319,
															561.333
														],
														[
															118,
															564
														],
														[
															118.995,
															565.495
														],
														[
															120,
															567
														],
														[
															120.995,
															568.495
														],
														[
															122,
															570
														],
														[
															122.52,
															570.918
														],
														[
															123,
															572
														],
														[
															125.507,
															574.564
														],
														[
															128,
															577
														],
														[
															128.036,
															577.974
														],
														[
															128,
															579
														],
														[
															130,
															580
														],
														[
															192,
															642
														],
														[
															242,
															672
														],
														[
															259,
															680
														],
														[
															270,
															684
														],
														[
															354,
															700
														],
														[
															373,
															699
														],
														[
															378,
															697
														],
														[
															381,
															693
														],
														[
															384,
															687
														],
														[
															386,
															687
														],
														[
															397,
															685
														],
														[
															528,
															630
														],
														[
															544,
															617
														],
														[
															569,
															593
														],
														[
															574,
															589
														],
														[
															578,
															583
														],
														[
															583,
															578
														],
														[
															589,
															570
														],
														[
															596,
															560
														],
														[
															598,
															559
														],
														[
															598,
															557
														],
														[
															600,
															556
														],
														[
															611,
															538
														],
														[
															625,
															513
														],
														[
															661,
															334
														],
														[
															602,
															159
														],
														[
															537,
															88
														],
														[
															523,
															78
														],
														[
															502,
															64
														],
														[
															476,
															51
														],
														[
															346,
															25
														],
														[
															345,
															26
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 96,
											"s": [
												{
													"i": [
														[
															12.543,
															-2.444
														],
														[
															4.135,
															-1.056
														],
														[
															3.385,
															-0.981
														],
														[
															3.468,
															-1.327
														],
														[
															3.676,
															-1.404
														],
														[
															1.362,
															-0.255
														],
														[
															1.286,
															-0.495
														],
														[
															0.541,
															-0.418
														],
														[
															0.491,
															-0.193
														],
														[
															2.68,
															-1.314
														],
														[
															2.843,
															-1.395
														],
														[
															2.357,
															-1.153
														],
														[
															2.157,
															-1.201
														],
														[
															14.682,
															-12.207
														],
														[
															11.823,
															-14.458
														],
														[
															9.902,
															-16.636
														],
														[
															7.192,
															-20.538
														],
														[
															4.035,
															-23.467
														],
														[
															-1.148,
															-26.125
														],
														[
															-7.848,
															-26.111
														],
														[
															-11.231,
															-21.206
														],
														[
															-0.713,
															-0.982
														],
														[
															-0.579,
															-1.002
														],
														[
															-0.42,
															-1.196
														],
														[
															-0.645,
															-1.051
														],
														[
															-1.999,
															-4.434
														],
														[
															-0.247,
															-0.37
														],
														[
															-0.23,
															-0.511
														],
														[
															-0.248,
															-0.358
														],
														[
															-0.227,
															-0.503
														],
														[
															-0.249,
															-0.346
														],
														[
															-2.573,
															-2.686
														],
														[
															-0.643,
															-0.813
														],
														[
															-3.116,
															-3.605
														],
														[
															-1.638,
															-1.789
														],
														[
															-8.918,
															-7.675
														],
														[
															-7.863,
															-3.544
														],
														[
															-0.346,
															-0.249
														],
														[
															-4.047,
															-1.824
														],
														[
															-0.399,
															-0.241
														],
														[
															-1.012,
															-0.969
														],
														[
															-1.176,
															-0.699
														],
														[
															-8.78,
															-3.763
														],
														[
															-2.551,
															-1.001
														],
														[
															-0.96,
															-0.385
														],
														[
															-2.742,
															-1.028
														],
														[
															-2.405,
															-0.816
														],
														[
															-24.566,
															-2.094
														],
														[
															-10.309,
															2.092
														],
														[
															-3.918,
															2.883
														],
														[
															-6.761,
															1.254
														],
														[
															-41.837,
															41.837
														],
														[
															-1.729,
															3.835
														],
														[
															-0.246,
															0.295
														],
														[
															-2.139,
															2.613
														],
														[
															-3.973,
															4.147
														],
														[
															-0.814,
															0.85
														],
														[
															-0.815,
															0.85
														],
														[
															-0.815,
															0.85
														],
														[
															-0.815,
															0.85
														],
														[
															-0.699,
															1.176
														],
														[
															-2.897,
															5.204
														],
														[
															-2.185,
															4.256
														],
														[
															4.716,
															73.245
														],
														[
															1.851,
															11.558
														],
														[
															1.137,
															5.139
														],
														[
															0.99,
															4.455
														],
														[
															0.138,
															0.526
														],
														[
															1.601,
															4.89
														],
														[
															1.776,
															5.018
														],
														[
															0.924,
															2.464
														],
														[
															1.043,
															2.527
														],
														[
															2.128,
															4.491
														],
														[
															4.687,
															7.992
														],
														[
															1.442,
															3.198
														],
														[
															0.245,
															0.385
														],
														[
															0.234,
															0.519
														],
														[
															0.247,
															0.37
														],
														[
															0.23,
															0.511
														],
														[
															0.247,
															0.37
														],
														[
															0.23,
															0.511
														],
														[
															0.247,
															0.37
														],
														[
															0.23,
															0.511
														],
														[
															0.248,
															0.354
														],
														[
															0.533,
															0.78
														],
														[
															1.963,
															2.569
														],
														[
															1.688,
															2.102
														],
														[
															2.985,
															3.435
														],
														[
															1.551,
															1.688
														],
														[
															10.803,
															9.26
														],
														[
															13.192,
															5.947
														],
														[
															0.399,
															0.241
														],
														[
															2.106,
															1.233
														],
														[
															2.075,
															1.114
														],
														[
															2.256,
															1.086
														],
														[
															4.564,
															1.976
														],
														[
															4.69,
															1.846
														],
														[
															5.372,
															1.499
														],
														[
															37.757,
															-2.218
														],
														[
															-0.112,
															0.008
														]
													],
													"o": [
														[
															-4.076,
															0.794
														],
														[
															-4.135,
															1.056
														],
														[
															-4.452,
															1.29
														],
														[
															-3.468,
															1.327
														],
														[
															-1.267,
															0.483
														],
														[
															-1.362,
															0.255
														],
														[
															-0.347,
															0.133
														],
														[
															-0.541,
															0.418
														],
														[
															-3.438,
															1.349
														],
														[
															-2.68,
															1.314
														],
														[
															-2.416,
															1.186
														],
														[
															-2.357,
															1.153
														],
														[
															-17.448,
															9.713
														],
														[
															-14.682,
															12.207
														],
														[
															-12.199,
															14.918
														],
														[
															-9.902,
															16.636
														],
														[
															-7.007,
															20.007
														],
														[
															-4.035,
															23.467
														],
														[
															1.379,
															31.352
														],
														[
															7.847,
															26.111
														],
														[
															0.567,
															1.072
														],
														[
															0.713,
															0.982
														],
														[
															0.674,
															1.167
														],
														[
															0.42,
															1.196
														],
														[
															2.947,
															4.801
														],
														[
															0.146,
															0.324
														],
														[
															0.307,
															0.46
														],
														[
															0.143,
															0.317
														],
														[
															0.31,
															0.448
														],
														[
															0.139,
															0.309
														],
														[
															2.868,
															3.99
														],
														[
															0.652,
															0.68
														],
														[
															2.884,
															3.648
														],
														[
															1.615,
															1.868
														],
														[
															8.136,
															8.883
														],
														[
															7.059,
															6.076
														],
														[
															0.309,
															0.139
														],
														[
															4.246,
															3.052
														],
														[
															0.342,
															0.154
														],
														[
															2.438,
															1.473
														],
														[
															0.854,
															0.819
														],
														[
															8.338,
															4.954
														],
														[
															2.855,
															1.223
														],
														[
															1.196,
															0.469
														],
														[
															2.382,
															0.956
														],
														[
															2.274,
															0.853
														],
														[
															20.251,
															6.871
														],
														[
															14.645,
															1.248
														],
														[
															7.229,
															-1.467
														],
														[
															4.958,
															-3.648
														],
														[
															71.118,
															-13.187
														],
														[
															3.583,
															-3.583
														],
														[
															0.124,
															-0.274
														],
														[
															2.519,
															-3.022
														],
														[
															4.437,
															-5.419
														],
														[
															0.803,
															-0.838
														],
														[
															0.803,
															-0.838
														],
														[
															0.803,
															-0.838
														],
														[
															0.803,
															-0.838
														],
														[
															0.818,
															-0.854
														],
														[
															3.195,
															-5.377
														],
														[
															2.276,
															-4.088
														],
														[
															24.664,
															-48.041
														],
														[
															-0.819,
															-12.715
														],
														[
															-0.863,
															-5.39
														],
														[
															-1.062,
															-4.801
														],
														[
															-0.083,
															-0.372
														],
														[
															-1.386,
															-5.29
														],
														[
															-1.634,
															-4.992
														],
														[
															-0.831,
															-2.347
														],
														[
															-0.881,
															-2.35
														],
														[
															-1.801,
															-4.365
														],
														[
															-4.485,
															-9.465
														],
														[
															-2.187,
															-3.729
														],
														[
															-0.15,
															-0.333
														],
														[
															-0.302,
															-0.475
														],
														[
															-0.146,
															-0.324
														],
														[
															-0.307,
															-0.46
														],
														[
															-0.146,
															-0.324
														],
														[
															-0.307,
															-0.46
														],
														[
															-0.146,
															-0.324
														],
														[
															-0.307,
															-0.46
														],
														[
															-0.142,
															-0.314
														],
														[
															-0.625,
															-0.892
														],
														[
															-1.977,
															-2.892
														],
														[
															-1.552,
															-2.032
														],
														[
															-3.216,
															-4.004
														],
														[
															-1.466,
															-1.688
														],
														[
															-9.712,
															-10.566
														],
														[
															-11.212,
															-9.611
														],
														[
															-0.342,
															-0.154
														],
														[
															-2.075,
															-1.254
														],
														[
															-2.193,
															-1.284
														],
														[
															-2.261,
															-1.214
														],
														[
															-4.498,
															-2.164
														],
														[
															-4.417,
															-1.913
														],
														[
															-5.87,
															-2.31
														],
														[
															-29.282,
															-8.172
														],
														[
															-0.628,
															0.037
														],
														[
															-12.339,
															0.856
														]
													],
													"v": [
														[
															306,
															30
														],
														[
															293.482,
															32.86
														],
														[
															282,
															36
														],
														[
															270.418,
															39.914
														],
														[
															260,
															44
														],
														[
															256.015,
															44.991
														],
														[
															252,
															46
														],
														[
															250.608,
															46.955
														],
														[
															249,
															48
														],
														[
															240.054,
															51.965
														],
														[
															232,
															56
														],
														[
															224.806,
															59.489
														],
														[
															218,
															63
														],
														[
															169.781,
															95.942
														],
														[
															130,
															136
														],
														[
															96.745,
															182.785
														],
														[
															71,
															238
														],
														[
															53.884,
															303.412
														],
														[
															49,
															378
														],
														[
															63.61,
															464.11
														],
														[
															93,
															535
														],
														[
															94.991,
															538.053
														],
														[
															97,
															541
														],
														[
															98.522,
															544.587
														],
														[
															100,
															548
														],
														[
															109,
															562
														],
														[
															111,
															563
														],
														[
															111,
															565
														],
														[
															113,
															566
														],
														[
															113,
															568
														],
														[
															115,
															569
														],
														[
															124,
															582
														],
														[
															125,
															584
														],
														[
															135,
															594
														],
														[
															139,
															600
														],
														[
															165,
															625
														],
														[
															189,
															643
														],
														[
															190,
															645
														],
														[
															204,
															653
														],
														[
															205,
															655
														],
														[
															213,
															659
														],
														[
															215,
															660
														],
														[
															242,
															674
														],
														[
															249,
															677
														],
														[
															252,
															679
														],
														[
															260,
															681
														],
														[
															267,
															684
														],
														[
															334,
															698
														],
														[
															374,
															699
														],
														[
															385,
															688
														],
														[
															408,
															684
														],
														[
															575,
															594
														],
														[
															585,
															582
														],
														[
															587,
															581
														],
														[
															594,
															573
														],
														[
															607,
															555
														],
														[
															609,
															552
														],
														[
															611,
															549
														],
														[
															613,
															546
														],
														[
															615,
															543
														],
														[
															616,
															541
														],
														[
															626,
															526
														],
														[
															632,
															513
														],
														[
															669,
															334
														],
														[
															666,
															298
														],
														[
															662,
															282
														],
														[
															660,
															269
														],
														[
															658,
															266
														],
														[
															654,
															251
														],
														[
															649,
															236
														],
														[
															646,
															229
														],
														[
															644,
															221
														],
														[
															637,
															208
														],
														[
															624,
															182
														],
														[
															618,
															171
														],
														[
															616,
															170
														],
														[
															616,
															168
														],
														[
															614,
															167
														],
														[
															614,
															165
														],
														[
															612,
															164
														],
														[
															612,
															162
														],
														[
															610,
															161
														],
														[
															610,
															159
														],
														[
															608,
															158
														],
														[
															607,
															155
														],
														[
															600,
															147
														],
														[
															596,
															141
														],
														[
															587,
															130
														],
														[
															582,
															125
														],
														[
															552,
															96
														],
														[
															513,
															69
														],
														[
															512,
															67
														],
														[
															505,
															64
														],
														[
															499,
															60
														],
														[
															492,
															57
														],
														[
															479,
															50
														],
														[
															465,
															45
														],
														[
															447,
															38
														],
														[
															345,
															25
														],
														[
															344,
															26
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 97,
											"s": [
												{
													"i": [
														[
															12.69,
															-2.455
														],
														[
															9.279,
															-2.74
														],
														[
															7.854,
															-3.1
														],
														[
															1.34,
															-0.483
														],
														[
															1.258,
															-0.524
														],
														[
															4.44,
															-2.405
														],
														[
															4.198,
															-2.279
														],
														[
															1.185,
															-0.433
														],
														[
															1.108,
															-0.644
														],
														[
															3.157,
															-2.006
														],
														[
															3.023,
															-2.032
														],
														[
															3.217,
															-2.384
														],
														[
															2.978,
															-1.343
														],
														[
															0.172,
															-0.452
														],
														[
															0.162,
															-0.124
														],
														[
															2.209,
															-1.946
														],
														[
															2.406,
															-2.105
														],
														[
															1.824,
															-1.65
														],
														[
															1.8,
															-1.734
														],
														[
															9.09,
															-11.439
														],
														[
															7.243,
															-12.229
														],
														[
															4.328,
															-8.78
														],
														[
															3.102,
															-8.139
														],
														[
															0.47,
															-1.273
														],
														[
															0.445,
															-1.132
														],
														[
															0.67,
															-1.824
														],
														[
															0.502,
															-1.621
														],
														[
															0.584,
															-2.818
														],
														[
															0.793,
															-2.923
														],
														[
															1.392,
															-5.462
														],
														[
															0.977,
															-5.792
														],
														[
															-1.145,
															-25.552
														],
														[
															-5.468,
															-20.794
														],
														[
															-4.748,
															-12.513
														],
														[
															-5.547,
															-10.788
														],
														[
															-1.391,
															-2.142
														],
														[
															-1.298,
															-2.219
														],
														[
															-1.111,
															-2.202
														],
														[
															-1.3,
															-2.045
														],
														[
															-1.607,
															-2.325
														],
														[
															-1.017,
															-2.255
														],
														[
															-0.451,
															-0.168
														],
														[
															-0.124,
															-0.173
														],
														[
															-0.958,
															-1.512
														],
														[
															-0.994,
															-1.317
														],
														[
															-1.255,
															-1.378
														],
														[
															-0.851,
															-0.993
														],
														[
															-0.266,
															-0.723
														],
														[
															-0.489,
															-0.587
														],
														[
															-1.715,
															-1.616
														],
														[
															-1.62,
															-1.707
														],
														[
															-1.62,
															-1.845
														],
														[
															-1.737,
															-1.744
														],
														[
															-16.769,
															-11.482
														],
														[
															-19.085,
															-8.179
														],
														[
															-0.489,
															-0.391
														],
														[
															-0.469,
															-0.188
														],
														[
															-1.402,
															-0.265
														],
														[
															-1.266,
															-0.487
														],
														[
															-0.541,
															-0.418
														],
														[
															-0.491,
															-0.192
														],
														[
															-6.923,
															-1.814
														],
														[
															-6.185,
															-1.34
														],
														[
															-9.919,
															-1.439
														],
														[
															-10.337,
															-0.297
														],
														[
															-4.282,
															0.147
														],
														[
															-2.192,
															0.515
														],
														[
															-0.222,
															0.368
														],
														[
															-0.424,
															0.368
														],
														[
															-1.446,
															2.129
														],
														[
															-3.138,
															0.683
														],
														[
															-1.821,
															0.08
														],
														[
															-1.819,
															0.265
														],
														[
															-4.013,
															0.84
														],
														[
															-3.957,
															0.913
														],
														[
															-14.071,
															5.689
														],
														[
															-13.134,
															7.418
														],
														[
															-14.659,
															12.239
														],
														[
															-11.978,
															14.787
														],
														[
															-8.579,
															13.433
														],
														[
															-6.127,
															14.473
														],
														[
															-5.139,
															26.466
														],
														[
															1.959,
															31.924
														],
														[
															3.287,
															14.694
														],
														[
															0.715,
															2.957
														],
														[
															0.665,
															2.407
														],
														[
															1.781,
															5.411
														],
														[
															1.704,
															4.342
														],
														[
															4.637,
															8.489
														],
														[
															2.341,
															5.194
														],
														[
															0.242,
															0.397
														],
														[
															1.063,
															1.109
														],
														[
															2.135,
															2.228
														],
														[
															0.815,
															0.85
														],
														[
															1.775,
															2.293
														],
														[
															1.506,
															1.918
														],
														[
															17.829,
															14.287
														],
														[
															39.819,
															12.32
														],
														[
															40.419,
															-2.374
														],
														[
															-0.112,
															0.008
														]
													],
													"o": [
														[
															-10.032,
															1.941
														],
														[
															-9.278,
															2.74
														],
														[
															-1.382,
															0.546
														],
														[
															-1.34,
															0.483
														],
														[
															-5.044,
															2.102
														],
														[
															-4.44,
															2.405
														],
														[
															-1.153,
															0.626
														],
														[
															-1.185,
															0.432
														],
														[
															-3.347,
															1.945
														],
														[
															-3.158,
															2.006
														],
														[
															-3.154,
															2.12
														],
														[
															-3.217,
															2.384
														],
														[
															-0.147,
															0.066
														],
														[
															-0.173,
															0.452
														],
														[
															-2.759,
															2.112
														],
														[
															-2.209,
															1.946
														],
														[
															-1.903,
															1.665
														],
														[
															-1.824,
															1.65
														],
														[
															-10.398,
															10.016
														],
														[
															-9.09,
															11.439
														],
														[
															-4.584,
															7.74
														],
														[
															-4.328,
															8.78
														],
														[
															-0.677,
															1.776
														],
														[
															-0.47,
															1.273
														],
														[
															-0.817,
															2.082
														],
														[
															-0.67,
															1.824
														],
														[
															-0.87,
															2.804
														],
														[
															-0.584,
															2.818
														],
														[
															-1.453,
															5.359
														],
														[
															-1.392,
															5.462
														],
														[
															-4.05,
															23.999
														],
														[
															1.145,
															25.552
														],
														[
															3.461,
															13.161
														],
														[
															4.748,
															12.513
														],
														[
															1.137,
															2.211
														],
														[
															1.391,
															2.142
														],
														[
															1.254,
															2.145
														],
														[
															1.111,
															2.202
														],
														[
															1.556,
															2.447
														],
														[
															1.607,
															2.325
														],
														[
															0.07,
															0.154
														],
														[
															0.451,
															0.168
														],
														[
															1.175,
															1.635
														],
														[
															0.958,
															1.512
														],
														[
															1.127,
															1.494
														],
														[
															1.255,
															1.378
														],
														[
															0.446,
															0.519
														],
														[
															0.266,
															0.723
														],
														[
															1.52,
															1.827
														],
														[
															1.715,
															1.616
														],
														[
															1.782,
															1.878
														],
														[
															1.62,
															1.845
														],
														[
															13.838,
															13.894
														],
														[
															16.769,
															11.482
														],
														[
															0.576,
															0.247
														],
														[
															0.489,
															0.391
														],
														[
															1.125,
															0.452
														],
														[
															1.402,
															0.265
														],
														[
															0.347,
															0.134
														],
														[
															0.541,
															0.418
														],
														[
															6.123,
															2.402
														],
														[
															6.923,
															1.814
														],
														[
															8.986,
															1.947
														],
														[
															9.919,
															1.439
														],
														[
															3.68,
															0.106
														],
														[
															4.282,
															-0.148
														],
														[
															0.689,
															-0.162
														],
														[
															0.222,
															-0.368
														],
														[
															2.079,
															-1.802
														],
														[
															1.446,
															-2.129
														],
														[
															1.899,
															-0.413
														],
														[
															1.82,
															-0.08
														],
														[
															4.99,
															-0.727
														],
														[
															4.013,
															-0.84
														],
														[
															16.582,
															-3.827
														],
														[
															14.071,
															-5.689
														],
														[
															16.386,
															-9.255
														],
														[
															14.659,
															-12.239
														],
														[
															9.555,
															-11.796
														],
														[
															8.579,
															-13.433
														],
														[
															9.403,
															-22.214
														],
														[
															5.139,
															-26.466
														],
														[
															-1.153,
															-18.785
														],
														[
															-0.708,
															-3.165
														],
														[
															-0.554,
															-2.288
														],
														[
															-1.491,
															-5.395
														],
														[
															-1.932,
															-5.868
														],
														[
															-4.317,
															-11.001
														],
														[
															-3.335,
															-6.107
														],
														[
															-0.154,
															-0.34
														],
														[
															-1.443,
															-2.367
														],
														[
															-2.91,
															-3.038
														],
														[
															-0.803,
															-0.838
														],
														[
															-2.192,
															-2.288
														],
														[
															-1.545,
															-1.995
														],
														[
															-14.703,
															-18.725
														],
														[
															-29.754,
															-23.843
														],
														[
															-30.635,
															-9.479
														],
														[
															-0.628,
															0.037
														],
														[
															-12.675,
															0.879
														]
													],
													"v": [
														[
															305,
															30
														],
														[
															275.866,
															37.13
														],
														[
															250,
															46
														],
														[
															245.907,
															47.516
														],
														[
															242,
															49
														],
														[
															227.865,
															55.867
														],
														[
															215,
															63
														],
														[
															211.467,
															64.487
														],
														[
															208,
															66
														],
														[
															198.257,
															71.934
														],
														[
															189,
															78
														],
														[
															179.369,
															85.083
														],
														[
															170,
															91
														],
														[
															169.511,
															91.957
														],
														[
															169,
															93
														],
														[
															161.735,
															99.005
														],
														[
															155,
															105
														],
														[
															149.423,
															109.948
														],
														[
															144,
															115
														],
														[
															114.634,
															147.34
														],
														[
															90,
															183
														],
														[
															76.388,
															208.2
														],
														[
															65,
															234
														],
														[
															63.326,
															238.483
														],
														[
															62,
															242
														],
														[
															59.764,
															247.846
														],
														[
															58,
															253
														],
														[
															55.942,
															261.411
														],
														[
															54,
															270
														],
														[
															49.644,
															286.176
														],
														[
															46,
															303
														],
														[
															41.861,
															378.903
														],
														[
															52,
															450
														],
														[
															64.436,
															488.78
														],
														[
															80,
															524
														],
														[
															83.879,
															530.494
														],
														[
															88,
															537
														],
														[
															91.465,
															543.575
														],
														[
															95,
															550
														],
														[
															99.905,
															557.144
														],
														[
															104,
															564
														],
														[
															104.959,
															564.486
														],
														[
															106,
															565
														],
														[
															109.136,
															569.738
														],
														[
															112,
															574
														],
														[
															115.707,
															578.375
														],
														[
															119,
															582
														],
														[
															119.967,
															583.949
														],
														[
															121,
															586
														],
														[
															125.925,
															591.09
														],
														[
															131,
															596
														],
														[
															136.034,
															601.601
														],
														[
															141,
															607
														],
														[
															187.064,
															645.285
														],
														[
															241,
															675
														],
														[
															242.581,
															676.044
														],
														[
															244,
															677
														],
														[
															247.894,
															677.974
														],
														[
															252,
															679
														],
														[
															253.392,
															679.956
														],
														[
															255,
															681
														],
														[
															274.953,
															687.297
														],
														[
															295,
															692
														],
														[
															323.486,
															697.237
														],
														[
															354,
															700
														],
														[
															366.616,
															699.966
														],
														[
															377,
															699
														],
														[
															378.199,
															698.154
														],
														[
															379,
															697
														],
														[
															383.706,
															690.662
														],
														[
															390,
															686
														],
														[
															395.56,
															685.389
														],
														[
															401,
															685
														],
														[
															414.274,
															682.639
														],
														[
															426,
															680
														],
														[
															471.586,
															665.694
														],
														[
															512,
															646
														],
														[
															558.806,
															613.649
														],
														[
															599,
															573
														],
														[
															626.572,
															535.007
														],
														[
															649,
															493
														],
														[
															671.522,
															420.283
														],
														[
															677,
															333
														],
														[
															669,
															281
														],
														[
															668,
															272
														],
														[
															665,
															265
														],
														[
															661,
															249
														],
														[
															654,
															231
														],
														[
															640,
															200
														],
														[
															631,
															182
														],
														[
															629,
															181
														],
														[
															625,
															173
														],
														[
															617,
															161
														],
														[
															615,
															158
														],
														[
															609,
															151
														],
														[
															605,
															145
														],
														[
															555,
															95
														],
														[
															451,
															39
														],
														[
															344,
															25
														],
														[
															343,
															26
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 98,
											"s": [
												{
													"i": [
														[
															13.099,
															-2.528
														],
														[
															5.608,
															-1.348
														],
														[
															4.97,
															-1.526
														],
														[
															10.924,
															-4.834
														],
														[
															8.876,
															-4.849
														],
														[
															1.565,
															-0.712
														],
														[
															0.494,
															-0.473
														],
														[
															0.859,
															-0.442
														],
														[
															0.756,
															-0.458
														],
														[
															1.627,
															-0.986
														],
														[
															0.436,
															-0.417
														],
														[
															0.539,
															-0.298
														],
														[
															0.425,
															-0.407
														],
														[
															0.282,
															-0.073
														],
														[
															0.488,
															-0.343
														],
														[
															0.789,
															-0.921
														],
														[
															0.947,
															-0.684
														],
														[
															0.384,
															0.067
														],
														[
															0.247,
															-0.112
														],
														[
															0.163,
															-0.451
														],
														[
															0.185,
															-0.124
														],
														[
															0.511,
															-0.23
														],
														[
															0.327,
															-0.249
														],
														[
															2.13,
															-0.96
														],
														[
															0.806,
															-0.675
														],
														[
															1.776,
															-1.524
														],
														[
															1.806,
															-1.606
														],
														[
															1.803,
															-1.803
														],
														[
															6.55,
															-7.428
														],
														[
															15.694,
															-41.851
														],
														[
															-2.473,
															-53.152
														],
														[
															-1.9,
															-11.698
														],
														[
															-20.117,
															-33.817
														],
														[
															-30.267,
															-24.353
														],
														[
															-8.57,
															-3.863
														],
														[
															-0.37,
															-0.247
														],
														[
															-0.511,
															-0.23
														],
														[
															-0.37,
															-0.247
														],
														[
															-0.511,
															-0.23
														],
														[
															-0.37,
															-0.247
														],
														[
															-0.511,
															-0.23
														],
														[
															-0.394,
															-0.243
														],
														[
															-2.094,
															-1.183
														],
														[
															-2.298,
															-1.251
														],
														[
															-59.844,
															-1.21
														],
														[
															-3.634,
															1.12
														],
														[
															-1.915,
															1.808
														],
														[
															-6.521,
															1.557
														],
														[
															-3.235,
															0.472
														],
														[
															-7.92,
															1.836
														],
														[
															-14.013,
															5.452
														],
														[
															-4.764,
															2.172
														],
														[
															-8.962,
															4.917
														],
														[
															-0.021,
															0.021
														],
														[
															-1.176,
															0.699
														],
														[
															-5.249,
															2.366
														],
														[
															-0.346,
															0.249
														],
														[
															-4.771,
															3.601
														],
														[
															-1.986,
															1.702
														],
														[
															-1.209,
															0.994
														],
														[
															-3.529,
															3.095
														],
														[
															-1.786,
															1.626
														],
														[
															-4.567,
															4.948
														],
														[
															-1.62,
															1.854
														],
														[
															-1.289,
															2.859
														],
														[
															-0.246,
															0.296
														],
														[
															-1.318,
															2.925
														],
														[
															-0.249,
															0.346
														],
														[
															-12.406,
															32.752
														],
														[
															4.018,
															53.776
														],
														[
															6.29,
															21.51
														],
														[
															4.766,
															12.147
														],
														[
															0.433,
															0.985
														],
														[
															2.409,
															4.878
														],
														[
															3.85,
															8.541
														],
														[
															0.247,
															0.37
														],
														[
															0.23,
															0.511
														],
														[
															0.247,
															0.37
														],
														[
															0.23,
															0.511
														],
														[
															0.247,
															0.37
														],
														[
															0.23,
															0.511
														],
														[
															0.247,
															0.369
														],
														[
															0.23,
															0.51
														],
														[
															0.247,
															0.37
														],
														[
															0.23,
															0.511
														],
														[
															0.248,
															0.363
														],
														[
															0.228,
															0.506
														],
														[
															0.248,
															0.358
														],
														[
															4.025,
															4.942
														],
														[
															6.189,
															6.599
														],
														[
															4.218,
															1.902
														],
														[
															0.295,
															0.246
														],
														[
															6.515,
															5.04
														],
														[
															9.493,
															4.279
														],
														[
															0.399,
															0.241
														],
														[
															0.992,
															0.95
														],
														[
															1.176,
															0.699
														],
														[
															8.323,
															3.902
														],
														[
															60.197,
															-3.199
														],
														[
															-0.115,
															0.007
														]
													],
													"o": [
														[
															-5.6,
															1.081
														],
														[
															-5.608,
															1.348
														],
														[
															-12.425,
															3.816
														],
														[
															-10.924,
															4.834
														],
														[
															-1.245,
															0.68
														],
														[
															-1.565,
															0.712
														],
														[
															-0.807,
															0.773
														],
														[
															-0.859,
															0.442
														],
														[
															-1.057,
															0.639
														],
														[
															-1.627,
															0.986
														],
														[
															-0.419,
															0.401
														],
														[
															-0.539,
															0.298
														],
														[
															-0.382,
															0.367
														],
														[
															-0.282,
															0.073
														],
														[
															-0.899,
															0.632
														],
														[
															-0.789,
															0.921
														],
														[
															-0.216,
															0.156
														],
														[
															-0.384,
															-0.067
														],
														[
															-0.162,
															0.073
														],
														[
															-0.163,
															0.451
														],
														[
															-0.46,
															0.307
														],
														[
															-0.296,
															0.134
														],
														[
															-2.794,
															2.123
														],
														[
															-1.065,
															0.48
														],
														[
															-1.874,
															1.57
														],
														[
															-1.898,
															1.63
														],
														[
															-1.898,
															1.687
														],
														[
															-6.96,
															6.96
														],
														[
															-25.653,
															29.093
														],
														[
															-15.11,
															40.294
														],
														[
															0.576,
															12.386
														],
														[
															7.736,
															47.64
														],
														[
															20.754,
															34.888
														],
														[
															7.722,
															6.213
														],
														[
															0.324,
															0.146
														],
														[
															0.46,
															0.307
														],
														[
															0.324,
															0.146
														],
														[
															0.46,
															0.307
														],
														[
															0.324,
															0.146
														],
														[
															0.46,
															0.307
														],
														[
															0.339,
															0.153
														],
														[
															2.05,
															1.264
														],
														[
															2.402,
															1.357
														],
														[
															38.78,
															21.122
														],
														[
															6.372,
															0.129
														],
														[
															3.813,
															-1.176
														],
														[
															4.328,
															-4.088
														],
														[
															3.533,
															-0.844
														],
														[
															9.966,
															-1.453
														],
														[
															16.604,
															-3.849
														],
														[
															4.797,
															-1.866
														],
														[
															9.353,
															-4.265
														],
														[
															-0.122,
															0.067
														],
														[
															0.854,
															-0.819
														],
														[
															5.607,
															-3.332
														],
														[
															0.309,
															-0.139
														],
														[
															5.035,
															-3.619
														],
														[
															2.987,
															-2.255
														],
														[
															1.285,
															-1.101
														],
														[
															3.542,
															-2.912
														],
														[
															1.846,
															-1.619
														],
														[
															5.32,
															-4.845
														],
														[
															1.642,
															-1.78
														],
														[
															2.539,
															-2.907
														],
														[
															0.124,
															-0.274
														],
														[
															2.725,
															-3.27
														],
														[
															0.139,
															-0.309
														],
														[
															19.209,
															-26.727
														],
														[
															14.883,
															-39.289
														],
														[
															-1.82,
															-24.355
														],
														[
															-4.083,
															-13.961
														],
														[
															-0.481,
															-1.225
														],
														[
															-2.201,
															-5.005
														],
														[
															-4.458,
															-9.029
														],
														[
															-0.146,
															-0.324
														],
														[
															-0.307,
															-0.46
														],
														[
															-0.146,
															-0.324
														],
														[
															-0.307,
															-0.46
														],
														[
															-0.146,
															-0.324
														],
														[
															-0.307,
															-0.46
														],
														[
															-0.146,
															-0.324
														],
														[
															-0.307,
															-0.459
														],
														[
															-0.146,
															-0.324
														],
														[
															-0.307,
															-0.46
														],
														[
															-0.144,
															-0.319
														],
														[
															-0.309,
															-0.452
														],
														[
															-0.143,
															-0.316
														],
														[
															-3.827,
															-5.522
														],
														[
															-6.237,
															-7.658
														],
														[
															-3.9,
															-4.159
														],
														[
															-0.274,
															-0.124
														],
														[
															-6.748,
															-5.623
														],
														[
															-8.665,
															-6.703
														],
														[
															-0.342,
															-0.154
														],
														[
															-2.299,
															-1.389
														],
														[
															-0.854,
															-0.818
														],
														[
															-7.668,
															-4.556
														],
														[
															-39.999,
															-18.753
														],
														[
															-0.629,
															0.033
														],
														[
															-12.917,
															0.832
														]
													],
													"v": [
														[
															304,
															30
														],
														[
															287.028,
															33.666
														],
														[
															271,
															38
														],
														[
															235.838,
															51.226
														],
														[
															206,
															66
														],
														[
															201.437,
															68.155
														],
														[
															198,
															70
														],
														[
															195.462,
															71.737
														],
														[
															193,
															73
														],
														[
															188.534,
															75.667
														],
														[
															185,
															78
														],
														[
															183.505,
															78.995
														],
														[
															182,
															80
														],
														[
															181.079,
															80.518
														],
														[
															180,
															81
														],
														[
															177.536,
															83.461
														],
														[
															175,
															86
														],
														[
															174.023,
															86.034
														],
														[
															173,
															86
														],
														[
															172.517,
															86.962
														],
														[
															172,
															88
														],
														[
															170,
															88
														],
														[
															169,
															90
														],
														[
															161,
															95
														],
														[
															157,
															99
														],
														[
															152,
															104
														],
														[
															146,
															108
														],
														[
															141,
															114
														],
														[
															120,
															135
														],
														[
															58,
															238
														],
														[
															35,
															380
														],
														[
															39,
															417
														],
														[
															83,
															538
														],
														[
															159,
															627
														],
														[
															184,
															645
														],
														[
															185,
															647
														],
														[
															187,
															647
														],
														[
															188,
															649
														],
														[
															190,
															649
														],
														[
															191,
															651
														],
														[
															193,
															651
														],
														[
															194,
															653
														],
														[
															201,
															656
														],
														[
															208,
															660
														],
														[
															355,
															700
														],
														[
															375,
															699
														],
														[
															380,
															697
														],
														[
															391,
															686
														],
														[
															402,
															685
														],
														[
															427,
															680
														],
														[
															473,
															666
														],
														[
															487,
															660
														],
														[
															515,
															647
														],
														[
															516,
															646
														],
														[
															518,
															645
														],
														[
															535,
															635
														],
														[
															536,
															633
														],
														[
															551,
															623
														],
														[
															559,
															616
														],
														[
															563,
															614
														],
														[
															573,
															604
														],
														[
															579,
															600
														],
														[
															594,
															585
														],
														[
															598,
															579
														],
														[
															604,
															572
														],
														[
															606,
															571
														],
														[
															613,
															561
														],
														[
															615,
															560
														],
														[
															663,
															472
														],
														[
															683,
															332
														],
														[
															671,
															264
														],
														[
															657,
															223
														],
														[
															655,
															220
														],
														[
															649,
															205
														],
														[
															634,
															178
														],
														[
															632,
															177
														],
														[
															632,
															175
														],
														[
															630,
															174
														],
														[
															630,
															172
														],
														[
															628,
															171
														],
														[
															628,
															169
														],
														[
															626,
															168
														],
														[
															626,
															166
														],
														[
															624,
															165
														],
														[
															624,
															163
														],
														[
															622,
															162
														],
														[
															622,
															160
														],
														[
															620,
															159
														],
														[
															609,
															144
														],
														[
															590,
															123
														],
														[
															578,
															112
														],
														[
															577,
															110
														],
														[
															558,
															94
														],
														[
															530,
															75
														],
														[
															529,
															73
														],
														[
															521,
															69
														],
														[
															519,
															68
														],
														[
															496,
															56
														],
														[
															344,
															25
														],
														[
															343,
															26
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 99,
											"s": [
												{
													"i": [
														[
															13.089,
															-2.476
														],
														[
															19.821,
															-8.077
														],
														[
															16.072,
															-10.219
														],
														[
															2.429,
															-1.66
														],
														[
															1.969,
															-0.888
														],
														[
															0.163,
															-0.451
														],
														[
															0.185,
															-0.124
														],
														[
															0.379,
															0.067
														],
														[
															0.255,
															-0.115
														],
														[
															0.171,
															-0.452
														],
														[
															0.167,
															-0.124
														],
														[
															1.364,
															-0.861
														],
														[
															1.158,
															-0.522
														],
														[
															0.168,
															-0.451
														],
														[
															0.173,
															-0.124
														],
														[
															0.983,
															-0.604
														],
														[
															0.868,
															-0.724
														],
														[
															1.75,
															-1.886
														],
														[
															1.293,
															-1.032
														],
														[
															0.716,
															-0.256
														],
														[
															0.587,
															-0.537
														],
														[
															3.144,
															-3.173
														],
														[
															2.413,
															-2.555
														],
														[
															0.265,
															-0.743
														],
														[
															0.517,
															-0.582
														],
														[
															1.719,
															-1.586
														],
														[
															1.508,
															-1.841
														],
														[
															1.497,
															-2.045
														],
														[
															1.501,
															-1.974
														],
														[
															2.826,
															-4.171
														],
														[
															2.668,
															-4.335
														],
														[
															3.522,
															-6.258
														],
														[
															2.564,
															-5.526
														],
														[
															0.104,
															-0.93
														],
														[
															0.291,
															-0.649
														],
														[
															1.255,
															-2.309
														],
														[
															0.948,
															-2.467
														],
														[
															4.106,
															-24.156
														],
														[
															-1.256,
															-27.009
														],
														[
															-2.1,
															-11.843
														],
														[
															-3.01,
															-10.975
														],
														[
															-4.393,
															-11.421
														],
														[
															-5.155,
															-9.385
														],
														[
															-1.767,
															-3.292
														],
														[
															-1.938,
															-3.202
														],
														[
															-5.815,
															-8.022
														],
														[
															-6.443,
															-7.161
														],
														[
															-3.68,
															-4.131
														],
														[
															-3.955,
															-1.783
														],
														[
															-0.179,
															-0.454
														],
														[
															-0.148,
															-0.123
														],
														[
															-1.286,
															-1.132
														],
														[
															-1.313,
															-1.187
														],
														[
															-9.627,
															-6.442
														],
														[
															-0.936,
															-0.897
														],
														[
															-0.85,
															-0.815
														],
														[
															-0.85,
															-0.815
														],
														[
															-1.51,
															-0.918
														],
														[
															-14.861,
															-5.831
														],
														[
															-14.238,
															-3.431
														],
														[
															-25.778,
															-0.637
														],
														[
															-3.571,
															3.206
														],
														[
															-1.96,
															1.848
														],
														[
															-1.273,
															0.847
														],
														[
															-7.245,
															1.299
														],
														[
															-5.112,
															1.116
														],
														[
															-14.524,
															5.604
														],
														[
															-35.342,
															40.677
														],
														[
															-14.425,
															45.024
														],
														[
															-1.45,
															5.437
														],
														[
															-0.125,
															0.562
														],
														[
															-0.367,
															1.583
														],
														[
															-1.305,
															8.531
														],
														[
															11.793,
															40.636
														],
														[
															0.702,
															2.284
														],
														[
															3.258,
															7.602
														],
														[
															1.016,
															2.371
														],
														[
															2.899,
															5.588
														],
														[
															1.222,
															2.224
														],
														[
															0.924,
															0.965
														],
														[
															0.925,
															1.506
														],
														[
															8.422,
															10.485
														],
														[
															0.959,
															2.128
														],
														[
															1.013,
															1.269
														],
														[
															1.075,
															1.174
														],
														[
															7.145,
															6.701
														],
														[
															4.039,
															1.82
														],
														[
															0.295,
															0.246
														],
														[
															2.925,
															1.319
														],
														[
															0.346,
															0.249
														],
														[
															4.544,
															3.041
														],
														[
															1.049,
															1.005
														],
														[
															0.85,
															0.814
														],
														[
															2.549,
															1.476
														],
														[
															3.01,
															1.547
														],
														[
															1.056,
															0.545
														],
														[
															4.875,
															2.206
														],
														[
															28.375,
															5.355
														],
														[
															26.637,
															-1.416
														],
														[
															-0.115,
															0.007
														]
													],
													"o": [
														[
															-23.646,
															4.474
														],
														[
															-19.821,
															8.077
														],
														[
															-2.315,
															1.472
														],
														[
															-2.429,
															1.66
														],
														[
															-0.162,
															0.073
														],
														[
															-0.163,
															0.451
														],
														[
															-0.23,
															0.154
														],
														[
															-0.379,
															-0.067
														],
														[
															-0.15,
															0.068
														],
														[
															-0.171,
															0.452
														],
														[
															-1.387,
															1.033
														],
														[
															-1.364,
															0.861
														],
														[
															-0.154,
															0.07
														],
														[
															-0.168,
															0.451
														],
														[
															-1.2,
															0.862
														],
														[
															-0.983,
															0.604
														],
														[
															-1.709,
															1.423
														],
														[
															-1.75,
															1.886
														],
														[
															-0.55,
															0.439
														],
														[
															-0.716,
															0.256
														],
														[
															-3.008,
															2.754
														],
														[
															-3.145,
															3.173
														],
														[
															-0.421,
															0.445
														],
														[
															-0.266,
															0.743
														],
														[
															-1.615,
															1.815
														],
														[
															-1.719,
															1.586
														],
														[
															-1.511,
															1.846
														],
														[
															-1.497,
															2.045
														],
														[
															-3.026,
															3.982
														],
														[
															-2.826,
															4.171
														],
														[
															-3.35,
															5.442
														],
														[
															-3.522,
															6.258
														],
														[
															-0.293,
															0.63
														],
														[
															-0.104,
															0.93
														],
														[
															-1.032,
															2.298
														],
														[
															-1.255,
															2.309
														],
														[
															-7.832,
															20.367
														],
														[
															-4.106,
															24.156
														],
														[
															0.588,
															12.653
														],
														[
															2.1,
															11.843
														],
														[
															3.273,
															11.931
														],
														[
															4.393,
															11.421
														],
														[
															1.995,
															3.631
														],
														[
															1.767,
															3.292
														],
														[
															5.297,
															8.753
														],
														[
															5.815,
															8.022
														],
														[
															3.323,
															3.694
														],
														[
															3.68,
															4.131
														],
														[
															0.137,
															0.062
														],
														[
															0.179,
															0.454
														],
														[
															1.543,
															1.285
														],
														[
															1.286,
															1.132
														],
														[
															9.137,
															8.254
														],
														[
															2.169,
															1.452
														],
														[
															0.838,
															0.803
														],
														[
															0.838,
															0.803
														],
														[
															1.614,
															1.546
														],
														[
															13.406,
															8.147
														],
														[
															14.072,
															5.522
														],
														[
															21.592,
															5.203
														],
														[
															9.624,
															0.238
														],
														[
															1.13,
															-1.015
														],
														[
															1.917,
															-1.808
														],
														[
															5.597,
															-3.724
														],
														[
															5.574,
															-1
														],
														[
															17.275,
															-3.77
														],
														[
															53.54,
															-20.657
														],
														[
															26.946,
															-31.014
														],
														[
															1.641,
															-5.122
														],
														[
															0.111,
															-0.415
														],
														[
															0.353,
															-1.587
														],
														[
															2.022,
															-8.714
														],
														[
															7.451,
															-48.706
														],
														[
															-0.704,
															-2.425
														],
														[
															-2.923,
															-9.513
														],
														[
															-1.17,
															-2.731
														],
														[
															-2.502,
															-5.838
														],
														[
															-1.105,
															-2.131
														],
														[
															-1.342,
															-2.443
														],
														[
															-1.547,
															-1.615
														],
														[
															-7.785,
															-12.674
														],
														[
															-1.833,
															-2.282
														],
														[
															-1.021,
															-2.265
														],
														[
															-0.878,
															-1.1
														],
														[
															-6.38,
															-6.969
														],
														[
															-3.804,
															-3.567
														],
														[
															-0.274,
															-0.124
														],
														[
															-3.27,
															-2.725
														],
														[
															-0.309,
															-0.139
														],
														[
															-5.199,
															-3.737
														],
														[
															-2.305,
															-1.543
														],
														[
															-0.838,
															-0.803
														],
														[
															-2.437,
															-2.335
														],
														[
															-3.299,
															-1.91
														],
														[
															-1.274,
															-0.655
														],
														[
															-4.442,
															-2.294
														],
														[
															-23.662,
															-10.706
														],
														[
															-23.229,
															-4.384
														],
														[
															-0.629,
															0.033
														],
														[
															-12.882,
															0.829
														]
													],
													"v": [
														[
															303,
															30
														],
														[
															237.819,
															49.191
														],
														[
															184,
															77
														],
														[
															176.74,
															81.939
														],
														[
															170,
															86
														],
														[
															169.517,
															86.962
														],
														[
															169,
															88
														],
														[
															168.019,
															88.029
														],
														[
															167,
															88
														],
														[
															166.512,
															88.958
														],
														[
															166,
															90
														],
														[
															161.828,
															92.883
														],
														[
															158,
															95
														],
														[
															157.514,
															95.959
														],
														[
															157,
															97
														],
														[
															153.751,
															99.104
														],
														[
															151,
															101
														],
														[
															145.688,
															106.294
														],
														[
															141,
															111
														],
														[
															139.028,
															111.926
														],
														[
															137,
															113
														],
														[
															127.554,
															122.149
														],
														[
															119,
															131
														],
														[
															118.073,
															132.898
														],
														[
															117,
															135
														],
														[
															111.92,
															139.98
														],
														[
															107,
															145
														],
														[
															102.492,
															150.904
														],
														[
															98,
															157
														],
														[
															89.231,
															169.235
														],
														[
															81,
															182
														],
														[
															70.41,
															199.937
														],
														[
															61,
															218
														],
														[
															60.499,
															220.486
														],
														[
															60,
															223
														],
														[
															56.438,
															229.873
														],
														[
															53,
															237
														],
														[
															34.684,
															304.018
														],
														[
															30,
															381
														],
														[
															34.184,
															417.758
														],
														[
															42,
															452
														],
														[
															53.588,
															487.41
														],
														[
															68,
															519
														],
														[
															73.543,
															529.322
														],
														[
															79,
															539
														],
														[
															95.64,
															564.193
														],
														[
															114,
															587
														],
														[
															124.526,
															599.434
														],
														[
															136,
															609
														],
														[
															136.492,
															609.954
														],
														[
															137,
															611
														],
														[
															141.172,
															614.574
														],
														[
															145,
															618
														],
														[
															174,
															641
														],
														[
															182,
															646
														],
														[
															185,
															648
														],
														[
															188,
															650
														],
														[
															193,
															653
														],
														[
															238,
															676
														],
														[
															281,
															690
														],
														[
															355,
															700
														],
														[
															381,
															697
														],
														[
															384,
															692
														],
														[
															388,
															688
														],
														[
															412,
															684
														],
														[
															428,
															680
														],
														[
															475,
															666
														],
														[
															607,
															574
														],
														[
															673,
															457
														],
														[
															677,
															441
														],
														[
															679,
															438
														],
														[
															679,
															433
														],
														[
															685,
															408
														],
														[
															676,
															262
														],
														[
															673,
															255
														],
														[
															664,
															229
														],
														[
															661,
															222
														],
														[
															653,
															204
														],
														[
															649,
															198
														],
														[
															645,
															190
														],
														[
															642,
															185
														],
														[
															617,
															149
														],
														[
															612,
															142
														],
														[
															605,
															136
														],
														[
															603,
															132
														],
														[
															582,
															112
														],
														[
															570,
															102
														],
														[
															569,
															100
														],
														[
															559,
															93
														],
														[
															558,
															91
														],
														[
															543,
															81
														],
														[
															535,
															76
														],
														[
															532,
															74
														],
														[
															524,
															69
														],
														[
															514,
															64
														],
														[
															511,
															61
														],
														[
															497,
															55
														],
														[
															420,
															30
														],
														[
															343,
															25
														],
														[
															342,
															26
														]
													],
													"c": true
												}
											],
											"h": 1
										},
										{
											"t": 100,
											"s": [
												{
													"i": [
														[
															6.505,
															-1.166
														],
														[
															24.181,
															-10.96
														],
														[
															18.82,
															-14.879
														],
														[
															18.004,
															-23.321
														],
														[
															12.065,
															-30.807
														],
														[
															4.183,
															-24.059
														],
														[
															-1.675,
															-26.477
														],
														[
															-1.764,
															-11.938
														],
														[
															-3.105,
															-10.949
														],
														[
															-3.819,
															-10.221
														],
														[
															-4.635,
															-9.22
														],
														[
															-19.769,
															-22.252
														],
														[
															-24.97,
															-16.238
														],
														[
															-29.446,
															-9.7
														],
														[
															-36.678,
															-0.543
														],
														[
															-4.481,
															0.117
														],
														[
															-1.799,
															0.581
														],
														[
															-0.275,
															0.375
														],
														[
															-0.373,
															0.327
														],
														[
															-0.842,
															1.112
														],
														[
															-0.592,
															0.635
														],
														[
															-0.115,
															0.624
														],
														[
															-0.282,
															0.226
														],
														[
															-2.79,
															0.355
														],
														[
															-2.246,
															0.305
														],
														[
															-4.176,
															0.854
														],
														[
															-4.145,
															0.887
														],
														[
															-2.832,
															0.404
														],
														[
															-2.801,
															0.772
														],
														[
															-1.126,
															0.57
														],
														[
															-1.264,
															0.38
														],
														[
															-14.182,
															6.359
														],
														[
															-12.123,
															7.699
														],
														[
															-1.615,
															0.97
														],
														[
															-0.44,
															0.421
														],
														[
															-0.539,
															0.298
														],
														[
															-0.425,
															0.408
														],
														[
															-0.282,
															0.073
														],
														[
															-0.487,
															0.343
														],
														[
															-0.827,
															0.947
														],
														[
															-0.831,
															0.607
														],
														[
															-0.385,
															-0.067
														],
														[
															-0.246,
															0.111
														],
														[
															-0.168,
															0.452
														],
														[
															-0.173,
															0.125
														],
														[
															-1.904,
															1.247
														],
														[
															-1.571,
															0.708
														],
														[
															-0.766,
															0.856
														],
														[
															-0.403,
															0.337
														],
														[
															-0.806,
															0.872
														],
														[
															-0.913,
															0.79
														],
														[
															-1.058,
															0.615
														],
														[
															-0.848,
															0.74
														],
														[
															-0.776,
															1.062
														],
														[
															-0.909,
															0.891
														],
														[
															-3.243,
															2.916
														],
														[
															-2.188,
															2.553
														],
														[
															-0.259,
															0.723
														],
														[
															-0.551,
															0.628
														],
														[
															-1.812,
															1.958
														],
														[
															-0.954,
															2.117
														],
														[
															-0.454,
															0.179
														],
														[
															-0.123,
															0.148
														],
														[
															-3.71,
															5.644
														],
														[
															-3.664,
															6.03
														],
														[
															-8.639,
															31.88
														],
														[
															2.133,
															39.851
														],
														[
															4.134,
															16.834
														],
														[
															5.458,
															13.867
														],
														[
															3.135,
															6.756
														],
														[
															2.769,
															6.143
														],
														[
															0.451,
															0.155
														],
														[
															0.119,
															0.206
														],
														[
															0.824,
															1.78
														],
														[
															0.726,
															1.183
														],
														[
															0.52,
															0.919
														],
														[
															0.304,
															0.317
														],
														[
															0.298,
															0.539
														],
														[
															0.408,
															0.425
														],
														[
															0.298,
															0.539
														],
														[
															0.408,
															0.425
														],
														[
															0.298,
															0.539
														],
														[
															0.408,
															0.425
														],
														[
															0.071,
															0.279
														],
														[
															0.345,
															0.498
														],
														[
															0.918,
															0.787
														],
														[
															0.661,
															0.891
														],
														[
															-0.067,
															0.386
														],
														[
															0.11,
															0.245
														],
														[
															0.451,
															0.166
														],
														[
															0.124,
															0.179
														],
														[
															6.916,
															7.667
														],
														[
															8.292,
															7.611
														],
														[
															16.784,
															10.525
														],
														[
															19.952,
															8.127
														],
														[
															23.411,
															4.379
														],
														[
															27.811,
															-1.478
														],
														[
															0.186,
															-0.247
														],
														[
															-0.058,
															0.004
														],
														[
															6.479,
															-0.603
														]
													],
													"o": [
														[
															-29.457,
															5.283
														],
														[
															-24.18,
															10.96
														],
														[
															-23.921,
															18.91
														],
														[
															-18.004,
															23.321
														],
														[
															-7.944,
															20.286
														],
														[
															-4.183,
															24.059
														],
														[
															0.841,
															13.299
														],
														[
															1.764,
															11.938
														],
														[
															3.09,
															10.898
														],
														[
															3.819,
															10.221
														],
														[
															13.954,
															27.755
														],
														[
															19.769,
															22.252
														],
														[
															22.538,
															14.657
														],
														[
															29.446,
															9.7
														],
														[
															3.279,
															0.048
														],
														[
															4.481,
															-0.117
														],
														[
															0.528,
															-0.17
														],
														[
															0.275,
															-0.375
														],
														[
															1.042,
															-0.916
														],
														[
															0.842,
															-1.112
														],
														[
															0.26,
															-0.279
														],
														[
															0.115,
															-0.624
														],
														[
															1.594,
															-1.276
														],
														[
															2.79,
															-0.355
														],
														[
															5.149,
															-0.698
														],
														[
															4.176,
															-0.854
														],
														[
															2.87,
															-0.613
														],
														[
															2.832,
															-0.404
														],
														[
															1.231,
															-0.339
														],
														[
															1.126,
															-0.57
														],
														[
															16.148,
															-4.865
														],
														[
															14.182,
															-6.359
														],
														[
															1.101,
															-0.699
														],
														[
															1.615,
															-0.97
														],
														[
															0.419,
															-0.401
														],
														[
															0.539,
															-0.298
														],
														[
															0.383,
															-0.366
														],
														[
															0.282,
															-0.073
														],
														[
															0.863,
															-0.607
														],
														[
															0.827,
															-0.947
														],
														[
															0.215,
															-0.157
														],
														[
															0.385,
															0.067
														],
														[
															0.154,
															-0.07
														],
														[
															0.168,
															-0.451
														],
														[
															1.815,
															-1.304
														],
														[
															1.904,
															-1.247
														],
														[
															0.533,
															-0.24
														],
														[
															0.766,
															-0.856
														],
														[
															0.863,
															-0.723
														],
														[
															0.806,
															-0.872
														],
														[
															0.923,
															-0.798
														],
														[
															1.058,
															-0.615
														],
														[
															0.988,
															-0.863
														],
														[
															0.776,
															-1.061
														],
														[
															2.839,
															-2.783
														],
														[
															3.243,
															-2.916
														],
														[
															0.411,
															-0.481
														],
														[
															0.259,
															-0.723
														],
														[
															1.8,
															-2.052
														],
														[
															1.812,
															-1.958
														],
														[
															0.062,
															-0.137
														],
														[
															0.454,
															-0.179
														],
														[
															4.495,
															-5.394
														],
														[
															3.71,
															-5.644
														],
														[
															15.577,
															-25.63
														],
														[
															8.639,
															-31.88
														],
														[
															-1.006,
															-18.797
														],
														[
															-4.134,
															-16.834
														],
														[
															-2.689,
															-6.833
														],
														[
															-3.135,
															-6.756
														],
														[
															-0.079,
															-0.174
														],
														[
															-0.451,
															-0.155
														],
														[
															-0.979,
															-1.696
														],
														[
															-0.824,
															-1.78
														],
														[
															-0.617,
															-1.006
														],
														[
															-0.52,
															-0.919
														],
														[
															-0.401,
															-0.419
														],
														[
															-0.298,
															-0.539
														],
														[
															-0.401,
															-0.419
														],
														[
															-0.298,
															-0.539
														],
														[
															-0.401,
															-0.419
														],
														[
															-0.298,
															-0.539
														],
														[
															-0.371,
															-0.387
														],
														[
															-0.071,
															-0.279
														],
														[
															-0.667,
															-0.962
														],
														[
															-0.918,
															-0.787
														],
														[
															-0.157,
															-0.212
														],
														[
															0.067,
															-0.386
														],
														[
															-0.072,
															-0.158
														],
														[
															-0.451,
															-0.166
														],
														[
															-6.044,
															-8.722
														],
														[
															-6.916,
															-7.667
														],
														[
															-13.913,
															-12.771
														],
														[
															-16.784,
															-10.525
														],
														[
															-19.546,
															-7.962
														],
														[
															-23.411,
															-4.379
														],
														[
															-0.315,
															0.017
														],
														[
															-0.186,
															0.247
														],
														[
															-6.579,
															0.424
														],
														[
															-6.479,
															0.602
														]
													],
													"v": [
														[
															303,
															30
														],
														[
															222.522,
															54.803
														],
														[
															158,
															94
														],
														[
															95.108,
															156.577
														],
														[
															50,
															237
														],
														[
															31.285,
															303.856
														],
														[
															27,
															380
														],
														[
															30.802,
															417.763
														],
														[
															38,
															452
														],
														[
															48.341,
															483.759
														],
														[
															61,
															513
														],
														[
															111.738,
															588.138
														],
														[
															179,
															646
														],
														[
															256.895,
															683.585
														],
														[
															356,
															700
														],
														[
															368.61,
															699.972
														],
														[
															379,
															699
														],
														[
															380.116,
															698.118
														],
														[
															381,
															697
														],
														[
															383.837,
															693.79
														],
														[
															386,
															691
														],
														[
															386.483,
															689.46
														],
														[
															387,
															688
														],
														[
															394.011,
															685.772
														],
														[
															402,
															685
														],
														[
															415.753,
															682.641
														],
														[
															428,
															680
														],
														[
															436.552,
															678.619
														],
														[
															445,
															677
														],
														[
															448.476,
															675.531
														],
														[
															452,
															674
														],
														[
															497.518,
															657.126
														],
														[
															537,
															636
														],
														[
															541.496,
															633.292
														],
														[
															545,
															631
														],
														[
															546.495,
															630.005
														],
														[
															548,
															629
														],
														[
															548.922,
															628.482
														],
														[
															550,
															628
														],
														[
															552.524,
															625.5
														],
														[
															555,
															623
														],
														[
															555.976,
															622.966
														],
														[
															557,
															623
														],
														[
															557.486,
															622.041
														],
														[
															558,
															621
														],
														[
															563.683,
															617.053
														],
														[
															569,
															614
														],
														[
															571.097,
															612.073
														],
														[
															573,
															610
														],
														[
															575.463,
															607.55
														],
														[
															578,
															605
														],
														[
															581.056,
															602.957
														],
														[
															584,
															601
														],
														[
															586.559,
															598.021
														],
														[
															589,
															595
														],
														[
															598.488,
															586.327
														],
														[
															607,
															578
														],
														[
															607.895,
															576.111
														],
														[
															609,
															574
														],
														[
															614.634,
															568.049
														],
														[
															619,
															562
														],
														[
															619.954,
															561.508
														],
														[
															621,
															561
														],
														[
															633.123,
															544.477
														],
														[
															644,
															527
														],
														[
															681.283,
															441.165
														],
														[
															692,
															334
														],
														[
															683.839,
															280.303
														],
														[
															669,
															234
														],
														[
															660.06,
															213.482
														],
														[
															651,
															194
														],
														[
															650.03,
															193.524
														],
														[
															649,
															193
														],
														[
															646.31,
															187.616
														],
														[
															644,
															183
														],
														[
															642.265,
															179.984
														],
														[
															641,
															178
														],
														[
															640.005,
															176.505
														],
														[
															639,
															175
														],
														[
															638.005,
															173.505
														],
														[
															637,
															172
														],
														[
															636.005,
															170.505
														],
														[
															635,
															169
														],
														[
															634.481,
															168.083
														],
														[
															634,
															167
														],
														[
															631.496,
															164.446
														],
														[
															629,
															162
														],
														[
															628.965,
															161.025
														],
														[
															629,
															160
														],
														[
															628.039,
															159.516
														],
														[
															627,
															159
														],
														[
															607.685,
															134.667
														],
														[
															585,
															112
														],
														[
															539.03,
															77.017
														],
														[
															484,
															49
														],
														[
															419.699,
															29.92
														],
														[
															343,
															25
														],
														[
															342.221,
															25.515
														],
														[
															342,
															26
														],
														[
															322.445,
															27.443
														]
													],
													"c": true
												}
											],
											"h": 1
										}
									]
								},
								"o": {
									"a": 1,
									"k": [
										{
											"t": 0,
											"s": [
												100
											],
											"h": 1
										},
										{
											"t": 27,
											"s": [
												0
											],
											"h": 1
										},
										{
											"t": 28,
											"s": [
												100
											],
											"h": 1
										},
										{
											"t": 77,
											"s": [
												0
											],
											"h": 1
										},
										{
											"t": 78,
											"s": [
												100
											],
											"h": 1
										}
									]
								},
								"x": {
									"a": 0,
									"k": 0
								},
								"nm": "Mask 2"
							}
						],
						"sw": 720,
						"sh": 720,
						"sc": "#000000",
						"ip": 0,
						"op": 101,
						"st": 0,
						"bm": 0,
						"sr": 1
					}
				]
			}
		],
		"layers": [
			{
				"ddd": 0,
				"ind": 1,
				"ty": 0,
				"nm": "logo720",
				"refId": "comp_0",
				"ks": {
					"o": {
						"a": 0,
						"k": 100
					},
					"r": {
						"a": 0,
						"k": 0
					},
					"p": {
						"a": 0,
						"k": [
							75,
							75,
							0
						]
					},
					"a": {
						"a": 0,
						"k": [
							360,
							360,
							0
						]
					},
					"s": {
						"a": 0,
						"k": [
							21,
							21,
							100
						]
					}
				},
				"ao": 0,
				"w": 720,
				"h": 720,
				"ip": 0,
				"op": 101,
				"st": 0,
				"bm": 0,
				"sr": 1
			}
		]
	};

/***/ },
/* 502 */
/***/ function(module, exports) {

	module.exports = {
		"v": "4.8.0",
		"fr": 29.9700012207031,
		"ip": 0,
		"op": 720.000029326201,
		"w": 1920,
		"h": 1080,
		"nm": "_typo 2",
		"ddd": 0,
		"assets": [
			{
				"id": "comp_0",
				"layers": [
					{
						"ddd": 0,
						"ind": 1,
						"ty": 0,
						"nm": "E",
						"refId": "comp_1",
						"ks": {
							"o": {
								"a": 0,
								"k": 100
							},
							"r": {
								"a": 0,
								"k": 0
							},
							"p": {
								"a": 0,
								"k": [
									1399,
									301.5,
									0
								]
							},
							"a": {
								"a": 0,
								"k": [
									960,
									540,
									0
								]
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100,
									100
								]
							}
						},
						"ao": 0,
						"w": 1920,
						"h": 1080,
						"ip": 0,
						"op": 601.000024479232,
						"st": 0,
						"bm": 0,
						"sr": 1
					},
					{
						"ddd": 0,
						"ind": 2,
						"ty": 0,
						"nm": "C",
						"refId": "comp_2",
						"ks": {
							"o": {
								"a": 0,
								"k": 100
							},
							"r": {
								"a": 0,
								"k": 0
							},
							"p": {
								"a": 0,
								"k": [
									725,
									301.5,
									0
								]
							},
							"a": {
								"a": 0,
								"k": [
									960,
									540,
									0
								]
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100,
									100
								]
							}
						},
						"ao": 0,
						"w": 1920,
						"h": 1080,
						"ip": 0,
						"op": 601.000024479232,
						"st": 0,
						"bm": 0,
						"sr": 1
					},
					{
						"ddd": 0,
						"ind": 3,
						"ty": 0,
						"nm": "A",
						"refId": "comp_3",
						"ks": {
							"o": {
								"a": 0,
								"k": 100
							},
							"r": {
								"a": 0,
								"k": 0
							},
							"p": {
								"a": 0,
								"k": [
									715,
									301.5,
									0
								]
							},
							"a": {
								"a": 0,
								"k": [
									960,
									540,
									0
								]
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100,
									100
								]
							}
						},
						"ao": 0,
						"ef": [
							{
								"ty": 5,
								"nm": "Curves",
								"mn": "ADBE CurvesCustom",
								"ix": 1,
								"en": 1,
								"ef": [
									{
										"ty": 7,
										"nm": "Channel:",
										"mn": "ADBE CurvesCustom-0002",
										"ix": 1,
										"v": {
											"a": 0,
											"k": 1
										}
									},
									{}
								]
							}
						],
						"w": 1920,
						"h": 1080,
						"ip": 0,
						"op": 601.000024479232,
						"st": 0,
						"bm": 0,
						"sr": 1
					},
					{
						"ddd": 0,
						"ind": 4,
						"ty": 0,
						"nm": "F",
						"refId": "comp_4",
						"ks": {
							"o": {
								"a": 0,
								"k": 100
							},
							"r": {
								"a": 0,
								"k": 0
							},
							"p": {
								"a": 0,
								"k": [
									705,
									301.5,
									0
								]
							},
							"a": {
								"a": 0,
								"k": [
									960,
									540,
									0
								]
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100,
									100
								]
							}
						},
						"ao": 0,
						"ef": [
							{
								"ty": 5,
								"nm": "Curves",
								"mn": "ADBE CurvesCustom",
								"ix": 1,
								"en": 1,
								"ef": [
									{
										"ty": 7,
										"nm": "Channel:",
										"mn": "ADBE CurvesCustom-0002",
										"ix": 1,
										"v": {
											"a": 0,
											"k": 1
										}
									},
									{}
								]
							}
						],
						"w": 1920,
						"h": 1080,
						"ip": 0,
						"op": 601.000024479232,
						"st": 0,
						"bm": 0,
						"sr": 1
					},
					{
						"ddd": 0,
						"ind": 5,
						"ty": 0,
						"nm": "R",
						"refId": "comp_5",
						"ks": {
							"o": {
								"a": 0,
								"k": 100
							},
							"r": {
								"a": 0,
								"k": 0
							},
							"p": {
								"a": 0,
								"k": [
									697,
									301.5,
									0
								]
							},
							"a": {
								"a": 0,
								"k": [
									960,
									540,
									0
								]
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100,
									100
								]
							}
						},
						"ao": 0,
						"ef": [
							{
								"ty": 5,
								"nm": "Curves",
								"mn": "ADBE CurvesCustom",
								"ix": 1,
								"en": 1,
								"ef": [
									{
										"ty": 7,
										"nm": "Channel:",
										"mn": "ADBE CurvesCustom-0002",
										"ix": 1,
										"v": {
											"a": 0,
											"k": 1
										}
									},
									{}
								]
							}
						],
						"w": 1920,
						"h": 1080,
						"ip": 0,
						"op": 601.000024479232,
						"st": 0,
						"bm": 0,
						"sr": 1
					},
					{
						"ddd": 0,
						"ind": 6,
						"ty": 0,
						"nm": "E",
						"refId": "comp_1",
						"ks": {
							"o": {
								"a": 0,
								"k": 100
							},
							"r": {
								"a": 0,
								"k": 0
							},
							"p": {
								"a": 0,
								"k": [
									687,
									301.5,
									0
								]
							},
							"a": {
								"a": 0,
								"k": [
									960,
									540,
									0
								]
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100,
									100
								]
							}
						},
						"ao": 0,
						"ef": [
							{
								"ty": 5,
								"nm": "Curves",
								"mn": "ADBE CurvesCustom",
								"ix": 1,
								"en": 1,
								"ef": [
									{
										"ty": 7,
										"nm": "Channel:",
										"mn": "ADBE CurvesCustom-0002",
										"ix": 1,
										"v": {
											"a": 0,
											"k": 1
										}
									},
									{}
								]
							}
						],
						"w": 1920,
						"h": 1080,
						"ip": 0,
						"op": 601.000024479232,
						"st": 0,
						"bm": 0,
						"sr": 1
					},
					{
						"ddd": 0,
						"ind": 7,
						"ty": 0,
						"nm": "P",
						"refId": "comp_6",
						"ks": {
							"o": {
								"a": 0,
								"k": 100
							},
							"r": {
								"a": 0,
								"k": 0
							},
							"p": {
								"a": 0,
								"k": [
									677,
									301.5,
									0
								]
							},
							"a": {
								"a": 0,
								"k": [
									960,
									540,
									0
								]
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100,
									100
								]
							}
						},
						"ao": 0,
						"ef": [
							{
								"ty": 5,
								"nm": "Curves",
								"mn": "ADBE CurvesCustom",
								"ix": 1,
								"en": 1,
								"ef": [
									{
										"ty": 7,
										"nm": "Channel:",
										"mn": "ADBE CurvesCustom-0002",
										"ix": 1,
										"v": {
											"a": 0,
											"k": 1
										}
									},
									{}
								]
							}
						],
						"w": 1920,
						"h": 1080,
						"ip": 0,
						"op": 601.000024479232,
						"st": 0,
						"bm": 0,
						"sr": 1
					},
					{
						"ddd": 0,
						"ind": 8,
						"ty": 0,
						"nm": "U",
						"refId": "comp_7",
						"ks": {
							"o": {
								"a": 0,
								"k": 100
							},
							"r": {
								"a": 0,
								"k": 0
							},
							"p": {
								"a": 0,
								"k": [
									669,
									301.5,
									0
								]
							},
							"a": {
								"a": 0,
								"k": [
									960,
									540,
									0
								]
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100,
									100
								]
							}
						},
						"ao": 0,
						"ef": [
							{
								"ty": 5,
								"nm": "Curves",
								"mn": "ADBE CurvesCustom",
								"ix": 1,
								"en": 1,
								"ef": [
									{
										"ty": 7,
										"nm": "Channel:",
										"mn": "ADBE CurvesCustom-0002",
										"ix": 1,
										"v": {
											"a": 0,
											"k": 1
										}
									},
									{}
								]
							}
						],
						"w": 1920,
						"h": 1080,
						"ip": 0,
						"op": 601.000024479232,
						"st": 0,
						"bm": 0,
						"sr": 1
					},
					{
						"ddd": 0,
						"ind": 9,
						"ty": 0,
						"nm": "S",
						"refId": "comp_8",
						"ks": {
							"o": {
								"a": 0,
								"k": 100
							},
							"r": {
								"a": 0,
								"k": 0
							},
							"p": {
								"a": 0,
								"k": [
									657,
									301.5,
									0
								]
							},
							"a": {
								"a": 0,
								"k": [
									960,
									540,
									0
								]
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100,
									100
								]
							}
						},
						"ao": 0,
						"ef": [
							{
								"ty": 5,
								"nm": "Curves",
								"mn": "ADBE CurvesCustom",
								"ix": 1,
								"en": 1,
								"ef": [
									{
										"ty": 7,
										"nm": "Channel:",
										"mn": "ADBE CurvesCustom-0002",
										"ix": 1,
										"v": {
											"a": 0,
											"k": 1
										}
									},
									{}
								]
							}
						],
						"w": 1920,
						"h": 1080,
						"ip": 0,
						"op": 601.000024479232,
						"st": 0,
						"bm": 0,
						"sr": 1
					}
				]
			},
			{
				"id": "comp_1",
				"layers": [
					{
						"ddd": 0,
						"ind": 1,
						"ty": 4,
						"nm": "E",
						"ks": {
							"o": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": [
												0.833
											],
											"y": [
												0.833
											]
										},
										"o": {
											"x": [
												0.167
											],
											"y": [
												0.167
											]
										},
										"n": [
											"0p833_0p833_0p167_0p167"
										],
										"t": 32,
										"s": [
											0
										],
										"e": [
											100
										]
									},
									{
										"t": 119.000004846969
									}
								]
							},
							"r": {
								"a": 0,
								"k": 0
							},
							"p": {
								"a": 0,
								"k": [
									389.592,
									227.534,
									0
								]
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0,
									0
								]
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100,
									100
								]
							}
						},
						"ao": 0,
						"shapes": [
							{
								"ty": "gr",
								"it": [
									{
										"ind": 0,
										"ty": "sh",
										"ix": 1,
										"ks": {
											"a": 1,
											"k": [
												{
													"i": {
														"x": 0.833,
														"y": 0.833
													},
													"o": {
														"x": 0.167,
														"y": 0.167
													},
													"n": "0p833_0p833_0p167_0p167",
													"t": 1,
													"s": [
														{
															"i": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"o": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"v": [
																[
																	-55.414,
																	71.132
																],
																[
																	56.413,
																	71.174
																],
																[
																	56.413,
																	71.247
																],
																[
																	-55.452,
																	71.122
																],
																[
																	-55.452,
																	1.927
																],
																[
																	44.104,
																	1.177
																],
																[
																	44.354,
																	1.125
																],
																[
																	-55.186,
																	1.875
																],
																[
																	-55.452,
																	1.516
																],
																[
																	-55.327,
																	-71.122
																],
																[
																	56.538,
																	-70.997
																],
																[
																	56.413,
																	-71.049
																],
																[
																	-55.414,
																	-71.091
																]
															],
															"c": true
														}
													],
													"e": [
														{
															"i": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"o": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"v": [
																[
																	-56.414,
																	71.799
																],
																[
																	56.413,
																	71.799
																],
																[
																	56.413,
																	69.747
																],
																[
																	-53.952,
																	69.747
																],
																[
																	-53.952,
																	2.052
																],
																[
																	44.104,
																	2.052
																],
																[
																	44.104,
																	0
																],
																[
																	-52.311,
																	0
																],
																[
																	-53.952,
																	1.641
																],
																[
																	-53.952,
																	-69.747
																],
																[
																	56.413,
																	-69.747
																],
																[
																	56.413,
																	-71.799
																],
																[
																	-56.414,
																	-71.799
																]
															],
															"c": true
														}
													]
												},
												{
													"i": {
														"x": 0.833,
														"y": 0.833
													},
													"o": {
														"x": 0.167,
														"y": 0.167
													},
													"n": "0p833_0p833_0p167_0p167",
													"t": 119.198,
													"s": [
														{
															"i": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"o": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"v": [
																[
																	-56.414,
																	71.799
																],
																[
																	56.413,
																	71.799
																],
																[
																	56.413,
																	69.747
																],
																[
																	-53.952,
																	69.747
																],
																[
																	-53.952,
																	2.052
																],
																[
																	44.104,
																	2.052
																],
																[
																	44.104,
																	0
																],
																[
																	-52.311,
																	0
																],
																[
																	-53.952,
																	1.641
																],
																[
																	-53.952,
																	-69.747
																],
																[
																	56.413,
																	-69.747
																],
																[
																	56.413,
																	-71.799
																],
																[
																	-56.414,
																	-71.799
																]
															],
															"c": true
														}
													],
													"e": [
														{
															"i": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"o": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"v": [
																[
																	-56.414,
																	71.799
																],
																[
																	56.413,
																	71.799
																],
																[
																	56.419,
																	55.622
																],
																[
																	-40.946,
																	55.659
																],
																[
																	-40.936,
																	8.464
																],
																[
																	44.12,
																	8.427
																],
																[
																	44.051,
																	-7.125
																],
																[
																	-26.364,
																	-7.142
																],
																[
																	-40.936,
																	7.303
																],
																[
																	-40.936,
																	-55.46
																],
																[
																	56.429,
																	-55.497
																],
																[
																	56.413,
																	-71.799
																],
																[
																	-56.414,
																	-71.799
																]
															],
															"c": true
														}
													]
												},
												{
													"i": {
														"x": 0.833,
														"y": 0.833
													},
													"o": {
														"x": 0.167,
														"y": 0.167
													},
													"n": "0p833_0p833_0p167_0p167",
													"t": 239.398,
													"s": [
														{
															"i": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"o": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"v": [
																[
																	-56.414,
																	71.799
																],
																[
																	56.413,
																	71.799
																],
																[
																	56.419,
																	55.622
																],
																[
																	-40.946,
																	55.659
																],
																[
																	-40.936,
																	8.464
																],
																[
																	44.12,
																	8.427
																],
																[
																	44.051,
																	-7.125
																],
																[
																	-26.364,
																	-7.142
																],
																[
																	-40.936,
																	7.303
																],
																[
																	-40.936,
																	-55.46
																],
																[
																	56.429,
																	-55.497
																],
																[
																	56.413,
																	-71.799
																],
																[
																	-56.414,
																	-71.799
																]
															],
															"c": true
														}
													],
													"e": [
														{
															"i": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"o": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"v": [
																[
																	-56.414,
																	71.799
																],
																[
																	56.413,
																	71.799
																],
																[
																	56.315,
																	31.372
																],
																[
																	-16.05,
																	31.301
																],
																[
																	-16.029,
																	20.106
																],
																[
																	44.026,
																	20.177
																],
																[
																	43.944,
																	-20.375
																],
																[
																	1.217,
																	-20.528
																],
																[
																	-15.967,
																	17.924
																],
																[
																	-16.029,
																	-31.568
																],
																[
																	56.336,
																	-31.497
																],
																[
																	56.413,
																	-71.799
																],
																[
																	-56.414,
																	-71.799
																]
															],
															"c": true
														}
													]
												},
												{
													"i": {
														"x": 0.833,
														"y": 0.833
													},
													"o": {
														"x": 0.167,
														"y": 0.167
													},
													"n": "0p833_0p833_0p167_0p167",
													"t": 359.599,
													"s": [
														{
															"i": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"o": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"v": [
																[
																	-56.414,
																	71.799
																],
																[
																	56.413,
																	71.799
																],
																[
																	56.315,
																	31.372
																],
																[
																	-16.05,
																	31.301
																],
																[
																	-16.029,
																	20.106
																],
																[
																	44.026,
																	20.177
																],
																[
																	43.944,
																	-20.375
																],
																[
																	1.217,
																	-20.528
																],
																[
																	-15.967,
																	17.924
																],
																[
																	-16.029,
																	-31.568
																],
																[
																	56.336,
																	-31.497
																],
																[
																	56.413,
																	-71.799
																],
																[
																	-56.414,
																	-71.799
																]
															],
															"c": true
														}
													],
													"e": [
														{
															"i": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"o": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"v": [
																[
																	-56.414,
																	71.799
																],
																[
																	56.413,
																	71.799
																],
																[
																	56.316,
																	31.372
																],
																[
																	56.201,
																	31.386
																],
																[
																	56.033,
																	61.996
																],
																[
																	107.776,
																	62.177
																],
																[
																	107.694,
																	-61.375
																],
																[
																	55.967,
																	-60.778
																],
																[
																	55.908,
																	17.689
																],
																[
																	56.221,
																	-31.483
																],
																[
																	56.336,
																	-31.497
																],
																[
																	56.413,
																	-71.799
																],
																[
																	-56.414,
																	-71.799
																]
															],
															"c": true
														}
													]
												},
												{
													"t": 600.000024438501
												}
											]
										},
										"nm": "Path 1",
										"mn": "ADBE Vector Shape - Group"
									},
									{
										"ty": "fl",
										"c": {
											"a": 0,
											"k": [
												1,
												1,
												1,
												1
											]
										},
										"o": {
											"a": 0,
											"k": 100
										},
										"r": 1,
										"nm": "Fill 1",
										"mn": "ADBE Vector Graphic - Fill"
									},
									{
										"ty": "tr",
										"p": {
											"a": 0,
											"k": [
												543.091,
												333.903
											],
											"ix": 2
										},
										"a": {
											"a": 0,
											"k": [
												0,
												0
											],
											"ix": 1
										},
										"s": {
											"a": 0,
											"k": [
												100,
												100
											],
											"ix": 3
										},
										"r": {
											"a": 0,
											"k": 0,
											"ix": 6
										},
										"o": {
											"a": 0,
											"k": 100,
											"ix": 7
										},
										"sk": {
											"a": 0,
											"k": 0,
											"ix": 4
										},
										"sa": {
											"a": 0,
											"k": 0,
											"ix": 5
										},
										"nm": "Transform"
									}
								],
								"nm": "Group 1",
								"np": 2,
								"cix": 2,
								"ix": 1,
								"mn": "ADBE Vector Group"
							}
						],
						"ip": 1.00000004073083,
						"op": 900.000036657751,
						"st": 0,
						"bm": 0,
						"sr": 1
					}
				]
			},
			{
				"id": "comp_2",
				"layers": [
					{
						"ddd": 0,
						"ind": 1,
						"ty": 4,
						"nm": "Shape Layer 2",
						"ks": {
							"o": {
								"a": 0,
								"k": 100
							},
							"r": {
								"a": 0,
								"k": 0
							},
							"p": {
								"a": 0,
								"k": [
									1480.875,
									564.875,
									0
								]
							},
							"a": {
								"a": 0,
								"k": [
									520.875,
									25.125,
									0
								]
							},
							"s": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": [
												0.833,
												0.833,
												0.833
											],
											"y": [
												0.833,
												0.833,
												0.833
											]
										},
										"o": {
											"x": [
												0.167,
												0.167,
												0.167
											],
											"y": [
												0.167,
												0.167,
												0.167
											]
										},
										"n": [
											"0p833_0p833_0p167_0p167",
											"0p833_0p833_0p167_0p167",
											"0p833_0p833_0p167_0p167"
										],
										"t": 505,
										"s": [
											100,
											0,
											100
										],
										"e": [
											100,
											100,
											100
										]
									},
									{
										"t": 600.000024438501
									}
								]
							}
						},
						"ao": 0,
						"shapes": [
							{
								"ty": "gr",
								"it": [
									{
										"ind": 0,
										"ty": "sh",
										"ix": 1,
										"ks": {
											"a": 0,
											"k": {
												"i": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"v": [
													[
														22.671,
														-36.542
													],
													[
														22.671,
														36.542
													],
													[
														-22.671,
														36.542
													],
													[
														-22.671,
														-36.542
													]
												],
												"c": true
											}
										},
										"nm": "Path 1",
										"mn": "ADBE Vector Shape - Group"
									},
									{
										"ty": "fl",
										"c": {
											"a": 0,
											"k": [
												1,
												1,
												1,
												1
											]
										},
										"o": {
											"a": 0,
											"k": 100
										},
										"r": 1,
										"nm": "Fill 1",
										"mn": "ADBE Vector Graphic - Fill"
									},
									{
										"ty": "tr",
										"p": {
											"a": 0,
											"k": [
												543.522,
												24.999
											],
											"ix": 2
										},
										"a": {
											"a": 0,
											"k": [
												0,
												0
											],
											"ix": 1
										},
										"s": {
											"a": 0,
											"k": [
												100.008,
												99.193
											],
											"ix": 3
										},
										"r": {
											"a": 0,
											"k": 0,
											"ix": 6
										},
										"o": {
											"a": 0,
											"k": 100,
											"ix": 7
										},
										"sk": {
											"a": 0,
											"k": 0,
											"ix": 4
										},
										"sa": {
											"a": 0,
											"k": 0,
											"ix": 5
										},
										"nm": "Transform"
									}
								],
								"nm": "Rectangle 1",
								"np": 3,
								"cix": 2,
								"ix": 1,
								"mn": "ADBE Vector Group"
							}
						],
						"ip": 505.000020569072,
						"op": 900.000036657751,
						"st": 0,
						"bm": 0,
						"sr": 1
					},
					{
						"ddd": 0,
						"ind": 2,
						"ty": 4,
						"nm": "Shape Layer 1",
						"td": 1,
						"ks": {
							"o": {
								"a": 0,
								"k": 100
							},
							"r": {
								"a": 0,
								"k": 0
							},
							"p": {
								"a": 0,
								"k": [
									960,
									540,
									0
								]
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0,
									0
								]
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100,
									100
								]
							}
						},
						"ao": 0,
						"shapes": [
							{
								"ty": "gr",
								"it": [
									{
										"ind": 0,
										"ty": "sh",
										"ix": 1,
										"ks": {
											"a": 1,
											"k": [
												{
													"i": {
														"x": 0.833,
														"y": 0.833
													},
													"o": {
														"x": 0.167,
														"y": 0.167
													},
													"n": "0p833_0p833_0p167_0p167",
													"t": 505,
													"s": [
														{
															"i": [
																[
																	27.906,
																	11.441
																],
																[
																	0,
																	-40.989
																],
																[
																	51.157,
																	-31.004
																],
																[
																	0,
																	40.989
																]
															],
															"o": [
																[
																	28.518,
																	13.309
																],
																[
																	0,
																	40.989
																],
																[
																	49.321,
																	-30.07
																],
																[
																	0,
																	-40.989
																]
															],
															"v": [
																[
																	25.698,
																	-65.812
																],
																[
																	62.526,
																	0
																],
																[
																	24.474,
																	68.147
																],
																[
																	62.292,
																	0.467
																]
															],
															"c": true
														}
													],
													"e": [
														{
															"i": [
																[
																	49.933,
																	6.305
																],
																[
																	0,
																	-40.989
																],
																[
																	36.56,
																	0
																],
																[
																	0,
																	40.989
																]
															],
															"o": [
																[
																	36.56,
																	0
																],
																[
																	0,
																	40.989
																],
																[
																	65.841,
																	-18.397
																],
																[
																	0,
																	-40.989
																]
															],
															"v": [
																[
																	0,
																	-74.217
																],
																[
																	66.197,
																	0
																],
																[
																	0,
																	74.217
																],
																[
																	42.713,
																	0
																]
															],
															"c": true
														}
													]
												},
												{
													"t": 600.000024438501
												}
											]
										},
										"nm": "Path 1",
										"mn": "ADBE Vector Shape - Group"
									},
									{
										"ty": "fl",
										"c": {
											"a": 0,
											"k": [
												0,
												0,
												0,
												1
											]
										},
										"o": {
											"a": 0,
											"k": 100
										},
										"r": 1,
										"nm": "Fill 1",
										"mn": "ADBE Vector Graphic - Fill"
									},
									{
										"ty": "tr",
										"p": {
											"a": 0,
											"k": [
												504.695,
												21.225
											],
											"ix": 2
										},
										"a": {
											"a": 0,
											"k": [
												0,
												0
											],
											"ix": 1
										},
										"s": {
											"a": 0,
											"k": [
												81.719,
												107.087
											],
											"ix": 3
										},
										"r": {
											"a": 0,
											"k": 0,
											"ix": 6
										},
										"o": {
											"a": 0,
											"k": 100,
											"ix": 7
										},
										"sk": {
											"a": 0,
											"k": 0,
											"ix": 4
										},
										"sa": {
											"a": 0,
											"k": 0,
											"ix": 5
										},
										"nm": "Transform"
									}
								],
								"nm": "Ellipse 1",
								"np": 3,
								"cix": 2,
								"ix": 1,
								"mn": "ADBE Vector Group"
							}
						],
						"ip": 505.000020569072,
						"op": 900.000036657751,
						"st": 0,
						"bm": 0,
						"sr": 1
					},
					{
						"ddd": 0,
						"ind": 3,
						"ty": 4,
						"nm": "C",
						"tt": 2,
						"ks": {
							"o": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": [
												0.833
											],
											"y": [
												0.833
											]
										},
										"o": {
											"x": [
												0.167
											],
											"y": [
												0.167
											]
										},
										"n": [
											"0p833_0p833_0p167_0p167"
										],
										"t": 29,
										"s": [
											0
										],
										"e": [
											100
										]
									},
									{
										"t": 120.0000048877
									}
								]
							},
							"r": {
								"a": 0,
								"k": 0
							},
							"p": {
								"a": 0,
								"k": [
									389.592,
									227.534,
									0
								]
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0,
									0
								]
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100,
									100
								]
							}
						},
						"ao": 0,
						"shapes": [
							{
								"ty": "gr",
								"it": [
									{
										"ind": 0,
										"ty": "sh",
										"ix": 1,
										"ks": {
											"a": 1,
											"k": [
												{
													"i": {
														"x": 0.833,
														"y": 0.833
													},
													"o": {
														"x": 0.167,
														"y": 0.167
													},
													"n": "0p833_0p833_0p167_0p167",
													"t": 0,
													"s": [
														{
															"i": [
																[
																	29.334,
																	0
																],
																[
																	0,
																	45.541
																],
																[
																	-38.156,
																	0
																],
																[
																	-1.962,
																	-18.999
																],
																[
																	0,
																	0
																],
																[
																	34.873,
																	-0.007
																],
																[
																	0,
																	-51.079
																],
																[
																	-32.228,
																	0.3
																],
																[
																	-4.102,
																	20.925
																],
																[
																	0,
																	0
																]
															],
															"o": [
																[
																	-38.156,
																	0
																],
																[
																	0,
																	-45.951
																],
																[
																	35.693,
																	0
																],
																[
																	0,
																	0
																],
																[
																	-2.05,
																	-19.489
																],
																[
																	-33.516,
																	0.007
																],
																[
																	0,
																	51.08
																],
																[
																	30.901,
																	-0.288
																],
																[
																	0,
																	0
																],
																[
																	-3.692,
																	21.54
																]
															],
															"v": [
																[
																	4.574,
																	72.923
																],
																[
																	-59.631,
																	-0.029
																],
																[
																	4.616,
																	-73.089
																],
																[
																	57.749,
																	-33.626
																],
																[
																	57.821,
																	-33.626
																],
																[
																	4.616,
																	-73.069
																],
																[
																	-59.592,
																	-0.029
																],
																[
																	4.574,
																	72.85
																],
																[
																	60.029,
																	33.694
																],
																[
																	59.942,
																	33.819
																]
															],
															"c": true
														}
													],
													"e": [
														{
															"i": [
																[
																	29.334,
																	0
																],
																[
																	0,
																	45.541
																],
																[
																	-38.156,
																	0
																],
																[
																	-1.025,
																	-16.001
																],
																[
																	0,
																	0
																],
																[
																	34.873,
																	0
																],
																[
																	0,
																	-51.079
																],
																[
																	-36.104,
																	0
																],
																[
																	-4.102,
																	20.925
																],
																[
																	0,
																	0
																]
															],
															"o": [
																[
																	-38.156,
																	0
																],
																[
																	0,
																	-45.951
																],
																[
																	35.693,
																	0
																],
																[
																	0,
																	0
																],
																[
																	-2.05,
																	-19.489
																],
																[
																	-36.104,
																	0
																],
																[
																	0,
																	51.08
																],
																[
																	33.027,
																	0
																],
																[
																	0,
																	0
																],
																[
																	-3.692,
																	21.54
																]
															],
															"v": [
																[
																	4.616,
																	71.798
																],
																[
																	-58.568,
																	0
																],
																[
																	4.616,
																	-71.799
																],
																[
																	56.515,
																	-33.642
																],
																[
																	58.977,
																	-33.642
																],
																[
																	4.616,
																	-73.85
																],
																[
																	-61.029,
																	0
																],
																[
																	4.616,
																	73.85
																],
																[
																	61.029,
																	33.643
																],
																[
																	58.567,
																	33.643
																]
															],
															"c": true
														}
													]
												},
												{
													"i": {
														"x": 0.833,
														"y": 0.833
													},
													"o": {
														"x": 0.167,
														"y": 0.167
													},
													"n": "0p833_0p833_0p167_0p167",
													"t": 120,
													"s": [
														{
															"i": [
																[
																	29.334,
																	0
																],
																[
																	0,
																	45.541
																],
																[
																	-38.156,
																	0
																],
																[
																	-1.025,
																	-16.001
																],
																[
																	0,
																	0
																],
																[
																	34.873,
																	0
																],
																[
																	0,
																	-51.079
																],
																[
																	-36.104,
																	0
																],
																[
																	-4.102,
																	20.925
																],
																[
																	0,
																	0
																]
															],
															"o": [
																[
																	-38.156,
																	0
																],
																[
																	0,
																	-45.951
																],
																[
																	35.693,
																	0
																],
																[
																	0,
																	0
																],
																[
																	-2.05,
																	-19.489
																],
																[
																	-36.104,
																	0
																],
																[
																	0,
																	51.08
																],
																[
																	33.027,
																	0
																],
																[
																	0,
																	0
																],
																[
																	-3.692,
																	21.54
																]
															],
															"v": [
																[
																	4.616,
																	71.798
																],
																[
																	-58.568,
																	0
																],
																[
																	4.616,
																	-71.799
																],
																[
																	56.515,
																	-33.642
																],
																[
																	58.977,
																	-33.642
																],
																[
																	4.616,
																	-73.85
																],
																[
																	-61.029,
																	0
																],
																[
																	4.616,
																	73.85
																],
																[
																	61.029,
																	33.643
																],
																[
																	58.567,
																	33.643
																]
															],
															"c": true
														}
													],
													"e": [
														{
															"i": [
																[
																	22.651,
																	-0.361
																],
																[
																	-0.082,
																	34.279
																],
																[
																	-21.351,
																	-0.31
																],
																[
																	-5.165,
																	-14.312
																],
																[
																	0,
																	0
																],
																[
																	34.873,
																	0
																],
																[
																	0,
																	-51.079
																],
																[
																	-36.104,
																	0
																],
																[
																	-4.102,
																	20.925
																],
																[
																	0,
																	0
																]
															],
															"o": [
																[
																	-32.098,
																	0.512
																],
																[
																	0.11,
																	-45.951
																],
																[
																	24.901,
																	0.362
																],
																[
																	0,
																	0
																],
																[
																	-2.05,
																	-19.489
																],
																[
																	-36.104,
																	0
																],
																[
																	0,
																	51.08
																],
																[
																	33.027,
																	0
																],
																[
																	0,
																	0
																],
																[
																	-6.592,
																	18.118
																]
															],
															"v": [
																[
																	4.574,
																	58.423
																],
																[
																	-45.193,
																	0.033
																],
																[
																	4.574,
																	-58.799
																],
																[
																	42.64,
																	-33.626
																],
																[
																	58.977,
																	-33.642
																],
																[
																	4.616,
																	-73.85
																],
																[
																	-61.029,
																	0
																],
																[
																	4.616,
																	73.85
																],
																[
																	61.029,
																	33.643
																],
																[
																	44.317,
																	33.694
																]
															],
															"c": true
														}
													]
												},
												{
													"i": {
														"x": 0.833,
														"y": 0.833
													},
													"o": {
														"x": 0.167,
														"y": 0.167
													},
													"n": "0p833_0p833_0p167_0p167",
													"t": 240,
													"s": [
														{
															"i": [
																[
																	22.651,
																	-0.361
																],
																[
																	-0.082,
																	34.279
																],
																[
																	-21.351,
																	-0.31
																],
																[
																	-5.165,
																	-14.312
																],
																[
																	0,
																	0
																],
																[
																	34.873,
																	0
																],
																[
																	0,
																	-51.079
																],
																[
																	-36.104,
																	0
																],
																[
																	-4.102,
																	20.925
																],
																[
																	0,
																	0
																]
															],
															"o": [
																[
																	-32.098,
																	0.512
																],
																[
																	0.11,
																	-45.951
																],
																[
																	24.901,
																	0.362
																],
																[
																	0,
																	0
																],
																[
																	-2.05,
																	-19.489
																],
																[
																	-36.104,
																	0
																],
																[
																	0,
																	51.08
																],
																[
																	33.027,
																	0
																],
																[
																	0,
																	0
																],
																[
																	-6.592,
																	18.118
																]
															],
															"v": [
																[
																	4.574,
																	58.423
																],
																[
																	-45.193,
																	0.033
																],
																[
																	4.574,
																	-58.799
																],
																[
																	42.64,
																	-33.626
																],
																[
																	58.977,
																	-33.642
																],
																[
																	4.616,
																	-73.85
																],
																[
																	-61.029,
																	0
																],
																[
																	4.616,
																	73.85
																],
																[
																	61.029,
																	33.643
																],
																[
																	44.317,
																	33.694
																]
															],
															"c": true
														}
													],
													"e": [
														{
															"i": [
																[
																	12.11,
																	-0.018
																],
																[
																	-0.087,
																	32.088
																],
																[
																	-21.353,
																	0.025
																],
																[
																	-3.165,
																	-14.47
																],
																[
																	0,
																	0
																],
																[
																	38.484,
																	0.038
																],
																[
																	0,
																	-51.079
																],
																[
																	-36.103,
																	0.255
																],
																[
																	-2.054,
																	25.67
																],
																[
																	0,
																	0
																]
															],
															"o": [
																[
																	-9.141,
																	0.014
																],
																[
																	0.043,
																	-15.788
																],
																[
																	11.109,
																	-0.013
																],
																[
																	0,
																	0
																],
																[
																	-4.002,
																	-27.67
																],
																[
																	-36.104,
																	-0.036
																],
																[
																	0,
																	51.08
																],
																[
																	40.859,
																	-0.288
																],
																[
																	0,
																	0
																],
																[
																	-2.092,
																	13.14
																]
															],
															"v": [
																[
																	4.491,
																	37.924
																],
																[
																	-21.193,
																	0.1
																],
																[
																	4.491,
																	-38.3
																],
																[
																	23.89,
																	-19.468
																],
																[
																	64.227,
																	-19.392
																],
																[
																	4.616,
																	-73.851
																],
																[
																	-61.029,
																	0
																],
																[
																	4.616,
																	73.851
																],
																[
																	66.779,
																	16.643
																],
																[
																	26.067,
																	16.672
																]
															],
															"c": true
														}
													]
												},
												{
													"i": {
														"x": 0.833,
														"y": 0.833
													},
													"o": {
														"x": 0.167,
														"y": 0.167
													},
													"n": "0p833_0p833_0p167_0p167",
													"t": 360,
													"s": [
														{
															"i": [
																[
																	12.11,
																	-0.018
																],
																[
																	-0.087,
																	32.088
																],
																[
																	-21.353,
																	0.025
																],
																[
																	-3.165,
																	-14.47
																],
																[
																	0,
																	0
																],
																[
																	38.484,
																	0.038
																],
																[
																	0,
																	-51.079
																],
																[
																	-36.103,
																	0.255
																],
																[
																	-2.054,
																	25.67
																],
																[
																	0,
																	0
																]
															],
															"o": [
																[
																	-9.141,
																	0.014
																],
																[
																	0.043,
																	-15.788
																],
																[
																	11.109,
																	-0.013
																],
																[
																	0,
																	0
																],
																[
																	-4.002,
																	-27.67
																],
																[
																	-36.104,
																	-0.036
																],
																[
																	0,
																	51.08
																],
																[
																	40.859,
																	-0.288
																],
																[
																	0,
																	0
																],
																[
																	-2.092,
																	13.14
																]
															],
															"v": [
																[
																	4.491,
																	37.924
																],
																[
																	-21.193,
																	0.1
																],
																[
																	4.491,
																	-38.3
																],
																[
																	23.89,
																	-19.468
																],
																[
																	64.227,
																	-19.392
																],
																[
																	4.616,
																	-73.851
																],
																[
																	-61.029,
																	0
																],
																[
																	4.616,
																	73.851
																],
																[
																	66.779,
																	16.643
																],
																[
																	26.067,
																	16.672
																]
															],
															"c": true
														}
													],
													"e": [
														{
															"i": [
																[
																	1.902,
																	0.139
																],
																[
																	0.668,
																	0.712
																],
																[
																	-1.516,
																	-0.138
																],
																[
																	-0.415,
																	-0.22
																],
																[
																	0,
																	0
																],
																[
																	47.612,
																	0.106
																],
																[
																	0,
																	-51.079
																],
																[
																	-36.104,
																	0.026
																],
																[
																	0.946,
																	27.42
																],
																[
																	0,
																	0
																]
															],
															"o": [
																[
																	-2.843,
																	-0.208
																],
																[
																	0.343,
																	-0.994
																],
																[
																	1.234,
																	0.112
																],
																[
																	0,
																	0
																],
																[
																	0.248,
																	-33.045
																],
																[
																	-39.141,
																	-0.087
																],
																[
																	0,
																	51.08
																],
																[
																	52.109,
																	-0.038
																],
																[
																	0,
																	0
																],
																[
																	0.158,
																	0.89
																]
															],
															"v": [
																[
																	3.323,
																	0.424
																],
																[
																	1.807,
																	0.6
																],
																[
																	3.491,
																	0.2
																],
																[
																	3.14,
																	-0.718
																],
																[
																	67.477,
																	-0.392
																],
																[
																	4.616,
																	-73.851
																],
																[
																	-63.529,
																	0
																],
																[
																	4.616,
																	73.851
																],
																[
																	67.779,
																	-0.857
																],
																[
																	3.067,
																	-0.578
																]
															],
															"c": true
														}
													]
												},
												{
													"i": {
														"x": 0.833,
														"y": 0.833
													},
													"o": {
														"x": 0.167,
														"y": 0.167
													},
													"n": "0p833_0p833_0p167_0p167",
													"t": 505,
													"s": [
														{
															"i": [
																[
																	1.902,
																	0.139
																],
																[
																	0.668,
																	0.712
																],
																[
																	-1.516,
																	-0.138
																],
																[
																	-0.415,
																	-0.22
																],
																[
																	0,
																	0
																],
																[
																	47.612,
																	0.106
																],
																[
																	0,
																	-51.079
																],
																[
																	-36.104,
																	0.026
																],
																[
																	0.946,
																	27.42
																],
																[
																	0,
																	0
																]
															],
															"o": [
																[
																	-2.843,
																	-0.208
																],
																[
																	0.343,
																	-0.994
																],
																[
																	1.234,
																	0.112
																],
																[
																	0,
																	0
																],
																[
																	0.248,
																	-33.045
																],
																[
																	-39.141,
																	-0.087
																],
																[
																	0,
																	51.08
																],
																[
																	52.109,
																	-0.038
																],
																[
																	0,
																	0
																],
																[
																	0.158,
																	0.89
																]
															],
															"v": [
																[
																	3.323,
																	0.424
																],
																[
																	1.807,
																	0.6
																],
																[
																	3.491,
																	0.2
																],
																[
																	3.14,
																	-0.718
																],
																[
																	67.477,
																	-0.392
																],
																[
																	4.616,
																	-73.851
																],
																[
																	-63.529,
																	0
																],
																[
																	4.616,
																	73.851
																],
																[
																	67.779,
																	-0.857
																],
																[
																	3.067,
																	-0.578
																]
															],
															"c": true
														}
													],
													"e": [
														{
															"i": [
																[
																	1.902,
																	0.139
																],
																[
																	0.668,
																	0.712
																],
																[
																	-1.516,
																	-0.138
																],
																[
																	-0.415,
																	-0.22
																],
																[
																	0,
																	0
																],
																[
																	61.109,
																	-0.337
																],
																[
																	0,
																	-51.079
																],
																[
																	-36.093,
																	0.892
																],
																[
																	0.946,
																	27.42
																],
																[
																	0,
																	0
																]
															],
															"o": [
																[
																	-2.843,
																	-0.208
																],
																[
																	0.343,
																	-0.994
																],
																[
																	1.234,
																	0.112
																],
																[
																	0,
																	0
																],
																[
																	8.998,
																	-53.795
																],
																[
																	-39.141,
																	0.216
																],
																[
																	0,
																	51.08
																],
																[
																	72.359,
																	-1.788
																],
																[
																	0,
																	0
																],
																[
																	0.158,
																	0.89
																]
															],
															"v": [
																[
																	3.323,
																	0.424
																],
																[
																	1.807,
																	0.6
																],
																[
																	3.491,
																	0.2
																],
																[
																	16.89,
																	38.532
																],
																[
																	77.727,
																	39.358
																],
																[
																	4.616,
																	-73.851
																],
																[
																	-63.529,
																	-0.001
																],
																[
																	4.616,
																	73.851
																],
																[
																	74.529,
																	-33.607
																],
																[
																	8.067,
																	-33.078
																]
															],
															"c": true
														}
													]
												},
												{
													"t": 600.000024438501
												}
											]
										},
										"nm": "Path 1",
										"mn": "ADBE Vector Shape - Group"
									},
									{
										"ty": "fl",
										"c": {
											"a": 0,
											"k": [
												1,
												1,
												1,
												1
											]
										},
										"o": {
											"a": 0,
											"k": 100
										},
										"r": 1,
										"nm": "Fill 1",
										"mn": "ADBE Vector Graphic - Fill"
									},
									{
										"ty": "tr",
										"p": {
											"a": 0,
											"k": [
												1075.933,
												333.904
											],
											"ix": 2
										},
										"a": {
											"a": 0,
											"k": [
												0,
												0
											],
											"ix": 1
										},
										"s": {
											"a": 0,
											"k": [
												100,
												100
											],
											"ix": 3
										},
										"r": {
											"a": 0,
											"k": 0,
											"ix": 6
										},
										"o": {
											"a": 0,
											"k": 100,
											"ix": 7
										},
										"sk": {
											"a": 0,
											"k": 0,
											"ix": 4
										},
										"sa": {
											"a": 0,
											"k": 0,
											"ix": 5
										},
										"nm": "Transform"
									}
								],
								"nm": "Group 2",
								"np": 2,
								"cix": 2,
								"ix": 1,
								"mn": "ADBE Vector Group"
							}
						],
						"ip": 1.00000004073083,
						"op": 900.000036657751,
						"st": 0,
						"bm": 0,
						"sr": 1
					}
				]
			},
			{
				"id": "comp_3",
				"layers": [
					{
						"ddd": 0,
						"ind": 1,
						"ty": 4,
						"nm": "Shape Layer 2",
						"ks": {
							"o": {
								"a": 0,
								"k": 100
							},
							"r": {
								"a": 0,
								"k": 0
							},
							"p": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"n": "0p833_0p833_0p167_0p167",
										"t": 447,
										"s": [
											1090,
											445,
											0
										],
										"e": [
											1090,
											510,
											0
										],
										"to": [
											0,
											10.8333330154419,
											0
										],
										"ti": [
											0,
											-10.8333330154419,
											0
										]
									},
									{
										"t": 600.000024438501
									}
								]
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0,
									0
								]
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100,
									100
								]
							}
						},
						"ao": 0,
						"shapes": [
							{
								"ty": "gr",
								"it": [
									{
										"ind": 0,
										"ty": "sh",
										"ix": 1,
										"ks": {
											"a": 0,
											"k": {
												"i": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"v": [
													[
														280.625,
														147
													],
													[
														235.5,
														147
													],
													[
														216.25,
														186.75
													],
													[
														283.125,
														186.75
													]
												],
												"c": true
											}
										},
										"nm": "Path 1",
										"mn": "ADBE Vector Shape - Group"
									},
									{
										"ty": "fl",
										"c": {
											"a": 0,
											"k": [
												1,
												1,
												1,
												1
											]
										},
										"o": {
											"a": 0,
											"k": 100
										},
										"r": 1,
										"nm": "Fill 1",
										"mn": "ADBE Vector Graphic - Fill"
									},
									{
										"ty": "tr",
										"p": {
											"a": 0,
											"k": [
												0,
												0
											],
											"ix": 2
										},
										"a": {
											"a": 0,
											"k": [
												0,
												0
											],
											"ix": 1
										},
										"s": {
											"a": 0,
											"k": [
												100,
												100
											],
											"ix": 3
										},
										"r": {
											"a": 0,
											"k": 0,
											"ix": 6
										},
										"o": {
											"a": 0,
											"k": 100,
											"ix": 7
										},
										"sk": {
											"a": 0,
											"k": 0,
											"ix": 4
										},
										"sa": {
											"a": 0,
											"k": 0,
											"ix": 5
										},
										"nm": "Transform"
									}
								],
								"nm": "Shape 1",
								"np": 3,
								"cix": 2,
								"ix": 1,
								"mn": "ADBE Vector Group"
							}
						],
						"ip": 447.000018206683,
						"op": 900.000036657751,
						"st": 0,
						"bm": 0,
						"sr": 1
					},
					{
						"ddd": 0,
						"ind": 2,
						"ty": 4,
						"nm": "Shape Layer 3",
						"td": 1,
						"ks": {
							"o": {
								"a": 0,
								"k": 100
							},
							"r": {
								"a": 0,
								"k": 0
							},
							"p": {
								"a": 0,
								"k": [
									960,
									540,
									0
								]
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0,
									0
								]
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100,
									100
								]
							}
						},
						"ao": 0,
						"shapes": [
							{
								"ty": "gr",
								"it": [
									{
										"ind": 0,
										"ty": "sh",
										"ix": 1,
										"ks": {
											"a": 0,
											"k": {
												"i": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"v": [
													[
														418.75,
														-50.25
													],
													[
														327,
														-50.25
													],
													[
														306,
														93
													],
													[
														439,
														93
													]
												],
												"c": true
											}
										},
										"nm": "Path 1",
										"mn": "ADBE Vector Shape - Group"
									},
									{
										"ty": "fl",
										"c": {
											"a": 0,
											"k": [
												1,
												0,
												0,
												1
											]
										},
										"o": {
											"a": 0,
											"k": 100
										},
										"r": 1,
										"nm": "Fill 1",
										"mn": "ADBE Vector Graphic - Fill"
									},
									{
										"ty": "tr",
										"p": {
											"a": 0,
											"k": [
												0,
												0
											],
											"ix": 2
										},
										"a": {
											"a": 0,
											"k": [
												0,
												0
											],
											"ix": 1
										},
										"s": {
											"a": 0,
											"k": [
												100,
												100
											],
											"ix": 3
										},
										"r": {
											"a": 0,
											"k": 0,
											"ix": 6
										},
										"o": {
											"a": 0,
											"k": 100,
											"ix": 7
										},
										"sk": {
											"a": 0,
											"k": 0,
											"ix": 4
										},
										"sa": {
											"a": 0,
											"k": 0,
											"ix": 5
										},
										"nm": "Transform"
									}
								],
								"nm": "Shape 1",
								"np": 3,
								"cix": 2,
								"ix": 1,
								"mn": "ADBE Vector Group"
							}
						],
						"ip": 0,
						"op": 900.000036657751,
						"st": 0,
						"bm": 0,
						"sr": 1
					},
					{
						"ddd": 0,
						"ind": 3,
						"ty": 4,
						"nm": "A",
						"tt": 1,
						"ks": {
							"o": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": [
												0.833
											],
											"y": [
												0.833
											]
										},
										"o": {
											"x": [
												0.167
											],
											"y": [
												0.167
											]
										},
										"n": [
											"0p833_0p833_0p167_0p167"
										],
										"t": 31,
										"s": [
											0
										],
										"e": [
											100
										]
									},
									{
										"t": 119.000004846969
									}
								]
							},
							"r": {
								"a": 0,
								"k": 0
							},
							"p": {
								"a": 0,
								"k": [
									389.592,
									227.534,
									0
								]
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0,
									0
								]
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100,
									100
								]
							}
						},
						"ao": 0,
						"shapes": [
							{
								"ty": "gr",
								"it": [
									{
										"ind": 0,
										"ty": "sh",
										"ix": 1,
										"ks": {
											"a": 1,
											"k": [
												{
													"i": {
														"x": 0.833,
														"y": 0.833
													},
													"o": {
														"x": 0.167,
														"y": 0.167
													},
													"n": "0p833_0p833_0p167_0p167",
													"t": 1,
													"s": [
														{
															"i": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"o": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"v": [
																[
																	0,
																	-71.799
																],
																[
																	41.288,
																	21.141
																],
																[
																	-41.342,
																	21.141
																],
																[
																	-41.277,
																	20.827
																],
																[
																	0,
																	-71.799
																],
																[
																	0.02,
																	-71.799
																],
																[
																	-63.983,
																	71.799
																],
																[
																	-63.986,
																	71.799
																],
																[
																	-41.357,
																	21.129
																],
																[
																	41.233,
																	21.129
																],
																[
																	63.799,
																	71.799
																],
																[
																	63.78,
																	71.799
																],
																[
																	0.042,
																	-71.814
																]
															],
															"c": true
														}
													],
													"e": [
														{
															"i": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"o": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"v": [
																[
																	0,
																	-71.799
																],
																[
																	40.413,
																	19.078
																],
																[
																	-39.592,
																	19.078
																],
																[
																	-41.027,
																	20.514
																],
																[
																	0,
																	-71.799
																],
																[
																	-2.667,
																	-71.799
																],
																[
																	-66.67,
																	71.799
																],
																[
																	-63.798,
																	71.799
																],
																[
																	-41.232,
																	21.129
																],
																[
																	41.233,
																	21.129
																],
																[
																	63.799,
																	71.799
																],
																[
																	66.671,
																	71.799
																],
																[
																	2.667,
																	-71.799
																]
															],
															"c": true
														}
													]
												},
												{
													"i": {
														"x": 0.833,
														"y": 0.833
													},
													"o": {
														"x": 0.167,
														"y": 0.167
													},
													"n": "0p833_0p833_0p167_0p167",
													"t": 119.198,
													"s": [
														{
															"i": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"o": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"v": [
																[
																	0,
																	-71.799
																],
																[
																	40.413,
																	19.078
																],
																[
																	-39.592,
																	19.078
																],
																[
																	-41.027,
																	20.514
																],
																[
																	0,
																	-71.799
																],
																[
																	-2.667,
																	-71.799
																],
																[
																	-66.67,
																	71.799
																],
																[
																	-63.798,
																	71.799
																],
																[
																	-41.232,
																	21.129
																],
																[
																	41.233,
																	21.129
																],
																[
																	63.799,
																	71.799
																],
																[
																	66.671,
																	71.799
																],
																[
																	2.667,
																	-71.799
																]
															],
															"c": true
														}
													],
													"e": [
														{
															"i": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"o": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"v": [
																[
																	0,
																	-71.799
																],
																[
																	29.417,
																	11.94
																],
																[
																	-19.463,
																	11.94
																],
																[
																	-33.027,
																	24.764
																],
																[
																	0,
																	-71.799
																],
																[
																	-17.292,
																	-71.814
																],
																[
																	-66.67,
																	71.799
																],
																[
																	-49.423,
																	71.757
																],
																[
																	-34.482,
																	28.004
																],
																[
																	34.983,
																	28.254
																],
																[
																	49.549,
																	71.757
																],
																[
																	66.671,
																	71.799
																],
																[
																	17.042,
																	-71.814
																]
															],
															"c": true
														}
													]
												},
												{
													"i": {
														"x": 0.833,
														"y": 0.833
													},
													"o": {
														"x": 0.167,
														"y": 0.167
													},
													"n": "0p833_0p833_0p167_0p167",
													"t": 239.398,
													"s": [
														{
															"i": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"o": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"v": [
																[
																	0,
																	-71.799
																],
																[
																	29.417,
																	11.94
																],
																[
																	-19.463,
																	11.94
																],
																[
																	-33.027,
																	24.764
																],
																[
																	0,
																	-71.799
																],
																[
																	-17.292,
																	-71.814
																],
																[
																	-66.67,
																	71.799
																],
																[
																	-49.423,
																	71.757
																],
																[
																	-34.482,
																	28.004
																],
																[
																	34.983,
																	28.254
																],
																[
																	49.549,
																	71.757
																],
																[
																	66.671,
																	71.799
																],
																[
																	17.042,
																	-71.814
																]
															],
															"c": true
														}
													],
													"e": [
														{
															"i": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"o": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"v": [
																[
																	0,
																	-71.799
																],
																[
																	11.177,
																	1.539
																],
																[
																	0.672,
																	1.539
																],
																[
																	-16.277,
																	39.389
																],
																[
																	0,
																	-71.799
																],
																[
																	-45.792,
																	-71.844
																],
																[
																	-66.67,
																	71.799
																],
																[
																	-20.798,
																	71.798
																],
																[
																	-16.658,
																	41.917
																],
																[
																	16.932,
																	42.167
																],
																[
																	21.174,
																	71.798
																],
																[
																	66.671,
																	71.799
																],
																[
																	45.792,
																	-71.844
																]
															],
															"c": true
														}
													]
												},
												{
													"i": {
														"x": 0.833,
														"y": 0.833
													},
													"o": {
														"x": 0.167,
														"y": 0.167
													},
													"n": "0p833_0p833_0p167_0p167",
													"t": 359.599,
													"s": [
														{
															"i": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"o": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"v": [
																[
																	0,
																	-71.799
																],
																[
																	11.177,
																	1.539
																],
																[
																	0.672,
																	1.539
																],
																[
																	-16.277,
																	39.389
																],
																[
																	0,
																	-71.799
																],
																[
																	-45.792,
																	-71.844
																],
																[
																	-66.67,
																	71.799
																],
																[
																	-20.798,
																	71.798
																],
																[
																	-16.658,
																	41.917
																],
																[
																	16.932,
																	42.167
																],
																[
																	21.174,
																	71.798
																],
																[
																	66.671,
																	71.799
																],
																[
																	45.792,
																	-71.844
																]
															],
															"c": true
														}
													],
													"e": [
														{
															"i": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"o": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"v": [
																[
																	0,
																	-71.799
																],
																[
																	14.071,
																	23.039
																],
																[
																	0.441,
																	23.039
																],
																[
																	-18.883,
																	60.889
																],
																[
																	0,
																	-71.799
																],
																[
																	-45.792,
																	-71.844
																],
																[
																	-66.67,
																	71.799
																],
																[
																	-20.798,
																	71.798
																],
																[
																	-19.264,
																	63.417
																],
																[
																	19.826,
																	63.667
																],
																[
																	21.174,
																	71.798
																],
																[
																	66.671,
																	71.799
																],
																[
																	45.792,
																	-71.844
																]
															],
															"c": true
														}
													]
												},
												{
													"t": 446.798768198486
												}
											]
										},
										"nm": "Path 1",
										"mn": "ADBE Vector Shape - Group"
									},
									{
										"ty": "fl",
										"c": {
											"a": 0,
											"k": [
												1,
												1,
												1,
												1
											]
										},
										"o": {
											"a": 0,
											"k": 100
										},
										"r": 1,
										"nm": "Fill 1",
										"mn": "ADBE Vector Graphic - Fill"
									},
									{
										"ty": "st",
										"c": {
											"a": 0,
											"k": [
												1,
												1,
												1,
												1
											]
										},
										"o": {
											"a": 0,
											"k": 100
										},
										"w": {
											"a": 1,
											"k": [
												{
													"i": {
														"x": [
															0.833
														],
														"y": [
															0.833
														]
													},
													"o": {
														"x": [
															0.167
														],
														"y": [
															0.167
														]
													},
													"n": [
														"0p833_0p833_0p167_0p167"
													],
													"t": 360,
													"s": [
														0
													],
													"e": [
														28
													]
												},
												{
													"t": 447.000018206683
												}
											]
										},
										"lc": 1,
										"lj": 1,
										"ml": 4,
										"nm": "Stroke 1",
										"mn": "ADBE Vector Graphic - Stroke"
									},
									{
										"ty": "tr",
										"p": {
											"a": 0,
											"k": [
												943.107,
												333.904
											],
											"ix": 2
										},
										"a": {
											"a": 0,
											"k": [
												0,
												0
											],
											"ix": 1
										},
										"s": {
											"a": 0,
											"k": [
												100,
												100
											],
											"ix": 3
										},
										"r": {
											"a": 0,
											"k": 0,
											"ix": 6
										},
										"o": {
											"a": 0,
											"k": 100,
											"ix": 7
										},
										"sk": {
											"a": 0,
											"k": 0,
											"ix": 4
										},
										"sa": {
											"a": 0,
											"k": 0,
											"ix": 5
										},
										"nm": "Transform"
									}
								],
								"nm": "Group 3",
								"np": 3,
								"cix": 2,
								"ix": 1,
								"mn": "ADBE Vector Group"
							}
						],
						"ip": 1.00000004073083,
						"op": 900.000036657751,
						"st": 0,
						"bm": 0,
						"sr": 1
					}
				]
			},
			{
				"id": "comp_4",
				"layers": [
					{
						"ddd": 0,
						"ind": 1,
						"ty": 4,
						"nm": "Shape Layer 2",
						"ks": {
							"o": {
								"a": 0,
								"k": 100
							},
							"r": {
								"a": 0,
								"k": 0
							},
							"p": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"n": "0p833_0p833_0p167_0p167",
										"t": 434,
										"s": [
											960,
											444.5,
											0
										],
										"e": [
											960,
											540,
											0
										],
										"to": [
											0,
											15.9166669845581,
											0
										],
										"ti": [
											0,
											-15.9166669845581,
											0
										]
									},
									{
										"t": 600.000024438501
									}
								]
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0,
									0
								]
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100,
									100
								]
							}
						},
						"ao": 0,
						"shapes": [
							{
								"ty": "gr",
								"it": [
									{
										"ind": 0,
										"ty": "sh",
										"ix": 1,
										"ks": {
											"a": 0,
											"k": {
												"i": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"v": [
													[
														283.125,
														144.5
													],
													[
														240.5,
														144.5
													],
													[
														223.75,
														186.75
													],
													[
														283.125,
														186.75
													]
												],
												"c": true
											}
										},
										"nm": "Path 1",
										"mn": "ADBE Vector Shape - Group"
									},
									{
										"ty": "fl",
										"c": {
											"a": 0,
											"k": [
												1,
												1,
												1,
												1
											]
										},
										"o": {
											"a": 0,
											"k": 100
										},
										"r": 1,
										"nm": "Fill 1",
										"mn": "ADBE Vector Graphic - Fill"
									},
									{
										"ty": "tr",
										"p": {
											"a": 0,
											"k": [
												0,
												0
											],
											"ix": 2
										},
										"a": {
											"a": 0,
											"k": [
												0,
												0
											],
											"ix": 1
										},
										"s": {
											"a": 0,
											"k": [
												100,
												100
											],
											"ix": 3
										},
										"r": {
											"a": 0,
											"k": 0,
											"ix": 6
										},
										"o": {
											"a": 0,
											"k": 100,
											"ix": 7
										},
										"sk": {
											"a": 0,
											"k": 0,
											"ix": 4
										},
										"sa": {
											"a": 0,
											"k": 0,
											"ix": 5
										},
										"nm": "Transform"
									}
								],
								"nm": "Shape 1",
								"np": 2,
								"cix": 2,
								"ix": 1,
								"mn": "ADBE Vector Group"
							}
						],
						"ip": 480.000019550801,
						"op": 900.000036657752,
						"st": 0,
						"bm": 0,
						"sr": 1
					},
					{
						"ddd": 0,
						"ind": 2,
						"ty": 4,
						"nm": "Shape Layer 1",
						"ks": {
							"o": {
								"a": 0,
								"k": 100
							},
							"r": {
								"a": 0,
								"k": 0
							},
							"p": {
								"a": 0,
								"k": [
									975.25,
									541,
									0
								]
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0,
									0
								]
							},
							"s": {
								"a": 0,
								"k": [
									74.614,
									100,
									100
								]
							}
						},
						"ao": 0,
						"shapes": [
							{
								"ty": "gr",
								"it": [
									{
										"ind": 0,
										"ty": "sh",
										"ix": 1,
										"ks": {
											"a": 1,
											"k": [
												{
													"i": {
														"x": 0.833,
														"y": 0.833
													},
													"o": {
														"x": 0.167,
														"y": 0.167
													},
													"n": "0p833_0p833_0p167_0p167",
													"t": 360,
													"s": [
														{
															"i": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"o": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"v": [
																[
																	-79.034,
																	-5.367
																],
																[
																	-79.034,
																	5.016
																],
																[
																	-79.216,
																	5.191
																],
																[
																	-79.216,
																	-5.191
																]
															],
															"c": true
														}
													],
													"e": [
														{
															"i": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"o": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"v": [
																[
																	182.156,
																	-5.117
																],
																[
																	182.156,
																	5.266
																],
																[
																	-79.216,
																	5.191
																],
																[
																	-79.216,
																	-5.191
																]
															],
															"c": true
														}
													]
												},
												{
													"t": 600.000024438501
												}
											]
										},
										"nm": "Path 1",
										"mn": "ADBE Vector Shape - Group"
									},
									{
										"ty": "fl",
										"c": {
											"a": 0,
											"k": [
												1,
												1,
												1,
												1
											]
										},
										"o": {
											"a": 0,
											"k": 100
										},
										"r": 1,
										"nm": "Fill 1",
										"mn": "ADBE Vector Graphic - Fill"
									},
									{
										"ty": "tr",
										"p": {
											"a": 0,
											"k": [
												358.716,
												87.191
											],
											"ix": 2
										},
										"a": {
											"a": 0,
											"k": [
												0,
												0
											],
											"ix": 1
										},
										"s": {
											"a": 0,
											"k": [
												100,
												100
											],
											"ix": 3
										},
										"r": {
											"a": 0,
											"k": 0,
											"ix": 6
										},
										"o": {
											"a": 0,
											"k": 100,
											"ix": 7
										},
										"sk": {
											"a": 0,
											"k": 0,
											"ix": 4
										},
										"sa": {
											"a": 0,
											"k": 0,
											"ix": 5
										},
										"nm": "Transform"
									}
								],
								"nm": "Rectangle 1",
								"np": 2,
								"cix": 2,
								"ix": 1,
								"mn": "ADBE Vector Group"
							}
						],
						"ip": 360.000014663101,
						"op": 900.000036657751,
						"st": 0,
						"bm": 0,
						"sr": 1
					},
					{
						"ddd": 0,
						"ind": 3,
						"ty": 4,
						"nm": "F",
						"ks": {
							"o": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": [
												0.833
											],
											"y": [
												0.833
											]
										},
										"o": {
											"x": [
												0.167
											],
											"y": [
												0.167
											]
										},
										"n": [
											"0p833_0p833_0p167_0p167"
										],
										"t": 29,
										"s": [
											0
										],
										"e": [
											100
										]
									},
									{
										"t": 119.000004846969
									}
								]
							},
							"r": {
								"a": 0,
								"k": 0
							},
							"p": {
								"a": 0,
								"k": [
									389.592,
									227.534,
									0
								]
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0,
									0
								]
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100,
									100
								]
							}
						},
						"ao": 0,
						"shapes": [
							{
								"ty": "gr",
								"it": [
									{
										"ind": 0,
										"ty": "sh",
										"ix": 1,
										"ks": {
											"a": 1,
											"k": [
												{
													"i": {
														"x": 0.833,
														"y": 0.833
													},
													"o": {
														"x": 0.167,
														"y": 0.167
													},
													"n": "0p833_0p833_0p167_0p167",
													"t": 1,
													"s": [
														{
															"i": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"o": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"v": [
																[
																	-55.351,
																	71.784
																],
																[
																	-55.326,
																	71.836
																],
																[
																	-55.326,
																	4.854
																],
																[
																	43.918,
																	4.817
																],
																[
																	43.856,
																	4.827
																],
																[
																	-55.31,
																	4.827
																],
																[
																	-55.326,
																	4.755
																],
																[
																	-55.451,
																	-70.71
																],
																[
																	56.289,
																	-70.747
																],
																[
																	56.467,
																	-70.674
																],
																[
																	-55.297,
																	-70.689
																]
															],
															"c": true
														}
													],
													"e": [
														{
															"i": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"o": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"v": [
																[
																	-56.413,
																	71.799
																],
																[
																	-53.951,
																	71.799
																],
																[
																	-53.951,
																	5.129
																],
																[
																	44.106,
																	5.129
																],
																[
																	44.106,
																	3.077
																],
																[
																	-52.31,
																	3.077
																],
																[
																	-53.951,
																	4.718
																],
																[
																	-53.951,
																	-69.747
																],
																[
																	56.414,
																	-69.747
																],
																[
																	56.414,
																	-71.799
																],
																[
																	-56.413,
																	-71.799
																]
															],
															"c": true
														}
													]
												},
												{
													"i": {
														"x": 0.833,
														"y": 0.833
													},
													"o": {
														"x": 0.167,
														"y": 0.167
													},
													"n": "0p833_0p833_0p167_0p167",
													"t": 119.198,
													"s": [
														{
															"i": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"o": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"v": [
																[
																	-56.413,
																	71.799
																],
																[
																	-53.951,
																	71.799
																],
																[
																	-53.951,
																	5.129
																],
																[
																	44.106,
																	5.129
																],
																[
																	44.106,
																	3.077
																],
																[
																	-52.31,
																	3.077
																],
																[
																	-53.951,
																	4.718
																],
																[
																	-53.951,
																	-69.747
																],
																[
																	56.414,
																	-69.747
																],
																[
																	56.414,
																	-71.799
																],
																[
																	-56.413,
																	-71.799
																]
															],
															"c": true
														}
													],
													"e": [
														{
															"i": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"o": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"v": [
																[
																	-56.413,
																	71.799
																],
																[
																	-39.701,
																	71.882
																],
																[
																	-39.754,
																	12.087
																],
																[
																	44.053,
																	12.004
																],
																[
																	44.053,
																	-4.048
																],
																[
																	-25.738,
																	-4.008
																],
																[
																	-39.654,
																	9.801
																],
																[
																	-39.811,
																	-55.414
																],
																[
																	56.304,
																	-55.497
																],
																[
																	56.414,
																	-71.799
																],
																[
																	-56.413,
																	-71.799
																]
															],
															"c": true
														}
													]
												},
												{
													"i": {
														"x": 0.833,
														"y": 0.833
													},
													"o": {
														"x": 0.167,
														"y": 0.167
													},
													"n": "0p833_0p833_0p167_0p167",
													"t": 239.398,
													"s": [
														{
															"i": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"o": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"v": [
																[
																	-56.413,
																	71.799
																],
																[
																	-39.701,
																	71.882
																],
																[
																	-39.754,
																	12.087
																],
																[
																	44.053,
																	12.004
																],
																[
																	44.053,
																	-4.048
																],
																[
																	-25.738,
																	-4.008
																],
																[
																	-39.654,
																	9.801
																],
																[
																	-39.811,
																	-55.414
																],
																[
																	56.304,
																	-55.497
																],
																[
																	56.414,
																	-71.799
																],
																[
																	-56.413,
																	-71.799
																]
															],
															"c": true
														}
													],
													"e": [
														{
															"i": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"o": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"v": [
																[
																	-56.413,
																	71.799
																],
																[
																	-14.951,
																	71.798
																],
																[
																	-15.108,
																	25.003
																],
																[
																	43.949,
																	25.004
																],
																[
																	43.949,
																	-18.548
																],
																[
																	-1.092,
																	-18.592
																],
																[
																	-14.966,
																	22.967
																],
																[
																	-15.029,
																	-30.998
																],
																[
																	56.336,
																	-30.997
																],
																[
																	56.414,
																	-71.799
																],
																[
																	-56.413,
																	-71.799
																]
															],
															"c": true
														}
													]
												},
												{
													"i": {
														"x": 0.833,
														"y": 0.833
													},
													"o": {
														"x": 0.167,
														"y": 0.167
													},
													"n": "0p833_0p833_0p167_0p167",
													"t": 359.599,
													"s": [
														{
															"i": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"o": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"v": [
																[
																	-56.413,
																	71.799
																],
																[
																	-14.951,
																	71.798
																],
																[
																	-15.108,
																	25.003
																],
																[
																	43.949,
																	25.004
																],
																[
																	43.949,
																	-18.548
																],
																[
																	-1.092,
																	-18.592
																],
																[
																	-14.966,
																	22.967
																],
																[
																	-15.029,
																	-30.998
																],
																[
																	56.336,
																	-30.997
																],
																[
																	56.414,
																	-71.799
																],
																[
																	-56.413,
																	-71.799
																]
															],
															"c": true
														}
													],
													"e": [
														{
															"i": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"o": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"v": [
																[
																	-56.413,
																	71.799
																],
																[
																	56.799,
																	71.88
																],
																[
																	56.376,
																	60.542
																],
																[
																	43.072,
																	60.118
																],
																[
																	42.99,
																	17.014
																],
																[
																	-14.051,
																	16.932
																],
																[
																	55.912,
																	71.718
																],
																[
																	56.649,
																	63.084
																],
																[
																	56.264,
																	63.003
																],
																[
																	56.414,
																	-71.799
																],
																[
																	-56.413,
																	-71.799
																]
															],
															"c": true
														}
													]
												},
												{
													"t": 434.000017677182
												}
											]
										},
										"nm": "Path 1",
										"mn": "ADBE Vector Shape - Group"
									},
									{
										"ty": "fl",
										"c": {
											"a": 0,
											"k": [
												1,
												1,
												1,
												1
											]
										},
										"o": {
											"a": 0,
											"k": 100
										},
										"r": 1,
										"nm": "Fill 1",
										"mn": "ADBE Vector Graphic - Fill"
									},
									{
										"ty": "tr",
										"p": {
											"a": 0,
											"k": [
												809.768,
												333.903
											],
											"ix": 2
										},
										"a": {
											"a": 0,
											"k": [
												0,
												0
											],
											"ix": 1
										},
										"s": {
											"a": 0,
											"k": [
												100,
												100
											],
											"ix": 3
										},
										"r": {
											"a": 0,
											"k": 0,
											"ix": 6
										},
										"o": {
											"a": 0,
											"k": 100,
											"ix": 7
										},
										"sk": {
											"a": 0,
											"k": 0,
											"ix": 4
										},
										"sa": {
											"a": 0,
											"k": 0,
											"ix": 5
										},
										"nm": "Transform"
									}
								],
								"nm": "Group 4",
								"np": 2,
								"cix": 2,
								"ix": 1,
								"mn": "ADBE Vector Group"
							}
						],
						"ip": 1.00000004073083,
						"op": 900.000036657751,
						"st": 0,
						"bm": 0,
						"sr": 1
					}
				]
			},
			{
				"id": "comp_5",
				"layers": [
					{
						"ddd": 0,
						"ind": 1,
						"ty": 4,
						"nm": "R",
						"ks": {
							"o": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": [
												0.833
											],
											"y": [
												0.833
											]
										},
										"o": {
											"x": [
												0.167
											],
											"y": [
												0.167
											]
										},
										"n": [
											"0p833_0p833_0p167_0p167"
										],
										"t": 31,
										"s": [
											0
										],
										"e": [
											100
										]
									},
									{
										"t": 120.0000048877
									}
								]
							},
							"r": {
								"a": 0,
								"k": 0
							},
							"p": {
								"a": 0,
								"k": [
									389.592,
									227.534,
									0
								]
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0,
									0
								]
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100,
									100
								]
							}
						},
						"ao": 0,
						"shapes": [
							{
								"ty": "gr",
								"it": [
									{
										"ind": 0,
										"ty": "sh",
										"ix": 1,
										"ks": {
											"a": 1,
											"k": [
												{
													"i": {
														"x": 0.833,
														"y": 0.833
													},
													"o": {
														"x": 0.167,
														"y": 0.167
													},
													"n": "0p833_0p833_0p167_0p167",
													"t": 1,
													"s": [
														{
															"i": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0.622,
																	-25.414
																],
																[
																	35.272,
																	-0.117
																]
															],
															"o": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	33.833,
																	-0.615
																],
																[
																	-0.62,
																	25.317
																],
																[
																	0,
																	0
																]
															],
															"v": [
																[
																	-60.064,
																	9.305
																],
																[
																	-60.205,
																	8.858
																],
																[
																	-60.318,
																	-70.71
																],
																[
																	-0.603,
																	-70.747
																],
																[
																	51.199,
																	-31.136
																],
																[
																	-0.49,
																	9.305
																]
															],
															"c": true
														}
													],
													"e": [
														{
															"i": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	-25.027
																],
																[
																	33.233,
																	0
																]
															],
															"o": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	33.233,
																	0
																],
																[
																	0,
																	26.052
																],
																[
																	0,
																	0
																]
															],
															"v": [
																[
																	-57.439,
																	7.18
																],
																[
																	-59.08,
																	8.821
																],
																[
																	-59.08,
																	-69.747
																],
																[
																	-0.615,
																	-69.747
																],
																[
																	48.824,
																	-31.386
																],
																[
																	-0.615,
																	7.18
																]
															],
															"c": true
														}
													]
												},
												{
													"i": {
														"x": 0.833,
														"y": 0.833
													},
													"o": {
														"x": 0.167,
														"y": 0.167
													},
													"n": "0p833_0p833_0p167_0p167",
													"t": 119.198,
													"s": [
														{
															"i": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	-25.027
																],
																[
																	33.233,
																	0
																]
															],
															"o": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	33.233,
																	0
																],
																[
																	0,
																	26.052
																],
																[
																	0,
																	0
																]
															],
															"v": [
																[
																	-57.439,
																	7.18
																],
																[
																	-59.08,
																	8.821
																],
																[
																	-59.08,
																	-69.747
																],
																[
																	-0.615,
																	-69.747
																],
																[
																	48.824,
																	-31.386
																],
																[
																	-0.615,
																	7.18
																]
															],
															"c": true
														}
													],
													"e": [
														{
															"i": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0.027,
																	-15.324
																],
																[
																	25.363,
																	-0.117
																]
															],
															"o": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	21.238,
																	0.051
																],
																[
																	-0.04,
																	23.129
																],
																[
																	0,
																	0
																]
															],
															"v": [
																[
																	-29.962,
																	0.394
																],
																[
																	-44.955,
																	14.983
																],
																[
																	-44.978,
																	-55.21
																],
																[
																	0.862,
																	-55.488
																],
																[
																	35.574,
																	-31.363
																],
																[
																	-0.638,
																	0.43
																]
															],
															"c": true
														}
													]
												},
												{
													"i": {
														"x": 0.833,
														"y": 0.833
													},
													"o": {
														"x": 0.167,
														"y": 0.167
													},
													"n": "0p833_0p833_0p167_0p167",
													"t": 239.398,
													"s": [
														{
															"i": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0.027,
																	-15.324
																],
																[
																	25.363,
																	-0.117
																]
															],
															"o": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	21.238,
																	0.051
																],
																[
																	-0.04,
																	23.129
																],
																[
																	0,
																	0
																]
															],
															"v": [
																[
																	-29.962,
																	0.394
																],
																[
																	-44.955,
																	14.983
																],
																[
																	-44.978,
																	-55.21
																],
																[
																	0.862,
																	-55.488
																],
																[
																	35.574,
																	-31.363
																],
																[
																	-0.638,
																	0.43
																]
															],
															"c": true
														}
													],
													"e": [
														{
															"i": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	-0.027,
																	-4.425
																],
																[
																	13.534,
																	-0.509
																]
															],
															"o": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	8.534,
																	-0.199
																],
																[
																	0.027,
																	4.425
																],
																[
																	0,
																	0
																]
															],
															"v": [
																[
																	-3.757,
																	-7.178
																],
																[
																	-21.068,
																	34.75
																],
																[
																	-21.017,
																	-31.381
																],
																[
																	0.823,
																	-31.676
																],
																[
																	11.387,
																	-20.113
																],
																[
																	-2.183,
																	-7.178
																]
															],
															"c": true
														}
													]
												},
												{
													"i": {
														"x": 0.833,
														"y": 0.833
													},
													"o": {
														"x": 0.167,
														"y": 0.167
													},
													"n": "0p833_0p833_0p167_0p167",
													"t": 359.599,
													"s": [
														{
															"i": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	-0.027,
																	-4.425
																],
																[
																	13.534,
																	-0.509
																]
															],
															"o": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	8.534,
																	-0.199
																],
																[
																	0.027,
																	4.425
																],
																[
																	0,
																	0
																]
															],
															"v": [
																[
																	-3.757,
																	-7.178
																],
																[
																	-21.068,
																	34.75
																],
																[
																	-21.017,
																	-31.381
																],
																[
																	0.823,
																	-31.676
																],
																[
																	11.387,
																	-20.113
																],
																[
																	-2.183,
																	-7.178
																]
															],
															"c": true
														}
													],
													"e": [
														{
															"i": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	-0.31,
																	-5.907
																],
																[
																	9.624,
																	-0.34
																]
															],
															"o": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	5.509,
																	0.24
																],
																[
																	0.17,
																	3.244
																],
																[
																	0,
																	0
																]
															],
															"v": [
																[
																	-14.511,
																	-18.086
																],
																[
																	-21.085,
																	34.667
																],
																[
																	-21.017,
																	-31.381
																],
																[
																	-13.659,
																	-31.696
																],
																[
																	-5.57,
																	-25.432
																],
																[
																	-14.273,
																	-18.723
																]
															],
															"c": true
														}
													]
												},
												{
													"i": {
														"x": 0.833,
														"y": 0.833
													},
													"o": {
														"x": 0.167,
														"y": 0.167
													},
													"n": "0p833_0p833_0p167_0p167",
													"t": 414,
													"s": [
														{
															"i": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	-0.31,
																	-5.907
																],
																[
																	9.624,
																	-0.34
																]
															],
															"o": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	5.509,
																	0.24
																],
																[
																	0.17,
																	3.244
																],
																[
																	0,
																	0
																]
															],
															"v": [
																[
																	-14.511,
																	-18.086
																],
																[
																	-21.085,
																	34.667
																],
																[
																	-21.017,
																	-31.381
																],
																[
																	-13.659,
																	-31.696
																],
																[
																	-5.57,
																	-25.432
																],
																[
																	-14.273,
																	-18.723
																]
															],
															"c": true
														}
													],
													"e": [
														{
															"i": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0.084,
																	-4.592
																],
																[
																	4.436,
																	0.239
																]
															],
															"o": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	4.44,
																	-0.261
																],
																[
																	0.084,
																	4.033
																],
																[
																	0,
																	0
																]
															],
															"v": [
																[
																	-22.237,
																	-16.666
																],
																[
																	-22.641,
																	26.923
																],
																[
																	-21.017,
																	-31.381
																],
																[
																	-19.589,
																	-31.551
																],
																[
																	-13.609,
																	-26.471
																],
																[
																	-22.211,
																	-22.302
																]
															],
															"c": true
														}
													]
												},
												{
													"i": {
														"x": 0.833,
														"y": 0.833
													},
													"o": {
														"x": 0.167,
														"y": 0.167
													},
													"n": "0p833_0p833_0p167_0p167",
													"t": 443,
													"s": [
														{
															"i": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0.084,
																	-4.592
																],
																[
																	4.436,
																	0.239
																]
															],
															"o": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	4.44,
																	-0.261
																],
																[
																	0.084,
																	4.033
																],
																[
																	0,
																	0
																]
															],
															"v": [
																[
																	-22.237,
																	-16.666
																],
																[
																	-22.641,
																	26.923
																],
																[
																	-21.017,
																	-31.381
																],
																[
																	-19.589,
																	-31.551
																],
																[
																	-13.609,
																	-26.471
																],
																[
																	-22.211,
																	-22.302
																]
															],
															"c": true
														}
													],
													"e": [
														{
															"i": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	8.923,
																	0.219
																],
																[
																	24.284,
																	-0.259
																]
															],
															"o": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	-0.723,
																	5.488
																],
																[
																	-3.036,
																	-0.075
																],
																[
																	0,
																	0
																]
															],
															"v": [
																[
																	-40.007,
																	-8.178
																],
																[
																	-31.068,
																	-15
																],
																[
																	-21.017,
																	-31.381
																],
																[
																	-20.427,
																	-33.176
																],
																[
																	-25.863,
																	-40.113
																],
																[
																	-65.183,
																	-41.678
																]
															],
															"c": true
														}
													]
												},
												{
													"t": 600.000024438501
												}
											]
										},
										"nm": "Path 1",
										"mn": "ADBE Vector Shape - Group"
									},
									{
										"ind": 1,
										"ty": "sh",
										"ix": 2,
										"ks": {
											"a": 1,
											"k": [
												{
													"i": {
														"x": 0.833,
														"y": 0.833
													},
													"o": {
														"x": 0.167,
														"y": 0.167
													},
													"n": "0p833_0p833_0p167_0p167",
													"t": 1,
													"s": [
														{
															"i": [
																[
																	0,
																	0
																],
																[
																	0,
																	24.001
																],
																[
																	32.823,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"o": [
																[
																	32.823,
																	0
																],
																[
																	0,
																	-23.796
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"v": [
																[
																	2.667,
																	9.231
																],
																[
																	51.285,
																	-31.386
																],
																[
																	2.676,
																	-70.674
																],
																[
																	-60.283,
																	-70.716
																],
																[
																	-60.292,
																	71.757
																],
																[
																	-60.33,
																	71.831
																],
																[
																	-60.205,
																	9.268
																],
																[
																	-1.042,
																	9.189
																],
																[
																	59.68,
																	71.757
																],
																[
																	59.792,
																	71.814
																],
																[
																	-1,
																	9.246
																]
															],
															"c": true
														}
													],
													"e": [
														{
															"i": [
																[
																	0,
																	0
																],
																[
																	0,
																	24.001
																],
																[
																	32.823,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"o": [
																[
																	32.823,
																	0
																],
																[
																	0,
																	-23.796
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"v": [
																[
																	2.667,
																	9.231
																],
																[
																	51.285,
																	-31.386
																],
																[
																	2.667,
																	-71.799
																],
																[
																	-61.542,
																	-71.799
																],
																[
																	-61.542,
																	71.799
																],
																[
																	-59.08,
																	71.799
																],
																[
																	-59.08,
																	9.231
																],
																[
																	-2.667,
																	9.231
																],
																[
																	58.055,
																	71.799
																],
																[
																	61.542,
																	71.799
																],
																[
																	0,
																	9.231
																]
															],
															"c": true
														}
													]
												},
												{
													"i": {
														"x": 0.833,
														"y": 0.833
													},
													"o": {
														"x": 0.167,
														"y": 0.167
													},
													"n": "0p833_0p833_0p167_0p167",
													"t": 119.198,
													"s": [
														{
															"i": [
																[
																	0,
																	0
																],
																[
																	0,
																	24.001
																],
																[
																	32.823,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"o": [
																[
																	32.823,
																	0
																],
																[
																	0,
																	-23.796
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"v": [
																[
																	2.667,
																	9.231
																],
																[
																	51.285,
																	-31.386
																],
																[
																	2.667,
																	-71.799
																],
																[
																	-61.542,
																	-71.799
																],
																[
																	-61.542,
																	71.799
																],
																[
																	-59.08,
																	71.799
																],
																[
																	-59.08,
																	9.231
																],
																[
																	-2.667,
																	9.231
																],
																[
																	58.055,
																	71.799
																],
																[
																	61.542,
																	71.799
																],
																[
																	0,
																	9.231
																]
															],
															"c": true
														}
													],
													"e": [
														{
															"i": [
																[
																	0,
																	0
																],
																[
																	-0.059,
																	31.074
																],
																[
																	28.184,
																	-0.639
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"o": [
																[
																	26.758,
																	-0.433
																],
																[
																	0.046,
																	-24.177
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"v": [
																[
																	7.592,
																	15.746
																],
																[
																	51.16,
																	-30.761
																],
																[
																	4.417,
																	-71.799
																],
																[
																	-61.542,
																	-71.799
																],
																[
																	-61.542,
																	71.799
																],
																[
																	-44.717,
																	71.757
																],
																[
																	-44.78,
																	15.939
																],
																[
																	-14.492,
																	15.996
																],
																[
																	39.18,
																	71.757
																],
																[
																	61.542,
																	71.799
																],
																[
																	7.05,
																	15.996
																]
															],
															"c": true
														}
													]
												},
												{
													"i": {
														"x": 0.833,
														"y": 0.833
													},
													"o": {
														"x": 0.167,
														"y": 0.167
													},
													"n": "0p833_0p833_0p167_0p167",
													"t": 239.398,
													"s": [
														{
															"i": [
																[
																	0,
																	0
																],
																[
																	-0.059,
																	31.074
																],
																[
																	28.184,
																	-0.639
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"o": [
																[
																	26.758,
																	-0.433
																],
																[
																	0.046,
																	-24.177
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"v": [
																[
																	7.592,
																	15.746
																],
																[
																	51.16,
																	-30.761
																],
																[
																	4.417,
																	-71.799
																],
																[
																	-61.542,
																	-71.799
																],
																[
																	-61.542,
																	71.799
																],
																[
																	-44.717,
																	71.757
																],
																[
																	-44.78,
																	15.939
																],
																[
																	-14.492,
																	15.996
																],
																[
																	39.18,
																	71.757
																],
																[
																	61.542,
																	71.799
																],
																[
																	7.05,
																	15.996
																]
															],
															"c": true
														}
													],
													"e": [
														{
															"i": [
																[
																	0,
																	0
																],
																[
																	-0.309,
																	38.949
																],
																[
																	28.184,
																	-0.639
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"o": [
																[
																	11.696,
																	-7.433
																],
																[
																	0.192,
																	-24.176
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"v": [
																[
																	23.78,
																	30.496
																],
																[
																	51.41,
																	-21.636
																],
																[
																	4.417,
																	-71.799
																],
																[
																	-61.542,
																	-71.799
																],
																[
																	-61.542,
																	71.799
																],
																[
																	-20.217,
																	71.676
																],
																[
																	-20.217,
																	40.108
																],
																[
																	-20.242,
																	37.496
																],
																[
																	-4.07,
																	71.798
																],
																[
																	61.542,
																	71.799
																],
																[
																	23.55,
																	30.746
																]
															],
															"c": true
														}
													]
												},
												{
													"i": {
														"x": 0.833,
														"y": 0.833
													},
													"o": {
														"x": 0.167,
														"y": 0.167
													},
													"n": "0p833_0p833_0p167_0p167",
													"t": 359.599,
													"s": [
														{
															"i": [
																[
																	0,
																	0
																],
																[
																	-0.309,
																	38.949
																],
																[
																	28.184,
																	-0.639
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"o": [
																[
																	11.696,
																	-7.433
																],
																[
																	0.192,
																	-24.176
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"v": [
																[
																	23.78,
																	30.496
																],
																[
																	51.41,
																	-21.636
																],
																[
																	4.417,
																	-71.799
																],
																[
																	-61.542,
																	-71.799
																],
																[
																	-61.542,
																	71.799
																],
																[
																	-20.217,
																	71.676
																],
																[
																	-20.217,
																	40.108
																],
																[
																	-20.242,
																	37.496
																],
																[
																	-4.07,
																	71.798
																],
																[
																	61.542,
																	71.799
																],
																[
																	23.55,
																	30.746
																]
															],
															"c": true
														}
													],
													"e": [
														{
															"i": [
																[
																	0,
																	0
																],
																[
																	4.191,
																	38.698
																],
																[
																	34.684,
																	-0.139
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"o": [
																[
																	-1.929,
																	-15.684
																],
																[
																	-2.603,
																	-24.037
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"v": [
																[
																	59.28,
																	47.996
																],
																[
																	53.91,
																	1.864
																],
																[
																	13.917,
																	-71.564
																],
																[
																	-61.542,
																	-71.799
																],
																[
																	-61.542,
																	71.799
																],
																[
																	-20.217,
																	71.676
																],
																[
																	61.783,
																	71.608
																],
																[
																	146.758,
																	-71.004
																],
																[
																	-68.237,
																	72.125
																],
																[
																	61.542,
																	71.799
																],
																[
																	59.05,
																	48.246
																]
															],
															"c": true
														}
													]
												},
												{
													"t": 600.000024438501
												}
											]
										},
										"nm": "Path 2",
										"mn": "ADBE Vector Shape - Group"
									},
									{
										"ty": "fl",
										"c": {
											"a": 0,
											"k": [
												1,
												1,
												1,
												1
											]
										},
										"o": {
											"a": 0,
											"k": 100
										},
										"r": 1,
										"nm": "Fill 1",
										"mn": "ADBE Vector Graphic - Fill"
									},
									{
										"ty": "tr",
										"p": {
											"a": 0,
											"k": [
												681.557,
												333.904
											],
											"ix": 2
										},
										"a": {
											"a": 0,
											"k": [
												0,
												0
											],
											"ix": 1
										},
										"s": {
											"a": 0,
											"k": [
												100,
												100
											],
											"ix": 3
										},
										"r": {
											"a": 0,
											"k": 0,
											"ix": 6
										},
										"o": {
											"a": 0,
											"k": 100,
											"ix": 7
										},
										"sk": {
											"a": 0,
											"k": 0,
											"ix": 4
										},
										"sa": {
											"a": 0,
											"k": 0,
											"ix": 5
										},
										"nm": "Transform"
									}
								],
								"nm": "Group 5",
								"np": 3,
								"cix": 2,
								"ix": 1,
								"mn": "ADBE Vector Group"
							}
						],
						"ip": 1.00000004073083,
						"op": 900.000036657751,
						"st": 0,
						"bm": 0,
						"sr": 1
					}
				]
			},
			{
				"id": "comp_6",
				"layers": [
					{
						"ddd": 0,
						"ind": 1,
						"ty": 4,
						"nm": "P",
						"ks": {
							"o": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": [
												0.833
											],
											"y": [
												0.833
											]
										},
										"o": {
											"x": [
												0.167
											],
											"y": [
												0.167
											]
										},
										"n": [
											"0p833_0p833_0p167_0p167"
										],
										"t": 32,
										"s": [
											0
										],
										"e": [
											100
										]
									},
									{
										"t": 120.0000048877
									}
								]
							},
							"r": {
								"a": 0,
								"k": 0
							},
							"p": {
								"a": 0,
								"k": [
									389.592,
									227.534,
									0
								]
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0,
									0
								]
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100,
									100
								]
							}
						},
						"ao": 0,
						"shapes": [
							{
								"ty": "gr",
								"it": [
									{
										"ind": 0,
										"ty": "sh",
										"ix": 1,
										"ks": {
											"a": 1,
											"k": [
												{
													"i": {
														"x": 0.833,
														"y": 0.833
													},
													"o": {
														"x": 0.167,
														"y": 0.167
													},
													"n": "0p833_0p833_0p167_0p167",
													"t": 1,
													"s": [
														{
															"i": [
																[
																	33.643,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	-0.046,
																	-26.852
																]
															],
															"o": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	35.194,
																	-1.44
																],
																[
																	0.046,
																	27.284
																]
															],
															"v": [
																[
																	3.837,
																	12.158
																],
																[
																	-54.81,
																	12.533
																],
																[
																	-55.202,
																	13.049
																],
																[
																	-55.202,
																	-70.497
																],
																[
																	2.462,
																	-70.622
																],
																[
																	54.827,
																	-29.335
																]
															],
															"c": true
														}
													],
													"e": [
														{
															"i": [
																[
																	33.643,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	-26.463
																]
															],
															"o": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	33.643,
																	0
																],
																[
																	0,
																	27.284
																]
															],
															"v": [
																[
																	2.462,
																	11.283
																],
																[
																	-52.31,
																	11.283
																],
																[
																	-53.952,
																	12.924
																],
																[
																	-53.952,
																	-69.747
																],
																[
																	2.462,
																	-69.747
																],
																[
																	53.952,
																	-29.335
																]
															],
															"c": true
														}
													]
												},
												{
													"i": {
														"x": 0.833,
														"y": 0.833
													},
													"o": {
														"x": 0.167,
														"y": 0.167
													},
													"n": "0p833_0p833_0p167_0p167",
													"t": 119.198,
													"s": [
														{
															"i": [
																[
																	33.643,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	-26.463
																]
															],
															"o": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	33.643,
																	0
																],
																[
																	0,
																	27.284
																]
															],
															"v": [
																[
																	2.462,
																	11.283
																],
																[
																	-52.31,
																	11.283
																],
																[
																	-53.952,
																	12.924
																],
																[
																	-53.952,
																	-69.747
																],
																[
																	2.462,
																	-69.747
																],
																[
																	53.952,
																	-29.335
																]
															],
															"c": true
														}
													],
													"e": [
														{
															"i": [
																[
																	16.819,
																	0.405
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0.079,
																	-22.102
																]
															],
															"o": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	17.391,
																	-0.065
																],
																[
																	-0.098,
																	27.284
																]
															],
															"v": [
																[
																	1.962,
																	3.783
																],
																[
																	-25.185,
																	3.783
																],
																[
																	-39.998,
																	18.32
																],
																[
																	-39.96,
																	-55.914
																],
																[
																	2.515,
																	-55.872
																],
																[
																	40.202,
																	-27.835
																]
															],
															"c": true
														}
													]
												},
												{
													"i": {
														"x": 0.833,
														"y": 0.833
													},
													"o": {
														"x": 0.167,
														"y": 0.167
													},
													"n": "0p833_0p833_0p167_0p167",
													"t": 239.398,
													"s": [
														{
															"i": [
																[
																	16.819,
																	0.405
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0.079,
																	-22.102
																]
															],
															"o": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	17.391,
																	-0.065
																],
																[
																	-0.098,
																	27.284
																]
															],
															"v": [
																[
																	1.962,
																	3.783
																],
																[
																	-25.185,
																	3.783
																],
																[
																	-39.998,
																	18.32
																],
																[
																	-39.96,
																	-55.914
																],
																[
																	2.515,
																	-55.872
																],
																[
																	40.202,
																	-27.835
																]
															],
															"c": true
														}
													],
													"e": [
														{
															"i": [
																[
																	8.819,
																	-0.095
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	-0.046,
																	-3.477
																]
															],
															"o": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	12.783,
																	-0.19
																],
																[
																	0.041,
																	3.149
																]
															],
															"v": [
																[
																	6.712,
																	-8.592
																],
																[
																	1.315,
																	-8.4
																],
																[
																	-15.404,
																	32.36
																],
																[
																	-15.353,
																	-31.623
																],
																[
																	2.623,
																	-31.622
																],
																[
																	15.702,
																	-19.96
																]
															],
															"c": true
														}
													]
												},
												{
													"i": {
														"x": 0.833,
														"y": 0.833
													},
													"o": {
														"x": 0.167,
														"y": 0.167
													},
													"n": "0p833_0p833_0p167_0p167",
													"t": 359.599,
													"s": [
														{
															"i": [
																[
																	8.819,
																	-0.095
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	-0.046,
																	-3.477
																]
															],
															"o": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	12.783,
																	-0.19
																],
																[
																	0.041,
																	3.149
																]
															],
															"v": [
																[
																	6.712,
																	-8.592
																],
																[
																	1.315,
																	-8.4
																],
																[
																	-15.404,
																	32.36
																],
																[
																	-15.353,
																	-31.623
																],
																[
																	2.623,
																	-31.622
																],
																[
																	15.702,
																	-19.96
																]
															],
															"c": true
														}
													],
													"e": [
														{
															"i": [
																[
																	3.278,
																	0.055
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	-0.012,
																	-4.627
																]
															],
															"o": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	2.583,
																	-0.165
																],
																[
																	0.238,
																	4.873
																]
															],
															"v": [
																[
																	-14.372,
																	-1.367
																],
																[
																	-14.844,
																	5.967
																],
																[
																	-15.433,
																	50.094
																],
																[
																	-15.819,
																	-11.556
																],
																[
																	-12.177,
																	-11.772
																],
																[
																	-6.332,
																	-6.56
																]
															],
															"c": true
														}
													]
												},
												{
													"i": {
														"x": 0.833,
														"y": 0.833
													},
													"o": {
														"x": 0.167,
														"y": 0.167
													},
													"n": "0p833_0p833_0p167_0p167",
													"t": 416,
													"s": [
														{
															"i": [
																[
																	3.278,
																	0.055
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	-0.012,
																	-4.627
																]
															],
															"o": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	2.583,
																	-0.165
																],
																[
																	0.238,
																	4.873
																]
															],
															"v": [
																[
																	-14.372,
																	-1.367
																],
																[
																	-14.844,
																	5.967
																],
																[
																	-15.433,
																	50.094
																],
																[
																	-15.819,
																	-11.556
																],
																[
																	-12.177,
																	-11.772
																],
																[
																	-6.332,
																	-6.56
																]
															],
															"c": true
														}
													],
													"e": [
														{
															"i": [
																[
																	1.319,
																	6.03
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0.079,
																	-0.727
																]
															],
															"o": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0.033,
																	-0.065
																],
																[
																	-0.332,
																	3.006
																]
															],
															"v": [
																[
																	-15.538,
																	-92.467
																],
																[
																	-16.435,
																	10.6
																],
																[
																	17.784,
																	64.61
																],
																[
																	-15.103,
																	-4.873
																],
																[
																	-14.252,
																	-4.747
																],
																[
																	-13.049,
																	-3.71
																]
															],
															"c": true
														}
													]
												},
												{
													"t": 600.000024438501
												}
											]
										},
										"nm": "Path 1",
										"mn": "ADBE Vector Shape - Group"
									},
									{
										"ind": 1,
										"ty": "sh",
										"ix": 2,
										"ks": {
											"a": 1,
											"k": [
												{
													"i": {
														"x": 0.833,
														"y": 0.833
													},
													"o": {
														"x": 0.167,
														"y": 0.167
													},
													"n": "0p833_0p833_0p167_0p167",
													"t": 1,
													"s": [
														{
															"i": [
																[
																	33.912,
																	-1.013
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	-0.008,
																	25.648
																]
															],
															"o": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	33.412,
																	-0.396
																],
																[
																	0.007,
																	-25.027
																]
															],
															"v": [
																[
																	5.743,
																	-70.549
																],
																[
																	-55.163,
																	-70.591
																],
																[
																	-55.163,
																	71.757
																],
																[
																	-55.202,
																	71.924
																],
																[
																	-55.202,
																	12.334
																],
																[
																	5.743,
																	12.209
																],
																[
																	54.789,
																	-29.335
																]
															],
															"c": true
														}
													],
													"e": [
														{
															"i": [
																[
																	34.259,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	25.233
																]
															],
															"o": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	34.259,
																	0
																],
																[
																	0,
																	-25.027
																]
															],
															"v": [
																[
																	5.743,
																	-71.799
																],
																[
																	-56.413,
																	-71.799
																],
																[
																	-56.413,
																	71.799
																],
																[
																	-53.952,
																	71.799
																],
																[
																	-53.952,
																	13.334
																],
																[
																	5.743,
																	13.334
																],
																[
																	56.414,
																	-29.335
																]
															],
															"c": true
														}
													]
												},
												{
													"i": {
														"x": 0.833,
														"y": 0.833
													},
													"o": {
														"x": 0.167,
														"y": 0.167
													},
													"n": "0p833_0p833_0p167_0p167",
													"t": 119.198,
													"s": [
														{
															"i": [
																[
																	34.259,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	25.233
																]
															],
															"o": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	34.259,
																	0
																],
																[
																	0,
																	-25.027
																]
															],
															"v": [
																[
																	5.743,
																	-71.799
																],
																[
																	-56.413,
																	-71.799
																],
																[
																	-56.413,
																	71.799
																],
																[
																	-53.952,
																	71.799
																],
																[
																	-53.952,
																	13.334
																],
																[
																	5.743,
																	13.334
																],
																[
																	56.414,
																	-29.335
																]
															],
															"c": true
														}
													],
													"e": [
														{
															"i": [
																[
																	34.259,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	25.233
																]
															],
															"o": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	39.389,
																	-0.521
																],
																[
																	0,
																	-25.027
																]
															],
															"v": [
																[
																	6.172,
																	-71.924
																],
																[
																	-56.36,
																	-72.049
																],
																[
																	-56.413,
																	71.799
																],
																[
																	-40.014,
																	71.757
																],
																[
																	-39.991,
																	20.167
																],
																[
																	5.767,
																	20.209
																],
																[
																	56.789,
																	-27.335
																]
															],
															"c": true
														}
													]
												},
												{
													"i": {
														"x": 0.833,
														"y": 0.833
													},
													"o": {
														"x": 0.167,
														"y": 0.167
													},
													"n": "0p833_0p833_0p167_0p167",
													"t": 239.398,
													"s": [
														{
															"i": [
																[
																	34.259,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	25.233
																]
															],
															"o": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	39.389,
																	-0.521
																],
																[
																	0,
																	-25.027
																]
															],
															"v": [
																[
																	6.172,
																	-71.924
																],
																[
																	-56.36,
																	-72.049
																],
																[
																	-56.413,
																	71.799
																],
																[
																	-40.014,
																	71.757
																],
																[
																	-39.991,
																	20.167
																],
																[
																	5.767,
																	20.209
																],
																[
																	56.789,
																	-27.335
																]
															],
															"c": true
														}
													],
													"e": [
														{
															"i": [
																[
																	34.259,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	-0.008,
																	27.523
																]
															],
															"o": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	46.264,
																	-0.521
																],
																[
																	0.007,
																	-25.027
																]
															],
															"v": [
																[
																	6.172,
																	-71.924
																],
																[
																	-56.36,
																	-72.049
																],
																[
																	-56.413,
																	71.799
																],
																[
																	-15.514,
																	71.798
																],
																[
																	-15.397,
																	34.458
																],
																[
																	5.267,
																	34.459
																],
																[
																	56.789,
																	-27.335
																]
															],
															"c": true
														}
													]
												},
												{
													"i": {
														"x": 0.833,
														"y": 0.833
													},
													"o": {
														"x": 0.167,
														"y": 0.167
													},
													"n": "0p833_0p833_0p167_0p167",
													"t": 359.599,
													"s": [
														{
															"i": [
																[
																	34.259,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	-0.008,
																	27.523
																]
															],
															"o": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	46.264,
																	-0.521
																],
																[
																	0.007,
																	-25.027
																]
															],
															"v": [
																[
																	6.172,
																	-71.924
																],
																[
																	-56.36,
																	-72.049
																],
																[
																	-56.413,
																	71.799
																],
																[
																	-15.514,
																	71.798
																],
																[
																	-15.397,
																	34.458
																],
																[
																	5.267,
																	34.459
																],
																[
																	56.789,
																	-27.335
																]
															],
															"c": true
														}
													],
													"e": [
														{
															"i": [
																[
																	34.259,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	-0.008,
																	27.523
																]
															],
															"o": [
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0.014,
																	-5.896
																],
																[
																	0.007,
																	-25.027
																]
															],
															"v": [
																[
																	6.172,
																	-71.924
																],
																[
																	-56.36,
																	-72.049
																],
																[
																	-56.413,
																	71.799
																],
																[
																	200.861,
																	71.63
																],
																[
																	199.478,
																	-125.667
																],
																[
																	57.142,
																	-5.791
																],
																[
																	56.789,
																	-27.335
																]
															],
															"c": true
														}
													]
												},
												{
													"t": 600.000024438501
												}
											]
										},
										"nm": "Path 2",
										"mn": "ADBE Vector Shape - Group"
									},
									{
										"ty": "fl",
										"c": {
											"a": 0,
											"k": [
												1,
												1,
												1,
												1
											]
										},
										"o": {
											"a": 0,
											"k": 100
										},
										"r": 1,
										"nm": "Fill 1",
										"mn": "ADBE Vector Graphic - Fill"
									},
									{
										"ty": "tr",
										"p": {
											"a": 0,
											"k": [
												409.752,
												333.903
											],
											"ix": 2
										},
										"a": {
											"a": 0,
											"k": [
												0,
												0
											],
											"ix": 1
										},
										"s": {
											"a": 0,
											"k": [
												100,
												100
											],
											"ix": 3
										},
										"r": {
											"a": 0,
											"k": 0,
											"ix": 6
										},
										"o": {
											"a": 0,
											"k": 100,
											"ix": 7
										},
										"sk": {
											"a": 0,
											"k": 0,
											"ix": 4
										},
										"sa": {
											"a": 0,
											"k": 0,
											"ix": 5
										},
										"nm": "Transform"
									}
								],
								"nm": "Group 1",
								"np": 3,
								"cix": 2,
								"ix": 1,
								"mn": "ADBE Vector Group"
							}
						],
						"ip": 1.00000004073083,
						"op": 900.000036657751,
						"st": 0,
						"bm": 0,
						"sr": 1
					}
				]
			},
			{
				"id": "comp_7",
				"layers": [
					{
						"ddd": 0,
						"ind": 1,
						"ty": 4,
						"nm": "U",
						"ks": {
							"o": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": [
												0.833
											],
											"y": [
												0.833
											]
										},
										"o": {
											"x": [
												0.167
											],
											"y": [
												0.167
											]
										},
										"n": [
											"0p833_0p833_0p167_0p167"
										],
										"t": 29,
										"s": [
											0
										],
										"e": [
											100
										]
									},
									{
										"t": 120.0000048877
									}
								]
							},
							"r": {
								"a": 0,
								"k": 0
							},
							"p": {
								"a": 0,
								"k": [
									389.34,
									227.534,
									0
								]
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0,
									0
								]
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100,
									100
								]
							}
						},
						"ao": 0,
						"shapes": [
							{
								"ty": "gr",
								"it": [
									{
										"ind": 0,
										"ty": "sh",
										"ix": 1,
										"ks": {
											"a": 1,
											"k": [
												{
													"i": {
														"x": 0.833,
														"y": 0.833
													},
													"o": {
														"x": 0.167,
														"y": 0.167
													},
													"n": "0p833_0p833_0p167_0p167",
													"t": 1,
													"s": [
														{
															"i": [
																[
																	0,
																	0
																],
																[
																	32.026,
																	-0.568
																],
																[
																	-0.381,
																	43.087
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	-32.139,
																	0.522
																],
																[
																	-0.09,
																	44.843
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"o": [
																[
																	0.559,
																	42.658
																],
																[
																	-32.045,
																	0.568
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0.431,
																	45.487
																],
																[
																	32.139,
																	-0.522
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"v": [
																[
																	55.326,
																	11.077
																],
																[
																	0.063,
																	71.835
																],
																[
																	-55.326,
																	11.099
																],
																[
																	-55.326,
																	-72.803
																],
																[
																	-55.351,
																	-72.824
																],
																[
																	-55.351,
																	9.847
																],
																[
																	0,
																	71.824
																],
																[
																	55.413,
																	9.909
																],
																[
																	55.413,
																	-72.762
																],
																[
																	55.326,
																	-72.824
																]
															],
															"c": true
														}
													],
													"e": [
														{
															"i": [
																[
																	0,
																	0
																],
																[
																	31.591,
																	0
																],
																[
																	0,
																	42.464
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	-32.617,
																	0
																],
																[
																	0,
																	45.746
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"o": [
																[
																	0,
																	42.464
																],
																[
																	-31.592,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	45.746
																],
																[
																	32.617,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"v": [
																[
																	53.952,
																	11.077
																],
																[
																	0,
																	70.772
																],
																[
																	-53.951,
																	11.077
																],
																[
																	-53.951,
																	-72.824
																],
																[
																	-56.413,
																	-72.824
																],
																[
																	-56.413,
																	9.846
																],
																[
																	0,
																	72.824
																],
																[
																	56.413,
																	9.846
																],
																[
																	56.413,
																	-72.824
																],
																[
																	53.952,
																	-72.824
																]
															],
															"c": true
														}
													]
												},
												{
													"i": {
														"x": 0.833,
														"y": 0.833
													},
													"o": {
														"x": 0.167,
														"y": 0.167
													},
													"n": "0p833_0p833_0p167_0p167",
													"t": 119.246,
													"s": [
														{
															"i": [
																[
																	0,
																	0
																],
																[
																	31.591,
																	0
																],
																[
																	0,
																	42.464
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	-32.617,
																	0
																],
																[
																	0,
																	45.746
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"o": [
																[
																	0,
																	42.464
																],
																[
																	-31.592,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	45.746
																],
																[
																	32.617,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"v": [
																[
																	53.952,
																	11.077
																],
																[
																	0,
																	70.772
																],
																[
																	-53.951,
																	11.077
																],
																[
																	-53.951,
																	-72.824
																],
																[
																	-56.413,
																	-72.824
																],
																[
																	-56.413,
																	9.846
																],
																[
																	0,
																	72.824
																],
																[
																	56.413,
																	9.846
																],
																[
																	56.413,
																	-72.824
																],
																[
																	53.952,
																	-72.824
																]
															],
															"c": true
														}
													],
													"e": [
														{
															"i": [
																[
																	0,
																	0
																],
																[
																	31.591,
																	0
																],
																[
																	0.199,
																	21.098
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	-32.617,
																	0
																],
																[
																	-0.416,
																	43.69
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"o": [
																[
																	-0.454,
																	21.848
																],
																[
																	-31.592,
																	0
																],
																[
																	-0.199,
																	-21.098
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	-0.089,
																	41.69
																],
																[
																	32.617,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"v": [
																[
																	39.952,
																	11.189
																],
																[
																	0.091,
																	56.272
																],
																[
																	-39.951,
																	11.189
																],
																[
																	-39.951,
																	-73.213
																],
																[
																	-56.413,
																	-73.324
																],
																[
																	-56.413,
																	9.846
																],
																[
																	0,
																	72.824
																],
																[
																	56.413,
																	9.846
																],
																[
																	56.413,
																	-73.324
																],
																[
																	39.952,
																	-73.213
																]
															],
															"c": true
														}
													]
												},
												{
													"i": {
														"x": 0.833,
														"y": 0.833
													},
													"o": {
														"x": 0.167,
														"y": 0.167
													},
													"n": "0p833_0p833_0p167_0p167",
													"t": 239.498,
													"s": [
														{
															"i": [
																[
																	0,
																	0
																],
																[
																	31.591,
																	0
																],
																[
																	0.199,
																	21.098
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	-32.617,
																	0
																],
																[
																	-0.416,
																	43.69
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"o": [
																[
																	-0.454,
																	21.848
																],
																[
																	-31.592,
																	0
																],
																[
																	-0.199,
																	-21.098
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	-0.089,
																	41.69
																],
																[
																	32.617,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"v": [
																[
																	39.952,
																	11.189
																],
																[
																	0.091,
																	56.272
																],
																[
																	-39.951,
																	11.189
																],
																[
																	-39.951,
																	-73.213
																],
																[
																	-56.413,
																	-73.324
																],
																[
																	-56.413,
																	9.846
																],
																[
																	0,
																	72.824
																],
																[
																	56.413,
																	9.846
																],
																[
																	56.413,
																	-73.324
																],
																[
																	39.952,
																	-73.213
																]
															],
															"c": true
														}
													],
													"e": [
														{
															"i": [
																[
																	0,
																	0
																],
																[
																	7.101,
																	0.014
																],
																[
																	0.449,
																	20.625
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	-32.617,
																	0
																],
																[
																	-0.416,
																	43.69
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"o": [
																[
																	-0.454,
																	21.375
																],
																[
																	-8.527,
																	-0.017
																],
																[
																	-0.459,
																	-21.094
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	-0.089,
																	41.69
																],
																[
																	32.617,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"v": [
																[
																	15.202,
																	11.162
																],
																[
																	0.084,
																	32.897
																],
																[
																	-15.201,
																	11.162
																],
																[
																	-15.201,
																	-73.24
																],
																[
																	-56.413,
																	-73.324
																],
																[
																	-56.413,
																	11.846
																],
																[
																	0,
																	72.824
																],
																[
																	56.413,
																	11.846
																],
																[
																	56.413,
																	-73.324
																],
																[
																	15.202,
																	-73.24
																]
															],
															"c": true
														}
													]
												},
												{
													"i": {
														"x": 0.833,
														"y": 0.833
													},
													"o": {
														"x": 0.167,
														"y": 0.167
													},
													"n": "0p833_0p833_0p167_0p167",
													"t": 359.749,
													"s": [
														{
															"i": [
																[
																	0,
																	0
																],
																[
																	7.101,
																	0.014
																],
																[
																	0.449,
																	20.625
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	-32.617,
																	0
																],
																[
																	-0.416,
																	43.69
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"o": [
																[
																	-0.454,
																	21.375
																],
																[
																	-8.527,
																	-0.017
																],
																[
																	-0.459,
																	-21.094
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	-0.089,
																	41.69
																],
																[
																	32.617,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"v": [
																[
																	15.202,
																	11.162
																],
																[
																	0.084,
																	32.897
																],
																[
																	-15.201,
																	11.162
																],
																[
																	-15.201,
																	-73.24
																],
																[
																	-56.413,
																	-73.324
																],
																[
																	-56.413,
																	11.846
																],
																[
																	0,
																	72.824
																],
																[
																	56.413,
																	11.846
																],
																[
																	56.413,
																	-73.324
																],
																[
																	15.202,
																	-73.24
																]
															],
															"c": true
														}
													],
													"e": [
														{
															"i": [
																[
																	0,
																	0
																],
																[
																	3.47,
																	-0.034
																],
																[
																	0.052,
																	2.272
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	-32.617,
																	0
																],
																[
																	-0.416,
																	43.69
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"o": [
																[
																	0.063,
																	4.772
																],
																[
																	-4.406,
																	0.044
																],
																[
																	-0.555,
																	-5.875
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	-0.089,
																	41.69
																],
																[
																	32.617,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"v": [
																[
																	3.934,
																	-49.485
																],
																[
																	0.029,
																	-43.132
																],
																[
																	-4.054,
																	-49.485
																],
																[
																	-4.443,
																	-73.146
																],
																[
																	-56.413,
																	-73.324
																],
																[
																	-56.413,
																	11.847
																],
																[
																	0,
																	72.824
																],
																[
																	56.413,
																	11.847
																],
																[
																	56.413,
																	-73.324
																],
																[
																	4.443,
																	-73.146
																]
															],
															"c": true
														}
													]
												},
												{
													"i": {
														"x": 0.833,
														"y": 0.833
													},
													"o": {
														"x": 0.167,
														"y": 0.167
													},
													"n": "0p833_0p833_0p167_0p167",
													"t": 446,
													"s": [
														{
															"i": [
																[
																	0,
																	0
																],
																[
																	3.47,
																	-0.034
																],
																[
																	0.052,
																	2.272
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	-32.617,
																	0
																],
																[
																	-0.416,
																	43.69
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"o": [
																[
																	0.063,
																	4.772
																],
																[
																	-4.406,
																	0.044
																],
																[
																	-0.555,
																	-5.875
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	-0.089,
																	41.69
																],
																[
																	32.617,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"v": [
																[
																	3.934,
																	-49.485
																],
																[
																	0.029,
																	-43.132
																],
																[
																	-4.054,
																	-49.485
																],
																[
																	-4.443,
																	-73.146
																],
																[
																	-56.413,
																	-73.324
																],
																[
																	-56.413,
																	11.847
																],
																[
																	0,
																	72.824
																],
																[
																	56.413,
																	11.847
																],
																[
																	56.413,
																	-73.324
																],
																[
																	4.443,
																	-73.146
																]
															],
															"c": true
														}
													],
													"e": [
														{
															"i": [
																[
																	0,
																	0
																],
																[
																	-0.156,
																	0.169
																],
																[
																	-0.192,
																	0.973
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	-32.617,
																	0
																],
																[
																	-0.416,
																	43.69
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"o": [
																[
																	-0.055,
																	0.522
																],
																[
																	-0.281,
																	0.169
																],
																[
																	0.058,
																	0.348
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	-0.089,
																	41.69
																],
																[
																	32.617,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	0
																]
															],
															"v": [
																[
																	0.428,
																	-72.485
																],
																[
																	0.647,
																	-72.257
																],
																[
																	0.564,
																	-73.187
																],
																[
																	0.182,
																	-73.097
																],
																[
																	-56.413,
																	-73.324
																],
																[
																	-56.413,
																	11.846
																],
																[
																	0,
																	72.824
																],
																[
																	56.413,
																	11.846
																],
																[
																	56.413,
																	-73.324
																],
																[
																	0.193,
																	-73.132
																]
															],
															"c": true
														}
													]
												},
												{
													"t": 480.000019550801
												}
											]
										},
										"nm": "Path 1",
										"mn": "ADBE Vector Shape - Group"
									},
									{
										"ty": "fl",
										"c": {
											"a": 0,
											"k": [
												1,
												1,
												1,
												1
											]
										},
										"o": {
											"a": 0,
											"k": 100
										},
										"r": 1,
										"nm": "Fill 1",
										"mn": "ADBE Vector Graphic - Fill"
									},
									{
										"ty": "tr",
										"p": {
											"a": 0,
											"k": [
												276.413,
												334.929
											],
											"ix": 2
										},
										"a": {
											"a": 0,
											"k": [
												0,
												0
											],
											"ix": 1
										},
										"s": {
											"a": 0,
											"k": [
												100,
												100
											],
											"ix": 3
										},
										"r": {
											"a": 0,
											"k": 0,
											"ix": 6
										},
										"o": {
											"a": 0,
											"k": 100,
											"ix": 7
										},
										"sk": {
											"a": 0,
											"k": 0,
											"ix": 4
										},
										"sa": {
											"a": 0,
											"k": 0,
											"ix": 5
										},
										"nm": "Transform"
									}
								],
								"nm": "Group 8",
								"np": 2,
								"cix": 2,
								"ix": 1,
								"mn": "ADBE Vector Group"
							}
						],
						"ip": 1.00000004073083,
						"op": 900.000036657751,
						"st": 0,
						"bm": 0,
						"sr": 1
					}
				]
			},
			{
				"id": "comp_8",
				"layers": [
					{
						"ddd": 0,
						"ind": 1,
						"ty": 4,
						"nm": "Shape Layer 1",
						"td": 1,
						"ks": {
							"o": {
								"a": 0,
								"k": 100
							},
							"r": {
								"a": 0,
								"k": 0
							},
							"p": {
								"a": 0,
								"k": [
									960,
									540,
									0
								]
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0,
									0
								]
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100,
									100
								]
							}
						},
						"ao": 0,
						"shapes": [
							{
								"ty": "gr",
								"it": [
									{
										"ind": 0,
										"ty": "sh",
										"ix": 1,
										"ks": {
											"a": 1,
											"k": [
												{
													"i": {
														"x": 0.833,
														"y": 0.833
													},
													"o": {
														"x": 0.167,
														"y": 0.167
													},
													"n": "0p833_0p833_0p167_0p167",
													"t": 538,
													"s": [
														{
															"i": [
																[
																	25.5,
																	2.75
																],
																[
																	-19,
																	-1.75
																]
															],
															"o": [
																[
																	17.75,
																	1
																],
																[
																	-14,
																	-1.5
																]
															],
															"v": [
																[
																	-476.75,
																	16.5
																],
																[
																	-440.5,
																	20
																]
															],
															"c": true
														}
													],
													"e": [
														{
															"i": [
																[
																	43,
																	-3.75
																],
																[
																	-19,
																	-1.75
																]
															],
															"o": [
																[
																	17.75,
																	1
																],
																[
																	0,
																	-13.75
																]
															],
															"v": [
																[
																	-447.75,
																	-21.5
																],
																[
																	-389.75,
																	-14.5
																]
															],
															"c": true
														}
													]
												},
												{
													"t": 601.000024479232
												}
											]
										},
										"nm": "Path 1",
										"mn": "ADBE Vector Shape - Group"
									},
									{
										"ind": 1,
										"ty": "sh",
										"ix": 2,
										"ks": {
											"a": 1,
											"k": [
												{
													"i": {
														"x": 0.833,
														"y": 0.833
													},
													"o": {
														"x": 0.167,
														"y": 0.167
													},
													"n": "0p833_0p833_0p167_0p167",
													"t": 538,
													"s": [
														{
															"i": [
																[
																	4.25,
																	1
																],
																[
																	-8.73,
																	-1.898
																],
																[
																	0,
																	0
																]
															],
															"o": [
																[
																	-4.25,
																	-1
																],
																[
																	11.5,
																	2.5
																],
																[
																	0,
																	0
																]
															],
															"v": [
																[
																	-473.25,
																	56
																],
																[
																	-443,
																	62.25
																],
																[
																	-430.75,
																	65
																]
															],
															"c": true
														}
													],
													"e": [
														{
															"i": [
																[
																	4.25,
																	1
																],
																[
																	-8.5,
																	-2.75
																],
																[
																	0,
																	0
																]
															],
															"o": [
																[
																	-4.25,
																	-1
																],
																[
																	22.394,
																	7.245
																],
																[
																	0,
																	0
																]
															],
															"v": [
																[
																	-473.25,
																	56
																],
																[
																	-464.25,
																	69.5
																],
																[
																	-429.75,
																	64.75
																]
															],
															"c": true
														}
													]
												},
												{
													"t": 601.000024479232
												}
											]
										},
										"nm": "Path 2",
										"mn": "ADBE Vector Shape - Group"
									},
									{
										"ty": "fl",
										"c": {
											"a": 0,
											"k": [
												1,
												0,
												0,
												1
											]
										},
										"o": {
											"a": 0,
											"k": 100
										},
										"r": 1,
										"nm": "Fill 1",
										"mn": "ADBE Vector Graphic - Fill"
									},
									{
										"ty": "tr",
										"p": {
											"a": 0,
											"k": [
												0,
												0
											],
											"ix": 2
										},
										"a": {
											"a": 0,
											"k": [
												0,
												0
											],
											"ix": 1
										},
										"s": {
											"a": 0,
											"k": [
												100,
												100
											],
											"ix": 3
										},
										"r": {
											"a": 0,
											"k": 0,
											"ix": 6
										},
										"o": {
											"a": 0,
											"k": 100,
											"ix": 7
										},
										"sk": {
											"a": 0,
											"k": 0,
											"ix": 4
										},
										"sa": {
											"a": 0,
											"k": 0,
											"ix": 5
										},
										"nm": "Transform"
									}
								],
								"nm": "Shape 1",
								"np": 4,
								"cix": 2,
								"ix": 1,
								"mn": "ADBE Vector Group"
							}
						],
						"ip": 538.000021913189,
						"op": 1260.00005132085,
						"st": 360.000014663101,
						"bm": 0,
						"sr": 1
					},
					{
						"ddd": 0,
						"ind": 2,
						"ty": 4,
						"nm": "S 2",
						"tt": 2,
						"ks": {
							"o": {
								"a": 0,
								"k": 100
							},
							"r": {
								"a": 0,
								"k": 0
							},
							"p": {
								"a": 0,
								"k": [
									389.592,
									227.534,
									0
								]
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0,
									0
								]
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100,
									100
								]
							}
						},
						"ao": 0,
						"shapes": [
							{
								"ty": "gr",
								"it": [
									{
										"ind": 0,
										"ty": "sh",
										"ix": 1,
										"ks": {
											"a": 1,
											"k": [
												{
													"i": {
														"x": 0.833,
														"y": 0.833
													},
													"o": {
														"x": 0.167,
														"y": 0.167
													},
													"n": "0p833_0p833_0p167_0p167",
													"t": 479.598,
													"s": [
														{
															"i": [
																[
																	0.723,
																	-5.481
																],
																[
																	2.318,
																	-7.26
																],
																[
																	30.378,
																	0.462
																],
																[
																	4.062,
																	23.881
																],
																[
																	0,
																	0
																],
																[
																	0.12,
																	1.059
																],
																[
																	-0.221,
																	4.779
																],
																[
																	-2.728,
																	8.606
																],
																[
																	-30.745,
																	-0.312
																],
																[
																	-10.123,
																	-15.617
																],
																[
																	0,
																	0
																],
																[
																	0.08,
																	-3.764
																]
															],
															"o": [
																[
																	-2.189,
																	16.596
																],
																[
																	-5.065,
																	15.863
																],
																[
																	-35.119,
																	-0.535
																],
																[
																	0,
																	0
																],
																[
																	-0.4,
																	-5.084
																],
																[
																	-0.295,
																	-2.612
																],
																[
																	-0.346,
																	-10.346
																],
																[
																	8.058,
																	-25.421
																],
																[
																	24.512,
																	0.248
																],
																[
																	10.123,
																	15.617
																],
																[
																	0.408,
																	6.189
																],
																[
																	-0.234,
																	11.043
																]
															],
															"v": [
																[
																	55.399,
																	18.09
																],
																[
																	51.266,
																	38.822
																],
																[
																	0.206,
																	73.6
																],
																[
																	-58.603,
																	28.431
																],
																[
																	-61.141,
																	14.021
																],
																[
																	-61.371,
																	5.424
																],
																[
																	-61.32,
																	-1.592
																],
																[
																	-57.688,
																	-33.544
																],
																[
																	0.206,
																	-74.225
																],
																[
																	45.102,
																	-51.376
																],
																[
																	55.423,
																	-18.877
																],
																[
																	56.007,
																	-1.674
																]
															],
															"c": true
														}
													],
													"e": [
														{
															"i": [
																[
																	0.723,
																	-5.482
																],
																[
																	4.305,
																	-6.288
																],
																[
																	30.38,
																	0.293
																],
																[
																	1.005,
																	15.222
																],
																[
																	0,
																	0
																],
																[
																	-0.067,
																	-19.265
																],
																[
																	22.446,
																	28.216
																],
																[
																	-0.086,
																	-35.053
																],
																[
																	-82.238,
																	0.166
																],
																[
																	-10.123,
																	-15.617
																],
																[
																	0,
																	0
																],
																[
																	-0.688,
																	-8.1
																]
															],
															"o": [
																[
																	-2.189,
																	16.596
																],
																[
																	-6.107,
																	8.919
																],
																[
																	-70.257,
																	-0.677
																],
																[
																	0,
																	0
																],
																[
																	2.527,
																	19.384
																],
																[
																	-88.309,
																	-14.126
																],
																[
																	-10.784,
																	41.268
																],
																[
																	0.72,
																	0.696
																],
																[
																	24.513,
																	-0.05
																],
																[
																	10.123,
																	15.617
																],
																[
																	0.408,
																	6.189
																],
																[
																	1.261,
																	14.849
																]
															],
															"v": [
																[
																	55.399,
																	18.09
																],
																[
																	39.037,
																	51.841
																],
																[
																	0.206,
																	73.6
																],
																[
																	-62.973,
																	-47.812
																],
																[
																	51.785,
																	-33.157
																],
																[
																	59.209,
																	55.985
																],
																[
																	-59.343,
																	-16.345
																],
																[
																	-69.293,
																	58.474
																],
																[
																	0.208,
																	-73.225
																],
																[
																	43.853,
																	-50.624
																],
																[
																	53.421,
																	-19.874
																],
																[
																	55.257,
																	-1.673
																]
															],
															"c": true
														}
													]
												},
												{
													"t": 600.000024438501
												}
											]
										},
										"nm": "Path 1",
										"mn": "ADBE Vector Shape - Group"
									},
									{
										"ty": "fl",
										"c": {
											"a": 0,
											"k": [
												1,
												1,
												1,
												1
											]
										},
										"o": {
											"a": 0,
											"k": 100
										},
										"r": 1,
										"nm": "Fill 1",
										"mn": "ADBE Vector Graphic - Fill"
									},
									{
										"ty": "tr",
										"p": {
											"a": 0,
											"k": [
												143.074,
												333.904
											],
											"ix": 2
										},
										"a": {
											"a": 0,
											"k": [
												0,
												0
											],
											"ix": 1
										},
										"s": {
											"a": 0,
											"k": [
												100,
												100
											],
											"ix": 3
										},
										"r": {
											"a": 0,
											"k": 0.09,
											"ix": 6
										},
										"o": {
											"a": 0,
											"k": 100,
											"ix": 7
										},
										"sk": {
											"a": 0,
											"k": 0,
											"ix": 4
										},
										"sa": {
											"a": 0,
											"k": 0,
											"ix": 5
										},
										"nm": "Transform"
									}
								],
								"nm": "Group 9",
								"np": 2,
								"cix": 2,
								"ix": 1,
								"mn": "ADBE Vector Group"
							}
						],
						"ip": 480.000019550801,
						"op": 959.000039060871,
						"st": 59.0000024031193,
						"bm": 0,
						"sr": 1
					},
					{
						"ddd": 0,
						"ind": 3,
						"ty": 4,
						"nm": "mate 1",
						"td": 1,
						"ks": {
							"o": {
								"a": 0,
								"k": 100
							},
							"r": {
								"a": 0,
								"k": 0
							},
							"p": {
								"a": 0,
								"k": [
									390.5,
									228,
									0
								]
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0,
									0
								]
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100,
									100
								]
							}
						},
						"ao": 0,
						"shapes": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 1,
									"k": [
										{
											"i": {
												"x": 0.833,
												"y": 0.833
											},
											"o": {
												"x": 0.167,
												"y": 0.167
											},
											"n": "0p833_0p833_0p167_0p167",
											"t": 437,
											"s": [
												{
													"i": [
														[
															-0.112,
															17.378
														],
														[
															1.751,
															15.911
														],
														[
															5.061,
															7.808
														],
														[
															7.832,
															3.729
														],
														[
															12.256,
															0.124
														],
														[
															9.686,
															-5.844
														],
														[
															4.029,
															-12.711
														],
														[
															0.487,
															-13.087
														],
														[
															0.141,
															-8.413
														],
														[
															-11.063,
															-8.412
														],
														[
															-17.559,
															-0.268
														],
														[
															-11.348,
															8.403
														]
													],
													"o": [
														[
															0.017,
															-2.764
														],
														[
															-1.751,
															-15.911
														],
														[
															-5.061,
															-7.808
														],
														[
															-7.832,
															-3.729
														],
														[
															-15.373,
															-0.156
														],
														[
															-9.686,
															5.844
														],
														[
															-1.364,
															4.303
														],
														[
															-0.487,
															13.087
														],
														[
															-0.217,
															12.912
														],
														[
															11.064,
															8.412
														],
														[
															15.189,
															0.231
														],
														[
															11.348,
															-8.403
														]
													],
													"v": [
														[
															203.973,
															356.744
														],
														[
															201.759,
															323.419
														],
														[
															191.926,
															282.528
														],
														[
															172.999,
															265.34
														],
														[
															143.28,
															259.679
														],
														[
															105.7,
															267.995
														],
														[
															85.136,
															295.61
														],
														[
															82.492,
															325.06
														],
														[
															81.683,
															360.675
														],
														[
															99.149,
															393.573
														],
														[
															143.28,
															407.504
														],
														[
															184.935,
															395.331
														]
													],
													"c": true
												}
											],
											"e": [
												{
													"i": [
														[
															-2.189,
															16.596
														],
														[
															-0.234,
															11.043
														],
														[
															0.408,
															6.189
														],
														[
															10.123,
															15.617
														],
														[
															24.512,
															0.248
														],
														[
															8.058,
															-25.421
														],
														[
															-0.346,
															-10.345
														],
														[
															-0.295,
															-2.612
														],
														[
															-0.4,
															-5.084
														],
														[
															0,
															0
														],
														[
															-35.119,
															-0.535
														],
														[
															-5.065,
															15.863
														]
													],
													"o": [
														[
															0.723,
															-5.481
														],
														[
															0.08,
															-3.764
														],
														[
															0,
															0
														],
														[
															-10.123,
															-15.617
														],
														[
															-30.745,
															-0.312
														],
														[
															-2.728,
															8.606
														],
														[
															-0.221,
															4.779
														],
														[
															0.12,
															1.059
														],
														[
															0,
															0
														],
														[
															4.062,
															23.881
														],
														[
															30.378,
															0.462
														],
														[
															2.318,
															-7.26
														]
													],
													"v": [
														[
															198.473,
															351.994
														],
														[
															199.08,
															332.229
														],
														[
															198.497,
															315.027
														],
														[
															188.176,
															282.528
														],
														[
															143.28,
															259.679
														],
														[
															85.386,
															300.36
														],
														[
															81.754,
															332.312
														],
														[
															81.703,
															339.328
														],
														[
															81.933,
															347.925
														],
														[
															84.471,
															362.335
														],
														[
															143.28,
															407.504
														],
														[
															194.34,
															372.726
														]
													],
													"c": true
												}
											]
										},
										{
											"t": 479.00001951007
										}
									]
								},
								"nm": "Path 1",
								"mn": "ADBE Vector Shape - Group"
							},
							{
								"ty": "fl",
								"c": {
									"a": 0,
									"k": [
										1,
										0,
										0,
										1
									]
								},
								"o": {
									"a": 0,
									"k": 100
								},
								"r": 1,
								"nm": "Fill 1",
								"mn": "ADBE Vector Graphic - Fill"
							}
						],
						"ip": 359.00001462237,
						"op": 900.000036657751,
						"st": 0,
						"bm": 0,
						"sr": 1
					},
					{
						"ddd": 0,
						"ind": 4,
						"ty": 4,
						"nm": "S",
						"tt": 1,
						"ks": {
							"o": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": [
												0.833
											],
											"y": [
												0.833
											]
										},
										"o": {
											"x": [
												0.167
											],
											"y": [
												0.167
											]
										},
										"n": [
											"0p833_0p833_0p167_0p167"
										],
										"t": 31,
										"s": [
											0
										],
										"e": [
											100
										]
									},
									{
										"t": 119.000004846969
									}
								]
							},
							"r": {
								"a": 0,
								"k": 0
							},
							"p": {
								"a": 0,
								"k": [
									389.592,
									227.534,
									0
								]
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0,
									0
								]
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100,
									100
								]
							}
						},
						"ao": 0,
						"shapes": [
							{
								"ty": "gr",
								"it": [
									{
										"ind": 0,
										"ty": "sh",
										"ix": 1,
										"ks": {
											"a": 1,
											"k": [
												{
													"i": {
														"x": 0.833,
														"y": 0.833
													},
													"o": {
														"x": 0.167,
														"y": 0.167
													},
													"n": "0p833_0p833_0p167_0p167",
													"t": 2,
													"s": [
														{
															"i": [
																[
																	-0.292,
																	-25.205
																],
																[
																	1.365,
																	-53.253
																],
																[
																	32.839,
																	-0.82
																],
																[
																	0,
																	29.54
																],
																[
																	0,
																	0
																],
																[
																	-31.655,
																	0.803
																],
																[
																	0.464,
																	25.368
																],
																[
																	-0.122,
																	55.193
																],
																[
																	-28.31,
																	0
																],
																[
																	0,
																	-19.488
																],
																[
																	0,
																	0
																],
																[
																	35.112,
																	0.456
																]
															],
															"o": [
																[
																	0.637,
																	54.923
																],
																[
																	-0.684,
																	26.682
																],
																[
																	-33.838,
																	0.845
																],
																[
																	0,
																	0
																],
																[
																	-0.446,
																	29.89
																],
																[
																	31.469,
																	-0.798
																],
																[
																	-0.992,
																	-54.194
																],
																[
																	0.059,
																	-26.668
																],
																[
																	36.719,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0.39,
																	-19.626
																],
																[
																	-29.512,
																	-0.383
																]
															],
															"v": [
																[
																	-56.039,
																	-34.97
																],
																[
																	59.391,
																	32.949
																],
																[
																	0.142,
																	72.663
																],
																[
																	-59.516,
																	31.242
																],
																[
																	-59.554,
																	31.308
																],
																[
																	0.145,
																	72.674
																],
																[
																	59.43,
																	33.31
																],
																[
																	-56.001,
																	-34.984
																],
																[
																	0.193,
																	-72.912
																],
																[
																	54.201,
																	-33.625
																],
																[
																	54.239,
																	-33.629
																],
																[
																	0.19,
																	-72.924
																]
															],
															"c": true
														}
													],
													"e": [
														{
															"i": [
																[
																	0,
																	-23.591
																],
																[
																	0,
																	-54.977
																],
																[
																	33.437,
																	0
																],
																[
																	0,
																	29.54
																],
																[
																	0,
																	0
																],
																[
																	-31.592,
																	0
																],
																[
																	0,
																	24.822
																],
																[
																	0,
																	55.798
																],
																[
																	-28.31,
																	0
																],
																[
																	0,
																	-19.488
																],
																[
																	0,
																	0
																],
																[
																	34.668,
																	0
																]
															],
															"o": [
																[
																	0,
																	53.952
																],
																[
																	0,
																	27.694
																],
																[
																	-33.849,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	28.309
																],
																[
																	31.181,
																	0
																],
																[
																	0,
																	-53.131
																],
																[
																	0,
																	-26.668
																],
																[
																	36.719,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	-19.078
																],
																[
																	-29.335,
																	0
																]
															],
															"v": [
																[
																	-54.977,
																	-35.284
																],
																[
																	60.516,
																	32.822
																],
																[
																	0.206,
																	73.85
																],
																[
																	-60.516,
																	31.181
																],
																[
																	-58.054,
																	31.181
																],
																[
																	0.206,
																	71.799
																],
																[
																	58.055,
																	33.437
																],
																[
																	-57.438,
																	-34.669
																],
																[
																	0.206,
																	-73.85
																],
																[
																	55.388,
																	-33.643
																],
																[
																	52.926,
																	-33.643
																],
																[
																	0.206,
																	-71.799
																]
															],
															"c": true
														}
													]
												},
												{
													"i": {
														"x": 0.833,
														"y": 0.833
													},
													"o": {
														"x": 0.167,
														"y": 0.167
													},
													"n": "0p833_0p833_0p167_0p167",
													"t": 116.383,
													"s": [
														{
															"i": [
																[
																	0,
																	-23.591
																],
																[
																	0,
																	-54.977
																],
																[
																	33.437,
																	0
																],
																[
																	0,
																	29.54
																],
																[
																	0,
																	0
																],
																[
																	-31.592,
																	0
																],
																[
																	0,
																	24.822
																],
																[
																	0,
																	55.798
																],
																[
																	-28.31,
																	0
																],
																[
																	0,
																	-19.488
																],
																[
																	0,
																	0
																],
																[
																	34.668,
																	0
																]
															],
															"o": [
																[
																	0,
																	53.952
																],
																[
																	0,
																	27.694
																],
																[
																	-33.849,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	28.309
																],
																[
																	31.181,
																	0
																],
																[
																	0,
																	-53.131
																],
																[
																	0,
																	-26.668
																],
																[
																	36.719,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	-19.078
																],
																[
																	-29.335,
																	0
																]
															],
															"v": [
																[
																	-54.977,
																	-35.284
																],
																[
																	60.516,
																	32.822
																],
																[
																	0.206,
																	73.85
																],
																[
																	-60.516,
																	31.181
																],
																[
																	-58.054,
																	31.181
																],
																[
																	0.206,
																	71.799
																],
																[
																	58.055,
																	33.437
																],
																[
																	-57.438,
																	-34.669
																],
																[
																	0.206,
																	-73.85
																],
																[
																	55.388,
																	-33.643
																],
																[
																	52.926,
																	-33.643
																],
																[
																	0.206,
																	-71.799
																]
															],
															"c": true
														}
													],
													"e": [
														{
															"i": [
																[
																	0.197,
																	-19.283
																],
																[
																	-0.182,
																	-57.76
																],
																[
																	33.437,
																	0
																],
																[
																	0,
																	29.54
																],
																[
																	0,
																	0
																],
																[
																	-31.588,
																	-0.5
																],
																[
																	0.404,
																	20.154
																],
																[
																	0.522,
																	57.856
																],
																[
																	-28.31,
																	0
																],
																[
																	0,
																	-19.488
																],
																[
																	0,
																	0
																],
																[
																	20.955,
																	-0.014
																]
															],
															"o": [
																[
																	-0.439,
																	42.971
																],
																[
																	0.087,
																	27.694
																],
																[
																	-33.849,
																	0
																],
																[
																	0,
																	0
																],
																[
																	1.888,
																	18.131
																],
																[
																	16.628,
																	0.263
																],
																[
																	-0.346,
																	-40.846
																],
																[
																	-0.241,
																	-26.667
																],
																[
																	36.719,
																	0
																],
																[
																	0,
																	0
																],
																[
																	-2.592,
																	-16.936
																],
																[
																	-20.955,
																	0.014
																]
															],
															"v": [
																[
																	-41.102,
																	-35.534
																],
																[
																	60.516,
																	32.822
																],
																[
																	0.206,
																	73.85
																],
																[
																	-60.516,
																	31.181
																],
																[
																	-44.804,
																	31.181
																],
																[
																	0.706,
																	57.799
																],
																[
																	43.43,
																	33.408
																],
																[
																	-57.438,
																	-34.669
																],
																[
																	0.206,
																	-73.85
																],
																[
																	55.388,
																	-33.643
																],
																[
																	38.551,
																	-33.627
																],
																[
																	0.254,
																	-59.549
																]
															],
															"c": true
														}
													]
												},
												{
													"i": {
														"x": 0.833,
														"y": 0.833
													},
													"o": {
														"x": 0.167,
														"y": 0.167
													},
													"n": "0p833_0p833_0p167_0p167",
													"t": 238.793,
													"s": [
														{
															"i": [
																[
																	0.197,
																	-19.283
																],
																[
																	-0.182,
																	-57.76
																],
																[
																	33.437,
																	0
																],
																[
																	0,
																	29.54
																],
																[
																	0,
																	0
																],
																[
																	-31.588,
																	-0.5
																],
																[
																	0.404,
																	20.154
																],
																[
																	0.522,
																	57.856
																],
																[
																	-28.31,
																	0
																],
																[
																	0,
																	-19.488
																],
																[
																	0,
																	0
																],
																[
																	20.955,
																	-0.014
																]
															],
															"o": [
																[
																	-0.439,
																	42.971
																],
																[
																	0.087,
																	27.694
																],
																[
																	-33.849,
																	0
																],
																[
																	0,
																	0
																],
																[
																	1.888,
																	18.131
																],
																[
																	16.628,
																	0.263
																],
																[
																	-0.346,
																	-40.846
																],
																[
																	-0.241,
																	-26.667
																],
																[
																	36.719,
																	0
																],
																[
																	0,
																	0
																],
																[
																	-2.592,
																	-16.936
																],
																[
																	-20.955,
																	0.014
																]
															],
															"v": [
																[
																	-41.102,
																	-35.534
																],
																[
																	60.516,
																	32.822
																],
																[
																	0.206,
																	73.85
																],
																[
																	-60.516,
																	31.181
																],
																[
																	-44.804,
																	31.181
																],
																[
																	0.706,
																	57.799
																],
																[
																	43.43,
																	33.408
																],
																[
																	-57.438,
																	-34.669
																],
																[
																	0.206,
																	-73.85
																],
																[
																	55.388,
																	-33.643
																],
																[
																	38.551,
																	-33.627
																],
																[
																	0.254,
																	-59.549
																]
															],
															"c": true
														}
													],
													"e": [
														{
															"i": [
																[
																	0.102,
																	-5.528
																],
																[
																	2.977,
																	-62.946
																],
																[
																	33.436,
																	0.274
																],
																[
																	0,
																	29.54
																],
																[
																	0,
																	0
																],
																[
																	-8.673,
																	0.076
																],
																[
																	-0.221,
																	4.779
																],
																[
																	-2.728,
																	64.481
																],
																[
																	-30.747,
																	-0.03
																],
																[
																	0,
																	-19.488
																],
																[
																	0,
																	0
																],
																[
																	9.83,
																	-0.139
																]
															],
															"o": [
																[
																	-0.314,
																	17.096
																],
																[
																	-1.182,
																	24.99
																],
																[
																	-35.122,
																	-0.288
																],
																[
																	0,
																	0
																],
																[
																	2.1,
																	9.916
																],
																[
																	12.705,
																	-0.112
																],
																[
																	-0.096,
																	-17.846
																],
																[
																	1.127,
																	-26.644
																],
																[
																	38.378,
																	0.037
																],
																[
																	0,
																	0
																],
																[
																	-2.092,
																	-6.561
																],
																[
																	-11.044,
																	0.156
																]
															],
															"v": [
																[
																	-15.102,
																	-29.534
																],
																[
																	61.766,
																	30.072
																],
																[
																	0.206,
																	73.6
																],
																[
																	-60.478,
																	24.681
																],
																[
																	-19.766,
																	24.646
																],
																[
																	1.254,
																	37.049
																],
																[
																	19.68,
																	27.658
																],
																[
																	-56.688,
																	-32.294
																],
																[
																	0.206,
																	-74.225
																],
																[
																	55.888,
																	-28.393
																],
																[
																	14.551,
																	-28.502
																],
																[
																	-1.621,
																	-38.674
																]
															],
															"c": true
														}
													]
												},
												{
													"i": {
														"x": 0.833,
														"y": 0.833
													},
													"o": {
														"x": 0.167,
														"y": 0.167
													},
													"n": "0p833_0p833_0p167_0p167",
													"t": 359,
													"s": [
														{
															"i": [
																[
																	0.102,
																	-5.528
																],
																[
																	2.977,
																	-62.946
																],
																[
																	33.436,
																	0.274
																],
																[
																	0,
																	29.54
																],
																[
																	0,
																	0
																],
																[
																	-8.673,
																	0.076
																],
																[
																	-0.221,
																	4.779
																],
																[
																	-2.728,
																	64.481
																],
																[
																	-30.747,
																	-0.03
																],
																[
																	0,
																	-19.488
																],
																[
																	0,
																	0
																],
																[
																	9.83,
																	-0.139
																]
															],
															"o": [
																[
																	-0.314,
																	17.096
																],
																[
																	-1.182,
																	24.99
																],
																[
																	-35.122,
																	-0.288
																],
																[
																	0,
																	0
																],
																[
																	2.1,
																	9.916
																],
																[
																	12.705,
																	-0.112
																],
																[
																	-0.096,
																	-17.846
																],
																[
																	1.127,
																	-26.644
																],
																[
																	38.378,
																	0.037
																],
																[
																	0,
																	0
																],
																[
																	-2.092,
																	-6.561
																],
																[
																	-11.044,
																	0.156
																]
															],
															"v": [
																[
																	-15.102,
																	-29.534
																],
																[
																	61.766,
																	30.072
																],
																[
																	0.206,
																	73.6
																],
																[
																	-60.478,
																	24.681
																],
																[
																	-19.766,
																	24.646
																],
																[
																	1.254,
																	37.049
																],
																[
																	19.68,
																	27.658
																],
																[
																	-56.688,
																	-32.294
																],
																[
																	0.206,
																	-74.225
																],
																[
																	55.888,
																	-28.393
																],
																[
																	14.551,
																	-28.502
																],
																[
																	-1.621,
																	-38.674
																]
															],
															"c": true
														}
													],
													"e": [
														{
															"i": [
																[
																	0.102,
																	-5.528
																],
																[
																	2.977,
																	-62.946
																],
																[
																	33.436,
																	0.274
																],
																[
																	0,
																	29.54
																],
																[
																	0,
																	0
																],
																[
																	-8.673,
																	0.076
																],
																[
																	-0.221,
																	4.779
																],
																[
																	-2.728,
																	64.481
																],
																[
																	-30.747,
																	-0.03
																],
																[
																	0,
																	-19.488
																],
																[
																	0,
																	0
																],
																[
																	9.83,
																	-0.139
																]
															],
															"o": [
																[
																	-0.314,
																	17.096
																],
																[
																	-1.182,
																	24.99
																],
																[
																	-35.122,
																	-0.288
																],
																[
																	0,
																	0
																],
																[
																	2.1,
																	9.916
																],
																[
																	12.705,
																	-0.112
																],
																[
																	-0.096,
																	-17.846
																],
																[
																	1.127,
																	-26.644
																],
																[
																	38.378,
																	0.037
																],
																[
																	0,
																	0
																],
																[
																	-2.092,
																	-6.561
																],
																[
																	-11.044,
																	0.156
																]
															],
															"v": [
																[
																	-15.102,
																	-29.534
																],
																[
																	61.766,
																	30.072
																],
																[
																	0.206,
																	73.6
																],
																[
																	-60.478,
																	24.681
																],
																[
																	-19.766,
																	24.646
																],
																[
																	1.254,
																	37.049
																],
																[
																	19.68,
																	27.658
																],
																[
																	-56.688,
																	-32.294
																],
																[
																	0.206,
																	-74.225
																],
																[
																	55.888,
																	-28.393
																],
																[
																	14.551,
																	-28.502
																],
																[
																	-1.621,
																	-38.674
																]
															],
															"c": true
														}
													]
												},
												{
													"i": {
														"x": 0.833,
														"y": 0.833
													},
													"o": {
														"x": 0.167,
														"y": 0.167
													},
													"n": "0p833_0p833_0p167_0p167",
													"t": 480,
													"s": [
														{
															"i": [
																[
																	0.102,
																	-5.528
																],
																[
																	2.977,
																	-62.946
																],
																[
																	33.436,
																	0.274
																],
																[
																	0,
																	29.54
																],
																[
																	0,
																	0
																],
																[
																	-8.673,
																	0.076
																],
																[
																	-0.221,
																	4.779
																],
																[
																	-2.728,
																	64.481
																],
																[
																	-30.747,
																	-0.03
																],
																[
																	0,
																	-19.488
																],
																[
																	0,
																	0
																],
																[
																	9.83,
																	-0.139
																]
															],
															"o": [
																[
																	-0.314,
																	17.096
																],
																[
																	-1.182,
																	24.99
																],
																[
																	-35.122,
																	-0.288
																],
																[
																	0,
																	0
																],
																[
																	2.1,
																	9.916
																],
																[
																	12.705,
																	-0.112
																],
																[
																	-0.096,
																	-17.846
																],
																[
																	1.127,
																	-26.644
																],
																[
																	38.378,
																	0.037
																],
																[
																	0,
																	0
																],
																[
																	-2.092,
																	-6.561
																],
																[
																	-11.044,
																	0.156
																]
															],
															"v": [
																[
																	-15.102,
																	-29.534
																],
																[
																	61.766,
																	30.072
																],
																[
																	0.206,
																	73.6
																],
																[
																	-60.478,
																	24.681
																],
																[
																	-19.766,
																	24.646
																],
																[
																	1.254,
																	37.049
																],
																[
																	19.68,
																	27.658
																],
																[
																	-56.688,
																	-32.294
																],
																[
																	0.206,
																	-74.225
																],
																[
																	55.888,
																	-28.393
																],
																[
																	14.551,
																	-28.502
																],
																[
																	-1.621,
																	-38.674
																]
															],
															"c": true
														}
													],
													"e": [
														{
															"i": [
																[
																	0.723,
																	-5.482
																],
																[
																	4.305,
																	-6.288
																],
																[
																	30.38,
																	0.293
																],
																[
																	1.005,
																	15.222
																],
																[
																	0,
																	0
																],
																[
																	-0.067,
																	-19.265
																],
																[
																	22.446,
																	28.216
																],
																[
																	-0.086,
																	-35.053
																],
																[
																	-82.238,
																	0.166
																],
																[
																	-10.123,
																	-15.617
																],
																[
																	0,
																	0
																],
																[
																	-0.688,
																	-8.1
																]
															],
															"o": [
																[
																	-2.189,
																	16.596
																],
																[
																	-6.107,
																	8.919
																],
																[
																	-70.257,
																	-0.677
																],
																[
																	0,
																	0
																],
																[
																	2.527,
																	19.384
																],
																[
																	-88.309,
																	-14.126
																],
																[
																	-10.784,
																	41.268
																],
																[
																	0.72,
																	0.696
																],
																[
																	24.513,
																	-0.05
																],
																[
																	10.123,
																	15.617
																],
																[
																	0.408,
																	6.189
																],
																[
																	1.261,
																	14.849
																]
															],
															"v": [
																[
																	55.399,
																	18.09
																],
																[
																	39.037,
																	51.841
																],
																[
																	0.206,
																	73.6
																],
																[
																	-62.973,
																	-47.812
																],
																[
																	51.785,
																	-33.157
																],
																[
																	59.209,
																	55.985
																],
																[
																	-59.343,
																	-16.345
																],
																[
																	-69.293,
																	58.474
																],
																[
																	0.208,
																	-73.225
																],
																[
																	43.853,
																	-50.624
																],
																[
																	53.421,
																	-19.874
																],
																[
																	55.257,
																	-1.673
																]
															],
															"c": true
														}
													]
												},
												{
													"t": 600.000024438501
												}
											]
										},
										"nm": "Path 1",
										"mn": "ADBE Vector Shape - Group"
									},
									{
										"ty": "st",
										"c": {
											"a": 0,
											"k": [
												1,
												1,
												1,
												1
											]
										},
										"o": {
											"a": 0,
											"k": 100
										},
										"w": {
											"a": 1,
											"k": [
												{
													"i": {
														"x": [
															0.833
														],
														"y": [
															0.833
														]
													},
													"o": {
														"x": [
															0.167
														],
														"y": [
															0.167
														]
													},
													"n": [
														"0p833_0p833_0p167_0p167"
													],
													"t": 359,
													"s": [
														0
													],
													"e": [
														23
													]
												},
												{
													"i": {
														"x": [
															0.833
														],
														"y": [
															0.833
														]
													},
													"o": {
														"x": [
															0.167
														],
														"y": [
															0.167
														]
													},
													"n": [
														"0p833_0p833_0p167_0p167"
													],
													"t": 479,
													"s": [
														23
													],
													"e": [
														48
													]
												},
												{
													"t": 480.000019550801
												}
											]
										},
										"lc": 1,
										"lj": 1,
										"ml": 4,
										"nm": "Stroke 1",
										"mn": "ADBE Vector Graphic - Stroke"
									},
									{
										"ty": "fl",
										"c": {
											"a": 0,
											"k": [
												1,
												1,
												1,
												1
											]
										},
										"o": {
											"a": 0,
											"k": 100
										},
										"r": 1,
										"nm": "Fill 1",
										"mn": "ADBE Vector Graphic - Fill"
									},
									{
										"ty": "tr",
										"p": {
											"a": 0,
											"k": [
												143.074,
												333.904
											],
											"ix": 2
										},
										"a": {
											"a": 0,
											"k": [
												0,
												0
											],
											"ix": 1
										},
										"s": {
											"a": 0,
											"k": [
												100,
												100
											],
											"ix": 3
										},
										"r": {
											"a": 0,
											"k": 0.09,
											"ix": 6
										},
										"o": {
											"a": 0,
											"k": 100,
											"ix": 7
										},
										"sk": {
											"a": 0,
											"k": 0,
											"ix": 4
										},
										"sa": {
											"a": 0,
											"k": 0,
											"ix": 5
										},
										"nm": "Transform"
									}
								],
								"nm": "Group 9",
								"np": 3,
								"cix": 2,
								"ix": 1,
								"mn": "ADBE Vector Group"
							}
						],
						"ip": 359.00001462237,
						"op": 481.000019591532,
						"st": 59.0000024031193,
						"bm": 0,
						"sr": 1
					},
					{
						"ddd": 0,
						"ind": 5,
						"ty": 4,
						"nm": "S 3",
						"ks": {
							"o": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": [
												0.833
											],
											"y": [
												0.833
											]
										},
										"o": {
											"x": [
												0.167
											],
											"y": [
												0.167
											]
										},
										"n": [
											"0p833_0p833_0p167_0p167"
										],
										"t": 31,
										"s": [
											0
										],
										"e": [
											100
										]
									},
									{
										"t": 119.000004846969
									}
								]
							},
							"r": {
								"a": 0,
								"k": 0
							},
							"p": {
								"a": 0,
								"k": [
									389.592,
									227.534,
									0
								]
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0,
									0
								]
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100,
									100
								]
							}
						},
						"ao": 0,
						"shapes": [
							{
								"ty": "gr",
								"it": [
									{
										"ind": 0,
										"ty": "sh",
										"ix": 1,
										"ks": {
											"a": 1,
											"k": [
												{
													"i": {
														"x": 0.833,
														"y": 0.833
													},
													"o": {
														"x": 0.167,
														"y": 0.167
													},
													"n": "0p833_0p833_0p167_0p167",
													"t": 2,
													"s": [
														{
															"i": [
																[
																	-0.292,
																	-25.205
																],
																[
																	1.365,
																	-53.253
																],
																[
																	32.839,
																	-0.82
																],
																[
																	0,
																	29.54
																],
																[
																	0,
																	0
																],
																[
																	-31.655,
																	0.803
																],
																[
																	0.464,
																	25.368
																],
																[
																	-0.122,
																	55.193
																],
																[
																	-28.31,
																	0
																],
																[
																	0,
																	-19.488
																],
																[
																	0,
																	0
																],
																[
																	35.112,
																	0.456
																]
															],
															"o": [
																[
																	0.637,
																	54.923
																],
																[
																	-0.684,
																	26.682
																],
																[
																	-33.838,
																	0.845
																],
																[
																	0,
																	0
																],
																[
																	-0.446,
																	29.89
																],
																[
																	31.469,
																	-0.798
																],
																[
																	-0.992,
																	-54.194
																],
																[
																	0.059,
																	-26.668
																],
																[
																	36.719,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0.39,
																	-19.626
																],
																[
																	-29.512,
																	-0.383
																]
															],
															"v": [
																[
																	-56.039,
																	-34.97
																],
																[
																	59.391,
																	32.949
																],
																[
																	0.142,
																	72.663
																],
																[
																	-59.516,
																	31.242
																],
																[
																	-59.554,
																	31.308
																],
																[
																	0.145,
																	72.674
																],
																[
																	59.43,
																	33.31
																],
																[
																	-56.001,
																	-34.984
																],
																[
																	0.193,
																	-72.912
																],
																[
																	54.201,
																	-33.625
																],
																[
																	54.239,
																	-33.629
																],
																[
																	0.19,
																	-72.924
																]
															],
															"c": true
														}
													],
													"e": [
														{
															"i": [
																[
																	0,
																	-23.591
																],
																[
																	0,
																	-54.977
																],
																[
																	33.437,
																	0
																],
																[
																	0,
																	29.54
																],
																[
																	0,
																	0
																],
																[
																	-31.592,
																	0
																],
																[
																	0,
																	24.822
																],
																[
																	0,
																	55.798
																],
																[
																	-28.31,
																	0
																],
																[
																	0,
																	-19.488
																],
																[
																	0,
																	0
																],
																[
																	34.668,
																	0
																]
															],
															"o": [
																[
																	0,
																	53.952
																],
																[
																	0,
																	27.694
																],
																[
																	-33.849,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	28.309
																],
																[
																	31.181,
																	0
																],
																[
																	0,
																	-53.131
																],
																[
																	0,
																	-26.668
																],
																[
																	36.719,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	-19.078
																],
																[
																	-29.335,
																	0
																]
															],
															"v": [
																[
																	-54.977,
																	-35.284
																],
																[
																	60.516,
																	32.822
																],
																[
																	0.206,
																	73.85
																],
																[
																	-60.516,
																	31.181
																],
																[
																	-58.054,
																	31.181
																],
																[
																	0.206,
																	71.799
																],
																[
																	58.055,
																	33.437
																],
																[
																	-57.438,
																	-34.669
																],
																[
																	0.206,
																	-73.85
																],
																[
																	55.388,
																	-33.643
																],
																[
																	52.926,
																	-33.643
																],
																[
																	0.206,
																	-71.799
																]
															],
															"c": true
														}
													]
												},
												{
													"i": {
														"x": 0.833,
														"y": 0.833
													},
													"o": {
														"x": 0.167,
														"y": 0.167
													},
													"n": "0p833_0p833_0p167_0p167",
													"t": 116.383,
													"s": [
														{
															"i": [
																[
																	0,
																	-23.591
																],
																[
																	0,
																	-54.977
																],
																[
																	33.437,
																	0
																],
																[
																	0,
																	29.54
																],
																[
																	0,
																	0
																],
																[
																	-31.592,
																	0
																],
																[
																	0,
																	24.822
																],
																[
																	0,
																	55.798
																],
																[
																	-28.31,
																	0
																],
																[
																	0,
																	-19.488
																],
																[
																	0,
																	0
																],
																[
																	34.668,
																	0
																]
															],
															"o": [
																[
																	0,
																	53.952
																],
																[
																	0,
																	27.694
																],
																[
																	-33.849,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	28.309
																],
																[
																	31.181,
																	0
																],
																[
																	0,
																	-53.131
																],
																[
																	0,
																	-26.668
																],
																[
																	36.719,
																	0
																],
																[
																	0,
																	0
																],
																[
																	0,
																	-19.078
																],
																[
																	-29.335,
																	0
																]
															],
															"v": [
																[
																	-54.977,
																	-35.284
																],
																[
																	60.516,
																	32.822
																],
																[
																	0.206,
																	73.85
																],
																[
																	-60.516,
																	31.181
																],
																[
																	-58.054,
																	31.181
																],
																[
																	0.206,
																	71.799
																],
																[
																	58.055,
																	33.437
																],
																[
																	-57.438,
																	-34.669
																],
																[
																	0.206,
																	-73.85
																],
																[
																	55.388,
																	-33.643
																],
																[
																	52.926,
																	-33.643
																],
																[
																	0.206,
																	-71.799
																]
															],
															"c": true
														}
													],
													"e": [
														{
															"i": [
																[
																	0.197,
																	-19.283
																],
																[
																	-0.182,
																	-57.76
																],
																[
																	33.437,
																	0
																],
																[
																	0,
																	29.54
																],
																[
																	0,
																	0
																],
																[
																	-31.588,
																	-0.5
																],
																[
																	0.404,
																	20.154
																],
																[
																	0.522,
																	57.856
																],
																[
																	-28.31,
																	0
																],
																[
																	0,
																	-19.488
																],
																[
																	0,
																	0
																],
																[
																	20.955,
																	-0.014
																]
															],
															"o": [
																[
																	-0.439,
																	42.971
																],
																[
																	0.087,
																	27.694
																],
																[
																	-33.849,
																	0
																],
																[
																	0,
																	0
																],
																[
																	1.888,
																	18.131
																],
																[
																	16.628,
																	0.263
																],
																[
																	-0.346,
																	-40.846
																],
																[
																	-0.241,
																	-26.667
																],
																[
																	36.719,
																	0
																],
																[
																	0,
																	0
																],
																[
																	-2.592,
																	-16.936
																],
																[
																	-20.955,
																	0.014
																]
															],
															"v": [
																[
																	-41.102,
																	-35.534
																],
																[
																	60.516,
																	32.822
																],
																[
																	0.206,
																	73.85
																],
																[
																	-60.516,
																	31.181
																],
																[
																	-44.804,
																	31.181
																],
																[
																	0.706,
																	57.799
																],
																[
																	43.43,
																	33.408
																],
																[
																	-57.438,
																	-34.669
																],
																[
																	0.206,
																	-73.85
																],
																[
																	55.388,
																	-33.643
																],
																[
																	38.551,
																	-33.627
																],
																[
																	0.254,
																	-59.549
																]
															],
															"c": true
														}
													]
												},
												{
													"i": {
														"x": 0.833,
														"y": 0.833
													},
													"o": {
														"x": 0.167,
														"y": 0.167
													},
													"n": "0p833_0p833_0p167_0p167",
													"t": 238.793,
													"s": [
														{
															"i": [
																[
																	0.197,
																	-19.283
																],
																[
																	-0.182,
																	-57.76
																],
																[
																	33.437,
																	0
																],
																[
																	0,
																	29.54
																],
																[
																	0,
																	0
																],
																[
																	-31.588,
																	-0.5
																],
																[
																	0.404,
																	20.154
																],
																[
																	0.522,
																	57.856
																],
																[
																	-28.31,
																	0
																],
																[
																	0,
																	-19.488
																],
																[
																	0,
																	0
																],
																[
																	20.955,
																	-0.014
																]
															],
															"o": [
																[
																	-0.439,
																	42.971
																],
																[
																	0.087,
																	27.694
																],
																[
																	-33.849,
																	0
																],
																[
																	0,
																	0
																],
																[
																	1.888,
																	18.131
																],
																[
																	16.628,
																	0.263
																],
																[
																	-0.346,
																	-40.846
																],
																[
																	-0.241,
																	-26.667
																],
																[
																	36.719,
																	0
																],
																[
																	0,
																	0
																],
																[
																	-2.592,
																	-16.936
																],
																[
																	-20.955,
																	0.014
																]
															],
															"v": [
																[
																	-41.102,
																	-35.534
																],
																[
																	60.516,
																	32.822
																],
																[
																	0.206,
																	73.85
																],
																[
																	-60.516,
																	31.181
																],
																[
																	-44.804,
																	31.181
																],
																[
																	0.706,
																	57.799
																],
																[
																	43.43,
																	33.408
																],
																[
																	-57.438,
																	-34.669
																],
																[
																	0.206,
																	-73.85
																],
																[
																	55.388,
																	-33.643
																],
																[
																	38.551,
																	-33.627
																],
																[
																	0.254,
																	-59.549
																]
															],
															"c": true
														}
													],
													"e": [
														{
															"i": [
																[
																	0.102,
																	-5.528
																],
																[
																	2.977,
																	-62.946
																],
																[
																	33.436,
																	0.274
																],
																[
																	0,
																	29.54
																],
																[
																	0,
																	0
																],
																[
																	-8.673,
																	0.076
																],
																[
																	-0.221,
																	4.779
																],
																[
																	-2.728,
																	64.481
																],
																[
																	-30.747,
																	-0.03
																],
																[
																	0,
																	-19.488
																],
																[
																	0,
																	0
																],
																[
																	9.83,
																	-0.139
																]
															],
															"o": [
																[
																	-0.314,
																	17.096
																],
																[
																	-1.182,
																	24.99
																],
																[
																	-35.122,
																	-0.288
																],
																[
																	0,
																	0
																],
																[
																	2.1,
																	9.916
																],
																[
																	12.705,
																	-0.112
																],
																[
																	-0.096,
																	-17.846
																],
																[
																	1.127,
																	-26.644
																],
																[
																	38.378,
																	0.037
																],
																[
																	0,
																	0
																],
																[
																	-2.092,
																	-6.561
																],
																[
																	-11.044,
																	0.156
																]
															],
															"v": [
																[
																	-15.102,
																	-29.534
																],
																[
																	61.766,
																	30.072
																],
																[
																	0.206,
																	73.6
																],
																[
																	-60.478,
																	24.681
																],
																[
																	-19.766,
																	24.646
																],
																[
																	1.254,
																	37.049
																],
																[
																	19.68,
																	27.658
																],
																[
																	-56.688,
																	-32.294
																],
																[
																	0.206,
																	-74.225
																],
																[
																	55.888,
																	-28.393
																],
																[
																	14.551,
																	-28.502
																],
																[
																	-1.621,
																	-38.674
																]
															],
															"c": true
														}
													]
												},
												{
													"i": {
														"x": 0.833,
														"y": 0.833
													},
													"o": {
														"x": 0.167,
														"y": 0.167
													},
													"n": "0p833_0p833_0p167_0p167",
													"t": 359,
													"s": [
														{
															"i": [
																[
																	0.102,
																	-5.528
																],
																[
																	2.977,
																	-62.946
																],
																[
																	33.436,
																	0.274
																],
																[
																	0,
																	29.54
																],
																[
																	0,
																	0
																],
																[
																	-8.673,
																	0.076
																],
																[
																	-0.221,
																	4.779
																],
																[
																	-2.728,
																	64.481
																],
																[
																	-30.747,
																	-0.03
																],
																[
																	0,
																	-19.488
																],
																[
																	0,
																	0
																],
																[
																	9.83,
																	-0.139
																]
															],
															"o": [
																[
																	-0.314,
																	17.096
																],
																[
																	-1.182,
																	24.99
																],
																[
																	-35.122,
																	-0.288
																],
																[
																	0,
																	0
																],
																[
																	2.1,
																	9.916
																],
																[
																	12.705,
																	-0.112
																],
																[
																	-0.096,
																	-17.846
																],
																[
																	1.127,
																	-26.644
																],
																[
																	38.378,
																	0.037
																],
																[
																	0,
																	0
																],
																[
																	-2.092,
																	-6.561
																],
																[
																	-11.044,
																	0.156
																]
															],
															"v": [
																[
																	-15.102,
																	-29.534
																],
																[
																	61.766,
																	30.072
																],
																[
																	0.206,
																	73.6
																],
																[
																	-60.478,
																	24.681
																],
																[
																	-19.766,
																	24.646
																],
																[
																	1.254,
																	37.049
																],
																[
																	19.68,
																	27.658
																],
																[
																	-56.688,
																	-32.294
																],
																[
																	0.206,
																	-74.225
																],
																[
																	55.888,
																	-28.393
																],
																[
																	14.551,
																	-28.502
																],
																[
																	-1.621,
																	-38.674
																]
															],
															"c": true
														}
													],
													"e": [
														{
															"i": [
																[
																	0.102,
																	-5.528
																],
																[
																	2.977,
																	-62.946
																],
																[
																	33.436,
																	0.274
																],
																[
																	0,
																	29.54
																],
																[
																	0,
																	0
																],
																[
																	-8.673,
																	0.076
																],
																[
																	-0.221,
																	4.779
																],
																[
																	-2.728,
																	64.481
																],
																[
																	-30.747,
																	-0.03
																],
																[
																	0,
																	-19.488
																],
																[
																	0,
																	0
																],
																[
																	9.83,
																	-0.139
																]
															],
															"o": [
																[
																	-0.314,
																	17.096
																],
																[
																	-1.182,
																	24.99
																],
																[
																	-35.122,
																	-0.288
																],
																[
																	0,
																	0
																],
																[
																	2.1,
																	9.916
																],
																[
																	12.705,
																	-0.112
																],
																[
																	-0.096,
																	-17.846
																],
																[
																	1.127,
																	-26.644
																],
																[
																	38.378,
																	0.037
																],
																[
																	0,
																	0
																],
																[
																	-2.092,
																	-6.561
																],
																[
																	-11.044,
																	0.156
																]
															],
															"v": [
																[
																	-15.102,
																	-29.534
																],
																[
																	61.766,
																	30.072
																],
																[
																	0.206,
																	73.6
																],
																[
																	-60.478,
																	24.681
																],
																[
																	-19.766,
																	24.646
																],
																[
																	1.254,
																	37.049
																],
																[
																	19.68,
																	27.658
																],
																[
																	-56.688,
																	-32.294
																],
																[
																	0.206,
																	-74.225
																],
																[
																	55.888,
																	-28.393
																],
																[
																	14.551,
																	-28.502
																],
																[
																	-1.621,
																	-38.674
																]
															],
															"c": true
														}
													]
												},
												{
													"i": {
														"x": 0.833,
														"y": 0.833
													},
													"o": {
														"x": 0.167,
														"y": 0.167
													},
													"n": "0p833_0p833_0p167_0p167",
													"t": 480,
													"s": [
														{
															"i": [
																[
																	0.102,
																	-5.528
																],
																[
																	2.977,
																	-62.946
																],
																[
																	33.436,
																	0.274
																],
																[
																	0,
																	29.54
																],
																[
																	0,
																	0
																],
																[
																	-8.673,
																	0.076
																],
																[
																	-0.221,
																	4.779
																],
																[
																	-2.728,
																	64.481
																],
																[
																	-30.747,
																	-0.03
																],
																[
																	0,
																	-19.488
																],
																[
																	0,
																	0
																],
																[
																	9.83,
																	-0.139
																]
															],
															"o": [
																[
																	-0.314,
																	17.096
																],
																[
																	-1.182,
																	24.99
																],
																[
																	-35.122,
																	-0.288
																],
																[
																	0,
																	0
																],
																[
																	2.1,
																	9.916
																],
																[
																	12.705,
																	-0.112
																],
																[
																	-0.096,
																	-17.846
																],
																[
																	1.127,
																	-26.644
																],
																[
																	38.378,
																	0.037
																],
																[
																	0,
																	0
																],
																[
																	-2.092,
																	-6.561
																],
																[
																	-11.044,
																	0.156
																]
															],
															"v": [
																[
																	-15.102,
																	-29.534
																],
																[
																	61.766,
																	30.072
																],
																[
																	0.206,
																	73.6
																],
																[
																	-60.478,
																	24.681
																],
																[
																	-19.766,
																	24.646
																],
																[
																	1.254,
																	37.049
																],
																[
																	19.68,
																	27.658
																],
																[
																	-56.688,
																	-32.294
																],
																[
																	0.206,
																	-74.225
																],
																[
																	55.888,
																	-28.393
																],
																[
																	14.551,
																	-28.502
																],
																[
																	-1.621,
																	-38.674
																]
															],
															"c": true
														}
													],
													"e": [
														{
															"i": [
																[
																	0.723,
																	-5.482
																],
																[
																	4.305,
																	-6.288
																],
																[
																	30.38,
																	0.293
																],
																[
																	1.005,
																	15.222
																],
																[
																	0,
																	0
																],
																[
																	-0.067,
																	-19.265
																],
																[
																	22.446,
																	28.216
																],
																[
																	-0.086,
																	-35.053
																],
																[
																	-82.238,
																	0.166
																],
																[
																	-10.123,
																	-15.617
																],
																[
																	0,
																	0
																],
																[
																	-0.688,
																	-8.1
																]
															],
															"o": [
																[
																	-2.189,
																	16.596
																],
																[
																	-6.107,
																	8.919
																],
																[
																	-70.257,
																	-0.677
																],
																[
																	0,
																	0
																],
																[
																	2.527,
																	19.384
																],
																[
																	-88.309,
																	-14.126
																],
																[
																	-10.784,
																	41.268
																],
																[
																	0.72,
																	0.696
																],
																[
																	24.513,
																	-0.05
																],
																[
																	10.123,
																	15.617
																],
																[
																	0.408,
																	6.189
																],
																[
																	1.261,
																	14.849
																]
															],
															"v": [
																[
																	55.399,
																	18.09
																],
																[
																	39.037,
																	51.841
																],
																[
																	0.206,
																	73.6
																],
																[
																	-62.973,
																	-47.812
																],
																[
																	51.785,
																	-33.157
																],
																[
																	59.209,
																	55.985
																],
																[
																	-59.343,
																	-16.345
																],
																[
																	-69.293,
																	58.474
																],
																[
																	0.208,
																	-73.225
																],
																[
																	43.853,
																	-50.624
																],
																[
																	53.421,
																	-19.874
																],
																[
																	55.257,
																	-1.673
																]
															],
															"c": true
														}
													]
												},
												{
													"t": 600.000024438501
												}
											]
										},
										"nm": "Path 1",
										"mn": "ADBE Vector Shape - Group"
									},
									{
										"ty": "fl",
										"c": {
											"a": 0,
											"k": [
												1,
												1,
												1,
												1
											]
										},
										"o": {
											"a": 0,
											"k": 100
										},
										"r": 1,
										"nm": "Fill 1",
										"mn": "ADBE Vector Graphic - Fill"
									},
									{
										"ty": "tr",
										"p": {
											"a": 0,
											"k": [
												143.074,
												333.904
											],
											"ix": 2
										},
										"a": {
											"a": 0,
											"k": [
												0,
												0
											],
											"ix": 1
										},
										"s": {
											"a": 0,
											"k": [
												100,
												100
											],
											"ix": 3
										},
										"r": {
											"a": 0,
											"k": 0.09,
											"ix": 6
										},
										"o": {
											"a": 0,
											"k": 100,
											"ix": 7
										},
										"sk": {
											"a": 0,
											"k": 0,
											"ix": 4
										},
										"sa": {
											"a": 0,
											"k": 0,
											"ix": 5
										},
										"nm": "Transform"
									}
								],
								"nm": "Group 9",
								"np": 2,
								"cix": 2,
								"ix": 1,
								"mn": "ADBE Vector Group"
							}
						],
						"ip": 2.00000008146167,
						"op": 360.000014663101,
						"st": 59.0000024031193,
						"bm": 0,
						"sr": 1
					}
				]
			}
		],
		"layers": [
			{
				"ddd": 0,
				"ind": 1,
				"ty": 0,
				"nm": "_typo",
				"refId": "comp_0",
				"ks": {
					"o": {
						"a": 0,
						"k": 100
					},
					"r": {
						"a": 0,
						"k": 0
					},
					"p": {
						"a": 0,
						"k": [
							960,
							540,
							0
						]
					},
					"a": {
						"a": 0,
						"k": [
							817,
							327.5,
							0
						]
					},
					"s": {
						"a": 0,
						"k": [
							100,
							100,
							100
						]
					}
				},
				"ao": 0,
				"tm": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [
									0.833
								],
								"y": [
									0.967
								]
							},
							"o": {
								"x": [
									0.333
								],
								"y": [
									0
								]
							},
							"n": [
								"0p833_0p967_0p333_0"
							],
							"t": 360,
							"s": [
								12.012
							],
							"e": [
								1.268
							]
						},
						{
							"t": 720.000029326201
						}
					]
				},
				"w": 1634,
				"h": 655,
				"ip": 360.000014663101,
				"op": 720.000029326201,
				"st": 322.000013115329,
				"bm": 0,
				"sr": 1
			},
			{
				"ddd": 0,
				"ind": 2,
				"ty": 0,
				"nm": "_typo",
				"refId": "comp_0",
				"ks": {
					"o": {
						"a": 0,
						"k": 100
					},
					"r": {
						"a": 0,
						"k": 0
					},
					"p": {
						"a": 0,
						"k": [
							960,
							540,
							0
						]
					},
					"a": {
						"a": 0,
						"k": [
							817,
							327.5,
							0
						]
					},
					"s": {
						"a": 0,
						"k": [
							100,
							100,
							100
						]
					}
				},
				"ao": 0,
				"tm": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [
									0.667
								],
								"y": [
									1
								]
							},
							"o": {
								"x": [
									0.167
								],
								"y": [
									0.033
								]
							},
							"n": [
								"0p667_1_0p167_0p033"
							],
							"t": 0,
							"s": [
								1.268
							],
							"e": [
								12.012
							]
						},
						{
							"t": 360.000014663101
						}
					]
				},
				"w": 1634,
				"h": 655,
				"ip": 0,
				"op": 361.000014703831,
				"st": -38.0000015477717,
				"bm": 0,
				"sr": 1
			}
		]
	};

/***/ },
/* 503 */
/***/ function(module, exports) {

	// Generated by CoffeeScript 1.9.2
	(function() {
	  var root;
	
	  root = typeof exports !== "undefined" && exports !== null ? exports : this;
	
	  root.Lethargy = (function() {
	    function Lethargy(stability, sensitivity, tolerance, delay) {
	      this.stability = stability != null ? Math.abs(stability) : 8;
	      this.sensitivity = sensitivity != null ? 1 + Math.abs(sensitivity) : 100;
	      this.tolerance = tolerance != null ? 1 + Math.abs(tolerance) : 1.1;
	      this.delay = delay != null ? delay : 150;
	      this.lastUpDeltas = (function() {
	        var i, ref, results;
	        results = [];
	        for (i = 1, ref = this.stability * 2; 1 <= ref ? i <= ref : i >= ref; 1 <= ref ? i++ : i--) {
	          results.push(null);
	        }
	        return results;
	      }).call(this);
	      this.lastDownDeltas = (function() {
	        var i, ref, results;
	        results = [];
	        for (i = 1, ref = this.stability * 2; 1 <= ref ? i <= ref : i >= ref; 1 <= ref ? i++ : i--) {
	          results.push(null);
	        }
	        return results;
	      }).call(this);
	      this.deltasTimestamp = (function() {
	        var i, ref, results;
	        results = [];
	        for (i = 1, ref = this.stability * 2; 1 <= ref ? i <= ref : i >= ref; 1 <= ref ? i++ : i--) {
	          results.push(null);
	        }
	        return results;
	      }).call(this);
	    }
	
	    Lethargy.prototype.check = function(e) {
	      var lastDelta;
	      e = e.originalEvent || e;
	      if (e.wheelDelta != null) {
	        lastDelta = e.wheelDelta;
	      } else if (e.deltaY != null) {
	        lastDelta = e.deltaY * -40;
	      } else if ((e.detail != null) || e.detail === 0) {
	        lastDelta = e.detail * -40;
	      }
	      this.deltasTimestamp.push(Date.now());
	      this.deltasTimestamp.shift();
	      if (lastDelta > 0) {
	        this.lastUpDeltas.push(lastDelta);
	        this.lastUpDeltas.shift();
	        return this.isInertia(1);
	      } else {
	        this.lastDownDeltas.push(lastDelta);
	        this.lastDownDeltas.shift();
	        return this.isInertia(-1);
	      }
	      return false;
	    };
	
	    Lethargy.prototype.isInertia = function(direction) {
	      var lastDeltas, lastDeltasNew, lastDeltasOld, newAverage, newSum, oldAverage, oldSum;
	      lastDeltas = direction === -1 ? this.lastDownDeltas : this.lastUpDeltas;
	      if (lastDeltas[0] === null) {
	        return direction;
	      }
	      if (this.deltasTimestamp[(this.stability * 2) - 2] + this.delay > Date.now() && lastDeltas[0] === lastDeltas[(this.stability * 2) - 1]) {
	        return false;
	      }
	      lastDeltasOld = lastDeltas.slice(0, this.stability);
	      lastDeltasNew = lastDeltas.slice(this.stability, this.stability * 2);
	      oldSum = lastDeltasOld.reduce(function(t, s) {
	        return t + s;
	      });
	      newSum = lastDeltasNew.reduce(function(t, s) {
	        return t + s;
	      });
	      oldAverage = oldSum / lastDeltasOld.length;
	      newAverage = newSum / lastDeltasNew.length;
	      if (Math.abs(oldAverage) < Math.abs(newAverage * this.tolerance) && (this.sensitivity < Math.abs(newAverage))) {
	        return direction;
	      } else {
	        return false;
	      }
	    };
	
	    Lethargy.prototype.showLastUpDeltas = function() {
	      return this.lastUpDeltas;
	    };
	
	    Lethargy.prototype.showLastDownDeltas = function() {
	      return this.lastDownDeltas;
	    };
	
	    return Lethargy;
	
	  })();
	
	}).call(this);


/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(198),
	    getRawTag = __webpack_require__(507),
	    objectToString = __webpack_require__(508);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ },
/* 505 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(509);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(198);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ },
/* 508 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ },
/* 509 */
/***/ function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(505);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ },
/* 511 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * Masonry v4.2.2
	 * Cascading grid layout library
	 * https://masonry.desandro.com
	 * MIT License
	 * by David DeSandro
	 */
	
	( function( window, factory ) {
	  // universal module definition
	  /* jshint strict: false */ /*globals define, module, require */
	  if ( true ) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(515),
	        __webpack_require__(125)
	      ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS
	    module.exports = factory(
	      require('outlayer'),
	      require('get-size')
	    );
	  } else {
	    // browser global
	    window.Masonry = factory(
	      window.Outlayer,
	      window.getSize
	    );
	  }
	
	}( window, function factory( Outlayer, getSize ) {
	
	'use strict';
	
	// -------------------------- masonryDefinition -------------------------- //
	
	  // create an Outlayer layout class
	  var Masonry = Outlayer.create('masonry');
	  // isFitWidth -> fitWidth
	  Masonry.compatOptions.fitWidth = 'isFitWidth';
	
	  var proto = Masonry.prototype;
	
	  proto._resetLayout = function() {
	    this.getSize();
	    this._getMeasurement( 'columnWidth', 'outerWidth' );
	    this._getMeasurement( 'gutter', 'outerWidth' );
	    this.measureColumns();
	
	    // reset column Y
	    this.colYs = [];
	    for ( var i=0; i < this.cols; i++ ) {
	      this.colYs.push( 0 );
	    }
	
	    this.maxY = 0;
	    this.horizontalColIndex = 0;
	  };
	
	  proto.measureColumns = function() {
	    this.getContainerWidth();
	    // if columnWidth is 0, default to outerWidth of first item
	    if ( !this.columnWidth ) {
	      var firstItem = this.items[0];
	      var firstItemElem = firstItem && firstItem.element;
	      // columnWidth fall back to item of first element
	      this.columnWidth = firstItemElem && getSize( firstItemElem ).outerWidth ||
	        // if first elem has no width, default to size of container
	        this.containerWidth;
	    }
	
	    var columnWidth = this.columnWidth += this.gutter;
	
	    // calculate columns
	    var containerWidth = this.containerWidth + this.gutter;
	    var cols = containerWidth / columnWidth;
	    // fix rounding errors, typically with gutters
	    var excess = columnWidth - containerWidth % columnWidth;
	    // if overshoot is less than a pixel, round up, otherwise floor it
	    var mathMethod = excess && excess < 1 ? 'round' : 'floor';
	    cols = Math[ mathMethod ]( cols );
	    this.cols = Math.max( cols, 1 );
	  };
	
	  proto.getContainerWidth = function() {
	    // container is parent if fit width
	    var isFitWidth = this._getOption('fitWidth');
	    var container = isFitWidth ? this.element.parentNode : this.element;
	    // check that this.size and size are there
	    // IE8 triggers resize on body size change, so they might not be
	    var size = getSize( container );
	    this.containerWidth = size && size.innerWidth;
	  };
	
	  proto._getItemLayoutPosition = function( item ) {
	    item.getSize();
	    // how many columns does this brick span
	    var remainder = item.size.outerWidth % this.columnWidth;
	    var mathMethod = remainder && remainder < 1 ? 'round' : 'ceil';
	    // round if off by 1 pixel, otherwise use ceil
	    var colSpan = Math[ mathMethod ]( item.size.outerWidth / this.columnWidth );
	    colSpan = Math.min( colSpan, this.cols );
	    // use horizontal or top column position
	    var colPosMethod = this.options.horizontalOrder ?
	      '_getHorizontalColPosition' : '_getTopColPosition';
	    var colPosition = this[ colPosMethod ]( colSpan, item );
	    // position the brick
	    var position = {
	      x: this.columnWidth * colPosition.col,
	      y: colPosition.y
	    };
	    // apply setHeight to necessary columns
	    var setHeight = colPosition.y + item.size.outerHeight;
	    var setMax = colSpan + colPosition.col;
	    for ( var i = colPosition.col; i < setMax; i++ ) {
	      this.colYs[i] = setHeight;
	    }
	
	    return position;
	  };
	
	  proto._getTopColPosition = function( colSpan ) {
	    var colGroup = this._getTopColGroup( colSpan );
	    // get the minimum Y value from the columns
	    var minimumY = Math.min.apply( Math, colGroup );
	
	    return {
	      col: colGroup.indexOf( minimumY ),
	      y: minimumY,
	    };
	  };
	
	  /**
	   * @param {Number} colSpan - number of columns the element spans
	   * @returns {Array} colGroup
	   */
	  proto._getTopColGroup = function( colSpan ) {
	    if ( colSpan < 2 ) {
	      // if brick spans only one column, use all the column Ys
	      return this.colYs;
	    }
	
	    var colGroup = [];
	    // how many different places could this brick fit horizontally
	    var groupCount = this.cols + 1 - colSpan;
	    // for each group potential horizontal position
	    for ( var i = 0; i < groupCount; i++ ) {
	      colGroup[i] = this._getColGroupY( i, colSpan );
	    }
	    return colGroup;
	  };
	
	  proto._getColGroupY = function( col, colSpan ) {
	    if ( colSpan < 2 ) {
	      return this.colYs[ col ];
	    }
	    // make an array of colY values for that one group
	    var groupColYs = this.colYs.slice( col, col + colSpan );
	    // and get the max value of the array
	    return Math.max.apply( Math, groupColYs );
	  };
	
	  // get column position based on horizontal index. #873
	  proto._getHorizontalColPosition = function( colSpan, item ) {
	    var col = this.horizontalColIndex % this.cols;
	    var isOver = colSpan > 1 && col + colSpan > this.cols;
	    // shift to next row if item can't fit on current row
	    col = isOver ? 0 : col;
	    // don't let zero-size items take up space
	    var hasSize = item.size.outerWidth && item.size.outerHeight;
	    this.horizontalColIndex = hasSize ? col + colSpan : this.horizontalColIndex;
	
	    return {
	      col: col,
	      y: this._getColGroupY( col, colSpan ),
	    };
	  };
	
	  proto._manageStamp = function( stamp ) {
	    var stampSize = getSize( stamp );
	    var offset = this._getElementOffset( stamp );
	    // get the columns that this stamp affects
	    var isOriginLeft = this._getOption('originLeft');
	    var firstX = isOriginLeft ? offset.left : offset.right;
	    var lastX = firstX + stampSize.outerWidth;
	    var firstCol = Math.floor( firstX / this.columnWidth );
	    firstCol = Math.max( 0, firstCol );
	    var lastCol = Math.floor( lastX / this.columnWidth );
	    // lastCol should not go over if multiple of columnWidth #425
	    lastCol -= lastX % this.columnWidth ? 0 : 1;
	    lastCol = Math.min( this.cols - 1, lastCol );
	    // set colYs to bottom of the stamp
	
	    var isOriginTop = this._getOption('originTop');
	    var stampMaxY = ( isOriginTop ? offset.top : offset.bottom ) +
	      stampSize.outerHeight;
	    for ( var i = firstCol; i <= lastCol; i++ ) {
	      this.colYs[i] = Math.max( stampMaxY, this.colYs[i] );
	    }
	  };
	
	  proto._getContainerSize = function() {
	    this.maxY = Math.max.apply( Math, this.colYs );
	    var size = {
	      height: this.maxY
	    };
	
	    if ( this._getOption('fitWidth') ) {
	      size.width = this._getContainerFitWidth();
	    }
	
	    return size;
	  };
	
	  proto._getContainerFitWidth = function() {
	    var unusedCols = 0;
	    // count unused columns
	    var i = this.cols;
	    while ( --i ) {
	      if ( this.colYs[i] !== 0 ) {
	        break;
	      }
	      unusedCols++;
	    }
	    // fit container to columns that have been used
	    return ( this.cols - unusedCols ) * this.columnWidth - this.gutter;
	  };
	
	  proto.needsResizeLayout = function() {
	    var previousWidth = this.containerWidth;
	    this.getContainerWidth();
	    return previousWidth != this.containerWidth;
	  };
	
	  return Masonry;
	
	}));


/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/* NProgress, (c) 2013, 2014 Rico Sta. Cruz - http://ricostacruz.com/nprogress
	 * @license MIT */
	
	;(function(root, factory) {
	
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    module.exports = factory();
	  } else {
	    root.NProgress = factory();
	  }
	
	})(this, function() {
	  var NProgress = {};
	
	  NProgress.version = '0.2.0';
	
	  var Settings = NProgress.settings = {
	    minimum: 0.08,
	    easing: 'ease',
	    positionUsing: '',
	    speed: 200,
	    trickle: true,
	    trickleRate: 0.02,
	    trickleSpeed: 800,
	    showSpinner: true,
	    barSelector: '[role="bar"]',
	    spinnerSelector: '[role="spinner"]',
	    parent: 'body',
	    template: '<div class="bar" role="bar"><div class="peg"></div></div><div class="spinner" role="spinner"><div class="spinner-icon"></div></div>'
	  };
	
	  /**
	   * Updates configuration.
	   *
	   *     NProgress.configure({
	   *       minimum: 0.1
	   *     });
	   */
	  NProgress.configure = function(options) {
	    var key, value;
	    for (key in options) {
	      value = options[key];
	      if (value !== undefined && options.hasOwnProperty(key)) Settings[key] = value;
	    }
	
	    return this;
	  };
	
	  /**
	   * Last number.
	   */
	
	  NProgress.status = null;
	
	  /**
	   * Sets the progress bar status, where `n` is a number from `0.0` to `1.0`.
	   *
	   *     NProgress.set(0.4);
	   *     NProgress.set(1.0);
	   */
	
	  NProgress.set = function(n) {
	    var started = NProgress.isStarted();
	
	    n = clamp(n, Settings.minimum, 1);
	    NProgress.status = (n === 1 ? null : n);
	
	    var progress = NProgress.render(!started),
	        bar      = progress.querySelector(Settings.barSelector),
	        speed    = Settings.speed,
	        ease     = Settings.easing;
	
	    progress.offsetWidth; /* Repaint */
	
	    queue(function(next) {
	      // Set positionUsing if it hasn't already been set
	      if (Settings.positionUsing === '') Settings.positionUsing = NProgress.getPositioningCSS();
	
	      // Add transition
	      css(bar, barPositionCSS(n, speed, ease));
	
	      if (n === 1) {
	        // Fade out
	        css(progress, { 
	          transition: 'none', 
	          opacity: 1 
	        });
	        progress.offsetWidth; /* Repaint */
	
	        setTimeout(function() {
	          css(progress, { 
	            transition: 'all ' + speed + 'ms linear', 
	            opacity: 0 
	          });
	          setTimeout(function() {
	            NProgress.remove();
	            next();
	          }, speed);
	        }, speed);
	      } else {
	        setTimeout(next, speed);
	      }
	    });
	
	    return this;
	  };
	
	  NProgress.isStarted = function() {
	    return typeof NProgress.status === 'number';
	  };
	
	  /**
	   * Shows the progress bar.
	   * This is the same as setting the status to 0%, except that it doesn't go backwards.
	   *
	   *     NProgress.start();
	   *
	   */
	  NProgress.start = function() {
	    if (!NProgress.status) NProgress.set(0);
	
	    var work = function() {
	      setTimeout(function() {
	        if (!NProgress.status) return;
	        NProgress.trickle();
	        work();
	      }, Settings.trickleSpeed);
	    };
	
	    if (Settings.trickle) work();
	
	    return this;
	  };
	
	  /**
	   * Hides the progress bar.
	   * This is the *sort of* the same as setting the status to 100%, with the
	   * difference being `done()` makes some placebo effect of some realistic motion.
	   *
	   *     NProgress.done();
	   *
	   * If `true` is passed, it will show the progress bar even if its hidden.
	   *
	   *     NProgress.done(true);
	   */
	
	  NProgress.done = function(force) {
	    if (!force && !NProgress.status) return this;
	
	    return NProgress.inc(0.3 + 0.5 * Math.random()).set(1);
	  };
	
	  /**
	   * Increments by a random amount.
	   */
	
	  NProgress.inc = function(amount) {
	    var n = NProgress.status;
	
	    if (!n) {
	      return NProgress.start();
	    } else {
	      if (typeof amount !== 'number') {
	        amount = (1 - n) * clamp(Math.random() * n, 0.1, 0.95);
	      }
	
	      n = clamp(n + amount, 0, 0.994);
	      return NProgress.set(n);
	    }
	  };
	
	  NProgress.trickle = function() {
	    return NProgress.inc(Math.random() * Settings.trickleRate);
	  };
	
	  /**
	   * Waits for all supplied jQuery promises and
	   * increases the progress as the promises resolve.
	   *
	   * @param $promise jQUery Promise
	   */
	  (function() {
	    var initial = 0, current = 0;
	
	    NProgress.promise = function($promise) {
	      if (!$promise || $promise.state() === "resolved") {
	        return this;
	      }
	
	      if (current === 0) {
	        NProgress.start();
	      }
	
	      initial++;
	      current++;
	
	      $promise.always(function() {
	        current--;
	        if (current === 0) {
	            initial = 0;
	            NProgress.done();
	        } else {
	            NProgress.set((initial - current) / initial);
	        }
	      });
	
	      return this;
	    };
	
	  })();
	
	  /**
	   * (Internal) renders the progress bar markup based on the `template`
	   * setting.
	   */
	
	  NProgress.render = function(fromStart) {
	    if (NProgress.isRendered()) return document.getElementById('nprogress');
	
	    addClass(document.documentElement, 'nprogress-busy');
	    
	    var progress = document.createElement('div');
	    progress.id = 'nprogress';
	    progress.innerHTML = Settings.template;
	
	    var bar      = progress.querySelector(Settings.barSelector),
	        perc     = fromStart ? '-100' : toBarPerc(NProgress.status || 0),
	        parent   = document.querySelector(Settings.parent),
	        spinner;
	    
	    css(bar, {
	      transition: 'all 0 linear',
	      transform: 'translate3d(' + perc + '%,0,0)'
	    });
	
	    if (!Settings.showSpinner) {
	      spinner = progress.querySelector(Settings.spinnerSelector);
	      spinner && removeElement(spinner);
	    }
	
	    if (parent != document.body) {
	      addClass(parent, 'nprogress-custom-parent');
	    }
	
	    parent.appendChild(progress);
	    return progress;
	  };
	
	  /**
	   * Removes the element. Opposite of render().
	   */
	
	  NProgress.remove = function() {
	    removeClass(document.documentElement, 'nprogress-busy');
	    removeClass(document.querySelector(Settings.parent), 'nprogress-custom-parent');
	    var progress = document.getElementById('nprogress');
	    progress && removeElement(progress);
	  };
	
	  /**
	   * Checks if the progress bar is rendered.
	   */
	
	  NProgress.isRendered = function() {
	    return !!document.getElementById('nprogress');
	  };
	
	  /**
	   * Determine which positioning CSS rule to use.
	   */
	
	  NProgress.getPositioningCSS = function() {
	    // Sniff on document.body.style
	    var bodyStyle = document.body.style;
	
	    // Sniff prefixes
	    var vendorPrefix = ('WebkitTransform' in bodyStyle) ? 'Webkit' :
	                       ('MozTransform' in bodyStyle) ? 'Moz' :
	                       ('msTransform' in bodyStyle) ? 'ms' :
	                       ('OTransform' in bodyStyle) ? 'O' : '';
	
	    if (vendorPrefix + 'Perspective' in bodyStyle) {
	      // Modern browsers with 3D support, e.g. Webkit, IE10
	      return 'translate3d';
	    } else if (vendorPrefix + 'Transform' in bodyStyle) {
	      // Browsers without 3D support, e.g. IE9
	      return 'translate';
	    } else {
	      // Browsers without translate() support, e.g. IE7-8
	      return 'margin';
	    }
	  };
	
	  /**
	   * Helpers
	   */
	
	  function clamp(n, min, max) {
	    if (n < min) return min;
	    if (n > max) return max;
	    return n;
	  }
	
	  /**
	   * (Internal) converts a percentage (`0..1`) to a bar translateX
	   * percentage (`-100%..0%`).
	   */
	
	  function toBarPerc(n) {
	    return (-1 + n) * 100;
	  }
	
	
	  /**
	   * (Internal) returns the correct CSS for changing the bar's
	   * position given an n percentage, and speed and ease from Settings
	   */
	
	  function barPositionCSS(n, speed, ease) {
	    var barCSS;
	
	    if (Settings.positionUsing === 'translate3d') {
	      barCSS = { transform: 'translate3d('+toBarPerc(n)+'%,0,0)' };
	    } else if (Settings.positionUsing === 'translate') {
	      barCSS = { transform: 'translate('+toBarPerc(n)+'%,0)' };
	    } else {
	      barCSS = { 'margin-left': toBarPerc(n)+'%' };
	    }
	
	    barCSS.transition = 'all '+speed+'ms '+ease;
	
	    return barCSS;
	  }
	
	  /**
	   * (Internal) Queues a function to be executed.
	   */
	
	  var queue = (function() {
	    var pending = [];
	    
	    function next() {
	      var fn = pending.shift();
	      if (fn) {
	        fn(next);
	      }
	    }
	
	    return function(fn) {
	      pending.push(fn);
	      if (pending.length == 1) next();
	    };
	  })();
	
	  /**
	   * (Internal) Applies css properties to an element, similar to the jQuery 
	   * css method.
	   *
	   * While this helper does assist with vendor prefixed property names, it 
	   * does not perform any manipulation of values prior to setting styles.
	   */
	
	  var css = (function() {
	    var cssPrefixes = [ 'Webkit', 'O', 'Moz', 'ms' ],
	        cssProps    = {};
	
	    function camelCase(string) {
	      return string.replace(/^-ms-/, 'ms-').replace(/-([\da-z])/gi, function(match, letter) {
	        return letter.toUpperCase();
	      });
	    }
	
	    function getVendorProp(name) {
	      var style = document.body.style;
	      if (name in style) return name;
	
	      var i = cssPrefixes.length,
	          capName = name.charAt(0).toUpperCase() + name.slice(1),
	          vendorName;
	      while (i--) {
	        vendorName = cssPrefixes[i] + capName;
	        if (vendorName in style) return vendorName;
	      }
	
	      return name;
	    }
	
	    function getStyleProp(name) {
	      name = camelCase(name);
	      return cssProps[name] || (cssProps[name] = getVendorProp(name));
	    }
	
	    function applyCss(element, prop, value) {
	      prop = getStyleProp(prop);
	      element.style[prop] = value;
	    }
	
	    return function(element, properties) {
	      var args = arguments,
	          prop, 
	          value;
	
	      if (args.length == 2) {
	        for (prop in properties) {
	          value = properties[prop];
	          if (value !== undefined && properties.hasOwnProperty(prop)) applyCss(element, prop, value);
	        }
	      } else {
	        applyCss(element, args[1], args[2]);
	      }
	    }
	  })();
	
	  /**
	   * (Internal) Determines if an element or space separated list of class names contains a class name.
	   */
	
	  function hasClass(element, name) {
	    var list = typeof element == 'string' ? element : classList(element);
	    return list.indexOf(' ' + name + ' ') >= 0;
	  }
	
	  /**
	   * (Internal) Adds a class to an element.
	   */
	
	  function addClass(element, name) {
	    var oldList = classList(element),
	        newList = oldList + name;
	
	    if (hasClass(oldList, name)) return; 
	
	    // Trim the opening space.
	    element.className = newList.substring(1);
	  }
	
	  /**
	   * (Internal) Removes a class from an element.
	   */
	
	  function removeClass(element, name) {
	    var oldList = classList(element),
	        newList;
	
	    if (!hasClass(element, name)) return;
	
	    // Replace the class name.
	    newList = oldList.replace(' ' + name + ' ', ' ');
	
	    // Trim the opening and closing spaces.
	    element.className = newList.substring(1, newList.length - 1);
	  }
	
	  /**
	   * (Internal) Gets a space separated list of the class names on the element. 
	   * The list is wrapped with a single space on each end to facilitate finding 
	   * matches within the list.
	   */
	
	  function classList(element) {
	    return (' ' + (element.className || '') + ' ').replace(/\s+/gi, ' ');
	  }
	
	  /**
	   * (Internal) Removes an element from the DOM.
	   */
	
	  function removeElement(element) {
	    element && element.parentNode && element.parentNode.removeChild(element);
	  }
	
	  return NProgress;
	});
	


/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * Outlayer Item
	 */
	
	( function( window, factory ) {
	  // universal module definition
	  /* jshint strict: false */ /* globals define, module, require */
	  if ( true ) {
	    // AMD - RequireJS
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(189),
	        __webpack_require__(125)
	      ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS - Browserify, Webpack
	    module.exports = factory(
	      require('ev-emitter'),
	      require('get-size')
	    );
	  } else {
	    // browser global
	    window.Outlayer = {};
	    window.Outlayer.Item = factory(
	      window.EvEmitter,
	      window.getSize
	    );
	  }
	
	}( window, function factory( EvEmitter, getSize ) {
	'use strict';
	
	// ----- helpers ----- //
	
	function isEmptyObj( obj ) {
	  for ( var prop in obj ) {
	    return false;
	  }
	  prop = null;
	  return true;
	}
	
	// -------------------------- CSS3 support -------------------------- //
	
	
	var docElemStyle = document.documentElement.style;
	
	var transitionProperty = typeof docElemStyle.transition == 'string' ?
	  'transition' : 'WebkitTransition';
	var transformProperty = typeof docElemStyle.transform == 'string' ?
	  'transform' : 'WebkitTransform';
	
	var transitionEndEvent = {
	  WebkitTransition: 'webkitTransitionEnd',
	  transition: 'transitionend'
	}[ transitionProperty ];
	
	// cache all vendor properties that could have vendor prefix
	var vendorProperties = {
	  transform: transformProperty,
	  transition: transitionProperty,
	  transitionDuration: transitionProperty + 'Duration',
	  transitionProperty: transitionProperty + 'Property',
	  transitionDelay: transitionProperty + 'Delay'
	};
	
	// -------------------------- Item -------------------------- //
	
	function Item( element, layout ) {
	  if ( !element ) {
	    return;
	  }
	
	  this.element = element;
	  // parent layout class, i.e. Masonry, Isotope, or Packery
	  this.layout = layout;
	  this.position = {
	    x: 0,
	    y: 0
	  };
	
	  this._create();
	}
	
	// inherit EvEmitter
	var proto = Item.prototype = Object.create( EvEmitter.prototype );
	proto.constructor = Item;
	
	proto._create = function() {
	  // transition objects
	  this._transn = {
	    ingProperties: {},
	    clean: {},
	    onEnd: {}
	  };
	
	  this.css({
	    position: 'absolute'
	  });
	};
	
	// trigger specified handler for event type
	proto.handleEvent = function( event ) {
	  var method = 'on' + event.type;
	  if ( this[ method ] ) {
	    this[ method ]( event );
	  }
	};
	
	proto.getSize = function() {
	  this.size = getSize( this.element );
	};
	
	/**
	 * apply CSS styles to element
	 * @param {Object} style
	 */
	proto.css = function( style ) {
	  var elemStyle = this.element.style;
	
	  for ( var prop in style ) {
	    // use vendor property if available
	    var supportedProp = vendorProperties[ prop ] || prop;
	    elemStyle[ supportedProp ] = style[ prop ];
	  }
	};
	
	 // measure position, and sets it
	proto.getPosition = function() {
	  var style = getComputedStyle( this.element );
	  var isOriginLeft = this.layout._getOption('originLeft');
	  var isOriginTop = this.layout._getOption('originTop');
	  var xValue = style[ isOriginLeft ? 'left' : 'right' ];
	  var yValue = style[ isOriginTop ? 'top' : 'bottom' ];
	  var x = parseFloat( xValue );
	  var y = parseFloat( yValue );
	  // convert percent to pixels
	  var layoutSize = this.layout.size;
	  if ( xValue.indexOf('%') != -1 ) {
	    x = ( x / 100 ) * layoutSize.width;
	  }
	  if ( yValue.indexOf('%') != -1 ) {
	    y = ( y / 100 ) * layoutSize.height;
	  }
	  // clean up 'auto' or other non-integer values
	  x = isNaN( x ) ? 0 : x;
	  y = isNaN( y ) ? 0 : y;
	  // remove padding from measurement
	  x -= isOriginLeft ? layoutSize.paddingLeft : layoutSize.paddingRight;
	  y -= isOriginTop ? layoutSize.paddingTop : layoutSize.paddingBottom;
	
	  this.position.x = x;
	  this.position.y = y;
	};
	
	// set settled position, apply padding
	proto.layoutPosition = function() {
	  var layoutSize = this.layout.size;
	  var style = {};
	  var isOriginLeft = this.layout._getOption('originLeft');
	  var isOriginTop = this.layout._getOption('originTop');
	
	  // x
	  var xPadding = isOriginLeft ? 'paddingLeft' : 'paddingRight';
	  var xProperty = isOriginLeft ? 'left' : 'right';
	  var xResetProperty = isOriginLeft ? 'right' : 'left';
	
	  var x = this.position.x + layoutSize[ xPadding ];
	  // set in percentage or pixels
	  style[ xProperty ] = this.getXValue( x );
	  // reset other property
	  style[ xResetProperty ] = '';
	
	  // y
	  var yPadding = isOriginTop ? 'paddingTop' : 'paddingBottom';
	  var yProperty = isOriginTop ? 'top' : 'bottom';
	  var yResetProperty = isOriginTop ? 'bottom' : 'top';
	
	  var y = this.position.y + layoutSize[ yPadding ];
	  // set in percentage or pixels
	  style[ yProperty ] = this.getYValue( y );
	  // reset other property
	  style[ yResetProperty ] = '';
	
	  this.css( style );
	  this.emitEvent( 'layout', [ this ] );
	};
	
	proto.getXValue = function( x ) {
	  var isHorizontal = this.layout._getOption('horizontal');
	  return this.layout.options.percentPosition && !isHorizontal ?
	    ( ( x / this.layout.size.width ) * 100 ) + '%' : x + 'px';
	};
	
	proto.getYValue = function( y ) {
	  var isHorizontal = this.layout._getOption('horizontal');
	  return this.layout.options.percentPosition && isHorizontal ?
	    ( ( y / this.layout.size.height ) * 100 ) + '%' : y + 'px';
	};
	
	proto._transitionTo = function( x, y ) {
	  this.getPosition();
	  // get current x & y from top/left
	  var curX = this.position.x;
	  var curY = this.position.y;
	
	  var didNotMove = x == this.position.x && y == this.position.y;
	
	  // save end position
	  this.setPosition( x, y );
	
	  // if did not move and not transitioning, just go to layout
	  if ( didNotMove && !this.isTransitioning ) {
	    this.layoutPosition();
	    return;
	  }
	
	  var transX = x - curX;
	  var transY = y - curY;
	  var transitionStyle = {};
	  transitionStyle.transform = this.getTranslate( transX, transY );
	
	  this.transition({
	    to: transitionStyle,
	    onTransitionEnd: {
	      transform: this.layoutPosition
	    },
	    isCleaning: true
	  });
	};
	
	proto.getTranslate = function( x, y ) {
	  // flip cooridinates if origin on right or bottom
	  var isOriginLeft = this.layout._getOption('originLeft');
	  var isOriginTop = this.layout._getOption('originTop');
	  x = isOriginLeft ? x : -x;
	  y = isOriginTop ? y : -y;
	  return 'translate3d(' + x + 'px, ' + y + 'px, 0)';
	};
	
	// non transition + transform support
	proto.goTo = function( x, y ) {
	  this.setPosition( x, y );
	  this.layoutPosition();
	};
	
	proto.moveTo = proto._transitionTo;
	
	proto.setPosition = function( x, y ) {
	  this.position.x = parseFloat( x );
	  this.position.y = parseFloat( y );
	};
	
	// ----- transition ----- //
	
	/**
	 * @param {Object} style - CSS
	 * @param {Function} onTransitionEnd
	 */
	
	// non transition, just trigger callback
	proto._nonTransition = function( args ) {
	  this.css( args.to );
	  if ( args.isCleaning ) {
	    this._removeStyles( args.to );
	  }
	  for ( var prop in args.onTransitionEnd ) {
	    args.onTransitionEnd[ prop ].call( this );
	  }
	};
	
	/**
	 * proper transition
	 * @param {Object} args - arguments
	 *   @param {Object} to - style to transition to
	 *   @param {Object} from - style to start transition from
	 *   @param {Boolean} isCleaning - removes transition styles after transition
	 *   @param {Function} onTransitionEnd - callback
	 */
	proto.transition = function( args ) {
	  // redirect to nonTransition if no transition duration
	  if ( !parseFloat( this.layout.options.transitionDuration ) ) {
	    this._nonTransition( args );
	    return;
	  }
	
	  var _transition = this._transn;
	  // keep track of onTransitionEnd callback by css property
	  for ( var prop in args.onTransitionEnd ) {
	    _transition.onEnd[ prop ] = args.onTransitionEnd[ prop ];
	  }
	  // keep track of properties that are transitioning
	  for ( prop in args.to ) {
	    _transition.ingProperties[ prop ] = true;
	    // keep track of properties to clean up when transition is done
	    if ( args.isCleaning ) {
	      _transition.clean[ prop ] = true;
	    }
	  }
	
	  // set from styles
	  if ( args.from ) {
	    this.css( args.from );
	    // force redraw. http://blog.alexmaccaw.com/css-transitions
	    var h = this.element.offsetHeight;
	    // hack for JSHint to hush about unused var
	    h = null;
	  }
	  // enable transition
	  this.enableTransition( args.to );
	  // set styles that are transitioning
	  this.css( args.to );
	
	  this.isTransitioning = true;
	
	};
	
	// dash before all cap letters, including first for
	// WebkitTransform => -webkit-transform
	function toDashedAll( str ) {
	  return str.replace( /([A-Z])/g, function( $1 ) {
	    return '-' + $1.toLowerCase();
	  });
	}
	
	var transitionProps = 'opacity,' + toDashedAll( transformProperty );
	
	proto.enableTransition = function(/* style */) {
	  // HACK changing transitionProperty during a transition
	  // will cause transition to jump
	  if ( this.isTransitioning ) {
	    return;
	  }
	
	  // make `transition: foo, bar, baz` from style object
	  // HACK un-comment this when enableTransition can work
	  // while a transition is happening
	  // var transitionValues = [];
	  // for ( var prop in style ) {
	  //   // dash-ify camelCased properties like WebkitTransition
	  //   prop = vendorProperties[ prop ] || prop;
	  //   transitionValues.push( toDashedAll( prop ) );
	  // }
	  // munge number to millisecond, to match stagger
	  var duration = this.layout.options.transitionDuration;
	  duration = typeof duration == 'number' ? duration + 'ms' : duration;
	  // enable transition styles
	  this.css({
	    transitionProperty: transitionProps,
	    transitionDuration: duration,
	    transitionDelay: this.staggerDelay || 0
	  });
	  // listen for transition end event
	  this.element.addEventListener( transitionEndEvent, this, false );
	};
	
	// ----- events ----- //
	
	proto.onwebkitTransitionEnd = function( event ) {
	  this.ontransitionend( event );
	};
	
	proto.onotransitionend = function( event ) {
	  this.ontransitionend( event );
	};
	
	// properties that I munge to make my life easier
	var dashedVendorProperties = {
	  '-webkit-transform': 'transform'
	};
	
	proto.ontransitionend = function( event ) {
	  // disregard bubbled events from children
	  if ( event.target !== this.element ) {
	    return;
	  }
	  var _transition = this._transn;
	  // get property name of transitioned property, convert to prefix-free
	  var propertyName = dashedVendorProperties[ event.propertyName ] || event.propertyName;
	
	  // remove property that has completed transitioning
	  delete _transition.ingProperties[ propertyName ];
	  // check if any properties are still transitioning
	  if ( isEmptyObj( _transition.ingProperties ) ) {
	    // all properties have completed transitioning
	    this.disableTransition();
	  }
	  // clean style
	  if ( propertyName in _transition.clean ) {
	    // clean up style
	    this.element.style[ event.propertyName ] = '';
	    delete _transition.clean[ propertyName ];
	  }
	  // trigger onTransitionEnd callback
	  if ( propertyName in _transition.onEnd ) {
	    var onTransitionEnd = _transition.onEnd[ propertyName ];
	    onTransitionEnd.call( this );
	    delete _transition.onEnd[ propertyName ];
	  }
	
	  this.emitEvent( 'transitionEnd', [ this ] );
	};
	
	proto.disableTransition = function() {
	  this.removeTransitionStyles();
	  this.element.removeEventListener( transitionEndEvent, this, false );
	  this.isTransitioning = false;
	};
	
	/**
	 * removes style property from element
	 * @param {Object} style
	**/
	proto._removeStyles = function( style ) {
	  // clean up transition styles
	  var cleanStyle = {};
	  for ( var prop in style ) {
	    cleanStyle[ prop ] = '';
	  }
	  this.css( cleanStyle );
	};
	
	var cleanTransitionStyle = {
	  transitionProperty: '',
	  transitionDuration: '',
	  transitionDelay: ''
	};
	
	proto.removeTransitionStyles = function() {
	  // remove transition
	  this.css( cleanTransitionStyle );
	};
	
	// ----- stagger ----- //
	
	proto.stagger = function( delay ) {
	  delay = isNaN( delay ) ? 0 : delay;
	  this.staggerDelay = delay + 'ms';
	};
	
	// ----- show/hide/remove ----- //
	
	// remove element from DOM
	proto.removeElem = function() {
	  this.element.parentNode.removeChild( this.element );
	  // remove display: none
	  this.css({ display: '' });
	  this.emitEvent( 'remove', [ this ] );
	};
	
	proto.remove = function() {
	  // just remove element if no transition support or no transition
	  if ( !transitionProperty || !parseFloat( this.layout.options.transitionDuration ) ) {
	    this.removeElem();
	    return;
	  }
	
	  // start transition
	  this.once( 'transitionEnd', function() {
	    this.removeElem();
	  });
	  this.hide();
	};
	
	proto.reveal = function() {
	  delete this.isHidden;
	  // remove display: none
	  this.css({ display: '' });
	
	  var options = this.layout.options;
	
	  var onTransitionEnd = {};
	  var transitionEndProperty = this.getHideRevealTransitionEndProperty('visibleStyle');
	  onTransitionEnd[ transitionEndProperty ] = this.onRevealTransitionEnd;
	
	  this.transition({
	    from: options.hiddenStyle,
	    to: options.visibleStyle,
	    isCleaning: true,
	    onTransitionEnd: onTransitionEnd
	  });
	};
	
	proto.onRevealTransitionEnd = function() {
	  // check if still visible
	  // during transition, item may have been hidden
	  if ( !this.isHidden ) {
	    this.emitEvent('reveal');
	  }
	};
	
	/**
	 * get style property use for hide/reveal transition end
	 * @param {String} styleProperty - hiddenStyle/visibleStyle
	 * @returns {String}
	 */
	proto.getHideRevealTransitionEndProperty = function( styleProperty ) {
	  var optionStyle = this.layout.options[ styleProperty ];
	  // use opacity
	  if ( optionStyle.opacity ) {
	    return 'opacity';
	  }
	  // get first property
	  for ( var prop in optionStyle ) {
	    return prop;
	  }
	};
	
	proto.hide = function() {
	  // set flag
	  this.isHidden = true;
	  // remove display: none
	  this.css({ display: '' });
	
	  var options = this.layout.options;
	
	  var onTransitionEnd = {};
	  var transitionEndProperty = this.getHideRevealTransitionEndProperty('hiddenStyle');
	  onTransitionEnd[ transitionEndProperty ] = this.onHideTransitionEnd;
	
	  this.transition({
	    from: options.visibleStyle,
	    to: options.hiddenStyle,
	    // keep hidden stuff hidden
	    isCleaning: true,
	    onTransitionEnd: onTransitionEnd
	  });
	};
	
	proto.onHideTransitionEnd = function() {
	  // check if still hidden
	  // during transition, item may have been un-hidden
	  if ( this.isHidden ) {
	    this.css({ display: 'none' });
	    this.emitEvent('hide');
	  }
	};
	
	proto.destroy = function() {
	  this.css({
	    position: '',
	    left: '',
	    right: '',
	    top: '',
	    bottom: '',
	    transition: '',
	    transform: ''
	  });
	};
	
	return Item;
	
	}));


/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * Outlayer v2.1.1
	 * the brains and guts of a layout library
	 * MIT license
	 */
	
	( function( window, factory ) {
	  'use strict';
	  // universal module definition
	  /* jshint strict: false */ /* globals define, module, require */
	  if ( true ) {
	    // AMD - RequireJS
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(189),
	        __webpack_require__(125),
	        __webpack_require__(497),
	        __webpack_require__(514)
	      ], __WEBPACK_AMD_DEFINE_RESULT__ = function( EvEmitter, getSize, utils, Item ) {
	        return factory( window, EvEmitter, getSize, utils, Item);
	      }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS - Browserify, Webpack
	    module.exports = factory(
	      window,
	      require('ev-emitter'),
	      require('get-size'),
	      require('fizzy-ui-utils'),
	      require('./item')
	    );
	  } else {
	    // browser global
	    window.Outlayer = factory(
	      window,
	      window.EvEmitter,
	      window.getSize,
	      window.fizzyUIUtils,
	      window.Outlayer.Item
	    );
	  }
	
	}( window, function factory( window, EvEmitter, getSize, utils, Item ) {
	'use strict';
	
	// ----- vars ----- //
	
	var console = window.console;
	var jQuery = window.jQuery;
	var noop = function() {};
	
	// -------------------------- Outlayer -------------------------- //
	
	// globally unique identifiers
	var GUID = 0;
	// internal store of all Outlayer intances
	var instances = {};
	
	
	/**
	 * @param {Element, String} element
	 * @param {Object} options
	 * @constructor
	 */
	function Outlayer( element, options ) {
	  var queryElement = utils.getQueryElement( element );
	  if ( !queryElement ) {
	    if ( console ) {
	      console.error( 'Bad element for ' + this.constructor.namespace +
	        ': ' + ( queryElement || element ) );
	    }
	    return;
	  }
	  this.element = queryElement;
	  // add jQuery
	  if ( jQuery ) {
	    this.$element = jQuery( this.element );
	  }
	
	  // options
	  this.options = utils.extend( {}, this.constructor.defaults );
	  this.option( options );
	
	  // add id for Outlayer.getFromElement
	  var id = ++GUID;
	  this.element.outlayerGUID = id; // expando
	  instances[ id ] = this; // associate via id
	
	  // kick it off
	  this._create();
	
	  var isInitLayout = this._getOption('initLayout');
	  if ( isInitLayout ) {
	    this.layout();
	  }
	}
	
	// settings are for internal use only
	Outlayer.namespace = 'outlayer';
	Outlayer.Item = Item;
	
	// default options
	Outlayer.defaults = {
	  containerStyle: {
	    position: 'relative'
	  },
	  initLayout: true,
	  originLeft: true,
	  originTop: true,
	  resize: true,
	  resizeContainer: true,
	  // item options
	  transitionDuration: '0.4s',
	  hiddenStyle: {
	    opacity: 0,
	    transform: 'scale(0.001)'
	  },
	  visibleStyle: {
	    opacity: 1,
	    transform: 'scale(1)'
	  }
	};
	
	var proto = Outlayer.prototype;
	// inherit EvEmitter
	utils.extend( proto, EvEmitter.prototype );
	
	/**
	 * set options
	 * @param {Object} opts
	 */
	proto.option = function( opts ) {
	  utils.extend( this.options, opts );
	};
	
	/**
	 * get backwards compatible option value, check old name
	 */
	proto._getOption = function( option ) {
	  var oldOption = this.constructor.compatOptions[ option ];
	  return oldOption && this.options[ oldOption ] !== undefined ?
	    this.options[ oldOption ] : this.options[ option ];
	};
	
	Outlayer.compatOptions = {
	  // currentName: oldName
	  initLayout: 'isInitLayout',
	  horizontal: 'isHorizontal',
	  layoutInstant: 'isLayoutInstant',
	  originLeft: 'isOriginLeft',
	  originTop: 'isOriginTop',
	  resize: 'isResizeBound',
	  resizeContainer: 'isResizingContainer'
	};
	
	proto._create = function() {
	  // get items from children
	  this.reloadItems();
	  // elements that affect layout, but are not laid out
	  this.stamps = [];
	  this.stamp( this.options.stamp );
	  // set container style
	  utils.extend( this.element.style, this.options.containerStyle );
	
	  // bind resize method
	  var canBindResize = this._getOption('resize');
	  if ( canBindResize ) {
	    this.bindResize();
	  }
	};
	
	// goes through all children again and gets bricks in proper order
	proto.reloadItems = function() {
	  // collection of item elements
	  this.items = this._itemize( this.element.children );
	};
	
	
	/**
	 * turn elements into Outlayer.Items to be used in layout
	 * @param {Array or NodeList or HTMLElement} elems
	 * @returns {Array} items - collection of new Outlayer Items
	 */
	proto._itemize = function( elems ) {
	
	  var itemElems = this._filterFindItemElements( elems );
	  var Item = this.constructor.Item;
	
	  // create new Outlayer Items for collection
	  var items = [];
	  for ( var i=0; i < itemElems.length; i++ ) {
	    var elem = itemElems[i];
	    var item = new Item( elem, this );
	    items.push( item );
	  }
	
	  return items;
	};
	
	/**
	 * get item elements to be used in layout
	 * @param {Array or NodeList or HTMLElement} elems
	 * @returns {Array} items - item elements
	 */
	proto._filterFindItemElements = function( elems ) {
	  return utils.filterFindElements( elems, this.options.itemSelector );
	};
	
	/**
	 * getter method for getting item elements
	 * @returns {Array} elems - collection of item elements
	 */
	proto.getItemElements = function() {
	  return this.items.map( function( item ) {
	    return item.element;
	  });
	};
	
	// ----- init & layout ----- //
	
	/**
	 * lays out all items
	 */
	proto.layout = function() {
	  this._resetLayout();
	  this._manageStamps();
	
	  // don't animate first layout
	  var layoutInstant = this._getOption('layoutInstant');
	  var isInstant = layoutInstant !== undefined ?
	    layoutInstant : !this._isLayoutInited;
	  this.layoutItems( this.items, isInstant );
	
	  // flag for initalized
	  this._isLayoutInited = true;
	};
	
	// _init is alias for layout
	proto._init = proto.layout;
	
	/**
	 * logic before any new layout
	 */
	proto._resetLayout = function() {
	  this.getSize();
	};
	
	
	proto.getSize = function() {
	  this.size = getSize( this.element );
	};
	
	/**
	 * get measurement from option, for columnWidth, rowHeight, gutter
	 * if option is String -> get element from selector string, & get size of element
	 * if option is Element -> get size of element
	 * else use option as a number
	 *
	 * @param {String} measurement
	 * @param {String} size - width or height
	 * @private
	 */
	proto._getMeasurement = function( measurement, size ) {
	  var option = this.options[ measurement ];
	  var elem;
	  if ( !option ) {
	    // default to 0
	    this[ measurement ] = 0;
	  } else {
	    // use option as an element
	    if ( typeof option == 'string' ) {
	      elem = this.element.querySelector( option );
	    } else if ( option instanceof HTMLElement ) {
	      elem = option;
	    }
	    // use size of element, if element
	    this[ measurement ] = elem ? getSize( elem )[ size ] : option;
	  }
	};
	
	/**
	 * layout a collection of item elements
	 * @api public
	 */
	proto.layoutItems = function( items, isInstant ) {
	  items = this._getItemsForLayout( items );
	
	  this._layoutItems( items, isInstant );
	
	  this._postLayout();
	};
	
	/**
	 * get the items to be laid out
	 * you may want to skip over some items
	 * @param {Array} items
	 * @returns {Array} items
	 */
	proto._getItemsForLayout = function( items ) {
	  return items.filter( function( item ) {
	    return !item.isIgnored;
	  });
	};
	
	/**
	 * layout items
	 * @param {Array} items
	 * @param {Boolean} isInstant
	 */
	proto._layoutItems = function( items, isInstant ) {
	  this._emitCompleteOnItems( 'layout', items );
	
	  if ( !items || !items.length ) {
	    // no items, emit event with empty array
	    return;
	  }
	
	  var queue = [];
	
	  items.forEach( function( item ) {
	    // get x/y object from method
	    var position = this._getItemLayoutPosition( item );
	    // enqueue
	    position.item = item;
	    position.isInstant = isInstant || item.isLayoutInstant;
	    queue.push( position );
	  }, this );
	
	  this._processLayoutQueue( queue );
	};
	
	/**
	 * get item layout position
	 * @param {Outlayer.Item} item
	 * @returns {Object} x and y position
	 */
	proto._getItemLayoutPosition = function( /* item */ ) {
	  return {
	    x: 0,
	    y: 0
	  };
	};
	
	/**
	 * iterate over array and position each item
	 * Reason being - separating this logic prevents 'layout invalidation'
	 * thx @paul_irish
	 * @param {Array} queue
	 */
	proto._processLayoutQueue = function( queue ) {
	  this.updateStagger();
	  queue.forEach( function( obj, i ) {
	    this._positionItem( obj.item, obj.x, obj.y, obj.isInstant, i );
	  }, this );
	};
	
	// set stagger from option in milliseconds number
	proto.updateStagger = function() {
	  var stagger = this.options.stagger;
	  if ( stagger === null || stagger === undefined ) {
	    this.stagger = 0;
	    return;
	  }
	  this.stagger = getMilliseconds( stagger );
	  return this.stagger;
	};
	
	/**
	 * Sets position of item in DOM
	 * @param {Outlayer.Item} item
	 * @param {Number} x - horizontal position
	 * @param {Number} y - vertical position
	 * @param {Boolean} isInstant - disables transitions
	 */
	proto._positionItem = function( item, x, y, isInstant, i ) {
	  if ( isInstant ) {
	    // if not transition, just set CSS
	    item.goTo( x, y );
	  } else {
	    item.stagger( i * this.stagger );
	    item.moveTo( x, y );
	  }
	};
	
	/**
	 * Any logic you want to do after each layout,
	 * i.e. size the container
	 */
	proto._postLayout = function() {
	  this.resizeContainer();
	};
	
	proto.resizeContainer = function() {
	  var isResizingContainer = this._getOption('resizeContainer');
	  if ( !isResizingContainer ) {
	    return;
	  }
	  var size = this._getContainerSize();
	  if ( size ) {
	    this._setContainerMeasure( size.width, true );
	    this._setContainerMeasure( size.height, false );
	  }
	};
	
	/**
	 * Sets width or height of container if returned
	 * @returns {Object} size
	 *   @param {Number} width
	 *   @param {Number} height
	 */
	proto._getContainerSize = noop;
	
	/**
	 * @param {Number} measure - size of width or height
	 * @param {Boolean} isWidth
	 */
	proto._setContainerMeasure = function( measure, isWidth ) {
	  if ( measure === undefined ) {
	    return;
	  }
	
	  var elemSize = this.size;
	  // add padding and border width if border box
	  if ( elemSize.isBorderBox ) {
	    measure += isWidth ? elemSize.paddingLeft + elemSize.paddingRight +
	      elemSize.borderLeftWidth + elemSize.borderRightWidth :
	      elemSize.paddingBottom + elemSize.paddingTop +
	      elemSize.borderTopWidth + elemSize.borderBottomWidth;
	  }
	
	  measure = Math.max( measure, 0 );
	  this.element.style[ isWidth ? 'width' : 'height' ] = measure + 'px';
	};
	
	/**
	 * emit eventComplete on a collection of items events
	 * @param {String} eventName
	 * @param {Array} items - Outlayer.Items
	 */
	proto._emitCompleteOnItems = function( eventName, items ) {
	  var _this = this;
	  function onComplete() {
	    _this.dispatchEvent( eventName + 'Complete', null, [ items ] );
	  }
	
	  var count = items.length;
	  if ( !items || !count ) {
	    onComplete();
	    return;
	  }
	
	  var doneCount = 0;
	  function tick() {
	    doneCount++;
	    if ( doneCount == count ) {
	      onComplete();
	    }
	  }
	
	  // bind callback
	  items.forEach( function( item ) {
	    item.once( eventName, tick );
	  });
	};
	
	/**
	 * emits events via EvEmitter and jQuery events
	 * @param {String} type - name of event
	 * @param {Event} event - original event
	 * @param {Array} args - extra arguments
	 */
	proto.dispatchEvent = function( type, event, args ) {
	  // add original event to arguments
	  var emitArgs = event ? [ event ].concat( args ) : args;
	  this.emitEvent( type, emitArgs );
	
	  if ( jQuery ) {
	    // set this.$element
	    this.$element = this.$element || jQuery( this.element );
	    if ( event ) {
	      // create jQuery event
	      var $event = jQuery.Event( event );
	      $event.type = type;
	      this.$element.trigger( $event, args );
	    } else {
	      // just trigger with type if no event available
	      this.$element.trigger( type, args );
	    }
	  }
	};
	
	// -------------------------- ignore & stamps -------------------------- //
	
	
	/**
	 * keep item in collection, but do not lay it out
	 * ignored items do not get skipped in layout
	 * @param {Element} elem
	 */
	proto.ignore = function( elem ) {
	  var item = this.getItem( elem );
	  if ( item ) {
	    item.isIgnored = true;
	  }
	};
	
	/**
	 * return item to layout collection
	 * @param {Element} elem
	 */
	proto.unignore = function( elem ) {
	  var item = this.getItem( elem );
	  if ( item ) {
	    delete item.isIgnored;
	  }
	};
	
	/**
	 * adds elements to stamps
	 * @param {NodeList, Array, Element, or String} elems
	 */
	proto.stamp = function( elems ) {
	  elems = this._find( elems );
	  if ( !elems ) {
	    return;
	  }
	
	  this.stamps = this.stamps.concat( elems );
	  // ignore
	  elems.forEach( this.ignore, this );
	};
	
	/**
	 * removes elements to stamps
	 * @param {NodeList, Array, or Element} elems
	 */
	proto.unstamp = function( elems ) {
	  elems = this._find( elems );
	  if ( !elems ){
	    return;
	  }
	
	  elems.forEach( function( elem ) {
	    // filter out removed stamp elements
	    utils.removeFrom( this.stamps, elem );
	    this.unignore( elem );
	  }, this );
	};
	
	/**
	 * finds child elements
	 * @param {NodeList, Array, Element, or String} elems
	 * @returns {Array} elems
	 */
	proto._find = function( elems ) {
	  if ( !elems ) {
	    return;
	  }
	  // if string, use argument as selector string
	  if ( typeof elems == 'string' ) {
	    elems = this.element.querySelectorAll( elems );
	  }
	  elems = utils.makeArray( elems );
	  return elems;
	};
	
	proto._manageStamps = function() {
	  if ( !this.stamps || !this.stamps.length ) {
	    return;
	  }
	
	  this._getBoundingRect();
	
	  this.stamps.forEach( this._manageStamp, this );
	};
	
	// update boundingLeft / Top
	proto._getBoundingRect = function() {
	  // get bounding rect for container element
	  var boundingRect = this.element.getBoundingClientRect();
	  var size = this.size;
	  this._boundingRect = {
	    left: boundingRect.left + size.paddingLeft + size.borderLeftWidth,
	    top: boundingRect.top + size.paddingTop + size.borderTopWidth,
	    right: boundingRect.right - ( size.paddingRight + size.borderRightWidth ),
	    bottom: boundingRect.bottom - ( size.paddingBottom + size.borderBottomWidth )
	  };
	};
	
	/**
	 * @param {Element} stamp
	**/
	proto._manageStamp = noop;
	
	/**
	 * get x/y position of element relative to container element
	 * @param {Element} elem
	 * @returns {Object} offset - has left, top, right, bottom
	 */
	proto._getElementOffset = function( elem ) {
	  var boundingRect = elem.getBoundingClientRect();
	  var thisRect = this._boundingRect;
	  var size = getSize( elem );
	  var offset = {
	    left: boundingRect.left - thisRect.left - size.marginLeft,
	    top: boundingRect.top - thisRect.top - size.marginTop,
	    right: thisRect.right - boundingRect.right - size.marginRight,
	    bottom: thisRect.bottom - boundingRect.bottom - size.marginBottom
	  };
	  return offset;
	};
	
	// -------------------------- resize -------------------------- //
	
	// enable event handlers for listeners
	// i.e. resize -> onresize
	proto.handleEvent = utils.handleEvent;
	
	/**
	 * Bind layout to window resizing
	 */
	proto.bindResize = function() {
	  window.addEventListener( 'resize', this );
	  this.isResizeBound = true;
	};
	
	/**
	 * Unbind layout to window resizing
	 */
	proto.unbindResize = function() {
	  window.removeEventListener( 'resize', this );
	  this.isResizeBound = false;
	};
	
	proto.onresize = function() {
	  this.resize();
	};
	
	utils.debounceMethod( Outlayer, 'onresize', 100 );
	
	proto.resize = function() {
	  // don't trigger if size did not change
	  // or if resize was unbound. See #9
	  if ( !this.isResizeBound || !this.needsResizeLayout() ) {
	    return;
	  }
	
	  this.layout();
	};
	
	/**
	 * check if layout is needed post layout
	 * @returns Boolean
	 */
	proto.needsResizeLayout = function() {
	  var size = getSize( this.element );
	  // check that this.size and size are there
	  // IE8 triggers resize on body size change, so they might not be
	  var hasSizes = this.size && size;
	  return hasSizes && size.innerWidth !== this.size.innerWidth;
	};
	
	// -------------------------- methods -------------------------- //
	
	/**
	 * add items to Outlayer instance
	 * @param {Array or NodeList or Element} elems
	 * @returns {Array} items - Outlayer.Items
	**/
	proto.addItems = function( elems ) {
	  var items = this._itemize( elems );
	  // add items to collection
	  if ( items.length ) {
	    this.items = this.items.concat( items );
	  }
	  return items;
	};
	
	/**
	 * Layout newly-appended item elements
	 * @param {Array or NodeList or Element} elems
	 */
	proto.appended = function( elems ) {
	  var items = this.addItems( elems );
	  if ( !items.length ) {
	    return;
	  }
	  // layout and reveal just the new items
	  this.layoutItems( items, true );
	  this.reveal( items );
	};
	
	/**
	 * Layout prepended elements
	 * @param {Array or NodeList or Element} elems
	 */
	proto.prepended = function( elems ) {
	  var items = this._itemize( elems );
	  if ( !items.length ) {
	    return;
	  }
	  // add items to beginning of collection
	  var previousItems = this.items.slice(0);
	  this.items = items.concat( previousItems );
	  // start new layout
	  this._resetLayout();
	  this._manageStamps();
	  // layout new stuff without transition
	  this.layoutItems( items, true );
	  this.reveal( items );
	  // layout previous items
	  this.layoutItems( previousItems );
	};
	
	/**
	 * reveal a collection of items
	 * @param {Array of Outlayer.Items} items
	 */
	proto.reveal = function( items ) {
	  this._emitCompleteOnItems( 'reveal', items );
	  if ( !items || !items.length ) {
	    return;
	  }
	  var stagger = this.updateStagger();
	  items.forEach( function( item, i ) {
	    item.stagger( i * stagger );
	    item.reveal();
	  });
	};
	
	/**
	 * hide a collection of items
	 * @param {Array of Outlayer.Items} items
	 */
	proto.hide = function( items ) {
	  this._emitCompleteOnItems( 'hide', items );
	  if ( !items || !items.length ) {
	    return;
	  }
	  var stagger = this.updateStagger();
	  items.forEach( function( item, i ) {
	    item.stagger( i * stagger );
	    item.hide();
	  });
	};
	
	/**
	 * reveal item elements
	 * @param {Array}, {Element}, {NodeList} items
	 */
	proto.revealItemElements = function( elems ) {
	  var items = this.getItems( elems );
	  this.reveal( items );
	};
	
	/**
	 * hide item elements
	 * @param {Array}, {Element}, {NodeList} items
	 */
	proto.hideItemElements = function( elems ) {
	  var items = this.getItems( elems );
	  this.hide( items );
	};
	
	/**
	 * get Outlayer.Item, given an Element
	 * @param {Element} elem
	 * @param {Function} callback
	 * @returns {Outlayer.Item} item
	 */
	proto.getItem = function( elem ) {
	  // loop through items to get the one that matches
	  for ( var i=0; i < this.items.length; i++ ) {
	    var item = this.items[i];
	    if ( item.element == elem ) {
	      // return item
	      return item;
	    }
	  }
	};
	
	/**
	 * get collection of Outlayer.Items, given Elements
	 * @param {Array} elems
	 * @returns {Array} items - Outlayer.Items
	 */
	proto.getItems = function( elems ) {
	  elems = utils.makeArray( elems );
	  var items = [];
	  elems.forEach( function( elem ) {
	    var item = this.getItem( elem );
	    if ( item ) {
	      items.push( item );
	    }
	  }, this );
	
	  return items;
	};
	
	/**
	 * remove element(s) from instance and DOM
	 * @param {Array or NodeList or Element} elems
	 */
	proto.remove = function( elems ) {
	  var removeItems = this.getItems( elems );
	
	  this._emitCompleteOnItems( 'remove', removeItems );
	
	  // bail if no items to remove
	  if ( !removeItems || !removeItems.length ) {
	    return;
	  }
	
	  removeItems.forEach( function( item ) {
	    item.remove();
	    // remove item from collection
	    utils.removeFrom( this.items, item );
	  }, this );
	};
	
	// ----- destroy ----- //
	
	// remove and disable Outlayer instance
	proto.destroy = function() {
	  // clean up dynamic styles
	  var style = this.element.style;
	  style.height = '';
	  style.position = '';
	  style.width = '';
	  // destroy items
	  this.items.forEach( function( item ) {
	    item.destroy();
	  });
	
	  this.unbindResize();
	
	  var id = this.element.outlayerGUID;
	  delete instances[ id ]; // remove reference to instance by id
	  delete this.element.outlayerGUID;
	  // remove data for jQuery
	  if ( jQuery ) {
	    jQuery.removeData( this.element, this.constructor.namespace );
	  }
	
	};
	
	// -------------------------- data -------------------------- //
	
	/**
	 * get Outlayer instance from element
	 * @param {Element} elem
	 * @returns {Outlayer}
	 */
	Outlayer.data = function( elem ) {
	  elem = utils.getQueryElement( elem );
	  var id = elem && elem.outlayerGUID;
	  return id && instances[ id ];
	};
	
	
	// -------------------------- create Outlayer class -------------------------- //
	
	/**
	 * create a layout class
	 * @param {String} namespace
	 */
	Outlayer.create = function( namespace, options ) {
	  // sub-class Outlayer
	  var Layout = subclass( Outlayer );
	  // apply new options and compatOptions
	  Layout.defaults = utils.extend( {}, Outlayer.defaults );
	  utils.extend( Layout.defaults, options );
	  Layout.compatOptions = utils.extend( {}, Outlayer.compatOptions  );
	
	  Layout.namespace = namespace;
	
	  Layout.data = Outlayer.data;
	
	  // sub-class Item
	  Layout.Item = subclass( Item );
	
	  // -------------------------- declarative -------------------------- //
	
	  utils.htmlInit( Layout, namespace );
	
	  // -------------------------- jQuery bridge -------------------------- //
	
	  // make into jQuery plugin
	  if ( jQuery && jQuery.bridget ) {
	    jQuery.bridget( namespace, Layout );
	  }
	
	  return Layout;
	};
	
	function subclass( Parent ) {
	  function SubClass() {
	    Parent.apply( this, arguments );
	  }
	
	  SubClass.prototype = Object.create( Parent.prototype );
	  SubClass.prototype.constructor = SubClass;
	
	  return SubClass;
	}
	
	// ----- helpers ----- //
	
	// how many milliseconds are in each unit
	var msUnits = {
	  ms: 1,
	  s: 1000
	};
	
	// munge time-like parameter into millisecond number
	// '0.4s' -> 40
	function getMilliseconds( time ) {
	  if ( typeof time == 'number' ) {
	    return time;
	  }
	  var matches = time.match( /(^\d*\.?\d*)(\w*)/ );
	  var num = matches && matches[1];
	  var unit = matches && matches[2];
	  if ( !num.length ) {
	    return 0;
	  }
	  num = parseFloat( num );
	  var mult = msUnits[ unit ] || 1;
	  return num * mult;
	}
	
	// ----- fin ----- //
	
	// back in global
	Outlayer.Item = Item;
	
	return Outlayer;
	
	}));


/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(88);
	var invariant = __webpack_require__(478);
	var ReactPropTypesSecret = __webpack_require__(517);
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 517 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.2.0
	 * react-dom.production.min.js
	 *
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	/*
	 Modernizr 3.0.0pre (Custom Build) | MIT
	*/
	'use strict';var aa=__webpack_require__(2),l=__webpack_require__(474),B=__webpack_require__(67),C=__webpack_require__(88),ba=__webpack_require__(473),da=__webpack_require__(477),ea=__webpack_require__(481),fa=__webpack_require__(475),ia=__webpack_require__(476),D=__webpack_require__(190);
	function E(a){for(var b=arguments.length-1,c="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,d=0;d<b;d++)c+="\x26args[]\x3d"+encodeURIComponent(arguments[d+1]);b=Error(c+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}aa?void 0:E("227");
	var oa={children:!0,dangerouslySetInnerHTML:!0,defaultValue:!0,defaultChecked:!0,innerHTML:!0,suppressContentEditableWarning:!0,suppressHydrationWarning:!0,style:!0};function pa(a,b){return(a&b)===b}
	var ta={MUST_USE_PROPERTY:1,HAS_BOOLEAN_VALUE:4,HAS_NUMERIC_VALUE:8,HAS_POSITIVE_NUMERIC_VALUE:24,HAS_OVERLOADED_BOOLEAN_VALUE:32,HAS_STRING_BOOLEAN_VALUE:64,injectDOMPropertyConfig:function(a){var b=ta,c=a.Properties||{},d=a.DOMAttributeNamespaces||{},e=a.DOMAttributeNames||{};a=a.DOMMutationMethods||{};for(var f in c){ua.hasOwnProperty(f)?E("48",f):void 0;var g=f.toLowerCase(),h=c[f];g={attributeName:g,attributeNamespace:null,propertyName:f,mutationMethod:null,mustUseProperty:pa(h,b.MUST_USE_PROPERTY),
	hasBooleanValue:pa(h,b.HAS_BOOLEAN_VALUE),hasNumericValue:pa(h,b.HAS_NUMERIC_VALUE),hasPositiveNumericValue:pa(h,b.HAS_POSITIVE_NUMERIC_VALUE),hasOverloadedBooleanValue:pa(h,b.HAS_OVERLOADED_BOOLEAN_VALUE),hasStringBooleanValue:pa(h,b.HAS_STRING_BOOLEAN_VALUE)};1>=g.hasBooleanValue+g.hasNumericValue+g.hasOverloadedBooleanValue?void 0:E("50",f);e.hasOwnProperty(f)&&(g.attributeName=e[f]);d.hasOwnProperty(f)&&(g.attributeNamespace=d[f]);a.hasOwnProperty(f)&&(g.mutationMethod=a[f]);ua[f]=g}}},ua={};
	function va(a,b){if(oa.hasOwnProperty(a)||2<a.length&&("o"===a[0]||"O"===a[0])&&("n"===a[1]||"N"===a[1]))return!1;if(null===b)return!0;switch(typeof b){case "boolean":return oa.hasOwnProperty(a)?a=!0:(b=wa(a))?a=b.hasBooleanValue||b.hasStringBooleanValue||b.hasOverloadedBooleanValue:(a=a.toLowerCase().slice(0,5),a="data-"===a||"aria-"===a),a;case "undefined":case "number":case "string":case "object":return!0;default:return!1}}function wa(a){return ua.hasOwnProperty(a)?ua[a]:null}
	var xa=ta,ya=xa.MUST_USE_PROPERTY,K=xa.HAS_BOOLEAN_VALUE,za=xa.HAS_NUMERIC_VALUE,Aa=xa.HAS_POSITIVE_NUMERIC_VALUE,Ba=xa.HAS_OVERLOADED_BOOLEAN_VALUE,Ca=xa.HAS_STRING_BOOLEAN_VALUE,Da={Properties:{allowFullScreen:K,async:K,autoFocus:K,autoPlay:K,capture:Ba,checked:ya|K,cols:Aa,contentEditable:Ca,controls:K,"default":K,defer:K,disabled:K,download:Ba,draggable:Ca,formNoValidate:K,hidden:K,loop:K,multiple:ya|K,muted:ya|K,noValidate:K,open:K,playsInline:K,readOnly:K,required:K,reversed:K,rows:Aa,rowSpan:za,
	scoped:K,seamless:K,selected:ya|K,size:Aa,start:za,span:Aa,spellCheck:Ca,style:0,tabIndex:0,itemScope:K,acceptCharset:0,className:0,htmlFor:0,httpEquiv:0,value:Ca},DOMAttributeNames:{acceptCharset:"accept-charset",className:"class",htmlFor:"for",httpEquiv:"http-equiv"},DOMMutationMethods:{value:function(a,b){if(null==b)return a.removeAttribute("value");"number"!==a.type||!1===a.hasAttribute("value")?a.setAttribute("value",""+b):a.validity&&!a.validity.badInput&&a.ownerDocument.activeElement!==a&&
	a.setAttribute("value",""+b)}}},Ea=xa.HAS_STRING_BOOLEAN_VALUE,M={xlink:"http://www.w3.org/1999/xlink",xml:"http://www.w3.org/XML/1998/namespace"},Ga={Properties:{autoReverse:Ea,externalResourcesRequired:Ea,preserveAlpha:Ea},DOMAttributeNames:{autoReverse:"autoReverse",externalResourcesRequired:"externalResourcesRequired",preserveAlpha:"preserveAlpha"},DOMAttributeNamespaces:{xlinkActuate:M.xlink,xlinkArcrole:M.xlink,xlinkHref:M.xlink,xlinkRole:M.xlink,xlinkShow:M.xlink,xlinkTitle:M.xlink,xlinkType:M.xlink,
	xmlBase:M.xml,xmlLang:M.xml,xmlSpace:M.xml}},Ha=/[\-\:]([a-z])/g;function Ia(a){return a[1].toUpperCase()}
	"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode x-height xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type xml:base xmlns:xlink xml:lang xml:space".split(" ").forEach(function(a){var b=a.replace(Ha,
	Ia);Ga.Properties[b]=0;Ga.DOMAttributeNames[b]=a});xa.injectDOMPropertyConfig(Da);xa.injectDOMPropertyConfig(Ga);
	var P={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,injection:{injectErrorUtils:function(a){"function"!==typeof a.invokeGuardedCallback?E("197"):void 0;Ja=a.invokeGuardedCallback}},invokeGuardedCallback:function(a,b,c,d,e,f,g,h,k){Ja.apply(P,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,g,h,k){P.invokeGuardedCallback.apply(this,arguments);if(P.hasCaughtError()){var q=P.clearCaughtError();P._hasRethrowError||(P._hasRethrowError=!0,P._rethrowError=
	q)}},rethrowCaughtError:function(){return Ka.apply(P,arguments)},hasCaughtError:function(){return P._hasCaughtError},clearCaughtError:function(){if(P._hasCaughtError){var a=P._caughtError;P._caughtError=null;P._hasCaughtError=!1;return a}E("198")}};function Ja(a,b,c,d,e,f,g,h,k){P._hasCaughtError=!1;P._caughtError=null;var q=Array.prototype.slice.call(arguments,3);try{b.apply(c,q)}catch(v){P._caughtError=v,P._hasCaughtError=!0}}
	function Ka(){if(P._hasRethrowError){var a=P._rethrowError;P._rethrowError=null;P._hasRethrowError=!1;throw a;}}var La=null,Ma={};
	function Na(){if(La)for(var a in Ma){var b=Ma[a],c=La.indexOf(a);-1<c?void 0:E("96",a);if(!Oa[c]){b.extractEvents?void 0:E("97",a);Oa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;Pa.hasOwnProperty(h)?E("99",h):void 0;Pa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&Qa(k[e],g,h);e=!0}else f.registrationName?(Qa(f.registrationName,g,h),e=!0):e=!1;e?void 0:E("98",d,a)}}}}
	function Qa(a,b,c){Ra[a]?E("100",a):void 0;Ra[a]=b;Sa[a]=b.eventTypes[c].dependencies}var Oa=[],Pa={},Ra={},Sa={};function Ta(a){La?E("101"):void 0;La=Array.prototype.slice.call(a);Na()}function Ua(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];Ma.hasOwnProperty(c)&&Ma[c]===d||(Ma[c]?E("102",c):void 0,Ma[c]=d,b=!0)}b&&Na()}
	var Va=Object.freeze({plugins:Oa,eventNameDispatchConfigs:Pa,registrationNameModules:Ra,registrationNameDependencies:Sa,possibleRegistrationNames:null,injectEventPluginOrder:Ta,injectEventPluginsByName:Ua}),Wa=null,Xa=null,Ya=null;function Za(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=Ya(d);P.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a);a.currentTarget=null}
	function $a(a,b){null==b?E("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function ab(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var bb=null;
	function cb(a,b){if(a){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)Za(a,b,c[e],d[e]);else c&&Za(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function db(a){return cb(a,!0)}function gb(a){return cb(a,!1)}var hb={injectEventPluginOrder:Ta,injectEventPluginsByName:Ua};
	function ib(a,b){var c=a.stateNode;if(!c)return null;var d=Wa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?E("231",b,typeof c):void 0;
	return c}function jb(a,b,c,d){for(var e,f=0;f<Oa.length;f++){var g=Oa[f];g&&(g=g.extractEvents(a,b,c,d))&&(e=$a(e,g))}return e}function kb(a){a&&(bb=$a(bb,a))}function lb(a){var b=bb;bb=null;b&&(a?ab(b,db):ab(b,gb),bb?E("95"):void 0,P.rethrowCaughtError())}var mb=Object.freeze({injection:hb,getListener:ib,extractEvents:jb,enqueueEvents:kb,processEventQueue:lb}),nb=Math.random().toString(36).slice(2),Q="__reactInternalInstance$"+nb,ob="__reactEventHandlers$"+nb;
	function pb(a){if(a[Q])return a[Q];for(var b=[];!a[Q];)if(b.push(a),a.parentNode)a=a.parentNode;else return null;var c=void 0,d=a[Q];if(5===d.tag||6===d.tag)return d;for(;a&&(d=a[Q]);a=b.pop())c=d;return c}function qb(a){if(5===a.tag||6===a.tag)return a.stateNode;E("33")}function rb(a){return a[ob]||null}
	var sb=Object.freeze({precacheFiberNode:function(a,b){b[Q]=a},getClosestInstanceFromNode:pb,getInstanceFromNode:function(a){a=a[Q];return!a||5!==a.tag&&6!==a.tag?null:a},getNodeFromInstance:qb,getFiberCurrentPropsFromNode:rb,updateFiberProps:function(a,b){a[ob]=b}});function tb(a){do a=a["return"];while(a&&5!==a.tag);return a?a:null}function ub(a,b,c){for(var d=[];a;)d.push(a),a=tb(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)}
	function vb(a,b,c){if(b=ib(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=$a(c._dispatchListeners,b),c._dispatchInstances=$a(c._dispatchInstances,a)}function wb(a){a&&a.dispatchConfig.phasedRegistrationNames&&ub(a._targetInst,vb,a)}function xb(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?tb(b):null;ub(b,vb,a)}}
	function yb(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=ib(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=$a(c._dispatchListeners,b),c._dispatchInstances=$a(c._dispatchInstances,a))}function zb(a){a&&a.dispatchConfig.registrationName&&yb(a._targetInst,null,a)}function Ab(a){ab(a,wb)}
	function Bb(a,b,c,d){if(c&&d)a:{var e=c;for(var f=d,g=0,h=e;h;h=tb(h))g++;h=0;for(var k=f;k;k=tb(k))h++;for(;0<g-h;)e=tb(e),g--;for(;0<h-g;)f=tb(f),h--;for(;g--;){if(e===f||e===f.alternate)break a;e=tb(e);f=tb(f)}e=null}else e=null;f=e;for(e=[];c&&c!==f;){g=c.alternate;if(null!==g&&g===f)break;e.push(c);c=tb(c)}for(c=[];d&&d!==f;){g=d.alternate;if(null!==g&&g===f)break;c.push(d);d=tb(d)}for(d=0;d<e.length;d++)yb(e[d],"bubbled",a);for(a=c.length;0<a--;)yb(c[a],"captured",b)}
	var Cb=Object.freeze({accumulateTwoPhaseDispatches:Ab,accumulateTwoPhaseDispatchesSkipTarget:function(a){ab(a,xb)},accumulateEnterLeaveDispatches:Bb,accumulateDirectDispatches:function(a){ab(a,zb)}}),Db=null;function Eb(){!Db&&l.canUseDOM&&(Db="textContent"in document.documentElement?"textContent":"innerText");return Db}var S={_root:null,_startText:null,_fallbackText:null};
	function Fb(){if(S._fallbackText)return S._fallbackText;var a,b=S._startText,c=b.length,d,e=Gb(),f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);S._fallbackText=e.slice(a,1<d?1-d:void 0);return S._fallbackText}function Gb(){return"value"in S._root?S._root.value:S._root[Eb()]}
	var Hb="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),Ib={type:null,target:null,currentTarget:C.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
	function T(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?C.thatReturnsTrue:C.thatReturnsFalse;this.isPropagationStopped=C.thatReturnsFalse;return this}
	B(T.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=C.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=C.thatReturnsTrue)},persist:function(){this.isPersistent=C.thatReturnsTrue},isPersistent:C.thatReturnsFalse,
	destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<Hb.length;a++)this[Hb[a]]=null}});T.Interface=Ib;T.augmentClass=function(a,b){function c(){}c.prototype=this.prototype;var d=new c;B(d,a.prototype);a.prototype=d;a.prototype.constructor=a;a.Interface=B({},this.Interface,b);a.augmentClass=this.augmentClass;Jb(a)};Jb(T);function Kb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
	function Lb(a){a instanceof this?void 0:E("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function Jb(a){a.eventPool=[];a.getPooled=Kb;a.release=Lb}function Mb(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Mb,{data:null});function Nb(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Nb,{data:null});var Pb=[9,13,27,32],Vb=l.canUseDOM&&"CompositionEvent"in window,Wb=null;l.canUseDOM&&"documentMode"in document&&(Wb=document.documentMode);var Xb;
	if(Xb=l.canUseDOM&&"TextEvent"in window&&!Wb){var Yb=window.opera;Xb=!("object"===typeof Yb&&"function"===typeof Yb.version&&12>=parseInt(Yb.version(),10))}
	var Zb=Xb,$b=l.canUseDOM&&(!Vb||Wb&&8<Wb&&11>=Wb),ac=String.fromCharCode(32),bc={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["topCompositionEnd","topKeyPress","topTextInput","topPaste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"topBlur topCompositionEnd topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
	captured:"onCompositionStartCapture"},dependencies:"topBlur topCompositionStart topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"topBlur topCompositionUpdate topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")}},cc=!1;
	function dc(a,b){switch(a){case "topKeyUp":return-1!==Pb.indexOf(b.keyCode);case "topKeyDown":return 229!==b.keyCode;case "topKeyPress":case "topMouseDown":case "topBlur":return!0;default:return!1}}function ec(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var fc=!1;function gc(a,b){switch(a){case "topCompositionEnd":return ec(b);case "topKeyPress":if(32!==b.which)return null;cc=!0;return ac;case "topTextInput":return a=b.data,a===ac&&cc?null:a;default:return null}}
	function hc(a,b){if(fc)return"topCompositionEnd"===a||!Vb&&dc(a,b)?(a=Fb(),S._root=null,S._startText=null,S._fallbackText=null,fc=!1,a):null;switch(a){case "topPaste":return null;case "topKeyPress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "topCompositionEnd":return $b?null:b.data;default:return null}}
	var ic={eventTypes:bc,extractEvents:function(a,b,c,d){var e;if(Vb)b:{switch(a){case "topCompositionStart":var f=bc.compositionStart;break b;case "topCompositionEnd":f=bc.compositionEnd;break b;case "topCompositionUpdate":f=bc.compositionUpdate;break b}f=void 0}else fc?dc(a,c)&&(f=bc.compositionEnd):"topKeyDown"===a&&229===c.keyCode&&(f=bc.compositionStart);f?($b&&(fc||f!==bc.compositionStart?f===bc.compositionEnd&&fc&&(e=Fb()):(S._root=d,S._startText=Gb(),fc=!0)),f=Mb.getPooled(f,b,c,d),e?f.data=
	e:(e=ec(c),null!==e&&(f.data=e)),Ab(f),e=f):e=null;(a=Zb?gc(a,c):hc(a,c))?(b=Nb.getPooled(bc.beforeInput,b,c,d),b.data=a,Ab(b)):b=null;return[e,b]}},jc=null,kc=null,lc=null;function mc(a){if(a=Xa(a)){jc&&"function"===typeof jc.restoreControlledState?void 0:E("194");var b=Wa(a.stateNode);jc.restoreControlledState(a.stateNode,a.type,b)}}var nc={injectFiberControlledHostComponent:function(a){jc=a}};function oc(a){kc?lc?lc.push(a):lc=[a]:kc=a}
	function pc(){if(kc){var a=kc,b=lc;lc=kc=null;mc(a);if(b)for(a=0;a<b.length;a++)mc(b[a])}}var qc=Object.freeze({injection:nc,enqueueStateRestore:oc,restoreStateIfNeeded:pc});function rc(a,b){return a(b)}var sc=!1;function tc(a,b){if(sc)return rc(a,b);sc=!0;try{return rc(a,b)}finally{sc=!1,pc()}}var uc={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};
	function vc(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!uc[a.type]:"textarea"===b?!0:!1}function wc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}var xc;l.canUseDOM&&(xc=document.implementation&&document.implementation.hasFeature&&!0!==document.implementation.hasFeature("",""));
	function yc(a,b){if(!l.canUseDOM||b&&!("addEventListener"in document))return!1;b="on"+a;var c=b in document;c||(c=document.createElement("div"),c.setAttribute(b,"return;"),c="function"===typeof c[b]);!c&&xc&&"wheel"===a&&(c=document.implementation.hasFeature("Events.wheel","3.0"));return c}function zc(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
	function Ac(a){var b=zc(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"function"===typeof c.get&&"function"===typeof c.set)return Object.defineProperty(a,b,{enumerable:c.enumerable,configurable:!0,get:function(){return c.get.call(this)},set:function(a){d=""+a;c.set.call(this,a)}}),{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=null;delete a[b]}}}
	function Bc(a){a._valueTracker||(a._valueTracker=Ac(a))}function Cc(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=zc(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}var Dc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"topBlur topChange topClick topFocus topInput topKeyDown topKeyUp topSelectionChange".split(" ")}};
	function Ec(a,b,c){a=T.getPooled(Dc.change,a,b,c);a.type="change";oc(c);Ab(a);return a}var Fc=null,Gc=null;function Hc(a){kb(a);lb(!1)}function Ic(a){var b=qb(a);if(Cc(b))return a}function Jc(a,b){if("topChange"===a)return b}var Kc=!1;l.canUseDOM&&(Kc=yc("input")&&(!document.documentMode||9<document.documentMode));function Lc(){Fc&&(Fc.detachEvent("onpropertychange",Mc),Gc=Fc=null)}function Mc(a){"value"===a.propertyName&&Ic(Gc)&&(a=Ec(Gc,a,wc(a)),tc(Hc,a))}
	function Nc(a,b,c){"topFocus"===a?(Lc(),Fc=b,Gc=c,Fc.attachEvent("onpropertychange",Mc)):"topBlur"===a&&Lc()}function Oc(a){if("topSelectionChange"===a||"topKeyUp"===a||"topKeyDown"===a)return Ic(Gc)}function Pc(a,b){if("topClick"===a)return Ic(b)}function $c(a,b){if("topInput"===a||"topChange"===a)return Ic(b)}
	var ad={eventTypes:Dc,_isInputEventSupported:Kc,extractEvents:function(a,b,c,d){var e=b?qb(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Jc;else if(vc(e))if(Kc)g=$c;else{g=Oc;var h=Nc}else f=e.nodeName,!f||"input"!==f.toLowerCase()||"checkbox"!==e.type&&"radio"!==e.type||(g=Pc);if(g&&(g=g(a,b)))return Ec(g,c,d);h&&h(a,e,b);"topBlur"===a&&null!=b&&(a=b._wrapperState||e._wrapperState)&&a.controlled&&"number"===e.type&&(a=""+e.value,e.getAttribute("value")!==
	a&&e.setAttribute("value",a))}};function bd(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(bd,{view:null,detail:null});var cd={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function dd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=cd[a])?!!b[a]:!1}function ed(){return dd}function fd(a,b,c,d){return T.call(this,a,b,c,d)}
	bd.augmentClass(fd,{screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:ed,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)}});
	var gd={mouseEnter:{registrationName:"onMouseEnter",dependencies:["topMouseOut","topMouseOver"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["topMouseOut","topMouseOver"]}},hd={eventTypes:gd,extractEvents:function(a,b,c,d){if("topMouseOver"===a&&(c.relatedTarget||c.fromElement)||"topMouseOut"!==a&&"topMouseOver"!==a)return null;var e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;"topMouseOut"===a?(a=b,b=(b=c.relatedTarget||c.toElement)?pb(b):null):a=null;if(a===
	b)return null;var f=null==a?e:qb(a);e=null==b?e:qb(b);var g=fd.getPooled(gd.mouseLeave,a,c,d);g.type="mouseleave";g.target=f;g.relatedTarget=e;c=fd.getPooled(gd.mouseEnter,b,c,d);c.type="mouseenter";c.target=e;c.relatedTarget=f;Bb(g,c,a,b);return[g,c]}},id=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner;function jd(a){a=a.type;return"string"===typeof a?a:"function"===typeof a?a.displayName||a.name:null}
	function kd(a){var b=a;if(a.alternate)for(;b["return"];)b=b["return"];else{if(0!==(b.effectTag&2))return 1;for(;b["return"];)if(b=b["return"],0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function ld(a){return(a=a._reactInternalFiber)?2===kd(a):!1}function md(a){2!==kd(a)?E("188"):void 0}
	function nd(a){var b=a.alternate;if(!b)return b=kd(a),3===b?E("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c["return"],f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return md(e),a;if(g===d)return md(e),b;g=g.sibling}E("188")}if(c["return"]!==d["return"])c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
	void 0:E("189")}}c.alternate!==d?E("190"):void 0}3!==c.tag?E("188"):void 0;return c.stateNode.current===c?a:b}function od(a){a=nd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}
	function pd(a){a=nd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child&&4!==b.tag)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}var qd=[];
	function rd(a){var b=a.targetInst;do{if(!b){a.ancestors.push(b);break}var c;for(c=b;c["return"];)c=c["return"];c=3!==c.tag?null:c.stateNode.containerInfo;if(!c)break;a.ancestors.push(b);b=pb(c)}while(b);for(c=0;c<a.ancestors.length;c++)b=a.ancestors[c],sd(a.topLevelType,b,a.nativeEvent,wc(a.nativeEvent))}var td=!0,sd=void 0;function ud(a){td=!!a}function U(a,b,c){return c?ba.listen(c,b,vd.bind(null,a)):null}function wd(a,b,c){return c?ba.capture(c,b,vd.bind(null,a)):null}
	function vd(a,b){if(td){var c=wc(b);c=pb(c);null===c||"number"!==typeof c.tag||2===kd(c)||(c=null);if(qd.length){var d=qd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{tc(rd,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>qd.length&&qd.push(a)}}}
	var xd=Object.freeze({get _enabled(){return td},get _handleTopLevel(){return sd},setHandleTopLevel:function(a){sd=a},setEnabled:ud,isEnabled:function(){return td},trapBubbledEvent:U,trapCapturedEvent:wd,dispatchEvent:vd});function yd(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;c["ms"+a]="MS"+b;c["O"+a]="o"+b.toLowerCase();return c}
	var zd={animationend:yd("Animation","AnimationEnd"),animationiteration:yd("Animation","AnimationIteration"),animationstart:yd("Animation","AnimationStart"),transitionend:yd("Transition","TransitionEnd")},Ad={},Bd={};l.canUseDOM&&(Bd=document.createElement("div").style,"AnimationEvent"in window||(delete zd.animationend.animation,delete zd.animationiteration.animation,delete zd.animationstart.animation),"TransitionEvent"in window||delete zd.transitionend.transition);
	function Cd(a){if(Ad[a])return Ad[a];if(!zd[a])return a;var b=zd[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Bd)return Ad[a]=b[c];return""}
	var Dd={topAbort:"abort",topAnimationEnd:Cd("animationend")||"animationend",topAnimationIteration:Cd("animationiteration")||"animationiteration",topAnimationStart:Cd("animationstart")||"animationstart",topBlur:"blur",topCancel:"cancel",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topChange:"change",topClick:"click",topClose:"close",topCompositionEnd:"compositionend",topCompositionStart:"compositionstart",topCompositionUpdate:"compositionupdate",topContextMenu:"contextmenu",topCopy:"copy",
	topCut:"cut",topDoubleClick:"dblclick",topDrag:"drag",topDragEnd:"dragend",topDragEnter:"dragenter",topDragExit:"dragexit",topDragLeave:"dragleave",topDragOver:"dragover",topDragStart:"dragstart",topDrop:"drop",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topFocus:"focus",topInput:"input",topKeyDown:"keydown",topKeyPress:"keypress",topKeyUp:"keyup",topLoadedData:"loadeddata",topLoad:"load",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",
	topMouseDown:"mousedown",topMouseMove:"mousemove",topMouseOut:"mouseout",topMouseOver:"mouseover",topMouseUp:"mouseup",topPaste:"paste",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topScroll:"scroll",topSeeked:"seeked",topSeeking:"seeking",topSelectionChange:"selectionchange",topStalled:"stalled",topSuspend:"suspend",topTextInput:"textInput",topTimeUpdate:"timeupdate",topToggle:"toggle",topTouchCancel:"touchcancel",topTouchEnd:"touchend",topTouchMove:"touchmove",
	topTouchStart:"touchstart",topTransitionEnd:Cd("transitionend")||"transitionend",topVolumeChange:"volumechange",topWaiting:"waiting",topWheel:"wheel"},Ed={},Fd=0,Gd="_reactListenersID"+(""+Math.random()).slice(2);function Hd(a){Object.prototype.hasOwnProperty.call(a,Gd)||(a[Gd]=Fd++,Ed[a[Gd]]={});return Ed[a[Gd]]}function Id(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
	function Jd(a,b){var c=Id(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Id(c)}}function Kd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&"text"===a.type||"textarea"===b||"true"===a.contentEditable)}
	var Ld=l.canUseDOM&&"documentMode"in document&&11>=document.documentMode,Md={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"topBlur topContextMenu topFocus topKeyDown topKeyUp topMouseDown topMouseUp topSelectionChange".split(" ")}},Nd=null,Od=null,Pd=null,Qd=!1;
	function Rd(a,b){if(Qd||null==Nd||Nd!==da())return null;var c=Nd;"selectionStart"in c&&Kd(c)?c={start:c.selectionStart,end:c.selectionEnd}:window.getSelection?(c=window.getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset}):c=void 0;return Pd&&ea(Pd,c)?null:(Pd=c,a=T.getPooled(Md.select,Od,a,b),a.type="select",a.target=Nd,Ab(a),a)}
	var Sd={eventTypes:Md,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Hd(e);f=Sa.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?qb(b):window;switch(a){case "topFocus":if(vc(e)||"true"===e.contentEditable)Nd=e,Od=b,Pd=null;break;case "topBlur":Pd=Od=Nd=null;break;case "topMouseDown":Qd=!0;break;case "topContextMenu":case "topMouseUp":return Qd=!1,Rd(c,d);case "topSelectionChange":if(Ld)break;
	case "topKeyDown":case "topKeyUp":return Rd(c,d)}return null}};function Td(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Td,{animationName:null,elapsedTime:null,pseudoElement:null});function Ud(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Ud,{clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}});function Vd(a,b,c,d){return T.call(this,a,b,c,d)}bd.augmentClass(Vd,{relatedTarget:null});
	function Wd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;return 32<=a||13===a?a:0}
	var Xd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},Yd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
	116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"};function Zd(a,b,c,d){return T.call(this,a,b,c,d)}
	bd.augmentClass(Zd,{key:function(a){if(a.key){var b=Xd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=Wd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?Yd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:ed,charCode:function(a){return"keypress"===a.type?Wd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===
	a.type?Wd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}});function $d(a,b,c,d){return T.call(this,a,b,c,d)}fd.augmentClass($d,{dataTransfer:null});function ae(a,b,c,d){return T.call(this,a,b,c,d)}bd.augmentClass(ae,{touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:ed});function be(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(be,{propertyName:null,elapsedTime:null,pseudoElement:null});
	function ce(a,b,c,d){return T.call(this,a,b,c,d)}fd.augmentClass(ce,{deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null});var de={},ee={};
	"abort animationEnd animationIteration animationStart blur cancel canPlay canPlayThrough click close contextMenu copy cut doubleClick drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error focus input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing progress rateChange reset scroll seeked seeking stalled submit suspend timeUpdate toggle touchCancel touchEnd touchMove touchStart transitionEnd volumeChange waiting wheel".split(" ").forEach(function(a){var b=a[0].toUpperCase()+
	a.slice(1),c="on"+b;b="top"+b;c={phasedRegistrationNames:{bubbled:c,captured:c+"Capture"},dependencies:[b]};de[a]=c;ee[b]=c});
	var fe={eventTypes:de,extractEvents:function(a,b,c,d){var e=ee[a];if(!e)return null;switch(a){case "topKeyPress":if(0===Wd(c))return null;case "topKeyDown":case "topKeyUp":a=Zd;break;case "topBlur":case "topFocus":a=Vd;break;case "topClick":if(2===c.button)return null;case "topDoubleClick":case "topMouseDown":case "topMouseMove":case "topMouseUp":case "topMouseOut":case "topMouseOver":case "topContextMenu":a=fd;break;case "topDrag":case "topDragEnd":case "topDragEnter":case "topDragExit":case "topDragLeave":case "topDragOver":case "topDragStart":case "topDrop":a=
	$d;break;case "topTouchCancel":case "topTouchEnd":case "topTouchMove":case "topTouchStart":a=ae;break;case "topAnimationEnd":case "topAnimationIteration":case "topAnimationStart":a=Td;break;case "topTransitionEnd":a=be;break;case "topScroll":a=bd;break;case "topWheel":a=ce;break;case "topCopy":case "topCut":case "topPaste":a=Ud;break;default:a=T}b=a.getPooled(e,b,c,d);Ab(b);return b}};sd=function(a,b,c,d){a=jb(a,b,c,d);kb(a);lb(!1)};hb.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
	Wa=sb.getFiberCurrentPropsFromNode;Xa=sb.getInstanceFromNode;Ya=sb.getNodeFromInstance;hb.injectEventPluginsByName({SimpleEventPlugin:fe,EnterLeaveEventPlugin:hd,ChangeEventPlugin:ad,SelectEventPlugin:Sd,BeforeInputEventPlugin:ic});var ge=[],he=-1;function V(a){0>he||(a.current=ge[he],ge[he]=null,he--)}function W(a,b){he++;ge[he]=a.current;a.current=b}new Set;var ie={current:D},X={current:!1},je=D;function ke(a){return le(a)?je:ie.current}
	function me(a,b){var c=a.type.contextTypes;if(!c)return D;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function le(a){return 2===a.tag&&null!=a.type.childContextTypes}function ne(a){le(a)&&(V(X,a),V(ie,a))}
	function oe(a,b,c){null!=ie.cursor?E("168"):void 0;W(ie,b,a);W(X,c,a)}function pe(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!==typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d?void 0:E("108",jd(a)||"Unknown",e);return B({},b,c)}function qe(a){if(!le(a))return!1;var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||D;je=ie.current;W(ie,b,a);W(X,X.current,a);return!0}
	function re(a,b){var c=a.stateNode;c?void 0:E("169");if(b){var d=pe(a,je);c.__reactInternalMemoizedMergedChildContext=d;V(X,a);V(ie,a);W(ie,d,a)}else V(X,a);W(X,b,a)}
	function Y(a,b,c){this.tag=a;this.key=b;this.stateNode=this.type=null;this.sibling=this.child=this["return"]=null;this.index=0;this.memoizedState=this.updateQueue=this.memoizedProps=this.pendingProps=this.ref=null;this.internalContextTag=c;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.expirationTime=0;this.alternate=null}
	function se(a,b,c){var d=a.alternate;null===d?(d=new Y(a.tag,a.key,a.internalContextTag),d.type=a.type,d.stateNode=a.stateNode,d.alternate=a,a.alternate=d):(d.effectTag=0,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null);d.expirationTime=c;d.pendingProps=b;d.child=a.child;d.memoizedProps=a.memoizedProps;d.memoizedState=a.memoizedState;d.updateQueue=a.updateQueue;d.sibling=a.sibling;d.index=a.index;d.ref=a.ref;return d}
	function te(a,b,c){var d=void 0,e=a.type,f=a.key;"function"===typeof e?(d=e.prototype&&e.prototype.isReactComponent?new Y(2,f,b):new Y(0,f,b),d.type=e,d.pendingProps=a.props):"string"===typeof e?(d=new Y(5,f,b),d.type=e,d.pendingProps=a.props):"object"===typeof e&&null!==e&&"number"===typeof e.tag?(d=e,d.pendingProps=a.props):E("130",null==e?e:typeof e,"");d.expirationTime=c;return d}function ue(a,b,c,d){b=new Y(10,d,b);b.pendingProps=a;b.expirationTime=c;return b}
	function ve(a,b,c){b=new Y(6,null,b);b.pendingProps=a;b.expirationTime=c;return b}function we(a,b,c){b=new Y(7,a.key,b);b.type=a.handler;b.pendingProps=a;b.expirationTime=c;return b}function xe(a,b,c){a=new Y(9,null,b);a.expirationTime=c;return a}function ye(a,b,c){b=new Y(4,a.key,b);b.pendingProps=a.children||[];b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}var ze=null,Ae=null;
	function Be(a){return function(b){try{return a(b)}catch(c){}}}function Ce(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);ze=Be(function(a){return b.onCommitFiberRoot(c,a)});Ae=Be(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}function De(a){"function"===typeof ze&&ze(a)}function Ee(a){"function"===typeof Ae&&Ae(a)}
	function Fe(a){return{baseState:a,expirationTime:0,first:null,last:null,callbackList:null,hasForceUpdate:!1,isInitialized:!1}}function Ge(a,b){null===a.last?a.first=a.last=b:(a.last.next=b,a.last=b);if(0===a.expirationTime||a.expirationTime>b.expirationTime)a.expirationTime=b.expirationTime}
	function He(a,b){var c=a.alternate,d=a.updateQueue;null===d&&(d=a.updateQueue=Fe(null));null!==c?(a=c.updateQueue,null===a&&(a=c.updateQueue=Fe(null))):a=null;a=a!==d?a:null;null===a?Ge(d,b):null===d.last||null===a.last?(Ge(d,b),Ge(a,b)):(Ge(d,b),a.last=b)}function Ie(a,b,c,d){a=a.partialState;return"function"===typeof a?a.call(b,c,d):a}
	function Je(a,b,c,d,e,f){null!==a&&a.updateQueue===c&&(c=b.updateQueue={baseState:c.baseState,expirationTime:c.expirationTime,first:c.first,last:c.last,isInitialized:c.isInitialized,callbackList:null,hasForceUpdate:!1});c.expirationTime=0;c.isInitialized?a=c.baseState:(a=c.baseState=b.memoizedState,c.isInitialized=!0);for(var g=!0,h=c.first,k=!1;null!==h;){var q=h.expirationTime;if(q>f){var v=c.expirationTime;if(0===v||v>q)c.expirationTime=q;k||(k=!0,c.baseState=a)}else{k||(c.first=h.next,null===
	c.first&&(c.last=null));if(h.isReplace)a=Ie(h,d,a,e),g=!0;else if(q=Ie(h,d,a,e))a=g?B({},a,q):B(a,q),g=!1;h.isForced&&(c.hasForceUpdate=!0);null!==h.callback&&(q=c.callbackList,null===q&&(q=c.callbackList=[]),q.push(h))}h=h.next}null!==c.callbackList?b.effectTag|=32:null!==c.first||c.hasForceUpdate||(b.updateQueue=null);k||(c.baseState=a);return a}
	function Ke(a,b){var c=a.callbackList;if(null!==c)for(a.callbackList=null,a=0;a<c.length;a++){var d=c[a],e=d.callback;d.callback=null;"function"!==typeof e?E("191",e):void 0;e.call(b)}}
	function Le(a,b,c,d){function e(a,b){b.updater=f;a.stateNode=b;b._reactInternalFiber=a}var f={isMounted:ld,enqueueSetState:function(c,d,e){c=c._reactInternalFiber;e=void 0===e?null:e;var g=b(c);He(c,{expirationTime:g,partialState:d,callback:e,isReplace:!1,isForced:!1,nextCallback:null,next:null});a(c,g)},enqueueReplaceState:function(c,d,e){c=c._reactInternalFiber;e=void 0===e?null:e;var g=b(c);He(c,{expirationTime:g,partialState:d,callback:e,isReplace:!0,isForced:!1,nextCallback:null,next:null});
	a(c,g)},enqueueForceUpdate:function(c,d){c=c._reactInternalFiber;d=void 0===d?null:d;var e=b(c);He(c,{expirationTime:e,partialState:null,callback:d,isReplace:!1,isForced:!0,nextCallback:null,next:null});a(c,e)}};return{adoptClassInstance:e,constructClassInstance:function(a,b){var c=a.type,d=ke(a),f=2===a.tag&&null!=a.type.contextTypes,g=f?me(a,d):D;b=new c(b,g);e(a,b);f&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=d,a.__reactInternalMemoizedMaskedChildContext=g);return b},mountClassInstance:function(a,
	b){var c=a.alternate,d=a.stateNode,e=d.state||null,g=a.pendingProps;g?void 0:E("158");var h=ke(a);d.props=g;d.state=a.memoizedState=e;d.refs=D;d.context=me(a,h);null!=a.type&&null!=a.type.prototype&&!0===a.type.prototype.unstable_isAsyncReactComponent&&(a.internalContextTag|=1);"function"===typeof d.componentWillMount&&(e=d.state,d.componentWillMount(),e!==d.state&&f.enqueueReplaceState(d,d.state,null),e=a.updateQueue,null!==e&&(d.state=Je(c,a,e,d,g,b)));"function"===typeof d.componentDidMount&&(a.effectTag|=
	4)},updateClassInstance:function(a,b,e){var g=b.stateNode;g.props=b.memoizedProps;g.state=b.memoizedState;var h=b.memoizedProps,k=b.pendingProps;k||(k=h,null==k?E("159"):void 0);var u=g.context,z=ke(b);z=me(b,z);"function"!==typeof g.componentWillReceiveProps||h===k&&u===z||(u=g.state,g.componentWillReceiveProps(k,z),g.state!==u&&f.enqueueReplaceState(g,g.state,null));u=b.memoizedState;e=null!==b.updateQueue?Je(a,b,b.updateQueue,g,k,e):u;if(!(h!==k||u!==e||X.current||null!==b.updateQueue&&b.updateQueue.hasForceUpdate))return"function"!==
	typeof g.componentDidUpdate||h===a.memoizedProps&&u===a.memoizedState||(b.effectTag|=4),!1;var G=k;if(null===h||null!==b.updateQueue&&b.updateQueue.hasForceUpdate)G=!0;else{var I=b.stateNode,L=b.type;G="function"===typeof I.shouldComponentUpdate?I.shouldComponentUpdate(G,e,z):L.prototype&&L.prototype.isPureReactComponent?!ea(h,G)||!ea(u,e):!0}G?("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(k,e,z),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4)):("function"!==typeof g.componentDidUpdate||
	h===a.memoizedProps&&u===a.memoizedState||(b.effectTag|=4),c(b,k),d(b,e));g.props=k;g.state=e;g.context=z;return G}}}var Qe="function"===typeof Symbol&&Symbol["for"],Re=Qe?Symbol["for"]("react.element"):60103,Se=Qe?Symbol["for"]("react.call"):60104,Te=Qe?Symbol["for"]("react.return"):60105,Ue=Qe?Symbol["for"]("react.portal"):60106,Ve=Qe?Symbol["for"]("react.fragment"):60107,We="function"===typeof Symbol&&Symbol.iterator;
	function Xe(a){if(null===a||"undefined"===typeof a)return null;a=We&&a[We]||a["@@iterator"];return"function"===typeof a?a:null}var Ye=Array.isArray;
	function Ze(a,b){var c=b.ref;if(null!==c&&"function"!==typeof c){if(b._owner){b=b._owner;var d=void 0;b&&(2!==b.tag?E("110"):void 0,d=b.stateNode);d?void 0:E("147",c);var e=""+c;if(null!==a&&null!==a.ref&&a.ref._stringRef===e)return a.ref;a=function(a){var b=d.refs===D?d.refs={}:d.refs;null===a?delete b[e]:b[e]=a};a._stringRef=e;return a}"string"!==typeof c?E("148"):void 0;b._owner?void 0:E("149",c)}return c}
	function $e(a,b){"textarea"!==a.type&&E("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
	function af(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=se(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
	2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=ve(c,a.internalContextTag,d),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function k(a,b,c,d){if(null!==b&&b.type===c.type)return d=e(b,c.props,d),d.ref=Ze(b,c),d["return"]=a,d;d=te(c,a.internalContextTag,d);d.ref=Ze(b,c);d["return"]=a;return d}function q(a,b,c,d){if(null===b||7!==b.tag)return b=we(c,a.internalContextTag,d),b["return"]=a,b;b=e(b,c,d);
	b["return"]=a;return b}function v(a,b,c,d){if(null===b||9!==b.tag)return b=xe(c,a.internalContextTag,d),b.type=c.value,b["return"]=a,b;b=e(b,null,d);b.type=c.value;b["return"]=a;return b}function y(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=ye(c,a.internalContextTag,d),b["return"]=a,b;b=e(b,c.children||[],d);b["return"]=a;return b}function u(a,b,c,d,f){if(null===b||10!==b.tag)return b=ue(c,a.internalContextTag,
	d,f),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function z(a,b,c){if("string"===typeof b||"number"===typeof b)return b=ve(""+b,a.internalContextTag,c),b["return"]=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Re:if(b.type===Ve)return b=ue(b.props.children,a.internalContextTag,c,b.key),b["return"]=a,b;c=te(b,a.internalContextTag,c);c.ref=Ze(null,b);c["return"]=a;return c;case Se:return b=we(b,a.internalContextTag,c),b["return"]=a,b;case Te:return c=xe(b,a.internalContextTag,
	c),c.type=b.value,c["return"]=a,c;case Ue:return b=ye(b,a.internalContextTag,c),b["return"]=a,b}if(Ye(b)||Xe(b))return b=ue(b,a.internalContextTag,c,null),b["return"]=a,b;$e(a,b)}return null}function G(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Re:return c.key===e?c.type===Ve?u(a,b,c.props.children,d,e):k(a,b,c,d):null;case Se:return c.key===e?q(a,b,c,d):null;case Te:return null===
	e?v(a,b,c,d):null;case Ue:return c.key===e?y(a,b,c,d):null}if(Ye(c)||Xe(c))return null!==e?null:u(a,b,c,d,null);$e(a,c)}return null}function I(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Re:return a=a.get(null===d.key?c:d.key)||null,d.type===Ve?u(b,a,d.props.children,e,d.key):k(b,a,d,e);case Se:return a=a.get(null===d.key?c:d.key)||null,q(b,a,d,e);case Te:return a=a.get(c)||null,v(b,a,d,e);case Ue:return a=
	a.get(null===d.key?c:d.key)||null,y(b,a,d,e)}if(Ye(d)||Xe(d))return a=a.get(c)||null,u(b,a,d,e,null);$e(b,d)}return null}function L(e,g,m,A){for(var h=null,r=null,n=g,w=g=0,k=null;null!==n&&w<m.length;w++){n.index>w?(k=n,n=null):k=n.sibling;var x=G(e,n,m[w],A);if(null===x){null===n&&(n=k);break}a&&n&&null===x.alternate&&b(e,n);g=f(x,g,w);null===r?h=x:r.sibling=x;r=x;n=k}if(w===m.length)return c(e,n),h;if(null===n){for(;w<m.length;w++)if(n=z(e,m[w],A))g=f(n,g,w),null===r?h=n:r.sibling=n,r=n;return h}for(n=
	d(e,n);w<m.length;w++)if(k=I(n,e,w,m[w],A)){if(a&&null!==k.alternate)n["delete"](null===k.key?w:k.key);g=f(k,g,w);null===r?h=k:r.sibling=k;r=k}a&&n.forEach(function(a){return b(e,a)});return h}function N(e,g,m,A){var h=Xe(m);"function"!==typeof h?E("150"):void 0;m=h.call(m);null==m?E("151"):void 0;for(var r=h=null,n=g,w=g=0,k=null,x=m.next();null!==n&&!x.done;w++,x=m.next()){n.index>w?(k=n,n=null):k=n.sibling;var J=G(e,n,x.value,A);if(null===J){n||(n=k);break}a&&n&&null===J.alternate&&b(e,n);g=f(J,
	g,w);null===r?h=J:r.sibling=J;r=J;n=k}if(x.done)return c(e,n),h;if(null===n){for(;!x.done;w++,x=m.next())x=z(e,x.value,A),null!==x&&(g=f(x,g,w),null===r?h=x:r.sibling=x,r=x);return h}for(n=d(e,n);!x.done;w++,x=m.next())if(x=I(n,e,w,x.value,A),null!==x){if(a&&null!==x.alternate)n["delete"](null===x.key?w:x.key);g=f(x,g,w);null===r?h=x:r.sibling=x;r=x}a&&n.forEach(function(a){return b(e,a)});return h}return function(a,d,f,h){"object"===typeof f&&null!==f&&f.type===Ve&&null===f.key&&(f=f.props.children);
	var m="object"===typeof f&&null!==f;if(m)switch(f.$$typeof){case Re:a:{var r=f.key;for(m=d;null!==m;){if(m.key===r)if(10===m.tag?f.type===Ve:m.type===f.type){c(a,m.sibling);d=e(m,f.type===Ve?f.props.children:f.props,h);d.ref=Ze(m,f);d["return"]=a;a=d;break a}else{c(a,m);break}else b(a,m);m=m.sibling}f.type===Ve?(d=ue(f.props.children,a.internalContextTag,h,f.key),d["return"]=a,a=d):(h=te(f,a.internalContextTag,h),h.ref=Ze(d,f),h["return"]=a,a=h)}return g(a);case Se:a:{for(m=f.key;null!==d;){if(d.key===
	m)if(7===d.tag){c(a,d.sibling);d=e(d,f,h);d["return"]=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=we(f,a.internalContextTag,h);d["return"]=a;a=d}return g(a);case Te:a:{if(null!==d)if(9===d.tag){c(a,d.sibling);d=e(d,null,h);d.type=f.value;d["return"]=a;a=d;break a}else c(a,d);d=xe(f,a.internalContextTag,h);d.type=f.value;d["return"]=a;a=d}return g(a);case Ue:a:{for(m=f.key;null!==d;){if(d.key===m)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===
	f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d["return"]=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=ye(f,a.internalContextTag,h);d["return"]=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h)):(c(a,d),d=ve(f,a.internalContextTag,h)),d["return"]=a,a=d,g(a);if(Ye(f))return L(a,d,f,h);if(Xe(f))return N(a,d,f,h);m&&$e(a,f);if("undefined"===typeof f)switch(a.tag){case 2:case 1:h=a.type,E("152",h.displayName||
	h.name||"Component")}return c(a,d)}}var bf=af(!0),cf=af(!1);
	function df(a,b,c,d,e){function f(a,b,c){var d=b.expirationTime;b.child=null===a?cf(b,null,c,d):bf(b,a.child,c,d)}function g(a,b){var c=b.ref;null===c||a&&a.ref===c||(b.effectTag|=128)}function h(a,b,c,d){g(a,b);if(!c)return d&&re(b,!1),q(a,b);c=b.stateNode;id.current=b;var e=c.render();b.effectTag|=1;f(a,b,e);b.memoizedState=c.state;b.memoizedProps=c.props;d&&re(b,!0);return b.child}function k(a){var b=a.stateNode;b.pendingContext?oe(a,b.pendingContext,b.pendingContext!==b.context):b.context&&oe(a,
	b.context,!1);I(a,b.containerInfo)}function q(a,b){null!==a&&b.child!==a.child?E("153"):void 0;if(null!==b.child){a=b.child;var c=se(a,a.pendingProps,a.expirationTime);b.child=c;for(c["return"]=b;null!==a.sibling;)a=a.sibling,c=c.sibling=se(a,a.pendingProps,a.expirationTime),c["return"]=b;c.sibling=null}return b.child}function v(a,b){switch(b.tag){case 3:k(b);break;case 2:qe(b);break;case 4:I(b,b.stateNode.containerInfo)}return null}var y=a.shouldSetTextContent,u=a.useSyncScheduling,z=a.shouldDeprioritizeSubtree,
	G=b.pushHostContext,I=b.pushHostContainer,L=c.enterHydrationState,N=c.resetHydrationState,J=c.tryToClaimNextHydratableInstance;a=Le(d,e,function(a,b){a.memoizedProps=b},function(a,b){a.memoizedState=b});var w=a.adoptClassInstance,m=a.constructClassInstance,A=a.mountClassInstance,Ob=a.updateClassInstance;return{beginWork:function(a,b,c){if(0===b.expirationTime||b.expirationTime>c)return v(a,b);switch(b.tag){case 0:null!==a?E("155"):void 0;var d=b.type,e=b.pendingProps,r=ke(b);r=me(b,r);d=d(e,r);b.effectTag|=
	1;"object"===typeof d&&null!==d&&"function"===typeof d.render?(b.tag=2,e=qe(b),w(b,d),A(b,c),b=h(a,b,!0,e)):(b.tag=1,f(a,b,d),b.memoizedProps=e,b=b.child);return b;case 1:a:{e=b.type;c=b.pendingProps;d=b.memoizedProps;if(X.current)null===c&&(c=d);else if(null===c||d===c){b=q(a,b);break a}d=ke(b);d=me(b,d);e=e(c,d);b.effectTag|=1;f(a,b,e);b.memoizedProps=c;b=b.child}return b;case 2:return e=qe(b),d=void 0,null===a?b.stateNode?E("153"):(m(b,b.pendingProps),A(b,c),d=!0):d=Ob(a,b,c),h(a,b,d,e);case 3:return k(b),
	e=b.updateQueue,null!==e?(d=b.memoizedState,e=Je(a,b,e,null,null,c),d===e?(N(),b=q(a,b)):(d=e.element,r=b.stateNode,(null===a||null===a.child)&&r.hydrate&&L(b)?(b.effectTag|=2,b.child=cf(b,null,d,c)):(N(),f(a,b,d)),b.memoizedState=e,b=b.child)):(N(),b=q(a,b)),b;case 5:G(b);null===a&&J(b);e=b.type;var n=b.memoizedProps;d=b.pendingProps;null===d&&(d=n,null===d?E("154"):void 0);r=null!==a?a.memoizedProps:null;X.current||null!==d&&n!==d?(n=d.children,y(e,d)?n=null:r&&y(e,r)&&(b.effectTag|=16),g(a,b),
	2147483647!==c&&!u&&z(e,d)?(b.expirationTime=2147483647,b=null):(f(a,b,n),b.memoizedProps=d,b=b.child)):b=q(a,b);return b;case 6:return null===a&&J(b),a=b.pendingProps,null===a&&(a=b.memoizedProps),b.memoizedProps=a,null;case 8:b.tag=7;case 7:e=b.pendingProps;if(X.current)null===e&&(e=a&&a.memoizedProps,null===e?E("154"):void 0);else if(null===e||b.memoizedProps===e)e=b.memoizedProps;d=e.children;b.stateNode=null===a?cf(b,b.stateNode,d,c):bf(b,b.stateNode,d,c);b.memoizedProps=e;return b.stateNode;
	case 9:return null;case 4:a:{I(b,b.stateNode.containerInfo);e=b.pendingProps;if(X.current)null===e&&(e=a&&a.memoizedProps,null==e?E("154"):void 0);else if(null===e||b.memoizedProps===e){b=q(a,b);break a}null===a?b.child=bf(b,null,e,c):f(a,b,e);b.memoizedProps=e;b=b.child}return b;case 10:a:{c=b.pendingProps;if(X.current)null===c&&(c=b.memoizedProps);else if(null===c||b.memoizedProps===c){b=q(a,b);break a}f(a,b,c);b.memoizedProps=c;b=b.child}return b;default:E("156")}},beginFailedWork:function(a,b,
	c){switch(b.tag){case 2:qe(b);break;case 3:k(b);break;default:E("157")}b.effectTag|=64;null===a?b.child=null:b.child!==a.child&&(b.child=a.child);if(0===b.expirationTime||b.expirationTime>c)return v(a,b);b.firstEffect=null;b.lastEffect=null;b.child=null===a?cf(b,null,null,c):bf(b,a.child,null,c);2===b.tag&&(a=b.stateNode,b.memoizedProps=a.props,b.memoizedState=a.state);return b.child}}}
	function ef(a,b,c){function d(a){a.effectTag|=4}var e=a.createInstance,f=a.createTextInstance,g=a.appendInitialChild,h=a.finalizeInitialChildren,k=a.prepareUpdate,q=a.persistence,v=b.getRootHostContainer,y=b.popHostContext,u=b.getHostContext,z=b.popHostContainer,G=c.prepareToHydrateHostInstance,I=c.prepareToHydrateHostTextInstance,L=c.popHydrationState,N=void 0,J=void 0,w=void 0;a.mutation?(N=function(){},J=function(a,b,c){(b.updateQueue=c)&&d(b)},w=function(a,b,c,e){c!==e&&d(b)}):q?E("235"):E("236");
	return{completeWork:function(a,b,c){var m=b.pendingProps;if(null===m)m=b.memoizedProps;else if(2147483647!==b.expirationTime||2147483647===c)b.pendingProps=null;switch(b.tag){case 1:return null;case 2:return ne(b),null;case 3:z(b);V(X,b);V(ie,b);m=b.stateNode;m.pendingContext&&(m.context=m.pendingContext,m.pendingContext=null);if(null===a||null===a.child)L(b),b.effectTag&=-3;N(b);return null;case 5:y(b);c=v();var A=b.type;if(null!==a&&null!=b.stateNode){var p=a.memoizedProps,q=b.stateNode,x=u();q=
	k(q,A,p,m,c,x);J(a,b,q,A,p,m,c);a.ref!==b.ref&&(b.effectTag|=128)}else{if(!m)return null===b.stateNode?E("166"):void 0,null;a=u();if(L(b))G(b,c,a)&&d(b);else{a=e(A,m,c,a,b);a:for(p=b.child;null!==p;){if(5===p.tag||6===p.tag)g(a,p.stateNode);else if(4!==p.tag&&null!==p.child){p.child["return"]=p;p=p.child;continue}if(p===b)break;for(;null===p.sibling;){if(null===p["return"]||p["return"]===b)break a;p=p["return"]}p.sibling["return"]=p["return"];p=p.sibling}h(a,A,m,c)&&d(b);b.stateNode=a}null!==b.ref&&
	(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)w(a,b,a.memoizedProps,m);else{if("string"!==typeof m)return null===b.stateNode?E("166"):void 0,null;a=v();c=u();L(b)?I(b)&&d(b):b.stateNode=f(m,a,c,b)}return null;case 7:(m=b.memoizedProps)?void 0:E("165");b.tag=8;A=[];a:for((p=b.stateNode)&&(p["return"]=b);null!==p;){if(5===p.tag||6===p.tag||4===p.tag)E("247");else if(9===p.tag)A.push(p.type);else if(null!==p.child){p.child["return"]=p;p=p.child;continue}for(;null===p.sibling;){if(null===
	p["return"]||p["return"]===b)break a;p=p["return"]}p.sibling["return"]=p["return"];p=p.sibling}p=m.handler;m=p(m.props,A);b.child=bf(b,null!==a?a.child:null,m,c);return b.child;case 8:return b.tag=7,null;case 9:return null;case 10:return null;case 4:return z(b),N(b),null;case 0:E("167");default:E("156")}}}}
	function ff(a,b){function c(a){var c=a.ref;if(null!==c)try{c(null)}catch(A){b(a,A)}}function d(a){"function"===typeof Ee&&Ee(a);switch(a.tag){case 2:c(a);var d=a.stateNode;if("function"===typeof d.componentWillUnmount)try{d.props=a.memoizedProps,d.state=a.memoizedState,d.componentWillUnmount()}catch(A){b(a,A)}break;case 5:c(a);break;case 7:e(a.stateNode);break;case 4:k&&g(a)}}function e(a){for(var b=a;;)if(d(b),null===b.child||k&&4===b.tag){if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||
	b["return"]===a)return;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}else b.child["return"]=b,b=b.child}function f(a){return 5===a.tag||3===a.tag||4===a.tag}function g(a){for(var b=a,c=!1,f=void 0,g=void 0;;){if(!c){c=b["return"];a:for(;;){null===c?E("160"):void 0;switch(c.tag){case 5:f=c.stateNode;g=!1;break a;case 3:f=c.stateNode.containerInfo;g=!0;break a;case 4:f=c.stateNode.containerInfo;g=!0;break a}c=c["return"]}c=!0}if(5===b.tag||6===b.tag)e(b),g?J(f,b.stateNode):N(f,b.stateNode);
	else if(4===b.tag?f=b.stateNode.containerInfo:d(b),null!==b.child){b.child["return"]=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||b["return"]===a)return;b=b["return"];4===b.tag&&(c=!1)}b.sibling["return"]=b["return"];b=b.sibling}}var h=a.getPublicInstance,k=a.mutation;a=a.persistence;k||(a?E("235"):E("236"));var q=k.commitMount,v=k.commitUpdate,y=k.resetTextContent,u=k.commitTextUpdate,z=k.appendChild,G=k.appendChildToContainer,I=k.insertBefore,L=k.insertInContainerBefore,
	N=k.removeChild,J=k.removeChildFromContainer;return{commitResetTextContent:function(a){y(a.stateNode)},commitPlacement:function(a){a:{for(var b=a["return"];null!==b;){if(f(b)){var c=b;break a}b=b["return"]}E("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:E("161")}c.effectTag&16&&(y(b),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c["return"]||f(c["return"])){c=
	null;break a}c=c["return"]}c.sibling["return"]=c["return"];for(c=c.sibling;5!==c.tag&&6!==c.tag;){if(c.effectTag&2)continue b;if(null===c.child||4===c.tag)continue b;else c.child["return"]=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)c?d?L(b,e.stateNode,c):I(b,e.stateNode,c):d?G(b,e.stateNode):z(b,e.stateNode);else if(4!==e.tag&&null!==e.child){e.child["return"]=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e["return"]||e["return"]===
	a)return;e=e["return"]}e.sibling["return"]=e["return"];e=e.sibling}},commitDeletion:function(a){g(a);a["return"]=null;a.child=null;a.alternate&&(a.alternate.child=null,a.alternate["return"]=null)},commitWork:function(a,b){switch(b.tag){case 2:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&v(c,f,e,a,d,b)}break;case 6:null===b.stateNode?E("162"):void 0;c=b.memoizedProps;u(b.stateNode,null!==a?a.memoizedProps:
	c,c);break;case 3:break;default:E("163")}},commitLifeCycles:function(a,b){switch(b.tag){case 2:var c=b.stateNode;if(b.effectTag&4)if(null===a)c.props=b.memoizedProps,c.state=b.memoizedState,c.componentDidMount();else{var d=a.memoizedProps;a=a.memoizedState;c.props=b.memoizedProps;c.state=b.memoizedState;c.componentDidUpdate(d,a)}b=b.updateQueue;null!==b&&Ke(b,c);break;case 3:c=b.updateQueue;null!==c&&Ke(c,null!==b.child?b.child.stateNode:null);break;case 5:c=b.stateNode;null===a&&b.effectTag&4&&q(c,
	b.type,b.memoizedProps,b);break;case 6:break;case 4:break;default:E("163")}},commitAttachRef:function(a){var b=a.ref;if(null!==b){var c=a.stateNode;switch(a.tag){case 5:b(h(c));break;default:b(c)}}},commitDetachRef:function(a){a=a.ref;null!==a&&a(null)}}}var gf={};
	function hf(a){function b(a){a===gf?E("174"):void 0;return a}var c=a.getChildHostContext,d=a.getRootHostContext,e={current:gf},f={current:gf},g={current:gf};return{getHostContext:function(){return b(e.current)},getRootHostContainer:function(){return b(g.current)},popHostContainer:function(a){V(e,a);V(f,a);V(g,a)},popHostContext:function(a){f.current===a&&(V(e,a),V(f,a))},pushHostContainer:function(a,b){W(g,b,a);b=d(b);W(f,a,a);W(e,b,a)},pushHostContext:function(a){var d=b(g.current),h=b(e.current);
	d=c(h,a.type,d);h!==d&&(W(f,a,a),W(e,d,a))},resetHostContainer:function(){e.current=gf;g.current=gf}}}
	function jf(a){function b(a,b){var c=new Y(5,null,0);c.type="DELETED";c.stateNode=b;c["return"]=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function c(a,b){switch(a.tag){case 5:return b=f(b,a.type,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;case 6:return b=g(b,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;default:return!1}}function d(a){for(a=a["return"];null!==a&&5!==a.tag&&3!==a.tag;)a=a["return"];y=a}var e=a.shouldSetTextContent;
	a=a.hydration;if(!a)return{enterHydrationState:function(){return!1},resetHydrationState:function(){},tryToClaimNextHydratableInstance:function(){},prepareToHydrateHostInstance:function(){E("175")},prepareToHydrateHostTextInstance:function(){E("176")},popHydrationState:function(){return!1}};var f=a.canHydrateInstance,g=a.canHydrateTextInstance,h=a.getNextHydratableSibling,k=a.getFirstHydratableChild,q=a.hydrateInstance,v=a.hydrateTextInstance,y=null,u=null,z=!1;return{enterHydrationState:function(a){u=
	k(a.stateNode.containerInfo);y=a;return z=!0},resetHydrationState:function(){u=y=null;z=!1},tryToClaimNextHydratableInstance:function(a){if(z){var d=u;if(d){if(!c(a,d)){d=h(d);if(!d||!c(a,d)){a.effectTag|=2;z=!1;y=a;return}b(y,u)}y=a;u=k(d)}else a.effectTag|=2,z=!1,y=a}},prepareToHydrateHostInstance:function(a,b,c){b=q(a.stateNode,a.type,a.memoizedProps,b,c,a);a.updateQueue=b;return null!==b?!0:!1},prepareToHydrateHostTextInstance:function(a){return v(a.stateNode,a.memoizedProps,a)},popHydrationState:function(a){if(a!==
	y)return!1;if(!z)return d(a),z=!0,!1;var c=a.type;if(5!==a.tag||"head"!==c&&"body"!==c&&!e(c,a.memoizedProps))for(c=u;c;)b(a,c),c=h(c);d(a);u=y?h(a.stateNode):null;return!0}}}
	function kf(a){function b(a){Qb=ja=!0;var b=a.stateNode;b.current===a?E("177"):void 0;b.isReadyForCommit=!1;id.current=null;if(1<a.effectTag)if(null!==a.lastEffect){a.lastEffect.nextEffect=a;var c=a.firstEffect}else c=a;else c=a.firstEffect;yg();for(t=c;null!==t;){var d=!1,e=void 0;try{for(;null!==t;){var f=t.effectTag;f&16&&zg(t);if(f&128){var g=t.alternate;null!==g&&Ag(g)}switch(f&-242){case 2:Ne(t);t.effectTag&=-3;break;case 6:Ne(t);t.effectTag&=-3;Oe(t.alternate,t);break;case 4:Oe(t.alternate,
	t);break;case 8:Sc=!0,Bg(t),Sc=!1}t=t.nextEffect}}catch(Tc){d=!0,e=Tc}d&&(null===t?E("178"):void 0,h(t,e),null!==t&&(t=t.nextEffect))}Cg();b.current=a;for(t=c;null!==t;){c=!1;d=void 0;try{for(;null!==t;){var k=t.effectTag;k&36&&Dg(t.alternate,t);k&128&&Eg(t);if(k&64)switch(e=t,f=void 0,null!==R&&(f=R.get(e),R["delete"](e),null==f&&null!==e.alternate&&(e=e.alternate,f=R.get(e),R["delete"](e))),null==f?E("184"):void 0,e.tag){case 2:e.stateNode.componentDidCatch(f.error,{componentStack:f.componentStack});
	break;case 3:null===ca&&(ca=f.error);break;default:E("157")}var Qc=t.nextEffect;t.nextEffect=null;t=Qc}}catch(Tc){c=!0,d=Tc}c&&(null===t?E("178"):void 0,h(t,d),null!==t&&(t=t.nextEffect))}ja=Qb=!1;"function"===typeof De&&De(a.stateNode);ha&&(ha.forEach(G),ha=null);null!==ca&&(a=ca,ca=null,Ob(a));b=b.current.expirationTime;0===b&&(qa=R=null);return b}function c(a){for(;;){var b=Fg(a.alternate,a,H),c=a["return"],d=a.sibling;var e=a;if(2147483647===H||2147483647!==e.expirationTime){if(2!==e.tag&&3!==
	e.tag)var f=0;else f=e.updateQueue,f=null===f?0:f.expirationTime;for(var g=e.child;null!==g;)0!==g.expirationTime&&(0===f||f>g.expirationTime)&&(f=g.expirationTime),g=g.sibling;e.expirationTime=f}if(null!==b)return b;null!==c&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a));if(null!==d)return d;
	if(null!==c)a=c;else{a.stateNode.isReadyForCommit=!0;break}}return null}function d(a){var b=rg(a.alternate,a,H);null===b&&(b=c(a));id.current=null;return b}function e(a){var b=Gg(a.alternate,a,H);null===b&&(b=c(a));id.current=null;return b}function f(a){if(null!==R){if(!(0===H||H>a))if(H<=Uc)for(;null!==F;)F=k(F)?e(F):d(F);else for(;null!==F&&!A();)F=k(F)?e(F):d(F)}else if(!(0===H||H>a))if(H<=Uc)for(;null!==F;)F=d(F);else for(;null!==F&&!A();)F=d(F)}function g(a,b){ja?E("243"):void 0;ja=!0;a.isReadyForCommit=
	!1;if(a!==ra||b!==H||null===F){for(;-1<he;)ge[he]=null,he--;je=D;ie.current=D;X.current=!1;x();ra=a;H=b;F=se(ra.current,null,b)}var c=!1,d=null;try{f(b)}catch(Rc){c=!0,d=Rc}for(;c;){if(eb){ca=d;break}var g=F;if(null===g)eb=!0;else{var k=h(g,d);null===k?E("183"):void 0;if(!eb){try{c=k;d=b;for(k=c;null!==g;){switch(g.tag){case 2:ne(g);break;case 5:qg(g);break;case 3:p(g);break;case 4:p(g)}if(g===k||g.alternate===k)break;g=g["return"]}F=e(c);f(d)}catch(Rc){c=!0;d=Rc;continue}break}}}b=ca;eb=ja=!1;ca=
	null;null!==b&&Ob(b);return a.isReadyForCommit?a.current.alternate:null}function h(a,b){var c=id.current=null,d=!1,e=!1,f=null;if(3===a.tag)c=a,q(a)&&(eb=!0);else for(var g=a["return"];null!==g&&null===c;){2===g.tag?"function"===typeof g.stateNode.componentDidCatch&&(d=!0,f=jd(g),c=g,e=!0):3===g.tag&&(c=g);if(q(g)){if(Sc||null!==ha&&(ha.has(g)||null!==g.alternate&&ha.has(g.alternate)))return null;c=null;e=!1}g=g["return"]}if(null!==c){null===qa&&(qa=new Set);qa.add(c);var h="";g=a;do{a:switch(g.tag){case 0:case 1:case 2:case 5:var k=
	g._debugOwner,Qc=g._debugSource;var m=jd(g);var n=null;k&&(n=jd(k));k=Qc;m="\n    in "+(m||"Unknown")+(k?" (at "+k.fileName.replace(/^.*[\\\/]/,"")+":"+k.lineNumber+")":n?" (created by "+n+")":"");break a;default:m=""}h+=m;g=g["return"]}while(g);g=h;a=jd(a);null===R&&(R=new Map);b={componentName:a,componentStack:g,error:b,errorBoundary:d?c.stateNode:null,errorBoundaryFound:d,errorBoundaryName:f,willRetry:e};R.set(c,b);try{var p=b.error;p&&p.suppressReactErrorLogging||console.error(p)}catch(Vc){Vc&&
	Vc.suppressReactErrorLogging||console.error(Vc)}Qb?(null===ha&&(ha=new Set),ha.add(c)):G(c);return c}null===ca&&(ca=b);return null}function k(a){return null!==R&&(R.has(a)||null!==a.alternate&&R.has(a.alternate))}function q(a){return null!==qa&&(qa.has(a)||null!==a.alternate&&qa.has(a.alternate))}function v(){return 20*(((I()+100)/20|0)+1)}function y(a){return 0!==ka?ka:ja?Qb?1:H:!Hg||a.internalContextTag&1?v():1}function u(a,b){return z(a,b,!1)}function z(a,b){for(;null!==a;){if(0===a.expirationTime||
	a.expirationTime>b)a.expirationTime=b;null!==a.alternate&&(0===a.alternate.expirationTime||a.alternate.expirationTime>b)&&(a.alternate.expirationTime=b);if(null===a["return"])if(3===a.tag){var c=a.stateNode;!ja&&c===ra&&b<H&&(F=ra=null,H=0);var d=c,e=b;Rb>Ig&&E("185");if(null===d.nextScheduledRoot)d.remainingExpirationTime=e,null===O?(sa=O=d,d.nextScheduledRoot=d):(O=O.nextScheduledRoot=d,O.nextScheduledRoot=sa);else{var f=d.remainingExpirationTime;if(0===f||e<f)d.remainingExpirationTime=e}Fa||(la?
	Sb&&(ma=d,na=1,m(ma,na)):1===e?w(1,null):L(e));!ja&&c===ra&&b<H&&(F=ra=null,H=0)}else break;a=a["return"]}}function G(a){z(a,1,!0)}function I(){return Uc=((Wc()-Pe)/10|0)+2}function L(a){if(0!==Tb){if(a>Tb)return;Jg(Xc)}var b=Wc()-Pe;Tb=a;Xc=Kg(J,{timeout:10*(a-2)-b})}function N(){var a=0,b=null;if(null!==O)for(var c=O,d=sa;null!==d;){var e=d.remainingExpirationTime;if(0===e){null===c||null===O?E("244"):void 0;if(d===d.nextScheduledRoot){sa=O=d.nextScheduledRoot=null;break}else if(d===sa)sa=e=d.nextScheduledRoot,
	O.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===O){O=c;O.nextScheduledRoot=sa;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{if(0===a||e<a)a=e,b=d;if(d===O)break;c=d;d=d.nextScheduledRoot}}c=ma;null!==c&&c===b?Rb++:Rb=0;ma=b;na=a}function J(a){w(0,a)}function w(a,b){fb=b;for(N();null!==ma&&0!==na&&(0===a||na<=a)&&!Yc;)m(ma,na),N();null!==fb&&(Tb=0,Xc=-1);0!==na&&L(na);fb=null;Yc=!1;Rb=0;if(Ub)throw a=Zc,Zc=
	null,Ub=!1,a;}function m(a,c){Fa?E("245"):void 0;Fa=!0;if(c<=I()){var d=a.finishedWork;null!==d?(a.finishedWork=null,a.remainingExpirationTime=b(d)):(a.finishedWork=null,d=g(a,c),null!==d&&(a.remainingExpirationTime=b(d)))}else d=a.finishedWork,null!==d?(a.finishedWork=null,a.remainingExpirationTime=b(d)):(a.finishedWork=null,d=g(a,c),null!==d&&(A()?a.finishedWork=d:a.remainingExpirationTime=b(d)));Fa=!1}function A(){return null===fb||fb.timeRemaining()>Lg?!1:Yc=!0}function Ob(a){null===ma?E("246"):
	void 0;ma.remainingExpirationTime=0;Ub||(Ub=!0,Zc=a)}var r=hf(a),n=jf(a),p=r.popHostContainer,qg=r.popHostContext,x=r.resetHostContainer,Me=df(a,r,n,u,y),rg=Me.beginWork,Gg=Me.beginFailedWork,Fg=ef(a,r,n).completeWork;r=ff(a,h);var zg=r.commitResetTextContent,Ne=r.commitPlacement,Bg=r.commitDeletion,Oe=r.commitWork,Dg=r.commitLifeCycles,Eg=r.commitAttachRef,Ag=r.commitDetachRef,Wc=a.now,Kg=a.scheduleDeferredCallback,Jg=a.cancelDeferredCallback,Hg=a.useSyncScheduling,yg=a.prepareForCommit,Cg=a.resetAfterCommit,
	Pe=Wc(),Uc=2,ka=0,ja=!1,F=null,ra=null,H=0,t=null,R=null,qa=null,ha=null,ca=null,eb=!1,Qb=!1,Sc=!1,sa=null,O=null,Tb=0,Xc=-1,Fa=!1,ma=null,na=0,Yc=!1,Ub=!1,Zc=null,fb=null,la=!1,Sb=!1,Ig=1E3,Rb=0,Lg=1;return{computeAsyncExpiration:v,computeExpirationForFiber:y,scheduleWork:u,batchedUpdates:function(a,b){var c=la;la=!0;try{return a(b)}finally{(la=c)||Fa||w(1,null)}},unbatchedUpdates:function(a){if(la&&!Sb){Sb=!0;try{return a()}finally{Sb=!1}}return a()},flushSync:function(a){var b=la;la=!0;try{a:{var c=
	ka;ka=1;try{var d=a();break a}finally{ka=c}d=void 0}return d}finally{la=b,Fa?E("187"):void 0,w(1,null)}},deferredUpdates:function(a){var b=ka;ka=v();try{return a()}finally{ka=b}}}}
	function lf(a){function b(a){a=od(a);return null===a?null:a.stateNode}var c=a.getPublicInstance;a=kf(a);var d=a.computeAsyncExpiration,e=a.computeExpirationForFiber,f=a.scheduleWork;return{createContainer:function(a,b){var c=new Y(3,null,0);a={current:c,containerInfo:a,pendingChildren:null,remainingExpirationTime:0,isReadyForCommit:!1,finishedWork:null,context:null,pendingContext:null,hydrate:b,nextScheduledRoot:null};return c.stateNode=a},updateContainer:function(a,b,c,q){var g=b.current;if(c){c=
	c._reactInternalFiber;var h;b:{2===kd(c)&&2===c.tag?void 0:E("170");for(h=c;3!==h.tag;){if(le(h)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}(h=h["return"])?void 0:E("171")}h=h.stateNode.context}c=le(c)?pe(c,h):h}else c=D;null===b.context?b.context=c:b.pendingContext=c;b=q;b=void 0===b?null:b;q=null!=a&&null!=a.type&&null!=a.type.prototype&&!0===a.type.prototype.unstable_isAsyncReactComponent?d():e(g);He(g,{expirationTime:q,partialState:{element:a},callback:b,isReplace:!1,isForced:!1,
	nextCallback:null,next:null});f(g,q)},batchedUpdates:a.batchedUpdates,unbatchedUpdates:a.unbatchedUpdates,deferredUpdates:a.deferredUpdates,flushSync:a.flushSync,getPublicRootInstance:function(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return c(a.child.stateNode);default:return a.child.stateNode}},findHostInstance:b,findHostInstanceWithNoPortals:function(a){a=pd(a);return null===a?null:a.stateNode},injectIntoDevTools:function(a){var c=a.findFiberByHostInstance;return Ce(B({},
	a,{findHostInstanceByFiber:function(a){return b(a)},findFiberByHostInstance:function(a){return c?c(a):null}}))}}}var mf=Object.freeze({default:lf}),nf=mf&&lf||mf,of=nf["default"]?nf["default"]:nf;function pf(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:Ue,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}var qf="object"===typeof performance&&"function"===typeof performance.now,rf=void 0;rf=qf?function(){return performance.now()}:function(){return Date.now()};
	var sf=void 0,tf=void 0;
	if(l.canUseDOM)if("function"!==typeof requestIdleCallback||"function"!==typeof cancelIdleCallback){var uf=null,vf=!1,wf=-1,xf=!1,yf=0,zf=33,Af=33,Bf;Bf=qf?{didTimeout:!1,timeRemaining:function(){var a=yf-performance.now();return 0<a?a:0}}:{didTimeout:!1,timeRemaining:function(){var a=yf-Date.now();return 0<a?a:0}};var Cf="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){if(a.source===window&&a.data===Cf){vf=!1;a=rf();if(0>=yf-a)if(-1!==wf&&wf<=
	a)Bf.didTimeout=!0;else{xf||(xf=!0,requestAnimationFrame(Df));return}else Bf.didTimeout=!1;wf=-1;a=uf;uf=null;null!==a&&a(Bf)}},!1);var Df=function(a){xf=!1;var b=a-yf+Af;b<Af&&zf<Af?(8>b&&(b=8),Af=b<zf?zf:b):zf=b;yf=a+Af;vf||(vf=!0,window.postMessage(Cf,"*"))};sf=function(a,b){uf=a;null!=b&&"number"===typeof b.timeout&&(wf=rf()+b.timeout);xf||(xf=!0,requestAnimationFrame(Df));return 0};tf=function(){uf=null;vf=!1;wf=-1}}else sf=window.requestIdleCallback,tf=window.cancelIdleCallback;else sf=function(a){return setTimeout(function(){a({timeRemaining:function(){return Infinity}})})},
	tf=function(a){clearTimeout(a)};var Ef=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Ff={},Gf={};
	function Hf(a){if(Gf.hasOwnProperty(a))return!0;if(Ff.hasOwnProperty(a))return!1;if(Ef.test(a))return Gf[a]=!0;Ff[a]=!0;return!1}
	function If(a,b,c){var d=wa(b);if(d&&va(b,c)){var e=d.mutationMethod;e?e(a,c):null==c||d.hasBooleanValue&&!c||d.hasNumericValue&&isNaN(c)||d.hasPositiveNumericValue&&1>c||d.hasOverloadedBooleanValue&&!1===c?Jf(a,b):d.mustUseProperty?a[d.propertyName]=c:(b=d.attributeName,(e=d.attributeNamespace)?a.setAttributeNS(e,b,""+c):d.hasBooleanValue||d.hasOverloadedBooleanValue&&!0===c?a.setAttribute(b,""):a.setAttribute(b,""+c))}else Kf(a,b,va(b,c)?c:null)}
	function Kf(a,b,c){Hf(b)&&(null==c?a.removeAttribute(b):a.setAttribute(b,""+c))}function Jf(a,b){var c=wa(b);c?(b=c.mutationMethod)?b(a,void 0):c.mustUseProperty?a[c.propertyName]=c.hasBooleanValue?!1:"":a.removeAttribute(c.attributeName):a.removeAttribute(b)}
	function Lf(a,b){var c=b.value,d=b.checked;return B({type:void 0,step:void 0,min:void 0,max:void 0},b,{defaultChecked:void 0,defaultValue:void 0,value:null!=c?c:a._wrapperState.initialValue,checked:null!=d?d:a._wrapperState.initialChecked})}function Mf(a,b){var c=b.defaultValue;a._wrapperState={initialChecked:null!=b.checked?b.checked:b.defaultChecked,initialValue:null!=b.value?b.value:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}
	function Nf(a,b){b=b.checked;null!=b&&If(a,"checked",b)}function Of(a,b){Nf(a,b);var c=b.value;if(null!=c)if(0===c&&""===a.value)a.value="0";else if("number"===b.type){if(b=parseFloat(a.value)||0,c!=b||c==b&&a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else null==b.value&&null!=b.defaultValue&&a.defaultValue!==""+b.defaultValue&&(a.defaultValue=""+b.defaultValue),null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
	function Pf(a,b){switch(b.type){case "submit":case "reset":break;case "color":case "date":case "datetime":case "datetime-local":case "month":case "time":case "week":a.value="";a.value=a.defaultValue;break;default:a.value=a.value}b=a.name;""!==b&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!a.defaultChecked;""!==b&&(a.name=b)}function Qf(a){var b="";aa.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}
	function Rf(a,b){a=B({children:void 0},b);if(b=Qf(b.children))a.children=b;return a}function Sf(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+c;b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
	function Tf(a,b){var c=b.value;a._wrapperState={initialValue:null!=c?c:b.defaultValue,wasMultiple:!!b.multiple}}function Uf(a,b){null!=b.dangerouslySetInnerHTML?E("91"):void 0;return B({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Vf(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?E("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:E("93"),b=b[0]),c=""+b),null==c&&(c=""));a._wrapperState={initialValue:""+c}}
	function Wf(a,b){var c=b.value;null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=b.defaultValue)}function Xf(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var Yf={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
	function Zf(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function $f(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Zf(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
	var ag=void 0,bg=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Yf.svg||"innerHTML"in a)a.innerHTML=b;else{ag=ag||document.createElement("div");ag.innerHTML="\x3csvg\x3e"+b+"\x3c/svg\x3e";for(b=ag.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
	function cg(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
	var dg={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,
	stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},eg=["Webkit","ms","Moz","O"];Object.keys(dg).forEach(function(a){eg.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);dg[b]=dg[a]})});
	function fg(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||dg.hasOwnProperty(e)&&dg[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var gg=B({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
	function hg(a,b,c){b&&(gg[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?E("137",a,c()):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?E("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:E("61")),null!=b.style&&"object"!==typeof b.style?E("62",c()):void 0)}
	function ig(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var jg=Yf.html,kg=C.thatReturns("");
	function lg(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Hd(a);b=Sa[b];for(var d=0;d<b.length;d++){var e=b[d];c.hasOwnProperty(e)&&c[e]||("topScroll"===e?wd("topScroll","scroll",a):"topFocus"===e||"topBlur"===e?(wd("topFocus","focus",a),wd("topBlur","blur",a),c.topBlur=!0,c.topFocus=!0):"topCancel"===e?(yc("cancel",!0)&&wd("topCancel","cancel",a),c.topCancel=!0):"topClose"===e?(yc("close",!0)&&wd("topClose","close",a),c.topClose=!0):Dd.hasOwnProperty(e)&&U(e,Dd[e],a),c[e]=!0)}}
	var mg={topAbort:"abort",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topLoadedData:"loadeddata",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topSeeked:"seeked",topSeeking:"seeking",topStalled:"stalled",topSuspend:"suspend",topTimeUpdate:"timeupdate",topVolumeChange:"volumechange",
	topWaiting:"waiting"};function ng(a,b,c,d){c=9===c.nodeType?c:c.ownerDocument;d===jg&&(d=Zf(a));d===jg?"script"===a?(a=c.createElement("div"),a.innerHTML="\x3cscript\x3e\x3c/script\x3e",a=a.removeChild(a.firstChild)):a="string"===typeof b.is?c.createElement(a,{is:b.is}):c.createElement(a):a=c.createElementNS(d,a);return a}function og(a,b){return(9===b.nodeType?b:b.ownerDocument).createTextNode(a)}
	function pg(a,b,c,d){var e=ig(b,c);switch(b){case "iframe":case "object":U("topLoad","load",a);var f=c;break;case "video":case "audio":for(f in mg)mg.hasOwnProperty(f)&&U(f,mg[f],a);f=c;break;case "source":U("topError","error",a);f=c;break;case "img":case "image":U("topError","error",a);U("topLoad","load",a);f=c;break;case "form":U("topReset","reset",a);U("topSubmit","submit",a);f=c;break;case "details":U("topToggle","toggle",a);f=c;break;case "input":Mf(a,c);f=Lf(a,c);U("topInvalid","invalid",a);
	lg(d,"onChange");break;case "option":f=Rf(a,c);break;case "select":Tf(a,c);f=B({},c,{value:void 0});U("topInvalid","invalid",a);lg(d,"onChange");break;case "textarea":Vf(a,c);f=Uf(a,c);U("topInvalid","invalid",a);lg(d,"onChange");break;default:f=c}hg(b,f,kg);var g=f,h;for(h in g)if(g.hasOwnProperty(h)){var k=g[h];"style"===h?fg(a,k,kg):"dangerouslySetInnerHTML"===h?(k=k?k.__html:void 0,null!=k&&bg(a,k)):"children"===h?"string"===typeof k?("textarea"!==b||""!==k)&&cg(a,k):"number"===typeof k&&cg(a,
	""+k):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(Ra.hasOwnProperty(h)?null!=k&&lg(d,h):e?Kf(a,h,k):null!=k&&If(a,h,k))}switch(b){case "input":Bc(a);Pf(a,c);break;case "textarea":Bc(a);Xf(a,c);break;case "option":null!=c.value&&a.setAttribute("value",c.value);break;case "select":a.multiple=!!c.multiple;b=c.value;null!=b?Sf(a,!!c.multiple,b,!1):null!=c.defaultValue&&Sf(a,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof f.onClick&&(a.onclick=
	C)}}
	function sg(a,b,c,d,e){var f=null;switch(b){case "input":c=Lf(a,c);d=Lf(a,d);f=[];break;case "option":c=Rf(a,c);d=Rf(a,d);f=[];break;case "select":c=B({},c,{value:void 0});d=B({},d,{value:void 0});f=[];break;case "textarea":c=Uf(a,c);d=Uf(a,d);f=[];break;default:"function"!==typeof c.onClick&&"function"===typeof d.onClick&&(a.onclick=C)}hg(b,d,kg);var g,h;a=null;for(g in c)if(!d.hasOwnProperty(g)&&c.hasOwnProperty(g)&&null!=c[g])if("style"===g)for(h in b=c[g],b)b.hasOwnProperty(h)&&(a||(a={}),a[h]=
	"");else"dangerouslySetInnerHTML"!==g&&"children"!==g&&"suppressContentEditableWarning"!==g&&"suppressHydrationWarning"!==g&&"autoFocus"!==g&&(Ra.hasOwnProperty(g)?f||(f=[]):(f=f||[]).push(g,null));for(g in d){var k=d[g];b=null!=c?c[g]:void 0;if(d.hasOwnProperty(g)&&k!==b&&(null!=k||null!=b))if("style"===g)if(b){for(h in b)!b.hasOwnProperty(h)||k&&k.hasOwnProperty(h)||(a||(a={}),a[h]="");for(h in k)k.hasOwnProperty(h)&&b[h]!==k[h]&&(a||(a={}),a[h]=k[h])}else a||(f||(f=[]),f.push(g,a)),a=k;else"dangerouslySetInnerHTML"===
	g?(k=k?k.__html:void 0,b=b?b.__html:void 0,null!=k&&b!==k&&(f=f||[]).push(g,""+k)):"children"===g?b===k||"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(g,""+k):"suppressContentEditableWarning"!==g&&"suppressHydrationWarning"!==g&&(Ra.hasOwnProperty(g)?(null!=k&&lg(e,g),f||b===k||(f=[])):(f=f||[]).push(g,k))}a&&(f=f||[]).push("style",a);return f}
	function tg(a,b,c,d,e){"input"===c&&"radio"===e.type&&null!=e.name&&Nf(a,e);ig(c,d);d=ig(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?fg(a,h,kg):"dangerouslySetInnerHTML"===g?bg(a,h):"children"===g?cg(a,h):d?null!=h?Kf(a,g,h):a.removeAttribute(g):null!=h?If(a,g,h):Jf(a,g)}switch(c){case "input":Of(a,e);break;case "textarea":Wf(a,e);break;case "select":a._wrapperState.initialValue=void 0,b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?Sf(a,
	!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?Sf(a,!!e.multiple,e.defaultValue,!0):Sf(a,!!e.multiple,e.multiple?[]:"",!1))}}
	function ug(a,b,c,d,e){switch(b){case "iframe":case "object":U("topLoad","load",a);break;case "video":case "audio":for(var f in mg)mg.hasOwnProperty(f)&&U(f,mg[f],a);break;case "source":U("topError","error",a);break;case "img":case "image":U("topError","error",a);U("topLoad","load",a);break;case "form":U("topReset","reset",a);U("topSubmit","submit",a);break;case "details":U("topToggle","toggle",a);break;case "input":Mf(a,c);U("topInvalid","invalid",a);lg(e,"onChange");break;case "select":Tf(a,c);
	U("topInvalid","invalid",a);lg(e,"onChange");break;case "textarea":Vf(a,c),U("topInvalid","invalid",a),lg(e,"onChange")}hg(b,c,kg);d=null;for(var g in c)c.hasOwnProperty(g)&&(f=c[g],"children"===g?"string"===typeof f?a.textContent!==f&&(d=["children",f]):"number"===typeof f&&a.textContent!==""+f&&(d=["children",""+f]):Ra.hasOwnProperty(g)&&null!=f&&lg(e,g));switch(b){case "input":Bc(a);Pf(a,c);break;case "textarea":Bc(a);Xf(a,c);break;case "select":case "option":break;default:"function"===typeof c.onClick&&
	(a.onclick=C)}return d}function vg(a,b){return a.nodeValue!==b}
	var wg=Object.freeze({createElement:ng,createTextNode:og,setInitialProperties:pg,diffProperties:sg,updateProperties:tg,diffHydratedProperties:ug,diffHydratedText:vg,warnForUnmatchedText:function(){},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(a,b,c){switch(b){case "input":Of(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=
	c.parentNode;c=c.querySelectorAll("input[name\x3d"+JSON.stringify(""+b)+'][type\x3d"radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=rb(d);e?void 0:E("90");Cc(d);Of(d,e)}}}break;case "textarea":Wf(a,c);break;case "select":b=c.value,null!=b&&Sf(a,!!c.multiple,b,!1)}}});nc.injectFiberControlledHostComponent(wg);var xg=null,Mg=null;function Ng(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}
	function Og(a){a=a?9===a.nodeType?a.documentElement:a.firstChild:null;return!(!a||1!==a.nodeType||!a.hasAttribute("data-reactroot"))}
	var Z=of({getRootHostContext:function(a){var b=a.nodeType;switch(b){case 9:case 11:a=(a=a.documentElement)?a.namespaceURI:$f(null,"");break;default:b=8===b?a.parentNode:a,a=b.namespaceURI||null,b=b.tagName,a=$f(a,b)}return a},getChildHostContext:function(a,b){return $f(a,b)},getPublicInstance:function(a){return a},prepareForCommit:function(){xg=td;var a=da();if(Kd(a)){if("selectionStart"in a)var b={start:a.selectionStart,end:a.selectionEnd};else a:{var c=window.getSelection&&window.getSelection();
	if(c&&0!==c.rangeCount){b=c.anchorNode;var d=c.anchorOffset,e=c.focusNode;c=c.focusOffset;try{b.nodeType,e.nodeType}catch(z){b=null;break a}var f=0,g=-1,h=-1,k=0,q=0,v=a,y=null;b:for(;;){for(var u;;){v!==b||0!==d&&3!==v.nodeType||(g=f+d);v!==e||0!==c&&3!==v.nodeType||(h=f+c);3===v.nodeType&&(f+=v.nodeValue.length);if(null===(u=v.firstChild))break;y=v;v=u}for(;;){if(v===a)break b;y===b&&++k===d&&(g=f);y===e&&++q===c&&(h=f);if(null!==(u=v.nextSibling))break;v=y;y=v.parentNode}v=u}b=-1===g||-1===h?null:
	{start:g,end:h}}else b=null}b=b||{start:0,end:0}}else b=null;Mg={focusedElem:a,selectionRange:b};ud(!1)},resetAfterCommit:function(){var a=Mg,b=da(),c=a.focusedElem,d=a.selectionRange;if(b!==c&&fa(document.documentElement,c)){if(Kd(c))if(b=d.start,a=d.end,void 0===a&&(a=b),"selectionStart"in c)c.selectionStart=b,c.selectionEnd=Math.min(a,c.value.length);else if(window.getSelection){b=window.getSelection();var e=c[Eb()].length;a=Math.min(d.start,e);d=void 0===d.end?a:Math.min(d.end,e);!b.extend&&a>
	d&&(e=d,d=a,a=e);e=Jd(c,a);var f=Jd(c,d);if(e&&f&&(1!==b.rangeCount||b.anchorNode!==e.node||b.anchorOffset!==e.offset||b.focusNode!==f.node||b.focusOffset!==f.offset)){var g=document.createRange();g.setStart(e.node,e.offset);b.removeAllRanges();a>d?(b.addRange(g),b.extend(f.node,f.offset)):(g.setEnd(f.node,f.offset),b.addRange(g))}}b=[];for(a=c;a=a.parentNode;)1===a.nodeType&&b.push({element:a,left:a.scrollLeft,top:a.scrollTop});ia(c);for(c=0;c<b.length;c++)a=b[c],a.element.scrollLeft=a.left,a.element.scrollTop=
	a.top}Mg=null;ud(xg);xg=null},createInstance:function(a,b,c,d,e){a=ng(a,b,c,d);a[Q]=e;a[ob]=b;return a},appendInitialChild:function(a,b){a.appendChild(b)},finalizeInitialChildren:function(a,b,c,d){pg(a,b,c,d);a:{switch(b){case "button":case "input":case "select":case "textarea":a=!!c.autoFocus;break a}a=!1}return a},prepareUpdate:function(a,b,c,d,e){return sg(a,b,c,d,e)},shouldSetTextContent:function(a,b){return"textarea"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===
	typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&"string"===typeof b.dangerouslySetInnerHTML.__html},shouldDeprioritizeSubtree:function(a,b){return!!b.hidden},createTextInstance:function(a,b,c,d){a=og(a,b);a[Q]=d;return a},now:rf,mutation:{commitMount:function(a){a.focus()},commitUpdate:function(a,b,c,d,e){a[ob]=e;tg(a,b,c,d,e)},resetTextContent:function(a){a.textContent=""},commitTextUpdate:function(a,b,c){a.nodeValue=c},appendChild:function(a,b){a.appendChild(b)},appendChildToContainer:function(a,
	b){8===a.nodeType?a.parentNode.insertBefore(b,a):a.appendChild(b)},insertBefore:function(a,b,c){a.insertBefore(b,c)},insertInContainerBefore:function(a,b,c){8===a.nodeType?a.parentNode.insertBefore(b,c):a.insertBefore(b,c)},removeChild:function(a,b){a.removeChild(b)},removeChildFromContainer:function(a,b){8===a.nodeType?a.parentNode.removeChild(b):a.removeChild(b)}},hydration:{canHydrateInstance:function(a,b){return 1!==a.nodeType||b.toLowerCase()!==a.nodeName.toLowerCase()?null:a},canHydrateTextInstance:function(a,
	b){return""===b||3!==a.nodeType?null:a},getNextHydratableSibling:function(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},getFirstHydratableChild:function(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},hydrateInstance:function(a,b,c,d,e,f){a[Q]=f;a[ob]=c;return ug(a,b,c,e,d)},hydrateTextInstance:function(a,b,c){a[Q]=c;return vg(a,b)},didNotMatchHydratedContainerTextInstance:function(){},didNotMatchHydratedTextInstance:function(){},
	didNotHydrateContainerInstance:function(){},didNotHydrateInstance:function(){},didNotFindHydratableContainerInstance:function(){},didNotFindHydratableContainerTextInstance:function(){},didNotFindHydratableInstance:function(){},didNotFindHydratableTextInstance:function(){}},scheduleDeferredCallback:sf,cancelDeferredCallback:tf,useSyncScheduling:!0});rc=Z.batchedUpdates;
	function Pg(a,b,c,d,e){Ng(c)?void 0:E("200");var f=c._reactRootContainer;if(f)Z.updateContainer(b,f,a,e);else{d=d||Og(c);if(!d)for(f=void 0;f=c.lastChild;)c.removeChild(f);var g=Z.createContainer(c,d);f=c._reactRootContainer=g;Z.unbatchedUpdates(function(){Z.updateContainer(b,g,a,e)})}return Z.getPublicRootInstance(f)}function Qg(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;Ng(b)?void 0:E("200");return pf(a,b,null,c)}
	function Rg(a,b){this._reactRootContainer=Z.createContainer(a,b)}Rg.prototype.render=function(a,b){Z.updateContainer(a,this._reactRootContainer,null,b)};Rg.prototype.unmount=function(a){Z.updateContainer(null,this._reactRootContainer,null,a)};
	var Sg={createPortal:Qg,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(b)return Z.findHostInstance(b);"function"===typeof a.render?E("188"):E("213",Object.keys(a))},hydrate:function(a,b,c){return Pg(null,a,b,!0,c)},render:function(a,b,c){return Pg(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?E("38"):void 0;return Pg(a,b,c,!1,d)},unmountComponentAtNode:function(a){Ng(a)?void 0:
	E("40");return a._reactRootContainer?(Z.unbatchedUpdates(function(){Pg(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:Qg,unstable_batchedUpdates:tc,unstable_deferredUpdates:Z.deferredUpdates,flushSync:Z.flushSync,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:mb,EventPluginRegistry:Va,EventPropagators:Cb,ReactControlledComponent:qc,ReactDOMComponentTree:sb,ReactDOMEventListener:xd}};
	Z.injectIntoDevTools({findFiberByHostInstance:pb,bundleType:0,version:"16.2.0",rendererPackageName:"react-dom"});var Tg=Object.freeze({default:Sg}),Ug=Tg&&Sg||Tg;module.exports=Ug["default"]?Ug["default"]:Ug;


/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(2), __webpack_require__(12));
		else if(typeof define === 'function' && define.amd)
			define(["react", "prop-types"], factory);
		else {
			var a = typeof exports === 'object' ? factory(require("react"), require("prop-types")) : factory(root["react"], root["prop-types"]);
			for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
		}
	})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_11__, __WEBPACK_EXTERNAL_MODULE_12__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 2);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = warn;
	function warn(s) {
	  console.warn('[react-ga]', s);
	}
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = trim;
	// GA strings need to have leading/trailing whitespace trimmed, and not all
	// browsers have String.prototoype.trim().
	
	function trim(s) {
	  return s.replace(/^\s+|\s+$/g, '');
	}
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.testModeAPI = exports.OutboundLink = exports.plugin = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.initialize = initialize;
	exports.ga = ga;
	exports.set = set;
	exports.send = send;
	exports.pageview = pageview;
	exports.modalview = modalview;
	exports.timing = timing;
	exports.event = event;
	exports.exception = exception;
	exports.outboundLink = outboundLink;
	
	var _format2 = __webpack_require__(3);
	
	var _format3 = _interopRequireDefault(_format2);
	
	var _removeLeadingSlash = __webpack_require__(6);
	
	var _removeLeadingSlash2 = _interopRequireDefault(_removeLeadingSlash);
	
	var _trim = __webpack_require__(1);
	
	var _trim2 = _interopRequireDefault(_trim);
	
	var _loadGA = __webpack_require__(7);
	
	var _loadGA2 = _interopRequireDefault(_loadGA);
	
	var _warn = __webpack_require__(0);
	
	var _warn2 = _interopRequireDefault(_warn);
	
	var _log = __webpack_require__(8);
	
	var _log2 = _interopRequireDefault(_log);
	
	var _testModeAPI = __webpack_require__(9);
	
	var _testModeAPI2 = _interopRequireDefault(_testModeAPI);
	
	var _OutboundLink = __webpack_require__(10);
	
	var _OutboundLink2 = _interopRequireDefault(_OutboundLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /**
	                                                                                                                                                                                                     * React Google Analytics Module
	                                                                                                                                                                                                     *
	                                                                                                                                                                                                     * @package react-ga
	                                                                                                                                                                                                     * @author  Adam Lofting <adam@mozillafoundation.org>
	                                                                                                                                                                                                     *          Atul Varma <atul@mozillafoundation.org>
	                                                                                                                                                                                                     */
	
	/**
	 * Utilities
	 */
	
	
	var _debug = false;
	var _titleCase = true;
	var _testMode = false;
	var _alwaysSendToDefaultTracker = true;
	
	var internalGa = function internalGa() {
	  var _window;
	
	  if (_testMode) return _testModeAPI2.default.ga.apply(_testModeAPI2.default, arguments);
	  if (!window.ga) return (0, _warn2.default)('ReactGA.initialize must be called first or GoogleAnalytics should be loaded manually');
	  return (_window = window).ga.apply(_window, arguments);
	};
	
	function _format(s) {
	  return (0, _format3.default)(s, _titleCase);
	}
	
	function _gaCommand(trackerNames) {
	  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  var command = args[0];
	  if (typeof internalGa === 'function') {
	    if (typeof command !== 'string') {
	      (0, _warn2.default)('ga command must be a string');
	      return;
	    }
	
	    if (_alwaysSendToDefaultTracker || !Array.isArray(trackerNames)) internalGa.apply(undefined, args);
	    if (Array.isArray(trackerNames)) {
	      trackerNames.forEach(function (name) {
	        internalGa.apply(undefined, _toConsumableArray([name + '.' + command].concat(args.slice(1))));
	      });
	    }
	  }
	}
	
	function _initialize(gaTrackingID, options) {
	  if (!gaTrackingID) {
	    (0, _warn2.default)('gaTrackingID is required in initialize()');
	    return;
	  }
	
	  if (options) {
	    if (options.debug && options.debug === true) {
	      _debug = true;
	    }
	
	    if (options.titleCase === false) {
	      _titleCase = false;
	    }
	  }
	
	  if (options && options.gaOptions) {
	    internalGa('create', gaTrackingID, options.gaOptions);
	  } else {
	    internalGa('create', gaTrackingID, 'auto');
	  }
	}
	
	function initialize(configsOrTrackingId, options) {
	  if (options && options.testMode === true) {
	    _testMode = true;
	  } else {
	    if (typeof window === 'undefined') {
	      return false;
	    }
	
	    (0, _loadGA2.default)(options);
	  }
	
	  _alwaysSendToDefaultTracker = options && typeof options.alwaysSendToDefaultTracker === 'boolean' ? options.alwaysSendToDefaultTracker : true;
	
	  if (Array.isArray(configsOrTrackingId)) {
	    configsOrTrackingId.forEach(function (config) {
	      if ((typeof config === 'undefined' ? 'undefined' : _typeof(config)) !== 'object') {
	        (0, _warn2.default)('All configs must be an object');
	        return;
	      }
	      _initialize(config.trackingId, config);
	    });
	  } else {
	    _initialize(configsOrTrackingId, options);
	  }
	  return true;
	}
	
	/**
	 * ga:
	 * Returns the original GA object.
	 */
	function ga() {
	  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  if (args.length > 0) {
	    internalGa.apply(undefined, args);
	    if (_debug) {
	      (0, _log2.default)('called ga(\'arguments\');');
	      (0, _log2.default)('with arguments: ' + JSON.stringify(args));
	    }
	  }
	
	  return window.ga;
	}
	
	/**
	 * set:
	 * GA tracker set method
	 * @param {Object} fieldsObject - a field/value pair or a group of field/value pairs on the tracker
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	function set(fieldsObject, trackerNames) {
	  if (!fieldsObject) {
	    (0, _warn2.default)('`fieldsObject` is required in .set()');
	    return;
	  }
	
	  if ((typeof fieldsObject === 'undefined' ? 'undefined' : _typeof(fieldsObject)) !== 'object') {
	    (0, _warn2.default)('Expected `fieldsObject` arg to be an Object');
	    return;
	  }
	
	  if (Object.keys(fieldsObject).length === 0) {
	    (0, _warn2.default)('empty `fieldsObject` given to .set()');
	  }
	
	  _gaCommand(trackerNames, 'set', fieldsObject);
	
	  if (_debug) {
	    (0, _log2.default)('called ga(\'set\', fieldsObject);');
	    (0, _log2.default)('with fieldsObject: ' + JSON.stringify(fieldsObject));
	  }
	}
	
	/**
	 * send:
	 * Clone of the low level `ga.send` method
	 * WARNING: No validations will be applied to this
	 * @param  {Object} fieldObject - field object for tracking different analytics
	 * @param  {Array} trackerNames - trackers to send the command to
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	function send(fieldObject, trackerNames) {
	  _gaCommand(trackerNames, 'send', fieldObject);
	  if (_debug) {
	    (0, _log2.default)('called ga(\'send\', fieldObject);');
	    (0, _log2.default)('with fieldObject: ' + JSON.stringify(fieldObject));
	    (0, _log2.default)('with trackers: ' + JSON.stringify(trackerNames));
	  }
	}
	
	/**
	 * pageview:
	 * Basic GA pageview tracking
	 * @param  {String} path - the current page page e.g. '/about'
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 * @param {String} title - (optional) the page title e. g. 'My Website'
	 */
	function pageview(rawPath, trackerNames, title) {
	  if (!rawPath) {
	    (0, _warn2.default)('path is required in .pageview()');
	    return;
	  }
	
	  var path = (0, _trim2.default)(rawPath);
	  if (path === '') {
	    (0, _warn2.default)('path cannot be an empty string in .pageview()');
	    return;
	  }
	
	  var extraFields = {};
	  if (title) {
	    extraFields.title = title;
	  }
	
	  if (typeof ga === 'function') {
	    _gaCommand(trackerNames, 'send', _extends({
	      hitType: 'pageview',
	      page: path
	    }, extraFields));
	
	    if (_debug) {
	      (0, _log2.default)('called ga(\'send\', \'pageview\', path);');
	      var extraLog = '';
	      if (title) {
	        extraLog = ' and title: ' + title;
	      }
	      (0, _log2.default)('with path: ' + path + extraLog);
	    }
	  }
	}
	
	/**
	 * modalview:
	 * a proxy to basic GA pageview tracking to consistently track
	 * modal views that are an equivalent UX to a traditional pageview
	 * @param  {String} modalName e.g. 'add-or-edit-club'
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	function modalview(rawModalName, trackerNames) {
	  if (!rawModalName) {
	    (0, _warn2.default)('modalName is required in .modalview(modalName)');
	    return;
	  }
	
	  var modalName = (0, _removeLeadingSlash2.default)((0, _trim2.default)(rawModalName));
	
	  if (modalName === '') {
	    (0, _warn2.default)('modalName cannot be an empty string or a single / in .modalview()');
	    return;
	  }
	
	  if (typeof ga === 'function') {
	    var path = '/modal/' + modalName;
	    _gaCommand(trackerNames, 'send', 'pageview', path);
	
	    if (_debug) {
	      (0, _log2.default)('called ga(\'send\', \'pageview\', path);');
	      (0, _log2.default)('with path: ' + path);
	    }
	  }
	}
	
	/**
	 * timing:
	 * GA timing
	 * @param args.category {String} required
	 * @param args.variable {String} required
	 * @param args.value  {Int}  required
	 * @param args.label  {String} required
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	function timing() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      category = _ref.category,
	      variable = _ref.variable,
	      value = _ref.value,
	      label = _ref.label;
	
	  var trackerNames = arguments[1];
	
	  if (typeof ga === 'function') {
	    if (!category || !variable || !value || typeof value !== 'number') {
	      (0, _warn2.default)('args.category, args.variable ' + 'AND args.value are required in timing() ' + 'AND args.value has to be a number');
	      return;
	    }
	
	    // Required Fields
	    var fieldObject = {
	      hitType: 'timing',
	      timingCategory: _format(category),
	      timingVar: _format(variable),
	      timingValue: value
	    };
	
	    if (label) {
	      fieldObject.timingLabel = _format(label);
	    }
	
	    send(fieldObject, trackerNames);
	  }
	}
	
	/**
	 * event:
	 * GA event tracking
	 * @param args.category {String} required
	 * @param args.action {String} required
	 * @param args.label {String} optional
	 * @param args.value {Int} optional
	 * @param args.nonInteraction {boolean} optional
	 * @param args.transport {string} optional
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	function event() {
	  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var trackerNames = arguments[1];
	
	  var category = _ref2.category,
	      action = _ref2.action,
	      label = _ref2.label,
	      value = _ref2.value,
	      nonInteraction = _ref2.nonInteraction,
	      transport = _ref2.transport,
	      args = _objectWithoutProperties(_ref2, ['category', 'action', 'label', 'value', 'nonInteraction', 'transport']);
	
	  if (typeof ga === 'function') {
	    // Simple Validation
	    if (!category || !action) {
	      (0, _warn2.default)('args.category AND args.action are required in event()');
	      return;
	    }
	
	    // Required Fields
	    var fieldObject = {
	      hitType: 'event',
	      eventCategory: _format(category),
	      eventAction: _format(action)
	    };
	
	    // Optional Fields
	    if (label) {
	      fieldObject.eventLabel = _format(label);
	    }
	
	    if (typeof value !== 'undefined') {
	      if (typeof value !== 'number') {
	        (0, _warn2.default)('Expected `args.value` arg to be a Number.');
	      } else {
	        fieldObject.eventValue = value;
	      }
	    }
	
	    if (typeof nonInteraction !== 'undefined') {
	      if (typeof nonInteraction !== 'boolean') {
	        (0, _warn2.default)('`args.nonInteraction` must be a boolean.');
	      } else {
	        fieldObject.nonInteraction = nonInteraction;
	      }
	    }
	
	    if (typeof transport !== 'undefined') {
	      if (typeof transport !== 'string') {
	        (0, _warn2.default)('`args.transport` must be a string.');
	      } else {
	        if (['beacon', 'xhr', 'image'].indexOf(transport) === -1) {
	          (0, _warn2.default)('`args.transport` must be either one of these values: `beacon`, `xhr` or `image`');
	        }
	
	        fieldObject.transport = transport;
	      }
	    }
	
	    Object.keys(args).filter(function (key) {
	      return key.substr(0, 'dimension'.length) === 'dimension';
	    }).forEach(function (key) {
	      fieldObject[key] = args[key];
	    });
	
	    Object.keys(args).filter(function (key) {
	      return key.substr(0, 'metric'.length) === 'metric';
	    }).forEach(function (key) {
	      fieldObject[key] = args[key];
	    });
	
	    // Send to GA
	    send(fieldObject, trackerNames);
	  }
	}
	
	/**
	 * exception:
	 * GA exception tracking
	 * @param args.description {String} optional
	 * @param args.fatal {boolean} optional
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	function exception(_ref3, trackerNames) {
	  var description = _ref3.description,
	      fatal = _ref3.fatal;
	
	  if (typeof ga === 'function') {
	    // Required Fields
	    var fieldObject = {
	      hitType: 'exception'
	    };
	
	    // Optional Fields
	    if (description) {
	      fieldObject.exDescription = _format(description);
	    }
	
	    if (typeof fatal !== 'undefined') {
	      if (typeof fatal !== 'boolean') {
	        (0, _warn2.default)('`args.fatal` must be a boolean.');
	      } else {
	        fieldObject.exFatal = fatal;
	      }
	    }
	
	    // Send to GA
	    send(fieldObject, trackerNames);
	  }
	}
	
	var plugin = exports.plugin = {
	  /**
	   * require:
	   * GA requires a plugin
	   * @param name {String} e.g. 'ecommerce' or 'myplugin'
	   * @param options {Object} optional e.g {path: '/log', debug: true}
	   */
	  require: function require(rawName, options) {
	    if (typeof ga === 'function') {
	      // Required Fields
	      if (!rawName) {
	        (0, _warn2.default)('`name` is required in .require()');
	        return;
	      }
	
	      var name = (0, _trim2.default)(rawName);
	      if (name === '') {
	        (0, _warn2.default)('`name` cannot be an empty string in .require()');
	        return;
	      }
	
	      // Optional Fields
	      if (options) {
	        if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) !== 'object') {
	          (0, _warn2.default)('Expected `options` arg to be an Object');
	          return;
	        }
	
	        if (Object.keys(options).length === 0) {
	          (0, _warn2.default)('Empty `options` given to .require()');
	        }
	
	        ga('require', name, options);
	
	        if (_debug) {
	          (0, _log2.default)('called ga(\'require\', \'' + name + '\', ' + JSON.stringify(options));
	        }
	      } else {
	        ga('require', name);
	
	        if (_debug) {
	          (0, _log2.default)('called ga(\'require\', \'' + name + '\');');
	        }
	      }
	    }
	  },
	
	  /**
	   * execute:
	   * GA execute action for plugin
	   * Takes variable number of arguments
	   * @param pluginName {String} e.g. 'ecommerce' or 'myplugin'
	   * @param action {String} e.g. 'addItem' or 'myCustomAction'
	   * @param actionType {String} optional e.g. 'detail'
	   * @param payload {Object} optional e.g { id: '1x5e', name : 'My product to track' }
	   */
	  execute: function execute(pluginName, action) {
	    var payload = void 0;
	    var actionType = void 0;
	
	    if ((arguments.length <= 2 ? 0 : arguments.length - 2) === 1) {
	      payload = arguments.length <= 2 ? undefined : arguments[2];
	    } else {
	      actionType = arguments.length <= 2 ? undefined : arguments[2];
	      payload = arguments.length <= 3 ? undefined : arguments[3];
	    }
	
	    if (typeof ga === 'function') {
	      if (typeof pluginName !== 'string') {
	        (0, _warn2.default)('Expected `pluginName` arg to be a String.');
	      } else if (typeof action !== 'string') {
	        (0, _warn2.default)('Expected `action` arg to be a String.');
	      } else {
	        var command = pluginName + ':' + action;
	        payload = payload || null;
	        if (actionType && payload) {
	          ga(command, actionType, payload);
	          if (_debug) {
	            (0, _log2.default)('called ga(\'' + command + '\');');
	            (0, _log2.default)('actionType: "' + actionType + '" with payload: ' + JSON.stringify(payload));
	          }
	        } else if (payload) {
	          ga(command, payload);
	          if (_debug) {
	            (0, _log2.default)('called ga(\'' + command + '\');');
	            (0, _log2.default)('with payload: ' + JSON.stringify(payload));
	          }
	        } else {
	          ga(command);
	          if (_debug) {
	            (0, _log2.default)('called ga(\'' + command + '\');');
	          }
	        }
	      }
	    }
	  }
	};
	
	/**
	 * outboundLink:
	 * GA outboundLink tracking
	 * @param args.label {String} e.g. url, or 'Create an Account'
	 * @param {function} hitCallback - Called after processing a hit.
	 */
	function outboundLink(args, hitCallback, trackerNames) {
	  if (typeof hitCallback !== 'function') {
	    (0, _warn2.default)('hitCallback function is required');
	    return;
	  }
	
	  if (typeof ga === 'function') {
	    // Simple Validation
	    if (!args || !args.label) {
	      (0, _warn2.default)('args.label is required in outboundLink()');
	      return;
	    }
	
	    // Required Fields
	    var fieldObject = {
	      hitType: 'event',
	      eventCategory: 'Outbound',
	      eventAction: 'Click',
	      eventLabel: _format(args.label)
	    };
	
	    var safetyCallbackCalled = false;
	    var safetyCallback = function safetyCallback() {
	      // This prevents a delayed response from GA
	      // causing hitCallback from being fired twice
	      safetyCallbackCalled = true;
	
	      hitCallback();
	    };
	
	    // Using a timeout to ensure the execution of critical application code
	    // in the case when the GA server might be down
	    // or an ad blocker prevents sending the data
	
	    // register safety net timeout:
	    var t = setTimeout(safetyCallback, 250);
	
	    var clearableCallbackForGA = function clearableCallbackForGA() {
	      clearTimeout(t);
	      if (!safetyCallbackCalled) {
	        hitCallback();
	      }
	    };
	
	    fieldObject.hitCallback = clearableCallbackForGA;
	
	    // Send to GA
	    send(fieldObject, trackerNames);
	  } else {
	    // if ga is not defined, return the callback so the application
	    // continues to work as expected
	    setTimeout(hitCallback, 0);
	  }
	}
	
	_OutboundLink2.default.origTrackLink = _OutboundLink2.default.trackLink;
	_OutboundLink2.default.trackLink = outboundLink;
	var OutboundLink = exports.OutboundLink = _OutboundLink2.default;
	var testModeAPI = exports.testModeAPI = _testModeAPI2.default;
	
	exports.default = {
	  initialize: initialize,
	  ga: ga,
	  set: set,
	  send: send,
	  pageview: pageview,
	  modalview: modalview,
	  timing: timing,
	  event: event,
	  exception: exception,
	  plugin: plugin,
	  outboundLink: outboundLink,
	  OutboundLink: OutboundLink,
	  testModeAPI: _testModeAPI2.default
	};
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = format;
	
	var _mightBeEmail = __webpack_require__(4);
	
	var _mightBeEmail2 = _interopRequireDefault(_mightBeEmail);
	
	var _toTitleCase = __webpack_require__(5);
	
	var _toTitleCase2 = _interopRequireDefault(_toTitleCase);
	
	var _warn = __webpack_require__(0);
	
	var _warn2 = _interopRequireDefault(_warn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var redacted = 'REDACTED (Potential Email Address)';
	
	function format(s, titleCase) {
	  if ((0, _mightBeEmail2.default)(s)) {
	    (0, _warn2.default)('This arg looks like an email address, redacting.');
	    return redacted;
	  }
	
	  if (titleCase) {
	    return (0, _toTitleCase2.default)(s);
	  }
	
	  return s;
	}
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = mightBeEmail;
	// See if s could be an email address. We don't want to send personal data like email.
	// https://support.google.com/analytics/answer/2795983?hl=en
	function mightBeEmail(s) {
	  // There's no point trying to validate rfc822 fully, just look for ...@...
	  return (/[^@]+@[^@]+/.test(s)
	  );
	}
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toTitleCase;
	
	var _trim = __webpack_require__(1);
	
	var _trim2 = _interopRequireDefault(_trim);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i; /**
	                                                                                                * To Title Case 2.1 - http://individed.com/code/to-title-case/
	                                                                                                * Copyright 2008-2013 David Gouch. Licensed under the MIT License.
	                                                                                                * https://github.com/gouch/to-title-case
	                                                                                                */
	
	function toTitleCase(string) {
	  return (0, _trim2.default)(string).replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
	    if (index > 0 && index + match.length !== title.length && match.search(smallWords) > -1 && title.charAt(index - 2) !== ':' && (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') && title.charAt(index - 1).search(/[^\s-]/) < 0) {
	      return match.toLowerCase();
	    }
	
	    if (match.substr(1).search(/[A-Z]|\../) > -1) {
	      return match;
	    }
	
	    return match.charAt(0).toUpperCase() + match.substr(1);
	  });
	}
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = removeLeadingSlash;
	function removeLeadingSlash(string) {
	  if (string.substring(0, 1) === '/') {
	    return string.substring(1);
	  }
	
	  return string;
	}
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (options) {
	  // https://developers.google.com/analytics/devguides/collection/analyticsjs/
	  /* eslint-disable */
	  (function (i, s, o, g, r, a, m) {
	    i['GoogleAnalyticsObject'] = r;
	    i[r] = i[r] || function () {
	      (i[r].q = i[r].q || []).push(arguments);
	    }, i[r].l = 1 * new Date();
	    a = s.createElement(o), m = s.getElementsByTagName(o)[0];
	    a.async = 1;
	    a.src = g;
	    m.parentNode.insertBefore(a, m);
	  })(window, document, 'script', options && options.gaAddress ? options.gaAddress : 'https://www.google-analytics.com/analytics.js', 'ga');
	  /* eslint-enable */
	};
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = log;
	function log(s) {
	  console.info('[react-ga]', s);
	}
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var gaCalls = exports.gaCalls = [];
	
	exports.default = {
	  calls: gaCalls,
	  ga: function ga() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    gaCalls.push([].concat(args));
	  }
	};
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warn = __webpack_require__(0);
	
	var _warn2 = _interopRequireDefault(_warn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NEWTAB = '_blank';
	var MIDDLECLICK = 1;
	
	var OutboundLink = function (_Component) {
	  _inherits(OutboundLink, _Component);
	
	  function OutboundLink() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, OutboundLink);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OutboundLink.__proto__ || Object.getPrototypeOf(OutboundLink)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (event) {
	      var _this$props = _this.props,
	          target = _this$props.target,
	          eventLabel = _this$props.eventLabel,
	          to = _this$props.to,
	          onClick = _this$props.onClick;
	
	      var eventMeta = { label: eventLabel };
	      var sameTarget = target !== NEWTAB;
	      var normalClick = !(event.ctrlKey || event.shiftKey || event.metaKey || event.button === MIDDLECLICK);
	
	      if (sameTarget && normalClick) {
	        event.preventDefault();
	        OutboundLink.trackLink(eventMeta, function () {
	          window.location.href = to;
	        });
	      } else {
	        OutboundLink.trackLink(eventMeta, function () {});
	      }
	
	      if (onClick) {
	        onClick(event);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(OutboundLink, [{
	    key: 'render',
	    value: function render() {
	      var props = _extends({}, this.props, {
	        href: this.props.to,
	        onClick: this.handleClick
	      });
	      delete props.eventLabel;
	      return _react2.default.createElement('a', props);
	    }
	  }]);
	
	  return OutboundLink;
	}(_react.Component);
	
	OutboundLink.propTypes = {
	  eventLabel: _propTypes2.default.string.isRequired,
	  target: _propTypes2.default.string,
	  to: _propTypes2.default.string,
	  onClick: _propTypes2.default.func
	};
	OutboundLink.defaultProps = {
	  target: null,
	  to: null,
	  onClick: null
	};
	
	OutboundLink.trackLink = function () {
	  (0, _warn2.default)('ga tracking not enabled');
	};
	
	exports.default = OutboundLink;
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_11__;
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_12__;
	
	/***/ })
	/******/ ]);
	});

/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createProvider = createProvider;
	
	var _react = __webpack_require__(2);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PropTypes = __webpack_require__(203);
	
	var _warning = __webpack_require__(130);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  (0, _warning2.default)('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	function createProvider() {
	  var _Provider$childContex;
	
	  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
	  var subKey = arguments[1];
	
	  var subscriptionKey = subKey || storeKey + 'Subscription';
	
	  var Provider = function (_Component) {
	    _inherits(Provider, _Component);
	
	    Provider.prototype.getChildContext = function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
	    };
	
	    function Provider(props, context) {
	      _classCallCheck(this, Provider);
	
	      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	      _this[storeKey] = props.store;
	      return _this;
	    }
	
	    Provider.prototype.render = function render() {
	      return _react.Children.only(this.props.children);
	    };
	
	    return Provider;
	  }(_react.Component);
	
	  if (false) {
	    Provider.prototype.componentWillReceiveProps = function (nextProps) {
	      if (this[storeKey] !== nextProps.store) {
	        warnAboutReceivingStore();
	      }
	    };
	  }
	
	  Provider.propTypes = {
	    store: _PropTypes.storeShape.isRequired,
	    children: _propTypes2.default.element.isRequired
	  };
	  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = _PropTypes.storeShape.isRequired, _Provider$childContex[subscriptionKey] = _PropTypes.subscriptionShape, _Provider$childContex);
	
	  return Provider;
	}
	
	exports.default = createProvider();

/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createConnect = createConnect;
	
	var _connectAdvanced = __webpack_require__(201);
	
	var _connectAdvanced2 = _interopRequireDefault(_connectAdvanced);
	
	var _shallowEqual = __webpack_require__(528);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _mapDispatchToProps = __webpack_require__(522);
	
	var _mapDispatchToProps2 = _interopRequireDefault(_mapDispatchToProps);
	
	var _mapStateToProps = __webpack_require__(523);
	
	var _mapStateToProps2 = _interopRequireDefault(_mapStateToProps);
	
	var _mergeProps = __webpack_require__(524);
	
	var _mergeProps2 = _interopRequireDefault(_mergeProps);
	
	var _selectorFactory = __webpack_require__(525);
	
	var _selectorFactory2 = _interopRequireDefault(_selectorFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/*
	  connect is a facade over connectAdvanced. It turns its args into a compatible
	  selectorFactory, which has the signature:
	
	    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
	  
	  connect passes its args to connectAdvanced as options, which will in turn pass them to
	  selectorFactory each time a Connect component instance is instantiated or hot reloaded.
	
	  selectorFactory returns a final props selector from its mapStateToProps,
	  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
	  mergePropsFactories, and pure args.
	
	  The resulting final props selector is called by the Connect component instance whenever
	  it receives new props or store state.
	 */
	
	function match(arg, factories, name) {
	  for (var i = factories.length - 1; i >= 0; i--) {
	    var result = factories[i](arg);
	    if (result) return result;
	  }
	
	  return function (dispatch, options) {
	    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
	  };
	}
	
	function strictEqual(a, b) {
	  return a === b;
	}
	
	// createConnect with default args builds the 'official' connect behavior. Calling it with
	// different options opens up some testing and extensibility scenarios
	function createConnect() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref$connectHOC = _ref.connectHOC,
	      connectHOC = _ref$connectHOC === undefined ? _connectAdvanced2.default : _ref$connectHOC,
	      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
	      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? _mapStateToProps2.default : _ref$mapStateToPropsF,
	      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
	      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? _mapDispatchToProps2.default : _ref$mapDispatchToPro,
	      _ref$mergePropsFactor = _ref.mergePropsFactories,
	      mergePropsFactories = _ref$mergePropsFactor === undefined ? _mergeProps2.default : _ref$mergePropsFactor,
	      _ref$selectorFactory = _ref.selectorFactory,
	      selectorFactory = _ref$selectorFactory === undefined ? _selectorFactory2.default : _ref$selectorFactory;
	
	  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
	        _ref2$pure = _ref2.pure,
	        pure = _ref2$pure === undefined ? true : _ref2$pure,
	        _ref2$areStatesEqual = _ref2.areStatesEqual,
	        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
	        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
	        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? _shallowEqual2.default : _ref2$areOwnPropsEqua,
	        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
	        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? _shallowEqual2.default : _ref2$areStatePropsEq,
	        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
	        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? _shallowEqual2.default : _ref2$areMergedPropsE,
	        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);
	
	    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
	    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
	    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
	
	    return connectHOC(selectorFactory, _extends({
	      // used in error messages
	      methodName: 'connect',
	
	      // used to compute Connect's displayName from the wrapped component's displayName.
	      getDisplayName: function getDisplayName(name) {
	        return 'Connect(' + name + ')';
	      },
	
	      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
	      shouldHandleStateChanges: Boolean(mapStateToProps),
	
	      // passed through to selectorFactory
	      initMapStateToProps: initMapStateToProps,
	      initMapDispatchToProps: initMapDispatchToProps,
	      initMergeProps: initMergeProps,
	      pure: pure,
	      areStatesEqual: areStatesEqual,
	      areOwnPropsEqual: areOwnPropsEqual,
	      areStatePropsEqual: areStatePropsEqual,
	      areMergedPropsEqual: areMergedPropsEqual
	
	    }, extraOptions));
	  };
	}
	
	exports.default = createConnect();

/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.whenMapDispatchToPropsIsFunction = whenMapDispatchToPropsIsFunction;
	exports.whenMapDispatchToPropsIsMissing = whenMapDispatchToPropsIsMissing;
	exports.whenMapDispatchToPropsIsObject = whenMapDispatchToPropsIsObject;
	
	var _redux = __webpack_require__(133);
	
	var _wrapMapToProps = __webpack_require__(202);
	
	function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
	  return typeof mapDispatchToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
	}
	
	function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
	  return !mapDispatchToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return { dispatch: dispatch };
	  }) : undefined;
	}
	
	function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
	  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return (0, _redux.bindActionCreators)(mapDispatchToProps, dispatch);
	  }) : undefined;
	}
	
	exports.default = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];

/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.whenMapStateToPropsIsFunction = whenMapStateToPropsIsFunction;
	exports.whenMapStateToPropsIsMissing = whenMapStateToPropsIsMissing;
	
	var _wrapMapToProps = __webpack_require__(202);
	
	function whenMapStateToPropsIsFunction(mapStateToProps) {
	  return typeof mapStateToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
	}
	
	function whenMapStateToPropsIsMissing(mapStateToProps) {
	  return !mapStateToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function () {
	    return {};
	  }) : undefined;
	}
	
	exports.default = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];

/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.defaultMergeProps = defaultMergeProps;
	exports.wrapMergePropsFunc = wrapMergePropsFunc;
	exports.whenMergePropsIsFunction = whenMergePropsIsFunction;
	exports.whenMergePropsIsOmitted = whenMergePropsIsOmitted;
	
	var _verifyPlainObject = __webpack_require__(204);
	
	var _verifyPlainObject2 = _interopRequireDefault(_verifyPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function defaultMergeProps(stateProps, dispatchProps, ownProps) {
	  return _extends({}, ownProps, stateProps, dispatchProps);
	}
	
	function wrapMergePropsFunc(mergeProps) {
	  return function initMergePropsProxy(dispatch, _ref) {
	    var displayName = _ref.displayName,
	        pure = _ref.pure,
	        areMergedPropsEqual = _ref.areMergedPropsEqual;
	
	    var hasRunOnce = false;
	    var mergedProps = void 0;
	
	    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
	      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	      if (hasRunOnce) {
	        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
	      } else {
	        hasRunOnce = true;
	        mergedProps = nextMergedProps;
	
	        if (false) (0, _verifyPlainObject2.default)(mergedProps, displayName, 'mergeProps');
	      }
	
	      return mergedProps;
	    };
	  };
	}
	
	function whenMergePropsIsFunction(mergeProps) {
	  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
	}
	
	function whenMergePropsIsOmitted(mergeProps) {
	  return !mergeProps ? function () {
	    return defaultMergeProps;
	  } : undefined;
	}
	
	exports.default = [whenMergePropsIsFunction, whenMergePropsIsOmitted];

/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.impureFinalPropsSelectorFactory = impureFinalPropsSelectorFactory;
	exports.pureFinalPropsSelectorFactory = pureFinalPropsSelectorFactory;
	exports.default = finalPropsSelectorFactory;
	
	var _verifySubselectors = __webpack_require__(526);
	
	var _verifySubselectors2 = _interopRequireDefault(_verifySubselectors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
	  return function impureFinalPropsSelector(state, ownProps) {
	    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
	  };
	}
	
	function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
	  var areStatesEqual = _ref.areStatesEqual,
	      areOwnPropsEqual = _ref.areOwnPropsEqual,
	      areStatePropsEqual = _ref.areStatePropsEqual;
	
	  var hasRunAtLeastOnce = false;
	  var state = void 0;
	  var ownProps = void 0;
	  var stateProps = void 0;
	  var dispatchProps = void 0;
	  var mergedProps = void 0;
	
	  function handleFirstCall(firstState, firstOwnProps) {
	    state = firstState;
	    ownProps = firstOwnProps;
	    stateProps = mapStateToProps(state, ownProps);
	    dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    hasRunAtLeastOnce = true;
	    return mergedProps;
	  }
	
	  function handleNewPropsAndNewState() {
	    stateProps = mapStateToProps(state, ownProps);
	
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewProps() {
	    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
	
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewState() {
	    var nextStateProps = mapStateToProps(state, ownProps);
	    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
	    stateProps = nextStateProps;
	
	    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	    return mergedProps;
	  }
	
	  function handleSubsequentCalls(nextState, nextOwnProps) {
	    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
	    var stateChanged = !areStatesEqual(nextState, state);
	    state = nextState;
	    ownProps = nextOwnProps;
	
	    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
	    if (propsChanged) return handleNewProps();
	    if (stateChanged) return handleNewState();
	    return mergedProps;
	  }
	
	  return function pureFinalPropsSelector(nextState, nextOwnProps) {
	    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
	  };
	}
	
	// TODO: Add more comments
	
	// If pure is true, the selector returned by selectorFactory will memoize its results,
	// allowing connectAdvanced's shouldComponentUpdate to return false if final
	// props have not changed. If false, the selector will always return a new
	// object and shouldComponentUpdate will always return true.
	
	function finalPropsSelectorFactory(dispatch, _ref2) {
	  var initMapStateToProps = _ref2.initMapStateToProps,
	      initMapDispatchToProps = _ref2.initMapDispatchToProps,
	      initMergeProps = _ref2.initMergeProps,
	      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);
	
	  var mapStateToProps = initMapStateToProps(dispatch, options);
	  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
	  var mergeProps = initMergeProps(dispatch, options);
	
	  if (false) {
	    (0, _verifySubselectors2.default)(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
	  }
	
	  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
	
	  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
	}

/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = verifySubselectors;
	
	var _warning = __webpack_require__(130);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function verify(selector, methodName, displayName) {
	  if (!selector) {
	    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
	  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
	    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
	      (0, _warning2.default)('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
	    }
	  }
	}
	
	function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
	  verify(mapStateToProps, 'mapStateToProps', displayName);
	  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
	  verify(mergeProps, 'mergeProps', displayName);
	}

/***/ },
/* 527 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// encapsulates the subscription logic for connecting a component to the redux store, as
	// well as nesting subscriptions of descendant components, so that we can ensure the
	// ancestor components re-render before descendants
	
	var CLEARED = null;
	var nullListeners = {
	  notify: function notify() {}
	};
	
	function createListenerCollection() {
	  // the current/next pattern is copied from redux's createStore code.
	  // TODO: refactor+expose that code to be reusable here?
	  var current = [];
	  var next = [];
	
	  return {
	    clear: function clear() {
	      next = CLEARED;
	      current = CLEARED;
	    },
	    notify: function notify() {
	      var listeners = current = next;
	      for (var i = 0; i < listeners.length; i++) {
	        listeners[i]();
	      }
	    },
	    get: function get() {
	      return next;
	    },
	    subscribe: function subscribe(listener) {
	      var isSubscribed = true;
	      if (next === current) next = current.slice();
	      next.push(listener);
	
	      return function unsubscribe() {
	        if (!isSubscribed || current === CLEARED) return;
	        isSubscribed = false;
	
	        if (next === current) next = current.slice();
	        next.splice(next.indexOf(listener), 1);
	      };
	    }
	  };
	}
	
	var Subscription = function () {
	  function Subscription(store, parentSub, onStateChange) {
	    _classCallCheck(this, Subscription);
	
	    this.store = store;
	    this.parentSub = parentSub;
	    this.onStateChange = onStateChange;
	    this.unsubscribe = null;
	    this.listeners = nullListeners;
	  }
	
	  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
	    this.trySubscribe();
	    return this.listeners.subscribe(listener);
	  };
	
	  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
	    this.listeners.notify();
	  };
	
	  Subscription.prototype.isSubscribed = function isSubscribed() {
	    return Boolean(this.unsubscribe);
	  };
	
	  Subscription.prototype.trySubscribe = function trySubscribe() {
	    if (!this.unsubscribe) {
	      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
	
	      this.listeners = createListenerCollection();
	    }
	  };
	
	  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
	    if (this.unsubscribe) {
	      this.unsubscribe();
	      this.unsubscribe = null;
	      this.listeners.clear();
	      this.listeners = nullListeners;
	    }
	  };
	
	  return Subscription;
	}();
	
	exports.default = Subscription;

/***/ },
/* 528 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = shallowEqual;
	var hasOwn = Object.prototype.hasOwnProperty;
	
	function is(x, y) {
	  if (x === y) {
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) return true;
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) return false;
	
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(24);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createBrowserHistory = __webpack_require__(126);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _Router = __webpack_require__(131);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that uses HTML5 history.
	 */
	var BrowserRouter = function (_React$Component) {
	  _inherits(BrowserRouter, _React$Component);
	
	  function BrowserRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, BrowserRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _createBrowserHistory2.default)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, '<BrowserRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { BrowserRouter as Router }`.');
	  };
	
	  BrowserRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return BrowserRouter;
	}(_react2.default.Component);
	
	BrowserRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  forceRefresh: _propTypes2.default.bool,
	  getUserConfirmation: _propTypes2.default.func,
	  keyLength: _propTypes2.default.number,
	  children: _propTypes2.default.node
	};
	exports.default = BrowserRouter;

/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(24);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createHashHistory = __webpack_require__(195);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _Router = __webpack_require__(131);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that uses window.location.hash.
	 */
	var HashRouter = function (_React$Component) {
	  _inherits(HashRouter, _React$Component);
	
	  function HashRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, HashRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _createHashHistory2.default)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  HashRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, '<HashRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { HashRouter as Router }`.');
	  };
	
	  HashRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return HashRouter;
	}(_react2.default.Component);
	
	HashRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  getUserConfirmation: _propTypes2.default.func,
	  hashType: _propTypes2.default.oneOf(['hashbang', 'noslash', 'slash']),
	  children: _propTypes2.default.node
	};
	exports.default = HashRouter;

/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _MemoryRouter = __webpack_require__(209);
	
	var _MemoryRouter2 = _interopRequireDefault(_MemoryRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _MemoryRouter2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Route = __webpack_require__(206);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	var _Link = __webpack_require__(205);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A <Link> wrapper that knows if it's "active" or not.
	 */
	var NavLink = function NavLink(_ref) {
	  var to = _ref.to,
	      exact = _ref.exact,
	      strict = _ref.strict,
	      location = _ref.location,
	      activeClassName = _ref.activeClassName,
	      className = _ref.className,
	      activeStyle = _ref.activeStyle,
	      style = _ref.style,
	      getIsActive = _ref.isActive,
	      ariaCurrent = _ref.ariaCurrent,
	      rest = _objectWithoutProperties(_ref, ['to', 'exact', 'strict', 'location', 'activeClassName', 'className', 'activeStyle', 'style', 'isActive', 'ariaCurrent']);
	
	  return _react2.default.createElement(_Route2.default, {
	    path: (typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object' ? to.pathname : to,
	    exact: exact,
	    strict: strict,
	    location: location,
	    children: function children(_ref2) {
	      var location = _ref2.location,
	          match = _ref2.match;
	
	      var isActive = !!(getIsActive ? getIsActive(match, location) : match);
	
	      return _react2.default.createElement(_Link2.default, _extends({
	        to: to,
	        className: isActive ? [className, activeClassName].filter(function (i) {
	          return i;
	        }).join(' ') : className,
	        style: isActive ? _extends({}, style, activeStyle) : style,
	        'aria-current': isActive && ariaCurrent
	      }, rest));
	    }
	  });
	};
	
	NavLink.propTypes = {
	  to: _Link2.default.propTypes.to,
	  exact: _propTypes2.default.bool,
	  strict: _propTypes2.default.bool,
	  location: _propTypes2.default.object,
	  activeClassName: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  activeStyle: _propTypes2.default.object,
	  style: _propTypes2.default.object,
	  isActive: _propTypes2.default.func,
	  ariaCurrent: _propTypes2.default.oneOf(['page', 'step', 'location', 'true'])
	};
	
	NavLink.defaultProps = {
	  activeClassName: 'active',
	  ariaCurrent: 'true'
	};
	
	exports.default = NavLink;

/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Prompt = __webpack_require__(210);
	
	var _Prompt2 = _interopRequireDefault(_Prompt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Prompt2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Redirect = __webpack_require__(211);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Redirect2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _StaticRouter = __webpack_require__(212);
	
	var _StaticRouter2 = _interopRequireDefault(_StaticRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _StaticRouter2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Switch = __webpack_require__(213);
	
	var _Switch2 = _interopRequireDefault(_Switch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Switch2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _matchPath = __webpack_require__(91);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _matchPath2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _withRouter = __webpack_require__(214);
	
	var _withRouter2 = _interopRequireDefault(_withRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _withRouter2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(41);
	
	var _reducer = __webpack_require__(208);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ConnectedRouter = function (_Component) {
	  _inherits(ConnectedRouter, _Component);
	
	  function ConnectedRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ConnectedRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleLocationChange = function (location) {
	      _this.store.dispatch({
	        type: _reducer.LOCATION_CHANGE,
	        payload: location
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ConnectedRouter.prototype.componentWillMount = function componentWillMount() {
	    var _props = this.props,
	        propsStore = _props.store,
	        history = _props.history;
	
	    this.store = propsStore || this.context.store;
	    this.handleLocationChange(history.location);
	  };
	
	  ConnectedRouter.prototype.componentDidMount = function componentDidMount() {
	    var history = this.props.history;
	
	    this.unsubscribeFromHistory = history.listen(this.handleLocationChange);
	  };
	
	  ConnectedRouter.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.unsubscribeFromHistory) this.unsubscribeFromHistory();
	  };
	
	  ConnectedRouter.prototype.render = function render() {
	    return _react2.default.createElement(_reactRouter.Router, this.props);
	  };
	
	  return ConnectedRouter;
	}(_react.Component);
	
	ConnectedRouter.propTypes = {
	  store: _propTypes2.default.object,
	  history: _propTypes2.default.object,
	  children: _propTypes2.default.node
	};
	ConnectedRouter.contextTypes = {
	  store: _propTypes2.default.object
	};
	exports.default = ConnectedRouter;

/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = routerMiddleware;
	
	var _actions = __webpack_require__(207);
	
	/**
	 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
	 * provided history object. This will prevent these actions from reaching your
	 * reducer or any middleware that comes after this one.
	 */
	function routerMiddleware(history) {
	  return function () {
	    return function (next) {
	      return function (action) {
	        if (action.type !== _actions.CALL_HISTORY_METHOD) {
	          return next(action);
	        }
	
	        var _action$payload = action.payload,
	            method = _action$payload.method,
	            args = _action$payload.args;
	
	        history[method].apply(history, args);
	      };
	    };
	  };
	}

/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createMatchSelector = exports.getLocation = undefined;
	
	var _reactRouter = __webpack_require__(41);
	
	var getLocation = exports.getLocation = function getLocation(state) {
	  return state.router.location;
	};
	
	var createMatchSelector = exports.createMatchSelector = function createMatchSelector(path) {
	  var lastPathname = null;
	  var lastMatch = null;
	  return function (state) {
	    var _getLocation = getLocation(state),
	        pathname = _getLocation.pathname;
	
	    if (pathname === lastPathname) {
	      return lastMatch;
	    }
	    lastPathname = pathname;
	    var match = (0, _reactRouter.matchPath)(pathname, path);
	    if (!match || !lastMatch || match.url !== lastMatch.url) {
	      lastMatch = match;
	    }
	    return lastMatch;
	  };
	};

/***/ },
/* 542 */
/***/ function(module, exports) {

	module.exports = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};


/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	var isarray = __webpack_require__(542)
	
	/**
	 * Expose `pathToRegexp`.
	 */
	module.exports = pathToRegexp
	module.exports.parse = parse
	module.exports.compile = compile
	module.exports.tokensToFunction = tokensToFunction
	module.exports.tokensToRegExp = tokensToRegExp
	
	/**
	 * The main path matching regexp utility.
	 *
	 * @type {RegExp}
	 */
	var PATH_REGEXP = new RegExp([
	  // Match escaped characters that would otherwise appear in future matches.
	  // This allows the user to escape special characters that won't transform.
	  '(\\\\.)',
	  // Match Express-style parameters and un-named parameters with a prefix
	  // and optional suffixes. Matches appear as:
	  //
	  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
	  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
	  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
	  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
	].join('|'), 'g')
	
	/**
	 * Parse a string for the raw tokens.
	 *
	 * @param  {string}  str
	 * @param  {Object=} options
	 * @return {!Array}
	 */
	function parse (str, options) {
	  var tokens = []
	  var key = 0
	  var index = 0
	  var path = ''
	  var defaultDelimiter = options && options.delimiter || '/'
	  var res
	
	  while ((res = PATH_REGEXP.exec(str)) != null) {
	    var m = res[0]
	    var escaped = res[1]
	    var offset = res.index
	    path += str.slice(index, offset)
	    index = offset + m.length
	
	    // Ignore already escaped sequences.
	    if (escaped) {
	      path += escaped[1]
	      continue
	    }
	
	    var next = str[index]
	    var prefix = res[2]
	    var name = res[3]
	    var capture = res[4]
	    var group = res[5]
	    var modifier = res[6]
	    var asterisk = res[7]
	
	    // Push the current path onto the tokens.
	    if (path) {
	      tokens.push(path)
	      path = ''
	    }
	
	    var partial = prefix != null && next != null && next !== prefix
	    var repeat = modifier === '+' || modifier === '*'
	    var optional = modifier === '?' || modifier === '*'
	    var delimiter = res[2] || defaultDelimiter
	    var pattern = capture || group
	
	    tokens.push({
	      name: name || key++,
	      prefix: prefix || '',
	      delimiter: delimiter,
	      optional: optional,
	      repeat: repeat,
	      partial: partial,
	      asterisk: !!asterisk,
	      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
	    })
	  }
	
	  // Match any characters still remaining.
	  if (index < str.length) {
	    path += str.substr(index)
	  }
	
	  // If the path exists, push it onto the end.
	  if (path) {
	    tokens.push(path)
	  }
	
	  return tokens
	}
	
	/**
	 * Compile a string to a template function for the path.
	 *
	 * @param  {string}             str
	 * @param  {Object=}            options
	 * @return {!function(Object=, Object=)}
	 */
	function compile (str, options) {
	  return tokensToFunction(parse(str, options))
	}
	
	/**
	 * Prettier encoding of URI path segments.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeURIComponentPretty (str) {
	  return encodeURI(str).replace(/[\/?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeAsterisk (str) {
	  return encodeURI(str).replace(/[?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Expose a method for transforming tokens into the path function.
	 */
	function tokensToFunction (tokens) {
	  // Compile all the tokens into regexps.
	  var matches = new Array(tokens.length)
	
	  // Compile all the patterns before compilation.
	  for (var i = 0; i < tokens.length; i++) {
	    if (typeof tokens[i] === 'object') {
	      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
	    }
	  }
	
	  return function (obj, opts) {
	    var path = ''
	    var data = obj || {}
	    var options = opts || {}
	    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent
	
	    for (var i = 0; i < tokens.length; i++) {
	      var token = tokens[i]
	
	      if (typeof token === 'string') {
	        path += token
	
	        continue
	      }
	
	      var value = data[token.name]
	      var segment
	
	      if (value == null) {
	        if (token.optional) {
	          // Prepend partial segment prefixes.
	          if (token.partial) {
	            path += token.prefix
	          }
	
	          continue
	        } else {
	          throw new TypeError('Expected "' + token.name + '" to be defined')
	        }
	      }
	
	      if (isarray(value)) {
	        if (!token.repeat) {
	          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
	        }
	
	        if (value.length === 0) {
	          if (token.optional) {
	            continue
	          } else {
	            throw new TypeError('Expected "' + token.name + '" to not be empty')
	          }
	        }
	
	        for (var j = 0; j < value.length; j++) {
	          segment = encode(value[j])
	
	          if (!matches[i].test(segment)) {
	            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
	          }
	
	          path += (j === 0 ? token.prefix : token.delimiter) + segment
	        }
	
	        continue
	      }
	
	      segment = token.asterisk ? encodeAsterisk(value) : encode(value)
	
	      if (!matches[i].test(segment)) {
	        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
	      }
	
	      path += token.prefix + segment
	    }
	
	    return path
	  }
	}
	
	/**
	 * Escape a regular expression string.
	 *
	 * @param  {string} str
	 * @return {string}
	 */
	function escapeString (str) {
	  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
	}
	
	/**
	 * Escape the capturing group by escaping special characters and meaning.
	 *
	 * @param  {string} group
	 * @return {string}
	 */
	function escapeGroup (group) {
	  return group.replace(/([=!:$\/()])/g, '\\$1')
	}
	
	/**
	 * Attach the keys as a property of the regexp.
	 *
	 * @param  {!RegExp} re
	 * @param  {Array}   keys
	 * @return {!RegExp}
	 */
	function attachKeys (re, keys) {
	  re.keys = keys
	  return re
	}
	
	/**
	 * Get the flags for a regexp from the options.
	 *
	 * @param  {Object} options
	 * @return {string}
	 */
	function flags (options) {
	  return options.sensitive ? '' : 'i'
	}
	
	/**
	 * Pull out keys from a regexp.
	 *
	 * @param  {!RegExp} path
	 * @param  {!Array}  keys
	 * @return {!RegExp}
	 */
	function regexpToRegexp (path, keys) {
	  // Use a negative lookahead to match only capturing groups.
	  var groups = path.source.match(/\((?!\?)/g)
	
	  if (groups) {
	    for (var i = 0; i < groups.length; i++) {
	      keys.push({
	        name: i,
	        prefix: null,
	        delimiter: null,
	        optional: false,
	        repeat: false,
	        partial: false,
	        asterisk: false,
	        pattern: null
	      })
	    }
	  }
	
	  return attachKeys(path, keys)
	}
	
	/**
	 * Transform an array into a regexp.
	 *
	 * @param  {!Array}  path
	 * @param  {Array}   keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function arrayToRegexp (path, keys, options) {
	  var parts = []
	
	  for (var i = 0; i < path.length; i++) {
	    parts.push(pathToRegexp(path[i], keys, options).source)
	  }
	
	  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))
	
	  return attachKeys(regexp, keys)
	}
	
	/**
	 * Create a path regexp from string input.
	 *
	 * @param  {string}  path
	 * @param  {!Array}  keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function stringToRegexp (path, keys, options) {
	  return tokensToRegExp(parse(path, options), keys, options)
	}
	
	/**
	 * Expose a function for taking tokens and returning a RegExp.
	 *
	 * @param  {!Array}          tokens
	 * @param  {(Array|Object)=} keys
	 * @param  {Object=}         options
	 * @return {!RegExp}
	 */
	function tokensToRegExp (tokens, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  var strict = options.strict
	  var end = options.end !== false
	  var route = ''
	
	  // Iterate over the tokens and create our regexp string.
	  for (var i = 0; i < tokens.length; i++) {
	    var token = tokens[i]
	
	    if (typeof token === 'string') {
	      route += escapeString(token)
	    } else {
	      var prefix = escapeString(token.prefix)
	      var capture = '(?:' + token.pattern + ')'
	
	      keys.push(token)
	
	      if (token.repeat) {
	        capture += '(?:' + prefix + capture + ')*'
	      }
	
	      if (token.optional) {
	        if (!token.partial) {
	          capture = '(?:' + prefix + '(' + capture + '))?'
	        } else {
	          capture = prefix + '(' + capture + ')?'
	        }
	      } else {
	        capture = prefix + '(' + capture + ')'
	      }
	
	      route += capture
	    }
	  }
	
	  var delimiter = escapeString(options.delimiter || '/')
	  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter
	
	  // In non-strict mode we allow a slash at the end of match. If the path to
	  // match already ends with a slash, we remove it for consistency. The slash
	  // is valid at the end of a path match, not in the middle. This is important
	  // in non-ending mode, where "/test/" shouldn't match "/test//route".
	  if (!strict) {
	    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
	  }
	
	  if (end) {
	    route += '$'
	  } else {
	    // In non-ending mode, we need the capturing groups to match as much as
	    // possible by using a positive lookahead to the end or next path segment.
	    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
	  }
	
	  return attachKeys(new RegExp('^' + route, flags(options)), keys)
	}
	
	/**
	 * Normalize the given path string, returning a regular expression.
	 *
	 * An empty array can be passed in for the keys, which will hold the
	 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
	 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
	 *
	 * @param  {(string|RegExp|Array)} path
	 * @param  {(Array|Object)=}       keys
	 * @param  {Object=}               options
	 * @return {!RegExp}
	 */
	function pathToRegexp (path, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  if (path instanceof RegExp) {
	    return regexpToRegexp(path, /** @type {!Array} */ (keys))
	  }
	
	  if (isarray(path)) {
	    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
	  }
	
	  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
	}


/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	// @remove-on-eject-begin
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	// @remove-on-eject-end
	'use strict';
	
	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(546).enable();
	  window.Promise = __webpack_require__(545);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(547);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(67);


/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(215);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(215);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 547 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(12);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _addClass = __webpack_require__(469);
	
	var _addClass2 = _interopRequireDefault(_addClass);
	
	var _removeClass = __webpack_require__(471);
	
	var _removeClass2 = _interopRequireDefault(_removeClass);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Transition = __webpack_require__(216);
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	var _PropTypes = __webpack_require__(217);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var addClass = function addClass(node, classes) {
	  return classes && classes.split(' ').forEach(function (c) {
	    return (0, _addClass2.default)(node, c);
	  });
	};
	var removeClass = function removeClass(node, classes) {
	  return classes && classes.split(' ').forEach(function (c) {
	    return (0, _removeClass2.default)(node, c);
	  });
	};
	
	var propTypes = _extends({}, _Transition2.default.propTypes, {
	
	  /**
	   * The animation classNames applied to the component as it enters or exits.
	   * A single name can be provided and it will be suffixed for each stage: e.g.
	   *
	   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`,
	   * `fade-exit`, `fade-exit-active`, `fade-appear`, and `fade-appear-active`.
	   * Each individual classNames can also be specified independently like:
	   *
	   * ```js
	   * classNames={{
	   *  appear: 'my-appear',
	   *  appearActive: 'my-active-appear',
	   *  enter: 'my-enter',
	   *  enterActive: 'my-active-enter',
	   *  exit: 'my-exit',
	   *  exitActive: 'my-active-exit',
	   * }}
	   * ```
	   *
	   * @type {string | {
	   *  appear?: string,
	   *  appearActive?: string,
	   *  enter?: string,
	   *  enterActive?: string,
	   *  exit?: string,
	   *  exitActive?: string,
	   * }}
	   */
	  classNames: _PropTypes.classNamesShape,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter-active' or
	   * 'appear-active' class is applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or
	   * 'appear' classes are **removed** from the DOM node.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
	   *
	   * @type Function(node: HtmlElement
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' classes
	   * are **removed** from the DOM node.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExited: PropTypes.func
	});
	
	/**
	 * A `Transition` component using CSS transitions and animations.
	 * It's inspired by the excellent [ng-animate](http://www.nganimate.org/) library.
	 *
	 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
	 * and `exit` stages of the transition. The first class is applied and then a
	 * second "active" class in order to activate the css animation.
	 *
	 * When the `in` prop is toggled to `true` the Component will get
	 * the `example-enter` CSS class and the `example-enter-active` CSS class
	 * added in the next tick. This is a convention based on the `classNames` prop.
	 *
	 * ```js
	 * import CSSTransition from 'react-transition-group/CSSTransition';
	 *
	 * const Fade = ({ children, ...props }) => (
	 *  <CSSTransition
	 *    {...props}
	 *    timeout={500}
	 *    classNames="fade"
	 *  >
	 *   {children}
	 *  </CSSTransition>
	 * );
	 *
	 * class FadeInAndOut extends React.Component {
	 *   constructor(...args) {
	 *     super(...args);
	 *     this.state= { show: false }
	 *
	 *     setInterval(() => {
	 *       this.setState({ show: !this.state.show })
	 *     }, 5000)
	 *   }
	 *   render() {
	 *     return (
	 *       <Fade in={this.state.show}>
	 *         <div>Hello world</div>
	 *       </Fade>
	 *     )
	 *   }
	 * }
	 * ```
	 *
	 * And the coorresponding CSS for the `<Fade>` component:
	 *
	 * ```css
	 * .fade-enter {
	 *   opacity: 0.01;
	 * }
	 *
	 * .fade-enter.fade-enter-active {
	 *   opacity: 1;
	 *   transition: opacity 500ms ease-in;
	 * }
	 *
	 * .fade-exit {
	 *   opacity: 1;
	 * }
	 *
	 * .fade-exit.fade-exit-active {
	 *   opacity: 0.01;
	 *   transition: opacity 300ms ease-in;
	 * }
	 * ```
	 */
	
	var CSSTransition = function (_React$Component) {
	  _inherits(CSSTransition, _React$Component);
	
	  function CSSTransition() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CSSTransition);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.onEnter = function (node, appearing) {
	      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
	          className = _this$getClassNames.className;
	
	      _this.removeClasses(node, 'exit');
	      addClass(node, className);
	
	      if (_this.props.onEnter) {
	        _this.props.onEnter(node);
	      }
	    }, _this.onEntering = function (node, appearing) {
	      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
	          activeClassName = _this$getClassNames2.activeClassName;
	
	      _this.reflowAndAddClass(node, activeClassName);
	
	      if (_this.props.onEntering) {
	        _this.props.onEntering(node);
	      }
	    }, _this.onEntered = function (node, appearing) {
	      _this.removeClasses(node, appearing ? 'appear' : 'enter');
	
	      if (_this.props.onEntered) {
	        _this.props.onEntered(node);
	      }
	    }, _this.onExit = function (node) {
	      var _this$getClassNames3 = _this.getClassNames('exit'),
	          className = _this$getClassNames3.className;
	
	      _this.removeClasses(node, 'appear');
	      _this.removeClasses(node, 'enter');
	      addClass(node, className);
	
	      if (_this.props.onExit) {
	        _this.props.onExit(node);
	      }
	    }, _this.onExiting = function (node) {
	      var _this$getClassNames4 = _this.getClassNames('exit'),
	          activeClassName = _this$getClassNames4.activeClassName;
	
	      _this.reflowAndAddClass(node, activeClassName);
	
	      if (_this.props.onExiting) {
	        _this.props.onExiting(node);
	      }
	    }, _this.onExited = function (node) {
	      _this.removeClasses(node, 'exit');
	
	      if (_this.props.onExited) {
	        _this.props.onExited(node);
	      }
	    }, _this.getClassNames = function (type) {
	      var classNames = _this.props.classNames;
	
	
	      var className = typeof classNames !== 'string' ? classNames[type] : classNames + '-' + type;
	
	      var activeClassName = typeof classNames !== 'string' ? classNames[type + 'Active'] : className + '-active';
	
	      return { className: className, activeClassName: activeClassName };
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  CSSTransition.prototype.removeClasses = function removeClasses(node, type) {
	    var _getClassNames = this.getClassNames(type),
	        className = _getClassNames.className,
	        activeClassName = _getClassNames.activeClassName;
	
	    className && removeClass(node, className);
	    activeClassName && removeClass(node, activeClassName);
	  };
	
	  CSSTransition.prototype.reflowAndAddClass = function reflowAndAddClass(node, className) {
	    // This is for to force a repaint,
	    // which is necessary in order to transition styles when adding a class name.
	    /* eslint-disable no-unused-expressions */
	    node.scrollTop;
	    /* eslint-enable no-unused-expressions */
	    addClass(node, className);
	  };
	
	  CSSTransition.prototype.render = function render() {
	    var props = _extends({}, this.props);
	
	    delete props.classNames;
	
	    return _react2.default.createElement(_Transition2.default, _extends({}, props, {
	      onEnter: this.onEnter,
	      onEntered: this.onEntered,
	      onEntering: this.onEntering,
	      onExit: this.onExit,
	      onExiting: this.onExiting,
	      onExited: this.onExited
	    }));
	  };
	
	  return CSSTransition;
	}(_react2.default.Component);
	
	CSSTransition.propTypes =  false ? propTypes : {};
	
	exports.default = CSSTransition;
	module.exports = exports['default'];

/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ChildMapping = __webpack_require__(551);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var values = Object.values || function (obj) {
	  return Object.keys(obj).map(function (k) {
	    return obj[k];
	  });
	};
	
	var propTypes = {
	  /**
	   * `<TransitionGroup>` renders a `<div>` by default. You can change this
	   * behavior by providing a `component` prop.
	   */
	  component: _propTypes2.default.any,
	  /**
	   * A set of `<Transition>` components, that are toggled `in` and out as they
	   * leave. the `<TransitionGroup>` will inject specific transition props, so
	   * remember to spread them through if you are wrapping the `<Transition>` as
	   * with our `<Fade>` example.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * A convenience prop that enables or disabled appear animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  appear: _propTypes2.default.bool,
	  /**
	   * A convenience prop that enables or disabled enter animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  enter: _propTypes2.default.bool,
	  /**
	    * A convenience prop that enables or disabled exit animations
	    * for all children. Note that specifying this will override any defaults set
	    * on individual children Transitions.
	    */
	  exit: _propTypes2.default.bool,
	
	  /**
	   * You may need to apply reactive updates to a child as it is exiting.
	   * This is generally done by using `cloneElement` however in the case of an exiting
	   * child the element has already been removed and not accessible to the consumer.
	   *
	   * If you do need to update a child as it leaves you can provide a `childFactory`
	   * to wrap every child, even the ones that are leaving.
	   *
	   * @type Function(child: ReactElement) -> ReactElement
	   */
	  childFactory: _propTypes2.default.func
	};
	
	var defaultProps = {
	  component: 'div',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	};
	
	/**
	 * The `<TransitionGroup>` component manages a set of `<Transition>` components
	 * in a list. Like with the `<Transition>` component, `<TransitionGroup>`, is a
	 * state machine for managing the mounting and unmounting of components over
	 * time.
	 *
	 * Consider the example below using the `Fade` CSS transition from before.
	 * As items are removed or added to the TodoList the `in` prop is toggled
	 * automatically by the `<TransitionGroup>`. You can use _any_ `<Transition>`
	 * component in a `<TransitionGroup>`, not just css.
	 *
	 * ```jsx
	 * import TransitionGroup from 'react-transition-group/TransitionGroup';
	 *
	 * class TodoList extends React.Component {
	 *   constructor(props) {
	 *     super(props)
	 *     this.state = {items: ['hello', 'world', 'click', 'me']}
	 *   }
	 *   handleAdd() {
	 *     const newItems = this.state.items.concat([
	 *       prompt('Enter some text')
	 *     ]);
	 *     this.setState({ items: newItems });
	 *   }
	 *   handleRemove(i) {
	 *     let newItems = this.state.items.slice();
	 *     newItems.splice(i, 1);
	 *     this.setState({items: newItems});
	 *   }
	 *   render() {
	 *     return (
	 *       <div>
	 *         <button onClick={() => this.handleAdd()}>Add Item</button>
	 *         <TransitionGroup>
	 *           {this.state.items.map((item, i) => (
	 *             <FadeTransition key={item}>
	 *               <div>
	 *                 {item}{' '}
	 *                 <button onClick={() => this.handleRemove(i)}>
	 *                   remove
	 *                 </button>
	 *               </div>
	 *             </FadeTransition>
	 *           ))}
	 *         </TransitionGroup>
	 *       </div>
	 *     );
	 *   }
	 * }
	 * ```
	 *
	 * Note that `<TransitionGroup>`  does not define any animation behavior!
	 * Exactly _how_ a list item animates is up to the individual `<Transition>`
	 * components. This means you can mix and match animations across different
	 * list items.
	 */
	
	var TransitionGroup = function (_React$Component) {
	  _inherits(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    _classCallCheck(this, TransitionGroup);
	
	    // Initial children should all be entering, dependent on appear
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.handleExited = function (key, node, originalHandler) {
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (key in currentChildMapping) return;
	
	      if (originalHandler) originalHandler(node);
	
	      _this.setState(function (state) {
	        var children = _extends({}, state.children);
	
	        delete children[key];
	        return { children: children };
	      });
	    };
	
	    _this.state = {
	      children: (0, _ChildMapping.getChildMapping)(props.children, function (child) {
	        var onExited = function onExited(node) {
	          _this.handleExited(child.key, node, child.props.onExited);
	        };
	
	        return (0, _react.cloneElement)(child, {
	          onExited: onExited,
	          in: true,
	          appear: _this.getProp(child, 'appear'),
	          enter: _this.getProp(child, 'enter'),
	          exit: _this.getProp(child, 'exit')
	        });
	      })
	    };
	    return _this;
	  }
	
	  TransitionGroup.prototype.getChildContext = function getChildContext() {
	    return {
	      transitionGroup: { isMounting: !this.appeared }
	    };
	  };
	  // use child config unless explictly set by the Group
	
	
	  TransitionGroup.prototype.getProp = function getProp(child, prop) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.props;
	
	    return props[prop] != null ? props[prop] : child.props[prop];
	  };
	
	  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
	    this.appeared = true;
	  };
	
	  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _this2 = this;
	
	    var prevChildMapping = this.state.children;
	    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
	
	    var children = (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping);
	
	    Object.keys(children).forEach(function (key) {
	      var child = children[key];
	
	      if (!(0, _react.isValidElement)(child)) return;
	
	      var onExited = function onExited(node) {
	        _this2.handleExited(child.key, node, child.props.onExited);
	      };
	
	      var hasPrev = key in prevChildMapping;
	      var hasNext = key in nextChildMapping;
	
	      var prevChild = prevChildMapping[key];
	      var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in;
	
	      // item is new (entering)
	      if (hasNext && (!hasPrev || isLeaving)) {
	        // console.log('entering', key)
	        children[key] = (0, _react.cloneElement)(child, {
	          onExited: onExited,
	          in: true,
	          exit: _this2.getProp(child, 'exit', nextProps),
	          enter: _this2.getProp(child, 'enter', nextProps)
	        });
	      }
	      // item is old (exiting)
	      else if (!hasNext && hasPrev && !isLeaving) {
	          // console.log('leaving', key)
	          children[key] = (0, _react.cloneElement)(child, { in: false });
	        }
	        // item hasn't changed transition states
	        // copy over the last transition props;
	        else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
	            // console.log('unchanged', key)
	            children[key] = (0, _react.cloneElement)(child, {
	              onExited: onExited,
	              in: prevChild.props.in,
	              exit: _this2.getProp(child, 'exit', nextProps),
	              enter: _this2.getProp(child, 'enter', nextProps)
	            });
	          }
	    });
	
	    this.setState({ children: children });
	  };
	
	  TransitionGroup.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.component,
	        childFactory = _props.childFactory,
	        props = _objectWithoutProperties(_props, ['component', 'childFactory']);
	
	    var children = this.state.children;
	
	
	    delete props.appear;
	    delete props.enter;
	    delete props.exit;
	
	    return _react2.default.createElement(
	      Component,
	      props,
	      values(children).map(childFactory)
	    );
	  };
	
	  return TransitionGroup;
	}(_react2.default.Component);
	
	TransitionGroup.childContextTypes = {
	  transitionGroup: _propTypes2.default.object.isRequired
	};
	
	
	TransitionGroup.propTypes =  false ? propTypes : {};
	TransitionGroup.defaultProps = defaultProps;
	
	exports.default = TransitionGroup;
	module.exports = exports['default'];

/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _CSSTransition = __webpack_require__(548);
	
	var _CSSTransition2 = _interopRequireDefault(_CSSTransition);
	
	var _TransitionGroup = __webpack_require__(549);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	var _Transition = __webpack_require__(216);
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  Transition: _Transition2.default,
	  TransitionGroup: _TransitionGroup2.default,
	  CSSTransition: _CSSTransition2.default
	};

/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	
	var _react = __webpack_require__(2);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children, mapFn) {
	  var mapper = function mapper(child) {
	    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
	  };
	
	  var result = Object.create(null);
	  if (children) _react.Children.map(children, function (c) {
	    return c;
	  }).forEach(function (child) {
	    // run the map function here instead so that the key is the computed one
	    result[child.key] = mapper(child);
	  });
	  return result;
	}
	
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    return key in next ? next[key] : prev[key];
	  }
	
	  // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	  var nextKeysPending = Object.create(null);
	
	  var pendingKeys = [];
	  for (var prevKey in prev) {
	    if (prevKey in next) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i = void 0;
	  var childMapping = {};
	  for (var nextKey in next) {
	    if (nextKeysPending[nextKey]) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	    childMapping[nextKey] = getValueForKey(nextKey);
	  }
	
	  // Finally, add the keys which didn't appear before any key in `next`
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}

/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.2.0
	 * react.production.min.js
	 *
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var m=__webpack_require__(67),n=__webpack_require__(190),p=__webpack_require__(88),q="function"===typeof Symbol&&Symbol["for"],r=q?Symbol["for"]("react.element"):60103,t=q?Symbol["for"]("react.call"):60104,u=q?Symbol["for"]("react.return"):60105,v=q?Symbol["for"]("react.portal"):60106,w=q?Symbol["for"]("react.fragment"):60107,x="function"===typeof Symbol&&Symbol.iterator;
	function y(a){for(var b=arguments.length-1,e="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,c=0;c<b;c++)e+="\x26args[]\x3d"+encodeURIComponent(arguments[c+1]);b=Error(e+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}
	var z={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};function A(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}A.prototype.isReactComponent={};A.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?y("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};A.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
	function B(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}function C(){}C.prototype=A.prototype;var D=B.prototype=new C;D.constructor=B;m(D,A.prototype);D.isPureReactComponent=!0;function E(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}var F=E.prototype=new C;F.constructor=E;m(F,A.prototype);F.unstable_isAsyncReactComponent=!0;F.render=function(){return this.props.children};var G={current:null},H=Object.prototype.hasOwnProperty,I={key:!0,ref:!0,__self:!0,__source:!0};
	function J(a,b,e){var c,d={},g=null,k=null;if(null!=b)for(c in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)H.call(b,c)&&!I.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var h=Array(f),l=0;l<f;l++)h[l]=arguments[l+2];d.children=h}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:r,type:a,key:g,ref:k,props:d,_owner:G.current}}function K(a){return"object"===typeof a&&null!==a&&a.$$typeof===r}
	function escape(a){var b={"\x3d":"\x3d0",":":"\x3d2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var L=/\/+/g,M=[];function N(a,b,e,c){if(M.length){var d=M.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}function O(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>M.length&&M.push(a)}
	function P(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case r:case t:case u:case v:g=!0}}if(g)return e(c,a,""===b?"."+Q(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+Q(d,k);g+=P(d,f,e,c)}else if(null===a||"undefined"===typeof a?f=null:(f=x&&a[x]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=
	f.call(a),k=0;!(d=a.next()).done;)d=d.value,f=b+Q(d,k++),g+=P(d,f,e,c);else"object"===d&&(e=""+a,y("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function Q(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function R(a,b){a.func.call(a.context,b,a.count++)}
	function S(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?T(a,c,e,p.thatReturnsArgument):null!=a&&(K(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(L,"$\x26/")+"/")+e,a={$$typeof:r,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a))}function T(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(L,"$\x26/")+"/");b=N(b,g,c,d);null==a||P(a,"",S,b);O(b)}
	var U={Children:{map:function(a,b,e){if(null==a)return a;var c=[];T(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=N(null,null,b,e);null==a||P(a,"",R,b);O(b)},count:function(a){return null==a?0:P(a,"",p.thatReturnsNull,null)},toArray:function(a){var b=[];T(a,b,null,p.thatReturnsArgument);return b},only:function(a){K(a)?void 0:y("143");return a}},Component:A,PureComponent:B,unstable_AsyncComponent:E,Fragment:w,createElement:J,cloneElement:function(a,b,e){var c=m({},a.props),
	d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=G.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)H.call(b,h)&&!I.hasOwnProperty(h)&&(c[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)c.children=e;else if(1<h){f=Array(h);for(var l=0;l<h;l++)f[l]=arguments[l+2];c.children=f}return{$$typeof:r,type:a.type,key:d,ref:g,props:c,_owner:k}},createFactory:function(a){var b=J.bind(null,a);b.type=a;return b},
	isValidElement:K,version:"16.2.0",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:G,assign:m}},V=Object.freeze({default:U}),W=V&&U||V;module.exports=W["default"]?W["default"]:W;


/***/ },
/* 553 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function createThunkMiddleware(extraArgument) {
	  return function (_ref) {
	    var dispatch = _ref.dispatch,
	        getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        if (typeof action === 'function') {
	          return action(dispatch, getState, extraArgument);
	        }
	
	        return next(action);
	      };
	    };
	  };
	}
	
	var thunk = createThunkMiddleware();
	thunk.withExtraArgument = createThunkMiddleware;
	
	exports['default'] = thunk;

/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__(218);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ },
/* 555 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__(219);
	
	var _isPlainObject = __webpack_require__(128);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(220);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var unexpectedKeyCache = void 0;
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError = void 0;
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(_key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ },
/* 557 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function isAbsolute(pathname) {
	  return pathname.charAt(0) === '/';
	}
	
	// About 1.5x faster than the two-arg version of Array#splice()
	function spliceOne(list, index) {
	  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
	    list[i] = list[k];
	  }
	
	  list.pop();
	}
	
	// This implementation is based heavily on node's url.parse
	function resolvePathname(to) {
	  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	  var toParts = to && to.split('/') || [];
	  var fromParts = from && from.split('/') || [];
	
	  var isToAbs = to && isAbsolute(to);
	  var isFromAbs = from && isAbsolute(from);
	  var mustEndAbs = isToAbs || isFromAbs;
	
	  if (to && isAbsolute(to)) {
	    // to is absolute
	    fromParts = toParts;
	  } else if (toParts.length) {
	    // to is relative, drop the filename
	    fromParts.pop();
	    fromParts = fromParts.concat(toParts);
	  }
	
	  if (!fromParts.length) return '/';
	
	  var hasTrailingSlash = void 0;
	  if (fromParts.length) {
	    var last = fromParts[fromParts.length - 1];
	    hasTrailingSlash = last === '.' || last === '..' || last === '';
	  } else {
	    hasTrailingSlash = false;
	  }
	
	  var up = 0;
	  for (var i = fromParts.length; i >= 0; i--) {
	    var part = fromParts[i];
	
	    if (part === '.') {
	      spliceOne(fromParts, i);
	    } else if (part === '..') {
	      spliceOne(fromParts, i);
	      up++;
	    } else if (up) {
	      spliceOne(fromParts, i);
	      up--;
	    }
	  }
	
	  if (!mustEndAbs) for (; up--; up) {
	    fromParts.unshift('..');
	  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');
	
	  var result = fromParts.join('/');
	
	  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
	
	  return result;
	}
	
	exports.default = resolvePathname;
	module.exports = exports['default'];

/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(559);


/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(560);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(574)(module)))

/***/ },
/* 560 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ },
/* 561 */
/***/ function(module, exports) {

	function E () {
	  // Keep this empty so it's easier to inherit from
	  // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
	}
	
	E.prototype = {
	  on: function (name, callback, ctx) {
	    var e = this.e || (this.e = {});
	
	    (e[name] || (e[name] = [])).push({
	      fn: callback,
	      ctx: ctx
	    });
	
	    return this;
	  },
	
	  once: function (name, callback, ctx) {
	    var self = this;
	    function listener () {
	      self.off(name, listener);
	      callback.apply(ctx, arguments);
	    };
	
	    listener._ = callback
	    return this.on(name, listener, ctx);
	  },
	
	  emit: function (name) {
	    var data = [].slice.call(arguments, 1);
	    var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
	    var i = 0;
	    var len = evtArr.length;
	
	    for (i; i < len; i++) {
	      evtArr[i].fn.apply(evtArr[i].ctx, data);
	    }
	
	    return this;
	  },
	
	  off: function (name, callback) {
	    var e = this.e || (this.e = {});
	    var evts = e[name];
	    var liveEvents = [];
	
	    if (evts && callback) {
	      for (var i = 0, len = evts.length; i < len; i++) {
	        if (evts[i].fn !== callback && evts[i].fn._ !== callback)
	          liveEvents.push(evts[i]);
	      }
	    }
	
	    // Remove event from queue to prevent memory leak
	    // Suggested by https://github.com/lazd
	    // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910
	
	    (liveEvents.length)
	      ? e[name] = liveEvents
	      : delete e[name];
	
	    return this;
	  }
	};
	
	module.exports = E;


/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _cookie = __webpack_require__(467);
	
	var _cookie2 = _interopRequireDefault(_cookie);
	
	var _objectAssign = __webpack_require__(67);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _utils = __webpack_require__(563);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Cookies = function () {
	  function Cookies(cookies, hooks) {
	    _classCallCheck(this, Cookies);
	
	    this.cookies = parseCookies(cookies);
	    this.hooks = hooks;
	    this.HAS_DOCUMENT_COOKIE = (0, _utils.hasDocumentCookie)();
	  }
	
	  _createClass(Cookies, [{
	    key: '_updateBrowserValues',
	    value: function _updateBrowserValues() {
	      if (!this.HAS_DOCUMENT_COOKIE) {
	        return;
	      }
	
	      this.cookies = _cookie2.default.parse(document.cookie);
	    }
	  }, {
	    key: 'get',
	    value: function get(name) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      this._updateBrowserValues();
	      return readCookie(this.cookies[name], options);
	    }
	  }, {
	    key: 'getAll',
	    value: function getAll() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      this._updateBrowserValues();
	      var result = {};
	
	      for (var name in this.cookies) {
	        result[name] = readCookie(this.cookies[name], options);
	      }
	
	      return result;
	    }
	  }, {
	    key: 'set',
	    value: function set(name, value, options) {
	      if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
	        value = JSON.stringify(value);
	      }
	
	      if (this.hooks && this.hooks.onSet) {
	        this.hooks.onSet(name, value, options);
	      }
	
	      this.cookies[name] = value;
	
	      if (this.HAS_DOCUMENT_COOKIE) {
	        document.cookie = _cookie2.default.serialize(name, value, options);
	      }
	    }
	  }, {
	    key: 'remove',
	    value: function remove(name, options) {
	      var finalOptions = options = (0, _objectAssign2.default)({}, options, {
	        expires: new Date(1970, 1, 1, 0, 0, 1),
	        maxAge: 0
	      });
	
	      if (this.hooks && this.hooks.onRemove) {
	        this.hooks.onRemove(name, finalOptions);
	      }
	
	      delete this.cookies[name];
	
	      if (this.HAS_DOCUMENT_COOKIE) {
	        document.cookie = _cookie2.default.serialize(name, '', finalOptions);
	      }
	    }
	  }]);
	
	  return Cookies;
	}();
	
	exports.default = Cookies;
	
	
	function parseCookies(cookies) {
	  if (typeof cookies === 'string') {
	    return _cookie2.default.parse(cookies);
	  } else if ((typeof cookies === 'undefined' ? 'undefined' : _typeof(cookies)) === 'object' && cookies !== null) {
	    return cookies;
	  } else {
	    return {};
	  }
	}
	
	function isParsingCookie(value, doNotParse) {
	  if (typeof doNotParse === 'undefined') {
	    // We guess if the cookie start with { or [, it has been serialized
	    doNotParse = !value || value[0] !== '{' && value[0] !== '[' && value[0] !== '"';
	  }
	
	  return !doNotParse;
	}
	
	function readCookie(value) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (isParsingCookie(value, options.doNotParse)) {
	    try {
	      return JSON.parse(value);
	    } catch (e) {
	      // At least we tried
	    }
	  }
	
	  return value;
	}
	module.exports = exports['default'];

/***/ },
/* 563 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.hasDocumentCookie = hasDocumentCookie;
	exports.cleanCookies = cleanCookies;
	// Can we get/set cookies on document.cookie?
	
	function hasDocumentCookie() {
	  return (typeof document === 'undefined' ? 'undefined' : _typeof(document)) === 'object' && typeof document.cookie === 'string';
	}
	
	//backwards compatibility
	var HAS_DOCUMENT_COOKIE = exports.HAS_DOCUMENT_COOKIE = hasDocumentCookie();
	
	function cleanCookies() {
	  document.cookie.split(';').forEach(function (c) {
	    document.cookie = c.replace(/^ +/, '').replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
	  });
	}

/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/superface_3D_1.5dfdddee.png";

/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/superface_3D_2.0080c187.png";

/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/superface_3D_3.8ae8341f.png";

/***/ },
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/superface_3D_4.b631e80a.png";

/***/ },
/* 568 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/superface_3D_5.6afc42e5.png";

/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/superface_3D_6.a53a1655.png";

/***/ },
/* 570 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function valueEqual(a, b) {
	  if (a === b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return valueEqual(item, b[index]);
	    });
	  }
	
	  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
	  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);
	
	  if (aType !== bType) return false;
	
	  if (aType === 'object') {
	    var aValue = a.valueOf();
	    var bValue = b.valueOf();
	
	    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);
	
	    var aKeys = Object.keys(a);
	    var bKeys = Object.keys(b);
	
	    if (aKeys.length !== bKeys.length) return false;
	
	    return aKeys.every(function (key) {
	      return valueEqual(a[key], b[key]);
	    });
	  }
	
	  return false;
	}
	
	exports.default = valueEqual;
	module.exports = exports['default'];

/***/ },
/* 571 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(source) {
	    return JSON.parse(JSON.stringify(source));
	};

/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var objectAssign = __webpack_require__(67);
	var Emitter = __webpack_require__(561);
	var Lethargy = __webpack_require__(503).Lethargy;
	var support = __webpack_require__(573);
	var clone = __webpack_require__(571);
	var bindAll = __webpack_require__(466);
	var EVT_ID = 'virtualscroll';
	
	module.exports = VirtualScroll;
	
	var keyCodes = {
	    LEFT: 37,
	    UP: 38,
	    RIGHT: 39,
	    DOWN: 40,
	    SPACE: 32
	};
	
	function VirtualScroll(options) {
	    bindAll(this, '_onWheel', '_onMouseWheel', '_onTouchStart', '_onTouchMove', '_onKeyDown');
	
	    this.el = window;
	    if (options && options.el) {
	        this.el = options.el;
	        delete options.el;
	    }
	    this.options = objectAssign({
	        mouseMultiplier: 1,
	        touchMultiplier: 2,
	        firefoxMultiplier: 15,
	        keyStep: 120,
	        preventTouch: false,
	        unpreventTouchClass: 'vs-touchmove-allowed',
	        limitInertia: false
	    }, options);
	
	    if (this.options.limitInertia) this._lethargy = new Lethargy();
	
	    this._emitter = new Emitter();
	    this._event = {
	        y: 0,
	        x: 0,
	        deltaX: 0,
	        deltaY: 0
	    };
	    this.touchStartX = null;
	    this.touchStartY = null;
	    this.bodyTouchAction = null;
	
	    if (this.options.passive !== undefined) {
	        this.listenerOptions = {passive: this.options.passive};
	    }
	}
	
	VirtualScroll.prototype._notify = function(e) {
	    var evt = this._event;
	    evt.x += evt.deltaX;
	    evt.y += evt.deltaY;
	
	   this._emitter.emit(EVT_ID, {
	        x: evt.x,
	        y: evt.y,
	        deltaX: evt.deltaX,
	        deltaY: evt.deltaY,
	        originalEvent: e
	   });
	};
	
	VirtualScroll.prototype._onWheel = function(e) {
	    var options = this.options;
	    if (this._lethargy && this._lethargy.check(e) === false) return;
	    var evt = this._event;
	
	    // In Chrome and in Firefox (at least the new one)
	    evt.deltaX = e.wheelDeltaX || e.deltaX * -1;
	    evt.deltaY = e.wheelDeltaY || e.deltaY * -1;
	
	    // for our purpose deltamode = 1 means user is on a wheel mouse, not touch pad
	    // real meaning: https://developer.mozilla.org/en-US/docs/Web/API/WheelEvent#Delta_modes
	    if(support.isFirefox && e.deltaMode == 1) {
	        evt.deltaX *= options.firefoxMultiplier;
	        evt.deltaY *= options.firefoxMultiplier;
	    }
	
	    evt.deltaX *= options.mouseMultiplier;
	    evt.deltaY *= options.mouseMultiplier;
	
	    this._notify(e);
	};
	
	VirtualScroll.prototype._onMouseWheel = function(e) {
	    if (this.options.limitInertia && this._lethargy.check(e) === false) return;
	
	    var evt = this._event;
	
	    // In Safari, IE and in Chrome if 'wheel' isn't defined
	    evt.deltaX = (e.wheelDeltaX) ? e.wheelDeltaX : 0;
	    evt.deltaY = (e.wheelDeltaY) ? e.wheelDeltaY : e.wheelDelta;
	
	    this._notify(e);
	};
	
	VirtualScroll.prototype._onTouchStart = function(e) {
	    var t = (e.targetTouches) ? e.targetTouches[0] : e;
	    this.touchStartX = t.pageX;
	    this.touchStartY = t.pageY;
	};
	
	VirtualScroll.prototype._onTouchMove = function(e) {
	    var options = this.options;
	    if(options.preventTouch
	        && !e.target.classList.contains(options.unpreventTouchClass)) {
	        e.preventDefault();
	    }
	
	    var evt = this._event;
	
	    var t = (e.targetTouches) ? e.targetTouches[0] : e;
	
	    evt.deltaX = (t.pageX - this.touchStartX) * options.touchMultiplier;
	    evt.deltaY = (t.pageY - this.touchStartY) * options.touchMultiplier;
	
	    this.touchStartX = t.pageX;
	    this.touchStartY = t.pageY;
	
	    this._notify(e);
	};
	
	VirtualScroll.prototype._onKeyDown = function(e) {
	    
	    if( this._noKey ) return
	    var evt = this._event;
	    evt.deltaX = evt.deltaY = 0;
	    var windowHeight = window.innerHeight - 40
	
	    switch(e.keyCode) {
	        case keyCodes.LEFT:
	        case keyCodes.UP:
	            evt.deltaY = this.options.keyStep;
	            break;
	
	        case keyCodes.RIGHT:
	        case keyCodes.DOWN:
	            evt.deltaY = - this.options.keyStep;
	            break;
	        case keyCodes.SPACE && e.shiftKey:
	            evt.deltaY = windowHeight;
	            break;
	        case keyCodes.SPACE:
	            evt.deltaY = - windowHeight;
	            break;
	        default:
	            return;
	    }
	
	    this._notify(e);
	};
	
	VirtualScroll.prototype._bind = function() {
	    if(support.hasWheelEvent) this.el.addEventListener('wheel', this._onWheel, this.listenerOptions);
	    if(support.hasMouseWheelEvent) this.el.addEventListener('mousewheel', this._onMouseWheel, this.listenerOptions);
	
	    if(support.hasTouch) {
	        this.el.addEventListener('touchstart', this._onTouchStart, this.listenerOptions);
	        this.el.addEventListener('touchmove', this._onTouchMove, this.listenerOptions);
	    }
	
	    if(support.hasPointer && support.hasTouchWin) {
	        this.bodyTouchAction = document.body.style.msTouchAction;
	        document.body.style.msTouchAction = 'none';
	        this.el.addEventListener('MSPointerDown', this._onTouchStart, true);
	        this.el.addEventListener('MSPointerMove', this._onTouchMove, true);
	    }
	
	    if(support.hasKeyDown) document.addEventListener('keydown', this._onKeyDown);
	};
	
	VirtualScroll.prototype._unbind = function() {
	    if(support.hasWheelEvent) this.el.removeEventListener('wheel', this._onWheel);
	    if(support.hasMouseWheelEvent) this.el.removeEventListener('mousewheel', this._onMouseWheel);
	
	    if(support.hasTouch) {
	        this.el.removeEventListener('touchstart', this._onTouchStart);
	        this.el.removeEventListener('touchmove', this._onTouchMove);
	    }
	
	    if(support.hasPointer && support.hasTouchWin) {
	        document.body.style.msTouchAction = this.bodyTouchAction;
	        this.el.removeEventListener('MSPointerDown', this._onTouchStart, true);
	        this.el.removeEventListener('MSPointerMove', this._onTouchMove, true);
	    }
	
	    if(support.hasKeyDown) document.removeEventListener('keydown', this._onKeyDown);
	};
	
	VirtualScroll.prototype.on = function(cb, ctx) {
	  this._emitter.on(EVT_ID, cb, ctx);
	
	  var events = this._emitter.e;
	  if (events && events[EVT_ID] && events[EVT_ID].length === 1) this._bind();
	};
	
	VirtualScroll.prototype.off = function(cb, ctx) {
	  this._emitter.off(EVT_ID, cb, ctx);
	
	  var events = this._emitter.e;
	  if (!events[EVT_ID] || events[EVT_ID].length <= 0) this._unbind();
	};
	
	VirtualScroll.prototype.reset = function() {
	    var evt = this._event;
	    evt.x = 0;
	    evt.y = 0;
	};
	
	VirtualScroll.prototype.destroy = function() {
	    this._emitter.off();
	    this._unbind();
	};


/***/ },
/* 573 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = (function getSupport() {
	    return {
	        hasWheelEvent: 'onwheel' in document,
	        hasMouseWheelEvent: 'onmousewheel' in document,
	        hasTouch: 'ontouchstart' in document,
	        hasTouchWin: navigator.msMaxTouchPoints && navigator.msMaxTouchPoints > 1,
	        hasPointer: !!window.navigator.msPointerEnabled,
	        hasKeyDown: 'onkeydown' in document,
	        isFirefox: navigator.userAgent.indexOf('Firefox') > -1
	    };
	})();


/***/ },
/* 574 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./superface_3D_1.png": 564,
		"./superface_3D_2.png": 565,
		"./superface_3D_3.png": 566,
		"./superface_3D_4.png": 567,
		"./superface_3D_5.png": 568,
		"./superface_3D_6.png": 569
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 575;


/***/ }
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.14d5780c.js